function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
function $parcel$defineInteropFlag(a) {
    Object.defineProperty(a, '__esModule', {
        value: true,
        configurable: true
    });
}
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $parcel$global = globalThis;
var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("9PBZj", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "ClassicRoadmap", ()=>$d26e3a17972dc638$export$bfeab976e73594a0);
    $parcel$export(module.exports, "ClassicRoadmapWithExperienceTracker", ()=>$d26e3a17972dc638$export$4fd8516fffeaa4c9);
    $parcel$export(module.exports, "default", ()=>$d26e3a17972dc638$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    parcelRequire("2Geeh");
    var $dkttM;
    var $2i4sA;
    var $heNNl;
    var $dXq4S;
    var $kUACW;
    var $4DPZY;
    var $e0swt;
    var $hJAri;
    var $efvDm;
    var $4dRjY;
    var $9OXo1;
    var $2YP9W;
    var $1bQGJ;
    var $2ML4O;
    var $cuvVR;
    var $iK5xG;
    const $d26e3a17972dc638$var$clearCache = ()=>{};
    const $d26e3a17972dc638$var$updateCache = ()=>{};
    const $d26e3a17972dc638$var$useRoadmapResource = (0, (0, parcelRequire("kUACW")).withSuspense)(()=>(0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("hJAri")).classicRoadmapResource)));
    const $d26e3a17972dc638$export$bfeab976e73594a0 = (boardId)=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const roadmapDataResource = $d26e3a17972dc638$var$useRoadmapResource();
        const [{ data: containerData }] = (0, (0, parcelRequire("4DPZY")).useContainerContext)();
        const boardName = containerData && containerData.scope && containerData.scope.name || '';
        const sourceAri = (0, (0, parcelRequire("dXq4S")).createAri)({
            resourceOwner: 'jira-software',
            cloudId: tenantContext.cloudId,
            resourceType: 'board',
            resourceId: boardId.toString()
        });
        const prefetchData = {
            data: roadmapDataResource.data,
            loading: roadmapDataResource.loading,
            error: roadmapDataResource.error,
            clearCache: $d26e3a17972dc638$var$clearCache,
            updateCache: $d26e3a17972dc638$var$updateCache,
            id: `software/roadmap:${boardId}`
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e0swt")).MetaAPIConsumer), null, (getMeta)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, containerData ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dkttM")).Breadcrumbs), null) : null, (0, (0, parcelRequire("cuvVR")).default)((0, $f1ec00c5efd4c816$export$40f914e9a75ff65a), boardId, boardName, sourceAri, getMeta, tenantContext, prefetchData)));
    };
    const $d26e3a17972dc638$export$4fd8516fffeaa4c9 = ({ match: match })=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const { boardId: boardIdString, projectKey: projectKey } = match.params;
        const boardId = Number(boardIdString);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4dRjY")).MarkProductStart), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2i4sA")).ViewExperienceTrackingProvider), {
            experienceId: projectKey,
            experience: "viewRoadmap",
            analyticsSource: "roadmap",
            edition: tenantContext.appEditions.software,
            application: (0, (0, parcelRequire("efvDm")).JIRA_SOFTWARE)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: (0, (0, parcelRequire("2ML4O")).toRoadmapSpaAppId)((0, $f1ec00c5efd4c816$export$40f914e9a75ff65a)),
            packageName: "jiraSpaAppsRoadmap",
            withExperienceTracker: true
        }, $d26e3a17972dc638$export$bfeab976e73594a0(boardId))));
    };
    const $d26e3a17972dc638$var$RouterWrapper = (0, (0, parcelRequire("1bQGJ")).withRouter)((0, (0, parcelRequire("iK5xG")).withLicenseCheck)($d26e3a17972dc638$export$4fd8516fffeaa4c9));
    var $d26e3a17972dc638$export$2e2bcd8739ae039 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($d26e3a17972dc638$var$RouterWrapper, props);
});
parcelRegister("dkttM", function(module, exports) {
    $parcel$export(module.exports, "Breadcrumbs", ()=>$43b5951c2eff0e64$export$2dc68d50d56fbbd);
    var $5uXOq = parcelRequire("5uXOq");
    var $4DPZY;
    var $doZTA;
    var $4hXjG;
    var $4dqPp;
    var $gYklg;
    const $43b5951c2eff0e64$export$2dc68d50d56fbbd = ()=>{
        const [{ query: query, match: match }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const baseUrl = '';
        const [{ data: data, error: error }] = (0, (0, parcelRequire("4DPZY")).useContainerContext)();
        const { chartView: chartView } = (0, (0, parcelRequire("4hXjG")).useUrlState)();
        if (!data || error) return null;
        let boardId;
        if (match && match.params && match.params.boardId !== undefined) boardId = Number(match.params.boardId);
        else boardId = Number(query.rapidView);
        const boardName = data.scope && data.scope.name || '';
        const isReportsView = query && query.view === 'reporting';
        if (data.user) {
            const accountId = match.params.accountId || '';
            const isLocationlessBoard = !!query.locationless;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gYklg")).UserBreadcrumbs), {
                accountId: accountId,
                boardId: boardId,
                boardName: boardName,
                isReportsView: isReportsView,
                profileUrl: data.user.profileUrl,
                userName: data.user.name,
                chart: chartView,
                isLocationlessBoard: isLocationlessBoard
            });
        }
        const { project: project } = data;
        const projectKey = project.key;
        const projectName = project.name;
        const projectId = project.id;
        const isSimplifiedProject = project.isSimplified;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4dqPp")).ProjectBreadcrumbs), {
            baseUrl: baseUrl,
            boardId: boardId,
            boardName: boardName,
            chart: chartView,
            projectKey: projectKey,
            projectName: projectName,
            projectId: projectId,
            isSimplifiedProject: isSimplifiedProject
        });
    };
});
parcelRegister("4hXjG", function(module, exports) {
    $parcel$export(module.exports, "useUrlState", ()=>$e0f62cfcc4b85d58$export$6a582373474709af);
    var $doZTA;
    var $lzIoE;
    const $e0f62cfcc4b85d58$export$6a582373474709af = ()=>{
        const [{ query: query, route: route, match: match }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const { rapidView: rapidView, chart: chart, view: view, config: config, projectKey: queryProjectKey, locationless: locationless } = query;
        const { accountId: accountId } = match.params;
        const isBoardLocationless = !!locationless;
        const shouldUsePrettyUrlState = !isBoardLocationless;
        const mode = shouldUsePrettyUrlState ? (0, (0, parcelRequire("lzIoE")).getModeV2)(route) : (0, (0, parcelRequire("lzIoE")).getMode)(view);
        const boardId = shouldUsePrettyUrlState ? match.params.boardId : rapidView;
        const projectKey = shouldUsePrettyUrlState ? match.params.projectKey : queryProjectKey;
        const chartView = shouldUsePrettyUrlState ? (0, (0, parcelRequire("lzIoE")).toCamelCaseChartView)(match.params.chartView) : chart;
        return {
            accountId: accountId,
            mode: mode,
            boardId: boardId,
            chartView: chartView,
            projectKey: projectKey,
            routeName: route.name,
            config: config,
            isBoardLocationless: isBoardLocationless
        };
    };
});
parcelRegister("lzIoE", function(module, exports) {
    $parcel$export(module.exports, "toCamelCaseChartView", ()=>$e82cb2563304145d$export$f1cb745981250009);
    $parcel$export(module.exports, "getMode", ()=>$e82cb2563304145d$export$1fc0f6205829e19c);
    $parcel$export(module.exports, "getModeV2", ()=>$e82cb2563304145d$export$cc65f5a30b63da10);
    var $e4eHl = parcelRequire("e4eHl");
    var $65Ltd;
    var $1pMQS;
    const $e82cb2563304145d$export$f1cb745981250009 = (chartView)=>(0, ($parcel$interopDefault($e4eHl)))(chartView);
    const $e82cb2563304145d$export$1fc0f6205829e19c = (view)=>{
        switch(view){
            case 'planning':
            case 'planning.nodetail':
                return 0, (0, parcelRequire("1pMQS")).PLAN;
            case 'reporting':
                return 0, (0, parcelRequire("1pMQS")).REPORT;
            default:
                return 0, (0, parcelRequire("1pMQS")).WORK;
        }
    };
    const $e82cb2563304145d$export$cc65f5a30b63da10 = (route)=>{
        if (!route) return 0, (0, parcelRequire("1pMQS")).WORK;
        switch(route.name){
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BACKLOG:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_USER_BACKLOG:
                return 0, (0, parcelRequire("1pMQS")).PLAN;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_REPORT:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_USER_REPORT:
                return 0, (0, parcelRequire("1pMQS")).REPORT;
            default:
                return 0, (0, parcelRequire("1pMQS")).WORK;
        }
    };
});
parcelRegister("1pMQS", function(module, exports) {
    $parcel$export(module.exports, "WORK", ()=>$59a745e430111b54$export$77d6f70978850641);
    $parcel$export(module.exports, "PLAN", ()=>$59a745e430111b54$export$c303e491e026ebc6);
    $parcel$export(module.exports, "INITIAL_DATA", ()=>$59a745e430111b54$export$b89e93f49fd2d1eb);
    $parcel$export(module.exports, "CONFIG_DATA", ()=>$59a745e430111b54$export$5711a66d592b156a);
    $parcel$export(module.exports, "REPORT", ()=>$59a745e430111b54$export$e3d31417f21c1ce7);
    $parcel$export(module.exports, "SUCCESS", ()=>$59a745e430111b54$export$638cc6e36b2a737a);
    $parcel$export(module.exports, "FAILURE", ()=>$59a745e430111b54$export$5b1e245d5eac107);
    $parcel$export(module.exports, "ALL_DATA_PROMISE", ()=>$59a745e430111b54$export$79529b1d8f537dc7);
    $parcel$export(module.exports, "GH_SPA_RESOURCES_READY", ()=>$59a745e430111b54$export$7d798b3d2b3dfe6e);
    $parcel$export(module.exports, "GH_SPA_RB_READY", ()=>$59a745e430111b54$export$af91ef97c134b44c);
    $parcel$export(module.exports, "GH_SPA_CONTENT_READY", ()=>$59a745e430111b54$export$f7f9968a603665fb);
    $parcel$export(module.exports, "GH_SPA_CONTENT_LOADING", ()=>$59a745e430111b54$export$dbfa398ce856dd34);
    $parcel$export(module.exports, "BENTO_ROOT", ()=>$59a745e430111b54$export$cd8e3f3a08b0ddda);
    const $59a745e430111b54$export$77d6f70978850641 = 'work';
    const $59a745e430111b54$export$c303e491e026ebc6 = 'plan';
    const $59a745e430111b54$export$b89e93f49fd2d1eb = 'initial-data';
    const $59a745e430111b54$export$5711a66d592b156a = 'config-data';
    const $59a745e430111b54$export$e3d31417f21c1ce7 = 'report';
    const $59a745e430111b54$export$638cc6e36b2a737a = 'success';
    const $59a745e430111b54$export$5b1e245d5eac107 = 'failure';
    const $59a745e430111b54$export$79529b1d8f537dc7 = 'all-data-promise';
    const $59a745e430111b54$export$7d798b3d2b3dfe6e = 'GH_SPA_RESOURCES_READY';
    const $59a745e430111b54$export$af91ef97c134b44c = 'GH_SPA_RB_READY';
    const $59a745e430111b54$export$f7f9968a603665fb = 'GH_SPA_SPINNER_HIDE';
    const $59a745e430111b54$export$dbfa398ce856dd34 = 'GH_SPA_SPINNER_SHOW';
    const $59a745e430111b54$export$cd8e3f3a08b0ddda = 'ghx-issue-fragment';
    const $59a745e430111b54$export$7ed3b6fb15486a80 = [
        'wrc!jira.webresources:skate',
        'wrc!jira.webresources:util-lite',
        'wrc!jira.webresources:util',
        'wrc!jira.webresources:feature-flags',
        'wrc!jira.webresources:dialogs',
        'wrc!jira.webresources:jira-global',
        'wrc!com.atlassian.auiplugin:aui-spinner',
        'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client',
        'wrc!jira.webresources:key-commands',
        'wrc!jira.webresources:header',
        'wrc!com.atlassian.jira.jira-atlaskit-plugin:sidebar',
        'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
        'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs',
        'wrc!com.atlassian.jira.jira-atlaskit-plugin:breadcrumbs',
        'wrc!com.atlassian.jira.jira-atlaskit-plugin:profilecard',
        'wrc!com.atlassian.jira.jira-atlaskit-plugin:ipblocklisting',
        'wrc!com.atlassian.jira.jira-atlaskit-plugin:async-modals',
        'wrc!jira.webresources:global-static',
        'wrc!com.atlassian.jira.plugins.jira-browser-metrics:contrib',
        'wrc!com.atlassian.plugins.browser.metrics.browser-metrics-plugin:impl',
        'wrc!com.atlassian.plugins.browser.metrics.browser-metrics-plugin:api',
        'wrc!com.atlassian.analytics.analytics-client:js-events'
    ];
});
parcelRegister("4dqPp", function(module, exports) {
    $parcel$export(module.exports, "ProjectBreadcrumbs", ()=>$f339d6c7abfa1840$export$38f8c59e2af08a87);
    var $5uXOq = parcelRequire("5uXOq");
    var $c2D8L;
    var $gEFwt;
    var $koVbs;
    var $bxv9E;
    const $f339d6c7abfa1840$export$38f8c59e2af08a87 = (0, $5uXOq.memo)(({ baseUrl: baseUrl, boardId: boardId, boardName: boardName, projectKey: projectKey, projectName: projectName, projectId: projectId, isSimplifiedProject: isSimplifiedProject, chart: chart })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gEFwt")).default), {
            baseUrl: baseUrl,
            projectKey: projectKey,
            projectName: projectName,
            projectId: projectId,
            isSimplifiedProject: isSimplifiedProject
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c2D8L")).default), {
            breadcrumb: {
                text: boardName,
                href: `/jira/software/c/projects/${projectKey}/boards/${boardId}`,
                type: 'boardName',
                analyticsAttributes: {
                    nextGenProject: isSimplifiedProject,
                    projectConfig: isSimplifiedProject ? 'next-gen' : 'classic'
                },
                analyticsFields: {
                    name: 'navigateToSubProject',
                    containerId: projectId,
                    containerType: 'project'
                }
            }
        }, chart && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c2D8L")).default), {
            breadcrumb: {
                text: formatMessage((0, (0, parcelRequire("bxv9E")).messages).projectReportBreadcrumb),
                href: `/projects/${projectKey}?selectedItem=com.atlassian.jira.jira-projects-plugin:report-page`
            }
        })));
    });
});
parcelRegister("bxv9E", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$74ad6184f87e3622$export$defe85febe8b728c);
    var $7VHMR;
    const $74ad6184f87e3622$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        projectReportBreadcrumb: {
            "id": "classic-software.rapidboard-content.breadcrumbs.project.project-report-breadcrumb",
            "defaultMessage": "Reports"
        }
    });
});
parcelRegister("gYklg", function(module, exports) {
    $parcel$export(module.exports, "UserBreadcrumbs", ()=>$3f7779ce9041362c$export$74fdd5a0187b08ef);
    var $5uXOq = parcelRequire("5uXOq");
    var $c2D8L;
    var $75PvK;
    var $koVbs;
    var $2OIQ0;
    const $3f7779ce9041362c$export$74fdd5a0187b08ef = (0, $5uXOq.memo)(({ accountId: accountId, boardId: boardId, boardName: boardName, profileUrl: profileUrl, userName: userName, chart: chart, isLocationlessBoard: isLocationlessBoard })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        if (isLocationlessBoard) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("75PvK")).default), {
            profileUrl: profileUrl,
            name: userName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c2D8L")).default), {
            breadcrumb: {
                text: boardName,
                href: `/secure/RapidBoard.jspa?rapidView=${boardId}&locationless=true`,
                type: 'boardName'
            }
        }, chart && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c2D8L")).default), {
            breadcrumb: {
                text: formatMessage((0, (0, parcelRequire("2OIQ0")).messages).userReportBreadcrumb),
                href: `/secure/RapidBoard.jspa?rapidView=${boardId}&view=reporting&chart=${chart}&locationless=true`
            }
        })));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("75PvK")).default), {
            profileUrl: profileUrl,
            name: userName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c2D8L")).default), {
            breadcrumb: {
                text: boardName,
                href: `/jira/people/${accountId}/boards/${boardId}`,
                type: 'boardName'
            }
        }, chart && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c2D8L")).default), {
            breadcrumb: {
                text: formatMessage((0, (0, parcelRequire("2OIQ0")).messages).userReportBreadcrumb),
                href: `/jira/people/${accountId}/boards/${boardId}/reports/${chart}`
            }
        })));
    });
});
parcelRegister("2OIQ0", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$f431e2a3ae360d6b$export$defe85febe8b728c);
    var $7VHMR;
    const $f431e2a3ae360d6b$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        userReportBreadcrumb: {
            "id": "classic-software.rapidboard-content.breadcrumbs.user.user-report-breadcrumb",
            "defaultMessage": "Reports"
        }
    });
});
parcelRegister("kUACW", function(module, exports) {
    $parcel$export(module.exports, "withSuspense", ()=>$4c5a941fc6e9229e$export$a3bce93d4fb4eda6);
    const $4c5a941fc6e9229e$var$isDataEmpty = (data)=>data == null;
    function $4c5a941fc6e9229e$export$a3bce93d4fb4eda6(theHook) {
        return (...args)=>{
            const result = theHook(...args);
            if (!false && $4c5a941fc6e9229e$var$isDataEmpty(result.data) && result.loading) throw result.promise;
            return result;
        };
    }
});
parcelRegister("e0swt", function(module, exports) {
    $parcel$export(module.exports, "MetaAPIConsumer", ()=>$89f0fbddf536aa38$export$8b3f3b109d67f2a);
    var $5uXOq = parcelRequire("5uXOq");
    var $j8DrX;
    const $89f0fbddf536aa38$var$MetaAPIContext = (0, $5uXOq.createContext)((0, (0, parcelRequire("j8DrX")).default));
    const { Provider: $89f0fbddf536aa38$export$ab3e6458d0544c37, Consumer: $89f0fbddf536aa38$export$8b3f3b109d67f2a } = $89f0fbddf536aa38$var$MetaAPIContext;
    const $89f0fbddf536aa38$export$42954e2090da65e = ()=>(0, $5uXOq.useContext)($89f0fbddf536aa38$var$MetaAPIContext);
});
const $f1ec00c5efd4c816$export$40f914e9a75ff65a = 'CLASSIC';
const $f1ec00c5efd4c816$export$296f840b5ae7056e = 'NEXTGEN';
parcelRegister("4dRjY", function(module, exports) {
    $parcel$export(module.exports, "PRODUCT_START_MARK", ()=>$9953c23a4f71adac$export$8e54fca0a680fdfd);
    $parcel$export(module.exports, "MarkProductStart", ()=>$9953c23a4f71adac$export$2a999c5f84501025);
    var $x9xyg;
    const $9953c23a4f71adac$export$8e54fca0a680fdfd = 'PRODUCT_START';
    const $9953c23a4f71adac$export$2a999c5f84501025 = ()=>{
        if (!false) {
            performance.clearMarks($9953c23a4f71adac$export$8e54fca0a680fdfd);
            (0, (0, parcelRequire("x9xyg")).setMark)($9953c23a4f71adac$export$8e54fca0a680fdfd);
        }
        return null;
    };
});
parcelRegister("2ML4O", function(module, exports) {
    $parcel$export(module.exports, "toRoadmapSpaAppId", ()=>$77725f47cd4a69bd$export$8a3bb66c7ed17f25);
    const $77725f47cd4a69bd$export$8a3bb66c7ed17f25 = (type)=>`spa-apps.roadmap.${type}`.toLowerCase();
});
parcelRegister("cuvVR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c1e60526311f0375$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    parcelRequire("2Geeh");
    var $hYfgW = parcelRequire("hYfgW");
    var $gJBT6 = parcelRequire("gJBT6");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $99gkn;
    var $8Sklq;
    var $g0Gtc;
    var $k12ix;
    var $dJl1T;
    var $iqr2y;
    var $co1wz;
    var $4R6GH;
    var $8PRuf;
    var $5rqex;
    var $lm7AC;
    var $eKt4x;
    var $8WL0u;
    var $9dbF6;
    var $dZw8H;
    var $l8ruj;
    var $7tQej;
    var $2ML4O;
    var $iMyxN;
    const $c1e60526311f0375$var$getIssueLimit = ()=>(0, (0, parcelRequire("co1wz")).getFeatureFlagValue)('jsw.roadmap.issue-overall-limit', 3000);
    const $c1e60526311f0375$var$logError = (0, ($parcel$interopDefault($gJBT6)))((type, error)=>(0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData(type, 'Prefetch data error', error));
    const $c1e60526311f0375$var$getIsReleasesVisible = (criticalData)=>Boolean(criticalData?.configuration?.projectConfiguration?.isReleasesFeatureEnabled && criticalData?.settings?.isReleasesVisible);
    const $c1e60526311f0375$var$getCriticalDataTraceId = (criticalData)=>({
            criticalDataTraceId: (0, ($parcel$interopDefault($hYfgW)))(criticalData?.metadata?.traceIds || []) || ''
        });
    const $c1e60526311f0375$var$isNativeGraphQL = (criticalData)=>criticalData?.metadata?.extensions?.roadmaps?.isNativeGraphQL || false;
    const $c1e60526311f0375$export$aea546e78d89246e = (criticalData)=>{
        let issuesCount = 0;
        let epicsCount = 0;
        if (criticalData && criticalData.issues) {
            const { hash: hash, sequence: sequence } = criticalData.issues;
            sequence.forEach((id)=>{
                issuesCount += 1;
                if (!hash[id].parentId.value) epicsCount += 1;
            });
        }
        return {
            issuesCount: issuesCount,
            epicsCount: epicsCount
        };
    };
    const $c1e60526311f0375$var$renderApp = (type, rapidViewId, containerName, sourceAri, metaConsumerData, { tenantContext: tenantContext }, { error: prefetchError, loading: loading, data: data })=>{
        if (prefetchError && !loading) {
            $c1e60526311f0375$var$logError((0, (0, parcelRequire("2ML4O")).toRoadmapSpaAppId)(type), prefetchError);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("g0Gtc")).ExperienceSuccessTracker), {
                location: (0, (0, parcelRequire("eKt4x")).ROADMAP_RESOURCE_DATA_FAILED)
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqr2y")).ErrorFlagRenderer), {
                id: "roadmap",
                error: prefetchError
            }));
        }
        if (!data) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lm7AC")).RoadmapSkeleton), null);
        if (data.roadmapErrorContext) {
            const errorType = data.roadmapErrorContext.type;
            if (errorType === (0, $445133175f40343b$export$50a1bc82cf68f557)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
                to: "/jira/projects?showFlag=jsw.project-not-found"
            });
            if (errorType === (0, $445133175f40343b$export$e5e4b8c32e68dd0b)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("g0Gtc")).ExperienceSuccessTracker), {
                location: (0, (0, parcelRequire("eKt4x")).ROADMAP_CRITICAL_DATA_SUCCEEDED)
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqr2y")).ErrorFlagRenderer), {
                id: "roadmap",
                error: null
            }));
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("g0Gtc")).ExperienceFailureTracker), {
                location: (0, (0, parcelRequire("eKt4x")).ROADMAP_CRITICAL_DATA_FAILED),
                failureEventAttributes: data.roadmapErrorContext.context
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqr2y")).ErrorFlagRenderer), {
                id: "roadmap",
                error: null
            }));
        }
        const analyticsCustomData = {
            ...(0, (0, parcelRequire("k12ix")).getNormalisedPerformanceFFs)(),
            ...$c1e60526311f0375$export$aea546e78d89246e(data.roadmapData),
            ...$c1e60526311f0375$var$getCriticalDataTraceId(data.roadmapData)
        };
        const { roadmapData: roadmapData, resourcesCacheSource: resourcesCacheSource } = data;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "roadmap"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Sklq")).ArchivedProjectRedirect), null), roadmapData && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8WL0u")).default), {
            type: type,
            boardId: rapidViewId,
            containerName: containerName,
            sourceAri: sourceAri,
            locale: tenantContext.locale,
            loggedInAccountId: tenantContext.atlassianAccountId || '',
            cloudId: tenantContext.cloudId,
            activationId: tenantContext.activationId,
            criticalData: {
                ...roadmapData,
                resourcesCacheSource: resourcesCacheSource
            },
            isServer: false,
            isSiteAdmin: tenantContext.isSiteAdmin,
            onUnmount: (0, ($parcel$interopDefault($8Rkzz)))
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5rqex")).default), {
            appName: "software-roadmap",
            isExpectedToHaveSsr: true,
            withMarks: [
                (0, (0, parcelRequire("8PRuf")).appBundleReadyMark),
                (0, (0, parcelRequire("8PRuf")).prefetchApiReadyMark)
            ],
            metric: (0, (0, parcelRequire("iMyxN")).roadmapPageLoad),
            extra: {
                ...analyticsCustomData,
                isNativeGraphQL: $c1e60526311f0375$var$isNativeGraphQL(data.roadmapData),
                isSimplified: type === (0, $f1ec00c5efd4c816$export$296f840b5ae7056e),
                isIssueDetailsOpen: window.location.href.includes('?selectedIssue='),
                hasAppliedJQLFilters: window.location.href.includes('customFilter=') || window.location.href.includes('quickFilter='),
                hasAppliedGoalFilters: window.location.href.includes('goal='),
                isIssueLimit5kEnabled: $c1e60526311f0375$var$getIssueLimit() === 5000,
                isReleasesVisible: $c1e60526311f0375$var$getIsReleasesVisible(data.roadmapData),
                isCustomScrollbarPdnd: (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline_table_custom_scroll_pdnd')
            },
            ttrSlo: (0, (0, parcelRequire("eKt4x")).TTRSLO),
            ttiSlo: (0, (0, parcelRequire("eKt4x")).TTISLO),
            emitOnAnimationFrame: (0, (0, parcelRequire("co1wz")).ff)('bm3.emit-on-raf.top-experiences')
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("99gkn")).default), {
            data: analyticsCustomData
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZw8H")).SpaStatePageReady), null));
    };
    var $c1e60526311f0375$export$2e2bcd8739ae039 = (type, rapidViewId, containerName, sourceAri, metaConsumerData, tenantContext, prefetchData)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9dbF6")).SubProductUpdater), {
            subProduct: "software"
        }), $c1e60526311f0375$var$renderApp(type, rapidViewId, containerName, sourceAri, metaConsumerData, {
            tenantContext: tenantContext
        }, prefetchData));
});
parcelRegister("8Sklq", function(module, exports) {
    $parcel$export(module.exports, "ArchivedProjectRedirect", ()=>$aeceecd368677e67$export$6e1a5929022745db);
    var $5uXOq = parcelRequire("5uXOq");
    var $4DPZY;
    var $3mYHL;
    const $aeceecd368677e67$export$6e1a5929022745db = ()=>{
        const [{ data: data, error: error }] = (0, (0, parcelRequire("4DPZY")).useContainerContext)();
        const projectData = data && data.project || {};
        const { key: projectKey } = projectData;
        if (error || !data) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3mYHL")).default), {
            projectKey: projectKey || null
        });
    };
});
parcelRegister("3mYHL", function(module, exports) {
    $parcel$export(module.exports, "isProjectArchivedCondition", ()=>$90d8776d2c89f4bd$export$34040938aec58f90);
    $parcel$export(module.exports, "RedirectToArchivedPage", ()=>$90d8776d2c89f4bd$export$36db2ddf32573bd8);
    $parcel$export(module.exports, "default", ()=>$90d8776d2c89f4bd$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dAfqg;
    var $7tQej;
    const $90d8776d2c89f4bd$export$34040938aec58f90 = (projectContextData)=>projectContextData && projectContextData.isProjectArchived || false;
    const $90d8776d2c89f4bd$var$RedirectIfProjectArchived = ({ projectKey: projectKey })=>{
        if (projectKey === null) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dAfqg")).ProjectContextProvider), null, (projectContext)=>$90d8776d2c89f4bd$export$34040938aec58f90(projectContext.data) ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
                to: (0, $a9bebd574fd66055$export$9a6ccb84170b615b)
            }) : null);
    };
    const $90d8776d2c89f4bd$export$36db2ddf32573bd8 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
            to: (0, $a9bebd574fd66055$export$9a6ccb84170b615b)
        });
    var $90d8776d2c89f4bd$export$2e2bcd8739ae039 = $90d8776d2c89f4bd$var$RedirectIfProjectArchived;
});
const $a9bebd574fd66055$export$9a6ccb84170b615b = '/jira/errors/project-archived';
parcelRegister("k12ix", function(module, exports) {
    $parcel$export(module.exports, "getPerformanceFFsString", ()=>$c2cbddd7f2605816$export$c983ad7dc5517558);
    $parcel$export(module.exports, "getNormalisedPerformanceFFs", ()=>$c2cbddd7f2605816$export$de03840ff3eb49a4);
    var $6eBRn = parcelRequire("6eBRn");
    var $9XE6b = parcelRequire("9XE6b");
    var $8QpSo;
    var $y7eb2;
    const $c2cbddd7f2605816$var$PERF_FF_PREFIX = 'jsw.perf.';
    const $c2cbddd7f2605816$var$EXTRA_FFS_WHITELIST = new Set([
        'fe.platform.error.tracking.enabled',
        'jsw-epic-panel-performance-async-epic-details'
    ]);
    const $c2cbddd7f2605816$var$getPerformanceFFs = (0, (0, parcelRequire("8QpSo")).default)(()=>{
        const featureFlags = Object.entries((0, (0, parcelRequire("y7eb2")).default)() || {}).filter(([key])=>key.startsWith($c2cbddd7f2605816$var$PERF_FF_PREFIX)).map(([key, value])=>[
                key.substring($c2cbddd7f2605816$var$PERF_FF_PREFIX.length),
                (0, ($parcel$interopDefault($9XE6b)))(value, [
                    'value'
                ], null)
            ]);
        return (0, ($parcel$interopDefault($6eBRn)))(featureFlags);
    });
    const $c2cbddd7f2605816$var$isConsistencyCheckValue = (value)=>value === 'NEW' || value === 'OLD' || value === 'CHECK' || value === 'CHECK_RETURN_NEW';
    const $c2cbddd7f2605816$export$448575db1388a8e6 = (0, (0, parcelRequire("8QpSo")).default)((whitelist = $c2cbddd7f2605816$var$EXTRA_FFS_WHITELIST)=>{
        const featurePairs = Object.entries((0, (0, parcelRequire("y7eb2")).default)() || {}).filter(([key])=>whitelist.has(key)).map(([key, value])=>[
                key,
                (0, ($parcel$interopDefault($9XE6b)))(value, [
                    'value'
                ], null)
            ]);
        const result = {};
        featurePairs.forEach(([key, value])=>{
            result[key] = value;
            if ($c2cbddd7f2605816$var$isConsistencyCheckValue(value)) {
                result[`${key}-new`] = value === 'NEW';
                result[`${key}-old`] = value === 'OLD';
                result[`${key}-check`] = value === 'CHECK';
                result[`${key}-check-return-new`] = value === 'CHECK_RETURN_NEW';
            }
        });
        return result;
    });
    const $c2cbddd7f2605816$export$c983ad7dc5517558 = (0, (0, parcelRequire("8QpSo")).default)(()=>JSON.stringify($c2cbddd7f2605816$var$getPerformanceFFs()));
    const $c2cbddd7f2605816$export$de03840ff3eb49a4 = (0, (0, parcelRequire("8QpSo")).default)(()=>{
        const featureEntries = Object.entries({
            ...$c2cbddd7f2605816$var$getPerformanceFFs(),
            ...$c2cbddd7f2605816$export$448575db1388a8e6()
        });
        const map = {};
        featureEntries.forEach(([key, value])=>{
            const normalisedKey = key.replace(/\./g, '-');
            map[normalisedKey] = value;
            return map;
        });
        return map;
    });
});
parcelRegister("5rqex", function(module, exports) {
    $parcel$export(module.exports, "checkAndEmitApdexSignal", ()=>$ab527e70454bab7e$export$3082c88b693a5230);
    $parcel$export(module.exports, "default", ()=>$ab527e70454bab7e$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "baseDefaultProps", ()=>$ab527e70454bab7e$export$9b3029ee6188a41f);
    var $5uXOq = parcelRequire("5uXOq");
    var $99gkn;
    var $aOr3t;
    var $1u4q7;
    var $co1wz;
    var $1AZST;
    var $6G6w0;
    var $3wLoG;
    var $gtdbK;
    var $zbAs4;
    var $3B7oW;
    const $ab527e70454bab7e$export$3082c88b693a5230 = (appName, metricKey)=>{
        var emitSignal;
    };
    class $ab527e70454bab7e$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                isExpectedToHaveSsr: false,
                withMarks: [],
                extra: {},
                emitOnAnimationFrame: false
            };
        }
        render() {
            const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
            $ab527e70454bab7e$export$3082c88b693a5230(appName, metricKey);
            const isUFODefined = (0, (0, parcelRequire("co1wz")).ff)('uip.ufo') && (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
            if (isUFODefined) (0, (0, parcelRequire("zbAs4")).addUFOSSRDoneAsFMPToInteraction)();
            if (metric) {
                (0, (0, parcelRequire("gtdbK")).addBM3SSRDoneAsFMPToInteraction)(metric);
                (0, (0, parcelRequire("3B7oW")).trackBM3FeatureFlagsAccessed)(metric);
            }
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("99gkn")).default), {
                data: extra
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aOr3t")).UFOBM3TimingsToUFO), {
                marks: metric?.getData()?.marks,
                timings: metric?.getData()?.config?.timings
            }), isUFODefined ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3wLoG")).StopUfo), {
                appName: appName,
                customData: extra,
                key: (0, (0, parcelRequire("1u4q7")).getInteractionId)().current
            }) : metric && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6G6w0")).StopBrowserMetrics3), {
                metric: metric,
                customData: extra,
                emitOnAnimationFrame: emitOnAnimationFrame
            }));
        }
    }
    const $ab527e70454bab7e$export$9b3029ee6188a41f = $ab527e70454bab7e$export$2e2bcd8739ae039.defaultProps;
});
parcelRegister("aOr3t", function(module, exports) {
    $parcel$export(module.exports, "getBm3Timings", ()=>$a3e67858f0c2f8da$export$f02972da195a43bb);
    $parcel$export(module.exports, "UFOBM3TimingsToUFO", ()=>$a3e67858f0c2f8da$export$30f0b5e5acd268bf);
    $parcel$export(module.exports, "addBM3TimingsToUFO", ()=>$a3e67858f0c2f8da$export$d93d677ef2f33c5c);
    var $5uXOq = parcelRequire("5uXOq");
    var $1tcYS;
    var $1u4q7;
    var $bFU4G;
    function $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingConfigs) {
        const bm3Timings = {};
        if (!marks || !timingConfigs) return bm3Timings;
        timingConfigs.forEach((item)=>{
            if (!item.startMark || !item.endMark) return;
            const startTime = marks[item.startMark];
            if (!startTime) return;
            const endTime = marks[item.endMark];
            if (!endTime) return;
            bm3Timings[item.key] = {
                startTime: startTime,
                endTime: endTime
            };
        });
        return bm3Timings;
    }
    function $a3e67858f0c2f8da$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
        const interactionContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("1tcYS")).default));
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)().current;
        (0, $5uXOq.useMemo)(()=>{
            if (interactionContext != null && interactionId != null && marks != null && timings != null) {
                const interactionType = (0, (0, parcelRequire("bFU4G")).getCurrentInteractionType)(interactionId);
                if (interactionType === 'press') return;
                const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timings);
                interactionContext.addCustomTimings(bm3Timings);
            }
        }, [
            interactionContext,
            interactionId,
            marks,
            timings
        ]);
        return null;
    }
    function $a3e67858f0c2f8da$export$d93d677ef2f33c5c(marks, timingsConfig) {
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)().current;
        if (interactionId) {
            const interactionType = (0, (0, parcelRequire("bFU4G")).getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingsConfig);
            (0, (0, parcelRequire("bFU4G")).addCustomTiming)(interactionId, [], bm3Timings);
        }
    }
});
parcelRegister("6G6w0", function(module, exports) {
    $parcel$export(module.exports, "StopBrowserMetrics3", ()=>$84d0d168ebb35c8a$export$575e93c0f9905999);
    var $5uXOq = parcelRequire("5uXOq");
    var $1tcYS;
    var $21pfT;
    var $x9xyg;
    var $7N30e;
    var $co1wz;
    var $4dRjY;
    var $2SVPM;
    var $6b6Tk;
    const $84d0d168ebb35c8a$var$emitMetrics = (metric, customData, stopTime)=>{
        !(0, (0, parcelRequire("co1wz")).ff)('bm3.emit-on-raf.top-experiences') && (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, (0, parcelRequire("4dRjY")).PRODUCT_START_MARK), true);
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
        if (stopTime !== undefined) {
            if (!(0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task')) {
                metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, (0, parcelRequire("x9xyg")).setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
            }
            metric.stop({
                customData: customData,
                stopTime: stopTime
            });
        } else metric.stop({
            customData: customData
        });
        if ((0, (0, parcelRequire("6b6Tk")).isAutomaticExposureCollectionEnabled)()) (0, (0, parcelRequire("7N30e")).stopLowPriorityEventDelay)();
    };
    class $84d0d168ebb35c8a$export$575e93c0f9905999 extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
            if (!metric) return;
            const start = (0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task') ? (0, (0, parcelRequire("21pfT")).browserMetrics).getPageLoadMetric().getData()?.start || 0 : 0;
            (0, (0, parcelRequire("x9xyg")).setMark)('BROWSER_METRICS_TTI_START', {
                startTime: start
            });
            (0, (0, parcelRequire("x9xyg")).setMark)('BROWSER_METRICS_TTI_END');
            (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
            const bm3Data = metric.getData();
            if (emitOnAnimationFrame) {
                const stopTime = performance.now();
                (0, (0, parcelRequire("co1wz")).ff)('bm3.emit-on-raf.top-experiences') && (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, (0, parcelRequire("4dRjY")).PRODUCT_START_MARK), true);
                if (bm3Data) this.context?.addApdex({
                    key: bm3Data.key,
                    startTime: bm3Data.start,
                    stopTime: stopTime
                });
                if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                    (0, (0, parcelRequire("x9xyg")).setMark)('BROWSER_METRICS_TTI_TASK_END');
                    (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
                });
                requestAnimationFrame(()=>{
                    if ((0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task')) {
                        metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                        (0, (0, parcelRequire("x9xyg")).setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                        (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
                    }
                    if ((0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task')) setTimeout(()=>{
                        $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                    }, 500);
                    else $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                });
            } else {
                if (bm3Data) this.context?.addApdex({
                    key: bm3Data.key,
                    startTime: bm3Data.start,
                    stopTime: performance.now()
                });
                (0, (0, parcelRequire("co1wz")).ff)('bm3.emit-on-raf.top-experiences') && (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, (0, parcelRequire("4dRjY")).PRODUCT_START_MARK), true);
                $84d0d168ebb35c8a$var$emitMetrics(metric, customData);
            }
        }
        static{
            this.contextType = (0, (0, parcelRequire("1tcYS")).default);
        }
        render() {
            return null;
        }
    }
});
const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';
parcelRegister("3wLoG", function(module, exports) {
    $parcel$export(module.exports, "StopUfo", ()=>$bc9c50f4292c4530$export$d91154f099475c5);
    var $5uXOq = parcelRequire("5uXOq");
    var $1tcYS;
    var $1AZST;
    class $bc9c50f4292c4530$export$d91154f099475c5 extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { customData: customData, appName: appName } = this.props;
            (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).success({
                force: true,
                metadata: customData
            });
            const name = appName || (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).loadingPageLoadId;
            if (name) this.context?.addApdex({
                key: name,
                stopTime: performance.now()
            });
        }
        static{
            this.contextType = (0, (0, parcelRequire("1tcYS")).default);
        }
        render() {
            return null;
        }
    }
});
parcelRegister("gtdbK", function(module, exports) {
    $parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", ()=>$9088c71f7c9189f4$export$bf239ac2bfb04967);
    var $1u4q7;
    var $bFU4G;
    function $9088c71f7c9189f4$export$bf239ac2bfb04967(metric) {
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        const data = metric.getData();
        const config = data?.config;
        if (config && data?.isInitial) (0, (0, parcelRequire("bFU4G")).addMetadata)(currentInteractionId, {
            __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
        });
    }
});
parcelRegister("zbAs4", function(module, exports) {
    $parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", ()=>$30d390cd1767d57f$export$e63862cd888fe05a);
    var $1u4q7;
    var $bFU4G;
    var $1AZST;
    var $49z18;
    async function $30d390cd1767d57f$export$e63862cd888fe05a() {
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        const data = await (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).exportData();
        const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, (0, parcelRequire("49z18")).payloadPublisher).ssr?.getDoneMark();
        if (data.initial && fmpMark) (0, (0, parcelRequire("bFU4G")).addMetadata)(currentInteractionId, {
            __legacy__ufoConfigSSRDoneAsFmp: true
        });
    }
});
parcelRegister("3B7oW", function(module, exports) {
    $parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", ()=>$afa764d83f81f55e$export$f00f1e874ce869e9);
    var $1u4q7;
    var $y7eb2;
    const $afa764d83f81f55e$var$startsAsObject = (value)=>{
        try {
            if (value.charAt(0) === '{') return true;
        } catch (e) {
            return false;
        }
        return false;
    };
    const $afa764d83f81f55e$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
    const $afa764d83f81f55e$var$isString = (input)=>{
        let result;
        try {
            result = typeof input === 'string' || input instanceof String;
        } catch (err) {
            result = false;
        }
        return result;
    };
    const $afa764d83f81f55e$export$7b4abba432e57989 = (value)=>$afa764d83f81f55e$var$isString(value) && $afa764d83f81f55e$var$startsAsObject(value) || $afa764d83f81f55e$var$isObject(value);
    const $afa764d83f81f55e$export$fcc03ee4c944962f = (featureFlagValue)=>$afa764d83f81f55e$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
    const $afa764d83f81f55e$export$d2818866b4acbea4 = new Map();
    const $afa764d83f81f55e$export$f00f1e874ce869e9 = (metric)=>{
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        const data = metric.getData();
        const config = data?.config;
        if (config && config?.featureFlags?.length) {
            const allFeatureFlags = (0, (0, parcelRequire("y7eb2")).default)();
            config.featureFlags.forEach((featureFlagName)=>{
                const value = allFeatureFlags[featureFlagName];
                if (value === undefined) return;
                const featureFlagValue = $afa764d83f81f55e$export$fcc03ee4c944962f(value);
                $afa764d83f81f55e$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
            });
        }
    };
});
const $445133175f40343b$export$50a1bc82cf68f557 = 'PROJECT_NOT_AVAILABLE_ERROR';
const $445133175f40343b$export$e5e4b8c32e68dd0b = 'NETWORK_ERROR';
const $445133175f40343b$export$f10b32dfda12e96e = 'UNKNOWN_ERROR';
parcelRegister("eKt4x", function(module, exports) {
    $parcel$export(module.exports, "ROADMAP_APP_ID", ()=>$cdfdb9620a1a4ae4$export$eb64d27edca3e703);
    $parcel$export(module.exports, "toRoadmapAppId", ()=>$cdfdb9620a1a4ae4$export$ad60357d6714d43);
    $parcel$export(module.exports, "ROADMAP_PACKAGE_NAME", ()=>$cdfdb9620a1a4ae4$export$8c14295980d51b03);
    $parcel$export(module.exports, "ROADMAP_CRITICAL_DATA_SUCCEEDED", ()=>$cdfdb9620a1a4ae4$export$4fd29a5a4da01768);
    $parcel$export(module.exports, "ROADMAP_CRITICAL_DATA_FAILED", ()=>$cdfdb9620a1a4ae4$export$f764daad80c436d4);
    $parcel$export(module.exports, "ROADMAP_RESOURCE_DATA_FAILED", ()=>$cdfdb9620a1a4ae4$export$aa3a14ab8610ef4c);
    $parcel$export(module.exports, "TTRSLO", ()=>$cdfdb9620a1a4ae4$export$747aad128920134d);
    $parcel$export(module.exports, "TTISLO", ()=>$cdfdb9620a1a4ae4$export$e4f8d353742c04ac);
    $parcel$export(module.exports, "PARENT_STARTS_AFTER_CHILD_MESSAGE_ID", ()=>$cdfdb9620a1a4ae4$export$a97149d40382503f);
    $parcel$export(module.exports, "PARENT_ENDS_BEFORE_CHILD_MESSAGE_ID", ()=>$cdfdb9620a1a4ae4$export$d766993468a8fc97);
    $parcel$export(module.exports, "PARENT_STARTS_AFTER_CHILD_AND_ENDS_BEFORE_CHILD_MESSAGE_ID", ()=>$cdfdb9620a1a4ae4$export$af6ac3ecd3a809a5);
    $parcel$export(module.exports, "SPRINT_ENDS_BEFORE_CHILD_MESSAGE_ID", ()=>$cdfdb9620a1a4ae4$export$15c1cc5c30ec0dfc);
    $parcel$export(module.exports, "START_DATE_LATER_DUE_DATE_MESSAGE_ID", ()=>$cdfdb9620a1a4ae4$export$92d02ff4a955dc9b);
    $parcel$export(module.exports, "END_DATE_LATER_RELEASE_DATE_MESSAGE_ID", ()=>$cdfdb9620a1a4ae4$export$200248664fd9723f);
    $parcel$export(module.exports, "PARENT_PLACEHOLDER_DAYS", ()=>$cdfdb9620a1a4ae4$export$6d703b8596a86779);
    $parcel$export(module.exports, "CHILD_PLACEHOLDER_DAYS", ()=>$cdfdb9620a1a4ae4$export$92aea0f0203ecd42);
    $parcel$export(module.exports, "INTERACTED_ITEMS_LIMIT", ()=>$cdfdb9620a1a4ae4$export$9272a348c522993d);
    $parcel$export(module.exports, "SCHEDULING_SECTION", ()=>$cdfdb9620a1a4ae4$export$621948a1f95448a3);
    $parcel$export(module.exports, "BULK_SECTION", ()=>$cdfdb9620a1a4ae4$export$b7607bb0b8643f2);
    $parcel$export(module.exports, "REMOVE_DATES", ()=>$cdfdb9620a1a4ae4$export$7fdcec4cf891105d);
    $parcel$export(module.exports, "EDIT_SPRINT", ()=>$cdfdb9620a1a4ae4$export$7e560fa5dffb36e);
    $parcel$export(module.exports, "EDIT_DATES", ()=>$cdfdb9620a1a4ae4$export$cbfaa2b9201694be);
    $parcel$export(module.exports, "BULK_EDIT_DATES", ()=>$cdfdb9620a1a4ae4$export$5e364e0a31ed0481);
    $parcel$export(module.exports, "CHANGE_PARENT_ISSUE", ()=>$cdfdb9620a1a4ae4$export$5a0f05a726955e4b);
    $parcel$export(module.exports, "CHANGE_ISSUE_COLOR", ()=>$cdfdb9620a1a4ae4$export$92ad4eabf7fea56c);
    $parcel$export(module.exports, "EDIT_DEPENDENCY", ()=>$cdfdb9620a1a4ae4$export$1cdd104841f05601);
    $parcel$export(module.exports, "REMOVE_START_DATE", ()=>$cdfdb9620a1a4ae4$export$8bfecf0f063625c9);
    $parcel$export(module.exports, "REMOVE_DUE_DATE", ()=>$cdfdb9620a1a4ae4$export$3d55939abaccfa3a);
    $parcel$export(module.exports, "REMOVE_START_DATE_AND_DUE_DATE", ()=>$cdfdb9620a1a4ae4$export$9a2eb0ee3249713e);
    const $cdfdb9620a1a4ae4$export$eb64d27edca3e703 = 'standard-roadmap';
    const $cdfdb9620a1a4ae4$export$ad60357d6714d43 = (type)=>type ? `${$cdfdb9620a1a4ae4$export$eb64d27edca3e703}.${type}`.toLowerCase() : $cdfdb9620a1a4ae4$export$eb64d27edca3e703;
    const $cdfdb9620a1a4ae4$export$8c14295980d51b03 = 'jiraSoftwareRoadmapStandard';
    const $cdfdb9620a1a4ae4$export$4fd29a5a4da01768 = 'roadmap-critical-data-succeeded';
    const $cdfdb9620a1a4ae4$export$f764daad80c436d4 = 'roadmap-critical-data-failed';
    const $cdfdb9620a1a4ae4$export$aa3a14ab8610ef4c = 'roadmap-resource-data-failed';
    const $cdfdb9620a1a4ae4$export$747aad128920134d = 1000;
    const $cdfdb9620a1a4ae4$export$e4f8d353742c04ac = 4000;
    const $cdfdb9620a1a4ae4$export$5b7423264d48ab04 = 'not-enrolled';
    const $cdfdb9620a1a4ae4$export$43f367b3e957f219 = 'control';
    const $cdfdb9620a1a4ae4$export$9ba2bc3b1bdc1519 = 'experiment';
    const $cdfdb9620a1a4ae4$export$a97149d40382503f = 'parentStartsAfterChild';
    const $cdfdb9620a1a4ae4$export$d766993468a8fc97 = 'parentEndsBeforeChild';
    const $cdfdb9620a1a4ae4$export$af6ac3ecd3a809a5 = 'parentStartsAfterChildAndEndsBeforeChild';
    const $cdfdb9620a1a4ae4$export$15c1cc5c30ec0dfc = 'sprintEndsBeforeChild';
    const $cdfdb9620a1a4ae4$export$92d02ff4a955dc9b = 'startDateLaterDueDate';
    const $cdfdb9620a1a4ae4$export$200248664fd9723f = 'endDateLaterReleasesDate';
    const $cdfdb9620a1a4ae4$export$6d703b8596a86779 = 30;
    const $cdfdb9620a1a4ae4$export$92aea0f0203ecd42 = 14;
    const $cdfdb9620a1a4ae4$export$9272a348c522993d = 50;
    const $cdfdb9620a1a4ae4$export$621948a1f95448a3 = 'schedulingSection';
    const $cdfdb9620a1a4ae4$export$b7607bb0b8643f2 = 'bulkSection';
    const $cdfdb9620a1a4ae4$export$7fdcec4cf891105d = 'REMOVE_DATES';
    const $cdfdb9620a1a4ae4$export$7e560fa5dffb36e = 'EDIT_SPRINT';
    const $cdfdb9620a1a4ae4$export$cbfaa2b9201694be = 'EDIT_DATES';
    const $cdfdb9620a1a4ae4$export$5e364e0a31ed0481 = 'BULK_EDIT_DATES';
    const $cdfdb9620a1a4ae4$export$5a0f05a726955e4b = 'CHANGE_PARENT_ISSUE';
    const $cdfdb9620a1a4ae4$export$92ad4eabf7fea56c = 'CHANGE_ISSUE_COLOR';
    const $cdfdb9620a1a4ae4$export$1cdd104841f05601 = 'EDIT_DEPENDENCY';
    const $cdfdb9620a1a4ae4$export$8bfecf0f063625c9 = 'REMOVE_START_DATE';
    const $cdfdb9620a1a4ae4$export$3d55939abaccfa3a = 'REMOVE_DUE_DATE';
    const $cdfdb9620a1a4ae4$export$9a2eb0ee3249713e = 'REMOVE_START_DATE_AND_DUE_DATE';
});
parcelRegister("8WL0u", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$86f14fb911de2aaf$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $ajpes = parcelRequire("ajpes");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $eZJjh;
    var $jD5no;
    var $lf2Au;
    var $j2mQS;
    var $bRUzT;
    var $fTc8n;
    var $7iJwP;
    var $97Kan;
    var $3HwlS;
    var $hN2XX;
    var $bicfN;
    var $1bQGJ;
    var $eKt4x;
    var $3XMkN;
    var $hMUWp;
    var $fLnKW;
    var $jAJAx;
    var $cvFzo;
    var $5EEYw;
    var $lEmZG;
    var $9MZpN;
    const $86f14fb911de2aaf$var$isDevelopment = window.BUILD_KEY === 'JF-TEST';
    class $86f14fb911de2aaf$var$StandardRoadmap extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                isServer: false,
                isReadOnly: false,
                cloudId: undefined,
                activationId: undefined,
                macroConfig: undefined,
                type: (0, $f1ec00c5efd4c816$export$296f840b5ae7056e),
                onUnmount: (0, ($parcel$interopDefault($8Rkzz)))
            };
        }
        constructor(props){
            super(props);
            const { criticalData: criticalData } = props;
            this.initialiseStore(criticalData);
        }
        componentDidMount() {
            const { criticalData: criticalData } = this.props;
            if (criticalData) this.initialiseUserPropertiesEngine();
        }
        componentDidUpdate(prevProps) {
            if (this.store && !(0, ($parcel$interopDefault($ajpes)))(prevProps.criticalData, this.props.criticalData) && this.props.criticalData && (!((0, $8631d6ce464ccf2e$export$889129cf7f70997b) in this.props.criticalData) || this.props.criticalData[0, $8631d6ce464ccf2e$export$889129cf7f70997b] !== (0, $8631d6ce464ccf2e$export$b7dfe28569b170a1))) {
                (0, (0, parcelRequire("hN2XX")).triggerCacheRefreshAnalytics)((0, $8631d6ce464ccf2e$export$ffff0a2c60bf4822));
                this.store.dispatch((0, (0, parcelRequire("jAJAx")).updateCriticalData)(this.props.criticalData));
            }
        }
        componentWillUnmount() {
            if (this.store && this.store.dispatch) this.store.dispatch((0, (0, parcelRequire("bRUzT")).DISPOSE_ACTION));
            this.props.onUnmount();
        }
        initialiseStore(criticalData) {
            const { push: push, location: location, type: type } = this.props;
            const rootEpic = (0, (0, parcelRequire("hMUWp")).default)(type);
            this.store = (0, (0, parcelRequire("cvFzo")).default)(type, (0, (0, parcelRequire("j2mQS")).disposableEpic)(rootEpic), {
                router: {
                    push: push
                }
            });
            this.store.dispatch((0, (0, parcelRequire("jAJAx")).initializeAppProps)(this.getAppProps()));
            this.store.dispatch((0, (0, parcelRequire("jAJAx")).initializeCriticalData)(criticalData));
            this.store.dispatch((0, (0, parcelRequire("5EEYw")).routerLocationChange)(location));
        }
        initialiseUserPropertiesEngine() {
            const { criticalData: criticalData, boardId: boardId, sourceAri: sourceAri, loggedInAccountId: loggedInAccountId, macroConfig: macroConfig } = this.props;
            const settings = criticalData.settings || {};
            const userPropertyKey = `roadmap${macroConfig ? '-macro' : ''}`;
            if (this.store) (0, (0, parcelRequire("fTc8n")).attachToStore)(this.store, (0, (0, parcelRequire("lEmZG")).engine)(userPropertyKey, boardId, sourceAri, ()=>loggedInAccountId, settings), (0, (0, parcelRequire("fLnKW")).default)).subscribe();
        }
        getAppProps() {
            const { isReadOnly: isReadOnly, boardId: boardId, sourceAri: sourceAri, loggedInAccountId: loggedInAccountId, cloudId: cloudId, activationId: activationId, macroConfig: macroConfig, type: type, containerName: containerName } = this.props;
            return {
                isReadOnly: isReadOnly,
                boardId: boardId,
                sourceAri: sourceAri,
                loggedInAccountId: loggedInAccountId,
                cloudId: cloudId,
                activationId: activationId,
                macroConfig: macroConfig,
                containerName: containerName,
                type: type
            };
        }
        getRoadmapView() {
            const { macroConfig: macroConfig, type: type } = this.props;
            if (type === (0, $f1ec00c5efd4c816$export$40f914e9a75ff65a) && !macroConfig) return 0, (0, parcelRequire("9MZpN")).ClassicStandardView;
            if (type === (0, $f1ec00c5efd4c816$export$40f914e9a75ff65a) && macroConfig) return 0, (0, parcelRequire("9MZpN")).ClassicStandardMacro;
            if (macroConfig) return 0, (0, parcelRequire("9MZpN")).StandardMacro;
            return 0, (0, parcelRequire("9MZpN")).StandardView;
        }
        render() {
            const { isServer: isServer, macroConfig: macroConfig, type: type, criticalData: criticalData } = this.props;
            if (!criticalData) return (0, ($parcel$interopDefault($5uXOq))).createElement($86f14fb911de2aaf$var$SpinnerWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
                size: "large"
            }));
            const RoadmapView = this.getRoadmapView();
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jD5no")).default), {
                id: (0, (0, parcelRequire("eKt4x")).toRoadmapAppId)(type),
                store: this.store,
                teamName: "chronos",
                packageName: "@atlassian/jira-software-roadmap-standard"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7iJwP")).default), {
                id: (0, (0, parcelRequire("eKt4x")).toRoadmapAppId)(type),
                packageName: (0, (0, parcelRequire("eKt4x")).ROADMAP_PACKAGE_NAME),
                attributes: {
                    isDevelopment: $86f14fb911de2aaf$var$isDevelopment
                }
            }, (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement(RoadmapView, {
                isServer: isServer,
                isMacroView: Boolean(macroConfig)
            }), type !== (0, $f1ec00c5efd4c816$export$40f914e9a75ff65a) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bicfN")).default), {
                origin: (0, $8631d6ce464ccf2e$export$ffff0a2c60bf4822)
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("97Kan")).FlagsDispatcher), {
                mapper: (0, (0, parcelRequire("3XMkN")).flagsMapper)
            })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lf2Au")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement(RoadmapView, {
                isServer: isServer,
                isMacroView: Boolean(macroConfig)
            }), type !== (0, $f1ec00c5efd4c816$export$40f914e9a75ff65a) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bicfN")).default), {
                origin: (0, $8631d6ce464ccf2e$export$ffff0a2c60bf4822)
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("97Kan")).FlagsDispatcher), {
                mapper: (0, (0, parcelRequire("3XMkN")).flagsMapper)
            }))));
        }
    }
    var $86f14fb911de2aaf$export$2e2bcd8739ae039 = (0, (0, parcelRequire("1bQGJ")).withRouter)($86f14fb911de2aaf$var$StandardRoadmap);
    const $86f14fb911de2aaf$var$SpinnerWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bsb13sl _4t3i1osq _kqswstnw _4cvr1h6o _1bah1h6o",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("lf2Au", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9249f8c63b854f95$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $47bDC = parcelRequire("47bDC");
    var $gwIPs;
    var $cSD7y;
    const $9249f8c63b854f95$var$AppStyle = ({ children: children })=>$5uXOq.createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_ect41sbm _1wyb1oud _4t3i1kw7 _1dyz4jg8"
            ])
        }, children);
    const $9249f8c63b854f95$var$AppStyleOld = (0, $47bDC.default).div.withConfig({
        componentId: "h5xpn2-0"
    })({
        fontFamily: (0, parcelRequire("gwIPs")).fontFamily,
        fontSize: `${(0, (0, parcelRequire("gwIPs")).fontSize)}px`,
        height: 'inherit',
        letterSpacing: 'normal'
    });
    const $9249f8c63b854f95$var$appStyles = null;
    const $9249f8c63b854f95$var$AppStyleFinal = (0, (0, parcelRequire("cSD7y")).componentWithFG)('jfp-1020-use-compiled', $9249f8c63b854f95$var$AppStyle, $9249f8c63b854f95$var$AppStyleOld);
    var $9249f8c63b854f95$export$2e2bcd8739ae039 = $9249f8c63b854f95$var$AppStyleFinal;
});
parcelRegister("j2mQS", function(module, exports) {
    $parcel$export(module.exports, "disposableEpic", ()=>$1c9d4320a4bfd294$export$e6b812e492b046b8);
    parcelRequire("7qVV7");
    const $1c9d4320a4bfd294$export$e6b812e492b046b8 = (rootEpic)=>(action$, store, dependencies)=>rootEpic(action$, store, dependencies).takeUntil(action$.ofType((0, $167b7959815986d2$export$58387e80544dbf03)));
});
const $167b7959815986d2$export$58387e80544dbf03 = 'COMMON/REDUX_DISPOSABLE/DISPOSE_ACTION';
parcelRegister("bRUzT", function(module, exports) {
    $parcel$export(module.exports, "DISPOSE_ACTION", ()=>$b69e8859fbb50550$export$78be82e7e063a3fb);
    const $b69e8859fbb50550$export$78be82e7e063a3fb = {
        type: (0, $167b7959815986d2$export$58387e80544dbf03)
    };
});
parcelRegister("fTc8n", function(module, exports) {
    $parcel$export(module.exports, "attachToStore", ()=>$f99a9797bfcfc8e9$export$646875c6afc27c8);
    parcelRequire("fp4O3");
    parcelRequire("zjDln");
    parcelRequire("8vsXW");
    parcelRequire("fPS7b");
    var $aB8eX = parcelRequire("aB8eX");
    var $kVLXA = parcelRequire("kVLXA");
    const $f99a9797bfcfc8e9$export$646875c6afc27c8 = (store, engine, rootStorage, waitUntil)=>{
        const trigger = waitUntil || (0, $kVLXA.Observable).from([
            true
        ]);
        let initialized = false;
        return trigger.first().mergeMap(()=>{
            if (initialized) return (0, $kVLXA.Observable).of(store);
            initialized = true;
            const hydrationActions = rootStorage.hydrate(store.getState(), engine);
            if (hydrationActions !== undefined) return hydrationActions.mergeMap((actions)=>{
                store.dispatch((0, $aB8eX.batchActions)(actions));
                store.subscribe(()=>{
                    rootStorage.modify(store.getState(), engine);
                });
                return (0, $kVLXA.Observable).of(store);
            });
            return (0, $kVLXA.Observable).of(store);
        });
    };
});
parcelRegister("97Kan", function(module, exports) {
    $parcel$export(module.exports, "FlagsDispatcher", ()=>$4ddeb9f500a62e17$export$9e60e3d40b6e758f);
    var $5uXOq = parcelRequire("5uXOq");
    var $pa9q9;
    var $fpHHI;
    const $4ddeb9f500a62e17$export$9e60e3d40b6e758f = ({ store: store, mapper: mapper })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fpHHI")).Dispatcher), {
            store: store,
            mapper: mapper,
            showFlag: (0, (0, parcelRequire("pa9q9")).showFlag),
            dismissFlag: (0, (0, parcelRequire("pa9q9")).dismissFlag)
        });
});
parcelRegister("fpHHI", function(module, exports) {
    $parcel$export(module.exports, "Dispatcher", ()=>$eef6139685bfb64e$export$ab054a1ef92eeb01);
    var $5uXOq = parcelRequire("5uXOq");
    var $1kijq;
    const $eef6139685bfb64e$export$ab054a1ef92eeb01 = (props)=>{
        const { store: store, ...dispatcherProps } = props;
        const [lastStore, setLastStore] = (0, $5uXOq.useState)(store);
        if (store !== lastStore) setLastStore(store);
        const DispatcherComponent = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("1kijq")).createDispatcher)(store), [
            store
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(DispatcherComponent, dispatcherProps);
    };
});
parcelRegister("1kijq", function(module, exports) {
    $parcel$export(module.exports, "createDispatcher", ()=>$c324e875f8c6fe8f$export$7b259d28468da15b);
    var $5uXOq = parcelRequire("5uXOq");
    var $kVVL1 = parcelRequire("kVVL1");
    var $pa9q9;
    const $c324e875f8c6fe8f$export$81c2f3c810206fa9 = (store)=>{
        if (!store) throw new Error('Store not available through direct injection or Provider context');
        if (!('addActionListener' in store) || !('removeActionListener' in store) || typeof store.addActionListener !== 'function' || typeof store.removeActionListener !== 'function') throw new Error("Your store doesn't support action listeners; please use the Tangerine store initialiser.");
        return store;
    };
    const $c324e875f8c6fe8f$export$8a44987212de21b = (store, result, showFlag, dismissFlag)=>{
        if (!result) return;
        if ((0, (0, parcelRequire("pa9q9")).isDismissFlag)(result)) dismissFlag(result);
        else if ((0, (0, parcelRequire("pa9q9")).isFlagComponent)(result)) {
            const FlagComponent = result;
            const FlagComponentWithProvider = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $kVVL1.Provider), {
                    store: store
                }, (0, ($parcel$interopDefault($5uXOq))).createElement(FlagComponent, props));
            showFlag(FlagComponentWithProvider);
        } else showFlag(result);
    };
    const $c324e875f8c6fe8f$export$2bedce6f5250e28d = (action, state, store, mapper, showFlag, dismissFlag)=>{
        if ((0, (0, parcelRequire("pa9q9")).isBatchAction)(action)) action.payload.forEach((childAction)=>{
            if (childAction.type && typeof childAction.type === 'string') {
                const childResult = mapper(childAction, state);
                $c324e875f8c6fe8f$export$8a44987212de21b(store, childResult, showFlag, dismissFlag);
            }
        });
        else {
            const result = mapper(action, state);
            $c324e875f8c6fe8f$export$8a44987212de21b(store, result, showFlag, dismissFlag);
        }
    };
    const $c324e875f8c6fe8f$var$Dispatcher8 = (props)=>{
        const { store: storeUnchecked, mapper: mapper, showFlag: showFlag, dismissFlag: dismissFlag } = props;
        const store = (0, $5uXOq.useMemo)(()=>$c324e875f8c6fe8f$export$81c2f3c810206fa9(storeUnchecked), [
            storeUnchecked
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const handleAction = (action, state)=>{
                $c324e875f8c6fe8f$export$2bedce6f5250e28d(action, state, store, mapper, showFlag, dismissFlag);
            };
            store.addActionListener(handleAction);
            return ()=>store.removeActionListener(handleAction);
        }, [
            store,
            mapper,
            showFlag,
            dismissFlag
        ]);
        return null;
    };
    const $c324e875f8c6fe8f$var$Dispatcher8DefaultStore = (props)=>{
        const store = (0, $kVVL1.useStore)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($c324e875f8c6fe8f$var$Dispatcher8, {
            ...props,
            store: store
        });
    };
    const $c324e875f8c6fe8f$export$7b259d28468da15b = (customStore)=>{
        const Dispatcher8CustomStore = (props)=>customStore ? (0, ($parcel$interopDefault($5uXOq))).createElement($c324e875f8c6fe8f$var$Dispatcher8, {
                ...props,
                store: customStore
            }) : null;
        return customStore ? Dispatcher8CustomStore : $c324e875f8c6fe8f$var$Dispatcher8DefaultStore;
    };
});
const $8631d6ce464ccf2e$export$9b8283d5878d2491 = 'BOARD';
const $8631d6ce464ccf2e$export$dedbdcc35e955187 = 'BACKLOG';
const $8631d6ce464ccf2e$export$ffff0a2c60bf4822 = 'ROADMAPS';
const $8631d6ce464ccf2e$export$78244dbb77cfa6b6 = 'UNKNOWN';
const $8631d6ce464ccf2e$export$b7dfe28569b170a1 = 'RESOURCES_CACHE_UPDATER_SOURCE';
const $8631d6ce464ccf2e$export$889129cf7f70997b = 'resourcesCacheSource';
parcelRegister("hN2XX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$43e79ffcea087bf1$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "triggerCacheRefreshAnalytics", ()=>$43e79ffcea087bf1$export$e78b5ce2eed37743);
    var $cab1K = parcelRequire("cab1K");
    const $43e79ffcea087bf1$var$ResourcesCacheRefreshAnalytics = new (0, $cab1K.Subject)();
    var $43e79ffcea087bf1$export$2e2bcd8739ae039 = $43e79ffcea087bf1$var$ResourcesCacheRefreshAnalytics;
    const $43e79ffcea087bf1$export$e78b5ce2eed37743 = (origin)=>{
        $43e79ffcea087bf1$var$ResourcesCacheRefreshAnalytics.next(origin);
    };
});
parcelRegister("bicfN", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$c2dc8c17f1f21ea3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iqr2y;
    var $ddxdb;
    var $4NXqP;
    var $k3C5L;
    const $c2dc8c17f1f21ea3$var$ResourcesCacheWrapper = ({ origin: origin })=>{
        (0, (0, parcelRequire("ddxdb")).default)(origin);
        (0, (0, parcelRequire("k3C5L")).default)();
        (0, (0, parcelRequire("4NXqP")).default)(origin);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null);
    };
    const $c2dc8c17f1f21ea3$var$ResourcesCacheWrapperWithBoundary = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqr2y")).ErrorBoundaryFlag), {
            id: "jira-software-resource-invalidator"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($c2dc8c17f1f21ea3$var$ResourcesCacheWrapper, props));
    var $c2dc8c17f1f21ea3$export$2e2bcd8739ae039 = $c2dc8c17f1f21ea3$var$ResourcesCacheWrapperWithBoundary;
});
parcelRegister("ddxdb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$18c7e4eef3bac87c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    parcelRequire("7mHDu");
    parcelRequire("1oQta");
    var $8Uumt = parcelRequire("8Uumt");
    var $koeKL;
    var $doZTA;
    var $b0yad;
    var $8asTe;
    var $77kqL;
    const $18c7e4eef3bac87c$var$useResourcesCacheInvalidation = (origin)=>{
        const [resourcesRef] = (0, (0, parcelRequire("8asTe")).default)();
        const environment = (0, $8Uumt.useRelayEnvironment)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const [{ match: match }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const boardId = match.params.boardId || '';
        (0, $5uXOq.useEffect)(()=>{
            let needToClearResourcesCacheOnExit = false;
            const subscription = (0, (0, parcelRequire("b0yad")).default).filter((val)=>val === origin).take(1).subscribe(()=>{
                Object.keys(resourcesRef.current).filter((key)=>key !== origin).forEach((key)=>{
                    resourcesRef.current[key].clear();
                });
                (0, (0, parcelRequire("77kqL")).invalidateRelayStore)(environment, cloudId, boardId);
                if (origin in resourcesRef.current) needToClearResourcesCacheOnExit = true;
            });
            return ()=>{
                subscription.unsubscribe();
                if (needToClearResourcesCacheOnExit && origin in resourcesRef.current) {
                    resourcesRef.current[origin].clear();
                    (0, (0, parcelRequire("77kqL")).invalidateRelayStore)(environment, cloudId, boardId);
                }
            };
        }, [
            origin,
            resourcesRef,
            environment,
            cloudId,
            boardId
        ]);
        return [
            (0, (0, parcelRequire("b0yad")).default)
        ];
    };
    var $18c7e4eef3bac87c$export$2e2bcd8739ae039 = $18c7e4eef3bac87c$var$useResourcesCacheInvalidation;
});
parcelRegister("b0yad", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0d7966c085fcd143$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "triggerResourceCacheInvalidation", ()=>$0d7966c085fcd143$export$76c3549b2288ab5d);
    $parcel$export(module.exports, "addInvalidationReason", ()=>$0d7966c085fcd143$export$77045c8772786aca);
    $parcel$export(module.exports, "getAndClearInvalidationReasons", ()=>$0d7966c085fcd143$export$c5ab3b0612bd31b4);
    var $cab1K = parcelRequire("cab1K");
    var $h8O2U;
    const $0d7966c085fcd143$var$invalidationTracker = new (0, (0, parcelRequire("h8O2U")).CacheInvalidationTracker)();
    const $0d7966c085fcd143$var$ResourcesCacheInvalidationSubject = new (0, $cab1K.Subject)();
    var $0d7966c085fcd143$export$2e2bcd8739ae039 = $0d7966c085fcd143$var$ResourcesCacheInvalidationSubject;
    const $0d7966c085fcd143$export$76c3549b2288ab5d = (origin, reason = (0, $8631d6ce464ccf2e$export$78244dbb77cfa6b6))=>{
        $0d7966c085fcd143$var$ResourcesCacheInvalidationSubject.next(origin);
        $0d7966c085fcd143$var$invalidationTracker.addReason(origin, reason);
    };
    const $0d7966c085fcd143$export$77045c8772786aca = (origin, reason)=>{
        $0d7966c085fcd143$var$invalidationTracker.addReason(origin, reason);
    };
    const $0d7966c085fcd143$export$c5ab3b0612bd31b4 = (origin)=>$0d7966c085fcd143$var$invalidationTracker.getAndClearReasons(origin);
});
parcelRegister("h8O2U", function(module, exports) {
    $parcel$export(module.exports, "CacheInvalidationTracker", ()=>$42c3911f8f33a9e0$export$71900622f425a7c3);
    class $42c3911f8f33a9e0$export$71900622f425a7c3 {
        addReason(origin, reason = (0, $8631d6ce464ccf2e$export$78244dbb77cfa6b6)) {
            const reasonString = `${origin}:${reason}`;
            Object.keys(this.reasons).forEach((key)=>{
                if (this.reasons[key].size >= 10) return;
                this.reasons[key].add(reasonString);
            });
        }
        getAndClearReasons(origin) {
            const reasonsSet = this.reasons[origin];
            const reasons = Array.from(reasonsSet);
            reasons.sort();
            reasonsSet.clear();
            return reasons;
        }
        constructor(){
            this.reasons = {
                [(0, $8631d6ce464ccf2e$export$9b8283d5878d2491)]: new Set(),
                [(0, $8631d6ce464ccf2e$export$dedbdcc35e955187)]: new Set(),
                [(0, $8631d6ce464ccf2e$export$ffff0a2c60bf4822)]: new Set(),
                [(0, $8631d6ce464ccf2e$export$78244dbb77cfa6b6)]: new Set()
            };
        }
    }
});
parcelRegister("8asTe", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7c43deb1cb1e63c2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5qQ9I;
    var $bAB30;
    var $jsFU4;
    var $2YP9W;
    const $7c43deb1cb1e63c2$var$buildResource = ({ update: update, refresh: refresh, clear: clear })=>({
            update: update,
            refresh: refresh,
            clear: clear
        });
    const $7c43deb1cb1e63c2$var$useResourcesCacheTracker = ()=>{
        const boardResource = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("5qQ9I")).boardResource));
        const backlogResource = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("bAB30")).backlogResource));
        const roadmapResource = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("jsFU4")).nextGenRoadmapResource));
        const resourcesByOriginByRef = (0, $5uXOq.useRef)({});
        (0, $5uXOq.useEffect)(()=>{
            resourcesByOriginByRef.current = {
                [(0, $b982f18ac4600ef5$export$9b8283d5878d2491)]: $7c43deb1cb1e63c2$var$buildResource(boardResource),
                [(0, $b982f18ac4600ef5$export$dedbdcc35e955187)]: $7c43deb1cb1e63c2$var$buildResource(backlogResource),
                [(0, $b982f18ac4600ef5$export$ffff0a2c60bf4822)]: $7c43deb1cb1e63c2$var$buildResource(roadmapResource)
            };
        }, [
            boardResource,
            backlogResource,
            roadmapResource
        ]);
        return [
            resourcesByOriginByRef
        ];
    };
    var $7c43deb1cb1e63c2$export$2e2bcd8739ae039 = $7c43deb1cb1e63c2$var$useResourcesCacheTracker;
});
const $b982f18ac4600ef5$export$9b8283d5878d2491 = 'BOARD';
const $b982f18ac4600ef5$export$dedbdcc35e955187 = 'BACKLOG';
const $b982f18ac4600ef5$export$ffff0a2c60bf4822 = 'ROADMAPS';
const $b982f18ac4600ef5$export$78244dbb77cfa6b6 = 'UNKNOWN';
parcelRegister("77kqL", function(module, exports) {
    $parcel$export(module.exports, "invalidateRelayStore", ()=>$27e06e0f0fab949e$export$fac5cf9145049c1c);
    var $dXq4S;
    const $27e06e0f0fab949e$export$fac5cf9145049c1c = (environment, cloudId, boardId)=>{
        const boardAri = (0, (0, parcelRequire("dXq4S")).createAri)({
            resourceOwner: 'jira-software',
            cloudId: cloudId,
            resourceType: 'board',
            resourceId: boardId
        });
        environment.commitUpdate((store)=>{
            const boardScopeRecord = store.getRoot().getLinkedRecord('boardScope', {
                boardId: boardAri
            });
            if (boardScopeRecord) boardScopeRecord.invalidateRecord();
        });
    };
});
parcelRegister("4NXqP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0697b27d8d29769e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    parcelRequire("1oQta");
    var $8zOmE;
    var $2NMNM;
    var $hN2XX;
    const $0697b27d8d29769e$var$useCacheRefreshAnalytics = (origin)=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            const subscription = (0, (0, parcelRequire("hN2XX")).default).filter((val)=>val === origin).subscribe(()=>{
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'resourcesCacheInvalidator updatedStaleData', {
                    origin: origin
                });
            });
            return ()=>{
                subscription.unsubscribe();
            };
        }, [
            createAnalyticsEvent,
            origin
        ]);
        return [
            (0, (0, parcelRequire("hN2XX")).default)
        ];
    };
    var $0697b27d8d29769e$export$2e2bcd8739ae039 = $0697b27d8d29769e$var$useCacheRefreshAnalytics;
});
parcelRegister("k3C5L", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$47581646a47d84d9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $hGgHi = parcelRequire("hGgHi");
    parcelRequire("1oQta");
    var $gBFyV;
    var $8asTe;
    const $47581646a47d84d9$var$useResourcesCacheUpdater = ()=>{
        const [resourcesByRef] = (0, (0, parcelRequire("8asTe")).default)();
        (0, $5uXOq.useEffect)(()=>{
            const subscription = (0, (0, parcelRequire("gBFyV")).default).filter((msg)=>!(0, ($parcel$interopDefault($hGgHi)))(msg.origin)).subscribe((msg)=>{
                if (msg.origin in resourcesByRef.current) {
                    if ((0, ($parcel$interopDefault($hGgHi)))(msg.payload)) resourcesByRef.current[msg.origin].clear();
                    else resourcesByRef.current[msg.origin].update((currentData)=>({
                            ...currentData,
                            ...msg.payload,
                            [(0, $8631d6ce464ccf2e$export$889129cf7f70997b)]: (0, $8631d6ce464ccf2e$export$b7dfe28569b170a1)
                        }));
                }
            });
            return ()=>{
                subscription.unsubscribe();
            };
        }, [
            resourcesByRef
        ]);
        return [
            (0, (0, parcelRequire("gBFyV")).default)
        ];
    };
    var $47581646a47d84d9$export$2e2bcd8739ae039 = $47581646a47d84d9$var$useResourcesCacheUpdater;
});
parcelRegister("gBFyV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$48bba9321b275587$export$2e2bcd8739ae039);
    var $cab1K = parcelRequire("cab1K");
    var $48bba9321b275587$export$2e2bcd8739ae039 = new (0, $cab1K.Subject)();
});
parcelRegister("3XMkN", function(module, exports) {
    $parcel$export(module.exports, "flagsMapper", ()=>$246c6940fc3f85d2$export$4de5eb17326eea98);
    var $5uXOq = parcelRequire("5uXOq");
    var $hb2iR;
    var $if2kE;
    var $jA5AF;
    var $i4z5a;
    var $b84ui;
    var $iekkc;
    var $7pgCQ;
    var $2iANt;
    var $3He3z;
    var $6IWLZ;
    var $lUdEM;
    var $7INve;
    var $F4kmw;
    var $lQpJj;
    var $aHk2U;
    const $246c6940fc3f85d2$export$4de5eb17326eea98 = (action)=>{
        switch(action.type){
            case 0, (0, parcelRequire("hb2iR")).GENERAL_ERROR:
                return (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iekkc")).default), props);
            case 0, (0, parcelRequire("hb2iR")).UPDATE_ITEM_PERMISSION:
                return (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7INve")).default), props);
            case 0, (0, parcelRequire("hb2iR")).AGG_ERROR:
                return (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("if2kE")).default), {
                        ...props,
                        ...action.payload
                    });
            case 0, (0, parcelRequire("hb2iR")).ISSUE_HIDDEN:
                return (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lUdEM")).default), {
                        ...props,
                        ...action.payload
                    });
            case 0, (0, parcelRequire("hb2iR")).HIDDEN_DEPENDENCY_CREATED:
                return (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7pgCQ")).default), props);
            case 0, (0, parcelRequire("hb2iR")).IRRELEVANT_ISSUES_CREATED:
                return (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6IWLZ")).default), {
                        ...props,
                        issueKeys: action.payload.issueKeys
                    });
            case 0, (0, parcelRequire("hb2iR")).DEPENDENCIES_UNAVAILABLE:
                return (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b84ui")).default), props);
            case 0, (0, parcelRequire("hb2iR")).ISSUE_DISAPPEARS_FROM_DISPLAY_RANGE:
                return (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("F4kmw")).default), {
                        ...props,
                        ...action.payload
                    });
            case 0, (0, parcelRequire("hb2iR")).DEPENDENCIES_PERMISSION:
                return (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i4z5a")).default), {
                        ...props,
                        ...action.payload
                    });
            case 0, (0, parcelRequire("hb2iR")).UNABLE_TO_RANK_ISSUE:
                return (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lQpJj")).default), {
                        ...props,
                        boardId: action.payload.boardId
                    });
            case 0, (0, parcelRequire("hb2iR")).SPRINT_SCOPE_CHANGE:
                return (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aHk2U")).default), {
                        ...props,
                        ...action.payload
                    });
            case 0, (0, parcelRequire("hb2iR")).INTERACTED_ITEMS_LIMIT_EXCEEDED:
                return (props)=>action.payload ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2iANt")).default), {
                        ...props,
                        ...action.payload
                    }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3He3z")).default), props);
            case 0, (0, parcelRequire("hb2iR")).DEPENDENCY_CYCLE_CREATION:
            case 0, (0, parcelRequire("hb2iR")).DEPENDENCY_DUPLICATION:
                return (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jA5AF")).default), {
                        ...props,
                        ...action.payload,
                        isDependencyDuplicated: action.type === (0, (0, parcelRequire("hb2iR")).DEPENDENCY_DUPLICATION)
                    });
            default:
                {
                    const _exhaustiveCheck = action;
                    return undefined;
                }
        }
    };
});
parcelRegister("hb2iR", function(module, exports) {
    $parcel$export(module.exports, "GENERAL_ERROR", ()=>$2368164c033e2a67$export$34c01b0a934c2cc3);
    $parcel$export(module.exports, "generalError", ()=>$2368164c033e2a67$export$92c1813bac9046d);
    $parcel$export(module.exports, "AGG_ERROR", ()=>$2368164c033e2a67$export$6ea4bc3af98cc26f);
    $parcel$export(module.exports, "aggError", ()=>$2368164c033e2a67$export$c9dde5743c9b0078);
    $parcel$export(module.exports, "ISSUE_HIDDEN", ()=>$2368164c033e2a67$export$56afcb57c54093ef);
    $parcel$export(module.exports, "issueHidden", ()=>$2368164c033e2a67$export$82dca12a93ca673f);
    $parcel$export(module.exports, "IRRELEVANT_ISSUES_CREATED", ()=>$2368164c033e2a67$export$88f828ea7faf6538);
    $parcel$export(module.exports, "irrelevantIssuesCreated", ()=>$2368164c033e2a67$export$943b8ae0debfb128);
    $parcel$export(module.exports, "ISSUE_DISAPPEARS_FROM_DISPLAY_RANGE", ()=>$2368164c033e2a67$export$57398f8dd536d3);
    $parcel$export(module.exports, "issueDisappearsFromDisplayRange", ()=>$2368164c033e2a67$export$57c6601b7de7174e);
    $parcel$export(module.exports, "UNABLE_TO_RANK_ISSUE", ()=>$2368164c033e2a67$export$9406ea723a962c47);
    $parcel$export(module.exports, "unableToRankIssue", ()=>$2368164c033e2a67$export$e3612e71b6b39da1);
    $parcel$export(module.exports, "HIDDEN_DEPENDENCY_CREATED", ()=>$2368164c033e2a67$export$88308e1b4abfd55e);
    $parcel$export(module.exports, "hiddenDependencyCreated", ()=>$2368164c033e2a67$export$a7f194f3b406f9e5);
    $parcel$export(module.exports, "DEPENDENCIES_UNAVAILABLE", ()=>$2368164c033e2a67$export$6c8916f000f0ecf3);
    $parcel$export(module.exports, "dependenciesUnavailable", ()=>$2368164c033e2a67$export$629f4726a19e166f);
    $parcel$export(module.exports, "DEPENDENCIES_PERMISSION", ()=>$2368164c033e2a67$export$bee605ca665bc47e);
    $parcel$export(module.exports, "dependenciesPermission", ()=>$2368164c033e2a67$export$7ae2a3c0890ea73c);
    $parcel$export(module.exports, "UPDATE_ITEM_PERMISSION", ()=>$2368164c033e2a67$export$d209d541a847828d);
    $parcel$export(module.exports, "updateItemPermission", ()=>$2368164c033e2a67$export$a7eada1968affd28);
    $parcel$export(module.exports, "SPRINT_SCOPE_CHANGE", ()=>$2368164c033e2a67$export$31b38b0222b12e4a);
    $parcel$export(module.exports, "sprintScopeChanged", ()=>$2368164c033e2a67$export$d580034b0a28e0db);
    $parcel$export(module.exports, "INTERACTED_ITEMS_LIMIT_EXCEEDED", ()=>$2368164c033e2a67$export$d574f859de528225);
    $parcel$export(module.exports, "interactedItemsLimitExceeded", ()=>$2368164c033e2a67$export$a7152d9c510f3783);
    $parcel$export(module.exports, "DEPENDENCY_CYCLE_CREATION", ()=>$2368164c033e2a67$export$84666f883c5c79a2);
    $parcel$export(module.exports, "dependencyCycleCreation", ()=>$2368164c033e2a67$export$b1275e1021a43355);
    $parcel$export(module.exports, "DEPENDENCY_DUPLICATION", ()=>$2368164c033e2a67$export$b7d53719119ed01a);
    $parcel$export(module.exports, "dependencyDuplication", ()=>$2368164c033e2a67$export$de85c6fa5ee537ca);
    const $2368164c033e2a67$export$34c01b0a934c2cc3 = 'state.flags.GENERAL_ERROR';
    const $2368164c033e2a67$export$92c1813bac9046d = ()=>({
            type: $2368164c033e2a67$export$34c01b0a934c2cc3
        });
    const $2368164c033e2a67$export$6ea4bc3af98cc26f = 'state.flags.AGG_ERROR';
    const $2368164c033e2a67$export$c9dde5743c9b0078 = (payload = {
        description: undefined,
        errorType: undefined
    })=>({
            type: $2368164c033e2a67$export$6ea4bc3af98cc26f,
            payload: payload
        });
    const $2368164c033e2a67$export$56afcb57c54093ef = 'state.flags.ISSUE_HIDDEN';
    const $2368164c033e2a67$export$82dca12a93ca673f = (payload)=>({
            type: $2368164c033e2a67$export$56afcb57c54093ef,
            payload: payload
        });
    const $2368164c033e2a67$export$88f828ea7faf6538 = 'state.flags.IRRELEVANT_ISSUES_CREATED';
    const $2368164c033e2a67$export$943b8ae0debfb128 = (payload)=>({
            type: $2368164c033e2a67$export$88f828ea7faf6538,
            payload: payload
        });
    const $2368164c033e2a67$export$57398f8dd536d3 = 'state.flags.ISSUE_DISAPPEARS_FROM_DISPLAY_RANGE';
    const $2368164c033e2a67$export$57c6601b7de7174e = (payload)=>({
            type: $2368164c033e2a67$export$57398f8dd536d3,
            payload: payload
        });
    const $2368164c033e2a67$export$23962d17d290f2c0 = 'state.flags.RANK_MISMATCH_ISSUE_CREATED';
    const $2368164c033e2a67$export$f1f725fa6b0c8a54 = (payload)=>({
            type: $2368164c033e2a67$export$23962d17d290f2c0,
            payload: payload
        });
    const $2368164c033e2a67$export$9406ea723a962c47 = 'state.flags.UNABLE_TO_RANK_ISSUE';
    const $2368164c033e2a67$export$e3612e71b6b39da1 = (payload)=>({
            type: $2368164c033e2a67$export$9406ea723a962c47,
            payload: payload
        });
    const $2368164c033e2a67$export$88308e1b4abfd55e = 'state.flags.HIDDEN_DEPENDENCY_CREATED';
    const $2368164c033e2a67$export$a7f194f3b406f9e5 = ()=>({
            type: $2368164c033e2a67$export$88308e1b4abfd55e
        });
    const $2368164c033e2a67$export$6c8916f000f0ecf3 = 'state.flags.DEPENDENCIES_UNAVAILABLE';
    const $2368164c033e2a67$export$629f4726a19e166f = ()=>({
            type: $2368164c033e2a67$export$6c8916f000f0ecf3
        });
    const $2368164c033e2a67$export$bee605ca665bc47e = 'state.flags.DEPENDENCIES_PERMISSION';
    const $2368164c033e2a67$export$7ae2a3c0890ea73c = (payload)=>({
            type: $2368164c033e2a67$export$bee605ca665bc47e,
            payload: payload
        });
    const $2368164c033e2a67$export$d209d541a847828d = 'state.flags.UPDATE_ITEM_PERMISSION';
    const $2368164c033e2a67$export$a7eada1968affd28 = ()=>({
            type: $2368164c033e2a67$export$d209d541a847828d
        });
    const $2368164c033e2a67$export$31b38b0222b12e4a = 'state.flags.SPRINT_SCOPE_CHANGE';
    const $2368164c033e2a67$export$d580034b0a28e0db = (payload)=>({
            type: $2368164c033e2a67$export$31b38b0222b12e4a,
            payload: payload
        });
    const $2368164c033e2a67$export$d574f859de528225 = 'state.flags.INTERACTED_ITEMS_LIMIT_EXCEEDED';
    const $2368164c033e2a67$export$a7152d9c510f3783 = (payload)=>({
            type: $2368164c033e2a67$export$d574f859de528225,
            payload: payload
        });
    const $2368164c033e2a67$export$84666f883c5c79a2 = 'state.flags.DEPENDENCY_CYCLE_CREATION';
    const $2368164c033e2a67$export$b1275e1021a43355 = (payload)=>({
            type: $2368164c033e2a67$export$84666f883c5c79a2,
            payload: payload
        });
    const $2368164c033e2a67$export$b7d53719119ed01a = 'state.flags.DEPENDENCY_DUPLICATION';
    const $2368164c033e2a67$export$de85c6fa5ee537ca = (payload)=>({
            type: $2368164c033e2a67$export$b7d53719119ed01a,
            payload: payload
        });
});
parcelRegister("if2kE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5251ae39695b3ce5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $1wpPp;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $bTbH5;
    const $5251ae39695b3ce5$var$AggErrorFlag = ({ id: id, onDismissed: onDismissed, description: description, errorType: errorType })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({
                action: 'viewed',
                actionSubject: 'roadmapErrorFlag'
            }), 'viewed roadmapErrorFlag', {
                cause: 'AGG'
            });
        }, []);
        const onDismissedCallback = ()=>{
            onDismissed(id);
        };
        const getDescription = ()=>{
            if (errorType === (0, $66c67c0c2e148cb9$export$d2fa25fc0fdc86b8)) return formatMessage((0, (0, parcelRequire("bTbH5")).default).jqlValidationErrorDescription);
            return description !== undefined ? description : formatMessage((0, (0, parcelRequire("bTbH5")).default).description);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1wpPp")).default), {
            onDismissed: onDismissedCallback,
            id: id,
            title: formatMessage((0, (0, parcelRequire("bTbH5")).default).title),
            description: getDescription()
        });
    };
    $5251ae39695b3ce5$var$AggErrorFlag.defaultProps = {
        description: undefined,
        onDismissed: (0, ($parcel$interopDefault($8Rkzz)))
    };
    var $5251ae39695b3ce5$export$2e2bcd8739ae039 = $5251ae39695b3ce5$var$AggErrorFlag;
});
parcelRegister("1wpPp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2ebed3b5115fbfc5$export$2e2bcd8739ae039);
    var $3KRpp;
    var $2ebed3b5115fbfc5$export$2e2bcd8739ae039 = (0, (0, parcelRequire("3KRpp")).ErrorFlag);
});
parcelRegister("3KRpp", function(module, exports) {
    $parcel$export(module.exports, "CommonFlag", ()=>$ef767762d5402ccf$export$13d73238a031436b);
    $parcel$export(module.exports, "ErrorFlag", ()=>$ef767762d5402ccf$export$518ba8e0e60f145f);
    $parcel$export(module.exports, "ErrorAutoDismissFlag", ()=>$ef767762d5402ccf$export$3f75672bb90a4431);
    $parcel$export(module.exports, "InfoFlag", ()=>$ef767762d5402ccf$export$6a55b52e74c1e48e);
    $parcel$export(module.exports, "SuccessAutoDismissFlag", ()=>$ef767762d5402ccf$export$74a3c0748aa31355);
    $parcel$export(module.exports, "SuccessFlag", ()=>$ef767762d5402ccf$export$93bd4963a1d00fd5);
    $parcel$export(module.exports, "WarningFlag", ()=>$ef767762d5402ccf$export$23695d8281998f27);
    $parcel$export(module.exports, "FlagGroup", ()=>$ef767762d5402ccf$export$a2c3479950310d7d);
    var $5uXOq = parcelRequire("5uXOq");
    var $1eg3p;
    var $kxZPA;
    const $ef767762d5402ccf$var$ForPaintJiraCommonFlag = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("lKKug")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
    });
    const $ef767762d5402ccf$var$AfterPaintJiraCommonFlag = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("lKKug")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
    });
    const $ef767762d5402ccf$var$CommonFlagImpl = (props)=>__SPA__ ? (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$AfterPaintJiraCommonFlag, props) : (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$ForPaintJiraCommonFlag, props);
    const $ef767762d5402ccf$var$ForPaintFlagGroup = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("fhw5b")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
    });
    const $ef767762d5402ccf$var$AfterPaintFlagGroup = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("fhw5b")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
    });
    const $ef767762d5402ccf$var$FlagGroupImpl = (props)=>__SPA__ ? (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$AfterPaintFlagGroup, props) : (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$ForPaintFlagGroup, props);
    const $ef767762d5402ccf$export$13d73238a031436b = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, props));
    const $ef767762d5402ccf$export$518ba8e0e60f145f = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "error",
            ...props
        }));
    const $ef767762d5402ccf$export$3f75672bb90a4431 = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "error",
            isAutoDismiss: true,
            ...props
        }));
    const $ef767762d5402ccf$export$6a55b52e74c1e48e = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "info",
            ...props
        }));
    const $ef767762d5402ccf$export$74a3c0748aa31355 = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "success",
            isAutoDismiss: true,
            ...props
        }));
    const $ef767762d5402ccf$export$93bd4963a1d00fd5 = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "success",
            ...props
        }));
    const $ef767762d5402ccf$export$23695d8281998f27 = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "warning",
            ...props
        }));
    const $ef767762d5402ccf$export$a2c3479950310d7d = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$FlagGroupImpl, props));
});
parcelRegister("lKKug", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("4yB9l")
    ]).then(()=>parcelRequire('8ZHDV'));
});
parcelRegister("fhw5b", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("Fkef4").then(()=>parcelRequire('5pz6a'));
});
const $66c67c0c2e148cb9$export$d2fa25fc0fdc86b8 = 'JQL_VALIDATION_FAILED';
parcelRegister("bTbH5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bf8a9551f0745c74$export$2e2bcd8739ae039);
    var $7VHMR;
    var $bf8a9551f0745c74$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "roadmap.standard-roadmap.flags.agg-error.title",
            "defaultMessage": "Something went wrong"
        },
        description: {
            "id": "roadmap.standard-roadmap.flags.agg-error.description",
            "defaultMessage": "Please try again later."
        },
        jqlValidationErrorDescription: {
            "id": "roadmap.standard-roadmap.flags.agg-error.jql-validation-error-description",
            "defaultMessage": "One or more fields associated with your JQL query is no longer valid. Edit your query, or adjust your settings then try again."
        }
    });
});
parcelRegister("jA5AF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$70039054f3167522$export$2e2bcd8739ae039);
    var $bC2fB;
    var $hhYQB;
    var $ilGit;
    var $l8zxk;
    var $70039054f3167522$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((state)=>({
            isDependenciesVisible: (0, (0, parcelRequire("hhYQB")).isDependenciesVisible)(state)
        }), {
        setShowDependencies: ()=>(0, (0, parcelRequire("ilGit")).setDependenciesViewVisibility)(true)
    })((0, (0, parcelRequire("l8zxk")).default));
});
parcelRegister("hhYQB", function(module, exports) {
    $parcel$export(module.exports, "getFilteredAssignees", ()=>$27a7bc40d3deef86$export$ead4f8ed70fc9285);
    $parcel$export(module.exports, "getFilteredIssueTypes", ()=>$27a7bc40d3deef86$export$f704001d88f4e8d2);
    $parcel$export(module.exports, "getFilteredText", ()=>$27a7bc40d3deef86$export$480513943813b51b);
    $parcel$export(module.exports, "getFilteredLabels", ()=>$27a7bc40d3deef86$export$1f2bd8f7634d2082);
    $parcel$export(module.exports, "getFilteredVersions", ()=>$27a7bc40d3deef86$export$e1963b8a944f3139);
    $parcel$export(module.exports, "getFilteredComponents", ()=>$27a7bc40d3deef86$export$5f2c47e8484746b9);
    $parcel$export(module.exports, "getFilteredQuickFilters", ()=>$27a7bc40d3deef86$export$6bf1855d9df1b383);
    $parcel$export(module.exports, "getFilteredCustomFilters", ()=>$27a7bc40d3deef86$export$4a8b3b1494c67db);
    $parcel$export(module.exports, "getNumJQLFiltersApplied", ()=>$27a7bc40d3deef86$export$bf3bd4b2a79eafca);
    $parcel$export(module.exports, "getFilteredGoalIssueIds", ()=>$27a7bc40d3deef86$export$d91b97590e8928e6);
    $parcel$export(module.exports, "getIssuesFilter", ()=>$27a7bc40d3deef86$export$8402447ccdc9e452);
    $parcel$export(module.exports, "isFilterActive", ()=>$27a7bc40d3deef86$export$71fbaed622c39d0f);
    $parcel$export(module.exports, "getTimelineMode", ()=>$27a7bc40d3deef86$export$c08af494d7047ac9);
    $parcel$export(module.exports, "isDependenciesVisible", ()=>$27a7bc40d3deef86$export$e6456cc1326d0539);
    $parcel$export(module.exports, "isProgressVisible", ()=>$27a7bc40d3deef86$export$879546fde72c4046);
    $parcel$export(module.exports, "isWarningsVisible", ()=>$27a7bc40d3deef86$export$14c823a13dc9b222);
    $parcel$export(module.exports, "getLevelOneSetting", ()=>$27a7bc40d3deef86$export$e748452c2646d46a);
    $parcel$export(module.exports, "getChildIssueTypes", ()=>$27a7bc40d3deef86$export$7d15cfb1065b114f);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $iZN6h;
    var $cKS6s;
    var $4gYYI;
    var $6thbV;
    var $hFyhA;
    var $fWch8;
    var $5IiTZ;
    var $2VUTz;
    var $9hAGg;
    var $fayLA;
    var $3rLbe;
    var $6kR2l;
    const $27a7bc40d3deef86$export$db9f6287b4948b1d = (0, (0, parcelRequire("cKS6s")).createSelectorWithDefaultEqual)((0, (0, parcelRequire("fWch8")).getStatus), (statuses)=>statuses);
    const $27a7bc40d3deef86$export$ead4f8ed70fc9285 = (0, (0, parcelRequire("cKS6s")).createSelectorWithDefaultEqual)((0, (0, parcelRequire("fWch8")).getAssignee), (assignees)=>assignees);
    const $27a7bc40d3deef86$export$f704001d88f4e8d2 = (0, (0, parcelRequire("cKS6s")).createSelectorWithDefaultEqual)((0, (0, parcelRequire("fWch8")).getIssueType), (issueTypes)=>issueTypes);
    const $27a7bc40d3deef86$export$480513943813b51b = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("fWch8")).getQuery), (query)=>query.text ?? '');
    const $27a7bc40d3deef86$export$1f2bd8f7634d2082 = (0, (0, parcelRequire("cKS6s")).createSelectorWithDefaultEqual)((0, (0, parcelRequire("fWch8")).getLabels), (0, (0, parcelRequire("fayLA")).getLabelsWithUnassignedOption), (0, (0, parcelRequire("6kR2l")).createGetFilteredLabels));
    const $27a7bc40d3deef86$export$d95ca7dc26056ef4 = (0, (0, parcelRequire("cKS6s")).createSelectorWithDefaultEqual)((0, (0, parcelRequire("fWch8")).getIssueParents), (0, (0, parcelRequire("hFyhA")).getIssueParentIds), (0, (0, parcelRequire("6kR2l")).createGetFilteredIssueParents));
    const $27a7bc40d3deef86$export$e1963b8a944f3139 = (0, (0, parcelRequire("cKS6s")).createSelectorWithDefaultEqual)((0, (0, parcelRequire("fWch8")).getVersions), (0, (0, parcelRequire("3rLbe")).getUniqueVersions), (0, (0, parcelRequire("6kR2l")).createGetFilteredVersions));
    const $27a7bc40d3deef86$export$5f2c47e8484746b9 = (0, (0, parcelRequire("cKS6s")).createSelectorWithDefaultEqual)((0, (0, parcelRequire("fWch8")).getComponents), (0, (0, parcelRequire("9hAGg")).getUniqueComponents), (0, (0, parcelRequire("6kR2l")).createGetFilteredComponents));
    const $27a7bc40d3deef86$export$6bf1855d9df1b383 = (0, (0, parcelRequire("cKS6s")).createSelectorWithDefaultEqual)((0, (0, parcelRequire("fWch8")).getQuickFilters), (quickFilters)=>quickFilters);
    const $27a7bc40d3deef86$export$4a8b3b1494c67db = (0, (0, parcelRequire("cKS6s")).createSelectorWithDefaultEqual)((0, (0, parcelRequire("fWch8")).getCustomFilters), (customFilters)=>customFilters);
    const $27a7bc40d3deef86$export$bf3bd4b2a79eafca = (0, (0, parcelRequire("cKS6s")).createSelectorWithDefaultEqual)((0, (0, parcelRequire("fWch8")).getQuickFilters), (0, (0, parcelRequire("fWch8")).getCustomFilters), (quickFilters, customFilters)=>Math.max(quickFilters.length, customFilters.length));
    const $27a7bc40d3deef86$export$41f1c2d38e27d357 = (0, (0, parcelRequire("cKS6s")).createSelectorWithDefaultEqual)((0, (0, parcelRequire("fWch8")).getGoalAris), (0, (0, parcelRequire("6thbV")).getUniqueGoalIds), (0, (0, parcelRequire("6kR2l")).createGetFilteredGoals));
    const $27a7bc40d3deef86$export$d91b97590e8928e6 = (0, $dGvGJ.createSelector)($27a7bc40d3deef86$export$41f1c2d38e27d357, (0, (0, parcelRequire("6thbV")).getGoalsHash), (0, (0, parcelRequire("hFyhA")).getIssueChildrenHash), (0, (0, parcelRequire("6kR2l")).createGetFilteredGoalIssueIds));
    const $27a7bc40d3deef86$export$8402447ccdc9e452 = (0, $dGvGJ.createSelector)($27a7bc40d3deef86$export$db9f6287b4948b1d, $27a7bc40d3deef86$export$ead4f8ed70fc9285, $27a7bc40d3deef86$export$f704001d88f4e8d2, $27a7bc40d3deef86$export$480513943813b51b, $27a7bc40d3deef86$export$1f2bd8f7634d2082, $27a7bc40d3deef86$export$d95ca7dc26056ef4, $27a7bc40d3deef86$export$e1963b8a944f3139, $27a7bc40d3deef86$export$5f2c47e8484746b9, $27a7bc40d3deef86$export$6bf1855d9df1b383, $27a7bc40d3deef86$export$4a8b3b1494c67db, $27a7bc40d3deef86$export$41f1c2d38e27d357, (statuses, assignees, issueTypes, text, labels, issueParents, versions, components, quickFilters, customFilters, goals)=>({
            statuses: statuses,
            assignees: assignees,
            issueTypes: issueTypes,
            text: text,
            labels: labels,
            issueParents: issueParents,
            versions: versions,
            components: components,
            quickFilters: quickFilters,
            customFilters: customFilters,
            goals: goals
        }));
    const $27a7bc40d3deef86$export$71fbaed622c39d0f = (0, $dGvGJ.createSelector)($27a7bc40d3deef86$export$8402447ccdc9e452, (filters)=>Object.values(filters).some((value)=>{
            if (Array.isArray(value) || typeof value === 'string') return value.length > 0;
            return false;
        }));
    const $27a7bc40d3deef86$export$c08af494d7047ac9 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("fWch8")).getQuery), (0, (0, parcelRequire("5IiTZ")).getStoredTimelineFilter), (query, storedTimelineFilter)=>{
        switch(query.timeline){
            case 0, (0, parcelRequire("iZN6h")).WEEKS:
                return 0, (0, parcelRequire("iZN6h")).WEEKS;
            case 0, (0, parcelRequire("iZN6h")).MONTHS:
                return 0, (0, parcelRequire("iZN6h")).MONTHS;
            case 0, (0, parcelRequire("iZN6h")).QUARTERS:
                return 0, (0, parcelRequire("iZN6h")).QUARTERS;
            default:
                return storedTimelineFilter || (0, (0, parcelRequire("iZN6h")).MONTHS);
        }
    });
    const $27a7bc40d3deef86$var$isViewVisible = (isVisibleInQuery, isVisibleInStore)=>!isVisibleInQuery ? false : isVisibleInStore;
    const $27a7bc40d3deef86$export$e6456cc1326d0539 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("fWch8")).isDependenciesVisibleInQuery), (0, (0, parcelRequire("2VUTz")).isDependenciesVisibleInView), $27a7bc40d3deef86$var$isViewVisible);
    const $27a7bc40d3deef86$export$879546fde72c4046 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("fWch8")).isProgressVisibleInQuery), (0, (0, parcelRequire("2VUTz")).isProgressVisibleInView), $27a7bc40d3deef86$var$isViewVisible);
    const $27a7bc40d3deef86$export$14c823a13dc9b222 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("fWch8")).isWarningsVisibleInQuery), (0, (0, parcelRequire("2VUTz")).isWarningsVisibleInView), $27a7bc40d3deef86$var$isViewVisible);
    const $27a7bc40d3deef86$export$e748452c2646d46a = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("fWch8")).getEpicSettingInQuery), (0, (0, parcelRequire("2VUTz")).getLevelOneSettingInView), (0, (0, parcelRequire("6kR2l")).getLevelOneSettingPure));
    const $27a7bc40d3deef86$export$7d15cfb1065b114f = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("4gYYI")).getFullIssueTypeHash), (0, (0, parcelRequire("4gYYI")).getEpicIssueTypeIds), (0, (0, parcelRequire("6kR2l")).getChildIssueTypesPure));
});
parcelRegister("iZN6h", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_DEPTH", ()=>$1080ad231b30fb16$export$7f882bb969de14a3);
    $parcel$export(module.exports, "DEFAULT_LEVEL", ()=>$1080ad231b30fb16$export$480df663967f228c);
    $parcel$export(module.exports, "RESIZE_DEBOUNCE_MS", ()=>$1080ad231b30fb16$export$747901c4619ea19c);
    $parcel$export(module.exports, "BASE_LEVEL", ()=>$1080ad231b30fb16$export$d5993e01b9439be4);
    $parcel$export(module.exports, "BASE_HEADER_HEIGHT", ()=>$1080ad231b30fb16$export$bf0adf7b400249e1);
    $parcel$export(module.exports, "HEADER_CONTENT_HEIGHT", ()=>$1080ad231b30fb16$export$46c78f5f070f677a);
    $parcel$export(module.exports, "DEFAULT_SUBHEADER_HEIGHT", ()=>$1080ad231b30fb16$export$29ae8fa7fd1c9a2f);
    $parcel$export(module.exports, "DEFAULT_ITEM_HEIGHT", ()=>$1080ad231b30fb16$export$f898a7479a35465b);
    $parcel$export(module.exports, "BASE_LEVEL_ITEM_HEIGHT", ()=>$1080ad231b30fb16$export$c4ca1a8adb6a9f07);
    $parcel$export(module.exports, "MINIMUM_LIST_WIDTH", ()=>$1080ad231b30fb16$export$6bb070ef26ec48d9);
    $parcel$export(module.exports, "DEFAULT_LIST_WIDTH", ()=>$1080ad231b30fb16$export$58590494eb7f9f92);
    $parcel$export(module.exports, "DEFAULT_HEADER_ROW_ID", ()=>$1080ad231b30fb16$export$b24bdd4190312b9);
    $parcel$export(module.exports, "UP", ()=>$1080ad231b30fb16$export$b29f845fa4b57508);
    $parcel$export(module.exports, "DOWN", ()=>$1080ad231b30fb16$export$c7c029a231f98d34);
    $parcel$export(module.exports, "ROW_DRAG_AND_DROP_ID", ()=>$1080ad231b30fb16$export$ac3c20c079db2388);
    $parcel$export(module.exports, "LIST_DRAG_AND_DROP", ()=>$1080ad231b30fb16$export$3c4f97ccd236019);
    $parcel$export(module.exports, "CHILD_LIST_DRAG_AND_DROP", ()=>$1080ad231b30fb16$export$d3793ebc963c3515);
    $parcel$export(module.exports, "LIST_RESIZE_DRAG_AND_DROP", ()=>$1080ad231b30fb16$export$ea4843d184267eb1);
    $parcel$export(module.exports, "DELAY_EXPAND_TIME", ()=>$1080ad231b30fb16$export$d165800dfbec11d6);
    $parcel$export(module.exports, "BEFORE", ()=>$1080ad231b30fb16$export$4cff6e48b6cc73b5);
    $parcel$export(module.exports, "INSIDE", ()=>$1080ad231b30fb16$export$48ea0cac79c83ca8);
    $parcel$export(module.exports, "LAST", ()=>$1080ad231b30fb16$export$5514f5adc70fa605);
    $parcel$export(module.exports, "TIMELINE_ID", ()=>$1080ad231b30fb16$export$80a4040613c38228);
    $parcel$export(module.exports, "WEEKS", ()=>$1080ad231b30fb16$export$ae0be2880fd1f23e);
    $parcel$export(module.exports, "MONTHS", ()=>$1080ad231b30fb16$export$f9a766aa2475e8ba);
    $parcel$export(module.exports, "QUARTERS", ()=>$1080ad231b30fb16$export$6bd120b531154c2a);
    $parcel$export(module.exports, "zIndex", ()=>$1080ad231b30fb16$export$56446adcecbeec34);
    $parcel$export(module.exports, "DEFAULT_CREATE_ID", ()=>$1080ad231b30fb16$export$420141f5c0e55c3e);
    $parcel$export(module.exports, "ITEM_TYPE", ()=>$1080ad231b30fb16$export$e0a522cf395aec9b);
    $parcel$export(module.exports, "CREATE_ITEM_TYPE", ()=>$1080ad231b30fb16$export$69cd3b48cdf4b6f0);
    $parcel$export(module.exports, "SCROLLED", ()=>$1080ad231b30fb16$export$9402ce0d1e070b14);
    $parcel$export(module.exports, "LIST_COLUMN_COORDINATE", ()=>$1080ad231b30fb16$export$4f0d26bf73633d25);
    $parcel$export(module.exports, "CHART_COLUMN_COORDINATE", ()=>$1080ad231b30fb16$export$3a13d2b8bb5c5942);
    $parcel$export(module.exports, "listItemMenu", ()=>$1080ad231b30fb16$export$ee28d791bd8e9db2);
    $parcel$export(module.exports, "DEFAULT_MENU_MAX_HEIGHT", ()=>$1080ad231b30fb16$export$1412163b7495b138);
    var $4R6GH;
    var $dCm1o;
    const $1080ad231b30fb16$export$7f882bb969de14a3 = 0;
    const $1080ad231b30fb16$export$480df663967f228c = 1;
    const $1080ad231b30fb16$export$747901c4619ea19c = 250;
    const $1080ad231b30fb16$export$d5993e01b9439be4 = 0;
    const $1080ad231b30fb16$export$6c5e715ac831956e = 1;
    const $1080ad231b30fb16$export$bf0adf7b400249e1 = 48;
    const $1080ad231b30fb16$export$46c78f5f070f677a = 16;
    const $1080ad231b30fb16$export$29ae8fa7fd1c9a2f = 36;
    const $1080ad231b30fb16$export$f898a7479a35465b = 40;
    const $1080ad231b30fb16$export$c4ca1a8adb6a9f07 = ()=>(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_2') ? 40 : 32;
    const $1080ad231b30fb16$export$6bb070ef26ec48d9 = ()=>(0, (0, parcelRequire("4R6GH")).fg)('project_timeline_multi-select_and_checkboxes') ? 384 : 320;
    const $1080ad231b30fb16$export$58590494eb7f9f92 = ()=>(0, (0, parcelRequire("4R6GH")).fg)('project_timeline_multi-select_and_checkboxes') ? 424 : 360;
    const $1080ad231b30fb16$export$b24bdd4190312b9 = 'DEFAULT_HEADER_ROW';
    const $1080ad231b30fb16$export$b29f845fa4b57508 = 'UP';
    const $1080ad231b30fb16$export$c7c029a231f98d34 = 'DOWN';
    const $1080ad231b30fb16$export$ac3c20c079db2388 = 'row-dnd-type-id';
    const $1080ad231b30fb16$export$3c4f97ccd236019 = 'listDnd';
    const $1080ad231b30fb16$export$d3793ebc963c3515 = 'childListDnd';
    const $1080ad231b30fb16$export$ea4843d184267eb1 = 'listResizeDnd';
    const $1080ad231b30fb16$export$d165800dfbec11d6 = 500;
    const $1080ad231b30fb16$export$4cff6e48b6cc73b5 = 'BEFORE';
    const $1080ad231b30fb16$export$48ea0cac79c83ca8 = 'INSIDE';
    const $1080ad231b30fb16$export$5514f5adc70fa605 = 'LAST';
    const $1080ad231b30fb16$export$80a4040613c38228 = 'sr-timeline';
    const $1080ad231b30fb16$export$ae0be2880fd1f23e = 'WEEKS';
    const $1080ad231b30fb16$export$f9a766aa2475e8ba = 'MONTHS';
    const $1080ad231b30fb16$export$6bd120b531154c2a = 'QUARTERS';
    const $1080ad231b30fb16$export$1041e95163fc373b = 20;
    const $1080ad231b30fb16$export$6d29db963a7e29b9 = $1080ad231b30fb16$export$1041e95163fc373b / 2;
    const $1080ad231b30fb16$var$CHART = 1;
    const $1080ad231b30fb16$var$TODAY_MARKER = 6;
    const $1080ad231b30fb16$var$HEADER = 7;
    const $1080ad231b30fb16$var$LIST_COVER = 8;
    const $1080ad231b30fb16$var$LIST = 9;
    const $1080ad231b30fb16$var$LIST_CREATE_ITEM = 10;
    const $1080ad231b30fb16$var$INLINE_INDICATOR = 11;
    const $1080ad231b30fb16$var$SCROLLBAR = 11;
    const $1080ad231b30fb16$var$ROW_HEADER = 12;
    const $1080ad231b30fb16$var$BORDER = 12;
    const $1080ad231b30fb16$var$LIST_RESIZER = 13;
    const $1080ad231b30fb16$var$DRAGGABLE = 13;
    const $1080ad231b30fb16$var$PORTAL = 13;
    const $1080ad231b30fb16$var$HIGHEST = 14;
    const $1080ad231b30fb16$export$56446adcecbeec34 = {
        CHART: $1080ad231b30fb16$var$CHART,
        BORDER: $1080ad231b30fb16$var$BORDER,
        TODAY_MARKER: $1080ad231b30fb16$var$TODAY_MARKER,
        LIST_COVER: $1080ad231b30fb16$var$LIST_COVER,
        HEADER: $1080ad231b30fb16$var$HEADER,
        LIST: $1080ad231b30fb16$var$LIST,
        LIST_CREATE_ITEM: $1080ad231b30fb16$var$LIST_CREATE_ITEM,
        INLINE_INDICATOR: $1080ad231b30fb16$var$INLINE_INDICATOR,
        SCROLLBAR: $1080ad231b30fb16$var$SCROLLBAR,
        ROW_HEADER: $1080ad231b30fb16$var$ROW_HEADER,
        LIST_RESIZER: $1080ad231b30fb16$var$LIST_RESIZER,
        DRAGGABLE: $1080ad231b30fb16$var$DRAGGABLE,
        PORTAL: $1080ad231b30fb16$var$PORTAL,
        HIGHEST: $1080ad231b30fb16$var$HIGHEST
    };
    const $1080ad231b30fb16$export$420141f5c0e55c3e = 'create-default';
    const $1080ad231b30fb16$export$e0a522cf395aec9b = 'ITEM_TYPE';
    const $1080ad231b30fb16$export$69cd3b48cdf4b6f0 = 'CREATE_ITEM_TYPE';
    const $1080ad231b30fb16$export$9402ce0d1e070b14 = 'scrolled';
    const $1080ad231b30fb16$export$4f0d26bf73633d25 = 0;
    const $1080ad231b30fb16$export$3a13d2b8bb5c5942 = 1;
    const $1080ad231b30fb16$var$ITEMS_SECTION = 'itemsSection';
    const $1080ad231b30fb16$var$CREATE_ITEM = 'createItem';
    const $1080ad231b30fb16$var$MOVE_ITEM = 'moveItem';
    const $1080ad231b30fb16$var$CREATE_CHILD_ITEM = 'createChildItem';
    const $1080ad231b30fb16$var$CREATE_ITEM_ABOVE = 'createItemAbove';
    const $1080ad231b30fb16$var$CREATE_ITEM_BELOW = 'createItemBelow';
    const $1080ad231b30fb16$var$MOVE_ITEM_UP = 'moveItemUp';
    const $1080ad231b30fb16$var$MOVE_ITEM_DOWN = 'moveItemDown';
    const $1080ad231b30fb16$var$MOVE_ITEM_TO_TOP = 'moveItemToTop';
    const $1080ad231b30fb16$var$MOVE_ITEM_TO_BOTTOM = 'moveItemToBottom';
    const $1080ad231b30fb16$var$SELECTED_ITEM_COUNTER = 'selectedItemCounter';
    const $1080ad231b30fb16$export$ee28d791bd8e9db2 = {
        SELECTED_ITEM_COUNTER: $1080ad231b30fb16$var$SELECTED_ITEM_COUNTER,
        ITEMS_SECTION: $1080ad231b30fb16$var$ITEMS_SECTION,
        CREATE_ITEM: $1080ad231b30fb16$var$CREATE_ITEM,
        MOVE_ITEM: $1080ad231b30fb16$var$MOVE_ITEM,
        CREATE_CHILD_ITEM: $1080ad231b30fb16$var$CREATE_CHILD_ITEM,
        CREATE_ITEM_ABOVE: $1080ad231b30fb16$var$CREATE_ITEM_ABOVE,
        CREATE_ITEM_BELOW: $1080ad231b30fb16$var$CREATE_ITEM_BELOW,
        MOVE_ITEM_UP: $1080ad231b30fb16$var$MOVE_ITEM_UP,
        MOVE_ITEM_DOWN: $1080ad231b30fb16$var$MOVE_ITEM_DOWN,
        MOVE_ITEM_TO_TOP: $1080ad231b30fb16$var$MOVE_ITEM_TO_TOP,
        MOVE_ITEM_TO_BOTTOM: $1080ad231b30fb16$var$MOVE_ITEM_TO_BOTTOM
    };
    const $1080ad231b30fb16$export$1412163b7495b138 = 480;
});
parcelRegister("cKS6s", function(module, exports) {
    $parcel$export(module.exports, "createSelectorWithDefaultEqual", ()=>$e76d34e5560ad12d$export$871506ce07a83fad);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $ajpes = parcelRequire("ajpes");
    const $e76d34e5560ad12d$export$871506ce07a83fad = (0, $dGvGJ.createSelectorCreator)((0, $dGvGJ.defaultMemoize), (0, ($parcel$interopDefault($ajpes))));
});
parcelRegister("4gYYI", function(module, exports) {
    $parcel$export(module.exports, "getProjectId", ()=>$af3333738b00c6c0$export$89040d072f281f85);
    $parcel$export(module.exports, "getStartDateCustomFieldId", ()=>$af3333738b00c6c0$export$72a0c0eaa38c43af);
    $parcel$export(module.exports, "getEpicIssueTypeIds", ()=>$af3333738b00c6c0$export$2757d772c10130c8);
    $parcel$export(module.exports, "getColorCustomFieldId", ()=>$af3333738b00c6c0$export$46544f5f5c1828e1);
    $parcel$export(module.exports, "getEpicLinkCustomFieldId", ()=>$af3333738b00c6c0$export$9b4fcf5b8538c861);
    $parcel$export(module.exports, "getEpicNameCustomFieldId", ()=>$af3333738b00c6c0$export$8af40cc1df82ba43);
    $parcel$export(module.exports, "getSprintCustomFieldId", ()=>$af3333738b00c6c0$export$c04a8f7b39c47d17);
    $parcel$export(module.exports, "getFieldsNamesHash", ()=>$af3333738b00c6c0$export$905fbc05dc222193);
    $parcel$export(module.exports, "hasCreateIssuesPermission", ()=>$af3333738b00c6c0$export$bc5899cabe5884a4);
    $parcel$export(module.exports, "hasEditIssuesPermission", ()=>$af3333738b00c6c0$export$f26e62ade6542d00);
    $parcel$export(module.exports, "hasScheduleIssuesPermission", ()=>$af3333738b00c6c0$export$96eae7feeb05906d);
    $parcel$export(module.exports, "hasAdministerProjectPermission", ()=>$af3333738b00c6c0$export$fc2b3fef6cb69ee3);
    $parcel$export(module.exports, "rankIssuesSupported", ()=>$af3333738b00c6c0$export$8bb7a2124eb8c9e5);
    $parcel$export(module.exports, "getToday", ()=>$af3333738b00c6c0$export$883228a582a7567d);
    $parcel$export(module.exports, "areDependenciesSupported", ()=>$af3333738b00c6c0$export$6cb87c93e2168baa);
    $parcel$export(module.exports, "getInwardDependencyDescription", ()=>$af3333738b00c6c0$export$fc5e983135217133);
    $parcel$export(module.exports, "getOutwardDependencyDescription", ()=>$af3333738b00c6c0$export$12df4b73c34b43df);
    $parcel$export(module.exports, "getFullIssueTypeHash", ()=>$af3333738b00c6c0$export$960b0734990a1dd4);
    $parcel$export(module.exports, "getIssueType", ()=>$af3333738b00c6c0$export$ed2455632bf977ef);
    $parcel$export(module.exports, "getProjectKey", ()=>$af3333738b00c6c0$export$667f2a0f99c75faa);
    $parcel$export(module.exports, "getProjectName", ()=>$af3333738b00c6c0$export$2cd058184eb75757);
    $parcel$export(module.exports, "getProjectDefaultItemTypeId", ()=>$af3333738b00c6c0$export$6dfd97337d797ebe);
    $parcel$export(module.exports, "getRequiredFieldsByIssueTypeId", ()=>$af3333738b00c6c0$export$a04cc75c31570bae);
    $parcel$export(module.exports, "hasRequiredFields", ()=>$af3333738b00c6c0$export$9f3eb5b3e6860c0);
    $parcel$export(module.exports, "getBoardJql", ()=>$af3333738b00c6c0$export$ba7a4ea5054ecd02);
    $parcel$export(module.exports, "getIsUserBoardAdmin", ()=>$af3333738b00c6c0$export$77922deb356fe9ac);
    $parcel$export(module.exports, "getActiveAndFutureSprints", ()=>$af3333738b00c6c0$export$531b49b68eed3b23);
    $parcel$export(module.exports, "getSprints", ()=>$af3333738b00c6c0$export$1b132ed8629e9cb0);
    $parcel$export(module.exports, "getFullVersionHash", ()=>$af3333738b00c6c0$export$28a38fc944590448);
    $parcel$export(module.exports, "getFullComponentHash", ()=>$af3333738b00c6c0$export$254cbc79cefe4a73);
    $parcel$export(module.exports, "getIsReleasesFeatureEnabled", ()=>$af3333738b00c6c0$export$486ac4364a6213c9);
    $parcel$export(module.exports, "getChildIssuePlanningMode", ()=>$af3333738b00c6c0$export$97f5859d9b9ee574);
    $parcel$export(module.exports, "getIsSprintsFeatureEnabled", ()=>$af3333738b00c6c0$export$236c77227e5ade46);
    $parcel$export(module.exports, "getIsSprintsPlanningEnabled", ()=>$af3333738b00c6c0$export$ef0a9ade329ddbde);
    $parcel$export(module.exports, "getIsChildIssuePlanningEnabled", ()=>$af3333738b00c6c0$export$1e1cd096ccca9b98);
    $parcel$export(module.exports, "hasActiveOrFutureSprint", ()=>$af3333738b00c6c0$export$deba3717b0119a76);
    $parcel$export(module.exports, "getLevelOneName", ()=>$af3333738b00c6c0$export$f361eea8c49edc41);
    $parcel$export(module.exports, "getFullDerivedFields", ()=>$af3333738b00c6c0$export$28b082b8254a5fc3);
    $parcel$export(module.exports, "getIsGoalsFeatureEnabled", ()=>$af3333738b00c6c0$export$d38f904d50b0a8af);
    $parcel$export(module.exports, "getCanInviteOthersToProject", ()=>$af3333738b00c6c0$export$5124aa00ca92f2c0);
    var $dGvGJ = parcelRequire("dGvGJ");
    const $af3333738b00c6c0$var$getSingleProjectConfiguration = (state)=>state.configuration.projectConfiguration;
    const $af3333738b00c6c0$export$89040d072f281f85 = (0, $dGvGJ.createSelector)($af3333738b00c6c0$var$getSingleProjectConfiguration, (projectConfig)=>projectConfig.id);
    const $af3333738b00c6c0$var$getProjectConfiguration = (0, $dGvGJ.createSelector)($af3333738b00c6c0$var$getSingleProjectConfiguration, (projectConfig)=>projectConfig);
    const $af3333738b00c6c0$export$72a0c0eaa38c43af = (state)=>state.configuration.startDateCustomFieldId;
    const $af3333738b00c6c0$export$2757d772c10130c8 = (0, $dGvGJ.createSelector)($af3333738b00c6c0$var$getProjectConfiguration, (projectConfiguration)=>projectConfiguration.epicIssueTypeIds);
    const $af3333738b00c6c0$export$46544f5f5c1828e1 = (state)=>state.configuration.colorCustomFieldId;
    const $af3333738b00c6c0$export$9b4fcf5b8538c861 = (state)=>state.configuration.epicLinkCustomFieldId;
    const $af3333738b00c6c0$export$8af40cc1df82ba43 = (state)=>state.configuration.epicNameCustomFieldId;
    const $af3333738b00c6c0$export$c04a8f7b39c47d17 = (state)=>state.configuration.sprintCustomFieldId;
    const $af3333738b00c6c0$export$bee351d0af1cb8ad = (state)=>state.configuration.boardConfiguration;
    const $af3333738b00c6c0$export$905fbc05dc222193 = (state)=>state.configuration.fields.reduce((acc, field)=>{
            acc[field.id] = field.name;
            return acc;
        }, {});
    const $af3333738b00c6c0$export$bc5899cabe5884a4 = (0, $dGvGJ.createSelector)($af3333738b00c6c0$var$getProjectConfiguration, (projectConfiguration)=>projectConfiguration.permissions.canCreateIssues);
    const $af3333738b00c6c0$export$f26e62ade6542d00 = (0, $dGvGJ.createSelector)($af3333738b00c6c0$var$getProjectConfiguration, (projectConfiguration)=>projectConfiguration.permissions.canEditIssues);
    const $af3333738b00c6c0$export$96eae7feeb05906d = (0, $dGvGJ.createSelector)($af3333738b00c6c0$var$getProjectConfiguration, (projectConfiguration)=>projectConfiguration.permissions.canScheduleIssues);
    const $af3333738b00c6c0$export$fc2b3fef6cb69ee3 = (0, $dGvGJ.createSelector)($af3333738b00c6c0$var$getProjectConfiguration, (projectConfiguration)=>projectConfiguration.permissions.canAdministerProjects);
    const $af3333738b00c6c0$export$8bb7a2124eb8c9e5 = (state)=>state.configuration.rankIssuesSupported;
    const $af3333738b00c6c0$export$883228a582a7567d = (state)=>state.configuration.today;
    const $af3333738b00c6c0$export$6cb87c93e2168baa = (state)=>state.configuration.dependenciesSupported;
    const $af3333738b00c6c0$export$ac75fa8de98d4194 = (state)=>state.configuration;
    const $af3333738b00c6c0$export$fc5e983135217133 = (state)=>state.configuration.inwardDependencyDescription;
    const $af3333738b00c6c0$export$12df4b73c34b43df = (state)=>state.configuration.outwardDependencyDescription;
    const $af3333738b00c6c0$export$960b0734990a1dd4 = (0, $dGvGJ.createSelector)($af3333738b00c6c0$var$getProjectConfiguration, (projectConfiguration)=>projectConfiguration.issueTypes.hash);
    const $af3333738b00c6c0$export$ed2455632bf977ef = (state, issueTypeId)=>$af3333738b00c6c0$export$960b0734990a1dd4(state)[issueTypeId];
    const $af3333738b00c6c0$export$667f2a0f99c75faa = (0, $dGvGJ.createSelector)($af3333738b00c6c0$var$getProjectConfiguration, (projectConfiguration)=>projectConfiguration.key);
    const $af3333738b00c6c0$export$2cd058184eb75757 = (0, $dGvGJ.createSelector)($af3333738b00c6c0$var$getProjectConfiguration, (projectConfiguration)=>projectConfiguration.name);
    const $af3333738b00c6c0$export$6dfd97337d797ebe = (0, $dGvGJ.createSelector)($af3333738b00c6c0$var$getProjectConfiguration, (projectConfiguration)=>projectConfiguration.defaultItemTypeId);
    const $af3333738b00c6c0$export$71a2c3ba1c6ae580 = (0, $dGvGJ.createSelector)($af3333738b00c6c0$var$getProjectConfiguration, (projectConfiguration)=>projectConfiguration.requiredFields);
    const $af3333738b00c6c0$export$a04cc75c31570bae = (state, issueTypeId)=>$af3333738b00c6c0$export$71a2c3ba1c6ae580(state)[issueTypeId];
    const $af3333738b00c6c0$export$9f3eb5b3e6860c0 = (0, $dGvGJ.createSelector)($af3333738b00c6c0$export$71a2c3ba1c6ae580, (requiredFieldsHash)=>Object.keys(requiredFieldsHash).some((itemTypeId)=>requiredFieldsHash[itemTypeId].length > 0));
    const $af3333738b00c6c0$export$ba7a4ea5054ecd02 = (state)=>state.configuration.boardConfiguration.jql;
    const $af3333738b00c6c0$export$77922deb356fe9ac = (0, $dGvGJ.createSelector)($af3333738b00c6c0$export$bee351d0af1cb8ad, (boardConfiguration)=>boardConfiguration.isUserBoardAdmin);
    const $af3333738b00c6c0$export$9328442a7d4e1089 = (0, $dGvGJ.createSelector)($af3333738b00c6c0$export$bee351d0af1cb8ad, (boardConfiguration)=>boardConfiguration.sprints.hash);
    const $af3333738b00c6c0$var$EMPTY_ARRAY = [];
    const $af3333738b00c6c0$export$531b49b68eed3b23 = (0, $dGvGJ.createSelector)($af3333738b00c6c0$export$bee351d0af1cb8ad, (boardConfiguration)=>{
        const { sequence: sequence } = boardConfiguration.sprints;
        if (sequence !== undefined) {
            const sprintsHash = boardConfiguration.sprints.hash;
            const sprintsSequence = boardConfiguration.sprints.sequence;
            return sprintsSequence.filter((sprintId)=>sprintsHash[sprintId].state !== (0, $575de6c25475b26c$export$19c4f83398a8dbce)).map((sprintId)=>sprintsHash[sprintId]);
        }
        return $af3333738b00c6c0$var$EMPTY_ARRAY;
    });
    const $af3333738b00c6c0$export$1b132ed8629e9cb0 = (0, $dGvGJ.createSelector)($af3333738b00c6c0$export$9328442a7d4e1089, (sprintsHash)=>Object.keys(sprintsHash).map((sprintId)=>sprintsHash[sprintId]));
    const $af3333738b00c6c0$export$28a38fc944590448 = (0, $dGvGJ.createSelector)($af3333738b00c6c0$var$getProjectConfiguration, (projectConfiguration)=>projectConfiguration.versions.hash);
    const $af3333738b00c6c0$export$c506eb22e615ba4a = (state, versionId)=>$af3333738b00c6c0$export$28a38fc944590448(state)[versionId];
    const $af3333738b00c6c0$export$254cbc79cefe4a73 = (0, $dGvGJ.createSelector)($af3333738b00c6c0$var$getProjectConfiguration, (projectConfiguration)=>projectConfiguration.components.hash);
    const $af3333738b00c6c0$export$486ac4364a6213c9 = (0, $dGvGJ.createSelector)($af3333738b00c6c0$var$getProjectConfiguration, (projectConfiguration)=>Boolean(projectConfiguration.isReleasesFeatureEnabled));
    const $af3333738b00c6c0$export$21a8719ce41a1de2 = (state, componentId)=>$af3333738b00c6c0$export$254cbc79cefe4a73(state)[componentId];
    const $af3333738b00c6c0$export$97f5859d9b9ee574 = (0, $dGvGJ.createSelector)($af3333738b00c6c0$export$bee351d0af1cb8ad, (boardConfiguration)=>boardConfiguration.childIssuePlanningMode);
    const $af3333738b00c6c0$export$236c77227e5ade46 = (0, $dGvGJ.createSelector)($af3333738b00c6c0$export$bee351d0af1cb8ad, (boardConfiguration)=>boardConfiguration.isSprintsFeatureEnabled);
    const $af3333738b00c6c0$export$ef0a9ade329ddbde = (0, $dGvGJ.createSelector)($af3333738b00c6c0$export$236c77227e5ade46, $af3333738b00c6c0$export$97f5859d9b9ee574, (isSprintFeatureEnabled, mode)=>isSprintFeatureEnabled && mode === (0, $5c67f944abd2f8af$export$a316570a0dbfd2b0));
    const $af3333738b00c6c0$export$1e1cd096ccca9b98 = (0, $dGvGJ.createSelector)($af3333738b00c6c0$export$bee351d0af1cb8ad, (boardConfiguration)=>boardConfiguration.isChildIssuePlanningEnabled);
    const $af3333738b00c6c0$export$deba3717b0119a76 = (0, $dGvGJ.createSelector)($af3333738b00c6c0$export$1b132ed8629e9cb0, (sprints)=>sprints.some((sprint)=>sprint.state === (0, $575de6c25475b26c$export$2b35adb71b3f6143) || sprint.state === (0, $575de6c25475b26c$export$47b7b82714c61a7c)));
    const $af3333738b00c6c0$export$32752434cc32c671 = (state)=>state.configuration.hierarchyConfiguration;
    const $af3333738b00c6c0$export$f361eea8c49edc41 = (0, $dGvGJ.createSelector)($af3333738b00c6c0$export$32752434cc32c671, (hierarchyConfiguration)=>hierarchyConfiguration.levelOneName);
    const $af3333738b00c6c0$export$28b082b8254a5fc3 = (0, $dGvGJ.createSelector)($af3333738b00c6c0$export$ac75fa8de98d4194, (configuration)=>configuration.deriveFields ?? {});
    const $af3333738b00c6c0$export$d38f904d50b0a8af = (0, $dGvGJ.createSelector)($af3333738b00c6c0$var$getProjectConfiguration, (projectConfiguration)=>projectConfiguration.isGoalsFeatureEnabled ?? false);
    const $af3333738b00c6c0$export$5124aa00ca92f2c0 = (0, $dGvGJ.createSelector)($af3333738b00c6c0$export$ac75fa8de98d4194, (configuration)=>configuration.canInviteOthersToProject);
});
const $5c67f944abd2f8af$export$501a7fac1df67a49 = 'DATE';
const $5c67f944abd2f8af$export$a316570a0dbfd2b0 = 'SPRINT';
const $5c67f944abd2f8af$export$8cd212c10b4124d2 = 'DISABLED';
const $575de6c25475b26c$export$19c4f83398a8dbce = 'CLOSED';
const $575de6c25475b26c$export$2b35adb71b3f6143 = 'ACTIVE';
const $575de6c25475b26c$export$47b7b82714c61a7c = 'FUTURE';
parcelRegister("6thbV", function(module, exports) {
    $parcel$export(module.exports, "getIsGoalsLoaded", ()=>$2d71fae7778d4d9b$export$e298bff40a30190e);
    $parcel$export(module.exports, "getGoalsHash", ()=>$2d71fae7778d4d9b$export$697e9cd4661d73ca);
    $parcel$export(module.exports, "getGoals", ()=>$2d71fae7778d4d9b$export$da2944c52ff0de62);
    $parcel$export(module.exports, "getGoalsByKeyHash", ()=>$2d71fae7778d4d9b$export$e5a3a472ce119e30);
    $parcel$export(module.exports, "getUniqueGoalIds", ()=>$2d71fae7778d4d9b$export$80b5fae50e4561f9);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $4Xk2W = parcelRequire("4Xk2W");
    const $2d71fae7778d4d9b$export$e298bff40a30190e = (state)=>state.entities.goals.isLoaded;
    const $2d71fae7778d4d9b$export$697e9cd4661d73ca = (state)=>state.entities.goals.hash;
    const $2d71fae7778d4d9b$export$da2944c52ff0de62 = (0, $dGvGJ.createSelector)($2d71fae7778d4d9b$export$697e9cd4661d73ca, (goalHash)=>Object.values(goalHash).map(({ goal: goal })=>goal));
    const $2d71fae7778d4d9b$export$e5a3a472ce119e30 = (0, $dGvGJ.createSelector)($2d71fae7778d4d9b$export$697e9cd4661d73ca, (goals)=>(0, ($parcel$interopDefault($4Xk2W)))(Object.values(goals), (roadmapGoal)=>roadmapGoal.goal?.key));
    const $2d71fae7778d4d9b$export$80b5fae50e4561f9 = (0, $dGvGJ.createSelector)($2d71fae7778d4d9b$export$697e9cd4661d73ca, (goalHash)=>Object.keys(goalHash));
});
parcelRegister("4Xk2W", function(module, exports) {
    var $1m3dq = parcelRequire("1m3dq");
    var $4CZTG = parcelRequire("4CZTG");
    var $39bc38f0156cacc0$var$keyBy = $4CZTG(function(result, value, key) {
        $1m3dq(result, key, value);
    });
    module.exports = $39bc38f0156cacc0$var$keyBy;
});
parcelRegister("hFyhA", function(module, exports) {
    $parcel$export(module.exports, "getFullIssueHash", ()=>$b203414430cd64ca$export$509a628015f94404);
    $parcel$export(module.exports, "getIssue", ()=>$b203414430cd64ca$export$34403cb88b30d33b);
    $parcel$export(module.exports, "isIssueExists", ()=>$b203414430cd64ca$export$a987926fdc8259e3);
    $parcel$export(module.exports, "getIssueIds", ()=>$b203414430cd64ca$export$370b31b0927c0664);
    $parcel$export(module.exports, "getIssueKeyHash", ()=>$b203414430cd64ca$export$709dd7a2719b4d3c);
    $parcel$export(module.exports, "getIssueSummaryHash", ()=>$b203414430cd64ca$export$45178bf1f6b30a05);
    $parcel$export(module.exports, "getIssueSummary", ()=>$b203414430cd64ca$export$7bead7bb2ab962ba);
    $parcel$export(module.exports, "getIssueLabelsHash", ()=>$b203414430cd64ca$export$89a09562712dfef3);
    $parcel$export(module.exports, "getIssueVersionIdsHash", ()=>$b203414430cd64ca$export$8245af4324992ff2);
    $parcel$export(module.exports, "getIssueComponentIdsHash", ()=>$b203414430cd64ca$export$5e800c163de4eaa7);
    $parcel$export(module.exports, "getIssueSprintIdsHash", ()=>$b203414430cd64ca$export$a4ba5eda4ed95a38);
    $parcel$export(module.exports, "getIssueStartDateHash", ()=>$b203414430cd64ca$export$e70cd0960ca3186b);
    $parcel$export(module.exports, "getIssueStartDate", ()=>$b203414430cd64ca$export$a8ae12d1f205826a);
    $parcel$export(module.exports, "getIssueDueDateHash", ()=>$b203414430cd64ca$export$50e1c24a80dbb314);
    $parcel$export(module.exports, "getIssueDueDate", ()=>$b203414430cd64ca$export$f8ab4a7848083941);
    $parcel$export(module.exports, "getIssueStatusHash", ()=>$b203414430cd64ca$export$b01abdaac5dcf309);
    $parcel$export(module.exports, "getIssueStatusCategoryIdHash", ()=>$b203414430cd64ca$export$adccc555500c3bee);
    $parcel$export(module.exports, "getIssueColorHash", ()=>$b203414430cd64ca$export$da98615adc72ad52);
    $parcel$export(module.exports, "getIssueColor", ()=>$b203414430cd64ca$export$55c693e53af6bf58);
    $parcel$export(module.exports, "getIssueDependenciesHash", ()=>$b203414430cd64ca$export$d18473c39ab467b9);
    $parcel$export(module.exports, "getIssueDependeesHash", ()=>$b203414430cd64ca$export$a75f6e1b2d9a96e6);
    $parcel$export(module.exports, "getIssueCreationTransitionHash", ()=>$b203414430cd64ca$export$463be3da47228a17);
    $parcel$export(module.exports, "getIssueTypeIdHash", ()=>$b203414430cd64ca$export$9c2cc629815990f4);
    $parcel$export(module.exports, "getIssueParentIdHash", ()=>$b203414430cd64ca$export$bc636ecad39aefe7);
    $parcel$export(module.exports, "getIssueParentIds", ()=>$b203414430cd64ca$export$e2a1f4395caa152c);
    $parcel$export(module.exports, "getIssueChildrenHash", ()=>$b203414430cd64ca$export$42b9de7c695b23f4);
    $parcel$export(module.exports, "getIssueAssigneeHash", ()=>$b203414430cd64ca$export$ece74a09c40b283c);
    $parcel$export(module.exports, "getIssueTypeIdForIssueId", ()=>$b203414430cd64ca$export$627dd4a8a3148b34);
    $parcel$export(module.exports, "getIssueRank", ()=>$b203414430cd64ca$export$83043f999557592);
    $parcel$export(module.exports, "getIssueKeyToIdHash", ()=>$b203414430cd64ca$export$725bd639062ab891);
    $parcel$export(module.exports, "getIssueKeyById", ()=>$b203414430cd64ca$export$1ee789fc749b8122);
    $parcel$export(module.exports, "getSafeId", ()=>$b203414430cd64ca$export$d1aa29729505dfb6);
    $parcel$export(module.exports, "getSafeIds", ()=>$b203414430cd64ca$export$7a2a38248dcbd59d);
    $parcel$export(module.exports, "getSafeIdResolve", ()=>$b203414430cd64ca$export$1ecfe4cc5bb1d8e8);
    $parcel$export(module.exports, "getIssueLevel", ()=>$b203414430cd64ca$export$7c3556a5aaee2b0b);
    $parcel$export(module.exports, "getIsIssueStartDateRequired", ()=>$b203414430cd64ca$export$8772cf309cb8256d);
    $parcel$export(module.exports, "getIsIssueDueDateRequired", ()=>$b203414430cd64ca$export$cbfbf3928d1b6c17);
    $parcel$export(module.exports, "getIsIssueResolved", ()=>$b203414430cd64ca$export$bf068fa0555f7625);
    $parcel$export(module.exports, "getIsIssueFlaggedHash", ()=>$b203414430cd64ca$export$5b8c57fffaec5b6b);
    parcelRequire("9IWoG");
    parcelRequire("fp4O3");
    parcelRequire("9o0uh");
    parcelRequire("d0pqD");
    parcelRequire("fPS7b");
    var $dGvGJ = parcelRequire("dGvGJ");
    var $lbWm4 = parcelRequire("lbWm4");
    var $hBTIy = parcelRequire("hBTIy");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $kVLXA = parcelRequire("kVLXA");
    var $kFsv3;
    var $joGLY;
    var $lB63i;
    var $CX7OH;
    var $4gYYI;
    var $4LbSm;
    const $b203414430cd64ca$var$get = (state)=>state.entities.issues;
    const $b203414430cd64ca$export$509a628015f94404 = (state)=>$b203414430cd64ca$var$get(state).hash;
    const $b203414430cd64ca$export$34403cb88b30d33b = (state, issueId)=>$b203414430cd64ca$export$509a628015f94404(state)[issueId];
    const $b203414430cd64ca$export$a987926fdc8259e3 = (state, issueId)=>Boolean($b203414430cd64ca$export$34403cb88b30d33b(state, issueId)) || Boolean((0, (0, parcelRequire("4LbSm")).getSubtaskParentHash)(state)[issueId]);
    const $b203414430cd64ca$export$370b31b0927c0664 = (state)=>$b203414430cd64ca$var$get(state).sequence;
    const $b203414430cd64ca$var$entityUpdateSelector = (0, (0, parcelRequire("lB63i")).createVersionedEntityHashDiffSelector)($b203414430cd64ca$export$509a628015f94404);
    const $b203414430cd64ca$export$709dd7a2719b4d3c = (0, (0, parcelRequire("CX7OH")).createPropertyHashSelector)($b203414430cd64ca$var$entityUpdateSelector, (issue)=>issue.key);
    const $b203414430cd64ca$export$45178bf1f6b30a05 = (0, (0, parcelRequire("CX7OH")).createPropertyHashSelector)($b203414430cd64ca$var$entityUpdateSelector, (issue)=>issue.summary.value);
    const $b203414430cd64ca$export$7bead7bb2ab962ba = (state, issueId)=>$b203414430cd64ca$export$45178bf1f6b30a05(state)[issueId];
    const $b203414430cd64ca$export$89a09562712dfef3 = (0, (0, parcelRequire("CX7OH")).createPropertyHashSelector)($b203414430cd64ca$var$entityUpdateSelector, (issue)=>issue.labels);
    const $b203414430cd64ca$export$424a50dfd4d5b981 = (state, issueId)=>$b203414430cd64ca$export$89a09562712dfef3(state)[issueId];
    const $b203414430cd64ca$export$8245af4324992ff2 = (0, (0, parcelRequire("CX7OH")).createPropertyHashSelector)($b203414430cd64ca$var$entityUpdateSelector, (issue)=>issue.versionIds);
    const $b203414430cd64ca$export$5e800c163de4eaa7 = (0, (0, parcelRequire("CX7OH")).createPropertyHashSelector)($b203414430cd64ca$var$entityUpdateSelector, (issue)=>issue.componentIds);
    const $b203414430cd64ca$export$a4ba5eda4ed95a38 = (0, (0, parcelRequire("CX7OH")).createPropertyHashSelector)($b203414430cd64ca$var$entityUpdateSelector, (issue)=>issue.sprintIds.value);
    const $b203414430cd64ca$export$e70cd0960ca3186b = (0, (0, parcelRequire("CX7OH")).createPropertyHashSelector)($b203414430cd64ca$var$entityUpdateSelector, (issue)=>issue.startDate.value);
    const $b203414430cd64ca$export$a8ae12d1f205826a = (state, issueId)=>$b203414430cd64ca$export$e70cd0960ca3186b(state)[issueId];
    const $b203414430cd64ca$export$50e1c24a80dbb314 = (0, (0, parcelRequire("CX7OH")).createPropertyHashSelector)($b203414430cd64ca$var$entityUpdateSelector, (issue)=>issue.dueDate.value);
    const $b203414430cd64ca$export$f8ab4a7848083941 = (state, issueId)=>$b203414430cd64ca$export$50e1c24a80dbb314(state)[issueId];
    const $b203414430cd64ca$export$b01abdaac5dcf309 = (0, (0, parcelRequire("CX7OH")).createPropertyHashSelector)($b203414430cd64ca$var$entityUpdateSelector, (issue)=>issue.status);
    const $b203414430cd64ca$export$adccc555500c3bee = (0, (0, parcelRequire("CX7OH")).createPropertyHashSelector)($b203414430cd64ca$var$entityUpdateSelector, (issue)=>issue.status ? issue.status.statusCategoryId : undefined);
    const $b203414430cd64ca$export$da98615adc72ad52 = (0, (0, parcelRequire("CX7OH")).createPropertyHashSelector)($b203414430cd64ca$var$entityUpdateSelector, (issue)=>issue?.color.value || (0, (0, parcelRequire("kFsv3")).PURPLE));
    const $b203414430cd64ca$export$55c693e53af6bf58 = (state, issueId)=>$b203414430cd64ca$export$da98615adc72ad52(state)[issueId];
    const $b203414430cd64ca$export$d18473c39ab467b9 = (0, (0, parcelRequire("CX7OH")).createPropertyHashSelector)($b203414430cd64ca$var$entityUpdateSelector, (issue)=>issue.dependencies);
    const $b203414430cd64ca$export$ce469229d91e527c = (state, issueId)=>{
        const dependencies = $b203414430cd64ca$export$d18473c39ab467b9(state)[issueId];
        return Boolean(dependencies && dependencies.length > 0);
    };
    const $b203414430cd64ca$export$a75f6e1b2d9a96e6 = (0, $dGvGJ.createSelector)($b203414430cd64ca$export$d18473c39ab467b9, (dependenciesHash)=>{
        const result = {};
        (0, ($parcel$interopDefault($lbWm4)))(dependenciesHash, (dependencies, issueId)=>{
            dependencies.forEach((dependencyId)=>{
                if (!result[dependencyId]) result[dependencyId] = [];
                result[dependencyId].push(issueId);
            });
        });
        return result;
    });
    const $b203414430cd64ca$export$463be3da47228a17 = (0, (0, parcelRequire("CX7OH")).createPropertyHashSelector)($b203414430cd64ca$var$entityUpdateSelector, (issue)=>issue.inCreation);
    const $b203414430cd64ca$export$9c2cc629815990f4 = (0, (0, parcelRequire("CX7OH")).createPropertyHashSelector)($b203414430cd64ca$var$entityUpdateSelector, (issue)=>issue.issueTypeId);
    const $b203414430cd64ca$export$bc636ecad39aefe7 = (0, (0, parcelRequire("CX7OH")).createPropertyHashSelector)($b203414430cd64ca$var$entityUpdateSelector, (issue)=>issue.parentId.value);
    const $b203414430cd64ca$export$e2a1f4395caa152c = (0, $dGvGJ.createSelector)($b203414430cd64ca$export$bc636ecad39aefe7, (issueParentIdHash)=>Object.keys(issueParentIdHash).filter((issueId)=>issueParentIdHash[issueId] === undefined));
    const $b203414430cd64ca$export$42b9de7c695b23f4 = (0, $dGvGJ.createSelector)($b203414430cd64ca$export$bc636ecad39aefe7, (0, ($parcel$interopDefault($hBTIy))));
    const $b203414430cd64ca$export$ece74a09c40b283c = (0, (0, parcelRequire("CX7OH")).createPropertyHashSelector)($b203414430cd64ca$var$entityUpdateSelector, (issue)=>issue.assignee);
    const $b203414430cd64ca$export$d4f6e058473cfdbe = (0, (0, parcelRequire("CX7OH")).createPropertyHashSelector)($b203414430cd64ca$var$entityUpdateSelector, (issue)=>issue.rank);
    const $b203414430cd64ca$export$627dd4a8a3148b34 = (state, issueId)=>$b203414430cd64ca$export$9c2cc629815990f4(state)[issueId];
    const $b203414430cd64ca$export$83043f999557592 = (state, issueId)=>$b203414430cd64ca$export$d4f6e058473cfdbe(state)[issueId];
    const $b203414430cd64ca$export$725bd639062ab891 = (0, $dGvGJ.createSelector)($b203414430cd64ca$export$709dd7a2719b4d3c, (keyHash)=>{
        const result = {};
        Object.keys(keyHash).forEach((id)=>{
            const issueKey = keyHash[id];
            if (issueKey !== undefined && typeof issueKey === 'string') result[issueKey] = id;
        });
        return result;
    });
    const $b203414430cd64ca$export$1ee789fc749b8122 = (state, issueId)=>$b203414430cd64ca$export$709dd7a2719b4d3c(state)[issueId];
    const $b203414430cd64ca$export$41017b23e16219ab = (state, issueId)=>$b203414430cd64ca$export$463be3da47228a17(state)[issueId] === true;
    const $b203414430cd64ca$var$getTransitionHandlers = (0, (0, parcelRequire("CX7OH")).createPropertyHashSelector)($b203414430cd64ca$var$entityUpdateSelector, (issue, id)=>{
        if (issue.inCreation) {
            const resolve = {
                func: (0, ($parcel$interopDefault($8Rkzz)))
            };
            const promise = new Promise((resolution)=>{
                resolve.func = resolution;
            });
            return {
                observable: (0, $kVLXA.Observable).fromPromise(promise),
                resolve: resolve.func
            };
        }
        return {
            observable: (0, $kVLXA.Observable).of(id),
            resolve: (0, ($parcel$interopDefault($8Rkzz)))
        };
    });
    const $b203414430cd64ca$var$getSafeTransitionId = (state, id)=>$b203414430cd64ca$var$getTransitionHandlers(state)[id];
    const $b203414430cd64ca$export$d1aa29729505dfb6 = (state, id)=>{
        const transitionId = $b203414430cd64ca$var$getSafeTransitionId(state, id);
        if (transitionId === undefined) return (0, $kVLXA.Observable).of({}).mergeMap(()=>{
            throw Error(`no safe id can be retrieved for id ${id}`);
        });
        return transitionId.observable;
    };
    const $b203414430cd64ca$export$7a2a38248dcbd59d = (state, ids)=>(0, $kVLXA.Observable).forkJoin(ids.map((id)=>$b203414430cd64ca$export$d1aa29729505dfb6(state, id))).map((safeIds)=>safeIds);
    const $b203414430cd64ca$export$1ecfe4cc5bb1d8e8 = (state, id)=>{
        const transitionId = $b203414430cd64ca$var$getSafeTransitionId(state, id);
        if (transitionId === undefined) return ()=>{
            throw Error(`cannot resolve id ${id}`);
        };
        return transitionId.resolve;
    };
    const $b203414430cd64ca$export$7c3556a5aaee2b0b = (state, issueId)=>{
        if ((0, (0, parcelRequire("4gYYI")).getEpicIssueTypeIds)(state).includes($b203414430cd64ca$export$627dd4a8a3148b34(state, issueId))) return 0, (0, parcelRequire("joGLY")).PARENT_LEVEL;
        return $b203414430cd64ca$export$bc636ecad39aefe7(state)[issueId] === undefined ? (0, (0, parcelRequire("joGLY")).PARENT_LEVEL) : (0, (0, parcelRequire("joGLY")).BASE_LEVEL);
    };
    const $b203414430cd64ca$export$8772cf309cb8256d = (state, issueId)=>(0, (0, parcelRequire("4gYYI")).getRequiredFieldsByIssueTypeId)(state, $b203414430cd64ca$export$627dd4a8a3148b34(state, issueId)).includes('startdate');
    const $b203414430cd64ca$export$cbfbf3928d1b6c17 = (state, issueId)=>(0, (0, parcelRequire("4gYYI")).getRequiredFieldsByIssueTypeId)(state, $b203414430cd64ca$export$627dd4a8a3148b34(state, issueId)).includes('duedate');
    const $b203414430cd64ca$export$d1de367978946dbc = (0, (0, parcelRequire("CX7OH")).createPropertyHashSelector)($b203414430cd64ca$var$entityUpdateSelector, (issue)=>issue.resolved);
    const $b203414430cd64ca$export$bf068fa0555f7625 = (state, issueId)=>$b203414430cd64ca$export$d1de367978946dbc(state)[issueId];
    const $b203414430cd64ca$export$5b8c57fffaec5b6b = (0, (0, parcelRequire("CX7OH")).createPropertyHashSelector)($b203414430cd64ca$var$entityUpdateSelector, (issue)=>issue.flagged);
});
parcelRegister("hBTIy", function(module, exports) {
    var $bxDef = parcelRequire("bxDef");
    var $fxKlj = parcelRequire("fxKlj");
    var $cd211cc0a4b46c85$var$objectProto = Object.prototype;
    var $cd211cc0a4b46c85$var$hasOwnProperty = $cd211cc0a4b46c85$var$objectProto.hasOwnProperty;
    var $cd211cc0a4b46c85$var$nativeObjectToString = $cd211cc0a4b46c85$var$objectProto.toString;
    var $cd211cc0a4b46c85$var$invertBy = $fxKlj(function(result, value, key) {
        if (value != null && typeof value.toString != 'function') value = $cd211cc0a4b46c85$var$nativeObjectToString.call(value);
        if ($cd211cc0a4b46c85$var$hasOwnProperty.call(result, value)) result[value].push(key);
        else result[value] = [
            key
        ];
    }, $bxDef);
    module.exports = $cd211cc0a4b46c85$var$invertBy;
});
parcelRegister("kFsv3", function(module, exports) {
    $parcel$export(module.exports, "PURPLE", ()=>$da8a77f13d52b186$export$7ffdeca4b2f927a2);
    $parcel$export(module.exports, "DARK_PURPLE", ()=>$da8a77f13d52b186$export$c815fe495e8174a0);
    $parcel$export(module.exports, "BLUE", ()=>$da8a77f13d52b186$export$738c3b9a44c87ecc);
    $parcel$export(module.exports, "DARK_BLUE", ()=>$da8a77f13d52b186$export$1225f83626261b80);
    $parcel$export(module.exports, "GREEN", ()=>$da8a77f13d52b186$export$48d4b2cd5bc0e88b);
    $parcel$export(module.exports, "DARK_GREEN", ()=>$da8a77f13d52b186$export$c6f4cf2e5768eb78);
    $parcel$export(module.exports, "TEAL", ()=>$da8a77f13d52b186$export$d0446fe88325854e);
    $parcel$export(module.exports, "DARK_TEAL", ()=>$da8a77f13d52b186$export$bb848c92687e69dc);
    $parcel$export(module.exports, "YELLOW", ()=>$da8a77f13d52b186$export$aab610c505c06a8f);
    $parcel$export(module.exports, "DARK_YELLOW", ()=>$da8a77f13d52b186$export$466af87757d343a2);
    $parcel$export(module.exports, "ORANGE", ()=>$da8a77f13d52b186$export$3de5e29ed1757f9b);
    $parcel$export(module.exports, "DARK_ORANGE", ()=>$da8a77f13d52b186$export$da02e4820b6ab753);
    $parcel$export(module.exports, "GREY", ()=>$da8a77f13d52b186$export$7d278ca694634874);
    $parcel$export(module.exports, "DARK_GREY", ()=>$da8a77f13d52b186$export$26453300bfc61cb8);
    $parcel$export(module.exports, "COLORS", ()=>$da8a77f13d52b186$export$56d196d2844d1ca1);
    $parcel$export(module.exports, "SERVER_PURPLE", ()=>$da8a77f13d52b186$export$792af22a0198af8d);
    $parcel$export(module.exports, "SERVER_DARK_PURPLE", ()=>$da8a77f13d52b186$export$588af712afdcb006);
    $parcel$export(module.exports, "SERVER_BLUE", ()=>$da8a77f13d52b186$export$84c4918645391802);
    $parcel$export(module.exports, "SERVER_DARK_BLUE", ()=>$da8a77f13d52b186$export$b8f1f5838352a33a);
    $parcel$export(module.exports, "SERVER_GREEN", ()=>$da8a77f13d52b186$export$9384b7e350ee6542);
    $parcel$export(module.exports, "SERVER_DARK_GREEN", ()=>$da8a77f13d52b186$export$87d3fb8d8656d38b);
    $parcel$export(module.exports, "SERVER_TEAL", ()=>$da8a77f13d52b186$export$b0b4ce3e99e66aae);
    $parcel$export(module.exports, "SERVER_DARK_TEAL", ()=>$da8a77f13d52b186$export$a89b77a449bd223e);
    $parcel$export(module.exports, "SERVER_YELLOW", ()=>$da8a77f13d52b186$export$9a33b5e3cde94885);
    $parcel$export(module.exports, "SERVER_DARK_YELLOW", ()=>$da8a77f13d52b186$export$33253d7862bceb8a);
    $parcel$export(module.exports, "SERVER_ORANGE", ()=>$da8a77f13d52b186$export$6609c2b23fc42f39);
    $parcel$export(module.exports, "SERVER_DARK_ORANGE", ()=>$da8a77f13d52b186$export$cd994662b5911917);
    $parcel$export(module.exports, "SERVER_GREY", ()=>$da8a77f13d52b186$export$1793d43e13e078c5);
    $parcel$export(module.exports, "SERVER_DARK_GREY", ()=>$da8a77f13d52b186$export$487a6e9145526564);
    $parcel$export(module.exports, "GHX_LABEL_1", ()=>$da8a77f13d52b186$export$e4bdf2d4c4bbb15e);
    $parcel$export(module.exports, "GHX_LABEL_2", ()=>$da8a77f13d52b186$export$8f5c1c5512278dc6);
    $parcel$export(module.exports, "GHX_LABEL_3", ()=>$da8a77f13d52b186$export$94ac87c81ed074a7);
    $parcel$export(module.exports, "GHX_LABEL_4", ()=>$da8a77f13d52b186$export$6bc9ab1f489f76f7);
    $parcel$export(module.exports, "GHX_LABEL_5", ()=>$da8a77f13d52b186$export$610a2c132b6fcf96);
    $parcel$export(module.exports, "GHX_LABEL_6", ()=>$da8a77f13d52b186$export$8e4997dba71f1c40);
    $parcel$export(module.exports, "GHX_LABEL_7", ()=>$da8a77f13d52b186$export$18a545b4e69b27b4);
    $parcel$export(module.exports, "GHX_LABEL_8", ()=>$da8a77f13d52b186$export$27fff1a0d295292a);
    $parcel$export(module.exports, "GHX_LABEL_9", ()=>$da8a77f13d52b186$export$e57aa662a56724e1);
    $parcel$export(module.exports, "GHX_LABEL_10", ()=>$da8a77f13d52b186$export$4b0d63e2c3be2072);
    $parcel$export(module.exports, "GHX_LABEL_11", ()=>$da8a77f13d52b186$export$457ecb9560f2bf83);
    $parcel$export(module.exports, "GHX_LABEL_12", ()=>$da8a77f13d52b186$export$a866db37165a696c);
    $parcel$export(module.exports, "GHX_LABEL_13", ()=>$da8a77f13d52b186$export$9b18447c1168a1b6);
    $parcel$export(module.exports, "GHX_LABEL_14", ()=>$da8a77f13d52b186$export$93b9ad4020e271b7);
    $parcel$export(module.exports, "AGILE_COLOR_1", ()=>$da8a77f13d52b186$export$5cd2af17b34de3e3);
    $parcel$export(module.exports, "AGILE_COLOR_2", ()=>$da8a77f13d52b186$export$987671fa69482a7b);
    $parcel$export(module.exports, "AGILE_COLOR_3", ()=>$da8a77f13d52b186$export$70ba8a5b1f4c7446);
    $parcel$export(module.exports, "AGILE_COLOR_4", ()=>$da8a77f13d52b186$export$fcd1c42d8d3ebd36);
    $parcel$export(module.exports, "AGILE_COLOR_5", ()=>$da8a77f13d52b186$export$f80a5bd2fa0ba256);
    $parcel$export(module.exports, "AGILE_COLOR_6", ()=>$da8a77f13d52b186$export$37ad5ce8d2aeaf78);
    $parcel$export(module.exports, "AGILE_COLOR_7", ()=>$da8a77f13d52b186$export$9dc62d5d151cb355);
    $parcel$export(module.exports, "AGILE_COLOR_8", ()=>$da8a77f13d52b186$export$1ed15b30f5663f92);
    $parcel$export(module.exports, "AGILE_COLOR_9", ()=>$da8a77f13d52b186$export$5d23a84d55ac1644);
    $parcel$export(module.exports, "AGILE_COLOR_10", ()=>$da8a77f13d52b186$export$bf08c9a6ed42e349);
    $parcel$export(module.exports, "AGILE_COLOR_11", ()=>$da8a77f13d52b186$export$66c5d8f0b5ff279c);
    $parcel$export(module.exports, "AGILE_COLOR_12", ()=>$da8a77f13d52b186$export$da30755a37c3a597);
    $parcel$export(module.exports, "AGILE_COLOR_13", ()=>$da8a77f13d52b186$export$721cf84faff6bf19);
    $parcel$export(module.exports, "AGILE_COLOR_14", ()=>$da8a77f13d52b186$export$4b8f8666bd7b61dd);
    $parcel$export(module.exports, "Colors", ()=>$da8a77f13d52b186$export$c537fa0d021d010b);
    $parcel$export(module.exports, "ServerColors", ()=>$da8a77f13d52b186$export$d33d39828a18210a);
    $parcel$export(module.exports, "ClassicEpicColors", ()=>$da8a77f13d52b186$export$f476e6e43e0101e7);
    $parcel$export(module.exports, "AgileColors", ()=>$da8a77f13d52b186$export$4b7407b8700035bd);
    const $da8a77f13d52b186$export$7ffdeca4b2f927a2 = 'PURPLE';
    const $da8a77f13d52b186$export$c815fe495e8174a0 = 'DARK_PURPLE';
    const $da8a77f13d52b186$export$738c3b9a44c87ecc = 'BLUE';
    const $da8a77f13d52b186$export$1225f83626261b80 = 'DARK_BLUE';
    const $da8a77f13d52b186$export$48d4b2cd5bc0e88b = 'GREEN';
    const $da8a77f13d52b186$export$c6f4cf2e5768eb78 = 'DARK_GREEN';
    const $da8a77f13d52b186$export$d0446fe88325854e = 'TEAL';
    const $da8a77f13d52b186$export$bb848c92687e69dc = 'DARK_TEAL';
    const $da8a77f13d52b186$export$aab610c505c06a8f = 'YELLOW';
    const $da8a77f13d52b186$export$466af87757d343a2 = 'DARK_YELLOW';
    const $da8a77f13d52b186$export$3de5e29ed1757f9b = 'ORANGE';
    const $da8a77f13d52b186$export$da02e4820b6ab753 = 'DARK_ORANGE';
    const $da8a77f13d52b186$export$7d278ca694634874 = 'GREY';
    const $da8a77f13d52b186$export$26453300bfc61cb8 = 'DARK_GREY';
    const $da8a77f13d52b186$export$56d196d2844d1ca1 = [
        $da8a77f13d52b186$export$7ffdeca4b2f927a2,
        $da8a77f13d52b186$export$c815fe495e8174a0,
        $da8a77f13d52b186$export$738c3b9a44c87ecc,
        $da8a77f13d52b186$export$1225f83626261b80,
        $da8a77f13d52b186$export$48d4b2cd5bc0e88b,
        $da8a77f13d52b186$export$c6f4cf2e5768eb78,
        $da8a77f13d52b186$export$d0446fe88325854e,
        $da8a77f13d52b186$export$bb848c92687e69dc,
        $da8a77f13d52b186$export$aab610c505c06a8f,
        $da8a77f13d52b186$export$466af87757d343a2,
        $da8a77f13d52b186$export$3de5e29ed1757f9b,
        $da8a77f13d52b186$export$da02e4820b6ab753,
        $da8a77f13d52b186$export$7d278ca694634874,
        $da8a77f13d52b186$export$26453300bfc61cb8
    ];
    const $da8a77f13d52b186$export$792af22a0198af8d = 'purple';
    const $da8a77f13d52b186$export$588af712afdcb006 = 'dark_purple';
    const $da8a77f13d52b186$export$84c4918645391802 = 'blue';
    const $da8a77f13d52b186$export$b8f1f5838352a33a = 'dark_blue';
    const $da8a77f13d52b186$export$9384b7e350ee6542 = 'green';
    const $da8a77f13d52b186$export$87d3fb8d8656d38b = 'dark_green';
    const $da8a77f13d52b186$export$b0b4ce3e99e66aae = 'teal';
    const $da8a77f13d52b186$export$a89b77a449bd223e = 'dark_teal';
    const $da8a77f13d52b186$export$9a33b5e3cde94885 = 'yellow';
    const $da8a77f13d52b186$export$33253d7862bceb8a = 'dark_yellow';
    const $da8a77f13d52b186$export$6609c2b23fc42f39 = 'orange';
    const $da8a77f13d52b186$export$cd994662b5911917 = 'dark_orange';
    const $da8a77f13d52b186$export$1793d43e13e078c5 = 'grey';
    const $da8a77f13d52b186$export$487a6e9145526564 = 'dark_grey';
    const $da8a77f13d52b186$export$e4bdf2d4c4bbb15e = 'ghx-label-1';
    const $da8a77f13d52b186$export$8f5c1c5512278dc6 = 'ghx-label-2';
    const $da8a77f13d52b186$export$94ac87c81ed074a7 = 'ghx-label-3';
    const $da8a77f13d52b186$export$6bc9ab1f489f76f7 = 'ghx-label-4';
    const $da8a77f13d52b186$export$610a2c132b6fcf96 = 'ghx-label-5';
    const $da8a77f13d52b186$export$8e4997dba71f1c40 = 'ghx-label-6';
    const $da8a77f13d52b186$export$18a545b4e69b27b4 = 'ghx-label-7';
    const $da8a77f13d52b186$export$27fff1a0d295292a = 'ghx-label-8';
    const $da8a77f13d52b186$export$e57aa662a56724e1 = 'ghx-label-9';
    const $da8a77f13d52b186$export$4b0d63e2c3be2072 = 'ghx-label-10';
    const $da8a77f13d52b186$export$457ecb9560f2bf83 = 'ghx-label-11';
    const $da8a77f13d52b186$export$a866db37165a696c = 'ghx-label-12';
    const $da8a77f13d52b186$export$9b18447c1168a1b6 = 'ghx-label-13';
    const $da8a77f13d52b186$export$93b9ad4020e271b7 = 'ghx-label-14';
    const $da8a77f13d52b186$export$5cd2af17b34de3e3 = 'color_1';
    const $da8a77f13d52b186$export$987671fa69482a7b = 'color_2';
    const $da8a77f13d52b186$export$70ba8a5b1f4c7446 = 'color_3';
    const $da8a77f13d52b186$export$fcd1c42d8d3ebd36 = 'color_4';
    const $da8a77f13d52b186$export$f80a5bd2fa0ba256 = 'color_5';
    const $da8a77f13d52b186$export$37ad5ce8d2aeaf78 = 'color_6';
    const $da8a77f13d52b186$export$9dc62d5d151cb355 = 'color_7';
    const $da8a77f13d52b186$export$1ed15b30f5663f92 = 'color_8';
    const $da8a77f13d52b186$export$5d23a84d55ac1644 = 'color_9';
    const $da8a77f13d52b186$export$bf08c9a6ed42e349 = 'color_10';
    const $da8a77f13d52b186$export$66c5d8f0b5ff279c = 'color_11';
    const $da8a77f13d52b186$export$da30755a37c3a597 = 'color_12';
    const $da8a77f13d52b186$export$721cf84faff6bf19 = 'color_13';
    const $da8a77f13d52b186$export$4b8f8666bd7b61dd = 'color_14';
    const $da8a77f13d52b186$export$c537fa0d021d010b = {
        PURPLE: $da8a77f13d52b186$export$7ffdeca4b2f927a2,
        DARK_PURPLE: $da8a77f13d52b186$export$c815fe495e8174a0,
        BLUE: $da8a77f13d52b186$export$738c3b9a44c87ecc,
        DARK_BLUE: $da8a77f13d52b186$export$1225f83626261b80,
        GREEN: $da8a77f13d52b186$export$48d4b2cd5bc0e88b,
        DARK_GREEN: $da8a77f13d52b186$export$c6f4cf2e5768eb78,
        TEAL: $da8a77f13d52b186$export$d0446fe88325854e,
        DARK_TEAL: $da8a77f13d52b186$export$bb848c92687e69dc,
        YELLOW: $da8a77f13d52b186$export$aab610c505c06a8f,
        DARK_YELLOW: $da8a77f13d52b186$export$466af87757d343a2,
        ORANGE: $da8a77f13d52b186$export$3de5e29ed1757f9b,
        DARK_ORANGE: $da8a77f13d52b186$export$da02e4820b6ab753,
        GREY: $da8a77f13d52b186$export$7d278ca694634874,
        DARK_GREY: $da8a77f13d52b186$export$26453300bfc61cb8
    };
    const $da8a77f13d52b186$export$d33d39828a18210a = {
        SERVER_PURPLE: $da8a77f13d52b186$export$792af22a0198af8d,
        SERVER_DARK_PURPLE: $da8a77f13d52b186$export$588af712afdcb006,
        SERVER_BLUE: $da8a77f13d52b186$export$84c4918645391802,
        SERVER_DARK_BLUE: $da8a77f13d52b186$export$b8f1f5838352a33a,
        SERVER_GREEN: $da8a77f13d52b186$export$9384b7e350ee6542,
        SERVER_DARK_GREEN: $da8a77f13d52b186$export$87d3fb8d8656d38b,
        SERVER_TEAL: $da8a77f13d52b186$export$b0b4ce3e99e66aae,
        SERVER_DARK_TEAL: $da8a77f13d52b186$export$a89b77a449bd223e,
        SERVER_YELLOW: $da8a77f13d52b186$export$9a33b5e3cde94885,
        SERVER_DARK_YELLOW: $da8a77f13d52b186$export$33253d7862bceb8a,
        SERVER_ORANGE: $da8a77f13d52b186$export$6609c2b23fc42f39,
        SERVER_DARK_ORANGE: $da8a77f13d52b186$export$cd994662b5911917,
        SERVER_GREY: $da8a77f13d52b186$export$1793d43e13e078c5,
        SERVER_DARK_GREY: $da8a77f13d52b186$export$487a6e9145526564
    };
    const $da8a77f13d52b186$export$f476e6e43e0101e7 = {
        GHX_LABEL_1: $da8a77f13d52b186$export$e4bdf2d4c4bbb15e,
        GHX_LABEL_2: $da8a77f13d52b186$export$8f5c1c5512278dc6,
        GHX_LABEL_3: $da8a77f13d52b186$export$94ac87c81ed074a7,
        GHX_LABEL_4: $da8a77f13d52b186$export$6bc9ab1f489f76f7,
        GHX_LABEL_5: $da8a77f13d52b186$export$610a2c132b6fcf96,
        GHX_LABEL_6: $da8a77f13d52b186$export$8e4997dba71f1c40,
        GHX_LABEL_7: $da8a77f13d52b186$export$18a545b4e69b27b4,
        GHX_LABEL_8: $da8a77f13d52b186$export$27fff1a0d295292a,
        GHX_LABEL_9: $da8a77f13d52b186$export$e57aa662a56724e1,
        GHX_LABEL_10: $da8a77f13d52b186$export$4b0d63e2c3be2072,
        GHX_LABEL_11: $da8a77f13d52b186$export$457ecb9560f2bf83,
        GHX_LABEL_12: $da8a77f13d52b186$export$a866db37165a696c,
        GHX_LABEL_13: $da8a77f13d52b186$export$9b18447c1168a1b6,
        GHX_LABEL_14: $da8a77f13d52b186$export$93b9ad4020e271b7
    };
    const $da8a77f13d52b186$export$4b7407b8700035bd = {
        AGILE_COLOR_1: $da8a77f13d52b186$export$5cd2af17b34de3e3,
        AGILE_COLOR_2: $da8a77f13d52b186$export$987671fa69482a7b,
        AGILE_COLOR_3: $da8a77f13d52b186$export$70ba8a5b1f4c7446,
        AGILE_COLOR_4: $da8a77f13d52b186$export$fcd1c42d8d3ebd36,
        AGILE_COLOR_5: $da8a77f13d52b186$export$f80a5bd2fa0ba256,
        AGILE_COLOR_6: $da8a77f13d52b186$export$37ad5ce8d2aeaf78,
        AGILE_COLOR_7: $da8a77f13d52b186$export$9dc62d5d151cb355,
        AGILE_COLOR_8: $da8a77f13d52b186$export$1ed15b30f5663f92,
        AGILE_COLOR_9: $da8a77f13d52b186$export$5d23a84d55ac1644,
        AGILE_COLOR_10: $da8a77f13d52b186$export$bf08c9a6ed42e349,
        AGILE_COLOR_11: $da8a77f13d52b186$export$66c5d8f0b5ff279c,
        AGILE_COLOR_12: $da8a77f13d52b186$export$da30755a37c3a597,
        AGILE_COLOR_13: $da8a77f13d52b186$export$721cf84faff6bf19,
        AGILE_COLOR_14: $da8a77f13d52b186$export$4b8f8666bd7b61dd
    };
});
parcelRegister("joGLY", function(module, exports) {
    $parcel$export(module.exports, "BASE_LEVEL", ()=>$b8fe24bf60ed4875$export$d5993e01b9439be4);
    $parcel$export(module.exports, "PARENT_LEVEL", ()=>$b8fe24bf60ed4875$export$6c5e715ac831956e);
    $parcel$export(module.exports, "isBaseLevel", ()=>$b8fe24bf60ed4875$export$3f3fbf12338c09a4);
    $parcel$export(module.exports, "isParentLevel", ()=>$b8fe24bf60ed4875$export$dbfe1bb564ec5b98);
    const $b8fe24bf60ed4875$export$7f882bb969de14a3 = 0;
    const $b8fe24bf60ed4875$export$d5993e01b9439be4 = 0;
    const $b8fe24bf60ed4875$export$6c5e715ac831956e = 1;
    const $b8fe24bf60ed4875$export$e3140dc7d0c35e48 = (depth)=>depth === $b8fe24bf60ed4875$export$7f882bb969de14a3;
    const $b8fe24bf60ed4875$export$3f3fbf12338c09a4 = (level)=>level === $b8fe24bf60ed4875$export$d5993e01b9439be4;
    const $b8fe24bf60ed4875$export$dbfe1bb564ec5b98 = (level)=>level === $b8fe24bf60ed4875$export$6c5e715ac831956e;
});
parcelRegister("lB63i", function(module, exports) {
    $parcel$export(module.exports, "createVersionedEntityHashDiffSelector", ()=>$e707c45f3dbd2d23$export$d8971c6f597927b5);
    var $qtX5t;
    const $e707c45f3dbd2d23$export$d8971c6f597927b5 = (hashSelector)=>{
        const weakHashPairsToDiffs = new WeakMap();
        const tryGetDiff = (previousHash, hash)=>{
            if (!previousHash) return undefined;
            const previousMap = weakHashPairsToDiffs.get(previousHash);
            if (!previousMap) return undefined;
            return previousMap.get(hash);
        };
        const createDiff = (previousHash, hash)=>{
            if (!previousHash) return (0, (0, parcelRequire("qtX5t")).createInitialized)(hash);
            if (previousHash === hash) return (0, (0, parcelRequire("qtX5t")).createUnchanged)(hash);
            const { added: added, changed: changed, removed: removed, unchanged: unchanged } = (0, (0, parcelRequire("qtX5t")).getHashDiff)(previousHash, hash);
            return {
                added: added,
                changed: changed,
                removed: removed,
                unchanged: unchanged,
                hash: hash
            };
        };
        const addDiff = (previousHash, hash, diff)=>{
            if (previousHash) {
                if (!weakHashPairsToDiffs.get(previousHash)) weakHashPairsToDiffs.set(previousHash, new WeakMap());
                const map = weakHashPairsToDiffs.get(previousHash);
                if (map && !map.get(hash)) map.set(hash, diff);
            }
        };
        return (state, previousHash)=>{
            const hash = hashSelector(state);
            const memoizedDiff = tryGetDiff(previousHash, hash);
            if (memoizedDiff) return memoizedDiff;
            const diff = createDiff(previousHash, hash);
            addDiff(previousHash, hash, diff);
            return diff;
        };
    };
});
parcelRegister("qtX5t", function(module, exports) {
    $parcel$export(module.exports, "createInitialized", ()=>$31ac066caadc4acd$export$c056a666e5fa43d9);
    $parcel$export(module.exports, "createUnchanged", ()=>$31ac066caadc4acd$export$2c3deafddfc1bfd8);
    $parcel$export(module.exports, "getHashDiff", ()=>$31ac066caadc4acd$export$5698c3adeade33cd);
    var $lbWm4 = parcelRequire("lbWm4");
    var $561FV = parcelRequire("561FV");
    const $31ac066caadc4acd$var$EMPTY = {};
    const $31ac066caadc4acd$export$c056a666e5fa43d9 = (hash)=>({
            added: hash,
            removed: $31ac066caadc4acd$var$EMPTY,
            changed: $31ac066caadc4acd$var$EMPTY,
            unchanged: $31ac066caadc4acd$var$EMPTY,
            hash: hash
        });
    const $31ac066caadc4acd$export$2c3deafddfc1bfd8 = (hash)=>({
            added: $31ac066caadc4acd$var$EMPTY,
            removed: $31ac066caadc4acd$var$EMPTY,
            changed: $31ac066caadc4acd$var$EMPTY,
            unchanged: hash,
            hash: hash
        });
    const $31ac066caadc4acd$var$createHashDiff = (hash)=>({
            removed: {},
            added: {},
            changed: {},
            unchanged: {},
            hash: hash
        });
    const $31ac066caadc4acd$export$5698c3adeade33cd = (prevItems, items)=>{
        const hashDiff = $31ac066caadc4acd$var$createHashDiff(items);
        (0, ($parcel$interopDefault($lbWm4)))(items, (value, key)=>{
            if (!(0, ($parcel$interopDefault($561FV)))(prevItems, key)) hashDiff.added[key] = value;
            else if (prevItems[key] !== value) hashDiff.changed[key] = value;
            else hashDiff.unchanged[key] = value;
        });
        (0, ($parcel$interopDefault($lbWm4)))(prevItems, (value, key)=>{
            if (!(0, ($parcel$interopDefault($561FV)))(items, key)) hashDiff.removed[key] = value;
        });
        return hashDiff;
    };
});
parcelRegister("CX7OH", function(module, exports) {
    $parcel$export(module.exports, "createPropertyHashSelector", ()=>$7cda63f7bfdf5180$export$be7e3b3993889dcc);
    var $lbWm4 = parcelRequire("lbWm4");
    var $gccSB = parcelRequire("gccSB");
    var $jEqi2;
    const $7cda63f7bfdf5180$export$be7e3b3993889dcc = (getVersionedEntityHash, propertyAccessor)=>{
        let previousPropertyHash = {};
        let previousEntityHash;
        return (state)=>{
            const hashDiff = getVersionedEntityHash(state, previousEntityHash);
            previousEntityHash = hashDiff.hash;
            if (!(0, (0, parcelRequire("jEqi2")).isHashModified)(hashDiff)) return previousPropertyHash;
            const newPropertyHash = {};
            let somePropertyModified = false;
            (0, ($parcel$interopDefault($lbWm4)))(hashDiff.changed, (item, key)=>{
                newPropertyHash[key] = propertyAccessor(item, key);
                somePropertyModified = somePropertyModified || previousPropertyHash[key] !== newPropertyHash[key];
            });
            if (!somePropertyModified && (0, ($parcel$interopDefault($gccSB)))(hashDiff.added) && (0, ($parcel$interopDefault($gccSB)))(hashDiff.removed)) return previousPropertyHash;
            (0, ($parcel$interopDefault($lbWm4)))(hashDiff.added, (entity, key)=>{
                newPropertyHash[key] = propertyAccessor(entity, key);
            });
            (0, ($parcel$interopDefault($lbWm4)))(hashDiff.unchanged, (entity, key)=>{
                newPropertyHash[key] = previousPropertyHash[key];
            });
            previousPropertyHash = newPropertyHash;
            return newPropertyHash;
        };
    };
});
parcelRegister("jEqi2", function(module, exports) {
    $parcel$export(module.exports, "isHashModified", ()=>$3eb00c70d2bb0291$export$938a7d6ce11aef20);
    var $gccSB = parcelRequire("gccSB");
    const $3eb00c70d2bb0291$export$938a7d6ce11aef20 = (hashDiff)=>!(0, ($parcel$interopDefault($gccSB)))(hashDiff.added) || !(0, ($parcel$interopDefault($gccSB)))(hashDiff.changed) || !(0, ($parcel$interopDefault($gccSB)))(hashDiff.removed);
});
parcelRegister("4LbSm", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_PROGRESS_META_DATA", ()=>$1ba41aaa5f3c1149$export$5effc9af7f3d5ab1);
    $parcel$export(module.exports, "getIssueSubtaskProgress", ()=>$1ba41aaa5f3c1149$export$b11597e808a0695f);
    $parcel$export(module.exports, "getSubtaskParentHash", ()=>$1ba41aaa5f3c1149$export$4815ade352754ab0);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $2udWc;
    var $fQlTr;
    const $1ba41aaa5f3c1149$export$5effc9af7f3d5ab1 = {
        total: 0,
        completed: 0
    };
    const $1ba41aaa5f3c1149$export$a4870c61873f9011 = (subtasksHash, doneStatusCategoryId)=>{
        const subtaskProgressHash = {};
        Object.keys(subtasksHash).forEach((issueId)=>{
            const subtasks = subtasksHash[issueId];
            subtaskProgressHash[issueId] = {
                total: subtasks.length,
                completed: subtasks.filter(({ statusCategoryId: statusCategoryId })=>statusCategoryId === doneStatusCategoryId).length
            };
        });
        return subtaskProgressHash;
    };
    const $1ba41aaa5f3c1149$export$dbe9e2254a5e78a5 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("fQlTr")).getFullSubtasksHash), (0, (0, parcelRequire("2udWc")).getDoneStatusCategoryId), $1ba41aaa5f3c1149$export$a4870c61873f9011);
    const $1ba41aaa5f3c1149$export$b11597e808a0695f = (state, issueId)=>$1ba41aaa5f3c1149$export$dbe9e2254a5e78a5(state)[issueId] || $1ba41aaa5f3c1149$export$5effc9af7f3d5ab1;
    const $1ba41aaa5f3c1149$export$4815ade352754ab0 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("fQlTr")).getFullSubtasksHash), (subtaskHash)=>{
        const parentHash = {};
        Object.keys(subtaskHash).forEach((issueId)=>{
            subtaskHash[issueId].forEach(({ id: subtaskId })=>{
                parentHash[subtaskId] = issueId;
            });
        });
        return parentHash;
    });
});
parcelRegister("2udWc", function(module, exports) {
    $parcel$export(module.exports, "getFullStatusCategoriesHash", ()=>$f51e1729fa64afb2$export$4d3052942abf4419);
    $parcel$export(module.exports, "getStatusCategoriesKeyHash", ()=>$f51e1729fa64afb2$export$d54ec7912540cebb);
    $parcel$export(module.exports, "getDoneStatusCategoryId", ()=>$f51e1729fa64afb2$export$3580b58bfbfbc93d);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $4Xk2W = parcelRequire("4Xk2W");
    var $h6fst = parcelRequire("h6fst");
    var $1RlSy;
    const $f51e1729fa64afb2$export$4d3052942abf4419 = (state)=>state.entities.statusCategories.hash;
    const $f51e1729fa64afb2$export$d54ec7912540cebb = (0, $dGvGJ.createSelector)($f51e1729fa64afb2$export$4d3052942abf4419, (statusCategories)=>(0, ($parcel$interopDefault($4Xk2W)))((0, ($parcel$interopDefault($h6fst)))(statusCategories), 'key'));
    const $f51e1729fa64afb2$export$3580b58bfbfbc93d = (0, $dGvGJ.createSelector)($f51e1729fa64afb2$export$4d3052942abf4419, (statusCategoriesHash)=>Object.keys(statusCategoriesHash).find((id)=>statusCategoriesHash[id].key === (0, (0, parcelRequire("1RlSy")).DONE)));
});
parcelRegister("h6fst", function(module, exports) {
    var $7Q2q6 = parcelRequire("7Q2q6");
    var $jHlUS = parcelRequire("jHlUS");
    var $jtBGw = parcelRequire("jtBGw");
    var $hTJwX = parcelRequire("hTJwX");
    var $agVdz = parcelRequire("agVdz");
    var $cY2dI = parcelRequire("cY2dI");
    var $f1B3k = parcelRequire("f1B3k");
    var $eUuIg = parcelRequire("eUuIg");
    var $jx6Tp = parcelRequire("jx6Tp");
    var $dMEgP = parcelRequire("dMEgP");
    var $c72efce4841a6f93$var$mapTag = '[object Map]', $c72efce4841a6f93$var$setTag = '[object Set]';
    var $c72efce4841a6f93$var$symIterator = $7Q2q6 ? $7Q2q6.iterator : undefined;
    function $c72efce4841a6f93$var$toArray(value) {
        if (!value) return [];
        if ($hTJwX(value)) return $agVdz(value) ? $jx6Tp(value) : $jHlUS(value);
        if ($c72efce4841a6f93$var$symIterator && value[$c72efce4841a6f93$var$symIterator]) return $cY2dI(value[$c72efce4841a6f93$var$symIterator]());
        var tag = $jtBGw(value), func = tag == $c72efce4841a6f93$var$mapTag ? $f1B3k : tag == $c72efce4841a6f93$var$setTag ? $eUuIg : $dMEgP;
        return func(value);
    }
    module.exports = $c72efce4841a6f93$var$toArray;
});
parcelRegister("cY2dI", function(module, exports) {
    function $970ccf8c01557998$var$iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    module.exports = $970ccf8c01557998$var$iteratorToArray;
});
parcelRegister("1RlSy", function(module, exports) {
    $parcel$export(module.exports, "NO_CATEGORY", ()=>$5262a098f3788151$export$485b1216c42d8d4);
    $parcel$export(module.exports, "TODO", ()=>$5262a098f3788151$export$aa456a5030160740);
    $parcel$export(module.exports, "IN_PROGRESS", ()=>$5262a098f3788151$export$5a9ac66c2785cc13);
    $parcel$export(module.exports, "DONE", ()=>$5262a098f3788151$export$71efb3495f6084f2);
    $parcel$export(module.exports, "STATUS_CATEGORY_APPEARENCE", ()=>$5262a098f3788151$export$d30a79bc64f85b0a);
    $parcel$export(module.exports, "TODO_STATUS_CATEGORY_ID", ()=>$5262a098f3788151$export$d436f83626e1a290);
    var $gULOk;
    const $5262a098f3788151$export$485b1216c42d8d4 = (0, (0, parcelRequire("gULOk")).StatusCategoryTypes).UNDEFINED;
    const $5262a098f3788151$export$aa456a5030160740 = (0, (0, parcelRequire("gULOk")).StatusCategoryTypes).NEW;
    const $5262a098f3788151$export$5a9ac66c2785cc13 = (0, (0, parcelRequire("gULOk")).StatusCategoryTypes).INDETERMINATE;
    const { DONE: $5262a098f3788151$export$71efb3495f6084f2 } = (0, (0, parcelRequire("gULOk")).StatusCategoryTypes);
    const $5262a098f3788151$export$d30a79bc64f85b0a = {
        '2': 'default',
        '3': 'success',
        '4': 'inprogress'
    };
    const $5262a098f3788151$export$d436f83626e1a290 = (0, (0, parcelRequire("gULOk")).StatusCategoryIds)[$5262a098f3788151$export$aa456a5030160740];
});
parcelRegister("fQlTr", function(module, exports) {
    $parcel$export(module.exports, "getFullSubtasksHash", ()=>$3ccbafd7896e1d86$export$180d47c15a1bb3af);
    const $3ccbafd7896e1d86$export$180d47c15a1bb3af = (state)=>state.entities.subtasks.hash;
});
parcelRegister("fWch8", function(module, exports) {
    $parcel$export(module.exports, "getLocation", ()=>$1c8c7202dc79bdd9$export$e7fd20fad3cf4b5f);
    $parcel$export(module.exports, "getLocationUrl", ()=>$1c8c7202dc79bdd9$export$c024dd91ea9ad904);
    $parcel$export(module.exports, "getQuery", ()=>$1c8c7202dc79bdd9$export$71eec30d9db46a56);
    $parcel$export(module.exports, "getStatus", ()=>$1c8c7202dc79bdd9$export$b70265791d2079d4);
    $parcel$export(module.exports, "getAssignee", ()=>$1c8c7202dc79bdd9$export$faae7c2d4768067b);
    $parcel$export(module.exports, "getIssueType", ()=>$1c8c7202dc79bdd9$export$ed2455632bf977ef);
    $parcel$export(module.exports, "getLabels", ()=>$1c8c7202dc79bdd9$export$f81a3ec2bfb3f287);
    $parcel$export(module.exports, "getIssueParents", ()=>$1c8c7202dc79bdd9$export$df9259146e40d32c);
    $parcel$export(module.exports, "getVersions", ()=>$1c8c7202dc79bdd9$export$cbd9528a83fbffa1);
    $parcel$export(module.exports, "getGoalAris", ()=>$1c8c7202dc79bdd9$export$d79b9fff2c89e8e9);
    $parcel$export(module.exports, "isGoalFilterActive", ()=>$1c8c7202dc79bdd9$export$ab702c2371a7d5f8);
    $parcel$export(module.exports, "getHighlightedVersionsInQuery", ()=>$1c8c7202dc79bdd9$export$5b6701495fa73553);
    $parcel$export(module.exports, "getComponents", ()=>$1c8c7202dc79bdd9$export$4e811121b221213b);
    $parcel$export(module.exports, "getQuickFilters", ()=>$1c8c7202dc79bdd9$export$59e2f55e44eccfa0);
    $parcel$export(module.exports, "getCustomFilters", ()=>$1c8c7202dc79bdd9$export$ada7918f4af738ad);
    $parcel$export(module.exports, "getQueryContainsJQLFilters", ()=>$1c8c7202dc79bdd9$export$dba384035ff81d88);
    $parcel$export(module.exports, "getSelectedIssueKey", ()=>$1c8c7202dc79bdd9$export$f4f27837c656f0ef);
    $parcel$export(module.exports, "isDependenciesVisibleInQuery", ()=>$1c8c7202dc79bdd9$export$4f0b76c30f0f3fd5);
    $parcel$export(module.exports, "isProgressVisibleInQuery", ()=>$1c8c7202dc79bdd9$export$6768efe8b031989d);
    $parcel$export(module.exports, "isWarningsVisibleInQuery", ()=>$1c8c7202dc79bdd9$export$bb252b79d23fc8f2);
    $parcel$export(module.exports, "isReleasesVisibleInQuery", ()=>$1c8c7202dc79bdd9$export$751544b976770556);
    $parcel$export(module.exports, "isShared", ()=>$1c8c7202dc79bdd9$export$973d2af2aea58feb);
    $parcel$export(module.exports, "getEpicSettingInQuery", ()=>$1c8c7202dc79bdd9$export$5f19542fc055e77c);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $9xRvt;
    var $9fPrG;
    var $6thbV;
    const $1c8c7202dc79bdd9$export$e7fd20fad3cf4b5f = (state)=>state.router.location;
    const $1c8c7202dc79bdd9$export$c024dd91ea9ad904 = (0, $dGvGJ.createSelector)($1c8c7202dc79bdd9$export$e7fd20fad3cf4b5f, (location)=>`${location.pathname}${location.search}${location.hash}`);
    const $1c8c7202dc79bdd9$export$71eec30d9db46a56 = (0, $dGvGJ.createSelector)($1c8c7202dc79bdd9$export$e7fd20fad3cf4b5f, (0, (0, parcelRequire("9fPrG")).getRoadmapType), (location, roadmapType)=>(0, (0, parcelRequire("9xRvt")).convertStringToQuery)(location.search.replace(/^\?/, ''), roadmapType));
    const $1c8c7202dc79bdd9$export$b70265791d2079d4 = (0, $dGvGJ.createSelector)($1c8c7202dc79bdd9$export$71eec30d9db46a56, (query)=>query.statuses || []);
    const $1c8c7202dc79bdd9$export$faae7c2d4768067b = (0, $dGvGJ.createSelector)($1c8c7202dc79bdd9$export$71eec30d9db46a56, (query)=>query.assignee || []);
    const $1c8c7202dc79bdd9$export$ed2455632bf977ef = (0, $dGvGJ.createSelector)($1c8c7202dc79bdd9$export$71eec30d9db46a56, (query)=>query.issueType || []);
    const $1c8c7202dc79bdd9$export$f81a3ec2bfb3f287 = (0, $dGvGJ.createSelector)($1c8c7202dc79bdd9$export$71eec30d9db46a56, (query)=>query.label || []);
    const $1c8c7202dc79bdd9$export$df9259146e40d32c = (0, $dGvGJ.createSelector)($1c8c7202dc79bdd9$export$71eec30d9db46a56, (query)=>query.issueParent || []);
    const $1c8c7202dc79bdd9$export$cbd9528a83fbffa1 = (0, $dGvGJ.createSelector)($1c8c7202dc79bdd9$export$71eec30d9db46a56, (query)=>query.version || []);
    const $1c8c7202dc79bdd9$export$d79b9fff2c89e8e9 = (0, $dGvGJ.createSelector)($1c8c7202dc79bdd9$export$71eec30d9db46a56, (0, (0, parcelRequire("6thbV")).getGoalsByKeyHash), (query, goals)=>(query.goal || []).map((ari)=>goals[ari]?.goal?.id).filter((id)=>id !== undefined));
    const $1c8c7202dc79bdd9$export$ab702c2371a7d5f8 = (0, $dGvGJ.createSelector)($1c8c7202dc79bdd9$export$d79b9fff2c89e8e9, (goals)=>goals.length > 0);
    const $1c8c7202dc79bdd9$export$5b6701495fa73553 = (0, $dGvGJ.createSelector)($1c8c7202dc79bdd9$export$71eec30d9db46a56, (query)=>query.highlightedVersions || []);
    const $1c8c7202dc79bdd9$export$4e811121b221213b = (0, $dGvGJ.createSelector)($1c8c7202dc79bdd9$export$71eec30d9db46a56, (query)=>query.component || []);
    const $1c8c7202dc79bdd9$export$59e2f55e44eccfa0 = (0, $dGvGJ.createSelector)($1c8c7202dc79bdd9$export$71eec30d9db46a56, (query)=>query.quickFilter || []);
    const $1c8c7202dc79bdd9$export$ada7918f4af738ad = (0, $dGvGJ.createSelector)($1c8c7202dc79bdd9$export$71eec30d9db46a56, (query)=>query.customFilter || []);
    const $1c8c7202dc79bdd9$export$dba384035ff81d88 = (0, $dGvGJ.createSelector)($1c8c7202dc79bdd9$export$59e2f55e44eccfa0, $1c8c7202dc79bdd9$export$ada7918f4af738ad, (quickFilters, customFilters)=>customFilters.length > 0 || quickFilters.length > 0);
    const $1c8c7202dc79bdd9$export$d5d5a91bd9ef0413 = (0, $dGvGJ.createSelector)($1c8c7202dc79bdd9$export$71eec30d9db46a56, (query)=>query.rapidView);
    const $1c8c7202dc79bdd9$export$f4f27837c656f0ef = (0, $dGvGJ.createSelector)($1c8c7202dc79bdd9$export$71eec30d9db46a56, (query)=>query.selectedIssue);
    const $1c8c7202dc79bdd9$export$4f0b76c30f0f3fd5 = (0, $dGvGJ.createSelector)($1c8c7202dc79bdd9$export$71eec30d9db46a56, (query)=>!query.hideDependencies);
    const $1c8c7202dc79bdd9$export$6768efe8b031989d = (0, $dGvGJ.createSelector)($1c8c7202dc79bdd9$export$71eec30d9db46a56, (query)=>!query.hideProgress);
    const $1c8c7202dc79bdd9$export$bb252b79d23fc8f2 = (0, $dGvGJ.createSelector)($1c8c7202dc79bdd9$export$71eec30d9db46a56, (query)=>!query.hideWarnings);
    const $1c8c7202dc79bdd9$export$751544b976770556 = (0, $dGvGJ.createSelector)($1c8c7202dc79bdd9$export$71eec30d9db46a56, (query)=>!query.hideVersionHeader);
    const $1c8c7202dc79bdd9$export$973d2af2aea58feb = (0, $dGvGJ.createSelector)($1c8c7202dc79bdd9$export$71eec30d9db46a56, (query)=>query.shared);
    const $1c8c7202dc79bdd9$export$5f19542fc055e77c = (0, $dGvGJ.createSelector)($1c8c7202dc79bdd9$export$71eec30d9db46a56, (query)=>query.epic);
});
parcelRegister("9xRvt", function(module, exports) {
    $parcel$export(module.exports, "convertQueryToString", ()=>$6df6f8fa648efb13$export$8883f4e93b9ac6a8);
    $parcel$export(module.exports, "convertStringToQuery", ()=>$6df6f8fa648efb13$export$2a2e058f3963d1fc);
    var $6ov1M = parcelRequire("6ov1M");
    var $ebyGx = parcelRequire("ebyGx");
    var $9b550;
    const $6df6f8fa648efb13$var$stringifyValuesList = (value)=>{
        if (Array.isArray(value)) return value.length > 0 ? (0, ($parcel$interopDefault($6ov1M)))(value, ',') : undefined;
        return value || undefined;
    };
    const $6df6f8fa648efb13$export$8883f4e93b9ac6a8 = (query)=>{
        const modOverride = {
            statuses: $6df6f8fa648efb13$var$stringifyValuesList(query.statuses),
            issueType: $6df6f8fa648efb13$var$stringifyValuesList(query.issueType),
            assignee: $6df6f8fa648efb13$var$stringifyValuesList(query.assignee),
            label: $6df6f8fa648efb13$var$stringifyValuesList(query.label),
            issueParent: $6df6f8fa648efb13$var$stringifyValuesList(query.issueParent),
            shared: query.shared ? null : undefined,
            version: $6df6f8fa648efb13$var$stringifyValuesList(query.version),
            component: $6df6f8fa648efb13$var$stringifyValuesList(query.component),
            quickFilter: $6df6f8fa648efb13$var$stringifyValuesList(query.quickFilter),
            customFilter: $6df6f8fa648efb13$var$stringifyValuesList(query.customFilter),
            highlightedVersions: $6df6f8fa648efb13$var$stringifyValuesList(query.highlightedVersions),
            goal: $6df6f8fa648efb13$var$stringifyValuesList(query.goal)
        };
        const mod = {
            ...query,
            ...modOverride
        };
        return (0, ($parcel$interopDefault($ebyGx))).stringify(mod);
    };
    const $6df6f8fa648efb13$export$2a2e058f3963d1fc = (query, roadmapType = (0, $f1ec00c5efd4c816$export$296f840b5ae7056e))=>{
        const parsed = (0, ($parcel$interopDefault($ebyGx))).parse(query);
        return (0, (0, parcelRequire("9b550")).getSanitizedQuery)(parsed, roadmapType);
    };
});
parcelRegister("6ov1M", function(module, exports) {
    var $4a7d0d67f8ea04be$var$arrayProto = Array.prototype;
    var $4a7d0d67f8ea04be$var$nativeJoin = $4a7d0d67f8ea04be$var$arrayProto.join;
    function $4a7d0d67f8ea04be$var$join(array, separator) {
        return array == null ? '' : $4a7d0d67f8ea04be$var$nativeJoin.call(array, separator);
    }
    module.exports = $4a7d0d67f8ea04be$var$join;
});
parcelRegister("9b550", function(module, exports) {
    $parcel$export(module.exports, "getSanitizedQuery", ()=>$fcfc97ebc94694e1$export$6e1abb516904ab3e);
    var $gccSB = parcelRequire("gccSB");
    var $agVdz = parcelRequire("agVdz");
    const $fcfc97ebc94694e1$var$parseValuesList = (value)=>{
        if (value !== undefined && !(0, ($parcel$interopDefault($gccSB)))(value) && (0, ($parcel$interopDefault($agVdz)))(value)) return value.split(',');
        return [];
    };
    const $fcfc97ebc94694e1$var$parseValueBoolean = (value)=>value === 'true' || value === true ? true : undefined;
    const $fcfc97ebc94694e1$export$6e1abb516904ab3e = (parsed, roadmapType)=>{
        const isCMP = roadmapType === (0, $f1ec00c5efd4c816$export$40f914e9a75ff65a);
        const sanitized = {
            projectKey: parsed.projectKey,
            rapidView: parsed.rapidView,
            timeline: parsed.timeline,
            selectedIssue: parsed.selectedIssue,
            text: parsed.text,
            hideDependencies: $fcfc97ebc94694e1$var$parseValueBoolean(parsed.hideDependencies),
            hideProgress: $fcfc97ebc94694e1$var$parseValueBoolean(parsed.hideProgress),
            hideWarnings: $fcfc97ebc94694e1$var$parseValueBoolean(parsed.hideWarnings),
            hideVersionHeader: $fcfc97ebc94694e1$var$parseValueBoolean(parsed.hideVersionHeader),
            epic: parsed.epic,
            statuses: $fcfc97ebc94694e1$var$parseValuesList(parsed.statuses),
            issueType: $fcfc97ebc94694e1$var$parseValuesList(parsed.issueType),
            assignee: $fcfc97ebc94694e1$var$parseValuesList(parsed.assignee),
            label: $fcfc97ebc94694e1$var$parseValuesList(parsed.label),
            issueParent: $fcfc97ebc94694e1$var$parseValuesList(parsed.issueParent),
            version: $fcfc97ebc94694e1$var$parseValuesList(parsed.version),
            component: $fcfc97ebc94694e1$var$parseValuesList(parsed.component),
            highlightedVersions: $fcfc97ebc94694e1$var$parseValuesList(parsed.highlightedVersions),
            shared: 'shared' in parsed,
            quickFilter: isCMP ? $fcfc97ebc94694e1$var$parseValuesList(parsed.quickFilter) : undefined,
            customFilter: !isCMP ? $fcfc97ebc94694e1$var$parseValuesList(parsed.customFilter) : undefined,
            goal: $fcfc97ebc94694e1$var$parseValuesList(parsed.goal)
        };
        return sanitized;
    };
});
parcelRegister("9fPrG", function(module, exports) {
    $parcel$export(module.exports, "getLoggedInAccountId", ()=>$f6e1e91b67520fcd$export$846c7c52537933ac);
    $parcel$export(module.exports, "getCloudId", ()=>$f6e1e91b67520fcd$export$fdd2c0ba94025c3c);
    $parcel$export(module.exports, "getActivationId", ()=>$f6e1e91b67520fcd$export$3ad4bb31a1816ff6);
    $parcel$export(module.exports, "getIsReadOnly", ()=>$f6e1e91b67520fcd$export$1fc90e957d653067);
    $parcel$export(module.exports, "getSourceARI", ()=>$f6e1e91b67520fcd$export$c0b7eb9c66c63628);
    $parcel$export(module.exports, "getBoardId", ()=>$f6e1e91b67520fcd$export$557c2f222778cea6);
    $parcel$export(module.exports, "hasMacroConfig", ()=>$f6e1e91b67520fcd$export$91384e8db69910af);
    $parcel$export(module.exports, "getMacroHideHeader", ()=>$f6e1e91b67520fcd$export$f9526ccea455c4f4);
    $parcel$export(module.exports, "getContainerName", ()=>$f6e1e91b67520fcd$export$d471dcb7d994b2a4);
    $parcel$export(module.exports, "getRoadmapType", ()=>$f6e1e91b67520fcd$export$6bcd10888326ba19);
    $parcel$export(module.exports, "isClassic", ()=>$f6e1e91b67520fcd$export$bb674e1910e1b216);
    $parcel$export(module.exports, "shouldUseQuickFilters", ()=>$f6e1e91b67520fcd$export$88699d4b7a7a02a0);
    $parcel$export(module.exports, "shouldUseCustomFilters", ()=>$f6e1e91b67520fcd$export$8019dd71e3c6ed2d);
    var $dGvGJ = parcelRequire("dGvGJ");
    const $f6e1e91b67520fcd$export$846c7c52537933ac = (state)=>state.app.loggedInAccountId;
    const $f6e1e91b67520fcd$export$fdd2c0ba94025c3c = (state)=>state.app.cloudId;
    const $f6e1e91b67520fcd$export$3ad4bb31a1816ff6 = (state)=>state.app.activationId;
    const $f6e1e91b67520fcd$export$1fc90e957d653067 = (state)=>state.app.isReadOnly;
    const $f6e1e91b67520fcd$export$c0b7eb9c66c63628 = (state)=>state.app.sourceAri;
    const $f6e1e91b67520fcd$export$557c2f222778cea6 = (state)=>state.app.boardId;
    const $f6e1e91b67520fcd$export$24be09ac26544799 = (state)=>state.app.macroConfig;
    const $f6e1e91b67520fcd$export$91384e8db69910af = (0, $dGvGJ.createSelector)($f6e1e91b67520fcd$export$24be09ac26544799, (macroConfig)=>Boolean(macroConfig));
    const $f6e1e91b67520fcd$export$f9526ccea455c4f4 = (0, $dGvGJ.createSelector)($f6e1e91b67520fcd$export$24be09ac26544799, (macroConfig)=>Boolean(macroConfig && macroConfig.hideHeader));
    const $f6e1e91b67520fcd$export$d471dcb7d994b2a4 = (state)=>state.app.containerName;
    const $f6e1e91b67520fcd$export$6bcd10888326ba19 = (state)=>state.app.type;
    const $f6e1e91b67520fcd$export$bb674e1910e1b216 = (0, $dGvGJ.createSelector)($f6e1e91b67520fcd$export$6bcd10888326ba19, (type)=>type === (0, $f1ec00c5efd4c816$export$40f914e9a75ff65a));
    const $f6e1e91b67520fcd$export$88699d4b7a7a02a0 = (state)=>state.app.type === (0, $f1ec00c5efd4c816$export$40f914e9a75ff65a);
    const $f6e1e91b67520fcd$export$8019dd71e3c6ed2d = (state)=>state.app.type === (0, $f1ec00c5efd4c816$export$296f840b5ae7056e);
});
parcelRegister("5IiTZ", function(module, exports) {
    $parcel$export(module.exports, "getStoredTimelineFilter", ()=>$8dad4b703e8c9590$export$ed161c26e81cde84);
    $parcel$export(module.exports, "getListWidth", ()=>$8dad4b703e8c9590$export$546faffca0a891d);
    $parcel$export(module.exports, "getCreationPreferences", ()=>$8dad4b703e8c9590$export$d5ca17246c80d2c8);
    $parcel$export(module.exports, "getHighlightedVersionsInSettings", ()=>$8dad4b703e8c9590$export$b33d9f325ade8c9b);
    $parcel$export(module.exports, "getIssuePanelRatio", ()=>$8dad4b703e8c9590$export$aea41387f8aebc6f);
    const $8dad4b703e8c9590$export$ed161c26e81cde84 = (state)=>state.settings.timelineMode;
    const $8dad4b703e8c9590$export$546faffca0a891d = (state)=>state.settings.listWidth;
    const $8dad4b703e8c9590$export$d5ca17246c80d2c8 = (state)=>state.settings.creationPreferences;
    const $8dad4b703e8c9590$export$b33d9f325ade8c9b = (state)=>state.settings.highlightedVersions;
    const $8dad4b703e8c9590$export$aea41387f8aebc6f = (state)=>state.settings.issuePanelRatio;
});
parcelRegister("2VUTz", function(module, exports) {
    $parcel$export(module.exports, "isDependenciesVisibleInView", ()=>$54fcd8357609da92$export$962f58efc6e07e87);
    $parcel$export(module.exports, "isProgressVisibleInView", ()=>$54fcd8357609da92$export$75bdd64d01e19367);
    $parcel$export(module.exports, "isWarningsVisibleInView", ()=>$54fcd8357609da92$export$767253e2fd89204c);
    $parcel$export(module.exports, "isReleasesVisibleInView", ()=>$54fcd8357609da92$export$6e3f0e22409097be);
    $parcel$export(module.exports, "getLevelOneSettingInView", ()=>$54fcd8357609da92$export$d502ece6c0972ba1);
    const $54fcd8357609da92$export$962f58efc6e07e87 = (state)=>state.ui.views.isDependenciesVisible;
    const $54fcd8357609da92$export$75bdd64d01e19367 = (state)=>state.ui.views.isProgressVisible;
    const $54fcd8357609da92$export$767253e2fd89204c = (state)=>state.ui.views.isWarningsVisible;
    const $54fcd8357609da92$export$6e3f0e22409097be = (state)=>state.ui.views.isReleasesVisible;
    const $54fcd8357609da92$export$d502ece6c0972ba1 = (state)=>state.ui.views.levelOneViewSettings;
});
parcelRegister("9hAGg", function(module, exports) {
    $parcel$export(module.exports, "getSanitisedIssueComponentIdsHash", ()=>$9e93ce104e448b62$export$3731ad97e9be4c92);
    $parcel$export(module.exports, "getUniqueComponents", ()=>$9e93ce104e448b62$export$16a540615fa7c203);
    $parcel$export(module.exports, "getComponents", ()=>$9e93ce104e448b62$export$4e811121b221213b);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $cKS6s;
    var $4gYYI;
    var $hFyhA;
    var $fZGrk;
    const $9e93ce104e448b62$export$3731ad97e9be4c92 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("hFyhA")).getIssueComponentIdsHash), (0, (0, parcelRequire("4gYYI")).getFullComponentHash), (0, (0, parcelRequire("fZGrk")).createGetSanitisedIssueComponentIdsHash));
    const $9e93ce104e448b62$export$16a540615fa7c203 = (0, $dGvGJ.createSelector)($9e93ce104e448b62$export$3731ad97e9be4c92, (0, (0, parcelRequire("fZGrk")).createGetUniqueComponents));
    const $9e93ce104e448b62$export$4e811121b221213b = (0, (0, parcelRequire("cKS6s")).createSelectorWithDefaultEqual)($9e93ce104e448b62$export$16a540615fa7c203, (0, (0, parcelRequire("4gYYI")).getFullComponentHash), (0, (0, parcelRequire("fZGrk")).createGetComponents));
});
parcelRegister("fZGrk", function(module, exports) {
    $parcel$export(module.exports, "createGetSanitisedIssueComponentIdsHash", ()=>$57513c72f7693655$export$f42e04a8615077a5);
    $parcel$export(module.exports, "createGetUniqueComponents", ()=>$57513c72f7693655$export$ab5c9aa3d05bf5d2);
    $parcel$export(module.exports, "createGetComponents", ()=>$57513c72f7693655$export$9a82eb1ebd237ecc);
    var $183uB = parcelRequire("183uB");
    var $kGsr8 = parcelRequire("kGsr8");
    const $57513c72f7693655$export$f42e04a8615077a5 = (issueComponentIdsHash, allComponentsHash)=>Object.keys(issueComponentIdsHash).reduce((acc, key)=>{
            const componentIds = issueComponentIdsHash[key];
            acc[key] = componentIds.filter((componentId)=>Boolean(allComponentsHash[componentId]));
            return acc;
        }, {});
    const $57513c72f7693655$export$ab5c9aa3d05bf5d2 = (issueComponentsHash)=>{
        const allComponents = (0, ($parcel$interopDefault($183uB)))(Object.keys(issueComponentsHash).map((key)=>{
            const issueComponents = issueComponentsHash[key] || [];
            return issueComponents;
        }));
        const uniqueComponents = (0, ($parcel$interopDefault($kGsr8)))(allComponents);
        return uniqueComponents.length ? [
            (0, $15a528573ccd89ae$export$4b7c755e61199a36),
            ...uniqueComponents
        ] : uniqueComponents;
    };
    const $57513c72f7693655$export$9a82eb1ebd237ecc = (uniqueComponents, componentsHash)=>{
        const components = [];
        uniqueComponents.forEach((componentId)=>{
            const component = componentsHash[componentId];
            component && components.push(component);
        });
        return components.sort((componentA, componentB)=>componentA.name.toLowerCase() < componentB.name.toLowerCase() ? -1 : 1);
    };
});
const $15a528573ccd89ae$export$d597759d33be802e = 'TEXT';
const $15a528573ccd89ae$export$f8f7545d2bb78afb = 'ASSIGNEE';
const $15a528573ccd89ae$export$37aee82a3cb1e8f7 = 'LABEL';
const $15a528573ccd89ae$export$2a4f270075a033de = 'ISSUE_PARENT';
const $15a528573ccd89ae$export$401f4b6eda6a369c = 'ISSUE_PROJECT';
const $15a528573ccd89ae$export$ebb48b08205007c5 = 'ISSUE_TYPE';
const $15a528573ccd89ae$export$a4ad2735b021c132 = 'VERSION';
const $15a528573ccd89ae$export$af1e30ebbae9df3b = 'COMPONENT';
const $15a528573ccd89ae$export$f863b019d19144f4 = 'STATUS_CATEGORY';
const $15a528573ccd89ae$export$a316570a0dbfd2b0 = 'SPRINT';
const $15a528573ccd89ae$export$e50006273435e7d4 = 'STATUS';
const $15a528573ccd89ae$export$92ab80c1dc9baf44 = 'REQUEST_TYPE';
const $15a528573ccd89ae$export$68d693c35a8d8866 = 'CUSTOM_FILTER';
const $15a528573ccd89ae$export$1ea95b94fb0c51d9 = 'QUICK_FILTER';
const $15a528573ccd89ae$export$871e58afc769b358 = 'GOAL';
const $15a528573ccd89ae$export$6c4d37c7f376a1de = 'CLEAR';
const $15a528573ccd89ae$export$db362e2d293fe52e = 'DEPENDENCIES';
const $15a528573ccd89ae$export$12e572fd459c10dc = 'unassigned';
const $15a528573ccd89ae$export$ac95b4b2317d4b33 = 'unassigned';
const $15a528573ccd89ae$export$81ef49afbbead0a1 = 'label unassigned';
const $15a528573ccd89ae$export$4b7c755e61199a36 = 'unassigned';
const $15a528573ccd89ae$export$c9408e3fb31ddc71 = 'offline';
const $15a528573ccd89ae$export$7a105aa475396c65 = 'online';
parcelRegister("fayLA", function(module, exports) {
    $parcel$export(module.exports, "getLabels", ()=>$02cb8e2bcf9ee86e$export$f81a3ec2bfb3f287);
    $parcel$export(module.exports, "getLabelsWithUnassignedOption", ()=>$02cb8e2bcf9ee86e$export$849c9376495979c4);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $183uB = parcelRequire("183uB");
    var $kGsr8 = parcelRequire("kGsr8");
    var $cKS6s;
    var $hFyhA;
    const $02cb8e2bcf9ee86e$var$getUniqueLabels = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("hFyhA")).getIssueLabelsHash), (issueLabelsHash)=>{
        const allLabels = (0, ($parcel$interopDefault($183uB)))(Object.keys(issueLabelsHash).map((key)=>{
            const issueLabels = issueLabelsHash[key] || [];
            return issueLabels;
        }));
        return (0, ($parcel$interopDefault($kGsr8)))(allLabels).sort();
    });
    const $02cb8e2bcf9ee86e$export$f81a3ec2bfb3f287 = (0, (0, parcelRequire("cKS6s")).createSelectorWithDefaultEqual)($02cb8e2bcf9ee86e$var$getUniqueLabels, (labels)=>labels);
    const $02cb8e2bcf9ee86e$export$849c9376495979c4 = (0, (0, parcelRequire("cKS6s")).createSelectorWithDefaultEqual)($02cb8e2bcf9ee86e$var$getUniqueLabels, (labels)=>labels.length ? [
            (0, $15a528573ccd89ae$export$81ef49afbbead0a1),
            ...labels
        ] : labels);
});
parcelRegister("3rLbe", function(module, exports) {
    $parcel$export(module.exports, "getSanitisedIssueVersionIdsHash", ()=>$ebb08dbbdad27a8c$export$c9041494b04fb60e);
    $parcel$export(module.exports, "getUniqueVersions", ()=>$ebb08dbbdad27a8c$export$f7cc858d2c3e2ed1);
    $parcel$export(module.exports, "getVersionsForFilter", ()=>$ebb08dbbdad27a8c$export$9cf24bc3913525f6);
    $parcel$export(module.exports, "getVersionIdsForFilter", ()=>$ebb08dbbdad27a8c$export$816050db139173ae);
    $parcel$export(module.exports, "createGetVersionsForKeyDates", ()=>$ebb08dbbdad27a8c$export$57b36ea5b0cba889);
    $parcel$export(module.exports, "getIsReleasesVisible", ()=>$ebb08dbbdad27a8c$export$1bd9547a6769d327);
    $parcel$export(module.exports, "getHighlightedVersions", ()=>$ebb08dbbdad27a8c$export$a46fe3951b75c931);
    $parcel$export(module.exports, "getHighlightedKeyDates", ()=>$ebb08dbbdad27a8c$export$fbd707cc0b3c1c08);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $cKS6s;
    var $4gYYI;
    var $hFyhA;
    var $fWch8;
    var $5IiTZ;
    var $2VUTz;
    var $6BxcZ;
    const $ebb08dbbdad27a8c$export$c9041494b04fb60e = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("hFyhA")).getIssueVersionIdsHash), (0, (0, parcelRequire("4gYYI")).getFullVersionHash), (0, (0, parcelRequire("6BxcZ")).createGetSanitisedIssueVersionIdsHash));
    const $ebb08dbbdad27a8c$export$f7cc858d2c3e2ed1 = (0, $dGvGJ.createSelector)($ebb08dbbdad27a8c$export$c9041494b04fb60e, (0, (0, parcelRequire("6BxcZ")).createGetUniqueVersions));
    const $ebb08dbbdad27a8c$export$9cf24bc3913525f6 = (0, (0, parcelRequire("cKS6s")).createSelectorWithDefaultEqual)($ebb08dbbdad27a8c$export$f7cc858d2c3e2ed1, (0, (0, parcelRequire("4gYYI")).getFullVersionHash), (0, (0, parcelRequire("6BxcZ")).createGetVersionsForFilter));
    const $ebb08dbbdad27a8c$export$816050db139173ae = (0, $dGvGJ.createSelector)($ebb08dbbdad27a8c$export$9cf24bc3913525f6, (versionsForFilter)=>versionsForFilter.map(({ id: id })=>id));
    const $ebb08dbbdad27a8c$export$57b36ea5b0cba889 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("4gYYI")).getFullVersionHash), (0, (0, parcelRequire("6BxcZ")).createGetVersionsForKeyDates));
    const $ebb08dbbdad27a8c$export$1bd9547a6769d327 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("4gYYI")).getIsReleasesFeatureEnabled), (0, (0, parcelRequire("fWch8")).isReleasesVisibleInQuery), (0, (0, parcelRequire("2VUTz")).isReleasesVisibleInView), (isReleaseFeatureEnable, isVisibleInQuery, isVisibleInView)=>!isReleaseFeatureEnable || !isVisibleInQuery ? false : isVisibleInView);
    const $ebb08dbbdad27a8c$var$EMPTY_ARRAY = [];
    const $ebb08dbbdad27a8c$export$a46fe3951b75c931 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("fWch8")).getHighlightedVersionsInQuery), (0, (0, parcelRequire("5IiTZ")).getHighlightedVersionsInSettings), $ebb08dbbdad27a8c$export$1bd9547a6769d327, (settingFromQuery, settingFromStore, isReleasesVisible)=>{
        if (!isReleasesVisible) return $ebb08dbbdad27a8c$var$EMPTY_ARRAY;
        return settingFromQuery.length > 0 ? settingFromQuery : settingFromStore;
    });
    const $ebb08dbbdad27a8c$export$fbd707cc0b3c1c08 = (0, $dGvGJ.createSelector)($ebb08dbbdad27a8c$export$a46fe3951b75c931, (highlightedVersions)=>highlightedVersions.map((version)=>version.toString()));
});
parcelRegister("6BxcZ", function(module, exports) {
    $parcel$export(module.exports, "createGetSanitisedIssueVersionIdsHash", ()=>$77b4da1564b0b528$export$7325f5903240ab1);
    $parcel$export(module.exports, "createGetUniqueVersions", ()=>$77b4da1564b0b528$export$e9b6ecb0558048b);
    $parcel$export(module.exports, "createGetVersionsForFilter", ()=>$77b4da1564b0b528$export$a928e57bd88fafd9);
    $parcel$export(module.exports, "createGetVersionsForKeyDates", ()=>$77b4da1564b0b528$export$57b36ea5b0cba889);
    var $183uB = parcelRequire("183uB");
    var $kGsr8 = parcelRequire("kGsr8");
    var $8QpSo;
    var $5SuOw;
    const $77b4da1564b0b528$export$7325f5903240ab1 = (issueVersionIdsHash, allVersionsHash)=>{
        const result = {};
        Object.keys(issueVersionIdsHash).forEach((issueId)=>{
            const versionIds = issueVersionIdsHash[issueId];
            result[issueId] = versionIds.filter((versionId)=>Boolean(allVersionsHash[versionId]));
        });
        return result;
    };
    const $77b4da1564b0b528$export$e9b6ecb0558048b = (issueVersionsHash)=>{
        const allVersions = (0, ($parcel$interopDefault($183uB)))(Object.keys(issueVersionsHash).map((key)=>{
            const issueVersions = issueVersionsHash[key] || [];
            return issueVersions;
        }));
        const uniqueVersions = (0, ($parcel$interopDefault($kGsr8)))(allVersions);
        return uniqueVersions.length ? [
            (0, $15a528573ccd89ae$export$ac95b4b2317d4b33),
            ...uniqueVersions
        ] : uniqueVersions;
    };
    const $77b4da1564b0b528$export$a928e57bd88fafd9 = (uniqueVersions, versionsHash)=>{
        const versions = [];
        uniqueVersions.forEach((versionId)=>{
            const version = versionsHash[versionId];
            if (version) versions.push({
                id: versionId,
                name: version.name
            });
        });
        return versions.sort((versionA, versionB)=>versionA.name.toLowerCase() < versionB.name.toLowerCase() ? -1 : 1);
    };
    const $77b4da1564b0b528$export$57b36ea5b0cba889 = (versionsHash)=>(0, (0, parcelRequire("8QpSo")).default)((today)=>{
            const keyDates = [];
            const STATUS_MAP = {
                [(0, $d001bb30fd795cf6$export$cb459d726a8530a5)]: (0, (0, parcelRequire("5SuOw")).IN_PROGRESS),
                [(0, $d001bb30fd795cf6$export$b983f2cb1f658a55)]: (0, (0, parcelRequire("5SuOw")).COMPLETED)
            };
            Object.keys(versionsHash).forEach((versionId)=>{
                const version = versionsHash[versionId];
                if (version.releaseDate !== undefined) keyDates.push({
                    id: versionId,
                    name: version.name,
                    date: version.releaseDate,
                    status: version.status === (0, $d001bb30fd795cf6$export$cb459d726a8530a5) && version.releaseDate < today ? (0, (0, parcelRequire("5SuOw")).WARNING) : STATUS_MAP[version.status]
                });
            });
            return keyDates;
        });
});
const $d001bb30fd795cf6$export$b983f2cb1f658a55 = 'RELEASED';
const $d001bb30fd795cf6$export$cb459d726a8530a5 = 'UNRELEASED';
parcelRegister("5SuOw", function(module, exports) {
    $parcel$export(module.exports, "MARKER_WIDTH", ()=>$f69c906e661218b6$export$4a6351d766d85076);
    $parcel$export(module.exports, "MARKER_WIDTH_WITH_SPACE", ()=>$f69c906e661218b6$export$95fcddab5858cd42);
    $parcel$export(module.exports, "MARKER_BORDER_WIDTH", ()=>$f69c906e661218b6$export$ff01cdc3aad1196);
    $parcel$export(module.exports, "COMPLETED", ()=>$f69c906e661218b6$export$fc332a617fd34192);
    $parcel$export(module.exports, "IN_PROGRESS", ()=>$f69c906e661218b6$export$5a9ac66c2785cc13);
    $parcel$export(module.exports, "WARNING", ()=>$f69c906e661218b6$export$64fdd419ec8dbc36);
    $parcel$export(module.exports, "MARKER_COLORS", ()=>$f69c906e661218b6$export$d4060d4eb5ad0b29);
    $parcel$export(module.exports, "STATUS_PRIORITY", ()=>$f69c906e661218b6$export$dc65af84169ff7fb);
    var $gwIPs;
    const $f69c906e661218b6$export$4a6351d766d85076 = (0, (0, parcelRequire("gwIPs")).gridSize) * 2.5;
    const $f69c906e661218b6$export$95fcddab5858cd42 = $f69c906e661218b6$export$4a6351d766d85076 + (0, (0, parcelRequire("gwIPs")).gridSize) * 2;
    const $f69c906e661218b6$export$ff01cdc3aad1196 = 2;
    const $f69c906e661218b6$export$fc332a617fd34192 = 'COMPLETED';
    const $f69c906e661218b6$export$5a9ac66c2785cc13 = 'IN_PROGRESS';
    const $f69c906e661218b6$export$64fdd419ec8dbc36 = 'WARNING';
    const $f69c906e661218b6$export$d4060d4eb5ad0b29 = {
        [$f69c906e661218b6$export$fc332a617fd34192]: `var(--ds-icon-success, ${(0, $829f609a65d26a98$export$a49394138f7b8e85)})`,
        [$f69c906e661218b6$export$5a9ac66c2785cc13]: `var(--ds-icon-information, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
        [$f69c906e661218b6$export$64fdd419ec8dbc36]: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`
    };
    const $f69c906e661218b6$export$dc65af84169ff7fb = {
        [$f69c906e661218b6$export$fc332a617fd34192]: 0,
        [$f69c906e661218b6$export$5a9ac66c2785cc13]: 1,
        [$f69c906e661218b6$export$64fdd419ec8dbc36]: 2
    };
});
var $829f609a65d26a98$exports = {};
$parcel$export($829f609a65d26a98$exports, "R50", ()=>$829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", ()=>$829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", ()=>$829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", ()=>$829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", ()=>$829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", ()=>$829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", ()=>$829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", ()=>$829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", ()=>$829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", ()=>$829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", ()=>$829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", ()=>$829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", ()=>$829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", ()=>$829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", ()=>$829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", ()=>$829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", ()=>$829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", ()=>$829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", ()=>$829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", ()=>$829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", ()=>$829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", ()=>$829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", ()=>$829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", ()=>$829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", ()=>$829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", ()=>$829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", ()=>$829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", ()=>$829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", ()=>$829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", ()=>$829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", ()=>$829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", ()=>$829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", ()=>$829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", ()=>$829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", ()=>$829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", ()=>$829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", ()=>$829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", ()=>$829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", ()=>$829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", ()=>$829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", ()=>$829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", ()=>$829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", ()=>$829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", ()=>$829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", ()=>$829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", ()=>$829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", ()=>$829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", ()=>$829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", ()=>$829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", ()=>$829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", ()=>$829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", ()=>$829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", ()=>$829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", ()=>$829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", ()=>$829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", ()=>$829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", ()=>$829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", ()=>$829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", ()=>$829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", ()=>$829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", ()=>$829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", ()=>$829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", ()=>$829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", ()=>$829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", ()=>$829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", ()=>$829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", ()=>$829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", ()=>$829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", ()=>$829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", ()=>$829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", ()=>$829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", ()=>$829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", ()=>$829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", ()=>$829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", ()=>$829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", ()=>$829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", ()=>$829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", ()=>$829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", ()=>$829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", ()=>$829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", ()=>$829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", ()=>$829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", ()=>$829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", ()=>$829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", ()=>$829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", ()=>$829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", ()=>$829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", ()=>$829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", ()=>$829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", ()=>$829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", ()=>$829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", ()=>$829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", ()=>$829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", ()=>$829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", ()=>$829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", ()=>$829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", ()=>$829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", ()=>$829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", ()=>$829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", ()=>$829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", ()=>$829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", ()=>$829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", ()=>$829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", ()=>$829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", ()=>$829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", ()=>$829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", ()=>$829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", ()=>$829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", ()=>$829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", ()=>$829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", ()=>$829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", ()=>$829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", ()=>$829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", ()=>$829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", ()=>$829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", ()=>$829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", ()=>$829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", ()=>$829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", ()=>$829f609a65d26a98$export$95e26d54def96891);
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';
parcelRegister("6kR2l", function(module, exports) {
    $parcel$export(module.exports, "createGetFilteredLabels", ()=>$f73c1e55de90262a$export$34da06a4ab395581);
    $parcel$export(module.exports, "createGetFilteredIssueParents", ()=>$f73c1e55de90262a$export$e5d358399bc5243b);
    $parcel$export(module.exports, "createGetFilteredVersions", ()=>$f73c1e55de90262a$export$33674feb2de63df5);
    $parcel$export(module.exports, "createGetFilteredComponents", ()=>$f73c1e55de90262a$export$1dc75016ff1b6891);
    $parcel$export(module.exports, "getChildIssueTypesPure", ()=>$f73c1e55de90262a$export$9edede936285e654);
    $parcel$export(module.exports, "getLevelOneSettingPure", ()=>$f73c1e55de90262a$export$4e27d35a1d765a6e);
    $parcel$export(module.exports, "createGetFilteredGoals", ()=>$f73c1e55de90262a$export$d8b78e7f68a52ee1);
    $parcel$export(module.exports, "createGetFilteredGoalIssueIds", ()=>$f73c1e55de90262a$export$7fca3aa3660623b6);
    var $4wVpT = parcelRequire("4wVpT");
    var $dDkmN = parcelRequire("dDkmN");
    var $l4LVp;
    const $f73c1e55de90262a$export$34da06a4ab395581 = (labels, uniqueLabels)=>(0, ($parcel$interopDefault($4wVpT)))(labels, uniqueLabels);
    const $f73c1e55de90262a$export$e5d358399bc5243b = (issueParents, uniqueIssueParents)=>(0, ($parcel$interopDefault($4wVpT)))(issueParents, uniqueIssueParents);
    const $f73c1e55de90262a$export$33674feb2de63df5 = (versions, uniqueVersions)=>(0, ($parcel$interopDefault($4wVpT)))(versions, uniqueVersions);
    const $f73c1e55de90262a$export$1dc75016ff1b6891 = (components, uniqueComponents)=>(0, ($parcel$interopDefault($4wVpT)))(components, uniqueComponents);
    const $f73c1e55de90262a$export$9edede936285e654 = (issueTypesHash, epicIssueTypeIds)=>{
        const issueTypes = [];
        Object.keys(issueTypesHash).forEach((issueTypeId)=>{
            if (!epicIssueTypeIds.includes(issueTypeId)) {
                const issueType = issueTypesHash[issueTypeId];
                issueTypes.push({
                    id: issueTypeId,
                    name: issueType.name,
                    iconUrl: issueType.iconUrl
                });
            }
        });
        return issueTypes;
    };
    const $f73c1e55de90262a$export$4e27d35a1d765a6e = (settingFromQuery, settingFromStore)=>{
        if (settingFromQuery !== undefined && settingFromStore !== undefined) {
            const period = settingFromQuery === (0, (0, parcelRequire("l4LVp")).INCOMPLETE) ? settingFromStore.period : (0, (0, parcelRequire("l4LVp")).levelOneQuerySettingsToPeriodMap).get(settingFromQuery) || 12;
            return {
                period: period,
                showCompleted: settingFromQuery !== (0, (0, parcelRequire("l4LVp")).INCOMPLETE)
            };
        }
        return settingFromStore;
    };
    const $f73c1e55de90262a$export$d8b78e7f68a52ee1 = (goals, uniqueGoals)=>(0, ($parcel$interopDefault($4wVpT)))(goals, uniqueGoals);
    const $f73c1e55de90262a$export$7fca3aa3660623b6 = (filteredGoals, goals, childrenHash)=>{
        const parentIssues = (0, ($parcel$interopDefault($dDkmN)))(...filteredGoals.map((goalId)=>goals[goalId].issueIds));
        return (0, ($parcel$interopDefault($dDkmN)))(parentIssues, ...parentIssues.map((issueId)=>childrenHash[issueId] ?? []));
    };
});
parcelRegister("4wVpT", function(module, exports) {
    var $1nIHN = parcelRequire("1nIHN");
    var $9dThv = parcelRequire("9dThv");
    var $g7i7g = parcelRequire("g7i7g");
    var $d9Hx6 = parcelRequire("d9Hx6");
    var $34c6b050456654f8$var$intersection = $g7i7g(function(arrays) {
        var mapped = $1nIHN(arrays, $d9Hx6);
        return mapped.length && mapped[0] === arrays[0] ? $9dThv(mapped) : [];
    });
    module.exports = $34c6b050456654f8$var$intersection;
});
parcelRegister("9dThv", function(module, exports) {
    var $ijRUK = parcelRequire("ijRUK");
    var $fUP98 = parcelRequire("fUP98");
    var $dA3tP = parcelRequire("dA3tP");
    var $1nIHN = parcelRequire("1nIHN");
    var $cW28x = parcelRequire("cW28x");
    var $40I25 = parcelRequire("40I25");
    var $6b7035a795ecd274$var$nativeMin = Math.min;
    function $6b7035a795ecd274$var$baseIntersection(arrays, iteratee, comparator) {
        var includes = comparator ? $dA3tP : $fUP98, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array(othLength), maxLength = Infinity, result = [];
        while(othIndex--){
            var array = arrays[othIndex];
            if (othIndex && iteratee) array = $1nIHN(array, $cW28x(iteratee));
            maxLength = $6b7035a795ecd274$var$nativeMin(array.length, maxLength);
            caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new $ijRUK(othIndex && array) : undefined;
        }
        array = arrays[0];
        var index = -1, seen = caches[0];
        outer: while(++index < length && result.length < maxLength){
            var value = array[index], computed = iteratee ? iteratee(value) : value;
            value = comparator || value !== 0 ? value : 0;
            if (!(seen ? $40I25(seen, computed) : includes(result, computed, comparator))) {
                othIndex = othLength;
                while(--othIndex){
                    var cache = caches[othIndex];
                    if (!(cache ? $40I25(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                }
                if (seen) seen.push(computed);
                result.push(value);
            }
        }
        return result;
    }
    module.exports = $6b7035a795ecd274$var$baseIntersection;
});
parcelRegister("d9Hx6", function(module, exports) {
    var $f3SOL = parcelRequire("f3SOL");
    function $993de25d5a02863a$var$castArrayLikeObject(value) {
        return $f3SOL(value) ? value : [];
    }
    module.exports = $993de25d5a02863a$var$castArrayLikeObject;
});
parcelRegister("dDkmN", function(module, exports) {
    var $ekcP3 = parcelRequire("ekcP3");
    var $g7i7g = parcelRequire("g7i7g");
    var $7CoLY = parcelRequire("7CoLY");
    var $f3SOL = parcelRequire("f3SOL");
    var $9eceb74c74389aa2$var$union = $g7i7g(function(arrays) {
        return $7CoLY($ekcP3(arrays, 1, $f3SOL, true));
    });
    module.exports = $9eceb74c74389aa2$var$union;
});
parcelRegister("l4LVp", function(module, exports) {
    $parcel$export(module.exports, "INCOMPLETE", ()=>$80da47aa3bbe3d9a$export$21a64a0a80457a5c);
    $parcel$export(module.exports, "periodToLevelOneQuerySettingsMap", ()=>$80da47aa3bbe3d9a$export$ff5c9debc121d4e5);
    $parcel$export(module.exports, "levelOneQuerySettingsToPeriodMap", ()=>$80da47aa3bbe3d9a$export$a820040c0626dd2d);
    $parcel$export(module.exports, "DEFAULT_LEVEL_ONE_VIEW_SETTINGS", ()=>$80da47aa3bbe3d9a$export$2aa5f7d521c704eb);
    const $80da47aa3bbe3d9a$export$21a64a0a80457a5c = 'INCOMPLETE';
    const $80da47aa3bbe3d9a$export$436621b04568a6f7 = 'COMPLETE1M';
    const $80da47aa3bbe3d9a$export$9c18cd7ad055218c = 'COMPLETE3M';
    const $80da47aa3bbe3d9a$export$fd408a62c645a1e5 = 'COMPLETE6M';
    const $80da47aa3bbe3d9a$export$8ce4d04150556a2c = 'COMPLETE9M';
    const $80da47aa3bbe3d9a$export$1f98274aa749e679 = 'COMPLETE12M';
    const $80da47aa3bbe3d9a$export$ff5c9debc121d4e5 = new Map([
        [
            12,
            $80da47aa3bbe3d9a$export$1f98274aa749e679
        ],
        [
            9,
            $80da47aa3bbe3d9a$export$8ce4d04150556a2c
        ],
        [
            6,
            $80da47aa3bbe3d9a$export$fd408a62c645a1e5
        ],
        [
            3,
            $80da47aa3bbe3d9a$export$9c18cd7ad055218c
        ],
        [
            1,
            $80da47aa3bbe3d9a$export$436621b04568a6f7
        ]
    ]);
    const $80da47aa3bbe3d9a$export$a820040c0626dd2d = new Map([
        [
            $80da47aa3bbe3d9a$export$1f98274aa749e679,
            12
        ],
        [
            $80da47aa3bbe3d9a$export$8ce4d04150556a2c,
            9
        ],
        [
            $80da47aa3bbe3d9a$export$fd408a62c645a1e5,
            6
        ],
        [
            $80da47aa3bbe3d9a$export$9c18cd7ad055218c,
            3
        ],
        [
            $80da47aa3bbe3d9a$export$436621b04568a6f7,
            1
        ]
    ]);
    const $80da47aa3bbe3d9a$export$2aa5f7d521c704eb = {
        showCompleted: true,
        period: 12
    };
});
parcelRegister("ilGit", function(module, exports) {
    $parcel$export(module.exports, "SET_DEPENDENCIES_VIEW_VISIBILITY", ()=>$313a6508e415ded9$export$1a16e905a7747be);
    $parcel$export(module.exports, "setDependenciesViewVisibility", ()=>$313a6508e415ded9$export$d9343ff84626d4c8);
    $parcel$export(module.exports, "SET_PROGRESS_VISIBILITY", ()=>$313a6508e415ded9$export$2e2e698a832d1a63);
    $parcel$export(module.exports, "setProgressVisibility", ()=>$313a6508e415ded9$export$53320a7a4c26a8ad);
    $parcel$export(module.exports, "SET_WARNINGS_VISIBILITY", ()=>$313a6508e415ded9$export$fc6caf89a567b8b1);
    $parcel$export(module.exports, "setWarningsVisibility", ()=>$313a6508e415ded9$export$97d3304d96905fb0);
    $parcel$export(module.exports, "SET_RELEASES_VISIBILITY", ()=>$313a6508e415ded9$export$44a92bc1a269f215);
    $parcel$export(module.exports, "setReleasesVisibility", ()=>$313a6508e415ded9$export$fdec3e0865bc1066);
    $parcel$export(module.exports, "SET_LEVEL_ONE_SETTING", ()=>$313a6508e415ded9$export$5847d71ec22dc665);
    $parcel$export(module.exports, "setLevelOneSetting", ()=>$313a6508e415ded9$export$1542a36683289b9c);
    $parcel$export(module.exports, "clearLevelOneSetting", ()=>$313a6508e415ded9$export$556a2127816d096d);
    var $l4LVp;
    const $313a6508e415ded9$export$1a16e905a7747be = 'state.ui.views.SET_DEPENDENCIES_VIEW_VISIBILITY';
    const $313a6508e415ded9$export$d9343ff84626d4c8 = (payload)=>({
            type: $313a6508e415ded9$export$1a16e905a7747be,
            payload: payload
        });
    const $313a6508e415ded9$export$2e2e698a832d1a63 = 'state.ui.views.SET_PROGRESS_VISIBILITY';
    const $313a6508e415ded9$export$53320a7a4c26a8ad = (payload)=>({
            type: $313a6508e415ded9$export$2e2e698a832d1a63,
            payload: payload
        });
    const $313a6508e415ded9$export$fc6caf89a567b8b1 = 'state.ui.views.SET_WARNINGS_VISIBILITY';
    const $313a6508e415ded9$export$97d3304d96905fb0 = (payload)=>({
            type: $313a6508e415ded9$export$fc6caf89a567b8b1,
            payload: payload
        });
    const $313a6508e415ded9$export$44a92bc1a269f215 = 'state.ui.views.SET_RELEASES_VISIBILITY';
    const $313a6508e415ded9$export$fdec3e0865bc1066 = (payload)=>({
            type: $313a6508e415ded9$export$44a92bc1a269f215,
            payload: payload
        });
    const $313a6508e415ded9$export$5847d71ec22dc665 = 'state.ui.views.SET_LEVEL_ONE_SETTING';
    const $313a6508e415ded9$export$1542a36683289b9c = (payload)=>({
            type: $313a6508e415ded9$export$5847d71ec22dc665,
            payload: payload
        });
    const $313a6508e415ded9$export$556a2127816d096d = ()=>({
            type: $313a6508e415ded9$export$5847d71ec22dc665,
            payload: (0, (0, parcelRequire("l4LVp")).DEFAULT_LEVEL_ONE_VIEW_SETTINGS)
        });
});
parcelRegister("l8zxk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cd53f31654b9b97c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $4R6GH;
    var $3KRpp;
    var $koVbs;
    var $33gp9;
    const $cd53f31654b9b97c$export$36f7d6a88f12c6f1 = {
        DUPLICATED: 'DUPLICATED',
        DUPLICATED_HIDDEN: 'DUPLICATED_HIDDEN',
        CYCLE: 'CYCLE',
        CYCLE_HIDDEN: 'CYCLE_HIDDEN'
    };
    const $cd53f31654b9b97c$var$DependencyInvalidFlag = ({ id: id, onDismissed: onDismissed, setShowDependencies: setShowDependencies, dependee: dependee, dependency: dependency, isDependenciesVisible: isDependenciesVisible, isDependencyDuplicated: isDependencyDuplicated })=>{
        const onDismissedCallback = (0, $5uXOq.useCallback)(()=>{
            onDismissed(id);
        }, [
            id,
            onDismissed
        ]);
        const onShowDependencies = (0, $5uXOq.useCallback)(()=>{
            setShowDependencies();
            onDismissedCallback();
        }, [
            setShowDependencies,
            onDismissedCallback
        ]);
        let flagType;
        if (isDependenciesVisible) flagType = isDependencyDuplicated ? $cd53f31654b9b97c$export$36f7d6a88f12c6f1.DUPLICATED : $cd53f31654b9b97c$export$36f7d6a88f12c6f1.CYCLE;
        else flagType = isDependencyDuplicated ? $cd53f31654b9b97c$export$36f7d6a88f12c6f1.DUPLICATED_HIDDEN : $cd53f31654b9b97c$export$36f7d6a88f12c6f1.CYCLE_HIDDEN;
        const getDescription = ()=>{
            switch(flagType){
                case $cd53f31654b9b97c$export$36f7d6a88f12c6f1.DUPLICATED:
                    return (0, (0, parcelRequire("33gp9")).default).duplicatedDescription;
                case $cd53f31654b9b97c$export$36f7d6a88f12c6f1.DUPLICATED_HIDDEN:
                    return (0, (0, parcelRequire("33gp9")).default).duplicatedDescriptionHidden;
                case $cd53f31654b9b97c$export$36f7d6a88f12c6f1.CYCLE:
                    return (0, (0, parcelRequire("33gp9")).default).cycleDescription;
                case $cd53f31654b9b97c$export$36f7d6a88f12c6f1.CYCLE_HIDDEN:
                    return (0, (0, parcelRequire("33gp9")).default).cycleDescriptionHidden;
                default:
                    return (0, (0, parcelRequire("33gp9")).default).duplicatedDescription;
            }
        };
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        if (!dependee || !dependency) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3KRpp")).WarningFlag), {
            ...(0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-meatball-dependency-modal') ? {
                delayAnnouncement: 300
            } : {},
            id: id,
            onDismissed: onDismissedCallback,
            title: formatMessage(flagType === $cd53f31654b9b97c$export$36f7d6a88f12c6f1.DUPLICATED || flagType === $cd53f31654b9b97c$export$36f7d6a88f12c6f1.DUPLICATED_HIDDEN ? (0, (0, parcelRequire("33gp9")).default).duplicatedTitle : (0, (0, parcelRequire("33gp9")).default).cycleTitle),
            description: formatMessage(getDescription(), {
                b: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement("b", null, chunks),
                dependency: dependency,
                dependee: dependee
            }),
            ...flagType === $cd53f31654b9b97c$export$36f7d6a88f12c6f1.CYCLE_HIDDEN || flagType === $cd53f31654b9b97c$export$36f7d6a88f12c6f1.DUPLICATED_HIDDEN ? {
                actions: [
                    {
                        content: formatMessage((0, (0, parcelRequire("33gp9")).default).showDependencies),
                        onClick: onShowDependencies
                    },
                    {
                        content: formatMessage((0, (0, parcelRequire("33gp9")).default).confirm),
                        onClick: onDismissedCallback
                    }
                ]
            } : {}
        });
    };
    $cd53f31654b9b97c$var$DependencyInvalidFlag.defaultProps = {
        onDismissed: (0, ($parcel$interopDefault($8Rkzz)))
    };
    var $cd53f31654b9b97c$export$2e2bcd8739ae039 = $cd53f31654b9b97c$var$DependencyInvalidFlag;
});
parcelRegister("33gp9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7b58e1c40af356fb$export$2e2bcd8739ae039);
    var $7VHMR;
    var $7b58e1c40af356fb$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        duplicatedTitle: {
            "id": "roadmap.standard-roadmap.flags.dependencies-invalid.duplicated-title",
            "defaultMessage": "Dependency already exists"
        },
        duplicatedDescription: {
            "id": "roadmap.standard-roadmap.flags.dependencies-invalid.duplicated-description",
            "defaultMessage": "<b>{dependency}</b> and <b>{dependee}</b> are already linked."
        },
        duplicatedDescriptionHidden: {
            "id": "roadmap.standard-roadmap.flags.dependencies-invalid.duplicated-description-hidden",
            "defaultMessage": "<b>{dependency}</b> and <b>{dependee}</b> are already linked, but dependencies are hidden on your timeline."
        },
        cycleTitle: {
            "id": "roadmap.standard-roadmap.flags.dependencies-invalid.cycle-title",
            "defaultMessage": "Couldn't create dependency"
        },
        cycleDescription: {
            "id": "roadmap.standard-roadmap.flags.dependencies-invalid.cycle-description",
            "defaultMessage": "Remove the existing dependency between <b>{dependency}</b> and <b>{dependee}</b>, and try again."
        },
        cycleDescriptionHidden: {
            "id": "roadmap.standard-roadmap.flags.dependencies-invalid.cycle-description-hidden",
            "defaultMessage": "Remove the existing dependency between <b>{dependency}</b> and <b>{dependee}</b> and try again. This dependency is currently hidden from your timeline."
        },
        showDependencies: {
            "id": "roadmap.standard-roadmap.flags.dependencies-invalid.show-dependencies",
            "defaultMessage": "Change Dependency settings"
        },
        confirm: {
            "id": "roadmap.standard-roadmap.flags.dependencies-invalid.confirm",
            "defaultMessage": "Got it"
        }
    });
});
parcelRegister("i4z5a", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cf32f5e5cb5cfa14$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $6s1PB;
    var $1wpPp;
    var $az4zD;
    var $1wiql;
    var $fq9yz;
    class $cf32f5e5cb5cfa14$export$3ac94ed2f6e2fad9 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                type: (0, $438c68509b62d950$export$706a65ec8b4360e1),
                onDismissed: (0, ($parcel$interopDefault($8Rkzz)))
            };
        }
        render() {
            const { type: type, dependeeKey: dependeeKey, dependencyKey: dependencyKey, intl: { formatMessage: formatMessage }, ...props } = this.props;
            const title = type === (0, $438c68509b62d950$export$706a65ec8b4360e1) ? formatMessage((0, (0, parcelRequire("fq9yz")).default).titleAdd) : formatMessage((0, (0, parcelRequire("fq9yz")).default).titleRemove);
            const getDescriptionWithIssueKey = ()=>{
                if (type === (0, $438c68509b62d950$export$706a65ec8b4360e1)) return formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("fq9yz")).default).descriptionAddIssueTermRefresh : (0, (0, parcelRequire("fq9yz")).default).descriptionAdd, {
                    dependee: dependeeKey,
                    dependency: dependencyKey
                });
                return formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("fq9yz")).default).descriptionRemoveIssueTermRefresh : (0, (0, parcelRequire("fq9yz")).default).descriptionRemove, {
                    dependee: dependeeKey,
                    dependency: dependencyKey
                });
            };
            const getErrorFlagMessage = ()=>{
                if (dependeeKey && dependencyKey) return getDescriptionWithIssueKey();
                return formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("fq9yz")).default).descriptionIssueTermRefresh : (0, (0, parcelRequire("fq9yz")).default).description);
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1wpPp")).default), {
                ...props,
                onDismissed: this.onDismissed,
                id: this.props.id,
                title: title,
                description: getErrorFlagMessage(),
                actions: [
                    {
                        content: formatMessage((0, (0, parcelRequire("fq9yz")).default).learnMore),
                        href: (0, (0, parcelRequire("1wiql")).docs).JIRA_PERMISSIONS_OVERVIEW
                    }
                ]
            });
        }
        constructor(...args){
            super(...args);
            this.onDismissed = ()=>{
                const { id: id, onDismissed: onDismissed } = this.props;
                onDismissed(id);
            };
        }
    }
    var $cf32f5e5cb5cfa14$export$2e2bcd8739ae039 = (0, (0, parcelRequire("az4zD")).injectIntlV2)($cf32f5e5cb5cfa14$export$3ac94ed2f6e2fad9);
});
const $438c68509b62d950$export$706a65ec8b4360e1 = 'DEPENDENCY_ADD_ERROR';
const $438c68509b62d950$export$4e33c4fb4fd4616f = 'DEPENDENCY_DELETE_ERROR';
parcelRegister("1wiql", function(module, exports) {
    $parcel$export(module.exports, "docs", ()=>$43ad5ee6f3af5cce$export$257224358692d0e0);
    const $43ad5ee6f3af5cce$var$SUPPORT_DOCUMENTATION_PREFIX = 'https://support.atlassian.com/jira-software-cloud/docs/';
    const $43ad5ee6f3af5cce$var$TROUBLESHOOT_TIMELINES_NEXT_GEN = `${$43ad5ee6f3af5cce$var$SUPPORT_DOCUMENTATION_PREFIX}troubleshoot-the-timelines-for-team-managed-projects`;
    const $43ad5ee6f3af5cce$var$DEPENDENCIES = `${$43ad5ee6f3af5cce$var$SUPPORT_DOCUMENTATION_PREFIX}manage-dependencies-between-epics-on-the-timeline`;
    const $43ad5ee6f3af5cce$var$CUSTOMIZE_VIEW = `${$43ad5ee6f3af5cce$var$SUPPORT_DOCUMENTATION_PREFIX}customize-your-view-on-the-timeline`;
    const $43ad5ee6f3af5cce$var$JIRA_PERMISSIONS_OVERVIEW = 'https://support.atlassian.com/jira-service-desk-cloud/docs/overview-of-jira-cloud-permissions/';
    const $43ad5ee6f3af5cce$var$CONTACT_SUPPORT = 'https://support.atlassian.com/contact/#/?inquiry_category=technical_issues';
    const $43ad5ee6f3af5cce$var$JIRA_SOFTWARE_PREMIUM_OVERVIEW = 'https://www.atlassian.com/software/jira/features/timelines?tab=advanced';
    const $43ad5ee6f3af5cce$var$JIRA_SOFTWARE_PREMIUM_START_TRIAL = 'https://www.atlassian.com/try/cloud/signup?bundle=jira-software&edition=premium';
    const $43ad5ee6f3af5cce$var$JIRA_WHAT_ARE_ADVANCED_ROADMAPS = 'https://www.atlassian.com/software/jira/guides/advanced-roadmaps/overview#what-are-advanced-roadmaps';
    const $43ad5ee6f3af5cce$export$257224358692d0e0 = {
        TROUBLESHOOT_TIMELINES_NEXT_GEN: $43ad5ee6f3af5cce$var$TROUBLESHOOT_TIMELINES_NEXT_GEN,
        DEPENDENCIES: $43ad5ee6f3af5cce$var$DEPENDENCIES,
        CUSTOMIZE_VIEW: $43ad5ee6f3af5cce$var$CUSTOMIZE_VIEW,
        JIRA_PERMISSIONS_OVERVIEW: $43ad5ee6f3af5cce$var$JIRA_PERMISSIONS_OVERVIEW,
        CONTACT_SUPPORT: $43ad5ee6f3af5cce$var$CONTACT_SUPPORT,
        JIRA_SOFTWARE_PREMIUM_OVERVIEW: $43ad5ee6f3af5cce$var$JIRA_SOFTWARE_PREMIUM_OVERVIEW,
        JIRA_SOFTWARE_PREMIUM_START_TRIAL: $43ad5ee6f3af5cce$var$JIRA_SOFTWARE_PREMIUM_START_TRIAL,
        JIRA_WHAT_ARE_ADVANCED_ROADMAPS: $43ad5ee6f3af5cce$var$JIRA_WHAT_ARE_ADVANCED_ROADMAPS
    };
});
parcelRegister("fq9yz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7deb2786e36bcbb6$export$2e2bcd8739ae039);
    var $7VHMR;
    var $7deb2786e36bcbb6$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        titleAdd: {
            "id": "roadmap.standard-roadmap.flags.dependencies-permission.title-add",
            "defaultMessage": "Sorry we couldn't create a dependency"
        },
        titleRemove: {
            "id": "roadmap.standard-roadmap.flags.dependencies-permission.title-remove",
            "defaultMessage": "Sorry we couldn't delete a dependency"
        },
        description: {
            "id": "roadmap.standard-roadmap.flags.dependencies-permission.description",
            "defaultMessage": "You don't have link issues permission. Check your issue link Jira setting or contact your Jira administrator for help."
        },
        descriptionAdd: {
            "id": "roadmap.standard-roadmap.flags.dependencies-permission.description-add",
            "defaultMessage": "You don't have permission to link issue {dependency} to {dependee}. Check your issue link Jira setting or contact your Jira administrator for help."
        },
        descriptionRemove: {
            "id": "roadmap.standard-roadmap.flags.dependencies-permission.description-remove",
            "defaultMessage": "You don't have permission to unlink issue {dependency} and {dependee}. Check your issue link Jira setting or contact your Jira administrator for help."
        },
        learnMore: {
            "id": "roadmap.standard-roadmap.flags.dependencies-permission.learn-more",
            "defaultMessage": "Learn more"
        },
        descriptionIssueTermRefresh: {
            "id": "roadmap.standard-roadmap.flags.dependencies-permission.description-issue-term-refresh",
            "defaultMessage": "You don't have the permission to link work items. Check your Jira settings or contact your Jira administrator for help."
        },
        descriptionAddIssueTermRefresh: {
            "id": "roadmap.standard-roadmap.flags.dependencies-permission.description-add-issue-term-refresh",
            "defaultMessage": "You don't have permission to link work item {dependency} to {dependee}. Check your work item link Jira setting or contact your Jira administrator for help."
        },
        descriptionRemoveIssueTermRefresh: {
            "id": "roadmap.standard-roadmap.flags.dependencies-permission.description-remove-issue-term-refresh",
            "defaultMessage": "You don't have permission to unlink work item {dependency} and {dependee}. Check your work item link Jira setting or contact your Jira administrator for help."
        }
    });
});
parcelRegister("b84ui", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9d7a984abf5fb149$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iXVV6;
    var $hbVms;
    const $9d7a984abf5fb149$var$FlagWithAnalytics = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: "standardRoadmapFlags",
            sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hbVms")).default), props));
    var $9d7a984abf5fb149$export$2e2bcd8739ae039 = $9d7a984abf5fb149$var$FlagWithAnalytics;
});
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';
parcelRegister("hbVms", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$79132df242059040$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $6s1PB;
    var $1wpPp;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $1wiql;
    var $eAUS5;
    const $79132df242059040$var$HiddenDependencyCreatedFlag = ({ id: id, onDismissed: onDismissed })=>{
        const onDismissedCallback = (0, $5uXOq.useCallback)(()=>{
            onDismissed(id);
        }, [
            id,
            onDismissed
        ]);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const onLearnMoreCallback = (0, $5uXOq.useCallback)(()=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'learnMoreUnavailableDependenciesButton');
        }, [
            createAnalyticsEvent
        ]);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1wpPp")).default), {
            id: id,
            onDismissed: onDismissedCallback,
            title: formatMessage((0, (0, parcelRequire("eAUS5")).default).title),
            description: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("eAUS5")).default).descriptionIssueTermRefresh : (0, (0, parcelRequire("eAUS5")).default).description),
            actions: [
                {
                    content: formatMessage((0, (0, parcelRequire("eAUS5")).default).learnMore),
                    href: (0, (0, parcelRequire("1wiql")).docs).DEPENDENCIES,
                    onClick: onLearnMoreCallback
                }
            ]
        });
    };
    $79132df242059040$var$HiddenDependencyCreatedFlag.defaultProps = {
        onDismissed: (0, ($parcel$interopDefault($8Rkzz)))
    };
    var $79132df242059040$export$2e2bcd8739ae039 = $79132df242059040$var$HiddenDependencyCreatedFlag;
});
parcelRegister("eAUS5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$edf10cdb89217a49$export$2e2bcd8739ae039);
    var $7VHMR;
    var $edf10cdb89217a49$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "roadmap.standard-roadmap.flags.dependencies-unavailable.title",
            "defaultMessage": "Sorry we couldn't create a dependency"
        },
        description: {
            "id": "roadmap.standard-roadmap.flags.dependencies-unavailable.description",
            "defaultMessage": "Check your issue link Jira setting or contact your Jira administrator for help."
        },
        learnMore: {
            "id": "roadmap.standard-roadmap.flags.dependencies-unavailable.learn-more",
            "defaultMessage": "Learn more"
        },
        descriptionIssueTermRefresh: {
            "id": "roadmap.standard-roadmap.flags.dependencies-unavailable.description-issue-term-refresh",
            "defaultMessage": "Check your work item link Jira setting or contact your Jira administrator for help."
        }
    });
});
parcelRegister("iekkc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$42734f2ec300d311$export$2e2bcd8739ae039);
    var $bC2fB;
    var $fWch8;
    var $8MAkq;
    var $42734f2ec300d311$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((state)=>({
            href: (0, (0, parcelRequire("fWch8")).getLocationUrl)(state)
        }), {})((0, (0, parcelRequire("8MAkq")).default));
});
parcelRegister("8MAkq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e1b6d6cc40672c9d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $1wpPp;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $iVTP3;
    const $e1b6d6cc40672c9d$var$RoadmapErrorFlag = ({ id: id, href: href, onDismissed: onDismissed = (0, ($parcel$interopDefault($8Rkzz))) })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const onDismissedHandler = ()=>{
            onDismissed(id);
        };
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({
                action: 'viewed',
                actionSubject: 'roadmapErrorFlag'
            }), 'viewed roadmapErrorFlag', {
                cause: 'unknown'
            });
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1wpPp")).default), {
            onDismissed: onDismissedHandler,
            id: id,
            title: formatMessage((0, (0, parcelRequire("iVTP3")).default).title),
            description: formatMessage((0, (0, parcelRequire("iVTP3")).default).flagDescription),
            actions: [
                {
                    content: formatMessage((0, (0, parcelRequire("iVTP3")).default).reloadPageButton),
                    href: href
                }
            ]
        });
    };
    var $e1b6d6cc40672c9d$export$2e2bcd8739ae039 = $e1b6d6cc40672c9d$var$RoadmapErrorFlag;
});
parcelRegister("iVTP3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$da846c5acc3ae83d$export$2e2bcd8739ae039);
    var $7VHMR;
    var $da846c5acc3ae83d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "roadmap.standard-roadmap.flags.general-error.title",
            "defaultMessage": "Something went wrong"
        },
        flagDescription: {
            "id": "roadmap.standard-roadmap.flags.general-error.flag-description",
            "defaultMessage": "Reload the timeline to continue."
        },
        reloadPageButton: {
            "id": "roadmap.standard-roadmap.flags.general-error.reload-page-button",
            "defaultMessage": "Reload page"
        }
    });
});
parcelRegister("7pgCQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$eab0e24cf340b4b1$export$2e2bcd8739ae039);
    var $bC2fB;
    var $ilGit;
    var $dpKZm;
    const $eab0e24cf340b4b1$var$onShowDependencies = ()=>(0, (0, parcelRequire("ilGit")).setDependenciesViewVisibility)(true);
    var $eab0e24cf340b4b1$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)(null, {
        onShowDependencies: $eab0e24cf340b4b1$var$onShowDependencies
    })((0, (0, parcelRequire("dpKZm")).default));
});
parcelRegister("dpKZm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f67c6c111d922635$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $3FbMI;
    var $az4zD;
    var $lmQ99;
    class $f67c6c111d922635$export$e7de86f3a3a670e1 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                onDismissed: (0, ($parcel$interopDefault($8Rkzz)))
            };
        }
        render() {
            const { intl: { formatMessage: formatMessage }, onShowDependencies: onShowDependencies, ...props } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3FbMI")).default), {
                ...props,
                onDismissed: this.onDismissed,
                id: this.props.id,
                title: formatMessage((0, (0, parcelRequire("lmQ99")).default).title),
                description: formatMessage((0, (0, parcelRequire("lmQ99")).default).description),
                actions: [
                    {
                        content: formatMessage((0, (0, parcelRequire("lmQ99")).default).showDependencies),
                        onClick: this.onShowDependencies
                    }
                ]
            });
        }
        constructor(...args){
            super(...args);
            this.onDismissed = ()=>{
                const { id: id, onDismissed: onDismissed } = this.props;
                onDismissed(id);
            };
            this.onShowDependencies = ()=>{
                const { onShowDependencies: onShowDependencies } = this.props;
                onShowDependencies();
                this.onDismissed();
            };
        }
    }
    var $f67c6c111d922635$export$2e2bcd8739ae039 = (0, (0, parcelRequire("az4zD")).injectIntlV2)($f67c6c111d922635$export$e7de86f3a3a670e1);
});
parcelRegister("3FbMI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9654ec4b7b2f42c6$export$2e2bcd8739ae039);
    var $3KRpp;
    var $9654ec4b7b2f42c6$export$2e2bcd8739ae039 = (0, (0, parcelRequire("3KRpp")).SuccessAutoDismissFlag);
});
parcelRegister("lmQ99", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f56a42d132a838a3$export$2e2bcd8739ae039);
    var $7VHMR;
    var $f56a42d132a838a3$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "roadmap.standard-roadmap.flags.hidden-dependency-created.title",
            "defaultMessage": "New dependency created"
        },
        description: {
            "id": "roadmap.standard-roadmap.flags.hidden-dependency-created.description",
            "defaultMessage": "Your dependency was created, but it is hidden by your views configuration."
        },
        showDependencies: {
            "id": "roadmap.standard-roadmap.flags.hidden-dependency-created.show-dependencies",
            "defaultMessage": "Show dependencies"
        }
    });
});
parcelRegister("2iANt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c5c09390628b8ef8$export$2e2bcd8739ae039);
    var $bC2fB;
    var $1VLi2;
    var $hFyhA;
    var $lFFM9;
    const $c5c09390628b8ef8$var$mapStateToProps = (state, { issueId: issueId })=>({
            issueKey: (0, (0, parcelRequire("hFyhA")).getIssueKeyById)(state, issueId)
        });
    const $c5c09390628b8ef8$var$mapDispatchToProps = (dispatch, { transitionId: transitionId, issueId: issueId, hasOverdueReleaseDate: hasOverdueReleaseDate, properties: properties, sourceEvent: sourceEvent })=>({
            onPersist: ()=>{
                dispatch((0, (0, parcelRequire("1VLi2")).updateAndPersistIssueWithoutSprintScopeCheck)(issueId, properties, sourceEvent, hasOverdueReleaseDate));
            },
            onUndo: ()=>{
                dispatch((0, (0, parcelRequire("1VLi2")).resetTransitionState)({
                    issueId: issueId,
                    transitionId: transitionId
                }));
            }
        });
    const $c5c09390628b8ef8$var$mergeProps = ({ issueKey: issueKey }, dispatchProps, { id: id, onDismissed: onDismissed })=>({
            ...dispatchProps,
            id: id,
            issueKey: issueKey,
            onDismissed: onDismissed
        });
    var $c5c09390628b8ef8$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($c5c09390628b8ef8$var$mapStateToProps, $c5c09390628b8ef8$var$mapDispatchToProps, $c5c09390628b8ef8$var$mergeProps)((0, (0, parcelRequire("lFFM9")).InteractedItemsLimitExceededWithActionsFlag));
});
parcelRegister("1VLi2", function(module, exports) {
    $parcel$export(module.exports, "RESET_TRANSITION_STATE", ()=>$58293cdec1283920$export$8b2e719778c50595);
    $parcel$export(module.exports, "resetTransitionState", ()=>$58293cdec1283920$export$3e3a419ce534070d);
    $parcel$export(module.exports, "CLEAR_TRANSITION_STATE", ()=>$58293cdec1283920$export$fbef743040b68312);
    $parcel$export(module.exports, "clearTransitionState", ()=>$58293cdec1283920$export$5643948e01640c7);
    $parcel$export(module.exports, "EXTEND_ISSUES", ()=>$58293cdec1283920$export$acec6bb3a5a13008);
    $parcel$export(module.exports, "extendIssues", ()=>$58293cdec1283920$export$5c46d88adae7253a);
    $parcel$export(module.exports, "REMOVE_ISSUE", ()=>$58293cdec1283920$export$dfe0d1d38e6d3bc8);
    $parcel$export(module.exports, "removeIssue", ()=>$58293cdec1283920$export$ff1397fe6a062d34);
    $parcel$export(module.exports, "REMOVE_ISSUES", ()=>$58293cdec1283920$export$1311cc4749d2adfa);
    $parcel$export(module.exports, "removeIssues", ()=>$58293cdec1283920$export$d26ebabba061649);
    $parcel$export(module.exports, "ATTEMPT_REMOVE_ISSUE", ()=>$58293cdec1283920$export$56031d1f1d2d8da3);
    $parcel$export(module.exports, "attemptRemoveIssue", ()=>$58293cdec1283920$export$878526d4c3e30e41);
    $parcel$export(module.exports, "INSERT_ISSUE", ()=>$58293cdec1283920$export$6d969e379686bfb9);
    $parcel$export(module.exports, "insertIssue", ()=>$58293cdec1283920$export$e392a0a52e0da7ef);
    $parcel$export(module.exports, "CREATE_ISSUE", ()=>$58293cdec1283920$export$a84692caf5a334ea);
    $parcel$export(module.exports, "createAndPersistIssue", ()=>$58293cdec1283920$export$8f908b487df336a4);
    $parcel$export(module.exports, "UPDATE_ISSUE", ()=>$58293cdec1283920$export$d46fd8e9a2a59b28);
    $parcel$export(module.exports, "updateAndPersistIssue", ()=>$58293cdec1283920$export$1a1d5fb1c9f2f724);
    $parcel$export(module.exports, "updateAndPersistIssueWithoutSprintScopeCheck", ()=>$58293cdec1283920$export$d9b76e68436e3b0a);
    $parcel$export(module.exports, "SCHEDULE_ISSUES", ()=>$58293cdec1283920$export$2f2764f1900fe93f);
    $parcel$export(module.exports, "scheduleIssues", ()=>$58293cdec1283920$export$d94e003b0e92f34d);
    $parcel$export(module.exports, "REPLACE_ISSUE", ()=>$58293cdec1283920$export$cfc29e47c9ddc12f);
    $parcel$export(module.exports, "replaceIssue", ()=>$58293cdec1283920$export$d1422f3889d29bc7);
    $parcel$export(module.exports, "RELOAD_ISSUE", ()=>$58293cdec1283920$export$4b88b0c6284a01e1);
    $parcel$export(module.exports, "reload", ()=>$58293cdec1283920$export$32da5b5043dcd88c);
    $parcel$export(module.exports, "RANK_ISSUE", ()=>$58293cdec1283920$export$9bbbeac0bf5bf14);
    $parcel$export(module.exports, "rankIssue", ()=>$58293cdec1283920$export$dbff149eb80fd116);
    $parcel$export(module.exports, "ATTEMPT_RANK_ISSUE", ()=>$58293cdec1283920$export$3b83ef841bccf5d5);
    $parcel$export(module.exports, "attemptRankIssue", ()=>$58293cdec1283920$export$79c072ab6e632f2b);
    $parcel$export(module.exports, "UPDATE_RANK_ISSUE", ()=>$58293cdec1283920$export$621a7ebb8de5fe23);
    $parcel$export(module.exports, "updateAndRankAndPersistIssue", ()=>$58293cdec1283920$export$126321c7035ddbf1);
    $parcel$export(module.exports, "CREATE_DEPENDENCY", ()=>$58293cdec1283920$export$69ea00e5fa233007);
    $parcel$export(module.exports, "createDependency", ()=>$58293cdec1283920$export$952ad7810a0f4e91);
    $parcel$export(module.exports, "ADD_DEPENDENCY", ()=>$58293cdec1283920$export$9a7f264b868961c1);
    $parcel$export(module.exports, "addDependency", ()=>$58293cdec1283920$export$2ff5bfa5e70abb1);
    $parcel$export(module.exports, "DELETE_DEPENDENCY", ()=>$58293cdec1283920$export$ec9e6de72498e3ce);
    $parcel$export(module.exports, "deleteDependency", ()=>$58293cdec1283920$export$d68ff131ad0917e4);
    $parcel$export(module.exports, "REMOVE_DEPENDENCY", ()=>$58293cdec1283920$export$3b9bd127b2360780);
    $parcel$export(module.exports, "removeDependency", ()=>$58293cdec1283920$export$d532b99b7da25b72);
    $parcel$export(module.exports, "UPDATE_ISSUES_SEQUENCE", ()=>$58293cdec1283920$export$e9eeeb115921df74);
    $parcel$export(module.exports, "updateIssuesSequence", ()=>$58293cdec1283920$export$4fa10774905ad67c);
    $parcel$export(module.exports, "UPDATE_ISSUES_HASH_AND_SEQUENCE", ()=>$58293cdec1283920$export$606616912159e339);
    $parcel$export(module.exports, "updateIssuesHashAndSequence", ()=>$58293cdec1283920$export$80537863405b2ccf);
    $parcel$export(module.exports, "GLOBAL_ISSUE_CREATE", ()=>$58293cdec1283920$export$49d57bef9ac2550b);
    $parcel$export(module.exports, "globalIssueCreate", ()=>$58293cdec1283920$export$aa9ce723b504431);
    const $58293cdec1283920$export$8b2e719778c50595 = 'state.entities.issues.RESET_TRANSITION_STATE';
    const $58293cdec1283920$export$3e3a419ce534070d = (payload)=>({
            type: $58293cdec1283920$export$8b2e719778c50595,
            payload: payload
        });
    const $58293cdec1283920$export$fbef743040b68312 = 'state.entities.issues.CLEAR_TRANSITION_STATE';
    const $58293cdec1283920$export$5643948e01640c7 = (payload, caller)=>({
            type: $58293cdec1283920$export$fbef743040b68312,
            payload: payload,
            ...caller ? {
                meta: {
                    caller: caller
                }
            } : {}
        });
    const $58293cdec1283920$export$acec6bb3a5a13008 = 'state.entities.issues.EXTEND_ISSUES';
    const $58293cdec1283920$export$5c46d88adae7253a = (payload, caller)=>({
            type: $58293cdec1283920$export$acec6bb3a5a13008,
            payload: payload,
            ...caller ? {
                meta: {
                    caller: caller
                }
            } : {}
        });
    const $58293cdec1283920$export$dfe0d1d38e6d3bc8 = 'state.entities.issues.REMOVE_ISSUE';
    const $58293cdec1283920$export$ff1397fe6a062d34 = (payload)=>({
            type: $58293cdec1283920$export$dfe0d1d38e6d3bc8,
            payload: payload
        });
    const $58293cdec1283920$export$1311cc4749d2adfa = 'state.entities.issues.REMOVE_ISSUES';
    const $58293cdec1283920$export$d26ebabba061649 = (payload)=>({
            type: $58293cdec1283920$export$1311cc4749d2adfa,
            payload: payload
        });
    const $58293cdec1283920$export$56031d1f1d2d8da3 = 'state.entities.issues.ATTEMPT_REMOVE_ISSUE';
    const $58293cdec1283920$export$878526d4c3e30e41 = (payload)=>({
            type: $58293cdec1283920$export$56031d1f1d2d8da3,
            payload: payload
        });
    const $58293cdec1283920$export$6d969e379686bfb9 = 'state.entities.issues.INSERT_ISSUE';
    const $58293cdec1283920$export$e392a0a52e0da7ef = (payload)=>({
            type: $58293cdec1283920$export$6d969e379686bfb9,
            payload: payload
        });
    const $58293cdec1283920$export$a84692caf5a334ea = 'state.entities.issues.CREATE_ISSUE';
    const $58293cdec1283920$export$8f908b487df336a4 = (payload, meta)=>({
            type: $58293cdec1283920$export$a84692caf5a334ea,
            payload: payload,
            meta: {
                resetCreateItemAnchor: meta.resetCreateItemAnchor,
                analyticsEvent: meta.analyticsEvent
            }
        });
    const $58293cdec1283920$export$d46fd8e9a2a59b28 = 'state.entities.issues.UPDATE_ISSUE';
    const $58293cdec1283920$export$1a1d5fb1c9f2f724 = (id, properties, event, meta)=>({
            type: $58293cdec1283920$export$d46fd8e9a2a59b28,
            payload: {
                id: id,
                properties: properties
            },
            meta: {
                analyticsEvent: event,
                bypassSprintScopeCheck: false,
                isDragged: !!meta?.isDragged,
                hasOverdueReleaseDate: meta?.hasOverdueReleaseDate
            }
        });
    const $58293cdec1283920$export$d9b76e68436e3b0a = (id, properties, event, hasOverdueReleaseDate)=>({
            type: $58293cdec1283920$export$d46fd8e9a2a59b28,
            payload: {
                id: id,
                properties: properties
            },
            meta: {
                analyticsEvent: event,
                bypassSprintScopeCheck: true,
                hasOverdueReleaseDate: hasOverdueReleaseDate
            }
        });
    const $58293cdec1283920$export$2f2764f1900fe93f = 'state.entities.issues.SCHEDULE_ISSUES';
    const $58293cdec1283920$export$d94e003b0e92f34d = (issueScheduleFields, event, hasOverdueReleaseDate)=>({
            type: $58293cdec1283920$export$2f2764f1900fe93f,
            payload: {
                issueScheduleFields: issueScheduleFields
            },
            meta: {
                analyticsEvent: event,
                hasOverdueReleaseDate: hasOverdueReleaseDate
            }
        });
    const $58293cdec1283920$export$cfc29e47c9ddc12f = 'state.entities.issues.REPLACE_ISSUE';
    const $58293cdec1283920$export$d1422f3889d29bc7 = (payload, caller)=>({
            type: $58293cdec1283920$export$cfc29e47c9ddc12f,
            payload: payload,
            ...caller ? {
                meta: {
                    caller: caller
                }
            } : {}
        });
    const $58293cdec1283920$export$4b88b0c6284a01e1 = 'state.entities.issues.RELOAD_ISSUE';
    const $58293cdec1283920$export$32da5b5043dcd88c = (event)=>({
            type: $58293cdec1283920$export$4b88b0c6284a01e1,
            payload: event
        });
    const $58293cdec1283920$export$9bbbeac0bf5bf14 = 'state.entities.issues.RANK_ISSUE';
    const $58293cdec1283920$export$dbff149eb80fd116 = (payload, analyticsEvent)=>({
            type: $58293cdec1283920$export$9bbbeac0bf5bf14,
            payload: payload,
            meta: {
                analyticsEvent: analyticsEvent
            }
        });
    const $58293cdec1283920$export$3b83ef841bccf5d5 = 'state.entities.issues.ATTEMPT_RANK_ISSUE';
    const $58293cdec1283920$export$79c072ab6e632f2b = (payload, analyticsEvent)=>({
            type: $58293cdec1283920$export$3b83ef841bccf5d5,
            payload: payload,
            meta: {
                analyticsEvent: analyticsEvent
            }
        });
    const $58293cdec1283920$export$621a7ebb8de5fe23 = 'state.entities.issues.UPDATE_RANK_ISSUE';
    const $58293cdec1283920$export$126321c7035ddbf1 = (payload, event)=>({
            type: $58293cdec1283920$export$621a7ebb8de5fe23,
            payload: payload,
            meta: {
                analyticsEvent: event
            }
        });
    const $58293cdec1283920$export$69ea00e5fa233007 = 'state.entities.issues.CREATE_DEPENDENCY';
    const $58293cdec1283920$export$952ad7810a0f4e91 = (payload, analyticsEvent)=>({
            type: $58293cdec1283920$export$69ea00e5fa233007,
            payload: payload,
            meta: {
                analyticsEvent: analyticsEvent
            }
        });
    const $58293cdec1283920$export$9a7f264b868961c1 = 'state.entities.issues.ADD_DEPENDENCY';
    const $58293cdec1283920$export$2ff5bfa5e70abb1 = (payload)=>({
            type: $58293cdec1283920$export$9a7f264b868961c1,
            payload: payload
        });
    const $58293cdec1283920$export$ec9e6de72498e3ce = 'state.entities.issues.DELETE_DEPENDENCY';
    const $58293cdec1283920$export$d68ff131ad0917e4 = (payload)=>({
            type: $58293cdec1283920$export$ec9e6de72498e3ce,
            payload: payload
        });
    const $58293cdec1283920$export$3b9bd127b2360780 = 'state.entities.issues.REMOVE_DEPENDENCY';
    const $58293cdec1283920$export$d532b99b7da25b72 = (payload, analyticsEvent)=>({
            type: $58293cdec1283920$export$3b9bd127b2360780,
            payload: payload,
            meta: {
                analyticsEvent: analyticsEvent
            }
        });
    const $58293cdec1283920$export$e9eeeb115921df74 = 'state.entities.issues.UPDATE_ISSUES_SEQUENCE';
    const $58293cdec1283920$export$4fa10774905ad67c = (payload)=>({
            type: $58293cdec1283920$export$e9eeeb115921df74,
            payload: payload
        });
    const $58293cdec1283920$export$606616912159e339 = 'state.entities.issues.UPDATE_ISSUES_HASH_AND_SEQUENCE';
    const $58293cdec1283920$export$80537863405b2ccf = (payload)=>({
            type: $58293cdec1283920$export$606616912159e339,
            payload: payload
        });
    const $58293cdec1283920$export$49d57bef9ac2550b = 'state.entities.issues.GLOBAL_ISSUE_CREATE';
    const $58293cdec1283920$export$aa9ce723b504431 = (payload)=>({
            type: $58293cdec1283920$export$49d57bef9ac2550b,
            payload: payload
        });
});
parcelRegister("lFFM9", function(module, exports) {
    $parcel$export(module.exports, "InteractedItemsLimitExceededWithActionsFlag", ()=>$92deb75d542083b7$export$f2e195f794705af0);
    var $5uXOq = parcelRequire("5uXOq");
    var $bU3PY;
    var $6s1PB;
    var $3FbMI;
    var $ousew;
    var $koVbs;
    var $eKt4x;
    var $jb272;
    const $92deb75d542083b7$export$f2e195f794705af0 = ({ id: id, issueKey: issueKey, onUndo: onUndo, onPersist: onPersist, onDismissed: onDismissed })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const isUndoing = (0, $5uXOq.useRef)(false);
        const handleDismissed = (0, $5uXOq.useCallback)((flagId, analyticsEvent)=>{
            isUndoing.current ? onDismissed?.(flagId, analyticsEvent) : onPersist(flagId, analyticsEvent);
        }, [
            onPersist,
            onDismissed
        ]);
        const handleUndo = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
            isUndoing.current = true;
            onUndo(id, analyticsEvent);
            onDismissed?.(id, analyticsEvent);
        }, [
            id,
            onUndo,
            onDismissed
        ]);
        const handlePersist = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
            isUndoing.current = false;
            onPersist(id, analyticsEvent);
            onDismissed?.(id, analyticsEvent);
        }, [
            id,
            onPersist,
            onDismissed
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3FbMI")).default), {
            id: id,
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("bU3PY"))))), {
                color: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$export$c6930421db9fa514)})`,
                spacing: "spacious",
                LEGACY_size: "medium",
                label: ""
            }),
            title: formatMessage((0, (0, parcelRequire("jb272")).default).title, {
                issueKey: issueKey
            }),
            description: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...(0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("jb272")).default).descriptionIssueTermRefresh : (0, (0, parcelRequire("jb272")).default).description,
                values: {
                    issueKey: issueKey,
                    limit: (0, (0, parcelRequire("eKt4x")).INTERACTED_ITEMS_LIMIT),
                    b: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement("b", null, chunks)
                }
            }),
            onDismissed: handleDismissed,
            actions: [
                {
                    content: formatMessage((0, (0, parcelRequire("jb272")).default).undo),
                    onClick: handleUndo
                },
                {
                    content: formatMessage((0, (0, parcelRequire("jb272")).default).persist),
                    onClick: handlePersist
                }
            ]
        });
    };
});
parcelRegister("jb272", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2f09e746ac2dc790$export$2e2bcd8739ae039);
    var $7VHMR;
    var $2f09e746ac2dc790$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "roadmap.standard-roadmap.flags.interacted-items-limit-exceeded-with-actions.title",
            "defaultMessage": "Only {issueKey} has been updated"
        },
        description: {
            "id": "roadmap.standard-roadmap.flags.interacted-items-limit-exceeded-with-actions.description",
            "defaultMessage": "<b>{issueKey}</b> has more than {limit} child issues which exceeds the amount that can be updated at one time. Select fewer issues and try again."
        },
        undo: {
            "id": "roadmap.standard-roadmap.flags.interacted-items-limit-exceeded-with-actions.undo",
            "defaultMessage": "Undo change"
        },
        persist: {
            "id": "roadmap.standard-roadmap.flags.interacted-items-limit-exceeded-with-actions.persist",
            "defaultMessage": "Got it"
        },
        descriptionIssueTermRefresh: {
            "id": "roadmap.standard-roadmap.flags.interacted-items-limit-exceeded-with-actions.description-issue-term-refresh",
            "defaultMessage": "<b>{issueKey}</b> has more than {limit} work items which exceeds the amount that can be updated at one time. Select fewer and try again."
        }
    });
});
parcelRegister("3He3z", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c40b08f4d4e54680$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bU3PY;
    var $6s1PB;
    var $3FbMI;
    var $koVbs;
    var $eKt4x;
    var $e6r6d;
    const $c40b08f4d4e54680$var$InteractedItemsLimitExceededFlag = ({ id: id, onDismissed: onDismissed })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3FbMI")).default), {
            id: id,
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("bU3PY"))))), {
                color: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$export$c6930421db9fa514)})`,
                spacing: "spacious",
                LEGACY_size: "medium",
                label: ""
            }),
            title: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("e6r6d")).default).titleIssueTermRefresh : (0, (0, parcelRequire("e6r6d")).default).title, {
                limit: (0, (0, parcelRequire("eKt4x")).INTERACTED_ITEMS_LIMIT)
            }),
            onDismissed: onDismissed
        });
    };
    var $c40b08f4d4e54680$export$2e2bcd8739ae039 = $c40b08f4d4e54680$var$InteractedItemsLimitExceededFlag;
});
parcelRegister("e6r6d", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1c1e1960907e8185$export$2e2bcd8739ae039);
    var $7VHMR;
    var $1c1e1960907e8185$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "roadmap.standard-roadmap.flags.interacted-items-limit-exceeded.title",
            "defaultMessage": "You can only select {limit} issues at a time."
        },
        titleIssueTermRefresh: {
            "id": "roadmap.standard-roadmap.flags.interacted-items-limit-exceeded.title-issue-term-refresh",
            "defaultMessage": "You can only select {limit} work items at a time."
        }
    });
});
parcelRegister("6IWLZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$70392a8b132bc0eb$export$2e2bcd8739ae039);
    var $bC2fB;
    var $9fPrG;
    var $4TOif;
    var $NAWJi;
    var $lPPpU;
    var $70392a8b132bc0eb$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((state)=>({
            Description: (0, (0, parcelRequire("9fPrG")).isClassic)(state) ? (0, (0, parcelRequire("4TOif")).default) : (0, (0, parcelRequire("NAWJi")).default)
        }), {})((0, (0, parcelRequire("lPPpU")).default));
});
parcelRegister("4TOif", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9fcc0b584e440ff2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6s1PB;
    var $ousew;
    var $bxtqx;
    const $9fcc0b584e440ff2$var$BoardDescription = ({ issueCount: issueCount, issueUrls: issueUrls })=>{
        const getMessageDescriptor = ()=>{
            if (issueCount === 1) return (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("bxtqx")).default).descriptionIssueTermRefresh : (0, (0, parcelRequire("bxtqx")).default).description;
            return (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("bxtqx")).default).descriptionMultipleIssuesIssueTermRefresh : (0, (0, parcelRequire("bxtqx")).default).descriptionMultipleIssues;
        };
        const messageDescriptor = getMessageDescriptor();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
            ...messageDescriptor,
            values: {
                issueUrls: issueUrls
            }
        });
    };
    var $9fcc0b584e440ff2$export$2e2bcd8739ae039 = $9fcc0b584e440ff2$var$BoardDescription;
});
parcelRegister("bxtqx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$277d2a34526c0022$export$2e2bcd8739ae039);
    var $7VHMR;
    var $277d2a34526c0022$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        description: {
            "id": "roadmap.standard-roadmap.flags.irrelevant-item-created.board-description.description",
            "defaultMessage": "Your issue {issueUrls} has been created but is not currently visible because it does not match your board filter."
        },
        descriptionMultipleIssues: {
            "id": "roadmap.standard-roadmap.flags.irrelevant-item-created.board-description.description-multiple-issues",
            "defaultMessage": "Your issues {issueUrls} have been created but are not currently visible because they do not match your board filter."
        },
        descriptionIssueTermRefresh: {
            "id": "roadmap.standard-roadmap.flags.irrelevant-item-created.board-description.description-issue-term-refresh",
            "defaultMessage": "Your work item {issueUrls} has been created but is not currently visible because it does not match your board filter."
        },
        descriptionMultipleIssuesIssueTermRefresh: {
            "id": "roadmap.standard-roadmap.flags.irrelevant-item-created.board-description.description-multiple-issues-issue-term-refresh",
            "defaultMessage": "Your work items {issueUrls} have been created but are not currently visible because they do not match your board filter."
        }
    });
});
parcelRegister("NAWJi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e464493b6f6b6408$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6s1PB;
    var $ousew;
    var $lCY59;
    const $e464493b6f6b6408$var$ProjectDescription = ({ issueCount: issueCount, issueUrls: issueUrls })=>{
        const getMessageDescriptor = ()=>{
            if (issueCount === 1) return (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("lCY59")).default).descriptionIssueTermRefresh : (0, (0, parcelRequire("lCY59")).default).description;
            return (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("lCY59")).default).descriptionMultipleIssuesIssueTermRefresh : (0, (0, parcelRequire("lCY59")).default).descriptionMultipleIssues;
        };
        const messageDescriptor = getMessageDescriptor();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
            ...messageDescriptor,
            values: {
                issueUrls: issueUrls
            }
        });
    };
    var $e464493b6f6b6408$export$2e2bcd8739ae039 = $e464493b6f6b6408$var$ProjectDescription;
});
parcelRegister("lCY59", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$68e81b97915f38ff$export$2e2bcd8739ae039);
    var $7VHMR;
    var $68e81b97915f38ff$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        description: {
            "id": "roadmap.standard-roadmap.flags.irrelevant-item-created.project-description.description",
            "defaultMessage": "Your issue {issueUrls} has been created but is not currently visible because it does not match your project."
        },
        descriptionMultipleIssues: {
            "id": "roadmap.standard-roadmap.flags.irrelevant-item-created.project-description.description-multiple-issues",
            "defaultMessage": "Your issues {issueUrls} have been created but are not currently visible because they do not match your project."
        },
        descriptionIssueTermRefresh: {
            "id": "roadmap.standard-roadmap.flags.irrelevant-item-created.project-description.description-issue-term-refresh",
            "defaultMessage": "Your work item {issueUrls} has been created but is not currently visible because it does not match your project."
        },
        descriptionMultipleIssuesIssueTermRefresh: {
            "id": "roadmap.standard-roadmap.flags.irrelevant-item-created.project-description.description-multiple-issues-issue-term-refresh",
            "defaultMessage": "Your work items {issueUrls} have been created but are not currently visible because they do not match your project."
        }
    });
});
parcelRegister("lPPpU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$80ef6e4ddfdd0a26$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $jhmo0;
    var $6s1PB;
    var $3FbMI;
    var $az4zD;
    var $iXVV6;
    var $5oFIy;
    var $4vLBs;
    class $80ef6e4ddfdd0a26$var$IrrelevantItemCreatedFlag extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                onDismissed: (0, ($parcel$interopDefault($8Rkzz)))
            };
        }
        renderIssueUrls() {
            const { issueKeys: issueKeys } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, issueKeys.map((issueKey, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
                    key: issueKey
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jhmo0")).default), {
                    href: `/browse/${issueKey}`
                }, issueKey), index < issueKeys.length - 1 && ', ')));
        }
        render() {
            const { id: id, issueKeys: issueKeys, Description: Description, intl: { formatMessage: formatMessage } } = this.props;
            const issueCount = issueKeys.length;
            const issueUrls = this.renderIssueUrls();
            const getTitleMessage = ()=>{
                if (issueCount === 1) return formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("4vLBs")).default).titleIssueTermRefresh : (0, (0, parcelRequire("4vLBs")).default).title);
                return formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("4vLBs")).default).titleMultipleIssuesIssueTermRefresh : (0, (0, parcelRequire("4vLBs")).default).titleMultipleIssues, {
                    issueCount: issueCount
                });
            };
            const title = getTitleMessage();
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
                sourceName: "irrelevantItemCreated",
                sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3FbMI")).default), {
                id: id,
                onDismissed: this.onDismissed,
                title: title,
                description: (0, ($parcel$interopDefault($5uXOq))).createElement(Description, {
                    issueCount: issueCount,
                    issueUrls: issueUrls
                })
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), null));
        }
        constructor(...args){
            super(...args);
            this.onDismissed = ()=>{
                const { id: id, onDismissed: onDismissed } = this.props;
                onDismissed(id);
            };
        }
    }
    var $80ef6e4ddfdd0a26$export$2e2bcd8739ae039 = (0, (0, parcelRequire("az4zD")).injectIntlV2)($80ef6e4ddfdd0a26$var$IrrelevantItemCreatedFlag);
});
parcelRegister("4vLBs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6b2acfbcc43d3747$export$2e2bcd8739ae039);
    var $7VHMR;
    var $6b2acfbcc43d3747$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "roadmap.standard-roadmap.flags.irrelevant-item-created.title",
            "defaultMessage": "Issue created"
        },
        titleMultipleIssues: {
            "id": "roadmap.standard-roadmap.flags.irrelevant-item-created.title-multiple-issues",
            "defaultMessage": "{issueCount} issues created"
        },
        titleIssueTermRefresh: {
            "id": "roadmap.standard-roadmap.flags.irrelevant-item-created.title-issue-term-refresh",
            "defaultMessage": "Work item created"
        },
        titleMultipleIssuesIssueTermRefresh: {
            "id": "roadmap.standard-roadmap.flags.irrelevant-item-created.title-multiple-issues-issue-term-refresh",
            "defaultMessage": "{issueCount} work items created"
        }
    });
});
parcelRegister("lUdEM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$70000c0fcc770d86$export$2e2bcd8739ae039);
    var $hGgHi = parcelRequire("hGgHi");
    var $bC2fB;
    var $hFyhA;
    var $hhYQB;
    var $9QFr0;
    var $gFEKp;
    var $lQSOv;
    const $70000c0fcc770d86$var$mapStateToProps = (state, { ids: ids })=>({
            keys: ids.reduce((acc, id)=>{
                const key = (0, (0, parcelRequire("hFyhA")).getIssueKeyById)(state, id);
                !(0, ($parcel$interopDefault($hGgHi)))(key) && acc.push(key);
                return acc;
            }, []),
            isFilterApplied: Object.values((0, (0, parcelRequire("hhYQB")).getIssuesFilter)(state)).some((filter)=>filter.length)
        });
    const $70000c0fcc770d86$var$mapDispatchToProps = {
        onViewIssue: (0, (0, parcelRequire("gFEKp")).setSelectedIssue),
        onClearFilter: (0, (0, parcelRequire("9QFr0")).clearFilter)
    };
    const $70000c0fcc770d86$export$9d1611c77c2fe928 = (stateProps, dispatchProps, { id: id, onDismissed: onDismissed })=>({
            id: id,
            onDismissed: onDismissed,
            ...stateProps,
            ...dispatchProps
        });
    var $70000c0fcc770d86$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($70000c0fcc770d86$var$mapStateToProps, $70000c0fcc770d86$var$mapDispatchToProps, $70000c0fcc770d86$export$9d1611c77c2fe928)((0, (0, parcelRequire("lQSOv")).default));
});
parcelRegister("9QFr0", function(module, exports) {
    $parcel$export(module.exports, "SET_TIMELINE_MODE", ()=>$4132d765f604217e$export$153dbe77ab644046);
    $parcel$export(module.exports, "setTimelineMode", ()=>$4132d765f604217e$export$a3936c3a6c7236f0);
    $parcel$export(module.exports, "SET_STATUS_CATEGORY_FILTER", ()=>$4132d765f604217e$export$3ce13c168d78b996);
    $parcel$export(module.exports, "setStatusCategoryFilter", ()=>$4132d765f604217e$export$d2a82d7c3461581);
    $parcel$export(module.exports, "SET_ISSUE_TYPE_FILTER", ()=>$4132d765f604217e$export$9ca69e0c20a04cec);
    $parcel$export(module.exports, "setIssueTypeFilter", ()=>$4132d765f604217e$export$316476ada8a934d1);
    $parcel$export(module.exports, "SET_ASSIGNEE_FILTER", ()=>$4132d765f604217e$export$6fe3d1b08c258323);
    $parcel$export(module.exports, "setAssigneeFilter", ()=>$4132d765f604217e$export$4a2731aa5fc2b425);
    $parcel$export(module.exports, "CLEAR_FILTER", ()=>$4132d765f604217e$export$80f6e3f69ac5bef4);
    $parcel$export(module.exports, "clearFilter", ()=>$4132d765f604217e$export$77cedf2a856f1597);
    $parcel$export(module.exports, "CLEAR_FILTER_AND_SETTING", ()=>$4132d765f604217e$export$af1441bab8ee3960);
    $parcel$export(module.exports, "SET_TEXT_FILTER", ()=>$4132d765f604217e$export$3ff6c5ed0a39e295);
    $parcel$export(module.exports, "setTextFilter", ()=>$4132d765f604217e$export$18ecd839459a178a);
    $parcel$export(module.exports, "SET_LABEL_FILTER", ()=>$4132d765f604217e$export$4bf2768ab3ecfce5);
    $parcel$export(module.exports, "setLabelFilter", ()=>$4132d765f604217e$export$ade76d88a88a3aed);
    $parcel$export(module.exports, "SET_ISSUE_PARENT_FILTER", ()=>$4132d765f604217e$export$ddc1d16dbce4b006);
    $parcel$export(module.exports, "setIssueParentFilter", ()=>$4132d765f604217e$export$e09ef35d0e5d72f3);
    $parcel$export(module.exports, "SET_VERSION_FILTER", ()=>$4132d765f604217e$export$3e9fc12271dccc0b);
    $parcel$export(module.exports, "setVersionFilter", ()=>$4132d765f604217e$export$4be540adb4b6f83b);
    $parcel$export(module.exports, "SET_COMPONENT_FILTER", ()=>$4132d765f604217e$export$3ecce12a664b23bf);
    $parcel$export(module.exports, "setComponentFilter", ()=>$4132d765f604217e$export$aa22dea8d756557b);
    $parcel$export(module.exports, "SET_QUICK_FILTERS_FILTER", ()=>$4132d765f604217e$export$866796b9a25fc413);
    $parcel$export(module.exports, "setQuickFiltersFilter", ()=>$4132d765f604217e$export$2bc4a51983d57990);
    $parcel$export(module.exports, "SET_FILTER_CONFIGURATION", ()=>$4132d765f604217e$export$be94f667af3087fd);
    $parcel$export(module.exports, "setFilterConfiguration", ()=>$4132d765f604217e$export$d17290d824a94b8);
    $parcel$export(module.exports, "QUICK_FILTERS_REQUEST", ()=>$4132d765f604217e$export$6f89cb6c7d158240);
    $parcel$export(module.exports, "quickFiltersRequest", ()=>$4132d765f604217e$export$638aaa01c7b2c997);
    $parcel$export(module.exports, "JQL_FILTERS_SUCCESS", ()=>$4132d765f604217e$export$7eb1ce875b31f0be);
    $parcel$export(module.exports, "jqlFiltersSuccess", ()=>$4132d765f604217e$export$c424cc8a00edb330);
    $parcel$export(module.exports, "QUICK_FILTERS_CLEAR", ()=>$4132d765f604217e$export$6a0d76c2a8ab6957);
    $parcel$export(module.exports, "clearQuickFilters", ()=>$4132d765f604217e$export$82a00f19fc766760);
    $parcel$export(module.exports, "JQL_FILTERS_REAPPLY", ()=>$4132d765f604217e$export$a0d61e9ea4ad5a05);
    $parcel$export(module.exports, "reapplyJQLFilters", ()=>$4132d765f604217e$export$6dc0831c960fc82c);
    $parcel$export(module.exports, "SET_CUSTOM_FILTER", ()=>$4132d765f604217e$export$309288e527577ea2);
    $parcel$export(module.exports, "setCustomFilter", ()=>$4132d765f604217e$export$d0e42db1dc9af930);
    $parcel$export(module.exports, "CUSTOM_FILTERS_REQUEST", ()=>$4132d765f604217e$export$20195c741d1bb1b4);
    $parcel$export(module.exports, "customFiltersRequest", ()=>$4132d765f604217e$export$3da18e7e501fd5f8);
    $parcel$export(module.exports, "CUSTOM_FILTERS_CLEAR", ()=>$4132d765f604217e$export$67b962401e1755ad);
    $parcel$export(module.exports, "clearCustomFilters", ()=>$4132d765f604217e$export$19fd00e898f244e9);
    $parcel$export(module.exports, "SET_GOAL_FILTER", ()=>$4132d765f604217e$export$41f9712fbaf4d66b);
    $parcel$export(module.exports, "setGoalFilter", ()=>$4132d765f604217e$export$70be1709162bf468);
    const $4132d765f604217e$export$153dbe77ab644046 = 'state.ui.filters.SET_TIMELINE_MODE';
    const $4132d765f604217e$export$a3936c3a6c7236f0 = (payload)=>({
            type: $4132d765f604217e$export$153dbe77ab644046,
            payload: payload
        });
    const $4132d765f604217e$export$3ce13c168d78b996 = 'state.ui.filters.SET_STATUS_CATEGORY_FILTER';
    const $4132d765f604217e$export$d2a82d7c3461581 = (payload)=>({
            type: $4132d765f604217e$export$3ce13c168d78b996,
            payload: payload
        });
    const $4132d765f604217e$export$9ca69e0c20a04cec = 'state.ui.filters.SET_ISSUE_TYPE_FILTER';
    const $4132d765f604217e$export$316476ada8a934d1 = (payload)=>({
            type: $4132d765f604217e$export$9ca69e0c20a04cec,
            payload: payload
        });
    const $4132d765f604217e$export$6fe3d1b08c258323 = 'state.ui.filters.SET_ASSIGNEE_FILTER';
    const $4132d765f604217e$export$4a2731aa5fc2b425 = (payload)=>({
            type: $4132d765f604217e$export$6fe3d1b08c258323,
            payload: payload
        });
    const $4132d765f604217e$export$80f6e3f69ac5bef4 = 'state.ui.filters.CLEAR_FILTER';
    const $4132d765f604217e$export$77cedf2a856f1597 = ()=>({
            type: $4132d765f604217e$export$80f6e3f69ac5bef4
        });
    const $4132d765f604217e$export$af1441bab8ee3960 = 'state.ui.filters.CLEAR_FILTER_AND_SETTING';
    const $4132d765f604217e$export$fb874fefdc9c2f15 = ()=>({
            type: $4132d765f604217e$export$af1441bab8ee3960
        });
    const $4132d765f604217e$export$3ff6c5ed0a39e295 = 'state.ui.filters.SET_TEXT_FILTER';
    const $4132d765f604217e$export$18ecd839459a178a = (payload)=>({
            type: $4132d765f604217e$export$3ff6c5ed0a39e295,
            payload: payload
        });
    const $4132d765f604217e$export$4bf2768ab3ecfce5 = 'state.ui.filters.SET_LABEL_FILTER';
    const $4132d765f604217e$export$ade76d88a88a3aed = (payload)=>({
            type: $4132d765f604217e$export$4bf2768ab3ecfce5,
            payload: payload
        });
    const $4132d765f604217e$export$ddc1d16dbce4b006 = 'state.ui.filters.SET_ISSUE_PARENT_FILTER';
    const $4132d765f604217e$export$e09ef35d0e5d72f3 = (payload)=>({
            type: $4132d765f604217e$export$ddc1d16dbce4b006,
            payload: payload
        });
    const $4132d765f604217e$export$3e9fc12271dccc0b = 'state.ui.filters.SET_VERSION_FILTER';
    const $4132d765f604217e$export$4be540adb4b6f83b = (payload)=>({
            type: $4132d765f604217e$export$3e9fc12271dccc0b,
            payload: payload
        });
    const $4132d765f604217e$export$3ecce12a664b23bf = 'state.ui.filters.SET_COMPONENT_FILTER';
    const $4132d765f604217e$export$aa22dea8d756557b = (payload)=>({
            type: $4132d765f604217e$export$3ecce12a664b23bf,
            payload: payload
        });
    const $4132d765f604217e$export$866796b9a25fc413 = 'state.ui.filters.SET_QUICK_FILTERS_FILTER';
    const $4132d765f604217e$export$2bc4a51983d57990 = (payload)=>({
            type: $4132d765f604217e$export$866796b9a25fc413,
            payload: payload
        });
    const $4132d765f604217e$export$be94f667af3087fd = 'state.ui.filters.SET_FILTER_CONFIGURATION';
    const $4132d765f604217e$export$d17290d824a94b8 = (payload)=>({
            type: $4132d765f604217e$export$be94f667af3087fd,
            payload: payload
        });
    const $4132d765f604217e$export$6f89cb6c7d158240 = 'state.ui.filters.QUICK_FILTERS_REQUEST';
    const $4132d765f604217e$export$638aaa01c7b2c997 = (payload)=>({
            type: $4132d765f604217e$export$6f89cb6c7d158240,
            payload: payload
        });
    const $4132d765f604217e$export$7eb1ce875b31f0be = 'state.ui.filters.JQL_FILTERS_SUCCESS';
    const $4132d765f604217e$export$c424cc8a00edb330 = (payload)=>({
            type: $4132d765f604217e$export$7eb1ce875b31f0be,
            payload: payload
        });
    const $4132d765f604217e$export$6a0d76c2a8ab6957 = 'state.ui.filters.QUICK_FILTERS_CLEAR';
    const $4132d765f604217e$export$82a00f19fc766760 = ()=>({
            type: $4132d765f604217e$export$6a0d76c2a8ab6957
        });
    const $4132d765f604217e$export$a0d61e9ea4ad5a05 = 'state.ui.filters.JQL_FILTERS_REAPPLY';
    const $4132d765f604217e$export$6dc0831c960fc82c = ()=>({
            type: $4132d765f604217e$export$a0d61e9ea4ad5a05
        });
    const $4132d765f604217e$export$309288e527577ea2 = 'state.ui.filters.SET_CUSTOM_FILTER';
    const $4132d765f604217e$export$d0e42db1dc9af930 = (payload)=>({
            type: $4132d765f604217e$export$309288e527577ea2,
            payload: payload
        });
    const $4132d765f604217e$export$20195c741d1bb1b4 = 'state.ui.filters.CUSTOM_FILTERS_REQUEST';
    const $4132d765f604217e$export$3da18e7e501fd5f8 = (payload)=>({
            type: $4132d765f604217e$export$20195c741d1bb1b4,
            payload: payload
        });
    const $4132d765f604217e$export$67b962401e1755ad = 'state.ui.filters.CUSTOM_FILTERS_CLEAR';
    const $4132d765f604217e$export$19fd00e898f244e9 = ()=>({
            type: $4132d765f604217e$export$67b962401e1755ad
        });
    const $4132d765f604217e$export$41f9712fbaf4d66b = 'state.ui.filters.SET_GOAL_FILTER';
    const $4132d765f604217e$export$70be1709162bf468 = (payload)=>({
            type: $4132d765f604217e$export$41f9712fbaf4d66b,
            payload: payload
        });
});
parcelRegister("gFEKp", function(module, exports) {
    $parcel$export(module.exports, "SHOW_PANEL", ()=>$bc1a308ea506372b$export$938bd55b420c1d30);
    $parcel$export(module.exports, "showPanel", ()=>$bc1a308ea506372b$export$e89c3c9af31c1e3b);
    $parcel$export(module.exports, "HIDE_PANEL", ()=>$bc1a308ea506372b$export$98671e345c4d9c82);
    $parcel$export(module.exports, "hidePanel", ()=>$bc1a308ea506372b$export$3646905057a9ef29);
    $parcel$export(module.exports, "SHOW_ISSUE_DETAILS", ()=>$bc1a308ea506372b$export$f925c7c8f6ccf4a5);
    $parcel$export(module.exports, "SET_SELECTED_ISSUE", ()=>$bc1a308ea506372b$export$799a01fd5c3028a);
    $parcel$export(module.exports, "setSelectedIssue", ()=>$bc1a308ea506372b$export$a7e96ee41f298462);
    const $bc1a308ea506372b$export$938bd55b420c1d30 = 'state.ui.panel.SHOW_PANEL';
    const $bc1a308ea506372b$export$e89c3c9af31c1e3b = (payload)=>({
            type: $bc1a308ea506372b$export$938bd55b420c1d30,
            payload: payload
        });
    const $bc1a308ea506372b$export$98671e345c4d9c82 = 'state.ui.panel.HIDE_PANEL';
    const $bc1a308ea506372b$export$3646905057a9ef29 = ()=>({
            type: $bc1a308ea506372b$export$98671e345c4d9c82
        });
    const $bc1a308ea506372b$export$f925c7c8f6ccf4a5 = 'state.ui.panel.SHOW_ISSUE_DETAILS';
    const $bc1a308ea506372b$export$b248d2709e43857 = (payload)=>({
            type: $bc1a308ea506372b$export$f925c7c8f6ccf4a5,
            payload: payload
        });
    const $bc1a308ea506372b$export$799a01fd5c3028a = 'state.ui.panel.SET_SELECTED_ISSUE';
    const $bc1a308ea506372b$export$a7e96ee41f298462 = (payload)=>({
            type: $bc1a308ea506372b$export$799a01fd5c3028a,
            payload: payload
        });
});
parcelRegister("lQSOv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a5fd38fd12cd0ba2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6s1PB;
    var $4R6GH;
    var $3KRpp;
    var $8Q4sF;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $8tWuK;
    var $kxu6E;
    const $a5fd38fd12cd0ba2$var$IssueHiddenFlag = ({ id: id, keys: keys, isFilterApplied: isFilterApplied, onClearFilter: onClearFilter, onViewIssue: onViewIssue, onDismissed: onDismissed })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({
                action: 'viewed',
                actionSubject: 'issueHiddenFlag'
            }), 'viewed issueHiddenFlag', {
                isStateChangeBasedIssueHiddenFlagsEnabled: (0, (0, parcelRequire("4R6GH")).fg)('jsw-roadmap-state-change-based-issue-hidden-flags')
            });
        }, []);
        const numIssues = keys.length;
        const onClick = numIssues === 1 && onViewIssue ? (e)=>{
            const { ctrlKey: ctrlKey, metaKey: metaKey } = e.nativeEvent;
            if (ctrlKey || metaKey) return;
            e.preventDefault();
            onViewIssue(keys[0]);
        } : undefined;
        const getDescriptionMessage = ()=>{
            if (numIssues === 1) return (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("8tWuK")).default).flagDescriptionWithLinkIssueTermRefresh : (0, (0, parcelRequire("8tWuK")).default).flagDescriptionWithLink;
            return (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("8tWuK")).default).flagDescriptionIssueTermRefresh : (0, (0, parcelRequire("8tWuK")).default).flagDescription;
        };
        const descriptionMessage = getDescriptionMessage();
        const description = numIssues === 1 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Q4sF")).FormattedI18nMessage), {
            message: formatMessage(descriptionMessage, {
                linkStart: '{linkStart}',
                linkEnd: '{linkEnd}'
            }),
            componentsMapping: {
                link: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("a", {
                        href: (0, (0, parcelRequire("kxu6E")).getIssueUrl)([
                            keys[0]
                        ]),
                        onClick: onClick,
                        target: "_blank"
                    }, keys[0])
            }
        }) : formatMessage(descriptionMessage, {
            numIssues: numIssues
        });
        const viewIssueAction = {
            content: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("8tWuK")).default).issueLinkIssueTermRefresh : (0, (0, parcelRequire("8tWuK")).default).issueLink, {
                numIssues: numIssues
            }),
            href: (0, (0, parcelRequire("kxu6E")).getIssueUrl)(keys),
            onClick: onClick,
            target: '_blank'
        };
        const clearFilterAction = {
            content: formatMessage((0, (0, parcelRequire("8tWuK")).default).clearFilter),
            onClick: onClearFilter
        };
        const actions = [];
        if (numIssues > 0) actions.push(viewIssueAction);
        if (isFilterApplied) actions.push(clearFilterAction);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3KRpp")).SuccessAutoDismissFlag), {
            id: id,
            onDismissed: onDismissed,
            title: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("8tWuK")).default).titleIssueTermRefresh : (0, (0, parcelRequire("8tWuK")).default).title, {
                numIssues: numIssues
            }),
            description: description,
            actions: actions
        });
    };
    var $a5fd38fd12cd0ba2$export$2e2bcd8739ae039 = $a5fd38fd12cd0ba2$var$IssueHiddenFlag;
});
parcelRegister("8Q4sF", function(module, exports) {
    $parcel$export(module.exports, "FormattedI18nMessage", ()=>$7c8c20575fbc9bfc$export$200d7bd7633253ce);
    var $5uXOq = parcelRequire("5uXOq");
    var $gHDlh;
    var $9Byym;
    const $7c8c20575fbc9bfc$export$200d7bd7633253ce = (props)=>{
        const { message: message, packageName: packageName, componentsMapping: componentsMapping } = props;
        const messageParts = (0, $5uXOq.useMemo)(()=>{
            const { tags: tags, openTags: openTags, closeTags: closeTags } = (0, (0, parcelRequire("9Byym")).getTags)(componentsMapping);
            try {
                const parts = [];
                let token = '';
                let TagComponent;
                let closeTagLookup;
                for(let i = 0; i < message.length; i += 1){
                    const letter = message[i];
                    token += letter;
                    if ((0, (0, parcelRequire("9Byym")).isCloseTagDelimiter)(letter)) {
                        const firstTagFound = (0, (0, parcelRequire("9Byym")).findTag)(token, {
                            tags: openTags
                        });
                        if (firstTagFound !== null && firstTagFound !== undefined) {
                            if (TagComponent) throw new (0, (0, parcelRequire("gHDlh")).MalformedMessageError)();
                            const text = token.replace(firstTagFound, '');
                            parts.push(text);
                            const tagInfo = tags[firstTagFound];
                            TagComponent = tagInfo.component;
                            closeTagLookup = tagInfo.close;
                            token = '';
                        }
                    }
                    if (closeTagLookup !== null && closeTagLookup !== undefined && (0, (0, parcelRequire("9Byym")).isCloseTagDelimiter)(letter) && (0, (0, parcelRequire("9Byym")).isAnyTag)(token, {
                        tags: [
                            closeTagLookup
                        ]
                    })) {
                        if (!TagComponent) throw new (0, (0, parcelRequire("gHDlh")).MalformedMessageError)();
                        const text = token.replace(closeTagLookup, '');
                        parts.push((0, ($parcel$interopDefault($5uXOq))).createElement(TagComponent, null, text));
                        TagComponent = undefined;
                        token = '';
                        closeTagLookup = undefined;
                    }
                    if ((0, (0, parcelRequire("9Byym")).isCloseTagDelimiter)(letter) && (0, (0, parcelRequire("9Byym")).isAnyTag)(token, {
                        tags: closeTags
                    })) {
                        if (!TagComponent) throw new (0, (0, parcelRequire("gHDlh")).MalformedMessageError)();
                    }
                }
                if (TagComponent || closeTagLookup) throw new (0, (0, parcelRequire("gHDlh")).MalformedMessageError)();
                if (token.length > 0) parts.push(token);
                return parts;
            } catch (e) {
                if (e instanceof (0, (0, parcelRequire("gHDlh")).MalformedMessageError)) {
                    (0, (0, parcelRequire("gHDlh")).logMalformedMessageError)({
                        message: message,
                        packageName: packageName
                    });
                    return [
                        (0, (0, parcelRequire("gHDlh")).getMalformedMessage)({
                            message: message,
                            closeTags: closeTags,
                            openTags: openTags
                        })
                    ];
                }
                throw e;
            }
        }, [
            message,
            packageName,
            componentsMapping
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, messageParts.map((item, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
                key: index
            }, item)));
    };
});
parcelRegister("gHDlh", function(module, exports) {
    $parcel$export(module.exports, "getMalformedMessage", ()=>$ecff24857c176a60$export$f085cf20ec1f69ab);
    $parcel$export(module.exports, "logMalformedMessageError", ()=>$ecff24857c176a60$export$954c3e6aad1c9429);
    $parcel$export(module.exports, "MalformedMessageError", ()=>$ecff24857c176a60$export$40d900e818b9630e);
    var $dJl1T;
    var $jcw0u;
    const $ecff24857c176a60$export$f085cf20ec1f69ab = ({ message: message, openTags: openTags, closeTags: closeTags })=>[
            ...openTags,
            ...closeTags
        ].reduce((acc, tag)=>acc.replace(new RegExp(tag, 'g'), ''), message);
    const $ecff24857c176a60$export$954c3e6aad1c9429 = ({ message: message, packageName: packageName })=>{
        if (packageName !== null && packageName !== undefined) {
            const errorMessage = `Malformed message: ${message}`;
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    packageName: packageName,
                    id: (0, $5514815b06163219$export$f3390a0e172fee41)
                },
                attributes: {
                    message: errorMessage
                }
            });
            const location = `${packageName}.${(0, $5514815b06163219$export$f3390a0e172fee41)}`;
            (0, (0, parcelRequire("dJl1T")).default).unsafeErrorWithCustomerData(location, errorMessage);
        }
    };
    class $ecff24857c176a60$export$40d900e818b9630e extends Error {
        constructor(){
            super('Malformed i18n message');
        }
    }
});
const $5514815b06163219$export$f3390a0e172fee41 = 'formattedI18NMessage';
parcelRegister("9Byym", function(module, exports) {
    $parcel$export(module.exports, "getTags", ()=>$84498158f946a67b$export$af63d7414243dad3);
    $parcel$export(module.exports, "isAnyTag", ()=>$84498158f946a67b$export$38ffa64fc639355f);
    $parcel$export(module.exports, "findTag", ()=>$84498158f946a67b$export$dfca0f74034f8657);
    $parcel$export(module.exports, "isCloseTagDelimiter", ()=>$84498158f946a67b$export$d5170904651e91b1);
    const $84498158f946a67b$export$af63d7414243dad3 = (componentsMapping)=>Object.entries(componentsMapping).reduce((acc, [key, value])=>{
            const open = `{${key}Start}`;
            const close = `{${key}End}`;
            acc.tags[open] = {
                close: close,
                component: value
            };
            acc.openTags.push(open);
            acc.closeTags.push(close);
            return acc;
        }, {
            tags: {},
            openTags: [],
            closeTags: []
        });
    const $84498158f946a67b$export$38ffa64fc639355f = (text, { tags: tags })=>tags.some((tag)=>text.includes(tag));
    const $84498158f946a67b$export$dfca0f74034f8657 = (text, { tags: tags })=>tags.find((tag)=>text.includes(tag));
    const $84498158f946a67b$export$d5170904651e91b1 = (letter)=>letter === (0, $7ed9c0b663db8b35$export$a10c567c3288a6b4);
});
const $7ed9c0b663db8b35$export$a10c567c3288a6b4 = '}';
parcelRegister("8tWuK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cee197e73cdfb275$export$2e2bcd8739ae039);
    var $7VHMR;
    var $cee197e73cdfb275$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "roadmap.standard-roadmap.flags.issue-hidden.title",
            "defaultMessage": "Changes are saved, but {numIssues, plural, one {issue isn't} other {issues aren't}} visible"
        },
        flagDescriptionWithLink: {
            "id": "roadmap.standard-roadmap.flags.issue-hidden.flag-description-with-link",
            "defaultMessage": "Changes were made to issue {linkStart}{linkEnd}, which is currently hidden on your timeline because of a filter or your view settings."
        },
        flagDescription: {
            "id": "roadmap.standard-roadmap.flags.issue-hidden.flag-description",
            "defaultMessage": "Changes were made to issues currently hidden on your timeline because of a filter or your view settings."
        },
        clearFilter: {
            "id": "roadmap.standard-roadmap.flags.issue-hidden.clear-filter",
            "defaultMessage": "Clear filter"
        },
        issueLink: {
            "id": "roadmap.standard-roadmap.flags.issue-hidden.issue-link",
            "defaultMessage": "View {numIssues, plural, one {issue} other {issues}}"
        },
        titleIssueTermRefresh: {
            "id": "roadmap.standard-roadmap.flags.issue-hidden.title-issue-term-refresh",
            "defaultMessage": "Changes are saved, but {numIssues, plural, one {work item isn't} other {work items aren't}} visible"
        },
        flagDescriptionWithLinkIssueTermRefresh: {
            "id": "roadmap.standard-roadmap.flags.issue-hidden.flag-description-with-link-issue-term-refresh",
            "defaultMessage": "Changes were made to work item {linkStart}{linkEnd}, which is currently hidden on your timeline because of a filter or your view settings."
        },
        flagDescriptionIssueTermRefresh: {
            "id": "roadmap.standard-roadmap.flags.issue-hidden.flag-description-issue-term-refresh",
            "defaultMessage": "Changes were made to work currently hidden on your timeline because of a filter or your view settings."
        },
        issueLinkIssueTermRefresh: {
            "id": "roadmap.standard-roadmap.flags.issue-hidden.issue-link-issue-term-refresh",
            "defaultMessage": "View {numIssues, plural, one {work item} other {work items}}"
        }
    });
});
parcelRegister("kxu6E", function(module, exports) {
    $parcel$export(module.exports, "getIssueUrl", ()=>$a36b6b8fd5c8be5d$export$dcf0cd5cf26c4b27);
    const $a36b6b8fd5c8be5d$export$dcf0cd5cf26c4b27 = (cardKeys)=>{
        if (cardKeys.length > 1) {
            const issueKeys = cardKeys.join(',');
            const jqlSearch = encodeURIComponent(`issueKey in (${issueKeys})`);
            return `/issues/?jql=${jqlSearch}`;
        }
        return `/browse/${cardKeys[0]}`;
    };
});
parcelRegister("7INve", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$80005392164765cd$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $6s1PB;
    var $1wpPp;
    var $koVbs;
    var $1wiql;
    var $hyGEV;
    const $80005392164765cd$var$IssueUpdatePermissionFlag = ({ id: id, onDismissed: onDismissed })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const title = formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("hyGEV")).default).titleUpdateIssueTermRefresh : (0, (0, parcelRequire("hyGEV")).default).titleUpdate);
        const description = formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("hyGEV")).default).descriptionUpdateIssueTermRefresh : (0, (0, parcelRequire("hyGEV")).default).descriptionUpdate);
        const learnMore = formatMessage((0, (0, parcelRequire("hyGEV")).default).learnMore);
        const onDismissedCallback = ()=>{
            onDismissed?.(id);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1wpPp")).default), {
            onDismissed: onDismissedCallback,
            id: id,
            title: title,
            description: description,
            actions: [
                {
                    content: learnMore,
                    href: (0, (0, parcelRequire("1wiql")).docs).JIRA_PERMISSIONS_OVERVIEW
                }
            ]
        });
    };
    $80005392164765cd$var$IssueUpdatePermissionFlag.defaultProps = {
        onDismissed: (0, ($parcel$interopDefault($8Rkzz)))
    };
    var $80005392164765cd$export$2e2bcd8739ae039 = $80005392164765cd$var$IssueUpdatePermissionFlag;
});
parcelRegister("hyGEV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$50346db25386abef$export$2e2bcd8739ae039);
    var $7VHMR;
    var $50346db25386abef$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        titleUpdate: {
            "id": "roadmap.standard-roadmap.flags.issue-update-permission.title-update",
            "defaultMessage": "We couldn't update your issue"
        },
        descriptionUpdate: {
            "id": "roadmap.standard-roadmap.flags.issue-update-permission.description-update",
            "defaultMessage": "You don't have permission to update this issue. Check your permissions settings or contact your Jira administrator for help."
        },
        learnMore: {
            "id": "roadmap.standard-roadmap.flags.issue-update-permission.learn-more",
            "defaultMessage": "Learn more"
        },
        titleUpdateIssueTermRefresh: {
            "id": "roadmap.standard-roadmap.flags.issue-update-permission.title-update-issue-term-refresh",
            "defaultMessage": "We couldn't update your work item"
        },
        descriptionUpdateIssueTermRefresh: {
            "id": "roadmap.standard-roadmap.flags.issue-update-permission.description-update-issue-term-refresh",
            "defaultMessage": "You don't have permission to update this work item. Check your permissions settings or contact your Jira administrator for help."
        }
    });
});
parcelRegister("F4kmw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1937bfa267610ebd$export$2e2bcd8739ae039);
    var $bC2fB;
    var $hFyhA;
    var $ilGit;
    var $dhQAs;
    var $1937bfa267610ebd$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((state, ownProps)=>({
            issueKey: (0, (0, parcelRequire("hFyhA")).getIssueKeyById)(state, ownProps.issueId)
        }), {
        onClearDisplayOption: (0, (0, parcelRequire("ilGit")).clearLevelOneSetting)
    }, (stateProps, dispatchProps, ownProps)=>{
        const { issueKey: issueKey } = stateProps;
        const { id: id, onDismissed: onDismissed } = ownProps;
        return {
            ...dispatchProps,
            issueKey: issueKey,
            id: id,
            onDismissed: onDismissed
        };
    })((0, (0, parcelRequire("dhQAs")).default));
});
parcelRegister("dhQAs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d8e64d4f832f1930$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $6s1PB;
    var $3FbMI;
    var $ousew;
    var $aWse0;
    var $2e7Tw;
    const $d8e64d4f832f1930$export$89ada5f647983029 = ({ issueKey: issueKey, onDismissed: onDismissed, id: id, onClearDisplayOption: onClearDisplayOption })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        const onDismissedCallback = (0, $5uXOq.useCallback)((flagId)=>{
            onDismissed(flagId);
        }, [
            onDismissed
        ]);
        const onClick = (0, $5uXOq.useCallback)(()=>{
            onDismissed(id);
            onClearDisplayOption();
        }, [
            onDismissed,
            id,
            onClearDisplayOption
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3FbMI")).default), {
            id: id,
            title: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...(0, (0, parcelRequire("2e7Tw")).default).title,
                values: {
                    issueKey: issueKey,
                    b: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement("b", null, chunks)
                }
            }),
            description: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...(0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("2e7Tw")).default).descriptionIssueTermRefresh : (0, (0, parcelRequire("2e7Tw")).default).description,
                values: {
                    issueKey: issueKey,
                    b: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement("b", null, chunks)
                }
            }),
            onDismissed: onDismissedCallback,
            actions: [
                {
                    content: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("2e7Tw")).default).clearDisplayOptionIssueTermRefresh : (0, (0, parcelRequire("2e7Tw")).default).clearDisplayOption),
                    onClick: onClick
                }
            ]
        });
    };
    $d8e64d4f832f1930$export$89ada5f647983029.defaultProps = {
        onDismissed: (0, ($parcel$interopDefault($8Rkzz)))
    };
    var $d8e64d4f832f1930$export$2e2bcd8739ae039 = $d8e64d4f832f1930$export$89ada5f647983029;
});
parcelRegister("2e7Tw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cfb0a0d9e31ff980$export$2e2bcd8739ae039);
    var $7VHMR;
    var $cfb0a0d9e31ff980$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "roadmap.standard-roadmap.flags.item-disappears-from-display-range.title",
            "defaultMessage": "<b>{issueKey}</b> is hidden from your plan"
        },
        description: {
            "id": "roadmap.standard-roadmap.flags.item-disappears-from-display-range.description",
            "defaultMessage": "<b>{issueKey}</b> is outside the visible date range of your plan. To view it, clear your issue display range settings."
        },
        clearDisplayOption: {
            "id": "roadmap.standard-roadmap.flags.item-disappears-from-display-range.clear-display-option",
            "defaultMessage": "Clear issue display range settings"
        },
        descriptionIssueTermRefresh: {
            "id": "roadmap.standard-roadmap.flags.item-disappears-from-display-range.description-issue-term-refresh",
            "defaultMessage": "<b>{issueKey}</b> is outside the visible date range of your plan. To view it, clear your issue display range settings."
        },
        clearDisplayOptionIssueTermRefresh: {
            "id": "roadmap.standard-roadmap.flags.item-disappears-from-display-range.clear-display-option-issue-term-refresh",
            "defaultMessage": "Clear issue display range settings"
        }
    });
});
parcelRegister("lQpJj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5a551159ce4f3b47$export$2e2bcd8739ae039);
    var $bC2fB;
    var $4gYYI;
    var $6eZhx;
    var $5a551159ce4f3b47$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((state)=>({
            isAdmin: (0, (0, parcelRequire("4gYYI")).hasAdministerProjectPermission)(state) || (0, (0, parcelRequire("4gYYI")).getIsUserBoardAdmin)(state)
        }), {})((0, (0, parcelRequire("6eZhx")).default));
});
parcelRegister("6eZhx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f5ec07bfa7500674$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $8igKv;
    var $az4zD;
    var $9R9nS;
    var $1JivP;
    class $f5ec07bfa7500674$export$321f8e7a5f776e25 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                onDismissed: (0, ($parcel$interopDefault($8Rkzz)))
            };
        }
        getContent() {
            const { isAdmin: isAdmin, boardId: boardId, intl: { formatMessage: formatMessage } } = this.props;
            if (isAdmin) return {
                description: formatMessage((0, (0, parcelRequire("1JivP")).default).description),
                actions: [
                    {
                        content: formatMessage((0, (0, parcelRequire("1JivP")).default).showJqlFilterForBoard),
                        href: (0, (0, parcelRequire("9R9nS")).getEditFilterUrl)(boardId)
                    }
                ]
            };
            return {
                description: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, (0, parcelRequire("1JivP")).default).description), (0, ($parcel$interopDefault($5uXOq))).createElement("br", null), formatMessage((0, (0, parcelRequire("1JivP")).default).contactAdmin))
            };
        }
        render() {
            const { id: id, intl: { formatMessage: formatMessage } } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8igKv")).default), {
                id: id,
                isAutoDismiss: true,
                onDismissed: this.onDismissed,
                title: formatMessage((0, (0, parcelRequire("1JivP")).default).title),
                ...this.getContent()
            });
        }
        constructor(...args){
            super(...args);
            this.onDismissed = ()=>{
                const { id: id, onDismissed: onDismissed } = this.props;
                onDismissed(id);
            };
        }
    }
    var $f5ec07bfa7500674$export$2e2bcd8739ae039 = (0, (0, parcelRequire("az4zD")).injectIntlV2)($f5ec07bfa7500674$export$321f8e7a5f776e25);
});
parcelRegister("8igKv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$87b804070d792a00$export$2e2bcd8739ae039);
    var $3KRpp;
    var $87b804070d792a00$export$2e2bcd8739ae039 = (0, (0, parcelRequire("3KRpp")).WarningFlag);
});
parcelRegister("9R9nS", function(module, exports) {
    $parcel$export(module.exports, "getEditFilterUrl", ()=>$3fec701167b1375d$export$4a8805dc45e0d1a2);
    const $3fec701167b1375d$export$4a8805dc45e0d1a2 = (boardId)=>`/secure/RapidBoard.jspa?rapidView=${boardId}&config=filter`;
});
parcelRegister("1JivP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e25f534bd6d63492$export$2e2bcd8739ae039);
    var $7VHMR;
    var $e25f534bd6d63492$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "roadmap.standard-roadmap.flags.rank-disabled.title",
            "defaultMessage": "Ranking is disabled"
        },
        description: {
            "id": "roadmap.standard-roadmap.flags.rank-disabled.description",
            "defaultMessage": "Ranking is disabled, as the Filter Query for this board is not ordered by ascending Rank."
        },
        contactAdmin: {
            "id": "roadmap.standard-roadmap.flags.rank-disabled.contact-admin",
            "defaultMessage": "Contact your admin to adjust the board filter."
        },
        showJqlFilterForBoard: {
            "id": "roadmap.standard-roadmap.flags.rank-disabled.show-jql-filter-for-board",
            "defaultMessage": "Please check your filter configuration"
        }
    });
});
parcelRegister("aHk2U", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f59c5f18f4503338$export$2e2bcd8739ae039);
    var $bC2fB;
    var $1VLi2;
    var $hFyhA;
    var $bZFir;
    var $4UHPo;
    const $f59c5f18f4503338$var$mapDispatchToProps = (dispatch, ownProps)=>({
            onPersist: ()=>{
                dispatch((0, (0, parcelRequire("1VLi2")).updateAndPersistIssueWithoutSprintScopeCheck)(ownProps.issueId, ownProps.properties, ownProps.sourceEvent, ownProps.hasOverdueReleaseDate));
            },
            onUndo: ()=>{
                dispatch((0, (0, parcelRequire("1VLi2")).resetTransitionState)({
                    issueId: ownProps.issueId,
                    transitionId: ownProps.transitionId
                }));
            }
        });
    const $f59c5f18f4503338$var$ConnectedFlag = (0, (0, parcelRequire("bC2fB")).connect)((state, ownProps)=>({
            issueKey: (0, (0, parcelRequire("hFyhA")).getIssueKeyById)(state, ownProps.issueId),
            changedSprintName: (0, (0, parcelRequire("bZFir")).getSprintName)(state)(ownProps.direction === (0, $faa12ce5ec04bf70$export$11ee87f991dd6574) ? ownProps.targetSprintId : ownProps.sourceSprintId)
        }), $f59c5f18f4503338$var$mapDispatchToProps, (stateProps, dispatchProps, ownProps)=>{
        const { issueKey: issueKey, changedSprintName: changedSprintName } = stateProps;
        const { id: id, direction: direction, onDismissed: onDismissed } = ownProps;
        return {
            ...dispatchProps,
            issueKey: issueKey,
            id: id,
            changedSprintName: changedSprintName,
            direction: direction,
            onDismissed: onDismissed
        };
    })((0, (0, parcelRequire("4UHPo")).default));
    var $f59c5f18f4503338$export$2e2bcd8739ae039 = $f59c5f18f4503338$var$ConnectedFlag;
});
const $faa12ce5ec04bf70$export$11ee87f991dd6574 = 'ASSIGN';
const $faa12ce5ec04bf70$export$be2c0bb3425b849c = 'UNASSIGN';
parcelRegister("bZFir", function(module, exports) {
    $parcel$export(module.exports, "createGetIntersectingSprintId", ()=>$40041049fb15c6d8$export$31abdd665c32a9d3);
    $parcel$export(module.exports, "getSprintState", ()=>$40041049fb15c6d8$export$9cbf48c04feaac07);
    $parcel$export(module.exports, "getSprintName", ()=>$40041049fb15c6d8$export$3df6198cde5435f9);
    $parcel$export(module.exports, "getSanitisedIssueSprintsHash", ()=>$40041049fb15c6d8$export$7ace1dbeb1bd9b20);
    $parcel$export(module.exports, "getCurrentlyAssignedSprints", ()=>$40041049fb15c6d8$export$c1e6c915824951b6);
    $parcel$export(module.exports, "getIsCurrentlyAssignedToSprints", ()=>$40041049fb15c6d8$export$2f4a726669194a00);
    $parcel$export(module.exports, "createGetIssueSprintDates", ()=>$40041049fb15c6d8$export$ed6951d58e67f638);
    $parcel$export(module.exports, "getSprintIntervals", ()=>$40041049fb15c6d8$export$acb5f9893119b5b6);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $cKS6s;
    var $4gYYI;
    var $hFyhA;
    var $2Hh6q;
    var $5SzPP;
    const $40041049fb15c6d8$export$4b81aebbd933400f = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("4gYYI")).getSprints), (0, (0, parcelRequire("5SzPP")).createGetSanitizedSprints));
    const $40041049fb15c6d8$export$9328442a7d4e1089 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("4gYYI")).getSprints), (0, (0, parcelRequire("5SzPP")).getSprintsHash));
    const $40041049fb15c6d8$export$31abdd665c32a9d3 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("2Hh6q")).getTimelineDuration), $40041049fb15c6d8$export$4b81aebbd933400f, (0, (0, parcelRequire("5SzPP")).createGetIntersectingSprintId));
    const $40041049fb15c6d8$export$9cbf48c04feaac07 = (0, $dGvGJ.createSelector)($40041049fb15c6d8$export$9328442a7d4e1089, (0, (0, parcelRequire("5SzPP")).getSprintState));
    const $40041049fb15c6d8$export$3df6198cde5435f9 = (0, $dGvGJ.createSelector)($40041049fb15c6d8$export$9328442a7d4e1089, (0, (0, parcelRequire("5SzPP")).getSprintName));
    const $40041049fb15c6d8$export$7ace1dbeb1bd9b20 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("hFyhA")).getIssueSprintIdsHash), $40041049fb15c6d8$export$9328442a7d4e1089, (0, (0, parcelRequire("5SzPP")).getSanitisedIssueSprintsHash));
    const $40041049fb15c6d8$export$c1e6c915824951b6 = (0, $dGvGJ.createSelector)($40041049fb15c6d8$export$7ace1dbeb1bd9b20, (0, (0, parcelRequire("5SzPP")).getCurrentlyAssignedSprints));
    const $40041049fb15c6d8$export$2f4a726669194a00 = (state, id)=>$40041049fb15c6d8$export$c1e6c915824951b6(state)(id).length > 0;
    const $40041049fb15c6d8$export$4198a074ed17eba2 = (0, $dGvGJ.createSelector)($40041049fb15c6d8$export$7ace1dbeb1bd9b20, (issueIdToSprints)=>Object.keys(issueIdToSprints).reduce((acc, key)=>{
            const issueId = key;
            if (issueIdToSprints[issueId].length > 0) acc[`${issueId}`] = issueIdToSprints[issueId].map((sprint)=>sprint.id);
            return acc;
        }, {}));
    const $40041049fb15c6d8$export$abdb1a5f7673f188 = (0, (0, parcelRequire("cKS6s")).createSelectorWithDefaultEqual)($40041049fb15c6d8$export$4198a074ed17eba2, (0, (0, parcelRequire("5SzPP")).createGetMostRecentSprintId));
    const $40041049fb15c6d8$export$ed6951d58e67f638 = (0, $dGvGJ.createSelector)($40041049fb15c6d8$export$9328442a7d4e1089, $40041049fb15c6d8$export$abdb1a5f7673f188, (sprintsHash, getMostRecentSprintId)=>(issueId)=>{
            const sprintId = getMostRecentSprintId(issueId);
            if (sprintId !== undefined) {
                const sprint = sprintsHash[sprintId];
                return {
                    inferredStartDate: sprint.startDate,
                    inferredEndDate: sprint.endDate
                };
            }
            return {
                inferredStartDate: undefined,
                inferredEndDate: undefined
            };
        });
    const $40041049fb15c6d8$export$acb5f9893119b5b6 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("4gYYI")).getSprints), (0, (0, parcelRequire("5SzPP")).getSprintIntervals));
});
parcelRegister("2Hh6q", function(module, exports) {
    $parcel$export(module.exports, "getTimelineDuration", ()=>$bc0102641b95d018$export$815b68ba93fb8347);
    $parcel$export(module.exports, "getTimelineOrigin", ()=>$bc0102641b95d018$export$173b9ad47017bbd3);
    $parcel$export(module.exports, "getMinTimelineDateRange", ()=>$bc0102641b95d018$export$46a0793d67bcbd40);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $15ADj;
    var $bFxJH;
    var $kvSZW;
    var $4gYYI;
    var $hhYQB;
    const $bc0102641b95d018$export$815b68ba93fb8347 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("4gYYI")).getToday), (0, (0, parcelRequire("hhYQB")).getTimelineMode), (today, timelineMode)=>(0, (0, parcelRequire("kvSZW")).getTimelineDurationFromDate)(timelineMode, today));
    const $bc0102641b95d018$export$173b9ad47017bbd3 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("4gYYI")).getToday), (0, (0, parcelRequire("hhYQB")).getTimelineMode), (today, timelineMode)=>(0, (0, parcelRequire("kvSZW")).getTimelineOriginForToday)(today, timelineMode));
    const $bc0102641b95d018$export$46a0793d67bcbd40 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("hhYQB")).getTimelineMode), $bc0102641b95d018$export$815b68ba93fb8347, (timelineMode, { totalMilliseconds: totalMilliseconds })=>{
        const timelineWidth = (0, (0, parcelRequire("bFxJH")).getTimelineWidth)(timelineMode, totalMilliseconds);
        return Math.ceil((0, (0, parcelRequire("15ADj")).MINIMUM_BAR_LENGTH) / timelineWidth * totalMilliseconds);
    });
});
parcelRegister("15ADj", function(module, exports) {
    $parcel$export(module.exports, "BAR_HEIGHT", ()=>$104fb1be4fcec117$export$4f2f40eb3120c);
    $parcel$export(module.exports, "BASE_BAR_HEIGHT", ()=>$104fb1be4fcec117$export$c8c47b136dc7ac05);
    $parcel$export(module.exports, "MINIMUM_BAR_LENGTH", ()=>$104fb1be4fcec117$export$729e677ca5ac2f4f);
    $parcel$export(module.exports, "DEFAULT_BORDER_RADIUS", ()=>$104fb1be4fcec117$export$f2926bd20425bb0d);
    $parcel$export(module.exports, "LEFT_PLACEHOLDER_BORDER_RADIUS", ()=>$104fb1be4fcec117$export$df860cf23132dfbb);
    $parcel$export(module.exports, "RIGHT_PLACEHOLDER_BORDER_RADIUS", ()=>$104fb1be4fcec117$export$a822ec327ef716a4);
    $parcel$export(module.exports, "LEFT_AND_RIGHT_PLACEHOLDER_BORDER_RADIUS", ()=>$104fb1be4fcec117$export$5b9db862a15e1457);
    $parcel$export(module.exports, "START_DATE_PLACEHOLDER", ()=>$104fb1be4fcec117$export$cfcf3497a5711f2c);
    $parcel$export(module.exports, "DUE_DATE_PLACEHOLDER", ()=>$104fb1be4fcec117$export$42702a43f0325a0c);
    $parcel$export(module.exports, "START_AND_DUE_DATE_PLACEHOLDER", ()=>$104fb1be4fcec117$export$1b72784d953fe9b3);
    var $gwIPs;
    const $104fb1be4fcec117$export$4f2f40eb3120c = (0, (0, parcelRequire("gwIPs")).gridSize) * 3;
    const $104fb1be4fcec117$export$c8c47b136dc7ac05 = (0, (0, parcelRequire("gwIPs")).gridSize) * 2.5;
    const $104fb1be4fcec117$export$729e677ca5ac2f4f = 36;
    const $104fb1be4fcec117$export$f2926bd20425bb0d = `${(0, (0, parcelRequire("gwIPs")).borderRadius)}px`;
    const $104fb1be4fcec117$export$deb313264d4a6a20 = `${(0, (0, parcelRequire("gwIPs")).borderRadius) * 3}px`;
    const $104fb1be4fcec117$export$df860cf23132dfbb = `${$104fb1be4fcec117$export$deb313264d4a6a20} ${$104fb1be4fcec117$export$f2926bd20425bb0d} ${$104fb1be4fcec117$export$f2926bd20425bb0d} ${$104fb1be4fcec117$export$deb313264d4a6a20}`;
    const $104fb1be4fcec117$export$a822ec327ef716a4 = `${$104fb1be4fcec117$export$f2926bd20425bb0d} ${$104fb1be4fcec117$export$deb313264d4a6a20} ${$104fb1be4fcec117$export$deb313264d4a6a20} ${$104fb1be4fcec117$export$f2926bd20425bb0d}`;
    const $104fb1be4fcec117$export$5b9db862a15e1457 = `${$104fb1be4fcec117$export$deb313264d4a6a20}`;
    const $104fb1be4fcec117$export$cfcf3497a5711f2c = 'START_DATE_PLACEHOLDER';
    const $104fb1be4fcec117$export$42702a43f0325a0c = 'DUE_DATE_PLACEHOLDER';
    const $104fb1be4fcec117$export$1b72784d953fe9b3 = 'START_AND_DUE_DATE_PLACEHOLDER';
});
parcelRegister("bFxJH", function(module, exports) {
    $parcel$export(module.exports, "getTimelineWidth", ()=>$a3f65a017bc2d798$export$87113eddf3515c00);
    $parcel$export(module.exports, "getTimelinePositionFromDate", ()=>$a3f65a017bc2d798$export$3d733aa4507a88f8);
    $parcel$export(module.exports, "getDateFromTimelinePosition", ()=>$a3f65a017bc2d798$export$2dd9c7d371d81aa3);
    var $8QpSo;
    var $2gnC5 = parcelRequire("2gnC5");
    var $iZN6h;
    const $a3f65a017bc2d798$var$COLUMN_BASELINE = 255;
    const $a3f65a017bc2d798$export$893f7447303d5bc0 = {
        [(0, (0, parcelRequire("iZN6h")).WEEKS)]: $a3f65a017bc2d798$var$COLUMN_BASELINE / (0, ($parcel$interopDefault($2gnC5))).duration(7, 'day').asMilliseconds(),
        [(0, (0, parcelRequire("iZN6h")).MONTHS)]: $a3f65a017bc2d798$var$COLUMN_BASELINE / (0, ($parcel$interopDefault($2gnC5))).duration(30, 'day').asMilliseconds(),
        [(0, (0, parcelRequire("iZN6h")).QUARTERS)]: $a3f65a017bc2d798$var$COLUMN_BASELINE / (0, ($parcel$interopDefault($2gnC5))).duration(91, 'day').asMilliseconds()
    };
    const $a3f65a017bc2d798$export$87113eddf3515c00 = (0, (0, parcelRequire("8QpSo")).default)((timelineMode, totalDuration)=>Math.round(totalDuration * $a3f65a017bc2d798$export$893f7447303d5bc0[timelineMode]));
    const $a3f65a017bc2d798$export$3d733aa4507a88f8 = ({ startMilliseconds: startMilliseconds, totalMilliseconds: totalMilliseconds }, timelineWidth, date)=>timelineWidth * ((date - startMilliseconds) / totalMilliseconds);
    const $a3f65a017bc2d798$export$2dd9c7d371d81aa3 = ({ startMilliseconds: startMilliseconds, totalMilliseconds: totalMilliseconds }, timelineWidth, position)=>Math.round(startMilliseconds + position / timelineWidth * totalMilliseconds);
});
parcelRegister("2gnC5", function(module, exports) {
    (function(global, factory) {
        module.exports = factory();
    })(this, function() {
        'use strict';
        var hookCallback;
        function hooks() {
            return hookCallback.apply(null, arguments);
        }
        function setHookCallback(callback) {
            hookCallback = callback;
        }
        function isArray(input) {
            return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
        }
        function isObject(input) {
            return input != null && Object.prototype.toString.call(input) === '[object Object]';
        }
        function hasOwnProp(a, b) {
            return Object.prototype.hasOwnProperty.call(a, b);
        }
        function isObjectEmpty(obj) {
            if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
            else {
                var k;
                for(k in obj){
                    if (hasOwnProp(obj, k)) return false;
                }
                return true;
            }
        }
        function isUndefined(input) {
            return input === void 0;
        }
        function isNumber(input) {
            return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
        }
        function isDate(input) {
            return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
        }
        function map(arr, fn) {
            var res = [], i, arrLen = arr.length;
            for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
            return res;
        }
        function extend(a, b) {
            for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
            if (hasOwnProp(b, 'toString')) a.toString = b.toString;
            if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
            return a;
        }
        function createUTC(input, format, locale, strict) {
            return createLocalOrUTC(input, format, locale, strict, true).utc();
        }
        function defaultParsingFlags() {
            return {
                empty: false,
                unusedTokens: [],
                unusedInput: [],
                overflow: -2,
                charsLeftOver: 0,
                nullInput: false,
                invalidEra: null,
                invalidMonth: null,
                invalidFormat: false,
                userInvalidated: false,
                iso: false,
                parsedDateParts: [],
                era: null,
                meridiem: null,
                rfc2822: false,
                weekdayMismatch: false
            };
        }
        function getParsingFlags(m) {
            if (m._pf == null) m._pf = defaultParsingFlags();
            return m._pf;
        }
        var some;
        if (Array.prototype.some) some = Array.prototype.some;
        else some = function(fun) {
            var t = Object(this), len = t.length >>> 0, i;
            for(i = 0; i < len; i++){
                if (i in t && fun.call(this, t[i], i, t)) return true;
            }
            return false;
        };
        function isValid(m) {
            var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
            if (isNowValid) {
                flags = getParsingFlags(m);
                parsedParts = some.call(flags.parsedDateParts, function(i) {
                    return i != null;
                });
                isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
                if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
            }
            if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
            else return isNowValid;
            return m._isValid;
        }
        function createInvalid(flags) {
            var m = createUTC(NaN);
            if (flags != null) extend(getParsingFlags(m), flags);
            else getParsingFlags(m).userInvalidated = true;
            return m;
        }
        var momentProperties = hooks.momentProperties = [], updateInProgress = false;
        function copyConfig(to, from) {
            var i, prop, val, momentPropertiesLen = momentProperties.length;
            if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
            if (!isUndefined(from._i)) to._i = from._i;
            if (!isUndefined(from._f)) to._f = from._f;
            if (!isUndefined(from._l)) to._l = from._l;
            if (!isUndefined(from._strict)) to._strict = from._strict;
            if (!isUndefined(from._tzm)) to._tzm = from._tzm;
            if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
            if (!isUndefined(from._offset)) to._offset = from._offset;
            if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
            if (!isUndefined(from._locale)) to._locale = from._locale;
            if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) to[prop] = val;
            }
            return to;
        }
        function Moment(config) {
            copyConfig(this, config);
            this._d = new Date(config._d != null ? config._d.getTime() : NaN);
            if (!this.isValid()) this._d = new Date(NaN);
            if (updateInProgress === false) {
                updateInProgress = true;
                hooks.updateOffset(this);
                updateInProgress = false;
            }
        }
        function isMoment(obj) {
            return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
        }
        function warn(msg) {
            if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
        }
        function deprecate(msg, fn) {
            var firstTime = true;
            return extend(function() {
                if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
                if (firstTime) {
                    var args = [], arg, i, key, argLen = arguments.length;
                    for(i = 0; i < argLen; i++){
                        arg = '';
                        if (typeof arguments[i] === 'object') {
                            arg += '\n[' + i + '] ';
                            for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                            arg = arg.slice(0, -2);
                        } else arg = arguments[i];
                        args.push(arg);
                    }
                    warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                    firstTime = false;
                }
                return fn.apply(this, arguments);
            }, fn);
        }
        var deprecations = {};
        function deprecateSimple(name, msg) {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
            if (!deprecations[name]) {
                warn(msg);
                deprecations[name] = true;
            }
        }
        hooks.suppressDeprecationWarnings = false;
        hooks.deprecationHandler = null;
        function isFunction(input) {
            return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
        }
        function set(config) {
            var prop, i;
            for(i in config)if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) this[i] = prop;
                else this['_' + i] = prop;
            }
            this._config = config;
            this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
        }
        function mergeConfigs(parentConfig, childConfig) {
            var res = extend({}, parentConfig), prop;
            for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
                else delete res[prop];
            }
            for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) res[prop] = extend({}, res[prop]);
            return res;
        }
        function Locale(config) {
            if (config != null) this.set(config);
        }
        var keys;
        if (Object.keys) keys = Object.keys;
        else keys = function(obj) {
            var i, res = [];
            for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
            return res;
        };
        var defaultCalendar = {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L'
        };
        function calendar(key, mom, now) {
            var output = this._calendar[key] || this._calendar['sameElse'];
            return isFunction(output) ? output.call(mom, now) : output;
        }
        function zeroFill(number, targetLength, forceSign) {
            var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
            return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
        }
        var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
        function addFormatToken(token, padded, ordinal, callback) {
            var func = callback;
            if (typeof callback === 'string') func = function() {
                return this[callback]();
            };
            if (token) formatTokenFunctions[token] = func;
            if (padded) formatTokenFunctions[padded[0]] = function() {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
            if (ordinal) formatTokenFunctions[ordinal] = function() {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
        function removeFormattingTokens(input) {
            if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
            return input.replace(/\\/g, '');
        }
        function makeFormatFunction(format) {
            var array = format.match(formattingTokens), i, length;
            for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
            else array[i] = removeFormattingTokens(array[i]);
            return function(mom) {
                var output = '', i;
                for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
                return output;
            };
        }
        function formatMoment(m, format) {
            if (!m.isValid()) return m.localeData().invalidDate();
            format = expandFormat(format, m.localeData());
            formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
            return formatFunctions[format](m);
        }
        function expandFormat(format, locale) {
            var i = 5;
            function replaceLongDateFormatTokens(input) {
                return locale.longDateFormat(input) || input;
            }
            localFormattingTokens.lastIndex = 0;
            while(i >= 0 && localFormattingTokens.test(format)){
                format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
                localFormattingTokens.lastIndex = 0;
                i -= 1;
            }
            return format;
        }
        var defaultLongDateFormat = {
            LTS: 'h:mm:ss A',
            LT: 'h:mm A',
            L: 'MM/DD/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY h:mm A',
            LLLL: 'dddd, MMMM D, YYYY h:mm A'
        };
        function longDateFormat(key) {
            var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
            if (format || !formatUpper) return format;
            this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
                if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
                return tok;
            }).join('');
            return this._longDateFormat[key];
        }
        var defaultInvalidDate = 'Invalid date';
        function invalidDate() {
            return this._invalidDate;
        }
        var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
        function ordinal(number) {
            return this._ordinal.replace('%d', number);
        }
        var defaultRelativeTime = {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            w: 'a week',
            ww: '%d weeks',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years'
        };
        function relativeTime(number, withoutSuffix, string, isFuture) {
            var output = this._relativeTime[string];
            return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
        }
        function pastFuture(diff, output) {
            var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
            return isFunction(format) ? format(output) : format.replace(/%s/i, output);
        }
        var aliases = {
            D: 'date',
            dates: 'date',
            date: 'date',
            d: 'day',
            days: 'day',
            day: 'day',
            e: 'weekday',
            weekdays: 'weekday',
            weekday: 'weekday',
            E: 'isoWeekday',
            isoweekdays: 'isoWeekday',
            isoweekday: 'isoWeekday',
            DDD: 'dayOfYear',
            dayofyears: 'dayOfYear',
            dayofyear: 'dayOfYear',
            h: 'hour',
            hours: 'hour',
            hour: 'hour',
            ms: 'millisecond',
            milliseconds: 'millisecond',
            millisecond: 'millisecond',
            m: 'minute',
            minutes: 'minute',
            minute: 'minute',
            M: 'month',
            months: 'month',
            month: 'month',
            Q: 'quarter',
            quarters: 'quarter',
            quarter: 'quarter',
            s: 'second',
            seconds: 'second',
            second: 'second',
            gg: 'weekYear',
            weekyears: 'weekYear',
            weekyear: 'weekYear',
            GG: 'isoWeekYear',
            isoweekyears: 'isoWeekYear',
            isoweekyear: 'isoWeekYear',
            w: 'week',
            weeks: 'week',
            week: 'week',
            W: 'isoWeek',
            isoweeks: 'isoWeek',
            isoweek: 'isoWeek',
            y: 'year',
            years: 'year',
            year: 'year'
        };
        function normalizeUnits(units) {
            return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
        }
        function normalizeObjectUnits(inputObject) {
            var normalizedInput = {}, normalizedProp, prop;
            for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
            }
            return normalizedInput;
        }
        var priorities = {
            date: 9,
            day: 11,
            weekday: 11,
            isoWeekday: 11,
            dayOfYear: 4,
            hour: 13,
            millisecond: 16,
            minute: 14,
            month: 8,
            quarter: 7,
            second: 15,
            weekYear: 1,
            isoWeekYear: 1,
            week: 5,
            isoWeek: 5,
            year: 1
        };
        function getPrioritizedUnits(unitsObj) {
            var units = [], u;
            for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
                unit: u,
                priority: priorities[u]
            });
            units.sort(function(a, b) {
                return a.priority - b.priority;
            });
            return units;
        }
        var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
        regexes = {};
        function addRegexToken(token, regex, strictRegex) {
            regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
                return isStrict && strictRegex ? strictRegex : regex;
            };
        }
        function getParseRegexForToken(token, config) {
            if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
            return regexes[token](config._strict, config._locale);
        }
        function unescapeFormat(s) {
            return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
                return p1 || p2 || p3 || p4;
            }));
        }
        function regexEscape(s) {
            return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
        }
        function absFloor(number) {
            if (number < 0) return Math.ceil(number) || 0;
            else return Math.floor(number);
        }
        function toInt(argumentForCoercion) {
            var coercedNumber = +argumentForCoercion, value = 0;
            if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
            return value;
        }
        var tokens = {};
        function addParseToken(token, callback) {
            var i, func = callback, tokenLen;
            if (typeof token === 'string') token = [
                token
            ];
            if (isNumber(callback)) func = function(input, array) {
                array[callback] = toInt(input);
            };
            tokenLen = token.length;
            for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
        }
        function addWeekParseToken(token, callback) {
            addParseToken(token, function(input, array, config, token) {
                config._w = config._w || {};
                callback(input, config._w, config, token);
            });
        }
        function addTimeToArrayFromToken(token, input, config) {
            if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
        }
        function isLeapYear(year) {
            return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
        }
        var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
        addFormatToken('Y', 0, 0, function() {
            var y = this.year();
            return y <= 9999 ? zeroFill(y, 4) : '+' + y;
        });
        addFormatToken(0, [
            'YY',
            2
        ], 0, function() {
            return this.year() % 100;
        });
        addFormatToken(0, [
            'YYYY',
            4
        ], 0, 'year');
        addFormatToken(0, [
            'YYYYY',
            5
        ], 0, 'year');
        addFormatToken(0, [
            'YYYYYY',
            6,
            true
        ], 0, 'year');
        addRegexToken('Y', matchSigned);
        addRegexToken('YY', match1to2, match2);
        addRegexToken('YYYY', match1to4, match4);
        addRegexToken('YYYYY', match1to6, match6);
        addRegexToken('YYYYYY', match1to6, match6);
        addParseToken([
            'YYYYY',
            'YYYYYY'
        ], YEAR);
        addParseToken('YYYY', function(input, array) {
            array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
        });
        addParseToken('YY', function(input, array) {
            array[YEAR] = hooks.parseTwoDigitYear(input);
        });
        addParseToken('Y', function(input, array) {
            array[YEAR] = parseInt(input, 10);
        });
        function daysInYear(year) {
            return isLeapYear(year) ? 366 : 365;
        }
        hooks.parseTwoDigitYear = function(input) {
            return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
        };
        var getSetYear = makeGetSet('FullYear', true);
        function getIsLeapYear() {
            return isLeapYear(this.year());
        }
        function makeGetSet(unit, keepTime) {
            return function(value) {
                if (value != null) {
                    set$1(this, unit, value);
                    hooks.updateOffset(this, keepTime);
                    return this;
                } else return get(this, unit);
            };
        }
        function get(mom, unit) {
            if (!mom.isValid()) return NaN;
            var d = mom._d, isUTC = mom._isUTC;
            switch(unit){
                case 'Milliseconds':
                    return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
                case 'Seconds':
                    return isUTC ? d.getUTCSeconds() : d.getSeconds();
                case 'Minutes':
                    return isUTC ? d.getUTCMinutes() : d.getMinutes();
                case 'Hours':
                    return isUTC ? d.getUTCHours() : d.getHours();
                case 'Date':
                    return isUTC ? d.getUTCDate() : d.getDate();
                case 'Day':
                    return isUTC ? d.getUTCDay() : d.getDay();
                case 'Month':
                    return isUTC ? d.getUTCMonth() : d.getMonth();
                case 'FullYear':
                    return isUTC ? d.getUTCFullYear() : d.getFullYear();
                default:
                    return NaN;
            }
        }
        function set$1(mom, unit, value) {
            var d, isUTC, year, month, date;
            if (!mom.isValid() || isNaN(value)) return;
            d = mom._d;
            isUTC = mom._isUTC;
            switch(unit){
                case 'Milliseconds':
                    return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
                case 'Seconds':
                    return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
                case 'Minutes':
                    return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
                case 'Hours':
                    return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
                case 'Date':
                    return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
                case 'FullYear':
                    break;
                default:
                    return;
            }
            year = value;
            month = mom.month();
            date = mom.date();
            date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
            isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
        }
        function stringGet(units) {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units]();
            return this;
        }
        function stringSet(units, value) {
            if (typeof units === 'object') {
                units = normalizeObjectUnits(units);
                var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
                for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
            } else {
                units = normalizeUnits(units);
                if (isFunction(this[units])) return this[units](value);
            }
            return this;
        }
        function mod(n, x) {
            return (n % x + x) % x;
        }
        var indexOf;
        if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
        else indexOf = function(o) {
            var i;
            for(i = 0; i < this.length; ++i){
                if (this[i] === o) return i;
            }
            return -1;
        };
        function daysInMonth(year, month) {
            if (isNaN(year) || isNaN(month)) return NaN;
            var modMonth = mod(month, 12);
            year += (month - modMonth) / 12;
            return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
        }
        addFormatToken('M', [
            'MM',
            2
        ], 'Mo', function() {
            return this.month() + 1;
        });
        addFormatToken('MMM', 0, 0, function(format) {
            return this.localeData().monthsShort(this, format);
        });
        addFormatToken('MMMM', 0, 0, function(format) {
            return this.localeData().months(this, format);
        });
        addRegexToken('M', match1to2, match1to2NoLeadingZero);
        addRegexToken('MM', match1to2, match2);
        addRegexToken('MMM', function(isStrict, locale) {
            return locale.monthsShortRegex(isStrict);
        });
        addRegexToken('MMMM', function(isStrict, locale) {
            return locale.monthsRegex(isStrict);
        });
        addParseToken([
            'M',
            'MM'
        ], function(input, array) {
            array[MONTH] = toInt(input) - 1;
        });
        addParseToken([
            'MMM',
            'MMMM'
        ], function(input, array, config, token) {
            var month = config._locale.monthsParse(input, token, config._strict);
            if (month != null) array[MONTH] = month;
            else getParsingFlags(config).invalidMonth = input;
        });
        var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
        function localeMonths(m, format) {
            if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
            return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
        }
        function localeMonthsShort(m, format) {
            if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
            return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
        }
        function handleStrictParse(monthName, format, strict) {
            var i, ii, mom, llc = monthName.toLocaleLowerCase();
            if (!this._monthsParse) {
                this._monthsParse = [];
                this._longMonthsParse = [];
                this._shortMonthsParse = [];
                for(i = 0; i < 12; ++i){
                    mom = createUTC([
                        2000,
                        i
                    ]);
                    this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                    this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
                }
            }
            if (strict) {
                if (format === 'MMM') {
                    ii = indexOf.call(this._shortMonthsParse, llc);
                    return ii !== -1 ? ii : null;
                } else {
                    ii = indexOf.call(this._longMonthsParse, llc);
                    return ii !== -1 ? ii : null;
                }
            } else if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
        function localeMonthsParse(monthName, format, strict) {
            var i, mom, regex;
            if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
            if (!this._monthsParse) {
                this._monthsParse = [];
                this._longMonthsParse = [];
                this._shortMonthsParse = [];
            }
            for(i = 0; i < 12; i++){
                mom = createUTC([
                    2000,
                    i
                ]);
                if (strict && !this._longMonthsParse[i]) {
                    this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                    this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
                }
                if (!strict && !this._monthsParse[i]) {
                    regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                    this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
                }
                if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
                else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
                else if (!strict && this._monthsParse[i].test(monthName)) return i;
            }
        }
        function setMonth(mom, value) {
            if (!mom.isValid()) return mom;
            if (typeof value === 'string') {
                if (/^\d+$/.test(value)) value = toInt(value);
                else {
                    value = mom.localeData().monthsParse(value);
                    if (!isNumber(value)) return mom;
                }
            }
            var month = value, date = mom.date();
            date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
            mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
            return mom;
        }
        function getSetMonth(value) {
            if (value != null) {
                setMonth(this, value);
                hooks.updateOffset(this, true);
                return this;
            } else return get(this, 'Month');
        }
        function getDaysInMonth() {
            return daysInMonth(this.year(), this.month());
        }
        function monthsShortRegex(isStrict) {
            if (this._monthsParseExact) {
                if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
                if (isStrict) return this._monthsShortStrictRegex;
                else return this._monthsShortRegex;
            } else {
                if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
                return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
            }
        }
        function monthsRegex(isStrict) {
            if (this._monthsParseExact) {
                if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
                if (isStrict) return this._monthsStrictRegex;
                else return this._monthsRegex;
            } else {
                if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
                return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
            }
        }
        function computeMonthsParse() {
            function cmpLenRev(a, b) {
                return b.length - a.length;
            }
            var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
            for(i = 0; i < 12; i++){
                mom = createUTC([
                    2000,
                    i
                ]);
                shortP = regexEscape(this.monthsShort(mom, ''));
                longP = regexEscape(this.months(mom, ''));
                shortPieces.push(shortP);
                longPieces.push(longP);
                mixedPieces.push(longP);
                mixedPieces.push(shortP);
            }
            shortPieces.sort(cmpLenRev);
            longPieces.sort(cmpLenRev);
            mixedPieces.sort(cmpLenRev);
            this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
            this._monthsShortRegex = this._monthsRegex;
            this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
            this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        }
        function createDate(y, m, d, h, M, s, ms) {
            var date;
            if (y < 100 && y >= 0) {
                date = new Date(y + 400, m, d, h, M, s, ms);
                if (isFinite(date.getFullYear())) date.setFullYear(y);
            } else date = new Date(y, m, d, h, M, s, ms);
            return date;
        }
        function createUTCDate(y) {
            var date, args;
            if (y < 100 && y >= 0) {
                args = Array.prototype.slice.call(arguments);
                args[0] = y + 400;
                date = new Date(Date.UTC.apply(null, args));
                if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
            } else date = new Date(Date.UTC.apply(null, arguments));
            return date;
        }
        function firstWeekOffset(year, dow, doy) {
            var fwd = 7 + dow - doy, fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
            return -fwdlw + fwd - 1;
        }
        function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
            var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
            if (dayOfYear <= 0) {
                resYear = year - 1;
                resDayOfYear = daysInYear(resYear) + dayOfYear;
            } else if (dayOfYear > daysInYear(year)) {
                resYear = year + 1;
                resDayOfYear = dayOfYear - daysInYear(year);
            } else {
                resYear = year;
                resDayOfYear = dayOfYear;
            }
            return {
                year: resYear,
                dayOfYear: resDayOfYear
            };
        }
        function weekOfYear(mom, dow, doy) {
            var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
            if (week < 1) {
                resYear = mom.year() - 1;
                resWeek = week + weeksInYear(resYear, dow, doy);
            } else if (week > weeksInYear(mom.year(), dow, doy)) {
                resWeek = week - weeksInYear(mom.year(), dow, doy);
                resYear = mom.year() + 1;
            } else {
                resYear = mom.year();
                resWeek = week;
            }
            return {
                week: resWeek,
                year: resYear
            };
        }
        function weeksInYear(year, dow, doy) {
            var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
            return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
        }
        addFormatToken('w', [
            'ww',
            2
        ], 'wo', 'week');
        addFormatToken('W', [
            'WW',
            2
        ], 'Wo', 'isoWeek');
        addRegexToken('w', match1to2, match1to2NoLeadingZero);
        addRegexToken('ww', match1to2, match2);
        addRegexToken('W', match1to2, match1to2NoLeadingZero);
        addRegexToken('WW', match1to2, match2);
        addWeekParseToken([
            'w',
            'ww',
            'W',
            'WW'
        ], function(input, week, config, token) {
            week[token.substr(0, 1)] = toInt(input);
        });
        function localeWeek(mom) {
            return weekOfYear(mom, this._week.dow, this._week.doy).week;
        }
        var defaultLocaleWeek = {
            dow: 0,
            doy: 6
        };
        function localeFirstDayOfWeek() {
            return this._week.dow;
        }
        function localeFirstDayOfYear() {
            return this._week.doy;
        }
        function getSetWeek(input) {
            var week = this.localeData().week(this);
            return input == null ? week : this.add((input - week) * 7, 'd');
        }
        function getSetISOWeek(input) {
            var week = weekOfYear(this, 1, 4).week;
            return input == null ? week : this.add((input - week) * 7, 'd');
        }
        addFormatToken('d', 0, 'do', 'day');
        addFormatToken('dd', 0, 0, function(format) {
            return this.localeData().weekdaysMin(this, format);
        });
        addFormatToken('ddd', 0, 0, function(format) {
            return this.localeData().weekdaysShort(this, format);
        });
        addFormatToken('dddd', 0, 0, function(format) {
            return this.localeData().weekdays(this, format);
        });
        addFormatToken('e', 0, 0, 'weekday');
        addFormatToken('E', 0, 0, 'isoWeekday');
        addRegexToken('d', match1to2);
        addRegexToken('e', match1to2);
        addRegexToken('E', match1to2);
        addRegexToken('dd', function(isStrict, locale) {
            return locale.weekdaysMinRegex(isStrict);
        });
        addRegexToken('ddd', function(isStrict, locale) {
            return locale.weekdaysShortRegex(isStrict);
        });
        addRegexToken('dddd', function(isStrict, locale) {
            return locale.weekdaysRegex(isStrict);
        });
        addWeekParseToken([
            'dd',
            'ddd',
            'dddd'
        ], function(input, week, config, token) {
            var weekday = config._locale.weekdaysParse(input, token, config._strict);
            if (weekday != null) week.d = weekday;
            else getParsingFlags(config).invalidWeekday = input;
        });
        addWeekParseToken([
            'd',
            'e',
            'E'
        ], function(input, week, config, token) {
            week[token] = toInt(input);
        });
        function parseWeekday(input, locale) {
            if (typeof input !== 'string') return input;
            if (!isNaN(input)) return parseInt(input, 10);
            input = locale.weekdaysParse(input);
            if (typeof input === 'number') return input;
            return null;
        }
        function parseIsoWeekday(input, locale) {
            if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
            return isNaN(input) ? null : input;
        }
        function shiftWeekdays(ws, n) {
            return ws.slice(n, 7).concat(ws.slice(0, n));
        }
        var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
        function localeWeekdays(m, format) {
            var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
            return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
        }
        function localeWeekdaysShort(m) {
            return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
        }
        function localeWeekdaysMin(m) {
            return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
        }
        function handleStrictParse$1(weekdayName, format, strict) {
            var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
            if (!this._weekdaysParse) {
                this._weekdaysParse = [];
                this._shortWeekdaysParse = [];
                this._minWeekdaysParse = [];
                for(i = 0; i < 7; ++i){
                    mom = createUTC([
                        2000,
                        1
                    ]).day(i);
                    this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                    this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                    this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
                }
            }
            if (strict) {
                if (format === 'dddd') {
                    ii = indexOf.call(this._weekdaysParse, llc);
                    return ii !== -1 ? ii : null;
                } else if (format === 'ddd') {
                    ii = indexOf.call(this._shortWeekdaysParse, llc);
                    return ii !== -1 ? ii : null;
                } else {
                    ii = indexOf.call(this._minWeekdaysParse, llc);
                    return ii !== -1 ? ii : null;
                }
            } else {
                if (format === 'dddd') {
                    ii = indexOf.call(this._weekdaysParse, llc);
                    if (ii !== -1) return ii;
                    ii = indexOf.call(this._shortWeekdaysParse, llc);
                    if (ii !== -1) return ii;
                    ii = indexOf.call(this._minWeekdaysParse, llc);
                    return ii !== -1 ? ii : null;
                } else if (format === 'ddd') {
                    ii = indexOf.call(this._shortWeekdaysParse, llc);
                    if (ii !== -1) return ii;
                    ii = indexOf.call(this._weekdaysParse, llc);
                    if (ii !== -1) return ii;
                    ii = indexOf.call(this._minWeekdaysParse, llc);
                    return ii !== -1 ? ii : null;
                } else {
                    ii = indexOf.call(this._minWeekdaysParse, llc);
                    if (ii !== -1) return ii;
                    ii = indexOf.call(this._weekdaysParse, llc);
                    if (ii !== -1) return ii;
                    ii = indexOf.call(this._shortWeekdaysParse, llc);
                    return ii !== -1 ? ii : null;
                }
            }
        }
        function localeWeekdaysParse(weekdayName, format, strict) {
            var i, mom, regex;
            if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
            if (!this._weekdaysParse) {
                this._weekdaysParse = [];
                this._minWeekdaysParse = [];
                this._shortWeekdaysParse = [];
                this._fullWeekdaysParse = [];
            }
            for(i = 0; i < 7; i++){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                if (strict && !this._fullWeekdaysParse[i]) {
                    this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                    this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                    this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
                }
                if (!this._weekdaysParse[i]) {
                    regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                    this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
                }
                if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
                else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
                else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
                else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
            }
        }
        function getSetDayOfWeek(input) {
            if (!this.isValid()) return input != null ? this : NaN;
            var day = get(this, 'Day');
            if (input != null) {
                input = parseWeekday(input, this.localeData());
                return this.add(input - day, 'd');
            } else return day;
        }
        function getSetLocaleDayOfWeek(input) {
            if (!this.isValid()) return input != null ? this : NaN;
            var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
            return input == null ? weekday : this.add(input - weekday, 'd');
        }
        function getSetISODayOfWeek(input) {
            if (!this.isValid()) return input != null ? this : NaN;
            if (input != null) {
                var weekday = parseIsoWeekday(input, this.localeData());
                return this.day(this.day() % 7 ? weekday : weekday - 7);
            } else return this.day() || 7;
        }
        function weekdaysRegex(isStrict) {
            if (this._weekdaysParseExact) {
                if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
                if (isStrict) return this._weekdaysStrictRegex;
                else return this._weekdaysRegex;
            } else {
                if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
                return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
            }
        }
        function weekdaysShortRegex(isStrict) {
            if (this._weekdaysParseExact) {
                if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
                if (isStrict) return this._weekdaysShortStrictRegex;
                else return this._weekdaysShortRegex;
            } else {
                if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
                return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
            }
        }
        function weekdaysMinRegex(isStrict) {
            if (this._weekdaysParseExact) {
                if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
                if (isStrict) return this._weekdaysMinStrictRegex;
                else return this._weekdaysMinRegex;
            } else {
                if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
                return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
            }
        }
        function computeWeekdaysParse() {
            function cmpLenRev(a, b) {
                return b.length - a.length;
            }
            var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
            for(i = 0; i < 7; i++){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                minp = regexEscape(this.weekdaysMin(mom, ''));
                shortp = regexEscape(this.weekdaysShort(mom, ''));
                longp = regexEscape(this.weekdays(mom, ''));
                minPieces.push(minp);
                shortPieces.push(shortp);
                longPieces.push(longp);
                mixedPieces.push(minp);
                mixedPieces.push(shortp);
                mixedPieces.push(longp);
            }
            minPieces.sort(cmpLenRev);
            shortPieces.sort(cmpLenRev);
            longPieces.sort(cmpLenRev);
            mixedPieces.sort(cmpLenRev);
            this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
            this._weekdaysShortRegex = this._weekdaysRegex;
            this._weekdaysMinRegex = this._weekdaysRegex;
            this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
            this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
            this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
        }
        function hFormat() {
            return this.hours() % 12 || 12;
        }
        function kFormat() {
            return this.hours() || 24;
        }
        addFormatToken('H', [
            'HH',
            2
        ], 0, 'hour');
        addFormatToken('h', [
            'hh',
            2
        ], 0, hFormat);
        addFormatToken('k', [
            'kk',
            2
        ], 0, kFormat);
        addFormatToken('hmm', 0, 0, function() {
            return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
        });
        addFormatToken('hmmss', 0, 0, function() {
            return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
        });
        addFormatToken('Hmm', 0, 0, function() {
            return '' + this.hours() + zeroFill(this.minutes(), 2);
        });
        addFormatToken('Hmmss', 0, 0, function() {
            return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
        });
        function meridiem(token, lowercase) {
            addFormatToken(token, 0, 0, function() {
                return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
            });
        }
        meridiem('a', true);
        meridiem('A', false);
        function matchMeridiem(isStrict, locale) {
            return locale._meridiemParse;
        }
        addRegexToken('a', matchMeridiem);
        addRegexToken('A', matchMeridiem);
        addRegexToken('H', match1to2, match1to2HasZero);
        addRegexToken('h', match1to2, match1to2NoLeadingZero);
        addRegexToken('k', match1to2, match1to2NoLeadingZero);
        addRegexToken('HH', match1to2, match2);
        addRegexToken('hh', match1to2, match2);
        addRegexToken('kk', match1to2, match2);
        addRegexToken('hmm', match3to4);
        addRegexToken('hmmss', match5to6);
        addRegexToken('Hmm', match3to4);
        addRegexToken('Hmmss', match5to6);
        addParseToken([
            'H',
            'HH'
        ], HOUR);
        addParseToken([
            'k',
            'kk'
        ], function(input, array, config) {
            var kInput = toInt(input);
            array[HOUR] = kInput === 24 ? 0 : kInput;
        });
        addParseToken([
            'a',
            'A'
        ], function(input, array, config) {
            config._isPm = config._locale.isPM(input);
            config._meridiem = input;
        });
        addParseToken([
            'h',
            'hh'
        ], function(input, array, config) {
            array[HOUR] = toInt(input);
            getParsingFlags(config).bigHour = true;
        });
        addParseToken('hmm', function(input, array, config) {
            var pos = input.length - 2;
            array[HOUR] = toInt(input.substr(0, pos));
            array[MINUTE] = toInt(input.substr(pos));
            getParsingFlags(config).bigHour = true;
        });
        addParseToken('hmmss', function(input, array, config) {
            var pos1 = input.length - 4, pos2 = input.length - 2;
            array[HOUR] = toInt(input.substr(0, pos1));
            array[MINUTE] = toInt(input.substr(pos1, 2));
            array[SECOND] = toInt(input.substr(pos2));
            getParsingFlags(config).bigHour = true;
        });
        addParseToken('Hmm', function(input, array, config) {
            var pos = input.length - 2;
            array[HOUR] = toInt(input.substr(0, pos));
            array[MINUTE] = toInt(input.substr(pos));
        });
        addParseToken('Hmmss', function(input, array, config) {
            var pos1 = input.length - 4, pos2 = input.length - 2;
            array[HOUR] = toInt(input.substr(0, pos1));
            array[MINUTE] = toInt(input.substr(pos1, 2));
            array[SECOND] = toInt(input.substr(pos2));
        });
        function localeIsPM(input) {
            return (input + '').toLowerCase().charAt(0) === 'p';
        }
        var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, getSetHour = makeGetSet('Hours', true);
        function localeMeridiem(hours, minutes, isLower) {
            if (hours > 11) return isLower ? 'pm' : 'PM';
            else return isLower ? 'am' : 'AM';
        }
        var baseConfig = {
            calendar: defaultCalendar,
            longDateFormat: defaultLongDateFormat,
            invalidDate: defaultInvalidDate,
            ordinal: defaultOrdinal,
            dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
            relativeTime: defaultRelativeTime,
            months: defaultLocaleMonths,
            monthsShort: defaultLocaleMonthsShort,
            week: defaultLocaleWeek,
            weekdays: defaultLocaleWeekdays,
            weekdaysMin: defaultLocaleWeekdaysMin,
            weekdaysShort: defaultLocaleWeekdaysShort,
            meridiemParse: defaultLocaleMeridiemParse
        };
        var locales = {}, localeFamilies = {}, globalLocale;
        function commonPrefix(arr1, arr2) {
            var i, minl = Math.min(arr1.length, arr2.length);
            for(i = 0; i < minl; i += 1){
                if (arr1[i] !== arr2[i]) return i;
            }
            return minl;
        }
        function normalizeLocale(key) {
            return key ? key.toLowerCase().replace('_', '-') : key;
        }
        function chooseLocale(names) {
            var i = 0, j, next, locale, split;
            while(i < names.length){
                split = normalizeLocale(names[i]).split('-');
                j = split.length;
                next = normalizeLocale(names[i + 1]);
                next = next ? next.split('-') : null;
                while(j > 0){
                    locale = loadLocale(split.slice(0, j).join('-'));
                    if (locale) return locale;
                    if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                    j--;
                }
                i++;
            }
            return globalLocale;
        }
        function isLocaleNameSane(name) {
            return !!(name && name.match('^[^/\\\\]*$'));
        }
        function loadLocale(name) {
            var oldLocale = null, aliasedRequire;
            if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = undefined;
                aliasedRequire('./locale/' + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                locales[name] = null;
            }
            return locales[name];
        }
        function getSetGlobalLocale(key, values) {
            var data;
            if (key) {
                if (isUndefined(values)) data = getLocale(key);
                else data = defineLocale(key, values);
                if (data) globalLocale = data;
                else if (typeof console !== 'undefined' && console.warn) console.warn('Locale ' + key + ' not found. Did you forget to load it?');
            }
            return globalLocale._abbr;
        }
        function defineLocale(name, config) {
            if (config !== null) {
                var locale, parentConfig = baseConfig;
                config.abbr = name;
                if (locales[name] != null) {
                    deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                    parentConfig = locales[name]._config;
                } else if (config.parentLocale != null) {
                    if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                    else {
                        locale = loadLocale(config.parentLocale);
                        if (locale != null) parentConfig = locale._config;
                        else {
                            if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                            localeFamilies[config.parentLocale].push({
                                name: name,
                                config: config
                            });
                            return null;
                        }
                    }
                }
                locales[name] = new Locale(mergeConfigs(parentConfig, config));
                if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                    defineLocale(x.name, x.config);
                });
                getSetGlobalLocale(name);
                return locales[name];
            } else {
                delete locales[name];
                return null;
            }
        }
        function updateLocale(name, config) {
            if (config != null) {
                var locale, tmpLocale, parentConfig = baseConfig;
                if (locales[name] != null && locales[name].parentLocale != null) locales[name].set(mergeConfigs(locales[name]._config, config));
                else {
                    tmpLocale = loadLocale(name);
                    if (tmpLocale != null) parentConfig = tmpLocale._config;
                    config = mergeConfigs(parentConfig, config);
                    if (tmpLocale == null) config.abbr = name;
                    locale = new Locale(config);
                    locale.parentLocale = locales[name];
                    locales[name] = locale;
                }
                getSetGlobalLocale(name);
            } else if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
                } else if (locales[name] != null) delete locales[name];
            }
            return locales[name];
        }
        function getLocale(key) {
            var locale;
            if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
            if (!key) return globalLocale;
            if (!isArray(key)) {
                locale = loadLocale(key);
                if (locale) return locale;
                key = [
                    key
                ];
            }
            return chooseLocale(key);
        }
        function listLocales() {
            return keys(locales);
        }
        function checkOverflow(m) {
            var overflow, a = m._a;
            if (a && getParsingFlags(m).overflow === -2) {
                overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
                if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
                if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
                if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
                getParsingFlags(m).overflow = overflow;
            }
            return m;
        }
        var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
            [
                'YYYYYY-MM-DD',
                /[+-]\d{6}-\d\d-\d\d/
            ],
            [
                'YYYY-MM-DD',
                /\d{4}-\d\d-\d\d/
            ],
            [
                'GGGG-[W]WW-E',
                /\d{4}-W\d\d-\d/
            ],
            [
                'GGGG-[W]WW',
                /\d{4}-W\d\d/,
                false
            ],
            [
                'YYYY-DDD',
                /\d{4}-\d{3}/
            ],
            [
                'YYYY-MM',
                /\d{4}-\d\d/,
                false
            ],
            [
                'YYYYYYMMDD',
                /[+-]\d{10}/
            ],
            [
                'YYYYMMDD',
                /\d{8}/
            ],
            [
                'GGGG[W]WWE',
                /\d{4}W\d{3}/
            ],
            [
                'GGGG[W]WW',
                /\d{4}W\d{2}/,
                false
            ],
            [
                'YYYYDDD',
                /\d{7}/
            ],
            [
                'YYYYMM',
                /\d{6}/,
                false
            ],
            [
                'YYYY',
                /\d{4}/,
                false
            ]
        ], isoTimes = [
            [
                'HH:mm:ss.SSSS',
                /\d\d:\d\d:\d\d\.\d+/
            ],
            [
                'HH:mm:ss,SSSS',
                /\d\d:\d\d:\d\d,\d+/
            ],
            [
                'HH:mm:ss',
                /\d\d:\d\d:\d\d/
            ],
            [
                'HH:mm',
                /\d\d:\d\d/
            ],
            [
                'HHmmss.SSSS',
                /\d\d\d\d\d\d\.\d+/
            ],
            [
                'HHmmss,SSSS',
                /\d\d\d\d\d\d,\d+/
            ],
            [
                'HHmmss',
                /\d\d\d\d\d\d/
            ],
            [
                'HHmm',
                /\d\d\d\d/
            ],
            [
                'HH',
                /\d\d/
            ]
        ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -240,
            EST: -300,
            CDT: -300,
            CST: -360,
            MDT: -360,
            MST: -420,
            PDT: -420,
            PST: -480
        };
        function configFromISO(config) {
            var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
            if (match) {
                getParsingFlags(config).iso = true;
                for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
                if (dateFormat == null) {
                    config._isValid = false;
                    return;
                }
                if (match[3]) {
                    for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                    if (timeFormat == null) {
                        config._isValid = false;
                        return;
                    }
                }
                if (!allowTime && timeFormat != null) {
                    config._isValid = false;
                    return;
                }
                if (match[4]) {
                    if (tzRegex.exec(match[4])) tzFormat = 'Z';
                    else {
                        config._isValid = false;
                        return;
                    }
                }
                config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
                configFromStringAndFormat(config);
            } else config._isValid = false;
        }
        function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
            var result = [
                untruncateYear(yearStr),
                defaultLocaleMonthsShort.indexOf(monthStr),
                parseInt(dayStr, 10),
                parseInt(hourStr, 10),
                parseInt(minuteStr, 10)
            ];
            if (secondStr) result.push(parseInt(secondStr, 10));
            return result;
        }
        function untruncateYear(yearStr) {
            var year = parseInt(yearStr, 10);
            if (year <= 49) return 2000 + year;
            else if (year <= 999) return 1900 + year;
            return year;
        }
        function preprocessRFC2822(s) {
            return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
        }
        function checkWeekday(weekdayStr, parsedInput, config) {
            if (weekdayStr) {
                var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
                if (weekdayProvided !== weekdayActual) {
                    getParsingFlags(config).weekdayMismatch = true;
                    config._isValid = false;
                    return false;
                }
            }
            return true;
        }
        function calculateOffset(obsOffset, militaryOffset, numOffset) {
            if (obsOffset) return obsOffsets[obsOffset];
            else if (militaryOffset) return 0;
            else {
                var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
                return h * 60 + m;
            }
        }
        function configFromRFC2822(config) {
            var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
            if (match) {
                parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
                if (!checkWeekday(match[1], parsedArray, config)) return;
                config._a = parsedArray;
                config._tzm = calculateOffset(match[8], match[9], match[10]);
                config._d = createUTCDate.apply(null, config._a);
                config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
                getParsingFlags(config).rfc2822 = true;
            } else config._isValid = false;
        }
        function configFromString(config) {
            var matched = aspNetJsonRegex.exec(config._i);
            if (matched !== null) {
                config._d = new Date(+matched[1]);
                return;
            }
            configFromISO(config);
            if (config._isValid === false) delete config._isValid;
            else return;
            configFromRFC2822(config);
            if (config._isValid === false) delete config._isValid;
            else return;
            if (config._strict) config._isValid = false;
            else hooks.createFromInputFallback(config);
        }
        hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        });
        function defaults(a, b, c) {
            if (a != null) return a;
            if (b != null) return b;
            return c;
        }
        function currentDateArray(config) {
            var nowValue = new Date(hooks.now());
            if (config._useUTC) return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate()
            ];
            return [
                nowValue.getFullYear(),
                nowValue.getMonth(),
                nowValue.getDate()
            ];
        }
        function configFromArray(config) {
            var i, date, input = [], currentDate, expectedWeekday, yearToUse;
            if (config._d) return;
            currentDate = currentDateArray(config);
            if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
            if (config._dayOfYear != null) {
                yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
                if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
                date = createUTCDate(yearToUse, 0, config._dayOfYear);
                config._a[MONTH] = date.getUTCMonth();
                config._a[DATE] = date.getUTCDate();
            }
            for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
            for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
            if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
                config._nextDay = true;
                config._a[HOUR] = 0;
            }
            config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
            expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
            if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            if (config._nextDay) config._a[HOUR] = 24;
            if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
        }
        function dayOfYearFromWeekInfo(config) {
            var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
            w = config._w;
            if (w.GG != null || w.W != null || w.E != null) {
                dow = 1;
                doy = 4;
                weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
                week = defaults(w.W, 1);
                weekday = defaults(w.E, 1);
                if (weekday < 1 || weekday > 7) weekdayOverflow = true;
            } else {
                dow = config._locale._week.dow;
                doy = config._locale._week.doy;
                curWeek = weekOfYear(createLocal(), dow, doy);
                weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
                week = defaults(w.w, curWeek.week);
                if (w.d != null) {
                    weekday = w.d;
                    if (weekday < 0 || weekday > 6) weekdayOverflow = true;
                } else if (w.e != null) {
                    weekday = w.e + dow;
                    if (w.e < 0 || w.e > 6) weekdayOverflow = true;
                } else weekday = dow;
            }
            if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
            else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
            else {
                temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
                config._a[YEAR] = temp.year;
                config._dayOfYear = temp.dayOfYear;
            }
        }
        hooks.ISO_8601 = function() {};
        hooks.RFC_2822 = function() {};
        function configFromStringAndFormat(config) {
            if (config._f === hooks.ISO_8601) {
                configFromISO(config);
                return;
            }
            if (config._f === hooks.RFC_2822) {
                configFromRFC2822(config);
                return;
            }
            config._a = [];
            getParsingFlags(config).empty = true;
            var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
            tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
            tokenLen = tokens.length;
            for(i = 0; i < tokenLen; i++){
                token = tokens[i];
                parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
                if (parsedInput) {
                    skipped = string.substr(0, string.indexOf(parsedInput));
                    if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                    string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                    totalParsedInputLength += parsedInput.length;
                }
                if (formatTokenFunctions[token]) {
                    if (parsedInput) getParsingFlags(config).empty = false;
                    else getParsingFlags(config).unusedTokens.push(token);
                    addTimeToArrayFromToken(token, parsedInput, config);
                } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
            }
            getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
            if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
            if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
            getParsingFlags(config).parsedDateParts = config._a.slice(0);
            getParsingFlags(config).meridiem = config._meridiem;
            config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
            era = getParsingFlags(config).era;
            if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
            configFromArray(config);
            checkOverflow(config);
        }
        function meridiemFixWrap(locale, hour, meridiem) {
            var isPm;
            if (meridiem == null) return hour;
            if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
            else if (locale.isPM != null) {
                isPm = locale.isPM(meridiem);
                if (isPm && hour < 12) hour += 12;
                if (!isPm && hour === 12) hour = 0;
                return hour;
            } else return hour;
        }
        function configFromStringAndArray(config) {
            var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
            if (configfLen === 0) {
                getParsingFlags(config).invalidFormat = true;
                config._d = new Date(NaN);
                return;
            }
            for(i = 0; i < configfLen; i++){
                currentScore = 0;
                validFormatFound = false;
                tempConfig = copyConfig({}, config);
                if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
                tempConfig._f = config._f[i];
                configFromStringAndFormat(tempConfig);
                if (isValid(tempConfig)) validFormatFound = true;
                currentScore += getParsingFlags(tempConfig).charsLeftOver;
                currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
                getParsingFlags(tempConfig).score = currentScore;
                if (!bestFormatIsValid) {
                    if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                        scoreToBeat = currentScore;
                        bestMoment = tempConfig;
                        if (validFormatFound) bestFormatIsValid = true;
                    }
                } else if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
            extend(config, bestMoment || tempConfig);
        }
        function configFromObject(config) {
            if (config._d) return;
            var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
            config._a = map([
                i.year,
                i.month,
                dayOrDate,
                i.hour,
                i.minute,
                i.second,
                i.millisecond
            ], function(obj) {
                return obj && parseInt(obj, 10);
            });
            configFromArray(config);
        }
        function createFromConfig(config) {
            var res = new Moment(checkOverflow(prepareConfig(config)));
            if (res._nextDay) {
                res.add(1, 'd');
                res._nextDay = undefined;
            }
            return res;
        }
        function prepareConfig(config) {
            var input = config._i, format = config._f;
            config._locale = config._locale || getLocale(config._l);
            if (input === null || format === undefined && input === '') return createInvalid({
                nullInput: true
            });
            if (typeof input === 'string') config._i = input = config._locale.preparse(input);
            if (isMoment(input)) return new Moment(checkOverflow(input));
            else if (isDate(input)) config._d = input;
            else if (isArray(format)) configFromStringAndArray(config);
            else if (format) configFromStringAndFormat(config);
            else configFromInput(config);
            if (!isValid(config)) config._d = null;
            return config;
        }
        function configFromInput(config) {
            var input = config._i;
            if (isUndefined(input)) config._d = new Date(hooks.now());
            else if (isDate(input)) config._d = new Date(input.valueOf());
            else if (typeof input === 'string') configFromString(config);
            else if (isArray(input)) {
                config._a = map(input.slice(0), function(obj) {
                    return parseInt(obj, 10);
                });
                configFromArray(config);
            } else if (isObject(input)) configFromObject(config);
            else if (isNumber(input)) config._d = new Date(input);
            else hooks.createFromInputFallback(config);
        }
        function createLocalOrUTC(input, format, locale, strict, isUTC) {
            var c = {};
            if (format === true || format === false) {
                strict = format;
                format = undefined;
            }
            if (locale === true || locale === false) {
                strict = locale;
                locale = undefined;
            }
            if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
            c._isAMomentObject = true;
            c._useUTC = c._isUTC = isUTC;
            c._l = locale;
            c._i = input;
            c._f = format;
            c._strict = strict;
            return createFromConfig(c);
        }
        function createLocal(input, format, locale, strict) {
            return createLocalOrUTC(input, format, locale, strict, false);
        }
        var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) return other < this ? this : other;
            else return createInvalid();
        }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) return other > this ? this : other;
            else return createInvalid();
        });
        function pickBy(fn, moments) {
            var res, i;
            if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
            if (!moments.length) return createLocal();
            res = moments[0];
            for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
            return res;
        }
        function min() {
            var args = [].slice.call(arguments, 0);
            return pickBy('isBefore', args);
        }
        function max() {
            var args = [].slice.call(arguments, 0);
            return pickBy('isAfter', args);
        }
        var now = function() {
            return Date.now ? Date.now() : +new Date();
        };
        var ordering = [
            'year',
            'quarter',
            'month',
            'week',
            'day',
            'hour',
            'minute',
            'second',
            'millisecond'
        ];
        function isDurationValid(m) {
            var key, unitHasDecimal = false, i, orderLen = ordering.length;
            for(key in m){
                if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
            }
            for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
                if (unitHasDecimal) return false;
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
            }
            return true;
        }
        function isValid$1() {
            return this._isValid;
        }
        function createInvalid$1() {
            return createDuration(NaN);
        }
        function Duration(duration) {
            var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
            this._isValid = isDurationValid(normalizedInput);
            this._milliseconds = +milliseconds + seconds * 1e3 + minutes * 6e4 + hours * 3600000;
            this._days = +days + weeks * 7;
            this._months = +months + quarters * 3 + years * 12;
            this._data = {};
            this._locale = getLocale();
            this._bubble();
        }
        function isDuration(obj) {
            return obj instanceof Duration;
        }
        function absRound(number) {
            if (number < 0) return Math.round(-1 * number) * -1;
            else return Math.round(number);
        }
        function compareArrays(array1, array2, dontConvert) {
            var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
            for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
            return diffs + lengthDiff;
        }
        function offset(token, separator) {
            addFormatToken(token, 0, 0, function() {
                var offset = this.utcOffset(), sign = '+';
                if (offset < 0) {
                    offset = -offset;
                    sign = '-';
                }
                return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
            });
        }
        offset('Z', ':');
        offset('ZZ', '');
        addRegexToken('Z', matchShortOffset);
        addRegexToken('ZZ', matchShortOffset);
        addParseToken([
            'Z',
            'ZZ'
        ], function(input, array, config) {
            config._useUTC = true;
            config._tzm = offsetFromString(matchShortOffset, input);
        });
        var chunkOffset = /([\+\-]|\d\d)/gi;
        function offsetFromString(matcher, string) {
            var matches = (string || '').match(matcher), chunk, parts, minutes;
            if (matches === null) return null;
            chunk = matches[matches.length - 1] || [];
            parts = (chunk + '').match(chunkOffset) || [
                '-',
                0,
                0
            ];
            minutes = +(parts[1] * 60) + toInt(parts[2]);
            return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
        }
        function cloneWithOffset(input, model) {
            var res, diff;
            if (model._isUTC) {
                res = model.clone();
                diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
                res._d.setTime(res._d.valueOf() + diff);
                hooks.updateOffset(res, false);
                return res;
            } else return createLocal(input).local();
        }
        function getDateOffset(m) {
            return -Math.round(m._d.getTimezoneOffset());
        }
        hooks.updateOffset = function() {};
        function getSetOffset(input, keepLocalTime, keepMinutes) {
            var offset = this._offset || 0, localAdjust;
            if (!this.isValid()) return input != null ? this : NaN;
            if (input != null) {
                if (typeof input === 'string') {
                    input = offsetFromString(matchShortOffset, input);
                    if (input === null) return this;
                } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
                if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
                this._offset = input;
                this._isUTC = true;
                if (localAdjust != null) this.add(localAdjust, 'm');
                if (offset !== input) {
                    if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                    else if (!this._changeInProgress) {
                        this._changeInProgress = true;
                        hooks.updateOffset(this, true);
                        this._changeInProgress = null;
                    }
                }
                return this;
            } else return this._isUTC ? offset : getDateOffset(this);
        }
        function getSetZone(input, keepLocalTime) {
            if (input != null) {
                if (typeof input !== 'string') input = -input;
                this.utcOffset(input, keepLocalTime);
                return this;
            } else return -this.utcOffset();
        }
        function setOffsetToUTC(keepLocalTime) {
            return this.utcOffset(0, keepLocalTime);
        }
        function setOffsetToLocal(keepLocalTime) {
            if (this._isUTC) {
                this.utcOffset(0, keepLocalTime);
                this._isUTC = false;
                if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
            }
            return this;
        }
        function setOffsetToParsedOffset() {
            if (this._tzm != null) this.utcOffset(this._tzm, false, true);
            else if (typeof this._i === 'string') {
                var tZone = offsetFromString(matchOffset, this._i);
                if (tZone != null) this.utcOffset(tZone);
                else this.utcOffset(0, true);
            }
            return this;
        }
        function hasAlignedHourOffset(input) {
            if (!this.isValid()) return false;
            input = input ? createLocal(input).utcOffset() : 0;
            return (this.utcOffset() - input) % 60 === 0;
        }
        function isDaylightSavingTime() {
            return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
        }
        function isDaylightSavingTimeShifted() {
            if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
            var c = {}, other;
            copyConfig(c, this);
            c = prepareConfig(c);
            if (c._a) {
                other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
                this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
            } else this._isDSTShifted = false;
            return this._isDSTShifted;
        }
        function isLocal() {
            return this.isValid() ? !this._isUTC : false;
        }
        function isUtcOffset() {
            return this.isValid() ? this._isUTC : false;
        }
        function isUtc() {
            return this.isValid() ? this._isUTC && this._offset === 0 : false;
        }
        var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
        function createDuration(input, key) {
            var duration = input, match = null, sign, ret, diffRes;
            if (isDuration(input)) duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months
            };
            else if (isNumber(input) || !isNaN(+input)) {
                duration = {};
                if (key) duration[key] = +input;
                else duration.milliseconds = +input;
            } else if (match = aspNetRegex.exec(input)) {
                sign = match[1] === '-' ? -1 : 1;
                duration = {
                    y: 0,
                    d: toInt(match[DATE]) * sign,
                    h: toInt(match[HOUR]) * sign,
                    m: toInt(match[MINUTE]) * sign,
                    s: toInt(match[SECOND]) * sign,
                    ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
                };
            } else if (match = isoRegex.exec(input)) {
                sign = match[1] === '-' ? -1 : 1;
                duration = {
                    y: parseIso(match[2], sign),
                    M: parseIso(match[3], sign),
                    w: parseIso(match[4], sign),
                    d: parseIso(match[5], sign),
                    h: parseIso(match[6], sign),
                    m: parseIso(match[7], sign),
                    s: parseIso(match[8], sign)
                };
            } else if (duration == null) duration = {};
            else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
                diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
                duration = {};
                duration.ms = diffRes.milliseconds;
                duration.M = diffRes.months;
            }
            ret = new Duration(duration);
            if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
            if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
            return ret;
        }
        createDuration.fn = Duration.prototype;
        createDuration.invalid = createInvalid$1;
        function parseIso(inp, sign) {
            var res = inp && parseFloat(inp.replace(',', '.'));
            return (isNaN(res) ? 0 : res) * sign;
        }
        function positiveMomentsDifference(base, other) {
            var res = {};
            res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
            if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
            res.milliseconds = +other - +base.clone().add(res.months, 'M');
            return res;
        }
        function momentsDifference(base, other) {
            var res;
            if (!(base.isValid() && other.isValid())) return {
                milliseconds: 0,
                months: 0
            };
            other = cloneWithOffset(other, base);
            if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
            else {
                res = positiveMomentsDifference(other, base);
                res.milliseconds = -res.milliseconds;
                res.months = -res.months;
            }
            return res;
        }
        function createAdder(direction, name) {
            return function(val, period) {
                var dur, tmp;
                if (period !== null && !isNaN(+period)) {
                    deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                    tmp = val;
                    val = period;
                    period = tmp;
                }
                dur = createDuration(val, period);
                addSubtract(this, dur, direction);
                return this;
            };
        }
        function addSubtract(mom, duration, isAdding, updateOffset) {
            var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
            if (!mom.isValid()) return;
            updateOffset = updateOffset == null ? true : updateOffset;
            if (months) setMonth(mom, get(mom, 'Month') + months * isAdding);
            if (days) set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
            if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
            if (updateOffset) hooks.updateOffset(mom, days || months);
        }
        var add = createAdder(1, 'add'), subtract = createAdder(-1, 'subtract');
        function isString(input) {
            return typeof input === 'string' || input instanceof String;
        }
        function isMomentInput(input) {
            return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
        }
        function isMomentInputObject(input) {
            var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms'
            ], i, property, propertyLen = properties.length;
            for(i = 0; i < propertyLen; i += 1){
                property = properties[i];
                propertyTest = propertyTest || hasOwnProp(input, property);
            }
            return objectTest && propertyTest;
        }
        function isNumberOrStringArray(input) {
            var arrayTest = isArray(input), dataTypeTest = false;
            if (arrayTest) dataTypeTest = input.filter(function(item) {
                return !isNumber(item) && isString(input);
            }).length === 0;
            return arrayTest && dataTypeTest;
        }
        function isCalendarSpec(input) {
            var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse'
            ], i, property;
            for(i = 0; i < properties.length; i += 1){
                property = properties[i];
                propertyTest = propertyTest || hasOwnProp(input, property);
            }
            return objectTest && propertyTest;
        }
        function getCalendarFormat(myMoment, now) {
            var diff = myMoment.diff(now, 'days', true);
            return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
        }
        function calendar$1(time, formats) {
            if (arguments.length === 1) {
                if (!arguments[0]) {
                    time = undefined;
                    formats = undefined;
                } else if (isMomentInput(arguments[0])) {
                    time = arguments[0];
                    formats = undefined;
                } else if (isCalendarSpec(arguments[0])) {
                    formats = arguments[0];
                    time = undefined;
                }
            }
            var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
            return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
        }
        function clone() {
            return new Moment(this);
        }
        function isAfter(input, units) {
            var localInput = isMoment(input) ? input : createLocal(input);
            if (!(this.isValid() && localInput.isValid())) return false;
            units = normalizeUnits(units) || 'millisecond';
            if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
            else return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
        function isBefore(input, units) {
            var localInput = isMoment(input) ? input : createLocal(input);
            if (!(this.isValid() && localInput.isValid())) return false;
            units = normalizeUnits(units) || 'millisecond';
            if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
            else return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
        function isBetween(from, to, units, inclusivity) {
            var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
            if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
            inclusivity = inclusivity || '()';
            return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
        }
        function isSame(input, units) {
            var localInput = isMoment(input) ? input : createLocal(input), inputMs;
            if (!(this.isValid() && localInput.isValid())) return false;
            units = normalizeUnits(units) || 'millisecond';
            if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
            else {
                inputMs = localInput.valueOf();
                return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
            }
        }
        function isSameOrAfter(input, units) {
            return this.isSame(input, units) || this.isAfter(input, units);
        }
        function isSameOrBefore(input, units) {
            return this.isSame(input, units) || this.isBefore(input, units);
        }
        function diff(input, units, asFloat) {
            var that, zoneDelta, output;
            if (!this.isValid()) return NaN;
            that = cloneWithOffset(input, this);
            if (!that.isValid()) return NaN;
            zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
            units = normalizeUnits(units);
            switch(units){
                case 'year':
                    output = monthDiff(this, that) / 12;
                    break;
                case 'month':
                    output = monthDiff(this, that);
                    break;
                case 'quarter':
                    output = monthDiff(this, that) / 3;
                    break;
                case 'second':
                    output = (this - that) / 1e3;
                    break;
                case 'minute':
                    output = (this - that) / 6e4;
                    break;
                case 'hour':
                    output = (this - that) / 36e5;
                    break;
                case 'day':
                    output = (this - that - zoneDelta) / 864e5;
                    break;
                case 'week':
                    output = (this - that - zoneDelta) / 6048e5;
                    break;
                default:
                    output = this - that;
            }
            return asFloat ? output : absFloor(output);
        }
        function monthDiff(a, b) {
            if (a.date() < b.date()) return -monthDiff(b, a);
            var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
            if (b - anchor < 0) {
                anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
                adjust = (b - anchor) / (anchor - anchor2);
            } else {
                anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
                adjust = (b - anchor) / (anchor2 - anchor);
            }
            return -(wholeMonthDiff + adjust) || 0;
        }
        hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
        hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
        function toString() {
            return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
        }
        function toISOString(keepOffset) {
            if (!this.isValid()) return null;
            var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
            if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
            if (isFunction(Date.prototype.toISOString)) {
                if (utc) return this.toDate().toISOString();
                else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
            return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        function inspect() {
            if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
            var func = 'moment', zone = '', prefix, year, datetime, suffix;
            if (!this.isLocal()) {
                func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
                zone = 'Z';
            }
            prefix = '[' + func + '("]';
            year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
            datetime = '-MM-DD[T]HH:mm:ss.SSS';
            suffix = zone + '[")]';
            return this.format(prefix + year + datetime + suffix);
        }
        function format(inputString) {
            if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
            var output = formatMoment(this, inputString);
            return this.localeData().postformat(output);
        }
        function from(time, withoutSuffix) {
            if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
                to: this,
                from: time
            }).locale(this.locale()).humanize(!withoutSuffix);
            else return this.localeData().invalidDate();
        }
        function fromNow(withoutSuffix) {
            return this.from(createLocal(), withoutSuffix);
        }
        function to(time, withoutSuffix) {
            if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
                from: this,
                to: time
            }).locale(this.locale()).humanize(!withoutSuffix);
            else return this.localeData().invalidDate();
        }
        function toNow(withoutSuffix) {
            return this.to(createLocal(), withoutSuffix);
        }
        function locale(key) {
            var newLocaleData;
            if (key === undefined) return this._locale._abbr;
            else {
                newLocaleData = getLocale(key);
                if (newLocaleData != null) this._locale = newLocaleData;
                return this;
            }
        }
        var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
            if (key === undefined) return this.localeData();
            else return this.locale(key);
        });
        function localeData() {
            return this._locale;
        }
        var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
        function mod$1(dividend, divisor) {
            return (dividend % divisor + divisor) % divisor;
        }
        function localStartOfDate(y, m, d) {
            if (y < 100 && y >= 0) return new Date(y + 400, m, d) - MS_PER_400_YEARS;
            else return new Date(y, m, d).valueOf();
        }
        function utcStartOfDate(y, m, d) {
            if (y < 100 && y >= 0) return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
            else return Date.UTC(y, m, d);
        }
        function startOf(units) {
            var time, startOfDate;
            units = normalizeUnits(units);
            if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
            startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
            switch(units){
                case 'year':
                    time = startOfDate(this.year(), 0, 1);
                    break;
                case 'quarter':
                    time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                    break;
                case 'month':
                    time = startOfDate(this.year(), this.month(), 1);
                    break;
                case 'week':
                    time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                    break;
                case 'isoWeek':
                    time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                    break;
                case 'day':
                case 'date':
                    time = startOfDate(this.year(), this.month(), this.date());
                    break;
                case 'hour':
                    time = this._d.valueOf();
                    time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                    break;
                case 'minute':
                    time = this._d.valueOf();
                    time -= mod$1(time, MS_PER_MINUTE);
                    break;
                case 'second':
                    time = this._d.valueOf();
                    time -= mod$1(time, MS_PER_SECOND);
                    break;
            }
            this._d.setTime(time);
            hooks.updateOffset(this, true);
            return this;
        }
        function endOf(units) {
            var time, startOfDate;
            units = normalizeUnits(units);
            if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
            startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
            switch(units){
                case 'year':
                    time = startOfDate(this.year() + 1, 0, 1) - 1;
                    break;
                case 'quarter':
                    time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                    break;
                case 'month':
                    time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                    break;
                case 'week':
                    time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                    break;
                case 'isoWeek':
                    time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                    break;
                case 'day':
                case 'date':
                    time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                    break;
                case 'hour':
                    time = this._d.valueOf();
                    time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                    break;
                case 'minute':
                    time = this._d.valueOf();
                    time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                    break;
                case 'second':
                    time = this._d.valueOf();
                    time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                    break;
            }
            this._d.setTime(time);
            hooks.updateOffset(this, true);
            return this;
        }
        function valueOf() {
            return this._d.valueOf() - (this._offset || 0) * 60000;
        }
        function unix() {
            return Math.floor(this.valueOf() / 1000);
        }
        function toDate() {
            return new Date(this.valueOf());
        }
        function toArray() {
            var m = this;
            return [
                m.year(),
                m.month(),
                m.date(),
                m.hour(),
                m.minute(),
                m.second(),
                m.millisecond()
            ];
        }
        function toObject() {
            var m = this;
            return {
                years: m.year(),
                months: m.month(),
                date: m.date(),
                hours: m.hours(),
                minutes: m.minutes(),
                seconds: m.seconds(),
                milliseconds: m.milliseconds()
            };
        }
        function toJSON() {
            return this.isValid() ? this.toISOString() : null;
        }
        function isValid$2() {
            return isValid(this);
        }
        function parsingFlags() {
            return extend({}, getParsingFlags(this));
        }
        function invalidAt() {
            return getParsingFlags(this).overflow;
        }
        function creationData() {
            return {
                input: this._i,
                format: this._f,
                locale: this._locale,
                isUTC: this._isUTC,
                strict: this._strict
            };
        }
        addFormatToken('N', 0, 0, 'eraAbbr');
        addFormatToken('NN', 0, 0, 'eraAbbr');
        addFormatToken('NNN', 0, 0, 'eraAbbr');
        addFormatToken('NNNN', 0, 0, 'eraName');
        addFormatToken('NNNNN', 0, 0, 'eraNarrow');
        addFormatToken('y', [
            'y',
            1
        ], 'yo', 'eraYear');
        addFormatToken('y', [
            'yy',
            2
        ], 0, 'eraYear');
        addFormatToken('y', [
            'yyy',
            3
        ], 0, 'eraYear');
        addFormatToken('y', [
            'yyyy',
            4
        ], 0, 'eraYear');
        addRegexToken('N', matchEraAbbr);
        addRegexToken('NN', matchEraAbbr);
        addRegexToken('NNN', matchEraAbbr);
        addRegexToken('NNNN', matchEraName);
        addRegexToken('NNNNN', matchEraNarrow);
        addParseToken([
            'N',
            'NN',
            'NNN',
            'NNNN',
            'NNNNN'
        ], function(input, array, config, token) {
            var era = config._locale.erasParse(input, token, config._strict);
            if (era) getParsingFlags(config).era = era;
            else getParsingFlags(config).invalidEra = input;
        });
        addRegexToken('y', matchUnsigned);
        addRegexToken('yy', matchUnsigned);
        addRegexToken('yyy', matchUnsigned);
        addRegexToken('yyyy', matchUnsigned);
        addRegexToken('yo', matchEraYearOrdinal);
        addParseToken([
            'y',
            'yy',
            'yyy',
            'yyyy'
        ], YEAR);
        addParseToken([
            'yo'
        ], function(input, array, config, token) {
            var match;
            if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
            if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
            else array[YEAR] = parseInt(input, 10);
        });
        function localeEras(m, format) {
            var i, l, date, eras = this._eras || getLocale('en')._eras;
            for(i = 0, l = eras.length; i < l; ++i){
                switch(typeof eras[i].since){
                    case 'string':
                        date = hooks(eras[i].since).startOf('day');
                        eras[i].since = date.valueOf();
                        break;
                }
                switch(typeof eras[i].until){
                    case 'undefined':
                        eras[i].until = Infinity;
                        break;
                    case 'string':
                        date = hooks(eras[i].until).startOf('day').valueOf();
                        eras[i].until = date.valueOf();
                        break;
                }
            }
            return eras;
        }
        function localeErasParse(eraName, format, strict) {
            var i, l, eras = this.eras(), name, abbr, narrow;
            eraName = eraName.toUpperCase();
            for(i = 0, l = eras.length; i < l; ++i){
                name = eras[i].name.toUpperCase();
                abbr = eras[i].abbr.toUpperCase();
                narrow = eras[i].narrow.toUpperCase();
                if (strict) switch(format){
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) return eras[i];
                        break;
                    case 'NNNN':
                        if (name === eraName) return eras[i];
                        break;
                    case 'NNNNN':
                        if (narrow === eraName) return eras[i];
                        break;
                }
                else if ([
                    name,
                    abbr,
                    narrow
                ].indexOf(eraName) >= 0) return eras[i];
            }
        }
        function localeErasConvertYear(era, year) {
            var dir = era.since <= era.until ? 1 : -1;
            if (year === undefined) return hooks(era.since).year();
            else return hooks(era.since).year() + (year - era.offset) * dir;
        }
        function getEraName() {
            var i, l, val, eras = this.localeData().eras();
            for(i = 0, l = eras.length; i < l; ++i){
                val = this.clone().startOf('day').valueOf();
                if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
                if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
            }
            return '';
        }
        function getEraNarrow() {
            var i, l, val, eras = this.localeData().eras();
            for(i = 0, l = eras.length; i < l; ++i){
                val = this.clone().startOf('day').valueOf();
                if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
                if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
            }
            return '';
        }
        function getEraAbbr() {
            var i, l, val, eras = this.localeData().eras();
            for(i = 0, l = eras.length; i < l; ++i){
                val = this.clone().startOf('day').valueOf();
                if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
                if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
            }
            return '';
        }
        function getEraYear() {
            var i, l, dir, val, eras = this.localeData().eras();
            for(i = 0, l = eras.length; i < l; ++i){
                dir = eras[i].since <= eras[i].until ? 1 : -1;
                val = this.clone().startOf('day').valueOf();
                if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
            }
            return this.year();
        }
        function erasNameRegex(isStrict) {
            if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
            return isStrict ? this._erasNameRegex : this._erasRegex;
        }
        function erasAbbrRegex(isStrict) {
            if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
            return isStrict ? this._erasAbbrRegex : this._erasRegex;
        }
        function erasNarrowRegex(isStrict) {
            if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
            return isStrict ? this._erasNarrowRegex : this._erasRegex;
        }
        function matchEraAbbr(isStrict, locale) {
            return locale.erasAbbrRegex(isStrict);
        }
        function matchEraName(isStrict, locale) {
            return locale.erasNameRegex(isStrict);
        }
        function matchEraNarrow(isStrict, locale) {
            return locale.erasNarrowRegex(isStrict);
        }
        function matchEraYearOrdinal(isStrict, locale) {
            return locale._eraYearOrdinalRegex || matchUnsigned;
        }
        function computeErasParse() {
            var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
            for(i = 0, l = eras.length; i < l; ++i){
                erasName = regexEscape(eras[i].name);
                erasAbbr = regexEscape(eras[i].abbr);
                erasNarrow = regexEscape(eras[i].narrow);
                namePieces.push(erasName);
                abbrPieces.push(erasAbbr);
                narrowPieces.push(erasNarrow);
                mixedPieces.push(erasName);
                mixedPieces.push(erasAbbr);
                mixedPieces.push(erasNarrow);
            }
            this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
            this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
            this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
            this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
        }
        addFormatToken(0, [
            'gg',
            2
        ], 0, function() {
            return this.weekYear() % 100;
        });
        addFormatToken(0, [
            'GG',
            2
        ], 0, function() {
            return this.isoWeekYear() % 100;
        });
        function addWeekYearFormatToken(token, getter) {
            addFormatToken(0, [
                token,
                token.length
            ], 0, getter);
        }
        addWeekYearFormatToken('gggg', 'weekYear');
        addWeekYearFormatToken('ggggg', 'weekYear');
        addWeekYearFormatToken('GGGG', 'isoWeekYear');
        addWeekYearFormatToken('GGGGG', 'isoWeekYear');
        addRegexToken('G', matchSigned);
        addRegexToken('g', matchSigned);
        addRegexToken('GG', match1to2, match2);
        addRegexToken('gg', match1to2, match2);
        addRegexToken('GGGG', match1to4, match4);
        addRegexToken('gggg', match1to4, match4);
        addRegexToken('GGGGG', match1to6, match6);
        addRegexToken('ggggg', match1to6, match6);
        addWeekParseToken([
            'gggg',
            'ggggg',
            'GGGG',
            'GGGGG'
        ], function(input, week, config, token) {
            week[token.substr(0, 2)] = toInt(input);
        });
        addWeekParseToken([
            'gg',
            'GG'
        ], function(input, week, config, token) {
            week[token] = hooks.parseTwoDigitYear(input);
        });
        function getSetWeekYear(input) {
            return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
        }
        function getSetISOWeekYear(input) {
            return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
        }
        function getISOWeeksInYear() {
            return weeksInYear(this.year(), 1, 4);
        }
        function getISOWeeksInISOWeekYear() {
            return weeksInYear(this.isoWeekYear(), 1, 4);
        }
        function getWeeksInYear() {
            var weekInfo = this.localeData()._week;
            return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
        }
        function getWeeksInWeekYear() {
            var weekInfo = this.localeData()._week;
            return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
        }
        function getSetWeekYearHelper(input, week, weekday, dow, doy) {
            var weeksTarget;
            if (input == null) return weekOfYear(this, dow, doy).year;
            else {
                weeksTarget = weeksInYear(input, dow, doy);
                if (week > weeksTarget) week = weeksTarget;
                return setWeekAll.call(this, input, week, weekday, dow, doy);
            }
        }
        function setWeekAll(weekYear, week, weekday, dow, doy) {
            var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
            this.year(date.getUTCFullYear());
            this.month(date.getUTCMonth());
            this.date(date.getUTCDate());
            return this;
        }
        addFormatToken('Q', 0, 'Qo', 'quarter');
        addRegexToken('Q', match1);
        addParseToken('Q', function(input, array) {
            array[MONTH] = (toInt(input) - 1) * 3;
        });
        function getSetQuarter(input) {
            return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
        }
        addFormatToken('D', [
            'DD',
            2
        ], 'Do', 'date');
        addRegexToken('D', match1to2, match1to2NoLeadingZero);
        addRegexToken('DD', match1to2, match2);
        addRegexToken('Do', function(isStrict, locale) {
            return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
        });
        addParseToken([
            'D',
            'DD'
        ], DATE);
        addParseToken('Do', function(input, array) {
            array[DATE] = toInt(input.match(match1to2)[0]);
        });
        var getSetDayOfMonth = makeGetSet('Date', true);
        addFormatToken('DDD', [
            'DDDD',
            3
        ], 'DDDo', 'dayOfYear');
        addRegexToken('DDD', match1to3);
        addRegexToken('DDDD', match3);
        addParseToken([
            'DDD',
            'DDDD'
        ], function(input, array, config) {
            config._dayOfYear = toInt(input);
        });
        function getSetDayOfYear(input) {
            var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
            return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
        }
        addFormatToken('m', [
            'mm',
            2
        ], 0, 'minute');
        addRegexToken('m', match1to2, match1to2HasZero);
        addRegexToken('mm', match1to2, match2);
        addParseToken([
            'm',
            'mm'
        ], MINUTE);
        var getSetMinute = makeGetSet('Minutes', false);
        addFormatToken('s', [
            'ss',
            2
        ], 0, 'second');
        addRegexToken('s', match1to2, match1to2HasZero);
        addRegexToken('ss', match1to2, match2);
        addParseToken([
            's',
            'ss'
        ], SECOND);
        var getSetSecond = makeGetSet('Seconds', false);
        addFormatToken('S', 0, 0, function() {
            return ~~(this.millisecond() / 100);
        });
        addFormatToken(0, [
            'SS',
            2
        ], 0, function() {
            return ~~(this.millisecond() / 10);
        });
        addFormatToken(0, [
            'SSS',
            3
        ], 0, 'millisecond');
        addFormatToken(0, [
            'SSSS',
            4
        ], 0, function() {
            return this.millisecond() * 10;
        });
        addFormatToken(0, [
            'SSSSS',
            5
        ], 0, function() {
            return this.millisecond() * 100;
        });
        addFormatToken(0, [
            'SSSSSS',
            6
        ], 0, function() {
            return this.millisecond() * 1000;
        });
        addFormatToken(0, [
            'SSSSSSS',
            7
        ], 0, function() {
            return this.millisecond() * 10000;
        });
        addFormatToken(0, [
            'SSSSSSSS',
            8
        ], 0, function() {
            return this.millisecond() * 100000;
        });
        addFormatToken(0, [
            'SSSSSSSSS',
            9
        ], 0, function() {
            return this.millisecond() * 1000000;
        });
        addRegexToken('S', match1to3, match1);
        addRegexToken('SS', match1to3, match2);
        addRegexToken('SSS', match1to3, match3);
        var token, getSetMillisecond;
        for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
        function parseMs(input, array) {
            array[MILLISECOND] = toInt(('0.' + input) * 1000);
        }
        for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
        getSetMillisecond = makeGetSet('Milliseconds', false);
        addFormatToken('z', 0, 0, 'zoneAbbr');
        addFormatToken('zz', 0, 0, 'zoneName');
        function getZoneAbbr() {
            return this._isUTC ? 'UTC' : '';
        }
        function getZoneName() {
            return this._isUTC ? 'Coordinated Universal Time' : '';
        }
        var proto = Moment.prototype;
        proto.add = add;
        proto.calendar = calendar$1;
        proto.clone = clone;
        proto.diff = diff;
        proto.endOf = endOf;
        proto.format = format;
        proto.from = from;
        proto.fromNow = fromNow;
        proto.to = to;
        proto.toNow = toNow;
        proto.get = stringGet;
        proto.invalidAt = invalidAt;
        proto.isAfter = isAfter;
        proto.isBefore = isBefore;
        proto.isBetween = isBetween;
        proto.isSame = isSame;
        proto.isSameOrAfter = isSameOrAfter;
        proto.isSameOrBefore = isSameOrBefore;
        proto.isValid = isValid$2;
        proto.lang = lang;
        proto.locale = locale;
        proto.localeData = localeData;
        proto.max = prototypeMax;
        proto.min = prototypeMin;
        proto.parsingFlags = parsingFlags;
        proto.set = stringSet;
        proto.startOf = startOf;
        proto.subtract = subtract;
        proto.toArray = toArray;
        proto.toObject = toObject;
        proto.toDate = toDate;
        proto.toISOString = toISOString;
        proto.inspect = inspect;
        if (typeof Symbol !== 'undefined' && Symbol.for != null) proto[Symbol.for('nodejs.util.inspect.custom')] = function() {
            return 'Moment<' + this.format() + '>';
        };
        proto.toJSON = toJSON;
        proto.toString = toString;
        proto.unix = unix;
        proto.valueOf = valueOf;
        proto.creationData = creationData;
        proto.eraName = getEraName;
        proto.eraNarrow = getEraNarrow;
        proto.eraAbbr = getEraAbbr;
        proto.eraYear = getEraYear;
        proto.year = getSetYear;
        proto.isLeapYear = getIsLeapYear;
        proto.weekYear = getSetWeekYear;
        proto.isoWeekYear = getSetISOWeekYear;
        proto.quarter = proto.quarters = getSetQuarter;
        proto.month = getSetMonth;
        proto.daysInMonth = getDaysInMonth;
        proto.week = proto.weeks = getSetWeek;
        proto.isoWeek = proto.isoWeeks = getSetISOWeek;
        proto.weeksInYear = getWeeksInYear;
        proto.weeksInWeekYear = getWeeksInWeekYear;
        proto.isoWeeksInYear = getISOWeeksInYear;
        proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
        proto.date = getSetDayOfMonth;
        proto.day = proto.days = getSetDayOfWeek;
        proto.weekday = getSetLocaleDayOfWeek;
        proto.isoWeekday = getSetISODayOfWeek;
        proto.dayOfYear = getSetDayOfYear;
        proto.hour = proto.hours = getSetHour;
        proto.minute = proto.minutes = getSetMinute;
        proto.second = proto.seconds = getSetSecond;
        proto.millisecond = proto.milliseconds = getSetMillisecond;
        proto.utcOffset = getSetOffset;
        proto.utc = setOffsetToUTC;
        proto.local = setOffsetToLocal;
        proto.parseZone = setOffsetToParsedOffset;
        proto.hasAlignedHourOffset = hasAlignedHourOffset;
        proto.isDST = isDaylightSavingTime;
        proto.isLocal = isLocal;
        proto.isUtcOffset = isUtcOffset;
        proto.isUtc = isUtc;
        proto.isUTC = isUtc;
        proto.zoneAbbr = getZoneAbbr;
        proto.zoneName = getZoneName;
        proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
        proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
        proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
        proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
        proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
        function createUnix(input) {
            return createLocal(input * 1000);
        }
        function createInZone() {
            return createLocal.apply(null, arguments).parseZone();
        }
        function preParsePostFormat(string) {
            return string;
        }
        var proto$1 = Locale.prototype;
        proto$1.calendar = calendar;
        proto$1.longDateFormat = longDateFormat;
        proto$1.invalidDate = invalidDate;
        proto$1.ordinal = ordinal;
        proto$1.preparse = preParsePostFormat;
        proto$1.postformat = preParsePostFormat;
        proto$1.relativeTime = relativeTime;
        proto$1.pastFuture = pastFuture;
        proto$1.set = set;
        proto$1.eras = localeEras;
        proto$1.erasParse = localeErasParse;
        proto$1.erasConvertYear = localeErasConvertYear;
        proto$1.erasAbbrRegex = erasAbbrRegex;
        proto$1.erasNameRegex = erasNameRegex;
        proto$1.erasNarrowRegex = erasNarrowRegex;
        proto$1.months = localeMonths;
        proto$1.monthsShort = localeMonthsShort;
        proto$1.monthsParse = localeMonthsParse;
        proto$1.monthsRegex = monthsRegex;
        proto$1.monthsShortRegex = monthsShortRegex;
        proto$1.week = localeWeek;
        proto$1.firstDayOfYear = localeFirstDayOfYear;
        proto$1.firstDayOfWeek = localeFirstDayOfWeek;
        proto$1.weekdays = localeWeekdays;
        proto$1.weekdaysMin = localeWeekdaysMin;
        proto$1.weekdaysShort = localeWeekdaysShort;
        proto$1.weekdaysParse = localeWeekdaysParse;
        proto$1.weekdaysRegex = weekdaysRegex;
        proto$1.weekdaysShortRegex = weekdaysShortRegex;
        proto$1.weekdaysMinRegex = weekdaysMinRegex;
        proto$1.isPM = localeIsPM;
        proto$1.meridiem = localeMeridiem;
        function get$1(format, index, field, setter) {
            var locale = getLocale(), utc = createUTC().set(setter, index);
            return locale[field](utc, format);
        }
        function listMonthsImpl(format, index, field) {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
            if (index != null) return get$1(format, index, field, 'month');
            var i, out = [];
            for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
            return out;
        }
        function listWeekdaysImpl(localeSorted, format, index, field) {
            if (typeof localeSorted === 'boolean') {
                if (isNumber(format)) {
                    index = format;
                    format = undefined;
                }
                format = format || '';
            } else {
                format = localeSorted;
                index = format;
                localeSorted = false;
                if (isNumber(format)) {
                    index = format;
                    format = undefined;
                }
                format = format || '';
            }
            var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
            if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
            for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
            return out;
        }
        function listMonths(format, index) {
            return listMonthsImpl(format, index, 'months');
        }
        function listMonthsShort(format, index) {
            return listMonthsImpl(format, index, 'monthsShort');
        }
        function listWeekdays(localeSorted, format, index) {
            return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
        }
        function listWeekdaysShort(localeSorted, format, index) {
            return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
        }
        function listWeekdaysMin(localeSorted, format, index) {
            return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
        }
        getSetGlobalLocale('en', {
            eras: [
                {
                    since: '0001-01-01',
                    until: Infinity,
                    offset: 1,
                    name: 'Anno Domini',
                    narrow: 'AD',
                    abbr: 'AD'
                },
                {
                    since: '0000-12-31',
                    until: -Infinity,
                    offset: 1,
                    name: 'Before Christ',
                    narrow: 'BC',
                    abbr: 'BC'
                }
            ],
            dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
            ordinal: function(number) {
                var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
                return number + output;
            }
        });
        hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
        hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
        var mathAbs = Math.abs;
        function abs() {
            var data = this._data;
            this._milliseconds = mathAbs(this._milliseconds);
            this._days = mathAbs(this._days);
            this._months = mathAbs(this._months);
            data.milliseconds = mathAbs(data.milliseconds);
            data.seconds = mathAbs(data.seconds);
            data.minutes = mathAbs(data.minutes);
            data.hours = mathAbs(data.hours);
            data.months = mathAbs(data.months);
            data.years = mathAbs(data.years);
            return this;
        }
        function addSubtract$1(duration, input, value, direction) {
            var other = createDuration(input, value);
            duration._milliseconds += direction * other._milliseconds;
            duration._days += direction * other._days;
            duration._months += direction * other._months;
            return duration._bubble();
        }
        function add$1(input, value) {
            return addSubtract$1(this, input, value, 1);
        }
        function subtract$1(input, value) {
            return addSubtract$1(this, input, value, -1);
        }
        function absCeil(number) {
            if (number < 0) return Math.floor(number);
            else return Math.ceil(number);
        }
        function bubble() {
            var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
            if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
                milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
                days = 0;
                months = 0;
            }
            data.milliseconds = milliseconds % 1000;
            seconds = absFloor(milliseconds / 1000);
            data.seconds = seconds % 60;
            minutes = absFloor(seconds / 60);
            data.minutes = minutes % 60;
            hours = absFloor(minutes / 60);
            data.hours = hours % 24;
            days += absFloor(hours / 24);
            monthsFromDays = absFloor(daysToMonths(days));
            months += monthsFromDays;
            days -= absCeil(monthsToDays(monthsFromDays));
            years = absFloor(months / 12);
            months %= 12;
            data.days = days;
            data.months = months;
            data.years = years;
            return this;
        }
        function daysToMonths(days) {
            return days * 4800 / 146097;
        }
        function monthsToDays(months) {
            return months * 146097 / 4800;
        }
        function as(units) {
            if (!this.isValid()) return NaN;
            var days, months, milliseconds = this._milliseconds;
            units = normalizeUnits(units);
            if (units === 'month' || units === 'quarter' || units === 'year') {
                days = this._days + milliseconds / 864e5;
                months = this._months + daysToMonths(days);
                switch(units){
                    case 'month':
                        return months;
                    case 'quarter':
                        return months / 3;
                    case 'year':
                        return months / 12;
                }
            } else {
                days = this._days + Math.round(monthsToDays(this._months));
                switch(units){
                    case 'week':
                        return days / 7 + milliseconds / 6048e5;
                    case 'day':
                        return days + milliseconds / 864e5;
                    case 'hour':
                        return days * 24 + milliseconds / 36e5;
                    case 'minute':
                        return days * 1440 + milliseconds / 6e4;
                    case 'second':
                        return days * 86400 + milliseconds / 1000;
                    case 'millisecond':
                        return Math.floor(days * 864e5) + milliseconds;
                    default:
                        throw new Error('Unknown unit ' + units);
                }
            }
        }
        function makeAs(alias) {
            return function() {
                return this.as(alias);
            };
        }
        var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y'), valueOf$1 = asMilliseconds;
        function clone$1() {
            return createDuration(this);
        }
        function get$2(units) {
            units = normalizeUnits(units);
            return this.isValid() ? this[units + 's']() : NaN;
        }
        function makeGetter(name) {
            return function() {
                return this.isValid() ? this._data[name] : NaN;
            };
        }
        var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
        function weeks() {
            return absFloor(this.days() / 7);
        }
        var round = Math.round, thresholds = {
            ss: 44,
            s: 45,
            m: 45,
            h: 22,
            d: 26,
            w: null,
            M: 11
        };
        function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
            return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
        }
        function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
            var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
                's',
                seconds
            ] || seconds < thresholds.s && [
                'ss',
                seconds
            ] || minutes <= 1 && [
                'm'
            ] || minutes < thresholds.m && [
                'mm',
                minutes
            ] || hours <= 1 && [
                'h'
            ] || hours < thresholds.h && [
                'hh',
                hours
            ] || days <= 1 && [
                'd'
            ] || days < thresholds.d && [
                'dd',
                days
            ];
            if (thresholds.w != null) a = a || weeks <= 1 && [
                'w'
            ] || weeks < thresholds.w && [
                'ww',
                weeks
            ];
            a = a || months <= 1 && [
                'M'
            ] || months < thresholds.M && [
                'MM',
                months
            ] || years <= 1 && [
                'y'
            ] || [
                'yy',
                years
            ];
            a[2] = withoutSuffix;
            a[3] = +posNegDuration > 0;
            a[4] = locale;
            return substituteTimeAgo.apply(null, a);
        }
        function getSetRelativeTimeRounding(roundingFunction) {
            if (roundingFunction === undefined) return round;
            if (typeof roundingFunction === 'function') {
                round = roundingFunction;
                return true;
            }
            return false;
        }
        function getSetRelativeTimeThreshold(threshold, limit) {
            if (thresholds[threshold] === undefined) return false;
            if (limit === undefined) return thresholds[threshold];
            thresholds[threshold] = limit;
            if (threshold === 's') thresholds.ss = limit - 1;
            return true;
        }
        function humanize(argWithSuffix, argThresholds) {
            if (!this.isValid()) return this.localeData().invalidDate();
            var withSuffix = false, th = thresholds, locale, output;
            if (typeof argWithSuffix === 'object') {
                argThresholds = argWithSuffix;
                argWithSuffix = false;
            }
            if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
            if (typeof argThresholds === 'object') {
                th = Object.assign({}, thresholds, argThresholds);
                if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
            }
            locale = this.localeData();
            output = relativeTime$1(this, !withSuffix, th, locale);
            if (withSuffix) output = locale.pastFuture(+this, output);
            return locale.postformat(output);
        }
        var abs$1 = Math.abs;
        function sign(x) {
            return (x > 0) - (x < 0) || +x;
        }
        function toISOString$1() {
            if (!this.isValid()) return this.localeData().invalidDate();
            var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
            if (!total) return 'P0D';
            minutes = absFloor(seconds / 60);
            hours = absFloor(minutes / 60);
            seconds %= 60;
            minutes %= 60;
            years = absFloor(months / 12);
            months %= 12;
            s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
            totalSign = total < 0 ? '-' : '';
            ymSign = sign(this._months) !== sign(total) ? '-' : '';
            daysSign = sign(this._days) !== sign(total) ? '-' : '';
            hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
            return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
        }
        var proto$2 = Duration.prototype;
        proto$2.isValid = isValid$1;
        proto$2.abs = abs;
        proto$2.add = add$1;
        proto$2.subtract = subtract$1;
        proto$2.as = as;
        proto$2.asMilliseconds = asMilliseconds;
        proto$2.asSeconds = asSeconds;
        proto$2.asMinutes = asMinutes;
        proto$2.asHours = asHours;
        proto$2.asDays = asDays;
        proto$2.asWeeks = asWeeks;
        proto$2.asMonths = asMonths;
        proto$2.asQuarters = asQuarters;
        proto$2.asYears = asYears;
        proto$2.valueOf = valueOf$1;
        proto$2._bubble = bubble;
        proto$2.clone = clone$1;
        proto$2.get = get$2;
        proto$2.milliseconds = milliseconds;
        proto$2.seconds = seconds;
        proto$2.minutes = minutes;
        proto$2.hours = hours;
        proto$2.days = days;
        proto$2.weeks = weeks;
        proto$2.months = months;
        proto$2.years = years;
        proto$2.humanize = humanize;
        proto$2.toISOString = toISOString$1;
        proto$2.toString = toISOString$1;
        proto$2.toJSON = toISOString$1;
        proto$2.locale = locale;
        proto$2.localeData = localeData;
        proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
        proto$2.lang = lang;
        addFormatToken('X', 0, 0, 'unix');
        addFormatToken('x', 0, 0, 'valueOf');
        addRegexToken('x', matchSigned);
        addRegexToken('X', matchTimestamp);
        addParseToken('X', function(input, array, config) {
            config._d = new Date(parseFloat(input) * 1000);
        });
        addParseToken('x', function(input, array, config) {
            config._d = new Date(toInt(input));
        });
        hooks.version = '2.30.1';
        setHookCallback(createLocal);
        hooks.fn = proto;
        hooks.min = min;
        hooks.max = max;
        hooks.now = now;
        hooks.utc = createUTC;
        hooks.unix = createUnix;
        hooks.months = listMonths;
        hooks.isDate = isDate;
        hooks.locale = getSetGlobalLocale;
        hooks.invalid = createInvalid;
        hooks.duration = createDuration;
        hooks.isMoment = isMoment;
        hooks.weekdays = listWeekdays;
        hooks.parseZone = createInZone;
        hooks.localeData = getLocale;
        hooks.isDuration = isDuration;
        hooks.monthsShort = listMonthsShort;
        hooks.weekdaysMin = listWeekdaysMin;
        hooks.defineLocale = defineLocale;
        hooks.updateLocale = updateLocale;
        hooks.locales = listLocales;
        hooks.weekdaysShort = listWeekdaysShort;
        hooks.normalizeUnits = normalizeUnits;
        hooks.relativeTimeRounding = getSetRelativeTimeRounding;
        hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
        hooks.calendarFormat = getCalendarFormat;
        hooks.prototype = proto;
        hooks.HTML5_FMT = {
            DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
            DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
            DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
            DATE: 'YYYY-MM-DD',
            TIME: 'HH:mm',
            TIME_SECONDS: 'HH:mm:ss',
            TIME_MS: 'HH:mm:ss.SSS',
            WEEK: 'GGGG-[W]WW',
            MONTH: 'YYYY-MM'
        };
        return hooks;
    });
});
parcelRegister("kvSZW", function(module, exports) {
    $parcel$export(module.exports, "getTimelineDurationFromDate", ()=>$8eccb852de85f1ac$export$844e598264c96110);
    $parcel$export(module.exports, "getTimelineOriginForToday", ()=>$8eccb852de85f1ac$export$afef567e98d0d2bb);
    $parcel$export(module.exports, "getDefaultTimelinePositionFromDate", ()=>$8eccb852de85f1ac$export$96eeb91a52b83f6d);
    var $8QpSo;
    var $2gnC5 = parcelRequire("2gnC5");
    var $iZN6h;
    var $bFxJH;
    const $8eccb852de85f1ac$export$844e598264c96110 = (0, (0, parcelRequire("8QpSo")).default)((timelineMode, date)=>{
        let startMoment = (0, ($parcel$interopDefault($2gnC5))).utc(date).subtract(1, 'year');
        let endMoment = (0, ($parcel$interopDefault($2gnC5))).utc(date).add(2, 'year');
        if (timelineMode === (0, (0, parcelRequire("iZN6h")).QUARTERS)) {
            startMoment = startMoment.startOf('quarter');
            endMoment = endMoment.endOf('quarter');
        } else if (timelineMode === (0, (0, parcelRequire("iZN6h")).MONTHS)) {
            startMoment = startMoment.startOf('month');
            endMoment = endMoment.endOf('month');
        } else {
            startMoment = startMoment.startOf('isoWeek');
            endMoment = endMoment.endOf('isoWeek');
        }
        return {
            startMilliseconds: startMoment.valueOf(),
            endMilliseconds: endMoment.valueOf(),
            totalMilliseconds: endMoment.diff(startMoment, 'milliseconds')
        };
    });
    const $8eccb852de85f1ac$export$afef567e98d0d2bb = (0, (0, parcelRequire("8QpSo")).default)((today, timelineMode)=>{
        const todayMoment = (0, ($parcel$interopDefault($2gnC5))).utc(today);
        if (timelineMode === (0, (0, parcelRequire("iZN6h")).QUARTERS)) return todayMoment.startOf('quarter').subtract(45, 'days').valueOf();
        if (timelineMode === (0, (0, parcelRequire("iZN6h")).MONTHS)) return todayMoment.startOf('month').subtract(15, 'days').valueOf();
        return todayMoment.startOf('isoWeek').subtract(4, 'days').valueOf();
    });
    const $8eccb852de85f1ac$export$96eeb91a52b83f6d = (0, (0, parcelRequire("8QpSo")).default)((date, timelineMode, timelineDuration)=>{
        const millisecondPosition = $8eccb852de85f1ac$export$afef567e98d0d2bb(date, timelineMode);
        const relativePosition = (millisecondPosition - timelineDuration.startMilliseconds) / timelineDuration.totalMilliseconds;
        return relativePosition * (0, (0, parcelRequire("bFxJH")).getTimelineWidth)(timelineMode, timelineDuration.totalMilliseconds);
    });
});
parcelRegister("5SzPP", function(module, exports) {
    $parcel$export(module.exports, "getSprintsHash", ()=>$0d015ff0cdf5bb2a$export$9328442a7d4e1089);
    $parcel$export(module.exports, "getSprintIntervals", ()=>$0d015ff0cdf5bb2a$export$acb5f9893119b5b6);
    $parcel$export(module.exports, "createGetSanitizedSprints", ()=>$0d015ff0cdf5bb2a$export$4b81aebbd933400f);
    $parcel$export(module.exports, "createGetIntersectingSprintId", ()=>$0d015ff0cdf5bb2a$export$31abdd665c32a9d3);
    $parcel$export(module.exports, "getSprintName", ()=>$0d015ff0cdf5bb2a$export$3df6198cde5435f9);
    $parcel$export(module.exports, "getSprintState", ()=>$0d015ff0cdf5bb2a$export$9cbf48c04feaac07);
    $parcel$export(module.exports, "createGetMostRecentSprintId", ()=>$0d015ff0cdf5bb2a$export$abdb1a5f7673f188);
    $parcel$export(module.exports, "getSanitisedIssueSprintsHash", ()=>$0d015ff0cdf5bb2a$export$7ace1dbeb1bd9b20);
    $parcel$export(module.exports, "getCurrentlyAssignedSprints", ()=>$0d015ff0cdf5bb2a$export$c1e6c915824951b6);
    var $8QpSo;
    var $esmwW;
    var $dn5Ng;
    var $fhoNh;
    const $0d015ff0cdf5bb2a$var$withAdjustedSprintDates = (sprints)=>sprints.map((sprint)=>({
                id: sprint.id,
                name: sprint.name,
                state: sprint.state,
                startDate: Math.min(sprint.startDate, sprint.endDate),
                endDate: Math.max(sprint.startDate, sprint.endDate)
            }));
    const $0d015ff0cdf5bb2a$export$9328442a7d4e1089 = (sprints)=>$0d015ff0cdf5bb2a$var$withAdjustedSprintDates(sprints).reduce((acc, sprint)=>{
            acc[`${sprint.id}`] = sprint;
            return acc;
        }, {});
    const $0d015ff0cdf5bb2a$export$acb5f9893119b5b6 = (sprints)=>sprints.map(({ id: id, name: name, state: state, startDate: startDate, endDate: endDate })=>({
                id: String(id),
                name: name,
                state: state,
                startDate: startDate,
                endDate: endDate
            }));
    const $0d015ff0cdf5bb2a$export$4b81aebbd933400f = (sprints)=>(0, (0, parcelRequire("8QpSo")).default)((timelineDuration)=>sprints.map((sprint)=>({
                    id: sprint.id,
                    name: sprint.name,
                    state: sprint.state,
                    startDate: Math.min(sprint.startDate, sprint.endDate),
                    endDate: Math.max(sprint.startDate, sprint.endDate) + (0, (0, parcelRequire("esmwW")).DUE_DATE_OFFSET)
                })).filter((sprint)=>sprint.startDate >= timelineDuration.startMilliseconds && sprint.startDate <= timelineDuration.endMilliseconds || sprint.endDate <= timelineDuration.endMilliseconds && sprint.endDate >= timelineDuration.startMilliseconds || sprint.startDate <= timelineDuration.startMilliseconds && sprint.endDate >= timelineDuration.endMilliseconds));
    const $0d015ff0cdf5bb2a$var$asSprintIntervalType = (sprint)=>({
            id: sprint.id,
            name: sprint.name,
            state: sprint.state,
            start: sprint.startDate,
            end: sprint.endDate
        });
    const $0d015ff0cdf5bb2a$export$31abdd665c32a9d3 = (timelineDuration, getSanitizedSprints)=>(startDate, currentSprintId)=>{
            const sprintGroups = (0, (0, parcelRequire("fhoNh")).groupOverlappingIntervals)(getSanitizedSprints(timelineDuration).filter((sprint)=>sprint.id !== currentSprintId).map($0d015ff0cdf5bb2a$var$asSprintIntervalType));
            const filteredSprintGroup = sprintGroups.find((sprintGroup)=>sprintGroup.start <= startDate && sprintGroup.end > startDate);
            return filteredSprintGroup ? (0, (0, parcelRequire("dn5Ng")).getFirstOpenSprint)(filteredSprintGroup.intervals) : undefined;
        };
    const $0d015ff0cdf5bb2a$export$3df6198cde5435f9 = (sprintsHash)=>(sprintId)=>sprintId !== undefined ? sprintsHash[sprintId]?.name : undefined;
    const $0d015ff0cdf5bb2a$export$9cbf48c04feaac07 = (sprintsHash)=>(sprintId)=>sprintId !== undefined ? sprintsHash[sprintId]?.state : undefined;
    const $0d015ff0cdf5bb2a$export$abdb1a5f7673f188 = (issueIdToSprintIds)=>(0, (0, parcelRequire("8QpSo")).default)((id)=>{
            const sprintIds = issueIdToSprintIds[id] || [];
            return sprintIds[0];
        });
    const $0d015ff0cdf5bb2a$export$7ace1dbeb1bd9b20 = (issueSprintIdsHash, allSprintsHash)=>{
        const result = {};
        Object.keys(issueSprintIdsHash).forEach((issueId)=>{
            const sprintIds = issueSprintIdsHash[issueId];
            const filteredSprints = sprintIds.filter((sprintId)=>allSprintsHash[sprintId] !== undefined).map((sprintId)=>allSprintsHash[sprintId]);
            result[issueId] = filteredSprints;
        });
        return result;
    };
    const $0d015ff0cdf5bb2a$export$c1e6c915824951b6 = (issueSprintsHash)=>(issueId)=>(issueSprintsHash[issueId] ?? []).filter((sprint)=>sprint.state !== (0, $575de6c25475b26c$export$19c4f83398a8dbce));
});
parcelRegister("esmwW", function(module, exports) {
    $parcel$export(module.exports, "DATE_FORMAT", ()=>$e415a20509ddf4c7$export$45c85543ba71221d);
    $parcel$export(module.exports, "DATE_FORMAT_MOMENT", ()=>$e415a20509ddf4c7$export$98de7bb6e1f5105c);
    $parcel$export(module.exports, "DUE_DATE_OFFSET", ()=>$e415a20509ddf4c7$export$28c98c2c1f9d90de);
    $parcel$export(module.exports, "INTERVAL", ()=>$e415a20509ddf4c7$export$7dea0e6e08f87a8a);
    $parcel$export(module.exports, "ROLLUP", ()=>$e415a20509ddf4c7$export$e299765c2b7892c0);
    $parcel$export(module.exports, "EXPLICIT", ()=>$e415a20509ddf4c7$export$29c6b89b5966039e);
    const $e415a20509ddf4c7$export$45c85543ba71221d = 'yyyy/MM/dd';
    const $e415a20509ddf4c7$export$98de7bb6e1f5105c = 'yyyy/MM/DD';
    const $e415a20509ddf4c7$export$28c98c2c1f9d90de = (0, $a797a5154a1373bc$export$1f04624003d2da7d) - 1;
    const $e415a20509ddf4c7$export$7dea0e6e08f87a8a = 'INTERVAL';
    const $e415a20509ddf4c7$export$e299765c2b7892c0 = 'ROLLUP';
    const $e415a20509ddf4c7$export$29c6b89b5966039e = 'EXPLICIT';
});
const $a797a5154a1373bc$export$e63e1e1c17a0e8b = 'YYYY-MM-DD';
const $a797a5154a1373bc$export$45c85543ba71221d = 'YYYY/MM/DD';
const $a797a5154a1373bc$export$1f04624003d2da7d = 86400000;
parcelRegister("dn5Ng", function(module, exports) {
    $parcel$export(module.exports, "getFirstOpenSprint", ()=>$d058f565edc0796f$export$d85846c0333cfbbb);
    const $d058f565edc0796f$export$d85846c0333cfbbb = (intervals)=>intervals.find((sprint)=>sprint.state !== (0, $575de6c25475b26c$export$19c4f83398a8dbce))?.id;
});
parcelRegister("fhoNh", function(module, exports) {
    $parcel$export(module.exports, "groupOverlappingIntervals", ()=>$736133d4e249ac5d$export$1b45218c7b9e570f);
    const $736133d4e249ac5d$export$1b45218c7b9e570f = (intervals)=>{
        const intervalsWithIndex = intervals.map((interval, index)=>({
                ...interval,
                index: index
            }));
        const sortedIntervals = [
            ...intervalsWithIndex
        ].sort((interval, otherInterval)=>{
            const endComparison = interval.end - otherInterval.end;
            if (endComparison !== 0) return endComparison;
            return otherInterval.start - interval.start;
        });
        let result = [];
        let i = sortedIntervals.length - 1;
        while(i >= 0){
            const currentInterval = sortedIntervals[i];
            let groupedIntervals = [
                currentInterval
            ];
            let j = i - 1;
            while(j >= 0){
                const nextInterval = sortedIntervals[j];
                const isNextIntervalCompletelyOverlapped = currentInterval.start <= nextInterval.start;
                if (isNextIntervalCompletelyOverlapped) groupedIntervals = [
                    nextInterval
                ].concat(groupedIntervals);
                else break;
                j -= 1;
            }
            const groupedIntervalsInOriginalOrdering = groupedIntervals.sort((interval, otherInterval)=>interval.index - otherInterval.index).map(({ index: index, ...interval })=>interval);
            result = [
                {
                    start: currentInterval.start,
                    end: currentInterval.end,
                    expandedEnd: currentInterval.end,
                    intervals: groupedIntervalsInOriginalOrdering
                }
            ].concat(result);
            i = j;
        }
        if (result.length >= 2) for(let k = 0; k < result.length - 1; k += 1){
            const currentIntervalGroup = result[k];
            const nextIntervalGroup = result[k + 1];
            if (currentIntervalGroup.end > nextIntervalGroup.start) currentIntervalGroup.end = nextIntervalGroup.start;
        }
        return result;
    };
});
parcelRegister("4UHPo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4496a65243a40366$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $6s1PB;
    var $3FbMI;
    var $ousew;
    var $aWse0;
    var $wQLnv;
    const $4496a65243a40366$export$bfc0b1314277ad8e = ({ id: id, changedSprintName: changedSprintName, direction: direction, issueKey: issueKey, onDismissed: onDismissed, onUndo: onUndo, onPersist: onPersist })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        const isUndoing = (0, $5uXOq.useRef)(false);
        const onDismissedCallback = (0, $5uXOq.useCallback)((flagId, event)=>{
            if (!isUndoing.current) onPersist(flagId, event);
            onDismissed(flagId, event);
        }, [
            onDismissed,
            onPersist
        ]);
        const onClick = (0, $5uXOq.useCallback)((_, event)=>{
            isUndoing.current = true;
            onUndo(id, event);
            onDismissed(id, event);
        }, [
            onUndo,
            id,
            onDismissed
        ]);
        const getMessage = ()=>{
            if ((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) return direction === (0, $faa12ce5ec04bf70$export$11ee87f991dd6574) ? (0, (0, parcelRequire("wQLnv")).default).descriptionAssignIssueTermRefresh : (0, (0, parcelRequire("wQLnv")).default).descriptionUnassignIssueTermRefresh;
            return direction === (0, $faa12ce5ec04bf70$export$11ee87f991dd6574) ? (0, (0, parcelRequire("wQLnv")).default).descriptionAssign : (0, (0, parcelRequire("wQLnv")).default).descriptionUnassign;
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3FbMI")).default), {
            id: id,
            title: formatMessage((0, (0, parcelRequire("wQLnv")).default).title),
            description: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...getMessage(),
                values: {
                    changedSprintName: changedSprintName,
                    issueKey: issueKey,
                    b: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement("b", null, chunks)
                }
            }),
            onDismissed: onDismissedCallback,
            actions: [
                {
                    content: formatMessage((0, (0, parcelRequire("wQLnv")).default).undo),
                    onClick: onClick
                }
            ]
        });
    };
    $4496a65243a40366$export$bfc0b1314277ad8e.defaultProps = {
        onDismissed: (0, ($parcel$interopDefault($8Rkzz)))
    };
    var $4496a65243a40366$export$2e2bcd8739ae039 = $4496a65243a40366$export$bfc0b1314277ad8e;
});
parcelRegister("wQLnv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$779ad8b3bda07861$export$2e2bcd8739ae039);
    var $7VHMR;
    var $779ad8b3bda07861$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "roadmap.standard-roadmap.flags.sprint-scope-change.title",
            "defaultMessage": "Active sprint scope has changed"
        },
        descriptionAssign: {
            "id": "roadmap.standard-roadmap.flags.sprint-scope-change.description-assign",
            "defaultMessage": "<b>{issueKey}</b> has been assigned to <b>{changedSprintName}</b>, which will affect its scope."
        },
        descriptionUnassign: {
            "id": "roadmap.standard-roadmap.flags.sprint-scope-change.description-unassign",
            "defaultMessage": "<b>{issueKey}</b> has been unassigned from <b>{changedSprintName}</b>, which will affect its scope."
        },
        undo: {
            "id": "roadmap.standard-roadmap.flags.sprint-scope-change.undo",
            "defaultMessage": "Undo"
        },
        descriptionAssignIssueTermRefresh: {
            "id": "roadmap.standard-roadmap.flags.sprint-scope-change.description-assign-issue-term-refresh",
            "defaultMessage": "<b>{issueKey}</b> has been assigned to <b>{changedSprintName}</b>, which will affect its scope."
        },
        descriptionUnassignIssueTermRefresh: {
            "id": "roadmap.standard-roadmap.flags.sprint-scope-change.description-unassign-issue-term-refresh",
            "defaultMessage": "<b>{issueKey}</b> has been unassigned from <b>{changedSprintName}</b>, which will affect its scope."
        }
    });
});
parcelRegister("hMUWp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4765d068d268542c$export$2e2bcd8739ae039);
    var $e1AU2 = parcelRequire("e1AU2");
    var $kVLXA = parcelRequire("kVLXA");
    parcelRequire("fp4O3");
    var $kleDs;
    var $iR96x;
    var $eKt4x;
    var $hb2iR;
    var $k7R2t;
    var $3oIkL;
    var $lWgs6;
    var $jSCJZ;
    var $bcPzn;
    var $kwuT3;
    var $kqmXe;
    var $lAEPz;
    var $fY8f7;
    var $j68aq;
    var $4765d068d268542c$export$2e2bcd8739ae039 = (type)=>(0, (0, parcelRequire("kleDs")).default)((0, (0, parcelRequire("eKt4x")).toRoadmapAppId)(type), 'root', (0, $e1AU2.combineEpics)((0, (0, parcelRequire("k7R2t")).default), (0, (0, parcelRequire("3oIkL")).default), (0, (0, parcelRequire("lWgs6")).default), (0, (0, parcelRequire("jSCJZ")).default), (0, (0, parcelRequire("kwuT3")).default), (0, (0, parcelRequire("kqmXe")).default), (0, (0, parcelRequire("lAEPz")).default), (0, (0, parcelRequire("j68aq")).default), (0, (0, parcelRequire("bcPzn")).default), (0, (0, parcelRequire("fY8f7")).getCanUserInviteEpic)), (error)=>{
            if (error?.skipSentry === true) {
                const errorWithoutSkipSentry = {
                    ...error,
                    skipSentry: false
                };
                (0, (0, parcelRequire("iR96x")).captureException)(`common.epic-error.${(0, (0, parcelRequire("eKt4x")).toRoadmapAppId)(type)}.root`, errorWithoutSkipSentry);
            }
            return (0, $kVLXA.Observable).of((0, (0, parcelRequire("hb2iR")).generalError)());
        });
});
parcelRegister("kleDs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$80cd67c932e51ded$export$2e2bcd8739ae039);
    parcelRequire("c66Ur");
    var $dJl1T;
    var $iR96x;
    var $80cd67c932e51ded$export$2e2bcd8739ae039 = (appId, location, epic, errorHandler)=>(action$, store, deps)=>epic(action$, store, deps).catch((error, stream)=>{
                const fullLocation = `common.epic-error.${appId}.${location}`;
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData(fullLocation, 'Unhandled error in epic', error);
                (0, (0, parcelRequire("iR96x")).captureException)(fullLocation, error);
                return errorHandler && errorHandler(error) || stream;
            });
});
parcelRegister("k7R2t", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$661a61f6acd6e469$export$2e2bcd8739ae039);
    var $e1AU2 = parcelRequire("e1AU2");
    var $6Xyf2;
    var $hzjpq;
    var $hPJQQ;
    var $2isEz;
    var $j28ON;
    var $a01Zn;
    var $c8JZA;
    var $bLmfk;
    var $IIqe4;
    var $hRcIV;
    var $4tLWL;
    var $bSlQb;
    var $7mHPj;
    var $5r3qD;
    var $8IgfA;
    var $emglt;
    var $5RPNj;
    var $5QKmJ;
    var $VfqTC;
    var $7CZRh;
    var $9OXj4;
    var $cVVNe;
    var $6o6LV;
    var $661a61f6acd6e469$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, (0, parcelRequire("hzjpq")).default), (0, (0, parcelRequire("6Xyf2")).default), (0, (0, parcelRequire("5QKmJ")).default), (0, (0, parcelRequire("VfqTC")).default), (0, (0, parcelRequire("bSlQb")).default), (0, (0, parcelRequire("4tLWL")).default), (0, (0, parcelRequire("9OXj4")).default), (0, (0, parcelRequire("IIqe4")).default), (0, (0, parcelRequire("8IgfA")).default), (0, (0, parcelRequire("6o6LV")).default), (0, (0, parcelRequire("5RPNj")).default), (0, (0, parcelRequire("5r3qD")).default), (0, (0, parcelRequire("7CZRh")).default), (0, (0, parcelRequire("7mHPj")).default), (0, (0, parcelRequire("a01Zn")).default), (0, (0, parcelRequire("cVVNe")).default), (0, (0, parcelRequire("c8JZA")).default), (0, (0, parcelRequire("emglt")).default), (0, (0, parcelRequire("j28ON")).default), (0, (0, parcelRequire("2isEz")).default), (0, (0, parcelRequire("bLmfk")).default), (0, (0, parcelRequire("hPJQQ")).default), (0, (0, parcelRequire("hRcIV")).default));
});
parcelRegister("6Xyf2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$db556b10d85d6647$export$2e2bcd8739ae039);
    parcelRequire("d0pqD");
    var $9QFr0;
    var $35igy;
    var $db556b10d85d6647$export$2e2bcd8739ae039 = (action$, store, { router: { push: push } })=>action$.ofType((0, (0, parcelRequire("9QFr0")).CLEAR_FILTER)).map(()=>(0, (0, parcelRequire("35igy")).default)(push, store.getState(), (query)=>({
                    ...query,
                    statuses: undefined,
                    assignee: undefined,
                    issueType: undefined,
                    text: undefined,
                    label: undefined,
                    issueParent: undefined,
                    version: undefined,
                    component: undefined,
                    quickFilter: undefined,
                    customFilter: undefined,
                    goal: undefined
                })));
});
parcelRegister("35igy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7213ecbcdda07679$export$2e2bcd8739ae039);
    var $9fPrG;
    var $5EEYw;
    var $fWch8;
    var $9xRvt;
    const $7213ecbcdda07679$var$updateQuery = (push, state, callback)=>{
        const location = (0, (0, parcelRequire("fWch8")).getLocation)(state);
        const searchStr = (0, (0, parcelRequire("9xRvt")).convertQueryToString)(callback((0, (0, parcelRequire("fWch8")).getQuery)(state)));
        if (!(0, (0, parcelRequire("9fPrG")).hasMacroConfig)(state)) push({
            ...location,
            search: searchStr
        });
        return (0, (0, parcelRequire("5EEYw")).routerLocationChange)({
            ...location,
            search: `?${searchStr}`
        });
    };
    var $7213ecbcdda07679$export$2e2bcd8739ae039 = (push, state, callback)=>$7213ecbcdda07679$var$updateQuery(push, state, callback);
});
parcelRegister("5EEYw", function(module, exports) {
    $parcel$export(module.exports, "ROUTER_LOCATION_CHANGE", ()=>$0132f7a662080ce4$export$1c5e4d78bc961ac8);
    $parcel$export(module.exports, "routerLocationChange", ()=>$0132f7a662080ce4$export$989554cbc13fc377);
    const $0132f7a662080ce4$export$1c5e4d78bc961ac8 = 'ROUTER_LOCATION_CHANGE';
    const $0132f7a662080ce4$export$989554cbc13fc377 = (payload)=>({
            type: $0132f7a662080ce4$export$1c5e4d78bc961ac8,
            payload: payload
        });
});
parcelRegister("hzjpq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9498a4fb35a8fc2e$export$2e2bcd8739ae039);
    parcelRequire("fp4O3");
    parcelRequire("fPS7b");
    var $aB8eX = parcelRequire("aB8eX");
    var $kVLXA = parcelRequire("kVLXA");
    var $9QFr0;
    var $ilGit;
    var $35igy;
    var $9498a4fb35a8fc2e$export$2e2bcd8739ae039 = (action$, store, { router: { push: push } })=>action$.ofType((0, (0, parcelRequire("9QFr0")).CLEAR_FILTER_AND_SETTING)).mergeMap(()=>(0, $kVLXA.Observable).of((0, $aB8eX.batchActions)([
                (0, (0, parcelRequire("ilGit")).clearLevelOneSetting)(),
                (0, (0, parcelRequire("35igy")).default)(push, store.getState(), (query)=>({
                        ...query,
                        statuses: undefined,
                        assignee: undefined,
                        issueType: undefined,
                        text: undefined,
                        label: undefined,
                        issueParent: undefined,
                        epic: undefined,
                        version: undefined,
                        component: undefined,
                        quickFilter: undefined,
                        customFilter: undefined
                    }))
            ])));
});
parcelRegister("hPJQQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2e045563643920b1$export$2e2bcd8739ae039);
    parcelRequire("fp4O3");
    parcelRequire("6hSeW");
    parcelRequire("3awJm");
    parcelRequire("6cbqE");
    parcelRequire("d0pqD");
    var $kVLXA = parcelRequire("kVLXA");
    var $hSQIY = parcelRequire("hSQIY");
    var $5ulVP;
    var $9fPrG;
    var $9QFr0;
    const $2e045563643920b1$var$filter = (action, store)=>{
        const state = store.getState();
        const customFilterIds = action.payload;
        if (customFilterIds.length === 0) return (0, $kVLXA.Observable).of((0, (0, parcelRequire("9QFr0")).clearCustomFilters)());
        return (0, (0, parcelRequire("5ulVP")).filterItemsByJQLFilters)((0, (0, parcelRequire("9fPrG")).getSourceARI)(state), [], customFilterIds).map((filteredIssueIds)=>(0, (0, parcelRequire("9QFr0")).jqlFiltersSuccess)(filteredIssueIds));
    };
    var $2e045563643920b1$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, (0, parcelRequire("9QFr0")).CUSTOM_FILTERS_REQUEST)).throttleTime(500, (0, $hSQIY.async), {
            leading: true,
            trailing: true
        }).switchMap((action)=>$2e045563643920b1$var$filter(action, store));
});
parcelRegister("5ulVP", function(module, exports) {
    $parcel$export(module.exports, "filterItemsByJQLFilters", ()=>$05d37228473ad838$export$ac2f1bddc6081e48);
    parcelRequire("d0pqD");
    parcelRequire("9o0uh");
    var $gcktI;
    var $4bVdQ;
    var $iW95S;
    var $8C5lr;
    const $05d37228473ad838$var$analyticKey = 'jira.frontend.fe.software.roadmap.filter-roadmap-items';
    const $05d37228473ad838$var$concurrentMetricDefinition = (0, (0, parcelRequire("8C5lr")).queryMetrics)[0, $8038b72ffd5aa8d4$export$d21f08c0570f92f7];
    const $05d37228473ad838$export$ac2f1bddc6081e48 = (sourceAri, quickFilterIds, customFilterIds)=>(0, (0, parcelRequire("iW95S")).runQueryWithMetadata)((0, (0, parcelRequire("gcktI")).default), (0, (0, parcelRequire("4bVdQ")).generateFilterRoadmapItemsQueryVariables)(sourceAri, quickFilterIds ?? [], customFilterIds ?? []), $05d37228473ad838$var$analyticKey, $05d37228473ad838$var$concurrentMetricDefinition).map(({ data: data })=>{
            const issueIds = data.roadmaps?.roadmapFilterItems ?? [];
            return issueIds.slice();
        });
});
parcelRegister("gcktI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$74a7593135848df0$export$2e2bcd8739ae039);
    const $74a7593135848df0$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "customFilterIds"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "quickFilterIds"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "sourceAri"
        }, v3 = [
            {
                "concreteType": "RoadmapsQuery",
                "kind": "LinkedField",
                "name": "roadmaps",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "customFilterIds",
                                "variableName": "customFilterIds"
                            },
                            {
                                "kind": "Variable",
                                "name": "quickFilterIds",
                                "variableName": "quickFilterIds"
                            },
                            {
                                "kind": "Variable",
                                "name": "sourceARI",
                                "variableName": "sourceAri"
                            }
                        ],
                        "kind": "ScalarField",
                        "name": "roadmapFilterItems"
                    }
                ]
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2
                ],
                "kind": "Fragment",
                "name": "filterRoadmapItemsQuery",
                "selections": v3,
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v2,
                    v1,
                    v0
                ],
                "kind": "Operation",
                "name": "filterRoadmapItemsQuery",
                "selections": v3
            },
            "params": {
                "id": "27d267d70916c4190d559166d5b624c365e56a06e45c7cd51a1a29372491ea76",
                "metadata": {},
                "name": "filterRoadmapItemsQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $74a7593135848df0$var$node.hash = "19827cdd137051897ba5e27b5db7eeae";
    var $74a7593135848df0$export$2e2bcd8739ae039 = $74a7593135848df0$var$node;
});
parcelRegister("4bVdQ", function(module, exports) {
    $parcel$export(module.exports, "generateFilterRoadmapItemsQueryVariables", ()=>$885bfaa6750f7d93$export$3b5355050a9c05db);
    const $885bfaa6750f7d93$export$3b5355050a9c05db = (sourceAri, quickFilterIds, customFilterIds)=>({
            sourceAri: sourceAri,
            quickFilterIds: quickFilterIds,
            customFilterIds: customFilterIds
        });
});
const $8038b72ffd5aa8d4$export$3ac90e7f239a7193 = 'dependencyDnd';
const $8038b72ffd5aa8d4$export$eedef6333f320132 = 'issueViewResizeDnd';
const $8038b72ffd5aa8d4$export$2475592765cae5b0 = 'chartBarResize';
const $8038b72ffd5aa8d4$export$2afae5ee414caffb = 'persistItem';
const $8038b72ffd5aa8d4$export$26d8759f6f1c8e13 = 'exportImageGenerated';
const $8038b72ffd5aa8d4$export$e04dc5133fcac555 = 'issueUpdated';
const $8038b72ffd5aa8d4$export$5913ec3a0f9505fe = 'dependencyAdded';
const $8038b72ffd5aa8d4$export$488a6fa9078615df = 'dependencyRemoved';
const $8038b72ffd5aa8d4$export$315e0cbd8c7bfbd4 = 'bulkIssuesScheduled';
const $8038b72ffd5aa8d4$export$f096bf13c1d89b91 = 'resolveHealthcheck';
const $8038b72ffd5aa8d4$export$12daf7ce2c179397 = 'criticalData';
const $8038b72ffd5aa8d4$export$ede40e627a0cbf14 = 'versionDetails';
const $8038b72ffd5aa8d4$export$1df1eb270f208354 = 'sprintDetails';
const $8038b72ffd5aa8d4$export$bd4cd00ee0750c9a = 'filterConfiguration';
const $8038b72ffd5aa8d4$export$9e57feecc7b4c365 = 'deriveFields';
const $8038b72ffd5aa8d4$export$d21f08c0570f92f7 = 'filterRoadmapItems';
const $8038b72ffd5aa8d4$export$72305db43681d1de = 'getIssueIds';
const $8038b72ffd5aa8d4$export$51617034fb6f2e3a = 'getItemsByIds';
const $8038b72ffd5aa8d4$export$d959a123e6ceb778 = 'getSubtasks';
const $8038b72ffd5aa8d4$export$2e07b3a26c033d37 = 'healthcheckIssueTypes';
const $8038b72ffd5aa8d4$export$a0d61e9ea4ad5a05 = 'jqlFiltersReapply';
const $8038b72ffd5aa8d4$export$57a4171901f1c15b = 'getGoals';
parcelRegister("iW95S", function(module, exports) {
    $parcel$export(module.exports, "runQueryWithMetadata", ()=>$7e96ecd8340785d0$export$24c7a6008914d023);
    $parcel$export(module.exports, "runQueryWithMetadataAndSelector", ()=>$7e96ecd8340785d0$export$58a45f50aef158ce);
    var $8Uumt = parcelRequire("8Uumt");
    var $kVLXA = parcelRequire("kVLXA");
    var $e6C7w = parcelRequire("e6C7w");
    parcelRequire("c66Ur");
    parcelRequire("d0pqD");
    var $j7Dz8 = parcelRequire("j7Dz8");
    var $7Jxgt = parcelRequire("7Jxgt");
    var $4R6GH;
    var $5yJb9;
    var $5a0Nh;
    var $4pgHP;
    var $5Wobd;
    var $8P9VR;
    parcelRequire("9o0uh");
    var $8ab4g;
    const $7e96ecd8340785d0$var$runQueryWithMetadataInternal = (compiledQuery, variables, executionOptions = {})=>{
        const operationName = compiledQuery.params.name;
        (0, (0, parcelRequire("5Wobd")).startCapturingTraceIds)(operationName);
        (0, (0, parcelRequire("4pgHP")).startCapturingExtensions)(operationName);
        const errorCollector = (0, (0, parcelRequire("5a0Nh")).startCaptureGraphQlErrors)();
        if ((0, (0, parcelRequire("4R6GH")).fg)('jsw-roadmap-unsubscribable-query')) return (0, (0, parcelRequire("8ab4g")).fetchQueryObservable)((0, (0, parcelRequire("5yJb9")).default)(), compiledQuery, variables).catch((error)=>{
            const traceIds = (0, (0, parcelRequire("5Wobd")).getTraceIds)(operationName);
            (0, (0, parcelRequire("5Wobd")).stopCapturingTraceIds)(operationName);
            throw (0, (0, parcelRequire("8ab4g")).transformGenericError)(error, traceIds, operationName);
        }).map((data)=>{
            const traceIds = (0, (0, parcelRequire("5Wobd")).getTraceIds)(operationName);
            (0, (0, parcelRequire("5Wobd")).stopCapturingTraceIds)(operationName);
            const [extensions] = (0, (0, parcelRequire("4pgHP")).getExtensions)(operationName);
            (0, (0, parcelRequire("4pgHP")).stopCapturingExtensions)(operationName);
            const relevantErrors = (0, (0, parcelRequire("8ab4g")).getGraphQlErrorsForOperation)(errorCollector, operationName, executionOptions);
            if (relevantErrors.length > 0) throw new (0, (0, parcelRequire("8P9VR")).AggError)(`Query ${operationName} had graphql errors`, relevantErrors, traceIds, (0, (0, parcelRequire("8P9VR")).GRAPHQL_ERROR));
            return {
                metadata: {
                    operationName: operationName,
                    traceIds: traceIds,
                    extensions: extensions
                },
                data: data
            };
        });
        return (0, $kVLXA.Observable).fromPromise(new Promise((resolve, reject)=>{
            (0, $8Uumt.fetchQuery)((0, (0, parcelRequire("5yJb9")).default)(), compiledQuery, variables).subscribe({
                error: (error)=>{
                    const traceIds = (0, (0, parcelRequire("5Wobd")).getTraceIds)(operationName);
                    (0, (0, parcelRequire("5Wobd")).stopCapturingTraceIds)(operationName);
                    (0, (0, parcelRequire("4pgHP")).stopCapturingExtensions)(operationName);
                    const transformedError = (0, (0, parcelRequire("8ab4g")).transformGenericError)(error, traceIds, operationName);
                    reject(transformedError);
                },
                next: (data)=>{
                    const traceIds = (0, (0, parcelRequire("5Wobd")).getTraceIds)(operationName);
                    (0, (0, parcelRequire("5Wobd")).stopCapturingTraceIds)(operationName);
                    const [extensions] = (0, (0, parcelRequire("4pgHP")).getExtensions)(operationName);
                    (0, (0, parcelRequire("4pgHP")).stopCapturingExtensions)(operationName);
                    const relevantErrors = (0, (0, parcelRequire("8ab4g")).getGraphQlErrorsForOperation)(errorCollector, operationName, executionOptions);
                    if (relevantErrors.length > 0) {
                        reject(new (0, (0, parcelRequire("8P9VR")).AggError)(`Query ${operationName} had graphql errors`, relevantErrors, traceIds, (0, (0, parcelRequire("8P9VR")).GRAPHQL_ERROR)));
                        return;
                    }
                    resolve({
                        metadata: {
                            operationName: operationName,
                            traceIds: traceIds,
                            extensions: extensions
                        },
                        data: data
                    });
                }
            });
        }));
    };
    const $7e96ecd8340785d0$export$24c7a6008914d023 = (compiledQuery, variables, analyticKey, concurrentMetricDefinition, executionOptions = {})=>{
        const concurrentId = (0, ($parcel$interopDefault($7Jxgt))).v4();
        concurrentMetricDefinition(concurrentId).start();
        let isRetried = false;
        return $7e96ecd8340785d0$var$runQueryWithMetadataInternal(compiledQuery, variables, executionOptions).pipe((0, $e6C7w.catchError)((error)=>{
            if (error instanceof (0, (0, parcelRequire("8P9VR")).AggError)) {
                if (error.errorType === (0, (0, parcelRequire("8P9VR")).INVALID_PAYLOAD_ERROR) || error.errorType === (0, (0, parcelRequire("8P9VR")).MISSING_DATA_ERROR) || (error.errorType === (0, (0, parcelRequire("8P9VR")).NETWORK_ERROR) || error.errorType === (0, (0, parcelRequire("8P9VR")).GRAPHQL_ERROR)) && (error.errors.length === 0 || error.errors[0].extensions != null && error.errors[0].extensions.statusCode >= '500' && error.errors[0].extensions.statusCode <= '600')) {
                    isRetried = true;
                    return $7e96ecd8340785d0$var$runQueryWithMetadataInternal(compiledQuery, variables, executionOptions);
                }
            }
            throw error;
        }), (0, $j7Dz8.tap)({
            next: ({ metadata: { traceIds: traceIds } })=>{
                (0, (0, parcelRequire("8ab4g")).sendOperationalEventV2)(analyticKey, '200', traceIds, isRetried);
                concurrentMetricDefinition(concurrentId).stop({
                    customData: {
                        traceId: traceIds[0],
                        statusCode: '200',
                        isRetried: isRetried
                    }
                });
            },
            error: (error)=>{
                const { traceIds: traceIds, statusCode: statusCode } = (0, (0, parcelRequire("8ab4g")).sendOperationalEventV2OnError)(error, analyticKey, isRetried);
                concurrentMetricDefinition(concurrentId).stop({
                    customData: {
                        traceId: traceIds[0],
                        statusCode: statusCode,
                        isRetried: isRetried
                    }
                });
            }
        }));
    };
    const $7e96ecd8340785d0$export$58a45f50aef158ce = (compiledQuery, variables, analyticKey, concurrentMetricDefinition, selector, executionOptions = {})=>$7e96ecd8340785d0$export$24c7a6008914d023(compiledQuery, variables, analyticKey, concurrentMetricDefinition, executionOptions).map(({ data: data, metadata: metadata })=>{
            const field = selector(data);
            if (field == null) throw new (0, (0, parcelRequire("8P9VR")).AggError)(`Failed to retrieve data via ${metadata.operationName}`, [], metadata.traceIds, (0, (0, parcelRequire("8P9VR")).MISSING_DATA_ERROR));
            return {
                data: field,
                metadata: metadata
            };
        });
});
parcelRegister("8P9VR", function(module, exports) {
    $parcel$export(module.exports, "GRAPHQL_ERROR", ()=>$727ed37194669db8$export$2d06efb8146cd043);
    $parcel$export(module.exports, "UNKNOWN_ERROR", ()=>$727ed37194669db8$export$f10b32dfda12e96e);
    $parcel$export(module.exports, "NETWORK_ERROR", ()=>$727ed37194669db8$export$e5e4b8c32e68dd0b);
    $parcel$export(module.exports, "MISSING_DATA_ERROR", ()=>$727ed37194669db8$export$3ee0525ef4410691);
    $parcel$export(module.exports, "INVALID_PAYLOAD_ERROR", ()=>$727ed37194669db8$export$e264e80e8bb90041);
    $parcel$export(module.exports, "AggError", ()=>$727ed37194669db8$export$fb37d46cecef6785);
    var $9XE6b = parcelRequire("9XE6b");
    var $hYfgW = parcelRequire("hYfgW");
    var $lGq2J;
    const $727ed37194669db8$export$2d06efb8146cd043 = 'graphql';
    const $727ed37194669db8$export$f10b32dfda12e96e = 'unknown';
    const $727ed37194669db8$export$e5e4b8c32e68dd0b = 'network';
    const $727ed37194669db8$export$3ee0525ef4410691 = 'missingData';
    const $727ed37194669db8$export$e264e80e8bb90041 = 'invalidPayload';
    const $727ed37194669db8$var$errorSanitizationRegex = /\bNetwork\serror:|GraphQL\serror:/;
    class $727ed37194669db8$export$fb37d46cecef6785 extends Error {
        getCause() {
            return this.cause;
        }
        constructor(message, errors, traceIds, errorType, cause){
            super(message, {
                cause: cause
            });
            this.affectsReliability = true;
            this.skipSentry = true;
            this.errors = errors;
            this.traceIds = traceIds;
            this.errorType = errorType;
            this.traceId = (0, ($parcel$interopDefault($hYfgW)))(this.traceIds);
            this.statusCodes = errors.map((graphQLError)=>graphQLError?.extensions?.statusCode).filter((x)=>x != null);
            this.userMessages = errors.map((graphQLError)=>(0, ($parcel$interopDefault($9XE6b)))(graphQLError, 'extensions.userMessage', undefined) || graphQLError?.message || undefined).filter((x)=>x != null);
            this.computeAffectsReliability();
            this.skipSentry = !this.affectsReliability || this.statusCodes.some((statusCode)=>(0, (0, parcelRequire("lGq2J")).statusCodesToSkipForSentry).includes(statusCode)) || this.userMessages.some((msg)=>(0, (0, parcelRequire("lGq2J")).errorMessagesToSkipForSentry).includes(msg.replace($727ed37194669db8$var$errorSanitizationRegex, '').trim()));
        }
        computeAffectsReliability() {
            const causeTrimmedMessage = this.getCause()?.message?.replace($727ed37194669db8$var$errorSanitizationRegex, '').trim() || '';
            this.affectsReliability = this.affectsReliability && !this.statusCodes.some((code)=>(0, (0, parcelRequire("lGq2J")).statusCodesNotImpactingReliability).includes(Number(code))) && !(0, (0, parcelRequire("lGq2J")).errorMessagesNotImpactingReliability).includes(causeTrimmedMessage) && !this.userMessages.some((message)=>(0, (0, parcelRequire("lGq2J")).errorMessagesNotImpactingReliability).includes(message.replace($727ed37194669db8$var$errorSanitizationRegex, '').trim()));
        }
    }
});
parcelRegister("lGq2J", function(module, exports) {
    $parcel$export(module.exports, "statusCodesNotImpactingReliability", ()=>$475f5c512b428e2b$export$501df64f0fda1d63);
    $parcel$export(module.exports, "statusCodesToSkipForSentry", ()=>$475f5c512b428e2b$export$8cef49ed469b6cd2);
    $parcel$export(module.exports, "errorMessagesToSkipForSentry", ()=>$475f5c512b428e2b$export$a23281a65ac65f85);
    $parcel$export(module.exports, "errorMessagesNotImpactingReliability", ()=>$475f5c512b428e2b$export$4e68293cfa47ee01);
    const $475f5c512b428e2b$export$501df64f0fda1d63 = [
        400,
        404,
        401,
        403,
        408,
        426,
        429
    ];
    const $475f5c512b428e2b$export$8cef49ed469b6cd2 = [
        503
    ];
    const $475f5c512b428e2b$export$a23281a65ac65f85 = [
        'The underlying service call timed out'
    ];
    const $475f5c512b428e2b$export$4e68293cfa47ee01 = [
        'Failed to fetch',
        'NetworkError when attempting to fetch resource.',
        'The operation was aborted.',
        'Auth category: UNAUTHENTICATED is not allowed in service roadmaps',
        'Failed to retrieve data via roadmapCriticalDataFromRoadmapService. Underlying error: Error: Failed to fetch'
    ];
});
parcelRegister("8ab4g", function(module, exports) {
    $parcel$export(module.exports, "getGraphQlErrorsForOperation", ()=>$98d3f614728d7a9f$export$c1e5df311f2b29b2);
    $parcel$export(module.exports, "sendOperationalEventV2", ()=>$98d3f614728d7a9f$export$93d0b35b696044cb);
    $parcel$export(module.exports, "fetchQueryObservable", ()=>$98d3f614728d7a9f$export$1b6907b181f00104);
    $parcel$export(module.exports, "commitMutationObservable", ()=>$98d3f614728d7a9f$export$86078ec91637a7ad);
    $parcel$export(module.exports, "transformGenericError", ()=>$98d3f614728d7a9f$export$7492c515d6da61a3);
    $parcel$export(module.exports, "transformGraphQLErrors", ()=>$98d3f614728d7a9f$export$b032b8d1c2b46aae);
    $parcel$export(module.exports, "sendOperationalEventV2OnError", ()=>$98d3f614728d7a9f$export$5434dcf2ed596c6e);
    $parcel$export(module.exports, "sendOperationalEventV2OnSuccess", ()=>$98d3f614728d7a9f$export$3a2ff6315865acd7);
    var $8Uumt = parcelRequire("8Uumt");
    var $kVLXA = parcelRequire("kVLXA");
    var $jJZqs;
    var $fjcgS;
    var $5a0Nh;
    var $8P9VR;
    const $98d3f614728d7a9f$var$statusCodeRegex = /^[12345][0-9]{2}$/;
    const $98d3f614728d7a9f$export$c1e5df311f2b29b2 = (errorCollector, operationName, executionOptions = {})=>{
        const errorsWithMeta = (0, (0, parcelRequire("5a0Nh")).stopCaptureGraphQlErrors)(errorCollector);
        if (Array.isArray(errorsWithMeta)) {
            const operationErrors = errorsWithMeta.filter((errorWithMeta)=>errorWithMeta.meta.operationName === operationName).flatMap((errorWithMeta)=>errorWithMeta.errors);
            return executionOptions.graphqlErrorFilter ? executionOptions.graphqlErrorFilter(operationErrors) : operationErrors;
        }
        return [];
    };
    const $98d3f614728d7a9f$export$e5f89b51c6d4e36b = (analyticKey, statusCode, aggTraceIds, isRetried, cause)=>{
        (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>{
            const analyticsClient = client.getInstance();
            if (!analyticsClient) return;
            let statusCodeFamily = 'unknown';
            if (statusCode !== null) {
                const statusCodeAsStr = String(statusCode);
                if (statusCodeAsStr === '0' || statusCodeAsStr === '429') statusCodeFamily = statusCodeAsStr;
                else if (statusCodeAsStr.match(/^[12345][0-9]{2}$/)) statusCodeFamily = `${statusCodeAsStr[0]}xx`;
            }
            analyticsClient.sendOperationalEvent({
                action: 'fetch',
                actionSubject: 'relay operation',
                attributes: {
                    key: analyticKey,
                    statusCode: statusCode,
                    statusCodeFamily: statusCodeFamily,
                    traceId: aggTraceIds[0],
                    frontendVersion: window.BUILD_KEY,
                    isRetried: isRetried,
                    cause: cause
                },
                source: 'relayOperation'
            });
        });
    };
    const $98d3f614728d7a9f$export$93d0b35b696044cb = (analyticKey, statusCode, aggTraceIds, isRetried, errorDetails)=>{
        (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>{
            const analyticsClient = client.getInstance();
            if (!analyticsClient) return;
            let statusCodeFamily = 'unknown';
            if (statusCode !== null) {
                const statusCodeAsStr = String(statusCode);
                if (statusCodeAsStr === '0' || statusCodeAsStr === '429') statusCodeFamily = statusCodeAsStr;
                else if (statusCodeAsStr.match($98d3f614728d7a9f$var$statusCodeRegex)) statusCodeFamily = `${statusCodeAsStr[0]}xx`;
            }
            analyticsClient.sendOperationalEvent({
                action: 'fetch',
                actionSubject: 'relay operation',
                attributes: {
                    key: analyticKey,
                    statusCode: statusCode,
                    statusCodeFamily: statusCodeFamily,
                    traceId: aggTraceIds[0],
                    frontendVersion: window.BUILD_KEY,
                    affectsReliability: errorDetails?.affectsReliability || false,
                    skipSentry: errorDetails?.skipSentry || false,
                    isRetried: isRetried,
                    cause: errorDetails?.cause
                },
                source: 'relayOperation'
            });
        });
    };
    const $98d3f614728d7a9f$export$b57c7b401625b0df = (create)=>(0, $kVLXA.Observable).create((sink)=>{
            const subscription = create().subscribe(sink);
            return ()=>subscription.unsubscribe();
        });
    const $98d3f614728d7a9f$export$1b6907b181f00104 = (environment, taggedNode, variables, cacheConfig)=>$98d3f614728d7a9f$export$b57c7b401625b0df(()=>(0, $8Uumt.fetchQuery)(environment, taggedNode, variables, cacheConfig));
    const $98d3f614728d7a9f$export$86078ec91637a7ad = (environment, config)=>(0, $kVLXA.Observable).create((subscriber)=>{
            const disposable = (0, $8Uumt.commitMutation)(environment, {
                ...config,
                onCompleted: (response)=>{
                    subscriber.next(response);
                    subscriber.complete();
                },
                onError: (err)=>subscriber.error(err),
                onUnsubscribe: ()=>subscriber.unsubscribe()
            });
            return ()=>disposable.dispose();
        });
    const $98d3f614728d7a9f$export$7492c515d6da61a3 = (error, traceIds, operationName)=>{
        let transformedError = new (0, (0, parcelRequire("8P9VR")).AggError)(error.message ?? `An unknown error has occured from ${operationName}`, [], traceIds, (0, (0, parcelRequire("8P9VR")).UNKNOWN_ERROR), error);
        if (error instanceof (0, (0, parcelRequire("jJZqs")).ValidationError)) {
            const newTraceId = error.traceId != null ? [
                error.traceId
            ] : traceIds;
            transformedError = new (0, (0, parcelRequire("8P9VR")).AggError)(`Query ${operationName} failed while fetching the data: HTTP ${error.statusCode}`, [
                {
                    message: error.message,
                    extensions: {
                        statusCode: error.statusCode,
                        errorType: (0, (0, parcelRequire("8P9VR")).NETWORK_ERROR)
                    }
                }
            ], newTraceId, (0, (0, parcelRequire("8P9VR")).NETWORK_ERROR), error);
        }
        if (error instanceof DOMException && error.name === 'AbortError') transformedError = new (0, (0, parcelRequire("8P9VR")).AggError)(`Query ${operationName} was aborted.`, [], traceIds, (0, (0, parcelRequire("8P9VR")).NETWORK_ERROR), error);
        if (error instanceof SyntaxError) transformedError = new (0, (0, parcelRequire("8P9VR")).AggError)(`Query ${operationName} response payload was invalid and could not be parsed`, [], traceIds, (0, (0, parcelRequire("8P9VR")).INVALID_PAYLOAD_ERROR), error);
        if (error instanceof (0, (0, parcelRequire("jJZqs")).default)) {
            const newTraceId = error.traceId != null ? [
                error.traceId
            ] : traceIds;
            transformedError = new (0, (0, parcelRequire("8P9VR")).AggError)(`Query ${operationName} failed while fetching the data: HTTP ${error.statusCode}`, [
                {
                    message: error.message,
                    extensions: {
                        statusCode: error.statusCode,
                        errorType: (0, (0, parcelRequire("8P9VR")).NETWORK_ERROR)
                    }
                }
            ], newTraceId, (0, (0, parcelRequire("8P9VR")).NETWORK_ERROR), error);
        }
        return transformedError;
    };
    const $98d3f614728d7a9f$export$b032b8d1c2b46aae = (relevantErrors, operationName, traceIds)=>new (0, (0, parcelRequire("8P9VR")).AggError)(`Query ${operationName} had graphql errors`, relevantErrors, traceIds, (0, (0, parcelRequire("8P9VR")).GRAPHQL_ERROR));
    const $98d3f614728d7a9f$export$5434dcf2ed596c6e = (error, analyticKey, isRetried, statusCodeOveride)=>{
        let traceIds = [];
        let statusCode = 'unknown';
        let cause = '';
        let skipSentry = false;
        let affectsReliability = true;
        if (error instanceof (0, (0, parcelRequire("8P9VR")).AggError)) {
            traceIds = error.traceIds;
            affectsReliability = error.affectsReliability;
            skipSentry = error.skipSentry;
            statusCode = statusCodeOveride || String(error.statusCodes[0] || 'unknown');
            cause = String(error.getCause()?.message || '');
        }
        $98d3f614728d7a9f$export$93d0b35b696044cb(analyticKey, statusCode, traceIds, isRetried, {
            cause: cause,
            affectsReliability: affectsReliability,
            skipSentry: skipSentry
        });
        return {
            traceIds: traceIds,
            statusCode: statusCode
        };
    };
    const $98d3f614728d7a9f$export$3a2ff6315865acd7 = (analyticKey, traceId, isRetried = false)=>{
        $98d3f614728d7a9f$export$93d0b35b696044cb(analyticKey, '200', traceId, isRetried);
    };
});
parcelRegister("8C5lr", function(module, exports) {
    $parcel$export(module.exports, "interactionMetrics", ()=>$6a2635e740e456a0$export$86db56030b57ba34);
    $parcel$export(module.exports, "mutationMetrics", ()=>$6a2635e740e456a0$export$bc11f2f91fc3aebe);
    $parcel$export(module.exports, "queryMetrics", ()=>$6a2635e740e456a0$export$d22c4382fb7221a0);
    var $3T6Xo = parcelRequire("3T6Xo");
    var $dGrdR;
    var $iZN6h;
    var $1XaAy;
    const $6a2635e740e456a0$var$STATE_CHANGE_BASED_ISSUE_HIDDEN_FLAGS = 'jsw-roadmap-state-change-based-issue-hidden-flags';
    const $6a2635e740e456a0$var$buildInteractionParameters = (type, featureFlags)=>{
        const slo = (0, (0, parcelRequire("1XaAy")).default)[type] || 0;
        return {
            key: `roadmap.${(0, ($parcel$interopDefault($3T6Xo)))(type)}`,
            featureFlags: featureFlags,
            ...slo ? {
                slo: {
                    response: {
                        threshold: slo
                    },
                    result: {
                        threshold: slo
                    }
                }
            } : undefined
        };
    };
    const $6a2635e740e456a0$var$getInteractionMetrics = (type, featureFlags)=>(0, (0, parcelRequire("dGrdR")).metrics).interaction($6a2635e740e456a0$var$buildInteractionParameters(type, featureFlags));
    const $6a2635e740e456a0$var$getConcurrentInteractionMetrics = (type)=>(0, (0, parcelRequire("dGrdR")).metrics).concurrent.interaction($6a2635e740e456a0$var$buildInteractionParameters(type));
    const $6a2635e740e456a0$export$86db56030b57ba34 = {
        [(0, (0, parcelRequire("iZN6h")).LIST_DRAG_AND_DROP)]: $6a2635e740e456a0$var$getInteractionMetrics((0, (0, parcelRequire("iZN6h")).LIST_DRAG_AND_DROP)),
        [(0, (0, parcelRequire("iZN6h")).CHILD_LIST_DRAG_AND_DROP)]: $6a2635e740e456a0$var$getInteractionMetrics((0, (0, parcelRequire("iZN6h")).CHILD_LIST_DRAG_AND_DROP)),
        [(0, (0, parcelRequire("iZN6h")).LIST_RESIZE_DRAG_AND_DROP)]: $6a2635e740e456a0$var$getInteractionMetrics((0, (0, parcelRequire("iZN6h")).LIST_RESIZE_DRAG_AND_DROP)),
        [(0, $8038b72ffd5aa8d4$export$3ac90e7f239a7193)]: $6a2635e740e456a0$var$getInteractionMetrics((0, $8038b72ffd5aa8d4$export$3ac90e7f239a7193)),
        [(0, $8038b72ffd5aa8d4$export$2475592765cae5b0)]: $6a2635e740e456a0$var$getInteractionMetrics((0, $8038b72ffd5aa8d4$export$2475592765cae5b0)),
        [(0, $8038b72ffd5aa8d4$export$26d8759f6f1c8e13)]: $6a2635e740e456a0$var$getInteractionMetrics((0, $8038b72ffd5aa8d4$export$26d8759f6f1c8e13)),
        [(0, (0, parcelRequire("iZN6h")).SCROLLED)]: $6a2635e740e456a0$var$getInteractionMetrics((0, (0, parcelRequire("iZN6h")).SCROLLED)),
        [(0, $8038b72ffd5aa8d4$export$a0d61e9ea4ad5a05)]: $6a2635e740e456a0$var$getInteractionMetrics((0, $8038b72ffd5aa8d4$export$a0d61e9ea4ad5a05), [
            $6a2635e740e456a0$var$STATE_CHANGE_BASED_ISSUE_HIDDEN_FLAGS
        ]),
        [(0, $8038b72ffd5aa8d4$export$eedef6333f320132)]: $6a2635e740e456a0$var$getInteractionMetrics((0, $8038b72ffd5aa8d4$export$eedef6333f320132))
    };
    const $6a2635e740e456a0$export$bc11f2f91fc3aebe = {
        [(0, $8038b72ffd5aa8d4$export$2afae5ee414caffb)]: $6a2635e740e456a0$var$getConcurrentInteractionMetrics((0, $8038b72ffd5aa8d4$export$2afae5ee414caffb)),
        [(0, $8038b72ffd5aa8d4$export$5913ec3a0f9505fe)]: $6a2635e740e456a0$var$getConcurrentInteractionMetrics((0, $8038b72ffd5aa8d4$export$5913ec3a0f9505fe)),
        [(0, $8038b72ffd5aa8d4$export$488a6fa9078615df)]: $6a2635e740e456a0$var$getConcurrentInteractionMetrics((0, $8038b72ffd5aa8d4$export$488a6fa9078615df)),
        [(0, $8038b72ffd5aa8d4$export$315e0cbd8c7bfbd4)]: $6a2635e740e456a0$var$getConcurrentInteractionMetrics((0, $8038b72ffd5aa8d4$export$315e0cbd8c7bfbd4)),
        [(0, $8038b72ffd5aa8d4$export$e04dc5133fcac555)]: $6a2635e740e456a0$var$getConcurrentInteractionMetrics((0, $8038b72ffd5aa8d4$export$e04dc5133fcac555)),
        [(0, $8038b72ffd5aa8d4$export$f096bf13c1d89b91)]: $6a2635e740e456a0$var$getConcurrentInteractionMetrics((0, $8038b72ffd5aa8d4$export$f096bf13c1d89b91))
    };
    const $6a2635e740e456a0$export$d22c4382fb7221a0 = {
        [(0, $8038b72ffd5aa8d4$export$12daf7ce2c179397)]: $6a2635e740e456a0$var$getConcurrentInteractionMetrics((0, $8038b72ffd5aa8d4$export$12daf7ce2c179397)),
        [(0, $8038b72ffd5aa8d4$export$bd4cd00ee0750c9a)]: $6a2635e740e456a0$var$getConcurrentInteractionMetrics((0, $8038b72ffd5aa8d4$export$bd4cd00ee0750c9a)),
        [(0, $8038b72ffd5aa8d4$export$9e57feecc7b4c365)]: $6a2635e740e456a0$var$getConcurrentInteractionMetrics((0, $8038b72ffd5aa8d4$export$9e57feecc7b4c365)),
        [(0, $8038b72ffd5aa8d4$export$ede40e627a0cbf14)]: $6a2635e740e456a0$var$getConcurrentInteractionMetrics((0, $8038b72ffd5aa8d4$export$ede40e627a0cbf14)),
        [(0, $8038b72ffd5aa8d4$export$1df1eb270f208354)]: $6a2635e740e456a0$var$getConcurrentInteractionMetrics((0, $8038b72ffd5aa8d4$export$1df1eb270f208354)),
        [(0, $8038b72ffd5aa8d4$export$d21f08c0570f92f7)]: $6a2635e740e456a0$var$getConcurrentInteractionMetrics((0, $8038b72ffd5aa8d4$export$d21f08c0570f92f7)),
        [(0, $8038b72ffd5aa8d4$export$72305db43681d1de)]: $6a2635e740e456a0$var$getConcurrentInteractionMetrics((0, $8038b72ffd5aa8d4$export$72305db43681d1de)),
        [(0, $8038b72ffd5aa8d4$export$51617034fb6f2e3a)]: $6a2635e740e456a0$var$getConcurrentInteractionMetrics((0, $8038b72ffd5aa8d4$export$51617034fb6f2e3a)),
        [(0, $8038b72ffd5aa8d4$export$d959a123e6ceb778)]: $6a2635e740e456a0$var$getConcurrentInteractionMetrics((0, $8038b72ffd5aa8d4$export$d959a123e6ceb778)),
        [(0, $8038b72ffd5aa8d4$export$2e07b3a26c033d37)]: $6a2635e740e456a0$var$getConcurrentInteractionMetrics((0, $8038b72ffd5aa8d4$export$2e07b3a26c033d37)),
        [(0, $8038b72ffd5aa8d4$export$57a4171901f1c15b)]: $6a2635e740e456a0$var$getConcurrentInteractionMetrics((0, $8038b72ffd5aa8d4$export$57a4171901f1c15b))
    };
});
parcelRegister("1XaAy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dfcada9941af7022$export$2e2bcd8739ae039);
    const $dfcada9941af7022$var$railTargets = {
        animation: 16,
        inline: 100,
        load: 1000
    };
    const $dfcada9941af7022$var$serverResponseTargets = {
        fetch: 750,
        bulk: 2000,
        mutate: 2500,
        fastMutate: 1500,
        slowFetch: 1000
    };
    const $dfcada9941af7022$var$interactionSLOs = {
        [(0, $8038b72ffd5aa8d4$export$2475592765cae5b0)]: $dfcada9941af7022$var$railTargets.inline,
        [(0, $8038b72ffd5aa8d4$export$26d8759f6f1c8e13)]: $dfcada9941af7022$var$railTargets.load,
        [(0, $8038b72ffd5aa8d4$export$2afae5ee414caffb)]: $dfcada9941af7022$var$serverResponseTargets.mutate,
        [(0, $8038b72ffd5aa8d4$export$315e0cbd8c7bfbd4)]: $dfcada9941af7022$var$serverResponseTargets.bulk,
        [(0, $8038b72ffd5aa8d4$export$e04dc5133fcac555)]: $dfcada9941af7022$var$serverResponseTargets.fastMutate,
        [(0, $8038b72ffd5aa8d4$export$5913ec3a0f9505fe)]: $dfcada9941af7022$var$serverResponseTargets.slowFetch,
        [(0, $8038b72ffd5aa8d4$export$12daf7ce2c179397)]: $dfcada9941af7022$var$serverResponseTargets.fetch,
        [(0, $8038b72ffd5aa8d4$export$ede40e627a0cbf14)]: $dfcada9941af7022$var$serverResponseTargets.fetch,
        [(0, $8038b72ffd5aa8d4$export$72305db43681d1de)]: $dfcada9941af7022$var$serverResponseTargets.slowFetch,
        [(0, $8038b72ffd5aa8d4$export$51617034fb6f2e3a)]: $dfcada9941af7022$var$serverResponseTargets.slowFetch,
        [(0, $8038b72ffd5aa8d4$export$2e07b3a26c033d37)]: $dfcada9941af7022$var$serverResponseTargets.fetch,
        [(0, $8038b72ffd5aa8d4$export$bd4cd00ee0750c9a)]: $dfcada9941af7022$var$serverResponseTargets.fetch,
        [(0, $8038b72ffd5aa8d4$export$9e57feecc7b4c365)]: $dfcada9941af7022$var$serverResponseTargets.fetch,
        [(0, $8038b72ffd5aa8d4$export$57a4171901f1c15b)]: $dfcada9941af7022$var$serverResponseTargets.fetch
    };
    var $dfcada9941af7022$export$2e2bcd8739ae039 = $dfcada9941af7022$var$interactionSLOs;
});
parcelRegister("2isEz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$acf8c7622a170cfe$export$2e2bcd8739ae039);
    parcelRequire("7Ts1V");
    parcelRequire("inj9P");
    var $kVLXA = parcelRequire("kVLXA");
    var $5ulVP;
    var $9fPrG;
    var $fWch8;
    var $9QFr0;
    var $acf8c7622a170cfe$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, (0, parcelRequire("9QFr0")).JQL_FILTERS_REAPPLY)).switchMap(()=>{
            const state = store.getState();
            const quickFilterIds = (0, (0, parcelRequire("fWch8")).getQuickFilters)(state);
            const customFilterIds = (0, (0, parcelRequire("fWch8")).getCustomFilters)(state);
            const isJQLFilterApplied = quickFilterIds.length > 0 || customFilterIds.length > 0;
            const sourceARI = (0, (0, parcelRequire("9fPrG")).getSourceARI)(state);
            if (isJQLFilterApplied) return (0, $kVLXA.Observable).defer(()=>(0, (0, parcelRequire("5ulVP")).filterItemsByJQLFilters)(sourceARI, quickFilterIds, customFilterIds).map((issueIds)=>(0, (0, parcelRequire("9QFr0")).jqlFiltersSuccess)(issueIds)));
            return (0, $kVLXA.Observable).empty();
        });
});
parcelRegister("j28ON", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$836733f4bf1ffdb2$export$2e2bcd8739ae039);
    parcelRequire("fp4O3");
    parcelRequire("6hSeW");
    parcelRequire("3awJm");
    parcelRequire("6cbqE");
    parcelRequire("d0pqD");
    var $kVLXA = parcelRequire("kVLXA");
    var $hSQIY = parcelRequire("hSQIY");
    var $5ulVP;
    var $9fPrG;
    var $9QFr0;
    const $836733f4bf1ffdb2$var$filter = (action, store)=>{
        const state = store.getState();
        const quickFilterIds = action.payload;
        if (!quickFilterIds || !quickFilterIds.length) return (0, $kVLXA.Observable).of((0, (0, parcelRequire("9QFr0")).clearQuickFilters)());
        return (0, (0, parcelRequire("5ulVP")).filterItemsByJQLFilters)((0, (0, parcelRequire("9fPrG")).getSourceARI)(state), quickFilterIds).map((filteredIssueIds)=>(0, (0, parcelRequire("9QFr0")).jqlFiltersSuccess)(filteredIssueIds));
    };
    var $836733f4bf1ffdb2$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, (0, parcelRequire("9QFr0")).QUICK_FILTERS_REQUEST)).throttleTime(500, (0, $hSQIY.async), {
            leading: true,
            trailing: true
        }).switchMap((action)=>$836733f4bf1ffdb2$var$filter(action, store));
});
parcelRegister("a01Zn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4513618f0454ffe2$export$2e2bcd8739ae039);
    parcelRequire("d0pqD");
    var $9QFr0;
    var $35igy;
    var $4513618f0454ffe2$export$2e2bcd8739ae039 = (action$, store, { router: { push: push } })=>action$.ofType((0, (0, parcelRequire("9QFr0")).SET_ASSIGNEE_FILTER)).map((action)=>(0, (0, parcelRequire("35igy")).default)(push, store.getState(), (query)=>({
                    ...query,
                    assignee: action.payload.length > 0 ? action.payload : undefined
                })));
});
parcelRegister("c8JZA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f57c69af539e1756$export$2e2bcd8739ae039);
    parcelRequire("d0pqD");
    var $9QFr0;
    var $35igy;
    var $f57c69af539e1756$export$2e2bcd8739ae039 = (action$, store, { router: { push: push } })=>action$.ofType((0, (0, parcelRequire("9QFr0")).SET_COMPONENT_FILTER)).map((action)=>(0, (0, parcelRequire("35igy")).default)(push, store.getState(), (query)=>({
                    ...query,
                    component: action.payload.length > 0 ? action.payload : undefined
                })));
});
parcelRegister("bLmfk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d6ab187eec86d71c$export$2e2bcd8739ae039);
    parcelRequire("d0pqD");
    var $9QFr0;
    var $35igy;
    var $d6ab187eec86d71c$export$2e2bcd8739ae039 = (action$, store, { router: { push: push } })=>action$.ofType((0, (0, parcelRequire("9QFr0")).SET_CUSTOM_FILTER)).map((action)=>(0, (0, parcelRequire("35igy")).default)(push, store.getState(), (query)=>({
                    ...query,
                    customFilter: action.payload.length > 0 ? action.payload : undefined
                })));
});
parcelRegister("IIqe4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ad9f645037f420bc$export$2e2bcd8739ae039);
    parcelRequire("d0pqD");
    var $ilGit;
    var $35igy;
    var $ad9f645037f420bc$export$2e2bcd8739ae039 = (action$, store, { router: { push: push } })=>action$.ofType((0, (0, parcelRequire("ilGit")).SET_DEPENDENCIES_VIEW_VISIBILITY)).map((action)=>{
            const hideDependencies = action.payload ? undefined : true;
            return (0, (0, parcelRequire("35igy")).default)(push, store.getState(), (query)=>({
                    ...query,
                    hideDependencies: hideDependencies
                }));
        });
});
parcelRegister("hRcIV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ab4da58837ff923c$export$2e2bcd8739ae039);
    parcelRequire("d0pqD");
    var $6thbV;
    var $9QFr0;
    var $35igy;
    var $ab4da58837ff923c$export$2e2bcd8739ae039 = (action$, store, { router: { push: push } })=>action$.ofType((0, (0, parcelRequire("9QFr0")).SET_GOAL_FILTER)).map((action)=>{
            const state = store.getState();
            const goals = (0, (0, parcelRequire("6thbV")).getGoalsHash)(state);
            return (0, (0, parcelRequire("35igy")).default)(push, store.getState(), (query)=>({
                    ...query,
                    goal: action.payload.length > 0 ? action.payload.reduce((acc, id)=>{
                        const goal = goals[id];
                        if (goal) acc.push(goal.goal.key);
                        return acc;
                    }, []) : undefined
                }));
        });
});
parcelRegister("4tLWL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ce1d8b95ca19aea4$export$2e2bcd8739ae039);
    parcelRequire("d0pqD");
    var $9QFr0;
    var $35igy;
    var $ce1d8b95ca19aea4$export$2e2bcd8739ae039 = (action$, store, { router: { push: push } })=>action$.ofType((0, (0, parcelRequire("9QFr0")).SET_ISSUE_PARENT_FILTER)).map((action)=>(0, (0, parcelRequire("35igy")).default)(push, store.getState(), (query)=>({
                    ...query,
                    issueParent: action.payload.length > 0 ? action.payload : undefined
                })));
});
parcelRegister("bSlQb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$67333e0dda8021ea$export$2e2bcd8739ae039);
    parcelRequire("d0pqD");
    var $9QFr0;
    var $35igy;
    var $67333e0dda8021ea$export$2e2bcd8739ae039 = (action$, store, { router: { push: push } })=>action$.ofType((0, (0, parcelRequire("9QFr0")).SET_ISSUE_TYPE_FILTER)).map((action)=>(0, (0, parcelRequire("35igy")).default)(push, store.getState(), (query)=>({
                    ...query,
                    issueType: action.payload.length > 0 ? action.payload : undefined
                })));
});
parcelRegister("7mHPj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7bb44c3447f85797$export$2e2bcd8739ae039);
    parcelRequire("d0pqD");
    var $9QFr0;
    var $35igy;
    var $7bb44c3447f85797$export$2e2bcd8739ae039 = (action$, store, { router: { push: push } })=>action$.ofType((0, (0, parcelRequire("9QFr0")).SET_LABEL_FILTER)).map((action)=>(0, (0, parcelRequire("35igy")).default)(push, store.getState(), (query)=>({
                    ...query,
                    label: action.payload.length > 0 ? action.payload : undefined
                })));
});
parcelRegister("5r3qD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dadacbf3f9a99b9a$export$2e2bcd8739ae039);
    parcelRequire("d0pqD");
    var $l4LVp;
    var $ilGit;
    var $35igy;
    var $dadacbf3f9a99b9a$export$2e2bcd8739ae039 = (action$, store, { router: { push: push } })=>action$.ofType((0, (0, parcelRequire("ilGit")).SET_LEVEL_ONE_SETTING)).map((action)=>(0, (0, parcelRequire("35igy")).default)(push, store.getState(), (query)=>{
                let levelOneView = (0, (0, parcelRequire("l4LVp")).INCOMPLETE);
                if (action.payload.showCompleted) levelOneView = (0, (0, parcelRequire("l4LVp")).periodToLevelOneQuerySettingsMap).get(action.payload.period);
                return {
                    ...query,
                    epic: levelOneView
                };
            }));
});
parcelRegister("8IgfA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a2e5a92775dc3b22$export$2e2bcd8739ae039);
    parcelRequire("d0pqD");
    var $ilGit;
    var $35igy;
    var $a2e5a92775dc3b22$export$2e2bcd8739ae039 = (action$, store, { router: { push: push } })=>action$.ofType((0, (0, parcelRequire("ilGit")).SET_PROGRESS_VISIBILITY)).map((action)=>{
            const hideProgress = action.payload ? undefined : true;
            return (0, (0, parcelRequire("35igy")).default)(push, store.getState(), (query)=>({
                    ...query,
                    hideProgress: hideProgress
                }));
        });
});
parcelRegister("emglt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$64f2390a544defdf$export$2e2bcd8739ae039);
    parcelRequire("d0pqD");
    var $9QFr0;
    var $35igy;
    var $64f2390a544defdf$export$2e2bcd8739ae039 = (action$, store, { router: { push: push } })=>action$.ofType((0, (0, parcelRequire("9QFr0")).SET_QUICK_FILTERS_FILTER)).map((action)=>(0, (0, parcelRequire("35igy")).default)(push, store.getState(), (query)=>({
                    ...query,
                    quickFilter: action.payload.length > 0 ? action.payload : undefined
                })));
});
parcelRegister("5RPNj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9969864aade1542e$export$2e2bcd8739ae039);
    parcelRequire("d0pqD");
    var $ilGit;
    var $35igy;
    var $9969864aade1542e$export$2e2bcd8739ae039 = (action$, store, { router: { push: push } })=>action$.ofType((0, (0, parcelRequire("ilGit")).SET_RELEASES_VISIBILITY)).map((action)=>{
            const hideVersionHeader = action.payload ? undefined : true;
            return (0, (0, parcelRequire("35igy")).default)(push, store.getState(), (query)=>({
                    ...query,
                    hideVersionHeader: hideVersionHeader
                }));
        });
});
parcelRegister("5QKmJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b077cc2b715c2fa7$export$2e2bcd8739ae039);
    parcelRequire("d0pqD");
    var $fVm8c;
    var $35igy;
    var $b077cc2b715c2fa7$export$2e2bcd8739ae039 = (action$, store, { router: { push: push } })=>action$.ofType((0, (0, parcelRequire("fVm8c")).SET_SHARED)).map((action)=>(0, (0, parcelRequire("35igy")).default)(push, store.getState(), (query)=>({
                    ...query,
                    shared: action.payload
                })));
});
parcelRegister("fVm8c", function(module, exports) {
    $parcel$export(module.exports, "SET_SHARED", ()=>$4c3e8386cd32fe59$export$bf0c919e7ee37f3f);
    $parcel$export(module.exports, "setShared", ()=>$4c3e8386cd32fe59$export$72030e9b32b3f1bb);
    $parcel$export(module.exports, "EXPORT_CSV", ()=>$4c3e8386cd32fe59$export$8ecd527409aaf724);
    $parcel$export(module.exports, "exportCsv", ()=>$4c3e8386cd32fe59$export$6a3b3e40f9ef1478);
    const $4c3e8386cd32fe59$export$bf0c919e7ee37f3f = 'state.ui.share.SET_SHARED';
    const $4c3e8386cd32fe59$export$72030e9b32b3f1bb = (payload)=>({
            type: $4c3e8386cd32fe59$export$bf0c919e7ee37f3f,
            payload: payload
        });
    const $4c3e8386cd32fe59$export$8ecd527409aaf724 = 'state.ui.share.EXPORT_CSV';
    const $4c3e8386cd32fe59$export$6a3b3e40f9ef1478 = (payload)=>({
            type: $4c3e8386cd32fe59$export$8ecd527409aaf724,
            payload: payload
        });
});
parcelRegister("VfqTC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f69c7b563fd81074$export$2e2bcd8739ae039);
    parcelRequire("d0pqD");
    var $9QFr0;
    var $35igy;
    var $f69c7b563fd81074$export$2e2bcd8739ae039 = (action$, store, { router: { push: push } })=>action$.ofType((0, (0, parcelRequire("9QFr0")).SET_STATUS_CATEGORY_FILTER)).map((action)=>(0, (0, parcelRequire("35igy")).default)(push, store.getState(), (query)=>({
                    ...query,
                    statuses: action.payload.length > 0 ? action.payload : undefined
                })));
});
parcelRegister("7CZRh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b8734730095be624$export$2e2bcd8739ae039);
    parcelRequire("d0pqD");
    var $9QFr0;
    var $35igy;
    var $b8734730095be624$export$2e2bcd8739ae039 = (action$, store, { router: { push: push } })=>action$.ofType((0, (0, parcelRequire("9QFr0")).SET_TEXT_FILTER)).map((action)=>(0, (0, parcelRequire("35igy")).default)(push, store.getState(), (query)=>({
                    ...query,
                    text: action.payload.length > 0 ? action.payload : undefined
                })));
});
parcelRegister("9OXj4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6ba0957622ce06e5$export$2e2bcd8739ae039);
    parcelRequire("d0pqD");
    var $9QFr0;
    var $35igy;
    var $6ba0957622ce06e5$export$2e2bcd8739ae039 = (action$, store, { router: { push: push } })=>action$.ofType((0, (0, parcelRequire("9QFr0")).SET_TIMELINE_MODE)).map((action)=>(0, (0, parcelRequire("35igy")).default)(push, store.getState(), (query)=>({
                    ...query,
                    timeline: action.payload
                })));
});
parcelRegister("cVVNe", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$86d9aed8edcf05f7$export$2e2bcd8739ae039);
    parcelRequire("d0pqD");
    var $9QFr0;
    var $35igy;
    var $86d9aed8edcf05f7$export$2e2bcd8739ae039 = (action$, store, { router: { push: push } })=>action$.ofType((0, (0, parcelRequire("9QFr0")).SET_VERSION_FILTER)).map((action)=>(0, (0, parcelRequire("35igy")).default)(push, store.getState(), (query)=>({
                    ...query,
                    version: action.payload.length > 0 ? action.payload : undefined
                })));
});
parcelRegister("6o6LV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$514853e711c51e8f$export$2e2bcd8739ae039);
    parcelRequire("d0pqD");
    var $ilGit;
    var $35igy;
    var $514853e711c51e8f$export$2e2bcd8739ae039 = (action$, store, { router: { push: push } })=>action$.ofType((0, (0, parcelRequire("ilGit")).SET_WARNINGS_VISIBILITY)).map((action)=>{
            const hideWarnings = action.payload ? undefined : true;
            return (0, (0, parcelRequire("35igy")).default)(push, store.getState(), (query)=>({
                    ...query,
                    hideWarnings: hideWarnings
                }));
        });
});
parcelRegister("3oIkL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2c4d0d97684ad185$export$2e2bcd8739ae039);
    var $e1AU2 = parcelRequire("e1AU2");
    var $eWVwU;
    var $8MQKo;
    var $ifG5J;
    var $2c4d0d97684ad185$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, (0, parcelRequire("ifG5J")).default), (0, (0, parcelRequire("8MQKo")).default), (0, (0, parcelRequire("eWVwU")).default));
});
parcelRegister("eWVwU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$be4061b8bab47e62$export$2e2bcd8739ae039);
    parcelRequire("fp4O3");
    parcelRequire("d0pqD");
    parcelRequire("c66Ur");
    var $kVLXA = parcelRequire("kVLXA");
    var $dXq4S;
    var $l8odF;
    var $hb2iR;
    var $jJEyp;
    var $be4061b8bab47e62$export$2e2bcd8739ae039 = (action$)=>action$.ofType((0, (0, parcelRequire("jJEyp")).REQUEST_ISSUE_TYPES)).mergeMap((action)=>{
            const { cloudId: cloudId, projectId: projectId } = action.payload;
            return (0, (0, parcelRequire("l8odF")).default)((0, (0, parcelRequire("dXq4S")).createAri)({
                resourceOwner: 'jira',
                cloudId: cloudId,
                resourceType: 'project',
                resourceId: String(projectId)
            })).map((issueTypes)=>(0, (0, parcelRequire("jJEyp")).extendIssueTypes)(issueTypes)).catch(()=>(0, $kVLXA.Observable).of((0, (0, parcelRequire("hb2iR")).aggError)()));
        });
});
parcelRegister("l8odF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ab16218d6f3d342f$export$2e2bcd8739ae039);
    var $h9don;
    var $g5X3G;
    var $dEuVC;
    var $iW95S;
    var $8C5lr;
    const $ab16218d6f3d342f$var$analyticKey = 'jira.frontend.fe.software.roadmap.filter-roadmap-items';
    const $ab16218d6f3d342f$var$concurrentMetricDefinition = (0, (0, parcelRequire("8C5lr")).queryMetrics)[0, $8038b72ffd5aa8d4$export$2e07b3a26c033d37];
    var $ab16218d6f3d342f$export$2e2bcd8739ae039 = (projectAri)=>(0, (0, parcelRequire("iW95S")).runQueryWithMetadata)((0, (0, parcelRequire("h9don")).default), (0, (0, parcelRequire("dEuVC")).generateProjectIssueTypesQueryVariables)(projectAri), $ab16218d6f3d342f$var$analyticKey, $ab16218d6f3d342f$var$concurrentMetricDefinition).map(({ data: data })=>{
            const issueTypes = {};
            data.jira.jiraProject.issueTypes.edges.forEach((edge)=>{
                if (edge) {
                    const { node: { issueTypeId: issueTypeId, avatar: avatar, name: name, description: description } } = edge;
                    issueTypes[(0, (0, parcelRequire("g5X3G")).toIssueTypeId)(issueTypeId)] = {
                        name: name,
                        description: description || '',
                        iconUrl: avatar.medium || ''
                    };
                }
            });
            return issueTypes;
        });
});
parcelRegister("h9don", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$234116e2d0a72e3b$export$2e2bcd8739ae039);
    const $234116e2d0a72e3b$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectAri"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "projectAri"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "id"
        }, v3 = {
            "kind": "ScalarField",
            "name": "name"
        }, v4 = {
            "kind": "ScalarField",
            "name": "description"
        }, v5 = {
            "kind": "ScalarField",
            "name": "issueTypeId"
        }, v6 = {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "medium"
                }
            ]
        }, v7 = {
            "kind": "ScalarField",
            "name": "cursor"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "projectIssueTypesQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v1,
                                        "concreteType": "JiraProject",
                                        "kind": "LinkedField",
                                        "name": "jiraProject",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "concreteType": "JiraIssueTypeConnection",
                                                    "kind": "LinkedField",
                                                    "name": "issueTypes",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": {
                                                                "concreteType": "JiraIssueTypeEdge",
                                                                "kind": "LinkedField",
                                                                "name": "edges",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": {
                                                                            "concreteType": "JiraIssueType",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v2,
                                                                                v3,
                                                                                v4,
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v5,
                                                                                    "action": "THROW",
                                                                                    "path": "jira.jiraProject.issueTypes.edges.node.issueTypeId"
                                                                                },
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v6,
                                                                                    "action": "THROW",
                                                                                    "path": "jira.jiraProject.issueTypes.edges.node.avatar"
                                                                                }
                                                                            ]
                                                                        },
                                                                        "action": "THROW",
                                                                        "path": "jira.jiraProject.issueTypes.edges.node"
                                                                    },
                                                                    v7
                                                                ]
                                                            },
                                                            "action": "THROW",
                                                            "path": "jira.jiraProject.issueTypes.edges"
                                                        }
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "jira.jiraProject.issueTypes"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.jiraProject"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "projectIssueTypesQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "jiraProject",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueTypeConnection",
                                        "kind": "LinkedField",
                                        "name": "issueTypes",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueTypeEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueType",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v2,
                                                            v3,
                                                            v4,
                                                            v5,
                                                            v6
                                                        ]
                                                    },
                                                    v7
                                                ]
                                            }
                                        ]
                                    },
                                    v2
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "936c169a1a3da60677b586f7416035e96cc19f2558c71ff347037e2d661f574f",
                "metadata": {},
                "name": "projectIssueTypesQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $234116e2d0a72e3b$var$node.hash = "e1bde9923437b56592abdd2237c64176";
    var $234116e2d0a72e3b$export$2e2bcd8739ae039 = $234116e2d0a72e3b$var$node;
});
parcelRegister("dEuVC", function(module, exports) {
    $parcel$export(module.exports, "generateProjectIssueTypesQueryVariables", ()=>$0bd2af9a09478a2e$export$4053c97707dd7d85);
    const $0bd2af9a09478a2e$export$4053c97707dd7d85 = (projectAri)=>({
            projectAri: projectAri
        });
});
parcelRegister("jJEyp", function(module, exports) {
    $parcel$export(module.exports, "RETRIEVE_ISSUE_TYPE_COUNT", ()=>$a2e6a7cb1192d0e3$export$6e62eb1ae117debe);
    $parcel$export(module.exports, "retrieveIssueTypeCount", ()=>$a2e6a7cb1192d0e3$export$d800abc79f7d0a4b);
    $parcel$export(module.exports, "EXTEND_ISSUE_TYPE_COUNT", ()=>$a2e6a7cb1192d0e3$export$7cea639a62ce64a2);
    $parcel$export(module.exports, "extendIssueTypeCount", ()=>$a2e6a7cb1192d0e3$export$388067634b61b046);
    $parcel$export(module.exports, "RESOLVE", ()=>$a2e6a7cb1192d0e3$export$4732ab3df087d9be);
    $parcel$export(module.exports, "SET_RESOLVING", ()=>$a2e6a7cb1192d0e3$export$bbea77d4819d05b3);
    $parcel$export(module.exports, "setResolving", ()=>$a2e6a7cb1192d0e3$export$d6f73a1d23a0f84c);
    $parcel$export(module.exports, "UPDATE_HEALTHCHECK", ()=>$a2e6a7cb1192d0e3$export$88295fbb4c70ff7b);
    $parcel$export(module.exports, "updateHealthcheck", ()=>$a2e6a7cb1192d0e3$export$a58491703ac419fb);
    $parcel$export(module.exports, "RESOLVE_HEALTHCHECK", ()=>$a2e6a7cb1192d0e3$export$f096bf13c1d89b91);
    $parcel$export(module.exports, "resolveHealthcheck", ()=>$a2e6a7cb1192d0e3$export$65c820cb5cc3a669);
    $parcel$export(module.exports, "REQUEST_ISSUE_TYPES", ()=>$a2e6a7cb1192d0e3$export$8c9d9e8eaa5b8c93);
    $parcel$export(module.exports, "requestIssueTypes", ()=>$a2e6a7cb1192d0e3$export$f615b4b60e70c65e);
    $parcel$export(module.exports, "EXTEND_ISSUE_TYPES", ()=>$a2e6a7cb1192d0e3$export$77b42279c05c291a);
    $parcel$export(module.exports, "extendIssueTypes", ()=>$a2e6a7cb1192d0e3$export$7f78f9436d5ef445);
    const $a2e6a7cb1192d0e3$export$6e62eb1ae117debe = 'state.ui.healthcheck.RETRIEVE_ISSUE_TYPE_COUNT';
    const $a2e6a7cb1192d0e3$export$d800abc79f7d0a4b = (payload)=>({
            type: $a2e6a7cb1192d0e3$export$6e62eb1ae117debe,
            payload: payload
        });
    const $a2e6a7cb1192d0e3$export$7cea639a62ce64a2 = 'state.ui.healthcheck.EXTEND_ISSUE_TYPE_COUNT';
    const $a2e6a7cb1192d0e3$export$388067634b61b046 = (payload)=>({
            type: $a2e6a7cb1192d0e3$export$7cea639a62ce64a2,
            payload: payload
        });
    const $a2e6a7cb1192d0e3$export$4732ab3df087d9be = 'state.ui.healthcheck.RESOLVE';
    const $a2e6a7cb1192d0e3$export$f7ad0328861e2f03 = (payload)=>({
            type: $a2e6a7cb1192d0e3$export$4732ab3df087d9be,
            payload: payload
        });
    const $a2e6a7cb1192d0e3$export$bbea77d4819d05b3 = 'state.ui.healthcheck.SET_RESOLVING';
    const $a2e6a7cb1192d0e3$export$d6f73a1d23a0f84c = (payload)=>({
            type: $a2e6a7cb1192d0e3$export$bbea77d4819d05b3,
            payload: payload
        });
    const $a2e6a7cb1192d0e3$export$88295fbb4c70ff7b = 'state.ui.healthcheck.UPDATE_HEALTHCHECK';
    const $a2e6a7cb1192d0e3$export$a58491703ac419fb = (payload)=>({
            type: $a2e6a7cb1192d0e3$export$88295fbb4c70ff7b,
            payload: payload
        });
    const $a2e6a7cb1192d0e3$export$f096bf13c1d89b91 = 'state.ui.healthcheck.RESOLVE_HEALTHCHECK';
    const $a2e6a7cb1192d0e3$export$65c820cb5cc3a669 = (payload, analyticsEvent)=>({
            type: $a2e6a7cb1192d0e3$export$f096bf13c1d89b91,
            payload: payload,
            meta: {
                analyticsEvent: analyticsEvent
            }
        });
    const $a2e6a7cb1192d0e3$export$8c9d9e8eaa5b8c93 = 'state.ui.healthcheck.REQUEST_ISSUE_TYPES';
    const $a2e6a7cb1192d0e3$export$f615b4b60e70c65e = (payload)=>({
            type: $a2e6a7cb1192d0e3$export$8c9d9e8eaa5b8c93,
            payload: payload
        });
    const $a2e6a7cb1192d0e3$export$77b42279c05c291a = 'state.ui.healthcheck.EXTEND_ISSUE_TYPES';
    const $a2e6a7cb1192d0e3$export$7f78f9436d5ef445 = (payload)=>({
            type: $a2e6a7cb1192d0e3$export$77b42279c05c291a,
            payload: payload
        });
});
parcelRegister("8MQKo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$52d53db34c4a7c1b$export$2e2bcd8739ae039);
    parcelRequire("jFVZ1");
    parcelRequire("zjDln");
    parcelRequire("fp4O3");
    parcelRequire("d0pqD");
    parcelRequire("c66Ur");
    parcelRequire("fPS7b");
    var $aB8eX = parcelRequire("aB8eX");
    var $kVLXA = parcelRequire("kVLXA");
    var $8zOmE;
    var $9NFU0;
    var $cmgcJ;
    var $9fPrG;
    var $hb2iR;
    var $fWch8;
    var $jJEyp;
    var $bFYz9;
    var $5TDr4;
    const $52d53db34c4a7c1b$var$transformLevelOneSelection = (levelOneIssueTypeSelection)=>{
        if (levelOneIssueTypeSelection) {
            if (levelOneIssueTypeSelection.issueTypeToPromote) return {
                promote: {
                    promoteItemTypeId: String(levelOneIssueTypeSelection.issueTypeToPromote)
                }
            };
            if (levelOneIssueTypeSelection.epicName !== undefined && levelOneIssueTypeSelection.epicDescription !== undefined) return {
                create: {
                    epicTypeName: levelOneIssueTypeSelection.epicName,
                    epicTypeDescription: levelOneIssueTypeSelection.epicDescription
                }
            };
        }
        return undefined;
    };
    var $52d53db34c4a7c1b$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, (0, parcelRequire("jJEyp")).RESOLVE_HEALTHCHECK)).mergeMap((action)=>{
            const state = store.getState();
            const sourceARI = (0, (0, parcelRequire("9fPrG")).getSourceARI)(state);
            const resolutionActionId = action.payload.actionId;
            const addLevelOneIssueType = $52d53db34c4a7c1b$var$transformLevelOneSelection(action.payload.levelOneIssueTypeSelection);
            const resolveHealthcheckObservable = (0, (0, parcelRequire("9NFU0")).resolveHealthcheckFromServer)(sourceARI, resolutionActionId, addLevelOneIssueType).mergeMap((response)=>{
                const resolveRoadmapHealthcheckData = response.roadmaps?.resolveRoadmapHealthcheck;
                const errors = resolveRoadmapHealthcheckData?.errors;
                const success = resolveRoadmapHealthcheckData?.success;
                if (success === false && errors?.length) return (0, (0, parcelRequire("bFYz9")).onHandleAggErrors)(!!resolveRoadmapHealthcheckData, errors).map((aggErrors)=>(0, $aB8eX.batchActions)([
                        (0, (0, parcelRequire("jJEyp")).setResolving)(false),
                        aggErrors
                    ]));
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(action.meta.analyticsEvent, 'healthcheck resolved', 'roadmapHealthcheck', {
                    projectType: 'software',
                    resolutionActionId: resolutionActionId
                });
                action.payload.refreshNavigationData();
                const query = (0, (0, parcelRequire("fWch8")).getQuery)(state);
                return (0, (0, parcelRequire("cmgcJ")).getCriticalDataObservable)((0, (0, parcelRequire("9fPrG")).getSourceARI)(state), query, undefined).mergeMap((criticalData)=>(0, $kVLXA.Observable).of((0, $aB8eX.batchActions)([
                        ...(0, (0, parcelRequire("5TDr4")).getCriticalDataActions)(criticalData),
                        (0, (0, parcelRequire("jJEyp")).setResolving)(false)
                    ])));
            }).catch(()=>(0, $kVLXA.Observable).from([
                    (0, (0, parcelRequire("hb2iR")).aggError)(),
                    (0, (0, parcelRequire("jJEyp")).setResolving)(false)
                ]));
            return (0, $kVLXA.Observable).concat((0, $kVLXA.Observable).of((0, (0, parcelRequire("jJEyp")).setResolving)(true)), resolveHealthcheckObservable);
        });
});
parcelRegister("9NFU0", function(module, exports) {
    $parcel$export(module.exports, "resolveHealthcheckFromServer", ()=>$35047df44a7d5b7d$export$1499faa3a2f25f61);
    var $16H7e;
    var $lQmZK;
    var $8C5lr;
    const $35047df44a7d5b7d$var$mutationName = 'resolveHealthcheck';
    const $35047df44a7d5b7d$var$concurrentMetricDefinition = (0, (0, parcelRequire("8C5lr")).mutationMetrics)[0, $8038b72ffd5aa8d4$export$f096bf13c1d89b91];
    const $35047df44a7d5b7d$var$analyticKey = 'jira.frontend.fe.software.roadmap.resolve-roadmap-healthcheck';
    const $35047df44a7d5b7d$export$1499faa3a2f25f61 = (sourceARI, actionId, addLevelOneIssueType)=>{
        const variables = {
            sourceARI: sourceARI,
            input: {
                actionId: actionId,
                addLevelOneIssueType: addLevelOneIssueType
            }
        };
        return (0, (0, parcelRequire("lQmZK")).runMutation)($35047df44a7d5b7d$var$mutationName, (0, (0, parcelRequire("16H7e")).default), variables, $35047df44a7d5b7d$var$analyticKey, $35047df44a7d5b7d$var$concurrentMetricDefinition);
    };
});
parcelRegister("16H7e", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dab207b42cee48e0$export$2e2bcd8739ae039);
    const $dab207b42cee48e0$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "sourceARI"
        }, v2 = [
            {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
            },
            {
                "kind": "Variable",
                "name": "sourceARI",
                "variableName": "sourceARI"
            }
        ], v3 = {
            "kind": "ScalarField",
            "name": "success"
        }, v4 = {
            "kind": "ScalarField",
            "name": "message"
        }, v5 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "statusCode"
                },
                {
                    "kind": "ScalarField",
                    "name": "errorType"
                }
            ],
            "type": "RoadmapMutationErrorExtension"
        };
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1
                ],
                "kind": "Fragment",
                "name": "resolveHealthcheckMutation",
                "selections": [
                    {
                        "concreteType": "RoadmapsMutation",
                        "kind": "LinkedField",
                        "name": "roadmaps",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2,
                                "concreteType": "RoadmapResolveHealthcheckPayload",
                                "kind": "LinkedField",
                                "name": "resolveRoadmapHealthcheck",
                                "plural": false,
                                "selections": [
                                    v3,
                                    {
                                        "concreteType": "MutationError",
                                        "kind": "LinkedField",
                                        "name": "errors",
                                        "plural": true,
                                        "selections": [
                                            v4,
                                            {
                                                "kind": "LinkedField",
                                                "name": "extensions",
                                                "plural": false,
                                                "selections": [
                                                    v5
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "Mutation"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v1,
                    v0
                ],
                "kind": "Operation",
                "name": "resolveHealthcheckMutation",
                "selections": [
                    {
                        "concreteType": "RoadmapsMutation",
                        "kind": "LinkedField",
                        "name": "roadmaps",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2,
                                "concreteType": "RoadmapResolveHealthcheckPayload",
                                "kind": "LinkedField",
                                "name": "resolveRoadmapHealthcheck",
                                "plural": false,
                                "selections": [
                                    v3,
                                    {
                                        "concreteType": "MutationError",
                                        "kind": "LinkedField",
                                        "name": "errors",
                                        "plural": true,
                                        "selections": [
                                            v4,
                                            {
                                                "kind": "LinkedField",
                                                "name": "extensions",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "__typename"
                                                    },
                                                    v5,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "id"
                                                            }
                                                        ],
                                                        "type": "BulkMutationErrorExtension"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "33a869b2348eba3530cb6f638df8e5e0d286115c291912fded9f10e48df8e18a",
                "metadata": {},
                "name": "resolveHealthcheckMutation",
                "operationKind": "mutation",
                "text": null
            }
        };
    }();
    $dab207b42cee48e0$var$node.hash = "7937429ceae92519546484200a3f3d14";
    var $dab207b42cee48e0$export$2e2bcd8739ae039 = $dab207b42cee48e0$var$node;
});
parcelRegister("lQmZK", function(module, exports) {
    $parcel$export(module.exports, "runMutation", ()=>$f581d7386ceecb28$export$5484b58371dd1c3a);
    var $9XE6b = parcelRequire("9XE6b");
    var $8Uumt = parcelRequire("8Uumt");
    var $kVLXA = parcelRequire("kVLXA");
    var $7Jxgt = parcelRequire("7Jxgt");
    var $4R6GH;
    var $5yJb9;
    var $5a0Nh;
    var $5Wobd;
    parcelRequire("9o0uh");
    parcelRequire("64ZAE");
    parcelRequire("c66Ur");
    var $8ab4g;
    const $f581d7386ceecb28$export$5484b58371dd1c3a = (mutationName, mutation, variables, analyticKey, concurrentMetricDefinition)=>{
        const operationName = `${mutationName}Mutation`;
        const concurrentId = (0, ($parcel$interopDefault($7Jxgt))).v4();
        (0, (0, parcelRequire("5Wobd")).startCapturingTraceIds)(operationName);
        const errorCollector = (0, (0, parcelRequire("5a0Nh")).startCaptureGraphQlErrors)();
        if ((0, (0, parcelRequire("4R6GH")).fg)('jsw-roadmap-unsubscribable-mutation')) {
            concurrentMetricDefinition(concurrentId).start();
            return (0, (0, parcelRequire("8ab4g")).commitMutationObservable)((0, (0, parcelRequire("5yJb9")).default)(), {
                mutation: mutation,
                variables: variables
            }).do((data)=>{
                concurrentMetricDefinition(concurrentId).stop();
                const mutationPayload = (0, ($parcel$interopDefault($9XE6b)))(data, [
                    'roadmaps',
                    mutationName
                ]);
                if (!mutationPayload || mutationPayload.success !== true) {
                    const statusCode = mutationPayload ? (0, ($parcel$interopDefault($9XE6b)))(mutationPayload, [
                        'errors',
                        0,
                        'extensions',
                        'statusCode'
                    ], 'unknown') : 'unknown';
                    const relevantErrors = (0, (0, parcelRequire("8ab4g")).getGraphQlErrorsForOperation)(errorCollector, operationName);
                    const transformedError = (0, (0, parcelRequire("8ab4g")).transformGraphQLErrors)(relevantErrors, operationName, (0, (0, parcelRequire("5Wobd")).getTraceIds)(operationName));
                    (0, (0, parcelRequire("8ab4g")).sendOperationalEventV2OnError)(transformedError, analyticKey, false, String(statusCode));
                } else (0, (0, parcelRequire("8ab4g")).sendOperationalEventV2OnSuccess)(analyticKey, (0, (0, parcelRequire("5Wobd")).getTraceIds)(operationName));
                (0, (0, parcelRequire("5Wobd")).stopCapturingTraceIds)(operationName);
            }).catch((error)=>{
                concurrentMetricDefinition(concurrentId).stop();
                const transformedError = (0, (0, parcelRequire("8ab4g")).transformGenericError)(error, (0, (0, parcelRequire("5Wobd")).getTraceIds)(operationName), operationName);
                (0, (0, parcelRequire("8ab4g")).sendOperationalEventV2OnError)(transformedError, analyticKey, false);
                (0, (0, parcelRequire("5Wobd")).stopCapturingTraceIds)(operationName);
                throw error;
            });
        }
        return (0, $kVLXA.Observable).fromPromise(new Promise((resolve, reject)=>{
            concurrentMetricDefinition(concurrentId).start();
            (0, $8Uumt.commitMutation)((0, (0, parcelRequire("5yJb9")).default)(), {
                mutation: mutation,
                variables: variables,
                onCompleted: (data)=>{
                    concurrentMetricDefinition(concurrentId).stop();
                    const mutationPayload = (0, ($parcel$interopDefault($9XE6b)))(data, [
                        'roadmaps',
                        mutationName
                    ]);
                    if (!mutationPayload || mutationPayload.success !== true) {
                        const statusCode = mutationPayload ? (0, ($parcel$interopDefault($9XE6b)))(mutationPayload, [
                            'errors',
                            0,
                            'extensions',
                            'statusCode'
                        ], 'unknown') : 'unknown';
                        const relevantErrors = (0, (0, parcelRequire("8ab4g")).getGraphQlErrorsForOperation)(errorCollector, operationName);
                        const transformedError = (0, (0, parcelRequire("8ab4g")).transformGraphQLErrors)(relevantErrors, operationName, (0, (0, parcelRequire("5Wobd")).getTraceIds)(operationName));
                        (0, (0, parcelRequire("8ab4g")).sendOperationalEventV2OnError)(transformedError, analyticKey, false, String(statusCode));
                    } else (0, (0, parcelRequire("8ab4g")).sendOperationalEventV2OnSuccess)(analyticKey, (0, (0, parcelRequire("5Wobd")).getTraceIds)(operationName));
                    (0, (0, parcelRequire("5Wobd")).stopCapturingTraceIds)(operationName);
                    resolve(data);
                },
                onError: (error)=>{
                    concurrentMetricDefinition(concurrentId).stop();
                    const transformedError = (0, (0, parcelRequire("8ab4g")).transformGenericError)(error, (0, (0, parcelRequire("5Wobd")).getTraceIds)(operationName), operationName);
                    (0, (0, parcelRequire("8ab4g")).sendOperationalEventV2OnError)(transformedError, analyticKey, false);
                    (0, (0, parcelRequire("5Wobd")).stopCapturingTraceIds)(operationName);
                    reject(error);
                }
            });
        }));
    };
});
parcelRegister("cmgcJ", function(module, exports) {
    $parcel$export(module.exports, "getCriticalDataObservable", ()=>$cdcbccc50225fd29$export$3e7267aae1bc4);
    $parcel$export(module.exports, "getCriticalDataWithEagerLoading", ()=>$cdcbccc50225fd29$export$ac6421fe3567f604);
    var $kVLXA = parcelRequire("kVLXA");
    parcelRequire("aSIuP");
    parcelRequire("fp4O3");
    parcelRequire("d0pqD");
    var $3Aw6w;
    var $5ulVP;
    var $amNTR;
    const $cdcbccc50225fd29$var$mapResult = (configuration, issues, statusCategories, users, settings, metadata, healthcheck, filteredIssueIds, eagerLoadedData)=>({
            configuration: configuration,
            issues: issues,
            statusCategories: statusCategories,
            users: users,
            settings: settings,
            metadata: metadata,
            healthcheck: healthcheck,
            filteredIssueIds: filteredIssueIds,
            eagerLoadedData: eagerLoadedData
        });
    const $cdcbccc50225fd29$export$3e7267aae1bc4 = (sourceAri, query, locationAri)=>{
        let filteredIssuesObservable = (0, $kVLXA.Observable).of(undefined);
        const customFilters = query?.customFilter ?? [];
        const quickFilters = query?.quickFilter ?? [];
        if (quickFilters.length > 0 || customFilters.length > 0) filteredIssuesObservable = (0, (0, parcelRequire("5ulVP")).filterItemsByJQLFilters)(sourceAri, quickFilters, customFilters);
        return (0, $kVLXA.Observable).zip((0, (0, parcelRequire("3Aw6w")).default)(sourceAri, locationAri), filteredIssuesObservable, ({ currentUser: currentUser, configuration: configuration, statusCategories: statusCategories, issues: issues, users: users, metadata: metadata, settings: settings, healthcheck: healthcheck }, filteredIssueIds)=>{
            const mappedCriticalData = $cdcbccc50225fd29$var$mapResult(configuration, issues, statusCategories, {
                ...currentUser,
                ...users
            }, settings, metadata, healthcheck, filteredIssueIds);
            return mappedCriticalData;
        });
    };
    const $cdcbccc50225fd29$export$ac6421fe3567f604 = (sourceAri, routerDataContext, locationAri)=>(0, $kVLXA.Observable).zip((0, (0, parcelRequire("3Aw6w")).default)(sourceAri, locationAri), (0, (0, parcelRequire("amNTR")).fetchEagerLoadedData)(sourceAri, routerDataContext), ({ currentUser: currentUser, configuration: configuration, statusCategories: statusCategories, issues: issues, users: users, metadata: metadata, settings: settings, healthcheck: healthcheck }, eagerLoadedlData)=>{
            const mappedCriticalData = $cdcbccc50225fd29$var$mapResult(configuration, issues, statusCategories, {
                ...currentUser,
                ...users
            }, settings, metadata, healthcheck, undefined, eagerLoadedlData);
            return mappedCriticalData;
        });
});
parcelRegister("3Aw6w", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f055dbff34908230$export$2e2bcd8739ae039);
    parcelRequire("d0pqD");
    var $eRvh4;
    var $9VhdC;
    var $8P9VR;
    var $iW95S;
    var $8C5lr;
    var $6uhbB;
    const $f055dbff34908230$var$concurrentMetricDefinition = (0, (0, parcelRequire("8C5lr")).queryMetrics)[0, $8038b72ffd5aa8d4$export$12daf7ce2c179397];
    const $f055dbff34908230$var$analyticKey = 'jira.frontend.fe.software.roadmap.critical-data';
    var $f055dbff34908230$export$2e2bcd8739ae039 = (sourceAri, locationAri)=>(0, (0, parcelRequire("iW95S")).runQueryWithMetadata)((0, (0, parcelRequire("eRvh4")).default), (0, (0, parcelRequire("9VhdC")).generateCriticalDataQueryVariables)(sourceAri, locationAri), $f055dbff34908230$var$analyticKey, $f055dbff34908230$var$concurrentMetricDefinition).map(({ data: data, metadata: { traceIds: traceIds, operationName: operationName, extensions: extensions } })=>{
            if (!data?.roadmaps?.roadmapForSource || !data?.me?.user || data?.roadmaps?.roadmapForSource.healthcheck === null && data?.roadmaps?.roadmapForSource.content === null) throw new (0, (0, parcelRequire("8P9VR")).AggError)(`Failed to retrieve data via ${operationName}`, [], traceIds, (0, (0, parcelRequire("8P9VR")).MISSING_DATA_ERROR));
            const { content: content, healthcheck: healthcheck } = data.roadmaps.roadmapForSource;
            const items = content?.items?.edges || [];
            return {
                currentUser: (0, (0, parcelRequire("6uhbB")).transformCurrentUser)(data?.me?.user),
                roadmapConfiguration: content?.configuration ? (0, (0, parcelRequire("6uhbB")).transformRoadmapConfiguration)(content.configuration) : undefined,
                items: items.filter(Boolean).map(({ node: roadmapItem })=>roadmapItem),
                metadata: {
                    traceIds: traceIds,
                    extensions: extensions
                },
                healthcheck: (0, (0, parcelRequire("6uhbB")).transformHealthcheck)(healthcheck)
            };
        }).map((0, (0, parcelRequire("6uhbB")).transformCriticalData));
});
parcelRegister("eRvh4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$afd99f72d2d32430$export$2e2bcd8739ae039);
    const $afd99f72d2d32430$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isRoadmapsCriticalDataItemFlaggedEnabled"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "locationAri"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "sourceAri"
        }, v3 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v4 = {
            "kind": "ScalarField",
            "name": "accountId"
        }, v5 = {
            "kind": "ScalarField",
            "name": "name"
        }, v6 = {
            "kind": "ScalarField",
            "name": "picture"
        }, v7 = [
            {
                "kind": "Variable",
                "name": "locationARI",
                "variableName": "locationAri"
            },
            {
                "kind": "Variable",
                "name": "sourceARI",
                "variableName": "sourceAri"
            }
        ], v8 = {
            "kind": "ScalarField",
            "name": "id"
        }, v9 = {
            "kind": "ScalarField",
            "name": "title"
        }, v10 = {
            "kind": "ScalarField",
            "name": "explanation"
        }, v11 = {
            "concreteType": "RoadmapHealthCheckLink",
            "kind": "LinkedField",
            "name": "learnMore",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "text"
                },
                {
                    "kind": "ScalarField",
                    "name": "url"
                }
            ]
        }, v12 = {
            "concreteType": "RoadmapHealthCheckResolution",
            "kind": "LinkedField",
            "name": "resolution",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "label"
                },
                {
                    "kind": "ScalarField",
                    "name": "actionId"
                }
            ]
        }, v13 = {
            "kind": "ScalarField",
            "name": "rankIssuesSupported"
        }, v14 = {
            "kind": "ScalarField",
            "name": "isCrossProject"
        }, v15 = {
            "kind": "ScalarField",
            "name": "isDependenciesEnabled"
        }, v16 = {
            "kind": "ScalarField",
            "name": "inwardDependencyDescription"
        }, v17 = {
            "kind": "ScalarField",
            "name": "outwardDependencyDescription"
        }, v18 = {
            "kind": "ScalarField",
            "name": "jql"
        }, v19 = {
            "kind": "ScalarField",
            "name": "isUserBoardAdmin"
        }, v20 = {
            "kind": "ScalarField",
            "name": "isBoardJqlFilteringOutEpics"
        }, v21 = {
            "kind": "ScalarField",
            "name": "isSprintsFeatureEnabled"
        }, v22 = {
            "kind": "ScalarField",
            "name": "isChildIssuePlanningEnabled"
        }, v23 = {
            "kind": "ScalarField",
            "name": "state"
        }, v24 = {
            "kind": "ScalarField",
            "name": "startDateRFC3339"
        }, v25 = {
            "kind": "ScalarField",
            "name": "endDateRFC3339"
        }, v26 = {
            "kind": "ScalarField",
            "name": "childIssuePlanningMode"
        }, v27 = {
            "concreteType": "RoadmapField",
            "kind": "LinkedField",
            "name": "derivedFields",
            "plural": true,
            "selections": [
                v8,
                {
                    "kind": "ScalarField",
                    "name": "values"
                }
            ]
        }, v28 = {
            "kind": "ScalarField",
            "name": "projectId"
        }, v29 = {
            "kind": "ScalarField",
            "name": "projectKey"
        }, v30 = {
            "kind": "ScalarField",
            "name": "projectName"
        }, v31 = {
            "kind": "ScalarField",
            "name": "iconUrl"
        }, v32 = {
            "kind": "ScalarField",
            "name": "requiredFieldIds"
        }, v33 = {
            "kind": "ScalarField",
            "name": "canEditIssues"
        }, v34 = {
            "kind": "ScalarField",
            "name": "canScheduleIssues"
        }, v35 = {
            "kind": "ScalarField",
            "name": "canCreateIssues"
        }, v36 = {
            "kind": "ScalarField",
            "name": "canAdministerProjects"
        }, v37 = {
            "kind": "ScalarField",
            "name": "status"
        }, v38 = {
            "kind": "ScalarField",
            "name": "releaseDate"
        }, v39 = {
            "kind": "ScalarField",
            "name": "isReleasesFeatureEnabled"
        }, v40 = {
            "kind": "ScalarField",
            "name": "defaultItemTypeId"
        }, v41 = {
            "kind": "ScalarField",
            "name": "isGoalsFeatureEnabled"
        }, v42 = {
            "kind": "ScalarField",
            "name": "startDateField"
        }, v43 = {
            "kind": "ScalarField",
            "name": "rankField"
        }, v44 = {
            "kind": "ScalarField",
            "name": "epicLinkField"
        }, v45 = {
            "kind": "ScalarField",
            "name": "epicNameField"
        }, v46 = {
            "kind": "ScalarField",
            "name": "sprintField"
        }, v47 = {
            "kind": "ScalarField",
            "name": "colorField"
        }, v48 = [
            v8,
            v5
        ], v49 = {
            "concreteType": "RoadmapFieldConfiguration",
            "kind": "LinkedField",
            "name": "fields",
            "plural": true,
            "selections": v48
        }, v50 = {
            "kind": "ScalarField",
            "name": "key"
        }, v51 = {
            "kind": "ScalarField",
            "name": "itemTypes"
        }, v52 = {
            "kind": "ScalarField",
            "name": "isDependenciesVisible"
        }, v53 = {
            "kind": "ScalarField",
            "name": "isProgressVisible"
        }, v54 = {
            "kind": "ScalarField",
            "name": "isWarningsVisible"
        }, v55 = {
            "kind": "ScalarField",
            "name": "listWidth"
        }, v56 = {
            "kind": "ScalarField",
            "name": "timelineMode"
        }, v57 = {
            "kind": "ScalarField",
            "name": "period"
        }, v58 = {
            "kind": "ScalarField",
            "name": "showCompleted"
        }, v59 = {
            "kind": "ScalarField",
            "name": "isReleasesVisible"
        }, v60 = {
            "kind": "ScalarField",
            "name": "highlightedVersions"
        }, v61 = {
            "kind": "ScalarField",
            "name": "issuePanelRatio"
        }, v62 = {
            "kind": "ScalarField",
            "name": "levelOneName"
        }, v63 = {
            "kind": "ScalarField",
            "name": "parentId"
        }, v64 = {
            "kind": "ScalarField",
            "name": "summary"
        }, v65 = {
            "kind": "ScalarField",
            "name": "dueDateRFC3339"
        }, v66 = {
            "kind": "ScalarField",
            "name": "color"
        }, v67 = {
            "kind": "ScalarField",
            "name": "dependencies"
        }, v68 = {
            "kind": "ScalarField",
            "name": "itemTypeId"
        }, v69 = {
            "kind": "ScalarField",
            "name": "rank"
        }, v70 = {
            "kind": "ScalarField",
            "name": "labels"
        }, v71 = {
            "kind": "ScalarField",
            "name": "sprintIds"
        }, v72 = {
            "kind": "ScalarField",
            "name": "versionIds"
        }, v73 = {
            "kind": "ScalarField",
            "name": "componentIds"
        }, v74 = {
            "kind": "ScalarField",
            "name": "resolved"
        }, v75 = {
            "kind": "ScalarField",
            "name": "flagged"
        }, v76 = [
            v3,
            v4,
            v5,
            v6,
            v8
        ], v77 = [
            v8,
            v31,
            v5,
            v32
        ];
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2
                ],
                "kind": "Fragment",
                "name": "roadmapCriticalDataQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "AuthenticationContext",
                            "kind": "LinkedField",
                            "name": "me",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v3,
                                            "action": "THROW",
                                            "path": "me.user.__typename"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v4,
                                            "action": "THROW",
                                            "path": "me.user.accountId"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v5,
                                            "action": "THROW",
                                            "path": "me.user.name"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v6,
                                            "action": "THROW",
                                            "path": "me.user.picture"
                                        }
                                    ]
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "me"
                    },
                    {
                        "concreteType": "RoadmapsQuery",
                        "kind": "LinkedField",
                        "name": "roadmaps",
                        "plural": false,
                        "selections": [
                            {
                                "args": v7,
                                "concreteType": "RoadmapDetails",
                                "kind": "LinkedField",
                                "name": "roadmapForSource",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "RoadmapHealthCheck",
                                        "kind": "LinkedField",
                                        "name": "healthcheck",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": v8,
                                                "action": "THROW",
                                                "path": "roadmaps.roadmapForSource.healthcheck.id"
                                            },
                                            v9,
                                            v10,
                                            v11,
                                            v12
                                        ]
                                    },
                                    {
                                        "concreteType": "RoadmapContent",
                                        "kind": "LinkedField",
                                        "name": "content",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "concreteType": "RoadmapConfiguration",
                                                    "kind": "LinkedField",
                                                    "name": "configuration",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v13,
                                                            "action": "THROW",
                                                            "path": "roadmaps.roadmapForSource.content.configuration.rankIssuesSupported"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v14,
                                                            "action": "THROW",
                                                            "path": "roadmaps.roadmapForSource.content.configuration.isCrossProject"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": {
                                                                "concreteType": "RoadmapDependencyConfiguration",
                                                                "kind": "LinkedField",
                                                                "name": "dependencies",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v15,
                                                                        "action": "THROW",
                                                                        "path": "roadmaps.roadmapForSource.content.configuration.dependencies.isDependenciesEnabled"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v16,
                                                                        "action": "THROW",
                                                                        "path": "roadmaps.roadmapForSource.content.configuration.dependencies.inwardDependencyDescription"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v17,
                                                                        "action": "THROW",
                                                                        "path": "roadmaps.roadmapForSource.content.configuration.dependencies.outwardDependencyDescription"
                                                                    }
                                                                ]
                                                            },
                                                            "action": "THROW",
                                                            "path": "roadmaps.roadmapForSource.content.configuration.dependencies"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": {
                                                                "concreteType": "RoadmapBoardConfiguration",
                                                                "kind": "LinkedField",
                                                                "name": "boardConfiguration",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v18,
                                                                        "action": "THROW",
                                                                        "path": "roadmaps.roadmapForSource.content.configuration.boardConfiguration.jql"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v19,
                                                                        "action": "THROW",
                                                                        "path": "roadmaps.roadmapForSource.content.configuration.boardConfiguration.isUserBoardAdmin"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v20,
                                                                        "action": "THROW",
                                                                        "path": "roadmaps.roadmapForSource.content.configuration.boardConfiguration.isBoardJqlFilteringOutEpics"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v21,
                                                                        "action": "THROW",
                                                                        "path": "roadmaps.roadmapForSource.content.configuration.boardConfiguration.isSprintsFeatureEnabled"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v22,
                                                                        "action": "THROW",
                                                                        "path": "roadmaps.roadmapForSource.content.configuration.boardConfiguration.isChildIssuePlanningEnabled"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": {
                                                                            "concreteType": "RoadmapSprint",
                                                                            "kind": "LinkedField",
                                                                            "name": "sprints",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v8,
                                                                                    "action": "THROW",
                                                                                    "path": "roadmaps.roadmapForSource.content.configuration.boardConfiguration.sprints.id"
                                                                                },
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v5,
                                                                                    "action": "THROW",
                                                                                    "path": "roadmaps.roadmapForSource.content.configuration.boardConfiguration.sprints.name"
                                                                                },
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v23,
                                                                                    "action": "THROW",
                                                                                    "path": "roadmaps.roadmapForSource.content.configuration.boardConfiguration.sprints.state"
                                                                                },
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v24,
                                                                                    "action": "THROW",
                                                                                    "path": "roadmaps.roadmapForSource.content.configuration.boardConfiguration.sprints.startDateRFC3339"
                                                                                },
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v25,
                                                                                    "action": "THROW",
                                                                                    "path": "roadmaps.roadmapForSource.content.configuration.boardConfiguration.sprints.endDateRFC3339"
                                                                                }
                                                                            ]
                                                                        },
                                                                        "action": "THROW",
                                                                        "path": "roadmaps.roadmapForSource.content.configuration.boardConfiguration.sprints"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v26,
                                                                        "action": "THROW",
                                                                        "path": "roadmaps.roadmapForSource.content.configuration.boardConfiguration.childIssuePlanningMode"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v27,
                                                                        "action": "THROW",
                                                                        "path": "roadmaps.roadmapForSource.content.configuration.boardConfiguration.derivedFields"
                                                                    }
                                                                ]
                                                            },
                                                            "action": "THROW",
                                                            "path": "roadmaps.roadmapForSource.content.configuration.boardConfiguration"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": {
                                                                "concreteType": "RoadmapProjectConfiguration",
                                                                "kind": "LinkedField",
                                                                "name": "projectConfiguration",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v28,
                                                                        "action": "THROW",
                                                                        "path": "roadmaps.roadmapForSource.content.configuration.projectConfiguration.projectId"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v29,
                                                                        "action": "THROW",
                                                                        "path": "roadmaps.roadmapForSource.content.configuration.projectConfiguration.projectKey"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v30,
                                                                        "action": "THROW",
                                                                        "path": "roadmaps.roadmapForSource.content.configuration.projectConfiguration.projectName"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": {
                                                                            "concreteType": "RoadmapItemType",
                                                                            "kind": "LinkedField",
                                                                            "name": "parentItemTypes",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v8,
                                                                                    "action": "THROW",
                                                                                    "path": "roadmaps.roadmapForSource.content.configuration.projectConfiguration.parentItemTypes.id"
                                                                                },
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v31,
                                                                                    "action": "THROW",
                                                                                    "path": "roadmaps.roadmapForSource.content.configuration.projectConfiguration.parentItemTypes.iconUrl"
                                                                                },
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v5,
                                                                                    "action": "THROW",
                                                                                    "path": "roadmaps.roadmapForSource.content.configuration.projectConfiguration.parentItemTypes.name"
                                                                                },
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v32,
                                                                                    "action": "THROW",
                                                                                    "path": "roadmaps.roadmapForSource.content.configuration.projectConfiguration.parentItemTypes.requiredFieldIds"
                                                                                }
                                                                            ]
                                                                        },
                                                                        "action": "THROW",
                                                                        "path": "roadmaps.roadmapForSource.content.configuration.projectConfiguration.parentItemTypes"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": {
                                                                            "concreteType": "RoadmapItemType",
                                                                            "kind": "LinkedField",
                                                                            "name": "childItemTypes",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v8,
                                                                                    "action": "THROW",
                                                                                    "path": "roadmaps.roadmapForSource.content.configuration.projectConfiguration.childItemTypes.id"
                                                                                },
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v31,
                                                                                    "action": "THROW",
                                                                                    "path": "roadmaps.roadmapForSource.content.configuration.projectConfiguration.childItemTypes.iconUrl"
                                                                                },
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v5,
                                                                                    "action": "THROW",
                                                                                    "path": "roadmaps.roadmapForSource.content.configuration.projectConfiguration.childItemTypes.name"
                                                                                },
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v32,
                                                                                    "action": "THROW",
                                                                                    "path": "roadmaps.roadmapForSource.content.configuration.projectConfiguration.childItemTypes.requiredFieldIds"
                                                                                }
                                                                            ]
                                                                        },
                                                                        "action": "THROW",
                                                                        "path": "roadmaps.roadmapForSource.content.configuration.projectConfiguration.childItemTypes"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": {
                                                                            "concreteType": "RoadmapProjectPermissions",
                                                                            "kind": "LinkedField",
                                                                            "name": "permissions",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v33,
                                                                                    "action": "THROW",
                                                                                    "path": "roadmaps.roadmapForSource.content.configuration.projectConfiguration.permissions.canEditIssues"
                                                                                },
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v34,
                                                                                    "action": "THROW",
                                                                                    "path": "roadmaps.roadmapForSource.content.configuration.projectConfiguration.permissions.canScheduleIssues"
                                                                                },
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v35,
                                                                                    "action": "THROW",
                                                                                    "path": "roadmaps.roadmapForSource.content.configuration.projectConfiguration.permissions.canCreateIssues"
                                                                                },
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v36,
                                                                                    "action": "THROW",
                                                                                    "path": "roadmaps.roadmapForSource.content.configuration.projectConfiguration.permissions.canAdministerProjects"
                                                                                }
                                                                            ]
                                                                        },
                                                                        "action": "THROW",
                                                                        "path": "roadmaps.roadmapForSource.content.configuration.projectConfiguration.permissions"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": {
                                                                            "concreteType": "RoadmapVersion",
                                                                            "kind": "LinkedField",
                                                                            "name": "versions",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v8,
                                                                                    "action": "THROW",
                                                                                    "path": "roadmaps.roadmapForSource.content.configuration.projectConfiguration.versions.id"
                                                                                },
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v5,
                                                                                    "action": "THROW",
                                                                                    "path": "roadmaps.roadmapForSource.content.configuration.projectConfiguration.versions.name"
                                                                                },
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v37,
                                                                                    "action": "THROW",
                                                                                    "path": "roadmaps.roadmapForSource.content.configuration.projectConfiguration.versions.status"
                                                                                },
                                                                                v38
                                                                            ]
                                                                        },
                                                                        "action": "THROW",
                                                                        "path": "roadmaps.roadmapForSource.content.configuration.projectConfiguration.versions"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": {
                                                                            "concreteType": "RoadmapComponent",
                                                                            "kind": "LinkedField",
                                                                            "name": "components",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v8,
                                                                                    "action": "THROW",
                                                                                    "path": "roadmaps.roadmapForSource.content.configuration.projectConfiguration.components.id"
                                                                                },
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v5,
                                                                                    "action": "THROW",
                                                                                    "path": "roadmaps.roadmapForSource.content.configuration.projectConfiguration.components.name"
                                                                                }
                                                                            ]
                                                                        },
                                                                        "action": "THROW",
                                                                        "path": "roadmaps.roadmapForSource.content.configuration.projectConfiguration.components"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v39,
                                                                        "action": "THROW",
                                                                        "path": "roadmaps.roadmapForSource.content.configuration.projectConfiguration.isReleasesFeatureEnabled"
                                                                    },
                                                                    v40,
                                                                    v41
                                                                ]
                                                            },
                                                            "action": "THROW",
                                                            "path": "roadmaps.roadmapForSource.content.configuration.projectConfiguration"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": {
                                                                "concreteType": "RoadmapExternalConfiguration",
                                                                "kind": "LinkedField",
                                                                "name": "externalConfiguration",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v42,
                                                                        "action": "THROW",
                                                                        "path": "roadmaps.roadmapForSource.content.configuration.externalConfiguration.startDateField"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v43,
                                                                        "action": "THROW",
                                                                        "path": "roadmaps.roadmapForSource.content.configuration.externalConfiguration.rankField"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v44,
                                                                        "action": "THROW",
                                                                        "path": "roadmaps.roadmapForSource.content.configuration.externalConfiguration.epicLinkField"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v45,
                                                                        "action": "THROW",
                                                                        "path": "roadmaps.roadmapForSource.content.configuration.externalConfiguration.epicNameField"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v46,
                                                                        "action": "THROW",
                                                                        "path": "roadmaps.roadmapForSource.content.configuration.externalConfiguration.sprintField"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v47,
                                                                        "action": "THROW",
                                                                        "path": "roadmaps.roadmapForSource.content.configuration.externalConfiguration.colorField"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v49,
                                                                        "action": "THROW",
                                                                        "path": "roadmaps.roadmapForSource.content.configuration.externalConfiguration.fields"
                                                                    }
                                                                ]
                                                            },
                                                            "action": "THROW",
                                                            "path": "roadmaps.roadmapForSource.content.configuration.externalConfiguration"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": {
                                                                "concreteType": "RoadmapStatusCategory",
                                                                "kind": "LinkedField",
                                                                "name": "statusCategories",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v8,
                                                                        "action": "THROW",
                                                                        "path": "roadmaps.roadmapForSource.content.configuration.statusCategories.id"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v50,
                                                                        "action": "THROW",
                                                                        "path": "roadmaps.roadmapForSource.content.configuration.statusCategories.key"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v5,
                                                                        "action": "THROW",
                                                                        "path": "roadmaps.roadmapForSource.content.configuration.statusCategories.name"
                                                                    }
                                                                ]
                                                            },
                                                            "action": "THROW",
                                                            "path": "roadmaps.roadmapForSource.content.configuration.statusCategories"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": {
                                                                "concreteType": "RoadmapUserConfiguration",
                                                                "kind": "LinkedField",
                                                                "name": "userConfiguration",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": {
                                                                            "concreteType": "RoadmapCreationPreferences",
                                                                            "kind": "LinkedField",
                                                                            "name": "creationPreferences",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v51,
                                                                                    "action": "THROW",
                                                                                    "path": "roadmaps.roadmapForSource.content.configuration.userConfiguration.creationPreferences.itemTypes"
                                                                                }
                                                                            ]
                                                                        },
                                                                        "action": "THROW",
                                                                        "path": "roadmaps.roadmapForSource.content.configuration.userConfiguration.creationPreferences"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v52,
                                                                        "action": "THROW",
                                                                        "path": "roadmaps.roadmapForSource.content.configuration.userConfiguration.isDependenciesVisible"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v53,
                                                                        "action": "THROW",
                                                                        "path": "roadmaps.roadmapForSource.content.configuration.userConfiguration.isProgressVisible"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v54,
                                                                        "action": "THROW",
                                                                        "path": "roadmaps.roadmapForSource.content.configuration.userConfiguration.isWarningsVisible"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v55,
                                                                        "action": "THROW",
                                                                        "path": "roadmaps.roadmapForSource.content.configuration.userConfiguration.listWidth"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v56,
                                                                        "action": "THROW",
                                                                        "path": "roadmaps.roadmapForSource.content.configuration.userConfiguration.timelineMode"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": {
                                                                            "concreteType": "RoadmapViewSettings",
                                                                            "kind": "LinkedField",
                                                                            "name": "levelOneViewSettings",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v57,
                                                                                    "action": "THROW",
                                                                                    "path": "roadmaps.roadmapForSource.content.configuration.userConfiguration.levelOneViewSettings.period"
                                                                                },
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v58,
                                                                                    "action": "THROW",
                                                                                    "path": "roadmaps.roadmapForSource.content.configuration.userConfiguration.levelOneViewSettings.showCompleted"
                                                                                }
                                                                            ]
                                                                        },
                                                                        "action": "THROW",
                                                                        "path": "roadmaps.roadmapForSource.content.configuration.userConfiguration.levelOneViewSettings"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v59,
                                                                        "action": "THROW",
                                                                        "path": "roadmaps.roadmapForSource.content.configuration.userConfiguration.isReleasesVisible"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v60,
                                                                        "action": "THROW",
                                                                        "path": "roadmaps.roadmapForSource.content.configuration.userConfiguration.highlightedVersions"
                                                                    },
                                                                    v61
                                                                ]
                                                            },
                                                            "action": "THROW",
                                                            "path": "roadmaps.roadmapForSource.content.configuration.userConfiguration"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": {
                                                                "concreteType": "RoadmapHierarchyConfiguration",
                                                                "kind": "LinkedField",
                                                                "name": "hierarchyConfiguration",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v62,
                                                                        "action": "THROW",
                                                                        "path": "roadmaps.roadmapForSource.content.configuration.hierarchyConfiguration.levelOneName"
                                                                    }
                                                                ]
                                                            },
                                                            "action": "THROW",
                                                            "path": "roadmaps.roadmapForSource.content.configuration.hierarchyConfiguration"
                                                        }
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "roadmaps.roadmapForSource.content.configuration"
                                            },
                                            {
                                                "concreteType": "RoadmapItemConnection",
                                                "kind": "LinkedField",
                                                "name": "items",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "RoadmapItemEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "RoadmapItem",
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v8,
                                                                                "action": "THROW",
                                                                                "path": "roadmaps.roadmapForSource.content.items.edges.node.id"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v50,
                                                                                "action": "THROW",
                                                                                "path": "roadmaps.roadmapForSource.content.items.edges.node.key"
                                                                            },
                                                                            v63,
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v64,
                                                                                "action": "THROW",
                                                                                "path": "roadmaps.roadmapForSource.content.items.edges.node.summary"
                                                                            },
                                                                            v24,
                                                                            v65,
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v66,
                                                                                "action": "THROW",
                                                                                "path": "roadmaps.roadmapForSource.content.items.edges.node.color"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v67,
                                                                                "action": "THROW",
                                                                                "path": "roadmaps.roadmapForSource.content.items.edges.node.dependencies"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v68,
                                                                                "action": "THROW",
                                                                                "path": "roadmaps.roadmapForSource.content.items.edges.node.itemTypeId"
                                                                            },
                                                                            {
                                                                                "kind": "LinkedField",
                                                                                "name": "assignee",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v4,
                                                                                        "action": "THROW",
                                                                                        "path": "roadmaps.roadmapForSource.content.items.edges.node.assignee.accountId"
                                                                                    },
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v5,
                                                                                        "action": "THROW",
                                                                                        "path": "roadmaps.roadmapForSource.content.items.edges.node.assignee.name"
                                                                                    },
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v6,
                                                                                        "action": "THROW",
                                                                                        "path": "roadmaps.roadmapForSource.content.items.edges.node.assignee.picture"
                                                                                    }
                                                                                ]
                                                                            },
                                                                            {
                                                                                "concreteType": "RoadmapItemStatus",
                                                                                "kind": "LinkedField",
                                                                                "name": "status",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v8,
                                                                                        "action": "THROW",
                                                                                        "path": "roadmaps.roadmapForSource.content.items.edges.node.status.id"
                                                                                    },
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v5,
                                                                                        "action": "THROW",
                                                                                        "path": "roadmaps.roadmapForSource.content.items.edges.node.status.name"
                                                                                    },
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": {
                                                                                            "concreteType": "RoadmapItemStatusCategory",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "statusCategory",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "RequiredField",
                                                                                                    "field": v8,
                                                                                                    "action": "THROW",
                                                                                                    "path": "roadmaps.roadmapForSource.content.items.edges.node.status.statusCategory.id"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        "action": "THROW",
                                                                                        "path": "roadmaps.roadmapForSource.content.items.edges.node.status.statusCategory"
                                                                                    }
                                                                                ]
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v69,
                                                                                "action": "THROW",
                                                                                "path": "roadmaps.roadmapForSource.content.items.edges.node.rank"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v70,
                                                                                "action": "THROW",
                                                                                "path": "roadmaps.roadmapForSource.content.items.edges.node.labels"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v71,
                                                                                "action": "THROW",
                                                                                "path": "roadmaps.roadmapForSource.content.items.edges.node.sprintIds"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v72,
                                                                                "action": "THROW",
                                                                                "path": "roadmaps.roadmapForSource.content.items.edges.node.versionIds"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v73,
                                                                                "action": "THROW",
                                                                                "path": "roadmaps.roadmapForSource.content.items.edges.node.componentIds"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v74,
                                                                                "action": "THROW",
                                                                                "path": "roadmaps.roadmapForSource.content.items.edges.node.resolved"
                                                                            },
                                                                            {
                                                                                "condition": "isRoadmapsCriticalDataItemFlaggedEnabled",
                                                                                "kind": "Condition",
                                                                                "passingValue": true,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v75,
                                                                                        "action": "THROW",
                                                                                        "path": "roadmaps.roadmapForSource.content.items.edges.node.flagged"
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    "action": "THROW",
                                                                    "path": "roadmaps.roadmapForSource.content.items.edges.node"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "roadmaps.roadmapForSource.content.items.edges"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v2,
                    v1,
                    v0
                ],
                "kind": "Operation",
                "name": "roadmapCriticalDataQuery",
                "selections": [
                    {
                        "concreteType": "AuthenticationContext",
                        "kind": "LinkedField",
                        "name": "me",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": v76
                            }
                        ]
                    },
                    {
                        "concreteType": "RoadmapsQuery",
                        "kind": "LinkedField",
                        "name": "roadmaps",
                        "plural": false,
                        "selections": [
                            {
                                "args": v7,
                                "concreteType": "RoadmapDetails",
                                "kind": "LinkedField",
                                "name": "roadmapForSource",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "RoadmapHealthCheck",
                                        "kind": "LinkedField",
                                        "name": "healthcheck",
                                        "plural": false,
                                        "selections": [
                                            v8,
                                            v9,
                                            v10,
                                            v11,
                                            v12
                                        ]
                                    },
                                    {
                                        "concreteType": "RoadmapContent",
                                        "kind": "LinkedField",
                                        "name": "content",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "RoadmapConfiguration",
                                                "kind": "LinkedField",
                                                "name": "configuration",
                                                "plural": false,
                                                "selections": [
                                                    v13,
                                                    v14,
                                                    {
                                                        "concreteType": "RoadmapDependencyConfiguration",
                                                        "kind": "LinkedField",
                                                        "name": "dependencies",
                                                        "plural": false,
                                                        "selections": [
                                                            v15,
                                                            v16,
                                                            v17
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "RoadmapBoardConfiguration",
                                                        "kind": "LinkedField",
                                                        "name": "boardConfiguration",
                                                        "plural": false,
                                                        "selections": [
                                                            v18,
                                                            v19,
                                                            v20,
                                                            v21,
                                                            v22,
                                                            {
                                                                "concreteType": "RoadmapSprint",
                                                                "kind": "LinkedField",
                                                                "name": "sprints",
                                                                "plural": true,
                                                                "selections": [
                                                                    v8,
                                                                    v5,
                                                                    v23,
                                                                    v24,
                                                                    v25
                                                                ]
                                                            },
                                                            v26,
                                                            v27
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "RoadmapProjectConfiguration",
                                                        "kind": "LinkedField",
                                                        "name": "projectConfiguration",
                                                        "plural": false,
                                                        "selections": [
                                                            v28,
                                                            v29,
                                                            v30,
                                                            {
                                                                "concreteType": "RoadmapItemType",
                                                                "kind": "LinkedField",
                                                                "name": "parentItemTypes",
                                                                "plural": true,
                                                                "selections": v77
                                                            },
                                                            {
                                                                "concreteType": "RoadmapItemType",
                                                                "kind": "LinkedField",
                                                                "name": "childItemTypes",
                                                                "plural": true,
                                                                "selections": v77
                                                            },
                                                            {
                                                                "concreteType": "RoadmapProjectPermissions",
                                                                "kind": "LinkedField",
                                                                "name": "permissions",
                                                                "plural": false,
                                                                "selections": [
                                                                    v33,
                                                                    v34,
                                                                    v35,
                                                                    v36
                                                                ]
                                                            },
                                                            {
                                                                "concreteType": "RoadmapVersion",
                                                                "kind": "LinkedField",
                                                                "name": "versions",
                                                                "plural": true,
                                                                "selections": [
                                                                    v8,
                                                                    v5,
                                                                    v37,
                                                                    v38
                                                                ]
                                                            },
                                                            {
                                                                "concreteType": "RoadmapComponent",
                                                                "kind": "LinkedField",
                                                                "name": "components",
                                                                "plural": true,
                                                                "selections": v48
                                                            },
                                                            v39,
                                                            v40,
                                                            v41
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "RoadmapExternalConfiguration",
                                                        "kind": "LinkedField",
                                                        "name": "externalConfiguration",
                                                        "plural": false,
                                                        "selections": [
                                                            v42,
                                                            v43,
                                                            v44,
                                                            v45,
                                                            v46,
                                                            v47,
                                                            v49
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "RoadmapStatusCategory",
                                                        "kind": "LinkedField",
                                                        "name": "statusCategories",
                                                        "plural": true,
                                                        "selections": [
                                                            v8,
                                                            v50,
                                                            v5
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "RoadmapUserConfiguration",
                                                        "kind": "LinkedField",
                                                        "name": "userConfiguration",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "RoadmapCreationPreferences",
                                                                "kind": "LinkedField",
                                                                "name": "creationPreferences",
                                                                "plural": false,
                                                                "selections": [
                                                                    v51
                                                                ]
                                                            },
                                                            v52,
                                                            v53,
                                                            v54,
                                                            v55,
                                                            v56,
                                                            {
                                                                "concreteType": "RoadmapViewSettings",
                                                                "kind": "LinkedField",
                                                                "name": "levelOneViewSettings",
                                                                "plural": false,
                                                                "selections": [
                                                                    v57,
                                                                    v58
                                                                ]
                                                            },
                                                            v59,
                                                            v60,
                                                            v61
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "RoadmapHierarchyConfiguration",
                                                        "kind": "LinkedField",
                                                        "name": "hierarchyConfiguration",
                                                        "plural": false,
                                                        "selections": [
                                                            v62
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                "concreteType": "RoadmapItemConnection",
                                                "kind": "LinkedField",
                                                "name": "items",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "RoadmapItemEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "concreteType": "RoadmapItem",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v8,
                                                                    v50,
                                                                    v63,
                                                                    v64,
                                                                    v24,
                                                                    v65,
                                                                    v66,
                                                                    v67,
                                                                    v68,
                                                                    {
                                                                        "kind": "LinkedField",
                                                                        "name": "assignee",
                                                                        "plural": false,
                                                                        "selections": v76
                                                                    },
                                                                    {
                                                                        "concreteType": "RoadmapItemStatus",
                                                                        "kind": "LinkedField",
                                                                        "name": "status",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v8,
                                                                            v5,
                                                                            {
                                                                                "concreteType": "RoadmapItemStatusCategory",
                                                                                "kind": "LinkedField",
                                                                                "name": "statusCategory",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v8
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    v69,
                                                                    v70,
                                                                    v71,
                                                                    v72,
                                                                    v73,
                                                                    v74,
                                                                    {
                                                                        "condition": "isRoadmapsCriticalDataItemFlaggedEnabled",
                                                                        "kind": "Condition",
                                                                        "passingValue": true,
                                                                        "selections": [
                                                                            v75
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "7faf0fcae69a16c1e634367363f5f232fda270030289124c5ef0cd9de019b126",
                "metadata": {},
                "name": "roadmapCriticalDataQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $afd99f72d2d32430$var$node.hash = "89db149db4d4f4d1b0c377d210f81bfb";
    var $afd99f72d2d32430$export$2e2bcd8739ae039 = $afd99f72d2d32430$var$node;
});
parcelRegister("9VhdC", function(module, exports) {
    $parcel$export(module.exports, "generateCriticalDataQueryVariables", ()=>$6311c9bd59223dda$export$9ffe3013471a2a01);
    var $f9Owr;
    const $6311c9bd59223dda$export$9ffe3013471a2a01 = (sourceAri, locationAri = null)=>({
            sourceAri: sourceAri,
            locationAri: locationAri,
            isRoadmapsCriticalDataItemFlaggedEnabled: (0, (0, parcelRequire("f9Owr")).ff)('jsw.timeline.return-flagged-attribute-fe')
        });
});
parcelRegister("6uhbB", function(module, exports) {
    $parcel$export(module.exports, "transformHealthcheck", ()=>$b98bc03e0e6afcc2$export$1bdeeafa873182c7);
    $parcel$export(module.exports, "transformCurrentUser", ()=>$b98bc03e0e6afcc2$export$6386c84a43c69c67);
    $parcel$export(module.exports, "transformRoadmapConfiguration", ()=>$b98bc03e0e6afcc2$export$89ded4c2b7361b2f);
    $parcel$export(module.exports, "transformCriticalData", ()=>$b98bc03e0e6afcc2$export$9bbdc053b14eb715);
    var $k8IPx = parcelRequire("k8IPx");
    var $l4LVp;
    var $iZN6h;
    var $g11uZ;
    var $9ux39;
    var $7Bdf2;
    var $dN0Pt;
    var $agt34;
    var $lpZMC;
    const $b98bc03e0e6afcc2$export$1bdeeafa873182c7 = (healthcheck)=>{
        if (healthcheck) return healthcheck;
        return undefined;
    };
    const $b98bc03e0e6afcc2$export$6386c84a43c69c67 = (currentUser)=>currentUser ? {
            [currentUser.accountId]: {
                displayName: currentUser.name,
                avatarUrls: {
                    '16x16': currentUser.picture,
                    '24x24': currentUser.picture,
                    '32x32': currentUser.picture,
                    '48x48': currentUser.picture
                }
            }
        } : undefined;
    const $b98bc03e0e6afcc2$export$89ded4c2b7361b2f = ({ dependencies: dependencies, externalConfiguration: externalConfiguration, ...rest })=>{
        const { isDependenciesEnabled: isDependenciesEnabled, ...dependenciesRest } = dependencies;
        return {
            ...rest,
            dependencies: {
                ...dependenciesRest,
                dependenciesEnabled: isDependenciesEnabled
            },
            externalConfiguration: externalConfiguration
        };
    };
    const $b98bc03e0e6afcc2$var$transformItemTypes = (itemTypes)=>itemTypes.reduce((acc, itemType)=>{
            acc[itemType.id] = {
                iconUrl: itemType.iconUrl,
                name: itemType.name
            };
            return acc;
        }, {});
    const $b98bc03e0e6afcc2$var$transformVersions = (versions)=>versions.reduce((acc, version)=>{
            acc[version.id] = {
                name: version.name,
                status: version.status,
                releaseDate: (0, (0, parcelRequire("9ux39")).optionalDateToUtcTimestamp)((0, (0, parcelRequire("7Bdf2")).nullableToOptional)(version.releaseDate))
            };
            return acc;
        }, {});
    const $b98bc03e0e6afcc2$var$transformComponents = (components)=>components.reduce((acc, component)=>{
            acc[component.id] = component;
            return acc;
        }, {});
    const $b98bc03e0e6afcc2$var$REQUIRED_FIELD_WHITELIST = [
        'reporter',
        'issuetype',
        'project',
        'summary'
    ];
    const $b98bc03e0e6afcc2$export$1b5f4e1a54578f29 = (itemTypes)=>{
        const requiredFieldsHash = {};
        itemTypes.forEach((itemType)=>{
            requiredFieldsHash[itemType.id] = (0, ($parcel$interopDefault($k8IPx)))(itemType.requiredFieldIds, $b98bc03e0e6afcc2$var$REQUIRED_FIELD_WHITELIST);
        });
        return requiredFieldsHash;
    };
    const $b98bc03e0e6afcc2$var$transformProjectConfig = (projectConfig)=>{
        const itemTypes = [
            ...projectConfig.parentItemTypes,
            ...projectConfig.childItemTypes
        ];
        const defaultItemTypeId = projectConfig.defaultItemTypeId !== null && projectConfig.defaultItemTypeId !== undefined ? projectConfig.defaultItemTypeId : undefined;
        return {
            id: projectConfig.projectId,
            key: projectConfig.projectKey,
            name: projectConfig.projectName,
            permissions: {
                ...projectConfig.permissions
            },
            epicIssueTypeIds: projectConfig.parentItemTypes.map((epicItemType)=>epicItemType.id),
            requiredFields: $b98bc03e0e6afcc2$export$1b5f4e1a54578f29(itemTypes),
            issueTypes: {
                hash: $b98bc03e0e6afcc2$var$transformItemTypes(itemTypes)
            },
            versions: {
                hash: $b98bc03e0e6afcc2$var$transformVersions(projectConfig.versions)
            },
            components: {
                hash: $b98bc03e0e6afcc2$var$transformComponents(projectConfig.components)
            },
            defaultItemTypeId: defaultItemTypeId,
            isReleasesFeatureEnabled: projectConfig.isReleasesFeatureEnabled,
            isGoalsFeatureEnabled: projectConfig.isGoalsFeatureEnabled
        };
    };
    const $b98bc03e0e6afcc2$var$transformSprintConfiguration = (sprintConfigs)=>{
        const sprintConfigHash = {};
        sprintConfigs.forEach((sprintConfig)=>{
            const { id: id, name: name, state: state, startDateRFC3339: startDateRFC3339, endDateRFC3339: endDateRFC3339 } = sprintConfig;
            sprintConfigHash[id] = {
                id: id,
                name: name,
                state: state,
                startDate: (0, (0, parcelRequire("9ux39")).dateToUtcTimestamp)(startDateRFC3339),
                endDate: (0, (0, parcelRequire("9ux39")).dateToUtcTimestamp)(endDateRFC3339)
            };
        });
        return sprintConfigHash;
    };
    const $b98bc03e0e6afcc2$var$transformChildIssuePlanningMode = (childIssuePlanningMode)=>{
        switch(childIssuePlanningMode){
            case 'DISABLED':
                return 0, $5c67f944abd2f8af$export$8cd212c10b4124d2;
            case 'DATE':
                return 0, $5c67f944abd2f8af$export$501a7fac1df67a49;
            case 'SPRINT':
            default:
                return 0, $5c67f944abd2f8af$export$a316570a0dbfd2b0;
        }
    };
    const $b98bc03e0e6afcc2$var$transformBoardConfiguration = (boardConfig)=>{
        const isSprintsFeatureEnabled = boardConfig.isSprintsFeatureEnabled === true;
        const isChildIssuePlanningEnabled = boardConfig.isChildIssuePlanningEnabled === true;
        const boardConfigTransformed = {
            ...boardConfig,
            isBoardJqlFilteringOutEpics: boardConfig.isBoardJqlFilteringOutEpics === true,
            isSprintsFeatureEnabled: isSprintsFeatureEnabled,
            isChildIssuePlanningEnabled: isChildIssuePlanningEnabled,
            childIssuePlanningMode: $b98bc03e0e6afcc2$var$transformChildIssuePlanningMode(boardConfig.childIssuePlanningMode),
            sprints: {
                hash: boardConfig.sprints ? $b98bc03e0e6afcc2$var$transformSprintConfiguration([
                    ...boardConfig.sprints
                ]) : {},
                sequence: boardConfig.sprints.map((sprint)=>sprint.id)
            }
        };
        return boardConfigTransformed;
    };
    const $b98bc03e0e6afcc2$var$transformConfiguration = (roadmapConfiguration)=>{
        const { dependencies: dependencies, externalConfiguration: externalConfiguration, rankIssuesSupported: rankIssuesSupported, isCrossProject: isCrossProject, boardConfiguration: boardConfiguration, projectConfiguration: projectConfiguration, hierarchyConfiguration: hierarchyConfiguration } = roadmapConfiguration;
        const { dependenciesEnabled: dependenciesEnabled, inwardDependencyDescription: inwardDependencyDescription, outwardDependencyDescription: outwardDependencyDescription } = dependencies;
        const { colorField: colorField, startDateField: startDateField, rankField: rankField, epicLinkField: epicLinkField, epicNameField: epicNameField, sprintField: sprintField } = externalConfiguration;
        return {
            today: (0, (0, parcelRequire("g11uZ")).getToday)(),
            rankIssuesSupported: rankIssuesSupported,
            isCrossProject: isCrossProject,
            startDateCustomFieldId: startDateField,
            lexoRankCustomFieldId: rankField,
            epicLinkCustomFieldId: epicLinkField,
            epicNameCustomFieldId: epicNameField,
            sprintCustomFieldId: sprintField,
            colorCustomFieldId: colorField,
            inwardDependencyDescription: (0, (0, parcelRequire("7Bdf2")).nullableToOptional)(inwardDependencyDescription),
            outwardDependencyDescription: (0, (0, parcelRequire("7Bdf2")).nullableToOptional)(outwardDependencyDescription),
            dependenciesSupported: dependenciesEnabled,
            projectConfiguration: $b98bc03e0e6afcc2$var$transformProjectConfig(projectConfiguration),
            boardConfiguration: $b98bc03e0e6afcc2$var$transformBoardConfiguration(boardConfiguration),
            hierarchyConfiguration: hierarchyConfiguration ?? {
                levelOneName: ''
            },
            deriveFields: (0, (0, parcelRequire("agt34")).transformDerivedFieldsHash)(boardConfiguration.derivedFields),
            fields: [
                ...externalConfiguration.fields ?? []
            ],
            canInviteOthersToProject: false
        };
    };
    const $b98bc03e0e6afcc2$var$transformCreationPreference = (creationPreferences)=>{
        const itemTypes = {};
        if (creationPreferences && creationPreferences.itemTypes) Object.keys(creationPreferences.itemTypes).forEach((key)=>{
            const level = Number(key);
            const { itemTypeId: itemTypeId } = creationPreferences.itemTypes[level];
            itemTypes[level] = {
                itemTypeId: itemTypeId.toString()
            };
        });
        return {
            itemTypes: itemTypes
        };
    };
    const $b98bc03e0e6afcc2$export$50644fb2a14d9591 = (setting)=>{
        const defaultSettings = {
            timelineMode: (0, (0, parcelRequire("iZN6h")).MONTHS),
            listWidth: (0, (0, parcelRequire("iZN6h")).DEFAULT_LIST_WIDTH)(),
            creationPreferences: {
                itemTypes: {}
            },
            isDependenciesVisible: true,
            isProgressVisible: true,
            isWarningsVisible: true,
            isReleasesVisible: true,
            highlightedVersions: [],
            levelOneViewSettings: (0, (0, parcelRequire("l4LVp")).DEFAULT_LEVEL_ONE_VIEW_SETTINGS),
            issuePanelRatio: (0, $e24db0c09a05523d$export$75a24528ec4289ef)
        };
        if (setting) {
            defaultSettings.creationPreferences = $b98bc03e0e6afcc2$var$transformCreationPreference(setting.creationPreferences);
            const { timelineMode: timelineMode = defaultSettings.timelineMode, listWidth: listWidth = defaultSettings.listWidth, isDependenciesVisible: isDependenciesVisible = defaultSettings.isDependenciesVisible, isProgressVisible: isProgressVisible = defaultSettings.isProgressVisible, isWarningsVisible: isWarningsVisible = defaultSettings.isWarningsVisible, isReleasesVisible: isReleasesVisible = defaultSettings.isReleasesVisible, highlightedVersions: highlightedVersions = defaultSettings.highlightedVersions, levelOneViewSettings: levelOneViewSettings = defaultSettings.levelOneViewSettings, issuePanelRatio: issuePanelRatio = defaultSettings.issuePanelRatio } = setting;
            return {
                ...defaultSettings,
                timelineMode: timelineMode,
                listWidth: listWidth,
                isDependenciesVisible: isDependenciesVisible,
                isProgressVisible: isProgressVisible,
                isWarningsVisible: isWarningsVisible,
                isReleasesVisible: isReleasesVisible,
                highlightedVersions: [
                    ...highlightedVersions
                ],
                levelOneViewSettings: levelOneViewSettings,
                issuePanelRatio: issuePanelRatio || defaultSettings.issuePanelRatio
            };
        }
        return defaultSettings;
    };
    const $b98bc03e0e6afcc2$export$9bbdc053b14eb715 = ({ currentUser: currentUser, roadmapConfiguration: roadmapConfiguration, items: items, metadata: metadata, healthcheck: healthcheck })=>({
            currentUser: currentUser,
            configuration: roadmapConfiguration ? $b98bc03e0e6afcc2$var$transformConfiguration(roadmapConfiguration) : undefined,
            statusCategories: roadmapConfiguration ? (0, (0, parcelRequire("dN0Pt")).transformStatusCategories)([
                ...roadmapConfiguration.statusCategories
            ]) : undefined,
            settings: $b98bc03e0e6afcc2$export$50644fb2a14d9591(roadmapConfiguration?.userConfiguration),
            ...(0, (0, parcelRequire("lpZMC")).transformIssues)([
                ...items
            ]),
            metadata: {
                ...metadata
            },
            healthcheck: healthcheck
        });
});
const $e24db0c09a05523d$export$75a24528ec4289ef = 0.35;
parcelRegister("g11uZ", function(module, exports) {
    $parcel$export(module.exports, "getToday", ()=>$dd0e6eedd8c09c8c$export$883228a582a7567d);
    $parcel$export(module.exports, "getStartOfDay", ()=>$dd0e6eedd8c09c8c$export$acfb4d8d6f22913c);
    $parcel$export(module.exports, "getClosestStartOfDay", ()=>$dd0e6eedd8c09c8c$export$3b10530a2652517a);
    $parcel$export(module.exports, "getEndOfDay", ()=>$dd0e6eedd8c09c8c$export$ba913d97bab95922);
    $parcel$export(module.exports, "getClosestEndOfDay", ()=>$dd0e6eedd8c09c8c$export$15bcb0122f94fe73);
    $parcel$export(module.exports, "getDateFromTimestamp", ()=>$dd0e6eedd8c09c8c$export$f268c901e7fab1f4);
    var $8QpSo;
    var $2gnC5 = parcelRequire("2gnC5");
    const $dd0e6eedd8c09c8c$var$HALF_DAY_IN_MS = (0, $a797a5154a1373bc$export$1f04624003d2da7d) / 2;
    const $dd0e6eedd8c09c8c$export$883228a582a7567d = (0, (0, parcelRequire("8QpSo")).default)(()=>{
        const now = new Date();
        const date = (0, ($parcel$interopDefault($2gnC5))).utc().startOf('day');
        date.set({
            year: now.getFullYear(),
            month: now.getMonth(),
            date: now.getDate()
        });
        return date.valueOf();
    });
    const $dd0e6eedd8c09c8c$export$acfb4d8d6f22913c = (date)=>(0, ($parcel$interopDefault($2gnC5))).utc(date).startOf('day').valueOf();
    const $dd0e6eedd8c09c8c$export$3b10530a2652517a = (date)=>{
        const newValue = $dd0e6eedd8c09c8c$export$acfb4d8d6f22913c(date);
        if (date - newValue > $dd0e6eedd8c09c8c$var$HALF_DAY_IN_MS) return newValue + $dd0e6eedd8c09c8c$var$HALF_DAY_IN_MS * 2;
        return newValue;
    };
    const $dd0e6eedd8c09c8c$export$ba913d97bab95922 = (date)=>(0, ($parcel$interopDefault($2gnC5))).utc(date).endOf('day').valueOf();
    const $dd0e6eedd8c09c8c$export$15bcb0122f94fe73 = (date)=>{
        const newValue = $dd0e6eedd8c09c8c$export$ba913d97bab95922(date);
        if (newValue - date > $dd0e6eedd8c09c8c$var$HALF_DAY_IN_MS) return newValue - $dd0e6eedd8c09c8c$var$HALF_DAY_IN_MS * 2;
        return newValue;
    };
    const $dd0e6eedd8c09c8c$export$b6b0beaf88b31f31 = (date)=>Math.round(date / (0, $a797a5154a1373bc$export$1f04624003d2da7d)) * (0, $a797a5154a1373bc$export$1f04624003d2da7d);
    const $dd0e6eedd8c09c8c$export$f268c901e7fab1f4 = (timestamp, format = (0, $a797a5154a1373bc$export$45c85543ba71221d))=>(0, ($parcel$interopDefault($2gnC5))).utc(timestamp).format(format);
});
parcelRegister("9ux39", function(module, exports) {
    $parcel$export(module.exports, "dateToUtcTimestamp", ()=>$2252dffbdbc03cb9$export$c56f0b7c199d6cc4);
    $parcel$export(module.exports, "optionalDateToUtcTimestamp", ()=>$2252dffbdbc03cb9$export$285bdc8a9ea7c1de);
    $parcel$export(module.exports, "optionalUtcTimestampToDate", ()=>$2252dffbdbc03cb9$export$b2b962f648d391c4);
    var $2gnC5 = parcelRequire("2gnC5");
    const $2252dffbdbc03cb9$export$c56f0b7c199d6cc4 = (date)=>(0, ($parcel$interopDefault($2gnC5))).utc(date, (0, $a797a5154a1373bc$export$e63e1e1c17a0e8b)).valueOf();
    const $2252dffbdbc03cb9$export$285bdc8a9ea7c1de = (date)=>{
        if (date === undefined) return undefined;
        return $2252dffbdbc03cb9$export$c56f0b7c199d6cc4(date);
    };
    const $2252dffbdbc03cb9$export$b2b962f648d391c4 = (timestamp)=>{
        if (timestamp === undefined) return undefined;
        return (0, ($parcel$interopDefault($2gnC5))).utc(timestamp).format((0, $a797a5154a1373bc$export$e63e1e1c17a0e8b));
    };
});
parcelRegister("7Bdf2", function(module, exports) {
    $parcel$export(module.exports, "toModifiable", ()=>$dd4f16acfb94a403$export$b807868ed7c6dc2);
    $parcel$export(module.exports, "nullableToModifiable", ()=>$dd4f16acfb94a403$export$1c3dc21bb7c157ad);
    $parcel$export(module.exports, "nullableToModifiableWithConversion", ()=>$dd4f16acfb94a403$export$fb3253a5ab719486);
    $parcel$export(module.exports, "nullableToOptional", ()=>$dd4f16acfb94a403$export$9d88f099d751247a);
    $parcel$export(module.exports, "optionalToNullableWithConversion", ()=>$dd4f16acfb94a403$export$b347dfde75ec8151);
    const $dd4f16acfb94a403$export$b807868ed7c6dc2 = (value)=>({
            value: value
        });
    const $dd4f16acfb94a403$export$1c3dc21bb7c157ad = (nullable)=>{
        if (nullable === null) return {
            value: undefined
        };
        return {
            value: nullable
        };
    };
    const $dd4f16acfb94a403$export$fb3253a5ab719486 = (nullable, func)=>{
        if (nullable === null) return {
            value: undefined
        };
        return {
            value: func(nullable)
        };
    };
    const $dd4f16acfb94a403$export$9d88f099d751247a = (nullable)=>{
        if (nullable === null) return undefined;
        return nullable;
    };
    const $dd4f16acfb94a403$export$85aa01adeb0c4c1c = (nullable, func)=>{
        if (nullable === null) return undefined;
        return func(nullable);
    };
    const $dd4f16acfb94a403$export$b2ed551664a25599 = (optional)=>{
        if (optional === undefined) return null;
        return optional;
    };
    const $dd4f16acfb94a403$export$b347dfde75ec8151 = (optional, func)=>{
        if (optional === undefined) return null;
        return func(optional);
    };
});
parcelRegister("dN0Pt", function(module, exports) {
    $parcel$export(module.exports, "transformStatusCategories", ()=>$d443b948d22a7471$export$847e60d12743ff1a);
    const $d443b948d22a7471$export$847e60d12743ff1a = (statusCategories)=>{
        const getTransformedStatusCategories = ()=>{
            const result = {};
            statusCategories.forEach((statusCategory)=>{
                result[statusCategory.id] = {
                    key: statusCategory.key,
                    name: statusCategory.name
                };
            });
            return result;
        };
        return getTransformedStatusCategories();
    };
});
parcelRegister("agt34", function(module, exports) {
    $parcel$export(module.exports, "transformDerivedFieldsHash", ()=>$92c624eddd5276ed$export$90c58bddabb88fa1);
    const $92c624eddd5276ed$export$90c58bddabb88fa1 = (derivedFields)=>derivedFields.reduce((acc, deriveField)=>{
            acc[deriveField.id] = [
                ...deriveField.values
            ];
            return acc;
        }, {});
});
parcelRegister("lpZMC", function(module, exports) {
    $parcel$export(module.exports, "transformIssue", ()=>$2478c433b9613eb4$export$2d1bde06ef9e2dcc);
    $parcel$export(module.exports, "transformIssues", ()=>$2478c433b9613eb4$export$a26a6de2e9ae64a0);
    $parcel$export(module.exports, "transformIssuesFromGetItemsByIdsQueryResponse", ()=>$2478c433b9613eb4$export$171bea9a74da27e6);
    $parcel$export(module.exports, "transformScheduleItemsRequest", ()=>$2478c433b9613eb4$export$c4dd18f037a8ccf9);
    $parcel$export(module.exports, "transformSubtasksAndStatusCategoriesResponse", ()=>$2478c433b9613eb4$export$29438f0dc3b07875);
    var $561FV = parcelRequire("561FV");
    var $9ux39;
    var $7Bdf2;
    var $dN0Pt;
    var $3wFFr;
    var $3ZrZm;
    const $2478c433b9613eb4$export$2d1bde06ef9e2dcc = (issue)=>{
        const assignee = (0, (0, parcelRequire("7Bdf2")).nullableToOptional)(issue.assignee);
        const parentId = issue.parentId || null;
        const color = issue.color;
        const componentIds = issue.componentIds || [];
        return {
            key: issue.key,
            summary: (0, (0, parcelRequire("7Bdf2")).toModifiable)(issue.summary),
            startDate: (0, (0, parcelRequire("7Bdf2")).nullableToModifiableWithConversion)(issue.startDateRFC3339, (0, (0, parcelRequire("9ux39")).optionalDateToUtcTimestamp)),
            dueDate: (0, (0, parcelRequire("7Bdf2")).nullableToModifiableWithConversion)(issue.dueDateRFC3339, (0, (0, parcelRequire("9ux39")).optionalDateToUtcTimestamp)),
            color: (0, (0, parcelRequire("7Bdf2")).toModifiable)(color),
            inCreation: false,
            issueTypeId: `${issue.itemTypeId}`,
            rank: issue.rank,
            status: (0, (0, parcelRequire("3wFFr")).transformStatus)(issue.status || null),
            assignee: assignee?.accountId,
            parentId: (0, (0, parcelRequire("7Bdf2")).nullableToModifiable)(parentId),
            dependencies: [
                ...issue.dependencies
            ],
            labels: Array.isArray(issue.labels) ? [
                ...issue.labels
            ] : [],
            sprintIds: (0, (0, parcelRequire("7Bdf2")).toModifiable)([
                ...issue.sprintIds
            ]),
            versionIds: [
                ...issue.versionIds
            ],
            componentIds: [
                ...componentIds
            ],
            resolved: issue.resolved,
            flagged: issue.flagged || false
        };
    };
    const $2478c433b9613eb4$export$a26a6de2e9ae64a0 = (graphQLIssues)=>{
        const users = {};
        const issues = {
            hash: {},
            sequence: []
        };
        graphQLIssues.forEach((issue)=>{
            const assignee = (0, (0, parcelRequire("7Bdf2")).nullableToOptional)(issue.assignee);
            if (assignee !== undefined) users[assignee.accountId] = (0, (0, parcelRequire("3ZrZm")).transformAssignee)(assignee);
            issues.sequence.push(issue.id);
            issues.hash[issue.id] = $2478c433b9613eb4$export$2d1bde06ef9e2dcc(issue);
        });
        return {
            users: users,
            issues: issues
        };
    };
    const $2478c433b9613eb4$export$171bea9a74da27e6 = (data)=>{
        const roadmapItems = data.roadmaps?.roadmapItemByIds;
        const users = {};
        const issues = {
            hash: {},
            sequence: []
        };
        if (roadmapItems) roadmapItems.forEach((issue)=>{
            if (issue) {
                const assignee = (0, (0, parcelRequire("7Bdf2")).nullableToOptional)(issue.assignee);
                if (assignee !== undefined) users[assignee.accountId] = (0, (0, parcelRequire("3ZrZm")).transformAssignee)(assignee);
                issues.sequence.push(issue.id);
                issues.hash[issue.id] = $2478c433b9613eb4$export$2d1bde06ef9e2dcc(issue);
            }
        });
        return {
            users: users,
            issues: issues
        };
    };
    const $2478c433b9613eb4$export$c4dd18f037a8ccf9 = (issueScheduleFields)=>{
        const issues = [];
        issueScheduleFields.forEach((scheduledIssue)=>{
            const itemId = scheduledIssue.issueId;
            let startDate = null;
            let dueDate = null;
            if ((0, ($parcel$interopDefault($561FV)))(scheduledIssue, 'startDate')) startDate = (0, (0, parcelRequire("7Bdf2")).optionalToNullableWithConversion)(scheduledIssue.startDate, (0, (0, parcelRequire("9ux39")).optionalUtcTimestampToDate));
            if ((0, ($parcel$interopDefault($561FV)))(scheduledIssue, 'dueDate')) dueDate = (0, (0, parcelRequire("7Bdf2")).optionalToNullableWithConversion)(scheduledIssue.dueDate, (0, (0, parcelRequire("9ux39")).optionalUtcTimestampToDate));
            issues.push({
                itemId: itemId,
                startDate: startDate,
                dueDate: dueDate
            });
        });
        return issues;
    };
    const $2478c433b9613eb4$export$29438f0dc3b07875 = (response)=>{
        const { subtasks: subtasks, statusCategories: statusCategories } = response;
        const subtasksHash = {};
        subtasks.forEach(({ parentId: parentId, id: id, key: key, statusCategoryId: statusCategoryId })=>{
            if (subtasksHash[parentId] === undefined) subtasksHash[parentId] = [];
            subtasksHash[parentId].push({
                id: id,
                key: key,
                statusCategoryId: statusCategoryId
            });
        });
        return {
            statusCategories: (0, (0, parcelRequire("dN0Pt")).transformStatusCategories)([
                ...statusCategories
            ]),
            subtasks: subtasksHash
        };
    };
});
parcelRegister("3wFFr", function(module, exports) {
    $parcel$export(module.exports, "transformStatus", ()=>$758ef6e5c96cd4d4$export$95f71e2e6b5bd102);
    const $758ef6e5c96cd4d4$export$95f71e2e6b5bd102 = (status)=>{
        if (status != null) return {
            id: status.id,
            name: status.name,
            statusCategoryId: status.statusCategory.id
        };
        return undefined;
    };
});
parcelRegister("3ZrZm", function(module, exports) {
    $parcel$export(module.exports, "transformAssignee", ()=>$ef205db7087fcc18$export$32f35dc2efaf5893);
    const $ef205db7087fcc18$export$32f35dc2efaf5893 = (assignee)=>({
            avatarUrls: {
                '16x16': assignee.picture,
                '24x24': assignee.picture,
                '32x32': assignee.picture,
                '48x48': assignee.picture
            },
            displayName: assignee.name
        });
});
parcelRegister("amNTR", function(module, exports) {
    $parcel$export(module.exports, "fetchEagerLoadedData", ()=>$857d49ec0bd1e214$export$28cd71eb0ba7805a);
    var $kVLXA = parcelRequire("kVLXA");
    parcelRequire("aSIuP");
    parcelRequire("fp4O3");
    parcelRequire("d0pqD");
    var $cGYoc;
    var $gMbXv;
    const $857d49ec0bd1e214$var$eagerDataFetchers = [
        (0, (0, parcelRequire("cGYoc")).goalsFetcher),
        (0, (0, parcelRequire("gMbXv")).filterItemsByJQLFetcher)
    ];
    const $857d49ec0bd1e214$var$mergeAdditionalData = (dataFragments)=>{
        const result = {};
        dataFragments.forEach((object)=>{
            Object.assign(result, object);
        });
        return result;
    };
    const $857d49ec0bd1e214$export$28cd71eb0ba7805a = (sourceAri, context)=>{
        const matchingFetchers = $857d49ec0bd1e214$var$eagerDataFetchers.filter((fetcher)=>fetcher.match(context));
        if (matchingFetchers.length === 0) return (0, $kVLXA.Observable).of({});
        return (0, $kVLXA.Observable).zip(...matchingFetchers.map((fetcher)=>fetcher.fetch(sourceAri, context))).map((dataFragments)=>$857d49ec0bd1e214$var$mergeAdditionalData(dataFragments));
    };
});
parcelRegister("cGYoc", function(module, exports) {
    $parcel$export(module.exports, "goalsFetcher", ()=>$f9b51198a5db8a90$export$bff1d3ae1b2929bc);
    var $arhyO;
    const $f9b51198a5db8a90$export$bff1d3ae1b2929bc = {
        match: ({ query: { goal: goal } })=>goal !== undefined,
        fetch: (sourceAri)=>(0, (0, parcelRequire("arhyO")).getGoals)(sourceAri).map((goals)=>({
                    goals: goals
                }))
    };
});
parcelRegister("arhyO", function(module, exports) {
    $parcel$export(module.exports, "getGoals", ()=>$62e9a349d8ec2619$export$da2944c52ff0de62);
    parcelRequire("d0pqD");
    parcelRequire("9o0uh");
    var $4vUsk;
    var $5f44M;
    var $iW95S;
    var $8C5lr;
    const $62e9a349d8ec2619$var$analyticKey = 'jira.frontend.fe.software.roadmap.goals';
    const $62e9a349d8ec2619$var$concurrentMetricDefinition = (0, (0, parcelRequire("8C5lr")).queryMetrics)[0, $8038b72ffd5aa8d4$export$57a4171901f1c15b];
    const $62e9a349d8ec2619$export$c4b84c37e5420d49 = {
        graphqlErrorFilter: (errors)=>errors.filter((error)=>!(error.path && error.path[0] === 'townsquare' && error.extensions?.statusCode === 403))
    };
    const $62e9a349d8ec2619$export$da2944c52ff0de62 = (sourceAri)=>(0, (0, parcelRequire("iW95S")).runQueryWithMetadataAndSelector)((0, (0, parcelRequire("4vUsk")).default), (0, (0, parcelRequire("5f44M")).generateRoadmapGoalsQueryVariables)(sourceAri), $62e9a349d8ec2619$var$analyticKey, $62e9a349d8ec2619$var$concurrentMetricDefinition, (data)=>data.roadmaps?.roadmapAriGoals?.goals, $62e9a349d8ec2619$export$c4b84c37e5420d49).map(({ data: data })=>data.reduce((acc, { goal: goal, issueIds: issueIds })=>{
                if (goal) acc[goal.id] = {
                    goal: goal,
                    issueIds: issueIds.map((id)=>String(id))
                };
                return acc;
            }, {}));
});
parcelRegister("4vUsk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0899ceedc0fa5069$export$2e2bcd8739ae039);
    const $0899ceedc0fa5069$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "sourceAri"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "sourceARI",
                "variableName": "sourceAri"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "ari"
        }, v3 = {
            "kind": "ScalarField",
            "name": "issueIds"
        }, v4 = {
            "kind": "ScalarField",
            "name": "id"
        }, v5 = {
            "kind": "ScalarField",
            "name": "uuid"
        }, v6 = {
            "kind": "ScalarField",
            "name": "key"
        }, v7 = {
            "kind": "ScalarField",
            "name": "name"
        }, v8 = {
            "kind": "ScalarField",
            "name": "label"
        }, v9 = {
            "kind": "ScalarField",
            "name": "score"
        }, v10 = {
            "kind": "ScalarField",
            "name": "value"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "roadmapGoalsQuery",
                "selections": [
                    {
                        "concreteType": "RoadmapsQuery",
                        "kind": "LinkedField",
                        "name": "roadmaps",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "RoadmapAriGoals",
                                "kind": "LinkedField",
                                "name": "roadmapAriGoals",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "RoadmapAriGoalDetails",
                                            "kind": "LinkedField",
                                            "name": "goals",
                                            "plural": true,
                                            "selections": [
                                                v2,
                                                v3,
                                                {
                                                    "concreteType": "TownsquareGoal",
                                                    "kind": "LinkedField",
                                                    "name": "goal",
                                                    "plural": false,
                                                    "selections": [
                                                        v4,
                                                        v5,
                                                        v6,
                                                        v7,
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": {
                                                                "concreteType": "TownsquareGoalState",
                                                                "kind": "LinkedField",
                                                                "name": "state",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v8,
                                                                        "action": "THROW",
                                                                        "path": "roadmaps.roadmapAriGoals.goals.goal.state.label"
                                                                    },
                                                                    v9,
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v10,
                                                                        "action": "THROW",
                                                                        "path": "roadmaps.roadmapAriGoals.goals.goal.state.value"
                                                                    }
                                                                ]
                                                            },
                                                            "action": "THROW",
                                                            "path": "roadmaps.roadmapAriGoals.goals.goal.state"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "roadmaps.roadmapAriGoals.goals"
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "roadmapGoalsQuery",
                "selections": [
                    {
                        "concreteType": "RoadmapsQuery",
                        "kind": "LinkedField",
                        "name": "roadmaps",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "RoadmapAriGoals",
                                "kind": "LinkedField",
                                "name": "roadmapAriGoals",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "RoadmapAriGoalDetails",
                                        "kind": "LinkedField",
                                        "name": "goals",
                                        "plural": true,
                                        "selections": [
                                            v2,
                                            v3,
                                            {
                                                "concreteType": "TownsquareGoal",
                                                "kind": "LinkedField",
                                                "name": "goal",
                                                "plural": false,
                                                "selections": [
                                                    v4,
                                                    v5,
                                                    v6,
                                                    v7,
                                                    {
                                                        "concreteType": "TownsquareGoalState",
                                                        "kind": "LinkedField",
                                                        "name": "state",
                                                        "plural": false,
                                                        "selections": [
                                                            v8,
                                                            v9,
                                                            v10
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "cd0e4c566bd1af6d8a8352be7b22bfc085c63b835d01e5adfd2ca9f0007cb006",
                "metadata": {},
                "name": "roadmapGoalsQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $0899ceedc0fa5069$var$node.hash = "2792b908e31158794969cc76ffa0f0f8";
    var $0899ceedc0fa5069$export$2e2bcd8739ae039 = $0899ceedc0fa5069$var$node;
});
parcelRegister("5f44M", function(module, exports) {
    $parcel$export(module.exports, "generateRoadmapGoalsQueryVariables", ()=>$66ab5dbda3182ca6$export$232f8dfcaf45cea7);
    const $66ab5dbda3182ca6$export$232f8dfcaf45cea7 = (sourceAri)=>({
            sourceAri: sourceAri
        });
});
parcelRegister("gMbXv", function(module, exports) {
    $parcel$export(module.exports, "filterItemsByJQLFetcher", ()=>$4524f166ca505068$export$175e69da1a1f5ca2);
    var $5ulVP;
    const $4524f166ca505068$export$175e69da1a1f5ca2 = {
        match: ({ query: { quickFilter: quickFilter, customFilter: customFilter } })=>quickFilter !== undefined || customFilter !== undefined,
        fetch: (sourceAri, { query: { quickFilter: quickFilter, customFilter: customFilter } })=>{
            const quickFilterIds = quickFilter ? quickFilter.split(',') : [];
            const customFilterIds = customFilter ? customFilter.split(',') : [];
            return (0, (0, parcelRequire("5ulVP")).filterItemsByJQLFilters)(sourceAri, quickFilterIds, customFilterIds).map((filteredIssueIds)=>({
                    filteredIssueIds: filteredIssueIds
                }));
        }
    };
});
parcelRegister("bFYz9", function(module, exports) {
    $parcel$export(module.exports, "onHandleAggErrors", ()=>$bb7dca39a6291617$export$e0ee9ab1145d2d14);
    var $74ySO = parcelRequire("74ySO");
    var $kVLXA = parcelRequire("kVLXA");
    parcelRequire("fp4O3");
    var $hb2iR;
    const $bb7dca39a6291617$export$e0ee9ab1145d2d14 = (isDataValid, errors)=>{
        if (!isDataValid) return (0, $kVLXA.Observable).of((0, (0, parcelRequire("hb2iR")).aggError)());
        if (errors && errors.length) {
            const errorTypes = errors.reduce((allErrorTypes, error)=>error && error.extensions && error.extensions.errorType ? allErrorTypes.concat([
                    error.extensions.errorType
                ]) : allErrorTypes, []);
            if (errorTypes.length > 0 && (0, ($parcel$interopDefault($74ySO)))(errorTypes, (0, $66c67c0c2e148cb9$export$d2fa25fc0fdc86b8))) return (0, $kVLXA.Observable).of((0, (0, parcelRequire("hb2iR")).aggError)({
                errorType: (0, $66c67c0c2e148cb9$export$d2fa25fc0fdc86b8),
                description: undefined
            }));
            const errorMessage = `${errors.reduce((errorMsg, error)=>error && error.message !== undefined && error.message !== null ? `${errorMsg}${error.message} ` : '', '').trim()}`;
            if (errorMessage.length) {
                const formattedErrorMessage = errorMessage.charAt(0).toUpperCase() + errorMessage.slice(1);
                return (0, $kVLXA.Observable).of((0, (0, parcelRequire("hb2iR")).aggError)({
                    description: formattedErrorMessage,
                    errorType: undefined
                }));
            }
        }
        return (0, $kVLXA.Observable).of((0, (0, parcelRequire("hb2iR")).aggError)());
    };
});
parcelRegister("5TDr4", function(module, exports) {
    $parcel$export(module.exports, "getCriticalDataActions", ()=>$e19826b8d5f8b212$export$9557d78156c411f1);
    var $50Z4W;
    var $fe0Qy;
    var $1VLi2;
    var $4hao7;
    var $dCEtc;
    var $lCbUI;
    var $iRJhX;
    var $k6Vft;
    var $9QFr0;
    var $jJEyp;
    var $ilGit;
    const $e19826b8d5f8b212$export$9557d78156c411f1 = (criticalData)=>{
        const { configuration: configuration, users: users, issues: issues, statusCategories: statusCategories, settings: settings, metadata: metadata, healthcheck: healthcheck, filteredIssueIds: filteredIssueIds, eagerLoadedData: eagerLoadedData, resourcesCacheSource: resourcesCacheSource } = criticalData;
        const basicInitActions = [
            (0, (0, parcelRequire("jJEyp")).updateHealthcheck)(healthcheck),
            (0, (0, parcelRequire("lCbUI")).setMetadata)(metadata)
        ];
        if (resourcesCacheSource !== (0, $8631d6ce464ccf2e$export$b7dfe28569b170a1)) basicInitActions.push((0, (0, parcelRequire("iRJhX")).updateResourceCache)(criticalData));
        if (configuration) basicInitActions.push((0, (0, parcelRequire("50Z4W")).setConfiguration)(configuration));
        if (settings) {
            basicInitActions.push((0, (0, parcelRequire("k6Vft")).setSettings)(settings));
            if (settings.isDependenciesVisible !== undefined) basicInitActions.push((0, (0, parcelRequire("ilGit")).setDependenciesViewVisibility)(settings.isDependenciesVisible));
            if (settings.isProgressVisible !== undefined) basicInitActions.push((0, (0, parcelRequire("ilGit")).setProgressVisibility)(settings.isProgressVisible));
            if (settings.isWarningsVisible !== undefined) basicInitActions.push((0, (0, parcelRequire("ilGit")).setWarningsVisibility)(settings.isWarningsVisible));
            if (settings.isReleasesVisible !== undefined) basicInitActions.push((0, (0, parcelRequire("ilGit")).setReleasesVisibility)(settings.isReleasesVisible));
            if (settings.levelOneViewSettings !== undefined && !(settings.levelOneViewSettings.showCompleted && settings.levelOneViewSettings.period === 12)) basicInitActions.push((0, (0, parcelRequire("ilGit")).setLevelOneSetting)(settings.levelOneViewSettings));
            if (filteredIssueIds !== undefined) basicInitActions.push((0, (0, parcelRequire("9QFr0")).jqlFiltersSuccess)(filteredIssueIds));
        }
        if (healthcheck !== undefined) return basicInitActions;
        if (eagerLoadedData) {
            if (configuration?.projectConfiguration?.isGoalsFeatureEnabled === true && eagerLoadedData.goals) basicInitActions.push((0, (0, parcelRequire("fe0Qy")).setGoals)(eagerLoadedData.goals));
            if (eagerLoadedData.filteredIssueIds) basicInitActions.push((0, (0, parcelRequire("9QFr0")).jqlFiltersSuccess)(eagerLoadedData.filteredIssueIds));
        }
        basicInitActions.push((0, (0, parcelRequire("dCEtc")).addUsers)(users), (0, (0, parcelRequire("1VLi2")).updateIssuesHashAndSequence)(issues));
        if (statusCategories) basicInitActions.push((0, (0, parcelRequire("4hao7")).mergeStatusCategories)(statusCategories));
        return basicInitActions;
    };
});
parcelRegister("50Z4W", function(module, exports) {
    $parcel$export(module.exports, "SET_CONFIGURATION", ()=>$cfb81d9b28b5b026$export$88d379a4ed7b960a);
    $parcel$export(module.exports, "SET_TODAY", ()=>$cfb81d9b28b5b026$export$ea5cc78508d1a91f);
    $parcel$export(module.exports, "SET_COMPONENTS", ()=>$cfb81d9b28b5b026$export$eb071a4d80c1cce1);
    $parcel$export(module.exports, "SET_VERSION", ()=>$cfb81d9b28b5b026$export$33d1af9ce619539e);
    $parcel$export(module.exports, "SET_SPRINT", ()=>$cfb81d9b28b5b026$export$26f77f93871b8908);
    $parcel$export(module.exports, "setConfiguration", ()=>$cfb81d9b28b5b026$export$6a52175581b4d614);
    $parcel$export(module.exports, "setComponents", ()=>$cfb81d9b28b5b026$export$41155fc643823ac5);
    $parcel$export(module.exports, "setVersion", ()=>$cfb81d9b28b5b026$export$f99c3c9c04cda7ae);
    $parcel$export(module.exports, "setSprint", ()=>$cfb81d9b28b5b026$export$cd32ff7d877f176c);
    $parcel$export(module.exports, "DERIVE_FIELDS_REQUEST", ()=>$cfb81d9b28b5b026$export$9eaf0f2039b438c4);
    $parcel$export(module.exports, "deriveFieldsRequest", ()=>$cfb81d9b28b5b026$export$75d1c1de4eb47530);
    $parcel$export(module.exports, "SET_DERIVE_FIELDS", ()=>$cfb81d9b28b5b026$export$b386863aaed4e128);
    $parcel$export(module.exports, "setDeriveFieldsHash", ()=>$cfb81d9b28b5b026$export$ecb601895f145781);
    $parcel$export(module.exports, "SET_CAN_USER_INVITE", ()=>$cfb81d9b28b5b026$export$c09a6e8888fd28fa);
    $parcel$export(module.exports, "setCanUserInvite", ()=>$cfb81d9b28b5b026$export$c07b821618e68774);
    const $cfb81d9b28b5b026$export$88d379a4ed7b960a = 'state.configuration.SET_CONFIGURATION';
    const $cfb81d9b28b5b026$export$ea5cc78508d1a91f = 'state.configuration.SET_TODAY';
    const $cfb81d9b28b5b026$export$eb071a4d80c1cce1 = 'state.configuration.SET_COMPONENTS';
    const $cfb81d9b28b5b026$export$33d1af9ce619539e = 'state.configuration.SET_VERSION';
    const $cfb81d9b28b5b026$export$26f77f93871b8908 = 'state.configuration.SET_SPRINT';
    const $cfb81d9b28b5b026$export$6a52175581b4d614 = (payload)=>({
            type: $cfb81d9b28b5b026$export$88d379a4ed7b960a,
            payload: payload
        });
    const $cfb81d9b28b5b026$export$e4826d6ef31827eb = (payload)=>({
            type: $cfb81d9b28b5b026$export$ea5cc78508d1a91f,
            payload: payload
        });
    const $cfb81d9b28b5b026$export$41155fc643823ac5 = (payload)=>({
            type: $cfb81d9b28b5b026$export$eb071a4d80c1cce1,
            payload: payload
        });
    const $cfb81d9b28b5b026$export$f99c3c9c04cda7ae = (payload)=>({
            type: $cfb81d9b28b5b026$export$33d1af9ce619539e,
            payload: payload
        });
    const $cfb81d9b28b5b026$export$cd32ff7d877f176c = (payload)=>({
            type: $cfb81d9b28b5b026$export$26f77f93871b8908,
            payload: payload
        });
    const $cfb81d9b28b5b026$export$9eaf0f2039b438c4 = 'state.configuration.DERIVE_FIELDS_REQUEST';
    const $cfb81d9b28b5b026$export$75d1c1de4eb47530 = ()=>({
            type: $cfb81d9b28b5b026$export$9eaf0f2039b438c4
        });
    const $cfb81d9b28b5b026$export$b386863aaed4e128 = 'state.configuration.SET_DERIVE_FIELDS';
    const $cfb81d9b28b5b026$export$ecb601895f145781 = (payload)=>({
            type: $cfb81d9b28b5b026$export$b386863aaed4e128,
            payload: payload
        });
    const $cfb81d9b28b5b026$export$c09a6e8888fd28fa = 'state.actions.can-user-invite.SET_CAN_USER_INVITE';
    const $cfb81d9b28b5b026$export$c07b821618e68774 = (payload)=>({
            type: $cfb81d9b28b5b026$export$c09a6e8888fd28fa,
            payload: payload
        });
});
parcelRegister("fe0Qy", function(module, exports) {
    $parcel$export(module.exports, "SET_GOALS", ()=>$b7d2eb90132326ee$export$daa9b77b180e2d74);
    $parcel$export(module.exports, "setGoals", ()=>$b7d2eb90132326ee$export$d76a439abd266c57);
    const $b7d2eb90132326ee$export$daa9b77b180e2d74 = 'state.entities.goals.SET_GOALS';
    const $b7d2eb90132326ee$export$d76a439abd266c57 = (payload)=>({
            type: $b7d2eb90132326ee$export$daa9b77b180e2d74,
            payload: payload
        });
});
parcelRegister("4hao7", function(module, exports) {
    $parcel$export(module.exports, "MERGE_STATUS_CATEGORIES", ()=>$bc2f103d4ff995cc$export$e1b89668a4ad1ca0);
    $parcel$export(module.exports, "mergeStatusCategories", ()=>$bc2f103d4ff995cc$export$a7fa16a7a2a0c3c6);
    const $bc2f103d4ff995cc$export$e1b89668a4ad1ca0 = 'state.entities.status-categories.MERGE_STATUS_CATEGORIES';
    const $bc2f103d4ff995cc$export$a7fa16a7a2a0c3c6 = (payload)=>({
            type: $bc2f103d4ff995cc$export$e1b89668a4ad1ca0,
            payload: payload
        });
});
parcelRegister("dCEtc", function(module, exports) {
    $parcel$export(module.exports, "ADD_USERS", ()=>$9a36f3a1fcdb0493$export$9f43e179ecfa3bdc);
    $parcel$export(module.exports, "addUsers", ()=>$9a36f3a1fcdb0493$export$8c4f477b62a4d628);
    const $9a36f3a1fcdb0493$export$9f43e179ecfa3bdc = 'state.entities.users.ADD_USERS';
    const $9a36f3a1fcdb0493$export$8c4f477b62a4d628 = (payload)=>({
            type: $9a36f3a1fcdb0493$export$9f43e179ecfa3bdc,
            payload: payload
        });
});
parcelRegister("lCbUI", function(module, exports) {
    $parcel$export(module.exports, "SET_METADATA", ()=>$cdca324802edd85b$export$eb6efca4aaa03911);
    $parcel$export(module.exports, "setMetadata", ()=>$cdca324802edd85b$export$f8685c902e685023);
    const $cdca324802edd85b$export$eb6efca4aaa03911 = 'state.metadata.SET_METADATA';
    const $cdca324802edd85b$export$f8685c902e685023 = (payload)=>({
            type: $cdca324802edd85b$export$eb6efca4aaa03911,
            payload: payload
        });
});
parcelRegister("iRJhX", function(module, exports) {
    $parcel$export(module.exports, "UPDATE_RESOURCE_CACHE", ()=>$51e433587a62efb6$export$54870d50c480d83);
    $parcel$export(module.exports, "updateResourceCache", ()=>$51e433587a62efb6$export$269d53138aef8ce1);
    const $51e433587a62efb6$export$54870d50c480d83 = 'state.metadata.UPDATE_RESOURCE_CACHE';
    const $51e433587a62efb6$export$269d53138aef8ce1 = (payload)=>({
            type: $51e433587a62efb6$export$54870d50c480d83,
            payload: payload
        });
});
parcelRegister("k6Vft", function(module, exports) {
    $parcel$export(module.exports, "SET_SETTINGS", ()=>$b82ad9bebad1c3a3$export$d0c4639253ab3ec7);
    $parcel$export(module.exports, "setSettings", ()=>$b82ad9bebad1c3a3$export$dc86d17a64679bc7);
    $parcel$export(module.exports, "SET_LIST_WIDTH", ()=>$b82ad9bebad1c3a3$export$39181e9b13b7b1a3);
    $parcel$export(module.exports, "setListWidth", ()=>$b82ad9bebad1c3a3$export$e9fd6c0c57a999a3);
    $parcel$export(module.exports, "SET_CREATION_PREFERENCES", ()=>$b82ad9bebad1c3a3$export$18e0a41e5d9d838e);
    $parcel$export(module.exports, "setCreationPreferences", ()=>$b82ad9bebad1c3a3$export$f2f0354403c25702);
    $parcel$export(module.exports, "UPDATE_CREATION_PREFERENCES", ()=>$b82ad9bebad1c3a3$export$1e29ef5ceeacfed9);
    $parcel$export(module.exports, "updateCreationPreferences", ()=>$b82ad9bebad1c3a3$export$9e8352969ee835d9);
    $parcel$export(module.exports, "SET_HIGHLIGHTED_VERSIONS", ()=>$b82ad9bebad1c3a3$export$9dfe09f4da54827);
    $parcel$export(module.exports, "setHighlightedVersions", ()=>$b82ad9bebad1c3a3$export$c4b191c3a49c947f);
    $parcel$export(module.exports, "SET_ISSUE_PANEL_RATIO", ()=>$b82ad9bebad1c3a3$export$972293701d976b1);
    $parcel$export(module.exports, "setIssuePanelRatio", ()=>$b82ad9bebad1c3a3$export$c51330ff34087218);
    const $b82ad9bebad1c3a3$export$d0c4639253ab3ec7 = 'state.settings.SET_SETTINGS';
    const $b82ad9bebad1c3a3$export$dc86d17a64679bc7 = (payload)=>({
            type: $b82ad9bebad1c3a3$export$d0c4639253ab3ec7,
            payload: payload
        });
    const $b82ad9bebad1c3a3$export$39181e9b13b7b1a3 = 'state.settings.SET_LIST_WIDTH';
    const $b82ad9bebad1c3a3$export$e9fd6c0c57a999a3 = (payload)=>({
            type: $b82ad9bebad1c3a3$export$39181e9b13b7b1a3,
            payload: payload
        });
    const $b82ad9bebad1c3a3$export$18e0a41e5d9d838e = 'state.settings.SET_CREATION_PREFERENCES';
    const $b82ad9bebad1c3a3$export$f2f0354403c25702 = (payload)=>({
            type: $b82ad9bebad1c3a3$export$18e0a41e5d9d838e,
            payload: payload
        });
    const $b82ad9bebad1c3a3$export$1e29ef5ceeacfed9 = 'state.settings.UPDATE_CREATION_PREFERENCES';
    const $b82ad9bebad1c3a3$export$9e8352969ee835d9 = (payload)=>({
            type: $b82ad9bebad1c3a3$export$1e29ef5ceeacfed9,
            payload: payload
        });
    const $b82ad9bebad1c3a3$export$9dfe09f4da54827 = 'state.settings.SET_HIGHLIGHTED_VERSIONS';
    const $b82ad9bebad1c3a3$export$c4b191c3a49c947f = (payload)=>({
            type: $b82ad9bebad1c3a3$export$9dfe09f4da54827,
            payload: payload
        });
    const $b82ad9bebad1c3a3$export$972293701d976b1 = 'state.settings.SET_ISSUE_PANEL_RATIO';
    const $b82ad9bebad1c3a3$export$c51330ff34087218 = (payload)=>({
            type: $b82ad9bebad1c3a3$export$972293701d976b1,
            payload: payload
        });
});
parcelRegister("ifG5J", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1818c4199984b852$export$2e2bcd8739ae039);
    parcelRequire("zjDln");
    parcelRequire("fp4O3");
    parcelRequire("jFVZ1");
    parcelRequire("c66Ur");
    parcelRequire("fPS7b");
    var $aB8eX = parcelRequire("aB8eX");
    var $kVLXA = parcelRequire("kVLXA");
    var $bdwUb;
    var $cmgcJ;
    var $9fPrG;
    var $4gYYI;
    var $hb2iR;
    var $fWch8;
    var $jJEyp;
    var $5TDr4;
    var $1818c4199984b852$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, (0, parcelRequire("jJEyp")).RESOLVE)).mergeMap((action)=>(0, $kVLXA.Observable).concat((0, $kVLXA.Observable).of((0, (0, parcelRequire("jJEyp")).setResolving)(true)), (0, (0, parcelRequire("bdwUb")).default)((0, (0, parcelRequire("4gYYI")).getProjectId)(store.getState()), action.payload.epicName, action.payload.epicDescription, action.payload.issueTypeToPromote).mergeMap(()=>{
                const state = store.getState();
                const query = (0, (0, parcelRequire("fWch8")).getQuery)(state);
                return (0, (0, parcelRequire("cmgcJ")).getCriticalDataObservable)((0, (0, parcelRequire("9fPrG")).getSourceARI)(state), query, undefined).mergeMap((criticalData)=>(0, $kVLXA.Observable).of((0, $aB8eX.batchActions)([
                        ...(0, (0, parcelRequire("5TDr4")).getCriticalDataActions)(criticalData),
                        (0, (0, parcelRequire("jJEyp")).setResolving)(false)
                    ]))).catch(()=>(0, $kVLXA.Observable).of((0, $aB8eX.batchActions)([
                        (0, (0, parcelRequire("hb2iR")).aggError)()
                    ])));
            })));
});
parcelRegister("bdwUb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4a7ac47dd9f5e23d$export$2e2bcd8739ae039);
    var $487fd;
    var $4a7ac47dd9f5e23d$export$2e2bcd8739ae039 = (projectId, epicTypeName, epicTypeDescription, promoteIssueTypeId)=>{
        const options = {
            method: 'POST',
            body: JSON.stringify({
                projectId: projectId,
                epicTypeName: epicTypeName,
                epicTypeDescription: epicTypeDescription,
                promoteIssueTypeId: Number(promoteIssueTypeId)
            })
        };
        return (0, (0, parcelRequire("487fd")).default)('/rest/greenhopper/1.0/roadmap/setup', options);
    };
});
parcelRegister("487fd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$96196282ac54fa24$export$2e2bcd8739ae039);
    var $7uUwQ = parcelRequire("7uUwQ");
    var $kVLXA = parcelRequire("kVLXA");
    parcelRequire("fp4O3");
    parcelRequire("c66Ur");
    parcelRequire("1oQta");
    parcelRequire("d0pqD");
    parcelRequire("fPS7b");
    var $aDvGo;
    var $x9xyg;
    var $fnyT4;
    var $jJZqs;
    var $8KpGl;
    var $51xpa;
    const $96196282ac54fa24$var$noContentStatus = 204;
    const $96196282ac54fa24$var$transformUrl = (url)=>{
        const lUrl = url.replace(/\//g, '_');
        const resUrl = lUrl.substr(0, lUrl.indexOf('?') > -1 ? lUrl.indexOf('?') : lUrl.length);
        return resUrl;
    };
    function $96196282ac54fa24$var$fetchJson$(url, options = {}) {
        const { perf: perf, headersProcessor: headersProcessor, ...opts } = options;
        let key;
        const isPerformanceCheckEnabled = !!perf;
        if (isPerformanceCheckEnabled) {
            const mark = `REST${$96196282ac54fa24$var$transformUrl(url)}`;
            key = perf && `${perf.prefix != null && perf.prefix !== '' ? `${perf.prefix}_` : ''}${perf.key}` || mark;
            (0, (0, parcelRequire("x9xyg")).setMark)(`BEGIN_${key}`);
        }
        return (0, $kVLXA.Observable).of(url).mergeMap(()=>fetch((0, (0, parcelRequire("8KpGl")).getReroutableURL)(url), (0, $7uUwQ.merge)((0, $7uUwQ.merge)((0, (0, parcelRequire("aDvGo")).default), opts), (0, (0, parcelRequire("51xpa")).makeObservabilityHeaders)(url)))).mergeMap((response)=>{
            if (isPerformanceCheckEnabled) (0, (0, parcelRequire("x9xyg")).setMark)(`END_${key}`);
            if (!response.ok) {
                const { status: status } = response;
                return response.text().then((str)=>{
                    const traceId = response.headers.get((0, (0, parcelRequire("fnyT4")).TRACE_ID_HEADER));
                    if (traceId != null && traceId !== '') throw new (0, (0, parcelRequire("jJZqs")).default)(status, str, traceId);
                    else throw new (0, (0, parcelRequire("jJZqs")).default)(status, str);
                });
            }
            if (typeof headersProcessor === 'function') headersProcessor(response.headers);
            if (response.status === $96196282ac54fa24$var$noContentStatus) return (0, $kVLXA.Observable).of(null);
            return response.json();
        });
    }
    var $96196282ac54fa24$export$2e2bcd8739ae039 = $96196282ac54fa24$var$fetchJson$;
});
parcelRegister("lWgs6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9a61462182093ebd$export$2e2bcd8739ae039);
    var $e1AU2 = parcelRequire("e1AU2");
    parcelRequire("fp4O3");
    var $2nKhy;
    var $liZKF;
    var $8gc5t;
    var $1npJo;
    var $9a61462182093ebd$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, (0, parcelRequire("2nKhy")).default), (0, (0, parcelRequire("8gc5t")).default), (0, (0, parcelRequire("liZKF")).default), (0, (0, parcelRequire("1npJo")).default));
});
parcelRegister("2nKhy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bb2d3443b1617bea$export$2e2bcd8739ae039);
    var $aB8eX = parcelRequire("aB8eX");
    parcelRequire("fp4O3");
    parcelRequire("fPS7b");
    var $kVLXA = parcelRequire("kVLXA");
    var $jAJAx;
    var $5TDr4;
    var $bb2d3443b1617bea$export$2e2bcd8739ae039 = (action$)=>action$.ofType((0, (0, parcelRequire("jAJAx")).INITIALIZE_CRITICAL_DATA)).mergeMap((action)=>(0, $kVLXA.Observable).of((0, $aB8eX.batchActions)((0, (0, parcelRequire("5TDr4")).getCriticalDataActions)(action.payload))));
});
parcelRegister("jAJAx", function(module, exports) {
    $parcel$export(module.exports, "INITIALIZE_APP_PROPS", ()=>$1fc4b6e0f20d04e4$export$84856e4ae7cd7538);
    $parcel$export(module.exports, "initializeAppProps", ()=>$1fc4b6e0f20d04e4$export$5f0e35553cecddfe);
    $parcel$export(module.exports, "UPDATE_CRITICAL_DATA", ()=>$1fc4b6e0f20d04e4$export$376502e6007b0f09);
    $parcel$export(module.exports, "updateCriticalData", ()=>$1fc4b6e0f20d04e4$export$4daba2868c495f34);
    $parcel$export(module.exports, "INITIALIZE_CRITICAL_DATA", ()=>$1fc4b6e0f20d04e4$export$2687fde7499d72c0);
    $parcel$export(module.exports, "initializeCriticalData", ()=>$1fc4b6e0f20d04e4$export$f93aa271c9412029);
    $parcel$export(module.exports, "INITIALIZE_NON_CRITICAL_DATA", ()=>$1fc4b6e0f20d04e4$export$2b57a52333b76c0a);
    $parcel$export(module.exports, "initializeNonCriticalData", ()=>$1fc4b6e0f20d04e4$export$ecba41fbc21bbd84);
    const $1fc4b6e0f20d04e4$export$84856e4ae7cd7538 = 'state.app.INITIALIZE_APP_PROPS';
    const $1fc4b6e0f20d04e4$export$5f0e35553cecddfe = (payload)=>({
            type: $1fc4b6e0f20d04e4$export$84856e4ae7cd7538,
            payload: payload
        });
    const $1fc4b6e0f20d04e4$export$376502e6007b0f09 = 'state.app.UPDATE_CRITICAL_DATA';
    const $1fc4b6e0f20d04e4$export$4daba2868c495f34 = (payload)=>({
            type: $1fc4b6e0f20d04e4$export$376502e6007b0f09,
            payload: payload
        });
    const $1fc4b6e0f20d04e4$export$2687fde7499d72c0 = 'state.app.INITIALIZE_CRITICAL_DATA';
    const $1fc4b6e0f20d04e4$export$f93aa271c9412029 = (payload)=>({
            type: $1fc4b6e0f20d04e4$export$2687fde7499d72c0,
            payload: payload
        });
    const $1fc4b6e0f20d04e4$export$2b57a52333b76c0a = 'state.app.INITIALIZE_NON_CRITICAL_DATA';
    const $1fc4b6e0f20d04e4$export$ecba41fbc21bbd84 = ()=>({
            type: $1fc4b6e0f20d04e4$export$2b57a52333b76c0a
        });
});
parcelRegister("liZKF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$28b94a906ae28ae4$export$2e2bcd8739ae039);
    var $gccSB = parcelRequire("gccSB");
    parcelRequire("6hSeW");
    parcelRequire("fPS7b");
    var $kVLXA = parcelRequire("kVLXA");
    var $9fPrG;
    var $50Z4W;
    var $4gYYI;
    var $fWch8;
    var $iET4k;
    var $fvqFq;
    var $28b94a906ae28ae4$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, (0, parcelRequire("50Z4W")).DERIVE_FIELDS_REQUEST)).mergeMap(()=>{
            const state = store.getState();
            const sourceAri = (0, (0, parcelRequire("9fPrG")).getSourceARI)(state);
            if (sourceAri !== undefined) {
                const boardJQL = (0, (0, parcelRequire("4gYYI")).getBoardJql)(state);
                if ((0, (0, parcelRequire("9fPrG")).isClassic)(state)) {
                    const quickFilters = (0, (0, parcelRequire("iET4k")).getFullQuickFilterHash)(state);
                    const validQuickFilterIds = Object.keys(quickFilters);
                    const appliedQuickFilterJQLs = (0, (0, parcelRequire("fWch8")).getQuickFilters)(state).reduce((acc, quickFilterId)=>{
                        if (validQuickFilterIds.indexOf(quickFilterId) > -1) {
                            const quickFilterJQL = quickFilters[quickFilterId]?.query;
                            if (quickFilterJQL !== undefined) acc.push(quickFilterJQL);
                        }
                        return acc;
                    }, []);
                    return (0, ($parcel$interopDefault($gccSB)))(appliedQuickFilterJQLs) ? (0, $kVLXA.Observable).empty() : (0, (0, parcelRequire("fvqFq")).getInitializeDeriveFieldsAction)(sourceAri, [
                        ...boardJQL !== null ? [
                            boardJQL
                        ] : [],
                        ...appliedQuickFilterJQLs
                    ], []);
                }
                const customFilters = (0, (0, parcelRequire("iET4k")).getFullCustomFilterHash)(state);
                const validCustomFilterIds = Object.keys(customFilters);
                const appliedCustomFilterIds = (0, (0, parcelRequire("fWch8")).getCustomFilters)(state).filter((customFilterId)=>validCustomFilterIds.indexOf(customFilterId) > -1);
                return (0, ($parcel$interopDefault($gccSB)))(appliedCustomFilterIds) ? (0, $kVLXA.Observable).empty() : (0, (0, parcelRequire("fvqFq")).getInitializeDeriveFieldsAction)(sourceAri, boardJQL !== null ? [
                    boardJQL
                ] : [], appliedCustomFilterIds);
            }
            return (0, $kVLXA.Observable).empty();
        });
});
parcelRegister("iET4k", function(module, exports) {
    $parcel$export(module.exports, "getFullQuickFilterHash", ()=>$ddda8787260c5eb1$export$4a2a1c7b06b352b0);
    $parcel$export(module.exports, "getFullCustomFilterHash", ()=>$ddda8787260c5eb1$export$a9437088d460ded8);
    $parcel$export(module.exports, "getJQLFilteredIssueIds", ()=>$ddda8787260c5eb1$export$815231ddc49f7ee7);
    $parcel$export(module.exports, "getIsJQLFiltersActive", ()=>$ddda8787260c5eb1$export$f0aa49ab84110c86);
    $parcel$export(module.exports, "getIsJQLFilterLoading", ()=>$ddda8787260c5eb1$export$76eb8b481e5adc40);
    $parcel$export(module.exports, "getFilteredQuickFilterQueries", ()=>$ddda8787260c5eb1$export$c50ba17b114351dc);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $hhYQB;
    var $dlsN4;
    const $ddda8787260c5eb1$export$d01c426cf75c490 = (state)=>state.ui.filter.configuration;
    const $ddda8787260c5eb1$export$4a2a1c7b06b352b0 = (0, $dGvGJ.createSelector)($ddda8787260c5eb1$export$d01c426cf75c490, (filterConfiguration)=>{
        if (filterConfiguration !== undefined) return filterConfiguration.quickFilters;
        return {};
    });
    const $ddda8787260c5eb1$export$a9437088d460ded8 = (0, $dGvGJ.createSelector)($ddda8787260c5eb1$export$d01c426cf75c490, (filterConfiguration)=>{
        if (filterConfiguration !== undefined) return filterConfiguration.customFilters;
        return {};
    });
    const $ddda8787260c5eb1$export$1377c852f579d8c5 = (state, quickFilterId)=>$ddda8787260c5eb1$export$4a2a1c7b06b352b0(state)[quickFilterId];
    const $ddda8787260c5eb1$export$9cfd924149019e5b = (state, customFilterId)=>$ddda8787260c5eb1$export$a9437088d460ded8(state)[customFilterId];
    const $ddda8787260c5eb1$export$815231ddc49f7ee7 = (state)=>state.ui.filter.issueIds;
    const $ddda8787260c5eb1$export$f0aa49ab84110c86 = (state)=>state.ui.filter.isJQLFilterActive;
    const $ddda8787260c5eb1$export$76eb8b481e5adc40 = (state)=>state.ui.filter.isJQLFilterLoading;
    const $ddda8787260c5eb1$export$c50ba17b114351dc = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("hhYQB")).getFilteredQuickFilters), $ddda8787260c5eb1$export$4a2a1c7b06b352b0, (0, (0, parcelRequire("dlsN4")).getFilteredQuickFilterQueriesPure));
});
parcelRegister("dlsN4", function(module, exports) {
    $parcel$export(module.exports, "getFilteredQuickFilterQueriesPure", ()=>$d3fca1735c93d419$export$1a2dbbfdd0122f3f);
    const $d3fca1735c93d419$export$1a2dbbfdd0122f3f = (filteredQuickFilters, quickFilterHash)=>filteredQuickFilters.reduce((queries, quickFilterId)=>{
            const quickFilter = quickFilterHash[quickFilterId];
            if (quickFilter !== undefined) queries.push(quickFilter.query);
            return queries;
        }, []);
});
parcelRegister("fvqFq", function(module, exports) {
    $parcel$export(module.exports, "getInitializeDeriveFieldsAction", ()=>$65c2fc9da7b3a49f$export$4faeceaf3c6757a2);
    var $kVLXA = parcelRequire("kVLXA");
    parcelRequire("6hSeW");
    parcelRequire("d0pqD");
    var $kjAF0;
    var $agt34;
    var $50Z4W;
    const $65c2fc9da7b3a49f$export$4faeceaf3c6757a2 = (sourceAri, jqlContexts, customFilterIds)=>jqlContexts.length === 0 && customFilterIds.length === 0 ? (0, $kVLXA.Observable).empty() : (0, (0, parcelRequire("kjAF0")).getDeriveFields)(sourceAri, jqlContexts, customFilterIds).map((deriveFields)=>{
            const deriveFieldsHash = (0, (0, parcelRequire("agt34")).transformDerivedFieldsHash)(deriveFields);
            return (0, (0, parcelRequire("50Z4W")).setDeriveFieldsHash)(deriveFieldsHash);
        });
});
parcelRegister("kjAF0", function(module, exports) {
    $parcel$export(module.exports, "getDeriveFields", ()=>$460f4a32cb9c5d9d$export$8677adeb17044443);
    parcelRequire("d0pqD");
    parcelRequire("9o0uh");
    var $7fc2g;
    var $iW95S;
    var $8C5lr;
    const $460f4a32cb9c5d9d$var$analyticKey = 'jira.frontend.fe.software.roadmap.derive-fields';
    const $460f4a32cb9c5d9d$var$concurrentMetricDefinition = (0, (0, parcelRequire("8C5lr")).queryMetrics)[0, $8038b72ffd5aa8d4$export$9e57feecc7b4c365];
    const $460f4a32cb9c5d9d$export$8677adeb17044443 = (sourceAri, jqlContexts, customFilterIds)=>(0, (0, parcelRequire("iW95S")).runQueryWithMetadata)((0, (0, parcelRequire("7fc2g")).default), {
            sourceAri: sourceAri,
            jqlContexts: jqlContexts,
            customFilterIds: customFilterIds
        }, $460f4a32cb9c5d9d$var$analyticKey, $460f4a32cb9c5d9d$var$concurrentMetricDefinition).map(({ data: data })=>data.roadmaps?.roadmapDeriveFields?.reduce((acc, deriveField)=>{
                if (deriveField != null) acc.push(deriveField);
                return acc;
            }, []) ?? []).catch(()=>[]);
});
parcelRegister("7fc2g", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6b5465e3f4822c30$export$2e2bcd8739ae039);
    const $6b5465e3f4822c30$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "customFilterIds"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "jqlContexts"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "sourceAri"
        }, v3 = [
            {
                "concreteType": "RoadmapsQuery",
                "kind": "LinkedField",
                "name": "roadmaps",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "customFilterIds",
                                "variableName": "customFilterIds"
                            },
                            {
                                "kind": "Variable",
                                "name": "jqlContexts",
                                "variableName": "jqlContexts"
                            },
                            {
                                "kind": "Variable",
                                "name": "sourceARI",
                                "variableName": "sourceAri"
                            }
                        ],
                        "concreteType": "RoadmapField",
                        "kind": "LinkedField",
                        "name": "roadmapDeriveFields",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "id"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "values"
                            }
                        ]
                    }
                ]
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2
                ],
                "kind": "Fragment",
                "name": "roadmapDeriveFieldsQuery",
                "selections": v3,
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v2,
                    v1,
                    v0
                ],
                "kind": "Operation",
                "name": "roadmapDeriveFieldsQuery",
                "selections": v3
            },
            "params": {
                "id": "01c1afb1671bea65374e5122e7f6071bed18381cc77a55f2fdf2be94c6806bd5",
                "metadata": {},
                "name": "roadmapDeriveFieldsQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $6b5465e3f4822c30$var$node.hash = "5b8a766134f80f9e9cd3532c1bf9cfbd";
    var $6b5465e3f4822c30$export$2e2bcd8739ae039 = $6b5465e3f4822c30$var$node;
});
parcelRegister("8gc5t", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2ebe72e8d3d72534$export$2e2bcd8739ae039);
    parcelRequire("6hSeW");
    parcelRequire("fPS7b");
    parcelRequire("jFVZ1");
    parcelRequire("93e44");
    var $e1AU2 = parcelRequire("e1AU2");
    var $kVLXA = parcelRequire("kVLXA");
    var $kleDs;
    var $iR96x;
    var $hb2iR;
    var $bIcOD;
    var $c6Dtu;
    var $30Pvs;
    const $2ebe72e8d3d72534$var$combineEpicsWithErrorHandling = (...epics)=>{
        const epicsWithErrorHandling = epics.map((epic)=>(0, (0, parcelRequire("kleDs")).default)('nonCriticalRoadmap', 'initializeNonCritical', epic, (error)=>{
                if (error?.skipSentry === true) {
                    const errorWithoutSkipSentry = {
                        ...error,
                        skipSentry: false
                    };
                    (0, (0, parcelRequire("iR96x")).captureException)('common.epic-error.nonCriticalRoadmap.initializeNonCritical', errorWithoutSkipSentry);
                }
                return (0, $kVLXA.Observable).of((0, (0, parcelRequire("hb2iR")).generalError)());
            }));
        return (0, $e1AU2.combineEpics)(...epicsWithErrorHandling);
    };
    var $2ebe72e8d3d72534$export$2e2bcd8739ae039 = $2ebe72e8d3d72534$var$combineEpicsWithErrorHandling((0, (0, parcelRequire("30Pvs")).default), (0, (0, parcelRequire("c6Dtu")).default), (0, (0, parcelRequire("bIcOD")).default));
});
parcelRegister("bIcOD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$de7a2280f1bb9b37$export$2e2bcd8739ae039);
    parcelRequire("6hSeW");
    parcelRequire("fPS7b");
    parcelRequire("jFVZ1");
    parcelRequire("93e44");
    var $kVLXA = parcelRequire("kVLXA");
    var $jAJAx;
    var $50Z4W;
    var $de7a2280f1bb9b37$export$2e2bcd8739ae039 = (action$, _)=>action$.ofType((0, (0, parcelRequire("jAJAx")).INITIALIZE_NON_CRITICAL_DATA)).mergeMap(()=>(0, $kVLXA.Observable).of((0, (0, parcelRequire("50Z4W")).deriveFieldsRequest)()));
});
parcelRegister("c6Dtu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1b4081247cc5cfdb$export$2e2bcd8739ae039);
    parcelRequire("6hSeW");
    parcelRequire("fPS7b");
    parcelRequire("jFVZ1");
    parcelRequire("93e44");
    var $kVLXA = parcelRequire("kVLXA");
    var $arhyO;
    var $jAJAx;
    var $9fPrG;
    var $4gYYI;
    var $fe0Qy;
    var $6thbV;
    const $1b4081247cc5cfdb$var$getInitializeGoalsAction = (sourceAri)=>(0, (0, parcelRequire("arhyO")).getGoals)(sourceAri).map((0, (0, parcelRequire("fe0Qy")).setGoals));
    var $1b4081247cc5cfdb$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, (0, parcelRequire("jAJAx")).INITIALIZE_NON_CRITICAL_DATA)).mergeMap(()=>{
            const state = store.getState();
            const sourceAri = (0, (0, parcelRequire("9fPrG")).getSourceARI)(state);
            const isGoalsFeatureEnabled = (0, (0, parcelRequire("4gYYI")).getIsGoalsFeatureEnabled)(state);
            const isGoalsLoaded = (0, (0, parcelRequire("6thbV")).getIsGoalsLoaded)(state);
            if (isGoalsFeatureEnabled && !isGoalsLoaded) return $1b4081247cc5cfdb$var$getInitializeGoalsAction(sourceAri);
            return (0, $kVLXA.Observable).empty();
        });
});
parcelRegister("30Pvs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5e26d759655faa01$export$2e2bcd8739ae039);
    parcelRequire("6hSeW");
    parcelRequire("fPS7b");
    parcelRequire("jFVZ1");
    parcelRequire("93e44");
    var $kVLXA = parcelRequire("kVLXA");
    var $jAJAx;
    var $9fPrG;
    var $44hJR;
    var $5e26d759655faa01$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, (0, parcelRequire("jAJAx")).INITIALIZE_NON_CRITICAL_DATA)).mergeMap(()=>{
            const state = store.getState();
            let filterConfigAction = (0, $kVLXA.Observable).empty();
            const sourceAri = (0, (0, parcelRequire("9fPrG")).getSourceARI)(state);
            const useQuickFilters = (0, (0, parcelRequire("9fPrG")).shouldUseQuickFilters)(state);
            const useCustomFilters = (0, (0, parcelRequire("9fPrG")).shouldUseCustomFilters)(state);
            if (sourceAri !== undefined) filterConfigAction = (0, (0, parcelRequire("44hJR")).getInitializeFilterConfigurationAction)(sourceAri, useQuickFilters, useCustomFilters);
            return filterConfigAction;
        });
});
parcelRegister("44hJR", function(module, exports) {
    $parcel$export(module.exports, "getInitializeFilterConfigurationAction", ()=>$9b966e7e9d2bd9fc$export$e34f5233e08f98c7);
    var $kVLXA = parcelRequire("kVLXA");
    parcelRequire("6hSeW");
    parcelRequire("d0pqD");
    var $ekMJv;
    var $9QFr0;
    const $9b966e7e9d2bd9fc$var$getConfig = (sourceAri)=>(0, (0, parcelRequire("ekMJv")).getFilterConfiguration)(sourceAri).map((filterConfiguration)=>(0, (0, parcelRequire("9QFr0")).setFilterConfiguration)(filterConfiguration));
    const $9b966e7e9d2bd9fc$export$e34f5233e08f98c7 = (sourceAri, useQuickFilters, useCustomFilters)=>useQuickFilters || useCustomFilters ? $9b966e7e9d2bd9fc$var$getConfig(sourceAri) : (0, $kVLXA.Observable).empty();
});
parcelRegister("ekMJv", function(module, exports) {
    $parcel$export(module.exports, "getFilterConfiguration", ()=>$53fdd18bd5bbd0ee$export$d01c426cf75c490);
    parcelRequire("d0pqD");
    parcelRequire("9o0uh");
    var $edhkg;
    var $1zHL9;
    var $iW95S;
    var $8C5lr;
    var $3DTCN;
    const $53fdd18bd5bbd0ee$var$analyticKey = 'jira.frontend.fe.software.roadmap.filter-configuration';
    const $53fdd18bd5bbd0ee$var$concurrentMetricDefinition = (0, (0, parcelRequire("8C5lr")).queryMetrics)[0, $8038b72ffd5aa8d4$export$bd4cd00ee0750c9a];
    const $53fdd18bd5bbd0ee$export$d01c426cf75c490 = (sourceAri)=>(0, (0, parcelRequire("iW95S")).runQueryWithMetadata)((0, (0, parcelRequire("edhkg")).default), (0, (0, parcelRequire("1zHL9")).generateFilterConfigurationQueryVariables)(sourceAri), $53fdd18bd5bbd0ee$var$analyticKey, $53fdd18bd5bbd0ee$var$concurrentMetricDefinition).map(({ data: data })=>{
            const filterConfig = {
                quickFilters: data.roadmaps?.roadmapFilterConfiguration?.quickFilters ?? [],
                customFilters: data.roadmaps?.roadmapFilterConfiguration?.customFilters ?? []
            };
            return (0, (0, parcelRequire("3DTCN")).transformFilterConfiguration)(filterConfig);
        });
});
parcelRegister("edhkg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c8ff3aa7f1cbcf3b$export$2e2bcd8739ae039);
    const $c8ff3aa7f1cbcf3b$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "sourceAri"
            }
        ], v1 = {
            "kind": "ScalarField",
            "name": "id"
        }, v2 = {
            "kind": "ScalarField",
            "name": "name"
        }, v3 = [
            {
                "concreteType": "RoadmapsQuery",
                "kind": "LinkedField",
                "name": "roadmaps",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "sourceARI",
                                "variableName": "sourceAri"
                            }
                        ],
                        "concreteType": "RoadmapFilterConfiguration",
                        "kind": "LinkedField",
                        "name": "roadmapFilterConfiguration",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "RoadmapQuickFilter",
                                "kind": "LinkedField",
                                "name": "quickFilters",
                                "plural": true,
                                "selections": [
                                    v1,
                                    v2,
                                    {
                                        "kind": "ScalarField",
                                        "name": "query"
                                    }
                                ]
                            },
                            {
                                "concreteType": "RoadmapCustomFilter",
                                "kind": "LinkedField",
                                "name": "customFilters",
                                "plural": true,
                                "selections": [
                                    v1,
                                    v2
                                ]
                            }
                        ]
                    }
                ]
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "roadmapFilterConfigurationQuery",
                "selections": v3,
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "roadmapFilterConfigurationQuery",
                "selections": v3
            },
            "params": {
                "id": "bc6e5f91caa4ea72ba0e0c1b6e9705b161b4143857be506725a8d16a51690270",
                "metadata": {},
                "name": "roadmapFilterConfigurationQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $c8ff3aa7f1cbcf3b$var$node.hash = "83a8710482c6bfc95e5dd7f72a0b0f83";
    var $c8ff3aa7f1cbcf3b$export$2e2bcd8739ae039 = $c8ff3aa7f1cbcf3b$var$node;
});
parcelRegister("1zHL9", function(module, exports) {
    $parcel$export(module.exports, "generateFilterConfigurationQueryVariables", ()=>$4fc018b49e5d071a$export$b527eee0f75a4247);
    const $4fc018b49e5d071a$export$b527eee0f75a4247 = (sourceAri)=>({
            sourceAri: sourceAri
        });
});
parcelRegister("3DTCN", function(module, exports) {
    $parcel$export(module.exports, "transformFilterConfiguration", ()=>$7d577c3a33885f41$export$c699535cb8d8f356);
    const $7d577c3a33885f41$var$transformQuickFilters = (quickFilters)=>quickFilters.reduce((acc, quickFilter, position)=>{
            acc[quickFilter.id] = {
                id: quickFilter.id,
                name: quickFilter.name,
                query: quickFilter.query,
                position: position
            };
            return acc;
        }, {});
    const $7d577c3a33885f41$var$transformCustomFilters = (customFilters)=>customFilters.reduce((acc, customFilter)=>{
            acc[customFilter.id] = {
                id: customFilter.id,
                name: customFilter.name
            };
            return acc;
        }, {});
    const $7d577c3a33885f41$export$c699535cb8d8f356 = (filterConfig)=>({
            quickFilters: $7d577c3a33885f41$var$transformQuickFilters(filterConfig.quickFilters),
            customFilters: $7d577c3a33885f41$var$transformCustomFilters(filterConfig.customFilters)
        });
});
parcelRegister("1npJo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7f4e5d00d98da92c$export$2e2bcd8739ae039);
    var $aB8eX = parcelRequire("aB8eX");
    parcelRequire("fp4O3");
    parcelRequire("fPS7b");
    var $kVLXA = parcelRequire("kVLXA");
    var $jAJAx;
    var $5TDr4;
    var $7f4e5d00d98da92c$export$2e2bcd8739ae039 = (action$)=>action$.ofType((0, (0, parcelRequire("jAJAx")).UPDATE_CRITICAL_DATA)).mergeMap((action)=>(0, $kVLXA.Observable).of((0, $aB8eX.batchActions)((0, (0, parcelRequire("5TDr4")).getCriticalDataActions)(action.payload))));
});
parcelRegister("jSCJZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$23b8c8233dbe34a7$export$2e2bcd8739ae039);
    var $e1AU2 = parcelRequire("e1AU2");
    var $e5wyW;
    var $4R6GH;
    var $fmAtv;
    var $b4xl6;
    var $2M4Eg;
    var $kFNcb;
    var $5U9gn;
    var $7n3n2;
    var $ibyhg;
    var $7YTcO;
    var $dRohj;
    var $iT7Wh;
    var $l5RsA;
    var $fvAKx;
    var $3HYXd;
    var $kGYAX;
    var $ltPjz;
    var $hb4jS;
    var $4ybzM;
    const $23b8c8233dbe34a7$var$issuesEpicsOld = ()=>(0, $e1AU2.combineEpics)((0, (0, parcelRequire("2M4Eg")).default), (0, (0, parcelRequire("kFNcb")).default), (0, (0, parcelRequire("7n3n2")).default), (0, (0, parcelRequire("7YTcO")).default), (0, (0, parcelRequire("ltPjz")).select), (0, (0, parcelRequire("ltPjz")).multiselect), (0, (0, parcelRequire("ltPjz")).default), (0, (0, parcelRequire("4ybzM")).default), (0, (0, parcelRequire("hb4jS")).default), (0, (0, parcelRequire("3HYXd")).default), (0, (0, parcelRequire("l5RsA")).default), (0, (0, parcelRequire("fmAtv")).default), (0, (0, parcelRequire("5U9gn")).default), (0, (0, parcelRequire("fvAKx")).default), (0, (0, parcelRequire("iT7Wh")).default), (0, (0, parcelRequire("kGYAX")).default), (0, (0, parcelRequire("b4xl6")).default), (0, (0, parcelRequire("ibyhg")).default));
    const $23b8c8233dbe34a7$var$issuesEpicsNew = ()=>(0, $e1AU2.combineEpics)((0, (0, parcelRequire("2M4Eg")).default), (0, (0, parcelRequire("kFNcb")).default), (0, (0, parcelRequire("7n3n2")).default), (0, (0, parcelRequire("7YTcO")).default), (0, (0, parcelRequire("dRohj")).default), (0, (0, parcelRequire("ltPjz")).select), (0, (0, parcelRequire("ltPjz")).multiselect), (0, (0, parcelRequire("ltPjz")).default), (0, (0, parcelRequire("4ybzM")).default), (0, (0, parcelRequire("hb4jS")).default), (0, (0, parcelRequire("3HYXd")).default), (0, (0, parcelRequire("l5RsA")).default), (0, (0, parcelRequire("fmAtv")).default), (0, (0, parcelRequire("5U9gn")).default), (0, (0, parcelRequire("fvAKx")).default), (0, (0, parcelRequire("iT7Wh")).default), (0, (0, parcelRequire("kGYAX")).default), (0, (0, parcelRequire("b4xl6")).default), (0, (0, parcelRequire("ibyhg")).default));
    var $23b8c8233dbe34a7$export$2e2bcd8739ae039 = (0, (0, parcelRequire("e5wyW")).functionWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('jsw-roadmap-state-change-based-issue-hidden-flags'), $23b8c8233dbe34a7$var$issuesEpicsNew(), $23b8c8233dbe34a7$var$issuesEpicsOld());
});
parcelRegister("fmAtv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$98af1e233abfb6b4$export$2e2bcd8739ae039);
    parcelRequire("fp4O3");
    parcelRequire("fPS7b");
    var $kVLXA = parcelRequire("kVLXA");
    var $9fPrG;
    var $4gYYI;
    var $1VLi2;
    var $hb2iR;
    var $98af1e233abfb6b4$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, (0, parcelRequire("1VLi2")).ATTEMPT_RANK_ISSUE)).mergeMap((action)=>{
            const state = store.getState();
            if ((0, (0, parcelRequire("4gYYI")).rankIssuesSupported)(state)) return (0, $kVLXA.Observable).of((0, (0, parcelRequire("1VLi2")).rankIssue)(action.payload, action.meta.analyticsEvent));
            return (0, $kVLXA.Observable).of((0, (0, parcelRequire("hb2iR")).unableToRankIssue)({
                boardId: (0, (0, parcelRequire("9fPrG")).getBoardId)(state)
            }));
        });
});
parcelRegister("b4xl6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c4fb0b543d6bf3e3$export$2e2bcd8739ae039);
    parcelRequire("fp4O3");
    parcelRequire("fPS7b");
    var $kVLXA = parcelRequire("kVLXA");
    var $1VLi2;
    var $bDdHs;
    var $4LbSm;
    var $c4fb0b543d6bf3e3$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, (0, parcelRequire("1VLi2")).ATTEMPT_REMOVE_ISSUE)).mergeMap((action)=>{
            const state = store.getState();
            const issueId = action.payload;
            const subtaskParent = (0, (0, parcelRequire("4LbSm")).getSubtaskParentHash)(state)[issueId];
            if (subtaskParent !== undefined) return (0, $kVLXA.Observable).of((0, (0, parcelRequire("bDdHs")).removeSubtasks)([
                {
                    id: issueId,
                    parentId: subtaskParent
                }
            ]));
            return (0, $kVLXA.Observable).of((0, (0, parcelRequire("1VLi2")).removeIssue)(issueId));
        });
});
parcelRegister("bDdHs", function(module, exports) {
    $parcel$export(module.exports, "EXTEND_SUBTASKS", ()=>$67f7eafd7428a2ad$export$d3662084139e9a0d);
    $parcel$export(module.exports, "extendSubtasks", ()=>$67f7eafd7428a2ad$export$816acc63178ce4a8);
    $parcel$export(module.exports, "ADD_SUBTASK", ()=>$67f7eafd7428a2ad$export$b9900d3419a32a0c);
    $parcel$export(module.exports, "addSubtask", ()=>$67f7eafd7428a2ad$export$bcf961302100908a);
    $parcel$export(module.exports, "REMOVE_SUBTASKS", ()=>$67f7eafd7428a2ad$export$446c994baf375781);
    $parcel$export(module.exports, "removeSubtasks", ()=>$67f7eafd7428a2ad$export$2ca9bbaf7e1f372c);
    $parcel$export(module.exports, "UPDATE_SUBTASK_STATUS", ()=>$67f7eafd7428a2ad$export$cc155d4209942051);
    $parcel$export(module.exports, "updateSubtaskStatus", ()=>$67f7eafd7428a2ad$export$1a29221067edde72);
    $parcel$export(module.exports, "CHANGE_SUBTASK_PARENT", ()=>$67f7eafd7428a2ad$export$8f84542de7233e3f);
    $parcel$export(module.exports, "changeSubtaskParent", ()=>$67f7eafd7428a2ad$export$6e9bf93d0d5ca735);
    const $67f7eafd7428a2ad$export$d3662084139e9a0d = 'state.entities.subtasks.EXTEND_SUBTASKS';
    const $67f7eafd7428a2ad$export$816acc63178ce4a8 = (payload)=>({
            type: $67f7eafd7428a2ad$export$d3662084139e9a0d,
            payload: payload
        });
    const $67f7eafd7428a2ad$export$b9900d3419a32a0c = 'state.entities.subtasks.ADD_SUBTASK';
    const $67f7eafd7428a2ad$export$bcf961302100908a = (payload)=>({
            type: $67f7eafd7428a2ad$export$b9900d3419a32a0c,
            payload: payload
        });
    const $67f7eafd7428a2ad$export$446c994baf375781 = 'state.entities.subtasks.REMOVE_SUBTASKS';
    const $67f7eafd7428a2ad$export$2ca9bbaf7e1f372c = (payload)=>({
            type: $67f7eafd7428a2ad$export$446c994baf375781,
            payload: payload
        });
    const $67f7eafd7428a2ad$export$cc155d4209942051 = 'state.entities.subtasks.UPDATE_SUBTASK_STATUS';
    const $67f7eafd7428a2ad$export$1a29221067edde72 = (payload)=>({
            type: $67f7eafd7428a2ad$export$cc155d4209942051,
            payload: payload
        });
    const $67f7eafd7428a2ad$export$8f84542de7233e3f = 'state.entities.subtasks.CHANGE_SUBTASK_PARENT';
    const $67f7eafd7428a2ad$export$6e9bf93d0d5ca735 = (payload)=>({
            type: $67f7eafd7428a2ad$export$8f84542de7233e3f,
            payload: payload
        });
});
parcelRegister("2M4Eg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$47086e3a98355077$export$2e2bcd8739ae039);
    parcelRequire("d0pqD");
    parcelRequire("fPS7b");
    var $a2O8k;
    var $jJEyp;
    var $47086e3a98355077$export$2e2bcd8739ae039 = (action$)=>action$.ofType((0, (0, parcelRequire("jJEyp")).RETRIEVE_ISSUE_TYPE_COUNT)).mergeMap((action)=>{
            const { issueTypeId: issueTypeId, projectId: projectId } = action.payload;
            return (0, (0, parcelRequire("a2O8k")).default)(projectId, issueTypeId).map((issueCount)=>{
                const newCounts = {};
                newCounts[issueTypeId] = issueCount;
                return (0, (0, parcelRequire("jJEyp")).extendIssueTypeCount)(newCounts);
            });
        });
});
parcelRegister("a2O8k", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$921e80356c27bdf9$export$2e2bcd8739ae039);
    parcelRequire("d0pqD");
    var $487fd;
    const $921e80356c27bdf9$var$getJqlForCount = (projectId, issueTypeId)=>`project = ${projectId} AND issuetype = ${issueTypeId}`;
    var $921e80356c27bdf9$export$2e2bcd8739ae039 = (projectId, issueTypeId)=>{
        const options = {
            method: 'POST',
            body: JSON.stringify({
                jql: $921e80356c27bdf9$var$getJqlForCount(projectId, issueTypeId),
                fields: [],
                expand: []
            })
        };
        return (0, (0, parcelRequire("487fd")).default)('/rest/api/2/search', options).map((result)=>result.total);
    };
});
parcelRegister("kFNcb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f5d2954ea2130666$export$2e2bcd8739ae039);
    parcelRequire("fPS7b");
    var $hGgHi = parcelRequire("hGgHi");
    var $4gYYI;
    var $1VLi2;
    var $hhYQB;
    var $bM42j;
    var $dpykG;
    var $ibwkC;
    var $6goAf;
    const $f5d2954ea2130666$export$c70950e65a75fd8a = (field)=>{
        if (!(0, ($parcel$interopDefault($hGgHi)))(field)) {
            if (Array.isArray(field) && field.length > 0) return true;
            const fieldType = typeof field;
            if (fieldType === 'boolean' || fieldType === 'number') return true;
            if (fieldType === 'string') return field.length > 0;
            if (typeof field === 'object') return $f5d2954ea2130666$export$c70950e65a75fd8a(field.value);
        }
        return false;
    };
    var $f5d2954ea2130666$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, (0, parcelRequire("1VLi2")).CREATE_ISSUE)).mergeMap((action)=>{
            const state = store.getState();
            const createItemAnchor = (0, (0, parcelRequire("bM42j")).getCreateItemAnchor)(state);
            if (createItemAnchor === undefined) throw new Error('Cannot create an issue without an anchor (anchor was undefined)');
            const { summary: summary, issueTypeId: issueTypeId } = action.payload;
            const parentId = 'parentId' in createItemAnchor && createItemAnchor.parentId ? createItemAnchor.parentId : undefined;
            const { assignees: assignees, labels: labels, versions: versions, components: components } = (0, (0, parcelRequire("hhYQB")).getIssuesFilter)(state);
            const filteredAssignees = assignees.filter((assignee)=>assignee !== (0, $15a528573ccd89ae$export$12e572fd459c10dc));
            const assignee = filteredAssignees[filteredAssignees.length - 1];
            const filteredVersions = versions.filter((version)=>version !== (0, $15a528573ccd89ae$export$ac95b4b2317d4b33));
            const filteredLabels = labels.filter((label)=>label !== (0, $15a528573ccd89ae$export$81ef49afbbead0a1));
            const filteredComponents = components.filter((component)=>component !== (0, $15a528573ccd89ae$export$4b7c755e61199a36));
            const requiredFields = (0, (0, parcelRequire("4gYYI")).getRequiredFieldsByIssueTypeId)(state, issueTypeId);
            const derivedFieldsHash = (0, (0, parcelRequire("4gYYI")).getFullDerivedFields)(state);
            const sprintCFId = (0, (0, parcelRequire("4gYYI")).getSprintCustomFieldId)(state);
            const optimisticIssue = (0, (0, parcelRequire("ibwkC")).mergeIssueContexts)((0, (0, parcelRequire("ibwkC")).derivedFieldsToIssueContext)(derivedFieldsHash, sprintCFId), {
                summary: {
                    value: summary
                },
                assignee: assignee,
                issueTypeId: issueTypeId,
                parentId: {
                    value: parentId
                },
                labels: filteredLabels,
                versionIds: filteredVersions,
                componentIds: filteredComponents
            });
            if (requiredFields.some((requiredField)=>!$f5d2954ea2130666$export$c70950e65a75fd8a(optimisticIssue[requiredField]) && !$f5d2954ea2130666$export$c70950e65a75fd8a(derivedFieldsHash[requiredField]))) return (0, (0, parcelRequire("6goAf")).default)(store, action, optimisticIssue);
            return (0, (0, parcelRequire("dpykG")).default)(store, action, optimisticIssue, createItemAnchor);
        });
});
parcelRegister("bM42j", function(module, exports) {
    $parcel$export(module.exports, "getCreateItemAnchor", ()=>$d43cefc44c24636d$export$136936d41252875f);
    $parcel$export(module.exports, "getExpandedItems", ()=>$d43cefc44c24636d$export$b38bc92ef8b87c5c);
    $parcel$export(module.exports, "getSelectedItemIds", ()=>$d43cefc44c24636d$export$e9f0552305c19203);
    $parcel$export(module.exports, "getSelectionAnchors", ()=>$d43cefc44c24636d$export$3c56d171cade2f38);
    $parcel$export(module.exports, "getTooltipParams", ()=>$d43cefc44c24636d$export$27834ee3c7180cde);
    $parcel$export(module.exports, "getActiveItemRef", ()=>$d43cefc44c24636d$export$a3426785fc1e0d8c);
    const $d43cefc44c24636d$export$136936d41252875f = (state)=>state.ui.table.createItemAnchor;
    const $d43cefc44c24636d$export$b38bc92ef8b87c5c = (state)=>state.ui.table.expandedItems;
    const $d43cefc44c24636d$export$e9f0552305c19203 = (state)=>state.ui.table.selectedItemIds;
    const $d43cefc44c24636d$export$3c56d171cade2f38 = (state)=>state.ui.table.selectionAnchors;
    const $d43cefc44c24636d$export$27834ee3c7180cde = (state)=>state.ui.table.tooltip;
    const $d43cefc44c24636d$export$a3426785fc1e0d8c = (state)=>state.ui.table.activeItemRef;
});
parcelRegister("dpykG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a43b5140bcdc7deb$export$2e2bcd8739ae039);
    parcelRequire("jFVZ1");
    parcelRequire("fp4O3");
    parcelRequire("d0pqD");
    parcelRequire("c66Ur");
    parcelRequire("fPS7b");
    var $aB8eX = parcelRequire("aB8eX");
    var $kVLXA = parcelRequire("kVLXA");
    var $7Jxgt = parcelRequire("7Jxgt");
    var $4R6GH;
    var $joGLY;
    var $7YAuW;
    var $lpZMC;
    var $9fPrG;
    var $4gYYI;
    var $gsBJe;
    var $1VLi2;
    var $hb2iR;
    var $fWch8;
    var $hhYQB;
    var $k6Vft;
    var $9QFr0;
    var $iET4k;
    var $lEiof;
    var $bFYz9;
    var $6AwHs;
    var $hEJMC;
    var $8ehfB;
    var $cjHBk;
    const $a43b5140bcdc7deb$var$getPostCreateActions = (state, temporaryId, { id: id, key: key, issue: issue, matchesSource: matchesSource, matchesJqlFilters: matchesJqlFilters }, skipQuickFilters)=>{
        const actions = [];
        if (matchesSource && issue !== undefined) {
            actions.push((0, (0, parcelRequire("1VLi2")).replaceIssue)({
                temporaryId: temporaryId,
                id: id,
                issue: issue
            }, (0, (0, parcelRequire("1VLi2")).CREATE_ISSUE)));
            if (!(0, (0, parcelRequire("4R6GH")).fg)('jsw-roadmap-state-change-based-issue-hidden-flags')) {
                const { isHiddenByFilter: isHiddenByFilter } = (0, (0, parcelRequire("6AwHs")).getIsIssueHiddenByFiltersOrSettings)(state, issue, id, skipQuickFilters);
                const isHidden = isHiddenByFilter || !matchesJqlFilters;
                if (isHidden) actions.push((0, (0, parcelRequire("hb2iR")).issueHidden)({
                    ids: [
                        id
                    ]
                }));
            }
            if (matchesJqlFilters) {
                const currentlyVisibleIssueIds = (0, (0, parcelRequire("iET4k")).getJQLFilteredIssueIds)(state);
                if ((0, (0, parcelRequire("fWch8")).getQueryContainsJQLFilters)(state)) actions.push((0, (0, parcelRequire("9QFr0")).jqlFiltersSuccess)([
                    ...currentlyVisibleIssueIds,
                    id
                ]));
            }
        } else {
            if (!key) throw new Error('Cannot remove issue without a key (key was undefined)');
            actions.push((0, (0, parcelRequire("1VLi2")).removeIssue)(temporaryId), (0, (0, parcelRequire("hb2iR")).irrelevantIssuesCreated)({
                issueKeys: [
                    key
                ]
            }));
        }
        return (0, $aB8eX.batchActions)(actions);
    };
    const $a43b5140bcdc7deb$var$getCreateErrorActions = (temporaryId, aggErrorAction)=>(0, $aB8eX.batchActions)([
            aggErrorAction ?? (0, (0, parcelRequire("hb2iR")).aggError)(),
            (0, (0, parcelRequire("1VLi2")).removeIssue)(temporaryId),
            (0, (0, parcelRequire("lEiof")).resetCreateItemAnchor)()
        ]);
    const $a43b5140bcdc7deb$var$createOnBackend = (store, temporaryId, optimisticIssue, createItemAnchor, analyticsEvent)=>{
        const state = store.getState();
        const { issueTypeId: issueTypeId } = optimisticIssue;
        const projectId = (0, (0, parcelRequire("4gYYI")).getProjectId)(state);
        const sourceARI = (0, (0, parcelRequire("9fPrG")).getSourceARI)(state);
        const jql = (0, (0, parcelRequire("4gYYI")).getBoardJql)(state);
        let jqlContexts = [];
        if ((0, (0, parcelRequire("9fPrG")).isClassic)(state)) jqlContexts = (0, (0, parcelRequire("iET4k")).getFilteredQuickFilterQueries)(state);
        else if (!(0, (0, parcelRequire("9fPrG")).isClassic)(state)) jqlContexts = (0, (0, parcelRequire("hhYQB")).getFilteredCustomFilters)(state);
        return (0, (0, parcelRequire("hEJMC")).getSafeRankBeforeRequest)(state, createItemAnchor !== undefined && 'beforeId' in createItemAnchor && createItemAnchor.beforeId !== undefined ? createItemAnchor.beforeId : undefined).mergeMap((rankRequest)=>(0, (0, parcelRequire("7YAuW")).create)({
                sourceARI: sourceARI,
                input: {
                    projectId: projectId,
                    itemTypeId: issueTypeId,
                    parentId: optimisticIssue.parentId.value,
                    summary: optimisticIssue.summary.value,
                    dueDate: null,
                    startDate: null,
                    color: optimisticIssue.color.value,
                    rank: rankRequest ? {
                        beforeId: String(rankRequest.beforeId)
                    } : undefined,
                    jql: jql,
                    jqlContexts: jqlContexts,
                    assignee: optimisticIssue.assignee,
                    labels: optimisticIssue.labels.length > 0 ? optimisticIssue.labels : undefined,
                    componentIds: optimisticIssue.componentIds.length > 0 ? optimisticIssue.componentIds : undefined,
                    versionIds: optimisticIssue.versionIds.length > 0 ? optimisticIssue.versionIds : undefined
                }
            })).mergeMap((data)=>{
            const addRoadmapItemPayload = data?.roadmaps?.addRoadmapItem;
            const addRoadmapItemOutput = data?.roadmaps?.addRoadmapItem?.output;
            if (addRoadmapItemPayload?.success === true && addRoadmapItemOutput) {
                const { id: id, key: key, matchesSource: matchesSource, matchesJqlFilters: matchesJqlFilters, item: item } = addRoadmapItemOutput;
                const safeState = store.getState();
                const createIssue = {
                    id: id,
                    parentId: optimisticIssue.parentId.value,
                    issueTypeId: issueTypeId,
                    key: key,
                    issue: item ? (0, (0, parcelRequire("lpZMC")).transformIssue)(item) : undefined,
                    matchesSource: matchesSource,
                    matchesJqlFilters: matchesJqlFilters ?? true
                };
                (0, (0, parcelRequire("cjHBk")).performPostCreateSideEffects)(safeState, temporaryId, createIssue, analyticsEvent);
                const skipQuickFilters = matchesJqlFilters ?? true;
                return (0, $kVLXA.Observable).of($a43b5140bcdc7deb$var$getPostCreateActions(safeState, temporaryId, createIssue, skipQuickFilters));
            }
            const errorMessage = (0, (0, parcelRequire("8ehfB")).getGICReasonOnCreateError)(addRoadmapItemPayload?.errors);
            if (errorMessage) return (0, $kVLXA.Observable).of((0, $aB8eX.batchActions)([
                (0, (0, parcelRequire("1VLi2")).removeIssue)(temporaryId),
                (0, (0, parcelRequire("gsBJe")).addPayloadGlobalIssueCreate)((0, (0, parcelRequire("8ehfB")).getFieldsForCreateDialogGIC)(state, optimisticIssue, errorMessage)),
                (0, (0, parcelRequire("k6Vft")).updateCreationPreferences)({
                    itemTypeId: issueTypeId,
                    level: optimisticIssue.parentId.value ? (0, (0, parcelRequire("joGLY")).BASE_LEVEL) : (0, (0, parcelRequire("joGLY")).PARENT_LEVEL),
                    projectId: projectId
                }),
                (0, (0, parcelRequire("lEiof")).resetCreateItemAnchor)()
            ]));
            return (0, (0, parcelRequire("bFYz9")).onHandleAggErrors)(!!addRoadmapItemPayload, addRoadmapItemPayload?.errors).map((aggErrorAction)=>$a43b5140bcdc7deb$var$getCreateErrorActions(temporaryId, aggErrorAction));
        }).catch(()=>(0, $kVLXA.Observable).of($a43b5140bcdc7deb$var$getCreateErrorActions(temporaryId)));
    };
    const $a43b5140bcdc7deb$var$inlineCreate = (store, { payload: { level: level }, meta: meta }, optimisticIssue, createItemAnchor)=>{
        const projectId = (0, (0, parcelRequire("4gYYI")).getProjectId)(store.getState());
        const { issueTypeId: issueTypeId } = optimisticIssue;
        const temporaryId = (0, ($parcel$interopDefault($7Jxgt))).v4();
        const optimisticActions = [
            (0, (0, parcelRequire("k6Vft")).updateCreationPreferences)({
                itemTypeId: issueTypeId,
                level: level,
                projectId: projectId
            }),
            (0, (0, parcelRequire("1VLi2")).insertIssue)({
                id: temporaryId,
                issue: optimisticIssue,
                anchor: createItemAnchor
            })
        ];
        if (meta.resetCreateItemAnchor) optimisticActions.push((0, (0, parcelRequire("lEiof")).resetCreateItemAnchor)());
        return (0, $kVLXA.Observable).concat((0, $kVLXA.Observable).of((0, $aB8eX.batchActions)(optimisticActions)), $a43b5140bcdc7deb$var$createOnBackend(store, temporaryId, optimisticIssue, createItemAnchor, meta.analyticsEvent));
    };
    var $a43b5140bcdc7deb$export$2e2bcd8739ae039 = $a43b5140bcdc7deb$var$inlineCreate;
});
parcelRegister("7YAuW", function(module, exports) {
    $parcel$export(module.exports, "create", ()=>$bb37eecf78c82ed1$export$185802fd694ee1f5);
    var $07sDG;
    parcelRequire("fp4O3");
    parcelRequire("fPS7b");
    var $f9Owr;
    var $lQmZK;
    var $8C5lr;
    const $bb37eecf78c82ed1$var$concurrentMetricDefinition = (0, (0, parcelRequire("8C5lr")).mutationMetrics)[0, $8038b72ffd5aa8d4$export$2afae5ee414caffb];
    const $bb37eecf78c82ed1$var$analyticKey = 'jira.frontend.fe.software.roadmap.persist-issue';
    const $bb37eecf78c82ed1$var$mutationName = 'addRoadmapItem';
    const $bb37eecf78c82ed1$export$185802fd694ee1f5 = ({ sourceARI: sourceARI, input: input })=>(0, (0, parcelRequire("lQmZK")).runMutation)($bb37eecf78c82ed1$var$mutationName, (0, (0, parcelRequire("07sDG")).default), {
            sourceARI: sourceARI,
            input: input,
            isRoadmapsCriticalDataItemFlaggedEnabled: (0, (0, parcelRequire("f9Owr")).ff)('jsw.timeline.return-flagged-attribute-fe')
        }, $bb37eecf78c82ed1$var$analyticKey, $bb37eecf78c82ed1$var$concurrentMetricDefinition);
});
parcelRegister("07sDG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$52684c8bd5f8d266$export$2e2bcd8739ae039);
    const $52684c8bd5f8d266$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isRoadmapsCriticalDataItemFlaggedEnabled"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "sourceARI"
        }, v3 = [
            {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
            },
            {
                "kind": "Variable",
                "name": "sourceARI",
                "variableName": "sourceARI"
            }
        ], v4 = {
            "kind": "ScalarField",
            "name": "success"
        }, v5 = {
            "kind": "ScalarField",
            "name": "message"
        }, v6 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "statusCode"
                },
                {
                    "kind": "ScalarField",
                    "name": "errorType"
                }
            ],
            "type": "RoadmapMutationErrorExtension"
        }, v7 = {
            "kind": "ScalarField",
            "name": "id"
        }, v8 = {
            "kind": "ScalarField",
            "name": "key"
        }, v9 = {
            "kind": "ScalarField",
            "name": "matchesSource"
        }, v10 = {
            "kind": "ScalarField",
            "name": "matchesJqlFilters"
        }, v11 = {
            "kind": "ScalarField",
            "name": "parentId"
        }, v12 = {
            "kind": "ScalarField",
            "name": "summary"
        }, v13 = {
            "kind": "ScalarField",
            "name": "startDateRFC3339"
        }, v14 = {
            "kind": "ScalarField",
            "name": "dueDateRFC3339"
        }, v15 = {
            "kind": "ScalarField",
            "name": "color"
        }, v16 = {
            "kind": "ScalarField",
            "name": "dependencies"
        }, v17 = {
            "kind": "ScalarField",
            "name": "itemTypeId"
        }, v18 = {
            "kind": "ScalarField",
            "name": "accountId"
        }, v19 = {
            "kind": "ScalarField",
            "name": "name"
        }, v20 = {
            "kind": "ScalarField",
            "name": "picture"
        }, v21 = [
            v7
        ], v22 = {
            "concreteType": "RoadmapItemStatus",
            "kind": "LinkedField",
            "name": "status",
            "plural": false,
            "selections": [
                v7,
                v19,
                {
                    "concreteType": "RoadmapItemStatusCategory",
                    "kind": "LinkedField",
                    "name": "statusCategory",
                    "plural": false,
                    "selections": v21
                }
            ]
        }, v23 = {
            "kind": "ScalarField",
            "name": "rank"
        }, v24 = {
            "kind": "ScalarField",
            "name": "labels"
        }, v25 = {
            "kind": "ScalarField",
            "name": "sprintIds"
        }, v26 = {
            "kind": "ScalarField",
            "name": "versionIds"
        }, v27 = {
            "kind": "ScalarField",
            "name": "componentIds"
        }, v28 = {
            "kind": "ScalarField",
            "name": "resolved"
        }, v29 = {
            "condition": "isRoadmapsCriticalDataItemFlaggedEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "flagged"
                }
            ]
        }, v30 = {
            "kind": "ScalarField",
            "name": "__typename"
        };
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2
                ],
                "kind": "Fragment",
                "name": "addRoadmapItemMutation",
                "selections": [
                    {
                        "concreteType": "RoadmapsMutation",
                        "kind": "LinkedField",
                        "name": "roadmaps",
                        "plural": false,
                        "selections": [
                            {
                                "args": v3,
                                "concreteType": "RoadmapAddItemPayload",
                                "kind": "LinkedField",
                                "name": "addRoadmapItem",
                                "plural": false,
                                "selections": [
                                    v4,
                                    {
                                        "concreteType": "MutationError",
                                        "kind": "LinkedField",
                                        "name": "errors",
                                        "plural": true,
                                        "selections": [
                                            v5,
                                            {
                                                "kind": "LinkedField",
                                                "name": "extensions",
                                                "plural": false,
                                                "selections": [
                                                    v6
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "RoadmapAddItemResponse",
                                        "kind": "LinkedField",
                                        "name": "output",
                                        "plural": false,
                                        "selections": [
                                            v7,
                                            v8,
                                            v9,
                                            v10,
                                            {
                                                "concreteType": "RoadmapItem",
                                                "kind": "LinkedField",
                                                "name": "item",
                                                "plural": false,
                                                "selections": [
                                                    v7,
                                                    v8,
                                                    v11,
                                                    v12,
                                                    v13,
                                                    v14,
                                                    v15,
                                                    v16,
                                                    v17,
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "assignee",
                                                        "plural": false,
                                                        "selections": [
                                                            v18,
                                                            v19,
                                                            v20
                                                        ]
                                                    },
                                                    v22,
                                                    v23,
                                                    v24,
                                                    v25,
                                                    v26,
                                                    v27,
                                                    v28,
                                                    v29
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "Mutation"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v2,
                    v0,
                    v1
                ],
                "kind": "Operation",
                "name": "addRoadmapItemMutation",
                "selections": [
                    {
                        "concreteType": "RoadmapsMutation",
                        "kind": "LinkedField",
                        "name": "roadmaps",
                        "plural": false,
                        "selections": [
                            {
                                "args": v3,
                                "concreteType": "RoadmapAddItemPayload",
                                "kind": "LinkedField",
                                "name": "addRoadmapItem",
                                "plural": false,
                                "selections": [
                                    v4,
                                    {
                                        "concreteType": "MutationError",
                                        "kind": "LinkedField",
                                        "name": "errors",
                                        "plural": true,
                                        "selections": [
                                            v5,
                                            {
                                                "kind": "LinkedField",
                                                "name": "extensions",
                                                "plural": false,
                                                "selections": [
                                                    v30,
                                                    v6,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": v21,
                                                        "type": "BulkMutationErrorExtension"
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "RoadmapAddItemResponse",
                                        "kind": "LinkedField",
                                        "name": "output",
                                        "plural": false,
                                        "selections": [
                                            v7,
                                            v8,
                                            v9,
                                            v10,
                                            {
                                                "concreteType": "RoadmapItem",
                                                "kind": "LinkedField",
                                                "name": "item",
                                                "plural": false,
                                                "selections": [
                                                    v7,
                                                    v8,
                                                    v11,
                                                    v12,
                                                    v13,
                                                    v14,
                                                    v15,
                                                    v16,
                                                    v17,
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "assignee",
                                                        "plural": false,
                                                        "selections": [
                                                            v30,
                                                            v18,
                                                            v19,
                                                            v20,
                                                            v7
                                                        ]
                                                    },
                                                    v22,
                                                    v23,
                                                    v24,
                                                    v25,
                                                    v26,
                                                    v27,
                                                    v28,
                                                    v29
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "3758129448547311f08b77e2bed6324551c5cffddb448486c6a3fe20ba22e4cb",
                "metadata": {},
                "name": "addRoadmapItemMutation",
                "operationKind": "mutation",
                "text": null
            }
        };
    }();
    $52684c8bd5f8d266$var$node.hash = "5d55eaa73059fae775c21e07aebd6bbe";
    var $52684c8bd5f8d266$export$2e2bcd8739ae039 = $52684c8bd5f8d266$var$node;
});
parcelRegister("gsBJe", function(module, exports) {
    $parcel$export(module.exports, "ADD_PAYLOAD_GLOBAL_ISSUE_CREATE", ()=>$6877a39c2ed99190$export$675a960198823add);
    $parcel$export(module.exports, "addPayloadGlobalIssueCreate", ()=>$6877a39c2ed99190$export$e0ba284a1fc021b7);
    $parcel$export(module.exports, "CLEAR_PAYLOAD_GLOBAL_ISSUE_CREATE", ()=>$6877a39c2ed99190$export$91304df9531434d5);
    $parcel$export(module.exports, "clearPayloadGlobalIssueCreate", ()=>$6877a39c2ed99190$export$a32481b575495215);
    const $6877a39c2ed99190$export$675a960198823add = 'state.entities.global-issue-create.ADD_PAYLOAD_GLOBAL_ISSUE_CREATE';
    const $6877a39c2ed99190$export$e0ba284a1fc021b7 = (payload)=>({
            type: $6877a39c2ed99190$export$675a960198823add,
            payload: payload
        });
    const $6877a39c2ed99190$export$91304df9531434d5 = 'state.entities.global-issue-create.CLEAR_PAYLOAD_GLOBAL_ISSUE_CREATE';
    const $6877a39c2ed99190$export$a32481b575495215 = ()=>({
            type: $6877a39c2ed99190$export$91304df9531434d5
        });
});
parcelRegister("lEiof", function(module, exports) {
    $parcel$export(module.exports, "SET_CREATE_ITEM_ANCHOR", ()=>$18efd0072589b49e$export$95f769ba297653c2);
    $parcel$export(module.exports, "setCreateItemAnchor", ()=>$18efd0072589b49e$export$f1ba3db771e71820);
    $parcel$export(module.exports, "RESET_CREATE_ITEM_ANCHOR", ()=>$18efd0072589b49e$export$a01718abc83595db);
    $parcel$export(module.exports, "resetCreateItemAnchor", ()=>$18efd0072589b49e$export$40c3dbaf42b82dd3);
    $parcel$export(module.exports, "CHANGE_EXPANSION_STATE", ()=>$18efd0072589b49e$export$ed5ea3119374e5c6);
    $parcel$export(module.exports, "changeExpansionState", ()=>$18efd0072589b49e$export$51e4400863559e4f);
    $parcel$export(module.exports, "BULK_CHANGE_EXPANSION_STATE", ()=>$18efd0072589b49e$export$db80068e23e4152b);
    $parcel$export(module.exports, "bulkChangeExpansionState", ()=>$18efd0072589b49e$export$a8352c05f0f63574);
    $parcel$export(module.exports, "EXPAND_ALL_ISSUES", ()=>$18efd0072589b49e$export$33c6058a7747823c);
    $parcel$export(module.exports, "expandAllIssues", ()=>$18efd0072589b49e$export$10ac7c690c63aaee);
    $parcel$export(module.exports, "COLLAPSE_ALL_ISSUES", ()=>$18efd0072589b49e$export$404716ca78e6b45b);
    $parcel$export(module.exports, "collapseAllIssues", ()=>$18efd0072589b49e$export$4c55fb4cb44a67e0);
    $parcel$export(module.exports, "SHOW_TOOLTIP", ()=>$18efd0072589b49e$export$7214ccce749e0556);
    $parcel$export(module.exports, "showToolTip", ()=>$18efd0072589b49e$export$b5df56b714e320a5);
    $parcel$export(module.exports, "HIDE_TOOLTIP", ()=>$18efd0072589b49e$export$ab59b5e1053acdd);
    $parcel$export(module.exports, "hideToolTip", ()=>$18efd0072589b49e$export$fa43f0bcb12c5e1c);
    $parcel$export(module.exports, "SELECT_ITEMS", ()=>$18efd0072589b49e$export$11e14d85d660d6b3);
    $parcel$export(module.exports, "selectItems", ()=>$18efd0072589b49e$export$3978dea8a714b756);
    $parcel$export(module.exports, "SELECT_MULTIPLE_ITEMS", ()=>$18efd0072589b49e$export$3366b046d25a8b48);
    $parcel$export(module.exports, "selectMultipleItems", ()=>$18efd0072589b49e$export$d747c0060051d52c);
    $parcel$export(module.exports, "ACTIVATE_ITEM", ()=>$18efd0072589b49e$export$62d5ab861bf71935);
    $parcel$export(module.exports, "activateItem", ()=>$18efd0072589b49e$export$3031f509587c24cc);
    $parcel$export(module.exports, "SET_SELECTED_ITEMS", ()=>$18efd0072589b49e$export$9aefe348679263b5);
    $parcel$export(module.exports, "setSelectedItemIds", ()=>$18efd0072589b49e$export$541aa27b138a3895);
    $parcel$export(module.exports, "SET_SELECTION_ANCHORS", ()=>$18efd0072589b49e$export$a12b0f6c746053e3);
    $parcel$export(module.exports, "setSelectionAnchors", ()=>$18efd0072589b49e$export$b8f7c93739288e95);
    $parcel$export(module.exports, "SET_ACTIVE_ITEM_REF", ()=>$18efd0072589b49e$export$ea01753190aa22d6);
    $parcel$export(module.exports, "setActiveItemRef", ()=>$18efd0072589b49e$export$4de4add87922367e);
    const $18efd0072589b49e$export$95f769ba297653c2 = 'state.ui.table.SET_CREATE_ITEM_ANCHOR';
    const $18efd0072589b49e$export$f1ba3db771e71820 = (payload)=>({
            type: $18efd0072589b49e$export$95f769ba297653c2,
            payload: payload
        });
    const $18efd0072589b49e$export$a01718abc83595db = 'state.ui.table.RESET_CREATE_ITEM_ANCHOR';
    const $18efd0072589b49e$export$40c3dbaf42b82dd3 = ()=>({
            type: $18efd0072589b49e$export$a01718abc83595db
        });
    const $18efd0072589b49e$export$ed5ea3119374e5c6 = 'state.ui.table.CHANGE_EXPANSION_STATE';
    const $18efd0072589b49e$export$51e4400863559e4f = (payload)=>({
            type: $18efd0072589b49e$export$ed5ea3119374e5c6,
            payload: payload
        });
    const $18efd0072589b49e$export$db80068e23e4152b = 'state.ui.table.BULK_CHANGE_EXPANSION_STATE';
    const $18efd0072589b49e$export$a8352c05f0f63574 = (payload)=>({
            type: $18efd0072589b49e$export$db80068e23e4152b,
            payload: payload
        });
    const $18efd0072589b49e$export$33c6058a7747823c = 'state.ui.table.EXPAND_ALL_ISSUES';
    const $18efd0072589b49e$export$10ac7c690c63aaee = ()=>({
            type: $18efd0072589b49e$export$33c6058a7747823c
        });
    const $18efd0072589b49e$export$404716ca78e6b45b = 'state.ui.table.COLLAPSE_ALL_ISSUES';
    const $18efd0072589b49e$export$4c55fb4cb44a67e0 = ()=>({
            type: $18efd0072589b49e$export$404716ca78e6b45b
        });
    const $18efd0072589b49e$export$7214ccce749e0556 = 'state.ui.table.SHOW_TOOLTIP';
    const $18efd0072589b49e$export$b5df56b714e320a5 = (payload)=>({
            type: $18efd0072589b49e$export$7214ccce749e0556,
            payload: payload
        });
    const $18efd0072589b49e$export$ab59b5e1053acdd = 'state.ui.table.HIDE_TOOLTIP';
    const $18efd0072589b49e$export$fa43f0bcb12c5e1c = ()=>({
            type: $18efd0072589b49e$export$ab59b5e1053acdd
        });
    const $18efd0072589b49e$export$11e14d85d660d6b3 = 'state.ui.table.SELECT_ITEMS';
    const $18efd0072589b49e$export$3978dea8a714b756 = (payload, analyticsEvent)=>({
            type: $18efd0072589b49e$export$11e14d85d660d6b3,
            payload: payload,
            meta: {
                analyticsEvent: analyticsEvent
            }
        });
    const $18efd0072589b49e$export$3366b046d25a8b48 = 'state.ui.table.SELECT_MULTIPLE_ITEMS';
    const $18efd0072589b49e$export$d747c0060051d52c = (analyticsEvent, itemIds)=>({
            type: $18efd0072589b49e$export$3366b046d25a8b48,
            payload: {
                itemIds: itemIds,
                analyticsEvent: analyticsEvent
            }
        });
    const $18efd0072589b49e$export$62d5ab861bf71935 = 'state.ui.table.ACTIVATE_ITEM';
    const $18efd0072589b49e$export$3031f509587c24cc = (itemId, ref)=>({
            type: $18efd0072589b49e$export$62d5ab861bf71935,
            payload: {
                itemId: itemId,
                ref: ref
            }
        });
    const $18efd0072589b49e$export$9aefe348679263b5 = 'state.ui.table.SET_SELECTED_ITEMS';
    const $18efd0072589b49e$export$541aa27b138a3895 = (payload)=>({
            type: $18efd0072589b49e$export$9aefe348679263b5,
            payload: payload
        });
    const $18efd0072589b49e$export$a12b0f6c746053e3 = 'state.ui.table.SET_SELECTION_ANCHORS';
    const $18efd0072589b49e$export$b8f7c93739288e95 = (payload)=>({
            type: $18efd0072589b49e$export$a12b0f6c746053e3,
            payload: payload
        });
    const $18efd0072589b49e$export$ea01753190aa22d6 = 'state.ui.table.SET_ACTIVE_ITEM_REF';
    const $18efd0072589b49e$export$4de4add87922367e = (payload)=>({
            type: $18efd0072589b49e$export$ea01753190aa22d6,
            payload: payload
        });
});
parcelRegister("6AwHs", function(module, exports) {
    $parcel$export(module.exports, "getFieldModForIssueUpdate", ()=>$86d8cce260cb56f4$export$9bcd863363405f3a);
    $parcel$export(module.exports, "getIsIssueHiddenByFiltersOrSettings", ()=>$86d8cce260cb56f4$export$f7eb58b1156295bd);
    var $561FV = parcelRequire("561FV");
    var $70YnB;
    var $iaL1N;
    var $2IdXh;
    const $86d8cce260cb56f4$export$9bcd863363405f3a = (issue)=>{
        const fieldMod = {};
        const clearFields = [];
        if ((0, ($parcel$interopDefault($561FV)))(issue.summary, 'old')) fieldMod.summary = issue.summary.value;
        if ((0, ($parcel$interopDefault($561FV)))(issue.startDate, 'old')) {
            if (issue.startDate.value === undefined) clearFields.push((0, (0, parcelRequire("70YnB")).START_DATE));
            else fieldMod.startDate = issue.startDate.value;
        }
        if ((0, ($parcel$interopDefault($561FV)))(issue.dueDate, 'old')) {
            if (issue.dueDate.value === undefined) clearFields.push((0, (0, parcelRequire("70YnB")).DUE_DATE));
            else fieldMod.dueDate = issue.dueDate.value;
        }
        if ((0, ($parcel$interopDefault($561FV)))(issue.color, 'old')) fieldMod.color = issue.color.value;
        if ((0, ($parcel$interopDefault($561FV)))(issue.parentId, 'old')) fieldMod.parentId = issue.parentId.value;
        if ((0, ($parcel$interopDefault($561FV)))(issue.sprintIds, 'old')) {
            if (issue.sprintIds.value.length === 0) clearFields.push((0, (0, parcelRequire("70YnB")).SPRINT_IDS));
            else {
                const sprintId = issue.sprintIds.value[0];
                fieldMod.sprintId = sprintId;
            }
        }
        if (clearFields.length > 0) fieldMod.clearFields = clearFields;
        return fieldMod;
    };
    const $86d8cce260cb56f4$export$f7eb58b1156295bd = (state, issue, issueId, skipQuickFilters = false)=>{
        const { key: key, issueTypeId: issueTypeId, summary: summary, status: status, assignee: assigneeId, labels: labels, parentId: parentId, versionIds: versionIds, dueDate: dueDate, componentIds: componentIds } = issue;
        const filter = (0, (0, parcelRequire("2IdXh")).getFilterFunction)(state, skipQuickFilters);
        const settingFilter = (0, (0, parcelRequire("2IdXh")).getSettingFilterFunction)(state);
        const userDisplayNameHash = (0, (0, parcelRequire("iaL1N")).getUserDisplayNameHash)(state);
        const assignee = assigneeId !== undefined ? {
            id: assigneeId,
            displayName: userDisplayNameHash[assigneeId]
        } : undefined;
        const filterFields = {
            key: key,
            summary: summary.value,
            labels: labels,
            parentId: parentId.value,
            type: {
                id: issueTypeId
            },
            versionIds: versionIds,
            componentIds: componentIds,
            statusCategoryId: status?.statusCategoryId,
            children: [],
            assignee: assignee,
            dueDate: dueDate.value,
            id: issueId
        };
        const isHiddenByFilter = filter ? filter(filterFields) === false : false;
        const isHiddenBySetting = settingFilter ? settingFilter(filterFields) === false : false;
        return {
            isHiddenByFilter: isHiddenByFilter,
            isHiddenBySetting: isHiddenBySetting
        };
    };
});
parcelRegister("70YnB", function(module, exports) {
    $parcel$export(module.exports, "SUMMARY", ()=>$8dac9f03a04b449a$export$913055729e1380b2);
    $parcel$export(module.exports, "START_DATE", ()=>$8dac9f03a04b449a$export$99a467bcc22b8df9);
    $parcel$export(module.exports, "DUE_DATE", ()=>$8dac9f03a04b449a$export$cf7e173386d30cdd);
    $parcel$export(module.exports, "COLOR", ()=>$8dac9f03a04b449a$export$9b982809044276a6);
    $parcel$export(module.exports, "STATUS", ()=>$8dac9f03a04b449a$export$e50006273435e7d4);
    $parcel$export(module.exports, "ASSIGNEE", ()=>$8dac9f03a04b449a$export$f8f7545d2bb78afb);
    $parcel$export(module.exports, "LABELS", ()=>$8dac9f03a04b449a$export$79b91d4669dcadcb);
    $parcel$export(module.exports, "PARENT_ID", ()=>$8dac9f03a04b449a$export$3af4d9a28905196d);
    $parcel$export(module.exports, "SPRINT_IDS", ()=>$8dac9f03a04b449a$export$fca7b6a230da6c2);
    $parcel$export(module.exports, "VERSION_IDS", ()=>$8dac9f03a04b449a$export$d47cf884beb9bf04);
    $parcel$export(module.exports, "COMPONENT_IDS", ()=>$8dac9f03a04b449a$export$38f111893f96104);
    $parcel$export(module.exports, "ISSUE_TYPE", ()=>$8dac9f03a04b449a$export$ebb48b08205007c5);
    var $5fc53;
    const $8dac9f03a04b449a$export$913055729e1380b2 = (0, (0, parcelRequire("5fc53")).SUMMARY_TYPE);
    const $8dac9f03a04b449a$export$99a467bcc22b8df9 = (0, (0, parcelRequire("5fc53")).START_DATE_TYPE);
    const $8dac9f03a04b449a$export$cf7e173386d30cdd = 'dueDate';
    const $8dac9f03a04b449a$export$9b982809044276a6 = (0, (0, parcelRequire("5fc53")).COLOR_TYPE);
    const $8dac9f03a04b449a$export$e50006273435e7d4 = (0, (0, parcelRequire("5fc53")).STATUS_TYPE);
    const $8dac9f03a04b449a$export$f8f7545d2bb78afb = (0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE);
    const $8dac9f03a04b449a$export$79b91d4669dcadcb = (0, (0, parcelRequire("5fc53")).LABELS_TYPE);
    const $8dac9f03a04b449a$export$3af4d9a28905196d = 'parentId';
    const $8dac9f03a04b449a$export$fca7b6a230da6c2 = 'sprintIds';
    const $8dac9f03a04b449a$export$d47cf884beb9bf04 = 'versionIds';
    const $8dac9f03a04b449a$export$38f111893f96104 = 'componentIds';
    const $8dac9f03a04b449a$export$ebb48b08205007c5 = (0, (0, parcelRequire("5fc53")).ISSUE_TYPE);
});
parcelRegister("iaL1N", function(module, exports) {
    $parcel$export(module.exports, "getFullUserHash", ()=>$07a9a6e8fe11942d$export$9c65f1b2beec0059);
    $parcel$export(module.exports, "getUser", ()=>$07a9a6e8fe11942d$export$7cbf767827cd68ba);
    $parcel$export(module.exports, "getUserDisplayNameHash", ()=>$07a9a6e8fe11942d$export$160cfd792cba790f);
    $parcel$export(module.exports, "getUserAvatar16x16Hash", ()=>$07a9a6e8fe11942d$export$275c56c7a00ae6ca);
    var $561FV = parcelRequire("561FV");
    var $lB63i;
    var $CX7OH;
    const $07a9a6e8fe11942d$export$9c65f1b2beec0059 = (state)=>state.entities.users.hash;
    const $07a9a6e8fe11942d$export$7cbf767827cd68ba = (state, accountId)=>$07a9a6e8fe11942d$export$9c65f1b2beec0059(state)[accountId];
    const $07a9a6e8fe11942d$var$entityUpdateSelector = (0, (0, parcelRequire("lB63i")).createVersionedEntityHashDiffSelector)($07a9a6e8fe11942d$export$9c65f1b2beec0059);
    const $07a9a6e8fe11942d$export$160cfd792cba790f = (0, (0, parcelRequire("CX7OH")).createPropertyHashSelector)($07a9a6e8fe11942d$var$entityUpdateSelector, (user)=>user.displayName);
    const $07a9a6e8fe11942d$export$275c56c7a00ae6ca = (0, (0, parcelRequire("CX7OH")).createPropertyHashSelector)($07a9a6e8fe11942d$var$entityUpdateSelector, (user)=>user.avatarUrls && user.avatarUrls['16x16']);
    const $07a9a6e8fe11942d$export$642cbbb15f6f21b = (state, accountId)=>(0, ($parcel$interopDefault($561FV)))($07a9a6e8fe11942d$export$9c65f1b2beec0059(state), accountId);
});
parcelRegister("2IdXh", function(module, exports) {
    $parcel$export(module.exports, "getSelectedIssueId", ()=>$627d52dd4b5fce58$export$19cf1f433bb54516);
    $parcel$export(module.exports, "getIssueTypeForIssueId", ()=>$627d52dd4b5fce58$export$6050f95a970355e3);
    $parcel$export(module.exports, "getSettingFilterFunction", ()=>$627d52dd4b5fce58$export$ceddd1a6c19dead0);
    $parcel$export(module.exports, "getFilterFunction", ()=>$627d52dd4b5fce58$export$4d2a5b62ef91607b);
    $parcel$export(module.exports, "getFilteredIssueIds", ()=>$627d52dd4b5fce58$export$7a57a09bf274fce6);
    $parcel$export(module.exports, "getFilteredIssueIdsHash", ()=>$627d52dd4b5fce58$export$f7ae446899657bda);
    $parcel$export(module.exports, "getFilteredIssueCount", ()=>$627d52dd4b5fce58$export$589c122e94692c);
    $parcel$export(module.exports, "getNonBaseLevelIssueIds", ()=>$627d52dd4b5fce58$export$9d3065a4935015a1);
    $parcel$export(module.exports, "getFilteredNonBaseLevelIssueIds", ()=>$627d52dd4b5fce58$export$6b86533989c11346);
    $parcel$export(module.exports, "getFilteredChildIssueIdsHash", ()=>$627d52dd4b5fce58$export$8e32946c3d3c8727);
    $parcel$export(module.exports, "getFilteredBaseLevelIssueIds", ()=>$627d52dd4b5fce58$export$90b3596fc3773f68);
    $parcel$export(module.exports, "getFilteredIssueDependenciesHash", ()=>$627d52dd4b5fce58$export$3c46a5657d663740);
    $parcel$export(module.exports, "getFilteredIssueDependeesHash", ()=>$627d52dd4b5fce58$export$9c925993a3e4a4bc);
    $parcel$export(module.exports, "getIssueDependencies", ()=>$627d52dd4b5fce58$export$fc4a6304669861ca);
    $parcel$export(module.exports, "getIssueDependees", ()=>$627d52dd4b5fce58$export$cce99423082ae667);
    $parcel$export(module.exports, "getProgress", ()=>$627d52dd4b5fce58$export$1947d5eba3dbedea);
    $parcel$export(module.exports, "getIssueContextMenuSprints", ()=>$627d52dd4b5fce58$export$3289885d4f62b5a4);
    $parcel$export(module.exports, "getIssueParentColor", ()=>$627d52dd4b5fce58$export$82d2b2062ab119f);
    $parcel$export(module.exports, "getIssueEdgeReleaseDatesHash", ()=>$627d52dd4b5fce58$export$13633a9e6b348fb);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $dPSWJ = parcelRequire("dPSWJ");
    var $gJBT6 = parcelRequire("gJBT6");
    var $2gnC5 = parcelRequire("2gnC5");
    var $dVREV;
    var $1RlSy;
    var $4gYYI;
    var $hFyhA;
    var $2udWc;
    var $iaL1N;
    var $fWch8;
    var $iET4k;
    var $9hAGg;
    var $hhYQB;
    var $bZFir;
    var $8uNFS;
    var $3rLbe;
    var $4oEhy;
    const $627d52dd4b5fce58$export$19cf1f433bb54516 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("hFyhA")).getIssueKeyToIdHash), (0, (0, parcelRequire("fWch8")).getSelectedIssueKey), (hash, key)=>{
        if (key === undefined) return undefined;
        return hash[key];
    });
    const $627d52dd4b5fce58$export$6050f95a970355e3 = (state, id)=>(0, (0, parcelRequire("4gYYI")).getIssueType)(state, (0, (0, parcelRequire("hFyhA")).getIssueTypeIdHash)(state)[id]);
    const $627d52dd4b5fce58$export$fd02f1f08f5001a4 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("hFyhA")).getIssueStatusCategoryIdHash), (0, (0, parcelRequire("2udWc")).getFullStatusCategoriesHash), (0, (0, parcelRequire("4oEhy")).getIssueStatusCategoryHashPure));
    const $627d52dd4b5fce58$var$createFilterFromProperties = (filterableProperties, checkProperties)=>{
        const filterablePropertiesSet = new Set(filterableProperties);
        return (issue)=>checkProperties(issue, filterablePropertiesSet);
    };
    const $627d52dd4b5fce58$var$statusCategoryChecker = (issue, statusCategories)=>issue.statusCategoryId !== undefined && statusCategories.has(issue.statusCategoryId);
    const $627d52dd4b5fce58$export$ceddd1a6c19dead0 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("4gYYI")).getEpicIssueTypeIds), (0, (0, parcelRequire("2udWc")).getFullStatusCategoriesHash), (0, (0, parcelRequire("hhYQB")).getLevelOneSetting), (0, (0, parcelRequire("4gYYI")).getToday), (0, (0, parcelRequire("2udWc")).getDoneStatusCategoryId), (epicIssueTypeIds, statusCategoriesHash, levelOneSetting, today, doneStatusCategoryId)=>{
        const allStatusCategoryId = Object.keys(statusCategoriesHash);
        if (!levelOneSetting.showCompleted) {
            const incompleteStatusCategoryId = allStatusCategoryId.filter((id)=>statusCategoriesHash[id].key !== (0, (0, parcelRequire("1RlSy")).DONE));
            const filterFunction = $627d52dd4b5fce58$var$createFilterFromProperties(incompleteStatusCategoryId, $627d52dd4b5fce58$var$statusCategoryChecker);
            return (issue)=>epicIssueTypeIds.includes(issue.type.id) ? filterFunction(issue) : true;
        }
        const filterFunction = (issue)=>{
            if (doneStatusCategoryId === issue.statusCategoryId && issue.dueDate !== undefined) {
                const { dueDate: dueDate } = issue;
                const { showCompleted: showCompleted, period: period } = levelOneSetting;
                const durationStart = (0, ($parcel$interopDefault($2gnC5))).utc(today).subtract(showCompleted ? period : 0, 'months').startOf('day').valueOf();
                return dueDate >= durationStart;
            }
            return true;
        };
        return (issue)=>epicIssueTypeIds.includes(issue.type.id) ? filterFunction(issue) : true;
    });
    const $627d52dd4b5fce58$var$makeMatcherHierarchical = (matcher)=>{
        const recursiveMatcher = (0, ($parcel$interopDefault($gJBT6)))((issue)=>matcher(issue) || issue.children.some(recursiveMatcher));
        return (issue)=>recursiveMatcher(issue);
    };
    const $627d52dd4b5fce58$var$getFilterFunctionWithIssueIdsFilters = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("hhYQB")).getIssuesFilter), (0, (0, parcelRequire("iET4k")).getJQLFilteredIssueIds), (0, (0, parcelRequire("hhYQB")).getFilteredGoalIssueIds), ({ text: text, statuses: statuses, assignees: assignees, issueTypes: issueTypes, issueParents: issueParents, labels: labels, versions: versions, components: components, quickFilters: quickFilters, customFilters: customFilters, goals: goals }, jqlFilteredIssueIds, goalFilteredIssueIds)=>(0, (0, parcelRequire("dVREV")).createFilterFunction)({
            [(0, $15a528573ccd89ae$export$d597759d33be802e)]: text,
            [(0, $15a528573ccd89ae$export$f8f7545d2bb78afb)]: assignees,
            [(0, $15a528573ccd89ae$export$37aee82a3cb1e8f7)]: labels,
            [(0, $15a528573ccd89ae$export$2a4f270075a033de)]: issueParents,
            [(0, $15a528573ccd89ae$export$ebb48b08205007c5)]: issueTypes,
            [(0, $15a528573ccd89ae$export$a4ad2735b021c132)]: versions,
            [(0, $15a528573ccd89ae$export$f863b019d19144f4)]: statuses,
            [(0, $15a528573ccd89ae$export$af1e30ebbae9df3b)]: components,
            [(0, $15a528573ccd89ae$export$1ea95b94fb0c51d9)]: quickFilters,
            [(0, $15a528573ccd89ae$export$68d693c35a8d8866)]: customFilters,
            [(0, $15a528573ccd89ae$export$871e58afc769b358)]: goals
        }, {
            filteredIssueIds: new Set((0, (0, parcelRequire("4oEhy")).combineIssueIdsFilters)(jqlFilteredIssueIds, goalFilteredIssueIds))
        }));
    const $627d52dd4b5fce58$var$getFilterFunctionWithoutJQLFilters = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("hhYQB")).getIssuesFilter), ({ text: text, statuses: statuses, assignees: assignees, issueTypes: issueTypes, issueParents: issueParents, labels: labels, versions: versions, components: components })=>(0, (0, parcelRequire("dVREV")).createFilterFunction)({
            [(0, $15a528573ccd89ae$export$d597759d33be802e)]: text,
            [(0, $15a528573ccd89ae$export$f8f7545d2bb78afb)]: assignees,
            [(0, $15a528573ccd89ae$export$37aee82a3cb1e8f7)]: labels,
            [(0, $15a528573ccd89ae$export$2a4f270075a033de)]: issueParents,
            [(0, $15a528573ccd89ae$export$ebb48b08205007c5)]: issueTypes,
            [(0, $15a528573ccd89ae$export$a4ad2735b021c132)]: versions,
            [(0, $15a528573ccd89ae$export$f863b019d19144f4)]: statuses,
            [(0, $15a528573ccd89ae$export$af1e30ebbae9df3b)]: components
        }, {}));
    const $627d52dd4b5fce58$export$4d2a5b62ef91607b = (state, skipQuickFilters = false)=>{
        if ((0, (0, parcelRequire("iET4k")).getIsJQLFiltersActive)(state) && !skipQuickFilters || (0, (0, parcelRequire("fWch8")).isGoalFilterActive)(state)) return $627d52dd4b5fce58$var$getFilterFunctionWithIssueIdsFilters(state);
        return $627d52dd4b5fce58$var$getFilterFunctionWithoutJQLFilters(state);
    };
    const $627d52dd4b5fce58$var$getIssuePropertyHashes = (0, $dGvGJ.createStructuredSelector)({
        issueStatusCategoryIdHash: (0, (0, parcelRequire("hFyhA")).getIssueStatusCategoryIdHash),
        issueAssigneeHash: (0, (0, parcelRequire("hFyhA")).getIssueAssigneeHash),
        issueTypeIdHash: (0, (0, parcelRequire("hFyhA")).getIssueTypeIdHash),
        issueChildrenHash: (0, (0, parcelRequire("hFyhA")).getIssueChildrenHash),
        issueCreationTransitionHash: (0, (0, parcelRequire("hFyhA")).getIssueCreationTransitionHash),
        issueSummaryHash: (0, (0, parcelRequire("hFyhA")).getIssueSummaryHash),
        issueParentIdHash: (0, (0, parcelRequire("hFyhA")).getIssueParentIdHash),
        issueLabelsHash: (0, (0, parcelRequire("hFyhA")).getIssueLabelsHash),
        issueKeyHash: (0, (0, parcelRequire("hFyhA")).getIssueKeyHash),
        issueVersionsHash: (0, (0, parcelRequire("3rLbe")).getSanitisedIssueVersionIdsHash),
        issueComponentsHash: (0, (0, parcelRequire("9hAGg")).getSanitisedIssueComponentIdsHash),
        issueDueDateHash: (0, (0, parcelRequire("hFyhA")).getIssueDueDateHash)
    });
    const $627d52dd4b5fce58$export$7a57a09bf274fce6 = (0, $dGvGJ.createSelector)($627d52dd4b5fce58$export$4d2a5b62ef91607b, $627d52dd4b5fce58$export$ceddd1a6c19dead0, (0, (0, parcelRequire("hFyhA")).getIssueIds), $627d52dd4b5fce58$var$getIssuePropertyHashes, (0, (0, parcelRequire("iaL1N")).getUserDisplayNameHash), (0, (0, parcelRequire("8uNFS")).getParentRolledUpDatesHash), (filterFunction, viewSettingFilterFunction, issueIds, { issueStatusCategoryIdHash: issueStatusCategoryIdHash, issueAssigneeHash: issueAssigneeHash, issueTypeIdHash: issueTypeIdHash, issueChildrenHash: issueChildrenHash, issueCreationTransitionHash: issueCreationTransitionHash, issueSummaryHash: issueSummaryHash, issueParentIdHash: issueParentIdHash, issueLabelsHash: issueLabelsHash, issueKeyHash: issueKeyHash, issueVersionsHash: issueVersionsHash, issueComponentsHash: issueComponentsHash, issueDueDateHash: issueDueDateHash }, userDisplayNameHash, parentRolledUpDatesHash)=>{
        if (filterFunction === undefined && viewSettingFilterFunction === undefined) return issueIds;
        const createFilterableIssue = (0, ($parcel$interopDefault($gJBT6)))((issueId)=>{
            const children = issueChildrenHash[issueId] || [];
            const parentRolledUpDate = parentRolledUpDatesHash[issueId];
            const rolledUpDueDate = parentRolledUpDate === undefined || parentRolledUpDate.isDueDatePlaceholder ? undefined : parentRolledUpDate.dueDate;
            const dueDate = issueDueDateHash[issueId] !== undefined ? issueDueDateHash[issueId] : rolledUpDueDate;
            const assigneeId = issueAssigneeHash[issueId];
            const assignee = assigneeId !== undefined ? {
                id: assigneeId,
                displayName: userDisplayNameHash[assigneeId]
            } : undefined;
            return {
                id: issueId,
                key: issueKeyHash[issueId],
                summary: issueSummaryHash[issueId],
                labels: issueLabelsHash[issueId],
                parentId: issueParentIdHash[issueId],
                type: {
                    id: issueTypeIdHash[issueId]
                },
                versionIds: issueVersionsHash[issueId],
                componentIds: issueComponentsHash[issueId],
                statusCategoryId: issueStatusCategoryIdHash[issueId],
                children: children.map(createFilterableIssue),
                assignee: assignee,
                dueDate: dueDate
            };
        });
        const recursiveFilterFunction = filterFunction !== undefined ? $627d52dd4b5fce58$var$makeMatcherHierarchical(filterFunction) : undefined;
        return issueIds.filter((issueId)=>{
            const issue = createFilterableIssue(issueId);
            if (issueCreationTransitionHash[issueId] === true) return true;
            if (recursiveFilterFunction !== undefined && viewSettingFilterFunction !== undefined) return recursiveFilterFunction(issue) && viewSettingFilterFunction(issue);
            if (recursiveFilterFunction !== undefined) return recursiveFilterFunction(issue);
            if (viewSettingFilterFunction !== undefined) return viewSettingFilterFunction(issue);
            return true;
        });
    });
    const $627d52dd4b5fce58$export$f7ae446899657bda = (0, $dGvGJ.createSelector)($627d52dd4b5fce58$export$7a57a09bf274fce6, (filteredIssueIds)=>{
        const issueIdsHash = {};
        filteredIssueIds.forEach((issueId)=>{
            issueIdsHash[issueId] = true;
        });
        return issueIdsHash;
    });
    const $627d52dd4b5fce58$export$589c122e94692c = (state)=>$627d52dd4b5fce58$export$7a57a09bf274fce6(state).length;
    const $627d52dd4b5fce58$export$fc04e99ac3563a66 = (state, issueId)=>$627d52dd4b5fce58$export$f7ae446899657bda(state)[issueId] || false;
    const $627d52dd4b5fce58$var$filterNonBaseLevelIssueIds = (issueIds, issueTypeIdHash, epicIssueTypeIds)=>issueIds.filter((issueId)=>epicIssueTypeIds.includes(issueTypeIdHash[issueId]));
    const $627d52dd4b5fce58$export$9d3065a4935015a1 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("hFyhA")).getIssueIds), (0, (0, parcelRequire("hFyhA")).getIssueTypeIdHash), (0, (0, parcelRequire("4gYYI")).getEpicIssueTypeIds), $627d52dd4b5fce58$var$filterNonBaseLevelIssueIds);
    const $627d52dd4b5fce58$export$6b86533989c11346 = (0, $dGvGJ.createSelector)($627d52dd4b5fce58$export$7a57a09bf274fce6, (0, (0, parcelRequire("hFyhA")).getIssueTypeIdHash), (0, (0, parcelRequire("4gYYI")).getEpicIssueTypeIds), $627d52dd4b5fce58$var$filterNonBaseLevelIssueIds);
    const $627d52dd4b5fce58$export$8e32946c3d3c8727 = (0, $dGvGJ.createSelector)($627d52dd4b5fce58$export$7a57a09bf274fce6, (0, (0, parcelRequire("hFyhA")).getIssueParentIdHash), (issueIds, parentIdHash)=>{
        const issueChildIdHash = {};
        issueIds.forEach((issueId)=>{
            const parentId = parentIdHash[issueId];
            if (parentId) {
                if (!issueChildIdHash[parentId]) issueChildIdHash[parentId] = [
                    issueId
                ];
                else issueChildIdHash[parentId].push(issueId);
            }
        });
        return issueChildIdHash;
    });
    const $627d52dd4b5fce58$export$90b3596fc3773f68 = (0, $dGvGJ.createSelector)($627d52dd4b5fce58$export$9d3065a4935015a1, $627d52dd4b5fce58$export$8e32946c3d3c8727, (issueParentIds, issueChildIdHash)=>{
        const filteredBaseLevelIssueIds = [];
        issueParentIds.forEach((id)=>{
            const ids = issueChildIdHash[id] || [];
            ids.length && filteredBaseLevelIssueIds.push(...ids);
        });
        return filteredBaseLevelIssueIds;
    });
    const $627d52dd4b5fce58$export$3c46a5657d663740 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("hFyhA")).getIssueDependenciesHash), (0, (0, parcelRequire("hFyhA")).getIssueTypeIdHash), (0, (0, parcelRequire("4gYYI")).getEpicIssueTypeIds), (0, (0, parcelRequire("4gYYI")).getFullIssueTypeHash), (issueDependenciesHash, issueTypeIdHash, epicIssueTypeIds, issueTypeHash)=>(0, ($parcel$interopDefault($dPSWJ)))(issueDependenciesHash, (dependencies)=>dependencies.filter((issueId)=>issueTypeHash[issueTypeIdHash[issueId]])));
    const $627d52dd4b5fce58$export$9c925993a3e4a4bc = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("hFyhA")).getIssueDependeesHash), (0, (0, parcelRequire("hFyhA")).getIssueTypeIdHash), (0, (0, parcelRequire("4gYYI")).getEpicIssueTypeIds), (0, (0, parcelRequire("4gYYI")).getFullIssueTypeHash), (issueDependeesHash, issueTypeIdHash, epicIssueTypeIds, issueTypeHash)=>(0, ($parcel$interopDefault($dPSWJ)))(issueDependeesHash, (dependencies)=>dependencies.filter((issueId)=>issueTypeHash[issueTypeIdHash[issueId]])));
    const $627d52dd4b5fce58$export$fc4a6304669861ca = (state, issueId)=>$627d52dd4b5fce58$export$3c46a5657d663740(state)[issueId];
    const $627d52dd4b5fce58$export$cce99423082ae667 = (state, issueId)=>$627d52dd4b5fce58$export$9c925993a3e4a4bc(state)[issueId];
    const $627d52dd4b5fce58$export$139880bd42541622 = (0, $dGvGJ.createSelector)($627d52dd4b5fce58$export$9d3065a4935015a1, (0, (0, parcelRequire("hFyhA")).getIssueChildrenHash), $627d52dd4b5fce58$export$fd02f1f08f5001a4, (0, (0, parcelRequire("2udWc")).getStatusCategoriesKeyHash), (0, (0, parcelRequire("4oEhy")).getProgressHashPure));
    const $627d52dd4b5fce58$export$1947d5eba3dbedea = (state, issueId)=>$627d52dd4b5fce58$export$139880bd42541622(state)[issueId];
    const $627d52dd4b5fce58$export$5ee2d25d02c7177 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("4gYYI")).getActiveAndFutureSprints), (0, (0, parcelRequire("bZFir")).getSanitisedIssueSprintsHash), (activeOrFutureSprints, issueSprintsHash)=>{
        const result = {};
        Object.keys(issueSprintsHash).forEach((issueId)=>{
            const sprintIds = issueSprintsHash[issueId].map((sprint)=>sprint.id);
            result[issueId] = activeOrFutureSprints.filter((sprint)=>!sprintIds.includes(sprint.id));
        });
        return result;
    });
    const $627d52dd4b5fce58$export$3289885d4f62b5a4 = (state, issueId)=>$627d52dd4b5fce58$export$5ee2d25d02c7177(state)[issueId];
    const $627d52dd4b5fce58$var$getIssueParentColorHash = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("hFyhA")).getIssueIds), (0, (0, parcelRequire("hFyhA")).getIssueParentIdHash), (0, (0, parcelRequire("hFyhA")).getIssueColorHash), (ids, parentIdHash, issueColorHash)=>{
        const issueParentColorHash = {};
        ids.forEach((id)=>{
            const parentId = parentIdHash[id];
            const color = parentId !== undefined ? issueColorHash[parentId] : issueColorHash[id];
            issueParentColorHash[`${id}`] = color;
        });
        return issueParentColorHash;
    });
    const $627d52dd4b5fce58$export$82d2b2062ab119f = (state, issueId)=>$627d52dd4b5fce58$var$getIssueParentColorHash(state)[issueId];
    const $627d52dd4b5fce58$export$13633a9e6b348fb = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("4gYYI")).getFullVersionHash), (0, (0, parcelRequire("3rLbe")).getSanitisedIssueVersionIdsHash), (0, (0, parcelRequire("4oEhy")).getIssueEdgeReleaseDatesPure));
});
parcelRegister("dPSWJ", function(module, exports) {
    var $1m3dq = parcelRequire("1m3dq");
    var $hDnyx = parcelRequire("hDnyx");
    var $bxDef = parcelRequire("bxDef");
    function $a12aa8fd8ab9a7da$var$mapValues(object, iteratee) {
        var result = {};
        iteratee = $bxDef(iteratee, 3);
        $hDnyx(object, function(value, key, object) {
            $1m3dq(result, key, iteratee(value, key, object));
        });
        return result;
    }
    module.exports = $a12aa8fd8ab9a7da$var$mapValues;
});
parcelRegister("dVREV", function(module, exports) {
    $parcel$export(module.exports, "createDefaultMatcherCreators", ()=>$da698aa4f276c01f$export$551eb27bf5bd708);
    $parcel$export(module.exports, "createFilterFunction", ()=>$da698aa4f276c01f$export$5b4da3e2bd753e6);
    var $83R7M;
    var $9NUFF;
    var $bOpxF;
    var $2Ol4g;
    var $kSow3;
    var $91AxA;
    var $8wcaA;
    var $7vODb;
    var $bliRS;
    var $iZeAQ;
    var $ly5rg;
    var $4nYh7;
    var $gbBLn;
    var $gw6jA;
    const $da698aa4f276c01f$export$551eb27bf5bd708 = ()=>({
            [(0, $15a528573ccd89ae$export$d597759d33be802e)]: (0, (0, parcelRequire("gbBLn")).textMatcherCreator),
            [(0, $15a528573ccd89ae$export$f8f7545d2bb78afb)]: (0, (0, parcelRequire("83R7M")).assigneeMatcherCreator),
            [(0, $15a528573ccd89ae$export$37aee82a3cb1e8f7)]: (0, (0, parcelRequire("7vODb")).labelMatcherCreator),
            [(0, $15a528573ccd89ae$export$2a4f270075a033de)]: (0, (0, parcelRequire("kSow3")).issueParentMatcherCreator),
            [(0, $15a528573ccd89ae$export$401f4b6eda6a369c)]: (0, (0, parcelRequire("91AxA")).issueProjectMatcherCreator),
            [(0, $15a528573ccd89ae$export$ebb48b08205007c5)]: (0, (0, parcelRequire("8wcaA")).issueTypeMatcherCreator),
            [(0, $15a528573ccd89ae$export$a4ad2735b021c132)]: (0, (0, parcelRequire("gw6jA")).versionMatcherCreator),
            [(0, $15a528573ccd89ae$export$68d693c35a8d8866)]: (0, (0, parcelRequire("2Ol4g")).filteredIssueIdsMatcherCreator),
            [(0, $15a528573ccd89ae$export$af1e30ebbae9df3b)]: (0, (0, parcelRequire("9NUFF")).componentMatcherCreator),
            [(0, $15a528573ccd89ae$export$92ab80c1dc9baf44)]: (0, (0, parcelRequire("bliRS")).requestTypeMatcherCreator),
            [(0, $15a528573ccd89ae$export$f863b019d19144f4)]: (0, (0, parcelRequire("ly5rg")).statusCategoryMatcherCreator),
            [(0, $15a528573ccd89ae$export$e50006273435e7d4)]: (0, (0, parcelRequire("4nYh7")).statusMatcherCreator),
            [(0, $15a528573ccd89ae$export$1ea95b94fb0c51d9)]: (0, (0, parcelRequire("2Ol4g")).filteredIssueIdsMatcherCreator),
            [(0, $15a528573ccd89ae$export$a316570a0dbfd2b0)]: (0, (0, parcelRequire("iZeAQ")).sprintMatcherCreator),
            [(0, $15a528573ccd89ae$export$871e58afc769b358)]: (0, (0, parcelRequire("2Ol4g")).filteredIssueIdsMatcherCreator),
            [(0, $15a528573ccd89ae$export$db362e2d293fe52e)]: (0, (0, parcelRequire("bOpxF")).dependenciesMatcherCreator)
        });
    const $da698aa4f276c01f$var$createMatchers = (filter, context, matcherCreators)=>Object.keys(filter).reduce((acc, key)=>{
            const filterValue = filter[key];
            const matcherCreator = matcherCreators[key];
            if (filterValue === undefined || filterValue.length <= 0 || matcherCreator === undefined) return acc;
            acc.push(matcherCreator(filterValue, context));
            return acc;
        }, []);
    const $da698aa4f276c01f$export$5b4da3e2bd753e6 = (filter, context, matcherCreators, overrideMatchers)=>{
        const matchers = $da698aa4f276c01f$var$createMatchers(filter, context, matcherCreators ?? $da698aa4f276c01f$export$551eb27bf5bd708());
        return (issue)=>matchers.every((matcher)=>matcher(issue)) || overrideMatchers !== undefined && overrideMatchers.some((matcher)=>matcher(issue));
    };
});
parcelRegister("83R7M", function(module, exports) {
    $parcel$export(module.exports, "assigneeMatcherCreator", ()=>$516b0f9136210863$export$5c453ff7d8a6957f);
    var $g5X3G;
    const $516b0f9136210863$export$5c453ff7d8a6957f = (assigneeFilter)=>{
        const assigneeSet = new Set(assigneeFilter);
        return ({ assignee: assignee })=>assignee !== undefined && assigneeSet.has(assignee.id) || assignee === undefined && assigneeSet.has((0, (0, parcelRequire("g5X3G")).toAccountId)((0, $15a528573ccd89ae$export$12e572fd459c10dc)));
    };
});
parcelRegister("9NUFF", function(module, exports) {
    $parcel$export(module.exports, "componentMatcherCreator", ()=>$f76f751e605f1ced$export$667cab6ac6c65512);
    const $f76f751e605f1ced$export$667cab6ac6c65512 = (componentFilter)=>{
        const componentSet = new Set(componentFilter);
        return ({ componentIds: componentIds })=>componentIds !== undefined && (componentIds.some((componentId)=>componentSet.has(componentId)) || componentIds.length === 0 && componentSet.has((0, $15a528573ccd89ae$export$4b7c755e61199a36)));
    };
});
parcelRegister("bOpxF", function(module, exports) {
    $parcel$export(module.exports, "dependenciesMatcherCreator", ()=>$03061179e3dc93a9$export$18a8a0a9891403f1);
    var $4R6GH;
    var $kIDH3;
    const $03061179e3dc93a9$export$18a8a0a9891403f1 = (dependenciesFilter)=>{
        if (dependenciesFilter && (0, (0, parcelRequire("4R6GH")).fg)('dependency_visualisation_program_board_fe_and_be')) {
            const includeOffTrack = dependenciesFilter.includes((0, (0, parcelRequire("kIDH3")).DependencyFilterOption).OFF_TRACK);
            const includeOnTrack = dependenciesFilter.includes((0, (0, parcelRequire("kIDH3")).DependencyFilterOption).ON_TRACK);
            return (issue)=>includeOffTrack && !!issue.hasOfftrackDependency || includeOnTrack && !!issue.hasOntrackDependency;
        }
        return ()=>true;
    };
});
parcelRegister("kIDH3", function(module, exports) {
    $parcel$export(module.exports, "DependencyFilterOption", ()=>$ddac187df0965772$export$499848eca2db01cf);
    const $ddac187df0965772$export$499848eca2db01cf = {
        OFF_TRACK: 'off-track',
        ON_TRACK: 'on-track'
    };
});
parcelRegister("2Ol4g", function(module, exports) {
    $parcel$export(module.exports, "filteredIssueIdsMatcherCreator", ()=>$497597637c50e49d$export$4493d922cd011b1a);
    const $497597637c50e49d$export$4493d922cd011b1a = (value, { filteredIssueIds: filteredIssueIds })=>({ id: id })=>filteredIssueIds !== undefined ? id !== undefined && filteredIssueIds.has(id) : true;
});
parcelRegister("kSow3", function(module, exports) {
    $parcel$export(module.exports, "issueParentMatcherCreator", ()=>$a81202b8afefb6ff$export$4729465fe91e6864);
    const $a81202b8afefb6ff$export$4729465fe91e6864 = (issueParentFilter, { issues: issues })=>{
        const issueParentSet = new Set(issueParentFilter);
        const isAncestorInFilter = (id, checked = [])=>{
            if (id === undefined) return issueParentSet.has((0, $9ac224d9ad6eb576$export$794f07be04aca3fe));
            if (issueParentSet.has(id)) return true;
            if (checked.includes(id)) return false;
            if (issues === undefined) return false;
            const issue = issues.hash[id];
            if (issue === undefined) return false;
            const { parentId: parentId } = issue;
            return isAncestorInFilter(parentId, checked.concat(id));
        };
        return ({ id: id, parentId: parentId })=>{
            if (id === undefined) return false;
            if (issueParentSet.has(id)) return true;
            if (id === parentId) return false;
            return isAncestorInFilter(parentId, [
                id
            ]);
        };
    };
});
const $9ac224d9ad6eb576$export$794f07be04aca3fe = '0';
const $9ac224d9ad6eb576$export$cb17e3c17bc50301 = 'Epic';
const $9ac224d9ad6eb576$export$7fbc739f2667a35e = 'Subtask';
parcelRegister("91AxA", function(module, exports) {
    $parcel$export(module.exports, "issueProjectMatcherCreator", ()=>$4fdd97fe73369965$export$b10ee43342090204);
    const $4fdd97fe73369965$export$b10ee43342090204 = (projectFilter)=>{
        const projectSet = new Set(projectFilter);
        return ({ projectId: projectId })=>!!projectId && projectSet.has(projectId);
    };
});
parcelRegister("8wcaA", function(module, exports) {
    $parcel$export(module.exports, "issueTypeMatcherCreator", ()=>$1427bf4cc0e6bee2$export$48b17418005f8b9b);
    const $1427bf4cc0e6bee2$export$48b17418005f8b9b = (issueTypeFilter)=>{
        const issueTypeSet = new Set(issueTypeFilter);
        return ({ type: type })=>issueTypeSet.has(type.id);
    };
});
parcelRegister("7vODb", function(module, exports) {
    $parcel$export(module.exports, "labelMatcherCreator", ()=>$40f84c5420493f05$export$71d90ee236f2e796);
    const $40f84c5420493f05$export$71d90ee236f2e796 = (labelFilter)=>{
        const labelSet = new Set(labelFilter);
        return ({ labels: labels })=>labels !== undefined && (labels.some((label)=>labelSet.has(label)) || labels.length === 0 && labelSet.has((0, $15a528573ccd89ae$export$81ef49afbbead0a1)));
    };
});
parcelRegister("bliRS", function(module, exports) {
    $parcel$export(module.exports, "requestTypeMatcherCreator", ()=>$0e9572c0a83b3cdc$export$d04e41d82fbfb8ba);
    const $0e9572c0a83b3cdc$export$d04e41d82fbfb8ba = (requestTypeFilter)=>{
        const requestTypeSet = new Set(requestTypeFilter);
        return ({ requestTypeId: requestTypeId })=>!!requestTypeId && requestTypeSet.has(requestTypeId);
    };
});
parcelRegister("iZeAQ", function(module, exports) {
    $parcel$export(module.exports, "sprintMatcherCreator", ()=>$18f99efa97d4433e$export$4706275ba29d0c7);
    const $18f99efa97d4433e$export$4706275ba29d0c7 = (sprintFilter)=>({ sprintId: sprintId })=>sprintFilter.includes(sprintId || '');
});
parcelRegister("ly5rg", function(module, exports) {
    $parcel$export(module.exports, "statusCategoryMatcherCreator", ()=>$e669431e48d4db53$export$bb986e45707c6c33);
    const $e669431e48d4db53$export$bb986e45707c6c33 = (statusCategoryFilter)=>{
        const statusCategorySet = new Set(statusCategoryFilter);
        return ({ statusCategoryId: statusCategoryId })=>statusCategoryId !== undefined && statusCategorySet.has(statusCategoryId);
    };
});
parcelRegister("4nYh7", function(module, exports) {
    $parcel$export(module.exports, "statusMatcherCreator", ()=>$931417eb46388f8b$export$c61724a440d8ea1d);
    const $931417eb46388f8b$export$c61724a440d8ea1d = (statusFilter)=>{
        const statusSet = new Set(statusFilter);
        return ({ statusId: statusId })=>!!statusId && statusSet.has(statusId);
    };
});
parcelRegister("gbBLn", function(module, exports) {
    $parcel$export(module.exports, "textMatcherCreator", ()=>$b425285590e5a6aa$export$71a22d4a5d2891fc);
    var $8QDwl = parcelRequire("8QDwl");
    var $gJBT6 = parcelRequire("gJBT6");
    const $b425285590e5a6aa$export$f3f2882e8b11d731 = (text)=>text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    const $b425285590e5a6aa$var$doesSummaryContainText = (summary, lowercaseText)=>summary.toLowerCase().includes(lowercaseText) || $b425285590e5a6aa$export$f3f2882e8b11d731(summary).toLowerCase().includes(lowercaseText);
    const $b425285590e5a6aa$var$doesIssueKeyMatchLoosely = (key, lowercaseText)=>key !== undefined && key?.toLowerCase().includes(lowercaseText);
    const $b425285590e5a6aa$var$createDisplayNameChecker = (text)=>{
        const pattern = text.split(/\s+/).map((0, ($parcel$interopDefault($8QDwl)))).join('.*\\s+');
        const regExp = new RegExp(pattern, 'i');
        return (0, ($parcel$interopDefault($gJBT6)))((displayName)=>regExp.test(displayName));
    };
    const $b425285590e5a6aa$export$71a22d4a5d2891fc = (textFilter)=>{
        const lowercaseText = textFilter.toLowerCase();
        const doesDisplayNameMatchRegExp = $b425285590e5a6aa$var$createDisplayNameChecker(textFilter);
        return ({ summary: summary, key: key, assignee: assignee })=>summary && $b425285590e5a6aa$var$doesSummaryContainText(summary, lowercaseText) || $b425285590e5a6aa$var$doesIssueKeyMatchLoosely(key, lowercaseText) || assignee !== undefined && doesDisplayNameMatchRegExp(assignee.displayName);
    };
});
parcelRegister("8QDwl", function(module, exports) {
    var $jJVtR = parcelRequire("jJVtR");
    var $6711d60dd8e02df4$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g, $6711d60dd8e02df4$var$reHasRegExpChar = RegExp($6711d60dd8e02df4$var$reRegExpChar.source);
    function $6711d60dd8e02df4$var$escapeRegExp(string) {
        string = $jJVtR(string);
        return string && $6711d60dd8e02df4$var$reHasRegExpChar.test(string) ? string.replace($6711d60dd8e02df4$var$reRegExpChar, '\\$&') : string;
    }
    module.exports = $6711d60dd8e02df4$var$escapeRegExp;
});
parcelRegister("gw6jA", function(module, exports) {
    $parcel$export(module.exports, "versionMatcherCreator", ()=>$f7a5a8a45b854dff$export$fb114a888e0e17b4);
    const $f7a5a8a45b854dff$export$fb114a888e0e17b4 = (versionFilter)=>{
        const versionSet = new Set(versionFilter);
        return ({ versionIds: versionIds })=>versionIds !== undefined && (versionIds.some((versionId)=>versionSet.has(versionId)) || versionIds.length === 0 && versionSet.has((0, $15a528573ccd89ae$export$ac95b4b2317d4b33)));
    };
});
parcelRegister("8uNFS", function(module, exports) {
    $parcel$export(module.exports, "getParentRolledUpDatesHash", ()=>$c076bde5bea859f8$export$19344f1f730b9c22);
    $parcel$export(module.exports, "getExplicitBoundaryDatesHash", ()=>$c076bde5bea859f8$export$4f77368293516479);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $4gYYI;
    var $hFyhA;
    var $bZFir;
    var $hbxrl;
    const $c076bde5bea859f8$export$19344f1f730b9c22 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("hFyhA")).getIssueChildrenHash), (0, (0, parcelRequire("bZFir")).createGetIssueSprintDates), (0, (0, parcelRequire("hFyhA")).getIssueStartDateHash), (0, (0, parcelRequire("hFyhA")).getIssueDueDateHash), (0, (0, parcelRequire("4gYYI")).getIsSprintsPlanningEnabled), (0, (0, parcelRequire("4gYYI")).getIsChildIssuePlanningEnabled), (0, (0, parcelRequire("hbxrl")).getParentRolledUpDatesHash));
    const $c076bde5bea859f8$export$4f77368293516479 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("hFyhA")).getIssueChildrenHash), (0, (0, parcelRequire("hFyhA")).getIssueStartDateHash), (0, (0, parcelRequire("hFyhA")).getIssueDueDateHash), (0, (0, parcelRequire("bZFir")).createGetIssueSprintDates), (0, (0, parcelRequire("4gYYI")).getIsSprintsPlanningEnabled), (0, (0, parcelRequire("hbxrl")).getBoundaryDatesHash));
});
parcelRegister("hbxrl", function(module, exports) {
    $parcel$export(module.exports, "getBoundaryDatesHash", ()=>$b3a17ea994ad1567$export$18b28b3bf7ea66b1);
    $parcel$export(module.exports, "getParentRolledUpDatesHash", ()=>$b3a17ea994ad1567$export$19344f1f730b9c22);
    var $fEeCa = parcelRequire("fEeCa");
    var $a66wu = parcelRequire("a66wu");
    var $2gnC5 = parcelRequire("2gnC5");
    var $eKt4x;
    const $b3a17ea994ad1567$var$getChildInferredSprintDates = (childIssueId, getIssueSprintDates)=>{
        const { inferredStartDate: startDate, inferredEndDate: dueDate } = getIssueSprintDates(childIssueId);
        return {
            startDate: startDate,
            dueDate: dueDate
        };
    };
    const $b3a17ea994ad1567$export$982f0c3b285f400e = ({ startDate: startDate, dueDate: dueDate })=>{
        if (startDate !== undefined && dueDate !== undefined) return {
            startDate: Math.min(startDate, dueDate),
            dueDate: Math.max(startDate, dueDate),
            isStartDatePlaceholder: false,
            isDueDatePlaceholder: false,
            areDatesFlipped: startDate > dueDate
        };
        if (startDate !== undefined) {
            const placeholderDueDate = (0, ($parcel$interopDefault($2gnC5))).utc(startDate).add((0, (0, parcelRequire("eKt4x")).CHILD_PLACEHOLDER_DAYS), 'days').startOf('day').valueOf();
            return {
                startDate: startDate,
                dueDate: placeholderDueDate,
                isStartDatePlaceholder: false,
                isDueDatePlaceholder: true,
                areDatesFlipped: false
            };
        }
        if (dueDate !== undefined) {
            const placeholderStartDate = (0, ($parcel$interopDefault($2gnC5))).utc(dueDate).subtract((0, (0, parcelRequire("eKt4x")).CHILD_PLACEHOLDER_DAYS), 'days').startOf('day').valueOf();
            return {
                startDate: placeholderStartDate,
                dueDate: dueDate,
                isStartDatePlaceholder: true,
                isDueDatePlaceholder: false,
                areDatesFlipped: false
            };
        }
        return {
            startDate: undefined,
            dueDate: undefined,
            isStartDatePlaceholder: false,
            isDueDatePlaceholder: false,
            areDatesFlipped: false
        };
    };
    const $b3a17ea994ad1567$var$getChildExplicitDates = (childIssueId, issueStartDateHash, issueDueDateHash)=>{
        const startDate = issueStartDateHash[childIssueId];
        const dueDate = issueDueDateHash[childIssueId];
        return {
            startDate: startDate,
            dueDate: dueDate
        };
    };
    const $b3a17ea994ad1567$export$a54cf1eacbf962ce = (childIssueIds, getIssueSprintDates, issueStartDateHash, issueDueDateHash, isSprintsPlanning)=>{
        const issueDatesHash = {};
        childIssueIds.forEach((childIssueId)=>{
            const { startDate: startDate, dueDate: dueDate, isStartDatePlaceholder: isStartDatePlaceholder, isDueDatePlaceholder: isDueDatePlaceholder, areDatesFlipped: areDatesFlipped } = $b3a17ea994ad1567$export$982f0c3b285f400e(isSprintsPlanning ? $b3a17ea994ad1567$var$getChildInferredSprintDates(childIssueId, getIssueSprintDates) : $b3a17ea994ad1567$var$getChildExplicitDates(childIssueId, issueStartDateHash, issueDueDateHash));
            if (startDate !== undefined && dueDate !== undefined) issueDatesHash[`${childIssueId}`] = {
                startDate: startDate,
                dueDate: dueDate,
                isStartDateInferred: isSprintsPlanning,
                isStartDatePlaceholder: isStartDatePlaceholder,
                isDueDateInferred: isSprintsPlanning,
                isDueDatePlaceholder: isDueDatePlaceholder,
                areDatesFlipped: areDatesFlipped
            };
        });
        return issueDatesHash;
    };
    const $b3a17ea994ad1567$var$startDateComparator = (first, second)=>first < second;
    const $b3a17ea994ad1567$var$dueDateComparator = (first, second)=>first > second;
    const $b3a17ea994ad1567$var$getRolledUpDate = (previousDate, date, isPreviousDatePlaceholder, isDatePlaceholder, shouldUseCurrentDateComparator)=>{
        if (previousDate === undefined) return {
            date: date,
            isDatePlaceholder: isDatePlaceholder
        };
        return {
            date: shouldUseCurrentDateComparator(date, previousDate) ? date : previousDate,
            isDatePlaceholder: isDatePlaceholder || isPreviousDatePlaceholder
        };
    };
    const $b3a17ea994ad1567$var$getRolledUpChildDates = (childIssueIds, childIssueDatesHash)=>childIssueIds.reduce((rolledUpDatesAcc, childIssueId)=>{
            const dates = childIssueDatesHash[childIssueId];
            if (dates !== undefined) {
                const { date: startDate, isDatePlaceholder: isStartDatePlaceholder } = $b3a17ea994ad1567$var$getRolledUpDate(rolledUpDatesAcc.startDate, dates.startDate, rolledUpDatesAcc.isStartDatePlaceholder, dates.isStartDatePlaceholder, $b3a17ea994ad1567$var$startDateComparator);
                const { date: latestStartDate } = $b3a17ea994ad1567$var$getRolledUpDate(rolledUpDatesAcc.latestStartDate, dates.startDate, rolledUpDatesAcc.isStartDatePlaceholder, dates.isStartDatePlaceholder, $b3a17ea994ad1567$var$dueDateComparator);
                const { date: earliestDueDate } = $b3a17ea994ad1567$var$getRolledUpDate(rolledUpDatesAcc.earliestDueDate, dates.dueDate, rolledUpDatesAcc.isDueDatePlaceholder, dates.isDueDatePlaceholder, $b3a17ea994ad1567$var$startDateComparator);
                const { date: dueDate, isDatePlaceholder: isDueDatePlaceholder } = $b3a17ea994ad1567$var$getRolledUpDate(rolledUpDatesAcc.dueDate, dates.dueDate, rolledUpDatesAcc.isDueDatePlaceholder, dates.isDueDatePlaceholder, $b3a17ea994ad1567$var$dueDateComparator);
                return {
                    startDate: startDate,
                    dueDate: dueDate,
                    isStartDatePlaceholder: isStartDatePlaceholder,
                    isDueDatePlaceholder: isDueDatePlaceholder,
                    latestStartDate: latestStartDate,
                    earliestDueDate: earliestDueDate
                };
            }
            return rolledUpDatesAcc;
        }, {
            startDate: undefined,
            dueDate: undefined,
            latestStartDate: undefined,
            earliestDueDate: undefined,
            isStartDatePlaceholder: true,
            isDueDatePlaceholder: true
        });
    const $b3a17ea994ad1567$var$getParentRolledUpDatesHashOld = (childrenHash, getIssueSprintDates)=>Object.keys(childrenHash).reduce((acc, parentIssueId)=>{
            const childIssueIds = childrenHash[parentIssueId];
            const rolledUpDates = childIssueIds.reduce((rolledupAcc, childIssueId)=>{
                const { inferredStartDate: childInferredStartDate, inferredEndDate: childInferredDueDate } = getIssueSprintDates(childIssueId);
                return {
                    startDate: (0, ($parcel$interopDefault($a66wu)))([
                        rolledupAcc.startDate,
                        childInferredStartDate
                    ]),
                    dueDate: (0, ($parcel$interopDefault($fEeCa)))([
                        rolledupAcc.dueDate,
                        childInferredDueDate
                    ]),
                    latestStartDate: undefined,
                    earliestDueDate: undefined,
                    isStartDatePlaceholder: false,
                    isDueDatePlaceholder: false
                };
            }, {
                startDate: undefined,
                dueDate: undefined,
                earliestDueDate: undefined,
                latestStartDate: undefined,
                isStartDatePlaceholder: true,
                isDueDatePlaceholder: true
            });
            acc[parentIssueId] = rolledUpDates;
            return acc;
        }, {});
    const $b3a17ea994ad1567$export$18b28b3bf7ea66b1 = (childrenHash, issueStartDateHash, issueDueDateHash, getIssueSprintDates, isSprintsPlanning)=>{
        const result = {};
        Object.keys(childrenHash).forEach((parentIssueId)=>{
            const parentStartDate = issueStartDateHash[parentIssueId];
            const parentDueDate = issueDueDateHash[parentIssueId];
            let earliestStart = parentStartDate;
            let earliestEnd = parentDueDate;
            let latestStart = parentStartDate;
            let latestEnd = parentDueDate;
            childrenHash[parentIssueId].forEach((childIssueId)=>{
                const { inferredEndDate: inferredEndDate, inferredStartDate: inferredStartDate } = getIssueSprintDates(childIssueId);
                const startDate = isSprintsPlanning ? inferredStartDate : issueStartDateHash[childIssueId];
                const endDate = isSprintsPlanning ? inferredEndDate : issueDueDateHash[childIssueId];
                if (parentStartDate !== undefined) {
                    earliestStart = (0, ($parcel$interopDefault($a66wu)))([
                        earliestStart,
                        startDate
                    ]);
                    latestStart = (0, ($parcel$interopDefault($fEeCa)))([
                        latestStart,
                        startDate
                    ]);
                }
                if (parentDueDate !== undefined) {
                    earliestEnd = (0, ($parcel$interopDefault($a66wu)))([
                        earliestEnd,
                        endDate
                    ]);
                    latestEnd = (0, ($parcel$interopDefault($fEeCa)))([
                        latestEnd,
                        endDate
                    ]);
                }
            });
            result[parentIssueId] = {
                startDateBoundary: (0, ($parcel$interopDefault($a66wu)))([
                    earliestStart,
                    earliestEnd
                ]),
                dueDateBoundary: (0, ($parcel$interopDefault($fEeCa)))([
                    latestStart,
                    latestEnd
                ])
            };
        });
        return result;
    };
    const $b3a17ea994ad1567$export$19344f1f730b9c22 = (childrenHash, getIssueSprintDates, issueStartDateHash, issueDueDateHash, isSprintsPlanning, isChildIssuePlanningEnabled)=>{
        if (!isChildIssuePlanningEnabled) return $b3a17ea994ad1567$var$getParentRolledUpDatesHashOld(childrenHash, getIssueSprintDates);
        return Object.keys(childrenHash).reduce((acc, parentIssueId)=>{
            const childIssueIds = childrenHash[parentIssueId];
            const childIssueDatesHash = $b3a17ea994ad1567$export$a54cf1eacbf962ce(childIssueIds, getIssueSprintDates, issueStartDateHash, issueDueDateHash, isSprintsPlanning);
            const dueDate = issueDueDateHash[parentIssueId];
            const startDate = issueStartDateHash[parentIssueId];
            const { dueDate: rolledUpDueDate, isDueDatePlaceholder: isRolledUpDueDatePlaceholder, isStartDatePlaceholder: isRolledUpStartDatePlaceholder, startDate: rolledUpStartDate, latestStartDate: latestStartDate, earliestDueDate: earliestDueDate } = $b3a17ea994ad1567$var$getRolledUpChildDates(childIssueIds, childIssueDatesHash);
            acc[parentIssueId] = {
                dueDate: rolledUpDueDate,
                isDueDatePlaceholder: dueDate === undefined && isRolledUpDueDatePlaceholder,
                isStartDatePlaceholder: startDate === undefined && isRolledUpStartDatePlaceholder,
                startDate: rolledUpStartDate,
                latestStartDate: latestStartDate,
                earliestDueDate: earliestDueDate
            };
            return acc;
        }, {});
    };
});
parcelRegister("fEeCa", function(module, exports) {
    var $la2vn = parcelRequire("la2vn");
    var $5JMmU = parcelRequire("5JMmU");
    var $etyzk = parcelRequire("etyzk");
    function $b645ed9a7ba1767e$var$max(array) {
        return array && array.length ? $la2vn(array, $etyzk, $5JMmU) : undefined;
    }
    module.exports = $b645ed9a7ba1767e$var$max;
});
parcelRegister("la2vn", function(module, exports) {
    var $4faK3 = parcelRequire("4faK3");
    function $f67c7999c5b61dcb$var$baseExtremum(array, iteratee, comparator) {
        var index = -1, length = array.length;
        while(++index < length){
            var value = array[index], current = iteratee(value);
            if (current != null && (computed === undefined ? current === current && !$4faK3(current) : comparator(current, computed))) var computed = current, result = value;
        }
        return result;
    }
    module.exports = $f67c7999c5b61dcb$var$baseExtremum;
});
parcelRegister("5JMmU", function(module, exports) {
    function $42d6acb577163acc$var$baseGt(value, other) {
        return value > other;
    }
    module.exports = $42d6acb577163acc$var$baseGt;
});
parcelRegister("a66wu", function(module, exports) {
    var $la2vn = parcelRequire("la2vn");
    var $48eTY = parcelRequire("48eTY");
    var $etyzk = parcelRequire("etyzk");
    function $759f863f9fd7b392$var$min(array) {
        return array && array.length ? $la2vn(array, $etyzk, $48eTY) : undefined;
    }
    module.exports = $759f863f9fd7b392$var$min;
});
parcelRegister("48eTY", function(module, exports) {
    function $302377fd2186d815$var$baseLt(value, other) {
        return value < other;
    }
    module.exports = $302377fd2186d815$var$baseLt;
});
parcelRegister("4oEhy", function(module, exports) {
    $parcel$export(module.exports, "getProgressHashPure", ()=>$3ce3ff692e2277b3$export$4679bf3e5c8b2fc8);
    $parcel$export(module.exports, "getIssueStatusCategoryHashPure", ()=>$3ce3ff692e2277b3$export$5de6d959ce8dde18);
    $parcel$export(module.exports, "getIssueEdgeReleaseDatesPure", ()=>$3ce3ff692e2277b3$export$f730c9142ca7307);
    $parcel$export(module.exports, "combineIssueIdsFilters", ()=>$3ce3ff692e2277b3$export$78fa515948420196);
    var $4wVpT = parcelRequire("4wVpT");
    var $dPSWJ = parcelRequire("dPSWJ");
    var $4R6GH;
    var $1RlSy;
    const $3ce3ff692e2277b3$export$4679bf3e5c8b2fc8 = (parentIssueIds, childrenHash, issueStatusCategoryHash, statusCategoryKeyHash)=>{
        const progressHash = {};
        const createProgressFromCounts = (progressCounts)=>[
                {
                    id: (0, (0, parcelRequire("1RlSy")).DONE),
                    name: statusCategoryKeyHash[0, (0, parcelRequire("1RlSy")).DONE].name,
                    count: progressCounts[0, (0, parcelRequire("1RlSy")).DONE],
                    color: (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-post-project-a11y-fix') ? "var(--ds-chart-success, #22A06B)" : `var(--ds-border-success, ${0, $829f609a65d26a98$export$940e1f69e873f202})`
                },
                {
                    id: (0, (0, parcelRequire("1RlSy")).IN_PROGRESS),
                    name: statusCategoryKeyHash[0, (0, parcelRequire("1RlSy")).IN_PROGRESS].name,
                    count: progressCounts[0, (0, parcelRequire("1RlSy")).IN_PROGRESS],
                    color: (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-post-project-a11y-fix') ? "var(--ds-chart-information, #388BFF)" : `var(--ds-border-information, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`
                },
                {
                    id: (0, (0, parcelRequire("1RlSy")).TODO),
                    name: statusCategoryKeyHash[0, (0, parcelRequire("1RlSy")).TODO].name,
                    count: progressCounts[0, (0, parcelRequire("1RlSy")).TODO],
                    color: (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-post-project-a11y-fix') ? "var(--ds-chart-neutral, #8590A2)" : `var(--ds-border, ${0, $829f609a65d26a98$export$8754fc7e6d8b3000})`
                }
            ];
        parentIssueIds.forEach((issueId)=>{
            const childIssues = childrenHash[issueId];
            if (childIssues && childIssues.length > 0) {
                const progressCounts = {
                    [(0, (0, parcelRequire("1RlSy")).TODO)]: 0,
                    [(0, (0, parcelRequire("1RlSy")).IN_PROGRESS)]: 0,
                    [(0, (0, parcelRequire("1RlSy")).DONE)]: 0
                };
                childIssues.forEach((childIssueId)=>{
                    const statusCategory = issueStatusCategoryHash[childIssueId];
                    const statusCategoryKey = statusCategory?.key;
                    if (statusCategoryKey && statusCategoryKey !== (0, (0, parcelRequire("1RlSy")).NO_CATEGORY)) progressCounts[statusCategoryKey] += 1;
                });
                progressHash[issueId] = createProgressFromCounts(progressCounts);
            }
        });
        return progressHash;
    };
    const $3ce3ff692e2277b3$export$5de6d959ce8dde18 = (issueStatusCategoryIdHash, fullStatusCategoryHash)=>(0, ($parcel$interopDefault($dPSWJ)))(issueStatusCategoryIdHash, (statusCategoryId)=>statusCategoryId ? fullStatusCategoryHash[statusCategoryId] : undefined);
    const $3ce3ff692e2277b3$export$f730c9142ca7307 = (fullVersionHash, sanitisedIssueVersionIdsHash)=>(0, ($parcel$interopDefault($dPSWJ)))(sanitisedIssueVersionIdsHash, (versionIds)=>{
            let minVersionReleaseDate;
            let maxVersionReleaseDate;
            if (versionIds.length > 0) versionIds.forEach((versionId)=>{
                const versionReleaseDate = fullVersionHash[versionId]?.releaseDate;
                if (versionReleaseDate === undefined) return;
                if (minVersionReleaseDate === undefined || versionReleaseDate < minVersionReleaseDate) minVersionReleaseDate = versionReleaseDate;
                if (maxVersionReleaseDate === undefined || versionReleaseDate > maxVersionReleaseDate) maxVersionReleaseDate = versionReleaseDate;
            });
            return [
                minVersionReleaseDate,
                maxVersionReleaseDate
            ];
        });
    const $3ce3ff692e2277b3$export$78fa515948420196 = (...issueSets)=>(0, ($parcel$interopDefault($4wVpT)))(...issueSets.filter((array)=>array.length > 0));
});
parcelRegister("hEJMC", function(module, exports) {
    $parcel$export(module.exports, "getSafeRankRequest", ()=>$b282ddb2f5247192$export$4c2551ba746466f5);
    $parcel$export(module.exports, "getSafeRankBeforeRequest", ()=>$b282ddb2f5247192$export$f66f8a46cc172ecd);
    var $kVLXA = parcelRequire("kVLXA");
    parcelRequire("fp4O3");
    parcelRequire("d0pqD");
    var $hFyhA;
    const $b282ddb2f5247192$export$4c2551ba746466f5 = (state, request)=>{
        if ('rankAfterId' in request) return (0, (0, parcelRequire("hFyhA")).getSafeId)(state, request.rankAfterId).map((safeIssueId)=>({
                rankAfterId: safeIssueId
            }));
        return (0, (0, parcelRequire("hFyhA")).getSafeId)(state, request.rankBeforeId).map((safeIssueId)=>({
                rankBeforeId: safeIssueId
            }));
    };
    const $b282ddb2f5247192$export$f66f8a46cc172ecd = (state, beforeId)=>{
        if (beforeId !== undefined) return (0, (0, parcelRequire("hFyhA")).getSafeId)(state, beforeId).map((safeIssueId)=>safeIssueId !== undefined ? {
                beforeId: safeIssueId
            } : null);
        return (0, $kVLXA.Observable).of(null);
    };
});
parcelRegister("8ehfB", function(module, exports) {
    $parcel$export(module.exports, "getFieldsForCreateDialogGIC", ()=>$d1a39f21fcc14c93$export$4542e58ddb5b2ec3);
    $parcel$export(module.exports, "getGICReasonOnCreateError", ()=>$d1a39f21fcc14c93$export$b1aafd89216b8b8f);
    var $gccSB = parcelRequire("gccSB");
    var $4HdDJ;
    var $4gYYI;
    var $hFyhA;
    const $d1a39f21fcc14c93$var$asStringArray = (array)=>array;
    const $d1a39f21fcc14c93$export$eb18ffe6388f217a = (issue, projectId, parentIssueKey, epicLinkCustomFieldId, epicNameCustomFieldId)=>{
        const outputPayload = {};
        const { summary: summary, issueTypeId: issueTypeId, assignee: assignee, labels: labels, versionIds: versionIds, componentIds: componentIds, parentId: parentId } = issue;
        outputPayload.project = {
            projectId: projectId
        };
        outputPayload.issueType = {
            issueTypeId: issueTypeId
        };
        if (parentId?.value !== undefined) outputPayload.parentId = {
            parentId: parentId.value
        };
        const otherFields = {
            summary: summary.value
        };
        if (parentIssueKey !== undefined && epicLinkCustomFieldId !== undefined) otherFields.epic = {
            fieldId: epicLinkCustomFieldId,
            fieldValue: `key:${parentIssueKey}`
        };
        if (parentIssueKey === undefined && epicNameCustomFieldId !== undefined) otherFields.epicName = {
            fieldId: epicNameCustomFieldId,
            fieldValue: summary.value
        };
        if (assignee !== undefined) otherFields.assignee = assignee;
        if (labels !== undefined) otherFields.labels = labels;
        if (versionIds !== undefined) otherFields.fixVersions = $d1a39f21fcc14c93$var$asStringArray(versionIds);
        if (componentIds !== undefined) otherFields.components = $d1a39f21fcc14c93$var$asStringArray(componentIds);
        if (Object.keys(otherFields).length > 0) {
            const { defaultValues: defaultValues, fieldIds: fieldIds } = (0, (0, parcelRequire("4HdDJ")).generateDefaultValues)(parentId?.value !== undefined ? {
                parent: parentId.value,
                ...otherFields
            } : otherFields);
            if (!(0, ($parcel$interopDefault($gccSB)))(defaultValues)) outputPayload.defaultValues = defaultValues;
            outputPayload.customFieldsToPreserveOnFormRecreation = fieldIds;
        }
        return outputPayload;
    };
    const $d1a39f21fcc14c93$export$4542e58ddb5b2ec3 = (state, issue, reason)=>{
        const { parentId: parentId } = issue;
        const projectId = (0, (0, parcelRequire("4gYYI")).getProjectId)(state);
        const parentKey = parentId.value ? (0, (0, parcelRequire("hFyhA")).getIssueKeyById)(state, parentId.value) : undefined;
        const epicLinkCustomFieldId = (0, (0, parcelRequire("4gYYI")).getEpicLinkCustomFieldId)(state);
        const epicNameCustomFieldId = (0, (0, parcelRequire("4gYYI")).getEpicNameCustomFieldId)(state);
        return {
            payload: $d1a39f21fcc14c93$export$eb18ffe6388f217a(issue, projectId, parentKey, epicLinkCustomFieldId, epicNameCustomFieldId),
            submitErrorMessage: reason
        };
    };
    const $d1a39f21fcc14c93$export$b1aafd89216b8b8f = (errors)=>{
        const createError = errors && errors.find((e)=>e && e.extensions && e.extensions.statusCode === 400);
        if (createError) return createError.message;
        return undefined;
    };
});
parcelRegister("4HdDJ", function(module, exports) {
    $parcel$export(module.exports, "generateDefaultValues", ()=>$0dff8558153b0cdd$export$300f392f5922240);
    $parcel$export(module.exports, "extractEventAttributes", ()=>$0dff8558153b0cdd$export$1e69307ca1d0a0a);
    $parcel$export(module.exports, "filterCustomFields", ()=>$0dff8558153b0cdd$export$3d0318b836ef9005);
    $parcel$export(module.exports, "mergeDefaultValues", ()=>$0dff8558153b0cdd$export$2b461e4b4c8d36cf);
    $parcel$export(module.exports, "transformGICPayload", ()=>$0dff8558153b0cdd$export$db3a4d24608ba186);
    var $gccSB = parcelRequire("gccSB");
    var $aZsz6 = parcelRequire("aZsz6");
    var $fafYK;
    var $6mTQO;
    const $0dff8558153b0cdd$var$CUSTOM_FIELD_PREFIX = 'customfield';
    const $0dff8558153b0cdd$var$mergePrefilled = (oldPayload, newPayload)=>{
        if (newPayload !== null && newPayload !== undefined) return {
            ...oldPayload,
            ...newPayload
        };
        return oldPayload;
    };
    const $0dff8558153b0cdd$var$returnActualValue = (value)=>{
        if (Array.isArray(value)) return value[0].toString();
        return value.toString();
    };
    const $0dff8558153b0cdd$var$mergeFormat = (format, finalKey, finalValue)=>{
        if (typeof format === 'string') {
            if (format === 'ID') return finalKey;
            return format;
        }
        return Object.keys(format).reduce((accumulator, currentKey)=>{
            const currentValue = format[currentKey];
            if (Array.isArray(currentValue)) {
                const mappedValue = Array.isArray(finalValue) ? finalValue : [
                    finalValue
                ];
                return {
                    ...accumulator,
                    [currentKey]: mappedValue.map((val)=>$0dff8558153b0cdd$var$mergeFormat(currentValue[0], finalKey, val))
                };
            }
            return {
                ...accumulator,
                [currentKey]: currentValue === null ? $0dff8558153b0cdd$var$returnActualValue(finalValue) : $0dff8558153b0cdd$var$mergeFormat(format[currentKey], finalKey, finalValue)
            };
        }, {});
    };
    const $0dff8558153b0cdd$var$generateDefaultValuesForEcosystemAPI = (otherFields)=>{
        const defaultValues = {};
        const fieldIds = [];
        Object.keys(otherFields).forEach((mutationKey)=>{
            const mutationValue = otherFields[mutationKey];
            if ((0, (0, parcelRequire("6mTQO")).ECOSYSTEM_API_FIELD_MAPPER_MUTATION_GROUP)[mutationKey]) {
                const mutationGroup = (0, (0, parcelRequire("6mTQO")).ECOSYSTEM_API_FIELD_MAPPER_MUTATION_GROUP)[mutationKey];
                const formattedValue = (0, (0, parcelRequire("6mTQO")).ECOSYSTEM_API_FIELD_FORMATTER)[mutationGroup](mutationKey, mutationValue);
                if (formattedValue) {
                    const { value: value, type: type } = formattedValue;
                    fieldIds.push(mutationKey);
                    if (!(0, ($parcel$interopDefault($gccSB)))(value)) {
                        if (type === 'array') (defaultValues[mutationGroup] = defaultValues[mutationGroup] || []).push(value);
                        else if (type === 'object') defaultValues[mutationGroup] = value;
                    }
                }
            }
        });
        return {
            defaultValues: defaultValues,
            fieldIds: fieldIds
        };
    };
    const $0dff8558153b0cdd$var$generateDefaultValuesLegacy = (otherFields)=>{
        const defaultValues = {};
        const fieldIds = [];
        Object.keys(otherFields).forEach((mutationKey)=>{
            const mutationValue = otherFields[mutationKey];
            if ((0, (0, parcelRequire("fafYK")).FIELD_MAPPER_MUTATION_GROUP)[mutationKey]) {
                const mutationGroup = (0, (0, parcelRequire("fafYK")).FIELD_MAPPER_MUTATION_GROUP)[mutationKey];
                const { type: type = null, value: depth = null } = (0, (0, parcelRequire("fafYK")).FORMATTER)[mutationGroup];
                let pattern = null;
                if (!(0, ($parcel$interopDefault($gccSB)))(mutationValue) && depth && type) {
                    if (!Array.isArray(mutationValue) && typeof mutationValue === 'object') {
                        const { fieldId: fieldId, fieldValue: fieldValue } = mutationValue;
                        pattern = $0dff8558153b0cdd$var$mergeFormat(depth, fieldId || mutationKey, fieldValue);
                        fieldIds.push(fieldId || mutationKey);
                    } else {
                        pattern = $0dff8558153b0cdd$var$mergeFormat(depth, mutationKey, mutationValue);
                        fieldIds.push(mutationKey);
                    }
                }
                if (!(0, ($parcel$interopDefault($gccSB)))(pattern)) {
                    if (type === 'array') (defaultValues[mutationGroup] = defaultValues[mutationGroup] || []).push(pattern);
                    else if (type === 'object') defaultValues[mutationGroup] = pattern;
                }
            }
        });
        return {
            defaultValues: defaultValues,
            fieldIds: fieldIds
        };
    };
    const $0dff8558153b0cdd$export$300f392f5922240 = (otherFields, isEcosystemAPI = false)=>{
        if (isEcosystemAPI) return $0dff8558153b0cdd$var$generateDefaultValuesForEcosystemAPI(otherFields);
        return $0dff8558153b0cdd$var$generateDefaultValuesLegacy(otherFields);
    };
    const $0dff8558153b0cdd$export$1e69307ca1d0a0a = (trigger)=>{
        const anchor = trigger.nodeName === 'A' ? trigger : trigger.querySelector('a');
        if (anchor) {
            const href = anchor.getAttribute('href');
            const { query: query } = (0, ($parcel$interopDefault($aZsz6)))(href, (qs)=>new URLSearchParams(qs));
            const returnData = {
                prefilledFields: {}
            };
            const pid = anchor.getAttribute('data-pid') || query.get('pid');
            const issuetype = anchor.getAttribute('data-issue-type') || query.get('issuetype');
            const requestype = anchor.getAttribute('data-itsm-category') || query.get('itsmCategory');
            if (pid) returnData.prefilledFields.pid = pid;
            if (issuetype) returnData.prefilledFields.issuetype = issuetype;
            if (requestype) returnData.prefilledFields.requestype = requestype;
            if (!(0, ($parcel$interopDefault($gccSB)))(returnData.prefilledFields)) return returnData;
            return {};
        }
        return {};
    };
    const $0dff8558153b0cdd$export$70cb7a42e309786 = (payload = {}, isEcosystemAPI = false)=>{
        const { prefilledFields: gicPreFilledFields, target: target = null } = payload;
        let prefilledFields = gicPreFilledFields;
        if (target) {
            const newPayload = $0dff8558153b0cdd$export$1e69307ca1d0a0a(target);
            prefilledFields = $0dff8558153b0cdd$var$mergePrefilled(gicPreFilledFields, newPayload.prefilledFields);
        }
        if (!(0, ($parcel$interopDefault($gccSB)))(prefilledFields)) {
            const { fieldsToRetain: fieldsToRetain = [], pid: pid, issuetype: issuetype, requestype: requestype, additionalContext: additionalContext, statusId: statusId, ...otherFields } = prefilledFields;
            const outputPayload = {};
            if ((!(0, ($parcel$interopDefault($gccSB)))(pid) || typeof pid === 'number') && pid !== 'undefined') outputPayload.project = {
                projectId: $0dff8558153b0cdd$var$returnActualValue(pid)
            };
            if (!(0, ($parcel$interopDefault($gccSB)))(issuetype) || typeof issuetype === 'number') outputPayload.issueType = {
                issueTypeId: $0dff8558153b0cdd$var$returnActualValue(issuetype)
            };
            if (!(0, ($parcel$interopDefault($gccSB)))(requestype)) outputPayload.requestType = {
                key: $0dff8558153b0cdd$var$returnActualValue(requestype)
            };
            if (!(0, ($parcel$interopDefault($gccSB)))(otherFields.parentId)) outputPayload.parentId = {
                parentId: $0dff8558153b0cdd$var$returnActualValue(otherFields.parentId)
            };
            if (!(0, ($parcel$interopDefault($gccSB)))(statusId)) outputPayload.status = {
                statusId: statusId
            };
            if (!(0, ($parcel$interopDefault($gccSB)))(additionalContext)) outputPayload.additionalContext = additionalContext;
            if (Object.keys(otherFields).length > 0) {
                const { parentId: parentId, ...otherFieldsWithoutParent } = otherFields;
                const { defaultValues: defaultValues, fieldIds: fieldIds } = $0dff8558153b0cdd$export$300f392f5922240(parentId !== undefined && !(0, ($parcel$interopDefault($gccSB)))(parentId) ? {
                    parent: parentId,
                    ...otherFieldsWithoutParent
                } : otherFieldsWithoutParent, isEcosystemAPI);
                if (!(0, ($parcel$interopDefault($gccSB)))(defaultValues)) outputPayload.defaultValues = defaultValues;
                outputPayload.customFieldsToPreserveOnFormRecreation = [
                    ...fieldsToRetain,
                    ...fieldIds
                ];
            }
            return outputPayload;
        }
        return null;
    };
    const $0dff8558153b0cdd$export$3d0318b836ef9005 = (payload = {})=>{
        const fieldsToPrefill = payload?.prefilledFields;
        if (!fieldsToPrefill) return {};
        const prefilledCustomFields = {};
        const systemFieldsToBeIncluded = [
            'worklog_timeLogged',
            'worklog_startDate',
            'worklog_comment',
            'timetracking_remainingestimate',
            'description',
            'paragraph',
            'environment'
        ];
        Object.keys(fieldsToPrefill).forEach((key)=>{
            if (key.startsWith($0dff8558153b0cdd$var$CUSTOM_FIELD_PREFIX) || systemFieldsToBeIncluded.includes(key)) prefilledCustomFields[key] = fieldsToPrefill[key];
        });
        return prefilledCustomFields;
    };
    const $0dff8558153b0cdd$export$2b461e4b4c8d36cf = (defaultValuesFromAPI = {}, defaultValuesFromFE = {})=>{
        const mergedDefaultValues = JSON.parse(JSON.stringify(defaultValuesFromAPI));
        if (!defaultValuesFromFE) return mergedDefaultValues;
        Object.keys(defaultValuesFromFE).forEach((key)=>{
            if (mergedDefaultValues?.key) mergedDefaultValues[key] = {
                ...mergedDefaultValues[key],
                ...defaultValuesFromFE[key]
            };
            else mergedDefaultValues[key] = defaultValuesFromFE[key];
        });
        return mergedDefaultValues;
    };
    const $0dff8558153b0cdd$export$db3a4d24608ba186 = $0dff8558153b0cdd$export$70cb7a42e309786;
});
parcelRegister("fafYK", function(module, exports) {
    $parcel$export(module.exports, "FORMATTER", ()=>$044a5aa973e46e78$export$92cfe806f4f0ae2f);
    $parcel$export(module.exports, "FIELD_MAPPER_MUTATION_GROUP", ()=>$044a5aa973e46e78$export$6669905e89f27d17);
    const $044a5aa973e46e78$export$92cfe806f4f0ae2f = {
        singleLineTextFields: {
            value: {
                fieldId: 'ID',
                text: null
            },
            type: 'array'
        },
        epicLinkField: {
            value: {
                fieldId: 'ID',
                epicLink: {
                    issueKey: null
                }
            },
            type: 'object'
        },
        sprintsField: {
            value: {
                fieldId: 'ID',
                sprints: [
                    {
                        sprintId: null
                    }
                ]
            },
            type: 'object'
        },
        priority: {
            value: {
                priorityId: 'ID'
            },
            type: 'object'
        },
        datePickerFields: {
            value: {
                fieldId: 'ID',
                date: {
                    formattedDate: null
                }
            },
            type: 'array'
        },
        dateTimePickerFields: {
            value: {
                fieldId: 'ID',
                dateTime: {
                    formattedDateTime: null
                }
            },
            type: 'array'
        },
        labelsFields: {
            value: {
                fieldId: 'ID',
                labels: [
                    {
                        name: null
                    }
                ]
            },
            type: 'array'
        },
        singleSelectUserPickerFields: {
            value: {
                fieldId: 'ID',
                user: {
                    accountId: null
                }
            },
            type: 'array'
        },
        multipleVersionPickerFields: {
            value: {
                fieldId: 'ID',
                versions: [
                    {
                        versionId: null
                    }
                ]
            },
            type: 'array'
        },
        components: {
            value: {
                componentId: null
            },
            type: 'array'
        },
        parentField: {
            value: {
                issueId: null
            },
            type: 'object'
        }
    };
    const $044a5aa973e46e78$export$6669905e89f27d17 = {
        summary: 'singleLineTextFields',
        epic: 'epicLinkField',
        epicName: 'singleLineTextFields',
        duedate: 'datePickerFields',
        startdate: 'datePickerFields',
        plannedStartDate: 'dateTimePickerFields',
        plannedEndDate: 'dateTimePickerFields',
        labels: 'labelsFields',
        sprint: 'sprintsField',
        assignee: 'singleSelectUserPickerFields',
        reporter: 'singleSelectUserPickerFields',
        fixVersions: 'multipleVersionPickerFields',
        components: 'components',
        parent: 'parentField'
    };
});
parcelRegister("6mTQO", function(module, exports) {
    $parcel$export(module.exports, "ECOSYSTEM_API_FIELD_FORMATTER", ()=>$b6c3b74824a18d57$export$8ef3266ee07318b4);
    $parcel$export(module.exports, "ECOSYSTEM_API_FIELD_MAPPER_MUTATION_GROUP", ()=>$b6c3b74824a18d57$export$343b44fa14f045e3);
    var $h5wrT;
    const $b6c3b74824a18d57$export$8ef3266ee07318b4 = {
        security: (id, input)=>{
            if ((0, (0, parcelRequire("h5wrT")).checkIfValidId)(input)) return {
                value: {
                    securityLevelId: Number(input)
                },
                type: 'object'
            };
            if (Array.isArray(input) && input.length > 0 && (0, (0, parcelRequire("h5wrT")).checkIfValidId)(input[0])) return {
                value: {
                    securityLevelId: Number(input[0])
                },
                type: 'object'
            };
        },
        singleLineTextFields: (id, input)=>{
            if (typeof input === 'string' || typeof input === 'number') return {
                value: {
                    fieldId: id,
                    text: input.toString()
                },
                type: 'array'
            };
            if (Array.isArray(input) && input.length > 0) return {
                value: {
                    fieldId: id,
                    text: input[0].toString()
                },
                type: 'array'
            };
        },
        timeTrackingField: (id, input)=>{
            if (typeof input === 'string') return {
                value: {
                    originalEstimate: input
                },
                type: 'object'
            };
            if (Array.isArray(input) && input.length > 0 && typeof input[0] === 'string') return {
                value: {
                    originalEstimate: input[0]
                },
                type: 'object'
            };
        },
        priority: (id, input)=>{
            if ((0, (0, parcelRequire("h5wrT")).checkIfValidId)(input)) return {
                value: {
                    priorityId: Number(input)
                },
                type: 'object'
            };
            if (Array.isArray(input) && input.length > 0 && (0, (0, parcelRequire("h5wrT")).checkIfValidId)(input[0])) return {
                value: {
                    priorityId: Number(input[0])
                },
                type: 'object'
            };
        },
        resolution: (id, input)=>{
            if ((0, (0, parcelRequire("h5wrT")).checkIfValidId)(input)) return {
                value: {
                    resolutionId: Number(input)
                },
                type: 'object'
            };
            if (Array.isArray(input) && input.length > 0 && (0, (0, parcelRequire("h5wrT")).checkIfValidId)(input[0])) return {
                value: {
                    resolutionId: Number(input[0])
                },
                type: 'object'
            };
            return {
                value: {
                    resolutionId: 10000
                },
                type: 'object'
            };
        },
        datePickerFields: (id, input)=>{
            if (typeof input === 'string') {
                const dateInISO = (0, (0, parcelRequire("h5wrT")).findADate)(input);
                if (dateInISO) return {
                    value: {
                        fieldId: id,
                        date: {
                            formattedDate: dateInISO
                        }
                    },
                    type: 'array'
                };
            }
            if (Array.isArray(input) && input.length > 0 && typeof input[0] === 'string') {
                const dateInISO = (0, (0, parcelRequire("h5wrT")).findADate)(input[0]);
                if (dateInISO) return {
                    value: {
                        fieldId: id,
                        date: {
                            formattedDate: dateInISO
                        }
                    },
                    type: 'array'
                };
            }
        },
        dateTimePickerFields: (id, input)=>{
            if (typeof input === 'string') {
                const dateInISO = (0, (0, parcelRequire("h5wrT")).findADate)(input);
                if (dateInISO) return {
                    value: {
                        fieldId: id,
                        dateTime: {
                            formattedDateTime: dateInISO
                        }
                    },
                    type: 'array'
                };
            }
            if (Array.isArray(input) && input.length > 0 && typeof input[0] === 'string') {
                const dateInISO = (0, (0, parcelRequire("h5wrT")).findADate)(input[0]);
                if (dateInISO) return {
                    value: {
                        fieldId: id,
                        dateTime: {
                            formattedDateTime: dateInISO
                        }
                    },
                    type: 'array'
                };
            }
        },
        labelsFields: (id, input)=>{
            let transformedValue = [];
            if (Array.isArray(input) && input.length > 0) {
                for (const label of input)if (typeof label === 'string' || typeof label === 'number') transformedValue.push({
                    name: label.toString()
                });
            } else if (typeof input === 'string' || typeof input === 'number') transformedValue = [
                {
                    name: input.toString()
                }
            ];
            return {
                value: {
                    fieldId: id,
                    labels: transformedValue
                },
                type: 'array'
            };
        },
        multipleVersionPickerFields: (id, input)=>{
            let transformedValue = [];
            if (Array.isArray(input) && input.length > 0) {
                for (const version of input)if ((0, (0, parcelRequire("h5wrT")).checkIfValidId)(version)) transformedValue.push({
                    versionId: Number(version)
                });
            } else if ((0, (0, parcelRequire("h5wrT")).checkIfValidId)(input)) transformedValue = [
                {
                    versionId: Number(input)
                }
            ];
            return {
                value: {
                    fieldId: id,
                    versions: transformedValue
                },
                type: 'array'
            };
        },
        components: (id, input)=>{
            let transformedValue = [];
            if (Array.isArray(input) && input.length > 0) {
                for (const component of input)if ((0, (0, parcelRequire("h5wrT")).checkIfValidId)(component)) transformedValue.push({
                    componentId: Number(component)
                });
            } else if ((0, (0, parcelRequire("h5wrT")).checkIfValidId)(input)) transformedValue = [
                {
                    componentId: Number(input)
                }
            ];
            return {
                value: transformedValue,
                type: 'object'
            };
        },
        parentField: (id, input)=>{
            if ((0, (0, parcelRequire("h5wrT")).checkIfValidId)(input)) return {
                value: {
                    issueId: Number(input)
                },
                type: 'object'
            };
            if (Array.isArray(input) && input.length > 0 && (0, (0, parcelRequire("h5wrT")).checkIfValidId)(input[0])) return {
                value: {
                    issueId: Number(input[0])
                },
                type: 'object'
            };
        }
    };
    const $b6c3b74824a18d57$export$343b44fa14f045e3 = {
        security: 'security',
        resolution: 'resolution',
        summary: 'singleLineTextFields',
        epicName: 'singleLineTextFields',
        duedate: 'datePickerFields',
        startdate: 'datePickerFields',
        labels: 'labelsFields',
        fixVersions: 'multipleVersionPickerFields',
        versions: 'multipleVersionPickerFields',
        components: 'components',
        parent: 'parentField',
        priority: 'priority',
        timetracking_originalestimate: 'timeTrackingField'
    };
});
parcelRegister("h5wrT", function(module, exports) {
    $parcel$export(module.exports, "findADate", ()=>$fc8e7b5490fd5042$export$3ce9cccf56f196eb);
    $parcel$export(module.exports, "checkIfValidId", ()=>$fc8e7b5490fd5042$export$d65005e77da517bc);
    const $fc8e7b5490fd5042$var$monthMap = {
        Jan: '01',
        January: '01',
        Feb: '02',
        February: '02',
        Mar: '03',
        March: '03',
        Apr: '04',
        April: '04',
        May: '05',
        Jun: '06',
        June: '06',
        Jul: '07',
        July: '07',
        Aug: '08',
        August: '08',
        Sep: '09',
        September: '09',
        Oct: '10',
        October: '10',
        Nov: '11',
        November: '11',
        Dec: '12',
        December: '12'
    };
    const $fc8e7b5490fd5042$var$formatDay = (day)=>{
        if (day.length === 1) return `0${day}`;
        return day;
    };
    const $fc8e7b5490fd5042$var$formatMonth = (month)=>{
        if ($fc8e7b5490fd5042$var$monthMap[month]) return $fc8e7b5490fd5042$var$monthMap[month];
        if (month.length === 1) return `0${month}`;
        return month;
    };
    const $fc8e7b5490fd5042$var$formatYear = (year)=>{
        const yearAsNumber = Number(year);
        if (yearAsNumber < 100) return yearAsNumber + 2000;
        return yearAsNumber;
    };
    const $fc8e7b5490fd5042$var$constructISOTime = (time)=>{
        const timeStr = time.trim();
        const time24HourPattern = /^T(\d{1,2}):(\d{2}):?(\d{2})?$/;
        const time12HourPattern = /^@?\s*(\d{1,2}):(\d{2})\s*(am|pm)?$/i;
        const match24Hour = timeStr.match(time24HourPattern);
        if (match24Hour) {
            let [, hours, minutes, seconds] = match24Hour;
            seconds = seconds || '00';
            return `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}:${seconds.padStart(2, '0')}`;
        }
        const match12Hour = timeStr.match(time12HourPattern);
        if (match12Hour) {
            let hours;
            let minutes;
            let ampm;
            [, hours, minutes, ampm] = match12Hour;
            hours = parseInt(hours, 10);
            minutes = parseInt(minutes, 10);
            if (ampm) {
                ampm = ampm.toLowerCase();
                if (ampm === 'pm' && hours !== 12) hours += 12;
                else if (ampm === 'am' && hours === 12) hours = 0;
            }
            return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:00`;
        }
        return '00:00:00';
    };
    const $fc8e7b5490fd5042$var$constructISODateTime = (date)=>{
        const regexForDay = /^(\d{1,2})[/\s-]([A-Za-z]+|\d{1,2})[/\s-](\d{2,4})(.*)/;
        const regexForDateWithYYYYFirst = /^(\d{2,4})[/\s-]([A-Za-z]+|\d{1,2})[/\s-](\d{1,2})(.*)/;
        const matchForDay = date.match(regexForDay);
        const matchForDayWithYYYYFirst = date.match(regexForDateWithYYYYFirst);
        if (matchForDay) {
            const [, day, month, year, time] = matchForDay;
            let formattedDay = $fc8e7b5490fd5042$var$formatDay(day);
            let formattedMonth = $fc8e7b5490fd5042$var$formatMonth(month);
            const formattedYear = $fc8e7b5490fd5042$var$formatYear(year);
            let skipMatchingDay = false;
            if (Number(day) < 13 && Number(month)) [formattedDay, formattedMonth] = [
                formattedMonth,
                formattedDay
            ];
            else if (Number(formattedMonth) > 12) {
                if (Number(formattedDay) < 13) [formattedDay, formattedMonth] = [
                    formattedMonth,
                    formattedDay
                ];
                else skipMatchingDay = true;
            }
            if (!skipMatchingDay) {
                const isoTime = $fc8e7b5490fd5042$var$constructISOTime(time);
                return `${formattedYear}-${formattedMonth}-${formattedDay}T${isoTime}`;
            }
        }
        if (matchForDayWithYYYYFirst) {
            const [, year, month, day, time] = matchForDayWithYYYYFirst;
            let formattedDay = $fc8e7b5490fd5042$var$formatDay(day);
            let formattedMonth = $fc8e7b5490fd5042$var$formatMonth(month);
            const formattedYear = $fc8e7b5490fd5042$var$formatYear(year);
            if (Number(formattedMonth) > 12) {
                if (Number(formattedDay) < 13) [formattedDay, formattedMonth] = [
                    formattedMonth,
                    formattedDay
                ];
                else return null;
            }
            const isoTime = $fc8e7b5490fd5042$var$constructISOTime(time);
            return `${formattedYear}-${formattedMonth}-${formattedDay}T${isoTime}`;
        }
        return null;
    };
    function $fc8e7b5490fd5042$var$convertUnixToISO(unixTimestamp) {
        const date = new Date(unixTimestamp * 1000);
        if (!date.getTime()) return null;
        return date.toISOString().slice(0, 19);
    }
    const $fc8e7b5490fd5042$export$3ce9cccf56f196eb = (defaultValue)=>{
        if (typeof defaultValue === 'number') return $fc8e7b5490fd5042$var$convertUnixToISO(defaultValue);
        if (typeof defaultValue === 'string') {
            if (Number(defaultValue)) return $fc8e7b5490fd5042$var$convertUnixToISO(Number(defaultValue));
            return $fc8e7b5490fd5042$var$constructISODateTime(defaultValue);
        }
        return null;
    };
    const $fc8e7b5490fd5042$export$d65005e77da517bc = (input)=>{
        if ((typeof input === 'string' || typeof input === 'number') && Number(input)) return true;
        return false;
    };
});
parcelRegister("cjHBk", function(module, exports) {
    $parcel$export(module.exports, "performPostCreateSideEffects", ()=>$7c374cb22f9d9e19$export$d5c3aa31cb8a425e);
    var $k8IPx = parcelRequire("k8IPx");
    var $11oYo;
    var $8zOmE;
    var $4gYYI;
    var $hFyhA;
    var $81Y3L;
    var $iET4k;
    var $5NyaP;
    const $7c374cb22f9d9e19$var$DERIVED_FIELD_WHITELIST = [
        'pid',
        'issuetype',
        'summary',
        'reporter'
    ];
    const $7c374cb22f9d9e19$export$d5c3aa31cb8a425e = (state, temporaryId, { id: id, issueTypeId: issueTypeId, parentId: parentId }, analyticsEvent)=>{
        const resolveSafeId = (0, (0, parcelRequire("hFyhA")).getSafeIdResolve)(state, temporaryId);
        resolveSafeId(id);
        if (parentId) {
            const issueKey = (0, (0, parcelRequire("hFyhA")).getIssueKeyById)(state, parentId);
            (0, (0, parcelRequire("5NyaP")).default)(state, issueKey);
        }
        const issueTypeName = (0, (0, parcelRequire("81Y3L")).getIssueTypeName)(state, issueTypeId);
        const safeIssueTypeName = issueTypeName !== undefined && (0, (0, parcelRequire("11oYo")).standardIssueTypes)[issueTypeName] ? issueTypeName : (0, (0, parcelRequire("11oYo")).CUSTOM);
        const clonedAnalyticsEvent = analyticsEvent.clone();
        if (clonedAnalyticsEvent) {
            const jqlFiltersActive = (0, (0, parcelRequire("iET4k")).getIsJQLFiltersActive)(state);
            const derivedFields = (0, (0, parcelRequire("4gYYI")).getFullDerivedFields)(state);
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(clonedAnalyticsEvent, 'issue created', `${id}`, {
                issueTypeId: issueTypeId,
                issueType: safeIssueTypeName,
                projectType: 'software',
                isJQLFiltersApplied: jqlFiltersActive,
                isDerivedFieldsApplied: (0, ($parcel$interopDefault($k8IPx)))(Object.keys(derivedFields), $7c374cb22f9d9e19$var$DERIVED_FIELD_WHITELIST).length > 0
            });
        }
    };
});
parcelRegister("11oYo", function(module, exports) {
    $parcel$export(module.exports, "CUSTOM", ()=>$1b54c33f277795bc$export$952581bc40160893);
    $parcel$export(module.exports, "standardIssueTypes", ()=>$1b54c33f277795bc$export$c5b8a33017b6146a);
    $parcel$export(module.exports, "translatedTaskNames", ()=>$1b54c33f277795bc$export$ae53d86e513cd6);
    const $1b54c33f277795bc$var$EPIC = 'Epic';
    const $1b54c33f277795bc$var$STORY = 'Story';
    const $1b54c33f277795bc$var$BUG = 'Bug';
    const $1b54c33f277795bc$var$TASK = 'Task';
    const $1b54c33f277795bc$export$952581bc40160893 = 'Custom';
    const $1b54c33f277795bc$export$c5b8a33017b6146a = {
        [$1b54c33f277795bc$var$EPIC]: true,
        [$1b54c33f277795bc$var$STORY]: true,
        [$1b54c33f277795bc$var$BUG]: true,
        [$1b54c33f277795bc$var$TASK]: true
    };
    const $1b54c33f277795bc$export$ae53d86e513cd6 = [
        'Task',
        'Aufgabe',
        'Tarea',
        "T\xe2che",
        "\u30BF\u30B9\u30AF",
        "\uC791\uC5C5",
        'Tarefa',
        "\u0417\u0430\u0434\u0430\u0447\u0430",
        "\xdakol",
        "\xdclesanne",
        "Teht\xe4v\xe4",
        'Feladat',
        'Verk',
        'Taak',
        'Opgave',
        'Oppgave',
        'Zadanie',
        'Activitate',
        "\u0417\u0430\u0434\u0430\u0447\u0430",
        "\xdaloha",
        'Uppgift',
        "G\xf6rev",
        "Nhi\u1EC7m v\u1EE5",
        "\u4EFB\u52A1",
        "\u4EFB\u52D9",
        "Attivit\xe0"
    ];
});
parcelRegister("81Y3L", function(module, exports) {
    $parcel$export(module.exports, "getIssueTypeName", ()=>$56ccf094e0f3625c$export$7fbe5338a34739de);
    var $4gYYI;
    const $56ccf094e0f3625c$export$7fbe5338a34739de = (state, issueTypeId)=>(0, (0, parcelRequire("4gYYI")).getIssueType)(state, issueTypeId).name;
});
parcelRegister("5NyaP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$50942d49f1cb509d$export$2e2bcd8739ae039);
    var $3BIWb;
    var $fWch8;
    var $50942d49f1cb509d$export$2e2bcd8739ae039 = (state, issueKey)=>{
        if (issueKey !== undefined && (0, (0, parcelRequire("fWch8")).getSelectedIssueKey)(state) === issueKey) (0, (0, parcelRequire("3BIWb")).default).refreshIssuePage(issueKey);
    };
});
parcelRegister("3BIWb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b65e83eb4ced9ce9$export$2e2bcd8739ae039);
    var $afs7f;
    const $b65e83eb4ced9ce9$var$REFRESH_ISSUE_PAGE_EVENT = 'legacy_refreshIssuePage';
    const $b65e83eb4ced9ce9$var$UPDATE_ISSUE_GLANCE_EVENT = 'legacy_updateIssueGlance';
    const $b65e83eb4ced9ce9$var$addEventListener = (event, callback)=>{
        document.addEventListener(event, callback);
    };
    const $b65e83eb4ced9ce9$var$removeEventListener = (event, callback)=>{
        document.removeEventListener(event, callback);
    };
    const $b65e83eb4ced9ce9$var$addRefreshIssueListener = (callback)=>$b65e83eb4ced9ce9$var$addEventListener($b65e83eb4ced9ce9$var$REFRESH_ISSUE_PAGE_EVENT, callback);
    const $b65e83eb4ced9ce9$var$removeRefreshIssueListener = (callback)=>$b65e83eb4ced9ce9$var$removeEventListener($b65e83eb4ced9ce9$var$REFRESH_ISSUE_PAGE_EVENT, callback);
    const $b65e83eb4ced9ce9$var$addUpdateIssueGlanceListener = (callback)=>$b65e83eb4ced9ce9$var$addEventListener($b65e83eb4ced9ce9$var$UPDATE_ISSUE_GLANCE_EVENT, callback);
    const $b65e83eb4ced9ce9$var$removeUpdateIssueGlanceListener = (callback)=>$b65e83eb4ced9ce9$var$removeEventListener($b65e83eb4ced9ce9$var$UPDATE_ISSUE_GLANCE_EVENT, callback);
    const $b65e83eb4ced9ce9$var$refreshIssuePageThrowable = (issueKey, reason = (0, (0, parcelRequire("afs7f")).Reason).OnDemand)=>{
        try {
            document.dispatchEvent(new CustomEvent($b65e83eb4ced9ce9$var$REFRESH_ISSUE_PAGE_EVENT, {
                detail: [
                    issueKey,
                    {
                        mergeIntoCurrent: false,
                        reason: reason
                    }
                ]
            }));
            return Promise.resolve();
        } catch (e) {
            return Promise.reject(e);
        }
    };
    const $b65e83eb4ced9ce9$var$refreshIssuePage = (issueKey)=>$b65e83eb4ced9ce9$var$refreshIssuePageThrowable(issueKey).catch(()=>{});
    var $b65e83eb4ced9ce9$export$2e2bcd8739ae039 = {
        addRefreshIssueListener: $b65e83eb4ced9ce9$var$addRefreshIssueListener,
        removeRefreshIssueListener: $b65e83eb4ced9ce9$var$removeRefreshIssueListener,
        addUpdateIssueGlanceListener: $b65e83eb4ced9ce9$var$addUpdateIssueGlanceListener,
        removeUpdateIssueGlanceListener: $b65e83eb4ced9ce9$var$removeUpdateIssueGlanceListener,
        refreshIssuePageThrowable: $b65e83eb4ced9ce9$var$refreshIssuePageThrowable,
        refreshIssuePage: $b65e83eb4ced9ce9$var$refreshIssuePage
    };
});
parcelRegister("afs7f", function(module, exports) {
    $parcel$export(module.exports, "Reason", ()=>$90b3aba4b3cc23bb$export$fe867595c4640fb1);
    const $90b3aba4b3cc23bb$export$fe867595c4640fb1 = {
        OnDemand: 'ON_DEMAND',
        SoftRefresh: 'SOFT_REFRESH',
        Realtime: 'REALTIME'
    };
});
parcelRegister("ibwkC", function(module, exports) {
    $parcel$export(module.exports, "derivedFieldsToIssueContext", ()=>$6ca7025920d9fc88$export$783926c2768c855b);
    $parcel$export(module.exports, "mergeIssueContexts", ()=>$6ca7025920d9fc88$export$212c66f230e8034);
    var $1UikQ = parcelRequire("1UikQ");
    var $kFsv3;
    const $6ca7025920d9fc88$var$LABELS_FIELD_ID = 'labels';
    const $6ca7025920d9fc88$var$DUE_DATE_FIELD_ID = 'duedate';
    const $6ca7025920d9fc88$var$VERSION_FIELD_ID = 'fixVersions';
    const $6ca7025920d9fc88$var$COMPONENT_FIELD_ID = 'components';
    const $6ca7025920d9fc88$export$783926c2768c855b = (derivedFieldsHash, sprintCustomFieldId)=>{
        const resultIssueContext = {};
        Object.keys(derivedFieldsHash).forEach((fieldName)=>{
            switch(fieldName){
                case $6ca7025920d9fc88$var$LABELS_FIELD_ID:
                    resultIssueContext.labels = derivedFieldsHash[fieldName];
                    break;
                case $6ca7025920d9fc88$var$DUE_DATE_FIELD_ID:
                    resultIssueContext.dueDate = {
                        value: Number(derivedFieldsHash[fieldName][0]) || undefined
                    };
                    break;
                case $6ca7025920d9fc88$var$VERSION_FIELD_ID:
                    break;
                case $6ca7025920d9fc88$var$COMPONENT_FIELD_ID:
                    break;
                case sprintCustomFieldId:
                    resultIssueContext.sprintIds = {
                        value: derivedFieldsHash[fieldName]
                    };
                    break;
                default:
                    break;
            }
        });
        return resultIssueContext;
    };
    const $6ca7025920d9fc88$export$212c66f230e8034 = (...contexts)=>{
        const defaultContext = {
            inCreation: true,
            key: undefined,
            summary: {
                value: ''
            },
            startDate: {
                value: undefined
            },
            dueDate: {
                value: undefined
            },
            status: undefined,
            color: {
                value: (0, (0, parcelRequire("kFsv3")).PURPLE)
            },
            assignee: undefined,
            issueTypeId: '',
            parentId: {
                value: ''
            },
            dependencies: [],
            rank: '1',
            labels: [],
            sprintIds: {
                value: []
            },
            versionIds: [],
            componentIds: [],
            resolved: false,
            flagged: false
        };
        const contextsWithoutMultipleValueFields = contexts.map(({ labels: labels, ...remainingFields })=>({
                ...remainingFields
            }));
        const resultIssue = (0, ($parcel$interopDefault($1UikQ)))(defaultContext, ...contextsWithoutMultipleValueFields);
        contexts.forEach(({ labels: labels = [] })=>{
            resultIssue.labels.push(...labels);
        });
        return resultIssue;
    };
});
parcelRegister("6goAf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0332df0708163aaf$export$2e2bcd8739ae039);
    parcelRequire("fp4O3");
    var $aB8eX = parcelRequire("aB8eX");
    var $kVLXA = parcelRequire("kVLXA");
    var $4gYYI;
    var $gsBJe;
    var $k6Vft;
    var $lEiof;
    var $8ehfB;
    const $0332df0708163aaf$var$requiredFieldsCreate = (store, { payload: { level: level } }, optimisticIssue)=>{
        const state = store.getState();
        const projectId = (0, (0, parcelRequire("4gYYI")).getProjectId)(state);
        const { issueTypeId: issueTypeId } = optimisticIssue;
        return (0, $kVLXA.Observable).of((0, $aB8eX.batchActions)([
            (0, (0, parcelRequire("gsBJe")).addPayloadGlobalIssueCreate)((0, (0, parcelRequire("8ehfB")).getFieldsForCreateDialogGIC)(state, optimisticIssue)),
            (0, (0, parcelRequire("k6Vft")).updateCreationPreferences)({
                itemTypeId: issueTypeId,
                level: level,
                projectId: projectId
            }),
            (0, (0, parcelRequire("lEiof")).resetCreateItemAnchor)()
        ]));
    };
    var $0332df0708163aaf$export$2e2bcd8739ae039 = $0332df0708163aaf$var$requiredFieldsCreate;
});
parcelRegister("5U9gn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$50abe963439c8f3e$export$2e2bcd8739ae039);
    var $e1AU2 = parcelRequire("e1AU2");
    var $3pOTA;
    var $eB39a;
    var $50abe963439c8f3e$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, (0, parcelRequire("3pOTA")).default), (0, (0, parcelRequire("eB39a")).default));
});
parcelRegister("3pOTA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dde74be7946c03fe$export$2e2bcd8739ae039);
    parcelRequire("jFVZ1");
    parcelRequire("fp4O3");
    parcelRequire("6hSeW");
    parcelRequire("c66Ur");
    parcelRequire("d0pqD");
    parcelRequire("fPS7b");
    parcelRequire("3ldUM");
    var $aB8eX = parcelRequire("aB8eX");
    var $kVLXA = parcelRequire("kVLXA");
    var $dJl1T;
    var $4R6GH;
    var $8zOmE;
    var $i7dwB;
    var $9fPrG;
    var $4gYYI;
    var $1VLi2;
    var $hFyhA;
    var $hb2iR;
    var $hhYQB;
    var $9QFr0;
    var $iWNPa;
    var $8z00f;
    var $bFYz9;
    var $5NyaP;
    var $5gPYT;
    const $dde74be7946c03fe$export$1ca7cc4cb19d0dda = (state, action)=>{
        const existingDependencies = (0, (0, parcelRequire("hFyhA")).getIssueDependenciesHash)(state);
        const { dependency: dependency, dependee: dependee } = action.payload;
        return existingDependencies[dependee]?.includes(dependency);
    };
    const $dde74be7946c03fe$var$fireAnalytics = (state, action, analyticsAction)=>{
        const clonedEvent = action.meta.analyticsEvent.clone();
        const { dependency: dependency, dependee: dependee } = action.payload;
        if (clonedEvent) (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(clonedEvent, `issueDependency ${analyticsAction}`, {
            dependeeLevel: (0, (0, parcelRequire("hFyhA")).getIssueLevel)(state, dependee),
            dependencyLevel: (0, (0, parcelRequire("hFyhA")).getIssueLevel)(state, dependency)
        });
    };
    var $dde74be7946c03fe$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, (0, parcelRequire("1VLi2")).CREATE_DEPENDENCY)).map((action)=>{
            const state = store.getState();
            const payload = {
                dependee: (0, (0, parcelRequire("hFyhA")).getIssueKeyById)(state, action.payload.dependee),
                dependency: (0, (0, parcelRequire("hFyhA")).getIssueKeyById)(state, action.payload.dependency)
            };
            if (!payload.dependency || !payload.dependee || payload.dependency === payload.dependee) return (0, $kVLXA.Observable).empty();
            const isCyclic = (0, (0, parcelRequire("iWNPa")).isDependencyCyclic)({
                dependenciesHash: (0, (0, parcelRequire("hFyhA")).getIssueDependenciesHash)(state),
                dependency: action.payload.dependency,
                dependee: action.payload.dependee
            });
            if (isCyclic) {
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('roadmap.standard.issues-add-dependency', 'Dependency cycle exceeds supported depth.');
                return (0, $kVLXA.Observable).of((0, (0, parcelRequire("hb2iR")).dependencyCycleCreation)(payload));
            }
            if ($dde74be7946c03fe$export$1ca7cc4cb19d0dda(state, action)) return (0, $kVLXA.Observable).of((0, (0, parcelRequire("hb2iR")).dependencyDuplication)(payload));
            if (!(0, (0, parcelRequire("4gYYI")).areDependenciesSupported)(store.getState())) {
                $dde74be7946c03fe$var$fireAnalytics(store.getState(), action, 'addFailed');
                return (0, $kVLXA.Observable).of((0, (0, parcelRequire("hb2iR")).dependenciesUnavailable)());
            }
            const sourceARI = (0, (0, parcelRequire("9fPrG")).getSourceARI)(state);
            const inputObservable = (0, (0, parcelRequire("5gPYT")).getSafeDependencyInput)(state, action.payload);
            const longRunning = inputObservable.mergeMap((input)=>{
                const { dependee: dependee, dependency: dependency } = input;
                const addDependencyOnBackendPromise = (0, (0, parcelRequire("i7dwB")).addDependencyOnServer)({
                    sourceARI: sourceARI,
                    input: {
                        dependee: dependee,
                        dependency: dependency
                    }
                }).mergeMap((data)=>{
                    const addRoadmapDependencyData = data?.roadmaps?.addRoadmapDependency;
                    const errors = addRoadmapDependencyData?.errors;
                    const success = addRoadmapDependencyData?.success;
                    if (success === false && errors?.length) {
                        if ((0, (0, parcelRequire("8z00f")).isPermissionError)(errors)) {
                            const actions = [
                                (0, (0, parcelRequire("1VLi2")).deleteDependency)(action.payload),
                                (0, (0, parcelRequire("hb2iR")).dependenciesPermission)({
                                    type: (0, $438c68509b62d950$export$706a65ec8b4360e1),
                                    dependeeKey: (0, (0, parcelRequire("hFyhA")).getIssueKeyHash)(state)[action.payload.dependee],
                                    dependencyKey: (0, (0, parcelRequire("hFyhA")).getIssueKeyHash)(state)[action.payload.dependency]
                                })
                            ];
                            return (0, $kVLXA.Observable).of((0, $aB8eX.batchActions)(actions));
                        }
                        return (0, (0, parcelRequire("bFYz9")).onHandleAggErrors)(!!addRoadmapDependencyData, errors).map((aggErrorAction)=>(0, $aB8eX.batchActions)([
                                (0, (0, parcelRequire("1VLi2")).deleteDependency)(action.payload),
                                aggErrorAction
                            ]));
                    }
                    (0, (0, parcelRequire("5NyaP")).default)(state, (0, (0, parcelRequire("hFyhA")).getIssueKeyById)(state, action.payload.dependee));
                    (0, (0, parcelRequire("5NyaP")).default)(state, (0, (0, parcelRequire("hFyhA")).getIssueKeyById)(state, action.payload.dependency));
                    $dde74be7946c03fe$var$fireAnalytics(store.getState(), action, 'added');
                    if ((0, (0, parcelRequire("hhYQB")).isDependenciesVisible)(store.getState())) return (0, $kVLXA.Observable).empty();
                    return (0, $kVLXA.Observable).of((0, (0, parcelRequire("hb2iR")).hiddenDependencyCreated)());
                });
                return addDependencyOnBackendPromise.catch(()=>{
                    const actions = [
                        (0, (0, parcelRequire("1VLi2")).deleteDependency)(action.payload),
                        (0, (0, parcelRequire("hb2iR")).aggError)()
                    ];
                    return (0, $kVLXA.Observable).of((0, $aB8eX.batchActions)(actions));
                });
            });
            return (0, $kVLXA.Observable).concat((0, $kVLXA.Observable).of((0, (0, parcelRequire("1VLi2")).addDependency)(action.payload)), longRunning, (0, (0, parcelRequire("4R6GH")).fg)('jsw-roadmap-state-change-based-issue-hidden-flags') ? (0, $kVLXA.Observable).empty() : (0, $kVLXA.Observable).of((0, (0, parcelRequire("9QFr0")).reapplyJQLFilters)()));
        }).mergeAll();
});
parcelRegister("i7dwB", function(module, exports) {
    $parcel$export(module.exports, "addDependencyOnServer", ()=>$c7293c0ea3eef7a6$export$aee09e3d42b0625e);
    var $eWVBN;
    var $lQmZK;
    var $8C5lr;
    const $c7293c0ea3eef7a6$var$mutationName = 'addRoadmapDependency';
    const $c7293c0ea3eef7a6$var$concurrentMetricDefinition = (0, (0, parcelRequire("8C5lr")).mutationMetrics)[0, $8038b72ffd5aa8d4$export$5913ec3a0f9505fe];
    const $c7293c0ea3eef7a6$var$analyticKey = 'jira.frontend.fe.software.roadmap.dependency-added';
    const $c7293c0ea3eef7a6$export$aee09e3d42b0625e = ({ sourceARI: sourceARI, input: input })=>(0, (0, parcelRequire("lQmZK")).runMutation)($c7293c0ea3eef7a6$var$mutationName, (0, (0, parcelRequire("eWVBN")).default), {
            sourceARI: sourceARI,
            input: input
        }, $c7293c0ea3eef7a6$var$analyticKey, $c7293c0ea3eef7a6$var$concurrentMetricDefinition);
});
parcelRegister("eWVBN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8da0f1433773883b$export$2e2bcd8739ae039);
    const $8da0f1433773883b$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "sourceARI"
        }, v2 = [
            {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
            },
            {
                "kind": "Variable",
                "name": "sourceARI",
                "variableName": "sourceARI"
            }
        ], v3 = {
            "kind": "ScalarField",
            "name": "success"
        }, v4 = {
            "kind": "ScalarField",
            "name": "message"
        }, v5 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "statusCode"
                },
                {
                    "kind": "ScalarField",
                    "name": "errorType"
                }
            ],
            "type": "RoadmapMutationErrorExtension"
        }, v6 = {
            "concreteType": "RoadmapToggleDependencyResponse",
            "kind": "LinkedField",
            "name": "output",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "dependee"
                },
                {
                    "kind": "ScalarField",
                    "name": "dependency"
                }
            ]
        };
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1
                ],
                "kind": "Fragment",
                "name": "addRoadmapDependencyMutation",
                "selections": [
                    {
                        "concreteType": "RoadmapsMutation",
                        "kind": "LinkedField",
                        "name": "roadmaps",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2,
                                "concreteType": "RoadmapToggleDependencyPayload",
                                "kind": "LinkedField",
                                "name": "addRoadmapDependency",
                                "plural": false,
                                "selections": [
                                    v3,
                                    {
                                        "concreteType": "MutationError",
                                        "kind": "LinkedField",
                                        "name": "errors",
                                        "plural": true,
                                        "selections": [
                                            v4,
                                            {
                                                "kind": "LinkedField",
                                                "name": "extensions",
                                                "plural": false,
                                                "selections": [
                                                    v5
                                                ]
                                            }
                                        ]
                                    },
                                    v6
                                ]
                            }
                        ]
                    }
                ],
                "type": "Mutation"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v1,
                    v0
                ],
                "kind": "Operation",
                "name": "addRoadmapDependencyMutation",
                "selections": [
                    {
                        "concreteType": "RoadmapsMutation",
                        "kind": "LinkedField",
                        "name": "roadmaps",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2,
                                "concreteType": "RoadmapToggleDependencyPayload",
                                "kind": "LinkedField",
                                "name": "addRoadmapDependency",
                                "plural": false,
                                "selections": [
                                    v3,
                                    {
                                        "concreteType": "MutationError",
                                        "kind": "LinkedField",
                                        "name": "errors",
                                        "plural": true,
                                        "selections": [
                                            v4,
                                            {
                                                "kind": "LinkedField",
                                                "name": "extensions",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "__typename"
                                                    },
                                                    v5,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "id"
                                                            }
                                                        ],
                                                        "type": "BulkMutationErrorExtension"
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    v6
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "5128cd59d6a48d3cf837c81e4baf8846c37dc31eba1fd40ee0fb65591718c84b",
                "metadata": {},
                "name": "addRoadmapDependencyMutation",
                "operationKind": "mutation",
                "text": null
            }
        };
    }();
    $8da0f1433773883b$var$node.hash = "32cf0e6cedae9ac26e7413c9b16a5074";
    var $8da0f1433773883b$export$2e2bcd8739ae039 = $8da0f1433773883b$var$node;
});
parcelRegister("iWNPa", function(module, exports) {
    $parcel$export(module.exports, "isDependencyCyclic", ()=>$e4aabea14a210bb9$export$1ad746945d35a8c6);
    const $e4aabea14a210bb9$var$MAX_DEPTH = 10;
    const $e4aabea14a210bb9$export$1ad746945d35a8c6 = ({ dependenciesHash: dependenciesHash, dependency: dependency, dependee: dependee, maxDepth: maxDepth = $e4aabea14a210bb9$var$MAX_DEPTH })=>{
        const visited = {};
        const findPath = (node, depth)=>{
            if (visited[node]) return false;
            visited[node] = true;
            if (depth >= maxDepth) return false;
            if (node === dependee) return true;
            const connectedNodes = dependenciesHash[node] ?? [];
            return connectedNodes.some((connectedNode)=>findPath(connectedNode, depth + 1));
        };
        return findPath(dependency, 0);
    };
});
parcelRegister("8z00f", function(module, exports) {
    $parcel$export(module.exports, "isPermissionError", ()=>$357e9acd59eb97b6$export$e11674744930cd15);
    const $357e9acd59eb97b6$export$e11674744930cd15 = (errors)=>errors.filter((error)=>error.extensions?.statusCode === 403).length > 0;
});
parcelRegister("5gPYT", function(module, exports) {
    $parcel$export(module.exports, "getSafeDependencyInput", ()=>$c87d11c9f79ab7d5$export$f57851ce68faa479);
    var $kVLXA = parcelRequire("kVLXA");
    parcelRequire("aSIuP");
    var $hFyhA;
    const $c87d11c9f79ab7d5$export$f57851ce68faa479 = (state, payload)=>(0, $kVLXA.Observable).zip((0, (0, parcelRequire("hFyhA")).getSafeId)(state, payload.dependee), (0, (0, parcelRequire("hFyhA")).getSafeId)(state, payload.dependency), (safeDependeeId, safeDependencyId)=>({
                dependee: safeDependeeId,
                dependency: safeDependencyId
            }));
});
parcelRegister("eB39a", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3e2a9bbeb6066444$export$2e2bcd8739ae039);
    parcelRequire("jFVZ1");
    parcelRequire("6hSeW");
    parcelRequire("fp4O3");
    parcelRequire("c66Ur");
    parcelRequire("d0pqD");
    parcelRequire("fPS7b");
    var $aB8eX = parcelRequire("aB8eX");
    var $kVLXA = parcelRequire("kVLXA");
    var $4R6GH;
    var $8zOmE;
    var $feZN4;
    var $9fPrG;
    var $1VLi2;
    var $hFyhA;
    var $hb2iR;
    var $9QFr0;
    var $8z00f;
    var $bFYz9;
    var $5NyaP;
    var $5gPYT;
    var $3e2a9bbeb6066444$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, (0, parcelRequire("1VLi2")).REMOVE_DEPENDENCY)).mergeMap((action)=>{
            const { payload: payload, meta: { analyticsEvent: analyticsEvent } } = action;
            const state = store.getState();
            const inputObservable = (0, (0, parcelRequire("5gPYT")).getSafeDependencyInput)(state, action.payload);
            const sourceARI = (0, (0, parcelRequire("9fPrG")).getSourceARI)(state);
            const longRunning = inputObservable.mergeMap((input)=>{
                const { dependee: dependee, dependency: dependency } = input;
                const removeDependencyOnBackendPromise = (0, (0, parcelRequire("feZN4")).removeDependencyOnServer)({
                    sourceARI: sourceARI,
                    input: {
                        dependee: dependee,
                        dependency: dependency
                    }
                }).mergeMap((data)=>{
                    const removeRoadmapDependencyData = data?.roadmaps?.removeRoadmapDependency;
                    const errors = removeRoadmapDependencyData?.errors;
                    const success = removeRoadmapDependencyData?.success;
                    if (success === false && errors?.length) {
                        if ((0, (0, parcelRequire("8z00f")).isPermissionError)(errors)) {
                            const actions = [
                                (0, (0, parcelRequire("1VLi2")).addDependency)(payload),
                                (0, (0, parcelRequire("hb2iR")).dependenciesPermission)({
                                    type: (0, $438c68509b62d950$export$4e33c4fb4fd4616f),
                                    dependeeKey: (0, (0, parcelRequire("hFyhA")).getIssueKeyHash)(state)[payload.dependee],
                                    dependencyKey: (0, (0, parcelRequire("hFyhA")).getIssueKeyHash)(state)[payload.dependency]
                                })
                            ];
                            return (0, $kVLXA.Observable).of((0, $aB8eX.batchActions)(actions));
                        }
                        return (0, (0, parcelRequire("bFYz9")).onHandleAggErrors)(!!removeRoadmapDependencyData, errors).map((aggErrorAction)=>(0, $aB8eX.batchActions)([
                                (0, (0, parcelRequire("1VLi2")).addDependency)(payload),
                                aggErrorAction
                            ]));
                    }
                    (0, (0, parcelRequire("5NyaP")).default)(state, (0, (0, parcelRequire("hFyhA")).getIssueKeyById)(state, payload.dependee));
                    (0, (0, parcelRequire("5NyaP")).default)(state, (0, (0, parcelRequire("hFyhA")).getIssueKeyById)(state, payload.dependency));
                    (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, 'issueDependency deleted', {
                        dependeeLevel: (0, (0, parcelRequire("hFyhA")).getIssueLevel)(state, payload.dependee),
                        dependencyLevel: (0, (0, parcelRequire("hFyhA")).getIssueLevel)(state, payload.dependency)
                    });
                    return (0, $kVLXA.Observable).empty();
                });
                return removeDependencyOnBackendPromise.catch(()=>{
                    const actions = [
                        (0, (0, parcelRequire("1VLi2")).addDependency)(payload),
                        (0, (0, parcelRequire("hb2iR")).aggError)()
                    ];
                    return (0, $kVLXA.Observable).of((0, $aB8eX.batchActions)(actions));
                });
            });
            return (0, $kVLXA.Observable).concat((0, $kVLXA.Observable).of((0, (0, parcelRequire("1VLi2")).deleteDependency)(payload)), longRunning, (0, (0, parcelRequire("4R6GH")).fg)('jsw-roadmap-state-change-based-issue-hidden-flags') ? (0, $kVLXA.Observable).empty() : (0, $kVLXA.Observable).of((0, (0, parcelRequire("9QFr0")).reapplyJQLFilters)()));
        });
});
parcelRegister("feZN4", function(module, exports) {
    $parcel$export(module.exports, "removeDependencyOnServer", ()=>$0d4ba481b7cd7b66$export$6177c0c69879770e);
    var $iwB43;
    var $lQmZK;
    var $8C5lr;
    const $0d4ba481b7cd7b66$var$mutationName = 'removeRoadmapDependency';
    const $0d4ba481b7cd7b66$var$concurrentMetricDefinition = (0, (0, parcelRequire("8C5lr")).mutationMetrics)[0, $8038b72ffd5aa8d4$export$488a6fa9078615df];
    const $0d4ba481b7cd7b66$var$analyticKey = 'jira.frontend.fe.software.roadmap.dependency-removed';
    const $0d4ba481b7cd7b66$export$6177c0c69879770e = ({ sourceARI: sourceARI, input: input })=>(0, (0, parcelRequire("lQmZK")).runMutation)($0d4ba481b7cd7b66$var$mutationName, (0, (0, parcelRequire("iwB43")).default), {
            sourceARI: sourceARI,
            input: input
        }, $0d4ba481b7cd7b66$var$analyticKey, $0d4ba481b7cd7b66$var$concurrentMetricDefinition);
});
parcelRegister("iwB43", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$080cb751d6b2a250$export$2e2bcd8739ae039);
    const $080cb751d6b2a250$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "sourceARI"
        }, v2 = [
            {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
            },
            {
                "kind": "Variable",
                "name": "sourceARI",
                "variableName": "sourceARI"
            }
        ], v3 = {
            "kind": "ScalarField",
            "name": "success"
        }, v4 = {
            "kind": "ScalarField",
            "name": "message"
        }, v5 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "statusCode"
                },
                {
                    "kind": "ScalarField",
                    "name": "errorType"
                }
            ],
            "type": "RoadmapMutationErrorExtension"
        }, v6 = {
            "concreteType": "RoadmapToggleDependencyResponse",
            "kind": "LinkedField",
            "name": "output",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "dependee"
                },
                {
                    "kind": "ScalarField",
                    "name": "dependency"
                }
            ]
        };
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1
                ],
                "kind": "Fragment",
                "name": "removeRoadmapDependencyMutation",
                "selections": [
                    {
                        "concreteType": "RoadmapsMutation",
                        "kind": "LinkedField",
                        "name": "roadmaps",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2,
                                "concreteType": "RoadmapToggleDependencyPayload",
                                "kind": "LinkedField",
                                "name": "removeRoadmapDependency",
                                "plural": false,
                                "selections": [
                                    v3,
                                    {
                                        "concreteType": "MutationError",
                                        "kind": "LinkedField",
                                        "name": "errors",
                                        "plural": true,
                                        "selections": [
                                            v4,
                                            {
                                                "kind": "LinkedField",
                                                "name": "extensions",
                                                "plural": false,
                                                "selections": [
                                                    v5
                                                ]
                                            }
                                        ]
                                    },
                                    v6
                                ]
                            }
                        ]
                    }
                ],
                "type": "Mutation"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v1,
                    v0
                ],
                "kind": "Operation",
                "name": "removeRoadmapDependencyMutation",
                "selections": [
                    {
                        "concreteType": "RoadmapsMutation",
                        "kind": "LinkedField",
                        "name": "roadmaps",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2,
                                "concreteType": "RoadmapToggleDependencyPayload",
                                "kind": "LinkedField",
                                "name": "removeRoadmapDependency",
                                "plural": false,
                                "selections": [
                                    v3,
                                    {
                                        "concreteType": "MutationError",
                                        "kind": "LinkedField",
                                        "name": "errors",
                                        "plural": true,
                                        "selections": [
                                            v4,
                                            {
                                                "kind": "LinkedField",
                                                "name": "extensions",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "__typename"
                                                    },
                                                    v5,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "id"
                                                            }
                                                        ],
                                                        "type": "BulkMutationErrorExtension"
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    v6
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "17bdaad9cdc6a0a9bdd038723300f6b082d5eedd61a018c8aa37141dc03e5645",
                "metadata": {},
                "name": "removeRoadmapDependencyMutation",
                "operationKind": "mutation",
                "text": null
            }
        };
    }();
    $080cb751d6b2a250$var$node.hash = "f2c55864aaec3b444aa411cc582decd9";
    var $080cb751d6b2a250$export$2e2bcd8739ae039 = $080cb751d6b2a250$var$node;
});
parcelRegister("7n3n2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b945762e4b874a3a$export$2e2bcd8739ae039);
    parcelRequire("fp4O3");
    parcelRequire("fPS7b");
    parcelRequire("6hSeW");
    var $kVLXA = parcelRequire("kVLXA");
    var $hFyhA;
    var $5EEYw;
    var $2IdXh;
    var $lEiof;
    var $bM42j;
    var $b945762e4b874a3a$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, (0, parcelRequire("5EEYw")).ROUTER_LOCATION_CHANGE)).mergeMap(()=>{
            const state = store.getState();
            const issueId = (0, (0, parcelRequire("2IdXh")).getSelectedIssueId)(state);
            if (issueId) {
                const parentId = (0, (0, parcelRequire("hFyhA")).getIssueParentIdHash)(state)[issueId];
                if (parentId && !(0, (0, parcelRequire("bM42j")).getExpandedItems)(state)[parentId]) return (0, $kVLXA.Observable).of((0, (0, parcelRequire("lEiof")).changeExpansionState)({
                    id: parentId,
                    isExpanded: true
                }));
            }
            return (0, $kVLXA.Observable).empty();
        });
});
parcelRegister("ibyhg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e7ba5b706afc13d5$export$2e2bcd8739ae039);
    parcelRequire("fp4O3");
    parcelRequire("fPS7b");
    parcelRequire("6hSeW");
    var $jpUKq = parcelRequire("jpUKq");
    var $2gnC5 = parcelRequire("2gnC5");
    var $kVLXA = parcelRequire("kVLXA");
    var $dJl1T;
    var $2WFZU;
    var $4gYYI;
    var $hFyhA;
    var $iaL1N;
    var $hb2iR;
    var $2IdXh;
    var $bZFir;
    var $1cn7Z;
    var $fVm8c;
    var $iWyGa;
    const $e7ba5b706afc13d5$var$BASE_LEVEL_PARENT = '[NO_PARENT]';
    const $e7ba5b706afc13d5$var$generatePartialCsv = (columnTransformers, context, parentId)=>{
        const { chartDataHash: chartDataHash, issuesByParent: issuesByParent } = context;
        let csv = '';
        (issuesByParent[parentId] ?? []).forEach(({ issueId: issueId, issue: issue })=>{
            const chartData = chartDataHash[issueId];
            csv += `${columnTransformers.map((column)=>column.transform({
                    issueId: issueId,
                    issue: issue,
                    chartData: chartData
                }, context)).join(',')}\r\n`;
            csv += $e7ba5b706afc13d5$var$generatePartialCsv(columnTransformers, context, issueId);
        });
        return csv;
    };
    const $e7ba5b706afc13d5$export$d4b63bab9e1886d8 = (columnTransformers, context)=>`${columnTransformers.map((column)=>(0, (0, parcelRequire("iWyGa")).escapeValue)(context.issueFields[column.fieldId ?? ''] ?? column.fieldId)).join(',')}\r\n`;
    const $e7ba5b706afc13d5$export$bf12c6f7f076b36f = (columnTransformers, context)=>{
        let csv = '';
        csv += $e7ba5b706afc13d5$export$d4b63bab9e1886d8(columnTransformers, context);
        csv += $e7ba5b706afc13d5$var$generatePartialCsv(columnTransformers, context, $e7ba5b706afc13d5$var$BASE_LEVEL_PARENT);
        const safeFileName = context.projectName.replace(/[^a-z0-9]/gi, '_').toLowerCase();
        const dateNow = (0, ($parcel$interopDefault($2gnC5)))().format('YYYY-MM-DD_hh.mma');
        const blob = new Blob([
            csv
        ], {
            type: 'text/plain;charset=utf-8'
        });
        (0, $jpUKq.saveAs)(blob, `${safeFileName}_${dateNow}.csv`);
    };
    const $e7ba5b706afc13d5$export$80d376111cc09ad7 = ({ issueIds: issueIds, issuesHash: issuesHash, userDisplayNameHash: userDisplayNameHash, issueTypesHash: issueTypesHash, startDateCustomFieldId: startDateCustomFieldId, colorCustomFieldId: colorCustomFieldId, sprintCustomFieldId: sprintCustomFieldId, issueFields: issueFields, issueSprintsHash: issueSprintsHash, isSprintsFeatureEnabled: isSprintsFeatureEnabled, chartDataHash: chartDataHash, projectName: projectName })=>{
        (0, (0, parcelRequire("2WFZU")).onGenerateCsv)({
            issueIds: issueIds,
            issuesHash: issuesHash,
            userDisplayNameHash: userDisplayNameHash,
            issueTypesHash: issueTypesHash,
            startDateCustomFieldId: startDateCustomFieldId,
            colorCustomFieldId: colorCustomFieldId,
            sprintCustomFieldId: sprintCustomFieldId,
            issueFields: issueFields,
            issueSprintsHash: issueSprintsHash,
            isSprintsFeatureEnabled: isSprintsFeatureEnabled,
            chartDataHash: chartDataHash,
            projectName: projectName
        });
    };
    var $e7ba5b706afc13d5$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, (0, parcelRequire("fVm8c")).EXPORT_CSV)).mergeMap(({ payload: { inferredDueDateHeader: inferredDueDateHeader, inferredStartDateHeader: inferredStartDateHeader } })=>{
            try {
                const state = store.getState();
                const issueIds = (0, (0, parcelRequire("2IdXh")).getFilteredIssueIds)(state);
                const issuesHash = (0, (0, parcelRequire("hFyhA")).getFullIssueHash)(state);
                const userDisplayNameHash = (0, (0, parcelRequire("iaL1N")).getUserDisplayNameHash)(state);
                const issueTypesHash = (0, (0, parcelRequire("4gYYI")).getFullIssueTypeHash)(state);
                const startDateCustomFieldId = (0, (0, parcelRequire("4gYYI")).getStartDateCustomFieldId)(state);
                const colorCustomFieldId = (0, (0, parcelRequire("4gYYI")).getColorCustomFieldId)(state);
                const sprintCustomFieldId = (0, (0, parcelRequire("4gYYI")).getSprintCustomFieldId)(state);
                const issueFields = {
                    inferredDueDate: inferredDueDateHeader,
                    inferredStartDate: inferredStartDateHeader,
                    ...(0, (0, parcelRequire("4gYYI")).getFieldsNamesHash)(state)
                };
                const issueSprintsHash = (0, (0, parcelRequire("bZFir")).getSanitisedIssueSprintsHash)(state);
                const isSprintsFeatureEnabled = (0, (0, parcelRequire("4gYYI")).getIsSprintsFeatureEnabled)(state);
                const chartDataHash = (0, (0, parcelRequire("1cn7Z")).getChartDataHash)(state);
                const projectName = (0, (0, parcelRequire("4gYYI")).getProjectName)(state);
                $e7ba5b706afc13d5$export$80d376111cc09ad7({
                    issueIds: issueIds,
                    issuesHash: issuesHash,
                    userDisplayNameHash: userDisplayNameHash,
                    issueTypesHash: issueTypesHash,
                    startDateCustomFieldId: startDateCustomFieldId,
                    colorCustomFieldId: colorCustomFieldId,
                    sprintCustomFieldId: sprintCustomFieldId,
                    issueFields: issueFields,
                    issueSprintsHash: issueSprintsHash,
                    isSprintsFeatureEnabled: isSprintsFeatureEnabled,
                    chartDataHash: chartDataHash,
                    projectName: projectName
                });
            } catch  {
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('jsw.timeline.export-csv.failure', 'Failed to generate timeline CSV');
                return (0, $kVLXA.Observable).of((0, (0, parcelRequire("hb2iR")).generalError)());
            }
            return (0, $kVLXA.Observable).empty();
        });
});
parcelRegister("jpUKq", function(module, exports) {
    var $e22c5f112f49df3f$var$saveAs = $e22c5f112f49df3f$var$saveAs || function(view) {
        "use strict";
        if (typeof view === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) return;
        var doc = view.document, get_URL = function() {
            return view.URL || view.webkitURL || view;
        }, save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a"), can_use_save_link = "download" in save_link, click = function(node) {
            var event = new MouseEvent("click");
            node.dispatchEvent(event);
        }, is_safari = /constructor/i.test(view.HTMLElement) || view.safari, is_chrome_ios = /CriOS\/[\d]+/.test(navigator.userAgent), throw_outside = function(ex) {
            (view.setImmediate || view.setTimeout)(function() {
                throw ex;
            }, 0);
        }, force_saveable_type = "application/octet-stream", arbitrary_revoke_timeout = 40000, revoke = function(file) {
            var revoker = function() {
                if (typeof file === "string") get_URL().revokeObjectURL(file);
                else file.remove();
            };
            setTimeout(revoker, arbitrary_revoke_timeout);
        }, dispatch = function(filesaver, event_types, event) {
            event_types = [].concat(event_types);
            var i = event_types.length;
            while(i--){
                var listener = filesaver["on" + event_types[i]];
                if (typeof listener === "function") try {
                    listener.call(filesaver, event || filesaver);
                } catch (ex) {
                    throw_outside(ex);
                }
            }
        }, auto_bom = function(blob) {
            if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) return new Blob([
                String.fromCharCode(0xFEFF),
                blob
            ], {
                type: blob.type
            });
            return blob;
        }, FileSaver = function(blob, name, no_auto_bom) {
            if (!no_auto_bom) blob = auto_bom(blob);
            var filesaver = this, type = blob.type, force = type === force_saveable_type, object_url, dispatch_all = function() {
                dispatch(filesaver, "writestart progress write writeend".split(" "));
            }, fs_error = function() {
                if ((is_chrome_ios || force && is_safari) && view.FileReader) {
                    var reader = new FileReader();
                    reader.onloadend = function() {
                        var url = is_chrome_ios ? reader.result : reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
                        var popup = view.open(url, '_blank');
                        if (!popup) view.location.href = url;
                        url = undefined;
                        filesaver.readyState = filesaver.DONE;
                        dispatch_all();
                    };
                    reader.readAsDataURL(blob);
                    filesaver.readyState = filesaver.INIT;
                    return;
                }
                if (!object_url) object_url = get_URL().createObjectURL(blob);
                if (force) view.location.href = object_url;
                else {
                    var opened = view.open(object_url, "_blank");
                    if (!opened) view.location.href = object_url;
                }
                filesaver.readyState = filesaver.DONE;
                dispatch_all();
                revoke(object_url);
            };
            filesaver.readyState = filesaver.INIT;
            if (can_use_save_link) {
                object_url = get_URL().createObjectURL(blob);
                setTimeout(function() {
                    save_link.href = object_url;
                    save_link.download = name;
                    click(save_link);
                    dispatch_all();
                    revoke(object_url);
                    filesaver.readyState = filesaver.DONE;
                });
                return;
            }
            fs_error();
        }, FS_proto = FileSaver.prototype, saveAs = function(blob, name, no_auto_bom) {
            return new FileSaver(blob, name || blob.name || "download", no_auto_bom);
        };
        if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) return function(blob, name, no_auto_bom) {
            name = name || blob.name || "download";
            if (!no_auto_bom) blob = auto_bom(blob);
            return navigator.msSaveOrOpenBlob(blob, name);
        };
        FS_proto.abort = function() {};
        FS_proto.readyState = FS_proto.INIT = 0;
        FS_proto.WRITING = 1;
        FS_proto.DONE = 2;
        FS_proto.error = FS_proto.onwritestart = FS_proto.onprogress = FS_proto.onwrite = FS_proto.onabort = FS_proto.onerror = FS_proto.onwriteend = null;
        return saveAs;
    }(typeof self !== "undefined" && self || typeof window !== "undefined" && window || module.exports.content);
    if (0, module.exports) module.exports.saveAs = $e22c5f112f49df3f$var$saveAs;
    else if (typeof define !== "undefined" && define !== null && define.amd !== null) define("FileSaver.js", function() {
        return $e22c5f112f49df3f$var$saveAs;
    });
});
parcelRegister("2WFZU", function(module, exports) {
    $parcel$export(module.exports, "onGenerateCsv", ()=>$722a9f49589bb970$export$e8a9be234322a768);
    parcelRequire("fp4O3");
    parcelRequire("fPS7b");
    parcelRequire("6hSeW");
    var $jpUKq = parcelRequire("jpUKq");
    var $2gnC5 = parcelRequire("2gnC5");
    var $kVLXA = parcelRequire("kVLXA");
    var $930Ym;
    const $722a9f49589bb970$var$BASE_LEVEL_PARENT = '[NO_PARENT]';
    const $722a9f49589bb970$var$generatePartialCsv = (columnTransformers, context, parentId)=>{
        const { chartDataHash: chartDataHash, issuesByParent: issuesByParent } = context;
        let csv = '';
        (issuesByParent[parentId] ?? []).forEach(({ issueId: issueId, issue: issue })=>{
            const chartData = chartDataHash?.[issueId];
            csv += `${columnTransformers.map((column)=>column.transform({
                    issueId: issueId,
                    issue: issue,
                    chartData: chartData
                }, context)).join(',')}\r\n`;
            csv += $722a9f49589bb970$var$generatePartialCsv(columnTransformers, context, issueId);
        });
        return csv;
    };
    const $722a9f49589bb970$export$d4b63bab9e1886d8 = (columnTransformers, context)=>`${columnTransformers.map((column)=>(0, (0, parcelRequire("930Ym")).escapeValue)(context.issueFields[column.fieldId ?? ''] ?? column.fieldId)).join(',')}\r\n`;
    const $722a9f49589bb970$export$bf12c6f7f076b36f = (columnTransformers, context)=>{
        let csv = '';
        csv += $722a9f49589bb970$export$d4b63bab9e1886d8(columnTransformers, context);
        csv += $722a9f49589bb970$var$generatePartialCsv(columnTransformers, context, $722a9f49589bb970$var$BASE_LEVEL_PARENT);
        const safeFileName = context.projectName.replace(/[^a-z0-9]/gi, '_').toLowerCase();
        const dateNow = (0, ($parcel$interopDefault($2gnC5)))().format('YYYY-MM-DD_hh.mma');
        const blob = new Blob([
            csv
        ], {
            type: 'text/plain;charset=utf-8'
        });
        (0, $jpUKq.saveAs)(blob, `${safeFileName}_${dateNow}.csv`);
    };
    const $722a9f49589bb970$export$e8a9be234322a768 = ({ issueIds: issueIds, issuesHash: issuesHash, userDisplayNameHash: userDisplayNameHash, issueTypesHash: issueTypesHash, startDateCustomFieldId: startDateCustomFieldId, colorCustomFieldId: colorCustomFieldId, sprintCustomFieldId: sprintCustomFieldId, issueFields: issueFields, issueSprintsHash: issueSprintsHash, chartDataHash: chartDataHash, projectName: projectName, isSprintsFeatureEnabled: isSprintsFeatureEnabled = false, hasInferredStartDueDateFields: hasInferredStartDueDateFields = true })=>{
        if (issueIds.length === 0) return (0, $kVLXA.Observable).empty();
        const issuesByParent = {
            BASE_LEVEL_PARENT: []
        };
        issueIds.forEach((issueId)=>{
            const issue = issuesHash[issueId];
            const parentId = issue.parentId?.value ?? $722a9f49589bb970$var$BASE_LEVEL_PARENT;
            const issueList = issuesByParent[parentId] ?? [];
            issueList.push({
                issueId: issueId,
                issue: issue
            });
            issuesByParent[parentId] = issueList;
        });
        const customFields = {
            startDateCustomFieldId: startDateCustomFieldId,
            colorCustomFieldId: colorCustomFieldId,
            sprintCustomFieldId: sprintCustomFieldId,
            isSprintsFeatureEnabled: isSprintsFeatureEnabled,
            hasInferredStartDueDateFields: hasInferredStartDueDateFields
        };
        const columnTransformers = (0, (0, parcelRequire("930Ym")).getColumnTransformers)(customFields);
        const transformationContext = {
            issueIds: issueIds,
            issuesByParent: issuesByParent,
            issuesHash: issuesHash,
            userDisplayNameHash: userDisplayNameHash,
            issueTypesHash: issueTypesHash,
            issueFields: issueFields,
            issueSprintsHash: issueSprintsHash,
            customFields: customFields,
            chartDataHash: chartDataHash,
            projectName: projectName
        };
        $722a9f49589bb970$export$bf12c6f7f076b36f(columnTransformers, transformationContext);
    };
});
parcelRegister("930Ym", function(module, exports) {
    $parcel$export(module.exports, "escapeValue", ()=>$96c8854850ab7fcc$export$ea39ee3092b88584);
    $parcel$export(module.exports, "getColumnTransformers", ()=>$96c8854850ab7fcc$export$8275ddb83241f041);
    var $2gnC5 = parcelRequire("2gnC5");
    var $f9Owr;
    var $heWHN;
    var $15ADj;
    const $96c8854850ab7fcc$export$98de7bb6e1f5105c = 'yyyy/MM/DD';
    const $96c8854850ab7fcc$export$ea39ee3092b88584 = (value)=>{
        if (value === undefined) return '""';
        if (value.includes('"')) return `"${value.replace(/"/g, '""')}"`;
        return `"${value}"`;
    };
    const $96c8854850ab7fcc$export$3ae94a2503e890a1 = (date)=>$96c8854850ab7fcc$export$ea39ee3092b88584(date !== undefined ? (0, ($parcel$interopDefault($2gnC5))).utc(date).format($96c8854850ab7fcc$export$98de7bb6e1f5105c) : '');
    const $96c8854850ab7fcc$export$8275ddb83241f041 = ({ startDateCustomFieldId: startDateCustomFieldId, colorCustomFieldId: colorCustomFieldId, sprintCustomFieldId: sprintCustomFieldId, isSprintsFeatureEnabled: isSprintsFeatureEnabled, hasInferredStartDueDateFields: hasInferredStartDueDateFields })=>[
            {
                fieldId: 'issuekey',
                transform: ({ issue: issue })=>$96c8854850ab7fcc$export$ea39ee3092b88584(issue.key)
            },
            {
                fieldId: 'issuetype',
                transform: ({ issue: issue }, { issueTypesHash: issueTypesHash })=>$96c8854850ab7fcc$export$ea39ee3092b88584(issueTypesHash[issue.issueTypeId]?.name)
            },
            {
                fieldId: 'parent',
                transform: ({ issue: issue }, { issuesHash: issuesHash })=>$96c8854850ab7fcc$export$ea39ee3092b88584(issue.parentId?.value ? issuesHash[issue.parentId.value]?.key : undefined)
            },
            {
                fieldId: 'summary',
                transform: ({ issue: issue })=>$96c8854850ab7fcc$export$ea39ee3092b88584(issue.summary.value)
            },
            ...(0, (0, parcelRequire("f9Owr")).ff)('jsw.timeline.return-flagged-attribute-fe') ? [
                {
                    fieldId: 'flagged',
                    transform: ({ issue: issue })=>$96c8854850ab7fcc$export$ea39ee3092b88584(issue.flagged.toString().toLowerCase())
                }
            ] : [],
            {
                fieldId: 'status',
                transform: ({ issue: issue })=>$96c8854850ab7fcc$export$ea39ee3092b88584(issue?.status?.name)
            },
            {
                fieldId: 'assignee',
                transform: ({ issue: issue }, { userDisplayNameHash: userDisplayNameHash })=>$96c8854850ab7fcc$export$ea39ee3092b88584(issue.assignee ? userDisplayNameHash[issue.assignee] : undefined)
            },
            ...isSprintsFeatureEnabled ? [
                {
                    fieldId: sprintCustomFieldId,
                    transform: ({ issueId: issueId }, { issueSprintsHash: issueSprintsHash })=>$96c8854850ab7fcc$export$ea39ee3092b88584(issueSprintsHash?.[issueId]?.at(0)?.name)
                }
            ] : [],
            {
                fieldId: startDateCustomFieldId,
                transform: ({ issue: issue })=>$96c8854850ab7fcc$export$3ae94a2503e890a1(issue.startDate?.value)
            },
            ...hasInferredStartDueDateFields ? [
                {
                    fieldId: 'inferredStartDate',
                    transform: ({ chartData: chartData })=>$96c8854850ab7fcc$export$3ae94a2503e890a1(chartData?.startDate && chartData.placeholder !== (0, (0, parcelRequire("15ADj")).START_AND_DUE_DATE_PLACEHOLDER) && chartData.placeholder !== (0, (0, parcelRequire("15ADj")).START_DATE_PLACEHOLDER) ? chartData.startDate : undefined)
                }
            ] : [],
            {
                fieldId: 'duedate',
                transform: ({ issue: issue })=>$96c8854850ab7fcc$export$3ae94a2503e890a1(issue.dueDate.value)
            },
            ...hasInferredStartDueDateFields ? [
                {
                    fieldId: 'inferredDueDate',
                    transform: ({ chartData: chartData })=>$96c8854850ab7fcc$export$3ae94a2503e890a1(chartData?.dueDate && chartData.placeholder !== (0, (0, parcelRequire("15ADj")).START_AND_DUE_DATE_PLACEHOLDER) && chartData.placeholder !== (0, (0, parcelRequire("15ADj")).DUE_DATE_PLACEHOLDER) ? chartData.dueDate : undefined)
                }
            ] : [],
            ...colorCustomFieldId ? [
                {
                    fieldId: colorCustomFieldId,
                    transform: ({ issue: issue })=>$96c8854850ab7fcc$export$ea39ee3092b88584((0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_SERVER_COLOR)[issue.color.value])
                }
            ] : []
        ];
});
parcelRegister("heWHN", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_EPIC_COLOR", ()=>$3a4ee6f2b0ce40ab$export$c2357bec51c5cf5b);
    $parcel$export(module.exports, "MAP_COLORS_TO_VALUE", ()=>$3a4ee6f2b0ce40ab$export$db33d74b098e3da9);
    $parcel$export(module.exports, "MAP_COLORS_TO_TOKEN", ()=>$3a4ee6f2b0ce40ab$export$fc5fe4213a5703f1);
    $parcel$export(module.exports, "MAP_VALUE_TO_COLOR", ()=>$3a4ee6f2b0ce40ab$export$a6cb26e106674600);
    $parcel$export(module.exports, "MAP_FROM_SERVER_COLOR", ()=>$3a4ee6f2b0ce40ab$export$43264b0781f10167);
    $parcel$export(module.exports, "MAP_FROM_CLIENT_SERVER_COLOR", ()=>$3a4ee6f2b0ce40ab$export$aedca9f3a1ee43d7);
    $parcel$export(module.exports, "MAP_FROM_SERVER_CLASSIC_COLOR", ()=>$3a4ee6f2b0ce40ab$export$fb5d051fe1b2bccc);
    $parcel$export(module.exports, "MAP_FROM_CLIENT_CLASSIC_COLOR", ()=>$3a4ee6f2b0ce40ab$export$c13af2d9629c53d8);
    $parcel$export(module.exports, "MAP_FROM_AGILE_COLOR", ()=>$3a4ee6f2b0ce40ab$export$994d3ffa39be04fd);
    $parcel$export(module.exports, "MAP_FROM_CLIENT_AGILE_COLOR", ()=>$3a4ee6f2b0ce40ab$export$db17671bf37971e7);
    $parcel$export(module.exports, "MAP_CLASSIC_COLOR_TO_AGILE_COLOR", ()=>$3a4ee6f2b0ce40ab$export$1fdd5a248b5f697c);
    $parcel$export(module.exports, "MAP_COLOR_TO_AK_COLOR", ()=>$3a4ee6f2b0ce40ab$export$82fc3b0b98905453);
    $parcel$export(module.exports, "MAP_AGILE_COLOR_TO_AK_COLOR", ()=>$3a4ee6f2b0ce40ab$export$703aca53c431bb88);
    $parcel$export(module.exports, "BASE_COLOR_SCHEMA", ()=>$3a4ee6f2b0ce40ab$export$92b6aebfb522f0d9);
    var $ggSx2 = parcelRequire("ggSx2");
    var $kFsv3;
    const $3a4ee6f2b0ce40ab$export$c2357bec51c5cf5b = 'PURPLE';
    const $3a4ee6f2b0ce40ab$export$db33d74b098e3da9 = {
        [(0, (0, parcelRequire("kFsv3")).PURPLE)]: `var(--ds-background-accent-purple-subtle, ${(0, $829f609a65d26a98$exports).P200})`,
        [(0, (0, parcelRequire("kFsv3")).BLUE)]: `var(--ds-background-accent-blue-subtle, ${(0, $829f609a65d26a98$exports).B200})`,
        [(0, (0, parcelRequire("kFsv3")).GREEN)]: `var(--ds-background-accent-green-subtle, ${(0, $829f609a65d26a98$exports).G200})`,
        [(0, (0, parcelRequire("kFsv3")).TEAL)]: `var(--ds-background-accent-teal-subtle, ${(0, $829f609a65d26a98$exports).T200})`,
        [(0, (0, parcelRequire("kFsv3")).YELLOW)]: `var(--ds-background-accent-yellow-subtle, ${(0, $829f609a65d26a98$exports).Y200})`,
        [(0, (0, parcelRequire("kFsv3")).ORANGE)]: `var(--ds-background-accent-red-subtle, ${(0, $829f609a65d26a98$exports).R200})`,
        [(0, (0, parcelRequire("kFsv3")).GREY)]: `var(--ds-background-accent-gray-subtle, ${(0, $829f609a65d26a98$exports).N200})`,
        [(0, (0, parcelRequire("kFsv3")).DARK_PURPLE)]: `var(--ds-background-accent-purple-bolder, ${(0, $829f609a65d26a98$exports).P400})`,
        [(0, (0, parcelRequire("kFsv3")).DARK_BLUE)]: `var(--ds-background-accent-blue-bolder, ${(0, $829f609a65d26a98$exports).B400})`,
        [(0, (0, parcelRequire("kFsv3")).DARK_GREEN)]: `var(--ds-background-accent-green-bolder, ${(0, $829f609a65d26a98$exports).G400})`,
        [(0, (0, parcelRequire("kFsv3")).DARK_TEAL)]: `var(--ds-background-accent-teal-bolder, ${(0, $829f609a65d26a98$exports).T400})`,
        [(0, (0, parcelRequire("kFsv3")).DARK_YELLOW)]: `var(--ds-background-accent-orange-bolder, ${(0, $829f609a65d26a98$exports).Y400})`,
        [(0, (0, parcelRequire("kFsv3")).DARK_ORANGE)]: `var(--ds-background-accent-red-bolder, ${(0, $829f609a65d26a98$exports).R400})`,
        [(0, (0, parcelRequire("kFsv3")).DARK_GREY)]: `var(--ds-background-accent-gray-bolder, ${(0, $829f609a65d26a98$exports).N700})`
    };
    const $3a4ee6f2b0ce40ab$export$fc5fe4213a5703f1 = {
        [(0, $829f609a65d26a98$exports).P200]: `var(--ds-background-accent-purple-subtle, ${(0, $829f609a65d26a98$exports).P200})`,
        [(0, $829f609a65d26a98$exports).B200]: `var(--ds-background-accent-blue-subtle, ${(0, $829f609a65d26a98$exports).B200})`,
        [(0, $829f609a65d26a98$exports).G200]: `var(--ds-background-accent-green-subtle, ${(0, $829f609a65d26a98$exports).G200})`,
        [(0, $829f609a65d26a98$exports).T200]: `var(--ds-background-accent-teal-subtle, ${(0, $829f609a65d26a98$exports).T200})`,
        [(0, $829f609a65d26a98$exports).Y200]: `var(--ds-background-accent-yellow-subtle, ${(0, $829f609a65d26a98$exports).Y200})`,
        [(0, $829f609a65d26a98$exports).R200]: `var(--ds-background-accent-red-subtle, ${(0, $829f609a65d26a98$exports).R200})`,
        [(0, $829f609a65d26a98$exports).N200]: `var(--ds-background-accent-gray-subtle, ${(0, $829f609a65d26a98$exports).N200})`,
        [(0, $829f609a65d26a98$exports).P400]: `var(--ds-background-accent-purple-bolder, ${(0, $829f609a65d26a98$exports).P400})`,
        [(0, $829f609a65d26a98$exports).B400]: `var(--ds-background-accent-blue-bolder, ${(0, $829f609a65d26a98$exports).B400})`,
        [(0, $829f609a65d26a98$exports).G400]: `var(--ds-background-accent-green-bolder, ${(0, $829f609a65d26a98$exports).G400})`,
        [(0, $829f609a65d26a98$exports).T400]: `var(--ds-background-accent-teal-bolder, ${(0, $829f609a65d26a98$exports).T400})`,
        [(0, $829f609a65d26a98$exports).Y400]: `var(--ds-background-accent-orange-bolder, ${(0, $829f609a65d26a98$exports).Y400})`,
        [(0, $829f609a65d26a98$exports).R400]: `var(--ds-background-accent-red-bolder, ${(0, $829f609a65d26a98$exports).R400})`,
        [(0, $829f609a65d26a98$exports).N700]: `var(--ds-background-accent-gray-bolder, ${(0, $829f609a65d26a98$exports).N700})`
    };
    const $3a4ee6f2b0ce40ab$export$a6cb26e106674600 = (0, ($parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$db33d74b098e3da9);
    const $3a4ee6f2b0ce40ab$export$43264b0781f10167 = {
        [(0, (0, parcelRequire("kFsv3")).SERVER_PURPLE)]: (0, (0, parcelRequire("kFsv3")).PURPLE),
        [(0, (0, parcelRequire("kFsv3")).SERVER_DARK_PURPLE)]: (0, (0, parcelRequire("kFsv3")).DARK_PURPLE),
        [(0, (0, parcelRequire("kFsv3")).SERVER_BLUE)]: (0, (0, parcelRequire("kFsv3")).BLUE),
        [(0, (0, parcelRequire("kFsv3")).SERVER_DARK_BLUE)]: (0, (0, parcelRequire("kFsv3")).DARK_BLUE),
        [(0, (0, parcelRequire("kFsv3")).SERVER_GREEN)]: (0, (0, parcelRequire("kFsv3")).GREEN),
        [(0, (0, parcelRequire("kFsv3")).SERVER_DARK_GREEN)]: (0, (0, parcelRequire("kFsv3")).DARK_GREEN),
        [(0, (0, parcelRequire("kFsv3")).SERVER_TEAL)]: (0, (0, parcelRequire("kFsv3")).TEAL),
        [(0, (0, parcelRequire("kFsv3")).SERVER_DARK_TEAL)]: (0, (0, parcelRequire("kFsv3")).DARK_TEAL),
        [(0, (0, parcelRequire("kFsv3")).SERVER_YELLOW)]: (0, (0, parcelRequire("kFsv3")).YELLOW),
        [(0, (0, parcelRequire("kFsv3")).SERVER_DARK_YELLOW)]: (0, (0, parcelRequire("kFsv3")).DARK_YELLOW),
        [(0, (0, parcelRequire("kFsv3")).SERVER_ORANGE)]: (0, (0, parcelRequire("kFsv3")).ORANGE),
        [(0, (0, parcelRequire("kFsv3")).SERVER_DARK_ORANGE)]: (0, (0, parcelRequire("kFsv3")).DARK_ORANGE),
        [(0, (0, parcelRequire("kFsv3")).SERVER_GREY)]: (0, (0, parcelRequire("kFsv3")).GREY),
        [(0, (0, parcelRequire("kFsv3")).SERVER_DARK_GREY)]: (0, (0, parcelRequire("kFsv3")).DARK_GREY)
    };
    const $3a4ee6f2b0ce40ab$export$aedca9f3a1ee43d7 = (0, ($parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$43264b0781f10167);
    const $3a4ee6f2b0ce40ab$export$fb5d051fe1b2bccc = {
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_1)]: (0, (0, parcelRequire("kFsv3")).DARK_GREY),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_2)]: (0, (0, parcelRequire("kFsv3")).DARK_YELLOW),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_3)]: (0, (0, parcelRequire("kFsv3")).YELLOW),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_4)]: (0, (0, parcelRequire("kFsv3")).DARK_BLUE),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_5)]: (0, (0, parcelRequire("kFsv3")).DARK_TEAL),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_6)]: (0, (0, parcelRequire("kFsv3")).GREEN),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_7)]: (0, (0, parcelRequire("kFsv3")).PURPLE),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_8)]: (0, (0, parcelRequire("kFsv3")).DARK_PURPLE),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_9)]: (0, (0, parcelRequire("kFsv3")).ORANGE),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_10)]: (0, (0, parcelRequire("kFsv3")).BLUE),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_11)]: (0, (0, parcelRequire("kFsv3")).TEAL),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_12)]: (0, (0, parcelRequire("kFsv3")).GREY),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_13)]: (0, (0, parcelRequire("kFsv3")).DARK_GREEN),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_14)]: (0, (0, parcelRequire("kFsv3")).DARK_ORANGE)
    };
    const $3a4ee6f2b0ce40ab$export$c13af2d9629c53d8 = (0, ($parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$fb5d051fe1b2bccc);
    const $3a4ee6f2b0ce40ab$export$994d3ffa39be04fd = {
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_1)]: (0, (0, parcelRequire("kFsv3")).DARK_GREY),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_2)]: (0, (0, parcelRequire("kFsv3")).DARK_YELLOW),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_3)]: (0, (0, parcelRequire("kFsv3")).YELLOW),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_4)]: (0, (0, parcelRequire("kFsv3")).DARK_BLUE),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_5)]: (0, (0, parcelRequire("kFsv3")).DARK_TEAL),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_6)]: (0, (0, parcelRequire("kFsv3")).GREEN),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_7)]: (0, (0, parcelRequire("kFsv3")).PURPLE),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_8)]: (0, (0, parcelRequire("kFsv3")).DARK_PURPLE),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_9)]: (0, (0, parcelRequire("kFsv3")).ORANGE),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_10)]: (0, (0, parcelRequire("kFsv3")).BLUE),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_11)]: (0, (0, parcelRequire("kFsv3")).TEAL),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_12)]: (0, (0, parcelRequire("kFsv3")).GREY),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_13)]: (0, (0, parcelRequire("kFsv3")).DARK_GREEN),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_14)]: (0, (0, parcelRequire("kFsv3")).DARK_ORANGE)
    };
    const $3a4ee6f2b0ce40ab$export$db17671bf37971e7 = (0, ($parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$994d3ffa39be04fd);
    const $3a4ee6f2b0ce40ab$export$1fdd5a248b5f697c = {
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_1)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_1),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_2)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_2),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_3)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_3),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_4)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_4),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_5)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_5),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_6)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_6),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_7)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_7),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_8)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_8),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_9)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_9),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_10)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_10),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_11)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_11),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_12)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_12),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_13)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_13),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_14)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_14)
    };
    const $3a4ee6f2b0ce40ab$export$82fc3b0b98905453 = {
        [(0, (0, parcelRequire("kFsv3")).DARK_GREY)]: 'grey',
        [(0, (0, parcelRequire("kFsv3")).DARK_YELLOW)]: 'yellow',
        [(0, (0, parcelRequire("kFsv3")).YELLOW)]: 'yellowLight',
        [(0, (0, parcelRequire("kFsv3")).DARK_BLUE)]: 'blue',
        [(0, (0, parcelRequire("kFsv3")).DARK_TEAL)]: 'teal',
        [(0, (0, parcelRequire("kFsv3")).GREEN)]: 'greenLight',
        [(0, (0, parcelRequire("kFsv3")).PURPLE)]: 'purpleLight',
        [(0, (0, parcelRequire("kFsv3")).DARK_PURPLE)]: 'purple',
        [(0, (0, parcelRequire("kFsv3")).ORANGE)]: 'redLight',
        [(0, (0, parcelRequire("kFsv3")).BLUE)]: 'blueLight',
        [(0, (0, parcelRequire("kFsv3")).TEAL)]: 'tealLight',
        [(0, (0, parcelRequire("kFsv3")).GREY)]: 'greyLight',
        [(0, (0, parcelRequire("kFsv3")).DARK_GREEN)]: 'green',
        [(0, (0, parcelRequire("kFsv3")).DARK_ORANGE)]: 'red'
    };
    const $3a4ee6f2b0ce40ab$export$703aca53c431bb88 = {
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_1)]: 'grey',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_2)]: 'yellow',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_3)]: 'yellowLight',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_4)]: 'blue',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_5)]: 'teal',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_6)]: 'greenLight',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_7)]: 'purpleLight',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_8)]: 'purple',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_9)]: 'redLight',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_10)]: 'blueLight',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_11)]: 'tealLight',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_12)]: 'greyLight',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_13)]: 'green',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_14)]: 'red'
    };
    const $3a4ee6f2b0ce40ab$export$92b6aebfb522f0d9 = {
        [(0, (0, parcelRequire("kFsv3")).PURPLE)]: {
            primary: `var(--ds-background-accent-purple-subtle, ${(0, $829f609a65d26a98$exports).P200})`,
            secondary: `var(--ds-background-accent-purple-bolder, ${(0, $829f609a65d26a98$exports).P500})`,
            text: `var(--ds-text-accent-purple, ${(0, $829f609a65d26a98$exports).P500})`,
            textBackground: `var(--ds-background-accent-purple-subtler, ${(0, $829f609a65d26a98$exports).P50})`,
            border: `var(--ds-border-accent-purple, ${(0, $829f609a65d26a98$exports).P400})`,
            line: `var(--ds-border-accent-purple, ${(0, $829f609a65d26a98$exports).P300})`,
            primaryGradient: `var(--ds-background-accent-purple-subtler, ${(0, $829f609a65d26a98$exports).P75})`,
            hasContrastSecondaryGradient: true
        },
        [(0, (0, parcelRequire("kFsv3")).BLUE)]: {
            primary: `var(--ds-background-accent-blue-subtle, ${(0, $829f609a65d26a98$exports).B200})`,
            secondary: `var(--ds-background-accent-blue-bolder, ${(0, $829f609a65d26a98$exports).B500})`,
            text: `var(--ds-text-accent-blue, ${(0, $829f609a65d26a98$exports).B500})`,
            textBackground: `var(--ds-background-accent-blue-subtler, ${(0, $829f609a65d26a98$exports).B50})`,
            border: `var(--ds-border-accent-blue, ${(0, $829f609a65d26a98$exports).B400})`,
            line: `var(--ds-border-accent-blue, ${(0, $829f609a65d26a98$exports).B300})`,
            primaryGradient: `var(--ds-background-accent-blue-subtler, ${(0, $829f609a65d26a98$exports).B75})`,
            hasContrastSecondaryGradient: true
        },
        [(0, (0, parcelRequire("kFsv3")).GREEN)]: {
            primary: `var(--ds-background-accent-green-subtle, ${(0, $829f609a65d26a98$exports).G200})`,
            secondary: `var(--ds-background-accent-green-bolder, ${(0, $829f609a65d26a98$exports).G500})`,
            text: `var(--ds-text-accent-green, ${(0, $829f609a65d26a98$exports).G500})`,
            textBackground: `var(--ds-background-accent-green-subtler, ${(0, $829f609a65d26a98$exports).G50})`,
            border: `var(--ds-border-accent-green, ${(0, $829f609a65d26a98$exports).G400})`,
            line: `var(--ds-border-accent-green, ${(0, $829f609a65d26a98$exports).G300})`,
            primaryGradient: `var(--ds-background-accent-green-subtler, ${(0, $829f609a65d26a98$exports).G75})`,
            hasContrastSecondaryGradient: true
        },
        [(0, (0, parcelRequire("kFsv3")).TEAL)]: {
            primary: `var(--ds-background-accent-teal-subtle, ${(0, $829f609a65d26a98$exports).T200})`,
            secondary: `var(--ds-background-accent-teal-bolder, ${(0, $829f609a65d26a98$exports).T500})`,
            text: `var(--ds-text-accent-teal, ${(0, $829f609a65d26a98$exports).T500})`,
            textBackground: `var(--ds-background-accent-teal-subtler, ${(0, $829f609a65d26a98$exports).T50})`,
            border: `var(--ds-border-accent-teal, ${(0, $829f609a65d26a98$exports).T400})`,
            line: `var(--ds-border-accent-teal, ${(0, $829f609a65d26a98$exports).T300})`,
            primaryGradient: `var(--ds-background-accent-teal-subtler, ${(0, $829f609a65d26a98$exports).T75})`,
            hasContrastSecondaryGradient: true
        },
        [(0, (0, parcelRequire("kFsv3")).YELLOW)]: {
            primary: `var(--ds-background-accent-yellow-subtle, ${(0, $829f609a65d26a98$exports).Y200})`,
            secondary: `var(--ds-background-accent-yellow-bolder, ${(0, $829f609a65d26a98$exports).Y500})`,
            text: `var(--ds-text-accent-yellow, ${(0, $829f609a65d26a98$exports).Y500})`,
            textBackground: `var(--ds-background-accent-yellow-subtler, ${(0, $829f609a65d26a98$exports).Y50})`,
            border: `var(--ds-border-accent-yellow, ${(0, $829f609a65d26a98$exports).Y400})`,
            line: `var(--ds-border-accent-yellow, ${(0, $829f609a65d26a98$exports).Y300})`,
            primaryGradient: `var(--ds-background-accent-yellow-subtler, ${(0, $829f609a65d26a98$exports).Y75})`,
            hasContrastSecondaryGradient: true
        },
        [(0, (0, parcelRequire("kFsv3")).ORANGE)]: {
            primary: `var(--ds-background-accent-red-subtle, ${(0, $829f609a65d26a98$exports).R200})`,
            secondary: `var(--ds-background-accent-red-bolder, ${(0, $829f609a65d26a98$exports).R500})`,
            text: `var(--ds-text-accent-red, ${(0, $829f609a65d26a98$exports).R500})`,
            textBackground: `var(--ds-background-accent-red-subtler, ${(0, $829f609a65d26a98$exports).R50})`,
            border: `var(--ds-border-accent-red, ${(0, $829f609a65d26a98$exports).R400})`,
            line: `var(--ds-border-accent-red, ${(0, $829f609a65d26a98$exports).R300})`,
            primaryGradient: `var(--ds-background-accent-red-subtler, ${(0, $829f609a65d26a98$exports).R75})`,
            hasContrastSecondaryGradient: true
        },
        [(0, (0, parcelRequire("kFsv3")).GREY)]: {
            primary: `var(--ds-background-accent-gray-subtle, ${(0, $829f609a65d26a98$exports).N200})`,
            secondary: `var(--ds-background-accent-gray-bolder, ${(0, $829f609a65d26a98$exports).N500})`,
            text: `var(--ds-text-accent-gray, ${(0, $829f609a65d26a98$exports).N500})`,
            textBackground: `var(--ds-background-accent-gray-subtler, ${(0, $829f609a65d26a98$exports).N30})`,
            border: `var(--ds-border-accent-gray, ${(0, $829f609a65d26a98$exports).N700})`,
            line: `var(--ds-border-accent-gray, ${(0, $829f609a65d26a98$exports).N500})`,
            primaryGradient: `var(--ds-background-accent-gray-subtler, ${(0, $829f609a65d26a98$exports).N50})`,
            hasContrastSecondaryGradient: true
        },
        [(0, (0, parcelRequire("kFsv3")).DARK_PURPLE)]: {
            primary: `var(--ds-background-accent-purple-bolder, ${(0, $829f609a65d26a98$exports).P400})`,
            secondary: `var(--ds-background-accent-purple-subtle, ${(0, $829f609a65d26a98$exports).P200})`,
            text: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
            textBackground: `var(--ds-background-accent-purple-bolder, ${(0, $829f609a65d26a98$exports).P400})`,
            border: `var(--ds-border-accent-purple, ${(0, $829f609a65d26a98$exports).P100})`,
            line: `var(--ds-border-accent-purple, ${(0, $829f609a65d26a98$exports).P300})`,
            primaryGradient: `var(--ds-background-accent-purple-subtle, ${(0, $829f609a65d26a98$exports).P100})`,
            hasContrastSecondaryGradient: false
        },
        [(0, (0, parcelRequire("kFsv3")).DARK_BLUE)]: {
            primary: `var(--ds-background-accent-blue-bolder, ${(0, $829f609a65d26a98$exports).B400})`,
            secondary: `var(--ds-background-accent-blue-subtle, ${(0, $829f609a65d26a98$exports).B200})`,
            text: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
            textBackground: `var(--ds-background-accent-blue-bolder, ${(0, $829f609a65d26a98$exports).B400})`,
            border: `var(--ds-border-accent-blue, ${(0, $829f609a65d26a98$exports).B200})`,
            line: `var(--ds-border-accent-blue, ${(0, $829f609a65d26a98$exports).B100})`,
            primaryGradient: `var(--ds-background-accent-blue-subtle, ${(0, $829f609a65d26a98$exports).B100})`,
            hasContrastSecondaryGradient: false
        },
        [(0, (0, parcelRequire("kFsv3")).DARK_GREEN)]: {
            primary: `var(--ds-background-accent-green-bolder, ${(0, $829f609a65d26a98$exports).G400})`,
            secondary: `var(--ds-background-accent-green-subtle, ${(0, $829f609a65d26a98$exports).G200})`,
            text: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
            textBackground: `var(--ds-background-accent-green-bolder, ${(0, $829f609a65d26a98$exports).G400})`,
            border: `var(--ds-border-accent-green, ${(0, $829f609a65d26a98$exports).G200})`,
            line: `var(--ds-border-accent-green, ${(0, $829f609a65d26a98$exports).G300})`,
            primaryGradient: `var(--ds-background-accent-green-subtle, ${(0, $829f609a65d26a98$exports).G200})`,
            hasContrastSecondaryGradient: false
        },
        [(0, (0, parcelRequire("kFsv3")).DARK_TEAL)]: {
            primary: `var(--ds-background-accent-teal-bolder, ${(0, $829f609a65d26a98$exports).T400})`,
            secondary: `var(--ds-background-accent-teal-subtle, ${(0, $829f609a65d26a98$exports).T200})`,
            text: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
            textBackground: `var(--ds-background-accent-teal-bolder, ${(0, $829f609a65d26a98$exports).T400})`,
            border: `var(--ds-border-accent-teal, ${(0, $829f609a65d26a98$exports).T200})`,
            line: `var(--ds-border-accent-teal, ${(0, $829f609a65d26a98$exports).T300})`,
            primaryGradient: `var(--ds-background-accent-teal-subtle, ${(0, $829f609a65d26a98$exports).T100})`,
            hasContrastSecondaryGradient: false
        },
        [(0, (0, parcelRequire("kFsv3")).DARK_YELLOW)]: {
            primary: `var(--ds-background-accent-orange-bolder, ${(0, $829f609a65d26a98$exports).Y400})`,
            secondary: `var(--ds-background-accent-orange-subtle, ${(0, $829f609a65d26a98$exports).Y200})`,
            text: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
            textBackground: `var(--ds-background-accent-orange-bolder, ${(0, $829f609a65d26a98$exports).Y400})`,
            border: `var(--ds-background-accent-orange-subtle, ${(0, $829f609a65d26a98$exports).Y200})`,
            line: `var(--ds-border-accent-orange, ${(0, $829f609a65d26a98$exports).Y300})`,
            primaryGradient: `var(--ds-background-accent-orange-subtle, ${(0, $829f609a65d26a98$exports).Y100})`,
            hasContrastSecondaryGradient: false
        },
        [(0, (0, parcelRequire("kFsv3")).DARK_ORANGE)]: {
            primary: `var(--ds-background-accent-red-bolder, ${(0, $829f609a65d26a98$exports).R400})`,
            secondary: `var(--ds-background-accent-red-subtle, ${(0, $829f609a65d26a98$exports).R200})`,
            text: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
            textBackground: `var(--ds-background-accent-red-bolder, ${(0, $829f609a65d26a98$exports).R400})`,
            border: `var(--ds-background-accent-red-subtle, ${(0, $829f609a65d26a98$exports).R100})`,
            line: `var(--ds-border-accent-red, ${(0, $829f609a65d26a98$exports).R300})`,
            primaryGradient: `var(--ds-background-accent-red-subtle, ${(0, $829f609a65d26a98$exports).R100})`,
            hasContrastSecondaryGradient: false
        },
        [(0, (0, parcelRequire("kFsv3")).DARK_GREY)]: {
            primary: `var(--ds-background-accent-gray-bolder, ${(0, $829f609a65d26a98$exports).N700})`,
            secondary: `var(--ds-background-accent-gray-subtle, ${(0, $829f609a65d26a98$exports).N300})`,
            text: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
            textBackground: `var(--ds-background-accent-gray-bolder, ${(0, $829f609a65d26a98$exports).N500})`,
            border: `var(--ds-background-accent-gray-subtle, ${(0, $829f609a65d26a98$exports).N100})`,
            line: `var(--ds-border-accent-gray, ${(0, $829f609a65d26a98$exports).N500})`,
            primaryGradient: `var(--ds-background-accent-gray-subtle, ${(0, $829f609a65d26a98$exports).N100})`,
            hasContrastSecondaryGradient: false
        }
    };
});
parcelRegister("1cn7Z", function(module, exports) {
    $parcel$export(module.exports, "getFilteredCreateCount", ()=>$f266c515bad40a96$export$68429a8cbb9a8844);
    $parcel$export(module.exports, "getItemTypesByLevel", ()=>$f266c515bad40a96$export$8e9c976d58d13d2c);
    $parcel$export(module.exports, "getSecondaryFieldsHash", ()=>$f266c515bad40a96$export$510887f0429ab384);
    $parcel$export(module.exports, "getChartDataHash", ()=>$f266c515bad40a96$export$f879d822e32ece35);
    $parcel$export(module.exports, "getChartDataById", ()=>$f266c515bad40a96$export$28e002e6c2204a53);
    $parcel$export(module.exports, "getItems", ()=>$f266c515bad40a96$export$d2f92acf417bbf5d);
    $parcel$export(module.exports, "getTableHeaderItems", ()=>$f266c515bad40a96$export$15bc8f218c19ff18);
    $parcel$export(module.exports, "getTableHeaderItemsHeight", ()=>$f266c515bad40a96$export$605bc738601d9d80);
    $parcel$export(module.exports, "getItemHeight", ()=>$f266c515bad40a96$export$ddd834f23fa82fc4);
    $parcel$export(module.exports, "getTableHeight", ()=>$f266c515bad40a96$export$81ff4c821ba5ba90);
    $parcel$export(module.exports, "getIsCreateSiblingEnabled", ()=>$f266c515bad40a96$export$6e34bc43d5f06c81);
    $parcel$export(module.exports, "getIsCreateChildEnabled", ()=>$f266c515bad40a96$export$b4d24e43117efaf5);
    $parcel$export(module.exports, "getIsDragEnabled", ()=>$f266c515bad40a96$export$71320b5c818a3427);
    $parcel$export(module.exports, "getAriaReadOnly", ()=>$f266c515bad40a96$export$704c61f9a16bf8cc);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $4R6GH;
    var $2KlaV;
    var $iZN6h;
    var $dCm1o;
    var $4gYYI;
    var $hFyhA;
    var $2udWc;
    var $iaL1N;
    var $5IiTZ;
    var $bM42j;
    var $hhYQB;
    var $2IdXh;
    var $d5e2N;
    var $fvM4Z;
    var $bZFir;
    var $3rLbe;
    var $hHkJ3;
    var $bPZMh;
    var $8uNFS;
    var $c6LTU;
    const $f266c515bad40a96$export$68429a8cbb9a8844 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("hhYQB")).getIssuesFilter), (0, (0, parcelRequire("c6LTU")).getFilteredCreateCountPure));
    const $f266c515bad40a96$export$8e9c976d58d13d2c = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("4gYYI")).getFullIssueTypeHash), (0, (0, parcelRequire("4gYYI")).getEpicIssueTypeIds), (0, (0, parcelRequire("5IiTZ")).getCreationPreferences), (0, (0, parcelRequire("4gYYI")).getProjectDefaultItemTypeId), (0, (0, parcelRequire("c6LTU")).getItemTypesByLevelPure));
    const $f266c515bad40a96$export$510887f0429ab384 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("hFyhA")).getIssueIds), (0, (0, parcelRequire("hFyhA")).getIssueParentIdHash), (0, (0, parcelRequire("hFyhA")).getIssueStatusHash), (0, (0, parcelRequire("hFyhA")).getIssueAssigneeHash), (0, (0, parcelRequire("iaL1N")).getUserAvatar16x16Hash), (0, (0, parcelRequire("iaL1N")).getUserDisplayNameHash), (0, (0, parcelRequire("2udWc")).getDoneStatusCategoryId), (0, (0, parcelRequire("hFyhA")).getIsIssueFlaggedHash), (0, (0, parcelRequire("c6LTU")).getSecondaryFieldsHashPure));
    const $f266c515bad40a96$export$f879d822e32ece35 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("2IdXh")).getFilteredNonBaseLevelIssueIds), (0, (0, parcelRequire("2IdXh")).getFilteredChildIssueIdsHash), (0, (0, parcelRequire("hFyhA")).getIssueStartDateHash), (0, (0, parcelRequire("hFyhA")).getIssueDueDateHash), (0, (0, parcelRequire("bZFir")).getSanitisedIssueSprintsHash), (0, (0, parcelRequire("hFyhA")).getIssueColorHash), (0, (0, parcelRequire("hHkJ3")).getIssueDateErrorsHashWithDefaultEqual), (0, (0, parcelRequire("8uNFS")).getParentRolledUpDatesHash), (0, (0, parcelRequire("hFyhA")).getIssueParentIdHash), (0, (0, parcelRequire("4gYYI")).getIsSprintsPlanningEnabled), (0, (0, parcelRequire("4gYYI")).getIsChildIssuePlanningEnabled), (0, (0, parcelRequire("bPZMh")).getChartDataHash));
    const $f266c515bad40a96$export$28e002e6c2204a53 = (state, id)=>$f266c515bad40a96$export$f879d822e32ece35(state)[id];
    const $f266c515bad40a96$export$d2f92acf417bbf5d = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("2IdXh")).getFilteredNonBaseLevelIssueIds), (0, (0, parcelRequire("2IdXh")).getFilteredChildIssueIdsHash), (0, (0, parcelRequire("hFyhA")).getIssueCreationTransitionHash), (nonBaseLevelIssueIds, issueChildIdsHash, issueCreationTransitionHash)=>{
        const items = [];
        const rootIssues = nonBaseLevelIssueIds;
        rootIssues.forEach((issueId)=>{
            const childIds = issueChildIdsHash[issueId];
            items.push({
                id: issueId,
                level: 1,
                isInTransition: Boolean(issueCreationTransitionHash[issueId]),
                childItems: childIds && childIds.map((childId)=>({
                        id: childId,
                        level: 0,
                        isInTransition: Boolean(issueCreationTransitionHash[childId]),
                        canCreateChildOverride: false
                    })),
                canCreateChildOverride: true
            });
        });
        return items;
    });
    const $f266c515bad40a96$export$15bc8f218c19ff18 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("4gYYI")).getIsSprintsFeatureEnabled), (0, (0, parcelRequire("3rLbe")).getIsReleasesVisible), (isSprintsFeatureEnabled, isReleasesHeaderVisible)=>{
        const headerItemConfigs = [];
        if (isSprintsFeatureEnabled) headerItemConfigs.push({
            id: (0, (0, parcelRequire("2KlaV")).SPRINTS_HEADER_ID),
            height: (0, (0, parcelRequire("iZN6h")).DEFAULT_SUBHEADER_HEIGHT)
        });
        if (isReleasesHeaderVisible) headerItemConfigs.push({
            id: (0, (0, parcelRequire("2KlaV")).RELEASES_HEADER_ID),
            height: (0, (0, parcelRequire("iZN6h")).DEFAULT_SUBHEADER_HEIGHT)
        });
        return headerItemConfigs;
    });
    const $f266c515bad40a96$export$605bc738601d9d80 = (0, $dGvGJ.createSelector)($f266c515bad40a96$export$15bc8f218c19ff18, (headerItems)=>headerItems.reduce((acc, { height: height })=>acc + (height ?? (0, (0, parcelRequire("iZN6h")).DEFAULT_SUBHEADER_HEIGHT)), 0));
    const $f266c515bad40a96$var$PROGRESS_ITEM_HEIGHT_OLD = 44;
    const $f266c515bad40a96$var$PROGRESS_ITEM_HEIGHT = 40;
    const $f266c515bad40a96$export$ddd834f23fa82fc4 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("hhYQB")).isProgressVisible), (isVisible)=>isVisible ? (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_2') ? $f266c515bad40a96$var$PROGRESS_ITEM_HEIGHT : $f266c515bad40a96$var$PROGRESS_ITEM_HEIGHT_OLD : (0, (0, parcelRequire("iZN6h")).DEFAULT_ITEM_HEIGHT));
    const $f266c515bad40a96$export$81ff4c821ba5ba90 = (0, $dGvGJ.createSelector)($f266c515bad40a96$export$605bc738601d9d80, $f266c515bad40a96$export$ddd834f23fa82fc4, (0, (0, parcelRequire("2IdXh")).getFilteredNonBaseLevelIssueIds), (0, (0, parcelRequire("2IdXh")).getFilteredChildIssueIdsHash), (0, (0, parcelRequire("bM42j")).getExpandedItems), (0, (0, parcelRequire("bM42j")).getCreateItemAnchor), (0, (0, parcelRequire("d5e2N")).getItemsHeight));
    const $f266c515bad40a96$export$6e34bc43d5f06c81 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("fvM4Z")).getCanUserCreate), (0, (0, parcelRequire("fvM4Z")).getCanUserRank), (0, (0, parcelRequire("fvM4Z")).getCanUserEdit), (0, (0, parcelRequire("4gYYI")).hasRequiredFields), (canCreate, canRank, canEdit, hasRequiredField)=>!hasRequiredField && canCreate && canRank && canEdit);
    const $f266c515bad40a96$export$b4d24e43117efaf5 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("fvM4Z")).getCanUserCreate), (0, (0, parcelRequire("hhYQB")).getChildIssueTypes), (canCreate, childItemTypes)=>canCreate && childItemTypes.length > 0);
    const $f266c515bad40a96$export$71320b5c818a3427 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("fvM4Z")).getCanUserRank), (0, (0, parcelRequire("fvM4Z")).getCanUserEdit), (canRank, canEdit)=>canRank && canEdit);
    const $f266c515bad40a96$export$704c61f9a16bf8cc = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("fvM4Z")).getCanUserCreate), (0, (0, parcelRequire("fvM4Z")).getCanUserRank), (0, (0, parcelRequire("fvM4Z")).getCanUserEdit), (canCreate, canRank, canEdit)=>!canRank && !canCreate && !canEdit);
});
parcelRegister("2KlaV", function(module, exports) {
    $parcel$export(module.exports, "TOP", ()=>$d2a0dd3547e5ef21$export$793ed84f5e13fedc);
    $parcel$export(module.exports, "BOTTOM", ()=>$d2a0dd3547e5ef21$export$84e1549b474f1b93);
    $parcel$export(module.exports, "LEFT", ()=>$d2a0dd3547e5ef21$export$f981f70d61d1405a);
    $parcel$export(module.exports, "RIGHT", ()=>$d2a0dd3547e5ef21$export$1cac5500365a4eb4);
    $parcel$export(module.exports, "LEFT_AND_RIGHT", ()=>$d2a0dd3547e5ef21$export$15a640865ed23fd6);
    $parcel$export(module.exports, "START_DATE_RELATIVE", ()=>$d2a0dd3547e5ef21$export$9353e50b864bcf30);
    $parcel$export(module.exports, "DUE_DATE_RELATIVE", ()=>$d2a0dd3547e5ef21$export$37796aed858ea4df);
    $parcel$export(module.exports, "START_DATE_AND_DUE_DATE_RELATIVE", ()=>$d2a0dd3547e5ef21$export$a7d970936077567f);
    $parcel$export(module.exports, "RELEASES_HEADER_ID", ()=>$d2a0dd3547e5ef21$export$c44d80b675e16f76);
    $parcel$export(module.exports, "SPRINTS_HEADER_ID", ()=>$d2a0dd3547e5ef21$export$8b5a447b30b83d68);
    $parcel$export(module.exports, "DEFAULT_RENDERER", ()=>$d2a0dd3547e5ef21$export$8c50c502a6dae24);
    const $d2a0dd3547e5ef21$export$793ed84f5e13fedc = 'TOP';
    const $d2a0dd3547e5ef21$export$84e1549b474f1b93 = 'BOTTOM';
    const $d2a0dd3547e5ef21$export$f981f70d61d1405a = 'LEFT';
    const $d2a0dd3547e5ef21$export$1cac5500365a4eb4 = 'RIGHT';
    const $d2a0dd3547e5ef21$export$15a640865ed23fd6 = 'LEFT_AND_RIGHT';
    const $d2a0dd3547e5ef21$export$9353e50b864bcf30 = 'START_DATE_RELATIVE';
    const $d2a0dd3547e5ef21$export$37796aed858ea4df = 'DUE_DATE_RELATIVE';
    const $d2a0dd3547e5ef21$export$a7d970936077567f = 'START_DATE_AND_DUE_DATE_RELATIVE';
    const $d2a0dd3547e5ef21$export$c44d80b675e16f76 = 'RELEASES_HEADER_ID';
    const $d2a0dd3547e5ef21$export$8b5a447b30b83d68 = 'SPRINTS_HEADER_ID';
    const $d2a0dd3547e5ef21$export$8c50c502a6dae24 = ()=>null;
});
parcelRegister("d5e2N", function(module, exports) {
    $parcel$export(module.exports, "getItemOffsetPositions", ()=>$961494e6344017d9$export$1c16f71ecb9378cb);
    $parcel$export(module.exports, "getItemsHeight", ()=>$961494e6344017d9$export$28a0df7c3241d02);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $iZN6h;
    const $961494e6344017d9$export$70dc67daffbef8af = (headerItemsHeight, itemHeight, itemIds, childIdsHash = {}, expandedItems = {}, createItemAnchor)=>{
        const result = [];
        let prevItemOffset = 0;
        itemIds.forEach((id)=>{
            const childIds = childIdsHash[id] || [];
            let childHeight = expandedItems[id] ? childIds.length * (0, (0, parcelRequire("iZN6h")).BASE_LEVEL_ITEM_HEIGHT)() : 0;
            let currentOffset = prevItemOffset;
            if (createItemAnchor) {
                const createBeforeItem = createItemAnchor.position === (0, (0, parcelRequire("iZN6h")).BEFORE) && createItemAnchor.beforeId === id;
                const createBeforeChildItem = createItemAnchor.position === (0, (0, parcelRequire("iZN6h")).BEFORE) && createItemAnchor.beforeId === id && createItemAnchor.parentId !== undefined;
                const createInsideItem = createItemAnchor.position === (0, (0, parcelRequire("iZN6h")).INSIDE) && createItemAnchor.parentId === id;
                if (createBeforeItem) currentOffset += itemHeight;
                if (createInsideItem || createBeforeChildItem) childHeight += itemHeight;
            }
            const totalHeight = itemHeight + childHeight;
            result.push({
                id: String(id),
                position: currentOffset + itemHeight / 2,
                height: itemHeight
            });
            if (expandedItems[id]) {
                let childPrevItemOffset = currentOffset + itemHeight;
                childIds.forEach((childId)=>{
                    if (createItemAnchor && typeof createItemAnchor === 'object' && 'parentId' in createItemAnchor && createItemAnchor.parentId && createItemAnchor.position === (0, (0, parcelRequire("iZN6h")).BEFORE) && createItemAnchor.beforeId === childId) {
                        childPrevItemOffset += itemHeight;
                        currentOffset += itemHeight;
                    }
                    result.push({
                        id: String(childId),
                        position: childPrevItemOffset + (0, (0, parcelRequire("iZN6h")).BASE_LEVEL_ITEM_HEIGHT)() / 2,
                        height: (0, (0, parcelRequire("iZN6h")).BASE_LEVEL_ITEM_HEIGHT)()
                    });
                    childPrevItemOffset += (0, (0, parcelRequire("iZN6h")).BASE_LEVEL_ITEM_HEIGHT)();
                });
            }
            prevItemOffset = currentOffset + totalHeight;
        });
        return result;
    };
    const $961494e6344017d9$var$parsePositions = (items)=>items.reduce((acc, { id: id, position: position })=>{
            acc[id] = position;
            return acc;
        }, {});
    const $961494e6344017d9$var$parseHeight = (items, headerItemsHeight)=>{
        let itemsHeight = 0;
        items.reduce((acc, { height: height })=>{
            itemsHeight += height;
            return acc;
        }, {});
        return itemsHeight + headerItemsHeight + (0, (0, parcelRequire("iZN6h")).BASE_HEADER_HEIGHT);
    };
    const $961494e6344017d9$export$1c16f71ecb9378cb = (0, $dGvGJ.createSelector)($961494e6344017d9$export$70dc67daffbef8af, $961494e6344017d9$var$parsePositions);
    const $961494e6344017d9$export$28a0df7c3241d02 = (0, $dGvGJ.createSelector)($961494e6344017d9$export$70dc67daffbef8af, (headerItemsHeight)=>headerItemsHeight, $961494e6344017d9$var$parseHeight);
});
parcelRegister("fvM4Z", function(module, exports) {
    $parcel$export(module.exports, "getCanUserEdit", ()=>$d0bd58da21a0a683$export$b47d5e7b73592dfd);
    $parcel$export(module.exports, "getCanUserCreate", ()=>$d0bd58da21a0a683$export$db23a83630667bd2);
    $parcel$export(module.exports, "getCanUserRank", ()=>$d0bd58da21a0a683$export$a2798deca233c810);
    $parcel$export(module.exports, "getCanUserViewDetails", ()=>$d0bd58da21a0a683$export$c4234881dfa9e672);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $9fPrG;
    var $4gYYI;
    const $d0bd58da21a0a683$export$b47d5e7b73592dfd = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("4gYYI")).hasEditIssuesPermission), (0, (0, parcelRequire("9fPrG")).getIsReadOnly), (0, (0, parcelRequire("9fPrG")).hasMacroConfig), (canEditIssue, isReadyOnly, isMacroConfigExist)=>canEditIssue && !isReadyOnly && !isMacroConfigExist);
    const $d0bd58da21a0a683$export$db23a83630667bd2 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("4gYYI")).hasCreateIssuesPermission), (0, (0, parcelRequire("9fPrG")).getIsReadOnly), (0, (0, parcelRequire("9fPrG")).hasMacroConfig), (canCreateIssue, isReadyOnly, isMacroConfigExist)=>canCreateIssue && !isReadyOnly && !isMacroConfigExist);
    const $d0bd58da21a0a683$export$a2798deca233c810 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("4gYYI")).hasScheduleIssuesPermission), (0, (0, parcelRequire("9fPrG")).getIsReadOnly), (0, (0, parcelRequire("9fPrG")).hasMacroConfig), (canRankIssue, isReadyOnly, isMacroConfigExist)=>canRankIssue && !isReadyOnly && !isMacroConfigExist);
    const $d0bd58da21a0a683$export$c4234881dfa9e672 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("9fPrG")).hasMacroConfig), (isMacroConfigExist)=>!isMacroConfigExist);
});
parcelRegister("hHkJ3", function(module, exports) {
    $parcel$export(module.exports, "getIssueDateErrorsHashWithDefaultEqual", ()=>$7f2edafadd0a3594$export$3ab7cce0b33f8834);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $cKS6s;
    var $4gYYI;
    var $hFyhA;
    var $2udWc;
    var $hhYQB;
    var $2IdXh;
    var $bZFir;
    var $8uNFS;
    var $ajTgO;
    const $7f2edafadd0a3594$export$56404af3856ae112 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("2udWc")).getDoneStatusCategoryId), (0, (0, parcelRequire("hFyhA")).getIssueStatusHash), (0, (0, parcelRequire("hFyhA")).getIssueStartDateHash), (0, (0, parcelRequire("hFyhA")).getIssueDueDateHash), (0, (0, parcelRequire("hFyhA")).getIssueParentIdHash), (0, (0, parcelRequire("8uNFS")).getParentRolledUpDatesHash), (0, (0, parcelRequire("8uNFS")).getExplicitBoundaryDatesHash), (0, (0, parcelRequire("4gYYI")).getIsSprintsPlanningEnabled), (0, (0, parcelRequire("4gYYI")).getIsChildIssuePlanningEnabled), (0, (0, parcelRequire("2IdXh")).getIssueEdgeReleaseDatesHash), (0, (0, parcelRequire("bZFir")).getSanitisedIssueSprintsHash), (0, (0, parcelRequire("4gYYI")).getIsReleasesFeatureEnabled), (0, (0, parcelRequire("ajTgO")).createGetIssueDateWarningsHash));
    const $7f2edafadd0a3594$export$36937d09d493b192 = (state)=>(0, (0, parcelRequire("hhYQB")).isWarningsVisible)(state) ? $7f2edafadd0a3594$export$56404af3856ae112(state) : {};
    const $7f2edafadd0a3594$export$3ab7cce0b33f8834 = (0, (0, parcelRequire("cKS6s")).createSelectorWithDefaultEqual)($7f2edafadd0a3594$export$36937d09d493b192, (dateErrors)=>dateErrors);
});
parcelRegister("ajTgO", function(module, exports) {
    $parcel$export(module.exports, "createGetIssueDateWarningsHash", ()=>$3ff14fd896241d65$export$3312d29c1b2c9e97);
    var $15ADj;
    var $eKt4x;
    var $fnJ0I;
    var $cRysC;
    var $9rckd;
    const $3ff14fd896241d65$export$b263ee37617f73e = (startDate, dueDate, rolledUpBaseLevelStartDate, rolledUpBaseLevelDueDate, rolledUpLatestStartDate, rolledUpEarliestDueDate)=>{
        const rolledUpStartDate = rolledUpLatestStartDate !== undefined && dueDate !== undefined && rolledUpLatestStartDate > dueDate ? rolledUpLatestStartDate : rolledUpBaseLevelStartDate;
        const rolledUpDueDate = rolledUpEarliestDueDate !== undefined && startDate !== undefined && rolledUpEarliestDueDate < startDate ? rolledUpEarliestDueDate : rolledUpBaseLevelDueDate;
        const warningMapKey = (0, (0, parcelRequire("9rckd")).getErrorForDatesOutsideBoundary)(rolledUpStartDate, rolledUpDueDate, startDate, dueDate);
        const warningMessageIdMap = new Map([
            [
                (0, (0, parcelRequire("9rckd")).BOTH),
                (0, (0, parcelRequire("eKt4x")).PARENT_STARTS_AFTER_CHILD_AND_ENDS_BEFORE_CHILD_MESSAGE_ID)
            ],
            [
                (0, (0, parcelRequire("9rckd")).START),
                (0, (0, parcelRequire("eKt4x")).PARENT_STARTS_AFTER_CHILD_MESSAGE_ID)
            ],
            [
                (0, (0, parcelRequire("9rckd")).DUE),
                (0, (0, parcelRequire("eKt4x")).PARENT_ENDS_BEFORE_CHILD_MESSAGE_ID)
            ]
        ]);
        const warningMessageId = warningMapKey && warningMessageIdMap.get(warningMapKey);
        return warningMessageId !== undefined ? (0, (0, parcelRequire("cRysC")).default)[warningMessageId] : undefined;
    };
    const $3ff14fd896241d65$export$3312d29c1b2c9e97 = (doneStatusCategoryId, issueStatusHash, issueStartDateHash, issueDueDateHash, parentIdHash, parentRolledUpDatesHash, boundaryDates, isSprintsPlanning, isChildIssuePlanningEnabled, issueEdgeReleaseDatesVersionHash, issueSprintIdsHash, isReleasesFeatureEnabled)=>{
        const result = {};
        Object.keys(issueStartDateHash).forEach((issueId)=>{
            result[issueId] = [];
            if (doneStatusCategoryId && issueStatusHash[issueId]?.statusCategoryId === doneStatusCategoryId) return;
            const explicitStartDate = issueStartDateHash[issueId];
            const explicitDueDate = issueDueDateHash[issueId];
            const sprints = issueSprintIdsHash[issueId] || [];
            const isParentIssue = parentIdHash[issueId] === undefined;
            let startDate;
            let dueDate;
            let placeholder;
            let childExceedsRolledUpParent;
            if (isParentIssue) {
                const rolledUpDates = parentRolledUpDatesHash[issueId] || {};
                const { startDate: parentLevelStartDate, dueDate: parentLevelDueDate, placeholder: parentLevelPlaceholder, childExceedsRolledUpParent: parentChildExceedsRolledUpParent } = (0, (0, parcelRequire("fnJ0I")).getParentLevelDates)(explicitStartDate, explicitDueDate, rolledUpDates, isChildIssuePlanningEnabled);
                startDate = parentLevelStartDate;
                dueDate = parentLevelDueDate;
                placeholder = parentLevelPlaceholder;
                childExceedsRolledUpParent = parentChildExceedsRolledUpParent;
            } else {
                const { startDate: baseLevelStartDate, dueDate: baseLevelDueDate, placeholder: baseLevelPlaceholder } = (0, (0, parcelRequire("fnJ0I")).getBaseLevelDates)(explicitStartDate, explicitDueDate, sprints, isSprintsPlanning, isChildIssuePlanningEnabled);
                startDate = baseLevelStartDate;
                dueDate = baseLevelDueDate;
                placeholder = baseLevelPlaceholder;
            }
            if ((0, (0, parcelRequire("9rckd")).isDateAfter)(explicitStartDate, explicitDueDate) || childExceedsRolledUpParent) result[issueId].push((0, (0, parcelRequire("cRysC")).default)[0, (0, parcelRequire("eKt4x")).START_DATE_LATER_DUE_DATE_MESSAGE_ID]);
            const shouldShowChildWarning = isParentIssue && isChildIssuePlanningEnabled;
            if (shouldShowChildWarning) {
                let parentDateError;
                const isStartDatePlaceholder = placeholder === (0, (0, parcelRequire("15ADj")).START_DATE_PLACEHOLDER) || placeholder === (0, (0, parcelRequire("15ADj")).START_AND_DUE_DATE_PLACEHOLDER);
                const isDueDatePlaceholder = placeholder === (0, (0, parcelRequire("15ADj")).DUE_DATE_PLACEHOLDER) || placeholder === (0, (0, parcelRequire("15ADj")).START_AND_DUE_DATE_PLACEHOLDER);
                const dateRangeBoundary = boundaryDates[issueId];
                const latestStartDate = parentRolledUpDatesHash[issueId]?.latestStartDate;
                const earliestDueDate = parentRolledUpDatesHash[issueId]?.earliestDueDate;
                if (dateRangeBoundary) parentDateError = $3ff14fd896241d65$export$b263ee37617f73e(!isStartDatePlaceholder ? startDate : undefined, !isDueDatePlaceholder ? dueDate : undefined, dateRangeBoundary.startDateBoundary, dateRangeBoundary.dueDateBoundary, latestStartDate, earliestDueDate);
                if (parentDateError !== undefined) result[issueId].push(parentDateError);
            }
            const shouldShowChildSprintWarning = !isParentIssue && isChildIssuePlanningEnabled && sprints.length > 0;
            if (shouldShowChildSprintWarning) {
                const { endDate: maxSprintDate } = sprints[0];
                const shouldShowWarning = maxSprintDate !== undefined && dueDate !== undefined && (!placeholder || placeholder === (0, (0, parcelRequire("15ADj")).START_DATE_PLACEHOLDER)) && (0, (0, parcelRequire("9rckd")).isDateAfter)(dueDate, maxSprintDate);
                if (shouldShowWarning) {
                    const sprintWarningMessage = (0, (0, parcelRequire("cRysC")).default)[0, (0, parcelRequire("eKt4x")).SPRINT_ENDS_BEFORE_CHILD_MESSAGE_ID];
                    result[issueId].push(sprintWarningMessage);
                }
            }
            if (isReleasesFeatureEnabled) {
                const [minReleaseDate, maxReleaseDate] = issueEdgeReleaseDatesVersionHash[issueId];
                const shouldShowWarning = isSprintsPlanning ? minReleaseDate !== undefined && startDate !== undefined && !placeholder && (0, (0, parcelRequire("9rckd")).isDateAfter)(startDate, minReleaseDate) : maxReleaseDate !== undefined && dueDate !== undefined && !placeholder && (0, (0, parcelRequire("9rckd")).isDateAfter)(dueDate, maxReleaseDate);
                if (shouldShowWarning) {
                    const releasesWarningMessage = (0, (0, parcelRequire("cRysC")).default)[0, (0, parcelRequire("eKt4x")).END_DATE_LATER_RELEASE_DATE_MESSAGE_ID];
                    result[issueId].push(releasesWarningMessage);
                }
            }
        });
        return result;
    };
});
parcelRegister("fnJ0I", function(module, exports) {
    $parcel$export(module.exports, "getParentLevelDates", ()=>$b49293fb564f16e3$export$bdde5ab43980faef);
    $parcel$export(module.exports, "getBaseLevelDates", ()=>$b49293fb564f16e3$export$9d659d7f902f05ab);
    var $esmwW;
    var $d8OAB;
    var $4dEfT;
    const $b49293fb564f16e3$export$a79b06f135b87e1f = (issueStartDateHash, issueDueDateHash, parentRolledUpDatesHash, issueId)=>{
        const explicitStartDate = issueStartDateHash[issueId];
        const explicitDueDate = issueDueDateHash[issueId];
        const rolledUpDates = parentRolledUpDatesHash[issueId] || {
            inferredStartDate: undefined,
            inferredEndDate: undefined
        };
        const { startDate: startDate, dueDate: dueDate, isStartDatePlaceholder: isStartDatePlaceholder, isDueDatePlaceholder: isDueDatePlaceholder } = (0, (0, parcelRequire("4dEfT")).fallbackToInferredDate)({
            explicitStartDate: explicitStartDate,
            explicitDueDate: explicitDueDate
        }, rolledUpDates);
        return {
            startDate: startDate,
            dueDate: dueDate,
            isStartDateInferred: explicitStartDate === undefined && startDate !== undefined,
            isDueDateInferred: explicitDueDate === undefined && dueDate !== undefined,
            isStartDatePlaceholder: isStartDatePlaceholder,
            isDueDatePlaceholder: isDueDatePlaceholder
        };
    };
    const $b49293fb564f16e3$var$getChildExceedsRolledUpParent = (rolledUpDates, explicitStartDate, explicitDueDate, rollUpStartDate, rollUpDueDate)=>({
            childStartsAfterParent: explicitStartDate === undefined && explicitDueDate !== undefined && rolledUpDates.startDate !== undefined && rollUpDueDate !== undefined && rolledUpDates.startDate > rollUpDueDate && rolledUpDates.latestStartDate !== undefined && rolledUpDates.latestStartDate > explicitDueDate,
            childEndsBeforeParent: explicitStartDate !== undefined && explicitDueDate === undefined && rolledUpDates.dueDate !== undefined && rollUpStartDate !== undefined && rolledUpDates.dueDate < rollUpStartDate && rolledUpDates.earliestDueDate !== undefined && rolledUpDates.earliestDueDate < explicitStartDate
        });
    const $b49293fb564f16e3$export$bdde5ab43980faef = (explicitStartDate, explicitDueDate, parentRolledUpDates, isChildIssuePlanningEnabled)=>{
        const rolledUpDates = isChildIssuePlanningEnabled && parentRolledUpDates ? parentRolledUpDates : {
            startDate: undefined,
            dueDate: undefined,
            latestStartDate: undefined,
            earliestDueDate: undefined,
            isStartDatePlaceholder: false,
            isDueDatePlaceholder: false
        };
        const { startDate: rollUpStartDate, dueDate: rollUpDueDate, isStartDatePlaceholder: isStartDatePlaceholder, isDueDatePlaceholder: isDueDatePlaceholder } = (0, (0, parcelRequire("4dEfT")).fallbackToInferredDate)({
            explicitStartDate: explicitStartDate,
            explicitDueDate: explicitDueDate
        }, rolledUpDates);
        const { childStartsAfterParent: childStartsAfterParent, childEndsBeforeParent: childEndsBeforeParent } = $b49293fb564f16e3$var$getChildExceedsRolledUpParent(rolledUpDates, explicitStartDate, explicitDueDate, rollUpStartDate, rollUpDueDate);
        const hasLeftPlaceholder = isChildIssuePlanningEnabled ? isStartDatePlaceholder || rollUpStartDate === undefined || childEndsBeforeParent : rollUpStartDate === undefined;
        const hasRightPlaceholder = isChildIssuePlanningEnabled ? isDueDatePlaceholder || rollUpDueDate === undefined || childStartsAfterParent : rollUpDueDate === undefined;
        return {
            startDate: rollUpStartDate,
            dueDate: rollUpDueDate,
            startDateType: explicitStartDate === undefined && rollUpStartDate !== undefined && !childStartsAfterParent ? (0, (0, parcelRequire("esmwW")).ROLLUP) : (0, (0, parcelRequire("esmwW")).EXPLICIT),
            dueDateType: explicitDueDate === undefined && rollUpDueDate !== undefined && !childEndsBeforeParent ? (0, (0, parcelRequire("esmwW")).ROLLUP) : (0, (0, parcelRequire("esmwW")).EXPLICIT),
            placeholder: (0, (0, parcelRequire("d8OAB")).getPlaceholder)(hasLeftPlaceholder, hasRightPlaceholder),
            childExceedsRolledUpParent: childStartsAfterParent || childEndsBeforeParent
        };
    };
    const $b49293fb564f16e3$export$9d659d7f902f05ab = (explicitStartDate, explicitDueDate, sprints, isSprintsPlanning, isChildIssuePlanningEnabled)=>{
        if (!isSprintsPlanning) {
            const issueStartDate = isChildIssuePlanningEnabled ? explicitStartDate : undefined;
            const issueDueDate = isChildIssuePlanningEnabled ? explicitDueDate : undefined;
            return {
                startDateType: (0, (0, parcelRequire("esmwW")).EXPLICIT),
                dueDateType: (0, (0, parcelRequire("esmwW")).EXPLICIT),
                placeholder: (0, (0, parcelRequire("d8OAB")).getPlaceholder)(issueStartDate === undefined, issueDueDate === undefined),
                startDate: issueStartDate,
                dueDate: issueDueDate
            };
        }
        const issueSprints = sprints || [];
        const inferredStartDate = isChildIssuePlanningEnabled ? issueSprints[0]?.startDate : undefined;
        const inferredDueDate = isChildIssuePlanningEnabled ? issueSprints[0]?.endDate : undefined;
        return {
            startDateType: (0, (0, parcelRequire("esmwW")).INTERVAL),
            dueDateType: (0, (0, parcelRequire("esmwW")).INTERVAL),
            placeholder: undefined,
            startDate: inferredStartDate,
            dueDate: inferredDueDate
        };
    };
});
parcelRegister("d8OAB", function(module, exports) {
    $parcel$export(module.exports, "isStartDatePlaceholder", ()=>$ff41fd85b688cb11$export$1673e5e0e5ff398a);
    $parcel$export(module.exports, "isDueDatePlaceholder", ()=>$ff41fd85b688cb11$export$bd9b44c69998322c);
    $parcel$export(module.exports, "getPlaceholderWhileDragging", ()=>$ff41fd85b688cb11$export$97dae3d8f882d620);
    $parcel$export(module.exports, "getPlaceholder", ()=>$ff41fd85b688cb11$export$d3f5c5e0a5023fa0);
    var $15ADj;
    var $2KlaV;
    const $ff41fd85b688cb11$export$1673e5e0e5ff398a = (placeholder)=>placeholder === (0, (0, parcelRequire("15ADj")).START_DATE_PLACEHOLDER) || placeholder === (0, (0, parcelRequire("15ADj")).START_AND_DUE_DATE_PLACEHOLDER);
    const $ff41fd85b688cb11$export$bd9b44c69998322c = (placeholder)=>placeholder === (0, (0, parcelRequire("15ADj")).DUE_DATE_PLACEHOLDER) || placeholder === (0, (0, parcelRequire("15ADj")).START_AND_DUE_DATE_PLACEHOLDER);
    const $ff41fd85b688cb11$export$97dae3d8f882d620 = (dragType, placeholder)=>{
        if (dragType === (0, (0, parcelRequire("2KlaV")).LEFT_AND_RIGHT)) return undefined;
        if (dragType === (0, (0, parcelRequire("2KlaV")).LEFT) && placeholder === (0, (0, parcelRequire("15ADj")).START_DATE_PLACEHOLDER)) return undefined;
        if (dragType === (0, (0, parcelRequire("2KlaV")).RIGHT) && placeholder === (0, (0, parcelRequire("15ADj")).DUE_DATE_PLACEHOLDER)) return undefined;
        if (dragType === (0, (0, parcelRequire("2KlaV")).RIGHT) && placeholder === (0, (0, parcelRequire("15ADj")).START_AND_DUE_DATE_PLACEHOLDER)) return 0, (0, parcelRequire("15ADj")).START_DATE_PLACEHOLDER;
        if (dragType === (0, (0, parcelRequire("2KlaV")).LEFT) && placeholder === (0, (0, parcelRequire("15ADj")).START_AND_DUE_DATE_PLACEHOLDER)) return 0, (0, parcelRequire("15ADj")).DUE_DATE_PLACEHOLDER;
        return placeholder;
    };
    const $ff41fd85b688cb11$export$d3f5c5e0a5023fa0 = (hasLeftPlaceholder, hasRightPlaceholder)=>{
        if (hasLeftPlaceholder && hasRightPlaceholder) return 0, (0, parcelRequire("15ADj")).START_AND_DUE_DATE_PLACEHOLDER;
        if (hasLeftPlaceholder) return 0, (0, parcelRequire("15ADj")).START_DATE_PLACEHOLDER;
        if (hasRightPlaceholder) return 0, (0, parcelRequire("15ADj")).DUE_DATE_PLACEHOLDER;
        return undefined;
    };
});
parcelRegister("4dEfT", function(module, exports) {
    $parcel$export(module.exports, "fallbackToInferredDate", ()=>$903b9ca0966cab4c$export$43b61ec222c43ae6);
    const $903b9ca0966cab4c$export$43b61ec222c43ae6 = (explicitDates, rolledUpDates)=>{
        const rollUpStartDate = rolledUpDates.startDate;
        const rollUpDueDate = rolledUpDates.dueDate;
        const { explicitStartDate: explicitStartDate, explicitDueDate: explicitDueDate } = explicitDates;
        const { isStartDatePlaceholder: isStartDatePlaceholder, isDueDatePlaceholder: isDueDatePlaceholder } = rolledUpDates;
        if (explicitStartDate === undefined && explicitDueDate === undefined) return {
            startDate: rollUpStartDate,
            dueDate: rollUpDueDate,
            isStartDatePlaceholder: isStartDatePlaceholder,
            isDueDatePlaceholder: isDueDatePlaceholder
        };
        if (rollUpStartDate !== undefined && rollUpDueDate !== undefined) {
            if (explicitStartDate !== undefined && explicitDueDate === undefined) return {
                startDate: explicitStartDate,
                dueDate: explicitStartDate >= rollUpDueDate ? rollUpStartDate : rollUpDueDate,
                isStartDatePlaceholder: isStartDatePlaceholder,
                isDueDatePlaceholder: isDueDatePlaceholder
            };
            if (explicitStartDate === undefined && explicitDueDate !== undefined) return {
                startDate: explicitDueDate <= rollUpStartDate ? rollUpDueDate : rollUpStartDate,
                dueDate: explicitDueDate,
                isStartDatePlaceholder: isStartDatePlaceholder,
                isDueDatePlaceholder: isDueDatePlaceholder
            };
        }
        return {
            startDate: explicitStartDate,
            dueDate: explicitDueDate,
            isStartDatePlaceholder: false,
            isDueDatePlaceholder: false
        };
    };
});
parcelRegister("cRysC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cd4ded459368382d$export$2e2bcd8739ae039);
    var $7VHMR;
    var $cd4ded459368382d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        startDateLaterDueDate: {
            "id": "roadmap.standard-roadmap.state.selectors.table.bar-warnings.start-date-later-due-date",
            "defaultMessage": "Start date must be before Due date."
        },
        endDateLaterReleasesDate: {
            "id": "roadmap.standard-roadmap.state.selectors.table.bar-warnings.end-date-later-releases-date",
            "defaultMessage": "This issue is scheduled to end after the release to which it's been assigned."
        },
        parentStartsAfterChild: {
            "id": "roadmap.standard-roadmap.state.selectors.table.bar-warnings.parent-starts-after-child",
            "defaultMessage": "This parent issue begins after the start date of a child issue."
        },
        parentEndsBeforeChild: {
            "id": "roadmap.standard-roadmap.state.selectors.table.bar-warnings.parent-ends-before-child",
            "defaultMessage": "This parent issue ends before its child issues are scheduled to complete."
        },
        parentStartsAfterChildAndEndsBeforeChild: {
            "id": "roadmap.standard-roadmap.state.selectors.table.bar-warnings.parent-starts-after-child-and-ends-before-child",
            "defaultMessage": "Child issues begin and end outside the dates set for this parent issue."
        },
        sprintEndsBeforeChild: {
            "id": "roadmap.standard-roadmap.state.selectors.table.bar-warnings.sprint-ends-before-child",
            "defaultMessage": "This issue is scheduled to end after the sprint to which it's been assigned."
        }
    });
});
parcelRegister("9rckd", function(module, exports) {
    $parcel$export(module.exports, "START", ()=>$9daefef34028774b$export$21c466265830bc3a);
    $parcel$export(module.exports, "DUE", ()=>$9daefef34028774b$export$ee74b0b7e193b0b0);
    $parcel$export(module.exports, "BOTH", ()=>$9daefef34028774b$export$1cb7e2af85daea7b);
    $parcel$export(module.exports, "getErrorForDatesOutsideBoundary", ()=>$9daefef34028774b$export$e261b272fabf99d);
    $parcel$export(module.exports, "isDateAfter", ()=>$9daefef34028774b$export$1c4ee043487b1d5e);
    const $9daefef34028774b$export$21c466265830bc3a = 'START';
    const $9daefef34028774b$export$ee74b0b7e193b0b0 = 'DUE';
    const $9daefef34028774b$export$1cb7e2af85daea7b = 'BOTH';
    const $9daefef34028774b$export$e261b272fabf99d = (startDate, dueDate, boundaryStartDate, boundaryDueDate)=>{
        if (boundaryStartDate === undefined && boundaryDueDate === undefined || startDate === undefined && dueDate === undefined) return undefined;
        const validBoundaryStartDate = boundaryStartDate;
        const validBoundaryDueDate = boundaryDueDate;
        let validStartDate = startDate;
        let validDueDate = dueDate;
        if (startDate !== undefined && dueDate !== undefined && startDate > dueDate) {
            validStartDate = dueDate;
            validDueDate = startDate;
        }
        const isStartDateBeforeBoundaryStartDate = validBoundaryStartDate !== undefined && validStartDate !== undefined ? validStartDate < validBoundaryStartDate : false;
        const isDueDateLaterBoundaryDueDate = validBoundaryDueDate !== undefined && validDueDate !== undefined ? validDueDate > validBoundaryDueDate : false;
        const isStartDateLaterBoundaryDueDate = validBoundaryDueDate !== undefined && validStartDate !== undefined ? validStartDate > validBoundaryDueDate : false;
        const isDueDateBeforeBoundaryStartDate = validBoundaryStartDate !== undefined && validDueDate !== undefined ? validDueDate < validBoundaryStartDate : false;
        const isOutsideBoundaryDates = isStartDateBeforeBoundaryStartDate && isDueDateLaterBoundaryDueDate || isStartDateLaterBoundaryDueDate && isDueDateLaterBoundaryDueDate || isStartDateBeforeBoundaryStartDate && isDueDateBeforeBoundaryStartDate;
        if (isOutsideBoundaryDates) return $9daefef34028774b$export$1cb7e2af85daea7b;
        if (isStartDateBeforeBoundaryStartDate) return $9daefef34028774b$export$21c466265830bc3a;
        if (isDueDateLaterBoundaryDueDate) return $9daefef34028774b$export$ee74b0b7e193b0b0;
        return undefined;
    };
    const $9daefef34028774b$export$1c4ee043487b1d5e = (date, comparisonDate)=>date !== undefined && comparisonDate !== undefined ? date > comparisonDate : false;
});
parcelRegister("bPZMh", function(module, exports) {
    $parcel$export(module.exports, "getChartDataHash", ()=>$867cd92b4a1a856e$export$f879d822e32ece35);
    var $39sKF;
    var $g0ijm;
    const $867cd92b4a1a856e$export$f879d822e32ece35 = (parentIds, childIdsHash, issueStartDateHash, issueDueDateHash, issueSprintsHash, issueColorHash, issueDateErrorsHash, parentRolledUpDatesHash, issueParentIdHash, isSprintsPlanning, isChildIssuePlanningEnabled)=>{
        const chartDataHash = {};
        parentIds.forEach((parentId)=>{
            chartDataHash[parentId] = (0, (0, parcelRequire("g0ijm")).getParentLevelChartData)(issueColorHash, issueStartDateHash, issueDueDateHash, parentRolledUpDatesHash, issueDateErrorsHash, parentId, isChildIssuePlanningEnabled);
            const childIds = childIdsHash[parentId] || [];
            childIds.forEach((childId)=>{
                chartDataHash[childId] = (0, (0, parcelRequire("39sKF")).getBaseLevelChartData)(isSprintsPlanning, isChildIssuePlanningEnabled, issueParentIdHash, issueColorHash, issueStartDateHash, issueDueDateHash, issueSprintsHash, issueDateErrorsHash, childId);
            });
        });
        return chartDataHash;
    };
});
parcelRegister("39sKF", function(module, exports) {
    $parcel$export(module.exports, "getBaseLevelChartData", ()=>$f823d3be734fbfed$export$81ce5c0846f33915);
    var $kFsv3;
    var $joGLY;
    var $e5ith;
    var $fnJ0I;
    const $f823d3be734fbfed$var$getBaseLevelColor = (issueParentIdHash, issueColorHash, issueId)=>{
        const parentId = issueParentIdHash[issueId];
        if (parentId !== undefined) return issueColorHash[parentId];
        return undefined;
    };
    const $f823d3be734fbfed$export$81ce5c0846f33915 = (isSprintsPlanning, isChildIssuePlanningEnabled, issueParentIdHash, issueColorHash, issueStartDateHash, issueDueDateHash, issueSprintsHash, issueDateErrorsHash, issueId)=>{
        const explicitStartDate = issueStartDateHash[issueId];
        const explicitDueDate = issueDueDateHash[issueId];
        const sprints = issueSprintsHash[issueId];
        const { startDate: baseLevelStartDate, dueDate: baseLevelDueDate, startDateType: startDateType, dueDateType: dueDateType, placeholder: placeholder } = (0, (0, parcelRequire("fnJ0I")).getBaseLevelDates)(explicitStartDate, explicitDueDate, sprints, isSprintsPlanning, isChildIssuePlanningEnabled);
        const color = $f823d3be734fbfed$var$getBaseLevelColor(issueParentIdHash, issueColorHash, issueId) || (0, (0, parcelRequire("kFsv3")).PURPLE);
        const { startDate: startDate, dueDate: dueDate } = (0, (0, parcelRequire("e5ith")).getChartDateData)(baseLevelStartDate, baseLevelDueDate, (0, (0, parcelRequire("joGLY")).BASE_LEVEL), isChildIssuePlanningEnabled);
        return {
            startDate: startDate,
            dueDate: dueDate,
            startDateType: startDateType,
            dueDateType: dueDateType,
            placeholder: placeholder,
            color: color,
            warnings: isChildIssuePlanningEnabled ? issueDateErrorsHash[issueId] : [],
            level: (0, (0, parcelRequire("joGLY")).BASE_LEVEL)
        };
    };
});
parcelRegister("e5ith", function(module, exports) {
    $parcel$export(module.exports, "getChartDateData", ()=>$0908c5269d135bf0$export$e05848039380116b);
    var $2gnC5 = parcelRequire("2gnC5");
    var $joGLY;
    var $eKt4x;
    const $0908c5269d135bf0$export$e05848039380116b = (startDate, dueDate, level, isChildIssuePlanningEnabled)=>{
        const placeholderDays = isChildIssuePlanningEnabled && level === (0, (0, parcelRequire("joGLY")).BASE_LEVEL) ? (0, (0, parcelRequire("eKt4x")).CHILD_PLACEHOLDER_DAYS) : (0, (0, parcelRequire("eKt4x")).PARENT_PLACEHOLDER_DAYS);
        if (startDate !== undefined && dueDate !== undefined) {
            const isDateError = startDate > dueDate;
            return {
                startDate: isDateError ? dueDate : startDate,
                dueDate: isDateError ? startDate : dueDate,
                isDateError: isDateError
            };
        }
        if (startDate !== undefined) {
            const monthAfterStart = (0, ($parcel$interopDefault($2gnC5))).utc(startDate).add(placeholderDays, 'days').startOf('day').valueOf();
            return {
                startDate: startDate,
                dueDate: monthAfterStart
            };
        }
        if (dueDate !== undefined) {
            const monthBeforeDue = (0, ($parcel$interopDefault($2gnC5))).utc(dueDate).subtract(placeholderDays, 'days').startOf('day').valueOf();
            return {
                startDate: monthBeforeDue,
                dueDate: dueDate
            };
        }
        return {
            startDate: undefined,
            dueDate: undefined
        };
    };
});
parcelRegister("g0ijm", function(module, exports) {
    $parcel$export(module.exports, "getParentLevelChartData", ()=>$199b49200e9b9266$export$93810e1de67e20a1);
    var $joGLY;
    var $e5ith;
    var $fnJ0I;
    const $199b49200e9b9266$export$93810e1de67e20a1 = (issueColorHash, issueStartDateHash, issueDueDateHash, parentRolledUpDatesHash, issueDateErrorsHash, issueId, isChildIssuePlanningEnabled)=>{
        const explicitStartDate = issueStartDateHash[issueId];
        const explicitDueDate = issueDueDateHash[issueId];
        const { startDate: parentLevelStartDate, dueDate: parentLevelDueDate, startDateType: startDateType, dueDateType: dueDateType, placeholder: placeholder } = (0, (0, parcelRequire("fnJ0I")).getParentLevelDates)(explicitStartDate, explicitDueDate, parentRolledUpDatesHash[issueId], isChildIssuePlanningEnabled);
        const color = issueColorHash[issueId];
        const { startDate: startDate, dueDate: dueDate } = (0, (0, parcelRequire("e5ith")).getChartDateData)(parentLevelStartDate, parentLevelDueDate, (0, (0, parcelRequire("joGLY")).PARENT_LEVEL), isChildIssuePlanningEnabled);
        return {
            startDateType: startDateType,
            dueDateType: dueDateType,
            placeholder: placeholder,
            color: color,
            startDate: startDate,
            dueDate: dueDate,
            warnings: issueDateErrorsHash[issueId],
            level: (0, (0, parcelRequire("joGLY")).PARENT_LEVEL)
        };
    };
});
parcelRegister("c6LTU", function(module, exports) {
    $parcel$export(module.exports, "getFilteredCreateCountPure", ()=>$532587a78656100a$export$300d851f748781ef);
    $parcel$export(module.exports, "getItemTypesByLevelPure", ()=>$532587a78656100a$export$3f53768088038f28);
    $parcel$export(module.exports, "getSecondaryFieldsHashPure", ()=>$532587a78656100a$export$73fd4330bbde09e8);
    var $lbWm4 = parcelRequire("lbWm4");
    var $f9Owr;
    var $joGLY;
    var $1RlSy;
    const $532587a78656100a$export$300d851f748781ef = ({ assignees: assignees, labels: labels, versions: versions, components: components })=>{
        const assigneesWithoutUnassigned = assignees.filter((assignee)=>assignee !== (0, $15a528573ccd89ae$export$12e572fd459c10dc));
        const filteredCreateCount = Math.min(assigneesWithoutUnassigned.length, 1) + Math.min(labels.length, 1) + Math.min(versions.length, 1) + Math.min(components.length, 1);
        return filteredCreateCount;
    };
    const $532587a78656100a$export$3f53768088038f28 = (issueTypeHash, epicIssueTypeIds, creationPreferences, defaultItemTypeId)=>{
        const itemTypes = {
            [(0, (0, parcelRequire("joGLY")).BASE_LEVEL)]: [],
            [(0, (0, parcelRequire("joGLY")).PARENT_LEVEL)]: []
        };
        (0, ($parcel$interopDefault($lbWm4)))(issueTypeHash, (issueType, issueTypeId)=>{
            const level = epicIssueTypeIds.includes(issueTypeId) ? 1 : 0;
            itemTypes[level].push({
                id: issueTypeId,
                iconUrl: issueType.iconUrl,
                name: issueType.name
            });
        });
        (0, ($parcel$interopDefault($lbWm4)))(itemTypes, (itemTypeForLevel, level)=>{
            itemTypeForLevel.sort((itemType1, itemType2)=>{
                const creationPreferenceForLevel = creationPreferences.itemTypes[Number(level)];
                const itemTypeName1 = itemType1.name.toUpperCase();
                const itemTypeName2 = itemType2.name.toUpperCase();
                if (creationPreferenceForLevel) {
                    if (creationPreferenceForLevel.itemTypeId === itemType1.id) return -1;
                    if (creationPreferenceForLevel.itemTypeId === itemType2.id) return 1;
                }
                if (defaultItemTypeId) {
                    if (defaultItemTypeId === itemType1.id) return -1;
                    if (defaultItemTypeId === itemType2.id) return 1;
                }
                if (itemTypeName1 < itemTypeName2) return -1;
                if (itemTypeName1 > itemTypeName2) return 1;
                return 0;
            });
        });
        return itemTypes;
    };
    const $532587a78656100a$export$73fd4330bbde09e8 = (issueIds, parentIdHash, issueStatusHash, issueAssigneeIdHash, userAvatarUrlHash, userDisplayNameHash, doneStatusCategoryId, issueFlaggedHash)=>{
        const issueSecondaryFieldHash = {};
        issueIds.forEach((id)=>{
            const issueStatus = issueStatusHash[id];
            const issueAssigneeId = issueAssigneeIdHash[id];
            const flagged = issueFlaggedHash[id];
            let status;
            let assignee;
            let mapItem;
            if (issueStatus) {
                const { name: name, statusCategoryId: statusCategoryId } = issueStatus;
                const appearance = (0, (0, parcelRequire("1RlSy")).STATUS_CATEGORY_APPEARENCE)[statusCategoryId];
                status = {
                    name: name,
                    appearance: appearance
                };
            }
            if (issueAssigneeId) {
                const name = userDisplayNameHash[issueAssigneeId];
                const avatarUrl = userAvatarUrlHash[issueAssigneeId];
                assignee = {
                    name: name,
                    avatarUrl: avatarUrl
                };
            }
            if (parentIdHash[id]) mapItem = {
                status: status,
                assignee: assignee
            };
            else if (issueStatus?.statusCategoryId === doneStatusCategoryId) mapItem = {
                status: status
            };
            issueSecondaryFieldHash[`${id}`] = {
                ...mapItem,
                flagged: (0, (0, parcelRequire("f9Owr")).ff)('jsw.timeline.return-flagged-attribute-fe') && !!flagged
            };
        });
        return issueSecondaryFieldHash;
    };
});
parcelRegister("iWyGa", function(module, exports) {
    $parcel$export(module.exports, "escapeValue", ()=>$25c6ad1fd1315972$export$ea39ee3092b88584);
    var $2gnC5 = parcelRequire("2gnC5");
    var $f9Owr;
    var $heWHN;
    var $15ADj;
    const $25c6ad1fd1315972$export$98de7bb6e1f5105c = 'yyyy/MM/DD';
    const $25c6ad1fd1315972$export$ea39ee3092b88584 = (value)=>{
        if (value === undefined) return '""';
        if (value.includes('"')) return `"${value.replace(/"/g, '""')}"`;
        return `"${value}"`;
    };
    const $25c6ad1fd1315972$export$3ae94a2503e890a1 = (date)=>$25c6ad1fd1315972$export$ea39ee3092b88584(date !== undefined ? (0, ($parcel$interopDefault($2gnC5))).utc(date).format($25c6ad1fd1315972$export$98de7bb6e1f5105c) : '');
    const $25c6ad1fd1315972$export$8275ddb83241f041 = ({ startDateCustomFieldId: startDateCustomFieldId, colorCustomFieldId: colorCustomFieldId, sprintCustomFieldId: sprintCustomFieldId, isSprintsFeatureEnabled: isSprintsFeatureEnabled })=>[
            {
                fieldId: 'issuekey',
                transform: ({ issue: issue })=>$25c6ad1fd1315972$export$ea39ee3092b88584(issue.key)
            },
            {
                fieldId: 'issuetype',
                transform: ({ issue: issue }, { issueTypesHash: issueTypesHash })=>$25c6ad1fd1315972$export$ea39ee3092b88584(issueTypesHash[issue.issueTypeId]?.name)
            },
            {
                fieldId: 'parent',
                transform: ({ issue: issue }, { issuesHash: issuesHash })=>$25c6ad1fd1315972$export$ea39ee3092b88584(issue.parentId.value ? issuesHash[issue.parentId.value]?.key : undefined)
            },
            {
                fieldId: 'summary',
                transform: ({ issue: issue })=>$25c6ad1fd1315972$export$ea39ee3092b88584(issue.summary.value)
            },
            ...(0, (0, parcelRequire("f9Owr")).ff)('jsw.timeline.return-flagged-attribute-fe') ? [
                {
                    fieldId: 'flagged',
                    transform: ({ issue: issue })=>$25c6ad1fd1315972$export$ea39ee3092b88584(issue.flagged.toString().toLowerCase())
                }
            ] : [],
            {
                fieldId: 'status',
                transform: ({ issue: issue })=>$25c6ad1fd1315972$export$ea39ee3092b88584(issue?.status?.name)
            },
            {
                fieldId: 'assignee',
                transform: ({ issue: issue }, { userDisplayNameHash: userDisplayNameHash })=>$25c6ad1fd1315972$export$ea39ee3092b88584(issue.assignee ? userDisplayNameHash[issue.assignee] : undefined)
            },
            ...isSprintsFeatureEnabled ? [
                {
                    fieldId: sprintCustomFieldId,
                    transform: ({ issueId: issueId }, { issueSprintsHash: issueSprintsHash })=>$25c6ad1fd1315972$export$ea39ee3092b88584(issueSprintsHash[issueId]?.at(0)?.name)
                }
            ] : [],
            {
                fieldId: startDateCustomFieldId,
                transform: ({ issue: issue })=>$25c6ad1fd1315972$export$3ae94a2503e890a1(issue.startDate.value)
            },
            {
                fieldId: 'inferredStartDate',
                transform: ({ chartData: chartData })=>$25c6ad1fd1315972$export$3ae94a2503e890a1(chartData?.startDate && chartData.placeholder !== (0, (0, parcelRequire("15ADj")).START_AND_DUE_DATE_PLACEHOLDER) && chartData.placeholder !== (0, (0, parcelRequire("15ADj")).START_DATE_PLACEHOLDER) ? chartData.startDate : undefined)
            },
            {
                fieldId: 'duedate',
                transform: ({ issue: issue })=>$25c6ad1fd1315972$export$3ae94a2503e890a1(issue.dueDate.value)
            },
            {
                fieldId: 'inferredDueDate',
                transform: ({ chartData: chartData })=>$25c6ad1fd1315972$export$3ae94a2503e890a1(chartData?.dueDate && chartData.placeholder !== (0, (0, parcelRequire("15ADj")).START_AND_DUE_DATE_PLACEHOLDER) && chartData.placeholder !== (0, (0, parcelRequire("15ADj")).DUE_DATE_PLACEHOLDER) ? chartData.dueDate : undefined)
            },
            {
                fieldId: colorCustomFieldId,
                transform: ({ issue: issue })=>$25c6ad1fd1315972$export$ea39ee3092b88584((0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_SERVER_COLOR)[issue.color.value])
            }
        ];
});
parcelRegister("7YTcO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dc043b93114fb4d3$export$2e2bcd8739ae039);
    parcelRequire("d0pqD");
    parcelRequire("fPS7b");
    parcelRequire("fp4O3");
    parcelRequire("aSIuP");
    var $aB8eX = parcelRequire("aB8eX");
    var $kVLXA = parcelRequire("kVLXA");
    var $4R6GH;
    var $5ulVP;
    var $5Umu2;
    var $9fPrG;
    var $1VLi2;
    var $dCEtc;
    var $hb2iR;
    var $fWch8;
    var $9QFr0;
    const $dc043b93114fb4d3$var$getIrrelevantIssueKeys = (globalIssues, roadmapIssues)=>{
        const irrelevantIssueKeys = [];
        globalIssues.forEach((globalIssue)=>{
            if (roadmapIssues[globalIssue.issueId] === undefined) irrelevantIssueKeys.push(globalIssue.issueKey);
        });
        return irrelevantIssueKeys;
    };
    var $dc043b93114fb4d3$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, (0, parcelRequire("1VLi2")).GLOBAL_ISSUE_CREATE)).mergeMap((action)=>{
            const globalIssues = action.payload;
            const globalIssueIds = globalIssues.map((issue)=>issue.issueId);
            const quickFilterIds = (0, (0, parcelRequire("fWch8")).getQuickFilters)(store.getState());
            const customFilterIds = (0, (0, parcelRequire("fWch8")).getCustomFilters)(store.getState());
            if ((0, (0, parcelRequire("4R6GH")).fg)('jsw-roadmap-state-change-based-issue-hidden-flags')) return (0, (0, parcelRequire("5Umu2")).getItems)((0, (0, parcelRequire("9fPrG")).getSourceARI)(store.getState()), globalIssueIds).map((roadmapIssuesAndUsers)=>{
                const { issues: roadmapIssues, users: roadmapUsers } = roadmapIssuesAndUsers;
                const irrelevantKeys = $dc043b93114fb4d3$var$getIrrelevantIssueKeys(globalIssues, roadmapIssues.hash);
                const createActions = [];
                if (Object.keys(roadmapUsers).length > 0) createActions.push((0, (0, parcelRequire("dCEtc")).addUsers)(roadmapUsers));
                if (roadmapIssues.sequence.length > 0) createActions.push((0, (0, parcelRequire("1VLi2")).extendIssues)(roadmapIssues, (0, (0, parcelRequire("1VLi2")).GLOBAL_ISSUE_CREATE)));
                if (irrelevantKeys.length > 0) createActions.push((0, (0, parcelRequire("hb2iR")).irrelevantIssuesCreated)({
                    issueKeys: irrelevantKeys
                }));
                return (0, $aB8eX.batchActions)(createActions);
            });
            return (0, $kVLXA.Observable).zip((0, (0, parcelRequire("5Umu2")).getItems)((0, (0, parcelRequire("9fPrG")).getSourceARI)(store.getState()), globalIssueIds), quickFilterIds.length > 0 || customFilterIds.length > 0 ? (0, (0, parcelRequire("5ulVP")).filterItemsByJQLFilters)((0, (0, parcelRequire("9fPrG")).getSourceARI)(store.getState()), quickFilterIds, customFilterIds) : (0, $kVLXA.Observable).of(null), (roadmapIssuesAndUsers, filterIssueIds)=>{
                const { issues: roadmapIssues, users: roadmapUsers } = roadmapIssuesAndUsers;
                const irrelevantKeys = $dc043b93114fb4d3$var$getIrrelevantIssueKeys(globalIssues, roadmapIssues.hash);
                const createActions = [];
                if (filterIssueIds) {
                    const issuesHiddenByQuickFilter = roadmapIssues.sequence.filter((roadmapIssueId)=>!filterIssueIds.includes(roadmapIssueId));
                    createActions.push((0, (0, parcelRequire("9QFr0")).jqlFiltersSuccess)(filterIssueIds));
                    if (issuesHiddenByQuickFilter.length > 0) createActions.push((0, (0, parcelRequire("hb2iR")).issueHidden)({
                        ids: issuesHiddenByQuickFilter
                    }));
                }
                if (Object.keys(roadmapUsers).length > 0) createActions.push((0, (0, parcelRequire("dCEtc")).addUsers)(roadmapUsers));
                if (roadmapIssues.sequence.length > 0) createActions.push((0, (0, parcelRequire("1VLi2")).extendIssues)(roadmapIssues, (0, (0, parcelRequire("1VLi2")).CREATE_ISSUE)));
                if (irrelevantKeys.length > 0) createActions.push((0, (0, parcelRequire("hb2iR")).irrelevantIssuesCreated)({
                    issueKeys: irrelevantKeys
                }));
                return (0, $aB8eX.batchActions)(createActions);
            });
        });
});
parcelRegister("5Umu2", function(module, exports) {
    $parcel$export(module.exports, "getItems", ()=>$f1bd3874c61442b1$export$d2f92acf417bbf5d);
    parcelRequire("d0pqD");
    parcelRequire("9o0uh");
    var $asgma;
    var $30COs;
    var $iW95S;
    var $8C5lr;
    var $lpZMC;
    const $f1bd3874c61442b1$var$analyticKey = 'jira.frontend.fe.software.roadmap.get-items-by-ids';
    const $f1bd3874c61442b1$var$concurrentMetricDefinition = (0, (0, parcelRequire("8C5lr")).queryMetrics)[0, $8038b72ffd5aa8d4$export$51617034fb6f2e3a];
    const $f1bd3874c61442b1$export$d2f92acf417bbf5d = (sourceAri, issueIds)=>(0, (0, parcelRequire("iW95S")).runQueryWithMetadata)((0, (0, parcelRequire("asgma")).default), (0, (0, parcelRequire("30COs")).generateGetItemsByIdsQueryVariables)(sourceAri, issueIds), $f1bd3874c61442b1$var$analyticKey, $f1bd3874c61442b1$var$concurrentMetricDefinition).map(({ data: data })=>(0, (0, parcelRequire("lpZMC")).transformIssuesFromGetItemsByIdsQueryResponse)(data));
});
parcelRegister("asgma", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a8c7b4dd55070ef6$export$2e2bcd8739ae039);
    const $a8c7b4dd55070ef6$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ids"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isRoadmapsCriticalDataItemFlaggedEnabled"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "sourceAri"
        }, v3 = [
            {
                "kind": "Variable",
                "name": "ids",
                "variableName": "ids"
            },
            {
                "kind": "Variable",
                "name": "sourceARI",
                "variableName": "sourceAri"
            }
        ], v4 = {
            "kind": "ScalarField",
            "name": "id"
        }, v5 = {
            "kind": "ScalarField",
            "name": "key"
        }, v6 = {
            "kind": "ScalarField",
            "name": "parentId"
        }, v7 = {
            "kind": "ScalarField",
            "name": "summary"
        }, v8 = {
            "kind": "ScalarField",
            "name": "startDateRFC3339"
        }, v9 = {
            "kind": "ScalarField",
            "name": "dueDateRFC3339"
        }, v10 = {
            "kind": "ScalarField",
            "name": "color"
        }, v11 = {
            "kind": "ScalarField",
            "name": "dependencies"
        }, v12 = {
            "kind": "ScalarField",
            "name": "itemTypeId"
        }, v13 = {
            "kind": "ScalarField",
            "name": "accountId"
        }, v14 = {
            "kind": "ScalarField",
            "name": "name"
        }, v15 = {
            "kind": "ScalarField",
            "name": "picture"
        }, v16 = {
            "kind": "ScalarField",
            "name": "rank"
        }, v17 = {
            "kind": "ScalarField",
            "name": "labels"
        }, v18 = {
            "kind": "ScalarField",
            "name": "sprintIds"
        }, v19 = {
            "kind": "ScalarField",
            "name": "versionIds"
        }, v20 = {
            "kind": "ScalarField",
            "name": "componentIds"
        }, v21 = {
            "kind": "ScalarField",
            "name": "resolved"
        }, v22 = {
            "kind": "ScalarField",
            "name": "flagged"
        };
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2
                ],
                "kind": "Fragment",
                "name": "getItemsByIdsQuery",
                "selections": [
                    {
                        "concreteType": "RoadmapsQuery",
                        "kind": "LinkedField",
                        "name": "roadmaps",
                        "plural": false,
                        "selections": [
                            {
                                "args": v3,
                                "concreteType": "RoadmapItem",
                                "kind": "LinkedField",
                                "name": "roadmapItemByIds",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": v4,
                                        "action": "THROW",
                                        "path": "roadmaps.roadmapItemByIds.id"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": v5,
                                        "action": "THROW",
                                        "path": "roadmaps.roadmapItemByIds.key"
                                    },
                                    v6,
                                    {
                                        "kind": "RequiredField",
                                        "field": v7,
                                        "action": "THROW",
                                        "path": "roadmaps.roadmapItemByIds.summary"
                                    },
                                    v8,
                                    v9,
                                    {
                                        "kind": "RequiredField",
                                        "field": v10,
                                        "action": "THROW",
                                        "path": "roadmaps.roadmapItemByIds.color"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": v11,
                                        "action": "THROW",
                                        "path": "roadmaps.roadmapItemByIds.dependencies"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": v12,
                                        "action": "THROW",
                                        "path": "roadmaps.roadmapItemByIds.itemTypeId"
                                    },
                                    {
                                        "kind": "LinkedField",
                                        "name": "assignee",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": v13,
                                                "action": "THROW",
                                                "path": "roadmaps.roadmapItemByIds.assignee.accountId"
                                            },
                                            {
                                                "kind": "RequiredField",
                                                "field": v14,
                                                "action": "THROW",
                                                "path": "roadmaps.roadmapItemByIds.assignee.name"
                                            },
                                            {
                                                "kind": "RequiredField",
                                                "field": v15,
                                                "action": "THROW",
                                                "path": "roadmaps.roadmapItemByIds.assignee.picture"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "RoadmapItemStatus",
                                        "kind": "LinkedField",
                                        "name": "status",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": v4,
                                                "action": "THROW",
                                                "path": "roadmaps.roadmapItemByIds.status.id"
                                            },
                                            {
                                                "kind": "RequiredField",
                                                "field": v14,
                                                "action": "THROW",
                                                "path": "roadmaps.roadmapItemByIds.status.name"
                                            },
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "concreteType": "RoadmapItemStatusCategory",
                                                    "kind": "LinkedField",
                                                    "name": "statusCategory",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v4,
                                                            "action": "THROW",
                                                            "path": "roadmaps.roadmapItemByIds.status.statusCategory.id"
                                                        }
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "roadmaps.roadmapItemByIds.status.statusCategory"
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": v16,
                                        "action": "THROW",
                                        "path": "roadmaps.roadmapItemByIds.rank"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": v17,
                                        "action": "THROW",
                                        "path": "roadmaps.roadmapItemByIds.labels"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": v18,
                                        "action": "THROW",
                                        "path": "roadmaps.roadmapItemByIds.sprintIds"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": v19,
                                        "action": "THROW",
                                        "path": "roadmaps.roadmapItemByIds.versionIds"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": v20,
                                        "action": "THROW",
                                        "path": "roadmaps.roadmapItemByIds.componentIds"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": v21,
                                        "action": "THROW",
                                        "path": "roadmaps.roadmapItemByIds.resolved"
                                    },
                                    {
                                        "condition": "isRoadmapsCriticalDataItemFlaggedEnabled",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": v22,
                                                "action": "THROW",
                                                "path": "roadmaps.roadmapItemByIds.flagged"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v2,
                    v0,
                    v1
                ],
                "kind": "Operation",
                "name": "getItemsByIdsQuery",
                "selections": [
                    {
                        "concreteType": "RoadmapsQuery",
                        "kind": "LinkedField",
                        "name": "roadmaps",
                        "plural": false,
                        "selections": [
                            {
                                "args": v3,
                                "concreteType": "RoadmapItem",
                                "kind": "LinkedField",
                                "name": "roadmapItemByIds",
                                "plural": true,
                                "selections": [
                                    v4,
                                    v5,
                                    v6,
                                    v7,
                                    v8,
                                    v9,
                                    v10,
                                    v11,
                                    v12,
                                    {
                                        "kind": "LinkedField",
                                        "name": "assignee",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "__typename"
                                            },
                                            v13,
                                            v14,
                                            v15,
                                            v4
                                        ]
                                    },
                                    {
                                        "concreteType": "RoadmapItemStatus",
                                        "kind": "LinkedField",
                                        "name": "status",
                                        "plural": false,
                                        "selections": [
                                            v4,
                                            v14,
                                            {
                                                "concreteType": "RoadmapItemStatusCategory",
                                                "kind": "LinkedField",
                                                "name": "statusCategory",
                                                "plural": false,
                                                "selections": [
                                                    v4
                                                ]
                                            }
                                        ]
                                    },
                                    v16,
                                    v17,
                                    v18,
                                    v19,
                                    v20,
                                    v21,
                                    {
                                        "condition": "isRoadmapsCriticalDataItemFlaggedEnabled",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            v22
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "90c1860875ba5b16004b821f7b613eaa617bf47cc6b4cdff8568a42a6c8d5729",
                "metadata": {},
                "name": "getItemsByIdsQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $a8c7b4dd55070ef6$var$node.hash = "591daa91640ce28204a62d6e310a6911";
    var $a8c7b4dd55070ef6$export$2e2bcd8739ae039 = $a8c7b4dd55070ef6$var$node;
});
parcelRegister("30COs", function(module, exports) {
    $parcel$export(module.exports, "generateGetItemsByIdsQueryVariables", ()=>$ce84b947a97cf779$export$b1321c96886bcd30);
    var $f9Owr;
    const $ce84b947a97cf779$export$b1321c96886bcd30 = (sourceAri, ids)=>({
            sourceAri: sourceAri,
            ids: ids,
            isRoadmapsCriticalDataItemFlaggedEnabled: (0, (0, parcelRequire("f9Owr")).ff)('jsw.timeline.return-flagged-attribute-fe')
        });
});
parcelRegister("dRohj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$603845cee9e68f04$export$2e2bcd8739ae039);
    var $kVLXA = parcelRequire("kVLXA");
    parcelRequire("bqQg9");
    parcelRequire("aPq29");
    parcelRequire("kclUa");
    var $jAJAx;
    var $1VLi2;
    var $fWch8;
    var $2IdXh;
    var $bkF6q;
    var $dKMCD;
    var $4rIVu;
    var $2QNFL;
    var $cpBs5;
    var $603845cee9e68f04$export$2e2bcd8739ae039 = (action$, store)=>{
        const afterCriticalDataLoad$ = action$.skipUntil(action$.ofType((0, (0, parcelRequire("jAJAx")).INITIALIZE_NON_CRITICAL_DATA)));
        const selectorResult$ = (0, (0, parcelRequire("bkF6q")).observeSelector)(afterCriticalDataLoad$, store, (0, (0, parcelRequire("2IdXh")).getFilteredIssueIds));
        const resultChangeWithAction$ = selectorResult$.pairwise().withLatestFrom(action$, (change, action)=>({
                change: change,
                action: action
            }));
        const groupedAction$ = (0, (0, parcelRequire("cpBs5")).groupBatchedActionsObservable)(resultChangeWithAction$);
        return groupedAction$.filter(({ action: action })=>[
                (0, (0, parcelRequire("1VLi2")).EXTEND_ISSUES),
                (0, (0, parcelRequire("1VLi2")).REPLACE_ISSUE),
                (0, (0, parcelRequire("1VLi2")).CLEAR_TRANSITION_STATE)
            ].includes(action.type)).mergeMap(({ change: change, action: action })=>{
            const state = store.getState();
            const { type: type, payload: payload } = action;
            const [before, after] = change;
            const quickFilterIds = (0, (0, parcelRequire("fWch8")).getQuickFilters)(state);
            const customFilterIds = (0, (0, parcelRequire("fWch8")).getCustomFilters)(state);
            const isJQLFilterApplied = quickFilterIds.length > 0 || customFilterIds.length > 0;
            const caller = payload[0]?.meta?.caller;
            if (type === (0, (0, parcelRequire("1VLi2")).REPLACE_ISSUE) && caller === (0, (0, parcelRequire("1VLi2")).CREATE_ISSUE)) return (0, (0, parcelRequire("dKMCD")).handleHiddenIssueCreated)(store, before, after, payload);
            if (type === (0, (0, parcelRequire("1VLi2")).EXTEND_ISSUES) && caller === (0, (0, parcelRequire("1VLi2")).GLOBAL_ISSUE_CREATE)) return (0, (0, parcelRequire("dKMCD")).handleHiddenGlobalIssueCreated)(store, before, after, payload);
            if (type === (0, (0, parcelRequire("1VLi2")).EXTEND_ISSUES) && caller === (0, (0, parcelRequire("1VLi2")).UPDATE_ISSUE)) return (0, (0, parcelRequire("2QNFL")).handleHiddenIssueUpdated)(action$, store, before, after, payload, isJQLFilterApplied);
            if (type === (0, (0, parcelRequire("1VLi2")).EXTEND_ISSUES) && caller === (0, (0, parcelRequire("1VLi2")).SCHEDULE_ISSUES)) return (0, (0, parcelRequire("4rIVu")).handleHiddenIssueRescheduled)(action$, store, before, after, payload, isJQLFilterApplied);
            return (0, $kVLXA.Observable).empty();
        });
    };
});
parcelRegister("kclUa", function(module, exports) {
    "use strict";
    var $kVLXA = parcelRequire("kVLXA");
    var $4rJjS = parcelRequire("4rJjS");
    $kVLXA.Observable.prototype.skipUntil = $4rJjS.skipUntil;
});
parcelRegister("4rJjS", function(module, exports) {
    $parcel$export(module.exports, "skipUntil", ()=>$33ccd68c53993323$export$facc584867c26fde, (v)=>$33ccd68c53993323$export$facc584867c26fde = v);
    var $33ccd68c53993323$export$facc584867c26fde;
    "use strict";
    var $eZ5AN = parcelRequire("eZ5AN");
    function $33ccd68c53993323$var$skipUntil(notifier) {
        return $eZ5AN.skipUntil(notifier)(this);
    }
    $33ccd68c53993323$export$facc584867c26fde = $33ccd68c53993323$var$skipUntil;
});
parcelRegister("eZ5AN", function(module, exports) {
    "use strict";
    var $ae8b19bf9da600d2$var$__extends = module.exports && module.exports.__extends || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var $RlQRN = parcelRequire("RlQRN");
    var $558qb = parcelRequire("558qb");
    function $ae8b19bf9da600d2$var$skipUntil(notifier) {
        return function(source) {
            return source.lift(new $ae8b19bf9da600d2$var$SkipUntilOperator(notifier));
        };
    }
    module.exports.skipUntil = $ae8b19bf9da600d2$var$skipUntil;
    var $ae8b19bf9da600d2$var$SkipUntilOperator = function() {
        function SkipUntilOperator(notifier) {
            this.notifier = notifier;
        }
        SkipUntilOperator.prototype.call = function(subscriber, source) {
            return source.subscribe(new $ae8b19bf9da600d2$var$SkipUntilSubscriber(subscriber, this.notifier));
        };
        return SkipUntilOperator;
    }();
    var $ae8b19bf9da600d2$var$SkipUntilSubscriber = function(_super) {
        $ae8b19bf9da600d2$var$__extends(SkipUntilSubscriber, _super);
        function SkipUntilSubscriber(destination, notifier) {
            _super.call(this, destination);
            this.hasValue = false;
            this.isInnerStopped = false;
            this.add($558qb.subscribeToResult(this, notifier));
        }
        SkipUntilSubscriber.prototype._next = function(value) {
            if (this.hasValue) _super.prototype._next.call(this, value);
        };
        SkipUntilSubscriber.prototype._complete = function() {
            if (this.isInnerStopped) _super.prototype._complete.call(this);
            else this.unsubscribe();
        };
        SkipUntilSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
            this.hasValue = true;
        };
        SkipUntilSubscriber.prototype.notifyComplete = function() {
            this.isInnerStopped = true;
            if (this.isStopped) _super.prototype._complete.call(this);
        };
        return SkipUntilSubscriber;
    }($RlQRN.OuterSubscriber);
});
parcelRegister("bkF6q", function(module, exports) {
    $parcel$export(module.exports, "observeSelector", ()=>$7f2b182d96edc4cd$export$ccc0552649affc7d);
    const $7f2b182d96edc4cd$export$ccc0552649affc7d = (action$, store, selector)=>{
        let recomputations = selector.recomputations();
        return action$.filter(()=>selector.recomputations() !== recomputations).map(()=>{
            const state = store.getState();
            recomputations = selector.recomputations();
            return selector(state);
        });
    };
});
parcelRegister("dKMCD", function(module, exports) {
    $parcel$export(module.exports, "handleHiddenIssueCreated", ()=>$fd0031495f596303$export$d095245b0238bf2);
    $parcel$export(module.exports, "handleHiddenGlobalIssueCreated", ()=>$fd0031495f596303$export$21f4857e44d73821);
    var $k8IPx = parcelRequire("k8IPx");
    var $dDkmN = parcelRequire("dDkmN");
    var $hqTkp = parcelRequire("hqTkp");
    var $kVLXA = parcelRequire("kVLXA");
    var $hb2iR;
    const $fd0031495f596303$var$getHiddenCreatedIssueIds = (before, after, created, removed)=>{
        const expected = (0, ($parcel$interopDefault($hqTkp)))((0, ($parcel$interopDefault($dDkmN)))(before, created), ...removed);
        return (0, ($parcel$interopDefault($k8IPx)))(expected, after);
    };
    const $fd0031495f596303$export$d095245b0238bf2 = (store, before, after, actions)=>{
        const created = actions.map((action)=>action.payload.id);
        const removed = actions.map((action)=>action.payload.temporaryId);
        const hidden = $fd0031495f596303$var$getHiddenCreatedIssueIds(before, after, created, removed);
        return hidden.length > 0 ? (0, $kVLXA.Observable).of((0, (0, parcelRequire("hb2iR")).issueHidden)({
            ids: hidden
        })) : (0, $kVLXA.Observable).empty();
    };
    const $fd0031495f596303$export$21f4857e44d73821 = (store, before, after, actions)=>{
        const created = actions.flatMap((action)=>Object.keys(action.payload.hash));
        const hidden = $fd0031495f596303$var$getHiddenCreatedIssueIds(before, after, created, []);
        return hidden.length > 0 ? (0, $kVLXA.Observable).of((0, (0, parcelRequire("hb2iR")).issueHidden)({
            ids: hidden
        })) : (0, $kVLXA.Observable).empty();
    };
});
parcelRegister("hqTkp", function(module, exports) {
    var $55pzo = parcelRequire("55pzo");
    var $g7i7g = parcelRequire("g7i7g");
    var $f3SOL = parcelRequire("f3SOL");
    var $cb0fc8686550aa11$var$without = $g7i7g(function(array, values) {
        return $f3SOL(array) ? $55pzo(array, values) : [];
    });
    module.exports = $cb0fc8686550aa11$var$without;
});
parcelRegister("4rIVu", function(module, exports) {
    $parcel$export(module.exports, "handleHiddenIssueRescheduled", ()=>$1011d97f3281007b$export$3511d3b1489d5cf4);
    var $k8IPx = parcelRequire("k8IPx");
    var $fn8B5 = parcelRequire("fn8B5");
    var $4wVpT = parcelRequire("4wVpT");
    var $kVLXA = parcelRequire("kVLXA");
    parcelRequire("inj9P");
    var $hFyhA;
    var $hb2iR;
    var $2IdXh;
    var $bM42j;
    var $9r8lg;
    const $1011d97f3281007b$var$getHiddenScheduledIssueIds = (before, after, scheduled)=>{
        const hidden = (0, ($parcel$interopDefault($k8IPx)))(before, after);
        return (0, ($parcel$interopDefault($4wVpT)))(hidden, scheduled);
    };
    const $1011d97f3281007b$var$getAlreadyHiddenScheduledIssueIds = (after, scheduled)=>(0, ($parcel$interopDefault($k8IPx)))(scheduled, after);
    const $1011d97f3281007b$var$getCollapsedScheduledIssueIds = (store, scheduled)=>{
        const state = store.getState();
        const issueParentIdHash = (0, (0, parcelRequire("hFyhA")).getIssueParentIdHash)(state);
        const issueIdsByParentIds = (0, ($parcel$interopDefault($fn8B5)))(scheduled, (id)=>issueParentIdHash[id]);
        const issueParentIds = Object.keys(issueIdsByParentIds);
        const scheduledIssueParentIds = (0, ($parcel$interopDefault($4wVpT)))(scheduled, issueParentIds);
        const expandedItems = (0, (0, parcelRequire("bM42j")).getExpandedItems)(state);
        const collapsedScheduledIssueParentIds = scheduledIssueParentIds.filter((id)=>!(expandedItems[id] ?? false));
        return collapsedScheduledIssueParentIds.flatMap((id)=>issueIdsByParentIds[id]);
    };
    const $1011d97f3281007b$export$3511d3b1489d5cf4 = (action$, store, before, after, actions, isJQLFilterApplied)=>{
        const scheduled = actions.flatMap((action)=>Object.keys(action.payload.hash));
        const clientHiddenScheduled = $1011d97f3281007b$var$getHiddenScheduledIssueIds(before, after, scheduled);
        if (clientHiddenScheduled.length > 0) return (0, $kVLXA.Observable).of((0, (0, parcelRequire("hb2iR")).issueDisappearsFromDisplayRange)({
            issueId: clientHiddenScheduled[0]
        }));
        const clientAlreadyHiddenScheduled = $1011d97f3281007b$var$getAlreadyHiddenScheduledIssueIds(after, scheduled);
        if (clientAlreadyHiddenScheduled.length > 0) return (0, $kVLXA.Observable).of((0, (0, parcelRequire("hb2iR")).issueHidden)({
            ids: clientAlreadyHiddenScheduled
        }));
        const collapsedScheduledIssueIds = $1011d97f3281007b$var$getCollapsedScheduledIssueIds(store, scheduled);
        if (collapsedScheduledIssueIds.length > 0) return (0, $kVLXA.Observable).of((0, (0, parcelRequire("hb2iR")).issueHidden)({
            ids: collapsedScheduledIssueIds
        }));
        const asyncCheck = ()=>{
            const state = store.getState();
            const final = (0, (0, parcelRequire("2IdXh")).getFilteredIssueIds)(state);
            const serverHiddenScheduled = $1011d97f3281007b$var$getHiddenScheduledIssueIds(before, final, scheduled);
            if (serverHiddenScheduled.length > 0) return (0, $kVLXA.Observable).of((0, (0, parcelRequire("hb2iR")).issueHidden)({
                ids: serverHiddenScheduled
            }));
            return (0, $kVLXA.Observable).empty();
        };
        if (isJQLFilterApplied) return (0, $kVLXA.Observable).concat((0, (0, parcelRequire("9r8lg")).awaitReapplyJQLFilters)(action$), (0, $kVLXA.Observable).defer(asyncCheck));
        return (0, $kVLXA.Observable).empty();
    };
});
parcelRegister("9r8lg", function(module, exports) {
    $parcel$export(module.exports, "awaitReapplyJQLFilters", ()=>$af044e1abca6ce38$export$36ac0dbca5255db1);
    var $kVLXA = parcelRequire("kVLXA");
    parcelRequire("8vsXW");
    parcelRequire("hZWgu");
    var $9QFr0;
    const $af044e1abca6ce38$export$36ac0dbca5255db1 = (action$)=>(0, $kVLXA.Observable).concat(action$.ofType((0, (0, parcelRequire("9QFr0")).JQL_FILTERS_REAPPLY)).first().ignoreElements(), action$.ofType((0, (0, parcelRequire("9QFr0")).JQL_FILTERS_SUCCESS)).first().ignoreElements());
});
parcelRegister("2QNFL", function(module, exports) {
    $parcel$export(module.exports, "handleHiddenIssueUpdated", ()=>$c2b21df8e39b4eec$export$b98d9ae8804c9ef8);
    var $k8IPx = parcelRequire("k8IPx");
    var $4wVpT = parcelRequire("4wVpT");
    var $kVLXA = parcelRequire("kVLXA");
    parcelRequire("inj9P");
    parcelRequire("8vsXW");
    var $hb2iR;
    var $2IdXh;
    var $9r8lg;
    const $c2b21df8e39b4eec$var$getHiddenUpdatedIssueIds = (before, after, updated)=>{
        const hidden = (0, ($parcel$interopDefault($k8IPx)))(before, after);
        return (0, ($parcel$interopDefault($4wVpT)))(hidden, updated);
    };
    const $c2b21df8e39b4eec$export$b98d9ae8804c9ef8 = (action$, store, before, after, actions, isJQLFilterApplied)=>{
        const updated = actions.flatMap((action)=>Object.keys(action.payload.hash));
        const clientHiddenUpdated = $c2b21df8e39b4eec$var$getHiddenUpdatedIssueIds(before, after, updated);
        if (clientHiddenUpdated.length > 0) return (0, $kVLXA.Observable).of((0, (0, parcelRequire("hb2iR")).issueDisappearsFromDisplayRange)({
            issueId: clientHiddenUpdated[0]
        }));
        const asyncCheck = ()=>{
            const state = store.getState();
            const final = (0, (0, parcelRequire("2IdXh")).getFilteredIssueIds)(state);
            const serverHiddenUpdated = $c2b21df8e39b4eec$var$getHiddenUpdatedIssueIds(before, final, updated);
            if (serverHiddenUpdated.length > 0) return (0, $kVLXA.Observable).of((0, (0, parcelRequire("hb2iR")).issueHidden)({
                ids: serverHiddenUpdated
            }));
            return (0, $kVLXA.Observable).empty();
        };
        if (isJQLFilterApplied) return (0, $kVLXA.Observable).concat((0, (0, parcelRequire("9r8lg")).awaitReapplyJQLFilters)(action$), (0, $kVLXA.Observable).defer(asyncCheck));
        return (0, $kVLXA.Observable).empty();
    };
});
parcelRegister("cpBs5", function(module, exports) {
    $parcel$export(module.exports, "groupBatchedActionsObservable", ()=>$f8f0a99a10e9d5ae$export$66441a0e10ffb390);
    var $aB8eX = parcelRequire("aB8eX");
    var $kVLXA = parcelRequire("kVLXA");
    parcelRequire("hZWgu");
    const $f8f0a99a10e9d5ae$export$a40b51388efb1169 = (action)=>action.type === (0, $aB8eX.BATCH);
    const $f8f0a99a10e9d5ae$var$group = (values, extractKey)=>values.reduce((acc, curr)=>{
            const key = extractKey(curr);
            if (acc[key] === undefined) acc[key] = [];
            acc[key].push(curr);
            return acc;
        }, {});
    const $f8f0a99a10e9d5ae$var$batchActionToGroupedActions = (action)=>{
        const actions = $f8f0a99a10e9d5ae$export$a40b51388efb1169(action) ? action.payload : [
            action
        ];
        const groupedActions = $f8f0a99a10e9d5ae$var$group(actions, ({ type: type })=>type);
        return Object.entries(groupedActions).map(([key, value])=>({
                type: key,
                payload: value,
                grouped: true
            }));
    };
    const $f8f0a99a10e9d5ae$export$66441a0e10ffb390 = (action$)=>action$.mergeMap(({ change: change, action: action })=>(0, $kVLXA.Observable).from($f8f0a99a10e9d5ae$var$batchActionToGroupedActions(action).map((groupedAction)=>({
                    change: change,
                    action: groupedAction
                }))));
});
parcelRegister("iT7Wh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cfd698aeb870dd66$export$2e2bcd8739ae039);
    parcelRequire("93e44");
    parcelRequire("6hSeW");
    parcelRequire("fp4O3");
    parcelRequire("fPS7b");
    parcelRequire("d0pqD");
    var $aB8eX = parcelRequire("aB8eX");
    var $4wVpT = parcelRequire("4wVpT");
    var $kVLXA = parcelRequire("kVLXA");
    var $dJl1T;
    var $4R6GH;
    var $FTaAj;
    var $5fc53;
    var $joGLY;
    var $70YnB;
    var $5ulVP;
    var $borsN;
    var $1RlSy;
    var $9fPrG;
    var $4gYYI;
    var $1VLi2;
    var $hFyhA;
    var $bDdHs;
    var $fQlTr;
    var $iaL1N;
    var $hb2iR;
    var $fWch8;
    var $4LbSm;
    var $9QFr0;
    var $aDWLo;
    var $dbmvg;
    const $cfd698aeb870dd66$var$getRoadmapIssueFieldName = (state, fieldId)=>{
        const colorFieldId = (0, (0, parcelRequire("4gYYI")).getColorCustomFieldId)(state);
        const startDateCustomFieldId = (0, (0, parcelRequire("4gYYI")).getStartDateCustomFieldId)(state);
        const epicLinkCustomFieldId = (0, (0, parcelRequire("4gYYI")).getEpicLinkCustomFieldId)(state);
        const sprintCustomFieldId = (0, (0, parcelRequire("4gYYI")).getSprintCustomFieldId)(state);
        return (0, (0, parcelRequire("borsN")).mapIssueViewFieldToRoadmapField)(fieldId, startDateCustomFieldId, colorFieldId, epicLinkCustomFieldId, sprintCustomFieldId);
    };
    const $cfd698aeb870dd66$var$updateIssueSequenceOptimistically = (store, issueIds, isRankAfter, rankId)=>{
        const oldSequence = (0, (0, parcelRequire("hFyhA")).getIssueIds)(store.getState());
        const issueIdsExisted = issueIds.filter((id)=>(0, (0, parcelRequire("hFyhA")).isIssueExists)(store.getState(), id));
        if (issueIdsExisted.length > 0) {
            const newSequence = oldSequence.filter((id)=>!issueIdsExisted.includes(id));
            const rank = rankId.toString();
            const getInsertIndex = ()=>{
                if (!isRankAfter) return newSequence.indexOf(rank);
                return rank ? newSequence.indexOf(rank) + 1 : 0;
            };
            newSequence.splice(getInsertIndex(), 0, ...issueIdsExisted);
            return (0, $kVLXA.Observable).of((0, (0, parcelRequire("1VLi2")).updateIssuesSequence)((0, ($parcel$interopDefault($4wVpT)))(newSequence, oldSequence)));
        }
        return (0, $kVLXA.Observable).empty();
    };
    const $cfd698aeb870dd66$var$canUpdateIssueOptimistically = (state, fieldName, newValue)=>!((fieldName === (0, (0, parcelRequire("70YnB")).ASSIGNEE) || fieldName === (0, (0, parcelRequire("70YnB")).STATUS)) && newValue !== null && (0, (0, parcelRequire("iaL1N")).getUser)(state, newValue.accountId) === undefined);
    const $cfd698aeb870dd66$var$shouldRemoveIssueFromRoadmap = (state, fieldName, newValue)=>fieldName === (0, (0, parcelRequire("70YnB")).PARENT_ID) && (newValue === null || !(0, (0, parcelRequire("hFyhA")).isIssueExists)(state, newValue.id));
    const $cfd698aeb870dd66$var$updateIssueOptimistically = (state, issueId, fieldName, issue, newValue)=>fieldName ? (0, $kVLXA.Observable).of((0, (0, parcelRequire("1VLi2")).extendIssues)({
            sequence: [],
            hash: {
                [issueId]: {
                    ...issue,
                    [fieldName]: (0, (0, parcelRequire("borsN")).convertIssueViewFieldValue)(fieldName, newValue)
                }
            }
        })) : (0, $kVLXA.Observable).empty();
    const $cfd698aeb870dd66$var$updateIssueField = (store, fieldId, issueId, newValue)=>{
        const state = store.getState();
        const fieldName = $cfd698aeb870dd66$var$getRoadmapIssueFieldName(state, fieldId);
        const issue = (0, (0, parcelRequire("hFyhA")).getIssue)(state, issueId);
        if (fieldName !== undefined && issue) {
            if (fieldName === (0, (0, parcelRequire("70YnB")).PARENT_ID) && (0, (0, parcelRequire("hFyhA")).getIssueLevel)(state, issueId) === (0, (0, parcelRequire("joGLY")).PARENT_LEVEL)) return (0, $kVLXA.Observable).empty();
            let issueAction;
            if ($cfd698aeb870dd66$var$shouldRemoveIssueFromRoadmap(state, fieldName, newValue)) issueAction = (0, $kVLXA.Observable).of((0, (0, parcelRequire("1VLi2")).removeIssue)(issueId));
            else if ($cfd698aeb870dd66$var$canUpdateIssueOptimistically(state, fieldName, newValue)) issueAction = $cfd698aeb870dd66$var$updateIssueOptimistically(state, issueId, fieldName, issue, newValue);
            else issueAction = (0, (0, parcelRequire("aDWLo")).reloadIssues)(store, [
                issueId
            ]);
            const setUpdatedFilter = (0, (0, parcelRequire("dbmvg")).createSetUpdatedFilter)(state, issueId, newValue, fieldName);
            const setUpdatedConfiguration = (0, (0, parcelRequire("dbmvg")).createSetUpdatedConfiguration)(state, newValue, fieldName);
            return (0, $kVLXA.Observable).merge(issueAction, setUpdatedFilter ? (0, $kVLXA.Observable).of(setUpdatedFilter) : (0, $kVLXA.Observable).empty(), setUpdatedConfiguration ? (0, $kVLXA.Observable).of(setUpdatedConfiguration) : (0, $kVLXA.Observable).empty());
        }
        return (0, $kVLXA.Observable).empty();
    };
    const $cfd698aeb870dd66$var$addChildIssue = (store, childIssue, quickFilterIds, customFilterIds)=>(0, (0, parcelRequire("5ulVP")).filterItemsByJQLFilters)((0, (0, parcelRequire("9fPrG")).getSourceARI)(store.getState()), quickFilterIds, customFilterIds).map((filterIssueIds)=>{
            const createActions = [];
            const childIssueId = childIssue.id;
            const isHiddenByQuickFilter = !filterIssueIds.includes(childIssueId);
            createActions.push((0, (0, parcelRequire("9QFr0")).jqlFiltersSuccess)(filterIssueIds));
            if (isHiddenByQuickFilter) createActions.push((0, (0, parcelRequire("hb2iR")).issueHidden)({
                ids: [
                    childIssueId
                ]
            }));
            return (0, $aB8eX.batchActions)(createActions);
        });
    const $cfd698aeb870dd66$var$updateSubtaskParent = (store, issueId, newParentId)=>{
        const state = store.getState();
        const oldParentId = (0, (0, parcelRequire("4LbSm")).getSubtaskParentHash)(state)[issueId];
        if (oldParentId) {
            if ((0, (0, parcelRequire("fQlTr")).getFullSubtasksHash)(state)[newParentId]) return (0, $kVLXA.Observable).of((0, (0, parcelRequire("bDdHs")).changeSubtaskParent)({
                id: issueId,
                oldParentId: oldParentId,
                newParentId: newParentId
            }));
            return (0, $kVLXA.Observable).of((0, (0, parcelRequire("bDdHs")).removeSubtasks)([
                {
                    id: issueId,
                    parentId: oldParentId
                }
            ]));
        }
        return (0, $kVLXA.Observable).empty();
    };
    const $cfd698aeb870dd66$var$isIssueSubtask = (state, issueId)=>Boolean((0, (0, parcelRequire("4LbSm")).getSubtaskParentHash)(state)[issueId]);
    const $cfd698aeb870dd66$var$isIssueSubtaskParent = (state, issueId)=>Boolean((0, (0, parcelRequire("fQlTr")).getFullSubtasksHash)(state)[issueId]);
    const $cfd698aeb870dd66$var$addJQLFiltersRequest = (store, quickFilterIds, customFilterIds)=>(0, (0, parcelRequire("5ulVP")).filterItemsByJQLFilters)((0, (0, parcelRequire("9fPrG")).getSourceARI)(store.getState()), quickFilterIds, customFilterIds).map((filterIssueIds)=>(0, (0, parcelRequire("9QFr0")).jqlFiltersSuccess)(filterIssueIds));
    var $cfd698aeb870dd66$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, (0, parcelRequire("1VLi2")).RELOAD_ISSUE)).mergeMap((action)=>{
            const event = action.payload;
            const state = store.getState();
            const { issueId: issueId } = event;
            const quickFilterIds = (0, (0, parcelRequire("fWch8")).getQuickFilters)(state);
            const customFilterIds = (0, (0, parcelRequire("fWch8")).getCustomFilters)(state);
            const isJQLFiltersApplied = quickFilterIds.length > 0 || customFilterIds.length > 0;
            if (!(0, (0, parcelRequire("hFyhA")).isIssueExists)(state, issueId)) return (0, $kVLXA.Observable).empty();
            switch(event.type){
                case (0, (0, parcelRequire("FTaAj")).ChangeEventTypes).CHILD_ISSUE_ADDED:
                    {
                        const { meta: { childIssue: childIssue } } = event;
                        if ($cfd698aeb870dd66$var$isIssueSubtaskParent(state, issueId)) return (0, $kVLXA.Observable).of((0, (0, parcelRequire("bDdHs")).addSubtask)({
                            id: issueId,
                            subtask: {
                                id: childIssue.id,
                                key: childIssue.issueKey || '',
                                statusCategoryId: `${(0, (0, parcelRequire("1RlSy")).TODO_STATUS_CATEGORY_ID)}`
                            }
                        }));
                        if (isJQLFiltersApplied) try {
                            return $cfd698aeb870dd66$var$addChildIssue(store, childIssue, quickFilterIds, customFilterIds);
                        } catch (error) {
                            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('roadmap.standard.ops.issue.optimistic-update', "Failed to handle optimistic update 'CHILD_ISSUE_ADDED' from the issue view", error);
                        }
                        break;
                    }
                case (0, (0, parcelRequire("FTaAj")).ChangeEventTypes).FIELD_CHANGED:
                    {
                        const { meta: { fieldId: fieldId, fieldValue: fieldValue } } = event;
                        if ((0, (0, parcelRequire("borsN")).isFieldUpdateWithoutRequestEvent)(fieldId)) {
                            if (fieldId === (0, (0, parcelRequire("70YnB")).STATUS) && $cfd698aeb870dd66$var$isIssueSubtask(state, issueId)) {
                                const { statusCategory: { id: statusCategoryId } } = fieldValue;
                                return (0, $kVLXA.Observable).of((0, (0, parcelRequire("bDdHs")).updateSubtaskStatus)({
                                    id: issueId,
                                    parentId: (0, (0, parcelRequire("4LbSm")).getSubtaskParentHash)(state)[issueId],
                                    statusCategoryId: statusCategoryId
                                }));
                            }
                            try {
                                if (!(0, (0, parcelRequire("4R6GH")).fg)('jsw-roadmap-state-change-based-issue-hidden-flags') && isJQLFiltersApplied) return (0, $kVLXA.Observable).merge($cfd698aeb870dd66$var$addJQLFiltersRequest(store, quickFilterIds, customFilterIds), $cfd698aeb870dd66$var$updateIssueField(store, fieldId, issueId, fieldValue));
                                return $cfd698aeb870dd66$var$updateIssueField(store, fieldId, issueId, fieldValue);
                            } catch (error) {
                                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('roadmap.standard.ops.issue.optimistic-update', `Failed to handle optimistic update 'FIELD_CHANGED' from the issue view for field "${fieldId}"`, error);
                            }
                        }
                        break;
                    }
                case (0, (0, parcelRequire("FTaAj")).ChangeEventTypes).FIELD_CHANGE_REQUESTED:
                    {
                        const { meta: { fieldId: fieldId, fieldValue: fieldValue } } = event;
                        try {
                            if (!(0, (0, parcelRequire("4R6GH")).fg)('jsw-roadmap-state-change-based-issue-hidden-flags') && isJQLFiltersApplied) {
                                if (!(0, (0, parcelRequire("borsN")).isFieldUpdateWithoutRequestEvent)(event.meta.fieldId)) return (0, $kVLXA.Observable).merge($cfd698aeb870dd66$var$addJQLFiltersRequest(store, quickFilterIds, customFilterIds), $cfd698aeb870dd66$var$updateIssueField(store, fieldId, issueId, fieldValue));
                                break;
                            }
                            return $cfd698aeb870dd66$var$updateIssueField(store, fieldId, issueId, fieldValue);
                        } catch (error) {
                            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('roadmap.standard.ops.issue.optimistic-update', `Failed to handle optimistic update 'FIELD_CHANGE_REQUESTED' from the issue view for field "${fieldId}"`, error);
                        }
                        break;
                    }
                case (0, (0, parcelRequire("FTaAj")).ChangeEventTypes).ISSUE_CHILDREN_ORDER_CHANGED:
                    {
                        const { meta: { issueIds: issueIds, rankId: rankId, isRankAfter: isRankAfter } } = event;
                        try {
                            return $cfd698aeb870dd66$var$updateIssueSequenceOptimistically(store, issueIds, isRankAfter, rankId);
                        } catch (error) {
                            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('roadmap.standard.ops.issue.optimistic-update', `Failed to handle optimistic rank update from the issue view for child issue "${issueIds.join(',')}"`, error);
                        }
                        break;
                    }
                case (0, (0, parcelRequire("FTaAj")).ChangeEventTypes).ISSUE_RELATIONSHIP_UPDATED:
                    {
                        const { meta: { newParentIssueId: newParentIssueId } } = event;
                        if ($cfd698aeb870dd66$var$isIssueSubtask(state, issueId) && newParentIssueId !== null) return $cfd698aeb870dd66$var$updateSubtaskParent(store, issueId, newParentIssueId);
                        try {
                            if (!(0, (0, parcelRequire("4R6GH")).fg)('jsw-roadmap-state-change-based-issue-hidden-flags') && isJQLFiltersApplied) return (0, $kVLXA.Observable).merge($cfd698aeb870dd66$var$addJQLFiltersRequest(store, quickFilterIds, customFilterIds), $cfd698aeb870dd66$var$updateIssueField(store, (0, (0, parcelRequire("5fc53")).PARENT_TYPE), issueId, {
                                id: newParentIssueId
                            }));
                            return $cfd698aeb870dd66$var$updateIssueField(store, (0, (0, parcelRequire("5fc53")).PARENT_TYPE), issueId, {
                                id: newParentIssueId
                            });
                        } catch (error) {
                            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('roadmap.standard.ops.issue.optimistic-update', `Failed to handle optimistic update 'ISSUE_RELATIONSHIP_UPDATED' from the issue view for field ${(0, (0, parcelRequire("5fc53")).PARENT_TYPE)}`, error);
                        }
                        break;
                    }
                case (0, (0, parcelRequire("FTaAj")).ChangeEventTypes).FIELD_CHANGE_FAILED:
                    {
                        const { meta: { fieldId: fieldId } } = event;
                        if ($cfd698aeb870dd66$var$getRoadmapIssueFieldName(store.getState(), fieldId) === undefined) break;
                        if (!(0, (0, parcelRequire("4R6GH")).fg)('jsw-roadmap-state-change-based-issue-hidden-flags') && isJQLFiltersApplied) return (0, $kVLXA.Observable).merge($cfd698aeb870dd66$var$addJQLFiltersRequest(store, quickFilterIds, customFilterIds), (0, (0, parcelRequire("aDWLo")).reloadIssues)(store, [
                            issueId
                        ]));
                        return (0, (0, parcelRequire("aDWLo")).reloadIssues)(store, [
                            issueId
                        ]);
                    }
                case (0, (0, parcelRequire("FTaAj")).ChangeEventTypes).ISSUE_TYPE_CHANGED:
                    {
                        const { fieldId: fieldId, meta: { typeName: typeName } } = event;
                        const setUpdatedFilter = (0, (0, parcelRequire("dbmvg")).createSetUpdatedFilter)(state, issueId, typeName, fieldId);
                        if (setUpdatedFilter) {
                            if (!(0, (0, parcelRequire("4R6GH")).fg)('jsw-roadmap-state-change-based-issue-hidden-flags') && isJQLFiltersApplied) return (0, $kVLXA.Observable).merge($cfd698aeb870dd66$var$addJQLFiltersRequest(store, quickFilterIds, customFilterIds), (0, $kVLXA.Observable).of(setUpdatedFilter));
                            return (0, $kVLXA.Observable).of(setUpdatedFilter);
                        }
                        if (!(0, (0, parcelRequire("4R6GH")).fg)('jsw-roadmap-state-change-based-issue-hidden-flags') && isJQLFiltersApplied) return $cfd698aeb870dd66$var$addJQLFiltersRequest(store, quickFilterIds, customFilterIds);
                        break;
                    }
                default:
                    break;
            }
            return (0, $kVLXA.Observable).empty();
        });
});
parcelRegister("FTaAj", function(module, exports) {
    $parcel$export(module.exports, "ChangeEventTypes", ()=>$0a7f3a2a8450d0c8$export$8db21fc94823e1cc);
    const $0a7f3a2a8450d0c8$var$FIELD_CHANGE_REQUESTED = 'FIELD_CHANGE_REQUESTED';
    const $0a7f3a2a8450d0c8$var$FIELD_CHANGED = 'FIELD_CHANGED';
    const $0a7f3a2a8450d0c8$var$FIELD_CHANGE_FAILED = 'FIELD_CHANGE_FAILED';
    const $0a7f3a2a8450d0c8$var$ISSUE_TYPE_CHANGED = 'ISSUE_TYPE_CHANGED';
    const $0a7f3a2a8450d0c8$var$ISSUE_RELATIONSHIP_UPDATED = 'ISSUE_RELATIONSHIP_UPDATED';
    const $0a7f3a2a8450d0c8$var$ISSUE_LINKS_CREATED = 'ISSUE_LINKS_CREATED';
    const $0a7f3a2a8450d0c8$var$ISSUE_LINK_DELETED = 'ISSUE_LINK_DELETED';
    const $0a7f3a2a8450d0c8$var$CHILD_ISSUE_ADDED = 'CHILD_ISSUE_ADDED';
    const $0a7f3a2a8450d0c8$var$SUBTASK_ADDED = 'SUBTASK_ADDED';
    const $0a7f3a2a8450d0c8$var$ISSUE_CHILDREN_ORDER_CHANGED = 'ISSUE_CHILDREN_ORDER_CHANGED';
    const $0a7f3a2a8450d0c8$var$CHILD_ISSUE_FIELD_UPDATED = 'CHILD_ISSUE_FIELD_UPDATED';
    const $0a7f3a2a8450d0c8$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS = 'CREATE_CONFLUENCE_PAGE_LINK_SUCCESS';
    const $0a7f3a2a8450d0c8$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS = 'DELETE_CONFLUENCE_PAGE_LINK_SUCCESS';
    const $0a7f3a2a8450d0c8$export$8db21fc94823e1cc = {
        [$0a7f3a2a8450d0c8$var$FIELD_CHANGE_REQUESTED]: $0a7f3a2a8450d0c8$var$FIELD_CHANGE_REQUESTED,
        [$0a7f3a2a8450d0c8$var$FIELD_CHANGE_FAILED]: $0a7f3a2a8450d0c8$var$FIELD_CHANGE_FAILED,
        [$0a7f3a2a8450d0c8$var$FIELD_CHANGED]: $0a7f3a2a8450d0c8$var$FIELD_CHANGED,
        [$0a7f3a2a8450d0c8$var$ISSUE_TYPE_CHANGED]: $0a7f3a2a8450d0c8$var$ISSUE_TYPE_CHANGED,
        [$0a7f3a2a8450d0c8$var$ISSUE_RELATIONSHIP_UPDATED]: $0a7f3a2a8450d0c8$var$ISSUE_RELATIONSHIP_UPDATED,
        [$0a7f3a2a8450d0c8$var$ISSUE_LINKS_CREATED]: $0a7f3a2a8450d0c8$var$ISSUE_LINKS_CREATED,
        [$0a7f3a2a8450d0c8$var$ISSUE_LINK_DELETED]: $0a7f3a2a8450d0c8$var$ISSUE_LINK_DELETED,
        [$0a7f3a2a8450d0c8$var$CHILD_ISSUE_ADDED]: $0a7f3a2a8450d0c8$var$CHILD_ISSUE_ADDED,
        [$0a7f3a2a8450d0c8$var$SUBTASK_ADDED]: $0a7f3a2a8450d0c8$var$SUBTASK_ADDED,
        [$0a7f3a2a8450d0c8$var$ISSUE_CHILDREN_ORDER_CHANGED]: $0a7f3a2a8450d0c8$var$ISSUE_CHILDREN_ORDER_CHANGED,
        [$0a7f3a2a8450d0c8$var$CHILD_ISSUE_FIELD_UPDATED]: $0a7f3a2a8450d0c8$var$CHILD_ISSUE_FIELD_UPDATED,
        [$0a7f3a2a8450d0c8$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS]: $0a7f3a2a8450d0c8$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS,
        [$0a7f3a2a8450d0c8$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS]: $0a7f3a2a8450d0c8$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS
    };
});
parcelRegister("borsN", function(module, exports) {
    $parcel$export(module.exports, "isFieldUpdateWithoutRequestEvent", ()=>$02f1429946f2140c$export$8db3339834f8a8f5);
    $parcel$export(module.exports, "mapIssueViewFieldToRoadmapField", ()=>$02f1429946f2140c$export$9d6d2e8f94e22e8f);
    $parcel$export(module.exports, "convertIssueViewFieldValue", ()=>$02f1429946f2140c$export$962c330cdbeb1d25);
    $parcel$export(module.exports, "convertIssueViewFieldValueToConfiguration", ()=>$02f1429946f2140c$export$25cd05ae94678477);
    var $hUobS = parcelRequire("hUobS");
    var $2gnC5 = parcelRequire("2gnC5");
    var $heWHN;
    var $iHPnC;
    var $5fc53;
    var $70YnB;
    const $02f1429946f2140c$export$8db3339834f8a8f5 = (fieldId)=>{
        const fields = [
            (0, (0, parcelRequire("70YnB")).ASSIGNEE),
            (0, (0, parcelRequire("70YnB")).STATUS),
            (0, (0, parcelRequire("70YnB")).SUMMARY)
        ];
        return fieldId !== undefined && fields.includes(fieldId);
    };
    const $02f1429946f2140c$export$9d6d2e8f94e22e8f = (fieldId, startDateCustomFieldId, colorFieldId, epicLinkCustomField, sprintCustomFieldId)=>{
        if (!fieldId) return undefined;
        if (colorFieldId === fieldId) return 0, (0, parcelRequire("70YnB")).COLOR;
        switch(fieldId){
            case 0, (0, parcelRequire("5fc53")).SUMMARY_TYPE:
                return 0, (0, parcelRequire("70YnB")).SUMMARY;
            case 0, (0, parcelRequire("5fc53")).DUE_DATE_TYPE:
                return 0, (0, parcelRequire("70YnB")).DUE_DATE;
            case startDateCustomFieldId:
                return 0, (0, parcelRequire("70YnB")).START_DATE;
            case 0, (0, parcelRequire("5fc53")).STATUS_TYPE:
                return 0, (0, parcelRequire("70YnB")).STATUS;
            case 0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE:
                return 0, (0, parcelRequire("70YnB")).ASSIGNEE;
            case 0, (0, parcelRequire("5fc53")).PARENT_TYPE:
            case epicLinkCustomField:
                return 0, (0, parcelRequire("70YnB")).PARENT_ID;
            case 0, (0, parcelRequire("5fc53")).LABELS_TYPE:
                return 0, (0, parcelRequire("70YnB")).LABELS;
            case 0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE:
                return 0, (0, parcelRequire("70YnB")).VERSION_IDS;
            case 0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE:
                return 0, (0, parcelRequire("70YnB")).COMPONENT_IDS;
            case sprintCustomFieldId:
                return 0, (0, parcelRequire("70YnB")).SPRINT_IDS;
            case 0, (0, parcelRequire("5fc53")).ISSUE_TYPE:
                return 0, (0, parcelRequire("70YnB")).ISSUE_TYPE;
            default:
                return undefined;
        }
    };
    const $02f1429946f2140c$var$convertDateFieldValue = (fieldName, value)=>{
        if (value === null || value === '') return undefined;
        if (typeof value !== 'string' && !(0, ($parcel$interopDefault($hUobS)))(value)) throw new Error(`Returned field value for field "${fieldName}" is not primitive: "${typeof value}"`);
        const date = (0, ($parcel$interopDefault($2gnC5))).utc(value, (0, $a797a5154a1373bc$export$e63e1e1c17a0e8b));
        if (date.isValid()) return date.valueOf();
        throw new Error(`Invalid date "${value}" was returned for field "${fieldName}"`);
    };
    const $02f1429946f2140c$var$convertColorFieldValue = (fieldName, value)=>{
        if (value in (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR)) return (0, (0, parcelRequire("iHPnC")).toFrontendColor)(value);
        if (value in (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR)) return (0, (0, parcelRequire("iHPnC")).classicToFrontendColor)(value);
        throw new Error(`Invalid color value "${value}" for "${fieldName}" field`);
    };
    const $02f1429946f2140c$var$convertSummaryFieldValue = (value)=>{
        if (value === null) throw new Error('Invalid summary value "null", should be string instead');
        if (typeof value !== 'string' && !(0, ($parcel$interopDefault($hUobS)))(value)) throw new Error(`Returned field value for field "summary" is not primitive: "${typeof value}"`);
        return value;
    };
    const $02f1429946f2140c$var$convertStatusFieldValue = (value)=>{
        if (value === null || !value.id || value.name === null || !value.statusCategory) throw new Error('Invalid status value "null", should be valid status value instead');
        return {
            id: value.id,
            name: value.name,
            statusCategoryId: value.statusCategory.id.toString()
        };
    };
    const $02f1429946f2140c$var$convertAssigneeFieldValue = (value)=>{
        if (value === null || value.accountId === null) return undefined;
        return value.accountId;
    };
    const $02f1429946f2140c$var$convertLabelsFieldValue = (value)=>{
        if (value === null) return undefined;
        return value;
    };
    const $02f1429946f2140c$var$convertVersionsFieldValue = (value)=>{
        if (value === null) return undefined;
        return value.map((version)=>version.id.toString());
    };
    const $02f1429946f2140c$var$convertComponentsFieldValue = (value)=>{
        if (value === null) return undefined;
        return value.map((component)=>component.id.toString());
    };
    const $02f1429946f2140c$var$convertComponentsFieldValueToConfiguration = (value)=>{
        if (value === null) return undefined;
        return value.reduce((acc, curr)=>{
            const id = curr.id.toString();
            const { name: name } = curr;
            acc[`${id}`] = {
                id: id,
                name: name
            };
            return acc;
        }, {});
    };
    const $02f1429946f2140c$var$convertParentIdFieldValue = (value)=>{
        if (value === null || value.id === null) return undefined;
        return value.id;
    };
    const $02f1429946f2140c$var$convertSprintFieldValue = (value)=>{
        if (value === null) return undefined;
        return value.map((sprint)=>sprint.id.toString());
    };
    const $02f1429946f2140c$var$convertIssueTypeFieldValue = (value)=>value;
    const $02f1429946f2140c$export$962c330cdbeb1d25 = (fieldName, value)=>{
        switch(fieldName){
            case 0, (0, parcelRequire("70YnB")).COLOR:
                return {
                    value: $02f1429946f2140c$var$convertColorFieldValue(fieldName, value)
                };
            case 0, (0, parcelRequire("70YnB")).START_DATE:
            case 0, (0, parcelRequire("70YnB")).DUE_DATE:
                return {
                    value: $02f1429946f2140c$var$convertDateFieldValue(fieldName, value)
                };
            case 0, (0, parcelRequire("70YnB")).SUMMARY:
                return {
                    value: $02f1429946f2140c$var$convertSummaryFieldValue(value)
                };
            case 0, (0, parcelRequire("70YnB")).STATUS:
                return $02f1429946f2140c$var$convertStatusFieldValue(value);
            case 0, (0, parcelRequire("70YnB")).ASSIGNEE:
                return $02f1429946f2140c$var$convertAssigneeFieldValue(value);
            case 0, (0, parcelRequire("70YnB")).LABELS:
                return $02f1429946f2140c$var$convertLabelsFieldValue(value);
            case 0, (0, parcelRequire("70YnB")).PARENT_ID:
                return {
                    value: $02f1429946f2140c$var$convertParentIdFieldValue(value)
                };
            case 0, (0, parcelRequire("70YnB")).SPRINT_IDS:
                return {
                    value: $02f1429946f2140c$var$convertSprintFieldValue(value)
                };
            case 0, (0, parcelRequire("70YnB")).VERSION_IDS:
                return $02f1429946f2140c$var$convertVersionsFieldValue(value);
            case 0, (0, parcelRequire("70YnB")).COMPONENT_IDS:
                return $02f1429946f2140c$var$convertComponentsFieldValue(value);
            case 0, (0, parcelRequire("70YnB")).ISSUE_TYPE:
                return $02f1429946f2140c$var$convertIssueTypeFieldValue(value);
            default:
                throw new Error(`Unknow field name: "${fieldName}"`);
        }
    };
    const $02f1429946f2140c$export$25cd05ae94678477 = (fieldName, value)=>{
        switch(fieldName){
            case 0, (0, parcelRequire("70YnB")).COMPONENT_IDS:
                return $02f1429946f2140c$var$convertComponentsFieldValueToConfiguration(value);
            default:
                throw new Error(`Unknow field name: "${fieldName}"`);
        }
    };
});
parcelRegister("hUobS", function(module, exports) {
    var $beQoo = parcelRequire("beQoo");
    var $fC1Kz = parcelRequire("fC1Kz");
    var $d09a6e5a442af90c$var$numberTag = '[object Number]';
    function $d09a6e5a442af90c$var$isNumber(value) {
        return typeof value == 'number' || $fC1Kz(value) && $beQoo(value) == $d09a6e5a442af90c$var$numberTag;
    }
    module.exports = $d09a6e5a442af90c$var$isNumber;
});
parcelRegister("iHPnC", function(module, exports) {
    $parcel$export(module.exports, "asColor", ()=>$e626bf77f0e696c5$export$b74af6529f09947);
    $parcel$export(module.exports, "asServerColor", ()=>$e626bf77f0e696c5$export$442690a499ee9598);
    $parcel$export(module.exports, "asClassicEpicColor", ()=>$e626bf77f0e696c5$export$eb754032c0b9698c);
    $parcel$export(module.exports, "transformColorToTheme", ()=>$e626bf77f0e696c5$export$37c9bd72afe7f286);
    $parcel$export(module.exports, "getValueFromColor", ()=>$e626bf77f0e696c5$export$a00423580059ae28);
    $parcel$export(module.exports, "getColorFromValue", ()=>$e626bf77f0e696c5$export$6d14528e40cbe34b);
    $parcel$export(module.exports, "toFrontendColor", ()=>$e626bf77f0e696c5$export$574e4dbf3c01f0ad);
    $parcel$export(module.exports, "toBackendColor", ()=>$e626bf77f0e696c5$export$47af25386a01de1);
    $parcel$export(module.exports, "classicToFrontendColor", ()=>$e626bf77f0e696c5$export$8f81207f7ac5fb9a);
    $parcel$export(module.exports, "classicToBackendColor", ()=>$e626bf77f0e696c5$export$28fb68bb1de025d5);
    $parcel$export(module.exports, "getDefaultColorPalette", ()=>$e626bf77f0e696c5$export$f6e067d5c418081a);
    $parcel$export(module.exports, "getLozengeThemeByColor", ()=>$e626bf77f0e696c5$export$949dc67535a8ff2);
    $parcel$export(module.exports, "getRandomColor", ()=>$e626bf77f0e696c5$export$e4369cabd7e84cd9);
    var $ggSx2 = parcelRequire("ggSx2");
    var $heWHN;
    var $ehxiD;
    var $kFsv3;
    const $e626bf77f0e696c5$export$b74af6529f09947 = (color)=>{
        if (color == null) return (0, (0, parcelRequire("kFsv3")).Colors).PURPLE;
        if (color in (0, (0, parcelRequire("kFsv3")).Colors)) return color;
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR)[color];
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_AGILE_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_AGILE_COLOR)[color];
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR)[color];
        return (0, (0, parcelRequire("kFsv3")).Colors).PURPLE;
    };
    const $e626bf77f0e696c5$export$442690a499ee9598 = (color)=>{
        if (color == null) return (0, (0, parcelRequire("kFsv3")).ServerColors).SERVER_PURPLE;
        if (color in (0, (0, parcelRequire("kFsv3")).ServerColors)) return color;
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_SERVER_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_SERVER_COLOR)[color];
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_AGILE_COLOR) && (0, (0, parcelRequire("heWHN")).MAP_FROM_AGILE_COLOR)[color] in (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_SERVER_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_SERVER_COLOR)[(0, (0, parcelRequire("heWHN")).MAP_FROM_AGILE_COLOR)[color]];
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR) && (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR)[color] in (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_SERVER_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_SERVER_COLOR)[(0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR)[color]];
        return (0, (0, parcelRequire("kFsv3")).ServerColors).SERVER_PURPLE;
    };
    const $e626bf77f0e696c5$export$eb754032c0b9698c = (color)=>{
        if (color === null) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, (0, parcelRequire("kFsv3")).Colors).PURPLE];
        if (color in (0, (0, parcelRequire("kFsv3")).ClassicEpicColors)) return color;
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_CLASSIC_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR) && (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR)[color] in (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_CLASSIC_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR)[color]];
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_AGILE_COLOR) && (0, (0, parcelRequire("heWHN")).MAP_FROM_AGILE_COLOR)[color] in (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_CLASSIC_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, (0, parcelRequire("heWHN")).MAP_FROM_AGILE_COLOR)[color]];
        return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, (0, parcelRequire("kFsv3")).Colors).PURPLE];
    };
    const $e626bf77f0e696c5$export$1a0a4af71e00cea4 = (color)=>{
        if (color === null) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_AGILE_COLOR)[(0, (0, parcelRequire("kFsv3")).Colors).PURPLE];
        if (color in (0, (0, parcelRequire("kFsv3")).AgileColors)) return color;
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_AGILE_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_AGILE_COLOR)[color];
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR) && (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR)[color] in (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_AGILE_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_AGILE_COLOR)[(0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR)[color]];
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR) && (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR)[color] in (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_AGILE_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_AGILE_COLOR)[(0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR)[color]];
        return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_AGILE_COLOR)[(0, (0, parcelRequire("kFsv3")).Colors).PURPLE];
    };
    const $e626bf77f0e696c5$export$37c9bd72afe7f286 = (transformation, colorSchemaExtension)=>{
        const newColorSchema = {
            ...(0, (0, parcelRequire("heWHN")).BASE_COLOR_SCHEMA),
            ...colorSchemaExtension
        };
        const extendedColors = (colorSchemaExtension ? Object.keys(colorSchemaExtension) : []).concat(Object.keys((0, (0, parcelRequire("kFsv3")).Colors)));
        return extendedColors.reduce((obj, color)=>({
                ...obj,
                [color]: transformation(newColorSchema[color])
            }), {});
    };
    const $e626bf77f0e696c5$export$a00423580059ae28 = (color)=>(0, (0, parcelRequire("heWHN")).MAP_COLORS_TO_VALUE)[color] || (0, (0, parcelRequire("heWHN")).MAP_COLORS_TO_VALUE)[0, (0, parcelRequire("kFsv3")).PURPLE];
    const $e626bf77f0e696c5$export$6d14528e40cbe34b = (value)=>(0, ($parcel$interopDefault($ggSx2)))((0, (0, parcelRequire("heWHN")).MAP_COLORS_TO_VALUE))[value] || (0, (0, parcelRequire("kFsv3")).PURPLE);
    const $e626bf77f0e696c5$export$574e4dbf3c01f0ad = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR) ? (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR)[colorStr] : (0, (0, parcelRequire("kFsv3")).PURPLE);
    const $e626bf77f0e696c5$export$47af25386a01de1 = (color)=>(0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_SERVER_COLOR)[color];
    const $e626bf77f0e696c5$export$8f81207f7ac5fb9a = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR) ? (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR)[colorStr] : (0, (0, parcelRequire("kFsv3")).PURPLE);
    const $e626bf77f0e696c5$export$28fb68bb1de025d5 = (color)=>(0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
    const $e626bf77f0e696c5$var$paletteColorValues = $e626bf77f0e696c5$export$37c9bd72afe7f286((colorSchema)=>colorSchema.primary);
    const $e626bf77f0e696c5$export$f6e067d5c418081a = (formatMessage)=>[
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).purpleLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).PURPLE]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).blueLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).BLUE]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).greenLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).GREEN]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).tealLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).TEAL]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).yellowLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).YELLOW]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).orangeLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).ORANGE]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).greyLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).GREY]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).darkPurpleLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).DARK_PURPLE]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).darkBlueLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).DARK_BLUE]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).darkGreenLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).DARK_GREEN]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).darkTealLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).DARK_TEAL]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).darkYellowLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).DARK_YELLOW]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).darkOrangeLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).DARK_ORANGE]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).darkGreyLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).DARK_GREY]
            }
        ];
    const $e626bf77f0e696c5$export$9b822862d986dfdf = $e626bf77f0e696c5$export$37c9bd72afe7f286((colorSchema)=>({
            color: colorSchema.text,
            backgroundColor: colorSchema.textBackground
        }));
    const $e626bf77f0e696c5$export$949dc67535a8ff2 = (color = (0, (0, parcelRequire("heWHN")).DEFAULT_EPIC_COLOR))=>$e626bf77f0e696c5$export$9b822862d986dfdf[color] ?? $e626bf77f0e696c5$export$9b822862d986dfdf[0, (0, parcelRequire("heWHN")).DEFAULT_EPIC_COLOR];
    const $e626bf77f0e696c5$export$e4369cabd7e84cd9 = ()=>{
        const colorKeys = Object.keys((0, (0, parcelRequire("kFsv3")).Colors));
        return colorKeys[Math.floor(Math.random() * colorKeys.length)];
    };
});
parcelRegister("ehxiD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$50b7e3d933c7b9f7$export$2e2bcd8739ae039);
    var $7VHMR;
    var $50b7e3d933c7b9f7$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        purpleLabel: {
            "id": "issue-epic-color.common.purple-label",
            "defaultMessage": "purple"
        },
        blueLabel: {
            "id": "issue-epic-color.common.blue-label",
            "defaultMessage": "blue"
        },
        greenLabel: {
            "id": "issue-epic-color.common.green-label",
            "defaultMessage": "green"
        },
        tealLabel: {
            "id": "issue-epic-color.common.teal-label",
            "defaultMessage": "teal"
        },
        yellowLabel: {
            "id": "issue-epic-color.common.yellow-label",
            "defaultMessage": "yellow"
        },
        orangeLabel: {
            "id": "issue-epic-color.common.orange-label",
            "defaultMessage": "orange"
        },
        greyLabel: {
            "id": "issue-epic-color.common.grey-label",
            "defaultMessage": "grey"
        },
        darkPurpleLabel: {
            "id": "issue-epic-color.common.dark-purple-label",
            "defaultMessage": "dark purple"
        },
        darkBlueLabel: {
            "id": "issue-epic-color.common.dark-blue-label",
            "defaultMessage": "dark blue"
        },
        darkGreenLabel: {
            "id": "issue-epic-color.common.dark-green-label",
            "defaultMessage": "dark green"
        },
        darkTealLabel: {
            "id": "issue-epic-color.common.dark-teal-label",
            "defaultMessage": "dark teal"
        },
        darkYellowLabel: {
            "id": "issue-epic-color.common.dark-yellow-label",
            "defaultMessage": "dark yellow"
        },
        darkOrangeLabel: {
            "id": "issue-epic-color.common.dark-orange-label",
            "defaultMessage": "dark orange"
        },
        darkGreyLabel: {
            "id": "issue-epic-color.common.dark-grey-label",
            "defaultMessage": "dark grey"
        }
    });
});
parcelRegister("aDWLo", function(module, exports) {
    $parcel$export(module.exports, "tryGetIssueFromIssuesAndUsers", ()=>$0776b5b58d5f8e43$export$b690423e2c8b5b34);
    $parcel$export(module.exports, "issueTypesReloadRequired", ()=>$0776b5b58d5f8e43$export$31e7869d01af42fd);
    $parcel$export(module.exports, "criticalDataReload", ()=>$0776b5b58d5f8e43$export$3b1fd433cebec571);
    $parcel$export(module.exports, "reloadIssues", ()=>$0776b5b58d5f8e43$export$ac45f1f94fef700c);
    parcelRequire("fPS7b");
    parcelRequire("6hSeW");
    parcelRequire("fp4O3");
    parcelRequire("d0pqD");
    var $aB8eX = parcelRequire("aB8eX");
    var $kVLXA = parcelRequire("kVLXA");
    var $fjcgS;
    var $cmgcJ;
    var $5Umu2;
    var $jAJAx;
    var $9fPrG;
    var $4gYYI;
    var $1VLi2;
    var $8CYyu;
    const $0776b5b58d5f8e43$export$b690423e2c8b5b34 = (issuesAndUsers, issueId)=>issuesAndUsers.issues.hash[issueId];
    const $0776b5b58d5f8e43$export$31e7869d01af42fd = (issuesAndUsers, currentIssueTypes)=>Object.entries(issuesAndUsers.issues.hash).some(([, issue])=>currentIssueTypes[issue.issueTypeId] === undefined);
    const $0776b5b58d5f8e43$export$3b1fd433cebec571 = (store)=>{
        (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>{
            const analyticsClient = client.getInstance();
            if (!analyticsClient) return;
            analyticsClient.sendOperationalEvent({
                action: 'fetch',
                actionSubject: 'relay operation',
                attributes: {
                    key: 'jira.frontend.fe.software.roadmap.critical-data.reload',
                    reason: 'issue-types'
                },
                source: 'relayOperation'
            });
        });
        return (0, (0, parcelRequire("cmgcJ")).getCriticalDataObservable)((0, (0, parcelRequire("9fPrG")).getSourceARI)(store.getState()), undefined, undefined).map((criticalData)=>(0, $aB8eX.batchActions)([
                (0, (0, parcelRequire("jAJAx")).updateCriticalData)(criticalData)
            ]));
    };
    const $0776b5b58d5f8e43$export$ac45f1f94fef700c = (store, issueIds)=>{
        if (issueIds.length === 0) return (0, $kVLXA.Observable).empty();
        return (0, (0, parcelRequire("5Umu2")).getItems)((0, (0, parcelRequire("9fPrG")).getSourceARI)(store.getState()), issueIds).flatMap((issues)=>{
            const issueTypes = (0, (0, parcelRequire("4gYYI")).getFullIssueTypeHash)(store.getState());
            if ($0776b5b58d5f8e43$export$31e7869d01af42fd(issues, issueTypes)) return $0776b5b58d5f8e43$export$3b1fd433cebec571(store);
            const issueIdsForRemoval = issueIds.filter((issueId)=>!$0776b5b58d5f8e43$export$b690423e2c8b5b34(issues, issueId));
            const hasDefinedIssues = issueIds.length !== issueIdsForRemoval.length;
            return hasDefinedIssues ? (0, $kVLXA.Observable).of((0, (0, parcelRequire("8CYyu")).updateIssuesAndUsers)(store, issues, issueIdsForRemoval)) : (0, $kVLXA.Observable).of((0, (0, parcelRequire("1VLi2")).removeIssues)(issueIdsForRemoval));
        });
    };
});
parcelRegister("8CYyu", function(module, exports) {
    $parcel$export(module.exports, "updateIssuesAndUsers", ()=>$65b750a87b1ab375$export$ae9eb5a0ed39309b);
    $parcel$export(module.exports, "createTransitionIssueWithUpdatedItems", ()=>$65b750a87b1ab375$export$69c12c168f550414);
    var $aB8eX = parcelRequire("aB8eX");
    var $k8IPx = parcelRequire("k8IPx");
    var $lbWm4 = parcelRequire("lbWm4");
    var $fr1K2 = parcelRequire("fr1K2");
    var $l8crC = parcelRequire("l8crC");
    var $70YnB;
    var $4gYYI;
    var $1VLi2;
    var $dCEtc;
    const $65b750a87b1ab375$var$isInvalid = (issue, issueTypes)=>issueTypes[issue.issueTypeId] === undefined;
    const $65b750a87b1ab375$export$ae9eb5a0ed39309b = (store, issues, invalidIssueIds = [])=>{
        const issueTypeHash = (0, (0, parcelRequire("4gYYI")).getFullIssueTypeHash)(store.getState());
        (0, ($parcel$interopDefault($lbWm4)))(issues.issues.hash, (issue, issueId)=>{
            if ($65b750a87b1ab375$var$isInvalid(issue, issueTypeHash)) invalidIssueIds.push(issueId);
        });
        const validIssues = {
            sequence: (0, ($parcel$interopDefault($k8IPx)))(issues.issues.sequence, invalidIssueIds),
            hash: (0, ($parcel$interopDefault($fr1K2)))(issues.issues.hash, invalidIssueIds)
        };
        const actions = [
            (0, (0, parcelRequire("dCEtc")).addUsers)(issues.users)
        ];
        if ((0, ($parcel$interopDefault($l8crC)))(validIssues.hash) > 0) actions.push((0, (0, parcelRequire("1VLi2")).extendIssues)(validIssues));
        if (invalidIssueIds.length > 0) actions.push((0, (0, parcelRequire("1VLi2")).removeIssues)(invalidIssueIds));
        return (0, $aB8eX.batchActions)(actions);
    };
    const $65b750a87b1ab375$export$d33eced2e1ca66ff = (oldProp, newProp, transitionId)=>{
        if ('old' in oldProp) return {
            value: newProp,
            old: oldProp.old,
            transitionId: transitionId
        };
        return {
            value: newProp,
            old: oldProp.value,
            transitionId: transitionId
        };
    };
    const $65b750a87b1ab375$export$69c12c168f550414 = (issue, updateProps, transitionId)=>{
        const transitionIssue = {
            ...issue
        };
        const updatedItems = [];
        if (updateProps.summary !== undefined) {
            updatedItems.push({
                name: 'summary'
            });
            transitionIssue.summary = $65b750a87b1ab375$export$d33eced2e1ca66ff(issue.summary, updateProps.summary, transitionId);
        }
        if ('startDate' in updateProps) {
            updatedItems.push({
                name: 'startDate'
            });
            transitionIssue.startDate = $65b750a87b1ab375$export$d33eced2e1ca66ff(issue.startDate, updateProps.startDate, transitionId);
        }
        if ('dueDate' in updateProps) {
            updatedItems.push({
                name: 'dueDate'
            });
            transitionIssue.dueDate = $65b750a87b1ab375$export$d33eced2e1ca66ff(issue.dueDate, updateProps.dueDate, transitionId);
        }
        if (updateProps.sprintId !== undefined) {
            updatedItems.push({
                name: 'sprintId'
            });
            transitionIssue.sprintIds = $65b750a87b1ab375$export$d33eced2e1ca66ff(issue.sprintIds, [
                updateProps.sprintId
            ], transitionId);
        }
        if ('clearFields' in updateProps && updateProps.clearFields && updateProps.clearFields.length > 0) {
            if (updateProps.clearFields.indexOf((0, (0, parcelRequire("70YnB")).START_DATE)) > -1) {
                updatedItems.push({
                    name: 'startDate'
                });
                transitionIssue.startDate = $65b750a87b1ab375$export$d33eced2e1ca66ff(issue.startDate, undefined, transitionId);
            }
            if (updateProps.clearFields.indexOf((0, (0, parcelRequire("70YnB")).DUE_DATE)) > -1) {
                updatedItems.push({
                    name: 'dueDate'
                });
                transitionIssue.dueDate = $65b750a87b1ab375$export$d33eced2e1ca66ff(issue.dueDate, undefined, transitionId);
            }
            if (updateProps.clearFields.indexOf((0, (0, parcelRequire("70YnB")).SPRINT_IDS)) > -1) {
                updatedItems.push({
                    name: 'sprintId'
                });
                transitionIssue.sprintIds = $65b750a87b1ab375$export$d33eced2e1ca66ff(issue.sprintIds, [], transitionId);
            }
        }
        if ('color' in updateProps) {
            updatedItems.push({
                name: 'color'
            });
            transitionIssue.color = $65b750a87b1ab375$export$d33eced2e1ca66ff(issue.color, updateProps.color, transitionId);
        }
        if ('parentId' in updateProps) {
            updatedItems.push({
                name: 'parentId'
            });
            transitionIssue.parentId = $65b750a87b1ab375$export$d33eced2e1ca66ff(issue.parentId, updateProps.parentId, transitionId);
        }
        return [
            transitionIssue,
            updatedItems
        ];
    };
});
parcelRegister("l8crC", function(module, exports) {
    var $hR3Ue = parcelRequire("hR3Ue");
    var $jtBGw = parcelRequire("jtBGw");
    var $hTJwX = parcelRequire("hTJwX");
    var $agVdz = parcelRequire("agVdz");
    var $ifYxh = parcelRequire("ifYxh");
    var $f623ff8b0231a65d$var$mapTag = '[object Map]', $f623ff8b0231a65d$var$setTag = '[object Set]';
    function $f623ff8b0231a65d$var$size(collection) {
        if (collection == null) return 0;
        if ($hTJwX(collection)) return $agVdz(collection) ? $ifYxh(collection) : collection.length;
        var tag = $jtBGw(collection);
        if (tag == $f623ff8b0231a65d$var$mapTag || tag == $f623ff8b0231a65d$var$setTag) return collection.size;
        return $hR3Ue(collection).length;
    }
    module.exports = $f623ff8b0231a65d$var$size;
});
parcelRegister("ifYxh", function(module, exports) {
    var $dkmPN = parcelRequire("dkmPN");
    var $axH2S = parcelRequire("axH2S");
    var $61ekh = parcelRequire("61ekh");
    function $d4a895dd16218f22$var$stringSize(string) {
        return $axH2S(string) ? $61ekh(string) : $dkmPN(string);
    }
    module.exports = $d4a895dd16218f22$var$stringSize;
});
parcelRegister("dkmPN", function(module, exports) {
    var $8hdQS = parcelRequire("8hdQS");
    var $9b3edb0cff432526$var$asciiSize = $8hdQS('length');
    module.exports = $9b3edb0cff432526$var$asciiSize;
});
parcelRegister("61ekh", function(module, exports) {
    var $461df2ef275f3803$var$rsAstralRange = '\\ud800-\\udfff', $461df2ef275f3803$var$rsComboMarksRange = '\\u0300-\\u036f', $461df2ef275f3803$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $461df2ef275f3803$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $461df2ef275f3803$var$rsComboRange = $461df2ef275f3803$var$rsComboMarksRange + $461df2ef275f3803$var$reComboHalfMarksRange + $461df2ef275f3803$var$rsComboSymbolsRange, $461df2ef275f3803$var$rsVarRange = '\\ufe0e\\ufe0f';
    var $461df2ef275f3803$var$rsAstral = '[' + $461df2ef275f3803$var$rsAstralRange + ']', $461df2ef275f3803$var$rsCombo = '[' + $461df2ef275f3803$var$rsComboRange + ']', $461df2ef275f3803$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $461df2ef275f3803$var$rsModifier = '(?:' + $461df2ef275f3803$var$rsCombo + '|' + $461df2ef275f3803$var$rsFitz + ')', $461df2ef275f3803$var$rsNonAstral = '[^' + $461df2ef275f3803$var$rsAstralRange + ']', $461df2ef275f3803$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $461df2ef275f3803$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $461df2ef275f3803$var$rsZWJ = '\\u200d';
    var $461df2ef275f3803$var$reOptMod = $461df2ef275f3803$var$rsModifier + '?', $461df2ef275f3803$var$rsOptVar = '[' + $461df2ef275f3803$var$rsVarRange + ']?', $461df2ef275f3803$var$rsOptJoin = '(?:' + $461df2ef275f3803$var$rsZWJ + '(?:' + [
        $461df2ef275f3803$var$rsNonAstral,
        $461df2ef275f3803$var$rsRegional,
        $461df2ef275f3803$var$rsSurrPair
    ].join('|') + ')' + $461df2ef275f3803$var$rsOptVar + $461df2ef275f3803$var$reOptMod + ')*', $461df2ef275f3803$var$rsSeq = $461df2ef275f3803$var$rsOptVar + $461df2ef275f3803$var$reOptMod + $461df2ef275f3803$var$rsOptJoin, $461df2ef275f3803$var$rsSymbol = '(?:' + [
        $461df2ef275f3803$var$rsNonAstral + $461df2ef275f3803$var$rsCombo + '?',
        $461df2ef275f3803$var$rsCombo,
        $461df2ef275f3803$var$rsRegional,
        $461df2ef275f3803$var$rsSurrPair,
        $461df2ef275f3803$var$rsAstral
    ].join('|') + ')';
    var $461df2ef275f3803$var$reUnicode = RegExp($461df2ef275f3803$var$rsFitz + '(?=' + $461df2ef275f3803$var$rsFitz + ')|' + $461df2ef275f3803$var$rsSymbol + $461df2ef275f3803$var$rsSeq, 'g');
    function $461df2ef275f3803$var$unicodeSize(string) {
        var result = $461df2ef275f3803$var$reUnicode.lastIndex = 0;
        while($461df2ef275f3803$var$reUnicode.test(string))++result;
        return result;
    }
    module.exports = $461df2ef275f3803$var$unicodeSize;
});
parcelRegister("dbmvg", function(module, exports) {
    $parcel$export(module.exports, "createSetUpdatedFilter", ()=>$744ab098e5e7d7a0$export$21444d00749e7c62);
    $parcel$export(module.exports, "createSetUpdatedConfiguration", ()=>$744ab098e5e7d7a0$export$f0f24bd9eeb55cf7);
    var $183uB = parcelRequire("183uB");
    var $4wVpT = parcelRequire("4wVpT");
    var $kGsr8 = parcelRequire("kGsr8");
    var $70YnB;
    var $borsN;
    var $9fPrG;
    var $50Z4W;
    var $4gYYI;
    var $hFyhA;
    var $hhYQB;
    var $9QFr0;
    const $744ab098e5e7d7a0$var$getValidFilter = (filteredOptions, issueOptions, fieldValue, issueId, fieldName)=>{
        const issueOptionsHash = {
            ...issueOptions
        };
        issueOptionsHash[issueId] = (0, (0, parcelRequire("borsN")).convertIssueViewFieldValue)(fieldName, fieldValue);
        const validOptions = (0, ($parcel$interopDefault($kGsr8)))((0, ($parcel$interopDefault($183uB)))(Object.keys(issueOptionsHash).map((key)=>issueOptionsHash[key])));
        const intersectingOptions = (0, ($parcel$interopDefault($4wVpT)))(filteredOptions, validOptions);
        if (intersectingOptions.length !== filteredOptions.length) return intersectingOptions;
        return undefined;
    };
    const $744ab098e5e7d7a0$export$21444d00749e7c62 = (state, issueId, fieldValue, fieldName)=>{
        if (fieldName === (0, (0, parcelRequire("70YnB")).LABELS)) {
            const filteredLabels = (0, (0, parcelRequire("hhYQB")).getFilteredLabels)(state);
            const issueLabels = (0, (0, parcelRequire("hFyhA")).getIssueLabelsHash)(state);
            const newValue = fieldValue;
            const validFilter = $744ab098e5e7d7a0$var$getValidFilter(filteredLabels, issueLabels, newValue, issueId, fieldName);
            if (validFilter) return (0, (0, parcelRequire("9QFr0")).setLabelFilter)(validFilter);
        }
        if (fieldName === (0, (0, parcelRequire("70YnB")).VERSION_IDS)) {
            const filteredVersions = (0, (0, parcelRequire("hhYQB")).getFilteredVersions)(state);
            const issueVersions = (0, (0, parcelRequire("hFyhA")).getIssueVersionIdsHash)(state);
            const newValue = fieldValue;
            const validFilter = $744ab098e5e7d7a0$var$getValidFilter(filteredVersions, issueVersions, newValue, issueId, fieldName);
            if (validFilter) return (0, (0, parcelRequire("9QFr0")).setVersionFilter)(validFilter);
        }
        if (fieldName === (0, (0, parcelRequire("70YnB")).COMPONENT_IDS)) {
            const filteredComponents = (0, (0, parcelRequire("hhYQB")).getFilteredComponents)(state);
            const issueComponents = (0, (0, parcelRequire("hFyhA")).getIssueComponentIdsHash)(state);
            const newValue = fieldValue;
            const validFilter = $744ab098e5e7d7a0$var$getValidFilter(filteredComponents, issueComponents, newValue, issueId, fieldName);
            if (validFilter) return (0, (0, parcelRequire("9QFr0")).setComponentFilter)(validFilter);
        }
        if (fieldName === (0, (0, parcelRequire("70YnB")).ASSIGNEE)) {
            const filteredAssignees = (0, (0, parcelRequire("hhYQB")).getFilteredAssignees)(state);
            const issueAssignees = (0, (0, parcelRequire("hFyhA")).getIssueAssigneeHash)(state);
            const newValue = fieldValue;
            const loggedInAccountId = (0, (0, parcelRequire("9fPrG")).getLoggedInAccountId)(state);
            const issueAssigneeWithLoggedInUser = {
                ...issueAssignees,
                '-1': loggedInAccountId
            };
            const validFilter = $744ab098e5e7d7a0$var$getValidFilter(filteredAssignees.filter((filteredOption)=>filteredOption !== (0, $15a528573ccd89ae$export$12e572fd459c10dc)), issueAssigneeWithLoggedInUser, newValue, issueId, fieldName);
            const unassignedFilter = filteredAssignees.includes((0, $15a528573ccd89ae$export$12e572fd459c10dc)) ? [
                (0, $15a528573ccd89ae$export$12e572fd459c10dc)
            ] : [];
            if (validFilter && !(filteredAssignees.length === 1 && unassignedFilter.length)) return (0, (0, parcelRequire("9QFr0")).setAssigneeFilter)([
                ...validFilter,
                ...unassignedFilter
            ]);
        }
        if (fieldName === (0, (0, parcelRequire("70YnB")).ISSUE_TYPE)) {
            const filteredIssueTypes = (0, (0, parcelRequire("hhYQB")).getFilteredIssueTypes)(state);
            const issueIssueTypes = (0, (0, parcelRequire("hFyhA")).getIssueTypeIdHash)(state);
            const issueTypes = (0, (0, parcelRequire("4gYYI")).getFullIssueTypeHash)(state);
            let issueTypeId;
            Object.keys(issueTypes).forEach((id)=>{
                if (issueTypes[id].name === fieldValue) issueTypeId = id;
            });
            if (issueTypeId) {
                const validFilter = $744ab098e5e7d7a0$var$getValidFilter(filteredIssueTypes, issueIssueTypes, issueTypeId, issueId, fieldName);
                if (validFilter) return (0, (0, parcelRequire("9QFr0")).setIssueTypeFilter)(validFilter);
            }
        }
        return undefined;
    };
    const $744ab098e5e7d7a0$export$f0f24bd9eeb55cf7 = (state, fieldValue, fieldName)=>{
        if (fieldName === (0, (0, parcelRequire("70YnB")).COMPONENT_IDS)) {
            const projectId = (0, (0, parcelRequire("4gYYI")).getProjectId)(state);
            const existingComponents = (0, (0, parcelRequire("4gYYI")).getFullComponentHash)(state);
            const issueComponents = (0, (0, parcelRequire("borsN")).convertIssueViewFieldValueToConfiguration)(fieldName, fieldValue);
            if (issueComponents === undefined) return undefined;
            const hasNewComponents = Object.keys(issueComponents).some((key)=>!(key in existingComponents));
            if (hasNewComponents) {
                const components = Object.assign(existingComponents, issueComponents);
                return (0, (0, parcelRequire("50Z4W")).setComponents)({
                    projectId: projectId,
                    components: components
                });
            }
        }
        return undefined;
    };
});
parcelRegister("l5RsA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7b1364ccfc792f53$export$2e2bcd8739ae039);
    parcelRequire("zjDln");
    parcelRequire("6hSeW");
    parcelRequire("c66Ur");
    parcelRequire("d0pqD");
    parcelRequire("fPS7b");
    var $kVLXA = parcelRequire("kVLXA");
    var $8zOmE;
    var $lOVLt;
    var $9fPrG;
    var $4gYYI;
    var $1VLi2;
    var $hFyhA;
    var $hb2iR;
    var $bFYz9;
    var $hEJMC;
    var $5NyaP;
    const $7b1364ccfc792f53$export$fbc8bcd33b574fbc = (unsafeIssueId, unsafeRankRequest, analyticsMetadata, sourceARI)=>unsafeIssueId.flatMap((issueId)=>unsafeRankRequest.mergeMap((request)=>{
                let aggRank;
                if ('rankBeforeId' in request) aggRank = {
                    id: request.rankBeforeId,
                    position: 'BEFORE'
                };
                else if ('rankAfterId' in request) aggRank = {
                    id: request.rankAfterId,
                    position: 'AFTER'
                };
                return (0, (0, parcelRequire("lOVLt")).updateItemGraphqlOnServer)({
                    sourceARI: sourceARI,
                    input: {
                        itemId: issueId,
                        projectId: analyticsMetadata.projectId,
                        rank: aggRank
                    }
                }).map((data)=>{
                    const updateRoadmapItemData = data?.roadmaps?.updateRoadmapItem;
                    const errors = updateRoadmapItemData?.errors;
                    const success = updateRoadmapItemData?.success;
                    if (success === false && errors?.length) (0, (0, parcelRequire("bFYz9")).onHandleAggErrors)(!!updateRoadmapItemData, errors);
                    const clonedEvent = analyticsMetadata.event.clone();
                    if (clonedEvent) {
                        const attributes = {
                            ...analyticsMetadata.attributes,
                            projectType: 'software',
                            updatedItems: [
                                {
                                    name: 'rank'
                                }
                            ]
                        };
                        (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(clonedEvent, 'issue updated', attributes);
                    }
                    return undefined;
                });
            }));
    var $7b1364ccfc792f53$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, (0, parcelRequire("1VLi2")).RANK_ISSUE)).mergeMap((action)=>{
            const state = store.getState();
            const sourceARI = (0, (0, parcelRequire("9fPrG")).getSourceARI)(state);
            const { issueId: issueId, rankRequest: rankRequest } = action.payload;
            const safeId = (0, (0, parcelRequire("hFyhA")).getSafeId)(state, issueId);
            const safeRankRequest = (0, (0, parcelRequire("hEJMC")).getSafeRankRequest)(state, rankRequest);
            const projectId = (0, (0, parcelRequire("4gYYI")).getProjectId)(state);
            const issueTypeId = (0, (0, parcelRequire("hFyhA")).getIssueTypeIdForIssueId)(state, issueId);
            const level = (0, (0, parcelRequire("4gYYI")).getEpicIssueTypeIds)(state).includes(issueTypeId) ? 1 : 0;
            const parentId = (0, (0, parcelRequire("hFyhA")).getIssueParentIdHash)(state)[issueId];
            const parentIssueKey = parentId ? (0, (0, parcelRequire("hFyhA")).getIssueKeyById)(state, parentId) : undefined;
            return $7b1364ccfc792f53$export$fbc8bcd33b574fbc(safeId, safeRankRequest, {
                event: action.meta.analyticsEvent,
                projectId: projectId,
                attributes: {
                    issueTypeId: issueTypeId,
                    level: level
                }
            }, sourceARI).flatMap(()=>{
                (0, (0, parcelRequire("5NyaP")).default)(state, parentIssueKey);
                return (0, $kVLXA.Observable).empty();
            }).catch(()=>(0, $kVLXA.Observable).from([
                    (0, (0, parcelRequire("hb2iR")).aggError)()
                ]));
        });
});
parcelRegister("lOVLt", function(module, exports) {
    $parcel$export(module.exports, "updateItemGraphqlOnServer", ()=>$30ac668b5f18037c$export$7fbe6f22690ea34c);
    var $8zftP;
    var $lQmZK;
    var $8C5lr;
    const $30ac668b5f18037c$var$mutationName = 'updateRoadmapItem';
    const $30ac668b5f18037c$var$concurrentMetricDefinition = (0, (0, parcelRequire("8C5lr")).mutationMetrics)[0, $8038b72ffd5aa8d4$export$e04dc5133fcac555];
    const $30ac668b5f18037c$var$analyticKey = 'jira.frontend.fe.software.roadmap.issue-updated';
    const $30ac668b5f18037c$export$7fbe6f22690ea34c = ({ sourceARI: sourceARI, input: input })=>{
        return (0, (0, parcelRequire("lQmZK")).runMutation)($30ac668b5f18037c$var$mutationName, (0, (0, parcelRequire("8zftP")).default), {
            sourceARI: sourceARI,
            input: input
        }, $30ac668b5f18037c$var$analyticKey, $30ac668b5f18037c$var$concurrentMetricDefinition);
    };
});
parcelRegister("8zftP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$897003fef973d463$export$2e2bcd8739ae039);
    const $897003fef973d463$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "sourceARI"
        }, v2 = [
            {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
            },
            {
                "kind": "Variable",
                "name": "sourceARI",
                "variableName": "sourceARI"
            }
        ], v3 = {
            "kind": "ScalarField",
            "name": "success"
        }, v4 = {
            "kind": "ScalarField",
            "name": "message"
        }, v5 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "statusCode"
                },
                {
                    "kind": "ScalarField",
                    "name": "errorType"
                }
            ],
            "type": "RoadmapMutationErrorExtension"
        };
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1
                ],
                "kind": "Fragment",
                "name": "updateRoadmapItemMutation",
                "selections": [
                    {
                        "concreteType": "RoadmapsMutation",
                        "kind": "LinkedField",
                        "name": "roadmaps",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2,
                                "concreteType": "RoadmapUpdateItemPayload",
                                "kind": "LinkedField",
                                "name": "updateRoadmapItem",
                                "plural": false,
                                "selections": [
                                    v3,
                                    {
                                        "concreteType": "MutationError",
                                        "kind": "LinkedField",
                                        "name": "errors",
                                        "plural": true,
                                        "selections": [
                                            v4,
                                            {
                                                "kind": "LinkedField",
                                                "name": "extensions",
                                                "plural": false,
                                                "selections": [
                                                    v5
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "Mutation"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v1,
                    v0
                ],
                "kind": "Operation",
                "name": "updateRoadmapItemMutation",
                "selections": [
                    {
                        "concreteType": "RoadmapsMutation",
                        "kind": "LinkedField",
                        "name": "roadmaps",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2,
                                "concreteType": "RoadmapUpdateItemPayload",
                                "kind": "LinkedField",
                                "name": "updateRoadmapItem",
                                "plural": false,
                                "selections": [
                                    v3,
                                    {
                                        "concreteType": "MutationError",
                                        "kind": "LinkedField",
                                        "name": "errors",
                                        "plural": true,
                                        "selections": [
                                            v4,
                                            {
                                                "kind": "LinkedField",
                                                "name": "extensions",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "__typename"
                                                    },
                                                    v5,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "id"
                                                            }
                                                        ],
                                                        "type": "BulkMutationErrorExtension"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "ac083b05f962f8d48e2193ea1422badaa7b089c2b0762e4e158e5e26b3d9238d",
                "metadata": {},
                "name": "updateRoadmapItemMutation",
                "operationKind": "mutation",
                "text": null
            }
        };
    }();
    $897003fef973d463$var$node.hash = "7ffc6f5477ee6a7f1c9eef09097f8de8";
    var $897003fef973d463$export$2e2bcd8739ae039 = $897003fef973d463$var$node;
});
parcelRegister("fvAKx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f5b9a117054fec5b$export$2e2bcd8739ae039);
    var $e1AU2 = parcelRequire("e1AU2");
    var $e5wyW;
    var $4R6GH;
    var $jUwRv;
    var $lrs3x;
    const $f5b9a117054fec5b$var$realTimeEpicsNew = ()=>(0, $e1AU2.combineEpics)((0, (0, parcelRequire("jUwRv")).default), (0, (0, parcelRequire("lrs3x")).default));
    const $f5b9a117054fec5b$var$realTimeEpicsOld = ()=>(0, $e1AU2.combineEpics)((0, (0, parcelRequire("jUwRv")).default));
    var $f5b9a117054fec5b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("e5wyW")).functionWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('jsw-roadmap-state-change-based-issue-hidden-flags'), $f5b9a117054fec5b$var$realTimeEpicsNew(), $f5b9a117054fec5b$var$realTimeEpicsOld());
});
parcelRegister("jUwRv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$26d836b5b1dceb8d$export$2e2bcd8739ae039);
    parcelRequire("jFVZ1");
    parcelRequire("fp4O3");
    parcelRequire("6hSeW");
    parcelRequire("2JdQp");
    parcelRequire("1oQta");
    parcelRequire("64ZAE");
    parcelRequire("76ueo");
    parcelRequire("fPS7b");
    var $hqTkp = parcelRequire("hqTkp");
    var $kVLXA = parcelRequire("kVLXA");
    var $fjcgS;
    var $1VLi2;
    var $hFyhA;
    var $bDdHs;
    var $3unH6;
    var $4LbSm;
    var $kt4TW;
    var $ijCAv;
    var $7w4cp;
    var $1ZRbT;
    const $26d836b5b1dceb8d$var$sendAnalyticEvent = (batchEventCount)=>{
        (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>{
            const analyticsClient = client.getInstance();
            if (!analyticsClient) return;
            analyticsClient.sendTrackEvent({
                action: 'update',
                actionSubject: 'realtime',
                attributes: {
                    batchEventCount: batchEventCount
                },
                source: 'roadmapRealtime'
            });
        });
    };
    var $26d836b5b1dceb8d$export$2e2bcd8739ae039 = (action$, store)=>{
        let bufferCounter = 0;
        return action$.ofType((0, (0, parcelRequire("3unH6")).REALTIME_DISPATCH_EVENT)).filter(({ payload: { type: type, payload: payload } })=>{
            if (!(0, (0, parcelRequire("kt4TW")).isIssueEvent)(type, payload)) return false;
            const state = store.getState();
            const { atlassianId: atlassianId, issueId: issueId } = payload;
            if ((0, (0, parcelRequire("kt4TW")).isCurrentUser)(state, atlassianId)) return false;
            return (0, (0, parcelRequire("hFyhA")).isIssueExists)(state, String(issueId)) || type === (0, $09d938f04e8899c4$export$b22a14d5dac59664);
        }).do(()=>{
            bufferCounter += 1;
        }).bufferWhen(()=>(0, $kVLXA.Observable).interval((0, (0, parcelRequire("1ZRbT")).getRealtimeBufferDuration)()).filter(()=>bufferCounter >= (0, (0, parcelRequire("1ZRbT")).getMaxBufferSize)() || (0, (0, parcelRequire("1ZRbT")).isBrowserTabVisible)())).mergeMap((actions)=>{
            bufferCounter = 0;
            if (actions.length === 0) return (0, $kVLXA.Observable).empty();
            const subtaskParentHash = (0, (0, parcelRequire("4LbSm")).getSubtaskParentHash)(store.getState());
            const issueIdsToReload = [];
            const issueIdsToRemove = [];
            const subtaskParentIdsToReload = [];
            const subtaskIissueIdsToRemove = [];
            actions.forEach((action)=>{
                if (action) {
                    const { payload: { payload: payload, type: type } } = action;
                    if (!(0, (0, parcelRequire("kt4TW")).isIssueEvent)(type, payload)) return;
                    const { issueId: issueId } = payload;
                    if (type === (0, $09d938f04e8899c4$export$b22a14d5dac59664) || type === (0, $09d938f04e8899c4$export$d9bc8850eeef9f60) || type === (0, $09d938f04e8899c4$export$b22142e61b3fdbee)) {
                        if (subtaskParentHash[issueId]) subtaskParentIdsToReload.push(subtaskParentHash[issueId]);
                        else issueIdsToReload.push(String(issueId));
                    } else if (type === (0, $09d938f04e8899c4$export$25fa37e5059c5a99)) {
                        if (subtaskParentHash[issueId]) subtaskIissueIdsToRemove.push({
                            id: `${issueId}`,
                            parentId: subtaskParentHash[issueId]
                        });
                        else issueIdsToRemove.push(String(issueId));
                    }
                }
            });
            const observablesToZip = [];
            if (issueIdsToRemove.length > 0) observablesToZip.push((0, $kVLXA.Observable).of((0, (0, parcelRequire("1VLi2")).removeIssues)(issueIdsToRemove)));
            if (subtaskIissueIdsToRemove.length > 0) observablesToZip.push((0, $kVLXA.Observable).of((0, (0, parcelRequire("bDdHs")).removeSubtasks)(subtaskIissueIdsToRemove)));
            const remainingIssuesIdsToReload = (0, ($parcel$interopDefault($hqTkp)))(issueIdsToReload, ...issueIdsToRemove);
            if (remainingIssuesIdsToReload.length > 0) {
                observablesToZip.push((0, (0, parcelRequire("7w4cp")).reloadIssuesWithSequence)(store, remainingIssuesIdsToReload));
                $26d836b5b1dceb8d$var$sendAnalyticEvent(remainingIssuesIdsToReload.length);
            }
            const remainingSubtaskParentToReload = (0, ($parcel$interopDefault($hqTkp)))(subtaskParentIdsToReload, ...subtaskIissueIdsToRemove.map(({ parentId: parentId })=>parentId));
            if (remainingSubtaskParentToReload.length > 0) observablesToZip.push((0, (0, parcelRequire("ijCAv")).reloadSubtaskProgress)(store, remainingSubtaskParentToReload));
            if (observablesToZip.length > 0) return (0, $kVLXA.Observable).concat(...observablesToZip);
            return (0, $kVLXA.Observable).empty();
        });
    };
});
const $09d938f04e8899c4$export$86d416e8d15777d = 'avi:jira:assigned:issue';
const $09d938f04e8899c4$export$b22a14d5dac59664 = 'avi:jira:created:issue';
const $09d938f04e8899c4$export$25fa37e5059c5a99 = 'avi:jira:deleted:issue';
const $09d938f04e8899c4$export$d9bc8850eeef9f60 = 'avi:jira:transitioned:issue';
const $09d938f04e8899c4$export$b22142e61b3fdbee = 'avi:jira:updated:issue';
const $09d938f04e8899c4$export$773466d9acc404c0 = 'avi:jira:commented:issue';
const $09d938f04e8899c4$export$6b7e46ea0442b66c = 'avi:jira:updated:issue_parent_association';
const $09d938f04e8899c4$export$6024bd0c20931af3 = 'avi:jira-software:update:board-scope-issues';
parcelRegister("3unH6", function(module, exports) {
    $parcel$export(module.exports, "REALTIME_DISPATCH_EVENT", ()=>$cabc841cae9aaa60$export$b5816ca887d8baac);
    $parcel$export(module.exports, "dispatchRealtimeEvent", ()=>$cabc841cae9aaa60$export$e0f58b7bfd5c1657);
    const $cabc841cae9aaa60$export$b5816ca887d8baac = 'state.realtime.REALTIME_DISPATCH_EVENT';
    const $cabc841cae9aaa60$export$e0f58b7bfd5c1657 = (event)=>({
            type: $cabc841cae9aaa60$export$b5816ca887d8baac,
            payload: event
        });
});
parcelRegister("kt4TW", function(module, exports) {
    $parcel$export(module.exports, "isCurrentUser", ()=>$e826eb99cc50b159$export$863470530413e3e7);
    $parcel$export(module.exports, "isIssueEvent", ()=>$e826eb99cc50b159$export$734ba008b9d9e61c);
    var $9fPrG;
    const $e826eb99cc50b159$export$863470530413e3e7 = (state, accountId)=>(0, (0, parcelRequire("9fPrG")).getLoggedInAccountId)(state) === accountId;
    const $e826eb99cc50b159$var$issueEventTypes = [
        (0, $09d938f04e8899c4$export$b22a14d5dac59664),
        (0, $09d938f04e8899c4$export$b22142e61b3fdbee),
        (0, $09d938f04e8899c4$export$d9bc8850eeef9f60),
        (0, $09d938f04e8899c4$export$25fa37e5059c5a99)
    ];
    const $e826eb99cc50b159$export$734ba008b9d9e61c = (type, payload)=>$e826eb99cc50b159$var$issueEventTypes.includes(type) && (payload === undefined || 'issueId' in payload && payload.issueId !== undefined);
});
parcelRegister("ijCAv", function(module, exports) {
    $parcel$export(module.exports, "reloadSubtaskProgress", ()=>$8c3367a58e80af5b$export$9c75d597f17b4dd1);
    parcelRequire("fp4O3");
    parcelRequire("6hSeW");
    parcelRequire("fPS7b");
    parcelRequire("93e44");
    parcelRequire("aSIuP");
    parcelRequire("c66Ur");
    var $aB8eX = parcelRequire("aB8eX");
    var $gccSB = parcelRequire("gccSB");
    var $kVLXA = parcelRequire("kVLXA");
    var $8FZ8l;
    var $9fPrG;
    var $4hao7;
    var $2udWc;
    var $bDdHs;
    const $8c3367a58e80af5b$export$9c75d597f17b4dd1 = (store, issueIds)=>{
        if (issueIds.length === 0) return (0, $kVLXA.Observable).empty();
        const state = store.getState();
        const fullStatusCategoriesHash = (0, (0, parcelRequire("2udWc")).getFullStatusCategoriesHash)(state);
        return (0, (0, parcelRequire("8FZ8l")).getSubtasksForIssues)((0, (0, parcelRequire("9fPrG")).getSourceARI)(state), issueIds).mergeMap(({ subtasks: subtasks, statusCategories: statusCategories })=>{
            const subtaskHash = {};
            const actions = [];
            issueIds.forEach((id)=>{
                subtaskHash[id] = [];
            });
            actions.push((0, (0, parcelRequire("bDdHs")).extendSubtasks)({
                ...subtaskHash,
                ...subtasks
            }));
            const newStatusCategories = {};
            Object.keys(statusCategories).forEach((statusCategoryId)=>{
                if (fullStatusCategoriesHash[statusCategoryId] === undefined) newStatusCategories[statusCategoryId] = statusCategories[statusCategoryId];
            });
            if (!(0, ($parcel$interopDefault($gccSB)))(newStatusCategories)) actions.push((0, (0, parcelRequire("4hao7")).mergeStatusCategories)(newStatusCategories));
            return (0, $kVLXA.Observable).of((0, $aB8eX.batchActions)(actions));
        }).catch(()=>(0, $kVLXA.Observable).empty());
    };
});
parcelRegister("8FZ8l", function(module, exports) {
    $parcel$export(module.exports, "getSubtasksForIssues", ()=>$c09e4c52567088f2$export$626d5c594c98bbce);
    parcelRequire("9o0uh");
    parcelRequire("d0pqD");
    var $fjcgS;
    var $VyVZZ;
    var $9rPVb;
    var $iW95S;
    var $8C5lr;
    var $lpZMC;
    const $c09e4c52567088f2$var$analyticKey = 'jira.frontend.fe.software.roadmap.get-subtasks';
    const $c09e4c52567088f2$var$concurrentMetricDefinition = (0, (0, parcelRequire("8C5lr")).queryMetrics)[0, $8038b72ffd5aa8d4$export$d959a123e6ceb778];
    const $c09e4c52567088f2$var$DEFAULT_RESPONSE = {
        statusCategories: [],
        subtasks: []
    };
    const $c09e4c52567088f2$export$626d5c594c98bbce = (sourceAri, issueIds)=>(0, (0, parcelRequire("iW95S")).runQueryWithMetadata)((0, (0, parcelRequire("VyVZZ")).default), (0, (0, parcelRequire("9rPVb")).generateGetSubtasksQueryVariables)(sourceAri, issueIds), $c09e4c52567088f2$var$analyticKey, $c09e4c52567088f2$var$concurrentMetricDefinition).map(({ data: data })=>{
            (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>{
                const analyticsClient = client.getInstance();
                if (analyticsClient) analyticsClient.sendOperationalEvent({
                    action: 'fetched',
                    actionSubject: 'roadmapSubtasks',
                    attributes: {
                        total: data?.roadmaps?.roadmapSubtasksByIds?.subtasks.length ?? 0
                    },
                    source: 'relayOperation'
                });
            });
            const response = data?.roadmaps?.roadmapSubtasksByIds ?? $c09e4c52567088f2$var$DEFAULT_RESPONSE;
            return (0, (0, parcelRequire("lpZMC")).transformSubtasksAndStatusCategoriesResponse)(response);
        });
});
parcelRegister("VyVZZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$170c6d3857069e73$export$2e2bcd8739ae039);
    const $170c6d3857069e73$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "itemIds"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "sourceAri"
        }, v2 = {
            "kind": "ScalarField",
            "name": "id"
        }, v3 = {
            "kind": "ScalarField",
            "name": "key"
        }, v4 = [
            {
                "concreteType": "RoadmapsQuery",
                "kind": "LinkedField",
                "name": "roadmaps",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "itemIds",
                                "variableName": "itemIds"
                            },
                            {
                                "kind": "Variable",
                                "name": "sourceARI",
                                "variableName": "sourceAri"
                            }
                        ],
                        "concreteType": "RoadmapSubtasksWithStatusCategories",
                        "kind": "LinkedField",
                        "name": "roadmapSubtasksByIds",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "RoadmapSubtasks",
                                "kind": "LinkedField",
                                "name": "subtasks",
                                "plural": true,
                                "selections": [
                                    v2,
                                    {
                                        "kind": "ScalarField",
                                        "name": "parentId"
                                    },
                                    v3,
                                    {
                                        "kind": "ScalarField",
                                        "name": "statusCategoryId"
                                    }
                                ]
                            },
                            {
                                "concreteType": "RoadmapStatusCategory",
                                "kind": "LinkedField",
                                "name": "statusCategories",
                                "plural": true,
                                "selections": [
                                    v2,
                                    {
                                        "kind": "ScalarField",
                                        "name": "name"
                                    },
                                    v3
                                ]
                            }
                        ]
                    }
                ]
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1
                ],
                "kind": "Fragment",
                "name": "getSubtasksQuery",
                "selections": v4,
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v1,
                    v0
                ],
                "kind": "Operation",
                "name": "getSubtasksQuery",
                "selections": v4
            },
            "params": {
                "id": "eac03d37c54edb765ed82f90ebd26f88b6be8aec5a8d90e4095bccaefef13888",
                "metadata": {},
                "name": "getSubtasksQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $170c6d3857069e73$var$node.hash = "86a1203541c65452598c6eb81a645287";
    var $170c6d3857069e73$export$2e2bcd8739ae039 = $170c6d3857069e73$var$node;
});
parcelRegister("9rPVb", function(module, exports) {
    $parcel$export(module.exports, "generateGetSubtasksQueryVariables", ()=>$b5a0e5aedc248c24$export$6d867358533d05b);
    const $b5a0e5aedc248c24$export$6d867358533d05b = (sourceAri, itemIds)=>({
            sourceAri: sourceAri,
            itemIds: itemIds
        });
});
parcelRegister("7w4cp", function(module, exports) {
    $parcel$export(module.exports, "reloadIssuesWithSequence", ()=>$9b600fca6586a6da$export$6bc188af425a1762);
    parcelRequire("fp4O3");
    parcelRequire("6hSeW");
    parcelRequire("fPS7b");
    parcelRequire("93e44");
    parcelRequire("aSIuP");
    var $4wVpT = parcelRequire("4wVpT");
    var $kVLXA = parcelRequire("kVLXA");
    var $5ulVP;
    var $5pPJr;
    var $5Umu2;
    var $9fPrG;
    var $4gYYI;
    var $1VLi2;
    var $hFyhA;
    var $fWch8;
    var $9QFr0;
    var $aDWLo;
    var $8CYyu;
    const $9b600fca6586a6da$export$6bc188af425a1762 = (store, issueIds)=>{
        if (issueIds.length === 0) return (0, $kVLXA.Observable).empty();
        const state = store.getState();
        const sourceAri = (0, (0, parcelRequire("9fPrG")).getSourceARI)(state);
        const quickFilterIds = (0, (0, parcelRequire("fWch8")).getQuickFilters)(store.getState());
        const customFilterIds = (0, (0, parcelRequire("fWch8")).getCustomFilters)(store.getState());
        const isJQLFiltersApplied = quickFilterIds.length > 0 || customFilterIds.length > 0;
        return (0, $kVLXA.Observable).zip((0, (0, parcelRequire("5Umu2")).getItems)(sourceAri, issueIds), isJQLFiltersApplied ? (0, (0, parcelRequire("5ulVP")).filterItemsByJQLFilters)((0, (0, parcelRequire("9fPrG")).getSourceARI)(state), quickFilterIds, customFilterIds) : (0, $kVLXA.Observable).of(null)).mergeMap(([issuesAndUsers, filterIssueIds])=>{
            const reloadWithSequenceObservables = [];
            if (filterIssueIds !== null) reloadWithSequenceObservables.push((0, $kVLXA.Observable).of((0, (0, parcelRequire("9QFr0")).jqlFiltersSuccess)(filterIssueIds)));
            if (issueIds.length === 0 && issuesAndUsers.issues.sequence.length === 0) return (0, $kVLXA.Observable).empty();
            const issueTypes = (0, (0, parcelRequire("4gYYI")).getFullIssueTypeHash)(store.getState());
            if ((0, (0, parcelRequire("aDWLo")).issueTypesReloadRequired)(issuesAndUsers, issueTypes)) {
                reloadWithSequenceObservables.push((0, (0, parcelRequire("aDWLo")).criticalDataReload)(store));
                return (0, $kVLXA.Observable).merge(...reloadWithSequenceObservables);
            }
            const isAnyRankNewOrDifferent = issueIds.some((issueId)=>{
                const oldRank = (0, (0, parcelRequire("hFyhA")).getIssueRank)(state, issueId);
                const newIssue = issuesAndUsers.issues.hash[issueId];
                return newIssue !== undefined && (oldRank === undefined || oldRank !== newIssue.rank);
            });
            if (isAnyRankNewOrDifferent) return (0, (0, parcelRequire("5pPJr")).getIssueIdsFromServer)(sourceAri).mergeMap((newSequence)=>{
                const oldSequence = (0, (0, parcelRequire("hFyhA")).getIssueIds)(state);
                const batched = (0, (0, parcelRequire("8CYyu")).updateIssuesAndUsers)(store, {
                    issues: {
                        hash: issuesAndUsers.issues.hash,
                        sequence: issuesAndUsers.issues.sequence
                    },
                    users: issuesAndUsers.users
                });
                batched.payload.unshift((0, (0, parcelRequire("1VLi2")).updateIssuesSequence)((0, ($parcel$interopDefault($4wVpT)))(newSequence, oldSequence.concat(issuesAndUsers.issues.sequence))));
                reloadWithSequenceObservables.push((0, $kVLXA.Observable).of(batched));
                return (0, $kVLXA.Observable).merge(...reloadWithSequenceObservables);
            });
            let issueIdsForRemoval = [];
            if (issueIds.length !== issuesAndUsers.issues.sequence.length) issueIdsForRemoval = issueIds.filter((issueId)=>!(0, (0, parcelRequire("aDWLo")).tryGetIssueFromIssuesAndUsers)(issuesAndUsers, issueId));
            reloadWithSequenceObservables.push((0, $kVLXA.Observable).of((0, (0, parcelRequire("8CYyu")).updateIssuesAndUsers)(store, issuesAndUsers, issueIdsForRemoval)));
            return (0, $kVLXA.Observable).merge(...reloadWithSequenceObservables);
        });
    };
});
parcelRegister("5pPJr", function(module, exports) {
    $parcel$export(module.exports, "getIssueIdsFromServer", ()=>$1fbb538a5eaad1bb$export$1016d311ff24ce21);
    parcelRequire("d0pqD");
    parcelRequire("9o0uh");
    var $6N5Qu;
    var $1UOCA;
    var $iW95S;
    var $8C5lr;
    const $1fbb538a5eaad1bb$var$analyticKey = 'jira.frontend.fe.software.roadmap.get-issue-ids';
    const $1fbb538a5eaad1bb$var$concurrentMetricDefinition = (0, (0, parcelRequire("8C5lr")).queryMetrics)[0, $8038b72ffd5aa8d4$export$72305db43681d1de];
    const $1fbb538a5eaad1bb$export$1016d311ff24ce21 = (sourceAri)=>(0, (0, parcelRequire("iW95S")).runQueryWithMetadata)((0, (0, parcelRequire("6N5Qu")).default), (0, (0, parcelRequire("1UOCA")).generateGetIssueIdsQueryVariables)(sourceAri), $1fbb538a5eaad1bb$var$analyticKey, $1fbb538a5eaad1bb$var$concurrentMetricDefinition).map(({ data: data })=>data.roadmaps?.roadmapForSource?.content?.items.edges.filter(Boolean).map(({ node: roadmapItem })=>roadmapItem.id) ?? []);
});
parcelRegister("6N5Qu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3f0a90fcd13f5911$export$2e2bcd8739ae039);
    const $3f0a90fcd13f5911$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "sourceAri"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "sourceARI",
                "variableName": "sourceAri"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "id"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "getIssueIdsQuery",
                "selections": [
                    {
                        "concreteType": "RoadmapsQuery",
                        "kind": "LinkedField",
                        "name": "roadmaps",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "RoadmapDetails",
                                "kind": "LinkedField",
                                "name": "roadmapForSource",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "RoadmapContent",
                                        "kind": "LinkedField",
                                        "name": "content",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "RoadmapItemConnection",
                                                "kind": "LinkedField",
                                                "name": "items",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "RoadmapItemEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "RoadmapItem",
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v2,
                                                                                "action": "THROW",
                                                                                "path": "roadmaps.roadmapForSource.content.items.edges.node.id"
                                                                            }
                                                                        ]
                                                                    },
                                                                    "action": "THROW",
                                                                    "path": "roadmaps.roadmapForSource.content.items.edges.node"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "roadmaps.roadmapForSource.content.items.edges"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "getIssueIdsQuery",
                "selections": [
                    {
                        "concreteType": "RoadmapsQuery",
                        "kind": "LinkedField",
                        "name": "roadmaps",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "RoadmapDetails",
                                "kind": "LinkedField",
                                "name": "roadmapForSource",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "RoadmapContent",
                                        "kind": "LinkedField",
                                        "name": "content",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "RoadmapItemConnection",
                                                "kind": "LinkedField",
                                                "name": "items",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "RoadmapItemEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "concreteType": "RoadmapItem",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v2
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "86d3d5d0c58fd2a26d1fd2f392bc3902793bfe94272758d1f721f1b99392b72b",
                "metadata": {},
                "name": "getIssueIdsQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $3f0a90fcd13f5911$var$node.hash = "ef97f4c0b11c66b5a686daf59be5fe4f";
    var $3f0a90fcd13f5911$export$2e2bcd8739ae039 = $3f0a90fcd13f5911$var$node;
});
parcelRegister("1UOCA", function(module, exports) {
    $parcel$export(module.exports, "generateGetIssueIdsQueryVariables", ()=>$b89e12f6ebd2e179$export$7cd8da70683a208d);
    const $b89e12f6ebd2e179$export$7cd8da70683a208d = (sourceAri)=>({
            sourceAri: sourceAri
        });
});
parcelRegister("1ZRbT", function(module, exports) {
    $parcel$export(module.exports, "getRealtimeBufferDuration", ()=>$4f2eae3b9e2312f7$export$d81b1507c0d48361);
    $parcel$export(module.exports, "getMaxBufferSize", ()=>$4f2eae3b9e2312f7$export$364161aa43e3a835);
    $parcel$export(module.exports, "isBrowserTabVisible", ()=>$4f2eae3b9e2312f7$export$ab764bf4fd8cc5f1);
    const $4f2eae3b9e2312f7$export$d81b1507c0d48361 = ()=>5000;
    const $4f2eae3b9e2312f7$export$364161aa43e3a835 = ()=>100;
    const $4f2eae3b9e2312f7$export$ab764bf4fd8cc5f1 = ()=>!document.hidden;
});
parcelRegister("lrs3x", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$55f2b73b6ae35284$export$2e2bcd8739ae039);
    var $kVLXA = parcelRequire("kVLXA");
    var $3unH6;
    var $fWch8;
    var $9QFr0;
    var $kt4TW;
    var $55f2b73b6ae35284$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, (0, parcelRequire("3unH6")).REALTIME_DISPATCH_EVENT)).filter(({ payload: { type: type, payload: payload } })=>{
            const state = store.getState();
            const { atlassianId: atlassianId } = payload;
            const quickFilterIds = (0, (0, parcelRequire("fWch8")).getQuickFilters)(state);
            const customFilterIds = (0, (0, parcelRequire("fWch8")).getCustomFilters)(state);
            const isJQLFilterApplied = quickFilterIds.length > 0 || customFilterIds.length > 0;
            return (0, (0, parcelRequire("kt4TW")).isIssueEvent)(type) && (0, (0, parcelRequire("kt4TW")).isCurrentUser)(state, atlassianId) && isJQLFilterApplied;
        }).mergeMap(()=>(0, $kVLXA.Observable).of((0, (0, parcelRequire("9QFr0")).reapplyJQLFilters)()));
});
parcelRegister("3HYXd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7700583294a27a4c$export$2e2bcd8739ae039);
    parcelRequire("6hSeW");
    parcelRequire("aSIuP");
    parcelRequire("fPS7b");
    var $kVLXA = parcelRequire("kVLXA");
    var $bkUsp;
    var $FTaAj;
    var $5Umu2;
    var $9fPrG;
    var $4gYYI;
    var $1VLi2;
    var $hFyhA;
    var $aDWLo;
    var $8CYyu;
    const $7700583294a27a4c$var$updateDependencies = (store, issueId, links)=>{
        const state = store.getState();
        const issueIdsSet = new Set();
        links.forEach((link)=>{
            if (link.direction === (0, (0, parcelRequire("bkUsp")).IssueLinkDirectionTypes).INWARD) issueIdsSet.add(issueId);
            else if (link.direction === (0, (0, parcelRequire("bkUsp")).IssueLinkDirectionTypes).OUTWARD) issueIdsSet.add(link.linkedIssueId);
        });
        return (0, $kVLXA.Observable).zip(...Array.from(issueIdsSet.values()).filter((targetIssueId)=>(0, (0, parcelRequire("hFyhA")).isIssueExists)(state, targetIssueId)).map((issueIdToFetch)=>(0, (0, parcelRequire("5Umu2")).getItems)((0, (0, parcelRequire("9fPrG")).getSourceARI)(state), [
                issueIdToFetch
            ])), (...issuesData)=>{
            if (issuesData.length) {
                const getMergedIssues = ()=>{
                    const result = {
                        issues: {
                            hash: {},
                            sequence: []
                        },
                        users: {}
                    };
                    issuesData.forEach((issuesDataItem)=>{
                        Object.assign(result.issues.hash, issuesDataItem.issues.hash);
                        Object.assign(result.users, issuesDataItem.users);
                    });
                    return result;
                };
                const mergedIssues = getMergedIssues();
                return (0, (0, parcelRequire("8CYyu")).updateIssuesAndUsers)(store, mergedIssues);
            }
            return (0, $kVLXA.Observable).empty();
        });
    };
    var $7700583294a27a4c$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, (0, parcelRequire("1VLi2")).RELOAD_ISSUE)).mergeMap((action)=>{
            const event = action.payload;
            switch(event.type){
                case (0, (0, parcelRequire("FTaAj")).ChangeEventTypes).ISSUE_TYPE_CHANGED:
                    {
                        const { issueId: issueId } = event;
                        return (0, (0, parcelRequire("aDWLo")).reloadIssues)(store, [
                            issueId
                        ]);
                    }
                case (0, (0, parcelRequire("FTaAj")).ChangeEventTypes).ISSUE_LINKS_CREATED:
                    {
                        const { issueId: issueId, meta: { links: links } } = event;
                        const state = store.getState();
                        const issueTypeId = (0, (0, parcelRequire("hFyhA")).getIssueTypeIdHash)(state)[issueId];
                        const issueTypeHash = (0, (0, parcelRequire("4gYYI")).getFullIssueTypeHash)(state);
                        if (!issueTypeHash[issueTypeId]) break;
                        return $7700583294a27a4c$var$updateDependencies(store, issueId, links);
                    }
                case (0, (0, parcelRequire("FTaAj")).ChangeEventTypes).ISSUE_LINK_DELETED:
                    {
                        const { issueId: issueId, meta: { direction: direction, linkedIssueId: linkedIssueId } } = event;
                        const state = store.getState();
                        const issueTypeIdHash = (0, (0, parcelRequire("hFyhA")).getIssueTypeIdHash)(state);
                        const issueTypeHash = (0, (0, parcelRequire("4gYYI")).getFullIssueTypeHash)(state);
                        if (!issueTypeHash[issueTypeIdHash[issueId]] && !issueTypeHash[issueTypeIdHash[linkedIssueId]]) break;
                        if (direction === (0, (0, parcelRequire("bkUsp")).IssueLinkDirectionTypes).INWARD) return (0, (0, parcelRequire("aDWLo")).reloadIssues)(store, [
                            issueId
                        ]);
                        if (direction === (0, (0, parcelRequire("bkUsp")).IssueLinkDirectionTypes).OUTWARD) return (0, (0, parcelRequire("aDWLo")).reloadIssues)(store, [
                            linkedIssueId
                        ]);
                        break;
                    }
                case (0, (0, parcelRequire("FTaAj")).ChangeEventTypes).CHILD_ISSUE_ADDED:
                    {
                        const { issueId: issueId, meta: { childIssue: { id: childIssueId } } } = event;
                        if ((0, (0, parcelRequire("hFyhA")).isIssueExists)(store.getState(), issueId)) return (0, (0, parcelRequire("aDWLo")).reloadIssues)(store, [
                            childIssueId
                        ]);
                        break;
                    }
                default:
                    break;
            }
            return (0, $kVLXA.Observable).empty();
        });
});
parcelRegister("bkUsp", function(module, exports) {
    $parcel$export(module.exports, "INWARD_LINK_DIRECTION", ()=>$1e4a31a537751af2$export$b5e2b68b0fa7f1c8);
    $parcel$export(module.exports, "OUTWARD_LINK_DIRECTION", ()=>$1e4a31a537751af2$export$5dec99d71ec794ba);
    $parcel$export(module.exports, "BOTH_LINK_DIRECTION", ()=>$1e4a31a537751af2$export$6cdcf74878b11d34);
    $parcel$export(module.exports, "IssueLinkDirectionTypes", ()=>$1e4a31a537751af2$export$4b7bcc27238c61b9);
    const $1e4a31a537751af2$export$b5e2b68b0fa7f1c8 = 'INWARD';
    const $1e4a31a537751af2$export$5dec99d71ec794ba = 'OUTWARD';
    const $1e4a31a537751af2$export$6cdcf74878b11d34 = 'BOTH';
    const $1e4a31a537751af2$export$4b7bcc27238c61b9 = {
        [$1e4a31a537751af2$export$b5e2b68b0fa7f1c8]: $1e4a31a537751af2$export$b5e2b68b0fa7f1c8,
        [$1e4a31a537751af2$export$5dec99d71ec794ba]: $1e4a31a537751af2$export$5dec99d71ec794ba,
        [$1e4a31a537751af2$export$6cdcf74878b11d34]: $1e4a31a537751af2$export$6cdcf74878b11d34
    };
});
parcelRegister("kGYAX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5e48b0f6047991fe$export$2e2bcd8739ae039);
    parcelRequire("zjDln");
    parcelRequire("jFVZ1");
    parcelRequire("6hSeW");
    parcelRequire("fp4O3");
    parcelRequire("c66Ur");
    parcelRequire("d0pqD");
    parcelRequire("fPS7b");
    var $aB8eX = parcelRequire("aB8eX");
    var $kVLXA = parcelRequire("kVLXA");
    var $7Jxgt = parcelRequire("7Jxgt");
    var $4R6GH;
    var $8zOmE;
    var $joGLY;
    var $lk6Fl;
    var $9fPrG;
    var $4gYYI;
    var $1VLi2;
    var $hFyhA;
    var $hb2iR;
    var $fWch8;
    var $9QFr0;
    var $bM42j;
    var $6AwHs;
    var $8CYyu;
    var $5NyaP;
    const $5e48b0f6047991fe$var$getPostScheduleActions = (state, scheduledIssues)=>{
        const nonBaseLevelIssues = scheduledIssues[0, (0, parcelRequire("joGLY")).PARENT_LEVEL];
        const baseLevelIssues = scheduledIssues[0, (0, parcelRequire("joGLY")).BASE_LEVEL];
        const actions = [];
        const issueChildrenHash = (0, (0, parcelRequire("hFyhA")).getIssueChildrenHash)(state);
        let activeIssueLevel = (0, (0, parcelRequire("joGLY")).PARENT_LEVEL);
        let isHiddenIssueRescheduledCalled = false;
        let hasIssueCollapsedWithScheduledChildIssue = false;
        nonBaseLevelIssues.concat(baseLevelIssues).some(({ issueId: issueId, level: level, issue: issue }, index)=>{
            if (index === 0) activeIssueLevel = level;
            const shouldExitEarly = activeIssueLevel === (0, (0, parcelRequire("joGLY")).PARENT_LEVEL) ? isHiddenIssueRescheduledCalled && level === (0, (0, parcelRequire("joGLY")).BASE_LEVEL) : isHiddenIssueRescheduledCalled;
            if (shouldExitEarly) return true;
            const { isHiddenByFilter: isHiddenByFilter, isHiddenBySetting: isHiddenBySetting } = (0, (0, parcelRequire("6AwHs")).getIsIssueHiddenByFiltersOrSettings)(state, issue, issueId);
            if (level === (0, (0, parcelRequire("joGLY")).PARENT_LEVEL) && isHiddenBySetting) actions.push((0, (0, parcelRequire("hb2iR")).issueDisappearsFromDisplayRange)({
                issueId: issueId
            }));
            else if (!isHiddenIssueRescheduledCalled) {
                if (isHiddenByFilter) {
                    actions.push((0, (0, parcelRequire("hb2iR")).issueHidden)({
                        ids: []
                    }));
                    isHiddenIssueRescheduledCalled = true;
                    return false;
                }
                if (level === (0, (0, parcelRequire("joGLY")).PARENT_LEVEL) && baseLevelIssues.length) {
                    const hasChildIssueScheduled = (issueChildrenHash[issueId] ?? []).some((childIssueId)=>baseLevelIssues.some(({ issueId: baseLevelIssueId })=>baseLevelIssueId === childIssueId));
                    const isCollapsed = !((0, (0, parcelRequire("bM42j")).getExpandedItems)(state)[issueId] ?? false);
                    hasIssueCollapsedWithScheduledChildIssue = hasChildIssueScheduled ? isCollapsed : false;
                    if (hasIssueCollapsedWithScheduledChildIssue) {
                        actions.push((0, (0, parcelRequire("hb2iR")).issueHidden)({
                            ids: []
                        }));
                        isHiddenIssueRescheduledCalled = true;
                        return false;
                    }
                }
            }
            return false;
        });
        return actions;
    };
    const $5e48b0f6047991fe$var$persistScheduleIssues = (issueIdsObservable, safeIssueScheduleFields, transitionId, { scheduledIssues: scheduledIssues, attributes: issuesAttributes, event: event }, store)=>issueIdsObservable.mergeMap(()=>{
            const state = store.getState();
            return (0, (0, parcelRequire("lk6Fl")).scheduleItems)((0, (0, parcelRequire("9fPrG")).getSourceARI)(state), safeIssueScheduleFields).map((data)=>{
                const scheduleRoadmapItemsData = data?.roadmaps?.scheduleRoadmapItems;
                const errors = scheduleRoadmapItemsData?.errors;
                const success = scheduleRoadmapItemsData?.success;
                if (success === false && errors && errors?.length) throw new Error(`ScheduleItems failed: ${errors[0]?.message || 'unknown'}, ${errors[0]?.extensions?.statusCode || 'statusCode unknown'}`);
                const clearTransitions = [];
                const clonedEvent = event.clone();
                const activeIssueAttributes = issuesAttributes[0];
                if (clonedEvent) {
                    const { issueId: issueId, ...otherAttributes } = activeIssueAttributes;
                    const numberOfSelectedIssuesShiftedTogether = (scheduledIssues[activeIssueAttributes.level] ?? []).length - 1;
                    const numberOfChildIssuesShiftedTogether = (scheduledIssues[activeIssueAttributes.level - 1] ?? []).length;
                    (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(clonedEvent, 'issue updated', issueId, {
                        ...otherAttributes,
                        projectType: 'software',
                        numberOfSelectedIssuesShiftedTogether: numberOfSelectedIssuesShiftedTogether,
                        numberOfChildIssuesShiftedTogether: numberOfChildIssuesShiftedTogether
                    });
                }
                safeIssueScheduleFields.forEach((scheduleField)=>{
                    clearTransitions.push((0, (0, parcelRequire("1VLi2")).clearTransitionState)({
                        issueId: scheduleField.issueId,
                        transitionId: transitionId
                    }, (0, (0, parcelRequire("1VLi2")).SCHEDULE_ISSUES)));
                });
                if ((0, (0, parcelRequire("4R6GH")).fg)('jsw-roadmap-state-change-based-issue-hidden-flags')) return clearTransitions;
                return [
                    ...clearTransitions,
                    ...$5e48b0f6047991fe$var$getPostScheduleActions(state, scheduledIssues)
                ];
            });
        });
    var $5e48b0f6047991fe$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, (0, parcelRequire("1VLi2")).SCHEDULE_ISSUES)).mergeMap(({ payload: { issueScheduleFields: issueScheduleFields }, meta: { hasOverdueReleaseDate: hasOverdueReleaseDate, analyticsEvent: analyticsEvent } })=>{
            const state = store.getState();
            const transitionId = (0, ($parcel$interopDefault($7Jxgt))).v4();
            const issueKeys = [];
            const ids = [];
            const projectIds = [];
            const issueTransitions = new Map();
            const safeIssueScheduleFields = [];
            const issuesAttributes = [];
            const baseLevelIssues = [];
            const nonBaseLevelIssues = [];
            const extendHash = {};
            issueScheduleFields.forEach((issueScheduleField)=>{
                const { issueId: issueId, startDate: startDate, dueDate: dueDate } = issueScheduleField;
                const issue = (0, (0, parcelRequire("hFyhA")).getIssue)(state, issueId);
                if (!issue) return;
                const projectId = (0, (0, parcelRequire("4gYYI")).getProjectId)(state);
                if (!projectIds.includes(projectId)) projectIds.push(projectId);
                const issueTypeId = (0, (0, parcelRequire("hFyhA")).getIssueTypeIdForIssueId)(state, issueId);
                const level = (0, (0, parcelRequire("4gYYI")).getEpicIssueTypeIds)(state).includes(issueTypeId) ? (0, (0, parcelRequire("joGLY")).PARENT_LEVEL) : (0, (0, parcelRequire("joGLY")).BASE_LEVEL);
                const updateProps = {};
                if (startDate !== issue.startDate.value) updateProps.startDate = startDate;
                if (dueDate !== issue.dueDate.value) updateProps.dueDate = dueDate;
                const [transitionIssue, updatedItems] = (0, (0, parcelRequire("8CYyu")).createTransitionIssueWithUpdatedItems)(issue, updateProps, transitionId);
                if (transitionIssue) {
                    extendHash[issueId] = transitionIssue;
                    const issueKey = (0, (0, parcelRequire("hFyhA")).getIssueKeyById)(state, issueId);
                    const isIssueBaseLevel = (0, (0, parcelRequire("joGLY")).isBaseLevel)(level);
                    ids.push(issueId);
                    issueKey && issueKeys.push(issueKey);
                    issueTransitions.set(issueId, transitionIssue);
                    safeIssueScheduleFields.push(issueScheduleField);
                    issuesAttributes.push({
                        issueId: issueId,
                        issueTypeId: issueTypeId,
                        level: level,
                        updatedItems: updatedItems,
                        ...isIssueBaseLevel ? undefined : {
                            hasOverdueReleaseDate: hasOverdueReleaseDate
                        }
                    });
                    (isIssueBaseLevel ? baseLevelIssues : nonBaseLevelIssues).push({
                        issueId: issueId,
                        level: level,
                        issue: transitionIssue
                    });
                }
            });
            if (!safeIssueScheduleFields.length) return (0, $kVLXA.Observable).empty();
            const transitionExtend = (0, (0, parcelRequire("hFyhA")).getSafeIds)(store.getState(), ids).mergeMap((issueIds)=>{
                const transitionExtendHash = {};
                issueIds.forEach((issueId)=>{
                    if (issueId !== undefined) {
                        const transitionIssue = issueTransitions.get(issueId);
                        if (transitionIssue) transitionExtendHash[issueId] = transitionIssue;
                    }
                });
                return (0, $kVLXA.Observable).of((0, (0, parcelRequire("1VLi2")).extendIssues)({
                    sequence: [],
                    hash: transitionExtendHash
                }));
            });
            const analyticsMetadata = {
                projectId: projectIds[0],
                scheduledIssues: {
                    [(0, (0, parcelRequire("joGLY")).BASE_LEVEL)]: baseLevelIssues,
                    [(0, (0, parcelRequire("joGLY")).PARENT_LEVEL)]: nonBaseLevelIssues
                },
                attributes: issuesAttributes,
                event: analyticsEvent
            };
            return (0, $kVLXA.Observable).concat((0, $kVLXA.Observable).of((0, (0, parcelRequire("1VLi2")).extendIssues)({
                sequence: [],
                hash: extendHash
            }, (0, (0, parcelRequire("1VLi2")).SCHEDULE_ISSUES))), transitionExtend, $5e48b0f6047991fe$var$persistScheduleIssues((0, (0, parcelRequire("hFyhA")).getSafeIds)(store.getState(), ids), safeIssueScheduleFields, transitionId, analyticsMetadata, store).map((actions)=>{
                const selectedIssueKey = (0, (0, parcelRequire("fWch8")).getSelectedIssueKey)(state);
                issueKeys.includes(selectedIssueKey) && (0, (0, parcelRequire("5NyaP")).default)(state, selectedIssueKey);
                return (0, $aB8eX.batchActions)(actions);
            }).catch(()=>(0, $kVLXA.Observable).from([
                    (0, (0, parcelRequire("hb2iR")).aggError)()
                ])), (0, (0, parcelRequire("4R6GH")).fg)('jsw-roadmap-state-change-based-issue-hidden-flags') ? (0, $kVLXA.Observable).empty() : (0, $kVLXA.Observable).of((0, (0, parcelRequire("9QFr0")).reapplyJQLFilters)()));
        });
});
parcelRegister("lk6Fl", function(module, exports) {
    $parcel$export(module.exports, "scheduleItems", ()=>$e8e4ed5cfb1eeb04$export$7b362d3efe98c60d);
    var $aIs2c;
    var $lQmZK;
    var $8C5lr;
    var $lpZMC;
    const $e8e4ed5cfb1eeb04$var$analyticKey = 'jira.frontend.fe.software.roadmap.bulk-issues-scheduled';
    const $e8e4ed5cfb1eeb04$var$scheduleItemsMetric = (0, (0, parcelRequire("8C5lr")).mutationMetrics)[0, $8038b72ffd5aa8d4$export$315e0cbd8c7bfbd4];
    const $e8e4ed5cfb1eeb04$var$mutationName = 'scheduleRoadmapItems';
    const $e8e4ed5cfb1eeb04$export$7b362d3efe98c60d = (sourceARI, issueScheduleFields)=>(0, (0, parcelRequire("lQmZK")).runMutation)($e8e4ed5cfb1eeb04$var$mutationName, (0, (0, parcelRequire("aIs2c")).default), {
            sourceARI: sourceARI,
            scheduleRequests: (0, (0, parcelRequire("lpZMC")).transformScheduleItemsRequest)(issueScheduleFields)
        }, $e8e4ed5cfb1eeb04$var$analyticKey, $e8e4ed5cfb1eeb04$var$scheduleItemsMetric);
});
parcelRegister("aIs2c", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ca236882f779fb90$export$2e2bcd8739ae039);
    const $ca236882f779fb90$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "scheduleRequests"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "sourceARI"
        }, v2 = [
            {
                "fields": [
                    {
                        "kind": "Variable",
                        "name": "scheduleRequests",
                        "variableName": "scheduleRequests"
                    }
                ],
                "kind": "ObjectValue",
                "name": "input"
            },
            {
                "kind": "Variable",
                "name": "sourceARI",
                "variableName": "sourceARI"
            }
        ], v3 = {
            "kind": "ScalarField",
            "name": "success"
        }, v4 = {
            "kind": "ScalarField",
            "name": "message"
        }, v5 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "statusCode"
                },
                {
                    "kind": "ScalarField",
                    "name": "errorType"
                }
            ],
            "type": "RoadmapMutationErrorExtension"
        };
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1
                ],
                "kind": "Fragment",
                "name": "scheduleRoadmapItemsMutation",
                "selections": [
                    {
                        "concreteType": "RoadmapsMutation",
                        "kind": "LinkedField",
                        "name": "roadmaps",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2,
                                "concreteType": "RoadmapScheduleItemsPayload",
                                "kind": "LinkedField",
                                "name": "scheduleRoadmapItems",
                                "plural": false,
                                "selections": [
                                    v3,
                                    {
                                        "concreteType": "MutationError",
                                        "kind": "LinkedField",
                                        "name": "errors",
                                        "plural": true,
                                        "selections": [
                                            v4,
                                            {
                                                "kind": "LinkedField",
                                                "name": "extensions",
                                                "plural": false,
                                                "selections": [
                                                    v5
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "Mutation"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v1,
                    v0
                ],
                "kind": "Operation",
                "name": "scheduleRoadmapItemsMutation",
                "selections": [
                    {
                        "concreteType": "RoadmapsMutation",
                        "kind": "LinkedField",
                        "name": "roadmaps",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2,
                                "concreteType": "RoadmapScheduleItemsPayload",
                                "kind": "LinkedField",
                                "name": "scheduleRoadmapItems",
                                "plural": false,
                                "selections": [
                                    v3,
                                    {
                                        "concreteType": "MutationError",
                                        "kind": "LinkedField",
                                        "name": "errors",
                                        "plural": true,
                                        "selections": [
                                            v4,
                                            {
                                                "kind": "LinkedField",
                                                "name": "extensions",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "__typename"
                                                    },
                                                    v5,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "id"
                                                            }
                                                        ],
                                                        "type": "BulkMutationErrorExtension"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "4f71597ff5dc1e918db86f2c0ed3f92c5c95a21bda21e558fe23d5b71ced2c4b",
                "metadata": {},
                "name": "scheduleRoadmapItemsMutation",
                "operationKind": "mutation",
                "text": null
            }
        };
    }();
    $ca236882f779fb90$var$node.hash = "0dd026eff03519d70944542fa22dbd32";
    var $ca236882f779fb90$export$2e2bcd8739ae039 = $ca236882f779fb90$var$node;
});
parcelRegister("ltPjz", function(module, exports) {
    $parcel$export(module.exports, "multiselect", ()=>$cd623a89d6f89567$export$afd90303e38e32b1);
    $parcel$export(module.exports, "select", ()=>$cd623a89d6f89567$export$2e6c959c16ff56b8);
    $parcel$export(module.exports, "default", ()=>$cd623a89d6f89567$export$2e2bcd8739ae039);
    parcelRequire("6hSeW");
    parcelRequire("fp4O3");
    parcelRequire("fPS7b");
    parcelRequire("jFVZ1");
    var $aB8eX = parcelRequire("aB8eX");
    var $kVLXA = parcelRequire("kVLXA");
    var $4R6GH;
    var $joGLY;
    var $hFyhA;
    var $hb2iR;
    var $2IdXh;
    var $1wSJc;
    var $gFEKp;
    var $9BcVE;
    var $lEiof;
    var $bM42j;
    var $fZLyn;
    const $cd623a89d6f89567$var$getIsInteractedItemsLimitExceeded = (state, isSelectedItemIdsBaseLevel, toBeSelectedItemIds, analyticsEvent)=>{
        const isInteractedItemsOverLimit = (0, (0, parcelRequire("1wSJc")).getIsInteractedItemsOverLimit)(state, isSelectedItemIdsBaseLevel, toBeSelectedItemIds);
        isInteractedItemsOverLimit && (0, (0, parcelRequire("fZLyn")).fireInteractedItemsLimitExceededAnalytics)(analyticsEvent);
        return isInteractedItemsOverLimit;
    };
    const $cd623a89d6f89567$var$getMultiSelectItems = (state, id, anchorId, isSelectedItemIdsBaseLevel)=>{
        if (!anchorId) return [];
        const orderedFilteredItems = isSelectedItemIdsBaseLevel ? (0, (0, parcelRequire("2IdXh")).getFilteredBaseLevelIssueIds)(state) : (0, (0, parcelRequire("2IdXh")).getFilteredNonBaseLevelIssueIds)(state);
        const clickedItemIndex = orderedFilteredItems.indexOf(id);
        const anchorIndex = orderedFilteredItems.indexOf(anchorId);
        const itemList = orderedFilteredItems.slice(Math.min(clickedItemIndex, anchorIndex), Math.max(clickedItemIndex, anchorIndex) + 1);
        return clickedItemIndex < anchorIndex ? itemList.reverse() : itemList;
    };
    const $cd623a89d6f89567$export$afd90303e38e32b1 = (action$, store)=>action$.ofType((0, (0, parcelRequire("lEiof")).SELECT_MULTIPLE_ITEMS)).mergeMap(({ payload: { analyticsEvent: analyticsEvent, itemIds: itemIds } })=>{
            const state = store.getState();
            const selectedItemLevel = itemIds.length ? (0, (0, parcelRequire("hFyhA")).getIssueLevel)(state, itemIds[0]) : undefined;
            if (selectedItemLevel === undefined) return (0, $kVLXA.Observable).of((0, (0, parcelRequire("lEiof")).setSelectedItemIds)([]));
            const isSelectedItemIdsBaseLevel = (0, (0, parcelRequire("joGLY")).isBaseLevel)(selectedItemLevel);
            const isInteractedItemsLimitExceeded = $cd623a89d6f89567$var$getIsInteractedItemsLimitExceeded(state, isSelectedItemIdsBaseLevel, itemIds, analyticsEvent);
            if (isInteractedItemsLimitExceeded) return (0, $kVLXA.Observable).of((0, (0, parcelRequire("hb2iR")).interactedItemsLimitExceeded)());
            return (0, $kVLXA.Observable).of((0, (0, parcelRequire("lEiof")).setSelectedItemIds)(itemIds));
        });
    const $cd623a89d6f89567$export$2e6c959c16ff56b8 = (action$, store)=>action$.ofType((0, (0, parcelRequire("lEiof")).ACTIVATE_ITEM)).mergeMap(({ payload: { itemId: itemId, ref: ref } })=>{
            const state = store.getState();
            const key = (0, (0, parcelRequire("hFyhA")).getIssueKeyById)(state, itemId);
            if ((0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps-timeline-bento-refocusing')) return (0, $kVLXA.Observable).concat((0, $kVLXA.Observable).of((0, (0, parcelRequire("lEiof")).setActiveItemRef)(ref)), (0, $kVLXA.Observable).of((0, (0, parcelRequire("gFEKp")).setSelectedIssue)(key)));
            return (0, $kVLXA.Observable).of((0, (0, parcelRequire("gFEKp")).setSelectedIssue)(key));
        });
    var $cd623a89d6f89567$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, (0, parcelRequire("lEiof")).SELECT_ITEMS)).mergeMap(({ payload: { id: id, level: level, withCmd: withCmd, withShift: withShift }, meta: { analyticsEvent: analyticsEvent } })=>{
            const state = store.getState();
            const key = (0, (0, parcelRequire("hFyhA")).getIssueKeyById)(state, id);
            if (!key) return (0, $kVLXA.Observable).empty();
            const isIssueDetailsShown = (0, (0, parcelRequire("9BcVE")).getPanelType)(state) === (0, $7c85843a6edcd27d$export$e90b483346a763db);
            if (!withCmd && !withShift) return (0, $kVLXA.Observable).concat((0, $kVLXA.Observable).of((0, $aB8eX.batchActions)([
                (0, (0, parcelRequire("lEiof")).setSelectionAnchors)([
                    id
                ]),
                (0, (0, parcelRequire("lEiof")).setSelectedItemIds)([
                    id
                ])
            ])), (0, $kVLXA.Observable).of((0, (0, parcelRequire("gFEKp")).setSelectedIssue)(key)));
            const parentIds = (0, (0, parcelRequire("hFyhA")).getIssueParentIdHash)(state);
            const selectedItemIds = (0, (0, parcelRequire("bM42j")).getSelectedItemIds)(state);
            const selectedItemLevel = selectedItemIds.length ? (0, (0, parcelRequire("hFyhA")).getIssueLevel)(state, selectedItemIds[0]) : level;
            const isSelectedItemIdsBaseLevel = (0, (0, parcelRequire("joGLY")).isBaseLevel)(selectedItemLevel);
            if (selectedItemIds.length && parentIds[selectedItemIds[0]] !== parentIds[id]) return (0, $kVLXA.Observable).empty();
            const selectionAnchors = (0, (0, parcelRequire("bM42j")).getSelectionAnchors)(state);
            if (withShift) {
                const actions = [];
                const [anchorId] = selectionAnchors.slice(-1);
                if (anchorId === id) return (0, $kVLXA.Observable).empty();
                const multiSelectItems = $cd623a89d6f89567$var$getMultiSelectItems(state, id, anchorId, isSelectedItemIdsBaseLevel);
                const updatedMultiSelectItems = withCmd ? selectedItemIds.filter((item)=>!multiSelectItems.includes(item)).concat(multiSelectItems) : multiSelectItems;
                const isInteractedItemsLimitExceeded = $cd623a89d6f89567$var$getIsInteractedItemsLimitExceeded(state, isSelectedItemIdsBaseLevel, updatedMultiSelectItems, analyticsEvent);
                if (isInteractedItemsLimitExceeded) return (0, $kVLXA.Observable).of((0, (0, parcelRequire("hb2iR")).interactedItemsLimitExceeded)());
                selectionAnchors.length > 1 && actions.push((0, (0, parcelRequire("lEiof")).setSelectionAnchors)([
                    anchorId
                ]));
                selectedItemIds.length ? actions.push((0, (0, parcelRequire("lEiof")).setSelectedItemIds)(updatedMultiSelectItems)) : actions.push((0, (0, parcelRequire("lEiof")).setSelectionAnchors)([
                    id
                ]), (0, (0, parcelRequire("lEiof")).setSelectedItemIds)([
                    id
                ]));
                const batchedActionsObservable = (0, $kVLXA.Observable).of(actions.length > 1 ? (0, $aB8eX.batchActions)(actions) : actions[0]);
                return isIssueDetailsShown ? (0, $kVLXA.Observable).concat(batchedActionsObservable, (0, $kVLXA.Observable).of((0, (0, parcelRequire("gFEKp")).setSelectedIssue)(key))) : batchedActionsObservable;
            }
            const selectedItemIndex = selectedItemIds.indexOf(id);
            const updatedSelectedItemIds = selectedItemIds.slice();
            const selectionAnchorIndex = selectionAnchors.indexOf(id);
            const updatedSelectionAnchors = selectionAnchors.slice();
            if (withCmd) {
                const actions = [];
                let issueKeyShown;
                if (selectedItemIds.length === 1 && selectedItemIndex === 0) {
                    updatedSelectionAnchors.pop();
                    updatedSelectedItemIds.pop();
                    isIssueDetailsShown && actions.push((0, (0, parcelRequire("gFEKp")).hidePanel)());
                } else {
                    issueKeyShown = key;
                    if (selectedItemIndex === -1) {
                        updatedSelectionAnchors.push(id);
                        updatedSelectedItemIds.push(id);
                        const isInteractedItemsLimitExceeded = $cd623a89d6f89567$var$getIsInteractedItemsLimitExceeded(state, isSelectedItemIdsBaseLevel, updatedSelectedItemIds, analyticsEvent);
                        if (isInteractedItemsLimitExceeded) return (0, $kVLXA.Observable).of((0, (0, parcelRequire("hb2iR")).interactedItemsLimitExceeded)());
                    } else {
                        const isAnchor = selectionAnchorIndex > -1;
                        isAnchor && updatedSelectionAnchors.splice(selectionAnchorIndex, 1);
                        updatedSelectedItemIds.splice(selectedItemIndex, 1);
                        const [prevSelectedItem] = updatedSelectedItemIds.slice(-1);
                        !updatedSelectionAnchors.length && updatedSelectionAnchors.push(prevSelectedItem);
                        if (prevSelectedItem !== id) issueKeyShown = (0, (0, parcelRequire("hFyhA")).getIssueKeyById)(state, prevSelectedItem);
                    }
                    if (isIssueDetailsShown && !issueKeyShown) actions.push((0, (0, parcelRequire("gFEKp")).hidePanel)());
                }
                actions.unshift((0, (0, parcelRequire("lEiof")).setSelectionAnchors)(updatedSelectionAnchors), (0, (0, parcelRequire("lEiof")).setSelectedItemIds)(updatedSelectedItemIds));
                const batchedActionsObservable = (0, $kVLXA.Observable).of((0, $aB8eX.batchActions)(actions));
                return isIssueDetailsShown && issueKeyShown ? (0, $kVLXA.Observable).concat(batchedActionsObservable, (0, $kVLXA.Observable).of((0, (0, parcelRequire("gFEKp")).setSelectedIssue)(issueKeyShown))) : batchedActionsObservable;
            }
            return (0, $kVLXA.Observable).empty();
        });
});
const $7c85843a6edcd27d$export$e90b483346a763db = 'ISSUE_DETAILS';
parcelRegister("1wSJc", function(module, exports) {
    $parcel$export(module.exports, "getIsInteractedItemsOverLimit", ()=>$1fa396b4d0874726$export$4b0e940e4f6d33c5);
    var $eKt4x;
    var $hFyhA;
    const $1fa396b4d0874726$export$4b0e940e4f6d33c5 = (state, isBaseLevel, toBeSelectedItemIds)=>{
        if (isBaseLevel) return toBeSelectedItemIds.length > (0, (0, parcelRequire("eKt4x")).INTERACTED_ITEMS_LIMIT);
        const issueChildrenHash = (0, (0, parcelRequire("hFyhA")).getIssueChildrenHash)(state);
        let childItemsNo = 0;
        toBeSelectedItemIds.forEach((issueId)=>{
            const childIds = issueChildrenHash[issueId] || [];
            childItemsNo += childIds.length;
        });
        return toBeSelectedItemIds.length + childItemsNo > (0, (0, parcelRequire("eKt4x")).INTERACTED_ITEMS_LIMIT);
    };
});
parcelRegister("9BcVE", function(module, exports) {
    $parcel$export(module.exports, "getPanelType", ()=>$8328981c1595176b$export$fa00fa3d6c22a747);
    const $8328981c1595176b$export$fa00fa3d6c22a747 = (state)=>state.ui.panel.panelType;
});
parcelRegister("fZLyn", function(module, exports) {
    $parcel$export(module.exports, "fireInteractedItemsLimitExceededAnalytics", ()=>$bf76442bd4c6b244$export$a66211dbb1def336);
    var $8zOmE;
    const $bf76442bd4c6b244$export$a66211dbb1def336 = (analyticsEvent)=>{
        const { actionSubject: actionSubject, action: action } = analyticsEvent.payload;
        const clonedEvent = analyticsEvent.clone();
        clonedEvent && (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(clonedEvent, 'interactedItemsLimit exceeded', {
            trigger: `${actionSubject} ${action}`
        });
    };
});
parcelRegister("hb4jS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e6dd1873cf14e09f$export$2e2bcd8739ae039);
    parcelRequire("zjDln");
    parcelRequire("jFVZ1");
    parcelRequire("6hSeW");
    parcelRequire("fp4O3");
    parcelRequire("c66Ur");
    parcelRequire("d0pqD");
    parcelRequire("fPS7b");
    var $aB8eX = parcelRequire("aB8eX");
    var $kVLXA = parcelRequire("kVLXA");
    var $7Jxgt = parcelRequire("7Jxgt");
    var $4R6GH;
    var $8zOmE;
    var $lOVLt;
    var $9fPrG;
    var $4gYYI;
    var $1VLi2;
    var $hFyhA;
    var $hb2iR;
    var $9QFr0;
    var $bFYz9;
    var $2GLRH;
    var $6AwHs;
    var $hEJMC;
    var $8CYyu;
    var $5NyaP;
    const $e6dd1873cf14e09f$export$6cafb1506b079115 = (issueIdObservable, issue, transitionId, unsafeRankRequest, analyticsMetadata, sourceARI)=>issueIdObservable.flatMap((issueId)=>unsafeRankRequest.flatMap((request)=>{
                let aggRank;
                if ('rankBeforeId' in request) aggRank = {
                    id: request.rankBeforeId,
                    position: 'BEFORE'
                };
                else if ('rankAfterId' in request) aggRank = {
                    id: request.rankAfterId,
                    position: 'AFTER'
                };
                const fields = {
                    ...(0, (0, parcelRequire("6AwHs")).getFieldModForIssueUpdate)(issue),
                    rank: aggRank
                };
                return (0, (0, parcelRequire("lOVLt")).updateItemGraphqlOnServer)({
                    sourceARI: sourceARI,
                    input: {
                        itemId: issueId,
                        projectId: analyticsMetadata.projectId,
                        summary: fields.summary,
                        dueDate: (0, (0, parcelRequire("2GLRH")).formatDate)(fields.dueDate),
                        startDate: (0, (0, parcelRequire("2GLRH")).formatDate)(fields.startDate),
                        color: fields.color,
                        parentId: fields.parentId,
                        sprintId: fields.sprintId,
                        clearFields: fields.clearFields,
                        rank: fields.rank
                    }
                }).flatMap((data)=>{
                    const updateRoadmapItemData = data?.roadmaps?.updateRoadmapItem;
                    const errors = updateRoadmapItemData?.errors;
                    const success = updateRoadmapItemData?.success;
                    if (success === false && errors?.length) return (0, (0, parcelRequire("bFYz9")).onHandleAggErrors)(!!updateRoadmapItemData, errors).map((aggErrorAction)=>[
                            (0, (0, parcelRequire("1VLi2")).clearTransitionState)({
                                issueId: issueId,
                                transitionId: transitionId
                            }),
                            aggErrorAction
                        ]);
                    const clonedEvent = analyticsMetadata.event.clone();
                    if (clonedEvent) {
                        const attributes = {
                            ...analyticsMetadata.attributes,
                            projectType: 'software'
                        };
                        (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(clonedEvent, 'issue updated', attributes);
                    }
                    return (0, $kVLXA.Observable).of([
                        (0, (0, parcelRequire("1VLi2")).clearTransitionState)({
                            issueId: issueId,
                            transitionId: transitionId
                        })
                    ]);
                });
            }));
    var $e6dd1873cf14e09f$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, (0, parcelRequire("1VLi2")).UPDATE_RANK_ISSUE)).flatMap((action)=>{
            const unsafeIssueId = action.payload.issueId;
            const { rankRequest: rankRequest } = action.payload;
            const state = store.getState();
            const sourceARI = (0, (0, parcelRequire("9fPrG")).getSourceARI)(state);
            const issue = (0, (0, parcelRequire("hFyhA")).getIssue)(state, unsafeIssueId);
            const issueKey = (0, (0, parcelRequire("hFyhA")).getIssueKeyById)(state, unsafeIssueId);
            const projectId = (0, (0, parcelRequire("4gYYI")).getProjectId)(state);
            const issueTypeId = (0, (0, parcelRequire("hFyhA")).getIssueTypeIdForIssueId)(state, unsafeIssueId);
            const level = (0, (0, parcelRequire("4gYYI")).getEpicIssueTypeIds)(state).includes(issueTypeId) ? 1 : 0;
            if (issue === undefined) return (0, $kVLXA.Observable).empty();
            if (!(0, (0, parcelRequire("4gYYI")).rankIssuesSupported)(state)) {
                const { parentId: parentId } = action.payload.properties;
                const clonedEvent = action.meta.analyticsEvent.clone();
                if (clonedEvent) {
                    const attributes = {
                        projectType: 'software',
                        parentIdUpdated: true
                    };
                    (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(clonedEvent, 'issue disabledRankDrop', attributes);
                }
                return (0, $kVLXA.Observable).concat((0, $kVLXA.Observable).of((0, (0, parcelRequire("hb2iR")).unableToRankIssue)({
                    boardId: (0, (0, parcelRequire("9fPrG")).getBoardId)(state)
                })), (0, $kVLXA.Observable).of((0, (0, parcelRequire("1VLi2")).updateAndPersistIssue)(unsafeIssueId, {
                    parentId: parentId
                }, action.meta.analyticsEvent)));
            }
            const sequence = (0, (0, parcelRequire("hFyhA")).getIssueIds)(state);
            let anchorId;
            let isBefore = true;
            if ('rankBeforeId' in rankRequest) anchorId = rankRequest.rankBeforeId;
            else {
                isBefore = false;
                anchorId = rankRequest.rankAfterId;
            }
            const issueIndex = sequence.indexOf(unsafeIssueId);
            sequence.splice(issueIndex, 1);
            let anchorIndex = sequence.indexOf(anchorId);
            if (isBefore === false) anchorIndex += 1;
            sequence.splice(anchorIndex, 0, unsafeIssueId);
            const transitionId = (0, ($parcel$interopDefault($7Jxgt))).v4();
            const [transitionIssue, updatedItems] = (0, (0, parcelRequire("8CYyu")).createTransitionIssueWithUpdatedItems)(issue, action.payload.properties, transitionId);
            const transitionExtend = (0, (0, parcelRequire("hFyhA")).getSafeId)(store.getState(), unsafeIssueId).flatMap((issueId)=>{
                if (issueId === undefined) return (0, $kVLXA.Observable).empty();
                const extendHash = {};
                extendHash[issueId] = transitionIssue;
                return (0, $kVLXA.Observable).of((0, (0, parcelRequire("1VLi2")).extendIssues)({
                    sequence: [
                        ...sequence
                    ],
                    hash: extendHash
                }));
            });
            const extendHash = {};
            extendHash[unsafeIssueId] = transitionIssue;
            const analyticsMetadata = {
                event: action.meta.analyticsEvent,
                projectId: projectId,
                attributes: {
                    issueTypeId: issueTypeId,
                    updatedItems: [
                        ...updatedItems,
                        {
                            name: 'rank'
                        }
                    ],
                    level: level
                }
            };
            const safeRankRequest = (0, (0, parcelRequire("hEJMC")).getSafeRankRequest)(state, rankRequest);
            return (0, $kVLXA.Observable).concat((0, $kVLXA.Observable).of((0, (0, parcelRequire("1VLi2")).extendIssues)({
                sequence: [],
                hash: extendHash
            })), transitionExtend, $e6dd1873cf14e09f$export$6cafb1506b079115((0, (0, parcelRequire("hFyhA")).getSafeId)(store.getState(), unsafeIssueId), transitionIssue, transitionId, safeRankRequest, analyticsMetadata, sourceARI).map((actions)=>{
                (0, (0, parcelRequire("5NyaP")).default)(state, issueKey);
                if ('old' in transitionIssue.parentId) {
                    const { parentId: { old: prevParentId, value: nextParentId } } = transitionIssue;
                    prevParentId && (0, (0, parcelRequire("5NyaP")).default)(state, (0, (0, parcelRequire("hFyhA")).getIssueKeyById)(state, prevParentId));
                    nextParentId && (0, (0, parcelRequire("5NyaP")).default)(state, (0, (0, parcelRequire("hFyhA")).getIssueKeyById)(state, nextParentId));
                }
                return (0, $aB8eX.batchActions)(actions);
            }).catch(()=>(0, $kVLXA.Observable).from([
                    (0, (0, parcelRequire("hb2iR")).aggError)()
                ])), (0, (0, parcelRequire("4R6GH")).fg)('jsw-roadmap-state-change-based-issue-hidden-flags') ? (0, $kVLXA.Observable).empty() : (0, $kVLXA.Observable).of((0, (0, parcelRequire("9QFr0")).reapplyJQLFilters)()));
        });
});
parcelRegister("2GLRH", function(module, exports) {
    $parcel$export(module.exports, "formatDate", ()=>$7017b372395f3873$export$3ae94a2503e890a1);
    var $2gnC5 = parcelRequire("2gnC5");
    const $7017b372395f3873$export$3ae94a2503e890a1 = (date)=>date !== undefined ? (0, ($parcel$interopDefault($2gnC5))).utc(date).format('YYYY-MM-DD') : null;
});
parcelRegister("4ybzM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3e1a0239400ec084$export$2e2bcd8739ae039);
    parcelRequire("zjDln");
    parcelRequire("jFVZ1");
    parcelRequire("6hSeW");
    parcelRequire("fp4O3");
    parcelRequire("c66Ur");
    parcelRequire("d0pqD");
    parcelRequire("fPS7b");
    var $aB8eX = parcelRequire("aB8eX");
    var $2gnC5 = parcelRequire("2gnC5");
    var $kVLXA = parcelRequire("kVLXA");
    var $7Jxgt = parcelRequire("7Jxgt");
    var $4R6GH;
    var $8zOmE;
    var $joGLY;
    var $70YnB;
    var $lOVLt;
    var $eKt4x;
    var $9fPrG;
    var $4gYYI;
    var $1VLi2;
    var $hFyhA;
    var $hb2iR;
    var $bZFir;
    var $9QFr0;
    var $9BcVE;
    var $bM42j;
    var $8z00f;
    var $bFYz9;
    var $jNu4Z;
    var $fZLyn;
    var $2GLRH;
    var $6AwHs;
    var $fUbie;
    var $8CYyu;
    var $5NyaP;
    const $3e1a0239400ec084$export$4addbf2b693857b = (isHiddenBySetting, issueIdObservable, issue, transitionId, startDateCustomFieldId, analyticsMetadata, sourceARI, unsafeIssueId)=>issueIdObservable.mergeMap((issueId)=>{
            const fieldMod = (0, (0, parcelRequire("6AwHs")).getFieldModForIssueUpdate)(issue);
            return (0, (0, parcelRequire("lOVLt")).updateItemGraphqlOnServer)({
                sourceARI: sourceARI,
                input: {
                    itemId: issueId,
                    projectId: analyticsMetadata.projectId,
                    summary: fieldMod?.summary,
                    dueDate: (0, (0, parcelRequire("2GLRH")).formatDate)(fieldMod?.dueDate),
                    startDate: (0, (0, parcelRequire("2GLRH")).formatDate)(fieldMod?.startDate),
                    color: fieldMod?.color,
                    parentId: fieldMod?.parentId,
                    sprintId: fieldMod?.sprintId,
                    clearFields: fieldMod?.clearFields
                }
            }).mergeMap((data)=>{
                const updateRoadmapItemData = data?.roadmaps?.updateRoadmapItem;
                const errors = updateRoadmapItemData?.errors;
                const success = updateRoadmapItemData?.success;
                if (success === false && errors?.length) {
                    if ((0, (0, parcelRequire("8z00f")).isPermissionError)(errors)) return (0, $kVLXA.Observable).of((0, (0, parcelRequire("hb2iR")).updateItemPermission)()).map((permissionErrorAction)=>[
                            permissionErrorAction,
                            (0, (0, parcelRequire("1VLi2")).resetTransitionState)({
                                issueId: unsafeIssueId,
                                transitionId: transitionId
                            })
                        ]);
                    return (0, (0, parcelRequire("bFYz9")).onHandleAggErrors)(!!updateRoadmapItemData, errors).map((aggErrorAction)=>[
                            aggErrorAction,
                            (0, (0, parcelRequire("1VLi2")).resetTransitionState)({
                                issueId: unsafeIssueId,
                                transitionId: transitionId
                            })
                        ]);
                }
                const clonedEvent = analyticsMetadata.event.clone();
                if (clonedEvent) {
                    const { level: level, updatedItems: updatedItems, issueTypeId: issueTypeId, hasOverdueReleaseDate: hasOverdueReleaseDate } = analyticsMetadata.attributes;
                    (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(clonedEvent, 'issue updated', issueId, {
                        level: level,
                        updatedItems: updatedItems,
                        issueTypeId: issueTypeId,
                        projectType: 'software',
                        hasOverdueReleaseDate: hasOverdueReleaseDate
                    });
                }
                const actions = [
                    (0, (0, parcelRequire("1VLi2")).clearTransitionState)({
                        issueId: issueId,
                        transitionId: transitionId
                    }, (0, (0, parcelRequire("1VLi2")).UPDATE_ISSUE))
                ];
                if (!(0, (0, parcelRequire("4R6GH")).fg)('jsw-roadmap-state-change-based-issue-hidden-flags') && isHiddenBySetting) actions.push((0, (0, parcelRequire("hb2iR")).issueDisappearsFromDisplayRange)({
                    issueId: issueId
                }));
                return (0, $kVLXA.Observable).of(actions);
            });
        });
    const $3e1a0239400ec084$export$8cf807211b294d82 = (bypassSprintScopeCheck, modifiedProperties, analyticsEvent, issueId, issue, state, transitionId, hasOverdueReleaseDate)=>{
        if (!bypassSprintScopeCheck && modifiedProperties.sprintId !== undefined || modifiedProperties.clearFields?.includes((0, (0, parcelRequire("70YnB")).SPRINT_IDS))) {
            const sourceSprintId = issue !== undefined && issue.sprintIds.value !== undefined && issue.sprintIds.value.length > 0 ? issue.sprintIds.value[0] : undefined;
            const sprintStateSelector = (0, (0, parcelRequire("bZFir")).getSprintState)(state);
            const targetSprintState = sprintStateSelector(modifiedProperties.sprintId);
            const sourceSprintState = sprintStateSelector(sourceSprintId);
            if (targetSprintState === (0, $575de6c25475b26c$export$2b35adb71b3f6143) || sourceSprintState === (0, $575de6c25475b26c$export$2b35adb71b3f6143)) return (0, (0, parcelRequire("hb2iR")).sprintScopeChanged)({
                direction: targetSprintState === (0, $575de6c25475b26c$export$2b35adb71b3f6143) ? (0, $faa12ce5ec04bf70$export$11ee87f991dd6574) : (0, $faa12ce5ec04bf70$export$be2c0bb3425b849c),
                issueId: issueId,
                targetSprintId: modifiedProperties.sprintId,
                sourceSprintId: sourceSprintId,
                properties: modifiedProperties,
                sourceEvent: analyticsEvent,
                transitionId: transitionId,
                hasOverdueReleaseDate: hasOverdueReleaseDate
            });
        }
        return undefined;
    };
    const $3e1a0239400ec084$export$5764cb619636eedb = (updatedStartDate, updatedDueDate, isDragged)=>isDragged === true ? (0, ($parcel$interopDefault($2gnC5))).utc((updatedStartDate + updatedDueDate) / 2).add(12, 'hours').startOf('day').valueOf() : updatedStartDate;
    var $3e1a0239400ec084$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, (0, parcelRequire("1VLi2")).UPDATE_ISSUE)).mergeMap(({ payload: { id: unsafeIssueId, properties: properties }, meta: { isDragged: isDragged, hasOverdueReleaseDate: hasOverdueReleaseDate, bypassSprintScopeCheck: bypassSprintScopeCheck, analyticsEvent: analyticsEvent } })=>{
            const state = store.getState();
            const issue = (0, (0, parcelRequire("hFyhA")).getIssue)(state, unsafeIssueId);
            if (issue === undefined) return (0, $kVLXA.Observable).empty();
            let modifiedProperties = {
                ...properties
            };
            const sourceARI = (0, (0, parcelRequire("9fPrG")).getSourceARI)(state);
            const isSprintsPlanning = (0, (0, parcelRequire("4gYYI")).getIsSprintsPlanningEnabled)(state);
            const isChildIssuePlannedEnabled = (0, (0, parcelRequire("4gYYI")).getIsChildIssuePlanningEnabled)(state);
            const issueKey = (0, (0, parcelRequire("hFyhA")).getIssueKeyById)(state, unsafeIssueId);
            const projectId = (0, (0, parcelRequire("4gYYI")).getProjectId)(state);
            const issueTypeId = (0, (0, parcelRequire("hFyhA")).getIssueTypeIdForIssueId)(state, unsafeIssueId);
            const level = (0, (0, parcelRequire("4gYYI")).getEpicIssueTypeIds)(state).includes(issueTypeId) ? (0, (0, parcelRequire("joGLY")).PARENT_LEVEL) : (0, (0, parcelRequire("joGLY")).BASE_LEVEL);
            const isIssueBaseLevel = (0, (0, parcelRequire("joGLY")).isBaseLevel)(level);
            if (isIssueBaseLevel) {
                const updatedStartDate = properties.startDate;
                const updatedDueDate = properties.dueDate;
                const currentSprintIds = issue?.sprintIds?.value ?? [];
                if (isSprintsPlanning && modifiedProperties.sprintId === undefined) {
                    const intersectingSprintId = updatedStartDate === undefined || updatedDueDate === undefined ? undefined : (0, (0, parcelRequire("bZFir")).createGetIntersectingSprintId)(state)($3e1a0239400ec084$export$5764cb619636eedb(updatedStartDate, updatedDueDate, isDragged), currentSprintIds[currentSprintIds.length - 1]);
                    const { startDate: startDate, dueDate: dueDate, ...otherProperties } = modifiedProperties;
                    if (intersectingSprintId === undefined) modifiedProperties = otherProperties;
                    else modifiedProperties = {
                        ...otherProperties,
                        sprintId: intersectingSprintId
                    };
                }
                if (Object.keys(modifiedProperties).length === 0) return (0, $kVLXA.Observable).empty();
            }
            let scheduleFields = [];
            const transitionId = (0, ($parcel$interopDefault($7Jxgt))).v4();
            const selectedItemIds = (0, (0, parcelRequire("bM42j")).getSelectedItemIds)(state);
            const prevStartDate = (0, (0, parcelRequire("hFyhA")).getIssueStartDate)(state, unsafeIssueId);
            const prevDueDate = (0, (0, parcelRequire("hFyhA")).getIssueDueDate)(state, unsafeIssueId);
            if (modifiedProperties.startDate === prevStartDate) delete modifiedProperties.startDate;
            if (modifiedProperties.dueDate === prevDueDate) delete modifiedProperties.dueDate;
            const childIds = (0, (0, parcelRequire("hFyhA")).getIssueChildrenHash)(state)[unsafeIssueId] || [];
            const canBulkSchedule = (0, (0, parcelRequire("fUbie")).shouldBulkSchedule)(unsafeIssueId, modifiedProperties, {
                startDate: prevStartDate,
                dueDate: prevDueDate
            }, selectedItemIds);
            const canScheduleChildren = (0, (0, parcelRequire("fUbie")).shouldScheduleChildrenIssues)(level, modifiedProperties, {
                startDate: prevStartDate,
                dueDate: prevDueDate
            }, childIds.length, isSprintsPlanning, isChildIssuePlannedEnabled);
            const isIssueOutsideSelection = selectedItemIds.length > 0 && !selectedItemIds.includes(unsafeIssueId);
            const isInteractedItemsLimitExceeded = canScheduleChildren && childIds.length + 1 > (0, (0, parcelRequire("eKt4x")).INTERACTED_ITEMS_LIMIT);
            const isIssueDetailsShown = (0, (0, parcelRequire("9BcVE")).getPanelType)(state) === (0, $7c85843a6edcd27d$export$e90b483346a763db);
            const resetActions = (0, (0, parcelRequire("jNu4Z")).getResetActions)(isIssueOutsideSelection, isIssueOutsideSelection && isIssueDetailsShown);
            const resetObservable = resetActions.length ? (0, $kVLXA.Observable).of(resetActions.length > 1 ? (0, $aB8eX.batchActions)(resetActions) : resetActions[0]) : (0, $kVLXA.Observable).empty();
            if (canBulkSchedule || canScheduleChildren) {
                const { startDate: startDate, dueDate: dueDate } = modifiedProperties;
                if (isInteractedItemsLimitExceeded) (0, (0, parcelRequire("fZLyn")).fireInteractedItemsLimitExceededAnalytics)(analyticsEvent);
                else scheduleFields = (0, (0, parcelRequire("fUbie")).getScheduleFieldsForBulkDatesUpdate)(store, unsafeIssueId, {
                    startDate: startDate,
                    dueDate: dueDate
                }, isIssueBaseLevel, selectedItemIds);
            }
            if (scheduleFields.length) return (0, $kVLXA.Observable).concat(resetObservable, (0, $kVLXA.Observable).of((0, (0, parcelRequire("1VLi2")).scheduleIssues)(scheduleFields, analyticsEvent, hasOverdueReleaseDate)));
            const [transitionIssue, updatedItems] = (0, (0, parcelRequire("8CYyu")).createTransitionIssueWithUpdatedItems)(issue, modifiedProperties, transitionId);
            const transitionExtend = (0, (0, parcelRequire("hFyhA")).getSafeId)(state, unsafeIssueId).mergeMap((issueId)=>{
                if (issueId === undefined) return (0, $kVLXA.Observable).empty();
                const extendHash = {};
                extendHash[issueId] = transitionIssue;
                return (0, $kVLXA.Observable).of((0, (0, parcelRequire("1VLi2")).extendIssues)({
                    sequence: [],
                    hash: extendHash
                }));
            });
            const extendHash = {};
            extendHash[unsafeIssueId] = transitionIssue;
            const handlePersistUpdate = ()=>{
                const sprintScopeChangedAction = $3e1a0239400ec084$export$8cf807211b294d82(bypassSprintScopeCheck, modifiedProperties, analyticsEvent, unsafeIssueId, issue, state, transitionId, hasOverdueReleaseDate);
                if (sprintScopeChangedAction) return (0, $kVLXA.Observable).of(sprintScopeChangedAction);
                if (isInteractedItemsLimitExceeded) return (0, $kVLXA.Observable).of((0, (0, parcelRequire("hb2iR")).interactedItemsLimitExceeded)({
                    transitionId: transitionId,
                    issueId: unsafeIssueId,
                    hasOverdueReleaseDate: hasOverdueReleaseDate,
                    properties: modifiedProperties,
                    sourceEvent: analyticsEvent
                }));
                const { isHiddenBySetting: isHiddenBySetting } = (0, (0, parcelRequire("6AwHs")).getIsIssueHiddenByFiltersOrSettings)(state, transitionIssue, unsafeIssueId);
                const analyticsMetadata = {
                    event: analyticsEvent,
                    projectId: projectId,
                    attributes: {
                        issueTypeId: issueTypeId,
                        updatedItems: updatedItems,
                        level: level,
                        hasOverdueReleaseDate: hasOverdueReleaseDate
                    }
                };
                return $3e1a0239400ec084$export$4addbf2b693857b(isHiddenBySetting, (0, (0, parcelRequire("hFyhA")).getSafeId)(state, unsafeIssueId), transitionIssue, transitionId, (0, (0, parcelRequire("4gYYI")).getStartDateCustomFieldId)(state), analyticsMetadata, sourceARI, unsafeIssueId).map((actions)=>{
                    (0, (0, parcelRequire("5NyaP")).default)(state, issueKey);
                    return (0, $aB8eX.batchActions)(actions);
                }).catch(()=>(0, $kVLXA.Observable).from([
                        (0, (0, parcelRequire("hb2iR")).aggError)(),
                        (0, (0, parcelRequire("1VLi2")).resetTransitionState)({
                            issueId: unsafeIssueId,
                            transitionId: transitionId
                        })
                    ]));
            };
            return (0, $kVLXA.Observable).concat(resetObservable, (0, $kVLXA.Observable).of((0, (0, parcelRequire("1VLi2")).extendIssues)({
                sequence: [],
                hash: extendHash
            }, (0, (0, parcelRequire("1VLi2")).UPDATE_ISSUE))), transitionExtend, handlePersistUpdate(), (0, (0, parcelRequire("4R6GH")).fg)('jsw-roadmap-state-change-based-issue-hidden-flags') ? (0, $kVLXA.Observable).empty() : (0, $kVLXA.Observable).of((0, (0, parcelRequire("9QFr0")).reapplyJQLFilters)()));
        });
});
parcelRegister("jNu4Z", function(module, exports) {
    $parcel$export(module.exports, "getResetActions", ()=>$b068bc8fc56413a9$export$3bc4b4116025636f);
    $parcel$export(module.exports, "getSyncActions", ()=>$b068bc8fc56413a9$export$dcee6b662e166418);
    var $4R6GH;
    var $hFyhA;
    var $gFEKp;
    var $9BcVE;
    var $lEiof;
    var $bM42j;
    const $b068bc8fc56413a9$export$3bc4b4116025636f = (shouldResetSelection = true, shouldHidePanel = true)=>{
        const actions = shouldResetSelection ? [
            (0, (0, parcelRequire("lEiof")).setSelectionAnchors)([]),
            (0, (0, parcelRequire("lEiof")).setSelectedItemIds)([])
        ] : [];
        const panelActions = shouldHidePanel ? [
            (0, (0, parcelRequire("gFEKp")).hidePanel)()
        ] : [];
        return actions.concat(panelActions);
    };
    const $b068bc8fc56413a9$export$dcee6b662e166418 = (state, key)=>{
        const selectedItemIds = (0, (0, parcelRequire("bM42j")).getSelectedItemIds)(state);
        const isIssueDetailsShown = (0, (0, parcelRequire("9BcVE")).getPanelType)(state) === (0, $7c85843a6edcd27d$export$e90b483346a763db);
        const id = (0, (0, parcelRequire("hFyhA")).getIssueKeyToIdHash)(state)[key ?? ''] ?? '';
        if (!key) return $b068bc8fc56413a9$export$3bc4b4116025636f(selectedItemIds.length === 1, isIssueDetailsShown);
        const selectedItemIndex = selectedItemIds.indexOf(id);
        const actions = (0, (0, parcelRequire("4R6GH")).fg)('project_timeline_multi-select_and_checkboxes') ? [
            (0, (0, parcelRequire("lEiof")).setSelectionAnchors)([
                id
            ])
        ] : [
            (0, (0, parcelRequire("lEiof")).setSelectionAnchors)([
                id
            ]),
            (0, (0, parcelRequire("lEiof")).setSelectedItemIds)([
                id
            ])
        ];
        const panelActions = isIssueDetailsShown ? [] : [
            (0, (0, parcelRequire("gFEKp")).showPanel)((0, $7c85843a6edcd27d$export$e90b483346a763db))
        ];
        return id && selectedItemIndex === -1 ? actions.concat(panelActions) : panelActions;
    };
});
parcelRegister("fUbie", function(module, exports) {
    $parcel$export(module.exports, "shouldScheduleChildrenIssues", ()=>$4e4fc1c71afdf497$export$f98ee0b182e34597);
    $parcel$export(module.exports, "shouldBulkSchedule", ()=>$4e4fc1c71afdf497$export$5b71390452906e47);
    $parcel$export(module.exports, "getScheduleFieldsForBulkDatesUpdate", ()=>$4e4fc1c71afdf497$export$d9763154bd67b2b3);
    var $joGLY;
    var $esmwW;
    var $2KlaV;
    var $g11uZ;
    var $hFyhA;
    var $e5ith;
    var $8uNFS;
    var $2Hh6q;
    const $4e4fc1c71afdf497$export$f98ee0b182e34597 = (level, { startDate: startDate, dueDate: dueDate }, { startDate: prevStartDate, dueDate: prevDueDate }, numberOfChildren, isSprintsPlanning, isChildIssuePlanningEnabled)=>{
        const isParentWithChildren = !(0, (0, parcelRequire("joGLY")).isBaseLevel)(level) && numberOfChildren > 0;
        const isBothDatesPopulated = startDate !== undefined && dueDate !== undefined;
        const isBothDatesUpdated = startDate !== prevStartDate && dueDate !== prevDueDate;
        return isChildIssuePlanningEnabled && !isSprintsPlanning && isParentWithChildren && isBothDatesPopulated && isBothDatesUpdated;
    };
    const $4e4fc1c71afdf497$export$5b71390452906e47 = (targetItem, { startDate: startDate, dueDate: dueDate }, { startDate: prevStartDate, dueDate: prevDueDate }, selectedItemIds)=>{
        const isDraggingOrResizing = startDate !== undefined || dueDate !== undefined;
        const isDateUpdated = startDate !== prevStartDate || dueDate !== prevDueDate;
        return isDraggingOrResizing && isDateUpdated && selectedItemIds.length > 1 && selectedItemIds.includes(targetItem);
    };
    const $4e4fc1c71afdf497$export$a43c8446bad60ee = (startDate, dueDate, timelineDuration, offset)=>{
        const direction = offset < 0 ? (0, (0, parcelRequire("2KlaV")).LEFT) : (0, (0, parcelRequire("2KlaV")).RIGHT);
        const { startMilliseconds: startMilliseconds, endMilliseconds: endMilliseconds } = timelineDuration;
        let newOffset = offset;
        if (direction === (0, (0, parcelRequire("2KlaV")).LEFT) && startDate !== undefined) {
            const maxLeftOffset = -Math.max(0, startDate - startMilliseconds);
            newOffset = Math.max(maxLeftOffset, offset);
        } else if (direction === (0, (0, parcelRequire("2KlaV")).RIGHT) && dueDate !== undefined) {
            const maxRightOffset = Math.max(0, endMilliseconds - dueDate - (0, (0, parcelRequire("esmwW")).DUE_DATE_OFFSET));
            newOffset = Math.min(maxRightOffset, offset);
        }
        const newStartDate = startDate !== undefined ? startDate + newOffset : undefined;
        const newDueDate = dueDate !== undefined ? dueDate + newOffset : undefined;
        return {
            startDate: newStartDate,
            dueDate: newDueDate
        };
    };
    const $4e4fc1c71afdf497$var$EMPTY_HASH = {};
    const $4e4fc1c71afdf497$var$getFlippedDates = (startDate, dueDate)=>startDate !== undefined && dueDate !== undefined && startDate > dueDate ? [
            dueDate,
            startDate
        ] : [
            startDate,
            dueDate
        ];
    const $4e4fc1c71afdf497$export$d9763154bd67b2b3 = (store, targetIssueId, { startDate: startDate, dueDate: dueDate }, isIssueBaseLevel, selectedItemIds)=>{
        const state = store.getState();
        let prevExplicitStartDate = (0, (0, parcelRequire("hFyhA")).getIssueStartDate)(state, targetIssueId);
        let prevExplicitDueDate = (0, (0, parcelRequire("hFyhA")).getIssueDueDate)(state, targetIssueId);
        [prevExplicitStartDate, prevExplicitDueDate] = $4e4fc1c71afdf497$var$getFlippedDates(prevExplicitStartDate, prevExplicitDueDate);
        const { startDate: prevRolledUpStartDate, dueDate: prevRolledUpDueDate } = isIssueBaseLevel ? $4e4fc1c71afdf497$var$EMPTY_HASH : (0, (0, parcelRequire("8uNFS")).getParentRolledUpDatesHash)(state)[targetIssueId] ?? $4e4fc1c71afdf497$var$EMPTY_HASH;
        const { startDate: prevInferredStartDate, dueDate: prevInferredDueDate } = (0, (0, parcelRequire("e5ith")).getChartDateData)(prevExplicitStartDate, prevExplicitDueDate, isIssueBaseLevel ? (0, (0, parcelRequire("joGLY")).BASE_LEVEL) : (0, (0, parcelRequire("joGLY")).PARENT_LEVEL), true);
        const scheduleFields = [];
        let offset = 0;
        if (startDate !== undefined && prevExplicitStartDate !== undefined) offset = startDate - prevExplicitStartDate;
        else if (dueDate !== undefined && prevExplicitDueDate !== undefined) offset = dueDate - prevExplicitDueDate;
        else if (startDate !== undefined && prevRolledUpStartDate !== undefined) offset = startDate - prevRolledUpStartDate;
        else if (dueDate !== undefined && prevRolledUpDueDate !== undefined) offset = dueDate - prevRolledUpDueDate;
        else if (startDate !== undefined && prevInferredStartDate !== undefined) offset = startDate - prevInferredStartDate;
        else if (dueDate !== undefined && prevInferredDueDate !== undefined) offset = dueDate - prevInferredDueDate;
        const timelineDuration = (0, (0, parcelRequire("2Hh6q")).getTimelineDuration)(state);
        const issueChildrenHash = (0, (0, parcelRequire("hFyhA")).getIssueChildrenHash)(state);
        const minTimelineDateRange = (0, (0, parcelRequire("2Hh6q")).getMinTimelineDateRange)(state);
        const isResizing = startDate === undefined || dueDate === undefined;
        const isBulkScheduling = selectedItemIds.length > 1 && selectedItemIds.includes(targetIssueId);
        const targetItems = isBulkScheduling ? selectedItemIds : [
            targetIssueId
        ];
        const targetItemsChidren = [];
        if (!isIssueBaseLevel && !isResizing) targetItems.forEach((issueId)=>{
            const childIds = issueChildrenHash[issueId] || [];
            childIds.length && targetItemsChidren.push(...childIds);
        });
        scheduleFields.push({
            issueId: targetIssueId,
            startDate: startDate ?? prevExplicitStartDate,
            dueDate: dueDate ?? prevExplicitDueDate
        });
        targetItems.forEach((issueId)=>{
            if (issueId === targetIssueId) return;
            const isStartDateResized = isResizing && dueDate === undefined;
            const isDueDateResized = isResizing && startDate === undefined;
            let issueExplicitStartDate = (0, (0, parcelRequire("hFyhA")).getIssueStartDate)(state, issueId);
            let issueExplicitDueDate = (0, (0, parcelRequire("hFyhA")).getIssueDueDate)(state, issueId);
            [issueExplicitStartDate, issueExplicitDueDate] = $4e4fc1c71afdf497$var$getFlippedDates(issueExplicitStartDate, issueExplicitDueDate);
            const { startDate: issueRolledUpStartDate, dueDate: issueRolledUpDueDate } = isIssueBaseLevel ? $4e4fc1c71afdf497$var$EMPTY_HASH : (0, (0, parcelRequire("8uNFS")).getParentRolledUpDatesHash)(state)[issueId] ?? $4e4fc1c71afdf497$var$EMPTY_HASH;
            const { startDate: issueInferredStartDate, dueDate: issueInferredDueDate } = (0, (0, parcelRequire("e5ith")).getChartDateData)(issueExplicitStartDate, issueExplicitDueDate, isIssueBaseLevel ? (0, (0, parcelRequire("joGLY")).BASE_LEVEL) : (0, (0, parcelRequire("joGLY")).PARENT_LEVEL), true);
            const { startDate: newStartDate, dueDate: newDueDate } = $4e4fc1c71afdf497$export$a43c8446bad60ee(issueExplicitStartDate ?? issueRolledUpStartDate ?? issueInferredStartDate, issueExplicitDueDate ?? issueRolledUpDueDate ?? issueInferredDueDate, timelineDuration, offset);
            if (issueExplicitStartDate !== newStartDate || issueExplicitDueDate !== newDueDate) {
                let cappedStartDate = isDueDateResized ? issueExplicitStartDate : newStartDate;
                let cappedDueDate = isStartDateResized ? issueExplicitDueDate : newDueDate;
                if (isResizing && cappedStartDate !== undefined && cappedDueDate !== undefined && cappedDueDate - cappedStartDate < minTimelineDateRange) {
                    if (isStartDateResized) cappedStartDate = (0, (0, parcelRequire("g11uZ")).getEndOfDay)(cappedDueDate - minTimelineDateRange);
                    else cappedDueDate = (0, (0, parcelRequire("g11uZ")).getStartOfDay)(cappedStartDate + minTimelineDateRange);
                }
                scheduleFields.push({
                    issueId: issueId,
                    startDate: cappedStartDate,
                    dueDate: cappedDueDate
                });
            }
        });
        targetItemsChidren.forEach((issueId)=>{
            const issueExplicitStartDate = (0, (0, parcelRequire("hFyhA")).getIssueStartDate)(state, issueId);
            const issueExplicitDueDate = (0, (0, parcelRequire("hFyhA")).getIssueDueDate)(state, issueId);
            const { startDate: newStartDate, dueDate: newDueDate } = $4e4fc1c71afdf497$export$a43c8446bad60ee(issueExplicitStartDate, issueExplicitDueDate, timelineDuration, offset);
            if (issueExplicitStartDate !== newStartDate || issueExplicitDueDate !== newDueDate) scheduleFields.push({
                issueId: issueId,
                startDate: newStartDate,
                dueDate: newDueDate
            });
        });
        return scheduleFields;
    };
});
parcelRegister("bcPzn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$39a4a2f4af2eea94$export$2e2bcd8739ae039);
    var $e1AU2 = parcelRequire("e1AU2");
    var $1Us7W;
    var $1oLqI;
    var $39a4a2f4af2eea94$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, (0, parcelRequire("1Us7W")).default), (0, (0, parcelRequire("1oLqI")).default));
});
parcelRegister("1Us7W", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ffd74915934a31b5$export$2e2bcd8739ae039);
    parcelRequire("fg0YM");
    parcelRequire("6hSeW");
    parcelRequire("hZWgu");
    parcelRequire("7mHDu");
    parcelRequire("1oQta");
    var $kVLXA = parcelRequire("kVLXA");
    var $99gkn;
    var $1VLi2;
    var $7aKdn;
    var $9QFr0;
    var $gFEKp;
    var $lEiof;
    var $ilGit;
    var $ffd74915934a31b5$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, (0, parcelRequire("1VLi2")).CREATE_ISSUE), (0, (0, parcelRequire("9QFr0")).SET_TIMELINE_MODE), (0, (0, parcelRequire("9QFr0")).SET_STATUS_CATEGORY_FILTER), (0, (0, parcelRequire("9QFr0")).SET_ISSUE_TYPE_FILTER), (0, (0, parcelRequire("9QFr0")).SET_ASSIGNEE_FILTER), (0, (0, parcelRequire("9QFr0")).SET_TEXT_FILTER), (0, (0, parcelRequire("9QFr0")).SET_LABEL_FILTER), (0, (0, parcelRequire("9QFr0")).SET_ISSUE_PARENT_FILTER), (0, (0, parcelRequire("9QFr0")).SET_VERSION_FILTER), (0, (0, parcelRequire("9QFr0")).SET_COMPONENT_FILTER), (0, (0, parcelRequire("lEiof")).CHANGE_EXPANSION_STATE), (0, (0, parcelRequire("lEiof")).SET_CREATE_ITEM_ANCHOR), (0, (0, parcelRequire("ilGit")).SET_PROGRESS_VISIBILITY), (0, (0, parcelRequire("ilGit")).SET_RELEASES_VISIBILITY), (0, (0, parcelRequire("ilGit")).SET_LEVEL_ONE_SETTING), (0, (0, parcelRequire("ilGit")).SET_DEPENDENCIES_VIEW_VISIBILITY), (0, (0, parcelRequire("lEiof")).SHOW_TOOLTIP), (0, (0, parcelRequire("gFEKp")).SHOW_PANEL), (0, (0, parcelRequire("gFEKp")).SET_SELECTED_ISSUE)).concatMap(()=>{
            const interactionPerformanceExtraData = (0, (0, parcelRequire("7aKdn")).getInteractionPerformanceExtraData)(store.getState());
            (0, (0, parcelRequire("99gkn")).addUFOCustomData)(interactionPerformanceExtraData);
            return (0, $kVLXA.Observable).empty();
        }).ignoreElements();
});
parcelRegister("7aKdn", function(module, exports) {
    $parcel$export(module.exports, "getInteractionPerformanceExtraData", ()=>$775703eedd49704f$export$f44b2ebb2dd51306);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $9fPrG;
    var $hhYQB;
    var $2IdXh;
    var $3rLbe;
    const $775703eedd49704f$export$f44b2ebb2dd51306 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("hhYQB")).getTimelineMode), (0, (0, parcelRequire("2IdXh")).getFilteredIssueCount), (0, (0, parcelRequire("hhYQB")).getNumJQLFiltersApplied), (0, (0, parcelRequire("hhYQB")).isDependenciesVisible), (0, (0, parcelRequire("hhYQB")).isProgressVisible), (0, (0, parcelRequire("3rLbe")).getIsReleasesVisible), (0, (0, parcelRequire("9fPrG")).hasMacroConfig), (timelineMode, filteredIssueCount, numJQLFiltersApplied, dependenciesVisible, progressVisible, releasesVisible, isMacro)=>({
            timelineMode: timelineMode,
            filteredIssueCount: filteredIssueCount,
            numJQLFiltersApplied: numJQLFiltersApplied,
            dependenciesVisible: dependenciesVisible,
            progressVisible: progressVisible,
            releasesVisible: releasesVisible,
            isMacro: isMacro
        }));
});
parcelRegister("1oLqI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$70e8ee277c443358$export$2e2bcd8739ae039);
    var $j7Dz8 = parcelRequire("j7Dz8");
    parcelRequire("6cbqE");
    parcelRequire("7mHDu");
    var $9MifT;
    var $1VLi2;
    var $9QFr0;
    var $70e8ee277c443358$export$2e2bcd8739ae039 = (action$)=>action$.ofType((0, (0, parcelRequire("1VLi2")).CREATE_ISSUE), (0, (0, parcelRequire("1VLi2")).UPDATE_ISSUE), (0, (0, parcelRequire("1VLi2")).SCHEDULE_ISSUES)).switchMap(()=>{
            (0, (0, parcelRequire("9MifT")).interactionPerformance).start((0, $8038b72ffd5aa8d4$export$a0d61e9ea4ad5a05));
            return action$.ofType((0, (0, parcelRequire("9QFr0")).JQL_FILTERS_SUCCESS)).take(1).pipe((0, $j7Dz8.tap)(()=>(0, (0, parcelRequire("9MifT")).interactionPerformance).stop((0, $8038b72ffd5aa8d4$export$a0d61e9ea4ad5a05))));
        }).ignoreElements();
});
parcelRegister("9MifT", function(module, exports) {
    $parcel$export(module.exports, "interactionPerformance", ()=>$2498e499f8fb1a94$export$5815a965e990dd4f);
    $parcel$export(module.exports, "InteractionMetricsExtraData", ()=>$2498e499f8fb1a94$export$45dbc3f8ac9dc78c);
    var $bC2fB;
    var $7aKdn;
    var $2egUN;
    const $2498e499f8fb1a94$export$5815a965e990dd4f = (0, (0, parcelRequire("2egUN")).default)();
    const $2498e499f8fb1a94$var$CaptureInteractionMetricsExtraData = ({ interactionPerformanceExtraData: interactionPerformanceExtraData })=>{
        $2498e499f8fb1a94$export$5815a965e990dd4f.setExtraData(interactionPerformanceExtraData);
        return null;
    };
    const $2498e499f8fb1a94$export$45dbc3f8ac9dc78c = (0, (0, parcelRequire("bC2fB")).connect)((state)=>({
            interactionPerformanceExtraData: (0, (0, parcelRequire("7aKdn")).getInteractionPerformanceExtraData)(state)
        }), {})($2498e499f8fb1a94$var$CaptureInteractionMetricsExtraData);
});
parcelRegister("2egUN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ed296e76956aa070$export$2e2bcd8739ae039);
    var $8C5lr;
    const $ed296e76956aa070$var$interactionPerformanceMetricFactory = ()=>{
        let lastExtraData;
        return {
            setExtraData: (extraData)=>{
                lastExtraData = extraData;
            },
            start: (type)=>{
                const performanceMetrics = (0, (0, parcelRequire("8C5lr")).interactionMetrics)[type];
                performanceMetrics?.cancel();
                performanceMetrics?.start();
            },
            stop: (type)=>{
                const performanceMetrics = (0, (0, parcelRequire("8C5lr")).interactionMetrics)[type];
                performanceMetrics?.stop({
                    customData: {
                        ...lastExtraData ?? undefined
                    }
                });
            }
        };
    };
    var $ed296e76956aa070$export$2e2bcd8739ae039 = $ed296e76956aa070$var$interactionPerformanceMetricFactory;
});
parcelRegister("kwuT3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$23c1aaab2398c05c$export$2e2bcd8739ae039);
    var $e1AU2 = parcelRequire("e1AU2");
    var $8Yity;
    var $fPMll;
    var $23c1aaab2398c05c$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, (0, parcelRequire("fPMll")).default), (0, (0, parcelRequire("8Yity")).default));
});
parcelRegister("8Yity", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0d247afa9bd129d1$export$2e2bcd8739ae039);
    parcelRequire("6hSeW");
    parcelRequire("fp4O3");
    parcelRequire("fPS7b");
    var $aB8eX = parcelRequire("aB8eX");
    var $kVLXA = parcelRequire("kVLXA");
    var $9fPrG;
    var $5EEYw;
    var $9xRvt;
    var $jNu4Z;
    var $0d247afa9bd129d1$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, (0, parcelRequire("5EEYw")).ROUTER_LOCATION_CHANGE)).mergeMap(({ payload: location })=>{
            const state = store.getState();
            const { selectedIssue: selectedIssue } = (0, (0, parcelRequire("9xRvt")).convertStringToQuery)(location.search, (0, (0, parcelRequire("9fPrG")).getRoadmapType)(state));
            const actions = (0, (0, parcelRequire("jNu4Z")).getSyncActions)(state, selectedIssue);
            return actions.length ? (0, $kVLXA.Observable).of(actions.length > 1 ? (0, $aB8eX.batchActions)(actions) : actions[0]) : (0, $kVLXA.Observable).empty();
        });
});
parcelRegister("fPMll", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7b17159a9e120f43$export$2e2bcd8739ae039);
    parcelRequire("d0pqD");
    var $gFEKp;
    var $35igy;
    var $7b17159a9e120f43$export$2e2bcd8739ae039 = (action$, store, { router: { push: push } })=>action$.ofType((0, (0, parcelRequire("gFEKp")).SET_SELECTED_ISSUE)).map((action)=>{
            const state = store.getState();
            const issueKey = action.payload;
            return (0, (0, parcelRequire("35igy")).default)(push, state, (query)=>({
                    ...query,
                    selectedIssue: issueKey
                }));
        });
});
parcelRegister("kqmXe", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$596de7b337f0e088$export$2e2bcd8739ae039);
    var $j7Dz8 = parcelRequire("j7Dz8");
    var $gBFyV;
    var $iRJhX;
    var $596de7b337f0e088$export$2e2bcd8739ae039 = (action$)=>action$.ofType((0, (0, parcelRequire("iRJhX")).UPDATE_RESOURCE_CACHE)).pipe((0, $j7Dz8.tap)(({ payload: payload })=>{
            (0, (0, parcelRequire("gBFyV")).default).next({
                origin: (0, $8631d6ce464ccf2e$export$ffff0a2c60bf4822),
                payload: {
                    roadmapData: payload
                }
            });
        }));
});
parcelRegister("lAEPz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$badf3c72b4c0ca5f$export$2e2bcd8739ae039);
    var $e1AU2 = parcelRequire("e1AU2");
    var $a3PQM;
    var $8mr81;
    var $cjWM8;
    var $badf3c72b4c0ca5f$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, (0, parcelRequire("cjWM8")).default), (0, (0, parcelRequire("8mr81")).default), (0, (0, parcelRequire("a3PQM")).default));
});
parcelRegister("a3PQM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f3e6009348b15a9c$export$2e2bcd8739ae039);
    parcelRequire("d0pqD");
    var $hFyhA;
    var $lEiof;
    var $f3e6009348b15a9c$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, (0, parcelRequire("lEiof")).EXPAND_ALL_ISSUES), (0, (0, parcelRequire("lEiof")).COLLAPSE_ALL_ISSUES)).map((action)=>{
            const { type: type } = action;
            const state = store.getState();
            const issueParentIds = (0, (0, parcelRequire("hFyhA")).getIssueParentIds)(state);
            const isExpanded = type === (0, (0, parcelRequire("lEiof")).EXPAND_ALL_ISSUES);
            return (0, (0, parcelRequire("lEiof")).bulkChangeExpansionState)({
                ids: issueParentIds,
                isExpanded: isExpanded
            });
        });
});
parcelRegister("8mr81", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f121f8f0a0171db0$export$2e2bcd8739ae039);
    parcelRequire("fPS7b");
    parcelRequire("6hSeW");
    parcelRequire("c66Ur");
    var $kVLXA = parcelRequire("kVLXA");
    var $hFyhA;
    var $fQlTr;
    var $lEiof;
    var $ijCAv;
    var $f121f8f0a0171db0$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, (0, parcelRequire("lEiof")).CHANGE_EXPANSION_STATE), (0, (0, parcelRequire("lEiof")).BULK_CHANGE_EXPANSION_STATE)).mergeMap((action)=>{
            const { type: type, payload: payload } = action;
            const { isExpanded: isExpanded } = payload;
            if (!isExpanded) return (0, $kVLXA.Observable).empty();
            const epicIds = type === (0, (0, parcelRequire("lEiof")).CHANGE_EXPANSION_STATE) ? [
                payload.id
            ] : payload.ids;
            const state = store.getState();
            const issueIds = epicIds.flatMap((epicId)=>(0, (0, parcelRequire("hFyhA")).getIssueChildrenHash)(state)[epicId] ?? []);
            const fullSubtaskHash = (0, (0, parcelRequire("fQlTr")).getFullSubtasksHash)(state);
            const issuesWithoutSubtask = issueIds.filter((issueId)=>fullSubtaskHash[issueId] === undefined);
            if (issuesWithoutSubtask.length === 0) return (0, $kVLXA.Observable).empty();
            return (0, (0, parcelRequire("ijCAv")).reloadSubtaskProgress)(store, issuesWithoutSubtask);
        });
});
parcelRegister("cjWM8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e9223294915d7ad7$export$2e2bcd8739ae039);
    parcelRequire("d0pqD");
    var $k6Vft;
    var $35igy;
    var $e9223294915d7ad7$export$2e2bcd8739ae039 = (action$, store, { router: { push: push } })=>action$.ofType((0, (0, parcelRequire("k6Vft")).SET_HIGHLIGHTED_VERSIONS)).map((action)=>(0, (0, parcelRequire("35igy")).default)(push, store.getState(), (query)=>({
                    ...query,
                    highlightedVersions: action.payload.length > 0 ? action.payload : undefined
                })));
});
parcelRegister("fY8f7", function(module, exports) {
    $parcel$export(module.exports, "getCanUserInviteEpic", ()=>$f27599d392dd5911$export$89828008460b535c);
    parcelRequire("fp4O3");
    parcelRequire("6cbqE");
    parcelRequire("fPS7b");
    parcelRequire("c66Ur");
    var $kVLXA = parcelRequire("kVLXA");
    var $jcw0u;
    var $6s1PB;
    var $fZneA;
    var $kUjQv;
    var $jAJAx;
    var $9fPrG;
    var $50Z4W;
    var $4gYYI;
    const $f27599d392dd5911$export$89828008460b535c = (action$, store)=>action$.ofType((0, (0, parcelRequire("jAJAx")).INITIALIZE_NON_CRITICAL_DATA)).switchMap(()=>{
            const state = store.getState();
            const isCMP = (0, (0, parcelRequire("9fPrG")).isClassic)(state);
            if (isCMP || !(0, (0, parcelRequire("6s1PB")).expValEquals)('open_invite_for_open_tmp_projects', 'cohort', 'experiment')) return (0, $kVLXA.Observable).of();
            const projectId = Number((0, (0, parcelRequire("4gYYI")).getProjectId)(state));
            return (0, (0, parcelRequire("kUjQv")).fetchCanUserInviteService)(projectId).mergeMap((canUserInviteResponse)=>(0, $kVLXA.Observable).of((0, (0, parcelRequire("50Z4W")).setCanUserInvite)(canUserInviteResponse))).catch((error)=>{
                if (!(0, (0, parcelRequire("fZneA")).isClientFetchError)(error)) (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: 'timeline.can-user-invite.load.failure',
                        packageName: 'jiraSoftwareRoadmapStandard',
                        teamName: 'chronos'
                    }
                });
                return (0, $kVLXA.Observable).of();
            });
        });
});
parcelRegister("kUjQv", function(module, exports) {
    $parcel$export(module.exports, "fetchCanUserInviteService", ()=>$2cda327f628659a2$export$583ef539d905855);
    parcelRequire("3q49N");
    var $487fd;
    const $2cda327f628659a2$var$getCanInviteOthersUrl = (projectId)=>`/rest/internal/latest/invite-user/project/${projectId}/can-invite-others`;
    const $2cda327f628659a2$export$22c733f1adfb0925 = (projectId)=>(0, (0, parcelRequire("487fd")).default)($2cda327f628659a2$var$getCanInviteOthersUrl(projectId), {
            method: 'GET'
        });
    const $2cda327f628659a2$export$583ef539d905855 = (projectId)=>$2cda327f628659a2$export$22c733f1adfb0925(projectId);
});
parcelRegister("j68aq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$759069d7fa05713d$export$2e2bcd8739ae039);
    var $e1AU2 = parcelRequire("e1AU2");
    var $dejLL;
    var $759069d7fa05713d$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, (0, parcelRequire("dejLL")).default));
});
parcelRegister("dejLL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8777356ade57da00$export$2e2bcd8739ae039);
    parcelRequire("6hSeW");
    parcelRequire("fPS7b");
    var $kVLXA = parcelRequire("kVLXA");
    var $dXq4S;
    var $fXkQT;
    var $9fPrG;
    var $50Z4W;
    var $8777356ade57da00$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, (0, parcelRequire("50Z4W")).SET_VERSION)).mergeMap(({ payload: { id: id } })=>{
            const state = store.getState();
            const cloudId = (0, (0, parcelRequire("9fPrG")).getCloudId)(state);
            const activationId = (0, (0, parcelRequire("9fPrG")).getActivationId)(state);
            const versionAri = (0, (0, parcelRequire("dXq4S")).createAri)({
                resourceOwner: 'jira',
                cloudId: cloudId,
                resourceType: 'version',
                activationId: activationId,
                resourceId: id
            });
            cloudId && activationId && (0, (0, parcelRequire("fXkQT")).removeVersionDetailsCache)(versionAri);
            return (0, $kVLXA.Observable).empty();
        });
});
parcelRegister("fXkQT", function(module, exports) {
    $parcel$export(module.exports, "removeVersionDetailsCache", ()=>$a121e3c14e2eec7f$export$b2c0b3575fda481c);
    $parcel$export(module.exports, "getVersionDetailsFromServer", ()=>$a121e3c14e2eec7f$export$6ad0cbfa40c89e6d);
    parcelRequire("d0pqD");
    parcelRequire("c66Ur");
    var $c3jsi;
    var $ilJEo;
    var $fq1Gb;
    const $a121e3c14e2eec7f$var$CACHE_SIZE = 50;
    const $a121e3c14e2eec7f$export$e29d82aabb0f64f = (0, (0, parcelRequire("c3jsi")).default)({
        size: $a121e3c14e2eec7f$var$CACHE_SIZE,
        cacheKey: 'roadmap-version-details-cache',
        storageType: (0, $43a74598c9c16cf3$export$bf340b99118a1511)
    });
    const $a121e3c14e2eec7f$export$b2c0b3575fda481c = (versionAri)=>{
        const cacheKey = versionAri.toString();
        return $a121e3c14e2eec7f$export$e29d82aabb0f64f.remove(cacheKey);
    };
    const $a121e3c14e2eec7f$export$6ad0cbfa40c89e6d = (versionAri, intl)=>{
        const cacheKey = versionAri.toString();
        return $a121e3c14e2eec7f$export$e29d82aabb0f64f.get(cacheKey).then((data)=>{
            if (data !== undefined) return data;
            return (0, (0, parcelRequire("ilJEo")).fetchVersionDetails)(versionAri).toPromise().then((response)=>{
                const versionDetails = (0, (0, parcelRequire("fq1Gb")).transformVersionDetails)(response, intl);
                $a121e3c14e2eec7f$export$e29d82aabb0f64f.set(cacheKey, versionDetails);
                return versionDetails;
            });
        });
    };
});
const $43a74598c9c16cf3$export$7271276960377470 = 'common-cache';
const $43a74598c9c16cf3$export$a61768fefd33fcb1 = 'capacity exceeded';
const $43a74598c9c16cf3$export$6c4d37c7f376a1de = 'clear';
const $43a74598c9c16cf3$export$e271b26eefe41db8 = 'update';
const $43a74598c9c16cf3$export$4bd2facc4a3e6aa1 = 'delete';
const $43a74598c9c16cf3$export$26d12233004a7a60 = 'delete stale entry';
const $43a74598c9c16cf3$export$1bb358554aac31c1 = 'get';
const $43a74598c9c16cf3$export$61f74127e2b53cbe = 'hydrate';
const $43a74598c9c16cf3$export$5e8f180ef0142226 = 'set';
const $43a74598c9c16cf3$export$9eb68924983e00fb = 'get entries';
const $43a74598c9c16cf3$export$bf340b99118a1511 = 'memory';
const $43a74598c9c16cf3$export$2670cb7d5d4f7184 = 'local';
const $43a74598c9c16cf3$export$b796061ff0c82e1a = 'session';
parcelRegister("c3jsi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ccdca2a0bd8756d7$export$2e2bcd8739ae039);
    var $8Op28;
    const $ccdca2a0bd8756d7$var$pNothing = ()=>Promise.resolve();
    var $ccdca2a0bd8756d7$export$2e2bcd8739ae039 = (config)=>{
        if (!false) {
            const Cache = (0, (0, parcelRequire("8Op28")).default)(config);
            const getAll = ()=>Cache.then((cache)=>cache.getEntries().then((entries)=>entries.map(([, value])=>value)));
            const get = (key)=>Cache.then((cache)=>cache.get(key));
            const set = (key, value)=>Cache.then((cache)=>cache.set(key, value));
            const remove = (key)=>Cache.then((cache)=>cache.delete(key));
            const update = (key, value)=>Cache.then((cache)=>cache.update(key, value));
            const refresh = ()=>Cache.then((cache)=>cache.refresh()).then(()=>getAll());
            const clearAll = ()=>Cache.then((cache)=>cache.getEntries().then((entries)=>Promise.all(entries.map(([key])=>cache.delete(key)))).then(()=>{}));
            return {
                get: get,
                getAll: getAll,
                set: set,
                remove: remove,
                update: update,
                refresh: refresh,
                clearAll: clearAll
            };
        }
        return {
            get: $ccdca2a0bd8756d7$var$pNothing,
            getAll: ()=>Promise.resolve([]),
            set: ()=>Promise.resolve(),
            remove: $ccdca2a0bd8756d7$var$pNothing,
            update: $ccdca2a0bd8756d7$var$pNothing,
            refresh: ()=>Promise.resolve([]),
            clearAll: $ccdca2a0bd8756d7$var$pNothing
        };
    };
});
parcelRegister("8Op28", function(module, exports) {
    $parcel$export(module.exports, "Cache", ()=>$3e46065a4b1d2500$export$94affb487e701bf2);
    $parcel$export(module.exports, "default", ()=>$3e46065a4b1d2500$export$2e2bcd8739ae039);
    var $bSSG7;
    var $eNf8a;
    var $dJl1T;
    var $1NZBJ;
    const $3e46065a4b1d2500$var$calculateEntryAge = (timestamp)=>Date.now() - timestamp;
    function $3e46065a4b1d2500$export$94affb487e701bf2(props) {
        const cache = new Map();
        const { size: size } = props;
        let storage;
        let hasSyncedFromStorage = false;
        const devTools = window && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__.connect({
            name: `Cache ${props.cacheKey}`,
            serialize: true
        }) : null;
        const syncWithDevTools = (type, payload)=>{
            if ((0, (0, parcelRequire("1NZBJ")).default).devTools) devTools && devTools.send({
                type: type,
                payload: payload
            }, cache, {}, props.cacheKey);
        };
        const removeExpiredKeysFromStorage = async (store)=>{
            const updatedStore = {
                ...store
            };
            if (props.storageType === (0, $43a74598c9c16cf3$export$bf340b99118a1511)) return {};
            const { cacheKey: cacheKey, maxAge: maxAge } = props;
            if (maxAge !== undefined) {
                Object.keys(store).forEach((key)=>{
                    const keyAge = $3e46065a4b1d2500$var$calculateEntryAge(store[key].timestamp);
                    if (keyAge > maxAge) {
                        syncWithDevTools((0, $43a74598c9c16cf3$export$26d12233004a7a60), {
                            [String(key)]: updatedStore[key]
                        });
                        delete updatedStore[key];
                        cache.delete(key);
                    }
                });
                storage.set(cacheKey, updatedStore);
            }
            return updatedStore;
        };
        const removeExpiredEntry = (key, val)=>{
            if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
                const { maxAge: maxAge } = props;
                if (maxAge !== undefined && $3e46065a4b1d2500$var$calculateEntryAge(val.timestamp) > maxAge) {
                    syncWithDevTools((0, $43a74598c9c16cf3$export$26d12233004a7a60), {
                        [String(key)]: val
                    });
                    cache.delete(key);
                    return true;
                }
            }
            return false;
        };
        const createStore = ()=>{
            if (props.storageType === (0, $43a74598c9c16cf3$export$2670cb7d5d4f7184)) storage = (0, (0, parcelRequire("bSSG7")).createLocalStorageProvider)((0, (0, parcelRequire("1NZBJ")).CACHE_PREFIX));
            else storage = (0, (0, parcelRequire("eNf8a")).createSessionStorageProvider)((0, (0, parcelRequire("1NZBJ")).CACHE_PREFIX));
            return storage;
        };
        const set = async (key, value)=>{
            await load();
            cache.delete(key);
            const entry = {
                value: value,
                timestamp: Date.now()
            };
            let storedContent = {};
            if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
                storedContent = storage.get(props.cacheKey) || {};
                storedContent[key] = entry;
            }
            cache.set(key, entry);
            syncWithDevTools((0, $43a74598c9c16cf3$export$5e8f180ef0142226), {
                [String(key)]: entry
            });
            if (cache.size > size) {
                const keys = cache.keys();
                const firstEntry = keys.next().value;
                if (firstEntry !== undefined) {
                    cache.delete(firstEntry);
                    syncWithDevTools((0, $43a74598c9c16cf3$export$a61768fefd33fcb1), firstEntry);
                    if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) delete storedContent[firstEntry];
                }
            }
            props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
        };
        const load = async ()=>{
            if (false || hasSyncedFromStorage) return;
            hasSyncedFromStorage = true;
            if (props.storageType === (0, $43a74598c9c16cf3$export$bf340b99118a1511)) return;
            const { cacheKey: cacheKey } = props;
            storage = createStore();
            try {
                let data = storage.get(cacheKey) || {};
                data = await removeExpiredKeysFromStorage(data);
                syncWithDevTools((0, $43a74598c9c16cf3$export$61f74127e2b53cbe), data);
                const orderedKeys = Object.keys(data).sort((key1, key2)=>data[key1].timestamp - data[key2].timestamp);
                await Promise.all(orderedKeys.map(async (key)=>{
                    await set(key, data[key].value);
                }));
            } catch (err) {
                (0, (0, parcelRequire("dJl1T")).default).safeWarnWithoutCustomerData((0, $43a74598c9c16cf3$export$7271276960377470), `There was an error syncing with storage - ${cacheKey}`, err);
                throw err;
            }
        };
        const clear = async ()=>{
            await load();
            cache.clear();
            if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
                const { cacheKey: cacheKey } = props;
                storage.remove(cacheKey);
            }
            syncWithDevTools((0, $43a74598c9c16cf3$export$6c4d37c7f376a1de), {});
        };
        const get = async (key)=>{
            await load();
            let val = cache.get(key);
            if (val) {
                if (removeExpiredEntry(key, val)) val = undefined;
            }
            syncWithDevTools((0, $43a74598c9c16cf3$export$1bb358554aac31c1), {
                [String(key)]: val
            });
            return val && val.value;
        };
        const update = async (key, value)=>{
            await load();
            const previousValue = cache.get(key);
            if (!previousValue) return;
            const entry = {
                value: value,
                timestamp: previousValue.timestamp
            };
            let storedContent = {};
            if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
                storedContent = storage.get(props.cacheKey) || {};
                storedContent[key] = entry;
            }
            cache.set(key, entry);
            syncWithDevTools((0, $43a74598c9c16cf3$export$e271b26eefe41db8), {
                [String(key)]: entry
            });
            props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
        };
        const getEntries = async ()=>{
            await load();
            const entries = Array.from(cache.entries()).filter(([key, value])=>!removeExpiredEntry(key, value));
            syncWithDevTools((0, $43a74598c9c16cf3$export$9eb68924983e00fb), entries);
            return entries.map(([key, { value: value }])=>[
                    key,
                    value
                ]);
        };
        const deleteEntry = async (key)=>{
            await load();
            if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
                const storedContent = storage.get(props.cacheKey) || {};
                delete storedContent[key];
                storage.set(props.cacheKey, storedContent);
            }
            cache.delete(key);
            syncWithDevTools((0, $43a74598c9c16cf3$export$4bd2facc4a3e6aa1), {
                [String(key)]: cache.get(key)
            });
        };
        const refresh = async ()=>{
            if (props.storageType === (0, $43a74598c9c16cf3$export$bf340b99118a1511)) return;
            cache.clear();
            hasSyncedFromStorage = false;
            await load();
        };
        if ((0, (0, parcelRequire("1NZBJ")).default).scopes.current !== (0, (0, parcelRequire("1NZBJ")).default).scopes.prev) clear();
        return {
            cache: cache,
            get: get,
            set: set,
            delete: deleteEntry,
            clear: clear,
            load: load,
            update: update,
            getEntries: getEntries,
            refresh: refresh
        };
    }
    const $3e46065a4b1d2500$var$cacheMap = {};
    const $3e46065a4b1d2500$var$getCache = async (props)=>{
        await (0, (0, parcelRequire("1NZBJ")).scopeGuard)().catch((error)=>{
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('common.cache.scope', 'There was a failure within cache scopeGuard', error);
        });
        const { cacheKey: cacheKey } = props;
        $3e46065a4b1d2500$var$cacheMap[cacheKey] = $3e46065a4b1d2500$var$cacheMap[cacheKey] || new $3e46065a4b1d2500$export$94affb487e701bf2(props);
        return $3e46065a4b1d2500$var$cacheMap[cacheKey];
    };
    const $3e46065a4b1d2500$export$710d301bf26d9700 = ()=>{
        Object.values($3e46065a4b1d2500$var$cacheMap).forEach((cache)=>cache.clear());
    };
    var $3e46065a4b1d2500$export$2e2bcd8739ae039 = $3e46065a4b1d2500$var$getCache;
});
parcelRegister("ilJEo", function(module, exports) {
    $parcel$export(module.exports, "fetchVersionDetails", ()=>$c5786df255f56b83$export$7148f3bfb84532da);
    var $dJl1T;
    var $jzXXL;
    var $iW95S;
    var $8C5lr;
    const $c5786df255f56b83$var$concurrentMetricDefinition = (0, (0, parcelRequire("8C5lr")).queryMetrics)[0, $8038b72ffd5aa8d4$export$ede40e627a0cbf14];
    const $c5786df255f56b83$var$analyticKey = 'jira.frontend.fe.software.roadmap.version-details';
    const $c5786df255f56b83$export$7148f3bfb84532da = (versionAri)=>(0, (0, parcelRequire("iW95S")).runQueryWithMetadataAndSelector)((0, (0, parcelRequire("jzXXL")).default), {
            versionAri: versionAri
        }, $c5786df255f56b83$var$analyticKey, $c5786df255f56b83$var$concurrentMetricDefinition, (data)=>data.jira.version).map(({ data: data })=>data).catch((error)=>{
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('getVersionDetails', 'getVersionDetails failed', error);
            throw error;
        });
});
parcelRegister("jzXXL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0701d745693a614f$export$2e2bcd8739ae039);
    const $0701d745693a614f$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "versionAri"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "versionAri"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v3 = {
            "kind": "ScalarField",
            "name": "versionId"
        }, v4 = {
            "kind": "ScalarField",
            "name": "description"
        }, v5 = {
            "kind": "ScalarField",
            "name": "startDate"
        }, v6 = {
            "kind": "ScalarField",
            "name": "releaseDate"
        }, v7 = [
            {
                "kind": "Literal",
                "name": "filter",
                "value": "TODO"
            }
        ], v8 = {
            "kind": "ScalarField",
            "name": "totalCount"
        }, v9 = [
            {
                "kind": "Literal",
                "name": "filter",
                "value": "IN_PROGRESS"
            }
        ], v10 = [
            {
                "kind": "Literal",
                "name": "filter",
                "value": "DONE"
            }
        ], v11 = [
            v8
        ];
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "versionDetailsQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v1,
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v2,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v3,
                                                    "action": "THROW",
                                                    "path": "jira.version.versionId"
                                                },
                                                v4,
                                                v5,
                                                v6,
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "alias": "todoIssues",
                                                        "args": v7,
                                                        "concreteType": "JiraIssueConnection",
                                                        "kind": "LinkedField",
                                                        "name": "issues",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v8,
                                                                "action": "THROW",
                                                                "path": "jira.version.todoIssues.totalCount"
                                                            }
                                                        ],
                                                        "storageKey": "issues(filter:\"TODO\")"
                                                    },
                                                    "action": "THROW",
                                                    "path": "jira.version.todoIssues"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "alias": "inProgressIssues",
                                                        "args": v9,
                                                        "concreteType": "JiraIssueConnection",
                                                        "kind": "LinkedField",
                                                        "name": "issues",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v8,
                                                                "action": "THROW",
                                                                "path": "jira.version.inProgressIssues.totalCount"
                                                            }
                                                        ],
                                                        "storageKey": "issues(filter:\"IN_PROGRESS\")"
                                                    },
                                                    "action": "THROW",
                                                    "path": "jira.version.inProgressIssues"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "alias": "doneIssues",
                                                        "args": v10,
                                                        "concreteType": "JiraIssueConnection",
                                                        "kind": "LinkedField",
                                                        "name": "issues",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v8,
                                                                "action": "THROW",
                                                                "path": "jira.version.doneIssues.totalCount"
                                                            }
                                                        ],
                                                        "storageKey": "issues(filter:\"DONE\")"
                                                    },
                                                    "action": "THROW",
                                                    "path": "jira.version.doneIssues"
                                                }
                                            ],
                                            "type": "JiraVersion"
                                        }
                                    ]
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "versionDetailsQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "kind": "LinkedField",
                                "name": "version",
                                "plural": false,
                                "selections": [
                                    v2,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v3,
                                            v4,
                                            v5,
                                            v6,
                                            {
                                                "alias": "todoIssues",
                                                "args": v7,
                                                "concreteType": "JiraIssueConnection",
                                                "kind": "LinkedField",
                                                "name": "issues",
                                                "plural": false,
                                                "selections": v11,
                                                "storageKey": "issues(filter:\"TODO\")"
                                            },
                                            {
                                                "alias": "inProgressIssues",
                                                "args": v9,
                                                "concreteType": "JiraIssueConnection",
                                                "kind": "LinkedField",
                                                "name": "issues",
                                                "plural": false,
                                                "selections": v11,
                                                "storageKey": "issues(filter:\"IN_PROGRESS\")"
                                            },
                                            {
                                                "alias": "doneIssues",
                                                "args": v10,
                                                "concreteType": "JiraIssueConnection",
                                                "kind": "LinkedField",
                                                "name": "issues",
                                                "plural": false,
                                                "selections": v11,
                                                "storageKey": "issues(filter:\"DONE\")"
                                            }
                                        ],
                                        "type": "JiraVersion"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "id"
                                            }
                                        ],
                                        "type": "Node",
                                        "abstractKey": "__isNode"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "16dbcd61c253daeede3a24c3baddf1a6ba9b5cc226a5184f833fdc8bbf4c31cf",
                "metadata": {},
                "name": "versionDetailsQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $0701d745693a614f$var$node.hash = "5d5e1bd006f223be75c2d70927a59808";
    var $0701d745693a614f$export$2e2bcd8739ae039 = $0701d745693a614f$var$node;
});
parcelRegister("fq1Gb", function(module, exports) {
    $parcel$export(module.exports, "transformVersionDetails", ()=>$1f147d16de2149aa$export$40f792aaeb1b9eb9);
    var $dRZss;
    var $9ux39;
    var $7Bdf2;
    var $l1Vjz;
    const $1f147d16de2149aa$export$40f792aaeb1b9eb9 = (version, { formatMessage: formatMessage })=>{
        if (version.__typename === 'JiraVersion') {
            const { versionId: id, description: description, startDate: startDate, releaseDate: releaseDate, todoIssues: todoIssues, inProgressIssues: inProgressIssues, doneIssues: doneIssues } = version;
            const progress = [
                {
                    id: `version-${id}-in-progress`,
                    name: formatMessage((0, (0, parcelRequire("l1Vjz")).default).inProgress),
                    count: inProgressIssues.totalCount,
                    color: (0, (0, parcelRequire("dRZss")).IN_PROGRESS_COLOR_HIGHER_CONTRAST)
                },
                {
                    id: `version-${id}-done`,
                    name: formatMessage((0, (0, parcelRequire("l1Vjz")).default).done),
                    count: doneIssues.totalCount,
                    color: (0, (0, parcelRequire("dRZss")).DONE_COLOR_HIGHER_CONTRAST)
                },
                {
                    id: `version-${id}-todo`,
                    name: formatMessage((0, (0, parcelRequire("l1Vjz")).default).todo),
                    count: todoIssues.totalCount,
                    color: (0, (0, parcelRequire("dRZss")).TODO_COLOR_HIGHER_CONTRAST)
                }
            ];
            return {
                id: id,
                description: description || '',
                startDate: (0, (0, parcelRequire("9ux39")).optionalDateToUtcTimestamp)((0, (0, parcelRequire("7Bdf2")).nullableToOptional)(startDate)),
                releaseDate: (0, (0, parcelRequire("9ux39")).optionalDateToUtcTimestamp)((0, (0, parcelRequire("7Bdf2")).nullableToOptional)(releaseDate)),
                progress: progress
            };
        }
        throw new Error(`Invalid version type: ${version.__typename}`);
    };
});
parcelRegister("dRZss", function(module, exports) {
    $parcel$export(module.exports, "TODO_COLOR_HIGHER_CONTRAST", ()=>$c58b160e0f53b369$export$8a8f905ccf4b0050);
    $parcel$export(module.exports, "IN_PROGRESS_COLOR_HIGHER_CONTRAST", ()=>$c58b160e0f53b369$export$15757ae585322101);
    $parcel$export(module.exports, "DONE_COLOR_HIGHER_CONTRAST", ()=>$c58b160e0f53b369$export$b718e067b2a5f1e5);
    const $c58b160e0f53b369$export$9a2ce699a8e88c00 = `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`;
    const $c58b160e0f53b369$export$8a8f905ccf4b0050 = `var(--ds-border, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`;
    const $c58b160e0f53b369$export$dc4e31a90347554e = `var(--ds-text-information, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`;
    const $c58b160e0f53b369$export$15757ae585322101 = `var(--ds-border-information, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`;
    const $c58b160e0f53b369$export$f2a648c26a91297f = `var(--ds-background-success-bold, ${(0, $829f609a65d26a98$export$940e1f69e873f202)})`;
    const $c58b160e0f53b369$export$b718e067b2a5f1e5 = `var(--ds-border-success, ${(0, $829f609a65d26a98$export$940e1f69e873f202)})`;
});
parcelRegister("l1Vjz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d1ca3bf22742fb6f$export$2e2bcd8739ae039);
    var $7VHMR;
    var $d1ca3bf22742fb6f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        todo: {
            "id": "software-roadmap-services.version.todo",
            "defaultMessage": "To Do"
        },
        inProgress: {
            "id": "software-roadmap-services.version.in-progress",
            "defaultMessage": "In Progress"
        },
        done: {
            "id": "software-roadmap-services.version.done",
            "defaultMessage": "Done"
        }
    });
});
parcelRegister("fLnKW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$71406f5dde6fd76b$export$2e2bcd8739ae039);
    var $h6Poe;
    var $56lBM;
    var $gvqFp;
    var $13PLy;
    var $71406f5dde6fd76b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("h6Poe")).combineStorage)((0, (0, parcelRequire("56lBM")).default), (0, (0, parcelRequire("13PLy")).default), (0, (0, parcelRequire("gvqFp")).default));
});
parcelRegister("h6Poe", function(module, exports) {
    $parcel$export(module.exports, "defineSimpleStorage", ()=>$4508f81cceceb129$export$b3e4b068c8b91397);
    $parcel$export(module.exports, "combineStorage", ()=>$4508f81cceceb129$export$2d3e45efc84ee30f);
    parcelRequire("aSIuP");
    parcelRequire("fp4O3");
    var $65i0E = parcelRequire("65i0E");
    var $lbWm4 = parcelRequire("lbWm4");
    var $ajpes = parcelRequire("ajpes");
    var $icGZu = parcelRequire("icGZu");
    var $kVLXA = parcelRequire("kVLXA");
    const $4508f81cceceb129$export$94c6bb4af8700ddd = (requestedStorageKeys, hydrationActionCreator, stateConnector, transformer)=>{
        let memoizedProps;
        const isModified = (newProps)=>(0, ($parcel$interopDefault($icGZu)))(newProps, (val, key)=>!memoizedProps || !memoizedProps[key] || !(0, ($parcel$interopDefault($ajpes)))(memoizedProps[key], val));
        return {
            hydrate: (state, engine)=>{
                const params = [];
                (0, ($parcel$interopDefault($lbWm4)))(requestedStorageKeys(state), (storageKey)=>{
                    params.push(engine.get(storageKey));
                });
                if (params.length === 0) return (0, $kVLXA.Observable).of([]);
                return (0, $kVLXA.Observable).zip(...params, (args)=>{
                    const { value: currentValue } = stateConnector(state);
                    if (args !== null && !(0, ($parcel$interopDefault($ajpes)))(args, currentValue)) return (0, ($parcel$interopDefault($65i0E)))([
                        hydrationActionCreator(args)
                    ]);
                    return [];
                });
            },
            modify: (state, engine)=>{
                const props = stateConnector(state);
                if (!engine.allowsModificationWithoutHydration && memoizedProps === undefined) memoizedProps = props;
                else if (isModified(props)) {
                    const transformed = transformer(props);
                    (0, ($parcel$interopDefault($lbWm4)))(transformed, (prop, key)=>engine.set(key, prop));
                    memoizedProps = props;
                }
            }
        };
    };
    const $4508f81cceceb129$export$b3e4b068c8b91397 = (key, hydrationActionCreator, stateConnector)=>$4508f81cceceb129$export$94c6bb4af8700ddd(()=>[
                key()
            ], hydrationActionCreator, (state)=>({
                value: stateConnector(state)
            }), (t)=>({
                [key()]: t.value
            }));
    const $4508f81cceceb129$export$2d3e45efc84ee30f = (...storageConfigs)=>({
            hydrate: (state, engine)=>{
                const hydrations = [];
                (0, ($parcel$interopDefault($lbWm4)))(storageConfigs, (def)=>{
                    hydrations.push(def.hydrate(state, engine));
                });
                const flat = (0, ($parcel$interopDefault($65i0E)))(hydrations);
                if (flat.length === 0) return (0, $kVLXA.Observable).of([]);
                return (0, $kVLXA.Observable).zip(...flat, (...hydrationActions)=>(0, ($parcel$interopDefault($65i0E)))(hydrationActions));
            },
            modify: (state, engine)=>{
                (0, ($parcel$interopDefault($lbWm4)))(storageConfigs, (def)=>{
                    def.modify(state, engine);
                });
            }
        });
});
parcelRegister("65i0E", function(module, exports) {
    var $ekcP3 = parcelRequire("ekcP3");
    var $46e12e07abca6e43$var$INFINITY = 1 / 0;
    function $46e12e07abca6e43$var$flattenDeep(array) {
        var length = array == null ? 0 : array.length;
        return length ? $ekcP3(array, $46e12e07abca6e43$var$INFINITY) : [];
    }
    module.exports = $46e12e07abca6e43$var$flattenDeep;
});
parcelRegister("icGZu", function(module, exports) {
    var $2k3l6 = parcelRequire("2k3l6");
    var $bxDef = parcelRequire("bxDef");
    var $6kYP8 = parcelRequire("6kYP8");
    var $8LQ84 = parcelRequire("8LQ84");
    var $4rDUz = parcelRequire("4rDUz");
    function $d40ab2104a331ebd$var$some(collection, predicate, guard) {
        var func = $8LQ84(collection) ? $2k3l6 : $6kYP8;
        if (guard && $4rDUz(collection, predicate, guard)) predicate = undefined;
        return func(collection, $bxDef(predicate, 3));
    }
    module.exports = $d40ab2104a331ebd$var$some;
});
parcelRegister("6kYP8", function(module, exports) {
    var $e7pfQ = parcelRequire("e7pfQ");
    function $49d3cab0435826ab$var$baseSome(collection, predicate) {
        var result;
        $e7pfQ(collection, function(value, index, collection) {
            result = predicate(value, index, collection);
            return !result;
        });
        return !!result;
    }
    module.exports = $49d3cab0435826ab$var$baseSome;
});
parcelRegister("56lBM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6f695b5d9f8d33ed$export$2e2bcd8739ae039);
    var $h6Poe;
    var $fk6Dx;
    var $eNNpZ;
    var $d8jp7;
    var $kHNkE;
    var $fr6RD;
    var $5qeAc;
    var $6f695b5d9f8d33ed$export$2e2bcd8739ae039 = (0, (0, parcelRequire("h6Poe")).combineStorage)((0, (0, parcelRequire("fr6RD")).default), (0, (0, parcelRequire("fk6Dx")).default), (0, (0, parcelRequire("d8jp7")).default), (0, (0, parcelRequire("5qeAc")).default), (0, (0, parcelRequire("kHNkE")).default), (0, (0, parcelRequire("eNNpZ")).default));
});
parcelRegister("fk6Dx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9a39bcfe4c64fe7d$export$2e2bcd8739ae039);
    var $h6Poe;
    var $hhYQB;
    var $ilGit;
    var $9a39bcfe4c64fe7d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("h6Poe")).defineSimpleStorage)(()=>'isDependenciesVisible', (isVisible)=>isVisible === null ? [] : [
            (0, (0, parcelRequire("ilGit")).setDependenciesViewVisibility)(isVisible)
        ], (state)=>(0, (0, parcelRequire("hhYQB")).isDependenciesVisible)(state));
});
parcelRegister("eNNpZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d9df4c3e6b6629bd$export$2e2bcd8739ae039);
    var $h6Poe;
    var $hhYQB;
    var $ilGit;
    var $d9df4c3e6b6629bd$export$2e2bcd8739ae039 = (0, (0, parcelRequire("h6Poe")).defineSimpleStorage)(()=>'levelOneViewSettings', (levelOneSetting)=>levelOneSetting === null ? [] : [
            (0, (0, parcelRequire("ilGit")).setLevelOneSetting)(levelOneSetting)
        ], (state)=>(0, (0, parcelRequire("hhYQB")).getLevelOneSetting)(state));
});
parcelRegister("d8jp7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ffe3907481fffc8c$export$2e2bcd8739ae039);
    var $h6Poe;
    var $ilGit;
    var $2VUTz;
    var $ffe3907481fffc8c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("h6Poe")).defineSimpleStorage)(()=>'isProgressVisible', (isVisible)=>isVisible === null ? [] : [
            (0, (0, parcelRequire("ilGit")).setProgressVisibility)(isVisible)
        ], (state)=>(0, (0, parcelRequire("2VUTz")).isProgressVisibleInView)(state));
});
parcelRegister("kHNkE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f369afa503165c69$export$2e2bcd8739ae039);
    var $h6Poe;
    var $ilGit;
    var $2VUTz;
    var $f369afa503165c69$export$2e2bcd8739ae039 = (0, (0, parcelRequire("h6Poe")).defineSimpleStorage)(()=>'isReleasesVisible', (isVisible)=>isVisible === null ? [] : [
            (0, (0, parcelRequire("ilGit")).setReleasesVisibility)(isVisible)
        ], (state)=>(0, (0, parcelRequire("2VUTz")).isReleasesVisibleInView)(state));
});
parcelRegister("fr6RD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a404c45ad3ff0b9b$export$2e2bcd8739ae039);
    var $h6Poe;
    var $hhYQB;
    var $9QFr0;
    var $a404c45ad3ff0b9b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("h6Poe")).defineSimpleStorage)(()=>'timelineMode', (timelineMode)=>timelineMode === null ? [] : [
            (0, (0, parcelRequire("9QFr0")).setTimelineMode)(timelineMode)
        ], (state)=>(0, (0, parcelRequire("hhYQB")).getTimelineMode)(state));
});
parcelRegister("5qeAc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$525af7360f261b6b$export$2e2bcd8739ae039);
    var $h6Poe;
    var $ilGit;
    var $2VUTz;
    var $525af7360f261b6b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("h6Poe")).defineSimpleStorage)(()=>'isWarningsVisible', (isVisible)=>isVisible === null ? [] : [
            (0, (0, parcelRequire("ilGit")).setWarningsVisibility)(isVisible)
        ], (state)=>(0, (0, parcelRequire("2VUTz")).isWarningsVisibleInView)(state));
});
parcelRegister("gvqFp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c57d3a8fdf34fc57$export$2e2bcd8739ae039);
    var $h6Poe;
    var $uWMNw;
    var $c57d3a8fdf34fc57$export$2e2bcd8739ae039 = (0, (0, parcelRequire("h6Poe")).combineStorage)((0, (0, parcelRequire("uWMNw")).default));
});
parcelRegister("uWMNw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$af09b8a5a6fc59b6$export$2e2bcd8739ae039);
    var $h6Poe;
    var $k6Vft;
    var $5IiTZ;
    var $af09b8a5a6fc59b6$export$2e2bcd8739ae039 = (0, (0, parcelRequire("h6Poe")).defineSimpleStorage)(()=>'issuePanelRatio', (issuePanelRatio)=>issuePanelRatio ? [
            (0, (0, parcelRequire("k6Vft")).setIssuePanelRatio)(issuePanelRatio)
        ] : [], (state)=>(0, (0, parcelRequire("5IiTZ")).getIssuePanelRatio)(state) || null);
});
parcelRegister("13PLy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6304e38a6b415ff0$export$2e2bcd8739ae039);
    var $h6Poe;
    var $lIvut;
    var $i7Jvf;
    var $1sug4;
    var $6304e38a6b415ff0$export$2e2bcd8739ae039 = (0, (0, parcelRequire("h6Poe")).combineStorage)((0, (0, parcelRequire("lIvut")).default), (0, (0, parcelRequire("1sug4")).default), (0, (0, parcelRequire("i7Jvf")).default));
});
parcelRegister("lIvut", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bae7e4fd4f549aa0$export$2e2bcd8739ae039);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $lbWm4 = parcelRequire("lbWm4");
    var $h6Poe;
    var $4gYYI;
    var $k6Vft;
    var $5IiTZ;
    const $bae7e4fd4f549aa0$var$STORAGE_KEY = 'creationPreferences';
    const $bae7e4fd4f549aa0$var$transformCreationPreferences = (creationPreferences, issueTypes)=>{
        const itemTypes = {};
        const safeCreationPreferences = {
            itemTypes: itemTypes
        };
        (0, ($parcel$interopDefault($lbWm4)))(creationPreferences.itemTypes, (preference, level)=>{
            if (issueTypes[preference.itemTypeId]) itemTypes[level] = preference;
        });
        safeCreationPreferences.itemTypes = itemTypes;
        return safeCreationPreferences;
    };
    const $bae7e4fd4f549aa0$var$mappedPreference = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("5IiTZ")).getCreationPreferences), (0, (0, parcelRequire("4gYYI")).getFullIssueTypeHash), $bae7e4fd4f549aa0$var$transformCreationPreferences);
    var $bae7e4fd4f549aa0$export$2e2bcd8739ae039 = (0, (0, parcelRequire("h6Poe")).defineSimpleStorage)(()=>$bae7e4fd4f549aa0$var$STORAGE_KEY, (creationPreferences)=>creationPreferences === null ? [] : [
            (0, (0, parcelRequire("k6Vft")).setCreationPreferences)(creationPreferences)
        ], (state)=>$bae7e4fd4f549aa0$var$mappedPreference(state));
});
parcelRegister("i7Jvf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ace57992cf3fd2af$export$2e2bcd8739ae039);
    var $h6Poe;
    var $3rLbe;
    var $k6Vft;
    var $ace57992cf3fd2af$export$2e2bcd8739ae039 = (0, (0, parcelRequire("h6Poe")).defineSimpleStorage)(()=>'highlightedVersions', (highlightedVersions)=>highlightedVersions === null ? [] : [
            (0, (0, parcelRequire("k6Vft")).setHighlightedVersions)(highlightedVersions)
        ], (state)=>(0, (0, parcelRequire("3rLbe")).getHighlightedVersions)(state));
});
parcelRegister("1sug4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f873c6c095b461c0$export$2e2bcd8739ae039);
    var $h6Poe;
    var $k6Vft;
    var $5IiTZ;
    var $f873c6c095b461c0$export$2e2bcd8739ae039 = (0, (0, parcelRequire("h6Poe")).defineSimpleStorage)(()=>'listWidth', (listWidth)=>listWidth === null ? [] : [
            (0, (0, parcelRequire("k6Vft")).setListWidth)(listWidth)
        ], (state)=>(0, (0, parcelRequire("5IiTZ")).getListWidth)(state));
});
parcelRegister("cvFzo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e77de91a4a9544c6$export$2e2bcd8739ae039);
    var $F2Mxm;
    var $g3qyq;
    var $eKt4x;
    var $hb2iR;
    var $a6j9d;
    var $ewja9;
    var $e77de91a4a9544c6$export$2e2bcd8739ae039 = (type, rootEpic, rootEpicDependencies)=>{
        const middlewares = [
            (0, (0, parcelRequire("g3qyq")).default)((0, (0, parcelRequire("eKt4x")).toRoadmapAppId)(type), (0, (0, parcelRequire("hb2iR")).generalError)),
            (0, (0, parcelRequire("a6j9d")).default)
        ];
        return (0, (0, parcelRequire("F2Mxm")).default)({
            appName: (0, (0, parcelRequire("eKt4x")).toRoadmapAppId)(type),
            rootReducer: (0, parcelRequire("ewja9")).default,
            rootEpic: rootEpic,
            rootEpicDependencies: rootEpicDependencies,
            middlewares: middlewares
        });
    };
});
parcelRegister("g3qyq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4c091411acc86b19$export$2e2bcd8739ae039);
    var $dJl1T;
    var $iR96x;
    const $4c091411acc86b19$var$errorHandling = (appId, errorActionCreator, onError)=>()=>(next)=>(action)=>{
                    try {
                        next(action);
                    } catch (error) {
                        const fullLocation = `common.redux-error.${appId}`;
                        (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData(fullLocation, `Unhandled error for Redux action: '${action?.type}'`, error);
                        (0, (0, parcelRequire("iR96x")).captureException)(fullLocation, error);
                        errorActionCreator && next(errorActionCreator());
                        onError && onError(error);
                    }
                };
    var $4c091411acc86b19$export$2e2bcd8739ae039 = $4c091411acc86b19$var$errorHandling;
});
parcelRegister("a6j9d", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$04fc5276dd9567ab$export$2e2bcd8739ae039);
    var $hi6AJ;
    var $jAJAx;
    var $50Z4W;
    var $fe0Qy;
    var $1VLi2;
    var $4hao7;
    var $3unH6;
    var $k6Vft;
    var $9QFr0;
    var $jJEyp;
    var $gFEKp;
    var $fVm8c;
    var $lEiof;
    const $04fc5276dd9567ab$var$ELIGIBLE_FOR_INVALIDATION = /^(state\.).+$/;
    const $04fc5276dd9567ab$var$ROADMAP_IGNORE_REGEX = /^(state\.flags\.).+$/;
    const $04fc5276dd9567ab$export$d4b7dead01a52ae = ({ type: type })=>{
        switch(type){
            case 0, (0, parcelRequire("jAJAx")).INITIALIZE_APP_PROPS:
            case 0, (0, parcelRequire("jAJAx")).INITIALIZE_CRITICAL_DATA:
            case 0, (0, parcelRequire("jAJAx")).INITIALIZE_NON_CRITICAL_DATA:
            case 0, (0, parcelRequire("jAJAx")).UPDATE_CRITICAL_DATA:
            case 0, (0, parcelRequire("k6Vft")).SET_SETTINGS:
            case 0, (0, parcelRequire("50Z4W")).SET_CONFIGURATION:
            case 0, (0, parcelRequire("50Z4W")).SET_TODAY:
            case 0, (0, parcelRequire("50Z4W")).SET_DERIVE_FIELDS:
            case 0, (0, parcelRequire("50Z4W")).DERIVE_FIELDS_REQUEST:
            case 0, (0, parcelRequire("lEiof")).SET_CREATE_ITEM_ANCHOR:
            case 0, (0, parcelRequire("lEiof")).RESET_CREATE_ITEM_ANCHOR:
            case 0, (0, parcelRequire("1VLi2")).EXTEND_ISSUES:
            case 0, (0, parcelRequire("4hao7")).MERGE_STATUS_CATEGORIES:
            case 0, (0, parcelRequire("9QFr0")).SET_TEXT_FILTER:
            case 0, (0, parcelRequire("9QFr0")).CLEAR_FILTER:
            case 0, (0, parcelRequire("9QFr0")).SET_ISSUE_TYPE_FILTER:
            case 0, (0, parcelRequire("9QFr0")).SET_LABEL_FILTER:
            case 0, (0, parcelRequire("9QFr0")).SET_ISSUE_PARENT_FILTER:
            case 0, (0, parcelRequire("9QFr0")).SET_VERSION_FILTER:
            case 0, (0, parcelRequire("9QFr0")).SET_COMPONENT_FILTER:
            case 0, (0, parcelRequire("9QFr0")).SET_QUICK_FILTERS_FILTER:
            case 0, (0, parcelRequire("9QFr0")).QUICK_FILTERS_REQUEST:
            case 0, (0, parcelRequire("9QFr0")).JQL_FILTERS_SUCCESS:
            case 0, (0, parcelRequire("9QFr0")).QUICK_FILTERS_CLEAR:
            case 0, (0, parcelRequire("9QFr0")).SET_CUSTOM_FILTER:
            case 0, (0, parcelRequire("9QFr0")).CUSTOM_FILTERS_CLEAR:
            case 0, (0, parcelRequire("9QFr0")).SET_ASSIGNEE_FILTER:
            case 0, (0, parcelRequire("9QFr0")).SET_STATUS_CATEGORY_FILTER:
            case 0, (0, parcelRequire("9QFr0")).SET_FILTER_CONFIGURATION:
            case 0, (0, parcelRequire("fVm8c")).SET_SHARED:
            case 0, (0, parcelRequire("lEiof")).CHANGE_EXPANSION_STATE:
            case 0, (0, parcelRequire("lEiof")).SHOW_TOOLTIP:
            case 0, (0, parcelRequire("lEiof")).HIDE_TOOLTIP:
            case 0, (0, parcelRequire("gFEKp")).SHOW_ISSUE_DETAILS:
            case 0, (0, parcelRequire("gFEKp")).HIDE_PANEL:
            case 0, (0, parcelRequire("gFEKp")).SET_SELECTED_ISSUE:
            case 0, (0, parcelRequire("3unH6")).REALTIME_DISPATCH_EVENT:
            case 0, (0, parcelRequire("jJEyp")).EXTEND_ISSUE_TYPE_COUNT:
            case 0, (0, parcelRequire("jJEyp")).RETRIEVE_ISSUE_TYPE_COUNT:
            case 0, (0, parcelRequire("jJEyp")).SET_RESOLVING:
            case 0, (0, parcelRequire("jJEyp")).RESOLVE:
            case 0, (0, parcelRequire("fe0Qy")).SET_GOALS:
            case 0, (0, parcelRequire("9QFr0")).SET_GOAL_FILTER:
                return false;
            default:
                break;
        }
        if (!$04fc5276dd9567ab$var$ELIGIBLE_FOR_INVALIDATION.exec(type) || $04fc5276dd9567ab$var$ROADMAP_IGNORE_REGEX.exec(type)) return false;
        return true;
    };
    var $04fc5276dd9567ab$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hi6AJ")).default)((0, $8631d6ce464ccf2e$export$ffff0a2c60bf4822), $04fc5276dd9567ab$export$d4b7dead01a52ae);
});
parcelRegister("hi6AJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1904eee7acf3b502$export$2e2bcd8739ae039);
    var $b0yad;
    const $1904eee7acf3b502$export$41c940a04807c68c = (subject)=>(origin, invalidationFunction)=>()=>(next)=>(action)=>{
                        if (action && invalidationFunction(action)) {
                            subject.next(origin);
                            (0, (0, parcelRequire("b0yad")).addInvalidationReason)(origin, action.type ?? 'UNKNOWN');
                        }
                        return next(action);
                    };
    var $1904eee7acf3b502$export$2e2bcd8739ae039 = $1904eee7acf3b502$export$41c940a04807c68c((0, (0, parcelRequire("b0yad")).default));
});
parcelRegister("ewja9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e266279d3a506345$export$2e2bcd8739ae039);
    var $3f2cs = parcelRequire("3f2cs");
    var $iVyJ0;
    var $99xSN;
    var $bElfy;
    var $2fDos;
    var $gqKcv;
    var $81ggD;
    var $e962v;
    var $e266279d3a506345$export$2e2bcd8739ae039 = (0, $3f2cs.combineReducers)({
        app: (0, parcelRequire("iVyJ0")).default,
        configuration: (0, parcelRequire("99xSN")).default,
        entities: (0, parcelRequire("bElfy")).default,
        ui: (0, parcelRequire("e962v")).default,
        router: (0, parcelRequire("gqKcv")).default,
        settings: (0, parcelRequire("81ggD")).default,
        metadata: (0, parcelRequire("2fDos")).default
    });
});
parcelRegister("iVyJ0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bf7df898a9198bfa$export$2e2bcd8739ae039);
    var $dXq4S;
    var $jAJAx;
    const $bf7df898a9198bfa$var$sourceAri = (0, (0, parcelRequire("dXq4S")).createAri)({
        resourceOwner: '',
        cloudId: '',
        resourceType: 'board',
        resourceId: ''
    });
    const $bf7df898a9198bfa$var$defaultState = {
        boardId: 0,
        loggedInAccountId: '',
        cloudId: undefined,
        activationId: undefined,
        sourceAri: $bf7df898a9198bfa$var$sourceAri,
        isReadOnly: false,
        macroConfig: undefined,
        type: (0, $f1ec00c5efd4c816$export$296f840b5ae7056e),
        containerName: ''
    };
    var $bf7df898a9198bfa$export$2e2bcd8739ae039 = (state = $bf7df898a9198bfa$var$defaultState, action)=>{
        switch(action.type){
            case 0, (0, parcelRequire("jAJAx")).INITIALIZE_APP_PROPS:
                return {
                    ...state,
                    ...action.payload
                };
            default:
                {
                    const _exhaustiveCheck = action.type;
                    return state;
                }
        }
    };
});
parcelRegister("99xSN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6b626eb5446b4d1e$export$2e2bcd8739ae039);
    var $50Z4W;
    const $6b626eb5446b4d1e$var$initialState = {
        today: 0,
        rankIssuesSupported: false,
        isCrossProject: false,
        startDateCustomFieldId: '',
        lexoRankCustomFieldId: '',
        colorCustomFieldId: '',
        epicLinkCustomFieldId: '',
        epicNameCustomFieldId: '',
        sprintCustomFieldId: '',
        inwardDependencyDescription: undefined,
        outwardDependencyDescription: undefined,
        dependenciesSupported: false,
        projectConfiguration: {
            id: '',
            key: '',
            name: '',
            permissions: {
                canEditIssues: false,
                canScheduleIssues: false,
                canCreateIssues: false,
                canAdministerProjects: false
            },
            epicIssueTypeIds: [],
            requiredFields: {},
            issueTypes: {
                hash: {}
            },
            versions: {
                hash: {}
            },
            components: {
                hash: {}
            },
            defaultItemTypeId: undefined,
            isReleasesFeatureEnabled: false,
            isGoalsFeatureEnabled: false
        },
        boardConfiguration: {
            isUserBoardAdmin: false,
            jql: null,
            isBoardJqlFilteringOutEpics: false,
            isSprintsFeatureEnabled: false,
            isChildIssuePlanningEnabled: false,
            sprints: {
                hash: {},
                sequence: []
            },
            childIssuePlanningMode: (0, $5c67f944abd2f8af$export$8cd212c10b4124d2)
        },
        hierarchyConfiguration: {
            levelOneName: ''
        },
        deriveFields: {},
        fields: [],
        canInviteOthersToProject: false
    };
    var $6b626eb5446b4d1e$export$2e2bcd8739ae039 = (state = $6b626eb5446b4d1e$var$initialState, action)=>{
        switch(action.type){
            case 0, (0, parcelRequire("50Z4W")).SET_CONFIGURATION:
                return action.payload;
            case 0, (0, parcelRequire("50Z4W")).SET_TODAY:
                return {
                    ...state,
                    today: action.payload
                };
            case 0, (0, parcelRequire("50Z4W")).SET_COMPONENTS:
                {
                    const { components: components } = action.payload;
                    const project = state.projectConfiguration;
                    return {
                        ...state,
                        projectConfiguration: {
                            ...project,
                            components: {
                                hash: components
                            }
                        }
                    };
                }
            case 0, (0, parcelRequire("50Z4W")).SET_VERSION:
                {
                    const { projectConfiguration: projectConfiguration } = state;
                    const { hash: versionHash } = projectConfiguration?.versions ?? {};
                    const { id: id, ...version } = action.payload;
                    return {
                        ...state,
                        projectConfiguration: {
                            ...projectConfiguration,
                            versions: {
                                hash: {
                                    ...versionHash,
                                    [id]: version
                                }
                            }
                        }
                    };
                }
            case 0, (0, parcelRequire("50Z4W")).SET_DERIVE_FIELDS:
                return {
                    ...state,
                    deriveFields: action.payload
                };
            case 0, (0, parcelRequire("50Z4W")).SET_SPRINT:
                {
                    const { boardConfiguration: boardConfiguration } = state;
                    const { hash: sprintHash, sequence: sprintSequence } = boardConfiguration?.sprints ?? {};
                    const sprint = action.payload;
                    return {
                        ...state,
                        boardConfiguration: {
                            ...boardConfiguration,
                            sprints: {
                                hash: {
                                    ...sprintHash,
                                    [sprint.id]: sprint
                                },
                                sequence: sprintSequence
                            }
                        }
                    };
                }
            case 0, (0, parcelRequire("50Z4W")).SET_CAN_USER_INVITE:
                return {
                    ...state,
                    canInviteOthersToProject: action.payload.canInviteOthersToProject
                };
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("bElfy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cded1d96ce6529db$export$2e2bcd8739ae039);
    var $3f2cs = parcelRequire("3f2cs");
    var $lHEM2;
    var $h6G4z;
    var $4xIRd;
    var $4PSmp;
    var $9UOy8;
    var $fhRQD;
    var $cded1d96ce6529db$export$2e2bcd8739ae039 = (0, $3f2cs.combineReducers)({
        issues: (0, parcelRequire("4xIRd")).default,
        statusCategories: (0, parcelRequire("4PSmp")).default,
        users: (0, parcelRequire("fhRQD")).default,
        globalIssueCreate: (0, parcelRequire("lHEM2")).default,
        subtasks: (0, parcelRequire("9UOy8")).default,
        goals: (0, parcelRequire("h6G4z")).default
    });
});
parcelRegister("lHEM2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4337cc1137ba2706$export$2e2bcd8739ae039);
    var $gsBJe;
    const $4337cc1137ba2706$var$initialState = {
        payloadGIC: undefined
    };
    var $4337cc1137ba2706$export$2e2bcd8739ae039 = (state = $4337cc1137ba2706$var$initialState, action)=>{
        switch(action.type){
            case 0, (0, parcelRequire("gsBJe")).ADD_PAYLOAD_GLOBAL_ISSUE_CREATE:
                return {
                    ...state,
                    payloadGIC: action.payload
                };
            case 0, (0, parcelRequire("gsBJe")).CLEAR_PAYLOAD_GLOBAL_ISSUE_CREATE:
                return {
                    ...state,
                    payloadGIC: undefined
                };
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("h6G4z", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$846339ac9557dce8$export$2e2bcd8739ae039);
    var $fe0Qy;
    const $846339ac9557dce8$var$NO_GOALS = {};
    const $846339ac9557dce8$var$initialState = {
        isLoaded: false,
        hash: $846339ac9557dce8$var$NO_GOALS
    };
    var $846339ac9557dce8$export$2e2bcd8739ae039 = (state = $846339ac9557dce8$var$initialState, action)=>{
        switch(action.type){
            case 0, (0, parcelRequire("fe0Qy")).SET_GOALS:
                return {
                    isLoaded: true,
                    hash: action.payload
                };
            default:
                {
                    const _exhaustiveCheck = action.type;
                    return state;
                }
        }
    };
});
parcelRegister("4xIRd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d9d0c48f37637e53$export$2e2bcd8739ae039);
    var $fr1K2 = parcelRequire("fr1K2");
    var $4f8Oj = parcelRequire("4f8Oj");
    var $dDkmN = parcelRequire("dDkmN");
    var $kGsr8 = parcelRequire("kGsr8");
    var $hqTkp = parcelRequire("hqTkp");
    var $iZN6h;
    var $1VLi2;
    const $d9d0c48f37637e53$var$initialState = {
        sequence: [],
        hash: {}
    };
    const $d9d0c48f37637e53$var$clearTransitionForField = (field, transitionId)=>{
        if ('transitionId' in field && field.transitionId === transitionId) return {
            value: field.value
        };
        return field;
    };
    const $d9d0c48f37637e53$var$resetTransitionForField = (field, transitionId)=>{
        if ('transitionId' in field && field.transitionId === transitionId) return {
            value: field.old
        };
        return field;
    };
    var $d9d0c48f37637e53$export$2e2bcd8739ae039 = (state = $d9d0c48f37637e53$var$initialState, action)=>{
        switch(action.type){
            case 0, (0, parcelRequire("1VLi2")).EXTEND_ISSUES:
                {
                    const { payload: payload } = action;
                    return {
                        sequence: (0, ($parcel$interopDefault($dDkmN)))(state.sequence, payload.sequence),
                        hash: {
                            ...state.hash,
                            ...payload.hash
                        }
                    };
                }
            case 0, (0, parcelRequire("1VLi2")).UPDATE_ISSUES_SEQUENCE:
                {
                    const { payload: payload } = action;
                    return {
                        sequence: payload,
                        hash: state.hash
                    };
                }
            case 0, (0, parcelRequire("1VLi2")).UPDATE_ISSUES_HASH_AND_SEQUENCE:
                {
                    const { payload: payload } = action;
                    return {
                        sequence: payload.sequence,
                        hash: payload.hash
                    };
                }
            case 0, (0, parcelRequire("1VLi2")).REMOVE_ISSUE:
                return {
                    sequence: (0, ($parcel$interopDefault($hqTkp)))(state.sequence, action.payload),
                    hash: (0, ($parcel$interopDefault($4f8Oj)))(state.hash, (item, key)=>key !== action.payload)
                };
            case 0, (0, parcelRequire("1VLi2")).REMOVE_ISSUES:
                return {
                    sequence: (0, ($parcel$interopDefault($hqTkp)))(state.sequence, ...action.payload),
                    hash: (0, ($parcel$interopDefault($4f8Oj)))(state.hash, (item, key)=>!action.payload.includes(key))
                };
            case 0, (0, parcelRequire("1VLi2")).INSERT_ISSUE:
                {
                    const { id: id, issue: issue, anchor: anchor } = action.payload;
                    const sequence = [
                        ...state.sequence
                    ];
                    if (anchor.position === (0, (0, parcelRequire("iZN6h")).LAST) || anchor.position === (0, (0, parcelRequire("iZN6h")).INSIDE)) sequence.push(id);
                    else sequence.splice(anchor?.beforeId ? sequence.indexOf(anchor.beforeId) : -1, 0, id);
                    return {
                        sequence: sequence,
                        hash: {
                            ...state.hash,
                            [`${id}`]: issue
                        }
                    };
                }
            case 0, (0, parcelRequire("1VLi2")).REPLACE_ISSUE:
                {
                    const { temporaryId: temporaryId, id: id, issue: issue } = action.payload;
                    return {
                        sequence: state.sequence.map((existingId)=>existingId === temporaryId ? id : existingId),
                        hash: {
                            ...(0, ($parcel$interopDefault($fr1K2)))(state.hash, [
                                temporaryId
                            ]),
                            [`${id}`]: issue
                        }
                    };
                }
            case 0, (0, parcelRequire("1VLi2")).RANK_ISSUE:
                {
                    const { issueId: issueId, rankRequest: rankRequest } = action.payload;
                    const { sequence: sequence } = state;
                    let anchorId;
                    let isBefore = true;
                    if ('rankBeforeId' in rankRequest) anchorId = rankRequest.rankBeforeId;
                    else {
                        isBefore = false;
                        anchorId = rankRequest.rankAfterId;
                    }
                    const issueIndex = sequence.indexOf(issueId);
                    sequence.splice(issueIndex, 1);
                    let anchorIndex = sequence.indexOf(anchorId);
                    if (isBefore === false) anchorIndex += 1;
                    sequence.splice(anchorIndex, 0, issueId);
                    return {
                        ...state,
                        sequence: [
                            ...sequence
                        ]
                    };
                }
            case 0, (0, parcelRequire("1VLi2")).ADD_DEPENDENCY:
                {
                    const { dependee: dependee, dependency: dependency } = action.payload;
                    const { hash: hash } = state;
                    if (hash[dependee]) return {
                        ...state,
                        hash: {
                            ...hash,
                            [dependee]: {
                                ...hash[dependee],
                                dependencies: (0, ($parcel$interopDefault($kGsr8)))([
                                    ...hash[dependee].dependencies || [],
                                    dependency
                                ])
                            }
                        }
                    };
                    return state;
                }
            case 0, (0, parcelRequire("1VLi2")).DELETE_DEPENDENCY:
                {
                    const { dependee: dependee, dependency: dependency } = action.payload;
                    const { hash: hash } = state;
                    if (hash[dependee]) return {
                        ...state,
                        hash: {
                            ...hash,
                            [dependee]: {
                                ...hash[dependee],
                                dependencies: hash[dependee].dependencies.filter((dependencyId)=>dependencyId !== dependency)
                            }
                        }
                    };
                    return state;
                }
            case 0, (0, parcelRequire("1VLi2")).CLEAR_TRANSITION_STATE:
                {
                    const { issueId: issueId, transitionId: transitionId } = action.payload;
                    const { hash: hash } = state;
                    const issue = hash[issueId];
                    if (issue !== undefined) return {
                        ...state,
                        hash: {
                            ...hash,
                            [issueId]: {
                                ...issue,
                                summary: $d9d0c48f37637e53$var$clearTransitionForField(issue.summary, transitionId),
                                startDate: $d9d0c48f37637e53$var$clearTransitionForField(issue.startDate, transitionId),
                                dueDate: $d9d0c48f37637e53$var$clearTransitionForField(issue.dueDate, transitionId),
                                color: $d9d0c48f37637e53$var$clearTransitionForField(issue.color, transitionId),
                                parentId: $d9d0c48f37637e53$var$clearTransitionForField(issue.parentId, transitionId),
                                sprintIds: $d9d0c48f37637e53$var$clearTransitionForField(issue.sprintIds, transitionId)
                            }
                        }
                    };
                    return state;
                }
            case 0, (0, parcelRequire("1VLi2")).RESET_TRANSITION_STATE:
                {
                    const { issueId: issueId, transitionId: transitionId } = action.payload;
                    const { hash: hash } = state;
                    const issue = hash[issueId];
                    if (issue !== undefined) return {
                        ...state,
                        hash: {
                            ...hash,
                            [issueId]: {
                                ...issue,
                                summary: $d9d0c48f37637e53$var$resetTransitionForField(issue.summary, transitionId),
                                startDate: $d9d0c48f37637e53$var$resetTransitionForField(issue.startDate, transitionId),
                                dueDate: $d9d0c48f37637e53$var$resetTransitionForField(issue.dueDate, transitionId),
                                color: $d9d0c48f37637e53$var$resetTransitionForField(issue.color, transitionId),
                                parentId: $d9d0c48f37637e53$var$resetTransitionForField(issue.parentId, transitionId),
                                sprintIds: $d9d0c48f37637e53$var$resetTransitionForField(issue.sprintIds, transitionId)
                            }
                        }
                    };
                    return state;
                }
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("4PSmp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$eaa58dde5ff76924$export$2e2bcd8739ae039);
    var $4hao7;
    const $eaa58dde5ff76924$var$initialState = {
        hash: {}
    };
    var $eaa58dde5ff76924$export$2e2bcd8739ae039 = (state = $eaa58dde5ff76924$var$initialState, action)=>{
        switch(action.type){
            case 0, (0, parcelRequire("4hao7")).MERGE_STATUS_CATEGORIES:
                return {
                    hash: {
                        ...state.hash,
                        ...action.payload
                    }
                };
            default:
                {
                    const _exhaustiveCheck = action.type;
                    return state;
                }
        }
    };
});
parcelRegister("9UOy8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$977b082bfc1ee5cd$export$2e2bcd8739ae039);
    var $bDdHs;
    const $977b082bfc1ee5cd$var$initialState = {
        hash: {}
    };
    var $977b082bfc1ee5cd$export$2e2bcd8739ae039 = (state = $977b082bfc1ee5cd$var$initialState, action)=>{
        switch(action.type){
            case 0, (0, parcelRequire("bDdHs")).EXTEND_SUBTASKS:
                return {
                    hash: {
                        ...state.hash,
                        ...action.payload
                    }
                };
            case 0, (0, parcelRequire("bDdHs")).UPDATE_SUBTASK_STATUS:
                {
                    const { id: id, parentId: parentId, statusCategoryId: statusCategoryId } = action.payload;
                    const subtaskIndex = state.hash[parentId].findIndex(({ id: subtaskId })=>id === subtaskId);
                    if (subtaskIndex >= 0) {
                        const subtask = {
                            ...state.hash[parentId][subtaskIndex],
                            statusCategoryId: statusCategoryId
                        };
                        const subtaskList = [
                            ...state.hash[parentId]
                        ];
                        subtaskList.splice(subtaskIndex, 1, subtask);
                        return {
                            hash: {
                                ...state.hash,
                                [`${parentId}`]: subtaskList
                            }
                        };
                    }
                    return state;
                }
            case 0, (0, parcelRequire("bDdHs")).ADD_SUBTASK:
                {
                    const { id: id, subtask: subtask } = action.payload;
                    const subtaskList = [
                        ...state.hash[id]
                    ];
                    subtaskList.push(subtask);
                    return {
                        hash: {
                            ...state.hash,
                            [`${id}`]: subtaskList
                        }
                    };
                }
            case 0, (0, parcelRequire("bDdHs")).REMOVE_SUBTASKS:
                {
                    const items = action.payload;
                    const updatedHash = {
                        ...state.hash
                    };
                    items.forEach(({ parentId: parentId, id: id })=>{
                        updatedHash[parentId] = updatedHash[parentId].filter((subtask)=>!id.includes(subtask.id));
                    });
                    return {
                        hash: updatedHash
                    };
                }
            case 0, (0, parcelRequire("bDdHs")).CHANGE_SUBTASK_PARENT:
                {
                    const { id: id, newParentId: newParentId, oldParentId: oldParentId } = action.payload;
                    const subtask = state.hash[oldParentId].find(({ id: subtaskId })=>id === subtaskId);
                    if (subtask !== undefined) {
                        const newParentList = [
                            ...state.hash[newParentId]
                        ];
                        newParentList.push(subtask);
                        return {
                            hash: {
                                ...state.hash,
                                [`${oldParentId}`]: state.hash[oldParentId].filter(({ id: subtaskId })=>id !== subtaskId),
                                [`${newParentId}`]: newParentList
                            }
                        };
                    }
                    return state;
                }
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("fhRQD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8f638a9ead9cc47b$export$2e2bcd8739ae039);
    var $dCEtc;
    const $8f638a9ead9cc47b$var$initialState = {
        hash: {}
    };
    var $8f638a9ead9cc47b$export$2e2bcd8739ae039 = (state = $8f638a9ead9cc47b$var$initialState, action)=>{
        switch(action.type){
            case 0, (0, parcelRequire("dCEtc")).ADD_USERS:
                return {
                    hash: {
                        ...state.hash,
                        ...action.payload
                    }
                };
            default:
                {
                    const _exhaustiveCheck = action.type;
                    return state;
                }
        }
    };
});
parcelRegister("2fDos", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3852c77af0c165ea$export$2e2bcd8739ae039);
    var $lCbUI;
    const $3852c77af0c165ea$var$defaultState = {
        traceIds: []
    };
    var $3852c77af0c165ea$export$2e2bcd8739ae039 = (state = $3852c77af0c165ea$var$defaultState, action)=>{
        switch(action.type){
            case 0, (0, parcelRequire("lCbUI")).SET_METADATA:
                return {
                    ...state,
                    ...action.payload
                };
            default:
                {
                    const _exhaustiveCheck = action.type;
                    return state;
                }
        }
    };
});
parcelRegister("gqKcv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$26676903db008290$export$2e2bcd8739ae039);
    var $5EEYw;
    const $26676903db008290$var$initialState = {
        location: {
            search: '',
            pathname: '',
            hash: ''
        }
    };
    var $26676903db008290$export$2e2bcd8739ae039 = (state = $26676903db008290$var$initialState, action)=>{
        switch(action.type){
            case 0, (0, parcelRequire("5EEYw")).ROUTER_LOCATION_CHANGE:
                return {
                    location: {
                        ...state.location,
                        ...action.payload
                    }
                };
            default:
                return state;
        }
    };
});
parcelRegister("81ggD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e60c5074dc8b5404$export$2e2bcd8739ae039);
    var $l4LVp;
    var $iZN6h;
    var $9QFr0;
    var $k6Vft;
    const $e60c5074dc8b5404$var$defaultState = {
        timelineMode: (0, (0, parcelRequire("iZN6h")).MONTHS),
        listWidth: (0, (0, parcelRequire("iZN6h")).DEFAULT_LIST_WIDTH)(),
        issuePanelRatio: (0, $e24db0c09a05523d$export$75a24528ec4289ef),
        creationPreferences: {
            itemTypes: {}
        },
        isDependenciesVisible: false,
        isProgressVisible: false,
        isWarningsVisible: false,
        isReleasesVisible: false,
        highlightedVersions: [],
        levelOneViewSettings: (0, (0, parcelRequire("l4LVp")).DEFAULT_LEVEL_ONE_VIEW_SETTINGS)
    };
    var $e60c5074dc8b5404$export$2e2bcd8739ae039 = (state = $e60c5074dc8b5404$var$defaultState, action)=>{
        switch(action.type){
            case 0, (0, parcelRequire("k6Vft")).SET_SETTINGS:
                return {
                    ...state,
                    ...action.payload
                };
            case 0, (0, parcelRequire("9QFr0")).SET_TIMELINE_MODE:
                return {
                    ...state,
                    timelineMode: action.payload
                };
            case 0, (0, parcelRequire("k6Vft")).SET_LIST_WIDTH:
                return {
                    ...state,
                    listWidth: action.payload
                };
            case 0, (0, parcelRequire("k6Vft")).SET_CREATION_PREFERENCES:
                return {
                    ...state,
                    creationPreferences: action.payload
                };
            case 0, (0, parcelRequire("k6Vft")).UPDATE_CREATION_PREFERENCES:
                return {
                    ...state,
                    creationPreferences: {
                        ...state.creationPreferences,
                        itemTypes: {
                            ...state.creationPreferences.itemTypes,
                            [action.payload.level]: {
                                itemTypeId: action.payload.itemTypeId
                            }
                        }
                    }
                };
            case 0, (0, parcelRequire("k6Vft")).SET_HIGHLIGHTED_VERSIONS:
                return {
                    ...state,
                    highlightedVersions: action.payload
                };
            case 0, (0, parcelRequire("k6Vft")).SET_ISSUE_PANEL_RATIO:
                return {
                    ...state,
                    issuePanelRatio: action.payload
                };
            default:
                return state;
        }
    };
});
parcelRegister("e962v", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d0d426b2534bce70$export$2e2bcd8739ae039);
    var $3f2cs = parcelRequire("3f2cs");
    var $3vhn2;
    var $fFSfT;
    var $1Dpws;
    var $ffrOb;
    var $5JYAi;
    var $d0d426b2534bce70$export$2e2bcd8739ae039 = (0, $3f2cs.combineReducers)({
        healthcheck: (0, parcelRequire("fFSfT")).default,
        table: (0, parcelRequire("ffrOb")).default,
        views: (0, parcelRequire("5JYAi")).default,
        panel: (0, parcelRequire("1Dpws")).default,
        filter: (0, parcelRequire("3vhn2")).default
    });
});
parcelRegister("3vhn2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f992d488a1882146$export$2e2bcd8739ae039);
    var $9QFr0;
    const $f992d488a1882146$var$initialState = {
        configuration: {
            quickFilters: {},
            customFilters: {}
        },
        issueIds: [],
        isJQLFilterActive: false,
        isJQLFilterLoading: false
    };
    var $f992d488a1882146$export$2e2bcd8739ae039 = (state = $f992d488a1882146$var$initialState, action)=>{
        switch(action.type){
            case 0, (0, parcelRequire("9QFr0")).SET_FILTER_CONFIGURATION:
                return {
                    ...state,
                    configuration: action.payload
                };
            case 0, (0, parcelRequire("9QFr0")).CUSTOM_FILTERS_REQUEST:
            case 0, (0, parcelRequire("9QFr0")).QUICK_FILTERS_REQUEST:
                return {
                    ...state,
                    isJQLFilterLoading: true
                };
            case 0, (0, parcelRequire("9QFr0")).JQL_FILTERS_SUCCESS:
                return {
                    ...state,
                    isJQLFilterActive: true,
                    isJQLFilterLoading: false,
                    issueIds: action.payload
                };
            case 0, (0, parcelRequire("9QFr0")).CUSTOM_FILTERS_CLEAR:
            case 0, (0, parcelRequire("9QFr0")).QUICK_FILTERS_CLEAR:
                return {
                    ...state,
                    isJQLFilterActive: $f992d488a1882146$var$initialState.isJQLFilterActive,
                    isJQLFilterLoading: $f992d488a1882146$var$initialState.isJQLFilterLoading,
                    issueIds: $f992d488a1882146$var$initialState.issueIds
                };
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("fFSfT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5ce1950cd3edb29e$export$2e2bcd8739ae039);
    var $jJEyp;
    const $5ce1950cd3edb29e$var$defaultState = {
        isResolving: false,
        issueTypeCounts: {},
        current: undefined,
        issueTypes: undefined
    };
    var $5ce1950cd3edb29e$export$2e2bcd8739ae039 = (state = $5ce1950cd3edb29e$var$defaultState, action)=>{
        switch(action.type){
            case 0, (0, parcelRequire("jJEyp")).EXTEND_ISSUE_TYPE_COUNT:
                return {
                    ...state,
                    issueTypeCounts: {
                        ...state.issueTypeCounts,
                        ...action.payload
                    }
                };
            case 0, (0, parcelRequire("jJEyp")).EXTEND_ISSUE_TYPES:
                return {
                    ...state,
                    issueTypes: action.payload
                };
            case 0, (0, parcelRequire("jJEyp")).SET_RESOLVING:
                return {
                    ...state,
                    isResolving: action.payload
                };
            case 0, (0, parcelRequire("jJEyp")).UPDATE_HEALTHCHECK:
                return {
                    ...state,
                    current: action.payload
                };
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("1Dpws", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c7e1dacdf27a9c23$export$2e2bcd8739ae039);
    var $gFEKp;
    const $c7e1dacdf27a9c23$var$defaultState = {
        panelType: undefined
    };
    var $c7e1dacdf27a9c23$export$2e2bcd8739ae039 = (state = $c7e1dacdf27a9c23$var$defaultState, action)=>{
        switch(action.type){
            case 0, (0, parcelRequire("gFEKp")).SHOW_PANEL:
                return {
                    ...state,
                    panelType: action.payload
                };
            case 0, (0, parcelRequire("gFEKp")).HIDE_PANEL:
                return {
                    ...state,
                    panelType: undefined
                };
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("ffrOb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1c017c582aff37e8$export$2e2bcd8739ae039);
    var $4R6GH;
    var $lEiof;
    const $1c017c582aff37e8$var$defaultState = {
        createItemAnchor: undefined,
        expandedItems: {},
        selectedItemIds: [],
        selectionAnchors: [],
        tooltip: undefined,
        activeItemRef: undefined
    };
    var $1c017c582aff37e8$export$2e2bcd8739ae039 = (state = $1c017c582aff37e8$var$defaultState, action)=>{
        switch(action.type){
            case 0, (0, parcelRequire("lEiof")).SET_CREATE_ITEM_ANCHOR:
                return {
                    ...state,
                    expandedItems: {
                        ...state.expandedItems,
                        ...action.payload && 'parentId' in action.payload && action.payload.parentId ? {
                            [action.payload.parentId]: true
                        } : {}
                    },
                    createItemAnchor: action.payload
                };
            case 0, (0, parcelRequire("lEiof")).RESET_CREATE_ITEM_ANCHOR:
                return {
                    ...state,
                    createItemAnchor: undefined
                };
            case 0, (0, parcelRequire("lEiof")).CHANGE_EXPANSION_STATE:
                return {
                    ...state,
                    expandedItems: {
                        ...state.expandedItems,
                        [action.payload.id]: action.payload.isExpanded
                    }
                };
            case 0, (0, parcelRequire("lEiof")).BULK_CHANGE_EXPANSION_STATE:
                return {
                    ...state,
                    expandedItems: {
                        ...state.expandedItems,
                        ...Object.fromEntries(action.payload.ids.map((id)=>[
                                id,
                                action.payload.isExpanded
                            ]))
                    }
                };
            case 0, (0, parcelRequire("lEiof")).SHOW_TOOLTIP:
                return {
                    ...state,
                    tooltip: action.payload
                };
            case 0, (0, parcelRequire("lEiof")).HIDE_TOOLTIP:
                return {
                    ...state,
                    tooltip: undefined
                };
            case 0, (0, parcelRequire("lEiof")).SET_SELECTED_ITEMS:
                return {
                    ...state,
                    selectedItemIds: action.payload
                };
            case 0, (0, parcelRequire("lEiof")).SET_SELECTION_ANCHORS:
                return {
                    ...state,
                    selectionAnchors: action.payload
                };
            case 0, (0, parcelRequire("lEiof")).SET_ACTIVE_ITEM_REF:
                return {
                    ...state,
                    ...(0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps-timeline-bento-refocusing') ? {
                        activeItemRef: action.payload
                    } : {}
                };
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("5JYAi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$889054a1bd8a11e5$export$2e2bcd8739ae039);
    var $l4LVp;
    var $ilGit;
    const $889054a1bd8a11e5$var$defaultState = {
        isDependenciesVisible: true,
        isProgressVisible: true,
        isWarningsVisible: true,
        isReleasesVisible: true,
        levelOneViewSettings: (0, (0, parcelRequire("l4LVp")).DEFAULT_LEVEL_ONE_VIEW_SETTINGS)
    };
    var $889054a1bd8a11e5$export$2e2bcd8739ae039 = (state = $889054a1bd8a11e5$var$defaultState, action)=>{
        switch(action.type){
            case 0, (0, parcelRequire("ilGit")).SET_DEPENDENCIES_VIEW_VISIBILITY:
                return {
                    ...state,
                    isDependenciesVisible: action.payload
                };
            case 0, (0, parcelRequire("ilGit")).SET_PROGRESS_VISIBILITY:
                return {
                    ...state,
                    isProgressVisible: action.payload
                };
            case 0, (0, parcelRequire("ilGit")).SET_WARNINGS_VISIBILITY:
                return {
                    ...state,
                    isWarningsVisible: action.payload
                };
            case 0, (0, parcelRequire("ilGit")).SET_RELEASES_VISIBILITY:
                return {
                    ...state,
                    isReleasesVisible: action.payload
                };
            case 0, (0, parcelRequire("ilGit")).SET_LEVEL_ONE_SETTING:
                return {
                    ...state,
                    levelOneViewSettings: action.payload
                };
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("lEmZG", function(module, exports) {
    $parcel$export(module.exports, "engine", ()=>$b1b9709716dc2718$export$d3c662a6136faebb);
    parcelRequire("fp4O3");
    var $ajpes = parcelRequire("ajpes");
    var $kVLXA = parcelRequire("kVLXA");
    var $8p6tp;
    var $dXq4S;
    var $aDAv9;
    const $b1b9709716dc2718$export$d3c662a6136faebb = (prefix, boardId, sourceAri, loggedInAccountIdSelector, prefetchedData)=>{
        const mod = (0, (0, parcelRequire("8p6tp")).prefixer)(`standard-${prefix}`);
        const blob = prefetchedData || {};
        let propertyKey = mod(`board-${boardId}`);
        const ariConfig = (0, (0, parcelRequire("dXq4S")).parseAri)(sourceAri);
        if (ariConfig) propertyKey = mod(`${ariConfig.resourceType}-${ariConfig.resourceId}`);
        return {
            get: (key)=>(0, $kVLXA.Observable).of(blob[key]),
            set: (key, value)=>{
                if (!(0, ($parcel$interopDefault($ajpes)))(blob[key], value)) {
                    blob[key] = value;
                    (0, (0, parcelRequire("aDAv9")).default)(loggedInAccountIdSelector(), propertyKey, JSON.stringify(blob));
                }
            },
            allowsModificationWithoutHydration: false
        };
    };
});
parcelRegister("8p6tp", function(module, exports) {
    $parcel$export(module.exports, "prefixer", ()=>$64448dc25e136cde$export$e08c7d021b829b7a);
    const $64448dc25e136cde$export$e08c7d021b829b7a = (prefix)=>(key)=>`${prefix}.${key}`;
});
parcelRegister("aDAv9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$12c9a1397237e471$export$2e2bcd8739ae039);
    parcelRequire("6hSeW");
    parcelRequire("9o0uh");
    parcelRequire("fPS7b");
    var $kVLXA = parcelRequire("kVLXA");
    var $eusud;
    var $12c9a1397237e471$export$2e2bcd8739ae039 = (accountId, propertyKey, propertyValue)=>{
        const options = {
            method: 'PUT',
            body: propertyValue
        };
        return (0, $kVLXA.Observable).fromPromise((0, (0, parcelRequire("eusud")).performPutRequest)(`/rest/api/2/user/properties/${propertyKey}?accountId=${encodeURIComponent(accountId)}`, options)).mergeMap(()=>(0, $kVLXA.Observable).empty());
    };
});
parcelRegister("9MZpN", function(module, exports) {
    $parcel$export(module.exports, "StandardMacro", ()=>$63eacc16f1893402$export$447e142a7e4ffcb6);
    $parcel$export(module.exports, "ClassicStandardMacro", ()=>$63eacc16f1893402$export$9dac407fe81bed96);
    $parcel$export(module.exports, "StandardView", ()=>$63eacc16f1893402$export$18d5f6166a1f65de);
    $parcel$export(module.exports, "ClassicStandardView", ()=>$63eacc16f1893402$export$2e9f3cb234df1140);
    var $5uXOq = parcelRequire("5uXOq");
    var $basmW = parcelRequire("basmW");
    var $8QpSo;
    var $iXVV6;
    var $bC2fB;
    var $jAJAx;
    var $9fPrG;
    var $4gYYI;
    var $hFyhA;
    var $fWch8;
    var $ed9mM;
    var $fVm8c;
    var $iAaEq;
    var $1nYQG;
    var $jLazb;
    var $jhhzY;
    var $gzKIg;
    var $k4sUr;
    var $lCaz0;
    var $i5OnV;
    var $gu4dg;
    const $63eacc16f1893402$var$mapStateToProps = (state, { isMacroView: isMacroView })=>{
        const projectId = (0, (0, parcelRequire("4gYYI")).getProjectId)(state) || '';
        const boardId = (0, (0, parcelRequire("9fPrG")).getBoardId)(state);
        return {
            boardId: (0, (0, parcelRequire("9fPrG")).getBoardId)(state),
            projectKey: (0, (0, parcelRequire("4gYYI")).getProjectKey)(state),
            isHealthy: !(0, (0, parcelRequire("ed9mM")).getHasHealthcheck)(state),
            isShared: (0, (0, parcelRequire("fWch8")).isShared)(state),
            isClassic: (0, (0, parcelRequire("9fPrG")).isClassic)(state),
            issueIds: (0, (0, parcelRequire("hFyhA")).getIssueIds)(state),
            Header: (0, parcelRequire("jLazb")).default,
            Table: (0, parcelRequire("i5OnV")).default,
            Healthcheck: (0, parcelRequire("jhhzY")).default,
            DocumentTitle: (0, parcelRequire("iAaEq")).default,
            RealtimeProvider: (0, parcelRequire("k4sUr")).default,
            RouterUpdater: (0, parcelRequire("lCaz0")).default,
            MountAnalytic: (0, parcelRequire("gzKIg")).default,
            isHeaderHidden: (0, (0, parcelRequire("9fPrG")).getMacroHideHeader)(state),
            shouldMountKeyboardShortcuts: !isMacroView,
            objectId: String(boardId),
            projectId: projectId,
            boardType: (0, (0, parcelRequire("4gYYI")).getIsSprintsFeatureEnabled)(state) ? 'Scrum' : 'Kanban',
            childIssuePlanningMode: (0, (0, parcelRequire("4gYYI")).getChildIssuePlanningMode)(state)
        };
    };
    const $63eacc16f1893402$var$mapDispatchToProps = {
        onSetShared: (0, (0, parcelRequire("fVm8c")).setShared),
        initializeNonCriticalData: (0, parcelRequire("jAJAx")).initializeNonCriticalData
    };
    const $63eacc16f1893402$var$onLoadedFactory = (0, (0, parcelRequire("8QpSo")).default)((dispatchPropsInitializeNonCriticalData, statePropsIsShared, onSetShared)=>()=>{
            dispatchPropsInitializeNonCriticalData();
            if (statePropsIsShared) onSetShared(false);
        });
    const $63eacc16f1893402$var$mergeProps = (stateProps, dispatchProps, ownProps)=>({
            ...stateProps,
            ...ownProps,
            onLoaded: $63eacc16f1893402$var$onLoadedFactory(dispatchProps.initializeNonCriticalData, stateProps.isShared, dispatchProps.onSetShared)
        });
    const $63eacc16f1893402$var$View = (0, (0, parcelRequire("1nYQG")).withViewExperienceTracker)((0, ($parcel$interopDefault($basmW)))([
        (0, (0, parcelRequire("bC2fB")).connect)($63eacc16f1893402$var$mapStateToProps, $63eacc16f1893402$var$mapDispatchToProps, $63eacc16f1893402$var$mergeProps)
    ])((0, (0, parcelRequire("gu4dg")).default)));
    const $63eacc16f1893402$export$447e142a7e4ffcb6 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: "roadmapMacro",
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($63eacc16f1893402$var$View, props));
    const $63eacc16f1893402$export$9dac407fe81bed96 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: "classicRoadmapMacro",
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($63eacc16f1893402$var$View, props));
    const $63eacc16f1893402$export$18d5f6166a1f65de = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: "roadmap",
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($63eacc16f1893402$var$View, props));
    const $63eacc16f1893402$export$2e9f3cb234df1140 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: "classicRoadmap",
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($63eacc16f1893402$var$View, props));
});
parcelRegister("ed9mM", function(module, exports) {
    $parcel$export(module.exports, "getIssueCounts", ()=>$a38e8f72bf3189de$export$bdfb218a19333daa);
    $parcel$export(module.exports, "getHealthcheckIssueTypes", ()=>$a38e8f72bf3189de$export$156194c028613748);
    $parcel$export(module.exports, "isResolving", ()=>$a38e8f72bf3189de$export$385897f863931845);
    $parcel$export(module.exports, "getHealthcheck", ()=>$a38e8f72bf3189de$export$47b0be97eea80dc5);
    $parcel$export(module.exports, "getHasHealthcheck", ()=>$a38e8f72bf3189de$export$330b0477c226ca52);
    const $a38e8f72bf3189de$export$bdfb218a19333daa = (state)=>state.ui.healthcheck.issueTypeCounts;
    const $a38e8f72bf3189de$export$156194c028613748 = (state)=>state.ui.healthcheck.issueTypes;
    const $a38e8f72bf3189de$export$385897f863931845 = (state)=>state.ui.healthcheck.isResolving;
    const $a38e8f72bf3189de$export$47b0be97eea80dc5 = (state)=>state.ui.healthcheck.current;
    const $a38e8f72bf3189de$export$330b0477c226ca52 = (state)=>state.ui.healthcheck.current !== undefined;
});
parcelRegister("iAaEq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f800cedc27d8514e$export$2e2bcd8739ae039);
    var $bC2fB;
    var $9fPrG;
    var $eqbtQ;
    var $f800cedc27d8514e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((state)=>({
            projectName: (0, (0, parcelRequire("9fPrG")).getContainerName)(state)
        }), {})((0, (0, parcelRequire("eqbtQ")).default));
});
parcelRegister("eqbtQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7aab2620639a1605$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ew1Lk;
    var $koVbs;
    var $9G3I7;
    const $7aab2620639a1605$var$DocumentTitle = ({ projectName: projectName })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ew1Lk")).DocumentTitle), {
            title: formatMessage((0, (0, parcelRequire("9G3I7")).default).timelineDocumentTitle, {
                projectName: projectName
            })
        });
    };
    var $7aab2620639a1605$export$2e2bcd8739ae039 = $7aab2620639a1605$var$DocumentTitle;
});
parcelRegister("ew1Lk", function(module, exports) {
    $parcel$export(module.exports, "DocumentTitle", ()=>$41b549fa18234081$export$dd5ad0b65cf665da);
    var $5uXOq = parcelRequire("5uXOq");
    var $6nkVm;
    class $41b549fa18234081$export$dd5ad0b65cf665da extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                TitleSubscriber: (0, (0, parcelRequire("6nkVm")).DocumentTitleSubscriber)
            };
        }
        shouldComponentUpdate(nextProps) {
            return nextProps.title !== this.props.title;
        }
        render() {
            const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6nkVm")).DocumentTitleHelper), {
                    title: title,
                    setTitle: setTitle,
                    addDocumentTitle: addDocumentTitle,
                    contextArray: contextArray,
                    removeDocumentTitle: removeDocumentTitle,
                    TitleSubscriber: TitleSubscriber
                }));
        }
    }
});
parcelRegister("9G3I7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$14e3f934f5133518$export$2e2bcd8739ae039);
    var $7VHMR;
    var $14e3f934f5133518$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        timelineDocumentTitle: {
            "id": "roadmap.standard-roadmap.document-title.timeline-document-title",
            "defaultMessage": "{projectName} - Timeline"
        }
    });
});
parcelRegister("1nYQG", function(module, exports) {
    $parcel$export(module.exports, "withViewExperienceTracker", ()=>$08accb80892d87ed$export$52092272c0483371);
    var $5uXOq = parcelRequire("5uXOq");
    var $aD4Nm;
    const $08accb80892d87ed$export$52092272c0483371 = (ComponentBeingTracked)=>{
        const WithViewExperienceTracker = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aD4Nm")).ExperienceTracker), {
                location: "roadmap"
            }, ({ onExperienceSuccess: onExperienceSuccess })=>(0, ($parcel$interopDefault($5uXOq))).createElement(ComponentBeingTracked, {
                    onExperienceSuccess: onExperienceSuccess,
                    ...props
                }));
        return WithViewExperienceTracker;
    };
});
parcelRegister("jLazb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3f1195610ffe222a$export$2e2bcd8739ae039);
    var $3HwlS;
    var $bC2fB;
    var $9fPrG;
    var $4gYYI;
    var $7VRlA;
    var $h85WD;
    var $6W6Zj;
    var $a4l5H;
    var $47e4t;
    var $4r7Ar;
    var $3f1195610ffe222a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((state)=>({
            isMacroView: (0, (0, parcelRequire("9fPrG")).hasMacroConfig)(state),
            Share: (0, parcelRequire("a4l5H")).default,
            Filters: (0, (0, parcelRequire("h85WD")).default),
            ViewSettings: (0, parcelRequire("47e4t")).default,
            MoreSettings: (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() || (0, (0, parcelRequire("4gYYI")).hasAdministerProjectPermission)(state) || (0, (0, parcelRequire("4gYYI")).getIsUserBoardAdmin)(state) ? (0, (0, parcelRequire("6W6Zj")).default) : undefined,
            Feedback: (0, parcelRequire("7VRlA")).default
        }), {})((0, (0, parcelRequire("4r7Ar")).default));
});
parcelRegister("7VRlA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5cc43875f5f21546$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $lfTZh;
    var $kxZPA;
    var $eKt4x;
    const $5cc43875f5f21546$var$LazyFeedback = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("NjOUx")), {
        ssr: false,
        moduleId: "./src/packages/software/roadmap/standard/src/view/header/feedback/index.tsx"
    });
    var $5cc43875f5f21546$export$2e2bcd8739ae039 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "async-standard-roadmap-feedback",
            packageName: (0, (0, parcelRequire("eKt4x")).ROADMAP_PACKAGE_NAME),
            fallback: "flag"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "standard-roadmap-feedback",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($5cc43875f5f21546$var$LazyFeedback, props)));
});
parcelRegister("NjOUx", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("4dMe8").then(()=>parcelRequire('aQZug'));
});
parcelRegister("h85WD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$79d23292cf49bb3d$export$2e2bcd8739ae039);
    var $6s1PB;
    var $bC2fB;
    var $9fPrG;
    var $50Z4W;
    var $4gYYI;
    var $6thbV;
    var $9hAGg;
    var $1XSJX;
    var $fESZY;
    var $euG84;
    var $HL9Is;
    var $fayLA;
    var $jOLfr;
    var $hJOAV;
    var $3rLbe;
    var $9QFr0;
    var $iET4k;
    var $3Gp9r;
    var $gu0m2;
    var $gro4f;
    const $79d23292cf49bb3d$var$EMPTY_ARRAY = [];
    const $79d23292cf49bb3d$var$shouldShowAddPeopleButton = (state)=>{
        const isCMP = (0, (0, parcelRequire("9fPrG")).isClassic)(state);
        const canAdministerProject = (0, (0, parcelRequire("4gYYI")).hasAdministerProjectPermission)(state);
        if (isCMP) return canAdministerProject;
        const canInviteOthersToProject = (0, (0, parcelRequire("4gYYI")).getCanInviteOthersToProject)(state);
        return canAdministerProject || canInviteOthersToProject;
    };
    const $79d23292cf49bb3d$var$mapStateToProps = (state, { isMacroView: isMacroView })=>({
            issueTypes: (0, (0, parcelRequire("HL9Is")).getIssueTypes)(state),
            assignees: (0, (0, parcelRequire("fESZY")).getAssignees)(state),
            labels: (0, (0, parcelRequire("fayLA")).getLabels)(state),
            issueParents: (0, (0, parcelRequire("euG84")).getIssueParents)(state),
            issueParentsLabel: (0, (0, parcelRequire("4gYYI")).getLevelOneName)(state),
            statusCategories: (0, (0, parcelRequire("jOLfr")).getStatusCategories)(state),
            AddPeopleModal: isMacroView ? undefined : (0, (0, parcelRequire("3Gp9r")).default),
            filter: (0, (0, parcelRequire("gu0m2")).getFilters)(state),
            boardId: (0, (0, parcelRequire("9fPrG")).getBoardId)(state),
            projectId: parseInt((0, (0, parcelRequire("4gYYI")).getProjectId)(state), 10),
            projectName: (0, (0, parcelRequire("4gYYI")).getProjectName)(state),
            projectKey: (0, (0, parcelRequire("4gYYI")).getProjectKey)(state),
            versions: (0, (0, parcelRequire("3rLbe")).getVersionsForFilter)(state),
            components: (0, (0, parcelRequire("9hAGg")).getComponents)(state),
            customFilters: (0, (0, parcelRequire("1XSJX")).getCustomFilters)(state),
            quickFilters: (0, (0, parcelRequire("hJOAV")).getQuickFilters)(state),
            goals: (0, (0, parcelRequire("6thbV")).getGoals)(state),
            isAddPeopleButtonEnabled: !(0, (0, parcelRequire("6s1PB")).expValEquals)('open_invite_for_open_tmp_projects', 'cohort', 'experiment') ? (0, (0, parcelRequire("4gYYI")).hasAdministerProjectPermission)(state) : $79d23292cf49bb3d$var$shouldShowAddPeopleButton(state),
            isCustomFilterManageLinkEnabled: (0, (0, parcelRequire("4gYYI")).hasAdministerProjectPermission)(state),
            isVersionFilterSpotlightEnabled: (0, (0, parcelRequire("4gYYI")).hasAdministerProjectPermission)(state),
            isCustomFiltersLoading: (0, (0, parcelRequire("iET4k")).getIsJQLFilterLoading)(state),
            isCMP: (0, (0, parcelRequire("9fPrG")).isClassic)(state)
        });
    const $79d23292cf49bb3d$var$mapDispatchToProps = (dispatch)=>({
            onClearAllButtonClicked: ()=>{
                dispatch((0, (0, parcelRequire("9QFr0")).clearFilter)());
                dispatch((0, (0, parcelRequire("9QFr0")).clearQuickFilters)());
                dispatch((0, (0, parcelRequire("50Z4W")).deriveFieldsRequest)());
            },
            onChange: (filters, filterType)=>{
                if (filterType === (0, $15a528573ccd89ae$export$d597759d33be802e)) {
                    const textValue = filters[0, $15a528573ccd89ae$export$d597759d33be802e] || '';
                    dispatch((0, (0, parcelRequire("9QFr0")).setTextFilter)(textValue));
                } else if (filterType === (0, $15a528573ccd89ae$export$f8f7545d2bb78afb)) {
                    const assigneeValue = filters[0, $15a528573ccd89ae$export$f8f7545d2bb78afb] || $79d23292cf49bb3d$var$EMPTY_ARRAY;
                    dispatch((0, (0, parcelRequire("9QFr0")).setAssigneeFilter)(assigneeValue));
                } else if (filterType === (0, $15a528573ccd89ae$export$37aee82a3cb1e8f7)) {
                    const labelValue = filters[0, $15a528573ccd89ae$export$37aee82a3cb1e8f7] || $79d23292cf49bb3d$var$EMPTY_ARRAY;
                    dispatch((0, (0, parcelRequire("9QFr0")).setLabelFilter)(labelValue));
                } else if (filterType === (0, $15a528573ccd89ae$export$2a4f270075a033de)) {
                    const issueParentValue = filters[0, $15a528573ccd89ae$export$2a4f270075a033de] || $79d23292cf49bb3d$var$EMPTY_ARRAY;
                    dispatch((0, (0, parcelRequire("9QFr0")).setIssueParentFilter)(issueParentValue));
                } else if (filterType === (0, $15a528573ccd89ae$export$ebb48b08205007c5)) {
                    const issueTypeValue = filters[0, $15a528573ccd89ae$export$ebb48b08205007c5] || $79d23292cf49bb3d$var$EMPTY_ARRAY;
                    dispatch((0, (0, parcelRequire("9QFr0")).setIssueTypeFilter)(issueTypeValue));
                } else if (filterType === (0, $15a528573ccd89ae$export$f863b019d19144f4)) {
                    const statusValue = filters[0, $15a528573ccd89ae$export$f863b019d19144f4] || $79d23292cf49bb3d$var$EMPTY_ARRAY;
                    dispatch((0, (0, parcelRequire("9QFr0")).setStatusCategoryFilter)(statusValue));
                } else if (filterType === (0, $15a528573ccd89ae$export$a4ad2735b021c132)) {
                    const versionValue = filters[0, $15a528573ccd89ae$export$a4ad2735b021c132] || $79d23292cf49bb3d$var$EMPTY_ARRAY;
                    dispatch((0, (0, parcelRequire("9QFr0")).setVersionFilter)(versionValue));
                } else if (filterType === (0, $15a528573ccd89ae$export$af1e30ebbae9df3b)) {
                    const componentValue = filters[0, $15a528573ccd89ae$export$af1e30ebbae9df3b] || $79d23292cf49bb3d$var$EMPTY_ARRAY;
                    dispatch((0, (0, parcelRequire("9QFr0")).setComponentFilter)(componentValue));
                } else if (filterType === (0, $15a528573ccd89ae$export$871e58afc769b358)) {
                    const goalValue = filters[0, $15a528573ccd89ae$export$871e58afc769b358] || $79d23292cf49bb3d$var$EMPTY_ARRAY;
                    dispatch((0, (0, parcelRequire("9QFr0")).setGoalFilter)(goalValue));
                } else if (filterType === (0, $15a528573ccd89ae$export$1ea95b94fb0c51d9)) {
                    const quickFilterValue = filters[0, $15a528573ccd89ae$export$1ea95b94fb0c51d9] || $79d23292cf49bb3d$var$EMPTY_ARRAY;
                    dispatch((0, (0, parcelRequire("9QFr0")).setQuickFiltersFilter)(quickFilterValue));
                    dispatch((0, (0, parcelRequire("9QFr0")).quickFiltersRequest)(quickFilterValue));
                    dispatch((0, (0, parcelRequire("50Z4W")).deriveFieldsRequest)());
                } else if (filterType === (0, $15a528573ccd89ae$export$68d693c35a8d8866)) {
                    const customFilterValue = filters[0, $15a528573ccd89ae$export$68d693c35a8d8866] || $79d23292cf49bb3d$var$EMPTY_ARRAY;
                    dispatch((0, (0, parcelRequire("9QFr0")).setCustomFilter)(customFilterValue));
                    dispatch((0, (0, parcelRequire("9QFr0")).customFiltersRequest)(customFilterValue));
                    dispatch((0, (0, parcelRequire("50Z4W")).deriveFieldsRequest)());
                }
            }
        });
    var $79d23292cf49bb3d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($79d23292cf49bb3d$var$mapStateToProps, $79d23292cf49bb3d$var$mapDispatchToProps)((0, (0, parcelRequire("gro4f")).default));
});
parcelRegister("1XSJX", function(module, exports) {
    $parcel$export(module.exports, "getCustomFilters", ()=>$2b6d6a09a71ef1ec$export$ada7918f4af738ad);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $iET4k;
    const $2b6d6a09a71ef1ec$export$34d8969cbca362eb = (customFiltershash)=>Object.keys(customFiltershash).map((customFilterId)=>{
            const customFilter = customFiltershash[customFilterId];
            return {
                id: customFilter.id,
                name: customFilter.name
            };
        });
    const $2b6d6a09a71ef1ec$export$ada7918f4af738ad = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("iET4k")).getFullCustomFilterHash), $2b6d6a09a71ef1ec$export$34d8969cbca362eb);
});
parcelRegister("fESZY", function(module, exports) {
    $parcel$export(module.exports, "getAssignees", ()=>$84077dc49811240c$export$83f72e15d115a0e7);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $cKS6s;
    var $9fPrG;
    var $hFyhA;
    var $iaL1N;
    const $84077dc49811240c$export$1b2f73c5cdda2111 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("9fPrG")).getLoggedInAccountId), (0, (0, parcelRequire("hFyhA")).getIssueIds), (0, (0, parcelRequire("hFyhA")).getIssueAssigneeHash), (loggedInUserId, issueIds, assigneeHash)=>{
        const assigneeSet = new Set([
            loggedInUserId
        ]);
        Array.from(issueIds).reverse().forEach((issueId)=>{
            const assignee = assigneeHash[issueId];
            if (assignee) assigneeSet.add(assignee);
        });
        return Array.from(assigneeSet.values());
    });
    const $84077dc49811240c$export$83f72e15d115a0e7 = (0, (0, parcelRequire("cKS6s")).createSelectorWithDefaultEqual)($84077dc49811240c$export$1b2f73c5cdda2111, (0, (0, parcelRequire("iaL1N")).getFullUserHash), (assigneeIds, usersHash)=>{
        const assignees = [];
        assigneeIds.forEach((assigneeId)=>{
            const user = usersHash[assigneeId];
            if (assigneeId && user) assignees.push({
                id: assigneeId,
                displayName: user.displayName,
                avatarUrl: user.avatarUrls['48x48']
            });
        });
        return assignees;
    });
});
parcelRegister("euG84", function(module, exports) {
    $parcel$export(module.exports, "getIssueParents", ()=>$7da9833da2e372d7$export$df9259146e40d32c);
    var $cKS6s;
    var $hFyhA;
    const $7da9833da2e372d7$export$df9259146e40d32c = (0, (0, parcelRequire("cKS6s")).createSelectorWithDefaultEqual)((0, (0, parcelRequire("hFyhA")).getIssueParentIds), (0, (0, parcelRequire("hFyhA")).getIssueSummaryHash), (uniqueIssueParentIds, issueSummaryHash)=>uniqueIssueParentIds.map((parentId)=>({
                id: parentId,
                name: issueSummaryHash[parentId]
            })));
});
parcelRegister("HL9Is", function(module, exports) {
    $parcel$export(module.exports, "getIssueTypes", ()=>$50bf001951b762ee$export$4cf4b24b88599615);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $ggSx2 = parcelRequire("ggSx2");
    var $cKS6s;
    var $hFyhA;
    var $hhYQB;
    const $50bf001951b762ee$var$getIssueTypesUsageHash = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("hFyhA")).getIssueTypeIdHash), (0, ($parcel$interopDefault($ggSx2))));
    const $50bf001951b762ee$var$getSortedChildIssueTypes = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("hhYQB")).getChildIssueTypes), $50bf001951b762ee$var$getIssueTypesUsageHash, (childIssueTypes, issueTypesUsageHash)=>childIssueTypes.filter(({ id: id })=>issueTypesUsageHash[id]).sort((issueTypeA, issueTypeB)=>issueTypeA.name.toLowerCase() < issueTypeB.name.toLowerCase() ? -1 : 1));
    const $50bf001951b762ee$export$4cf4b24b88599615 = (0, (0, parcelRequire("cKS6s")).createSelectorWithDefaultEqual)($50bf001951b762ee$var$getSortedChildIssueTypes, (childIssueTypes)=>childIssueTypes);
});
parcelRegister("jOLfr", function(module, exports) {
    $parcel$export(module.exports, "getStatusCategories", ()=>$a0a9bf93673252ca$export$29350702a509e1b9);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $7qDUb = parcelRequire("7qDUb");
    var $1RlSy;
    var $2udWc;
    const $a0a9bf93673252ca$var$STATUS_KEYS_ORDER_HASH = {
        [`${0, (0, parcelRequire("1RlSy")).TODO}`]: 1,
        [`${0, (0, parcelRequire("1RlSy")).IN_PROGRESS}`]: 2,
        [`${0, (0, parcelRequire("1RlSy")).DONE}`]: 3
    };
    const $a0a9bf93673252ca$export$29350702a509e1b9 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("2udWc")).getFullStatusCategoriesHash), (statusCategoriesHash)=>{
        const statusCategoryIds = Object.keys(statusCategoriesHash).filter((id)=>statusCategoriesHash[id].key in $a0a9bf93673252ca$var$STATUS_KEYS_ORDER_HASH);
        const orderedStatusCategoryIds = (0, ($parcel$interopDefault($7qDUb)))(statusCategoryIds, (id)=>$a0a9bf93673252ca$var$STATUS_KEYS_ORDER_HASH[statusCategoriesHash[id].key]);
        return orderedStatusCategoryIds.map((id)=>({
                id: id,
                name: statusCategoriesHash[id].name
            }));
    });
});
parcelRegister("hJOAV", function(module, exports) {
    $parcel$export(module.exports, "getQuickFilters", ()=>$f0519936bf6f0033$export$59e2f55e44eccfa0);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $iET4k;
    const $f0519936bf6f0033$var$getQuickFiltersOrderedBase = (quickFiltersHash)=>Object.values(quickFiltersHash).sort((a, b)=>a.position - b.position).map((quickFilter)=>({
                id: quickFilter.id,
                name: quickFilter.name
            }));
    const $f0519936bf6f0033$export$59e2f55e44eccfa0 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("iET4k")).getFullQuickFilterHash), $f0519936bf6f0033$var$getQuickFiltersOrderedBase);
});
parcelRegister("3Gp9r", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bdf103b29fb1953e$export$2e2bcd8739ae039);
    var $8Rkzz = parcelRequire("8Rkzz");
    var $2vSU6;
    var $fjJ1B;
    var $bC2fB;
    var $4gYYI;
    const $bdf103b29fb1953e$var$mapStateToProps = (state, ownProps)=>({
            baseUrl: '',
            projectId: Number((0, (0, parcelRequire("4gYYI")).getProjectId)(state)),
            projectKey: (0, (0, parcelRequire("4gYYI")).getProjectKey)(state),
            isOpen: ownProps.isOpen,
            projectType: (0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT),
            isAdmin: true,
            analyticsPrefix: 'software.roadmap',
            allowFlags: true,
            onClose: (0, ($parcel$interopDefault($8Rkzz))),
            onError: (0, ($parcel$interopDefault($8Rkzz))),
            onAddSuccess: (0, ($parcel$interopDefault($8Rkzz))),
            onStopPerfMetric: (0, ($parcel$interopDefault($8Rkzz))),
            projectRoles: undefined,
            partiesInProject: undefined,
            defaultRoleId: undefined,
            adminRoleId: undefined,
            roleConfigurable: undefined
        });
    var $bdf103b29fb1953e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($bdf103b29fb1953e$var$mapStateToProps, {})((0, (0, parcelRequire("fjJ1B")).default));
});
parcelRegister("fjJ1B", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$05d4cefe384a250f$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "AddPeopleModalBoundary", ()=>$05d4cefe384a250f$export$374b95de0cd72a02);
    var $5uXOq = parcelRequire("5uXOq");
    var $gAeCk;
    var $39xOx;
    var $gjEtj;
    var $lfTZh;
    var $kxZPA;
    const $05d4cefe384a250f$var$LazyComponent = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("7HRyA")), {
        moduleId: "./src/packages/permissions-administration/components/project-add-people/src/index.tsx"
    });
    const $05d4cefe384a250f$export$c4cbbeec160c9988 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "async-project-add-people-dialog",
            packageName: "project-add-people"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "project-add-people-dialog",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gAeCk")).default), {
                metricKey: (0, $f7307e9423a0bb88$export$b68a44ad9e8d6ce)
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($05d4cefe384a250f$var$LazyComponent, props)));
    var $05d4cefe384a250f$export$2e2bcd8739ae039 = $05d4cefe384a250f$export$c4cbbeec160c9988;
    const $05d4cefe384a250f$export$374b95de0cd72a02 = ({ children: children, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjEtj")).ModalBoundary), {
            id: "add-people-modal",
            metricKey: (0, $f7307e9423a0bb88$export$b68a44ad9e8d6ce),
            ...props
        }, children);
});
parcelRegister("gjEtj", function(module, exports) {
    $parcel$export(module.exports, "ModalBoundary", ()=>$c322f875acea1654$export$c3f500e812fb1bb3);
    var $5uXOq = parcelRequire("5uXOq");
    var $gAeCk;
    var $iqr2y;
    var $heNNl;
    var $lfTZh;
    const $c322f875acea1654$export$c3f500e812fb1bb3 = ({ children: children, id: id, metricKey: metricKey, packageName: packageName, onError: onError })=>{
        const ErrorState = (0, $5uXOq.useCallback)((args)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqr2y")).ErrorFlagRenderer), {
                id: id,
                error: args.error
            }), [
            id
        ]);
        const fallback = typeof metricKey === 'string' && metricKey.length > 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gAeCk")).default), {
            metricKey: metricKey
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: id,
            packageName: packageName,
            render: ErrorState,
            onError: onError
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: id,
            fallback: fallback
        }, children));
    };
});
const $f7307e9423a0bb88$export$8fcd8ea7ed6539b1 = 'project-settings-apps.add-people-dialog';
const $f7307e9423a0bb88$export$b68a44ad9e8d6ce = 'ADD_PEOPLE_LOAD_START_MARK_KEY';
const $f7307e9423a0bb88$export$656613627a47a509 = 'ADD_PEOPLE_LOAD_END_MARK_KEY';
const $f7307e9423a0bb88$export$61762786d0849c64 = 'ADD_PEOPLE_READY_MARK_KEY';
parcelRegister("7HRyA", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("1TWxe")
    ]).then(()=>parcelRequire('jd2mv'));
});
parcelRegister("gu0m2", function(module, exports) {
    $parcel$export(module.exports, "getFilters", ()=>$423b06f535d18fc1$export$1933a9fe712fc1fd);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $4f8Oj = parcelRequire("4f8Oj");
    var $hhYQB;
    const $423b06f535d18fc1$var$isNotEmpty = (a)=>a.length !== 0;
    const $423b06f535d18fc1$export$1933a9fe712fc1fd = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("hhYQB")).getIssuesFilter), ({ assignees: assignees, issueTypes: issueTypes, statuses: statuses, text: text, labels: labels, issueParents: issueParents, versions: versions, components: components, quickFilters: quickFilters, customFilters: customFilters, goals: goals })=>{
        const filters = {
            [(0, $15a528573ccd89ae$export$d597759d33be802e)]: text,
            [(0, $15a528573ccd89ae$export$f8f7545d2bb78afb)]: assignees,
            [(0, $15a528573ccd89ae$export$37aee82a3cb1e8f7)]: labels,
            [(0, $15a528573ccd89ae$export$2a4f270075a033de)]: issueParents,
            [(0, $15a528573ccd89ae$export$ebb48b08205007c5)]: issueTypes,
            [(0, $15a528573ccd89ae$export$f863b019d19144f4)]: statuses,
            [(0, $15a528573ccd89ae$export$a4ad2735b021c132)]: versions,
            [(0, $15a528573ccd89ae$export$af1e30ebbae9df3b)]: components,
            [(0, $15a528573ccd89ae$export$1ea95b94fb0c51d9)]: quickFilters,
            [(0, $15a528573ccd89ae$export$68d693c35a8d8866)]: customFilters,
            [(0, $15a528573ccd89ae$export$871e58afc769b358)]: goals
        };
        return (0, ($parcel$interopDefault($4f8Oj)))(filters, $423b06f535d18fc1$var$isNotEmpty);
    });
});
parcelRegister("gro4f", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f1519c516ab31c7d$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $eTXmK;
    var $9vASA;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $kbfkr;
    var $jtCoi;
    var $2GIeL;
    const $f1519c516ab31c7d$var$RoadmapCustomFilter = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9vASA")).default), {
            filters: props.filters,
            ...props
        });
    const $f1519c516ab31c7d$var$Filter = ({ isMacroView: isMacroView, isCMP: isCMP, goals: goals, ...filterProps })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { isCustomFiltersLoading: isCustomFiltersLoading, versions: versions, labels: labels, components: components, customFilters: customFilters, quickFilters: quickFilters, onChange: onChange, onClearAllButtonClicked: onClearAllButtonClicked } = filterProps;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const jqlFilters = isCMP ? quickFilters : customFilters;
        const { collator: collator } = (0, (0, parcelRequire("jtCoi")).useCollator)();
        const onFilterChanged = (0, $5uXOq.useCallback)((filters, filterType, extraAttributes)=>{
            (0, (0, parcelRequire("eTXmK")).default)('timeline-filter');
            onChange(filters, filterType);
            const analyticsEvent = createAnalyticsEvent({
                action: 'changed',
                actionSubject: 'filterBar'
            });
            const hasUnassignedAssignee = Boolean(filterType === (0, $15a528573ccd89ae$export$f8f7545d2bb78afb) && filters[0, $15a528573ccd89ae$export$f8f7545d2bb78afb]);
            let hasUnassignedOption = hasUnassignedAssignee;
            const isAssigneeUnassigned = filters[0, $15a528573ccd89ae$export$f8f7545d2bb78afb]?.includes((0, $15a528573ccd89ae$export$12e572fd459c10dc));
            let isUnassigned = isAssigneeUnassigned;
            const hasUnassignedVersion = Boolean(filterType === (0, $15a528573ccd89ae$export$a4ad2735b021c132) && filters[0, $15a528573ccd89ae$export$a4ad2735b021c132]);
            const hasUnassignedLabel = Boolean(filterType === (0, $15a528573ccd89ae$export$37aee82a3cb1e8f7) && filters[0, $15a528573ccd89ae$export$37aee82a3cb1e8f7]);
            const hasUnassignedComponent = Boolean(filterType === (0, $15a528573ccd89ae$export$af1e30ebbae9df3b) && filters[0, $15a528573ccd89ae$export$af1e30ebbae9df3b]);
            hasUnassignedOption = hasUnassignedAssignee || hasUnassignedVersion || hasUnassignedLabel || hasUnassignedComponent;
            const isVersionUnassigned = filters[0, $15a528573ccd89ae$export$a4ad2735b021c132]?.includes((0, $15a528573ccd89ae$export$ac95b4b2317d4b33));
            const isLabelUnassigned = filters[0, $15a528573ccd89ae$export$37aee82a3cb1e8f7]?.includes((0, $15a528573ccd89ae$export$81ef49afbbead0a1));
            const isComponentUnassigned = filters[0, $15a528573ccd89ae$export$af1e30ebbae9df3b]?.includes((0, $15a528573ccd89ae$export$4b7c755e61199a36));
            isUnassigned = isAssigneeUnassigned || isVersionUnassigned || isLabelUnassigned || isComponentUnassigned;
            const attributes = hasUnassignedOption ? {
                filterType: filterType,
                isUnassigned: isUnassigned,
                ...extraAttributes || {}
            } : {
                filterType: filterType,
                ...extraAttributes || {}
            };
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'changeFilterBar', attributes);
        }, [
            createAnalyticsEvent,
            onChange
        ]);
        const onClear = (0, $5uXOq.useCallback)(()=>{
            onClearAllButtonClicked();
            const clickedAnalyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            });
            const clearedAnalyticsEvent = createAnalyticsEvent({
                action: 'changed',
                actionSubject: 'filterBar'
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(clickedAnalyticsEvent, 'clearFiltersButton');
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(clearedAnalyticsEvent, 'changeFilterBar', {
                filterType: (0, $15a528573ccd89ae$export$6c4d37c7f376a1de)
            });
        }, [
            createAnalyticsEvent,
            onClearAllButtonClicked
        ]);
        const FilterBar = (0, (0, parcelRequire("kbfkr")).default);
        const sortedGoals = [
            ...goals
        ].sort((a, b)=>collator.compare(a.name, b.name));
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                isMacroView ? "_19bv1ejb" : "_19bvidpf"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(FilterBar, {
            ...filterProps,
            goals: sortedGoals,
            externalId: "software.roadmap",
            screenName: "roadmap",
            onChange: onFilterChanged,
            onClearAllButtonClicked: onClear,
            isVersionsFeatureEnabled: versions.length > 0,
            isLabelsFeatureEnabled: labels.length > 0,
            isComponentsFeatureEnabled: components.length > 0,
            isGoalsFeatureOptionEnabled: goals.length > 0,
            showPanelToggle: false,
            showSearchFilterChangeboarding: !isMacroView,
            hijackBrowserDefaultSearch: !isMacroView,
            isUnassignedAssigneeOptionEnabled: true,
            isUnassignedVersionOptionEnabled: true,
            isUnassignedLabelOptionEnabled: true,
            isUnassignedComponentOptionEnabled: true,
            jqlFilters: jqlFilters,
            CustomFilter: $f1519c516ab31c7d$var$RoadmapCustomFilter,
            showCustomFilters: !isCMP,
            placeholder: formatMessage((0, (0, parcelRequire("2GIeL")).default).filterPlaceholder),
            isCustomFiltersLoading: isCustomFiltersLoading
        }));
    };
    $f1519c516ab31c7d$var$Filter.whyDidYouRender = true;
    var $f1519c516ab31c7d$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($f1519c516ab31c7d$var$Filter);
    const $f1519c516ab31c7d$var$macroViewStyles = null;
    const $f1519c516ab31c7d$var$nonMacroViewStyles = null;
});
parcelRegister("9vASA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0c0f814f674e18a1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $koVbs;
    var $14uhY;
    var $96s6B;
    var $78uGw;
    const $0c0f814f674e18a1$var$MAX_SELECTION_ALLOWED = 10;
    const $0c0f814f674e18a1$var$CustomFilter = ({ filters: filters = [], selectedFilters: selectedFilters = [], showLink: showLink = false, manageUrl: manageUrl = '', onChange: onChange = (0, ($parcel$interopDefault($8Rkzz))), isNested: isNested = false, isCompanyManaged: isCompanyManaged = false, isPanelToggleChecked: isPanelToggleChecked = false, onTogglePanel: onTogglePanel = (0, ($parcel$interopDefault($8Rkzz))), showPanelToggle: showPanelToggle = false, shouldReturnFocus: shouldReturnFocus })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const values = (0, $5uXOq.useMemo)(()=>filters.map((filter)=>({
                    label: filter.name,
                    value: filter.id
                })), [
            filters
        ]);
        const onChangeMapValues = (0, $5uXOq.useCallback)((entries)=>{
            const analyticAttributes = {
                isNested: isNested
            };
            onChange(entries.map((entry)=>entry.value), analyticAttributes);
        }, [
            onChange,
            isNested
        ]);
        const maxSelectionReachedTooltip = formatMessage((0, (0, parcelRequire("78uGw")).default).maxSelectionReachedTooltip, {
            maxSelectionAllowed: $0c0f814f674e18a1$var$MAX_SELECTION_ALLOWED
        });
        const onLinkItemClick = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("14uhY")).setReturnToProjectUrl)();
        }, []);
        const filterLabel = isCompanyManaged ? (0, (0, parcelRequire("78uGw")).default).labelCmp : (0, (0, parcelRequire("78uGw")).default).label;
        const manageLinkTitle = isCompanyManaged ? (0, (0, parcelRequire("78uGw")).default).manageLinkTitleCmp : (0, (0, parcelRequire("78uGw")).default).manageLinkTitle;
        const toggleLabel = isCompanyManaged ? formatMessage((0, (0, parcelRequire("78uGw")).default).toggleLabelCmp) : undefined;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("96s6B")).default), {
            shouldReturnFocus: shouldReturnFocus,
            buttonType: "QuickFilters",
            "data-testid": "filters.ui.filters.custom.assignee-filter",
            label: formatMessage(filterLabel),
            values: values,
            selectedValues: selectedFilters,
            onChange: onChangeMapValues,
            showLink: showLink,
            url: manageUrl,
            useHrefForUrl: isCompanyManaged,
            linkTitle: formatMessage(manageLinkTitle),
            maxSelectionAllowed: isCompanyManaged ? undefined : $0c0f814f674e18a1$var$MAX_SELECTION_ALLOWED,
            maxSelectionReachedTooltip: maxSelectionReachedTooltip,
            isNested: isNested,
            onLinkItemClick: onLinkItemClick,
            showPanelToggle: showPanelToggle,
            onTogglePanel: onTogglePanel,
            isPanelToggleChecked: isPanelToggleChecked,
            toggleLabel: toggleLabel
        });
    };
    const $0c0f814f674e18a1$var$CustomFilterComponent = (0, $5uXOq.memo)($0c0f814f674e18a1$var$CustomFilter);
    $0c0f814f674e18a1$var$CustomFilterComponent.displayName = 'CustomFilter';
    $0c0f814f674e18a1$var$CustomFilterComponent.whyDidYouRender = true;
    var $0c0f814f674e18a1$export$2e2bcd8739ae039 = $0c0f814f674e18a1$var$CustomFilterComponent;
});
parcelRegister("14uhY", function(module, exports) {
    $parcel$export(module.exports, "setReturnToProjectUrl", ()=>$5f614763a26e8877$export$127f7bd1c092fc8f);
    $parcel$export(module.exports, "getReturnToProjectUrl", ()=>$5f614763a26e8877$export$575dc7c4a154874b);
    var $eNf8a;
    const $5f614763a26e8877$var$RETURN_TO_PROJECT_URL = 'returnToProjectUrl';
    const $5f614763a26e8877$var$sessionStorage = (0, (0, parcelRequire("eNf8a")).createSessionExpirableStorageProvider)('navigation');
    const $5f614763a26e8877$export$127f7bd1c092fc8f = ()=>{
        $5f614763a26e8877$var$sessionStorage.set($5f614763a26e8877$var$RETURN_TO_PROJECT_URL, window.location.pathname + window.location.search);
    };
    const $5f614763a26e8877$export$575dc7c4a154874b = ()=>String($5f614763a26e8877$var$sessionStorage.get($5f614763a26e8877$var$RETURN_TO_PROJECT_URL) || '');
});
parcelRegister("96s6B", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$51e7460acbb65361$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $2NMNM;
    var $itpgN;
    var $bChGW;
    var $b9dFI;
    var $dqoiX;
    var $4R6GH;
    var $koVbs;
    var $8zOmE;
    var $8C9C3;
    var $dF38k;
    var $73s29;
    var $d9hVL;
    var $4Mv0u;
    var $ijTad;
    const $51e7460acbb65361$var$MenuListWrapper = ({ children: children, ...rest })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "filters.common.ui.list.menu-list-wrapper"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).MenuList, rest, children));
    const $51e7460acbb65361$export$fa71ab09534e6447 = ({ isOpen: defaultIsOpen, isTriggerDisabled: isTriggerDisabled, isNested: isNested, isLoading: isLoading, isAsyncSearch: isAsyncSearch, showMenuIfValuesAreEmpty: showMenuIfValuesAreEmpty, label: label, toggleLabel: toggleLabel, buttonType: buttonType, values: values, selectedValues: selectedValueIds, onChange: onChange, onInputChange: onInputChange, onOpenChange: onOpenChange, noOptionsMessage: noOptionsMessage, menuGroupTitle: menuGroupTitle, inputValue: inputValue, maxSelectionAllowed: maxSelectionAllowed, maxSelectionReachedTooltip: maxSelectionReachedTooltip, onMouseEnterToTriggerButton: onMouseEnterToTriggerButton, CustomOptionLabel: CustomOptionLabel, placeholder: placeholder, shouldReturnFocus: shouldReturnFocus, ...footerProps })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const firstRender = (0, $5uXOq.useRef)(true);
        const options = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("ijTad")).getOptionsFromProps)({
                values: values,
                menuGroupTitle: menuGroupTitle
            }), [
            values,
            menuGroupTitle
        ]);
        const { optionsWithSelectedSection: optionsWithSelectedSection, updateSelectedOptionGroup: updateSelectedOptionGroup, shouldTrackExperimentEvents: shouldTrackExperimentEvents } = (0, (0, parcelRequire("ijTad")).useGetOptionsWithSelectedOptionGroup)();
        if (firstRender.current === true && defaultIsOpen === true && (0, (0, parcelRequire("4R6GH")).fg)('jira-make-it-easier-to-deselect-filter-items-gate')) updateSelectedOptionGroup({
            isOpen: defaultIsOpen,
            options: options,
            selectedValueIds: selectedValueIds
        });
        if (firstRender.current === true) firstRender.current = false;
        const { selectedIdLookup: selectedIdLookup, selectedOptions: selectedOptions } = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("ijTad")).getSelectedOptionsFromProps)({
                values: values,
                selectedValueIds: selectedValueIds
            }), [
            values,
            selectedValueIds
        ]);
        const previousSelectedCount = (0, $5uXOq.useRef)(selectedValueIds.length);
        if (!showMenuIfValuesAreEmpty && !isAsyncSearch && values.length === 0) return null;
        const onChangeHandler = (selected)=>{
            onChange(selected);
            if (shouldTrackExperimentEvents.current === true && (0, (0, parcelRequire("4R6GH")).fg)('jira-make-it-easier-to-deselect-filter-items-gate')) {
                if (selected.length > previousSelectedCount.current) (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                    actionSubject: 'filterItem',
                    action: 'selected',
                    actionSubjectId: 'listFilter'
                }));
                else if (selected.length < previousSelectedCount.current) (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                    actionSubject: 'filterItem',
                    action: 'deselected',
                    actionSubjectId: 'listFilter'
                }));
                previousSelectedCount.current = selected.length;
            }
        };
        const onOpenChangeHandler = (isOpen)=>{
            const analyticsEvent = createAnalyticsEvent((0, (0, parcelRequire("8C9C3")).OPEN_CHANGE_PAYLOAD));
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, (0, (0, parcelRequire("8C9C3")).OPEN_CHANGE_SUBJECT_ID));
            onOpenChange(isOpen);
            updateSelectedOptionGroup({
                isOpen: isOpen,
                options: options,
                selectedValueIds: selectedValueIds
            });
        };
        const isOptionDisabled = (option)=>selectedOptions.length >= maxSelectionAllowed && !selectedIdLookup.has(option.value.toString());
        const getNoOptionsMessage = noOptionsMessage === undefined ? noOptionsMessage : ()=>noOptionsMessage;
        const renderTrigger = (popupProps)=>(0, (0, parcelRequire("4R6GH")).fg)('allow_jplat_filter_list_to_be_disabled') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4Mv0u")).default), {
                ...popupProps,
                isDisabled: isTriggerDisabled,
                shouldReturnFocus: shouldReturnFocus,
                buttonType: buttonType,
                label: label,
                selectedCount: selectedOptions.length,
                isNested: isNested,
                onMouseEnter: onMouseEnterToTriggerButton
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4Mv0u")).default), {
                ...popupProps,
                shouldReturnFocus: shouldReturnFocus,
                buttonType: buttonType,
                label: label,
                selectedCount: selectedOptions.length,
                isNested: isNested,
                onMouseEnter: onMouseEnterToTriggerButton
            });
        const renderFooter = ()=>(footerProps.showLink || footerProps.showPanelToggle) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dF38k")).default), {
                label: label,
                toggleLabel: toggleLabel,
                ...footerProps
            });
        const renderOption = (option)=>{
            const { label: optionLabel, iconUrl: iconUrl, subLabel: subLabel, value: value } = option;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d9hVL")).default), {
                label: optionLabel,
                subLabel: subLabel,
                iconUrl: iconUrl,
                value: String(value),
                isDisabled: isOptionDisabled(option),
                maxSelectionReachedTooltip: maxSelectionReachedTooltip,
                CustomOptionLabel: CustomOptionLabel ?? (0, (0, parcelRequire("d9hVL")).DefaultOptionLabel)
            });
        };
        const onKeyDown = (event)=>{
            if (event.key === 'Escape') event.stopPropagation();
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b9dFI")).default), {
            "aria-label": `Select ${label} filters`,
            isMulti: true,
            isLoading: isLoading,
            backspaceRemovesValue: true,
            hideSelectedOptions: false,
            closeMenuOnSelect: false,
            defaultIsOpen: defaultIsOpen,
            options: optionsWithSelectedSection || options,
            value: selectedOptions,
            inputValue: inputValue,
            noOptionsMessage: getNoOptionsMessage,
            placeholder: placeholder ?? formatMessage((0, (0, parcelRequire("73s29")).default).placeholder),
            target: renderTrigger,
            footer: renderFooter(),
            formatOptionLabel: renderOption,
            components: {
                Option: (0, (0, parcelRequire("itpgN")).CheckboxOption),
                DropdownIndicator: null,
                MenuList: $51e7460acbb65361$var$MenuListWrapper
            },
            popperProps: {
                placement: isNested ? 'right-start' : 'bottom-start',
                strategy: 'fixed'
            },
            onChange: onChangeHandler,
            onInputChange: onInputChange,
            isOptionDisabled: isOptionDisabled,
            onMenuOpen: ()=>onOpenChangeHandler(true),
            onMenuClose: ()=>onOpenChangeHandler(false),
            onKeyDown: onKeyDown,
            ...(0, (0, parcelRequire("ijTad")).getSearchableProps)({
                isAsyncSearch: isAsyncSearch,
                optionsCount: values.length,
                isNested: isNested
            }),
            styles: optionsWithSelectedSection ? {
                group: (base, props)=>{
                    const borderStyles = props.data.label === formatMessage((0, (0, parcelRequire("73s29")).default).selectedItemsGroupLabel) ? {
                        borderBottom: `1px solid ${`var(--ds-border, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`}`
                    } : {};
                    return {
                        ...base,
                        ...borderStyles,
                        padding: 0
                    };
                },
                groupHeading: (base, props)=>{
                    if (props.data.label === formatMessage((0, (0, parcelRequire("73s29")).default).selectedItemsGroupLabel)) return 0, (0, parcelRequire("dqoiX")).visuallyHiddenStyles;
                    return base;
                }
            } : undefined
        });
    };
    $51e7460acbb65361$export$fa71ab09534e6447.defaultProps = {
        isOpen: false,
        isNested: false,
        isTriggerDisabled: false,
        isLoading: false,
        isAsyncSearch: false,
        isPanelToggleChecked: false,
        showLink: false,
        showPanelToggle: false,
        showMenuIfValuesAreEmpty: false,
        useHrefForUrl: false,
        values: [],
        selectedValues: [],
        menuGroupTitle: undefined,
        noOptionsMessage: undefined,
        maxSelectionAllowed: Number.MAX_SAFE_INTEGER,
        url: undefined,
        linkTitle: undefined,
        onChange: (0, ($parcel$interopDefault($8Rkzz))),
        onOpenChange: (0, ($parcel$interopDefault($8Rkzz))),
        onInputChange: (0, ($parcel$interopDefault($8Rkzz))),
        onTogglePanel: (0, ($parcel$interopDefault($8Rkzz))),
        onLinkItemClick: (0, ($parcel$interopDefault($8Rkzz))),
        onMouseEnterToTriggerButton: (0, ($parcel$interopDefault($8Rkzz))),
        toggleRef: (0, ($parcel$interopDefault($8Rkzz)))
    };
    var $51e7460acbb65361$export$2e2bcd8739ae039 = $51e7460acbb65361$export$fa71ab09534e6447;
});
parcelRegister("itpgN", function(module, exports) {
    $parcel$export(module.exports, "CheckboxOption", ()=>$f5875245cd0ad0c1$export$d40cc97ecda916f9);
    $parcel$export(module.exports, "RadioOption", ()=>$f5875245cd0ad0c1$export$82ab7168879267a7);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6aY6N;
    var $iQHJo;
    function $f5875245cd0ad0c1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $f5875245cd0ad0c1$var$getPrimitiveStyles = (props)=>{
        const { cx: cx, className: className, getStyles: getStyles, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected } = props;
        const baseStyles = {
            alignItems: 'center',
            backgroundColor: isFocused ? `var(--ds-background-neutral-subtle-hovered, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})` : 'transparent',
            color: isDisabled ? "var(--ds-text-disabled, inherit)" : 'inherit',
            display: 'flex ',
            paddingBottom: "var(--ds-space-050, 4px)",
            paddingLeft: "var(--ds-space-200, 16px)",
            paddingTop: "var(--ds-space-050, 4px)",
            boxShadow: isFocused ? `inset 2px 0px 0px ${`var(--ds-border-focused, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`}` : 'none',
            ':active': {
                backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`
            },
            '@media screen and (-ms-high-contrast: active)': {
                borderLeft: isFocused ? '2px solid transparent' : ''
            }
        };
        const augmentedStyles = (0, (0, parcelRequire("f8Sb3")).css)({
            ...getStyles('option', props),
            ...baseStyles
        });
        const bemClasses = {
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        };
        return [
            augmentedStyles,
            cx(bemClasses, className)
        ];
    };
    const $f5875245cd0ad0c1$var$getPrimaryColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
        if (isDisabled && isSelected) return `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$8c13c2ee36917869})`;
        else if (isDisabled) return `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$8d43898f60b96a82})`;
        else if (isSelected && isActive) return `var(--ds-background-selected-bold-pressed, ${0, $829f609a65d26a98$export$8c13c2ee36917869})`;
        else if (isActive) return `var(--ds-background-selected-pressed, ${0, $829f609a65d26a98$export$8c13c2ee36917869})`;
        else if (isFocused && isSelected) return `var(--ds-background-selected-bold-hovered, ${0, $829f609a65d26a98$export$e62e8919cca44969})`;
        else if (isFocused) return `var(--ds-surface, ${0, $829f609a65d26a98$export$29a4f05edc054374})`;
        else if (isSelected) return `var(--ds-background-selected-bold, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
        return `var(--ds-background-neutral, ${0, $829f609a65d26a98$export$29a4f05edc054374})`;
    };
    const $f5875245cd0ad0c1$var$getSecondaryColor = ({ isActive: isActive, isDisabled: isDisabled, isSelected: isSelected })=>{
        if (isDisabled && isSelected) return `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`;
        else if (isActive && isSelected && !isDisabled) return `var(--ds-surface, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
        else if (!isSelected) return 'transparent';
        return `var(--ds-surface, ${0, $829f609a65d26a98$export$29a4f05edc054374})`;
    };
    const $f5875245cd0ad0c1$var$getBorderColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
        if (isDisabled && isSelected) return `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
        else if (isDisabled) return `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$d6447c357493214f})`;
        else if (isSelected && isActive) return `var(--ds-background-selected-bold-pressed, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
        else if (isActive) return `var(--ds-background-selected-bold, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
        else if (isFocused && isSelected) return `var(--ds-background-selected-bold-hovered, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
        else if (isFocused) return `var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`;
        else if (isSelected) return `var(--ds-background-selected-bold, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
        return `var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`;
    };
    const $f5875245cd0ad0c1$var$baseIconStyles = {
        name: "35x0q3",
        styles: "display:flex ;align-items:center;flex-shrink:0;padding-inline-end:var(--ds-space-050, 4px);& svg rect, & svg circle:first-of-type{stroke-linejoin:round;stroke-width:var(--ds-border-width, 1px);}"
    };
    const $f5875245cd0ad0c1$var$baseOptionStyles = {
        name: "16e0ede",
        styles: "flex-grow:1;overflow-x:hidden;text-overflow:ellipsis;white-space:nowrap"
    };
    class $f5875245cd0ad0c1$var$ControlOption extends (0, $5uXOq.Component) {
        render() {
            const { getStyles: getStyles, Icon: Icon, children: children, innerProps: innerProps, innerRef: innerRef, ...rest } = this.props;
            const props = {
                ...innerProps,
                onMouseDown: this.onMouseDown,
                onMouseUp: this.onMouseUp,
                onMouseLeave: this.onMouseLeave
            };
            const [styles, classes] = $f5875245cd0ad0c1$var$getPrimitiveStyles({
                getStyles: getStyles,
                ...rest
            });
            return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: styles,
                className: classes,
                ref: innerRef,
                ...props
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: [
                    $f5875245cd0ad0c1$var$baseIconStyles,
                    {
                        '& svg rect, & svg circle:first-of-type': {
                            stroke: $f5875245cd0ad0c1$var$getBorderColor({
                                ...this.props,
                                ...this.state
                            })
                        }
                    }
                ]
            }, !!Icon ? (0, (0, parcelRequire("f8Sb3")).jsx)(Icon, {
                label: "",
                primaryColor: $f5875245cd0ad0c1$var$getPrimaryColor({
                    ...this.props,
                    ...this.state
                }),
                secondaryColor: $f5875245cd0ad0c1$var$getSecondaryColor({
                    ...this.props,
                    ...this.state
                }),
                isFacadeDisabled: true
            }) : null), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $f5875245cd0ad0c1$var$baseOptionStyles
            }, children)));
        }
        constructor(...args){
            super(...args);
            this.state = {
                isActive: false
            };
            this.onMouseDown = ()=>this.setState({
                    isActive: true
                });
            this.onMouseUp = ()=>this.setState({
                    isActive: false
                });
            this.onMouseLeave = ()=>this.setState({
                    isActive: false
                });
        }
    }
    const $f5875245cd0ad0c1$export$d40cc97ecda916f9 = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)($f5875245cd0ad0c1$var$ControlOption, {
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("6aY6N"))))),
            ...props
        });
    const $f5875245cd0ad0c1$export$82ab7168879267a7 = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)($f5875245cd0ad0c1$var$ControlOption, {
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("iQHJo"))))),
            ...props
        });
});
parcelRegister("6aY6N", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $47f24d9003b82760$var$_react = $47f24d9003b82760$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $47f24d9003b82760$var$_checkboxChecked = $47f24d9003b82760$var$_interopRequireDefault((parcelRequire("aoKYM")));
    function $47f24d9003b82760$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $47f24d9003b82760$var$CheckboxIcon = (props)=>$47f24d9003b82760$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><rect width="12" height="12" x="6" y="6" fill="currentcolor" rx="2"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
        }, props, {
            newIcon: $47f24d9003b82760$var$_checkboxChecked.default
        }));
    $47f24d9003b82760$var$CheckboxIcon.displayName = 'CheckboxIcon';
    var $47f24d9003b82760$var$_default = module.exports.default = $47f24d9003b82760$var$CheckboxIcon;
});
parcelRegister("aoKYM", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $79209663d32c0c44$var$_react = $79209663d32c0c44$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $79209663d32c0c44$var$_UNSAFE_baseNew = $79209663d32c0c44$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $79209663d32c0c44$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $79209663d32c0c44$var$CheckboxCheckedIcon = (props)=>$79209663d32c0c44$var$_react.default.createElement($79209663d32c0c44$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm9.326 4.48-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
        }, props));
    $79209663d32c0c44$var$CheckboxCheckedIcon.displayName = 'CheckboxCheckedIcon';
    var $79209663d32c0c44$var$_default = module.exports.default = $79209663d32c0c44$var$CheckboxCheckedIcon;
});
parcelRegister("iQHJo", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $db8f016a0af5fda9$var$_react = $db8f016a0af5fda9$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $db8f016a0af5fda9$var$_radioChecked = $db8f016a0af5fda9$var$_interopRequireDefault((parcelRequire("kqGQn")));
    function $db8f016a0af5fda9$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $db8f016a0af5fda9$var$RadioIcon = (props)=>$db8f016a0af5fda9$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="6" fill="currentcolor"/><circle cx="12" cy="12" r="2" fill="inherit"/></g></svg>`
        }, props, {
            newIcon: $db8f016a0af5fda9$var$_radioChecked.default
        }));
    $db8f016a0af5fda9$var$RadioIcon.displayName = 'RadioIcon';
    var $db8f016a0af5fda9$var$_default = module.exports.default = $db8f016a0af5fda9$var$RadioIcon;
});
parcelRegister("kqGQn", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $edf7783e719984ba$var$_react = $edf7783e719984ba$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $edf7783e719984ba$var$_UNSAFE_baseNew = $edf7783e719984ba$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $edf7783e719984ba$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $edf7783e719984ba$var$RadioCheckedIcon = (props)=>$edf7783e719984ba$var$_react.default.createElement($edf7783e719984ba$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6" clip-rule="evenodd"/>`
        }, props));
    $edf7783e719984ba$var$RadioCheckedIcon.displayName = 'RadioCheckedIcon';
    var $edf7783e719984ba$var$_default = module.exports.default = $edf7783e719984ba$var$RadioCheckedIcon;
});
parcelRegister("bChGW", function(module, exports) {
    $parcel$export(module.exports, "components", ()=>$ea75c1778b4e3ad2$export$9b5ac10f59f76296);
    $parcel$export(module.exports, "defaultComponents", ()=>$ea75c1778b4e3ad2$export$71abc632aa29e6fe);
    var $h1QWG;
    var $eZFhY;
    var $i48X9;
    var $95iuW;
    var $dS5G5;
    var $aA8TC;
    var $hqcPo;
    var $8l2RA;
    var $kKm82;
    var $hpcbi;
    const $ea75c1778b4e3ad2$export$9b5ac10f59f76296 = {
        ClearIndicator: (0, (0, parcelRequire("95iuW")).ClearIndicator),
        Control: (0, (0, parcelRequire("eZFhY")).default),
        DropdownIndicator: (0, (0, parcelRequire("95iuW")).DropdownIndicator),
        DownChevron: (0, (0, parcelRequire("95iuW")).DownChevron),
        CrossIcon: (0, (0, parcelRequire("95iuW")).CrossIcon),
        Group: (0, (0, parcelRequire("i48X9")).default),
        GroupHeading: (0, (0, parcelRequire("i48X9")).GroupHeading),
        IndicatorsContainer: (0, (0, parcelRequire("h1QWG")).IndicatorsContainer),
        IndicatorSeparator: (0, (0, parcelRequire("95iuW")).IndicatorSeparator),
        Input: (0, (0, parcelRequire("dS5G5")).default),
        LoadingIndicator: (0, (0, parcelRequire("95iuW")).LoadingIndicator),
        Menu: (0, (0, parcelRequire("aA8TC")).default),
        MenuList: (0, (0, parcelRequire("aA8TC")).MenuList),
        MenuPortal: (0, (0, parcelRequire("aA8TC")).MenuPortal),
        LoadingMessage: (0, (0, parcelRequire("aA8TC")).LoadingMessage),
        NoOptionsMessage: (0, (0, parcelRequire("aA8TC")).NoOptionsMessage),
        MultiValue: (0, (0, parcelRequire("hqcPo")).default),
        MultiValueContainer: (0, (0, parcelRequire("hqcPo")).MultiValueContainer),
        MultiValueLabel: (0, (0, parcelRequire("hqcPo")).MultiValueLabel),
        MultiValueRemove: (0, (0, parcelRequire("hqcPo")).MultiValueRemove),
        Option: (0, (0, parcelRequire("8l2RA")).default),
        Placeholder: (0, (0, parcelRequire("kKm82")).default),
        SelectContainer: (0, (0, parcelRequire("h1QWG")).SelectContainer),
        SingleValue: (0, (0, parcelRequire("hpcbi")).default),
        ValueContainer: (0, (0, parcelRequire("h1QWG")).ValueContainer)
    };
    const $ea75c1778b4e3ad2$export$71abc632aa29e6fe = (props)=>({
            ...$ea75c1778b4e3ad2$export$9b5ac10f59f76296,
            ...props.components
        });
});
parcelRegister("h1QWG", function(module, exports) {
    $parcel$export(module.exports, "containerCSS", ()=>$78186faf13ea75d3$export$949392aeaf7d2e3a);
    $parcel$export(module.exports, "SelectContainer", ()=>$78186faf13ea75d3$export$446eebadefe1123b);
    $parcel$export(module.exports, "valueContainerCSS", ()=>$78186faf13ea75d3$export$47aec73c7aa6b9aa);
    $parcel$export(module.exports, "ValueContainer", ()=>$78186faf13ea75d3$export$4dc9f58ad9a1a000);
    $parcel$export(module.exports, "indicatorsContainerCSS", ()=>$78186faf13ea75d3$export$9d74e3c8b5868ad7);
    $parcel$export(module.exports, "IndicatorsContainer", ()=>$78186faf13ea75d3$export$d0ffd7e649cab6f);
    var $f8Sb3;
    var $gyjU7;
    const $78186faf13ea75d3$export$949392aeaf7d2e3a = ({ isDisabled: isDisabled, isRtl: isRtl })=>({
            label: 'container',
            direction: isRtl ? 'rtl' : undefined,
            pointerEvents: isDisabled ? 'none' : undefined,
            position: 'relative'
        });
    const $78186faf13ea75d3$export$446eebadefe1123b = (props)=>{
        const { children: children, innerProps: innerProps, isDisabled: isDisabled, isRtl: isRtl } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'container', {
                '--is-disabled': isDisabled,
                '--is-rtl': isRtl
            }),
            ...innerProps
        }, children);
    };
    const $78186faf13ea75d3$export$47aec73c7aa6b9aa = ({ theme: { spacing: spacing }, isMulti: isMulti, hasValue: hasValue, selectProps: { controlShouldRenderValue: controlShouldRenderValue } }, unstyled)=>({
            alignItems: 'center',
            display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
            flex: 1,
            flexWrap: 'wrap',
            WebkitOverflowScrolling: 'touch',
            position: 'relative',
            overflow: 'hidden',
            ...unstyled ? {} : {
                padding: `${spacing.baseUnit / 2}px ${spacing.baseUnit * 2}px`
            }
        });
    const $78186faf13ea75d3$export$4dc9f58ad9a1a000 = (props)=>{
        const { children: children, innerProps: innerProps, isMulti: isMulti, hasValue: hasValue } = props;
        const styles = (0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'valueContainer', {
            'value-container': true,
            'value-container--is-multi': isMulti,
            'value-container--has-value': hasValue
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: styles.css,
            className: styles.className || 'value-container',
            ...innerProps
        }, children);
    };
    const $78186faf13ea75d3$export$9d74e3c8b5868ad7 = ()=>({
            alignItems: 'center',
            alignSelf: 'stretch',
            display: 'flex',
            flexShrink: 0
        });
    const $78186faf13ea75d3$export$d0ffd7e649cab6f = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'indicatorsContainer', {
                indicators: true
            }),
            ...innerProps
        }, children);
    };
});
parcelRegister("gyjU7", function(module, exports) {
    $parcel$export(module.exports, "noop", ()=>$109d3f9af5469308$export$8793edee2d425525);
    $parcel$export(module.exports, "classNames", ()=>$109d3f9af5469308$export$ce4ab0c55987d1ff);
    $parcel$export(module.exports, "cleanValue", ()=>$109d3f9af5469308$export$33f062f47f21a01);
    $parcel$export(module.exports, "cleanCommonProps", ()=>$109d3f9af5469308$export$8e9fd4287627890c);
    $parcel$export(module.exports, "getStyleProps", ()=>$109d3f9af5469308$export$26417cabd806a658);
    $parcel$export(module.exports, "handleInputChange", ()=>$109d3f9af5469308$export$2096bae78ecda911);
    $parcel$export(module.exports, "isDocumentElement", ()=>$109d3f9af5469308$export$d8a62a489b442872);
    $parcel$export(module.exports, "normalizedHeight", ()=>$109d3f9af5469308$export$2e0654fad740d2e4);
    $parcel$export(module.exports, "getScrollTop", ()=>$109d3f9af5469308$export$c4a223a8ba9e4ea5);
    $parcel$export(module.exports, "scrollTo", ()=>$109d3f9af5469308$export$3f99968195accfaf);
    $parcel$export(module.exports, "getScrollParent", ()=>$109d3f9af5469308$export$cfa2225e87938781);
    $parcel$export(module.exports, "animatedScrollTo", ()=>$109d3f9af5469308$export$858c30343199f3af);
    $parcel$export(module.exports, "scrollIntoView", ()=>$109d3f9af5469308$export$53a0910f038337bd);
    $parcel$export(module.exports, "getBoundingClientObj", ()=>$109d3f9af5469308$export$7807c2a424c2f6d1);
    $parcel$export(module.exports, "isTouchCapable", ()=>$109d3f9af5469308$export$56963d77dbffdde7);
    $parcel$export(module.exports, "isMobileDevice", ()=>$109d3f9af5469308$export$44f917bf91becd01);
    $parcel$export(module.exports, "supportsPassiveEvents", ()=>$109d3f9af5469308$export$b0622a6911dbeaf5);
    $parcel$export(module.exports, "notNullish", ()=>$109d3f9af5469308$export$aedb69ff3e31596c);
    $parcel$export(module.exports, "valueTernary", ()=>$109d3f9af5469308$export$40fb9515c784cc3b);
    $parcel$export(module.exports, "singleValueAsValue", ()=>$109d3f9af5469308$export$dea4763e29237f4c);
    $parcel$export(module.exports, "multiValueAsValue", ()=>$109d3f9af5469308$export$d1ca752ec761b95b);
    $parcel$export(module.exports, "removeProps", ()=>$109d3f9af5469308$export$4213b25a1c4e877);
    const $109d3f9af5469308$export$8793edee2d425525 = ()=>{};
    const $109d3f9af5469308$export$1643ccb46f49255c = ()=>'';
    function $109d3f9af5469308$var$applyPrefixToName(prefix, name) {
        if (!name) return prefix;
        else if (name[0] === '-') return prefix + name;
        else return prefix + '__' + name;
    }
    function $109d3f9af5469308$export$ce4ab0c55987d1ff(prefix, state, ...classNameList) {
        const arr = [
            ...classNameList
        ];
        if (state && prefix) {
            for(let key in state)if (state.hasOwnProperty(key) && state[key]) arr.push(`${$109d3f9af5469308$var$applyPrefixToName(prefix, key)}`);
        }
        return arr.filter((i)=>i).map((i)=>String(i).trim()).join(' ');
    }
    const $109d3f9af5469308$export$33f062f47f21a01 = (value)=>{
        if ($109d3f9af5469308$export$43bee75e5e14138e(value)) return value.filter(Boolean);
        if (typeof value === 'object' && value !== null) return [
            value
        ];
        return [];
    };
    const $109d3f9af5469308$export$8e9fd4287627890c = (props)=>{
        const { className: className, clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, hasValue: hasValue, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, theme: theme, ...innerProps } = props;
        return {
            ...innerProps
        };
    };
    const $109d3f9af5469308$export$26417cabd806a658 = (props, name, classNamesState)=>{
        const { cx: cx, getStyles: getStyles, getClassNames: getClassNames, className: className } = props;
        return {
            css: getStyles(name, props),
            className: cx(classNamesState ?? {}, getClassNames(name, props), className)
        };
    };
    function $109d3f9af5469308$export$2096bae78ecda911(inputValue, actionMeta, onInputChange) {
        if (onInputChange) {
            const newValue = onInputChange(inputValue, actionMeta);
            if (typeof newValue === 'string') return newValue;
        }
        return inputValue;
    }
    function $109d3f9af5469308$export$d8a62a489b442872(el) {
        return [
            document.documentElement,
            document.body,
            window
        ].indexOf(el) > -1;
    }
    function $109d3f9af5469308$export$2e0654fad740d2e4(el) {
        if ($109d3f9af5469308$export$d8a62a489b442872(el)) return window.innerHeight;
        return el.clientHeight;
    }
    function $109d3f9af5469308$export$c4a223a8ba9e4ea5(el) {
        if ($109d3f9af5469308$export$d8a62a489b442872(el)) return window.pageYOffset;
        return el.scrollTop;
    }
    function $109d3f9af5469308$export$3f99968195accfaf(el, top) {
        if ($109d3f9af5469308$export$d8a62a489b442872(el)) {
            window.scrollTo(0, top);
            return;
        }
        el.scrollTop = top;
    }
    function $109d3f9af5469308$export$cfa2225e87938781(element) {
        let style = getComputedStyle(element);
        const excludeStaticParent = style.position === 'absolute';
        const overflowRx = /(auto|scroll)/;
        if (style.position === 'fixed') return document.documentElement;
        for(let parent = element; parent = parent.parentElement;){
            style = getComputedStyle(parent);
            if (excludeStaticParent && style.position === 'static') continue;
            if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
        }
        return document.documentElement;
    }
    function $109d3f9af5469308$var$easeOutCubic(t, b, c, d) {
        return c * ((t = t / d - 1) * t * t + 1) + b;
    }
    function $109d3f9af5469308$export$858c30343199f3af(element, to, duration = 200, callback = $109d3f9af5469308$export$8793edee2d425525) {
        const start = $109d3f9af5469308$export$c4a223a8ba9e4ea5(element);
        const change = to - start;
        const increment = 10;
        let currentTime = 0;
        function animateScroll() {
            currentTime += increment;
            const val = $109d3f9af5469308$var$easeOutCubic(currentTime, start, change, duration);
            $109d3f9af5469308$export$3f99968195accfaf(element, val);
            if (currentTime < duration) window.requestAnimationFrame(animateScroll);
            else callback(element);
        }
        animateScroll();
    }
    function $109d3f9af5469308$export$53a0910f038337bd(menuEl, focusedEl) {
        const menuRect = menuEl.getBoundingClientRect();
        const focusedRect = focusedEl.getBoundingClientRect();
        const overScroll = focusedEl.offsetHeight / 3;
        if (focusedRect.bottom + overScroll > menuRect.bottom) $109d3f9af5469308$export$3f99968195accfaf(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
        else if (focusedRect.top - overScroll < menuRect.top) $109d3f9af5469308$export$3f99968195accfaf(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
    }
    function $109d3f9af5469308$export$7807c2a424c2f6d1(element) {
        const rect = element.getBoundingClientRect();
        return {
            bottom: rect.bottom,
            height: rect.height,
            left: rect.left,
            right: rect.right,
            top: rect.top,
            width: rect.width
        };
    }
    function $109d3f9af5469308$export$c0d0115e766e14c3(str) {
        return str.replace(/\W/g, '-');
    }
    function $109d3f9af5469308$export$56963d77dbffdde7() {
        try {
            document.createEvent('TouchEvent');
            return true;
        } catch (e) {
            return false;
        }
    }
    function $109d3f9af5469308$export$44f917bf91becd01() {
        try {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        } catch (e) {
            return false;
        }
    }
    let $109d3f9af5469308$var$passiveOptionAccessed = false;
    const $109d3f9af5469308$var$options = {
        get passive () {
            return $109d3f9af5469308$var$passiveOptionAccessed = true;
        }
    };
    const $109d3f9af5469308$var$w = typeof window !== 'undefined' ? window : {};
    if ($109d3f9af5469308$var$w.addEventListener && $109d3f9af5469308$var$w.removeEventListener) {
        $109d3f9af5469308$var$w.addEventListener('p', $109d3f9af5469308$export$8793edee2d425525, $109d3f9af5469308$var$options);
        $109d3f9af5469308$var$w.removeEventListener('p', $109d3f9af5469308$export$8793edee2d425525, false);
    }
    const $109d3f9af5469308$export$b0622a6911dbeaf5 = $109d3f9af5469308$var$passiveOptionAccessed;
    function $109d3f9af5469308$export$aedb69ff3e31596c(item) {
        return item != null;
    }
    function $109d3f9af5469308$export$43bee75e5e14138e(arg) {
        return Array.isArray(arg);
    }
    function $109d3f9af5469308$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
        return isMulti ? multiValue : singleValue;
    }
    function $109d3f9af5469308$export$dea4763e29237f4c(singleValue) {
        return singleValue;
    }
    function $109d3f9af5469308$export$d1ca752ec761b95b(multiValue) {
        return multiValue;
    }
    const $109d3f9af5469308$export$4213b25a1c4e877 = (propsObj, ...properties)=>{
        let propsMap = Object.entries(propsObj).filter(([key])=>!properties.includes(key));
        return propsMap.reduce((newProps, [key, val])=>{
            newProps[key] = val;
            return newProps;
        }, {});
    };
});
parcelRegister("eZFhY", function(module, exports) {
    $parcel$export(module.exports, "css", ()=>$728816cb4150b6bc$export$dbf350e5966cf602);
    $parcel$export(module.exports, "default", ()=>$728816cb4150b6bc$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $728816cb4150b6bc$export$dbf350e5966cf602 = ({ isDisabled: isDisabled, isFocused: isFocused, theme: { colors: colors, borderRadius: borderRadius, spacing: spacing } }, unstyled)=>({
            label: 'control',
            alignItems: 'center',
            cursor: 'default',
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            minHeight: spacing.controlHeight,
            outline: '0 !important',
            position: 'relative',
            transition: 'all 100ms',
            ...unstyled ? {} : {
                backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
                borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
                borderRadius: borderRadius,
                borderStyle: 'solid',
                borderWidth: 1,
                boxShadow: isFocused ? `0 0 0 1px ${colors.primary}` : undefined,
                '&:hover': {
                    borderColor: isFocused ? colors.primary : colors.neutral30
                }
            }
        });
    const $728816cb4150b6bc$var$Control = (props)=>{
        const { children: children, isDisabled: isDisabled, isFocused: isFocused, innerRef: innerRef, innerProps: innerProps, menuIsOpen: menuIsOpen } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: innerRef,
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'control', {
                control: true,
                'control--is-disabled': isDisabled,
                'control--is-focused': isFocused,
                'control--menu-is-open': menuIsOpen
            }),
            ...innerProps,
            "aria-disabled": isDisabled || undefined
        }, children);
    };
    var $728816cb4150b6bc$export$2e2bcd8739ae039 = $728816cb4150b6bc$var$Control;
});
parcelRegister("i48X9", function(module, exports) {
    $parcel$export(module.exports, "groupCSS", ()=>$902e86f4b4fe337b$export$b6794329c1460634);
    $parcel$export(module.exports, "groupHeadingCSS", ()=>$902e86f4b4fe337b$export$e5a7fbb542efcb7d);
    $parcel$export(module.exports, "GroupHeading", ()=>$902e86f4b4fe337b$export$85c8b41a3cd87edc);
    $parcel$export(module.exports, "default", ()=>$902e86f4b4fe337b$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $902e86f4b4fe337b$export$b6794329c1460634 = ({ theme: { spacing: spacing } }, unstyled)=>unstyled ? {} : {
            paddingBottom: spacing.baseUnit * 2,
            paddingTop: spacing.baseUnit * 2
        };
    const $902e86f4b4fe337b$var$Group = (props)=>{
        const { children: children, cx: cx, getStyles: getStyles, getClassNames: getClassNames, Heading: Heading, headingProps: headingProps, innerProps: innerProps, label: label, theme: theme, selectProps: selectProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'group', {
                group: true
            }),
            ...innerProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)(Heading, {
            ...headingProps,
            selectProps: selectProps,
            theme: theme,
            getStyles: getStyles,
            getClassNames: getClassNames,
            cx: cx
        }, label), (0, (0, parcelRequire("f8Sb3")).jsx)("div", null, children));
    };
    const $902e86f4b4fe337b$export$e5a7fbb542efcb7d = ({ theme: { colors: colors, spacing: spacing } }, unstyled)=>({
            label: 'group',
            cursor: 'default',
            display: 'block',
            ...unstyled ? {} : {
                color: colors.neutral40,
                fontSize: '75%',
                fontWeight: 500,
                marginBottom: '0.25em',
                paddingLeft: spacing.baseUnit * 3,
                paddingRight: spacing.baseUnit * 3,
                textTransform: 'uppercase'
            }
        });
    const $902e86f4b4fe337b$export$85c8b41a3cd87edc = (props)=>{
        const { data: data, ...innerProps } = (0, (0, parcelRequire("gyjU7")).cleanCommonProps)(props);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'groupHeading', {
                'group-heading': true
            }),
            ...innerProps
        });
    };
    var $902e86f4b4fe337b$export$2e2bcd8739ae039 = $902e86f4b4fe337b$var$Group;
});
parcelRegister("95iuW", function(module, exports) {
    $parcel$export(module.exports, "CrossIcon", ()=>$13f090f36c42825d$export$3b621d86b1566b2);
    $parcel$export(module.exports, "DownChevron", ()=>$13f090f36c42825d$export$c5cbe1656ba71e6c);
    $parcel$export(module.exports, "dropdownIndicatorCSS", ()=>$13f090f36c42825d$export$e1687335805e1230);
    $parcel$export(module.exports, "DropdownIndicator", ()=>$13f090f36c42825d$export$ec98719d3db7f2e4);
    $parcel$export(module.exports, "clearIndicatorCSS", ()=>$13f090f36c42825d$export$9c0419fd944c1def);
    $parcel$export(module.exports, "ClearIndicator", ()=>$13f090f36c42825d$export$ecf9cf59142dd54a);
    $parcel$export(module.exports, "indicatorSeparatorCSS", ()=>$13f090f36c42825d$export$ec39646155d07fdd);
    $parcel$export(module.exports, "IndicatorSeparator", ()=>$13f090f36c42825d$export$bd638c2ba7915668);
    $parcel$export(module.exports, "loadingIndicatorCSS", ()=>$13f090f36c42825d$export$1d3f24cde248e6b5);
    $parcel$export(module.exports, "LoadingIndicator", ()=>$13f090f36c42825d$export$7c20be4c1d342248);
    var $f8Sb3;
    var $gyjU7;
    function $13f090f36c42825d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $13f090f36c42825d$var$styles = {
        name: "8mmkcg",
        styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
    };
    const $13f090f36c42825d$var$Svg = ({ size: size, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)("svg", {
            height: size,
            width: size,
            viewBox: "0 0 20 20",
            "aria-hidden": "true",
            focusable: "false",
            css: $13f090f36c42825d$var$styles,
            ...props
        });
    const $13f090f36c42825d$export$3b621d86b1566b2 = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$Svg, {
            size: 20,
            ...props
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
        }));
    const $13f090f36c42825d$export$c5cbe1656ba71e6c = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$Svg, {
            size: 20,
            ...props
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
        }));
    const $13f090f36c42825d$var$baseCSS = ({ isFocused: isFocused, theme: { spacing: { baseUnit: baseUnit }, colors: colors } }, unstyled)=>({
            label: 'indicatorContainer',
            display: 'flex',
            transition: 'color 150ms',
            ...unstyled ? {} : {
                color: isFocused ? colors.neutral60 : colors.neutral20,
                padding: baseUnit * 2,
                ':hover': {
                    color: isFocused ? colors.neutral80 : colors.neutral40
                }
            }
        });
    const $13f090f36c42825d$export$e1687335805e1230 = $13f090f36c42825d$var$baseCSS;
    const $13f090f36c42825d$export$ec98719d3db7f2e4 = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'dropdownIndicator', {
                indicator: true,
                'dropdown-indicator': true
            }),
            ...innerProps
        }, children || (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$export$c5cbe1656ba71e6c, null));
    };
    const $13f090f36c42825d$export$9c0419fd944c1def = $13f090f36c42825d$var$baseCSS;
    const $13f090f36c42825d$export$ecf9cf59142dd54a = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'clearIndicator', {
                indicator: true,
                'clear-indicator': true
            }),
            ...innerProps
        }, children || (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$export$3b621d86b1566b2, null));
    };
    const $13f090f36c42825d$export$ec39646155d07fdd = ({ isDisabled: isDisabled, theme: { spacing: { baseUnit: baseUnit }, colors: colors } }, unstyled)=>({
            label: 'indicatorSeparator',
            alignSelf: 'stretch',
            width: 1,
            ...unstyled ? {} : {
                backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
                marginBottom: baseUnit * 2,
                marginTop: baseUnit * 2
            }
        });
    const $13f090f36c42825d$export$bd638c2ba7915668 = (props)=>{
        const { innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            ...innerProps,
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'indicatorSeparator', {
                'indicator-separator': true
            })
        });
    };
    const $13f090f36c42825d$var$loadingDotAnimations = (0, (0, parcelRequire("f8Sb3")).keyframes)({
        '0%, 80%, 100%': {
            opacity: 0
        },
        '40%': {
            opacity: 1
        }
    });
    const $13f090f36c42825d$export$1d3f24cde248e6b5 = ({ isFocused: isFocused, size: size, theme: { colors: colors, spacing: { baseUnit: baseUnit } } }, unstyled)=>({
            label: 'loadingIndicator',
            display: 'flex',
            transition: 'color 150ms',
            alignSelf: 'center',
            fontSize: size,
            lineHeight: 1,
            marginRight: size,
            textAlign: 'center',
            verticalAlign: 'middle',
            ...unstyled ? {} : {
                color: isFocused ? colors.neutral60 : colors.neutral20,
                padding: baseUnit * 2
            }
        });
    const $13f090f36c42825d$var$LoadingDot = ({ delay: delay, offset: offset })=>(0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: (0, (0, parcelRequire("f8Sb3")).css)({
                animation: `${$13f090f36c42825d$var$loadingDotAnimations} 1s ease-in-out ${delay}ms infinite;`,
                backgroundColor: 'currentColor',
                borderRadius: '1em',
                display: 'inline-block',
                marginLeft: offset ? '1em' : undefined,
                height: '1em',
                verticalAlign: 'top',
                width: '1em'
            })
        });
    const $13f090f36c42825d$export$7c20be4c1d342248 = ({ innerProps: innerProps, isRtl: isRtl, size: size = 4, ...restProps })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)({
                ...restProps,
                innerProps: innerProps,
                isRtl: isRtl,
                size: size
            }, 'loadingIndicator', {
                indicator: true,
                'loading-indicator': true
            }),
            ...innerProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$LoadingDot, {
            delay: 0,
            offset: isRtl
        }), (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$LoadingDot, {
            delay: 160,
            offset: true
        }), (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$LoadingDot, {
            delay: 320,
            offset: !isRtl
        }));
    };
});
parcelRegister("dS5G5", function(module, exports) {
    $parcel$export(module.exports, "inputCSS", ()=>$1c949ac6f5985b40$export$14a7781d0ca7abea);
    $parcel$export(module.exports, "default", ()=>$1c949ac6f5985b40$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $1c949ac6f5985b40$export$14a7781d0ca7abea = ({ isDisabled: isDisabled, value: value, theme: { spacing: spacing, colors: colors } }, unstyled)=>({
            visibility: isDisabled ? 'hidden' : 'visible',
            transform: value ? 'translateZ(0)' : '',
            ...$1c949ac6f5985b40$var$containerStyle,
            ...unstyled ? {} : {
                margin: spacing.baseUnit / 2,
                paddingBottom: spacing.baseUnit / 2,
                paddingTop: spacing.baseUnit / 2,
                color: colors.neutral80
            }
        });
    const $1c949ac6f5985b40$var$spacingStyle = {
        gridArea: '1 / 2',
        font: 'inherit',
        minWidth: '2px',
        border: 0,
        margin: 0,
        outline: 0,
        padding: 0
    };
    const $1c949ac6f5985b40$var$containerStyle = {
        flex: '1 1 auto',
        display: 'inline-grid',
        gridArea: '1 / 1 / 2 / 3',
        gridTemplateColumns: '0 min-content',
        '&:after': {
            content: 'attr(data-value) " "',
            visibility: 'hidden',
            whiteSpace: 'pre',
            ...$1c949ac6f5985b40$var$spacingStyle
        }
    };
    const $1c949ac6f5985b40$var$inputStyle = (isHidden)=>({
            label: 'input',
            color: 'inherit',
            background: 0,
            opacity: isHidden ? 0 : 1,
            width: '100%',
            ...$1c949ac6f5985b40$var$spacingStyle
        });
    const $1c949ac6f5985b40$var$Input = (props)=>{
        const { cx: cx, value: value } = props;
        const { innerRef: innerRef, isDisabled: isDisabled, isHidden: isHidden, inputClassName: inputClassName, ...innerProps } = (0, (0, parcelRequire("gyjU7")).cleanCommonProps)(props);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'input', {
                'input-container': true
            }),
            "data-value": value || ''
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            className: cx({
                input: true
            }, inputClassName),
            ref: innerRef,
            style: $1c949ac6f5985b40$var$inputStyle(isHidden),
            disabled: isDisabled,
            ...innerProps
        }));
    };
    var $1c949ac6f5985b40$export$2e2bcd8739ae039 = $1c949ac6f5985b40$var$Input;
});
parcelRegister("aA8TC", function(module, exports) {
    $parcel$export(module.exports, "menuCSS", ()=>$1fde8cb844828ae2$export$a228922d5ca42a79);
    $parcel$export(module.exports, "MenuPlacer", ()=>$1fde8cb844828ae2$export$f32337f3a7617699);
    $parcel$export(module.exports, "default", ()=>$1fde8cb844828ae2$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "menuListCSS", ()=>$1fde8cb844828ae2$export$abafed69cff95d5e);
    $parcel$export(module.exports, "MenuList", ()=>$1fde8cb844828ae2$export$d4c4e98c5044dc8);
    $parcel$export(module.exports, "noOptionsMessageCSS", ()=>$1fde8cb844828ae2$export$cf0e22534d8b0074);
    $parcel$export(module.exports, "loadingMessageCSS", ()=>$1fde8cb844828ae2$export$98ec46397a8cb3cd);
    $parcel$export(module.exports, "NoOptionsMessage", ()=>$1fde8cb844828ae2$export$d58b72b7d3c4072c);
    $parcel$export(module.exports, "LoadingMessage", ()=>$1fde8cb844828ae2$export$e928a71d039d3102);
    $parcel$export(module.exports, "menuPortalCSS", ()=>$1fde8cb844828ae2$export$1dbbeb9648d1fdc9);
    $parcel$export(module.exports, "MenuPortal", ()=>$1fde8cb844828ae2$export$793392f970497feb);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $g9RrE;
    var $7nsd3 = parcelRequire("7nsd3");
    var $hrqx3 = parcelRequire("hrqx3");
    var $gyjU7;
    function $1fde8cb844828ae2$export$bd649b913ec78e4a({ maxHeight: preferredMaxHeight, menuEl: menuEl, minHeight: minHeight, placement: preferredPlacement, shouldScroll: shouldScroll, isFixedPosition: isFixedPosition, controlHeight: controlHeight }) {
        const scrollParent = (0, (0, parcelRequire("gyjU7")).getScrollParent)(menuEl);
        const defaultState = {
            placement: 'bottom',
            maxHeight: preferredMaxHeight
        };
        if (!menuEl || !menuEl.offsetParent) return defaultState;
        const { height: scrollHeight } = scrollParent.getBoundingClientRect();
        const { bottom: menuBottom, height: menuHeight, top: menuTop } = menuEl.getBoundingClientRect();
        const { top: containerTop } = menuEl.offsetParent.getBoundingClientRect();
        const viewHeight = isFixedPosition ? window.innerHeight : (0, (0, parcelRequire("gyjU7")).normalizedHeight)(scrollParent);
        const scrollTop = (0, (0, parcelRequire("gyjU7")).getScrollTop)(scrollParent);
        const marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
        const marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
        const viewSpaceAbove = containerTop - marginTop;
        const viewSpaceBelow = viewHeight - menuTop;
        const scrollSpaceAbove = viewSpaceAbove + scrollTop;
        const scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
        const scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
        const scrollUp = scrollTop + menuTop - marginTop;
        const scrollDuration = 160;
        switch(preferredPlacement){
            case 'auto':
            case 'bottom':
                if (viewSpaceBelow >= menuHeight) return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
                if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                    return {
                        placement: 'bottom',
                        maxHeight: preferredMaxHeight
                    };
                }
                if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                    const constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                    return {
                        placement: 'bottom',
                        maxHeight: constrainedHeight
                    };
                }
                if (preferredPlacement === 'auto' || isFixedPosition) {
                    let constrainedHeight = preferredMaxHeight;
                    const spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                    if (spaceAbove >= minHeight) constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                    return {
                        placement: 'top',
                        maxHeight: constrainedHeight
                    };
                }
                if (preferredPlacement === 'bottom') {
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).scrollTo)(scrollParent, scrollDown);
                    return {
                        placement: 'bottom',
                        maxHeight: preferredMaxHeight
                    };
                }
                break;
            case 'top':
                if (viewSpaceAbove >= menuHeight) return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
                if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                    return {
                        placement: 'top',
                        maxHeight: preferredMaxHeight
                    };
                }
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                    let constrainedHeight = preferredMaxHeight;
                    if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) constrainedHeight = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                    return {
                        placement: 'top',
                        maxHeight: constrainedHeight
                    };
                }
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            default:
                throw new Error(`Invalid placement provided "${preferredPlacement}".`);
        }
        return defaultState;
    }
    function $1fde8cb844828ae2$var$alignToControl(placement) {
        const placementToCSSProp = {
            bottom: 'top',
            top: 'bottom'
        };
        return placement ? placementToCSSProp[placement] : 'bottom';
    }
    const $1fde8cb844828ae2$var$coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
    const $1fde8cb844828ae2$export$a228922d5ca42a79 = ({ placement: placement, theme: { borderRadius: borderRadius, spacing: spacing, colors: colors } }, unstyled)=>({
            label: 'menu',
            [$1fde8cb844828ae2$var$alignToControl(placement)]: '100%',
            position: 'absolute',
            width: '100%',
            zIndex: 1,
            ...unstyled ? {} : {
                backgroundColor: colors.neutral0,
                borderRadius: borderRadius,
                boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
                marginBottom: spacing.menuGutter,
                marginTop: spacing.menuGutter
            }
        });
    const $1fde8cb844828ae2$var$PortalPlacementContext = (0, $5uXOq.createContext)(null);
    const $1fde8cb844828ae2$export$f32337f3a7617699 = (props)=>{
        const { children: children, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView, theme: theme } = props;
        const { setPortalPlacement: setPortalPlacement } = (0, $5uXOq.useContext)($1fde8cb844828ae2$var$PortalPlacementContext) || {};
        const ref = (0, $5uXOq.useRef)(null);
        const [maxHeight, setMaxHeight] = (0, $5uXOq.useState)(maxMenuHeight);
        const [placement, setPlacement] = (0, $5uXOq.useState)(null);
        const { controlHeight: controlHeight } = theme.spacing;
        (0, $hrqx3.default)(()=>{
            const menuEl = ref.current;
            if (!menuEl) return;
            const isFixedPosition = menuPosition === 'fixed';
            const shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
            const state = $1fde8cb844828ae2$export$bd649b913ec78e4a({
                maxHeight: maxMenuHeight,
                menuEl: menuEl,
                minHeight: minMenuHeight,
                placement: menuPlacement,
                shouldScroll: shouldScroll,
                isFixedPosition: isFixedPosition,
                controlHeight: controlHeight
            });
            setMaxHeight(state.maxHeight);
            setPlacement(state.placement);
            setPortalPlacement?.(state.placement);
        }, [
            maxMenuHeight,
            menuPlacement,
            menuPosition,
            menuShouldScrollIntoView,
            minMenuHeight,
            setPortalPlacement,
            controlHeight
        ]);
        return children({
            ref: ref,
            placerProps: {
                ...props,
                placement: placement || $1fde8cb844828ae2$var$coercePlacement(menuPlacement),
                maxHeight: maxHeight
            }
        });
    };
    const $1fde8cb844828ae2$var$Menu = (props)=>{
        const { children: children, innerRef: innerRef, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'menu', {
                menu: true
            }),
            ref: innerRef,
            ...innerProps
        }, children);
    };
    var $1fde8cb844828ae2$export$2e2bcd8739ae039 = $1fde8cb844828ae2$var$Menu;
    const $1fde8cb844828ae2$export$abafed69cff95d5e = ({ maxHeight: maxHeight, theme: { spacing: { baseUnit: baseUnit } } }, unstyled)=>({
            maxHeight: maxHeight,
            overflowY: 'auto',
            position: 'relative',
            WebkitOverflowScrolling: 'touch',
            ...unstyled ? {} : {
                paddingBottom: baseUnit,
                paddingTop: baseUnit
            }
        });
    const $1fde8cb844828ae2$export$d4c4e98c5044dc8 = (props)=>{
        const { children: children, innerProps: innerProps, innerRef: innerRef, isMulti: isMulti } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'menuList', {
                'menu-list': true,
                'menu-list--is-multi': isMulti
            }),
            ref: innerRef,
            ...innerProps,
            tabIndex: -1
        }, children);
    };
    const $1fde8cb844828ae2$var$noticeCSS = ({ theme: { spacing: { baseUnit: baseUnit }, colors: colors } }, unstyled)=>({
            textAlign: 'center',
            ...unstyled ? {} : {
                color: colors.neutral40,
                padding: `${baseUnit * 2}px ${baseUnit * 3}px`
            }
        });
    const $1fde8cb844828ae2$export$cf0e22534d8b0074 = $1fde8cb844828ae2$var$noticeCSS;
    const $1fde8cb844828ae2$export$98ec46397a8cb3cd = $1fde8cb844828ae2$var$noticeCSS;
    const $1fde8cb844828ae2$export$d58b72b7d3c4072c = ({ children: children = 'No options', innerProps: innerProps, ...restProps })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)({
                ...restProps,
                children: children,
                innerProps: innerProps
            }, 'noOptionsMessage', {
                'menu-notice': true,
                'menu-notice--no-options': true
            }),
            role: "option",
            ...innerProps
        }, children);
    };
    const $1fde8cb844828ae2$export$e928a71d039d3102 = ({ children: children = 'Loading...', innerProps: innerProps, ...restProps })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)({
                ...restProps,
                children: children,
                innerProps: innerProps
            }, 'loadingMessage', {
                'menu-notice': true,
                'menu-notice--loading': true
            }),
            ...innerProps,
            role: "option"
        }, children);
    };
    const $1fde8cb844828ae2$export$1dbbeb9648d1fdc9 = ({ rect: rect, offset: offset, position: position })=>({
            left: rect.left,
            position: position,
            top: offset,
            width: rect.width,
            zIndex: 1
        });
    const $1fde8cb844828ae2$export$793392f970497feb = (props)=>{
        const { appendTo: appendTo, children: children, controlElement: controlElement, innerProps: innerProps, menuPlacement: menuPlacement, menuPosition: menuPosition } = props;
        const menuPortalRef = (0, $5uXOq.useRef)(null);
        const cleanupRef = (0, $5uXOq.useRef)(null);
        const [placement, setPortalPlacement] = (0, $5uXOq.useState)($1fde8cb844828ae2$var$coercePlacement(menuPlacement));
        const portalPlacementContext = (0, $5uXOq.useMemo)(()=>({
                setPortalPlacement: setPortalPlacement
            }), []);
        const [computedPosition, setComputedPosition] = (0, $5uXOq.useState)(null);
        const updateComputedPosition = (0, $5uXOq.useCallback)(()=>{
            if (!controlElement) return;
            const rect = (0, (0, parcelRequire("gyjU7")).getBoundingClientObj)(controlElement);
            const scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
            const offset = rect[placement] + scrollDistance;
            if (offset !== computedPosition?.offset || rect.left !== computedPosition?.rect.left || rect.width !== computedPosition?.rect.width) setComputedPosition({
                offset: offset,
                rect: rect
            });
        }, [
            controlElement,
            menuPosition,
            placement,
            computedPosition?.offset,
            computedPosition?.rect.left,
            computedPosition?.rect.width
        ]);
        (0, $hrqx3.default)(()=>{
            updateComputedPosition();
        }, [
            updateComputedPosition
        ]);
        const runAutoUpdate = (0, $5uXOq.useCallback)(()=>{
            if (typeof cleanupRef.current === 'function') {
                cleanupRef.current();
                cleanupRef.current = null;
            }
            if (controlElement && menuPortalRef.current) cleanupRef.current = (0, (0, parcelRequire("g9RrE")).autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
                elementResize: 'ResizeObserver' in window
            });
        }, [
            controlElement,
            updateComputedPosition
        ]);
        (0, $hrqx3.default)(()=>{
            runAutoUpdate();
        }, [
            runAutoUpdate
        ]);
        const setMenuPortalElement = (0, $5uXOq.useCallback)((menuPortalElement)=>{
            menuPortalRef.current = menuPortalElement;
            runAutoUpdate();
        }, [
            runAutoUpdate
        ]);
        if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
        const menuWrapper = (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: setMenuPortalElement,
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)({
                ...props,
                offset: computedPosition.offset,
                position: menuPosition,
                rect: computedPosition.rect
            }, 'menuPortal', {
                'menu-portal': true
            }),
            ...innerProps
        }, children);
        return (0, (0, parcelRequire("f8Sb3")).jsx)($1fde8cb844828ae2$var$PortalPlacementContext.Provider, {
            value: portalPlacementContext
        }, appendTo ? (0, $7nsd3.createPortal)(menuWrapper, appendTo) : menuWrapper);
    };
});
parcelRegister("g9RrE", function(module, exports) {
    $parcel$export(module.exports, "autoUpdate", ()=>$bc36f1aefc070984$export$deee3a793edee05f);
    var $gSfPF;
    var $cVo0M;
    var $cVo0M;
    var $f8LYQ;
    function $bc36f1aefc070984$var$getCssDimensions(element) {
        const css = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element);
        let width = parseFloat(css.width) || 0;
        let height = parseFloat(css.height) || 0;
        const hasOffset = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element);
        const offsetWidth = hasOffset ? element.offsetWidth : width;
        const offsetHeight = hasOffset ? element.offsetHeight : height;
        const shouldFallback = (0, (0, parcelRequire("cVo0M")).round)(width) !== offsetWidth || (0, (0, parcelRequire("cVo0M")).round)(height) !== offsetHeight;
        if (shouldFallback) {
            width = offsetWidth;
            height = offsetHeight;
        }
        return {
            width: width,
            height: height,
            $: shouldFallback
        };
    }
    function $bc36f1aefc070984$var$unwrapElement(element) {
        return !(0, (0, parcelRequire("f8LYQ")).isElement)(element) ? element.contextElement : element;
    }
    function $bc36f1aefc070984$var$getScale(element) {
        const domElement = $bc36f1aefc070984$var$unwrapElement(element);
        if (!(0, (0, parcelRequire("f8LYQ")).isHTMLElement)(domElement)) return (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        const rect = domElement.getBoundingClientRect();
        const { width: width, height: height, $: $ } = $bc36f1aefc070984$var$getCssDimensions(domElement);
        let x = ($ ? (0, (0, parcelRequire("cVo0M")).round)(rect.width) : rect.width) / width;
        let y = ($ ? (0, (0, parcelRequire("cVo0M")).round)(rect.height) : rect.height) / height;
        if (!x || !Number.isFinite(x)) x = 1;
        if (!y || !Number.isFinite(y)) y = 1;
        return {
            x: x,
            y: y
        };
    }
    const $bc36f1aefc070984$var$noOffsets = (0, (0, parcelRequire("cVo0M")).createCoords)(0);
    function $bc36f1aefc070984$var$getVisualOffsets(element) {
        const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(element);
        if (!(0, (0, parcelRequire("f8LYQ")).isWebKit)() || !win.visualViewport) return $bc36f1aefc070984$var$noOffsets;
        return {
            x: win.visualViewport.offsetLeft,
            y: win.visualViewport.offsetTop
        };
    }
    function $bc36f1aefc070984$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
        if (isFixed === void 0) isFixed = false;
        if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, (0, parcelRequire("f8LYQ")).getWindow)(element)) return false;
        return isFixed;
    }
    function $bc36f1aefc070984$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
        if (includeScale === void 0) includeScale = false;
        if (isFixedStrategy === void 0) isFixedStrategy = false;
        const clientRect = element.getBoundingClientRect();
        const domElement = $bc36f1aefc070984$var$unwrapElement(element);
        let scale = (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        if (includeScale) {
            if (offsetParent) {
                if ((0, (0, parcelRequire("f8LYQ")).isElement)(offsetParent)) scale = $bc36f1aefc070984$var$getScale(offsetParent);
            } else scale = $bc36f1aefc070984$var$getScale(element);
        }
        const visualOffsets = $bc36f1aefc070984$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $bc36f1aefc070984$var$getVisualOffsets(domElement) : (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        let x = (clientRect.left + visualOffsets.x) / scale.x;
        let y = (clientRect.top + visualOffsets.y) / scale.y;
        let width = clientRect.width / scale.x;
        let height = clientRect.height / scale.y;
        if (domElement) {
            const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(domElement);
            const offsetWin = offsetParent && (0, (0, parcelRequire("f8LYQ")).isElement)(offsetParent) ? (0, (0, parcelRequire("f8LYQ")).getWindow)(offsetParent) : offsetParent;
            let currentWin = win;
            let currentIFrame = (0, (0, parcelRequire("f8LYQ")).getFrameElement)(currentWin);
            while(currentIFrame && offsetParent && offsetWin !== currentWin){
                const iframeScale = $bc36f1aefc070984$var$getScale(currentIFrame);
                const iframeRect = currentIFrame.getBoundingClientRect();
                const css = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(currentIFrame);
                const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
                const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
                x *= iframeScale.x;
                y *= iframeScale.y;
                width *= iframeScale.x;
                height *= iframeScale.y;
                x += left;
                y += top;
                currentWin = (0, (0, parcelRequire("f8LYQ")).getWindow)(currentIFrame);
                currentIFrame = (0, (0, parcelRequire("f8LYQ")).getFrameElement)(currentWin);
            }
        }
        return (0, (0, parcelRequire("cVo0M")).rectToClientRect)({
            width: width,
            height: height,
            x: x,
            y: y
        });
    }
    function $bc36f1aefc070984$var$getWindowScrollBarX(element, rect) {
        const leftScroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(element).scrollLeft;
        if (!rect) return $bc36f1aefc070984$var$getBoundingClientRect((0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element)).left + leftScroll;
        return rect.left + leftScroll;
    }
    function $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
        if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
        const htmlRect = documentElement.getBoundingClientRect();
        const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : $bc36f1aefc070984$var$getWindowScrollBarX(documentElement, htmlRect));
        const y = htmlRect.top + scroll.scrollTop;
        return {
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
        let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
        const isFixed = strategy === 'fixed';
        const documentElement = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(offsetParent);
        const topLayer = elements ? (0, (0, parcelRequire("f8LYQ")).isTopLayer)(elements.floating) : false;
        if (offsetParent === documentElement || topLayer && isFixed) return rect;
        let scroll = {
            scrollLeft: 0,
            scrollTop: 0
        };
        let scale = (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        const offsets = (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        const isOffsetParentAnElement = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(offsetParent);
        if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
            if ((0, (0, parcelRequire("f8LYQ")).getNodeName)(offsetParent) !== 'body' || (0, (0, parcelRequire("f8LYQ")).isOverflowElement)(documentElement)) scroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(offsetParent);
            if ((0, (0, parcelRequire("f8LYQ")).isHTMLElement)(offsetParent)) {
                const offsetRect = $bc36f1aefc070984$var$getBoundingClientRect(offsetParent);
                scale = $bc36f1aefc070984$var$getScale(offsetParent);
                offsets.x = offsetRect.x + offsetParent.clientLeft;
                offsets.y = offsetRect.y + offsetParent.clientTop;
            }
        }
        const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll, true) : (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        return {
            width: rect.width * scale.x,
            height: rect.height * scale.y,
            x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
            y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
        };
    }
    function $bc36f1aefc070984$var$getClientRects(element) {
        return Array.from(element.getClientRects());
    }
    function $bc36f1aefc070984$var$getDocumentRect(element) {
        const html = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element);
        const scroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(element);
        const body = element.ownerDocument.body;
        const width = (0, (0, parcelRequire("cVo0M")).max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
        const height = (0, (0, parcelRequire("cVo0M")).max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
        let x = -scroll.scrollLeft + $bc36f1aefc070984$var$getWindowScrollBarX(element);
        const y = -scroll.scrollTop;
        if ((0, (0, parcelRequire("f8LYQ")).getComputedStyle)(body).direction === 'rtl') x += (0, (0, parcelRequire("cVo0M")).max)(html.clientWidth, body.clientWidth) - width;
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$getViewportRect(element, strategy) {
        const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(element);
        const html = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element);
        const visualViewport = win.visualViewport;
        let width = html.clientWidth;
        let height = html.clientHeight;
        let x = 0;
        let y = 0;
        if (visualViewport) {
            width = visualViewport.width;
            height = visualViewport.height;
            const visualViewportBased = (0, (0, parcelRequire("f8LYQ")).isWebKit)();
            if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
                x = visualViewport.offsetLeft;
                y = visualViewport.offsetTop;
            }
        }
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$getInnerBoundingClientRect(element, strategy) {
        const clientRect = $bc36f1aefc070984$var$getBoundingClientRect(element, true, strategy === 'fixed');
        const top = clientRect.top + element.clientTop;
        const left = clientRect.left + element.clientLeft;
        const scale = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element) ? $bc36f1aefc070984$var$getScale(element) : (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        const width = element.clientWidth * scale.x;
        const height = element.clientHeight * scale.y;
        const x = left * scale.x;
        const y = top * scale.y;
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
        let rect;
        if (clippingAncestor === 'viewport') rect = $bc36f1aefc070984$var$getViewportRect(element, strategy);
        else if (clippingAncestor === 'document') rect = $bc36f1aefc070984$var$getDocumentRect((0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element));
        else if ((0, (0, parcelRequire("f8LYQ")).isElement)(clippingAncestor)) rect = $bc36f1aefc070984$var$getInnerBoundingClientRect(clippingAncestor, strategy);
        else {
            const visualOffsets = $bc36f1aefc070984$var$getVisualOffsets(element);
            rect = {
                x: clippingAncestor.x - visualOffsets.x,
                y: clippingAncestor.y - visualOffsets.y,
                width: clippingAncestor.width,
                height: clippingAncestor.height
            };
        }
        return (0, (0, parcelRequire("cVo0M")).rectToClientRect)(rect);
    }
    function $bc36f1aefc070984$var$hasFixedPositionAncestor(element, stopNode) {
        const parentNode = (0, (0, parcelRequire("f8LYQ")).getParentNode)(element);
        if (parentNode === stopNode || !(0, (0, parcelRequire("f8LYQ")).isElement)(parentNode) || (0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(parentNode)) return false;
        return (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(parentNode).position === 'fixed' || $bc36f1aefc070984$var$hasFixedPositionAncestor(parentNode, stopNode);
    }
    function $bc36f1aefc070984$var$getClippingElementAncestors(element, cache) {
        const cachedResult = cache.get(element);
        if (cachedResult) return cachedResult;
        let result = (0, (0, parcelRequire("f8LYQ")).getOverflowAncestors)(element, [], false).filter((el)=>(0, (0, parcelRequire("f8LYQ")).isElement)(el) && (0, (0, parcelRequire("f8LYQ")).getNodeName)(el) !== 'body');
        let currentContainingBlockComputedStyle = null;
        const elementIsFixed = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).position === 'fixed';
        let currentNode = elementIsFixed ? (0, (0, parcelRequire("f8LYQ")).getParentNode)(element) : element;
        while((0, (0, parcelRequire("f8LYQ")).isElement)(currentNode) && !(0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(currentNode)){
            const computedStyle = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(currentNode);
            const currentNodeIsContaining = (0, (0, parcelRequire("f8LYQ")).isContainingBlock)(currentNode);
            if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
            const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && [
                'absolute',
                'fixed'
            ].includes(currentContainingBlockComputedStyle.position) || (0, (0, parcelRequire("f8LYQ")).isOverflowElement)(currentNode) && !currentNodeIsContaining && $bc36f1aefc070984$var$hasFixedPositionAncestor(element, currentNode);
            if (shouldDropCurrentNode) result = result.filter((ancestor)=>ancestor !== currentNode);
            else currentContainingBlockComputedStyle = computedStyle;
            currentNode = (0, (0, parcelRequire("f8LYQ")).getParentNode)(currentNode);
        }
        cache.set(element, result);
        return result;
    }
    function $bc36f1aefc070984$var$getClippingRect(_ref) {
        let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
        const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, (0, parcelRequire("f8LYQ")).isTopLayer)(element) ? [] : $bc36f1aefc070984$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
        const clippingAncestors = [
            ...elementClippingAncestors,
            rootBoundary
        ];
        const firstClippingAncestor = clippingAncestors[0];
        const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
            const rect = $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
            accRect.top = (0, (0, parcelRequire("cVo0M")).max)(rect.top, accRect.top);
            accRect.right = (0, (0, parcelRequire("cVo0M")).min)(rect.right, accRect.right);
            accRect.bottom = (0, (0, parcelRequire("cVo0M")).min)(rect.bottom, accRect.bottom);
            accRect.left = (0, (0, parcelRequire("cVo0M")).max)(rect.left, accRect.left);
            return accRect;
        }, $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
        return {
            width: clippingRect.right - clippingRect.left,
            height: clippingRect.bottom - clippingRect.top,
            x: clippingRect.left,
            y: clippingRect.top
        };
    }
    function $bc36f1aefc070984$var$getDimensions(element) {
        const { width: width, height: height } = $bc36f1aefc070984$var$getCssDimensions(element);
        return {
            width: width,
            height: height
        };
    }
    function $bc36f1aefc070984$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
        const isOffsetParentAnElement = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(offsetParent);
        const documentElement = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(offsetParent);
        const isFixed = strategy === 'fixed';
        const rect = $bc36f1aefc070984$var$getBoundingClientRect(element, true, isFixed, offsetParent);
        let scroll = {
            scrollLeft: 0,
            scrollTop: 0
        };
        const offsets = (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
            if ((0, (0, parcelRequire("f8LYQ")).getNodeName)(offsetParent) !== 'body' || (0, (0, parcelRequire("f8LYQ")).isOverflowElement)(documentElement)) scroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(offsetParent);
            if (isOffsetParentAnElement) {
                const offsetRect = $bc36f1aefc070984$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
                offsets.x = offsetRect.x + offsetParent.clientLeft;
                offsets.y = offsetRect.y + offsetParent.clientTop;
            } else if (documentElement) offsets.x = $bc36f1aefc070984$var$getWindowScrollBarX(documentElement);
        }
        const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll) : (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
        const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
        return {
            x: x,
            y: y,
            width: rect.width,
            height: rect.height
        };
    }
    function $bc36f1aefc070984$var$isStaticPositioned(element) {
        return (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).position === 'static';
    }
    function $bc36f1aefc070984$var$getTrueOffsetParent(element, polyfill) {
        if (!(0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element) || (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).position === 'fixed') return null;
        if (polyfill) return polyfill(element);
        let rawOffsetParent = element.offsetParent;
        if ((0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
        return rawOffsetParent;
    }
    function $bc36f1aefc070984$var$getOffsetParent(element, polyfill) {
        const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(element);
        if ((0, (0, parcelRequire("f8LYQ")).isTopLayer)(element)) return win;
        if (!(0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element)) {
            let svgOffsetParent = (0, (0, parcelRequire("f8LYQ")).getParentNode)(element);
            while(svgOffsetParent && !(0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(svgOffsetParent)){
                if ((0, (0, parcelRequire("f8LYQ")).isElement)(svgOffsetParent) && !$bc36f1aefc070984$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
                svgOffsetParent = (0, (0, parcelRequire("f8LYQ")).getParentNode)(svgOffsetParent);
            }
            return win;
        }
        let offsetParent = $bc36f1aefc070984$var$getTrueOffsetParent(element, polyfill);
        while(offsetParent && (0, (0, parcelRequire("f8LYQ")).isTableElement)(offsetParent) && $bc36f1aefc070984$var$isStaticPositioned(offsetParent))offsetParent = $bc36f1aefc070984$var$getTrueOffsetParent(offsetParent, polyfill);
        if (offsetParent && (0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(offsetParent) && $bc36f1aefc070984$var$isStaticPositioned(offsetParent) && !(0, (0, parcelRequire("f8LYQ")).isContainingBlock)(offsetParent)) return win;
        return offsetParent || (0, (0, parcelRequire("f8LYQ")).getContainingBlock)(element) || win;
    }
    const $bc36f1aefc070984$var$getElementRects = async function(data) {
        const getOffsetParentFn = this.getOffsetParent || $bc36f1aefc070984$var$getOffsetParent;
        const getDimensionsFn = this.getDimensions;
        const floatingDimensions = await getDimensionsFn(data.floating);
        return {
            reference: $bc36f1aefc070984$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
            floating: {
                x: 0,
                y: 0,
                width: floatingDimensions.width,
                height: floatingDimensions.height
            }
        };
    };
    function $bc36f1aefc070984$var$isRTL(element) {
        return (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).direction === 'rtl';
    }
    const $bc36f1aefc070984$export$722a64dea1b767dc = {
        convertOffsetParentRelativeRectToViewportRelativeRect: $bc36f1aefc070984$var$convertOffsetParentRelativeRectToViewportRelativeRect,
        getDocumentElement: (0, parcelRequire("f8LYQ")).getDocumentElement,
        getClippingRect: $bc36f1aefc070984$var$getClippingRect,
        getOffsetParent: $bc36f1aefc070984$var$getOffsetParent,
        getElementRects: $bc36f1aefc070984$var$getElementRects,
        getClientRects: $bc36f1aefc070984$var$getClientRects,
        getDimensions: $bc36f1aefc070984$var$getDimensions,
        getScale: $bc36f1aefc070984$var$getScale,
        isElement: (0, parcelRequire("f8LYQ")).isElement,
        isRTL: $bc36f1aefc070984$var$isRTL
    };
    function $bc36f1aefc070984$var$observeMove(element, onMove) {
        let io = null;
        let timeoutId;
        const root = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element);
        function cleanup() {
            var _io;
            clearTimeout(timeoutId);
            (_io = io) == null || _io.disconnect();
            io = null;
        }
        function refresh(skip, threshold) {
            if (skip === void 0) skip = false;
            if (threshold === void 0) threshold = 1;
            cleanup();
            const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
            if (!skip) onMove();
            if (!width || !height) return;
            const insetTop = (0, (0, parcelRequire("cVo0M")).floor)(top);
            const insetRight = (0, (0, parcelRequire("cVo0M")).floor)(root.clientWidth - (left + width));
            const insetBottom = (0, (0, parcelRequire("cVo0M")).floor)(root.clientHeight - (top + height));
            const insetLeft = (0, (0, parcelRequire("cVo0M")).floor)(left);
            const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
            const options = {
                rootMargin: rootMargin,
                threshold: (0, (0, parcelRequire("cVo0M")).max)(0, (0, (0, parcelRequire("cVo0M")).min)(1, threshold)) || 1
            };
            let isFirstUpdate = true;
            function handleObserve(entries) {
                const ratio = entries[0].intersectionRatio;
                if (ratio !== threshold) {
                    if (!isFirstUpdate) return refresh();
                    if (!ratio) timeoutId = setTimeout(()=>{
                        refresh(false, 1e-7);
                    }, 1000);
                    else refresh(false, ratio);
                }
                isFirstUpdate = false;
            }
            try {
                io = new IntersectionObserver(handleObserve, {
                    ...options,
                    root: root.ownerDocument
                });
            } catch (e) {
                io = new IntersectionObserver(handleObserve, options);
            }
            io.observe(element);
        }
        refresh(true);
        return cleanup;
    }
    function $bc36f1aefc070984$export$deee3a793edee05f(reference, floating, update, options) {
        if (options === void 0) options = {};
        const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
        const referenceEl = $bc36f1aefc070984$var$unwrapElement(reference);
        const ancestors = ancestorScroll || ancestorResize ? [
            ...referenceEl ? (0, (0, parcelRequire("f8LYQ")).getOverflowAncestors)(referenceEl) : [],
            ...(0, (0, parcelRequire("f8LYQ")).getOverflowAncestors)(floating)
        ] : [];
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.addEventListener('scroll', update, {
                passive: true
            });
            ancestorResize && ancestor.addEventListener('resize', update);
        });
        const cleanupIo = referenceEl && layoutShift ? $bc36f1aefc070984$var$observeMove(referenceEl, update) : null;
        let reobserveFrame = -1;
        let resizeObserver = null;
        if (elementResize) {
            resizeObserver = new ResizeObserver((_ref)=>{
                let [firstEntry] = _ref;
                if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                    resizeObserver.unobserve(floating);
                    cancelAnimationFrame(reobserveFrame);
                    reobserveFrame = requestAnimationFrame(()=>{
                        var _resizeObserver;
                        (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                    });
                }
                update();
            });
            if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
            resizeObserver.observe(floating);
        }
        let frameId;
        let prevRefRect = animationFrame ? $bc36f1aefc070984$var$getBoundingClientRect(reference) : null;
        if (animationFrame) frameLoop();
        function frameLoop() {
            const nextRefRect = $bc36f1aefc070984$var$getBoundingClientRect(reference);
            if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
            prevRefRect = nextRefRect;
            frameId = requestAnimationFrame(frameLoop);
        }
        update();
        return ()=>{
            var _resizeObserver2;
            ancestors.forEach((ancestor)=>{
                ancestorScroll && ancestor.removeEventListener('scroll', update);
                ancestorResize && ancestor.removeEventListener('resize', update);
            });
            cleanupIo == null || cleanupIo();
            (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
            resizeObserver = null;
            if (animationFrame) cancelAnimationFrame(frameId);
        };
    }
    const $bc36f1aefc070984$export$37b6bde19b108ecc = (0, (0, parcelRequire("gSfPF")).detectOverflow);
    const $bc36f1aefc070984$export$cc800923e997bb8 = (0, (0, parcelRequire("gSfPF")).offset);
    const $bc36f1aefc070984$export$91fb6ecbd551914 = (0, (0, parcelRequire("gSfPF")).autoPlacement);
    const $bc36f1aefc070984$export$fba63a578e423eb = (0, (0, parcelRequire("gSfPF")).shift);
    const $bc36f1aefc070984$export$8a83211c878a3f1f = (0, (0, parcelRequire("gSfPF")).flip);
    const $bc36f1aefc070984$export$346677f925de839c = (0, (0, parcelRequire("gSfPF")).size);
    const $bc36f1aefc070984$export$fe8985bb6374093c = (0, (0, parcelRequire("gSfPF")).hide);
    const $bc36f1aefc070984$export$f2120bbfa5450bd2 = (0, (0, parcelRequire("gSfPF")).arrow);
    const $bc36f1aefc070984$export$18c8ad048e32c7d5 = (0, (0, parcelRequire("gSfPF")).inline);
    const $bc36f1aefc070984$export$7bf07e38f3dc4b69 = (0, (0, parcelRequire("gSfPF")).limitShift);
    const $bc36f1aefc070984$export$48a53dcb22e581d0 = (reference, floating, options)=>{
        const cache = new Map();
        const mergedOptions = {
            platform: $bc36f1aefc070984$export$722a64dea1b767dc,
            ...options
        };
        const platformWithCache = {
            ...mergedOptions.platform,
            _c: cache
        };
        return (0, (0, parcelRequire("gSfPF")).computePosition)(reference, floating, {
            ...mergedOptions,
            platform: platformWithCache
        });
    };
});
parcelRegister("gSfPF", function(module, exports) {
    $parcel$export(module.exports, "computePosition", ()=>$c48df878d8118962$export$48a53dcb22e581d0);
    $parcel$export(module.exports, "detectOverflow", ()=>$c48df878d8118962$export$37b6bde19b108ecc);
    $parcel$export(module.exports, "arrow", ()=>$c48df878d8118962$export$f2120bbfa5450bd2);
    $parcel$export(module.exports, "autoPlacement", ()=>$c48df878d8118962$export$91fb6ecbd551914);
    $parcel$export(module.exports, "flip", ()=>$c48df878d8118962$export$8a83211c878a3f1f);
    $parcel$export(module.exports, "hide", ()=>$c48df878d8118962$export$fe8985bb6374093c);
    $parcel$export(module.exports, "inline", ()=>$c48df878d8118962$export$18c8ad048e32c7d5);
    $parcel$export(module.exports, "offset", ()=>$c48df878d8118962$export$cc800923e997bb8);
    $parcel$export(module.exports, "shift", ()=>$c48df878d8118962$export$fba63a578e423eb);
    $parcel$export(module.exports, "limitShift", ()=>$c48df878d8118962$export$7bf07e38f3dc4b69);
    $parcel$export(module.exports, "size", ()=>$c48df878d8118962$export$346677f925de839c);
    $parcel$export(module.exports, "rectToClientRect", ()=>(parcelRequire("cVo0M")).rectToClientRect);
    var $cVo0M;
    function $c48df878d8118962$var$computeCoordsFromPlacement(_ref, placement, rtl) {
        let { reference: reference, floating: floating } = _ref;
        const sideAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement);
        const alignmentAxis = (0, (0, parcelRequire("cVo0M")).getAlignmentAxis)(placement);
        const alignLength = (0, (0, parcelRequire("cVo0M")).getAxisLength)(alignmentAxis);
        const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
        const isVertical = sideAxis === 'y';
        const commonX = reference.x + reference.width / 2 - floating.width / 2;
        const commonY = reference.y + reference.height / 2 - floating.height / 2;
        const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
        let coords;
        switch(side){
            case 'top':
                coords = {
                    x: commonX,
                    y: reference.y - floating.height
                };
                break;
            case 'bottom':
                coords = {
                    x: commonX,
                    y: reference.y + reference.height
                };
                break;
            case 'right':
                coords = {
                    x: reference.x + reference.width,
                    y: commonY
                };
                break;
            case 'left':
                coords = {
                    x: reference.x - floating.width,
                    y: commonY
                };
                break;
            default:
                coords = {
                    x: reference.x,
                    y: reference.y
                };
        }
        switch((0, (0, parcelRequire("cVo0M")).getAlignment)(placement)){
            case 'start':
                coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
                break;
            case 'end':
                coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
                break;
        }
        return coords;
    }
    const $c48df878d8118962$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
        const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
        const validMiddleware = middleware.filter(Boolean);
        const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
        let rects = await platform.getElementRects({
            reference: reference,
            floating: floating,
            strategy: strategy
        });
        let { x: x, y: y } = $c48df878d8118962$var$computeCoordsFromPlacement(rects, placement, rtl);
        let statefulPlacement = placement;
        let middlewareData = {};
        let resetCount = 0;
        for(let i = 0; i < validMiddleware.length; i++){
            const { name: name, fn: fn } = validMiddleware[i];
            const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
                x: x,
                y: y,
                initialPlacement: placement,
                placement: statefulPlacement,
                strategy: strategy,
                middlewareData: middlewareData,
                rects: rects,
                platform: platform,
                elements: {
                    reference: reference,
                    floating: floating
                }
            });
            x = nextX != null ? nextX : x;
            y = nextY != null ? nextY : y;
            middlewareData = {
                ...middlewareData,
                [name]: {
                    ...middlewareData[name],
                    ...data
                }
            };
            if (reset && resetCount <= 50) {
                resetCount++;
                if (typeof reset === 'object') {
                    if (reset.placement) statefulPlacement = reset.placement;
                    if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                        reference: reference,
                        floating: floating,
                        strategy: strategy
                    }) : reset.rects;
                    ({ x: x, y: y } = $c48df878d8118962$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
                }
                i = -1;
            }
        }
        return {
            x: x,
            y: y,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData
        };
    };
    async function $c48df878d8118962$export$37b6bde19b108ecc(state, options) {
        var _await$platform$isEle;
        if (options === void 0) options = {};
        const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
        const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
        const paddingObject = (0, (0, parcelRequire("cVo0M")).getPaddingObject)(padding);
        const altContext = elementContext === 'floating' ? 'reference' : 'floating';
        const element = elements[altBoundary ? altContext : elementContext];
        const clippingClientRect = (0, (0, parcelRequire("cVo0M")).rectToClientRect)(await platform.getClippingRect({
            element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
            boundary: boundary,
            rootBoundary: rootBoundary,
            strategy: strategy
        }));
        const rect = elementContext === 'floating' ? {
            x: x,
            y: y,
            width: rects.floating.width,
            height: rects.floating.height
        } : rects.reference;
        const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
        const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
            x: 1,
            y: 1
        } : {
            x: 1,
            y: 1
        };
        const elementClientRect = (0, (0, parcelRequire("cVo0M")).rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
            elements: elements,
            rect: rect,
            offsetParent: offsetParent,
            strategy: strategy
        }) : rect);
        return {
            top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
            bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
            left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
            right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
        };
    }
    const $c48df878d8118962$export$f2120bbfa5450bd2 = (options)=>({
            name: 'arrow',
            options: options,
            async fn (state) {
                const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
                const { element: element, padding: padding = 0 } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state) || {};
                if (element == null) return {};
                const paddingObject = (0, (0, parcelRequire("cVo0M")).getPaddingObject)(padding);
                const coords = {
                    x: x,
                    y: y
                };
                const axis = (0, (0, parcelRequire("cVo0M")).getAlignmentAxis)(placement);
                const length = (0, (0, parcelRequire("cVo0M")).getAxisLength)(axis);
                const arrowDimensions = await platform.getDimensions(element);
                const isYAxis = axis === 'y';
                const minProp = isYAxis ? 'top' : 'left';
                const maxProp = isYAxis ? 'bottom' : 'right';
                const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
                const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
                const startDiff = coords[axis] - rects.reference[axis];
                const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
                let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
                if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
                const centerToReference = endDiff / 2 - startDiff / 2;
                const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
                const minPadding = (0, (0, parcelRequire("cVo0M")).min)(paddingObject[minProp], largestPossiblePadding);
                const maxPadding = (0, (0, parcelRequire("cVo0M")).min)(paddingObject[maxProp], largestPossiblePadding);
                const min$1 = minPadding;
                const max = clientSize - arrowDimensions[length] - maxPadding;
                const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
                const offset = (0, (0, parcelRequire("cVo0M")).clamp)(min$1, center, max);
                const shouldAddOffset = !middlewareData.arrow && (0, (0, parcelRequire("cVo0M")).getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
                const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
                return {
                    [axis]: coords[axis] + alignmentOffset,
                    data: {
                        [axis]: offset,
                        centerOffset: center - offset - alignmentOffset,
                        ...shouldAddOffset && {
                            alignmentOffset: alignmentOffset
                        }
                    },
                    reset: shouldAddOffset
                };
            }
        });
    function $c48df878d8118962$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
        const allowedPlacementsSortedByAlignment = alignment ? [
            ...allowedPlacements.filter((placement)=>(0, (0, parcelRequire("cVo0M")).getAlignment)(placement) === alignment),
            ...allowedPlacements.filter((placement)=>(0, (0, parcelRequire("cVo0M")).getAlignment)(placement) !== alignment)
        ] : allowedPlacements.filter((placement)=>(0, (0, parcelRequire("cVo0M")).getSide)(placement) === placement);
        return allowedPlacementsSortedByAlignment.filter((placement)=>{
            if (alignment) return (0, (0, parcelRequire("cVo0M")).getAlignment)(placement) === alignment || (autoAlignment ? (0, (0, parcelRequire("cVo0M")).getOppositeAlignmentPlacement)(placement) !== placement : false);
            return true;
        });
    }
    const $c48df878d8118962$export$91fb6ecbd551914 = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'autoPlacement',
            options: options,
            async fn (state) {
                var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
                const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
                const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, (0, parcelRequire("cVo0M")).placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const placements$1 = alignment !== undefined || allowedPlacements === (0, (0, parcelRequire("cVo0M")).placements) ? $c48df878d8118962$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
                const currentPlacement = placements$1[currentIndex];
                if (currentPlacement == null) return {};
                const alignmentSides = (0, (0, parcelRequire("cVo0M")).getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
                if (placement !== currentPlacement) return {
                    reset: {
                        placement: placements$1[0]
                    }
                };
                const currentOverflows = [
                    overflow[(0, (0, parcelRequire("cVo0M")).getSide)(currentPlacement)],
                    overflow[alignmentSides[0]],
                    overflow[alignmentSides[1]]
                ];
                const allOverflows = [
                    ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                    {
                        placement: currentPlacement,
                        overflows: currentOverflows
                    }
                ];
                const nextPlacement = placements$1[currentIndex + 1];
                if (nextPlacement) return {
                    data: {
                        index: currentIndex + 1,
                        overflows: allOverflows
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                const placementsSortedByMostSpace = allOverflows.map((d)=>{
                    const alignment = (0, (0, parcelRequire("cVo0M")).getAlignment)(d.placement);
                    return [
                        d.placement,
                        alignment && crossAxis ? d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : d.overflows[0],
                        d.overflows
                    ];
                }).sort((a, b)=>a[1] - b[1]);
                const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, (0, (0, parcelRequire("cVo0M")).getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
                const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
                if (resetPlacement !== placement) return {
                    data: {
                        index: currentIndex + 1,
                        overflows: allOverflows
                    },
                    reset: {
                        placement: resetPlacement
                    }
                };
                return {};
            }
        };
    };
    const $c48df878d8118962$export$8a83211c878a3f1f = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'flip',
            options: options,
            async fn (state) {
                var _middlewareData$arrow, _middlewareData$flip;
                const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
                const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
                const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
                const initialSideAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(initialPlacement);
                const isBasePlacement = (0, (0, parcelRequire("cVo0M")).getSide)(initialPlacement) === initialPlacement;
                const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
                const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                    (0, (0, parcelRequire("cVo0M")).getOppositePlacement)(initialPlacement)
                ] : (0, (0, parcelRequire("cVo0M")).getExpandedPlacements)(initialPlacement));
                const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
                if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, (0, parcelRequire("cVo0M")).getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
                const placements = [
                    initialPlacement,
                    ...fallbackPlacements
                ];
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const overflows = [];
                let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
                if (checkMainAxis) overflows.push(overflow[side]);
                if (checkCrossAxis) {
                    const sides = (0, (0, parcelRequire("cVo0M")).getAlignmentSides)(placement, rects, rtl);
                    overflows.push(overflow[sides[0]], overflow[sides[1]]);
                }
                overflowsData = [
                    ...overflowsData,
                    {
                        placement: placement,
                        overflows: overflows
                    }
                ];
                if (!overflows.every((side)=>side <= 0)) {
                    var _middlewareData$flip2, _overflowsData$filter;
                    const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                    const nextPlacement = placements[nextIndex];
                    if (nextPlacement) return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                    let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                    if (!resetPlacement) switch(fallbackStrategy){
                        case 'bestFit':
                            {
                                var _overflowsData$filter2;
                                const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                    if (hasFallbackAxisSideDirection) {
                                        const currentSideAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(d.placement);
                                        return currentSideAxis === initialSideAxis || currentSideAxis === 'y';
                                    }
                                    return true;
                                }).map((d)=>[
                                        d.placement,
                                        d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                    ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                                if (placement) resetPlacement = placement;
                                break;
                            }
                        case 'initialPlacement':
                            resetPlacement = initialPlacement;
                            break;
                    }
                    if (placement !== resetPlacement) return {
                        reset: {
                            placement: resetPlacement
                        }
                    };
                }
                return {};
            }
        };
    };
    function $c48df878d8118962$var$getSideOffsets(overflow, rect) {
        return {
            top: overflow.top - rect.height,
            right: overflow.right - rect.width,
            bottom: overflow.bottom - rect.height,
            left: overflow.left - rect.width
        };
    }
    function $c48df878d8118962$var$isAnySideFullyClipped(overflow) {
        return (0, (0, parcelRequire("cVo0M")).sides).some((side)=>overflow[side] >= 0);
    }
    const $c48df878d8118962$export$fe8985bb6374093c = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'hide',
            options: options,
            async fn (state) {
                const { rects: rects } = state;
                const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                switch(strategy){
                    case 'referenceHidden':
                        {
                            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, {
                                ...detectOverflowOptions,
                                elementContext: 'reference'
                            });
                            const offsets = $c48df878d8118962$var$getSideOffsets(overflow, rects.reference);
                            return {
                                data: {
                                    referenceHiddenOffsets: offsets,
                                    referenceHidden: $c48df878d8118962$var$isAnySideFullyClipped(offsets)
                                }
                            };
                        }
                    case 'escaped':
                        {
                            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, {
                                ...detectOverflowOptions,
                                altBoundary: true
                            });
                            const offsets = $c48df878d8118962$var$getSideOffsets(overflow, rects.floating);
                            return {
                                data: {
                                    escapedOffsets: offsets,
                                    escaped: $c48df878d8118962$var$isAnySideFullyClipped(offsets)
                                }
                            };
                        }
                    default:
                        return {};
                }
            }
        };
    };
    function $c48df878d8118962$var$getBoundingRect(rects) {
        const minX = (0, (0, parcelRequire("cVo0M")).min)(...rects.map((rect)=>rect.left));
        const minY = (0, (0, parcelRequire("cVo0M")).min)(...rects.map((rect)=>rect.top));
        const maxX = (0, (0, parcelRequire("cVo0M")).max)(...rects.map((rect)=>rect.right));
        const maxY = (0, (0, parcelRequire("cVo0M")).max)(...rects.map((rect)=>rect.bottom));
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    }
    function $c48df878d8118962$var$getRectsByLine(rects) {
        const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
        const groups = [];
        let prevRect = null;
        for(let i = 0; i < sortedRects.length; i++){
            const rect = sortedRects[i];
            if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
                rect
            ]);
            else groups[groups.length - 1].push(rect);
            prevRect = rect;
        }
        return groups.map((rect)=>(0, (0, parcelRequire("cVo0M")).rectToClientRect)($c48df878d8118962$var$getBoundingRect(rect)));
    }
    const $c48df878d8118962$export$18c8ad048e32c7d5 = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'inline',
            options: options,
            async fn (state) {
                const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
                const { padding: padding = 2, x: x, y: y } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
                const clientRects = $c48df878d8118962$var$getRectsByLine(nativeClientRects);
                const fallback = (0, (0, parcelRequire("cVo0M")).rectToClientRect)($c48df878d8118962$var$getBoundingRect(nativeClientRects));
                const paddingObject = (0, (0, parcelRequire("cVo0M")).getPaddingObject)(padding);
                function getBoundingClientRect() {
                    if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                    if (clientRects.length >= 2) {
                        if ((0, (0, parcelRequire("cVo0M")).getSideAxis)(placement) === 'y') {
                            const firstRect = clientRects[0];
                            const lastRect = clientRects[clientRects.length - 1];
                            const isTop = (0, (0, parcelRequire("cVo0M")).getSide)(placement) === 'top';
                            const top = firstRect.top;
                            const bottom = lastRect.bottom;
                            const left = isTop ? firstRect.left : lastRect.left;
                            const right = isTop ? firstRect.right : lastRect.right;
                            const width = right - left;
                            const height = bottom - top;
                            return {
                                top: top,
                                bottom: bottom,
                                left: left,
                                right: right,
                                width: width,
                                height: height,
                                x: left,
                                y: top
                            };
                        }
                        const isLeftSide = (0, (0, parcelRequire("cVo0M")).getSide)(placement) === 'left';
                        const maxRight = (0, (0, parcelRequire("cVo0M")).max)(...clientRects.map((rect)=>rect.right));
                        const minLeft = (0, (0, parcelRequire("cVo0M")).min)(...clientRects.map((rect)=>rect.left));
                        const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                        const top = measureRects[0].top;
                        const bottom = measureRects[measureRects.length - 1].bottom;
                        const left = minLeft;
                        const right = maxRight;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    return fallback;
                }
                const resetRects = await platform.getElementRects({
                    reference: {
                        getBoundingClientRect: getBoundingClientRect
                    },
                    floating: elements.floating,
                    strategy: strategy
                });
                if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                    reset: {
                        rects: resetRects
                    }
                };
                return {};
            }
        };
    };
    async function $c48df878d8118962$var$convertValueToCoords(state, options) {
        const { placement: placement, platform: platform, elements: elements } = state;
        const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
        const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
        const alignment = (0, (0, parcelRequire("cVo0M")).getAlignment)(placement);
        const isVertical = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement) === 'y';
        const mainAxisMulti = [
            'left',
            'top'
        ].includes(side) ? -1 : 1;
        const crossAxisMulti = rtl && isVertical ? -1 : 1;
        const rawValue = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
        let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
            mainAxis: rawValue,
            crossAxis: 0,
            alignmentAxis: null
        } : {
            mainAxis: rawValue.mainAxis || 0,
            crossAxis: rawValue.crossAxis || 0,
            alignmentAxis: rawValue.alignmentAxis
        };
        if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
        return isVertical ? {
            x: crossAxis * crossAxisMulti,
            y: mainAxis * mainAxisMulti
        } : {
            x: mainAxis * mainAxisMulti,
            y: crossAxis * crossAxisMulti
        };
    }
    const $c48df878d8118962$export$cc800923e997bb8 = function(options) {
        if (options === void 0) options = 0;
        return {
            name: 'offset',
            options: options,
            async fn (state) {
                var _middlewareData$offse, _middlewareData$arrow;
                const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
                const diffCoords = await $c48df878d8118962$var$convertValueToCoords(state, options);
                if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
                return {
                    x: x + diffCoords.x,
                    y: y + diffCoords.y,
                    data: {
                        ...diffCoords,
                        placement: placement
                    }
                };
            }
        };
    };
    const $c48df878d8118962$export$fba63a578e423eb = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'shift',
            options: options,
            async fn (state) {
                const { x: x, y: y, placement: placement } = state;
                const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                    fn: (_ref)=>{
                        let { x: x, y: y } = _ref;
                        return {
                            x: x,
                            y: y
                        };
                    }
                }, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const coords = {
                    x: x,
                    y: y
                };
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const crossAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)((0, (0, parcelRequire("cVo0M")).getSide)(placement));
                const mainAxis = (0, (0, parcelRequire("cVo0M")).getOppositeAxis)(crossAxis);
                let mainAxisCoord = coords[mainAxis];
                let crossAxisCoord = coords[crossAxis];
                if (checkMainAxis) {
                    const minSide = mainAxis === 'y' ? 'top' : 'left';
                    const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                    const min = mainAxisCoord + overflow[minSide];
                    const max = mainAxisCoord - overflow[maxSide];
                    mainAxisCoord = (0, (0, parcelRequire("cVo0M")).clamp)(min, mainAxisCoord, max);
                }
                if (checkCrossAxis) {
                    const minSide = crossAxis === 'y' ? 'top' : 'left';
                    const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                    const min = crossAxisCoord + overflow[minSide];
                    const max = crossAxisCoord - overflow[maxSide];
                    crossAxisCoord = (0, (0, parcelRequire("cVo0M")).clamp)(min, crossAxisCoord, max);
                }
                const limitedCoords = limiter.fn({
                    ...state,
                    [mainAxis]: mainAxisCoord,
                    [crossAxis]: crossAxisCoord
                });
                return {
                    ...limitedCoords,
                    data: {
                        x: limitedCoords.x - x,
                        y: limitedCoords.y - y,
                        enabled: {
                            [mainAxis]: checkMainAxis,
                            [crossAxis]: checkCrossAxis
                        }
                    }
                };
            }
        };
    };
    const $c48df878d8118962$export$7bf07e38f3dc4b69 = function(options) {
        if (options === void 0) options = {};
        return {
            options: options,
            fn (state) {
                const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
                const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const coords = {
                    x: x,
                    y: y
                };
                const crossAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement);
                const mainAxis = (0, (0, parcelRequire("cVo0M")).getOppositeAxis)(crossAxis);
                let mainAxisCoord = coords[mainAxis];
                let crossAxisCoord = coords[crossAxis];
                const rawOffset = (0, (0, parcelRequire("cVo0M")).evaluate)(offset, state);
                const computedOffset = typeof rawOffset === 'number' ? {
                    mainAxis: rawOffset,
                    crossAxis: 0
                } : {
                    mainAxis: 0,
                    crossAxis: 0,
                    ...rawOffset
                };
                if (checkMainAxis) {
                    const len = mainAxis === 'y' ? 'height' : 'width';
                    const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                    const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                    if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                    else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
                }
                if (checkCrossAxis) {
                    var _middlewareData$offse, _middlewareData$offse2;
                    const len = mainAxis === 'y' ? 'width' : 'height';
                    const isOriginSide = [
                        'top',
                        'left'
                    ].includes((0, (0, parcelRequire("cVo0M")).getSide)(placement));
                    const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                    const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                    if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                    else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
                }
                return {
                    [mainAxis]: mainAxisCoord,
                    [crossAxis]: crossAxisCoord
                };
            }
        };
    };
    const $c48df878d8118962$export$346677f925de839c = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'size',
            options: options,
            async fn (state) {
                var _state$middlewareData, _state$middlewareData2;
                const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
                const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
                const alignment = (0, (0, parcelRequire("cVo0M")).getAlignment)(placement);
                const isYAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement) === 'y';
                const { width: width, height: height } = rects.floating;
                let heightSide;
                let widthSide;
                if (side === 'top' || side === 'bottom') {
                    heightSide = side;
                    widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
                } else {
                    widthSide = side;
                    heightSide = alignment === 'end' ? 'top' : 'bottom';
                }
                const maximumClippingHeight = height - overflow.top - overflow.bottom;
                const maximumClippingWidth = width - overflow.left - overflow.right;
                const overflowAvailableHeight = (0, (0, parcelRequire("cVo0M")).min)(height - overflow[heightSide], maximumClippingHeight);
                const overflowAvailableWidth = (0, (0, parcelRequire("cVo0M")).min)(width - overflow[widthSide], maximumClippingWidth);
                const noShift = !state.middlewareData.shift;
                let availableHeight = overflowAvailableHeight;
                let availableWidth = overflowAvailableWidth;
                if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
                if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
                if (noShift && !alignment) {
                    const xMin = (0, (0, parcelRequire("cVo0M")).max)(overflow.left, 0);
                    const xMax = (0, (0, parcelRequire("cVo0M")).max)(overflow.right, 0);
                    const yMin = (0, (0, parcelRequire("cVo0M")).max)(overflow.top, 0);
                    const yMax = (0, (0, parcelRequire("cVo0M")).max)(overflow.bottom, 0);
                    if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, (0, parcelRequire("cVo0M")).max)(overflow.left, overflow.right));
                    else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, (0, parcelRequire("cVo0M")).max)(overflow.top, overflow.bottom));
                }
                await apply({
                    ...state,
                    availableWidth: availableWidth,
                    availableHeight: availableHeight
                });
                const nextDimensions = await platform.getDimensions(elements.floating);
                if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                    reset: {
                        rects: true
                    }
                };
                return {};
            }
        };
    };
});
parcelRegister("cVo0M", function(module, exports) {
    $parcel$export(module.exports, "sides", ()=>$968d6f1d7e429938$export$832b6fa47fa053d2);
    $parcel$export(module.exports, "placements", ()=>$968d6f1d7e429938$export$803cd8101b6c182b);
    $parcel$export(module.exports, "min", ()=>$968d6f1d7e429938$export$96ec731ed4dcb222);
    $parcel$export(module.exports, "max", ()=>$968d6f1d7e429938$export$8960430cfd85939f);
    $parcel$export(module.exports, "round", ()=>$968d6f1d7e429938$export$2077e0241d6afd3c);
    $parcel$export(module.exports, "floor", ()=>$968d6f1d7e429938$export$a3fe094919f356fd);
    $parcel$export(module.exports, "createCoords", ()=>$968d6f1d7e429938$export$a397704b5e280835);
    $parcel$export(module.exports, "clamp", ()=>$968d6f1d7e429938$export$7d15b64cf5a3a4c4);
    $parcel$export(module.exports, "evaluate", ()=>$968d6f1d7e429938$export$fef61f332f2c0afc);
    $parcel$export(module.exports, "getSide", ()=>$968d6f1d7e429938$export$3c915306cb7fc97a);
    $parcel$export(module.exports, "getAlignment", ()=>$968d6f1d7e429938$export$f0989780f32bfcda);
    $parcel$export(module.exports, "getOppositeAxis", ()=>$968d6f1d7e429938$export$8a000a963141ac32);
    $parcel$export(module.exports, "getAxisLength", ()=>$968d6f1d7e429938$export$320bd9d53520c68a);
    $parcel$export(module.exports, "getSideAxis", ()=>$968d6f1d7e429938$export$f28e8f882010718a);
    $parcel$export(module.exports, "getAlignmentAxis", ()=>$968d6f1d7e429938$export$2b57e0052a6d6d4c);
    $parcel$export(module.exports, "getAlignmentSides", ()=>$968d6f1d7e429938$export$be42861551f17911);
    $parcel$export(module.exports, "getOppositePlacement", ()=>$968d6f1d7e429938$export$9c5e28bad23365fa);
    $parcel$export(module.exports, "getExpandedPlacements", ()=>$968d6f1d7e429938$export$496432a3699e50b1);
    $parcel$export(module.exports, "getOppositeAlignmentPlacement", ()=>$968d6f1d7e429938$export$2b182c584985588b);
    $parcel$export(module.exports, "getOppositeAxisPlacements", ()=>$968d6f1d7e429938$export$a9b6fb18fd92c3ec);
    $parcel$export(module.exports, "getPaddingObject", ()=>$968d6f1d7e429938$export$598c291c29bc2e71);
    $parcel$export(module.exports, "rectToClientRect", ()=>$968d6f1d7e429938$export$ee05aea0aeecbad4);
    const $968d6f1d7e429938$export$832b6fa47fa053d2 = [
        'top',
        'right',
        'bottom',
        'left'
    ];
    const $968d6f1d7e429938$export$27b07d8a310ed8b5 = [
        'start',
        'end'
    ];
    const $968d6f1d7e429938$export$803cd8101b6c182b = $968d6f1d7e429938$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $968d6f1d7e429938$export$27b07d8a310ed8b5[0], side + "-" + $968d6f1d7e429938$export$27b07d8a310ed8b5[1]), []);
    const $968d6f1d7e429938$export$96ec731ed4dcb222 = Math.min;
    const $968d6f1d7e429938$export$8960430cfd85939f = Math.max;
    const $968d6f1d7e429938$export$2077e0241d6afd3c = Math.round;
    const $968d6f1d7e429938$export$a3fe094919f356fd = Math.floor;
    const $968d6f1d7e429938$export$a397704b5e280835 = (v)=>({
            x: v,
            y: v
        });
    const $968d6f1d7e429938$var$oppositeSideMap = {
        left: 'right',
        right: 'left',
        bottom: 'top',
        top: 'bottom'
    };
    const $968d6f1d7e429938$var$oppositeAlignmentMap = {
        start: 'end',
        end: 'start'
    };
    function $968d6f1d7e429938$export$7d15b64cf5a3a4c4(start, value, end) {
        return $968d6f1d7e429938$export$8960430cfd85939f(start, $968d6f1d7e429938$export$96ec731ed4dcb222(value, end));
    }
    function $968d6f1d7e429938$export$fef61f332f2c0afc(value, param) {
        return typeof value === 'function' ? value(param) : value;
    }
    function $968d6f1d7e429938$export$3c915306cb7fc97a(placement) {
        return placement.split('-')[0];
    }
    function $968d6f1d7e429938$export$f0989780f32bfcda(placement) {
        return placement.split('-')[1];
    }
    function $968d6f1d7e429938$export$8a000a963141ac32(axis) {
        return axis === 'x' ? 'y' : 'x';
    }
    function $968d6f1d7e429938$export$320bd9d53520c68a(axis) {
        return axis === 'y' ? 'height' : 'width';
    }
    function $968d6f1d7e429938$export$f28e8f882010718a(placement) {
        return [
            'top',
            'bottom'
        ].includes($968d6f1d7e429938$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
    }
    function $968d6f1d7e429938$export$2b57e0052a6d6d4c(placement) {
        return $968d6f1d7e429938$export$8a000a963141ac32($968d6f1d7e429938$export$f28e8f882010718a(placement));
    }
    function $968d6f1d7e429938$export$be42861551f17911(placement, rects, rtl) {
        if (rtl === void 0) rtl = false;
        const alignment = $968d6f1d7e429938$export$f0989780f32bfcda(placement);
        const alignmentAxis = $968d6f1d7e429938$export$2b57e0052a6d6d4c(placement);
        const length = $968d6f1d7e429938$export$320bd9d53520c68a(alignmentAxis);
        let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
        if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $968d6f1d7e429938$export$9c5e28bad23365fa(mainAlignmentSide);
        return [
            mainAlignmentSide,
            $968d6f1d7e429938$export$9c5e28bad23365fa(mainAlignmentSide)
        ];
    }
    function $968d6f1d7e429938$export$496432a3699e50b1(placement) {
        const oppositePlacement = $968d6f1d7e429938$export$9c5e28bad23365fa(placement);
        return [
            $968d6f1d7e429938$export$2b182c584985588b(placement),
            oppositePlacement,
            $968d6f1d7e429938$export$2b182c584985588b(oppositePlacement)
        ];
    }
    function $968d6f1d7e429938$export$2b182c584985588b(placement) {
        return placement.replace(/start|end/g, (alignment)=>$968d6f1d7e429938$var$oppositeAlignmentMap[alignment]);
    }
    function $968d6f1d7e429938$var$getSideList(side, isStart, rtl) {
        const lr = [
            'left',
            'right'
        ];
        const rl = [
            'right',
            'left'
        ];
        const tb = [
            'top',
            'bottom'
        ];
        const bt = [
            'bottom',
            'top'
        ];
        switch(side){
            case 'top':
            case 'bottom':
                if (rtl) return isStart ? rl : lr;
                return isStart ? lr : rl;
            case 'left':
            case 'right':
                return isStart ? tb : bt;
            default:
                return [];
        }
    }
    function $968d6f1d7e429938$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
        const alignment = $968d6f1d7e429938$export$f0989780f32bfcda(placement);
        let list = $968d6f1d7e429938$var$getSideList($968d6f1d7e429938$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
        if (alignment) {
            list = list.map((side)=>side + "-" + alignment);
            if (flipAlignment) list = list.concat(list.map($968d6f1d7e429938$export$2b182c584985588b));
        }
        return list;
    }
    function $968d6f1d7e429938$export$9c5e28bad23365fa(placement) {
        return placement.replace(/left|right|bottom|top/g, (side)=>$968d6f1d7e429938$var$oppositeSideMap[side]);
    }
    function $968d6f1d7e429938$export$1c66dbf1a9e34223(padding) {
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...padding
        };
    }
    function $968d6f1d7e429938$export$598c291c29bc2e71(padding) {
        return typeof padding !== 'number' ? $968d6f1d7e429938$export$1c66dbf1a9e34223(padding) : {
            top: padding,
            right: padding,
            bottom: padding,
            left: padding
        };
    }
    function $968d6f1d7e429938$export$ee05aea0aeecbad4(rect) {
        const { x: x, y: y, width: width, height: height } = rect;
        return {
            width: width,
            height: height,
            top: y,
            left: x,
            right: x + width,
            bottom: y + height,
            x: x,
            y: y
        };
    }
});
parcelRegister("f8LYQ", function(module, exports) {
    $parcel$export(module.exports, "getNodeName", ()=>$b05cd24baa7455b6$export$651544f548703224);
    $parcel$export(module.exports, "getWindow", ()=>$b05cd24baa7455b6$export$38b2d434cce3ea22);
    $parcel$export(module.exports, "getDocumentElement", ()=>$b05cd24baa7455b6$export$e495491855dc5418);
    $parcel$export(module.exports, "isElement", ()=>$b05cd24baa7455b6$export$45a5e7f76e0caa8d);
    $parcel$export(module.exports, "isHTMLElement", ()=>$b05cd24baa7455b6$export$1b3bfaa9684536aa);
    $parcel$export(module.exports, "isOverflowElement", ()=>$b05cd24baa7455b6$export$989e911fa9af580a);
    $parcel$export(module.exports, "getComputedStyle", ()=>$b05cd24baa7455b6$export$3735103072e4a80);
    $parcel$export(module.exports, "isTableElement", ()=>$b05cd24baa7455b6$export$71535ffaa902797f);
    $parcel$export(module.exports, "isTopLayer", ()=>$b05cd24baa7455b6$export$89e651af02346cd4);
    $parcel$export(module.exports, "isContainingBlock", ()=>$b05cd24baa7455b6$export$d6c4e8150c35fed1);
    $parcel$export(module.exports, "isWebKit", ()=>$b05cd24baa7455b6$export$78551043582a6a98);
    $parcel$export(module.exports, "getContainingBlock", ()=>$b05cd24baa7455b6$export$940d8225183e1404);
    $parcel$export(module.exports, "getParentNode", ()=>$b05cd24baa7455b6$export$4e12058fc4d51d56);
    $parcel$export(module.exports, "isLastTraversableNode", ()=>$b05cd24baa7455b6$export$d1162fb0b6d4cd51);
    $parcel$export(module.exports, "getNodeScroll", ()=>$b05cd24baa7455b6$export$dc8fc79fa2800137);
    $parcel$export(module.exports, "getOverflowAncestors", ()=>$b05cd24baa7455b6$export$3b57c1601291186b);
    $parcel$export(module.exports, "getFrameElement", ()=>$b05cd24baa7455b6$export$7bf1f8740e3e34af);
    function $b05cd24baa7455b6$var$hasWindow() {
        return typeof window !== 'undefined';
    }
    function $b05cd24baa7455b6$export$651544f548703224(node) {
        if ($b05cd24baa7455b6$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
        return '#document';
    }
    function $b05cd24baa7455b6$export$38b2d434cce3ea22(node) {
        var _node$ownerDocument;
        return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
    }
    function $b05cd24baa7455b6$export$e495491855dc5418(node) {
        var _ref;
        return (_ref = ($b05cd24baa7455b6$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
    }
    function $b05cd24baa7455b6$export$8ee0fc9ee280b4ee(value) {
        if (!$b05cd24baa7455b6$var$hasWindow()) return false;
        return value instanceof Node || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).Node;
    }
    function $b05cd24baa7455b6$export$45a5e7f76e0caa8d(value) {
        if (!$b05cd24baa7455b6$var$hasWindow()) return false;
        return value instanceof Element || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).Element;
    }
    function $b05cd24baa7455b6$export$1b3bfaa9684536aa(value) {
        if (!$b05cd24baa7455b6$var$hasWindow()) return false;
        return value instanceof HTMLElement || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).HTMLElement;
    }
    function $b05cd24baa7455b6$export$af51f0f06c0f328a(value) {
        if (!$b05cd24baa7455b6$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
        return value instanceof ShadowRoot || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).ShadowRoot;
    }
    function $b05cd24baa7455b6$export$989e911fa9af580a(element) {
        const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $b05cd24baa7455b6$export$3735103072e4a80(element);
        return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
            'inline',
            'contents'
        ].includes(display);
    }
    function $b05cd24baa7455b6$export$71535ffaa902797f(element) {
        return [
            'table',
            'td',
            'th'
        ].includes($b05cd24baa7455b6$export$651544f548703224(element));
    }
    function $b05cd24baa7455b6$export$89e651af02346cd4(element) {
        return [
            ':popover-open',
            ':modal'
        ].some((selector)=>{
            try {
                return element.matches(selector);
            } catch (e) {
                return false;
            }
        });
    }
    function $b05cd24baa7455b6$export$d6c4e8150c35fed1(elementOrCss) {
        const webkit = $b05cd24baa7455b6$export$78551043582a6a98();
        const css = $b05cd24baa7455b6$export$45a5e7f76e0caa8d(elementOrCss) ? $b05cd24baa7455b6$export$3735103072e4a80(elementOrCss) : elementOrCss;
        return css.transform !== 'none' || css.perspective !== 'none' || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || [
            'transform',
            'perspective',
            'filter'
        ].some((value)=>(css.willChange || '').includes(value)) || [
            'paint',
            'layout',
            'strict',
            'content'
        ].some((value)=>(css.contain || '').includes(value));
    }
    function $b05cd24baa7455b6$export$940d8225183e1404(element) {
        let currentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(element);
        while($b05cd24baa7455b6$export$1b3bfaa9684536aa(currentNode) && !$b05cd24baa7455b6$export$d1162fb0b6d4cd51(currentNode)){
            if ($b05cd24baa7455b6$export$d6c4e8150c35fed1(currentNode)) return currentNode;
            else if ($b05cd24baa7455b6$export$89e651af02346cd4(currentNode)) return null;
            currentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(currentNode);
        }
        return null;
    }
    function $b05cd24baa7455b6$export$78551043582a6a98() {
        if (typeof CSS === 'undefined' || !CSS.supports) return false;
        return CSS.supports('-webkit-backdrop-filter', 'none');
    }
    function $b05cd24baa7455b6$export$d1162fb0b6d4cd51(node) {
        return [
            'html',
            'body',
            '#document'
        ].includes($b05cd24baa7455b6$export$651544f548703224(node));
    }
    function $b05cd24baa7455b6$export$3735103072e4a80(element) {
        return $b05cd24baa7455b6$export$38b2d434cce3ea22(element).getComputedStyle(element);
    }
    function $b05cd24baa7455b6$export$dc8fc79fa2800137(element) {
        if ($b05cd24baa7455b6$export$45a5e7f76e0caa8d(element)) return {
            scrollLeft: element.scrollLeft,
            scrollTop: element.scrollTop
        };
        return {
            scrollLeft: element.scrollX,
            scrollTop: element.scrollY
        };
    }
    function $b05cd24baa7455b6$export$4e12058fc4d51d56(node) {
        if ($b05cd24baa7455b6$export$651544f548703224(node) === 'html') return node;
        const result = node.assignedSlot || node.parentNode || $b05cd24baa7455b6$export$af51f0f06c0f328a(node) && node.host || $b05cd24baa7455b6$export$e495491855dc5418(node);
        return $b05cd24baa7455b6$export$af51f0f06c0f328a(result) ? result.host : result;
    }
    function $b05cd24baa7455b6$export$7cd01a57c8ca906c(node) {
        const parentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(node);
        if ($b05cd24baa7455b6$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
        if ($b05cd24baa7455b6$export$1b3bfaa9684536aa(parentNode) && $b05cd24baa7455b6$export$989e911fa9af580a(parentNode)) return parentNode;
        return $b05cd24baa7455b6$export$7cd01a57c8ca906c(parentNode);
    }
    function $b05cd24baa7455b6$export$3b57c1601291186b(node, list, traverseIframes) {
        var _node$ownerDocument2;
        if (list === void 0) list = [];
        if (traverseIframes === void 0) traverseIframes = true;
        const scrollableAncestor = $b05cd24baa7455b6$export$7cd01a57c8ca906c(node);
        const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
        const win = $b05cd24baa7455b6$export$38b2d434cce3ea22(scrollableAncestor);
        if (isBody) {
            const frameElement = $b05cd24baa7455b6$export$7bf1f8740e3e34af(win);
            return list.concat(win, win.visualViewport || [], $b05cd24baa7455b6$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $b05cd24baa7455b6$export$3b57c1601291186b(frameElement) : []);
        }
        return list.concat(scrollableAncestor, $b05cd24baa7455b6$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
    }
    function $b05cd24baa7455b6$export$7bf1f8740e3e34af(win) {
        return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
    }
});
parcelRegister("hrqx3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cb2989fd9beaabfa$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cb2989fd9beaabfa$var$index = (0, $5uXOq.useLayoutEffect);
    var $cb2989fd9beaabfa$export$2e2bcd8739ae039 = $cb2989fd9beaabfa$var$index;
});
parcelRegister("hqcPo", function(module, exports) {
    $parcel$export(module.exports, "multiValueCSS", ()=>$20933ad7b05a0c37$export$23c213f7717186af);
    $parcel$export(module.exports, "multiValueLabelCSS", ()=>$20933ad7b05a0c37$export$f40612612e0af964);
    $parcel$export(module.exports, "multiValueRemoveCSS", ()=>$20933ad7b05a0c37$export$283467f6c4ac142b);
    $parcel$export(module.exports, "MultiValueContainer", ()=>$20933ad7b05a0c37$export$cf9cf2a30a59265c);
    $parcel$export(module.exports, "MultiValueLabel", ()=>$20933ad7b05a0c37$export$544aeea2a5ce08ee);
    $parcel$export(module.exports, "MultiValueRemove", ()=>$20933ad7b05a0c37$export$8e1fd1a40e7a2f4a);
    $parcel$export(module.exports, "default", ()=>$20933ad7b05a0c37$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    var $95iuW;
    const $20933ad7b05a0c37$export$23c213f7717186af = ({ theme: { spacing: spacing, borderRadius: borderRadius, colors: colors } }, unstyled)=>({
            label: 'multiValue',
            display: 'flex',
            minWidth: 0,
            ...unstyled ? {} : {
                backgroundColor: colors.neutral10,
                borderRadius: borderRadius / 2,
                margin: spacing.baseUnit / 2
            }
        });
    const $20933ad7b05a0c37$export$f40612612e0af964 = ({ theme: { borderRadius: borderRadius, colors: colors }, cropWithEllipsis: cropWithEllipsis }, unstyled)=>({
            overflow: 'hidden',
            textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
            whiteSpace: 'nowrap',
            ...unstyled ? {} : {
                borderRadius: borderRadius / 2,
                color: colors.neutral80,
                fontSize: '85%',
                padding: 3,
                paddingLeft: 6
            }
        });
    const $20933ad7b05a0c37$export$283467f6c4ac142b = ({ theme: { spacing: spacing, borderRadius: borderRadius, colors: colors }, isFocused: isFocused }, unstyled)=>({
            alignItems: 'center',
            display: 'flex',
            ...unstyled ? {} : {
                borderRadius: borderRadius / 2,
                backgroundColor: isFocused ? colors.dangerLight : undefined,
                paddingLeft: spacing.baseUnit,
                paddingRight: spacing.baseUnit,
                ':hover': {
                    backgroundColor: colors.dangerLight,
                    color: colors.danger
                }
            }
        });
    const $20933ad7b05a0c37$export$e1de505c1242dc1a = ({ children: children, innerProps: innerProps })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", innerProps, children);
    const $20933ad7b05a0c37$export$cf9cf2a30a59265c = $20933ad7b05a0c37$export$e1de505c1242dc1a;
    const $20933ad7b05a0c37$export$544aeea2a5ce08ee = $20933ad7b05a0c37$export$e1de505c1242dc1a;
    function $20933ad7b05a0c37$export$8e1fd1a40e7a2f4a({ children: children, innerProps: innerProps }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            role: "button",
            ...innerProps
        }, children || (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("95iuW")).CrossIcon), {
            size: 14
        }));
    }
    const $20933ad7b05a0c37$var$MultiValue = (props)=>{
        const { children: children, components: components, data: data, innerProps: innerProps, isDisabled: isDisabled, removeProps: removeProps, selectProps: selectProps } = props;
        const { Container: Container, Label: Label, Remove: Remove } = components;
        return (0, (0, parcelRequire("f8Sb3")).jsx)(Container, {
            data: data,
            innerProps: {
                ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'multiValue', {
                    'multi-value': true,
                    'multi-value--is-disabled': isDisabled
                }),
                ...innerProps
            },
            selectProps: selectProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)(Label, {
            data: data,
            innerProps: {
                ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'multiValueLabel', {
                    'multi-value__label': true
                })
            },
            selectProps: selectProps
        }, children), (0, (0, parcelRequire("f8Sb3")).jsx)(Remove, {
            data: data,
            innerProps: {
                ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'multiValueRemove', {
                    'multi-value__remove': true
                }),
                'aria-label': `Remove ${children || 'option'}`,
                ...removeProps
            },
            selectProps: selectProps
        }));
    };
    var $20933ad7b05a0c37$export$2e2bcd8739ae039 = $20933ad7b05a0c37$var$MultiValue;
});
parcelRegister("8l2RA", function(module, exports) {
    $parcel$export(module.exports, "optionCSS", ()=>$6e6d67a90b457dc1$export$ef897119b7e920ba);
    $parcel$export(module.exports, "default", ()=>$6e6d67a90b457dc1$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $6e6d67a90b457dc1$export$ef897119b7e920ba = ({ isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, theme: { spacing: spacing, colors: colors } }, unstyled)=>({
            label: 'option',
            cursor: 'default',
            display: 'block',
            fontSize: 'inherit',
            width: '100%',
            userSelect: 'none',
            WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
            ...unstyled ? {} : {
                backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
                color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
                padding: `${spacing.baseUnit * 2}px ${spacing.baseUnit * 3}px`,
                ':active': {
                    backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
                }
            }
        });
    const $6e6d67a90b457dc1$var$Option = (props)=>{
        const { children: children, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, innerRef: innerRef, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'option', {
                option: true,
                'option--is-disabled': isDisabled,
                'option--is-focused': isFocused,
                'option--is-selected': isSelected
            }),
            ref: innerRef,
            "aria-disabled": isDisabled,
            ...innerProps,
            tabIndex: -1
        }, children);
    };
    var $6e6d67a90b457dc1$export$2e2bcd8739ae039 = $6e6d67a90b457dc1$var$Option;
});
parcelRegister("kKm82", function(module, exports) {
    $parcel$export(module.exports, "placeholderCSS", ()=>$889d652a9d0dc097$export$5f3ffacd6594d90f);
    $parcel$export(module.exports, "default", ()=>$889d652a9d0dc097$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $889d652a9d0dc097$export$5f3ffacd6594d90f = ({ theme: { spacing: spacing, colors: colors } }, unstyled)=>({
            label: 'placeholder',
            gridArea: '1 / 1 / 2 / 3',
            ...unstyled ? {} : {
                color: colors.neutral50,
                marginLeft: spacing.baseUnit / 2,
                marginRight: spacing.baseUnit / 2
            }
        });
    const $889d652a9d0dc097$var$Placeholder = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'placeholder', {
                placeholder: true
            }),
            ...innerProps
        }, children);
    };
    var $889d652a9d0dc097$export$2e2bcd8739ae039 = $889d652a9d0dc097$var$Placeholder;
});
parcelRegister("hpcbi", function(module, exports) {
    $parcel$export(module.exports, "css", ()=>$aff94346c62a222f$export$dbf350e5966cf602);
    $parcel$export(module.exports, "default", ()=>$aff94346c62a222f$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $aff94346c62a222f$export$dbf350e5966cf602 = ({ isDisabled: isDisabled, theme: { spacing: spacing, colors: colors } }, unstyled)=>({
            label: 'singleValue',
            gridArea: '1 / 1 / 2 / 3',
            maxWidth: '100%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            ...unstyled ? {} : {
                color: isDisabled ? colors.neutral40 : colors.neutral80,
                marginLeft: spacing.baseUnit / 2,
                marginRight: spacing.baseUnit / 2
            }
        });
    const $aff94346c62a222f$var$SingleValue = (props)=>{
        const { children: children, isDisabled: isDisabled, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'singleValue', {
                'single-value': true,
                'single-value--is-disabled': isDisabled
            }),
            ...innerProps
        }, children);
    };
    var $aff94346c62a222f$export$2e2bcd8739ae039 = $aff94346c62a222f$var$SingleValue;
});
parcelRegister("b9dFI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$768d8504b373d7ff$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cBeZP;
    var $7nsd3 = parcelRequire("7nsd3");
    var $ao4Ml = parcelRequire("ao4Ml");
    var $9ZKDH = parcelRequire("9ZKDH");
    var $dI393 = parcelRequire("dI393");
    var $5n5w4;
    var $283js;
    var $iGDLS;
    var $4wJSY = parcelRequire("4wJSY");
    var $9KnKW;
    var $VSDnB;
    var $7VXAu;
    var $7K5PP;
    var $eaXSR;
    var $1DATb;
    var $hT6ku;
    const $768d8504b373d7ff$var$canUseDOM = ()=>Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
    const $768d8504b373d7ff$var$FocusLock = (0, (0, parcelRequire("VSDnB")).fg)('platform_dst_select-bump-react-focus-lock') ? (0, $9ZKDH.default) : (0, $ao4Ml.default);
    const $768d8504b373d7ff$var$modifiers = [
        {
            name: 'offset',
            options: {
                offset: [
                    0,
                    8
                ]
            }
        },
        {
            name: 'preventOverflow',
            enabled: true,
            options: {
                padding: 5,
                boundary: 'clippingParents',
                altAxis: true,
                altBoundary: true
            }
        }
    ];
    const $768d8504b373d7ff$var$defaultPopperProps = {
        modifiers: $768d8504b373d7ff$var$modifiers,
        placement: 'bottom-start'
    };
    const $768d8504b373d7ff$var$isEmpty = (obj)=>Object.keys(obj).length === 0;
    class $768d8504b373d7ff$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
        static{
            this.defaultProps = {
                closeMenuOnSelect: true,
                shouldCloseMenuOnTab: true,
                components: {},
                maxMenuHeight: 300,
                maxMenuWidth: 440,
                minMenuWidth: 220,
                popperProps: {},
                isSearchable: true,
                searchThreshold: 5,
                styles: {},
                options: []
            };
        }
        static getDerivedStateFromProps(props, state) {
            const newState = {};
            const mergedPopperProps = {
                ...$768d8504b373d7ff$var$defaultPopperProps,
                ...props.popperProps
            };
            if (!(0, $4wJSY.shallowEqualObjects)(mergedPopperProps, state.mergedPopperProps)) newState.mergedPopperProps = mergedPopperProps;
            const mergedComponents = {
                ...(0, (0, parcelRequire("hT6ku")).defaultComponents),
                ...props.components
            };
            if (!(0, $4wJSY.shallowEqualObjects)(mergedComponents, state.mergedComponents)) newState.mergedComponents = mergedComponents;
            if (!$768d8504b373d7ff$var$isEmpty(newState)) return newState;
            return null;
        }
        componentDidMount() {
            if (typeof window === 'undefined') return;
            this.unbindWindowClick = (0, (0, parcelRequire("cBeZP")).bind)(window, {
                type: 'click',
                listener: this.handleClick,
                options: {
                    capture: true
                }
            });
        }
        componentWillUnmount() {
            if (typeof window === 'undefined') return;
            this.unbindWindowClick?.();
            this.unbindWindowClick = null;
            this.unbindWindowKeydown?.();
            this.unbindWindowKeydown = null;
        }
        componentDidUpdate(prevProps) {
            const { isOpen: isOpen } = this.props;
            if (prevProps.isOpen !== isOpen) {
                if (isOpen === true) this.open({
                    controlOverride: true
                });
                else if (isOpen === false) this.close({
                    controlOverride: true
                });
            }
        }
        render() {
            const { target: target } = this.props;
            const { isOpen: isOpen } = this.state;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5n5w4")).Manager), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9KnKW")).IdProvider), {
                postfix: "-popup-select"
            }, ({ id: id })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iGDLS")).Reference), null, ({ ref: ref })=>target && target({
                        isOpen: isOpen,
                        onKeyDown: this.handleTargetKeyDown,
                        ref: this.resolveTargetRef(ref),
                        'aria-haspopup': 'true',
                        'aria-expanded': isOpen,
                        'aria-controls': isOpen ? id : undefined
                    })), this.renderSelect(id))));
        }
        constructor(...args){
            super(...args);
            this.menuRef = null;
            this.selectRef = null;
            this.targetRef = null;
            this.unbindWindowClick = null;
            this.unbindWindowKeydown = null;
            this.defaultStyles = (0, (0, parcelRequire("7VXAu")).mergeStyles)((0, (0, parcelRequire("eaXSR")).default)(this.props.validationState || (this.props.isInvalid ? 'error' : 'default'), this.props.spacing === 'compact', 'default'), {
                groupHeading: (provided)=>({
                        ...provided,
                        color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$eaa8c8a70ac22806})`
                    })
            });
            this.isOpenControlled = this.props.isOpen !== undefined;
            this.defaultOpenState = this.isOpenControlled ? this.props.isOpen : this.props.defaultIsOpen;
            this.state = {
                focusLockEnabled: false,
                isOpen: this.defaultOpenState ?? false,
                mergedComponents: (0, (0, parcelRequire("hT6ku")).defaultComponents),
                mergedPopperProps: $768d8504b373d7ff$var$defaultPopperProps
            };
            this.handleTargetKeyDown = (event)=>{
                switch(event.key){
                    case 'ArrowDown':
                        this.open();
                        break;
                    default:
                }
            };
            this.handleKeyDown = (event)=>{
                const tabEvent = event.key === 'Tab' && event.shiftKey || event.key === 'Tab';
                if (this.props.shouldCloseMenuOnTab && tabEvent) this.close();
                switch(event.key){
                    case 'Escape':
                    case 'Esc':
                        this.close();
                        break;
                    default:
                }
                if (this.props.onKeyDown) this.props.onKeyDown(event);
            };
            this.handleClick = ({ target: target })=>{
                const { isOpen: isOpen } = this.state;
                if (!(target instanceof Element)) return;
                if (isOpen && this.menuRef && !this.menuRef.contains(target)) this.close();
                if (!isOpen && this.targetRef && this.targetRef.contains(target)) this.open();
            };
            this.handleSelectChange = (value, actionMeta)=>{
                const { closeMenuOnSelect: closeMenuOnSelect, onChange: onChange } = this.props;
                if (closeMenuOnSelect && actionMeta.action !== 'clear') this.close();
                if (onChange) onChange(value, actionMeta);
            };
            this.handleFirstPopperUpdate = ()=>{
                this.setState({
                    focusLockEnabled: true
                });
            };
            this.open = (options)=>{
                const { onOpen: onOpen, onMenuOpen: onMenuOpen } = this.props;
                if (!options?.controlOverride && this.isOpenControlled) return;
                if (onOpen) onOpen();
                if (onMenuOpen && (0, (0, parcelRequire("VSDnB")).fg)('platform_design_system_team_select_node_resolver')) onMenuOpen();
                this.setState({
                    isOpen: true
                }, ()=>{
                    if (this.selectRef) this.selectRef.select?.openMenu('first');
                });
                if (typeof window === 'undefined') return;
                this.unbindWindowKeydown = (0, (0, parcelRequire("cBeZP")).bind)(window, {
                    type: 'keydown',
                    listener: this.handleKeyDown,
                    options: {
                        capture: true
                    }
                });
            };
            this.close = (options)=>{
                const { onClose: onClose, onMenuClose: onMenuClose } = this.props;
                if (!options?.controlOverride && this.isOpenControlled) return;
                if (onClose) onClose();
                if (onMenuClose && (0, (0, parcelRequire("VSDnB")).fg)('platform_design_system_team_select_node_resolver')) onMenuClose();
                this.setState({
                    isOpen: false
                });
                this.setState({
                    focusLockEnabled: false
                });
                if (this.targetRef != null) this.targetRef.focus();
                if (typeof window === 'undefined') return;
                this.unbindWindowKeydown?.();
                this.unbindWindowKeydown = null;
            };
            this.resolveTargetRef = (popperRef)=>(ref)=>{
                    if (!this.targetRef && popperRef && ref) {
                        this.targetRef = ref;
                        if (typeof popperRef === 'function') popperRef(ref);
                        else popperRef.current = ref;
                    }
                };
            this.resolveMenuRef = (popperRef)=>(ref)=>{
                    this.menuRef = ref;
                    if (typeof popperRef === 'function') popperRef(ref);
                    else popperRef.current = ref;
                };
            this.getSelectRef = (ref)=>{
                this.selectRef = ref;
            };
            this.getItemCount = ()=>{
                const { options: options } = this.props;
                let count = 0;
                options.forEach((groupOrOption)=>{
                    if (groupOrOption.options) groupOrOption.options.forEach(()=>count++);
                    else count++;
                });
                return count;
            };
            this.getMaxHeight = ()=>{
                const { maxMenuHeight: maxMenuHeight } = this.props;
                if (!this.selectRef) return maxMenuHeight;
                const showSearchControl = this.showSearchControl();
                const controlRef = this.selectRef.select?.controlRef;
                const offsetHeight = showSearchControl && controlRef ? controlRef.offsetHeight : 0;
                const maxHeight = maxMenuHeight - offsetHeight;
                return maxHeight;
            };
            this.showSearchControl = ()=>{
                const { searchThreshold: searchThreshold, isSearchable: isSearchable } = this.props;
                return isSearchable && this.getItemCount() > searchThreshold;
            };
            this.renderSelect = (id)=>{
                const { footer: footer, label: label, maxMenuWidth: maxMenuWidth, minMenuWidth: minMenuWidth, placeholder: placeholder, target: target, testId: testId, onMenuOpen: onMenuOpen, onMenuClose: onMenuClose, ...props } = this.props;
                const menuHandlers = !(0, (0, parcelRequire("VSDnB")).fg)('platform_design_system_team_select_node_resolver') ? {
                    onMenuOpen: onMenuOpen,
                    onMenuClose: onMenuClose
                } : {};
                const { focusLockEnabled: focusLockEnabled, isOpen: isOpen, mergedComponents: mergedComponents, mergedPopperProps: mergedPopperProps } = this.state;
                const showSearchControl = this.showSearchControl();
                const portalDestination = $768d8504b373d7ff$var$canUseDOM() ? document.body : null;
                if (!portalDestination || !isOpen) return null;
                const selectComponents = {
                    ...mergedComponents,
                    Control: showSearchControl ? mergedComponents.Control : (0, (0, parcelRequire("hT6ku")).DummyControl)
                };
                const getLabel = ()=>{
                    if (label) return label;
                    else if (typeof placeholder === 'string') return placeholder;
                };
                const providedAriaLabel = getLabel();
                const updateInputAriaLabel = (ariaLabelText)=>{
                    if (this.selectRef?.select?.inputRef) {
                        if (providedAriaLabel) ariaLabelText = `${providedAriaLabel}. ${ariaLabelText}`;
                        this.selectRef?.select.inputRef?.setAttribute('aria-label', ariaLabelText);
                    }
                };
                const generateNoGroupsAriaText = (onFocusProps, ariaLabelSuffix)=>{
                    const { focused: focused } = onFocusProps;
                    const options = props?.options || [];
                    const totalLength = options?.length;
                    const optionIndex = options?.findIndex((option)=>option === focused) ?? 0;
                    const optionName = typeof props?.getOptionLabel === 'function' ? props.getOptionLabel(focused) : focused.label;
                    const ariaLabelText = `Option ${optionName} focused, ${optionIndex + 1} of ${totalLength}.
			${totalLength} results available.
			${ariaLabelSuffix}
			`;
                    return ariaLabelText;
                };
                const onReactSelectFocus = (onFocusProps)=>{
                    const ariaLabelSuffix = ' Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu.';
                    let ariaLabelText = '';
                    let ariaLiveMessage = '';
                    if (props.options?.length) {
                        if ((0, (0, parcelRequire("1DATb")).isOptionsGrouped)(props.options)) {
                            const totalLength = (0, (0, parcelRequire("1DATb")).countAllOptions)(props.options);
                            ariaLiveMessage = (0, (0, parcelRequire("1DATb")).onFocus)(onFocusProps, props.options);
                            ariaLabelText = `${ariaLiveMessage} ${totalLength} results available. ${ariaLabelSuffix}`;
                        } else {
                            ariaLabelText = generateNoGroupsAriaText(onFocusProps, ariaLabelSuffix);
                            ariaLiveMessage = ariaLabelText;
                        }
                        updateInputAriaLabel(ariaLabelText);
                        return ariaLiveMessage;
                    }
                    return ariaLiveMessage;
                };
                const popper = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("283js")).Popper), {
                    ...mergedPopperProps,
                    onFirstUpdate: (state)=>{
                        this.handleFirstPopperUpdate();
                        mergedPopperProps.onFirstUpdate?.(state);
                    }
                }, ({ placement: placement, ref: ref, style: style })=>(0, ($parcel$interopDefault($5uXOq))).createElement($768d8504b373d7ff$var$ConditionalNodeResolverWrapper, {
                        hasNodeResolver: !(0, (0, parcelRequire("VSDnB")).fg)('platform_design_system_team_select_node_resolver'),
                        innerRef: this.resolveMenuRef(ref)
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hT6ku")).MenuDialog), {
                        style: style,
                        "data-placement": placement,
                        minWidth: minMenuWidth,
                        maxWidth: maxMenuWidth,
                        id: id,
                        testId: testId,
                        ref: !(0, (0, parcelRequire("VSDnB")).fg)('platform_design_system_team_select_node_resolver') ? null : this.resolveMenuRef(ref)
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement($768d8504b373d7ff$var$FocusLock, {
                        disabled: !focusLockEnabled,
                        returnFocus: true
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
                        "aria-label": providedAriaLabel,
                        backspaceRemovesValue: false,
                        controlShouldRenderValue: false,
                        isClearable: false,
                        tabSelectsValue: false,
                        menuIsOpen: true,
                        placeholder: placeholder,
                        ref: this.getSelectRef,
                        ...props,
                        ...menuHandlers,
                        isSearchable: showSearchControl,
                        styles: (0, (0, parcelRequire("7VXAu")).mergeStyles)(this.defaultStyles, props.styles || {}),
                        maxMenuHeight: this.getMaxHeight(),
                        components: selectComponents,
                        onChange: this.handleSelectChange,
                        ariaLiveMessages: !showSearchControl ? {
                            onFocus: onReactSelectFocus,
                            ...props.ariaLiveMessages
                        } : props.ariaLiveMessages
                    }), footer))));
                return mergedPopperProps.strategy === 'fixed' ? popper : (0, $7nsd3.createPortal)(popper, portalDestination);
            };
        }
    }
    const $768d8504b373d7ff$var$ConditionalNodeResolverWrapper = ({ hasNodeResolver: hasNodeResolver, children: children, innerRef: innerRef })=>{
        if (hasNodeResolver) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($dI393))), {
            innerRef: innerRef
        }, children);
        return children;
    };
});
parcelRegister("5n5w4", function(module, exports) {
    $parcel$export(module.exports, "ManagerReferenceNodeContext", ()=>$3e93612641040812$export$3dbd3405086fec7b);
    $parcel$export(module.exports, "ManagerReferenceNodeSetterContext", ()=>$3e93612641040812$export$cbabb21c2529b130);
    $parcel$export(module.exports, "Manager", ()=>$3e93612641040812$export$d0d38e7dec7a1a61);
    var $5uXOq = parcelRequire("5uXOq");
    var $3e93612641040812$export$3dbd3405086fec7b = $5uXOq.createContext();
    var $3e93612641040812$export$cbabb21c2529b130 = $5uXOq.createContext();
    function $3e93612641040812$export$d0d38e7dec7a1a61(_ref) {
        var children = _ref.children;
        var _React$useState = $5uXOq.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
        var hasUnmounted = $5uXOq.useRef(false);
        $5uXOq.useEffect(function() {
            return function() {
                hasUnmounted.current = true;
            };
        }, []);
        var handleSetReferenceNode = $5uXOq.useCallback(function(node) {
            if (!hasUnmounted.current) setReferenceNode(node);
        }, []);
        return $5uXOq.createElement($3e93612641040812$export$3dbd3405086fec7b.Provider, {
            value: referenceNode
        }, $5uXOq.createElement($3e93612641040812$export$cbabb21c2529b130.Provider, {
            value: handleSetReferenceNode
        }, children));
    }
});
parcelRegister("283js", function(module, exports) {
    $parcel$export(module.exports, "Popper", ()=>$18cee5f949ac4034$export$badac9ada3a0bdf9);
    var $5uXOq = parcelRequire("5uXOq");
    var $5n5w4;
    var $eclLw;
    var $fNOWl;
    var $18cee5f949ac4034$var$NOOP = function NOOP() {
        return void 0;
    };
    var $18cee5f949ac4034$var$NOOP_PROMISE = function NOOP_PROMISE() {
        return Promise.resolve(null);
    };
    var $18cee5f949ac4034$var$EMPTY_MODIFIERS = [];
    function $18cee5f949ac4034$export$badac9ada3a0bdf9(_ref) {
        var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $18cee5f949ac4034$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
        var referenceNode = $5uXOq.useContext((0, (0, parcelRequire("5n5w4")).ManagerReferenceNodeContext));
        var _React$useState = $5uXOq.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
        var _React$useState2 = $5uXOq.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
        $5uXOq.useEffect(function() {
            (0, (0, parcelRequire("eclLw")).setRef)(innerRef, popperElement);
        }, [
            innerRef,
            popperElement
        ]);
        var options = $5uXOq.useMemo(function() {
            return {
                placement: placement,
                strategy: strategy,
                onFirstUpdate: onFirstUpdate,
                modifiers: [].concat(modifiers, [
                    {
                        name: 'arrow',
                        enabled: arrowElement != null,
                        options: {
                            element: arrowElement
                        }
                    }
                ])
            };
        }, [
            placement,
            strategy,
            onFirstUpdate,
            modifiers,
            arrowElement
        ]);
        var _usePopper = (0, (0, parcelRequire("fNOWl")).usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
        var childrenProps = $5uXOq.useMemo(function() {
            return {
                ref: setPopperElement,
                style: styles.popper,
                placement: state ? state.placement : placement,
                hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
                isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
                arrowProps: {
                    style: styles.arrow,
                    ref: setArrowElement
                },
                forceUpdate: forceUpdate || $18cee5f949ac4034$var$NOOP,
                update: update || $18cee5f949ac4034$var$NOOP_PROMISE
            };
        }, [
            setPopperElement,
            setArrowElement,
            placement,
            state,
            styles,
            update,
            forceUpdate
        ]);
        return (0, (0, parcelRequire("eclLw")).unwrapArray)(children)(childrenProps);
    }
});
parcelRegister("eclLw", function(module, exports) {
    $parcel$export(module.exports, "unwrapArray", ()=>$a56311d537d20f47$export$f52c55943429c8b6);
    $parcel$export(module.exports, "safeInvoke", ()=>$a56311d537d20f47$export$3dfa7c28635fe028);
    $parcel$export(module.exports, "setRef", ()=>$a56311d537d20f47$export$4bb192c7cacf928f);
    $parcel$export(module.exports, "fromEntries", ()=>$a56311d537d20f47$export$5150077fc2e7c662);
    $parcel$export(module.exports, "useIsomorphicLayoutEffect", ()=>$a56311d537d20f47$export$700979bc83e7db82);
    var $5uXOq = parcelRequire("5uXOq");
    var $a56311d537d20f47$export$f52c55943429c8b6 = function unwrapArray(arg) {
        return Array.isArray(arg) ? arg[0] : arg;
    };
    var $a56311d537d20f47$export$3dfa7c28635fe028 = function safeInvoke(fn) {
        if (typeof fn === 'function') {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return fn.apply(void 0, args);
        }
    };
    var $a56311d537d20f47$export$4bb192c7cacf928f = function setRef(ref, node) {
        if (typeof ref === 'function') return $a56311d537d20f47$export$3dfa7c28635fe028(ref, node);
        else if (ref != null) ref.current = node;
    };
    var $a56311d537d20f47$export$5150077fc2e7c662 = function fromEntries(entries) {
        return entries.reduce(function(acc, _ref) {
            var key = _ref[0], value = _ref[1];
            acc[key] = value;
            return acc;
        }, {});
    };
    var $a56311d537d20f47$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $5uXOq.useLayoutEffect : $5uXOq.useEffect;
});
parcelRegister("fNOWl", function(module, exports) {
    $parcel$export(module.exports, "usePopper", ()=>$b812f23d0bbb9e85$export$f4d5bf230a36dd6e);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $8Pv9O;
    var $lHrkK = parcelRequire("lHrkK");
    var $eclLw;
    var $b812f23d0bbb9e85$var$EMPTY_MODIFIERS = [];
    var $b812f23d0bbb9e85$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
        if (options === void 0) options = {};
        var prevOptions = $5uXOq.useRef(null);
        var optionsWithDefaults = {
            onFirstUpdate: options.onFirstUpdate,
            placement: options.placement || 'bottom',
            strategy: options.strategy || 'absolute',
            modifiers: options.modifiers || $b812f23d0bbb9e85$var$EMPTY_MODIFIERS
        };
        var _React$useState = $5uXOq.useState({
            styles: {
                popper: {
                    position: optionsWithDefaults.strategy,
                    left: '0',
                    top: '0'
                },
                arrow: {
                    position: 'absolute'
                }
            },
            attributes: {}
        }), state = _React$useState[0], setState = _React$useState[1];
        var updateStateModifier = $5uXOq.useMemo(function() {
            return {
                name: 'updateState',
                enabled: true,
                phase: 'write',
                fn: function fn(_ref) {
                    var state = _ref.state;
                    var elements = Object.keys(state.elements);
                    $7nsd3.flushSync(function() {
                        setState({
                            styles: (0, (0, parcelRequire("eclLw")).fromEntries)(elements.map(function(element) {
                                return [
                                    element,
                                    state.styles[element] || {}
                                ];
                            })),
                            attributes: (0, (0, parcelRequire("eclLw")).fromEntries)(elements.map(function(element) {
                                return [
                                    element,
                                    state.attributes[element]
                                ];
                            }))
                        });
                    });
                },
                requires: [
                    'computeStyles'
                ]
            };
        }, []);
        var popperOptions = $5uXOq.useMemo(function() {
            var newOptions = {
                onFirstUpdate: optionsWithDefaults.onFirstUpdate,
                placement: optionsWithDefaults.placement,
                strategy: optionsWithDefaults.strategy,
                modifiers: [].concat(optionsWithDefaults.modifiers, [
                    updateStateModifier,
                    {
                        name: 'applyStyles',
                        enabled: false
                    }
                ])
            };
            if ((0, ($parcel$interopDefault($lHrkK)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
            else {
                prevOptions.current = newOptions;
                return newOptions;
            }
        }, [
            optionsWithDefaults.onFirstUpdate,
            optionsWithDefaults.placement,
            optionsWithDefaults.strategy,
            optionsWithDefaults.modifiers,
            updateStateModifier
        ]);
        var popperInstanceRef = $5uXOq.useRef();
        (0, (0, parcelRequire("eclLw")).useIsomorphicLayoutEffect)(function() {
            if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
        }, [
            popperOptions
        ]);
        (0, (0, parcelRequire("eclLw")).useIsomorphicLayoutEffect)(function() {
            if (referenceElement == null || popperElement == null) return;
            var createPopper = options.createPopper || (0, (0, parcelRequire("8Pv9O")).createPopper);
            var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
            popperInstanceRef.current = popperInstance;
            return function() {
                popperInstance.destroy();
                popperInstanceRef.current = null;
            };
        }, [
            referenceElement,
            popperElement,
            options.createPopper
        ]);
        return {
            state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
            styles: state.styles,
            attributes: state.attributes,
            update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
            forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
        };
    };
});
parcelRegister("8Pv9O", function(module, exports) {
    $parcel$export(module.exports, "createPopper", ()=>$66db415bc009fd50$export$8f7491d57c8f97a9);
    var $dsn8Y;
    var $4TVC8;
    var $j8nKB;
    var $baic6;
    var $1AoLg;
    var $gy4Xr;
    var $3dDWl;
    var $1DdSC;
    var $gzAfz;
    var $6iLAT;
    var $66db415bc009fd50$export$d34966752335dd47 = [
        (0, (0, parcelRequire("4TVC8")).default),
        (0, (0, parcelRequire("j8nKB")).default),
        (0, (0, parcelRequire("baic6")).default),
        (0, (0, parcelRequire("1AoLg")).default),
        (0, (0, parcelRequire("gy4Xr")).default),
        (0, (0, parcelRequire("3dDWl")).default),
        (0, (0, parcelRequire("1DdSC")).default),
        (0, (0, parcelRequire("gzAfz")).default),
        (0, (0, parcelRequire("6iLAT")).default)
    ];
    var $66db415bc009fd50$export$8f7491d57c8f97a9 = (0, (0, parcelRequire("dsn8Y")).popperGenerator)({
        defaultModifiers: $66db415bc009fd50$export$d34966752335dd47
    });
});
parcelRegister("dsn8Y", function(module, exports) {
    $parcel$export(module.exports, "popperGenerator", ()=>$9cbfd7bdb6a4f3f1$export$ed5e13716264f202);
    var $gvlia;
    var $jkGDj;
    var $2r6BH;
    var $gbHJy;
    var $kcmIg;
    var $a8clb;
    var $i9xH7;
    var $gmkfg;
    var $9cbfd7bdb6a4f3f1$var$DEFAULT_OPTIONS = {
        placement: 'bottom',
        modifiers: [],
        strategy: 'absolute'
    };
    function $9cbfd7bdb6a4f3f1$var$areValidElements() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return !args.some(function(element) {
            return !(element && typeof element.getBoundingClientRect === 'function');
        });
    }
    function $9cbfd7bdb6a4f3f1$export$ed5e13716264f202(generatorOptions) {
        if (generatorOptions === void 0) generatorOptions = {};
        var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $9cbfd7bdb6a4f3f1$var$DEFAULT_OPTIONS : _generatorOptions$def2;
        return function createPopper(reference, popper, options) {
            if (options === void 0) options = defaultOptions;
            var state = {
                placement: 'bottom',
                orderedModifiers: [],
                options: Object.assign({}, $9cbfd7bdb6a4f3f1$var$DEFAULT_OPTIONS, defaultOptions),
                modifiersData: {},
                elements: {
                    reference: reference,
                    popper: popper
                },
                attributes: {},
                styles: {}
            };
            var effectCleanupFns = [];
            var isDestroyed = false;
            var instance = {
                state: state,
                setOptions: function setOptions(setOptionsAction) {
                    var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                    cleanupModifierEffects();
                    state.options = Object.assign({}, defaultOptions, state.options, options);
                    state.scrollParents = {
                        reference: (0, (0, parcelRequire("gmkfg")).isElement)(reference) ? (0, (0, parcelRequire("2r6BH")).default)(reference) : reference.contextElement ? (0, (0, parcelRequire("2r6BH")).default)(reference.contextElement) : [],
                        popper: (0, (0, parcelRequire("2r6BH")).default)(popper)
                    };
                    var orderedModifiers = (0, (0, parcelRequire("kcmIg")).default)((0, (0, parcelRequire("i9xH7")).default)([].concat(defaultModifiers, state.options.modifiers)));
                    state.orderedModifiers = orderedModifiers.filter(function(m) {
                        return m.enabled;
                    });
                    runModifierEffects();
                    return instance.update();
                },
                forceUpdate: function forceUpdate() {
                    if (isDestroyed) return;
                    var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper;
                    if (!$9cbfd7bdb6a4f3f1$var$areValidElements(reference, popper)) return;
                    state.rects = {
                        reference: (0, (0, parcelRequire("gvlia")).default)(reference, (0, (0, parcelRequire("gbHJy")).default)(popper), state.options.strategy === 'fixed'),
                        popper: (0, (0, parcelRequire("jkGDj")).default)(popper)
                    };
                    state.reset = false;
                    state.placement = state.options.placement;
                    state.orderedModifiers.forEach(function(modifier) {
                        return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                    });
                    for(var index = 0; index < state.orderedModifiers.length; index++){
                        if (state.reset === true) {
                            state.reset = false;
                            index = -1;
                            continue;
                        }
                        var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                        if (typeof fn === 'function') state = fn({
                            state: state,
                            options: _options,
                            name: name,
                            instance: instance
                        }) || state;
                    }
                },
                update: (0, (0, parcelRequire("a8clb")).default)(function() {
                    return new Promise(function(resolve) {
                        instance.forceUpdate();
                        resolve(state);
                    });
                }),
                destroy: function destroy() {
                    cleanupModifierEffects();
                    isDestroyed = true;
                }
            };
            if (!$9cbfd7bdb6a4f3f1$var$areValidElements(reference, popper)) return instance;
            instance.setOptions(options).then(function(state) {
                if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
            });
            function runModifierEffects() {
                state.orderedModifiers.forEach(function(_ref) {
                    var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                    if (typeof effect === 'function') {
                        var cleanupFn = effect({
                            state: state,
                            name: name,
                            instance: instance,
                            options: options
                        });
                        var noopFn = function noopFn() {};
                        effectCleanupFns.push(cleanupFn || noopFn);
                    }
                });
            }
            function cleanupModifierEffects() {
                effectCleanupFns.forEach(function(fn) {
                    return fn();
                });
                effectCleanupFns = [];
            }
            return instance;
        };
    }
    var $9cbfd7bdb6a4f3f1$export$8f7491d57c8f97a9 = $9cbfd7bdb6a4f3f1$export$ed5e13716264f202();
});
parcelRegister("gvlia", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c0400ebb908e52cb$export$2e2bcd8739ae039);
    var $g2O7Z;
    var $9FFjG;
    var $f5IBt;
    var $gmkfg;
    var $imzt5;
    var $eVELE;
    var $c6EdA;
    var $90xPK;
    function $c0400ebb908e52cb$var$isElementScaled(element) {
        var rect = element.getBoundingClientRect();
        var scaleX = (0, (0, parcelRequire("90xPK")).round)(rect.width) / element.offsetWidth || 1;
        var scaleY = (0, (0, parcelRequire("90xPK")).round)(rect.height) / element.offsetHeight || 1;
        return scaleX !== 1 || scaleY !== 1;
    }
    function $c0400ebb908e52cb$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
        if (isFixed === void 0) isFixed = false;
        var isOffsetParentAnElement = (0, (0, parcelRequire("gmkfg")).isHTMLElement)(offsetParent);
        var offsetParentIsScaled = (0, (0, parcelRequire("gmkfg")).isHTMLElement)(offsetParent) && $c0400ebb908e52cb$var$isElementScaled(offsetParent);
        var documentElement = (0, (0, parcelRequire("eVELE")).default)(offsetParent);
        var rect = (0, (0, parcelRequire("g2O7Z")).default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
        var scroll = {
            scrollLeft: 0,
            scrollTop: 0
        };
        var offsets = {
            x: 0,
            y: 0
        };
        if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
            if ((0, (0, parcelRequire("f5IBt")).default)(offsetParent) !== 'body' || (0, (0, parcelRequire("c6EdA")).default)(documentElement)) scroll = (0, (0, parcelRequire("9FFjG")).default)(offsetParent);
            if ((0, (0, parcelRequire("gmkfg")).isHTMLElement)(offsetParent)) {
                offsets = (0, (0, parcelRequire("g2O7Z")).default)(offsetParent, true);
                offsets.x += offsetParent.clientLeft;
                offsets.y += offsetParent.clientTop;
            } else if (documentElement) offsets.x = (0, (0, parcelRequire("imzt5")).default)(documentElement);
        }
        return {
            x: rect.left + scroll.scrollLeft - offsets.x,
            y: rect.top + scroll.scrollTop - offsets.y,
            width: rect.width,
            height: rect.height
        };
    }
});
parcelRegister("g2O7Z", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bae3b796a534b2cf$export$2e2bcd8739ae039);
    var $gmkfg;
    var $90xPK;
    var $1Prpe;
    var $d8bsQ;
    function $bae3b796a534b2cf$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
        if (includeScale === void 0) includeScale = false;
        if (isFixedStrategy === void 0) isFixedStrategy = false;
        var clientRect = element.getBoundingClientRect();
        var scaleX = 1;
        var scaleY = 1;
        if (includeScale && (0, (0, parcelRequire("gmkfg")).isHTMLElement)(element)) {
            scaleX = element.offsetWidth > 0 ? (0, (0, parcelRequire("90xPK")).round)(clientRect.width) / element.offsetWidth || 1 : 1;
            scaleY = element.offsetHeight > 0 ? (0, (0, parcelRequire("90xPK")).round)(clientRect.height) / element.offsetHeight || 1 : 1;
        }
        var _ref = (0, (0, parcelRequire("gmkfg")).isElement)(element) ? (0, (0, parcelRequire("1Prpe")).default)(element) : window, visualViewport = _ref.visualViewport;
        var addVisualOffsets = !(0, (0, parcelRequire("d8bsQ")).default)() && isFixedStrategy;
        var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
        var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
        var width = clientRect.width / scaleX;
        var height = clientRect.height / scaleY;
        return {
            width: width,
            height: height,
            top: y,
            right: x + width,
            bottom: y + height,
            left: x,
            x: x,
            y: y
        };
    }
});
parcelRegister("gmkfg", function(module, exports) {
    $parcel$export(module.exports, "isElement", ()=>$be8e67adfa808002$export$45a5e7f76e0caa8d);
    $parcel$export(module.exports, "isHTMLElement", ()=>$be8e67adfa808002$export$1b3bfaa9684536aa);
    $parcel$export(module.exports, "isShadowRoot", ()=>$be8e67adfa808002$export$af51f0f06c0f328a);
    var $1Prpe;
    function $be8e67adfa808002$export$45a5e7f76e0caa8d(node) {
        var OwnElement = (0, (0, parcelRequire("1Prpe")).default)(node).Element;
        return node instanceof OwnElement || node instanceof Element;
    }
    function $be8e67adfa808002$export$1b3bfaa9684536aa(node) {
        var OwnElement = (0, (0, parcelRequire("1Prpe")).default)(node).HTMLElement;
        return node instanceof OwnElement || node instanceof HTMLElement;
    }
    function $be8e67adfa808002$export$af51f0f06c0f328a(node) {
        if (typeof ShadowRoot === 'undefined') return false;
        var OwnElement = (0, (0, parcelRequire("1Prpe")).default)(node).ShadowRoot;
        return node instanceof OwnElement || node instanceof ShadowRoot;
    }
});
parcelRegister("1Prpe", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$154fd01b154b825f$export$2e2bcd8739ae039);
    function $154fd01b154b825f$export$2e2bcd8739ae039(node) {
        if (node == null) return window;
        if (node.toString() !== '[object Window]') {
            var ownerDocument = node.ownerDocument;
            return ownerDocument ? ownerDocument.defaultView || window : window;
        }
        return node;
    }
});
parcelRegister("90xPK", function(module, exports) {
    $parcel$export(module.exports, "max", ()=>$68ee5bce69e9df7e$export$8960430cfd85939f);
    $parcel$export(module.exports, "min", ()=>$68ee5bce69e9df7e$export$96ec731ed4dcb222);
    $parcel$export(module.exports, "round", ()=>$68ee5bce69e9df7e$export$2077e0241d6afd3c);
    var $68ee5bce69e9df7e$export$8960430cfd85939f = Math.max;
    var $68ee5bce69e9df7e$export$96ec731ed4dcb222 = Math.min;
    var $68ee5bce69e9df7e$export$2077e0241d6afd3c = Math.round;
});
parcelRegister("d8bsQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$98f4ea48bb7f7060$export$2e2bcd8739ae039);
    var $j5Xhq;
    function $98f4ea48bb7f7060$export$2e2bcd8739ae039() {
        return !/^((?!chrome|android).)*safari/i.test((0, (0, parcelRequire("j5Xhq")).default)());
    }
});
parcelRegister("j5Xhq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$de6c77c242bcf4cf$export$2e2bcd8739ae039);
    function $de6c77c242bcf4cf$export$2e2bcd8739ae039() {
        var uaData = navigator.userAgentData;
        if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
            return item.brand + "/" + item.version;
        }).join(' ');
        return navigator.userAgent;
    }
});
parcelRegister("9FFjG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$70a7fdf85bb2e8b8$export$2e2bcd8739ae039);
    var $8YTLN;
    var $1Prpe;
    var $gmkfg;
    var $i1ad3;
    function $70a7fdf85bb2e8b8$export$2e2bcd8739ae039(node) {
        if (node === (0, (0, parcelRequire("1Prpe")).default)(node) || !(0, (0, parcelRequire("gmkfg")).isHTMLElement)(node)) return (0, (0, parcelRequire("8YTLN")).default)(node);
        else return (0, (0, parcelRequire("i1ad3")).default)(node);
    }
});
parcelRegister("8YTLN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$689f300ec0defb42$export$2e2bcd8739ae039);
    var $1Prpe;
    function $689f300ec0defb42$export$2e2bcd8739ae039(node) {
        var win = (0, (0, parcelRequire("1Prpe")).default)(node);
        var scrollLeft = win.pageXOffset;
        var scrollTop = win.pageYOffset;
        return {
            scrollLeft: scrollLeft,
            scrollTop: scrollTop
        };
    }
});
parcelRegister("i1ad3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d1e03d69dfb9832f$export$2e2bcd8739ae039);
    function $d1e03d69dfb9832f$export$2e2bcd8739ae039(element) {
        return {
            scrollLeft: element.scrollLeft,
            scrollTop: element.scrollTop
        };
    }
});
parcelRegister("f5IBt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$afc9ebf0aa1487e4$export$2e2bcd8739ae039);
    function $afc9ebf0aa1487e4$export$2e2bcd8739ae039(element) {
        return element ? (element.nodeName || '').toLowerCase() : null;
    }
});
parcelRegister("imzt5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d5e5cb506db8cdcb$export$2e2bcd8739ae039);
    var $g2O7Z;
    var $eVELE;
    var $8YTLN;
    function $d5e5cb506db8cdcb$export$2e2bcd8739ae039(element) {
        return (0, (0, parcelRequire("g2O7Z")).default)((0, (0, parcelRequire("eVELE")).default)(element)).left + (0, (0, parcelRequire("8YTLN")).default)(element).scrollLeft;
    }
});
parcelRegister("eVELE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ade6032ba4b824fe$export$2e2bcd8739ae039);
    var $gmkfg;
    function $ade6032ba4b824fe$export$2e2bcd8739ae039(element) {
        return (((0, (0, parcelRequire("gmkfg")).isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
    }
});
parcelRegister("c6EdA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8d053e13cecc73ee$export$2e2bcd8739ae039);
    var $1ix2F;
    function $8d053e13cecc73ee$export$2e2bcd8739ae039(element) {
        var _getComputedStyle = (0, (0, parcelRequire("1ix2F")).default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
        return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
    }
});
parcelRegister("1ix2F", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0f211a5db2cb1d1b$export$2e2bcd8739ae039);
    var $1Prpe;
    function $0f211a5db2cb1d1b$export$2e2bcd8739ae039(element) {
        return (0, (0, parcelRequire("1Prpe")).default)(element).getComputedStyle(element);
    }
});
parcelRegister("jkGDj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e130f49f6e9ebcb4$export$2e2bcd8739ae039);
    var $g2O7Z;
    function $e130f49f6e9ebcb4$export$2e2bcd8739ae039(element) {
        var clientRect = (0, (0, parcelRequire("g2O7Z")).default)(element);
        var width = element.offsetWidth;
        var height = element.offsetHeight;
        if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
        if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
        return {
            x: element.offsetLeft,
            y: element.offsetTop,
            width: width,
            height: height
        };
    }
});
parcelRegister("2r6BH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1c633a6ac170841a$export$2e2bcd8739ae039);
    var $k82dT;
    var $eTUzl;
    var $1Prpe;
    var $c6EdA;
    function $1c633a6ac170841a$export$2e2bcd8739ae039(element, list) {
        var _element$ownerDocumen;
        if (list === void 0) list = [];
        var scrollParent = (0, (0, parcelRequire("k82dT")).default)(element);
        var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
        var win = (0, (0, parcelRequire("1Prpe")).default)(scrollParent);
        var target = isBody ? [
            win
        ].concat(win.visualViewport || [], (0, (0, parcelRequire("c6EdA")).default)(scrollParent) ? scrollParent : []) : scrollParent;
        var updatedList = list.concat(target);
        return isBody ? updatedList : updatedList.concat($1c633a6ac170841a$export$2e2bcd8739ae039((0, (0, parcelRequire("eTUzl")).default)(target)));
    }
});
parcelRegister("k82dT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ea7647704a508683$export$2e2bcd8739ae039);
    var $eTUzl;
    var $c6EdA;
    var $f5IBt;
    var $gmkfg;
    function $ea7647704a508683$export$2e2bcd8739ae039(node) {
        if ([
            'html',
            'body',
            '#document'
        ].indexOf((0, (0, parcelRequire("f5IBt")).default)(node)) >= 0) return node.ownerDocument.body;
        if ((0, (0, parcelRequire("gmkfg")).isHTMLElement)(node) && (0, (0, parcelRequire("c6EdA")).default)(node)) return node;
        return $ea7647704a508683$export$2e2bcd8739ae039((0, (0, parcelRequire("eTUzl")).default)(node));
    }
});
parcelRegister("eTUzl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ad921528f26834dd$export$2e2bcd8739ae039);
    var $f5IBt;
    var $eVELE;
    var $gmkfg;
    function $ad921528f26834dd$export$2e2bcd8739ae039(element) {
        if ((0, (0, parcelRequire("f5IBt")).default)(element) === 'html') return element;
        return (element.assignedSlot || element.parentNode || ((0, (0, parcelRequire("gmkfg")).isShadowRoot)(element) ? element.host : null) || (0, (0, parcelRequire("eVELE")).default)(element));
    }
});
parcelRegister("gbHJy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bc8f9908a1e4106f$export$2e2bcd8739ae039);
    var $1Prpe;
    var $f5IBt;
    var $1ix2F;
    var $gmkfg;
    var $6hs9X;
    var $eTUzl;
    var $j5Xhq;
    function $bc8f9908a1e4106f$var$getTrueOffsetParent(element) {
        if (!(0, (0, parcelRequire("gmkfg")).isHTMLElement)(element) || (0, (0, parcelRequire("1ix2F")).default)(element).position === 'fixed') return null;
        return element.offsetParent;
    }
    function $bc8f9908a1e4106f$var$getContainingBlock(element) {
        var isFirefox = /firefox/i.test((0, (0, parcelRequire("j5Xhq")).default)());
        var isIE = /Trident/i.test((0, (0, parcelRequire("j5Xhq")).default)());
        if (isIE && (0, (0, parcelRequire("gmkfg")).isHTMLElement)(element)) {
            var elementCss = (0, (0, parcelRequire("1ix2F")).default)(element);
            if (elementCss.position === 'fixed') return null;
        }
        var currentNode = (0, (0, parcelRequire("eTUzl")).default)(element);
        if ((0, (0, parcelRequire("gmkfg")).isShadowRoot)(currentNode)) currentNode = currentNode.host;
        while((0, (0, parcelRequire("gmkfg")).isHTMLElement)(currentNode) && [
            'html',
            'body'
        ].indexOf((0, (0, parcelRequire("f5IBt")).default)(currentNode)) < 0){
            var css = (0, (0, parcelRequire("1ix2F")).default)(currentNode);
            if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
                'transform',
                'perspective'
            ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
            else currentNode = currentNode.parentNode;
        }
        return null;
    }
    function $bc8f9908a1e4106f$export$2e2bcd8739ae039(element) {
        var window = (0, (0, parcelRequire("1Prpe")).default)(element);
        var offsetParent = $bc8f9908a1e4106f$var$getTrueOffsetParent(element);
        while(offsetParent && (0, (0, parcelRequire("6hs9X")).default)(offsetParent) && (0, (0, parcelRequire("1ix2F")).default)(offsetParent).position === 'static')offsetParent = $bc8f9908a1e4106f$var$getTrueOffsetParent(offsetParent);
        if (offsetParent && ((0, (0, parcelRequire("f5IBt")).default)(offsetParent) === 'html' || (0, (0, parcelRequire("f5IBt")).default)(offsetParent) === 'body' && (0, (0, parcelRequire("1ix2F")).default)(offsetParent).position === 'static')) return window;
        return offsetParent || $bc8f9908a1e4106f$var$getContainingBlock(element) || window;
    }
});
parcelRegister("6hs9X", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$492a2c861940c94d$export$2e2bcd8739ae039);
    var $f5IBt;
    function $492a2c861940c94d$export$2e2bcd8739ae039(element) {
        return [
            'table',
            'td',
            'th'
        ].indexOf((0, (0, parcelRequire("f5IBt")).default)(element)) >= 0;
    }
});
parcelRegister("kcmIg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$eb468bf0752088cc$export$2e2bcd8739ae039);
    var $kJPed;
    function $eb468bf0752088cc$var$order(modifiers) {
        var map = new Map();
        var visited = new Set();
        var result = [];
        modifiers.forEach(function(modifier) {
            map.set(modifier.name, modifier);
        });
        function sort(modifier) {
            visited.add(modifier.name);
            var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
            requires.forEach(function(dep) {
                if (!visited.has(dep)) {
                    var depModifier = map.get(dep);
                    if (depModifier) sort(depModifier);
                }
            });
            result.push(modifier);
        }
        modifiers.forEach(function(modifier) {
            if (!visited.has(modifier.name)) sort(modifier);
        });
        return result;
    }
    function $eb468bf0752088cc$export$2e2bcd8739ae039(modifiers) {
        var orderedModifiers = $eb468bf0752088cc$var$order(modifiers);
        return (0, (0, parcelRequire("kJPed")).modifierPhases).reduce(function(acc, phase) {
            return acc.concat(orderedModifiers.filter(function(modifier) {
                return modifier.phase === phase;
            }));
        }, []);
    }
});
parcelRegister("kJPed", function(module, exports) {
    $parcel$export(module.exports, "top", ()=>$f18fbf7b212a7c8e$export$1e95b668f3b82d);
    $parcel$export(module.exports, "bottom", ()=>$f18fbf7b212a7c8e$export$40e543e69a8b3fbb);
    $parcel$export(module.exports, "right", ()=>$f18fbf7b212a7c8e$export$79ffe56a765070d2);
    $parcel$export(module.exports, "left", ()=>$f18fbf7b212a7c8e$export$eabcd2c8791e7bf4);
    $parcel$export(module.exports, "auto", ()=>$f18fbf7b212a7c8e$export$dfb5619354ba860);
    $parcel$export(module.exports, "basePlacements", ()=>$f18fbf7b212a7c8e$export$aec2ce47c367b8c3);
    $parcel$export(module.exports, "start", ()=>$f18fbf7b212a7c8e$export$b3571188c770cc5a);
    $parcel$export(module.exports, "end", ()=>$f18fbf7b212a7c8e$export$bd5df0f255a350f8);
    $parcel$export(module.exports, "clippingParents", ()=>$f18fbf7b212a7c8e$export$390fd549c5303b4d);
    $parcel$export(module.exports, "viewport", ()=>$f18fbf7b212a7c8e$export$d7b7311ec04a3e8f);
    $parcel$export(module.exports, "popper", ()=>$f18fbf7b212a7c8e$export$ae5ab1c730825774);
    $parcel$export(module.exports, "reference", ()=>$f18fbf7b212a7c8e$export$ca50aac9f3ba507f);
    $parcel$export(module.exports, "variationPlacements", ()=>$f18fbf7b212a7c8e$export$368f9a87e87fa4e1);
    $parcel$export(module.exports, "placements", ()=>$f18fbf7b212a7c8e$export$803cd8101b6c182b);
    $parcel$export(module.exports, "modifierPhases", ()=>$f18fbf7b212a7c8e$export$d087d3878fdf71d5);
    var $f18fbf7b212a7c8e$export$1e95b668f3b82d = 'top';
    var $f18fbf7b212a7c8e$export$40e543e69a8b3fbb = 'bottom';
    var $f18fbf7b212a7c8e$export$79ffe56a765070d2 = 'right';
    var $f18fbf7b212a7c8e$export$eabcd2c8791e7bf4 = 'left';
    var $f18fbf7b212a7c8e$export$dfb5619354ba860 = 'auto';
    var $f18fbf7b212a7c8e$export$aec2ce47c367b8c3 = [
        $f18fbf7b212a7c8e$export$1e95b668f3b82d,
        $f18fbf7b212a7c8e$export$40e543e69a8b3fbb,
        $f18fbf7b212a7c8e$export$79ffe56a765070d2,
        $f18fbf7b212a7c8e$export$eabcd2c8791e7bf4
    ];
    var $f18fbf7b212a7c8e$export$b3571188c770cc5a = 'start';
    var $f18fbf7b212a7c8e$export$bd5df0f255a350f8 = 'end';
    var $f18fbf7b212a7c8e$export$390fd549c5303b4d = 'clippingParents';
    var $f18fbf7b212a7c8e$export$d7b7311ec04a3e8f = 'viewport';
    var $f18fbf7b212a7c8e$export$ae5ab1c730825774 = 'popper';
    var $f18fbf7b212a7c8e$export$ca50aac9f3ba507f = 'reference';
    var $f18fbf7b212a7c8e$export$368f9a87e87fa4e1 = $f18fbf7b212a7c8e$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
        return acc.concat([
            placement + "-" + $f18fbf7b212a7c8e$export$b3571188c770cc5a,
            placement + "-" + $f18fbf7b212a7c8e$export$bd5df0f255a350f8
        ]);
    }, []);
    var $f18fbf7b212a7c8e$export$803cd8101b6c182b = [].concat($f18fbf7b212a7c8e$export$aec2ce47c367b8c3, [
        $f18fbf7b212a7c8e$export$dfb5619354ba860
    ]).reduce(function(acc, placement) {
        return acc.concat([
            placement,
            placement + "-" + $f18fbf7b212a7c8e$export$b3571188c770cc5a,
            placement + "-" + $f18fbf7b212a7c8e$export$bd5df0f255a350f8
        ]);
    }, []);
    var $f18fbf7b212a7c8e$export$421679a7c3d56e = 'beforeRead';
    var $f18fbf7b212a7c8e$export$aafa59e2e03f2942 = 'read';
    var $f18fbf7b212a7c8e$export$6964f6c886723980 = 'afterRead';
    var $f18fbf7b212a7c8e$export$c65e99957a05207c = 'beforeMain';
    var $f18fbf7b212a7c8e$export$f22da7240b7add18 = 'main';
    var $f18fbf7b212a7c8e$export$bab79516f2d662fe = 'afterMain';
    var $f18fbf7b212a7c8e$export$8d4d2d70e7d46032 = 'beforeWrite';
    var $f18fbf7b212a7c8e$export$68d8715fc104d294 = 'write';
    var $f18fbf7b212a7c8e$export$70a6e5159acce2e6 = 'afterWrite';
    var $f18fbf7b212a7c8e$export$d087d3878fdf71d5 = [
        $f18fbf7b212a7c8e$export$421679a7c3d56e,
        $f18fbf7b212a7c8e$export$aafa59e2e03f2942,
        $f18fbf7b212a7c8e$export$6964f6c886723980,
        $f18fbf7b212a7c8e$export$c65e99957a05207c,
        $f18fbf7b212a7c8e$export$f22da7240b7add18,
        $f18fbf7b212a7c8e$export$bab79516f2d662fe,
        $f18fbf7b212a7c8e$export$8d4d2d70e7d46032,
        $f18fbf7b212a7c8e$export$68d8715fc104d294,
        $f18fbf7b212a7c8e$export$70a6e5159acce2e6
    ];
});
parcelRegister("a8clb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7604395822cc5d61$export$2e2bcd8739ae039);
    function $7604395822cc5d61$export$2e2bcd8739ae039(fn) {
        var pending;
        return function() {
            if (!pending) pending = new Promise(function(resolve) {
                Promise.resolve().then(function() {
                    pending = undefined;
                    resolve(fn());
                });
            });
            return pending;
        };
    }
});
parcelRegister("i9xH7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d3733441fcf2e882$export$2e2bcd8739ae039);
    function $d3733441fcf2e882$export$2e2bcd8739ae039(modifiers) {
        var merged = modifiers.reduce(function(merged, current) {
            var existing = merged[current.name];
            merged[current.name] = existing ? Object.assign({}, existing, current, {
                options: Object.assign({}, existing.options, current.options),
                data: Object.assign({}, existing.data, current.data)
            }) : current;
            return merged;
        }, {});
        return Object.keys(merged).map(function(key) {
            return merged[key];
        });
    }
});
parcelRegister("4TVC8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3918fd6b815bcf57$export$2e2bcd8739ae039);
    var $1Prpe;
    var $3918fd6b815bcf57$var$passive = {
        passive: true
    };
    function $3918fd6b815bcf57$var$effect(_ref) {
        var state = _ref.state, instance = _ref.instance, options = _ref.options;
        var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
        var window = (0, (0, parcelRequire("1Prpe")).default)(state.elements.popper);
        var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.addEventListener('scroll', instance.update, $3918fd6b815bcf57$var$passive);
        });
        if (resize) window.addEventListener('resize', instance.update, $3918fd6b815bcf57$var$passive);
        return function() {
            if (scroll) scrollParents.forEach(function(scrollParent) {
                scrollParent.removeEventListener('scroll', instance.update, $3918fd6b815bcf57$var$passive);
            });
            if (resize) window.removeEventListener('resize', instance.update, $3918fd6b815bcf57$var$passive);
        };
    }
    var $3918fd6b815bcf57$export$2e2bcd8739ae039 = {
        name: 'eventListeners',
        enabled: true,
        phase: 'write',
        fn: function fn() {},
        effect: $3918fd6b815bcf57$var$effect,
        data: {}
    };
});
parcelRegister("j8nKB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dee1300a39219bb5$export$2e2bcd8739ae039);
    var $dJ0Jl;
    function $dee1300a39219bb5$var$popperOffsets(_ref) {
        var state = _ref.state, name = _ref.name;
        state.modifiersData[name] = (0, (0, parcelRequire("dJ0Jl")).default)({
            reference: state.rects.reference,
            element: state.rects.popper,
            strategy: 'absolute',
            placement: state.placement
        });
    }
    var $dee1300a39219bb5$export$2e2bcd8739ae039 = {
        name: 'popperOffsets',
        enabled: true,
        phase: 'read',
        fn: $dee1300a39219bb5$var$popperOffsets,
        data: {}
    };
});
parcelRegister("dJ0Jl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9fe00b5c334118ac$export$2e2bcd8739ae039);
    var $QXpw1;
    var $cGRJ4;
    var $9GF9F;
    var $kJPed;
    function $9fe00b5c334118ac$export$2e2bcd8739ae039(_ref) {
        var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
        var basePlacement = placement ? (0, (0, parcelRequire("QXpw1")).default)(placement) : null;
        var variation = placement ? (0, (0, parcelRequire("cGRJ4")).default)(placement) : null;
        var commonX = reference.x + reference.width / 2 - element.width / 2;
        var commonY = reference.y + reference.height / 2 - element.height / 2;
        var offsets;
        switch(basePlacement){
            case 0, (0, parcelRequire("kJPed")).top:
                offsets = {
                    x: commonX,
                    y: reference.y - element.height
                };
                break;
            case 0, (0, parcelRequire("kJPed")).bottom:
                offsets = {
                    x: commonX,
                    y: reference.y + reference.height
                };
                break;
            case 0, (0, parcelRequire("kJPed")).right:
                offsets = {
                    x: reference.x + reference.width,
                    y: commonY
                };
                break;
            case 0, (0, parcelRequire("kJPed")).left:
                offsets = {
                    x: reference.x - element.width,
                    y: commonY
                };
                break;
            default:
                offsets = {
                    x: reference.x,
                    y: reference.y
                };
        }
        var mainAxis = basePlacement ? (0, (0, parcelRequire("9GF9F")).default)(basePlacement) : null;
        if (mainAxis != null) {
            var len = mainAxis === 'y' ? 'height' : 'width';
            switch(variation){
                case 0, (0, parcelRequire("kJPed")).start:
                    offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                    break;
                case 0, (0, parcelRequire("kJPed")).end:
                    offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                    break;
                default:
            }
        }
        return offsets;
    }
});
parcelRegister("QXpw1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$09f2f123ac4a9fdf$export$2e2bcd8739ae039);
    function $09f2f123ac4a9fdf$export$2e2bcd8739ae039(placement) {
        return placement.split('-')[0];
    }
});
parcelRegister("cGRJ4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$93d315208040ceed$export$2e2bcd8739ae039);
    function $93d315208040ceed$export$2e2bcd8739ae039(placement) {
        return placement.split('-')[1];
    }
});
parcelRegister("9GF9F", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$70d7f5cda4210aa3$export$2e2bcd8739ae039);
    function $70d7f5cda4210aa3$export$2e2bcd8739ae039(placement) {
        return [
            'top',
            'bottom'
        ].indexOf(placement) >= 0 ? 'x' : 'y';
    }
});
parcelRegister("baic6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$820ebddbe0682e4f$export$2e2bcd8739ae039);
    var $kJPed;
    var $gbHJy;
    var $1Prpe;
    var $eVELE;
    var $1ix2F;
    var $QXpw1;
    var $cGRJ4;
    var $90xPK;
    var $820ebddbe0682e4f$var$unsetSides = {
        top: 'auto',
        right: 'auto',
        bottom: 'auto',
        left: 'auto'
    };
    function $820ebddbe0682e4f$var$roundOffsetsByDPR(_ref, win) {
        var x = _ref.x, y = _ref.y;
        var dpr = win.devicePixelRatio || 1;
        return {
            x: (0, (0, parcelRequire("90xPK")).round)(x * dpr) / dpr || 0,
            y: (0, (0, parcelRequire("90xPK")).round)(y * dpr) / dpr || 0
        };
    }
    function $820ebddbe0682e4f$export$378fa78a8fea596f(_ref2) {
        var _Object$assign2;
        var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
        var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
        var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
            x: x,
            y: y
        }) : {
            x: x,
            y: y
        };
        x = _ref3.x;
        y = _ref3.y;
        var hasX = offsets.hasOwnProperty('x');
        var hasY = offsets.hasOwnProperty('y');
        var sideX = (0, (0, parcelRequire("kJPed")).left);
        var sideY = (0, (0, parcelRequire("kJPed")).top);
        var win = window;
        if (adaptive) {
            var offsetParent = (0, (0, parcelRequire("gbHJy")).default)(popper);
            var heightProp = 'clientHeight';
            var widthProp = 'clientWidth';
            if (offsetParent === (0, (0, parcelRequire("1Prpe")).default)(popper)) {
                offsetParent = (0, (0, parcelRequire("eVELE")).default)(popper);
                if ((0, (0, parcelRequire("1ix2F")).default)(offsetParent).position !== 'static' && position === 'absolute') {
                    heightProp = 'scrollHeight';
                    widthProp = 'scrollWidth';
                }
            }
            offsetParent;
            if (placement === (0, (0, parcelRequire("kJPed")).top) || (placement === (0, (0, parcelRequire("kJPed")).left) || placement === (0, (0, parcelRequire("kJPed")).right)) && variation === (0, (0, parcelRequire("kJPed")).end)) {
                sideY = (0, (0, parcelRequire("kJPed")).bottom);
                var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
                y -= offsetY - popperRect.height;
                y *= gpuAcceleration ? 1 : -1;
            }
            if (placement === (0, (0, parcelRequire("kJPed")).left) || (placement === (0, (0, parcelRequire("kJPed")).top) || placement === (0, (0, parcelRequire("kJPed")).bottom)) && variation === (0, (0, parcelRequire("kJPed")).end)) {
                sideX = (0, (0, parcelRequire("kJPed")).right);
                var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
                x -= offsetX - popperRect.width;
                x *= gpuAcceleration ? 1 : -1;
            }
        }
        var commonStyles = Object.assign({
            position: position
        }, adaptive && $820ebddbe0682e4f$var$unsetSides);
        var _ref4 = roundOffsets === true ? $820ebddbe0682e4f$var$roundOffsetsByDPR({
            x: x,
            y: y
        }, (0, (0, parcelRequire("1Prpe")).default)(popper)) : {
            x: x,
            y: y
        };
        x = _ref4.x;
        y = _ref4.y;
        if (gpuAcceleration) {
            var _Object$assign;
            return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
        }
        return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
    }
    function $820ebddbe0682e4f$var$computeStyles(_ref5) {
        var state = _ref5.state, options = _ref5.options;
        var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
        var commonStyles = {
            placement: (0, (0, parcelRequire("QXpw1")).default)(state.placement),
            variation: (0, (0, parcelRequire("cGRJ4")).default)(state.placement),
            popper: state.elements.popper,
            popperRect: state.rects.popper,
            gpuAcceleration: gpuAcceleration,
            isFixed: state.options.strategy === 'fixed'
        };
        if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $820ebddbe0682e4f$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
            offsets: state.modifiersData.popperOffsets,
            position: state.options.strategy,
            adaptive: adaptive,
            roundOffsets: roundOffsets
        })));
        if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $820ebddbe0682e4f$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
            offsets: state.modifiersData.arrow,
            position: 'absolute',
            adaptive: false,
            roundOffsets: roundOffsets
        })));
        state.attributes.popper = Object.assign({}, state.attributes.popper, {
            'data-popper-placement': state.placement
        });
    }
    var $820ebddbe0682e4f$export$2e2bcd8739ae039 = {
        name: 'computeStyles',
        enabled: true,
        phase: 'beforeWrite',
        fn: $820ebddbe0682e4f$var$computeStyles,
        data: {}
    };
});
parcelRegister("1AoLg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$127c5c56b9511f5f$export$2e2bcd8739ae039);
    var $f5IBt;
    var $gmkfg;
    function $127c5c56b9511f5f$var$applyStyles(_ref) {
        var state = _ref.state;
        Object.keys(state.elements).forEach(function(name) {
            var style = state.styles[name] || {};
            var attributes = state.attributes[name] || {};
            var element = state.elements[name];
            if (!(0, (0, parcelRequire("gmkfg")).isHTMLElement)(element) || !(0, (0, parcelRequire("f5IBt")).default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(name) {
                var value = attributes[name];
                if (value === false) element.removeAttribute(name);
                else element.setAttribute(name, value === true ? '' : value);
            });
        });
    }
    function $127c5c56b9511f5f$var$effect(_ref2) {
        var state = _ref2.state;
        var initialStyles = {
            popper: {
                position: state.options.strategy,
                left: '0',
                top: '0',
                margin: '0'
            },
            arrow: {
                position: 'absolute'
            },
            reference: {}
        };
        Object.assign(state.elements.popper.style, initialStyles.popper);
        state.styles = initialStyles;
        if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
        return function() {
            Object.keys(state.elements).forEach(function(name) {
                var element = state.elements[name];
                var attributes = state.attributes[name] || {};
                var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]);
                var style = styleProperties.reduce(function(style, property) {
                    style[property] = '';
                    return style;
                }, {});
                if (!(0, (0, parcelRequire("gmkfg")).isHTMLElement)(element) || !(0, (0, parcelRequire("f5IBt")).default)(element)) return;
                Object.assign(element.style, style);
                Object.keys(attributes).forEach(function(attribute) {
                    element.removeAttribute(attribute);
                });
            });
        };
    }
    var $127c5c56b9511f5f$export$2e2bcd8739ae039 = {
        name: 'applyStyles',
        enabled: true,
        phase: 'write',
        fn: $127c5c56b9511f5f$var$applyStyles,
        effect: $127c5c56b9511f5f$var$effect,
        requires: [
            'computeStyles'
        ]
    };
});
parcelRegister("gy4Xr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c0c3aad300d72ee1$export$2e2bcd8739ae039);
    var $QXpw1;
    var $kJPed;
    function $c0c3aad300d72ee1$export$7fa02d8595b015ed(placement, rects, offset) {
        var basePlacement = (0, (0, parcelRequire("QXpw1")).default)(placement);
        var invertDistance = [
            (0, (0, parcelRequire("kJPed")).left),
            (0, (0, parcelRequire("kJPed")).top)
        ].indexOf(basePlacement) >= 0 ? -1 : 1;
        var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
            placement: placement
        })) : offset, skidding = _ref[0], distance = _ref[1];
        skidding = skidding || 0;
        distance = (distance || 0) * invertDistance;
        return [
            (0, (0, parcelRequire("kJPed")).left),
            (0, (0, parcelRequire("kJPed")).right)
        ].indexOf(basePlacement) >= 0 ? {
            x: distance,
            y: skidding
        } : {
            x: skidding,
            y: distance
        };
    }
    function $c0c3aad300d72ee1$var$offset(_ref2) {
        var state = _ref2.state, options = _ref2.options, name = _ref2.name;
        var _options$offset = options.offset, offset = _options$offset === void 0 ? [
            0,
            0
        ] : _options$offset;
        var data = (0, (0, parcelRequire("kJPed")).placements).reduce(function(acc, placement) {
            acc[placement] = $c0c3aad300d72ee1$export$7fa02d8595b015ed(placement, state.rects, offset);
            return acc;
        }, {});
        var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
        if (state.modifiersData.popperOffsets != null) {
            state.modifiersData.popperOffsets.x += x;
            state.modifiersData.popperOffsets.y += y;
        }
        state.modifiersData[name] = data;
    }
    var $c0c3aad300d72ee1$export$2e2bcd8739ae039 = {
        name: 'offset',
        enabled: true,
        phase: 'main',
        requires: [
            'popperOffsets'
        ],
        fn: $c0c3aad300d72ee1$var$offset
    };
});
parcelRegister("3dDWl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$258191447a7022df$export$2e2bcd8739ae039);
    var $jwSgb;
    var $QXpw1;
    var $4tIVJ;
    var $kgkit;
    var $cqF2x;
    var $kJPed;
    var $cGRJ4;
    function $258191447a7022df$var$getExpandedFallbackPlacements(placement) {
        if ((0, (0, parcelRequire("QXpw1")).default)(placement) === (0, (0, parcelRequire("kJPed")).auto)) return [];
        var oppositePlacement = (0, (0, parcelRequire("jwSgb")).default)(placement);
        return [
            (0, (0, parcelRequire("4tIVJ")).default)(placement),
            oppositePlacement,
            (0, (0, parcelRequire("4tIVJ")).default)(oppositePlacement)
        ];
    }
    function $258191447a7022df$var$flip(_ref) {
        var state = _ref.state, options = _ref.options, name = _ref.name;
        if (state.modifiersData[name]._skip) return;
        var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
        var preferredPlacement = state.options.placement;
        var basePlacement = (0, (0, parcelRequire("QXpw1")).default)(preferredPlacement);
        var isBasePlacement = basePlacement === preferredPlacement;
        var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
            (0, (0, parcelRequire("jwSgb")).default)(preferredPlacement)
        ] : $258191447a7022df$var$getExpandedFallbackPlacements(preferredPlacement));
        var placements = [
            preferredPlacement
        ].concat(fallbackPlacements).reduce(function(acc, placement) {
            return acc.concat((0, (0, parcelRequire("QXpw1")).default)(placement) === (0, (0, parcelRequire("kJPed")).auto) ? (0, (0, parcelRequire("cqF2x")).default)(state, {
                placement: placement,
                boundary: boundary,
                rootBoundary: rootBoundary,
                padding: padding,
                flipVariations: flipVariations,
                allowedAutoPlacements: allowedAutoPlacements
            }) : placement);
        }, []);
        var referenceRect = state.rects.reference;
        var popperRect = state.rects.popper;
        var checksMap = new Map();
        var makeFallbackChecks = true;
        var firstFittingPlacement = placements[0];
        for(var i = 0; i < placements.length; i++){
            var placement = placements[i];
            var _basePlacement = (0, (0, parcelRequire("QXpw1")).default)(placement);
            var isStartVariation = (0, (0, parcelRequire("cGRJ4")).default)(placement) === (0, (0, parcelRequire("kJPed")).start);
            var isVertical = [
                (0, (0, parcelRequire("kJPed")).top),
                (0, (0, parcelRequire("kJPed")).bottom)
            ].indexOf(_basePlacement) >= 0;
            var len = isVertical ? 'width' : 'height';
            var overflow = (0, (0, parcelRequire("kgkit")).default)(state, {
                placement: placement,
                boundary: boundary,
                rootBoundary: rootBoundary,
                altBoundary: altBoundary,
                padding: padding
            });
            var mainVariationSide = isVertical ? isStartVariation ? (0, (0, parcelRequire("kJPed")).right) : (0, (0, parcelRequire("kJPed")).left) : isStartVariation ? (0, (0, parcelRequire("kJPed")).bottom) : (0, (0, parcelRequire("kJPed")).top);
            if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, (0, parcelRequire("jwSgb")).default)(mainVariationSide);
            var altVariationSide = (0, (0, parcelRequire("jwSgb")).default)(mainVariationSide);
            var checks = [];
            if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
            if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
            if (checks.every(function(check) {
                return check;
            })) {
                firstFittingPlacement = placement;
                makeFallbackChecks = false;
                break;
            }
            checksMap.set(placement, checks);
        }
        if (makeFallbackChecks) {
            var numberOfChecks = flipVariations ? 3 : 1;
            var _loop = function _loop(_i) {
                var fittingPlacement = placements.find(function(placement) {
                    var checks = checksMap.get(placement);
                    if (checks) return checks.slice(0, _i).every(function(check) {
                        return check;
                    });
                });
                if (fittingPlacement) {
                    firstFittingPlacement = fittingPlacement;
                    return "break";
                }
            };
            for(var _i = numberOfChecks; _i > 0; _i--){
                var _ret = _loop(_i);
                if (_ret === "break") break;
            }
        }
        if (state.placement !== firstFittingPlacement) {
            state.modifiersData[name]._skip = true;
            state.placement = firstFittingPlacement;
            state.reset = true;
        }
    }
    var $258191447a7022df$export$2e2bcd8739ae039 = {
        name: 'flip',
        enabled: true,
        phase: 'main',
        fn: $258191447a7022df$var$flip,
        requiresIfExists: [
            'offset'
        ],
        data: {
            _skip: false
        }
    };
});
parcelRegister("jwSgb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e37b1862c86f39c4$export$2e2bcd8739ae039);
    var $e37b1862c86f39c4$var$hash = {
        left: 'right',
        right: 'left',
        bottom: 'top',
        top: 'bottom'
    };
    function $e37b1862c86f39c4$export$2e2bcd8739ae039(placement) {
        return placement.replace(/left|right|bottom|top/g, function(matched) {
            return $e37b1862c86f39c4$var$hash[matched];
        });
    }
});
parcelRegister("4tIVJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$342cb90cb2622617$export$2e2bcd8739ae039);
    var $342cb90cb2622617$var$hash = {
        start: 'end',
        end: 'start'
    };
    function $342cb90cb2622617$export$2e2bcd8739ae039(placement) {
        return placement.replace(/start|end/g, function(matched) {
            return $342cb90cb2622617$var$hash[matched];
        });
    }
});
parcelRegister("kgkit", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ec050bcf5e349283$export$2e2bcd8739ae039);
    var $dknpr;
    var $eVELE;
    var $g2O7Z;
    var $dJ0Jl;
    var $h8W1z;
    var $kJPed;
    var $gmkfg;
    var $gIXWB;
    var $50KfK;
    function $ec050bcf5e349283$export$2e2bcd8739ae039(state, options) {
        if (options === void 0) options = {};
        var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, (0, parcelRequire("kJPed")).clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, (0, parcelRequire("kJPed")).viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, (0, parcelRequire("kJPed")).popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
        var paddingObject = (0, (0, parcelRequire("gIXWB")).default)(typeof padding !== 'number' ? padding : (0, (0, parcelRequire("50KfK")).default)(padding, (0, (0, parcelRequire("kJPed")).basePlacements)));
        var altContext = elementContext === (0, (0, parcelRequire("kJPed")).popper) ? (0, (0, parcelRequire("kJPed")).reference) : (0, (0, parcelRequire("kJPed")).popper);
        var popperRect = state.rects.popper;
        var element = state.elements[altBoundary ? altContext : elementContext];
        var clippingClientRect = (0, (0, parcelRequire("dknpr")).default)((0, (0, parcelRequire("gmkfg")).isElement)(element) ? element : element.contextElement || (0, (0, parcelRequire("eVELE")).default)(state.elements.popper), boundary, rootBoundary, strategy);
        var referenceClientRect = (0, (0, parcelRequire("g2O7Z")).default)(state.elements.reference);
        var popperOffsets = (0, (0, parcelRequire("dJ0Jl")).default)({
            reference: referenceClientRect,
            element: popperRect,
            strategy: 'absolute',
            placement: placement
        });
        var popperClientRect = (0, (0, parcelRequire("h8W1z")).default)(Object.assign({}, popperRect, popperOffsets));
        var elementClientRect = elementContext === (0, (0, parcelRequire("kJPed")).popper) ? popperClientRect : referenceClientRect;
        var overflowOffsets = {
            top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
            bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
            left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
            right: elementClientRect.right - clippingClientRect.right + paddingObject.right
        };
        var offsetData = state.modifiersData.offset;
        if (elementContext === (0, (0, parcelRequire("kJPed")).popper) && offsetData) {
            var offset = offsetData[placement];
            Object.keys(overflowOffsets).forEach(function(key) {
                var multiply = [
                    (0, (0, parcelRequire("kJPed")).right),
                    (0, (0, parcelRequire("kJPed")).bottom)
                ].indexOf(key) >= 0 ? 1 : -1;
                var axis = [
                    (0, (0, parcelRequire("kJPed")).top),
                    (0, (0, parcelRequire("kJPed")).bottom)
                ].indexOf(key) >= 0 ? 'y' : 'x';
                overflowOffsets[key] += offset[axis] * multiply;
            });
        }
        return overflowOffsets;
    }
});
parcelRegister("dknpr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9b3f4d3932acb3b2$export$2e2bcd8739ae039);
    var $kJPed;
    var $3V2hG;
    var $9NXD7;
    var $2r6BH;
    var $gbHJy;
    var $eVELE;
    var $1ix2F;
    var $gmkfg;
    var $g2O7Z;
    var $eTUzl;
    var $j6yPg;
    var $f5IBt;
    var $h8W1z;
    var $90xPK;
    function $9b3f4d3932acb3b2$var$getInnerBoundingClientRect(element, strategy) {
        var rect = (0, (0, parcelRequire("g2O7Z")).default)(element, false, strategy === 'fixed');
        rect.top = rect.top + element.clientTop;
        rect.left = rect.left + element.clientLeft;
        rect.bottom = rect.top + element.clientHeight;
        rect.right = rect.left + element.clientWidth;
        rect.width = element.clientWidth;
        rect.height = element.clientHeight;
        rect.x = rect.left;
        rect.y = rect.top;
        return rect;
    }
    function $9b3f4d3932acb3b2$var$getClientRectFromMixedType(element, clippingParent, strategy) {
        return clippingParent === (0, (0, parcelRequire("kJPed")).viewport) ? (0, (0, parcelRequire("h8W1z")).default)((0, (0, parcelRequire("3V2hG")).default)(element, strategy)) : (0, (0, parcelRequire("gmkfg")).isElement)(clippingParent) ? $9b3f4d3932acb3b2$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, (0, parcelRequire("h8W1z")).default)((0, (0, parcelRequire("9NXD7")).default)((0, (0, parcelRequire("eVELE")).default)(element)));
    }
    function $9b3f4d3932acb3b2$var$getClippingParents(element) {
        var clippingParents = (0, (0, parcelRequire("2r6BH")).default)((0, (0, parcelRequire("eTUzl")).default)(element));
        var canEscapeClipping = [
            'absolute',
            'fixed'
        ].indexOf((0, (0, parcelRequire("1ix2F")).default)(element).position) >= 0;
        var clipperElement = canEscapeClipping && (0, (0, parcelRequire("gmkfg")).isHTMLElement)(element) ? (0, (0, parcelRequire("gbHJy")).default)(element) : element;
        if (!(0, (0, parcelRequire("gmkfg")).isElement)(clipperElement)) return [];
        return clippingParents.filter(function(clippingParent) {
            return (0, (0, parcelRequire("gmkfg")).isElement)(clippingParent) && (0, (0, parcelRequire("j6yPg")).default)(clippingParent, clipperElement) && (0, (0, parcelRequire("f5IBt")).default)(clippingParent) !== 'body';
        });
    }
    function $9b3f4d3932acb3b2$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
        var mainClippingParents = boundary === 'clippingParents' ? $9b3f4d3932acb3b2$var$getClippingParents(element) : [].concat(boundary);
        var clippingParents = [].concat(mainClippingParents, [
            rootBoundary
        ]);
        var firstClippingParent = clippingParents[0];
        var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
            var rect = $9b3f4d3932acb3b2$var$getClientRectFromMixedType(element, clippingParent, strategy);
            accRect.top = (0, (0, parcelRequire("90xPK")).max)(rect.top, accRect.top);
            accRect.right = (0, (0, parcelRequire("90xPK")).min)(rect.right, accRect.right);
            accRect.bottom = (0, (0, parcelRequire("90xPK")).min)(rect.bottom, accRect.bottom);
            accRect.left = (0, (0, parcelRequire("90xPK")).max)(rect.left, accRect.left);
            return accRect;
        }, $9b3f4d3932acb3b2$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
        clippingRect.width = clippingRect.right - clippingRect.left;
        clippingRect.height = clippingRect.bottom - clippingRect.top;
        clippingRect.x = clippingRect.left;
        clippingRect.y = clippingRect.top;
        return clippingRect;
    }
});
parcelRegister("3V2hG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2da877912142c34b$export$2e2bcd8739ae039);
    var $1Prpe;
    var $eVELE;
    var $imzt5;
    var $d8bsQ;
    function $2da877912142c34b$export$2e2bcd8739ae039(element, strategy) {
        var win = (0, (0, parcelRequire("1Prpe")).default)(element);
        var html = (0, (0, parcelRequire("eVELE")).default)(element);
        var visualViewport = win.visualViewport;
        var width = html.clientWidth;
        var height = html.clientHeight;
        var x = 0;
        var y = 0;
        if (visualViewport) {
            width = visualViewport.width;
            height = visualViewport.height;
            var layoutViewport = (0, (0, parcelRequire("d8bsQ")).default)();
            if (layoutViewport || !layoutViewport && strategy === 'fixed') {
                x = visualViewport.offsetLeft;
                y = visualViewport.offsetTop;
            }
        }
        return {
            width: width,
            height: height,
            x: x + (0, (0, parcelRequire("imzt5")).default)(element),
            y: y
        };
    }
});
parcelRegister("9NXD7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7236f1f1532b7fe8$export$2e2bcd8739ae039);
    var $eVELE;
    var $1ix2F;
    var $imzt5;
    var $8YTLN;
    var $90xPK;
    function $7236f1f1532b7fe8$export$2e2bcd8739ae039(element) {
        var _element$ownerDocumen;
        var html = (0, (0, parcelRequire("eVELE")).default)(element);
        var winScroll = (0, (0, parcelRequire("8YTLN")).default)(element);
        var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
        var width = (0, (0, parcelRequire("90xPK")).max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
        var height = (0, (0, parcelRequire("90xPK")).max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
        var x = -winScroll.scrollLeft + (0, (0, parcelRequire("imzt5")).default)(element);
        var y = -winScroll.scrollTop;
        if ((0, (0, parcelRequire("1ix2F")).default)(body || html).direction === 'rtl') x += (0, (0, parcelRequire("90xPK")).max)(html.clientWidth, body ? body.clientWidth : 0) - width;
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
});
parcelRegister("j6yPg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$de89978be23479c4$export$2e2bcd8739ae039);
    var $gmkfg;
    function $de89978be23479c4$export$2e2bcd8739ae039(parent, child) {
        var rootNode = child.getRootNode && child.getRootNode();
        if (parent.contains(child)) return true;
        else if (rootNode && (0, (0, parcelRequire("gmkfg")).isShadowRoot)(rootNode)) {
            var next = child;
            do {
                if (next && parent.isSameNode(next)) return true;
                next = next.parentNode || next.host;
            }while (next)
        }
        return false;
    }
});
parcelRegister("h8W1z", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c7b0316bb2f8fd97$export$2e2bcd8739ae039);
    function $c7b0316bb2f8fd97$export$2e2bcd8739ae039(rect) {
        return Object.assign({}, rect, {
            left: rect.x,
            top: rect.y,
            right: rect.x + rect.width,
            bottom: rect.y + rect.height
        });
    }
});
parcelRegister("gIXWB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c2cf410c4fe133f4$export$2e2bcd8739ae039);
    var $1ANH0;
    function $c2cf410c4fe133f4$export$2e2bcd8739ae039(paddingObject) {
        return Object.assign({}, (0, (0, parcelRequire("1ANH0")).default)(), paddingObject);
    }
});
parcelRegister("1ANH0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$128fb32b18b92ffa$export$2e2bcd8739ae039);
    function $128fb32b18b92ffa$export$2e2bcd8739ae039() {
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        };
    }
});
parcelRegister("50KfK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3a60d4b4ac4f93e5$export$2e2bcd8739ae039);
    function $3a60d4b4ac4f93e5$export$2e2bcd8739ae039(value, keys) {
        return keys.reduce(function(hashMap, key) {
            hashMap[key] = value;
            return hashMap;
        }, {});
    }
});
parcelRegister("cqF2x", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$90c7bf65fbdbec33$export$2e2bcd8739ae039);
    var $cGRJ4;
    var $kJPed;
    var $kgkit;
    var $QXpw1;
    function $90c7bf65fbdbec33$export$2e2bcd8739ae039(state, options) {
        if (options === void 0) options = {};
        var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, (0, parcelRequire("kJPed")).placements) : _options$allowedAutoP;
        var variation = (0, (0, parcelRequire("cGRJ4")).default)(placement);
        var placements = variation ? flipVariations ? (0, (0, parcelRequire("kJPed")).variationPlacements) : (0, (0, parcelRequire("kJPed")).variationPlacements).filter(function(placement) {
            return (0, (0, parcelRequire("cGRJ4")).default)(placement) === variation;
        }) : (0, (0, parcelRequire("kJPed")).basePlacements);
        var allowedPlacements = placements.filter(function(placement) {
            return allowedAutoPlacements.indexOf(placement) >= 0;
        });
        if (allowedPlacements.length === 0) allowedPlacements = placements;
        var overflows = allowedPlacements.reduce(function(acc, placement) {
            acc[placement] = (0, (0, parcelRequire("kgkit")).default)(state, {
                placement: placement,
                boundary: boundary,
                rootBoundary: rootBoundary,
                padding: padding
            })[(0, (0, parcelRequire("QXpw1")).default)(placement)];
            return acc;
        }, {});
        return Object.keys(overflows).sort(function(a, b) {
            return overflows[a] - overflows[b];
        });
    }
});
parcelRegister("1DdSC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$13043339457d5bc5$export$2e2bcd8739ae039);
    var $kJPed;
    var $QXpw1;
    var $9GF9F;
    var $dNtrn;
    var $4WpIh;
    var $jkGDj;
    var $gbHJy;
    var $kgkit;
    var $cGRJ4;
    var $1ANH0;
    var $90xPK;
    function $13043339457d5bc5$var$preventOverflow(_ref) {
        var state = _ref.state, options = _ref.options, name = _ref.name;
        var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
        var overflow = (0, (0, parcelRequire("kgkit")).default)(state, {
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            altBoundary: altBoundary
        });
        var basePlacement = (0, (0, parcelRequire("QXpw1")).default)(state.placement);
        var variation = (0, (0, parcelRequire("cGRJ4")).default)(state.placement);
        var isBasePlacement = !variation;
        var mainAxis = (0, (0, parcelRequire("9GF9F")).default)(basePlacement);
        var altAxis = (0, (0, parcelRequire("dNtrn")).default)(mainAxis);
        var popperOffsets = state.modifiersData.popperOffsets;
        var referenceRect = state.rects.reference;
        var popperRect = state.rects.popper;
        var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
            placement: state.placement
        })) : tetherOffset;
        var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
            mainAxis: tetherOffsetValue,
            altAxis: tetherOffsetValue
        } : Object.assign({
            mainAxis: 0,
            altAxis: 0
        }, tetherOffsetValue);
        var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
        var data = {
            x: 0,
            y: 0
        };
        if (!popperOffsets) return;
        if (checkMainAxis) {
            var _offsetModifierState$;
            var mainSide = mainAxis === 'y' ? (0, (0, parcelRequire("kJPed")).top) : (0, (0, parcelRequire("kJPed")).left);
            var altSide = mainAxis === 'y' ? (0, (0, parcelRequire("kJPed")).bottom) : (0, (0, parcelRequire("kJPed")).right);
            var len = mainAxis === 'y' ? 'height' : 'width';
            var offset = popperOffsets[mainAxis];
            var min = offset + overflow[mainSide];
            var max = offset - overflow[altSide];
            var additive = tether ? -popperRect[len] / 2 : 0;
            var minLen = variation === (0, (0, parcelRequire("kJPed")).start) ? referenceRect[len] : popperRect[len];
            var maxLen = variation === (0, (0, parcelRequire("kJPed")).start) ? -popperRect[len] : -referenceRect[len];
            var arrowElement = state.elements.arrow;
            var arrowRect = tether && arrowElement ? (0, (0, parcelRequire("jkGDj")).default)(arrowElement) : {
                width: 0,
                height: 0
            };
            var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, (0, parcelRequire("1ANH0")).default)();
            var arrowPaddingMin = arrowPaddingObject[mainSide];
            var arrowPaddingMax = arrowPaddingObject[altSide];
            var arrowLen = (0, (0, parcelRequire("4WpIh")).within)(0, referenceRect[len], arrowRect[len]);
            var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
            var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
            var arrowOffsetParent = state.elements.arrow && (0, (0, parcelRequire("gbHJy")).default)(state.elements.arrow);
            var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
            var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
            var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
            var tetherMax = offset + maxOffset - offsetModifierValue;
            var preventedOffset = (0, (0, parcelRequire("4WpIh")).within)(tether ? (0, (0, parcelRequire("90xPK")).min)(min, tetherMin) : min, offset, tether ? (0, (0, parcelRequire("90xPK")).max)(max, tetherMax) : max);
            popperOffsets[mainAxis] = preventedOffset;
            data[mainAxis] = preventedOffset - offset;
        }
        if (checkAltAxis) {
            var _offsetModifierState$2;
            var _mainSide = mainAxis === 'x' ? (0, (0, parcelRequire("kJPed")).top) : (0, (0, parcelRequire("kJPed")).left);
            var _altSide = mainAxis === 'x' ? (0, (0, parcelRequire("kJPed")).bottom) : (0, (0, parcelRequire("kJPed")).right);
            var _offset = popperOffsets[altAxis];
            var _len = altAxis === 'y' ? 'height' : 'width';
            var _min = _offset + overflow[_mainSide];
            var _max = _offset - overflow[_altSide];
            var isOriginSide = [
                (0, (0, parcelRequire("kJPed")).top),
                (0, (0, parcelRequire("kJPed")).left)
            ].indexOf(basePlacement) !== -1;
            var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
            var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
            var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
            var _preventedOffset = tether && isOriginSide ? (0, (0, parcelRequire("4WpIh")).withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, (0, parcelRequire("4WpIh")).within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
            popperOffsets[altAxis] = _preventedOffset;
            data[altAxis] = _preventedOffset - _offset;
        }
        state.modifiersData[name] = data;
    }
    var $13043339457d5bc5$export$2e2bcd8739ae039 = {
        name: 'preventOverflow',
        enabled: true,
        phase: 'main',
        fn: $13043339457d5bc5$var$preventOverflow,
        requiresIfExists: [
            'offset'
        ]
    };
});
parcelRegister("dNtrn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a0b6b03fadcbdfd7$export$2e2bcd8739ae039);
    function $a0b6b03fadcbdfd7$export$2e2bcd8739ae039(axis) {
        return axis === 'x' ? 'y' : 'x';
    }
});
parcelRegister("4WpIh", function(module, exports) {
    $parcel$export(module.exports, "within", ()=>$3990864f59117d05$export$f28d906d67a997f3);
    $parcel$export(module.exports, "withinMaxClamp", ()=>$3990864f59117d05$export$86c8af6d3ef0b4a);
    var $90xPK;
    function $3990864f59117d05$export$f28d906d67a997f3(min, value, max) {
        return (0, (0, parcelRequire("90xPK")).max)(min, (0, (0, parcelRequire("90xPK")).min)(value, max));
    }
    function $3990864f59117d05$export$86c8af6d3ef0b4a(min, value, max) {
        var v = $3990864f59117d05$export$f28d906d67a997f3(min, value, max);
        return v > max ? max : v;
    }
});
parcelRegister("gzAfz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c10c08bd5e0ed9fb$export$2e2bcd8739ae039);
    var $QXpw1;
    var $jkGDj;
    var $j6yPg;
    var $gbHJy;
    var $9GF9F;
    var $4WpIh;
    var $gIXWB;
    var $50KfK;
    var $kJPed;
    var $c10c08bd5e0ed9fb$var$toPaddingObject = function toPaddingObject(padding, state) {
        padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
            placement: state.placement
        })) : padding;
        return (0, (0, parcelRequire("gIXWB")).default)(typeof padding !== 'number' ? padding : (0, (0, parcelRequire("50KfK")).default)(padding, (0, (0, parcelRequire("kJPed")).basePlacements)));
    };
    function $c10c08bd5e0ed9fb$var$arrow(_ref) {
        var _state$modifiersData$;
        var state = _ref.state, name = _ref.name, options = _ref.options;
        var arrowElement = state.elements.arrow;
        var popperOffsets = state.modifiersData.popperOffsets;
        var basePlacement = (0, (0, parcelRequire("QXpw1")).default)(state.placement);
        var axis = (0, (0, parcelRequire("9GF9F")).default)(basePlacement);
        var isVertical = [
            (0, (0, parcelRequire("kJPed")).left),
            (0, (0, parcelRequire("kJPed")).right)
        ].indexOf(basePlacement) >= 0;
        var len = isVertical ? 'height' : 'width';
        if (!arrowElement || !popperOffsets) return;
        var paddingObject = $c10c08bd5e0ed9fb$var$toPaddingObject(options.padding, state);
        var arrowRect = (0, (0, parcelRequire("jkGDj")).default)(arrowElement);
        var minProp = axis === 'y' ? (0, (0, parcelRequire("kJPed")).top) : (0, (0, parcelRequire("kJPed")).left);
        var maxProp = axis === 'y' ? (0, (0, parcelRequire("kJPed")).bottom) : (0, (0, parcelRequire("kJPed")).right);
        var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
        var startDiff = popperOffsets[axis] - state.rects.reference[axis];
        var arrowOffsetParent = (0, (0, parcelRequire("gbHJy")).default)(arrowElement);
        var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
        var centerToReference = endDiff / 2 - startDiff / 2;
        var min = paddingObject[minProp];
        var max = clientSize - arrowRect[len] - paddingObject[maxProp];
        var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
        var offset = (0, (0, parcelRequire("4WpIh")).within)(min, center, max);
        var axisProp = axis;
        state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
    }
    function $c10c08bd5e0ed9fb$var$effect(_ref2) {
        var state = _ref2.state, options = _ref2.options;
        var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
        if (arrowElement == null) return;
        if (typeof arrowElement === 'string') {
            arrowElement = state.elements.popper.querySelector(arrowElement);
            if (!arrowElement) return;
        }
        if (!(0, (0, parcelRequire("j6yPg")).default)(state.elements.popper, arrowElement)) return;
        state.elements.arrow = arrowElement;
    }
    var $c10c08bd5e0ed9fb$export$2e2bcd8739ae039 = {
        name: 'arrow',
        enabled: true,
        phase: 'main',
        fn: $c10c08bd5e0ed9fb$var$arrow,
        effect: $c10c08bd5e0ed9fb$var$effect,
        requires: [
            'popperOffsets'
        ],
        requiresIfExists: [
            'preventOverflow'
        ]
    };
});
parcelRegister("6iLAT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$496957b0c691a0ed$export$2e2bcd8739ae039);
    var $kJPed;
    var $kgkit;
    function $496957b0c691a0ed$var$getSideOffsets(overflow, rect, preventedOffsets) {
        if (preventedOffsets === void 0) preventedOffsets = {
            x: 0,
            y: 0
        };
        return {
            top: overflow.top - rect.height - preventedOffsets.y,
            right: overflow.right - rect.width + preventedOffsets.x,
            bottom: overflow.bottom - rect.height + preventedOffsets.y,
            left: overflow.left - rect.width - preventedOffsets.x
        };
    }
    function $496957b0c691a0ed$var$isAnySideFullyClipped(overflow) {
        return [
            (0, (0, parcelRequire("kJPed")).top),
            (0, (0, parcelRequire("kJPed")).right),
            (0, (0, parcelRequire("kJPed")).bottom),
            (0, (0, parcelRequire("kJPed")).left)
        ].some(function(side) {
            return overflow[side] >= 0;
        });
    }
    function $496957b0c691a0ed$var$hide(_ref) {
        var state = _ref.state, name = _ref.name;
        var referenceRect = state.rects.reference;
        var popperRect = state.rects.popper;
        var preventedOffsets = state.modifiersData.preventOverflow;
        var referenceOverflow = (0, (0, parcelRequire("kgkit")).default)(state, {
            elementContext: 'reference'
        });
        var popperAltOverflow = (0, (0, parcelRequire("kgkit")).default)(state, {
            altBoundary: true
        });
        var referenceClippingOffsets = $496957b0c691a0ed$var$getSideOffsets(referenceOverflow, referenceRect);
        var popperEscapeOffsets = $496957b0c691a0ed$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
        var isReferenceHidden = $496957b0c691a0ed$var$isAnySideFullyClipped(referenceClippingOffsets);
        var hasPopperEscaped = $496957b0c691a0ed$var$isAnySideFullyClipped(popperEscapeOffsets);
        state.modifiersData[name] = {
            referenceClippingOffsets: referenceClippingOffsets,
            popperEscapeOffsets: popperEscapeOffsets,
            isReferenceHidden: isReferenceHidden,
            hasPopperEscaped: hasPopperEscaped
        };
        state.attributes.popper = Object.assign({}, state.attributes.popper, {
            'data-popper-reference-hidden': isReferenceHidden,
            'data-popper-escaped': hasPopperEscaped
        });
    }
    var $496957b0c691a0ed$export$2e2bcd8739ae039 = {
        name: 'hide',
        enabled: true,
        phase: 'main',
        requiresIfExists: [
            'preventOverflow'
        ],
        fn: $496957b0c691a0ed$var$hide
    };
});
parcelRegister("iGDLS", function(module, exports) {
    $parcel$export(module.exports, "Reference", ()=>$d9aafffd117cbcc1$export$e0be378c32fb70a7);
    var $5uXOq = parcelRequire("5uXOq");
    var $hBYjV = parcelRequire("hBYjV");
    var $5n5w4;
    var $eclLw;
    function $d9aafffd117cbcc1$export$e0be378c32fb70a7(_ref) {
        var children = _ref.children, innerRef = _ref.innerRef;
        var setReferenceNode = $5uXOq.useContext((0, (0, parcelRequire("5n5w4")).ManagerReferenceNodeSetterContext));
        var refHandler = $5uXOq.useCallback(function(node) {
            (0, (0, parcelRequire("eclLw")).setRef)(innerRef, node);
            (0, (0, parcelRequire("eclLw")).safeInvoke)(setReferenceNode, node);
        }, [
            innerRef,
            setReferenceNode
        ]);
        $5uXOq.useEffect(function() {
            return function() {
                return (0, (0, parcelRequire("eclLw")).setRef)(innerRef, null);
            };
        }, []);
        $5uXOq.useEffect(function() {
            (0, ($parcel$interopDefault($hBYjV)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
        }, [
            setReferenceNode
        ]);
        return (0, (0, parcelRequire("eclLw")).unwrapArray)(children)({
            ref: refHandler
        });
    }
});
parcelRegister("4wJSY", function(module, exports) {
    $parcel$export(module.exports, "shallowEqualObjects", ()=>$34bdbe885d924a05$export$3e67810a3f0e9f1c);
    function $34bdbe885d924a05$export$967a6b9924a689f7(arrA, arrB) {
        if (arrA === arrB) return true;
        if (!arrA || !arrB) return false;
        const len = arrA.length;
        if (arrB.length !== len) return false;
        for(let i = 0; i < len; i++){
            if (arrA[i] !== arrB[i]) return false;
        }
        return true;
    }
    function $34bdbe885d924a05$export$3e67810a3f0e9f1c(objA, objB) {
        if (objA === objB) return true;
        if (!objA || !objB) return false;
        const aKeys = Object.keys(objA);
        const bKeys = Object.keys(objB);
        const len = aKeys.length;
        if (bKeys.length !== len) return false;
        for(let i = 0; i < len; i++){
            const key = aKeys[i];
            if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
        }
        return true;
    }
    function $34bdbe885d924a05$export$d36bdfa510afb180(a, b) {
        const aIsArr = Array.isArray(a);
        const bIsArr = Array.isArray(b);
        if (aIsArr !== bIsArr) return false;
        if (aIsArr && bIsArr) return $34bdbe885d924a05$export$967a6b9924a689f7(a, b);
        return $34bdbe885d924a05$export$3e67810a3f0e9f1c(a, b);
    }
});
parcelRegister("7VXAu", function(module, exports) {
    $parcel$export(module.exports, "defaultStyles", ()=>$11d0fd648d1f51c0$export$214b055320e0bf32);
    $parcel$export(module.exports, "mergeStyles", ()=>$11d0fd648d1f51c0$export$e618dc39ac9ad607);
    var $h1QWG;
    var $eZFhY;
    var $i48X9;
    var $95iuW;
    var $dS5G5;
    var $aA8TC;
    var $hqcPo;
    var $8l2RA;
    var $kKm82;
    var $hpcbi;
    const $11d0fd648d1f51c0$export$214b055320e0bf32 = {
        clearIndicator: (0, (0, parcelRequire("95iuW")).clearIndicatorCSS),
        container: (0, (0, parcelRequire("h1QWG")).containerCSS),
        control: (0, (0, parcelRequire("eZFhY")).css),
        dropdownIndicator: (0, (0, parcelRequire("95iuW")).dropdownIndicatorCSS),
        group: (0, (0, parcelRequire("i48X9")).groupCSS),
        groupHeading: (0, (0, parcelRequire("i48X9")).groupHeadingCSS),
        indicatorsContainer: (0, (0, parcelRequire("h1QWG")).indicatorsContainerCSS),
        indicatorSeparator: (0, (0, parcelRequire("95iuW")).indicatorSeparatorCSS),
        input: (0, (0, parcelRequire("dS5G5")).inputCSS),
        loadingIndicator: (0, (0, parcelRequire("95iuW")).loadingIndicatorCSS),
        loadingMessage: (0, (0, parcelRequire("aA8TC")).loadingMessageCSS),
        menu: (0, (0, parcelRequire("aA8TC")).menuCSS),
        menuList: (0, (0, parcelRequire("aA8TC")).menuListCSS),
        menuPortal: (0, (0, parcelRequire("aA8TC")).menuPortalCSS),
        multiValue: (0, (0, parcelRequire("hqcPo")).multiValueCSS),
        multiValueLabel: (0, (0, parcelRequire("hqcPo")).multiValueLabelCSS),
        multiValueRemove: (0, (0, parcelRequire("hqcPo")).multiValueRemoveCSS),
        noOptionsMessage: (0, (0, parcelRequire("aA8TC")).noOptionsMessageCSS),
        option: (0, (0, parcelRequire("8l2RA")).optionCSS),
        placeholder: (0, (0, parcelRequire("kKm82")).placeholderCSS),
        singleValue: (0, (0, parcelRequire("hpcbi")).css),
        valueContainer: (0, (0, parcelRequire("h1QWG")).valueContainerCSS)
    };
    function $11d0fd648d1f51c0$export$e618dc39ac9ad607(source, target = {}) {
        const styles = {
            ...source
        };
        Object.keys(target).forEach((keyAsString)=>{
            const key = keyAsString;
            if (source[key]) styles[key] = (rsCss, props)=>{
                return target[key](source[key](rsCss, props), props);
            };
            else styles[key] = target[key];
        });
        return styles;
    }
});
parcelRegister("7K5PP", function(module, exports) {
    $parcel$export(module.exports, "SelectWithoutAnalytics", ()=>$c2d344e1481a2d3b$export$d1de3b251ccaa8a3);
    $parcel$export(module.exports, "default", ()=>$c2d344e1481a2d3b$export$2e2bcd8739ae039);
    var $gB4mS;
    var $994MI;
    var $cb25w;
    var $eAthk;
    var $3c98u;
    const $c2d344e1481a2d3b$var$packageName = "platform-pkg";
    const $c2d344e1481a2d3b$var$packageVersion = "0.0.0-use.local";
    const $c2d344e1481a2d3b$export$d1de3b251ccaa8a3 = (0, (0, parcelRequire("3c98u")).default)((0, (0, parcelRequire("eAthk")).default));
    const $c2d344e1481a2d3b$var$createAndFireEventOnAtlaskit = (0, (0, parcelRequire("gB4mS")).default)('atlaskit');
    const $c2d344e1481a2d3b$var$Select = (0, (0, parcelRequire("994MI")).default)({
        componentName: 'select',
        packageName: $c2d344e1481a2d3b$var$packageName,
        packageVersion: $c2d344e1481a2d3b$var$packageVersion
    })((0, (0, parcelRequire("cb25w")).default)({
        onChange: $c2d344e1481a2d3b$var$createAndFireEventOnAtlaskit({
            action: 'changed',
            actionSubject: 'option',
            attributes: {
                componentName: 'select',
                packageName: $c2d344e1481a2d3b$var$packageName,
                packageVersion: $c2d344e1481a2d3b$var$packageVersion
            }
        })
    })($c2d344e1481a2d3b$export$d1de3b251ccaa8a3));
    var $c2d344e1481a2d3b$export$2e2bcd8739ae039 = $c2d344e1481a2d3b$var$Select;
});
parcelRegister("eAthk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6d0cf20527a3a891$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "useAsync", ()=>(parcelRequire("iaInK")).default);
    var $5uXOq = parcelRequire("5uXOq");
    var $2QhWf;
    var $iaInK;
    var $9uJ4X;
    const $6d0cf20527a3a891$var$AsyncSelect = (0, $5uXOq.forwardRef)((props, ref)=>{
        const isAsyncEnabledInBaseSelect = props.isAsync && !props.options && (!!props.loadOptions || !!props.defaultOptions);
        const stateManagedProps = (0, (0, parcelRequire("iaInK")).default)(props);
        let selectAsyncProps = !props.isAsync || isAsyncEnabledInBaseSelect ? stateManagedProps : props;
        const selectProps = (0, (0, parcelRequire("9uJ4X")).default)(selectAsyncProps);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2QhWf")).default), {
            ref: ref,
            ...selectProps
        });
    });
    var $6d0cf20527a3a891$export$2e2bcd8739ae039 = $6d0cf20527a3a891$var$AsyncSelect;
});
parcelRegister("2QhWf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d8e863683b34816f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $VSDnB;
    var $aCMCu;
    var $eEtcC;
    var $bChGW;
    var $jtVgE;
    var $9cRAr;
    var $galqx;
    var $81i5b;
    var $aA8TC;
    var $5JAlL;
    var $7VXAu;
    var $5HBcW;
    var $gyjU7;
    const $d8e863683b34816f$export$9c21a3269931e1e6 = {
        'aria-live': 'polite',
        backspaceRemovesValue: true,
        blurInputOnSelect: (0, (0, parcelRequire("gyjU7")).isTouchCapable)(),
        captureMenuScroll: !(0, (0, parcelRequire("gyjU7")).isTouchCapable)(),
        classNames: {},
        closeMenuOnSelect: true,
        closeMenuOnScroll: false,
        components: {},
        controlShouldRenderValue: true,
        escapeClearsValue: false,
        filterOption: (0, (0, parcelRequire("5JAlL")).createFilter)(),
        formatGroupLabel: (0, (0, parcelRequire("eEtcC")).formatGroupLabel),
        getOptionLabel: (0, (0, parcelRequire("eEtcC")).getOptionLabel),
        getOptionValue: (0, (0, parcelRequire("eEtcC")).getOptionValue),
        isDisabled: false,
        isLoading: false,
        isMulti: false,
        isRtl: false,
        isSearchable: true,
        isOptionDisabled: (0, (0, parcelRequire("eEtcC")).isOptionDisabled),
        loadingMessage: ()=>'Loading...',
        maxMenuHeight: 300,
        minMenuHeight: 140,
        menuIsOpen: false,
        menuPlacement: 'bottom',
        menuPosition: 'absolute',
        menuShouldBlockScroll: false,
        menuShouldScrollIntoView: !(0, (0, parcelRequire("gyjU7")).isMobileDevice)(),
        noOptionsMessage: ()=>'No options',
        openMenuOnFocus: false,
        openMenuOnClick: true,
        options: [],
        pageSize: 5,
        placeholder: 'Select...',
        screenReaderStatus: ({ count: count })=>`${count} result${count !== 1 ? 's' : ''} available`,
        styles: {},
        tabIndex: 0,
        tabSelectsValue: true,
        unstyled: false
    };
    function $d8e863683b34816f$var$toCategorizedOption(props, option, selectValue, index) {
        const isDisabled = $d8e863683b34816f$var$isOptionDisabled(props, option, selectValue);
        const isSelected = $d8e863683b34816f$var$isOptionSelected(props, option, selectValue);
        const label = $d8e863683b34816f$var$getOptionLabel(props, option);
        const value = $d8e863683b34816f$var$getOptionValue(props, option);
        return {
            type: 'option',
            data: option,
            isDisabled: isDisabled,
            isSelected: isSelected,
            label: label,
            value: value,
            index: index
        };
    }
    function $d8e863683b34816f$var$buildCategorizedOptions(props, selectValue) {
        return props.options.map((groupOrOption, groupOrOptionIndex)=>{
            if ('options' in groupOrOption) {
                const categorizedOptions = groupOrOption.options.map((option, optionIndex)=>$d8e863683b34816f$var$toCategorizedOption(props, option, selectValue, optionIndex)).filter((categorizedOption)=>$d8e863683b34816f$var$isFocusable(props, categorizedOption));
                return categorizedOptions.length > 0 ? {
                    type: 'group',
                    data: groupOrOption,
                    options: categorizedOptions,
                    index: groupOrOptionIndex
                } : undefined;
            }
            const categorizedOption = $d8e863683b34816f$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
            return $d8e863683b34816f$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
        }).filter((0, (0, parcelRequire("gyjU7")).notNullish));
    }
    function $d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
        return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
            if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>option.data));
            else optionsAccumulator.push(categorizedOption.data);
            return optionsAccumulator;
        }, []);
    }
    function $d8e863683b34816f$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
        return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
            if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>({
                    data: option.data,
                    id: `${optionId}-${categorizedOption.index}-${option.index}`
                })));
            else optionsAccumulator.push({
                data: categorizedOption.data,
                id: `${optionId}-${categorizedOption.index}`
            });
            return optionsAccumulator;
        }, []);
    }
    function $d8e863683b34816f$var$buildFocusableOptions(props, selectValue) {
        return $d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions($d8e863683b34816f$var$buildCategorizedOptions(props, selectValue));
    }
    function $d8e863683b34816f$var$isFocusable(props, categorizedOption) {
        const { inputValue: inputValue = '' } = props;
        const { data: data, isSelected: isSelected, label: label, value: value } = categorizedOption;
        return (!$d8e863683b34816f$var$shouldHideSelectedOptions(props) || !isSelected) && $d8e863683b34816f$var$filterOption(props, {
            label: label,
            value: value,
            data: data
        }, inputValue);
    }
    function $d8e863683b34816f$var$getNextFocusedValue(state, nextSelectValue) {
        const { focusedValue: focusedValue, selectValue: lastSelectValue } = state;
        const lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
        if (lastFocusedIndex > -1) {
            const nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
            if (nextFocusedIndex > -1) return focusedValue;
            else if (lastFocusedIndex < nextSelectValue.length) return nextSelectValue[lastFocusedIndex];
        }
        return null;
    }
    function $d8e863683b34816f$var$getNextFocusedOption(state, options) {
        const { focusedOption: lastFocusedOption } = state;
        return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
    }
    const $d8e863683b34816f$var$getFocusedOptionId = (focusableOptionsWithIds, focusedOption)=>{
        const focusedOptionId = focusableOptionsWithIds.find((option)=>option.data === focusedOption)?.id;
        return focusedOptionId || null;
    };
    const $d8e863683b34816f$var$getOptionLabel = (props, data)=>{
        return props.getOptionLabel(data);
    };
    const $d8e863683b34816f$var$getOptionValue = (props, data)=>{
        return props.getOptionValue(data);
    };
    function $d8e863683b34816f$var$isOptionDisabled(props, option, selectValue) {
        return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
    }
    function $d8e863683b34816f$var$isOptionSelected(props, option, selectValue) {
        if (selectValue.indexOf(option) > -1) return true;
        if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
        const candidate = $d8e863683b34816f$var$getOptionValue(props, option);
        return selectValue.some((i)=>$d8e863683b34816f$var$getOptionValue(props, i) === candidate);
    }
    function $d8e863683b34816f$var$filterOption(props, option, inputValue) {
        return props.filterOption ? props.filterOption(option, inputValue) : true;
    }
    const $d8e863683b34816f$var$shouldHideSelectedOptions = (props)=>{
        const { hideSelectedOptions: hideSelectedOptions, isMulti: isMulti } = props;
        if (hideSelectedOptions === undefined) return isMulti;
        return hideSelectedOptions;
    };
    let $d8e863683b34816f$var$instanceId = 1;
    class $d8e863683b34816f$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = $d8e863683b34816f$export$9c21a3269931e1e6;
        }
        constructor(props){
            super(props);
            this.state = {
                ariaSelection: null,
                focusedOption: null,
                focusedOptionId: null,
                focusableOptionsWithIds: [],
                focusedValue: null,
                inputIsHidden: false,
                isFocused: false,
                selectValue: [],
                clearFocusValueOnUpdate: false,
                prevWasFocused: false,
                inputIsHiddenAfterUpdate: undefined,
                prevProps: undefined,
                instancePrefix: ''
            };
            this.blockOptionHover = false;
            this.isComposing = false;
            this.initialTouchX = 0;
            this.initialTouchY = 0;
            this.openAfterFocus = false;
            this.scrollToFocusedOptionOnUpdate = false;
            this.isAppleDevice = (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? (0, (0, parcelRequire("aCMCu")).isSafari)() : (0, (0, parcelRequire("aCMCu")).isAppleDevice)();
            this.controlRef = null;
            this.getControlRef = (ref)=>{
                this.controlRef = ref;
            };
            this.focusedOptionRef = null;
            this.getFocusedOptionRef = (ref)=>{
                this.focusedOptionRef = ref;
            };
            this.menuListRef = null;
            this.getMenuListRef = (ref)=>{
                this.menuListRef = ref;
            };
            this.inputRef = null;
            this.getInputRef = (ref)=>{
                this.inputRef = ref;
            };
            this.focus = this.focusInput;
            this.blur = this.blurInput;
            this.onChange = (newValue, actionMeta)=>{
                const { onChange: onChange, name: name } = this.props;
                actionMeta.name = name;
                this.ariaOnChange(newValue, actionMeta);
                onChange(newValue, actionMeta);
            };
            this.setValue = (newValue, action, option)=>{
                const { closeMenuOnSelect: closeMenuOnSelect, isMulti: isMulti, inputValue: inputValue } = this.props;
                this.onInputChange('', {
                    action: 'set-value',
                    prevInputValue: inputValue
                });
                if (closeMenuOnSelect) {
                    this.setState({
                        inputIsHiddenAfterUpdate: !isMulti
                    });
                    this.onMenuClose();
                }
                this.setState({
                    clearFocusValueOnUpdate: true
                });
                this.onChange(newValue, {
                    action: action,
                    option: option
                });
            };
            this.selectOption = (newValue)=>{
                const { blurInputOnSelect: blurInputOnSelect, isMulti: isMulti, name: name } = this.props;
                const { selectValue: selectValue } = this.state;
                const deselected = isMulti && this.isOptionSelected(newValue, selectValue);
                const isDisabled = this.isOptionDisabled(newValue, selectValue);
                if (deselected) {
                    const candidate = this.getOptionValue(newValue);
                    this.setValue((0, (0, parcelRequire("gyjU7")).multiValueAsValue)(selectValue.filter((i)=>this.getOptionValue(i) !== candidate)), 'deselect-option', newValue);
                } else if (!isDisabled) {
                    if (isMulti) this.setValue((0, (0, parcelRequire("gyjU7")).multiValueAsValue)([
                        ...selectValue,
                        newValue
                    ]), 'select-option', newValue);
                    else this.setValue((0, (0, parcelRequire("gyjU7")).singleValueAsValue)(newValue), 'select-option');
                } else {
                    this.ariaOnChange((0, (0, parcelRequire("gyjU7")).singleValueAsValue)(newValue), {
                        action: 'select-option',
                        option: newValue,
                        name: name
                    });
                    return;
                }
                if (blurInputOnSelect) this.blurInput();
            };
            this.removeValue = (removedValue)=>{
                const { isMulti: isMulti } = this.props;
                const { selectValue: selectValue } = this.state;
                const candidate = this.getOptionValue(removedValue);
                const newValueArray = selectValue.filter((i)=>this.getOptionValue(i) !== candidate);
                const newValue = (0, (0, parcelRequire("gyjU7")).valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
                this.onChange(newValue, {
                    action: 'remove-value',
                    removedValue: removedValue
                });
                this.focusInput();
            };
            this.clearValue = ()=>{
                const { selectValue: selectValue } = this.state;
                this.onChange((0, (0, parcelRequire("gyjU7")).valueTernary)(this.props.isMulti, [], null), {
                    action: 'clear',
                    removedValues: selectValue
                });
            };
            this.popValue = ()=>{
                const { isMulti: isMulti } = this.props;
                const { selectValue: selectValue } = this.state;
                const lastSelectedValue = selectValue[selectValue.length - 1];
                const newValueArray = selectValue.slice(0, selectValue.length - 1);
                const newValue = (0, (0, parcelRequire("gyjU7")).valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
                this.onChange(newValue, {
                    action: 'pop-value',
                    removedValue: lastSelectedValue
                });
            };
            this.getFocusedOptionId = (focusedOption)=>{
                return $d8e863683b34816f$var$getFocusedOptionId(this.state.focusableOptionsWithIds, focusedOption);
            };
            this.getFocusableOptionsWithIds = ()=>{
                return $d8e863683b34816f$var$buildFocusableOptionsWithIds($d8e863683b34816f$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getElementId('option'));
            };
            this.getValue = ()=>this.state.selectValue;
            this.cx = (...args)=>(0, (0, parcelRequire("gyjU7")).classNames)(this.props.classNamePrefix, ...args);
            this.getOptionLabel = (data)=>{
                return $d8e863683b34816f$var$getOptionLabel(this.props, data);
            };
            this.getOptionValue = (data)=>{
                return $d8e863683b34816f$var$getOptionValue(this.props, data);
            };
            this.getStyles = (key, props)=>{
                const { unstyled: unstyled } = this.props;
                const base = (0, (0, parcelRequire("7VXAu")).defaultStyles)[key](props, unstyled);
                base.boxSizing = 'border-box';
                const custom = this.props.styles[key];
                return custom ? custom(base, props) : base;
            };
            this.getClassNames = (key, props)=>this.props.classNames[key]?.(props);
            this.getElementId = (element)=>{
                return `${this.state.instancePrefix}-${element}`;
            };
            this.getComponents = ()=>{
                return (0, (0, parcelRequire("bChGW")).defaultComponents)(this.props);
            };
            this.buildCategorizedOptions = ()=>$d8e863683b34816f$var$buildCategorizedOptions(this.props, this.state.selectValue);
            this.getCategorizedOptions = ()=>this.props.menuIsOpen ? this.buildCategorizedOptions() : [];
            this.buildFocusableOptions = ()=>$d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions(this.buildCategorizedOptions());
            this.getFocusableOptions = ()=>this.props.menuIsOpen ? this.buildFocusableOptions() : [];
            this.ariaOnChange = (value, actionMeta)=>{
                this.setState({
                    ariaSelection: {
                        value: value,
                        ...actionMeta
                    }
                });
            };
            this.onMenuMouseDown = (event)=>{
                if (event.button !== 0) return;
                event.stopPropagation();
                event.preventDefault();
                this.focusInput();
            };
            this.onMenuMouseMove = (event)=>{
                this.blockOptionHover = false;
            };
            this.onControlMouseDown = (event)=>{
                if (event.defaultPrevented) {
                    if (!this.controlRef?.closest('[data-rbd-draggable-context-id]')) return;
                }
                const { openMenuOnClick: openMenuOnClick } = this.props;
                if (!this.state.isFocused) {
                    if (openMenuOnClick) this.openAfterFocus = true;
                    this.focusInput();
                } else if (!this.props.menuIsOpen) {
                    if (openMenuOnClick) this.openMenu('first');
                } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') this.onMenuClose();
                if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
            };
            this.onDropdownIndicatorMouseDown = (event)=>{
                if (event && event.type === 'mousedown' && event.button !== 0) return;
                if (this.props.isDisabled) return;
                const { isMulti: isMulti, menuIsOpen: menuIsOpen } = this.props;
                this.focusInput();
                if (menuIsOpen) {
                    this.setState({
                        inputIsHiddenAfterUpdate: !isMulti
                    });
                    this.onMenuClose();
                } else this.openMenu('first');
                event.preventDefault();
            };
            this.onClearIndicatorMouseDown = (event)=>{
                if (event && event.type === 'mousedown' && event.button !== 0) return;
                this.clearValue();
                event.preventDefault();
                this.openAfterFocus = false;
                if (event.type === 'touchend') this.focusInput();
                else setTimeout(()=>this.focusInput());
            };
            this.onScroll = (event)=>{
                if (typeof this.props.closeMenuOnScroll === 'boolean') {
                    if (event.target instanceof HTMLElement && (0, (0, parcelRequire("gyjU7")).isDocumentElement)(event.target)) this.props.onMenuClose();
                } else if (typeof this.props.closeMenuOnScroll === 'function') {
                    if (this.props.closeMenuOnScroll(event)) this.props.onMenuClose();
                }
            };
            this.onCompositionStart = ()=>{
                this.isComposing = true;
            };
            this.onCompositionEnd = ()=>{
                this.isComposing = false;
            };
            this.onTouchStart = ({ touches: touches })=>{
                const touch = touches && touches.item(0);
                if (!touch) return;
                this.initialTouchX = touch.clientX;
                this.initialTouchY = touch.clientY;
                this.userIsDragging = false;
            };
            this.onTouchMove = ({ touches: touches })=>{
                const touch = touches && touches.item(0);
                if (!touch) return;
                const deltaX = Math.abs(touch.clientX - this.initialTouchX);
                const deltaY = Math.abs(touch.clientY - this.initialTouchY);
                const moveThreshold = 5;
                this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
            };
            this.onTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                if (this.controlRef && !this.controlRef.contains(event.target) && this.menuListRef && !this.menuListRef.contains(event.target)) this.blurInput();
                this.initialTouchX = 0;
                this.initialTouchY = 0;
            };
            this.onControlTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                this.onControlMouseDown(event);
            };
            this.onClearIndicatorTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                this.onClearIndicatorMouseDown(event);
            };
            this.onDropdownIndicatorTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                this.onDropdownIndicatorMouseDown(event);
            };
            this.handleInputChange = (event)=>{
                const { inputValue: prevInputValue } = this.props;
                const inputValue = event.currentTarget.value;
                this.setState({
                    inputIsHiddenAfterUpdate: false
                });
                this.onInputChange(inputValue, {
                    action: 'input-change',
                    prevInputValue: prevInputValue
                });
                if (!this.props.menuIsOpen) this.onMenuOpen();
            };
            this.onInputFocus = (event)=>{
                if (this.props.onFocus) this.props.onFocus(event);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    isFocused: true
                });
                if (this.openAfterFocus || this.props.openMenuOnFocus) this.openMenu('first');
                this.openAfterFocus = false;
            };
            this.onInputBlur = (event)=>{
                const { inputValue: prevInputValue } = this.props;
                if (this.menuListRef && this.menuListRef.contains(document.activeElement)) {
                    this.inputRef.focus();
                    return;
                }
                if (this.props.onBlur) this.props.onBlur(event);
                this.onInputChange('', {
                    action: 'input-blur',
                    prevInputValue: prevInputValue
                });
                this.onMenuClose();
                this.setState({
                    focusedValue: null,
                    isFocused: false
                });
            };
            this.onOptionHover = (focusedOption)=>{
                if (this.blockOptionHover || this.state.focusedOption === focusedOption) return;
                const options = this.getFocusableOptions();
                const focusedOptionIndex = options.indexOf(focusedOption);
                this.setState({
                    focusedOption: focusedOption,
                    focusedOptionId: focusedOptionIndex > -1 ? this.getFocusedOptionId(focusedOption) : null
                });
            };
            this.shouldHideSelectedOptions = ()=>{
                return $d8e863683b34816f$var$shouldHideSelectedOptions(this.props);
            };
            this.onValueInputFocus = (e)=>{
                e.preventDefault();
                e.stopPropagation();
                this.focus();
            };
            this.onKeyDown = (event)=>{
                const { isMulti: isMulti, backspaceRemovesValue: backspaceRemovesValue, escapeClearsValue: escapeClearsValue, inputValue: inputValue, isClearable: isClearable, isDisabled: isDisabled, menuIsOpen: menuIsOpen, onKeyDown: onKeyDown, tabSelectsValue: tabSelectsValue, openMenuOnFocus: openMenuOnFocus } = this.props;
                const { focusedOption: focusedOption, focusedValue: focusedValue, selectValue: selectValue } = this.state;
                if (isDisabled) return;
                if (typeof onKeyDown === 'function') {
                    onKeyDown(event);
                    if (event.defaultPrevented) return;
                }
                this.blockOptionHover = true;
                switch(event.key){
                    case 'ArrowLeft':
                        if (!isMulti || inputValue) return;
                        this.focusValue('previous');
                        break;
                    case 'ArrowRight':
                        if (!isMulti || inputValue) return;
                        this.focusValue('next');
                        break;
                    case 'Delete':
                    case 'Backspace':
                        if (inputValue) return;
                        if (focusedValue) this.removeValue(focusedValue);
                        else {
                            if (!backspaceRemovesValue) return;
                            if (isMulti) this.popValue();
                            else if (isClearable) this.clearValue();
                        }
                        break;
                    case 'Tab':
                        if (this.isComposing) return;
                        if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || openMenuOnFocus && this.isOptionSelected(focusedOption, selectValue)) return;
                        this.selectOption(focusedOption);
                        break;
                    case 'Enter':
                        if (event.keyCode === 229) break;
                        if (menuIsOpen) {
                            if (!focusedOption) return;
                            if (this.isComposing) return;
                            this.selectOption(focusedOption);
                            break;
                        }
                        return;
                    case 'Escape':
                        if (menuIsOpen) {
                            this.setState({
                                inputIsHiddenAfterUpdate: false
                            });
                            this.onInputChange('', {
                                action: 'menu-close',
                                prevInputValue: inputValue
                            });
                            this.onMenuClose();
                        } else if (isClearable && escapeClearsValue) this.clearValue();
                        break;
                    case ' ':
                        if (inputValue) return;
                        if (!menuIsOpen) {
                            this.openMenu('first');
                            break;
                        }
                        if (!focusedOption) return;
                        this.selectOption(focusedOption);
                        break;
                    case 'ArrowUp':
                        if (menuIsOpen) this.focusOption('up');
                        else this.openMenu('last');
                        break;
                    case 'ArrowDown':
                        if (menuIsOpen) this.focusOption('down');
                        else this.openMenu('first');
                        break;
                    case 'PageUp':
                        if (!menuIsOpen) return;
                        this.focusOption('pageup');
                        break;
                    case 'PageDown':
                        if (!menuIsOpen) return;
                        this.focusOption('pagedown');
                        break;
                    case 'Home':
                        if (!menuIsOpen) return;
                        this.focusOption('first');
                        break;
                    case 'End':
                        if (!menuIsOpen) return;
                        this.focusOption('last');
                        break;
                    default:
                        return;
                }
                event.preventDefault();
            };
            this.state.instancePrefix = 'react-select-' + (this.props.instanceId || ++$d8e863683b34816f$var$instanceId);
            this.state.selectValue = (0, (0, parcelRequire("gyjU7")).cleanValue)(props.value);
            if (props.menuIsOpen && this.state.selectValue.length) {
                const focusableOptionsWithIds = this.getFocusableOptionsWithIds();
                const focusableOptions = this.buildFocusableOptions();
                const optionIndex = focusableOptions.indexOf(this.state.selectValue[0]);
                this.state.focusableOptionsWithIds = focusableOptionsWithIds;
                this.state.focusedOption = focusableOptions[optionIndex];
                this.state.focusedOptionId = $d8e863683b34816f$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
            }
        }
        static getDerivedStateFromProps(props, state) {
            const { prevProps: prevProps, clearFocusValueOnUpdate: clearFocusValueOnUpdate, inputIsHiddenAfterUpdate: inputIsHiddenAfterUpdate, ariaSelection: ariaSelection, isFocused: isFocused, prevWasFocused: prevWasFocused, instancePrefix: instancePrefix } = state;
            const { options: options, value: value, menuIsOpen: menuIsOpen, inputValue: inputValue, isMulti: isMulti } = props;
            const selectValue = (0, (0, parcelRequire("gyjU7")).cleanValue)(value);
            let newMenuOptionsState = {};
            if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                const focusableOptions = menuIsOpen ? $d8e863683b34816f$var$buildFocusableOptions(props, selectValue) : [];
                const focusableOptionsWithIds = menuIsOpen ? $d8e863683b34816f$var$buildFocusableOptionsWithIds($d8e863683b34816f$var$buildCategorizedOptions(props, selectValue), `${instancePrefix}-option`) : [];
                const focusedValue = clearFocusValueOnUpdate ? $d8e863683b34816f$var$getNextFocusedValue(state, selectValue) : null;
                const focusedOption = $d8e863683b34816f$var$getNextFocusedOption(state, focusableOptions);
                const focusedOptionId = $d8e863683b34816f$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                newMenuOptionsState = {
                    selectValue: selectValue,
                    focusedOption: focusedOption,
                    focusedOptionId: focusedOptionId,
                    focusableOptionsWithIds: focusableOptionsWithIds,
                    focusedValue: focusedValue,
                    clearFocusValueOnUpdate: false
                };
            }
            const newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                inputIsHidden: inputIsHiddenAfterUpdate,
                inputIsHiddenAfterUpdate: undefined
            } : {};
            let newAriaSelection = ariaSelection;
            let hasKeptFocus = isFocused && prevWasFocused;
            if (isFocused && !hasKeptFocus) {
                newAriaSelection = {
                    value: (0, (0, parcelRequire("gyjU7")).valueTernary)(isMulti, selectValue, selectValue[0] || null),
                    options: selectValue,
                    action: 'initial-input-focus'
                };
                hasKeptFocus = !prevWasFocused;
            }
            if (ariaSelection?.action === 'initial-input-focus') newAriaSelection = null;
            return {
                ...newMenuOptionsState,
                ...newInputIsHiddenState,
                prevProps: props,
                ariaSelection: newAriaSelection,
                prevWasFocused: hasKeptFocus
            };
        }
        componentDidMount() {
            this.startListeningComposition();
            this.startListeningToTouch();
            if (this.props.closeMenuOnScroll && document && document.addEventListener) document.addEventListener('scroll', this.onScroll, true);
            if (this.props.autoFocus) this.focusInput();
            if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, (0, parcelRequire("gyjU7")).scrollIntoView)(this.menuListRef, this.focusedOptionRef);
        }
        componentDidUpdate(prevProps) {
            const { isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
            const { isFocused: isFocused } = this.state;
            if (isFocused && !isDisabled && prevProps.isDisabled || isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
            if (isFocused && isDisabled && !prevProps.isDisabled) this.setState({
                isFocused: false
            }, this.onMenuClose);
            else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) this.setState({
                isFocused: true
            });
            if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                (0, (0, parcelRequire("gyjU7")).scrollIntoView)(this.menuListRef, this.focusedOptionRef);
                this.scrollToFocusedOptionOnUpdate = false;
            }
        }
        componentWillUnmount() {
            this.stopListeningComposition();
            this.stopListeningToTouch();
            document.removeEventListener('scroll', this.onScroll, true);
        }
        onMenuOpen() {
            this.props.onMenuOpen();
        }
        onMenuClose() {
            this.onInputChange('', {
                action: 'menu-close',
                prevInputValue: this.props.inputValue
            });
            this.props.onMenuClose();
        }
        onInputChange(newValue, actionMeta) {
            this.props.onInputChange(newValue, actionMeta);
        }
        focusInput() {
            if (!this.inputRef) return;
            this.inputRef.focus();
        }
        blurInput() {
            if (!this.inputRef) return;
            this.inputRef.blur();
        }
        openMenu(focusOption) {
            const { selectValue: selectValue, isFocused: isFocused } = this.state;
            const focusableOptions = this.buildFocusableOptions();
            let openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
            if (!this.props.isMulti) {
                const selectedIndex = focusableOptions.indexOf(selectValue[0]);
                if (selectedIndex > -1) openAtIndex = selectedIndex;
            }
            this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
            this.setState({
                inputIsHiddenAfterUpdate: false,
                focusedValue: null,
                focusedOption: focusableOptions[openAtIndex],
                focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
            }, ()=>this.onMenuOpen());
        }
        focusValue(direction) {
            const { selectValue: selectValue, focusedValue: focusedValue } = this.state;
            if (!this.props.isMulti) return;
            this.setState({
                focusedOption: null
            });
            let focusedIndex = selectValue.indexOf(focusedValue);
            if (!focusedValue) focusedIndex = -1;
            const lastIndex = selectValue.length - 1;
            let nextFocus = -1;
            if (!selectValue.length) return;
            switch(direction){
                case 'previous':
                    if (focusedIndex === 0) nextFocus = 0;
                    else if (focusedIndex === -1) nextFocus = lastIndex;
                    else nextFocus = focusedIndex - 1;
                    break;
                case 'next':
                    if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                    break;
            }
            this.setState({
                inputIsHidden: nextFocus !== -1,
                focusedValue: selectValue[nextFocus]
            });
        }
        focusOption(direction = 'first') {
            const { pageSize: pageSize } = this.props;
            const { focusedOption: focusedOption } = this.state;
            const options = this.getFocusableOptions();
            if (!options.length) return;
            let nextFocus = 0;
            let focusedIndex = options.indexOf(focusedOption);
            if (!focusedOption) focusedIndex = -1;
            if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
            else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
            else if (direction === 'pageup') {
                nextFocus = focusedIndex - pageSize;
                if (nextFocus < 0) nextFocus = 0;
            } else if (direction === 'pagedown') {
                nextFocus = focusedIndex + pageSize;
                if (nextFocus > options.length - 1) nextFocus = options.length - 1;
            } else if (direction === 'last') nextFocus = options.length - 1;
            this.scrollToFocusedOptionOnUpdate = true;
            this.setState({
                focusedOption: options[nextFocus],
                focusedValue: null,
                focusedOptionId: this.getFocusedOptionId(options[nextFocus])
            });
        }
        getTheme() {
            if (!this.props.theme) return 0, (0, parcelRequire("5HBcW")).defaultTheme;
            if (typeof this.props.theme === 'function') return this.props.theme((0, (0, parcelRequire("5HBcW")).defaultTheme));
            return {
                ...(0, (0, parcelRequire("5HBcW")).defaultTheme),
                ...this.props.theme
            };
        }
        getCommonProps() {
            const { clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, selectOption: selectOption, setValue: setValue, props: props } = this;
            const { isMulti: isMulti, isRtl: isRtl, options: options } = props;
            const hasValue = this.hasValue();
            return {
                clearValue: clearValue,
                cx: cx,
                getStyles: getStyles,
                getClassNames: getClassNames,
                getValue: getValue,
                hasValue: hasValue,
                isMulti: isMulti,
                isRtl: isRtl,
                options: options,
                selectOption: selectOption,
                selectProps: props,
                setValue: setValue,
                theme: this.getTheme()
            };
        }
        hasValue() {
            const { selectValue: selectValue } = this.state;
            return selectValue.length > 0;
        }
        hasOptions() {
            return !!this.getFocusableOptions().length;
        }
        isClearable() {
            const { isClearable: isClearable, isMulti: isMulti } = this.props;
            if (isClearable === undefined) return isMulti;
            return isClearable;
        }
        isOptionDisabled(option, selectValue) {
            return $d8e863683b34816f$var$isOptionDisabled(this.props, option, selectValue);
        }
        isOptionSelected(option, selectValue) {
            return $d8e863683b34816f$var$isOptionSelected(this.props, option, selectValue);
        }
        filterOption(option, inputValue) {
            return $d8e863683b34816f$var$filterOption(this.props, option, inputValue);
        }
        formatOptionLabel(data, context) {
            if (typeof this.props.formatOptionLabel === 'function') {
                const { inputValue: inputValue } = this.props;
                const { selectValue: selectValue } = this.state;
                return this.props.formatOptionLabel(data, {
                    context: context,
                    inputValue: inputValue,
                    selectValue: selectValue
                });
            } else return this.getOptionLabel(data);
        }
        formatGroupLabel(data) {
            return this.props.formatGroupLabel(data);
        }
        startListeningComposition() {
            if (document && document.addEventListener) {
                document.addEventListener('compositionstart', this.onCompositionStart, false);
                document.addEventListener('compositionend', this.onCompositionEnd, false);
            }
        }
        stopListeningComposition() {
            if (document && document.removeEventListener) {
                document.removeEventListener('compositionstart', this.onCompositionStart);
                document.removeEventListener('compositionend', this.onCompositionEnd);
            }
        }
        startListeningToTouch() {
            if (document && document.addEventListener) {
                document.addEventListener('touchstart', this.onTouchStart, false);
                document.addEventListener('touchmove', this.onTouchMove, false);
                document.addEventListener('touchend', this.onTouchEnd, false);
            }
        }
        stopListeningToTouch() {
            if (document && document.removeEventListener) {
                document.removeEventListener('touchstart', this.onTouchStart);
                document.removeEventListener('touchmove', this.onTouchMove);
                document.removeEventListener('touchend', this.onTouchEnd);
            }
        }
        renderInput() {
            const { descriptionId: descriptionId, form: form, inputId: inputId, inputValue: inputValue, isDisabled: isDisabled, isInvalid: isInvalid, isRequired: isRequired, isSearchable: isSearchable, label: label, labelId: labelId, menuIsOpen: menuIsOpen, required: required, tabIndex: tabIndex = 0 } = this.props;
            const { Input: Input } = this.getComponents();
            const { inputIsHidden: inputIsHidden, ariaSelection: ariaSelection } = this.state;
            const { commonProps: commonProps } = this;
            const id = inputId || this.getElementId('input');
            const description = this.props['aria-describedby'] || descriptionId;
            const ariaAttributes = {
                'aria-autocomplete': 'both',
                'aria-errormessage': this.props['aria-errormessage'],
                'aria-expanded': menuIsOpen,
                'aria-haspopup': 'listbox',
                'aria-describedby': description,
                'aria-invalid': this.props['aria-invalid'] || isInvalid,
                'aria-label': this.props['aria-label'] || label,
                'aria-labelledby': this.props['aria-labelledby'] || labelId,
                'aria-required': required || isRequired,
                role: 'combobox',
                'aria-activedescendant': this.state.focusedOptionId || undefined,
                ...menuIsOpen && {
                    'aria-controls': this.getElementId('listbox')
                },
                ...!isSearchable && {
                    'aria-readonly': true
                },
                ...this.hasValue() ? ariaSelection?.action === 'initial-input-focus' && {
                    'aria-describedby': description ? [
                        description,
                        this.getElementId('live-region')
                    ].join(' ') : this.getElementId('live-region')
                } : {
                    'aria-describedby': description ? [
                        description,
                        this.getElementId('placeholder')
                    ].join(' ') : this.getElementId('placeholder')
                }
            };
            if (!isSearchable) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jtVgE")).default), {
                id: id,
                innerRef: this.getInputRef,
                onBlur: this.onInputBlur,
                onChange: (0, (0, parcelRequire("gyjU7")).noop),
                onFocus: this.onInputFocus,
                disabled: isDisabled,
                tabIndex: tabIndex,
                inputMode: "none",
                form: form,
                value: "",
                ...ariaAttributes
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement(Input, {
                ...commonProps,
                autoCapitalize: "none",
                autoComplete: "off",
                autoCorrect: "off",
                id: id,
                innerRef: this.getInputRef,
                isDisabled: isDisabled,
                isHidden: inputIsHidden,
                onBlur: this.onInputBlur,
                onChange: this.handleInputChange,
                onFocus: this.onInputFocus,
                spellCheck: "false",
                tabIndex: tabIndex,
                form: form,
                type: "text",
                value: inputValue,
                ...ariaAttributes
            });
        }
        renderPlaceholderOrValue() {
            const { MultiValue: MultiValue, MultiValueContainer: MultiValueContainer, MultiValueLabel: MultiValueLabel, MultiValueRemove: MultiValueRemove, SingleValue: SingleValue, Placeholder: Placeholder } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { controlShouldRenderValue: controlShouldRenderValue, isDisabled: isDisabled, isMulti: isMulti, inputValue: inputValue, placeholder: placeholder } = this.props;
            const { selectValue: selectValue, focusedValue: focusedValue, isFocused: isFocused } = this.state;
            if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : (0, ($parcel$interopDefault($5uXOq))).createElement(Placeholder, {
                ...commonProps,
                key: "placeholder",
                isDisabled: isDisabled,
                isFocused: isFocused,
                innerProps: {
                    id: this.getElementId('placeholder')
                }
            }, placeholder);
            if (isMulti) return selectValue.map((opt, index)=>{
                const isOptionFocused = opt === focusedValue;
                const key = `${this.getOptionLabel(opt)}-${this.getOptionValue(opt)}`;
                return (0, ($parcel$interopDefault($5uXOq))).createElement(MultiValue, {
                    ...commonProps,
                    components: {
                        Container: MultiValueContainer,
                        Label: MultiValueLabel,
                        Remove: MultiValueRemove
                    },
                    isFocused: isOptionFocused,
                    isDisabled: isDisabled,
                    key: key,
                    index: index,
                    removeProps: {
                        onClick: ()=>this.removeValue(opt),
                        onTouchEnd: ()=>this.removeValue(opt),
                        onMouseDown: (e)=>{
                            e.preventDefault();
                        }
                    },
                    data: opt
                }, this.formatOptionLabel(opt, 'value'));
            });
            if (inputValue) return null;
            const singleValue = selectValue[0];
            return (0, ($parcel$interopDefault($5uXOq))).createElement(SingleValue, {
                ...commonProps,
                data: singleValue,
                isDisabled: isDisabled
            }, this.formatOptionLabel(singleValue, 'value'));
        }
        renderClearIndicator() {
            const { ClearIndicator: ClearIndicator } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { clearControlLabel: clearControlLabel, isDisabled: isDisabled, isLoading: isLoading } = this.props;
            const { isFocused: isFocused } = this.state;
            if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
            const innerProps = {
                onMouseDown: this.onClearIndicatorMouseDown,
                onTouchEnd: this.onClearIndicatorTouchEnd,
                'aria-hidden': 'true'
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement(ClearIndicator, {
                clearControlLabel: clearControlLabel,
                ...commonProps,
                innerProps: innerProps,
                isFocused: isFocused
            });
        }
        renderLoadingIndicator() {
            const { LoadingIndicator: LoadingIndicator } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { isDisabled: isDisabled, isLoading: isLoading } = this.props;
            const { isFocused: isFocused } = this.state;
            if (!LoadingIndicator || !isLoading) return null;
            const innerProps = {
                'aria-hidden': 'true'
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement(LoadingIndicator, {
                ...commonProps,
                innerProps: innerProps,
                isDisabled: isDisabled,
                isFocused: isFocused
            });
        }
        renderIndicatorSeparator() {
            const { DropdownIndicator: DropdownIndicator, IndicatorSeparator: IndicatorSeparator } = this.getComponents();
            if (!DropdownIndicator || !IndicatorSeparator) return null;
            const { commonProps: commonProps } = this;
            const { isDisabled: isDisabled } = this.props;
            const { isFocused: isFocused } = this.state;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(IndicatorSeparator, {
                ...commonProps,
                isDisabled: isDisabled,
                isFocused: isFocused
            });
        }
        renderDropdownIndicator() {
            const { DropdownIndicator: DropdownIndicator } = this.getComponents();
            if (!DropdownIndicator) return null;
            const { commonProps: commonProps } = this;
            const { isDisabled: isDisabled } = this.props;
            const { isFocused: isFocused } = this.state;
            const innerProps = {
                onMouseDown: this.onDropdownIndicatorMouseDown,
                onTouchEnd: this.onDropdownIndicatorTouchEnd,
                'aria-hidden': 'true'
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement(DropdownIndicator, {
                ...commonProps,
                innerProps: innerProps,
                isDisabled: isDisabled,
                isFocused: isFocused
            });
        }
        renderMenu() {
            const { Group: Group, GroupHeading: GroupHeading, Menu: Menu, MenuList: MenuList, MenuPortal: MenuPortal, LoadingMessage: LoadingMessage, NoOptionsMessage: NoOptionsMessage, Option: Option } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { focusedOption: focusedOption } = this.state;
            const { captureMenuScroll: captureMenuScroll, inputValue: inputValue, isLoading: isLoading, loadingMessage: loadingMessage, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuIsOpen: menuIsOpen, menuPlacement: menuPlacement, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, menuShouldBlockScroll: menuShouldBlockScroll, menuShouldScrollIntoView: menuShouldScrollIntoView, noOptionsMessage: noOptionsMessage, onMenuScrollToTop: onMenuScrollToTop, onMenuScrollToBottom: onMenuScrollToBottom, labelId: labelId, label: label } = this.props;
            if (!menuIsOpen) return null;
            const render = (props, id, headingId)=>{
                const { type: type, data: data, isDisabled: isDisabled, isSelected: isSelected, label: label, value: value } = props;
                const isFocused = focusedOption === data;
                const onHover = isDisabled ? undefined : ()=>this.onOptionHover(data);
                const onSelect = isDisabled ? undefined : ()=>this.selectOption(data);
                const optionId = `${this.getElementId('option')}-${id}`;
                const innerProps = {
                    id: optionId,
                    onClick: onSelect,
                    onMouseMove: onHover,
                    onMouseOver: onHover,
                    role: 'option',
                    'aria-selected': !commonProps.isMulti && (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? isSelected || undefined : isSelected,
                    'aria-describedby': (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? headingId : undefined
                };
                return (0, ($parcel$interopDefault($5uXOq))).createElement(Option, {
                    ...commonProps,
                    innerProps: innerProps,
                    data: data,
                    isDisabled: isDisabled,
                    isSelected: isSelected,
                    key: optionId,
                    label: label,
                    type: type,
                    value: value,
                    isFocused: isFocused,
                    innerRef: isFocused ? this.getFocusedOptionRef : undefined
                }, this.formatOptionLabel(props.data, 'menu'));
            };
            let menuUI;
            if (this.hasOptions()) {
                const items = this.getCategorizedOptions();
                menuUI = items.map((item)=>{
                    if (item.type === 'group') {
                        const { data: data, options: options, index: groupIndex } = item;
                        const groupId = `${this.getElementId('group')}-${groupIndex}`;
                        const headingId = `${groupId}-heading`;
                        return (0, ($parcel$interopDefault($5uXOq))).createElement(Group, {
                            ...commonProps,
                            key: groupId,
                            data: data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: this.formatGroupLabel(item.data)
                        }, item.options.map((option)=>render(option, `${groupIndex}-${option.index}`, headingId)));
                    } else if (item.type === 'option') return render(item, `${item.index}`);
                });
            } else if (isLoading) {
                const message = loadingMessage({
                    inputValue: inputValue
                });
                if (message === null) return null;
                menuUI = (0, ($parcel$interopDefault($5uXOq))).createElement(LoadingMessage, commonProps, message);
            } else {
                const message = noOptionsMessage({
                    inputValue: inputValue
                });
                if (message === null) return null;
                menuUI = (0, ($parcel$interopDefault($5uXOq))).createElement(NoOptionsMessage, commonProps, message);
            }
            const menuPlacementProps = {
                minMenuHeight: minMenuHeight,
                maxMenuHeight: maxMenuHeight,
                menuPlacement: menuPlacement,
                menuPosition: menuPosition,
                menuShouldScrollIntoView: menuShouldScrollIntoView
            };
            const menuElement = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aA8TC")).MenuPlacer), {
                ...commonProps,
                ...menuPlacementProps
            }, ({ ref: ref, placerProps: { placement: placement, maxHeight: maxHeight } })=>(0, ($parcel$interopDefault($5uXOq))).createElement(Menu, {
                    ...commonProps,
                    ...menuPlacementProps,
                    innerRef: ref,
                    innerProps: {
                        onMouseDown: this.onMenuMouseDown,
                        onMouseMove: this.onMenuMouseMove,
                        id: this.props.components.Menu ? this.getElementId('listbox') : undefined
                    },
                    isLoading: isLoading,
                    placement: placement
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("galqx")).default), {
                    captureEnabled: captureMenuScroll,
                    onTopArrive: onMenuScrollToTop,
                    onBottomArrive: onMenuScrollToBottom,
                    lockEnabled: menuShouldBlockScroll
                }, (scrollTargetRef)=>(0, ($parcel$interopDefault($5uXOq))).createElement(MenuList, {
                        ...commonProps,
                        innerRef: (instance)=>{
                            this.getMenuListRef(instance);
                            scrollTargetRef(instance);
                        },
                        innerProps: {
                            role: 'listbox',
                            'aria-multiselectable': (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? commonProps.isMulti || undefined : commonProps.isMulti,
                            id: this.getElementId('listbox'),
                            ...(0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') && {
                                'aria-label': label,
                                'aria-labelledby': labelId
                            }
                        },
                        isLoading: isLoading,
                        maxHeight: maxHeight,
                        focusedOption: focusedOption
                    }, menuUI))));
            return menuPortalTarget || menuPosition === 'fixed' ? (0, ($parcel$interopDefault($5uXOq))).createElement(MenuPortal, {
                ...commonProps,
                appendTo: menuPortalTarget,
                controlElement: this.controlRef,
                menuPlacement: menuPlacement,
                menuPosition: menuPosition
            }, menuElement) : menuElement;
        }
        renderFormField() {
            const { delimiter: delimiter, isDisabled: isDisabled, isMulti: isMulti, required: required, name: name } = this.props;
            const { selectValue: selectValue } = this.state;
            if (required && !this.hasValue() && !isDisabled) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9cRAr")).default), {
                name: name,
                onFocus: this.onValueInputFocus
            });
            if (!name || isDisabled) return;
            if (isMulti) {
                if (delimiter) {
                    const value = selectValue.map((opt)=>this.getOptionValue(opt)).join(delimiter);
                    return (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                        name: name,
                        type: "hidden",
                        value: value
                    });
                } else {
                    const input = selectValue.length > 0 ? selectValue.map((opt, i)=>(0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                            key: `i-${i}`,
                            name: name,
                            type: "hidden",
                            value: this.getOptionValue(opt)
                        })) : (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                        name: name,
                        type: "hidden",
                        value: ""
                    });
                    return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, input);
                }
            } else {
                const value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                return (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                    name: name,
                    type: "hidden",
                    value: value
                });
            }
        }
        renderLiveRegion() {
            const { commonProps: commonProps } = this;
            const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, isFocused: isFocused, selectValue: selectValue } = this.state;
            const focusableOptions = this.getFocusableOptions();
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("81i5b")).default), {
                ...commonProps,
                id: this.getElementId('live-region'),
                ariaSelection: ariaSelection,
                focusedOption: focusedOption,
                focusedValue: focusedValue,
                isFocused: isFocused,
                selectValue: selectValue,
                focusableOptions: focusableOptions,
                isAppleDevice: this.isAppleDevice
            });
        }
        render() {
            const { Control: Control, IndicatorsContainer: IndicatorsContainer, SelectContainer: SelectContainer, ValueContainer: ValueContainer } = this.getComponents();
            const { className: className, id: id, isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
            const { isFocused: isFocused } = this.state;
            const commonProps = this.commonProps = this.getCommonProps();
            return (0, ($parcel$interopDefault($5uXOq))).createElement(SelectContainer, {
                ...commonProps,
                className: className,
                innerProps: {
                    id: id,
                    onKeyDown: this.onKeyDown
                },
                isDisabled: isDisabled,
                isFocused: isFocused
            }, this.renderLiveRegion(), (0, ($parcel$interopDefault($5uXOq))).createElement(Control, {
                ...commonProps,
                innerRef: this.getControlRef,
                innerProps: {
                    onMouseDown: this.onControlMouseDown,
                    onTouchEnd: this.onControlTouchEnd
                },
                isDisabled: isDisabled,
                isFocused: isFocused,
                menuIsOpen: menuIsOpen
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(ValueContainer, {
                ...commonProps,
                isDisabled: isDisabled
            }, this.renderPlaceholderOrValue(), this.renderInput()), (0, ($parcel$interopDefault($5uXOq))).createElement(IndicatorsContainer, {
                ...commonProps,
                isDisabled: isDisabled
            }, this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
        }
    }
});
parcelRegister("aCMCu", function(module, exports) {
    $parcel$export(module.exports, "isSafari", ()=>$150018e79a44f2ed$export$95df08bae54cb4df);
    $parcel$export(module.exports, "isAppleDevice", ()=>$150018e79a44f2ed$export$e1865c3bedcd822b);
    function $150018e79a44f2ed$var$testPlatform(re) {
        return typeof window !== 'undefined' && window.navigator != null ? re.test(window.navigator['userAgentData']?.platform || window.navigator.platform) : false;
    }
    function $150018e79a44f2ed$export$186c6964ca17d99() {
        return $150018e79a44f2ed$var$testPlatform(/^iPhone/i);
    }
    function $150018e79a44f2ed$export$95df08bae54cb4df() {
        if (typeof window !== 'undefined' && window.navigator != null) {
            const ua = window.navigator.userAgent?.toLowerCase();
            return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
        }
        return false;
    }
    function $150018e79a44f2ed$export$9ac100e40613ea10() {
        return $150018e79a44f2ed$var$testPlatform(/^Mac/i);
    }
    function $150018e79a44f2ed$export$7bef049ce92e4224() {
        return $150018e79a44f2ed$var$testPlatform(/^iPad/i) || $150018e79a44f2ed$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
    }
    function $150018e79a44f2ed$export$fedb369cb70207f1() {
        return $150018e79a44f2ed$export$186c6964ca17d99() || $150018e79a44f2ed$export$7bef049ce92e4224();
    }
    function $150018e79a44f2ed$export$e1865c3bedcd822b() {
        return $150018e79a44f2ed$export$9ac100e40613ea10() || $150018e79a44f2ed$export$fedb369cb70207f1();
    }
});
parcelRegister("eEtcC", function(module, exports) {
    $parcel$export(module.exports, "formatGroupLabel", ()=>$1a3d0f2eb875e1af$export$f4da216a6ca54656);
    $parcel$export(module.exports, "getOptionLabel", ()=>$1a3d0f2eb875e1af$export$dac6ace3020563ca);
    $parcel$export(module.exports, "getOptionValue", ()=>$1a3d0f2eb875e1af$export$40be908210c5a79c);
    $parcel$export(module.exports, "isOptionDisabled", ()=>$1a3d0f2eb875e1af$export$56bd0c8d90db075);
    const $1a3d0f2eb875e1af$export$f4da216a6ca54656 = (group)=>group.label;
    const $1a3d0f2eb875e1af$export$dac6ace3020563ca = (option)=>option.label;
    const $1a3d0f2eb875e1af$export$40be908210c5a79c = (option)=>option.value;
    const $1a3d0f2eb875e1af$export$56bd0c8d90db075 = (option)=>!!option.isDisabled;
});
parcelRegister("jtVgE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$afe53037961824c2$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $afe53037961824c2$var$dummyInputStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: 1,
        padding: 0,
        position: 'relative',
        background: 0,
        border: 0,
        caretColor: 'transparent',
        color: 'transparent',
        fontSize: 'inherit',
        gridArea: '1 / 1 / 2 / 3',
        insetInlineStart: -100,
        label: 'dummyInput',
        opacity: 0,
        outline: 0,
        transform: 'scale(.01)'
    });
    function $afe53037961824c2$export$2e2bcd8739ae039({ innerRef: innerRef, ...props }) {
        const filteredProps = (0, (0, parcelRequire("gyjU7")).removeProps)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
        return (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            ref: innerRef,
            ...filteredProps,
            css: $afe53037961824c2$var$dummyInputStyles
        });
    }
});
parcelRegister("9cRAr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a388fa48a9e96271$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $eGmKJ;
    function $a388fa48a9e96271$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $a388fa48a9e96271$var$styles = {
        name: "1fj9brw-requiredInput",
        styles: "width:100%;position:absolute;inset-block-end:0;inset-inline-end:0;inset-inline-start:0;label:requiredInput;opacity:0;pointer-events:none"
    };
    const $a388fa48a9e96271$var$RequiredInput = ({ name: name, onFocus: onFocus })=>(0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            required: true,
            name: name,
            tabIndex: -1,
            "aria-hidden": "true",
            onFocus: onFocus,
            css: $a388fa48a9e96271$var$styles,
            value: "",
            onChange: (0, (0, parcelRequire("eGmKJ")).default)
        });
    var $a388fa48a9e96271$export$2e2bcd8739ae039 = $a388fa48a9e96271$var$RequiredInput;
});
parcelRegister("galqx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e15a49c0b3452f71$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $59IMp;
    var $3jzRI;
    function $e15a49c0b3452f71$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $e15a49c0b3452f71$var$styles = {
        name: "qzxev8",
        styles: "position:fixed;inset-block-end:0;inset-block-start:0;inset-inline-end:0;inset-inline-start:0"
    };
    const $e15a49c0b3452f71$var$blurSelectInput = (event)=>{
        const element = event.target;
        return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
    };
    function $e15a49c0b3452f71$export$2e2bcd8739ae039({ children: children, lockEnabled: lockEnabled, captureEnabled: captureEnabled = true, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
        const setScrollCaptureTarget = (0, (0, parcelRequire("59IMp")).default)({
            isEnabled: captureEnabled,
            onBottomArrive: onBottomArrive,
            onBottomLeave: onBottomLeave,
            onTopArrive: onTopArrive,
            onTopLeave: onTopLeave
        });
        const setScrollLockTarget = (0, (0, parcelRequire("3jzRI")).default)({
            isEnabled: lockEnabled
        });
        const targetRef = (element)=>{
            setScrollCaptureTarget(element);
            setScrollLockTarget(element);
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, lockEnabled && (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            onClick: $e15a49c0b3452f71$var$blurSelectInput,
            css: $e15a49c0b3452f71$var$styles
        }), children(targetRef));
    }
});
parcelRegister("59IMp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$96c08116303d9e3a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gyjU7;
    const $96c08116303d9e3a$var$cancelScroll = (event)=>{
        if (event.cancelable) event.preventDefault();
        event.stopPropagation();
    };
    function $96c08116303d9e3a$export$2e2bcd8739ae039({ isEnabled: isEnabled, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
        const isBottom = (0, $5uXOq.useRef)(false);
        const isTop = (0, $5uXOq.useRef)(false);
        const touchStart = (0, $5uXOq.useRef)(0);
        const scrollTarget = (0, $5uXOq.useRef)(null);
        const handleEventDelta = (0, $5uXOq.useCallback)((event, delta)=>{
            if (scrollTarget.current === null) return;
            const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = scrollTarget.current;
            const target = scrollTarget.current;
            const isDeltaPositive = delta > 0;
            const availableScroll = scrollHeight - clientHeight - scrollTop;
            let shouldCancelScroll = false;
            if (availableScroll > delta && isBottom.current) {
                if (onBottomLeave) onBottomLeave(event);
                isBottom.current = false;
            }
            if (isDeltaPositive && isTop.current) {
                if (onTopLeave) onTopLeave(event);
                isTop.current = false;
            }
            if (isDeltaPositive && delta > availableScroll) {
                if (onBottomArrive && !isBottom.current) onBottomArrive(event);
                target.scrollTop = scrollHeight;
                shouldCancelScroll = true;
                isBottom.current = true;
            } else if (!isDeltaPositive && -delta > scrollTop) {
                if (onTopArrive && !isTop.current) onTopArrive(event);
                target.scrollTop = 0;
                shouldCancelScroll = true;
                isTop.current = true;
            }
            if (shouldCancelScroll) $96c08116303d9e3a$var$cancelScroll(event);
        }, [
            onBottomArrive,
            onBottomLeave,
            onTopArrive,
            onTopLeave
        ]);
        const onWheel = (0, $5uXOq.useCallback)((event)=>{
            handleEventDelta(event, event.deltaY);
        }, [
            handleEventDelta
        ]);
        const onTouchStart = (0, $5uXOq.useCallback)((event)=>{
            touchStart.current = event.changedTouches[0].clientY;
        }, []);
        const onTouchMove = (0, $5uXOq.useCallback)((event)=>{
            const deltaY = touchStart.current - event.changedTouches[0].clientY;
            handleEventDelta(event, deltaY);
        }, [
            handleEventDelta
        ]);
        const startListening = (0, $5uXOq.useCallback)((el)=>{
            if (!el) return;
            const notPassive = (0, (0, parcelRequire("gyjU7")).supportsPassiveEvents) ? {
                passive: false
            } : false;
            el.addEventListener('wheel', onWheel, notPassive);
            el.addEventListener('touchstart', onTouchStart, notPassive);
            el.addEventListener('touchmove', onTouchMove, notPassive);
        }, [
            onTouchMove,
            onTouchStart,
            onWheel
        ]);
        const stopListening = (0, $5uXOq.useCallback)((el)=>{
            if (!el) return;
            el.removeEventListener('wheel', onWheel, false);
            el.removeEventListener('touchstart', onTouchStart, false);
            el.removeEventListener('touchmove', onTouchMove, false);
        }, [
            onTouchMove,
            onTouchStart,
            onWheel
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isEnabled) return;
            const element = scrollTarget.current;
            startListening(element);
            return ()=>{
                stopListening(element);
            };
        }, [
            isEnabled,
            startListening,
            stopListening
        ]);
        return (element)=>{
            scrollTarget.current = element;
        };
    }
});
parcelRegister("3jzRI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$840302f0f43020c5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $840302f0f43020c5$var$STYLE_KEYS = [
        'boxSizing',
        'height',
        'overflow',
        'paddingRight',
        'position'
    ];
    const $840302f0f43020c5$var$LOCK_STYLES = {
        boxSizing: 'border-box',
        overflow: 'hidden',
        position: 'relative',
        height: '100%'
    };
    function $840302f0f43020c5$var$preventTouchMove(e) {
        e.preventDefault();
    }
    function $840302f0f43020c5$var$allowTouchMove(e) {
        e.stopPropagation();
    }
    function $840302f0f43020c5$var$preventInertiaScroll() {
        const top = this.scrollTop;
        const totalScroll = this.scrollHeight;
        const currentScroll = top + this.offsetHeight;
        if (top === 0) this.scrollTop = 1;
        else if (currentScroll === totalScroll) this.scrollTop = top - 1;
    }
    function $840302f0f43020c5$var$isTouchDevice() {
        return 'ontouchstart' in window || navigator.maxTouchPoints;
    }
    const $840302f0f43020c5$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
    let $840302f0f43020c5$var$activeScrollLocks = 0;
    const $840302f0f43020c5$var$listenerOptions = {
        capture: false,
        passive: false
    };
    function $840302f0f43020c5$export$2e2bcd8739ae039({ isEnabled: isEnabled, accountForScrollbars: accountForScrollbars = true }) {
        const originalStyles = (0, $5uXOq.useRef)({});
        const scrollTarget = (0, $5uXOq.useRef)(null);
        const addScrollLock = (0, $5uXOq.useCallback)((touchScrollTarget)=>{
            if (!$840302f0f43020c5$var$canUseDOM) return;
            const target = document.body;
            const targetStyle = target && target.style;
            if (accountForScrollbars) $840302f0f43020c5$var$STYLE_KEYS.forEach((key)=>{
                const val = targetStyle && targetStyle[key];
                originalStyles.current[key] = val;
            });
            if (accountForScrollbars && $840302f0f43020c5$var$activeScrollLocks < 1) {
                const currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
                const clientWidth = document.body ? document.body.clientWidth : 0;
                const adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
                Object.keys($840302f0f43020c5$var$LOCK_STYLES).forEach((key)=>{
                    const val = $840302f0f43020c5$var$LOCK_STYLES[key];
                    if (targetStyle) targetStyle[key] = val;
                });
                if (targetStyle) targetStyle.paddingRight = `${adjustedPadding}px`;
            }
            if (target && $840302f0f43020c5$var$isTouchDevice()) {
                target.addEventListener('touchmove', $840302f0f43020c5$var$preventTouchMove, $840302f0f43020c5$var$listenerOptions);
                if (touchScrollTarget) {
                    touchScrollTarget.addEventListener('touchstart', $840302f0f43020c5$var$preventInertiaScroll, $840302f0f43020c5$var$listenerOptions);
                    touchScrollTarget.addEventListener('touchmove', $840302f0f43020c5$var$allowTouchMove, $840302f0f43020c5$var$listenerOptions);
                }
            }
            $840302f0f43020c5$var$activeScrollLocks += 1;
        }, [
            accountForScrollbars
        ]);
        const removeScrollLock = (0, $5uXOq.useCallback)((touchScrollTarget)=>{
            if (!$840302f0f43020c5$var$canUseDOM) return;
            const target = document.body;
            const targetStyle = target && target.style;
            $840302f0f43020c5$var$activeScrollLocks = Math.max($840302f0f43020c5$var$activeScrollLocks - 1, 0);
            if (accountForScrollbars && $840302f0f43020c5$var$activeScrollLocks < 1) $840302f0f43020c5$var$STYLE_KEYS.forEach((key)=>{
                const val = originalStyles.current[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (target && $840302f0f43020c5$var$isTouchDevice()) {
                target.removeEventListener('touchmove', $840302f0f43020c5$var$preventTouchMove, $840302f0f43020c5$var$listenerOptions);
                if (touchScrollTarget) {
                    touchScrollTarget.removeEventListener('touchstart', $840302f0f43020c5$var$preventInertiaScroll, $840302f0f43020c5$var$listenerOptions);
                    touchScrollTarget.removeEventListener('touchmove', $840302f0f43020c5$var$allowTouchMove, $840302f0f43020c5$var$listenerOptions);
                }
            }
        }, [
            accountForScrollbars
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isEnabled) return;
            const element = scrollTarget.current;
            addScrollLock(element);
            return ()=>{
                removeScrollLock(element);
            };
        }, [
            isEnabled,
            addScrollLock,
            removeScrollLock
        ]);
        return (element)=>{
            scrollTarget.current = element;
        };
    }
});
parcelRegister("81i5b", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a3ccfcdca5695e58$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $VSDnB;
    var $dQlbw;
    var $bEd7d;
    const $a3ccfcdca5695e58$var$LiveRegion = (props)=>{
        const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, focusableOptions: focusableOptions, isFocused: isFocused, selectValue: selectValue, selectProps: selectProps, id: id, isAppleDevice: isAppleDevice } = props;
        const { ariaLiveMessages: ariaLiveMessages, getOptionLabel: getOptionLabel, inputValue: inputValue, isMulti: isMulti, isOptionDisabled: isOptionDisabled, isSearchable: isSearchable, label: label, menuIsOpen: menuIsOpen, options: options, screenReaderStatus: screenReaderStatus, tabSelectsValue: tabSelectsValue, isLoading: isLoading } = selectProps;
        const ariaLabel = selectProps['aria-label'] || label;
        const ariaLive = selectProps['aria-live'];
        const isA11yImprovementEnabled = (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') && !isAppleDevice;
        const messages = (0, $5uXOq.useMemo)(()=>({
                ...(0, (0, parcelRequire("dQlbw")).defaultAriaLiveMessages),
                ...ariaLiveMessages || {}
            }), [
            ariaLiveMessages
        ]);
        const ariaSelected = (0, $5uXOq.useMemo)(()=>{
            let message = '';
            if (isA11yImprovementEnabled && menuIsOpen) return '';
            if (ariaSelection && messages.onChange) {
                const { option: option, options: selectedOptions, removedValue: removedValue, removedValues: removedValues, value: value } = ariaSelection;
                const asOption = (val)=>!Array.isArray(val) ? val : null;
                const selected = removedValue || option || asOption(value);
                const label = selected ? getOptionLabel(selected) : '';
                const multiSelected = selectedOptions || removedValues || undefined;
                const labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
                if (isA11yImprovementEnabled && !label && !labels.length) return '';
                const onChangeProps = {
                    isDisabled: selected && isOptionDisabled(selected, selectValue),
                    label: label,
                    labels: labels,
                    ...ariaSelection
                };
                message = messages.onChange(onChangeProps);
            }
            return message;
        }, [
            ariaSelection,
            messages,
            isOptionDisabled,
            selectValue,
            getOptionLabel,
            isA11yImprovementEnabled,
            menuIsOpen
        ]);
        const prevInputValue = (0, $5uXOq.useRef)('');
        const ariaFocused = (0, $5uXOq.useMemo)(()=>{
            let focusMsg = '';
            const focused = focusedOption || focusedValue;
            const isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
            if (inputValue === prevInputValue.current && isA11yImprovementEnabled) return '';
            if (focused && messages.onFocus) {
                const onFocusProps = {
                    focused: focused,
                    label: getOptionLabel(focused),
                    isDisabled: isOptionDisabled(focused, selectValue),
                    isSelected: isSelected,
                    options: focusableOptions,
                    context: focused === focusedOption ? 'menu' : 'value',
                    selectValue: selectValue,
                    isMulti: isMulti
                };
                focusMsg = messages.onFocus(onFocusProps);
            }
            prevInputValue.current = inputValue;
            return focusMsg;
        }, [
            inputValue,
            focusedOption,
            focusedValue,
            getOptionLabel,
            isOptionDisabled,
            messages,
            focusableOptions,
            selectValue,
            isA11yImprovementEnabled,
            isMulti
        ]);
        const ariaResults = (0, $5uXOq.useMemo)(()=>{
            let resultsMsg = '';
            if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
                const shouldAnnounceAvailableResults = !focusableOptions.length;
                if (shouldAnnounceAvailableResults && (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') || !(0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement')) {
                    const resultsMessage = screenReaderStatus({
                        count: focusableOptions.length
                    });
                    resultsMsg = messages.onFilter({
                        inputValue: inputValue,
                        resultsMessage: resultsMessage
                    });
                }
            }
            return resultsMsg;
        }, [
            focusableOptions,
            inputValue,
            menuIsOpen,
            messages,
            options,
            screenReaderStatus,
            isLoading
        ]);
        const isInitialFocus = ariaSelection?.action === 'initial-input-focus';
        const ariaGuidance = (0, $5uXOq.useMemo)(()=>{
            if ((0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement')) return '';
            let guidanceMsg = '';
            if (messages.guidance) {
                const context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
                guidanceMsg = messages.guidance({
                    'aria-label': ariaLabel,
                    context: context,
                    isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                    isMulti: isMulti,
                    isSearchable: isSearchable,
                    tabSelectsValue: tabSelectsValue,
                    isInitialFocus: isInitialFocus
                });
            }
            return guidanceMsg;
        }, [
            ariaLabel,
            focusedOption,
            focusedValue,
            isMulti,
            isOptionDisabled,
            isSearchable,
            menuIsOpen,
            messages,
            selectValue,
            tabSelectsValue,
            isInitialFocus
        ]);
        const ScreenReaderText = (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-selection"
        }, ariaSelected), (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-focused"
        }, ariaFocused), (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-results"
        }, ariaResults), !(0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') && (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-guidance"
        }, ariaGuidance));
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bEd7d")).default), {
            id: id
        }, isInitialFocus && ScreenReaderText), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bEd7d")).default), {
            "aria-live": isA11yImprovementEnabled ? 'polite' : ariaLive,
            role: isA11yImprovementEnabled ? 'status' : 'log'
        }, isFocused && !isInitialFocus && ScreenReaderText));
    };
    var $a3ccfcdca5695e58$export$2e2bcd8739ae039 = $a3ccfcdca5695e58$var$LiveRegion;
});
parcelRegister("dQlbw", function(module, exports) {
    $parcel$export(module.exports, "defaultAriaLiveMessages", ()=>$d3258ad64818881e$export$a7265767c78f9bae);
    var $VSDnB;
    const $d3258ad64818881e$export$a7265767c78f9bae = {
        guidance: (props)=>{
            const { isSearchable: isSearchable, isMulti: isMulti, tabSelectsValue: tabSelectsValue, context: context, isInitialFocus: isInitialFocus } = props;
            switch(context){
                case 'menu':
                    return `Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu${tabSelectsValue ? ', press Tab to select the option and exit the menu' : ''}.`;
                case 'input':
                    return isInitialFocus ? `${props['aria-label'] || 'Select'} is focused ${isSearchable ? ',type to refine list' : ''}, press Down to open the menu, ${isMulti ? ' press left to focus selected values' : ''}` : '';
                case 'value':
                    return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
                default:
                    return '';
            }
        },
        onChange: (props)=>{
            const { action: action, label: label = '', labels: labels, isDisabled: isDisabled } = props;
            switch(action){
                case 'deselect-option':
                case 'pop-value':
                case 'remove-value':
                    return `option ${label}, deselected.`;
                case 'clear':
                    return 'All selected options have been cleared.';
                case 'initial-input-focus':
                    return `option${labels.length > 1 ? 's' : ''} ${labels.join(',')}, selected.`;
                case 'select-option':
                    return isDisabled ? `option ${label} is disabled. Select another option.` : `option ${label}, selected.`;
                default:
                    return '';
            }
        },
        onFocus: (props)=>{
            const { context: context, focused: focused, options: options, label: label = '', selectValue: selectValue, isMulti: isMulti, isDisabled: isDisabled, isSelected: isSelected } = props;
            const getArrayIndex = (arr, item)=>arr && arr.length ? `(${arr.indexOf(item) + 1} of ${arr.length})` : '';
            if (context === 'value' && selectValue) return `value ${label} focused, ${getArrayIndex(selectValue, focused)}.`;
            if (context === 'menu') {
                const disabled = isDisabled ? ' disabled' : '';
                const notSelectedStatus = !isMulti && (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? '' : ' not selected';
                const status = `${isSelected ? ' selected' : notSelectedStatus}${disabled}`;
                return `${label}${status}, ${getArrayIndex(options, focused)}, completion selected`;
            }
            return '';
        },
        onFilter: (props)=>{
            const { inputValue: inputValue, resultsMessage: resultsMessage } = props;
            return `${resultsMessage}${inputValue ? ' for search term ' + inputValue : ''}.`;
        }
    };
});
parcelRegister("bEd7d", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7cc43afa82d3c33b$export$2e2bcd8739ae039);
    var $f8Sb3;
    function $7cc43afa82d3c33b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $7cc43afa82d3c33b$var$styles = {
        name: "1j8j4w4-a11yText",
        styles: "width:1px;height:1px;padding:0;position:absolute;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);label:a11yText;overflow:hidden;white-space:nowrap"
    };
    const $7cc43afa82d3c33b$var$A11yText = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $7cc43afa82d3c33b$var$styles,
            ...props
        });
    var $7cc43afa82d3c33b$export$2e2bcd8739ae039 = $7cc43afa82d3c33b$var$A11yText;
});
parcelRegister("5JAlL", function(module, exports) {
    $parcel$export(module.exports, "createFilter", ()=>$2c9d8148d5bbcfb3$export$5d81789ff4aeccdf);
    var $8QpSo;
    var $bXu2O;
    const $2c9d8148d5bbcfb3$var$memoizedStripDiacriticsForInput = (0, (0, parcelRequire("8QpSo")).default)((0, (0, parcelRequire("bXu2O")).stripDiacritics));
    const $2c9d8148d5bbcfb3$var$trimString = (str)=>str.replace(/^\s+|\s+$/g, '');
    const $2c9d8148d5bbcfb3$var$defaultStringify = (option)=>`${option.label} ${option.value}`;
    const $2c9d8148d5bbcfb3$export$5d81789ff4aeccdf = (config)=>(option, rawInput)=>{
            if (option.data.__isNew__) return true;
            const { ignoreCase: ignoreCase, ignoreAccents: ignoreAccents, stringify: stringify, trim: trim, matchFrom: matchFrom } = {
                ignoreCase: true,
                ignoreAccents: true,
                stringify: $2c9d8148d5bbcfb3$var$defaultStringify,
                trim: true,
                matchFrom: 'any',
                ...config
            };
            let input = trim ? $2c9d8148d5bbcfb3$var$trimString(rawInput) : rawInput;
            let candidate = trim ? $2c9d8148d5bbcfb3$var$trimString(stringify(option)) : stringify(option);
            if (ignoreCase) {
                input = input.toLowerCase();
                candidate = candidate.toLowerCase();
            }
            if (ignoreAccents) {
                input = $2c9d8148d5bbcfb3$var$memoizedStripDiacriticsForInput(input);
                candidate = (0, (0, parcelRequire("bXu2O")).stripDiacritics)(candidate);
            }
            return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
        };
});
parcelRegister("bXu2O", function(module, exports) {
    $parcel$export(module.exports, "stripDiacritics", ()=>$df93339199dda18e$export$b5bee4b27048330b);
    const $df93339199dda18e$var$diacritics = [
        {
            base: 'A',
            letters: '\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'
        },
        {
            base: 'AA',
            letters: '\uA732'
        },
        {
            base: 'AE',
            letters: '\u00C6\u01FC\u01E2'
        },
        {
            base: 'AO',
            letters: '\uA734'
        },
        {
            base: 'AU',
            letters: '\uA736'
        },
        {
            base: 'AV',
            letters: '\uA738\uA73A'
        },
        {
            base: 'AY',
            letters: '\uA73C'
        },
        {
            base: 'B',
            letters: '\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'
        },
        {
            base: 'C',
            letters: '\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'
        },
        {
            base: 'D',
            letters: '\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'
        },
        {
            base: 'DZ',
            letters: '\u01F1\u01C4'
        },
        {
            base: 'Dz',
            letters: '\u01F2\u01C5'
        },
        {
            base: 'E',
            letters: '\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'
        },
        {
            base: 'F',
            letters: '\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'
        },
        {
            base: 'G',
            letters: '\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'
        },
        {
            base: 'H',
            letters: '\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'
        },
        {
            base: 'I',
            letters: '\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'
        },
        {
            base: 'J',
            letters: '\u004A\u24BF\uFF2A\u0134\u0248'
        },
        {
            base: 'K',
            letters: '\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'
        },
        {
            base: 'L',
            letters: '\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'
        },
        {
            base: 'LJ',
            letters: '\u01C7'
        },
        {
            base: 'Lj',
            letters: '\u01C8'
        },
        {
            base: 'M',
            letters: '\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'
        },
        {
            base: 'N',
            letters: '\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'
        },
        {
            base: 'NJ',
            letters: '\u01CA'
        },
        {
            base: 'Nj',
            letters: '\u01CB'
        },
        {
            base: 'O',
            letters: '\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'
        },
        {
            base: 'OI',
            letters: '\u01A2'
        },
        {
            base: 'OO',
            letters: '\uA74E'
        },
        {
            base: 'OU',
            letters: '\u0222'
        },
        {
            base: 'P',
            letters: '\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'
        },
        {
            base: 'Q',
            letters: '\u0051\u24C6\uFF31\uA756\uA758\u024A'
        },
        {
            base: 'R',
            letters: '\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'
        },
        {
            base: 'S',
            letters: '\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'
        },
        {
            base: 'T',
            letters: '\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'
        },
        {
            base: 'TZ',
            letters: '\uA728'
        },
        {
            base: 'U',
            letters: '\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'
        },
        {
            base: 'V',
            letters: '\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'
        },
        {
            base: 'VY',
            letters: '\uA760'
        },
        {
            base: 'W',
            letters: '\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'
        },
        {
            base: 'X',
            letters: '\u0058\u24CD\uFF38\u1E8A\u1E8C'
        },
        {
            base: 'Y',
            letters: '\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'
        },
        {
            base: 'Z',
            letters: '\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'
        },
        {
            base: 'a',
            letters: '\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'
        },
        {
            base: 'aa',
            letters: '\uA733'
        },
        {
            base: 'ae',
            letters: '\u00E6\u01FD\u01E3'
        },
        {
            base: 'ao',
            letters: '\uA735'
        },
        {
            base: 'au',
            letters: '\uA737'
        },
        {
            base: 'av',
            letters: '\uA739\uA73B'
        },
        {
            base: 'ay',
            letters: '\uA73D'
        },
        {
            base: 'b',
            letters: '\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'
        },
        {
            base: 'c',
            letters: '\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'
        },
        {
            base: 'd',
            letters: '\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'
        },
        {
            base: 'dz',
            letters: '\u01F3\u01C6'
        },
        {
            base: 'e',
            letters: '\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'
        },
        {
            base: 'f',
            letters: '\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'
        },
        {
            base: 'g',
            letters: '\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'
        },
        {
            base: 'h',
            letters: '\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'
        },
        {
            base: 'hv',
            letters: '\u0195'
        },
        {
            base: 'i',
            letters: '\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'
        },
        {
            base: 'j',
            letters: '\u006A\u24D9\uFF4A\u0135\u01F0\u0249'
        },
        {
            base: 'k',
            letters: '\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'
        },
        {
            base: 'l',
            letters: '\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'
        },
        {
            base: 'lj',
            letters: '\u01C9'
        },
        {
            base: 'm',
            letters: '\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'
        },
        {
            base: 'n',
            letters: '\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'
        },
        {
            base: 'nj',
            letters: '\u01CC'
        },
        {
            base: 'o',
            letters: '\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'
        },
        {
            base: 'oi',
            letters: '\u01A3'
        },
        {
            base: 'ou',
            letters: '\u0223'
        },
        {
            base: 'oo',
            letters: '\uA74F'
        },
        {
            base: 'p',
            letters: '\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'
        },
        {
            base: 'q',
            letters: '\u0071\u24E0\uFF51\u024B\uA757\uA759'
        },
        {
            base: 'r',
            letters: '\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'
        },
        {
            base: 's',
            letters: '\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'
        },
        {
            base: 't',
            letters: '\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'
        },
        {
            base: 'tz',
            letters: '\uA729'
        },
        {
            base: 'u',
            letters: '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'
        },
        {
            base: 'v',
            letters: '\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'
        },
        {
            base: 'vy',
            letters: '\uA761'
        },
        {
            base: 'w',
            letters: '\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'
        },
        {
            base: 'x',
            letters: '\u0078\u24E7\uFF58\u1E8B\u1E8D'
        },
        {
            base: 'y',
            letters: '\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'
        },
        {
            base: 'z',
            letters: '\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'
        }
    ];
    const $df93339199dda18e$var$anyDiacritic = new RegExp('[' + $df93339199dda18e$var$diacritics.map((d)=>d.letters).join('') + ']', 'g');
    const $df93339199dda18e$var$diacriticToBase = {};
    for(let i = 0; i < $df93339199dda18e$var$diacritics.length; i++){
        let diacritic = $df93339199dda18e$var$diacritics[i];
        for(let j = 0; j < diacritic.letters.length; j++)$df93339199dda18e$var$diacriticToBase[diacritic.letters[j]] = diacritic.base;
    }
    const $df93339199dda18e$export$b5bee4b27048330b = (str)=>{
        return str.replace($df93339199dda18e$var$anyDiacritic, (match)=>$df93339199dda18e$var$diacriticToBase[match]);
    };
});
parcelRegister("5HBcW", function(module, exports) {
    $parcel$export(module.exports, "defaultTheme", ()=>$f64b5780144c9fe8$export$164de7ab8df77ef0);
    const $f64b5780144c9fe8$export$8f45430ccf837300 = {
        primary: '#2684FF',
        primary75: '#4C9AFF',
        primary50: '#B2D4FF',
        primary25: '#DEEBFF',
        danger: '#DE350B',
        dangerLight: '#FFBDAD',
        neutral0: 'hsl(0, 0%, 100%)',
        neutral5: 'hsl(0, 0%, 95%)',
        neutral10: 'hsl(0, 0%, 90%)',
        neutral20: 'hsl(0, 0%, 80%)',
        neutral30: 'hsl(0, 0%, 70%)',
        neutral40: 'hsl(0, 0%, 60%)',
        neutral50: 'hsl(0, 0%, 50%)',
        neutral60: 'hsl(0, 0%, 40%)',
        neutral70: 'hsl(0, 0%, 30%)',
        neutral80: 'hsl(0, 0%, 20%)',
        neutral90: 'hsl(0, 0%, 10%)'
    };
    const $f64b5780144c9fe8$var$borderRadius = 4;
    const $f64b5780144c9fe8$var$baseUnit = 4;
    const $f64b5780144c9fe8$var$controlHeight = 38;
    const $f64b5780144c9fe8$var$menuGutter = $f64b5780144c9fe8$var$baseUnit * 2;
    const $f64b5780144c9fe8$export$5458b64234d1333c = {
        baseUnit: $f64b5780144c9fe8$var$baseUnit,
        controlHeight: $f64b5780144c9fe8$var$controlHeight,
        menuGutter: $f64b5780144c9fe8$var$menuGutter
    };
    const $f64b5780144c9fe8$export$164de7ab8df77ef0 = {
        borderRadius: $f64b5780144c9fe8$var$borderRadius,
        colors: $f64b5780144c9fe8$export$8f45430ccf837300,
        spacing: $f64b5780144c9fe8$export$5458b64234d1333c
    };
});
parcelRegister("iaInK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7e85c90096c52fe4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gyjU7;
    function $7e85c90096c52fe4$export$2e2bcd8739ae039({ defaultOptions: propsDefaultOptions = false, cacheOptions: cacheOptions = false, loadOptions: propsLoadOptions, options: propsOptions, isLoading: propsIsLoading = false, onInputChange: propsOnInputChange, filterOption: filterOption = null, ...restSelectProps }) {
        const { inputValue: propsInputValue } = restSelectProps;
        const lastRequest = (0, $5uXOq.useRef)(undefined);
        const mounted = (0, $5uXOq.useRef)(false);
        const [defaultOptions, setDefaultOptions] = (0, $5uXOq.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        const [stateInputValue, setStateInputValue] = (0, $5uXOq.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : '');
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(propsDefaultOptions === true);
        const [loadedInputValue, setLoadedInputValue] = (0, $5uXOq.useState)(undefined);
        const [loadedOptions, setLoadedOptions] = (0, $5uXOq.useState)([]);
        const [passEmptyOptions, setPassEmptyOptions] = (0, $5uXOq.useState)(false);
        const [optionsCache, setOptionsCache] = (0, $5uXOq.useState)({});
        const [prevDefaultOptions, setPrevDefaultOptions] = (0, $5uXOq.useState)(undefined);
        const [prevCacheOptions, setPrevCacheOptions] = (0, $5uXOq.useState)(undefined);
        if (cacheOptions !== prevCacheOptions) {
            setOptionsCache({});
            setPrevCacheOptions(cacheOptions);
        }
        if (propsDefaultOptions !== prevDefaultOptions) {
            setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
            setPrevDefaultOptions(propsDefaultOptions);
        }
        (0, $5uXOq.useEffect)(()=>{
            mounted.current = true;
            return ()=>{
                mounted.current = false;
            };
        }, []);
        const loadOptions = (0, $5uXOq.useCallback)((inputValue, callback)=>{
            if (!propsLoadOptions) return callback();
            const loader = propsLoadOptions(inputValue, callback);
            if (loader && typeof loader.then === 'function') loader.then(callback, ()=>callback());
        }, [
            propsLoadOptions
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (propsDefaultOptions === true) loadOptions(stateInputValue, (options)=>{
                if (!mounted.current) return;
                setDefaultOptions(options || []);
                setIsLoading(!!lastRequest.current);
            });
        }, []);
        const onInputChange = (0, $5uXOq.useCallback)((newValue, actionMeta)=>{
            const inputValue = (0, (0, parcelRequire("gyjU7")).handleInputChange)(newValue, actionMeta, propsOnInputChange);
            if (!inputValue) {
                lastRequest.current = undefined;
                setStateInputValue('');
                setLoadedInputValue('');
                setLoadedOptions([]);
                setIsLoading(false);
                setPassEmptyOptions(false);
                return;
            }
            if (cacheOptions && optionsCache[inputValue]) {
                setStateInputValue(inputValue);
                setLoadedInputValue(inputValue);
                setLoadedOptions(optionsCache[inputValue]);
                setIsLoading(false);
                setPassEmptyOptions(false);
            } else {
                const request = lastRequest.current = {};
                setStateInputValue(inputValue);
                setIsLoading(true);
                setPassEmptyOptions(!loadedInputValue);
                loadOptions(inputValue, (options)=>{
                    if (!mounted) return;
                    if (request !== lastRequest.current) return;
                    lastRequest.current = undefined;
                    setIsLoading(false);
                    setLoadedInputValue(inputValue);
                    setLoadedOptions(options || []);
                    setPassEmptyOptions(false);
                    setOptionsCache(options ? {
                        ...optionsCache,
                        [inputValue]: options
                    } : optionsCache);
                });
            }
        }, [
            cacheOptions,
            loadOptions,
            loadedInputValue,
            optionsCache,
            propsOnInputChange
        ]);
        const options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
        return {
            ...restSelectProps,
            options: options,
            isLoading: isLoading || propsIsLoading,
            onInputChange: onInputChange,
            filterOption: filterOption
        };
    }
});
parcelRegister("9uJ4X", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$72b6d9d338d10de1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $72b6d9d338d10de1$export$2e2bcd8739ae039({ defaultInputValue: defaultInputValue = '', defaultMenuIsOpen: defaultMenuIsOpen = false, defaultValue: defaultValue = null, inputValue: propsInputValue, menuIsOpen: propsMenuIsOpen, onChange: propsOnChange, onInputChange: propsOnInputChange, onMenuClose: propsOnMenuClose, onMenuOpen: propsOnMenuOpen, value: propsValue, ...restSelectProps }) {
        const [stateInputValue, setStateInputValue] = (0, $5uXOq.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue);
        const [stateMenuIsOpen, setStateMenuIsOpen] = (0, $5uXOq.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen);
        const [stateValue, setStateValue] = (0, $5uXOq.useState)(propsValue !== undefined ? propsValue : defaultValue);
        const onChange = (0, $5uXOq.useCallback)((value, actionMeta)=>{
            if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
            setStateValue(value);
        }, [
            propsOnChange
        ]);
        const onInputChange = (0, $5uXOq.useCallback)((value, actionMeta)=>{
            let newValue;
            if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
            setStateInputValue(newValue !== undefined ? newValue : value);
        }, [
            propsOnInputChange
        ]);
        const onMenuOpen = (0, $5uXOq.useCallback)(()=>{
            if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
            setStateMenuIsOpen(true);
        }, [
            propsOnMenuOpen
        ]);
        const onMenuClose = (0, $5uXOq.useCallback)(()=>{
            if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
            setStateMenuIsOpen(false);
        }, [
            propsOnMenuClose
        ]);
        const inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
        const menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
        const value = propsValue !== undefined ? propsValue : stateValue;
        return {
            ...restSelectProps,
            inputValue: inputValue,
            menuIsOpen: menuIsOpen,
            onChange: onChange,
            onInputChange: onInputChange,
            onMenuClose: onMenuClose,
            onMenuOpen: onMenuOpen,
            value: value
        };
    }
});
parcelRegister("3c98u", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$628a0199069e875a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7VXAu;
    var $l4W7r;
    var $1k2at;
    var $j1GDZ;
    var $bA56e;
    var $eaXSR;
    var $1DATb;
    function $628a0199069e875a$export$2e2bcd8739ae039(WrappedComponent) {
        const AtlaskitSelect = (0, $5uXOq.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
            const { appearance: appearance, ariaLiveMessages: ariaLiveMessages, components: componentsProp, isInvalid: isInvalid, onClickPreventDefault: onClickPreventDefault = true, spacing: spacing = 'default', styles: styles = {}, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
            const internalSelectRef = (0, $5uXOq.useRef)(null);
            const components = (0, $5uXOq.useMemo)(()=>({
                    ClearIndicator: (0, parcelRequire("l4W7r")).ClearIndicator,
                    DropdownIndicator: (0, parcelRequire("l4W7r")).DropdownIndicator,
                    LoadingIndicator: (0, parcelRequire("l4W7r")).LoadingIndicator,
                    MultiValueRemove: (0, parcelRequire("1k2at")).MultiValueRemove,
                    IndicatorSeparator: (0, parcelRequire("1k2at")).IndicatorSeparator,
                    Input: (0, parcelRequire("j1GDZ")).Input,
                    NoOptionsMessage: (0, parcelRequire("bA56e")).NoOptionsMessage,
                    ...componentsProp
                }), [
                componentsProp
            ]);
            const descriptionId = props['aria-describedby'];
            const isSearchable = props.isSearchable;
            (0, $5uXOq.useEffect)(()=>{
                if (!isSearchable && descriptionId) {
                    const input = internalSelectRef.current?.inputRef;
                    const ariaDescribedby = input?.getAttribute('aria-describedby');
                    if (!ariaDescribedby?.includes(descriptionId)) input?.setAttribute('aria-describedby', `${ariaDescribedby} ${descriptionId}`);
                }
            }, [
                descriptionId,
                isSearchable
            ]);
            const isCompact = spacing === 'compact';
            (0, $5uXOq.useImperativeHandle)(forwardedRef, ()=>({
                    select: internalSelectRef.current,
                    focus: ()=>internalSelectRef.current?.focus(),
                    blur: ()=>internalSelectRef.current?.blur()
                }), []);
            return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ref: internalSelectRef,
                "aria-live": "assertive",
                ariaLiveMessages: (0, (0, parcelRequire("1DATb")).isOptionsGrouped)(props.options) ? {
                    onFocus: (data)=>(0, (0, parcelRequire("1DATb")).onFocus)(data, props.options),
                    ...ariaLiveMessages
                } : {
                    ...ariaLiveMessages
                },
                tabSelectsValue: tabSelectsValue,
                onClickPreventDefault: onClickPreventDefault,
                isInvalid: isInvalid,
                ...restProps,
                components: components,
                styles: (0, (0, parcelRequire("7VXAu")).mergeStyles)((0, (0, parcelRequire("eaXSR")).default)(typeof isInvalid !== 'undefined' ? isInvalid ? 'error' : 'default' : validationState, isCompact, appearance || 'default'), styles),
                isAsync: true
            });
        });
        AtlaskitSelect.displayName = 'AtlaskitSelect';
        return AtlaskitSelect;
    }
});
parcelRegister("l4W7r", function(module, exports) {
    $parcel$export(module.exports, "ClearIndicator", ()=>$9145857df3efc9da$export$ecf9cf59142dd54a);
    $parcel$export(module.exports, "DropdownIndicator", ()=>$9145857df3efc9da$export$ec98719d3db7f2e4);
    $parcel$export(module.exports, "LoadingIndicator", ()=>$9145857df3efc9da$export$7c20be4c1d342248);
    var $f8Sb3;
    var $c8Oei;
    var $cQz2U;
    var $f5TWP;
    var $5ILhZ;
    var $8CUq3;
    var $bChGW;
    var $eZJjh;
    const $9145857df3efc9da$var$iconContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        all: 'unset',
        outline: 'revert',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 'space.025'
    });
    const $9145857df3efc9da$var$dropdownWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.075'
    });
    const $9145857df3efc9da$export$ecf9cf59142dd54a = ({ clearControlLabel: clearControlLabel = 'clear', ...props })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).ClearIndicator, {
            ...props,
            innerProps: {
                ...props.innerProps,
                'aria-hidden': 'false'
            }
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5ILhZ")).default), {
            xcss: $9145857df3efc9da$var$iconContainerStyles,
            tabIndex: -1,
            "aria-label": clearControlLabel
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("cQz2U"))))), {
            label: "",
            color: "currentColor",
            LEGACY_size: "small",
            LEGACY_margin: "var(--ds-space-negative-025, -0.125rem)"
        })));
    };
    const $9145857df3efc9da$export$ec98719d3db7f2e4 = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).DropdownIndicator, props, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f5TWP")).default), {
            as: "span",
            xcss: $9145857df3efc9da$var$dropdownWrapperStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("c8Oei"))))), {
            color: "currentColor",
            label: "open",
            LEGACY_margin: "var(--ds-space-negative-075, -0.375rem)"
        })));
    const $9145857df3efc9da$export$7c20be4c1d342248 = (props)=>{
        const loadingStyles = (0, (0, parcelRequire("f8Sb3")).css)(props.getStyles('loadingIndicator', props));
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: loadingStyles,
            ...props.innerProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("eZJjh")).default), {
            size: "small"
        })));
    };
});
parcelRegister("cQz2U", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $95a586bfe482ffec$var$_react = $95a586bfe482ffec$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $95a586bfe482ffec$var$_crossCircle = $95a586bfe482ffec$var$_interopRequireDefault((parcelRequire("47etd")));
    var $95a586bfe482ffec$var$_selectClear = $95a586bfe482ffec$var$_interopRequireDefault((parcelRequire("673MF")));
    function $95a586bfe482ffec$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $95a586bfe482ffec$var$CrossCircleIcon = (props)=>$95a586bfe482ffec$var$_react.default.createElement($95a586bfe482ffec$var$_crossCircle.default, Object.assign({
            LEGACY_fallbackIcon: $95a586bfe482ffec$var$_selectClear.default
        }, props));
    $95a586bfe482ffec$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
    var $95a586bfe482ffec$var$_default = module.exports.default = $95a586bfe482ffec$var$CrossCircleIcon;
});
parcelRegister("47etd", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $2ff30a5d9a7d32b6$var$_react = $2ff30a5d9a7d32b6$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $2ff30a5d9a7d32b6$var$_UNSAFE_baseNew = $2ff30a5d9a7d32b6$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $2ff30a5d9a7d32b6$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $2ff30a5d9a7d32b6$var$CrossCircleIcon = (props)=>$2ff30a5d9a7d32b6$var$_react.default.createElement($2ff30a5d9a7d32b6$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12m3.28-8.22L7.06 6l2.22 2.22-1.06 1.06L6 7.06 3.78 9.28 2.72 8.22 4.94 6 2.72 3.78l1.06-1.06L6 4.94l2.22-2.22z" clip-rule="evenodd"/>`,
            type: 'utility'
        }, props));
    $2ff30a5d9a7d32b6$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
    var $2ff30a5d9a7d32b6$var$_default = module.exports.default = $2ff30a5d9a7d32b6$var$CrossCircleIcon;
});
parcelRegister("673MF", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $473654f205f53fc4$var$_react = $473654f205f53fc4$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $473654f205f53fc4$var$_crossCircle = $473654f205f53fc4$var$_interopRequireDefault((parcelRequire("hI6SY")));
    function $473654f205f53fc4$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $473654f205f53fc4$var$SelectClearIcon = (props)=>$473654f205f53fc4$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="9" fill="currentcolor"/><path fill="inherit" d="M16.155 14.493a1.174 1.174 0 1 1-1.662 1.663L12 13.662l-2.494 2.494a1.17 1.17 0 0 1-1.662 0 1.176 1.176 0 0 1 0-1.663L10.337 12 7.844 9.507a1.176 1.176 0 0 1 1.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 1 1 1.662 1.662L13.662 12z"/></g></svg>`
        }, props, {
            newIcon: $473654f205f53fc4$var$_crossCircle.default
        }));
    $473654f205f53fc4$var$SelectClearIcon.displayName = 'SelectClearIcon';
    var $473654f205f53fc4$var$_default = module.exports.default = $473654f205f53fc4$var$SelectClearIcon;
});
parcelRegister("hI6SY", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ce4be313f95bc8ed$var$_react = $ce4be313f95bc8ed$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $ce4be313f95bc8ed$var$_UNSAFE_baseNew = $ce4be313f95bc8ed$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $ce4be313f95bc8ed$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $ce4be313f95bc8ed$var$CrossCircleIcon = (props)=>$ce4be313f95bc8ed$var$_react.default.createElement($ce4be313f95bc8ed$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
        }, props));
    $ce4be313f95bc8ed$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
    var $ce4be313f95bc8ed$var$_default = module.exports.default = $ce4be313f95bc8ed$var$CrossCircleIcon;
});
parcelRegister("1k2at", function(module, exports) {
    $parcel$export(module.exports, "MultiValueRemove", ()=>$5fdfa3c8145f4e13$export$8e1fd1a40e7a2f4a);
    $parcel$export(module.exports, "IndicatorSeparator", ()=>$5fdfa3c8145f4e13$export$bd638c2ba7915668);
    var $f8Sb3;
    var $673MF;
    var $bjGSs;
    var $VSDnB;
    var $f5TWP;
    var $8CUq3;
    var $bChGW;
    var $l4W7r;
    function $5fdfa3c8145f4e13$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $5fdfa3c8145f4e13$var$disabledStyles = {
        name: "eivff4",
        styles: "display:none"
    };
    const $5fdfa3c8145f4e13$var$enabledStyles = {
        name: "ck88l6",
        styles: "display:inherit"
    };
    const $5fdfa3c8145f4e13$var$iconWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.025'
    });
    const $5fdfa3c8145f4e13$export$8e1fd1a40e7a2f4a = (props)=>{
        const { isDisabled: isDisabled } = props.selectProps;
        const renderIcon = ()=>{
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh')) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("bjGSs"))))), {
                label: "Clear",
                color: "currentColor"
            });
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons-legacy-facade')) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f5TWP")).default), {
                xcss: $5fdfa3c8145f4e13$var$iconWrapperStyles
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("bjGSs"))))), {
                label: "Clear",
                color: "currentColor"
            }));
            return ((0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("673MF"))))), {
                label: "Clear",
                primaryColor: "transparent",
                size: "small",
                secondaryColor: "inherit"
            }));
        };
        return ((0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).MultiValueRemove, props, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: isDisabled ? $5fdfa3c8145f4e13$var$disabledStyles : $5fdfa3c8145f4e13$var$enabledStyles,
            "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon'
        }, renderIcon())));
    };
    const $5fdfa3c8145f4e13$export$bd638c2ba7915668 = null;
});
parcelRegister("bjGSs", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $83d2ba975692c1a3$var$_react = $83d2ba975692c1a3$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $83d2ba975692c1a3$var$_UNSAFE_baseNew = $83d2ba975692c1a3$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $83d2ba975692c1a3$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $83d2ba975692c1a3$var$CrossIcon = (props)=>$83d2ba975692c1a3$var$_react.default.createElement($83d2ba975692c1a3$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m2 10 4-4m4-4L6 6m0 0L2 2m4 4 4 4"/>`,
            type: 'utility'
        }, props));
    $83d2ba975692c1a3$var$CrossIcon.displayName = 'CrossIcon';
    var $83d2ba975692c1a3$var$_default = module.exports.default = $83d2ba975692c1a3$var$CrossIcon;
});
parcelRegister("j1GDZ", function(module, exports) {
    $parcel$export(module.exports, "Input", ()=>$4cb02513bf42b58e$export$f5b8910cec6cf069);
    var $5uXOq = parcelRequire("5uXOq");
    var $bChGW;
    function $4cb02513bf42b58e$export$f5b8910cec6cf069(props) {
        let ariaDescribedByAttribute = props['aria-describedby'];
        const passed_describedby = props.selectProps['aria-describedby'] || props.selectProps.descriptionId;
        if (passed_describedby && !ariaDescribedByAttribute?.includes(passed_describedby)) ariaDescribedByAttribute = props['aria-describedby'] + ' ' + passed_describedby;
        else ariaDescribedByAttribute = props['aria-describedby'] || passed_describedby;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).Input, {
            ...props,
            "aria-describedby": ariaDescribedByAttribute
        });
    }
});
parcelRegister("bA56e", function(module, exports) {
    $parcel$export(module.exports, "NoOptionsMessage", ()=>$eeac7d0aa054dce2$export$d58b72b7d3c4072c);
    var $5uXOq = parcelRequire("5uXOq");
    var $cgL5K;
    var $bChGW;
    const $eeac7d0aa054dce2$export$d58b72b7d3c4072c = (props)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).NoOptionsMessage, props, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            color: "color.text.subtle"
        }, props.children || `No options`));
    };
});
parcelRegister("eaXSR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b7eb841defe611e3$export$2e2bcd8739ae039);
    var $VSDnB;
    function $b7eb841defe611e3$export$2e2bcd8739ae039(validationState, isCompact = false, appearance) {
        return {
            container: (css, { isDisabled: isDisabled })=>({
                    ...css,
                    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    pointerEvents: 'all',
                    cursor: isDisabled ? 'not-allowed' : css.cursor
                }),
            input: (css)=>({
                    ...css,
                    color: "var(--ds-text, hsl(0, 0%, 20%))"
                }),
            control: (css, { isFocused: isFocused, isDisabled: isDisabled })=>{
                let borderColor = isFocused ? `var(--ds-border-focused, ${0, $829f609a65d26a98$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`;
                let backgroundColor = isFocused ? `var(--ds-background-input-pressed, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : `var(--ds-background-input, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`;
                let backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})`;
                if (isDisabled) {
                    backgroundColor = `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`;
                    borderColor = `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`;
                }
                if (validationState === 'error') borderColor = `var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`;
                if (validationState === 'success') borderColor = `var(--ds-border-success, ${0, $829f609a65d26a98$export$a49394138f7b8e85})`;
                let borderColorHover = isFocused ? `var(--ds-border-focused, ${0, $829f609a65d26a98$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`;
                if (validationState === 'error') borderColorHover = `var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`;
                if (validationState === 'success') borderColorHover = `var(--ds-border-success, ${0, $829f609a65d26a98$export$a49394138f7b8e85})`;
                const transitionDuration = '200ms';
                if (appearance === 'subtle') {
                    borderColor = isFocused ? `var(--ds-border-focused, ${0, $829f609a65d26a98$export$ecfc1dff386a3e7a})` : 'transparent';
                    backgroundColor = isFocused ? `var(--ds-surface, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : 'transparent';
                    backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})`;
                }
                if (appearance === 'none') {
                    borderColor = 'transparent';
                    backgroundColor = 'transparent';
                    backgroundColorHover = 'transparent';
                    borderColorHover = 'transparent';
                }
                return {
                    ...css,
                    pointerEvents: isDisabled ? 'none' : undefined,
                    backgroundColor: backgroundColor,
                    borderColor: borderColor,
                    borderStyle: 'solid',
                    borderRadius: "var(--ds-border-radius-100, 3px)",
                    borderWidth: "var(--ds-border-width, 1px)",
                    boxShadow: validationState === 'error' ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}` : 'none',
                    '&:focus-within': {
                        boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}`
                    },
                    minHeight: isCompact ? 32 : 40,
                    padding: 0,
                    transition: `background-color ${transitionDuration} ease-in-out,
        border-color ${transitionDuration} ease-in-out`,
                    '::-webkit-scrollbar': {
                        height: 8,
                        width: 8
                    },
                    '::-webkit-scrollbar-corner': {
                        display: 'none'
                    },
                    ':hover': {
                        '::-webkit-scrollbar-thumb': {
                            backgroundColor: 'rgba(0,0,0,0.2)'
                        },
                        cursor: 'pointer',
                        backgroundColor: backgroundColorHover,
                        borderColor: borderColorHover
                    },
                    '::-webkit-scrollbar-thumb:hover': {
                        backgroundColor: 'rgba(0,0,0,0.4)'
                    }
                };
            },
            valueContainer: (css)=>({
                    ...css,
                    paddingLeft: "var(--ds-space-075, 6px)",
                    paddingRight: "var(--ds-space-075, 6px)",
                    paddingBottom: isCompact ? 0 : 2,
                    paddingTop: isCompact ? 0 : 2
                }),
            clearIndicator: (css)=>({
                    ...css,
                    color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    paddingRight: "var(--ds-space-025, 2px)",
                    paddingBottom: isCompact ? 0 : 6,
                    paddingTop: isCompact ? 0 : 6,
                    ':hover': {
                        color: `var(--ds-text-subtle, ${0, $829f609a65d26a98$export$c39c0fe0f26207ae})`
                    }
                }),
            loadingIndicator: (css)=>({
                    ...css,
                    paddingBottom: isCompact ? 0 : 6,
                    paddingTop: isCompact ? 0 : 6
                }),
            dropdownIndicator: (css, { isDisabled: isDisabled })=>{
                let color = `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`;
                if (isDisabled) color = `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`;
                return {
                    ...css,
                    color: color,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    paddingRight: "var(--ds-space-025, 2px)",
                    paddingBottom: isCompact ? 0 : 6,
                    paddingTop: isCompact ? 0 : 6,
                    ':hover': {
                        color: `var(--ds-text-subtle, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`
                    }
                };
            },
            indicatorsContainer: (css)=>({
                    ...css,
                    paddingRight: "var(--ds-space-050, 4px)"
                }),
            option: (css, { isFocused: isFocused, isSelected: isSelected, isDisabled: isDisabled })=>{
                let color = `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`;
                if (isDisabled) color = `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`;
                else if (isSelected) color = `var(--ds-text-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
                let boxShadow;
                let backgroundColor;
                if (isDisabled) backgroundColor = undefined;
                else if (isSelected && isFocused) backgroundColor = `var(--ds-background-selected-hovered, ${0, $829f609a65d26a98$export$226de0355ed012f8})`;
                else if (isSelected) backgroundColor = `var(--ds-background-selected, ${0, $829f609a65d26a98$export$226de0355ed012f8})`;
                else if (isFocused) backgroundColor = `var(--ds-background-neutral-subtle-hovered, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`;
                if (!isDisabled && (isFocused || isSelected)) boxShadow = `inset 2px 0px 0px ${`var(--ds-border-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`}`;
                const cursor = isDisabled ? 'not-allowed' : css.cursor;
                return {
                    ...css,
                    padding: '6px 12px',
                    backgroundColor: backgroundColor,
                    color: color,
                    cursor: cursor,
                    boxShadow: boxShadow,
                    ':active': {
                        backgroundColor: !isDisabled ? isSelected ? `var(--ds-background-selected-pressed, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})` : `var(--ds-background-neutral-subtle-pressed, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})` : undefined
                    },
                    '@media screen and (-ms-high-contrast: active)': {
                        borderLeft: !isDisabled && (isFocused || isSelected) ? '2px solid transparent' : ''
                    }
                };
            },
            placeholder: (css, { isDisabled: isDisabled })=>({
                    ...css,
                    color: isDisabled ? `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$e2ef2124cf4024b1})` : `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`
                }),
            singleValue: (css, { isDisabled: isDisabled })=>({
                    ...css,
                    color: isDisabled ? `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})` : `var(--ds-text, ${0, $829f609a65d26a98$export$7d61b15e0da132af})`
                }),
            menu: (css)=>({
                    ...css,
                    backgroundColor: "var(--ds-surface-overlay, white)",
                    boxShadow: "var(--ds-shadow-overlay, 0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%))"
                }),
            menuList: (css)=>({
                    ...css,
                    paddingTop: "var(--ds-space-100, 8px)",
                    paddingBottom: "var(--ds-space-100, 8px)"
                }),
            multiValue: (css, { isDisabled: isDisabled, isFocused: isFocused })=>{
                let backgroundColor;
                let color;
                if (isDisabled) {
                    backgroundColor = `var(--ds-background-neutral, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`;
                    color = `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`;
                } else if (isFocused) {
                    backgroundColor = `var(--ds-background-selected, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`;
                    color = "var(--ds-text-selected, hsl(0, 0%, 20%))";
                } else {
                    backgroundColor = (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? "var(--ds-background-neutral-subtle-hovered, #091E420F)" : `var(--ds-background-neutral, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`;
                    color = "var(--ds-text, hsl(0, 0%, 20%))";
                }
                return {
                    ...css,
                    borderRadius: "var(--ds-border-radius-050, 2px)",
                    backgroundColor: backgroundColor,
                    boxShadow: isFocused ? `0 0 0 2px ${"var(--ds-surface, transparent)"}, 0 0 0 4px ${"var(--ds-border-focused, transparent)"}` : 'none',
                    maxWidth: '100%',
                    '@media screen and (-ms-high-contrast: active)': {
                        border: isFocused ? '1px solid transparent' : 'none'
                    },
                    color: color,
                    ...(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') && {
                        borderRadius: "var(--ds-border-radius-100, 4px)",
                        borderColor: '#B7B9BE',
                        borderWidth: "var(--ds-border-width, 1px)",
                        borderStyle: 'solid',
                        backgroundColor: "var(--ds-background-input, #FFFFFF)"
                    }
                };
            },
            multiValueLabel: (css, { isDisabled: isDisabled })=>({
                    ...css,
                    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    padding: "var(--ds-space-025, 2px)",
                    color: isDisabled ? `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})` : 'inherit',
                    paddingRight: "var(--ds-space-025, 2px)",
                    ...(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') && {
                        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                        paddingTop: 0,
                        paddingBottom: 0,
                        paddingLeft: "var(--ds-space-050, 4px)"
                    }
                }),
            multiValueRemove: (css, { isFocused: isFocused })=>({
                    ...css,
                    backgroundColor: isFocused ? `var(--ds-UNSAFE-transparent, ${0, $829f609a65d26a98$export$b34b069eff244586})` : undefined,
                    fill: isFocused ? "var(--ds-text-selected, #000)" : "var(--ds-text, #000)",
                    paddingLeft: "var(--ds-space-025, 2px)",
                    paddingRight: "var(--ds-space-025, 2px)",
                    borderRadius: '0px 2px 2px 0px',
                    ':hover': {
                        backgroundColor: `var(--ds-background-danger-hovered, ${0, $829f609a65d26a98$export$b34b069eff244586})`,
                        fill: "var(--ds-text-danger, #000)"
                    },
                    ':active': {
                        backgroundColor: `var(--ds-background-danger-pressed, ${0, $829f609a65d26a98$export$b34b069eff244586})`,
                        fill: "var(--ds-text-danger, #000)"
                    },
                    ...(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') && {
                        backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
                        border: 'none',
                        alignItems: 'center',
                        justifyContent: 'center',
                        alignSelf: 'center',
                        appearance: 'none',
                        borderRadius: "var(--ds-border-radius, 4px)",
                        color: "var(--ds-text, #172B4D)",
                        padding: "var(--ds-space-025, 2px)",
                        marginRight: "var(--ds-space-025, 2px)",
                        ':focus-visible': {
                            outlineOffset: "var(--ds-space-negative-025, -2px)"
                        },
                        ':hover': {
                            backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
                        },
                        ':active': {
                            backgroundColor: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
                        }
                    }
                }),
            groupHeading: (css)=>({
                    ...css,
                    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    color: `var(--ds-text-subtle, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`,
                    fontWeight: `${"var(--ds-font-weight-bold, 700)"} !important`,
                    textTransform: 'none'
                })
        };
    }
});
parcelRegister("1DATb", function(module, exports) {
    $parcel$export(module.exports, "onFocus", ()=>$a998ee34d66f3da7$export$ecf9bf35ad97eb74);
    $parcel$export(module.exports, "isOptionsGrouped", ()=>$a998ee34d66f3da7$export$d2756249f53f9f8);
    $parcel$export(module.exports, "countAllOptions", ()=>$a998ee34d66f3da7$export$8ee33f304118fce4);
    function $a998ee34d66f3da7$export$ecf9bf35ad97eb74(onFocusProps, defaultOptions) {
        const { focused: focused } = onFocusProps;
        const isOptionFocused = (option)=>{
            return option.label === focused.label;
        };
        const groupData = defaultOptions?.find((option)=>{
            return option.options?.some(isOptionFocused);
        });
        const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
        return `Option ${focused.label}, ${groupData?.label} group, item ${groupOptionIndex + 1} out of ${groupData?.options.length}. All in all `;
    }
    const $a998ee34d66f3da7$export$d2756249f53f9f8 = (arr)=>{
        return arr?.every((obj)=>obj.hasOwnProperty('options'));
    };
    const $a998ee34d66f3da7$export$8ee33f304118fce4 = (groupsArray)=>{
        const totalLength = groupsArray?.reduce((acc, currentGroup)=>{
            const group = currentGroup;
            acc += group?.options?.length;
            return acc;
        }, 0);
        return totalLength;
    };
});
parcelRegister("hT6ku", function(module, exports) {
    $parcel$export(module.exports, "MenuDialog", ()=>$3f79b132df1e01ff$export$c94219dad7c0e37d);
    $parcel$export(module.exports, "DummyControl", ()=>$3f79b132df1e01ff$export$87ce933b7fc29b8c);
    $parcel$export(module.exports, "defaultComponents", ()=>$3f79b132df1e01ff$export$71abc632aa29e6fe);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $gMMNe;
    var $bChGW;
    var $k5uoT;
    var $jldZL;
    function $3f79b132df1e01ff$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $3f79b132df1e01ff$var$menuDialogStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        zIndex: (0, (0, parcelRequire("k5uoT")).layers).modal(),
        backgroundColor: "var(--ds-surface-overlay, white)",
        borderRadius: "var(--ds-border-radius-100, 4px)",
        boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)}, 0 4px 11px ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)}`})`
    });
    const $3f79b132df1e01ff$export$c94219dad7c0e37d = (0, $5uXOq.forwardRef)(({ maxWidth: maxWidth, minWidth: minWidth, children: children, id: id, style: style, testId: testId }, ref)=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: ref,
            css: [
                $3f79b132df1e01ff$var$menuDialogStyles,
                {
                    maxWidth: maxWidth,
                    minWidth: minWidth
                }
            ],
            style: style,
            id: id,
            "data-testid": testId && `${testId}--menu`
        }, children));
    const $3f79b132df1e01ff$var$dropdownStyles = {
        name: "7693z9",
        styles: "width:32px;margin-inline-end:var(--ds-space-025, 2px);text-align:center"
    };
    const $3f79b132df1e01ff$var$DropdownIndicator = ()=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $3f79b132df1e01ff$var$dropdownStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("gMMNe"))))), {
            color: "currentColor",
            spacing: "spacious",
            label: "open"
        }));
    const $3f79b132df1e01ff$var$controlStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-050, 4px)"}`
    });
    const $3f79b132df1e01ff$var$Control = ({ innerRef: innerRef, innerProps: innerProps, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: innerRef,
            css: $3f79b132df1e01ff$var$controlStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).Control, {
            ...props,
            innerProps: innerProps
        }));
    const $3f79b132df1e01ff$export$87ce933b7fc29b8c = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jldZL")).default), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).Control, props));
    const $3f79b132df1e01ff$var$Menu = ({ children: children, innerProps: innerProps })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", innerProps, children);
    const $3f79b132df1e01ff$var$IndicatorSeparator = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).IndicatorSeparator, props);
    const $3f79b132df1e01ff$var$ClearIndicator = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).ClearIndicator, props);
    const $3f79b132df1e01ff$var$MultiValueRemove = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).MultiValueRemove, props);
    const $3f79b132df1e01ff$export$71abc632aa29e6fe = {
        Control: $3f79b132df1e01ff$var$Control,
        DropdownIndicator: $3f79b132df1e01ff$var$DropdownIndicator,
        Menu: $3f79b132df1e01ff$var$Menu,
        IndicatorSeparator: $3f79b132df1e01ff$var$IndicatorSeparator,
        ClearIndicator: $3f79b132df1e01ff$var$ClearIndicator,
        MultiValueRemove: $3f79b132df1e01ff$var$MultiValueRemove
    };
});
parcelRegister("gMMNe", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c386fa4cb21167b0$var$_react = $c386fa4cb21167b0$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c386fa4cb21167b0$var$_search = $c386fa4cb21167b0$var$_interopRequireDefault((parcelRequire("hyOJh")));
    var $c386fa4cb21167b0$var$_search2 = $c386fa4cb21167b0$var$_interopRequireDefault((parcelRequire("77ZoC")));
    function $c386fa4cb21167b0$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c386fa4cb21167b0$var$SearchIcon = (props)=>$c386fa4cb21167b0$var$_react.default.createElement($c386fa4cb21167b0$var$_search.default, Object.assign({
            LEGACY_fallbackIcon: $c386fa4cb21167b0$var$_search2.default
        }, props));
    $c386fa4cb21167b0$var$SearchIcon.Name = 'SearchIconMigration';
    var $c386fa4cb21167b0$var$_default = module.exports.default = $c386fa4cb21167b0$var$SearchIcon;
});
parcelRegister("77ZoC", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $5308cfd5e45a5605$var$_react = $5308cfd5e45a5605$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $5308cfd5e45a5605$var$_search = $5308cfd5e45a5605$var$_interopRequireDefault((parcelRequire("hyOJh")));
    function $5308cfd5e45a5605$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $5308cfd5e45a5605$var$EditorSearchIcon = (props)=>$5308cfd5e45a5605$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M14.823 15.883a5.5 5.5 0 1 1 1.06-1.06l2.647 2.647c.293.293.53.59 0 1.06s-.767.293-1.06 0zM11.5 15.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8"/></svg>`
        }, props, {
            newIcon: $5308cfd5e45a5605$var$_search.default
        }));
    $5308cfd5e45a5605$var$EditorSearchIcon.displayName = 'EditorSearchIcon';
    var $5308cfd5e45a5605$var$_default = module.exports.default = $5308cfd5e45a5605$var$EditorSearchIcon;
});
parcelRegister("dqoiX", function(module, exports) {
    $parcel$export(module.exports, "visuallyHiddenStyles", ()=>$11827e0613b04108$export$8dd524ceb40e3d16);
    $parcel$export(module.exports, "ScreenReaderText", ()=>$11827e0613b04108$export$88fad6aa294f111c);
    $parcel$export(module.exports, "ScreenReaderCaption", ()=>$11827e0613b04108$export$200c8e5d652aa9af);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $11827e0613b04108$export$8dd524ceb40e3d16 = {
        clip: 'rect(1px, 1px, 1px, 1px)',
        clipPath: 'inset(50%)',
        height: '1px',
        width: '1px',
        margin: '-1px',
        overflow: 'hidden',
        padding: 0,
        position: 'absolute'
    };
    const $11827e0613b04108$export$88fad6aa294f111c = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_ogto7mnp _mkrz1wmp _4t3it94y _1bsbt94y _19pk1n1a _2hwx1n1a _otyr1n1a _18u01n1a _1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw",
                __cmplp.className
            ])
        });
    });
    const $11827e0613b04108$export$200c8e5d652aa9af = (0, $5uXOq.forwardRef)(({ as: C = "caption", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_ogto7mnp _mkrz1wmp _4t3it94y _1bsbt94y _19pk1n1a _2hwx1n1a _otyr1n1a _18u01n1a _1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("8C9C3", function(module, exports) {
    $parcel$export(module.exports, "FILTER_MENU_MIN_WIDTH", ()=>$e9228ce7bf573a8c$export$84ae3fb9fdba8a12);
    $parcel$export(module.exports, "FILTER_MENU_MIN_WIDTH_ON_NESTED", ()=>$e9228ce7bf573a8c$export$920d89f17cd2fe3d);
    $parcel$export(module.exports, "FILTER_MENU_MAX_WIDTH", ()=>$e9228ce7bf573a8c$export$6ea791ab71b8fa00);
    $parcel$export(module.exports, "FILTER_SEARCH_THRESHOLD", ()=>$e9228ce7bf573a8c$export$1d287c6a8b81eb5b);
    $parcel$export(module.exports, "OPEN_CHANGE_PAYLOAD", ()=>$e9228ce7bf573a8c$export$2f5981b7dbafe3a4);
    $parcel$export(module.exports, "OPEN_CHANGE_SUBJECT_ID", ()=>$e9228ce7bf573a8c$export$b94e5dc1a8a1409);
    $parcel$export(module.exports, "EXPERIMENT_MAKE_IT_EASIER_TO_DESELECT_FILTER_ITEMS_THRESHOLD", ()=>$e9228ce7bf573a8c$export$f63317e791502e67);
    var $gwIPs;
    const $e9228ce7bf573a8c$export$84ae3fb9fdba8a12 = (0, (0, parcelRequire("gwIPs")).gridSize) * 21;
    const $e9228ce7bf573a8c$export$920d89f17cd2fe3d = (0, (0, parcelRequire("gwIPs")).gridSize) * 25;
    const $e9228ce7bf573a8c$export$6ea791ab71b8fa00 = (0, (0, parcelRequire("gwIPs")).gridSize) * 48;
    const $e9228ce7bf573a8c$export$1d287c6a8b81eb5b = 9;
    const $e9228ce7bf573a8c$export$2f5981b7dbafe3a4 = {
        action: 'clicked',
        actionSubject: 'dropdownMenu'
    };
    const $e9228ce7bf573a8c$export$b94e5dc1a8a1409 = 'filterList';
    const $e9228ce7bf573a8c$export$f63317e791502e67 = 9;
});
parcelRegister("dF38k", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2deb009ebf7ebceb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Rkzz = parcelRequire("8Rkzz");
    var $8zOmE;
    var $8wifS;
    var $l6YPM;
    const $2deb009ebf7ebceb$var$FilterListFooter = ({ isPanelToggleChecked: isPanelToggleChecked, showLink: showLink, showPanelToggle: showPanelToggle, useHrefForUrl: useHrefForUrl, url: url, label: label, toggleLabel: toggleLabel, linkTitle: linkTitle, toggleRef: toggleRef, onTogglePanel: onTogglePanel, onLinkItemClick: onLinkItemClick })=>{
        const onToggleHandler = (_, analyticsEvent)=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent);
            onTogglePanel();
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (showPanelToggle || showLink && url && linkTitle) && (0, ($parcel$interopDefault($5uXOq))).createElement($2deb009ebf7ebceb$var$HorizontalSeparator, null), showPanelToggle && (0, ($parcel$interopDefault($5uXOq))).createElement($2deb009ebf7ebceb$var$PanelToggleContainer, {
            "data-testid": "filters.common.ui.list.footer.panel-toggle"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l6YPM")).default), {
            label: toggleLabel || label,
            panelType: label,
            isChecked: isPanelToggleChecked,
            toggleRef: toggleRef,
            onToggle: onToggleHandler
        })), showLink && url && linkTitle && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8wifS")).default), {
            url: url,
            linkTitle: linkTitle,
            onClick: onLinkItemClick,
            useHref: useHrefForUrl
        }));
    };
    $2deb009ebf7ebceb$var$FilterListFooter.defaultProps = {
        url: undefined,
        linkTitle: undefined,
        showPanel: false,
        showLink: false,
        toggleRef: (0, ($parcel$interopDefault($8Rkzz)))
    };
    var $2deb009ebf7ebceb$export$2e2bcd8739ae039 = $2deb009ebf7ebceb$var$FilterListFooter;
    const $2deb009ebf7ebceb$var$HorizontalSeparator = (0, $5uXOq.forwardRef)(({ as: C = "hr", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19itglyw _4t3iv77o _bfhkyucn _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                __cmplp.className
            ])
        });
    });
    const $2deb009ebf7ebceb$var$PanelToggleContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt4wux3 _1e0c1txw _2lx21bp4",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("8wifS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8743d62747e29a3c$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $6B7KL;
    var $8oe80;
    var $8zOmE;
    var $lVJAU;
    const $8743d62747e29a3c$var$DropdownItem = (0, (0, parcelRequire("8oe80")).default)('dropdownItem', {
        onClick: 'clicked'
    })((0, (0, parcelRequire("6B7KL")).default));
    const $8743d62747e29a3c$var$linkWrapperStyles = null;
    const $8743d62747e29a3c$export$532cb6865ebe8946 = ({ url: url, linkTitle: linkTitle, onClick: onClick, useHref: useHref = false })=>{
        const { push: push } = (0, (0, parcelRequire("lVJAU")).useRouterActions)();
        const onDropdownClick = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'clickLinkFromFilters');
            onClick && onClick();
            if (!useHref) push(url);
        }, [
            useHref,
            onClick,
            push,
            url
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            role: "menu",
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c116y _4cvr1h6o _1bsb1osq _n3td1b66 _n3ag1osq _1i3qd8e8 _hjpp1osq _c24d81pi"
            ])
        }, useHref ? (0, ($parcel$interopDefault($5uXOq))).createElement($8743d62747e29a3c$var$DropdownItem, {
            href: url,
            onClick: onDropdownClick
        }, linkTitle) : (0, ($parcel$interopDefault($5uXOq))).createElement($8743d62747e29a3c$var$DropdownItem, {
            onClick: onDropdownClick
        }, linkTitle));
    };
    var $8743d62747e29a3c$export$2e2bcd8739ae039 = $8743d62747e29a3c$export$532cb6865ebe8946;
});
parcelRegister("6B7KL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9ff85f737833a5bc$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5JjdN;
    var $kJpBP;
    var $1aogK;
    var $3Z96c;
    var $VSDnB;
    var $l7Q0F;
    const $9ff85f737833a5bc$var$DropdownMenuItem = (0, $5uXOq.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, interactionName: interactionName, ...rest }, ref)=>{
        const itemRef = (0, (0, parcelRequire("l7Q0F")).default)();
        const handleItemClick = (0, $5uXOq.useCallback)((event)=>{
            if (returnFocusRef?.current) returnFocusRef.current.focus();
            if (onClick) onClick(event);
        }, [
            onClick,
            returnFocusRef
        ]);
        if (component) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1aogK")).default), {
            component: component,
            description: description,
            iconAfter: elemAfter,
            iconBefore: elemBefore,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: handleItemClick,
            ref: (0, (0, parcelRequire("5JjdN")).default)([
                ref,
                itemRef
            ]),
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            href: href,
            target: target,
            rel: rel,
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest
        }, children);
        else if (href) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Z96c")).default), {
            description: description,
            href: href,
            iconAfter: elemAfter,
            iconBefore: elemBefore,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: handleItemClick,
            ref: (0, (0, parcelRequire("5JjdN")).default)([
                ref,
                itemRef
            ]),
            rel: rel,
            role: "menuitem",
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            target: target,
            testId: testId,
            UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest
        }, children);
        else return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
            description: description,
            iconAfter: elemAfter,
            iconBefore: elemBefore,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: handleItemClick,
            ref: (0, (0, parcelRequire("5JjdN")).default)([
                ref,
                itemRef
            ]),
            role: "menuitem",
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            target: target,
            rel: rel,
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest
        }, children);
    });
    var $9ff85f737833a5bc$export$2e2bcd8739ae039 = $9ff85f737833a5bc$var$DropdownMenuItem;
});
parcelRegister("l6YPM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4ad247e508ffc141$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $basmW = parcelRequire("basmW");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $lj8SI;
    var $dTlW6;
    var $8oe80;
    var $ousew;
    var $8RXs9;
    var $3XFdo;
    var $gCuaO;
    const $4ad247e508ffc141$var$TOGGLE_CHECKBOX_ID = 'filters.common.ui.list.panel-toggle.toggle-checkbox';
    const $4ad247e508ffc141$var$TOGGLE_HINT_ID = 'filters.common.ui.list.panel-toggle.toggle-hint';
    const $4ad247e508ffc141$var$PanelToggle = (props)=>{
        const { isChecked: isChecked, panelType: panelType, onToggle: onToggle, ariaLabel: ariaLabel, intl: { formatMessage: formatMessage }, toggleRef: toggleRef = null, label: label } = props;
        const panelToggleKeyboardShortcut = (0, (0, parcelRequire("3XFdo")).getKeyboardShortcutForPanel)(panelType);
        const toggleLabel = label || formatMessage((0, (0, parcelRequire("gCuaO")).default).toggleLabel, {
            panelType: panelType
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($4ad247e508ffc141$var$PanelToggleContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement($4ad247e508ffc141$var$PanelToggleControl, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dTlW6")).default), {
            label: ariaLabel,
            id: $4ad247e508ffc141$var$TOGGLE_CHECKBOX_ID,
            ref: toggleRef,
            onChange: onToggle,
            isChecked: isChecked,
            testId: "filters.common.ui.list.panel-toggle.panel-toggle",
            descriptionId: $4ad247e508ffc141$var$TOGGLE_HINT_ID
        })), (0, ($parcel$interopDefault($5uXOq))).createElement($4ad247e508ffc141$var$PanelToggleLabel, {
            htmlFor: $4ad247e508ffc141$var$TOGGLE_CHECKBOX_ID
        }, toggleLabel)), panelToggleKeyboardShortcut && (0, ($parcel$interopDefault($5uXOq))).createElement($4ad247e508ffc141$var$PanelToggleHint, {
            id: $4ad247e508ffc141$var$TOGGLE_HINT_ID
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
            ...(0, (0, parcelRequire("gCuaO")).default).toggleHint,
            values: {
                kbd: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), null, chunks),
                key: panelToggleKeyboardShortcut
            }
        })));
    };
    $4ad247e508ffc141$var$PanelToggle.defaultProps = {
        isChecked: false,
        panelType: '',
        onToggle: (0, ($parcel$interopDefault($8Rkzz)))
    };
    var $4ad247e508ffc141$export$2e2bcd8739ae039 = (0, ($parcel$interopDefault($basmW)))((0, (0, parcelRequire("8RXs9")).default), (0, $5uXOq.memo), (0, (0, parcelRequire("8oe80")).default)('filterPanelToggle', {
        onToggle: 'toggled'
    }))($4ad247e508ffc141$var$PanelToggle);
    const $4ad247e508ffc141$var$PanelToggleContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c116y _4cvr1h6o _1bsb1osq",
                __cmplp.className
            ])
        });
    });
    const $4ad247e508ffc141$var$PanelToggleControl = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlidpf _1o9zidpf _i0dl1wug",
                __cmplp.className
            ])
        });
    });
    const $4ad247e508ffc141$var$PanelToggleLabel = (0, $5uXOq.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n _1o9zkb7n _i0dl1wug _18u0v77o _1reo15vq _1bto1l2s",
                __cmplp.className
            ])
        });
    });
    const $4ad247e508ffc141$var$PanelToggleHint = (0, $5uXOq.forwardRef)(({ as: C = "small", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1wmz _o5721q9c _11c8qk37 _19pkidpf _19bv12x7",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("dTlW6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3db77843cf29c460$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6QvkM;
    var $eGmKJ;
    var $9KnKW;
    var $7fA4P;
    var $aFYTH;
    var $lahQ6;
    var $hzG2v;
    const $3db77843cf29c460$var$noop = (0, (0, parcelRequire("eGmKJ")).default);
    const $3db77843cf29c460$var$analyticsAttributes = {
        componentName: 'toggle',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $3db77843cf29c460$var$iconSizeMap = {
        regular: 'small',
        large: 'medium'
    };
    const $3db77843cf29c460$var$Toggle = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)((props, ref)=>{
        const { defaultChecked: defaultChecked = false, isDisabled: isDisabled = false, onBlur: providedOnBlur = $3db77843cf29c460$var$noop, onChange: providedChange = $3db77843cf29c460$var$noop, onFocus: providedFocus = $3db77843cf29c460$var$noop, size: size = 'regular', name: name = '', value: value = '', isChecked: isChecked, analyticsContext: analyticsContext, id: id, testId: testId, label: label, descriptionId: descriptionId } = props;
        const isControlled = typeof isChecked === 'undefined';
        const [checked, setChecked] = (0, $5uXOq.useState)(defaultChecked);
        const handleBlur = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: providedOnBlur,
            action: 'blur',
            analyticsData: analyticsContext,
            ...$3db77843cf29c460$var$analyticsAttributes
        });
        const handleFocus = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: providedFocus,
            action: 'focus',
            analyticsData: analyticsContext,
            ...$3db77843cf29c460$var$analyticsAttributes
        });
        const handleChange = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (event, analyticsEvent)=>{
                if (isControlled) setChecked((checked)=>!checked);
                return providedChange(event, analyticsEvent);
            },
            action: 'change',
            analyticsData: analyticsContext,
            ...$3db77843cf29c460$var$analyticsAttributes
        });
        const shouldChecked = isControlled ? checked : isChecked;
        const controlProps = {
            'data-checked': shouldChecked ? shouldChecked : undefined,
            'data-disabled': isDisabled ? isDisabled : undefined,
            'data-size': size,
            'data-testid': testId ? testId : undefined
        };
        const toggleStyles = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("hzG2v")).getStyles)(size), [
            size
        ]);
        const legacyIconSize = $3db77843cf29c460$var$iconSizeMap[size];
        const labelId = (0, (0, parcelRequire("9KnKW")).useId)();
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("label", {
            ...controlProps,
            css: toggleStyles
        }, label ? (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: labelId,
            hidden: true
        }, label) : null, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            ref: ref,
            checked: shouldChecked,
            disabled: isDisabled,
            id: id,
            name: name,
            onBlur: handleBlur,
            onChange: handleChange,
            onFocus: handleFocus,
            type: "checkbox",
            value: value,
            "data-testid": testId && `${testId}--input`,
            "aria-labelledby": label ? labelId : undefined,
            "aria-describedby": descriptionId
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("lahQ6")).default), {
            size: size,
            isHidden: !shouldChecked,
            position: "left"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("7fA4P"))))), {
            label: "",
            color: "currentColor",
            LEGACY_size: legacyIconSize,
            testId: testId && `${testId}--toggle-check-icon`
        })), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("lahQ6")).default), {
            size: size,
            isHidden: shouldChecked,
            position: "right"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("aFYTH"))))), {
            label: "",
            color: "currentColor",
            LEGACY_size: legacyIconSize,
            testId: testId && `${testId}--toggle-cross-icon`
        }))));
    }));
    $3db77843cf29c460$var$Toggle.displayName = 'Toggle';
    var $3db77843cf29c460$export$2e2bcd8739ae039 = $3db77843cf29c460$var$Toggle;
});
parcelRegister("7fA4P", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $5475eb3f94e0b044$var$_react = $5475eb3f94e0b044$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $5475eb3f94e0b044$var$_checkMark = $5475eb3f94e0b044$var$_interopRequireDefault((parcelRequire("f22iM")));
    var $5475eb3f94e0b044$var$_done = $5475eb3f94e0b044$var$_interopRequireDefault((parcelRequire("4DXCl")));
    function $5475eb3f94e0b044$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $5475eb3f94e0b044$var$CheckMarkIcon = (props)=>$5475eb3f94e0b044$var$_react.default.createElement($5475eb3f94e0b044$var$_checkMark.default, Object.assign({
            LEGACY_fallbackIcon: $5475eb3f94e0b044$var$_done.default
        }, props));
    $5475eb3f94e0b044$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
    var $5475eb3f94e0b044$var$_default = module.exports.default = $5475eb3f94e0b044$var$CheckMarkIcon;
});
parcelRegister("f22iM", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $af18d40ba5b744b4$var$_react = $af18d40ba5b744b4$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $af18d40ba5b744b4$var$_UNSAFE_baseNew = $af18d40ba5b744b4$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $af18d40ba5b744b4$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $af18d40ba5b744b4$var$CheckMarkIcon = (props)=>$af18d40ba5b744b4$var$_react.default.createElement($af18d40ba5b744b4$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 6 2.75 3.5 6.25-7"/>`,
            type: 'utility'
        }, props));
    $af18d40ba5b744b4$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
    var $af18d40ba5b744b4$var$_default = module.exports.default = $af18d40ba5b744b4$var$CheckMarkIcon;
});
parcelRegister("4DXCl", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $36190cbd288fec69$var$_react = $36190cbd288fec69$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $36190cbd288fec69$var$_checkMark = $36190cbd288fec69$var$_interopRequireDefault((parcelRequire("bjo8S")));
    function $36190cbd288fec69$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $36190cbd288fec69$var$EditorDoneIcon = (props)=>$36190cbd288fec69$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
        }, props, {
            newIcon: $36190cbd288fec69$var$_checkMark.default
        }));
    $36190cbd288fec69$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
    var $36190cbd288fec69$var$_default = module.exports.default = $36190cbd288fec69$var$EditorDoneIcon;
});
parcelRegister("bjo8S", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $83c43234bc70a485$var$_react = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $83c43234bc70a485$var$_UNSAFE_baseNew = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $83c43234bc70a485$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $83c43234bc70a485$var$CheckMarkIcon = (props)=>$83c43234bc70a485$var$_react.default.createElement($83c43234bc70a485$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 8 4.25 5.25 8.75-10.5"/>`
        }, props));
    $83c43234bc70a485$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
    var $83c43234bc70a485$var$_default = module.exports.default = $83c43234bc70a485$var$CheckMarkIcon;
});
parcelRegister("aFYTH", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $7c5cf8a572bea882$var$_react = $7c5cf8a572bea882$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7c5cf8a572bea882$var$_cross = $7c5cf8a572bea882$var$_interopRequireDefault((parcelRequire("bjGSs")));
    var $7c5cf8a572bea882$var$_close = $7c5cf8a572bea882$var$_interopRequireDefault((parcelRequire("2C7j9")));
    function $7c5cf8a572bea882$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $7c5cf8a572bea882$var$CrossIcon = (props)=>$7c5cf8a572bea882$var$_react.default.createElement($7c5cf8a572bea882$var$_cross.default, Object.assign({
            LEGACY_fallbackIcon: $7c5cf8a572bea882$var$_close.default
        }, props));
    $7c5cf8a572bea882$var$CrossIcon.Name = 'CrossIconMigration';
    var $7c5cf8a572bea882$var$_default = module.exports.default = $7c5cf8a572bea882$var$CrossIcon;
});
parcelRegister("2C7j9", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $1e74cc92a54dd799$var$_react = $1e74cc92a54dd799$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $1e74cc92a54dd799$var$_close = $1e74cc92a54dd799$var$_interopRequireDefault((parcelRequire("i28qQ")));
    function $1e74cc92a54dd799$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $1e74cc92a54dd799$var$EditorCloseIcon = (props)=>$1e74cc92a54dd799$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
        }, props, {
            newIcon: $1e74cc92a54dd799$var$_close.default
        }));
    $1e74cc92a54dd799$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
    var $1e74cc92a54dd799$var$_default = module.exports.default = $1e74cc92a54dd799$var$EditorCloseIcon;
});
parcelRegister("lahQ6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ca1cdaa1eb34599d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $VSDnB;
    var $dC5iT;
    var $8CUq3;
    const $ca1cdaa1eb34599d$var$iconContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'opacity 0.2s ease',
        position: 'absolute',
        insetBlockStart: 'space.025'
    });
    const $ca1cdaa1eb34599d$var$iconContainerRegularStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '16px',
        height: '16px'
    });
    const $ca1cdaa1eb34599d$var$iconContainerLargeStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '20px',
        height: '20px'
    });
    const $ca1cdaa1eb34599d$var$hiddenStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        opacity: 0
    });
    const $ca1cdaa1eb34599d$var$leftStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        insetInlineStart: '3px'
    });
    const $ca1cdaa1eb34599d$var$rightStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        insetInlineEnd: '3px'
    });
    const $ca1cdaa1eb34599d$var$IconContainer = ({ children: children, size: size, isHidden: isHidden, position: position })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            as: "span",
            xcss: [
                $ca1cdaa1eb34599d$var$iconContainerStyles,
                isHidden && (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') && $ca1cdaa1eb34599d$var$hiddenStyles,
                size === 'regular' && $ca1cdaa1eb34599d$var$iconContainerRegularStyles,
                size === 'large' && $ca1cdaa1eb34599d$var$iconContainerLargeStyles,
                position === 'left' && $ca1cdaa1eb34599d$var$leftStyles,
                position === 'right' && $ca1cdaa1eb34599d$var$rightStyles
            ]
        }, children);
    };
    var $ca1cdaa1eb34599d$export$2e2bcd8739ae039 = $ca1cdaa1eb34599d$var$IconContainer;
});
parcelRegister("hzG2v", function(module, exports) {
    $parcel$export(module.exports, "getStyles", ()=>$3af6a5b9114f4fd0$export$ffd58b7f6f099a57);
    var $f8Sb3;
    var $VSDnB;
    var $k5uoT;
    var $3VjLl;
    const $3af6a5b9114f4fd0$var$globalGridSize = (0, (0, parcelRequire("k5uoT")).gridSize)();
    const $3af6a5b9114f4fd0$var$dimensions = {
        regular: {
            height: $3af6a5b9114f4fd0$var$globalGridSize * 2,
            width: $3af6a5b9114f4fd0$var$globalGridSize * 4
        },
        large: {
            height: $3af6a5b9114f4fd0$var$globalGridSize * 2 + $3af6a5b9114f4fd0$var$globalGridSize / 2,
            width: $3af6a5b9114f4fd0$var$globalGridSize * 5
        }
    };
    const $3af6a5b9114f4fd0$var$getHeight = ({ size: size })=>$3af6a5b9114f4fd0$var$dimensions[size].height;
    const $3af6a5b9114f4fd0$var$getWidth = ({ size: size })=>$3af6a5b9114f4fd0$var$dimensions[size].width;
    const $3af6a5b9114f4fd0$var$borderWidth = 2;
    const $3af6a5b9114f4fd0$var$paddingUnitless = $3af6a5b9114f4fd0$var$globalGridSize / 4;
    const $3af6a5b9114f4fd0$var$transition = 'transform 0.2s ease';
    const $3af6a5b9114f4fd0$export$ffd58b7f6f099a57 = (size)=>{
        const colors = (0, (0, parcelRequire("3VjLl")).getColors)();
        return (0, (0, parcelRequire("f8Sb3")).css)({
            boxSizing: 'content-box',
            display: 'inline-block',
            padding: $3af6a5b9114f4fd0$var$borderWidth,
            margin: $3af6a5b9114f4fd0$var$borderWidth,
            backgroundClip: 'content-box',
            backgroundColor: colors.backgroundColorUnchecked,
            borderRadius: `${$3af6a5b9114f4fd0$var$getHeight({
                size: size
            })}px`,
            border: `${$3af6a5b9114f4fd0$var$borderWidth}px solid transparent`,
            height: `${$3af6a5b9114f4fd0$var$getHeight({
                size: size
            })}px`,
            position: 'relative',
            transition: `${$3af6a5b9114f4fd0$var$transition}`,
            width: `${$3af6a5b9114f4fd0$var$getWidth({
                size: size
            })}px`,
            '&[data-checked]': {
                backgroundColor: colors.backgroundColorChecked,
                color: colors.iconColorChecked
            },
            '&[data-disabled]:not([data-checked])': {
                backgroundColor: colors.backgroundColorUncheckedDisabled
            },
            '&[data-disabled][data-checked],&[data-disabled][data-checked]:hover': {
                backgroundColor: colors.backgroundColorCheckedDisabled
            },
            '&:focus-within': {
                border: `${$3af6a5b9114f4fd0$var$borderWidth}px solid ${colors.borderColorFocus}`
            },
            '&:hover': {
                backgroundColor: colors.backgroundColorUncheckedHover,
                cursor: 'pointer'
            },
            '&[data-disabled]:hover,&[data-disabled][data-checked]:hover,&[data-disabled]:not([data-checked]):hover': {
                cursor: 'not-allowed'
            },
            '&[data-checked]:hover': {
                backgroundColor: colors.backgroundColorCheckedHover
            },
            '&:not([data-checked]):hover': {
                backgroundColor: colors.backgroundColorUncheckedHover
            },
            '&[data-disabled]:not([data-checked]):hover': {
                backgroundColor: colors.backgroundColorCheckedDisabled
            },
            color: colors.iconColorUnchecked,
            '&[data-disabled], &[data-disabled][data-checked], &[data-disabled][data-checked]:hover': {
                color: colors.iconColorDisabled
            },
            'input[type="checkbox"]': {
                opacity: 0,
                margin: 0,
                padding: 0,
                border: 'none',
                '&:focus': {
                    outline: 'none !important'
                }
            },
            '::before': {
                backgroundColor: colors.handleBackgroundColor,
                borderRadius: "var(--ds-border-radius-circle, 50%)",
                content: '""',
                position: 'absolute',
                transform: 'initial',
                transition: $3af6a5b9114f4fd0$var$transition,
                insetBlockEnd: `${2 * $3af6a5b9114f4fd0$var$paddingUnitless}px`,
                height: `${$3af6a5b9114f4fd0$var$getHeight({
                    size: size
                }) - $3af6a5b9114f4fd0$var$paddingUnitless * 2}px`,
                width: `${$3af6a5b9114f4fd0$var$getHeight({
                    size: size
                }) - $3af6a5b9114f4fd0$var$paddingUnitless * 2}px`,
                insetInlineStart: `${2 * $3af6a5b9114f4fd0$var$paddingUnitless}px`
            },
            '&[data-checked]::before': {
                backgroundColor: colors.handleBackgroundColorChecked,
                transform: `translateX(${$3af6a5b9114f4fd0$var$getHeight({
                    size: size
                })}px)`
            },
            '&[data-disabled]::before': {
                backgroundColor: colors.handleBackgroundColorDisabled,
                zIndex: 1
            },
            ...size === 'large' && !(0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') && {
                '> span > span': {
                    height: '20px',
                    width: '20px'
                }
            },
            '@media screen and (forced-colors: active)': {
                '::before': {
                    filter: 'grayscale(100%) invert(1)'
                },
                '&:focus-within': {
                    outline: '1px solid'
                }
            }
        });
    };
});
parcelRegister("3VjLl", function(module, exports) {
    $parcel$export(module.exports, "getColors", ()=>$7761f9acd89472cc$export$6cee60e8aa85e528);
    const $7761f9acd89472cc$var$colorMap = {
        backgroundColorChecked: `var(--ds-background-success-bold, ${(0, $829f609a65d26a98$export$a49394138f7b8e85)})`,
        backgroundColorCheckedHover: `var(--ds-background-success-bold-hovered, ${(0, $829f609a65d26a98$export$6fa04827ac68a4fb)})`,
        backgroundColorCheckedDisabled: `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
        backgroundColorUnchecked: `var(--ds-background-neutral-bold, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`,
        backgroundColorUncheckedHover: `var(--ds-background-neutral-bold-hovered, ${(0, $829f609a65d26a98$export$eece5f492e429f08)})`,
        backgroundColorUncheckedDisabled: `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
        borderColorFocus: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
        iconColorChecked: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        iconColorDisabled: `var(--ds-icon-disabled, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`,
        iconColorUnchecked: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        handleBackgroundColor: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        handleBackgroundColorChecked: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        handleBackgroundColorDisabled: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`
    };
    const $7761f9acd89472cc$export$6cee60e8aa85e528 = ()=>$7761f9acd89472cc$var$colorMap;
});
parcelRegister("3XFdo", function(module, exports) {
    $parcel$export(module.exports, "getKeyboardShortcutForPanel", ()=>$5bd9980697730d58$export$fa36ece4b5d88abc);
    const $5bd9980697730d58$var$panelShortcuts = {
        Epic: (0, $570f28ac9bf58edd$export$9b094cdf6fd7589e),
        Version: (0, $570f28ac9bf58edd$export$6f416a1fb11a53d9)
    };
    const $5bd9980697730d58$export$fa36ece4b5d88abc = (panelType)=>$5bd9980697730d58$var$panelShortcuts[panelType];
});
const $570f28ac9bf58edd$export$a10c132b86ae798b = 'Epic';
const $570f28ac9bf58edd$export$41073ac826c57195 = 'Version';
const $570f28ac9bf58edd$export$9b094cdf6fd7589e = 'E';
const $570f28ac9bf58edd$export$6f416a1fb11a53d9 = 'V';
parcelRegister("gCuaO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2063ebcfe536a9b7$export$2e2bcd8739ae039);
    var $7VHMR;
    var $2063ebcfe536a9b7$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        toggleAccessibilityLabel: {
            "id": "software-filters.common.list.panel-toggle.toggle-accessibility-label",
            "defaultMessage": "Toggle panel"
        },
        toggleLabel: {
            "id": "software-filters.common.list.panel-toggle.toggle-label",
            "defaultMessage": "{panelType} panel"
        },
        toggleHint: {
            "id": "software-filters.common.list.panel-toggle.toggle-hint",
            "defaultMessage": "Press <kbd>{key}</kbd> to open and close"
        }
    });
});
parcelRegister("73s29", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6a49ecd68dc207cc$export$2e2bcd8739ae039);
    var $7VHMR;
    var $6a49ecd68dc207cc$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        placeholder: {
            "id": "software-filters.common.list.placeholder",
            "defaultMessage": "Search filters\u2026"
        },
        anounceMessage: {
            "id": "software-filters.common.list.anounce-message",
            "defaultMessage": "When selecting from the {field} filter, content in the backlog board will automatically update"
        },
        selectedItemsGroupLabel: {
            "id": "software-filters.common.list.selected-items-group-label",
            "defaultMessage": "Selected Items"
        }
    });
});
parcelRegister("d9hVL", function(module, exports) {
    $parcel$export(module.exports, "DefaultOptionLabel", ()=>$3a4e6a305ebc1d35$export$86f820b2f37564e5);
    $parcel$export(module.exports, "default", ()=>$3a4e6a305ebc1d35$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $3bDjY;
    var $gwIPs;
    const $3a4e6a305ebc1d35$export$86f820b2f37564e5 = ({ label: label, iconUrl: iconUrl })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, iconUrl !== undefined && (0, ($parcel$interopDefault($5uXOq))).createElement($3a4e6a305ebc1d35$var$Icon, {
            src: iconUrl,
            role: "presentation"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($3a4e6a305ebc1d35$var$SelectOptionLabel, null, label));
    const $3a4e6a305ebc1d35$var$ListFilterOption = ({ label: label, subLabel: subLabel, iconUrl: iconUrl, value: value, maxSelectionReachedTooltip: maxSelectionReachedTooltip, isDisabled: isDisabled, CustomOptionLabel: CustomOptionLabel })=>{
        const content = isDisabled && maxSelectionReachedTooltip ? maxSelectionReachedTooltip : label;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: content
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($3a4e6a305ebc1d35$var$SelectOptionWrapper, {
            "data-testid": "filters.common.ui.list.option"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(CustomOptionLabel, {
            label: label,
            value: value,
            iconUrl: iconUrl
        })), subLabel !== undefined && (0, ($parcel$interopDefault($5uXOq))).createElement($3a4e6a305ebc1d35$var$SelectOptionSubLabel, null, subLabel));
    };
    $3a4e6a305ebc1d35$var$ListFilterOption.defaultProps = {
        iconUrl: undefined,
        isDisabled: false
    };
    var $3a4e6a305ebc1d35$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($3a4e6a305ebc1d35$var$ListFilterOption);
    const $3a4e6a305ebc1d35$var$SelectOptionWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1y6m",
                __cmplp.className
            ])
        });
    });
    const $3a4e6a305ebc1d35$var$SelectOptionLabel = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1reo15vq _18m915vq _1bto1l2s _o5721q9c",
                __cmplp.className
            ])
        });
    });
    const $3a4e6a305ebc1d35$var$SelectOptionSubLabel = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _11c81vlj _syaz1e9r",
                __cmplp.className
            ])
        });
    });
    const $3a4e6a305ebc1d35$var$Icon = (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_zb0g5d": (0, (0, parcelRequire("lD23V")).default)((0, (0, parcelRequire("gwIPs")).layout).issueIconSize, "px")
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _1bsbwrp2 _4t3iwrp2 _u5f3u2gc",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("4Mv0u", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bd436e148f99ab3e$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $16T6Y;
    var $fVnbM;
    var $6Ingq;
    var $ebd3R;
    var $hORKG;
    var $3dGN0;
    var $dC5iT;
    var $8CUq3;
    var $3bDjY;
    var $4R6GH;
    var $7mPT9;
    var $iXVV6;
    var $dCm1o;
    const $bd436e148f99ab3e$var$FilterListTrigger = (0, $5uXOq.forwardRef)(({ isOpen: isOpen, isNested: isNested, isDisabled: isDisabled, label: label, buttonType: buttonType, selectedCount: selectedCount, onMouseEnter: onMouseEnter, shouldReturnFocus: shouldReturnFocus, ...popupProps }, ref)=>{
        const testId = `filters.common.ui.list.${label.toLowerCase().replace(/ /g, '-')}-filter`;
        const primaryColor = isOpen ? "var(--ds-icon-selected, #0052CC)" : "var(--ds-icon, #44546F)";
        const IconComponent = isNested ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("3dGN0"))))), {
            label: "",
            color: primaryColor,
            LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("ebd3R"))))),
            LEGACY_primaryColor: primaryColor
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("hORKG"))))), {
            label: "",
            color: primaryColor,
            LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("6Ingq"))))),
            LEGACY_primaryColor: primaryColor
        });
        const inputRef = (0, $5uXOq.useRef)();
        const isMounted = (0, $5uXOq.useRef)(false);
        (0, $5uXOq.useEffect)(()=>{
            if (shouldReturnFocus && buttonType === 'QuickFilters' && isMounted.current) inputRef?.current?.focus();
            else isMounted.current = true;
        }, [
            shouldReturnFocus,
            buttonType
        ]);
        const conditionalRef = buttonType === 'QuickFilters' ? (0, (0, parcelRequire("7mPT9")).mergeRefs)(ref, inputRef) : ref;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                !isNested && $bd436e148f99ab3e$var$containerStyles
            ]
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: "dropDownMenu",
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            attributes: {
                filterType: label
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($bd436e148f99ab3e$var$StyledButton, {
            ...popupProps,
            ref: conditionalRef,
            isNested: isNested,
            isSelected: isOpen || (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && selectedCount > 0,
            shouldFitContainer: isNested,
            appearance: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? 'default' : 'subtle',
            onMouseEnter: onMouseEnter,
            iconAfter: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && selectedCount > 0 ? undefined : IconComponent,
            ...(0, (0, parcelRequire("4R6GH")).fg)('allow_jplat_filter_list_to_be_disabled') && {
                isDisabled: isDisabled || false
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: label,
            hideTooltipOnClick: true,
            tag: "span"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($bd436e148f99ab3e$var$TriggerContainer, {
            "data-testid": testId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($bd436e148f99ab3e$var$TriggerLabel, null, label), selectedCount > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement($bd436e148f99ab3e$var$CountWrapper, {
            isNested: isNested,
            "data-testid": `${testId}-badge`
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("16T6Y")).default), {
            appearance: "primary"
        }, selectedCount)))))));
    });
    var $bd436e148f99ab3e$export$2e2bcd8739ae039 = $bd436e148f99ab3e$var$FilterListTrigger;
    const $bd436e148f99ab3e$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingLeft: 'space.050',
        paddingRight: 'space.050'
    });
    const $bd436e148f99ab3e$var$StyledButton = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("fVnbM")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "",
                __cmplp.isNested && "_2rkogrf3 _u5f3ns44 _1bg412gs",
                __cmplp.className
            ])
        });
    });
    const $bd436e148f99ab3e$var$CountWrapper = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isNested: isNested, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1o8l",
                __cmplp.isNested ? "_18u01wug _19bvftgi" : "_19bv1y44",
                __cmplp.className
            ])
        });
    });
    const $bd436e148f99ab3e$var$TriggerContainer = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw",
                __cmplp.className
            ])
        });
    });
    const $bd436e148f99ab3e$var$TriggerLabel = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_p12f68cl _o5721q9c _1reo15vq _18m915vq _1bto1l2s",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("16T6Y", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fe7856b71523badd$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $VSDnB;
    var $dC5iT;
    var $cgL5K;
    var $8CUq3;
    var $ehtcU;
    function $fe7856b71523badd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $fe7856b71523badd$var$boxStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderRadius: 'border.radius.200',
        display: 'inline-flex',
        blockSize: 'min-content',
        flexShrink: 0
    });
    const $fe7856b71523badd$var$neutral300 = '#DDDEE1';
    const $fe7856b71523badd$var$red300 = '#FD9891';
    const $fe7856b71523badd$var$blue300 = '#8FB8F6';
    const $fe7856b71523badd$var$neutral1000 = '#292A2E';
    const $fe7856b71523badd$var$styles = {
        root: {
            name: "85bcg3",
            styles: "display:inline-flex;box-sizing:border-box;min-width:var(--ds-space-300, 24px);justify-content:center;flex-shrink:0;block-size:min-content;border-radius:var(--ds-border-radius-050, 2px);padding-inline:var(--ds-space-050, 4px)"
        },
        added: {
            name: "4x7cmh",
            styles: "background-color:var(--ds-background-success, #DCFFF1);color:var(--ds-text, #172B4D)"
        },
        default: (0, (0, parcelRequire("f8Sb3")).css)({
            backgroundColor: $fe7856b71523badd$var$neutral300,
            color: $fe7856b71523badd$var$neutral1000
        }),
        important: (0, (0, parcelRequire("f8Sb3")).css)({
            backgroundColor: $fe7856b71523badd$var$red300,
            color: $fe7856b71523badd$var$neutral1000
        }),
        primary: (0, (0, parcelRequire("f8Sb3")).css)({
            backgroundColor: $fe7856b71523badd$var$blue300,
            color: $fe7856b71523badd$var$neutral1000
        }),
        primaryInverted: {
            name: "1425qmy",
            styles: "background-color:var(--ds-surface, #FFFFFF);color:var(--ds-text-brand, #0C66E4)"
        },
        removed: {
            name: "10hiq01",
            styles: "background-color:var(--ds-background-danger, #FFECEB);color:var(--ds-text, #172B4D)"
        }
    };
    const $fe7856b71523badd$var$Badge = (0, $5uXOq.memo)(function Badge({ appearance: appearance = 'default', children: children = 0, max: max = 99, style: style, testId: testId }) {
        if ((0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh')) return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            "data-testid": testId,
            css: [
                $fe7856b71523badd$var$styles.root,
                $fe7856b71523badd$var$styles[appearance]
            ],
            style: {
                background: style?.backgroundColor,
                color: style?.color
            }
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cgL5K")).default), {
            size: "small",
            align: "center",
            color: "inherit"
        }, typeof children === 'number' && max ? (0, (0, parcelRequire("ehtcU")).formatValue)(children, max) : children));
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            testId: testId,
            as: "span",
            backgroundColor: $fe7856b71523badd$var$backgroundColors[appearance],
            xcss: $fe7856b71523badd$var$boxStyles,
            style: {
                background: style?.backgroundColor,
                color: style?.color
            },
            paddingInline: "space.075"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cgL5K")).default), {
            size: "UNSAFE_small",
            align: "center",
            color: style?.color ? 'inherit' : $fe7856b71523badd$var$textColors[appearance]
        }, typeof children === 'number' && max ? (0, (0, parcelRequire("ehtcU")).formatValue)(children, max) : children));
    });
    $fe7856b71523badd$var$Badge.displayName = 'Badge';
    var $fe7856b71523badd$export$2e2bcd8739ae039 = $fe7856b71523badd$var$Badge;
    const $fe7856b71523badd$var$backgroundColors = {
        added: 'color.background.success',
        default: 'color.background.neutral',
        important: 'color.background.danger.bold',
        primary: 'color.background.brand.bold',
        primaryInverted: 'elevation.surface',
        removed: 'color.background.danger'
    };
    const $fe7856b71523badd$var$textColors = {
        added: 'color.text.success',
        default: 'color.text',
        important: 'color.text.inverse',
        primary: 'color.text.inverse',
        primaryInverted: 'color.text.brand',
        removed: 'color.text.danger'
    };
});
parcelRegister("ehtcU", function(module, exports) {
    $parcel$export(module.exports, "formatValue", ()=>$24d41a560822020b$export$7c4d25c0c3217d8c);
    function $24d41a560822020b$var$getSafeValue(value = 0) {
        const numericValue = +value;
        if (numericValue < 0) return 0;
        return value;
    }
    function $24d41a560822020b$export$7c4d25c0c3217d8c(value, max) {
        const safeValue = $24d41a560822020b$var$getSafeValue(value);
        const safeMax = $24d41a560822020b$var$getSafeValue(max);
        if (safeMax && safeMax < safeValue) return `${safeMax}+`;
        if (safeValue === Infinity) return "\u221E";
        return safeValue.toString();
    }
});
parcelRegister("7mPT9", function(module, exports) {
    $parcel$export(module.exports, "mergeRefs", ()=>$d1da29f25d5b5e0a$export$c9058316764c140e);
    $parcel$export(module.exports, "default", ()=>$d1da29f25d5b5e0a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $d1da29f25d5b5e0a$export$c9058316764c140e(...refs) {
        return (value)=>{
            refs.forEach((ref)=>{
                if (typeof ref === 'function') ref(value);
                else if (ref != null) ref.current = value;
            });
        };
    }
    function $d1da29f25d5b5e0a$export$2e2bcd8739ae039(...refs) {
        return (0, $5uXOq.useMemo)(()=>$d1da29f25d5b5e0a$export$c9058316764c140e(...refs), refs);
    }
});
parcelRegister("ijTad", function(module, exports) {
    $parcel$export(module.exports, "getOptionsFromProps", ()=>$a5603fd49981b3bf$export$ecd68164c475a713);
    $parcel$export(module.exports, "getSelectedOptionsFromProps", ()=>$a5603fd49981b3bf$export$94d5b7a6f69b418);
    $parcel$export(module.exports, "getSearchableProps", ()=>$a5603fd49981b3bf$export$62d9d395b3dd2ae8);
    $parcel$export(module.exports, "useGetOptionsWithSelectedOptionGroup", ()=>$a5603fd49981b3bf$export$2729924204b6e540);
    var $5uXOq = parcelRequire("5uXOq");
    var $5JAlL;
    var $6s1PB;
    var $4R6GH;
    var $koVbs;
    var $8C9C3;
    var $73s29;
    const $a5603fd49981b3bf$var$isValueGroupOption = (value)=>'options' in value;
    const $a5603fd49981b3bf$export$67e7296d7bc3550c = (values)=>values.every((value)=>!$a5603fd49981b3bf$var$isValueGroupOption(value));
    const $a5603fd49981b3bf$export$ecd68164c475a713 = ({ values: values, menuGroupTitle: menuGroupTitle })=>{
        if (menuGroupTitle && $a5603fd49981b3bf$export$67e7296d7bc3550c(values)) return [
            {
                label: menuGroupTitle,
                options: values
            }
        ];
        return values;
    };
    const $a5603fd49981b3bf$export$94d5b7a6f69b418 = ({ values: values, selectedValueIds: selectedValueIds })=>{
        const selectedIdLookup = selectedValueIds.reduce((acc, cur)=>{
            acc.add(cur);
            return acc;
        }, new Set());
        const valuesToLook = values.flatMap((value)=>$a5603fd49981b3bf$var$isValueGroupOption(value) ? value.options : [
                value
            ]);
        const selectedOptions = valuesToLook.filter(({ value: value })=>selectedIdLookup.has(value));
        return {
            selectedIdLookup: selectedIdLookup,
            selectedOptions: selectedOptions
        };
    };
    const $a5603fd49981b3bf$export$62d9d395b3dd2ae8 = ({ optionsCount: optionsCount, isAsyncSearch: isAsyncSearch, defaultSearchThreshold: defaultSearchThreshold = (0, (0, parcelRequire("8C9C3")).FILTER_SEARCH_THRESHOLD), isNested: isNested })=>{
        const searchThreshold = isAsyncSearch ? -1 : defaultSearchThreshold;
        const isSearchable = optionsCount > searchThreshold;
        const filterMenuMinWidth = isNested ? (0, (0, parcelRequire("8C9C3")).FILTER_MENU_MIN_WIDTH_ON_NESTED) : (0, (0, parcelRequire("8C9C3")).FILTER_MENU_MIN_WIDTH);
        const maxMenuWidth = (0, (0, parcelRequire("8C9C3")).FILTER_MENU_MAX_WIDTH);
        const minMenuWidth = isSearchable ? maxMenuWidth : filterMenuMinWidth;
        const filter = (0, (0, parcelRequire("5JAlL")).createFilter)({
            stringify: (option)=>option.label
        });
        const filterOption = isAsyncSearch ? undefined : filter;
        return {
            minMenuWidth: minMenuWidth,
            maxMenuWidth: maxMenuWidth,
            searchThreshold: searchThreshold,
            filterOption: filterOption
        };
    };
    const $a5603fd49981b3bf$export$2729924204b6e540 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [optionsWithSelectedSection, setOptionsWithSelectedSection] = (0, $5uXOq.useState)(null);
        const shouldTrackExperimentEvents = (0, $5uXOq.useRef)(false);
        const updateSelectedOptionGroup = ({ isOpen: isOpen, options: options, selectedValueIds: selectedValueIds })=>{
            if ((0, (0, parcelRequire("4R6GH")).fg)('jira-make-it-easier-to-deselect-filter-items-gate')) {
                if (isOpen === true && $a5603fd49981b3bf$export$67e7296d7bc3550c(options) && (options.length > (0, (0, parcelRequire("8C9C3")).EXPERIMENT_MAKE_IT_EASIER_TO_DESELECT_FILTER_ITEMS_THRESHOLD) || optionsWithSelectedSection !== null)) {
                    if ((0, (0, parcelRequire("6s1PB")).expVal)('jira-make-it-easier-to-deselect-filter-items', 'isEnabled', false)) {
                        if (selectedValueIds.length === 0 || options.length <= (0, (0, parcelRequire("8C9C3")).EXPERIMENT_MAKE_IT_EASIER_TO_DESELECT_FILTER_ITEMS_THRESHOLD)) {
                            setOptionsWithSelectedSection(null);
                            shouldTrackExperimentEvents.current = false;
                        } else {
                            const selected = options.filter((option)=>selectedValueIds.includes(option.value));
                            const unselected = options.filter((option)=>!selectedValueIds.includes(option.value));
                            const optionsWithSelectedOptionGroup = [
                                {
                                    label: formatMessage((0, (0, parcelRequire("73s29")).default).selectedItemsGroupLabel),
                                    options: selected
                                },
                                {
                                    label: '',
                                    options: unselected
                                }
                            ];
                            setOptionsWithSelectedSection(optionsWithSelectedOptionGroup);
                            shouldTrackExperimentEvents.current = true;
                        }
                    } else if (selectedValueIds.length === 0 || options.length <= (0, (0, parcelRequire("8C9C3")).EXPERIMENT_MAKE_IT_EASIER_TO_DESELECT_FILTER_ITEMS_THRESHOLD)) shouldTrackExperimentEvents.current = false;
                    else shouldTrackExperimentEvents.current = true;
                }
            }
        };
        return {
            optionsWithSelectedSection: optionsWithSelectedSection,
            updateSelectedOptionGroup: updateSelectedOptionGroup,
            shouldTrackExperimentEvents: shouldTrackExperimentEvents
        };
    };
});
parcelRegister("78uGw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cad440f119fd51b3$export$2e2bcd8739ae039);
    var $7VHMR;
    var $cad440f119fd51b3$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        label: {
            "id": "software-filters.filters.custom.label",
            "defaultMessage": "Custom filters"
        },
        labelCmp: {
            "id": "software-filters.filters.custom.label-cmp",
            "defaultMessage": "Quick filters"
        },
        manageLinkTitle: {
            "id": "software-filters.filters.custom.manage-link-title",
            "defaultMessage": "Manage custom filters"
        },
        manageLinkTitleCmp: {
            "id": "software-filters.filters.custom.manage-link-title-cmp",
            "defaultMessage": "Manage quick filters"
        },
        maxSelectionReachedTooltip: {
            "id": "software-filters.filters.custom.max-selection-reached-tooltip",
            "defaultMessage": "You can't select more than {maxSelectionAllowed} custom filters"
        },
        toggleLabelCmp: {
            "id": "software-filters.filters.custom.toggle-label-cmp",
            "defaultMessage": "Show quick filters"
        }
    });
});
parcelRegister("kbfkr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cb7c802f0a442491$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lFKmC = parcelRequire("lFKmC");
    var $9XE6b = parcelRequire("9XE6b");
    var $hGgHi = parcelRequire("hGgHi");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $hqTkp = parcelRequire("hqTkp");
    var $gKZoD;
    var $eWXbg;
    var $tvuR8;
    var $dC5iT;
    var $eZJjh;
    var $kY99m;
    var $dqoiX;
    var $5p1kJ;
    var $5rVQI;
    var $eG9rp;
    var $879xD;
    var $joX8T;
    var $6s1PB;
    var $4R6GH;
    var $6CjZR;
    var $1beWO;
    var $3oCwY;
    var $7j6PN;
    var $8bg0N;
    var $kgqZV;
    var $efv79;
    var $jKPI1;
    var $hHL6f;
    var $2fsdj;
    var $bLWKp;
    var $hpA0D;
    var $g65Ek;
    var $jdA4J;
    var $cSFZv;
    var $3f9TT;
    var $aMFc7;
    var $fJnmW;
    var $koVbs;
    var $cTi8P;
    var $2m0b6;
    var $gtgKk;
    var $8vjSE;
    var $2WENx;
    var $2xSAL;
    var $g5X3G;
    var $fUHZ2;
    var $90yGq;
    var $dCm1o;
    var $cM4EP;
    var $2FvdY;
    var $kH9yv;
    var $bBMqL;
    var $l38sT;
    var $649U3;
    const $cb7c802f0a442491$var$EMPTY_ARRAY = [];
    const $cb7c802f0a442491$var$MIN_VISIBLE_USERS = 2;
    const $cb7c802f0a442491$var$USER_AVATAR_WIDTH = 30;
    const $cb7c802f0a442491$var$DEFAULT_VISIBLE_USERS = 7;
    const $cb7c802f0a442491$var$MIN_FILTER_BAR_WIDTH = 510;
    const $cb7c802f0a442491$var$LARGE_SEARCH_FILTER_BREAKPOINT = 1440;
    const $cb7c802f0a442491$var$SoftwareFiltersStateless = (props)=>{
        (0, (0, parcelRequire("gKZoD")).di)(requestAnimationFrame);
        const { filter: filter, issueParentsLabel: issueParentsLabel, assignees: assignees = [], issueParents: issueParents = [], versions: versions = [], components: components = [], labels: labels = [], issueProjects: issueProjects = {}, issueTypes: issueTypes = [], issueTypeGroups: issueTypeGroups = [], statuses: statuses = [], requestTypes: requestTypes = [], onChange: onChange, onSearchFieldFocus: onSearchFieldFocus = (0, ($parcel$interopDefault($8Rkzz))), onExtraAvatarMenuOpen: onExtraAvatarMenuOpen = (0, ($parcel$interopDefault($8Rkzz))), onFilterPanelMounted: onFilterPanelMounted = (0, ($parcel$interopDefault($8Rkzz))), onClearAllButtonClicked: onClearAllButtonClicked = (0, ($parcel$interopDefault($8Rkzz))), onToggleParentPanel: onToggleParentPanel = (0, ($parcel$interopDefault($8Rkzz))), onToggleVersionsPanel: onToggleVersionsPanel = (0, ($parcel$interopDefault($8Rkzz))), isIssueParentPanelToggleChecked: isIssueParentPanelToggleChecked = false, isVersionPanelToggleChecked: isVersionPanelToggleChecked = false, isAnyModalOpen: isAnyModalOpen = false, AddPeopleModal: AddPeopleModal, showPanelToggle: showPanelToggle = false, panelToggleVisibility: panelToggleVisibility, showParentIssueMenuIfValuesAreEmpty: showParentIssueMenuIfValuesAreEmpty = false, showSearchFilterChangeboarding: showSearchFilterChangeboarding = false, hijackBrowserDefaultSearch: hijackBrowserDefaultSearch = false, screenName: screenName, isVersionsFeatureEnabled: isVersionsFeatureEnabled = false, isComponentsFeatureEnabled: isComponentsFeatureEnabled = false, isStatusCategoriesFeatureEnabled: isStatusCategoriesFeatureEnabled = true, isIssueParentsFeatureEnabled: isIssueParentsFeatureEnabled = true, isLabelsFeatureEnabled: isLabelsFeatureEnabled = true, isIssueProjectsFeatureEnabled: isIssueProjectsFeatureEnabled = false, isIssueTypesFeatureEnabled: isIssueTypesFeatureEnabled = true, isSprintsFeatureEnabled: isSprintsFeatureEnabled = true, isRequestTypesFeatureEnabled: isRequestTypesFeatureEnabled = false, isStatusesFeatureEnabled: isStatusesFeatureEnabled = false, isGroupIssueTypesEnabled: isGroupIssueTypesEnabled = false, isDependenciesFeatureEnabled: isDependenciesFeatureEnabled = false, onChangeInteractionStart: onChangeInteractionStart = (0, ($parcel$interopDefault($8Rkzz))), projectId: projectId, projectName: projectName, projectKey: projectKey, boardId: boardId, statusCategories: statusCategories = [], customFiltersQueryRef: customFiltersQueryRef, CustomFilter: CustomFilter, showAssigneeFilter: showAssigneeFilter = true, showCustomFilters: showCustomFilters = false, showBoardSwitcher: showBoardSwitcher = false, isBoardSwitcherReadOnly: isBoardSwitcherReadOnly = true, versionFilterRelayQueryRef: versionFilterRelayQueryRef, VersionFilterRelay: VersionFilterRelay, isVersionFilterRelayEnabled: isVersionFilterRelayEnabled = false, isUnassignedAssigneeOptionEnabled: isUnassignedAssigneeOptionEnabled = false, isUnassignedVersionOptionEnabled: isUnassignedVersionOptionEnabled = false, isUnassignedLabelOptionEnabled: isUnassignedLabelOptionEnabled = false, isUnassignedComponentOptionEnabled: isUnassignedComponentOptionEnabled = false, isCustomFiltersLoading: isCustomFiltersLoading = false, placeholder: placeholder = '', screenReaderInstruction: screenReaderInstruction = '', sprints: sprints = [], isAddPeopleButtonEnabled: isAddPeopleButtonEnabled = false, isCustomFilterManageLinkEnabled: isCustomFilterManageLinkEnabled = false, jqlFilters: jqlFilters = [], isCompanyManaged: isCompanyManaged = false, isJSMBoard: isJSMBoard = false, hasMultipleProjects: hasMultipleProjects = false, isGoalsFeatureOptionEnabled: isGoalsFeatureOptionEnabled = false, goals: goals = [] } = props;
        const accountId = (0, (0, parcelRequire("90yGq")).useAccountId)();
        const isAsyncFilterLoading = isCustomFiltersLoading;
        const [screenReaderInstructionForFilters, setScreenReaderInstructionForFilters] = (0, $5uXOq.useState)(false);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const allAssignees = (0, $5uXOq.useMemo)(()=>{
            if (!isUnassignedAssigneeOptionEnabled) return assignees;
            const unassignedUser = {
                id: (0, (0, parcelRequire("g5X3G")).toAccountId)((0, $15a528573ccd89ae$export$12e572fd459c10dc)),
                displayName: formatMessage((0, (0, parcelRequire("l38sT")).default).unassignedAssigneeDisplayName),
                avatarUrl: undefined
            };
            if ((0, (0, parcelRequire("4R6GH")).fg)('jira-collab-unassigned-filter-cta-gate')) return [
                unassignedUser,
                ...assignees
            ];
            return [
                ...assignees,
                unassignedUser
            ];
        }, [
            assignees,
            isUnassignedAssigneeOptionEnabled,
            formatMessage
        ]);
        const allVersions = (0, $5uXOq.useMemo)(()=>isUnassignedVersionOptionEnabled && versions.length ? [
                {
                    id: (0, $15a528573ccd89ae$export$ac95b4b2317d4b33),
                    name: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("l38sT")).default).unassignedVersionLabelIssueTermRefresh : (0, (0, parcelRequire("l38sT")).default).unassignedVersionLabel)
                },
                ...versions
            ] : versions, [
            versions,
            isUnassignedVersionOptionEnabled,
            formatMessage
        ]);
        const unassignedOption = (0, $5uXOq.useMemo)(()=>({
                label: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("l38sT")).default).unassignedLabelLabelIssueTermRefresh : (0, (0, parcelRequire("l38sT")).default).unassignedLabelLabel),
                value: (0, $15a528573ccd89ae$export$81ef49afbbead0a1)
            }), [
            formatMessage
        ]);
        const allComponents = (0, $5uXOq.useMemo)(()=>isUnassignedComponentOptionEnabled && components.length ? [
                {
                    id: (0, $15a528573ccd89ae$export$4b7c755e61199a36),
                    name: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("l38sT")).default).unassignedComponentLabelIssueTermRefresh : (0, (0, parcelRequire("l38sT")).default).unassignedComponentLabel)
                },
                ...components
            ] : components, [
            components,
            isUnassignedComponentOptionEnabled,
            formatMessage
        ]);
        (0, $5uXOq.useEffect)(()=>{
            onFilterPanelMounted();
        }, [
            onFilterPanelMounted
        ]);
        const onSearchChange = (0, $5uXOq.useCallback)((0, ($parcel$interopDefault($lFKmC)))((newText)=>{
            onChangeInteractionStart();
            onChange({
                [(0, $15a528573ccd89ae$export$d597759d33be802e)]: newText
            }, (0, $15a528573ccd89ae$export$d597759d33be802e), undefined);
        }, 300), [
            onChange,
            onChangeInteractionStart
        ]);
        const assigneeValue = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($9XE6b)))(filter, [
                (0, $15a528573ccd89ae$export$f8f7545d2bb78afb)
            ], $cb7c802f0a442491$var$EMPTY_ARRAY), [
            filter
        ]);
        const onToggleAssignee = (0, $5uXOq.useCallback)((entryId)=>{
            setScreenReaderInstructionForFilters(true);
            setTimeout(()=>{
                setScreenReaderInstructionForFilters(false);
            });
            const withoutValue = (0, ($parcel$interopDefault($hqTkp)))(assigneeValue, entryId);
            const newFilterValue = withoutValue.length === assigneeValue.length ? withoutValue.concat(entryId) : withoutValue;
            onChange({
                [(0, $15a528573ccd89ae$export$f8f7545d2bb78afb)]: (0, (0, parcelRequire("g5X3G")).toAccountIdArray)(newFilterValue)
            }, (0, $15a528573ccd89ae$export$f8f7545d2bb78afb), {
                isUnassignedFilterCta: false,
                isUnassignedSelected: newFilterValue.includes((0, $15a528573ccd89ae$export$12e572fd459c10dc)),
                isOnlyCurrentUserSelected: accountId && newFilterValue.length === 1 && newFilterValue[0] === accountId
            });
        }, [
            assigneeValue,
            onChange,
            accountId
        ]);
        const onChangeParents = (0, $5uXOq.useCallback)((parentIds, attributes)=>{
            onChange({
                [(0, $15a528573ccd89ae$export$2a4f270075a033de)]: parentIds
            }, (0, $15a528573ccd89ae$export$2a4f270075a033de), attributes);
        }, [
            onChange
        ]);
        const onChangeVersions = (0, $5uXOq.useCallback)((versionIds, attributes)=>{
            onChange({
                [(0, $15a528573ccd89ae$export$a4ad2735b021c132)]: (0, (0, parcelRequire("g5X3G")).toVersionIdArray)(versionIds)
            }, (0, $15a528573ccd89ae$export$a4ad2735b021c132), attributes);
        }, [
            onChange
        ]);
        const onChangeComponents = (0, $5uXOq.useCallback)((componentIds, attributes)=>{
            onChange({
                [(0, $15a528573ccd89ae$export$af1e30ebbae9df3b)]: (0, (0, parcelRequire("g5X3G")).toComponentIdArray)(componentIds)
            }, (0, $15a528573ccd89ae$export$af1e30ebbae9df3b), attributes);
        }, [
            onChange
        ]);
        const onChangeLabels = (0, $5uXOq.useCallback)((newLabels, attributes)=>{
            onChange({
                [(0, $15a528573ccd89ae$export$37aee82a3cb1e8f7)]: newLabels
            }, (0, $15a528573ccd89ae$export$37aee82a3cb1e8f7), attributes);
        }, [
            onChange
        ]);
        const onChangeIssueProjects = (0, $5uXOq.useCallback)((newProjects, attributes)=>{
            onChange({
                [(0, $15a528573ccd89ae$export$401f4b6eda6a369c)]: newProjects
            }, (0, $15a528573ccd89ae$export$401f4b6eda6a369c), attributes);
        }, [
            onChange
        ]);
        const onChangeIssueTypes = (0, $5uXOq.useCallback)((issueTypeIds, attributes)=>{
            onChange({
                [(0, $15a528573ccd89ae$export$ebb48b08205007c5)]: issueTypeIds
            }, (0, $15a528573ccd89ae$export$ebb48b08205007c5), attributes);
        }, [
            onChange
        ]);
        const onChangeStatusCategories = (0, $5uXOq.useCallback)((newStatusCategories, attributes)=>{
            onChange({
                [(0, $15a528573ccd89ae$export$f863b019d19144f4)]: newStatusCategories
            }, (0, $15a528573ccd89ae$export$f863b019d19144f4), attributes);
        }, [
            onChange
        ]);
        const onChangeCustomFilters = (0, $5uXOq.useCallback)((newCustomFilters, attributes)=>{
            onChange({
                [(0, $15a528573ccd89ae$export$68d693c35a8d8866)]: newCustomFilters
            }, (0, $15a528573ccd89ae$export$68d693c35a8d8866), attributes);
        }, [
            onChange
        ]);
        const onChangeSprints = (0, $5uXOq.useCallback)((newSprintIds, attributes)=>{
            onChange({
                [(0, $15a528573ccd89ae$export$a316570a0dbfd2b0)]: newSprintIds
            }, (0, $15a528573ccd89ae$export$a316570a0dbfd2b0), attributes);
        }, [
            onChange
        ]);
        const onChangeStatuses = (0, $5uXOq.useCallback)((newStatuses, attributes)=>{
            onChange({
                [(0, $15a528573ccd89ae$export$e50006273435e7d4)]: newStatuses
            }, (0, $15a528573ccd89ae$export$e50006273435e7d4), attributes);
        }, [
            onChange
        ]);
        const onChangeRequestTypes = (0, $5uXOq.useCallback)((newRequestTypeIds, attributes)=>{
            onChange({
                [(0, $15a528573ccd89ae$export$92ab80c1dc9baf44)]: newRequestTypeIds
            }, (0, $15a528573ccd89ae$export$92ab80c1dc9baf44), attributes);
        }, [
            onChange
        ]);
        const onChangeQuickFilters = (0, $5uXOq.useCallback)((newQuickFilters, attributes)=>{
            onChange({
                [(0, $15a528573ccd89ae$export$1ea95b94fb0c51d9)]: newQuickFilters
            }, (0, $15a528573ccd89ae$export$1ea95b94fb0c51d9), attributes);
        }, [
            onChange
        ]);
        const onChangeGoals = (0, $5uXOq.useCallback)((goalIds, attributes)=>{
            onChange({
                [(0, $15a528573ccd89ae$export$871e58afc769b358)]: goalIds
            }, (0, $15a528573ccd89ae$export$871e58afc769b358), attributes);
        }, [
            onChange
        ]);
        const onChangeDependencies = (0, $5uXOq.useCallback)((dependencyOptions, attributes)=>{
            onChange({
                [(0, $15a528573ccd89ae$export$db362e2d293fe52e)]: dependencyOptions
            }, (0, $15a528573ccd89ae$export$db362e2d293fe52e), attributes);
        }, [
            onChange
        ]);
        const isClearButtonVisible = (0, $5uXOq.useMemo)(()=>filter && Object.keys(filter).length > 0, [
            filter
        ]);
        const searchInputRef = (0, $5uXOq.useRef)(null);
        const fireShortcutAnalytics = (0, (0, parcelRequire("fUHZ2")).useShortcutAnalytics)(screenName);
        const focusSearchInput = (0, (0, parcelRequire("4R6GH")).fg)('blu-3488_small_refactor_in_filters_bar') ? ()=>{
            if (!searchInputRef.current) return;
            requestAnimationFrame(()=>{
                searchInputRef.current && searchInputRef.current.focus();
            });
            const analyticsPayload = {
                id: 'focusSearchField',
                key: 'f',
                attributes: {}
            };
            fireShortcutAnalytics(analyticsPayload);
        } : ()=>{
            if (!(0, ($parcel$interopDefault($hGgHi)))(searchInputRef) && !(0, ($parcel$interopDefault($hGgHi)))(searchInputRef.current)) {
                requestAnimationFrame(()=>{
                    searchInputRef.current && searchInputRef.current.focus();
                });
                const analyticsPayload = {
                    id: 'focusSearchField',
                    key: 'f',
                    attributes: {}
                };
                fireShortcutAnalytics(analyticsPayload);
            }
        };
        const screenReaderDescriptionId = 'search-issue-description';
        const isUserBoard = window.location.pathname.startsWith('/jira/people/');
        const customFilterManageUrl = (0, (0, parcelRequire("649U3")).getManageCustomFiltersUrl)(projectKey, boardId.toString(), isCompanyManaged, isUserBoard, isJSMBoard);
        const showEpicPanelToggle = panelToggleVisibility ? panelToggleVisibility.showEpicPanelToggle : showPanelToggle;
        const isMounted = (0, $5uXOq.useRef)(false);
        (0, $5uXOq.useEffect)(()=>{
            if (isMounted.current) {
                if (!isClearButtonVisible) {
                    setScreenReaderInstructionForFilters(true);
                    setTimeout(()=>{
                        setScreenReaderInstructionForFilters(false);
                    }, 1000);
                }
            } else isMounted.current = true;
        }, [
            isClearButtonVisible
        ]);
        const parentFilter = {
            id: (0, $15a528573ccd89ae$export$2a4f270075a033de),
            isStatic: false,
            isHidden: !isIssueParentsFeatureEnabled,
            renderer: (isNested)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bLWKp")).default), {
                    key: "ParentFilter",
                    isNested: isNested,
                    label: issueParentsLabel,
                    parents: issueParents,
                    selectedParents: filter[0, $15a528573ccd89ae$export$2a4f270075a033de],
                    isToggleChecked: isIssueParentPanelToggleChecked,
                    onChange: onChangeParents,
                    onTogglePanel: onToggleParentPanel,
                    showPanelToggle: showEpicPanelToggle,
                    showMenuIfValuesAreEmpty: showParentIssueMenuIfValuesAreEmpty
                })
        };
        const showVersionsPanelToggle = panelToggleVisibility ? panelToggleVisibility.showVersionsPanelToggle : showPanelToggle;
        const versionFilter = {
            id: (0, $15a528573ccd89ae$export$a4ad2735b021c132),
            isStatic: false,
            hidden: !isVersionsFeatureEnabled,
            renderer: (isNested)=>isVersionFilterRelayEnabled ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bBMqL")).default), {
                    key: "VersionFilterRelayBoundary",
                    screenName: screenName,
                    fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aMFc7")).default), {
                        isNested: isNested,
                        versions: $cb7c802f0a442491$var$EMPTY_ARRAY,
                        isToggleChecked: isVersionPanelToggleChecked,
                        onChange: onChangeVersions,
                        onTogglePanel: onToggleVersionsPanel,
                        selectedVersions: filter[0, $15a528573ccd89ae$export$a4ad2735b021c132] ?? $cb7c802f0a442491$var$EMPTY_ARRAY,
                        isSpotlightEnabled: false,
                        showPanelToggle: showVersionsPanelToggle,
                        isVersionsFeatureEnabled: isVersionsFeatureEnabled,
                        hasMultipleProjects: hasMultipleProjects,
                        isLoading: true
                    })
                }, versionFilterRelayQueryRef != null && VersionFilterRelay != null ? (0, ($parcel$interopDefault($5uXOq))).createElement(VersionFilterRelay, {
                    isNested: isNested,
                    isToggleChecked: isVersionPanelToggleChecked,
                    onChange: onChangeVersions,
                    onTogglePanel: onToggleVersionsPanel,
                    selectedVersions: filter[0, $15a528573ccd89ae$export$a4ad2735b021c132] ?? $cb7c802f0a442491$var$EMPTY_ARRAY,
                    isSpotlightEnabled: false,
                    showPanelToggle: showVersionsPanelToggle,
                    isVersionsFeatureEnabled: isVersionsFeatureEnabled,
                    versionFilterRelayQueryRef: versionFilterRelayQueryRef,
                    isUnassignedVersionOptionEnabled: isUnassignedVersionOptionEnabled,
                    hasMultipleProjects: hasMultipleProjects
                }) : null) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aMFc7")).default), {
                    key: "VersionFilter",
                    isNested: isNested,
                    versions: allVersions,
                    isToggleChecked: isVersionPanelToggleChecked,
                    onChange: onChangeVersions,
                    onTogglePanel: onToggleVersionsPanel,
                    selectedVersions: filter[0, $15a528573ccd89ae$export$a4ad2735b021c132] ?? $cb7c802f0a442491$var$EMPTY_ARRAY,
                    isSpotlightEnabled: false,
                    showPanelToggle: showVersionsPanelToggle,
                    isVersionsFeatureEnabled: isVersionsFeatureEnabled
                })
        };
        const overflowItemsBefore = [
            {
                id: (0, $15a528573ccd89ae$export$f863b019d19144f4),
                isStatic: false,
                isHidden: !isStatusCategoriesFeatureEnabled,
                renderer: (isNested)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cSFZv")).default), {
                        key: "StatusCategoryFilter",
                        isNested: isNested,
                        statusCategories: statusCategories,
                        selectedStatusCategories: filter[0, $15a528573ccd89ae$export$f863b019d19144f4],
                        onChange: onChangeStatusCategories
                    })
            },
            {
                id: (0, $15a528573ccd89ae$export$401f4b6eda6a369c),
                isStatic: false,
                isHidden: !isIssueProjectsFeatureEnabled,
                renderer: (isNested)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("efv79")).default), {
                        isNested: isNested,
                        issueProjects: issueProjects,
                        key: "IssueProjectFilter",
                        onChange: onChangeIssueProjects,
                        selectedProjects: filter[0, $15a528573ccd89ae$export$401f4b6eda6a369c]
                    })
            },
            versionFilter,
            parentFilter,
            {
                id: (0, $15a528573ccd89ae$export$37aee82a3cb1e8f7),
                isStatic: false,
                isHidden: !isLabelsFeatureEnabled,
                renderer: (isNested)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2fsdj")).default), {
                        key: "LabelFilter",
                        isNested: isNested,
                        ...isUnassignedLabelOptionEnabled && labels.length ? {
                            unassignedOption: unassignedOption
                        } : undefined,
                        labels: labels,
                        selectedLabels: filter[0, $15a528573ccd89ae$export$37aee82a3cb1e8f7],
                        onChange: onChangeLabels
                    })
            },
            {
                id: (0, $15a528573ccd89ae$export$ebb48b08205007c5),
                isStatic: false,
                isHidden: !isIssueTypesFeatureEnabled,
                renderer: (isNested)=>isGroupIssueTypesEnabled ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jKPI1")).default), {
                        key: "IssueTypeGroupFilter",
                        isNested: isNested,
                        issueTypeGroups: issueTypeGroups,
                        selectedIssueTypes: filter[0, $15a528573ccd89ae$export$ebb48b08205007c5],
                        onChange: onChangeIssueTypes
                    }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hHL6f")).default), {
                        key: "IssueTypeFilter",
                        isNested: isNested,
                        issueTypes: issueTypes,
                        selectedIssueTypes: filter[0, $15a528573ccd89ae$export$ebb48b08205007c5],
                        onChange: onChangeIssueTypes
                    })
            },
            {
                id: (0, $15a528573ccd89ae$export$af1e30ebbae9df3b),
                isStatic: false,
                isHidden: !isComponentsFeatureEnabled,
                renderer: (isNested)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7j6PN")).default), {
                        key: "ComponentFilter",
                        isNested: isNested,
                        components: allComponents,
                        onChange: onChangeComponents,
                        selectedComponents: filter[0, $15a528573ccd89ae$export$af1e30ebbae9df3b]
                    })
            },
            {
                id: (0, $15a528573ccd89ae$export$a316570a0dbfd2b0),
                isStatic: false,
                isHidden: !isSprintsFeatureEnabled || sprints.length <= 1,
                renderer: (isNested)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jdA4J")).default), {
                        key: "SprintFilter",
                        isNested: isNested,
                        sprints: sprints,
                        selectedSprints: filter[0, $15a528573ccd89ae$export$a316570a0dbfd2b0],
                        onChange: onChangeSprints
                    })
            },
            {
                id: (0, $15a528573ccd89ae$export$e50006273435e7d4),
                isStatic: false,
                isHidden: !isStatusesFeatureEnabled,
                renderer: (isNested)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3f9TT")).default), {
                        key: "StatusFilter",
                        isNested: isNested,
                        statuses: statuses,
                        selectedStatuses: filter[0, $15a528573ccd89ae$export$e50006273435e7d4],
                        onChange: onChangeStatuses
                    })
            },
            {
                id: (0, $15a528573ccd89ae$export$92ab80c1dc9baf44),
                isStatic: false,
                isHidden: !isRequestTypesFeatureEnabled,
                renderer: (isNested)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("g65Ek")).default), {
                        key: "RequestTypeFilter",
                        isNested: isNested,
                        requestTypes: requestTypes,
                        selectedRequestTypes: filter[0, $15a528573ccd89ae$export$92ab80c1dc9baf44],
                        onChange: onChangeRequestTypes
                    })
            },
            {
                id: (0, $15a528573ccd89ae$export$68d693c35a8d8866),
                isStatic: false,
                renderer: (isNested)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cM4EP")).default), {
                        key: "CustomFilterBoundary",
                        screenName: screenName,
                        customFiltersQueryRef: customFiltersQueryRef
                    }, (!!customFiltersQueryRef || showCustomFilters) && !!CustomFilter && (0, ($parcel$interopDefault($5uXOq))).createElement(CustomFilter, {
                        shouldReturnFocus: (0, (0, parcelRequire("4R6GH")).fg)('jsw_remove_the_auto_focus_on_custom_filter') ? undefined : isClearButtonVisible === false,
                        isNested: isNested,
                        customFiltersQueryRef: customFiltersQueryRef,
                        selectedFilters: filter[0, $15a528573ccd89ae$export$68d693c35a8d8866],
                        filters: jqlFilters,
                        onChange: onChangeCustomFilters,
                        showLink: isCustomFilterManageLinkEnabled,
                        manageUrl: customFilterManageUrl,
                        screenName: screenName
                    }))
            },
            {
                id: (0, $15a528573ccd89ae$export$1ea95b94fb0c51d9),
                isStatic: false,
                isHidden: showCustomFilters,
                renderer: (isNested)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hpA0D")).default), {
                        key: "QuickFilter",
                        isNested: isNested,
                        filters: jqlFilters,
                        selectedFilters: filter[0, $15a528573ccd89ae$export$1ea95b94fb0c51d9],
                        onChange: onChangeQuickFilters
                    })
            },
            {
                id: (0, $15a528573ccd89ae$export$871e58afc769b358),
                isStatic: false,
                isHidden: !isGoalsFeatureOptionEnabled || goals.length === 0,
                renderer: (isNested)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgqZV")).default), {
                        key: "GoalFilter",
                        isNested: isNested,
                        goals: goals,
                        selectedGoals: filter[0, $15a528573ccd89ae$export$871e58afc769b358],
                        onChange: onChangeGoals
                    })
            },
            {
                id: (0, $15a528573ccd89ae$export$db362e2d293fe52e),
                isStatic: false,
                isHidden: (0, (0, parcelRequire("4R6GH")).fg)('dependency_visualisation_program_board_fe_and_be') ? !isDependenciesFeatureEnabled : true,
                renderer: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8bg0N")).default), {
                        key: "DependenciesFilter",
                        onChange: onChangeDependencies,
                        selectedValues: filter[0, $15a528573ccd89ae$export$db362e2d293fe52e]
                    })
            }
        ];
        const overflowItemsAfter = [
            {
                id: 'CLEAR_BUTTON',
                isStatic: isClearButtonVisible,
                isHidden: !isClearButtonVisible,
                renderer: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3oCwY")).default), {
                        key: "ClearButton",
                        onClick: onClearAllButtonClicked
                    })
            }
        ];
        if (isAsyncFilterLoading) overflowItemsAfter.push({
            id: 'SPINNER',
            isStatic: true,
            isHidden: !isAsyncFilterLoading,
            renderer: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($cb7c802f0a442491$var$SpinnerContainer, {
                    key: "SpinnerContainer"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
                    size: "small"
                }))
        });
        const { getKeywords: getKeywords } = (0, (0, parcelRequire("eG9rp")).useCommandKeywords)();
        const [maxVisibleUsers, setMaxVisibleUsers] = (0, $5uXOq.useState)($cb7c802f0a442491$var$DEFAULT_VISIBLE_USERS);
        const [showLargeSearchFilter, setShowLargeSearchFilter] = (0, $5uXOq.useState)(true);
        const filterBarRef = (0, $5uXOq.useRef)(null);
        const onResize = (0, $5uXOq.useCallback)(()=>{
            if (!filterBarRef.current || !searchInputRef.current) return;
            const completeFilterBarWidth = filterBarRef.current.offsetWidth;
            const searchInputWidth = searchInputRef.current.offsetWidth;
            const remainingWidth = completeFilterBarWidth - searchInputWidth;
            if (remainingWidth < $cb7c802f0a442491$var$MIN_FILTER_BAR_WIDTH) {
                const usersToReduce = Math.ceil(($cb7c802f0a442491$var$MIN_FILTER_BAR_WIDTH - remainingWidth) / $cb7c802f0a442491$var$USER_AVATAR_WIDTH);
                const newMax = Math.max($cb7c802f0a442491$var$DEFAULT_VISIBLE_USERS - usersToReduce, $cb7c802f0a442491$var$MIN_VISIBLE_USERS);
                setMaxVisibleUsers(newMax);
            } else setMaxVisibleUsers($cb7c802f0a442491$var$DEFAULT_VISIBLE_USERS);
            setShowLargeSearchFilter(window.innerWidth >= $cb7c802f0a442491$var$LARGE_SEARCH_FILTER_BREAKPOINT);
        }, []);
        (0, (0, parcelRequire("2m0b6")).useResizeObserver)({
            ref: filterBarRef,
            onResize: onResize
        });
        (0, (0, parcelRequire("2m0b6")).useResizeObserver)({
            ref: searchInputRef,
            onResize: onResize
        });
        const { experimentCohort: experimentCohort } = (0, (0, parcelRequire("2WENx")).useRealtimePresenceExperiment)();
        const isRealtimePresenceEnabled = ()=>screenName === 'board' && experimentCohort === (0, (0, parcelRequire("joX8T")).VARIATION);
        if (screenName === 'board' && experimentCohort !== (0, (0, parcelRequire("joX8T")).NOT_ENROLLED)) {
            const [, fireExposure] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('jsw_board_real-time_collaboration_through_presence');
            fireExposure();
        }
        const [{ participants: participants }] = (0, (0, parcelRequire("8vjSE")).useCollabStore)();
        const allUsersWithPresence = isRealtimePresenceEnabled() ? (0, (0, parcelRequire("649U3")).getAssigneesWithPresence)(allAssignees, participants) : allAssignees;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fJnmW")).FilterBar), {
            ref: filterBarRef
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("879xD")).CommandShortcuts), {
            keyMap: {
                f: {
                    callback: focusSearchInput,
                    registerInCommandPalette: {
                        id: 'software-filters-stateless-focus-search-input',
                        name: formatMessage((0, (0, parcelRequire("l38sT")).default).searchCurrentPage),
                        keywords: getKeywords('pageSearchSynonyms'),
                        priority: (0, (0, parcelRequire("5rVQI")).COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY).searchOnCurrentPage,
                        section: (0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_SECTIONS).quickActions,
                        components: {
                            LeftIcon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("eWXbg"))))), {
                                    label: formatMessage((0, (0, parcelRequire("l38sT")).default).searchCurrentPage)
                                })
                        },
                        analytics: {
                            action: 'searchCurrentPage'
                        }
                    }
                }
            },
            location: "software.filters.keyboard-shortcuts"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dqoiX")).ScreenReaderText), {
            id: screenReaderDescriptionId
        }, screenReaderInstruction || formatMessage((0, (0, parcelRequire("l38sT")).default).screenReaderInstruction)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, screenReaderInstructionForFilters ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dqoiX")).ScreenReaderText), {
            "data-testid": "software-filters.ui.stateless.screen-reader-instruction",
            id: "software-filters.ui.stateless.screen-reader-instruction",
            role: "status",
            "aria-relevant": "all"
        }, formatMessage((0, (0, parcelRequire("l38sT")).default).screenReaderInstructionForFilters)) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dqoiX")).ScreenReaderText), {
            "data-testid": "software-filters.ui.stateless.screen-reader-instruction",
            id: "software-filters.ui.stateless.screen-reader-instruction",
            role: "status"
        })), hijackBrowserDefaultSearch === true && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2FvdY")).default), {
            onFocusSearch: focusSearchInput,
            isAnyModalOpen: isAnyModalOpen
        }), showSearchFilterChangeboarding === true ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kH9yv")).default), {
            hijackBrowserDefaultSearch: hijackBrowserDefaultSearch,
            screenName: screenName,
            isCompanyManaged: isCompanyManaged
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2xSAL")).SearchField), {
            placeholderAlwaysVisible: true,
            describedById: screenReaderDescriptionId,
            isAlwaysExpanded: showLargeSearchFilter,
            searchIconVisible: false,
            renderCustomSearchField: $cb7c802f0a442491$var$CustomSearchInput,
            value: filter[0, $15a528573ccd89ae$export$d597759d33be802e] || '',
            placeholder: placeholder || formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("l38sT")).default).textFilterIssueTermRefresh : (0, (0, parcelRequire("l38sT")).default).textFilter),
            onChange: onSearchChange,
            onFocus: onSearchFieldFocus,
            inputRef: searchInputRef,
            maxLength: 255,
            testId: "software-filters.ui.stateless.search-field"
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2xSAL")).SearchField), {
            placeholderAlwaysVisible: true,
            describedById: screenReaderDescriptionId,
            isAlwaysExpanded: showLargeSearchFilter,
            searchIconVisible: false,
            renderCustomSearchField: $cb7c802f0a442491$var$CustomSearchInput,
            value: filter[0, $15a528573ccd89ae$export$d597759d33be802e] || '',
            placeholder: placeholder || formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("l38sT")).default).textFilterIssueTermRefresh : (0, (0, parcelRequire("l38sT")).default).textFilter),
            onChange: onSearchChange,
            onFocus: onSearchFieldFocus,
            inputRef: searchInputRef,
            maxLength: 255,
            testId: "software-filters.ui.stateless.search-field"
        }), showBoardSwitcher && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cTi8P")).default), {
            boardId: boardId,
            isReadOnly: isBoardSwitcherReadOnly
        }), showAssigneeFilter && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1beWO")).default), {
            maxUsers: maxVisibleUsers,
            users: allUsersWithPresence,
            screenName: screenName,
            selectedUsers: assigneeValue,
            onToggle: onToggleAssignee,
            onAssigneeMenuOpen: onExtraAvatarMenuOpen,
            AddPeopleModal: AddPeopleModal,
            projectId: projectId,
            projectName: projectName,
            isAddPeopleButtonEnabled: isAddPeopleButtonEnabled,
            projectKey: projectKey
        }), isRealtimePresenceEnabled() && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gtgKk")).CollabContainerAsync), {
            screenName: screenName,
            boardId: boardId
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fJnmW")).ListFilterContainerNextGen), {
            "data-testid": "software-filters.ui.list-filter-container"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6CjZR")).default), {
            itemsBefore: overflowItemsBefore,
            itemsAfter: overflowItemsAfter,
            selectedItems: filter
        })));
    };
    const $cb7c802f0a442491$var$customSearchInputStyles = null;
    const $cb7c802f0a442491$var$customSearchInputStylesOld = null;
    const $cb7c802f0a442491$var$CustomSearchInput = ({ textFieldProps: textFieldProps, searchIcon: searchIcon })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kY99m")).default), {
            ...textFieldProps,
            elemAfterInput: searchIcon,
            elemBeforeInput: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                paddingInlineStart: "space.100",
                paddingBlockStart: "space.025"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("tvuR8"))))), {
                primaryColor: "var(--ds-icon, #44546F)",
                size: "small",
                label: ""
            })),
            autoComplete: "off",
            testId: "software-filters.ui.stateless.search-field",
            className: (0, (0, parcelRequire("bwpsq")).default)([
                (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? "_1hxm12x7 _1twg1b66" : "_2rkoq1pp _1yt4ze3t _1rns1b66 _1srlxy5q"
            ])
        });
    var $cb7c802f0a442491$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($cb7c802f0a442491$var$SoftwareFiltersStateless);
    const $cb7c802f0a442491$var$SpinnerContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19bv1b66 _4t3i1osq _1e0c1txw _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("eWXbg", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ae246388ea520792$var$_react = $ae246388ea520792$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $ae246388ea520792$var$_page = $ae246388ea520792$var$_interopRequireDefault((parcelRequire("kdfZa")));
    function $ae246388ea520792$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $ae246388ea520792$var$PageIcon = (props)=>$ae246388ea520792$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="8" height="2" x="8" y="6" rx="1"/><rect width="8" height="2" x="8" y="9" rx="1"/><rect width="4" height="2" x="8" y="12" rx="1"/><path fill-rule="nonzero" d="M7 4v16h10V4zm-2-.01C5 2.892 5.897 2 7.006 2h9.988C18.102 2 19 2.898 19 3.99v16.02c0 1.099-.897 1.99-2.006 1.99H7.006A2.003 2.003 0 0 1 5 20.01z"/></g></svg>`
        }, props, {
            newIcon: $ae246388ea520792$var$_page.default
        }));
    $ae246388ea520792$var$PageIcon.displayName = 'PageIcon';
    var $ae246388ea520792$var$_default = module.exports.default = $ae246388ea520792$var$PageIcon;
});
parcelRegister("kdfZa", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $eb716bf3c984513d$var$_react = $eb716bf3c984513d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $eb716bf3c984513d$var$_UNSAFE_baseNew = $eb716bf3c984513d$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $eb716bf3c984513d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $eb716bf3c984513d$var$PageIcon = (props)=>$eb716bf3c984513d$var$_react.default.createElement($eb716bf3c984513d$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4 5.25h8m-8 3.5h6m-7 5.5h10c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25Z"/>`
        }, props));
    $eb716bf3c984513d$var$PageIcon.displayName = 'PageIcon';
    var $eb716bf3c984513d$var$_default = module.exports.default = $eb716bf3c984513d$var$PageIcon;
});
parcelRegister("kY99m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$509076ff0c6afa78$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6QvkM;
    var $hbrbl;
    const $509076ff0c6afa78$var$analyticsParams = {
        componentName: 'textField',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $509076ff0c6afa78$var$Textfield = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
        const inputRef = (0, $5uXOq.useRef)(null);
        const handleOnFocus = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (event)=>{
                onFocus && onFocus(event);
            },
            action: 'focused',
            ...$509076ff0c6afa78$var$analyticsParams
        });
        const handleOnBlur = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (event)=>{
                onBlur && onBlur(event);
            },
            action: 'blurred',
            ...$509076ff0c6afa78$var$analyticsParams
        });
        const handleOnMouseDown = (0, $5uXOq.useCallback)((event)=>{
            const target = event.target;
            if (target.tagName !== 'INPUT') event.preventDefault();
            if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
            onMouseDown && onMouseDown(event);
        }, [
            onMouseDown,
            isDisabled
        ]);
        const setInputRef = (0, $5uXOq.useCallback)((inputElement)=>{
            inputRef.current = inputElement;
            if (!ref) return;
            if (typeof ref === 'object') ref.current = inputElement;
            if (typeof ref === 'function') ref(inputElement);
        }, [
            ref
        ]);
        const containerStyles = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("hbrbl")).containerStyles)(appearance, width), [
            appearance,
            width
        ]);
        const inputStyle = (0, (0, parcelRequire("hbrbl")).inputStyles)();
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            role: "presentation",
            "data-disabled": isDisabled ? isDisabled : undefined,
            "data-invalid": isInvalid ? isInvalid : undefined,
            "data-ds--text-field--container": true,
            "data-testid": testId && `${testId}-container`,
            onMouseDown: handleOnMouseDown,
            css: containerStyles,
            className: className
        }, elemBeforeInput, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            ...spreadProps,
            "aria-invalid": isInvalid ? isInvalid : undefined,
            css: inputStyle,
            "data-compact": isCompact ? isCompact : undefined,
            "data-ds--text-field--input": true,
            "data-monospaced": isMonospaced ? isMonospaced : undefined,
            "data-testid": testId,
            disabled: isDisabled,
            name: name,
            onBlur: handleOnBlur,
            onChange: onChange,
            onFocus: handleOnFocus,
            placeholder: placeholder,
            readOnly: isReadOnly,
            ref: setInputRef,
            required: isRequired
        }), elemAfterInput));
    });
    var $509076ff0c6afa78$export$2e2bcd8739ae039 = $509076ff0c6afa78$var$Textfield;
});
parcelRegister("hbrbl", function(module, exports) {
    $parcel$export(module.exports, "containerStyles", ()=>$9b106cc21ace4b3b$export$5972a68b6e54f38f);
    $parcel$export(module.exports, "inputStyles", ()=>$9b106cc21ace4b3b$export$3eeb47dc8e6249d9);
    const $9b106cc21ace4b3b$var$backgroundColor = {
        standard: `var(--ds-background-input, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
        subtle: 'transparent',
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$backgroundColorFocus = {
        standard: `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        subtle: `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$backgroundColorHover = {
        standard: `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        subtle: `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$borderColor = {
        standard: `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
        subtle: 'transparent',
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$borderColorFocus = {
        standard: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
        subtle: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$borderColorHover = {
        standard: `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
        subtle: "var(--ds-border-input, transparent)",
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$getContainerTextBgAndBorderColor = (appearance)=>({
            backgroundColor: $9b106cc21ace4b3b$var$backgroundColor[appearance],
            borderColor: $9b106cc21ace4b3b$var$borderColor[appearance],
            color: `var(--ds-text, ${0, $829f609a65d26a98$export$fbda843f0a27fe96})`,
            cursor: 'text',
            '&:hover:not([data-disabled])': {
                backgroundColor: $9b106cc21ace4b3b$var$backgroundColorHover[appearance],
                borderColor: $9b106cc21ace4b3b$var$borderColorHover[appearance]
            },
            '&:focus-within:not([data-disabled])': {
                backgroundColor: $9b106cc21ace4b3b$var$backgroundColorFocus[appearance],
                borderColor: $9b106cc21ace4b3b$var$borderColorFocus[appearance],
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$9b106cc21ace4b3b$var$borderColorFocus[appearance]}`
            },
            '&[data-disabled]': {
                color: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`,
                cursor: 'not-allowed',
                ...appearance === 'standard' && {
                    backgroundColor: `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})`,
                    borderColor: `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})`
                }
            },
            '&[data-invalid], &[data-invalid]:hover': {
                borderColor: `var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`}`
            },
            '&[data-invalid]:focus-within': {
                backgroundColor: `var(--ds-background-input-pressed, ${0, $829f609a65d26a98$export$29a4f05edc054374})`,
                borderColor: `var(--ds-border-focused, ${0, $829f609a65d26a98$export$215b7063051591f1})`,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${0, $829f609a65d26a98$export$215b7063051591f1})`}`
            },
            '@media screen and (-ms-high-contrast: active)': {
                '&[data-invalid]:focus-within': {
                    borderColor: 'Highlight'
                },
                '&:focus-within': {
                    borderColor: 'Highlight'
                },
                '&[data-disabled]': {
                    borderColor: 'GrayText'
                }
            }
        });
    const $9b106cc21ace4b3b$var$widthMap = {
        xsmall: 80,
        small: 160,
        medium: 240,
        large: 320,
        xlarge: 480
    };
    const $9b106cc21ace4b3b$var$getMaxWidth = (width)=>!width ? `100%` : width in $9b106cc21ace4b3b$var$widthMap ? $9b106cc21ace4b3b$var$widthMap[width] : +width;
    const $9b106cc21ace4b3b$export$5972a68b6e54f38f = (appearance, width)=>({
            alignItems: 'center',
            ...$9b106cc21ace4b3b$var$getContainerTextBgAndBorderColor(appearance),
            borderRadius: 3,
            borderWidth: "var(--ds-border-width, 1px)",
            ...appearance !== 'none' ? {
                padding: `${"var(--ds-border-width, 1px)"} 0`
            } : {},
            borderStyle: appearance === 'none' ? 'none' : 'solid',
            boxSizing: 'border-box',
            display: 'flex',
            flex: '1 1 100%',
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            justifyContent: 'space-between',
            maxWidth: $9b106cc21ace4b3b$var$getMaxWidth(width),
            overflow: 'hidden',
            transition: `background-color 0.2s ease-in-out, border-color 0.2s ease-in-out`,
            wordWrap: 'break-word',
            verticalAlign: 'top',
            pointerEvents: 'auto'
        });
    const $9b106cc21ace4b3b$export$3eeb47dc8e6249d9 = ()=>({
            backgroundColor: 'transparent',
            border: 0,
            boxSizing: 'border-box',
            color: 'inherit',
            cursor: 'inherit',
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            minWidth: '0',
            outline: 'none',
            width: '100%',
            '&[data-monospaced]': {
                fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
            },
            '&[data-compact]': {
                padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`
            },
            '&:not([data-compact])': {
                padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}`
            },
            '&[disabled]': {
                WebkitTextFillColor: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`
            },
            '&::-ms-clear': {
                display: 'none'
            },
            '&:invalid': {
                boxShadow: 'none'
            },
            '&:placeholder-shown': {
                textOverflow: 'ellipsis'
            },
            '&::placeholder': {
                color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`,
                '&:disabled': {
                    color: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`
                }
            },
            '@media screen and (-ms-high-contrast: active)': {
                '&[disabled]': {
                    color: 'GrayText'
                }
            }
        });
});
parcelRegister("5p1kJ", function(module, exports) {
    $parcel$export(module.exports, "COMMAND_PALETTE_SECTIONS", ()=>$7691773a5eed3db6$export$16b06d29ef8f802b);
    $parcel$export(module.exports, "COMMAND_PALETTE_ISSUE_ACTIONS", ()=>$7691773a5eed3db6$export$156ebd2354e25466);
    $parcel$export(module.exports, "COMMAND_PALETTE_PRESSED_ANALYTICS", ()=>$7691773a5eed3db6$export$7fe859528e87e623);
    $parcel$export(module.exports, "COMMAND_PALETTE_ID", ()=>$7691773a5eed3db6$export$9f646ab88e1d2b14);
    $parcel$export(module.exports, "COMMAND_PALETTE_SECTIONS_PRIORITY", ()=>$7691773a5eed3db6$export$abf26cc5daebd2c8);
    $parcel$export(module.exports, "COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY", ()=>$7691773a5eed3db6$export$12514ca8899b0521);
    $parcel$export(module.exports, "COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY", ()=>$7691773a5eed3db6$export$5fa0bcf59f933c21);
    $parcel$export(module.exports, "COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY", ()=>$7691773a5eed3db6$export$7d9743be0b7d862f);
    $parcel$export(module.exports, "COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY", ()=>$7691773a5eed3db6$export$b4e1633c86db2b70);
    $parcel$export(module.exports, "COMMAND_PALETTE_HELP_PRIORITY", ()=>$7691773a5eed3db6$export$5e5a87aac5d9771f);
    var $7691773a5eed3db6$export$16b06d29ef8f802b;
    (function(COMMAND_PALETTE_SECTIONS) {
        COMMAND_PALETTE_SECTIONS["quickSearch"] = "quick-search";
        COMMAND_PALETTE_SECTIONS["projectNavigation"] = "project-navigation";
        COMMAND_PALETTE_SECTIONS["siteNavigation"] = "site-navigation";
        COMMAND_PALETTE_SECTIONS["help"] = "help";
        COMMAND_PALETTE_SECTIONS["quickActions"] = "quick-actions";
        COMMAND_PALETTE_SECTIONS["personalSettings"] = "personal-settings";
        COMMAND_PALETTE_SECTIONS["jiraSettings"] = "jira-settings";
        COMMAND_PALETTE_SECTIONS["atlassianAdmin"] = "atlassian-admin";
    })($7691773a5eed3db6$export$16b06d29ef8f802b || ($7691773a5eed3db6$export$16b06d29ef8f802b = {}));
    const $7691773a5eed3db6$export$156ebd2354e25466 = 'issueActions';
    const $7691773a5eed3db6$export$7fe859528e87e623 = {
        action: 'pressed',
        actionSubject: 'commandPaletteKeyboardShortcut'
    };
    const $7691773a5eed3db6$export$9f646ab88e1d2b14 = 'commandPalette';
    var $7691773a5eed3db6$export$abf26cc5daebd2c8;
    (function(COMMAND_PALETTE_SECTIONS_PRIORITY) {
        COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["quickSearch"] = 0] = "quickSearch";
        COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["issueActions"] = 1] = "issueActions";
        COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["projectNavigation"] = 2] = "projectNavigation";
        COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["quickActions"] = 3] = "quickActions";
        COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["siteNavigation"] = 4] = "siteNavigation";
        COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["atlassianAdmin"] = 5] = "atlassianAdmin";
        COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["jiraSettings"] = 6] = "jiraSettings";
        COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["personalSettings"] = 7] = "personalSettings";
        COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["help"] = 8] = "help";
    })($7691773a5eed3db6$export$abf26cc5daebd2c8 || ($7691773a5eed3db6$export$abf26cc5daebd2c8 = {}));
    var $7691773a5eed3db6$export$12514ca8899b0521;
    (function(COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY) {
        COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToBacklog"] = 0] = "goToBacklog";
        COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToBoard"] = 1] = "goToBoard";
        COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToReports"] = 2] = "goToReports";
        COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToTimeline"] = 3] = "goToTimeline";
        COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToIssues"] = 4] = "goToIssues";
    })($7691773a5eed3db6$export$12514ca8899b0521 || ($7691773a5eed3db6$export$12514ca8899b0521 = {}));
    var $7691773a5eed3db6$export$5fa0bcf59f933c21;
    (function(COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY) {
        COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY[COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY["userManagement"] = 0] = "userManagement";
        COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY[COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY["billing"] = 1] = "billing";
    })($7691773a5eed3db6$export$5fa0bcf59f933c21 || ($7691773a5eed3db6$export$5fa0bcf59f933c21 = {}));
    var $7691773a5eed3db6$export$7d9743be0b7d862f;
    (function(COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY) {
        COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToDarkTheme"] = 0] = "switchToDarkTheme";
        COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToLightTheme"] = 1] = "switchToLightTheme";
        COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToSystemTheme"] = 2] = "switchToSystemTheme";
        COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["goToPersonalSettings"] = 3] = "goToPersonalSettings";
        COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["goToAccountSettings"] = 4] = "goToAccountSettings";
    })($7691773a5eed3db6$export$7d9743be0b7d862f || ($7691773a5eed3db6$export$7d9743be0b7d862f = {}));
    var $7691773a5eed3db6$export$b4e1633c86db2b70;
    (function(COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY) {
        COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["viewAllIssues"] = 0] = "viewAllIssues";
        COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToProjects"] = 1] = "goToProjects";
        COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToBoards"] = 2] = "goToBoards";
        COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToFilters"] = 3] = "goToFilters";
        COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToDashboards"] = 4] = "goToDashboards";
        COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToPlans"] = 5] = "goToPlans";
    })($7691773a5eed3db6$export$b4e1633c86db2b70 || ($7691773a5eed3db6$export$b4e1633c86db2b70 = {}));
    var $7691773a5eed3db6$export$5e5a87aac5d9771f;
    (function(COMMAND_PALETTE_HELP_PRIORITY) {
        COMMAND_PALETTE_HELP_PRIORITY[COMMAND_PALETTE_HELP_PRIORITY["getHelp"] = 0] = "getHelp";
        COMMAND_PALETTE_HELP_PRIORITY[COMMAND_PALETTE_HELP_PRIORITY["viewKeyboardShortcuts"] = 1] = "viewKeyboardShortcuts";
    })($7691773a5eed3db6$export$5e5a87aac5d9771f || ($7691773a5eed3db6$export$5e5a87aac5d9771f = {}));
});
parcelRegister("5rVQI", function(module, exports) {
    $parcel$export(module.exports, "COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY", ()=>$c7aab549acec9d6e$export$5ea2dca0a260365d);
    var $c7aab549acec9d6e$export$5ea2dca0a260365d;
    (function(COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY) {
        COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["createIssue"] = 0] = "createIssue";
        COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["searchOnCurrentPage"] = 1] = "searchOnCurrentPage";
        COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["openQuickSearch"] = 2] = "openQuickSearch";
        COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["copyUrl"] = 3] = "copyUrl";
        COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["checkNotifications"] = 4] = "checkNotifications";
    })($c7aab549acec9d6e$export$5ea2dca0a260365d || ($c7aab549acec9d6e$export$5ea2dca0a260365d = {}));
});
parcelRegister("eG9rp", function(module, exports) {
    $parcel$export(module.exports, "useCommandKeywords", ()=>$61ebfb9239c4f8e5$export$4d8fe3ef6385358);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $dYWZb;
    const $61ebfb9239c4f8e5$export$4d8fe3ef6385358 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const getKeywords = (0, $5uXOq.useCallback)((keywordGroup)=>(0, (0, parcelRequire("dYWZb")).messages)[keywordGroup] ? formatMessage((0, (0, parcelRequire("dYWZb")).messages)[keywordGroup]) : undefined, [
            formatMessage
        ]);
        return {
            getKeywords: getKeywords
        };
    };
});
parcelRegister("dYWZb", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$df7d7dd7b88156b7$export$defe85febe8b728c);
    var $7VHMR;
    const $df7d7dd7b88156b7$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        searchYourIssuesSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.search-your-issues-synonyms",
            "defaultMessage": "Find my ideas tickets requests tasks work"
        },
        changeStatusSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.change-status-synonyms",
            "defaultMessage": "Move through workflow  Progress Done Complete transition"
        },
        assignToMeSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.assign-to-me-synonyms",
            "defaultMessage": "self"
        },
        assignIssueSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.assign-issue-synonyms",
            "defaultMessage": "Choose person Give work Pick assignee Select ticket idea"
        },
        startWatchingIssueSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.start-watching-issue-synonyms",
            "defaultMessage": "Follow work Track Unwatch Unfollow"
        },
        backlogSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.backlog-synonyms",
            "defaultMessage": "Inventory Go"
        },
        boardSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.board-synonyms",
            "defaultMessage": "Boards Sprint Kanban Swimlanes Do Go"
        },
        reportsSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.reports-synonyms",
            "defaultMessage": "Summary Insights Burndown Go"
        },
        timelineSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.timeline-synonyms",
            "defaultMessage": "Plan Work calendar Schedule Overview Delivery Go Roadmap"
        },
        quickSearchSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.quick-search-synonyms",
            "defaultMessage": "Search products across Atlassian Go to"
        },
        pageSearchSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.page-search-synonyms",
            "defaultMessage": "Control f Command cmd cntrl Go find ctrl"
        },
        createIssueSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.create-issue-synonyms",
            "defaultMessage": "work Start idea New ticket task"
        },
        switchDarkThemeSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.switch-dark-theme-synonyms",
            "defaultMessage": "light Darkmode lightmode Change Appearance Colours colors nightmode daymode"
        },
        matchSystemThemeSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.match-system-theme-synonyms",
            "defaultMessage": "Sync settings Darkmode lightmode Change Appearance Colours colors nightmode daymode"
        },
        copyCurrentPageUrlSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.copy-current-page-url-synonyms",
            "defaultMessage": "link website address"
        },
        getHelpSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.get-help-synonyms",
            "defaultMessage": "In-product Support Documentation Questions Answers"
        },
        viewKeyboardShortcutsSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.view-keyboard-shortcuts-synonyms",
            "defaultMessage": "Hotkeys Show See"
        },
        editDescriptionSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.edit-description-synonyms",
            "defaultMessage": "Completion criteria Info Information Details Add Write"
        },
        addAttachmentSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.add-attachment-synonyms",
            "defaultMessage": "Attach Upload Document Media"
        },
        addCommentSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.add-comment-synonyms",
            "defaultMessage": "Write Message"
        },
        logWorkSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.log-work-synonyms",
            "defaultMessage": "Track Record hours Time spent"
        },
        addRemoveFlagSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.add-remove-flag-synonyms",
            "defaultMessage": "Unflag Mark Unmark Star Unstar"
        },
        cloneIssueSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.clone-issue-synonyms",
            "defaultMessage": "Copy Duplicate Task Idea Request"
        },
        linkConfluencePageSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.link-confluence-page-synonyms",
            "defaultMessage": "Relate Add Connect"
        },
        addAUrlSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.add-a-url-synonyms",
            "defaultMessage": "Connect Weblink Link Website Domain"
        },
        goToIssuesSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.go-to-issues-synonyms",
            "defaultMessage": "Advanced issue search Project Filter JQL search list View all"
        },
        goToPersonalSettingsSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.go-to-personal-settings-synonyms",
            "defaultMessage": "Preferences Notifications Theme Jira labs"
        },
        goToAccountSettingsSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.go-to-account-settings-synonyms",
            "defaultMessage": "Preferences Privacy Profile Your details Personal information"
        },
        viewAllIssuesSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.view-all-issues-synonyms",
            "defaultMessage": "Site issues JQL View all"
        },
        viewAllProjectsSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.view-all-projects-synonyms",
            "defaultMessage": "List Go"
        },
        viewAllPlansSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.view-all-plans-synonyms",
            "defaultMessage": "List Go"
        },
        viewAllBoardsSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.view-all-boards-synonyms",
            "defaultMessage": "List Go"
        },
        viewAllFiltersSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.view-all-filters-synonyms",
            "defaultMessage": "List Go"
        },
        viewAllDashboardsSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.view-all-dashboards-synonyms",
            "defaultMessage": "List Go"
        },
        checkNotificationsSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.check-notifications-synonyms",
            "defaultMessage": "window See Updates"
        },
        goToUserManagementSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.go-to-user-management-synonyms",
            "defaultMessage": "Permissions"
        }
    });
});
parcelRegister("879xD", function(module, exports) {
    $parcel$export(module.exports, "CommandShortcuts", ()=>$6700f9962d7215c2$export$7ff7e4fe85a5960a);
    var $5uXOq = parcelRequire("5uXOq");
    var $1Kt4o;
    var $556k7;
    var $jh7L9;
    var $3Tty1;
    const $6700f9962d7215c2$export$7ff7e4fe85a5960a = (props)=>{
        const { keyMap: keyMap } = props;
        const mappedCommands = (0, $5uXOq.useMemo)(()=>{
            const commands = [];
            Object.entries(keyMap).forEach(([key, mapItem])=>{
                if (!mapItem.registerInCommandPalette) return;
                const { primaryAction: primaryAction, ...command } = mapItem.registerInCommandPalette;
                let shortcutPrimaryAction;
                if (primaryAction?.type === (0, (0, parcelRequire("jh7L9")).CommandActionType).COMMAND_LIST || primaryAction?.type === (0, (0, parcelRequire("jh7L9")).CommandActionType).PERFORM) shortcutPrimaryAction = primaryAction;
                else if (mapItem.callback) shortcutPrimaryAction = {
                    type: (0, (0, parcelRequire("jh7L9")).CommandActionType).PERFORM,
                    perform: ()=>mapItem.callback()
                };
                commands.push({
                    id: `command-shortcut-${key}`,
                    shortcut: key,
                    ...command,
                    primaryAction: shortcutPrimaryAction
                });
            });
            return commands;
        }, [
            keyMap
        ]);
        const shortcutIds = (0, $5uXOq.useMemo)(()=>mappedCommands.map(({ id: id })=>id).toString(), [
            mappedCommands
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Tty1")).default), props), !!mappedCommands.length && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("556k7")).RegisterCommands), {
            registrationId: (0, (0, parcelRequire("1Kt4o")).COMMAND_PALETTE_REGISTRY_IDS).SHORTCUTS,
            commands: mappedCommands,
            deps: [
                shortcutIds
            ]
        }));
    };
});
parcelRegister("1Kt4o", function(module, exports) {
    $parcel$export(module.exports, "COMMAND_PALETTE_REGISTRY_IDS", ()=>$3add01bee0e3b846$export$689de18177335e39);
    $parcel$export(module.exports, "COMMAND_PALETTE_REGISTRY", ()=>$3add01bee0e3b846$export$96f61eb1261e42c3);
    const $3add01bee0e3b846$export$689de18177335e39 = {
        ADD_CHILD_ISSUE: 'ADD_CHILD_ISSUE',
        ADMIN_NAVIGATION: 'ADMIN_NAVIGATION',
        CHECK_NOTIFICATIONS: 'CHECK_NOTIFICATIONS',
        COPY_URL: 'COPY_URL',
        DESCRIPTION: 'DESCRIPTION',
        ISSUE_ACTIONS: 'ISSUE_ACTIONS',
        ISSUE_FIELD_ASSIGN: 'ISSUE_FIELD_ASSIGN',
        ISSUE_HEADER_ACTIONS: 'ISSUE_HEADER_ACTIONS',
        ISSUE_SUB_HEADER_ACTIONS: 'ISSUE_SUB_HEADER_ACTIONS',
        LOG_WORK: 'LOG_WORK',
        NAVIGATION_COMMANDS: 'NAVIGATION_COMMANDS',
        PARENT: 'PARENT',
        PROJECT_NAVIGATION: 'PROJECT_NAVIGATION',
        QUICK_ADD: 'QUICK_ADD',
        QUICK_SEARCH: 'QUICK_SEARCH',
        SHORTCUTS: 'SHORTCUTS',
        STATUS: 'STATUS',
        STORY_POINTS: 'STORY_POINTS',
        TEST: 'TEST',
        THEME_MODE: 'THEME_MODE'
    };
    const $3add01bee0e3b846$var$teams = {
        Deliveroo: 'Deliveroo'
    };
    const $3add01bee0e3b846$export$96f61eb1261e42c3 = {
        ADMIN_NAVIGATION: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.ADMIN_NAVIGATION,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        CHECK_NOTIFICATIONS: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.CHECK_NOTIFICATIONS,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        COPY_URL: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.COPY_URL,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        DESCRIPTION: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.DESCRIPTION,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        ISSUE_ACTIONS: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.ISSUE_ACTIONS,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        ISSUE_FIELD_ASSIGN: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.ISSUE_FIELD_ASSIGN,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        ISSUE_HEADER_ACTIONS: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.ISSUE_HEADER_ACTIONS,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        ISSUE_SUB_HEADER_ACTIONS: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.ISSUE_SUB_HEADER_ACTIONS,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        LOG_WORK: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.LOG_WORK,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        NAVIGATION_COMMANDS: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.NAVIGATION_COMMANDS,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        PARENT: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.PARENT,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        PROJECT_NAVIGATION: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.PROJECT_NAVIGATION,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        QUICK_ADD: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.QUICK_ADD,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        QUICK_SEARCH: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.QUICK_SEARCH,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        SHORTCUTS: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.SHORTCUTS,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        STATUS: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.STATUS,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        STORY_POINTS: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.STORY_POINTS,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        THEME_MODE: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.THEME_MODE,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        }
    };
});
parcelRegister("556k7", function(module, exports) {
    $parcel$export(module.exports, "RegisterCommands", ()=>$ba0d6dd9c2ef02f6$export$cd555833c78729f1);
    var $5uXOq = parcelRequire("5uXOq");
    var $buHQa;
    const $ba0d6dd9c2ef02f6$export$cd555833c78729f1 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("buHQa")).RegisterCommandsWithRegistry), props);
});
parcelRegister("buHQa", function(module, exports) {
    $parcel$export(module.exports, "RegisterCommandsWithRegistry", ()=>$3f4c8625aa6e8942$export$b8955a01360d2876);
    var $6QoIp;
    function $3f4c8625aa6e8942$export$b8955a01360d2876({ registrationId: registrationId, commands: commands, deps: deps }) {
        (0, (0, parcelRequire("6QoIp")).useRegisterCommandsWithRegistry)(registrationId, commands, deps);
        return null;
    }
});
parcelRegister("6QoIp", function(module, exports) {
    $parcel$export(module.exports, "useRegisterCommandsWithRegistry", ()=>$9d04f6fb396fa7c9$export$8a824ae164ff968d);
    var $5uXOq = parcelRequire("5uXOq");
    var $fIZf0;
    function $9d04f6fb396fa7c9$export$8a824ae164ff968d(registrationId, commands, dependencies = []) {
        const subscribe = (0, (0, parcelRequire("fIZf0")).useSubscribeCommandsWithRegistry)();
        const commandCache = (0, $5uXOq.useRef)(commands);
        (0, $5uXOq.useEffect)(()=>{
            commandCache.current = commands;
        }, [
            commands
        ]);
        (0, $5uXOq.useEffect)(()=>subscribe(registrationId, commandCache.current), [
            ...dependencies,
            subscribe
        ]);
    }
});
parcelRegister("fIZf0", function(module, exports) {
    $parcel$export(module.exports, "useSubscribeCommandsWithRegistry", ()=>$72118e9f2599bc72$export$880fc01e31710b27);
    var $5uXOq = parcelRequire("5uXOq");
    var $d8lE2;
    function $72118e9f2599bc72$export$880fc01e31710b27() {
        const { addCommands: addCommands, removeCommands: removeCommands, updateActiveRegistry: updateActiveRegistry, removeFromActiveRegistry: removeFromActiveRegistry } = (0, (0, parcelRequire("d8lE2")).useActionsCommandPalette)();
        const subscribe = (0, $5uXOq.useCallback)((registrationId, commands)=>{
            updateActiveRegistry(registrationId, commands);
            addCommands(commands);
            return ()=>{
                removeCommands(commands);
                removeFromActiveRegistry(registrationId, commands);
            };
        }, [
            addCommands,
            removeCommands,
            removeFromActiveRegistry,
            updateActiveRegistry
        ]);
        return subscribe;
    }
});
parcelRegister("d8lE2", function(module, exports) {
    $parcel$export(module.exports, "useCommandPalette", ()=>$f75514d959bfcca8$export$6b58f9610017fbb7);
    $parcel$export(module.exports, "useActionsCommandPalette", ()=>$f75514d959bfcca8$export$72aa7bc7c6a83c36);
    $parcel$export(module.exports, "useCommandPaletteAnalyticsAttributes", ()=>$f75514d959bfcca8$export$1f90c8f89f98110e);
    $parcel$export(module.exports, "useCommandPaletteIsOpen", ()=>$f75514d959bfcca8$export$cc979be9b69236df);
    $parcel$export(module.exports, "useCommandPaletteHasChildPopup", ()=>$f75514d959bfcca8$export$a18633b655403b12);
    $parcel$export(module.exports, "useCommandPaletteIsLoaded", ()=>$f75514d959bfcca8$export$af8fd8cd4b048315);
    $parcel$export(module.exports, "useCommandPaletteSessionId", ()=>$f75514d959bfcca8$export$7422170a403e909);
    $parcel$export(module.exports, "useCommandPaletteExpandedCommand", ()=>$f75514d959bfcca8$export$282aa48e4a3afada);
    $parcel$export(module.exports, "useCommandPaletteSearch", ()=>$f75514d959bfcca8$export$96819dfb22ad05d3);
    $parcel$export(module.exports, "useCommandPaletteRegistryCurrentAttribution", ()=>$f75514d959bfcca8$export$f893891deedab3c6);
    $parcel$export(module.exports, "useCommandPaletteUsePerformModeState", ()=>$f75514d959bfcca8$export$bbc05723eb144e03);
    var $5uXOq = parcelRequire("5uXOq");
    var $3sQ5x;
    var $6dDSs;
    var $iXqE5;
    var $gM5ou;
    var $2sRNe;
    const $f75514d959bfcca8$var$initialState = {
        commandPaletteSessionId: '',
        isOpen: false,
        isLoaded: false,
        search: '',
        activeIndex: 0,
        isSearchFieldFocused: false,
        commands: [],
        parentCommand: [],
        sections: [],
        isDisabled: false,
        registry: {},
        activeRegistry: {
            commandRegistry: {},
            registryIds: []
        },
        onClosePendingCommandAction: undefined,
        isLoadChildrenError: false
    };
    const $f75514d959bfcca8$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $f75514d959bfcca8$var$initialState,
        actions: (0, parcelRequire("2sRNe")).actions,
        name: 'commandPalette'
    });
    const $f75514d959bfcca8$export$6b58f9610017fbb7 = (0, (0, parcelRequire("3sQ5x")).createHook)($f75514d959bfcca8$var$store);
    const $f75514d959bfcca8$export$72aa7bc7c6a83c36 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($f75514d959bfcca8$var$store);
    const $f75514d959bfcca8$export$e144a44b650635f4 = (ComponentToRender)=>(props)=>{
            const commandPalette = $f75514d959bfcca8$export$6b58f9610017fbb7();
            return (0, ($parcel$interopDefault($5uXOq))).createElement(ComponentToRender, {
                ...props,
                commandPalette: commandPalette
            });
        };
    const $f75514d959bfcca8$export$56f06313122d0aac = ({ search: search, commandPaletteSessionId: commandPaletteSessionId, expandedCommand: expandedCommand, registry: registry, activeRegistry: activeRegistry })=>({
            wordCount: (0, (0, parcelRequire("gM5ou")).getWordCount)(search),
            queryLength: search.length,
            queryHash: (0, (0, parcelRequire("gM5ou")).getQueryHash)(search),
            commandPaletteSessionId: commandPaletteSessionId,
            cpMenu: expandedCommand?.id || 'rootMenu',
            ...(0, (0, parcelRequire("gM5ou")).getExpandedCommandRegistryAnalytics)(registry, activeRegistry, expandedCommand?.id) || {},
            activeRegistryIds: activeRegistry.registryIds,
            activeRegistryIdsLength: activeRegistry.registryIds.length,
            activeRegistryCommandsLength: Object.keys(activeRegistry.commandRegistry).length,
            relevancyModel: 'v2-string-similarity'
        });
    const $f75514d959bfcca8$export$1f90c8f89f98110e = (0, (0, parcelRequire("3sQ5x")).createHook)($f75514d959bfcca8$var$store, {
        selector: $f75514d959bfcca8$export$56f06313122d0aac
    });
    const $f75514d959bfcca8$export$cc979be9b69236df = (0, (0, parcelRequire("3sQ5x")).createHook)($f75514d959bfcca8$var$store, {
        selector: ({ isOpen: isOpen })=>({
                isOpen: isOpen
            })
    });
    const $f75514d959bfcca8$export$a18633b655403b12 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($f75514d959bfcca8$var$store, {
        selector: (state)=>state.hasPopupOverlay
    });
    const $f75514d959bfcca8$export$af8fd8cd4b048315 = (0, (0, parcelRequire("3sQ5x")).createHook)($f75514d959bfcca8$var$store, {
        selector: ({ isLoaded: isLoaded })=>({
                isLoaded: isLoaded
            })
    });
    const $f75514d959bfcca8$export$4372697329bd9cbe = (0, (0, parcelRequire("3sQ5x")).createHook)($f75514d959bfcca8$var$store, {
        selector: ({ isDisabled: isDisabled })=>({
                isDisabled: isDisabled
            })
    });
    const $f75514d959bfcca8$export$7422170a403e909 = (0, (0, parcelRequire("3sQ5x")).createHook)($f75514d959bfcca8$var$store, {
        selector: ({ commandPaletteSessionId: commandPaletteSessionId })=>({
                commandPaletteSessionId: commandPaletteSessionId
            })
    });
    const $f75514d959bfcca8$export$282aa48e4a3afada = (0, (0, parcelRequire("3sQ5x")).createHook)($f75514d959bfcca8$var$store, {
        selector: ({ expandedCommand: expandedCommand, isOpen: isOpen })=>({
                expandedCommand: expandedCommand,
                isOpen: isOpen
            })
    });
    const $f75514d959bfcca8$export$96819dfb22ad05d3 = (0, (0, parcelRequire("3sQ5x")).createHook)($f75514d959bfcca8$var$store, {
        selector: ({ search: search })=>({
                search: search
            })
    });
    const $f75514d959bfcca8$export$a40e8ae3e53feab0 = (0, (0, parcelRequire("6dDSs")).createSelector)(({ registry: registry, activeRegistry: activeRegistry, expandedCommand: expandedCommand })=>({
            registry: registry,
            activeRegistry: activeRegistry,
            expandedCommand: expandedCommand
        }), ()=>undefined, ({ registry: registry, activeRegistry: activeRegistry, expandedCommand: expandedCommand })=>{
        if (!expandedCommand) return undefined;
        const registryData = (0, (0, parcelRequire("gM5ou")).getRegistryData)(registry, activeRegistry, expandedCommand.id);
        return {
            registryData: registryData,
            analyticsAttributes: registryData
        };
    });
    const $f75514d959bfcca8$export$f893891deedab3c6 = (0, (0, parcelRequire("3sQ5x")).createHook)($f75514d959bfcca8$var$store, {
        selector: $f75514d959bfcca8$export$a40e8ae3e53feab0
    });
    const $f75514d959bfcca8$export$bbc05723eb144e03 = (0, (0, parcelRequire("3sQ5x")).createHook)($f75514d959bfcca8$var$store, {
        selector: ({ commands: commands, search: search, expandedCommand: expandedCommand, childResult: childResult, registry: registry, activeRegistry: activeRegistry })=>({
                commands: commands,
                search: search,
                expandedCommand: expandedCommand,
                childResult: childResult,
                registry: registry,
                activeRegistry: activeRegistry
            })
    });
});
parcelRegister("gM5ou", function(module, exports) {
    $parcel$export(module.exports, "getRegistryData", ()=>$cf289af0c139712c$export$6a1ed481c04a3ae6);
    $parcel$export(module.exports, "getExpandedCommandRegistryAnalytics", ()=>$cf289af0c139712c$export$eb055284806da6e5);
    $parcel$export(module.exports, "getShortcutSpecialCharacters", ()=>$cf289af0c139712c$export$e6994b845b967732);
    $parcel$export(module.exports, "removeShortcutSpecialCharacters", ()=>$cf289af0c139712c$export$cd2a5827eae5f4cf);
    $parcel$export(module.exports, "mergeSections", ()=>$cf289af0c139712c$export$389b0273703d5c48);
    $parcel$export(module.exports, "mergeChildResults", ()=>$cf289af0c139712c$export$60a91e1b94ab4fef);
    $parcel$export(module.exports, "getAnalyticsAttributesFromState", ()=>$cf289af0c139712c$export$4023cd53e5e5fcb8);
    $parcel$export(module.exports, "isSecondaryTrigger", ()=>$cf289af0c139712c$export$daa5beabdf8d9fc3);
    $parcel$export(module.exports, "hasChildren", ()=>$cf289af0c139712c$export$bd5ff50f0e53d41c);
    $parcel$export(module.exports, "getAnalyticsAttributesFromResult", ()=>$cf289af0c139712c$export$bc9cd28438b3ea4b);
    $parcel$export(module.exports, "getQueryHash", ()=>$cf289af0c139712c$export$fa1c95a5ffa92036);
    $parcel$export(module.exports, "getWordCount", ()=>$cf289af0c139712c$export$dba3e2bcdbd49da4);
    $parcel$export(module.exports, "getCommandAction", ()=>$cf289af0c139712c$export$fb6dafa07e60c21a);
    $parcel$export(module.exports, "hasAction", ()=>$cf289af0c139712c$export$e217e69099d082f5);
    $parcel$export(module.exports, "useSetTimeoutAutoClear", ()=>$cf289af0c139712c$export$c3d20e8c1e93a572);
    var $5uXOq = parcelRequire("5uXOq");
    var $bdDiz = parcelRequire("bdDiz");
    var $2f2jJ;
    var $bcTvL;
    var $jh7L9;
    const $cf289af0c139712c$export$6a1ed481c04a3ae6 = (registry, activeRegistry, commandId)=>{
        if (!commandId) return undefined;
        const activeCommandRegistryData = activeRegistry?.commandRegistry?.[commandId];
        const registryData = activeCommandRegistryData?.registryId ? registry[activeCommandRegistryData?.registryId] : undefined;
        return registryData;
    };
    const $cf289af0c139712c$export$eb055284806da6e5 = (registry, activeRegistry, commandId)=>$cf289af0c139712c$export$6a1ed481c04a3ae6(registry, activeRegistry, commandId);
    const $cf289af0c139712c$export$8af60a6897157f84 = (registry, activeRegistry, parentCommands)=>{
        const parentCommandIds = parentCommands?.map((command)=>command.id);
        while(parentCommandIds?.length){
            const nextParentCommandId = parentCommandIds?.pop();
            const registryData = $cf289af0c139712c$export$6a1ed481c04a3ae6(registry, activeRegistry, nextParentCommandId);
            if (registryData) return registryData;
        }
        return undefined;
    };
    const $cf289af0c139712c$export$e6994b845b967732 = ()=>[
            {
                char: ' ',
                replacement: (0, (0, parcelRequire("bcTvL")).SHORTCUT_ELEMENT_TYPES).THEN
            },
            {
                char: '+',
                replacement: (0, (0, parcelRequire("bcTvL")).SHORTCUT_ELEMENT_TYPES).PLUS
            },
            {
                char: '|',
                replacement: (0, (0, parcelRequire("bcTvL")).SHORTCUT_ELEMENT_TYPES).OR
            }
        ];
    const $cf289af0c139712c$export$cd2a5827eae5f4cf = (shortcut)=>{
        const specialChars = $cf289af0c139712c$export$e6994b845b967732();
        let strippedShortcut = shortcut;
        specialChars.forEach(({ char: char })=>{
            strippedShortcut = strippedShortcut.split(char).join('');
        });
        return strippedShortcut.toLowerCase();
    };
    const $cf289af0c139712c$export$389b0273703d5c48 = (sections)=>sections.reduce((acc, curr)=>{
            Object.entries(curr).forEach(([key, entry])=>{
                acc[key] = entry;
            });
            return acc;
        }, {});
    const $cf289af0c139712c$export$60a91e1b94ab4fef = (childResults)=>{
        const commands = [];
        const sections = [];
        childResults.forEach((childResult)=>{
            commands.push(...childResult.commands);
            if (childResult.sections) sections.push(childResult.sections);
        });
        return {
            commands: commands,
            sections: $cf289af0c139712c$export$389b0273703d5c48(sections)
        };
    };
    const $cf289af0c139712c$export$ae8f55d2b67cb8d6 = (text, commonWordsToBeRemoved)=>{
        const commonWords = commonWordsToBeRemoved.toLowerCase().replace(/\s{2,}/g, ' ').trim().split(' ');
        const regexString = commonWords.map((word)=>`\\b${word}\\b`).join('|');
        const regex = new RegExp(regexString, 'g');
        return text.replace(/[.,]/g, '').replace(regex, '').replace(/\s{2,}/g, ' ').trim();
    };
    const $cf289af0c139712c$export$4023cd53e5e5fcb8 = (state, command, method = 'undefined', wasSecondaryTriggered, attributes)=>{
        const analyticsAttributes = {
            commandPaletteId: command.id,
            commandPaletteSessionId: state.commandPaletteSessionId,
            searchTaken: !!state.search,
            method: method,
            cpMenu: 'rootMenu',
            action: command.id,
            actionCategory: 'none',
            wasSecondaryTriggered: wasSecondaryTriggered,
            ...$cf289af0c139712c$export$8af60a6897157f84(state.registry, state.activeRegistry, command.parentCommands) || {},
            ...$cf289af0c139712c$export$6a1ed481c04a3ae6(state.registry, state.activeRegistry, command.id) || {},
            ...$cf289af0c139712c$export$eb055284806da6e5(state.registry, state.activeRegistry, state.expandedCommand?.id) || {},
            ...attributes,
            ...!!command.analytics && command.analytics
        };
        if (state.expandedCommand?.analytics) analyticsAttributes.cpMenu = state.expandedCommand.analytics.action;
        else if (state.expandedCommand?.id) analyticsAttributes.cpMenu = state.expandedCommand.id;
        const sections = state.expandedCommand && state.childResult?.sections ? $cf289af0c139712c$export$389b0273703d5c48([
            ...state.sections,
            state.childResult?.sections
        ]) : $cf289af0c139712c$export$389b0273703d5c48(state.sections);
        const rootCommand = state.parentCommand?.[0] || state.expandedCommand || command;
        const rootSection = rootCommand.section ? sections?.[rootCommand.section] : undefined;
        analyticsAttributes.actionCategory = rootSection?.actionCategory || rootCommand?.section || rootCommand?.analytics?.actionCategory || (command?.section ? sections?.[command?.section]?.actionCategory || command?.section : undefined) || analyticsAttributes.actionCategory;
        return analyticsAttributes;
    };
    const $cf289af0c139712c$export$daa5beabdf8d9fc3 = (event)=>(0, (0, parcelRequire("2f2jJ")).isMacOs)() ? event.metaKey : event.ctrlKey;
    const $cf289af0c139712c$export$bd5ff50f0e53d41c = (command)=>{
        if (command?.wasSecondaryTriggered) {
            if (command?.secondaryAction?.type) {
                const hasSecondaryChildren = (0, (0, parcelRequire("jh7L9")).COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.secondaryAction?.type);
                return hasSecondaryChildren;
            }
            return (0, (0, parcelRequire("jh7L9")).COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.primaryAction?.type);
        }
        return (0, (0, parcelRequire("jh7L9")).COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.primaryAction?.type);
    };
    const $cf289af0c139712c$export$bc9cd28438b3ea4b = (result)=>{
        if (result) return {
            globalIndex: result.index,
            sectionIndex: result.sectionIndex,
            indexWithinSection: result.indexWithinSection,
            sectionId: result.sectionId
        };
        return {};
    };
    const $cf289af0c139712c$export$fa1c95a5ffa92036 = (str)=>(0, $bdDiz.createHash)().update(str).digest('hex');
    const $cf289af0c139712c$export$dba3e2bcdbd49da4 = (str)=>str.length > 0 ? str.split(/\s+/).length : 0;
    const $cf289af0c139712c$export$fb6dafa07e60c21a = (command, wasSecondaryTriggered)=>{
        if (!command) return null;
        const { secondaryAction: secondaryAction, primaryAction: primaryAction } = command;
        if (!primaryAction) return null;
        const commandAction = wasSecondaryTriggered && secondaryAction ? secondaryAction : primaryAction;
        return {
            ...commandAction
        };
    };
    const $cf289af0c139712c$export$e217e69099d082f5 = (command)=>Boolean(command.primaryAction || command.secondaryAction);
    const $cf289af0c139712c$export$c3d20e8c1e93a572 = ()=>{
        const timeoutRef = (0, $5uXOq.useRef)();
        (0, $5uXOq.useEffect)(()=>()=>{
                if (timeoutRef.current) clearTimeout(timeoutRef.current);
            }, []);
        const setTimeoutAutoClear = (...args)=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
            timeoutRef.current = setTimeout(...args);
        };
        return {
            setTimeoutAutoClear: setTimeoutAutoClear
        };
    };
});
parcelRegister("2f2jJ", function(module, exports) {
    $parcel$export(module.exports, "isMacOs", ()=>$6846128323867ebd$export$c5e71f489eb3970b);
    $parcel$export(module.exports, "getShortcutModifierKey", ()=>$6846128323867ebd$export$fe66dae91c68619b);
    const $6846128323867ebd$export$c5e71f489eb3970b = ()=>/Mac/i.test(window?.navigator?.platform);
    const $6846128323867ebd$export$fe66dae91c68619b = ()=>$6846128323867ebd$export$c5e71f489eb3970b() ? 'meta' : 'ctrl';
});
parcelRegister("bcTvL", function(module, exports) {
    $parcel$export(module.exports, "UI_EVENT_TYPE", ()=>$3996a4302dca83b1$export$a1562d08625f5d7e);
    $parcel$export(module.exports, "TRACK_EVENT_TYPE", ()=>$3996a4302dca83b1$export$947dac6c72b26f81);
    $parcel$export(module.exports, "SHORTCUT_ELEMENT_TYPES", ()=>$3996a4302dca83b1$export$1ee9d153576afd13);
    $parcel$export(module.exports, "COMMAND_PALETTE_DEBOUNCE_DEFAULT", ()=>$3996a4302dca83b1$export$894e19fc96687503);
    const $3996a4302dca83b1$export$a1562d08625f5d7e = 'UI';
    const $3996a4302dca83b1$export$947dac6c72b26f81 = 'TRACK';
    const $3996a4302dca83b1$export$f1d537d508d2945a = 'SCREEN';
    const $3996a4302dca83b1$export$12346a674644c156 = 'OPERATIONAL';
    var $3996a4302dca83b1$export$1ee9d153576afd13;
    (function(SHORTCUT_ELEMENT_TYPES) {
        SHORTCUT_ELEMENT_TYPES["THEN"] = "then";
        SHORTCUT_ELEMENT_TYPES["OR"] = "or";
        SHORTCUT_ELEMENT_TYPES["PLUS"] = "plus";
        SHORTCUT_ELEMENT_TYPES["KEY"] = "key";
    })($3996a4302dca83b1$export$1ee9d153576afd13 || ($3996a4302dca83b1$export$1ee9d153576afd13 = {}));
    const $3996a4302dca83b1$export$894e19fc96687503 = 250;
});
parcelRegister("jh7L9", function(module, exports) {
    $parcel$export(module.exports, "CommandActionType", ()=>$b1e48ebd4c8d5e4e$export$f041b1b117ab382f);
    $parcel$export(module.exports, "COMMAND_WITH_CHILDREN", ()=>$b1e48ebd4c8d5e4e$export$904b2a0e38a1bef3);
    var $b1e48ebd4c8d5e4e$export$f041b1b117ab382f;
    (function(CommandActionType) {
        CommandActionType["PERFORM"] = "perform";
        CommandActionType["COMMAND_LIST"] = "command-list";
    })($b1e48ebd4c8d5e4e$export$f041b1b117ab382f || ($b1e48ebd4c8d5e4e$export$f041b1b117ab382f = {}));
    const $b1e48ebd4c8d5e4e$export$3e448fd53031e13c = Object.values($b1e48ebd4c8d5e4e$export$f041b1b117ab382f);
    const $b1e48ebd4c8d5e4e$export$904b2a0e38a1bef3 = [
        "command-list"
    ];
});
parcelRegister("2sRNe", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$4f4c9e92d50d4f24$export$e324594224ef24da);
    var $kGsr8 = parcelRequire("kGsr8");
    var $7Jxgt = parcelRequire("7Jxgt");
    var $e7WVN;
    var $eTXmK;
    var $2f2jJ;
    var $jcw0u;
    var $bcTvL;
    var $jh7L9;
    var $gM5ou;
    var $4DwnT;
    var $h3eZO;
    const $4f4c9e92d50d4f24$var$rootCommands = {
        parentCommand: [],
        expandedCommand: undefined,
        childCommands: undefined,
        childResult: undefined
    };
    const $4f4c9e92d50d4f24$var$open = ()=>({ setState: setState, getState: getState })=>{
            if (getState().isDisabled) return;
            setState({
                commandPaletteSessionId: (0, ($parcel$interopDefault($7Jxgt))).v4(),
                isOpen: true,
                activeIndex: 0,
                search: ''
            });
        };
    const $4f4c9e92d50d4f24$var$close = ()=>({ setState: setState })=>{
            setState({
                isOpen: false,
                commandPaletteSessionId: '',
                search: '',
                ...$4f4c9e92d50d4f24$var$rootCommands
            });
        };
    const $4f4c9e92d50d4f24$var$toggle = ()=>({ setState: setState, getState: getState })=>{
            const isOpen = !getState().isOpen;
            setState({
                isOpen: isOpen,
                activeIndex: 0,
                search: '',
                commandPaletteSessionId: isOpen ? (0, ($parcel$interopDefault($7Jxgt))).v4() : '',
                ...!isOpen ? $4f4c9e92d50d4f24$var$rootCommands : {}
            });
        };
    const $4f4c9e92d50d4f24$var$addCommands = (commands)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const newCommands = currentState.commands.concat(commands);
            const newState = {
                commands: newCommands
            };
            if (currentState.expandedCommand) {
                const matchedExpandedCommand = commands.filter((command)=>command.id === currentState.expandedCommand?.id);
                if (matchedExpandedCommand.length === 1) {
                    const [updatedExpandedCommand] = matchedExpandedCommand;
                    newState.expandedCommand = updatedExpandedCommand;
                }
            }
            setState(newState);
        };
    const $4f4c9e92d50d4f24$var$removeCommands = (commands)=>({ setState: setState, getState: getState })=>{
            const newCommands = getState().commands.filter((command)=>!commands.includes(command));
            setState({
                commands: newCommands
            });
        };
    const $4f4c9e92d50d4f24$var$removeCommandsById = (commandIds)=>({ setState: setState, getState: getState })=>{
            const newCommands = getState().commands.filter((command)=>!commandIds.includes(command.id));
            setState({
                commands: newCommands
            });
        };
    const $4f4c9e92d50d4f24$var$handleSearch = (search)=>({ setState: setState })=>{
            setState({
                search: search,
                activeIndex: 0
            });
        };
    const $4f4c9e92d50d4f24$var$forceSearchValue = (search)=>({ setState: setState })=>{
            setState({
                search: search,
                shouldForceSearchValue: true
            });
        };
    const $4f4c9e92d50d4f24$var$resetShouldForceSearchValue = ()=>({ setState: setState })=>{
            setState({
                shouldForceSearchValue: false
            });
        };
    const $4f4c9e92d50d4f24$var$goBackLevel = (goToRoot, analytics)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (!currentState.expandedCommand) return;
            const newState = {
                search: '',
                activeIndex: 0,
                childResult: undefined,
                forceSearchFocus: true
            };
            if (currentState.parentCommand.length && !goToRoot) {
                newState.expandedCommand = currentState.parentCommand[currentState.parentCommand.length - 1];
                newState.parentCommand = currentState.parentCommand.slice(0, currentState.parentCommand.length - 1);
                if (newState.expandedCommand?.primaryAction?.type === (0, (0, parcelRequire("jh7L9")).CommandActionType).COMMAND_LIST && newState.expandedCommand?.primaryAction?.commands) newState.childResult = {
                    commands: newState.expandedCommand?.primaryAction?.commands,
                    sections: newState.expandedCommand?.primaryAction?.sections
                };
            } else {
                newState.loadingList = false;
                newState.parentCommand = [];
                newState.expandedCommand = undefined;
                newState.childResult = undefined;
            }
            if (currentState?.onAnalytics && analytics?.createAnalyticsEvent) currentState.onAnalytics(analytics.createAnalyticsEvent({
                action: 'navigation',
                actionSubject: 'commandPalette'
            }), (0, (0, parcelRequire("bcTvL")).TRACK_EVENT_TYPE), {
                attributes: {
                    cpMenu: currentState.expandedCommand?.id || 'rootMenu',
                    searchSessionId: currentState.commandPaletteSessionId,
                    action: goToRoot ? 'backToRoot' : 'backToParent',
                    actionCategory: 'back',
                    method: analytics?.method
                }
            });
            setState(newState);
        };
    const $4f4c9e92d50d4f24$var$forceFocusSearch = (forceSearchFocus = false)=>({ setState: setState })=>{
            setState({
                forceSearchFocus: forceSearchFocus
            });
        };
    const $4f4c9e92d50d4f24$var$setActiveIndex = (index)=>({ setState: setState, getState: getState })=>{
            const { isSearchFieldFocused: isSearchFieldFocused } = getState();
            setState({
                activeIndex: index,
                ...!isSearchFieldFocused ? {
                    forceSearchFocus: true
                } : {}
            });
        };
    const $4f4c9e92d50d4f24$var$getAnalyticsAttributes = (command, method, wasSecondaryTriggered = false, attributes = {})=>({ getState: getState })=>(0, (0, parcelRequire("gM5ou")).getAnalyticsAttributesFromState)(getState(), command, method, wasSecondaryTriggered, attributes);
    const $4f4c9e92d50d4f24$var$performDialogCloseCommand = ()=>({ setState: setState, getState: getState })=>{
            setTimeout(()=>{
                const { onClosePendingCommandAction: onClosePendingCommandAction, onAnalytics: onAnalytics } = getState();
                if (onClosePendingCommandAction !== undefined) {
                    try {
                        (0, (0, parcelRequire("eTXmK")).default)('command-palette-executed');
                        onClosePendingCommandAction.perform();
                        if (onAnalytics && onClosePendingCommandAction?.createAnalyticsEvent) {
                            const performAnalyticsEvent = onClosePendingCommandAction?.createAnalyticsEvent({
                                action: 'taskSucceeded',
                                actionSubject: 'commandPalette'
                            });
                            onAnalytics(performAnalyticsEvent, (0, (0, parcelRequire("bcTvL")).TRACK_EVENT_TYPE), {
                                attributes: onClosePendingCommandAction?.analyticsArgs
                            });
                        }
                    } catch (err) {
                        const error = err instanceof Error ? err : new Error('Command palette perform error');
                        (0, (0, parcelRequire("jcw0u")).default)({
                            error: error,
                            meta: {
                                id: 'compal.performDialogCloseCommand',
                                packageName: 'jiraCommandPalette',
                                teamName: typeof onClosePendingCommandAction?.analyticsArgs?.teamName === 'string' ? onClosePendingCommandAction?.analyticsArgs.teamName : 'deliveroo'
                            },
                            attributes: onClosePendingCommandAction.analyticsArgs
                        });
                        (0, (0, parcelRequire("e7WVN")).setInteractionError)('command-palette-executed', {
                            errorMessage: error.message,
                            name: 'performDialogCloseCommandPerformError'
                        });
                    }
                    setState({
                        onClosePendingCommandAction: undefined
                    });
                }
            }, 0);
        };
    const $4f4c9e92d50d4f24$var$executeCommand = (command, analytics, wasSecondaryTriggered = false)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const newState = {
                ...!(0, (0, parcelRequire("4DwnT")).getActiveCommandList)(command, wasSecondaryTriggered)?.keepSearch && {
                    search: ''
                },
                activeIndex: 0
            };
            const analyticsAttributes = (0, (0, parcelRequire("gM5ou")).getAnalyticsAttributesFromState)(currentState, command, analytics?.method || 'undefined', wasSecondaryTriggered, analytics?.attributes);
            const currentCommandAction = (0, (0, parcelRequire("gM5ou")).getCommandAction)(command, wasSecondaryTriggered);
            if (!currentCommandAction) return;
            if (currentState?.onAnalytics && analytics?.createAnalyticsEvent) {
                const analyticsEvent = analytics.createAnalyticsEvent({
                    action: 'navigation',
                    actionSubject: 'commandPalette'
                });
                currentState.onAnalytics(analyticsEvent, (0, (0, parcelRequire("bcTvL")).TRACK_EVENT_TYPE), {
                    attributes: analyticsAttributes
                });
            }
            const shouldLoadChildren = (0, (0, parcelRequire("gM5ou")).hasChildren)({
                ...command,
                wasSecondaryTriggered: wasSecondaryTriggered
            });
            const shouldExecutePerform = currentCommandAction?.type === (0, (0, parcelRequire("jh7L9")).CommandActionType).PERFORM;
            if (shouldLoadChildren) {
                (0, (0, parcelRequire("eTXmK")).default)('command-palette-load-child-command-list');
                if (currentState.expandedCommand) newState.parentCommand = [
                    ...currentState.parentCommand,
                    currentState.expandedCommand
                ];
                newState.expandedCommand = {
                    ...command,
                    wasSecondaryTriggered: wasSecondaryTriggered
                };
                newState.childResult = undefined;
                newState.forceSearchFocus = true;
                if ((0, (0, parcelRequire("h3eZO")).isSearchableChildrenAction)(currentCommandAction)) {
                    newState.childResult = {
                        commands: currentCommandAction.commands,
                        sections: currentCommandAction.sections
                    };
                    if (command.parentCommands?.length) newState.parentCommand = [
                        ...newState.parentCommand || [],
                        ...command.parentCommands
                    ];
                } else newState.childResult = undefined;
                setState(newState);
                if (currentCommandAction.type === (0, (0, parcelRequire("jh7L9")).CommandActionType).COMMAND_LIST && currentCommandAction.onClick) currentCommandAction.onClick();
            } else if (shouldExecutePerform) {
                if (!currentCommandAction.preventModalClose) {
                    newState.commandPaletteSessionId = '';
                    newState.isOpen = false;
                    newState.expandedCommand = undefined;
                    newState.parentCommand = [];
                    newState.childResult = undefined;
                    setState(newState);
                    if (currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                        const closeAnalyticsEvent = analytics.createAnalyticsEvent({
                            action: 'closed',
                            actionSubject: 'commandPalette'
                        });
                        currentState.onAnalytics(closeAnalyticsEvent, (0, (0, parcelRequire("bcTvL")).UI_EVENT_TYPE), {
                            attributes: analyticsAttributes
                        });
                    }
                }
                if (wasSecondaryTriggered && currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                    const closeAnalyticsEvent = analytics.createAnalyticsEvent({
                        action: 'secondaryAction',
                        actionSubject: 'commandPalette'
                    });
                    currentState.onAnalytics(closeAnalyticsEvent, (0, (0, parcelRequire("bcTvL")).TRACK_EVENT_TYPE), {
                        attributes: {
                            ...analyticsAttributes,
                            keyPressed: (0, (0, parcelRequire("2f2jJ")).isMacOs)() ? 'cmdEnter' : 'ctrlEnter',
                            ...currentCommandAction.analyticsArgs
                        }
                    });
                }
                if (currentCommandAction.preventModalClose) try {
                    (0, (0, parcelRequire("eTXmK")).default)('command-palette-executed');
                    currentCommandAction.perform();
                    if (currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                        const performAnalyticsEvent = analytics.createAnalyticsEvent({
                            action: 'taskSucceeded',
                            actionSubject: 'commandPalette'
                        });
                        currentState.onAnalytics(performAnalyticsEvent, (0, (0, parcelRequire("bcTvL")).TRACK_EVENT_TYPE), {
                            attributes: analyticsAttributes
                        });
                    }
                } catch (err) {
                    const error = err instanceof Error ? err : new Error('Command palette perform error');
                    (0, (0, parcelRequire("jcw0u")).default)({
                        error: error,
                        meta: {
                            id: 'compal.executeCommand',
                            packageName: 'jiraCommandPalette',
                            teamName: typeof analytics?.attributes?.teamName === 'string' ? analytics?.attributes.teamName : 'deliveroo'
                        },
                        attributes: analytics?.attributes
                    });
                    (0, (0, parcelRequire("e7WVN")).setInteractionError)('command-palette-executed', {
                        errorMessage: error.message,
                        name: 'executeCommandPerformError'
                    });
                }
                else setState({
                    onClosePendingCommandAction: {
                        ...currentCommandAction,
                        analyticsArgs: analyticsAttributes,
                        createAnalyticsEvent: analytics?.createAnalyticsEvent
                    }
                });
            }
        };
    const $4f4c9e92d50d4f24$var$setChildCommands = (childResult)=>({ setState: setState })=>{
            setState({
                childResult: childResult
            });
        };
    const $4f4c9e92d50d4f24$var$setLoadingList = (loadingList)=>({ setState: setState })=>{
            setState({
                loadingList: loadingList
            });
        };
    const $4f4c9e92d50d4f24$var$setFocusInput = (isSearchFieldFocused)=>({ setState: setState })=>setState({
                isSearchFieldFocused: isSearchFieldFocused
            });
    const $4f4c9e92d50d4f24$var$registerSections = (newSections)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const sections = currentState.sections.slice(0);
            sections.push(newSections);
            setState({
                sections: sections
            });
        };
    const $4f4c9e92d50d4f24$var$unregisterSections = (newSections)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const sections = currentState.sections.filter((section)=>section !== newSections);
            setState({
                sections: sections
            });
        };
    const $4f4c9e92d50d4f24$var$markAsLoaded = ()=>({ setState: setState })=>{
            setState({
                isLoaded: true
            });
        };
    const $4f4c9e92d50d4f24$var$setIsDisabled = (isDisabled)=>({ setState: setState })=>{
            setState({
                isDisabled: isDisabled,
                ...isDisabled ? {
                    isOpen: false
                } : {}
            });
        };
    const $4f4c9e92d50d4f24$var$setRegistry = (registry)=>({ setState: setState })=>{
            setState({
                registry: registry
            });
        };
    const $4f4c9e92d50d4f24$var$updateActiveRegistry = (registryId, commands)=>({ setState: setState, getState: getState })=>{
            const currentActiveRegistry = getState().activeRegistry;
            const activeRegistry = {
                commandRegistry: {
                    ...currentActiveRegistry.commandRegistry,
                    ...commands.reduce((acc, command)=>{
                        acc[command.id] = {
                            registryId: registryId
                        };
                        return acc;
                    }, {})
                },
                registryIds: (0, ($parcel$interopDefault($kGsr8)))([
                    ...currentActiveRegistry.registryIds,
                    registryId
                ])
            };
            setState({
                activeRegistry: activeRegistry
            });
        };
    const $4f4c9e92d50d4f24$var$removeFromActiveRegistry = (registryId, commands)=>({ setState: setState, getState: getState })=>{
            const currentActiveRegistry = getState().activeRegistry;
            const commandRegistry = {
                ...currentActiveRegistry.commandRegistry
            };
            commands.forEach((command)=>{
                delete commandRegistry[command.id];
            });
            setState({
                activeRegistry: {
                    commandRegistry: commandRegistry,
                    registryIds: currentActiveRegistry.registryIds.filter((id)=>id !== registryId)
                }
            });
        };
    const $4f4c9e92d50d4f24$var$setAnalytics = (onAnalytics, onErrorAnalytics)=>({ setState: setState })=>{
            setState({
                onAnalytics: onAnalytics,
                onErrorAnalytics: onErrorAnalytics
            });
        };
    const $4f4c9e92d50d4f24$var$setFallbackOverride = (fallbackOverride)=>({ setState: setState })=>{
            setState({
                fallbackOverride: fallbackOverride
            });
        };
    const $4f4c9e92d50d4f24$var$setHasPopupOverlay = (hasPopupOverlay)=>({ setState: setState })=>{
            setState({
                hasPopupOverlay: hasPopupOverlay
            });
        };
    const $4f4c9e92d50d4f24$export$e324594224ef24da = {
        open: $4f4c9e92d50d4f24$var$open,
        toggle: $4f4c9e92d50d4f24$var$toggle,
        close: $4f4c9e92d50d4f24$var$close,
        addCommands: $4f4c9e92d50d4f24$var$addCommands,
        removeCommands: $4f4c9e92d50d4f24$var$removeCommands,
        handleSearch: $4f4c9e92d50d4f24$var$handleSearch,
        forceFocusSearch: $4f4c9e92d50d4f24$var$forceFocusSearch,
        setActiveIndex: $4f4c9e92d50d4f24$var$setActiveIndex,
        executeCommand: $4f4c9e92d50d4f24$var$executeCommand,
        goBackLevel: $4f4c9e92d50d4f24$var$goBackLevel,
        setChildCommands: $4f4c9e92d50d4f24$var$setChildCommands,
        setLoadingList: $4f4c9e92d50d4f24$var$setLoadingList,
        setFocusInput: $4f4c9e92d50d4f24$var$setFocusInput,
        registerSections: $4f4c9e92d50d4f24$var$registerSections,
        unregisterSections: $4f4c9e92d50d4f24$var$unregisterSections,
        markAsLoaded: $4f4c9e92d50d4f24$var$markAsLoaded,
        getAnalyticsAttributes: $4f4c9e92d50d4f24$var$getAnalyticsAttributes,
        setIsDisabled: $4f4c9e92d50d4f24$var$setIsDisabled,
        setRegistry: $4f4c9e92d50d4f24$var$setRegistry,
        updateActiveRegistry: $4f4c9e92d50d4f24$var$updateActiveRegistry,
        removeCommandsById: $4f4c9e92d50d4f24$var$removeCommandsById,
        removeFromActiveRegistry: $4f4c9e92d50d4f24$var$removeFromActiveRegistry,
        performDialogCloseCommand: $4f4c9e92d50d4f24$var$performDialogCloseCommand,
        setAnalytics: $4f4c9e92d50d4f24$var$setAnalytics,
        setFallbackOverride: $4f4c9e92d50d4f24$var$setFallbackOverride,
        setHasPopupOverlay: $4f4c9e92d50d4f24$var$setHasPopupOverlay,
        forceSearchValue: $4f4c9e92d50d4f24$var$forceSearchValue,
        resetShouldForceSearchValue: $4f4c9e92d50d4f24$var$resetShouldForceSearchValue
    };
});
parcelRegister("4DwnT", function(module, exports) {
    $parcel$export(module.exports, "getActiveCommandList", ()=>$b4088022dc3f5c54$export$639b7f41b0b47a01);
    var $jh7L9;
    const $b4088022dc3f5c54$export$639b7f41b0b47a01 = (expandedCommand, wasSecondaryTriggered)=>{
        if (wasSecondaryTriggered && expandedCommand?.secondaryAction?.type === (0, (0, parcelRequire("jh7L9")).CommandActionType).COMMAND_LIST) return expandedCommand.secondaryAction;
        if (!wasSecondaryTriggered && expandedCommand?.primaryAction?.type === (0, (0, parcelRequire("jh7L9")).CommandActionType).COMMAND_LIST) return expandedCommand.primaryAction;
        return null;
    };
});
parcelRegister("h3eZO", function(module, exports) {
    $parcel$export(module.exports, "isSearchableChildrenAction", ()=>$dd5db8363c7eeda7$export$d75616d77443fe4e);
    var $jh7L9;
    const $dd5db8363c7eeda7$export$d75616d77443fe4e = (action)=>action?.type === (0, (0, parcelRequire("jh7L9")).CommandActionType).COMMAND_LIST && action.commands !== undefined;
});
parcelRegister("3Tty1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6ba57d5dc6c0de0a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9IeM0;
    var $4lkOX;
    var $h0GOb;
    var $k4r7E;
    var $9fuVs;
    var $kspvB;
    let $6ba57d5dc6c0de0a$var$shortcutsCount = 0;
    let $6ba57d5dc6c0de0a$var$subscription = null;
    const $6ba57d5dc6c0de0a$var$ShortcutsSubscriber = false ? ()=>null : ({ keyMap: keyMap, label: label, location: location })=>{
        const parentRegistry = (0, $5uXOq.useContext)((0, (0, parcelRequire("9fuVs")).ShortcutRegistryContext)) || (0, (0, parcelRequire("k4r7E")).rootRegistry);
        const addKeyMap = (0, $5uXOq.useCallback)(()=>parentRegistry.addKeyMap(()=>({
                    keyMap: (0, (0, parcelRequire("kspvB")).bindKeyMapWithErrorHandling)(keyMap, location),
                    label: label
                })), [
            label,
            parentRegistry,
            keyMap,
            location
        ]);
        (0, $5uXOq.useEffect)(()=>{
            $6ba57d5dc6c0de0a$var$shortcutsCount += 1;
            const removeKeyMap = addKeyMap();
            return ()=>{
                removeKeyMap();
                $6ba57d5dc6c0de0a$var$shortcutsCount -= 1;
                if ($6ba57d5dc6c0de0a$var$subscription && $6ba57d5dc6c0de0a$var$shortcutsCount === 0) {
                    $6ba57d5dc6c0de0a$var$subscription.unsubscribe();
                    $6ba57d5dc6c0de0a$var$subscription = null;
                }
            };
        }, [
            addKeyMap
        ]);
        (0, $5uXOq.useEffect)(()=>{
            $6ba57d5dc6c0de0a$var$subscription = $6ba57d5dc6c0de0a$var$subscription || (0, (0, parcelRequire("h0GOb")).default)().subscribe((0, (0, parcelRequire("4lkOX")).default));
        }, [
            parentRegistry,
            keyMap
        ]);
        return null;
    };
    var $6ba57d5dc6c0de0a$export$2e2bcd8739ae039 = ({ useKeyboardShortcutsToggle: useKeyboardShortcutsToggle = (0, (0, parcelRequire("9IeM0")).useKeyboardShortcutsToggle), ...props })=>{
        const [{ isEnabled: isEnabled }] = useKeyboardShortcutsToggle();
        return isEnabled && !false ? (0, ($parcel$interopDefault($5uXOq))).createElement($6ba57d5dc6c0de0a$var$ShortcutsSubscriber, props) : null;
    };
});
parcelRegister("9IeM0", function(module, exports) {
    $parcel$export(module.exports, "useKeyboardShortcutsToggle", ()=>$dc712fc9bec05022$export$a33a81f1fc5458ad);
    var $jcw0u;
    var $eusud;
    var $j8DrX;
    var $8zOmE;
    var $3sQ5x;
    var $iXqE5;
    const $dc712fc9bec05022$var$URL_FRAGMENT = '/rest/internal/latest/user/preferences/keyboardShortcuts?turn=';
    const $dc712fc9bec05022$export$b62f67be35e65859 = (analyticsEvent)=>async ({ setState: setState, getState: getState })=>{
            const currentState = getState().isEnabled;
            const status = currentState ? 'off' : 'on';
            const url = `${$dc712fc9bec05022$var$URL_FRAGMENT}${status}`;
            try {
                await (0, (0, parcelRequire("eusud")).performPutRequest)(url);
                setState({
                    isEnabled: !currentState,
                    error: null
                });
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'keyboardShortcutsToggle', {
                    isEnabled: !currentState
                });
            } catch (err) {
                setState({
                    error: err
                });
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'keyboardShortcutToggleFailure',
                        packageName: 'jiraCommonLegacyDoNotAddAnythingNew'
                    },
                    error: err
                });
            }
        };
    const $dc712fc9bec05022$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            isEnabled: false ? false : !((0, (0, parcelRequire("j8DrX")).default)('ajs-keyboard-shortcuts-enabled') === 'false'),
            error: null
        },
        actions: {
            toggle: $dc712fc9bec05022$export$b62f67be35e65859
        }
    });
    const $dc712fc9bec05022$export$a33a81f1fc5458ad = (0, (0, parcelRequire("3sQ5x")).createHook)($dc712fc9bec05022$var$Store);
});
parcelRegister("4lkOX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f11d50ddafbb6f85$export$2e2bcd8739ae039);
    var $h0GOb;
    var $k4r7E;
    const $f11d50ddafbb6f85$var$matches = (prefix)=>(definedSequence)=>definedSequence.startsWith(`${prefix} `);
    var $f11d50ddafbb6f85$export$2e2bcd8739ae039 = (keySequence)=>{
        const { sequence: sequence, e: e } = keySequence || {};
        const activeKeyMap = (0, (0, parcelRequire("k4r7E")).rootRegistry).getActiveKeyMap();
        if (sequence !== undefined && activeKeyMap[sequence]) {
            activeKeyMap[sequence].callback(e);
            (0, (0, parcelRequire("h0GOb")).flush)();
        } else {
            const isFutureMatchPossible = sequence !== undefined && Object.keys(activeKeyMap).some($f11d50ddafbb6f85$var$matches(sequence));
            if (!isFutureMatchPossible) (0, (0, parcelRequire("h0GOb")).flush)();
        }
    };
});
parcelRegister("h0GOb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$849cd54ac4017470$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "flush", ()=>$849cd54ac4017470$export$4909b86c8034bf73);
    var $kVLXA = parcelRequire("kVLXA");
    var $cab1K = parcelRequire("cab1K");
    parcelRequire("jG6Un");
    parcelRequire("eSGL3");
    parcelRequire("1oQta");
    parcelRequire("4kRRr");
    parcelRequire("d0pqD");
    parcelRequire("iQCJJ");
    parcelRequire("fjPtF");
    parcelRequire("2R2to");
    var $lIZQG;
    const $849cd54ac4017470$var$ignoredKeys = {
        Control: true,
        Meta: true,
        Shift: true,
        Alt: true,
        AltGraph: true,
        CapsLock: true,
        Fn: true,
        FnLock: true,
        Hyper: true,
        NumLock: true,
        OS: true,
        ScrollLock: true,
        Super: true,
        Symbol: true,
        SymbolLock: true
    };
    const $849cd54ac4017470$var$isNonTextInput = ({ inputMode: inputMode = '', type: type })=>inputMode === 'none' || type === 'checkbox';
    const $849cd54ac4017470$var$isEditable = (node)=>node.nodeName === 'INPUT' && !$849cd54ac4017470$var$isNonTextInput(node) || node.nodeName === 'TEXTAREA' || node.isContentEditable === true;
    const $849cd54ac4017470$var$isRelevantKeyEvent = (e)=>typeof e.key === 'string' && (e.key === 'Escape' || !$849cd54ac4017470$var$isEditable(e.target) && !$849cd54ac4017470$var$ignoredKeys[e.key]);
    const $849cd54ac4017470$export$25d1b8252b4c49b7 = ()=>{
        const elBlankets = document.querySelectorAll('.aui-blanket');
        if (elBlankets.length === 0) return true;
        const isAllHidden = Array.from(elBlankets || []).every((el)=>{
            if (el.getAttribute('aria-hidden') === 'true' || el.getAttribute('hidden') !== null) return true;
            return false;
        });
        return isAllHidden;
    };
    let $849cd54ac4017470$var$key$;
    const $849cd54ac4017470$var$flush$ = new (0, $cab1K.Subject)();
    var $849cd54ac4017470$export$2e2bcd8739ae039 = ()=>{
        if (!$849cd54ac4017470$var$key$) {
            $849cd54ac4017470$var$key$ = false ? new (0, $cab1K.Subject)() : (0, $kVLXA.Observable).fromEvent(document, 'keydown').filter($849cd54ac4017470$var$isRelevantKeyEvent).filter($849cd54ac4017470$export$25d1b8252b4c49b7).map((0, (0, parcelRequire("lIZQG")).toKeyWithModifiers));
            const sequence$ = $849cd54ac4017470$var$key$.scan((seq, key)=>{
                if (!key || !seq) return undefined;
                return {
                    sequence: `${String(seq.sequence)} ${String(key.sequence)}`,
                    e: key.e
                };
            });
            $849cd54ac4017470$var$key$ = $849cd54ac4017470$var$key$.debounceTime(1000).startWith(null).merge($849cd54ac4017470$var$flush$).switchMapTo(sequence$);
        }
        return $849cd54ac4017470$var$key$;
    };
    const $849cd54ac4017470$export$4909b86c8034bf73 = ()=>{
        $849cd54ac4017470$var$flush$.next();
    };
});
parcelRegister("lIZQG", function(module, exports) {
    $parcel$export(module.exports, "toKeyWithModifiers", ()=>$ca3344250c7b7406$export$8cf0d2c3d060a0c2);
    $parcel$export(module.exports, "isValidShortcut", ()=>$ca3344250c7b7406$export$8e231506c5580162);
    $parcel$export(module.exports, "isShortcutCollision", ()=>$ca3344250c7b7406$export$4add9e50cb49d130);
    const $ca3344250c7b7406$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
    const $ca3344250c7b7406$var$modifiers = [
        {
            name: 'ctrl',
            test: (e)=>e.ctrlKey
        },
        {
            name: 'shift',
            test: (e)=>e.shiftKey && $ca3344250c7b7406$var$isNonCharacterKey(e)
        },
        {
            name: 'meta',
            test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
        }
    ];
    const $ca3344250c7b7406$var$toKey = (e)=>{
        if ($ca3344250c7b7406$var$isNonCharacterKey(e)) return e.key.toLowerCase();
        return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
    };
    const $ca3344250c7b7406$export$8cf0d2c3d060a0c2 = (e)=>{
        if (!e || !e.key) return {
            sequence: '',
            e: e
        };
        return {
            sequence: $ca3344250c7b7406$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($ca3344250c7b7406$var$toKey(e)).join('+'),
            e: e
        };
    };
    const $ca3344250c7b7406$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
    const $ca3344250c7b7406$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$ca3344250c7b7406$var$orSpecialChars}))))?(meta\\+)?(${$ca3344250c7b7406$var$orSpecialChars}|[!-~])`;
    const $ca3344250c7b7406$var$shortcutRegex = RegExp(`^${$ca3344250c7b7406$var$singleShortcutEntry}( ${$ca3344250c7b7406$var$singleShortcutEntry})*$`);
    const $ca3344250c7b7406$export$8e231506c5580162 = (shortcut)=>$ca3344250c7b7406$var$shortcutRegex.test(shortcut);
    const $ca3344250c7b7406$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
        if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
        if (rightShortcut === leftShortcut) return true;
        if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
        if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
        return false;
    };
});
parcelRegister("k4r7E", function(module, exports) {
    $parcel$export(module.exports, "ShortcutRegistry", ()=>$a65fecdbaed23de2$export$ca1c75b575abf5ff);
    $parcel$export(module.exports, "rootRegistry", ()=>$a65fecdbaed23de2$export$1dd4c61d1ce1fa15);
    var $lbWm4 = parcelRequire("lbWm4");
    var $561FV = parcelRequire("561FV");
    var $hGgHi = parcelRequire("hGgHi");
    var $FISJv = parcelRequire("FISJv");
    var $lIZQG;
    const $a65fecdbaed23de2$var$validateKeyMaps = (keyMaps)=>{
        (0, ($parcel$interopDefault($lbWm4)))(keyMaps, (keyMap, keyMapIndex)=>{
            const shortcuts = Object.keys(keyMap);
            (0, ($parcel$interopDefault($lbWm4)))(shortcuts, (shortcut, shortcutIndex)=>{
                if (!(0, (0, parcelRequire("lIZQG")).isValidShortcut)(shortcut)) console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
                for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                    const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                    (0, ($parcel$interopDefault($lbWm4)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                        if ((0, (0, parcelRequire("lIZQG")).isShortcutCollision)(anotherShortcut, shortcut)) {
                            if ((0, ($parcel$interopDefault($hGgHi)))(keyMap[shortcut].priority) && (0, ($parcel$interopDefault($hGgHi)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                        }
                    });
                }
                for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, (0, parcelRequire("lIZQG")).isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
            });
        });
    };
    const $a65fecdbaed23de2$var$mergeKeyMaps = (keyMapsToMerge)=>keyMapsToMerge.reduce((prev, keyMap)=>({
                ...prev,
                ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                    if (!(0, ($parcel$interopDefault($561FV)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1)) return {
                        ...newAccumulator,
                        [newKey]: keyMap[newKey]
                    };
                    return newAccumulator;
                }, {})
            }), {});
    class $a65fecdbaed23de2$export$ca1c75b575abf5ff {
        addChildRegistry(child) {
            this.children.push(child);
            return ()=>{
                (0, ($parcel$interopDefault($FISJv)))(this.children, child);
            };
        }
        addKeyMap(getKeyMap) {
            this.keyMapRetrievers.push(getKeyMap);
            return ()=>{
                (0, ($parcel$interopDefault($FISJv)))(this.keyMapRetrievers, getKeyMap);
            };
        }
        getActiveKeyMap() {
            const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
            return {
                ...$a65fecdbaed23de2$var$mergeKeyMaps(keyMaps)
            };
        }
        getKeyMapInfo() {
            const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
            const flattenedInfo = [].concat(...info);
            return flattenedInfo;
        }
        constructor(){
            this.children = [];
            this.keyMapRetrievers = [];
        }
    }
    const $a65fecdbaed23de2$export$1dd4c61d1ce1fa15 = new $a65fecdbaed23de2$export$ca1c75b575abf5ff();
});
parcelRegister("9fuVs", function(module, exports) {
    $parcel$export(module.exports, "ShortcutRegistryContext", ()=>$1dd87679d9ca363b$export$ebbb59327adb551a);
    $parcel$export(module.exports, "default", ()=>$1dd87679d9ca363b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $k4r7E;
    const $1dd87679d9ca363b$export$ebbb59327adb551a = (0, $5uXOq.createContext)((0, (0, parcelRequire("k4r7E")).rootRegistry));
    const $1dd87679d9ca363b$var$ShortcutScope = ({ children: children = null })=>{
        const registry = (0, $5uXOq.useMemo)(()=>new (0, (0, parcelRequire("k4r7E")).ShortcutRegistry)(), []);
        const parentRegistry = (0, $5uXOq.useContext)($1dd87679d9ca363b$export$ebbb59327adb551a) || (0, (0, parcelRequire("k4r7E")).rootRegistry);
        (0, $5uXOq.useEffect)(()=>{
            const removeRegistry = parentRegistry.addChildRegistry(registry);
            return removeRegistry;
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($1dd87679d9ca363b$export$ebbb59327adb551a.Provider, {
            value: registry
        }, children);
    };
    var $1dd87679d9ca363b$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children) : $1dd87679d9ca363b$var$ShortcutScope;
});
parcelRegister("kspvB", function(module, exports) {
    $parcel$export(module.exports, "bindKeyMapWithErrorHandling", ()=>$f9e30ab2465f6f16$export$77477772a9b904da);
    var $dJl1T;
    const $f9e30ab2465f6f16$var$wrapCallbackWithErrorHandling = (key, callback, location = 'keyboard-shortcuts.common')=>(e)=>{
            try {
                callback(e);
            } catch (error) {
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData(location, `Error firing shortcut '${key}': ${error.message} (commandPaletteBlockNativeShortcutFF=true)`, error);
            }
        };
    const $f9e30ab2465f6f16$export$77477772a9b904da = (keyMap, location)=>Object.keys(keyMap).reduce((map, key)=>({
                ...map,
                [key]: {
                    ...keyMap[key],
                    callback: $f9e30ab2465f6f16$var$wrapCallbackWithErrorHandling(key, keyMap[key].callback, location)
                }
            }), {});
});
parcelRegister("joX8T", function(module, exports) {
    $parcel$export(module.exports, "COHORT", ()=>$a85d1363752adaec$export$3d370c33621572df);
    $parcel$export(module.exports, "NOT_ENROLLED", ()=>$a85d1363752adaec$export$5b7423264d48ab04);
    $parcel$export(module.exports, "CONTROL", ()=>$a85d1363752adaec$export$43f367b3e957f219);
    $parcel$export(module.exports, "VARIATION", ()=>$a85d1363752adaec$export$fa04ad826acc90da);
    var $co1wz;
    const $a85d1363752adaec$export$3d370c33621572df = 'cohort';
    const $a85d1363752adaec$export$5b7423264d48ab04 = 'not-enrolled';
    const $a85d1363752adaec$export$43f367b3e957f219 = 'control';
    const $a85d1363752adaec$export$9ba2bc3b1bdc1519 = 'experiment';
    const $a85d1363752adaec$export$fa04ad826acc90da = 'variation';
    const $a85d1363752adaec$export$6486974e39493fa6 = 'variation-1';
    const $a85d1363752adaec$export$7d994996134ad562 = 'variation-2';
    const $a85d1363752adaec$export$795e7d69b248dcd0 = 'variation-3';
    const $a85d1363752adaec$export$c9c947c57470b787 = 'variation-4';
    const $a85d1363752adaec$var$DEFAULT_VALID_EXPERIMENT_GROUPS = [
        $a85d1363752adaec$export$5b7423264d48ab04,
        $a85d1363752adaec$export$43f367b3e957f219,
        $a85d1363752adaec$export$9ba2bc3b1bdc1519,
        $a85d1363752adaec$export$fa04ad826acc90da,
        $a85d1363752adaec$export$6486974e39493fa6,
        $a85d1363752adaec$export$7d994996134ad562,
        $a85d1363752adaec$export$795e7d69b248dcd0,
        $a85d1363752adaec$export$c9c947c57470b787
    ];
    var $a85d1363752adaec$export$2e2bcd8739ae039 = (experimentFeatureFlag, validExperimentGroups = $a85d1363752adaec$var$DEFAULT_VALID_EXPERIMENT_GROUPS)=>(0, (0, parcelRequire("co1wz")).getMultivariateFeatureFlag)(experimentFeatureFlag, $a85d1363752adaec$export$5b7423264d48ab04, validExperimentGroups);
});
parcelRegister("6CjZR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0aef8f88c53fc825$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $47bDC = parcelRequire("47bDC");
    var $16T6Y;
    var $fVnbM;
    var $6Ingq;
    var $1I7E8;
    var $3bDjY;
    var $gSExi;
    var $co1wz;
    var $4R6GH;
    var $koVbs;
    var $2m0b6;
    var $dCm1o;
    var $7Hgp8;
    var $AOaWd;
    var $5yCxu;
    const $0aef8f88c53fc825$var$OverflowHandler = ({ itemsBefore: itemsBefore, itemsAfter: itemsAfter, selectedItems: selectedItems = {} })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const overflowContainerRef = (0, $5uXOq.useRef)(null);
        const moreFilterRef = (0, $5uXOq.useRef)(null);
        const elementsRef = (0, $5uXOq.useRef)({});
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        const prevOverflowContainerWidthRef = (0, $5uXOq.useRef)(0);
        const elementsWidthRef = (0, $5uXOq.useRef)({});
        const visibleElementsRef = (0, $5uXOq.useRef)({});
        const prevElementsWidthRef = (0, $5uXOq.useRef)({});
        const [{ overflowableHideState: overflowableHideState, isMoreDropdownHidden: isMoreDropdownHidden }, setOverflowState] = (0, $5uXOq.useState)({
            overflowableHideState: {},
            isMoreDropdownHidden: true
        });
        const { renderedOverflowableItems: renderedOverflowableItems, staticItems: staticItems, renderedItemsBefore: renderedItemsBefore, renderedItemsAfter: renderedItemsAfter } = (0, $5uXOq.useMemo)(()=>{
            const theOverflowable = [];
            const theStatic = [];
            const theRenderedBefore = [];
            const theRenderedAfter = [];
            const categoriseItems = ({ isRenderedBefore: isRenderedBefore })=>{
                (isRenderedBefore ? itemsBefore : itemsAfter).forEach((item)=>{
                    const { isStatic: isStatic, isHidden: isHidden = false } = item;
                    if (!isStatic && isHidden) return;
                    (isStatic ? theStatic : theOverflowable).push(item);
                    (isRenderedBefore ? theRenderedBefore : theRenderedAfter).push(item);
                });
            };
            categoriseItems({
                isRenderedBefore: true
            });
            categoriseItems({
                isRenderedBefore: false
            });
            return {
                renderedOverflowableItems: theOverflowable,
                staticItems: theStatic,
                renderedItemsBefore: theRenderedBefore,
                renderedItemsAfter: theRenderedAfter
            };
        }, [
            itemsBefore,
            itemsAfter
        ]);
        const selectedOverflowItemsCount = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("5yCxu")).getSelectedItemsCount)(overflowableHideState, selectedItems), [
            overflowableHideState,
            selectedItems
        ]);
        const onResize = (0, $5uXOq.useCallback)(()=>{
            const { current: overflowContainer } = overflowContainerRef;
            const { current: moreFilter } = moreFilterRef;
            const shouldRecomputeOverflow = (0, (0, parcelRequire("5yCxu")).getShouldRecomputeOverflow)(prevOverflowContainerWidthRef.current, overflowContainer?.offsetWidth ?? 0, prevElementsWidthRef.current, elementsWidthRef.current);
            if (!overflowContainer || !moreFilter || !renderedOverflowableItems.length || !shouldRecomputeOverflow) return;
            prevOverflowContainerWidthRef.current = overflowContainer.offsetWidth;
            prevElementsWidthRef.current = {
                ...elementsWidthRef.current
            };
            setOverflowState((0, (0, parcelRequire("5yCxu")).calcOverflow)(overflowContainer, moreFilter, renderedOverflowableItems, staticItems, elementsRef.current));
        }, [
            renderedOverflowableItems,
            staticItems
        ]);
        if ((0, (0, parcelRequire("4R6GH")).fg)('blu-3488_small_refactor_in_filters_bar')) (0, (0, parcelRequire("2m0b6")).useResizeObserver)({
            ref: overflowContainerRef,
            onResize: onResize
        });
        else (0, (0, parcelRequire("AOaWd")).useResizeObserver)(overflowContainerRef, onResize);
        const onClick = (0, $5uXOq.useCallback)(()=>{
            setIsOpen(!isOpen);
        }, [
            isOpen,
            setIsOpen
        ]);
        const onClose = (0, $5uXOq.useCallback)(()=>{
            setIsOpen(false);
        }, [
            setIsOpen
        ]);
        const triggerLabel = formatMessage((0, (0, parcelRequire("7Hgp8")).default).more);
        const triggerTooltipText = formatMessage((0, (0, parcelRequire("7Hgp8")).default).moreFiltersTooltip);
        const buttonToolTip = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                content: triggerTooltipText,
                hideTooltipOnClick: true,
                tag: "span"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($0aef8f88c53fc825$var$TriggerContainer, {
                "data-testid": "filters.common.ui.overflow-handler.trigger-container"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($0aef8f88c53fc825$var$TriggerLabel, null, triggerLabel), selectedOverflowItemsCount > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement($0aef8f88c53fc825$var$BadgeContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("16T6Y")).default), {
                appearance: "primary"
            }, selectedOverflowItemsCount)))), [
            selectedOverflowItemsCount,
            triggerTooltipText,
            triggerLabel
        ]);
        const content = (0, $5uXOq.useCallback)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement($0aef8f88c53fc825$var$PopupContainer, null, renderedOverflowableItems.map(({ id: id, renderer: renderer })=>Boolean(overflowableHideState[id]) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
                    key: id
                }, renderer(true)))), [
            renderedOverflowableItems,
            overflowableHideState
        ]);
        const renderItems = (items)=>items.map(({ id: id, isStatic: isStatic, isHidden: isHidden = false, renderer: renderer })=>{
                const isItemHidden = isStatic ? isHidden : Boolean(overflowableHideState[id]);
                return (0, ($parcel$interopDefault($5uXOq))).createElement($0aef8f88c53fc825$var$ItemWrapper, {
                    key: id,
                    innerRef: (element)=>{
                        elementsRef.current[id] = element;
                        if (element) {
                            elementsWidthRef.current[id] = element.offsetWidth;
                            if (!isHidden) visibleElementsRef.current[id] = {
                                width: element.offsetWidth,
                                height: element.offsetHeight
                            };
                        }
                    },
                    "aria-hidden": isItemHidden,
                    isHidden: isItemHidden
                }, renderer(false));
            });
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: overflowContainerRef,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? "_1e0c1txw _1ul9idpf _18s83l1n" : "_1e0c1txw _1ul9idpf"
            ])
        }, renderItems(renderedItemsBefore), (0, ($parcel$interopDefault($5uXOq))).createElement($0aef8f88c53fc825$var$ItemWrapper, {
            innerRef: moreFilterRef,
            "aria-hidden": isMoreDropdownHidden,
            isHidden: isMoreDropdownHidden
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).Popup), {
            trigger: (triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                    ...triggerProps,
                    appearance: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? 'default' : 'subtle',
                    isSelected: isOpen,
                    iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("6Ingq"))))), {
                        primaryColor: "var(--ds-icon, #44546F)",
                        label: triggerLabel
                    }),
                    onClick: onClick
                }, buttonToolTip),
            shouldRenderToParent: true,
            shouldFlip: true,
            isOpen: isOpen,
            placement: "bottom-start",
            content: content,
            onClose: onClose
        })), renderItems(renderedItemsAfter));
    };
    var $0aef8f88c53fc825$export$2e2bcd8739ae039 = $0aef8f88c53fc825$var$OverflowHandler;
    const $0aef8f88c53fc825$var$overflowContainerStylesOld = null;
    const $0aef8f88c53fc825$var$overflowContainerStyles = null;
    const $0aef8f88c53fc825$var$PopupContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt4swc3",
                __cmplp.className
            ])
        });
    });
    const $0aef8f88c53fc825$var$TriggerContainer = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw",
                __cmplp.className
            ])
        });
    });
    const $0aef8f88c53fc825$var$TriggerLabel = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_o5721q9c",
                __cmplp.className
            ])
        });
    });
    const $0aef8f88c53fc825$var$BadgeContainer = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1o8l _19bv1b66",
                __cmplp.className
            ])
        });
    });
    const $0aef8f88c53fc825$var$ItemWrapperControl = (0, $47bDC.default).div.withConfig({
        componentId: "sc-1krxkwp-0"
    })((props)=>({
            flexShrink: 0,
            order: props.isHidden ? 2 : 1,
            visibility: props.isHidden ? 'hidden' : 'visible',
            pointerEvents: props.isHidden ? 'none' : 'auto'
        }));
    const $0aef8f88c53fc825$var$ItemWrapperExperiment = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isHidden: isHidden, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1o9zidpf",
                __cmplp.isHidden ? "_1f49cs5v" : "_1f49kb7n",
                __cmplp.isHidden ? "_3um015vq" : "_3um0ewfl",
                __cmplp.isHidden ? "_lcxvglyw" : "_lcxv1wug",
                __cmplp.className
            ])
        });
    });
    const $0aef8f88c53fc825$var$ItemWrapper = (0, (0, parcelRequire("gSExi")).styledComponentWithCondition)(()=>(0, (0, parcelRequire("co1wz")).ff)('compiled.migration.jsw.tanuki'), $0aef8f88c53fc825$var$ItemWrapperExperiment, $0aef8f88c53fc825$var$ItemWrapperControl);
});
parcelRegister("gSExi", function(module, exports) {
    $parcel$export(module.exports, "styledComponentWithCondition", ()=>$cd06fcc13efa32a5$export$62d8d8fbf238d6af);
    var $5uXOq = parcelRequire("5uXOq");
    const $cd06fcc13efa32a5$export$62d8d8fbf238d6af = (useCompiled, CompiledComponent, StyledComponent)=>({ innerRef: innerRef, ...rest })=>useCompiled() ? (0, ($parcel$interopDefault($5uXOq))).createElement(CompiledComponent, {
                ...rest,
                ref: innerRef
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement(StyledComponent, {
                ...rest,
                innerRef: innerRef
            });
    const $cd06fcc13efa32a5$export$f5b752428255ba78 = (useCompiled, CompiledComponent, StyledComponent)=>({ innerRef: innerRef, ...rest })=>useCompiled() ? (0, ($parcel$interopDefault($5uXOq))).createElement(CompiledComponent, {
                ...rest,
                ref: innerRef
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement(StyledComponent, {
                ...rest,
                innerRef: innerRef
            });
});
parcelRegister("2m0b6", function(module, exports) {
    $parcel$export(module.exports, "createResizeObserverHook", ()=>$072291c9ed048772$export$87a9d3e287304ae4);
    $parcel$export(module.exports, "useResizeObserver", ()=>$072291c9ed048772$export$683480f191c0e3ea);
    $parcel$export(module.exports, "flushResizeObservers", ()=>$072291c9ed048772$export$a181ef2a6d0a1bb6);
    $parcel$export(module.exports, "useRectObserver", ()=>$072291c9ed048772$export$e58143dc89297272);
    var $5uXOq = parcelRequire("5uXOq");
    var $eUdQc;
    function $072291c9ed048772$export$87a9d3e287304ae4(params) {
        const group = new (0, (0, parcelRequire("eUdQc")).ResizeObserverGroup)(params?.debouncePeriod);
        function useResizeObserver({ ref: ref, onResize: onResize }) {
            const onResizeRef = (0, $5uXOq.useRef)(onResize);
            (0, $5uXOq.useEffect)(()=>{
                onResizeRef.current = onResize;
            });
            const stableOnResize = (0, $5uXOq.useCallback)(()=>onResizeRef.current(), []);
            (0, $5uXOq.useLayoutEffect)(()=>group.observe(ref, stableOnResize), [
                ref,
                stableOnResize
            ]);
        }
        return {
            useResizeObserver: useResizeObserver,
            flushResizeObservers: ()=>group.flush()
        };
    }
    const { useResizeObserver: $072291c9ed048772$export$683480f191c0e3ea, flushResizeObservers: $072291c9ed048772$export$a181ef2a6d0a1bb6 } = $072291c9ed048772$export$87a9d3e287304ae4();
    function $072291c9ed048772$export$e58143dc89297272({ ref: ref, useResizeObserverDI: useResizeObserverDI = $072291c9ed048772$export$683480f191c0e3ea }) {
        const [rect, setRect] = (0, $5uXOq.useState)(null);
        const onResize = ()=>{
            if (ref.current) setRect(ref.current.getBoundingClientRect());
        };
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (!ref.current) throw new Error([
                'useRectObserver: ref is not available on mount.',
                'This means you are attaching refs conditionally onto your elements, for example in with an early return.',
                'This will not work properly. Please update your code so that refs are always attached to components on mount.'
            ].join('\n'));
            setRect(ref.current.getBoundingClientRect());
        }, [
            ref
        ]);
        useResizeObserverDI({
            ref: ref,
            onResize: onResize
        });
        return rect;
    }
});
parcelRegister("eUdQc", function(module, exports) {
    $parcel$export(module.exports, "ResizeObserverGroup", ()=>$52e6ab4254804b44$export$607798bbe2869c0);
    var $7nsd3 = parcelRequire("7nsd3");
    var $lFKmC = parcelRequire("lFKmC");
    class $52e6ab4254804b44$export$607798bbe2869c0 {
        constructor(debouncePeriod = 16){
            this.subscribers = new Map();
            this.pendingUpdates = new Map();
            this.onResize = (entries)=>{
                entries.forEach((entry)=>{
                    const subscriber = this.subscribers.get(entry.target);
                    if (subscriber) this.pendingUpdates.set(subscriber.element, subscriber);
                });
                this.scheduleFlush();
            };
            this.observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(this.onResize) : null;
            this.scheduleFlush = debouncePeriod > 0 ? (0, ($parcel$interopDefault($lFKmC)))(()=>{
                this.flush();
            }, debouncePeriod, {
                trailing: true,
                maxWait: 32
            }) : ()=>{
                this.flush();
            };
        }
        observe(ref, callback) {
            if (!ref.current) return ()=>{};
            this.subscribers.set(ref.current, {
                element: ref.current,
                callback: callback
            });
            this.observer?.observe(ref.current);
            return ()=>{
                if (!ref.current) return;
                this.subscribers.delete(ref.current);
                this.pendingUpdates.delete(ref.current);
                this.observer?.unobserve(ref.current);
            };
        }
        flush() {
            const entries = Array.from(this.pendingUpdates.values()).filter((entry)=>this.subscribers.has(entry.element));
            this.pendingUpdates.clear();
            (0, $7nsd3.unstable_batchedUpdates)(()=>{
                entries.forEach(({ callback: callback })=>{
                    callback();
                });
            });
        }
    }
});
parcelRegister("7Hgp8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cea3021c9215d69b$export$2e2bcd8739ae039);
    var $7VHMR;
    var $cea3021c9215d69b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        more: {
            "id": "software-filters.common.overflow-handler.more",
            "defaultMessage": "More"
        },
        moreFiltersTooltip: {
            "id": "software-filters.common.overflow-handler.more-filters-tooltip",
            "defaultMessage": "More filters"
        }
    });
});
parcelRegister("AOaWd", function(module, exports) {
    $parcel$export(module.exports, "useResizeObserver", ()=>$d7fe9cd69e6a83c0$export$683480f191c0e3ea);
    var $5uXOq = parcelRequire("5uXOq");
    let $d7fe9cd69e6a83c0$var$resizeObserver;
    const $d7fe9cd69e6a83c0$var$callbacks = new Map();
    const $d7fe9cd69e6a83c0$var$runCallbacks = (entries)=>{
        entries.forEach((entry)=>{
            const { target: target } = entry;
            const callback = $d7fe9cd69e6a83c0$var$callbacks.get(target);
            callback?.(entry);
        });
    };
    const $d7fe9cd69e6a83c0$var$observeElement = (target, callback)=>{
        if (typeof ResizeObserver === 'undefined') return;
        if (!$d7fe9cd69e6a83c0$var$resizeObserver) $d7fe9cd69e6a83c0$var$resizeObserver = new ResizeObserver($d7fe9cd69e6a83c0$var$runCallbacks);
        $d7fe9cd69e6a83c0$var$callbacks.set(target, callback);
        $d7fe9cd69e6a83c0$var$resizeObserver.observe(target);
    };
    const $d7fe9cd69e6a83c0$var$unobserveElement = (target)=>{
        if (!$d7fe9cd69e6a83c0$var$resizeObserver) return;
        $d7fe9cd69e6a83c0$var$callbacks.delete(target);
        $d7fe9cd69e6a83c0$var$resizeObserver.unobserve(target);
    };
    const $d7fe9cd69e6a83c0$export$683480f191c0e3ea = (ref, callback)=>{
        (0, $5uXOq.useLayoutEffect)(()=>{
            const element = ref.current;
            element && $d7fe9cd69e6a83c0$var$observeElement(element, callback);
            return ()=>{
                element && $d7fe9cd69e6a83c0$var$unobserveElement(element);
            };
        }, [
            ref,
            callback
        ]);
    };
});
parcelRegister("5yCxu", function(module, exports) {
    $parcel$export(module.exports, "calcOverflow", ()=>$6dfc047016dbaaed$export$7128ab9dfe00f62e);
    $parcel$export(module.exports, "getShouldRecomputeOverflow", ()=>$6dfc047016dbaaed$export$2544af09d06b9c65);
    $parcel$export(module.exports, "getSelectedItemsCount", ()=>$6dfc047016dbaaed$export$b0e31612dc0df344);
    var $gccSB = parcelRequire("gccSB");
    const $6dfc047016dbaaed$export$1fed873882a661c5 = (items, itemElements, spaceLimit)=>{
        const hideState = {};
        let usedSpace = 0;
        let isOverflowingAssumed = false;
        items.forEach(({ id: id })=>{
            const element = itemElements[id];
            if (element) {
                const { offsetWidth: space } = element;
                if ((spaceLimit === undefined || usedSpace + space < spaceLimit) && !isOverflowingAssumed) usedSpace += space;
                else {
                    if (!isOverflowingAssumed) isOverflowingAssumed = true;
                    hideState[id] = true;
                }
            }
        });
        return {
            usedSpace: usedSpace,
            hideState: hideState
        };
    };
    const $6dfc047016dbaaed$export$7128ab9dfe00f62e = ({ offsetWidth: availableSpace }, { offsetWidth: moreFilterSpace }, renderedOverflowableItems, staticItems, itemElements)=>{
        const { usedSpace: staticSpace } = $6dfc047016dbaaed$export$1fed873882a661c5(staticItems, itemElements);
        const maxOverflowableSpace = renderedOverflowableItems.reduce((maxSpace, { id: id })=>maxSpace + (itemElements[id]?.offsetWidth ?? 0), 0);
        const isOverflowing = maxOverflowableSpace + staticSpace > availableSpace;
        let overflowableHideState = {};
        if (isOverflowing) {
            const spaceLimit = Math.max(availableSpace - moreFilterSpace - staticSpace, 0);
            const { hideState: hideState } = $6dfc047016dbaaed$export$1fed873882a661c5(renderedOverflowableItems, itemElements, spaceLimit);
            overflowableHideState = hideState;
        }
        return {
            overflowableHideState: overflowableHideState,
            isMoreDropdownHidden: !isOverflowing
        };
    };
    const $6dfc047016dbaaed$var$BADGE_WIDTH_THRESHOLD = 25;
    const $6dfc047016dbaaed$export$2544af09d06b9c65 = (prevContainerWidth, currContainerWidth, prevElementsWidthRef, currElementsWidthRef)=>{
        const currItemIds = Object.keys(currElementsWidthRef);
        const prevItemIds = Object.keys(prevElementsWidthRef);
        if (prevItemIds.length !== currItemIds.length || prevContainerWidth !== currContainerWidth) return true;
        const hasItemsWidthChange = currItemIds.some((id)=>prevElementsWidthRef[id] === undefined || Math.abs(prevElementsWidthRef[id] - currElementsWidthRef[id]) > $6dfc047016dbaaed$var$BADGE_WIDTH_THRESHOLD);
        return hasItemsWidthChange;
    };
    const $6dfc047016dbaaed$export$b0e31612dc0df344 = (itemsHiddenState, selectedItems)=>{
        if ((0, ($parcel$interopDefault($gccSB)))(selectedItems) || (0, ($parcel$interopDefault($gccSB)))(itemsHiddenState)) return 0;
        return Object.entries(selectedItems).reduce((acc, [key, value])=>{
            if (value === undefined || itemsHiddenState[key] !== true) return acc;
            return Array.isArray(value) ? acc + value.length : acc + 1;
        }, 0);
    };
});
parcelRegister("1beWO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6f4b1966602deeb5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $7rViF;
    var $caSh0;
    var $6s1PB;
    var $4R6GH;
    var $2OMDV;
    var $8zOmE;
    var $2NMNM;
    var $12hlA;
    var $efvDm;
    var $ldyPw;
    var $9OXo1;
    var $cpQgt;
    var $j6etC;
    var $eJpZk;
    var $lAu6N;
    const $6f4b1966602deeb5$var$StatelessAssigneeFilterWithAnalytics = (0, (0, parcelRequire("2OMDV")).AnalyticsEventToProps)('StatelessAssigneeFilterWithAnalytics', {
        onAddPeopleClick: 'clicked'
    })((0, (0, parcelRequire("lAu6N")).default));
    $6f4b1966602deeb5$var$StatelessAssigneeFilterWithAnalytics.displayName = 'StatelessAssigneeFilterWithAnalytics';
    const $6f4b1966602deeb5$export$3ecb2c48b5973cac = ({ AddPeopleModal: AddPeopleModal, showAddPeopleModal: showAddPeopleModal, onAddPeopleModalClose: onAddPeopleModalClose, cloudId: cloudId, projectName: projectName, projectId: projectId, projectKey: projectKey, appEdition: appEdition, isSiteAdmin: isSiteAdmin, modalRef: modalRef })=>{
        if ((0, (0, parcelRequire("caSh0")).isCoreInvitesInJiraProjectsEnabled)(isSiteAdmin)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("12hlA")).default), {
            inviteRef: modalRef,
            appEdition: appEdition,
            cloudId: cloudId,
            isOpen: (0, (0, parcelRequire("4R6GH")).fg)('jsw-perf-async-add-people-modal-load') ? true : showAddPeopleModal,
            onClose: onAddPeopleModalClose,
            jiraProjectName: projectName,
            projectId: projectId,
            jiraProjectKey: projectKey,
            isSiteAdmin: isSiteAdmin
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement(AddPeopleModal, {
            onClose: onAddPeopleModalClose,
            isOpen: (0, (0, parcelRequire("4R6GH")).fg)('jsw-perf-async-add-people-modal-load') ? true : showAddPeopleModal
        });
    };
    const $6f4b1966602deeb5$export$804bfdea59f89629 = (createAnalyticsEvent, baseUrl, setShowUpSell, showUpSell, setShowAddPeopleModal, showAddPeopleModal, jswEdition, analyticsEvent, isSiteAdmin, screenName, fireTriggerClickEvent)=>{
        const openAddPeopleModal = ()=>{
            (0, (0, parcelRequire("7rViF")).fireCoreInvitesInJiraProjectFeatureExposed)(createAnalyticsEvent, isSiteAdmin);
            setShowAddPeopleModal(!showAddPeopleModal);
        };
        const [expConfig] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('jsw_allow_project_invite_past_10th_user_on_free');
        if (jswEdition === (0, (0, parcelRequire("ldyPw")).toEdition)((0, (0, parcelRequire("ldyPw")).FREE_EDITION))) (0, (0, parcelRequire("j6etC")).getRemainingSeats)(baseUrl, (0, $c06e1abca7c13910$export$1346c9aa3cbb477d)).then((remainingSeats)=>{
            if (remainingSeats === 0) {
                if (expConfig.get('cohort', 'not-enrolled') !== 'not-enrolled') {
                    const [, fireExposureEvent] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('jsw_allow_project_invite_past_10th_user_on_free');
                    fireExposureEvent();
                }
                fireTriggerClickEvent();
                if (expConfig.get('cohort', 'not-enrolled') === 'variation') openAddPeopleModal();
                else {
                    setShowUpSell(!showUpSell);
                    if (!showUpSell) (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, `${screenName}AssigneeFilterAddPeople`);
                }
            } else {
                fireTriggerClickEvent();
                openAddPeopleModal();
            }
        }).catch((e)=>{
            fireTriggerClickEvent();
            openAddPeopleModal();
            throw e;
        });
        else {
            fireTriggerClickEvent();
            openAddPeopleModal();
        }
    };
    const $6f4b1966602deeb5$var$ConditionalUpsellDialogWrapper = (props)=>{
        const { children: children, showUpsellDialog: showUpsellDialog, setShowUpsellDialog: setShowUpsellDialog, screenName: screenName } = props;
        const [expConfig] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('jsw_allow_project_invite_past_10th_user_on_free');
        if (expConfig.get('cohort', 'not-enrolled') === 'variation') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
        const onUpgradeDialogClose = ()=>{
            setShowUpsellDialog(false);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cpQgt")).default), {
            isOpen: showUpsellDialog,
            onClose: onUpgradeDialogClose,
            touchpointId: `${screenName || ''}${screenName ? 'A' : 'a'}ssigneeFilterAddPeople`,
            onUpFlowDismiss: onUpgradeDialogClose
        }, children);
    };
    const $6f4b1966602deeb5$export$20e0939737a940df = (props)=>{
        const { users: users, maxUsers: maxUsers, AddPeopleModal: AddPeopleModal, screenName: screenName, selectedUsers: selectedUsers, onToggle: onToggle, projectId: projectId, isAddPeopleButtonEnabled: isAddPeopleButtonEnabled, projectName: projectName, projectKey: projectKey } = props;
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const [showAddPeopleModal, setShowAddPeopleModal] = (0, $5uXOq.useState)(false);
        const [showUpSell, setShowUpSell] = (0, $5uXOq.useState)(false);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const appEdition = (0, (0, parcelRequire("ldyPw")).getEdition)((0, (0, parcelRequire("efvDm")).JIRA_SOFTWARE), tenantContext.appEditions);
        const onAddPeopleClick = (0, $5uXOq.useCallback)((analyticsEvent)=>{
            const fireAddPeopleClickEvent = ()=>{
                if (!showAddPeopleModal && !showUpSell) {
                    const event = createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        source: screenName
                    });
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(event, 'assigneeFilterAddPeople');
                }
            };
            $6f4b1966602deeb5$export$804bfdea59f89629(createAnalyticsEvent, tenantContext.baseUrl, setShowUpSell, showUpSell, setShowAddPeopleModal, showAddPeopleModal, appEdition, analyticsEvent, tenantContext.isSiteAdmin, screenName || '', fireAddPeopleClickEvent);
        }, [
            createAnalyticsEvent,
            tenantContext.baseUrl,
            tenantContext.isSiteAdmin,
            showUpSell,
            showAddPeopleModal,
            appEdition,
            screenName
        ]);
        const onAddPeopleModalClose = (0, $5uXOq.useCallback)(()=>{
            setShowAddPeopleModal(false);
        }, []);
        const showAddPeopleButton = AddPeopleModal !== undefined && isAddPeopleButtonEnabled;
        const addButtonRef = (0, $5uXOq.useRef)(null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($6f4b1966602deeb5$var$ConditionalUpsellDialogWrapper, {
            showUpsellDialog: showUpSell,
            setShowUpsellDialog: setShowUpSell,
            screenName: screenName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($6f4b1966602deeb5$var$StatelessAssigneeFilterWithAnalytics, {
            peopleRef: addButtonRef,
            users: users,
            maxUsers: maxUsers,
            selectedUsers: selectedUsers,
            onToggle: onToggle,
            onAddPeopleClick: onAddPeopleClick,
            showAddPeopleButton: showAddPeopleButton,
            screenName: screenName || '',
            projectId: projectId
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eJpZk")).Analytics), {
            baseUrl: tenantContext.baseUrl,
            projectId: projectId,
            screenName: screenName || '',
            showAddPeopleButton: showAddPeopleButton
        }), AddPeopleModal && ((0, (0, parcelRequire("4R6GH")).fg)('jsw-perf-async-add-people-modal-load') ? true : showAddPeopleButton) && ((0, (0, parcelRequire("4R6GH")).fg)('jsw-perf-async-add-people-modal-load') ? showAddPeopleModal : true) && (0, ($parcel$interopDefault($5uXOq))).createElement($6f4b1966602deeb5$export$3ecb2c48b5973cac, {
            modalRef: addButtonRef,
            projectName: projectName,
            projectKey: projectKey,
            projectId: projectId,
            AddPeopleModal: AddPeopleModal,
            showAddPeopleModal: (0, (0, parcelRequire("4R6GH")).fg)('jsw-perf-async-add-people-modal-load') ? true : showAddPeopleModal,
            onAddPeopleModalClose: onAddPeopleModalClose,
            cloudId: tenantContext.cloudId,
            appEdition: appEdition,
            isSiteAdmin: tenantContext.isSiteAdmin
        }));
    };
    $6f4b1966602deeb5$export$20e0939737a940df.defaultProps = {
        users: [],
        selectedUsers: [],
        maxUsers: 5,
        onToggle: (0, ($parcel$interopDefault($8Rkzz))),
        onAssigneeMenuOpen: (0, ($parcel$interopDefault($8Rkzz))),
        AddPeopleModal: undefined,
        isAddPeopleButtonEnabled: false,
        projectId: -1
    };
    const $6f4b1966602deeb5$var$AssigneeFilterComponent = (0, $5uXOq.memo)($6f4b1966602deeb5$export$20e0939737a940df);
    $6f4b1966602deeb5$var$AssigneeFilterComponent.displayName = 'AssigneeFilter';
    $6f4b1966602deeb5$var$AssigneeFilterComponent.whyDidYouRender = true;
    var $6f4b1966602deeb5$export$2e2bcd8739ae039 = $6f4b1966602deeb5$var$AssigneeFilterComponent;
});
parcelRegister("7rViF", function(module, exports) {
    $parcel$export(module.exports, "fireCoreInvitesInJiraProjectFeatureExposed", ()=>$19157e19516eca78$export$2f2d4a4234531655);
    $parcel$export(module.exports, "fireCoreInvitesInJsmProjectFeatureExposed", ()=>$19157e19516eca78$export$4ae66d6e56a5cb11);
    var $co1wz;
    var $8zOmE;
    var $caSh0;
    const $19157e19516eca78$var$getCoreInvitesInJiraProjects = ()=>(0, (0, parcelRequire("co1wz")).getMultivariateFeatureFlag)('core-invites-in-jira-projects', (0, (0, parcelRequire("caSh0")).CORE_INVITES_IN_JIRA_PROJECTS).NOT_ENROLLED, [
            (0, (0, parcelRequire("caSh0")).CORE_INVITES_IN_JIRA_PROJECTS).NOT_ENROLLED,
            (0, (0, parcelRequire("caSh0")).CORE_INVITES_IN_JIRA_PROJECTS).CONTROL,
            (0, (0, parcelRequire("caSh0")).CORE_INVITES_IN_JIRA_PROJECTS).INVITE_ONLY,
            (0, (0, parcelRequire("caSh0")).CORE_INVITES_IN_JIRA_PROJECTS).INVITE_ONLY_NOT_ENROLLED,
            (0, (0, parcelRequire("caSh0")).CORE_INVITES_IN_JIRA_PROJECTS).INVITE_RA,
            (0, (0, parcelRequire("caSh0")).CORE_INVITES_IN_JIRA_PROJECTS).INVITE_RA_NOT_ENROLLED
        ]);
    const $19157e19516eca78$export$2f2d4a4234531655 = (createAnalyticsEvent, isSiteAdmin)=>{
        const featureFlagValue = $19157e19516eca78$var$getCoreInvitesInJiraProjects();
        const cohort = featureFlagValue;
        (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'feature exposed', {
            flagKey: 'core-invites-in-jira-projects',
            value: featureFlagValue,
            cohort: cohort,
            isSiteAdmin: isSiteAdmin,
            ineligibilityReasons: [],
            growthInitiative: 'virality'
        });
    };
    const $19157e19516eca78$export$4ae66d6e56a5cb11 = (createAnalyticsEvent, coreInvitesJsmExpValue)=>{
        (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'feature exposed', {
            flagKey: 'jsm_core_invites_experiment',
            cohort: coreInvitesJsmExpValue
        });
    };
});
parcelRegister("caSh0", function(module, exports) {
    $parcel$export(module.exports, "CORE_INVITES_IN_JIRA_PROJECTS", ()=>$c0c54262b44db685$export$3496ae3c3008d7e5);
    $parcel$export(module.exports, "isCoreInvitesInJiraProjectsEnabled", ()=>$c0c54262b44db685$export$78d85fc0e603743c);
    $parcel$export(module.exports, "isElligibleProject", ()=>$c0c54262b44db685$export$b0222359e25e154);
    $parcel$export(module.exports, "isServiceProject", ()=>$c0c54262b44db685$export$f52f6e19ac3c110);
    var $2vSU6;
    var $co1wz;
    const $c0c54262b44db685$export$3496ae3c3008d7e5 = {
        CONTROL: 'control',
        NOT_ENROLLED: 'not-enrolled',
        INVITE_ONLY: 'invite-only-variation',
        INVITE_ONLY_NOT_ENROLLED: 'invite-only-not-enrolled',
        INVITE_RA: 'invite-ra-variation',
        INVITE_RA_NOT_ENROLLED: 'invite-ra-variation'
    };
    const $c0c54262b44db685$var$getCoreInvitesInJiraProjects = ()=>(0, (0, parcelRequire("co1wz")).getMultivariateFeatureFlag)('core-invites-in-jira-projects', $c0c54262b44db685$export$3496ae3c3008d7e5.NOT_ENROLLED, [
            $c0c54262b44db685$export$3496ae3c3008d7e5.NOT_ENROLLED,
            $c0c54262b44db685$export$3496ae3c3008d7e5.CONTROL,
            $c0c54262b44db685$export$3496ae3c3008d7e5.INVITE_ONLY,
            $c0c54262b44db685$export$3496ae3c3008d7e5.INVITE_ONLY_NOT_ENROLLED,
            $c0c54262b44db685$export$3496ae3c3008d7e5.INVITE_RA,
            $c0c54262b44db685$export$3496ae3c3008d7e5.INVITE_RA_NOT_ENROLLED
        ]);
    const $c0c54262b44db685$export$78d85fc0e603743c = (isSiteAdmin)=>{
        const flag = $c0c54262b44db685$var$getCoreInvitesInJiraProjects();
        return isSiteAdmin && flag === $c0c54262b44db685$export$3496ae3c3008d7e5.INVITE_ONLY || flag === $c0c54262b44db685$export$3496ae3c3008d7e5.INVITE_RA;
    };
    const $c0c54262b44db685$export$b0222359e25e154 = (projectType)=>projectType === (0, (0, parcelRequire("2vSU6")).CORE_PROJECT) || projectType === (0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT);
    const $c0c54262b44db685$export$f52f6e19ac3c110 = (projectType)=>projectType === (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT);
});
parcelRegister("2OMDV", function(module, exports) {
    $parcel$export(module.exports, "AnalyticsEventToProps", ()=>$28422a5dfa4a4065$export$3e9ef96ba97ea9dc);
    var $cb25w;
    const $28422a5dfa4a4065$export$871de8747c9eaa88 = (props, componentName)=>Object.keys(props).reduce((result, key)=>({
                ...result,
                [key]: {
                    action: props[key],
                    actionSubject: componentName
                }
            }), {});
    const $28422a5dfa4a4065$export$3e9ef96ba97ea9dc = (componentName, eventActions)=>(WrappedComponent)=>(0, (0, parcelRequire("cb25w")).default)($28422a5dfa4a4065$export$871de8747c9eaa88(eventActions, componentName))(WrappedComponent);
});
parcelRegister("12hlA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0bc8c7c74346f034$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $lfTZh;
    var $kxZPA;
    const $0bc8c7c74346f034$var$LazyComponent = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("jWZZk")), {
        moduleId: "./src/packages/project-settings/invite-people-modal-project/src/index.tsx"
    });
    const $0bc8c7c74346f034$export$6a02a79fa2b0ddab = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "async-project-invite-people-modal",
            packageName: "jira-project-invite-people-modal",
            teamName: "groot-growth"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "project-invite-people-modal",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($0bc8c7c74346f034$var$LazyComponent, props)));
    var $0bc8c7c74346f034$export$2e2bcd8739ae039 = $0bc8c7c74346f034$export$6a02a79fa2b0ddab;
});
parcelRegister("jWZZk", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("6C6tQ")
    ]).then(()=>parcelRequire('3dNZP'));
});
const $c06e1abca7c13910$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $c06e1abca7c13910$export$e9c56aa3b027d98f = 'jira-customer-service';
const $c06e1abca7c13910$export$1346c9aa3cbb477d = 'jira-software';
const $c06e1abca7c13910$export$202f50ee62667e32 = 'jira-product-discovery';
const $c06e1abca7c13910$export$db515c8cec1e6f79 = 'jira-core';
const $c06e1abca7c13910$export$c811f21c9ad05dc2 = 'confluence';
const $c06e1abca7c13910$export$961148c98d198270 = 'opsgenie';
parcelRegister("cpQgt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1fee2ed613b7661e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $9yOBd;
    var $ctg8C;
    var $dC5iT;
    var $8CUq3;
    var $iMd5l;
    var $cVzoY;
    var $34Vv8;
    var $az4zD;
    var $iXVV6;
    var $5oFIy;
    var $8zOmE;
    var $ldyPw;
    var $9OXo1;
    var $2hXCB;
    var $02gpZ;
    var $4J6oz;
    var $de8ma;
    const $1fee2ed613b7661e$var$fireCTAButtonAnalytics = (analyticsEvent, actionSubjectId, touchpointId, currentEdition)=>{
        (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, actionSubjectId, {
            currentEdition: currentEdition,
            touchpointId: touchpointId,
            targetEdition: (0, (0, parcelRequire("4J6oz")).applicationEditionToUpFlowEdition)((0, (0, parcelRequire("ldyPw")).STANDARD_EDITION)),
            isGrandfathered: false,
            isSiteAdmin: true,
            upFlowVariateFlag: 'experiment'
        });
    };
    const $1fee2ed613b7661e$var$showTryNowButton = (onClick, label, href, target)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9yOBd")).default), {
            appearance: "primary",
            onClick: onClick,
            href: href,
            target: target,
            rel: "noopener"
        }, label);
    const $1fee2ed613b7661e$var$showLearnMoreButton = (appearance, onClick, label, href, target)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9yOBd")).default), {
            appearance: appearance,
            onClick: onClick,
            href: href,
            target: target,
            rel: "noopener"
        }, label);
    const $1fee2ed613b7661e$var$UpgradeToAddUsersDialog = (props)=>{
        const { children: children, isOpen: isOpen, onClose: onClose, intl: intl, touchpointId: touchpointId, onUpFlowDismiss: onUpFlowDismiss } = props;
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const explicitlyLicensedProducts = (0, (0, parcelRequire("cVzoY")).default)(tenantContext);
        const hasOnlyJSW = explicitlyLicensedProducts.length === 1 && explicitlyLicensedProducts[0] === (0, $c06e1abca7c13910$export$1346c9aa3cbb477d);
        const [upFlowIframeState, setUpFlowIframeState] = (0, $5uXOq.useState)(null);
        const currentEdition = (0, (0, parcelRequire("4J6oz")).applicationEditionToUpFlowEdition)((0, (0, parcelRequire("iMd5l")).getProductEdition)(explicitlyLicensedProducts[0], tenantContext));
        const upgradeButtonOnClick = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
            const actionSubjectId = (0, (0, parcelRequire("2hXCB")).mapActionIdFromType)[0, (0, parcelRequire("2hXCB")).UPGRADE];
            $1fee2ed613b7661e$var$fireCTAButtonAnalytics(analyticsEvent, actionSubjectId, touchpointId, currentEdition);
            hasOnlyJSW && setUpFlowIframeState((0, (0, parcelRequire("2hXCB")).UPGRADE));
        }, [
            currentEdition,
            hasOnlyJSW,
            touchpointId
        ]);
        const learnMoreButtonOnClick = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
            const actionSubjectId = (0, (0, parcelRequire("2hXCB")).mapActionIdFromType)[0, (0, parcelRequire("2hXCB")).LEARN_MORE];
            $1fee2ed613b7661e$var$fireCTAButtonAnalytics(analyticsEvent, actionSubjectId, touchpointId, currentEdition);
            hasOnlyJSW && setUpFlowIframeState((0, (0, parcelRequire("2hXCB")).LEARN_MORE));
        }, [
            currentEdition,
            hasOnlyJSW,
            touchpointId
        ]);
        const onUpFlowIframeClose = (0, $5uXOq.useCallback)(()=>{
            setUpFlowIframeState(null);
            onUpFlowDismiss();
        }, [
            onUpFlowDismiss
        ]);
        const learnMoreButtonAppearance = tenantContext.isSiteAdmin ? 'link' : 'primary';
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: touchpointId,
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ctg8C")).default), {
            content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
                sourceName: "changeEditionGateway",
                sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), {
                attributes: {
                    isSiteAdmin: tenantContext.isSiteAdmin,
                    source: touchpointId
                }
            })), (0, ($parcel$interopDefault($5uXOq))).createElement("b", null, intl.formatMessage((0, (0, parcelRequire("de8ma")).default).upgradeToAddUsersHeader)), (0, ($parcel$interopDefault($5uXOq))).createElement($1fee2ed613b7661e$var$MultiLineParagraph, null, intl.formatMessage((0, (0, parcelRequire("de8ma")).default).upgradeToAddUsersContent)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $1fee2ed613b7661e$var$buttonBarStyles
            }, tenantContext.isSiteAdmin ? $1fee2ed613b7661e$var$showTryNowButton(upgradeButtonOnClick, intl.formatMessage((0, (0, parcelRequire("de8ma")).default).upgradeButtonLabel), hasOnlyJSW ? undefined : (0, $9996ddd22815931e$export$cfca87b5d4683694), hasOnlyJSW ? undefined : '_blank') : null, $1fee2ed613b7661e$var$showLearnMoreButton(learnMoreButtonAppearance, learnMoreButtonOnClick, intl.formatMessage((0, (0, parcelRequire("de8ma")).default).learnMoreButtonLabel), hasOnlyJSW ? undefined : (0, $9996ddd22815931e$export$997e23a0aec74966), hasOnlyJSW ? undefined : '_blank')), upFlowIframeState && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("02gpZ")).UpFlowIFrame), {
                targetEdition: (0, (0, parcelRequire("ldyPw")).STANDARD_EDITION),
                product: explicitlyLicensedProducts[0],
                flow: upFlowIframeState,
                touchpointId: touchpointId,
                experienceTrackingEnabled: true,
                onClose: onUpFlowIframeClose
            })),
            isOpen: isOpen,
            onClose: onClose,
            placement: "bottom-start"
        }, children));
    };
    var $1fee2ed613b7661e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("az4zD")).injectIntlV2)((0, (0, parcelRequire("34Vv8")).default)($1fee2ed613b7661e$var$UpgradeToAddUsersDialog));
    const $1fee2ed613b7661e$var$buttonBarStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginTop: 'space.100'
    });
    const $1fee2ed613b7661e$var$MultiLineParagraph = (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_o5726vc6",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("iMd5l", function(module, exports) {
    $parcel$export(module.exports, "getProductEdition", ()=>$658df12da4e62335$export$53e066a63a960439);
    const $658df12da4e62335$export$53e066a63a960439 = (product, tenantContext)=>{
        if (product === (0, $c06e1abca7c13910$export$1346c9aa3cbb477d)) return tenantContext.appEditions.software;
        if (product === (0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61)) return tenantContext.appEditions.serviceDesk;
        return tenantContext.appEditions.core;
    };
});
parcelRegister("cVzoY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$386aacc800b616d8$export$2e2bcd8739ae039);
    var $386aacc800b616d8$export$2e2bcd8739ae039 = (tenantContext)=>{
        const { licensedProducts: licensedProducts } = tenantContext;
        const result = [];
        licensedProducts[0, $c06e1abca7c13910$export$db515c8cec1e6f79] && result.push((0, $c06e1abca7c13910$export$db515c8cec1e6f79));
        licensedProducts[0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61] && result.push((0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61));
        licensedProducts[0, $c06e1abca7c13910$export$1346c9aa3cbb477d] && result.push((0, $c06e1abca7c13910$export$1346c9aa3cbb477d));
        licensedProducts[0, $c06e1abca7c13910$export$202f50ee62667e32] && result.push((0, $c06e1abca7c13910$export$202f50ee62667e32));
        return result;
    };
});
parcelRegister("2hXCB", function(module, exports) {
    $parcel$export(module.exports, "LEARN_MORE", ()=>$a61f434346a6f772$export$1979295cc80a7ec1);
    $parcel$export(module.exports, "WORKFLOW_EDIT_PERMISSION_LEARN_MORE", ()=>$a61f434346a6f772$export$779203acbfa8bf12);
    $parcel$export(module.exports, "UPGRADE", ()=>$a61f434346a6f772$export$fe5b785cab515b6e);
    $parcel$export(module.exports, "mapActionIdFromType", ()=>$a61f434346a6f772$export$2bf527ee1645dc7d);
    const $a61f434346a6f772$export$9ba2bc3b1bdc1519 = 'experiment';
    const $a61f434346a6f772$export$5b7423264d48ab04 = 'not-enrolled';
    const $a61f434346a6f772$export$43f367b3e957f219 = 'control';
    const $a61f434346a6f772$export$1979295cc80a7ec1 = 'learn-more';
    const $a61f434346a6f772$export$779203acbfa8bf12 = 'workflow-edit-permission-learn-more';
    const $a61f434346a6f772$export$fe5b785cab515b6e = 'upgrade';
    const $a61f434346a6f772$export$2bf527ee1645dc7d = {
        [$a61f434346a6f772$export$1979295cc80a7ec1]: 'freeLearnMore',
        [$a61f434346a6f772$export$779203acbfa8bf12]: 'workflowEditLearnMore',
        [$a61f434346a6f772$export$fe5b785cab515b6e]: 'freeTryNow'
    };
});
parcelRegister("02gpZ", function(module, exports) {
    $parcel$export(module.exports, "UpFlowIFrame", ()=>$6cdd801078d648f3$export$e9eafd8c579e773d);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $lfTZh;
    var $kxZPA;
    var $4J6oz;
    var $g6ckq;
    const $6cdd801078d648f3$var$UpFlowIFrameLazy = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("e4DQi")), {
        moduleId: "./src/packages/growth/up-flow/up-flow-iframe/src/main.tsx"
    });
    const $6cdd801078d648f3$export$e9eafd8c579e773d = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: (0, $abaf639d63a27f10$export$c73007a11ea7e52),
            packageName: (0, $abaf639d63a27f10$export$c73007a11ea7e52),
            teamName: "luna-growth",
            fallback: (0, (0, parcelRequire("g6ckq")).ChunkLoadErrorFlag),
            attributes: (0, (0, parcelRequire("4J6oz")).addChunkLoadErrorAnalyticsAttribute)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "flow-iframe-lazy",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($6cdd801078d648f3$var$UpFlowIFrameLazy, props)));
});
const $abaf639d63a27f10$export$c73007a11ea7e52 = 'jiraUpFlowIframe';
const $abaf639d63a27f10$export$cb7e587097a78810 = 'upsell-edition';
const $abaf639d63a27f10$export$fb320338324d1328 = 'upflowIFrame';
const $abaf639d63a27f10$export$782491eab0c2154d = 'INITIATE_SPA_CLOSE';
const $abaf639d63a27f10$export$dc3263ec2276f3f3 = 'START_EDITION_POLLING';
const $abaf639d63a27f10$export$8a7c66f5574473bd = 'FINISH_EDITION_POLLING';
const $abaf639d63a27f10$export$c012ea75b4437aea = 'TRACK_EXPERIENCE_FAIL';
const $abaf639d63a27f10$export$1b2e801262ba754 = 'TRACK_EXPERIENCE_SUCCESS';
const $abaf639d63a27f10$export$b6cceaecfde9dc91 = 'SPA_READY';
parcelRegister("4J6oz", function(module, exports) {
    $parcel$export(module.exports, "applicationEditionToUpFlowEdition", ()=>$7e87fb5ffa0cfceb$export$b48ea9d6b982b3e1);
    $parcel$export(module.exports, "jiraUpFlowIframeUpgradePlanInteraction", ()=>$7e87fb5ffa0cfceb$export$7d4045a899f62dfd);
    $parcel$export(module.exports, "addChunkLoadErrorAnalyticsAttribute", ()=>$7e87fb5ffa0cfceb$export$94ee0b5fca1e74d2);
    $parcel$export(module.exports, "handleError", ()=>$7e87fb5ffa0cfceb$export$d3da1ecaf1206c58);
    var $5uXOq = parcelRequire("5uXOq");
    var $dGrdR;
    var $jcw0u;
    var $ldyPw;
    var $bCf8q;
    var $ajCo3;
    const $7e87fb5ffa0cfceb$export$e4e69593f7c9f3b7 = (attributes, error)=>{
        (0, (0, parcelRequire("jcw0u")).default)({
            meta: {
                id: (0, $abaf639d63a27f10$export$c73007a11ea7e52),
                packageName: (0, $abaf639d63a27f10$export$c73007a11ea7e52),
                teamName: 'luna-growth'
            },
            attributes: {
                ...attributes
            },
            error: error
        });
    };
    const $7e87fb5ffa0cfceb$export$b48ea9d6b982b3e1 = (applicationEdition)=>{
        if (applicationEdition === (0, (0, parcelRequire("ldyPw")).FREE_EDITION)) return 0, $4c0643787f48cf65$export$e69af2c4378638a2;
        if (applicationEdition === (0, (0, parcelRequire("ldyPw")).STANDARD_EDITION)) return 0, $4c0643787f48cf65$export$7bc7dd5faba7ad6b;
        return 0, $4c0643787f48cf65$export$3fd0bbb8c68dc4c7;
    };
    const $7e87fb5ffa0cfceb$export$7d4045a899f62dfd = (0, (0, parcelRequire("dGrdR")).metrics).interaction({
        key: `${(0, $abaf639d63a27f10$export$c73007a11ea7e52)}.upgrade.plan`
    });
    const $7e87fb5ffa0cfceb$export$94ee0b5fca1e74d2 = (error)=>({
            chunkLoadError: (0, (0, parcelRequire("bCf8q")).isLoaderError)(error)
        });
    const $7e87fb5ffa0cfceb$export$d3da1ecaf1206c58 = (subject, onClose, apiError)=>{
        $7e87fb5ffa0cfceb$export$e4e69593f7c9f3b7({
            subject: subject,
            message: apiError?.message || ''
        }, apiError);
        $7e87fb5ffa0cfceb$export$7d4045a899f62dfd.cancel();
        onClose();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ajCo3")).CommerceApiErrorFlag), null);
    };
});
const $4c0643787f48cf65$export$e69af2c4378638a2 = 'free';
const $4c0643787f48cf65$export$7bc7dd5faba7ad6b = 'standard';
const $4c0643787f48cf65$export$3fd0bbb8c68dc4c7 = 'premium';
parcelRegister("ajCo3", function(module, exports) {
    $parcel$export(module.exports, "CommerceApiErrorFlag", ()=>$0ee877bbb47ef7cb$export$7ee77c445dd775b4);
    var $pa9q9;
    var $7HGHK;
    var $cPOtr;
    const $0ee877bbb47ef7cb$export$7ee77c445dd775b4 = ()=>{
        const flagKey = (0, (0, parcelRequire("7HGHK")).toFlagId)('commerce-api-error');
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        showFlag({
            id: flagKey,
            key: flagKey,
            type: 'error',
            title: (0, (0, parcelRequire("cPOtr")).default).title,
            description: (0, (0, parcelRequire("cPOtr")).default).description,
            isAutoDismiss: true
        });
        return null;
    };
});
parcelRegister("cPOtr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c8891414a165fed2$export$2e2bcd8739ae039);
    var $7VHMR;
    var $c8891414a165fed2$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "up-flow-iframe.common.commerce-api-error-flag.title",
            "defaultMessage": "We can't upgrade your plan right now"
        },
        description: {
            "id": "up-flow-iframe.common.commerce-api-error-flag.description",
            "defaultMessage": "Try again, or if this keeps happening try contacting support"
        }
    });
});
parcelRegister("g6ckq", function(module, exports) {
    $parcel$export(module.exports, "ChunkLoadErrorFlag", ()=>$590350b4061b001a$export$7a9d9407b3a5f50e);
    var $pa9q9;
    var $7HGHK;
    var $bCf8q;
    var $kgvbW;
    const $590350b4061b001a$export$7a9d9407b3a5f50e = ({ error: error })=>{
        const flagKey = (0, (0, parcelRequire("7HGHK")).toFlagId)('chunk-load-error');
        const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        if ((0, (0, parcelRequire("bCf8q")).isLoaderError)(error)) showFlag({
            id: flagKey,
            key: flagKey,
            type: 'error',
            title: (0, (0, parcelRequire("kgvbW")).default).title,
            description: (0, (0, parcelRequire("kgvbW")).default).description,
            isAutoDismiss: true,
            actions: [
                {
                    content: (0, (0, parcelRequire("kgvbW")).default).refreshPageButton,
                    onClick: ()=>{
                        dismissFlag(flagKey);
                        window.location.reload();
                    }
                }
            ]
        });
        return null;
    };
});
parcelRegister("kgvbW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ae312d01f0160cd3$export$2e2bcd8739ae039);
    var $7VHMR;
    var $ae312d01f0160cd3$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "up-flow-iframe.chunk-load-error-flag.title",
            "defaultMessage": "Something went wrong"
        },
        description: {
            "id": "up-flow-iframe.chunk-load-error-flag.description",
            "defaultMessage": "Refresh the page and try again."
        },
        refreshPageButton: {
            "id": "up-flow-iframe.chunk-load-error-flag.refresh-page-button",
            "defaultMessage": "Refresh page"
        }
    });
});
parcelRegister("e4DQi", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("9cUHu")
    ]).then(()=>parcelRequire('1W7nw'));
});
const $9996ddd22815931e$export$997e23a0aec74966 = 'https://confluence.atlassian.com/display/AdminJIRACloud/Jira+Cloud+plans';
const $9996ddd22815931e$export$30ce584c3652886c = 'https://support.atlassian.com/jira-cloud-administration/docs/permissions-for-company-managed-projects/#Edit-Workflows';
const $9996ddd22815931e$export$cfca87b5d4683694 = '/admin/billing/applications';
parcelRegister("de8ma", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fc942e740b757f44$export$2e2bcd8739ae039);
    var $7VHMR;
    var $fc942e740b757f44$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        upgradeToAddUsersHeader: {
            "id": "up-flow-upgrade-to-add-users-dialog.upgrade-to-add-users-header",
            "defaultMessage": "Upgrade to add users"
        },
        upgradeToAddUsersContent: {
            "id": "up-flow-upgrade-to-add-users-dialog.upgrade-to-add-users-content",
            "defaultMessage": "You've reached the maximum number of users for your plan.\nRemove existing users or upgrade to grow your team."
        },
        upgradeButtonLabel: {
            "id": "up-flow-upgrade-to-add-users-dialog.upgrade-button-label",
            "defaultMessage": "Try it now"
        },
        learnMoreButtonLabel: {
            "id": "up-flow-upgrade-to-add-users-dialog.learn-more-button-label",
            "defaultMessage": "Learn more"
        }
    });
});
parcelRegister("j6etC", function(module, exports) {
    $parcel$export(module.exports, "getRemainingSeats", ()=>$1d52ab7e56655772$export$6397e3bbf35b34e3);
    var $eusud;
    const $1d52ab7e56655772$var$toRemainingSeats = (json)=>json.remainingSeat;
    const $1d52ab7e56655772$export$6397e3bbf35b34e3 = (baseUrl, applicationKey)=>(0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/internal/2/invite-user/application/remaining-seat?key=${applicationKey}`).then((json)=>$1d52ab7e56655772$var$toRemainingSeats(json));
});
parcelRegister("eJpZk", function(module, exports) {
    $parcel$export(module.exports, "Analytics", ()=>$981a920c7dd6e4e8$export$2b3af6baec22bd98);
    var $5uXOq = parcelRequire("5uXOq");
    var $2NMNM;
    var $1sLR4;
    var $1zwpK;
    var $iqJSe;
    const $981a920c7dd6e4e8$export$2b3af6baec22bd98 = (props)=>{
        const { projectId: projectId, baseUrl: baseUrl, showAddPeopleButton: showAddPeopleButton, screenName: screenName } = props;
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            if (projectId >= 0 && showAddPeopleButton) Promise.all([
                (0, (0, parcelRequire("1zwpK")).getUserProjectRoles)(baseUrl, projectId),
                (0, (0, parcelRequire("1sLR4")).getProjectAccessLevel)(baseUrl, projectId)
            ]).then(([roleData, projectAccessLevel])=>{
                const projectRoleNames = roleData === null || roleData.projectRoleNames === null ? null : (0, (0, parcelRequire("iqJSe")).reduceCustomRoles)(roleData.projectRoleNames);
                (0, (0, parcelRequire("iqJSe")).fireAddPeopleRenderedEvent)(createAnalyticsEvent, screenName, projectId, projectRoleNames, projectAccessLevel);
            });
        }, [
            baseUrl,
            createAnalyticsEvent,
            projectId,
            screenName,
            showAddPeopleButton
        ]);
        return null;
    };
});
parcelRegister("1sLR4", function(module, exports) {
    $parcel$export(module.exports, "getProjectAccessLevel", ()=>$6d37e68816b91c3b$export$f5f97c28ee230e06);
    var $jcw0u;
    var $jJZqs;
    var $eusud;
    const $6d37e68816b91c3b$export$128fa18b7194ef = (baseUrl, projectId)=>`${baseUrl}/rest/internal/simplified/1.0/accesslevel/project/${projectId}`;
    const $6d37e68816b91c3b$var$transform = (data)=>data.value;
    const $6d37e68816b91c3b$export$f5f97c28ee230e06 = (baseUrl, projectId)=>{
        const request = ()=>(0, (0, parcelRequire("eusud")).performGetRequest)($6d37e68816b91c3b$export$128fa18b7194ef(baseUrl, projectId));
        return request().then((data)=>$6d37e68816b91c3b$var$transform(data)).catch((error)=>{
            const attributes = error instanceof (0, (0, parcelRequire("jJZqs")).default) ? {
                statusCode: error.statusCode,
                traceId: error.traceId
            } : {
                errorMessage: error.message
            };
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'fetchProjectAccessLevel',
                    packageName: 'jiraFilters',
                    teamName: 'a4t-tanuki'
                },
                error: error,
                attributes: attributes,
                sendToPrivacyUnsafeSplunk: true
            });
            return Promise.resolve(null);
        });
    };
});
parcelRegister("1zwpK", function(module, exports) {
    $parcel$export(module.exports, "getUserProjectRoles", ()=>$845d77939718574b$export$3b587d1e1fe73b9d);
    var $jcw0u;
    var $jJZqs;
    var $eusud;
    const $845d77939718574b$var$MEMBER_ROLE_NAME = 'Member';
    const $845d77939718574b$var$VIEWER_ROLE_NAME = 'Viewer';
    const $845d77939718574b$var$userProjectRoleNames = (data)=>data.map((projectRole)=>projectRole.name);
    const $845d77939718574b$export$5a1a2e9d57f47aee = (data)=>data.some((role)=>role.name === $845d77939718574b$var$MEMBER_ROLE_NAME);
    const $845d77939718574b$export$10eeb2d34050404e = (data)=>data.some((role)=>role.admin);
    const $845d77939718574b$export$a4d7f3415bee4b75 = (data)=>data.some((role)=>role.name !== $845d77939718574b$var$VIEWER_ROLE_NAME && role.name !== $845d77939718574b$var$MEMBER_ROLE_NAME && !role.admin);
    const $845d77939718574b$export$128fa18b7194ef = (baseUrl, projectId)=>`${baseUrl}/rest/api/3/project/${projectId}/roledetails?excludeConnectAddons=true&currentMember=true`;
    const $845d77939718574b$export$3b587d1e1fe73b9d = (baseUrl, projectId)=>{
        const request = ()=>(0, (0, parcelRequire("eusud")).performGetRequest)($845d77939718574b$export$128fa18b7194ef(baseUrl, projectId));
        return request().then((data)=>({
                isMember: $845d77939718574b$export$5a1a2e9d57f47aee(data),
                isJiraAdmin: $845d77939718574b$export$10eeb2d34050404e(data),
                hasCustomRole: $845d77939718574b$export$a4d7f3415bee4b75(data),
                projectRoleNames: $845d77939718574b$var$userProjectRoleNames(data)
            })).catch((error)=>{
            const attributes = error instanceof (0, (0, parcelRequire("jJZqs")).default) ? {
                statusCode: error.statusCode,
                traceId: error.traceId
            } : {
                errorMessage: error.message
            };
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'fetchUserProjectRoles',
                    packageName: 'jiraFilters',
                    teamName: 'a4t-tanuki'
                },
                error: error,
                attributes: attributes,
                sendToPrivacyUnsafeSplunk: true
            });
            return Promise.resolve(null);
        });
    };
});
parcelRegister("iqJSe", function(module, exports) {
    $parcel$export(module.exports, "fireAddPeopleRenderedEvent", ()=>$131644081500a421$export$8014b0c4810b7867);
    $parcel$export(module.exports, "reduceCustomRoles", ()=>$131644081500a421$export$7f2d1c0dab5190f9);
    var $8zOmE;
    const $131644081500a421$var$defaultProjectRoles = [
        'Administrator',
        'Member',
        'Viewer'
    ];
    const $131644081500a421$export$ecf9824f02c8a125 = 'Custom Role';
    const $131644081500a421$export$8014b0c4810b7867 = (createAnalyticsEvent, source, projectId, userProjectRoles, projectAccessLevel)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'rendered',
            actionSubject: 'addPeopleButton',
            source: source
        });
        (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, {
            projectId: projectId,
            userProjectRoles: userProjectRoles,
            projectAccessLevel: projectAccessLevel
        });
    };
    const $131644081500a421$export$7f2d1c0dab5190f9 = (userProjectRoles)=>{
        let hasCustomRole = false;
        const modifiedProjectRoles = userProjectRoles.reduce((acc, role)=>{
            const isDefaultRole = $131644081500a421$var$defaultProjectRoles.includes(role);
            hasCustomRole = hasCustomRole || !isDefaultRole;
            if (isDefaultRole) acc.push(role);
            return acc;
        }, []);
        if (hasCustomRole) modifiedProjectRoles.push($131644081500a421$export$ecf9824f02c8a125);
        return modifiedProjectRoles;
    };
});
parcelRegister("lAu6N", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$020a81e9686d5942$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Rkzz = parcelRequire("8Rkzz");
    var $dC5iT;
    var $8CUq3;
    var $az4zD;
    var $dCm1o;
    var $gQDFP;
    var $kfN7T;
    var $a43Dp;
    var $2eCzd;
    var $mafYu;
    const $020a81e9686d5942$var$AssigneeFilter = (props)=>{
        const { users: users, selectedUsers: selectedUsers, maxUsers: maxUsers, onAddPeopleClick: onAddPeopleClick, showAddPeopleButton: showAddPeopleButton, onToggle: onToggle, onAssigneeMenuOpen: onAssigneeMenuOpen, intl: { formatMessage: formatMessage }, peopleRef: peopleRef } = props;
        const mainList = (0, $5uXOq.useMemo)(()=>users.length > maxUsers ? users.slice(0, maxUsers - 1) : users.slice(0), [
            users,
            maxUsers
        ]);
        const moreList = (0, $5uXOq.useMemo)(()=>users.length > maxUsers ? users.slice(maxUsers - 1) : [], [
            users,
            maxUsers
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            as: "fieldset",
            xcss: [
                (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? $020a81e9686d5942$var$fieldsetStyles : $020a81e9686d5942$var$fieldsetStylesOld
            ],
            "data-test-id": "filters.ui.filters.assignee.stateless.assignee-filter",
            testId: "filters.ui.filters.assignee.stateless.assignee-filter",
            style: {
                zIndex: 0
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($020a81e9686d5942$var$AvatarFilterLegend, {
            id: (0, (0, parcelRequire("gQDFP")).FILTER_PREFIX)
        }, formatMessage((0, (0, parcelRequire("2eCzd")).default).label)), (0, ($parcel$interopDefault($5uXOq))).createElement($020a81e9686d5942$var$AvatarsList, null, mainList.map((user, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a43Dp")).default), {
                key: user.id,
                zIndex: maxUsers - index,
                user: user,
                isSelected: selectedUsers.includes(user.id),
                onToggle: onToggle
            })), moreList.length > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("mafYu")).default), {
            users: moreList,
            selectedUsers: selectedUsers,
            onItemActivated: onToggle,
            onOpen: onAssigneeMenuOpen
        }), showAddPeopleButton && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kfN7T")).default), {
            peopleButtonRef: peopleRef,
            onClick: onAddPeopleClick
        })));
    };
    $020a81e9686d5942$var$AssigneeFilter.defaultProps = {
        onAddPeopleClick: (0, ($parcel$interopDefault($8Rkzz))),
        onAssigneeMenuOpen: (0, ($parcel$interopDefault($8Rkzz))),
        onToggle: (0, ($parcel$interopDefault($8Rkzz))),
        showAddPeopleButton: false
    };
    var $020a81e9686d5942$export$2e2bcd8739ae039 = (0, (0, parcelRequire("az4zD")).injectIntlV2)($020a81e9686d5942$var$AssigneeFilter);
    const $020a81e9686d5942$var$fieldsetStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        flexShrink: 0,
        border: 0
    });
    const $020a81e9686d5942$var$fieldsetStylesOld = (0, (0, parcelRequire("8CUq3")).xcss)({
        flexShrink: 0,
        border: 0,
        marginLeft: 'space.150'
    });
    const $020a81e9686d5942$var$AvatarsList = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx2vrvc _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $020a81e9686d5942$var$AvatarFilterLegend = (0, $5uXOq.forwardRef)(({ as: C = "legend", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _4t3it94y _1bsbt94y _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _ogto7mnp _1reo15vq _18m915vq _o5721q9c",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("gQDFP", function(module, exports) {
    $parcel$export(module.exports, "FILTER_PREFIX", ()=>$4ab71e27db0ec1f1$export$d6acfe0d617669c3);
    $parcel$export(module.exports, "Z_INDEX", ()=>$4ab71e27db0ec1f1$export$42310dd57a41067);
    const $4ab71e27db0ec1f1$export$d6acfe0d617669c3 = 'assignee';
    const $4ab71e27db0ec1f1$export$42310dd57a41067 = {
        SELECTED: 1,
        ADD: 2,
        MENU: 3,
        HOVER: 4
    };
    const $4ab71e27db0ec1f1$export$e70f7f4a08e4d8fb = 10;
    const $4ab71e27db0ec1f1$export$75297e3804621b0 = 36;
});
parcelRegister("kfN7T", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$66a6af3ecba65952$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $8Rkzz = parcelRequire("8Rkzz");
    var $vIiRg;
    var $ijaND;
    var $4R6GH;
    var $8RXs9;
    var $cE2Qr;
    var $hchBL;
    var $2XCFo;
    var $gQDFP;
    var $k1LTw;
    var $cWMNe;
    var $7oMpD;
    var $ihiH5;
    const $66a6af3ecba65952$var$ADD_PEOPLE_BUTTON_TARGET = 'addPeopleButtonTarget';
    const $66a6af3ecba65952$var$AddUsersButton = (props)=>{
        const { intl: { formatMessage: formatMessage }, onClick: onClickProp, peopleButtonRef: peopleButtonRef } = props;
        const onClick = (0, $5uXOq.useCallback)((event)=>{
            (0, (0, parcelRequire("cWMNe")).onBlur)(event);
            onClickProp();
        }, [
            onClickProp
        ]);
        const [, { register: register }] = (0, (0, parcelRequire("hchBL")).useGlobalRefStoreActions)();
        const onRef = (0, $5uXOq.useCallback)((ref)=>{
            register($66a6af3ecba65952$var$ADD_PEOPLE_BUTTON_TARGET, ref);
        }, [
            register
        ]);
        const [isDismissed] = (0, (0, parcelRequire("cE2Qr")).useIsDismissed)();
        const NudgeTooltip = !(0, (0, parcelRequire("4R6GH")).fg)('jsw-perf-async-add-people-modal-load') || !isDismissed ? (0, (0, parcelRequire("2XCFo")).AssigneeFilterAddPeopleButtonWrapperNudgeAsync) : (0, $5uXOq.Fragment);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($66a6af3ecba65952$var$AddButtonWrapper, {
            ref: onRef
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(NudgeTooltip, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ihiH5")).AddPeopleTooltip), {
            content: formatMessage((0, (0, parcelRequire("7oMpD")).default).addPeople)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($66a6af3ecba65952$var$ActionAvatarWrapper, {
            ref: peopleButtonRef,
            "data-test-id": "filters.ui.filters.assignee.stateless.add-button",
            "data-testid": "filters.ui.filters.assignee.stateless.add-button",
            "data-pollinator-filter-bar-add-people": true,
            id: `${(0, (0, parcelRequire("gQDFP")).FILTER_PREFIX)}-add-person`,
            "aria-label": formatMessage((0, (0, parcelRequire("7oMpD")).default).addPeople),
            onClick: onClick,
            "aria-describedby": (0, (0, parcelRequire("gQDFP")).FILTER_PREFIX)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($66a6af3ecba65952$var$AddButtonAvatarSpacer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("ijaND"))))), {
            size: "medium",
            label: formatMessage((0, (0, parcelRequire("7oMpD")).default).addPeople)
        }))))));
    };
    $66a6af3ecba65952$var$AddUsersButton.defaultProps = {
        onClick: (0, ($parcel$interopDefault($8Rkzz)))
    };
    var $66a6af3ecba65952$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($66a6af3ecba65952$var$AddUsersButton);
    const $66a6af3ecba65952$var$AddButtonWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u01b66",
                __cmplp.className
            ])
        });
    });
    const $66a6af3ecba65952$var$ActionAvatarWrapper = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("k1LTw")).ActionAvatar), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2rko1ssb _1e0c1txw",
                __cmplp.className
            ])
        });
    });
    const $66a6af3ecba65952$var$AddButtonAvatarSpacer = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("k1LTw")).ActionAvatarSpacer), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_1lu4wzb": (0, (0, parcelRequire("lD23V")).default)((0, (0, parcelRequire("vIiRg")).AVATAR_SIZES).medium, "px")
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2rko12pq _1ul912pq _1bsb1wug _1yt4otz2 _vchhusvi _bfhk1s4m _1p9v18uv",
                __cmplp.className
            ])
        });
    });
    const $66a6af3ecba65952$export$7ed12d2a5241e393 = {
        ActionAvatarWrapper: $66a6af3ecba65952$var$ActionAvatarWrapper
    };
});
parcelRegister("ijaND", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $d54260e58fec7f9a$var$_react = $d54260e58fec7f9a$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $d54260e58fec7f9a$var$_personAdd = $d54260e58fec7f9a$var$_interopRequireDefault((parcelRequire("fvfvk")));
    function $d54260e58fec7f9a$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $d54260e58fec7f9a$var$InviteTeamIcon = (props)=>$d54260e58fec7f9a$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="2" height="6" x="18" y="5" rx="1"/><rect width="6" height="2" x="16" y="7" rx="1"/><path d="M5 14c0-1.105.902-2 2.009-2h7.982c1.11 0 2.009.894 2.009 2.006v4.44c0 3.405-12 3.405-12 0z"/><circle cx="11" cy="7" r="4"/></g></svg>`
        }, props, {
            newIcon: $d54260e58fec7f9a$var$_personAdd.default
        }));
    $d54260e58fec7f9a$var$InviteTeamIcon.displayName = 'InviteTeamIcon';
    var $d54260e58fec7f9a$var$_default = module.exports.default = $d54260e58fec7f9a$var$InviteTeamIcon;
});
parcelRegister("fvfvk", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $b495c71cb30b2c7c$var$_react = $b495c71cb30b2c7c$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $b495c71cb30b2c7c$var$_UNSAFE_baseNew = $b495c71cb30b2c7c$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $b495c71cb30b2c7c$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $b495c71cb30b2c7c$var$PersonAddIcon = (props)=>$b495c71cb30b2c7c$var$_react.default.createElement($b495c71cb30b2c7c$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M.75 15v-2.25a3 3 0 0 1 3-3h2.5a3 3 0 0 1 3 3V15M13 8V5m0 3v3m0-3h3m-3 0h-3M8.25 4a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0Z"/>`
        }, props));
    $b495c71cb30b2c7c$var$PersonAddIcon.displayName = 'PersonAddIcon';
    var $b495c71cb30b2c7c$var$_default = module.exports.default = $b495c71cb30b2c7c$var$PersonAddIcon;
});
parcelRegister("hchBL", function(module, exports) {
    $parcel$export(module.exports, "useGlobalRef", ()=>$b03364e48d8512c5$export$361e4f658203e95);
    $parcel$export(module.exports, "useGlobalRefStoreActions", ()=>$b03364e48d8512c5$export$3c6c6911d09d7d8a);
    $parcel$export(module.exports, "withGlobalRef", ()=>$b03364e48d8512c5$export$6b4b878b04fd3017);
    var $5uXOq = parcelRequire("5uXOq");
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    const $b03364e48d8512c5$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {},
        actions: {
            register: (key, ref)=>({ setState: setState })=>{
                    setState({
                        [key]: ref || undefined
                    });
                }
        },
        name: 'refs-store'
    });
    const $b03364e48d8512c5$export$4beaa3baa53198e4 = (0, (0, parcelRequire("gg7kZ")).createContainer)($b03364e48d8512c5$var$store);
    const $b03364e48d8512c5$var$useGlobalRefStateSelector = (0, (0, parcelRequire("3sQ5x")).createStateHook)($b03364e48d8512c5$var$store, {
        selector: (state, key)=>state[key]
    });
    const $b03364e48d8512c5$export$361e4f658203e95 = (key)=>[
            $b03364e48d8512c5$var$useGlobalRefStateSelector(key)
        ];
    const $b03364e48d8512c5$export$3c6c6911d09d7d8a = (0, (0, parcelRequire("3sQ5x")).createHook)($b03364e48d8512c5$var$store, {
        selector: null
    });
    const $b03364e48d8512c5$export$6b4b878b04fd3017 = (propName, refName)=>(Component)=>(props)=>{
                const [ref] = $b03364e48d8512c5$export$361e4f658203e95(refName);
                return (0, ($parcel$interopDefault($5uXOq))).createElement(Component, {
                    ...props,
                    [propName]: ref
                });
            };
});
parcelRegister("2XCFo", function(module, exports) {
    $parcel$export(module.exports, "AssigneeFilterAddPeopleButtonWrapperNudgeAsync", ()=>$ca2358eaf62c0b1a$export$4e4097c2567f79b7);
    var $5uXOq = parcelRequire("5uXOq");
    var $bBbEG;
    var $lfTZh;
    var $kxZPA;
    const $ca2358eaf62c0b1a$var$AssigneeFilterAddPeopleButtonLazy = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("1YfpH")).then((exportedModule)=>exportedModule.AssigneeFilterAddPeopleButtonWrapperNudge), {
        ssr: false,
        moduleId: "./src/packages/software/onboarding-nudges/src/ui/assignee-filter-add-people/index.tsx"
    });
    const $ca2358eaf62c0b1a$export$4e4097c2567f79b7 = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bBbEG")).OnboardingNudgeErrorBoundary), {
            id: (0, $6784cbc7d62e5d7c$export$92c7f0eacc8d8d98),
            fallback: children,
            attributes: {
                nudgeId: (0, $6784cbc7d62e5d7c$export$92c7f0eacc8d8d98)
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "software-onboarding-assignee-filter-add-people-nudge",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ca2358eaf62c0b1a$var$AssigneeFilterAddPeopleButtonLazy, {
            nudgeId: (0, $6784cbc7d62e5d7c$export$92c7f0eacc8d8d98)
        }, children)));
});
const $6784cbc7d62e5d7c$export$67abe0a3b8dfe03f = 'should-show-scrum-modal-v2';
const $6784cbc7d62e5d7c$export$4e1360a3e7785935 = 'should-show-kanban-modal';
const $6784cbc7d62e5d7c$export$e3884212029f7bef = 'should-show-welcome-modal';
const $6784cbc7d62e5d7c$export$eaf6b96a17b6476c = 'can-enroll-in-select-initial-view';
const $6784cbc7d62e5d7c$export$891ca65264b256bb = 'should-show-personlized-sample-data-for-kanban';
const $6784cbc7d62e5d7c$export$f47dca9dda77d157 = 'should-hide-quickstart-for-personalized-sample-data';
const $6784cbc7d62e5d7c$export$928ffae10e4c0006 = 'template-key-to-show-onboarding-modal';
const $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe = 'onboarding-selected-project-template-type';
const $6784cbc7d62e5d7c$export$69fe8832c4f79a32 = 'onboarding_started_timestamp';
const $6784cbc7d62e5d7c$export$a8d62e500b59f31e = 'boardCreateColumnButtonNudge';
const $6784cbc7d62e5d7c$export$92c7f0eacc8d8d98 = 'assigneeFilterAddPeopleButtonNudge';
const $6784cbc7d62e5d7c$export$dd63d0099d95ba4f = 'navigationAppsNavItemNudge';
const $6784cbc7d62e5d7c$export$aba87e019f5ccb8d = 'navigationCreateIssueButtonNudge';
const $6784cbc7d62e5d7c$export$46d9a3d441dfd22b = 'navigationPlansNavItemNudge';
const $6784cbc7d62e5d7c$export$e20072f7d0c5357f = 'roadmapCreateEpicButtonNudge';
const $6784cbc7d62e5d7c$export$1e39959907a7f359 = 'roadmapCreateEpicChildIssueButtonNudge';
const $6784cbc7d62e5d7c$export$b74a8fdb2c75b869 = 'navigationPeopleNavItemNudge';
const $6784cbc7d62e5d7c$export$b1a6ab17737f33e = 'backlogAccordionNudge';
const $6784cbc7d62e5d7c$export$3366ddefe77d5112 = 'boardCreateColumnNudge';
const $6784cbc7d62e5d7c$export$9d9e95a66a2c6abe = 'addItemsCalendarNudge';
const $6784cbc7d62e5d7c$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $6784cbc7d62e5d7c$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $6784cbc7d62e5d7c$export$7aa8bceae32c7862 = 'navigationAppsProfileItemNudge';
const $6784cbc7d62e5d7c$export$c6df9a2c7447e12d = 'getStartedListNudge';
const $6784cbc7d62e5d7c$export$468488291ccd988 = 'timelineAddItemNudge';
const $6784cbc7d62e5d7c$export$7a33548109ac931d = 'createFormNudge';
const $6784cbc7d62e5d7c$export$b65ba9ea0c0ced43 = 'jsw-onboarding-checklist.open';
const $6784cbc7d62e5d7c$export$3b5d230b66f60471 = 'jsw-onboarding-checklist.visibility';
const $6784cbc7d62e5d7c$export$594d3436316492be = 'summaryViewNudge';
const $6784cbc7d62e5d7c$export$77bc79debbf5c069 = 'inviteTeamNudge';
parcelRegister("1YfpH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("d744b")
    ]).then(()=>parcelRequire('1Pog6'));
});
parcelRegister("k1LTw", function(module, exports) {
    $parcel$export(module.exports, "AvatarWrapper", ()=>$03be4aba8d3a8915$export$f7513421c53ce141);
    $parcel$export(module.exports, "ActionAvatar", ()=>$03be4aba8d3a8915$export$1a5d4fdc8fa41cfb);
    $parcel$export(module.exports, "ActionAvatarSpacer", ()=>$03be4aba8d3a8915$export$d1aac2da5f30c370);
    $parcel$export(module.exports, "AvatarBorder", ()=>$03be4aba8d3a8915$export$398a7826f6fd570e);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $vIiRg;
    var $7XYc4;
    var $dCm1o;
    var $gQDFP;
    const $03be4aba8d3a8915$export$483a2b43be170225 = {
        position: 'absolute',
        width: '100%',
        height: '100%',
        padding: 0,
        border: 0,
        opacity: 0,
        overflow: 'hidden',
        'white-space': 'nowrap',
        cursor: 'pointer'
    };
    const $03be4aba8d3a8915$export$a3e8c7acf36da4c1 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { zIndex: zIndex, jiggle: jiggle, ...__cmpldp } = __cmplp;
        return $5uXOq.createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_10xi207": (0, (0, parcelRequire("lD23V")).default)(__cmplp.zIndex + (0, (0, parcelRequire("gQDFP")).Z_INDEX).SELECTED),
                "--_3qw8s9": (0, (0, parcelRequire("lD23V")).default)(__cmplp.zIndex),
                "--_1rh09jt": (0, (0, parcelRequire("lD23V")).default)(__cmplp.zIndex + (0, (0, parcelRequire("gQDFP")).Z_INDEX).HOVER)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c116y _4cvr1h6o _4t3i1ylp _kqswh2mm _18u014id _bfhk18uv _s7n4jp4b _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _v5644a6k _2rko1ssb _11cpidpf _rk8t1bgr _1dig1bgr _yt1x1bgr _qa15stnw _1tfxstnw _ixiwstnw _1wnsb3bt _h10pb3bt _1boqb3bt _328d1osq _cqfi1osq _rtz31osq _1mhnidpf _44x7idpf _l3jaidpf _1rky1n1a _1a071n1a _1wtq1n1a _1xpg1n1a _ti301n1a _1j2w1n1a _s1sf1mrw _1v981mrw _x2d61mrw _1pcqvab1 _1qb3vab1 _1b1bvab1 _vdzntlke _1virtlke _1y7ctlke",
                __cmplp.selected ? "_1pby1ho9" : "_1pby1hh6",
                __cmplp.jiggle ? "_1bvqr915 _66dkr915 _1llwr915" : "_1bvq1kli _66dk1kli _1llw1kli",
                __cmplp.jiggle ? "_n3lxmyb0 _gabdmyb0 _9di1myb0" : "_n3lxidpf _gabdidpf _9di1idpf",
                __cmplp.className
            ])
        });
    });
    const $03be4aba8d3a8915$export$7d5adb020315f211 = (0, $5uXOq.forwardRef)(({ as: C = $03be4aba8d3a8915$export$a3e8c7acf36da4c1, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3in7od",
                __cmplp.className
            ])
        });
    });
    const $03be4aba8d3a8915$export$f7513421c53ce141 = (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled), $03be4aba8d3a8915$export$7d5adb020315f211, $03be4aba8d3a8915$export$a3e8c7acf36da4c1);
    const $03be4aba8d3a8915$export$1a5d4fdc8fa41cfb = (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _2rko1ssb _19it7zi8 _bfhk1s4m _v5644dm8 _80omtlke _7ehi12h7 _nt751r31 _49pcglyw _1hvw1o36 _irr3yucn",
                __cmplp.className
            ])
        });
    });
    const $03be4aba8d3a8915$export$d1aac2da5f30c370 = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_1lu4wzb": (0, (0, parcelRequire("lD23V")).default)((0, (0, parcelRequire("vIiRg")).AVATAR_SIZES).medium, "px")
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2rko1ssb _1e0c1txw _4cvr1h6o _1bah1h6o _1bsb12pq _4t3i12pq _bfhk18uv _syazi7uo _vwz412pq",
                __cmplp.className
            ])
        });
    });
    const $03be4aba8d3a8915$export$398a7826f6fd570e = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2rko1ssb _19itj1ic",
                __cmplp.selected ? "_1h6d1c86" : "_1h6d3acm",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("cWMNe", function(module, exports) {
    $parcel$export(module.exports, "onBlur", ()=>$3b2d077e6f2bec18$export$5e446bc31724fca4);
    $parcel$export(module.exports, "useOnKeyPress", ()=>$3b2d077e6f2bec18$export$49f6dd346c7dfb52);
    var $5uXOq = parcelRequire("5uXOq");
    const $3b2d077e6f2bec18$export$5e446bc31724fca4 = (event)=>{
        event.currentTarget.blur();
    };
    const $3b2d077e6f2bec18$export$49f6dd346c7dfb52 = (callback)=>(0, $5uXOq.useCallback)((event)=>{
            if (event.key === 'Enter') callback(event);
        }, [
            callback
        ]);
});
parcelRegister("7oMpD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$84bb6f0a7c1ddc3e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $84bb6f0a7c1ddc3e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        addPeople: {
            "id": "software-filters.filters.assignee.stateless.add-button.add-people",
            "defaultMessage": "Add people"
        }
    });
});
parcelRegister("ihiH5", function(module, exports) {
    $parcel$export(module.exports, "AddPeopleTooltip", ()=>$936c019622c243d2$export$7d4858372ded9f0e);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $3bDjY;
    const $936c019622c243d2$export$7d4858372ded9f0e = ({ content: content, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: content
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($936c019622c243d2$var$TooltipWrapper, null, children));
    const $936c019622c243d2$var$TooltipWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1o8l _kqswh2mm _12ji1r31 _1qu2glyw _12y3idpf _4t3i14no",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("a43Dp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$68ed3a89d7efd9a4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Rkzz = parcelRequire("8Rkzz");
    var $ujWmd;
    var $3bDjY;
    var $joX8T;
    var $4R6GH;
    var $8RXs9;
    var $2WENx;
    var $dCm1o;
    var $k1LTw;
    var $cWMNe;
    var $f0vy0;
    var $iv6Wk;
    const $68ed3a89d7efd9a4$var$type = 'assignee';
    const $68ed3a89d7efd9a4$var$Avatar = (props)=>{
        const { user: user, isSelected: isSelected, zIndex: zIndex, intl: intl } = props;
        const { formatMessage: formatMessage } = intl;
        const userIdentifier = user.id;
        const checkboxId = `${$68ed3a89d7efd9a4$var$type}-${userIdentifier}`;
        const onToggle = (0, $5uXOq.useCallback)(()=>{
            props.onToggle(user.id);
        }, [
            props,
            user.id
        ]);
        const onKeyPress = (0, (0, parcelRequire("cWMNe")).useOnKeyPress)(onToggle);
        const { experimentCohort: experimentCohort } = (0, (0, parcelRequire("2WENx")).useRealtimePresenceExperiment)();
        const isRealtimePresenceEnabled = experimentCohort === (0, (0, parcelRequire("joX8T")).VARIATION);
        const altTextWithPresence = formatMessage(user.presence === 'online' ? (0, (0, parcelRequire("iv6Wk")).default).presenceOnlineLabel : (0, (0, parcelRequire("iv6Wk")).default).presenceOfflineLabel, {
            name: user.displayName
        });
        const avatarWithTooltip = isRealtimePresenceEnabled ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f0vy0")).default), {
            content: user.displayName,
            presence: user.presence,
            tag: "span"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
            testId: "filters.ui.filters.assignee.stateless.avatar.ak-avatar",
            size: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap_drop_1') ? 'small' : 'medium',
            as: "span",
            src: user.avatarUrl,
            name: user.presence ? altTextWithPresence : user.displayName,
            presence: user.presence
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: user.displayName,
            tag: "span"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
            testId: "filters.ui.filters.assignee.stateless.avatar.ak-avatar",
            size: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap_drop_1') ? 'small' : 'medium',
            as: "span",
            src: user.avatarUrl,
            name: user.displayName,
            presence: user.presence
        }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k1LTw")).AvatarWrapper), {
            selected: isSelected,
            zIndex: zIndex
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($68ed3a89d7efd9a4$var$AvatarInputCheckbox, {
            "aria-label": formatMessage((0, (0, parcelRequire("iv6Wk")).default).avatarInputCheckboxLabel),
            type: "checkbox",
            id: checkboxId,
            name: $68ed3a89d7efd9a4$var$type,
            value: userIdentifier,
            defaultChecked: isSelected,
            onChange: onToggle,
            onKeyPress: onKeyPress,
            onClick: (0, (0, parcelRequire("cWMNe")).onBlur)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k1LTw")).AvatarBorder), {
            selected: isSelected
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($68ed3a89d7efd9a4$var$AvatarLabel, {
            "data-test-id": "filters.ui.filters.assignee.stateless.avatar.assignee-filter-avatar",
            "data-testid": "filters.ui.filters.assignee.stateless.avatar.assignee-filter-avatar",
            htmlFor: checkboxId
        }, avatarWithTooltip)));
    };
    $68ed3a89d7efd9a4$var$Avatar.defaultProps = {
        isSelected: false,
        onToggle: (0, ($parcel$interopDefault($8Rkzz)))
    };
    var $68ed3a89d7efd9a4$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($68ed3a89d7efd9a4$var$Avatar);
    const $68ed3a89d7efd9a4$var$AvatarLabel = (0, $5uXOq.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_vwz4idpf _1e0c1ule _80omtlke",
                __cmplp.className
            ])
        });
    });
    const $68ed3a89d7efd9a4$var$AvatarInputCheckbox = (0, $5uXOq.forwardRef)(({ as: C = "input", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _1bsb1osq _4t3i1osq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _tzy4idpf _1reo15vq _18m915vq _o5721q9c _80omtlke _1xp4rg51",
                __cmplp.className
            ])
        });
    });
    const $68ed3a89d7efd9a4$export$7ed12d2a5241e393 = {
        AvatarInputCheckbox: $68ed3a89d7efd9a4$var$AvatarInputCheckbox
    };
});
parcelRegister("2WENx", function(module, exports) {
    $parcel$export(module.exports, "useRealtimePresenceExperiment", ()=>$ef9e8ab383852170$export$ba964695877b24);
    var $4mBKK;
    var $6s1PB;
    var $dkqym;
    const $ef9e8ab383852170$export$ba964695877b24 = ()=>{
        const firstActivationDateMs = (0, (0, parcelRequire("dkqym")).useFirstActivationDateMs)();
        const [expConfig] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('jsw_board_real-time_collaboration_through_presence');
        return {
            experimentCohort: !firstActivationDateMs || (0, (0, parcelRequire("4mBKK")).default)(new Date(), firstActivationDateMs) < 30 ? 'not-enrolled' : expConfig.get('cohort', 'not-enrolled')
        };
    };
});
parcelRegister("dkqym", function(module, exports) {
    $parcel$export(module.exports, "useFirstActivationDateMs", ()=>$61794ef454831b86$export$9df3a539e50a284b);
    var $9OXo1;
    const $61794ef454831b86$export$9df3a539e50a284b = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return tenantContext && tenantContext.firstActivationDateMs != null ? tenantContext.firstActivationDateMs : null;
    };
});
parcelRegister("f0vy0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fff18090899dca54$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3bDjY;
    var $koVbs;
    var $hf0Xf;
    const $fff18090899dca54$var$PresenceTooltip = ({ presence: presence, content: content, children: children, ...restProps })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const contentWithPresence = presence === 'online' ? formatMessage((0, (0, parcelRequire("hf0Xf")).default).presenceToolTipOnline, {
            name: String(content)
        }) : formatMessage((0, (0, parcelRequire("hf0Xf")).default).presenceToolTipOffline, {
            name: String(content)
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: presence ? contentWithPresence : content,
            ...restProps
        }, children);
    };
    var $fff18090899dca54$export$2e2bcd8739ae039 = $fff18090899dca54$var$PresenceTooltip;
});
parcelRegister("hf0Xf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$14a1fa5c7f46c36b$export$2e2bcd8739ae039);
    var $7VHMR;
    var $14a1fa5c7f46c36b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        presenceToolTipOnline: {
            "id": "software-filters.common.presence-tooltip.presence-tool-tip-online",
            "defaultMessage": "{name} is online"
        },
        presenceToolTipOffline: {
            "id": "software-filters.common.presence-tooltip.presence-tool-tip-offline",
            "defaultMessage": "{name} is offline"
        }
    });
});
parcelRegister("iv6Wk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2a7903d4e27c8480$export$2e2bcd8739ae039);
    var $7VHMR;
    var $2a7903d4e27c8480$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        presenceOnlineLabel: {
            "id": "software-filters.filters.assignee.stateless.avatar.presence-online-label",
            "defaultMessage": "{name} (online)"
        },
        presenceOfflineLabel: {
            "id": "software-filters.filters.assignee.stateless.avatar.presence-offline-label",
            "defaultMessage": "{name} (offline)"
        },
        avatarInputCheckboxLabel: {
            "id": "software-filters.filters.assignee.stateless.avatar.avatar-input-checkbox-label",
            "defaultMessage": "assignee filter avatar"
        }
    });
});
parcelRegister("2eCzd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0a3184a04c19fde7$export$2e2bcd8739ae039);
    var $7VHMR;
    var $0a3184a04c19fde7$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        label: {
            "id": "software-filters.filters.assignee.stateless.label",
            "defaultMessage": "Filter by assignee"
        },
        showMoreButton: {
            "id": "software-filters.filters.assignee.stateless.show-more",
            "defaultMessage": "Show more assignees"
        }
    });
});
parcelRegister("mafYu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bb88f751cbd22241$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $8Rkzz = parcelRequire("8Rkzz");
    var $vIiRg;
    var $ujWmd;
    var $BLPHT;
    var $jFrow;
    var $3bDjY;
    var $joX8T;
    var $4R6GH;
    var $koVbs;
    var $2WENx;
    var $g5X3G;
    var $dCm1o;
    var $gQDFP;
    var $k1LTw;
    var $cWMNe;
    var $f0vy0;
    var $2eCzd;
    const $bb88f751cbd22241$var$ShowMoreButton = (props)=>{
        const { users: users, selectedUsers: selectedUsers, onOpen: onOpen, onItemActivated: onItemActivatedProps } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [isOpen, setOpenState] = (0, $5uXOq.useState)(false);
        const _onOpenChange = (0, $5uXOq.useCallback)((attrs)=>{
            setOpenState(attrs.isOpen);
            if (attrs.isOpen) onOpen();
        }, [
            setOpenState,
            onOpen
        ]);
        const isSelected = (0, $5uXOq.useMemo)(()=>users.some((user)=>selectedUsers.includes(user.id)), [
            users,
            selectedUsers
        ]);
        const { experimentCohort: experimentCohort } = (0, (0, parcelRequire("2WENx")).useRealtimePresenceExperiment)();
        const isRealtimePresenceEnabled = experimentCohort === (0, (0, parcelRequire("joX8T")).VARIATION);
        const dropdownItems = (0, $5uXOq.useMemo)(()=>users.map(({ id: id, displayName: displayName, avatarUrl: avatarUrl, presence: presence })=>(0, ($parcel$interopDefault($5uXOq))).createElement($bb88f751cbd22241$var$ItemWrapper, {
                    key: id
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jFrow")).default), {
                    id: id,
                    isSelected: selectedUsers.includes(id),
                    onClick: ()=>{
                        onItemActivatedProps((0, (0, parcelRequire("g5X3G")).toAccountId)(String(id)));
                    }
                }, (0, ($parcel$interopDefault($5uXOq))).createElement($bb88f751cbd22241$var$ItemContent, null, isRealtimePresenceEnabled ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f0vy0")).default), {
                    content: displayName,
                    presence: presence
                }, (0, ($parcel$interopDefault($5uXOq))).createElement($bb88f751cbd22241$var$DropdownAvatarWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
                    size: "small",
                    src: avatarUrl,
                    name: displayName,
                    presence: presence
                }))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                    content: displayName
                }, (0, ($parcel$interopDefault($5uXOq))).createElement($bb88f751cbd22241$var$DropdownAvatarWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
                    size: "small",
                    src: avatarUrl,
                    name: displayName,
                    presence: presence
                }))), (0, ($parcel$interopDefault($5uXOq))).createElement($bb88f751cbd22241$var$TextContentWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($bb88f751cbd22241$var$TextContent, null, displayName)))))), [
            users,
            selectedUsers,
            onItemActivatedProps,
            isRealtimePresenceEnabled
        ]);
        const avatarWrapperStyle = {
            margin: 0,
            padding: 0,
            border: 0,
            borderRadius: '50%',
            background: 'none',
            outline: 0
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement($bb88f751cbd22241$var$DropdownMenuWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("BLPHT")).default), {
            trigger: ({ triggerRef: triggerRef, 'aria-expanded': ariaExpanded, ...triggerProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k1LTw")).AvatarWrapper), {
                    ...triggerProps,
                    as: (0, (0, parcelRequire("4R6GH")).fg)('jsw-filters-avatar-show-more-aria-fix') ? 'button' : undefined,
                    "aria-expanded": ariaExpanded,
                    ref: triggerRef,
                    zIndex: (0, (0, parcelRequire("gQDFP")).Z_INDEX).MENU,
                    style: (0, (0, parcelRequire("4R6GH")).fg)('jsw-filters-avatar-show-more-aria-fix') ? avatarWrapperStyle : undefined,
                    "data-testid": (0, (0, parcelRequire("4R6GH")).fg)('jsw-filters-avatar-show-more-aria-fix') ? 'filters.ui.filters.assignee.stateless.show-more-button.assignee-filter-show-more' : undefined
                }, !(0, (0, parcelRequire("4R6GH")).fg)('jsw-filters-avatar-show-more-aria-fix') ? (0, ($parcel$interopDefault($5uXOq))).createElement($bb88f751cbd22241$var$ActionInputCheckbox, {
                    "data-test-id": "filters.ui.filters.assignee.stateless.show-more-button.assignee-filter-show-more",
                    "data-testid": "filters.ui.filters.assignee.stateless.show-more-button.assignee-filter-show-more",
                    type: "checkbox",
                    id: `${(0, (0, parcelRequire("gQDFP")).FILTER_PREFIX)}-show-more`,
                    name: (0, (0, parcelRequire("gQDFP")).FILTER_PREFIX),
                    value: `${(0, (0, parcelRequire("gQDFP")).FILTER_PREFIX)}-show-more`,
                    defaultChecked: isOpen,
                    "aria-expanded": ariaExpanded,
                    "aria-label": formatMessage((0, (0, parcelRequire("2eCzd")).default).showMoreButton),
                    onClick: (0, (0, parcelRequire("cWMNe")).onBlur)
                }) : null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k1LTw")).AvatarBorder), {
                    selected: isSelected
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k1LTw")).ActionAvatar), {
                    as: (0, (0, parcelRequire("4R6GH")).fg)('jsw-filters-avatar-show-more-aria-fix') ? 'div' : undefined,
                    tabIndex: -1
                }, (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap_drop_1') ? (0, ($parcel$interopDefault($5uXOq))).createElement($bb88f751cbd22241$var$ShowMoreButtonAvatarSpacer, null, `+${users.length}`) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k1LTw")).ActionAvatarSpacer), null, `+${users.length}`))))
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($bb88f751cbd22241$var$DropdownItemsWrapper, null, dropdownItems)));
    };
    $bb88f751cbd22241$var$ShowMoreButton.defaultProps = {
        onItemActivated: (0, ($parcel$interopDefault($8Rkzz))),
        onOpen: (0, ($parcel$interopDefault($8Rkzz)))
    };
    var $bb88f751cbd22241$export$2e2bcd8739ae039 = $bb88f751cbd22241$var$ShowMoreButton;
    const $bb88f751cbd22241$var$DropdownMenuWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c116y _4cvr1h6o _18u014id _1pbyidpf",
                __cmplp.className
            ])
        });
    });
    const $bb88f751cbd22241$var$DropdownItemsWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_p12f1mjv _1yt4swc3",
                __cmplp.className
            ])
        });
    });
    const $bb88f751cbd22241$var$ItemWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1t4ug9d8 _k907ze3t",
                __cmplp.className
            ])
        });
    });
    const $bb88f751cbd22241$var$ItemContent = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bto1l2s",
                __cmplp.className
            ])
        });
    });
    const $bb88f751cbd22241$var$DropdownAvatarWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _18u0v77o",
                __cmplp.className
            ])
        });
    });
    const $bb88f751cbd22241$var$TextContentWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _18s816r1 _1yt41w01 _1reo15vq _18m915vq",
                __cmplp.className
            ])
        });
    });
    const $bb88f751cbd22241$var$TextContent = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1reo15vq _18m915vq _1bto1l2s _o5721q9c",
                __cmplp.className
            ])
        });
    });
    const $bb88f751cbd22241$var$ActionInputCheckbox = (0, $5uXOq.forwardRef)(({ as: C = "input", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _1bsb1osq _4t3i1osq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _tzy4idpf _1reo15vq _18m915vq _o5721q9c _80omtlke _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1glwzk5k _5o9f194a",
                __cmplp.className
            ])
        });
    });
    const $bb88f751cbd22241$var$ShowMoreButtonAvatarSpacer = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("k1LTw")).ActionAvatarSpacer), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_wiw70x": (0, (0, parcelRequire("lD23V")).default)((0, (0, parcelRequire("vIiRg")).AVATAR_SIZES).small, "px")
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1yj7 _4t3i1yj7 _1wyb19bv _t9ec1win",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("jFrow", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9d90ebe7a2adf26d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eGmKJ;
    var $j7LBE;
    var $kJpBP;
    var $VSDnB;
    var $hEtee;
    var $6PlGW;
    var $l7Q0F;
    var $6cAn5 = parcelRequire("6cAn5");
    const $9d90ebe7a2adf26d$var$DropdownItemCheckbox = ({ children: children, defaultSelected: defaultSelected, description: description, id: id, isDisabled: isDisabled, isSelected: isSelected, onClick: providedOnClick = (0, (0, parcelRequire("eGmKJ")).default), shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, testId: testId, interactionName: interactionName, ...rest })=>{
        typeof $6cAn5;
        const [selected, setSelected] = (0, (0, parcelRequire("6PlGW")).default)({
            id: id,
            isSelected: isSelected,
            defaultSelected: defaultSelected
        });
        const onClickHandler = (0, $5uXOq.useCallback)((event)=>{
            setSelected((selected)=>!selected);
            providedOnClick(event);
        }, [
            providedOnClick,
            setSelected
        ]);
        const itemRef = (0, (0, parcelRequire("l7Q0F")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j7LBE")).SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
            value: "none"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
            "aria-checked": selected,
            description: description,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hEtee")).default), {
                checked: selected
            }),
            id: id,
            isDisabled: isDisabled,
            isSelected: selected,
            onClick: onClickHandler,
            ref: itemRef,
            role: "menuitemcheckbox",
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest
        }, children));
    };
    var $9d90ebe7a2adf26d$export$2e2bcd8739ae039 = $9d90ebe7a2adf26d$var$DropdownItemCheckbox;
});
parcelRegister("hEtee", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$181f17e87025e1b2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dV6Te;
    const $181f17e87025e1b2$var$CheckboxIcon = ({ checked: checked })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dV6Te")).default), {
            label: "",
            size: "medium",
            primaryColor: checked ? `var(--ds-background-selected-bold, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})` : `var(--ds-background-input, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})`,
            secondaryColor: checked ? `var(--ds-icon-inverse, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})` : 'transparent'
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            fillRule: "evenodd"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            fill: "currentColor",
            x: "6",
            y: "6",
            width: "12",
            height: "12",
            rx: "2",
            stroke: checked ? `var(--ds-border-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})` : `var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`,
            strokeWidth: 1
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M9.707 11.293a1 1 0 10-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 10-1.414-1.414L11 12.586l-1.293-1.293z",
            fill: "inherit"
        })));
    };
    var $181f17e87025e1b2$export$2e2bcd8739ae039 = $181f17e87025e1b2$var$CheckboxIcon;
});
parcelRegister("6PlGW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3e2d30248a719600$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5MgQz;
    var $iY6id;
    const $3e2d30248a719600$var$useCheckboxState = ({ isSelected: isSelected, id: id, defaultSelected: defaultSelected })=>{
        const { setItemState: setItemState, getItemState: getItemState } = (0, $5uXOq.useContext)((0, (0, parcelRequire("iY6id")).SelectionStoreContext));
        const groupId = (0, $5uXOq.useContext)((0, (0, parcelRequire("5MgQz")).CheckboxGroupContext));
        const persistedIsSelected = getItemState(groupId, id);
        const [localIsSelected, setLocalIsSelected] = (0, $5uXOq.useState)(()=>persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false);
        const setLocalState = (0, $5uXOq.useCallback)((newValue)=>{
            const nextValue = newValue(persistedIsSelected);
            setLocalIsSelected(nextValue);
            setItemState(groupId, id, nextValue);
        }, [
            setItemState,
            persistedIsSelected,
            groupId,
            id
        ]);
        if (typeof isSelected === 'boolean') return [
            isSelected,
            ()=>false
        ];
        if (persistedIsSelected === undefined) setItemState(groupId, id, defaultSelected || false);
        return [
            localIsSelected,
            setLocalState
        ];
    };
    var $3e2d30248a719600$export$2e2bcd8739ae039 = $3e2d30248a719600$var$useCheckboxState;
});
parcelRegister("5MgQz", function(module, exports) {
    $parcel$export(module.exports, "CheckboxGroupContext", ()=>$155fc86a3d14dca7$export$baf37c4be89255b8);
    var $5uXOq = parcelRequire("5uXOq");
    const $155fc86a3d14dca7$export$baf37c4be89255b8 = (0, $5uXOq.createContext)('');
});
parcelRegister("3oCwY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$195137f112bf0000$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $fVnbM;
    var $dC5iT;
    var $8CUq3;
    var $koVbs;
    var $dCm1o;
    var $aVUro;
    const $195137f112bf0000$var$ClearFilterButton = (props)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                !(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && $195137f112bf0000$var$styledClearFilterStyles
            ],
            "data-test-id": "filters.ui.filters.clear-button.ak-button",
            testId: "filters.ui.filters.clear-button.ak-button"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? 'default' : 'subtle',
            onClick: props.onClick
        }, props.label || formatMessage((0, (0, parcelRequire("aVUro")).default).label)));
    };
    $195137f112bf0000$var$ClearFilterButton.defaultProps = {
        onClick: (0, ($parcel$interopDefault($8Rkzz)))
    };
    var $195137f112bf0000$export$2e2bcd8739ae039 = $195137f112bf0000$var$ClearFilterButton;
    const $195137f112bf0000$var$styledClearFilterStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingLeft: 'space.050',
        paddingRight: 'space.050'
    });
});
parcelRegister("aVUro", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dfdad8f510b5e904$export$2e2bcd8739ae039);
    var $7VHMR;
    var $dfdad8f510b5e904$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        label: {
            "id": "software-filters.filters.clear-button.label",
            "defaultMessage": "Clear filters"
        }
    });
});
parcelRegister("7j6PN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1bf5bd4e554fcb50$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $koVbs;
    var $g5X3G;
    var $96s6B;
    var $cTznA;
    const $1bf5bd4e554fcb50$var$ComponentFilter = ({ components: components = [], selectedComponents: selectedComponents = [], onChange: onChange = (0, ($parcel$interopDefault($8Rkzz))), isNested: isNested = false })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const values = (0, $5uXOq.useMemo)(()=>components.map((component)=>({
                    label: component.name,
                    value: String(component.id)
                })), [
            components
        ]);
        const onChangeCallback = (0, $5uXOq.useCallback)((entries)=>{
            const analyticAttributes = {
                isNested: isNested
            };
            onChange(entries.map(({ value: value })=>value), analyticAttributes);
        }, [
            onChange,
            isNested
        ]);
        return (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("96s6B")).default), {
                label: formatMessage((0, (0, parcelRequire("cTznA")).default).label),
                values: values,
                selectedValues: (0, (0, parcelRequire("g5X3G")).toStringArray)(selectedComponents),
                onChange: onChangeCallback,
                isNested: isNested
            }), [
            formatMessage,
            onChangeCallback,
            selectedComponents,
            values,
            isNested
        ]);
    };
    var $1bf5bd4e554fcb50$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($1bf5bd4e554fcb50$var$ComponentFilter);
});
parcelRegister("cTznA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$798caf1923191bc1$export$2e2bcd8739ae039);
    var $7VHMR;
    var $798caf1923191bc1$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        label: {
            "id": "software-filters.filters.component.label",
            "defaultMessage": "Components"
        }
    });
});
parcelRegister("8bg0N", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6a3ccb8efb497741$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $koVbs;
    var $96s6B;
    var $1k18w;
    var $kIDH3;
    const $6a3ccb8efb497741$var$DependenciesFilter = ({ isOpen: isOpen = false, onChange: onChange = (0, ($parcel$interopDefault($8Rkzz))), selectedValues: selectedValues = [] })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const onChangeValue = (0, $5uXOq.useCallback)((entries)=>{
            onChange(entries.map(({ value: value })=>value));
        }, [
            onChange
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("96s6B")).default), {
            isOpen: isOpen,
            label: formatMessage((0, (0, parcelRequire("1k18w")).default).label),
            onChange: onChangeValue,
            values: [
                {
                    label: formatMessage((0, (0, parcelRequire("1k18w")).default).dependencyType),
                    options: [
                        {
                            label: formatMessage((0, (0, parcelRequire("1k18w")).default).offTrack),
                            value: (0, (0, parcelRequire("kIDH3")).DependencyFilterOption).OFF_TRACK
                        },
                        {
                            label: formatMessage((0, (0, parcelRequire("1k18w")).default).onTrack),
                            value: (0, (0, parcelRequire("kIDH3")).DependencyFilterOption).ON_TRACK
                        }
                    ]
                }
            ],
            selectedValues: selectedValues
        });
    };
    $6a3ccb8efb497741$var$DependenciesFilter.displayName = 'DependenciesFilter';
    $6a3ccb8efb497741$var$DependenciesFilter.whyDidYouRender = true;
    var $6a3ccb8efb497741$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($6a3ccb8efb497741$var$DependenciesFilter);
});
parcelRegister("1k18w", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b6bab5f988dfca5a$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b6bab5f988dfca5a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        label: {
            "id": "software-filters.filters.dependencies.label",
            "defaultMessage": "Dependencies"
        },
        dependencyType: {
            "id": "software-filters.filters.dependencies.dependency-type",
            "defaultMessage": "Dependency type"
        },
        offTrack: {
            "id": "software-filters.filters.dependencies.off-track",
            "defaultMessage": "Off-track"
        },
        onTrack: {
            "id": "software-filters.filters.dependencies.on-track",
            "defaultMessage": "On-track"
        }
    });
});
parcelRegister("kgqZV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$089e7ae732d57721$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $4Xk2W = parcelRequire("4Xk2W");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $dC5iT;
    var $f5TWP;
    var $8CUq3;
    var $koVbs;
    var $2Ywmz;
    var $3uePO;
    var $96s6B;
    var $9vXUM;
    var $BZHAT;
    const $089e7ae732d57721$var$EMPTY_ARRAY = [];
    const $089e7ae732d57721$var$GoalCustomOptionLabel = ({ label: label, value: value })=>{
        const goalContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("9vXUM")).GoalFilterContext));
        const goalState = goalContext.goals[value]?.state;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.050",
            alignBlock: "center",
            alignInline: "start",
            grow: "fill"
        }, goalState && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2Ywmz")).GoalIcon), {
            state: goalState.value
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            as: "span",
            xcss: $089e7ae732d57721$var$goalLabelStyles
        }, label), goalState && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3uePO")).GoalTracker), {
            label: goalState.label,
            score: goalState.score,
            value: goalState.value
        }));
    };
    const $089e7ae732d57721$var$GoalFilter = ({ goals: goals, selectedGoals: selectedGoals = $089e7ae732d57721$var$EMPTY_ARRAY, onChange: onChange = (0, ($parcel$interopDefault($8Rkzz))), onInputChange: onInputChange = (0, ($parcel$interopDefault($8Rkzz))), onOpenChange: onOpenChange = (0, ($parcel$interopDefault($8Rkzz))), onMouseEnterToTriggerButton: onMouseEnterToTriggerButton = (0, ($parcel$interopDefault($8Rkzz))), showMenuIfValuesAreEmpty: showMenuIfValuesAreEmpty = false, inputValue: inputValue, isLoading: isLoading = false, isNested: isNested = false, isOpen: isOpen = false })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const values = (0, $5uXOq.useMemo)(()=>goals.map((goal)=>({
                    label: goal.name,
                    value: goal.id,
                    data: goal.state
                })), [
            goals
        ]);
        const goalsHash = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($4Xk2W)))(goals, (goal)=>goal.id), [
            goals
        ]);
        const onChangeCallback = (0, $5uXOq.useCallback)((entries)=>{
            const analyticAttributes = {
                isNested: isNested
            };
            onChange(entries.map((entry)=>entry.value), analyticAttributes);
        }, [
            onChange,
            isNested
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9vXUM")).GoalFilterContext).Provider, {
            value: {
                goals: goalsHash
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("96s6B")).default), {
            label: formatMessage((0, (0, parcelRequire("BZHAT")).default).label),
            values: values,
            isOpen: isOpen,
            selectedValues: selectedGoals,
            isPanelToggleChecked: false,
            onChange: onChangeCallback,
            inputValue: inputValue,
            isLoading: isLoading,
            onInputChange: onInputChange,
            onOpenChange: onOpenChange,
            noOptionsMessage: formatMessage((0, (0, parcelRequire("BZHAT")).default).noGoals),
            showMenuIfValuesAreEmpty: showMenuIfValuesAreEmpty,
            isAsyncSearch: false,
            isNested: isNested,
            onMouseEnterToTriggerButton: onMouseEnterToTriggerButton,
            placeholder: formatMessage((0, (0, parcelRequire("BZHAT")).default).placeholder),
            CustomOptionLabel: $089e7ae732d57721$var$GoalCustomOptionLabel,
            showPanelToggle: false,
            showLink: false,
            useHrefForUrl: false,
            maxSelectionAllowed: Number.MAX_SAFE_INTEGER,
            onTogglePanel: (0, ($parcel$interopDefault($8Rkzz))),
            onLinkItemClick: (0, ($parcel$interopDefault($8Rkzz))),
            toggleRef: (0, ($parcel$interopDefault($8Rkzz)))
        }));
    };
    var $089e7ae732d57721$export$2e2bcd8739ae039 = $089e7ae732d57721$var$GoalFilter;
    const $089e7ae732d57721$var$goalLabelStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
});
parcelRegister("2Ywmz", function(module, exports) {
    $parcel$export(module.exports, "GoalIcon", ()=>$7be6a95607230c54$export$134cbcd70c6693b8);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    var $dC5iT;
    var $8CUq3;
    var $koVbs;
    var $6yf6t;
    var $4UrMe;
    const $7be6a95607230c54$var$GoalGlyph = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            ...props,
            xmlns: "http://www.w3.org/2000/svg",
            width: "18",
            height: "18",
            viewBox: "0 0 18 18"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            fill: "currentColor",
            fillRule: "evenodd"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M16 9C16 12.866 12.866 16 9 16C5.13401 16 2 12.866 2 9C2 5.13401 5.13401 2 9 2C12.866 2 16 5.13401 16 9ZM18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9ZM11 9C11 10.1046 10.1046 11 9 11C7.89543 11 7 10.1046 7 9C7 7.89543 7.89543 7 9 7C10.1046 7 11 7.89543 11 9ZM13 9C13 11.2091 11.2091 13 9 13C6.79086 13 5 11.2091 5 9C5 6.79086 6.79086 5 9 5C11.2091 5 13 6.79086 13 9Z",
            fillRule: "evenodd"
        })));
    const $7be6a95607230c54$export$134cbcd70c6693b8 = ({ state: state, ariaLabel: ariaLabel })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $7be6a95607230c54$var$iconContainerStyles,
            style: {
                backgroundColor: (0, (0, parcelRequire("6yf6t")).mapStateToBgColor)(state)
            },
            "aria-label": ariaLabel
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            glyph: $7be6a95607230c54$var$GoalGlyph,
            label: formatMessage((0, (0, parcelRequire("4UrMe")).default).goalIconLabel),
            primaryColor: (0, (0, parcelRequire("6yf6t")).mapStateToColor)(state)
        }));
    };
    const $7be6a95607230c54$var$iconContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '24px',
        minWidth: '24px',
        height: '24px',
        borderRadius: 'border.radius',
        marginRight: 'space.025'
    });
});
parcelRegister("6yf6t", function(module, exports) {
    $parcel$export(module.exports, "mapStateToBgColor", ()=>$6a435c3af325b8dc$export$931dac3fa53640b1);
    $parcel$export(module.exports, "mapStateToColor", ()=>$6a435c3af325b8dc$export$163d1ee1b3b2aead);
    $parcel$export(module.exports, "mapScoreToBgColor", ()=>$6a435c3af325b8dc$export$525ec0d5be9572a4);
    $parcel$export(module.exports, "extractStatusLabelWithoutScore", ()=>$6a435c3af325b8dc$export$88bbcb3741dee92d);
    const $6a435c3af325b8dc$export$931dac3fa53640b1 = (state)=>{
        switch(state){
            case 'off_track':
                return `var(--ds-background-accent-red-subtlest, ${(0, $829f609a65d26a98$exports).R50})`;
            case 'at_risk':
                return `var(--ds-background-accent-yellow-subtlest, ${(0, $829f609a65d26a98$exports).Y50})`;
            case 'on_track':
                return `var(--ds-background-accent-green-subtlest, ${(0, $829f609a65d26a98$exports).G50})`;
            case 'archived':
            case 'cancelled':
            case 'done':
            case 'paused':
            case 'pending':
            default:
                return `var(--ds-background-accent-gray-subtlest, ${(0, $829f609a65d26a98$exports).N20})`;
        }
    };
    const $6a435c3af325b8dc$export$163d1ee1b3b2aead = (state)=>{
        switch(state){
            case 'off_track':
                return `var(--ds-text-accent-red, ${(0, $829f609a65d26a98$exports).R500})`;
            case 'at_risk':
                return `var(--ds-text-accent-orange, ${(0, $829f609a65d26a98$exports).Y500})`;
            case 'on_track':
                return `var(--ds-text-accent-green, ${(0, $829f609a65d26a98$exports).G500})`;
            case 'archived':
            case 'cancelled':
            case 'done':
            case 'paused':
            case 'pending':
            default:
                return `var(--ds-text-accent-gray, ${(0, $829f609a65d26a98$exports).N500})`;
        }
    };
    const $6a435c3af325b8dc$export$525ec0d5be9572a4 = (score)=>{
        if (score < 0.4) return `var(--ds-background-danger-bold, ${(0, $829f609a65d26a98$exports).R500})`;
        if (score < 0.7) return `var(--ds-background-accent-orange-bolder, ${(0, $829f609a65d26a98$exports).Y500})`;
        return `var(--ds-background-success-bold, ${(0, $829f609a65d26a98$exports).G500})`;
    };
    const $6a435c3af325b8dc$export$88bbcb3741dee92d = (fullLabel)=>fullLabel.split(' - ')[0];
});
parcelRegister("4UrMe", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2ec31bd513378ade$export$2e2bcd8739ae039);
    var $7VHMR;
    var $2ec31bd513378ade$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        goalIconLabel: {
            "id": "software-goals.goal.icon.goal-icon-label",
            "defaultMessage": "Goal"
        }
    });
});
parcelRegister("3uePO", function(module, exports) {
    $parcel$export(module.exports, "GoalTracker", ()=>$ec22661ff8271891$export$c0fdf469f92e8578);
    var $5uXOq = parcelRequire("5uXOq");
    var $6yf6t;
    var $aabh6;
    var $e0NSW;
    const $ec22661ff8271891$export$c0fdf469f92e8578 = ({ value: value, label: label, score: score })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e0NSW")).Tracker), {
            backgroundColor: (0, (0, parcelRequire("6yf6t")).mapStateToBgColor)(value),
            color: (0, (0, parcelRequire("6yf6t")).mapStateToColor)(value)
        }, (0, (0, parcelRequire("6yf6t")).extractStatusLabelWithoutScore)(label), score !== undefined && score !== null && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aabh6")).Score), {
            score: score
        }));
});
parcelRegister("aabh6", function(module, exports) {
    $parcel$export(module.exports, "Score", ()=>$08dbd54fe256bc26$export$6735cf84ecd2736);
    var $5uXOq = parcelRequire("5uXOq");
    var $6yf6t;
    var $3b4jf;
    const $08dbd54fe256bc26$export$6735cf84ecd2736 = ({ score: score })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3b4jf")).ScoreContainer), {
            backgroundColor: (0, (0, parcelRequire("6yf6t")).mapScoreToBgColor)(score)
        }, score);
});
parcelRegister("3b4jf", function(module, exports) {
    $parcel$export(module.exports, "ScoreContainer", ()=>$c781656d37adaa64$export$32466e20de52fc97);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    const $c781656d37adaa64$export$32466e20de52fc97 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { backgroundColor: backgroundColor, ...__cmpldp } = __cmplp;
        return $5uXOq.createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1hphqkz": (0, (0, parcelRequire("lD23V")).default)(__cmplp.backgroundColor)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c116y _bfhk3qkl _syaz15cr _2rko1l7b _18u01b66 _1yt4otz2 _4t3i7vkz",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("e0NSW", function(module, exports) {
    $parcel$export(module.exports, "Tracker", ()=>$5a7c474ebf7da8e1$export$254d9747e34ddc90);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    const $5a7c474ebf7da8e1$export$254d9747e34ddc90 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { backgroundColor: backgroundColor, ...__cmpldp } = __cmplp;
        return $5uXOq.createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1hphqkz": (0, (0, parcelRequire("lD23V")).default)(__cmplp.backgroundColor),
                "--_xexnhp": (0, (0, parcelRequire("lD23V")).default)(__cmplp.color)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_bfhk3qkl _2rko1l7b _1yt41b66 _11c81vlj _k48pmoej _syaz1cj8 _1p1dangw _3fcw1q9c _1e0c1ule _4t3i7vkz _vwz47vkz",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("9vXUM", function(module, exports) {
    $parcel$export(module.exports, "GoalFilterContext", ()=>$c20e77c82f0ed08e$export$f656d92d95229cd2);
    var $5uXOq = parcelRequire("5uXOq");
    const $c20e77c82f0ed08e$export$f656d92d95229cd2 = (0, $5uXOq.createContext)({
        goals: {}
    });
});
parcelRegister("BZHAT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dfb7fe3166051b6f$export$2e2bcd8739ae039);
    var $7VHMR;
    var $dfb7fe3166051b6f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noGoals: {
            "id": "software-filters.filters.goals.no-goals",
            "defaultMessage": "There are no matching goals"
        },
        placeholder: {
            "id": "software-filters.filters.goals.placeholder",
            "defaultMessage": "Choose goals"
        },
        label: {
            "id": "software-filters.filters.goals.label",
            "defaultMessage": "Goals"
        }
    });
});
parcelRegister("efv79", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7e07b1cd691dec67$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $koVbs;
    var $g5X3G;
    var $96s6B;
    var $4c4ZP;
    const $7e07b1cd691dec67$var$IssueProjectFilter = ({ isOpen: isOpen = false, isNested: isNested = false, issueProjects: issueProjects = {}, onChange: onChange = (0, ($parcel$interopDefault($8Rkzz))), selectedProjects: selectedProjects = [] })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const values = (0, $5uXOq.useMemo)(()=>Object.values(issueProjects).map(({ avatar: avatar, id: id, name: name })=>({
                    iconUrl: avatar,
                    label: name,
                    value: String(id)
                })).sort((a, b)=>a.label.localeCompare(b.label)), [
            issueProjects
        ]);
        const onChangeValue = (0, $5uXOq.useCallback)((entries)=>{
            const analyticAttributes = {
                isNested: isNested
            };
            onChange(entries.map(({ value: value })=>(0, (0, parcelRequire("g5X3G")).toProjectId)(value)), analyticAttributes);
        }, [
            onChange,
            isNested
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("96s6B")).default), {
            isOpen: isOpen,
            isNested: isNested,
            label: formatMessage((0, (0, parcelRequire("4c4ZP")).default).label),
            onChange: onChangeValue,
            selectedValues: selectedProjects.map(String),
            values: values
        });
    };
    $7e07b1cd691dec67$var$IssueProjectFilter.displayName = 'IssueProjectFilter';
    $7e07b1cd691dec67$var$IssueProjectFilter.whyDidYouRender = true;
    var $7e07b1cd691dec67$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($7e07b1cd691dec67$var$IssueProjectFilter);
});
parcelRegister("4c4ZP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$01676d3e9ff29bbf$export$2e2bcd8739ae039);
    var $7VHMR;
    var $01676d3e9ff29bbf$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        label: {
            "id": "software-filters.filters.issue-project.label",
            "defaultMessage": "Project"
        }
    });
});
parcelRegister("jKPI1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6442616aa336213b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $koVbs;
    var $96s6B;
    var $hF6jn;
    const $6442616aa336213b$var$IssueTypeGroupFilter = ({ isOpen: isOpen = false, issueTypeGroups: issueTypeGroups = [], selectedIssueTypes: selectedIssueTypes = [], onChange: onChange = (0, ($parcel$interopDefault($8Rkzz))), isNested: isNested = false })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const issueTypeGroupByIssueType = (0, $5uXOq.useMemo)(()=>new Map(issueTypeGroups.flatMap((group)=>group.issueTypes.map((issueType)=>[
                        issueType,
                        group
                    ]))), [
            issueTypeGroups
        ]);
        const issueTypeGroupByGroupKey = (0, $5uXOq.useMemo)(()=>new Map(issueTypeGroups.map((group)=>[
                    group.key,
                    group
                ])), [
            issueTypeGroups
        ]);
        const values = (0, $5uXOq.useMemo)(()=>issueTypeGroups.map((group)=>({
                    label: group.name,
                    value: group.key,
                    iconUrl: group.iconUrl
                })), [
            issueTypeGroups
        ]);
        const selectGroupsByKeys = (0, $5uXOq.useCallback)((keys)=>{
            const analyticAttributes = {
                isNested: isNested
            };
            onChange(keys.flatMap((key)=>issueTypeGroupByGroupKey.get(key)?.issueTypes).filter(Boolean), analyticAttributes);
        }, [
            onChange,
            issueTypeGroupByGroupKey,
            isNested
        ]);
        const selectedGroups = (0, $5uXOq.useMemo)(()=>Array.from(new Set(selectedIssueTypes.map((key)=>issueTypeGroupByIssueType.get(key)))), [
            issueTypeGroupByIssueType,
            selectedIssueTypes
        ]);
        const selectedGroupKeys = selectedGroups.map((group)=>group?.key).filter(Boolean);
        const selectedGroupsAllIssueTypes = selectedGroups.flatMap((group)=>group?.issueTypes).filter(Boolean);
        const onChangeCallback = (0, $5uXOq.useCallback)((entries)=>{
            const entryValues = entries.map(({ value: value })=>value);
            selectGroupsByKeys(entryValues);
        }, [
            selectGroupsByKeys
        ]);
        if (issueTypeGroups.length <= 1) return null;
        if (selectedGroupsAllIssueTypes.length !== selectedIssueTypes.length) {
            const analyticAttributes = {
                isNested: isNested
            };
            onChange(selectedGroupsAllIssueTypes, analyticAttributes);
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("96s6B")).default), {
            isOpen: isOpen,
            label: formatMessage((0, (0, parcelRequire("hF6jn")).default).label),
            values: values,
            selectedValues: selectedGroupKeys,
            onChange: onChangeCallback,
            isNested: isNested
        });
    };
    $6442616aa336213b$var$IssueTypeGroupFilter.displayName = 'IssueTypeGroupFilter';
    $6442616aa336213b$var$IssueTypeGroupFilter.whyDidYouRender = true;
    var $6442616aa336213b$export$2e2bcd8739ae039 = $6442616aa336213b$var$IssueTypeGroupFilter;
});
parcelRegister("hF6jn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1d157749564d70c9$export$2e2bcd8739ae039);
    var $7VHMR;
    var $1d157749564d70c9$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        label: {
            "id": "software-filters.filters.issue-type-group.label",
            "defaultMessage": "Type"
        }
    });
});
parcelRegister("hHL6f", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2b5fa2dd02736e8c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $koVbs;
    var $g5X3G;
    var $96s6B;
    var $lcsGW;
    const $2b5fa2dd02736e8c$var$IssueTypeFilter = ({ issueTypes: issueTypes = [], selectedIssueTypes: selectedIssueTypes = [], onChange: onChange = (0, ($parcel$interopDefault($8Rkzz))), isNested: isNested = false })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const values = (0, $5uXOq.useMemo)(()=>issueTypes.map((issueType)=>({
                    label: issueType.name,
                    value: issueType.id,
                    iconUrl: issueType.iconUrl
                })), [
            issueTypes
        ]);
        const onChangeCallback = (0, $5uXOq.useCallback)((entries)=>{
            const analyticAttributes = {
                isNested: isNested
            };
            onChange(entries.map((entry)=>(0, (0, parcelRequire("g5X3G")).toIssueTypeId)(entry.value)), analyticAttributes);
        }, [
            onChange,
            isNested
        ]);
        if (issueTypes.length <= 1) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("96s6B")).default), {
            label: formatMessage((0, (0, parcelRequire("lcsGW")).default).label),
            values: values,
            selectedValues: selectedIssueTypes.map(String),
            onChange: onChangeCallback,
            isNested: isNested
        });
    };
    const $2b5fa2dd02736e8c$var$IssueTypeFilterComponent = (0, $5uXOq.memo)($2b5fa2dd02736e8c$var$IssueTypeFilter);
    $2b5fa2dd02736e8c$var$IssueTypeFilterComponent.displayName = 'IssueTypeFilter';
    $2b5fa2dd02736e8c$var$IssueTypeFilterComponent.whyDidYouRender = true;
    var $2b5fa2dd02736e8c$export$2e2bcd8739ae039 = $2b5fa2dd02736e8c$var$IssueTypeFilterComponent;
});
parcelRegister("lcsGW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$418d852f97677c87$export$2e2bcd8739ae039);
    var $7VHMR;
    var $418d852f97677c87$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        label: {
            "id": "software-filters.filters.issue-type.label",
            "defaultMessage": "Type"
        }
    });
});
parcelRegister("2fsdj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2f5c968fce1f630e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $koVbs;
    var $96s6B;
    var $bvI90;
    const $2f5c968fce1f630e$var$LabelFilter = ({ labels: labels = [], selectedLabels: selectedLabels = [], onChange: onChange = (0, ($parcel$interopDefault($8Rkzz))), isNested: isNested = false, unassignedOption: unassignedOption })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const values = (0, $5uXOq.useMemo)(()=>{
            const options = labels.map((label)=>({
                    label: label,
                    value: label
                }));
            unassignedOption && options.unshift(unassignedOption);
            return options;
        }, [
            labels,
            unassignedOption
        ]);
        const onChangeMapValues = (0, $5uXOq.useCallback)((entries)=>{
            const analyticAttributes = {
                isNested: isNested
            };
            onChange(entries.map((entry)=>entry.value), analyticAttributes);
        }, [
            onChange,
            isNested
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("96s6B")).default), {
            label: formatMessage((0, (0, parcelRequire("bvI90")).default).label),
            values: values,
            selectedValues: selectedLabels,
            onChange: onChangeMapValues,
            isNested: isNested
        });
    };
    const $2f5c968fce1f630e$var$LabelFilterComponent = (0, $5uXOq.memo)($2f5c968fce1f630e$var$LabelFilter);
    $2f5c968fce1f630e$var$LabelFilterComponent.displayName = 'LabelFilter';
    $2f5c968fce1f630e$var$LabelFilterComponent.whyDidYouRender = true;
    var $2f5c968fce1f630e$export$2e2bcd8739ae039 = $2f5c968fce1f630e$var$LabelFilterComponent;
});
parcelRegister("bvI90", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7299efb383111469$export$2e2bcd8739ae039);
    var $7VHMR;
    var $7299efb383111469$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        label: {
            "id": "software-filters.filters.label.label",
            "defaultMessage": "Label"
        }
    });
});
parcelRegister("bLWKp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$31db5ca9c486657a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $az4zD;
    var $iXVV6;
    var $g5X3G;
    var $9pP0g;
    var $iDGXn;
    var $bmKPg;
    var $96s6B;
    var $9oo3F;
    const $31db5ca9c486657a$var$ParentFilter = (props)=>{
        const { label: label, parents: parents, selectedParents: selectedParents, isToggleChecked: isToggleChecked, onTogglePanel: onTogglePanel, onInputChange: onInputChange, onOpenChange: onOpenChange, onMouseEnterToTriggerButton: onMouseEnterToTriggerButton, intl: { formatMessage: formatMessage }, showPanelToggle: showPanelToggle, showMenuIfValuesAreEmpty: showMenuIfValuesAreEmpty, inputValue: inputValue, isLoading: isLoading, isAsyncSearch: isAsyncSearch, isNested: isNested, isOpen: isOpen } = props;
        const [boardId] = (0, (0, parcelRequire("bmKPg")).usePathParam)('boardId');
        const { toggleViewSetting: toggleViewSetting } = (0, (0, parcelRequire("iDGXn")).useViewSettingsActions)();
        const values = (0, $5uXOq.useMemo)(()=>parents.map((parent)=>({
                    label: parent.name,
                    value: parent.id,
                    subLabel: parent.key
                })), [
            parents
        ]);
        const onChange = (0, $5uXOq.useCallback)((entries)=>{
            const analyticAttributes = {
                isNested: isNested
            };
            props.onChange(entries.map((entry)=>(0, (0, parcelRequire("g5X3G")).toIssueId)(entry.value)), analyticAttributes);
        }, [
            props,
            isNested
        ]);
        const handleTogglePanel = (0, $5uXOq.useCallback)(()=>{
            if (boardId) toggleViewSetting({
                boardId: Number(boardId),
                setting: (0, (0, parcelRequire("9pP0g")).ViewSetting).EPIC_PANEL
            });
            onTogglePanel();
        }, [
            boardId,
            onTogglePanel,
            toggleViewSetting
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: "epicPanelToggle",
            attributes: {
                isOpen: !isToggleChecked,
                filterType: label
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("96s6B")).default), {
            label: label,
            toggleLabel: formatMessage((0, (0, parcelRequire("9oo3F")).default).toggleLabel, {
                parentName: label?.toLowerCase()
            }),
            values: values,
            isOpen: isOpen,
            showPanelToggle: showPanelToggle,
            selectedValues: selectedParents.map(String),
            isPanelToggleChecked: isToggleChecked,
            onChange: onChange,
            inputValue: inputValue,
            isLoading: isLoading,
            onInputChange: onInputChange,
            onTogglePanel: handleTogglePanel,
            onOpenChange: onOpenChange,
            noOptionsMessage: formatMessage((0, (0, parcelRequire("9oo3F")).default).noParentIssues, {
                parentName: label
            }),
            showMenuIfValuesAreEmpty: showMenuIfValuesAreEmpty,
            isAsyncSearch: isAsyncSearch,
            isNested: isNested,
            onMouseEnterToTriggerButton: onMouseEnterToTriggerButton
        }));
    };
    $31db5ca9c486657a$var$ParentFilter.defaultProps = {
        selectedParents: [],
        isToggleChecked: false,
        onChange: (0, ($parcel$interopDefault($8Rkzz))),
        onInputChange: (0, ($parcel$interopDefault($8Rkzz))),
        onTogglePanel: (0, ($parcel$interopDefault($8Rkzz))),
        showPanelToggle: false,
        showMenuIfValuesAreEmpty: false,
        isLoading: false,
        isAsyncSearch: false,
        isNested: false
    };
    var $31db5ca9c486657a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("az4zD")).injectIntlV2)($31db5ca9c486657a$var$ParentFilter);
});
parcelRegister("9pP0g", function(module, exports) {
    $parcel$export(module.exports, "ViewSetting", ()=>$23bab0da4eba41c6$export$b6da678b61e4982c);
    var $a4XJc;
    var $iJgHp;
    const $23bab0da4eba41c6$export$b6da678b61e4982c = {
        ...(0, (0, parcelRequire("a4XJc")).Panels),
        ...(0, (0, parcelRequire("iJgHp")).CardDetails),
        ...(0, (0, parcelRequire("a4XJc")).IncrementPlanningSettings),
        QUICK_FILTERS: (0, parcelRequire("a4XJc")).QUICK_FILTERS,
        COMPACT_MODE: (0, parcelRequire("a4XJc")).COMPACT_MODE
    };
});
parcelRegister("a4XJc", function(module, exports) {
    $parcel$export(module.exports, "View", ()=>$3338322e4425e825$export$27a5bd065ad55220);
    $parcel$export(module.exports, "KeyboardShortcut", ()=>$3338322e4425e825$export$47a1bf8d9994c680);
    $parcel$export(module.exports, "ExpandableState", ()=>$3338322e4425e825$export$d0f8c009a99b9c1b);
    $parcel$export(module.exports, "ViewLocation", ()=>$3338322e4425e825$export$7ee1cf745baadfcd);
    $parcel$export(module.exports, "ViewAs", ()=>$3338322e4425e825$export$70549c4aef7e1632);
    $parcel$export(module.exports, "QUICK_FILTERS", ()=>$3338322e4425e825$export$59191afd909777e0);
    $parcel$export(module.exports, "COMPACT_MODE", ()=>$3338322e4425e825$export$abd09d2531440e47);
    $parcel$export(module.exports, "SHOW_EPICS", ()=>$3338322e4425e825$export$f3d7917d25ca2d13);
    $parcel$export(module.exports, "SHOW_STATUSES", ()=>$3338322e4425e825$export$933792f2c41e7c51);
    $parcel$export(module.exports, "SHOW_VERSIONS", ()=>$3338322e4425e825$export$fe0a5eeac8bdee53);
    $parcel$export(module.exports, "SHOW_ISSUE_LINKS_STATS", ()=>$3338322e4425e825$export$889dbf130218e8b3);
    $parcel$export(module.exports, "SHOW_ISSUE_KEY", ()=>$3338322e4425e825$export$f199de710b228934);
    $parcel$export(module.exports, "SHOW_ISSUE_TYPE", ()=>$3338322e4425e825$export$e8f86e49139c6abb);
    $parcel$export(module.exports, "SHOW_ESTIMATE", ()=>$3338322e4425e825$export$e1f60d3e74825af0);
    $parcel$export(module.exports, "SHOW_PRIORITY", ()=>$3338322e4425e825$export$bcfd60da3302536e);
    $parcel$export(module.exports, "SHOW_DEVELOPMENT", ()=>$3338322e4425e825$export$e7b5d3d062c615d5);
    $parcel$export(module.exports, "SHOW_ASSIGNEE", ()=>$3338322e4425e825$export$3c14ba0cd46183b);
    $parcel$export(module.exports, "SHOW_DAYS_IN_COLUMN", ()=>$3338322e4425e825$export$8224ffeed837235e);
    $parcel$export(module.exports, "SHOW_DUE_DATE", ()=>$3338322e4425e825$export$770e28bfe2e0208d);
    $parcel$export(module.exports, "SHOW_LABELS", ()=>$3338322e4425e825$export$63993996bfd99919);
    $parcel$export(module.exports, "SHOW_CARD_COVERS", ()=>$3338322e4425e825$export$b811e8bce70dd7c2);
    $parcel$export(module.exports, "Panels", ()=>$3338322e4425e825$export$b94e9de8950563ef);
    $parcel$export(module.exports, "IncrementPlanningSettings", ()=>$3338322e4425e825$export$ad46e765f851721f);
    const $3338322e4425e825$export$27a5bd065ad55220 = {
        BACKLOG: 'jsw-backlog',
        BOARD: 'jsw-board',
        INCREMENT_PLANNING_BOARD: 'increment-planning-board',
        JSM_BOARD: 'jsm-board'
    };
    const $3338322e4425e825$export$47a1bf8d9994c680 = {
        ISSUE_PARENT_PANEL_SHORTCUT: 'E',
        VERSION_PANEL_SHORTCUT: 'V'
    };
    const $3338322e4425e825$export$d0f8c009a99b9c1b = {
        EXPANDED: 'expanded',
        COLLAPSED: 'collapsed'
    };
    const $3338322e4425e825$export$7ee1cf745baadfcd = {
        SIDEBAR: 'sidebar',
        MODAL: 'modal'
    };
    const $3338322e4425e825$export$70549c4aef7e1632 = {
        PANEL: 'Panel',
        POPUP: 'Popup'
    };
    const $3338322e4425e825$export$41073ac826c57195 = 'VERSION_PANEL';
    const $3338322e4425e825$export$86bfe5c9d2cf6b7c = 'EPIC_PANEL';
    const $3338322e4425e825$export$59191afd909777e0 = 'QUICK_FILTERS';
    const $3338322e4425e825$export$abd09d2531440e47 = 'COMPACT_MODE';
    const $3338322e4425e825$export$f3d7917d25ca2d13 = 'SHOW_EPICS';
    const $3338322e4425e825$export$933792f2c41e7c51 = 'SHOW_STATUSES';
    const $3338322e4425e825$export$fe0a5eeac8bdee53 = 'SHOW_VERSIONS';
    const $3338322e4425e825$export$889dbf130218e8b3 = 'SHOW_ISSUE_LINKS_STATS';
    const $3338322e4425e825$export$c3308fa11d994bc5 = 'SHOW_UNSCHEDULED_COLUMN';
    const $3338322e4425e825$export$f199de710b228934 = 'SHOW_ISSUE_KEY';
    const $3338322e4425e825$export$e8f86e49139c6abb = 'SHOW_ISSUE_TYPE';
    const $3338322e4425e825$export$e1f60d3e74825af0 = 'SHOW_ESTIMATE';
    const $3338322e4425e825$export$bcfd60da3302536e = 'SHOW_PRIORITY';
    const $3338322e4425e825$export$e7b5d3d062c615d5 = 'SHOW_DEVELOPMENT';
    const $3338322e4425e825$export$3c14ba0cd46183b = 'SHOW_ASSIGNEE';
    const $3338322e4425e825$export$8224ffeed837235e = 'SHOW_DAYS_IN_COLUMN';
    const $3338322e4425e825$export$770e28bfe2e0208d = 'SHOW_DUE_DATE';
    const $3338322e4425e825$export$63993996bfd99919 = 'SHOW_LABELS';
    const $3338322e4425e825$export$b811e8bce70dd7c2 = 'SHOW_CARD_COVERS';
    const $3338322e4425e825$export$ecec86e489253c13 = 'SHOW_OFFTRACK_DEPENDENCY_LINES';
    const $3338322e4425e825$export$79b3cada7e291288 = 'ISSUE_IDS_TO_SHOW_DEPENDENCIES';
    const $3338322e4425e825$export$b94e9de8950563ef = {
        VERSION_PANEL: $3338322e4425e825$export$41073ac826c57195,
        EPIC_PANEL: $3338322e4425e825$export$86bfe5c9d2cf6b7c
    };
    const $3338322e4425e825$export$ad46e765f851721f = {
        SHOW_UNSCHEDULED_COLUMN: $3338322e4425e825$export$c3308fa11d994bc5,
        SHOW_OFFTRACK_DEPENDENCY_LINES: $3338322e4425e825$export$ecec86e489253c13,
        ISSUE_IDS_TO_SHOW_DEPENDENCIES: $3338322e4425e825$export$79b3cada7e291288
    };
});
parcelRegister("iJgHp", function(module, exports) {
    $parcel$export(module.exports, "CardDetails", ()=>$a1cb757db25241b3$export$741386389156bf07);
    var $a4XJc;
    const $a1cb757db25241b3$export$741386389156bf07 = {
        SHOW_ISSUE_KEY: (0, parcelRequire("a4XJc")).SHOW_ISSUE_KEY,
        SHOW_ISSUE_TYPE: (0, parcelRequire("a4XJc")).SHOW_ISSUE_TYPE,
        SHOW_EPICS: (0, parcelRequire("a4XJc")).SHOW_EPICS,
        SHOW_STATUSES: (0, parcelRequire("a4XJc")).SHOW_STATUSES,
        SHOW_VERSIONS: (0, parcelRequire("a4XJc")).SHOW_VERSIONS,
        SHOW_ISSUE_LINKS_STATS: (0, parcelRequire("a4XJc")).SHOW_ISSUE_LINKS_STATS,
        SHOW_PRIORITY: (0, parcelRequire("a4XJc")).SHOW_PRIORITY,
        SHOW_DEVELOPMENT: (0, parcelRequire("a4XJc")).SHOW_DEVELOPMENT,
        SHOW_ASSIGNEE: (0, parcelRequire("a4XJc")).SHOW_ASSIGNEE,
        SHOW_ESTIMATE: (0, parcelRequire("a4XJc")).SHOW_ESTIMATE,
        SHOW_DAYS_IN_COLUMN: (0, parcelRequire("a4XJc")).SHOW_DAYS_IN_COLUMN,
        SHOW_DUE_DATE: (0, parcelRequire("a4XJc")).SHOW_DUE_DATE,
        SHOW_LABELS: (0, parcelRequire("a4XJc")).SHOW_LABELS,
        SHOW_CARD_COVERS: (0, parcelRequire("a4XJc")).SHOW_CARD_COVERS
    };
});
parcelRegister("iDGXn", function(module, exports) {
    $parcel$export(module.exports, "ViewSettingsContainer", ()=>$ca78323127435ce7$export$920204d7413f6fe1);
    $parcel$export(module.exports, "useViewSettings", ()=>$ca78323127435ce7$export$704cffd05c51e2b6);
    $parcel$export(module.exports, "useViewSettingsActions", ()=>$ca78323127435ce7$export$d6a70239aff099b8);
    $parcel$export(module.exports, "useIsFullscreen", ()=>$ca78323127435ce7$export$d397eccea5f37b0a);
    $parcel$export(module.exports, "useShowVersionPanel", ()=>$ca78323127435ce7$export$459b400687bc0f20);
    $parcel$export(module.exports, "useShowEpicPanel", ()=>$ca78323127435ce7$export$203c9a05aebea04a);
    $parcel$export(module.exports, "useShowQuickFilters", ()=>$ca78323127435ce7$export$714ba21e90859f45);
    $parcel$export(module.exports, "useShowCompactMode", ()=>$ca78323127435ce7$export$8a591bb42a805814);
    $parcel$export(module.exports, "useShowPanels", ()=>$ca78323127435ce7$export$736bfa164a60e240);
    $parcel$export(module.exports, "useShowEpics", ()=>$ca78323127435ce7$export$ecaca052f9755b4e);
    $parcel$export(module.exports, "useShowVersions", ()=>$ca78323127435ce7$export$10178a1fc177e27a);
    $parcel$export(module.exports, "useShowStatuses", ()=>$ca78323127435ce7$export$7a14d92e68e42de1);
    $parcel$export(module.exports, "useShowUnscheduledColumn", ()=>$ca78323127435ce7$export$afb23457b0007ce7);
    $parcel$export(module.exports, "useShowIssueLinksStats", ()=>$ca78323127435ce7$export$1d584d816be8e0fd);
    $parcel$export(module.exports, "useShowAssignee", ()=>$ca78323127435ce7$export$be6bf1e24771efde);
    $parcel$export(module.exports, "useShowCardCovers", ()=>$ca78323127435ce7$export$77ff271d002b6f7e);
    $parcel$export(module.exports, "useHasCardExtraFields", ()=>$ca78323127435ce7$export$9e1ece2ef34a030);
    $parcel$export(module.exports, "useCardFieldsSettings", ()=>$ca78323127435ce7$export$e41d531469117029);
    $parcel$export(module.exports, "useShowOfftrackDependencyLines", ()=>$ca78323127435ce7$export$e709b26074f3a4a5);
    $parcel$export(module.exports, "useIssueIdsToShowDependencies", ()=>$ca78323127435ce7$export$b6fb171038a9e77e);
    var $3sQ5x;
    var $gg7kZ;
    var $iXqE5;
    var $duOMW;
    var $6zihU;
    var $ffHmx;
    const $ca78323127435ce7$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'ViewSettings',
        initialState: (0, parcelRequire("duOMW")).initialState,
        actions: (0, parcelRequire("6zihU")).actions
    });
    const $ca78323127435ce7$export$920204d7413f6fe1 = (0, (0, parcelRequire("gg7kZ")).createContainer)($ca78323127435ce7$var$Store, {
        onInit: (0, (0, parcelRequire("6zihU")).actions).initState
    });
    const $ca78323127435ce7$export$704cffd05c51e2b6 = (0, (0, parcelRequire("3sQ5x")).createHook)($ca78323127435ce7$var$Store);
    const $ca78323127435ce7$export$d6a70239aff099b8 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($ca78323127435ce7$var$Store);
    const $ca78323127435ce7$export$d397eccea5f37b0a = (0, (0, parcelRequire("3sQ5x")).createStateHook)($ca78323127435ce7$var$Store, {
        selector: (0, (0, parcelRequire("ffHmx")).getIsFullscreen)
    });
    const $ca78323127435ce7$export$459b400687bc0f20 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($ca78323127435ce7$var$Store, {
        selector: (0, (0, parcelRequire("ffHmx")).getShowVersionPanel)
    });
    const $ca78323127435ce7$export$203c9a05aebea04a = (0, (0, parcelRequire("3sQ5x")).createStateHook)($ca78323127435ce7$var$Store, {
        selector: (0, (0, parcelRequire("ffHmx")).getShowEpicPanel)
    });
    const $ca78323127435ce7$export$714ba21e90859f45 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($ca78323127435ce7$var$Store, {
        selector: (0, (0, parcelRequire("ffHmx")).getShowQuickFilters)
    });
    const $ca78323127435ce7$export$8a591bb42a805814 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($ca78323127435ce7$var$Store, {
        selector: (0, (0, parcelRequire("ffHmx")).getShowCompactMode)
    });
    const $ca78323127435ce7$export$736bfa164a60e240 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($ca78323127435ce7$var$Store, {
        selector: (0, (0, parcelRequire("ffHmx")).getShowPanels)
    });
    const $ca78323127435ce7$export$ecaca052f9755b4e = (0, (0, parcelRequire("3sQ5x")).createStateHook)($ca78323127435ce7$var$Store, {
        selector: (0, (0, parcelRequire("ffHmx")).getShowEpics)
    });
    const $ca78323127435ce7$export$10178a1fc177e27a = (0, (0, parcelRequire("3sQ5x")).createStateHook)($ca78323127435ce7$var$Store, {
        selector: (0, (0, parcelRequire("ffHmx")).getShowVersions)
    });
    const $ca78323127435ce7$export$7a14d92e68e42de1 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($ca78323127435ce7$var$Store, {
        selector: (0, (0, parcelRequire("ffHmx")).getShowStatuses)
    });
    const $ca78323127435ce7$export$afb23457b0007ce7 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($ca78323127435ce7$var$Store, {
        selector: (0, (0, parcelRequire("ffHmx")).getShowUnscheduledColumn)
    });
    const $ca78323127435ce7$export$1d584d816be8e0fd = (0, (0, parcelRequire("3sQ5x")).createStateHook)($ca78323127435ce7$var$Store, {
        selector: (0, (0, parcelRequire("ffHmx")).getShowIssueLinksStats)
    });
    const $ca78323127435ce7$export$c94c02788702c7e4 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($ca78323127435ce7$var$Store, {
        selector: (0, (0, parcelRequire("ffHmx")).getShowIssueType)
    });
    const $ca78323127435ce7$export$8007ae8b25a75629 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($ca78323127435ce7$var$Store, {
        selector: (0, (0, parcelRequire("ffHmx")).getShowIssueKey)
    });
    const $ca78323127435ce7$export$75223d65852dc3c0 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($ca78323127435ce7$var$Store, {
        selector: (0, (0, parcelRequire("ffHmx")).getShowPriority)
    });
    const $ca78323127435ce7$export$eac20fb60c7f35ac = (0, (0, parcelRequire("3sQ5x")).createStateHook)($ca78323127435ce7$var$Store, {
        selector: (0, (0, parcelRequire("ffHmx")).getShowDevelopment)
    });
    const $ca78323127435ce7$export$be6bf1e24771efde = (0, (0, parcelRequire("3sQ5x")).createStateHook)($ca78323127435ce7$var$Store, {
        selector: (0, (0, parcelRequire("ffHmx")).getShowAssignee)
    });
    const $ca78323127435ce7$export$b5a76590347456cc = (0, (0, parcelRequire("3sQ5x")).createStateHook)($ca78323127435ce7$var$Store, {
        selector: (0, (0, parcelRequire("ffHmx")).getShowEstimate)
    });
    const $ca78323127435ce7$export$5e8e69c97a3cd45b = (0, (0, parcelRequire("3sQ5x")).createStateHook)($ca78323127435ce7$var$Store, {
        selector: (0, (0, parcelRequire("ffHmx")).getShowCardExtraField)
    });
    const $ca78323127435ce7$export$a53839ab3a916ce3 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($ca78323127435ce7$var$Store, {
        selector: (0, (0, parcelRequire("ffHmx")).getShowDaysInColumn)
    });
    const $ca78323127435ce7$export$77ff271d002b6f7e = (0, (0, parcelRequire("3sQ5x")).createStateHook)($ca78323127435ce7$var$Store, {
        selector: (0, (0, parcelRequire("ffHmx")).getShowCardCovers)
    });
    const $ca78323127435ce7$export$9e1ece2ef34a030 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($ca78323127435ce7$var$Store, {
        selector: (0, (0, parcelRequire("ffHmx")).getHasCardExtraFields)
    });
    const $ca78323127435ce7$export$e41d531469117029 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($ca78323127435ce7$var$Store, {
        selector: (0, (0, parcelRequire("ffHmx")).getCardFieldsSettings)
    });
    const $ca78323127435ce7$export$e709b26074f3a4a5 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($ca78323127435ce7$var$Store, {
        selector: (0, (0, parcelRequire("ffHmx")).getShowOfftrackDependencyLines)
    });
    const $ca78323127435ce7$export$b6fb171038a9e77e = (0, (0, parcelRequire("3sQ5x")).createStateHook)($ca78323127435ce7$var$Store, {
        selector: (0, (0, parcelRequire("ffHmx")).getIssueIdsToShowDependencies)
    });
});
parcelRegister("duOMW", function(module, exports) {
    $parcel$export(module.exports, "VIEW_SETTINGS", ()=>$6350b42865dc529c$export$f900da9acbf1ac33);
    $parcel$export(module.exports, "VIEW_SETTINGS_LOCAL_STORAGE", ()=>$6350b42865dc529c$export$752f3d44db2fbd2d);
    $parcel$export(module.exports, "initialState", ()=>$6350b42865dc529c$export$d4c72bab9d6cc13a);
    $parcel$export(module.exports, "initialStateNew", ()=>$6350b42865dc529c$export$d85d94032b13e11a);
    $parcel$export(module.exports, "boardViewTestIds", ()=>$6350b42865dc529c$export$9cf6a064d9c55597);
    $parcel$export(module.exports, "backlogViewTestIds", ()=>$6350b42865dc529c$export$af828cca0407ed81);
    $parcel$export(module.exports, "VIEW_SETTINGS_PANEL_CLOSE_BUTTON_TEST_ID", ()=>$6350b42865dc529c$export$b954e2c30216a1e9);
    $parcel$export(module.exports, "VIEW_SETTINGS_BUTTON_LG", ()=>$6350b42865dc529c$export$20070c180403c06a);
    $parcel$export(module.exports, "VIEW_SETTINGS_BUTTON_SM", ()=>$6350b42865dc529c$export$563c80e8ea5620c4);
    $parcel$export(module.exports, "VIEW_SETTINGS_BUTTON_RESPONSIVE", ()=>$6350b42865dc529c$export$3895498dfef21366);
    $parcel$export(module.exports, "QUERY_ENABLED_VALUE", ()=>$6350b42865dc529c$export$c0d46007b8549aca);
    const $6350b42865dc529c$export$f900da9acbf1ac33 = 'view-settings';
    const $6350b42865dc529c$export$752f3d44db2fbd2d = 'jira-software-view-settings';
    const $6350b42865dc529c$export$d4c72bab9d6cc13a = {
        view: null,
        isFullscreen: false,
        showEpicPanel: false,
        showVersionPanel: false,
        showQuickFilters: false,
        showEpics: true,
        showStatuses: true,
        showVersions: true,
        showCompactMode: false,
        showUnscheduledColumn: true,
        showIssueLinksStats: false,
        showIssueKey: true,
        showIssueType: true,
        showEstimate: true,
        showAssignee: true,
        showPriority: true,
        showDevelopment: true,
        showDaysInColumn: true,
        showDueDate: true,
        showLabels: true,
        showCardCovers: false,
        showOfftrackDependencyLines: true,
        issueIdsToShowDependencies: [],
        cardExtraFields: {}
    };
    const $6350b42865dc529c$export$d85d94032b13e11a = {
        view: null,
        isFullscreen: false,
        showEpicPanel: false,
        showVersionPanel: false,
        showQuickFilters: false,
        showEpics: true,
        showStatuses: true,
        showVersions: true,
        showCompactMode: false,
        showUnscheduledColumn: true,
        showIssueLinksStats: false,
        showIssueKey: true,
        showIssueType: true,
        showEstimate: true,
        showAssignee: true,
        showPriority: true,
        showDevelopment: true,
        showDaysInColumn: true,
        showDueDate: true,
        showLabels: true,
        showCardCovers: true,
        showOfftrackDependencyLines: true,
        issueIdsToShowDependencies: [],
        cardExtraFields: {}
    };
    const $6350b42865dc529c$export$9cf6a064d9c55597 = {
        viewSettingsBoardMenu: 'software-view-settings.ui.view-settings-menu.menu-board',
        openIssuesInSidebarToggle: 'software-view-settings.ui.view-settings-menu.views.board.open-issues-in-sidebar',
        showQuickFiltersToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-quick-filters-toggle',
        showWorkSuggestionsToggle: 'software-view-settings.ui.view-settings-menu.views.board.work-suggestions-toggle',
        swimlaneExpandAll: 'software-view-settings.ui.view-settings-menu.views.board.expand-all',
        swimlaneCollapseAll: 'software-view-settings.ui.view-settings-menu.views.board.collapse-all',
        cardDetailsSection: 'software-view-settings.ui.view-settings-menu.views.board.card-details-board',
        showIssueTypeToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-issue-type-toggle-board',
        showIssueKeyToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-issue-key-toggle-board',
        showEpicsToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-epics-toggle-board',
        showDueDateToggle: 'software-view-settings.ui.view-settings-menu.views.board.due-date-toggle-board',
        showLabelsToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-labels-toggle-board',
        showEstimateToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-estimate-toggle-board',
        showDaysInColumnToggle: 'software-view-settings.ui.view-settings-menu.views.board.days-in-column-toggle-board',
        showLinkedIssueStatsToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-linked-issue-stats-toggle-board',
        showCardCoversToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-card-covers-toggle-board',
        showPriorityToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-priority-toggle-board',
        showDevelopmentToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-development-toggle-board',
        showAssigneeToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-assignee-toggle-board',
        customFieldsSection: 'software-view-settings.ui.view-settings-menu.views.board.custom-fields-board'
    };
    const $6350b42865dc529c$export$af828cca0407ed81 = {
        showVersionPanelToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-version-panel-toggle',
        showEpicPanelToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-epic-panel-toggle',
        showQuickFiltersToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-quick-filters-toggle',
        cardLayoutSection: 'software-view-settings.view-settings-menu.card-layout',
        cardLayoutRadioGroup: 'software-view-settings.ui.view-settings-menu.views.backlog.card-layout',
        showCompactModeToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-compact-mode-toggle',
        subtaskSection: 'software-view-settings.view-settings-menu.subtasks',
        subtaskExpandAll: 'software-view-settings.ui.view-settings-menu.views.backlog.expand-all-subtasks',
        subtaskCollapseAll: 'software-view-settings.ui.view-settings-menu.views.backlog.collapse-all-subtasks',
        cardDetailsSection: 'software-view-settings.ui.view-settings-menu.views.backlog.card-details-backlog',
        showIssueTypeToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-issue-type-toggle-backlog',
        showIssueKeyToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-issue-key-toggle-backlog',
        showVersionsToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-versions-toggle-backlog',
        showEpicsToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-epics-toggle-backlog',
        showDueDateToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.due-date-toggle-backlog',
        showStatusToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-statuses-toggle-backlog',
        showEstimateToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-estimate-toggle-backlog',
        showPriorityToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-priority-toggle-backlog',
        showAssigneeToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-assignee-toggle-backlog',
        customFieldsSection: 'software-view-settings.ui.view-settings-menu.views.backlog.custom-fields-backlog'
    };
    const $6350b42865dc529c$export$b954e2c30216a1e9 = 'view-settings.ui.panel.header.close-button';
    const $6350b42865dc529c$export$20070c180403c06a = 'view-settings-show-button.ui.view-settings-button-large';
    const $6350b42865dc529c$export$563c80e8ea5620c4 = 'view-settings-show-button.ui.view-settings-button-small';
    const $6350b42865dc529c$export$3895498dfef21366 = 'view-settings-show-button.ui.view-settings-button-responsive';
    const $6350b42865dc529c$export$c0d46007b8549aca = 'on';
    const $6350b42865dc529c$export$788a94e8107fb947 = 'off';
});
parcelRegister("6zihU", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$718ecccac1489fb2$export$e324594224ef24da);
    var $3whhk;
    const $718ecccac1489fb2$export$e324594224ef24da = {
        setViewSettings: (0, parcelRequire("3whhk")).setViewSettings,
        setIsFullscreen: (0, parcelRequire("3whhk")).setIsFullscreen,
        setViewSettingsPanels: (0, parcelRequire("3whhk")).setViewSettingsPanels,
        setViewSettingsQuickFilters: (0, parcelRequire("3whhk")).setViewSettingsQuickFilters,
        setViewSettingsCardDetails: (0, parcelRequire("3whhk")).setViewSettingsCardDetails,
        setViewSettingsCardExtraFields: (0, parcelRequire("3whhk")).setViewSettingsCardExtraFields,
        setViewSettingsCompactMode: (0, parcelRequire("3whhk")).setViewSettingsCompactMode,
        setShowUnscheduledColumn: (0, parcelRequire("3whhk")).setShowUnscheduledColumn,
        setShowOfftrackDependencyLines: (0, parcelRequire("3whhk")).setShowOfftrackDependencyLines,
        setIssueIdsToShowDependencies: (0, parcelRequire("3whhk")).setIssueIdsToShowDependencies,
        setViewSettingsShowCardCovers: (0, parcelRequire("3whhk")).setViewSettingsShowCardCovers,
        toggleViewSetting: (0, parcelRequire("3whhk")).toggleViewSetting,
        toggleShowEpics: (0, parcelRequire("3whhk")).toggleShowEpics,
        toggleShowVersions: (0, parcelRequire("3whhk")).toggleShowVersions,
        toggleShowStatuses: (0, parcelRequire("3whhk")).toggleShowStatuses,
        toggleShowLinkedIssuesStats: (0, parcelRequire("3whhk")).toggleShowLinkedIssuesStats,
        toggleExtraField: (0, parcelRequire("3whhk")).toggleExtraField,
        toggleShowDaysInColumn: (0, parcelRequire("3whhk")).toggleShowDaysInColumn,
        toggleShowDueDate: (0, parcelRequire("3whhk")).toggleShowDueDate,
        toggleShowLabels: (0, parcelRequire("3whhk")).toggleShowLabels,
        initState: (0, parcelRequire("3whhk")).initState
    };
});
parcelRegister("3whhk", function(module, exports) {
    $parcel$export(module.exports, "initState", ()=>$b6bf5ef387c9e297$export$f6196a6c6bb539b4);
    $parcel$export(module.exports, "setViewSettings", ()=>$b6bf5ef387c9e297$export$99f2d9eb0b41b93);
    $parcel$export(module.exports, "setIsFullscreen", ()=>$b6bf5ef387c9e297$export$9c73b2f282069160);
    $parcel$export(module.exports, "setViewSettingsPanels", ()=>$b6bf5ef387c9e297$export$427f126b21640252);
    $parcel$export(module.exports, "setViewSettingsQuickFilters", ()=>$b6bf5ef387c9e297$export$60d0caf3b1c59159);
    $parcel$export(module.exports, "setViewSettingsCompactMode", ()=>$b6bf5ef387c9e297$export$9ca6e4490ca9b1fc);
    $parcel$export(module.exports, "setViewSettingsCardDetails", ()=>$b6bf5ef387c9e297$export$af2e5a35023755b5);
    $parcel$export(module.exports, "setViewSettingsCardExtraFields", ()=>$b6bf5ef387c9e297$export$b54537ba70def946);
    $parcel$export(module.exports, "setViewSettingsShowCardCovers", ()=>$b6bf5ef387c9e297$export$d166622a8f3a93f0);
    $parcel$export(module.exports, "toggleViewSetting", ()=>$b6bf5ef387c9e297$export$779d9a10b8826796);
    $parcel$export(module.exports, "toggleShowEpics", ()=>$b6bf5ef387c9e297$export$c1bb93dcfa07c797);
    $parcel$export(module.exports, "toggleShowVersions", ()=>$b6bf5ef387c9e297$export$582a65f6c8cb93ab);
    $parcel$export(module.exports, "toggleShowStatuses", ()=>$b6bf5ef387c9e297$export$ac311ca7d5df1d03);
    $parcel$export(module.exports, "toggleShowLinkedIssuesStats", ()=>$b6bf5ef387c9e297$export$580abda923c30dc5);
    $parcel$export(module.exports, "setShowUnscheduledColumn", ()=>$b6bf5ef387c9e297$export$6edce735c6eb4cb0);
    $parcel$export(module.exports, "toggleShowDaysInColumn", ()=>$b6bf5ef387c9e297$export$2849cc68d8e521b7);
    $parcel$export(module.exports, "toggleShowDueDate", ()=>$b6bf5ef387c9e297$export$ef2b1a307fba6e8a);
    $parcel$export(module.exports, "toggleShowLabels", ()=>$b6bf5ef387c9e297$export$229260fb852e61e0);
    $parcel$export(module.exports, "toggleExtraField", ()=>$b6bf5ef387c9e297$export$6acb0c83c20a20);
    $parcel$export(module.exports, "setShowOfftrackDependencyLines", ()=>$b6bf5ef387c9e297$export$2c48063cd4ef1ade);
    $parcel$export(module.exports, "setIssueIdsToShowDependencies", ()=>$b6bf5ef387c9e297$export$f7b68cb584e33d77);
    var $9pP0g;
    var $8zmNw;
    const $b6bf5ef387c9e297$export$f6196a6c6bb539b4 = ()=>({ setState: setState }, { view: view })=>{
            setState({
                view: view
            });
        };
    const $b6bf5ef387c9e297$export$99f2d9eb0b41b93 = (newState)=>({ setState: setState })=>{
            setState(newState);
        };
    const $b6bf5ef387c9e297$export$9c73b2f282069160 = ({ boardId: boardId, view: view, isFullscreen: isFullscreen })=>({ setState: setState, getState: getState })=>{
            const currentSettings = getState();
            (0, parcelRequire("8zmNw")).setViewSettingsIsFullscreen({
                boardId: boardId,
                isFullscreen: isFullscreen,
                view: view || currentSettings.view || undefined
            });
            setState({
                ...currentSettings,
                isFullscreen: isFullscreen
            });
        };
    const $b6bf5ef387c9e297$export$427f126b21640252 = ({ boardId: boardId, view: view, panelState: panelState })=>({ setState: setState, getState: getState })=>{
            const currentSettings = getState();
            (0, parcelRequire("8zmNw")).setViewSettingsPanels({
                boardId: boardId,
                panelState: panelState,
                view: view || currentSettings.view || undefined
            });
            setState({
                ...currentSettings,
                showEpicPanel: panelState.EPIC_PANEL,
                showVersionPanel: panelState.VERSION_PANEL
            });
        };
    const $b6bf5ef387c9e297$export$60d0caf3b1c59159 = ({ boardId: boardId, view: view, showQuickFilters: showQuickFilters })=>({ setState: setState, getState: getState })=>{
            const currentSettings = getState();
            (0, parcelRequire("8zmNw")).setViewSettingsQuickFilters({
                boardId: boardId,
                showQuickFilters: showQuickFilters,
                view: view || currentSettings.view || undefined
            });
            setState({
                ...currentSettings,
                showQuickFilters: showQuickFilters
            });
        };
    const $b6bf5ef387c9e297$export$9ca6e4490ca9b1fc = ({ boardId: boardId, view: view, showCompactMode: showCompactMode })=>({ setState: setState, getState: getState })=>{
            const currentSettings = getState();
            (0, parcelRequire("8zmNw")).setViewSettingsCompactMode({
                boardId: boardId,
                showCompactMode: showCompactMode,
                view: view || currentSettings.view || undefined
            });
            setState({
                ...currentSettings,
                showCompactMode: showCompactMode
            });
        };
    const $b6bf5ef387c9e297$export$af2e5a35023755b5 = ({ boardId: boardId, view: view, cardDetailsState: cardDetailsState })=>({ setState: setState, getState: getState })=>{
            const currentSettings = getState();
            (0, parcelRequire("8zmNw")).setViewSettingsCardDetails({
                boardId: boardId,
                cardDetailsState: cardDetailsState,
                view: view || currentSettings.view || undefined
            });
            setState({
                ...currentSettings,
                showEpics: cardDetailsState.SHOW_EPICS,
                showVersions: cardDetailsState.SHOW_VERSIONS,
                showStatuses: cardDetailsState.SHOW_STATUSES,
                showIssueLinksStats: cardDetailsState.SHOW_ISSUE_LINKS_STATS,
                showDaysInColumn: cardDetailsState.SHOW_DAYS_IN_COLUMN,
                showIssueType: cardDetailsState.SHOW_ISSUE_TYPE,
                showIssueKey: cardDetailsState.SHOW_ISSUE_KEY,
                showEstimate: cardDetailsState.SHOW_ESTIMATE,
                showPriority: cardDetailsState.SHOW_PRIORITY,
                showDevelopment: cardDetailsState.SHOW_DEVELOPMENT,
                showAssignee: cardDetailsState.SHOW_ASSIGNEE,
                showDueDate: cardDetailsState.SHOW_DUE_DATE,
                showLabels: cardDetailsState.SHOW_LABELS,
                showCardCovers: cardDetailsState.SHOW_CARD_COVERS
            });
        };
    const $b6bf5ef387c9e297$export$b54537ba70def946 = ({ boardId: boardId, view: view, cardExtraFieldsState: cardExtraFieldsState })=>({ setState: setState, getState: getState })=>{
            const currentSettings = getState();
            (0, parcelRequire("8zmNw")).setViewSettingsCardExtraFields({
                boardId: boardId,
                cardExtraFieldsState: cardExtraFieldsState,
                view: view || currentSettings.view || undefined
            });
            setState({
                ...currentSettings,
                cardExtraFields: cardExtraFieldsState
            });
        };
    const $b6bf5ef387c9e297$export$d166622a8f3a93f0 = ({ boardId: boardId, view: view, showCardCovers: showCardCovers })=>({ setState: setState, getState: getState })=>{
            const currentSettings = getState();
            const newState = {
                ...currentSettings,
                showCardCovers: showCardCovers
            };
            (0, parcelRequire("8zmNw")).setViewSettings({
                boardId: boardId,
                state: newState,
                view: view || currentSettings.view || undefined
            });
            setState(newState);
        };
    const $b6bf5ef387c9e297$export$779d9a10b8826796 = ({ boardId: boardId, view: view, setting: setting })=>({ setState: setState, getState: getState })=>{
            const currentSettings = getState();
            const set = (newState)=>{
                setState(newState);
                (0, parcelRequire("8zmNw")).setViewSettings({
                    boardId: boardId,
                    state: newState,
                    view: view || currentSettings.view || undefined
                });
            };
            switch(setting){
                case (0, (0, parcelRequire("9pP0g")).ViewSetting).VERSION_PANEL:
                    set({
                        ...currentSettings,
                        showVersionPanel: !currentSettings.showVersionPanel
                    });
                    break;
                case (0, (0, parcelRequire("9pP0g")).ViewSetting).EPIC_PANEL:
                    set({
                        ...currentSettings,
                        showEpicPanel: !currentSettings.showEpicPanel
                    });
                    break;
                case (0, (0, parcelRequire("9pP0g")).ViewSetting).QUICK_FILTERS:
                    set({
                        ...currentSettings,
                        showQuickFilters: !currentSettings.showQuickFilters
                    });
                    break;
                case (0, (0, parcelRequire("9pP0g")).ViewSetting).COMPACT_MODE:
                    set({
                        ...currentSettings,
                        showCompactMode: !currentSettings.showCompactMode
                    });
                    break;
                case (0, (0, parcelRequire("9pP0g")).ViewSetting).SHOW_EPICS:
                    set({
                        ...currentSettings,
                        showEpics: !currentSettings.showEpics
                    });
                    break;
                case (0, (0, parcelRequire("9pP0g")).ViewSetting).SHOW_STATUSES:
                    set({
                        ...currentSettings,
                        showStatuses: !currentSettings.showStatuses
                    });
                    break;
                case (0, (0, parcelRequire("9pP0g")).ViewSetting).SHOW_VERSIONS:
                    set({
                        ...currentSettings,
                        showVersions: !currentSettings.showVersions
                    });
                    break;
                case (0, (0, parcelRequire("9pP0g")).ViewSetting).SHOW_UNSCHEDULED_COLUMN:
                    set({
                        ...currentSettings,
                        showUnscheduledColumn: !currentSettings.showUnscheduledColumn
                    });
                    break;
                case (0, (0, parcelRequire("9pP0g")).ViewSetting).SHOW_ISSUE_KEY:
                    set({
                        ...currentSettings,
                        showIssueKey: !currentSettings.showIssueKey
                    });
                    break;
                case (0, (0, parcelRequire("9pP0g")).ViewSetting).SHOW_ISSUE_TYPE:
                    set({
                        ...currentSettings,
                        showIssueType: !currentSettings.showIssueType
                    });
                    break;
                case (0, (0, parcelRequire("9pP0g")).ViewSetting).SHOW_PRIORITY:
                    set({
                        ...currentSettings,
                        showPriority: !currentSettings.showPriority
                    });
                    break;
                case (0, (0, parcelRequire("9pP0g")).ViewSetting).SHOW_DEVELOPMENT:
                    set({
                        ...currentSettings,
                        showDevelopment: !currentSettings.showDevelopment
                    });
                    break;
                case (0, (0, parcelRequire("9pP0g")).ViewSetting).SHOW_ASSIGNEE:
                    set({
                        ...currentSettings,
                        showAssignee: !currentSettings.showAssignee
                    });
                    break;
                case (0, (0, parcelRequire("9pP0g")).ViewSetting).SHOW_ESTIMATE:
                    set({
                        ...currentSettings,
                        showEstimate: !currentSettings.showEstimate
                    });
                    break;
                case (0, (0, parcelRequire("9pP0g")).ViewSetting).SHOW_DAYS_IN_COLUMN:
                    set({
                        ...currentSettings,
                        showDaysInColumn: !currentSettings.showDaysInColumn
                    });
                    break;
                case (0, (0, parcelRequire("9pP0g")).ViewSetting).SHOW_DUE_DATE:
                    set({
                        ...currentSettings,
                        showDueDate: !currentSettings.showDueDate
                    });
                    break;
                case (0, (0, parcelRequire("9pP0g")).ViewSetting).SHOW_LABELS:
                    set({
                        ...currentSettings,
                        showLabels: !currentSettings.showLabels
                    });
                    break;
                case (0, (0, parcelRequire("9pP0g")).ViewSetting).SHOW_CARD_COVERS:
                    set({
                        ...currentSettings,
                        showCardCovers: !currentSettings.showCardCovers
                    });
                    break;
                case (0, (0, parcelRequire("9pP0g")).ViewSetting).SHOW_OFFTRACK_DEPENDENCY_LINES:
                    set({
                        ...currentSettings,
                        showOfftrackDependencyLines: !currentSettings.showOfftrackDependencyLines
                    });
                    break;
                default:
                    break;
            }
        };
    const $b6bf5ef387c9e297$export$c1bb93dcfa07c797 = ({ boardId: boardId, view: view })=>({ setState: setState, getState: getState })=>{
            const currentSettings = getState();
            (0, parcelRequire("8zmNw")).setShowEpics({
                boardId: boardId,
                showEpics: !currentSettings.showEpics,
                view: view || currentSettings.view || undefined
            });
            setState({
                ...currentSettings,
                showEpics: !currentSettings.showEpics
            });
        };
    const $b6bf5ef387c9e297$export$582a65f6c8cb93ab = ({ boardId: boardId, view: view })=>({ setState: setState, getState: getState })=>{
            const currentSettings = getState();
            (0, parcelRequire("8zmNw")).setShowVersions({
                boardId: boardId,
                showVersions: !currentSettings.showVersions,
                view: view || currentSettings.view || undefined
            });
            setState({
                ...currentSettings,
                showVersions: !currentSettings.showVersions
            });
        };
    const $b6bf5ef387c9e297$export$ac311ca7d5df1d03 = ({ boardId: boardId, view: view })=>({ setState: setState, getState: getState })=>{
            const currentSettings = getState();
            (0, parcelRequire("8zmNw")).setShowStatuses({
                boardId: boardId,
                showStatuses: !currentSettings.showStatuses,
                view: view || currentSettings.view || undefined
            });
            setState({
                ...currentSettings,
                showStatuses: !currentSettings.showStatuses
            });
        };
    const $b6bf5ef387c9e297$export$580abda923c30dc5 = ({ boardId: boardId, view: view })=>({ setState: setState, getState: getState })=>{
            const currentSettings = getState();
            (0, parcelRequire("8zmNw")).setShowIssueLinksStats({
                boardId: boardId,
                showIssueLinksStats: !currentSettings.showIssueLinksStats,
                view: view || currentSettings.view || undefined
            });
            setState({
                ...currentSettings,
                showIssueLinksStats: !currentSettings.showIssueLinksStats
            });
        };
    const $b6bf5ef387c9e297$export$6edce735c6eb4cb0 = (boardId, isVisible)=>({ setState: setState, getState: getState })=>{
            const currentSettings = getState();
            (0, parcelRequire("8zmNw")).setShowUnscheduledColumn({
                boardId: boardId,
                showUnscheduledColumn: isVisible
            });
            setState({
                ...currentSettings,
                showUnscheduledColumn: isVisible
            });
        };
    const $b6bf5ef387c9e297$export$2849cc68d8e521b7 = ({ boardId: boardId, view: view })=>({ setState: setState, getState: getState })=>{
            const currentSettings = getState();
            (0, parcelRequire("8zmNw")).setShowDaysInColumn({
                boardId: boardId,
                showDaysInColumn: !currentSettings.showDaysInColumn,
                view: view || currentSettings.view || undefined
            });
            setState({
                ...currentSettings,
                showDaysInColumn: !currentSettings.showDaysInColumn
            });
        };
    const $b6bf5ef387c9e297$export$ef2b1a307fba6e8a = ({ boardId: boardId, view: view })=>({ setState: setState, getState: getState })=>{
            const currentSettings = getState();
            (0, parcelRequire("8zmNw")).setShowDueDate({
                boardId: boardId,
                showDueDate: !currentSettings.showDueDate,
                view: view || currentSettings.view || undefined
            });
            setState({
                ...currentSettings,
                showDueDate: !currentSettings.showDueDate
            });
        };
    const $b6bf5ef387c9e297$export$229260fb852e61e0 = ({ boardId: boardId, view: view })=>({ setState: setState, getState: getState })=>{
            const currentSettings = getState();
            (0, parcelRequire("8zmNw")).setShowLabels({
                boardId: boardId,
                showLabels: !currentSettings.showLabels,
                view: view || currentSettings.view || undefined
            });
            setState({
                ...currentSettings,
                showLabels: !currentSettings.showLabels
            });
        };
    const $b6bf5ef387c9e297$export$6acb0c83c20a20 = ({ boardId: boardId, view: view, fieldId: fieldId })=>({ setState: setState, getState: getState })=>{
            const currentSettings = getState();
            const currentExtraFields = currentSettings.cardExtraFields;
            (0, parcelRequire("8zmNw")).setExtraFields({
                boardId: boardId,
                cardExtraFields: {
                    ...currentExtraFields,
                    [fieldId]: !currentExtraFields[fieldId]
                },
                view: view || currentSettings.view || undefined
            });
            setState({
                ...currentSettings,
                cardExtraFields: {
                    ...currentExtraFields,
                    [fieldId]: !currentExtraFields[fieldId]
                }
            });
        };
    const $b6bf5ef387c9e297$export$2c48063cd4ef1ade = (boardId, isVisible)=>({ setState: setState, getState: getState })=>{
            const currentSettings = getState();
            (0, parcelRequire("8zmNw")).setShowOfftrackDependencyLines({
                boardId: boardId,
                showOfftrackDependencyLines: isVisible
            });
            setState({
                ...currentSettings,
                showOfftrackDependencyLines: isVisible
            });
        };
    const $b6bf5ef387c9e297$export$f7b68cb584e33d77 = (boardId, issueIds)=>({ setState: setState, getState: getState })=>{
            const currentSettings = getState();
            (0, parcelRequire("8zmNw")).setIssueIdsToShowDependencies({
                boardId: boardId,
                issueIds: issueIds
            });
            setState({
                ...currentSettings,
                issueIdsToShowDependencies: issueIds
            });
        };
});
parcelRegister("8zmNw", function(module, exports) {
    $parcel$export(module.exports, "getViewSettings", ()=>$a5d579bc47cfed7a$export$3ae70db4a97563c);
    $parcel$export(module.exports, "setViewSettingsIsFullscreen", ()=>$a5d579bc47cfed7a$export$322210075289ef56);
    $parcel$export(module.exports, "getViewSettingsIsFullscreen", ()=>$a5d579bc47cfed7a$export$d2c8042121049ae8);
    $parcel$export(module.exports, "getViewSettingsPanels", ()=>$a5d579bc47cfed7a$export$d6a5a0d616fcec93);
    $parcel$export(module.exports, "setViewSettings", ()=>$a5d579bc47cfed7a$export$99f2d9eb0b41b93);
    $parcel$export(module.exports, "setViewSettingsPanels", ()=>$a5d579bc47cfed7a$export$427f126b21640252);
    $parcel$export(module.exports, "getViewSettingsQuickFilters", ()=>$a5d579bc47cfed7a$export$18eb87e1feb49f18);
    $parcel$export(module.exports, "setViewSettingsQuickFilters", ()=>$a5d579bc47cfed7a$export$60d0caf3b1c59159);
    $parcel$export(module.exports, "getViewSettingsCompactMode", ()=>$a5d579bc47cfed7a$export$658ed39e1ffe75b);
    $parcel$export(module.exports, "setViewSettingsCompactMode", ()=>$a5d579bc47cfed7a$export$9ca6e4490ca9b1fc);
    $parcel$export(module.exports, "getViewSettingsCardDetails", ()=>$a5d579bc47cfed7a$export$a2a95ab43ea98277);
    $parcel$export(module.exports, "setViewSettingsCardDetails", ()=>$a5d579bc47cfed7a$export$af2e5a35023755b5);
    $parcel$export(module.exports, "getViewSettingsCardExtraFields", ()=>$a5d579bc47cfed7a$export$6a2173913af81755);
    $parcel$export(module.exports, "setViewSettingsCardExtraFields", ()=>$a5d579bc47cfed7a$export$b54537ba70def946);
    $parcel$export(module.exports, "setShowEpics", ()=>$a5d579bc47cfed7a$export$294c0e262bd1285a);
    $parcel$export(module.exports, "setShowVersions", ()=>$a5d579bc47cfed7a$export$a3ab3e2c6a6189bd);
    $parcel$export(module.exports, "setShowStatuses", ()=>$a5d579bc47cfed7a$export$e95c7c8d7cbf6350);
    $parcel$export(module.exports, "setShowIssueLinksStats", ()=>$a5d579bc47cfed7a$export$163e0dded7eda9d9);
    $parcel$export(module.exports, "setShowUnscheduledColumn", ()=>$a5d579bc47cfed7a$export$6edce735c6eb4cb0);
    $parcel$export(module.exports, "getShowUnscheduledColumn", ()=>$a5d579bc47cfed7a$export$bf31a7b99f7bc62f);
    $parcel$export(module.exports, "setShowDaysInColumn", ()=>$a5d579bc47cfed7a$export$68382c1a767b0133);
    $parcel$export(module.exports, "setShowDueDate", ()=>$a5d579bc47cfed7a$export$13fed6c54275816a);
    $parcel$export(module.exports, "setShowLabels", ()=>$a5d579bc47cfed7a$export$43aa76b69739d220);
    $parcel$export(module.exports, "setExtraFields", ()=>$a5d579bc47cfed7a$export$b24e660e664a6bba);
    $parcel$export(module.exports, "setShowOfftrackDependencyLines", ()=>$a5d579bc47cfed7a$export$2c48063cd4ef1ade);
    $parcel$export(module.exports, "getShowOfftrackDependencyLines", ()=>$a5d579bc47cfed7a$export$32c01395d25dfdcc);
    $parcel$export(module.exports, "setIssueIdsToShowDependencies", ()=>$a5d579bc47cfed7a$export$f7b68cb584e33d77);
    $parcel$export(module.exports, "getIssueIdsToShowDependencies", ()=>$a5d579bc47cfed7a$export$67e6bba1326e537a);
    var $bSSG7;
    var $4R6GH;
    var $duOMW;
    var $a4XJc;
    var $cYeCp;
    const $a5d579bc47cfed7a$var$browserLocalStorage = (0, (0, parcelRequire("bSSG7")).createLocalStorageProvider)((0, (0, parcelRequire("duOMW")).VIEW_SETTINGS_LOCAL_STORAGE));
    const $a5d579bc47cfed7a$export$36e24695f02d4503 = (view)=>{
        if (view && view === (0, (0, parcelRequire("a4XJc")).View).INCREMENT_PLANNING_BOARD) return `${0, (0, parcelRequire("duOMW")).VIEW_SETTINGS}-${(0, (0, parcelRequire("a4XJc")).View).INCREMENT_PLANNING_BOARD}`;
        if ((0, (0, parcelRequire("cYeCp")).isViewSettingsPanelAndTailoredViewExperimentEnabled)()) switch(view){
            case (0, (0, parcelRequire("a4XJc")).View).INCREMENT_PLANNING_BOARD:
                return `${0, (0, parcelRequire("duOMW")).VIEW_SETTINGS}-${(0, (0, parcelRequire("a4XJc")).View).INCREMENT_PLANNING_BOARD}`;
            case (0, (0, parcelRequire("a4XJc")).View).BACKLOG:
                return `${0, (0, parcelRequire("duOMW")).VIEW_SETTINGS}-${(0, (0, parcelRequire("a4XJc")).View).BACKLOG}`;
            case (0, (0, parcelRequire("a4XJc")).View).BOARD:
                return `${0, (0, parcelRequire("duOMW")).VIEW_SETTINGS}-${(0, (0, parcelRequire("a4XJc")).View).BOARD}`;
            case (0, (0, parcelRequire("a4XJc")).View).JSM_BOARD:
                return `${0, (0, parcelRequire("duOMW")).VIEW_SETTINGS}-${(0, (0, parcelRequire("a4XJc")).View).JSM_BOARD}`;
            default:
                return 0, (0, parcelRequire("duOMW")).VIEW_SETTINGS;
        }
        return 0, (0, parcelRequire("duOMW")).VIEW_SETTINGS;
    };
    const $a5d579bc47cfed7a$export$3ae70db4a97563c = ({ boardId: boardId, view: view })=>$a5d579bc47cfed7a$var$browserLocalStorage.get(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`) || $a5d579bc47cfed7a$var$browserLocalStorage.get(`${(0, (0, parcelRequire("duOMW")).VIEW_SETTINGS)}-${boardId}`);
    const $a5d579bc47cfed7a$export$322210075289ef56 = ({ boardId: boardId, isFullscreen: isFullscreen, view: view })=>{
        const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
            boardId: boardId,
            view: view
        });
        $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
            ...state,
            isFullscreen: isFullscreen
        });
    };
    const $a5d579bc47cfed7a$export$d2c8042121049ae8 = ({ boardId: boardId, view: view })=>{
        const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
            boardId: boardId,
            view: view
        });
        return state?.isFullscreen ?? (0, (0, parcelRequire("duOMW")).initialState).isFullscreen;
    };
    const $a5d579bc47cfed7a$export$d6a5a0d616fcec93 = ({ boardId: boardId, view: view })=>{
        const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
            boardId: boardId,
            view: view
        });
        return {
            EPIC_PANEL: state?.showEpicPanel ?? (0, (0, parcelRequire("duOMW")).initialState).showEpicPanel,
            VERSION_PANEL: state?.showVersionPanel ?? (0, (0, parcelRequire("duOMW")).initialState).showVersionPanel
        };
    };
    const $a5d579bc47cfed7a$export$99f2d9eb0b41b93 = ({ boardId: boardId, state: state, view: view })=>$a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, state);
    const $a5d579bc47cfed7a$export$427f126b21640252 = ({ boardId: boardId, panelState: panelState, view: view })=>{
        const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
            boardId: boardId,
            view: view
        });
        $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
            ...state,
            showEpicPanel: panelState.EPIC_PANEL,
            showVersionPanel: panelState.VERSION_PANEL
        });
    };
    const $a5d579bc47cfed7a$export$7a001fa75693814b = ({ boardId: boardId, panel: panel, show: show, view: view })=>{
        const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
            boardId: boardId,
            view: view
        });
        if (panel === (0, (0, parcelRequire("a4XJc")).Panels).EPIC_PANEL) $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
            ...state,
            showEpicPanel: show
        });
        if (panel === (0, (0, parcelRequire("a4XJc")).Panels).VERSION_PANEL) $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
            ...state,
            showVersionPanel: show
        });
    };
    const $a5d579bc47cfed7a$export$18eb87e1feb49f18 = ({ boardId: boardId, view: view })=>{
        const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
            boardId: boardId,
            view: view
        });
        return state?.showQuickFilters ?? (0, (0, parcelRequire("duOMW")).initialState).showQuickFilters;
    };
    const $a5d579bc47cfed7a$export$60d0caf3b1c59159 = ({ boardId: boardId, showQuickFilters: showQuickFilters, view: view })=>{
        const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
            boardId: boardId,
            view: view
        });
        $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
            ...state,
            showQuickFilters: showQuickFilters
        });
    };
    const $a5d579bc47cfed7a$export$658ed39e1ffe75b = ({ boardId: boardId, view: view })=>{
        const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
            boardId: boardId,
            view: view
        });
        return state?.showCompactMode ?? (0, (0, parcelRequire("duOMW")).initialState).showCompactMode;
    };
    const $a5d579bc47cfed7a$export$9ca6e4490ca9b1fc = ({ boardId: boardId, showCompactMode: showCompactMode, view: view })=>{
        const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
            boardId: boardId,
            view: view
        });
        $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
            ...state,
            showCompactMode: showCompactMode
        });
    };
    const $a5d579bc47cfed7a$export$a2a95ab43ea98277 = ({ boardId: boardId, view: view, isDaysInColumnEnabled: isDaysInColumnEnabled, isDueDateEnabled: isDueDateEnabled, isLabelsEnabled: isLabelsEnabled, isEstimateEnabled: isEstimateEnabled, isPriorityEnabled: isPriorityEnabled })=>{
        const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
            boardId: boardId,
            view: view
        });
        const defaultState = (0, (0, parcelRequire("4R6GH")).fg)('jsw_card_cover_image_default_on') ? (0, (0, parcelRequire("duOMW")).initialStateNew) : (0, (0, parcelRequire("duOMW")).initialState);
        return {
            SHOW_EPICS: state?.showEpics ?? defaultState.showEpics,
            SHOW_STATUSES: state?.showStatuses ?? defaultState.showStatuses,
            SHOW_VERSIONS: state?.showVersions ?? defaultState.showVersions,
            SHOW_ISSUE_LINKS_STATS: state?.showIssueLinksStats ?? defaultState.showIssueLinksStats,
            SHOW_ISSUE_KEY: state?.showIssueKey ?? defaultState.showIssueKey,
            SHOW_ISSUE_TYPE: state?.showIssueType ?? defaultState.showIssueType,
            SHOW_ASSIGNEE: state?.showAssignee ?? defaultState.showAssignee,
            SHOW_PRIORITY: (isPriorityEnabled ? state?.showPriority : defaultState.showPriority) ?? defaultState.showPriority,
            SHOW_DEVELOPMENT: state?.showDevelopment ?? defaultState.showDevelopment,
            SHOW_ESTIMATE: (isEstimateEnabled ? state?.showEstimate : defaultState.showEstimate) ?? defaultState.showEstimate,
            SHOW_DAYS_IN_COLUMN: (isDaysInColumnEnabled ? state?.showDaysInColumn : defaultState.showDaysInColumn) ?? defaultState.showDaysInColumn,
            SHOW_DUE_DATE: (isDueDateEnabled ? state?.showDueDate : defaultState.showDueDate) ?? defaultState.showDueDate,
            SHOW_LABELS: (isLabelsEnabled ? state?.showLabels : defaultState.showLabels) ?? defaultState.showLabels,
            SHOW_CARD_COVERS: state?.showCardCovers ?? defaultState.showCardCovers
        };
    };
    const $a5d579bc47cfed7a$export$af2e5a35023755b5 = ({ boardId: boardId, cardDetailsState: cardDetailsState, view: view })=>{
        const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
            boardId: boardId,
            view: view
        });
        $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
            ...state,
            showEpics: cardDetailsState.SHOW_EPICS,
            showStatuses: cardDetailsState.SHOW_STATUSES,
            showVersions: cardDetailsState.SHOW_VERSIONS,
            showDaysInColumn: cardDetailsState.SHOW_DAYS_IN_COLUMN,
            showEstimate: cardDetailsState.SHOW_ESTIMATE,
            showIssueLinksStats: cardDetailsState.SHOW_ISSUE_LINKS_STATS,
            showIssueKey: cardDetailsState.SHOW_ISSUE_KEY,
            showIssueType: cardDetailsState.SHOW_ISSUE_TYPE,
            showAssignee: cardDetailsState.SHOW_ASSIGNEE,
            showPriority: cardDetailsState.SHOW_PRIORITY,
            showDevelopment: cardDetailsState.SHOW_DEVELOPMENT,
            showDueDate: cardDetailsState.SHOW_DUE_DATE,
            showLabels: cardDetailsState.SHOW_LABELS,
            showCardCovers: cardDetailsState.SHOW_CARD_COVERS
        });
    };
    const $a5d579bc47cfed7a$export$6a2173913af81755 = ({ boardId: boardId, view: view, cardExtraFields: cardExtraFields })=>{
        const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
            boardId: boardId,
            view: view
        });
        return cardExtraFields.reduce((acc, field)=>{
            acc[field.id] = state?.cardExtraFields?.[field.id] ?? true;
            return acc;
        }, {});
    };
    const $a5d579bc47cfed7a$export$b54537ba70def946 = ({ boardId: boardId, cardExtraFieldsState: cardExtraFieldsState, view: view })=>{
        const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
            boardId: boardId,
            view: view
        });
        $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
            ...state,
            cardExtraFields: cardExtraFieldsState
        });
    };
    const $a5d579bc47cfed7a$export$294c0e262bd1285a = ({ boardId: boardId, showEpics: showEpics, view: view })=>{
        const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
            boardId: boardId,
            view: view
        });
        $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
            ...state,
            showEpics: showEpics
        });
    };
    const $a5d579bc47cfed7a$export$a3ab3e2c6a6189bd = ({ boardId: boardId, showVersions: showVersions, view: view })=>{
        const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
            boardId: boardId,
            view: view
        });
        $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
            ...state,
            showVersions: showVersions
        });
    };
    const $a5d579bc47cfed7a$export$e95c7c8d7cbf6350 = ({ boardId: boardId, showStatuses: showStatuses, view: view })=>{
        const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
            boardId: boardId,
            view: view
        });
        $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
            ...state,
            showStatuses: showStatuses
        });
    };
    const $a5d579bc47cfed7a$export$163e0dded7eda9d9 = ({ boardId: boardId, showIssueLinksStats: showIssueLinksStats, view: view })=>{
        const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
            boardId: boardId,
            view: view
        });
        $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
            ...state,
            showIssueLinksStats: showIssueLinksStats
        });
    };
    const $a5d579bc47cfed7a$export$6edce735c6eb4cb0 = ({ boardId: boardId, showUnscheduledColumn: showUnscheduledColumn })=>{
        const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
            boardId: boardId,
            view: (0, (0, parcelRequire("a4XJc")).View).INCREMENT_PLANNING_BOARD
        });
        $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503((0, (0, parcelRequire("a4XJc")).View).INCREMENT_PLANNING_BOARD)}-${boardId}`, {
            ...state,
            showUnscheduledColumn: showUnscheduledColumn
        });
    };
    const $a5d579bc47cfed7a$export$bf31a7b99f7bc62f = (boardId)=>{
        const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
            boardId: boardId,
            view: (0, (0, parcelRequire("a4XJc")).View).INCREMENT_PLANNING_BOARD
        });
        return state?.showUnscheduledColumn ?? (0, (0, parcelRequire("duOMW")).initialState).showUnscheduledColumn;
    };
    const $a5d579bc47cfed7a$export$68382c1a767b0133 = ({ boardId: boardId, showDaysInColumn: showDaysInColumn, view: view })=>{
        const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
            boardId: boardId,
            view: view
        });
        $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
            ...state,
            showDaysInColumn: showDaysInColumn
        });
    };
    const $a5d579bc47cfed7a$export$13fed6c54275816a = ({ boardId: boardId, showDueDate: showDueDate, view: view })=>{
        const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
            boardId: boardId,
            view: view
        });
        $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
            ...state,
            showDueDate: showDueDate
        });
    };
    const $a5d579bc47cfed7a$export$43aa76b69739d220 = ({ boardId: boardId, showLabels: showLabels, view: view })=>{
        const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
            boardId: boardId,
            view: view
        });
        $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
            ...state,
            showLabels: showLabels
        });
    };
    const $a5d579bc47cfed7a$export$b24e660e664a6bba = ({ boardId: boardId, cardExtraFields: cardExtraFields, view: view })=>{
        const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
            boardId: boardId,
            view: view
        });
        $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
            ...state,
            cardExtraFields: cardExtraFields
        });
    };
    const $a5d579bc47cfed7a$export$90df0703e41f9b = ({ boardId: boardId, showCardCovers: showCardCovers, view: view })=>{
        const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
            boardId: boardId,
            view: view
        });
        $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
            ...state,
            showCardCovers: showCardCovers
        });
    };
    const $a5d579bc47cfed7a$export$2c48063cd4ef1ade = ({ boardId: boardId, showOfftrackDependencyLines: showOfftrackDependencyLines })=>{
        const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
            boardId: boardId,
            view: (0, (0, parcelRequire("a4XJc")).View).INCREMENT_PLANNING_BOARD
        });
        $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503((0, (0, parcelRequire("a4XJc")).View).INCREMENT_PLANNING_BOARD)}-${boardId}`, {
            ...state,
            showOfftrackDependencyLines: showOfftrackDependencyLines
        });
    };
    const $a5d579bc47cfed7a$export$32c01395d25dfdcc = (boardId)=>{
        const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
            boardId: boardId,
            view: (0, (0, parcelRequire("a4XJc")).View).INCREMENT_PLANNING_BOARD
        });
        return state?.showOfftrackDependencyLines ?? (0, (0, parcelRequire("duOMW")).initialState).showOfftrackDependencyLines;
    };
    const $a5d579bc47cfed7a$export$f7b68cb584e33d77 = ({ boardId: boardId, issueIds: issueIds })=>{
        const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
            boardId: boardId,
            view: (0, (0, parcelRequire("a4XJc")).View).INCREMENT_PLANNING_BOARD
        });
        $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503((0, (0, parcelRequire("a4XJc")).View).INCREMENT_PLANNING_BOARD)}-${boardId}`, {
            ...state,
            issueIdsToShowDependencies: issueIds
        });
    };
    const $a5d579bc47cfed7a$export$67e6bba1326e537a = (boardId)=>{
        const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
            boardId: boardId,
            view: (0, (0, parcelRequire("a4XJc")).View).INCREMENT_PLANNING_BOARD
        });
        return state?.issueIdsToShowDependencies ?? (0, (0, parcelRequire("duOMW")).initialState).issueIdsToShowDependencies;
    };
});
parcelRegister("cYeCp", function(module, exports) {
    $parcel$export(module.exports, "parseSearchQuery", ()=>$e84c24ee8b7a736a$export$6298490de4ddc3eb);
    $parcel$export(module.exports, "setPanels", ()=>$e84c24ee8b7a736a$export$d89c07c704083e54);
    $parcel$export(module.exports, "parseSearchQueryForIPBoard", ()=>$e84c24ee8b7a736a$export$442a6f7c9ee1c18a);
    $parcel$export(module.exports, "setIncrementPlanningSettingsQuery", ()=>$e84c24ee8b7a736a$export$8bc567645273ba46);
    $parcel$export(module.exports, "isViewSettingsPanelAndTailoredViewExperimentEnabled", ()=>$e84c24ee8b7a736a$export$eed360eb853808ee);
    var $7uUwQ = parcelRequire("7uUwQ");
    var $ebyGx = parcelRequire("ebyGx");
    var $4R6GH;
    const $e84c24ee8b7a736a$export$6298490de4ddc3eb = (search)=>{
        const searchParams = (0, ($parcel$interopDefault($ebyGx))).parse(search);
        return {
            EPIC_PANEL: searchParams[0, $2634c0a33984ecbe$export$ec3c43b997309252] === 'visible',
            VERSION_PANEL: searchParams[0, $2634c0a33984ecbe$export$a86c1a6dde9da34f] === 'visible'
        };
    };
    const $e84c24ee8b7a736a$export$d89c07c704083e54 = (panels, location)=>{
        const search = (0, $7uUwQ.chain)({
            ...(0, ($parcel$interopDefault($ebyGx))).parse(location.search)
        });
        search.unset((0, $2634c0a33984ecbe$export$ec3c43b997309252));
        search.unset((0, $2634c0a33984ecbe$export$a86c1a6dde9da34f));
        if (panels.EPIC_PANEL) search.set((0, $2634c0a33984ecbe$export$ec3c43b997309252), 'visible');
        if (panels.VERSION_PANEL) search.set((0, $2634c0a33984ecbe$export$a86c1a6dde9da34f), 'visible');
        return {
            ...location,
            search: (0, ($parcel$interopDefault($ebyGx))).stringify(search.value())
        };
    };
    const $e84c24ee8b7a736a$export$442a6f7c9ee1c18a = (search)=>{
        const searchParams = (0, ($parcel$interopDefault($ebyGx))).parse(search);
        if (!(0, (0, parcelRequire("4R6GH")).fg)('dependency_visualisation_program_board_fe_and_be')) return {
            SHOW_UNSCHEDULED_COLUMN: searchParams[0, $2634c0a33984ecbe$export$bfa26a3d2f080ac5] === 'hidden' ? false : undefined,
            SHOW_OFFTRACK_DEPENDENCY_LINES: searchParams[0, $2634c0a33984ecbe$export$8b0819c4fa234ad] === 'hidden' ? false : undefined,
            ISSUE_IDS_TO_SHOW_DEPENDENCIES: []
        };
        const issuesQuery = searchParams[0, $2634c0a33984ecbe$export$1692762d83d78f09] ? decodeURIComponent(searchParams[0, $2634c0a33984ecbe$export$1692762d83d78f09]) : undefined;
        const issuesSplit = issuesQuery ? issuesQuery.split(',') : [];
        const issueIdsToShowDependencies = [];
        issuesSplit.forEach((issueId)=>{
            const trimmedIssueId = issueId.trim();
            if (trimmedIssueId.length) issueIdsToShowDependencies.push(trimmedIssueId);
        });
        return {
            SHOW_UNSCHEDULED_COLUMN: searchParams[0, $2634c0a33984ecbe$export$bfa26a3d2f080ac5] === 'hidden' ? false : undefined,
            SHOW_OFFTRACK_DEPENDENCY_LINES: searchParams[0, $2634c0a33984ecbe$export$8b0819c4fa234ad] === 'hidden' ? false : undefined,
            ISSUE_IDS_TO_SHOW_DEPENDENCIES: issueIdsToShowDependencies
        };
    };
    const $e84c24ee8b7a736a$export$8bc567645273ba46 = (incrementPlanningSettings, location)=>{
        const search = (0, $7uUwQ.chain)({
            ...(0, ($parcel$interopDefault($ebyGx))).parse(location.search)
        });
        search.unset((0, $2634c0a33984ecbe$export$bfa26a3d2f080ac5));
        if (!incrementPlanningSettings.SHOW_UNSCHEDULED_COLUMN) search.set((0, $2634c0a33984ecbe$export$bfa26a3d2f080ac5), 'hidden');
        if ((0, (0, parcelRequire("4R6GH")).fg)('dependency_visualisation_program_board_fe_and_be')) {
            search.unset((0, $2634c0a33984ecbe$export$8b0819c4fa234ad));
            search.unset((0, $2634c0a33984ecbe$export$1692762d83d78f09));
            if (!incrementPlanningSettings.SHOW_OFFTRACK_DEPENDENCY_LINES) search.set((0, $2634c0a33984ecbe$export$8b0819c4fa234ad), 'hidden');
            if (incrementPlanningSettings.ISSUE_IDS_TO_SHOW_DEPENDENCIES && incrementPlanningSettings.ISSUE_IDS_TO_SHOW_DEPENDENCIES.length) search.set((0, $2634c0a33984ecbe$export$1692762d83d78f09), encodeURIComponent(incrementPlanningSettings.ISSUE_IDS_TO_SHOW_DEPENDENCIES.toString()));
        }
        return {
            ...location,
            search: (0, ($parcel$interopDefault($ebyGx))).stringify(search.value())
        };
    };
    const $e84c24ee8b7a736a$export$eed360eb853808ee = ()=>(0, (0, parcelRequire("4R6GH")).fg)('jira_view_settings_additional_fields');
});
const $2634c0a33984ecbe$export$ec3c43b997309252 = 'epics';
const $2634c0a33984ecbe$export$a86c1a6dde9da34f = 'versions';
const $2634c0a33984ecbe$export$bfa26a3d2f080ac5 = 'unscheduledWork';
const $2634c0a33984ecbe$export$8b0819c4fa234ad = 'showOfftrackDependencyLines';
const $2634c0a33984ecbe$export$1692762d83d78f09 = 'issueIdsToShowDependencies';
parcelRegister("ffHmx", function(module, exports) {
    $parcel$export(module.exports, "getIsFullscreen", ()=>$fc378329dceca517$export$b061161f83abaf15);
    $parcel$export(module.exports, "getShowVersionPanel", ()=>$fc378329dceca517$export$cdf1158c8123d31c);
    $parcel$export(module.exports, "getShowEpicPanel", ()=>$fc378329dceca517$export$fc9a39e5c1906367);
    $parcel$export(module.exports, "getShowQuickFilters", ()=>$fc378329dceca517$export$732caa9fcae1c5ff);
    $parcel$export(module.exports, "getShowCompactMode", ()=>$fc378329dceca517$export$72bae49530cc02bb);
    $parcel$export(module.exports, "getShowPanels", ()=>$fc378329dceca517$export$e2483fb3e0d0ff4b);
    $parcel$export(module.exports, "getShowEpics", ()=>$fc378329dceca517$export$b631ebb4887e6060);
    $parcel$export(module.exports, "getShowVersions", ()=>$fc378329dceca517$export$2cb6de520195dbf5);
    $parcel$export(module.exports, "getShowStatuses", ()=>$fc378329dceca517$export$b5f1c34af9498ea);
    $parcel$export(module.exports, "getShowUnscheduledColumn", ()=>$fc378329dceca517$export$bf31a7b99f7bc62f);
    $parcel$export(module.exports, "getShowIssueLinksStats", ()=>$fc378329dceca517$export$266785c43d094472);
    $parcel$export(module.exports, "getShowIssueType", ()=>$fc378329dceca517$export$a079b5f709c4d237);
    $parcel$export(module.exports, "getShowIssueKey", ()=>$fc378329dceca517$export$cb710ef8b1ccd94b);
    $parcel$export(module.exports, "getShowPriority", ()=>$fc378329dceca517$export$5abfbf16fb2cec7b);
    $parcel$export(module.exports, "getShowDevelopment", ()=>$fc378329dceca517$export$d89a1b3e54af627e);
    $parcel$export(module.exports, "getShowAssignee", ()=>$fc378329dceca517$export$ad1a6d247a05049d);
    $parcel$export(module.exports, "getShowEstimate", ()=>$fc378329dceca517$export$d21c0b83591460c9);
    $parcel$export(module.exports, "getShowCardExtraField", ()=>$fc378329dceca517$export$7549550e839e6e0c);
    $parcel$export(module.exports, "getShowDaysInColumn", ()=>$fc378329dceca517$export$9a608cd91e68c95c);
    $parcel$export(module.exports, "getShowCardCovers", ()=>$fc378329dceca517$export$983376245b8547dc);
    $parcel$export(module.exports, "getShowOfftrackDependencyLines", ()=>$fc378329dceca517$export$32c01395d25dfdcc);
    $parcel$export(module.exports, "getIssueIdsToShowDependencies", ()=>$fc378329dceca517$export$67e6bba1326e537a);
    $parcel$export(module.exports, "getCardFieldsSettings", ()=>$fc378329dceca517$export$e9dfc10bd434fabb);
    $parcel$export(module.exports, "getHasCardExtraFields", ()=>$fc378329dceca517$export$1e24fae4497ff7e0);
    const $fc378329dceca517$export$b061161f83abaf15 = (state)=>state.isFullscreen;
    const $fc378329dceca517$export$cdf1158c8123d31c = (state)=>state.showVersionPanel;
    const $fc378329dceca517$export$fc9a39e5c1906367 = (state)=>state.showEpicPanel;
    const $fc378329dceca517$export$732caa9fcae1c5ff = (state)=>state.showQuickFilters;
    const $fc378329dceca517$export$72bae49530cc02bb = (state)=>state.showCompactMode;
    const $fc378329dceca517$export$e2483fb3e0d0ff4b = (state)=>({
            EPIC_PANEL: state.showEpicPanel,
            VERSION_PANEL: state.showVersionPanel
        });
    const $fc378329dceca517$export$b631ebb4887e6060 = (state)=>state.showEpics;
    const $fc378329dceca517$export$2cb6de520195dbf5 = (state)=>state.showVersions;
    const $fc378329dceca517$export$b5f1c34af9498ea = (state)=>state.showStatuses;
    const $fc378329dceca517$export$bf31a7b99f7bc62f = (state)=>state.showUnscheduledColumn;
    const $fc378329dceca517$export$266785c43d094472 = (state)=>state.showIssueLinksStats;
    const $fc378329dceca517$export$a079b5f709c4d237 = (state)=>state.showIssueType;
    const $fc378329dceca517$export$cb710ef8b1ccd94b = (state)=>state.showIssueKey;
    const $fc378329dceca517$export$5abfbf16fb2cec7b = (state)=>state.showPriority;
    const $fc378329dceca517$export$d89a1b3e54af627e = (state)=>state.showDevelopment;
    const $fc378329dceca517$export$ad1a6d247a05049d = (state)=>state.showAssignee;
    const $fc378329dceca517$export$d21c0b83591460c9 = (state)=>state.showEstimate;
    const $fc378329dceca517$export$7549550e839e6e0c = (state)=>state.cardExtraFields;
    const $fc378329dceca517$export$9a608cd91e68c95c = (state)=>state.showDaysInColumn;
    const $fc378329dceca517$export$983376245b8547dc = (state)=>state.showCardCovers;
    const $fc378329dceca517$export$32c01395d25dfdcc = (state)=>state.showOfftrackDependencyLines;
    const $fc378329dceca517$export$67e6bba1326e537a = (state)=>state.issueIdsToShowDependencies;
    const $fc378329dceca517$export$e9dfc10bd434fabb = (state)=>({
            showIssueType: state.showIssueType,
            showIssueKey: state.showIssueKey,
            showPriority: state.showPriority,
            showDevelopment: state.showDevelopment,
            showAssignee: state.showAssignee,
            showEstimate: state.showEstimate,
            cardExtraFields: state.cardExtraFields,
            showDaysInColumn: state.showDaysInColumn,
            showDueDate: state.showDueDate,
            showLabels: state.showLabels,
            showCardCovers: state.showCardCovers
        });
    const $fc378329dceca517$export$1e24fae4497ff7e0 = (state)=>Object.values(state.cardExtraFields).length > 0 && Object.values(state.cardExtraFields).some((value)=>value === true);
});
parcelRegister("9oo3F", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9506229386ae6ee1$export$2e2bcd8739ae039);
    var $7VHMR;
    var $9506229386ae6ee1$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noParentIssues: {
            "id": "software-filters.filters.parent.no-parent-issues",
            "defaultMessage": "Your project has no {parentName}"
        },
        toggleLabel: {
            "id": "software-filters.filters.parent.toggle-label",
            "defaultMessage": "Show {parentName} panel"
        }
    });
});
parcelRegister("hpA0D", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$779f77cd70091738$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $aWse0;
    var $96s6B;
    var $6DAJ4;
    const $779f77cd70091738$var$MAX_SELECTION_ALLOWED = 10;
    const $779f77cd70091738$var$QuickFilter = ({ filters: filters = [], selectedFilters: selectedFilters = [], onChange: onChange = (0, ($parcel$interopDefault($8Rkzz))), isNested: isNested = false })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        const values = (0, $5uXOq.useMemo)(()=>filters.map((filter)=>({
                    label: filter.name,
                    value: filter.id
                })), [
            filters
        ]);
        const onChangeMapValues = (0, $5uXOq.useCallback)((entries)=>{
            const analyticAttributes = {
                isNested: isNested
            };
            onChange(entries.map((entry)=>entry.value), analyticAttributes);
        }, [
            onChange,
            isNested
        ]);
        const maxSelectionReachedTooltip = formatMessage((0, (0, parcelRequire("6DAJ4")).default).maxSelectionReachedTooltip, {
            maxSelectionAllowed: $779f77cd70091738$var$MAX_SELECTION_ALLOWED
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("96s6B")).default), {
            label: formatMessage((0, (0, parcelRequire("6DAJ4")).default).label),
            values: values,
            selectedValues: selectedFilters,
            onChange: onChangeMapValues,
            maxSelectionAllowed: $779f77cd70091738$var$MAX_SELECTION_ALLOWED,
            maxSelectionReachedTooltip: maxSelectionReachedTooltip,
            isNested: isNested
        });
    };
    const $779f77cd70091738$var$QuickFilterComponent = (0, $5uXOq.memo)($779f77cd70091738$var$QuickFilter);
    $779f77cd70091738$var$QuickFilterComponent.displayName = 'QuickFilter';
    $779f77cd70091738$var$QuickFilterComponent.whyDidYouRender = true;
    var $779f77cd70091738$export$2e2bcd8739ae039 = $779f77cd70091738$var$QuickFilterComponent;
});
parcelRegister("6DAJ4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$28d3824050b576c4$export$2e2bcd8739ae039);
    var $7VHMR;
    var $28d3824050b576c4$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        label: {
            "id": "software-filters.filters.quick.label",
            "defaultMessage": "Quick filters"
        },
        maxSelectionReachedTooltip: {
            "id": "software-filters.filters.quick.max-selection-reached-tooltip",
            "defaultMessage": "You can't select more than {maxSelectionAllowed, plural, one {# quick filter} other {# quick filters}}"
        }
    });
});
parcelRegister("g65Ek", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ccc78a455db68a11$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $koVbs;
    var $96s6B;
    var $e0XMB;
    const $ccc78a455db68a11$var$RequestTypeFilter = ({ requestTypes: requestTypes = [], selectedRequestTypes: selectedRequestTypes = [], onChange: onChange = (0, ($parcel$interopDefault($8Rkzz))), isNested: isNested = false })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const values = (0, $5uXOq.useMemo)(()=>requestTypes.map((requestType)=>({
                    label: requestType.name,
                    value: requestType.id,
                    iconUrl: requestType.iconUrl
                })), [
            requestTypes
        ]);
        const onChangeCallback = (0, $5uXOq.useCallback)((entries)=>{
            const analyticAttributes = {
                isNested: isNested
            };
            onChange(entries.map((entry)=>entry.value), analyticAttributes);
        }, [
            onChange,
            isNested
        ]);
        if (requestTypes.length <= 1) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("96s6B")).default), {
            label: formatMessage((0, (0, parcelRequire("e0XMB")).default).label),
            values: values,
            selectedValues: selectedRequestTypes.map(String),
            onChange: onChangeCallback,
            isNested: isNested
        });
    };
    const $ccc78a455db68a11$var$RequestTypeFilterComponent = (0, $5uXOq.memo)($ccc78a455db68a11$var$RequestTypeFilter);
    $ccc78a455db68a11$var$RequestTypeFilterComponent.displayName = 'RequestTypeFilter';
    $ccc78a455db68a11$var$RequestTypeFilterComponent.whyDidYouRender = true;
    var $ccc78a455db68a11$export$2e2bcd8739ae039 = $ccc78a455db68a11$var$RequestTypeFilterComponent;
});
parcelRegister("e0XMB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4c7eddbc8ad682f0$export$2e2bcd8739ae039);
    var $7VHMR;
    var $4c7eddbc8ad682f0$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        label: {
            "id": "software-filters.filters.request-type.label",
            "defaultMessage": "Request type"
        }
    });
});
parcelRegister("jdA4J", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b6cedc5f723f1df5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $96s6B;
    var $6TH6s;
    const $b6cedc5f723f1df5$var$SprintFilter = ({ sprints: sprints = [], selectedSprints: selectedSprints = [], onChange: onChange = (0, ($parcel$interopDefault($8Rkzz))), isNested: isNested = false })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'sprintFilter rendered', {
                numberOfSprints: sprints.length
            });
        }, [
            createAnalyticsEvent,
            sprints
        ]);
        const values = (0, $5uXOq.useMemo)(()=>sprints.map((sprint)=>({
                    label: sprint.name,
                    value: sprint.id.toString()
                })), [
            sprints
        ]);
        const onChangeMapValues = (0, $5uXOq.useCallback)((entries)=>{
            const analyticAttributes = {
                isNested: isNested
            };
            onChange(entries.map((entry)=>entry.value), analyticAttributes);
        }, [
            onChange,
            isNested
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("96s6B")).default), {
            label: formatMessage((0, (0, parcelRequire("6TH6s")).default).label),
            values: values,
            selectedValues: selectedSprints,
            onChange: onChangeMapValues,
            isNested: isNested
        });
    };
    const $b6cedc5f723f1df5$var$SprintFilterComponent = (0, $5uXOq.memo)($b6cedc5f723f1df5$var$SprintFilter);
    $b6cedc5f723f1df5$var$SprintFilterComponent.displayName = 'SprintFilter';
    var $b6cedc5f723f1df5$export$2e2bcd8739ae039 = $b6cedc5f723f1df5$var$SprintFilterComponent;
});
parcelRegister("6TH6s", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a136882e810c6f5b$export$2e2bcd8739ae039);
    var $7VHMR;
    var $a136882e810c6f5b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        label: {
            "id": "software-filters.filters.sprint.label",
            "defaultMessage": "Sprint"
        }
    });
});
parcelRegister("cSFZv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$746f8d9f8aa82396$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $aWse0;
    var $g5X3G;
    var $96s6B;
    var $5qiVm;
    const $746f8d9f8aa82396$var$StatusCategoryFilter = ({ statusCategories: statusCategories = [], selectedStatusCategories: selectedStatusCategories = [], onChange: onChange = (0, ($parcel$interopDefault($8Rkzz))), isNested: isNested = false })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        const values = (0, $5uXOq.useMemo)(()=>statusCategories.map(({ id: id, name: name })=>({
                    label: name,
                    value: id
                })), [
            statusCategories
        ]);
        const onChangeValue = (0, $5uXOq.useCallback)((entries)=>{
            const analyticAttributes = {
                isNested: isNested
            };
            onChange(entries.map(({ value: value })=>(0, (0, parcelRequire("g5X3G")).toIssueStatusCategoryId)(value)), analyticAttributes);
        }, [
            onChange,
            isNested
        ]);
        if (values.length <= 1) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("96s6B")).default), {
            label: formatMessage((0, (0, parcelRequire("5qiVm")).default).label),
            values: values,
            selectedValues: selectedStatusCategories.map(String),
            onChange: onChangeValue,
            isNested: isNested
        });
    };
    const $746f8d9f8aa82396$var$StatusCategoryFilterComponent = (0, $5uXOq.memo)($746f8d9f8aa82396$var$StatusCategoryFilter);
    $746f8d9f8aa82396$var$StatusCategoryFilterComponent.displayName = 'StatusCategoryFilter';
    $746f8d9f8aa82396$var$StatusCategoryFilterComponent.whyDidYouRender = true;
    var $746f8d9f8aa82396$export$2e2bcd8739ae039 = $746f8d9f8aa82396$var$StatusCategoryFilterComponent;
});
parcelRegister("5qiVm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$16c5f1e62f5bac0b$export$2e2bcd8739ae039);
    var $7VHMR;
    var $16c5f1e62f5bac0b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        label: {
            "id": "software-filters.filters.status-category.label",
            "defaultMessage": "Status category"
        }
    });
});
parcelRegister("3f9TT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$45ecaaab2e5e2a52$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $koVbs;
    var $g5X3G;
    var $96s6B;
    var $33ioU;
    const $45ecaaab2e5e2a52$var$StatusFilter = ({ statuses: statuses = [], selectedStatuses: selectedStatuses = [], onChange: onChange = (0, ($parcel$interopDefault($8Rkzz))), isNested: isNested = false })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const values = (0, $5uXOq.useMemo)(()=>statuses.map(({ id: id, name: name })=>({
                    label: name,
                    value: id
                })), [
            statuses
        ]);
        const onChangeValue = (0, $5uXOq.useCallback)((entries)=>{
            const analyticAttributes = {
                isNested: isNested
            };
            onChange(entries.map(({ value: value })=>(0, (0, parcelRequire("g5X3G")).toIssueStatusId)(value)), analyticAttributes);
        }, [
            onChange,
            isNested
        ]);
        if (values.length <= 1) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("96s6B")).default), {
            label: formatMessage((0, (0, parcelRequire("33ioU")).default).label),
            values: values,
            selectedValues: selectedStatuses.map(String),
            onChange: onChangeValue,
            isNested: isNested
        });
    };
    const $45ecaaab2e5e2a52$var$StatusFilterComponent = (0, $5uXOq.memo)($45ecaaab2e5e2a52$var$StatusFilter);
    $45ecaaab2e5e2a52$var$StatusFilterComponent.displayName = 'StatusFilter';
    $45ecaaab2e5e2a52$var$StatusFilterComponent.whyDidYouRender = true;
    var $45ecaaab2e5e2a52$export$2e2bcd8739ae039 = $45ecaaab2e5e2a52$var$StatusFilterComponent;
});
parcelRegister("33ioU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ee3eff355f28d572$export$2e2bcd8739ae039);
    var $7VHMR;
    var $ee3eff355f28d572$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        label: {
            "id": "software-filters.filters.status.label",
            "defaultMessage": "Status"
        }
    });
});
parcelRegister("aMFc7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$119ce63ee3cabcee$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $jZ4fr;
    var $imZsD;
    var $5Fk4Z;
    var $heNNl;
    var $7iJwP;
    var $koVbs;
    var $iXVV6;
    var $5oFIy;
    var $g5X3G;
    var $9pP0g;
    var $iDGXn;
    var $bmKPg;
    var $96s6B;
    var $gfbKZ;
    const $119ce63ee3cabcee$var$VersionFilter = (props)=>{
        const { versions: versions, selectedVersions: selectedVersions, isToggleChecked: isToggleChecked, onTogglePanel: onTogglePanel, isSpotlightEnabled: isSpotlightEnabled, showPanelToggle: showPanelToggle, isNested: isNested, toggleRef: toggleRef, hasMultipleProjects: hasMultipleProjects, isLoading: isLoading } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { toggleViewSetting: toggleViewSetting } = (0, (0, parcelRequire("iDGXn")).useViewSettingsActions)();
        const [boardId] = (0, (0, parcelRequire("bmKPg")).usePathParam)('boardId');
        const values = (0, $5uXOq.useMemo)(()=>versions.map((version)=>({
                    label: version.name,
                    value: String(version.id),
                    subLabel: hasMultipleProjects ? version.projectKey : undefined
                })), [
            versions,
            hasMultipleProjects
        ]);
        const onChange = (0, $5uXOq.useCallback)((entries)=>{
            const analyticAttributes = {
                isNested: isNested
            };
            props.onChange(entries.map(({ value: value })=>value), analyticAttributes);
        }, [
            props,
            isNested
        ]);
        const handleTogglePanel = (0, $5uXOq.useCallback)(()=>{
            if (boardId) toggleViewSetting({
                boardId: Number(boardId),
                setting: (0, (0, parcelRequire("9pP0g")).ViewSetting).VERSION_PANEL
            });
            onTogglePanel();
        }, [
            boardId,
            onTogglePanel,
            toggleViewSetting
        ]);
        const renderContent = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("96s6B")).default), {
                label: formatMessage((0, (0, parcelRequire("gfbKZ")).default).label),
                toggleLabel: formatMessage((0, (0, parcelRequire("gfbKZ")).default).toggleLabel),
                values: values,
                showPanelToggle: showPanelToggle,
                selectedValues: (0, (0, parcelRequire("g5X3G")).toStringArray)(selectedVersions),
                isPanelToggleChecked: isToggleChecked,
                onChange: onChange,
                onTogglePanel: handleTogglePanel,
                noOptionsMessage: formatMessage(values.length === 0 ? (0, (0, parcelRequire("gfbKZ")).default).noUnreleasedVersions : (0, (0, parcelRequire("gfbKZ")).default).noMatchingVersions),
                showMenuIfValuesAreEmpty: true,
                isNested: isNested,
                toggleRef: toggleRef,
                isLoading: isLoading
            }), [
            formatMessage,
            values,
            showPanelToggle,
            selectedVersions,
            isToggleChecked,
            onChange,
            isNested,
            toggleRef,
            handleTogglePanel,
            isLoading
        ]);
        if (isSpotlightEnabled) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("imZsD")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Fk4Z")).default), {
            name: "fusionBacklogVersionsPanel"
        }, renderContent, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jZ4fr")).EngagementSpotlight), {
            engagementId: "fusionBacklogVersionsPanel"
        })));
        return renderContent;
    };
    $119ce63ee3cabcee$var$VersionFilter.displayName = 'VersionFilter';
    $119ce63ee3cabcee$var$VersionFilter.whyDidYouRender = true;
    const $119ce63ee3cabcee$var$ErrorWrapper = (props)=>{
        if (!props.isVersionsFeatureEnabled) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "jira.backlog.version.filter",
            packageName: "jiraFilters"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7iJwP")).default), {
            id: "jira.backlog.version.filter",
            packageName: "jiraFilters"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            sourceName: "versionFilter",
            attributes: {
                isVersionPanelOpen: props.isToggleChecked
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($119ce63ee3cabcee$var$VersionFilter, props), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), null))));
    };
    $119ce63ee3cabcee$var$ErrorWrapper.defaultProps = {
        versions: [],
        selectedVersions: [],
        isToggleChecked: false,
        isSpotlightEnabled: false,
        showPanelToggle: true,
        isVersionsFeatureEnabled: false,
        onChange: (0, ($parcel$interopDefault($8Rkzz))),
        onTogglePanel: (0, ($parcel$interopDefault($8Rkzz))),
        isNested: false
    };
    var $119ce63ee3cabcee$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($119ce63ee3cabcee$var$ErrorWrapper);
});
parcelRegister("gfbKZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3f065e16be4d58f9$export$2e2bcd8739ae039);
    var $7VHMR;
    var $3f065e16be4d58f9$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noUnreleasedVersions: {
            "id": "software-filters.filters.version.no-unreleased-versions",
            "defaultMessage": "No unreleased versions in this project"
        },
        noMatchingVersions: {
            "id": "software-filters.filters.version.no-matching-versions",
            "defaultMessage": "No matching versions"
        },
        label: {
            "id": "software-filters.filters.version.label",
            "defaultMessage": "Version"
        },
        toggleLabel: {
            "id": "software-filters.filters.version.toggle-label",
            "defaultMessage": "Show version panel"
        }
    });
});
parcelRegister("fJnmW", function(module, exports) {
    $parcel$export(module.exports, "FilterBar", ()=>$fcc1c800bf761f9d$export$56a20ec2552ffba2);
    $parcel$export(module.exports, "ListFilterContainerNextGen", ()=>$fcc1c800bf761f9d$export$4a72bd88f9845459);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $7XYc4;
    var $dCm1o;
    const $fcc1c800bf761f9d$export$9ea8cdcfa806101a = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _kqswh2mm _4cvr1h6o _1ul9idpf",
                __cmplp.className
            ])
        });
    });
    const $fcc1c800bf761f9d$export$35dfe29d505ceb8f = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _kqswh2mm _4cvr1h6o _1ul9idpf _zulpu2gc",
                __cmplp.className
            ])
        });
    });
    const $fcc1c800bf761f9d$export$56a20ec2552ffba2 = (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled), $fcc1c800bf761f9d$export$35dfe29d505ceb8f, $fcc1c800bf761f9d$export$9ea8cdcfa806101a);
    const $fcc1c800bf761f9d$export$847557029097218a = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jx1txw _1hftutpp _1uf81b66 _1o94h2mm _79vbb3bt _lpsrstnw _9uwn1ssb _41sd7vkz _be5h1i34 _4amot94y _1omzidpf _1sn01d4u",
                __cmplp.className
            ])
        });
    });
    const $fcc1c800bf761f9d$export$6fe98dc7be67e1c2 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jx1txw _1hftv77o _1uf81b66 _1o94h2mm _yj55idpf",
                __cmplp.className
            ])
        });
    });
    const $fcc1c800bf761f9d$export$595be9b8d0603674 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jx1txw _1o94h2mm _yj55idpf",
                __cmplp.className
            ])
        });
    });
    const $fcc1c800bf761f9d$export$4a72bd88f9845459 = (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled), $fcc1c800bf761f9d$export$595be9b8d0603674, $fcc1c800bf761f9d$export$6fe98dc7be67e1c2);
});
parcelRegister("cTi8P", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e898d158ecdd3c47$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7XluA;
    var $4mO32;
    var $4jAPy;
    var $3Qsxg;
    const $e898d158ecdd3c47$var$AsyncBoardSwitcher = (props)=>{
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("3Qsxg")).syncBoardSwitcher), {});
        (0, $5uXOq.useEffect)(()=>{
            entryPointActions.load();
            return ()=>{
                entryPointActions.unload();
            };
        }, [
            entryPointActions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            id: "plan-increment-board-switcher",
            packageName: (0, (0, parcelRequire("4jAPy")).PACKAGE_NAME),
            teamName: (0, (0, parcelRequire("4jAPy")).ERROR_REPORTING_TEAM),
            entryPointReferenceSubject: entryPointReferenceSubject,
            runtimeProps: props
        });
    };
    var $e898d158ecdd3c47$export$2e2bcd8739ae039 = $e898d158ecdd3c47$var$AsyncBoardSwitcher;
});
parcelRegister("4jAPy", function(module, exports) {
    $parcel$export(module.exports, "SCRUM_TEAM", ()=>$acaa4e836b6925cd$export$103a728db4a941f8);
    $parcel$export(module.exports, "KANBAN_TEAM", ()=>$acaa4e836b6925cd$export$f43662b315e78f32);
    $parcel$export(module.exports, "BOARD_ISSUE_SOURCE", ()=>$acaa4e836b6925cd$export$4c4602fa98384024);
    $parcel$export(module.exports, "SINGLE_CUSTOM_FIELD_TYPE_KEY", ()=>$acaa4e836b6925cd$export$7a7b05cceb7cc8a9);
    $parcel$export(module.exports, "MULTI_CUSTOM_FIELD_TYPE_KEY", ()=>$acaa4e836b6925cd$export$2afd90c3608e7105);
    $parcel$export(module.exports, "SYSTEM_LABEL_FIELD_ID", ()=>$acaa4e836b6925cd$export$84bf4e4e31fe4475);
    $parcel$export(module.exports, "CUSTOM_FIELD_OPTION_MISSED_ERROR", ()=>$acaa4e836b6925cd$export$aa4bdec93afa2924);
    $parcel$export(module.exports, "FILTER_FIELD_ERROR", ()=>$acaa4e836b6925cd$export$a497a01fd14a64af);
    $parcel$export(module.exports, "MAX_ACTIVE_BOARDS", ()=>$acaa4e836b6925cd$export$70493a18b15fa2cc);
    $parcel$export(module.exports, "IP_BOARD_STORY_POINTS_PLANNING_UNIT", ()=>$acaa4e836b6925cd$export$e2ffaae341a16c5e);
    $parcel$export(module.exports, "IP_BOARD_HOURS_PLANNING_UNIT", ()=>$acaa4e836b6925cd$export$9a6e823d5b9e62be);
    $parcel$export(module.exports, "IP_BOARD_DAYS_PLANNING_UNIT", ()=>$acaa4e836b6925cd$export$ad92792f1d38ffba);
    $parcel$export(module.exports, "ERROR_REPORTING_TEAM", ()=>$acaa4e836b6925cd$export$cfeee2ee86ead336);
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$acaa4e836b6925cd$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "SERVICES_ERROR_ID", ()=>$acaa4e836b6925cd$export$7930b6315c134d49);
    $parcel$export(module.exports, "DOC_LINKS", ()=>$acaa4e836b6925cd$export$f8975d2c25cd8c82);
    $parcel$export(module.exports, "IPH_IDS", ()=>$acaa4e836b6925cd$export$253194752488840a);
    $parcel$export(module.exports, "MARK_SYNC_SPRINTS_PREFIX", ()=>$acaa4e836b6925cd$export$c78721cd39b97424);
    $parcel$export(module.exports, "MARK_SYNC_SPRINTS_START", ()=>$acaa4e836b6925cd$export$1bb2633f6c6f66d1);
    $parcel$export(module.exports, "MARK_SYNC_SPRINTS_END", ()=>$acaa4e836b6925cd$export$9583c6ba8c6caee3);
    $parcel$export(module.exports, "BOARD_SCOPE_FILTER_NONE", ()=>$acaa4e836b6925cd$export$f2ee1113933b4540);
    $parcel$export(module.exports, "BOARD_SCOPE_FILTER_LABEL", ()=>$acaa4e836b6925cd$export$3212503575d06ffd);
    $parcel$export(module.exports, "BOARD_SCOPE_FILTER_SINGLE_SELECT", ()=>$acaa4e836b6925cd$export$ba991b7dc2732ca3);
    $parcel$export(module.exports, "BOARD_SCOPE_FILTER_MULTI_SELECT", ()=>$acaa4e836b6925cd$export$df2129225b939441);
    $parcel$export(module.exports, "DEFAULT_ITERATION_LENGTH", ()=>$acaa4e836b6925cd$export$8400d4ac050fc755);
    $parcel$export(module.exports, "DEFAULT_ITERATIONS_COUNT", ()=>$acaa4e836b6925cd$export$b83f977709573647);
    $parcel$export(module.exports, "ITERATIONS_COUNT_OPTIONS", ()=>$acaa4e836b6925cd$export$f16a2b8db5d397c);
    $parcel$export(module.exports, "SWIMLANE_TEAMLESS", ()=>$acaa4e836b6925cd$export$b5d1b5cc4a0cc53c);
    $parcel$export(module.exports, "MAX_SELECTED_ISSUES_FOR_DEPENDENCY_LINES", ()=>$acaa4e836b6925cd$export$ca464ff38a49aee8);
    const $acaa4e836b6925cd$export$103a728db4a941f8 = 'Scrum';
    const $acaa4e836b6925cd$export$f43662b315e78f32 = 'Kanban';
    const $acaa4e836b6925cd$export$4c4602fa98384024 = 'Board';
    const $acaa4e836b6925cd$export$ab08f53e1080ee4f = 'Project';
    const $acaa4e836b6925cd$export$e5b9ed989e245a1a = 'Filter';
    const $acaa4e836b6925cd$export$7a7b05cceb7cc8a9 = 'com.atlassian.jira.plugin.system.customfieldtypes:select';
    const $acaa4e836b6925cd$export$2afd90c3608e7105 = 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect';
    const $acaa4e836b6925cd$export$84bf4e4e31fe4475 = 'labels';
    const $acaa4e836b6925cd$export$aa4bdec93afa2924 = 'CUSTOM_FIELD_OPTION_MISSED';
    const $acaa4e836b6925cd$export$a497a01fd14a64af = {
        NOT_FOUND: 'CUSTOM_FIELD_NOT_FOUND',
        TRASHED: 'CUSTOM_FIELD_TRASHED',
        NOT_IN_PLAN: 'CUSTOM_FIELD_NOT_IN_PLAN',
        OPTION_NOT_FOUND: 'CUSTOM_FIELD_OPTION_NOT_FOUND'
    };
    const $acaa4e836b6925cd$export$70493a18b15fa2cc = 2;
    const $acaa4e836b6925cd$export$e2ffaae341a16c5e = 'StoryPoints';
    const $acaa4e836b6925cd$export$9a6e823d5b9e62be = 'Hours';
    const $acaa4e836b6925cd$export$ad92792f1d38ffba = 'Days';
    const $acaa4e836b6925cd$export$cfeee2ee86ead336 = 'axolotl';
    const $acaa4e836b6925cd$export$b8b9d90f9e5bd72b = 'jiraPortfolio3PlanIncrementCommon';
    const $acaa4e836b6925cd$export$7930b6315c134d49 = 'services';
    const $acaa4e836b6925cd$export$f8975d2c25cd8c82 = {
        PROGRAM_BOARD: 'https://support.atlassian.com/jira-software-cloud/docs/what-is-the-program-board-in-my-plan/',
        LINK_SPRINTS: 'https://support.atlassian.com/jira-software-cloud/docs/add-and-change-sprints-on-the-program-board-in-your-plan/',
        CREATION: 'https://support.atlassian.com/jira-software-cloud/docs/what-does-the-program-board-show/',
        CAPACITY_PLANNING: 'https://support.atlassian.com/jira-software-cloud/docs/enable-capacity-planning-in-advanced-roadmaps/',
        OFFTRACK_DEPENDENCIES: 'https://support.atlassian.com/jira-software-cloud/docs/what-are-dependencies-in-advanced-roadmaps/'
    };
    const $acaa4e836b6925cd$export$253194752488840a = {
        PROGRAM_BOARDS_CREATE: '6gJCMknYvLjnUgKrm4BKIj',
        PROGRAM_BOARDS_SETTINGS: '1pdnvDJUBHtLdAcH6F03rm',
        CAPACITY_PLANNING: '4kDm3TUQ7LwIEubH72m3Gk',
        OFFTRACK_DEPENDENCIES: '2HQv4dgTi14DCpGY1YU2ZF'
    };
    const $acaa4e836b6925cd$export$c78721cd39b97424 = 'plan-increment.sync-sprints:';
    const $acaa4e836b6925cd$export$1bb2633f6c6f66d1 = `${$acaa4e836b6925cd$export$c78721cd39b97424}start`;
    const $acaa4e836b6925cd$export$9583c6ba8c6caee3 = `${$acaa4e836b6925cd$export$c78721cd39b97424}end`;
    const $acaa4e836b6925cd$export$f2ee1113933b4540 = 'none';
    const $acaa4e836b6925cd$export$3212503575d06ffd = 'label';
    const $acaa4e836b6925cd$export$ba991b7dc2732ca3 = 'select';
    const $acaa4e836b6925cd$export$df2129225b939441 = 'multiselect';
    const $acaa4e836b6925cd$export$8400d4ac050fc755 = 2;
    const $acaa4e836b6925cd$export$b83f977709573647 = 6;
    const $acaa4e836b6925cd$export$f16a2b8db5d397c = [
        {
            label: '3',
            value: 3
        },
        {
            label: '4',
            value: 4
        },
        {
            label: '5',
            value: 5
        },
        {
            label: '6',
            value: 6
        },
        {
            label: '7',
            value: 7
        },
        {
            label: '8',
            value: 8
        },
        {
            label: '9',
            value: 9
        },
        {
            label: '10',
            value: 10
        },
        {
            label: '11',
            value: 11
        },
        {
            label: '12',
            value: 12
        },
        {
            label: '13',
            value: 13
        }
    ];
    const $acaa4e836b6925cd$export$b5d1b5cc4a0cc53c = '$teamless$';
    const $acaa4e836b6925cd$export$ca464ff38a49aee8 = 10;
});
parcelRegister("3Qsxg", function(module, exports) {
    $parcel$export(module.exports, "syncBoardSwitcher", ()=>$afceff36abed190f$export$e13b401cdb60e3ed);
    var $eufEc;
    var $fEDBv;
    const $afceff36abed190f$export$e13b401cdb60e3ed = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("g0sLo")).then((module)=>module.AsyncBoardSwitcher), {
            moduleId: "2623f17b"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("g0sLo", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("exBMr")
    ]).then(()=>parcelRequire('2C9Uz'));
});
parcelRegister("gtgKk", function(module, exports) {
    $parcel$export(module.exports, "CollabContainerAsync", ()=>$d8b06fe481f4b829$export$69b83fdf5027068d);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $lfTZh;
    var $kxZPA;
    const $d8b06fe481f4b829$var$LazyCollabContainer = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("hSq0e")).then(({ CollabContainer: CollabContainer })=>CollabContainer), {
        moduleId: "./src/packages/software/real-time-presence/src/controllers/collab/index.tsx"
    });
    const $d8b06fe481f4b829$export$69b83fdf5027068d = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "async-jira-software-real-time-presence",
            packageName: "jiraSoftwareRealtimePresence",
            teamName: "jira-werewolves",
            fallback: "flag"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "software-real-time-presence",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($d8b06fe481f4b829$var$LazyCollabContainer, props)));
});
parcelRegister("hSq0e", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("7IZwQ")
    ]).then(()=>parcelRequire('cwA3d'));
});
parcelRegister("8vjSE", function(module, exports) {
    $parcel$export(module.exports, "useCollabStore", ()=>$4e59b4cbd57cc99d$export$4159ae80cfa2156);
    var $3JOCw = parcelRequire("3JOCw");
    var $3sQ5x;
    var $iXqE5;
    const $4e59b4cbd57cc99d$var$updateUserInParticipants = (user)=>({ getState: getState, setState: setState })=>{
            const state = getState();
            setState({
                ...state,
                participants: state.participants.map((participant)=>{
                    if (participant.clientId === user.userId) return {
                        ...participant,
                        avatar: user.avatar,
                        name: user.name,
                        email: user.email
                    };
                    return participant;
                })
            });
        };
    const $4e59b4cbd57cc99d$var$participantsJoined = (joined)=>({ getState: getState, setState: setState })=>{
            const uniqueJoined = (0, ($parcel$interopDefault($3JOCw)))(joined, ({ sessionId: sessionId })=>sessionId);
            const newParticipantSessionIds = uniqueJoined.map(({ sessionId: sessionId })=>sessionId);
            const state = getState();
            const { provider: provider } = state;
            const newParticipants = [
                ...state.participants.filter(({ sessionId: sessionId })=>!newParticipantSessionIds.includes(sessionId)),
                ...uniqueJoined
            ];
            if (newParticipants.length >= (0, $4123025face0353e$export$3debf01bbfa135e5) && provider) {
                const sortedUsers = newParticipants.sort((userA, userB)=>userA.lastActive > userB.lastActive ? 1 : -1);
                const currentUser = sortedUsers.find((user)=>user.sessionId === provider.sessionId);
                const lastActiveUser = sortedUsers[sortedUsers.length - 1];
                setState({
                    ...state,
                    participants: newParticipants.filter(({ sessionId: sessionId })=>sessionId !== lastActiveUser.sessionId)
                });
                if (lastActiveUser.sessionId === currentUser?.sessionId) provider.destroy();
                return;
            }
            setState({
                ...state,
                participants: newParticipants
            });
        };
    const $4e59b4cbd57cc99d$var$participantsLeft = (left)=>({ getState: getState, setState: setState })=>{
            const leftSessionIds = left.map(({ sessionId: sessionId })=>sessionId);
            const state = getState();
            const newSelection = {};
            Object.keys(state.nodeSelection).forEach((nodeIdKey)=>{
                const selections = state.nodeSelection[nodeIdKey];
                if (selections.length > 0) {
                    const filteredSelections = selections.filter((selection)=>!leftSessionIds.includes(selection.sessionId));
                    if (filteredSelections.length === 0) return;
                    newSelection[nodeIdKey] = filteredSelections;
                }
            });
            setState({
                ...state,
                participants: state.participants.filter(({ sessionId: sessionId })=>!leftSessionIds.includes(sessionId)),
                nodeSelection: newSelection
            });
        };
    const $4e59b4cbd57cc99d$var$setProvider = (provider)=>({ getState: getState, setState: setState })=>setState({
                ...getState(),
                provider: provider
            });
    const $4e59b4cbd57cc99d$var$sendNodeSelected = ({ nodeId: nodeId })=>({ getState: getState })=>{
            if (nodeId == null) return;
            const { provider: provider, participants: participants } = getState();
            if (participants.length <= 1) return;
            if (provider) provider.sendMessage({
                type: 'telepointer',
                sessionId: provider.sessionId,
                selection: {
                    type: 'nodeSelection',
                    anchor: JSON.stringify({
                        nodeId: nodeId
                    })
                }
            });
        };
    const $4e59b4cbd57cc99d$var$sendClearNodeSelection = ({ nodeId: nodeId, dropParams: dropParams })=>({ getState: getState })=>{
            if (nodeId == null) return;
            const { provider: provider, participants: participants } = getState();
            if (participants.length <= 1) return;
            if (provider) provider.sendMessage({
                type: 'telepointer',
                sessionId: provider.sessionId,
                selection: {
                    type: 'nodeSelection',
                    head: JSON.stringify({
                        nodeId: nodeId,
                        dropParams: dropParams
                    })
                }
            });
        };
    const $4e59b4cbd57cc99d$var$setNodeSelection = ({ nodeId: nodeId, sessionId: sessionId, user: user })=>({ setState: setState, getState: getState })=>{
            const newSelection = {
                nodeId: nodeId,
                user: user,
                sessionId: sessionId
            };
            const state = getState();
            const dedupCurrentSelection = state.nodeSelection[nodeId] && state.nodeSelection[nodeId].filter((selection)=>selection.user.userId !== user.userId);
            const nodeSelection = dedupCurrentSelection ? [
                ...dedupCurrentSelection,
                newSelection
            ] : [
                newSelection
            ];
            const dedupOtherSelections = {};
            Object.keys(state.nodeSelection).forEach((nodeIdKey)=>{
                const selections = state.nodeSelection[nodeIdKey];
                if (selections.length > 0) {
                    const filteredSelections = selections.filter((selection)=>selection.user.userId !== user.userId);
                    if (filteredSelections.length === 0) return;
                    dedupOtherSelections[nodeIdKey] = filteredSelections;
                }
            });
            setState({
                ...state,
                nodeSelection: {
                    ...dedupOtherSelections,
                    [nodeId]: nodeSelection
                }
            });
        };
    const $4e59b4cbd57cc99d$var$clearNodeSelection = ({ nodeId: nodeId, dropParams: dropParams, userId: userId })=>({ setState: setState, getState: getState })=>{
            const state = getState();
            const newNodeSelection = {};
            Object.keys(state.nodeSelection).forEach((nodeIdKey)=>{
                if (nodeIdKey !== nodeId) newNodeSelection[nodeIdKey] = state.nodeSelection[nodeIdKey];
            });
            setState({
                ...state,
                nodeSelection: newNodeSelection,
                dragAnimation: dropParams && userId != null ? [
                    ...state.dragAnimation,
                    {
                        ...dropParams,
                        userId: userId
                    }
                ] : state.dragAnimation
            });
        };
    const $4e59b4cbd57cc99d$var$stopDragAnimation = ({ sourceNodeId: sourceNodeId })=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                dragAnimation: state.dragAnimation.filter((animation)=>String(animation.sourceNodeId) !== String(sourceNodeId))
            });
        };
    const $4e59b4cbd57cc99d$var$actions = {
        setProvider: $4e59b4cbd57cc99d$var$setProvider,
        participantsLeft: $4e59b4cbd57cc99d$var$participantsLeft,
        participantsJoined: $4e59b4cbd57cc99d$var$participantsJoined,
        updateUserInParticipants: $4e59b4cbd57cc99d$var$updateUserInParticipants,
        sendNodeSelected: $4e59b4cbd57cc99d$var$sendNodeSelected,
        sendClearNodeSelection: $4e59b4cbd57cc99d$var$sendClearNodeSelection,
        setNodeSelection: $4e59b4cbd57cc99d$var$setNodeSelection,
        clearNodeSelection: $4e59b4cbd57cc99d$var$clearNodeSelection,
        stopDragAnimation: $4e59b4cbd57cc99d$var$stopDragAnimation
    };
    const $4e59b4cbd57cc99d$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            provider: null,
            participants: [],
            nodeSelection: {},
            dragAnimation: []
        },
        actions: $4e59b4cbd57cc99d$var$actions,
        name: 'JSWCollabStore'
    });
    const $4e59b4cbd57cc99d$export$4159ae80cfa2156 = (0, (0, parcelRequire("3sQ5x")).createHook)($4e59b4cbd57cc99d$var$Store);
});
const $4123025face0353e$export$3debf01bbfa135e5 = 80;
parcelRegister("2xSAL", function(module, exports) {
    $parcel$export(module.exports, "SearchField", ()=>$f115db1c327fbbaa$export$b94867ecbd698f21);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $fW62l = parcelRequire("fW62l");
    var $2NMNM;
    var $kY99m;
    var $koVbs;
    var $dCm1o;
    var $cBssJ;
    var $hJBhl;
    var $5yLnO;
    const $f115db1c327fbbaa$var$className = 'ajs-dirty-warning-exempt';
    const $f115db1c327fbbaa$var$SearchFieldUnmemoized = ({ onEnter: onEnter, onChange: onChange, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder = '', inputRef: inputRef, value: externalValue, autoFocus: autoFocus = false, isCompact: isCompact = false, isDisabled: isDisabled = false, shouldFitContainerWidth: shouldFitContainerWidth = false, isAutocompleteDisabled: isAutocompleteDisabled = false, placeholderAlwaysVisible: placeholderAlwaysVisible = false, searchIconVisible: searchIconVisible = true, isAlwaysExpanded: isAlwaysExpanded = false, increasedWidth: increasedWidth = false, maxLength: maxLength, describedById: describedById = '', ariaLabelText: ariaLabelText, id: id, renderCustomSearchField: renderCustomSearchField, searchIconPrimaryColor: searchIconPrimaryColor, testId: testId, inputProps: inputProps = {}, isResponsive: isResponsive = false, showIconBeforeInput: showIconBeforeInput = false })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [isFocused, setIsFocused] = (0, $5uXOq.useState)(false);
        const [value, setValue] = (0, $5uXOq.useState)(externalValue || '');
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const textInput = (0, $5uXOq.useRef)(null);
        const previousValueRef = (0, $5uXOq.useRef)();
        const previousValue = previousValueRef.current;
        if (externalValue !== previousValue && externalValue !== value) setValue(externalValue);
        previousValueRef.current = externalValue;
        const handleOnFocus = (0, $5uXOq.useCallback)((event)=>{
            setIsFocused(true);
            onFocus && onFocus(event);
        }, [
            onFocus
        ]);
        const handleOnBlur = (0, $5uXOq.useCallback)((event)=>{
            onBlur && onBlur(event);
            setIsFocused(false);
        }, [
            onBlur
        ]);
        const handleOnChange = (0, $5uXOq.useCallback)(({ currentTarget: currentTarget })=>{
            const { value: val } = currentTarget;
            const analyticsEvent = createAnalyticsEvent({
                action: 'changed'
            });
            setValue(val);
            onChange(val, analyticsEvent);
        }, [
            createAnalyticsEvent,
            onChange
        ]);
        const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'changed'
            });
            if (event.key === 'Escape') {
                setValue('');
                onChange('', analyticsEvent);
            }
            if (onEnter && event.keyCode === (0, ($parcel$interopDefault($fW62l)))('enter')) {
                event.preventDefault();
                onEnter(event.currentTarget && event.currentTarget.value);
            }
        }, [
            createAnalyticsEvent,
            onChange,
            onEnter
        ]);
        const handleOnClear = (0, $5uXOq.useCallback)(()=>{
            if (value !== '') {
                const analyticsEvent = createAnalyticsEvent({
                    action: 'changed'
                });
                setValue('');
                onChange('', analyticsEvent);
            }
            if (inputRef && inputRef.current !== null) inputRef.current.blur();
            if (textInput.current !== null) textInput.current.blur();
        }, [
            createAnalyticsEvent,
            inputRef,
            onChange,
            value
        ]);
        const isExpanded = isFocused || value !== '' || isAlwaysExpanded;
        const textFieldProps = {
            ...inputProps,
            'aria-label': ariaLabelText || placeholder || formatMessage((0, (0, parcelRequire("cBssJ")).messages).search),
            'aria-describedby': describedById,
            type: 'text',
            'data-test-id': 'searchfield',
            testId: testId ?? 'searchfield',
            name: 'search',
            className: $f115db1c327fbbaa$var$className,
            placeholder: placeholder,
            onFocus: handleOnFocus,
            onBlur: handleOnBlur,
            width: '120px',
            onChange: handleOnChange,
            onKeyDown: handleKeyDown,
            ref: inputRef || textInput,
            isCompact: isCompact,
            autoFocus: autoFocus,
            autoComplete: isAutocompleteDisabled ? 'off' : 'on',
            value: value,
            maxLength: maxLength,
            isDisabled: isDisabled
        };
        const searchIconDynamic = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5yLnO")).SearchFieldIconDynamic), {
            onClear: handleOnClear,
            hasValue: value !== '',
            clearIconLabel: formatMessage((0, (0, parcelRequire("cBssJ")).messages).clear),
            searchIconVisible: searchIconVisible,
            primaryColor: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? undefined : searchIconPrimaryColor,
            onlyIconSpacing: isResponsive && !isExpanded
        });
        const searchIcon = showIconBeforeInput ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5yLnO")).SearchFieldIcon), {
            searchIconVisible: searchIconVisible,
            onlyIconSpacing: isResponsive && !isExpanded
        }) : undefined;
        const clearIcon = showIconBeforeInput && value !== '' ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hJBhl")).ClearFieldIcon), {
            onClear: handleOnClear,
            clearIconLabel: formatMessage((0, (0, parcelRequire("cBssJ")).messages).clear)
        }) : undefined;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($f115db1c327fbbaa$var$Container, {
            shouldFitContainerWidth: shouldFitContainerWidth
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($f115db1c327fbbaa$var$InputWrapper, {
            isExpanded: isExpanded,
            shouldFitContainerWidth: shouldFitContainerWidth,
            increasedWidth: increasedWidth,
            maxWidth: increasedWidth ? 328 : 184,
            placeholderAlwaysVisible: placeholderAlwaysVisible,
            isResponsive: isResponsive
        }, renderCustomSearchField !== undefined ? renderCustomSearchField({
            textFieldProps: textFieldProps,
            searchIcon: searchIconDynamic
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kY99m")).default), {
            ...textFieldProps,
            elemBeforeInput: searchIcon,
            elemAfterInput: !showIconBeforeInput ? searchIconDynamic : clearIcon,
            ...id !== undefined ? {
                id: id
            } : {}
        })));
    };
    $f115db1c327fbbaa$var$SearchFieldUnmemoized.displayName = 'Search';
    $f115db1c327fbbaa$var$SearchFieldUnmemoized.whyDidYouRender = true;
    const $f115db1c327fbbaa$export$b94867ecbd698f21 = (0, $5uXOq.memo)($f115db1c327fbbaa$var$SearchFieldUnmemoized);
    $f115db1c327fbbaa$export$b94867ecbd698f21.displayName = 'Search';
    const $f115db1c327fbbaa$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { shouldFitContainerWidth: shouldFitContainerWidth, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw",
                __cmplp.shouldFitContainerWidth && "_1bsb1osq",
                __cmplp.className
            ])
        });
    });
    const $f115db1c327fbbaa$var$InputWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { placeholderAlwaysVisible: placeholderAlwaysVisible, isResponsive: isResponsive, maxWidth: maxWidth, isExpanded: isExpanded, shouldFitContainerWidth: shouldFitContainerWidth, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1et2rhb": (0, (0, parcelRequire("lD23V")).default)(__cmplp.maxWidth, "px"),
                "--_47juog": (0, (0, parcelRequire("lD23V")).default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '30px'),
                "--_5cv8rq": (0, (0, parcelRequire("lD23V")).default)(__cmplp.isExpanded ? 'auto' : '32px'),
                "--_jy5l88": (0, (0, parcelRequire("lD23V")).default)(__cmplp.isExpanded ? `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}` : "var(--ds-space-0, 0px)"),
                "--_1skyi4s": (0, (0, parcelRequire("lD23V")).default)(__cmplp.isExpanded ? 'auto' : 0),
                "--_1qenfck": (0, (0, parcelRequire("lD23V")).default)(__cmplp.isExpanded ? 1 : 0),
                "--_1b7586u": (0, (0, parcelRequire("lD23V")).default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '120px'),
                "--_1b72lxu": (0, (0, parcelRequire("lD23V")).default)(__cmplp.shouldFitContainerWidth ? '100%' : `${__cmplp.isExpanded ? __cmplp.maxWidth : 120}px`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _v564zpk5 _166qglyw _101ad2bq _i2ybkb7n",
                __cmplp.placeholderAlwaysVisible ? "_lav0kb7n" : "_lav0idpf",
                __cmplp.isResponsive ? "_1bsb1ayu _1s4pflvl _1kneabdv _odci1sf5 _wngi16hp _5xde1wic _1hr27bcq" : "_1bsb1di6",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("fW62l", function(module, exports) {
    function keyCode(searchInput) {
        if (searchInput && 'object' === typeof searchInput) {
            var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode;
            if (hasKeyCode) searchInput = hasKeyCode;
        }
        if ('number' === typeof searchInput) return names[searchInput];
        var search = String(searchInput);
        var foundNamedKey = codes[search.toLowerCase()];
        if (foundNamedKey) return foundNamedKey;
        var foundNamedKey = aliases[search.toLowerCase()];
        if (foundNamedKey) return foundNamedKey;
        if (search.length === 1) return search.charCodeAt(0);
        return undefined;
    }
    keyCode.isEventKey = function isEventKey(event, nameOrCode) {
        if (event && 'object' === typeof event) {
            var keyCode = event.which || event.keyCode || event.charCode;
            if (keyCode === null || keyCode === undefined) return false;
            if (typeof nameOrCode === 'string') {
                var foundNamedKey = codes[nameOrCode.toLowerCase()];
                if (foundNamedKey) return foundNamedKey === keyCode;
                var foundNamedKey = aliases[nameOrCode.toLowerCase()];
                if (foundNamedKey) return foundNamedKey === keyCode;
            } else if (typeof nameOrCode === 'number') return nameOrCode === keyCode;
            return false;
        }
    };
    exports = module.exports = keyCode;
    var codes = exports.code = exports.codes = {
        'backspace': 8,
        'tab': 9,
        'enter': 13,
        'shift': 16,
        'ctrl': 17,
        'alt': 18,
        'pause/break': 19,
        'caps lock': 20,
        'esc': 27,
        'space': 32,
        'page up': 33,
        'page down': 34,
        'end': 35,
        'home': 36,
        'left': 37,
        'up': 38,
        'right': 39,
        'down': 40,
        'insert': 45,
        'delete': 46,
        'command': 91,
        'left command': 91,
        'right command': 93,
        'numpad *': 106,
        'numpad +': 107,
        'numpad -': 109,
        'numpad .': 110,
        'numpad /': 111,
        'num lock': 144,
        'scroll lock': 145,
        'my computer': 182,
        'my calculator': 183,
        ';': 186,
        '=': 187,
        ',': 188,
        '-': 189,
        '.': 190,
        '/': 191,
        '`': 192,
        '[': 219,
        '\\': 220,
        ']': 221,
        "'": 222
    };
    var aliases = exports.aliases = {
        'windows': 91,
        "\u21E7": 16,
        "\u2325": 18,
        "\u2303": 17,
        "\u2318": 91,
        'ctl': 17,
        'control': 17,
        'option': 18,
        'pause': 19,
        'break': 19,
        'caps': 20,
        'return': 13,
        'escape': 27,
        'spc': 32,
        'spacebar': 32,
        'pgup': 33,
        'pgdn': 34,
        'ins': 45,
        'del': 46,
        'cmd': 91
    };
    for(i = 97; i < 123; i++)codes[String.fromCharCode(i)] = i - 32;
    for(var i = 48; i < 58; i++)codes[i - 48] = i;
    for(i = 1; i < 13; i++)codes['f' + i] = i + 111;
    for(i = 0; i < 10; i++)codes['numpad ' + i] = i + 96;
    var names = exports.names = exports.title = {};
    for(i in codes)names[codes[i]] = i;
    for(var alias in aliases)codes[alias] = aliases[alias];
});
parcelRegister("cBssJ", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$08273d4fc2a6d6da$export$defe85febe8b728c);
    var $7VHMR;
    const $08273d4fc2a6d6da$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        clear: {
            "id": "searchfield.clear",
            "defaultMessage": "Clear"
        },
        search: {
            "id": "searchfield.search",
            "defaultMessage": "Search"
        }
    });
});
parcelRegister("hJBhl", function(module, exports) {
    $parcel$export(module.exports, "ClearFieldIcon", ()=>$99940a7c159b00c0$export$84038b503874befa);
    var $5uXOq = parcelRequire("5uXOq");
    var $42CjB;
    var $i28qQ;
    var $dC5iT;
    var $h9kUS;
    var $8CUq3;
    const $99940a7c159b00c0$export$84038b503874befa = ({ onClear: onClear, clearIconLabel: clearIconLabel })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $99940a7c159b00c0$var$wrapperStylesCloseIcon
            ]
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
            appearance: "subtle",
            testId: "searchfield.ui.clearfield-icon.clear-button",
            onClick: onClear,
            label: clearIconLabel,
            spacing: "compact",
            icon: (0, ($parcel$interopDefault((0, parcelRequire("i28qQ")))))
        }));
    const $99940a7c159b00c0$var$wrapperStylesCloseIcon = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        marginRight: 'space.025',
        [(0, (0, parcelRequire("h9kUS")).media).above.md]: {
            marginRight: 'space.050'
        }
    });
});
parcelRegister("5yLnO", function(module, exports) {
    $parcel$export(module.exports, "SearchFieldIconDynamic", ()=>$71cc18983db63a0d$export$9eef03e91cdeba14);
    $parcel$export(module.exports, "SearchFieldIcon", ()=>$71cc18983db63a0d$export$8a82bff895521bd9);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $84THj;
    var $26g7Y;
    var $hyOJh;
    var $dC5iT;
    var $h9kUS;
    var $8CUq3;
    const $71cc18983db63a0d$export$9eef03e91cdeba14 = ({ onClear: onClear, hasValue: hasValue, searchIconVisible: searchIconVisible, clearIconLabel: clearIconLabel, primaryColor: primaryColor, onlyIconSpacing: onlyIconSpacing = false })=>{
        const akSearchIcon = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("26g7Y"))))), {
            LEGACY_size: "small",
            label: "",
            LEGACY_primaryColor: primaryColor,
            color: "currentColor"
        });
        const searchIcon = searchIconVisible ? akSearchIcon : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $71cc18983db63a0d$var$wrapperStyles,
                onlyIconSpacing && $71cc18983db63a0d$var$spacingStyles
            ]
        }, hasValue ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "subtle",
            spacing: "none",
            "data-test-id": "searchfield.ui.searchfield-icon.clear-button",
            testId: "searchfield.ui.searchfield-icon.clear-button",
            onClick: onClear,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("84THj"))))), {
                LEGACY_size: "small",
                label: clearIconLabel,
                LEGACY_primaryColor: primaryColor,
                color: "currentColor"
            })
        }) : searchIcon);
    };
    const $71cc18983db63a0d$export$8a82bff895521bd9 = ({ searchIconVisible: searchIconVisible, onlyIconSpacing: onlyIconSpacing = false })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $71cc18983db63a0d$var$wrapperStylesBefore,
                onlyIconSpacing && $71cc18983db63a0d$var$spacingStylesBefore
            ]
        }, searchIconVisible ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("hyOJh"))))), {
            spacing: "none",
            label: "",
            color: "var(--ds-icon, #44546F)"
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null));
    const $71cc18983db63a0d$var$wrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.text.accent.gray',
        marginTop: 'space.0',
        marginRight: 'space.100',
        marginBottom: 'space.0',
        marginLeft: 'space.0',
        height: '16px',
        display: 'flex'
    });
    const $71cc18983db63a0d$var$spacingStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginRight: 'space.075',
        [(0, (0, parcelRequire("h9kUS")).media).above.md]: {
            marginRight: 'space.100'
        }
    });
    const $71cc18983db63a0d$var$wrapperStylesBefore = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        marginRight: 'space.0',
        marginLeft: 'space.075',
        [(0, (0, parcelRequire("h9kUS")).media).above.md]: {
            marginLeft: 'space.100'
        }
    });
    const $71cc18983db63a0d$var$spacingStylesBefore = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginLeft: 'space.075',
        [(0, (0, parcelRequire("h9kUS")).media).above.md]: {
            marginLeft: 'space.100'
        }
    });
});
parcelRegister("fUHZ2", function(module, exports) {
    $parcel$export(module.exports, "useShortcutAnalytics", ()=>$a45625fee4d71e0e$export$cd482f0b72849b2c);
    var $5uXOq = parcelRequire("5uXOq");
    var $2NMNM;
    var $8zOmE;
    const $a45625fee4d71e0e$export$56c266726b07692d = (createAnalyticsEvent, { id: id, key: key, attributes: attributes }, shortcutSource)=>{
        const attrs = {
            ...attributes,
            key: key,
            shortcutSource: shortcutSource,
            nextGenProject: true
        };
        (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
            action: 'pressed',
            actionSubject: 'keyboardShortcut'
        }), id, attrs);
    };
    const $a45625fee4d71e0e$export$cd482f0b72849b2c = (shortcutSource)=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const fireAnalytics = (0, $5uXOq.useCallback)((payload)=>{
            $a45625fee4d71e0e$export$56c266726b07692d(createAnalyticsEvent, payload, shortcutSource);
        }, [
            createAnalyticsEvent,
            shortcutSource
        ]);
        return fireAnalytics;
    };
});
parcelRegister("cM4EP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$93fab47741ff1022$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $iqr2y;
    var $kobfu;
    var $fZneA;
    var $lfTZh;
    var $8zOmE;
    var $5oFIy;
    var $2NMNM;
    var $5a0Nh;
    var $7Oku1;
    class $93fab47741ff1022$export$876b3e4acf4df22c extends (0, $5uXOq.Component) {
        static{
            this.getDerivedStateFromError = (error)=>({
                    error: error,
                    isRelayValidationError: (0, (0, parcelRequire("7Oku1")).isRelayValidationError)(error)
                });
        }
        static getDerivedStateFromProps({ customFiltersQueryRef: customFiltersQueryRef }, state) {
            if (state.error && !state.aggErrors && customFiltersQueryRef) {
                const capturedGQLErrorsInfo = (0, (0, parcelRequire("5a0Nh")).stopCaptureGraphQlErrors)(customFiltersQueryRef.fetchKey.toString());
                const validGQLErrorsInfo = capturedGQLErrorsInfo.find((err)=>err.meta.operationName === customFiltersQueryRef.name);
                if (validGQLErrorsInfo?.errors.length) return {
                    ...state,
                    aggErrors: validGQLErrorsInfo.errors,
                    aggErrorsMeta: validGQLErrorsInfo.meta
                };
            }
            return null;
        }
        constructor(props){
            super(props);
            this.state = {
                error: null,
                aggErrors: null,
                aggErrorsMeta: null,
                isRelayValidationError: false
            };
        }
        getCommonErrorAttributes(error) {
            return {
                task: 'loadCustomFilters',
                screenName: this.props.screenName,
                isNetworkError: false,
                isRelayValidationError: this.state.isRelayValidationError,
                hash: (0, (0, parcelRequire("kobfu")).getErrorHash)(error) ?? '',
                errorMessage: error.message,
                stack: error.stack
            };
        }
        render() {
            const { error: error, aggErrors: aggErrors, aggErrorsMeta: aggErrorsMeta, isRelayValidationError: isRelayValidationError } = this.state;
            const { children: children } = this.props;
            if (!error) return children;
            if (aggErrors?.length) {
                const aggError = new (0, (0, parcelRequire("7Oku1")).AGGErrors)(aggErrors, aggErrorsMeta?.requestId);
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireOperationalAnalytics), {
                    eventName: "ui taskFail",
                    attributes: {
                        traceId: aggError.traceId,
                        statusCode: aggError.statusCode,
                        ...this.getCommonErrorAttributes(aggError)
                    }
                }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqr2y")).ErrorFlagRenderer), {
                    id: "custom-filter-dropdown",
                    error: aggError
                }));
            }
            if (isRelayValidationError) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireOperationalAnalytics), {
                eventName: "ui taskFail",
                attributes: {
                    ...this.getCommonErrorAttributes(error)
                }
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqr2y")).ErrorFlagRenderer), {
                id: "custom-filter-dropdown",
                error: error
            }));
            throw error;
        }
    }
    const $93fab47741ff1022$var$CustomFilterBoundary = (props)=>{
        const { children: children, screenName: screenName } = props;
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const onError = (_, error)=>{
            (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'ui taskFail', {
                screenName: screenName,
                task: 'loadCustomFilters',
                isNetworkError: (0, (0, parcelRequire("fZneA")).isClientFetchError)(error),
                hash: (0, (0, parcelRequire("kobfu")).getErrorHash)(error) ?? '',
                errorMessage: error.message
            });
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "custom-filter-dropdown",
            packageName: "software-filters",
            teamName: "a4t-tanuki",
            fallback: "flag",
            extraEventData: {
                screenName: screenName
            },
            onError: onError
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($93fab47741ff1022$export$876b3e4acf4df22c, props, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "custom-filter-boundary",
            fallback: null
        }, children)));
    };
    var $93fab47741ff1022$export$2e2bcd8739ae039 = $93fab47741ff1022$var$CustomFilterBoundary;
});
parcelRegister("7Oku1", function(module, exports) {
    $parcel$export(module.exports, "isRelayValidationError", ()=>$8940bd8b67d2f481$export$f450dbe0abffdade);
    $parcel$export(module.exports, "AGGErrors", ()=>$8940bd8b67d2f481$export$60d8267243755b9c);
    var $ht021;
    const $8940bd8b67d2f481$export$321834dc4377cb7 = 'Relay: Missing @required value at path';
    const $8940bd8b67d2f481$export$f450dbe0abffdade = (error)=>error.message.includes($8940bd8b67d2f481$export$321834dc4377cb7);
    class $8940bd8b67d2f481$export$60d8267243755b9c extends (0, (0, parcelRequire("ht021")).default) {
        constructor(errors, traceId){
            super(errors[0].message, {
                cause: errors[0]
            });
            this.name = 'AGGError';
            this.graphQLErrors = errors;
            this.traceId = traceId;
            this.statusCode = errors[0].extensions?.statusCode ?? undefined;
        }
    }
});
parcelRegister("2FvdY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fb1987110dd76b24$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8zOmE;
    var $2NMNM;
    var $dF9Z3;
    const $fb1987110dd76b24$var$HijackBrowserDefaultSearch = ({ onFocusSearch: onFocusSearch, isAnyModalOpen: isAnyModalOpen = false })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const onGlobalSearch = (0, $5uXOq.useCallback)(({ event: event })=>{
            if (isAnyModalOpen) return;
            event.preventDefault();
            onFocusSearch();
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'hijackBrowserDefaultSearch triggered');
        }, [
            createAnalyticsEvent,
            isAnyModalOpen,
            onFocusSearch
        ]);
        (0, (0, parcelRequire("dF9Z3")).useGlobalSearch)(onGlobalSearch);
        return null;
    };
    var $fb1987110dd76b24$export$2e2bcd8739ae039 = $fb1987110dd76b24$var$HijackBrowserDefaultSearch;
});
parcelRegister("dF9Z3", function(module, exports) {
    $parcel$export(module.exports, "isMacOS", ()=>$3300b05877fade72$export$6159e43e50a41987);
    $parcel$export(module.exports, "useGlobalSearch", ()=>$3300b05877fade72$export$1df85516f1b3e335);
    $parcel$export(module.exports, "default", ()=>$3300b05877fade72$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fW62l = parcelRequire("fW62l");
    var $8zOmE;
    var $2NMNM;
    const $3300b05877fade72$export$6159e43e50a41987 = ()=>Boolean(navigator && /^Mac/.test(navigator.platform));
    const $3300b05877fade72$export$1df85516f1b3e335 = (callback, getGlobalDocument = ()=>document)=>{
        (0, $5uXOq.useEffect)(()=>{
            const trackGlobalSearch = (event)=>{
                const isMacOs = $3300b05877fade72$export$6159e43e50a41987();
                if (isMacOs && event.keyCode === (0, ($parcel$interopDefault($fW62l)))('f') && event.metaKey || !isMacOs && event.keyCode === (0, ($parcel$interopDefault($fW62l)))('f') && event.ctrlKey) callback({
                    isMacOs: isMacOs,
                    event: event
                });
            };
            getGlobalDocument().addEventListener('keydown', trackGlobalSearch);
            return ()=>getGlobalDocument().removeEventListener('keydown', trackGlobalSearch);
        }, [
            callback,
            getGlobalDocument
        ]);
    };
    const $3300b05877fade72$var$GlobalSearchTracker = ({ getGlobalDocument: getGlobalDocument = ()=>document, fireAnalytics: fireAnalytics = (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics), analyticsAttributes: analyticsAttributes = {} })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const onGlobalSearch = (0, $5uXOq.useCallback)(({ isMacOs: isMacOs })=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'triggered',
                actionSubject: 'globalSearch'
            });
            const attributes = {
                ...analyticsAttributes,
                isMacOs: isMacOs
            };
            fireAnalytics(analyticsEvent, 'globalSearch triggered', attributes);
        }, [
            analyticsAttributes,
            createAnalyticsEvent,
            fireAnalytics
        ]);
        $3300b05877fade72$export$1df85516f1b3e335(onGlobalSearch, getGlobalDocument);
        return null;
    };
    var $3300b05877fade72$export$2e2bcd8739ae039 = $3300b05877fade72$var$GlobalSearchTracker;
});
parcelRegister("kH9yv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$333f125f896ef4d8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $5ujeO;
    var $k6T4f;
    var $dC5iT;
    var $6s1PB;
    var $ousew;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $dF9Z3;
    var $ew9g5;
    var $gtlfw;
    const $333f125f896ef4d8$var$SearchFilterChangeboarding = ({ children: children, hijackBrowserDefaultSearch: hijackBrowserDefaultSearch = false, screenName: screenName, isCompanyManaged: isCompanyManaged = false })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [isVisible, setIsVisible] = (0, $5uXOq.useState)(false);
        const hasShown = (0, $5uXOq.useRef)(false);
        const onGlobalSearch = (0, $5uXOq.useCallback)(()=>{
            if (!hasShown.current) {
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'searchFilterChangeboarding shown', {
                    isHijackBrowserDefaultSearchEnabled: hijackBrowserDefaultSearch
                });
                setIsVisible(true);
                hasShown.current = true;
                if (screenName === 'backlog' || screenName === 'board' || screenName === 'roadmap') (0, (0, parcelRequire("ew9g5")).setUserSeenSearchFieldChangeboarding)(screenName);
            }
        }, [
            createAnalyticsEvent,
            hijackBrowserDefaultSearch,
            screenName
        ]);
        const onDismiss = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'searchFilterChangeboarding dismissed', {
                isHijackBrowserDefaultSearchEnabled: hijackBrowserDefaultSearch
            });
            setIsVisible(false);
        }, [
            createAnalyticsEvent,
            hijackBrowserDefaultSearch
        ]);
        const actions = (0, $5uXOq.useMemo)(()=>[
                {
                    text: formatMessage((0, (0, parcelRequire("gtlfw")).default).changeboardingConfirmButton),
                    onClick: onDismiss
                }
            ], [
            formatMessage,
            onDismiss
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const getUserSeenSearchFieldChangeboarding = async ()=>{
                if (screenName === 'backlog' || screenName === 'board' || screenName === 'roadmap') {
                    const seen = await (0, (0, parcelRequire("ew9g5")).hasUserSeenSearchFieldChangeboarding)(createAnalyticsEvent({}), screenName);
                    if (seen) hasShown.current = true;
                }
            };
            getUserSeenSearchFieldChangeboarding();
        }, [
            createAnalyticsEvent,
            hijackBrowserDefaultSearch,
            screenName
        ]);
        const changeBoardingMessage = ()=>{
            const ctrlKey = (0, (0, parcelRequire("dF9Z3")).isMacOS)() ? (0, ($parcel$interopDefault($5uXOq))).createElement($333f125f896ef4d8$var$Code, null, "Cmnd") : (0, ($parcel$interopDefault($5uXOq))).createElement($333f125f896ef4d8$var$Code, null, "Ctrl");
            return hijackBrowserDefaultSearch ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...(0, (0, parcelRequire("gtlfw")).default).hijackingDefaultSearchMessage,
                values: {
                    key: (0, ($parcel$interopDefault($5uXOq))).createElement($333f125f896ef4d8$var$Code, null, "F"),
                    ctrlKey: ctrlKey
                }
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...(0, (0, parcelRequire("gtlfw")).default).changeboardingMessage,
                values: {
                    key: (0, ($parcel$interopDefault($5uXOq))).createElement($333f125f896ef4d8$var$Code, null, "f")
                }
            });
        };
        let spotlightCard = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ujeO")).default), {
            actions: actions,
            width: 300
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), null, changeBoardingMessage()));
        if (isCompanyManaged) spotlightCard = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ujeO")).default), {
            heading: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("gtlfw")).default).changeboardingUifMessageHeadingIssueTermRefresh : (0, (0, parcelRequire("gtlfw")).default).changeboardingUifMessageHeading),
            actions: actions,
            width: 300
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), null, formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("gtlfw")).default).changeboardingUifMessageIssueTermRefresh : (0, (0, parcelRequire("gtlfw")).default).changeboardingUifMessage)));
        (0, (0, parcelRequire("dF9Z3")).useGlobalSearch)(onGlobalSearch);
        if (isVisible) return (0, ($parcel$interopDefault($5uXOq))).createElement($333f125f896ef4d8$var$ChangeboardingContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement($333f125f896ef4d8$var$Pulse, null, children), (0, ($parcel$interopDefault($5uXOq))).createElement($333f125f896ef4d8$var$SpolightCardContainer, null, spotlightCard));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    };
    var $333f125f896ef4d8$export$2e2bcd8739ae039 = $333f125f896ef4d8$var$SearchFilterChangeboarding;
    const $333f125f896ef4d8$var$Pulse = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("k6T4f")).Pulse), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1pbyowjs",
                __cmplp.className
            ])
        });
    });
    const $333f125f896ef4d8$var$ChangeboardingContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm",
                __cmplp.className
            ])
        });
    });
    const $333f125f896ef4d8$var$spotlightAnimation = null;
    const $333f125f896ef4d8$var$SpolightCardContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _1pbyowjs _19pku2gc _tzy4idpf _y44v18t4 _o5724jg8",
                __cmplp.className
            ])
        });
    });
    const $333f125f896ef4d8$var$Code = (0, $5uXOq.forwardRef)(({ as: C = "code", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11c8qk37 _11q7exu1 _syaz1fxt _2rko1l7b _1e0c1nu9 _1reo1wug _o5721jtm _1yt4u49m",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("ew9g5", function(module, exports) {
    $parcel$export(module.exports, "hasUserSeenSearchFieldChangeboarding", ()=>$f70c479b04e71cf2$export$b5010e3edd313ae1);
    $parcel$export(module.exports, "setUserSeenSearchFieldChangeboarding", ()=>$f70c479b04e71cf2$export$fba51361338c8f18);
    var $i205g;
    var $8zOmE;
    const $f70c479b04e71cf2$var$changeboardingFlags = {
        board: 'jsw.filters.board.search-field-changeboarding.shown',
        backlog: 'jsw.filters.backlog.search-field-changeboarding.shown'
    };
    const $f70c479b04e71cf2$var$CHANGEBOARDING_TTL_SEEN = 31536000000;
    const $f70c479b04e71cf2$export$b5010e3edd313ae1 = (analyticsEvent, screenName)=>(0, (0, parcelRequire("i205g")).getFlags)({
            [$f70c479b04e71cf2$var$changeboardingFlags[screenName]]: {}
        }).then((res)=>res[$f70c479b04e71cf2$var$changeboardingFlags[screenName]].status).catch(()=>{
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, 'searchFilterChangeboarding checkSeenFailed');
            return false;
        });
    const $f70c479b04e71cf2$export$fba51361338c8f18 = (screenName)=>(0, (0, parcelRequire("i205g")).setFlag)($f70c479b04e71cf2$var$changeboardingFlags[screenName], $f70c479b04e71cf2$var$CHANGEBOARDING_TTL_SEEN);
});
parcelRegister("i205g", function(module, exports) {
    $parcel$export(module.exports, "getFlags", ()=>$2e5c55e74efea073$export$d5815430bcc75df0);
    $parcel$export(module.exports, "setFlag", ()=>$2e5c55e74efea073$export$5e165df1e30a1331);
    var $dPSWJ = parcelRequire("dPSWJ");
    var $sLb2Q = parcelRequire("sLb2Q");
    var $4Pf62;
    var $1nokx;
    var $7UyIQ;
    const $2e5c55e74efea073$export$442e3330dfabd1f5 = 3600000;
    const $2e5c55e74efea073$export$4d45fa66d41a8ca9 = 2592000000;
    const $2e5c55e74efea073$export$d5815430bcc75df0 = async (request)=>{
        const { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } = (0, (0, parcelRequire("4Pf62")).getTenantContext_DEPRECATED_DO_NOT_USE)();
        const flagKeys = Object.keys(request);
        const retrieveFlagKeysLookup = (0, ($parcel$interopDefault($sLb2Q)))(flagKeys);
        if (!atlassianAccountId || isAnonymous) return (0, ($parcel$interopDefault($dPSWJ)))(retrieveFlagKeysLookup, ()=>({
                status: true,
                lastSeenDate: null
            }));
        const flags = {};
        if (0, (0, parcelRequire("7UyIQ")).default) flagKeys.forEach((flagKey)=>{
            const value = (0, (0, parcelRequire("7UyIQ")).default).get(flagKey);
            if (value) {
                delete retrieveFlagKeysLookup[flagKey];
                flags[flagKey] = value;
            }
        });
        const retrieveFlagKeys = Object.keys(retrieveFlagKeysLookup);
        if (retrieveFlagKeys.length > 0) Object.assign(flags, await (0, (0, parcelRequire("1nokx")).getFlags)(atlassianAccountId, retrieveFlagKeys));
        if (0, (0, parcelRequire("7UyIQ")).default) {
            const now = Date.now();
            retrieveFlagKeys.forEach((flagKey)=>{
                if (!flags[flagKey]) return;
                const { status: status } = flags[flagKey];
                const ttlNotSeen = request[flagKey].ttlNotSeen || $2e5c55e74efea073$export$442e3330dfabd1f5;
                const ttlSeen = request[flagKey].ttlSeen || $2e5c55e74efea073$export$4d45fa66d41a8ca9;
                (0, (0, parcelRequire("7UyIQ")).default).set(flagKey, flags[flagKey], now + (status ? ttlSeen : ttlNotSeen));
            });
        }
        return flags;
    };
    const $2e5c55e74efea073$export$5e165df1e30a1331 = async (flagKey, ttl = $2e5c55e74efea073$export$4d45fa66d41a8ca9)=>{
        const { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } = (0, (0, parcelRequire("4Pf62")).getTenantContext_DEPRECATED_DO_NOT_USE)();
        if (!atlassianAccountId || isAnonymous) return;
        if (0, (0, parcelRequire("7UyIQ")).default) {
            const value = (0, (0, parcelRequire("7UyIQ")).default).get(flagKey);
            if (value && value.status) return;
            const now = new Date();
            (0, (0, parcelRequire("7UyIQ")).default).set(flagKey, {
                status: true,
                lastSeenDate: now.toISOString()
            }, now.getTime() + ttl);
        }
        await (0, (0, parcelRequire("1nokx")).setFlag)(atlassianAccountId, flagKey);
    };
});
parcelRegister("sLb2Q", function(module, exports) {
    var $hsOo6 = parcelRequire("hsOo6");
    var $dVL8S = parcelRequire("dVL8S");
    function $056736098c9e0b45$var$zipObject(props, values) {
        return $dVL8S(props || [], values || [], $hsOo6);
    }
    module.exports = $056736098c9e0b45$var$zipObject;
});
parcelRegister("dVL8S", function(module, exports) {
    function $a2452aab1e6d9d16$var$baseZipObject(props, values, assignFunc) {
        var index = -1, length = props.length, valsLength = values.length, result = {};
        while(++index < length){
            var value = index < valsLength ? values[index] : undefined;
            assignFunc(result, props[index], value);
        }
        return result;
    }
    module.exports = $a2452aab1e6d9d16$var$baseZipObject;
});
parcelRegister("1nokx", function(module, exports) {
    $parcel$export(module.exports, "setFlag", ()=>$4c27c5726c27889e$export$5e165df1e30a1331);
    $parcel$export(module.exports, "getFlags", ()=>$4c27c5726c27889e$export$d5815430bcc75df0);
    var $dPSWJ = parcelRequire("dPSWJ");
    var $jJZqs;
    const $4c27c5726c27889e$export$c1f083639d344e75 = 'https://have-i-seen-it.us-east-1.prod.public.atl-paas.net';
    const $4c27c5726c27889e$export$5e165df1e30a1331 = (userKey, flagKey)=>{
        const data = {
            userKey: userKey,
            flagKey: flagKey
        };
        return fetch(`${$4c27c5726c27889e$export$c1f083639d344e75}/flag`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new (0, (0, parcelRequire("jJZqs")).default)(response.status, response.statusText);
            return undefined;
        });
    };
    const $4c27c5726c27889e$var$convertToDates = (response)=>(0, ($parcel$interopDefault($dPSWJ)))(response, ({ status: status, lastSeenDate: lastSeenDate })=>({
                status: status,
                lastSeenDate: lastSeenDate ? new Date(lastSeenDate) : null
            }));
    const $4c27c5726c27889e$export$d5815430bcc75df0 = (userKey, flagKeys)=>{
        const params = new URLSearchParams();
        flagKeys.forEach((flagKey)=>params.append('flagKey', flagKey));
        params.append('userKey', userKey);
        return fetch(`${$4c27c5726c27889e$export$c1f083639d344e75}/flags?${params.toString()}`).then((response)=>{
            if (!response.ok) throw new (0, (0, parcelRequire("jJZqs")).default)(response.status, response.statusText);
            return response.json();
        }).then((response)=>$4c27c5726c27889e$var$convertToDates(response));
    };
});
parcelRegister("7UyIQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$158da724691281b4$export$2e2bcd8739ae039);
    var $eNf8a;
    var $4Pf62;
    var $dJl1T;
    const $158da724691281b4$var$createStorage = ()=>{
        let storage = null;
        try {
            let context;
            try {
                context = (0, (0, parcelRequire("4Pf62")).getTenantContext_DEPRECATED_DO_NOT_USE)();
            } catch (e) {
                return storage;
            }
            const { atlassianAccountId: atlassianAccountId } = context;
            if (atlassianAccountId) storage = (0, (0, parcelRequire("eNf8a")).createSessionExpirableStorageProvider)(`have-i-seen-it-${atlassianAccountId.replace(/:/g, '_')}`);
        } catch (e) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('have-i-seen-it.storage', 'Failed to initialize storage.');
        }
        return storage;
    };
    var $158da724691281b4$export$2e2bcd8739ae039 = $158da724691281b4$var$createStorage();
});
parcelRegister("gtlfw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8e167f73d4db9857$export$2e2bcd8739ae039);
    var $7VHMR;
    var $8e167f73d4db9857$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        changeboardingMessage: {
            "id": "software-filters.search-filter-changeboarding.changeboarding-message",
            "defaultMessage": "For quick access to search, use {key} on your keyboard anywhere in Jira. It takes you directly to the search field."
        },
        changeboardingUifMessageHeading: {
            "id": "software-filters.search-filter-changeboarding.changeboarding-uif-message-heading",
            "defaultMessage": "Search for an issue"
        },
        changeboardingUifMessage: {
            "id": "software-filters.search-filter-changeboarding.changeboarding-uif-message",
            "defaultMessage": "The backlog loads issues as you scroll to help increase performance. If you struggle to find results using a keyboard shortcut, try entering the keyword here instead."
        },
        hijackingDefaultSearchMessage: {
            "id": "software-filters.search-filter-changeboarding.hijacking-default-search-message",
            "defaultMessage": "{ ctrlKey } + { key } takes you directly to the search field, just like keyboard shortcut { key }. Both shortcuts give you quick access to our optimized search."
        },
        changeboardingConfirmButton: {
            "id": "software-filters.search-filter-changeboarding.changeboarding-confirm-button",
            "defaultMessage": "OK"
        },
        changeboardingUifMessageHeadingIssueTermRefresh: {
            "id": "software-filters.search-filter-changeboarding.changeboarding-uif-message-heading-issue-term-refresh",
            "defaultMessage": "Search for a work item"
        },
        changeboardingUifMessageIssueTermRefresh: {
            "id": "software-filters.search-filter-changeboarding.changeboarding-uif-message-issue-term-refresh",
            "defaultMessage": "The backlog loads work items as you scroll to help increase performance. If you struggle to find results using a keyboard shortcut, try entering the keyword here instead."
        }
    });
});
parcelRegister("bBMqL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cf4b1c241e667722$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $lfTZh;
    const $cf4b1c241e667722$var$VersionFilterRelayBoundary = ({ fallback: fallback = null, children: children, screenName: screenName })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "version-filter-relay-dropdown",
            packageName: "software-filters",
            teamName: "a4t-tanuki",
            fallback: "flag",
            extraEventData: {
                screenName: screenName
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "version-filter-relay-boundary",
            fallback: fallback
        }, children));
    var $cf4b1c241e667722$export$2e2bcd8739ae039 = $cf4b1c241e667722$var$VersionFilterRelayBoundary;
});
parcelRegister("l38sT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4c71ac6a8ffa9b82$export$2e2bcd8739ae039);
    var $7VHMR;
    var $4c71ac6a8ffa9b82$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        textFilter: {
            "id": "software-filters.stateless.text-filter",
            "defaultMessage": "Filter issues"
        },
        screenReaderInstruction: {
            "id": "software-filters.stateless.screen-reader-instruction",
            "defaultMessage": "Results will be filtered below as you type to search or apply filters."
        },
        screenReaderInstructionForFilters: {
            "id": "software-filters.stateless.screen-reader-instruction-for-filters",
            "defaultMessage": "Content below has been updated"
        },
        searchCurrentPage: {
            "id": "software-filters.stateless.search-current-page",
            "defaultMessage": "Search on current page"
        },
        goToSection: {
            "id": "software-filters.stateless.go-to-section",
            "defaultMessage": "Go to"
        },
        unassignedAssigneeDisplayName: {
            "id": "software-filters.stateless.unassigned-assignee-display-name",
            "defaultMessage": "Unassigned"
        },
        unassignedVersionLabel: {
            "id": "software-filters.stateless.unassigned-version-label",
            "defaultMessage": "Issues without version"
        },
        unassignedLabelLabel: {
            "id": "software-filters.stateless.unassigned-label-label",
            "defaultMessage": "Issues without label"
        },
        unassignedComponentLabel: {
            "id": "software-filters.stateless.unassigned-component-label",
            "defaultMessage": "Issues without component"
        },
        textFilterIssueTermRefresh: {
            "id": "software-filters.stateless.text-filter-issue-term-refresh",
            "defaultMessage": "Filter work items"
        },
        unassignedVersionLabelIssueTermRefresh: {
            "id": "software-filters.stateless.unassigned-version-label-issue-term-refresh",
            "defaultMessage": "Work items without version"
        },
        unassignedLabelLabelIssueTermRefresh: {
            "id": "software-filters.stateless.unassigned-label-label-issue-term-refresh",
            "defaultMessage": "Work items without label"
        },
        unassignedComponentLabelIssueTermRefresh: {
            "id": "software-filters.stateless.unassigned-component-label-issue-term-refresh",
            "defaultMessage": "Work items without component "
        }
    });
});
parcelRegister("649U3", function(module, exports) {
    $parcel$export(module.exports, "getManageCustomFiltersUrl", ()=>$224b64cdfcbfd0e3$export$84a62bf03b005a81);
    $parcel$export(module.exports, "getAssigneesWithPresence", ()=>$224b64cdfcbfd0e3$export$cd7b2f0d4c426239);
    const $224b64cdfcbfd0e3$export$84a62bf03b005a81 = (projectKey, boardId, isCompanyManaged, isUserBoard, isJSMBoard, pathname = window.location.pathname)=>{
        if (isJSMBoard) return `/jira/servicedesk/projects/${projectKey}/boards/${boardId}?config=quickFilters`;
        if (isCompanyManaged) {
            if (isUserBoard) return `${pathname}?config=quickFilters`;
            return `/jira/software/c/projects/${projectKey}/boards/${boardId}${pathname.endsWith('backlog') ? '/backlog' : ''}?config=quickFilters`;
        }
        return `/jira/software/projects/${projectKey}/settings/boards/${boardId}/custom-filters`;
    };
    const $224b64cdfcbfd0e3$export$cd7b2f0d4c426239 = (allAssignees, participants)=>allAssignees.map((assignee)=>{
            if (assignee.id === (0, $15a528573ccd89ae$export$12e572fd459c10dc)) return assignee;
            return {
                ...assignee,
                presence: participants.some((participant)=>participant.clientId === assignee.id) ? (0, $15a528573ccd89ae$export$7a105aa475396c65) : (0, $15a528573ccd89ae$export$c9408e3fb31ddc71)
            };
        }).sort((a, b)=>{
            if (a.id === allAssignees[0].id) return -1;
            if (b.id === allAssignees[0].id) return 1;
            if (a.presence === (0, $15a528573ccd89ae$export$7a105aa475396c65)) return -1;
            if (b.presence === (0, $15a528573ccd89ae$export$7a105aa475396c65)) return 1;
            return 0;
        });
});
parcelRegister("jtCoi", function(module, exports) {
    $parcel$export(module.exports, "useCollator", ()=>$4d999619da6603d4$export$a16aca283550c30d);
    var $5uXOq = parcelRequire("5uXOq");
    var $lzeFL;
    var $9OXo1;
    const $4d999619da6603d4$export$a16aca283550c30d = ()=>{
        const { locale: locale } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const { current: collator } = (0, $5uXOq.useRef)(new Intl.Collator((0, (0, parcelRequire("lzeFL")).standardizeLocale)(locale)));
        return {
            collator: collator
        };
    };
});
parcelRegister("2GIeL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7e1cbc4b5098530d$export$2e2bcd8739ae039);
    var $7VHMR;
    var $7e1cbc4b5098530d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        filterPlaceholder: {
            "id": "roadmap.standard-roadmap.header.filter-bar.filter-placeholder",
            "defaultMessage": "Search timeline"
        }
    });
});
parcelRegister("6W6Zj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ae20917e41bb8c90$export$2e2bcd8739ae039);
    var $bC2fB;
    var $9fPrG;
    var $4gYYI;
    var $4QQEL;
    var $ae20917e41bb8c90$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((state)=>({
            isCMP: (0, (0, parcelRequire("9fPrG")).isClassic)(state),
            boardId: (0, (0, parcelRequire("9fPrG")).getBoardId)(state),
            projectKey: (0, (0, parcelRequire("4gYYI")).getProjectKey)(state),
            cloudId: (0, (0, parcelRequire("9fPrG")).getCloudId)(state) ?? '',
            boardType: (0, (0, parcelRequire("4gYYI")).getIsSprintsFeatureEnabled)(state) ? 'Scrum' : 'Kanban',
            canConfigureTimeline: (0, (0, parcelRequire("4gYYI")).hasAdministerProjectPermission)(state) || (0, (0, parcelRequire("4gYYI")).getIsUserBoardAdmin)(state)
        }), {})((0, (0, parcelRequire("4QQEL")).default));
});
parcelRegister("4QQEL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d076472baf06e26a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $42CjB;
    var $fVnbM;
    var $BLPHT;
    var $6B7KL;
    var $aRoVz;
    var $l14Zy;
    var $aEHvW;
    var $k2tiP;
    var $bJeNF;
    var $8KRBa;
    var $3Tty1;
    var $4R6GH;
    var $7iULw;
    var $dseDh;
    var $koVbs;
    var $g7crU;
    var $3HwlS;
    var $14uhY;
    var $bw7Gm;
    var $8zOmE;
    var $2NMNM;
    var $6lmg7;
    var $aCKi5;
    var $k9JTq;
    var $itmJb;
    var $9OXo1;
    var $dCm1o;
    var $lVJAU;
    var $fvdWw;
    var $1sV0H;
    const $d076472baf06e26a$var$licensedProductsToString = (products)=>Object.keys(products).map((productKey)=>products[productKey] ? productKey : '').join(', ');
    const $d076472baf06e26a$var$MoreSettings = ({ isCMP: isCMP, boardId: boardId, projectKey: projectKey, cloudId: cloudId, boardType: boardType, canConfigureTimeline: canConfigureTimeline, defaultOpen: defaultOpen = false })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { push: push } = (0, (0, parcelRequire("lVJAU")).useRouterActions)();
        const isAdmin = (0, (0, parcelRequire("itmJb")).useIsAdmin)();
        const { licensedProducts: licensedProducts } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const { software: softwareEdition } = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        const { openFeedbackCollector: openFeedbackCollector } = (0, (0, parcelRequire("dseDh")).useFeedbackCollectorActions)();
        const [isFullscreen, { setIsFullscreen: setIsFullscreen }] = (0, (0, parcelRequire("g7crU")).useIsFullscreen)();
        const configureRoadmapAnalyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'configureRoadmapButtonClicked'
        });
        const navigateToRoadmapSettingsPage = ()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(configureRoadmapAnalyticsEvent);
            if (!isCMP) (0, (0, parcelRequire("14uhY")).setReturnToProjectUrl)();
            const url = (0, (0, parcelRequire("fvdWw")).getRoadmapSettingsUrl)(isCMP, projectKey, boardId);
            push(url);
        };
        const toggleFullscreen = (0, $5uXOq.useCallback)(()=>{
            setIsFullscreen(!isFullscreen);
        }, [
            isFullscreen,
            setIsFullscreen
        ]);
        const shortcutsKeyMap = {
            z: {
                callback: toggleFullscreen
            }
        };
        const feedbackButtonRef = (0, $5uXOq.useRef)(null);
        const additionalFeedbackEntries = (0, $5uXOq.useMemo)(()=>[
                {
                    id: (0, (0, parcelRequire("7iULw")).EntryKeys).OPT_OUT,
                    value: 'No'
                },
                {
                    id: (0, (0, parcelRequire("7iULw")).EntryKeys).FEEDBACK_COLLECTOR_LOCATION,
                    value: 'jsw.roadmap'
                },
                {
                    id: (0, (0, parcelRequire("7iULw")).EntryKeys).CLOUD_ID,
                    value: cloudId
                },
                {
                    id: (0, (0, parcelRequire("7iULw")).EntryKeys).IS_SIMPLIFIED_PROJECT,
                    value: !isCMP.toString()
                },
                {
                    id: (0, (0, parcelRequire("7iULw")).EntryKeys).BOARD_TYPE,
                    value: boardType
                },
                {
                    id: (0, (0, parcelRequire("7iULw")).EntryKeys).LOCATION,
                    value: (0, (0, parcelRequire("bw7Gm")).default)(window?.location?.href ?? '')
                },
                {
                    id: (0, (0, parcelRequire("7iULw")).EntryKeys).REFERER,
                    value: document.referrer ? (0, (0, parcelRequire("bw7Gm")).default)(document.referrer) : ''
                },
                {
                    id: (0, (0, parcelRequire("7iULw")).EntryKeys).USER_AGENT,
                    value: navigator.userAgent
                },
                {
                    id: (0, (0, parcelRequire("7iULw")).EntryKeys).SCREEN_RESOLUTION,
                    value: `${window.screen.width} x ${window.screen.height}`
                },
                {
                    id: (0, (0, parcelRequire("7iULw")).EntryKeys).IS_ADMIN,
                    value: isAdmin.toString()
                },
                {
                    id: (0, (0, parcelRequire("7iULw")).EntryKeys).SUPPORTED_PROJECT_TYPES,
                    value: $d076472baf06e26a$var$licensedProductsToString(licensedProducts)
                },
                {
                    id: (0, (0, parcelRequire("7iULw")).EntryKeys).PROJECT_TYPE,
                    value: 'software'
                },
                {
                    id: (0, (0, parcelRequire("7iULw")).EntryKeys).EDITION,
                    value: softwareEdition
                }
            ], [
            boardType,
            cloudId,
            isCMP,
            isAdmin,
            licensedProducts,
            softwareEdition
        ]);
        const onOpenFeedbackCollector = (0, $5uXOq.useCallback)(()=>{
            openFeedbackCollector({
                entrypointId: (0, (0, parcelRequire("7iULw")).ENTRYPOINT_ID_JIRA_PLATFORM),
                feedbackTitle: formatMessage((0, (0, parcelRequire("1sV0H")).default).feedbackCollectorTitle),
                feedbackTitleDetails: formatMessage((0, (0, parcelRequire("1sV0H")).default).feedbackCollectorDescription),
                triggerRef: feedbackButtonRef,
                feedbackContext: additionalFeedbackEntries
            });
        }, [
            openFeedbackCollector,
            formatMessage,
            additionalFeedbackEntries
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("BLPHT")).default), {
            testId: "roadmap.standard-roadmap.header.more-settings",
            trigger: ({ triggerRef: triggerRef, ...triggerProps })=>(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
                    ...triggerProps,
                    icon: (0, ($parcel$interopDefault((0, parcelRequire("bJeNF"))))),
                    label: formatMessage((0, (0, parcelRequire("1sV0H")).default).moreSettingsMenuLabel),
                    ref: triggerRef,
                    isTooltipDisabled: false
                }) : (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6lmg7")).ResponsiveButton), {
                    label: formatMessage((0, (0, parcelRequire("1sV0H")).default).moreSettingsMenuLabel),
                    icon: (0, ($parcel$interopDefault((0, parcelRequire("bJeNF"))))),
                    ref: triggerRef,
                    ...triggerProps
                }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                    ...triggerProps,
                    ref: triggerRef,
                    appearance: "subtle",
                    iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("bJeNF"))))), {
                        label: "",
                        color: "currentColor",
                        spacing: "spacious"
                    })
                }),
            placement: "bottom-end",
            defaultOpen: defaultOpen
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRoVz")).default), null, (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            elemBefore: isFullscreen ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8KRBa"))))), {
                label: "",
                color: "currentColor",
                spacing: "spacious"
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("l14Zy"))))), {
                label: "",
                color: "currentColor",
                spacing: "spacious"
            }),
            elemAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCKi5")).ShortcutLabel), {
                text: "Z"
            }),
            "aria-keyshortcuts": "Z",
            onClick: toggleFullscreen
        }, isFullscreen ? formatMessage((0, (0, parcelRequire("1sV0H")).default).exitFullScreen) : formatMessage((0, (0, parcelRequire("1sV0H")).default).enterFullScreen)), canConfigureTimeline && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            onClick: navigateToRoadmapSettingsPage,
            elemBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("k2tiP"))))), {
                label: "",
                color: "currentColor",
                spacing: "spacious"
            }),
            testId: "roadmap.standard-roadmap.header.more-settings.configure-timeline"
        }, formatMessage((0, (0, parcelRequire("1sV0H")).default).moreSettingsButtonLabel)), (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            elemBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("aEHvW"))))), {
                label: "",
                color: "currentColor",
                spacing: "spacious"
            }),
            onClick: onOpenFeedbackCollector,
            ref: feedbackButtonRef,
            testId: "roadmap.standard-roadmap.header.more-settings.feedback"
        }, formatMessage((0, (0, parcelRequire("1sV0H")).default).feedbackButtonLabel)))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Tty1")).default), {
            keyMap: shortcutsKeyMap
        }));
    };
    var $d076472baf06e26a$export$2e2bcd8739ae039 = $d076472baf06e26a$var$MoreSettings;
});
parcelRegister("aRoVz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6c1f89f82839ba50$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9KnKW;
    var $9UCCQ;
    var $k20lf;
    const $6c1f89f82839ba50$var$DropdownMenuItemGroup = (0, $5uXOq.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, overrides: overrides, ...rest }, ref)=>{
        const uid = (0, (0, parcelRequire("9KnKW")).useId)();
        const titleId = `dropdown-menu-item-group-title-${uid}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), {
            id: id,
            ref: ref,
            isList: isList,
            isScrollable: isScrollable,
            hasSeparator: hasSeparator,
            testId: testId,
            titleId: title ? titleId : undefined,
            overrides: overrides,
            ...rest
        }, title && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k20lf")).default), {
            id: titleId,
            title: title
        }), children);
    });
    var $6c1f89f82839ba50$export$2e2bcd8739ae039 = $6c1f89f82839ba50$var$DropdownMenuItemGroup;
});
parcelRegister("l14Zy", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $f4cd903aabaa4c53$var$_react = $f4cd903aabaa4c53$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $f4cd903aabaa4c53$var$_UNSAFE_baseNew = $f4cd903aabaa4c53$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $f4cd903aabaa4c53$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $f4cd903aabaa4c53$var$GrowDiagonalIcon = (props)=>$f4cd903aabaa4c53$var$_react.default.createElement($f4cd903aabaa4c53$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m7 9-4.75 4.75M9 7l4.75-4.75m-12 7.25v4.75H6.5m7.75-7.75V1.75H9.5"/>`
        }, props));
    $f4cd903aabaa4c53$var$GrowDiagonalIcon.displayName = 'GrowDiagonalIcon';
    var $f4cd903aabaa4c53$var$_default = module.exports.default = $f4cd903aabaa4c53$var$GrowDiagonalIcon;
});
parcelRegister("aEHvW", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $7c1f64cf4f9c421f$var$_react = $7c1f64cf4f9c421f$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7c1f64cf4f9c421f$var$_feedback = $7c1f64cf4f9c421f$var$_interopRequireDefault((parcelRequire("5dqGX")));
    var $7c1f64cf4f9c421f$var$_feedback2 = $7c1f64cf4f9c421f$var$_interopRequireDefault((parcelRequire("3g1Fk")));
    function $7c1f64cf4f9c421f$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $7c1f64cf4f9c421f$var$FeedbackIcon = (props)=>$7c1f64cf4f9c421f$var$_react.default.createElement($7c1f64cf4f9c421f$var$_feedback.default, Object.assign({
            LEGACY_fallbackIcon: $7c1f64cf4f9c421f$var$_feedback2.default
        }, props));
    $7c1f64cf4f9c421f$var$FeedbackIcon.Name = 'FeedbackIconMigration';
    var $7c1f64cf4f9c421f$var$_default = module.exports.default = $7c1f64cf4f9c421f$var$FeedbackIcon;
});
parcelRegister("5dqGX", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $3cc2df171aca9493$var$_react = $3cc2df171aca9493$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $3cc2df171aca9493$var$_UNSAFE_baseNew = $3cc2df171aca9493$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $3cc2df171aca9493$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $3cc2df171aca9493$var$FeedbackIcon = (props)=>$3cc2df171aca9493$var$_react.default.createElement($3cc2df171aca9493$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 9.5V15L6 12.25h7c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v2.75C1.75 6.44 2.31 7 3 7h6.75m-2-2.5 2.5 2.5-2.5 2.5"/>`
        }, props));
    $3cc2df171aca9493$var$FeedbackIcon.displayName = 'FeedbackIcon';
    var $3cc2df171aca9493$var$_default = module.exports.default = $3cc2df171aca9493$var$FeedbackIcon;
});
parcelRegister("3g1Fk", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $25f4287f17f73dc4$var$_react = $25f4287f17f73dc4$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $25f4287f17f73dc4$var$_feedback = $25f4287f17f73dc4$var$_interopRequireDefault((parcelRequire("5dqGX")));
    function $25f4287f17f73dc4$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $25f4287f17f73dc4$var$FeedbackIcon = (props)=>$25f4287f17f73dc4$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m10.88 5.48-8.43 6.83c-.4.32-.58.96-.41 1.42l.1.27c.17.46.73.83 1.23.82l1.13-.02 6.06-.1 3.65-.06c.51-.01.79-.38.62-.86l-2.92-8.03c-.1-.29-.32-.44-.57-.44a.73.73 0 0 0-.46.18m-5.9 10.46 1.75 4.82a1 1 0 1 0 1.88-.68l-1.54-4.23zm13.71-9.11-2.82 1.03a1 1 0 1 0 .68 1.88l2.82-1.03a1 1 0 1 0-.68-1.88m-1.79 3.85a1 1 0 0 0-.64.77 1 1 0 0 0 .81 1.16l2.96.52a1 1 0 0 0 1.12-1.3l-.02-.05a1 1 0 0 0-.76-.62l-2.95-.52a.97.97 0 0 0-.51.05m-.56-7.65-1.93 2.3a1 1 0 0 0 1.53 1.29l1.93-2.3a1 1 0 0 0-.76-1.64 1 1 0 0 0-.77.36"/></svg>`
        }, props, {
            newIcon: $25f4287f17f73dc4$var$_feedback.default
        }));
    $25f4287f17f73dc4$var$FeedbackIcon.displayName = 'FeedbackIcon';
    var $25f4287f17f73dc4$var$_default = module.exports.default = $25f4287f17f73dc4$var$FeedbackIcon;
});
parcelRegister("bJeNF", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $889f60aca54b55ef$var$_react = $889f60aca54b55ef$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $889f60aca54b55ef$var$_showMoreHorizontal = $889f60aca54b55ef$var$_interopRequireDefault((parcelRequire("8U6zd")));
    var $889f60aca54b55ef$var$_more = $889f60aca54b55ef$var$_interopRequireDefault((parcelRequire("3oUqw")));
    function $889f60aca54b55ef$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $889f60aca54b55ef$var$ShowMoreHorizontalIcon = (props)=>$889f60aca54b55ef$var$_react.default.createElement($889f60aca54b55ef$var$_showMoreHorizontal.default, Object.assign({
            LEGACY_fallbackIcon: $889f60aca54b55ef$var$_more.default
        }, props));
    $889f60aca54b55ef$var$ShowMoreHorizontalIcon.Name = 'ShowMoreHorizontalIconMigration';
    var $889f60aca54b55ef$var$_default = module.exports.default = $889f60aca54b55ef$var$ShowMoreHorizontalIcon;
});
parcelRegister("8KRBa", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $65fc322a3db160cb$var$_react = $65fc322a3db160cb$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $65fc322a3db160cb$var$_UNSAFE_baseNew = $65fc322a3db160cb$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $65fc322a3db160cb$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $65fc322a3db160cb$var$ShrinkDiagonalIcon = (props)=>$65fc322a3db160cb$var$_react.default.createElement($65fc322a3db160cb$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 14.5 5.25-5.25M14.5 1.5 9.25 6.75M6.75 14V9.25H2M9.25 2v4.75H14"/>`
        }, props));
    $65fc322a3db160cb$var$ShrinkDiagonalIcon.displayName = 'ShrinkDiagonalIcon';
    var $65fc322a3db160cb$var$_default = module.exports.default = $65fc322a3db160cb$var$ShrinkDiagonalIcon;
});
parcelRegister("6lmg7", function(module, exports) {
    $parcel$export(module.exports, "ResponsiveButton", ()=>$aeaed609d1db7293$export$47e82d861696e68c);
    $parcel$export(module.exports, "ResponsiveLinkButton", ()=>$aeaed609d1db7293$export$50fd17babcd996ef);
    var $5uXOq = parcelRequire("5uXOq");
    var $eCeGD;
    var $42CjB;
    var $1GGwS;
    var $krXdA;
    var $f5TWP;
    var $1kVqg;
    var $oGXFy;
    var $3bDjY;
    const $aeaed609d1db7293$export$47e82d861696e68c = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { icon: icon, label: label, iconAfter: iconAfter, breakpoint: breakpoint = 'lg', appearance: appearance, testId: testId, 'aria-label': ariaLabel, iconButtonSpacing: iconButtonSpacing, buttonSpacing: buttonSpacing, ...restProps } = props;
        const mediaQueryBreakpoint = (0, (0, parcelRequire("oGXFy")).UNSAFE_useMediaQuery)(`above.${breakpoint}`, (event)=>setIsAboveBreakpoint(event.matches));
        const [isAboveBreakpoint, setIsAboveBreakpoint] = (0, $5uXOq.useState)(mediaQueryBreakpoint?.matches);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1kVqg")).Show), {
            below: breakpoint
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: label
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
            ...restProps,
            icon: icon,
            appearance: appearance ?? 'default',
            label: label,
            testId: `${testId ?? (0, $7c15fdea32a398a0$export$9c51afe8741be906)}.collapsed`,
            ref: !isAboveBreakpoint ? ref : undefined,
            spacing: iconButtonSpacing
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1kVqg")).Show), {
            above: breakpoint
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eCeGD")).default), {
            ...restProps,
            iconBefore: icon,
            iconAfter: iconAfter,
            appearance: appearance ?? 'default',
            testId: `${testId ?? (0, $7c15fdea32a398a0$export$9c51afe8741be906)}.expanded`,
            ref: isAboveBreakpoint ? ref : undefined,
            "aria-label": ariaLabel,
            spacing: buttonSpacing
        }, label)));
    });
    const $aeaed609d1db7293$export$50fd17babcd996ef = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { icon: icon, label: label, iconAfter: iconAfter, breakpoint: breakpoint = 'lg', appearance: appearance, testId: testId, 'aria-label': ariaLabel, iconButtonSpacing: iconButtonSpacing, buttonSpacing: buttonSpacing, ...restProps } = props;
        const mediaQueryBreakpoint = (0, (0, parcelRequire("oGXFy")).UNSAFE_useMediaQuery)(`above.${breakpoint}`, (event)=>setIsAboveBreakpoint(event.matches));
        const [isAboveBreakpoint, setIsAboveBreakpoint] = (0, $5uXOq.useState)(mediaQueryBreakpoint?.matches);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1kVqg")).Show), {
            below: breakpoint
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: label
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("krXdA")).default), {
            ...restProps,
            icon: icon,
            appearance: appearance ?? 'default',
            label: label,
            testId: `${testId ?? (0, $7c15fdea32a398a0$export$9c51afe8741be906)}.collapsed`,
            href: restProps.href,
            ref: !isAboveBreakpoint ? ref : undefined,
            spacing: iconButtonSpacing
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1kVqg")).Show), {
            above: breakpoint
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1GGwS")).default), {
            ...restProps,
            iconBefore: icon,
            iconAfter: iconAfter,
            appearance: appearance ?? 'default',
            testId: `${testId ?? (0, $7c15fdea32a398a0$export$9c51afe8741be906)}.expanded`,
            href: restProps.href,
            ref: isAboveBreakpoint ? ref : undefined,
            "aria-label": ariaLabel,
            spacing: buttonSpacing
        }, label)));
    });
});
parcelRegister("1GGwS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9768e745d0380796$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $jhmo0;
    var $fuBHX;
    const $9768e745d0380796$var$LinkButtonBase = ({ analyticsContext: analyticsContext, appearance: appearance, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus: autoFocus, children: children, href: href, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, ...unsafeRest }, ref)=>{
        const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
        const baseProps = (0, (0, parcelRequire("fuBHX")).default)({
            analyticsContext: analyticsContext,
            appearance: appearance,
            ariaLabel: ariaLabel,
            ariaLabelledBy: ariaLabelledBy,
            autoFocus: autoFocus,
            buttonType: 'link',
            children: children,
            iconAfter: iconAfter,
            iconBefore: iconBefore,
            interactionName: interactionName,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: onClick,
            onClickCapture: onClickCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onTouchEndCapture: onTouchEndCapture,
            onTouchStartCapture: onTouchStartCapture,
            ref: ref,
            shouldFitContainer: shouldFitContainer,
            spacing: spacing,
            testId: testId
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jhmo0")).default), {
            ...saferRest,
            "aria-label": baseProps['aria-label'],
            "aria-labelledby": baseProps['aria-labelledby'],
            ref: baseProps.ref,
            xcss: baseProps.xcss,
            onClick: baseProps.onClick,
            onMouseDownCapture: baseProps.onMouseDownCapture,
            onMouseUpCapture: baseProps.onMouseUpCapture,
            onKeyDownCapture: baseProps.onKeyDownCapture,
            onKeyUpCapture: baseProps.onKeyUpCapture,
            onTouchStartCapture: baseProps.onTouchStartCapture,
            onTouchEndCapture: baseProps.onTouchEndCapture,
            onPointerDownCapture: baseProps.onPointerDownCapture,
            onPointerUpCapture: baseProps.onPointerUpCapture,
            onClickCapture: baseProps.onClickCapture,
            testId: testId,
            href: baseProps.isDisabled ? undefined : href,
            role: baseProps.isDisabled ? 'link' : undefined,
            "aria-disabled": baseProps.isDisabled === true ? true : undefined,
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            componentName: "LinkButton"
        }, baseProps.children);
    };
    const $9768e745d0380796$var$WithRef = (0, $5uXOq.forwardRef)($9768e745d0380796$var$LinkButtonBase);
    const $9768e745d0380796$var$LinkButton = (0, $5uXOq.memo)($9768e745d0380796$var$WithRef);
    var $9768e745d0380796$export$2e2bcd8739ae039 = $9768e745d0380796$var$LinkButton;
});
parcelRegister("1kVqg", function(module, exports) {
    $parcel$export(module.exports, "Show", ()=>$7b5b5f6fd54f1de9$export$f6a3d19be20f5819);
    var $f8Sb3;
    var $8CUq3;
    var $2pf2j;
    function $7b5b5f6fd54f1de9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $7b5b5f6fd54f1de9$var$showAboveQueries = (0, (0, parcelRequire("2pf2j")).UNSAFE_buildAboveMediaQueryCSS)({
        display: 'revert'
    });
    const $7b5b5f6fd54f1de9$var$showBelowQueries = (0, (0, parcelRequire("2pf2j")).UNSAFE_buildBelowMediaQueryCSS)({
        display: 'revert'
    });
    const $7b5b5f6fd54f1de9$var$defaultHiddenStyles = {
        name: "eivff4",
        styles: "display:none"
    };
    const $7b5b5f6fd54f1de9$export$f6a3d19be20f5819 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
        const resolvedStyles = (0, (0, parcelRequire("8CUq3")).parseXcss)(xcss);
        return (0, (0, parcelRequire("f8Sb3")).jsx)(AsElement, {
            className: resolvedStyles.static,
            css: [
                $7b5b5f6fd54f1de9$var$defaultHiddenStyles,
                above && $7b5b5f6fd54f1de9$var$showAboveQueries[above],
                below && $7b5b5f6fd54f1de9$var$showBelowQueries[below],
                resolvedStyles.emotion
            ]
        }, children);
    };
});
parcelRegister("2pf2j", function(module, exports) {
    $parcel$export(module.exports, "UNSAFE_buildAboveMediaQueryCSS", ()=>$f32e5b846e53517d$export$918f8818cfbbeb2c);
    $parcel$export(module.exports, "UNSAFE_buildBelowMediaQueryCSS", ()=>$f32e5b846e53517d$export$b2a4e2b0c6417297);
    var $f8Sb3;
    var $eXt4g;
    var $h9kUS;
    const $f32e5b846e53517d$export$918f8818cfbbeb2c = (input)=>{
        return (0, (0, parcelRequire("eXt4g")).UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>({
                ...acc,
                [breakpoint]: (0, (0, parcelRequire("f8Sb3")).css)({
                    [(0, (0, parcelRequire("h9kUS")).media).above[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
                })
            }), {});
    };
    const $f32e5b846e53517d$export$b2a4e2b0c6417297 = (input)=>{
        return (0, (0, parcelRequire("eXt4g")).UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>{
            if (breakpoint === 'xxs') return acc;
            return {
                ...acc,
                [breakpoint]: (0, (0, parcelRequire("f8Sb3")).css)({
                    [(0, (0, parcelRequire("h9kUS")).UNSAFE_media).below[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
                })
            };
        }, {});
    };
});
parcelRegister("eXt4g", function(module, exports) {
    $parcel$export(module.exports, "UNSAFE_BREAKPOINTS_ORDERED_LIST", ()=>$3f07a1aff81e4a42$export$2d293d9871c38e91);
    const $3f07a1aff81e4a42$export$e5ee4fe8b989fd09 = {
        xxs: {
            gridItemGutter: "var(--ds-space-200, 16px)",
            gridMargin: "var(--ds-space-200, 16px)",
            min: '0rem',
            max: '29.99rem'
        },
        xs: {
            gridItemGutter: "var(--ds-space-200, 16px)",
            gridMargin: "var(--ds-space-200, 16px)",
            min: '30rem',
            max: '47.99rem'
        },
        sm: {
            gridItemGutter: "var(--ds-space-200, 16px)",
            gridMargin: "var(--ds-space-300, 24px)",
            min: '48rem',
            max: '63.99rem'
        },
        md: {
            gridItemGutter: "var(--ds-space-300, 24px)",
            gridMargin: "var(--ds-space-400, 32px)",
            min: '64rem',
            max: '89.99rem'
        },
        lg: {
            gridItemGutter: "var(--ds-space-400, 32px)",
            gridMargin: "var(--ds-space-400, 32px)",
            min: '90rem',
            max: '110.49rem'
        },
        xl: {
            gridItemGutter: "var(--ds-space-400, 32px)",
            gridMargin: "var(--ds-space-500, 40px)",
            min: '110.5rem',
            max: null
        }
    };
    const $3f07a1aff81e4a42$export$2d293d9871c38e91 = Object.keys($3f07a1aff81e4a42$export$e5ee4fe8b989fd09);
    const $3f07a1aff81e4a42$export$b7ed752a57b4177b = $3f07a1aff81e4a42$export$2d293d9871c38e91[0];
});
const $7c15fdea32a398a0$export$9c51afe8741be906 = 'responsive-button.ui.responsive-button';
parcelRegister("aCKi5", function(module, exports) {
    $parcel$export(module.exports, "ShortcutLabel", ()=>$e8926de4a65ad47f$export$dfa0cc182ab7b0c3);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    const $e8926de4a65ad47f$export$dfa0cc182ab7b0c3 = ({ text: text })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            "aria-hidden": true,
            xcss: $e8926de4a65ad47f$var$ShortcutLabelComponentStyles
        }, text);
    const $e8926de4a65ad47f$var$ShortcutLabelComponentStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'inline-block',
        backgroundColor: 'color.background.neutral',
        borderRadius: 'border.radius.100',
        fontSize: "var(--ds-space-150, 12px)",
        lineHeight: "var(--ds-space-150, 12px)",
        paddingTop: 'space.075',
        paddingBottom: 'space.075',
        paddingLeft: 'space.100',
        paddingRight: 'space.100'
    });
});
parcelRegister("fvdWw", function(module, exports) {
    $parcel$export(module.exports, "getRoadmapSettingsUrl", ()=>$8cf4cb14d5b6598f$export$5466ff98ef58e78a);
    const $8cf4cb14d5b6598f$export$5466ff98ef58e78a = (isCMP, projectKey, boardId)=>{
        const cmpRoadmapConfigUrl = `/jira/software/c/projects/${projectKey}/boards/${boardId}?config=timelineConfig`;
        const tmpRoadmapConfigUrl = `/jira/software/projects/${projectKey}/settings/boards/${boardId}/timeline`;
        return isCMP ? cmpRoadmapConfigUrl : tmpRoadmapConfigUrl;
    };
});
parcelRegister("1sV0H", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$eb617a582d6440fa$export$2e2bcd8739ae039);
    var $7VHMR;
    var $eb617a582d6440fa$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        moreSettingsMenuLabel: {
            "id": "roadmap.standard-roadmap.header.more-settings.more-settings-menu-label",
            "defaultMessage": "More"
        },
        moreSettingsButtonLabel: {
            "id": "roadmap.standard-roadmap.header.more-settings.more-settings-button-label",
            "defaultMessage": "Configure Timeline"
        },
        feedbackButtonLabel: {
            "id": "roadmap.standard-roadmap.header.more-settings.feedback-button-label",
            "defaultMessage": "Give feedback"
        },
        feedbackCollectorTitle: {
            "id": "roadmap.standard-roadmap.header.more-settings.feedback-collector-title",
            "defaultMessage": "Give feedback to Atlassian"
        },
        feedbackCollectorDescription: {
            "id": "roadmap.standard-roadmap.header.more-settings.feedback-collector-description",
            "defaultMessage": "Select Jira Timeline feedback type"
        },
        enterFullScreen: {
            "id": "roadmap.standard-roadmap.header.more-settings.enter-full-screen",
            "defaultMessage": "Enter full screen"
        },
        exitFullScreen: {
            "id": "roadmap.standard-roadmap.header.more-settings.exit-full-screen",
            "defaultMessage": "Exit full screen"
        }
    });
});
parcelRegister("a4l5H", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$30da6a2368c61aab$export$2e2bcd8739ae039);
    var $bC2fB;
    var $9fPrG;
    var $igaiw;
    var $fVm8c;
    var $jKbWr;
    var $9aaGe;
    var $30da6a2368c61aab$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((state)=>({
            ShareModalWithAnalytics: (0, parcelRequire("jKbWr")).default,
            roadmapAri: (0, (0, parcelRequire("9fPrG")).getSourceARI)(state) || (0, (0, parcelRequire("igaiw")).getRoadmapAri)(state)
        }), {
        onExportCsv: (0, (0, parcelRequire("fVm8c")).exportCsv)
    })((0, (0, parcelRequire("9aaGe")).default));
});
parcelRegister("igaiw", function(module, exports) {
    $parcel$export(module.exports, "getShareTableProps", ()=>$b43d7bea14503bf3$export$377240b7d7caf8d3);
    $parcel$export(module.exports, "getRoadmapAri", ()=>$b43d7bea14503bf3$export$ad07c153802f7136);
    var $24ebX;
    var $ggx2p;
    var $9fPrG;
    var $4gYYI;
    var $5IiTZ;
    var $bM42j;
    var $1cn7Z;
    const $b43d7bea14503bf3$var$additionalSpaceForAssigneeLozenge = (0, (0, parcelRequire("ggx2p")).MAX_LOZENGE_WIDTH);
    const $b43d7bea14503bf3$export$377240b7d7caf8d3 = (0, (0, parcelRequire("24ebX")).createSelector)((0, (0, parcelRequire("1cn7Z")).getItems), (0, (0, parcelRequire("bM42j")).getExpandedItems), (0, (0, parcelRequire("4gYYI")).getToday), (0, (0, parcelRequire("5IiTZ")).getListWidth), (0, (0, parcelRequire("1cn7Z")).getTableHeight), (0, (0, parcelRequire("1cn7Z")).getItemHeight), (0, (0, parcelRequire("1cn7Z")).getTableHeaderItems), (items, expandedItems, today, listWidth, listHeight, itemHeight, headerItems)=>({
            items: items,
            expandedItems: expandedItems,
            today: today,
            listWidth: listWidth + $b43d7bea14503bf3$var$additionalSpaceForAssigneeLozenge,
            listHeight: listHeight,
            itemHeight: itemHeight,
            headerItems: headerItems
        }));
    const $b43d7bea14503bf3$export$9cd9650c80504278 = (0, (0, parcelRequire("24ebX")).createSelector)((0, (0, parcelRequire("9fPrG")).getCloudId), (cloudId)=>cloudId != null && cloudId !== '' ? `ari:cloud:jira:${cloudId}` : null);
    const $b43d7bea14503bf3$export$ad07c153802f7136 = (0, (0, parcelRequire("24ebX")).createSelector)($b43d7bea14503bf3$export$9cd9650c80504278, (0, (0, parcelRequire("4gYYI")).getProjectId), (baseAri, projectId)=>{
        if (baseAri == null || baseAri === '' || projectId == null) return '';
        return `${baseAri}:project/${projectId}`;
    });
});
parcelRegister("24ebX", function(module, exports) {
    $parcel$export(module.exports, "createWeakMapSelector", ()=>$f4af8f8b2496e057$export$3a90d1d234e724b5);
    $parcel$export(module.exports, "createSelector", ()=>$f4af8f8b2496e057$export$595d22ed68ca2841);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $eKGsF;
    const $f4af8f8b2496e057$var$weakMapMemoize = (func)=>{
        const memorizer = (0, (0, parcelRequire("eKGsF")).createMemorizer)();
        return (...args)=>{
            const cached = memorizer.read(args);
            if (cached !== undefined) return (0, (0, parcelRequire("eKGsF")).toReturnValue)(cached);
            const result = func.apply(func, args);
            memorizer.store(args, result);
            return result;
        };
    };
    const $f4af8f8b2496e057$export$3a90d1d234e724b5 = (0, $dGvGJ.createSelectorCreator)($f4af8f8b2496e057$var$weakMapMemoize);
    const $f4af8f8b2496e057$export$595d22ed68ca2841 = (0, $dGvGJ.createSelectorCreator)((0, $dGvGJ.defaultMemoize));
});
parcelRegister("eKGsF", function(module, exports) {
    $parcel$export(module.exports, "toReturnValue", ()=>$a725e29cfc60dcfc$export$9f3707bed4fc53c8);
    $parcel$export(module.exports, "createMemorizer", ()=>$a725e29cfc60dcfc$export$9db09f4ba21f9d2a);
    const $a725e29cfc60dcfc$var$UNDEFINED = {};
    const $a725e29cfc60dcfc$var$NULL = {};
    const $a725e29cfc60dcfc$export$7abc386bcfed62e1 = (key)=>{
        if (key === undefined) return $a725e29cfc60dcfc$var$UNDEFINED;
        if (key === null) return $a725e29cfc60dcfc$var$NULL;
        return key;
    };
    const $a725e29cfc60dcfc$export$9f3707bed4fc53c8 = (x)=>{
        if (x === $a725e29cfc60dcfc$var$UNDEFINED) return undefined;
        if (x === $a725e29cfc60dcfc$var$NULL) return null;
        return x;
    };
    const $a725e29cfc60dcfc$var$getFromWeakMapChain = (args, index, map)=>{
        const element = map.get($a725e29cfc60dcfc$export$7abc386bcfed62e1(args[index]));
        if (index < args.length - 1) {
            if (element) return $a725e29cfc60dcfc$var$getFromWeakMapChain(args, index + 1, element);
            return undefined;
        }
        return element;
    };
    const $a725e29cfc60dcfc$var$storeToEmptyWeakMapChain = (args, index, map, result)=>{
        if (index < args.length - 1) {
            const subMap = new WeakMap();
            map.set($a725e29cfc60dcfc$export$7abc386bcfed62e1(args[index]), subMap);
            $a725e29cfc60dcfc$var$storeToEmptyWeakMapChain(args, index + 1, subMap, result);
        } else map.set($a725e29cfc60dcfc$export$7abc386bcfed62e1(args[index]), result);
    };
    const $a725e29cfc60dcfc$var$storeToWeakMapChain = (args, index, map, result)=>{
        if (index < args.length - 1) {
            const element = map.get($a725e29cfc60dcfc$export$7abc386bcfed62e1(args[index]));
            if (element) $a725e29cfc60dcfc$var$storeToWeakMapChain(args, index + 1, element, result);
            else {
                const subMap = new WeakMap();
                map.set($a725e29cfc60dcfc$export$7abc386bcfed62e1(args[index]), subMap);
                $a725e29cfc60dcfc$var$storeToEmptyWeakMapChain(args, index + 1, subMap, result);
            }
        } else map.set($a725e29cfc60dcfc$export$7abc386bcfed62e1(args[index]), result);
    };
    const $a725e29cfc60dcfc$export$9db09f4ba21f9d2a = ()=>{
        const weakMap = new WeakMap();
        return {
            store: (args, result)=>result !== undefined ? $a725e29cfc60dcfc$var$storeToWeakMapChain(args, 0, weakMap, result) : $a725e29cfc60dcfc$var$storeToWeakMapChain(args, 0, weakMap, $a725e29cfc60dcfc$var$UNDEFINED),
            read: (args)=>$a725e29cfc60dcfc$var$getFromWeakMapChain(args, 0, weakMap)
        };
    };
});
parcelRegister("ggx2p", function(module, exports) {
    $parcel$export(module.exports, "DATE_RANGE_LIMIT", ()=>$8da406a51bfacce4$export$3f8939c9b1d3b1e3);
    $parcel$export(module.exports, "MAX_LOZENGE_WIDTH", ()=>$8da406a51bfacce4$export$c13c0c5385d46707);
    var $iZN6h;
    const $8da406a51bfacce4$export$3f8939c9b1d3b1e3 = {
        [(0, (0, parcelRequire("iZN6h")).QUARTERS)]: 18,
        [(0, (0, parcelRequire("iZN6h")).MONTHS)]: 12,
        [(0, (0, parcelRequire("iZN6h")).WEEKS)]: 12
    };
    const $8da406a51bfacce4$export$c13c0c5385d46707 = 72;
});
parcelRegister("jKbWr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8711a5a3aa419de4$export$2e2bcd8739ae039);
    var $bC2fB;
    var $fWch8;
    var $95lzH;
    var $5JupA;
    var $9cep4;
    var $8711a5a3aa419de4$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((state)=>({
            ShareModal: (0, parcelRequire("5JupA")).default,
            isDependenciesVisible: (0, (0, parcelRequire("fWch8")).isDependenciesVisibleInQuery)(state),
            isProgressVisible: (0, (0, parcelRequire("fWch8")).isProgressVisibleInQuery)(state),
            isWarningsVisible: (0, (0, parcelRequire("fWch8")).isWarningsVisibleInQuery)(state),
            isReleasesVisible: (0, (0, parcelRequire("fWch8")).isReleasesVisibleInQuery)(state),
            imageExportMetrics: (0, (0, parcelRequire("95lzH")).getRoadmapImageExportMetrics)(state)
        }), {})((0, (0, parcelRequire("9cep4")).default));
});
parcelRegister("95lzH", function(module, exports) {
    $parcel$export(module.exports, "getRoadmapImageExportMetrics", ()=>$d4f5bfb6f0cf9a3b$export$92ac8d7608dcdf31);
    $parcel$export(module.exports, "getRoadmapLoadedAnalyticsData", ()=>$d4f5bfb6f0cf9a3b$export$e68fb6340167d9bb);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $9fPrG;
    var $hFyhA;
    var $fWch8;
    var $hhYQB;
    var $2IdXh;
    var $igaiw;
    var $3rLbe;
    var $apC9o;
    const $d4f5bfb6f0cf9a3b$export$8b3528166f5efd8a = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("hhYQB")).getIssuesFilter), (0, (0, parcelRequire("9fPrG")).isClassic), ({ assignees: assignees, issueTypes: issueTypes, statuses: statuses, text: text, labels: labels, versions: versions, quickFilters: quickFilters, customFilters: customFilters, goals: goals }, isClassic)=>({
            assignees: assignees.length > 0,
            issueTypes: issueTypes.length > 0,
            statuses: statuses.length > 0,
            text: text.length > 0,
            labels: labels.length > 0,
            versions: versions.length > 0,
            quickFilters: quickFilters.length > 0,
            customFilters: customFilters.length > 0,
            isClassic: isClassic,
            goals: goals.length > 0
        }));
    const $d4f5bfb6f0cf9a3b$export$92ac8d7608dcdf31 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("igaiw")).getShareTableProps), (0, (0, parcelRequire("hFyhA")).getIssueIds), $d4f5bfb6f0cf9a3b$export$8b3528166f5efd8a, (0, (0, parcelRequire("apC9o")).getRoadmapImageExportMetrics));
    const $d4f5bfb6f0cf9a3b$export$e68fb6340167d9bb = (0, $dGvGJ.createSelector)([
        (0, (0, parcelRequire("hhYQB")).getTimelineMode),
        $d4f5bfb6f0cf9a3b$export$8b3528166f5efd8a,
        (0, (0, parcelRequire("fWch8")).isShared),
        (0, (0, parcelRequire("hhYQB")).getLevelOneSetting),
        (0, (0, parcelRequire("3rLbe")).getHighlightedVersions),
        (0, (0, parcelRequire("2IdXh")).getFilteredIssueCount)
    ], (timelineMode, filters, shared, levelOneSetting, highlightedVersions, filteredIssueCount)=>({
            shared: shared,
            timelineMode: timelineMode,
            filters: filters,
            levelOneSetting: levelOneSetting,
            highlightedVersionCount: highlightedVersions.length,
            filteredIssueCount: filteredIssueCount
        }));
});
parcelRegister("apC9o", function(module, exports) {
    $parcel$export(module.exports, "getRoadmapImageExportMetrics", ()=>$3ef4c19f50d2abb1$export$92ac8d7608dcdf31);
    const $3ef4c19f50d2abb1$export$92ac8d7608dcdf31 = (shareTableProps, issueIds, filtersAnalyticsData)=>{
        let visibleStoriesCount = 0;
        const { items: items, expandedItems: expandedItems } = shareTableProps;
        items.forEach((item)=>{
            if (expandedItems[item.id]) visibleStoriesCount += item.childItems?.length ?? 0;
        });
        const visibleEpicsCount = items.length;
        return {
            filters: filtersAnalyticsData,
            visibleEpicsCount: visibleEpicsCount,
            visibleStoriesCount: visibleStoriesCount,
            issuesCount: issueIds.length
        };
    };
});
parcelRegister("5JupA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6efff15577b0d8dc$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $lfTZh;
    var $kxZPA;
    var $eKt4x;
    const $6efff15577b0d8dc$var$ShareModal = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("kQbZk")), {
        moduleId: "./src/packages/software/roadmap/standard/src/view/header/share/share-modal-with-analytics/share-modal/index.tsx"
    });
    const $6efff15577b0d8dc$var$AsyncShareModal = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "async-standard-roadmap-share-modal",
            packageName: (0, (0, parcelRequire("eKt4x")).ROADMAP_PACKAGE_NAME),
            fallback: "flag"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "standard-roadmap-share-modal",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($6efff15577b0d8dc$var$ShareModal, props)));
    var $6efff15577b0d8dc$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($6efff15577b0d8dc$var$AsyncShareModal);
});
parcelRegister("kQbZk", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("iAfAl")
    ]).then(()=>parcelRequire('iWLvg'));
});
parcelRegister("9cep4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$700e7b6f82e5b391$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iXVV6;
    const $700e7b6f82e5b391$var$ShareModalWithAnalytics = ({ isDependenciesVisible: isDependenciesVisible, isProgressVisible: isProgressVisible, isWarningsVisible: isWarningsVisible, isReleasesVisible: isReleasesVisible, imageExportMetrics: imageExportMetrics, ShareModal: ShareModal, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: "share",
            sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa),
            attributes: {
                isDependenciesVisible: isDependenciesVisible,
                isProgressVisible: isProgressVisible,
                isWarningsVisible: isWarningsVisible,
                isReleasesVisible: isReleasesVisible,
                ...imageExportMetrics
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(ShareModal, props));
    var $700e7b6f82e5b391$export$2e2bcd8739ae039 = $700e7b6f82e5b391$var$ShareModalWithAnalytics;
});
parcelRegister("9aaGe", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$872caf8073e8fead$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $42CjB;
    var $fVnbM;
    var $BLPHT;
    var $6B7KL;
    var $aRoVz;
    var $kOEld;
    var $gC0dr;
    var $i8Qvm;
    var $f5TWP;
    var $koVbs;
    var $3HwlS;
    var $8zOmE;
    var $2NMNM;
    var $6lmg7;
    var $5GqLe;
    var $iL8EU;
    var $d38Sb;
    var $dCm1o;
    var $doZTA;
    var $bTl1K;
    var $28deQ;
    const $872caf8073e8fead$var$ShareCustomTriggerButton = ({ isDisabled: isDisabled, isSelected: isSelected, onClick: onClick }, triggerProps)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6lmg7")).ResponsiveButton), {
            label: formatMessage((0, (0, parcelRequire("bTl1K")).default).share),
            icon: (0, ($parcel$interopDefault((0, parcelRequire("kOEld"))))),
            onClick: onClick,
            isDisabled: isDisabled,
            isSelected: isSelected,
            ...triggerProps
        });
    };
    const $872caf8073e8fead$var$Share = ({ ShareModalWithAnalytics: ShareModalWithAnalytics, roadmapAri: roadmapAri, onExportCsv: onExportCsv })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [routerState] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const [isModalOpen, setIsModalOpen] = (0, $5uXOq.useState)(false);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const onModalOpen = (0, $5uXOq.useCallback)(()=>{
            const analyticsEvent = createAnalyticsEvent({});
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'exportImage clicked');
            setIsModalOpen(true);
        }, [
            createAnalyticsEvent
        ]);
        const onModalClose = (0, $5uXOq.useCallback)(()=>{
            setIsModalOpen(false);
        }, []);
        const onExportCsvCallback = (0, $5uXOq.useCallback)(()=>{
            const analyticsEvent = createAnalyticsEvent({});
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'exportCsv clicked');
            onExportCsv({
                inferredStartDateHeader: formatMessage((0, (0, parcelRequire("bTl1K")).default).exportSpreadsheetInferredStartDate),
                inferredDueDateHeader: formatMessage((0, (0, parcelRequire("bTl1K")).default).exportSpreadsheetInferredDueDate)
            });
        }, [
            createAnalyticsEvent,
            onExportCsv,
            formatMessage
        ]);
        const exportButton = (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d38Sb")).ExportButton), {
            onExportCsv: onExportCsv,
            onExportAsImageClick: onModalOpen
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("BLPHT")).default), {
            trigger: ({ triggerRef: triggerRef, ...props })=>(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
                    label: formatMessage((0, (0, parcelRequire("bTl1K")).default).exportButton),
                    icon: (0, ($parcel$interopDefault((0, parcelRequire("gC0dr"))))),
                    ref: triggerRef,
                    isTooltipDisabled: false,
                    ...props
                }) : (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6lmg7")).ResponsiveButton), {
                    label: formatMessage((0, (0, parcelRequire("bTl1K")).default).exportButton),
                    icon: (0, ($parcel$interopDefault((0, parcelRequire("gC0dr"))))),
                    ref: triggerRef,
                    ...props
                }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                    ...props,
                    appearance: "subtle",
                    iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("gC0dr"))))), {
                        label: formatMessage((0, (0, parcelRequire("bTl1K")).default).exportButtonIcon),
                        color: "currentColor",
                        spacing: "spacious"
                    }),
                    ref: triggerRef
                }, formatMessage((0, (0, parcelRequire("bTl1K")).default).exportButton))
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRoVz")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            onClick: onModalOpen
        }, formatMessage((0, (0, parcelRequire("bTl1K")).default).exportImagePng)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            onClick: onExportCsvCallback
        }, formatMessage((0, (0, parcelRequire("bTl1K")).default).exportSpreadsheetCsv))));
        const shareButton = !(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && ((0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iL8EU")).default), {
            integrationType: (0, (0, parcelRequire("5GqLe")).integrationTypes).ROADMAP,
            productId: "jira",
            subProductId: "jira-software",
            shareLink: (0, (0, parcelRequire("28deQ")).getShareUrl)(routerState.location.pathname, routerState.location.search),
            shareTitle: formatMessage((0, (0, parcelRequire("bTl1K")).default).timeline),
            shareContentType: "roadmap",
            objectAri: roadmapAri,
            renderCustomTriggerButton: $872caf8073e8fead$var$ShareCustomTriggerButton
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iL8EU")).default), {
            integrationType: (0, (0, parcelRequire("5GqLe")).integrationTypes).ROADMAP,
            triggerButtonAppearance: "subtle",
            triggerButtonStyle: "icon-with-text",
            productId: "jira",
            subProductId: "jira-software",
            shareLink: (0, (0, parcelRequire("28deQ")).getShareUrl)(routerState.location.pathname, routerState.location.search),
            shareTitle: formatMessage((0, (0, parcelRequire("bTl1K")).default).timeline),
            shareContentType: "roadmap",
            objectAri: roadmapAri
        }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.100"
        }, shareButton, exportButton), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8Qvm")).default), null, isModalOpen && (0, ($parcel$interopDefault($5uXOq))).createElement(ShareModalWithAnalytics, {
            onClose: onModalClose
        })));
    };
    var $872caf8073e8fead$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($872caf8073e8fead$var$Share);
});
parcelRegister("kOEld", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $f277c50ed79b6741$var$_react = $f277c50ed79b6741$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $f277c50ed79b6741$var$_share = $f277c50ed79b6741$var$_interopRequireDefault((parcelRequire("empdx")));
    var $f277c50ed79b6741$var$_share2 = $f277c50ed79b6741$var$_interopRequireDefault((parcelRequire("jZX0t")));
    function $f277c50ed79b6741$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $f277c50ed79b6741$var$ShareIcon = (props)=>$f277c50ed79b6741$var$_react.default.createElement($f277c50ed79b6741$var$_share.default, Object.assign({
            LEGACY_fallbackIcon: $f277c50ed79b6741$var$_share2.default
        }, props));
    $f277c50ed79b6741$var$ShareIcon.Name = 'ShareIconMigration';
    var $f277c50ed79b6741$var$_default = module.exports.default = $f277c50ed79b6741$var$ShareIcon;
});
parcelRegister("empdx", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $a746ae65a0e1944c$var$_react = $a746ae65a0e1944c$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $a746ae65a0e1944c$var$_UNSAFE_baseNew = $a746ae65a0e1944c$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $a746ae65a0e1944c$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $a746ae65a0e1944c$var$ShareIcon = (props)=>$a746ae65a0e1944c$var$_react.default.createElement($a746ae65a0e1944c$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M10.434 11.717a1.75 1.75 0 1 0 3.131 1.566 1.75 1.75 0 0 0-3.13-1.566Zm0 0L5.316 8.783m0 0a1.74 1.74 0 0 0 0-1.566m0 1.566a1.75 1.75 0 1 1 0-1.566m0 0 5.118-2.934m0 0a1.75 1.75 0 1 0 3.13-1.566 1.75 1.75 0 0 0-3.13 1.566Z"/>`
        }, props));
    $a746ae65a0e1944c$var$ShareIcon.displayName = 'ShareIcon';
    var $a746ae65a0e1944c$var$_default = module.exports.default = $a746ae65a0e1944c$var$ShareIcon;
});
parcelRegister("jZX0t", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $e8f17c524b03e26b$var$_react = $e8f17c524b03e26b$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $e8f17c524b03e26b$var$_share = $e8f17c524b03e26b$var$_interopRequireDefault((parcelRequire("empdx")));
    function $e8f17c524b03e26b$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $e8f17c524b03e26b$var$ShareIcon = (props)=>$e8f17c524b03e26b$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m12-4a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m0 14a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/><path d="m7 13.562 8.66 5 1-1.732-8.66-5z"/><path d="m7 10.83 1 1.732 8.66-5-1-1.732z"/></g></svg>`
        }, props, {
            newIcon: $e8f17c524b03e26b$var$_share.default
        }));
    $e8f17c524b03e26b$var$ShareIcon.displayName = 'ShareIcon';
    var $e8f17c524b03e26b$var$_default = module.exports.default = $e8f17c524b03e26b$var$ShareIcon;
});
parcelRegister("gC0dr", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c1805ccdd7796085$var$_react = $c1805ccdd7796085$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c1805ccdd7796085$var$_upload = $c1805ccdd7796085$var$_interopRequireDefault((parcelRequire("50qBU")));
    var $c1805ccdd7796085$var$_export = $c1805ccdd7796085$var$_interopRequireDefault((parcelRequire("61MPp")));
    function $c1805ccdd7796085$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c1805ccdd7796085$var$UploadIcon = (props)=>$c1805ccdd7796085$var$_react.default.createElement($c1805ccdd7796085$var$_upload.default, Object.assign({
            LEGACY_fallbackIcon: $c1805ccdd7796085$var$_export.default
        }, props));
    $c1805ccdd7796085$var$UploadIcon.Name = 'UploadIconMigration';
    var $c1805ccdd7796085$var$_default = module.exports.default = $c1805ccdd7796085$var$UploadIcon;
});
parcelRegister("50qBU", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $3a519821f4edd432$var$_react = $3a519821f4edd432$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $3a519821f4edd432$var$_UNSAFE_baseNew = $3a519821f4edd432$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $3a519821f4edd432$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $3a519821f4edd432$var$UploadIcon = (props)=>$3a519821f4edd432$var$_react.default.createElement($3a519821f4edd432$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 9v4c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V9M8 11V2.25m-4 3.5 4-4 4 4"/>`
        }, props));
    $3a519821f4edd432$var$UploadIcon.displayName = 'UploadIcon';
    var $3a519821f4edd432$var$_default = module.exports.default = $3a519821f4edd432$var$UploadIcon;
});
parcelRegister("61MPp", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $4638b6534bbbec0b$var$_react = $4638b6534bbbec0b$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $4638b6534bbbec0b$var$_upload = $4638b6534bbbec0b$var$_interopRequireDefault((parcelRequire("50qBU")));
    function $4638b6534bbbec0b$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $4638b6534bbbec0b$var$ExportIcon = (props)=>$4638b6534bbbec0b$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M13 6.491V16a1 1 0 0 1-2 0V6.491L9.784 7.697a1.05 1.05 0 0 1-1.478 0 1.03 1.03 0 0 1 0-1.465l2.955-2.929a1.05 1.05 0 0 1 1.478 0l2.955 2.93c.408.404.408 1.06 0 1.464a1.05 1.05 0 0 1-1.478 0zM9 9v2H7c-.002 0 0 7.991 0 7.991 0 .004 9.994.009 9.994.009.003 0 .006-7.991.006-7.991 0-.006-2-.009-2-.009V9h2c1.105 0 2 .902 2 2.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.01 2.01 0 0 1 5 18.991V11.01A2 2 0 0 1 7 9z"/></svg>`
        }, props, {
            newIcon: $4638b6534bbbec0b$var$_upload.default
        }));
    $4638b6534bbbec0b$var$ExportIcon.displayName = 'ExportIcon';
    var $4638b6534bbbec0b$var$_default = module.exports.default = $4638b6534bbbec0b$var$ExportIcon;
});
parcelRegister("5GqLe", function(module, exports) {
    $parcel$export(module.exports, "integrationTypes", ()=>$0970fea694a8095f$export$a7359bcfb0ca8e98);
    const $0970fea694a8095f$export$a7359bcfb0ca8e98 = {
        BENTO_ISSUE: 'bentoIssue',
        CLASSIC_BOARD: 'classicBoard',
        NEXTGEN_BOARD: 'nextGenBoard',
        ROADMAP: 'roadmap',
        TIMELINE: 'timeline',
        LIST: 'list',
        CALENDAR: 'calendar',
        BOARD: 'board',
        FORM: 'form',
        SUMMARY: 'summary',
        ATTACHMENTS: 'attachments'
    };
});
parcelRegister("iL8EU", function(module, exports) {
    $parcel$export(module.exports, "ShareLoadingPlaceholder", ()=>$4e5335f44d688bbf$export$5619d05bf511476b);
    $parcel$export(module.exports, "default", ()=>$4e5335f44d688bbf$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $fVnbM;
    var $jZX0t;
    var $heNNl;
    var $koVbs;
    var $lfTZh;
    var $kxZPA;
    var $Kpokz;
    const $4e5335f44d688bbf$export$5619d05bf511476b = ({ triggerButtonStyle: triggerButtonStyle = 'icon-only' })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "subtle",
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("jZX0t"))))), {
                size: "medium",
                label: formatMessage((0, (0, parcelRequire("Kpokz")).messages).shareTriggerButtonText),
                primaryColor: `var(--ds-icon, ${(0, $829f609a65d26a98$exports).N30})`
            }),
            isDisabled: true
        }, triggerButtonStyle === 'icon-with-text' ? formatMessage((0, (0, parcelRequire("Kpokz")).messages).shareTriggerButtonText) : null));
    };
    const $4e5335f44d688bbf$var$ShareButton = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("jHQiG")), {
        ssr: false,
        moduleId: "./src/packages/growth/share-button/src/ui/index.tsx"
    });
    var $4e5335f44d688bbf$export$2e2bcd8739ae039 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "async.share.button",
            packageName: "share-button"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "share-button",
            fallback: props.renderCustomTriggerButton === undefined ? (0, ($parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$export$5619d05bf511476b, {
                triggerButtonStyle: props.triggerButtonStyle
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement(props.renderCustomTriggerButton, {
                isDisabled: true,
                onClick: (0, ($parcel$interopDefault($8Rkzz)))
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$var$ShareButton, props)));
});
parcelRegister("Kpokz", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$026d1258a1c95d57$export$defe85febe8b728c);
    var $7VHMR;
    const $026d1258a1c95d57$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        shareTriggerButtonText: {
            "id": "share-button.share-trigger-button-text",
            "defaultMessage": "Share"
        }
    });
});
parcelRegister("jHQiG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("bfk3F")
    ]).then(()=>parcelRequire('7aU9g'));
});
parcelRegister("d38Sb", function(module, exports) {
    $parcel$export(module.exports, "ExportButton", ()=>$56c018896df0ff06$export$bec7fd3dce2f28c0);
    var $5uXOq = parcelRequire("5uXOq");
    var $42CjB;
    var $BLPHT;
    var $6B7KL;
    var $aRoVz;
    var $gC0dr;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $22OQR;
    var $6lmg7;
    var $dCm1o;
    var $8YMED;
    const $56c018896df0ff06$export$bec7fd3dce2f28c0 = ({ onExportCsv: onExportCsv, onExportAsImageClick: onExportAsImageClick, isThemedButton: isThemedButton })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const onExportCsvCallback = (0, $5uXOq.useCallback)(()=>{
            const analyticsEvent = createAnalyticsEvent({});
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'exportCsv clicked');
            onExportCsv({
                inferredStartDateHeader: formatMessage((0, (0, parcelRequire("8YMED")).default).exportSpreadsheetInferredStartDate),
                inferredDueDateHeader: formatMessage((0, (0, parcelRequire("8YMED")).default).exportSpreadsheetInferredDueDate)
            });
        }, [
            createAnalyticsEvent,
            onExportCsv,
            formatMessage
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("BLPHT")).default), {
            trigger: ({ triggerRef: triggerRef, ...props })=>(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? isThemedButton ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("22OQR")).ThemedButton), {
                    "aria-label": formatMessage((0, (0, parcelRequire("8YMED")).default).exportButton),
                    label: formatMessage((0, (0, parcelRequire("8YMED")).default).exportButton),
                    iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("gC0dr"))))), {
                        label: "",
                        color: "currentColor",
                        spacing: "spacious"
                    }),
                    ref: triggerRef,
                    ...props,
                    testId: "roadmap.timeline-table-kit.ui.header.export.export-button"
                }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
                    label: formatMessage((0, (0, parcelRequire("8YMED")).default).exportButton),
                    icon: (0, ($parcel$interopDefault((0, parcelRequire("gC0dr"))))),
                    ref: triggerRef,
                    isTooltipDisabled: false,
                    ...props,
                    testId: "roadmap.timeline-table-kit.ui.header.export.export-button"
                }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6lmg7")).ResponsiveButton), {
                    label: formatMessage((0, (0, parcelRequire("8YMED")).default).exportButton),
                    icon: (0, ($parcel$interopDefault((0, parcelRequire("gC0dr"))))),
                    ref: triggerRef,
                    ...props
                })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRoVz")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            onClick: onExportAsImageClick
        }, formatMessage((0, (0, parcelRequire("8YMED")).default).exportImagePng)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            onClick: onExportCsvCallback
        }, formatMessage((0, (0, parcelRequire("8YMED")).default).exportSpreadsheetCsv))));
    };
});
parcelRegister("22OQR", function(module, exports) {
    $parcel$export(module.exports, "ThemedButton", ()=>$87e6157378e1cf19$export$f67fb575035cc7d0);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $2rqOp;
    const $87e6157378e1cf19$export$f67fb575035cc7d0 = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(({ as: as, ...props }, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement($87e6157378e1cf19$var$CustomButton, {
            ...props,
            as: as,
            ref: ref
        })));
    const $87e6157378e1cf19$var$CustomButton = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("2rqOp")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1qt3kjry _1g9h1tex _1umfuwj9 _6l8r3x59 _9se5176f _12rallho _zk5uzt2a _18vg2zyf _192e1jcw _fnp717ga _1xjgvy9e _1u0u14e8 _17z218zq _7n83frbu _n2ul1jo4 _1cf1r7td _1d7c1ag4 _nwukvy9e _fsjd4zrn _z1i3eyly",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("8YMED", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3d73b218592e519f$export$2e2bcd8739ae039);
    var $7VHMR;
    var $3d73b218592e519f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        exportButton: {
            "id": "roadmap.timeline-table-kit.header.export.export-button",
            "defaultMessage": "Export"
        },
        exportImagePng: {
            "id": "roadmap.timeline-table-kit.header.export.export-image-png",
            "defaultMessage": "Image (.png)"
        },
        exportSpreadsheetCsv: {
            "id": "roadmap.timeline-table-kit.header.export.export-spreadsheet-csv",
            "defaultMessage": "Spreadsheet (.csv)"
        },
        exportSpreadsheetInferredStartDate: {
            "id": "roadmap.timeline-table-kit.header.export.export-spreadsheet-inferred-start-date",
            "defaultMessage": "Inferred start date"
        },
        exportSpreadsheetInferredDueDate: {
            "id": "roadmap.timeline-table-kit.header.export.export-spreadsheet-inferred-due-date",
            "defaultMessage": "Inferred due date"
        }
    });
});
parcelRegister("bTl1K", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$33a945e95ff0e12e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $33a945e95ff0e12e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        share: {
            "id": "roadmap.standard-roadmap.header.share.share",
            "defaultMessage": "Share"
        },
        export: {
            "id": "roadmap.standard-roadmap.header.share.export",
            "defaultMessage": "Export image"
        },
        exportButton: {
            "id": "roadmap.standard-roadmap.header.share.export-button",
            "defaultMessage": "Export"
        },
        exportImagePng: {
            "id": "roadmap.standard-roadmap.header.share.export-image-png",
            "defaultMessage": "Image (.png)"
        },
        exportSpreadsheetCsv: {
            "id": "roadmap.standard-roadmap.header.share.export-spreadsheet-csv",
            "defaultMessage": "Spreadsheet (.csv)"
        },
        exportButtonIcon: {
            "id": "roadmap.standard-roadmap.header.share.export-button-icon",
            "defaultMessage": "Export icon"
        },
        timeline: {
            "id": "roadmap.standard-roadmap.header.share.timeline",
            "defaultMessage": "Timeline"
        },
        exportSpreadsheetInferredStartDate: {
            "id": "roadmap.standard-roadmap.header.share.export-spreadsheet-inferred-start-date",
            "defaultMessage": "Inferred start date"
        },
        exportSpreadsheetInferredDueDate: {
            "id": "roadmap.standard-roadmap.header.share.export-spreadsheet-inferred-due-date",
            "defaultMessage": "Inferred due date"
        }
    });
});
parcelRegister("28deQ", function(module, exports) {
    $parcel$export(module.exports, "getShareUrl", ()=>$a72d8290696af141$export$3a81dd9bbf5c2322);
    const $a72d8290696af141$export$3a81dd9bbf5c2322 = (path, search)=>{
        const { hostname: hostname, protocol: protocol } = window.location;
        return `${protocol}//${hostname}${path}${search}${search !== '' && search !== undefined ? '&' : '?'}shared`;
    };
});
parcelRegister("47e4t", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3e9ab27c70a96d1d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $42CjB;
    var $8jMCF;
    var $1I7E8;
    var $koVbs;
    var $3HwlS;
    var $8zOmE;
    var $2NMNM;
    var $6lmg7;
    var $dCm1o;
    var $63d23;
    var $1reDi;
    var $jwQhj;
    const $3e9ab27c70a96d1d$var$ViewSettings = ()=>{
        const [viewSettingsOpen, setViewSettingsOpen] = (0, $5uXOq.useState)(false);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const toggleViewSettings = (0, $5uXOq.useCallback)(()=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            });
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, `viewSettings ${viewSettingsOpen ? 'closed' : 'opened'}`);
            setViewSettingsOpen(!viewSettingsOpen);
        }, [
            createAnalyticsEvent,
            viewSettingsOpen
        ]);
        const onClose = (0, $5uXOq.useCallback)(()=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            });
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, 'viewSettings closed');
            setViewSettingsOpen(false);
        }, [
            createAnalyticsEvent
        ]);
        const renderTrigger = (0, $5uXOq.useCallback)((triggerProps)=>(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
                isSelected: viewSettingsOpen,
                icon: (0, ($parcel$interopDefault((0, parcelRequire("8jMCF"))))),
                onClick: toggleViewSettings,
                label: formatMessage((0, (0, parcelRequire("1reDi")).default).viewSettings),
                ...triggerProps
            }) : (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6lmg7")).ResponsiveButton), {
                isSelected: viewSettingsOpen,
                onClick: toggleViewSettings,
                icon: (0, ($parcel$interopDefault((0, parcelRequire("8jMCF"))))),
                label: formatMessage((0, (0, parcelRequire("1reDi")).default).viewSettings),
                ...triggerProps
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement("div", triggerProps, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("63d23")).default), {
                isSelected: viewSettingsOpen,
                onClick: toggleViewSettings
            })), [
            viewSettingsOpen,
            toggleViewSettings,
            formatMessage
        ]);
        const renderContent = (0, $5uXOq.useCallback)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jwQhj")).default), {
                onClose: onClose
            }), [
            onClose
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).Popup), {
            placement: "bottom-end",
            isOpen: viewSettingsOpen,
            onClose: onClose,
            trigger: renderTrigger,
            content: renderContent,
            shouldUseCaptureOnOutsideClick: true
        });
    };
    var $3e9ab27c70a96d1d$export$2e2bcd8739ae039 = $3e9ab27c70a96d1d$var$ViewSettings;
});
parcelRegister("8jMCF", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $60e5d086aacc57a4$var$_react = $60e5d086aacc57a4$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $60e5d086aacc57a4$var$_customize = $60e5d086aacc57a4$var$_interopRequireDefault((parcelRequire("4QAwn")));
    var $60e5d086aacc57a4$var$_preferences = $60e5d086aacc57a4$var$_interopRequireDefault((parcelRequire("5KZxU")));
    function $60e5d086aacc57a4$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $60e5d086aacc57a4$var$CustomizeIcon = (props)=>$60e5d086aacc57a4$var$_react.default.createElement($60e5d086aacc57a4$var$_customize.default, Object.assign({
            LEGACY_fallbackIcon: $60e5d086aacc57a4$var$_preferences.default
        }, props));
    $60e5d086aacc57a4$var$CustomizeIcon.Name = 'CustomizeIconMigration';
    var $60e5d086aacc57a4$var$_default = module.exports.default = $60e5d086aacc57a4$var$CustomizeIcon;
});
parcelRegister("4QAwn", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $3878591d802e976a$var$_react = $3878591d802e976a$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $3878591d802e976a$var$_UNSAFE_baseNew = $3878591d802e976a$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $3878591d802e976a$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $3878591d802e976a$var$CustomizeIcon = (props)=>$3878591d802e976a$var$_react.default.createElement($3878591d802e976a$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M12.25 11.5V9.375a.625.625 0 0 0-.625-.625h-1.75a.625.625 0 0 0-.625.625v4.25c0 .345.28.625.625.625h1.75c.345 0 .625-.28.625-.625zm0 0H16m-16 0h7.5m-3.75-7v2.125c0 .345.28.625.625.625h1.75c.345 0 .625-.28.625-.625v-4.25a.625.625 0 0 0-.625-.625h-1.75a.625.625 0 0 0-.625.625zm0 0H0m16 0H8.5"/>`
        }, props));
    $3878591d802e976a$var$CustomizeIcon.displayName = 'CustomizeIcon';
    var $3878591d802e976a$var$_default = module.exports.default = $3878591d802e976a$var$CustomizeIcon;
});
parcelRegister("5KZxU", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $4310fd5ff8fcaeb0$var$_react = $4310fd5ff8fcaeb0$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $4310fd5ff8fcaeb0$var$_customize = $4310fd5ff8fcaeb0$var$_interopRequireDefault((parcelRequire("4QAwn")));
    function $4310fd5ff8fcaeb0$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $4310fd5ff8fcaeb0$var$PreferencesIcon = (props)=>$4310fd5ff8fcaeb0$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M3 7h3v2H3zm0 8h11v2H3zm7-8h11v2H10zm8 8h3v2h-3z"/><path d="M11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0M9 8a1 1 0 1 0-2 0 1 1 0 0 0 2 0m10 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-2 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0"/></g></svg>`
        }, props, {
            newIcon: $4310fd5ff8fcaeb0$var$_customize.default
        }));
    $4310fd5ff8fcaeb0$var$PreferencesIcon.displayName = 'PreferencesIcon';
    var $4310fd5ff8fcaeb0$var$_default = module.exports.default = $4310fd5ff8fcaeb0$var$PreferencesIcon;
});
parcelRegister("63d23", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3c137d06506d0239$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $8jMCF;
    var $dC5iT;
    var $h9kUS;
    var $8CUq3;
    var $eTXmK;
    var $3bDjY;
    var $koVbs;
    var $8zOmE;
    var $1reDi;
    const $3c137d06506d0239$export$805802ea39f3d804 = ({ isSelected: isSelected, onClick: onClick })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const handleClick = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
            (0, (0, parcelRequire("eTXmK")).default)('timeline-view-settings-clicked', event.timeStamp);
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'viewSettingsButton');
            onClick();
        }, [
            onClick
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $3c137d06506d0239$var$buttonWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $3c137d06506d0239$var$largeButtonStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            testId: "roadmap.standard-roadmap.header.view-settings.button.large",
            "aria-label": formatMessage((0, (0, parcelRequire("1reDi")).default).viewSettings),
            appearance: "default",
            isSelected: isSelected,
            onClick: handleClick,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8jMCF"))))), {
                label: "",
                spacing: "spacious",
                color: "currentColor"
            })
        }, formatMessage((0, (0, parcelRequire("1reDi")).default).viewSettings))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $3c137d06506d0239$var$smallButtonStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: formatMessage((0, (0, parcelRequire("1reDi")).default).viewSettings)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            testId: "roadmap.standard-roadmap.header.view-settings.button.small",
            "aria-label": formatMessage((0, (0, parcelRequire("1reDi")).default).viewSettings),
            appearance: "default",
            isSelected: isSelected,
            onClick: handleClick,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8jMCF"))))), {
                label: "",
                spacing: "spacious",
                color: "currentColor"
            })
        }))));
    };
    var $3c137d06506d0239$export$2e2bcd8739ae039 = $3c137d06506d0239$export$805802ea39f3d804;
    const $3c137d06506d0239$var$largeButtonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'var(--large-button-visibility, none)',
        [(0, (0, parcelRequire("h9kUS")).media).above.md]: {
            display: 'var(--large-button-visibility, block)'
        }
    });
    const $3c137d06506d0239$var$smallButtonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'var(--small-button-visibility, block)',
        [(0, (0, parcelRequire("h9kUS")).media).above.md]: {
            display: 'var(--small-button-visibility, none)'
        }
    });
    const $3c137d06506d0239$var$buttonWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginLeft: 'space.100'
    });
});
parcelRegister("1reDi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0ac8c8a311d18321$export$2e2bcd8739ae039);
    var $7VHMR;
    var $0ac8c8a311d18321$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        viewSettings: {
            "id": "roadmap.standard-roadmap.header.view-settings.button.view-settings",
            "defaultMessage": "View settings"
        }
    });
});
parcelRegister("jwQhj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1bd137fd09faad7a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $lfTZh;
    var $kxZPA;
    var $eKt4x;
    var $bKgKk;
    const $1bd137fd09faad7a$var$LazyViewSettingsMenu = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("9NNFM")), {
        moduleId: "./src/packages/software/roadmap/standard/src/view/header/view-settings/menu/view.tsx"
    });
    const $1bd137fd09faad7a$var$ViewSettingsMenu = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "async-standard-roadmap-view-settings-menu",
            packageName: (0, (0, parcelRequire("eKt4x")).ROADMAP_PACKAGE_NAME),
            fallback: "flag"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "standard-roadmap-view-settings-menu",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bKgKk")).default), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($1bd137fd09faad7a$var$LazyViewSettingsMenu, props)));
    var $1bd137fd09faad7a$export$2e2bcd8739ae039 = $1bd137fd09faad7a$var$ViewSettingsMenu;
});
parcelRegister("bKgKk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$eb8c45ac56ae6c0a$export$2e2bcd8739ae039);
    var $bC2fB;
    var $4gYYI;
    var $3l1vy;
    var $eb8c45ac56ae6c0a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((state)=>({
            isReleasesFeatureEnabled: (0, (0, parcelRequire("4gYYI")).getIsReleasesFeatureEnabled)(state)
        }), {})((0, (0, parcelRequire("3l1vy")).default));
});
parcelRegister("3l1vy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cf209b5c27cbeddf$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $1wbtX;
    const $cf209b5c27cbeddf$var$Toggle = ({ width: width })=>(0, ($parcel$interopDefault($5uXOq))).createElement($cf209b5c27cbeddf$var$ToggleItem, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1wbtX")).SkeletonCompiled), {
            width: width,
            height: "20px"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($cf209b5c27cbeddf$var$ToggleButton, {
            width: "32px",
            height: "16px"
        }));
    const $cf209b5c27cbeddf$var$ViewSettingsMenuSkeleton = ({ isReleasesFeatureEnabled: isReleasesFeatureEnabled = false })=>(0, ($parcel$interopDefault($5uXOq))).createElement($cf209b5c27cbeddf$var$Container, null, (0, ($parcel$interopDefault($5uXOq))).createElement($cf209b5c27cbeddf$var$Section, null, (0, ($parcel$interopDefault($5uXOq))).createElement($cf209b5c27cbeddf$var$SectionTitle, {
            width: "85px",
            height: "16px"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($cf209b5c27cbeddf$var$Toggle, {
            width: "130px"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($cf209b5c27cbeddf$var$Item, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1wbtX")).SkeletonCompiled), {
            width: "240px",
            height: "32px"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement($cf209b5c27cbeddf$var$WrapTextItem, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1wbtX")).SkeletonCompiled), {
            width: "350px",
            height: "14.5px"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1wbtX")).SkeletonCompiled), {
            width: "120px",
            height: "14.5px"
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement($cf209b5c27cbeddf$var$Section, null, (0, ($parcel$interopDefault($5uXOq))).createElement($cf209b5c27cbeddf$var$ButtonItem, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1wbtX")).SkeletonCompiled), {
            width: "100px",
            height: "16px"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement($cf209b5c27cbeddf$var$ButtonItem, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1wbtX")).SkeletonCompiled), {
            width: "110px",
            height: "16px"
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement($cf209b5c27cbeddf$var$Section, null, (0, ($parcel$interopDefault($5uXOq))).createElement($cf209b5c27cbeddf$var$SectionTitle, {
            width: "80px",
            height: "16px"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($cf209b5c27cbeddf$var$Toggle, {
            width: "80px"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($cf209b5c27cbeddf$var$Toggle, {
            width: "70px"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($cf209b5c27cbeddf$var$Toggle, {
            width: "75px"
        }), isReleasesFeatureEnabled && (0, ($parcel$interopDefault($5uXOq))).createElement($cf209b5c27cbeddf$var$Toggle, {
            width: "70px"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement($cf209b5c27cbeddf$var$LearnMoreItem, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1wbtX")).SkeletonCompiled), {
            width: "240px",
            height: "16px"
        })));
    var $cf209b5c27cbeddf$export$2e2bcd8739ae039 = $cf209b5c27cbeddf$var$ViewSettingsMenuSkeleton;
    const $cf209b5c27cbeddf$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1kdj",
                __cmplp.className
            ])
        });
    });
    const $cf209b5c27cbeddf$var$Section = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt437zh _1pnm1uzb",
                __cmplp.className
            ])
        });
    });
    const $cf209b5c27cbeddf$var$Item = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bsb1osq _vchhusvi _1tke1ejb _18s81bpf",
                __cmplp.className
            ])
        });
    });
    const $cf209b5c27cbeddf$var$ToggleItem = (0, $5uXOq.forwardRef)(({ as: C = $cf209b5c27cbeddf$var$Item, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1f4h _4cvr1h6o _1bah1yb4",
                __cmplp.className
            ])
        });
    });
    const $cf209b5c27cbeddf$var$WrapTextItem = (0, $5uXOq.forwardRef)(({ as: C = $cf209b5c27cbeddf$var$Item, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2lx21bp4 _zulp1b66",
                __cmplp.className
            ])
        });
    });
    const $cf209b5c27cbeddf$var$ButtonItem = (0, $5uXOq.forwardRef)(({ as: C = $cf209b5c27cbeddf$var$Item, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1ylp _4cvr1h6o _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1yt41bpf",
                __cmplp.className
            ])
        });
    });
    const $cf209b5c27cbeddf$var$LearnMoreItem = (0, $5uXOq.forwardRef)(({ as: C = $cf209b5c27cbeddf$var$Item, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt41hrj",
                __cmplp.className
            ])
        });
    });
    const $cf209b5c27cbeddf$var$SectionTitle = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("1wbtX")).SkeletonCompiled), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkdlk8 _2hwxidpf _otyri2wt _18u0idpf",
                __cmplp.className
            ])
        });
    });
    const $cf209b5c27cbeddf$var$ToggleButton = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("1wbtX")).SkeletonCompiled), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18s81b66 _2rko7vkz",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("1wbtX", function(module, exports) {
    $parcel$export(module.exports, "getKeyframes", ()=>$39c21c8edc6f2616$export$b2b5e866b2fbf2ec);
    $parcel$export(module.exports, "Skeleton", ()=>$39c21c8edc6f2616$export$8f31e4c4a37b8e9c);
    $parcel$export(module.exports, "Spacer", ()=>$39c21c8edc6f2616$export$d7a54cba636a8cd6);
    $parcel$export(module.exports, "SkeletonCompiled", ()=>$39c21c8edc6f2616$export$dc84d515085190e);
    $parcel$export(module.exports, "SpacerCompiled", ()=>$39c21c8edc6f2616$export$e477bb7d17087f28);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $47bDC = parcelRequire("47bDC");
    const $39c21c8edc6f2616$export$b2b5e866b2fbf2ec = (offsetX = 0)=>{
        const fromPositionX = -Math.abs(offsetX) - 300;
        const toPositionX = fromPositionX + 2000;
        return (0, $47bDC.keyframes)({
            '0%': {
                backgroundPosition: `${fromPositionX}px 0`
            },
            '100%': {
                backgroundPosition: `${toPositionX}px 0`
            }
        });
    };
    const $39c21c8edc6f2616$var$shimmer = $39c21c8edc6f2616$export$b2b5e866b2fbf2ec();
    const $39c21c8edc6f2616$export$8f31e4c4a37b8e9c = (0, $47bDC.default).div.withConfig({
        componentId: "ieqbub-0"
    })((props)=>({
            animationDelay: props.theme.animationDelay || '0s',
            animationDuration: '1s',
            animationFillMode: 'forwards',
            animationIterationCount: 'infinite',
            animationName: props.theme.animationName || $39c21c8edc6f2616$var$shimmer,
            animationTimingFunction: 'linear',
            backgroundColor: `var(--ds-skeleton, ${(0, $829f609a65d26a98$exports).N30})`,
            backgroundImage: `linear-gradient( to right, ${`var(--ds-skeleton, ${(0, $829f609a65d26a98$exports).N30})`} 10%, ${`var(--ds-skeleton-subtle, ${(0, $829f609a65d26a98$exports).N20})`} 30%, ${`var(--ds-skeleton, ${(0, $829f609a65d26a98$exports).N30})`} 50% )`,
            backgroundRepeat: 'no-repeat',
            borderRadius: '2px',
            height: props.height,
            width: props.width
        }));
    const $39c21c8edc6f2616$export$d7a54cba636a8cd6 = (0, $47bDC.default).div.withConfig({
        componentId: "ieqbub-1"
    })((props)=>({
            height: props.height
        }));
    const $39c21c8edc6f2616$export$dc84d515085190e = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_8jvb0j": (0, (0, parcelRequire("lD23V")).default)(__cmplp.height),
                "--_1gljcou": (0, (0, parcelRequire("lD23V")).default)(__cmplp.width)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_ju25ru3m _5sag9cwz _1o51q7pw _tip812c5 _j7hq1245 _1pglp3kn _bfhkqrzy _1itk1ipn _12vemgnk _2rkoyh40 _4t3i1474 _1bsb1rkg",
                __cmplp.className
            ])
        });
    });
    const $39c21c8edc6f2616$export$e477bb7d17087f28 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_8jvb0j": (0, (0, parcelRequire("lD23V")).default)(__cmplp.height)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1474",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("9NNFM", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("1Nc1r")
    ]).then(()=>parcelRequire('dnv36'));
});
parcelRegister("4r7Ar", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d865532fc37402bb$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $f5TWP;
    var $jS4lj;
    var $cS37j;
    var $gwIPs;
    var $koVbs;
    var $8CVvd;
    var $3HwlS;
    var $l8ruj;
    var $dCm1o;
    var $IONO4;
    var $kUScF;
    var $fnRmc;
    const $d865532fc37402bb$var$containerStylesOldNavigation = null;
    const $d865532fc37402bb$var$containerStylesNewNavigation = null;
    const $d865532fc37402bb$var$headerRowContainerStyles = null;
    const $d865532fc37402bb$var$breadcrumbRowContainerStyles = null;
    const $d865532fc37402bb$var$spacedHeaderRowContainerStylesOld = null;
    const $d865532fc37402bb$var$spacedHeaderRowContainerStyles = null;
    const $d865532fc37402bb$var$RoadmapHeader = ({ Feedback: Feedback, Share: Share, Filters: Filters, isMacroView: isMacroView, ViewSettings: ViewSettings, MoreSettings: MoreSettings })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const ref = (0, $5uXOq.useRef)(null);
        (0, (0, parcelRequire("IONO4")).useBreakpointCSSVariables)(ref, (0, (0, parcelRequire("kUScF")).headerBreakpointOptions));
        const marginBottom = ()=>{
            if ((0, (0, parcelRequire("3HwlS")).getWillShowNav4)()) return `${(0, (0, parcelRequire("gwIPs")).gridSize) * 2}px`;
            return isMacroView ? `${(0, (0, parcelRequire("gwIPs")).gridSize) * 2}px` : `${(0, (0, parcelRequire("gwIPs")).gridSize) * 4}px`;
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: ref,
            "data-fullscreen-id": (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? undefined : 'roadmap-header-container',
            className: (0, (0, parcelRequire("bwpsq")).default)([
                (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? "_16jlidpf _1o9zidpf _i0dl1wug _u5f31ejb" : "_16jlidpf _1o9zidpf _i0dl1wug _u5f31ejb _11w3glyw"
            ])
        }, (0, (0, parcelRequire("8CVvd")).getWillShowNav3)() && !isMacroView && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cS37j")).default), {
            truncateTitle: true,
            actions: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
                space: "space.100"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(Feedback, null), (0, ($parcel$interopDefault($5uXOq))).createElement(Share, null), MoreSettings ? (0, ($parcel$interopDefault($5uXOq))).createElement(MoreSettings, null) : null),
            breadcrumbs: (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_1e0c1txw _1bah1yb4 _4cvr1h6o"
                ])
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jS4lj")).default), null))
        }, formatMessage((0, (0, parcelRequire("fnRmc")).default).timeline)), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                marginBottom: marginBottom()
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bah1yb4 _4cvr1h6o",
                (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? "_19pkv47k _eedjidpf _1v0eidpf" : "_19pkpxbi _eedjidpf _1v0eidpf"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "roadmap-filters"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(Filters, {
            isMacroView: isMacroView
        })), (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.100"
        }, !isMacroView && (0, ($parcel$interopDefault($5uXOq))).createElement(Share, null), (0, ($parcel$interopDefault($5uXOq))).createElement(ViewSettings, null), MoreSettings && !isMacroView ? (0, ($parcel$interopDefault($5uXOq))).createElement(MoreSettings, null) : null), (0, (0, parcelRequire("8CVvd")).getWillShowNav3)() && (0, ($parcel$interopDefault($5uXOq))).createElement(ViewSettings, null)));
    };
    $d865532fc37402bb$var$RoadmapHeader.defaultProps = {
        isMacroView: false
    };
    var $d865532fc37402bb$export$2e2bcd8739ae039 = $d865532fc37402bb$var$RoadmapHeader;
});
parcelRegister("cS37j", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2a15efb09f101ecb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $57MwZ;
    const $2a15efb09f101ecb$var$PageHeader = ({ actions: actions, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("57MwZ")).default), {
            ...props,
            actions: actions ? (0, ($parcel$interopDefault($5uXOq))).createElement($2a15efb09f101ecb$var$ActionsWrapper, null, actions) : null
        });
    var $2a15efb09f101ecb$export$2e2bcd8739ae039 = $2a15efb09f101ecb$var$PageHeader;
    const $2a15efb09f101ecb$var$ActionsWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_y3gn1e5h",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("57MwZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9694e728fd1ea060$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eeGIy;
    const $9694e728fd1ea060$var$PageHeader = ({ innerRef: innerRef, breadcrumbs: breadcrumbs, actions: actions, bottomBar: bottomBar, children: children, id: id, disableTitleStyles: disableTitleStyles = false, truncateTitle: truncateTitle = false })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).OuterWrapper), null, breadcrumbs, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).TitleWrapper), {
            truncateTitle: truncateTitle
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).TitleContainer), {
            truncateTitle: truncateTitle
        }, disableTitleStyles ? children : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).StyledTitleWrapper), {
            ref: innerRef,
            truncateTitle: truncateTitle,
            id: id
        }, children)), actions && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).ActionsWrapper), null, actions)), bottomBar && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).BottomBarWrapper), null, " ", bottomBar, " "));
    };
    var $9694e728fd1ea060$export$2e2bcd8739ae039 = $9694e728fd1ea060$var$PageHeader;
});
parcelRegister("eeGIy", function(module, exports) {
    $parcel$export(module.exports, "OuterWrapper", ()=>$0c196d37a4e8266c$export$edaaad985a878983);
    $parcel$export(module.exports, "StyledTitleWrapper", ()=>$0c196d37a4e8266c$export$284be1ee64a3465c);
    $parcel$export(module.exports, "TitleWrapper", ()=>$0c196d37a4e8266c$export$585a3b23e887288b);
    $parcel$export(module.exports, "TitleContainer", ()=>$0c196d37a4e8266c$export$35e09ba17cc51c69);
    $parcel$export(module.exports, "ActionsWrapper", ()=>$0c196d37a4e8266c$export$c8223871eecc8f3a);
    $parcel$export(module.exports, "BottomBarWrapper", ()=>$0c196d37a4e8266c$export$6330225854c30dc);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $dC5iT;
    var $8CUq3;
    function $0c196d37a4e8266c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $0c196d37a4e8266c$var$truncateStyles = {
        name: "13oenf9",
        styles: "overflow-x:hidden;overflow-y:hidden;text-overflow:ellipsis;white-space:nowrap"
    };
    const $0c196d37a4e8266c$var$outerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        margin: `${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-200, 16px)"} 0`
    });
    const $0c196d37a4e8266c$var$titleStyles = {
        name: "1o56te0",
        styles: "color:var(--ds-text, #172B4D);font:var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);letter-spacing:normal;margin-block-start:0;outline:none"
    };
    const $0c196d37a4e8266c$var$titleWrapperStyles = {
        name: "1wb76vg",
        styles: "display:flex;align-items:flex-start;flex-wrap:wrap"
    };
    const $0c196d37a4e8266c$var$titleWrapperTruncateStyles = {
        name: "14gl6v0",
        styles: "flex-wrap:nowrap"
    };
    const $0c196d37a4e8266c$var$titleContainerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        minWidth: 0,
        maxWidth: '100%',
        flex: '1 0 auto',
        flexShrink: undefined,
        marginBlockEnd: "var(--ds-space-100, 8px)"
    });
    const $0c196d37a4e8266c$var$actionStyles = {
        name: "1ianfu6",
        styles: "max-width:100%;flex:0 0 auto;margin-block-end:var(--ds-space-100, 8px);margin-inline-start:auto;padding-inline-start:var(--ds-space-400, 32px);white-space:nowrap;>{text-align:right;}"
    };
    const $0c196d37a4e8266c$var$titleContainerTruncateStyles = {
        name: "s2a4s9",
        styles: "flex-shrink:1"
    };
    const $0c196d37a4e8266c$var$bottomBarStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginBlockStart: 'space.200'
    });
    const $0c196d37a4e8266c$export$edaaad985a878983 = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $0c196d37a4e8266c$var$outerStyles
        }, children);
    };
    const $0c196d37a4e8266c$export$284be1ee64a3465c = (0, ($parcel$interopDefault($5uXOq))).forwardRef(({ children: children, id: id, truncateTitle: truncateTitle }, ref)=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("h1", {
            css: [
                $0c196d37a4e8266c$var$titleStyles,
                truncateTitle && $0c196d37a4e8266c$var$truncateStyles
            ],
            ref: ref,
            tabIndex: -1,
            id: id
        }, children);
    });
    const $0c196d37a4e8266c$export$585a3b23e887288b = ({ children: children, truncateTitle: truncateTitle })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $0c196d37a4e8266c$var$titleWrapperStyles,
                truncateTitle && $0c196d37a4e8266c$var$titleWrapperTruncateStyles
            ]
        }, children);
    };
    const $0c196d37a4e8266c$export$35e09ba17cc51c69 = ({ children: children, truncateTitle: truncateTitle })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $0c196d37a4e8266c$var$titleContainerStyles,
                truncateTitle && $0c196d37a4e8266c$var$titleContainerTruncateStyles
            ]
        }, children);
    };
    const $0c196d37a4e8266c$export$c8223871eecc8f3a = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $0c196d37a4e8266c$var$actionStyles
        }, children);
    };
    const $0c196d37a4e8266c$export$6330225854c30dc = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $0c196d37a4e8266c$var$bottomBarStyles
        }, children);
    };
});
parcelRegister("IONO4", function(module, exports) {
    $parcel$export(module.exports, "useBreakpointCSSVariables", ()=>$dccd00c0d6c5c575$export$695e30b23e1ef1ba);
    var $5uXOq = parcelRequire("5uXOq");
    var $3T6Xo = parcelRequire("3T6Xo");
    var $dowFx;
    const $dccd00c0d6c5c575$var$toPropertyName = (name)=>`--${(0, ($parcel$interopDefault($3T6Xo)))(name)}`;
    const $dccd00c0d6c5c575$var$setVariables = (element, variables)=>{
        Object.keys(variables).forEach((key)=>{
            const property = $dccd00c0d6c5c575$var$toPropertyName(key);
            const value = variables[key];
            element.style.setProperty(property, value);
        });
    };
    const $dccd00c0d6c5c575$export$695e30b23e1ef1ba = (ref, options)=>{
        const { breakpoint: breakpoint, above: above, below: below } = options;
        const flag = (0, $5uXOq.useRef)(null);
        const evalWidth = (0, $5uXOq.useCallback)((width)=>{
            const element = ref.current;
            if (!element) return;
            const isAbove = width > breakpoint;
            if (flag.current !== null && isAbove === flag.current) return;
            flag.current = isAbove;
            const variables = isAbove ? above : below;
            $dccd00c0d6c5c575$var$setVariables(element, variables);
        }, [
            above,
            below,
            breakpoint,
            ref
        ]);
        (0, (0, parcelRequire("dowFx")).useResizeObserver)(ref, (entry)=>{
            const { width: width } = entry.contentRect;
            evalWidth(width);
        });
    };
});
parcelRegister("dowFx", function(module, exports) {
    $parcel$export(module.exports, "useResizeObserver", ()=>$cadac6590ff106fc$export$683480f191c0e3ea);
    var $5uXOq = parcelRequire("5uXOq");
    let $cadac6590ff106fc$var$resizeObserver;
    const $cadac6590ff106fc$var$callbacks = new Map();
    const $cadac6590ff106fc$var$runCallbacks = (entries)=>{
        entries.forEach((entry)=>{
            const { target: target } = entry;
            const callback = $cadac6590ff106fc$var$callbacks.get(target);
            callback?.(entry);
        });
    };
    const $cadac6590ff106fc$export$9137ee61fe58d50e = (target, callback)=>{
        if (typeof ResizeObserver === 'undefined') return;
        if (!$cadac6590ff106fc$var$resizeObserver) $cadac6590ff106fc$var$resizeObserver = new ResizeObserver($cadac6590ff106fc$var$runCallbacks);
        $cadac6590ff106fc$var$callbacks.set(target, callback);
        $cadac6590ff106fc$var$resizeObserver.observe(target);
    };
    const $cadac6590ff106fc$export$4d125402ac99f1b = (target)=>{
        if (!$cadac6590ff106fc$var$resizeObserver) return;
        $cadac6590ff106fc$var$callbacks.delete(target);
        $cadac6590ff106fc$var$resizeObserver.unobserve(target);
    };
    const $cadac6590ff106fc$export$683480f191c0e3ea = (ref, callback)=>{
        (0, $5uXOq.useLayoutEffect)(()=>{
            const element = ref.current;
            element && $cadac6590ff106fc$export$9137ee61fe58d50e(element, callback);
            return ()=>{
                element && $cadac6590ff106fc$export$4d125402ac99f1b(element);
            };
        }, [
            ref,
            callback
        ]);
    };
});
parcelRegister("kUScF", function(module, exports) {
    $parcel$export(module.exports, "headerBreakpointOptions", ()=>$10096ae4e18debc3$export$289323b1807e3857);
    const $10096ae4e18debc3$export$289323b1807e3857 = {
        breakpoint: 1140,
        above: {
            largeButtonVisibility: 'block',
            smallButtonVisibility: 'none'
        },
        below: {
            largeButtonVisibility: 'none',
            smallButtonVisibility: 'block'
        }
    };
});
parcelRegister("fnRmc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1001a83386939a4e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $1001a83386939a4e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        timeline: {
            "id": "roadmap.standard-roadmap.header.timeline",
            "defaultMessage": "Timeline"
        }
    });
});
parcelRegister("jhhzY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6a230fc3b615eb94$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iXVV6;
    var $5oFIy;
    var $3rTr3;
    var $3tu2l;
    const $6a230fc3b615eb94$var$HealthcheckWithContext = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: "healthcheck",
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3tu2l")).default), {
            Indicator: (0, (0, parcelRequire("3rTr3")).default)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), null));
    var $6a230fc3b615eb94$export$2e2bcd8739ae039 = $6a230fc3b615eb94$var$HealthcheckWithContext;
});
parcelRegister("3rTr3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$94fbda17042053e3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $lfTZh;
    var $kxZPA;
    var $eKt4x;
    var $e6DZF;
    const $94fbda17042053e3$var$ResolveHealthcheck = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("f3UgV")), {
        moduleId: "./src/packages/software/roadmap/standard/src/view/healthcheck/unified-healthcheck/index.tsx"
    });
    var $94fbda17042053e3$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "async-standard-roadmap-unified-healthcheck",
            packageName: (0, (0, parcelRequire("eKt4x")).ROADMAP_PACKAGE_NAME),
            fallback: "flag"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "standard-roadmap-unified-healthcheck",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e6DZF")).default), {
                imageSize: "default",
                paragraphHeight: 65
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($94fbda17042053e3$var$ResolveHealthcheck, null)));
});
parcelRegister("e6DZF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$09f695c68a29c8fd$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $1wbtX;
    var $34fhs;
    var $OC803;
    const $09f695c68a29c8fd$var$DEFAULT_IMAGE_SIZE = 'default';
    const $09f695c68a29c8fd$var$LARGE_IMAGE_SIZE = 'large';
    const $09f695c68a29c8fd$var$headerStyles = null;
    const $09f695c68a29c8fd$var$paragraphSkeletonStyles = null;
    const $09f695c68a29c8fd$var$HealthcheckSkeleton = ({ imageSize: imageSize, paragraphHeight: paragraphHeight })=>{
        const imgWidth = imageSize === $09f695c68a29c8fd$var$DEFAULT_IMAGE_SIZE ? (0, (0, parcelRequire("OC803")).DEFAULT_IMAGE_WIDTH) : (0, (0, parcelRequire("OC803")).LARGE_IMAGE_WIDTH);
        const imgHeight = imageSize === $09f695c68a29c8fd$var$DEFAULT_IMAGE_SIZE ? (0, (0, parcelRequire("OC803")).DEFAULT_IMAGE_HEIGHT) : (0, (0, parcelRequire("OC803")).LARGE_IMAGE_HEIGHT);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("OC803")).Content), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1wbtX")).SkeletonCompiled), {
            style: {
                width: `${imgWidth}px`,
                height: `${imgHeight}px`
            }
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1w8u"
            ])
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("34fhs")).H700MCompiled), {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1w8u"
            ])
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1wbtX")).SkeletonCompiled), {
            style: {
                height: `${paragraphHeight}px`
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1lk2 _19pkv47k"
            ])
        }));
    };
    var $09f695c68a29c8fd$export$2e2bcd8739ae039 = $09f695c68a29c8fd$var$HealthcheckSkeleton;
});
parcelRegister("34fhs", function(module, exports) {
    $parcel$export(module.exports, "PlainText", ()=>$2ff3bfba15f6ac9d$export$f6d32c6d49be0014);
    $parcel$export(module.exports, "Paragraph", ()=>$2ff3bfba15f6ac9d$export$358a232cca1ab2ac);
    $parcel$export(module.exports, "H300", ()=>$2ff3bfba15f6ac9d$export$f36868a89c031e58);
    $parcel$export(module.exports, "H500", ()=>$2ff3bfba15f6ac9d$export$377ef4361b3db48f);
    $parcel$export(module.exports, "PlainTextCompiled", ()=>$2ff3bfba15f6ac9d$export$e6dbad138f5bdf17);
    $parcel$export(module.exports, "H400Compiled", ()=>$2ff3bfba15f6ac9d$export$892b8de9d7e14f37);
    $parcel$export(module.exports, "H700MCompiled", ()=>$2ff3bfba15f6ac9d$export$53b7b049cff342cb);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $47bDC = parcelRequire("47bDC");
    var $1wbtX;
    const $2ff3bfba15f6ac9d$export$e2253033e6e1df16 = (0, $47bDC.default)((0, (0, parcelRequire("1wbtX")).Skeleton)).withConfig({
        componentId: "p93our-0"
    })({
        width: '100%'
    });
    const $2ff3bfba15f6ac9d$export$f6d32c6d49be0014 = (0, $47bDC.default)($2ff3bfba15f6ac9d$export$e2253033e6e1df16).withConfig({
        componentId: "p93our-1"
    })({
        height: '14px',
        marginBottom: "var(--ds-space-075, 6px)"
    });
    const $2ff3bfba15f6ac9d$export$358a232cca1ab2ac = (0, $47bDC.default).div.withConfig({
        componentId: "p93our-2"
    })`width:100%;margin-top:${"var(--ds-space-150, 12px)"};& > ${$2ff3bfba15f6ac9d$export$f6d32c6d49be0014}{margin:0;}& > ${$2ff3bfba15f6ac9d$export$f6d32c6d49be0014} + ${$2ff3bfba15f6ac9d$export$f6d32c6d49be0014}{margin-top:3px;}`;
    const $2ff3bfba15f6ac9d$export$7465ee154025f712 = (0, $47bDC.default)($2ff3bfba15f6ac9d$export$e2253033e6e1df16).withConfig({
        componentId: "p93our-3"
    })({
        height: '11px',
        marginTop: "var(--ds-space-025, 2px)",
        marginBottom: '3px'
    });
    const $2ff3bfba15f6ac9d$export$a5fc4a344b34831f = (0, $47bDC.default)($2ff3bfba15f6ac9d$export$7465ee154025f712).withConfig({
        componentId: "p93our-4"
    })({
        marginTop: '18px'
    });
    const $2ff3bfba15f6ac9d$export$cf375857a047f134 = (0, $47bDC.default)($2ff3bfba15f6ac9d$export$e2253033e6e1df16).withConfig({
        componentId: "p93our-5"
    })({
        height: '12px',
        marginTop: "var(--ds-space-025, 2px)",
        marginBottom: "var(--ds-space-025, 2px)"
    });
    const $2ff3bfba15f6ac9d$export$234850447241d4be = $2ff3bfba15f6ac9d$export$a5fc4a344b34831f;
    const $2ff3bfba15f6ac9d$export$d65da85d43adf958 = (0, $47bDC.default)($2ff3bfba15f6ac9d$export$cf375857a047f134).withConfig({
        componentId: "p93our-6"
    })({
        marginTop: '18px'
    });
    const $2ff3bfba15f6ac9d$export$f36868a89c031e58 = (0, $47bDC.default)($2ff3bfba15f6ac9d$export$e2253033e6e1df16).withConfig({
        componentId: "p93our-7"
    })({
        height: '12px',
        marginTop: "var(--ds-space-025, 2px)",
        marginBottom: "var(--ds-space-025, 2px)"
    });
    const $2ff3bfba15f6ac9d$export$5863115a55e7a278 = (0, $47bDC.default)($2ff3bfba15f6ac9d$export$f36868a89c031e58).withConfig({
        componentId: "p93our-8"
    })({
        marginTop: '22px'
    });
    const $2ff3bfba15f6ac9d$export$6c2738d775286d02 = (0, $47bDC.default)($2ff3bfba15f6ac9d$export$e2253033e6e1df16).withConfig({
        componentId: "p93our-9"
    })({
        height: '14px',
        marginTop: '1px',
        marginBottom: '1px'
    });
    const $2ff3bfba15f6ac9d$export$4b8e008fe165f543 = $2ff3bfba15f6ac9d$export$d65da85d43adf958;
    const $2ff3bfba15f6ac9d$export$a46c8598b69fa9c9 = $2ff3bfba15f6ac9d$export$5863115a55e7a278;
    const $2ff3bfba15f6ac9d$export$655c11a59e0fb8b7 = (0, $47bDC.default)($2ff3bfba15f6ac9d$export$6c2738d775286d02).withConfig({
        componentId: "p93our-10"
    })({
        marginTop: '17px'
    });
    const $2ff3bfba15f6ac9d$export$225af344711a2ee8 = (0, $47bDC.default)($2ff3bfba15f6ac9d$export$655c11a59e0fb8b7).withConfig({
        componentId: "p93our-11"
    })({
        marginTop: '27px',
        marginBottom: '3px'
    });
    const $2ff3bfba15f6ac9d$export$377ef4361b3db48f = (0, $47bDC.default)($2ff3bfba15f6ac9d$export$e2253033e6e1df16).withConfig({
        componentId: "p93our-12"
    })({
        height: '20px'
    });
    const $2ff3bfba15f6ac9d$export$9af2972d81bc22d4 = (0, $47bDC.default)($2ff3bfba15f6ac9d$export$377ef4361b3db48f).withConfig({
        componentId: "p93our-13"
    })({
        marginTop: '26px'
    });
    const $2ff3bfba15f6ac9d$export$d5a20b614606407a = (0, $47bDC.default)($2ff3bfba15f6ac9d$export$9af2972d81bc22d4).withConfig({
        componentId: "p93our-14"
    })({
        marginTop: '36px',
        marginBottom: "var(--ds-space-050, 4px)"
    });
    const $2ff3bfba15f6ac9d$export$1fb177267a8ebba2 = (0, $47bDC.default)($2ff3bfba15f6ac9d$export$e2253033e6e1df16).withConfig({
        componentId: "p93our-15"
    })({
        height: '20px',
        marginTop: "var(--ds-space-025, 2px)",
        marginBottom: "var(--ds-space-025, 2px)"
    });
    const $2ff3bfba15f6ac9d$export$5ad8b93a781ab376 = (0, $47bDC.default)($2ff3bfba15f6ac9d$export$1fb177267a8ebba2).withConfig({
        componentId: "p93our-16"
    })({
        marginTop: '30px'
    });
    const $2ff3bfba15f6ac9d$export$8fca2a02d1129baa = (0, $47bDC.default)($2ff3bfba15f6ac9d$export$5ad8b93a781ab376).withConfig({
        componentId: "p93our-17"
    })({
        marginTop: '38px'
    });
    const $2ff3bfba15f6ac9d$export$47d8e8f28b07dbe6 = (0, $47bDC.default)($2ff3bfba15f6ac9d$export$e2253033e6e1df16).withConfig({
        componentId: "p93our-18"
    })({
        height: '24px',
        marginTop: "var(--ds-space-025, 2px)",
        marginBottom: "var(--ds-space-025, 2px)"
    });
    const $2ff3bfba15f6ac9d$export$8cf550a6494f0a95 = (0, $47bDC.default)($2ff3bfba15f6ac9d$export$47d8e8f28b07dbe6).withConfig({
        componentId: "p93our-19"
    })({
        marginTop: '42px'
    });
    const $2ff3bfba15f6ac9d$export$11421df4b306eac5 = $2ff3bfba15f6ac9d$export$8cf550a6494f0a95;
    const $2ff3bfba15f6ac9d$export$f79dd616b4b7940 = (0, $47bDC.default)($2ff3bfba15f6ac9d$export$e2253033e6e1df16).withConfig({
        componentId: "p93our-20"
    })({
        height: '29px',
        marginTop: '1px',
        marginBottom: "var(--ds-space-025, 2px)"
    });
    const $2ff3bfba15f6ac9d$export$1673bc4956a0d574 = (0, $47bDC.default)($2ff3bfba15f6ac9d$export$f79dd616b4b7940).withConfig({
        componentId: "p93our-21"
    })({
        marginTop: '41px'
    });
    const $2ff3bfba15f6ac9d$export$23912bec87db0a67 = (0, $47bDC.default)($2ff3bfba15f6ac9d$export$1673bc4956a0d574).withConfig({
        componentId: "p93our-22"
    })({
        marginTop: '49px'
    });
    const $2ff3bfba15f6ac9d$export$4f15f48a88de4246 = (0, $47bDC.default)($2ff3bfba15f6ac9d$export$e2253033e6e1df16).withConfig({
        componentId: "p93our-23"
    })({
        height: '35px',
        marginTop: "var(--ds-space-025, 2px)",
        marginBottom: '3px'
    });
    const $2ff3bfba15f6ac9d$export$7d09a8e3c995666f = (0, $47bDC.default)($2ff3bfba15f6ac9d$export$4f15f48a88de4246).withConfig({
        componentId: "p93our-24"
    })({
        marginTop: '54px'
    });
    const $2ff3bfba15f6ac9d$export$7e32c7deacf14279 = $2ff3bfba15f6ac9d$export$7d09a8e3c995666f;
    const $2ff3bfba15f6ac9d$export$b0895c0bfbd1ffb8 = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("1wbtX")).SkeletonCompiled), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq",
                __cmplp.className
            ])
        });
    });
    const $2ff3bfba15f6ac9d$export$e6dbad138f5bdf17 = (0, $5uXOq.forwardRef)(({ as: C = $2ff3bfba15f6ac9d$export$b0895c0bfbd1ffb8, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3idlk8 _otyr12x7",
                __cmplp.className
            ])
        });
    });
    const $2ff3bfba15f6ac9d$export$7c050ac4f729d35 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _19pkutpp",
                __cmplp.className
            ])
        });
    });
    const $2ff3bfba15f6ac9d$export$33ebdec21c095f6e = (0, $5uXOq.forwardRef)(({ as: C = $2ff3bfba15f6ac9d$export$b0895c0bfbd1ffb8, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1skh _19pkv77o _otyr1l7b",
                __cmplp.className
            ])
        });
    });
    const $2ff3bfba15f6ac9d$export$82a6f7cce44c254 = (0, $5uXOq.forwardRef)(({ as: C = $2ff3bfba15f6ac9d$export$33ebdec21c095f6e, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkf6fq",
                __cmplp.className
            ])
        });
    });
    const $2ff3bfba15f6ac9d$export$e61e2190cb48676b = $2ff3bfba15f6ac9d$export$82a6f7cce44c254;
    const $2ff3bfba15f6ac9d$export$8c60685913d30500 = (0, $5uXOq.forwardRef)(({ as: C = $2ff3bfba15f6ac9d$export$b0895c0bfbd1ffb8, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1crf _19pkv77o _otyrv77o",
                __cmplp.className
            ])
        });
    });
    const $2ff3bfba15f6ac9d$export$f82bfe67e6a089e6 = (0, $5uXOq.forwardRef)(({ as: C = $2ff3bfba15f6ac9d$export$8c60685913d30500, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkf6fq",
                __cmplp.className
            ])
        });
    });
    const $2ff3bfba15f6ac9d$export$350917bb6067b798 = $2ff3bfba15f6ac9d$export$f82bfe67e6a089e6;
    const $2ff3bfba15f6ac9d$export$eb27f46149e3e85a = (0, $5uXOq.forwardRef)(({ as: C = $2ff3bfba15f6ac9d$export$b0895c0bfbd1ffb8, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1crf _19pkv77o _otyrv77o",
                __cmplp.className
            ])
        });
    });
    const $2ff3bfba15f6ac9d$export$fd72e0c4b34be76a = (0, $5uXOq.forwardRef)(({ as: C = $2ff3bfba15f6ac9d$export$eb27f46149e3e85a, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkqslr",
                __cmplp.className
            ])
        });
    });
    const $2ff3bfba15f6ac9d$export$bfaabc8568c580b1 = $2ff3bfba15f6ac9d$export$fd72e0c4b34be76a;
    const $2ff3bfba15f6ac9d$export$892b8de9d7e14f37 = (0, $5uXOq.forwardRef)(({ as: C = $2ff3bfba15f6ac9d$export$b0895c0bfbd1ffb8, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3idlk8 _19pkt94y _otyrt94y",
                __cmplp.className
            ])
        });
    });
    const $2ff3bfba15f6ac9d$export$9f435470752d8e4b = (0, $5uXOq.forwardRef)(({ as: C = $2ff3bfba15f6ac9d$export$892b8de9d7e14f37, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkl52n",
                __cmplp.className
            ])
        });
    });
    const $2ff3bfba15f6ac9d$export$f9230dd2e3259be0 = (0, $5uXOq.forwardRef)(({ as: C = $2ff3bfba15f6ac9d$export$9f435470752d8e4b, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkd4y9 _otyr1l7b",
                __cmplp.className
            ])
        });
    });
    const $2ff3bfba15f6ac9d$export$ef0a9f1262ddb059 = (0, $5uXOq.forwardRef)(({ as: C = $2ff3bfba15f6ac9d$export$b0895c0bfbd1ffb8, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3igktf",
                __cmplp.className
            ])
        });
    });
    const $2ff3bfba15f6ac9d$export$3306f1638a65aa25 = (0, $5uXOq.forwardRef)(({ as: C = $2ff3bfba15f6ac9d$export$ef0a9f1262ddb059, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pk1ou6",
                __cmplp.className
            ])
        });
    });
    const $2ff3bfba15f6ac9d$export$8fbd282ac52a8998 = (0, $5uXOq.forwardRef)(({ as: C = $2ff3bfba15f6ac9d$export$3306f1638a65aa25, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pk14no _otyr1b66",
                __cmplp.className
            ])
        });
    });
    const $2ff3bfba15f6ac9d$export$7966954511c1edb6 = (0, $5uXOq.forwardRef)(({ as: C = $2ff3bfba15f6ac9d$export$b0895c0bfbd1ffb8, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3igktf _19pkv77o _otyrv77o",
                __cmplp.className
            ])
        });
    });
    const $2ff3bfba15f6ac9d$export$576c433bd0b626fd = (0, $5uXOq.forwardRef)(({ as: C = $2ff3bfba15f6ac9d$export$7966954511c1edb6, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pk1ul9",
                __cmplp.className
            ])
        });
    });
    const $2ff3bfba15f6ac9d$export$594a18f5d65c77d1 = (0, $5uXOq.forwardRef)(({ as: C = $2ff3bfba15f6ac9d$export$576c433bd0b626fd, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pk10mc",
                __cmplp.className
            ])
        });
    });
    const $2ff3bfba15f6ac9d$export$bd4f20a0c6dc0659 = (0, $5uXOq.forwardRef)(({ as: C = $2ff3bfba15f6ac9d$export$b0895c0bfbd1ffb8, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1tcg _19pkv77o _otyrv77o",
                __cmplp.className
            ])
        });
    });
    const $2ff3bfba15f6ac9d$export$53b7b049cff342cb = (0, $5uXOq.forwardRef)(({ as: C = $2ff3bfba15f6ac9d$export$bd4f20a0c6dc0659, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkor1b",
                __cmplp.className
            ])
        });
    });
    const $2ff3bfba15f6ac9d$export$957ddfeb34e9bf68 = $2ff3bfba15f6ac9d$export$53b7b049cff342cb;
    const $2ff3bfba15f6ac9d$export$675af1e83e93897e = (0, $5uXOq.forwardRef)(({ as: C = $2ff3bfba15f6ac9d$export$b0895c0bfbd1ffb8, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1pa9 _19pkt94y _otyrv77o",
                __cmplp.className
            ])
        });
    });
    const $2ff3bfba15f6ac9d$export$19ab514bc0674f75 = (0, $5uXOq.forwardRef)(({ as: C = $2ff3bfba15f6ac9d$export$675af1e83e93897e, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkpzf8",
                __cmplp.className
            ])
        });
    });
    const $2ff3bfba15f6ac9d$export$8293db07860f297 = (0, $5uXOq.forwardRef)(({ as: C = $2ff3bfba15f6ac9d$export$19ab514bc0674f75, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pk189y",
                __cmplp.className
            ])
        });
    });
    const $2ff3bfba15f6ac9d$export$a3699bd2412e4867 = (0, $5uXOq.forwardRef)(({ as: C = $2ff3bfba15f6ac9d$export$b0895c0bfbd1ffb8, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3ildb6 _19pkv77o _otyr1l7b",
                __cmplp.className
            ])
        });
    });
    const $2ff3bfba15f6ac9d$export$e3181bb29e80b5f3 = (0, $5uXOq.forwardRef)(({ as: C = $2ff3bfba15f6ac9d$export$a3699bd2412e4867, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pk1l27",
                __cmplp.className
            ])
        });
    });
    const $2ff3bfba15f6ac9d$export$1b6e300f10774868 = $2ff3bfba15f6ac9d$export$e3181bb29e80b5f3;
});
parcelRegister("OC803", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_IMAGE_WIDTH", ()=>$fdd0b1a513bab7b6$export$d722b7527b1834a8);
    $parcel$export(module.exports, "DEFAULT_IMAGE_HEIGHT", ()=>$fdd0b1a513bab7b6$export$da894f7669b4e67c);
    $parcel$export(module.exports, "LARGE_IMAGE_WIDTH", ()=>$fdd0b1a513bab7b6$export$9069cbcb36903e62);
    $parcel$export(module.exports, "LARGE_IMAGE_HEIGHT", ()=>$fdd0b1a513bab7b6$export$66157be652bb2e88);
    $parcel$export(module.exports, "Content", ()=>$fdd0b1a513bab7b6$export$7c6e2c02157bb7d2);
    $parcel$export(module.exports, "Messages", ()=>$fdd0b1a513bab7b6$export$ceaacf8b390a3600);
    $parcel$export(module.exports, "Title", ()=>$fdd0b1a513bab7b6$export$f99233281efd08a0);
    var $5uXOq = parcelRequire("5uXOq");
    var $1dJ6S;
    var $dC5iT;
    var $kgoHi;
    var $8CUq3;
    const $fdd0b1a513bab7b6$export$6cccba5fae1d609d = 500;
    const $fdd0b1a513bab7b6$export$a38d4ef0bccda3ff = 221;
    const $fdd0b1a513bab7b6$export$d722b7527b1834a8 = 235;
    const $fdd0b1a513bab7b6$export$da894f7669b4e67c = 138;
    const $fdd0b1a513bab7b6$export$9069cbcb36903e62 = 344;
    const $fdd0b1a513bab7b6$export$66157be652bb2e88 = 167;
    const $fdd0b1a513bab7b6$export$7c6e2c02157bb7d2 = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            direction: "column",
            justifyContent: "start",
            alignItems: "center",
            xcss: $fdd0b1a513bab7b6$var$ContentStyles
        }, children);
    const $fdd0b1a513bab7b6$export$ceaacf8b390a3600 = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $fdd0b1a513bab7b6$var$MessagesStyles
        }, children);
    const $fdd0b1a513bab7b6$export$f99233281efd08a0 = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            size: "large"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $fdd0b1a513bab7b6$var$TitleComponentStyle
        }, children));
    const $fdd0b1a513bab7b6$var$ContentStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: `${$fdd0b1a513bab7b6$export$6cccba5fae1d609d}px`
    });
    const $fdd0b1a513bab7b6$var$MessagesStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        textAlign: 'center',
        marginTop: 'space.250',
        marginBottom: 'space.250'
    });
    const $fdd0b1a513bab7b6$var$TitleComponentStyle = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginTop: 'space.500',
        textAlign: 'center'
    });
});
parcelRegister("f3UgV", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("e4FGE")
    ]).then(()=>parcelRequire('bcltE'));
});
parcelRegister("3tu2l", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$05ab372859fceb68$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $jS4lj;
    var $cS37j;
    var $koVbs;
    var $cOWvU;
    const $05ab372859fceb68$var$Healthcheck = ({ Indicator: Indicator })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cS37j")).default), {
            truncateTitle: true,
            breadcrumbs: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jS4lj")).default), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($05ab372859fceb68$var$PageHeaderContainer, null, formatMessage((0, (0, parcelRequire("cOWvU")).default).timeline))), (0, ($parcel$interopDefault($5uXOq))).createElement($05ab372859fceb68$var$Content, null, (0, ($parcel$interopDefault($5uXOq))).createElement(Indicator, null)));
    };
    var $05ab372859fceb68$export$2e2bcd8739ae039 = $05ab372859fceb68$var$Healthcheck;
    const $05ab372859fceb68$var$Content = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bsb1osq _2lx21bp4 _1bah1y6m _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $05ab372859fceb68$var$PageHeaderContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("cOWvU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c967ddc798d0a9b9$export$2e2bcd8739ae039);
    var $7VHMR;
    var $c967ddc798d0a9b9$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        timeline: {
            "id": "roadmap.standard-roadmap.healthcheck.timeline",
            "defaultMessage": "Timeline"
        }
    });
});
parcelRegister("gzKIg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4d995efcf4979794$export$2e2bcd8739ae039);
    var $bC2fB;
    var $95lzH;
    var $OcuDb;
    var $4d995efcf4979794$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((state)=>({
            attributes: (0, (0, parcelRequire("95lzH")).getRoadmapLoadedAnalyticsData)(state)
        }), {})((0, (0, parcelRequire("OcuDb")).default));
});
parcelRegister("OcuDb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$301ce4c98f8bf482$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $hxoiH;
    var $8zOmE;
    var $isuse;
    var $9OXo1;
    var $301ce4c98f8bf482$export$2e2bcd8739ae039 = ({ attributes: attributes })=>{
        const { colorMode: colorMode } = (0, (0, parcelRequire("hxoiH")).default)();
        const { isSiteAdmin: isSiteAdmin } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const fireRoadmapViewedAnalytic = (analyticsEvent)=>(0, (0, parcelRequire("8zOmE")).fireTrackAnalyticsDeferred)(analyticsEvent, 'roadmap viewed', {
                ...attributes,
                theme: colorMode,
                isSiteAdmin: isSiteAdmin
            });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("isuse")).MountEvent), {
            onMount: fireRoadmapViewedAnalytic
        });
    };
});
parcelRegister("k4sUr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$12e9dec70c45765a$export$2e2bcd8739ae039);
    var $8Rkzz = parcelRequire("8Rkzz");
    var $8QpSo;
    var $bC2fB;
    var $dd8Xx;
    var $eKt4x;
    var $cyp7n;
    var $9fPrG;
    var $4gYYI;
    var $3unH6;
    var $fqDxE;
    const $12e9dec70c45765a$var$mapStateToProps = (state)=>({
            cloudId: (0, (0, parcelRequire("9fPrG")).getCloudId)(state) || '',
            projectId: (0, (0, parcelRequire("4gYYI")).getProjectId)(state),
            channels: (0, (0, parcelRequire("fqDxE")).getRealtimeChannels)(state)
        });
    const $12e9dec70c45765a$var$mapDispatchToProps = {
        dispatchRealtimeEvent: (0, parcelRequire("3unH6")).dispatchRealtimeEvent
    };
    const $12e9dec70c45765a$var$onReceiveFactory = (0, (0, parcelRequire("8QpSo")).default)((dispatchPropsDispatchRealtimeEvent)=>(event)=>{
            if (event) dispatchPropsDispatchRealtimeEvent(event);
        });
    const $12e9dec70c45765a$export$9d1611c77c2fe928 = (stateProps, dispatchProps)=>({
            appId: (0, (0, parcelRequire("eKt4x")).ROADMAP_APP_ID),
            channels: stateProps.channels,
            events: (0, (0, parcelRequire("cyp7n")).REALTIME_EVENTS),
            onJoin: (0, ($parcel$interopDefault($8Rkzz))),
            onReceive: $12e9dec70c45765a$var$onReceiveFactory(dispatchProps.dispatchRealtimeEvent),
            onLeave: (0, ($parcel$interopDefault($8Rkzz)))
        });
    var $12e9dec70c45765a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($12e9dec70c45765a$var$mapStateToProps, $12e9dec70c45765a$var$mapDispatchToProps, $12e9dec70c45765a$export$9d1611c77c2fe928)((0, (0, parcelRequire("dd8Xx")).default));
});
parcelRegister("dd8Xx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9a980bab3107478f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $b32lf;
    var $jiRmc;
    class $9a980bab3107478f$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                onJoin: (0, ($parcel$interopDefault($8Rkzz))),
                onReceive: (0, ($parcel$interopDefault($8Rkzz))),
                onLeave: (0, ($parcel$interopDefault($8Rkzz)))
            };
        }
        render() {
            const { appId: appId, events: events, onJoin: onJoin, onLeave: onLeave, channels: channels } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jiRmc")).RealtimeProvider), {
                appId: appId,
                onJoin: onJoin,
                onLeave: onLeave,
                channels: channels
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b32lf")).RealtimeClient), {
                events: events,
                onReceive: this.onEventReceive
            }));
        }
        constructor(...args){
            super(...args);
            this.onEventReceive = (eventType, payload)=>{
                const event = {
                    type: eventType,
                    payload: payload
                };
                this.props.onReceive(event);
            };
        }
    }
});
parcelRegister("b32lf", function(module, exports) {
    $parcel$export(module.exports, "RealtimeClient", ()=>$89de761bbc8dc49a$export$e680ceb7b9fcc184);
    var $5uXOq = parcelRequire("5uXOq");
    var $basmW = parcelRequire("basmW");
    var $2OMDV;
    var $50Ssb;
    var $iwG6l;
    class $89de761bbc8dc49a$var$RealtimeClientView extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                children: null
            };
        }
        componentDidMount() {
            this.subscribeToPropEvents();
        }
        componentDidUpdate(prevProps) {
            if (this.props.client !== prevProps.client || this.props.events !== prevProps.events) {
                const removedEvents = prevProps.events.filter((prevEvent)=>!this.props.events.includes(prevEvent));
                removedEvents.forEach(this.unSubscribeToEvent);
                this.subscribeToPropEvents();
            }
        }
        componentWillUnmount() {
            this.unsubscribeToPropEvents();
        }
        render() {
            return this.props.children;
        }
        constructor(...args){
            super(...args);
            this.onReceiveEvent = (event, payload)=>{
                this.props.onReceive(event, payload);
            };
            this.subscribeToEvent = (eventName)=>{
                this.props.client?.on(eventName, this.onReceiveEvent);
            };
            this.unSubscribeToEvent = (eventName)=>{
                this.props.client?.off(eventName, this.onReceiveEvent);
            };
            this.subscribeToPropEvents = ()=>{
                if (this.props.client) this.props.events.forEach(this.subscribeToEvent);
            };
            this.unsubscribeToPropEvents = ()=>{
                if (this.props.client) this.props.events.forEach(this.unSubscribeToEvent);
            };
        }
    }
    const $89de761bbc8dc49a$var$withAnalytics = (0, (0, parcelRequire("2OMDV")).AnalyticsEventToProps)('realtimeClient', {
        onReceive: 'eventReceived'
    });
    const $89de761bbc8dc49a$export$e680ceb7b9fcc184 = (0, ($parcel$interopDefault($basmW)))($89de761bbc8dc49a$var$withAnalytics, (0, (0, parcelRequire("iwG6l")).withPubSubClient), (0, (0, parcelRequire("50Ssb")).asClientOnly))($89de761bbc8dc49a$var$RealtimeClientView);
    var $89de761bbc8dc49a$export$2e2bcd8739ae039 = $89de761bbc8dc49a$export$e680ceb7b9fcc184;
});
parcelRegister("50Ssb", function(module, exports) {
    $parcel$export(module.exports, "asClientOnly", ()=>$ccf1df230f4f0e4b$export$95cd02374de3431);
    var $5uXOq = parcelRequire("5uXOq");
    function $ccf1df230f4f0e4b$export$95cd02374de3431(WrappedComponent) {
        return (props)=>{
            if (false) return null;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, props);
        };
    }
    var $ccf1df230f4f0e4b$export$2e2bcd8739ae039 = $ccf1df230f4f0e4b$export$95cd02374de3431;
});
parcelRegister("iwG6l", function(module, exports) {
    $parcel$export(module.exports, "withPubSubClient", ()=>$9fb4f4e8a5d3670b$export$32d968d4900ae3cd);
    var $5uXOq = parcelRequire("5uXOq");
    var $bYYrF;
    function $9fb4f4e8a5d3670b$export$32d968d4900ae3cd(WrappedComponent) {
        return (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bYYrF")).Consumer), null, ({ client: client })=>(0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                    ...props,
                    client: client
                }));
    }
    var $9fb4f4e8a5d3670b$export$2e2bcd8739ae039 = $9fb4f4e8a5d3670b$export$32d968d4900ae3cd;
});
parcelRegister("bYYrF", function(module, exports) {
    $parcel$export(module.exports, "Provider", ()=>$9398e66c20b16e31$export$2881499e37b75b9a);
    $parcel$export(module.exports, "Consumer", ()=>$9398e66c20b16e31$export$b3bffd4bb7da6b8f);
    var $5uXOq = parcelRequire("5uXOq");
    const $9398e66c20b16e31$var$defaultContext = {
        client: null
    };
    const { Provider: $9398e66c20b16e31$export$2881499e37b75b9a, Consumer: $9398e66c20b16e31$export$b3bffd4bb7da6b8f } = (0, $5uXOq.createContext)($9398e66c20b16e31$var$defaultContext);
});
parcelRegister("jiRmc", function(module, exports) {
    $parcel$export(module.exports, "RealtimeProvider", ()=>$db014a952af56f77$export$64d242981d970821);
    var $5uXOq = parcelRequire("5uXOq");
    var $basmW = parcelRequire("basmW");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $dJl1T;
    var $2OMDV;
    var $fjcgS;
    var $bYYrF;
    var $1eGpy;
    var $FPIEb;
    const $db014a952af56f77$var$createPubSubClient = (host, analyticsClient)=>(parcelRequire("gXdhU")).then((module)=>{
            const Client = module.default;
            return new Client({
                product: (0, $dd367d66c147872b$export$13ac40d1a5475532),
                url: `${host}`,
                apsProtocol: {
                    enabled: true
                },
                analyticsClient: analyticsClient
            });
        });
    const $db014a952af56f77$export$c127c26e30518ed5 = (appId, client, channels, onHandler)=>client.join(channels).then(onHandler).catch((error)=>{
            if (error && error.code === 401) return;
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('realtime.channel.join.failure', `Failed to join channel @ ${appId}`, error);
        });
    const $db014a952af56f77$export$e6c41c8aa28ddeb9 = (appId, client, channels, onHandler)=>client.leave(channels).then(onHandler).catch((error)=>{
            if (error && error.code === 401) return;
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('realtime.channel.leave.failure', `Failed to left channel @ ${appId}`, error);
        });
    class $db014a952af56f77$var$RealtimeProviderView extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                host: (0, $dd367d66c147872b$export$92ffb25149c24a33),
                onJoin: (0, ($parcel$interopDefault($8Rkzz))),
                onLeave: (0, ($parcel$interopDefault($8Rkzz)))
            };
        }
        componentDidMount() {
            const { appId: appId, host: host, channels: channels } = this.props;
            this.isComponentMounted = true;
            (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((analyticsClient)=>$db014a952af56f77$var$createPubSubClient(host, analyticsClient.getInstance())).then((pubSubClient)=>$db014a952af56f77$export$c127c26e30518ed5(appId, pubSubClient, channels, this.onJoinChannel).then(()=>{
                    if (this.isComponentMounted) this.setState({
                        client: pubSubClient
                    });
                }));
        }
        componentDidUpdate({ channels: prevChannels }) {
            const { appId: appId, channels: newChannels } = this.props;
            const { client: client } = this.state;
            if (client && newChannels !== prevChannels) {
                const removedChannels = prevChannels.filter((channel)=>!newChannels.includes(channel));
                $db014a952af56f77$export$e6c41c8aa28ddeb9(appId, client, removedChannels, this.onLeaveChannel);
                $db014a952af56f77$export$c127c26e30518ed5(appId, client, newChannels, this.onJoinChannel);
            }
        }
        componentWillUnmount() {
            const { appId: appId, channels: channels } = this.props;
            const { client: client } = this.state;
            this.isComponentMounted = false;
            if (client) $db014a952af56f77$export$e6c41c8aa28ddeb9(appId, client, channels, this.onLeaveChannel);
        }
        render() {
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bYYrF")).Provider), {
                value: {
                    client: this.state.client
                }
            }, this.props.children);
        }
        constructor(...args){
            super(...args);
            this.state = {
                client: null
            };
            this.onJoinChannel = (result)=>{
                const { onJoin: onJoin } = this.props;
                onJoin(Array.from(result.currentChannels));
            };
            this.onLeaveChannel = (result)=>{
                const { onLeave: onLeave } = this.props;
                onLeave(Array.from(result.currentChannels));
            };
            this.isComponentMounted = false;
        }
    }
    const $db014a952af56f77$var$withAnalytics = (0, (0, parcelRequire("2OMDV")).AnalyticsEventToProps)('realtimeProvider', {
        onJoin: 'joinedChannel',
        onLeave: 'leftChannel'
    });
    const $db014a952af56f77$export$64d242981d970821 = (0, ($parcel$interopDefault($basmW)))($db014a952af56f77$var$withAnalytics, (0, (0, parcelRequire("1eGpy")).withHost), (0, (0, parcelRequire("FPIEb")).withRuntimeProvider))($db014a952af56f77$var$RealtimeProviderView);
    var $db014a952af56f77$export$2e2bcd8739ae039 = $db014a952af56f77$export$64d242981d970821;
});
const $dd367d66c147872b$export$92ffb25149c24a33 = '/gateway/api/pubsub';
const $dd367d66c147872b$export$13ac40d1a5475532 = 'JIRA';
parcelRegister("1eGpy", function(module, exports) {
    $parcel$export(module.exports, "withHost", ()=>$af5e53f160713d44$export$b2d89aaea1461cd9);
    var $5uXOq = parcelRequire("5uXOq");
    var $4h0Jz;
    function $af5e53f160713d44$export$b2d89aaea1461cd9(WrappedComponent) {
        return (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ...props,
                host: (0, (0, parcelRequire("4h0Jz")).getDefaultPubSubHost)()
            });
    }
    var $af5e53f160713d44$export$2e2bcd8739ae039 = $af5e53f160713d44$export$b2d89aaea1461cd9;
});
parcelRegister("4h0Jz", function(module, exports) {
    $parcel$export(module.exports, "getDefaultPubSubHost", ()=>$15272668181566a5$export$f795b2d9ba365882);
    $parcel$export(module.exports, "buildChannelString", ()=>$15272668181566a5$export$354e43de513ff5);
    var $j8DrX;
    const $15272668181566a5$export$f795b2d9ba365882 = ()=>(0, (0, parcelRequire("j8DrX")).default)('ajs-fabric-realtime-url') || (0, $dd367d66c147872b$export$92ffb25149c24a33);
    const $15272668181566a5$export$354e43de513ff5 = (cloudId, projectId)=>`ari:cloud:jira:${cloudId}:project/${projectId}`;
});
parcelRegister("FPIEb", function(module, exports) {
    $parcel$export(module.exports, "withRuntimeProvider", ()=>$5962bf1fe62742cb$export$4b38d0b01368c3f4);
    var $5uXOq = parcelRequire("5uXOq");
    function $5962bf1fe62742cb$export$4b38d0b01368c3f4(WrappedComponent) {
        return (props)=>{
            if (false) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, props.children);
            return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, props);
        };
    }
    var $5962bf1fe62742cb$export$2e2bcd8739ae039 = $5962bf1fe62742cb$export$4b38d0b01368c3f4;
});
parcelRegister("gXdhU", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("8c9ac")
    ]).then(()=>parcelRequire('9uh43'));
});
parcelRegister("cyp7n", function(module, exports) {
    $parcel$export(module.exports, "REALTIME_EVENTS", ()=>$983a0cf03cb33e29$export$a45e758f2a5806e6);
    const $983a0cf03cb33e29$export$a45e758f2a5806e6 = [
        (0, $09d938f04e8899c4$export$b22a14d5dac59664),
        (0, $09d938f04e8899c4$export$25fa37e5059c5a99),
        (0, $09d938f04e8899c4$export$d9bc8850eeef9f60),
        (0, $09d938f04e8899c4$export$b22142e61b3fdbee)
    ];
});
parcelRegister("fqDxE", function(module, exports) {
    $parcel$export(module.exports, "getRealtimeChannels", ()=>$9ebeda739b38bbbc$export$2aa0d60688620de7);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $4h0Jz;
    var $9fPrG;
    var $4gYYI;
    const $9ebeda739b38bbbc$var$EMPTY_CHANNELS = [];
    const $9ebeda739b38bbbc$export$2aa0d60688620de7 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("9fPrG")).getCloudId), (0, (0, parcelRequire("4gYYI")).getProjectId), (cloudId, projectId)=>{
        if (cloudId !== undefined) return [
            (0, (0, parcelRequire("4h0Jz")).buildChannelString)(cloudId, projectId)
        ];
        return $9ebeda739b38bbbc$var$EMPTY_CHANNELS;
    });
});
parcelRegister("lCaz0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a29eb1fff76e6834$export$2e2bcd8739ae039);
    var $bC2fB;
    var $1bQGJ;
    var $5EEYw;
    var $fWch8;
    var $k5Vcp;
    var $a29eb1fff76e6834$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((state)=>({
            locationFromStore: (0, (0, parcelRequire("fWch8")).getLocation)(state)
        }), {
        onLocationChanged: (0, (0, parcelRequire("5EEYw")).routerLocationChange)
    })((0, (0, parcelRequire("1bQGJ")).withRouter)((0, (0, parcelRequire("k5Vcp")).default)));
});
parcelRegister("k5Vcp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$882e81a5fb86e713$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    class $882e81a5fb86e713$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        componentDidUpdate(prevProps) {
            const { location: spaRouterlocation, onLocationChanged: onLocationChanged, locationFromStore: locationFromStore } = this.props;
            const { location: prevSpaRouterlocation } = prevProps;
            if (prevSpaRouterlocation.search !== spaRouterlocation.search && locationFromStore.search !== spaRouterlocation.search) onLocationChanged(spaRouterlocation);
        }
        render() {
            return null;
        }
    }
});
parcelRegister("i5OnV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ac26966a6c11c74e$export$2e2bcd8739ae039);
    var $4R6GH;
    var $bC2fB;
    var $1mW3K;
    var $4gYYI;
    var $1VLi2;
    var $hFyhA;
    var $hhYQB;
    var $2IdXh;
    var $4EeLx;
    var $fvM4Z;
    var $1cn7Z;
    var $2Hh6q;
    var $k6Vft;
    var $5IiTZ;
    var $lEiof;
    var $bM42j;
    var $eETxb;
    const $ac26966a6c11c74e$var$onItemDrop = (id, { parentId: parentId, rankRequest: rankRequest }, analyticsEvent)=>{
        if (parentId !== undefined && rankRequest !== undefined) return (0, (0, parcelRequire("1VLi2")).updateAndRankAndPersistIssue)({
            issueId: id,
            rankRequest: rankRequest,
            properties: {
                parentId: parentId
            }
        }, analyticsEvent);
        if (rankRequest !== undefined) return (0, (0, parcelRequire("1VLi2")).attemptRankIssue)({
            issueId: id,
            rankRequest: rankRequest
        }, analyticsEvent);
        return (0, (0, parcelRequire("1VLi2")).updateAndPersistIssue)(id, {
            parentId: parentId
        }, analyticsEvent);
    };
    const $ac26966a6c11c74e$var$onItemExpandChanged = (id, isExpanded)=>(0, (0, parcelRequire("lEiof")).changeExpansionState)({
            id: id,
            isExpanded: !isExpanded
        });
    const $ac26966a6c11c74e$var$onCreateClick = (anchor)=>(0, (0, parcelRequire("lEiof")).setCreateItemAnchor)(anchor);
    const $ac26966a6c11c74e$var$onItemSelect = (id, { level: level, withCmd: withCmd, withShift: withShift }, analyticsEvent)=>(0, (0, parcelRequire("lEiof")).selectItems)({
            id: id,
            level: level,
            withCmd: withCmd,
            withShift: withShift
        }, analyticsEvent);
    const $ac26966a6c11c74e$var$mapStateToProps = (state, ownProps)=>{
        const isSelectEnabled = (0, (0, parcelRequire("fvM4Z")).getCanUserViewDetails)(state);
        const canUserCreate = (0, (0, parcelRequire("fvM4Z")).getCanUserCreate)(state);
        const canUserEdit = (0, (0, parcelRequire("fvM4Z")).getCanUserEdit)(state);
        return {
            isHighlightToday: !ownProps.isServer,
            isMeatballsButtonEnabled: canUserEdit || canUserCreate,
            isCreateLastEnabled: canUserCreate,
            isCreateSiblingEnabled: (0, (0, parcelRequire("1cn7Z")).getIsCreateSiblingEnabled)(state),
            isCreateChildEnabled: (0, (0, parcelRequire("1cn7Z")).getIsCreateChildEnabled)(state),
            isDragEnabled: (0, (0, parcelRequire("1cn7Z")).getIsDragEnabled)(state),
            isSelectEnabled: isSelectEnabled,
            isMultiSelectEnabled: (0, (0, parcelRequire("4R6GH")).fg)('project_timeline_multi-select_and_checkboxes') ? isSelectEnabled : isSelectEnabled || undefined,
            hasSprints: (0, (0, parcelRequire("4gYYI")).getSprints)(state).length !== 0,
            items: (0, (0, parcelRequire("1cn7Z")).getItems)(state),
            expandedItems: (0, (0, parcelRequire("bM42j")).getExpandedItems)(state),
            createItemAnchor: (0, (0, parcelRequire("bM42j")).getCreateItemAnchor)(state),
            selectedItemIds: (0, (0, parcelRequire("bM42j")).getSelectedItemIds)(state),
            activeItemId: (0, (0, parcelRequire("4R6GH")).fg)('project_timeline_multi-select_and_checkboxes') ? (0, (0, parcelRequire("2IdXh")).getSelectedIssueId)(state) : undefined,
            timelineMode: (0, (0, parcelRequire("hhYQB")).getTimelineMode)(state),
            timelineDuration: (0, (0, parcelRequire("2Hh6q")).getTimelineDuration)(state),
            timelineOrigin: (0, (0, parcelRequire("2Hh6q")).getTimelineOrigin)(state),
            today: (0, (0, parcelRequire("4gYYI")).getToday)(state),
            listWidth: (0, (0, parcelRequire("5IiTZ")).getListWidth)(state),
            itemHeight: (0, (0, parcelRequire("1cn7Z")).getItemHeight)(state),
            DndLongTaskMetric: (0, (0, parcelRequire("1mW3K")).DragAndDropLongTaskMetric),
            isVirtualiseEnabled: true,
            headerItems: (0, (0, parcelRequire("1cn7Z")).getTableHeaderItems)(state),
            ariaReadOnly: (0, (0, parcelRequire("1cn7Z")).getAriaReadOnly)(state),
            flaggedItemsHash: (0, (0, parcelRequire("hFyhA")).getIsIssueFlaggedHash)(state),
            listItemMenuOptions: (0, (0, parcelRequire("4EeLx")).getListItemMenuOptions)(state)
        };
    };
    var $ac26966a6c11c74e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($ac26966a6c11c74e$var$mapStateToProps, {
        onItemDrop: $ac26966a6c11c74e$var$onItemDrop,
        onItemSelect: $ac26966a6c11c74e$var$onItemSelect,
        onItemExpandChanged: $ac26966a6c11c74e$var$onItemExpandChanged,
        onCreateClick: $ac26966a6c11c74e$var$onCreateClick,
        onSetListWidth: (0, (0, parcelRequire("k6Vft")).setListWidth),
        onItemActivate: (0, (0, parcelRequire("lEiof")).activateItem),
        onItemMultiSelect: (0, (0, parcelRequire("lEiof")).selectMultipleItems)
    })((0, (0, parcelRequire("eETxb")).default));
});
parcelRegister("1mW3K", function(module, exports) {
    $parcel$export(module.exports, "DragAndDropLongTaskMetric", ()=>$4dab81a8fc50784d$export$5b46e4151f98a6d5);
    $parcel$export(module.exports, "useDragAndDropLongTaskMetric", ()=>$4dab81a8fc50784d$export$50ec904529fc184c);
    var $5uXOq = parcelRequire("5uXOq");
    var $7rRxE;
    const $4dab81a8fc50784d$var$onDragStart = (metricType)=>(0, (0, parcelRequire("7rRxE")).default).start(metricType);
    const $4dab81a8fc50784d$var$onDragEnd = (metricType, extraProps)=>(0, (0, parcelRequire("7rRxE")).default).stop(metricType, extraProps);
    class $4dab81a8fc50784d$export$5b46e4151f98a6d5 extends (0, $5uXOq.PureComponent) {
        static{
            this.defaultProps = {
                extraProps: {}
            };
        }
        componentDidUpdate(prevProps) {
            if (!prevProps.isDragging && this.props.isDragging) $4dab81a8fc50784d$var$onDragStart(this.props.metricType);
            else if (prevProps.isDragging && !this.props.isDragging) {
                const extraProps = {
                    ...this.props.extraProps
                };
                $4dab81a8fc50784d$var$onDragEnd(this.props.metricType, extraProps);
            }
        }
        componentWillUnmount() {
            if (this.props.isDragging) {
                const extraProps = {
                    ...this.props.extraProps
                };
                $4dab81a8fc50784d$var$onDragEnd(this.props.metricType, extraProps);
            }
        }
        render() {
            return null;
        }
    }
    const $4dab81a8fc50784d$export$50ec904529fc184c = ({ metricType: metricType, extraProps: extraProps })=>{
        const isDragging = (0, $5uXOq.useRef)(false);
        const start = ()=>{
            if (!isDragging.current) {
                $4dab81a8fc50784d$var$onDragStart(metricType);
                isDragging.current = true;
            }
        };
        const stop = (0, $5uXOq.useCallback)(()=>{
            if (isDragging.current) {
                const extraData = {
                    ...extraProps
                };
                $4dab81a8fc50784d$var$onDragEnd(metricType, extraData);
                isDragging.current = false;
            }
        }, [
            metricType,
            extraProps
        ]);
        (0, $5uXOq.useEffect)(()=>stop, [
            stop
        ]);
        return {
            start: start,
            stop: stop
        };
    };
    var $4dab81a8fc50784d$export$2e2bcd8739ae039 = $4dab81a8fc50784d$export$5b46e4151f98a6d5;
});
parcelRegister("7rRxE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$30ce13d2c67bdacb$export$2e2bcd8739ae039);
    var $5Cp2H;
    var $eKt4x;
    var $30ce13d2c67bdacb$export$2e2bcd8739ae039 = (0, (0, parcelRequire("5Cp2H")).default)((0, (0, parcelRequire("eKt4x")).ROADMAP_APP_ID));
});
parcelRegister("5Cp2H", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$373371f923120491$export$2e2bcd8739ae039);
    var $7wqBZ;
    var $dmo3v;
    var $8CsHB;
    var $26JJs;
    var $iZN6h;
    const $373371f923120491$var$dndReporterWithSloAndExtraProps = (props)=>(observationData, extraProps, stopTimestamp)=>(0, (0, parcelRequire("dmo3v")).dndReporterWithSlo)({
                framerateThreshold: 20,
                blocktimeThreshold: 100
            })(observationData, {
                ...extraProps,
                ...props
            }, stopTimestamp);
    const $373371f923120491$var$slowDndReporterWithSloAndExtraProps = (props)=>(observationData, extraProps, stopTimestamp)=>(0, (0, parcelRequire("dmo3v")).dndReporterWithSlo)({
                framerateThreshold: 16,
                blocktimeThreshold: 100
            })(observationData, {
                ...extraProps,
                ...props
            }, stopTimestamp);
    const $373371f923120491$var$scrollReporterWithSloAndExtraProps = (props)=>(observationData, extraProps)=>(0, (0, parcelRequire("26JJs")).scrollReporterWithSlo)({
                framerateThreshold: 20,
                blocktimeThreshold: 100
            })(observationData, {
                ...extraProps,
                ...props
            });
    var $373371f923120491$export$2e2bcd8739ae039 = (appId)=>({
            start: (type)=>{
                (0, (0, parcelRequire("7wqBZ")).getLongTasksMetrics)(type).start(appId);
            },
            stop: (type, extraProps = {})=>{
                let reporter = (0, (0, parcelRequire("8CsHB")).genericReporter);
                switch(type){
                    case 0, $8038b72ffd5aa8d4$export$2475592765cae5b0:
                    case 0, (0, parcelRequire("iZN6h")).LIST_DRAG_AND_DROP:
                    case 0, (0, parcelRequire("iZN6h")).CHILD_LIST_DRAG_AND_DROP:
                    case 0, (0, parcelRequire("iZN6h")).LIST_RESIZE_DRAG_AND_DROP:
                    case 0, $8038b72ffd5aa8d4$export$3ac90e7f239a7193:
                        reporter = $373371f923120491$var$dndReporterWithSloAndExtraProps(extraProps);
                        break;
                    case 0, $8038b72ffd5aa8d4$export$eedef6333f320132:
                        reporter = $373371f923120491$var$slowDndReporterWithSloAndExtraProps(extraProps);
                        break;
                    case 0, (0, parcelRequire("iZN6h")).SCROLLED:
                        reporter = $373371f923120491$var$scrollReporterWithSloAndExtraProps(extraProps);
                        break;
                    default:
                        reporter = (0, (0, parcelRequire("8CsHB")).genericReporter);
                        break;
                }
                (0, (0, parcelRequire("7wqBZ")).getLongTasksMetrics)(type).stop(reporter);
            }
        });
});
parcelRegister("7wqBZ", function(module, exports) {
    $parcel$export(module.exports, "getLongTasksMetrics", ()=>$f85af650a825558e$export$b092a8653a66aa5e);
    var $gJBT6 = parcelRequire("gJBT6");
    var $x9xyg;
    var $6RCeq;
    var $cJpFl;
    let $f85af650a825558e$var$observer = null;
    const $f85af650a825558e$var$stopObserver = ()=>{
        if ($f85af650a825558e$var$observer) {
            $f85af650a825558e$var$observer.disconnect();
            $f85af650a825558e$var$observer = null;
        }
    };
    const $f85af650a825558e$export$b092a8653a66aa5e = (0, ($parcel$interopDefault($gJBT6)))((type)=>{
        const clearData = {
            type: type
        };
        let isStarted = false;
        let observationData = {
            ...clearData
        };
        const isDnd = /dnd$/.test(type.toLowerCase());
        return {
            start: (appName, startPerformanceMark, extra = {})=>{
                if (window.PerformanceObserver && !isStarted) try {
                    const startTimestamp = (0, (0, parcelRequire("6RCeq")).default).now();
                    observationData = {
                        type: observationData.type,
                        startTimestamp: startTimestamp,
                        dragStartEndTimestamp: startTimestamp,
                        eventStartPerformanceMark: startPerformanceMark,
                        events: [],
                        appName: appName,
                        extra: extra
                    };
                    isStarted = true;
                    $f85af650a825558e$var$stopObserver();
                    $f85af650a825558e$var$observer = new window.PerformanceObserver((list)=>{
                        list.getEntries().forEach((entry)=>{
                            if (entry.entryType === 'longtask') {
                                if (!(0, (0, parcelRequire("cJpFl")).isExpandedObservationData)(observationData) || observationData.events.find((item)=>item.timestamp === entry.startTime && item.duration === entry.duration)) return;
                                observationData.events.push({
                                    timestamp: entry.startTime,
                                    duration: entry.duration
                                });
                            } else if (entry.entryType === 'event' && entry.name === 'dragstart') observationData.dragStartEndTimestamp = entry.startTime + entry.duration;
                        });
                    });
                    $f85af650a825558e$var$observer.observe({
                        type: 'longtask'
                    });
                    if (isDnd) $f85af650a825558e$var$observer.observe({
                        type: 'event',
                        durationThreshold: 48
                    });
                } catch (e) {}
            },
            stop: (callback, extra = {})=>{
                if ((0, (0, parcelRequire("6RCeq")).default).now && isStarted) {
                    const stopTimestamp = (0, (0, parcelRequire("6RCeq")).default).now();
                    setTimeout(()=>{
                        $f85af650a825558e$var$stopObserver();
                        callback({
                            ...observationData
                        }, extra, stopTimestamp);
                        observationData = {
                            ...clearData
                        };
                        isStarted = false;
                    });
                }
            },
            stopIfNoMark: (performanceMark)=>{
                if ($f85af650a825558e$var$observer && performanceMark) {
                    const perfMark = (0, (0, parcelRequire("x9xyg")).getMark)(performanceMark);
                    if (!perfMark) {
                        $f85af650a825558e$var$stopObserver();
                        observationData = {
                            ...clearData
                        };
                        isStarted = false;
                    }
                }
            }
        };
    });
});
parcelRegister("cJpFl", function(module, exports) {
    $parcel$export(module.exports, "isExpandedObservationData", ()=>$3e1de7ace69512d1$export$3d38a87309e205a4);
    const $3e1de7ace69512d1$export$3d38a87309e205a4 = (observationData)=>observationData !== undefined && 'events' in observationData && observationData.events !== undefined;
});
parcelRegister("dmo3v", function(module, exports) {
    $parcel$export(module.exports, "dndReporterWithSlo", ()=>$4a0e33c36c54a683$export$e5a00a4133cb3d76);
    $parcel$export(module.exports, "dndReporter", ()=>$4a0e33c36c54a683$export$62f293b5c9d6890c);
    var $kUU4G;
    var $fjcgS;
    var $k12ix;
    var $cJpFl;
    var $if7bx;
    const $4a0e33c36c54a683$export$e5a00a4133cb3d76 = (sloSettings)=>(observationData, extraProps, stopTimestamp)=>{
            if ((0, (0, parcelRequire("cJpFl")).isExpandedObservationData)(observationData)) {
                const { eventStartPerformanceMark: eventStartPerformanceMark } = observationData;
                if (eventStartPerformanceMark) (0, (0, parcelRequire("kUU4G")).default)(eventStartPerformanceMark);
                const startTimes = observationData.events.map((event)=>event.timestamp);
                const startLongTaskEndTimestamp = observationData.dragStartEndTimestamp;
                const startLongTasks = observationData.events.filter((event)=>event.timestamp < startLongTaskEndTimestamp);
                const movingLongTasks = observationData.events.filter((event)=>event.timestamp >= startLongTaskEndTimestamp && event.timestamp < stopTimestamp);
                const dropLongTasks = observationData.events.filter((event)=>event.timestamp >= stopTimestamp);
                const analyticsData = {
                    ...extraProps,
                    ...(0, (0, parcelRequire("if7bx")).generateLongTaskAnalyticsSummaryWithSlo)('start', startLongTasks, sloSettings),
                    ...(0, (0, parcelRequire("if7bx")).generateLongTaskAnalyticsSummaryWithSlo)('moving', movingLongTasks, sloSettings),
                    ...(0, (0, parcelRequire("if7bx")).generateLongTaskAnalyticsSummaryWithSlo)('drop', dropLongTasks, sloSettings),
                    type: observationData.type || 'unknown',
                    measureTimespan: performance.now() - Math.min(observationData.startTimestamp, ...startTimes),
                    performanceFFs: (0, (0, parcelRequire("k12ix")).getPerformanceFFsString)()
                };
                const triggerSoftwareAnalytics = (0, (0, parcelRequire("if7bx")).triggerAnalytics)(`software.${observationData.appName}`);
                triggerSoftwareAnalytics(`long-tasks-${observationData.type || 'dnd'}`, analyticsData);
                if (sloSettings) {
                    const attributes = {
                        ...extraProps,
                        type: observationData.type || 'unknown',
                        startLongTaskSloIsSuccess: analyticsData.startLongTaskSloIsSuccess,
                        movingLongTaskSloIsSuccess: analyticsData.movingLongTaskSloIsSuccess,
                        dropLongTaskSloIsSuccess: analyticsData.dropLongTaskSloIsSuccess,
                        ...sloSettings
                    };
                    (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>{
                        const payload = {
                            source: observationData.appName,
                            action: 'complete',
                            actionSubject: 'dnd operation',
                            attributes: attributes
                        };
                        client.getInstance().sendOperationalEvent(payload);
                    });
                }
            }
        };
    const $4a0e33c36c54a683$export$62f293b5c9d6890c = $4a0e33c36c54a683$export$e5a00a4133cb3d76();
});
parcelRegister("if7bx", function(module, exports) {
    $parcel$export(module.exports, "triggerAnalytics", ()=>$3a39af364070fc96$export$2c57de8a70f64057);
    $parcel$export(module.exports, "generateLongTaskAnalyticsSummary", ()=>$3a39af364070fc96$export$2be2635781d23aab);
    $parcel$export(module.exports, "generateLongTaskAnalyticsSummaryWithSlo", ()=>$3a39af364070fc96$export$c674a20081e82c6a);
    $parcel$export(module.exports, "getAverageResultsFromContinuousActions", ()=>$3a39af364070fc96$export$c36fdc326d0c207c);
    $parcel$export(module.exports, "generateLongTaskAnalyticsContinuousActionSummary", ()=>$3a39af364070fc96$export$7e5f2df95eca342a);
    var $gZFbt = parcelRequire("gZFbt");
    var $iThRn = parcelRequire("iThRn");
    var $6oxJH = parcelRequire("6oxJH");
    const $3a39af364070fc96$export$2c57de8a70f64057 = (_appName)=>(_eventNameSuffix, _eventData)=>Promise.resolve(undefined);
    const $3a39af364070fc96$export$2be2635781d23aab = (prefix, longTasks)=>{
        const durations = longTasks.map((task)=>task.duration);
        return {
            [`${prefix}LongTaskCount`]: longTasks.length,
            [`${prefix}LongTaskAvg`]: longTasks.length > 0 ? durations.reduce((sumAcc, duration)=>sumAcc + duration, 0) / longTasks.length : 0,
            [`${prefix}LongTaskMax`]: longTasks.length > 0 ? Math.max(...durations) : 0
        };
    };
    const $3a39af364070fc96$export$c674a20081e82c6a = (prefix, longTasks, sloSettings)=>{
        const summary = $3a39af364070fc96$export$2be2635781d23aab(prefix, longTasks);
        if (!sloSettings) return summary;
        const framerate = summary[`${prefix}LongTaskCount`] === 0 ? 20 : 1000 / summary[`${prefix}LongTaskAvg`];
        const blocktime = summary[`${prefix}LongTaskCount`] === 0 ? 0 : summary[`${prefix}LongTaskCount`] * summary[`${prefix}LongTaskAvg`];
        const isSuccess = framerate >= sloSettings.framerateThreshold && blocktime < sloSettings.blocktimeThreshold;
        return {
            [`${prefix}LongTaskSloIsSuccess`]: isSuccess,
            ...summary
        };
    };
    const $3a39af364070fc96$export$c36fdc326d0c207c = (prefix, data)=>({
            [`${prefix}ClusterCount`]: (0, ($parcel$interopDefault($6oxJH)))(data, `${prefix}ClusterCount`) || 0,
            [`${prefix}ClusterCountAvg`]: (0, ($parcel$interopDefault($gZFbt)))(data, `${prefix}ClusterCount`) || 0,
            [`${prefix}ClusterAvg`]: (0, ($parcel$interopDefault($gZFbt)))(data, `${prefix}ClusterAvg`) || 0,
            [`${prefix}ClusterDistanceAvg`]: (0, ($parcel$interopDefault($gZFbt)))(data, `${prefix}ClusterDistanceAvg`) || 0,
            [`${prefix}ClusterAvgLongTaskCount`]: (0, ($parcel$interopDefault($gZFbt)))(data, `${prefix}ClusterAvgLongTaskCount`) || 0,
            [`${prefix}ClusterAvgLongTaskAvg`]: data.length > 0 ? (0, ($parcel$interopDefault($iThRn)))(data.map((entry)=>entry[`${prefix}ClusterAvgLongTaskCount`] * entry[`${prefix}ClusterAvgLongTaskAvg`])) / (0, ($parcel$interopDefault($6oxJH)))(data, `${prefix}ClusterAvgLongTaskCount`) : 0,
            [`${prefix}Count`]: data.length
        });
    const $3a39af364070fc96$export$7e5f2df95eca342a = (prefix, longTasks)=>{
        const clusters = longTasks.reduce((foundClusters, task)=>{
            if (foundClusters.length === 0) foundClusters.push({
                tasks: [],
                start: 0,
                stop: 0
            });
            const prevCluster = foundClusters[foundClusters.length - 1];
            const taskEnd = task.timestamp + task.duration;
            if (prevCluster.tasks.length === 0) {
                prevCluster.tasks.push(task);
                prevCluster.start = task.timestamp;
                prevCluster.stop = taskEnd;
            } else if (task.timestamp - prevCluster.stop < 100) {
                prevCluster.tasks.push(task);
                prevCluster.stop = taskEnd;
            } else foundClusters.push({
                tasks: [
                    task
                ],
                start: task.timestamp,
                stop: taskEnd
            });
            return foundClusters;
        }, []);
        const clusterDurations = clusters.map((cluster)=>cluster.stop - cluster.start);
        const tasksDurations = longTasks.map((task)=>task.duration);
        const gapsBetweenClusters = clusters.length > 1 ? clusters.reduce((gaps, cluster, i)=>{
            if (gaps.length === 0) {
                gaps.push({
                    start: cluster.stop,
                    stop: null
                });
                return gaps;
            }
            gaps[gaps.length - 1].stop = cluster.start;
            if (i !== clusters.length - 1) gaps.push({
                start: cluster.stop,
                stop: null
            });
            return gaps;
        }, []).map((gap)=>gap.stop - gap.start) : [];
        return {
            [`${prefix}ClusterCount`]: clusters.length,
            [`${prefix}ClusterAvg`]: clusters.length > 0 ? clusterDurations.reduce((sumAcc, duration)=>sumAcc + duration, 0) / clusters.length : 0,
            [`${prefix}ClusterDistanceAvg`]: gapsBetweenClusters.length > 0 ? gapsBetweenClusters.reduce((sumAcc, duration)=>sumAcc + duration, 0) / gapsBetweenClusters.length : 0,
            [`${prefix}ClusterAvgLongTaskCount`]: clusters.length > 0 ? clusters.map((cluster)=>cluster.tasks.length).reduce((sumAcc, count)=>sumAcc + count, 0) / clusters.length : 0,
            [`${prefix}ClusterAvgLongTaskAvg`]: longTasks.length > 0 ? tasksDurations.reduce((sumAcc, duration)=>sumAcc + duration, 0) / longTasks.length : 0
        };
    };
});
parcelRegister("gZFbt", function(module, exports) {
    var $bxDef = parcelRequire("bxDef");
    var $520Yb = parcelRequire("520Yb");
    function $c5f24a2590a3cbef$var$meanBy(array, iteratee) {
        return $520Yb(array, $bxDef(iteratee, 2));
    }
    module.exports = $c5f24a2590a3cbef$var$meanBy;
});
parcelRegister("520Yb", function(module, exports) {
    var $gBzAF = parcelRequire("gBzAF");
    var $3a9de433504d679a$var$NAN = 0 / 0;
    function $3a9de433504d679a$var$baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? $gBzAF(array, iteratee) / length : $3a9de433504d679a$var$NAN;
    }
    module.exports = $3a9de433504d679a$var$baseMean;
});
parcelRegister("gBzAF", function(module, exports) {
    function $c16bb58eedefe4cd$var$baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    module.exports = $c16bb58eedefe4cd$var$baseSum;
});
parcelRegister("iThRn", function(module, exports) {
    var $gBzAF = parcelRequire("gBzAF");
    var $etyzk = parcelRequire("etyzk");
    function $dc0b37ac120f9bb6$var$sum(array) {
        return array && array.length ? $gBzAF(array, $etyzk) : 0;
    }
    module.exports = $dc0b37ac120f9bb6$var$sum;
});
parcelRegister("6oxJH", function(module, exports) {
    var $bxDef = parcelRequire("bxDef");
    var $gBzAF = parcelRequire("gBzAF");
    function $4a7f273a61dd10a7$var$sumBy(array, iteratee) {
        return array && array.length ? $gBzAF(array, $bxDef(iteratee, 2)) : 0;
    }
    module.exports = $4a7f273a61dd10a7$var$sumBy;
});
parcelRegister("8CsHB", function(module, exports) {
    $parcel$export(module.exports, "genericReporter", ()=>$fb974fbed382ceb2$export$bf7963bc28dd02c2);
    var $cJpFl;
    var $if7bx;
    const $fb974fbed382ceb2$export$bf7963bc28dd02c2 = (observationData, featureFlags = {})=>{
        if ((0, (0, parcelRequire("cJpFl")).isExpandedObservationData)(observationData)) {
            const triggerSoftwareAnalytics = (0, (0, parcelRequire("if7bx")).triggerAnalytics)(`software.${observationData.appName}`);
            const startTime = observationData.events.map((event)=>event.timestamp);
            const analyticsData = {
                ...(0, (0, parcelRequire("if7bx")).generateLongTaskAnalyticsSummary)(`${observationData.type}`, observationData.events),
                measureTimespan: performance.now() - Math.min(observationData.startTimestamp, ...startTime),
                ...featureFlags
            };
            triggerSoftwareAnalytics(`long-tasks-${observationData.type}`, analyticsData);
        }
    };
});
parcelRegister("26JJs", function(module, exports) {
    $parcel$export(module.exports, "scrollReporterWithSlo", ()=>$7e711f579f27813b$export$4cfca7ce0b67bede);
    var $fjcgS;
    var $cJpFl;
    var $if7bx;
    const $7e711f579f27813b$export$4cfca7ce0b67bede = (sloSettings)=>(observationData, extraProps)=>{
            if (!(0, (0, parcelRequire("cJpFl")).isExpandedObservationData)(observationData) || sloSettings === undefined) return;
            const startTime = observationData.events.map((event)=>event.timestamp);
            const analyticsData = {
                ...extraProps,
                ...(0, (0, parcelRequire("if7bx")).generateLongTaskAnalyticsSummaryWithSlo)('scroll', observationData.events, sloSettings),
                type: observationData.type || 'unknown',
                measureTimespan: performance.now() - Math.min(observationData.startTimestamp, ...startTime)
            };
            const attributes = {
                ...extraProps,
                type: observationData.type || 'unknown',
                isSuccess: analyticsData.scrollLongTaskSloIsSuccess,
                ...sloSettings
            };
            (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>{
                const payload = {
                    source: observationData.appName,
                    action: 'complete',
                    actionSubject: 'scroll operation',
                    attributes: attributes
                };
                client.getInstance().sendOperationalEvent(payload);
            });
        };
});
parcelRegister("4EeLx", function(module, exports) {
    $parcel$export(module.exports, "getListItemMenuOptions", ()=>$ae91582b7f393b04$export$2d38f26d6331442e);
    $parcel$export(module.exports, "getEditDatesOptionParams", ()=>$ae91582b7f393b04$export$596b38721828a359);
    $parcel$export(module.exports, "getBulkEditDatesOptionParams", ()=>$ae91582b7f393b04$export$15791ea194fd6f13);
    $parcel$export(module.exports, "getChangeColorOptionParams", ()=>$ae91582b7f393b04$export$b97c2dc8a4fa25d1);
    $parcel$export(module.exports, "getEditSprintOptionParams", ()=>$ae91582b7f393b04$export$50e3c22b2ee601e);
    $parcel$export(module.exports, "getParentOptions", ()=>$ae91582b7f393b04$export$ac3b26300904305a);
    $parcel$export(module.exports, "getDependencyOptions", ()=>$ae91582b7f393b04$export$e9fe09f7c25f0d68);
    $parcel$export(module.exports, "getDependenciesById", ()=>$ae91582b7f393b04$export$960ad1bb9ab003b5);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $bkUsp;
    var $4gYYI;
    var $hFyhA;
    var $bM42j;
    var $2IdXh;
    var $fvM4Z;
    var $bZFir;
    var $1cn7Z;
    var $fyX6b;
    var $aRAQD;
    var $Z6GXg;
    var $eo92s;
    var $b2dLY;
    var $f1rwj;
    var $6QBdz;
    const $ae91582b7f393b04$export$2d38f26d6331442e = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("fvM4Z")).getCanUserEdit), (0, (0, parcelRequire("4gYYI")).getIsSprintsFeatureEnabled), (0, (0, parcelRequire("4gYYI")).getIsChildIssuePlanningEnabled), (0, (0, parcelRequire("f1rwj")).getListItemMenuOptionsPure));
    const $ae91582b7f393b04$export$596b38721828a359 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("4gYYI")).getIsChildIssuePlanningEnabled), (0, (0, parcelRequire("4gYYI")).getIsSprintsPlanningEnabled), (0, (0, parcelRequire("hFyhA")).getIsIssueStartDateRequired), (0, (0, parcelRequire("hFyhA")).getIsIssueDueDateRequired), (0, (0, parcelRequire("hFyhA")).getIssue), (0, (0, parcelRequire("2IdXh")).getIssueTypeForIssueId), (0, (0, parcelRequire("1cn7Z")).getChartDataById), (0, (0, parcelRequire("Z6GXg")).getEditDatesOptionParamsPure));
    const $ae91582b7f393b04$export$15791ea194fd6f13 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("bM42j")).getSelectedItemIds), $ae91582b7f393b04$export$596b38721828a359, (0, (0, parcelRequire("fyX6b")).getBulkEditDatesOptionParamsPure));
    const $ae91582b7f393b04$export$b97c2dc8a4fa25d1 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("hFyhA")).getIssueLevel), (0, (0, parcelRequire("hFyhA")).getIssueColor), (0, (0, parcelRequire("aRAQD")).getChangeColorOptionParamsPure));
    const $ae91582b7f393b04$export$50e3c22b2ee601e = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("hFyhA")).getIssueLevel), (0, (0, parcelRequire("bZFir")).getIsCurrentlyAssignedToSprints), (0, (0, parcelRequire("2IdXh")).getIssueContextMenuSprints), (0, (0, parcelRequire("b2dLY")).getEditSprintOptionParamsPure));
    const $ae91582b7f393b04$export$ac3b26300904305a = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("2IdXh")).getNonBaseLevelIssueIds), (0, (0, parcelRequire("hFyhA")).getIssueTypeIdHash), (0, (0, parcelRequire("4gYYI")).getFullIssueTypeHash), (0, (0, parcelRequire("hFyhA")).getIssueKeyHash), (0, (0, parcelRequire("hFyhA")).getIssueSummaryHash), (0, (0, parcelRequire("6QBdz")).getParentOptionsPure));
    const $ae91582b7f393b04$export$e9fe09f7c25f0d68 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("hFyhA")).getIssueIds), (0, (0, parcelRequire("hFyhA")).getIssueTypeIdHash), (0, (0, parcelRequire("4gYYI")).getFullIssueTypeHash), (0, (0, parcelRequire("hFyhA")).getIssueKeyHash), (0, (0, parcelRequire("hFyhA")).getIssueSummaryHash), (0, (0, parcelRequire("eo92s")).getDependencyOptionsPure));
    const $ae91582b7f393b04$export$960ad1bb9ab003b5 = (0, $dGvGJ.createSelector)((state, issueId)=>{
        const dependencyIds = (0, (0, parcelRequire("2IdXh")).getIssueDependencies)(state, issueId);
        const dependeeIds = (0, (0, parcelRequire("2IdXh")).getIssueDependees)(state, issueId);
        const dependencies = [];
        const mapDependencies = (link)=>(dependencyId)=>{
                const dependencyIssueType = (0, (0, parcelRequire("2IdXh")).getIssueTypeForIssueId)(state, dependencyId);
                const dependencyIssueKey = (0, (0, parcelRequire("hFyhA")).getIssueKeyById)(state, dependencyId);
                if (dependencyIssueKey) dependencies.push({
                    id: dependencyId,
                    issueKey: dependencyIssueKey,
                    issueSummary: (0, (0, parcelRequire("hFyhA")).getIssueSummary)(state, dependencyId),
                    issueType: dependencyIssueType.name,
                    iconUrl: dependencyIssueType.iconUrl,
                    link: link
                });
            };
        dependencyIds?.forEach(mapDependencies((0, (0, parcelRequire("bkUsp")).INWARD_LINK_DIRECTION)));
        dependeeIds?.forEach(mapDependencies((0, (0, parcelRequire("bkUsp")).OUTWARD_LINK_DIRECTION)));
        return dependencies;
    }, (dependencies)=>dependencies);
});
parcelRegister("fyX6b", function(module, exports) {
    $parcel$export(module.exports, "getBulkEditDatesOptionParamsPure", ()=>$5870c89ab241c23c$export$721a3dbd7ea05586);
    const $5870c89ab241c23c$export$721a3dbd7ea05586 = (selectedIssueIds, { isDateEditable: isDateEditable, startDate: startDate, dueDate: dueDate, editDatesModalParams: { issueKey: issueKey, issueSummary: issueSummary, level: level, warnings: warnings } })=>({
            isDateEditable: isDateEditable,
            issueKey: issueKey,
            issueSummary: issueSummary,
            startDate: startDate,
            dueDate: dueDate,
            level: level,
            selectedIssueCount: selectedIssueIds.length,
            warnings: warnings
        });
});
parcelRegister("aRAQD", function(module, exports) {
    $parcel$export(module.exports, "getChangeColorOptionParamsPure", ()=>$317b7821738ec1d1$export$1aaf4071a599968a);
    var $joGLY;
    const $317b7821738ec1d1$export$1aaf4071a599968a = (level, color)=>({
            isColorEditable: (0, (0, parcelRequire("joGLY")).isParentLevel)(level),
            color: color
        });
});
parcelRegister("Z6GXg", function(module, exports) {
    $parcel$export(module.exports, "getEditDatesOptionParamsPure", ()=>$2420e1a29f481a7f$export$e537892b44c7a67f);
    var $joGLY;
    var $15ADj;
    var $esmwW;
    const $2420e1a29f481a7f$export$e537892b44c7a67f = (isChildIssuePlanningEnabled, isSprintsPlanningEnabled, isStartDateRequired, isDueDateRequired, issue, issueTypeData, chartData)=>{
        const { key: issueKey = '', summary: summary, startDate: startDateRaw, dueDate: dueDateRaw } = issue ?? {};
        const { name: issueType, iconUrl: iconUrl } = issueTypeData ?? {};
        const { level: level = 0, startDate: startDate, dueDate: dueDate, startDateType: startDateType, dueDateType: dueDateType, placeholder: placeholder, warnings: warnings } = chartData ?? {};
        const isParent = (0, (0, parcelRequire("joGLY")).isParentLevel)(level);
        const isDateEditable = isChildIssuePlanningEnabled && !isSprintsPlanningEnabled || isParent;
        const isStartDatePlaceholder = placeholder === (0, (0, parcelRequire("15ADj")).START_DATE_PLACEHOLDER) || placeholder === (0, (0, parcelRequire("15ADj")).START_AND_DUE_DATE_PLACEHOLDER);
        const isDueDatePlaceholder = placeholder === (0, (0, parcelRequire("15ADj")).DUE_DATE_PLACEHOLDER) || placeholder === (0, (0, parcelRequire("15ADj")).START_AND_DUE_DATE_PLACEHOLDER);
        const isStartDateInferred = startDateType === (0, (0, parcelRequire("esmwW")).ROLLUP) || startDateType === (0, (0, parcelRequire("esmwW")).INTERVAL);
        const isDueDateInferred = dueDateType === (0, (0, parcelRequire("esmwW")).ROLLUP) || dueDateType === (0, (0, parcelRequire("esmwW")).INTERVAL);
        const isStartDateEmpty = startDate === undefined || isStartDatePlaceholder || isStartDateInferred;
        const isDueDateEmpty = dueDate === undefined || isDueDatePlaceholder || isDueDateInferred;
        const isStartDateClearable = !isStartDateRequired && !isStartDateEmpty;
        const isDueDateClearable = !isDueDateRequired && !isDueDateEmpty;
        const isDateFlipped = startDate !== undefined && dueDate !== undefined && startDate < dueDate && (startDate === dueDateRaw?.value || dueDate === startDateRaw?.value);
        const canHaveChildRollup = isChildIssuePlanningEnabled && !isSprintsPlanningEnabled && isParent;
        const canHaveSprintRollup = isChildIssuePlanningEnabled && isSprintsPlanningEnabled && isParent;
        const currentStartDate = isStartDateEmpty ? undefined : new Date(startDate);
        const currentDueDate = isDueDateEmpty ? undefined : new Date(dueDate);
        return {
            isDateEditable: isDateEditable,
            isStartDateRequired: isStartDateRequired,
            isDueDateRequired: isDueDateRequired,
            startDate: startDate,
            dueDate: dueDate,
            editDatesModalParams: {
                isStartDateInferred: isStartDateInferred,
                isDueDateInferred: isDueDateInferred,
                canHaveChildRollup: canHaveChildRollup,
                canHaveSprintRollup: canHaveSprintRollup,
                issueKey: issueKey,
                issueSummary: summary?.value ?? '',
                issueType: issueType,
                iconUrl: iconUrl,
                level: level,
                currentStartDate: currentStartDate,
                currentDueDate: currentDueDate,
                warnings: warnings ?? []
            },
            removeDatesOptionParams: {
                isStartDateClearable: isDateFlipped ? isDueDateClearable : isStartDateClearable,
                isDueDateClearable: isDateFlipped ? isStartDateClearable : isDueDateClearable,
                isStartDateRolledUp: isDateFlipped ? isDueDateInferred : isStartDateInferred,
                isDueDateRolledUp: isDateFlipped ? isStartDateInferred : isDueDateInferred
            }
        };
    };
});
parcelRegister("eo92s", function(module, exports) {
    $parcel$export(module.exports, "getDependencyOptionsPure", ()=>$1735e77fd9554928$export$95e663b22b28d36);
    const $1735e77fd9554928$export$95e663b22b28d36 = (issueIds, issueTypeIdHash, issueTypesHash, issueKeyHash, issueSummaryHash)=>issueIds.reduce((dependencyOptions, id)=>{
            const issueKey = issueKeyHash[id];
            const issueType = issueTypesHash[issueTypeIdHash[id]];
            if (issueKey) dependencyOptions.push({
                id: id,
                issueKey: issueKey,
                issueSummary: issueSummaryHash[id],
                issueType: issueType.name,
                iconUrl: issueType.iconUrl
            });
            return dependencyOptions;
        }, []);
});
parcelRegister("b2dLY", function(module, exports) {
    $parcel$export(module.exports, "getEditSprintOptionParamsPure", ()=>$204a5a33fce85412$export$71756d0ea1deed1f);
    var $joGLY;
    const $204a5a33fce85412$export$71756d0ea1deed1f = (level, isCurrentlyAssignedToSprints, sprintsAssignable)=>({
            isSprintEditable: (0, (0, parcelRequire("joGLY")).isBaseLevel)(level) && (isCurrentlyAssignedToSprints || sprintsAssignable.length > 0),
            isSprintClearable: isCurrentlyAssignedToSprints,
            sprints: sprintsAssignable
        });
});
parcelRegister("f1rwj", function(module, exports) {
    $parcel$export(module.exports, "getListItemMenuOptionsPure", ()=>$00dbaa46f4412f84$export$359bb0efbdc4166b);
    var $4R6GH;
    var $iZN6h;
    var $eKt4x;
    var $h4UZ5;
    const $00dbaa46f4412f84$export$359bb0efbdc4166b = (canUserEdit, isSprintsFeatureEnabled, isChildIssuePlanningEnabled)=>{
        const { ITEMS_SECTION: ITEMS_SECTION, MOVE_ITEM: MOVE_ITEM, CREATE_ITEM: CREATE_ITEM, CREATE_CHILD_ITEM: CREATE_CHILD_ITEM, CREATE_ITEM_ABOVE: CREATE_ITEM_ABOVE, CREATE_ITEM_BELOW: CREATE_ITEM_BELOW, MOVE_ITEM_UP: MOVE_ITEM_UP, MOVE_ITEM_DOWN: MOVE_ITEM_DOWN, MOVE_ITEM_TO_TOP: MOVE_ITEM_TO_TOP, MOVE_ITEM_TO_BOTTOM: MOVE_ITEM_TO_BOTTOM, SELECTED_ITEM_COUNTER: SELECTED_ITEM_COUNTER } = (0, (0, parcelRequire("iZN6h")).listItemMenu);
        const overrideLabels = {
            [ITEMS_SECTION]: (0, (0, parcelRequire("h4UZ5")).default)[ITEMS_SECTION],
            [CREATE_ITEM]: (0, (0, parcelRequire("h4UZ5")).default)[CREATE_ITEM],
            [MOVE_ITEM]: (0, (0, parcelRequire("h4UZ5")).default)[MOVE_ITEM],
            [CREATE_CHILD_ITEM]: (0, (0, parcelRequire("h4UZ5")).default)[CREATE_CHILD_ITEM],
            [CREATE_ITEM_ABOVE]: (0, (0, parcelRequire("h4UZ5")).default)[CREATE_ITEM_ABOVE],
            [CREATE_ITEM_BELOW]: (0, (0, parcelRequire("h4UZ5")).default)[CREATE_ITEM_BELOW],
            [MOVE_ITEM_UP]: (0, (0, parcelRequire("h4UZ5")).default)[MOVE_ITEM_UP],
            [MOVE_ITEM_DOWN]: (0, (0, parcelRequire("h4UZ5")).default)[MOVE_ITEM_DOWN],
            [MOVE_ITEM_TO_TOP]: (0, (0, parcelRequire("h4UZ5")).default)[MOVE_ITEM_TO_TOP],
            [MOVE_ITEM_TO_BOTTOM]: (0, (0, parcelRequire("h4UZ5")).default)[MOVE_ITEM_TO_BOTTOM],
            [SELECTED_ITEM_COUNTER]: (0, (0, parcelRequire("h4UZ5")).default)[SELECTED_ITEM_COUNTER]
        };
        if ((0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y')) {
            if (canUserEdit) {
                const schedulingOptions = [
                    ...isSprintsFeatureEnabled && isChildIssuePlanningEnabled && (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline_sprint_scheduling_a11y') ? [
                        {
                            id: (0, (0, parcelRequire("eKt4x")).EDIT_SPRINT)
                        }
                    ] : [],
                    ...(0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-meatballs-date-update-modal') ? [
                        {
                            id: (0, (0, parcelRequire("eKt4x")).EDIT_DATES)
                        },
                        {
                            id: (0, (0, parcelRequire("eKt4x")).REMOVE_DATES)
                        }
                    ] : [],
                    ...(0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-meatball-dependency-modal') ? [
                        {
                            id: (0, (0, parcelRequire("eKt4x")).EDIT_DEPENDENCY)
                        }
                    ] : []
                ];
                return {
                    overrideLabels: overrideLabels,
                    customSections: [
                        {
                            id: ITEMS_SECTION,
                            title: (0, (0, parcelRequire("h4UZ5")).default)[ITEMS_SECTION],
                            options: [
                                ...(0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-meatball-reparent-menu') ? [
                                    {
                                        id: (0, (0, parcelRequire("eKt4x")).CHANGE_PARENT_ISSUE)
                                    }
                                ] : [],
                                ...(0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-meatballs-change-issue-color') ? [
                                    {
                                        id: (0, (0, parcelRequire("eKt4x")).CHANGE_ISSUE_COLOR)
                                    }
                                ] : []
                            ]
                        },
                        {
                            id: (0, (0, parcelRequire("eKt4x")).SCHEDULING_SECTION),
                            title: (0, (0, parcelRequire("h4UZ5")).default)[0, (0, parcelRequire("eKt4x")).SCHEDULING_SECTION],
                            options: schedulingOptions
                        }
                    ],
                    customSectionsBulk: [
                        {
                            id: (0, (0, parcelRequire("eKt4x")).BULK_SECTION),
                            options: [
                                ...(0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmap_timeline_meatball_selected_item_option') ? [
                                    {
                                        id: (0, (0, parcelRequire("eKt4x")).BULK_EDIT_DATES)
                                    }
                                ] : []
                            ]
                        }
                    ]
                };
            }
        }
        return {
            overrideLabels: overrideLabels,
            customSections: [],
            customSectionsBulk: []
        };
    };
});
parcelRegister("h4UZ5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d835cb040cf0c0e6$export$2e2bcd8739ae039);
    var $7VHMR;
    var $d835cb040cf0c0e6$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        schedulingSection: {
            "id": "roadmap.standard-roadmap.state.selectors.list-item-menu-option.pure.scheduling-section",
            "defaultMessage": "Scheduling"
        },
        itemsSection: {
            "id": "roadmap.standard-roadmap.state.selectors.list-item-menu-option.pure.items-section",
            "defaultMessage": "Issues"
        },
        createItem: {
            "id": "roadmap.standard-roadmap.state.selectors.list-item-menu-option.pure.create-item",
            "defaultMessage": "Create issue"
        },
        createChildItem: {
            "id": "roadmap.standard-roadmap.state.selectors.list-item-menu-option.pure.create-child-item",
            "defaultMessage": "Create child issue"
        },
        createItemAbove: {
            "id": "roadmap.standard-roadmap.state.selectors.list-item-menu-option.pure.create-item-above",
            "defaultMessage": "Create issue above"
        },
        createItemBelow: {
            "id": "roadmap.standard-roadmap.state.selectors.list-item-menu-option.pure.create-item-below",
            "defaultMessage": "Create issue below"
        },
        moveItem: {
            "id": "roadmap.standard-roadmap.state.selectors.list-item-menu-option.pure.move-item",
            "defaultMessage": "Move issue"
        },
        moveItemUp: {
            "id": "roadmap.standard-roadmap.state.selectors.list-item-menu-option.pure.move-item-up",
            "defaultMessage": "Move issue up"
        },
        moveItemDown: {
            "id": "roadmap.standard-roadmap.state.selectors.list-item-menu-option.pure.move-item-down",
            "defaultMessage": "Move issue down"
        },
        moveItemToTop: {
            "id": "roadmap.standard-roadmap.state.selectors.list-item-menu-option.pure.move-item-to-top",
            "defaultMessage": "Move issue to top"
        },
        moveItemToBottom: {
            "id": "roadmap.standard-roadmap.state.selectors.list-item-menu-option.pure.move-item-to-bottom",
            "defaultMessage": "Move issue to bottom"
        },
        selectedItemCounter: {
            "id": "roadmap.standard-roadmap.state.selectors.list-item-menu-option.pure.selected-item-counter",
            "defaultMessage": "<badge>{count}</badge> {count, plural, one {issue selected} other {issues selected}}"
        }
    });
});
parcelRegister("6QBdz", function(module, exports) {
    $parcel$export(module.exports, "getParentOptionsPure", ()=>$50f963d0d18eef32$export$f53bc4fef5dddefe);
    const $50f963d0d18eef32$export$f53bc4fef5dddefe = (parentIds, issueTypeIdHash, issueTypesHash, issueKeyHash, issueSummaryHash)=>parentIds.reduce((parentOptions, id)=>{
            const issueKey = issueKeyHash[id];
            const issueSummary = issueSummaryHash[id];
            const issueTypeId = issueTypeIdHash[id];
            const issueType = issueTypesHash[issueTypeId];
            if (issueKey) parentOptions.push({
                id: id,
                key: issueKey,
                summary: issueSummary,
                issueType: issueType.name,
                iconUrl: issueType.iconUrl
            });
            return parentOptions;
        }, []);
});
parcelRegister("eETxb", function(module, exports) {
    $parcel$export(module.exports, "renderers", ()=>$9b079e5ee49fa0f9$export$161aa799a4b9b9d7);
    $parcel$export(module.exports, "default", ()=>$9b079e5ee49fa0f9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fMv2d;
    var $50ELZ;
    var $hdLIE;
    var $2IvBE;
    var $9ary6;
    var $cToNg;
    var $9iIto;
    var $hEVku;
    var $i4Xj8;
    var $5u7kL;
    var $cvG33;
    var $ehQek;
    var $hFbeZ;
    var $dHRcC;
    var $jaLzQ;
    var $3Z7BC;
    const $9b079e5ee49fa0f9$var$renderListItemContent = (props, { isVirtual: isVirtual, ...state })=>{
        if (isVirtual) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i4Xj8")).default), props);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5u7kL")).default), {
            ...props,
            ...state
        });
    };
    const $9b079e5ee49fa0f9$var$renderListItemSecondaryContent = (props, { isVirtual: isVirtual })=>isVirtual ? null : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dHRcC")).default), props);
    const $9b079e5ee49fa0f9$var$renderListItemMenuOption = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ehQek")).default), props);
    const $9b079e5ee49fa0f9$var$renderListItemModal = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hFbeZ")).default), props);
    const $9b079e5ee49fa0f9$var$renderChartItemContent = (props, { isVirtual: isVirtual, ...state })=>{
        if (isVirtual) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hdLIE")).default), props);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2IvBE")).default), {
            ...props,
            ...state
        });
    };
    const $9b079e5ee49fa0f9$export$161aa799a4b9b9d7 = {
        renderListEmptyContent: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9iIto")).default), null),
        renderListItemContent: $9b079e5ee49fa0f9$var$renderListItemContent,
        renderListItemSecondaryContent: $9b079e5ee49fa0f9$var$renderListItemSecondaryContent,
        renderListItemCreate: (props, state)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cvG33")).default), {
                ...props,
                ...state
            }),
        renderChartOverlay: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9ary6")).default), null),
        renderChartTimelineOverlay: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cToNg")).default), null),
        renderListItemMenuOption: $9b079e5ee49fa0f9$var$renderListItemMenuOption,
        renderListItemModal: $9b079e5ee49fa0f9$var$renderListItemModal,
        renderChartItemContent: $9b079e5ee49fa0f9$var$renderChartItemContent,
        renderProvider: (0, parcelRequire("3Z7BC")).renderProvider,
        renderListHeaderItem: (0, parcelRequire("hEVku")).renderListHeaderItem,
        renderChartHeaderItem: (0, parcelRequire("50ELZ")).renderChartHeaderItem
    };
    const $9b079e5ee49fa0f9$var$RoadmapsTable = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fMv2d")).default), {
            ...props,
            scope: "roadmap",
            renderers: $9b079e5ee49fa0f9$export$161aa799a4b9b9d7,
            marshalOptions: (0, (0, parcelRequire("jaLzQ")).marshalOptions)
        });
    var $9b079e5ee49fa0f9$export$2e2bcd8739ae039 = $9b079e5ee49fa0f9$var$RoadmapsTable;
});
parcelRegister("fMv2d", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9572c37c42355ae0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $iZN6h;
    var $WPwAA;
    var $g3prf;
    var $hGh1Z;
    var $9puhl;
    var $cQx6e;
    var $3ruU1;
    var $lGdZu;
    var $biT18;
    var $5SIwg;
    const $9572c37c42355ae0$var$EMPTY_ARRAY = [];
    function $9572c37c42355ae0$export$2e2bcd8739ae039(props) {
        const { marshalOptions: marshalOptions, isCreateLastEnabled: isCreateLastEnabled, isCreateChildEnabled: isCreateChildEnabled, isCreateSiblingEnabled: isCreateSiblingEnabled, isDragEnabled: isDragEnabled, isSelectEnabled: isSelectEnabled, isMultiSelectEnabled: isMultiSelectEnabled, isHighlightToday: isHighlightToday, listWidth: listWidth, items: items, headerItems: headerItems, itemHeight: itemHeight, activeItemId: activeItemId, onItemActivate: onItemActivate, selectedItemIds: selectedItemIds, onItemMultiSelect: onItemMultiSelect, expandedItems: expandedItems, today: today, timelineMode: timelineMode, timelineDuration: timelineDuration, timelineOrigin: timelineOrigin, createItemAnchor: createItemAnchor, ariaRowCount: ariaRowCount, ariaLabel: ariaLabel, ariaReadOnly: ariaReadOnly, isTreeDrag: isTreeDrag = false, listItemMenuOptions: listItemMenuOptions, isMeatballsButtonEnabled: isMeatballsButtonEnabled = false, ...mainProps } = props;
        const safeSelectedItemIds = isSelectEnabled ? selectedItemIds : $9572c37c42355ae0$var$EMPTY_ARRAY;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cQx6e")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lGdZu")).TimelineViewportProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("WPwAA")).EnablementProvider), {
            isDragEnabled: isDragEnabled,
            isSelectEnabled: isSelectEnabled,
            isMultiSelectEnabled: isSelectEnabled && isMultiSelectEnabled,
            isCreateLastEnabled: isCreateLastEnabled,
            isCreateSiblingEnabled: isCreateSiblingEnabled,
            isCreateChildEnabled: isCreateChildEnabled,
            isMeatballsButtonEnabled: isMeatballsButtonEnabled,
            isHighlightToday: isHighlightToday,
            isTreeDrag: isTreeDrag
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("g3prf")).default), {
            headerItems: headerItems,
            isRowCountKnown: ariaRowCount !== -1
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hGh1Z")).ItemsProvider), {
            items: items,
            createItemAnchor: createItemAnchor,
            isCreateLastEnabled: isCreateLastEnabled,
            isCreateSiblingEnabled: isCreateSiblingEnabled,
            isCreateChildEnabled: isCreateChildEnabled,
            expandedItems: expandedItems,
            selectedItemIdsWithPermission: isSelectEnabled ? selectedItemIds : undefined,
            onItemMultiSelect: onItemMultiSelect,
            activeItemId: activeItemId,
            onItemActivate: onItemActivate,
            itemHeight: itemHeight
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("biT18")).TimelineProviderSweetState), {
            timelineMode: timelineMode,
            timelineDuration: timelineDuration,
            timelineOrigin: timelineOrigin,
            today: today
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9puhl")).default), {
            listWidth: listWidth,
            listItemMenuOptions: listItemMenuOptions
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3ruU1")).default), {
            scope: mainProps.scope,
            ariaLabel: ariaLabel,
            ariaReadOnly: ariaReadOnly,
            ariaMultiselectable: isSelectEnabled ? isMultiSelectEnabled : undefined,
            ...marshalOptions
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5SIwg")).default), {
            ...mainProps,
            selectedItemIds: safeSelectedItemIds
        })))))))));
    }
    $9572c37c42355ae0$export$2e2bcd8739ae039.defaultProps = {
        isVirtualiseEnabled: false,
        isCreateLastEnabled: true,
        isCreateSiblingEnabled: true,
        isCreateChildEnabled: true,
        isDragEnabled: true,
        isSelectEnabled: true,
        isMultiSelectEnabled: false,
        isResizeEnabled: true,
        isHighlightToday: true,
        isHideScrollbar: false,
        items: [],
        headerItems: [],
        expandedItems: {},
        renderers: {},
        marshalOptions: {},
        createItemAnchor: undefined,
        activeItemId: undefined,
        selectedItemIds: [],
        itemHeight: (0, (0, parcelRequire("iZN6h")).DEFAULT_ITEM_HEIGHT),
        listWidth: (0, (0, parcelRequire("iZN6h")).DEFAULT_LIST_WIDTH)(),
        DndLongTaskMetric: undefined,
        onItemSelect: (0, ($parcel$interopDefault($8Rkzz))),
        onItemMultiSelect: (0, ($parcel$interopDefault($8Rkzz))),
        onItemActivate: (0, ($parcel$interopDefault($8Rkzz))),
        onItemDrop: (0, ($parcel$interopDefault($8Rkzz))),
        onCreateClick: (0, ($parcel$interopDefault($8Rkzz))),
        onItemExpandChanged: (0, ($parcel$interopDefault($8Rkzz))),
        onSetListWidth: (0, ($parcel$interopDefault($8Rkzz))),
        ariaRowCount: undefined,
        ariaLabel: undefined,
        ariaReadOnly: undefined,
        listItemMenuOptions: {
            overrideLabels: {},
            customSections: []
        }
    };
});
parcelRegister("WPwAA", function(module, exports) {
    $parcel$export(module.exports, "useEnablements", ()=>$eccd758798ebd83c$export$f6bfb0ec6efae17b);
    $parcel$export(module.exports, "EnablementProvider", ()=>$eccd758798ebd83c$export$221a50e4a5e2cf12);
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    var $i7qsd;
    const $eccd758798ebd83c$var$initialState = {
        isDragEnabled: false,
        isSelectEnabled: false,
        isMultiSelectEnabled: false,
        isCreateLastEnabled: false,
        isCreateSiblingEnabled: false,
        isCreateChildEnabled: false,
        isHighlightToday: true,
        isTreeDrag: false,
        isMeatballsButtonEnabled: false
    };
    const $eccd758798ebd83c$export$faca84be7efd165 = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $eccd758798ebd83c$var$initialState,
        actions: (0, parcelRequire("i7qsd")).actions,
        name: 'timeline-table.enablements'
    });
    const $eccd758798ebd83c$export$f6bfb0ec6efae17b = (0, (0, parcelRequire("3sQ5x")).createHook)($eccd758798ebd83c$export$faca84be7efd165);
    const $eccd758798ebd83c$export$221a50e4a5e2cf12 = (0, (0, parcelRequire("gg7kZ")).createContainer)($eccd758798ebd83c$export$faca84be7efd165, {
        onInit: ()=>({ setState: setState }, enablements)=>{
                setState({
                    ...enablements
                });
            },
        onUpdate: ()=>({ setState: setState }, enablements)=>{
                setState({
                    ...enablements
                });
            }
    });
});
parcelRegister("i7qsd", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$4dd51ff8d4f8c8e2$export$e324594224ef24da);
    const $4dd51ff8d4f8c8e2$export$e324594224ef24da = {};
});
parcelRegister("g3prf", function(module, exports) {
    $parcel$export(module.exports, "useHeaderState", ()=>$2776b7d6c4501657$export$704ca874967743c3);
    $parcel$export(module.exports, "useAriaRowOffset", ()=>$2776b7d6c4501657$export$21de272f1555a588);
    $parcel$export(module.exports, "useHeaderItemIndexes", ()=>$2776b7d6c4501657$export$665cd3c10cd5eb7);
    $parcel$export(module.exports, "default", ()=>$2776b7d6c4501657$export$2e2bcd8739ae039);
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    var $iZN6h;
    var $kKwEI;
    var $1Abrp;
    const $2776b7d6c4501657$var$initialState = {
        headerItems: [],
        headerHeight: (0, (0, parcelRequire("iZN6h")).BASE_HEADER_HEIGHT),
        headerItemsOffsetTop: {},
        isRowCountKnown: true
    };
    const $2776b7d6c4501657$export$52342bdf89fb39e7 = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $2776b7d6c4501657$var$initialState,
        actions: (0, parcelRequire("kKwEI")).actions,
        name: 'timeline-table.header'
    });
    const $2776b7d6c4501657$export$704ca874967743c3 = (0, (0, parcelRequire("3sQ5x")).createHook)($2776b7d6c4501657$export$52342bdf89fb39e7);
    const $2776b7d6c4501657$export$21de272f1555a588 = (0, (0, parcelRequire("3sQ5x")).createHook)($2776b7d6c4501657$export$52342bdf89fb39e7, {
        selector: ({ isRowCountKnown: isRowCountKnown, headerItems: headerItems })=>isRowCountKnown ? headerItems.length : undefined
    });
    const $2776b7d6c4501657$export$665cd3c10cd5eb7 = (0, (0, parcelRequire("3sQ5x")).createHook)($2776b7d6c4501657$export$52342bdf89fb39e7, {
        selector: ({ headerItems: headerItems })=>headerItems.reduce((acc, item, index)=>{
                acc[item.id] = index;
                return acc;
            }, {})
    });
    const $2776b7d6c4501657$var$handleState = ()=>({ setState: setState }, { headerItems: headerItems, isRowCountKnown: isRowCountKnown })=>{
            const derivedHeaderState = (0, (0, parcelRequire("1Abrp")).getDerivedHeaderState)(headerItems);
            setState({
                ...derivedHeaderState,
                isRowCountKnown: isRowCountKnown
            });
        };
    const $2776b7d6c4501657$var$HeaderProvider = (0, (0, parcelRequire("gg7kZ")).createContainer)($2776b7d6c4501657$export$52342bdf89fb39e7, {
        onInit: $2776b7d6c4501657$var$handleState,
        onUpdate: $2776b7d6c4501657$var$handleState
    });
    var $2776b7d6c4501657$export$2e2bcd8739ae039 = $2776b7d6c4501657$var$HeaderProvider;
});
parcelRegister("kKwEI", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$e19c33e323b398e1$export$e324594224ef24da);
    const $e19c33e323b398e1$export$e324594224ef24da = {};
});
parcelRegister("1Abrp", function(module, exports) {
    $parcel$export(module.exports, "getDerivedHeaderState", ()=>$0c737e962e2aa7d1$export$cde087a6551ccf85);
    var $iZN6h;
    const $0c737e962e2aa7d1$export$cde087a6551ccf85 = (customHeaderItems)=>{
        const combinedHeaderItems = [
            {
                id: (0, (0, parcelRequire("iZN6h")).DEFAULT_HEADER_ROW_ID),
                height: (0, (0, parcelRequire("iZN6h")).BASE_HEADER_HEIGHT)
            },
            ...customHeaderItems
        ];
        const sanitizedHeaderItems = combinedHeaderItems.map(({ id: id, height: height })=>({
                id: id,
                height: height ?? (0, (0, parcelRequire("iZN6h")).DEFAULT_SUBHEADER_HEIGHT)
            }));
        const headerItemsOffsetTop = {};
        const headerHeight = sanitizedHeaderItems.reduce((total, { id: id, height: height })=>{
            headerItemsOffsetTop[id] = total;
            return total + height;
        }, 0);
        return {
            headerItems: sanitizedHeaderItems,
            headerHeight: headerHeight,
            headerItemsOffsetTop: headerItemsOffsetTop
        };
    };
});
parcelRegister("hGh1Z", function(module, exports) {
    $parcel$export(module.exports, "useItems", ()=>$cf7a1679ad005897$export$7bfdd97581ca93c);
    $parcel$export(module.exports, "useItemIndexes", ()=>$cf7a1679ad005897$export$bd1eaa5808f71a42);
    $parcel$export(module.exports, "useIsItemSelected", ()=>$cf7a1679ad005897$export$3d9fe48014f19d8a);
    $parcel$export(module.exports, "useIsItemMultiSelected", ()=>$cf7a1679ad005897$export$e452b1d46f765b84);
    $parcel$export(module.exports, "useItemsSelectionCount", ()=>$cf7a1679ad005897$export$fd6d33cbb99af134);
    $parcel$export(module.exports, "useIsTableEmpty", ()=>$cf7a1679ad005897$export$ad9c09bad4bdddda);
    $parcel$export(module.exports, "useItemsCount", ()=>$cf7a1679ad005897$export$29409325c4d1aa3a);
    $parcel$export(module.exports, "useAriaRowCount", ()=>$cf7a1679ad005897$export$35cd36afbcd5e208);
    $parcel$export(module.exports, "useItemHeight", ()=>$cf7a1679ad005897$export$1d47b041c6ce1962);
    $parcel$export(module.exports, "useItemsContainerStyles", ()=>$cf7a1679ad005897$export$4d54f7a51148a517);
    $parcel$export(module.exports, "useCreateItemAnchor", ()=>$cf7a1679ad005897$export$79c0b16424e10cdb);
    $parcel$export(module.exports, "useCreateItemAnchorIndex", ()=>$cf7a1679ad005897$export$97b98339b446b4f4);
    $parcel$export(module.exports, "useSelectedItemIds", ()=>$cf7a1679ad005897$export$c9fc8524b88d56df);
    $parcel$export(module.exports, "useActiveItemId", ()=>$cf7a1679ad005897$export$6962c376bd636b65);
    $parcel$export(module.exports, "useIsItemActive", ()=>$cf7a1679ad005897$export$22302ddf52c3b4c2);
    $parcel$export(module.exports, "useIsItemSelectable", ()=>$cf7a1679ad005897$export$a431ef15e96621e9);
    $parcel$export(module.exports, "ItemsProvider", ()=>$cf7a1679ad005897$export$dab1678cbe62d3ff);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    var $iZN6h;
    var $7ouUj;
    var $iymwf;
    var $daR3B;
    var $g3prf;
    var $g1EyU;
    var $2vEiN;
    const $cf7a1679ad005897$var$DEFAULT_STATE = {
        items: [],
        itemIndexes: {},
        selectedItemIds: [],
        rangeAnchorItemId: undefined,
        onItemMultiSelect: (0, ($parcel$interopDefault($8Rkzz))),
        activeItemId: undefined,
        onItemActivate: (0, ($parcel$interopDefault($8Rkzz))),
        itemsSelectionState: {},
        itemsSelectionCount: 0,
        ariaRowCount: 0,
        isTableEmpty: false,
        itemsBackground: 'none',
        totalHeight: 0,
        itemHeight: (0, (0, parcelRequire("iZN6h")).DEFAULT_ITEM_HEIGHT),
        createItemAnchor: undefined
    };
    const $cf7a1679ad005897$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $cf7a1679ad005897$var$DEFAULT_STATE,
        actions: (0, parcelRequire("g1EyU")).actions,
        name: 'timeline-table.items'
    });
    const $cf7a1679ad005897$export$fbd09c28377f1868 = (0, (0, parcelRequire("3sQ5x")).createHook)($cf7a1679ad005897$var$store);
    const $cf7a1679ad005897$export$7bfdd97581ca93c = (0, (0, parcelRequire("3sQ5x")).createHook)($cf7a1679ad005897$var$store, {
        selector: (0, (0, parcelRequire("2vEiN")).getItems)
    });
    const $cf7a1679ad005897$export$bd1eaa5808f71a42 = (0, (0, parcelRequire("3sQ5x")).createHook)($cf7a1679ad005897$var$store, {
        selector: (0, (0, parcelRequire("2vEiN")).getItemIndexes)
    });
    const $cf7a1679ad005897$export$3d9fe48014f19d8a = (0, (0, parcelRequire("3sQ5x")).createHook)($cf7a1679ad005897$var$store, {
        selector: (0, (0, parcelRequire("2vEiN")).getIsItemSelected)
    });
    const $cf7a1679ad005897$export$e452b1d46f765b84 = (0, (0, parcelRequire("3sQ5x")).createHook)($cf7a1679ad005897$var$store, {
        selector: (0, (0, parcelRequire("2vEiN")).getIsItemMultiSelected)
    });
    const $cf7a1679ad005897$export$fd6d33cbb99af134 = (0, (0, parcelRequire("3sQ5x")).createHook)($cf7a1679ad005897$var$store, {
        selector: (0, (0, parcelRequire("2vEiN")).getItemsSelectionCount)
    });
    const $cf7a1679ad005897$export$ad9c09bad4bdddda = (0, (0, parcelRequire("3sQ5x")).createHook)($cf7a1679ad005897$var$store, {
        selector: (0, (0, parcelRequire("2vEiN")).getIsTableEmpty)
    });
    const $cf7a1679ad005897$export$29409325c4d1aa3a = (0, (0, parcelRequire("3sQ5x")).createHook)($cf7a1679ad005897$var$store, {
        selector: (0, (0, parcelRequire("2vEiN")).getItemsCount)
    });
    const $cf7a1679ad005897$export$35cd36afbcd5e208 = (0, (0, parcelRequire("3sQ5x")).createHook)($cf7a1679ad005897$var$store, {
        selector: (0, (0, parcelRequire("2vEiN")).getAriaRowCount)
    });
    const $cf7a1679ad005897$export$1d47b041c6ce1962 = (0, (0, parcelRequire("3sQ5x")).createHook)($cf7a1679ad005897$var$store, {
        selector: (0, (0, parcelRequire("2vEiN")).getItemHeight)
    });
    const $cf7a1679ad005897$export$4d54f7a51148a517 = (0, (0, parcelRequire("3sQ5x")).createHook)($cf7a1679ad005897$var$store, {
        selector: (0, (0, parcelRequire("2vEiN")).getItemsContainerStyles)
    });
    const $cf7a1679ad005897$export$79c0b16424e10cdb = (0, (0, parcelRequire("3sQ5x")).createHook)($cf7a1679ad005897$var$store, {
        selector: (0, (0, parcelRequire("2vEiN")).getCreateItemAnchor)
    });
    const $cf7a1679ad005897$export$97b98339b446b4f4 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($cf7a1679ad005897$var$store, {
        selector: (0, (0, parcelRequire("2vEiN")).getCreateItemAnchorIndex)
    });
    const $cf7a1679ad005897$export$51a276b6d0945af7 = (0, (0, parcelRequire("3sQ5x")).createHook)($cf7a1679ad005897$var$store, {
        selector: (0, (0, parcelRequire("2vEiN")).getHasActiveCreate)
    });
    const $cf7a1679ad005897$export$c9fc8524b88d56df = (0, (0, parcelRequire("3sQ5x")).createHook)($cf7a1679ad005897$var$store, {
        selector: (0, (0, parcelRequire("2vEiN")).getSelectedItemIds)
    });
    const $cf7a1679ad005897$export$6962c376bd636b65 = (0, (0, parcelRequire("3sQ5x")).createHook)($cf7a1679ad005897$var$store, {
        selector: (0, (0, parcelRequire("2vEiN")).getActiveItemId)
    });
    const $cf7a1679ad005897$export$22302ddf52c3b4c2 = (0, (0, parcelRequire("3sQ5x")).createHook)($cf7a1679ad005897$var$store, {
        selector: (0, (0, parcelRequire("2vEiN")).getIsItemActive)
    });
    const $cf7a1679ad005897$export$a431ef15e96621e9 = (0, (0, parcelRequire("3sQ5x")).createHook)($cf7a1679ad005897$var$store, {
        selector: (0, (0, parcelRequire("2vEiN")).getIsItemSelectable)
    });
    const $cf7a1679ad005897$var$updateState = ()=>({ setState: setState }, { items: items, createItemAnchor: createItemAnchor, expandedItems: expandedItems, activeItemId: activeItemId, onItemActivate: onItemActivate, selectedItemIdsWithPermission: selectedItemIdsWithPermission, onItemMultiSelect: onItemMultiSelect, isCreateLastEnabled: isCreateLastEnabled, isCreateSiblingEnabled: isCreateSiblingEnabled, isCreateChildEnabled: isCreateChildEnabled, itemHeight: itemHeight, ariaRowOffset: ariaRowOffset })=>{
            const { flatItems: flatItems, itemIndexes: itemIndexes, ariaRowCount: ariaRowCount } = (0, (0, parcelRequire("7ouUj")).getHierarchyEnrichedItems)(items, createItemAnchor, expandedItems, isCreateLastEnabled, isCreateSiblingEnabled, isCreateChildEnabled, itemHeight, ariaRowOffset);
            const itemsSelectionState = (0, (0, parcelRequire("daR3B")).getSelectedItemIdsHash)(selectedItemIdsWithPermission);
            const { itemsBackground: itemsBackground, totalHeight: totalHeight } = (0, (0, parcelRequire("iymwf")).getItemsContainerStyle)(flatItems, itemHeight);
            setState({
                items: flatItems,
                itemIndexes: itemIndexes,
                itemsSelectionState: itemsSelectionState,
                itemsSelectionCount: selectedItemIdsWithPermission?.length,
                activeItemId: activeItemId,
                onItemActivate: onItemActivate,
                selectedItemIds: selectedItemIdsWithPermission ?? [],
                onItemMultiSelect: onItemMultiSelect,
                ariaRowCount: ariaRowCount,
                isTableEmpty: items.length === 0,
                itemsBackground: itemsBackground,
                totalHeight: totalHeight,
                itemHeight: itemHeight,
                createItemAnchor: createItemAnchor
            });
        };
    const $cf7a1679ad005897$var$ItemsProviderContainer = (0, (0, parcelRequire("gg7kZ")).createContainer)($cf7a1679ad005897$var$store, {
        onInit: $cf7a1679ad005897$var$updateState,
        onUpdate: $cf7a1679ad005897$var$updateState
    });
    const $cf7a1679ad005897$export$dab1678cbe62d3ff = (props)=>{
        const [ariaRowOffset] = (0, (0, parcelRequire("g3prf")).useAriaRowOffset)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($cf7a1679ad005897$var$ItemsProviderContainer, {
            ...props,
            ariaRowOffset: ariaRowOffset
        });
    };
});
parcelRegister("7ouUj", function(module, exports) {
    $parcel$export(module.exports, "isRoot", ()=>$cf73b6cf34ba63b7$export$e3140dc7d0c35e48);
    $parcel$export(module.exports, "isBaseLevel", ()=>$cf73b6cf34ba63b7$export$3f3fbf12338c09a4);
    $parcel$export(module.exports, "getItemLevel", ()=>$cf73b6cf34ba63b7$export$aabd95853648484e);
    $parcel$export(module.exports, "getHierarchyEnrichedItems", ()=>$cf73b6cf34ba63b7$export$29090c866cb2cf07);
    var $8QpSo;
    var $iZN6h;
    const $cf73b6cf34ba63b7$export$e3140dc7d0c35e48 = (depth)=>depth === (0, (0, parcelRequire("iZN6h")).DEFAULT_DEPTH);
    const $cf73b6cf34ba63b7$export$3f3fbf12338c09a4 = (level)=>level === (0, (0, parcelRequire("iZN6h")).BASE_LEVEL);
    const $cf73b6cf34ba63b7$var$shouldCreateBeforeItem = (createItemAnchor, id)=>createItemAnchor !== undefined && createItemAnchor.position === (0, (0, parcelRequire("iZN6h")).BEFORE) && createItemAnchor.beforeId === id;
    const $cf73b6cf34ba63b7$var$shouldCreateInsideItem = (createItemAnchor, id)=>{
        if (createItemAnchor === undefined) return false;
        const createChildLast = createItemAnchor.position === (0, (0, parcelRequire("iZN6h")).INSIDE) && createItemAnchor.parentId === id;
        const createChildSibling = createItemAnchor.position === (0, (0, parcelRequire("iZN6h")).BEFORE) && createItemAnchor.parentId === id;
        return createChildLast || createChildSibling;
    };
    const $cf73b6cf34ba63b7$var$shouldCreateLast = (createItemAnchor)=>createItemAnchor === undefined || createItemAnchor.position === (0, (0, parcelRequire("iZN6h")).LAST);
    const $cf73b6cf34ba63b7$var$getItemBackgroundColor = (rootIndex)=>rootIndex % 2 === 0 ? `var(--ds-surface, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : `var(--ds-surface-sunken, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`;
    const $cf73b6cf34ba63b7$var$getStableCreateId = (createItemAnchor)=>{
        if (createItemAnchor === undefined) return 0, (0, parcelRequire("iZN6h")).DEFAULT_CREATE_ID;
        if (!('beforeId' in createItemAnchor) && createItemAnchor.position === (0, (0, parcelRequire("iZN6h")).LAST)) return 0, (0, parcelRequire("iZN6h")).DEFAULT_CREATE_ID;
        if (createItemAnchor.position === (0, (0, parcelRequire("iZN6h")).INSIDE) && createItemAnchor.parentId) return `create-${createItemAnchor.position}${createItemAnchor.parentId}`;
        return `create-${createItemAnchor.position}${'beforeId' in createItemAnchor && createItemAnchor.beforeId ? createItemAnchor.beforeId : ''}`;
    };
    const $cf73b6cf34ba63b7$var$getCreateLevel = (createItemAnchor, anchorItem)=>{
        if (anchorItem === undefined) return 0, (0, parcelRequire("iZN6h")).DEFAULT_LEVEL;
        const { id: id, level: level } = anchorItem;
        return $cf73b6cf34ba63b7$var$shouldCreateBeforeItem(createItemAnchor, id) ? level : level - 1;
    };
    const $cf73b6cf34ba63b7$var$getCreateDepth = (createItemAnchor, anchorItem)=>{
        if (anchorItem === undefined) return 0, (0, parcelRequire("iZN6h")).DEFAULT_DEPTH;
        const { id: id, depth: depth = 0 } = anchorItem;
        return $cf73b6cf34ba63b7$var$shouldCreateBeforeItem(createItemAnchor, id) ? depth : depth + 1;
    };
    const $cf73b6cf34ba63b7$var$enrichCreateItem = ({ anchorItem: anchorItem, parentId: parentId, createItemAnchor: createItemAnchor, rootIndex: rootIndex, ariaRowIndex: ariaRowIndex, startOffset: startOffset, topOffset: topOffset, flatIndex: flatIndex })=>({
            id: $cf73b6cf34ba63b7$var$getStableCreateId(createItemAnchor),
            type: (0, (0, parcelRequire("iZN6h")).CREATE_ITEM_TYPE),
            anchorItem: anchorItem,
            meta: {
                level: $cf73b6cf34ba63b7$var$getCreateLevel(createItemAnchor, anchorItem),
                isActive: createItemAnchor !== undefined,
                backgroundColor: $cf73b6cf34ba63b7$var$getItemBackgroundColor(rootIndex),
                parentId: parentId,
                ariaRowIndex: ariaRowIndex,
                topOffset: topOffset + startOffset,
                depth: $cf73b6cf34ba63b7$var$getCreateDepth(createItemAnchor, anchorItem)
            },
            flatIndex: flatIndex
        });
    const $cf73b6cf34ba63b7$var$countDescendants = (item)=>{
        const { childItems: childItems = [] } = item;
        return childItems.length + childItems.reduce((acc, child)=>acc + $cf73b6cf34ba63b7$var$countDescendants(child), 0);
    };
    const $cf73b6cf34ba63b7$var$enrichItem = ({ item: item, expandedItems: expandedItems, rootIndex: rootIndex, flatIndex: flatIndex, ariaRowIndex: ariaRowIndex, isParent: isParent, numChildren: numChildren, startOffset: startOffset, childItemsHeight: childItemsHeight, parentItem: parentItem, ariaControls: ariaControls })=>({
            type: (0, (0, parcelRequire("iZN6h")).ITEM_TYPE),
            item: item,
            meta: {
                parentId: parentItem?.item.id,
                backgroundColor: $cf73b6cf34ba63b7$var$getItemBackgroundColor(rootIndex),
                isParent: isParent,
                isExpanded: Boolean(expandedItems[item.id]),
                ariaRowIndex: ariaRowIndex,
                numChildren: numChildren,
                childItemsHeight: childItemsHeight,
                rootIndex: rootIndex,
                topOffset: (parentItem?.meta.topOffset ?? 0) + startOffset,
                ariaControls: ariaControls
            },
            flatIndex: flatIndex
        });
    const $cf73b6cf34ba63b7$export$aabd95853648484e = (enrichedItem)=>{
        switch(enrichedItem.type){
            case 0, (0, parcelRequire("iZN6h")).CREATE_ITEM_TYPE:
                return enrichedItem.meta.level;
            case 0, (0, parcelRequire("iZN6h")).ITEM_TYPE:
                return enrichedItem.item.level;
            default:
                {
                    const _exhaustiveCheck = enrichedItem;
                    return -1;
                }
        }
    };
    const $cf73b6cf34ba63b7$export$29090c866cb2cf07 = (0, (0, parcelRequire("8QpSo")).default)((items, createItemAnchor, expandedItems, isCreateLastEnabled, isCreateSiblingEnabled, isCreateChildEnabled, rootItemHeight, ariaRowOffset, lastFlatIndex = 0, parentItem)=>{
        const depth = parentItem ? (parentItem.item.depth ?? 0) + 1 : 0;
        let offset = 0;
        if (depth > 0) offset += depth > 1 ? (0, (0, parcelRequire("iZN6h")).BASE_LEVEL_ITEM_HEIGHT)() : rootItemHeight;
        let flatIndex = lastFlatIndex;
        const isRowCountKnown = ariaRowOffset !== undefined;
        let ariaRowIndex = (ariaRowOffset ?? 0) + 1;
        const flattenedItems = [];
        const itemIndexes = {};
        items.forEach((item, index)=>{
            const rootIndex = parentItem?.meta.rootIndex ?? index;
            const itemHeight = depth > 0 ? (0, (0, parcelRequire("iZN6h")).BASE_LEVEL_ITEM_HEIGHT)() : rootItemHeight;
            const { id: id, level: level = (0, (0, parcelRequire("iZN6h")).DEFAULT_LEVEL), isInTransition: isInTransition, canCreateChildOverride: canCreateChildOverride = true, childItems: childItems = [] } = item;
            const itemProps = {
                id: id,
                level: level,
                depth: depth,
                isInTransition: isInTransition,
                canCreateChildOverride: canCreateChildOverride
            };
            if (isCreateSiblingEnabled && $cf73b6cf34ba63b7$var$shouldCreateBeforeItem(createItemAnchor, id)) {
                const createItem = $cf73b6cf34ba63b7$var$enrichCreateItem({
                    anchorItem: itemProps,
                    parentId: parentItem?.item.id,
                    createItemAnchor: createItemAnchor,
                    rootIndex: rootIndex,
                    ariaRowIndex: isRowCountKnown ? ariaRowIndex : undefined,
                    startOffset: offset,
                    topOffset: parentItem?.meta?.topOffset ?? 0,
                    flatIndex: flatIndex
                });
                flattenedItems.push(createItem);
                itemIndexes[createItem.id] = flatIndex;
                ariaRowIndex += 1;
                offset += rootItemHeight;
                flatIndex += 1;
            }
            const isChildCreate = isCreateChildEnabled && canCreateChildOverride && $cf73b6cf34ba63b7$var$shouldCreateInsideItem(createItemAnchor, id);
            const isChildCreateInside = Boolean(isChildCreate && createItemAnchor && createItemAnchor.position === (0, (0, parcelRequire("iZN6h")).INSIDE));
            const numChildren = childItems.length + (isChildCreate ? 1 : 0);
            const flattenedItem = $cf73b6cf34ba63b7$var$enrichItem({
                item: itemProps,
                expandedItems: expandedItems,
                rootIndex: rootIndex,
                flatIndex: flatIndex,
                ariaRowIndex: isRowCountKnown ? ariaRowIndex : undefined,
                isParent: childItems.length > 0,
                numChildren: numChildren,
                startOffset: offset,
                childItemsHeight: 0,
                parentItem: parentItem,
                ...childItems.length > 0 && {
                    ariaControls: childItems.map((child)=>child.id).join(' ')
                }
            });
            flatIndex += 1;
            ariaRowIndex += 1;
            offset += itemHeight;
            let innerHierarchyEnrichedItems;
            let itemsHeight = 0;
            let childEnrichedItems = [];
            if (expandedItems[id]) {
                innerHierarchyEnrichedItems = $cf73b6cf34ba63b7$export$29090c866cb2cf07(childItems, createItemAnchor, expandedItems, isCreateLastEnabled, isCreateSiblingEnabled, isCreateChildEnabled, rootItemHeight, isRowCountKnown ? ariaRowIndex - 1 : -1, flatIndex, flattenedItem);
                ariaRowIndex = innerHierarchyEnrichedItems?.ariaRowIndex ?? 0;
                itemsHeight = (innerHierarchyEnrichedItems?.offset ?? itemHeight) - itemHeight;
                childEnrichedItems = innerHierarchyEnrichedItems?.flatItems ?? [];
                flatIndex = innerHierarchyEnrichedItems?.flatIndex ?? flatIndex;
                if (isChildCreateInside) {
                    const createChildItem = $cf73b6cf34ba63b7$var$enrichCreateItem({
                        anchorItem: itemProps,
                        parentId: id,
                        createItemAnchor: createItemAnchor,
                        rootIndex: rootIndex,
                        ariaRowIndex: isRowCountKnown ? ariaRowIndex : undefined,
                        startOffset: itemsHeight + itemHeight,
                        topOffset: flattenedItem?.meta?.topOffset ?? 0,
                        flatIndex: flatIndex
                    });
                    childEnrichedItems.push(createChildItem);
                    itemsHeight += rootItemHeight;
                    ariaRowIndex += 1;
                    flatIndex += 1;
                }
            } else ariaRowIndex += $cf73b6cf34ba63b7$var$countDescendants(item);
            flattenedItems.push({
                ...flattenedItem,
                meta: {
                    ...flattenedItem.meta,
                    childItemsHeight: itemsHeight
                }
            });
            itemIndexes[flattenedItem.item.id] = flattenedItem.flatIndex;
            childEnrichedItems.forEach((enrichedChildItem)=>{
                flattenedItems.push(enrichedChildItem);
                const key = 'id' in enrichedChildItem ? enrichedChildItem.id : enrichedChildItem.item.id;
                itemIndexes[key] = enrichedChildItem.flatIndex;
            });
            offset += itemsHeight;
        });
        if (depth === (0, (0, parcelRequire("iZN6h")).DEFAULT_DEPTH) && isCreateLastEnabled && $cf73b6cf34ba63b7$var$shouldCreateLast(createItemAnchor)) {
            const createItem = $cf73b6cf34ba63b7$var$enrichCreateItem({
                anchorItem: undefined,
                parentId: undefined,
                createItemAnchor: createItemAnchor,
                rootIndex: items.length,
                ariaRowIndex: isRowCountKnown ? ariaRowIndex : undefined,
                startOffset: offset,
                topOffset: parentItem?.meta?.topOffset ?? 0,
                flatIndex: flatIndex
            });
            flattenedItems.push(createItem);
            itemIndexes[createItem.id] = flatIndex;
            ariaRowIndex += 1;
            offset += rootItemHeight;
            flatIndex += 1;
        }
        return {
            flatItems: flattenedItems,
            itemIndexes: itemIndexes,
            ariaRowCount: isRowCountKnown ? ariaRowIndex - 1 : -1,
            offset: offset,
            flatIndex: flatIndex,
            ariaRowIndex: ariaRowIndex
        };
    });
});
parcelRegister("iymwf", function(module, exports) {
    $parcel$export(module.exports, "getItemsContainerStyle", ()=>$4e2c895bb0f5fef2$export$30f72c856f253ec5);
    var $8QpSo;
    var $iZN6h;
    const $4e2c895bb0f5fef2$export$38a59fc64a33c476 = (0, (0, parcelRequire("8QpSo")).default)((items, itemHeight)=>{
        if (!items.length) return [];
        const rows = [];
        let createItemIndex = -1;
        items.filter(({ meta: meta })=>meta?.parentId === undefined).forEach((item, index)=>{
            if (item.type === (0, (0, parcelRequire("iZN6h")).CREATE_ITEM_TYPE)) {
                if (index === items.length - 1) rows.push(itemHeight);
                else createItemIndex = index;
            } else rows.push((item.meta?.childItemsHeight || 0) + itemHeight);
        });
        if (createItemIndex !== -1) rows[Math.max(0, createItemIndex - 1)] += itemHeight;
        return rows;
    });
    const $4e2c895bb0f5fef2$export$115273ef5e87cd0c = (0, (0, parcelRequire("8QpSo")).default)((rows)=>{
        if (!rows.length) return {
            itemsBackground: `var(--ds-background-neutral, ${0, $829f609a65d26a98$export$7d3359664e8bb0e5})`,
            totalHeight: 0
        };
        const prefix = 'linear-gradient(to bottom,';
        let position = 0;
        let count = 0;
        const chunkSize = 4;
        const rowsBackground = rows.reduce((accum, curr, index)=>{
            const bgColor = index % 2 === 0 ? `var(--ds-surface, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : `var(--ds-surface-sunken, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`;
            let rowStyle = `${bgColor} ${position}px ${position + curr}px`;
            if (count === chunkSize || index === rows.length - 1) {
                count = 0;
                rowStyle += `,transparent ${position + curr}px)`;
                rowStyle += index !== rows.length - 1 ? `,${prefix}` : '';
            } else {
                count += 1;
                rowStyle += ',';
            }
            position += curr;
            return accum + rowStyle;
        }, prefix);
        return {
            itemsBackground: rowsBackground,
            totalHeight: position
        };
    });
    const $4e2c895bb0f5fef2$export$30f72c856f253ec5 = (0, (0, parcelRequire("8QpSo")).default)((items, itemHeight)=>{
        const rows = $4e2c895bb0f5fef2$export$38a59fc64a33c476(items, itemHeight);
        return $4e2c895bb0f5fef2$export$115273ef5e87cd0c(rows);
    });
});
parcelRegister("daR3B", function(module, exports) {
    $parcel$export(module.exports, "getSelectedItemIdsHash", ()=>$6750a8bfabc945ae$export$6147ec740e92f913);
    var $8QpSo;
    const $6750a8bfabc945ae$export$6147ec740e92f913 = (0, (0, parcelRequire("8QpSo")).default)((selectedItemIdsWithPermission)=>selectedItemIdsWithPermission ? selectedItemIdsWithPermission.reduce((itemsSelectionState, selectedItemId)=>{
            Object.assign(itemsSelectionState, {
                [selectedItemId]: true
            });
            return itemsSelectionState;
        }, {}) : undefined);
});
parcelRegister("g1EyU", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$a27bae9f28f172b9$export$e324594224ef24da);
    var $9PCp5 = parcelRequire("9PCp5");
    var $4R6GH;
    var $7ouUj;
    const $a27bae9f28f172b9$export$e324594224ef24da = {
        toggleItem: (id, { analyticsEvent: analyticsEvent, deselectOthers: deselectOthers, withRange: withRange })=>({ setState: setState, getState: getState })=>{
                const { items: items, selectedItemIds: selectedItemIds, activeItemId: activeItemId, rangeAnchorItemId: rangeAnchorItemId = activeItemId, itemIndexes: itemIndexes, onItemMultiSelect: onItemMultiSelect } = getState();
                const current = new Set(selectedItemIds);
                const next = deselectOthers ? new Set() : current;
                if (selectedItemIds.some((itemId)=>itemIndexes[itemId] === undefined)) next.clear();
                const selected = !current.has(id);
                const anchorIndex = withRange && rangeAnchorItemId ? itemIndexes[rangeAnchorItemId] : undefined;
                const targetIndex = withRange ? itemIndexes[id] : undefined;
                if (anchorIndex !== undefined && targetIndex !== undefined) {
                    const anchorItem = items[anchorIndex];
                    let itemIdsInRange = [];
                    let isRangeCancelled = false;
                    const indexRange = [
                        ...(0, ($parcel$interopDefault($9PCp5)))(anchorIndex, targetIndex),
                        targetIndex
                    ];
                    for (const index of indexRange){
                        const item = items[index];
                        if ('item' in item && (0, (0, parcelRequire("7ouUj")).getItemLevel)(item) === (0, (0, parcelRequire("7ouUj")).getItemLevel)(anchorItem)) itemIdsInRange.push(item.item.id);
                        if ((0, (0, parcelRequire("7ouUj")).getItemLevel)(item) > (0, (0, parcelRequire("7ouUj")).getItemLevel)(anchorItem)) {
                            isRangeCancelled = true;
                            break;
                        }
                    }
                    if (isRangeCancelled) itemIdsInRange = [
                        id
                    ];
                    itemIdsInRange.forEach((itemIdInRange)=>{
                        selected ? next.add(itemIdInRange) : next.delete(itemIdInRange);
                    });
                } else selected ? next.add(id) : next.delete(id);
                setState({
                    rangeAnchorItemId: id
                });
                onItemMultiSelect(analyticsEvent, [
                    ...next
                ]);
            },
        activateItem: (id, ref)=>({ getState: getState, setState: setState })=>{
                (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps-timeline-bento-refocusing') ? getState().onItemActivate(id, ref) : getState().onItemActivate(id);
                setState({
                    rangeAnchorItemId: id
                });
            }
    };
});
parcelRegister("9PCp5", function(module, exports) {
    var $lVx1a = parcelRequire("lVx1a");
    var $7286aa9f89a20bb7$var$func = $lVx1a('range', (parcelRequire("iASWI")));
    $7286aa9f89a20bb7$var$func.placeholder = (parcelRequire("aPsMW"));
    module.exports = $7286aa9f89a20bb7$var$func;
});
parcelRegister("lVx1a", function(module, exports) {
    var $iIayQ = parcelRequire("iIayQ");
    var $7sR67 = parcelRequire("7sR67");
    function $ff688881095ae098$var$convert(name, func, options) {
        return $iIayQ($7sR67, name, func, options);
    }
    module.exports = $ff688881095ae098$var$convert;
});
parcelRegister("iIayQ", function(module, exports) {
    var $lTdwm = parcelRequire("lTdwm");
    var $aPsMW = parcelRequire("aPsMW");
    var $d9f487426e0f9b59$var$push = Array.prototype.push;
    function $d9f487426e0f9b59$var$baseArity(func, n) {
        return n == 2 ? function(a, b) {
            return func.apply(undefined, arguments);
        } : function(a) {
            return func.apply(undefined, arguments);
        };
    }
    function $d9f487426e0f9b59$var$baseAry(func, n) {
        return n == 2 ? function(a, b) {
            return func(a, b);
        } : function(a) {
            return func(a);
        };
    }
    function $d9f487426e0f9b59$var$cloneArray(array) {
        var length = array ? array.length : 0, result = Array(length);
        while(length--)result[length] = array[length];
        return result;
    }
    function $d9f487426e0f9b59$var$createCloner(func) {
        return function(object) {
            return func({}, object);
        };
    }
    function $d9f487426e0f9b59$var$flatSpread(func, start) {
        return function() {
            var length = arguments.length, lastIndex = length - 1, args = Array(length);
            while(length--)args[length] = arguments[length];
            var array = args[start], otherArgs = args.slice(0, start);
            if (array) $d9f487426e0f9b59$var$push.apply(otherArgs, array);
            if (start != lastIndex) $d9f487426e0f9b59$var$push.apply(otherArgs, args.slice(start + 1));
            return func.apply(this, otherArgs);
        };
    }
    function $d9f487426e0f9b59$var$wrapImmutable(func, cloner) {
        return function() {
            var length = arguments.length;
            if (!length) return;
            var args = Array(length);
            while(length--)args[length] = arguments[length];
            var result = args[0] = cloner.apply(undefined, args);
            func.apply(undefined, args);
            return result;
        };
    }
    function $d9f487426e0f9b59$var$baseConvert(util, name, func, options) {
        var isLib = typeof name == 'function', isObj = name === Object(name);
        if (isObj) {
            options = func;
            func = name;
            name = undefined;
        }
        if (func == null) throw new TypeError;
        options || (options = {});
        var config = {
            'cap': 'cap' in options ? options.cap : true,
            'curry': 'curry' in options ? options.curry : true,
            'fixed': 'fixed' in options ? options.fixed : true,
            'immutable': 'immutable' in options ? options.immutable : true,
            'rearg': 'rearg' in options ? options.rearg : true
        };
        var defaultHolder = isLib ? func : $aPsMW, forceCurry = 'curry' in options && options.curry, forceFixed = 'fixed' in options && options.fixed, forceRearg = 'rearg' in options && options.rearg, pristine = isLib ? func.runInContext() : undefined;
        var helpers = isLib ? func : {
            'ary': util.ary,
            'assign': util.assign,
            'clone': util.clone,
            'curry': util.curry,
            'forEach': util.forEach,
            'isArray': util.isArray,
            'isError': util.isError,
            'isFunction': util.isFunction,
            'isWeakMap': util.isWeakMap,
            'iteratee': util.iteratee,
            'keys': util.keys,
            'rearg': util.rearg,
            'toInteger': util.toInteger,
            'toPath': util.toPath
        };
        var ary = helpers.ary, assign = helpers.assign, clone = helpers.clone, curry = helpers.curry, each = helpers.forEach, isArray = helpers.isArray, isError = helpers.isError, isFunction = helpers.isFunction, isWeakMap = helpers.isWeakMap, keys = helpers.keys, rearg = helpers.rearg, toInteger = helpers.toInteger, toPath = helpers.toPath;
        var aryMethodKeys = keys($lTdwm.aryMethod);
        var wrappers = {
            'castArray': function(castArray) {
                return function() {
                    var value = arguments[0];
                    return isArray(value) ? castArray($d9f487426e0f9b59$var$cloneArray(value)) : castArray.apply(undefined, arguments);
                };
            },
            'iteratee': function(iteratee) {
                return function() {
                    var func = arguments[0], arity = arguments[1], result = iteratee(func, arity), length = result.length;
                    if (config.cap && typeof arity == 'number') {
                        arity = arity > 2 ? arity - 2 : 1;
                        return length && length <= arity ? result : $d9f487426e0f9b59$var$baseAry(result, arity);
                    }
                    return result;
                };
            },
            'mixin': function(mixin) {
                return function(source) {
                    var func = this;
                    if (!isFunction(func)) return mixin(func, Object(source));
                    var pairs = [];
                    each(keys(source), function(key) {
                        if (isFunction(source[key])) pairs.push([
                            key,
                            func.prototype[key]
                        ]);
                    });
                    mixin(func, Object(source));
                    each(pairs, function(pair) {
                        var value = pair[1];
                        if (isFunction(value)) func.prototype[pair[0]] = value;
                        else delete func.prototype[pair[0]];
                    });
                    return func;
                };
            },
            'nthArg': function(nthArg) {
                return function(n) {
                    var arity = n < 0 ? 1 : toInteger(n) + 1;
                    return curry(nthArg(n), arity);
                };
            },
            'rearg': function(rearg) {
                return function(func, indexes) {
                    var arity = indexes ? indexes.length : 0;
                    return curry(rearg(func, indexes), arity);
                };
            },
            'runInContext': function(runInContext) {
                return function(context) {
                    return $d9f487426e0f9b59$var$baseConvert(util, runInContext(context), options);
                };
            }
        };
        function castCap(name, func) {
            if (config.cap) {
                var indexes = $lTdwm.iterateeRearg[name];
                if (indexes) return iterateeRearg(func, indexes);
                var n = !isLib && $lTdwm.iterateeAry[name];
                if (n) return iterateeAry(func, n);
            }
            return func;
        }
        function castCurry(name, func, n) {
            return forceCurry || config.curry && n > 1 ? curry(func, n) : func;
        }
        function castFixed(name, func, n) {
            if (config.fixed && (forceFixed || !$lTdwm.skipFixed[name])) {
                var data = $lTdwm.methodSpread[name], start = data && data.start;
                return start === undefined ? ary(func, n) : $d9f487426e0f9b59$var$flatSpread(func, start);
            }
            return func;
        }
        function castRearg(name, func, n) {
            return config.rearg && n > 1 && (forceRearg || !$lTdwm.skipRearg[name]) ? rearg(func, $lTdwm.methodRearg[name] || $lTdwm.aryRearg[n]) : func;
        }
        function cloneByPath(object, path) {
            path = toPath(path);
            var index = -1, length = path.length, lastIndex = length - 1, result = clone(Object(object)), nested = result;
            while(nested != null && ++index < length){
                var key = path[index], value = nested[key];
                if (value != null && !(isFunction(value) || isError(value) || isWeakMap(value))) nested[key] = clone(index == lastIndex ? value : Object(value));
                nested = nested[key];
            }
            return result;
        }
        function convertLib(options) {
            return _.runInContext.convert(options)(undefined);
        }
        function createConverter(name, func) {
            var realName = $lTdwm.aliasToReal[name] || name, methodName = $lTdwm.remap[realName] || realName, oldOptions = options;
            return function(options) {
                var newUtil = isLib ? pristine : helpers, newFunc = isLib ? pristine[methodName] : func, newOptions = assign(assign({}, oldOptions), options);
                return $d9f487426e0f9b59$var$baseConvert(newUtil, realName, newFunc, newOptions);
            };
        }
        function iterateeAry(func, n) {
            return overArg(func, function(func) {
                return typeof func == 'function' ? $d9f487426e0f9b59$var$baseAry(func, n) : func;
            });
        }
        function iterateeRearg(func, indexes) {
            return overArg(func, function(func) {
                var n = indexes.length;
                return $d9f487426e0f9b59$var$baseArity(rearg($d9f487426e0f9b59$var$baseAry(func, n), indexes), n);
            });
        }
        function overArg(func, transform) {
            return function() {
                var length = arguments.length;
                if (!length) return func();
                var args = Array(length);
                while(length--)args[length] = arguments[length];
                var index = config.rearg ? 0 : length - 1;
                args[index] = transform(args[index]);
                return func.apply(undefined, args);
            };
        }
        function wrap(name, func, placeholder) {
            var result, realName = $lTdwm.aliasToReal[name] || name, wrapped = func, wrapper = wrappers[realName];
            if (wrapper) wrapped = wrapper(func);
            else if (config.immutable) {
                if ($lTdwm.mutate.array[realName]) wrapped = $d9f487426e0f9b59$var$wrapImmutable(func, $d9f487426e0f9b59$var$cloneArray);
                else if ($lTdwm.mutate.object[realName]) wrapped = $d9f487426e0f9b59$var$wrapImmutable(func, $d9f487426e0f9b59$var$createCloner(func));
                else if ($lTdwm.mutate.set[realName]) wrapped = $d9f487426e0f9b59$var$wrapImmutable(func, cloneByPath);
            }
            each(aryMethodKeys, function(aryKey) {
                each($lTdwm.aryMethod[aryKey], function(otherName) {
                    if (realName == otherName) {
                        var data = $lTdwm.methodSpread[realName], afterRearg = data && data.afterRearg;
                        result = afterRearg ? castFixed(realName, castRearg(realName, wrapped, aryKey), aryKey) : castRearg(realName, castFixed(realName, wrapped, aryKey), aryKey);
                        result = castCap(realName, result);
                        result = castCurry(realName, result, aryKey);
                        return false;
                    }
                });
                return !result;
            });
            result || (result = wrapped);
            if (result == func) result = forceCurry ? curry(result, 1) : function() {
                return func.apply(this, arguments);
            };
            result.convert = createConverter(realName, func);
            result.placeholder = func.placeholder = placeholder;
            return result;
        }
        if (!isObj) return wrap(name, func, defaultHolder);
        var _ = func;
        var pairs = [];
        each(aryMethodKeys, function(aryKey) {
            each($lTdwm.aryMethod[aryKey], function(key) {
                var func = _[$lTdwm.remap[key] || key];
                if (func) pairs.push([
                    key,
                    wrap(key, func, _)
                ]);
            });
        });
        each(keys(_), function(key) {
            var func = _[key];
            if (typeof func == 'function') {
                var length = pairs.length;
                while(length--){
                    if (pairs[length][0] == key) return;
                }
                func.convert = createConverter(key, func);
                pairs.push([
                    key,
                    func
                ]);
            }
        });
        each(pairs, function(pair) {
            _[pair[0]] = pair[1];
        });
        _.convert = convertLib;
        _.placeholder = _;
        each(keys(_), function(key) {
            each($lTdwm.realToAlias[key] || [], function(alias) {
                _[alias] = _[key];
            });
        });
        return _;
    }
    module.exports = $d9f487426e0f9b59$var$baseConvert;
});
parcelRegister("lTdwm", function(module, exports) {
    $parcel$export(module.exports, "aliasToReal", ()=>$fef938fb92c31507$export$bd0f5e6e44efa6b4, (v)=>$fef938fb92c31507$export$bd0f5e6e44efa6b4 = v);
    $parcel$export(module.exports, "aryMethod", ()=>$fef938fb92c31507$export$85c665b4d7da9cb4, (v)=>$fef938fb92c31507$export$85c665b4d7da9cb4 = v);
    $parcel$export(module.exports, "aryRearg", ()=>$fef938fb92c31507$export$42564e045b285e32, (v)=>$fef938fb92c31507$export$42564e045b285e32 = v);
    $parcel$export(module.exports, "iterateeAry", ()=>$fef938fb92c31507$export$81e17196e6a22b07, (v)=>$fef938fb92c31507$export$81e17196e6a22b07 = v);
    $parcel$export(module.exports, "iterateeRearg", ()=>$fef938fb92c31507$export$30975ceb42167ebd, (v)=>$fef938fb92c31507$export$30975ceb42167ebd = v);
    $parcel$export(module.exports, "methodRearg", ()=>$fef938fb92c31507$export$8ceb0ad7e94d3801, (v)=>$fef938fb92c31507$export$8ceb0ad7e94d3801 = v);
    $parcel$export(module.exports, "methodSpread", ()=>$fef938fb92c31507$export$fbaeb3f87df3cf26, (v)=>$fef938fb92c31507$export$fbaeb3f87df3cf26 = v);
    $parcel$export(module.exports, "mutate", ()=>$fef938fb92c31507$export$57e795267c26e600, (v)=>$fef938fb92c31507$export$57e795267c26e600 = v);
    $parcel$export(module.exports, "realToAlias", ()=>$fef938fb92c31507$export$1eb71a7e27943e71, (v)=>$fef938fb92c31507$export$1eb71a7e27943e71 = v);
    $parcel$export(module.exports, "remap", ()=>$fef938fb92c31507$export$aee1dbae5de2db9d, (v)=>$fef938fb92c31507$export$aee1dbae5de2db9d = v);
    $parcel$export(module.exports, "skipFixed", ()=>$fef938fb92c31507$export$87ffbe4821a5d5e0, (v)=>$fef938fb92c31507$export$87ffbe4821a5d5e0 = v);
    $parcel$export(module.exports, "skipRearg", ()=>$fef938fb92c31507$export$b4d07413ce528c90, (v)=>$fef938fb92c31507$export$b4d07413ce528c90 = v);
    var $fef938fb92c31507$export$bd0f5e6e44efa6b4;
    var $fef938fb92c31507$export$85c665b4d7da9cb4;
    var $fef938fb92c31507$export$42564e045b285e32;
    var $fef938fb92c31507$export$81e17196e6a22b07;
    var $fef938fb92c31507$export$30975ceb42167ebd;
    var $fef938fb92c31507$export$8ceb0ad7e94d3801;
    var $fef938fb92c31507$export$fbaeb3f87df3cf26;
    var $fef938fb92c31507$export$57e795267c26e600;
    var $fef938fb92c31507$export$1eb71a7e27943e71;
    var $fef938fb92c31507$export$aee1dbae5de2db9d;
    var $fef938fb92c31507$export$87ffbe4821a5d5e0;
    var $fef938fb92c31507$export$b4d07413ce528c90;
    $fef938fb92c31507$export$bd0f5e6e44efa6b4 = {
        'each': 'forEach',
        'eachRight': 'forEachRight',
        'entries': 'toPairs',
        'entriesIn': 'toPairsIn',
        'extend': 'assignIn',
        'extendAll': 'assignInAll',
        'extendAllWith': 'assignInAllWith',
        'extendWith': 'assignInWith',
        'first': 'head',
        'conforms': 'conformsTo',
        'matches': 'isMatch',
        'property': 'get',
        '__': 'placeholder',
        'F': 'stubFalse',
        'T': 'stubTrue',
        'all': 'every',
        'allPass': 'overEvery',
        'always': 'constant',
        'any': 'some',
        'anyPass': 'overSome',
        'apply': 'spread',
        'assoc': 'set',
        'assocPath': 'set',
        'complement': 'negate',
        'compose': 'flowRight',
        'contains': 'includes',
        'dissoc': 'unset',
        'dissocPath': 'unset',
        'dropLast': 'dropRight',
        'dropLastWhile': 'dropRightWhile',
        'equals': 'isEqual',
        'identical': 'eq',
        'indexBy': 'keyBy',
        'init': 'initial',
        'invertObj': 'invert',
        'juxt': 'over',
        'omitAll': 'omit',
        'nAry': 'ary',
        'path': 'get',
        'pathEq': 'matchesProperty',
        'pathOr': 'getOr',
        'paths': 'at',
        'pickAll': 'pick',
        'pipe': 'flow',
        'pluck': 'map',
        'prop': 'get',
        'propEq': 'matchesProperty',
        'propOr': 'getOr',
        'props': 'at',
        'symmetricDifference': 'xor',
        'symmetricDifferenceBy': 'xorBy',
        'symmetricDifferenceWith': 'xorWith',
        'takeLast': 'takeRight',
        'takeLastWhile': 'takeRightWhile',
        'unapply': 'rest',
        'unnest': 'flatten',
        'useWith': 'overArgs',
        'where': 'conformsTo',
        'whereEq': 'isMatch',
        'zipObj': 'zipObject'
    };
    $fef938fb92c31507$export$85c665b4d7da9cb4 = {
        '1': [
            'assignAll',
            'assignInAll',
            'attempt',
            'castArray',
            'ceil',
            'create',
            'curry',
            'curryRight',
            'defaultsAll',
            'defaultsDeepAll',
            'floor',
            'flow',
            'flowRight',
            'fromPairs',
            'invert',
            'iteratee',
            'memoize',
            'method',
            'mergeAll',
            'methodOf',
            'mixin',
            'nthArg',
            'over',
            'overEvery',
            'overSome',
            'rest',
            'reverse',
            'round',
            'runInContext',
            'spread',
            'template',
            'trim',
            'trimEnd',
            'trimStart',
            'uniqueId',
            'words',
            'zipAll'
        ],
        '2': [
            'add',
            'after',
            'ary',
            'assign',
            'assignAllWith',
            'assignIn',
            'assignInAllWith',
            'at',
            'before',
            'bind',
            'bindAll',
            'bindKey',
            'chunk',
            'cloneDeepWith',
            'cloneWith',
            'concat',
            'conformsTo',
            'countBy',
            'curryN',
            'curryRightN',
            'debounce',
            'defaults',
            'defaultsDeep',
            'defaultTo',
            'delay',
            'difference',
            'divide',
            'drop',
            'dropRight',
            'dropRightWhile',
            'dropWhile',
            'endsWith',
            'eq',
            'every',
            'filter',
            'find',
            'findIndex',
            'findKey',
            'findLast',
            'findLastIndex',
            'findLastKey',
            'flatMap',
            'flatMapDeep',
            'flattenDepth',
            'forEach',
            'forEachRight',
            'forIn',
            'forInRight',
            'forOwn',
            'forOwnRight',
            'get',
            'groupBy',
            'gt',
            'gte',
            'has',
            'hasIn',
            'includes',
            'indexOf',
            'intersection',
            'invertBy',
            'invoke',
            'invokeMap',
            'isEqual',
            'isMatch',
            'join',
            'keyBy',
            'lastIndexOf',
            'lt',
            'lte',
            'map',
            'mapKeys',
            'mapValues',
            'matchesProperty',
            'maxBy',
            'meanBy',
            'merge',
            'mergeAllWith',
            'minBy',
            'multiply',
            'nth',
            'omit',
            'omitBy',
            'overArgs',
            'pad',
            'padEnd',
            'padStart',
            'parseInt',
            'partial',
            'partialRight',
            'partition',
            'pick',
            'pickBy',
            'propertyOf',
            'pull',
            'pullAll',
            'pullAt',
            'random',
            'range',
            'rangeRight',
            'rearg',
            'reject',
            'remove',
            'repeat',
            'restFrom',
            'result',
            'sampleSize',
            'some',
            'sortBy',
            'sortedIndex',
            'sortedIndexOf',
            'sortedLastIndex',
            'sortedLastIndexOf',
            'sortedUniqBy',
            'split',
            'spreadFrom',
            'startsWith',
            'subtract',
            'sumBy',
            'take',
            'takeRight',
            'takeRightWhile',
            'takeWhile',
            'tap',
            'throttle',
            'thru',
            'times',
            'trimChars',
            'trimCharsEnd',
            'trimCharsStart',
            'truncate',
            'union',
            'uniqBy',
            'uniqWith',
            'unset',
            'unzipWith',
            'without',
            'wrap',
            'xor',
            'zip',
            'zipObject',
            'zipObjectDeep'
        ],
        '3': [
            'assignInWith',
            'assignWith',
            'clamp',
            'differenceBy',
            'differenceWith',
            'findFrom',
            'findIndexFrom',
            'findLastFrom',
            'findLastIndexFrom',
            'getOr',
            'includesFrom',
            'indexOfFrom',
            'inRange',
            'intersectionBy',
            'intersectionWith',
            'invokeArgs',
            'invokeArgsMap',
            'isEqualWith',
            'isMatchWith',
            'flatMapDepth',
            'lastIndexOfFrom',
            'mergeWith',
            'orderBy',
            'padChars',
            'padCharsEnd',
            'padCharsStart',
            'pullAllBy',
            'pullAllWith',
            'rangeStep',
            'rangeStepRight',
            'reduce',
            'reduceRight',
            'replace',
            'set',
            'slice',
            'sortedIndexBy',
            'sortedLastIndexBy',
            'transform',
            'unionBy',
            'unionWith',
            'update',
            'xorBy',
            'xorWith',
            'zipWith'
        ],
        '4': [
            'fill',
            'setWith',
            'updateWith'
        ]
    };
    $fef938fb92c31507$export$42564e045b285e32 = {
        '2': [
            1,
            0
        ],
        '3': [
            2,
            0,
            1
        ],
        '4': [
            3,
            2,
            0,
            1
        ]
    };
    $fef938fb92c31507$export$81e17196e6a22b07 = {
        'dropRightWhile': 1,
        'dropWhile': 1,
        'every': 1,
        'filter': 1,
        'find': 1,
        'findFrom': 1,
        'findIndex': 1,
        'findIndexFrom': 1,
        'findKey': 1,
        'findLast': 1,
        'findLastFrom': 1,
        'findLastIndex': 1,
        'findLastIndexFrom': 1,
        'findLastKey': 1,
        'flatMap': 1,
        'flatMapDeep': 1,
        'flatMapDepth': 1,
        'forEach': 1,
        'forEachRight': 1,
        'forIn': 1,
        'forInRight': 1,
        'forOwn': 1,
        'forOwnRight': 1,
        'map': 1,
        'mapKeys': 1,
        'mapValues': 1,
        'partition': 1,
        'reduce': 2,
        'reduceRight': 2,
        'reject': 1,
        'remove': 1,
        'some': 1,
        'takeRightWhile': 1,
        'takeWhile': 1,
        'times': 1,
        'transform': 2
    };
    $fef938fb92c31507$export$30975ceb42167ebd = {
        'mapKeys': [
            1
        ],
        'reduceRight': [
            1,
            0
        ]
    };
    $fef938fb92c31507$export$8ceb0ad7e94d3801 = {
        'assignInAllWith': [
            1,
            0
        ],
        'assignInWith': [
            1,
            2,
            0
        ],
        'assignAllWith': [
            1,
            0
        ],
        'assignWith': [
            1,
            2,
            0
        ],
        'differenceBy': [
            1,
            2,
            0
        ],
        'differenceWith': [
            1,
            2,
            0
        ],
        'getOr': [
            2,
            1,
            0
        ],
        'intersectionBy': [
            1,
            2,
            0
        ],
        'intersectionWith': [
            1,
            2,
            0
        ],
        'isEqualWith': [
            1,
            2,
            0
        ],
        'isMatchWith': [
            2,
            1,
            0
        ],
        'mergeAllWith': [
            1,
            0
        ],
        'mergeWith': [
            1,
            2,
            0
        ],
        'padChars': [
            2,
            1,
            0
        ],
        'padCharsEnd': [
            2,
            1,
            0
        ],
        'padCharsStart': [
            2,
            1,
            0
        ],
        'pullAllBy': [
            2,
            1,
            0
        ],
        'pullAllWith': [
            2,
            1,
            0
        ],
        'rangeStep': [
            1,
            2,
            0
        ],
        'rangeStepRight': [
            1,
            2,
            0
        ],
        'setWith': [
            3,
            1,
            2,
            0
        ],
        'sortedIndexBy': [
            2,
            1,
            0
        ],
        'sortedLastIndexBy': [
            2,
            1,
            0
        ],
        'unionBy': [
            1,
            2,
            0
        ],
        'unionWith': [
            1,
            2,
            0
        ],
        'updateWith': [
            3,
            1,
            2,
            0
        ],
        'xorBy': [
            1,
            2,
            0
        ],
        'xorWith': [
            1,
            2,
            0
        ],
        'zipWith': [
            1,
            2,
            0
        ]
    };
    $fef938fb92c31507$export$fbaeb3f87df3cf26 = {
        'assignAll': {
            'start': 0
        },
        'assignAllWith': {
            'start': 0
        },
        'assignInAll': {
            'start': 0
        },
        'assignInAllWith': {
            'start': 0
        },
        'defaultsAll': {
            'start': 0
        },
        'defaultsDeepAll': {
            'start': 0
        },
        'invokeArgs': {
            'start': 2
        },
        'invokeArgsMap': {
            'start': 2
        },
        'mergeAll': {
            'start': 0
        },
        'mergeAllWith': {
            'start': 0
        },
        'partial': {
            'start': 1
        },
        'partialRight': {
            'start': 1
        },
        'without': {
            'start': 1
        },
        'zipAll': {
            'start': 0
        }
    };
    $fef938fb92c31507$export$57e795267c26e600 = {
        'array': {
            'fill': true,
            'pull': true,
            'pullAll': true,
            'pullAllBy': true,
            'pullAllWith': true,
            'pullAt': true,
            'remove': true,
            'reverse': true
        },
        'object': {
            'assign': true,
            'assignAll': true,
            'assignAllWith': true,
            'assignIn': true,
            'assignInAll': true,
            'assignInAllWith': true,
            'assignInWith': true,
            'assignWith': true,
            'defaults': true,
            'defaultsAll': true,
            'defaultsDeep': true,
            'defaultsDeepAll': true,
            'merge': true,
            'mergeAll': true,
            'mergeAllWith': true,
            'mergeWith': true
        },
        'set': {
            'set': true,
            'setWith': true,
            'unset': true,
            'update': true,
            'updateWith': true
        }
    };
    $fef938fb92c31507$export$1eb71a7e27943e71 = function() {
        var hasOwnProperty = Object.prototype.hasOwnProperty, object = $fef938fb92c31507$export$bd0f5e6e44efa6b4, result = {};
        for(var key in object){
            var value = object[key];
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }
        return result;
    }();
    $fef938fb92c31507$export$aee1dbae5de2db9d = {
        'assignAll': 'assign',
        'assignAllWith': 'assignWith',
        'assignInAll': 'assignIn',
        'assignInAllWith': 'assignInWith',
        'curryN': 'curry',
        'curryRightN': 'curryRight',
        'defaultsAll': 'defaults',
        'defaultsDeepAll': 'defaultsDeep',
        'findFrom': 'find',
        'findIndexFrom': 'findIndex',
        'findLastFrom': 'findLast',
        'findLastIndexFrom': 'findLastIndex',
        'getOr': 'get',
        'includesFrom': 'includes',
        'indexOfFrom': 'indexOf',
        'invokeArgs': 'invoke',
        'invokeArgsMap': 'invokeMap',
        'lastIndexOfFrom': 'lastIndexOf',
        'mergeAll': 'merge',
        'mergeAllWith': 'mergeWith',
        'padChars': 'pad',
        'padCharsEnd': 'padEnd',
        'padCharsStart': 'padStart',
        'propertyOf': 'get',
        'rangeStep': 'range',
        'rangeStepRight': 'rangeRight',
        'restFrom': 'rest',
        'spreadFrom': 'spread',
        'trimChars': 'trim',
        'trimCharsEnd': 'trimEnd',
        'trimCharsStart': 'trimStart',
        'zipAll': 'zip'
    };
    $fef938fb92c31507$export$87ffbe4821a5d5e0 = {
        'castArray': true,
        'flow': true,
        'flowRight': true,
        'iteratee': true,
        'mixin': true,
        'rearg': true,
        'runInContext': true
    };
    $fef938fb92c31507$export$b4d07413ce528c90 = {
        'add': true,
        'assign': true,
        'assignIn': true,
        'bind': true,
        'bindKey': true,
        'concat': true,
        'difference': true,
        'divide': true,
        'eq': true,
        'gt': true,
        'gte': true,
        'isEqual': true,
        'lt': true,
        'lte': true,
        'matchesProperty': true,
        'merge': true,
        'multiply': true,
        'overArgs': true,
        'partial': true,
        'partialRight': true,
        'propertyOf': true,
        'random': true,
        'range': true,
        'rangeRight': true,
        'subtract': true,
        'zip': true,
        'zipObject': true,
        'zipObjectDeep': true
    };
});
parcelRegister("aPsMW", function(module, exports) {
    module.exports = {};
});
parcelRegister("7sR67", function(module, exports) {
    module.exports = {
        'ary': (parcelRequire("lEyvi")),
        'assign': (parcelRequire("bqJNK")),
        'clone': (parcelRequire("91VA7")),
        'curry': (parcelRequire("a7NzZ")),
        'forEach': (parcelRequire("fmP8r")),
        'isArray': (parcelRequire("8LQ84")),
        'isError': (parcelRequire("aZFhV")),
        'isFunction': (parcelRequire("5vD8v")),
        'isWeakMap': (parcelRequire("5UxIS")),
        'iteratee': (parcelRequire("5qDt4")),
        'keys': (parcelRequire("hR3Ue")),
        'rearg': (parcelRequire("iZlmO")),
        'toInteger': (parcelRequire("kPZpS")),
        'toPath': (parcelRequire("6TYHJ"))
    };
});
parcelRegister("lEyvi", function(module, exports) {
    var $5oTQF = parcelRequire("5oTQF");
    var $fc3819207d6eebc6$var$WRAP_ARY_FLAG = 128;
    function $fc3819207d6eebc6$var$ary(func, n, guard) {
        n = guard ? undefined : n;
        n = func && n == null ? func.length : n;
        return $5oTQF(func, $fc3819207d6eebc6$var$WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }
    module.exports = $fc3819207d6eebc6$var$ary;
});
parcelRegister("5oTQF", function(module, exports) {
    var $g1o5k = parcelRequire("g1o5k");
    var $1BSxH = parcelRequire("1BSxH");
    var $gQoGK = parcelRequire("gQoGK");
    var $2pq1V = parcelRequire("2pq1V");
    var $cwXqG = parcelRequire("cwXqG");
    var $dzqxs = parcelRequire("dzqxs");
    var $c8pf3 = parcelRequire("c8pf3");
    var $4EzKU = parcelRequire("4EzKU");
    var $iKqmZ = parcelRequire("iKqmZ");
    var $kPZpS = parcelRequire("kPZpS");
    var $3eea84024a50d6cf$var$FUNC_ERROR_TEXT = 'Expected a function';
    var $3eea84024a50d6cf$var$WRAP_BIND_FLAG = 1, $3eea84024a50d6cf$var$WRAP_BIND_KEY_FLAG = 2, $3eea84024a50d6cf$var$WRAP_CURRY_FLAG = 8, $3eea84024a50d6cf$var$WRAP_CURRY_RIGHT_FLAG = 16, $3eea84024a50d6cf$var$WRAP_PARTIAL_FLAG = 32, $3eea84024a50d6cf$var$WRAP_PARTIAL_RIGHT_FLAG = 64;
    var $3eea84024a50d6cf$var$nativeMax = Math.max;
    function $3eea84024a50d6cf$var$createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
        var isBindKey = bitmask & $3eea84024a50d6cf$var$WRAP_BIND_KEY_FLAG;
        if (!isBindKey && typeof func != 'function') throw new TypeError($3eea84024a50d6cf$var$FUNC_ERROR_TEXT);
        var length = partials ? partials.length : 0;
        if (!length) {
            bitmask &= ~($3eea84024a50d6cf$var$WRAP_PARTIAL_FLAG | $3eea84024a50d6cf$var$WRAP_PARTIAL_RIGHT_FLAG);
            partials = holders = undefined;
        }
        ary = ary === undefined ? ary : $3eea84024a50d6cf$var$nativeMax($kPZpS(ary), 0);
        arity = arity === undefined ? arity : $kPZpS(arity);
        length -= holders ? holders.length : 0;
        if (bitmask & $3eea84024a50d6cf$var$WRAP_PARTIAL_RIGHT_FLAG) {
            var partialsRight = partials, holdersRight = holders;
            partials = holders = undefined;
        }
        var data = isBindKey ? undefined : $dzqxs(func);
        var newData = [
            func,
            bitmask,
            thisArg,
            partials,
            holders,
            partialsRight,
            holdersRight,
            argPos,
            ary,
            arity
        ];
        if (data) $c8pf3(newData, data);
        func = newData[0];
        bitmask = newData[1];
        thisArg = newData[2];
        partials = newData[3];
        holders = newData[4];
        arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : $3eea84024a50d6cf$var$nativeMax(newData[9] - length, 0);
        if (!arity && bitmask & ($3eea84024a50d6cf$var$WRAP_CURRY_FLAG | $3eea84024a50d6cf$var$WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~($3eea84024a50d6cf$var$WRAP_CURRY_FLAG | $3eea84024a50d6cf$var$WRAP_CURRY_RIGHT_FLAG);
        if (!bitmask || bitmask == $3eea84024a50d6cf$var$WRAP_BIND_FLAG) var result = $1BSxH(func, bitmask, thisArg);
        else if (bitmask == $3eea84024a50d6cf$var$WRAP_CURRY_FLAG || bitmask == $3eea84024a50d6cf$var$WRAP_CURRY_RIGHT_FLAG) result = $gQoGK(func, bitmask, arity);
        else if ((bitmask == $3eea84024a50d6cf$var$WRAP_PARTIAL_FLAG || bitmask == ($3eea84024a50d6cf$var$WRAP_BIND_FLAG | $3eea84024a50d6cf$var$WRAP_PARTIAL_FLAG)) && !holders.length) result = $cwXqG(func, bitmask, thisArg, partials);
        else result = $2pq1V.apply(undefined, newData);
        var setter = data ? $g1o5k : $4EzKU;
        return $iKqmZ(setter(result, newData), func, bitmask);
    }
    module.exports = $3eea84024a50d6cf$var$createWrap;
});
parcelRegister("g1o5k", function(module, exports) {
    var $etyzk = parcelRequire("etyzk");
    var $hQCy5 = parcelRequire("hQCy5");
    var $ba9f6c1d52531584$var$baseSetData = !$hQCy5 ? $etyzk : function(func, data) {
        $hQCy5.set(func, data);
        return func;
    };
    module.exports = $ba9f6c1d52531584$var$baseSetData;
});
parcelRegister("1BSxH", function(module, exports) {
    var $iJkMv = parcelRequire("iJkMv");
    var $1V15E = parcelRequire("1V15E");
    var $12c38e2c5009183b$var$WRAP_BIND_FLAG = 1;
    function $12c38e2c5009183b$var$createBind(func, bitmask, thisArg) {
        var isBind = bitmask & $12c38e2c5009183b$var$WRAP_BIND_FLAG, Ctor = $iJkMv(func);
        function wrapper() {
            var fn = this && this !== $1V15E && this instanceof wrapper ? Ctor : func;
            return fn.apply(isBind ? thisArg : this, arguments);
        }
        return wrapper;
    }
    module.exports = $12c38e2c5009183b$var$createBind;
});
parcelRegister("iJkMv", function(module, exports) {
    var $ady43 = parcelRequire("ady43");
    var $k0qYG = parcelRequire("k0qYG");
    function $da2c8caf7ae3955a$var$createCtor(Ctor) {
        return function() {
            var args = arguments;
            switch(args.length){
                case 0:
                    return new Ctor;
                case 1:
                    return new Ctor(args[0]);
                case 2:
                    return new Ctor(args[0], args[1]);
                case 3:
                    return new Ctor(args[0], args[1], args[2]);
                case 4:
                    return new Ctor(args[0], args[1], args[2], args[3]);
                case 5:
                    return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                case 6:
                    return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                case 7:
                    return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
            }
            var thisBinding = $ady43(Ctor.prototype), result = Ctor.apply(thisBinding, args);
            return $k0qYG(result) ? result : thisBinding;
        };
    }
    module.exports = $da2c8caf7ae3955a$var$createCtor;
});
parcelRegister("gQoGK", function(module, exports) {
    var $hlchF = parcelRequire("hlchF");
    var $iJkMv = parcelRequire("iJkMv");
    var $2pq1V = parcelRequire("2pq1V");
    var $6fuEo = parcelRequire("6fuEo");
    var $8ZIC5 = parcelRequire("8ZIC5");
    var $kBUUu = parcelRequire("kBUUu");
    var $1V15E = parcelRequire("1V15E");
    function $c434a7442e0e841e$var$createCurry(func, bitmask, arity) {
        var Ctor = $iJkMv(func);
        function wrapper() {
            var length = arguments.length, args = Array(length), index = length, placeholder = $8ZIC5(wrapper);
            while(index--)args[index] = arguments[index];
            var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : $kBUUu(args, placeholder);
            length -= holders.length;
            if (length < arity) return $6fuEo(func, bitmask, $2pq1V, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
            var fn = this && this !== $1V15E && this instanceof wrapper ? Ctor : func;
            return $hlchF(fn, this, args);
        }
        return wrapper;
    }
    module.exports = $c434a7442e0e841e$var$createCurry;
});
parcelRegister("2pq1V", function(module, exports) {
    var $k8MLc = parcelRequire("k8MLc");
    var $eqXBf = parcelRequire("eqXBf");
    var $khpbX = parcelRequire("khpbX");
    var $iJkMv = parcelRequire("iJkMv");
    var $6fuEo = parcelRequire("6fuEo");
    var $8ZIC5 = parcelRequire("8ZIC5");
    var $3Prcz = parcelRequire("3Prcz");
    var $kBUUu = parcelRequire("kBUUu");
    var $1V15E = parcelRequire("1V15E");
    var $1c121b92b9034c1f$var$WRAP_BIND_FLAG = 1, $1c121b92b9034c1f$var$WRAP_BIND_KEY_FLAG = 2, $1c121b92b9034c1f$var$WRAP_CURRY_FLAG = 8, $1c121b92b9034c1f$var$WRAP_CURRY_RIGHT_FLAG = 16, $1c121b92b9034c1f$var$WRAP_ARY_FLAG = 128, $1c121b92b9034c1f$var$WRAP_FLIP_FLAG = 512;
    function $1c121b92b9034c1f$var$createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
        var isAry = bitmask & $1c121b92b9034c1f$var$WRAP_ARY_FLAG, isBind = bitmask & $1c121b92b9034c1f$var$WRAP_BIND_FLAG, isBindKey = bitmask & $1c121b92b9034c1f$var$WRAP_BIND_KEY_FLAG, isCurried = bitmask & ($1c121b92b9034c1f$var$WRAP_CURRY_FLAG | $1c121b92b9034c1f$var$WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & $1c121b92b9034c1f$var$WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : $iJkMv(func);
        function wrapper() {
            var length = arguments.length, args = Array(length), index = length;
            while(index--)args[index] = arguments[index];
            if (isCurried) var placeholder = $8ZIC5(wrapper), holdersCount = $khpbX(args, placeholder);
            if (partials) args = $k8MLc(args, partials, holders, isCurried);
            if (partialsRight) args = $eqXBf(args, partialsRight, holdersRight, isCurried);
            length -= holdersCount;
            if (isCurried && length < arity) {
                var newHolders = $kBUUu(args, placeholder);
                return $6fuEo(func, bitmask, $1c121b92b9034c1f$var$createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
            }
            var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
            length = args.length;
            if (argPos) args = $3Prcz(args, argPos);
            else if (isFlip && length > 1) args.reverse();
            if (isAry && ary < length) args.length = ary;
            if (this && this !== $1V15E && this instanceof wrapper) fn = Ctor || $iJkMv(fn);
            return fn.apply(thisBinding, args);
        }
        return wrapper;
    }
    module.exports = $1c121b92b9034c1f$var$createHybrid;
});
parcelRegister("k8MLc", function(module, exports) {
    var $ea9a60ca966f8da9$var$nativeMax = Math.max;
    function $ea9a60ca966f8da9$var$composeArgs(args, partials, holders, isCurried) {
        var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = $ea9a60ca966f8da9$var$nativeMax(argsLength - holdersLength, 0), result = Array(leftLength + rangeLength), isUncurried = !isCurried;
        while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
        while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
        while(rangeLength--)result[leftIndex++] = args[argsIndex++];
        return result;
    }
    module.exports = $ea9a60ca966f8da9$var$composeArgs;
});
parcelRegister("eqXBf", function(module, exports) {
    var $a821b9ab167c5b82$var$nativeMax = Math.max;
    function $a821b9ab167c5b82$var$composeArgsRight(args, partials, holders, isCurried) {
        var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = $a821b9ab167c5b82$var$nativeMax(argsLength - holdersLength, 0), result = Array(rangeLength + rightLength), isUncurried = !isCurried;
        while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
        var offset = argsIndex;
        while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
        while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
        return result;
    }
    module.exports = $a821b9ab167c5b82$var$composeArgsRight;
});
parcelRegister("khpbX", function(module, exports) {
    function $ec38efbc1ab3f809$var$countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    module.exports = $ec38efbc1ab3f809$var$countHolders;
});
parcelRegister("6fuEo", function(module, exports) {
    var $2dCKt = parcelRequire("2dCKt");
    var $4EzKU = parcelRequire("4EzKU");
    var $iKqmZ = parcelRequire("iKqmZ");
    var $48cbeb57943323d5$var$WRAP_BIND_FLAG = 1, $48cbeb57943323d5$var$WRAP_BIND_KEY_FLAG = 2, $48cbeb57943323d5$var$WRAP_CURRY_BOUND_FLAG = 4, $48cbeb57943323d5$var$WRAP_CURRY_FLAG = 8, $48cbeb57943323d5$var$WRAP_PARTIAL_FLAG = 32, $48cbeb57943323d5$var$WRAP_PARTIAL_RIGHT_FLAG = 64;
    function $48cbeb57943323d5$var$createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
        var isCurry = bitmask & $48cbeb57943323d5$var$WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
        bitmask |= isCurry ? $48cbeb57943323d5$var$WRAP_PARTIAL_FLAG : $48cbeb57943323d5$var$WRAP_PARTIAL_RIGHT_FLAG;
        bitmask &= ~(isCurry ? $48cbeb57943323d5$var$WRAP_PARTIAL_RIGHT_FLAG : $48cbeb57943323d5$var$WRAP_PARTIAL_FLAG);
        if (!(bitmask & $48cbeb57943323d5$var$WRAP_CURRY_BOUND_FLAG)) bitmask &= ~($48cbeb57943323d5$var$WRAP_BIND_FLAG | $48cbeb57943323d5$var$WRAP_BIND_KEY_FLAG);
        var newData = [
            func,
            bitmask,
            thisArg,
            newPartials,
            newHolders,
            newPartialsRight,
            newHoldersRight,
            argPos,
            ary,
            arity
        ];
        var result = wrapFunc.apply(undefined, newData);
        if ($2dCKt(func)) $4EzKU(result, newData);
        result.placeholder = placeholder;
        return $iKqmZ(result, func, bitmask);
    }
    module.exports = $48cbeb57943323d5$var$createRecurry;
});
parcelRegister("4EzKU", function(module, exports) {
    var $g1o5k = parcelRequire("g1o5k");
    var $eqv0t = parcelRequire("eqv0t");
    var $3636a22a88d50b78$var$setData = $eqv0t($g1o5k);
    module.exports = $3636a22a88d50b78$var$setData;
});
parcelRegister("iKqmZ", function(module, exports) {
    var $d25DY = parcelRequire("d25DY");
    var $iPKwQ = parcelRequire("iPKwQ");
    var $8pgNR = parcelRequire("8pgNR");
    var $1ZcUe = parcelRequire("1ZcUe");
    function $da60fa5a8c702882$var$setWrapToString(wrapper, reference, bitmask) {
        var source = reference + '';
        return $8pgNR(wrapper, $iPKwQ(source, $1ZcUe($d25DY(source), bitmask)));
    }
    module.exports = $da60fa5a8c702882$var$setWrapToString;
});
parcelRegister("d25DY", function(module, exports) {
    var $97cfd7023a392295$var$reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, $97cfd7023a392295$var$reSplitDetails = /,? & /;
    function $97cfd7023a392295$var$getWrapDetails(source) {
        var match = source.match($97cfd7023a392295$var$reWrapDetails);
        return match ? match[1].split($97cfd7023a392295$var$reSplitDetails) : [];
    }
    module.exports = $97cfd7023a392295$var$getWrapDetails;
});
parcelRegister("iPKwQ", function(module, exports) {
    var $db61150bcd231438$var$reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
    function $db61150bcd231438$var$insertWrapDetails(source, details) {
        var length = details.length;
        if (!length) return source;
        var lastIndex = length - 1;
        details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
        details = details.join(length > 2 ? ', ' : ' ');
        return source.replace($db61150bcd231438$var$reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }
    module.exports = $db61150bcd231438$var$insertWrapDetails;
});
parcelRegister("1ZcUe", function(module, exports) {
    var $fmP8r = parcelRequire("fmP8r");
    var $fUP98 = parcelRequire("fUP98");
    var $17257fcfcc231370$var$WRAP_BIND_FLAG = 1, $17257fcfcc231370$var$WRAP_BIND_KEY_FLAG = 2, $17257fcfcc231370$var$WRAP_CURRY_FLAG = 8, $17257fcfcc231370$var$WRAP_CURRY_RIGHT_FLAG = 16, $17257fcfcc231370$var$WRAP_PARTIAL_FLAG = 32, $17257fcfcc231370$var$WRAP_PARTIAL_RIGHT_FLAG = 64, $17257fcfcc231370$var$WRAP_ARY_FLAG = 128, $17257fcfcc231370$var$WRAP_REARG_FLAG = 256, $17257fcfcc231370$var$WRAP_FLIP_FLAG = 512;
    var $17257fcfcc231370$var$wrapFlags = [
        [
            'ary',
            $17257fcfcc231370$var$WRAP_ARY_FLAG
        ],
        [
            'bind',
            $17257fcfcc231370$var$WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            $17257fcfcc231370$var$WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            $17257fcfcc231370$var$WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            $17257fcfcc231370$var$WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            $17257fcfcc231370$var$WRAP_FLIP_FLAG
        ],
        [
            'partial',
            $17257fcfcc231370$var$WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            $17257fcfcc231370$var$WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            $17257fcfcc231370$var$WRAP_REARG_FLAG
        ]
    ];
    function $17257fcfcc231370$var$updateWrapDetails(details, bitmask) {
        $fmP8r($17257fcfcc231370$var$wrapFlags, function(pair) {
            var value = '_.' + pair[0];
            if (bitmask & pair[1] && !$fUP98(details, value)) details.push(value);
        });
        return details.sort();
    }
    module.exports = $17257fcfcc231370$var$updateWrapDetails;
});
parcelRegister("8ZIC5", function(module, exports) {
    function $68c6a086039b9437$var$getHolder(func) {
        var object = func;
        return object.placeholder;
    }
    module.exports = $68c6a086039b9437$var$getHolder;
});
parcelRegister("3Prcz", function(module, exports) {
    var $jHlUS = parcelRequire("jHlUS");
    var $e8U1z = parcelRequire("e8U1z");
    var $2c9b3c36ffa24094$var$nativeMin = Math.min;
    function $2c9b3c36ffa24094$var$reorder(array, indexes) {
        var arrLength = array.length, length = $2c9b3c36ffa24094$var$nativeMin(indexes.length, arrLength), oldArray = $jHlUS(array);
        while(length--){
            var index = indexes[length];
            array[length] = $e8U1z(index, arrLength) ? oldArray[index] : undefined;
        }
        return array;
    }
    module.exports = $2c9b3c36ffa24094$var$reorder;
});
parcelRegister("kBUUu", function(module, exports) {
    var $f0136883d4267917$var$PLACEHOLDER = '__lodash_placeholder__';
    function $f0136883d4267917$var$replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === $f0136883d4267917$var$PLACEHOLDER) {
                array[index] = $f0136883d4267917$var$PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    module.exports = $f0136883d4267917$var$replaceHolders;
});
parcelRegister("cwXqG", function(module, exports) {
    var $hlchF = parcelRequire("hlchF");
    var $iJkMv = parcelRequire("iJkMv");
    var $1V15E = parcelRequire("1V15E");
    var $91f6929c17575724$var$WRAP_BIND_FLAG = 1;
    function $91f6929c17575724$var$createPartial(func, bitmask, thisArg, partials) {
        var isBind = bitmask & $91f6929c17575724$var$WRAP_BIND_FLAG, Ctor = $iJkMv(func);
        function wrapper() {
            var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array(leftLength + argsLength), fn = this && this !== $1V15E && this instanceof wrapper ? Ctor : func;
            while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
            while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
            return $hlchF(fn, isBind ? thisArg : this, args);
        }
        return wrapper;
    }
    module.exports = $91f6929c17575724$var$createPartial;
});
parcelRegister("c8pf3", function(module, exports) {
    var $k8MLc = parcelRequire("k8MLc");
    var $eqXBf = parcelRequire("eqXBf");
    var $kBUUu = parcelRequire("kBUUu");
    var $8d59cfe3586d6695$var$PLACEHOLDER = '__lodash_placeholder__';
    var $8d59cfe3586d6695$var$WRAP_BIND_FLAG = 1, $8d59cfe3586d6695$var$WRAP_BIND_KEY_FLAG = 2, $8d59cfe3586d6695$var$WRAP_CURRY_BOUND_FLAG = 4, $8d59cfe3586d6695$var$WRAP_CURRY_FLAG = 8, $8d59cfe3586d6695$var$WRAP_ARY_FLAG = 128, $8d59cfe3586d6695$var$WRAP_REARG_FLAG = 256;
    var $8d59cfe3586d6695$var$nativeMin = Math.min;
    function $8d59cfe3586d6695$var$mergeData(data, source) {
        var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < ($8d59cfe3586d6695$var$WRAP_BIND_FLAG | $8d59cfe3586d6695$var$WRAP_BIND_KEY_FLAG | $8d59cfe3586d6695$var$WRAP_ARY_FLAG);
        var isCombo = srcBitmask == $8d59cfe3586d6695$var$WRAP_ARY_FLAG && bitmask == $8d59cfe3586d6695$var$WRAP_CURRY_FLAG || srcBitmask == $8d59cfe3586d6695$var$WRAP_ARY_FLAG && bitmask == $8d59cfe3586d6695$var$WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == ($8d59cfe3586d6695$var$WRAP_ARY_FLAG | $8d59cfe3586d6695$var$WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == $8d59cfe3586d6695$var$WRAP_CURRY_FLAG;
        if (!(isCommon || isCombo)) return data;
        if (srcBitmask & $8d59cfe3586d6695$var$WRAP_BIND_FLAG) {
            data[2] = source[2];
            newBitmask |= bitmask & $8d59cfe3586d6695$var$WRAP_BIND_FLAG ? 0 : $8d59cfe3586d6695$var$WRAP_CURRY_BOUND_FLAG;
        }
        var value = source[3];
        if (value) {
            var partials = data[3];
            data[3] = partials ? $k8MLc(partials, value, source[4]) : value;
            data[4] = partials ? $kBUUu(data[3], $8d59cfe3586d6695$var$PLACEHOLDER) : source[4];
        }
        value = source[5];
        if (value) {
            partials = data[5];
            data[5] = partials ? $eqXBf(partials, value, source[6]) : value;
            data[6] = partials ? $kBUUu(data[5], $8d59cfe3586d6695$var$PLACEHOLDER) : source[6];
        }
        value = source[7];
        if (value) data[7] = value;
        if (srcBitmask & $8d59cfe3586d6695$var$WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : $8d59cfe3586d6695$var$nativeMin(data[8], source[8]);
        if (data[9] == null) data[9] = source[9];
        data[0] = source[0];
        data[1] = newBitmask;
        return data;
    }
    module.exports = $8d59cfe3586d6695$var$mergeData;
});
parcelRegister("91VA7", function(module, exports) {
    var $7MmCC = parcelRequire("7MmCC");
    var $6930df867851495d$var$CLONE_SYMBOLS_FLAG = 4;
    function $6930df867851495d$var$clone(value) {
        return $7MmCC(value, $6930df867851495d$var$CLONE_SYMBOLS_FLAG);
    }
    module.exports = $6930df867851495d$var$clone;
});
parcelRegister("a7NzZ", function(module, exports) {
    var $5oTQF = parcelRequire("5oTQF");
    var $75f10447dad5f8f2$var$WRAP_CURRY_FLAG = 8;
    function $75f10447dad5f8f2$var$curry(func, arity, guard) {
        arity = guard ? undefined : arity;
        var result = $5oTQF(func, $75f10447dad5f8f2$var$WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
        result.placeholder = $75f10447dad5f8f2$var$curry.placeholder;
        return result;
    }
    $75f10447dad5f8f2$var$curry.placeholder = {};
    module.exports = $75f10447dad5f8f2$var$curry;
});
parcelRegister("aZFhV", function(module, exports) {
    var $beQoo = parcelRequire("beQoo");
    var $fC1Kz = parcelRequire("fC1Kz");
    var $1QOns = parcelRequire("1QOns");
    var $800fa0dabdb52684$var$domExcTag = '[object DOMException]', $800fa0dabdb52684$var$errorTag = '[object Error]';
    function $800fa0dabdb52684$var$isError(value) {
        if (!$fC1Kz(value)) return false;
        var tag = $beQoo(value);
        return tag == $800fa0dabdb52684$var$errorTag || tag == $800fa0dabdb52684$var$domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !$1QOns(value);
    }
    module.exports = $800fa0dabdb52684$var$isError;
});
parcelRegister("5UxIS", function(module, exports) {
    var $jtBGw = parcelRequire("jtBGw");
    var $fC1Kz = parcelRequire("fC1Kz");
    var $44dc5758474a5c9f$var$weakMapTag = '[object WeakMap]';
    function $44dc5758474a5c9f$var$isWeakMap(value) {
        return $fC1Kz(value) && $jtBGw(value) == $44dc5758474a5c9f$var$weakMapTag;
    }
    module.exports = $44dc5758474a5c9f$var$isWeakMap;
});
parcelRegister("5qDt4", function(module, exports) {
    var $7MmCC = parcelRequire("7MmCC");
    var $bxDef = parcelRequire("bxDef");
    var $3f3dfefad45dde4d$var$CLONE_DEEP_FLAG = 1;
    function $3f3dfefad45dde4d$var$iteratee(func) {
        return $bxDef(typeof func == 'function' ? func : $7MmCC(func, $3f3dfefad45dde4d$var$CLONE_DEEP_FLAG));
    }
    module.exports = $3f3dfefad45dde4d$var$iteratee;
});
parcelRegister("iZlmO", function(module, exports) {
    var $5oTQF = parcelRequire("5oTQF");
    var $9SRAA = parcelRequire("9SRAA");
    var $dd2e7f874e5ccea3$var$WRAP_REARG_FLAG = 256;
    var $dd2e7f874e5ccea3$var$rearg = $9SRAA(function(func, indexes) {
        return $5oTQF(func, $dd2e7f874e5ccea3$var$WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });
    module.exports = $dd2e7f874e5ccea3$var$rearg;
});
parcelRegister("6TYHJ", function(module, exports) {
    var $1nIHN = parcelRequire("1nIHN");
    var $jHlUS = parcelRequire("jHlUS");
    var $8LQ84 = parcelRequire("8LQ84");
    var $4faK3 = parcelRequire("4faK3");
    var $h5JBK = parcelRequire("h5JBK");
    var $gzebZ = parcelRequire("gzebZ");
    var $jJVtR = parcelRequire("jJVtR");
    function $5066f7c1bc1a55ec$var$toPath(value) {
        if ($8LQ84(value)) return $1nIHN(value, $gzebZ);
        return $4faK3(value) ? [
            value
        ] : $jHlUS($h5JBK($jJVtR(value)));
    }
    module.exports = $5066f7c1bc1a55ec$var$toPath;
});
parcelRegister("iASWI", function(module, exports) {
    var $irTmi = parcelRequire("irTmi");
    var $d89635f071f7433a$var$range = $irTmi();
    module.exports = $d89635f071f7433a$var$range;
});
parcelRegister("irTmi", function(module, exports) {
    var $7DMj9 = parcelRequire("7DMj9");
    var $4rDUz = parcelRequire("4rDUz");
    var $kJ0Lf = parcelRequire("kJ0Lf");
    function $d6e5b0af0cc26ead$var$createRange(fromRight) {
        return function(start, end, step) {
            if (step && typeof step != 'number' && $4rDUz(start, end, step)) end = step = undefined;
            start = $kJ0Lf(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = $kJ0Lf(end);
            step = step === undefined ? start < end ? 1 : -1 : $kJ0Lf(step);
            return $7DMj9(start, end, step, fromRight);
        };
    }
    module.exports = $d6e5b0af0cc26ead$var$createRange;
});
parcelRegister("7DMj9", function(module, exports) {
    var $5901a5dd7694a169$var$nativeCeil = Math.ceil, $5901a5dd7694a169$var$nativeMax = Math.max;
    function $5901a5dd7694a169$var$baseRange(start, end, step, fromRight) {
        var index = -1, length = $5901a5dd7694a169$var$nativeMax($5901a5dd7694a169$var$nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
        while(length--){
            result[fromRight ? length : ++index] = start;
            start += step;
        }
        return result;
    }
    module.exports = $5901a5dd7694a169$var$baseRange;
});
parcelRegister("2vEiN", function(module, exports) {
    $parcel$export(module.exports, "getIsTableEmpty", ()=>$334022f4a2ef522c$export$b8347bf00a122737);
    $parcel$export(module.exports, "getItemsSelectionCount", ()=>$334022f4a2ef522c$export$a3c7ec1348b0395b);
    $parcel$export(module.exports, "getItems", ()=>$334022f4a2ef522c$export$d2f92acf417bbf5d);
    $parcel$export(module.exports, "getItemIndexes", ()=>$334022f4a2ef522c$export$b3e7f67495a21c55);
    $parcel$export(module.exports, "getItemsContainerStyles", ()=>$334022f4a2ef522c$export$cc1469a0793758e9);
    $parcel$export(module.exports, "getItemHeight", ()=>$334022f4a2ef522c$export$ddd834f23fa82fc4);
    $parcel$export(module.exports, "getItemsCount", ()=>$334022f4a2ef522c$export$dd01a43948d7de86);
    $parcel$export(module.exports, "getAriaRowCount", ()=>$334022f4a2ef522c$export$3d62f784b6f09127);
    $parcel$export(module.exports, "getHasActiveCreate", ()=>$334022f4a2ef522c$export$37a764c3aa026241);
    $parcel$export(module.exports, "getCreateItemAnchor", ()=>$334022f4a2ef522c$export$136936d41252875f);
    $parcel$export(module.exports, "getCreateItemAnchorIndex", ()=>$334022f4a2ef522c$export$32b1b971ba5fa108);
    $parcel$export(module.exports, "getSelectedItemIds", ()=>$334022f4a2ef522c$export$e9f0552305c19203);
    $parcel$export(module.exports, "getActiveItemId", ()=>$334022f4a2ef522c$export$b40482e3ca743b81);
    $parcel$export(module.exports, "getIsItemActive", ()=>$334022f4a2ef522c$export$4b209aa328dc6c69);
    $parcel$export(module.exports, "getIsItemSelected", ()=>$334022f4a2ef522c$export$eacf042ab4fde4a7);
    $parcel$export(module.exports, "getIsItemMultiSelected", ()=>$334022f4a2ef522c$export$1c36f8ddcf135195);
    $parcel$export(module.exports, "getIsItemSelectable", ()=>$334022f4a2ef522c$export$b3fb6474950e2ea0);
    var $4R6GH;
    var $6dDSs;
    var $iZN6h;
    var $7ouUj;
    const $334022f4a2ef522c$export$b8347bf00a122737 = (state)=>state.isTableEmpty;
    const $334022f4a2ef522c$export$71297f0abe09788f = ({ itemsSelectionState: itemsSelectionState }, id)=>itemsSelectionState ? itemsSelectionState[id] ?? false : undefined;
    const $334022f4a2ef522c$export$42fccc645f404e95 = ({ itemsSelectionState: itemsSelectionState, itemsSelectionCount: itemsSelectionCount }, id)=>{
        if (!itemsSelectionState || itemsSelectionCount === undefined) return undefined;
        return itemsSelectionCount > 1 && itemsSelectionState[id] || false;
    };
    const $334022f4a2ef522c$export$a3c7ec1348b0395b = (state)=>state.selectedItemIds.length;
    const $334022f4a2ef522c$export$d2f92acf417bbf5d = (state)=>state.items;
    const $334022f4a2ef522c$export$b3e7f67495a21c55 = (state)=>state.itemIndexes;
    const $334022f4a2ef522c$export$cc1469a0793758e9 = (state)=>({
            itemsBackground: state.itemsBackground,
            totalHeight: state.totalHeight
        });
    const $334022f4a2ef522c$export$ddd834f23fa82fc4 = (state)=>state.itemHeight;
    const $334022f4a2ef522c$export$dd01a43948d7de86 = (state)=>state.items.length;
    const $334022f4a2ef522c$export$3d62f784b6f09127 = (state)=>state.ariaRowCount;
    const $334022f4a2ef522c$export$37a764c3aa026241 = (state)=>state.createItemAnchor !== undefined;
    const $334022f4a2ef522c$export$136936d41252875f = (state)=>state.createItemAnchor;
    const $334022f4a2ef522c$export$32b1b971ba5fa108 = ({ createItemAnchor: createItemAnchor, itemIndexes: itemIndexes })=>{
        if (!createItemAnchor || createItemAnchor.position === (0, (0, parcelRequire("iZN6h")).LAST)) return undefined;
        if (createItemAnchor.beforeId) return itemIndexes[createItemAnchor.beforeId];
        if (createItemAnchor.parentId) return itemIndexes[createItemAnchor.parentId];
    };
    const $334022f4a2ef522c$export$e9f0552305c19203 = (state)=>state.selectedItemIds;
    const $334022f4a2ef522c$export$b40482e3ca743b81 = (state)=>state.activeItemId;
    const $334022f4a2ef522c$export$4b209aa328dc6c69 = (state, id)=>state.activeItemId === id;
    const $334022f4a2ef522c$export$6c44f432f7ffa367 = (0, (0, parcelRequire("6dDSs")).createSelector)([
        $334022f4a2ef522c$export$e9f0552305c19203
    ], (selectedItemIds)=>new Set(selectedItemIds));
    const $334022f4a2ef522c$export$eacf042ab4fde4a7 = (state, id)=>{
        if (!(0, (0, parcelRequire("4R6GH")).fg)('project_timeline_multi-select_and_checkboxes')) return $334022f4a2ef522c$export$71297f0abe09788f(state, id);
        return $334022f4a2ef522c$export$6c44f432f7ffa367(state).has(id);
    };
    const $334022f4a2ef522c$export$1c36f8ddcf135195 = (state, id)=>{
        if (!(0, (0, parcelRequire("4R6GH")).fg)('project_timeline_multi-select_and_checkboxes')) return $334022f4a2ef522c$export$42fccc645f404e95(state, id);
        const selection = $334022f4a2ef522c$export$6c44f432f7ffa367(state);
        return selection.size > 1 && selection.has(id);
    };
    const $334022f4a2ef522c$var$getFirstSelectedItem = ({ items: items, itemIndexes: itemIndexes, selectedItemIds: selectedItemIds })=>selectedItemIds.length > 0 ? items[itemIndexes[selectedItemIds[0]]] : undefined;
    const $334022f4a2ef522c$export$b3fb6474950e2ea0 = (0, (0, parcelRequire("6dDSs")).createSelector)([
        $334022f4a2ef522c$export$d2f92acf417bbf5d,
        $334022f4a2ef522c$export$b3e7f67495a21c55,
        $334022f4a2ef522c$var$getFirstSelectedItem,
        (_, itemId)=>itemId
    ], (items, itemIndexes, firstSelectedItem, itemId)=>{
        if (!firstSelectedItem) return true;
        const item = items[itemIndexes[itemId]];
        if (!item) return false;
        return (0, (0, parcelRequire("7ouUj")).getItemLevel)(firstSelectedItem) === (0, (0, parcelRequire("7ouUj")).getItemLevel)(item) && firstSelectedItem.meta.parentId === item.meta.parentId;
    });
});
parcelRegister("9puhl", function(module, exports) {
    $parcel$export(module.exports, "useListWidth", ()=>$8908d54a7209f6db$export$55c090d16aa0f75d);
    $parcel$export(module.exports, "useListItemMenuOptions", ()=>$8908d54a7209f6db$export$1951ac3cbf4049a0);
    $parcel$export(module.exports, "default", ()=>$8908d54a7209f6db$export$2e2bcd8739ae039);
    var $4R6GH;
    var $3sQ5x;
    var $gg7kZ;
    var $iXqE5;
    var $iZN6h;
    var $8blQT;
    var $45N9l;
    const $8908d54a7209f6db$var$initialState = {
        listWidth: 0,
        listItemMenuOptions: {
            overrideLabels: {},
            customSections: [],
            customSectionsBulk: []
        }
    };
    const $8908d54a7209f6db$export$3e2081a696ef1795 = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $8908d54a7209f6db$var$initialState,
        actions: (0, parcelRequire("8blQT")).actions,
        name: 'timeline-table.list'
    });
    const $8908d54a7209f6db$export$469df0dd4929d037 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($8908d54a7209f6db$export$3e2081a696ef1795);
    const $8908d54a7209f6db$export$55c090d16aa0f75d = (0, (0, parcelRequire("3sQ5x")).createHook)($8908d54a7209f6db$export$3e2081a696ef1795, {
        selector: (0, (0, parcelRequire("45N9l")).getListWidth)
    });
    const $8908d54a7209f6db$export$1951ac3cbf4049a0 = (0, (0, parcelRequire("3sQ5x")).createHook)($8908d54a7209f6db$export$3e2081a696ef1795, {
        selector: (0, (0, parcelRequire("45N9l")).getListItemMenuOptions)
    });
    const $8908d54a7209f6db$export$2f645645f7bca764 = (0, (0, parcelRequire("3sQ5x")).createHook)($8908d54a7209f6db$export$3e2081a696ef1795);
    const $8908d54a7209f6db$export$9b0a72e5d41d62ec = (0, (0, parcelRequire("gg7kZ")).createContainer)($8908d54a7209f6db$export$3e2081a696ef1795, {
        onInit: ()=>({ setState: setState }, listState)=>{
                setState({
                    ...listState,
                    ...(0, (0, parcelRequire("4R6GH")).fg)('project_timeline_multi-select_and_checkboxes') && {
                        listWidth: Math.max((0, (0, parcelRequire("iZN6h")).MINIMUM_LIST_WIDTH)(), listState.listWidth)
                    }
                });
            },
        onUpdate: ()=>({ setState: setState }, listState)=>{
                setState({
                    ...listState,
                    ...(0, (0, parcelRequire("4R6GH")).fg)('project_timeline_multi-select_and_checkboxes') && {
                        listWidth: Math.max((0, (0, parcelRequire("iZN6h")).MINIMUM_LIST_WIDTH)(), listState.listWidth)
                    }
                });
            }
    });
    var $8908d54a7209f6db$export$2e2bcd8739ae039 = $8908d54a7209f6db$export$9b0a72e5d41d62ec;
});
parcelRegister("8blQT", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$248b6a58cffa4e63$export$e324594224ef24da);
    var $34Zjv;
    const $248b6a58cffa4e63$export$e324594224ef24da = {
        setListWidth: (0, parcelRequire("34Zjv")).setListWidth
    };
});
parcelRegister("34Zjv", function(module, exports) {
    $parcel$export(module.exports, "setListWidth", ()=>$a7e782f1b950c324$export$e9fd6c0c57a999a3);
    const $a7e782f1b950c324$export$e9fd6c0c57a999a3 = (listWidth)=>({ setState: setState })=>{
            setState({
                listWidth: listWidth
            });
        };
});
parcelRegister("45N9l", function(module, exports) {
    $parcel$export(module.exports, "getListWidth", ()=>$c72198c17c460390$export$546faffca0a891d);
    $parcel$export(module.exports, "getListItemMenuOptions", ()=>$c72198c17c460390$export$2d38f26d6331442e);
    const $c72198c17c460390$export$546faffca0a891d = (state)=>state.listWidth;
    const $c72198c17c460390$export$2d38f26d6331442e = (state)=>state.listItemMenuOptions;
});
parcelRegister("cQx6e", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6fd9ed6ab2b605b2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $c7Iuw;
    const $6fd9ed6ab2b605b2$var$TablePortalProvider = (props)=>{
        const [portalContainerElement, setPortalContainerElement] = (0, $5uXOq.useState)(null);
        const portalState = (0, $5uXOq.useMemo)(()=>({
                setPortalContainerElement: setPortalContainerElement,
                portalContainerElement: portalContainerElement
            }), [
            portalContainerElement
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c7Iuw")).PortalScopeContext).Provider, {
            value: portalState
        }, props.children);
    };
    var $6fd9ed6ab2b605b2$export$2e2bcd8739ae039 = $6fd9ed6ab2b605b2$var$TablePortalProvider;
});
parcelRegister("c7Iuw", function(module, exports) {
    $parcel$export(module.exports, "PortalScopeContext", ()=>$4da8629c07fd2ab2$export$c9ecc14d092a6ed0);
    $parcel$export(module.exports, "usePortalScope", ()=>$4da8629c07fd2ab2$export$ed9db44bbd000055);
    var $5uXOq = parcelRequire("5uXOq");
    const $4da8629c07fd2ab2$export$c9ecc14d092a6ed0 = (0, $5uXOq.createContext)({
        setPortalContainerElement: ()=>undefined,
        portalContainerElement: null
    });
    const $4da8629c07fd2ab2$export$ed9db44bbd000055 = ()=>(0, $5uXOq.useContext)($4da8629c07fd2ab2$export$c9ecc14d092a6ed0);
});
parcelRegister("3ruU1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3d93168080b8ac44$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "useSideEffectMarshal", ()=>$3d93168080b8ac44$export$b2476fd3df1b06b6);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $4R6GH;
    var $3MKmR;
    var $82CeN;
    var $7de6U;
    var $7OK0c;
    var $hS1s8;
    var $ehMvl;
    var $93fNo;
    var $2SP8o;
    const $3d93168080b8ac44$var$SideEffectMarshal = ({ scope: scope, customActions: customActions, overrideActions: overrideActions, ariaLabel: ariaLabel, ariaReadOnly: ariaReadOnly, ariaMultiselectable: ariaMultiselectable, children: children })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const styleAPI = (0, (0, parcelRequire("93fNo")).useStyleMarshal)(scope);
        const rowState = (0, (0, parcelRequire("ehMvl")).useRowState)();
        const defaultActions = (0, $5uXOq.useMemo)(()=>{
            const onRowMouseEnter = (id)=>{
                if (rowState.get(id) || rowState.isAnyRowDragging()) return;
                styleAPI.hoverRow(id);
            };
            const onRowMouseLeave = (id)=>{
                if (rowState.get(id) || rowState.isAnyRowDragging()) return;
                styleAPI.leaveRow(id);
            };
            const onRowFocus = (id)=>{
                if (!(0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y')) return;
                if (rowState.get(id) || rowState.isAnyRowDragging()) return;
                rowState.set(id, (0, (0, parcelRequire("hS1s8")).ROW_STATES).FOCUSED);
                styleAPI.hoverRow(id);
            };
            const onRowBlur = (id)=>{
                if (!(0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y')) return;
                if (rowState.get(id) !== (0, (0, parcelRequire("hS1s8")).ROW_STATES).FOCUSED || rowState.isAnyRowDragging()) return;
                rowState.clear(id);
                styleAPI.leaveRow(id);
            };
            const onRowSelect = (ids)=>{
                ids.forEach((id)=>rowState.set(id, (0, (0, parcelRequire("hS1s8")).ROW_STATES).SELECTED));
                styleAPI.selectRow(ids);
            };
            const onRowDeselect = (ids)=>{
                ids.forEach((id)=>rowState.clear(id));
                styleAPI.deselectRow();
            };
            const onRowGenerateDragPreview = ()=>{
                styleAPI.hideChildCreate();
            };
            const onRowDragStart = (id)=>{
                rowState.set(id, (0, (0, parcelRequire("hS1s8")).ROW_STATES).DRAGGED);
                styleAPI.dragRow(id);
            };
            const onRowDragEnd = (id)=>{
                const wasRowSelected = rowState.wasRowSelected(id);
                wasRowSelected ? rowState.set(id, (0, (0, parcelRequire("hS1s8")).ROW_STATES).SELECTED) : rowState.clear(id);
                styleAPI.dropRow(id, wasRowSelected);
            };
            const onRowDragOver = (id, top, left)=>{
                rowState.set(id, (0, (0, parcelRequire("hS1s8")).ROW_STATES).DRAGGED_OVER);
                styleAPI.showDragIndicator(top, left);
            };
            const onRowDragChildOverParent = (id, parentId)=>{
                rowState.set(id, (0, (0, parcelRequire("hS1s8")).ROW_STATES).DRAGGED_OVER);
                styleAPI.dragOverParent(parentId, rowState.get(parentId) === (0, (0, parcelRequire("hS1s8")).ROW_STATES).SELECTED);
            };
            const onRowDragChildOverParentEnd = (parentId)=>{
                styleAPI.leaveRow(parentId);
            };
            const onRowDragOutOfBounds = (id)=>{
                rowState.set(id, (0, (0, parcelRequire("hS1s8")).ROW_STATES).DRAGGED_OUT);
                styleAPI.dragOutOfBounds();
            };
            const onAddButtonMouseEnter = (top, tabFocused)=>{
                if (rowState.isAnyRowDragging()) return;
                styleAPI.showInlineCreate(top, tabFocused);
            };
            const onAddButtonMouseLeave = ()=>{
                if (rowState.isAnyRowDragging()) return;
                styleAPI.hideInlineCreate();
            };
            const onScrollStateChanged = (isScrolling)=>{
                if (rowState.isAnyRowDragging()) return;
                isScrolling ? styleAPI.blockPointerEvents() : styleAPI.allowPointerEvents();
            };
            return {
                onRowMouseEnter: onRowMouseEnter,
                onRowMouseLeave: onRowMouseLeave,
                onRowSelect: onRowSelect,
                onRowDeselect: onRowDeselect,
                onRowFocus: onRowFocus,
                onRowBlur: onRowBlur,
                onRowGenerateDragPreview: onRowGenerateDragPreview,
                onRowDragStart: onRowDragStart,
                onRowDragEnd: onRowDragEnd,
                onRowDragOver: onRowDragOver,
                onRowDragChildOverParent: onRowDragChildOverParent,
                onRowDragChildOverParentEnd: onRowDragChildOverParentEnd,
                onRowDragOutOfBounds: onRowDragOutOfBounds,
                onAddButtonMouseEnter: onAddButtonMouseEnter,
                onAddButtonMouseLeave: onAddButtonMouseLeave,
                onScrollStateChanged: onScrollStateChanged
            };
        }, [
            rowState,
            styleAPI
        ]);
        const combinedActions = (0, $5uXOq.useMemo)(()=>({
                ...(0, (0, parcelRequire("2SP8o")).bindOverrideActions)(defaultActions, overrideActions, styleAPI),
                custom: (0, (0, parcelRequire("2SP8o")).bindCustomActions)(customActions, styleAPI)
            }), [
            defaultActions,
            customActions,
            overrideActions,
            styleAPI
        ]);
        const GridComponent = (0, (0, parcelRequire("4R6GH")).fg)('timeline_grid_navigation_m2') ? (0, (0, parcelRequire("7de6U")).Grid) : (0, (0, parcelRequire("7de6U")).GridOld);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3MKmR")).SideEffectContext).Provider, {
            value: combinedActions
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("82CeN")).FocusMarshalProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement(GridComponent, {
            scope: scope,
            ariaReadOnly: ariaReadOnly,
            ariaMultiselectable: ariaMultiselectable,
            ariaLabel: ariaLabel ?? formatMessage((0, (0, parcelRequire("7OK0c")).default).defaultLabel)
        }, children)));
    };
    $3d93168080b8ac44$var$SideEffectMarshal.defaultProps = {
        customActions: {},
        overrideActions: {},
        ariaLabel: undefined,
        ariaReadOnly: undefined,
        ariaMultiselectable: undefined
    };
    var $3d93168080b8ac44$export$2e2bcd8739ae039 = $3d93168080b8ac44$var$SideEffectMarshal;
    const $3d93168080b8ac44$export$b2476fd3df1b06b6 = ()=>(0, $5uXOq.useContext)((0, (0, parcelRequire("3MKmR")).SideEffectContext));
});
parcelRegister("3MKmR", function(module, exports) {
    $parcel$export(module.exports, "SideEffectContext", ()=>$dc4147209a0266e0$export$f87600ce6f9a1288);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    const $dc4147209a0266e0$export$f87600ce6f9a1288 = (0, $5uXOq.createContext)({
        custom: {},
        onRowMouseEnter: (0, ($parcel$interopDefault($8Rkzz))),
        onRowMouseLeave: (0, ($parcel$interopDefault($8Rkzz))),
        onRowSelect: (0, ($parcel$interopDefault($8Rkzz))),
        onRowDeselect: (0, ($parcel$interopDefault($8Rkzz))),
        onRowFocus: (0, ($parcel$interopDefault($8Rkzz))),
        onRowBlur: (0, ($parcel$interopDefault($8Rkzz))),
        onRowGenerateDragPreview: (0, ($parcel$interopDefault($8Rkzz))),
        onRowDragStart: (0, ($parcel$interopDefault($8Rkzz))),
        onRowDragEnd: (0, ($parcel$interopDefault($8Rkzz))),
        onRowDragOver: (0, ($parcel$interopDefault($8Rkzz))),
        onRowDragChildOverParent: (0, ($parcel$interopDefault($8Rkzz))),
        onRowDragChildOverParentEnd: (0, ($parcel$interopDefault($8Rkzz))),
        onRowDragOutOfBounds: (0, ($parcel$interopDefault($8Rkzz))),
        onAddButtonMouseEnter: (0, ($parcel$interopDefault($8Rkzz))),
        onAddButtonMouseLeave: (0, ($parcel$interopDefault($8Rkzz))),
        onScrollStateChanged: (0, ($parcel$interopDefault($8Rkzz)))
    });
});
parcelRegister("82CeN", function(module, exports) {
    $parcel$export(module.exports, "useFocusMarshal", ()=>$ad6f6f91368ea63b$export$c8db889fd790e2d0);
    $parcel$export(module.exports, "useIsNavigationEnabled", ()=>$ad6f6f91368ea63b$export$197de480eb3dcfb5);
    $parcel$export(module.exports, "useIsNavigationPrevented", ()=>$ad6f6f91368ea63b$export$f0f577624c158cba);
    $parcel$export(module.exports, "useIsCreateTriggerActive", ()=>$ad6f6f91368ea63b$export$1d8ad99a41e9aa75);
    $parcel$export(module.exports, "FocusMarshalProvider", ()=>$ad6f6f91368ea63b$export$835dc2bb3cd0a80a);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $3sQ5x;
    var $gg7kZ;
    var $iXqE5;
    var $g3prf;
    var $hGh1Z;
    var $2YsNz;
    var $kon0h;
    var $1osZ4;
    const $ad6f6f91368ea63b$var$initialState = {
        gridCells: new (0, (0, parcelRequire("kon0h")).CellMap)(),
        focusedCell: undefined,
        activeCreateTrigger: undefined,
        rovingCell: undefined,
        isNavigationEnabled: true,
        isNavigationPrevented: false
    };
    const $ad6f6f91368ea63b$var$FocusContainer = (0, (0, parcelRequire("gg7kZ")).createContainer)();
    const $ad6f6f91368ea63b$var$focusStore = (0, (0, parcelRequire("iXqE5")).createStore)({
        containedBy: $ad6f6f91368ea63b$var$FocusContainer,
        initialState: $ad6f6f91368ea63b$var$initialState,
        actions: (0, parcelRequire("2YsNz")).actions,
        name: 'timeline-table.focus',
        handlers: {
            onContainerUpdate: (nextProps, prevProps)=>({ getState: getState })=>{
                    if ((0, (0, parcelRequire("4R6GH")).fg)('timeline_grid_navigation_m2')) {
                        if (nextProps.headerIndexes !== prevProps.headerIndexes || nextProps.itemIndexes !== prevProps.itemIndexes) {
                            const cellMap = getState().gridCells;
                            cellMap.setIsDirty(true);
                        }
                    }
                }
        }
    });
    const $ad6f6f91368ea63b$export$c8db889fd790e2d0 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($ad6f6f91368ea63b$var$focusStore);
    const $ad6f6f91368ea63b$export$ae79915617215704 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($ad6f6f91368ea63b$var$focusStore);
    const $ad6f6f91368ea63b$export$197de480eb3dcfb5 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($ad6f6f91368ea63b$var$focusStore, {
        selector: (0, (0, parcelRequire("1osZ4")).isNavigationEnabled)
    });
    const $ad6f6f91368ea63b$export$f0f577624c158cba = (0, (0, parcelRequire("3sQ5x")).createStateHook)($ad6f6f91368ea63b$var$focusStore, {
        selector: (0, (0, parcelRequire("1osZ4")).isNavigationPrevented)
    });
    const $ad6f6f91368ea63b$export$1d8ad99a41e9aa75 = (0, (0, parcelRequire("3sQ5x")).createHook)($ad6f6f91368ea63b$var$focusStore, {
        selector: (0, (0, parcelRequire("1osZ4")).isCreateTriggerActiveForItem)
    });
    const $ad6f6f91368ea63b$export$835dc2bb3cd0a80a = ({ children: children })=>{
        const [headerIndexesUnstable] = (0, (0, parcelRequire("g3prf")).useHeaderItemIndexes)();
        const [itemIndexesUnstable] = (0, (0, parcelRequire("hGh1Z")).useItemIndexes)();
        const headerIndexes = (0, $5uXOq.useRef)(headerIndexesUnstable);
        const itemIndexes = (0, $5uXOq.useRef)(itemIndexesUnstable);
        (0, $5uXOq.useEffect)(()=>{
            headerIndexes.current = headerIndexesUnstable;
            itemIndexes.current = itemIndexesUnstable;
        });
        const getCoordinates = (0, $5uXOq.useCallback)((getRowData)=>{
            const { column: column, rowId: rowId } = getRowData();
            const itemIndexOffset = Object.keys(headerIndexes.current).length;
            const row = headerIndexes.current[rowId] ?? itemIndexes.current[rowId] + itemIndexOffset;
            return [
                column,
                row
            ];
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($ad6f6f91368ea63b$var$FocusContainer, {
            getCoordinates: getCoordinates,
            ...(0, (0, parcelRequire("4R6GH")).fg)('timeline_grid_navigation_m2') ? {
                headerIndexes: headerIndexes.current,
                itemIndexes: itemIndexes.current
            } : {}
        }, children);
    };
});
parcelRegister("2YsNz", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$58d14c3de517b7e4$export$e324594224ef24da);
    var $4R6GH;
    const $58d14c3de517b7e4$var$rove = (current, next)=>({ setState: setState })=>{
            current?.setAttribute('tabindex', '-1');
            next.setAttribute('tabindex', '0');
            setState({
                rovingCell: next
            });
        };
    const $58d14c3de517b7e4$var$reconcile = (previous)=>({ getState: getState, dispatch: dispatch })=>{
            const { gridCells: gridCells, rovingCell: rovingCell, focusedCell: focusedCell } = getState();
            if (previous === rovingCell) {
                const nextCell = gridCells.getStart(rovingCell, true);
                if (nextCell) {
                    dispatch($58d14c3de517b7e4$var$rove(undefined, nextCell));
                    previous === focusedCell && nextCell.focus();
                }
            }
        };
    const $58d14c3de517b7e4$var$toggleNavigation = (cell, shouldEnable, autofocus)=>({ getState: getState, setState: setState })=>{
            const { gridCells: gridCells } = getState();
            const cellContent = gridCells.get(cell)?.getContent();
            if (!cellContent) return;
            if (shouldEnable) {
                setState({
                    isNavigationEnabled: true
                });
                autofocus && cell.focus();
            } else if (!shouldEnable && cellContent.length > 0) {
                setState({
                    isNavigationEnabled: false
                });
                autofocus && cellContent[0].focus();
            }
        };
    const $58d14c3de517b7e4$var$enableNavigation = ({ autofocus: autofocus } = {
        autofocus: true
    })=>({ getState: getState, dispatch: dispatch })=>{
            const { rovingCell: rovingCell, isNavigationEnabled: isNavigationEnabled } = getState();
            if (!isNavigationEnabled && rovingCell) dispatch($58d14c3de517b7e4$var$toggleNavigation(rovingCell, true, autofocus));
        };
    const $58d14c3de517b7e4$var$disableNavigation = ({ autofocus: autofocus } = {
        autofocus: true
    })=>({ getState: getState, dispatch: dispatch })=>{
            const { focusedCell: focusedCell, isNavigationEnabled: isNavigationEnabled } = getState();
            if (isNavigationEnabled && focusedCell) dispatch($58d14c3de517b7e4$var$toggleNavigation(focusedCell, false, autofocus));
        };
    const $58d14c3de517b7e4$var$initialiseRovingCell = (elem)=>({ getState: getState, setState: setState })=>{
            if (!getState().rovingCell) setState({
                rovingCell: elem
            });
        };
    const $58d14c3de517b7e4$var$createGetCoordinates = (getData, { getCoordinates: getCoordinates })=>()=>getCoordinates(getData);
    const $58d14c3de517b7e4$var$trackCell = (elem, getData, getContent)=>({ getState: getState }, containerProps)=>{
            const getCoordinates = $58d14c3de517b7e4$var$createGetCoordinates(getData, containerProps);
            getState().gridCells.set(elem, {
                getCoordinates: getCoordinates,
                getContent: getContent
            });
        };
    const $58d14c3de517b7e4$var$untrackCell = (elem)=>({ getState: getState, dispatch: dispatch })=>{
            const { gridCells: gridCells } = getState();
            gridCells.delete(elem);
            dispatch($58d14c3de517b7e4$var$reconcile(elem));
        };
    const $58d14c3de517b7e4$var$focusCellOld = (elem)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const { gridCells: gridCells, rovingCell: rovingCell } = getState();
            if (gridCells.has(elem)) {
                setState({
                    focusedCell: elem
                });
                if (elem !== rovingCell) dispatch($58d14c3de517b7e4$var$rove(rovingCell, elem));
            }
        };
    const $58d14c3de517b7e4$var$focusCell = (cell, focusing)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const { gridCells: gridCells, rovingCell: rovingCell, isNavigationEnabled: isNavigationEnabled } = getState();
            if (isNavigationEnabled && gridCells.has(focusing)) {
                setState({
                    focusedCell: focusing
                });
                if (focusing !== rovingCell) dispatch($58d14c3de517b7e4$var$rove(rovingCell, focusing));
            } else if (isNavigationEnabled && cell.contains(focusing)) {
                setState({
                    focusedCell: cell
                });
                if (cell !== rovingCell) dispatch($58d14c3de517b7e4$var$rove(rovingCell, cell));
            } else if (!isNavigationEnabled && rovingCell) {
                const cellContent = gridCells.get(rovingCell)?.getContent();
                const isContentToFocus = cellContent && cellContent.length > 0;
                if (isContentToFocus && focusing === rovingCell) cellContent[cellContent.length - 1].focus();
                else if (isContentToFocus && !rovingCell.contains(focusing)) cellContent[0].focus();
            }
        };
    const $58d14c3de517b7e4$var$blurCell = (blurring)=>({ getState: getState, setState: setState })=>{
            const { gridCells: gridCells, focusedCell: focusedCell } = getState();
            if (gridCells.has(blurring) && focusedCell === blurring) setState({
                focusedCell: undefined
            });
        };
    const $58d14c3de517b7e4$var$navigateCell = (type, { ctrlKey: ctrlKey })=>({ getState: getState, dispatch: dispatch })=>{
            const { isNavigationEnabled: isNavigationEnabled, gridCells: gridCells, focusedCell: focusedCell } = getState();
            if (!isNavigationEnabled && (0, (0, parcelRequire("4R6GH")).fg)('timeline_grid_navigation_m2')) return;
            if (!focusedCell) return;
            let nextCell;
            switch(type){
                case 'ArrowLeft':
                    nextCell = gridCells.getBefore(focusedCell);
                    break;
                case 'ArrowRight':
                    nextCell = gridCells.getAfter(focusedCell);
                    break;
                case 'ArrowUp':
                    nextCell = gridCells.getAbove(focusedCell);
                    break;
                case 'ArrowDown':
                    nextCell = gridCells.getBelow(focusedCell);
                    break;
                case 'PageUp':
                    nextCell = gridCells.getAbove(focusedCell, (0, $d9d2477c67cdc919$export$25f3022e3913e948));
                    break;
                case 'PageDown':
                    nextCell = gridCells.getBelow(focusedCell, (0, $d9d2477c67cdc919$export$25f3022e3913e948));
                    break;
                case 'Home':
                    nextCell = gridCells.getStart(focusedCell, ctrlKey);
                    break;
                case 'End':
                    nextCell = gridCells.getEnd(focusedCell, ctrlKey);
                    break;
                default:
                    break;
            }
            if (nextCell && nextCell !== focusedCell) {
                dispatch($58d14c3de517b7e4$var$rove(focusedCell, nextCell));
                nextCell.focus();
            }
        };
    const $58d14c3de517b7e4$var$setActiveCreateTrigger = (rowId, type, element)=>({ setState: setState })=>{
            if ((0, (0, parcelRequire("4R6GH")).fg)('timeline_grid_navigation_m2')) setState({
                isNavigationEnabled: true,
                activeCreateTrigger: {
                    rowId: rowId,
                    type: type,
                    element: element
                }
            });
            else setState({
                activeCreateTrigger: {
                    rowId: rowId,
                    type: type,
                    element: element
                }
            });
        };
    const $58d14c3de517b7e4$var$resetRovingCell = ()=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const { gridCells: gridCells, rovingCell: rovingCell } = getState();
            if (rovingCell) {
                const origin = gridCells.getClosestStartOrEnd(rovingCell);
                if (origin) {
                    setState({
                        isNavigationEnabled: true
                    });
                    dispatch($58d14c3de517b7e4$var$rove(rovingCell, origin));
                }
            }
        };
    const $58d14c3de517b7e4$var$removeActiveCreateTrigger = ()=>({ setState: setState })=>{
            setState({
                activeCreateTrigger: undefined
            });
        };
    const $58d14c3de517b7e4$var$focusCreateTrigger = ()=>({ getState: getState, setState: setState })=>{
            const activeCreateTrigger = getState().activeCreateTrigger;
            if (activeCreateTrigger && !(0, (0, parcelRequire("4R6GH")).fg)('timeline_grid_navigation_m2')) {
                setState({
                    activeCreateTrigger: undefined
                });
                activeCreateTrigger.element?.focus();
            } else if (activeCreateTrigger && (0, (0, parcelRequire("4R6GH")).fg)('timeline_grid_navigation_m2')) {
                activeCreateTrigger.element?.focus();
                setState({
                    isNavigationEnabled: false,
                    activeCreateTrigger: undefined
                });
            }
        };
    const $58d14c3de517b7e4$var$shouldPreventNavigation = (isNavigationPrevented)=>({ setState: setState })=>{
            setState({
                isNavigationPrevented: isNavigationPrevented
            });
        };
    const $58d14c3de517b7e4$export$e324594224ef24da = {
        enableNavigation: $58d14c3de517b7e4$var$enableNavigation,
        disableNavigation: $58d14c3de517b7e4$var$disableNavigation,
        shouldPreventNavigation: $58d14c3de517b7e4$var$shouldPreventNavigation,
        initialiseRovingCell: $58d14c3de517b7e4$var$initialiseRovingCell,
        resetRovingCell: $58d14c3de517b7e4$var$resetRovingCell,
        trackCell: $58d14c3de517b7e4$var$trackCell,
        untrackCell: $58d14c3de517b7e4$var$untrackCell,
        focusCellOld: $58d14c3de517b7e4$var$focusCellOld,
        focusCell: $58d14c3de517b7e4$var$focusCell,
        blurCell: $58d14c3de517b7e4$var$blurCell,
        navigateCell: $58d14c3de517b7e4$var$navigateCell,
        setActiveCreateTrigger: $58d14c3de517b7e4$var$setActiveCreateTrigger,
        focusCreateTrigger: $58d14c3de517b7e4$var$focusCreateTrigger,
        removeActiveCreateTrigger: $58d14c3de517b7e4$var$removeActiveCreateTrigger
    };
});
const $d9d2477c67cdc919$export$25f3022e3913e948 = 5;
parcelRegister("kon0h", function(module, exports) {
    $parcel$export(module.exports, "CellMap", ()=>$489e7d6098a5dd71$export$8c5f03eb5739ef16);
    var $4R6GH;
    var $73cx7;
    class $489e7d6098a5dd71$export$8c5f03eb5739ef16 extends Map {
        set(key, value) {
            this.isDirty = true;
            return super.set(key, value);
        }
        delete(key) {
            this.isDirty = true;
            return super.delete(key);
        }
        clear() {
            this.isDirty = true;
            return super.clear();
        }
        setIsDirty(value) {
            this.isDirty = value;
        }
        getBefore(key) {
            const cell = this.get(key);
            if (!cell) return;
            this.prepareCoordinates();
            const [column, row] = cell.getCoordinates();
            return this.getClosestByColumn(column - 1, row);
        }
        getAfter(key) {
            const cell = this.get(key);
            if (!cell) return;
            this.prepareCoordinates();
            const [column, row] = cell.getCoordinates();
            return this.getClosestByColumn(column + 1, row);
        }
        getAbove(key, offset = 1) {
            const cell = this.get(key);
            if (!cell) return;
            this.prepareCoordinates();
            const [column, row] = cell.getCoordinates();
            return this.getClosestByRow(column, row - offset);
        }
        getBelow(key, offset = 1) {
            const cell = this.get(key);
            if (!cell) return;
            this.prepareCoordinates();
            const [column, row] = cell.getCoordinates();
            return this.getClosestByRow(column, row + offset);
        }
        getStart(key, isGlobal = false) {
            this.prepareCoordinates();
            const cell = this.get(key);
            if (isGlobal || !cell) return this.elementLookup.get((0, (0, parcelRequire("73cx7")).coordToString)(...this.globalMin));
            const [, row] = cell.getCoordinates();
            const columnBoundary = this.columnBoundaries.get(row);
            if (columnBoundary) return this.getClosestByColumn(columnBoundary.min, row);
        }
        getEnd(key, isGlobal = false) {
            this.prepareCoordinates();
            const cell = this.get(key);
            if (isGlobal || !cell) return this.elementLookup.get((0, (0, parcelRequire("73cx7")).coordToString)(...this.globalMax));
            const [, row] = cell.getCoordinates();
            const columnBoundary = this.columnBoundaries.get(row);
            if (columnBoundary) return this.getClosestByColumn(columnBoundary.max, row);
        }
        getClosestStartOrEnd(key) {
            const cell = this.get(key);
            if (!cell) return;
            this.prepareCoordinates();
            const [column, row] = cell.getCoordinates();
            const rowBoundary = this.rowBoundaries.get(column);
            if (rowBoundary) {
                const isClosestToStart = Math.abs(row - rowBoundary.min) <= Math.abs(row - rowBoundary.max);
                return isClosestToStart ? this.getStart(key, true) : this.getEnd(key, true);
            }
        }
        clean() {
            this.elementLookup.clear();
            this.rowBoundaries.clear();
            this.columnBoundaries.clear();
            this.globalMin = [
                0,
                0
            ];
            this.globalMax = [
                0,
                0
            ];
            this.isDirty = false;
        }
        prepareCoordinates() {
            if (!this.isDirty) return;
            this.clean();
            for (const [key, value] of this){
                const [column, row] = value.getCoordinates();
                this.elementLookup.set((0, (0, parcelRequire("73cx7")).coordToString)(column, row), key);
                const rowBoundary = this.rowBoundaries.get(column);
                const columnBoundary = this.columnBoundaries.get(row);
                if (rowBoundary === undefined) this.rowBoundaries.set(column, {
                    min: row,
                    max: row
                });
                else {
                    const min = Math.min(rowBoundary.min, row);
                    const max = Math.max(rowBoundary.max, row);
                    this.rowBoundaries.set(column, {
                        min: min,
                        max: max
                    });
                }
                if (columnBoundary === undefined) this.columnBoundaries.set(row, {
                    min: column,
                    max: column
                });
                else {
                    const min = Math.min(columnBoundary.min, column);
                    const max = Math.max(columnBoundary.max, column);
                    this.columnBoundaries.set(row, {
                        min: min,
                        max: max
                    });
                }
                if (row <= this.globalMin[1]) {
                    const updatedColumnBoundary = this.columnBoundaries.get(row);
                    const minColumn = updatedColumnBoundary?.min ?? this.globalMin[0];
                    this.globalMin = [
                        minColumn,
                        row
                    ];
                }
                if (row >= this.globalMax[1]) {
                    const updatedColumnBoundary = this.columnBoundaries.get(row);
                    const maxColumn = updatedColumnBoundary?.max ?? this.globalMax[0];
                    this.globalMax = [
                        maxColumn,
                        row
                    ];
                }
            }
        }
        getClosestByRow(column, row) {
            const happyCell = this.elementLookup.get((0, (0, parcelRequire("73cx7")).coordToString)(column, row));
            if (happyCell) return happyCell;
            const columnBoundary = this.columnBoundaries.get(row);
            const rowBoundary = this.rowBoundaries.get(column);
            if (columnBoundary) {
                const clampedColumn = columnBoundary.max;
                return this.elementLookup.get((0, (0, parcelRequire("73cx7")).coordToString)(clampedColumn, row));
            }
            if (rowBoundary && (row > rowBoundary.max || row < rowBoundary.min)) {
                const isClosestToStart = Math.abs(row - rowBoundary.min) <= Math.abs(row - rowBoundary.max);
                const closestRow = isClosestToStart ? rowBoundary.min : rowBoundary.max;
                return this.elementLookup.get((0, (0, parcelRequire("73cx7")).coordToString)(column, closestRow));
            }
            if (rowBoundary && row <= rowBoundary.max && row >= rowBoundary.min && (0, (0, parcelRequire("4R6GH")).fg)('timeline_grid_navigation_m2')) {
                const possibleRows = [];
                for (const [, value] of this){
                    const coordinates = value.getCoordinates();
                    if (coordinates[0] === column && coordinates[1] > row) possibleRows.push(coordinates[1]);
                }
                const fastSortArray = Uint32Array.from(possibleRows).sort();
                return this.elementLookup.get((0, (0, parcelRequire("73cx7")).coordToString)(column, fastSortArray[0]));
            }
            return undefined;
        }
        getClosestByColumn(column, row) {
            return this.elementLookup.get((0, (0, parcelRequire("73cx7")).coordToString)(column, row));
        }
        constructor(...args){
            super(...args);
            this.isDirty = false;
            this.elementLookup = new Map();
            this.rowBoundaries = new Map();
            this.columnBoundaries = new Map();
            this.globalMin = [
                0,
                0
            ];
            this.globalMax = [
                0,
                0
            ];
        }
    }
});
parcelRegister("73cx7", function(module, exports) {
    $parcel$export(module.exports, "coordToString", ()=>$f9b93de51acf695d$export$ad1ba9454d886ee3);
    const $f9b93de51acf695d$export$ad1ba9454d886ee3 = (column, row)=>String([
            column,
            row
        ]);
});
parcelRegister("1osZ4", function(module, exports) {
    $parcel$export(module.exports, "isCreateTriggerActiveForItem", ()=>$cd0c6342bed88239$export$e90c69d47d50701f);
    $parcel$export(module.exports, "isNavigationEnabled", ()=>$cd0c6342bed88239$export$146dfdd989f678b);
    $parcel$export(module.exports, "isNavigationPrevented", ()=>$cd0c6342bed88239$export$627dcd18967df965);
    const $cd0c6342bed88239$export$e90c69d47d50701f = (state, { id: id, type: type })=>{
        const activeCreateTrigger = state.activeCreateTrigger;
        if (activeCreateTrigger) return activeCreateTrigger.rowId === id && activeCreateTrigger.type === type;
    };
    const $cd0c6342bed88239$export$146dfdd989f678b = (state)=>state.isNavigationEnabled;
    const $cd0c6342bed88239$export$627dcd18967df965 = (state)=>state.isNavigationPrevented;
});
parcelRegister("7de6U", function(module, exports) {
    $parcel$export(module.exports, "GridOld", ()=>$9902ab059fcf964a$export$9e141a01a3e47f8e);
    $parcel$export(module.exports, "Grid", ()=>$9902ab059fcf964a$export$ef2184bd89960b14);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $WPwAA;
    var $hGh1Z;
    var $cvOvx;
    const $9902ab059fcf964a$export$9e141a01a3e47f8e = ({ scope: scope, ariaMultiselectable: ariaMultiselectable, ariaLabel: ariaLabel, ariaReadOnly: ariaReadOnly, children: children })=>{
        const [ariaRowCount] = (0, (0, parcelRequire("hGh1Z")).useAriaRowCount)();
        const eventHandlers = (0, (0, parcelRequire("cvOvx")).useGridContainerOld)();
        const [{ isMultiSelectEnabled: isMultiSelectEnabled }] = (0, (0, parcelRequire("WPwAA")).useEnablements)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            role: "grid",
            "aria-rowcount": ariaRowCount,
            "aria-multiselectable": (0, (0, parcelRequire("4R6GH")).fg)('project_timeline_multi-select_and_checkboxes') ? isMultiSelectEnabled || undefined : ariaMultiselectable,
            "aria-label": ariaLabel,
            "aria-readonly": ariaReadOnly,
            className: scope,
            ...eventHandlers
        }, children);
    };
    const $9902ab059fcf964a$export$ef2184bd89960b14 = ({ scope: scope, ariaMultiselectable: ariaMultiselectable, ariaLabel: ariaLabel, ariaReadOnly: ariaReadOnly, children: children })=>{
        const [ariaRowCount] = (0, (0, parcelRequire("hGh1Z")).useAriaRowCount)();
        const containerProps = (0, (0, parcelRequire("cvOvx")).useGridContainer)();
        const [{ isMultiSelectEnabled: isMultiSelectEnabled }] = (0, (0, parcelRequire("WPwAA")).useEnablements)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            role: "grid",
            "aria-rowcount": ariaRowCount,
            "aria-multiselectable": (0, (0, parcelRequire("4R6GH")).fg)('project_timeline_multi-select_and_checkboxes') ? isMultiSelectEnabled || undefined : ariaMultiselectable,
            "aria-label": ariaLabel,
            "aria-readonly": ariaReadOnly,
            className: scope,
            ...containerProps
        }, children);
    };
});
parcelRegister("cvOvx", function(module, exports) {
    $parcel$export(module.exports, "useGridContainer", ()=>$351d3b3ca22da7aa$export$89cacf57f4ae1143);
    $parcel$export(module.exports, "useGridContainerOld", ()=>$351d3b3ca22da7aa$export$ed776ebfb0fadaa3);
    var $5uXOq = parcelRequire("5uXOq");
    var $82CeN;
    const $351d3b3ca22da7aa$var$isElementInGrid = (grid, target)=>{
        let current = target;
        while(current){
            if (current === grid) return true;
            current = current.parentElement;
        }
        return false;
    };
    const $351d3b3ca22da7aa$export$89cacf57f4ae1143 = ()=>{
        const element = (0, $5uXOq.useRef)(null);
        const { enableNavigation: enableNavigation, disableNavigation: disableNavigation, navigateCell: navigateCell, resetRovingCell: resetRovingCell } = (0, (0, parcelRequire("82CeN")).useFocusMarshal)();
        const isNavigationEnabled = (0, (0, parcelRequire("82CeN")).useIsNavigationEnabled)();
        const isNavigationPrevented = (0, (0, parcelRequire("82CeN")).useIsNavigationPrevented)();
        const setGridRef = (0, $5uXOq.useCallback)((ref)=>{
            element.current = ref;
        }, []);
        const onKeyDown = (0, $5uXOq.useCallback)((event)=>{
            const { key: key, ctrlKey: ctrlKey } = event;
            if (isNavigationPrevented) return;
            switch(key){
                case 'Enter':
                    if (isNavigationEnabled) {
                        event.preventDefault();
                        disableNavigation();
                    }
                    break;
                case 'Escape':
                    if (!isNavigationEnabled) {
                        event.preventDefault();
                        enableNavigation();
                    }
                    break;
                case 'ArrowLeft':
                case 'ArrowRight':
                case 'ArrowUp':
                case 'ArrowDown':
                case 'PageUp':
                case 'PageDown':
                case 'Home':
                case 'End':
                    if (isNavigationEnabled) {
                        event.preventDefault();
                        navigateCell(key, {
                            ctrlKey: ctrlKey
                        });
                    }
                    break;
                default:
                    break;
            }
        }, [
            isNavigationPrevented,
            isNavigationEnabled,
            disableNavigation,
            enableNavigation,
            navigateCell
        ]);
        const onKeyUp = (0, $5uXOq.useCallback)(({ key: key })=>{
            if (isNavigationPrevented) return;
            switch(key){
                case 'Tab':
                    if (isNavigationEnabled) disableNavigation({
                        autofocus: false
                    });
                    break;
                default:
                    break;
            }
        }, [
            isNavigationEnabled,
            isNavigationPrevented,
            disableNavigation
        ]);
        const onBlur = (0, $5uXOq.useCallback)(({ relatedTarget: relatedTarget })=>{
            if (isNavigationPrevented) return;
            if (element.current && relatedTarget instanceof HTMLElement && !$351d3b3ca22da7aa$var$isElementInGrid(element.current, relatedTarget)) resetRovingCell();
        }, [
            isNavigationPrevented,
            resetRovingCell
        ]);
        return {
            ref: setGridRef,
            onKeyDown: onKeyDown,
            onKeyUp: onKeyUp,
            onBlur: onBlur
        };
    };
    const $351d3b3ca22da7aa$export$ed776ebfb0fadaa3 = ()=>{
        const { focusCellOld: focusCellOld, blurCell: blurCell, navigateCell: navigateCell } = (0, (0, parcelRequire("82CeN")).useFocusMarshal)();
        const onFocus = (0, $5uXOq.useCallback)((event)=>{
            if (event.target instanceof HTMLElement) focusCellOld(event.target);
        }, [
            focusCellOld
        ]);
        const onBlur = (0, $5uXOq.useCallback)((event)=>{
            if (event.target instanceof HTMLElement) blurCell(event.target);
        }, [
            blurCell
        ]);
        const onKeyDown = (0, $5uXOq.useCallback)((event)=>{
            const { key: key, ctrlKey: ctrlKey } = event;
            switch(key){
                case 'ArrowLeft':
                case 'ArrowRight':
                case 'ArrowUp':
                case 'ArrowDown':
                case 'PageUp':
                case 'PageDown':
                case 'Home':
                case 'End':
                    event.preventDefault();
                    navigateCell(key, {
                        ctrlKey: ctrlKey
                    });
                    break;
                default:
                    break;
            }
        }, [
            navigateCell
        ]);
        return {
            onKeyDown: onKeyDown,
            onFocus: onFocus,
            onBlur: onBlur
        };
    };
});
parcelRegister("7OK0c", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2891709b7dcc590c$export$2e2bcd8739ae039);
    var $7VHMR;
    var $2891709b7dcc590c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        defaultLabel: {
            id: 'roadmap.timeline-table.common.context.side-effect-marshal.default-label',
            defaultMessage: 'Timeline',
            description: "Default label for assistive technology. Describes in short the purpose of the Timeline's table component"
        }
    });
});
parcelRegister("hS1s8", function(module, exports) {
    $parcel$export(module.exports, "ROW_STATES", ()=>$1ecc5aefc8a6d1ca$export$d17c451ccb229dcb);
    $parcel$export(module.exports, "VALID_INITIAL_STATES", ()=>$1ecc5aefc8a6d1ca$export$43acf26460204930);
    $parcel$export(module.exports, "VALID_TRANSITIONS", ()=>$1ecc5aefc8a6d1ca$export$682b071fc4ac4b0c);
    $parcel$export(module.exports, "DEFAULT_COUNTS", ()=>$1ecc5aefc8a6d1ca$export$ccc216ff57ae82b9);
    const $1ecc5aefc8a6d1ca$export$d17c451ccb229dcb = {
        FOCUSED: 'FOCUSED',
        SELECTED: 'SELECTED',
        DRAGGED: 'DRAGGED',
        DRAGGED_OUT: 'DRAGGED_OUT',
        DRAGGED_OVER: 'DRAGGED_OVER'
    };
    const $1ecc5aefc8a6d1ca$export$43acf26460204930 = {
        FOCUSED: true,
        SELECTED: true,
        DRAGGED: true,
        DRAGGED_OUT: false,
        DRAGGED_OVER: false
    };
    const $1ecc5aefc8a6d1ca$export$682b071fc4ac4b0c = {
        FOCUSED: {
            SELECTED: true,
            DRAGGED: true
        },
        SELECTED: {
            DRAGGED: true
        },
        DRAGGED: {
            SELECTED: true,
            DRAGGED_OUT: true,
            DRAGGED_OVER: true
        },
        DRAGGED_OUT: {
            SELECTED: true,
            DRAGGED_OVER: true
        },
        DRAGGED_OVER: {
            SELECTED: true,
            DRAGGED_OUT: true
        }
    };
    const $1ecc5aefc8a6d1ca$export$ccc216ff57ae82b9 = {
        FOCUSED: 0,
        SELECTED: 0,
        DRAGGED: 0,
        DRAGGED_OUT: 0,
        DRAGGED_OVER: 0
    };
});
parcelRegister("ehMvl", function(module, exports) {
    $parcel$export(module.exports, "useRowState", ()=>$b70c7282056e1f4e$export$b2440517e54eabc);
    var $5uXOq = parcelRequire("5uXOq");
    var $2NMNM;
    var $hUAzM;
    var $hS1s8;
    const $b70c7282056e1f4e$export$b2440517e54eabc = ()=>{
        const rowState = (0, $5uXOq.useRef)({});
        const stateCount = (0, $5uXOq.useRef)({
            ...(0, (0, parcelRequire("hS1s8")).DEFAULT_COUNTS)
        });
        const previouslySelected = (0, $5uXOq.useRef)({});
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const fireInvalidRowTransitionEvent = (0, $5uXOq.useCallback)((message)=>{
            const event = createAnalyticsEvent({
                action: 'invalidRowTransition',
                actionSubject: 'timelineTable.sideEffectMarshall',
                attributes: {
                    message: message
                }
            });
            (0, (0, parcelRequire("hUAzM")).fireOperationalAnalyticsEvent)(event);
        }, [
            createAnalyticsEvent
        ]);
        const fireEmptyRowEntryEvent = (0, $5uXOq.useCallback)(()=>{
            const event = createAnalyticsEvent({
                action: 'emptyRowEntry',
                actionSubject: 'timelineTable.sideEffectMarshall'
            });
            (0, (0, parcelRequire("hUAzM")).fireOperationalAnalyticsEvent)(event);
        }, [
            createAnalyticsEvent
        ]);
        const updateStateCount = (0, $5uXOq.useCallback)((currentState, nextState)=>{
            if (currentState) stateCount.current[currentState] -= 1;
            if (nextState) stateCount.current[nextState] += 1;
        }, []);
        const isAnyRowDragging = (0, $5uXOq.useCallback)(()=>stateCount.current[(0, (0, parcelRequire("hS1s8")).ROW_STATES).DRAGGED] > 0 || stateCount.current[(0, (0, parcelRequire("hS1s8")).ROW_STATES).DRAGGED_OVER] > 0 || stateCount.current[(0, (0, parcelRequire("hS1s8")).ROW_STATES).DRAGGED_OUT] > 0, []);
        const updatePreviouslySelected = (0, $5uXOq.useCallback)((id, currentState, nextState)=>{
            if (nextState && currentState === (0, (0, parcelRequire("hS1s8")).ROW_STATES).SELECTED) previouslySelected.current[id] = true;
            if (!nextState || nextState === (0, (0, parcelRequire("hS1s8")).ROW_STATES).SELECTED) delete previouslySelected.current[id];
        }, []);
        const wasRowSelected = (0, $5uXOq.useCallback)((id)=>previouslySelected.current[id] ?? false, []);
        const get = (0, $5uXOq.useCallback)((id)=>rowState.current[id], []);
        const set = (0, $5uXOq.useCallback)((id, nextState)=>{
            const currentState = get(id);
            if (!currentState && (0, (0, parcelRequire("hS1s8")).VALID_INITIAL_STATES)[nextState] || currentState && (0, (0, parcelRequire("hS1s8")).VALID_TRANSITIONS)[currentState][nextState]) {
                updateStateCount(currentState, nextState);
                updatePreviouslySelected(id, currentState, nextState);
                rowState.current[id] = nextState;
            } else if (currentState !== nextState) fireInvalidRowTransitionEvent(`Invalid transition from ${currentState} to ${nextState}`);
        }, [
            get,
            updateStateCount,
            updatePreviouslySelected,
            fireInvalidRowTransitionEvent
        ]);
        const clear = (0, $5uXOq.useCallback)((id)=>{
            const currentState = get(id);
            if (currentState) {
                updateStateCount(currentState);
                updatePreviouslySelected(id, currentState);
                delete rowState.current[id];
            } else fireEmptyRowEntryEvent();
        }, [
            get,
            updateStateCount,
            updatePreviouslySelected,
            fireEmptyRowEntryEvent
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                get: get,
                set: set,
                clear: clear,
                isAnyRowDragging: isAnyRowDragging,
                wasRowSelected: wasRowSelected
            }), [
            get,
            set,
            clear,
            isAnyRowDragging,
            wasRowSelected
        ]);
    };
});
parcelRegister("hUAzM", function(module, exports) {
    $parcel$export(module.exports, "fireOperationalAnalyticsEvent", ()=>$5566e8787897db11$export$4e7937b444ac21e8);
    $parcel$export(module.exports, "fireUIAnalyticsEvent", ()=>$5566e8787897db11$export$47e016b53a5f0465);
    const $5566e8787897db11$var$EVENT_TYPES = {
        UI: 'UI',
        TRACK: 'TRACK',
        SCREEN: 'SCREEN',
        OPERATIONAL: 'OPERATIONAL'
    };
    const $5566e8787897db11$var$createFireAnalytics = (analyticsType)=>(event)=>{
            const clonedEvent = event.clone();
            if (clonedEvent) clonedEvent.update({
                ...event.payload,
                analyticsType: analyticsType
            }).fire('productAnalytics');
        };
    const $5566e8787897db11$export$4e7937b444ac21e8 = $5566e8787897db11$var$createFireAnalytics($5566e8787897db11$var$EVENT_TYPES.OPERATIONAL);
    const $5566e8787897db11$export$47e016b53a5f0465 = $5566e8787897db11$var$createFireAnalytics($5566e8787897db11$var$EVENT_TYPES.UI);
});
parcelRegister("93fNo", function(module, exports) {
    $parcel$export(module.exports, "useStyleMarshal", ()=>$82aa8295b40d45f4$export$984a1617ce4cc44b);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $ghKWA;
    const $82aa8295b40d45f4$export$984a1617ce4cc44b = (scope)=>{
        const styleEl = (0, $5uXOq.useRef)();
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (typeof document !== 'undefined') {
                styleEl.current = document.createElement('style');
                styleEl.current.id = 'roadmap-data-styles';
                const head = document.querySelector('head');
                head && head.appendChild(styleEl.current);
            }
            return ()=>{
                styleEl.current?.parentNode?.removeChild(styleEl.current);
            };
        }, []);
        const styleUtils = (0, $5uXOq.useMemo)(()=>{
            const insertStyle = (className, rule)=>{
                removeStyle(className);
                addToStylesheet((0, (0, parcelRequire("ghKWA")).toSelector)(className), rule);
            };
            const removeStyle = (className)=>{
                if (!styleEl.current || !styleEl.current.sheet) return;
                const ruleIndex = (0, (0, parcelRequire("ghKWA")).getIndexBySelector)(scope, styleEl.current.sheet.cssRules, (0, (0, parcelRequire("ghKWA")).toSelector)(className));
                if (ruleIndex !== -1) styleEl.current.sheet.deleteRule(ruleIndex);
            };
            const updateStyle = (targetClassNames, style)=>{
                if (!styleEl.current || !styleEl.current.sheet) return;
                const ruleIndex = (0, (0, parcelRequire("ghKWA")).getIndexByRule)(styleEl.current.sheet.cssRules, style);
                const selectors = (0, (0, parcelRequire("ghKWA")).toSelectors)(targetClassNames, scope);
                ruleIndex !== -1 && styleEl.current.sheet.deleteRule(ruleIndex);
                if (selectors.length > 0) styleEl.current.sheet.insertRule(`${selectors.join(', ')} {${(0, (0, parcelRequire("ghKWA")).toRule)(style)}}`, styleEl.current.sheet.cssRules.length);
            };
            const addToStylesheet = (selector, rule)=>{
                styleEl.current?.sheet?.insertRule(`.${scope} ${String(selector)} {${rule.replace('\n', ' ')}}`, styleEl.current.sheet.cssRules.length);
            };
            return {
                insertStyle: insertStyle,
                removeStyle: removeStyle,
                updateStyle: updateStyle
            };
        }, [
            scope
        ]);
        const styleAPI = (0, $5uXOq.useMemo)(()=>{
            const hoverRow = (id)=>{
                styleUtils.insertStyle((0, (0, parcelRequire("ghKWA")).classNames).row(id), (0, (0, parcelRequire("ghKWA")).styles).itemHover);
            };
            const leaveRow = (id)=>{
                styleUtils.removeStyle((0, (0, parcelRequire("ghKWA")).classNames).row(id));
            };
            const selectRow = (ids)=>{
                const selectedClasses = ids.map((id)=>(0, (0, parcelRequire("ghKWA")).classNames).row(id));
                styleUtils.updateStyle([], (0, (0, parcelRequire("ghKWA")).styles).itemHover);
                styleUtils.updateStyle(selectedClasses, (0, (0, parcelRequire("ghKWA")).styles).itemSelected);
            };
            const deselectRow = ()=>{
                styleUtils.updateStyle([], (0, (0, parcelRequire("ghKWA")).styles).itemSelected);
            };
            const dragRow = (id)=>{
                styleUtils.removeStyle((0, (0, parcelRequire("ghKWA")).classNames).inlineCreate);
                styleUtils.insertStyle((0, (0, parcelRequire("ghKWA")).classNames).row(id), (0, (0, parcelRequire("ghKWA")).styles).itemDragging);
                styleUtils.insertStyle((0, (0, parcelRequire("ghKWA")).classNames).rowChild(id), (0, (0, parcelRequire("ghKWA")).styles).itemDragging);
                styleUtils.insertStyle((0, (0, parcelRequire("ghKWA")).classNames).itemsContainer, (0, (0, parcelRequire("ghKWA")).styles).itemsContainerDragging);
            };
            const dropRow = (id, wasSelected)=>{
                styleUtils.removeStyle((0, (0, parcelRequire("ghKWA")).classNames).createChild);
                styleUtils.removeStyle((0, (0, parcelRequire("ghKWA")).classNames).row(id));
                styleUtils.removeStyle((0, (0, parcelRequire("ghKWA")).classNames).rowChild(id));
                styleUtils.removeStyle((0, (0, parcelRequire("ghKWA")).classNames).dragIndicator);
                styleUtils.removeStyle((0, (0, parcelRequire("ghKWA")).classNames).itemsContainer);
                wasSelected && styleUtils.insertStyle((0, (0, parcelRequire("ghKWA")).classNames).row(id), (0, (0, parcelRequire("ghKWA")).styles).itemSelected);
            };
            const showDragIndicator = (top, left)=>{
                styleUtils.insertStyle((0, (0, parcelRequire("ghKWA")).classNames).dragIndicator, (0, (0, parcelRequire("ghKWA")).styles).getDragIndicator(top, left));
            };
            const dragOverParent = (parentId, isSelected)=>{
                styleUtils.removeStyle((0, (0, parcelRequire("ghKWA")).classNames).dragIndicator);
                const style = isSelected ? (0, (0, parcelRequire("ghKWA")).styles).selectedItemCanBeCombined : (0, (0, parcelRequire("ghKWA")).styles).itemCanBeCombined;
                styleUtils.updateStyle([
                    (0, (0, parcelRequire("ghKWA")).classNames).row(parentId)
                ], style);
            };
            const dragOutOfBounds = ()=>{
                styleUtils.removeStyle((0, (0, parcelRequire("ghKWA")).classNames).dragIndicator);
            };
            const showInlineCreate = (top, tabFocused)=>{
                styleUtils.insertStyle((0, (0, parcelRequire("ghKWA")).classNames).inlineCreate, (0, (0, parcelRequire("ghKWA")).styles).getInlineCreateButton(top));
                if (tabFocused) styleUtils.insertStyle((0, (0, parcelRequire("ghKWA")).classNames).inlineCreateIcon, (0, (0, parcelRequire("ghKWA")).styles).getInlineCreateIcon());
                if (!tabFocused && (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y')) styleUtils.removeStyle((0, (0, parcelRequire("ghKWA")).classNames).inlineCreateIcon);
            };
            const hideInlineCreate = ()=>{
                styleUtils.removeStyle((0, (0, parcelRequire("ghKWA")).classNames).inlineCreate);
                styleUtils.removeStyle((0, (0, parcelRequire("ghKWA")).classNames).inlineCreateIcon);
            };
            const hideChildCreate = ()=>{
                styleUtils.insertStyle((0, (0, parcelRequire("ghKWA")).classNames).createChild, (0, (0, parcelRequire("ghKWA")).styles).itemDragging);
            };
            const blockPointerEvents = ()=>{
                styleUtils.insertStyle((0, (0, parcelRequire("ghKWA")).classNames).itemsContainer, (0, (0, parcelRequire("ghKWA")).styles).itemsContainerScrolling);
            };
            const allowPointerEvents = ()=>{
                styleAPI.removeStyle((0, (0, parcelRequire("ghKWA")).classNames).itemsContainer);
            };
            return {
                ...styleUtils,
                hoverRow: hoverRow,
                leaveRow: leaveRow,
                selectRow: selectRow,
                deselectRow: deselectRow,
                dragRow: dragRow,
                dropRow: dropRow,
                showDragIndicator: showDragIndicator,
                dragOverParent: dragOverParent,
                dragOutOfBounds: dragOutOfBounds,
                showInlineCreate: showInlineCreate,
                hideInlineCreate: hideInlineCreate,
                hideChildCreate: hideChildCreate,
                blockPointerEvents: blockPointerEvents,
                allowPointerEvents: allowPointerEvents
            };
        }, [
            styleUtils
        ]);
        return styleAPI;
    };
});
parcelRegister("ghKWA", function(module, exports) {
    $parcel$export(module.exports, "getIndexBySelector", ()=>$b963b9a538f75606$export$531566c459a9453);
    $parcel$export(module.exports, "getIndexByRule", ()=>$b963b9a538f75606$export$5e88903c48b9b53);
    $parcel$export(module.exports, "toRule", ()=>$b963b9a538f75606$export$f9a10e11cef4ed80);
    $parcel$export(module.exports, "toSelector", ()=>$b963b9a538f75606$export$fef48429545ba792);
    $parcel$export(module.exports, "toSelectors", ()=>$b963b9a538f75606$export$fea3972019a1b6b0);
    $parcel$export(module.exports, "classNames", ()=>$b963b9a538f75606$export$ce4ab0c55987d1ff);
    $parcel$export(module.exports, "styles", ()=>$b963b9a538f75606$export$9dd6ff9ea0189349);
    $parcel$export(module.exports, "getDragIndicatorClassName", ()=>$b963b9a538f75606$export$5295be4f68791c03);
    $parcel$export(module.exports, "getInlineCreateButtonClassName", ()=>$b963b9a538f75606$export$c6b1c9f0aaabd326);
    $parcel$export(module.exports, "getInlineCreateIconClassName", ()=>$b963b9a538f75606$export$36993ff9ff59e588);
    $parcel$export(module.exports, "getItemsBackgroundClassName", ()=>$b963b9a538f75606$export$db96af0fdcbdbc30);
    $parcel$export(module.exports, "getCreateChildButtonClassName", ()=>$b963b9a538f75606$export$30e1e4b30ec4d53);
    $parcel$export(module.exports, "getRowClassName", ()=>$b963b9a538f75606$export$d435f2dd2e4838a0);
    const $b963b9a538f75606$export$5a544e13ad4e1fa5 = (hexColor, alpha = 1)=>{
        const parsed = hexColor.match(/[a-f0-9]{2}/gi);
        if (!parsed || parsed && parsed.length !== 3 || hexColor.indexOf('#') < 0) return hexColor;
        const rgb = parsed.map((hex)=>parseInt(hex, 16));
        if (alpha < 1 && alpha >= 0) return `rgba(${rgb.concat(alpha).join(',')})`;
        return `rgb(${rgb.join()})`;
    };
    const $b963b9a538f75606$export$307b18b61172f7ed = (className)=>({
            className: Array.isArray(className) ? className.join(' ') : className
        });
    const $b963b9a538f75606$export$531566c459a9453 = (scope, cssRules, target)=>Array.from(cssRules || []).findIndex((cssRule)=>'selectorText' in cssRule && cssRule.selectorText === `.${scope} ${target}`);
    const $b963b9a538f75606$export$5e88903c48b9b53 = (cssRules, target)=>Array.from(cssRules || []).findIndex(({ cssText: cssText })=>$b963b9a538f75606$export$f9a10e11cef4ed80(cssText).endsWith(`{${$b963b9a538f75606$export$f9a10e11cef4ed80(target)}}`));
    const $b963b9a538f75606$export$fef48429545ba792 = (className)=>`.${className}`;
    const $b963b9a538f75606$export$fea3972019a1b6b0 = (targetClassNames, scope)=>targetClassNames.map((className)=>`.${scope} .${className}`);
    const $b963b9a538f75606$export$f9a10e11cef4ed80 = (style)=>style.replace(/#\w+/g, (hexColor)=>$b963b9a538f75606$export$5a544e13ad4e1fa5(hexColor)).replace(/[\r\n\s]/g, '');
    const $b963b9a538f75606$var$row = (id)=>`row-${id}`;
    const $b963b9a538f75606$var$rowChild = (id)=>`row-child-${id}`;
    const $b963b9a538f75606$var$inlineCreate = 'inline-create-button';
    const $b963b9a538f75606$var$inlineCreateIcon = 'inline-create-button-icon';
    const $b963b9a538f75606$var$dragIndicator = 'inline-drag-indicator';
    const $b963b9a538f75606$var$dragIndicatorTop = 'inline-drag-indicator-top';
    const $b963b9a538f75606$var$itemsContainer = 'items-container';
    const $b963b9a538f75606$var$createChild = 'create-child-button';
    const $b963b9a538f75606$export$ce4ab0c55987d1ff = {
        row: $b963b9a538f75606$var$row,
        rowChild: $b963b9a538f75606$var$rowChild,
        inlineCreate: $b963b9a538f75606$var$inlineCreate,
        inlineCreateIcon: $b963b9a538f75606$var$inlineCreateIcon,
        dragIndicator: $b963b9a538f75606$var$dragIndicator,
        dragIndicatorTop: $b963b9a538f75606$var$dragIndicatorTop,
        itemsContainer: $b963b9a538f75606$var$itemsContainer,
        createChild: $b963b9a538f75606$var$createChild
    };
    const $b963b9a538f75606$var$itemHover = `
    background-color: ${`var(--ds-background-neutral-subtle-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`} !important;
`;
    const $b963b9a538f75606$var$itemSelected = `
    background-color: ${`var(--ds-background-selected, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`} !important;
`;
    const $b963b9a538f75606$var$itemDragging = `
    opacity: 0;
`;
    const $b963b9a538f75606$var$itemsContainerDragging = `
    background: ${`var(--ds-surface-pressed, ${(0, $829f609a65d26a98$export$8754fc7e6d8b3000)})`} !important;
`;
    const $b963b9a538f75606$var$itemsContainerScrolling = `
    pointer-events: none;
`;
    const $b963b9a538f75606$var$itemCanBeCombined = `
    background-color: ${`var(--ds-background-selected, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`} !important;
`;
    const $b963b9a538f75606$var$selectedItemCanBeCombined = `
    background-color: ${`var(--ds-background-selected-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`} !important;
`;
    const $b963b9a538f75606$var$getDragIndicator = (top, left)=>`
    display: block;
    position: fixed;
    right: 0;
    transform: ${left ? `translate(${left}px, ${top}px)` : `translateY(${top}px)`};
    pointer-events: none;
`;
    const $b963b9a538f75606$var$getInlineCreateButton = (top)=>`
    display: block;
    position: fixed;
    right: 0;
    transform: translateY(${top}px);
    pointer-events: none;
`;
    const $b963b9a538f75606$var$getInlineCreateIcon = ()=>`
	outline: 2px solid ${`var(--ds-border-focused, ${0, $829f609a65d26a98$export$e62e8919cca44969})`};
	outline-offset: 2px;
`;
    const $b963b9a538f75606$export$9dd6ff9ea0189349 = {
        itemHover: $b963b9a538f75606$var$itemHover,
        itemSelected: $b963b9a538f75606$var$itemSelected,
        itemDragging: $b963b9a538f75606$var$itemDragging,
        itemsContainerDragging: $b963b9a538f75606$var$itemsContainerDragging,
        itemsContainerScrolling: $b963b9a538f75606$var$itemsContainerScrolling,
        itemCanBeCombined: $b963b9a538f75606$var$itemCanBeCombined,
        selectedItemCanBeCombined: $b963b9a538f75606$var$selectedItemCanBeCombined,
        getDragIndicator: $b963b9a538f75606$var$getDragIndicator,
        getInlineCreateButton: $b963b9a538f75606$var$getInlineCreateButton,
        getInlineCreateIcon: $b963b9a538f75606$var$getInlineCreateIcon
    };
    const $b963b9a538f75606$export$5295be4f68791c03 = ()=>$b963b9a538f75606$export$307b18b61172f7ed([
            $b963b9a538f75606$var$dragIndicator,
            $b963b9a538f75606$var$dragIndicatorTop
        ]);
    const $b963b9a538f75606$export$c6b1c9f0aaabd326 = ()=>$b963b9a538f75606$export$307b18b61172f7ed($b963b9a538f75606$var$inlineCreate);
    const $b963b9a538f75606$export$36993ff9ff59e588 = ()=>$b963b9a538f75606$export$307b18b61172f7ed($b963b9a538f75606$var$inlineCreateIcon);
    const $b963b9a538f75606$export$db96af0fdcbdbc30 = ()=>$b963b9a538f75606$export$307b18b61172f7ed($b963b9a538f75606$var$itemsContainer);
    const $b963b9a538f75606$export$30e1e4b30ec4d53 = ()=>$b963b9a538f75606$export$307b18b61172f7ed($b963b9a538f75606$var$createChild);
    const $b963b9a538f75606$export$d435f2dd2e4838a0 = (id, parentId)=>{
        const classes = parentId !== undefined ? [
            $b963b9a538f75606$var$row(id),
            $b963b9a538f75606$var$rowChild(parentId)
        ] : $b963b9a538f75606$var$row(id);
        return $b963b9a538f75606$export$307b18b61172f7ed(classes);
    };
});
parcelRegister("2SP8o", function(module, exports) {
    $parcel$export(module.exports, "bindCustomActions", ()=>$ca453860589f2160$export$85d352c410f2eb84);
    $parcel$export(module.exports, "bindOverrideActions", ()=>$ca453860589f2160$export$d27110202ae8442b);
    const $ca453860589f2160$var$getPublicStyleAPI = (styleAPI)=>({
            insertStyle: styleAPI.insertStyle,
            removeStyle: styleAPI.removeStyle,
            updateStyle: styleAPI.updateStyle
        });
    const $ca453860589f2160$export$85d352c410f2eb84 = (customActions, styleAPI)=>Object.keys(customActions).reduce((acc, key)=>{
            acc[key] = customActions[key].bind(null, {
                styleAPI: $ca453860589f2160$var$getPublicStyleAPI(styleAPI)
            });
            return acc;
        }, {});
    const $ca453860589f2160$var$combineActions = (actionOne, actionTwo, styleAPI)=>(...args)=>{
            actionOne(...args);
            actionTwo?.bind(null, {
                styleAPI: $ca453860589f2160$var$getPublicStyleAPI(styleAPI)
            })(...args);
        };
    const $ca453860589f2160$export$d27110202ae8442b = (defaultActions, overrideActions, styleAPI)=>Object.keys(defaultActions).reduce((acc, key)=>{
            const defaults = defaultActions[key];
            const overrides = overrideActions[key];
            acc[key] = $ca453860589f2160$var$combineActions(defaults, overrides, styleAPI);
            return acc;
        }, {});
});
parcelRegister("lGdZu", function(module, exports) {
    $parcel$export(module.exports, "useTimelineViewportActions", ()=>$cf6bb10d35944ef2$export$93c2697e07ec9389);
    $parcel$export(module.exports, "useTimelineViewport", ()=>$cf6bb10d35944ef2$export$408aa890bc70d3dc);
    $parcel$export(module.exports, "TimelineViewportProvider", ()=>$cf6bb10d35944ef2$export$f521cde558624422);
    var $3sQ5x;
    var $gg7kZ;
    var $iXqE5;
    var $gO8Eu;
    const $cf6bb10d35944ef2$var$initialState = {
        left: 0,
        clientWidth: 0,
        indicatorLineOffset: 0
    };
    const $cf6bb10d35944ef2$export$d474af741f65a5d3 = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $cf6bb10d35944ef2$var$initialState,
        actions: (0, parcelRequire("gO8Eu")).actions,
        name: 'timeline-table.timeline-viewport'
    });
    const $cf6bb10d35944ef2$export$93c2697e07ec9389 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($cf6bb10d35944ef2$export$d474af741f65a5d3);
    const $cf6bb10d35944ef2$export$408aa890bc70d3dc = (0, (0, parcelRequire("3sQ5x")).createHook)($cf6bb10d35944ef2$export$d474af741f65a5d3);
    const $cf6bb10d35944ef2$export$f521cde558624422 = (0, (0, parcelRequire("gg7kZ")).createContainer)($cf6bb10d35944ef2$export$d474af741f65a5d3);
});
parcelRegister("gO8Eu", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$7d7b8bc61e5302e0$export$e324594224ef24da);
    var $8JuJr;
    const $7d7b8bc61e5302e0$export$e324594224ef24da = {
        onResize: (0, parcelRequire("8JuJr")).onResize
    };
});
parcelRegister("8JuJr", function(module, exports) {
    $parcel$export(module.exports, "onResize", ()=>$67bfbb484d77eed1$export$45b39e67d4ce4921);
    const $67bfbb484d77eed1$export$45b39e67d4ce4921 = (params)=>({ setState: setState })=>{
            setState({
                ...params
            });
        };
});
parcelRegister("biT18", function(module, exports) {
    $parcel$export(module.exports, "useTimelineState", ()=>$11ae6e482458e57a$export$f92f0bc83b35c17b);
    $parcel$export(module.exports, "TimelineProviderSweetState", ()=>$11ae6e482458e57a$export$4f33ace85fd289c5);
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    var $iZN6h;
    var $iwcO1;
    var $bFxJH;
    var $h5O3P;
    const $11ae6e482458e57a$var$initialState = {
        today: 0,
        timelineMode: (0, (0, parcelRequire("iZN6h")).MONTHS),
        timelineDuration: {
            startMilliseconds: 0,
            endMilliseconds: 0,
            totalMilliseconds: 0
        },
        timelineOrigin: 0,
        timelineWidth: 0,
        timelineOriginPosition: 0,
        columnDurations: [],
        columnPositions: []
    };
    const $11ae6e482458e57a$export$2ce7f0e10391f4 = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $11ae6e482458e57a$var$initialState,
        actions: (0, parcelRequire("h5O3P")).actions,
        name: 'timeline-table.timeline'
    });
    const $11ae6e482458e57a$export$f92f0bc83b35c17b = (0, (0, parcelRequire("3sQ5x")).createHook)($11ae6e482458e57a$export$2ce7f0e10391f4);
    const $11ae6e482458e57a$var$handleState = ()=>({ setState: setState }, timelineData)=>{
            const { timelineMode: timelineMode, timelineDuration: timelineDuration, timelineOrigin: timelineOrigin } = timelineData;
            const timelineWidth = (0, (0, parcelRequire("bFxJH")).getTimelineWidth)(timelineMode, timelineDuration.totalMilliseconds);
            const columnDurations = (0, (0, parcelRequire("iwcO1")).getColumnDurations)(timelineMode, timelineDuration);
            const columnPositions = (0, (0, parcelRequire("iwcO1")).getColumnPositions)(timelineDuration, columnDurations);
            const timelineOriginPosition = (0, (0, parcelRequire("bFxJH")).getTimelinePositionFromDate)(timelineDuration, timelineWidth, timelineOrigin);
            setState({
                ...timelineData,
                timelineWidth: timelineWidth,
                timelineOriginPosition: timelineOriginPosition,
                columnDurations: columnDurations,
                columnPositions: columnPositions
            });
        };
    const $11ae6e482458e57a$export$4f33ace85fd289c5 = (0, (0, parcelRequire("gg7kZ")).createContainer)($11ae6e482458e57a$export$2ce7f0e10391f4, {
        onInit: $11ae6e482458e57a$var$handleState,
        onUpdate: $11ae6e482458e57a$var$handleState
    });
});
parcelRegister("iwcO1", function(module, exports) {
    $parcel$export(module.exports, "getColumnDurations", ()=>$83f6cf322fa93419$export$97c232fe861416fb);
    $parcel$export(module.exports, "getColumnPositions", ()=>$83f6cf322fa93419$export$1f04562dc761554b);
    $parcel$export(module.exports, "getTodayColumnIndex", ()=>$83f6cf322fa93419$export$ce237023318dfe05);
    var $8QpSo;
    var $2gnC5 = parcelRequire("2gnC5");
    var $iZN6h;
    const $83f6cf322fa93419$var$getColumnDurationsForMode = (timelineDuration, momentIdentifier)=>{
        const columnDurations = [];
        const { startMilliseconds: startMilliseconds, endMilliseconds: endMilliseconds } = timelineDuration;
        const momentAddIdentifier = momentIdentifier === 'isoWeek' ? 'week' : momentIdentifier;
        const startMoment = (0, ($parcel$interopDefault($2gnC5))).utc(startMilliseconds).startOf(momentIdentifier);
        while(startMoment.valueOf() < endMilliseconds){
            const endMoment = startMoment.clone().endOf(momentIdentifier);
            columnDurations.push({
                startMilliseconds: startMoment.valueOf(),
                endMilliseconds: endMoment.valueOf(),
                totalMilliseconds: endMoment.diff(startMoment, 'milliseconds')
            });
            startMoment.add(1, momentAddIdentifier);
        }
        return columnDurations;
    };
    const $83f6cf322fa93419$export$97c232fe861416fb = (0, (0, parcelRequire("8QpSo")).default)((timelineMode, timelineDuration)=>{
        if (timelineMode === (0, (0, parcelRequire("iZN6h")).QUARTERS)) return $83f6cf322fa93419$var$getColumnDurationsForMode(timelineDuration, 'quarter');
        if (timelineMode === (0, (0, parcelRequire("iZN6h")).MONTHS)) return $83f6cf322fa93419$var$getColumnDurationsForMode(timelineDuration, 'month');
        return $83f6cf322fa93419$var$getColumnDurationsForMode(timelineDuration, 'isoWeek');
    });
    const $83f6cf322fa93419$export$1f04562dc761554b = (0, (0, parcelRequire("8QpSo")).default)((timelineDuration, columnDurations)=>{
        let left = 0;
        if (columnDurations.length > 0) left = (columnDurations[0].startMilliseconds - timelineDuration.startMilliseconds) / timelineDuration.totalMilliseconds * 100;
        return columnDurations.map((columnDuration)=>{
            const width = columnDuration.totalMilliseconds / timelineDuration.totalMilliseconds * 100;
            left += width;
            return [
                left - width,
                100 - left
            ];
        });
    });
    const $83f6cf322fa93419$export$ce237023318dfe05 = (0, (0, parcelRequire("8QpSo")).default)((today, columnDurations)=>{
        let todayColumnIndex = 0;
        columnDurations.some(({ startMilliseconds: startMilliseconds, endMilliseconds: endMilliseconds })=>{
            if (today >= startMilliseconds && today <= endMilliseconds) return true;
            todayColumnIndex += 1;
            return false;
        });
        return todayColumnIndex;
    });
});
parcelRegister("h5O3P", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$9d7b09dc8acd079d$export$e324594224ef24da);
    const $9d7b09dc8acd079d$export$e324594224ef24da = {};
});
parcelRegister("5SIwg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c85e5a25a380b891$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $6iqcY;
    var $58xNR;
    var $hEf85;
    var $2VHr3;
    var $4nLPh;
    var $a79cp;
    var $2MYv1;
    var $aaAik;
    var $cdyDR;
    var $lTlao;
    var $gc064;
    const $c85e5a25a380b891$var$containerStyles = null;
    const $c85e5a25a380b891$var$TableMain = ({ isVirtualiseEnabled: isVirtualiseEnabled, isResizeEnabled: isResizeEnabled, isHideScrollbar: isHideScrollbar, scope: scope, selectedItemIds: selectedItemIds, onItemDrop: onItemDrop, onItemSelect: onItemSelect, onItemExpandChanged: onItemExpandChanged, onCreateClick: onCreateClick, onSetListWidth: onSetListWidth, DndLongTaskMetric: DndLongTaskMetric, renderers: renderers })=>{
        const { listRenderers: listRenderers, chartRenderers: chartRenderers, renderProvider: renderProvider } = (0, (0, parcelRequire("gc064")).getRenderersWithDefaults)(renderers);
        const { renderListEmptyContent: renderListEmptyContent, renderListHeaderItem: renderListHeaderItem, renderListItemContent: renderListItemContent, renderListItemSecondaryContent: renderListItemSecondaryContent, renderListItemCreate: renderListItemCreate, renderListItemMenuOption: renderListItemMenuOption, renderListItemModal: renderListItemModal } = listRenderers;
        const { renderChartHeaderItem: renderChartHeaderItem, renderChartItemContent: renderChartItemContent, renderChartOverlay: renderChartOverlay, renderChartTimelineOverlay: renderChartTimelineOverlay } = chartRenderers;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2VHr3")).default), {
            isHideScrollbar: isHideScrollbar
        }, ({ scrollElement: scrollElement, onContentResize: onContentResize })=>{
            const containerContent = (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_kqswh2mm _1e0c1txw _2lx21bp4 _16jlkb7n _1o9zkb7n _i0dl1wug _1bsb1ns9 _4t3i1ns9 _1tke1osq"
                ])
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a79cp")).default), {
                renderListHeaderItem: renderListHeaderItem,
                renderChartHeaderItem: renderChartHeaderItem
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hEf85")).default), {
                isResizeEnabled: isResizeEnabled,
                DndLongTaskMetric: DndLongTaskMetric,
                onItemDrop: onItemDrop,
                onItemSelect: onItemSelect,
                onItemExpandChanged: onItemExpandChanged,
                onCreateClick: onCreateClick,
                onSetListWidth: onSetListWidth,
                onContentResize: onContentResize,
                renderListEmptyContent: renderListEmptyContent,
                renderListItemContent: renderListItemContent,
                renderListItemSecondaryContent: renderListItemSecondaryContent,
                renderListItemCreate: renderListItemCreate,
                renderChartItemContent: renderChartItemContent,
                renderChartTimelineOverlay: renderChartTimelineOverlay,
                renderListItemMenuOption: renderListItemMenuOption,
                renderListItemModal: renderListItemModal
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cdyDR")).default), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4nLPh")).default), {
                DndLongTaskMetric: DndLongTaskMetric
            }), (0, (0, parcelRequire("4R6GH")).fg)('project_timeline_multi-select_and_checkboxes') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2MYv1")).default), null) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aaAik")).default), {
                selectedItemIds: selectedItemIds
            }));
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6iqcY")).default), {
                scope: scope,
                scrollElement: scrollElement
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("58xNR")).default), {
                scrollElement: scrollElement,
                isEnabled: isVirtualiseEnabled
            }, renderProvider({
                children: containerContent
            })));
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lTlao")).default), {
            renderChartOverlay: renderChartOverlay
        }));
    };
    $c85e5a25a380b891$var$TableMain.displayName = 'TableMain';
    $c85e5a25a380b891$var$TableMain.whyDidYouRender = true;
    var $c85e5a25a380b891$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($c85e5a25a380b891$var$TableMain);
});
parcelRegister("6iqcY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2e3d7da017f31045$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7wqBZ;
    var $8CsHB;
    var $26JJs;
    var $iZN6h;
    var $g3prf;
    var $hGh1Z;
    var $3Kr5N;
    var $3ruU1;
    var $cRUzn;
    var $d1oik;
    var $de769;
    const $2e3d7da017f31045$var$start = (scope)=>{
        (0, (0, parcelRequire("7wqBZ")).getLongTasksMetrics)((0, (0, parcelRequire("iZN6h")).SCROLLED)).start(scope);
    };
    const $2e3d7da017f31045$var$stop = (scope)=>{
        let reporter = (0, (0, parcelRequire("8CsHB")).genericReporter);
        reporter = (0, (0, parcelRequire("26JJs")).scrollReporterWithSlo)();
        (0, (0, parcelRequire("7wqBZ")).getLongTasksMetrics)(scope).stop(reporter);
    };
    const $2e3d7da017f31045$var$SCROLL_COUNT_THRESHOLD = 5;
    const $2e3d7da017f31045$var$Container = ({ scope: scope, scrollElement: scrollElement })=>{
        const [{ headerHeight: headerHeight }] = (0, (0, parcelRequire("g3prf")).useHeaderState)();
        const { onScrollStateChanged: onScrollStateChanged } = (0, (0, parcelRequire("3ruU1")).useSideEffectMarshal)();
        const [, { updateScrollMeta: updateScrollMeta, updateScrollPosition: updateScrollPosition }] = (0, (0, parcelRequire("3Kr5N")).useScrollMetaActions)();
        const [{ totalHeight: totalHeight }] = (0, (0, parcelRequire("hGh1Z")).useItemsContainerStyles)();
        const isScrolling = (0, $5uXOq.useRef)(false);
        const scrollCount = (0, $5uXOq.useRef)(0);
        const getAndUpdateScrollPosition = (0, $5uXOq.useCallback)(()=>{
            const { scrollTop: scrollTop, clientHeight: clientHeight } = scrollElement;
            const tableHeight = totalHeight + headerHeight;
            const scrollBottom = Math.max(0, tableHeight - (scrollTop + clientHeight));
            updateScrollPosition({
                scrollTop: scrollTop,
                scrollBottom: scrollBottom
            });
        }, [
            scrollElement,
            totalHeight,
            updateScrollPosition,
            headerHeight
        ]);
        const onScrollChange = (0, $5uXOq.useCallback)((scrollingState)=>{
            if (isScrolling.current !== scrollingState.isScrollingY) {
                if (scrollCount.current === $2e3d7da017f31045$var$SCROLL_COUNT_THRESHOLD) {
                    if (scrollingState.isScrollingY) $2e3d7da017f31045$var$start(scope);
                    else {
                        $2e3d7da017f31045$var$stop(scope);
                        scrollCount.current = 0;
                    }
                    isScrolling.current = scrollingState.isScrollingY;
                } else scrollCount.current += 1;
            }
            updateScrollMeta(scrollingState);
            if (!scrollingState.isScrollingY) getAndUpdateScrollPosition();
            onScrollStateChanged(scrollingState.isScrollingY);
        }, [
            updateScrollMeta,
            getAndUpdateScrollPosition,
            onScrollStateChanged,
            scope
        ]);
        (0, (0, parcelRequire("de769")).useIsScrolling)(scrollElement, onScrollChange);
        (0, (0, parcelRequire("cRUzn")).useResizeObserver)(scrollElement, getAndUpdateScrollPosition);
        return null;
    };
    const $2e3d7da017f31045$var$ScrollMetaContainer = ({ scope: scope, scrollElement: scrollElement, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Kr5N")).ScrollMetaProviderSweetState), null, scrollElement && (0, ($parcel$interopDefault($5uXOq))).createElement($2e3d7da017f31045$var$Container, {
            scope: scope,
            scrollElement: scrollElement
        }), scrollElement && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d1oik")).default), {
            scope: scope,
            scrollElement: scrollElement
        }), children);
    var $2e3d7da017f31045$export$2e2bcd8739ae039 = $2e3d7da017f31045$var$ScrollMetaContainer;
});
parcelRegister("3Kr5N", function(module, exports) {
    $parcel$export(module.exports, "useScrollMetaActions", ()=>$b162d083ad3dce4e$export$ad4800a08d9776a3);
    $parcel$export(module.exports, "ScrollMetaProviderSweetState", ()=>$b162d083ad3dce4e$export$e0f28de8d4016f86);
    $parcel$export(module.exports, "isScrollToTop", ()=>$b162d083ad3dce4e$export$5a36b1e9643b5cf2);
    $parcel$export(module.exports, "useIsScrollingY", ()=>$b162d083ad3dce4e$export$b4e5a0824bff5bca);
    $parcel$export(module.exports, "useIsScrollingX", ()=>$b162d083ad3dce4e$export$b8a077e56392e785);
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    var $28eI8;
    var $02ckh;
    const $b162d083ad3dce4e$var$DEFAULT_STATE = {
        isScrollingX: false,
        isScrollingY: false,
        positions: {
            top: 0,
            bottom: 0
        }
    };
    const $b162d083ad3dce4e$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $b162d083ad3dce4e$var$DEFAULT_STATE,
        actions: (0, (0, parcelRequire("28eI8")).scrollMetaActions),
        name: 'timeline-table.scroll-meta'
    });
    const $b162d083ad3dce4e$export$ad4800a08d9776a3 = (0, (0, parcelRequire("3sQ5x")).createHook)($b162d083ad3dce4e$var$store, {
        selector: null
    });
    const $b162d083ad3dce4e$export$e0f28de8d4016f86 = (0, (0, parcelRequire("gg7kZ")).createContainer)($b162d083ad3dce4e$var$store);
    const $b162d083ad3dce4e$export$5a36b1e9643b5cf2 = (0, (0, parcelRequire("3sQ5x")).createHook)($b162d083ad3dce4e$var$store, {
        selector: (0, (0, parcelRequire("02ckh")).getIsScrollToTop)
    });
    const $b162d083ad3dce4e$export$b4e5a0824bff5bca = (0, (0, parcelRequire("3sQ5x")).createHook)($b162d083ad3dce4e$var$store, {
        selector: (0, (0, parcelRequire("02ckh")).getIsScrollingY)
    });
    const $b162d083ad3dce4e$export$b8a077e56392e785 = (0, (0, parcelRequire("3sQ5x")).createHook)($b162d083ad3dce4e$var$store, {
        selector: (0, (0, parcelRequire("02ckh")).getIsScrollingX)
    });
});
parcelRegister("28eI8", function(module, exports) {
    $parcel$export(module.exports, "scrollMetaActions", ()=>$83aaef37d3b5b1cd$export$a0445084aaf6bbad);
    const $83aaef37d3b5b1cd$var$updateScrollMeta = ({ isScrollingX: isScrollingX, isScrollingY: isScrollingY })=>({ setState: setState })=>{
            setState({
                isScrollingX: isScrollingX,
                isScrollingY: isScrollingY
            });
        };
    const $83aaef37d3b5b1cd$var$updateScrollPosition = ({ scrollTop: scrollTop, scrollBottom: scrollBottom })=>({ setState: setState })=>{
            const positions = {
                top: scrollTop,
                bottom: scrollBottom
            };
            setState({
                positions: positions
            });
        };
    const $83aaef37d3b5b1cd$export$a0445084aaf6bbad = {
        updateScrollMeta: $83aaef37d3b5b1cd$var$updateScrollMeta,
        updateScrollPosition: $83aaef37d3b5b1cd$var$updateScrollPosition
    };
});
parcelRegister("02ckh", function(module, exports) {
    $parcel$export(module.exports, "getIsScrollingX", ()=>$42a3363cc610a84e$export$1b889f4869aca117);
    $parcel$export(module.exports, "getIsScrollingY", ()=>$42a3363cc610a84e$export$ca3dc64117d091c8);
    $parcel$export(module.exports, "getIsScrollToTop", ()=>$42a3363cc610a84e$export$2119597e6872810a);
    const $42a3363cc610a84e$export$1b889f4869aca117 = (state)=>state.isScrollingX;
    const $42a3363cc610a84e$export$ca3dc64117d091c8 = (state)=>state.isScrollingY;
    const $42a3363cc610a84e$export$2119597e6872810a = (state)=>state.positions.top === 0;
});
parcelRegister("cRUzn", function(module, exports) {
    $parcel$export(module.exports, "useResizeObserver", ()=>$86448c82fe51ac99$export$683480f191c0e3ea);
    var $5uXOq = parcelRequire("5uXOq");
    var $8U1C6;
    let $86448c82fe51ac99$var$resizeObserver;
    const $86448c82fe51ac99$export$683480f191c0e3ea = (element, callback)=>{
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (typeof ResizeObserver !== 'undefined') {
                if (!$86448c82fe51ac99$var$resizeObserver) $86448c82fe51ac99$var$resizeObserver = new ResizeObserver((0, (0, parcelRequire("8U1C6")).runCallbacks));
                element && (0, (0, parcelRequire("8U1C6")).observeElement)($86448c82fe51ac99$var$resizeObserver, element, callback);
            }
            return ()=>{
                if (element && $86448c82fe51ac99$var$resizeObserver) (0, (0, parcelRequire("8U1C6")).unobserveElement)($86448c82fe51ac99$var$resizeObserver, element, callback);
            };
        }, [
            element,
            callback
        ]);
    };
});
parcelRegister("8U1C6", function(module, exports) {
    $parcel$export(module.exports, "runCallbacks", ()=>$74e3391927aa1bb5$export$4219acf616175acb);
    $parcel$export(module.exports, "observeElement", ()=>$74e3391927aa1bb5$export$9137ee61fe58d50e);
    $parcel$export(module.exports, "unobserveElement", ()=>$74e3391927aa1bb5$export$4d125402ac99f1b);
    const $74e3391927aa1bb5$var$elementsForCallback = new Map();
    const $74e3391927aa1bb5$export$4219acf616175acb = (entries)=>{
        $74e3391927aa1bb5$var$elementsForCallback.forEach((elements, callback)=>{
            const relevantEntries = [];
            entries.forEach((entry)=>{
                if (elements.includes(entry.target)) relevantEntries.push(entry);
            });
            if (relevantEntries.length > 0) callback(relevantEntries);
        });
    };
    const $74e3391927aa1bb5$export$9137ee61fe58d50e = (resizeObserver, element, callback)=>{
        const existingElements = $74e3391927aa1bb5$var$elementsForCallback.get(callback);
        if (existingElements) $74e3391927aa1bb5$var$elementsForCallback.set(callback, [
            ...existingElements,
            element
        ]);
        else $74e3391927aa1bb5$var$elementsForCallback.set(callback, [
            element
        ]);
        resizeObserver.observe(element);
    };
    const $74e3391927aa1bb5$export$4d125402ac99f1b = (resizeObserver, element, callback)=>{
        $74e3391927aa1bb5$var$elementsForCallback.delete(callback);
        resizeObserver.unobserve(element);
    };
});
parcelRegister("d1oik", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7cab0141580aca4a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $2nbdU;
    var $hGh1Z;
    const $7cab0141580aca4a$var$TimelineTableScrollFPSMetric = ({ scope: scope, scrollElement: scrollElement })=>{
        const [itemsCount] = (0, (0, parcelRequire("hGh1Z")).useItemsCount)();
        const attributes = {
            isCustomScrollbarPdnd: (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline_table_custom_scroll_pdnd')
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2nbdU")).default), {
            viewId: scope,
            itemsCount: itemsCount,
            scrollElement: scrollElement,
            attributes: attributes
        });
    };
    var $7cab0141580aca4a$export$2e2bcd8739ae039 = $7cab0141580aca4a$var$TimelineTableScrollFPSMetric;
});
parcelRegister("2nbdU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$551da07557368f71$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8zOmE;
    var $2NMNM;
    const $551da07557368f71$export$df7175b69b5630dd = (frames, elapsedMs)=>Math.min(Math.floor(1000 * (frames / elapsedMs)), (0, $ed1164448c2018a0$export$9d3e6d8a99023567));
    const $551da07557368f71$export$46962be62755f053 = (0, $5uXOq.memo)(({ viewId: viewId, itemsCount: itemsCount, samplingRate: samplingRate = (0, $ed1164448c2018a0$export$71d024136796e395), scrollElement: scrollElement, attributes: attributes })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const samplingCount = (0, $5uXOq.useRef)(0);
        const frames = (0, $5uXOq.useRef)(0);
        const rafId = (0, $5uXOq.useRef)(null);
        const start = (0, $5uXOq.useRef)(0);
        (0, $5uXOq.useEffect)(()=>{
            const container = scrollElement ?? document;
            const hasScrollCapture = true;
            const tick = ()=>{
                if (frames.current < (0, $ed1164448c2018a0$export$299249b1dad3b14a)) {
                    frames.current += 1;
                    rafId.current = requestAnimationFrame(tick);
                } else {
                    const stopTime = performance.now();
                    const elapsedMs = stopTime - start.current;
                    const fps = $551da07557368f71$export$df7175b69b5630dd(frames.current, elapsedMs);
                    const avgFrameDuration = Math.floor(elapsedMs / frames.current);
                    frames.current = 0;
                    const attr = {
                        ...attributes || {},
                        itemsCount: itemsCount,
                        avgFrameDuration: avgFrameDuration,
                        fps: fps
                    };
                    (0, (0, parcelRequire("8zOmE")).fireOperationalAnalyticsDeferred)(createAnalyticsEvent({}), `${viewId} scrolled`, attr);
                }
            };
            const handleOnScroll = ()=>{
                samplingCount.current += 1;
                if (samplingCount.current !== samplingRate) return;
                samplingCount.current = 0;
                start.current = performance.now();
                tick();
            };
            container.addEventListener('scroll', handleOnScroll, hasScrollCapture);
            return ()=>{
                container.removeEventListener('scroll', handleOnScroll, hasScrollCapture);
                if (rafId.current) cancelAnimationFrame(rafId.current);
            };
        }, [
            scrollElement,
            createAnalyticsEvent,
            itemsCount,
            samplingRate,
            viewId,
            attributes
        ]);
        return null;
    });
    var $551da07557368f71$export$2e2bcd8739ae039 = $551da07557368f71$export$46962be62755f053;
});
const $ed1164448c2018a0$export$71d024136796e395 = 100;
const $ed1164448c2018a0$export$299249b1dad3b14a = 20;
const $ed1164448c2018a0$export$9d3e6d8a99023567 = 60;
parcelRegister("de769", function(module, exports) {
    $parcel$export(module.exports, "useIsScrolling", ()=>$e0c492fa7660c72b$export$fde36fcfab14caba);
    var $5uXOq = parcelRequire("5uXOq");
    var $e76oB;
    var $k9k0z;
    const $e0c492fa7660c72b$export$fde36fcfab14caba = (scrollElement, onScrollChange)=>{
        const rafId = (0, $5uXOq.useRef)(null);
        const startTime = (0, $5uXOq.useRef)(-1);
        const isScrolling = (0, $5uXOq.useRef)(false);
        const lastPosition = (0, $5uXOq.useRef)({
            x: 0,
            y: 0
        });
        const lastScrollState = (0, $5uXOq.useRef)((0, (0, parcelRequire("e76oB")).DEFAULT_STATE));
        const scrollEnd = (0, $5uXOq.useCallback)(()=>{
            if (isScrolling.current) {
                startTime.current = -1;
                isScrolling.current = false;
                lastScrollState.current = (0, (0, parcelRequire("e76oB")).DEFAULT_STATE);
                onScrollChange((0, (0, parcelRequire("e76oB")).DEFAULT_STATE));
            }
            if (rafId.current !== null) {
                cancelAnimationFrame(rafId.current);
                rafId.current = null;
            }
        }, [
            onScrollChange
        ]);
        const tick = (0, $5uXOq.useCallback)(()=>{
            if (isScrolling.current) {
                const stopTime = performance.now();
                const time = stopTime - startTime.current;
                const { scrollTop: scrollTop, scrollLeft: scrollLeft } = scrollElement;
                const scrollState = {
                    ...lastScrollState.current
                };
                if (scrollTop !== lastPosition.current.y) scrollState.isScrollingY = true;
                if (scrollLeft !== lastPosition.current.x) scrollState.isScrollingX = true;
                lastPosition.current = {
                    x: scrollLeft,
                    y: scrollTop
                };
                if (time >= (0, (0, parcelRequire("e76oB")).IDLE_THRESHOLD)) scrollEnd();
                else {
                    if ((0, (0, parcelRequire("k9k0z")).hasStateChanged)(lastScrollState.current, scrollState)) {
                        lastScrollState.current = {
                            ...scrollState
                        };
                        onScrollChange(scrollState);
                    }
                    rafId.current = requestAnimationFrame(tick);
                }
            }
        }, [
            scrollElement,
            scrollEnd,
            onScrollChange
        ]);
        const onScroll = (0, $5uXOq.useCallback)(()=>{
            isScrolling.current = true;
            startTime.current = performance.now();
            if (!rafId.current) rafId.current = requestAnimationFrame(tick);
        }, [
            tick
        ]);
        (0, $5uXOq.useEffect)(()=>{
            scrollElement.addEventListener('scroll', onScroll);
            return ()=>{
                scrollElement.removeEventListener('scroll', onScroll);
                if (rafId.current !== null) {
                    cancelAnimationFrame(rafId.current);
                    rafId.current = null;
                }
            };
        }, [
            scrollElement,
            onScroll
        ]);
    };
});
parcelRegister("e76oB", function(module, exports) {
    $parcel$export(module.exports, "IDLE_THRESHOLD", ()=>$9e06f723d94dcb9e$export$a9b912713512229e);
    $parcel$export(module.exports, "DEFAULT_STATE", ()=>$9e06f723d94dcb9e$export$a3a6a28ae8823b06);
    const $9e06f723d94dcb9e$export$a9b912713512229e = 150;
    const $9e06f723d94dcb9e$export$a3a6a28ae8823b06 = {
        isScrollingX: false,
        isScrollingY: false
    };
});
parcelRegister("k9k0z", function(module, exports) {
    $parcel$export(module.exports, "hasStateChanged", ()=>$0f21825f1e10a969$export$ba6070bd39de76e0);
    const $0f21825f1e10a969$export$ba6070bd39de76e0 = (oldState, newState)=>!oldState.isScrollingX && newState.isScrollingX || !oldState.isScrollingY && newState.isScrollingY;
});
parcelRegister("58xNR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$105ef404676cd478$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9suPc;
    var $iZN6h;
    var $g3prf;
    var $hGh1Z;
    var $jlrVi;
    var $kJTbm;
    const $105ef404676cd478$var$useVirtualItems = ({ scrollElement: scrollElement, itemHeights: itemHeights })=>{
        const [, { generateVirtualMeta: generateVirtualMeta }] = (0, (0, parcelRequire("jlrVi")).useVirtualisedActions)();
        const parentRef = (0, $5uXOq.useRef)(scrollElement);
        const getRowHeight = (0, $5uXOq.useCallback)((index)=>itemHeights[index], [
            itemHeights
        ]);
        const [{ headerHeight: headerHeight }] = (0, (0, parcelRequire("g3prf")).useHeaderState)();
        const virtualizer = (0, (0, parcelRequire("9suPc")).useVirtualizer)({
            count: itemHeights.length,
            getScrollElement: ()=>parentRef.current,
            estimateSize: getRowHeight,
            overscan: 0,
            paddingStart: headerHeight
        });
        (0, $5uXOq.useLayoutEffect)(()=>{
            const virtualItems = virtualizer.getVirtualItems();
            if (virtualizer.getVirtualItems().length > 0) {
                const { index: startIndex } = virtualItems[0];
                const { index: endIndex } = virtualItems[virtualItems.length - 1];
                const visibleItemCount = endIndex - startIndex;
                const roundedStart = Math.round(startIndex / 5) * 5;
                generateVirtualMeta(roundedStart, Math.min(roundedStart + visibleItemCount, endIndex));
            } else generateVirtualMeta(0, itemHeights.length - 1);
        }, [
            generateVirtualMeta,
            virtualizer.getVirtualItems(),
            itemHeights
        ]);
    };
    const $105ef404676cd478$var$Container = ({ itemHeights: itemHeights, scrollElement: scrollElement })=>{
        $105ef404676cd478$var$useVirtualItems({
            itemHeights: itemHeights,
            scrollElement: scrollElement
        });
        return null;
    };
    const $105ef404676cd478$var$VirtualiseContainer = ({ isEnabled: isEnabled, children: children, scrollElement: scrollElement })=>{
        const [items] = (0, (0, parcelRequire("hGh1Z")).useItems)();
        const [itemHeight] = (0, (0, parcelRequire("hGh1Z")).useItemHeight)();
        const itemHeights = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("kJTbm")).getItemHeights)(items, itemHeight), [
            items,
            itemHeight
        ]);
        const createItemIndex = (0, $5uXOq.useMemo)(()=>items.findIndex((item)=>item.type === (0, (0, parcelRequire("iZN6h")).CREATE_ITEM_TYPE)), [
            items
        ]);
        if (typeof ResizeObserver === 'undefined') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jlrVi")).VirtualiseProviderSweetState), {
            itemHeights: itemHeights,
            createItemIndex: createItemIndex,
            isEnabled: isEnabled,
            items: items
        }, scrollElement && isEnabled && (0, ($parcel$interopDefault($5uXOq))).createElement($105ef404676cd478$var$Container, {
            itemHeights: itemHeights,
            scrollElement: scrollElement
        }), children);
    };
    var $105ef404676cd478$export$2e2bcd8739ae039 = $105ef404676cd478$var$VirtualiseContainer;
});
parcelRegister("9suPc", function(module, exports) {
    $parcel$export(module.exports, "elementScroll", ()=>(parcelRequire("lASGB")).elementScroll);
    $parcel$export(module.exports, "notUndefined", ()=>(parcelRequire("cDbvq")).notUndefined);
    $parcel$export(module.exports, "observeElementOffset", ()=>(parcelRequire("lASGB")).observeElementOffset);
    $parcel$export(module.exports, "observeElementRect", ()=>(parcelRequire("lASGB")).observeElementRect);
    $parcel$export(module.exports, "observeWindowOffset", ()=>(parcelRequire("lASGB")).observeWindowOffset);
    $parcel$export(module.exports, "observeWindowRect", ()=>(parcelRequire("lASGB")).observeWindowRect);
    $parcel$export(module.exports, "Virtualizer", ()=>(parcelRequire("lASGB")).Virtualizer);
    $parcel$export(module.exports, "windowScroll", ()=>(parcelRequire("lASGB")).windowScroll);
    $parcel$export(module.exports, "useVirtualizer", ()=>$6e2ea3c4609c52d6$export$dd6d526d88b5a137);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $lASGB;
    const $6e2ea3c4609c52d6$var$useIsomorphicLayoutEffect = typeof document !== "undefined" ? $5uXOq.useLayoutEffect : $5uXOq.useEffect;
    function $6e2ea3c4609c52d6$var$useVirtualizerBase(options) {
        const rerender = $5uXOq.useReducer(()=>({}), {})[1];
        const resolvedOptions = {
            ...options,
            onChange: (instance2, sync)=>{
                var _a;
                if (sync) (0, $7nsd3.flushSync)(rerender);
                else rerender();
                (_a = options.onChange) == null || _a.call(options, instance2, sync);
            }
        };
        const [instance] = $5uXOq.useState(()=>new (0, (0, parcelRequire("lASGB")).Virtualizer)(resolvedOptions));
        instance.setOptions(resolvedOptions);
        $5uXOq.useEffect(()=>{
            return instance._didMount();
        }, []);
        $6e2ea3c4609c52d6$var$useIsomorphicLayoutEffect(()=>{
            return instance._willUpdate();
        });
        return instance;
    }
    function $6e2ea3c4609c52d6$export$dd6d526d88b5a137(options) {
        return $6e2ea3c4609c52d6$var$useVirtualizerBase({
            observeElementRect: (0, parcelRequire("lASGB")).observeElementRect,
            observeElementOffset: (0, parcelRequire("lASGB")).observeElementOffset,
            scrollToFn: (0, (0, parcelRequire("lASGB")).elementScroll),
            ...options
        });
    }
    function $6e2ea3c4609c52d6$export$645722dcac657cb9(options) {
        return $6e2ea3c4609c52d6$var$useVirtualizerBase({
            getScrollElement: ()=>typeof document !== "undefined" ? window : null,
            observeElementRect: (0, (0, parcelRequire("lASGB")).observeWindowRect),
            observeElementOffset: (0, (0, parcelRequire("lASGB")).observeWindowOffset),
            scrollToFn: (0, (0, parcelRequire("lASGB")).windowScroll),
            initialOffset: ()=>typeof document !== "undefined" ? window.scrollY : 0,
            ...options
        });
    }
});
parcelRegister("lASGB", function(module, exports) {
    $parcel$export(module.exports, "observeElementRect", ()=>$fb876145852c2505$export$5a50ff2cde8c3802);
    $parcel$export(module.exports, "observeWindowRect", ()=>$fb876145852c2505$export$e911b82c7a99311);
    $parcel$export(module.exports, "observeElementOffset", ()=>$fb876145852c2505$export$fbc040aee017375a);
    $parcel$export(module.exports, "observeWindowOffset", ()=>$fb876145852c2505$export$518998f8c5d09287);
    $parcel$export(module.exports, "windowScroll", ()=>$fb876145852c2505$export$2162c5b3eeedd27);
    $parcel$export(module.exports, "elementScroll", ()=>$fb876145852c2505$export$1cdb988e5ab69fe7);
    $parcel$export(module.exports, "Virtualizer", ()=>$fb876145852c2505$export$89be5a243e59c4b2);
    $parcel$export(module.exports, "notUndefined", ()=>(parcelRequire("cDbvq")).notUndefined);
    var $cDbvq;
    const $fb876145852c2505$export$76974b428a49f15b = (index)=>index;
    const $fb876145852c2505$export$7eb7cb13fd21e5e1 = (range)=>{
        const start = Math.max(range.startIndex - range.overscan, 0);
        const end = Math.min(range.endIndex + range.overscan, range.count - 1);
        const arr = [];
        for(let i = start; i <= end; i++)arr.push(i);
        return arr;
    };
    const $fb876145852c2505$export$5a50ff2cde8c3802 = (instance, cb)=>{
        const element = instance.scrollElement;
        if (!element) return;
        const targetWindow = instance.targetWindow;
        if (!targetWindow) return;
        const handler = (rect)=>{
            const { width: width, height: height } = rect;
            cb({
                width: Math.round(width),
                height: Math.round(height)
            });
        };
        handler(element.getBoundingClientRect());
        if (!targetWindow.ResizeObserver) return ()=>{};
        const observer = new targetWindow.ResizeObserver((entries)=>{
            const entry = entries[0];
            if (entry == null ? void 0 : entry.borderBoxSize) {
                const box = entry.borderBoxSize[0];
                if (box) {
                    handler({
                        width: box.inlineSize,
                        height: box.blockSize
                    });
                    return;
                }
            }
            handler(element.getBoundingClientRect());
        });
        observer.observe(element, {
            box: "border-box"
        });
        return ()=>{
            observer.unobserve(element);
        };
    };
    const $fb876145852c2505$var$addEventListenerOptions = {
        passive: true
    };
    const $fb876145852c2505$export$e911b82c7a99311 = (instance, cb)=>{
        const element = instance.scrollElement;
        if (!element) return;
        const handler = ()=>{
            cb({
                width: element.innerWidth,
                height: element.innerHeight
            });
        };
        handler();
        element.addEventListener("resize", handler, $fb876145852c2505$var$addEventListenerOptions);
        return ()=>{
            element.removeEventListener("resize", handler);
        };
    };
    const $fb876145852c2505$var$supportsScrollend = typeof window == "undefined" ? true : "onscrollend" in window;
    const $fb876145852c2505$export$fbc040aee017375a = (instance, cb)=>{
        const element = instance.scrollElement;
        if (!element) return;
        const targetWindow = instance.targetWindow;
        if (!targetWindow) return;
        let offset = 0;
        const fallback = $fb876145852c2505$var$supportsScrollend ? ()=>void 0 : (0, (0, parcelRequire("cDbvq")).debounce)(targetWindow, ()=>{
            cb(offset, false);
        }, instance.options.isScrollingResetDelay);
        const createHandler = (isScrolling)=>()=>{
                const { horizontal: horizontal, isRtl: isRtl } = instance.options;
                offset = horizontal ? element["scrollLeft"] * (isRtl && -1 || 1) : element["scrollTop"];
                fallback();
                cb(offset, isScrolling);
            };
        const handler = createHandler(true);
        const endHandler = createHandler(false);
        endHandler();
        element.addEventListener("scroll", handler, $fb876145852c2505$var$addEventListenerOptions);
        element.addEventListener("scrollend", endHandler, $fb876145852c2505$var$addEventListenerOptions);
        return ()=>{
            element.removeEventListener("scroll", handler);
            element.removeEventListener("scrollend", endHandler);
        };
    };
    const $fb876145852c2505$export$518998f8c5d09287 = (instance, cb)=>{
        const element = instance.scrollElement;
        if (!element) return;
        const targetWindow = instance.targetWindow;
        if (!targetWindow) return;
        let offset = 0;
        const fallback = $fb876145852c2505$var$supportsScrollend ? ()=>void 0 : (0, (0, parcelRequire("cDbvq")).debounce)(targetWindow, ()=>{
            cb(offset, false);
        }, instance.options.isScrollingResetDelay);
        const createHandler = (isScrolling)=>()=>{
                offset = element[instance.options.horizontal ? "scrollX" : "scrollY"];
                fallback();
                cb(offset, isScrolling);
            };
        const handler = createHandler(true);
        const endHandler = createHandler(false);
        endHandler();
        element.addEventListener("scroll", handler, $fb876145852c2505$var$addEventListenerOptions);
        element.addEventListener("scrollend", endHandler, $fb876145852c2505$var$addEventListenerOptions);
        return ()=>{
            element.removeEventListener("scroll", handler);
            element.removeEventListener("scrollend", endHandler);
        };
    };
    const $fb876145852c2505$export$6aa9c23c0f5932af = (element, entry, instance)=>{
        if (entry == null ? void 0 : entry.borderBoxSize) {
            const box = entry.borderBoxSize[0];
            if (box) {
                const size = Math.round(box[instance.options.horizontal ? "inlineSize" : "blockSize"]);
                return size;
            }
        }
        return Math.round(element.getBoundingClientRect()[instance.options.horizontal ? "width" : "height"]);
    };
    const $fb876145852c2505$export$2162c5b3eeedd27 = (offset, { adjustments: adjustments = 0, behavior: behavior }, instance)=>{
        var _a, _b;
        const toOffset = offset + adjustments;
        (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null || _b.call(_a, {
            [instance.options.horizontal ? "left" : "top"]: toOffset,
            behavior: behavior
        });
    };
    const $fb876145852c2505$export$1cdb988e5ab69fe7 = (offset, { adjustments: adjustments = 0, behavior: behavior }, instance)=>{
        var _a, _b;
        const toOffset = offset + adjustments;
        (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null || _b.call(_a, {
            [instance.options.horizontal ? "left" : "top"]: toOffset,
            behavior: behavior
        });
    };
    class $fb876145852c2505$export$89be5a243e59c4b2 {
        constructor(opts){
            this.unsubs = [];
            this.scrollElement = null;
            this.targetWindow = null;
            this.isScrolling = false;
            this.scrollToIndexTimeoutId = null;
            this.measurementsCache = [];
            this.itemSizeCache = new Map();
            this.pendingMeasuredCacheIndexes = [];
            this.scrollRect = null;
            this.scrollOffset = null;
            this.scrollDirection = null;
            this.scrollAdjustments = 0;
            this.elementsCache = new Map();
            this.observer = (()=>{
                let _ro = null;
                const get = ()=>{
                    if (_ro) return _ro;
                    if (!this.targetWindow || !this.targetWindow.ResizeObserver) return null;
                    return _ro = new this.targetWindow.ResizeObserver((entries)=>{
                        entries.forEach((entry)=>{
                            this._measureElement(entry.target, entry);
                        });
                    });
                };
                return {
                    disconnect: ()=>{
                        var _a;
                        (_a = get()) == null || _a.disconnect();
                        _ro = null;
                    },
                    observe: (target)=>{
                        var _a;
                        return (_a = get()) == null ? void 0 : _a.observe(target, {
                            box: "border-box"
                        });
                    },
                    unobserve: (target)=>{
                        var _a;
                        return (_a = get()) == null ? void 0 : _a.unobserve(target);
                    }
                };
            })();
            this.range = null;
            this.setOptions = (opts2)=>{
                Object.entries(opts2).forEach(([key, value])=>{
                    if (typeof value === "undefined") delete opts2[key];
                });
                this.options = {
                    debug: false,
                    initialOffset: 0,
                    overscan: 1,
                    paddingStart: 0,
                    paddingEnd: 0,
                    scrollPaddingStart: 0,
                    scrollPaddingEnd: 0,
                    horizontal: false,
                    getItemKey: $fb876145852c2505$export$76974b428a49f15b,
                    rangeExtractor: $fb876145852c2505$export$7eb7cb13fd21e5e1,
                    onChange: ()=>{},
                    measureElement: $fb876145852c2505$export$6aa9c23c0f5932af,
                    initialRect: {
                        width: 0,
                        height: 0
                    },
                    scrollMargin: 0,
                    gap: 0,
                    indexAttribute: "data-index",
                    initialMeasurementsCache: [],
                    lanes: 1,
                    isScrollingResetDelay: 150,
                    enabled: true,
                    isRtl: false,
                    ...opts2
                };
            };
            this.notify = (sync)=>{
                var _a, _b;
                (_b = (_a = this.options).onChange) == null || _b.call(_a, this, sync);
            };
            this.maybeNotify = (0, (0, parcelRequire("cDbvq")).memo)(()=>{
                this.calculateRange();
                return [
                    this.isScrolling,
                    this.range ? this.range.startIndex : null,
                    this.range ? this.range.endIndex : null
                ];
            }, (isScrolling)=>{
                this.notify(isScrolling);
            }, {
                key: false,
                debug: ()=>this.options.debug,
                initialDeps: [
                    this.isScrolling,
                    this.range ? this.range.startIndex : null,
                    this.range ? this.range.endIndex : null
                ]
            });
            this.cleanup = ()=>{
                this.unsubs.filter(Boolean).forEach((d)=>d());
                this.unsubs = [];
                this.observer.disconnect();
                this.scrollElement = null;
                this.targetWindow = null;
            };
            this._didMount = ()=>{
                return ()=>{
                    this.cleanup();
                };
            };
            this._willUpdate = ()=>{
                var _a;
                const scrollElement = this.options.enabled ? this.options.getScrollElement() : null;
                if (this.scrollElement !== scrollElement) {
                    this.cleanup();
                    if (!scrollElement) {
                        this.maybeNotify();
                        return;
                    }
                    this.scrollElement = scrollElement;
                    if (this.scrollElement && "ownerDocument" in this.scrollElement) this.targetWindow = this.scrollElement.ownerDocument.defaultView;
                    else this.targetWindow = ((_a = this.scrollElement) == null ? void 0 : _a.window) ?? null;
                    this.elementsCache.forEach((cached)=>{
                        this.observer.observe(cached);
                    });
                    this._scrollToOffset(this.getScrollOffset(), {
                        adjustments: void 0,
                        behavior: void 0
                    });
                    this.unsubs.push(this.options.observeElementRect(this, (rect)=>{
                        this.scrollRect = rect;
                        this.maybeNotify();
                    }));
                    this.unsubs.push(this.options.observeElementOffset(this, (offset, isScrolling)=>{
                        this.scrollAdjustments = 0;
                        this.scrollDirection = isScrolling ? this.getScrollOffset() < offset ? "forward" : "backward" : null;
                        this.scrollOffset = offset;
                        this.isScrolling = isScrolling;
                        this.maybeNotify();
                    }));
                }
            };
            this.getSize = ()=>{
                if (!this.options.enabled) {
                    this.scrollRect = null;
                    return 0;
                }
                this.scrollRect = this.scrollRect ?? this.options.initialRect;
                return this.scrollRect[this.options.horizontal ? "width" : "height"];
            };
            this.getScrollOffset = ()=>{
                if (!this.options.enabled) {
                    this.scrollOffset = null;
                    return 0;
                }
                this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset === "function" ? this.options.initialOffset() : this.options.initialOffset);
                return this.scrollOffset;
            };
            this.getFurthestMeasurement = (measurements, index)=>{
                const furthestMeasurementsFound = new Map();
                const furthestMeasurements = new Map();
                for(let m = index - 1; m >= 0; m--){
                    const measurement = measurements[m];
                    if (furthestMeasurementsFound.has(measurement.lane)) continue;
                    const previousFurthestMeasurement = furthestMeasurements.get(measurement.lane);
                    if (previousFurthestMeasurement == null || measurement.end > previousFurthestMeasurement.end) furthestMeasurements.set(measurement.lane, measurement);
                    else if (measurement.end < previousFurthestMeasurement.end) furthestMeasurementsFound.set(measurement.lane, true);
                    if (furthestMeasurementsFound.size === this.options.lanes) break;
                }
                return furthestMeasurements.size === this.options.lanes ? Array.from(furthestMeasurements.values()).sort((a, b)=>{
                    if (a.end === b.end) return a.index - b.index;
                    return a.end - b.end;
                })[0] : void 0;
            };
            this.getMeasurementOptions = (0, (0, parcelRequire("cDbvq")).memo)(()=>[
                    this.options.count,
                    this.options.paddingStart,
                    this.options.scrollMargin,
                    this.options.getItemKey,
                    this.options.enabled
                ], (count, paddingStart, scrollMargin, getItemKey, enabled)=>{
                this.pendingMeasuredCacheIndexes = [];
                return {
                    count: count,
                    paddingStart: paddingStart,
                    scrollMargin: scrollMargin,
                    getItemKey: getItemKey,
                    enabled: enabled
                };
            }, {
                key: false
            });
            this.getMeasurements = (0, (0, parcelRequire("cDbvq")).memo)(()=>[
                    this.getMeasurementOptions(),
                    this.itemSizeCache
                ], ({ count: count, paddingStart: paddingStart, scrollMargin: scrollMargin, getItemKey: getItemKey, enabled: enabled }, itemSizeCache)=>{
                if (!enabled) {
                    this.measurementsCache = [];
                    this.itemSizeCache.clear();
                    return [];
                }
                if (this.measurementsCache.length === 0) {
                    this.measurementsCache = this.options.initialMeasurementsCache;
                    this.measurementsCache.forEach((item)=>{
                        this.itemSizeCache.set(item.key, item.size);
                    });
                }
                const min = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
                this.pendingMeasuredCacheIndexes = [];
                const measurements = this.measurementsCache.slice(0, min);
                for(let i = min; i < count; i++){
                    const key = getItemKey(i);
                    const furthestMeasurement = this.options.lanes === 1 ? measurements[i - 1] : this.getFurthestMeasurement(measurements, i);
                    const start = furthestMeasurement ? furthestMeasurement.end + this.options.gap : paddingStart + scrollMargin;
                    const measuredSize = itemSizeCache.get(key);
                    const size = typeof measuredSize === "number" ? measuredSize : this.options.estimateSize(i);
                    const end = start + size;
                    const lane = furthestMeasurement ? furthestMeasurement.lane : i % this.options.lanes;
                    measurements[i] = {
                        index: i,
                        start: start,
                        size: size,
                        end: end,
                        key: key,
                        lane: lane
                    };
                }
                this.measurementsCache = measurements;
                return measurements;
            }, {
                key: false,
                debug: ()=>this.options.debug
            });
            this.calculateRange = (0, (0, parcelRequire("cDbvq")).memo)(()=>[
                    this.getMeasurements(),
                    this.getSize(),
                    this.getScrollOffset()
                ], (measurements, outerSize, scrollOffset)=>{
                return this.range = measurements.length > 0 && outerSize > 0 ? $fb876145852c2505$var$calculateRange({
                    measurements: measurements,
                    outerSize: outerSize,
                    scrollOffset: scrollOffset
                }) : null;
            }, {
                key: false,
                debug: ()=>this.options.debug
            });
            this.getIndexes = (0, (0, parcelRequire("cDbvq")).memo)(()=>[
                    this.options.rangeExtractor,
                    this.calculateRange(),
                    this.options.overscan,
                    this.options.count
                ], (rangeExtractor, range, overscan, count)=>{
                return range === null ? [] : rangeExtractor({
                    startIndex: range.startIndex,
                    endIndex: range.endIndex,
                    overscan: overscan,
                    count: count
                });
            }, {
                key: false,
                debug: ()=>this.options.debug
            });
            this.indexFromElement = (node)=>{
                const attributeName = this.options.indexAttribute;
                const indexStr = node.getAttribute(attributeName);
                if (!indexStr) {
                    console.warn(`Missing attribute name '${attributeName}={index}' on measured element.`);
                    return -1;
                }
                return parseInt(indexStr, 10);
            };
            this._measureElement = (node, entry)=>{
                const index = this.indexFromElement(node);
                const item = this.measurementsCache[index];
                if (!item) return;
                const key = item.key;
                const prevNode = this.elementsCache.get(key);
                if (prevNode !== node) {
                    if (prevNode) this.observer.unobserve(prevNode);
                    this.observer.observe(node);
                    this.elementsCache.set(key, node);
                }
                if (node.isConnected) this.resizeItem(index, this.options.measureElement(node, entry, this));
            };
            this.resizeItem = (index, size)=>{
                const item = this.measurementsCache[index];
                if (!item) return;
                const itemSize = this.itemSizeCache.get(item.key) ?? item.size;
                const delta = size - itemSize;
                if (delta !== 0) {
                    if (this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(item, delta, this) : item.start < this.getScrollOffset() + this.scrollAdjustments) this._scrollToOffset(this.getScrollOffset(), {
                        adjustments: this.scrollAdjustments += delta,
                        behavior: void 0
                    });
                    this.pendingMeasuredCacheIndexes.push(item.index);
                    this.itemSizeCache = new Map(this.itemSizeCache.set(item.key, size));
                    this.notify(false);
                }
            };
            this.measureElement = (node)=>{
                if (!node) {
                    this.elementsCache.forEach((cached, key)=>{
                        if (!cached.isConnected) {
                            this.observer.unobserve(cached);
                            this.elementsCache.delete(key);
                        }
                    });
                    return;
                }
                this._measureElement(node, void 0);
            };
            this.getVirtualItems = (0, (0, parcelRequire("cDbvq")).memo)(()=>[
                    this.getIndexes(),
                    this.getMeasurements()
                ], (indexes, measurements)=>{
                const virtualItems = [];
                for(let k = 0, len = indexes.length; k < len; k++){
                    const i = indexes[k];
                    const measurement = measurements[i];
                    virtualItems.push(measurement);
                }
                return virtualItems;
            }, {
                key: false,
                debug: ()=>this.options.debug
            });
            this.getVirtualItemForOffset = (offset)=>{
                const measurements = this.getMeasurements();
                if (measurements.length === 0) return void 0;
                return (0, (0, parcelRequire("cDbvq")).notUndefined)(measurements[$fb876145852c2505$var$findNearestBinarySearch(0, measurements.length - 1, (index)=>(0, (0, parcelRequire("cDbvq")).notUndefined)(measurements[index]).start, offset)]);
            };
            this.getOffsetForAlignment = (toOffset, align)=>{
                const size = this.getSize();
                const scrollOffset = this.getScrollOffset();
                if (align === "auto") {
                    if (toOffset <= scrollOffset) align = "start";
                    else if (toOffset >= scrollOffset + size) align = "end";
                    else align = "start";
                }
                if (align === "start") toOffset;
                else if (align === "end") toOffset = toOffset - size;
                else if (align === "center") toOffset = toOffset - size / 2;
                const scrollSizeProp = this.options.horizontal ? "scrollWidth" : "scrollHeight";
                const scrollSize = this.scrollElement ? "document" in this.scrollElement ? this.scrollElement.document.documentElement[scrollSizeProp] : this.scrollElement[scrollSizeProp] : 0;
                const maxOffset = scrollSize - size;
                return Math.max(Math.min(maxOffset, toOffset), 0);
            };
            this.getOffsetForIndex = (index, align = "auto")=>{
                index = Math.max(0, Math.min(index, this.options.count - 1));
                const item = this.measurementsCache[index];
                if (!item) return void 0;
                const size = this.getSize();
                const scrollOffset = this.getScrollOffset();
                if (align === "auto") {
                    if (item.end >= scrollOffset + size - this.options.scrollPaddingEnd) align = "end";
                    else if (item.start <= scrollOffset + this.options.scrollPaddingStart) align = "start";
                    else return [
                        scrollOffset,
                        align
                    ];
                }
                const toOffset = align === "end" ? item.end + this.options.scrollPaddingEnd : item.start - this.options.scrollPaddingStart;
                return [
                    this.getOffsetForAlignment(toOffset, align),
                    align
                ];
            };
            this.isDynamicMode = ()=>this.elementsCache.size > 0;
            this.cancelScrollToIndex = ()=>{
                if (this.scrollToIndexTimeoutId !== null && this.targetWindow) {
                    this.targetWindow.clearTimeout(this.scrollToIndexTimeoutId);
                    this.scrollToIndexTimeoutId = null;
                }
            };
            this.scrollToOffset = (toOffset, { align: align = "start", behavior: behavior } = {})=>{
                this.cancelScrollToIndex();
                if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
                this._scrollToOffset(this.getOffsetForAlignment(toOffset, align), {
                    adjustments: void 0,
                    behavior: behavior
                });
            };
            this.scrollToIndex = (index, { align: initialAlign = "auto", behavior: behavior } = {})=>{
                index = Math.max(0, Math.min(index, this.options.count - 1));
                this.cancelScrollToIndex();
                if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
                const offsetAndAlign = this.getOffsetForIndex(index, initialAlign);
                if (!offsetAndAlign) return;
                const [offset, align] = offsetAndAlign;
                this._scrollToOffset(offset, {
                    adjustments: void 0,
                    behavior: behavior
                });
                if (behavior !== "smooth" && this.isDynamicMode() && this.targetWindow) this.scrollToIndexTimeoutId = this.targetWindow.setTimeout(()=>{
                    this.scrollToIndexTimeoutId = null;
                    const elementInDOM = this.elementsCache.has(this.options.getItemKey(index));
                    if (elementInDOM) {
                        const [latestOffset] = (0, (0, parcelRequire("cDbvq")).notUndefined)(this.getOffsetForIndex(index, align));
                        if (!(0, (0, parcelRequire("cDbvq")).approxEqual)(latestOffset, this.getScrollOffset())) this.scrollToIndex(index, {
                            align: align,
                            behavior: behavior
                        });
                    } else this.scrollToIndex(index, {
                        align: align,
                        behavior: behavior
                    });
                });
            };
            this.scrollBy = (delta, { behavior: behavior } = {})=>{
                this.cancelScrollToIndex();
                if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
                this._scrollToOffset(this.getScrollOffset() + delta, {
                    adjustments: void 0,
                    behavior: behavior
                });
            };
            this.getTotalSize = ()=>{
                var _a;
                const measurements = this.getMeasurements();
                let end;
                if (measurements.length === 0) end = this.options.paddingStart;
                else end = this.options.lanes === 1 ? ((_a = measurements[measurements.length - 1]) == null ? void 0 : _a.end) ?? 0 : Math.max(...measurements.slice(-this.options.lanes).map((m)=>m.end));
                return Math.max(end - this.options.scrollMargin + this.options.paddingEnd, 0);
            };
            this._scrollToOffset = (offset, { adjustments: adjustments, behavior: behavior })=>{
                this.options.scrollToFn(offset, {
                    behavior: behavior,
                    adjustments: adjustments
                }, this);
            };
            this.measure = ()=>{
                this.itemSizeCache = new Map();
                this.notify(false);
            };
            this.setOptions(opts);
        }
    }
    const $fb876145852c2505$var$findNearestBinarySearch = (low, high, getCurrentValue, value)=>{
        while(low <= high){
            const middle = (low + high) / 2 | 0;
            const currentValue = getCurrentValue(middle);
            if (currentValue < value) low = middle + 1;
            else if (currentValue > value) high = middle - 1;
            else return middle;
        }
        if (low > 0) return low - 1;
        else return 0;
    };
    function $fb876145852c2505$var$calculateRange({ measurements: measurements, outerSize: outerSize, scrollOffset: scrollOffset }) {
        const count = measurements.length - 1;
        const getOffset = (index)=>measurements[index].start;
        const startIndex = $fb876145852c2505$var$findNearestBinarySearch(0, count, getOffset, scrollOffset);
        let endIndex = startIndex;
        while(endIndex < count && measurements[endIndex].end < scrollOffset + outerSize)endIndex++;
        return {
            startIndex: startIndex,
            endIndex: endIndex
        };
    }
});
parcelRegister("cDbvq", function(module, exports) {
    $parcel$export(module.exports, "memo", ()=>$93220d646a94e11c$export$7c73462e0d25e514);
    $parcel$export(module.exports, "notUndefined", ()=>$93220d646a94e11c$export$9a1adf421b69c6a);
    $parcel$export(module.exports, "approxEqual", ()=>$93220d646a94e11c$export$8a4f1dcc58a69dbd);
    $parcel$export(module.exports, "debounce", ()=>$93220d646a94e11c$export$61fc7d43ac8f84b0);
    function $93220d646a94e11c$export$7c73462e0d25e514(getDeps, fn, opts) {
        let deps = opts.initialDeps ?? [];
        let result;
        return ()=>{
            var _a, _b, _c, _d;
            let depTime;
            if (opts.key && ((_a = opts.debug) == null ? void 0 : _a.call(opts))) depTime = Date.now();
            const newDeps = getDeps();
            const depsChanged = newDeps.length !== deps.length || newDeps.some((dep, index)=>deps[index] !== dep);
            if (!depsChanged) return result;
            deps = newDeps;
            let resultTime;
            if (opts.key && ((_b = opts.debug) == null ? void 0 : _b.call(opts))) resultTime = Date.now();
            result = fn(...newDeps);
            if (opts.key && ((_c = opts.debug) == null ? void 0 : _c.call(opts))) {
                const depEndTime = Math.round((Date.now() - depTime) * 100) / 100;
                const resultEndTime = Math.round((Date.now() - resultTime) * 100) / 100;
                const resultFpsPercentage = resultEndTime / 16;
                const pad = (str, num)=>{
                    str = String(str);
                    while(str.length < num)str = " " + str;
                    return str;
                };
                console.info(`%c\u{23F1} ${pad(resultEndTime, 5)} /${pad(depEndTime, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * resultFpsPercentage, 120))}deg 100% 31%);`, opts == null ? void 0 : opts.key);
            }
            (_d = opts == null ? void 0 : opts.onChange) == null || _d.call(opts, result);
            return result;
        };
    }
    function $93220d646a94e11c$export$9a1adf421b69c6a(value, msg) {
        if (value === void 0) throw new Error(`Unexpected undefined${msg ? `: ${msg}` : ""}`);
        else return value;
    }
    const $93220d646a94e11c$export$8a4f1dcc58a69dbd = (a, b)=>Math.abs(a - b) < 1;
    const $93220d646a94e11c$export$61fc7d43ac8f84b0 = (targetWindow, fn, ms)=>{
        let timeoutId;
        return function(...args) {
            targetWindow.clearTimeout(timeoutId);
            timeoutId = targetWindow.setTimeout(()=>fn.apply(this, args), ms);
        };
    };
});
parcelRegister("jlrVi", function(module, exports) {
    $parcel$export(module.exports, "useVirtualisedActions", ()=>$471e093fab4fea6e$export$affb102126dcde2a);
    $parcel$export(module.exports, "useVirtualisedItems", ()=>$471e093fab4fea6e$export$a4da365e237701e3);
    $parcel$export(module.exports, "VirtualiseProviderSweetState", ()=>$471e093fab4fea6e$export$6754b86f75c8ce1a);
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    var $iZN6h;
    var $284CM;
    var $6ulzk;
    var $cgSxA;
    const $471e093fab4fea6e$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: (0, (0, parcelRequire("6ulzk")).DEFAULT_VALUE),
        actions: (0, (0, parcelRequire("284CM")).virtualiserActions),
        name: 'timeline-table.virtualise'
    });
    const $471e093fab4fea6e$export$affb102126dcde2a = (0, (0, parcelRequire("3sQ5x")).createHook)($471e093fab4fea6e$var$store, {
        selector: null
    });
    const $471e093fab4fea6e$export$a4da365e237701e3 = (0, (0, parcelRequire("3sQ5x")).createHook)($471e093fab4fea6e$var$store, {
        selector: (0, (0, parcelRequire("cgSxA")).getVirtualisedItems)
    });
    const $471e093fab4fea6e$export$34f4621b58d3fbc8 = ()=>({ dispatch: dispatch }, { itemHeights: itemHeights, isEnabled: isEnabled })=>{
            if (isEnabled) {
                const fallbackItemsCount = Math.round(window.innerHeight / (0, (0, parcelRequire("iZN6h")).DEFAULT_ITEM_HEIGHT));
                const fallbackEnd = Math.min(itemHeights.length - 1, fallbackItemsCount);
                dispatch((0, (0, parcelRequire("284CM")).virtualiserActions).generateVirtualMeta(0, fallbackEnd));
            } else dispatch((0, (0, parcelRequire("284CM")).virtualiserActions).generateVirtualMeta(0, itemHeights.length - 1));
        };
    const $471e093fab4fea6e$export$ab8f0de40a3a2d2d = ()=>({ dispatch: dispatch }, { itemHeights: itemHeights, isEnabled: isEnabled })=>{
            if (!isEnabled) dispatch((0, (0, parcelRequire("284CM")).virtualiserActions).generateVirtualMeta(0, itemHeights.length - 1));
        };
    const $471e093fab4fea6e$export$6754b86f75c8ce1a = (0, (0, parcelRequire("gg7kZ")).createContainer)($471e093fab4fea6e$var$store, {
        onInit: $471e093fab4fea6e$export$34f4621b58d3fbc8,
        onUpdate: $471e093fab4fea6e$export$ab8f0de40a3a2d2d
    });
});
parcelRegister("284CM", function(module, exports) {
    $parcel$export(module.exports, "virtualiserActions", ()=>$b9b0869fd0fa9f88$export$e8a8e63a5a7f1929);
    var $6ulzk;
    const $b9b0869fd0fa9f88$export$e8a8e63a5a7f1929 = {
        generateVirtualMeta: (0, parcelRequire("6ulzk")).generateVirtualMeta
    };
});
parcelRegister("6ulzk", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_VALUE", ()=>$fe837ba7e74306bb$export$66a151256d4631f5);
    $parcel$export(module.exports, "generateVirtualMeta", ()=>$fe837ba7e74306bb$export$ac5dd8f3ecc3f3f9);
    var $k0IsY;
    const $fe837ba7e74306bb$export$66a151256d4631f5 = {
        overscan: (0, $31e198dce5c86093$export$def0e365218ffa1e),
        requiredItems: [],
        overscanRange: {
            start: 0,
            end: 0
        }
    };
    const $fe837ba7e74306bb$export$ac5dd8f3ecc3f3f9 = (startIndex, endIndex)=>({ setState: setState }, { createItemIndex: createItemIndex, itemHeights: itemHeights, items: items })=>{
            if (startIndex !== undefined && endIndex !== undefined) {
                const virtualMeta = (0, (0, parcelRequire("k0IsY")).getVisibleItemsFromIndexes)({
                    createItemIndex: createItemIndex,
                    itemHeights: itemHeights,
                    startIndex: startIndex,
                    endIndex: endIndex,
                    items: items
                });
                setState(virtualMeta);
            } else setState($fe837ba7e74306bb$export$66a151256d4631f5);
        };
});
const $31e198dce5c86093$export$793ed84f5e13fedc = 'TOP';
const $31e198dce5c86093$export$84e1549b474f1b93 = 'BOTTOM';
const $31e198dce5c86093$export$def0e365218ffa1e = 5;
parcelRegister("k0IsY", function(module, exports) {
    $parcel$export(module.exports, "getVisibleItemsFromIndexes", ()=>$5caaafdb8f3b6d57$export$aefb967ef9d43391);
    var $8QpSo;
    var $iZN6h;
    const $5caaafdb8f3b6d57$var$getAccumulateHeight = (0, (0, parcelRequire("8QpSo")).default)((itemHeights)=>itemHeights.reduce((acc, current, index)=>{
            acc.push(current + (index > 0 ? acc[index - 1] : 0));
            return acc;
        }, []));
    const $5caaafdb8f3b6d57$export$b55fce277fa0884f = (startIndex, endIndex, itemHeights)=>{
        if (endIndex <= startIndex) return 0;
        const accumHeight = $5caaafdb8f3b6d57$var$getAccumulateHeight(itemHeights);
        return accumHeight[endIndex - 1] - (startIndex === 0 ? 0 : accumHeight[startIndex - 1]);
    };
    const $5caaafdb8f3b6d57$export$1101758ce03ba6b1 = (index, itemHeights, start, end)=>{
        const before = $5caaafdb8f3b6d57$export$b55fce277fa0884f(start, index, itemHeights);
        const after = $5caaafdb8f3b6d57$export$b55fce277fa0884f(index + 1, end, itemHeights);
        return {
            before: before,
            after: after
        };
    };
    const $5caaafdb8f3b6d57$export$c6fd3ab3f44300d0 = (items, item)=>{
        const ancestors = [];
        if (item) {
            let currentParentId = item.meta.parentId;
            const startingIndex = item.flatIndex - 1;
            for(let i = startingIndex; i >= 0 && currentParentId; i--){
                const currentItem = items[i];
                if (currentItem.type === (0, (0, parcelRequire("iZN6h")).ITEM_TYPE) && currentItem.item.id === currentParentId) {
                    ancestors.push(currentItem);
                    currentParentId = items[i].meta.parentId;
                }
            }
        }
        return ancestors.reverse();
    };
    const $5caaafdb8f3b6d57$export$7adcff1c9f66e792 = (items, createItemIndex)=>{
        const createItem = items[createItemIndex];
        if (createItem === undefined || createItem.type !== (0, (0, parcelRequire("iZN6h")).CREATE_ITEM_TYPE)) return undefined;
        return createItem;
    };
    const $5caaafdb8f3b6d57$export$aefb967ef9d43391 = ({ startIndex: startIndex, endIndex: endIndex, itemHeights: itemHeights, createItemIndex: createItemIndex, items: items, overscan: overscan = (0, $31e198dce5c86093$export$def0e365218ffa1e) })=>{
        const totalCount = itemHeights.length;
        const overscanStart = Math.max(startIndex - overscan, 0);
        const overscanEnd = Math.min(endIndex + overscan, totalCount - 1);
        let createPosition;
        if (createItemIndex > -1 && createItemIndex < overscanStart) createPosition = (0, $31e198dce5c86093$export$793ed84f5e13fedc);
        else if (createItemIndex > overscanEnd) createPosition = (0, $31e198dce5c86093$export$84e1549b474f1b93);
        const createItem = $5caaafdb8f3b6d57$export$7adcff1c9f66e792(items, createItemIndex);
        const invisibleAncestors = $5caaafdb8f3b6d57$export$c6fd3ab3f44300d0(items, items[overscanStart]);
        const createItemAncestors = createPosition && createItem ? $5caaafdb8f3b6d57$export$c6fd3ab3f44300d0(items, createItem) : [];
        const requiredItems = items.filter((item, index)=>index >= overscanStart && index <= overscanEnd || index === createItemIndex || item.type === (0, (0, parcelRequire("iZN6h")).ITEM_TYPE) && (createItemAncestors?.includes(item) || invisibleAncestors?.includes(item)));
        return {
            requiredItems: requiredItems,
            overscanRange: {
                start: overscanStart,
                end: overscanEnd
            },
            overscan: overscan
        };
    };
});
parcelRegister("cgSxA", function(module, exports) {
    $parcel$export(module.exports, "getVirtualisedItems", ()=>$81d149403e50db79$export$fab83018e0db4fa8);
    const $81d149403e50db79$export$fab83018e0db4fa8 = (state)=>state;
});
parcelRegister("kJTbm", function(module, exports) {
    $parcel$export(module.exports, "getItemHeights", ()=>$7089fa4beeab56f9$export$b0c1b33ea0acf206);
    var $iZN6h;
    const $7089fa4beeab56f9$export$b0c1b33ea0acf206 = (items, itemHeight)=>items.map((item)=>{
            const depth = item.type === (0, (0, parcelRequire("iZN6h")).ITEM_TYPE) && item?.item?.depth;
            if (item.type === (0, (0, parcelRequire("iZN6h")).ITEM_TYPE) && depth === 0) return itemHeight;
            if (item.type === (0, (0, parcelRequire("iZN6h")).CREATE_ITEM_TYPE)) return itemHeight;
            return (0, (0, parcelRequire("iZN6h")).BASE_LEVEL_ITEM_HEIGHT)();
        });
});
parcelRegister("hEf85", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1131366f450d3aa8$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $2NMNM;
    var $4R6GH;
    var $l8ruj;
    var $fcOMi;
    var $WPwAA;
    var $hGh1Z;
    var $hUAzM;
    var $cRUzn;
    var $iNpaX;
    var $d6NhP;
    var $iFc7j;
    var $kY4b5;
    var $l75uJ;
    var $3yTFv;
    var $6lHwb;
    var $fepzL;
    var $jIXeo;
    var $kBjnL;
    var $anfdB;
    const $1131366f450d3aa8$var$contentContainerStyles = null;
    const $1131366f450d3aa8$var$Content = ({ isResizeEnabled: isResizeEnabled, DndLongTaskMetric: DndLongTaskMetric, onItemDrop: onItemDrop, onItemSelect: onItemSelect, onItemExpandChanged: onItemExpandChanged, onCreateClick: onCreateClick, onSetListWidth: onSetListWidth, onContentResize: onContentResize, renderListEmptyContent: renderListEmptyContent, renderListItemContent: renderListItemContent, renderListItemSecondaryContent: renderListItemSecondaryContent, renderListItemCreate: renderListItemCreate, renderChartItemContent: renderChartItemContent, renderChartTimelineOverlay: renderChartTimelineOverlay, renderListItemMenuOption: renderListItemMenuOption, renderListItemModal: renderListItemModal })=>{
        const contentContainerRef = (0, $5uXOq.useRef)(null);
        const [{ isDragEnabled: isDragEnabled, isSelectEnabled: isSelectEnabled, isMultiSelectEnabled: isMultiSelectEnabled, isCreateSiblingEnabled: isCreateSiblingEnabled, isCreateChildEnabled: isCreateChildEnabled, isMeatballsButtonEnabled: isMeatballsButtonEnabled }] = (0, (0, parcelRequire("WPwAA")).useEnablements)();
        const [createItemAnchor] = (0, (0, parcelRequire("hGh1Z")).useCreateItemAnchor)();
        const [itemHeight] = (0, (0, parcelRequire("hGh1Z")).useItemHeight)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const onSelect = (0, $5uXOq.useCallback)((id, payload)=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'listItem',
                actionSubjectId: 'issueListItem',
                attributes: payload
            });
            (0, (0, parcelRequire("hUAzM")).fireUIAnalyticsEvent)(analyticsEvent);
            onItemSelect(id, payload, analyticsEvent);
        }, [
            onItemSelect,
            createAnalyticsEvent
        ]);
        const onExpandChanged = (0, $5uXOq.useCallback)((id, isItemExpanded)=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'expansionStateChanged',
                actionSubject: 'listItem',
                actionSubjectId: 'issueListItem',
                attributes: {
                    type: isItemExpanded ? 'collapsed' : 'expanded'
                }
            });
            (0, (0, parcelRequire("hUAzM")).fireUIAnalyticsEvent)(analyticsEvent);
            onItemExpandChanged(id, isItemExpanded);
        }, [
            onItemExpandChanged,
            createAnalyticsEvent
        ]);
        const onDrop = (0, $5uXOq.useCallback)((id, payload)=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'dragEnded',
                actionSubject: 'listItem',
                actionSubjectId: 'issueListItem',
                attributes: {
                    level: payload.level,
                    isReparent: Boolean(payload.parentId),
                    ...(0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y') ? {
                        isMeatballsAction: payload.isMeatballsAction
                    } : {}
                }
            });
            (0, (0, parcelRequire("hUAzM")).fireUIAnalyticsEvent)(analyticsEvent);
            onItemDrop(id, payload, analyticsEvent);
        }, [
            onItemDrop,
            createAnalyticsEvent
        ]);
        const renderCreateItem = (id, anchorItem, { level: level, depth: depth = 0, backgroundColor: backgroundColor, isActive: isActive, ariaRowIndex: ariaRowIndex, topOffset: topOffset })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l75uJ")).default), {
                key: id,
                id: id,
                level: level,
                canCreateChildOverride: Boolean(anchorItem?.canCreateChildOverride),
                depth: depth,
                anchorId: anchorItem?.id,
                itemHeight: itemHeight,
                backgroundColor: backgroundColor,
                isActive: isActive,
                ariaRowIndex: ariaRowIndex,
                topOffset: topOffset,
                onCreateClick: onCreateClick,
                renderListItemCreate: renderListItemCreate
            });
        const renderItem = ({ id: id, level: level, isInTransition: isInTransition, canCreateChildOverride: canCreateChildOverride = true, depth: depth = 0 }, { parentId: parentId, backgroundColor: backgroundColor, isParent: isParent, isExpanded: isExpanded, ariaControls: ariaControls }, index, isVirtual = false)=>{
            if (isVirtual) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fepzL")).default), {
                key: `list-item-lite-${id}`,
                id: id,
                depth: depth,
                itemHeight: itemHeight,
                backgroundColor: backgroundColor,
                renderListItemContent: renderListItemContent,
                renderListItemSecondaryContent: renderListItemSecondaryContent
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d6NhP")).default), {
                id: id,
                key: `chart-item-lite-${id}`,
                depth: depth,
                itemHeight: itemHeight,
                backgroundColor: backgroundColor,
                renderChartItemContent: renderChartItemContent
            }));
            const canCreateChild = (0, (0, parcelRequire("anfdB")).canItemCreateChild)({
                id: id,
                createItemAnchor: createItemAnchor,
                isInTransition: isInTransition,
                isCreateChildEnabled: isCreateChildEnabled,
                canCreateChildOverride: canCreateChildOverride
            });
            const canCreateSibling = (0, (0, parcelRequire("anfdB")).canItemCreateSibling)({
                id: id,
                index: index,
                depth: depth,
                createItemAnchor: createItemAnchor,
                isInTransition: isInTransition,
                isCreateChildEnabled: isCreateChildEnabled,
                isCreateSiblingEnabled: isCreateSiblingEnabled
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jIXeo")).default), {
                ariaControls: ariaControls,
                key: `list-item-${id}`,
                id: id,
                parentId: parentId,
                level: level,
                depth: depth,
                itemHeight: itemHeight,
                backgroundColor: backgroundColor,
                isParent: isParent,
                isExpanded: isExpanded,
                isDragEnabled: isDragEnabled,
                isInTransition: isInTransition,
                isSelectEnabled: isSelectEnabled,
                isMultiSelectEnabled: isMultiSelectEnabled,
                isCreateChildEnabled: canCreateChild,
                isCreateSiblingEnabled: canCreateSibling,
                isMeatballsButtonEnabled: isMeatballsButtonEnabled,
                onSelect: onSelect,
                onDrop: onDrop,
                onExpandChanged: onExpandChanged,
                onInlineCreateClicked: onCreateClick,
                renderListItemContent: renderListItemContent,
                renderListItemSecondaryContent: renderListItemSecondaryContent,
                renderListItemMenuOption: renderListItemMenuOption,
                renderListItemModal: renderListItemModal
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iFc7j")).default), {
                id: id,
                key: `chart-item-${id}`,
                depth: depth,
                parentId: parentId,
                itemHeight: itemHeight,
                backgroundColor: backgroundColor,
                renderChartItemContent: renderChartItemContent
            }));
        };
        const renderItemContainer = ({ parentId: parentId, isExpanded: isExpanded, isParent: isParent, id: id, level: level, depth: depth = 0, topOffset: topOffset, ariaRowIndex: ariaRowIndex, childItemsHeight: childItemsHeight, isInTransition: isInTransition }, _, children)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3yTFv")).default), {
                id: id,
                key: `drop-target-${id}`,
                ariaRowIndex: ariaRowIndex,
                topOffset: topOffset,
                level: level,
                depth: depth,
                parentId: parentId,
                isExpanded: isExpanded,
                isParent: isParent,
                itemHeight: itemHeight,
                childItemsHeight: childItemsHeight,
                isInTransition: isInTransition,
                onDrop: onDrop,
                onExpandChanged: onExpandChanged
            }, children);
        (0, (0, parcelRequire("cRUzn")).useResizeObserver)(contentContainerRef.current, onContentResize);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "timeline-table-content"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            role: "rowgroup",
            ref: contentContainerRef,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kY4b5")).ItemsBackground), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fcOMi")).default), {
            renderItem: renderItem,
            renderItemContainer: renderItemContainer,
            renderCreateItem: renderCreateItem
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6lHwb")).default), {
            renderListEmptyContent: renderListEmptyContent
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iNpaX")).default), {
            renderChartTimelineOverlay: renderChartTimelineOverlay
        }), isResizeEnabled && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kBjnL")).default), {
            DndLongTaskMetric: DndLongTaskMetric,
            onSetListWidth: onSetListWidth
        }));
    };
    $1131366f450d3aa8$var$Content.defaultProps = {
        isResizeEnabled: true,
        onItemDrop: (0, ($parcel$interopDefault($8Rkzz))),
        onItemSelect: (0, ($parcel$interopDefault($8Rkzz))),
        onItemExpandChanged: (0, ($parcel$interopDefault($8Rkzz))),
        onCreateClick: (0, ($parcel$interopDefault($8Rkzz))),
        onSetListWidth: (0, ($parcel$interopDefault($8Rkzz))),
        onContentResize: (0, ($parcel$interopDefault($8Rkzz)))
    };
    $1131366f450d3aa8$var$Content.displayName = 'Content';
    $1131366f450d3aa8$var$Content.whyDidYouRender = true;
    var $1131366f450d3aa8$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($1131366f450d3aa8$var$Content);
});
parcelRegister("fcOMi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d1c4dd68c4d10c32$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $iZN6h;
    var $hGh1Z;
    var $jlrVi;
    const $d1c4dd68c4d10c32$var$ItemsRenderer = ({ renderItem: renderItem, renderItemContainer: renderItemContainer, renderCreateItem: renderCreateItem })=>{
        const [virtualisedData] = (0, (0, parcelRequire("jlrVi")).useVirtualisedItems)();
        const createItemAnchorIndex = (0, (0, parcelRequire("hGh1Z")).useCreateItemAnchorIndex)();
        const { requiredItems: requiredItems = [], overscanRange: overscanRange } = virtualisedData;
        const getIsVirtual = (flatIndex)=>(flatIndex < overscanRange.start || flatIndex > overscanRange.end) && flatIndex !== createItemAnchorIndex;
        const getIsVirtualOld = (flatIndex)=>flatIndex < overscanRange.start || flatIndex > overscanRange.end;
        const renderedItems = $d1c4dd68c4d10c32$var$renderList({
            items: requiredItems,
            getIsVirtual: (0, (0, parcelRequire("4R6GH")).fg)('timeline_grid_navigation_m2') ? getIsVirtual : getIsVirtualOld,
            parentItem: undefined,
            renderItem: renderItem,
            renderItemContainer: renderItemContainer,
            renderCreateItem: renderCreateItem
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, renderedItems);
    };
    const $d1c4dd68c4d10c32$var$renderList = ({ items: items, getIsVirtual: getIsVirtual, parentItem: parentItem, renderItem: renderItem, renderItemContainer: renderItemContainer, renderCreateItem: renderCreateItem })=>{
        const flatItemElements = [];
        const getItemsToRender = (parentFlatItem, flatItems)=>{
            if (parentFlatItem === undefined) return flatItems.filter(({ meta: meta })=>!meta.parentId);
            return flatItems.filter(({ meta: meta })=>meta.parentId === parentFlatItem.item.id);
        };
        const itemsToRender = getItemsToRender(parentItem, items);
        itemsToRender?.forEach((enrichedItem)=>{
            if (enrichedItem.type === (0, (0, parcelRequire("iZN6h")).ITEM_TYPE)) {
                const itemContainerChildren = [];
                const { item: item, meta: meta, flatIndex: flatIndex } = enrichedItem;
                itemContainerChildren.push(renderItem(item, meta, flatIndex, getIsVirtual(flatIndex)));
                const { isExpanded: isExpanded, isParent: isParent, numChildren: numChildren = 0, ariaRowIndex: ariaRowIndex, topOffset: topOffset, childItemsHeight: childItemsHeight } = meta;
                const parentItemContainerMeta = {
                    parentId: parentItem?.item.id,
                    isExpanded: isExpanded,
                    isParent: isParent,
                    id: item.id,
                    level: item.level,
                    depth: item.depth,
                    ariaRowIndex: ariaRowIndex,
                    topOffset: topOffset,
                    childItemsHeight: childItemsHeight,
                    isInTransition: item.isInTransition
                };
                flatItemElements.push(renderItemContainer(parentItemContainerMeta, 0, itemContainerChildren));
                if (isExpanded && numChildren > 0) {
                    const renderedChildItems = $d1c4dd68c4d10c32$var$renderList({
                        items: items,
                        getIsVirtual: getIsVirtual,
                        parentItem: enrichedItem,
                        renderItem: renderItem,
                        renderItemContainer: renderItemContainer,
                        renderCreateItem: renderCreateItem
                    });
                    flatItemElements.push(...renderedChildItems);
                }
            } else if (enrichedItem.type === (0, (0, parcelRequire("iZN6h")).CREATE_ITEM_TYPE)) flatItemElements.push(renderCreateItem(enrichedItem.id, enrichedItem.anchorItem, enrichedItem.meta));
        });
        return flatItemElements;
    };
    var $d1c4dd68c4d10c32$export$2e2bcd8739ae039 = $d1c4dd68c4d10c32$var$ItemsRenderer;
});
parcelRegister("iNpaX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$180762d2c6c2429a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $4R6GH;
    var $dCm1o;
    var $iZN6h;
    var $WPwAA;
    var $g3prf;
    var $biT18;
    var $1III9;
    var $6Z5oR;
    var $8ZDUa;
    const $180762d2c6c2429a$var$containerStyles = null;
    const $180762d2c6c2429a$var$chartContainerStyles = null;
    const $180762d2c6c2429a$var$ScrollableOverlay = ({ isOverlayInHeader: isOverlayInHeader, renderChartTimelineOverlay: renderChartTimelineOverlay })=>{
        const columnsOverlayElementsRef = (0, $5uXOq.useRef)({});
        const [{ today: today, timelineMode: timelineMode, timelineDuration: timelineDuration, columnDurations: columnDurations, timelineWidth: timelineWidth }] = (0, (0, parcelRequire("biT18")).useTimelineState)();
        const [{ headerHeight: headerHeight }] = (0, (0, parcelRequire("g3prf")).useHeaderState)();
        const [{ isHighlightToday: isHighlightToday }] = (0, (0, parcelRequire("WPwAA")).useEnablements)();
        if (!columnsOverlayElementsRef.current[timelineMode]) columnsOverlayElementsRef.current[timelineMode] = $5uXOq.createElement((0, (0, parcelRequire("1III9")).default), {
            isHighlightToday: isHighlightToday,
            today: today,
            timelineDuration: timelineDuration,
            columnDurations: columnDurations,
            ...(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_2') ? {
                isOverlayInHeader: isOverlayInHeader ?? false,
                subheaderHeight: headerHeight - (0, (0, parcelRequire("iZN6h")).BASE_HEADER_HEIGHT)
            } : {}
        });
        return $5uXOq.createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _1e0c1txw _154iidpf _94n5idpf _1ltvidpf _1bsb1osq _lcxvglyw"
            ])
        }, $5uXOq.createElement((0, (0, parcelRequire("6Z5oR")).default), null), $5uXOq.createElement("div", {
            style: {
                ...isOverlayInHeader ? {
                    position: 'sticky',
                    top: 0
                } : {
                    position: 'relative',
                    top: `${headerHeight}px`,
                    height: `calc(100% - ${headerHeight}px)`
                },
                width: `${timelineWidth}px`
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlidpf _1o9zidpf _i0dl1wug"
            ])
        }, columnsOverlayElementsRef.current[timelineMode], !isOverlayInHeader && renderChartTimelineOverlay(), !isOverlayInHeader && isHighlightToday && $5uXOq.createElement((0, (0, parcelRequire("8ZDUa")).default), {
            today: today,
            timelineMode: timelineMode,
            timelineDuration: timelineDuration
        })));
    };
    var $180762d2c6c2429a$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($180762d2c6c2429a$var$ScrollableOverlay);
});
parcelRegister("1III9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b31806079c71ac72$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $dCm1o;
    var $iwcO1;
    var $jKvH8;
    const $b31806079c71ac72$var$ColumnsOverlay = ({ isHighlightToday: isHighlightToday, today: today, timelineDuration: timelineDuration, columnDurations: columnDurations, isOverlayInHeader: isOverlayInHeader, subheaderHeight: subheaderHeight })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jKvH8")).default), {
            isHighlightToday: isHighlightToday,
            columnPositions: (0, (0, parcelRequire("iwcO1")).getColumnPositions)(timelineDuration, columnDurations),
            todayColumnIndex: (0, (0, parcelRequire("iwcO1")).getTodayColumnIndex)(today, columnDurations),
            ...(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_2') ? {
                isOverlayInHeader: isOverlayInHeader,
                subheaderHeight: subheaderHeight
            } : {}
        });
    var $b31806079c71ac72$export$2e2bcd8739ae039 = $b31806079c71ac72$var$ColumnsOverlay;
});
parcelRegister("jKvH8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$091b57fdf9854bbb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $dC5iT;
    var $8CUq3;
    var $4R6GH;
    var $dCm1o;
    var $jfF8l;
    const $091b57fdf9854bbb$var$Columns = ({ isHighlightToday: isHighlightToday, todayColumnIndex: todayColumnIndex, columnPositions: columnPositions, isOverlayInHeader: isOverlayInHeader, subheaderHeight: subheaderHeight })=>{
        const visuallyRefreshedContent = (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_2') ? $5uXOq.createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $091b57fdf9854bbb$var$todayColumnBorderStyles
        }, $5uXOq.createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                isOverlayInHeader ? $091b57fdf9854bbb$var$todayHeaderColumnStyles : $091b57fdf9854bbb$var$todayColumnStyles
            ],
            style: {
                ...isOverlayInHeader && {
                    height: `calc(100% - ${subheaderHeight}px)`
                }
            }
        })) : $5uXOq.createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _vchhusvi _154iidpf _1xi21n1a _1ltv1n1a _4t3i1osq _bfhkiw92 _1kl71xde _1s7z1xde"
            ])
        });
        return $5uXOq.createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _1e0c1txw _154iidpf _1bsb1osq _4t3i1osq _lcxvglyw"
            ])
        }, columnPositions.map(([left, right], index)=>$5uXOq.createElement("div", {
                key: `column-position-${index}`,
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_kqswstnw _vchhusvi _16jlidpf _1o9zidpf _i0dl1wug _154iidpf _94n5idpf _1s7z1hum"
                ]),
                style: {
                    left: `${left}%`,
                    right: `${right}%`,
                    "--_1p5ufam": (0, (0, parcelRequire("lD23V")).default)((0, (0, parcelRequire("jfF8l")).secondaryBorder))
                }
            }, todayColumnIndex === index && isHighlightToday ? visuallyRefreshedContent : null)));
    };
    var $091b57fdf9854bbb$export$2e2bcd8739ae039 = $091b57fdf9854bbb$var$Columns;
    const $091b57fdf9854bbb$var$containerStyles = null;
    const $091b57fdf9854bbb$var$columnStyles = null;
    const $091b57fdf9854bbb$var$todayColumnStylesOld = null;
    const $091b57fdf9854bbb$var$todayColumnStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'absolute',
        boxSizing: 'border-box',
        top: '0',
        right: '-1px',
        left: '-1px',
        height: '100%',
        backgroundColor: 'color.background.neutral'
    });
    const $091b57fdf9854bbb$var$todayHeaderColumnStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'absolute',
        boxSizing: 'border-box',
        top: '0',
        right: '-1px',
        left: '-1px',
        backgroundColor: 'color.background.neutral'
    });
    const $091b57fdf9854bbb$var$todayColumnBorderStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'absolute',
        boxSizing: 'border-box',
        top: '0',
        right: '-1px',
        left: '-1px',
        height: '100%',
        borderLeft: `1px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$export$791e57b27ca738ef)})`}`,
        borderRight: `1px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$export$791e57b27ca738ef)})`}`
    });
});
parcelRegister("jfF8l", function(module, exports) {
    $parcel$export(module.exports, "secondaryBorderColor", ()=>$e1127bc9a1fd77e3$export$95d9e829dbec7e8b);
    $parcel$export(module.exports, "secondaryBorder", ()=>$e1127bc9a1fd77e3$export$a84a730095edc78);
    const $e1127bc9a1fd77e3$export$12879c7697ed953d = 1;
    const $e1127bc9a1fd77e3$export$95d9e829dbec7e8b = `var(--ds-border, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`;
    const $e1127bc9a1fd77e3$export$a84a730095edc78 = `${$e1127bc9a1fd77e3$export$12879c7697ed953d}px solid ${$e1127bc9a1fd77e3$export$95d9e829dbec7e8b}`;
    const $e1127bc9a1fd77e3$export$d1cf5418fbd2830d = 'background-color 100ms linear';
});
parcelRegister("6Z5oR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1f006b9c4cd5a6e5$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $9puhl;
    const $1f006b9c4cd5a6e5$var$containerStyles = null;
    const $1f006b9c4cd5a6e5$var$ListCover = ()=>{
        const [listWidth] = (0, (0, parcelRequire("9puhl")).useListWidth)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                width: `${listWidth}px`
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqsw1if8 _16jlidpf _1o9zidpf _i0dl1wug _1ltvidpf _11q7vuon _1pby37uc"
            ])
        });
    };
    var $1f006b9c4cd5a6e5$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($1f006b9c4cd5a6e5$var$ListCover);
});
parcelRegister("8ZDUa", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$00b0778a4e9de6b9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bFxJH;
    var $d23XT;
    var $8Z2vH;
    const $00b0778a4e9de6b9$var$TodayMarker = ({ today: today, timelineMode: timelineMode, timelineDuration: timelineDuration })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Z2vH")).default), {
            todayPosition: (0, (0, parcelRequire("d23XT")).getTodayPosition)(today, timelineDuration, (0, (0, parcelRequire("bFxJH")).getTimelineWidth)(timelineMode, timelineDuration.totalMilliseconds))
        });
    var $00b0778a4e9de6b9$export$2e2bcd8739ae039 = $00b0778a4e9de6b9$var$TodayMarker;
});
parcelRegister("d23XT", function(module, exports) {
    $parcel$export(module.exports, "getTodayPosition", ()=>$68f530816a63571f$export$1c4a20ec05eb2ad0);
    var $2gnC5 = parcelRequire("2gnC5");
    const $68f530816a63571f$export$1c4a20ec05eb2ad0 = (today, timelineDuration, timelineWidth)=>{
        const middleOfToday = (0, ($parcel$interopDefault($2gnC5))).utc(today).add(12, 'hour').valueOf();
        const relativePosition = (middleOfToday - timelineDuration.startMilliseconds) / timelineDuration.totalMilliseconds;
        return relativePosition * timelineWidth - 2;
    };
});
parcelRegister("8Z2vH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8bfe7f2a3f57a3af$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $g3prf;
    const $8bfe7f2a3f57a3af$var$MARKER_LINE_WIDTH = 2;
    const $8bfe7f2a3f57a3af$var$POINTER_WIDTH = 4;
    const $8bfe7f2a3f57a3af$var$containerStyles = null;
    const $8bfe7f2a3f57a3af$var$markerStyles = null;
    const $8bfe7f2a3f57a3af$var$pointerStyles = null;
    const $8bfe7f2a3f57a3af$var$TodayMarkerLine = ({ todayPosition: todayPosition })=>{
        const [{ headerHeight: headerHeight }] = (0, (0, parcelRequire("g3prf")).useHeaderState)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "roadmap.timeline-table.main.scrollable-overlay.today-marker.container",
            style: {
                left: `${todayPosition}px`
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _1e0c1txw _154iidpf _94n5idpf _1pbyouyt _lcxvglyw"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            role: "presentation",
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsbyh40 _4t3i1osq _bfhk1sn9"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            style: {
                top: `${headerHeight}px`
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqsw1if8 _1bsbidpf _4t3iidpf _18u0j39m _x3dom65w _1s7z12me _1kl712me"
            ])
        })));
    };
    var $8bfe7f2a3f57a3af$export$2e2bcd8739ae039 = $8bfe7f2a3f57a3af$var$TodayMarkerLine;
});
parcelRegister("d6NhP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$416a82879be86d97$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $biT18;
    var $6MiMm;
    const $416a82879be86d97$var$ChartItemLite = ({ id: id, depth: depth, itemHeight: itemHeight, backgroundColor: backgroundColor, renderChartItemContent: renderChartItemContent })=>{
        const rendererProps = {
            id: id
        };
        const rendererState = {
            isVirtual: true,
            isHovered: false
        };
        const [{ timelineWidth: timelineWidth }] = (0, (0, parcelRequire("biT18")).useTimelineState)();
        const height = (0, (0, parcelRequire("6MiMm")).getContainerHeight)({
            itemHeight: itemHeight,
            depth: depth
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            role: "gridcell",
            tabIndex: -1,
            xcss: $416a82879be86d97$var$chartItemLiteContainerStyles,
            style: {
                width: `${timelineWidth}px`,
                height: height,
                backgroundColor: backgroundColor
            }
        }, renderChartItemContent(rendererProps, rendererState));
    };
    const $416a82879be86d97$var$chartItemLiteContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden'
    });
    var $416a82879be86d97$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($416a82879be86d97$var$ChartItemLite);
});
parcelRegister("6MiMm", function(module, exports) {
    $parcel$export(module.exports, "getContainerHeight", ()=>$fb592467990ecf1e$export$cf6292b4985d86a5);
    var $4R6GH;
    var $dCm1o;
    const $fb592467990ecf1e$export$cf6292b4985d86a5 = ({ itemHeight: itemHeight, depth: depth })=>{
        const height = depth > 0 ? (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_2') ? "var(--ds-space-500, 40px)" : "var(--ds-space-400, 32px)" : `${itemHeight}px`;
        return height;
    };
});
parcelRegister("iFc7j", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9f6cda27f063330d$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $2NMNM;
    var $4R6GH;
    var $iZN6h;
    var $5BWo9;
    var $3ruU1;
    var $ghKWA;
    var $biT18;
    var $kCVTH;
    var $6MiMm;
    const $9f6cda27f063330d$var$itemBaseStyles = null;
    const $9f6cda27f063330d$var$chartItemContainer = null;
    const $9f6cda27f063330d$var$ChartItem = ({ id: id, parentId: parentId, depth: depth, itemHeight: itemHeight, backgroundColor: backgroundColor, renderChartItemContent: renderChartItemContent })=>{
        const [isHovered, setIsHovered] = (0, $5uXOq.useState)(false);
        const { onRowMouseEnter: onRowMouseEnter, onRowMouseLeave: onRowMouseLeave } = (0, (0, parcelRequire("3ruU1")).useSideEffectMarshal)();
        const [{ timelineWidth: timelineWidth }] = (0, (0, parcelRequire("biT18")).useTimelineState)();
        const cellRef = (0, (0, parcelRequire("5BWo9")).useGridCell)(id, (0, (0, parcelRequire("iZN6h")).CHART_COLUMN_COORDINATE));
        let onCellKeyDown;
        if ((0, (0, parcelRequire("4R6GH")).fg)('project_timeline_multi-select_and_checkboxes')) {
            const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
            const { handleKeyDown: handleKeyDown } = (0, (0, parcelRequire("kCVTH")).useItemSelect)(id);
            onCellKeyDown = (0, $5uXOq.useCallback)((event)=>{
                if (event.target === event.currentTarget) {
                    const analyticsEvent = createAnalyticsEvent({
                        action: 'keydown',
                        actionSubject: 'chartItem',
                        actionSubjectId: 'issueChartItem'
                    });
                    handleKeyDown(event, analyticsEvent);
                }
            }, [
                createAnalyticsEvent,
                handleKeyDown
            ]);
        }
        const onMouseEnter = (0, $5uXOq.useCallback)(()=>{
            onRowMouseEnter(id);
            setIsHovered(true);
        }, [
            id,
            onRowMouseEnter
        ]);
        const onMouseLeave = (0, $5uXOq.useCallback)(()=>{
            onRowMouseLeave(id);
            setIsHovered(false);
        }, [
            id,
            onRowMouseLeave
        ]);
        const rendererProps = {
            id: id
        };
        const rendererState = {
            isVirtual: false,
            isHovered: isHovered
        };
        const height = (0, (0, parcelRequire("6MiMm")).getContainerHeight)({
            itemHeight: itemHeight,
            depth: depth
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: cellRef,
            role: "gridcell",
            tabIndex: -1,
            "data-testid": `roadmap.timeline-table.components.chart-item.container-${id}`,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _v564lfip _nt751r31 _49pcglyw _1hvw1o36 _1ejj168b",
                "_kqswh2mm _1reo15vq _18m915vq",
                (0, (0, parcelRequire("ghKWA")).getRowClassName)(id, parentId).className
            ]),
            style: {
                width: `${timelineWidth}px`,
                height: `${height}`,
                backgroundColor: backgroundColor
            },
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onKeyDown: onCellKeyDown,
            ...(0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-row-highlight-bar-focus') ? {
                onFocus: onMouseEnter,
                onBlur: onMouseLeave
            } : {}
        }, renderChartItemContent(rendererProps, rendererState));
    };
    $9f6cda27f063330d$var$ChartItem.displayName = 'ChartItem';
    $9f6cda27f063330d$var$ChartItem.whyDidYouRender = true;
    var $9f6cda27f063330d$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($9f6cda27f063330d$var$ChartItem);
});
parcelRegister("5BWo9", function(module, exports) {
    $parcel$export(module.exports, "useGridCell", ()=>$d785e5aac36d54e8$export$c7e10bfc0c59f67c);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $82CeN;
    const $d785e5aac36d54e8$export$c7e10bfc0c59f67c = (rowId, column, isOriginCell = false)=>{
        const element = (0, $5uXOq.useRef)(null);
        const { trackCell: trackCell, untrackCell: untrackCell, focusCell: focusCell, blurCell: blurCell, initialiseRovingCell: initialiseRovingCell } = (0, (0, parcelRequire("82CeN")).useFocusMarshal)();
        const setCellRef = (0, $5uXOq.useCallback)((ref)=>{
            element.current = ref;
        }, []);
        const getData = (0, $5uXOq.useCallback)(()=>({
                rowId: rowId,
                column: column
            }), [
            rowId,
            column
        ]);
        const getContent = (0, $5uXOq.useCallback)(()=>{
            if (!element.current) return [];
            const keyboardFocusable = element.current.querySelectorAll('a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])');
            return Array.from(keyboardFocusable).filter((e)=>e instanceof HTMLElement && !e.hasAttribute('disabled'));
        }, []);
        const onFocus = (0, $5uXOq.useCallback)((event)=>{
            if (element.current && event.target instanceof HTMLElement) focusCell(element.current, event.target);
        }, [
            focusCell
        ]);
        const onBlur = (0, $5uXOq.useCallback)((event)=>{
            if (event.target instanceof HTMLElement) blurCell(event.target);
        }, [
            blurCell
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!element.current || !(0, (0, parcelRequire("4R6GH")).fg)('timeline_grid_navigation_m2')) return;
            const setup = (safeElement)=>{
                trackCell(safeElement, getData, getContent);
                isOriginCell && initialiseRovingCell(safeElement);
                safeElement.addEventListener('focusin', onFocus);
                safeElement.addEventListener('focusout', onBlur);
                return ()=>{
                    untrackCell(safeElement);
                    safeElement.removeEventListener('focusin', onFocus);
                    safeElement.removeEventListener('focusout', onBlur);
                };
            };
            const cleanup = setup(element.current);
            return ()=>{
                cleanup();
            };
        }, [
            rowId,
            column,
            isOriginCell,
            getData,
            getContent,
            trackCell,
            untrackCell,
            initialiseRovingCell,
            onFocus,
            onBlur
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!element.current || (0, (0, parcelRequire("4R6GH")).fg)('timeline_grid_navigation_m2')) return;
            const setup = (safeElement)=>{
                trackCell(safeElement, getData, ()=>[]);
                isOriginCell && initialiseRovingCell(safeElement);
                return ()=>untrackCell(safeElement);
            };
            const cleanup = setup(element.current);
            return ()=>{
                cleanup();
            };
        }, [
            rowId,
            column,
            isOriginCell,
            getData,
            trackCell,
            untrackCell,
            initialiseRovingCell
        ]);
        return setCellRef;
    };
});
parcelRegister("kCVTH", function(module, exports) {
    $parcel$export(module.exports, "useItemSelect", ()=>$b5f5b1b1288d26b4$export$a7ddc5029ca778e1);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $WPwAA;
    var $hGh1Z;
    const $b5f5b1b1288d26b4$export$a7ddc5029ca778e1 = (id)=>{
        const [{ isMultiSelectEnabled: isMultiSelectEnabled, isSelectEnabled: isSelectEnabled }] = (0, (0, parcelRequire("WPwAA")).useEnablements)();
        const [selected = false, { toggleItem: toggleItem, activateItem: activateItem }] = (0, (0, parcelRequire("hGh1Z")).useIsItemSelected)(id);
        const [isItemSelectable = false] = (0, (0, parcelRequire("hGh1Z")).useIsItemSelectable)(id);
        const handleClick = (0, $5uXOq.useCallback)(({ ctrlKey: ctrlKey, metaKey: metaKey, shiftKey: shiftKey, currentTarget: currentTarget }, analyticsEvent, ref)=>{
            const isCheckbox = currentTarget instanceof HTMLInputElement && currentTarget.type === 'checkbox';
            const shouldOnlyToggleItem = isMultiSelectEnabled && (isCheckbox || ctrlKey || metaKey || shiftKey);
            if (shouldOnlyToggleItem && isItemSelectable) return toggleItem(id, {
                analyticsEvent: analyticsEvent,
                withRange: shiftKey
            });
            if (isSelectEnabled && !shouldOnlyToggleItem) return (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps-timeline-bento-refocusing') ? activateItem(id, ref) : activateItem(id);
        }, [
            isSelectEnabled,
            isMultiSelectEnabled,
            activateItem,
            id,
            isItemSelectable,
            toggleItem
        ]);
        const handleKeyDown = (0, $5uXOq.useCallback)(({ shiftKey: shiftKey, ctrlKey: ctrlKey, metaKey: metaKey, altKey: altKey, key: key }, analyticsEvent)=>{
            if (isMultiSelectEnabled && isItemSelectable && shiftKey && key === ' ' && !(ctrlKey || metaKey || altKey)) toggleItem(id, {
                analyticsEvent: analyticsEvent
            });
        }, [
            id,
            isItemSelectable,
            isMultiSelectEnabled,
            toggleItem
        ]);
        return {
            selectable: isItemSelectable,
            selected: selected,
            handleClick: handleClick,
            handleKeyDown: handleKeyDown
        };
    };
});
parcelRegister("kY4b5", function(module, exports) {
    $parcel$export(module.exports, "ItemsBackground", ()=>$c0fd3dbe9b4d507e$export$2473dc1b5c75a4f);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $iZN6h;
    var $hGh1Z;
    var $9puhl;
    var $ghKWA;
    const $c0fd3dbe9b4d507e$var$container = null;
    const $c0fd3dbe9b4d507e$var$sticky = null;
    const $c0fd3dbe9b4d507e$var$widthApproximation = null;
    const $c0fd3dbe9b4d507e$export$2473dc1b5c75a4f = ()=>{
        const [{ itemsBackground: itemsBackground, totalHeight: totalHeight }] = (0, (0, parcelRequire("hGh1Z")).useItemsContainerStyles)();
        const [listWidth] = (0, (0, parcelRequire("9puhl")).useListWidth)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            role: "presentation",
            style: {
                height: `${totalHeight}px`
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqsw1if8 _1ltvidpf _lcxvglyw",
                (0, (0, parcelRequire("ghKWA")).getItemsBackgroundClassName)().className
            ]),
            style: {
                background: itemsBackground,
                width: listWidth,
                zIndex: (0, (0, parcelRequire("iZN6h")).zIndex).LIST
            }
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqsw1if8 _1ltvidpf _lcxvglyw",
                "_1bsbauwl",
                (0, (0, parcelRequire("ghKWA")).getItemsBackgroundClassName)().className
            ]),
            style: {
                background: itemsBackground
            }
        }));
    };
});
parcelRegister("l75uJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3b9acaadbd20ff30$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $biT18;
    var $7ouUj;
    var $bzkdK;
    const $3b9acaadbd20ff30$var$itemBaseStyles = null;
    const $3b9acaadbd20ff30$var$containerStyles = null;
    const $3b9acaadbd20ff30$var$chartCreateItemStyles = null;
    const $3b9acaadbd20ff30$var$CreateItem = ({ id: id, level: level, depth: depth, anchorId: anchorId, canCreateChildOverride: canCreateChildOverride, itemHeight: itemHeight, topOffset: topOffset, ariaRowIndex: ariaRowIndex, backgroundColor: backgroundColor, isActive: isActive, onCreateClick: onCreateClick, renderListItemCreate: renderListItemCreate })=>{
        const [{ timelineWidth: timelineWidth }] = (0, (0, parcelRequire("biT18")).useTimelineState)();
        const createItemBackgroundColor = isActive && (0, (0, parcelRequire("7ouUj")).isRoot)(depth) ? `var(--ds-surface-pressed, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})` : backgroundColor;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "roadmap.timeline-table.main.content.list.create-item.button",
            role: "row",
            "aria-rowindex": ariaRowIndex,
            style: {
                top: `${topOffset}px`,
                height: `${itemHeight}px`
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _v564lfip",
                "_kqswstnw _1bsb1osq"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bzkdK")).default), {
            id: id,
            isActive: isActive,
            anchorId: anchorId,
            canCreateChildOverride: canCreateChildOverride,
            level: level,
            depth: depth,
            itemHeight: itemHeight,
            backgroundColor: backgroundColor,
            onCreateClick: onCreateClick,
            renderListItemCreate: renderListItemCreate
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                width: `${timelineWidth}px`,
                height: `${itemHeight}px`,
                backgroundColor: createItemBackgroundColor
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _16jlidpf _1o9zidpf _i0dl1wug"
            ])
        }));
    };
    var $3b9acaadbd20ff30$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($3b9acaadbd20ff30$var$CreateItem);
});
parcelRegister("bzkdK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d55020d2502d8e47$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $2NMNM;
    var $dC5iT;
    var $8CUq3;
    var $eTXmK;
    var $4R6GH;
    var $dCm1o;
    var $iZN6h;
    var $WPwAA;
    var $hGh1Z;
    var $9puhl;
    var $5BWo9;
    var $a7L1o;
    var $hUAzM;
    var $7ouUj;
    const $d55020d2502d8e47$var$listCreateItemCellStylesOld = null;
    const $d55020d2502d8e47$var$listCreateItemCellStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        alignItems: 'center',
        position: 'sticky',
        flex: '0 0 auto',
        boxSizing: 'border-box',
        left: 'space.0',
        ':focus': {
            outline: 'none'
        },
        ':focus-visible': {
            outline: `2px solid ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`}`
        }
    });
    const $d55020d2502d8e47$var$ListCreateItem = ({ id: id, isActive: isActive, anchorId: anchorId, level: level, depth: depth, itemHeight: itemHeight, backgroundColor: backgroundColor, onCreateClick: onCreateClick, renderListItemCreate: renderListItemCreate, canCreateChildOverride: canCreateChildOverride })=>{
        let isMultiSelectEnabled;
        if ((0, (0, parcelRequire("4R6GH")).fg)('project_timeline_multi-select_and_checkboxes')) [{ isMultiSelectEnabled: isMultiSelectEnabled }] = (0, (0, parcelRequire("WPwAA")).useEnablements)();
        const [isListEmpty] = (0, (0, parcelRequire("hGh1Z")).useIsTableEmpty)();
        const [listWidth] = (0, (0, parcelRequire("9puhl")).useListWidth)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const cellRef = (0, (0, parcelRequire("5BWo9")).useGridCell)(id, (0, (0, parcelRequire("iZN6h")).LIST_COLUMN_COORDINATE));
        (0, $5uXOq.useEffect)(()=>{
            if (isListEmpty) onCreateClick({
                position: (0, (0, parcelRequire("iZN6h")).LAST)
            });
        }, []);
        const onClick = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("eTXmK")).default)('timeline-add-item-clicked');
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'issueCreateButton',
                attributes: {
                    position: (0, (0, parcelRequire("iZN6h")).LAST)
                }
            });
            (0, (0, parcelRequire("hUAzM")).fireUIAnalyticsEvent)(analyticsEvent);
            onCreateClick({
                position: (0, (0, parcelRequire("iZN6h")).LAST)
            });
        }, [
            onCreateClick,
            createAnalyticsEvent
        ]);
        const createItemBackgroundColor = isActive && (0, (0, parcelRequire("7ouUj")).isRoot)(depth) ? `var(--ds-surface-pressed, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})` : backgroundColor;
        const paddingLeftStyle = !(0, (0, parcelRequire("7ouUj")).isRoot)(depth) ? {
            paddingLeft: `${(0, (0, parcelRequire("a7L1o")).getListContentPaddingLeft)({
                depth: depth,
                ...(0, (0, parcelRequire("4R6GH")).fg)('project_timeline_multi-select_and_checkboxes') && {
                    hasCheckbox: isMultiSelectEnabled
                },
                isCreate: true,
                isParent: false
            })}px`
        } : {};
        return (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            ref: cellRef,
            role: "gridcell",
            tabIndex: -1,
            paddingInline: "space.050",
            paddingBlock: "space.0",
            xcss: $d55020d2502d8e47$var$listCreateItemCellStyles,
            style: {
                zIndex: (0, (0, parcelRequire("iZN6h")).zIndex).LIST_CREATE_ITEM,
                width: `${listWidth}px`,
                height: `${itemHeight}px`,
                ...paddingLeftStyle,
                backgroundColor: createItemBackgroundColor
            }
        }, renderListItemCreate({
            anchorId: anchorId,
            level: level,
            onClick: onClick,
            canCreateChildOverride: canCreateChildOverride
        }, {
            isActive: isActive
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: cellRef,
            role: "gridcell",
            tabIndex: -1,
            style: {
                width: `${listWidth}px`,
                height: `${itemHeight}px`,
                ...paddingLeftStyle,
                backgroundColor: createItemBackgroundColor
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqsw1if8 _1e0c1txw _4cvr1h6o _16jlidpf _1o9zidpf _i0dl1wug _vchhusvi _1ltvidpf _1yt4s8vo _1pbyzo7u _nt751r31 _49pcglyw _1hvw1o36 _1ejj168b"
            ])
        }, renderListItemCreate({
            anchorId: anchorId,
            level: level,
            onClick: onClick,
            canCreateChildOverride: canCreateChildOverride
        }, {
            isActive: isActive
        }));
    };
    var $d55020d2502d8e47$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($d55020d2502d8e47$var$ListCreateItem);
});
parcelRegister("a7L1o", function(module, exports) {
    $parcel$export(module.exports, "getListContentPaddingLeft", ()=>$f6631d4525bf464e$export$ca5712918dfd7d6b);
    var $4R6GH;
    var $dCm1o;
    const $f6631d4525bf464e$var$GRID_SIZE = 8;
    const $f6631d4525bf464e$var$DEFAULT_LIST_CONTENT_PADDING = $f6631d4525bf464e$var$GRID_SIZE * 3;
    const $f6631d4525bf464e$var$NON_BASE_LEVEL_LIST_CONTENT_PADDING = 0;
    const $f6631d4525bf464e$var$DEFAULT_LIST_CREATE_OFFSET = -12;
    const $f6631d4525bf464e$var$CHECKBOX_SPACE = 36;
    const $f6631d4525bf464e$var$CHECKBOX_SPACE_OLD = 32;
    const $f6631d4525bf464e$export$ca5712918dfd7d6b = ({ isCreate: isCreate = false, hasCheckbox: hasCheckbox = false, depth: depth, isParent: isParent, offset: offset })=>{
        let result = depth * $f6631d4525bf464e$var$DEFAULT_LIST_CONTENT_PADDING;
        const checkboxSpace = (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1') ? $f6631d4525bf464e$var$CHECKBOX_SPACE : $f6631d4525bf464e$var$CHECKBOX_SPACE_OLD;
        if (hasCheckbox) result += checkboxSpace;
        if ((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)()) result += offset || 0;
        if (isParent) result += $f6631d4525bf464e$var$NON_BASE_LEVEL_LIST_CONTENT_PADDING;
        else result += $f6631d4525bf464e$var$DEFAULT_LIST_CONTENT_PADDING;
        if (isCreate) result += $f6631d4525bf464e$var$DEFAULT_LIST_CREATE_OFFSET;
        return result;
    };
});
parcelRegister("3yTFv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cb1293cd631ffada$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $iZN6h;
    var $WPwAA;
    var $hGh1Z;
    var $bf58Z;
    const $cb1293cd631ffada$var$containerStyles = null;
    const $cb1293cd631ffada$var$DropTarget = ({ id: id, parentId: parentId, level: level, depth: depth, ariaRowIndex: ariaRowIndex, topOffset: topOffset, children: children, itemHeight: itemHeight, childItemsHeight: childItemsHeight, isParent: isParent, isExpanded: isExpanded, isInTransition: isInTransition, onDrop: onDrop, onExpandChanged: onExpandChanged })=>{
        const [{ isTreeDrag: isTreeDrag }] = (0, (0, parcelRequire("WPwAA")).useEnablements)();
        const [setDropRef, clearDropRef] = (0, (0, parcelRequire("bf58Z")).useListDropTarget)({
            id: id,
            level: level,
            depth: depth,
            parentId: parentId,
            isParent: isParent,
            isExpanded: isExpanded,
            isInTransition: isInTransition,
            isTreeDrag: isTreeDrag,
            childItemsHeight: childItemsHeight,
            onDrop: onDrop,
            onExpandChanged: onExpandChanged
        });
        const [isItemSelected] = (0, (0, parcelRequire("hGh1Z")).useIsItemSelected)(id);
        (0, $5uXOq.useEffect)(()=>()=>{
                clearDropRef();
            }, [
            clearDropRef
        ]);
        const height = depth > 0 ? (0, (0, parcelRequire("iZN6h")).BASE_LEVEL_ITEM_HEIGHT)() : itemHeight;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            role: "row",
            "aria-rowindex": ariaRowIndex,
            "aria-selected": isItemSelected,
            ref: setDropRef,
            style: {
                top: `${topOffset}px`,
                height: `${height}px`
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _1e0c1txw _1bsb1osq"
            ])
        }, children);
    };
    var $cb1293cd631ffada$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($cb1293cd631ffada$var$DropTarget);
});
parcelRegister("bf58Z", function(module, exports) {
    $parcel$export(module.exports, "useListDropTarget", ()=>$e85fc38aaf8ff858$export$4aeed369644ffdbb);
    var $5uXOq = parcelRequire("5uXOq");
    var $f3lfW;
    var $4hDdm = parcelRequire("4hDdm");
    var $7gWdR = parcelRequire("7gWdR");
    var $iZN6h;
    var $3ruU1;
    var $lGdZu;
    var $a7L1o;
    var $hvBZZ;
    const $e85fc38aaf8ff858$export$4aeed369644ffdbb = ({ id: id, level: level, depth: depth, parentId: parentId, isParent: isParent, isExpanded: isExpanded, isInTransition: isInTransition, isTreeDrag: isTreeDrag, childItemsHeight: childItemsHeight = 0, onDrop: onDrop, onExpandChanged: onExpandChanged })=>{
        const directionRef = (0, $5uXOq.useRef)((0, (0, parcelRequire("iZN6h")).DOWN));
        const cleanupDragAndDrop = (0, $5uXOq.useRef)(null);
        const isDraggedOver = (0, $5uXOq.useRef)(false);
        const timerRef = (0, $5uXOq.useRef)(undefined);
        const instructionRef = (0, $5uXOq.useRef)(null);
        const { onResize: onResize } = (0, (0, parcelRequire("lGdZu")).useTimelineViewportActions)();
        const isDragChildOverParent = (0, $5uXOq.useRef)(false);
        const { onRowDragOver: onRowDragOver, onRowDragChildOverParent: onRowDragChildOverParent, onRowDragChildOverParentEnd: onRowDragChildOverParentEnd } = (0, (0, parcelRequire("3ruU1")).useSideEffectMarshal)();
        const makeDroppable = (0, $5uXOq.useCallback)((dragElement)=>{
            const el = dragElement;
            if (el === null) return;
            const getData = ()=>({
                    id: id,
                    level: level,
                    isInTransition: isInTransition
                });
            const canDrop = ({ source: source })=>{
                const item = source.data;
                return item.type === (0, (0, parcelRequire("iZN6h")).ROW_DRAG_AND_DROP_ID) && !(0, (0, parcelRequire("hvBZZ")).getIsDragParentOverChild)(item.level, level) && isInTransition !== true;
            };
            const onDragEnter = ({ source: source })=>{
                const item = source.data;
                if (item.type === (0, (0, parcelRequire("iZN6h")).ROW_DRAG_AND_DROP_ID) && item.id !== id) {
                    isDraggedOver.current = true;
                    if ((0, (0, parcelRequire("hvBZZ")).getIsDragChildOverParent)(item.level, level)) {
                        onRowDragChildOverParent(item.id, id);
                        if (isParent && !isExpanded) {
                            timerRef.current && clearTimeout(timerRef.current);
                            timerRef.current = setTimeout(()=>{
                                onExpandChanged(id, false);
                                clearTimeout(timerRef.current);
                                timerRef.current = undefined;
                            }, (0, (0, parcelRequire("iZN6h")).DELAY_EXPAND_TIME));
                        }
                    }
                }
            };
            const onDrag = ({ source: source, location: location })=>{
                const item = source.data;
                const { current: { input: current } } = location;
                if (isDraggedOver.current && !(0, (0, parcelRequire("hvBZZ")).getIsDragChildOverParent)(item.level, level)) {
                    const { top: top, bottom: bottom } = el.getBoundingClientRect();
                    const midpoint = top + (bottom - top) / 2;
                    directionRef.current = current.pageY <= midpoint ? (0, (0, parcelRequire("iZN6h")).UP) : (0, (0, parcelRequire("iZN6h")).DOWN);
                    const bottomWithOffset = bottom + childItemsHeight;
                    const relativeTop = directionRef.current === (0, (0, parcelRequire("iZN6h")).DOWN) ? bottomWithOffset : top;
                    onRowDragOver(item.id, relativeTop);
                }
            };
            const onItemDrop = ({ source: source, location: { current: { dropTargets: dropTargets } } })=>{
                const isShallowDrop = dropTargets.length > 0 && dropTargets[0].data.id === id;
                const item = source.data;
                if (item.id !== id && isShallowDrop) {
                    const rankRequest = directionRef.current === (0, (0, parcelRequire("iZN6h")).DOWN) ? {
                        rankAfterId: id
                    } : {
                        rankBeforeId: id
                    };
                    const updateType = (0, (0, parcelRequire("hvBZZ")).getUpdateType)({
                        level: item.level,
                        parentId: item.parentId,
                        id: item.id,
                        depth: item.depth
                    }, {
                        level: level,
                        parentId: parentId,
                        id: id,
                        depth: depth
                    });
                    switch(updateType){
                        case 0, (0, parcelRequire("hvBZZ")).UPDATE_RANK:
                            onDrop(item.id, {
                                level: item.level,
                                rankRequest: rankRequest
                            });
                            break;
                        case 0, (0, parcelRequire("hvBZZ")).UPDATE_PARENT:
                            onDrop(item.id, {
                                level: item.level,
                                parentId: id
                            });
                            break;
                        case 0, (0, parcelRequire("hvBZZ")).UPDATE_RANK_AND_PARENT:
                            onDrop(item.id, {
                                level: item.level,
                                parentId: parentId,
                                rankRequest: rankRequest
                            });
                            break;
                        default:
                            break;
                    }
                }
            };
            const treeGetData = ({ source: source, input: input, element: element })=>{
                const data = {
                    id: id,
                    level: level,
                    isInTransition: isInTransition
                };
                const draggedItem = source.data;
                const dropTarget = {
                    id: id,
                    parentId: parentId,
                    level: level,
                    depth: depth
                };
                const blockedInstructions = (0, (0, parcelRequire("hvBZZ")).getBlockedInstructions)({
                    dropTarget: dropTarget,
                    draggedItem: draggedItem
                });
                return (0, (0, parcelRequire("f3lfW")).attachInstruction)(data, {
                    input: input,
                    element: element,
                    indentPerLevel: (0, (0, parcelRequire("hvBZZ")).INDENT_PER_LEVEL),
                    currentLevel: depth || 0,
                    mode: isParent && isExpanded ? 'expanded' : 'standard',
                    block: blockedInstructions
                });
            };
            const treeCanDrop = ({ source: source })=>source.data.type === (0, (0, parcelRequire("iZN6h")).ROW_DRAG_AND_DROP_ID) && isInTransition !== true;
            const onTreeDrag = ({ source: source, self: self, location: location })=>{
                const { dropTargets: dropTargets } = location.current;
                const item = source.data;
                const dropTarget = dropTargets[0];
                if (dropTarget.data.id === id) {
                    const extractedInstruction = (0, (0, parcelRequire("f3lfW")).extractInstruction)(self.data);
                    if (extractedInstruction?.type !== 'instruction-blocked') {
                        if (extractedInstruction?.type === 'reorder-above' || extractedInstruction?.type === 'reorder-below') {
                            const { top: top, bottom: bottom } = el.getBoundingClientRect();
                            const relativeTop = extractedInstruction?.type === 'reorder-below' ? bottom : top;
                            const paddingLeft = (0, (0, parcelRequire("a7L1o")).getListContentPaddingLeft)({
                                isParent: true,
                                depth: depth
                            });
                            onResize({
                                indicatorLineOffset: paddingLeft
                            });
                            onRowDragOver(item.id, relativeTop, paddingLeft);
                            if (isDragChildOverParent.current) {
                                onRowDragChildOverParentEnd(parentId ?? id);
                                isDragChildOverParent.current = false;
                            }
                        }
                        if (extractedInstruction?.type === 'make-child') {
                            onRowDragChildOverParent(item.id, id);
                            isDragChildOverParent.current = true;
                        }
                        instructionRef.current = extractedInstruction;
                    }
                }
            };
            const onTreeDrop = ({ source: source, location: { current: { dropTargets: dropTargets } } })=>{
                const isShallowDrop = dropTargets.length > 0 && dropTargets[0].data.id === id;
                const item = source.data;
                if (instructionRef.current && item.id !== id && isShallowDrop) {
                    const isReparent = item.parentId !== parentId;
                    switch(instructionRef.current.type){
                        case 'make-child':
                            onDrop(item.id, {
                                level: item.level,
                                parentId: id
                            });
                            if (isDragChildOverParent.current) {
                                onRowDragChildOverParentEnd(id);
                                isDragChildOverParent.current = false;
                            }
                            break;
                        case 'reorder-above':
                        case 'reorder-below':
                            onDrop(item.id, {
                                level: item.level,
                                rankRequest: instructionRef.current.type === 'reorder-above' ? {
                                    rankBeforeId: id
                                } : {
                                    rankAfterId: id
                                },
                                ...isReparent ? {
                                    parentId: parentId
                                } : {}
                            });
                            break;
                        default:
                            break;
                    }
                }
                instructionRef.current = null;
            };
            const onTreeDragEnter = ({ source: source })=>{
                const item = source.data;
                if (item.type === (0, (0, parcelRequire("iZN6h")).ROW_DRAG_AND_DROP_ID) && item.id !== id) {
                    isDraggedOver.current = true;
                    if ((0, (0, parcelRequire("hvBZZ")).getTreeItemIsDragChildOverParent)(item.level, level)) {
                        if (isParent && !isExpanded) {
                            timerRef.current && clearTimeout(timerRef.current);
                            timerRef.current = setTimeout(()=>{
                                onExpandChanged(id, false);
                                clearTimeout(timerRef.current);
                                timerRef.current = undefined;
                            }, (0, (0, parcelRequire("iZN6h")).DELAY_EXPAND_TIME));
                        }
                    }
                }
            };
            const onTreeDropTargetChange = ({ location: location })=>{
                const previousDropTargetId = location.previous?.dropTargets[0]?.data.id;
                if (isDragChildOverParent.current && previousDropTargetId) {
                    onRowDragChildOverParentEnd(previousDropTargetId);
                    isDragChildOverParent.current = false;
                }
            };
            cleanupDragAndDrop.current = (0, $4hDdm.combine)((0, $7gWdR.dropTargetForElements)({
                element: el,
                getData: isTreeDrag ? treeGetData : getData,
                canDrop: isTreeDrag ? treeCanDrop : canDrop,
                onDragEnter: isTreeDrag ? onTreeDragEnter : onDragEnter,
                onDrag: isTreeDrag ? onTreeDrag : onDrag,
                onDrop: isTreeDrag ? onTreeDrop : onItemDrop,
                onDragLeave: ()=>{
                    if (isDraggedOver.current || timerRef.current) {
                        isDraggedOver.current = false;
                        clearTimeout(timerRef.current);
                        timerRef.current = undefined;
                    }
                },
                ...isTreeDrag ? {
                    onDropTargetChange: onTreeDropTargetChange
                } : {}
            }));
        }, [
            id,
            level,
            isParent,
            isExpanded,
            isInTransition,
            isTreeDrag,
            parentId,
            depth,
            childItemsHeight,
            onExpandChanged,
            onRowDragOver,
            onRowDragChildOverParent,
            onDrop,
            onResize,
            onRowDragChildOverParentEnd
        ]);
        const cleanupDroppable = (0, $5uXOq.useCallback)(()=>{
            cleanupDragAndDrop.current?.();
        }, []);
        return [
            makeDroppable,
            cleanupDroppable
        ];
    };
});
parcelRegister("f3lfW", function(module, exports) {
    $parcel$export(module.exports, "attachInstruction", ()=>$8ac1160b89f36213$export$267ad49d812c2c7f);
    $parcel$export(module.exports, "extractInstruction", ()=>$8ac1160b89f36213$export$c8ffecbe249dc8f8);
    const $8ac1160b89f36213$var$uniqueKey = Symbol('tree-item-instruction');
    function $8ac1160b89f36213$var$getCenter(rect) {
        return {
            x: (rect.right + rect.left) / 2,
            y: (rect.bottom + rect.top) / 2
        };
    }
    function $8ac1160b89f36213$var$standardHitbox({ client: client, borderBox: borderBox }) {
        const quarterOfHeight = borderBox.height / 4;
        if (client.y <= borderBox.top + quarterOfHeight) return 'reorder-above';
        if (client.y >= borderBox.bottom - quarterOfHeight) return 'reorder-below';
        return 'make-child';
    }
    function $8ac1160b89f36213$var$getInstruction({ element: element, input: input, currentLevel: currentLevel, indentPerLevel: indentPerLevel, mode: mode }) {
        const client = {
            x: input.clientX,
            y: input.clientY
        };
        const borderBox = element.getBoundingClientRect();
        if (mode === 'standard') {
            const type = $8ac1160b89f36213$var$standardHitbox({
                borderBox: borderBox,
                client: client
            });
            return {
                type: type,
                indentPerLevel: indentPerLevel,
                currentLevel: currentLevel
            };
        }
        const center = $8ac1160b89f36213$var$getCenter(borderBox);
        if (mode === 'expanded') {
            const type = $8ac1160b89f36213$var$standardHitbox({
                borderBox: borderBox,
                client: client
            });
            return {
                type: type === 'reorder-above' ? type : 'make-child',
                indentPerLevel: indentPerLevel,
                currentLevel: currentLevel
            };
        }
        const visibleInset = indentPerLevel * currentLevel;
        if (client.x < borderBox.left + visibleInset) {
            if (client.y < center.y) return {
                type: 'reorder-above',
                indentPerLevel: indentPerLevel,
                currentLevel: currentLevel
            };
            const rawLevel = (client.x - borderBox.left) / indentPerLevel;
            const desiredLevel = Math.max(Math.floor(rawLevel), 0);
            return {
                type: 'reparent',
                desiredLevel: desiredLevel,
                indentPerLevel: indentPerLevel,
                currentLevel: currentLevel
            };
        }
        return {
            type: $8ac1160b89f36213$var$standardHitbox({
                borderBox: borderBox,
                client: client
            }),
            indentPerLevel: indentPerLevel,
            currentLevel: currentLevel
        };
    }
    function $8ac1160b89f36213$var$isShallowEqual(a, b) {
        const aKeys = Object.keys(a).sort();
        const bKeys = Object.keys(b).sort();
        if (aKeys.length !== bKeys.length) return false;
        return aKeys.every((key)=>a[key] === b[key]);
    }
    function $8ac1160b89f36213$var$areInstructionsEqual(a, b) {
        if (a.type !== b.type) return false;
        if (a.type === 'instruction-blocked' && b.type === 'instruction-blocked') return $8ac1160b89f36213$var$areInstructionsEqual(a.desired, b.desired);
        return $8ac1160b89f36213$var$isShallowEqual(a, b);
    }
    const $8ac1160b89f36213$var$memoizeInstruction = (()=>{
        let last = null;
        return (instruction)=>{
            if (last && $8ac1160b89f36213$var$areInstructionsEqual(last, instruction)) return last;
            last = instruction;
            return instruction;
        };
    })();
    function $8ac1160b89f36213$var$applyInstructionBlock({ desired: desired, block: block }) {
        if (block?.includes(desired.type) && desired.type !== 'instruction-blocked') {
            const blocked = {
                type: 'instruction-blocked',
                desired: desired
            };
            return blocked;
        }
        return desired;
    }
    function $8ac1160b89f36213$export$267ad49d812c2c7f(userData, { block: block, ...rest }) {
        const desired = $8ac1160b89f36213$var$getInstruction(rest);
        const withBlock = $8ac1160b89f36213$var$applyInstructionBlock({
            desired: desired,
            block: block
        });
        const memoized = $8ac1160b89f36213$var$memoizeInstruction(withBlock);
        return {
            ...userData,
            [$8ac1160b89f36213$var$uniqueKey]: memoized
        };
    }
    function $8ac1160b89f36213$export$c8ffecbe249dc8f8(userData) {
        return userData[$8ac1160b89f36213$var$uniqueKey] ?? null;
    }
});
parcelRegister("hvBZZ", function(module, exports) {
    $parcel$export(module.exports, "UPDATE_RANK", ()=>$5caf6c2fa64366cf$export$576ea426c903d7e1);
    $parcel$export(module.exports, "UPDATE_PARENT", ()=>$5caf6c2fa64366cf$export$44bc1fe1c2a61c81);
    $parcel$export(module.exports, "UPDATE_RANK_AND_PARENT", ()=>$5caf6c2fa64366cf$export$14628ae53fe631c7);
    $parcel$export(module.exports, "INDENT_PER_LEVEL", ()=>$5caf6c2fa64366cf$export$130b26c73bb9d040);
    $parcel$export(module.exports, "getUpdateType", ()=>$5caf6c2fa64366cf$export$df2aa842dc5172b0);
    $parcel$export(module.exports, "getIsDragChildOverParent", ()=>$5caf6c2fa64366cf$export$64e82cf96e63ddf2);
    $parcel$export(module.exports, "getIsDragParentOverChild", ()=>$5caf6c2fa64366cf$export$fa3830d8bd814624);
    $parcel$export(module.exports, "getTreeItemIsDragChildOverParent", ()=>$5caf6c2fa64366cf$export$466f5fb38504576b);
    $parcel$export(module.exports, "getBlockedInstructions", ()=>$5caf6c2fa64366cf$export$44539271c2e3abc8);
    var $7ouUj;
    const $5caf6c2fa64366cf$export$576ea426c903d7e1 = 'UPDATE_RANK';
    const $5caf6c2fa64366cf$export$44bc1fe1c2a61c81 = 'UPDATE_PARENT';
    const $5caf6c2fa64366cf$export$14628ae53fe631c7 = 'UPDATE_RANK_AND_PARENT';
    const $5caf6c2fa64366cf$export$5b388ccfa29be01 = -1;
    const $5caf6c2fa64366cf$export$130b26c73bb9d040 = 25;
    const $5caf6c2fa64366cf$export$df2aa842dc5172b0 = (draggedItem, dropTarget)=>{
        if (draggedItem.level === dropTarget.level) {
            if ((0, (0, parcelRequire("7ouUj")).isBaseLevel)(draggedItem.level) && dropTarget.parentId !== draggedItem.parentId) return $5caf6c2fa64366cf$export$14628ae53fe631c7;
            return $5caf6c2fa64366cf$export$576ea426c903d7e1;
        }
        if ((0, (0, parcelRequire("7ouUj")).isBaseLevel)(draggedItem.level) && !(0, (0, parcelRequire("7ouUj")).isBaseLevel)(dropTarget.level) && dropTarget.id !== draggedItem.parentId) return $5caf6c2fa64366cf$export$44bc1fe1c2a61c81;
        return undefined;
    };
    const $5caf6c2fa64366cf$export$64e82cf96e63ddf2 = (itemLevel, overItemLevel)=>(0, (0, parcelRequire("7ouUj")).isBaseLevel)(itemLevel) && !(0, (0, parcelRequire("7ouUj")).isBaseLevel)(overItemLevel);
    const $5caf6c2fa64366cf$export$fa3830d8bd814624 = (itemLevel, overItemLevel)=>!(0, (0, parcelRequire("7ouUj")).isBaseLevel)(itemLevel) && (0, (0, parcelRequire("7ouUj")).isBaseLevel)(overItemLevel);
    const $5caf6c2fa64366cf$export$466f5fb38504576b = (draggedItemLevel, dropTargetLevel)=>dropTargetLevel - draggedItemLevel === 1;
    const $5caf6c2fa64366cf$export$244c1f40d1decdb6 = (draggedItemLevel, dropTargetLevel)=>dropTargetLevel - draggedItemLevel === 0 || dropTargetLevel - draggedItemLevel === 1;
    const $5caf6c2fa64366cf$export$98df7fcf26a10604 = (draggedItemLevel, dropTargetLevel)=>dropTargetLevel === draggedItemLevel;
    const $5caf6c2fa64366cf$export$df097d1d7a83adbb = (draggedItemLevel, dropTargetLevel)=>dropTargetLevel - draggedItemLevel === 1;
    const $5caf6c2fa64366cf$export$44539271c2e3abc8 = ({ dropTarget: dropTarget, draggedItem: draggedItem })=>{
        const { level: dropTargetLevel, parentId: dropTargetParentId } = dropTarget;
        const { level: draggedItemLevel } = draggedItem;
        const isOnSameLevel = $5caf6c2fa64366cf$export$98df7fcf26a10604(draggedItemLevel, dropTargetLevel);
        const isWithinOneLevel = $5caf6c2fa64366cf$export$244c1f40d1decdb6(draggedItemLevel, dropTargetLevel);
        const isOneLevelBelow = $5caf6c2fa64366cf$export$df097d1d7a83adbb(draggedItemLevel, dropTargetLevel);
        const isSubTask = draggedItemLevel === $5caf6c2fa64366cf$export$5b388ccfa29be01;
        if (isOnSameLevel) return [
            'make-child'
        ];
        if (!isWithinOneLevel) {
            if (dropTargetParentId || isSubTask) return [
                'make-child',
                'reorder-below',
                'reorder-above'
            ];
            return [
                'make-child'
            ];
        }
        if (isOneLevelBelow) {
            if (isSubTask) return [
                'reorder-below',
                'reorder-above'
            ];
            if (dropTargetParentId) return [
                'reorder-below',
                'reorder-above'
            ];
        }
        return [];
    };
});
parcelRegister("6lHwb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$02b304f1b298804c$export$2e2bcd8739ae039);
    var $bwpsq;
    var $lD23V;
    var $5uXOq = parcelRequire("5uXOq");
    var $hGh1Z;
    var $9puhl;
    var $biT18;
    var $jfF8l;
    const $02b304f1b298804c$var$listEmptyContentStyles = null;
    const $02b304f1b298804c$var$bottomBorderContainerStyles = null;
    const $02b304f1b298804c$var$listBottomBorderStyles = null;
    const $02b304f1b298804c$var$chartBottomBorderStyles = null;
    const $02b304f1b298804c$var$Footer = ({ renderListEmptyContent: renderListEmptyContent })=>{
        const [isTableEmpty] = (0, (0, parcelRequire("hGh1Z")).useIsTableEmpty)();
        const [{ timelineWidth: timelineWidth }] = (0, (0, parcelRequire("biT18")).useTimelineState)();
        const [listWidth] = (0, (0, parcelRequire("9puhl")).useListWidth)();
        return isTableEmpty ? (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                width: `${listWidth}px`
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqsw1if8 _1ltvidpf _1pby1406"
            ])
        }, renderListEmptyContent()) : (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _1e0c1txw _1bsb1osq _4t3it94y"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqsw1if8 _16jlidpf _1o9zidpf _i0dl1wug _1ltvidpf _4t3it94y _bfhk14l7 _1pby1406"
            ]),
            style: {
                width: `${listWidth}px`,
                "--_drom5x": (0, (0, parcelRequire("lD23V")).default)((0, (0, parcelRequire("jfF8l")).secondaryBorderColor))
            }
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _16jlidpf _1o9zidpf _i0dl1wug _4t3it94y _bfhk14l7"
            ]),
            style: {
                width: `${timelineWidth}px`,
                "--_drom5x": (0, (0, parcelRequire("lD23V")).default)((0, (0, parcelRequire("jfF8l")).secondaryBorderColor))
            }
        }));
    };
    var $02b304f1b298804c$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($02b304f1b298804c$var$Footer);
});
parcelRegister("fepzL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$48c9da01ac495983$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $iZN6h;
    var $9puhl;
    var $a7L1o;
    const $48c9da01ac495983$var$listItemLiteCellStyles = null;
    const $48c9da01ac495983$var$ListItemLite = ({ id: id, depth: depth, itemHeight: itemHeight, backgroundColor: backgroundColor, renderListItemContent: renderListItemContent, renderListItemSecondaryContent: renderListItemSecondaryContent })=>{
        const [listWidth] = (0, (0, parcelRequire("9puhl")).useListWidth)();
        const rendererProps = {
            id: id
        };
        const rendererState = {
            isVirtual: true,
            isHoveredOrFocused: false
        };
        const height = depth > 0 ? (0, (0, parcelRequire("iZN6h")).BASE_LEVEL_ITEM_HEIGHT)() : itemHeight;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            role: "gridcell",
            tabIndex: -1,
            style: {
                width: `${listWidth}px`,
                height: `${height}px`,
                paddingLeft: `${(0, (0, parcelRequire("a7L1o")).getListContentPaddingLeft)({
                    isParent: false,
                    depth: depth
                })}px`,
                backgroundColor: backgroundColor
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqsw1if8 _1e0c1txw _vchhusvi _4cvr1h6o _16jlidpf _1o9zidpf _i0dl1wug _1ltvidpf _u5f3u2gc _1reo15vq _18m915vq _1pby1406"
            ])
        }, renderListItemContent(rendererProps, rendererState), renderListItemSecondaryContent(rendererProps, rendererState));
    };
    var $48c9da01ac495983$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($48c9da01ac495983$var$ListItemLite);
});
parcelRegister("jIXeo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0fd87eb677e3673f$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $koVbs;
    var $2NMNM;
    var $dC5iT;
    var $8CUq3;
    var $eTXmK;
    var $eZJjh;
    var $6s1PB;
    var $4R6GH;
    var $dCm1o;
    var $iZN6h;
    var $hGh1Z;
    var $9puhl;
    var $82CeN;
    var $5BWo9;
    var $3ruU1;
    var $ghKWA;
    var $a7L1o;
    var $hUAzM;
    var $1YcpO;
    var $kCVTH;
    var $df6UD;
    var $4Rpjg;
    var $hQYX7;
    var $e3R1o;
    var $jU4rh;
    var $3euyd;
    var $4vwx2;
    var $bNMH3;
    const $0fd87eb677e3673f$var$secondaryContentStyles = null;
    const $0fd87eb677e3673f$var$listItemContainerStyles = null;
    const $0fd87eb677e3673f$var$getCursor = (isInTransition, isSelectEnabled)=>{
        if (isInTransition) return 'not-allowed';
        if (isSelectEnabled) return 'pointer';
        return 'default';
    };
    const $0fd87eb677e3673f$var$PADDING_LEFT_INCREMENT = 12;
    const $0fd87eb677e3673f$var$ListItem = ({ id: id, parentId: parentId, level: level, depth: depth, itemHeight: itemHeight, backgroundColor: backgroundColor, ariaControls: ariaControls, isParent: isParent, isExpanded: isExpanded, isDragEnabled: isDragEnabled, isInTransition: isInTransition, isSelectEnabled: isSelectEnabled, isMultiSelectEnabled: isMultiSelectEnabled, isCreateChildEnabled: isCreateChildEnabled, isCreateSiblingEnabled: isCreateSiblingEnabled, isMeatballsButtonEnabled: isMeatballsButtonEnabled, onSelect: onSelect, onDrop: onDrop, onExpandChanged: onExpandChanged, onInlineCreateClicked: onInlineCreateClicked, renderListItemContent: renderListItemContent, renderListItemSecondaryContent: renderListItemSecondaryContent, renderListItemMenuOption: renderListItemMenuOption, renderListItemModal: renderListItemModal })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const sideEffectMarshal = (0, (0, parcelRequire("3ruU1")).useSideEffectMarshal)();
        const [listWidth] = (0, (0, parcelRequire("9puhl")).useListWidth)();
        const [isHoveredOrFocused, setIsHoveredOrFocused] = (0, $5uXOq.useState)(false);
        const [isMenuOpen, setIsMenuOpen] = (0, $5uXOq.useState)(false);
        const isContainerInFocus = (0, $5uXOq.useRef)(false);
        const element = (0, $5uXOq.useRef)(null);
        const cellRef = (0, (0, parcelRequire("5BWo9")).useGridCell)(id, (0, (0, parcelRequire("iZN6h")).LIST_COLUMN_COORDINATE));
        const isFocused = (0, $5uXOq.useRef)(false);
        const [isActive] = (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y') ? (0, (0, parcelRequire("hGh1Z")).useIsItemActive)(id) : [
            false
        ];
        const { selectable: selectable, selected: selected, handleClick: handleClick, handleKeyDown: handleKeyDown } = (()=>{
            if ((0, (0, parcelRequire("4R6GH")).fg)('project_timeline_multi-select_and_checkboxes')) return (0, (0, parcelRequire("kCVTH")).useItemSelect)(id);
            const [isItemSelected = false] = (0, (0, parcelRequire("hGh1Z")).useIsItemSelected)(id);
            return {
                selectable: false,
                selected: isItemSelected,
                handleClick: (0, ($parcel$interopDefault($8Rkzz))),
                handleKeyDown: (0, ($parcel$interopDefault($8Rkzz)))
            };
        })();
        const { onRowMouseEnter: onRowMouseEnter, onRowMouseLeave: onRowMouseLeave, onRowFocus: onRowFocus, onRowBlur: onRowBlur } = sideEffectMarshal;
        const [isActiveCreateChildTrigger] = (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y') ? (0, (0, parcelRequire("82CeN")).useIsCreateTriggerActive)({
            id: id,
            type: 'CHILD'
        }) : [
            false
        ];
        const canDrag = isDragEnabled && !isInTransition;
        const [makeDraggable, cleanupDraggable] = (0, (0, parcelRequire("bNMH3")).default)({
            id: id,
            level: level,
            depth: depth,
            parentId: parentId,
            canDrag: canDrag,
            sideEffectMarshal: sideEffectMarshal
        });
        (0, $5uXOq.useEffect)(()=>{
            makeDraggable(element.current);
            return ()=>{
                cleanupDraggable();
            };
        }, [
            makeDraggable,
            cleanupDraggable
        ]);
        const onHoverOrFocus = (0, $5uXOq.useCallback)(()=>{
            onRowMouseEnter(id);
            setIsHoveredOrFocused(true);
        }, [
            id,
            onRowMouseEnter
        ]);
        const onStopHoverOrFocus = (0, $5uXOq.useCallback)(()=>{
            if (isFocused.current && (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y')) {
                onRowBlur(id);
                isFocused.current = false;
            }
            onRowMouseLeave(id);
            setIsMenuOpen(false);
            setIsHoveredOrFocused(false);
        }, [
            id,
            onRowMouseLeave,
            onRowBlur
        ]);
        const onFocus = (0, $5uXOq.useCallback)(()=>{
            onRowFocus(id);
            onHoverOrFocus();
            isFocused.current = true;
        }, [
            id,
            onHoverOrFocus,
            onRowFocus
        ]);
        const onContainerBlurOld = (0, $5uXOq.useCallback)(({ relatedTarget: relatedTarget })=>{
            if (!element.current?.contains(relatedTarget) && !isContainerInFocus.current) onStopHoverOrFocus();
            isContainerInFocus.current = false;
        }, [
            onStopHoverOrFocus
        ]);
        const onContainerBlur = (0, $5uXOq.useCallback)(({ relatedTarget: relatedTarget })=>{
            if (!element.current?.contains(relatedTarget)) onStopHoverOrFocus();
        }, [
            onStopHoverOrFocus
        ]);
        const onContainerClickOld = (0, $5uXOq.useCallback)((event)=>{
            const { timeStamp: timeStamp, metaKey: metaKey, ctrlKey: ctrlKey, shiftKey: shiftKey } = event;
            (0, (0, parcelRequire("eTXmK")).default)('timeline-item-clicked', timeStamp);
            const withCmd = ctrlKey || metaKey;
            const withShift = shiftKey;
            onSelect(id, {
                level: level,
                withCmd: withCmd,
                withShift: withShift,
                depth: depth
            });
        }, [
            id,
            level,
            depth,
            onSelect
        ]);
        const onContainerClickNew = (0, $5uXOq.useCallback)((event)=>{
            const { timeStamp: timeStamp, metaKey: metaKey, ctrlKey: ctrlKey, shiftKey: shiftKey } = event;
            (0, (0, parcelRequire("eTXmK")).default)('timeline-item-clicked', timeStamp);
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'listItem',
                actionSubjectId: 'issueListItem',
                attributes: {
                    level: level,
                    depth: depth,
                    withCmd: ctrlKey || metaKey,
                    withShift: shiftKey
                }
            });
            (0, (0, parcelRequire("hUAzM")).fireUIAnalyticsEvent)(analyticsEvent);
            (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps-timeline-bento-refocusing') ? handleClick(event, analyticsEvent, element) : handleClick(event, analyticsEvent);
        }, [
            createAnalyticsEvent,
            level,
            depth,
            handleClick
        ]);
        const onContainerClick = (0, (0, parcelRequire("4R6GH")).fg)('project_timeline_multi-select_and_checkboxes') ? onContainerClickNew : onContainerClickOld;
        const onSelectCheckboxToggle = (0, $5uXOq.useCallback)((event)=>{
            const { timeStamp: timeStamp, shiftKey: shiftKey } = event;
            (0, (0, parcelRequire("eTXmK")).default)('timeline-item-select-checkbox-toggled', timeStamp);
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'checkbox',
                actionSubjectId: 'issueListItemSelect',
                attributes: {
                    level: level,
                    depth: depth,
                    withShift: shiftKey
                }
            });
            (0, (0, parcelRequire("hUAzM")).fireUIAnalyticsEvent)(analyticsEvent);
            handleClick(event, analyticsEvent);
        }, [
            createAnalyticsEvent,
            depth,
            handleClick,
            level
        ]);
        const onContainerMouseLeave = (0, $5uXOq.useCallback)(()=>{
            if (!element.current?.contains(document.activeElement)) onStopHoverOrFocus();
        }, [
            onStopHoverOrFocus
        ]);
        const onContainerMouseDown = (0, $5uXOq.useCallback)(()=>{
            isContainerInFocus.current = true;
        }, []);
        let onContainerKeyDown = (0, $5uXOq.useCallback)((event)=>{
            if ((0, (0, parcelRequire("1YcpO")).isEnterOrSpaceKey)(event) && !(0, (0, parcelRequire("1YcpO")).isBubbledEvent)(event)) {
                event.preventDefault();
                onContainerClick(event);
            }
        }, [
            onContainerClick
        ]);
        if ((0, (0, parcelRequire("4R6GH")).fg)('timeline_grid_navigation_m2')) onContainerKeyDown = undefined;
        if ((0, (0, parcelRequire("4R6GH")).fg)('project_timeline_multi-select_and_checkboxes')) onContainerKeyDown = (0, $5uXOq.useCallback)((event)=>{
            if (event.target === event.currentTarget) {
                const analyticsEvent = createAnalyticsEvent({
                    action: 'keydown',
                    actionSubject: 'listItem',
                    actionSubjectId: 'issueListItem'
                });
                handleKeyDown(event, analyticsEvent);
            }
        }, [
            createAnalyticsEvent,
            handleKeyDown
        ]);
        const setItemRef = (0, $5uXOq.useCallback)((ref)=>{
            element.current = ref;
            cellRef(ref);
        }, [
            cellRef
        ]);
        const rendererProps = {
            id: id
        };
        const rendererState = {
            isVirtual: false,
            isHoveredOrFocused: isHoveredOrFocused
        };
        const renderSecondaryContent = ()=>{
            if (isInTransition) return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_1e0c116y _4cvr1h6o _18u01b66"
                ])
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
                size: "small",
                testId: `roadmap.timeline-table.components.list-item.spinner.${id}`
            }));
            return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_1e0c116y _4cvr1h6o _18u01b66"
                ])
            }, renderListItemSecondaryContent(rendererProps, rendererState), renderListItemMenuOption && isMeatballsButtonEnabled && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (isCreateChildEnabled && isHoveredOrFocused || isActiveCreateChildTrigger) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("df6UD")).default), {
                parentId: id,
                label: formatMessage((0, (0, parcelRequire("3euyd")).default).createChild),
                onInlineCreateClicked: onInlineCreateClicked,
                isVisible: !isActiveCreateChildTrigger
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jU4rh")).default), {
                isTriggerVisible: isHoveredOrFocused,
                isMenuOpen: isMenuOpen,
                id: id,
                level: level,
                depth: depth,
                parentId: parentId,
                isCreateChildEnabled: isCreateChildEnabled,
                isCreateSiblingEnabled: isCreateSiblingEnabled,
                renderListItemMenuOption: renderListItemMenuOption,
                renderListItemModal: renderListItemModal,
                onStopHoverOrFocus: onStopHoverOrFocus,
                onInlineCreateClicked: onInlineCreateClicked,
                onDrop: onDrop,
                setIsMenuOpen: setIsMenuOpen,
                cellRef: element
            })));
        };
        const renderSecondaryContentOld = ()=>{
            let innerElement;
            if (isInTransition) innerElement = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
                size: "small",
                testId: `roadmap.timeline-table.components.list-item.spinner.${id}`
            });
            else if (isCreateChildEnabled) innerElement = isHoveredOrFocused ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("df6UD")).default), {
                parentId: id,
                label: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("3euyd")).default).createChildIssueTermRefresh : (0, (0, parcelRequire("3euyd")).default).createChild),
                onInlineCreateClicked: onInlineCreateClicked
            }) : null;
            if (innerElement) return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_1e0c116y _4cvr1h6o _18u01b66"
                ])
            }, innerElement);
            return renderListItemSecondaryContent(rendererProps, rendererState);
        };
        const height = depth > 0 ? (0, (0, parcelRequire("iZN6h")).BASE_LEVEL_ITEM_HEIGHT)() : itemHeight;
        const listContentPaddingLeft = (0, (0, parcelRequire("a7L1o")).getListContentPaddingLeft)({
            isParent: isParent,
            depth: depth,
            ...(0, (0, parcelRequire("4R6GH")).fg)('project_timeline_multi-select_and_checkboxes') && {
                hasCheckbox: isMultiSelectEnabled
            },
            offset: !isMultiSelectEnabled && (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? $0fd87eb677e3673f$var$PADDING_LEFT_INCREMENT : undefined
        });
        const ExpandComponent = (0, (0, parcelRequire("4R6GH")).fg)('timeline_grid_navigation_m2') ? (0, (0, parcelRequire("e3R1o")).default) : (0, (0, parcelRequire("hQYX7")).default);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            id: id,
            "data-testid": `roadmap.timeline-table.components.list-item.container-${id}`,
            role: "gridcell",
            tabIndex: -1,
            ref: setItemRef,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqsw1if8 _1ltvidpf _1e0c1txw _4cvr1h6o _vchhusvi _u5f3u2gc _v564lfip _nt751r31 _49pcglyw _1hvw1o36 _1ejj168b",
                (0, (0, parcelRequire("ghKWA")).getRowClassName)(id, parentId).className
            ]),
            style: {
                width: `${listWidth}px`,
                height: `${height}px`,
                backgroundColor: backgroundColor,
                paddingLeft: `${listContentPaddingLeft}px`,
                zIndex: isMenuOpen && (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y') ? (0, (0, parcelRequire("iZN6h")).zIndex).PORTAL : (0, (0, parcelRequire("iZN6h")).zIndex).LIST,
                cursor: $0fd87eb677e3673f$var$getCursor(isInTransition, isSelectEnabled)
            },
            onClick: isSelectEnabled && !isInTransition ? onContainerClick : undefined,
            onKeyDown: onContainerKeyDown,
            onMouseEnter: onHoverOrFocus,
            onMouseLeave: (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y') ? onContainerMouseLeave : onStopHoverOrFocus,
            ...!(0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y') && {
                onMouseDown: onContainerMouseDown
            },
            onFocus: (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y') ? onFocus : onHoverOrFocus,
            onBlur: (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y') ? onContainerBlur : onContainerBlurOld
        }, isSelectEnabled && (selected || isActive) && isMenuOpen && (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $0fd87eb677e3673f$var$borderOverlayStyles
        }) : null, isMultiSelectEnabled && (0, (0, parcelRequire("4R6GH")).fg)('project_timeline_multi-select_and_checkboxes') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1') ? $0fd87eb677e3673f$var$checkboxWrapperStyles : $0fd87eb677e3673f$var$checkboxWrapperStylesOld
            ]
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4vwx2")).default), {
            id: id,
            isChecked: selected,
            isDisabled: !selectable,
            onToggle: onSelectCheckboxToggle
        })), isCreateSiblingEnabled && !(0, (0, parcelRequire("4R6GH")).fg)('timeline_grid_navigation_m2') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4Rpjg")).default), {
            id: id,
            level: level,
            depth: depth,
            parentId: parentId,
            label: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("3euyd")).default).createSiblingIssueTermRefresh : (0, (0, parcelRequire("3euyd")).default).createSibling),
            onInlineCreateClicked: onInlineCreateClicked
        }), isParent && (0, ($parcel$interopDefault($5uXOq))).createElement(ExpandComponent, {
            id: id,
            label: isExpanded && !(0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-post-project-a11y-fix') ? formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("3euyd")).default).collapseIssueTermRefresh : (0, (0, parcelRequire("3euyd")).default).collapse) : formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("3euyd")).default).expandIssueTermRefresh : (0, (0, parcelRequire("3euyd")).default).expand),
            isExpanded: isExpanded,
            isRichContentEnabled: isHoveredOrFocused,
            onExpandChanged: onExpandChanged,
            ariaControls: ariaControls
        }), renderListItemContent(rendererProps, rendererState), (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y') ? renderSecondaryContent() : renderSecondaryContentOld(), isCreateSiblingEnabled && (0, (0, parcelRequire("4R6GH")).fg)('timeline_grid_navigation_m2') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4Rpjg")).default), {
            id: id,
            level: level,
            depth: depth,
            parentId: parentId,
            label: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("3euyd")).default).createSiblingIssueTermRefresh : (0, (0, parcelRequire("3euyd")).default).createSibling),
            onInlineCreateClicked: onInlineCreateClicked
        }));
    };
    const $0fd87eb677e3673f$var$borderOverlayStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: '0',
        left: '0',
        pointerEvents: 'none',
        borderLeft: `1px solid ${"var(--ds-border, #091E4224)"}`,
        borderRight: `2px solid ${"var(--ds-border, #091E4224)"}`
    });
    $0fd87eb677e3673f$var$ListItem.defaultProps = {
        isInTransition: false
    };
    $0fd87eb677e3673f$var$ListItem.displayName = 'ListItem';
    $0fd87eb677e3673f$var$ListItem.whyDidYouRender = true;
    var $0fd87eb677e3673f$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($0fd87eb677e3673f$var$ListItem);
    const $0fd87eb677e3673f$var$checkboxWrapperStylesOld = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'absolute',
        left: 'space.0',
        marginLeft: 'space.050',
        marginRight: 'space.050'
    });
    const $0fd87eb677e3673f$var$checkboxWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'absolute',
        left: 'space.0',
        marginLeft: 'space.150'
    });
});
parcelRegister("1YcpO", function(module, exports) {
    $parcel$export(module.exports, "isEnterOrSpaceKey", ()=>$caebb734c61a2262$export$f6deda1cc2672a2e);
    $parcel$export(module.exports, "isBubbledEvent", ()=>$caebb734c61a2262$export$6cc56ae238ebd443);
    const $caebb734c61a2262$export$f6deda1cc2672a2e = (event)=>event.keyCode === 13 || event.keyCode === 32;
    const $caebb734c61a2262$export$a6587fe901c3baf7 = (event)=>event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27;
    const $caebb734c61a2262$export$6cc56ae238ebd443 = (event)=>event.currentTarget !== event.target;
    const $caebb734c61a2262$export$9c580eee50acd9e2 = (e)=>{
        const event = e || window.event;
        if ('buttons' in event) return event.buttons === 1;
        if (event) {
            const { button: button } = event;
            return button === 1;
        }
        return false;
    };
});
parcelRegister("df6UD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$06bd428ce6408342$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $bWn3s;
    var $2NMNM;
    var $42CjB;
    var $dZbEw;
    var $9lMrf;
    var $dC5iT;
    var $8CUq3;
    var $eTXmK;
    var $3bDjY;
    var $cSD7y;
    var $4R6GH;
    var $dCm1o;
    var $iZN6h;
    var $f28cG;
    var $ghKWA;
    var $hUAzM;
    const $06bd428ce6408342$var$CreateChildButtonNew = ({ parentId: parentId, label: label, onInlineCreateClicked: onInlineCreateClicked, isVisible: isVisible })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { createTriggerRef: createTriggerRef, onCreateTriggerClick: onCreateTriggerClick } = (0, (0, parcelRequire("f28cG")).useCreateTrigger)(parentId, 'CHILD');
        const onClick = (0, $5uXOq.useCallback)((event)=>{
            event.stopPropagation();
            onCreateTriggerClick();
            (0, (0, parcelRequire("eTXmK")).default)('timeline-add-item-clicked', event.timeStamp);
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'childIssueCreateButton',
                attributes: {
                    position: (0, (0, parcelRequire("iZN6h")).INSIDE)
                }
            });
            (0, (0, parcelRequire("hUAzM")).fireUIAnalyticsEvent)(analyticsEvent);
            onInlineCreateClicked({
                parentId: parentId,
                position: (0, (0, parcelRequire("iZN6h")).INSIDE)
            });
        }, [
            onCreateTriggerClick,
            createAnalyticsEvent,
            onInlineCreateClicked,
            parentId
        ]);
        const stopPropagation = (0, $5uXOq.useCallback)((e)=>{
            if (e.key === 'Escape') e.stopPropagation();
        }, []);
        return (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_2') ? $5uXOq.createElement("div", {
            className: (0, (0, parcelRequire("ghKWA")).getCreateChildButtonClassName)().className
        }, $5uXOq.createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: !isVisible && $06bd428ce6408342$var$hideButtonStyles
        }, $5uXOq.createElement((0, (0, parcelRequire("42CjB")).default), {
            ref: createTriggerRef,
            icon: (0, ($parcel$interopDefault((0, parcelRequire("dZbEw"))))),
            testId: `roadmap.timeline-table.components.list-item.create-child-button.container-${parentId}`,
            label: label,
            onClick: onClick,
            onKeyUp: stopPropagation,
            appearance: "subtle",
            spacing: "compact",
            isTooltipDisabled: false
        }))) : $5uXOq.createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: label
        }, ({ ref: tooltipRef, ...tooltipProps })=>$5uXOq.createElement("button", {
                ...tooltipProps,
                ref: (0, (0, parcelRequire("bWn3s")).mergeRefs)([
                    tooltipRef,
                    createTriggerRef
                ]),
                "data-testid": `roadmap.timeline-table.components.list-item.create-child-button.container-${parentId}`,
                "aria-label": label,
                onClick: onClick,
                onKeyUp: stopPropagation,
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _19itglyw _80omtlke _1bsb1ejb _4t3i1ejb _2rko1sit _s7n4jp4b _bfhklecj _syazjjyb _12ji1r31 _1qu2glyw _12y31o36 _nt751r31 _49pcglyw _1hvw1o36 _1ejj168b _jomrfj8p _irr3fj8p _1di61elt _9h8h85f4",
                    !isVisible && "_tzy4idpf _lcxvglyw",
                    (0, (0, parcelRequire("ghKWA")).getCreateChildButtonClassName)().className
                ])
            }, $5uXOq.createElement((0, ($parcel$interopDefault((0, parcelRequire("9lMrf"))))), {
                label: "",
                size: "medium"
            })));
    };
    const $06bd428ce6408342$var$CreateChildButtonOld = ({ parentId: parentId, label: label, onInlineCreateClicked: onInlineCreateClicked })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const onClick = (0, $5uXOq.useCallback)((event)=>{
            event.stopPropagation();
            (0, (0, parcelRequire("eTXmK")).default)('timeline-add-item-clicked', event.timeStamp);
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'childIssueCreateButton',
                attributes: {
                    position: (0, (0, parcelRequire("iZN6h")).INSIDE)
                }
            });
            (0, (0, parcelRequire("hUAzM")).fireUIAnalyticsEvent)(analyticsEvent);
            onInlineCreateClicked({
                parentId: parentId,
                position: (0, (0, parcelRequire("iZN6h")).INSIDE)
            });
        }, [
            createAnalyticsEvent,
            parentId,
            onInlineCreateClicked
        ]);
        return (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_2') ? $5uXOq.createElement("div", {
            className: (0, (0, parcelRequire("ghKWA")).getCreateChildButtonClassName)().className
        }, $5uXOq.createElement((0, (0, parcelRequire("42CjB")).default), {
            icon: (0, ($parcel$interopDefault((0, parcelRequire("dZbEw"))))),
            testId: `roadmap.timeline-table.components.list-item.create-child-button.container-${parentId}`,
            label: label,
            onClick: onClick,
            appearance: "subtle",
            spacing: "compact",
            isTooltipDisabled: false
        })) : $5uXOq.createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: label
        }, (tooltipProps)=>$5uXOq.createElement("button", {
                ...tooltipProps,
                "data-testid": `roadmap.timeline-table.components.list-item.create-child-button.container-${parentId}`,
                "aria-label": label,
                onClick: onClick,
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _19itglyw _80omtlke _1bsb1ejb _4t3i1ejb _2rko1sit _s7n4jp4b _bfhklecj _syazjjyb _12ji1r31 _1qu2glyw _12y31o36 _nt751r31 _49pcglyw _1hvw1o36 _1ejj168b _jomrfj8p _irr3fj8p _1di61elt _9h8h85f4",
                    (0, (0, parcelRequire("ghKWA")).getCreateChildButtonClassName)().className
                ])
            }, $5uXOq.createElement((0, ($parcel$interopDefault((0, parcelRequire("9lMrf"))))), {
                label: "",
                size: "medium"
            })));
    };
    const $06bd428ce6408342$var$CreateChildButton = (0, (0, parcelRequire("cSD7y")).componentWithFG)('jsw_roadmaps_timeline_table_meatballs_menu_a11y', $06bd428ce6408342$var$CreateChildButtonNew, $06bd428ce6408342$var$CreateChildButtonOld);
    var $06bd428ce6408342$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($06bd428ce6408342$var$CreateChildButton);
    const $06bd428ce6408342$var$hideButtonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        opacity: 0,
        pointerEvents: 'none'
    });
    const $06bd428ce6408342$var$buttonStyles = null;
    const $06bd428ce6408342$var$hideButtonStylesOld = null;
});
parcelRegister("bWn3s", function(module, exports) {
    $parcel$export(module.exports, "mergeRefs", ()=>$8b16fea90e636ddb$export$c9058316764c140e);
    var $dv0OY;
    var $3XwZB;
    function $8b16fea90e636ddb$export$c9058316764c140e(refs) {
        return (0, (0, parcelRequire("3XwZB")).createCallbackRef)((newValue)=>refs.forEach((ref)=>(0, (0, parcelRequire("dv0OY")).assignRef)(ref, newValue)));
    }
});
parcelRegister("3XwZB", function(module, exports) {
    $parcel$export(module.exports, "createCallbackRef", ()=>$2e2079715de82b22$export$35a19128eb4acba4);
    function $2e2079715de82b22$export$35a19128eb4acba4(callback) {
        let current = null;
        return {
            get current () {
                return current;
            },
            set current (value){
                const last = current;
                if (last !== value) {
                    current = value;
                    callback(value, last);
                }
            }
        };
    }
});
parcelRegister("f28cG", function(module, exports) {
    $parcel$export(module.exports, "useCreateTrigger", ()=>$a352d29754ee84b9$export$91c6835e1a79c0e7);
    var $5uXOq = parcelRequire("5uXOq");
    var $82CeN;
    const $a352d29754ee84b9$export$91c6835e1a79c0e7 = (rowId, type)=>{
        const element = (0, $5uXOq.useRef)(null);
        const { setActiveCreateTrigger: setActiveCreateTrigger } = (0, (0, parcelRequire("82CeN")).useFocusMarshal)();
        const setCreateTriggerRef = (0, $5uXOq.useCallback)((ref)=>{
            element.current = ref;
        }, []);
        const onCreateTriggerClick = (0, $5uXOq.useCallback)(()=>{
            if (element.current) setActiveCreateTrigger(rowId, type, element.current);
        }, [
            rowId,
            setActiveCreateTrigger,
            type
        ]);
        return {
            createTriggerRef: setCreateTriggerRef,
            onCreateTriggerClick: onCreateTriggerClick
        };
    };
});
parcelRegister("4Rpjg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$45f9bd1b7bbd9b4e$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $bWn3s;
    var $2NMNM;
    var $eTXmK;
    var $3bDjY;
    var $cSD7y;
    var $iZN6h;
    var $f28cG;
    var $3ruU1;
    var $hUAzM;
    const $45f9bd1b7bbd9b4e$var$buttonStyles = null;
    const $45f9bd1b7bbd9b4e$var$zIndexStyle = null;
    const $45f9bd1b7bbd9b4e$var$CreateSiblingButton = ({ id: id, level: level, depth: depth, parentId: parentId, label: label, onInlineCreateClicked: onInlineCreateClicked })=>{
        const element = (0, $5uXOq.useRef)(null);
        const { onAddButtonMouseEnter: onAddButtonMouseEnter, onAddButtonMouseLeave: onAddButtonMouseLeave } = (0, (0, parcelRequire("3ruU1")).useSideEffectMarshal)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { createTriggerRef: createTriggerRef, onCreateTriggerClick: onCreateTriggerClick } = (0, (0, parcelRequire("f28cG")).useCreateTrigger)(id, 'SIBLING');
        const onClick = (0, $5uXOq.useCallback)((event)=>{
            event.stopPropagation();
            onCreateTriggerClick();
            (0, (0, parcelRequire("eTXmK")).default)('timeline-add-item-clicked', event.timeStamp);
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'issueCreateButton',
                attributes: {
                    position: (0, (0, parcelRequire("iZN6h")).BEFORE),
                    level: level,
                    depth: depth
                }
            });
            (0, (0, parcelRequire("hUAzM")).fireUIAnalyticsEvent)(analyticsEvent);
            onAddButtonMouseLeave();
            onInlineCreateClicked({
                beforeId: id,
                parentId: parentId,
                position: (0, (0, parcelRequire("iZN6h")).BEFORE)
            });
        }, [
            onCreateTriggerClick,
            createAnalyticsEvent,
            level,
            depth,
            onAddButtonMouseLeave,
            onInlineCreateClicked,
            id,
            parentId
        ]);
        const updateVisualIndicator = (0, $5uXOq.useCallback)((tabFocused)=>{
            if (element.current) {
                const { top: top } = element.current.getBoundingClientRect();
                onAddButtonMouseEnter(top, tabFocused);
            }
        }, [
            onAddButtonMouseEnter
        ]);
        const onActiveHandler = (0, $5uXOq.useCallback)((tabFocused)=>{
            if (tabFocused) setTimeout(()=>updateVisualIndicator(true), 10);
            else updateVisualIndicator(false);
        }, [
            updateVisualIndicator
        ]);
        const onActive = (0, $5uXOq.useCallback)(()=>{
            onActiveHandler(false);
        }, [
            onActiveHandler
        ]);
        const onActiveFocus = (0, $5uXOq.useCallback)(()=>{
            onActiveHandler(true);
        }, [
            onActiveHandler
        ]);
        const onInactive = (0, $5uXOq.useCallback)(()=>{
            onAddButtonMouseLeave();
        }, [
            onAddButtonMouseLeave
        ]);
        const createOnFocus = (tooltipCallback)=>(e)=>{
                onActiveFocus();
                tooltipCallback(e);
            };
        const createOnBlur = (tooltipCallback)=>(e)=>{
                onInactive();
                tooltipCallback(e);
            };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: label,
            position: "left"
        }, (tooltipProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement("button", {
                ...tooltipProps,
                ref: (0, (0, parcelRequire("bWn3s")).mergeRefs)([
                    tooltipProps.ref,
                    element,
                    createTriggerRef
                ]),
                "data-testid": `roadmap.timeline-table.components.list-item.create-sibling-button.container-${id}`,
                "aria-label": label,
                onMouseEnter: onActive,
                onMouseLeave: onInactive,
                onClick: onClick,
                onFocus: createOnFocus(tooltipProps.onFocus),
                onBlur: createOnBlur(tooltipProps.onBlur),
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_kqswstnw _154i1lpd _1ltv14id _1bsb1r7l _4t3i19bv _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _bfhk18uv _19itglyw _80omtlke _nt751r31 _49pcglyw _1hvw1o36",
                    "_1pbyibnn"
                ])
            }));
    };
    const $45f9bd1b7bbd9b4e$var$CreateSiblingButtonOld = ({ id: id, level: level, depth: depth, parentId: parentId, label: label, onInlineCreateClicked: onInlineCreateClicked })=>{
        const element = (0, $5uXOq.useRef)(null);
        const { onAddButtonMouseEnter: onAddButtonMouseEnter, onAddButtonMouseLeave: onAddButtonMouseLeave } = (0, (0, parcelRequire("3ruU1")).useSideEffectMarshal)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const onClick = (0, $5uXOq.useCallback)((event)=>{
            event.stopPropagation();
            (0, (0, parcelRequire("eTXmK")).default)('timeline-add-item-clicked', event.timeStamp);
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'issueCreateButton',
                attributes: {
                    position: (0, (0, parcelRequire("iZN6h")).BEFORE),
                    level: level,
                    depth: depth
                }
            });
            (0, (0, parcelRequire("hUAzM")).fireUIAnalyticsEvent)(analyticsEvent);
            onAddButtonMouseLeave();
            onInlineCreateClicked({
                beforeId: id,
                parentId: parentId,
                position: (0, (0, parcelRequire("iZN6h")).BEFORE)
            });
        }, [
            createAnalyticsEvent,
            level,
            depth,
            onAddButtonMouseLeave,
            onInlineCreateClicked,
            id,
            parentId
        ]);
        const onActiveHandler = (0, $5uXOq.useCallback)((tabFocused)=>{
            if (element.current) {
                const { top: top } = element.current.getBoundingClientRect();
                onAddButtonMouseEnter(top, tabFocused);
            }
        }, [
            onAddButtonMouseEnter
        ]);
        const onActive = (0, $5uXOq.useCallback)(()=>{
            onActiveHandler(false);
        }, [
            onActiveHandler
        ]);
        const onActiveFocus = (0, $5uXOq.useCallback)(()=>{
            onActiveHandler(true);
        }, [
            onActiveHandler
        ]);
        const onInactive = (0, $5uXOq.useCallback)(()=>{
            onAddButtonMouseLeave();
        }, [
            onAddButtonMouseLeave
        ]);
        const createOnFocus = (tooltipCallback)=>(e)=>{
                onActiveFocus();
                tooltipCallback(e);
            };
        const createOnBlur = (tooltipCallback)=>(e)=>{
                onInactive();
                tooltipCallback(e);
            };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: label,
            position: "left"
        }, (tooltipProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement("button", {
                ...tooltipProps,
                ref: (0, (0, parcelRequire("bWn3s")).mergeRefs)([
                    tooltipProps.ref,
                    element
                ]),
                "data-testid": `roadmap.timeline-table.components.list-item.create-sibling-button.container-${id}`,
                "aria-label": label,
                onMouseEnter: onActive,
                onMouseLeave: onInactive,
                onClick: onClick,
                onFocus: createOnFocus(tooltipProps.onFocus),
                onBlur: createOnBlur(tooltipProps.onBlur),
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_kqswstnw _154i1lpd _1ltv14id _1bsb1r7l _4t3i19bv _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _bfhk18uv _19itglyw _80omtlke _nt751r31 _49pcglyw _1hvw1o36",
                    "_1pbyibnn"
                ])
            }));
    };
    var $45f9bd1b7bbd9b4e$export$2e2bcd8739ae039 = (0, $5uXOq.memo)((0, (0, parcelRequire("cSD7y")).componentWithFG)('jsw_roadmaps_timeline_table_meatballs_menu_a11y', $45f9bd1b7bbd9b4e$var$CreateSiblingButton, $45f9bd1b7bbd9b4e$var$CreateSiblingButtonOld));
});
parcelRegister("hQYX7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$756a5e7051e31a8c$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $c8Oei;
    var $hWZau;
    var $kgoHi;
    var $8CUq3;
    var $eTXmK;
    var $dCm1o;
    const $756a5e7051e31a8c$var$buttonStyles = null;
    const $756a5e7051e31a8c$var$ChevronWrapper = ({ children: children })=>(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            testId: "roadmap.timeline-table.main.content.list.list-item.expand-button.wrapper",
            justifyContent: "center",
            alignItems: "center",
            xcss: $756a5e7051e31a8c$var$containerStyles
        }, children) : children;
    const $756a5e7051e31a8c$var$ExpandButton = ({ id: id, label: label, isRichContentEnabled: isRichContentEnabled, isExpanded: isExpanded, ariaControls: ariaControls, onExpandChanged: onExpandChanged })=>{
        const onClick = (0, $5uXOq.useCallback)((event)=>{
            event.stopPropagation();
            (0, (0, parcelRequire("eTXmK")).default)('timeline-expand-changed', event.timeStamp);
            onExpandChanged(id, isExpanded);
        }, [
            id,
            isExpanded,
            onExpandChanged
        ]);
        const Chevron = isExpanded ? (0, ($parcel$interopDefault((0, parcelRequire("c8Oei"))))) : (0, ($parcel$interopDefault((0, parcelRequire("hWZau")))));
        const chevronElement = (0, ($parcel$interopDefault($5uXOq))).createElement($756a5e7051e31a8c$var$ChevronWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement(Chevron, {
            testId: `roadmap.timeline-table.components.list-item.expand-button.container-${id}`,
            color: `var(--ds-icon, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
            label: label
        }));
        if (!isRichContentEnabled) return chevronElement;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("button", {
            onClick: onClick,
            "aria-expanded": isExpanded,
            "aria-label": label,
            ...isExpanded && ariaControls && {
                'aria-controls': ariaControls
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _19itglyw _bfhk18uv _80omtlke _1e0c1txw _16jlidpf _1o9zidpf _i0dl1wug _12ji1r31 _1qu2glyw _12y31o36 _nt751r31 _49pcglyw _1hvw1o36 _1ejj168b"
            ])
        }, chevronElement);
    };
    var $756a5e7051e31a8c$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($756a5e7051e31a8c$var$ExpandButton);
    const $756a5e7051e31a8c$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '24px',
        height: '24px'
    });
});
parcelRegister("e3R1o", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a6d75372fa4bcf21$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $hORKG;
    var $3dGN0;
    var $eTXmK;
    var $4R6GH;
    const $a6d75372fa4bcf21$var$buttonStyles = null;
    const $a6d75372fa4bcf21$var$ExpandButton = ({ id: id, label: label, isExpanded: isExpanded, ariaControls: ariaControls, onExpandChanged: onExpandChanged })=>{
        const onClick = (0, $5uXOq.useCallback)((event)=>{
            event.stopPropagation();
            (0, (0, parcelRequire("eTXmK")).default)('timeline-expand-changed', event.timeStamp);
            onExpandChanged(id, isExpanded);
        }, [
            id,
            isExpanded,
            onExpandChanged
        ]);
        const Chevron = isExpanded ? (0, ($parcel$interopDefault((0, parcelRequire("hORKG"))))) : (0, ($parcel$interopDefault((0, parcelRequire("3dGN0")))));
        const chevronElement = (0, ($parcel$interopDefault($5uXOq))).createElement(Chevron, {
            testId: `roadmap.timeline-table.components.list-item.expand-button.container-${id}`,
            label: (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-post-project-a11y-fix') ? '' : label
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement("button", {
            onClick: onClick,
            "aria-expanded": isExpanded,
            "aria-label": label,
            ...isExpanded && ariaControls && {
                'aria-controls': ariaControls
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1tcg _1bsb1tcg _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _19itglyw _bfhk18uv _80omtlke _16jlidpf _1o9zidpf _i0dl1wug _12ji1r31 _1qu2glyw _12y31o36 _nt751r31 _49pcglyw _1hvw1o36 _1ejj168b"
            ])
        }, chevronElement);
    };
    var $a6d75372fa4bcf21$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($a6d75372fa4bcf21$var$ExpandButton);
});
parcelRegister("jU4rh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a4b5018ddc89c433$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $fiCSn;
    const $a4b5018ddc89c433$var$ListItemMeatBallsButton = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "timeline-table-list-item-meatballs-button",
            packageName: "timelineTable",
            fallback: "flag"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fiCSn")).default), props));
    var $a4b5018ddc89c433$export$2e2bcd8739ae039 = $a4b5018ddc89c433$var$ListItemMeatBallsButton;
});
parcelRegister("fiCSn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$86827779df6f3ef5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $iZN6h;
    var $WPwAA;
    var $9puhl;
    var $82CeN;
    var $dhWQP;
    var $8FneZ;
    const $86827779df6f3ef5$var$MeatBallsButton = ({ isTriggerVisible: isTriggerVisible = true, isMenuOpen: isMenuOpen, id: id, level: level, depth: depth, parentId: parentId, isCreateChildEnabled: isCreateChildEnabled, isCreateSiblingEnabled: isCreateSiblingEnabled, renderListItemMenuOption: renderListItemMenuOption, renderListItemModal: renderListItemModal, onStopHoverOrFocus: onStopHoverOrFocus, onInlineCreateClicked: onInlineCreateClicked, onDrop: onDrop, setIsMenuOpen: setIsMenuOpen, cellRef: cellRef })=>{
        const [activeOptionId, setActiveOptionId] = (0, $5uXOq.useState)('');
        const [{ customSections: customSections }] = (0, (0, parcelRequire("9puhl")).useListItemMenuOptions)();
        const [{ isDragEnabled: isDragEnabled }] = (0, (0, parcelRequire("WPwAA")).useEnablements)();
        const [isActiveMeatballTrigger] = (0, (0, parcelRequire("82CeN")).useIsCreateTriggerActive)({
            id: id,
            type: 'MEATBALLS'
        });
        const { shouldPreventNavigation: shouldPreventNavigation } = (0, (0, parcelRequire("82CeN")).useFocusMarshal)();
        const returnFocus = (0, $5uXOq.useRef)(false);
        const ref = (0, $5uXOq.useRef)(null);
        const menuRef = (0, $5uXOq.useRef)(null);
        const closeMenu = (0, $5uXOq.useCallback)(()=>{
            setIsMenuOpen(false);
        }, [
            setIsMenuOpen
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isMenuOpen && returnFocus.current) {
                returnFocus.current = false;
                setTimeout(()=>{
                    ref.current?.focus();
                }, 0);
            }
        }, [
            isMenuOpen
        ]);
        (0, (0, parcelRequire("dhWQP")).useOnClickOutside)({
            cellRef: cellRef,
            menuRef: menuRef,
            triggerRef: ref,
            closeMenu: closeMenu,
            isMenuOpen: isMenuOpen,
            onStopHoverOrFocus: onStopHoverOrFocus
        });
        const [customItemsSections, customOtherSections] = (0, $5uXOq.useMemo)(()=>{
            const itemsSections = [];
            const otherSections = [];
            customSections.forEach((section)=>{
                if (section.id === (0, (0, parcelRequire("iZN6h")).listItemMenu).ITEMS_SECTION) itemsSections.push(section);
                else otherSections.push(section);
            });
            return [
                itemsSections,
                otherSections
            ];
        }, [
            customSections
        ]);
        const setCloseMenu = (0, $5uXOq.useCallback)((event, { shouldReturnFocus: shouldReturnFocus, shouldEnableNavigation: shouldEnableNavigation } = {
            shouldReturnFocus: true,
            shouldEnableNavigation: true
        })=>{
            const isMouseClick = event?.detail && event.detail > 0;
            const shouldStopFocus = isMouseClick || shouldReturnFocus === false;
            returnFocus.current = !shouldStopFocus;
            setIsMenuOpen(false);
            if (shouldStopFocus) onStopHoverOrFocus();
            if (shouldEnableNavigation && (0, (0, parcelRequire("4R6GH")).fg)('timeline_grid_navigation_m2')) shouldPreventNavigation(false);
        }, [
            shouldPreventNavigation,
            onStopHoverOrFocus,
            setIsMenuOpen
        ]);
        const onMenuToggle = (0, $5uXOq.useCallback)(()=>{
            setIsMenuOpen((currentState)=>!currentState);
        }, [
            setIsMenuOpen
        ]);
        const setOpenModal = (0, $5uXOq.useCallback)((event, optionId)=>{
            (0, (0, parcelRequire("4R6GH")).fg)('timeline_grid_navigation_m2') ? setCloseMenu(event, {
                shouldEnableNavigation: false
            }) : setCloseMenu(event);
            setActiveOptionId(optionId);
        }, [
            setCloseMenu
        ]);
        const setCloseModal = (0, $5uXOq.useCallback)(()=>{
            setActiveOptionId('');
            if ((0, (0, parcelRequire("4R6GH")).fg)('timeline_grid_navigation_m2')) shouldPreventNavigation(false);
        }, [
            shouldPreventNavigation
        ]);
        const onStopPropagation = (0, $5uXOq.useCallback)((event)=>{
            event.stopPropagation();
        }, []);
        const onStopDragging = (0, $5uXOq.useCallback)((event)=>{
            event.preventDefault();
            event.stopPropagation();
        }, []);
        const prebuiltOptions = (0, $5uXOq.useMemo)(()=>{
            const options = [];
            if (isCreateChildEnabled || isCreateSiblingEnabled) options.push({
                id: (0, (0, parcelRequire("iZN6h")).listItemMenu).CREATE_ITEM
            });
            if ((0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmap_timeline_meatball_move_menu')) {
                if (isDragEnabled) options.push({
                    id: (0, (0, parcelRequire("iZN6h")).listItemMenu).MOVE_ITEM
                });
            }
            return options;
        }, [
            isCreateChildEnabled,
            isCreateSiblingEnabled,
            isDragEnabled
        ]);
        const issuesSectionOptions = (0, $5uXOq.useMemo)(()=>{
            const issuesSectionCustomOptions = customItemsSections.reduce((acc, { options: options })=>{
                acc.push(...options);
                return acc;
            }, []);
            return [
                ...prebuiltOptions,
                ...issuesSectionCustomOptions
            ];
        }, [
            customItemsSections,
            prebuiltOptions
        ]);
        if (issuesSectionOptions.length > 0 || customSections.length > 0) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            role: "presentation",
            onClick: onStopPropagation,
            draggable: true,
            onDragStart: onStopDragging
        }, isTriggerVisible || isActiveMeatballTrigger ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8FneZ")).default), {
            id: id,
            isOpen: isMenuOpen,
            onMenuToggle: onMenuToggle,
            setCloseMenu: setCloseMenu,
            setOpenModal: setOpenModal,
            issuesSectionOptions: issuesSectionOptions,
            customOtherSections: customOtherSections,
            parentId: parentId,
            level: level,
            depth: depth,
            isCreateChildEnabled: isCreateChildEnabled,
            isCreateSiblingEnabled: isCreateSiblingEnabled,
            onInlineCreateClicked: onInlineCreateClicked,
            renderListItemMenuOption: renderListItemMenuOption,
            onDrop: onDrop,
            ref: ref,
            menuRef: menuRef
        }) : null), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            role: "presentation",
            onClick: onStopPropagation,
            onKeyUp: onStopPropagation
        }, renderListItemModal?.({
            id: id,
            optionId: activeOptionId,
            setCloseModal: setCloseModal,
            triggerRef: ref
        })));
        return null;
    };
    var $86827779df6f3ef5$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($86827779df6f3ef5$var$MeatBallsButton);
});
parcelRegister("dhWQP", function(module, exports) {
    $parcel$export(module.exports, "useOnClickOutside", ()=>$a54593f463a3e35b$export$9afc64c180e82dc4);
    var $5uXOq = parcelRequire("5uXOq");
    const $a54593f463a3e35b$export$9afc64c180e82dc4 = ({ menuRef: menuRef, cellRef: cellRef, triggerRef: triggerRef, closeMenu: closeMenu, isMenuOpen: isMenuOpen, onStopHoverOrFocus: onStopHoverOrFocus })=>{
        (0, $5uXOq.useEffect)(()=>{
            const handleOnClickOutsideMenu = ({ target: target })=>{
                if (target instanceof Node) {
                    if (isMenuOpen && cellRef && !cellRef.current?.contains(target)) onStopHoverOrFocus?.();
                    else if (isMenuOpen && !triggerRef.current?.contains(target) && !menuRef.current?.contains(target)) closeMenu();
                }
            };
            if (typeof document !== 'undefined') document.addEventListener('mousedown', handleOnClickOutsideMenu);
            return ()=>{
                if (typeof document !== 'undefined') document.removeEventListener('mousedown', handleOnClickOutsideMenu);
            };
        }, [
            cellRef,
            closeMenu,
            isMenuOpen,
            menuRef,
            onStopHoverOrFocus,
            triggerRef
        ]);
    };
});
parcelRegister("8FneZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$910dcbf94700408d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $bWn3s;
    var $42CjB;
    var $bJeNF;
    var $eZUJu;
    var $1I7E8;
    var $dC5iT;
    var $8CUq3;
    var $4R6GH;
    var $dCm1o;
    var $iZN6h;
    var $hGh1Z;
    var $3Kr5N;
    var $82CeN;
    var $f28cG;
    var $c2ZwS;
    var $hJ7HI;
    var $daGMH;
    const $910dcbf94700408d$var$MeatballPopup = (0, $5uXOq.forwardRef)(({ id: id, isOpen: isOpen, issuesSectionOptions: issuesSectionOptions, customOtherSections: customOtherSections, parentId: parentId, level: level, depth: depth, onDrop: onDrop, menuRef: menuRef, isCreateChildEnabled: isCreateChildEnabled, isCreateSiblingEnabled: isCreateSiblingEnabled, onInlineCreateClicked: onInlineCreateClicked, renderListItemMenuOption: renderListItemMenuOption, onMenuToggle: onMenuToggle, setCloseMenu: setCloseMenu, setOpenModal: setOpenModal }, ref)=>{
        const { createTriggerRef: createTriggerRef, onCreateTriggerClick: onCreateTriggerClick } = (0, (0, parcelRequire("f28cG")).useCreateTrigger)(id, 'MEATBALLS');
        const [isMultiSelected] = (0, (0, parcelRequire("hGh1Z")).useIsItemMultiSelected)(id);
        const [isScrollingY] = (0, (0, parcelRequire("3Kr5N")).useIsScrollingY)();
        const [itemsSelectionCount] = (0, (0, parcelRequire("hGh1Z")).useItemsSelectionCount)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        let itemsSelectionAriaLabel = '';
        if (isMultiSelected) itemsSelectionAriaLabel = formatMessage((0, (0, parcelRequire("c2ZwS")).default).itemsSelectionCount, {
            count: itemsSelectionCount
        });
        const { shouldPreventNavigation: shouldPreventNavigation } = (0, (0, parcelRequire("82CeN")).useFocusMarshal)();
        (0, $5uXOq.useEffect)(()=>{
            if (isScrollingY && isOpen) setCloseMenu();
        }, [
            isOpen,
            isScrollingY,
            setCloseMenu
        ]);
        const renderMenu = (0, $5uXOq.useCallback)(({ setInitialFocusRef: setInitialFocusRef })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                ref: menuRef,
                xcss: $910dcbf94700408d$var$menuWrapStyles
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZUJu")).default), {
                testId: `roadmap.timeline-table.main.content.list.list-item.meatballs-button.meatball-popup.menu-${id}`,
                maxHeight: (0, (0, parcelRequire("iZN6h")).DEFAULT_MENU_MAX_HEIGHT)
            }, isMultiSelected && (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmap_timeline_meatball_selected_item_option') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hJ7HI")).default), {
                id: id,
                renderListItemMenuOption: renderListItemMenuOption,
                setOpenModal: setOpenModal,
                onCreateTriggerClick: onCreateTriggerClick,
                setInitialFocusRef: setInitialFocusRef,
                setCloseMenu: setCloseMenu
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("daGMH")).default), {
                issuesSectionOptions: issuesSectionOptions,
                customOtherSections: customOtherSections,
                id: id,
                parentId: parentId,
                level: level,
                depth: depth,
                isCreateChildEnabled: isCreateChildEnabled,
                isCreateSiblingEnabled: isCreateSiblingEnabled,
                onInlineCreateClicked: onInlineCreateClicked,
                setInitialFocusRef: setInitialFocusRef,
                onDrop: onDrop,
                renderListItemMenuOption: renderListItemMenuOption,
                setCloseMenu: setCloseMenu,
                setOpenModal: setOpenModal,
                onCreateTriggerClick: onCreateTriggerClick
            }))), [
            customOtherSections,
            depth,
            id,
            isCreateChildEnabled,
            isCreateSiblingEnabled,
            isMultiSelected,
            issuesSectionOptions,
            level,
            menuRef,
            onCreateTriggerClick,
            onDrop,
            onInlineCreateClicked,
            parentId,
            renderListItemMenuOption,
            setCloseMenu,
            setOpenModal
        ]);
        const onClick = (0, $5uXOq.useCallback)((e)=>{
            shouldPreventNavigation(true);
            onMenuToggle(e);
        }, [
            shouldPreventNavigation,
            onMenuToggle
        ]);
        const trigger = (0, $5uXOq.useCallback)(({ ref: triggerRef, ...triggerProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $910dcbf94700408d$var$buttonWrapStyles
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
                ...triggerProps,
                ref: (0, (0, parcelRequire("bWn3s")).mergeRefs)([
                    ref,
                    createTriggerRef,
                    triggerRef
                ]),
                onClick: (0, (0, parcelRequire("4R6GH")).fg)('timeline_grid_navigation_m2') ? onClick : onMenuToggle,
                spacing: "compact",
                testId: `roadmap.timeline-table.main.content.list.list-item.more-options-button.meatballs-menu-${id}`,
                label: itemsSelectionAriaLabel && (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmap_timeline_meatball_selected_item_option') ? `${formatMessage((0, (0, parcelRequire("c2ZwS")).default).meatballsButtonLabel)} ${itemsSelectionAriaLabel}` : formatMessage((0, (0, parcelRequire("c2ZwS")).default).meatballsButtonLabel),
                icon: (0, ($parcel$interopDefault((0, parcelRequire("bJeNF"))))),
                interactionName: "timeline-meatballs-trigger-clicked",
                appearance: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? 'subtle' : 'default'
            })), [
            createTriggerRef,
            formatMessage,
            id,
            itemsSelectionAriaLabel,
            onClick,
            onMenuToggle,
            ref
        ]);
        const onPopupClose = (0, $5uXOq.useCallback)((event)=>setCloseMenu(event), [
            setCloseMenu
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            role: "dialog",
            shouldFlip: false,
            shouldRenderToParent: true,
            shouldReturnFocus: false,
            shouldUseCaptureOnOutsideClick: true,
            onClose: onPopupClose,
            placement: "right-start",
            isOpen: isOpen,
            content: renderMenu,
            trigger: trigger
        });
    });
    const $910dcbf94700408d$var$buttonWrapStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginLeft: 'space.050'
    });
    const $910dcbf94700408d$var$menuWrapStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        cursor: 'default'
    });
    var $910dcbf94700408d$export$2e2bcd8739ae039 = $910dcbf94700408d$var$MeatballPopup;
});
parcelRegister("c2ZwS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$39aaa2bfa3ac9243$export$2e2bcd8739ae039);
    var $7VHMR;
    const $39aaa2bfa3ac9243$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        meatballsButtonLabel: {
            id: 'roadmap.timeline-table.main.content.list.list-item.meatballs-button.meatball-popup.meatballs-button-label',
            defaultMessage: 'More actions',
            description: 'Label for the more options button in the list item'
        },
        itemsSectionHeader: {
            id: 'roadmap.timeline-table.main.content.list.list-item.meatballs-button.meatball-popup.items-section-header',
            defaultMessage: 'Items',
            description: 'Header for the item section in the list item'
        },
        itemsSelectionCount: {
            id: 'roadmap.timeline-table.main.content.list.list-item.meatballs-button.meatball-popup.items-selection-count',
            defaultMessage: '{count} {count, plural, one {item selected} other {items selected}}',
            description: 'Label to indicate the count of selected items on a meatballs button'
        }
    });
    var $39aaa2bfa3ac9243$export$2e2bcd8739ae039 = $39aaa2bfa3ac9243$var$messages;
});
parcelRegister("hJ7HI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0cedfc9508758fa3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $16T6Y;
    var $dC5iT;
    var $8CUq3;
    var $iZN6h;
    var $hGh1Z;
    var $9puhl;
    var $dedQ1;
    var $8AXBg;
    const $0cedfc9508758fa3$var$MultiSelectOptions = ({ id: id, onCreateTriggerClick: onCreateTriggerClick, setCloseMenu: setCloseMenu, setInitialFocusRef: setInitialFocusRef, setOpenModal: setOpenModal, renderListItemMenuOption: renderListItemMenuOption })=>{
        const [{ overrideLabels: overrideLabels, customSectionsBulk: customSectionsBulk }] = (0, (0, parcelRequire("9puhl")).useListItemMenuOptions)();
        const [itemsSelectionCount] = (0, (0, parcelRequire("hGh1Z")).useItemsSelectionCount)();
        const isLabelOverridden = Boolean(overrideLabels[(0, (0, parcelRequire("iZN6h")).listItemMenu).SELECTED_ITEM_COUNTER]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            testId: "roadmap.timeline-table.main.content.list.list-item.meatballs-button.meatball-popup.multi-select-options.section"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $0cedfc9508758fa3$var$bulkIndicatorContainer,
            "aria-hidden": true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
            ...isLabelOverridden ? overrideLabels[(0, (0, parcelRequire("iZN6h")).listItemMenu).SELECTED_ITEM_COUNTER] : (0, (0, parcelRequire("8AXBg")).default).selected,
            values: {
                count: itemsSelectionCount,
                badge: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("16T6Y")).default), {
                        appearance: "primary"
                    }, chunks)
            }
        }))), customSectionsBulk.length > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dedQ1")).default), {
            id: id,
            customOtherSections: customSectionsBulk,
            onCreateTriggerClick: onCreateTriggerClick,
            setCloseMenu: setCloseMenu,
            setInitialFocusRef: setInitialFocusRef,
            setOpenModal: setOpenModal,
            renderListItemMenuOption: renderListItemMenuOption
        }));
    };
    const $0cedfc9508758fa3$var$bulkIndicatorContainer = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        paddingLeft: 'space.250',
        paddingRight: 'space.250',
        textTransform: 'uppercase',
        alignItems: 'center',
        height: "var(--ds-space-400, 32px)",
        color: 'color.text.subtle',
        font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        fontWeight: "var(--ds-font-weight-medium, 500)",
        gap: 'space.100'
    });
    var $0cedfc9508758fa3$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($0cedfc9508758fa3$var$MultiSelectOptions);
});
parcelRegister("dedQ1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$50b9289e9e8f41bb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $1dJ6S;
    var $dC5iT;
    var $8CUq3;
    var $hyeSr;
    var $lgz7j;
    const $50b9289e9e8f41bb$var$CustomOptions = ({ id: id, customOtherSections: customOtherSections, onCreateTriggerClick: onCreateTriggerClick, setCloseMenu: setCloseMenu, setInitialFocusRef: setInitialFocusRef, setOpenModal: setOpenModal, renderListItemMenuOption: renderListItemMenuOption })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, customOtherSections.map(({ id: sectionId, title: title, options: options })=>{
            if (!options || options.length === 0) return null;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $50b9289e9e8f41bb$var$sectionWrap,
                key: sectionId,
                testId: `roadmap.timeline-table.main.content.list.list-item.meatballs-button.meatball-popup.custom-options.${sectionId}`
            }, title && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $50b9289e9e8f41bb$var$headingWrap
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
                size: "xxsmall",
                as: "div"
            }, (0, (0, parcelRequire("lgz7j")).renderOverrideLabel)(formatMessage, title))), options.map(({ id: optionId }, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    key: optionId
                }, renderListItemMenuOption({
                    id: id,
                    optionId: optionId,
                    setInitialFocusRef: index === 0 ? setInitialFocusRef : undefined,
                    setOpenModal: (event)=>{
                        setOpenModal(event, optionId);
                    },
                    Option: (0, (0, parcelRequire("hyeSr")).ListItemMenuOption),
                    onCreateTriggerClick: onCreateTriggerClick,
                    setCloseMenu: setCloseMenu
                }))));
        }));
    };
    const $50b9289e9e8f41bb$var$headingWrap = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginTop: 'space.250',
        marginBottom: 'space.075',
        paddingLeft: 'space.200',
        paddingRight: 'space.200'
    });
    const $50b9289e9e8f41bb$var$sectionWrap = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderTop: '1px solid',
        borderColor: 'color.border',
        marginTop: 'space.075'
    });
    var $50b9289e9e8f41bb$export$2e2bcd8739ae039 = $50b9289e9e8f41bb$var$CustomOptions;
});
parcelRegister("hyeSr", function(module, exports) {
    $parcel$export(module.exports, "ListItemMenuOption", ()=>$896c724a6a983c05$export$6c14ffa7379dfa2e);
    var $5uXOq = parcelRequire("5uXOq");
    var $bWn3s;
    var $kJpBP;
    var $3bDjY;
    var $4R6GH;
    var $cAWit;
    const $896c724a6a983c05$export$6c14ffa7379dfa2e = ({ isDisabled: isDisabled, label: label, disabledTooltip: disabledTooltip, triggerRef: triggerRef, interactionName: interactionName, onClick: onClick, setInitialFocusRef: setInitialFocusRef, children: children })=>{
        const renderButtonItem = (0, $5uXOq.useCallback)((triggerProps)=>{
            const refs = [];
            if (setInitialFocusRef) refs.push(setInitialFocusRef);
            if (triggerProps?.ref) refs.push(triggerProps.ref);
            if (triggerRef) refs.push(triggerRef);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
                ...triggerProps,
                isDisabled: isDisabled,
                onClick: onClick,
                ref: (0, (0, parcelRequire("bWn3s")).mergeRefs)(refs),
                ...(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics') ? {
                    interactionName: interactionName
                } : {}
            }, label);
        }, [
            setInitialFocusRef,
            triggerRef,
            isDisabled,
            onClick,
            interactionName,
            label
        ]);
        if (children) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cAWit")).default), {
            isDisabled: isDisabled,
            disabledTooltip: disabledTooltip,
            label: label,
            setInitialFocusRef: setInitialFocusRef,
            triggerRef: triggerRef,
            ...(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics') ? {
                interactionName: interactionName
            } : {}
        }, children);
        return isDisabled && disabledTooltip ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: disabledTooltip
        }, renderButtonItem) : renderButtonItem();
    };
});
parcelRegister("cAWit", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d30d299666541606$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bWn3s;
    var $hWZau;
    var $kJpBP;
    var $1I7E8;
    var $dC5iT;
    var $3bDjY;
    var $4R6GH;
    var $dhWQP;
    const $d30d299666541606$var$PopupButton = ({ label: label, isDisabled: isDisabled, disabledTooltip: disabledTooltip, triggerRef: triggerRef, interactionName: interactionName, setInitialFocusRef: setInitialFocusRef, children: children })=>{
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        const menuRef = (0, $5uXOq.useRef)(null);
        const ref = (0, $5uXOq.useRef)(null);
        const onClose = (0, $5uXOq.useCallback)(()=>{
            setIsOpen(false);
        }, []);
        const onMenuToggle = (0, $5uXOq.useCallback)((e)=>{
            e.stopPropagation();
            setIsOpen((currentState)=>!currentState);
        }, []);
        (0, (0, parcelRequire("dhWQP")).useOnClickOutside)({
            menuRef: menuRef,
            closeMenu: onClose,
            isMenuOpen: isOpen,
            triggerRef: ref
        });
        const renderContent = (0, $5uXOq.useCallback)(({ setInitialFocusRef: setFocusRef })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                ref: menuRef,
                testId: "roadmap.timeline-table.main.content.list.list-item.list-item-menu-option.popup-button.content"
            }, children({
                setInitialFocusRef: setFocusRef
            })), [
            children
        ]);
        const renderButtonItem = (0, $5uXOq.useCallback)((popupTriggerProps, tooltipTriggerProps)=>{
            const refs = [
                popupTriggerProps.ref
            ];
            if (tooltipTriggerProps?.ref) refs.push(tooltipTriggerProps.ref);
            if (setInitialFocusRef) refs.push(setInitialFocusRef);
            if (triggerRef) refs.push(triggerRef);
            refs.push(ref);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
                ...tooltipTriggerProps,
                ...popupTriggerProps,
                onClick: onMenuToggle,
                isDisabled: isDisabled,
                iconAfter: !isDisabled ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("hWZau"))))), {
                    color: "var(--ds-icon-subtle)",
                    label: "",
                    testId: "roadmap.timeline-table.main.content.list.list-item.list-item-menu-option.popup-button.chevron-right-icon"
                }) : undefined,
                ref: (0, (0, parcelRequire("bWn3s")).mergeRefs)(refs),
                ...(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics') ? {
                    interactionName: interactionName
                } : {}
            }, label);
        }, [
            interactionName,
            isDisabled,
            label,
            onMenuToggle,
            setInitialFocusRef,
            triggerRef
        ]);
        const trigger = (0, $5uXOq.useCallback)((triggerProps)=>isDisabled && disabledTooltip ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                content: disabledTooltip
            }, (tooltipProps)=>renderButtonItem(triggerProps, tooltipProps)) : renderButtonItem(triggerProps), [
            isDisabled,
            disabledTooltip,
            renderButtonItem
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            role: "dialog",
            shouldRenderToParent: true,
            shouldUseCaptureOnOutsideClick: true,
            isOpen: isOpen,
            placement: "right-start",
            onClose: onClose,
            content: renderContent,
            trigger: trigger
        });
    };
    var $d30d299666541606$export$2e2bcd8739ae039 = $d30d299666541606$var$PopupButton;
});
parcelRegister("lgz7j", function(module, exports) {
    $parcel$export(module.exports, "renderOverrideLabel", ()=>$081cd1d18b8e60f3$export$9f99feb062b3eb64);
    const $081cd1d18b8e60f3$export$9f99feb062b3eb64 = (formatMessage, descriptor, values)=>{
        if (descriptor) return formatMessage(descriptor, values);
    };
});
parcelRegister("8AXBg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5ced3165e49d91ff$export$2e2bcd8739ae039);
    var $7VHMR;
    const $5ced3165e49d91ff$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        selected: {
            id: 'roadmap.timeline-table.main.content.list.list-item.meatballs-button.meatball-popup.multi-select-options.selected',
            description: 'Label to indicate the number of selected item on a meatballs menu',
            defaultMessage: '<badge>{count}</badge> selected'
        }
    });
    var $5ced3165e49d91ff$export$2e2bcd8739ae039 = $5ced3165e49d91ff$var$messages;
});
parcelRegister("daGMH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d23221329fab77af$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $1dJ6S;
    var $dC5iT;
    var $8CUq3;
    var $iZN6h;
    var $9puhl;
    var $lgz7j;
    var $dedQ1;
    var $4Eawx;
    var $c2ZwS;
    const $d23221329fab77af$var$SingleSelectOptions = ({ issuesSectionOptions: issuesSectionOptions, customOtherSections: customOtherSections, id: id, parentId: parentId, level: level, depth: depth, isCreateChildEnabled: isCreateChildEnabled, isCreateSiblingEnabled: isCreateSiblingEnabled, renderListItemMenuOption: renderListItemMenuOption, onInlineCreateClicked: onInlineCreateClicked, onDrop: onDrop, setCloseMenu: setCloseMenu, setInitialFocusRef: setInitialFocusRef, setOpenModal: setOpenModal, onCreateTriggerClick: onCreateTriggerClick })=>{
        const [{ overrideLabels: overrideLabels }] = (0, (0, parcelRequire("9puhl")).useListItemMenuOptions)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const headingLabel = (0, (0, parcelRequire("lgz7j")).renderOverrideLabel)(formatMessage, overrideLabels[(0, (0, parcelRequire("iZN6h")).listItemMenu).ITEMS_SECTION]) || formatMessage((0, (0, parcelRequire("c2ZwS")).default).itemsSectionHeader);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, issuesSectionOptions.length > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            testId: "roadmap.timeline-table.main.content.list.list-item.meatballs-button.meatball-popup.single-select-options.items-section"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $d23221329fab77af$var$headingWrap
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            size: "xxsmall",
            as: "div",
            testId: "roadmap.timeline-table.main.content.list.list-item.meatballs-button.meatball-popup.single-select-options.heading"
        }, headingLabel)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4Eawx")).default), {
            issuesSectionOptions: issuesSectionOptions,
            id: id,
            parentId: parentId,
            level: level,
            depth: depth,
            isCreateChildEnabled: isCreateChildEnabled,
            isCreateSiblingEnabled: isCreateSiblingEnabled,
            onInlineCreateClicked: onInlineCreateClicked,
            setInitialFocusRef: setInitialFocusRef,
            onDrop: onDrop,
            renderListItemMenuOption: renderListItemMenuOption,
            onCreateTriggerClick: onCreateTriggerClick,
            setCloseMenu: setCloseMenu,
            setOpenModal: setOpenModal
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dedQ1")).default), {
            id: id,
            customOtherSections: customOtherSections,
            onCreateTriggerClick: onCreateTriggerClick,
            setCloseMenu: setCloseMenu,
            setInitialFocusRef: issuesSectionOptions.length === 0 ? setInitialFocusRef : undefined,
            setOpenModal: setOpenModal,
            renderListItemMenuOption: renderListItemMenuOption
        }));
    };
    const $d23221329fab77af$var$headingWrap = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginTop: 'space.250',
        marginBottom: 'space.075',
        paddingLeft: 'space.200',
        paddingRight: 'space.200'
    });
    var $d23221329fab77af$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($d23221329fab77af$var$SingleSelectOptions);
});
parcelRegister("4Eawx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$99ab925a6af54be0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iZN6h;
    var $hyeSr;
    var $iup31;
    var $ek5AF;
    const $99ab925a6af54be0$var$ItemSectionOptions = ({ id: id, parentId: parentId, level: level, depth: depth, isCreateChildEnabled: isCreateChildEnabled, isCreateSiblingEnabled: isCreateSiblingEnabled, onInlineCreateClicked: onInlineCreateClicked, issuesSectionOptions: issuesSectionOptions, setInitialFocusRef: setInitialFocusRef, renderListItemMenuOption: renderListItemMenuOption, setCloseMenu: setCloseMenu, setOpenModal: setOpenModal, onDrop: onDrop, onCreateTriggerClick: onCreateTriggerClick })=>issuesSectionOptions.map(({ id: optionId }, index)=>{
            switch(optionId){
                case (0, (0, parcelRequire("iZN6h")).listItemMenu).CREATE_ITEM:
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iup31")).default), {
                        key: optionId,
                        id: id,
                        parentId: parentId,
                        level: level,
                        depth: depth,
                        isCreateChildEnabled: isCreateChildEnabled,
                        isCreateSiblingEnabled: isCreateSiblingEnabled,
                        onInlineCreateClicked: onInlineCreateClicked,
                        setInitialFocusRef: index === 0 ? setInitialFocusRef : undefined,
                        onCreateTriggerClick: onCreateTriggerClick,
                        setCloseMenu: setCloseMenu
                    });
                case (0, (0, parcelRequire("iZN6h")).listItemMenu).MOVE_ITEM:
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ek5AF")).default), {
                        id: id,
                        key: optionId,
                        level: level,
                        parentId: parentId,
                        setInitialFocusRef: index === 0 ? setInitialFocusRef : undefined,
                        onDrop: onDrop,
                        setCloseMenu: setCloseMenu
                    });
                default:
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
                        key: optionId
                    }, renderListItemMenuOption({
                        id: id,
                        optionId: optionId,
                        setOpenModal: (event)=>setOpenModal(event, optionId),
                        setInitialFocusRef: index === 0 ? setInitialFocusRef : undefined,
                        Option: (0, (0, parcelRequire("hyeSr")).ListItemMenuOption),
                        onCreateTriggerClick: onCreateTriggerClick,
                        setCloseMenu: setCloseMenu
                    }));
            }
        });
    var $99ab925a6af54be0$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($99ab925a6af54be0$var$ItemSectionOptions);
});
parcelRegister("iup31", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c5fa1c1ac7ef259e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $2NMNM;
    var $eTXmK;
    var $4R6GH;
    var $iZN6h;
    var $9puhl;
    var $hUAzM;
    var $hyeSr;
    var $lgz7j;
    var $7tmdB;
    const $c5fa1c1ac7ef259e$var$CreateItemMenu = ({ id: id, level: level, depth: depth, parentId: parentId, isCreateChildEnabled: isCreateChildEnabled, isCreateSiblingEnabled: isCreateSiblingEnabled, onInlineCreateClicked: onInlineCreateClicked, setInitialFocusRef: setInitialFocusRef, onCreateTriggerClick: onCreateTriggerClick, setCloseMenu: setCloseMenu })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [{ overrideLabels: overrideLabels }] = (0, (0, parcelRequire("9puhl")).useListItemMenuOptions)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const onClickCreateChildOption = (0, $5uXOq.useCallback)((event)=>{
            onCreateTriggerClick();
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'createChildMenuOption',
                attributes: {
                    position: (0, (0, parcelRequire("iZN6h")).INSIDE)
                }
            });
            (0, (0, parcelRequire("hUAzM")).fireUIAnalyticsEvent)(analyticsEvent);
            if (!(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics')) (0, (0, parcelRequire("eTXmK")).default)('timeline-create-child-option-clicked', event.timeStamp);
            onInlineCreateClicked({
                parentId: id,
                position: (0, (0, parcelRequire("iZN6h")).INSIDE)
            });
            setCloseMenu(event, {
                shouldReturnFocus: false
            });
        }, [
            createAnalyticsEvent,
            id,
            onCreateTriggerClick,
            onInlineCreateClicked,
            setCloseMenu
        ]);
        const onClickCreateSiblingAboveOption = (0, $5uXOq.useCallback)((event)=>{
            onCreateTriggerClick();
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'createAboveMenuOption',
                attributes: {
                    position: (0, (0, parcelRequire("iZN6h")).BEFORE),
                    level: level,
                    depth: depth
                }
            });
            (0, (0, parcelRequire("hUAzM")).fireUIAnalyticsEvent)(analyticsEvent);
            if (!(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics')) (0, (0, parcelRequire("eTXmK")).default)('timeline-create-above-option-clicked', event.timeStamp);
            onInlineCreateClicked({
                beforeId: id,
                parentId: parentId,
                position: (0, (0, parcelRequire("iZN6h")).BEFORE)
            });
            setCloseMenu(event, {
                shouldReturnFocus: false
            });
        }, [
            createAnalyticsEvent,
            depth,
            id,
            level,
            onCreateTriggerClick,
            onInlineCreateClicked,
            parentId,
            setCloseMenu
        ]);
        const createItemChildOptions = (0, $5uXOq.useMemo)(()=>{
            const options = [];
            if (isCreateChildEnabled) options.push({
                id: (0, (0, parcelRequire("iZN6h")).listItemMenu).CREATE_CHILD_ITEM,
                onClick: onClickCreateChildOption,
                ...(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics') ? {
                    interactionName: 'timeline-create-child-option-clicked'
                } : {}
            });
            if (isCreateSiblingEnabled) options.push({
                id: (0, (0, parcelRequire("iZN6h")).listItemMenu).CREATE_ITEM_ABOVE,
                onClick: onClickCreateSiblingAboveOption,
                ...(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics') ? {
                    interactionName: 'timeline-create-above-option-clicked'
                } : {}
            });
            return options;
        }, [
            isCreateChildEnabled,
            isCreateSiblingEnabled,
            onClickCreateChildOption,
            onClickCreateSiblingAboveOption
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hyeSr")).ListItemMenuOption), {
            setInitialFocusRef: setInitialFocusRef,
            label: (0, (0, parcelRequire("lgz7j")).renderOverrideLabel)(formatMessage, overrideLabels[(0, (0, parcelRequire("iZN6h")).listItemMenu).CREATE_ITEM]) || formatMessage((0, (0, parcelRequire("7tmdB")).default).createItem),
            ...(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics') ? {
                interactionName: 'timeline-create-primary-option-clicked'
            } : {}
        }, ({ setInitialFocusRef: setChildFocusRef })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, createItemChildOptions.map(({ id: optionId, onClick: onClick, interactionName: interactionName }, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hyeSr")).ListItemMenuOption), {
                    key: optionId,
                    label: (0, (0, parcelRequire("lgz7j")).renderOverrideLabel)(formatMessage, overrideLabels[optionId]) || formatMessage((0, (0, parcelRequire("7tmdB")).default)[optionId]),
                    setInitialFocusRef: index === 0 ? setChildFocusRef : undefined,
                    ...(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics') ? {
                        interactionName: interactionName
                    } : {},
                    onClick: onClick
                }))));
    };
    var $c5fa1c1ac7ef259e$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($c5fa1c1ac7ef259e$var$CreateItemMenu);
});
parcelRegister("7tmdB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$27ecaadd4d148c02$export$2e2bcd8739ae039);
    var $7VHMR;
    const $27ecaadd4d148c02$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        createItem: {
            id: 'roadmap.timeline-table.main.content.list.list-item.meatballs-button.meatball-popup.item-section-options.create-item-menu.create-item',
            defaultMessage: 'Create',
            description: 'Label for the create option in the list item menu'
        },
        createChildItem: {
            id: 'roadmap.timeline-table.main.content.list.list-item.meatballs-button.meatball-popup.item-section-options.create-item-menu.create-child-item',
            defaultMessage: 'Create child',
            description: 'Label for the create child option in the list item menu'
        },
        createItemAbove: {
            id: 'roadmap.timeline-table.main.content.list.list-item.meatballs-button.meatball-popup.item-section-options.create-item-menu.create-item-above',
            defaultMessage: 'Create above',
            description: 'Label for the create above option in the list item menu'
        },
        createItemBelow: {
            id: 'roadmap.timeline-table.main.content.list.list-item.meatballs-button.meatball-popup.item-section-options.create-item-menu.create-item-below',
            defaultMessage: 'Create below',
            description: 'Label for the create below option in the list item menu'
        }
    });
    var $27ecaadd4d148c02$export$2e2bcd8739ae039 = $27ecaadd4d148c02$var$messages;
});
parcelRegister("ek5AF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0c96c8479590de46$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $eTXmK;
    var $4R6GH;
    var $iZN6h;
    var $hGh1Z;
    var $9puhl;
    var $hyeSr;
    var $lgz7j;
    var $J8O27;
    const $0c96c8479590de46$var$MoveItemMenu = ({ id: id, level: level, parentId: parentId, onDrop: onDrop, setCloseMenu: setCloseMenu, setInitialFocusRef: setInitialFocusRef })=>{
        const [items] = (0, (0, parcelRequire("hGh1Z")).useItems)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [{ overrideLabels: overrideLabels }] = (0, (0, parcelRequire("9puhl")).useListItemMenuOptions)();
        const siblingItemIds = (0, $5uXOq.useMemo)(()=>{
            const siblingIds = [];
            items.forEach((item)=>{
                const { type: type, meta: meta } = item;
                if (type === (0, (0, parcelRequire("iZN6h")).ITEM_TYPE)) {
                    if (meta.parentId === parentId) siblingIds.push(item.item.id);
                }
            });
            return siblingIds;
        }, [
            items,
            parentId
        ]);
        const siblingItemsLength = siblingItemIds.length;
        const onMoveUp = (0, $5uXOq.useCallback)((event)=>{
            const currentIndex = siblingItemIds.findIndex((itemId)=>itemId === id);
            if (currentIndex > 0) {
                if (!(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics')) (0, (0, parcelRequire("eTXmK")).default)('timeline-move-up-option-clicked', event.timeStamp);
                onDrop(id, {
                    level: level,
                    rankRequest: {
                        rankBeforeId: siblingItemIds[currentIndex - 1]
                    },
                    isMeatballsAction: true
                });
            }
        }, [
            id,
            level,
            siblingItemIds,
            onDrop
        ]);
        const onMoveDown = (0, $5uXOq.useCallback)((event)=>{
            const currentIndex = siblingItemIds.findIndex((itemId)=>itemId === id);
            if (currentIndex < siblingItemsLength - 1) {
                if (!(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics')) (0, (0, parcelRequire("eTXmK")).default)('timeline-move-down-option-clicked', event.timeStamp);
                onDrop(id, {
                    level: level,
                    rankRequest: {
                        rankAfterId: siblingItemIds[currentIndex + 1]
                    },
                    isMeatballsAction: true
                });
            }
        }, [
            siblingItemIds,
            siblingItemsLength,
            id,
            onDrop,
            level
        ]);
        const onMoveToTop = (0, $5uXOq.useCallback)((event)=>{
            if (siblingItemsLength > 0) {
                if (!(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics')) (0, (0, parcelRequire("eTXmK")).default)('timeline-move-to-top-option-clicked', event.timeStamp);
                onDrop(id, {
                    level: level,
                    rankRequest: {
                        rankBeforeId: siblingItemIds[0]
                    },
                    isMeatballsAction: true
                });
            }
        }, [
            siblingItemsLength,
            onDrop,
            id,
            level,
            siblingItemIds
        ]);
        const onMoveToBottom = (0, $5uXOq.useCallback)((event)=>{
            if (siblingItemsLength > 0) {
                if (!(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics')) (0, (0, parcelRequire("eTXmK")).default)('timeline-move-to-bottom-option-clicked', event.timeStamp);
                onDrop(id, {
                    level: level,
                    rankRequest: {
                        rankAfterId: siblingItemIds[siblingItemsLength - 1]
                    },
                    isMeatballsAction: true
                });
            }
        }, [
            onDrop,
            id,
            level,
            siblingItemIds,
            siblingItemsLength
        ]);
        const moveItemChildOptions = (0, $5uXOq.useMemo)(()=>{
            const isMoveUpDisabled = !siblingItemsLength || id === siblingItemIds?.[0];
            const isMoveDownDisabled = !siblingItemsLength || id === siblingItemIds[siblingItemsLength - 1];
            const options = [
                {
                    id: (0, (0, parcelRequire("iZN6h")).listItemMenu).MOVE_ITEM_UP,
                    onClick: onMoveUp,
                    isDisabled: isMoveUpDisabled,
                    ...(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics') ? {
                        interactionName: 'timeline-move-up-option-clicked'
                    } : {}
                },
                {
                    id: (0, (0, parcelRequire("iZN6h")).listItemMenu).MOVE_ITEM_DOWN,
                    onClick: onMoveDown,
                    isDisabled: isMoveDownDisabled,
                    ...(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics') ? {
                        interactionName: 'timeline-move-down-option-clicked'
                    } : {}
                },
                {
                    id: (0, (0, parcelRequire("iZN6h")).listItemMenu).MOVE_ITEM_TO_TOP,
                    onClick: onMoveToTop,
                    isDisabled: isMoveUpDisabled,
                    ...(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics') ? {
                        interactionName: 'timeline-move-to-top-option-clicked'
                    } : {}
                },
                {
                    id: (0, (0, parcelRequire("iZN6h")).listItemMenu).MOVE_ITEM_TO_BOTTOM,
                    onClick: onMoveToBottom,
                    isDisabled: isMoveDownDisabled,
                    ...(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics') ? {
                        interactionName: 'timeline-move-to-bottom-option-clicked'
                    } : {}
                }
            ];
            return options;
        }, [
            id,
            onMoveDown,
            onMoveToBottom,
            onMoveToTop,
            onMoveUp,
            siblingItemIds,
            siblingItemsLength
        ]);
        const firstEnabledOptionIndex = moveItemChildOptions.findIndex((option)=>!option.isDisabled);
        const renderMoveItemChildOptions = (0, $5uXOq.useCallback)(({ id: optionId, onClick: onClick, isDisabled: isDisabled, interactionName: interactionName }, index, setChildFocusRef)=>{
            const handleClick = (e)=>{
                onClick(e);
                setCloseMenu(e);
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hyeSr")).ListItemMenuOption), {
                key: optionId,
                label: (0, (0, parcelRequire("lgz7j")).renderOverrideLabel)(formatMessage, overrideLabels[optionId]) || formatMessage((0, (0, parcelRequire("J8O27")).default)[optionId]),
                setInitialFocusRef: firstEnabledOptionIndex === index ? setChildFocusRef : undefined,
                isDisabled: isDisabled,
                ...(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics') ? {
                    interactionName: interactionName
                } : {},
                onClick: handleClick
            });
        }, [
            firstEnabledOptionIndex,
            formatMessage,
            overrideLabels,
            setCloseMenu
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hyeSr")).ListItemMenuOption), {
            setInitialFocusRef: setInitialFocusRef,
            isDisabled: siblingItemsLength <= 1,
            label: (0, (0, parcelRequire("lgz7j")).renderOverrideLabel)(formatMessage, overrideLabels[(0, (0, parcelRequire("iZN6h")).listItemMenu).MOVE_ITEM]) || formatMessage((0, (0, parcelRequire("J8O27")).default).moveItem),
            ...(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics') ? {
                interactionName: 'timeline-move-primary-option-clicked'
            } : {}
        }, ({ setInitialFocusRef: setChildFocusRef })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, moveItemChildOptions.map((option, index)=>renderMoveItemChildOptions(option, index, setChildFocusRef))));
    };
    var $0c96c8479590de46$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($0c96c8479590de46$var$MoveItemMenu);
});
parcelRegister("J8O27", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$999988b18591c272$export$2e2bcd8739ae039);
    var $7VHMR;
    const $999988b18591c272$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        moveItem: {
            id: 'roadmap.timeline-table.main.content.list.list-item.meatballs-button.meatball-popup.item-section-options.move-item-menu.move-item',
            defaultMessage: 'Move',
            description: 'Label for the move option in the list item menu'
        },
        moveItemUp: {
            id: 'roadmap.timeline-table.main.content.list.list-item.meatballs-button.meatball-popup.item-section-options.move-item-menu.move-item-up',
            defaultMessage: 'Move up',
            description: 'Label for the move up option in the list item menu'
        },
        moveItemDown: {
            id: 'roadmap.timeline-table.main.content.list.list-item.meatballs-button.meatball-popup.item-section-options.move-item-menu.move-item-down',
            defaultMessage: 'Move down',
            description: 'Label for the move down option in the list item menu'
        },
        moveItemToTop: {
            id: 'roadmap.timeline-table.main.content.list.list-item.meatballs-button.meatball-popup.item-section-options.move-item-menu.move-item-to-top',
            defaultMessage: 'Move to top',
            description: 'Label for the move to top option in the list item menu'
        },
        moveItemToBottom: {
            id: 'roadmap.timeline-table.main.content.list.list-item.meatballs-button.meatball-popup.item-section-options.move-item-menu.move-item-to-bottom',
            defaultMessage: 'Move to bottom',
            description: 'Label for the move to bottom option in the list item menu'
        }
    });
    var $999988b18591c272$export$2e2bcd8739ae039 = $999988b18591c272$var$messages;
});
parcelRegister("3euyd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$56d53d8a5184a382$export$2e2bcd8739ae039);
    var $7VHMR;
    var $56d53d8a5184a382$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        expand: {
            id: 'roadmap.timeline-table.main.content.list.list-item.expand',
            defaultMessage: 'Show child issues',
            description: 'Button label. Button expands and collapses a list item on Timelines issue list.'
        },
        collapse: {
            id: 'roadmap.timeline-table.main.content.list.list-item.collapse',
            defaultMessage: 'Hide child issues',
            description: 'Button label. Button expands and collapses a list item on Timelines issue list.'
        },
        createSibling: {
            id: 'roadmap.timeline-table.main.content.list.list-item.create-sibling',
            defaultMessage: 'Create issue',
            description: 'Button label. Button begins issue creation process inline on Timelines issue list.'
        },
        createChild: {
            id: 'roadmap.timeline-table.main.content.list.list-item.create-child',
            defaultMessage: 'Create child issue',
            description: 'Button label. Button begins issue creation process inline on Timelines issue list.'
        },
        done: {
            id: 'roadmap.timeline-table.main.content.list.list-item.done',
            defaultMessage: 'Done',
            description: 'Icon label. Icon appears when issue is in the done status category.'
        },
        expandIssueTermRefresh: {
            id: 'roadmap.timeline-table.main.content.list.list-item.expand-issue-term-refresh',
            defaultMessage: 'Show work items',
            description: 'Button label. Button expands and collapses a list item on Timelines issue list.'
        },
        collapseIssueTermRefresh: {
            id: 'roadmap.timeline-table.main.content.list.list-item.collapse-issue-term-refresh',
            defaultMessage: 'Hide work items',
            description: 'Button label. Button expands and collapses a list item on Timelines issue list.'
        },
        createSiblingIssueTermRefresh: {
            id: 'roadmap.timeline-table.main.content.list.list-item.create-sibling-issue-term-refresh',
            defaultMessage: 'Create work item',
            description: 'Button label. Button begins issue creation process inline on Timelines issue list.'
        },
        createChildIssueTermRefresh: {
            id: 'roadmap.timeline-table.main.content.list.list-item.create-child-issue-term-refresh',
            defaultMessage: 'Create child work item',
            description: 'Button label. Button begins issue creation process inline on Timelines issue list.'
        }
    });
});
parcelRegister("4vwx2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$13a5365f09f08fff$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $kkJfY;
    var $3C8rg;
    const $13a5365f09f08fff$var$ListItemSelectCheckbox = ({ id: id, onToggle: onToggle, isChecked: isChecked, isDisabled: isDisabled })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const handleClick = (0, $5uXOq.useCallback)((e)=>{
            e.stopPropagation();
            onToggle(e);
        }, [
            onToggle
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kkJfY")).default), {
            value: `${id} selected`,
            "aria-label": formatMessage((0, (0, parcelRequire("3C8rg")).default).label),
            isChecked: isChecked,
            isDisabled: isDisabled,
            onClick: handleClick
        });
    };
    var $13a5365f09f08fff$export$2e2bcd8739ae039 = $13a5365f09f08fff$var$ListItemSelectCheckbox;
});
parcelRegister("kkJfY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3106eb14f9b0a593$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6QvkM;
    var $5JjdN;
    var $kag1C;
    var $7xteU;
    var $hsLv2;
    var $e62YQ;
    const $3106eb14f9b0a593$var$checkboxStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: '100%',
        height: '100%',
        margin: "var(--ds-space-0, 0px)",
        appearance: 'none',
        border: 'none',
        gridArea: '1 / 1 / 2 / 2',
        opacity: 0,
        outline: 'none',
        '& + svg': {
            '--checkbox-background-color': 'var(--local-background)',
            '--checkbox-border-color': 'var(--local-border)',
            '--checkbox-tick-color': 'var(--local-tick-rest)',
            color: 'var(--checkbox-background-color)',
            fill: 'var(--checkbox-tick-color)',
            gridArea: '1 / 1 / 2 / 2',
            pointerEvents: 'none',
            transition: 'color 0.2s ease-in-out, fill 0.2s ease-in-out',
            'rect:first-of-type': {
                stroke: 'var(--checkbox-border-color)',
                strokeWidth: "var(--ds-border-width, 1px)",
                transition: 'stroke 0.2s ease-in-out'
            }
        },
        '&&:focus + svg, &&:checked:focus + svg': {
            borderRadius: "var(--ds-border-radius, 0.25rem)",
            outline: `${"var(--ds-border-width-outline, 2px)"} solid ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`}`,
            outlineOffset: "var(--ds-space-negative-025, -2px)"
        },
        '&:hover + svg': {
            '--checkbox-background-color': 'var(--local-background-hover)',
            '--checkbox-border-color': 'var(--local-border-hover)'
        },
        '&:checked:hover + svg': {
            '--checkbox-background-color': 'var(--local-background-checked-hover)',
            '--checkbox-border-color': 'var(--local-border-checked-hover)'
        },
        '&:checked + svg': {
            '--checkbox-background-color': 'var(--local-background-checked)',
            '--checkbox-border-color': 'var(--local-border-checked)',
            '--checkbox-tick-color': 'var(--local-tick-checked)'
        },
        '&[data-invalid] + svg': {
            '--checkbox-border-color': 'var(--local-border-invalid)'
        },
        '&:checked[data-invalid] + svg': {
            '--checkbox-border-color': 'var(--local-border-checked-invalid)'
        },
        '&:active + svg': {
            '--checkbox-background-color': 'var(--local-background-active)',
            '--checkbox-border-color': 'var(--local-border-active)'
        },
        '&:checked:active + svg': {
            '--checkbox-background-color': 'var(--local-background-active)',
            '--checkbox-border-color': 'var(--local-border-active)',
            '--checkbox-tick-color': 'var(--local-tick-active)'
        },
        '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
            '--checkbox-background-color': 'var(--local-background-disabled)',
            '--checkbox-border-color': 'var(--local-border-disabled)',
            cursor: 'not-allowed',
            pointerEvents: 'none'
        },
        '&:disabled:checked + svg': {
            '--checkbox-tick-color': 'var(--local-tick-disabled)'
        },
        '&:indeterminate + svg': {
            '--checkbox-background-color': 'var(--local-background-checked)',
            '--checkbox-border-color': 'var(--local-border-checked)',
            '--checkbox-tick-color': 'var(--local-tick-checked)'
        },
        '&:disabled:indeterminate + svg': {
            '--checkbox-background-color': 'var(--local-background-disabled)',
            '--checkbox-border-color': 'var(--local-border-disabled)',
            '--checkbox-tick-color': 'var(--local-tick-disabled)'
        },
        '@media screen and (forced-colors: active)': {
            '& + svg': {
                '--checkbox-background-color': 'Canvas',
                '--checkbox-border-color': 'CanvasText',
                '--checkbox-tick-color': 'CanvasText'
            },
            '&:checked + svg, &:checked:hover + svg': {
                '--checkbox-background-color': 'Canvas',
                '--checkbox-border-color': 'CanvasText',
                '--checkbox-tick-color': 'CanvasText'
            },
            '&:focus + svg rect:first-of-type': {
                stroke: 'Highlight'
            },
            '&[data-invalid] + svg': {
                '--checkbox-border-color': 'Highlight'
            },
            '&:checked[data-invalid] + svg': {
                '--checkbox-border-color': 'Highlight'
            },
            '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
                '--checkbox-background-color': 'Canvas',
                '--checkbox-border-color': 'GrayText',
                '--checkbox-tick-color': 'GrayText'
            }
        }
    });
    const $3106eb14f9b0a593$var$Checkbox = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(function Checkbox(props, ref) {
        const { isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, ...rest } = props;
        const [isCheckedState, setIsCheckedState] = (0, $5uXOq.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
        const onChange = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
            setIsCheckedState(e.target.checked);
            if (onChangeProps) onChangeProps(e, analyticsEvent);
        }, [
            onChangeProps
        ]);
        const onChangeAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: onChange,
            action: 'changed',
            analyticsData: analyticsContext,
            componentName: 'checkbox',
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local"
        });
        const internalRef = (0, $5uXOq.useRef)(null);
        const mergedRefs = (0, (0, parcelRequire("5JjdN")).default)([
            internalRef,
            ref
        ]);
        const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
        (0, $5uXOq.useEffect)(()=>{
            if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
        }, [
            isIndeterminate
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("7xteU")).default), {
            isDisabled: isDisabled,
            label: label,
            id: rest.id ? `${rest.id}-label` : undefined,
            testId: testId && `${testId}--checkbox-label`,
            xcss: xcss
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            tabIndex: 0,
            ...rest,
            type: "checkbox",
            ref: mergedRefs,
            disabled: isDisabled,
            checked: isChecked,
            value: value,
            name: name,
            required: isRequired,
            css: $3106eb14f9b0a593$var$checkboxStyles,
            onChange: onChangeAnalytics,
            "aria-invalid": isInvalid ? 'true' : undefined,
            "data-testid": testId && `${testId}--hidden-checkbox`,
            "data-invalid": isInvalid ? 'true' : undefined
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kag1C")).default), {
            isIndeterminate: isIndeterminate,
            isChecked: isChecked
        }), label && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("hsLv2")).default), null, label, isRequired && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("e62YQ")).default), null)));
    }));
    $3106eb14f9b0a593$var$Checkbox.displayName = 'Checkbox';
    var $3106eb14f9b0a593$export$2e2bcd8739ae039 = $3106eb14f9b0a593$var$Checkbox;
});
parcelRegister("kag1C", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a0746a27410bc168$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $dV6Te;
    function $a0746a27410bc168$var$getIcon(isIndeterminate, isChecked) {
        if (isIndeterminate) return (0, (0, parcelRequire("f8Sb3")).jsx)("rect", {
            fill: "inherit",
            x: "8",
            y: "11",
            width: "8",
            height: "2",
            rx: "1"
        });
        if (isChecked) return (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
            fill: "inherit"
        });
        return null;
    }
    const $a0746a27410bc168$var$CheckboxIcon = (0, $5uXOq.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
        const icon = (0, $5uXOq.useMemo)(()=>$a0746a27410bc168$var$getIcon(isIndeterminate, isChecked), [
            isIndeterminate,
            isChecked
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dV6Te")).default), {
            label: "",
            primaryColor: "var(--checkbox-background-color)",
            secondaryColor: "var(--checkbox-tick-color)"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("g", {
            fillRule: "evenodd"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("rect", {
            fill: "currentColor",
            x: "6",
            y: "6",
            width: "12",
            height: "12",
            rx: "2"
        }), icon));
    });
    var $a0746a27410bc168$export$2e2bcd8739ae039 = $a0746a27410bc168$var$CheckboxIcon;
});
parcelRegister("7xteU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7b368d644c230660$export$2e2bcd8739ae039);
    var $f8Sb3;
    const $7b368d644c230660$var$baseStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'grid',
        gridAutoColumns: '1fr',
        gridAutoRows: 'min-content',
        color: `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`,
        cursor: 'default',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    });
    const $7b368d644c230660$var$textLabelLayoutStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        gap: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
        gridTemplateColumns: 'min-content auto'
    });
    const $7b368d644c230660$var$disabledStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        color: `var(--ds-text-disabled, ${(0, $829f609a65d26a98$export$eaa8c8a70ac22806)})`,
        cursor: 'not-allowed'
    });
    const $7b368d644c230660$var$labelStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '--local-background': `var(--ds-background-input, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
        '--local-background-active': `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
        '--local-background-checked': `var(--ds-background-selected-bold, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
        '--local-background-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`,
        '--local-background-disabled': `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
        '--local-background-hover': `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        '--local-border': `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
        '--local-border-active': `var(--ds-border, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
        '--local-border-checked': `var(--ds-background-selected-bold, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
        '--local-border-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`,
        '--local-border-checked-invalid': `var(--ds-border-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`,
        '--local-border-disabled': `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
        '--local-border-focus': `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
        '--local-border-hover': `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
        '--local-border-invalid': `var(--ds-border-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`,
        '--local-tick-active': `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
        '--local-tick-checked': `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
        '--local-tick-disabled': `var(--ds-icon-disabled, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`,
        '--local-tick-rest': 'transparent'
    });
    function $7b368d644c230660$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("label", {
            className: xcss,
            css: [
                $7b368d644c230660$var$baseStyles,
                label && $7b368d644c230660$var$textLabelLayoutStyles,
                isDisabled && $7b368d644c230660$var$disabledStyles,
                $7b368d644c230660$var$labelStyles
            ],
            "data-testid": testId,
            "data-disabled": isDisabled || undefined,
            id: id
        }, children);
    }
});
parcelRegister("hsLv2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ce636d67b4ff1120$export$2e2bcd8739ae039);
    var $f8Sb3;
    function $ce636d67b4ff1120$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $ce636d67b4ff1120$var$labelTextStyles = {
        name: "12hofyr",
        styles: "align-self:center;grid-area:1 / 2 / 2 / 3"
    };
    function $ce636d67b4ff1120$export$2e2bcd8739ae039({ children: children }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $ce636d67b4ff1120$var$labelTextStyles
        }, children);
    }
});
parcelRegister("e62YQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d2156c28a3894cac$export$2e2bcd8739ae039);
    var $f8Sb3;
    const $d2156c28a3894cac$var$requiredIndicatorStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        color: `var(--ds-text-danger, ${(0, $829f609a65d26a98$export$2837b5a1a71d5c02)})`,
        paddingInlineStart: "var(--ds-space-025, 2px)"
    });
    function $d2156c28a3894cac$export$2e2bcd8739ae039() {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $d2156c28a3894cac$var$requiredIndicatorStyles,
            "aria-hidden": true
        }, "*");
    }
});
parcelRegister("3C8rg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4a60fe46a29e758c$export$2e2bcd8739ae039);
    var $7VHMR;
    var $4a60fe46a29e758c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        label: {
            id: 'roadmap.timeline-table.main.content.list.list-item.select-checkbox.label',
            defaultMessage: 'Row selection',
            description: 'Label for the select checkbox on each of the rows.'
        }
    });
});
parcelRegister("bNMH3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$83c79864653d2022$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $4hDdm = parcelRequire("4hDdm");
    var $7gWdR = parcelRequire("7gWdR");
    var $iZN6h;
    const $83c79864653d2022$var$useListItemDrag = ({ id: id, level: level, depth: depth, parentId: parentId, canDrag: canDrag, sideEffectMarshal: sideEffectMarshal })=>{
        const cleanupDragAndDrop = (0, $5uXOq.useRef)(null);
        const { onRowGenerateDragPreview: onRowGenerateDragPreview } = sideEffectMarshal;
        const makeDraggable = (0, $5uXOq.useCallback)((dragElement)=>{
            const el = dragElement;
            if (el === null) return;
            cleanupDragAndDrop.current = (0, $4hDdm.combine)((0, $7gWdR.draggable)({
                element: el,
                canDrag: ()=>canDrag,
                getInitialData: ()=>({
                        type: (0, (0, parcelRequire("iZN6h")).ROW_DRAG_AND_DROP_ID),
                        id: id,
                        level: level,
                        depth: depth,
                        parentId: parentId
                    }),
                onGenerateDragPreview: ()=>{
                    onRowGenerateDragPreview();
                }
            }));
        }, [
            canDrag,
            id,
            level,
            depth,
            parentId,
            onRowGenerateDragPreview
        ]);
        const cleanupDraggable = (0, $5uXOq.useCallback)(()=>{
            cleanupDragAndDrop.current?.();
        }, []);
        return [
            makeDraggable,
            cleanupDraggable
        ];
    };
    var $83c79864653d2022$export$2e2bcd8739ae039 = $83c79864653d2022$var$useListItemDrag;
});
parcelRegister("kBjnL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9dd0b3fbe7e8d4fa$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $cSD7y;
    var $9puhl;
    var $8wpG6;
    var $5qL6X;
    const $9dd0b3fbe7e8d4fa$var$ResizerComponent = (0, (0, parcelRequire("cSD7y")).componentWithFG)('jsw_roadmaps_timeline_table_custom_scroll_pdnd', (0, (0, parcelRequire("5qL6X")).default), (0, (0, parcelRequire("8wpG6")).default));
    const $9dd0b3fbe7e8d4fa$var$containerStyles = null;
    const $9dd0b3fbe7e8d4fa$var$listResizerContainerStyles = null;
    const $9dd0b3fbe7e8d4fa$var$ListResizer = ({ DndLongTaskMetric: DndLongTaskMetric, onSetListWidth: onSetListWidth })=>{
        const [listWidth, { setListWidth: setListWidth }] = (0, (0, parcelRequire("9puhl")).useListWidth)();
        const onResize = (0, $5uXOq.useCallback)((width)=>{
            setListWidth(width);
        }, [
            setListWidth
        ]);
        const onResizeEnd = (0, $5uXOq.useCallback)(()=>{
            onSetListWidth(listWidth);
        }, [
            listWidth,
            onSetListWidth
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _1e0c1txw _154iidpf _94n5idpf _1ltvidpf _1bsb1osq _lcxvglyw"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                width: `${listWidth}px`
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqsw1if8 _1ltvidpf _1pbyilow"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($9dd0b3fbe7e8d4fa$var$ResizerComponent, {
            width: listWidth,
            DndLongTaskMetric: DndLongTaskMetric,
            onResize: onResize,
            onResizeEnd: onResizeEnd
        })));
    };
    var $9dd0b3fbe7e8d4fa$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($9dd0b3fbe7e8d4fa$var$ListResizer);
});
parcelRegister("8wpG6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bdf3f3af3b07f0a5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3PELs = parcelRequire("3PELs");
    var $2NMNM;
    var $iZN6h;
    var $hUAzM;
    var $h7CQc;
    var $9qpVA;
    const $bdf3f3af3b07f0a5$var$Resizer = ({ width: width, DndLongTaskMetric: DndLongTaskMetric, onResize: onResize, onResizeEnd: onResizeEnd })=>{
        const initialWidth = (0, $5uXOq.useRef)(width);
        const [isDragging, setIsDragging] = (0, $5uXOq.useState)(false);
        const maxWidth = (0, (0, parcelRequire("9qpVA")).useMaxWidth)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            width > maxWidth && onResize(maxWidth);
        }, [
            width,
            maxWidth,
            onResize
        ]);
        const onDragStart = (0, $5uXOq.useCallback)(()=>{
            initialWidth.current = width;
            setIsDragging(true);
        }, [
            width
        ]);
        const onDrag = (0, $5uXOq.useCallback)((_from, to, start)=>{
            const newWidth = Math.round(initialWidth.current + to.x - start.x);
            const saneWidth = (0, ($parcel$interopDefault($3PELs)))(newWidth, (0, (0, parcelRequire("iZN6h")).MINIMUM_LIST_WIDTH)(), maxWidth);
            onResize(saneWidth);
        }, [
            maxWidth,
            onResize
        ]);
        const onDragEnd = (0, $5uXOq.useCallback)((from, to)=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'resized',
                actionSubject: 'list',
                actionSubjectId: 'resizedList',
                attributes: {
                    didExpand: to.x > from.x
                }
            });
            (0, (0, parcelRequire("hUAzM")).fireUIAnalyticsEvent)(analyticsEvent);
            setIsDragging(false);
            onResizeEnd(initialWidth.current);
        }, [
            createAnalyticsEvent,
            onResizeEnd
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("h7CQc")).default), {
            onDragStart: onDragStart,
            onDrag: onDrag,
            onDragEnd: onDragEnd
        }), DndLongTaskMetric !== undefined && (0, ($parcel$interopDefault($5uXOq))).createElement(DndLongTaskMetric, {
            isDragging: isDragging,
            metricType: (0, (0, parcelRequire("iZN6h")).LIST_RESIZE_DRAG_AND_DROP)
        }));
    };
    var $bdf3f3af3b07f0a5$export$2e2bcd8739ae039 = $bdf3f3af3b07f0a5$var$Resizer;
});
parcelRegister("3PELs", function(module, exports) {
    var $gPWEE = parcelRequire("gPWEE");
    var $1sXeC = parcelRequire("1sXeC");
    function $2ca5c181afe24ac6$var$clamp(number, lower, upper) {
        if (upper === undefined) {
            upper = lower;
            lower = undefined;
        }
        if (upper !== undefined) {
            upper = $1sXeC(upper);
            upper = upper === upper ? upper : 0;
        }
        if (lower !== undefined) {
            lower = $1sXeC(lower);
            lower = lower === lower ? lower : 0;
        }
        return $gPWEE($1sXeC(number), lower, upper);
    }
    module.exports = $2ca5c181afe24ac6$var$clamp;
});
parcelRegister("gPWEE", function(module, exports) {
    function $c41ee85d08292e29$var$baseClamp(number, lower, upper) {
        if (number === number) {
            if (upper !== undefined) number = number <= upper ? number : upper;
            if (lower !== undefined) number = number >= lower ? number : lower;
        }
        return number;
    }
    module.exports = $c41ee85d08292e29$var$baseClamp;
});
parcelRegister("h7CQc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$949c73c24e654306$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $fNuuD;
    const $949c73c24e654306$var$ResizeHandler = ({ isDragging: isDragging, children: children, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ...props,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _154iidpf _1xi21i6y _1bsbu2gc _4t3i1osq _1pbyilow _v564ryu7 _lcxv1rj4 _80omuf7j _18postnw _1ywu1ule _aetrb3bt _15l2idpf _32rxv77o _z0aiv77o _1qdg1osq _16r21can _11fnglyw",
                isDragging ? "_tzy4kb7n" : "_tzy4idpf _16l4kb7n"
            ])
        }, children);
    var $949c73c24e654306$export$2e2bcd8739ae039 = (0, (0, parcelRequire("fNuuD")).withDragObserver)($949c73c24e654306$var$ResizeHandler);
    const $949c73c24e654306$var$resizeHandlerStyles = null;
    const $949c73c24e654306$var$staticStyles = null;
    const $949c73c24e654306$var$draggingStyles = null;
});
parcelRegister("fNuuD", function(module, exports) {
    $parcel$export(module.exports, "withDragObserver", ()=>$6a9466b713e40645$export$a0ae95ab2800c7f2);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $fr1K2 = parcelRequire("fr1K2");
    var $aRGMp;
    const $6a9466b713e40645$export$13171b62aaa278f9 = 3;
    const $6a9466b713e40645$var$DISABLED_DRAG_PROPS = [
        'onMouseDown',
        'onDragStart',
        'onDrag',
        'onDragEnd'
    ];
    const $6a9466b713e40645$var$ENABLED_DRAG_PROPS = [
        'onMouseDown',
        'onClick',
        'onDragStart',
        'onDrag',
        'onDragEnd'
    ];
    const $6a9466b713e40645$var$getMousePosition = (event)=>({
            x: event.pageX,
            y: event.pageY
        });
    const $6a9466b713e40645$var$requestAnimationFrame = (0, (0, parcelRequire("aRGMp")).createRaf)();
    const $6a9466b713e40645$export$a0ae95ab2800c7f2 = (WrappedComponent, threshold = $6a9466b713e40645$export$13171b62aaa278f9)=>{
        class DragObserver extends (0, $5uXOq.PureComponent) {
            static{
                this.defaultProps = {
                    isDisabled: false,
                    onMouseDown: undefined,
                    onDragStart: undefined,
                    onDrag: undefined,
                    onDragEnd: undefined,
                    onClick: undefined
                };
            }
            constructor(props){
                super(props);
                this.onChildMouseDown = (event)=>{
                    if (this.props.isDisabled || event.button !== 0) return;
                    event.preventDefault();
                    event.stopPropagation();
                    this.addWindowEventListeners();
                    const dragStart = $6a9466b713e40645$var$getMousePosition(event);
                    this.setState({
                        isDragging: false,
                        dragStart: dragStart,
                        previousDragPosition: dragStart
                    }, ()=>this.onMouseDown(event));
                };
                this.onWindowMouseMove = (event)=>{
                    event.preventDefault();
                    const mouse = $6a9466b713e40645$var$getMousePosition(event);
                    const { isDragging: isDragging, dragStart: dragStart, previousDragPosition: previousDragPosition } = this.state;
                    if (!isDragging) {
                        if (Math.abs(mouse.x - dragStart.x) > threshold || Math.abs(mouse.y - dragStart.y) > threshold) {
                            this.setState({
                                isDragging: true
                            });
                            this.onDragStart(dragStart);
                        }
                    } else {
                        const from = previousDragPosition;
                        const to = mouse;
                        this.setState({
                            previousDragPosition: mouse
                        });
                        this.onDrag(from, to, dragStart);
                    }
                };
                this.onWindowMouseUp = (event)=>{
                    const { isDragging: isDragging, dragStart: dragStart } = this.state;
                    if (isDragging) {
                        const mouse = $6a9466b713e40645$var$getMousePosition(event);
                        const start = dragStart;
                        const end = mouse;
                        if (this.mounted) this.setState({
                            isDragging: false
                        });
                        this.onDragEnd(start, end);
                    } else if (event.button === 0 && ((navigator?.userAgent ?? '').includes('Mac') ? !event.ctrlKey : true)) this.onClick(event);
                    this.removeWindowEventListeners();
                };
                this.animationId = undefined;
                this.mounted = false;
                this.state = {
                    isDragging: false,
                    dragStart: {
                        x: 0,
                        y: 0
                    },
                    previousDragPosition: {
                        x: 0,
                        y: 0
                    }
                };
            }
            componentDidMount() {
                this.mounted = true;
                this.ref = (0, ($parcel$interopDefault($7nsd3))).findDOMNode(this);
                if (this.ref) this.ref.addEventListener('mousedown', this.onChildMouseDown);
            }
            componentWillUnmount() {
                if (this.ref) this.ref.removeEventListener('mousedown', this.onChildMouseDown);
                this.removeWindowEventListeners();
                if (this.animationId !== undefined) {
                    cancelAnimationFrame(this.animationId);
                    this.animationId = undefined;
                }
                this.mounted = false;
            }
            addWindowEventListeners() {
                window.addEventListener('mousemove', this.onWindowMouseMove);
                window.addEventListener('mouseup', this.onWindowMouseUp);
            }
            removeWindowEventListeners() {
                window.removeEventListener('mousemove', this.onWindowMouseMove);
                window.removeEventListener('mouseup', this.onWindowMouseUp);
            }
            onMouseDown(event) {
                if (this.props.onMouseDown) this.props.onMouseDown(event);
            }
            onDragStart(from) {
                if (this.props.onDragStart) this.props.onDragStart(from);
            }
            onDrag(from, to, start) {
                if (this.props.onDrag) this.animationId = $6a9466b713e40645$var$requestAnimationFrame(()=>{
                    if (this.props.onDrag && this.state.isDragging) this.props.onDrag(from, to, start);
                });
            }
            onDragEnd(from, to) {
                if (this.props.onDragEnd) this.props.onDragEnd(from, to);
            }
            onClick(event) {
                if (this.props.onClick) this.props.onClick(event);
            }
            render() {
                const { isDisabled: isDisabled } = this.props;
                const { isDragging: isDragging } = this.state;
                const safeProps = (0, ($parcel$interopDefault($fr1K2)))(this.props, isDisabled ? $6a9466b713e40645$var$DISABLED_DRAG_PROPS : $6a9466b713e40645$var$ENABLED_DRAG_PROPS);
                return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                    isDragging: isDragging,
                    ...safeProps
                });
            }
        }
        return DragObserver;
    };
});
parcelRegister("aRGMp", function(module, exports) {
    $parcel$export(module.exports, "createRaf", ()=>$98d827f74bc46e8c$export$adfe8e38eaee509d);
    const $98d827f74bc46e8c$export$adfe8e38eaee509d = ()=>{
        let frameId = null;
        return (callback)=>{
            if (frameId) cancelAnimationFrame(frameId);
            frameId = requestAnimationFrame(callback);
            return frameId;
        };
    };
});
parcelRegister("9qpVA", function(module, exports) {
    $parcel$export(module.exports, "useMaxWidth", ()=>$2175711dbc5f67dd$export$f8d842793af60bfe);
    var $5uXOq = parcelRequire("5uXOq");
    var $lFKmC = parcelRequire("lFKmC");
    var $iZN6h;
    var $kyahI;
    var $fY8ne;
    const $2175711dbc5f67dd$export$f8d842793af60bfe = ()=>{
        const [maxWidth, setMaxWidth] = (0, $5uXOq.useState)(Infinity);
        const { requestViewportBoundingClient: requestViewportBoundingClient } = (0, (0, parcelRequire("kyahI")).useViewport)();
        const setMaxWidthFromViewport = (0, $5uXOq.useCallback)(()=>{
            const viewportBoundingClient = requestViewportBoundingClient({
                withTimelineOffset: false
            });
            if (viewportBoundingClient) {
                const newMaxWidth = (0, (0, parcelRequire("fY8ne")).getMaxListWidth)(viewportBoundingClient.width);
                setMaxWidth(newMaxWidth);
            }
        }, [
            requestViewportBoundingClient
        ]);
        (0, $5uXOq.useEffect)(()=>{
            setMaxWidthFromViewport();
        }, [
            setMaxWidthFromViewport
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const onWindowResize = (0, ($parcel$interopDefault($lFKmC)))(()=>{
                setMaxWidthFromViewport();
            }, (0, (0, parcelRequire("iZN6h")).RESIZE_DEBOUNCE_MS));
            window.addEventListener('resize', onWindowResize);
            return ()=>{
                window.removeEventListener('resize', onWindowResize);
                onWindowResize.cancel();
            };
        }, [
            setMaxWidthFromViewport
        ]);
        return maxWidth;
    };
});
parcelRegister("kyahI", function(module, exports) {
    $parcel$export(module.exports, "useViewport", ()=>$40329f63f37d38cb$export$297ec8eb77d6211d);
    $parcel$export(module.exports, "default", ()=>$40329f63f37d38cb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $eA5c9;
    const $40329f63f37d38cb$var$ViewportContext = (0, $5uXOq.createContext)({
        requestViewportBoundingClient: ()=>(0, (0, parcelRequire("eA5c9")).DEFAULT_BOUNDING_CLIENT),
        requestViewportScrollBounding: ()=>(0, (0, parcelRequire("eA5c9")).DEFAULT_SCROLL_BOUNDING),
        listenToViewportScroll: (0, ($parcel$interopDefault($8Rkzz))),
        stopListeningToViewportScroll: (0, ($parcel$interopDefault($8Rkzz))),
        setViewportScroll: (0, ($parcel$interopDefault($8Rkzz)))
    });
    const $40329f63f37d38cb$export$297ec8eb77d6211d = ()=>(0, $5uXOq.useContext)($40329f63f37d38cb$var$ViewportContext);
    var $40329f63f37d38cb$export$2e2bcd8739ae039 = $40329f63f37d38cb$var$ViewportContext;
});
parcelRegister("eA5c9", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_BOUNDING_CLIENT", ()=>$54aa9414eabfde0c$export$2b0ecbff0a0d633b);
    $parcel$export(module.exports, "DEFAULT_SCROLL_BOUNDING", ()=>$54aa9414eabfde0c$export$2f9f19f71eef1ceb);
    const $54aa9414eabfde0c$export$2b0ecbff0a0d633b = {
        width: 0,
        height: 0,
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
    const $54aa9414eabfde0c$export$2f9f19f71eef1ceb = {
        scrollTop: 0,
        scrollLeft: 0,
        scrollRight: 0,
        scrollBottom: 0,
        scrollHeight: 0,
        scrollWidth: 0,
        isOverflowY: false
    };
});
parcelRegister("fY8ne", function(module, exports) {
    $parcel$export(module.exports, "getMaxListWidth", ()=>$ace114e12ea74984$export$5db3ad0238a5a9b3);
    var $iZN6h;
    const $ace114e12ea74984$var$MAX_WIDTH_RATIO = 0.9;
    const $ace114e12ea74984$export$5db3ad0238a5a9b3 = (viewportWidth)=>{
        const tableLimitedWidth = Math.round(viewportWidth * $ace114e12ea74984$var$MAX_WIDTH_RATIO);
        return Math.max((0, (0, parcelRequire("iZN6h")).MINIMUM_LIST_WIDTH)(), tableLimitedWidth);
    };
});
parcelRegister("5qL6X", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5c8bcaa39410cf1d$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $3joPi = parcelRequire("3joPi");
    var $2NMNM;
    var $7gWdR = parcelRequire("7gWdR");
    var $hjhoK = parcelRequire("hjhoK");
    var $fmZmH = parcelRequire("fmZmH");
    var $iZN6h;
    var $hUAzM;
    var $9qpVA;
    const $5c8bcaa39410cf1d$var$getProposedWidth = ({ initialWidth: initialWidth, maxWidth: maxWidth, location: location })=>{
        const diffX = location.current.input.clientX - location.initial.input.clientX;
        const proposedWidth = initialWidth + diffX;
        return Math.min(Math.max((0, (0, parcelRequire("iZN6h")).MINIMUM_LIST_WIDTH)(), proposedWidth), maxWidth);
    };
    const $5c8bcaa39410cf1d$var$Resizer = ({ width: width, DndLongTaskMetric: DndLongTaskMetric, onResize: onResize, onResizeEnd: onResizeEnd })=>{
        const [isDragging, setIsDragging] = (0, $5uXOq.useState)(false);
        const dividerRef = (0, $5uXOq.useRef)(null);
        const initialWidth = (0, $5uXOq.useRef)(width);
        const maxWidth = (0, (0, parcelRequire("9qpVA")).useMaxWidth)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const onDragStart = (0, $5uXOq.useCallback)(()=>{
            initialWidth.current = width;
            setIsDragging(true);
        }, [
            width
        ]);
        const onDrag = (0, $5uXOq.useCallback)(({ location: location })=>{
            onResize($5c8bcaa39410cf1d$var$getProposedWidth({
                initialWidth: initialWidth.current,
                maxWidth: maxWidth,
                location: location
            }));
        }, [
            onResize,
            maxWidth
        ]);
        const onDrop = (0, $5uXOq.useCallback)(({ location: location })=>{
            (0, $fmZmH.preventUnhandled).stop();
            setIsDragging(false);
            const analyticsEvent = createAnalyticsEvent({
                action: 'resized',
                actionSubject: 'list',
                actionSubjectId: 'resizedList',
                attributes: {
                    didExpand: location.current.input.clientX > location.initial.input.clientX
                }
            });
            (0, (0, parcelRequire("hUAzM")).fireUIAnalyticsEvent)(analyticsEvent);
            onResizeEnd(initialWidth.current);
        }, [
            createAnalyticsEvent,
            onResizeEnd
        ]);
        (0, $5uXOq.useEffect)(()=>{
            width > maxWidth && onResize(maxWidth);
        }, [
            width,
            maxWidth,
            onResize
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const divider = dividerRef.current;
            (0, $3joPi.default)(divider);
            return (0, $7gWdR.draggable)({
                element: divider,
                onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                    (0, $hjhoK.disableNativeDragPreview)({
                        nativeSetDragImage: nativeSetDragImage
                    });
                    (0, $fmZmH.preventUnhandled).start();
                },
                onDragStart: onDragStart,
                onDrag: onDrag,
                onDrop: onDrop
            });
        }, [
            onDragStart,
            onDrag,
            onDrop
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: dividerRef,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _154iidpf _1xi21i6y _1bsbu2gc _4t3i1osq _1pbyilow _v564ryu7 _lcxv1rj4 _80omuf7j _18postnw _1ywu1ule _aetrb3bt _15l2idpf _32rxv77o _z0aiv77o _1qdg1osq _16r21can _11fnglyw",
                isDragging ? "_tzy4kb7n" : "_tzy4idpf _16l4kb7n"
            ])
        }), DndLongTaskMetric !== undefined && (0, ($parcel$interopDefault($5uXOq))).createElement(DndLongTaskMetric, {
            isDragging: isDragging,
            metricType: (0, (0, parcelRequire("iZN6h")).LIST_RESIZE_DRAG_AND_DROP)
        }));
    };
    const $5c8bcaa39410cf1d$var$resizeHandlerStyles = null;
    const $5c8bcaa39410cf1d$var$staticStyles = null;
    const $5c8bcaa39410cf1d$var$draggingStyles = null;
    var $5c8bcaa39410cf1d$export$2e2bcd8739ae039 = $5c8bcaa39410cf1d$var$Resizer;
});
parcelRegister("anfdB", function(module, exports) {
    $parcel$export(module.exports, "canItemCreateSibling", ()=>$73a9297f2613259d$export$a638fd397c012b84);
    $parcel$export(module.exports, "canItemCreateChild", ()=>$73a9297f2613259d$export$8d944d58a048c0d4);
    var $4R6GH;
    var $iZN6h;
    var $7ouUj;
    const $73a9297f2613259d$var$isItemAlreadyInCreate = (id, createItemAnchor)=>createItemAnchor && (createItemAnchor.position === (0, (0, parcelRequire("iZN6h")).BEFORE) || createItemAnchor.position === (0, (0, parcelRequire("iZN6h")).INSIDE)) && (createItemAnchor.beforeId === id || createItemAnchor.parentId === id);
    const $73a9297f2613259d$var$canItemCreate = ({ id: id, createItemAnchor: createItemAnchor, isInTransition: isInTransition })=>!isInTransition && !$73a9297f2613259d$var$isItemAlreadyInCreate(id, createItemAnchor);
    const $73a9297f2613259d$export$a638fd397c012b84 = ({ index: index, isCreateChildEnabled: isCreateChildEnabled, isCreateSiblingEnabled: isCreateSiblingEnabled, depth: depth, ...createCheckParams })=>isCreateSiblingEnabled && ($73a9297f2613259d$var$canItemCreate(createCheckParams) || !createCheckParams.isInTransition && (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y')) && ((0, (0, parcelRequire("7ouUj")).isRoot)(depth) && index !== 0 || !(0, (0, parcelRequire("7ouUj")).isRoot)(depth) && isCreateChildEnabled);
    const $73a9297f2613259d$export$8d944d58a048c0d4 = ({ isCreateChildEnabled: isCreateChildEnabled, canCreateChildOverride: canCreateChildOverride, ...createCheckParams })=>isCreateChildEnabled && canCreateChildOverride && ($73a9297f2613259d$var$canItemCreate(createCheckParams) || !createCheckParams.isInTransition && (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y'));
});
parcelRegister("2VHr3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$62929fb6c6b4c8d9$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $cSD7y;
    var $iZN6h;
    var $g3prf;
    var $9puhl;
    var $lGdZu;
    var $biT18;
    var $iCvEL;
    var $eWv2M;
    var $cRUzn;
    var $6DX98;
    var $695Hr;
    var $6NWvS;
    var $csiwd;
    const $62929fb6c6b4c8d9$var$ThumbTrackComponent = (0, (0, parcelRequire("cSD7y")).componentWithFG)('jsw_roadmaps_timeline_table_custom_scroll_pdnd', (0, (0, parcelRequire("6NWvS")).default), (0, (0, parcelRequire("695Hr")).default));
    const $62929fb6c6b4c8d9$var$containerStyles = null;
    const $62929fb6c6b4c8d9$var$hiddenScrollbarPanelStyles = null;
    const $62929fb6c6b4c8d9$var$HiddenScrollbarPanel = ({ scrollbarSize: scrollbarSize, innerRef: innerRef, children: children, ...rest })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: innerRef,
            style: scrollbarSize > 0 ? {
                right: `-${scrollbarSize}px`,
                bottom: `-${scrollbarSize}px`
            } : undefined,
            ...rest,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _kqswstnw _154iidpf _1xi2idpf _94n5idpf _1ltvidpf _1reo15zi _18m915zi"
            ])
        }, children);
    const $62929fb6c6b4c8d9$var$requestAnimationFrame = (0, (0, parcelRequire("eWv2M")).createRaf)();
    const $62929fb6c6b4c8d9$var$Viewport = (0, (0, parcelRequire("iCvEL")).default)($62929fb6c6b4c8d9$var$HiddenScrollbarPanel);
    const $62929fb6c6b4c8d9$var$CustomScrollbars = ({ isHideScrollbar: isHideScrollbar, children: children })=>{
        const [{ timelineOriginPosition: timelineOriginPosition }] = (0, (0, parcelRequire("biT18")).useTimelineState)();
        const [{ headerHeight: headerHeight }] = (0, (0, parcelRequire("g3prf")).useHeaderState)();
        const [listWidth] = (0, (0, parcelRequire("9puhl")).useListWidth)();
        const [scrollbarSize, setScrollbarSize] = (0, $5uXOq.useState)(-1);
        const viewportRef = (0, $5uXOq.useRef)(null);
        const thumbTracksRef = (0, $5uXOq.useRef)(null);
        const lastScrollY = (0, $5uXOq.useRef)(0);
        const lastScrollX = (0, $5uXOq.useRef)(0);
        const frameId = (0, $5uXOq.useRef)();
        const [setupDragScroller, teardownDragScroller] = (0, (0, parcelRequire("6DX98")).useDragScroller)(headerHeight);
        const { onResize: onResize } = (0, (0, parcelRequire("lGdZu")).useTimelineViewportActions)();
        const onSetViewportRef = (elem)=>{
            viewportRef.current = elem;
            setupDragScroller(elem);
        };
        const onSetScrollLeft = (0, $5uXOq.useCallback)((relativePosition)=>{
            if (!viewportRef.current || !thumbTracksRef.current) throw new Error('An element required to set the scroll left position was null');
            const { scrollWidth: scrollWidth } = viewportRef.current;
            viewportRef.current.scrollLeft = relativePosition * scrollWidth;
        }, []);
        const onSetScrollTop = (0, $5uXOq.useCallback)((relativePosition)=>{
            if (!viewportRef.current || !thumbTracksRef.current) throw new Error('An element required to set the scroll top position was null');
            const { scrollHeight: scrollHeight } = viewportRef.current;
            viewportRef.current.scrollTop = relativePosition * scrollHeight;
        }, []);
        const onScroll = ({ currentTarget: currentTarget })=>{
            frameId.current = $62929fb6c6b4c8d9$var$requestAnimationFrame(()=>{
                const { scrollLeft: scrollLeft, scrollTop: scrollTop, scrollWidth: scrollWidth, scrollHeight: scrollHeight, clientWidth: clientWidth, clientHeight: clientHeight } = currentTarget;
                let horizontalScrollRatio = -1;
                let verticalScrollRatio = -1;
                if (lastScrollX.current !== scrollLeft) {
                    lastScrollX.current = scrollLeft;
                    horizontalScrollRatio = (0, (0, parcelRequire("csiwd")).getScrollOffsetRatio)(scrollLeft, scrollWidth, clientWidth);
                }
                if (lastScrollY.current !== scrollTop) {
                    lastScrollY.current = scrollTop;
                    verticalScrollRatio = (0, (0, parcelRequire("csiwd")).getScrollOffsetRatio)(scrollTop, scrollHeight, clientHeight);
                }
                thumbTracksRef.current?.setThumbPositions({
                    horizontalScrollRatio: horizontalScrollRatio,
                    verticalScrollRatio: verticalScrollRatio
                });
            });
        };
        const updateScrollbars = (0, $5uXOq.useCallback)(()=>{
            if (!viewportRef.current || !thumbTracksRef.current) throw new Error('An element required to set the custom scroll parameters was null');
            const { scrollWidth: scrollWidth, scrollHeight: scrollHeight, clientWidth: clientWidth, clientHeight: clientHeight, scrollLeft: scrollLeft, scrollTop: scrollTop } = viewportRef.current;
            const { left: left } = viewportRef.current.getBoundingClientRect();
            onResize({
                left: left,
                clientWidth: clientWidth
            });
            const horizontalScrollRatio = (0, (0, parcelRequire("csiwd")).getScrollOffsetRatio)(scrollLeft, scrollWidth, clientWidth);
            const verticalScrollRatio = (0, (0, parcelRequire("csiwd")).getScrollOffsetRatio)(scrollTop, scrollHeight, clientHeight);
            const horizontalContentRatio = (0, (0, parcelRequire("csiwd")).getContentToViewportRatio)(scrollWidth, clientWidth);
            const verticalContentRatio = (0, (0, parcelRequire("csiwd")).getContentToViewportRatio)(scrollHeight, clientHeight);
            thumbTracksRef.current?.update({
                horizontalScrollRatio: horizontalScrollRatio,
                verticalScrollRatio: verticalScrollRatio
            }, {
                horizontalContentRatio: horizontalContentRatio,
                verticalContentRatio: verticalContentRatio
            });
        }, [
            onResize
        ]);
        const onContentResize = scrollbarSize > 0 ? updateScrollbars : (0, ($parcel$interopDefault($8Rkzz)));
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (!viewportRef.current) throw new Error('An element required to initialise the custom scrollbars was null');
            const initialScrollbarSize = (0, (0, parcelRequire("csiwd")).getScrollbarSize)(viewportRef.current);
            const integerTimelineDefaultPosition = Math.round(timelineOriginPosition);
            viewportRef.current.scrollLeft = integerTimelineDefaultPosition;
            lastScrollX.current = integerTimelineDefaultPosition;
            setScrollbarSize(initialScrollbarSize);
        }, [
            timelineOriginPosition
        ]);
        (0, (0, parcelRequire("cRUzn")).useResizeObserver)(viewportRef.current, onContentResize);
        (0, $5uXOq.useEffect)(()=>()=>{
                frameId.current && cancelAnimationFrame(frameId.current);
                teardownDragScroller(null);
            }, [
            teardownDragScroller
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _154iidpf _1xi2idpf _94n5idpf _1ltvidpf _1reo15vq _18m915vq _2rkoo8o8"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($62929fb6c6b4c8d9$var$Viewport, {
            id: (0, (0, parcelRequire("iZN6h")).TIMELINE_ID),
            "data-testid": (0, (0, parcelRequire("iZN6h")).TIMELINE_ID),
            innerRef: onSetViewportRef,
            scrollbarSize: scrollbarSize,
            offsets: (0, (0, parcelRequire("csiwd")).getViewportOffsets)(scrollbarSize, listWidth, headerHeight),
            onScroll: scrollbarSize > 0 ? onScroll : undefined
        }, children({
            scrollElement: viewportRef.current,
            onContentResize: onContentResize
        })), scrollbarSize > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement($62929fb6c6b4c8d9$var$ThumbTrackComponent, {
            ref: thumbTracksRef,
            listWidth: listWidth,
            timelineTop: headerHeight,
            isHideScrollbar: isHideScrollbar,
            onSetScrollLeft: onSetScrollLeft,
            onSetScrollTop: onSetScrollTop
        }));
    };
    var $62929fb6c6b4c8d9$export$2e2bcd8739ae039 = $62929fb6c6b4c8d9$var$CustomScrollbars;
});
parcelRegister("iCvEL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$91051642b8e26938$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $kyahI;
    var $8Pr6K;
    var $6y462;
    const $91051642b8e26938$var$withViewportProvider = (WrappedComponent)=>{
        class WithViewportProvider extends (0, $5uXOq.Component) {
            static{
                this.defaultProps = {
                    offsets: (0, (0, parcelRequire("8Pr6K")).DEFAULT_OFFSETS),
                    innerRef: (0, ($parcel$interopDefault($8Rkzz)))
                };
            }
            constructor(props){
                super(props);
                this.requestBoundingClient = ({ withTimelineOffset: withTimelineOffset } = (0, (0, parcelRequire("8Pr6K")).DEFAULT_BOUNDING_OPTIONS))=>{
                    if (!this.ref) throw new Error((0, (0, parcelRequire("8Pr6K")).MISSING_REF_ERROR_MESSAGE));
                    return (0, (0, parcelRequire("6y462")).calculateClientBounding)({
                        element: this.ref,
                        offsets: this.props.offsets,
                        withTimelineOffset: withTimelineOffset
                    });
                };
                this.requestScrollBounding = ({ withTimelineOffset: withTimelineOffset } = (0, (0, parcelRequire("8Pr6K")).DEFAULT_BOUNDING_OPTIONS))=>{
                    if (!this.ref) throw new Error((0, (0, parcelRequire("8Pr6K")).MISSING_REF_ERROR_MESSAGE));
                    return (0, (0, parcelRequire("6y462")).calculateScrollBounding)({
                        element: this.ref,
                        offsets: this.props.offsets,
                        withTimelineOffset: withTimelineOffset
                    });
                };
                this.listenToScroll = (callback)=>{
                    if (!this.ref) throw new Error((0, (0, parcelRequire("8Pr6K")).MISSING_REF_ERROR_MESSAGE));
                    this.ref.addEventListener('scroll', callback);
                };
                this.stopListeningToScroll = (callback)=>{
                    if (this.ref) this.ref.removeEventListener('scroll', callback);
                };
                this.setScroll = ({ scrollLeft: scrollLeft, scrollTop: scrollTop })=>{
                    if (!this.ref) throw new Error((0, (0, parcelRequire("8Pr6K")).MISSING_REF_ERROR_MESSAGE));
                    if (scrollLeft !== undefined) this.ref.scrollLeft = scrollLeft;
                    if (scrollTop !== undefined) this.ref.scrollTop = scrollTop;
                };
                this.onSetRef = (elem)=>{
                    const { innerRef: innerRef } = this.props;
                    this.ref = elem;
                    innerRef(elem);
                };
                this.ref = null;
                this.state = {
                    requestViewportBoundingClient: this.requestBoundingClient,
                    requestViewportScrollBounding: this.requestScrollBounding,
                    listenToViewportScroll: this.listenToScroll,
                    stopListeningToViewportScroll: this.stopListeningToScroll,
                    setViewportScroll: this.setScroll
                };
            }
            render() {
                const { children: children, ...props } = this.props;
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kyahI")).default).Provider, {
                    value: this.state
                }, (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                    ...props,
                    innerRef: this.onSetRef
                }, children));
            }
        }
        return WithViewportProvider;
    };
    var $91051642b8e26938$export$2e2bcd8739ae039 = $91051642b8e26938$var$withViewportProvider;
});
parcelRegister("8Pr6K", function(module, exports) {
    $parcel$export(module.exports, "MISSING_REF_ERROR_MESSAGE", ()=>$f55409c99ca305b3$export$a374b3d597cc8a2f);
    $parcel$export(module.exports, "DEFAULT_BOUNDING_OPTIONS", ()=>$f55409c99ca305b3$export$411ca18ef48ec0a9);
    $parcel$export(module.exports, "DEFAULT_OFFSETS", ()=>$f55409c99ca305b3$export$86c907556a515793);
    const $f55409c99ca305b3$export$a374b3d597cc8a2f = 'Viewport element was null. Only make this request when it is certain to be available (e.g. not in componentDidMount)';
    const $f55409c99ca305b3$export$411ca18ef48ec0a9 = {
        withTimelineOffset: true
    };
    const $f55409c99ca305b3$export$86c907556a515793 = {
        scrollbar: 0,
        timelineTop: 0,
        timelineLeft: 0
    };
});
parcelRegister("6y462", function(module, exports) {
    $parcel$export(module.exports, "calculateClientBounding", ()=>$3992543d55e71f7e$export$787a1f452b87b38);
    $parcel$export(module.exports, "calculateScrollBounding", ()=>$3992543d55e71f7e$export$7bc284cde09cb25);
    const $3992543d55e71f7e$export$787a1f452b87b38 = ({ element: element, offsets: offsets, withTimelineOffset: withTimelineOffset })=>{
        const { width: width, height: height, right: right, bottom: bottom, left: left, top: top } = element.getBoundingClientRect();
        const { timelineTop: timelineTop, timelineLeft: timelineLeft, scrollbar: scrollbar } = offsets;
        const effectiveTimelineTop = withTimelineOffset ? timelineTop : 0;
        const effectiveTimelineLeft = withTimelineOffset ? timelineLeft : 0;
        return {
            width: width - scrollbar - effectiveTimelineLeft,
            height: height - scrollbar - effectiveTimelineTop,
            right: right - scrollbar,
            bottom: bottom - scrollbar,
            left: left + effectiveTimelineLeft,
            top: top + effectiveTimelineTop
        };
    };
    const $3992543d55e71f7e$export$7bc284cde09cb25 = ({ element: element, offsets: offsets, withTimelineOffset: withTimelineOffset })=>{
        const { scrollTop: scrollTop, scrollLeft: scrollLeft, scrollHeight: scrollHeight, scrollWidth: scrollWidth, clientWidth: clientWidth, clientHeight: clientHeight } = element;
        const { timelineTop: timelineTop, timelineLeft: timelineLeft } = offsets;
        const effectiveTimelineTop = withTimelineOffset ? timelineTop : 0;
        const effectiveTimelineLeft = withTimelineOffset ? timelineLeft : 0;
        return {
            scrollTop: scrollTop,
            scrollLeft: scrollLeft,
            scrollRight: Math.max(scrollWidth - clientWidth - scrollLeft, 0),
            scrollBottom: Math.max(scrollHeight - clientHeight - scrollTop, 0),
            scrollHeight: scrollHeight - effectiveTimelineTop,
            scrollWidth: scrollWidth - effectiveTimelineLeft,
            isOverflowY: scrollHeight > clientHeight
        };
    };
});
parcelRegister("eWv2M", function(module, exports) {
    $parcel$export(module.exports, "createRaf", ()=>$5369a1e296f60979$export$adfe8e38eaee509d);
    const $5369a1e296f60979$export$adfe8e38eaee509d = ()=>{
        let frameId = null;
        return (callback)=>{
            if (frameId) cancelAnimationFrame(frameId);
            frameId = requestAnimationFrame(callback);
            return frameId;
        };
    };
});
parcelRegister("6DX98", function(module, exports) {
    $parcel$export(module.exports, "useDragScroller", ()=>$0804fa8fad232017$export$ef7372695b4ed2f3);
    var $5uXOq = parcelRequire("5uXOq");
    var $41Tr4;
    var $4hDdm = parcelRequire("4hDdm");
    var $7gWdR = parcelRequire("7gWdR");
    var $iZN6h;
    const $0804fa8fad232017$export$ef7372695b4ed2f3 = (timelineTop)=>{
        const cleanupDragAndDrop = (0, $5uXOq.useRef)(null);
        const clientXPos = (0, $5uXOq.useRef)(0);
        const thresholdTop = (0, $5uXOq.useRef)(0);
        const setupDragScroller = (0, $5uXOq.useCallback)((viewportElement)=>{
            cleanupDragAndDrop.current = (0, $4hDdm.combine)((0, $7gWdR.monitorForElements)({
                onDragStart: ({ source: source, location: location })=>{
                    const item = source.data;
                    if (item.type === (0, (0, parcelRequire("iZN6h")).ROW_DRAG_AND_DROP_ID) && viewportElement !== null) {
                        const viewportBoundingRect = viewportElement?.getBoundingClientRect();
                        const offsetTop = viewportBoundingRect?.top ?? 0;
                        clientXPos.current = (viewportBoundingRect?.left ?? 0) + (viewportBoundingRect?.width ?? 0) / 2;
                        thresholdTop.current = offsetTop / 2 + timelineTop + offsetTop;
                        (0, (0, parcelRequire("41Tr4")).autoScroller).start({
                            input: {
                                ...location.current.input,
                                pageX: clientXPos.current,
                                clientX: clientXPos.current
                            }
                        });
                    }
                },
                onDrop: ({ source: source })=>{
                    const item = source.data;
                    if (item.type === (0, (0, parcelRequire("iZN6h")).ROW_DRAG_AND_DROP_ID) && viewportElement !== null) (0, (0, parcelRequire("41Tr4")).autoScroller).stop();
                },
                onDrag: ({ source: source, location: location })=>{
                    const item = source.data;
                    if (item.type === (0, (0, parcelRequire("iZN6h")).ROW_DRAG_AND_DROP_ID) && viewportElement !== null) {
                        const { clientY: clientY, pageX: pageX, clientX: clientX, pageY: pageY, ...restInputs } = location.current.input;
                        const newClientY = clientY < thresholdTop.current ? clientY - timelineTop : clientY;
                        const input = {
                            ...restInputs,
                            pageX: clientXPos.current,
                            clientX: clientXPos.current,
                            pageY: newClientY,
                            clientY: newClientY
                        };
                        (0, (0, parcelRequire("41Tr4")).autoScroller).updateInput({
                            input: input
                        });
                    }
                }
            }));
        }, [
            timelineTop
        ]);
        const teardownDragScroller = (0, $5uXOq.useCallback)(()=>{
            cleanupDragAndDrop.current?.();
        }, []);
        return [
            setupDragScroller,
            teardownDragScroller
        ];
    };
});
parcelRegister("41Tr4", function(module, exports) {
    $parcel$export(module.exports, "createAutoScroller", ()=>$109b883638d1460e$export$fbda4b72e803ec38);
    $parcel$export(module.exports, "autoScroller", ()=>$109b883638d1460e$export$d19940cfc7560cd8);
    var $bKki5;
    const $109b883638d1460e$var$scrollElement = (element, change)=>{
        element.scrollBy(change.x, change.y);
    };
    const $109b883638d1460e$var$scrollWindow = (change)=>{
        window.scrollBy(change.x, change.y);
    };
    const $109b883638d1460e$export$fbda4b72e803ec38 = ()=>{
        let dragging = null;
        function tryScroll(fakeScrollCallback) {
            if (dragging == null) return;
            (0, (0, parcelRequire("bKki5")).scroll)({
                input: dragging.latestInput,
                dragStartTime: dragging.dragStartTime,
                shouldUseTimeDampening: dragging.shouldUseTimeDampening,
                behavior: dragging.behavior,
                scrollElement: fakeScrollCallback ?? $109b883638d1460e$var$scrollElement,
                scrollWindow: fakeScrollCallback ?? $109b883638d1460e$var$scrollWindow
            });
        }
        function loop() {
            if (!dragging) return;
            dragging.loopFrameId = requestAnimationFrame(()=>{
                tryScroll();
                loop();
            });
        }
        const start = ({ input: input, behavior: behavior = 'window-then-container' })=>{
            const dragStartTime = Date.now();
            dragging = {
                dragStartTime: dragStartTime,
                latestInput: input,
                loopFrameId: null,
                shouldUseTimeDampening: false,
                behavior: behavior
            };
            const fakeScrollCallback = ()=>{
                if (dragging) dragging.shouldUseTimeDampening = true;
            };
            tryScroll(fakeScrollCallback);
            loop();
        };
        function updateInput({ input: input }) {
            if (!dragging) return;
            dragging.latestInput = input;
        }
        const stop = ()=>{
            if (!dragging) return;
            if (dragging.loopFrameId) cancelAnimationFrame(dragging.loopFrameId);
            dragging = null;
        };
        return {
            start: start,
            updateInput: updateInput,
            stop: stop
        };
    };
    const $109b883638d1460e$export$d19940cfc7560cd8 = $109b883638d1460e$export$fbda4b72e803ec38();
});
parcelRegister("bKki5", function(module, exports) {
    $parcel$export(module.exports, "scroll", ()=>$fa05b34874c18386$export$209876d7b1ac8f3);
    parcelRequire("i6e0j");
    var $kKgsQ = parcelRequire("kKgsQ");
    var $8IFZn;
    var $cd0ri;
    var $bUPhs;
    var $2tkrf;
    var $lVsVC;
    const $fa05b34874c18386$export$209876d7b1ac8f3 = ({ input: input, dragStartTime: dragStartTime, shouldUseTimeDampening: shouldUseTimeDampening, scrollElement: scrollElement, scrollWindow: scrollWindow, behavior: behavior })=>{
        const tryScrollWindow = ()=>{
            const viewport = (0, (0, parcelRequire("lVsVC")).default)();
            const windowScrollChange = (0, (0, parcelRequire("2tkrf")).default)({
                dragStartTime: dragStartTime,
                viewport: viewport,
                center: {
                    x: input.clientX + viewport.scroll.current.x,
                    y: input.clientY + viewport.scroll.current.y
                },
                shouldUseTimeDampening: shouldUseTimeDampening
            });
            if (windowScrollChange) {
                scrollWindow(windowScrollChange);
                return true;
            }
            return false;
        };
        const tryScrollContainer = ()=>{
            const over = (0, $kKgsQ.getElementFromPointWithoutHoneypot)({
                x: input.clientX,
                y: input.clientY
            });
            const closestScrollable = (0, (0, parcelRequire("8IFZn")).getClosestScrollableElement)(over);
            if (!closestScrollable) return false;
            const scrollable = (0, (0, parcelRequire("cd0ri")).getScrollable)({
                closestScrollable: closestScrollable
            });
            const scrollableScrollChange = (0, (0, parcelRequire("bUPhs")).default)({
                dragStartTime: dragStartTime,
                scrollable: scrollable,
                center: {
                    x: input.clientX,
                    y: input.clientY
                },
                shouldUseTimeDampening: shouldUseTimeDampening
            });
            if (scrollableScrollChange) {
                scrollElement(closestScrollable, scrollableScrollChange);
                return true;
            }
            return false;
        };
        if (behavior === 'container-only') tryScrollContainer();
        if (behavior === 'window-only') tryScrollWindow();
        if (behavior === 'container-then-window') tryScrollContainer() || tryScrollWindow();
        if (behavior === 'window-then-container') tryScrollWindow() || tryScrollContainer();
    };
});
parcelRegister("i6e0j", function(module, exports) {
    $parcel$export(module.exports, "getElementFromPointWithoutHoneypot", ()=>(parcelRequire("kKgsQ")).getElementFromPointWithoutHoneypot);
    var $kKgsQ = parcelRequire("kKgsQ");
});
parcelRegister("8IFZn", function(module, exports) {
    $parcel$export(module.exports, "getClosestScrollableElement", ()=>$d89049a655de884c$export$f39f407dd5a0ebdb);
    const $d89049a655de884c$var$isEqual = (base)=>(value)=>base === value;
    const $d89049a655de884c$var$isScroll = $d89049a655de884c$var$isEqual('scroll');
    const $d89049a655de884c$var$isAuto = $d89049a655de884c$var$isEqual('auto');
    const $d89049a655de884c$var$isEither = (overflow, fn)=>fn(overflow.overflowX) || fn(overflow.overflowY);
    const $d89049a655de884c$var$isElementScrollable = (el)=>{
        const style = window.getComputedStyle(el);
        const overflow = {
            overflowX: style.overflowX,
            overflowY: style.overflowY
        };
        return $d89049a655de884c$var$isEither(overflow, $d89049a655de884c$var$isScroll) || $d89049a655de884c$var$isEither(overflow, $d89049a655de884c$var$isAuto);
    };
    const $d89049a655de884c$export$f39f407dd5a0ebdb = (el)=>{
        if (!el) return null;
        if (el === document.body || el === document.documentElement) return null;
        if (!$d89049a655de884c$var$isElementScrollable(el)) return $d89049a655de884c$export$f39f407dd5a0ebdb(el.parentElement);
        return el;
    };
});
parcelRegister("cd0ri", function(module, exports) {
    $parcel$export(module.exports, "getScrollable", ()=>$3bb4723f24ee5351$export$9b7238c949d126e9);
    var $3YKxB;
    const $3bb4723f24ee5351$export$9b7238c949d126e9 = ({ closestScrollable: closestScrollable })=>{
        const rect = closestScrollable.getBoundingClientRect();
        const scrollPosition = {
            x: closestScrollable.scrollLeft,
            y: closestScrollable.scrollTop
        };
        return {
            container: (0, (0, parcelRequire("3YKxB")).getRect)(rect),
            scroll: {
                current: scrollPosition,
                max: {
                    x: closestScrollable.scrollWidth - closestScrollable.clientWidth,
                    y: closestScrollable.scrollHeight - closestScrollable.clientHeight
                }
            }
        };
    };
});
parcelRegister("3YKxB", function(module, exports) {
    $parcel$export(module.exports, "getRect", ()=>$2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe);
    $parcel$export(module.exports, "expand", ()=>$2e5b13c1f6ee9f8a$export$9f77e0932fb78f72);
    $parcel$export(module.exports, "createBox", ()=>$2e5b13c1f6ee9f8a$export$6459fc9e86be362e);
    $parcel$export(module.exports, "offset", ()=>$2e5b13c1f6ee9f8a$export$cc800923e997bb8);
    $parcel$export(module.exports, "withScroll", ()=>$2e5b13c1f6ee9f8a$export$1d0caec378d7d0ae);
    $parcel$export(module.exports, "calculateBox", ()=>$2e5b13c1f6ee9f8a$export$b8dfc5d4e552b8e1);
    $parcel$export(module.exports, "getBox", ()=>$2e5b13c1f6ee9f8a$export$34928e660d2a8702);
    var $3joPi = parcelRequire("3joPi");
    var $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe = function getRect(_ref) {
        var top = _ref.top, right = _ref.right, bottom = _ref.bottom, left = _ref.left;
        var width = right - left;
        var height = bottom - top;
        var rect = {
            top: top,
            right: right,
            bottom: bottom,
            left: left,
            width: width,
            height: height,
            x: left,
            y: top,
            center: {
                x: (right + left) / 2,
                y: (bottom + top) / 2
            }
        };
        return rect;
    };
    var $2e5b13c1f6ee9f8a$export$9f77e0932fb78f72 = function expand(target, expandBy) {
        return {
            top: target.top - expandBy.top,
            left: target.left - expandBy.left,
            bottom: target.bottom + expandBy.bottom,
            right: target.right + expandBy.right
        };
    };
    var $2e5b13c1f6ee9f8a$export$8b1f3092f5e28575 = function shrink(target, shrinkBy) {
        return {
            top: target.top + shrinkBy.top,
            left: target.left + shrinkBy.left,
            bottom: target.bottom - shrinkBy.bottom,
            right: target.right - shrinkBy.right
        };
    };
    var $2e5b13c1f6ee9f8a$var$shift = function shift(target, shiftBy) {
        return {
            top: target.top + shiftBy.y,
            left: target.left + shiftBy.x,
            bottom: target.bottom + shiftBy.y,
            right: target.right + shiftBy.x
        };
    };
    var $2e5b13c1f6ee9f8a$var$noSpacing = {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
    var $2e5b13c1f6ee9f8a$export$6459fc9e86be362e = function createBox(_ref2) {
        var borderBox = _ref2.borderBox, _ref2$margin = _ref2.margin, margin = _ref2$margin === void 0 ? $2e5b13c1f6ee9f8a$var$noSpacing : _ref2$margin, _ref2$border = _ref2.border, border = _ref2$border === void 0 ? $2e5b13c1f6ee9f8a$var$noSpacing : _ref2$border, _ref2$padding = _ref2.padding, padding = _ref2$padding === void 0 ? $2e5b13c1f6ee9f8a$var$noSpacing : _ref2$padding;
        var marginBox = $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe($2e5b13c1f6ee9f8a$export$9f77e0932fb78f72(borderBox, margin));
        var paddingBox = $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe($2e5b13c1f6ee9f8a$export$8b1f3092f5e28575(borderBox, border));
        var contentBox = $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe($2e5b13c1f6ee9f8a$export$8b1f3092f5e28575(paddingBox, padding));
        return {
            marginBox: marginBox,
            borderBox: $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe(borderBox),
            paddingBox: paddingBox,
            contentBox: contentBox,
            margin: margin,
            border: border,
            padding: padding
        };
    };
    var $2e5b13c1f6ee9f8a$var$parse = function parse(raw) {
        var value = raw.slice(0, -2);
        var suffix = raw.slice(-2);
        if (suffix !== 'px') return 0;
        var result = Number(value);
        !!isNaN(result) && (0, $3joPi.default)(false);
        return result;
    };
    var $2e5b13c1f6ee9f8a$var$getWindowScroll = function getWindowScroll() {
        return {
            x: window.pageXOffset,
            y: window.pageYOffset
        };
    };
    var $2e5b13c1f6ee9f8a$export$cc800923e997bb8 = function offset(original, change) {
        var borderBox = original.borderBox, border = original.border, margin = original.margin, padding = original.padding;
        var shifted = $2e5b13c1f6ee9f8a$var$shift(borderBox, change);
        return $2e5b13c1f6ee9f8a$export$6459fc9e86be362e({
            borderBox: shifted,
            border: border,
            margin: margin,
            padding: padding
        });
    };
    var $2e5b13c1f6ee9f8a$export$1d0caec378d7d0ae = function withScroll(original, scroll) {
        if (scroll === void 0) scroll = $2e5b13c1f6ee9f8a$var$getWindowScroll();
        return $2e5b13c1f6ee9f8a$export$cc800923e997bb8(original, scroll);
    };
    var $2e5b13c1f6ee9f8a$export$b8dfc5d4e552b8e1 = function calculateBox(borderBox, styles) {
        var margin = {
            top: $2e5b13c1f6ee9f8a$var$parse(styles.marginTop),
            right: $2e5b13c1f6ee9f8a$var$parse(styles.marginRight),
            bottom: $2e5b13c1f6ee9f8a$var$parse(styles.marginBottom),
            left: $2e5b13c1f6ee9f8a$var$parse(styles.marginLeft)
        };
        var padding = {
            top: $2e5b13c1f6ee9f8a$var$parse(styles.paddingTop),
            right: $2e5b13c1f6ee9f8a$var$parse(styles.paddingRight),
            bottom: $2e5b13c1f6ee9f8a$var$parse(styles.paddingBottom),
            left: $2e5b13c1f6ee9f8a$var$parse(styles.paddingLeft)
        };
        var border = {
            top: $2e5b13c1f6ee9f8a$var$parse(styles.borderTopWidth),
            right: $2e5b13c1f6ee9f8a$var$parse(styles.borderRightWidth),
            bottom: $2e5b13c1f6ee9f8a$var$parse(styles.borderBottomWidth),
            left: $2e5b13c1f6ee9f8a$var$parse(styles.borderLeftWidth)
        };
        return $2e5b13c1f6ee9f8a$export$6459fc9e86be362e({
            borderBox: borderBox,
            margin: margin,
            padding: padding,
            border: border
        });
    };
    var $2e5b13c1f6ee9f8a$export$34928e660d2a8702 = function getBox(el) {
        var borderBox = el.getBoundingClientRect();
        var styles = window.getComputedStyle(el);
        return $2e5b13c1f6ee9f8a$export$b8dfc5d4e552b8e1(borderBox, styles);
    };
});
parcelRegister("bUPhs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ac1c10c5ae151830$export$2e2bcd8739ae039);
    var $g2R1U;
    var $elgbz;
    var $ac1c10c5ae151830$export$2e2bcd8739ae039 = ({ scrollable: scrollable, center: center, dragStartTime: dragStartTime, shouldUseTimeDampening: shouldUseTimeDampening })=>{
        const scroll = (0, (0, parcelRequire("elgbz")).default)({
            dragStartTime: dragStartTime,
            container: scrollable.container,
            center: center,
            shouldUseTimeDampening: shouldUseTimeDampening
        });
        return scroll && (0, (0, parcelRequire("g2R1U")).canScrollScrollable)(scrollable, scroll) ? scroll : null;
    };
});
parcelRegister("g2R1U", function(module, exports) {
    $parcel$export(module.exports, "canScrollWindow", ()=>$e4b7c0460454dc35$export$cbd1e6fd5e887f10);
    $parcel$export(module.exports, "canScrollScrollable", ()=>$e4b7c0460454dc35$export$57c21b61d76c9819);
    var $72Pcv;
    const $e4b7c0460454dc35$var$smallestSigned = (0, (0, parcelRequire("72Pcv")).apply)((value)=>{
        if (value === 0) return 0;
        return value > 0 ? 1 : -1;
    });
    const $e4b7c0460454dc35$export$6b13012b06f8f95b = (()=>{
        const getRemainder = (target, max)=>{
            if (target < 0) return target;
            if (target > max) return target - max;
            return 0;
        };
        return ({ current: current, max: max, change: change })=>{
            const targetScroll = (0, (0, parcelRequire("72Pcv")).add)(current, change);
            const overlap = {
                x: getRemainder(targetScroll.x, max.x),
                y: getRemainder(targetScroll.y, max.y)
            };
            if ((0, (0, parcelRequire("72Pcv")).isEqual)(overlap, (0, (0, parcelRequire("72Pcv")).origin))) return null;
            return overlap;
        };
    })();
    const $e4b7c0460454dc35$export$dbc3ad6130556cf6 = ({ max: rawMax, current: current, change: change })=>{
        const max = {
            x: Math.max(current.x, rawMax.x),
            y: Math.max(current.y, rawMax.y)
        };
        const smallestChange = $e4b7c0460454dc35$var$smallestSigned(change);
        const overlap = $e4b7c0460454dc35$export$6b13012b06f8f95b({
            max: max,
            current: current,
            change: smallestChange
        });
        if (!overlap) return true;
        if (smallestChange.x !== 0 && overlap.x === 0) return true;
        if (smallestChange.y !== 0 && overlap.y === 0) return true;
        return false;
    };
    const $e4b7c0460454dc35$export$cbd1e6fd5e887f10 = (viewport, change)=>$e4b7c0460454dc35$export$dbc3ad6130556cf6({
            current: viewport.scroll.current,
            max: viewport.scroll.max,
            change: change
        });
    const $e4b7c0460454dc35$export$2f1f3b9e315c6096 = (viewport, change)=>{
        if (!$e4b7c0460454dc35$export$cbd1e6fd5e887f10(viewport, change)) return null;
        const max = viewport.scroll.max;
        const current = viewport.scroll.current;
        return $e4b7c0460454dc35$export$6b13012b06f8f95b({
            current: current,
            max: max,
            change: change
        });
    };
    const $e4b7c0460454dc35$export$57c21b61d76c9819 = (scrollable, change)=>{
        return $e4b7c0460454dc35$export$dbc3ad6130556cf6({
            current: scrollable.scroll.current,
            max: scrollable.scroll.max,
            change: change
        });
    };
    const $e4b7c0460454dc35$export$d88a6b2979421049 = (scrollable, change)=>{
        if (!$e4b7c0460454dc35$export$57c21b61d76c9819(scrollable, change)) return null;
        return $e4b7c0460454dc35$export$6b13012b06f8f95b({
            current: scrollable.scroll.current,
            max: scrollable.scroll.max,
            change: change
        });
    };
});
parcelRegister("72Pcv", function(module, exports) {
    $parcel$export(module.exports, "origin", ()=>$6ab9ddd38a038691$export$f710a83a91838a36);
    $parcel$export(module.exports, "apply", ()=>$6ab9ddd38a038691$export$5635d7ef4b8fee1c);
    $parcel$export(module.exports, "isEqual", ()=>$6ab9ddd38a038691$export$248d38f6296296c5);
    $parcel$export(module.exports, "add", ()=>$6ab9ddd38a038691$export$e16d8520af44a096);
    $parcel$export(module.exports, "subtract", ()=>$6ab9ddd38a038691$export$4e2d2ead65e5f7e3);
    const $6ab9ddd38a038691$export$f710a83a91838a36 = {
        x: 0,
        y: 0
    };
    const $6ab9ddd38a038691$export$5635d7ef4b8fee1c = (fn)=>(point)=>({
                x: fn(point.x),
                y: fn(point.y)
            });
    const $6ab9ddd38a038691$export$248d38f6296296c5 = (point1, point2)=>point1.x === point2.x && point1.y === point2.y;
    const $6ab9ddd38a038691$export$e16d8520af44a096 = (point1, point2)=>({
            x: point1.x + point2.x,
            y: point1.y + point2.y
        });
    const $6ab9ddd38a038691$export$4e2d2ead65e5f7e3 = (point1, point2)=>({
            x: point1.x - point2.x,
            y: point1.y - point2.y
        });
});
parcelRegister("elgbz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7bd53a776b729d8f$export$2e2bcd8739ae039);
    var $8x8E3;
    var $72Pcv;
    var $3hu7o;
    const $7bd53a776b729d8f$var$clean = (0, (0, parcelRequire("72Pcv")).apply)((value)=>value === 0 ? 0 : value);
    var $7bd53a776b729d8f$export$2e2bcd8739ae039 = ({ dragStartTime: dragStartTime, container: container, center: center, shouldUseTimeDampening: shouldUseTimeDampening })=>{
        const distanceToEdges = {
            top: center.y - container.top,
            right: container.right - center.x,
            bottom: container.bottom - center.y,
            left: center.x - container.left
        };
        const y = (0, (0, parcelRequire("3hu7o")).default)({
            container: container,
            distanceToEdges: distanceToEdges,
            dragStartTime: dragStartTime,
            axis: (0, (0, parcelRequire("8x8E3")).vertical),
            shouldUseTimeDampening: shouldUseTimeDampening
        });
        const x = (0, (0, parcelRequire("3hu7o")).default)({
            container: container,
            distanceToEdges: distanceToEdges,
            dragStartTime: dragStartTime,
            axis: (0, (0, parcelRequire("8x8E3")).horizontal),
            shouldUseTimeDampening: shouldUseTimeDampening
        });
        const required = $7bd53a776b729d8f$var$clean({
            x: x,
            y: y
        });
        if ((0, (0, parcelRequire("72Pcv")).isEqual)(required, (0, (0, parcelRequire("72Pcv")).origin))) return null;
        return required;
    };
});
parcelRegister("8x8E3", function(module, exports) {
    $parcel$export(module.exports, "minScroll", ()=>$bf32c7b0b1170f48$export$67e2de1e1e796844);
    $parcel$export(module.exports, "vertical", ()=>$bf32c7b0b1170f48$export$32f8a6eb41d46820);
    $parcel$export(module.exports, "horizontal", ()=>$bf32c7b0b1170f48$export$641ecd0b2bc39508);
    const $bf32c7b0b1170f48$export$67e2de1e1e796844 = 1;
    const $bf32c7b0b1170f48$export$32f8a6eb41d46820 = {
        direction: 'vertical',
        start: 'top',
        end: 'bottom',
        size: 'height',
        scrollAxis: 'scrollTop'
    };
    const $bf32c7b0b1170f48$export$641ecd0b2bc39508 = {
        direction: 'horizontal',
        start: 'left',
        end: 'right',
        size: 'width',
        scrollAxis: 'scrollLeft'
    };
    const $bf32c7b0b1170f48$export$1a8fc111f6979e7a = [
        $bf32c7b0b1170f48$export$641ecd0b2bc39508.direction,
        $bf32c7b0b1170f48$export$32f8a6eb41d46820.direction
    ];
});
parcelRegister("3hu7o", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a9df84024ef20482$export$2e2bcd8739ae039);
    var $TN11L;
    var $h91se;
    var $a9df84024ef20482$export$2e2bcd8739ae039 = ({ container: container, distanceToEdges: distanceToEdges, dragStartTime: dragStartTime, axis: axis, shouldUseTimeDampening: shouldUseTimeDampening })=>{
        const thresholds = (0, (0, parcelRequire("TN11L")).default)(container, axis);
        const isCloserToEnd = distanceToEdges[axis.end] < distanceToEdges[axis.start];
        if (isCloserToEnd) return (0, (0, parcelRequire("h91se")).default)({
            distanceToEdge: distanceToEdges[axis.end],
            thresholds: thresholds,
            dragStartTime: dragStartTime,
            shouldUseTimeDampening: shouldUseTimeDampening
        });
        return -1 * (0, (0, parcelRequire("h91se")).default)({
            distanceToEdge: distanceToEdges[axis.start],
            thresholds: thresholds,
            dragStartTime: dragStartTime,
            shouldUseTimeDampening: shouldUseTimeDampening
        });
    };
});
parcelRegister("TN11L", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e3b60bb9d8221ac4$export$2e2bcd8739ae039);
    var $2gHPS;
    const $e3b60bb9d8221ac4$export$79446fee27934459 = (container, axis)=>{
        const startScrollingFrom = container[axis.size] * (0, (0, parcelRequire("2gHPS")).default).startFromPercentage;
        const maxScrollValueAt = container[axis.size] * (0, (0, parcelRequire("2gHPS")).default).maxScrollAtPercentage;
        const thresholds = {
            startScrollingFrom: startScrollingFrom,
            maxScrollValueAt: maxScrollValueAt
        };
        return thresholds;
    };
    var $e3b60bb9d8221ac4$export$2e2bcd8739ae039 = $e3b60bb9d8221ac4$export$79446fee27934459;
});
parcelRegister("2gHPS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$372e7e4331f931a5$export$2e2bcd8739ae039);
    const $372e7e4331f931a5$var$config = {
        startFromPercentage: 0.25,
        maxScrollAtPercentage: 0.05,
        maxPixelScroll: 28,
        ease: (percentage)=>Math.pow(percentage, 2),
        durationDampening: {
            stopDampeningAt: 1200,
            accelerateAt: 360
        }
    };
    var $372e7e4331f931a5$export$2e2bcd8739ae039 = $372e7e4331f931a5$var$config;
});
parcelRegister("h91se", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$46ce8abe6474bdaa$export$2e2bcd8739ae039);
    var $8x8E3;
    var $edWdS;
    var $7vxL6;
    const $46ce8abe6474bdaa$export$bf7199a9ebcb84a9 = ({ distanceToEdge: distanceToEdge, thresholds: thresholds, dragStartTime: dragStartTime, shouldUseTimeDampening: shouldUseTimeDampening })=>{
        const scroll = (0, (0, parcelRequire("7vxL6")).getValueFromDistance)(distanceToEdge, thresholds);
        if (scroll === 0) return 0;
        if (!shouldUseTimeDampening) return scroll;
        return Math.max((0, (0, parcelRequire("edWdS")).dampenValueByTime)(scroll, dragStartTime), (0, (0, parcelRequire("8x8E3")).minScroll));
    };
    var $46ce8abe6474bdaa$export$2e2bcd8739ae039 = $46ce8abe6474bdaa$export$bf7199a9ebcb84a9;
});
parcelRegister("edWdS", function(module, exports) {
    $parcel$export(module.exports, "dampenValueByTime", ()=>$b46522d5c480b17a$export$2fe468ff7a999ed6);
    var $2gHPS;
    var $8x8E3;
    var $5yDwA;
    const $b46522d5c480b17a$var$accelerateAt = (0, (0, parcelRequire("2gHPS")).default).durationDampening.accelerateAt;
    const $b46522d5c480b17a$var$stopAt = (0, (0, parcelRequire("2gHPS")).default).durationDampening.stopDampeningAt;
    const $b46522d5c480b17a$export$2fe468ff7a999ed6 = (proposedScroll, dragStartTime)=>{
        const startOfRange = dragStartTime;
        const endOfRange = $b46522d5c480b17a$var$stopAt;
        const now = Date.now();
        const runTime = now - startOfRange;
        if (runTime >= $b46522d5c480b17a$var$stopAt) return proposedScroll;
        if (runTime < $b46522d5c480b17a$var$accelerateAt) return 0, (0, parcelRequire("8x8E3")).minScroll;
        const betweenAccelerateAtAndStopAtPercentage = (0, (0, parcelRequire("5yDwA")).getPercentage)({
            startOfRange: $b46522d5c480b17a$var$accelerateAt,
            endOfRange: endOfRange,
            current: runTime
        });
        const scroll = proposedScroll * (0, (0, parcelRequire("2gHPS")).default).ease(betweenAccelerateAtAndStopAtPercentage);
        return Math.ceil(scroll);
    };
});
parcelRegister("5yDwA", function(module, exports) {
    $parcel$export(module.exports, "getPercentage", ()=>$9599504fdea7da9c$export$6712e0f6cd0ea03);
    const $9599504fdea7da9c$export$6712e0f6cd0ea03 = ({ startOfRange: startOfRange, endOfRange: endOfRange, current: current })=>{
        const range = endOfRange - startOfRange;
        if (range === 0) return 0;
        const currentInRange = current - startOfRange;
        const percentage = currentInRange / range;
        return percentage;
    };
});
parcelRegister("7vxL6", function(module, exports) {
    $parcel$export(module.exports, "getValueFromDistance", ()=>$fa6f09f36cc6d31c$export$f3e495573a199c91);
    var $2gHPS;
    var $8x8E3;
    var $5yDwA;
    const $fa6f09f36cc6d31c$export$f3e495573a199c91 = (distanceToEdge, thresholds)=>{
        if (distanceToEdge > thresholds.startScrollingFrom) return 0;
        if (distanceToEdge <= thresholds.maxScrollValueAt) return (0, (0, parcelRequire("2gHPS")).default).maxPixelScroll;
        if (distanceToEdge === thresholds.startScrollingFrom) return 0, (0, parcelRequire("8x8E3")).minScroll;
        const percentageFromMaxScrollValueAt = (0, (0, parcelRequire("5yDwA")).getPercentage)({
            startOfRange: thresholds.maxScrollValueAt,
            endOfRange: thresholds.startScrollingFrom,
            current: distanceToEdge
        });
        const percentageFromStartScrollingFrom = 1 - percentageFromMaxScrollValueAt;
        const scroll = (0, (0, parcelRequire("2gHPS")).default).maxPixelScroll * (0, (0, parcelRequire("2gHPS")).default).ease(percentageFromStartScrollingFrom);
        return Math.ceil(scroll);
    };
});
parcelRegister("2tkrf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d272222f271a432a$export$2e2bcd8739ae039);
    var $g2R1U;
    var $elgbz;
    var $d272222f271a432a$export$2e2bcd8739ae039 = ({ viewport: viewport, center: center, dragStartTime: dragStartTime, shouldUseTimeDampening: shouldUseTimeDampening })=>{
        const scroll = (0, (0, parcelRequire("elgbz")).default)({
            dragStartTime: dragStartTime,
            container: viewport.container,
            center: center,
            shouldUseTimeDampening: shouldUseTimeDampening
        });
        return scroll && (0, (0, parcelRequire("g2R1U")).canScrollWindow)(viewport, scroll) ? scroll : null;
    };
});
parcelRegister("lVsVC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3afd8185a3fe1873$export$2e2bcd8739ae039);
    var $3YKxB;
    var $bsp0B;
    var $feNdz;
    var $3afd8185a3fe1873$export$2e2bcd8739ae039 = ()=>{
        const scroll = (0, (0, parcelRequire("feNdz")).default)();
        const maxScroll = (0, (0, parcelRequire("bsp0B")).default)();
        const top = scroll.y;
        const left = scroll.x;
        const doc = document.documentElement;
        const width = doc.clientWidth;
        const height = doc.clientHeight;
        const right = left + width;
        const bottom = top + height;
        const container = (0, (0, parcelRequire("3YKxB")).getRect)({
            top: top,
            left: left,
            right: right,
            bottom: bottom
        });
        const viewport = {
            container: container,
            scroll: {
                current: scroll,
                max: maxScroll
            }
        };
        return viewport;
    };
});
parcelRegister("bsp0B", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e50ed177aa05ce5d$export$2e2bcd8739ae039);
    var $bX8yW;
    var $e50ed177aa05ce5d$export$2e2bcd8739ae039 = ()=>{
        const doc = document.documentElement;
        const maxScroll = (0, (0, parcelRequire("bX8yW")).default)({
            scrollHeight: doc.scrollHeight,
            scrollWidth: doc.scrollWidth,
            width: doc.clientWidth,
            height: doc.clientHeight
        });
        return maxScroll;
    };
});
parcelRegister("bX8yW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2927a2a5ef61b637$export$2e2bcd8739ae039);
    var $72Pcv;
    var $2927a2a5ef61b637$export$2e2bcd8739ae039 = ({ scrollHeight: scrollHeight, scrollWidth: scrollWidth, height: height, width: width })=>{
        const maxScroll = (0, (0, parcelRequire("72Pcv")).subtract)({
            x: scrollWidth,
            y: scrollHeight
        }, {
            x: width,
            y: height
        });
        const adjustedMaxScroll = {
            x: Math.max(0, maxScroll.x),
            y: Math.max(0, maxScroll.y)
        };
        return adjustedMaxScroll;
    };
});
parcelRegister("feNdz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$31ea253008c58ece$export$2e2bcd8739ae039);
    var $31ea253008c58ece$export$2e2bcd8739ae039 = ()=>({
            x: window.pageXOffset,
            y: window.pageYOffset
        });
});
parcelRegister("695Hr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$55f5b8e4f5cdd430$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $fNuuD;
    var $3SHG6;
    var $khH0q;
    const $55f5b8e4f5cdd430$var$baseTrackStyles = null;
    const $55f5b8e4f5cdd430$var$baseThumbStyles = null;
    const $55f5b8e4f5cdd430$var$visibleStyles = null;
    const $55f5b8e4f5cdd430$var$notVisibleStyles = null;
    const $55f5b8e4f5cdd430$var$verticalTrackStyles = null;
    const $55f5b8e4f5cdd430$var$horizontalTrackStyles = null;
    const $55f5b8e4f5cdd430$var$verticalThumbStyles = null;
    const $55f5b8e4f5cdd430$var$horizontalThumbStyles = null;
    const $55f5b8e4f5cdd430$var$HorizontalThumb = ({ size: size, innerRef: innerRef, children: children, ...rest })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "roadmap.timeline-table.main.custom-scrollbars.thumb-tracks.horizontal-thumb",
            ref: innerRef,
            style: {
                width: `${size}px`
            },
            ...rest,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _2rko19bv _bfhkvrk4",
                "_4t3i1osq"
            ])
        }, children);
    const $55f5b8e4f5cdd430$var$VerticalThumb = ({ size: size, innerRef: innerRef, children: children, ...rest })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "roadmap.timeline-table.main.custom-scrollbars.thumb-tracks.vertical-thumb",
            ref: innerRef,
            style: {
                height: `${size}px`
            },
            ...rest,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _2rko19bv _bfhkvrk4",
                "_1bsb1osq"
            ])
        }, children);
    const $55f5b8e4f5cdd430$var$DraggableHorizontalThumb = (0, (0, parcelRequire("fNuuD")).withDragObserver)($55f5b8e4f5cdd430$var$HorizontalThumb, (0, (0, parcelRequire("3SHG6")).THUMB_DRAG_THRESHOLD));
    const $55f5b8e4f5cdd430$var$DraggableVerticalThumb = (0, (0, parcelRequire("fNuuD")).withDragObserver)($55f5b8e4f5cdd430$var$VerticalThumb, (0, (0, parcelRequire("3SHG6")).THUMB_DRAG_THRESHOLD));
    const $55f5b8e4f5cdd430$var$ScrollbarThumbTracks = ({ listWidth: listWidth, isHideScrollbar: isHideScrollbar, timelineTop: timelineTop, onSetScrollLeft: onSetScrollLeft, onSetScrollTop: onSetScrollTop }, ref)=>{
        const horizontalTrackRef = (0, $5uXOq.useRef)(null);
        const horizontalThumbRef = (0, $5uXOq.useRef)(null);
        const verticalTrackRef = (0, $5uXOq.useRef)(null);
        const verticalThumbRef = (0, $5uXOq.useRef)(null);
        const dragCache = (0, $5uXOq.useRef)((0, (0, parcelRequire("3SHG6")).DEFAULT_DRAG_CACHE));
        const [{ horizontalThumbSize: horizontalThumbSize, verticalThumbSize: verticalThumbSize }, setThumbSizes] = (0, $5uXOq.useState)({
            horizontalThumbSize: 0,
            verticalThumbSize: 0
        });
        const setHorizontalThumbPosition = (0, $5uXOq.useCallback)((trackSize, scrollRatio, thumbSize)=>{
            if (scrollRatio >= 0) {
                const position = (0, (0, parcelRequire("khH0q")).getThumbPosition)(scrollRatio, trackSize, thumbSize);
                if (horizontalThumbRef.current) horizontalThumbRef.current.style.transform = `translateX(${position}px)`;
            }
        }, []);
        const setVerticalThumbPosition = (0, $5uXOq.useCallback)((trackSize, scrollRatio, thumbSize)=>{
            if (scrollRatio >= 0) {
                const position = (0, (0, parcelRequire("khH0q")).getThumbPosition)(scrollRatio, trackSize, thumbSize);
                if (verticalThumbRef.current) verticalThumbRef.current.style.transform = `translateY(${position}px)`;
            }
        }, []);
        (0, $5uXOq.useImperativeHandle)(ref, ()=>({
                setThumbPositions: ({ horizontalScrollRatio: horizontalScrollRatio, verticalScrollRatio: verticalScrollRatio })=>{
                    if (!horizontalTrackRef.current || !verticalTrackRef.current) throw new Error('An element required to set the thumb positions were null');
                    const { clientWidth: clientWidth } = horizontalTrackRef.current;
                    const { clientHeight: clientHeight } = verticalTrackRef.current;
                    setHorizontalThumbPosition(clientWidth, horizontalScrollRatio, horizontalThumbSize);
                    setVerticalThumbPosition(clientHeight, verticalScrollRatio, verticalThumbSize);
                },
                update: ({ horizontalScrollRatio: horizontalScrollRatio, verticalScrollRatio: verticalScrollRatio }, { horizontalContentRatio: horizontalContentRatio, verticalContentRatio: verticalContentRatio })=>{
                    if (!horizontalTrackRef.current || !verticalTrackRef.current) throw new Error('An element required to update the thumb tracks were null');
                    const { clientWidth: clientWidth } = horizontalTrackRef.current;
                    const { clientHeight: clientHeight } = verticalTrackRef.current;
                    let hThumbSize = 0;
                    let vThumbSize = 0;
                    if (horizontalContentRatio < 1) {
                        hThumbSize = (0, (0, parcelRequire("khH0q")).getThumbSize)(horizontalContentRatio, clientWidth);
                        setHorizontalThumbPosition(clientWidth, horizontalScrollRatio, hThumbSize);
                    }
                    if (verticalContentRatio < 1) {
                        vThumbSize = (0, (0, parcelRequire("khH0q")).getThumbSize)(verticalContentRatio, clientHeight);
                        setVerticalThumbPosition(clientHeight, verticalScrollRatio, vThumbSize);
                    }
                    setThumbSizes((0, (0, parcelRequire("khH0q")).getMemoisedThumbState)(hThumbSize, vThumbSize));
                }
            }), [
            horizontalThumbSize,
            verticalThumbSize,
            setHorizontalThumbPosition,
            setVerticalThumbPosition
        ]);
        const onStartDragHorizontalThumb = ({ x: x })=>{
            if (!horizontalTrackRef.current || !horizontalThumbRef.current) throw new Error('An element required to drag the horizontal scroll thumb was null');
            const { left: left, width: width } = horizontalTrackRef.current.getBoundingClientRect();
            const thumbClientRect = horizontalThumbRef.current.getBoundingClientRect();
            const relativeMousePosition = x - thumbClientRect.left;
            dragCache.current = {
                thumbOrigin: Math.round(horizontalThumbSize / 2 - relativeMousePosition),
                trackPosition: left,
                trackSize: width
            };
        };
        const onDragHorizontalThumb = (from, to)=>{
            const { thumbOrigin: thumbOrigin, trackPosition: trackPosition, trackSize: trackSize } = dragCache.current;
            const relativeScrollPosition = (0, (0, parcelRequire("khH0q")).getRelativeScrollPosition)({
                thumbPosition: thumbOrigin + to.x,
                thumbSize: horizontalThumbSize,
                trackPosition: trackPosition,
                trackSize: trackSize
            });
            onSetScrollLeft(relativeScrollPosition);
        };
        const onMouseDownHorizontalTrack = (event)=>{
            const { left: left, width: width } = event.currentTarget.getBoundingClientRect();
            const relativeScrollPosition = (0, (0, parcelRequire("khH0q")).getRelativeScrollPosition)({
                thumbPosition: event.pageX,
                thumbSize: horizontalThumbSize,
                trackPosition: left,
                trackSize: width
            });
            onSetScrollLeft(relativeScrollPosition);
        };
        const onStartDragVerticalThumb = ({ y: y })=>{
            if (!verticalTrackRef.current || !verticalThumbRef.current) throw new Error('An element required to drag the vertical scroll thumb was null');
            const { top: top, height: height } = verticalTrackRef.current.getBoundingClientRect();
            const thumbClientRect = verticalThumbRef.current.getBoundingClientRect();
            const relativeMousePosition = y - thumbClientRect.top;
            dragCache.current = {
                thumbOrigin: Math.round(verticalThumbSize / 2 - relativeMousePosition),
                trackPosition: top,
                trackSize: height
            };
        };
        const onDragVerticalThumb = (from, to)=>{
            const { thumbOrigin: thumbOrigin, trackPosition: trackPosition, trackSize: trackSize } = dragCache.current;
            const relativeScrollPosition = (0, (0, parcelRequire("khH0q")).getRelativeScrollPosition)({
                thumbPosition: thumbOrigin + to.y,
                thumbSize: verticalThumbSize,
                trackPosition: trackPosition,
                trackSize: trackSize
            });
            onSetScrollTop(relativeScrollPosition);
        };
        const onMouseDownVerticalTrack = (event)=>{
            const { top: top, height: height } = event.currentTarget.getBoundingClientRect();
            const relativeScrollPosition = (0, (0, parcelRequire("khH0q")).getRelativeScrollPosition)({
                thumbPosition: event.pageY,
                thumbSize: verticalThumbSize,
                trackPosition: top,
                trackSize: height
            });
            onSetScrollTop(relativeScrollPosition);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: horizontalTrackRef,
            "data-testid": "roadmap.timeline-table.main.custom-scrollbars.thumb-tracks.horizontal-track",
            style: {
                left: `${listWidth + (0, (0, parcelRequire("3SHG6")).SCROLLBAR_OFFSET)}px`
            },
            onMouseDown: onMouseDownHorizontalTrack,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _2rko19bv _1pbyibnn _o7ks1fkz _irr31409 _1di61409",
                horizontalThumbSize > 0 && !isHideScrollbar ? "_3um0ewfl" : "_3um015vq",
                "_1xi21v6z _4t3i19bv _94n5idpf"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($55f5b8e4f5cdd430$var$DraggableHorizontalThumb, {
            innerRef: horizontalThumbRef,
            size: horizontalThumbSize,
            onDrag: onDragHorizontalThumb,
            onDragStart: onStartDragHorizontalThumb
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: verticalTrackRef,
            "data-testid": "roadmap.timeline-table.main.custom-scrollbars.thumb-tracks.vertical-track",
            style: {
                top: `${timelineTop + (0, (0, parcelRequire("3SHG6")).SCROLLBAR_OFFSET)}px`
            },
            onMouseDown: onMouseDownVerticalTrack,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _2rko19bv _1pbyibnn _o7ks1fkz _irr31409 _1di61409",
                verticalThumbSize > 0 && !isHideScrollbar ? "_3um0ewfl" : "_3um015vq",
                "_94n51v6z _1bsb19bv _1xi2idpf"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($55f5b8e4f5cdd430$var$DraggableVerticalThumb, {
            innerRef: verticalThumbRef,
            size: verticalThumbSize,
            onDrag: onDragVerticalThumb,
            onDragStart: onStartDragVerticalThumb
        })));
    };
    var $55f5b8e4f5cdd430$export$2e2bcd8739ae039 = (0, $5uXOq.forwardRef)($55f5b8e4f5cdd430$var$ScrollbarThumbTracks);
});
parcelRegister("3SHG6", function(module, exports) {
    $parcel$export(module.exports, "THUMB_DRAG_THRESHOLD", ()=>$c24fc9f6483454d6$export$e42a8c8f5541f7b0);
    $parcel$export(module.exports, "THUMB_MINIMUM_SIZE", ()=>$c24fc9f6483454d6$export$e68be48bcc227668);
    $parcel$export(module.exports, "SCROLLBAR_OFFSET", ()=>$c24fc9f6483454d6$export$b902a3a0053e40b);
    $parcel$export(module.exports, "DEFAULT_DRAG_CACHE", ()=>$c24fc9f6483454d6$export$1580f12b2bee9a05);
    const $c24fc9f6483454d6$export$e42a8c8f5541f7b0 = 0.1;
    const $c24fc9f6483454d6$export$e68be48bcc227668 = 20;
    const $c24fc9f6483454d6$export$d83d7e5e215aa7f9 = 10;
    const $c24fc9f6483454d6$export$b902a3a0053e40b = 7;
    const $c24fc9f6483454d6$export$1580f12b2bee9a05 = {
        thumbOrigin: 0,
        trackPosition: 0,
        trackSize: 0
    };
});
parcelRegister("khH0q", function(module, exports) {
    $parcel$export(module.exports, "getRelativeScrollPosition", ()=>$1f21e85cd42fa368$export$2bc8e9ae2ef96ba4);
    $parcel$export(module.exports, "getThumbPosition", ()=>$1f21e85cd42fa368$export$1bcd41904c090870);
    $parcel$export(module.exports, "getThumbSize", ()=>$1f21e85cd42fa368$export$7b14c3f3cc4d1eca);
    $parcel$export(module.exports, "getMemoisedThumbState", ()=>$1f21e85cd42fa368$export$1c021ba4dc4fcf31);
    var $8QpSo;
    var $3SHG6;
    const $1f21e85cd42fa368$export$2bc8e9ae2ef96ba4 = ({ thumbPosition: thumbPosition, thumbSize: thumbSize, trackPosition: trackPosition, trackSize: trackSize })=>{
        const relativePosition = thumbPosition - trackPosition;
        const newThumbOffset = relativePosition - thumbSize / 2;
        return newThumbOffset / trackSize;
    };
    const $1f21e85cd42fa368$export$1bcd41904c090870 = (scrollOffsetRatio, trackSize, thumbSize)=>scrollOffsetRatio * (trackSize - thumbSize);
    const $1f21e85cd42fa368$export$7b14c3f3cc4d1eca = (contentToViewportRatio, trackSize)=>{
        const size = Math.round(contentToViewportRatio * trackSize);
        return Math.max((0, (0, parcelRequire("3SHG6")).THUMB_MINIMUM_SIZE), size);
    };
    const $1f21e85cd42fa368$export$1c021ba4dc4fcf31 = (0, (0, parcelRequire("8QpSo")).default)((horizontalThumbSize, verticalThumbSize)=>({
            horizontalThumbSize: horizontalThumbSize,
            verticalThumbSize: verticalThumbSize
        }));
});
parcelRegister("6NWvS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a4792843849a449a$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $3joPi = parcelRequire("3joPi");
    var $7gWdR = parcelRequire("7gWdR");
    var $hjhoK = parcelRequire("hjhoK");
    var $fmZmH = parcelRequire("fmZmH");
    var $3SHG6;
    var $khH0q;
    const $a4792843849a449a$var$baseTrackStyles = null;
    const $a4792843849a449a$var$baseThumbStyles = null;
    const $a4792843849a449a$var$visibleStyles = null;
    const $a4792843849a449a$var$notVisibleStyles = null;
    const $a4792843849a449a$var$verticalTrackStyles = null;
    const $a4792843849a449a$var$horizontalTrackStyles = null;
    const $a4792843849a449a$var$verticalThumbStyles = null;
    const $a4792843849a449a$var$horizontalThumbStyles = null;
    const $a4792843849a449a$var$useImperativeTracksAndThumbs = ({ mainComponentRef: mainComponentRef })=>{
        const horizontalTrackRef = (0, $5uXOq.useRef)(null);
        const horizontalThumbRef = (0, $5uXOq.useRef)(null);
        const verticalTrackRef = (0, $5uXOq.useRef)(null);
        const verticalThumbRef = (0, $5uXOq.useRef)(null);
        const [{ horizontalThumbSize: horizontalThumbSize, verticalThumbSize: verticalThumbSize }, setThumbSizes] = (0, $5uXOq.useState)({
            horizontalThumbSize: 0,
            verticalThumbSize: 0
        });
        const setHorizontalThumbPosition = (0, $5uXOq.useCallback)((trackSize, scrollRatio, thumbSize)=>{
            if (scrollRatio >= 0) {
                const position = (0, (0, parcelRequire("khH0q")).getThumbPosition)(scrollRatio, trackSize, thumbSize);
                if (horizontalThumbRef.current) horizontalThumbRef.current.style.transform = `translateX(${position}px)`;
            }
        }, []);
        const setVerticalThumbPosition = (0, $5uXOq.useCallback)((trackSize, scrollRatio, thumbSize)=>{
            if (scrollRatio >= 0) {
                const position = (0, (0, parcelRequire("khH0q")).getThumbPosition)(scrollRatio, trackSize, thumbSize);
                if (verticalThumbRef.current) verticalThumbRef.current.style.transform = `translateY(${position}px)`;
            }
        }, []);
        (0, $5uXOq.useImperativeHandle)(mainComponentRef, ()=>({
                setThumbPositions: ({ horizontalScrollRatio: horizontalScrollRatio, verticalScrollRatio: verticalScrollRatio })=>{
                    if (!horizontalTrackRef.current || !verticalTrackRef.current) throw new Error('An element required to set the thumb positions were null');
                    const { clientWidth: clientWidth } = horizontalTrackRef.current;
                    const { clientHeight: clientHeight } = verticalTrackRef.current;
                    setHorizontalThumbPosition(clientWidth, horizontalScrollRatio, horizontalThumbSize);
                    setVerticalThumbPosition(clientHeight, verticalScrollRatio, verticalThumbSize);
                },
                update: ({ horizontalScrollRatio: horizontalScrollRatio, verticalScrollRatio: verticalScrollRatio }, { horizontalContentRatio: horizontalContentRatio, verticalContentRatio: verticalContentRatio })=>{
                    if (!horizontalTrackRef.current || !verticalTrackRef.current) throw new Error('An element required to update the thumb tracks were null');
                    const { clientWidth: clientWidth } = horizontalTrackRef.current;
                    const { clientHeight: clientHeight } = verticalTrackRef.current;
                    let hThumbSize = 0;
                    let vThumbSize = 0;
                    if (horizontalContentRatio < 1) {
                        hThumbSize = (0, (0, parcelRequire("khH0q")).getThumbSize)(horizontalContentRatio, clientWidth);
                        setHorizontalThumbPosition(clientWidth, horizontalScrollRatio, hThumbSize);
                    }
                    if (verticalContentRatio < 1) {
                        vThumbSize = (0, (0, parcelRequire("khH0q")).getThumbSize)(verticalContentRatio, clientHeight);
                        setVerticalThumbPosition(clientHeight, verticalScrollRatio, vThumbSize);
                    }
                    setThumbSizes((0, (0, parcelRequire("khH0q")).getMemoisedThumbState)(hThumbSize, vThumbSize));
                }
            }), [
            horizontalThumbSize,
            verticalThumbSize,
            setHorizontalThumbPosition,
            setVerticalThumbPosition
        ]);
        return {
            horizontalThumbRef: horizontalThumbRef,
            horizontalTrackRef: horizontalTrackRef,
            verticalTrackRef: verticalTrackRef,
            verticalThumbRef: verticalThumbRef,
            horizontalThumbSize: horizontalThumbSize,
            verticalThumbSize: verticalThumbSize
        };
    };
    const $a4792843849a449a$var$handleThumbMouseDown = (event)=>{
        event.stopPropagation();
    };
    const $a4792843849a449a$var$CustomScrollbarThumbTracks = ({ listWidth: listWidth, isHideScrollbar: isHideScrollbar, timelineTop: timelineTop, onSetScrollLeft: onSetScrollLeft, onSetScrollTop: onSetScrollTop }, ref)=>{
        const dragCache = (0, $5uXOq.useRef)((0, (0, parcelRequire("3SHG6")).DEFAULT_DRAG_CACHE));
        const { horizontalThumbRef: horizontalThumbRef, horizontalTrackRef: horizontalTrackRef, verticalTrackRef: verticalTrackRef, verticalThumbRef: verticalThumbRef, horizontalThumbSize: horizontalThumbSize, verticalThumbSize: verticalThumbSize } = $a4792843849a449a$var$useImperativeTracksAndThumbs({
            mainComponentRef: ref
        });
        const onStartDragHorizontalThumb = (0, $5uXOq.useCallback)(({ location: location })=>{
            if (!horizontalTrackRef.current || !horizontalThumbRef.current) throw new Error('An element required to drag the horizontal scroll thumb was null');
            const { left: left, width: width } = horizontalTrackRef.current.getBoundingClientRect();
            const thumbClientRect = horizontalThumbRef.current.getBoundingClientRect();
            const relativeMousePosition = location.initial.input.clientX - thumbClientRect.left;
            dragCache.current = {
                thumbOrigin: Math.round(horizontalThumbSize / 2 - relativeMousePosition),
                trackPosition: left,
                trackSize: width
            };
        }, [
            horizontalThumbRef,
            horizontalThumbSize,
            horizontalTrackRef
        ]);
        const onDragHorizontalThumb = (0, $5uXOq.useCallback)(({ location: location })=>{
            const { thumbOrigin: thumbOrigin, trackPosition: trackPosition, trackSize: trackSize } = dragCache.current;
            const relativeScrollPosition = (0, (0, parcelRequire("khH0q")).getRelativeScrollPosition)({
                thumbPosition: thumbOrigin + location.current.input.clientX,
                thumbSize: horizontalThumbSize,
                trackPosition: trackPosition,
                trackSize: trackSize
            });
            onSetScrollLeft(relativeScrollPosition);
        }, [
            horizontalThumbSize,
            onSetScrollLeft
        ]);
        const onMouseDownHorizontalTrack = (event)=>{
            const { left: left, width: width } = event.currentTarget.getBoundingClientRect();
            const relativeScrollPosition = (0, (0, parcelRequire("khH0q")).getRelativeScrollPosition)({
                thumbPosition: event.pageX,
                thumbSize: horizontalThumbSize,
                trackPosition: left,
                trackSize: width
            });
            onSetScrollLeft(relativeScrollPosition);
        };
        const onMouseDownVerticalTrack = (event)=>{
            const { top: top, height: height } = event.currentTarget.getBoundingClientRect();
            const relativeScrollPosition = (0, (0, parcelRequire("khH0q")).getRelativeScrollPosition)({
                thumbPosition: event.pageY,
                thumbSize: verticalThumbSize,
                trackPosition: top,
                trackSize: height
            });
            onSetScrollTop(relativeScrollPosition);
        };
        const onStartDragVerticalThumb = (0, $5uXOq.useCallback)(({ location: location })=>{
            if (!verticalTrackRef.current || !verticalThumbRef.current) throw new Error('An element required to drag the vertical scroll thumb was null');
            const { top: top, height: height } = verticalTrackRef.current.getBoundingClientRect();
            const thumbClientRect = verticalThumbRef.current.getBoundingClientRect();
            const relativeMousePosition = location.initial.input.clientY - thumbClientRect.top;
            dragCache.current = {
                thumbOrigin: Math.round(verticalThumbSize / 2 - relativeMousePosition),
                trackPosition: top,
                trackSize: height
            };
        }, [
            verticalThumbRef,
            verticalThumbSize,
            verticalTrackRef
        ]);
        const onDragVerticalThumb = (0, $5uXOq.useCallback)(({ location: location })=>{
            const { thumbOrigin: thumbOrigin, trackPosition: trackPosition, trackSize: trackSize } = dragCache.current;
            const relativeScrollPosition = (0, (0, parcelRequire("khH0q")).getRelativeScrollPosition)({
                thumbPosition: thumbOrigin + location.current.input.clientY,
                thumbSize: verticalThumbSize,
                trackPosition: trackPosition,
                trackSize: trackSize
            });
            onSetScrollTop(relativeScrollPosition);
        }, [
            verticalThumbSize,
            onSetScrollTop
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const horizontalThumb = horizontalThumbRef.current;
            (0, $3joPi.default)(horizontalThumb);
            return (0, $7gWdR.draggable)({
                element: horizontalThumb,
                onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                    (0, $hjhoK.disableNativeDragPreview)({
                        nativeSetDragImage: nativeSetDragImage
                    });
                    (0, $fmZmH.preventUnhandled).start();
                },
                onDragStart: onStartDragHorizontalThumb,
                onDrag: onDragHorizontalThumb
            });
        }, [
            onStartDragHorizontalThumb,
            onDragHorizontalThumb,
            horizontalThumbRef
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const verticalThumb = verticalThumbRef.current;
            (0, $3joPi.default)(verticalThumb);
            return (0, $7gWdR.draggable)({
                element: verticalThumb,
                onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                    (0, $hjhoK.disableNativeDragPreview)({
                        nativeSetDragImage: nativeSetDragImage
                    });
                    (0, $fmZmH.preventUnhandled).start();
                },
                onDragStart: onStartDragVerticalThumb,
                onDrag: onDragVerticalThumb
            });
        }, [
            onStartDragVerticalThumb,
            onDragVerticalThumb,
            verticalThumbRef
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: horizontalTrackRef,
            "data-testid": "roadmap.timeline-table.main.custom-scrollbars.thumb-tracks.horizontal-track",
            style: {
                left: `${listWidth + (0, (0, parcelRequire("3SHG6")).SCROLLBAR_OFFSET)}px`
            },
            onMouseDown: onMouseDownHorizontalTrack,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _2rko19bv _1pbyibnn _o7ks1fkz _irr31409 _1di61409",
                horizontalThumbSize > 0 && !isHideScrollbar ? "_3um0ewfl" : "_3um015vq",
                "_1xi21v6z _4t3i19bv _94n5idpf"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "roadmap.timeline-table.main.custom-scrollbars.thumb-tracks.horizontal-thumb",
            ref: horizontalThumbRef,
            onMouseDown: $a4792843849a449a$var$handleThumbMouseDown,
            style: {
                width: `${horizontalThumbSize}px`
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _2rko19bv _bfhkvrk4",
                "_4t3i1osq"
            ])
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: verticalTrackRef,
            "data-testid": "roadmap.timeline-table.main.custom-scrollbars.thumb-tracks.vertical-track",
            style: {
                top: `${timelineTop + (0, (0, parcelRequire("3SHG6")).SCROLLBAR_OFFSET)}px`
            },
            onMouseDown: onMouseDownVerticalTrack,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _2rko19bv _1pbyibnn _o7ks1fkz _irr31409 _1di61409",
                verticalThumbSize > 0 && !isHideScrollbar ? "_3um0ewfl" : "_3um015vq",
                "_94n51v6z _1bsb19bv _1xi2idpf"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "roadmap.timeline-table.main.custom-scrollbars.thumb-tracks.vertical-thumb",
            ref: verticalThumbRef,
            onMouseDown: $a4792843849a449a$var$handleThumbMouseDown,
            style: {
                height: `${verticalThumbSize}px`
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _2rko19bv _bfhkvrk4",
                "_1bsb1osq"
            ])
        })));
    };
    var $a4792843849a449a$export$2e2bcd8739ae039 = (0, $5uXOq.forwardRef)($a4792843849a449a$var$CustomScrollbarThumbTracks);
});
parcelRegister("csiwd", function(module, exports) {
    $parcel$export(module.exports, "getScrollbarSize", ()=>$2cd1680e9e2fd335$export$728dbf35b325565b);
    $parcel$export(module.exports, "getScrollOffsetRatio", ()=>$2cd1680e9e2fd335$export$1fb2953abd799768);
    $parcel$export(module.exports, "getContentToViewportRatio", ()=>$2cd1680e9e2fd335$export$e27ceda66fe97870);
    $parcel$export(module.exports, "getViewportOffsets", ()=>$2cd1680e9e2fd335$export$af20ae2261e1a891);
    var $8QpSo;
    const $2cd1680e9e2fd335$export$728dbf35b325565b = (scrollElement)=>scrollElement.offsetWidth - scrollElement.clientWidth;
    const $2cd1680e9e2fd335$export$1fb2953abd799768 = (scrollOffset, scrollSize, clientSize)=>scrollOffset / (scrollSize - clientSize);
    const $2cd1680e9e2fd335$export$e27ceda66fe97870 = (scrollSize, clientSize)=>clientSize / scrollSize;
    const $2cd1680e9e2fd335$export$af20ae2261e1a891 = (0, (0, parcelRequire("8QpSo")).default)((scrollbarSize, listWidth, timelineTop)=>({
            scrollbar: scrollbarSize,
            timelineLeft: listWidth,
            timelineTop: timelineTop
        }));
});
parcelRegister("4nLPh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$73bac808c32ccbec$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $4hDdm = parcelRequire("4hDdm");
    var $7gWdR = parcelRequire("7gWdR");
    var $iZN6h;
    var $WPwAA;
    var $3ruU1;
    var $lGdZu;
    var $7ouUj;
    const $73bac808c32ccbec$var$DragMonitor = ({ DndLongTaskMetric: DndLongTaskMetric })=>{
        const [{ isTreeDrag: isTreeDrag }] = (0, (0, parcelRequire("WPwAA")).useEnablements)();
        const [dragState, setDragState] = (0, $5uXOq.useState)({
            level: (0, (0, parcelRequire("iZN6h")).DEFAULT_LEVEL),
            isDragging: false
        });
        const { onRowDragStart: onRowDragStart, onRowDragEnd: onRowDragEnd, onRowDragOutOfBounds: onRowDragOutOfBounds } = (0, (0, parcelRequire("3ruU1")).useSideEffectMarshal)();
        const { onResize: onResize } = (0, (0, parcelRequire("lGdZu")).useTimelineViewportActions)();
        (0, $5uXOq.useEffect)(()=>(0, $4hDdm.combine)((0, $7gWdR.monitorForElements)({
                onDragStart: ({ source: source })=>{
                    const item = source.data;
                    if (item.type === (0, (0, parcelRequire("iZN6h")).ROW_DRAG_AND_DROP_ID)) {
                        onRowDragStart(item.id);
                        setDragState({
                            level: item.level,
                            isDragging: true
                        });
                    }
                },
                onDropTargetChange: ({ source: source, location: location })=>{
                    const item = source.data;
                    if (item.type === (0, (0, parcelRequire("iZN6h")).ROW_DRAG_AND_DROP_ID)) {
                        const { dropTargets: dropTargets } = location.current;
                        if (dropTargets.length === 0) onRowDragOutOfBounds(item.id);
                    }
                },
                onDrop: ({ source: source })=>{
                    const item = source.data;
                    if (item.type === (0, (0, parcelRequire("iZN6h")).ROW_DRAG_AND_DROP_ID)) {
                        onRowDragEnd(item.id);
                        setDragState({
                            level: item.level,
                            isDragging: false
                        });
                        if (isTreeDrag) onResize({
                            indicatorLineOffset: 0
                        });
                    }
                }
            })), [
            onRowDragStart,
            onRowDragEnd,
            onRowDragOutOfBounds,
            onResize,
            isTreeDrag
        ]);
        return DndLongTaskMetric ? (0, ($parcel$interopDefault($5uXOq))).createElement(DndLongTaskMetric, {
            isDragging: dragState.isDragging,
            metricType: (0, (0, parcelRequire("7ouUj")).isBaseLevel)(dragState.level) ? (0, (0, parcelRequire("iZN6h")).CHILD_LIST_DRAG_AND_DROP) : (0, (0, parcelRequire("iZN6h")).LIST_DRAG_AND_DROP)
        }) : null;
    };
    const $73bac808c32ccbec$var$DragMonitorEnabler = (props)=>{
        const [{ isDragEnabled: isDragEnabled }] = (0, (0, parcelRequire("WPwAA")).useEnablements)();
        return isDragEnabled ? (0, ($parcel$interopDefault($5uXOq))).createElement($73bac808c32ccbec$var$DragMonitor, props) : null;
    };
    var $73bac808c32ccbec$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($73bac808c32ccbec$var$DragMonitorEnabler);
});
parcelRegister("a79cp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b70bfe2d939251cd$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $l8ruj;
    var $iZN6h;
    var $g3prf;
    var $3Kr5N;
    var $iNpaX;
    var $7x4gL;
    var $bwj2C;
    const $b70bfe2d939251cd$var$headerContainerStyles = null;
    const $b70bfe2d939251cd$var$headerRowStyles = null;
    const $b70bfe2d939251cd$var$headerShadow = null;
    const $b70bfe2d939251cd$var$defaultBackground = null;
    const $b70bfe2d939251cd$var$Header = ({ renderListHeaderItem: renderListHeaderItem, renderChartHeaderItem: renderChartHeaderItem })=>{
        const [{ headerItems: headerItems, headerHeight: headerHeight, isRowCountKnown: isRowCountKnown }] = (0, (0, parcelRequire("g3prf")).useHeaderState)();
        const [isAtTop] = (0, (0, parcelRequire("3Kr5N")).isScrollToTop)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "timeline-table-header"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            role: "rowgroup",
            style: {
                height: headerHeight
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqsw1if8 _vchhusvi _1bsb1osq _154iidpf _11q7vuon _2rkoo8o8 _1pby1ial",
                !isAtTop && "_16qs157p"
            ])
        }, headerItems.map(({ height: height = (0, (0, parcelRequire("iZN6h")).DEFAULT_SUBHEADER_HEIGHT), id: id }, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                key: id,
                "data-testid": `roadmap.timeline-table.main.header.sub-header-${id.toLowerCase()}`,
                role: "row",
                "aria-rowindex": isRowCountKnown ? index + 1 : undefined,
                style: {
                    height: height
                },
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_kqswh2mm _1e0c1txw",
                    id === (0, (0, parcelRequire("iZN6h")).DEFAULT_HEADER_ROW_ID) && "_bfhk1s4m"
                ])
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bwj2C")).default), {
                id: id,
                itemHeight: height,
                renderListHeaderItem: renderListHeaderItem
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7x4gL")).ChartHeaderCell), {
                id: id,
                itemHeight: height,
                renderChartHeaderItem: renderChartHeaderItem
            }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iNpaX")).default), {
            isOverlayInHeader: true
        })));
    };
    $b70bfe2d939251cd$var$Header.displayName = 'Header';
    $b70bfe2d939251cd$var$Header.whyDidYouRender = true;
    var $b70bfe2d939251cd$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($b70bfe2d939251cd$var$Header);
});
parcelRegister("7x4gL", function(module, exports) {
    $parcel$export(module.exports, "ChartHeaderCell", ()=>$79e5f0136d703cf2$export$da889e50c82c0962);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $iZN6h;
    var $WPwAA;
    var $5BWo9;
    var $biT18;
    var $l5t89;
    const $79e5f0136d703cf2$var$defaultHeaderCellsContainer = null;
    const $79e5f0136d703cf2$var$subHeaderCellsContainer = null;
    const $79e5f0136d703cf2$export$da889e50c82c0962 = ({ id: id, itemHeight: itemHeight, renderChartHeaderItem: renderChartHeaderItem })=>{
        const [{ timelineWidth: timelineWidth, timelineMode: timelineMode, timelineDuration: timelineDuration, columnDurations: columnDurations, today: today }] = (0, (0, parcelRequire("biT18")).useTimelineState)();
        const [{ isHighlightToday: isHighlightToday }] = (0, (0, parcelRequire("WPwAA")).useEnablements)();
        const cellRef = (0, (0, parcelRequire("5BWo9")).useGridCell)(id, (0, (0, parcelRequire("iZN6h")).CHART_COLUMN_COORDINATE));
        if (id === (0, (0, parcelRequire("iZN6h")).DEFAULT_HEADER_ROW_ID)) return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                width: timelineWidth,
                height: itemHeight
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _vchhusvi _x3doh6cr _n7zlh6cr _1pby1ohn"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l5t89")).default), {
            today: today,
            timelineMode: timelineMode,
            timelineDuration: timelineDuration,
            columnDurations: columnDurations,
            isHighlightToday: isHighlightToday
        }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: cellRef,
            role: "gridcell",
            tabIndex: -1,
            style: {
                width: timelineWidth,
                height: itemHeight
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _vchhusvi _1e0c1txw _4cvr1h6o _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _n7zlh6cr _1pby1ohn _nt751r31 _49pcglyw _1hvw1o36 _1ejj168b"
            ])
        }, renderChartHeaderItem({
            id: id
        }));
    };
});
parcelRegister("l5t89", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$36f809feb4beb8ef$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $cSD7y;
    var $iZN6h;
    var $iwcO1;
    var $lztNT;
    var $fFQYa;
    var $E9dZI;
    var $gORsc;
    var $ayXBh;
    const $36f809feb4beb8ef$var$containerStyles = null;
    const $36f809feb4beb8ef$var$ChartCalendarCellsNew = ({ isHighlightToday: isHighlightToday, today: today, timelineMode: timelineMode, timelineDuration: timelineDuration, columnDurations: columnDurations })=>{
        const todayColumnIndex = (0, (0, parcelRequire("iwcO1")).getTodayColumnIndex)(today, columnDurations);
        const getIsHighlighted = (0, $5uXOq.useCallback)((index)=>isHighlightToday && todayColumnIndex === index, [
            isHighlightToday,
            todayColumnIndex
        ]);
        const renderWeekCells = (0, $5uXOq.useCallback)((columnPositions)=>{
            const todayCoordinates = isHighlightToday ? (0, (0, parcelRequire("lztNT")).getTodayCoordinates)(today, columnDurations) : undefined;
            const columnWeekNumbers = (0, (0, parcelRequire("lztNT")).getColumnWeekNumbers)(columnDurations);
            const yearCaptions = (0, (0, parcelRequire("lztNT")).getColumnYearCaptions)(today, columnDurations);
            return columnPositions.map(([left, right], index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fFQYa")).CalendarCellWrapper), {
                    key: index,
                    left: left,
                    right: right,
                    column: index
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ayXBh")).default), {
                    columnIndex: index,
                    isHighlightToday: isHighlightToday,
                    todayCoordinates: todayCoordinates,
                    weekNumbers: columnWeekNumbers[index],
                    yearCaption: yearCaptions[index],
                    isHighlighted: getIsHighlighted(index)
                })));
        }, [
            isHighlightToday,
            today,
            columnDurations,
            getIsHighlighted
        ]);
        const renderMonthCells = (0, $5uXOq.useCallback)((columnPositions)=>{
            const columnMonthNumbers = (0, (0, parcelRequire("lztNT")).getColumnMonthNumbers)(columnDurations);
            const yearCaptions = (0, (0, parcelRequire("lztNT")).getColumnYearCaptions)(today, columnDurations);
            return columnPositions.map(([left, right], index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fFQYa")).CalendarCellWrapper), {
                    key: index,
                    left: left,
                    right: right,
                    column: index
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("E9dZI")).default), {
                    monthNumber: columnMonthNumbers[index],
                    yearCaption: yearCaptions[index],
                    isHighlighted: getIsHighlighted(index)
                })));
        }, [
            columnDurations,
            today,
            getIsHighlighted
        ]);
        const renderQuarterCells = (0, $5uXOq.useCallback)((columnPositions)=>{
            const columnQuarterNumbers = (0, (0, parcelRequire("lztNT")).getColumnQuarterNumbers)(columnDurations);
            const yearCaptions = (0, (0, parcelRequire("lztNT")).getColumnYearCaptions)(today, columnDurations);
            return columnPositions.map(([left, right], index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fFQYa")).CalendarCellWrapper), {
                    key: index,
                    left: left,
                    right: right,
                    column: index
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gORsc")).default), {
                    quarterNumber: columnQuarterNumbers[index],
                    yearCaption: yearCaptions[index],
                    isHighlighted: getIsHighlighted(index)
                })));
        }, [
            columnDurations,
            today,
            getIsHighlighted
        ]);
        const renderColumnsForMode = (0, $5uXOq.useCallback)(()=>{
            const columnPositions = (0, (0, parcelRequire("iwcO1")).getColumnPositions)(timelineDuration, columnDurations);
            if (timelineMode === (0, (0, parcelRequire("iZN6h")).WEEKS)) return renderWeekCells(columnPositions);
            if (timelineMode === (0, (0, parcelRequire("iZN6h")).MONTHS)) return renderMonthCells(columnPositions);
            return renderQuarterCells(columnPositions);
        }, [
            timelineMode,
            columnDurations,
            timelineDuration,
            renderWeekCells,
            renderMonthCells,
            renderQuarterCells
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _1bsb1osq _4t3i1osq"
            ])
        }, renderColumnsForMode());
    };
    const $36f809feb4beb8ef$var$ChartCalendarCellsOld = ({ isHighlightToday: isHighlightToday, today: today, timelineMode: timelineMode, timelineDuration: timelineDuration, columnDurations: columnDurations })=>{
        const renderWeekCells = (0, $5uXOq.useCallback)((columnPositions)=>{
            const todayCoordinates = isHighlightToday ? (0, (0, parcelRequire("lztNT")).getTodayCoordinates)(today, columnDurations) : undefined;
            const columnWeekNumbers = (0, (0, parcelRequire("lztNT")).getColumnWeekNumbers)(columnDurations);
            const yearCaptions = (0, (0, parcelRequire("lztNT")).getColumnYearCaptions)(today, columnDurations);
            return columnPositions.map(([left, right], index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fFQYa")).CalendarCellWrapper), {
                    key: index,
                    left: left,
                    right: right,
                    column: index
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ayXBh")).default), {
                    columnIndex: index,
                    isHighlightToday: isHighlightToday,
                    todayCoordinates: todayCoordinates,
                    weekNumbers: columnWeekNumbers[index],
                    yearCaption: yearCaptions[index]
                })));
        }, [
            isHighlightToday,
            today,
            columnDurations
        ]);
        const renderMonthCells = (0, $5uXOq.useCallback)((columnPositions)=>{
            const columnMonthNumbers = (0, (0, parcelRequire("lztNT")).getColumnMonthNumbers)(columnDurations);
            const yearCaptions = (0, (0, parcelRequire("lztNT")).getColumnYearCaptions)(today, columnDurations);
            return columnPositions.map(([left, right], index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fFQYa")).CalendarCellWrapper), {
                    key: index,
                    left: left,
                    right: right,
                    column: index
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("E9dZI")).default), {
                    monthNumber: columnMonthNumbers[index],
                    yearCaption: yearCaptions[index]
                })));
        }, [
            today,
            columnDurations
        ]);
        const renderQuarterCells = (0, $5uXOq.useCallback)((columnPositions)=>{
            const columnQuarterNumbers = (0, (0, parcelRequire("lztNT")).getColumnQuarterNumbers)(columnDurations);
            const yearCaptions = (0, (0, parcelRequire("lztNT")).getColumnYearCaptions)(today, columnDurations);
            return columnPositions.map(([left, right], index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fFQYa")).CalendarCellWrapper), {
                    key: index,
                    left: left,
                    right: right,
                    column: index
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gORsc")).default), {
                    quarterNumber: columnQuarterNumbers[index],
                    yearCaption: yearCaptions[index]
                })));
        }, [
            today,
            columnDurations
        ]);
        const renderColumnsForMode = (0, $5uXOq.useCallback)(()=>{
            const columnPositions = (0, (0, parcelRequire("iwcO1")).getColumnPositions)(timelineDuration, columnDurations);
            if (timelineMode === (0, (0, parcelRequire("iZN6h")).WEEKS)) return renderWeekCells(columnPositions);
            if (timelineMode === (0, (0, parcelRequire("iZN6h")).MONTHS)) return renderMonthCells(columnPositions);
            return renderQuarterCells(columnPositions);
        }, [
            timelineMode,
            columnDurations,
            timelineDuration,
            renderWeekCells,
            renderMonthCells,
            renderQuarterCells
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _1bsb1osq _4t3i1osq"
            ])
        }, renderColumnsForMode());
    };
    $36f809feb4beb8ef$var$ChartCalendarCellsNew.whyDidYouRender = true;
    $36f809feb4beb8ef$var$ChartCalendarCellsOld.whyDidYouRender = true;
    const $36f809feb4beb8ef$var$ChartCalendarCells = (0, (0, parcelRequire("cSD7y")).componentWithFG)('jsw_roadmaps_timeline-gridcell-header-contrast', $36f809feb4beb8ef$var$ChartCalendarCellsNew, $36f809feb4beb8ef$var$ChartCalendarCellsOld);
    $36f809feb4beb8ef$var$ChartCalendarCells.displayName = 'ChartCalendarCells';
    var $36f809feb4beb8ef$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($36f809feb4beb8ef$var$ChartCalendarCells);
});
parcelRegister("lztNT", function(module, exports) {
    $parcel$export(module.exports, "getColumnMonthNumbers", ()=>$23b15552ebbcdf45$export$2db9691736ad99a0);
    $parcel$export(module.exports, "getColumnQuarterNumbers", ()=>$23b15552ebbcdf45$export$f8f2585f7189f116);
    $parcel$export(module.exports, "getColumnYearCaptions", ()=>$23b15552ebbcdf45$export$318e116da7ff1363);
    $parcel$export(module.exports, "getColumnWeekNumbers", ()=>$23b15552ebbcdf45$export$a1fb8a69eea17cba);
    $parcel$export(module.exports, "getTodayCoordinates", ()=>$23b15552ebbcdf45$export$1c186d1bc45d38b7);
    var $8QpSo;
    var $2gnC5 = parcelRequire("2gnC5");
    var $iwcO1;
    const $23b15552ebbcdf45$export$2db9691736ad99a0 = (0, (0, parcelRequire("8QpSo")).default)((columnDurations)=>columnDurations.map((columnDuration)=>(0, ($parcel$interopDefault($2gnC5))).utc(columnDuration.startMilliseconds).month()));
    const $23b15552ebbcdf45$export$f8f2585f7189f116 = (0, (0, parcelRequire("8QpSo")).default)((columnDurations)=>columnDurations.map((columnDuration)=>(0, ($parcel$interopDefault($2gnC5))).utc(columnDuration.startMilliseconds).quarter() - 1));
    const $23b15552ebbcdf45$export$318e116da7ff1363 = (0, (0, parcelRequire("8QpSo")).default)((today, columnDurations)=>{
        const startOfCurrentYear = (0, ($parcel$interopDefault($2gnC5))).utc(today).startOf('year').valueOf();
        const endOfCurrentYear = (0, ($parcel$interopDefault($2gnC5))).utc(today).endOf('year').valueOf();
        let cachedYear;
        let nextYear;
        return columnDurations.map(({ startMilliseconds: startMilliseconds })=>{
            if (startMilliseconds < startOfCurrentYear || startMilliseconds > endOfCurrentYear) {
                if (!cachedYear || startMilliseconds >= nextYear) {
                    const columnMoment = (0, ($parcel$interopDefault($2gnC5))).utc(startMilliseconds);
                    cachedYear = `'${columnMoment.year().toString().slice(2)}`;
                    nextYear = columnMoment.add(1, 'year').startOf('year').valueOf();
                }
                return cachedYear;
            }
            return undefined;
        });
    });
    const $23b15552ebbcdf45$export$a1fb8a69eea17cba = (0, (0, parcelRequire("8QpSo")).default)((columnDurations)=>{
        const daysArray = [
            ...new Array(7)
        ];
        return columnDurations.map(({ startMilliseconds: startMilliseconds })=>{
            const columnMoment = (0, ($parcel$interopDefault($2gnC5))).utc(startMilliseconds);
            const weekNumbers = daysArray.map(()=>{
                const data = {
                    day: columnMoment.date(),
                    month: columnMoment.month()
                };
                columnMoment.add(1, 'day');
                return data;
            });
            return weekNumbers;
        });
    });
    const $23b15552ebbcdf45$export$1c186d1bc45d38b7 = (0, (0, parcelRequire("8QpSo")).default)((today, columnDurations)=>{
        let todayDayIndex = 0;
        const todayNumber = (0, ($parcel$interopDefault($2gnC5))).utc(today).date();
        const todayColumnIndex = (0, (0, parcelRequire("iwcO1")).getTodayColumnIndex)(today, columnDurations);
        const weekNumbers = $23b15552ebbcdf45$export$a1fb8a69eea17cba(columnDurations);
        const weekOfToday = weekNumbers[todayColumnIndex];
        weekOfToday.forEach((weekNumber, index)=>{
            if (weekNumber.day === todayNumber) todayDayIndex = index;
        });
        return [
            todayColumnIndex,
            todayDayIndex
        ];
    });
});
parcelRegister("fFQYa", function(module, exports) {
    $parcel$export(module.exports, "CalendarCellWrapper", ()=>$6a1307db1731318b$export$68256deaaec8dcee);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $iZN6h;
    var $5BWo9;
    const $6a1307db1731318b$var$wrapperStyles = null;
    const $6a1307db1731318b$export$68256deaaec8dcee = ({ left: left, right: right, column: column, children: children })=>{
        const cellRef = (0, (0, parcelRequire("5BWo9")).useGridCell)((0, (0, parcelRequire("iZN6h")).DEFAULT_HEADER_ROW_ID), (0, (0, parcelRequire("iZN6h")).CHART_COLUMN_COORDINATE) + column);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: cellRef,
            role: "columnheader",
            tabIndex: -1,
            style: {
                left: `${left}%`,
                right: `${right}%`
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _154ize3t _94n5ze3t _16jlidpf _1o9zidpf _i0dl1wug _1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _vchhusvi _nt751r31 _49pcglyw _1hvw1o36 _1ejj168b"
            ])
        }, children);
    };
});
parcelRegister("E9dZI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e20f87b556e66ee7$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $4R6GH;
    var $dCm1o;
    var $kGL3e;
    const $e20f87b556e66ee7$var$headerStyles = null;
    const $e20f87b556e66ee7$var$headerTextTransformStyles = null;
    const $e20f87b556e66ee7$var$contrastStyles = null;
    const $e20f87b556e66ee7$var$MonthCell = ({ monthNumber: monthNumber, yearCaption: yearCaption, isHighlighted: isHighlighted })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("small", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11c8qk37 _k48p1wq8 _syaz1rc1 _19pkidpf",
                !(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && "_1p1dangw",
                isHighlighted && (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-gridcell-header-contrast') && "_syaz1x9z"
            ])
        }, formatMessage((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? (0, (0, parcelRequire("kGL3e")).inMonthOrder)[monthNumber] : (0, (0, parcelRequire("kGL3e")).inMonthOrderOld)[monthNumber]), ' ', yearCaption);
    };
    $e20f87b556e66ee7$var$MonthCell.defaultProps = {
        yearCaption: null
    };
    var $e20f87b556e66ee7$export$2e2bcd8739ae039 = $e20f87b556e66ee7$var$MonthCell;
});
parcelRegister("kGL3e", function(module, exports) {
    $parcel$export(module.exports, "inMonthOrder", ()=>$ad857913bcc6dfb7$export$12c2656d1700ed6e);
    $parcel$export(module.exports, "inMonthOrderOld", ()=>$ad857913bcc6dfb7$export$21620c71d33a251c);
    $parcel$export(module.exports, "inQuarterOrder", ()=>$ad857913bcc6dfb7$export$62f5e462247f69c8);
    $parcel$export(module.exports, "inQuarterOrderOld", ()=>$ad857913bcc6dfb7$export$51eb1b094826ff0c);
    var $7VHMR;
    const $ad857913bcc6dfb7$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        january: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.january',
            defaultMessage: 'January',
            description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Header for the month of January'
        },
        february: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.february',
            defaultMessage: 'February',
            description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Header for the month of February'
        },
        march: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.march',
            defaultMessage: 'March',
            description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Header for the month of March'
        },
        april: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.april',
            defaultMessage: 'April',
            description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Header for the month of April'
        },
        may: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.may',
            defaultMessage: 'May',
            description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Header for the month of May'
        },
        june: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.june',
            defaultMessage: 'June',
            description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Header for the month of June'
        },
        july: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.july',
            defaultMessage: 'July',
            description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Header for the month of July'
        },
        august: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.august',
            defaultMessage: 'August',
            description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Header for the month of August'
        },
        september: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.september',
            defaultMessage: 'September',
            description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Header for the month of September'
        },
        october: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.october',
            defaultMessage: 'October',
            description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Header for the month of October'
        },
        november: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.november',
            defaultMessage: 'November',
            description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Header for the month of November'
        },
        december: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.december',
            defaultMessage: 'December',
            description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Header for the month of December'
        },
        januaryOld: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.january-old',
            defaultMessage: 'Jan',
            description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Abbreviation for the month of January'
        },
        februaryOld: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.february-old',
            defaultMessage: 'Feb',
            description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Abbreviation for the month of February'
        },
        marchOld: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.march-old',
            defaultMessage: 'Mar',
            description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Abbreviation for the month of March'
        },
        aprilOld: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.april-old',
            defaultMessage: 'Apr',
            description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Abbreviation for the month of April'
        },
        mayOld: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.may-old',
            defaultMessage: 'May',
            description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Abbreviation for the month of May'
        },
        juneOld: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.june-old',
            defaultMessage: 'Jun',
            description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Abbreviation for the month of June'
        },
        julyOld: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.july-old',
            defaultMessage: 'Jul',
            description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Abbreviation for the month of July'
        },
        augustOld: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.august-old',
            defaultMessage: 'Aug',
            description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Abbreviation for the month of August'
        },
        septemberOld: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.september-old',
            defaultMessage: 'Sep',
            description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Abbreviation for the month of September'
        },
        octoberOld: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.october-old',
            defaultMessage: 'Oct',
            description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Abbreviation for the month of October'
        },
        novemberOld: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.november-old',
            defaultMessage: 'Nov',
            description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Abbreviation for the month of November'
        },
        decemberOld: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.december-old',
            defaultMessage: 'Dec',
            description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Abbreviation for the month of December'
        },
        monday: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.monday',
            defaultMessage: 'M',
            description: 'Column sub-heading text. High fidelity visual guide for a users relative position timeline. Proper noun. Abbreviation for the day of Monday'
        },
        tuesday: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.tuesday',
            defaultMessage: 'T',
            description: 'Column sub-heading text. High fidelity visual guide for a users relative position timeline. Proper noun. Abbreviation for the day of Tuesday'
        },
        wednesday: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.wednesday',
            defaultMessage: 'W',
            description: 'Column sub-heading text. High fidelity visual guide for a users relative position timeline. Proper noun. Abbreviation for the day of Wednesday'
        },
        thursday: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.thursday',
            defaultMessage: 'T',
            description: 'Column sub-heading text. High fidelity visual guide for a users relative position timeline. Proper noun. Abbreviation for the day of Thursday'
        },
        friday: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.friday',
            defaultMessage: 'F',
            description: 'Column sub-heading text. High fidelity visual guide for a users relative position timeline. Proper noun. Abbreviation for the day of Friday'
        },
        saturday: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.saturday',
            defaultMessage: 'S',
            description: 'Column sub-heading text. High fidelity visual guide for a users relative position timeline. Proper noun. Abbreviation for the day of Saturday'
        },
        sunday: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.sunday',
            defaultMessage: 'S',
            description: 'Column sub-heading text. High fidelity visual guide for a users relative position timeline. Proper noun. Abbreviation for the day of Sunday'
        }
    });
    const $ad857913bcc6dfb7$export$b7dd7c64470aa506 = [
        $ad857913bcc6dfb7$var$messages.monday,
        $ad857913bcc6dfb7$var$messages.tuesday,
        $ad857913bcc6dfb7$var$messages.wednesday,
        $ad857913bcc6dfb7$var$messages.thursday,
        $ad857913bcc6dfb7$var$messages.friday,
        $ad857913bcc6dfb7$var$messages.saturday,
        $ad857913bcc6dfb7$var$messages.sunday
    ];
    const $ad857913bcc6dfb7$export$12c2656d1700ed6e = [
        $ad857913bcc6dfb7$var$messages.january,
        $ad857913bcc6dfb7$var$messages.february,
        $ad857913bcc6dfb7$var$messages.march,
        $ad857913bcc6dfb7$var$messages.april,
        $ad857913bcc6dfb7$var$messages.may,
        $ad857913bcc6dfb7$var$messages.june,
        $ad857913bcc6dfb7$var$messages.july,
        $ad857913bcc6dfb7$var$messages.august,
        $ad857913bcc6dfb7$var$messages.september,
        $ad857913bcc6dfb7$var$messages.october,
        $ad857913bcc6dfb7$var$messages.november,
        $ad857913bcc6dfb7$var$messages.december
    ];
    const $ad857913bcc6dfb7$export$21620c71d33a251c = [
        $ad857913bcc6dfb7$var$messages.januaryOld,
        $ad857913bcc6dfb7$var$messages.februaryOld,
        $ad857913bcc6dfb7$var$messages.marchOld,
        $ad857913bcc6dfb7$var$messages.aprilOld,
        $ad857913bcc6dfb7$var$messages.mayOld,
        $ad857913bcc6dfb7$var$messages.juneOld,
        $ad857913bcc6dfb7$var$messages.julyOld,
        $ad857913bcc6dfb7$var$messages.augustOld,
        $ad857913bcc6dfb7$var$messages.septemberOld,
        $ad857913bcc6dfb7$var$messages.octoberOld,
        $ad857913bcc6dfb7$var$messages.novemberOld,
        $ad857913bcc6dfb7$var$messages.decemberOld
    ];
    const $ad857913bcc6dfb7$export$62f5e462247f69c8 = [
        {
            startMonth: $ad857913bcc6dfb7$var$messages.january,
            endMonth: $ad857913bcc6dfb7$var$messages.march
        },
        {
            startMonth: $ad857913bcc6dfb7$var$messages.april,
            endMonth: $ad857913bcc6dfb7$var$messages.june
        },
        {
            startMonth: $ad857913bcc6dfb7$var$messages.july,
            endMonth: $ad857913bcc6dfb7$var$messages.september
        },
        {
            startMonth: $ad857913bcc6dfb7$var$messages.october,
            endMonth: $ad857913bcc6dfb7$var$messages.december
        }
    ];
    const $ad857913bcc6dfb7$export$51eb1b094826ff0c = [
        {
            startMonth: $ad857913bcc6dfb7$var$messages.januaryOld,
            endMonth: $ad857913bcc6dfb7$var$messages.marchOld
        },
        {
            startMonth: $ad857913bcc6dfb7$var$messages.aprilOld,
            endMonth: $ad857913bcc6dfb7$var$messages.juneOld
        },
        {
            startMonth: $ad857913bcc6dfb7$var$messages.julyOld,
            endMonth: $ad857913bcc6dfb7$var$messages.septemberOld
        },
        {
            startMonth: $ad857913bcc6dfb7$var$messages.octoberOld,
            endMonth: $ad857913bcc6dfb7$var$messages.decemberOld
        }
    ];
    var $ad857913bcc6dfb7$export$2e2bcd8739ae039 = $ad857913bcc6dfb7$var$messages;
});
parcelRegister("gORsc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$25c5a578600dd859$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $4R6GH;
    var $dCm1o;
    var $kGL3e;
    const $25c5a578600dd859$var$headerStyles = null;
    const $25c5a578600dd859$var$headerTextTransformStyles = null;
    const $25c5a578600dd859$var$contrastStyles = null;
    const $25c5a578600dd859$var$QuarterCell = ({ quarterNumber: quarterNumber, yearCaption: yearCaption, isHighlighted: isHighlighted })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { startMonth: startMonth, endMonth: endMonth } = (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? (0, (0, parcelRequire("kGL3e")).inQuarterOrder)[quarterNumber] : (0, (0, parcelRequire("kGL3e")).inQuarterOrderOld)[quarterNumber];
        return (0, ($parcel$interopDefault($5uXOq))).createElement("small", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11c8qk37 _syaz1rc1 _19pkidpf",
                !(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && "_1p1dangw",
                isHighlighted && (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-gridcell-header-contrast') && "_syaz1x9z"
            ])
        }, `${formatMessage(startMonth)} \u{2013} ${formatMessage(endMonth)}`, " ", yearCaption);
    };
    $25c5a578600dd859$var$QuarterCell.defaultProps = {
        yearCaption: null
    };
    var $25c5a578600dd859$export$2e2bcd8739ae039 = $25c5a578600dd859$var$QuarterCell;
});
parcelRegister("ayXBh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9dee9da93d060bfb$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $dC5iT;
    var $8CUq3;
    var $4R6GH;
    var $dCm1o;
    var $kGL3e;
    const $9dee9da93d060bfb$var$dayWidth = 1 / 7 * 100;
    const $9dee9da93d060bfb$var$headerStyles = null;
    const $9dee9da93d060bfb$var$headerTextTransformStyles = null;
    const $9dee9da93d060bfb$var$dayContainerStylesOld = null;
    const $9dee9da93d060bfb$var$dayChildTodayStylesOld = null;
    const $9dee9da93d060bfb$var$dayContainerStyles = null;
    const $9dee9da93d060bfb$var$dayChildWeekendStyles = null;
    const $9dee9da93d060bfb$var$dayChildTodayStyles = null;
    const $9dee9da93d060bfb$var$dayChildStyles = null;
    const $9dee9da93d060bfb$var$dayChildHighlightedStyles = null;
    const $9dee9da93d060bfb$var$WeekCell = ({ columnIndex: columnIndex, weekNumbers: weekNumbers, todayCoordinates: todayCoordinates, yearCaption: yearCaption, isHighlightToday: isHighlightToday, isHighlighted: isHighlighted })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const monthNumber = weekNumbers[3].month;
        const todayIndex = weekNumbers.findIndex((element, i)=>isHighlightToday && todayCoordinates && todayCoordinates[0] === columnIndex && todayCoordinates[1] === i);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("small", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pk1b66 _11c81vlj _syaz1rc1",
                !(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && "_1p1dangw"
            ])
        }, (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-gridcell-header-contrast') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            as: "span",
            xcss: [
                isHighlighted && (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-gridcell-header-contrast') && $9dee9da93d060bfb$var$contrastStyles
            ]
        }, formatMessage((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? (0, (0, parcelRequire("kGL3e")).inMonthOrder)[monthNumber] : (0, (0, parcelRequire("kGL3e")).inMonthOrderOld)[monthNumber]), ' ', yearCaption) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? (0, (0, parcelRequire("kGL3e")).inMonthOrder)[monthNumber] : (0, (0, parcelRequire("kGL3e")).inMonthOrderOld)[monthNumber]), ' ', yearCaption)), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                !(0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-gridcell-header-contrast') && "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dl1wug _4cvr1h6o _1bsb1osq _4t3i1y7b _e2oo14zn _1sc11vlj _13t319ii _15ai1h6o _c8i51hna _k907c5fp _kgm11nxw _1tjq1rc1 _1e85hkel _1pzyhkel _1fl41sit _u2op1sit",
                (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-gridcell-header-contrast') && "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dl1wug _4cvr1h6o _1bsb1osq _4t3i1y7b"
            ])
        }, weekNumbers.map(({ day: day }, dayIndex)=>(0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-gridcell-header-contrast') ? (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                key: `week-number-${dayIndex}`,
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_1bsb14zn _11c81vlj _y3gn1h6o _1i4q1hna _18s8c5fp _1yt41nxw _syaz1rc1",
                    (dayIndex === 5 || dayIndex === 6) && "_bfhkhkel _2rko1sit",
                    isHighlighted && "_syaz16ez",
                    todayIndex === dayIndex && "_2rko1sit _bfhk1hdx _syaz1pqp"
                ])
            }, day) : (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                key: `week-number-${dayIndex}`,
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    todayIndex === dayIndex && "_2rko1sit _bfhk1hdx _syazkmhu"
                ])
            }, day))));
    };
    const $9dee9da93d060bfb$var$contrastStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.text.accent.gray.bolder'
    });
    $9dee9da93d060bfb$var$WeekCell.defaultProps = {
        yearCaption: null
    };
    var $9dee9da93d060bfb$export$2e2bcd8739ae039 = $9dee9da93d060bfb$var$WeekCell;
});
parcelRegister("bwj2C", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$db4ac71a2cd48743$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $iZN6h;
    var $9puhl;
    var $5BWo9;
    const $db4ac71a2cd48743$var$rowHeaderCellStyles = null;
    const $db4ac71a2cd48743$var$dateRowHeaderContainerStyles = null;
    const $db4ac71a2cd48743$var$subRowHeaderContainerStyles = null;
    const $db4ac71a2cd48743$var$ListHeaderCell = ({ id: id, itemHeight: itemHeight, renderListHeaderItem: renderListHeaderItem })=>{
        const [listWidth] = (0, (0, parcelRequire("9puhl")).useListWidth)();
        const isDefaultHeader = id === (0, (0, parcelRequire("iZN6h")).DEFAULT_HEADER_ROW_ID);
        const cellRef = (0, (0, parcelRequire("5BWo9")).useGridCell)(id, (0, (0, parcelRequire("iZN6h")).LIST_COLUMN_COORDINATE), isDefaultHeader);
        const tabIndex = isDefaultHeader ? 0 : -1;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: cellRef,
            role: "rowheader",
            tabIndex: tabIndex,
            style: {
                width: `${listWidth}px`,
                height: `${itemHeight}px`
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqsw1if8 _16jlidpf _1o9zidpf _i0dl1wug _1ltvidpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _bfhkvuon _2rkoo8o8 _1pby1ial _nt751r31 _49pcglyw _1hvw1o36 _1ejj168b"
            ])
        }, id === (0, (0, parcelRequire("iZN6h")).DEFAULT_HEADER_ROW_ID) ? (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _vchhusvi _1bsb1osq _4t3i1osq _bfhk1s4m _2rkoo8o8 _x3doh6cr _n7zlh6cr"
            ])
        }, renderListHeaderItem({
            id: id
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _1e0c1txw _16jlidpf _1o9zidpf _i0dl1wug _4cvr1h6o _vchhusvi _1bsb1osq _4t3i1osq _1yt4pn94 _n7zlh6cr"
            ])
        }, renderListHeaderItem({
            id: id
        })));
    };
    var $db4ac71a2cd48743$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($db4ac71a2cd48743$var$ListHeaderCell);
});
parcelRegister("2MYv1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1e827aea62556d07$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $k8IPx = parcelRequire("k8IPx");
    var $8GOx7 = parcelRequire("8GOx7");
    var $ajpes = parcelRequire("ajpes");
    var $hGh1Z;
    var $3ruU1;
    const $1e827aea62556d07$export$130b459525f81fe1 = ()=>{
        const [selectedItemIds] = (0, (0, parcelRequire("hGh1Z")).useSelectedItemIds)();
        const [activeItemId] = (0, (0, parcelRequire("hGh1Z")).useActiveItemId)();
        const { onRowSelect: onRowSelect, onRowDeselect: onRowDeselect } = (0, (0, parcelRequire("3ruU1")).useSideEffectMarshal)();
        const highlighted = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($8GOx7)))(selectedItemIds.concat(activeItemId ? [
                activeItemId
            ] : [])), [
            selectedItemIds,
            activeItemId
        ]);
        const prevHighlighted = (0, $5uXOq.useRef)(highlighted);
        (0, $5uXOq.useEffect)(()=>{
            const toBeDehighlighted = (0, ($parcel$interopDefault($k8IPx)))(prevHighlighted.current, highlighted);
            onRowDeselect(toBeDehighlighted);
            onRowSelect(highlighted);
        }, [
            selectedItemIds,
            onRowSelect,
            onRowDeselect,
            highlighted
        ]);
        (0, $5uXOq.useEffect)(()=>{
            prevHighlighted.current = highlighted;
        }, [
            highlighted
        ]);
        return null;
    };
    var $1e827aea62556d07$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($1e827aea62556d07$export$130b459525f81fe1, (0, ($parcel$interopDefault($ajpes))));
});
parcelRegister("8GOx7", function(module, exports) {
    var $lVx1a = parcelRequire("lVx1a");
    var $653971d100474755$var$func = $lVx1a('uniq', (parcelRequire("kGsr8")), (parcelRequire("bUoRH")));
    $653971d100474755$var$func.placeholder = (parcelRequire("aPsMW"));
    module.exports = $653971d100474755$var$func;
});
parcelRegister("bUoRH", function(module, exports) {
    module.exports = {
        'cap': false,
        'curry': false,
        'fixed': false,
        'immutable': false,
        'rearg': false
    };
});
parcelRegister("aaAik", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$75e273f76ce6f6de$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $k8IPx = parcelRequire("k8IPx");
    var $ajpes = parcelRequire("ajpes");
    var $3ruU1;
    const $75e273f76ce6f6de$var$ItemsSelector = ({ selectedItemIds: selectedItemIds })=>{
        const { onRowSelect: onRowSelect, onRowDeselect: onRowDeselect } = (0, (0, parcelRequire("3ruU1")).useSideEffectMarshal)();
        const previousSelectedItemIds = (0, $5uXOq.useRef)(selectedItemIds);
        (0, $5uXOq.useEffect)(()=>{
            const unselectedItemIds = (0, ($parcel$interopDefault($k8IPx)))(previousSelectedItemIds.current, selectedItemIds);
            onRowDeselect(unselectedItemIds);
            onRowSelect(selectedItemIds);
        }, [
            previousSelectedItemIds,
            selectedItemIds,
            onRowSelect,
            onRowDeselect
        ]);
        (0, $5uXOq.useEffect)(()=>{
            previousSelectedItemIds.current = selectedItemIds;
        }, [
            selectedItemIds
        ]);
        return null;
    };
    var $75e273f76ce6f6de$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($75e273f76ce6f6de$var$ItemsSelector, (0, ($parcel$interopDefault($ajpes))));
});
parcelRegister("cdyDR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$359ceda11fd51304$export$2e2bcd8739ae039);
    var $bwpsq;
    var $lD23V;
    var $5uXOq = parcelRequire("5uXOq");
    var $9puhl;
    var $jfF8l;
    const $359ceda11fd51304$var$containerStyles = null;
    const $359ceda11fd51304$var$listContainerStyles = null;
    const $359ceda11fd51304$var$Borders = ()=>{
        const [listWidth] = (0, (0, parcelRequire("9puhl")).useListWidth)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _154iidpf _94n5idpf _1ltvidpf _1bsb1osq _1pby1ial _lcxvglyw"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqsw1if8 _vchhusvi _1ltvidpf _4t3i1osq _2rkoo8o8 _1s7z9fei _1kl71hum"
            ]),
            style: {
                width: `${listWidth}px`,
                "--_drom5x": (0, (0, parcelRequire("lD23V")).default)((0, (0, parcelRequire("jfF8l")).secondaryBorderColor)),
                "--_1p5ufam": (0, (0, parcelRequire("lD23V")).default)((0, (0, parcelRequire("jfF8l")).secondaryBorder))
            }
        }));
    };
    var $359ceda11fd51304$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($359ceda11fd51304$var$Borders);
});
parcelRegister("lTlao", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3e9230eea482b27b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9puhl;
    var $cC9dj;
    var $73Gyu;
    const $3e9230eea482b27b$var$StaticOverlay = ({ renderChartOverlay: renderChartOverlay })=>{
        const [listWidth] = (0, (0, parcelRequire("9puhl")).useListWidth)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("73Gyu")).default), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cC9dj")).default), {
            listWidth: listWidth,
            renderChartOverlay: renderChartOverlay
        }));
    };
    $3e9230eea482b27b$var$StaticOverlay.displayName = 'StaticOverlay';
    $3e9230eea482b27b$var$StaticOverlay.whyDidYouRender = true;
    var $3e9230eea482b27b$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($3e9230eea482b27b$var$StaticOverlay);
});
parcelRegister("cC9dj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$822144dc27a4c851$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $cmHWc;
    const $822144dc27a4c851$var$containerStyles = null;
    const $822144dc27a4c851$var$ChartOverlay = ({ listWidth: listWidth, renderChartOverlay: renderChartOverlay })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                left: `${listWidth}px`
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _154iidpf _1xi2idpf _94n5idpf _1pby1o8a _lcxvglyw"
            ])
        }, renderChartOverlay(), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cmHWc")).default), null));
    var $822144dc27a4c851$export$2e2bcd8739ae039 = $822144dc27a4c851$var$ChartOverlay;
});
parcelRegister("cmHWc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$25e54f730e3352bc$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $c7Iuw;
    const $25e54f730e3352bc$var$containerStyles = null;
    const $25e54f730e3352bc$var$PortalContainer = ()=>{
        const { setPortalContainerElement: setPortalContainerElement } = (0, (0, parcelRequire("c7Iuw")).usePortalScope)();
        const containerRef = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            setPortalContainerElement(containerRef.current);
            return ()=>{
                setPortalContainerElement(null);
            };
        }, [
            setPortalContainerElement
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: containerRef,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _lcxvglyw _1ltvidpf _154iidpf _94n5idpf _1xi2idpf _1pbyilow _ogto1994 _mkrz1fck"
            ])
        });
    };
    var $25e54f730e3352bc$export$2e2bcd8739ae039 = $25e54f730e3352bc$var$PortalContainer;
});
parcelRegister("73Gyu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cee2fb79426596ee$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $WPwAA;
    var $3Kr5N;
    var $eF50C;
    var $ehSu7;
    var $1QY8L;
    const $cee2fb79426596ee$var$InlineIndicators = ()=>{
        const [{ isCreateSiblingEnabled: isCreateSiblingEnabled, isDragEnabled: isDragEnabled }] = (0, (0, parcelRequire("WPwAA")).useEnablements)();
        const [isScrollingY] = (0, (0, parcelRequire("3Kr5N")).useIsScrollingY)();
        const inlineIndicatorParams = (0, (0, parcelRequire("1QY8L")).useInlineIndicator)();
        if (isScrollingY) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, isCreateSiblingEnabled && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eF50C")).default), inlineIndicatorParams), isDragEnabled && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ehSu7")).default), inlineIndicatorParams));
    };
    var $cee2fb79426596ee$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($cee2fb79426596ee$var$InlineIndicators);
});
parcelRegister("eF50C", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bc9d92dc26c0df72$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $9lMrf;
    var $ghKWA;
    var $4X5Iv;
    const $bc9d92dc26c0df72$var$appear = null;
    const $bc9d92dc26c0df72$var$opacityTransitionStyles = null;
    const $bc9d92dc26c0df72$var$iconWrapperStyles = null;
    const $bc9d92dc26c0df72$var$iconContainerStyles = null;
    const $bc9d92dc26c0df72$var$lineStyles = null;
    const $bc9d92dc26c0df72$var$containerStyles = null;
    const $bc9d92dc26c0df72$var$outerButtonStyles = null;
    const $bc9d92dc26c0df72$var$InlineCreateIndicator = ({ left: left, width: width })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0cglyw _kqswstnw _154iidpf _1bsb1osq _1pbyibnn",
                "_j7hq1wwu _tzy4idpf _5sagfnf5 _ju25188d _1o51q7pw",
                (0, (0, parcelRequire("ghKWA")).getInlineCreateButtonClassName)().className
            ]),
            style: {
                left: `${left}px`
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _154i1lpd _1ltvidpf _4t3igktf _1bsb1r7l _80omtlke _7momkb7n _b59ukb7n"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-component-selector": "line",
            style: {
                width: `${width}px`
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _154irdoj _4t3iyh40 _bfhki2p0"
            ])
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _4t3igktf _1bsbgktf _154iidpf _1ltv14id _bfhk1ffm _syaz15cr _2rko1sit",
                (0, (0, parcelRequire("ghKWA")).getInlineCreateIconClassName)().className
            ]),
            "data-component-selector": "icon-wrapper"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1tcg _1bsb1tcg _kqswh2mm _18u01i6y _19pk1i6y"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("9lMrf"))))), {
            label: formatMessage((0, (0, parcelRequire("4X5Iv")).default).label)
        })))));
    };
    var $bc9d92dc26c0df72$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($bc9d92dc26c0df72$var$InlineCreateIndicator);
});
parcelRegister("4X5Iv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5bc81b62b196143f$export$2e2bcd8739ae039);
    var $7VHMR;
    var $5bc81b62b196143f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        label: {
            id: 'roadmap.timeline-table.main.static-overlay.inline-indicators.create.label',
            defaultMessage: 'What needs to be done?',
            description: 'Icon label. Appears when the epics list is too long. Activates epic creation input at the bottom of the list'
        }
    });
});
parcelRegister("ehSu7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$395cffd1fd62174a$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $ghKWA;
    const $395cffd1fd62174a$var$containerStyles = null;
    const $395cffd1fd62174a$var$lineStyles = null;
    const $395cffd1fd62174a$var$InlineDragIndicator = ({ left: left, width: width })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "roadmap.timeline-table.main.static-overlay.inline-indicators.drag.inline-drag-indicator",
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0cglyw _kqswstnw _154iidpf _1bsb1osq _1pbyibnn",
                (0, (0, parcelRequire("ghKWA")).getDragIndicatorClassName)().className
            ]),
            style: {
                left: `${left}px`
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                width: `${width}px`
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3iyh40 _bfhk1r2e _1kt9b3bt _1cs8stnw _kfgtidpf _1mp4idpf _1aukj39m _qnec1lpd _1pq812me _4k1c12me _1n1j18is"
            ])
        }));
    var $395cffd1fd62174a$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($395cffd1fd62174a$var$InlineDragIndicator);
});
parcelRegister("1QY8L", function(module, exports) {
    $parcel$export(module.exports, "useInlineIndicator", ()=>$e2e1d2521d9b4f80$export$27583fc2bcba0ca1);
    var $5uXOq = parcelRequire("5uXOq");
    var $iZN6h;
    var $lGdZu;
    var $cRUzn;
    const $e2e1d2521d9b4f80$export$27583fc2bcba0ca1 = ()=>{
        const [{ left: left, clientWidth: clientWidth, indicatorLineOffset: indicatorLineOffset }] = (0, (0, parcelRequire("lGdZu")).useTimelineViewport)();
        const [params, setParams] = (0, $5uXOq.useState)({
            left: 0,
            width: 0
        });
        const viewportRef = (0, $5uXOq.useRef)(null);
        const setInlineIndicatorParams = (viewport)=>{
            if (viewport) setParams({
                left: viewport.getBoundingClientRect().left,
                width: viewport.clientWidth
            });
        };
        (0, $5uXOq.useEffect)(()=>{
            if (!clientWidth) {
                const viewport = document.getElementById((0, (0, parcelRequire("iZN6h")).TIMELINE_ID));
                viewportRef.current = viewport;
                setInlineIndicatorParams(viewport);
            }
        }, []);
        const onContentResize = (0, $5uXOq.useCallback)(()=>{
            setInlineIndicatorParams(viewportRef.current);
        }, []);
        (0, (0, parcelRequire("cRUzn")).useResizeObserver)(viewportRef.current, onContentResize);
        const inlineIndicatorParams = (0, $5uXOq.useMemo)(()=>({
                left: viewportRef.current ? params.left : left,
                width: viewportRef.current ? params.width - indicatorLineOffset : clientWidth - indicatorLineOffset
            }), [
            params.left,
            params.width,
            left,
            indicatorLineOffset,
            clientWidth
        ]);
        return inlineIndicatorParams;
    };
});
parcelRegister("gc064", function(module, exports) {
    $parcel$export(module.exports, "getRenderersWithDefaults", ()=>$1d12dd1471f35dce$export$59f24ad0cf4048d7);
    var $8QpSo;
    var $jZppz;
    const $1d12dd1471f35dce$export$59f24ad0cf4048d7 = (0, (0, parcelRequire("8QpSo")).default)((customRenderers)=>{
        const safeRenderers = {
            ...(0, (0, parcelRequire("jZppz")).defaultRenderers),
            ...customRenderers
        };
        return {
            listRenderers: {
                renderListEmptyContent: safeRenderers.renderListEmptyContent,
                renderListItemContent: safeRenderers.renderListItemContent,
                renderListItemSecondaryContent: safeRenderers.renderListItemSecondaryContent,
                renderListItemCreate: safeRenderers.renderListItemCreate,
                renderListHeaderItem: safeRenderers.renderListHeaderItem,
                renderListItemMenuOption: customRenderers?.renderListItemMenuOption,
                renderListItemModal: customRenderers?.renderListItemModal
            },
            chartRenderers: {
                renderChartOverlay: safeRenderers.renderChartOverlay,
                renderChartItemContent: safeRenderers.renderChartItemContent,
                renderChartTimelineOverlay: safeRenderers.renderChartTimelineOverlay,
                renderChartHeaderItem: safeRenderers.renderChartHeaderItem
            },
            renderProvider: safeRenderers.renderProvider
        };
    });
});
parcelRegister("jZppz", function(module, exports) {
    $parcel$export(module.exports, "defaultRenderers", ()=>$57507187b2991c68$export$2d95bc3f1f7b3d23);
    const $57507187b2991c68$var$DEFAULT_RENDERER = ()=>null;
    const $57507187b2991c68$export$2d95bc3f1f7b3d23 = {
        renderListItemMenuOption: $57507187b2991c68$var$DEFAULT_RENDERER,
        renderListItemModal: $57507187b2991c68$var$DEFAULT_RENDERER,
        renderListHeaderItem: $57507187b2991c68$var$DEFAULT_RENDERER,
        renderListEmptyContent: $57507187b2991c68$var$DEFAULT_RENDERER,
        renderListItemContent: $57507187b2991c68$var$DEFAULT_RENDERER,
        renderListItemSecondaryContent: $57507187b2991c68$var$DEFAULT_RENDERER,
        renderListItemCreate: $57507187b2991c68$var$DEFAULT_RENDERER,
        renderChartHeaderItem: $57507187b2991c68$var$DEFAULT_RENDERER,
        renderChartOverlay: $57507187b2991c68$var$DEFAULT_RENDERER,
        renderChartItemContent: $57507187b2991c68$var$DEFAULT_RENDERER,
        renderChartTimelineOverlay: $57507187b2991c68$var$DEFAULT_RENDERER,
        renderProvider: ({ children: children })=>children
    };
});
parcelRegister("50ELZ", function(module, exports) {
    $parcel$export(module.exports, "renderChartHeaderItem", ()=>$0e6b1bb447a5d6da$export$c4c87c526c6346ef);
    var $5uXOq = parcelRequire("5uXOq");
    var $2KlaV;
    var $9GaTL;
    var $upR7L;
    const $0e6b1bb447a5d6da$export$c4c87c526c6346ef = ({ id: id })=>{
        switch(id){
            case 0, (0, parcelRequire("2KlaV")).RELEASES_HEADER_ID:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9GaTL")).default), null);
            case 0, (0, parcelRequire("2KlaV")).SPRINTS_HEADER_ID:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("upR7L")).default), null);
            default:
                return null;
        }
    };
});
parcelRegister("9GaTL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$abc0d8c6b9876c0b$export$2e2bcd8739ae039);
    var $bC2fB;
    var $3rLbe;
    var $9ayiW;
    const $abc0d8c6b9876c0b$var$mapStateToProps = (state)=>({
            getVersionsForKeyDate: (0, (0, parcelRequire("3rLbe")).createGetVersionsForKeyDates)(state),
            highlightedKeyDates: (0, (0, parcelRequire("3rLbe")).getHighlightedKeyDates)(state)
        });
    var $abc0d8c6b9876c0b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($abc0d8c6b9876c0b$var$mapStateToProps, {})((0, (0, parcelRequire("9ayiW")).default));
});
parcelRegister("9ayiW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d9d7d80342b5be88$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6vTmk;
    var $biT18;
    var $3qgHY;
    const $d9d7d80342b5be88$var$ReleasesHeader = ({ getVersionsForKeyDate: getVersionsForKeyDate, highlightedKeyDates: highlightedKeyDates })=>{
        const [{ today: today }] = (0, (0, parcelRequire("biT18")).useTimelineState)();
        const keyDates = getVersionsForKeyDate(today);
        const renderPopupContent = (0, $5uXOq.useCallback)((selectedKeyDates, setInitialFocusRef)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3qgHY")).default), {
                keyDates: selectedKeyDates,
                setInitialFocusRef: setInitialFocusRef
            }), []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6vTmk")).RoadmapKeyDates), {
            keyDates: keyDates,
            highlightedKeyDates: highlightedKeyDates,
            renderPopupContent: renderPopupContent
        });
    };
    var $d9d7d80342b5be88$export$2e2bcd8739ae039 = $d9d7d80342b5be88$var$ReleasesHeader;
});
parcelRegister("6vTmk", function(module, exports) {
    $parcel$export(module.exports, "RoadmapKeyDates", ()=>$06e37dc7d0d80f20$export$c2d959f07ed56d48);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $f22iM;
    var $dC5iT;
    var $8CUq3;
    var $4R6GH;
    var $8zOmE;
    var $2NMNM;
    var $iZN6h;
    var $g3prf;
    var $biT18;
    var $dCm1o;
    var $2KlaV;
    var $5SuOw;
    var $44Slk;
    var $bNrCO;
    var $3jWmF;
    var $lDNAb;
    var $aVOvi;
    const $06e37dc7d0d80f20$export$123b0ad6149c0886 = (headerItems, headerItemsOffsetTop, headerHeight)=>{
        const releasesRow = headerItems.find((headerItem)=>headerItem.id === (0, (0, parcelRequire("2KlaV")).RELEASES_HEADER_ID));
        const releasesRowHeight = releasesRow && releasesRow.height !== undefined ? releasesRow.height : (0, (0, parcelRequire("iZN6h")).DEFAULT_SUBHEADER_HEIGHT);
        return headerHeight - headerItemsOffsetTop[0, (0, parcelRequire("2KlaV")).RELEASES_HEADER_ID] - releasesRowHeight / 2 - (0, (0, parcelRequire("5SuOw")).MARKER_WIDTH) / 2 + (0, (0, parcelRequire("5SuOw")).MARKER_BORDER_WIDTH);
    };
    const $06e37dc7d0d80f20$var$RoadmapKeyDates = ({ keyDates: keyDatesProp, highlightedKeyDates: highlightedKeyDates, renderPopupContent: renderPopupContent })=>{
        const [{ timelineDuration: timelineDuration, timelineWidth: timelineWidth, timelineMode: timelineMode }] = (0, (0, parcelRequire("biT18")).useTimelineState)();
        const [{ headerItems: headerItems, headerItemsOffsetTop: headerItemsOffsetTop, headerHeight: headerHeight }] = (0, (0, parcelRequire("g3prf")).useHeaderState)();
        const highlightLineHeight = $06e37dc7d0d80f20$export$123b0ad6149c0886(headerItems, headerItemsOffsetTop, headerHeight);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const keyDateGroups = (0, (0, parcelRequire("44Slk")).getKeyDatesGroups)({
            keyDates: keyDatesProp,
            timelineMode: timelineMode,
            timelineDuration: timelineDuration,
            timelineWidth: timelineWidth
        });
        let highlightLines;
        if (highlightedKeyDates.length > 0) highlightLines = (0, (0, parcelRequire("bNrCO")).getHighlightLines)({
            keyDateGroups: keyDateGroups,
            highlightedKeyDates: highlightedKeyDates
        });
        const getMarkerContent = (count, status)=>{
            if (count > 1) return count > 9 ? '9+' : count;
            if (status === (0, (0, parcelRequire("5SuOw")).WARNING)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lDNAb")).FailedIcon), null);
            if (status === (0, (0, parcelRequire("5SuOw")).COMPLETED)) return (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap_drop_2') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("f22iM"))))), {
                label: "",
                color: "currentColor"
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3jWmF")).CompletedIcon), null);
            return null;
        };
        (0, $5uXOq.useEffect)(()=>{
            const numberOfKeyDatesPerGroup = keyDateGroups.map(({ keyDates: keyDates })=>keyDates.length);
            const maxNumberOfKeyDatesInAGroup = Math.max(...numberOfKeyDatesPerGroup);
            const numberOfWarning = keyDateGroups.filter(({ status: status })=>status === (0, (0, parcelRequire("5SuOw")).WARNING)).length;
            const analyticsEvent = createAnalyticsEvent({
                action: 'mounted',
                actionSubject: 'keyDatesHeader'
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'keyDates', {
                maxNumberOfKeyDatesInAGroup: maxNumberOfKeyDatesInAGroup,
                numberOfWarning: numberOfWarning,
                numberOfMarker: keyDateGroups.length,
                timelineMode: timelineMode
            });
        }, [
            timelineMode
        ]);
        const renderSelectedKeyDatePopupContent = (0, $5uXOq.useCallback)((selectedKeyDates)=>({ setInitialFocusRef: setInitialFocusRef })=>renderPopupContent(selectedKeyDates, setInitialFocusRef), [
            renderPopupContent
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, keyDateGroups.map(({ keyDates: keyDates, status: status, maxWidth: maxWidth, leftPosition: leftPosition, id: id }, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aVOvi")).MarkerWithTooltip), {
                key: index,
                leftPosition: leftPosition,
                keyDates: keyDates,
                status: status,
                id: id,
                renderPopupContent: renderSelectedKeyDatePopupContent(keyDates)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                style: {
                    backgroundColor: (0, (0, parcelRequire("5SuOw")).MARKER_COLORS)[status]
                },
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_eaap5w2r _11c81vlj _k48p8n31 _syaz15cr _1bsbgktf _4t3igktf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _4cvr1h6o _1bah1h6o _2rko1osq _vchhusvi _19it1byb _1reo15vq _18m915vq"
                ])
            }, getMarkerContent(keyDates.length, status)), keyDates.length === 1 && maxWidth > (0, (0, parcelRequire("5SuOw")).MARKER_WIDTH_WITH_SPACE) && ((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap_drop_1') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                as: "span",
                xcss: $06e37dc7d0d80f20$var$labelStyle,
                style: {
                    maxWidth: `${maxWidth - (0, (0, parcelRequire("5SuOw")).MARKER_WIDTH_WITH_SPACE)}px`
                }
            }, keyDates[0].name) : (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                style: {
                    maxWidth: `${maxWidth - (0, (0, parcelRequire("5SuOw")).MARKER_WIDTH_WITH_SPACE)}px`
                },
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_o5721q9c _1bto1l2s _1e0c1o8l _s7n4nkob _1yt4otz2 _1reo15vq _18m915vq _11c8qk37 _k48pbfng _19pkidpf _syaz1fxt"
                ])
            }, keyDates[0].name)))), highlightLines && highlightLines.map(({ left: left, id: id, status: status })=>(0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                key: id,
                style: {
                    height: `${highlightLineHeight}px`,
                    backgroundColor: (0, (0, parcelRequire("5SuOw")).MARKER_COLORS)[status],
                    left: `${left}px`
                },
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_kqswstnw _1e0c1ule _1bsbv77o _154i8rdq"
                ])
            })));
    };
    $06e37dc7d0d80f20$var$RoadmapKeyDates.whyDidYouRender = true;
    $06e37dc7d0d80f20$var$RoadmapKeyDates.defaultProps = {
        highlightedKeyDates: []
    };
    const $06e37dc7d0d80f20$export$c2d959f07ed56d48 = (0, $5uXOq.memo)($06e37dc7d0d80f20$var$RoadmapKeyDates);
    $06e37dc7d0d80f20$export$c2d959f07ed56d48.displayName = 'RoadmapKeyDates';
    const $06e37dc7d0d80f20$var$markerStyles = null;
    const $06e37dc7d0d80f20$var$highlightLineStyles = null;
    const $06e37dc7d0d80f20$var$labelStyles = null;
    const $06e37dc7d0d80f20$var$labelStyle = (0, (0, parcelRequire("8CUq3")).xcss)({
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        display: 'inline-block',
        verticalAlign: 'middle',
        padding: 'space.0',
        paddingRight: 'space.050',
        paddingLeft: 'space.050',
        overflow: 'hidden',
        font: 'font.body.UNSAFE_small',
        fontWeight: 'font.weight.medium',
        marginTop: 'space.0',
        color: 'color.text.subtle'
    });
});
parcelRegister("44Slk", function(module, exports) {
    $parcel$export(module.exports, "getKeyDatesGroups", ()=>$b8fdf5ade525c6a4$export$efd6cb53cfb8bfc2);
    var $ajpes = parcelRequire("ajpes");
    var $8QpSo;
    var $iZN6h;
    var $bFxJH;
    var $esmwW;
    var $5SuOw;
    const $b8fdf5ade525c6a4$var$NUMBER_OF_DAYS_OFFSET = {
        [(0, (0, parcelRequire("iZN6h")).QUARTERS)]: 3,
        [(0, (0, parcelRequire("iZN6h")).MONTHS)]: 1,
        [(0, (0, parcelRequire("iZN6h")).WEEKS)]: 1
    };
    const $b8fdf5ade525c6a4$var$MAX_WIDTH = 300;
    const $b8fdf5ade525c6a4$export$efd6cb53cfb8bfc2 = (0, (0, parcelRequire("8QpSo")).default)(({ keyDates: keyDates, timelineMode: timelineMode, timelineDuration: timelineDuration, timelineWidth: timelineWidth })=>{
        const dayOffset = $b8fdf5ade525c6a4$var$NUMBER_OF_DAYS_OFFSET[timelineMode];
        const groups = [];
        let lastStart;
        let lastEnd;
        const keyDatesInDescOrder = keyDates.slice().sort((keyDate, nextKeyDate)=>nextKeyDate.date - keyDate.date);
        keyDatesInDescOrder.forEach((keydate)=>{
            const { date: date, status: status } = keydate;
            if (date >= timelineDuration.startMilliseconds && date <= timelineDuration.endMilliseconds) {
                if (lastStart && lastEnd && date > lastStart && date <= lastEnd) {
                    const lastGroup = groups[0];
                    lastGroup.keyDates.unshift(keydate);
                    if ((0, (0, parcelRequire("5SuOw")).STATUS_PRIORITY)[status] > (0, (0, parcelRequire("5SuOw")).STATUS_PRIORITY)[lastGroup.status]) lastGroup.status = status;
                } else {
                    lastStart = Math.max(date - dayOffset * (0, $a797a5154a1373bc$export$1f04624003d2da7d), timelineDuration.startMilliseconds);
                    lastEnd = date;
                    const newLeft = (0, (0, parcelRequire("bFxJH")).getTimelinePositionFromDate)(timelineDuration, timelineWidth, dayOffset > 1 ? (lastEnd + lastStart) / 2 : lastEnd + (0, (0, parcelRequire("esmwW")).DUE_DATE_OFFSET));
                    const lastLeft = groups.length > 0 ? groups[0].leftPosition : timelineWidth;
                    groups.unshift({
                        id: keydate.id,
                        keyDates: [
                            keydate
                        ],
                        status: status,
                        leftPosition: newLeft,
                        maxWidth: Math.min(Math.round(lastLeft - newLeft), $b8fdf5ade525c6a4$var$MAX_WIDTH)
                    });
                }
            }
        });
        return groups;
    }, (newArgs, lastArgs)=>{
        if (newArgs.length !== lastArgs.length) return false;
        const equalityFn = (0, ($parcel$interopDefault($ajpes)));
        return newArgs.every((newArg, index)=>equalityFn(newArg, lastArgs[index]));
    });
});
parcelRegister("bNrCO", function(module, exports) {
    $parcel$export(module.exports, "getHighlightLines", ()=>$6ca0bc78a8f415d1$export$dfb1168c62133e0d);
    var $ajpes = parcelRequire("ajpes");
    var $8QpSo;
    var $5SuOw;
    const $6ca0bc78a8f415d1$export$1cce90b57e2c2286 = (0, (0, parcelRequire("8QpSo")).default)((keyDateGroups)=>{
        const keyDatesAttributesHash = {};
        keyDateGroups.forEach((keyDateGroup)=>{
            const { leftPosition: leftPosition, keyDates: keyDatesWithinGroup, id: groupId } = keyDateGroup;
            keyDatesWithinGroup.forEach(({ id: id, status: status })=>{
                keyDatesAttributesHash[`${id}`] = {
                    groupId: groupId,
                    left: leftPosition,
                    status: status
                };
            });
        });
        return keyDatesAttributesHash;
    }, (newArgs, lastArgs)=>{
        if (newArgs.length !== lastArgs.length) return false;
        const equalityFn = (0, ($parcel$interopDefault($ajpes)));
        return newArgs.every((newArg, index)=>equalityFn(newArg, lastArgs[index]));
    });
    const $6ca0bc78a8f415d1$export$dfb1168c62133e0d = (0, (0, parcelRequire("8QpSo")).default)(({ keyDateGroups: keyDateGroups, highlightedKeyDates: highlightedKeyDates })=>{
        const highlightGroups = {};
        const keyDatesAttributesHash = $6ca0bc78a8f415d1$export$1cce90b57e2c2286(keyDateGroups);
        highlightedKeyDates.forEach((id)=>{
            const keyDateAttributes = keyDatesAttributesHash[id];
            if (keyDateAttributes) {
                const { left: left, groupId: groupId, status: status } = keyDateAttributes;
                const highlightedGroup = highlightGroups[groupId];
                if (!highlightedGroup || (0, (0, parcelRequire("5SuOw")).STATUS_PRIORITY)[status] > (0, (0, parcelRequire("5SuOw")).STATUS_PRIORITY)[highlightedGroup.status]) highlightGroups[groupId] = {
                    left: left,
                    status: status,
                    id: groupId
                };
            }
        });
        return Object.keys(highlightGroups).map((key)=>highlightGroups[key]);
    }, (newArgs, lastArgs)=>{
        if (newArgs.length !== lastArgs.length) return false;
        const equalityFn = (0, ($parcel$interopDefault($ajpes)));
        return newArgs.every((newArg, index)=>equalityFn(newArg, lastArgs[index]));
    });
});
parcelRegister("3jWmF", function(module, exports) {
    $parcel$export(module.exports, "CompletedIcon", ()=>$84231a5a6cbd2bce$export$78a23b7901d2dcd);
    var $5uXOq = parcelRequire("5uXOq");
    var $5SuOw;
    const $84231a5a6cbd2bce$export$78a23b7901d2dcd = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "16",
            height: "16",
            fill: "none",
            viewBox: "0 0 16 16",
            style: {
                pointerEvents: 'none'
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("circle", {
            r: "7",
            cx: "8",
            cy: "8",
            fill: "currentColor"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: (0, (0, parcelRequire("5SuOw")).MARKER_COLORS)[0, (0, parcelRequire("5SuOw")).COMPLETED],
            fillRule: "evenodd",
            d: "M8 16A8 8 0 108 0a8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L7 8.586 5.707 7.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
            clipRule: "evenodd"
        }));
});
parcelRegister("lDNAb", function(module, exports) {
    $parcel$export(module.exports, "FailedIcon", ()=>$24645649a0d67b26$export$47b17d91c8e9a146);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $dCm1o;
    var $5SuOw;
    const $24645649a0d67b26$export$47b17d91c8e9a146 = ()=>(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap_drop_2') ? (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("circle", {
            r: "6",
            cx: "8",
            cy: "8",
            fill: "currentColor"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M0.0175781 8C0.0175478 12.4085 3.59133 15.9823 7.99981 15.9823C12.4083 15.9823 15.9821 12.4085 15.982 8C15.982 3.59155 12.4083 0.0178225 7.99981 0.0178223C3.59136 0.017822 0.0176084 3.59155 0.0175781 8ZM7.24981 9V3.75H8.74981V9H7.24981ZM7.99981 12.25C8.5521 12.25 8.99981 11.8023 8.99981 11.25C8.99981 10.6977 8.5521 10.25 7.99981 10.25C7.44753 10.25 6.99981 10.6977 6.99981 11.25C6.99981 11.8023 7.44753 12.25 7.99981 12.25Z",
            fill: (0, (0, parcelRequire("5SuOw")).MARKER_COLORS)[0, (0, parcelRequire("5SuOw")).WARNING]
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "16",
            height: "16",
            fill: "none",
            viewBox: "0 0 16 16",
            style: {
                pointerEvents: 'none'
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("circle", {
            r: "6",
            cx: "8",
            cy: "8",
            fill: "currentColor"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: (0, (0, parcelRequire("5SuOw")).MARKER_COLORS)[0, (0, parcelRequire("5SuOw")).WARNING],
            fillRule: "evenodd",
            d: "M.768 9.768a2.5 2.5 0 010-3.536L6.232.768a2.5 2.5 0 013.536 0l5.464 5.464a2.5 2.5 0 010 3.536l-5.464 5.464a2.5 2.5 0 01-3.536 0L.768 9.768zM7 4a1 1 0 112 0v4a1 1 0 01-2 0V4zm1 8a1 1 0 100-2 1 1 0 000 2z",
            clipRule: "evenodd"
        }));
});
parcelRegister("aVOvi", function(module, exports) {
    $parcel$export(module.exports, "MarkerWithTooltip", ()=>$daf917e652b7672e$export$c2965f235e376059);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $1I7E8;
    var $eTXmK;
    var $3bDjY;
    var $4R6GH;
    var $koVbs;
    var $7mPT9;
    var $8zOmE;
    var $2NMNM;
    var $82CeN;
    var $kyahI;
    var $1YcpO;
    var $g11uZ;
    var $knkJA;
    var $6wTnN;
    var $fLniF;
    var $gPXTo;
    var $dEqGC;
    var $lJjHv;
    const $daf917e652b7672e$var$tooltipStyles = null;
    const $daf917e652b7672e$var$markerStyles = null;
    const $daf917e652b7672e$export$c2965f235e376059 = ({ id: id, keyDates: keyDates, leftPosition: leftPosition, children: children, status: status, renderPopupContent: renderPopupContent })=>{
        const { listenToViewportScroll: listenToViewportScroll, stopListeningToViewportScroll: stopListeningToViewportScroll } = (0, (0, parcelRequire("kyahI")).useViewport)();
        const [{ isHeaderModalActive: isHeaderModalActive }, { onToggleHeaderModal: onToggleHeaderModal }] = (0, (0, parcelRequire("gPXTo")).useIsHeaderModalActive)();
        const [isPopupActive, setIsPopupActive] = (0, $5uXOq.useState)(false);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { shouldPreventNavigation: shouldPreventNavigation } = (0, (0, parcelRequire("82CeN")).useFocusMarshal)();
        const openPopup = (0, $5uXOq.useCallback)(()=>{
            shouldPreventNavigation(true);
            setIsPopupActive(true);
        }, [
            shouldPreventNavigation
        ]);
        const closePopup = (0, $5uXOq.useCallback)(()=>{
            shouldPreventNavigation(false);
            setIsPopupActive(false);
        }, [
            shouldPreventNavigation
        ]);
        const tooltipContent = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, keyDates.map(({ name: name, date: date }, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6wTnN")).TooltipInterval), {
                    key: index
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fLniF")).ReleaseIcon), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6wTnN")).ContentName), null, name), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6wTnN")).ContentDateLabel), null, `(${(0, (0, parcelRequire("g11uZ")).getDateFromTimestamp)(date)})`)))), [
            keyDates
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const onViewPortScrollHandler = ()=>{
                if ((0, (0, parcelRequire("4R6GH")).fg)('timeline_grid_navigation_m2')) closePopup();
                else setIsPopupActive(false);
            };
            listenToViewportScroll(onViewPortScrollHandler);
            return function cleanup() {
                stopListeningToViewportScroll(onViewPortScrollHandler);
            };
        }, [
            closePopup,
            listenToViewportScroll,
            stopListeningToViewportScroll
        ]);
        const onClickMarkerLabelHandler = (0, $5uXOq.useCallback)((event)=>{
            (0, (0, parcelRequire("eTXmK")).default)('timeline-keydate-marker-clicked', event.timeStamp);
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'keyDatesMarker', {
                status: status
            });
            if ((0, (0, parcelRequire("4R6GH")).fg)('timeline_grid_navigation_m2')) openPopup();
            else setIsPopupActive(true);
        }, [
            createAnalyticsEvent,
            status,
            openPopup
        ]);
        const onKeyDown = (0, $5uXOq.useCallback)((event)=>{
            if ((0, (0, parcelRequire("1YcpO")).isEnterOrSpaceKey)(event)) {
                event.preventDefault();
                (0, (0, parcelRequire("eTXmK")).default)('timeline-keydate-marker-clicked', event.timeStamp);
                if ((0, (0, parcelRequire("4R6GH")).fg)('timeline_grid_navigation_m2')) openPopup();
                else setIsPopupActive(true);
            }
        }, [
            openPopup
        ]);
        const onClosePopup = (0, $5uXOq.useCallback)(()=>{
            if (!isHeaderModalActive) {
                if ((0, (0, parcelRequire("4R6GH")).fg)('timeline_grid_navigation_m2')) closePopup();
                else setIsPopupActive(false);
                onToggleHeaderModal(false);
            }
        }, [
            closePopup,
            isHeaderModalActive,
            onToggleHeaderModal
        ]);
        const renderPopupTrigger = ({ ref: ref, ...restTriggerProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                content: tooltipContent,
                position: "bottom-end",
                hideTooltipOnClick: true,
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_2rko1l7b _vchhusvi _1yt41ppf _p12f1ogm _bfhkgkf6 _syaz15cr _vwz4nqt0"
                ])
            }, ({ 'aria-describedby': ariaDescribedBy, ...tooltipProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    ...restTriggerProps,
                    ...tooltipProps,
                    style: {
                        left: `${leftPosition}px`,
                        top: '7.5px'
                    },
                    ref: (0, (0, parcelRequire("7mPT9")).mergeRefs)(ref, tooltipProps.ref),
                    tabIndex: 0,
                    role: "button",
                    "data-testid": `roadmap.timeline-table-kit.ui.chart-header-item.key-dates.marker-${id}`,
                    onClick: onClickMarkerLabelHandler,
                    onKeyDown: onKeyDown,
                    "aria-label": formatMessage((0, (0, parcelRequire("dEqGC")).default).releases, {
                        noOfReleases: keyDates.length,
                        releaseNamesAndDates: (0, (0, parcelRequire("lJjHv")).getReleaseNamesAndDatesAlly)(keyDates)
                    }),
                    className: (0, (0, parcelRequire("bwpsq")).default)([
                        "_kqswstnw _4t3igktf _t9ec1ah0 _1e0c1txw _4cvr1h6o _80omtlke _yt1xcs5v"
                    ])
                }, children));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).Popup), {
            isOpen: isPopupActive,
            onClose: onClosePopup,
            placement: "bottom-start",
            content: renderPopupContent,
            trigger: renderPopupTrigger,
            zIndex: (0, (0, parcelRequire("knkJA")).OVERLAY_FLYOUT_Z_INDEX),
            role: "dialog",
            autoFocus: false,
            label: formatMessage((0, (0, parcelRequire("dEqGC")).default).popupLabel)
        });
    };
});
parcelRegister("knkJA", function(module, exports) {
    $parcel$export(module.exports, "CHART_BAR_Z_INDEX", ()=>$cd07191b9c4a43cd$export$b769e19d85a0dd1f);
    $parcel$export(module.exports, "OVERLAY_FLYOUT_Z_INDEX", ()=>$cd07191b9c4a43cd$export$607b7b6549bb844a);
    var $gwIPs;
    const $cd07191b9c4a43cd$export$b8c38275349a321a = 2;
    const $cd07191b9c4a43cd$export$bf7c4b09e1259e0c = 2;
    const $cd07191b9c4a43cd$export$b769e19d85a0dd1f = 3;
    const $cd07191b9c4a43cd$export$e3452b0e8cf45d94 = 3;
    const $cd07191b9c4a43cd$export$fd0eb84f1cc64bd1 = 4;
    const $cd07191b9c4a43cd$export$ccfab360c3bec41f = 5;
    const $cd07191b9c4a43cd$export$d0b62675e5ca73fd = 6;
    const $cd07191b9c4a43cd$export$952b9e656bb22739 = 6;
    const $cd07191b9c4a43cd$export$bf33c90eb728615a = 8;
    const $cd07191b9c4a43cd$export$d2c2571c3482d99f = 15;
    const $cd07191b9c4a43cd$export$607b7b6549bb844a = (0, (0, parcelRequire("gwIPs")).layers).navigation;
});
parcelRegister("6wTnN", function(module, exports) {
    $parcel$export(module.exports, "TooltipInterval", ()=>$94a6725bdb847735$export$dccd89ac2f47033e);
    $parcel$export(module.exports, "ContentName", ()=>$94a6725bdb847735$export$6e99a112608b0053);
    $parcel$export(module.exports, "ContentDateLabel", ()=>$94a6725bdb847735$export$3f3c4d01a01294ab);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $kgoHi;
    var $8CUq3;
    const $94a6725bdb847735$export$dccd89ac2f47033e = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            direction: "row",
            alignItems: "center",
            xcss: $94a6725bdb847735$var$tooltipStyles
        }, children);
    const $94a6725bdb847735$export$6e99a112608b0053 = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1reo15vq _18m915vq _o5721q9c _1bto1l2s"
            ])
        }, children);
    const $94a6725bdb847735$export$3f3c4d01a01294ab = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u01b66 _syazafn2"
            ])
        }, children);
    const $94a6725bdb847735$var$tooltipStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        whiteSpace: 'nowrap'
    });
});
parcelRegister("fLniF", function(module, exports) {
    $parcel$export(module.exports, "ReleaseIcon", ()=>$bbc9b36a5937bab9$export$8417cbec3ac6c318);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $esjuM;
    var $gwIPs;
    const $bbc9b36a5937bab9$export$8417cbec3ac6c318 = ({ size: size })=>(0, ($parcel$interopDefault($5uXOq))).createElement($bbc9b36a5937bab9$var$Wrapper, {
            size: size
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("esjuM"))))), {
            label: "",
            spacing: size === 'medium' ? 'spacious' : 'none',
            color: "currentColor",
            LEGACY_size: size
        }));
    $bbc9b36a5937bab9$export$8417cbec3ac6c318.defaultProps = {
        size: 'small'
    };
    const $bbc9b36a5937bab9$var$SMALL_ICON_SIZE = (0, (0, parcelRequire("gwIPs")).gridSize) * 2;
    const $bbc9b36a5937bab9$var$MEDIUM_ICON_SIZE = (0, (0, parcelRequire("gwIPs")).gridSize) * 3;
    const $bbc9b36a5937bab9$var$getIconSize = ({ size: size })=>size === 'small' ? $bbc9b36a5937bab9$var$SMALL_ICON_SIZE : $bbc9b36a5937bab9$var$MEDIUM_ICON_SIZE;
    const $bbc9b36a5937bab9$var$Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_2ylchh": (0, (0, parcelRequire("lD23V")).default)($bbc9b36a5937bab9$var$getIconSize, "px")
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsbktuk _4t3iktuk _2hwx1b66",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("gPXTo", function(module, exports) {
    $parcel$export(module.exports, "useResetChartInteractionState", ()=>$663cda5abab042f5$export$fc4108d49b02ba94);
    $parcel$export(module.exports, "useInteractionData", ()=>$663cda5abab042f5$export$2f4e7606a05110d7);
    $parcel$export(module.exports, "useTargetIntervalId", ()=>$663cda5abab042f5$export$a93e57268029ba2d);
    $parcel$export(module.exports, "useIntervalDropZoneData", ()=>$663cda5abab042f5$export$6814590c602b8a2a);
    $parcel$export(module.exports, "useIsHeaderModalActive", ()=>$663cda5abab042f5$export$5eb5fe0fd641b668);
    $parcel$export(module.exports, "useHeaderItemActions", ()=>$663cda5abab042f5$export$fad9cd2384b134e0);
    $parcel$export(module.exports, "RoadmapChartItemInteractionProvider", ()=>$663cda5abab042f5$export$9d4771cc037ac267);
    var $5uXOq = parcelRequire("5uXOq");
    var $3ruU1;
    var $biT18;
    var $3sQ5x;
    var $gg7kZ;
    var $iXqE5;
    var $bdtf9;
    var $5GeZM;
    var $10N8P;
    var $aTYP2;
    var $g85ud;
    const $663cda5abab042f5$export$c830a1fa415103b0 = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: (0, (0, parcelRequire("10N8P")).DEFAULT_STATE),
        actions: (0, parcelRequire("5GeZM")).actions,
        name: 'timeline-table-kit.table-providers.chart-item-interactions'
    });
    const $663cda5abab042f5$var$useChartInteractionActions = (0, (0, parcelRequire("3sQ5x")).createHook)($663cda5abab042f5$export$c830a1fa415103b0, {
        selector: null
    });
    const $663cda5abab042f5$export$fc4108d49b02ba94 = ()=>{
        const [, chartInteractionActions] = $663cda5abab042f5$var$useChartInteractionActions();
        return {
            resetChartInteractionState: chartInteractionActions.onLingerEnd
        };
    };
    const $663cda5abab042f5$export$2f4e7606a05110d7 = (0, (0, parcelRequire("3sQ5x")).createHook)($663cda5abab042f5$export$c830a1fa415103b0, {
        selector: (0, (0, parcelRequire("aTYP2")).getInteractionDataById)
    });
    const $663cda5abab042f5$export$a93e57268029ba2d = (0, (0, parcelRequire("3sQ5x")).createHook)($663cda5abab042f5$export$c830a1fa415103b0, {
        selector: (0, (0, parcelRequire("aTYP2")).getTargetIntervalId)
    });
    const $663cda5abab042f5$export$6814590c602b8a2a = (0, (0, parcelRequire("3sQ5x")).createHook)($663cda5abab042f5$export$c830a1fa415103b0, {
        selector: (0, (0, parcelRequire("aTYP2")).getIntervalDropZoneDataById)
    });
    const $663cda5abab042f5$export$5eb5fe0fd641b668 = (0, (0, parcelRequire("3sQ5x")).createHook)($663cda5abab042f5$export$c830a1fa415103b0, {
        selector: (0, (0, parcelRequire("aTYP2")).getIsHeaderModalActive)
    });
    const $663cda5abab042f5$export$fad9cd2384b134e0 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($663cda5abab042f5$export$c830a1fa415103b0);
    const $663cda5abab042f5$var$Container = (0, (0, parcelRequire("gg7kZ")).createContainer)($663cda5abab042f5$export$c830a1fa415103b0);
    const $663cda5abab042f5$export$9d4771cc037ac267 = ({ items: items, selectedItemIds: selectedItemIds, isDragAlongEnabled: isDragAlongEnabled, intervals: intervals, children: children })=>{
        const sideEffectMarshal = (0, (0, parcelRequire("3ruU1")).useSideEffectMarshal)();
        const [{ timelineMode: timelineMode, timelineDuration: timelineDuration, timelineWidth: timelineWidth }] = (0, (0, parcelRequire("biT18")).useTimelineState)();
        const { updateViewportCache: updateViewportCache, adjustScrollPositionAndGetOffset: adjustScrollPositionAndGetOffset } = (0, (0, parcelRequire("bdtf9")).useAdjustScrollPosition)();
        const simpleIntervals = (0, (0, parcelRequire("g85ud")).getSimpleIntervals)(intervals, timelineDuration, timelineWidth);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($663cda5abab042f5$var$Container, {
            items: items,
            selectedItemIds: selectedItemIds,
            sideEffectMarshal: sideEffectMarshal,
            timelineMode: timelineMode,
            timelineWidth: timelineWidth,
            timelineDuration: timelineDuration,
            setViewportCache: updateViewportCache,
            getScrollOffset: adjustScrollPositionAndGetOffset,
            isDragAlongEnabled: isDragAlongEnabled,
            simpleIntervals: simpleIntervals
        }, children);
    };
    $663cda5abab042f5$export$9d4771cc037ac267.defaultProps = {
        selectedItemIds: []
    };
});
parcelRegister("bdtf9", function(module, exports) {
    $parcel$export(module.exports, "adjustScrollPosition", ()=>$b460cd5b76919591$export$9b07bbd51c0d1d84);
    $parcel$export(module.exports, "useAdjustScrollPosition", ()=>$b460cd5b76919591$export$6853243092b02409);
    var $5uXOq = parcelRequire("5uXOq");
    var $kyahI;
    var $er2y9;
    const $b460cd5b76919591$var$calculateScrollOnDragLeft = (0, (0, parcelRequire("er2y9")).createCalculateScrollOnDragWithOffset)(120);
    const $b460cd5b76919591$var$calculateScrollOnDragTop = (0, (0, parcelRequire("er2y9")).createCalculateScrollOnDragWithOffset)(40);
    const $b460cd5b76919591$var$DEFAULT_VIEWPORT_CACHE = {
        scrollBoundingRect: undefined,
        viewportBoundingRect: undefined
    };
    const $b460cd5b76919591$export$9b07bbd51c0d1d84 = (from, to, setViewportScroll, initialScrollBoundingRect, requestViewportScrollBounding, viewportBoundingRect, newScrollLeft, newScrollTop)=>{
        const initialScrollLeft = initialScrollBoundingRect ? initialScrollBoundingRect.scrollLeft : 0;
        const initialScrollTop = initialScrollBoundingRect ? initialScrollBoundingRect.scrollTop : 0;
        const { scrollLeft: scrollLeft, scrollWidth: scrollWidth, scrollTop: scrollTop, scrollHeight: scrollHeight } = requestViewportScrollBounding();
        let topScroll;
        let leftScroll;
        if (viewportBoundingRect) {
            const { width: width, left: left, right: right, top: top, height: height, bottom: bottom } = viewportBoundingRect;
            const newScrollTopValue = $b460cd5b76919591$var$calculateScrollOnDragTop(height, top, bottom, to.y, to.y - from.y, scrollTop, scrollHeight - height);
            if (newScrollTopValue !== scrollTop && newScrollTopValue > 0) {
                setViewportScroll({
                    scrollTop: newScrollTopValue
                });
                topScroll = newScrollTopValue;
            }
            const newScrollLeftValue = $b460cd5b76919591$var$calculateScrollOnDragLeft(width, left, right, to.x, to.x - from.x, scrollLeft, scrollWidth - width);
            if (newScrollLeftValue !== scrollLeft && newScrollLeftValue > 0) {
                setViewportScroll({
                    scrollLeft: newScrollLeftValue
                });
                leftScroll = newScrollLeftValue;
            }
        }
        return {
            scrollLeft: initialScrollLeft - (newScrollLeft !== undefined ? newScrollLeft : scrollLeft),
            scrollTop: initialScrollTop - (newScrollTop !== undefined ? newScrollTop : scrollTop),
            updatedScrollLeft: leftScroll,
            updatedScrollTop: topScroll
        };
    };
    const $b460cd5b76919591$export$6853243092b02409 = ()=>{
        const viewportContext = (0, (0, parcelRequire("kyahI")).useViewport)();
        const viewportCache = (0, $5uXOq.useRef)($b460cd5b76919591$var$DEFAULT_VIEWPORT_CACHE);
        const baselineScrollLeft = (0, $5uXOq.useRef)(0);
        const baselineScrollTop = (0, $5uXOq.useRef)(0);
        const { requestViewportBoundingClient: requestViewportBoundingClient, requestViewportScrollBounding: requestViewportScrollBounding, setViewportScroll: setViewportScroll } = viewportContext;
        const updateViewportCache = (0, $5uXOq.useCallback)(()=>{
            const scrollBoundingRect = requestViewportScrollBounding();
            const viewportBoundingRect = requestViewportBoundingClient();
            viewportCache.current = {
                viewportBoundingRect: viewportBoundingRect,
                scrollBoundingRect: scrollBoundingRect
            };
            baselineScrollLeft.current = scrollBoundingRect.scrollLeft;
            baselineScrollTop.current = scrollBoundingRect.scrollTop;
        }, [
            requestViewportBoundingClient,
            requestViewportScrollBounding
        ]);
        const adjustScrollPositionAndGetOffset = (0, $5uXOq.useCallback)((from, to)=>{
            const { scrollBoundingRect: scrollBoundingRect, viewportBoundingRect: viewportBoundingRect } = viewportCache.current;
            const { scrollLeft: scrollLeft, updatedScrollLeft: updatedScrollLeft } = $b460cd5b76919591$export$9b07bbd51c0d1d84(from, to, setViewportScroll, scrollBoundingRect, requestViewportScrollBounding, viewportBoundingRect, baselineScrollLeft.current, baselineScrollTop.current);
            if (updatedScrollLeft !== undefined) baselineScrollLeft.current = updatedScrollLeft;
            return scrollLeft;
        }, [
            setViewportScroll,
            requestViewportScrollBounding
        ]);
        return {
            updateViewportCache: updateViewportCache,
            adjustScrollPositionAndGetOffset: adjustScrollPositionAndGetOffset
        };
    };
});
parcelRegister("er2y9", function(module, exports) {
    $parcel$export(module.exports, "createCalculateScrollOnDragWithOffset", ()=>$4c40bb85342ca2db$export$62b7f59ff4b39d81);
    const $4c40bb85342ca2db$var$SCROLL_SCALE_WITH_OFFSET = 2;
    const $4c40bb85342ca2db$var$getWeightedScrollAmountWithOffset = (scrollAmount)=>Math.round(scrollAmount ** $4c40bb85342ca2db$var$SCROLL_SCALE_WITH_OFFSET);
    const $4c40bb85342ca2db$var$SCROLL_MAX = 150;
    const $4c40bb85342ca2db$var$getThrottledScrollAmount = (scrollAmount)=>Math.min($4c40bb85342ca2db$var$SCROLL_MAX, scrollAmount);
    const $4c40bb85342ca2db$export$62b7f59ff4b39d81 = (scrollThreshold)=>(height, top, bottom, cursorOffset, cursorOffsetDiff, scrollPosition, scrollSize)=>{
            let newScrollPosition = scrollPosition;
            const threshold = Math.min(height / 2, scrollThreshold);
            if (cursorOffset > top && cursorOffset <= top + threshold && cursorOffsetDiff < 0) {
                const scrollAmount = $4c40bb85342ca2db$var$getWeightedScrollAmountWithOffset(1 / ((cursorOffset - top) / threshold));
                const throttledScrollAmount = $4c40bb85342ca2db$var$getThrottledScrollAmount(scrollAmount);
                newScrollPosition = Math.max(0, scrollPosition - throttledScrollAmount);
            } else if (cursorOffset < bottom && cursorOffset >= bottom - threshold && cursorOffset > 0) {
                const scrollAmount = $4c40bb85342ca2db$var$getWeightedScrollAmountWithOffset(1 / ((bottom - cursorOffset) / threshold));
                const throttledScrollAmount = $4c40bb85342ca2db$var$getThrottledScrollAmount(scrollAmount);
                newScrollPosition = Math.min(scrollSize, scrollPosition + throttledScrollAmount);
            }
            return newScrollPosition;
        };
});
parcelRegister("5GeZM", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$f71adb117d5d1a76$export$e324594224ef24da);
    var $hwFXB;
    var $kC16z;
    var $3wUU2;
    var $35zaD;
    var $6lhlv;
    var $l8ERH;
    var $7aEbA;
    var $f5seX;
    const $f71adb117d5d1a76$export$e324594224ef24da = {
        onDrag: (0, parcelRequire("3wUU2")).onDrag,
        onDragEnd: (0, parcelRequire("hwFXB")).onDragEnd,
        onDragStart: (0, parcelRequire("kC16z")).onDragStart,
        onLinger: (0, parcelRequire("l8ERH")).onLinger,
        onLingerEnd: (0, parcelRequire("35zaD")).onLingerEnd,
        onLingerStart: (0, parcelRequire("6lhlv")).onLingerStart,
        onPreview: (0, parcelRequire("7aEbA")).onPreview,
        onToggleHeaderModal: (0, parcelRequire("f5seX")).onToggleHeaderModal
    };
});
parcelRegister("hwFXB", function(module, exports) {
    $parcel$export(module.exports, "onDragEnd", ()=>$9113ed4f231daa8f$export$8566066e92caa8a);
    var $10N8P;
    const $9113ed4f231daa8f$export$8566066e92caa8a = ()=>({ setState: setState }, { sideEffectMarshal: sideEffectMarshal })=>{
            sideEffectMarshal.custom.onBarInteractionEnd();
            const { activeItem: activeItem, hasLingered: hasLingered, ...defaultState } = (0, (0, parcelRequire("10N8P")).DEFAULT_STATE);
            setState(defaultState);
        };
});
parcelRegister("10N8P", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_STATE", ()=>$14da3dcec3f581f5$export$a3a6a28ae8823b06);
    const $14da3dcec3f581f5$export$a3a6a28ae8823b06 = {
        activeItem: undefined,
        hasLingered: false,
        dragType: undefined,
        itemPositions: {},
        targetIntervalId: undefined,
        isHeaderModalActive: false,
        previewBaselinePosition: undefined
    };
});
parcelRegister("kC16z", function(module, exports) {
    $parcel$export(module.exports, "onDragStart", ()=>$84ce831abd593bf8$export$b00174fdb6a6ab8f);
    var $esmwW;
    var $jdJcB;
    const $84ce831abd593bf8$export$b00174fdb6a6ab8f = (id, dragType)=>({ getState: getState, setState: setState }, { items: items, sideEffectMarshal: sideEffectMarshal, setViewportCache: setViewportCache })=>{
            const activeItem = items.find((item)=>item.id === id);
            if (activeItem) {
                const { itemPositions: itemPositions, hasLingered: hasLingeredFromState } = getState();
                const previewBaselinePosition = (0, (0, parcelRequire("jdJcB")).getPreviewBaselinePosition)(activeItem, itemPositions);
                const hasLingered = activeItem.startDateType === (0, (0, parcelRequire("esmwW")).INTERVAL) && activeItem.dueDateType === (0, (0, parcelRequire("esmwW")).INTERVAL) ? hasLingeredFromState : false;
                setViewportCache();
                sideEffectMarshal.custom.onBarInteractionStart();
                setState({
                    activeItem: activeItem,
                    dragType: dragType,
                    previewBaselinePosition: previewBaselinePosition,
                    hasLingered: hasLingered
                });
            }
        };
});
parcelRegister("jdJcB", function(module, exports) {
    $parcel$export(module.exports, "getPreviewBaselinePosition", ()=>$2c057e9eb67186b9$export$6e65532e85c8e991);
    const $2c057e9eb67186b9$export$6e65532e85c8e991 = (activeItem, itemPositions)=>{
        let previewBaselinePosition;
        const { id: id, startDate: startDate, dueDate: dueDate } = activeItem;
        if (startDate === undefined && dueDate === undefined && itemPositions[id]) {
            const { leftPosition: leftPosition, rightPosition: rightPosition } = itemPositions[id];
            if (leftPosition !== undefined && rightPosition !== undefined) previewBaselinePosition = {
                leftPosition: leftPosition,
                rightPosition: rightPosition
            };
        }
        return previewBaselinePosition;
    };
});
parcelRegister("3wUU2", function(module, exports) {
    $parcel$export(module.exports, "onDrag", ()=>$a004b6600311e0d8$export$11a07b18d6f8f6d2);
    var $bJRKQ;
    var $fFUUs;
    const $a004b6600311e0d8$export$11a07b18d6f8f6d2 = (from, to, start)=>({ setState: setState, getState: getState }, containerProps)=>{
            const { activeItem: activeItem, dragType: dragType, itemPositions: itemPositions, previewBaselinePosition: previewBaselinePosition } = getState();
            if (!activeItem || !dragType) return;
            let dragResult;
            const { startDate: startDate, dueDate: dueDate } = activeItem;
            if (startDate === undefined && dueDate === undefined && previewBaselinePosition) {
                const noDateActiveItem = {
                    ...activeItem,
                    startDate: startDate,
                    dueDate: dueDate
                };
                dragResult = (0, (0, parcelRequire("fFUUs")).onNoDateDrag)({
                    from: from,
                    to: to,
                    start: start
                }, {
                    activeItem: noDateActiveItem,
                    dragType: dragType,
                    previewBaselinePosition: previewBaselinePosition
                }, containerProps);
            } else if (startDate !== undefined && dueDate !== undefined) {
                const dateActiveItem = {
                    ...activeItem,
                    startDate: startDate,
                    dueDate: dueDate
                };
                dragResult = (0, (0, parcelRequire("bJRKQ")).onDateDrag)({
                    from: from,
                    to: to,
                    start: start
                }, {
                    activeItem: dateActiveItem,
                    dragType: dragType,
                    itemPositions: itemPositions
                }, containerProps);
            }
            dragResult && setState(dragResult);
        };
});
parcelRegister("bJRKQ", function(module, exports) {
    $parcel$export(module.exports, "onDateDrag", ()=>$4b640855180a9ba7$export$6abaacf95e615b18);
    var $gccSB = parcelRequire("gccSB");
    var $esmwW;
    var $2KlaV;
    var $7Vii8;
    var $jeYNi;
    const $4b640855180a9ba7$export$6abaacf95e615b18 = (dragPosition, { activeItem: activeItem, dragType: dragType, itemPositions: itemPositions }, { items: items, selectedItemIds: selectedItemIds, timelineDuration: timelineDuration, timelineWidth: timelineWidth, isDragAlongEnabled: isDragAlongEnabled, getScrollOffset: getScrollOffset, simpleIntervals: simpleIntervals })=>{
        const gridSize = (0, (0, parcelRequire("7Vii8")).getGridSize)(timelineDuration, timelineWidth);
        const scrollOffset = getScrollOffset(dragPosition.from, dragPosition.to);
        const { selectedItems: selectedItems, childItemsHash: childItemsHash } = (0, (0, parcelRequire("jeYNi")).getItemsCollection)(items, selectedItemIds);
        const newItemPositions = {};
        const handleDrag = (targetItem)=>{
            const { leftPosition: leftPosition, rightPosition: rightPosition } = (0, (0, parcelRequire("jeYNi")).getDragPosition)(dragType, targetItem, timelineDuration, timelineWidth, dragPosition, gridSize, scrollOffset);
            if (leftPosition === undefined && rightPosition === undefined) return;
            newItemPositions[targetItem.id] = {
                leftPosition: leftPosition,
                rightPosition: rightPosition
            };
            if (isDragAlongEnabled && dragType === (0, (0, parcelRequire("2KlaV")).LEFT_AND_RIGHT)) {
                const childItems = childItemsHash[targetItem.id] || [];
                childItems.forEach((childItem)=>{
                    const { leftPosition: childLeftPosition, rightPosition: childRightPosition } = (0, (0, parcelRequire("jeYNi")).getDragPosition)(dragType, childItem, timelineDuration, timelineWidth, dragPosition, gridSize, scrollOffset);
                    if (childLeftPosition !== undefined || childRightPosition !== undefined) newItemPositions[childItem.id] = {
                        leftPosition: childLeftPosition,
                        rightPosition: childRightPosition
                    };
                });
            }
        };
        let targetIntervalId;
        const { id: id, intervalId: intervalId, startDateType: startDateType, dueDateType: dueDateType } = activeItem;
        if (selectedItemIds.length > 1 && selectedItemIds.includes(id) && startDateType !== (0, (0, parcelRequire("esmwW")).INTERVAL) && dueDateType !== (0, (0, parcelRequire("esmwW")).INTERVAL)) {
            selectedItems.forEach((item)=>{
                handleDrag(item);
            });
            if ((0, ($parcel$interopDefault($gccSB)))(newItemPositions)) return undefined;
        } else {
            handleDrag(activeItem);
            if ((0, ($parcel$interopDefault($gccSB)))(newItemPositions)) return undefined;
            const { leftPosition: leftPosition, rightPosition: rightPosition } = newItemPositions[id];
            if (intervalId !== undefined && dragType === (0, (0, parcelRequire("2KlaV")).LEFT_AND_RIGHT) && leftPosition !== undefined && rightPosition !== undefined) {
                const midPosition = (timelineWidth - rightPosition - leftPosition) / 2 + leftPosition;
                const unsafeTargetIntervalId = (0, (0, parcelRequire("7Vii8")).getTargetIntervalId)(simpleIntervals, timelineWidth, midPosition);
                if (unsafeTargetIntervalId !== intervalId) targetIntervalId = unsafeTargetIntervalId;
            }
        }
        return {
            itemPositions: {
                ...itemPositions,
                ...newItemPositions
            },
            targetIntervalId: targetIntervalId
        };
    };
});
parcelRegister("7Vii8", function(module, exports) {
    $parcel$export(module.exports, "to1DP", ()=>$c3012527d6a31ffc$export$6c9c23d367dcea0f);
    $parcel$export(module.exports, "getTargetIntervalId", ()=>$c3012527d6a31ffc$export$fd188f2e31f7a51c);
    $parcel$export(module.exports, "getGridSize", ()=>$c3012527d6a31ffc$export$3a0507da8b146ff1);
    $parcel$export(module.exports, "snapToGrid", ()=>$c3012527d6a31ffc$export$195604d042fd3f87);
    var $8QpSo;
    var $2gnC5 = parcelRequire("2gnC5");
    const $c3012527d6a31ffc$export$6c9c23d367dcea0f = (value)=>Math.round((value + Number.EPSILON) * 10) / 10;
    const $c3012527d6a31ffc$export$fd188f2e31f7a51c = (simpleIntervals, timelineWidth, posX)=>{
        const overlappingIntervals = simpleIntervals.filter(({ leftPosition: leftPosition, rightPosition: rightPosition })=>{
            const isItemStartEqualToOrGreaterThanIntervalStart = $c3012527d6a31ffc$export$6c9c23d367dcea0f(posX) >= $c3012527d6a31ffc$export$6c9c23d367dcea0f(leftPosition);
            const isItemStartLessThanIntervalEnd = $c3012527d6a31ffc$export$6c9c23d367dcea0f(posX) < $c3012527d6a31ffc$export$6c9c23d367dcea0f(timelineWidth - rightPosition);
            return isItemStartEqualToOrGreaterThanIntervalStart && isItemStartLessThanIntervalEnd;
        });
        return overlappingIntervals.length > 0 ? overlappingIntervals[0].targetId : undefined;
    };
    const $c3012527d6a31ffc$export$3a0507da8b146ff1 = (0, (0, parcelRequire("8QpSo")).default)(({ endMilliseconds: endMilliseconds, startMilliseconds: startMilliseconds }, timelineWidth)=>{
        const numberOfDaysInTimeline = (0, ($parcel$interopDefault($2gnC5)))(endMilliseconds).diff(startMilliseconds, 'days') + 1;
        return timelineWidth / numberOfDaysInTimeline;
    });
    const $c3012527d6a31ffc$export$195604d042fd3f87 = (position, gridSize, offset = 0)=>{
        const roundedOffset = Math.round(offset / gridSize) * gridSize;
        return position + roundedOffset;
    };
});
parcelRegister("jeYNi", function(module, exports) {
    $parcel$export(module.exports, "getDragPosition", ()=>$9f9a455828c38dc2$export$43fc86aa4efa07b0);
    $parcel$export(module.exports, "getItemsCollection", ()=>$9f9a455828c38dc2$export$68a20f16cafe8131);
    var $8QpSo;
    var $15ADj;
    var $esmwW;
    var $2KlaV;
    var $apjDv;
    var $7Vii8;
    const $9f9a455828c38dc2$export$38e26b36381469ee = (dragType, hasLeftPlaceholder, dateType)=>dragType === (0, (0, parcelRequire("2KlaV")).LEFT_AND_RIGHT) || dragType === (0, (0, parcelRequire("2KlaV")).LEFT) || dragType === (0, (0, parcelRequire("2KlaV")).RIGHT) && hasLeftPlaceholder && dateType !== (0, (0, parcelRequire("esmwW")).ROLLUP);
    const $9f9a455828c38dc2$export$40ce9920ffc376d2 = (dragType, hasRightPlaceholder, dateType)=>dragType === (0, (0, parcelRequire("2KlaV")).LEFT_AND_RIGHT) || dragType === (0, (0, parcelRequire("2KlaV")).RIGHT) || dragType === (0, (0, parcelRequire("2KlaV")).LEFT) && hasRightPlaceholder && dateType !== (0, (0, parcelRequire("esmwW")).ROLLUP);
    const $9f9a455828c38dc2$export$94ff4f58995a561 = (dragType, leftPosition, rightPosition, timelineWidth, direction)=>{
        if (dragType === (0, (0, parcelRequire("2KlaV")).LEFT_AND_RIGHT) && leftPosition < 0 && direction === (0, (0, parcelRequire("2KlaV")).LEFT)) return false;
        if (dragType === (0, (0, parcelRequire("2KlaV")).LEFT_AND_RIGHT) && rightPosition < 0 && direction === (0, (0, parcelRequire("2KlaV")).RIGHT)) return false;
        if (dragType === (0, (0, parcelRequire("2KlaV")).LEFT) && (leftPosition < 0 || leftPosition > timelineWidth)) return false;
        if (dragType === (0, (0, parcelRequire("2KlaV")).RIGHT) && (rightPosition < 0 || rightPosition > timelineWidth)) return false;
        if (dragType === (0, (0, parcelRequire("2KlaV")).LEFT) || dragType === (0, (0, parcelRequire("2KlaV")).RIGHT)) return timelineWidth - rightPosition - leftPosition > (0, (0, parcelRequire("15ADj")).MINIMUM_BAR_LENGTH);
        return true;
    };
    const $9f9a455828c38dc2$var$getDragDirection = (dragType, leftPosition, baselineLeftPosition)=>{
        if (dragType === (0, (0, parcelRequire("2KlaV")).LEFT_AND_RIGHT)) return leftPosition !== undefined && leftPosition < baselineLeftPosition ? (0, (0, parcelRequire("2KlaV")).LEFT) : (0, (0, parcelRequire("2KlaV")).RIGHT);
        if (dragType === (0, (0, parcelRequire("2KlaV")).LEFT)) return 0, (0, parcelRequire("2KlaV")).LEFT;
        return 0, (0, parcelRequire("2KlaV")).RIGHT;
    };
    const $9f9a455828c38dc2$export$43fc86aa4efa07b0 = (dragType, item, timelineDuration, timelineWidth, { to: to, start: start }, gridSize, scrollOffset)=>{
        let leftPosition;
        let rightPosition;
        const { startDate: startDate, dueDate: dueDate, placeholder: placeholder, startDateType: startDateType, dueDateType: dueDateType } = item;
        const baselineLeftPosition = (0, (0, parcelRequire("apjDv")).getBarLeftPosition)(startDate, timelineDuration, timelineWidth);
        const baselineRightPosition = (0, (0, parcelRequire("apjDv")).getBarRightPosition)(dueDate, timelineDuration, timelineWidth);
        const hasLeftPlaceholder = placeholder === (0, (0, parcelRequire("15ADj")).START_DATE_PLACEHOLDER) || placeholder === (0, (0, parcelRequire("15ADj")).START_AND_DUE_DATE_PLACEHOLDER);
        const hasRightPlaceholder = placeholder === (0, (0, parcelRequire("15ADj")).DUE_DATE_PLACEHOLDER) || placeholder === (0, (0, parcelRequire("15ADj")).START_AND_DUE_DATE_PLACEHOLDER);
        if ($9f9a455828c38dc2$export$38e26b36381469ee(dragType, hasLeftPlaceholder, startDateType)) {
            const offset = to.x - start.x - scrollOffset;
            leftPosition = (0, (0, parcelRequire("7Vii8")).snapToGrid)(baselineLeftPosition, gridSize, offset);
        }
        if ($9f9a455828c38dc2$export$40ce9920ffc376d2(dragType, hasRightPlaceholder, dueDateType)) {
            const offset = start.x - to.x + scrollOffset;
            rightPosition = (0, (0, parcelRequire("7Vii8")).snapToGrid)(baselineRightPosition, gridSize, offset);
        }
        const actualLeftPosition = leftPosition ?? baselineLeftPosition;
        const actualRightPosition = rightPosition ?? baselineRightPosition;
        const direction = $9f9a455828c38dc2$var$getDragDirection(dragType, leftPosition, baselineLeftPosition);
        if ($9f9a455828c38dc2$export$94ff4f58995a561(dragType, actualLeftPosition, actualRightPosition, timelineWidth, direction)) return {
            leftPosition: leftPosition,
            rightPosition: rightPosition
        };
        return {
            leftPosition: undefined,
            rightPosition: undefined
        };
    };
    const $9f9a455828c38dc2$var$isDateInteractiveChartItem = (item)=>item.startDate !== undefined && item.dueDate !== undefined;
    const $9f9a455828c38dc2$export$68a20f16cafe8131 = (0, (0, parcelRequire("8QpSo")).default)((items, selectedItemIds)=>{
        const itemsTree = items.reduce((acc, item)=>{
            if (item.parentId && $9f9a455828c38dc2$var$isDateInteractiveChartItem(item)) {
                const childItems = acc[item.parentId] ?? [];
                childItems.push(item);
                acc[item.parentId] = childItems;
            }
            return acc;
        }, {});
        const descendantItemsHash = {};
        const findDescendants = (parentId)=>{
            if (descendantItemsHash[parentId]) return descendantItemsHash[parentId];
            const children = itemsTree[parentId] ?? [];
            const descendants = children.flatMap((child)=>[
                    child,
                    ...findDescendants(child.id)
                ]);
            descendantItemsHash[parentId] = descendants;
            return descendants;
        };
        return items.reduce((acc, item)=>{
            if (!$9f9a455828c38dc2$var$isDateInteractiveChartItem(item)) return acc;
            if (selectedItemIds.includes(item.id)) acc.selectedItems.push(item);
            if (item.parentId) acc.childItemsHash[item.parentId] = findDescendants(item.parentId);
            return acc;
        }, {
            selectedItems: [],
            childItemsHash: {}
        });
    });
});
parcelRegister("apjDv", function(module, exports) {
    $parcel$export(module.exports, "getBarLeftPosition", ()=>$bc5642321ea52013$export$7515da295c144459);
    $parcel$export(module.exports, "getBarRightPosition", ()=>$bc5642321ea52013$export$6d1b18b85e7cc7aa);
    $parcel$export(module.exports, "getStartDate", ()=>$bc5642321ea52013$export$3ee8fbdbeceaef0e);
    $parcel$export(module.exports, "getDueDate", ()=>$bc5642321ea52013$export$813ac50a60a492f2);
    $parcel$export(module.exports, "getIsBarVisible", ()=>$bc5642321ea52013$export$4a4fadfd0dbb59d8);
    var $bFxJH;
    var $esmwW;
    const $bc5642321ea52013$export$7515da295c144459 = (startDate, timelineDuration, timelineWidth)=>(0, (0, parcelRequire("bFxJH")).getTimelinePositionFromDate)(timelineDuration, timelineWidth, startDate);
    const $bc5642321ea52013$export$6d1b18b85e7cc7aa = (dueDate, timelineDuration, timelineWidth)=>{
        const endOfDueDate = dueDate + (0, (0, parcelRequire("esmwW")).DUE_DATE_OFFSET);
        const leftPosition = (0, (0, parcelRequire("bFxJH")).getTimelinePositionFromDate)(timelineDuration, timelineWidth, endOfDueDate);
        return timelineWidth - leftPosition;
    };
    const $bc5642321ea52013$export$b6b0beaf88b31f31 = (date)=>Math.round(date / (0, $a797a5154a1373bc$export$1f04624003d2da7d)) * (0, $a797a5154a1373bc$export$1f04624003d2da7d);
    const $bc5642321ea52013$export$3ee8fbdbeceaef0e = (leftPosition, timelineDuration, timelineWidth)=>{
        const startDate = (0, (0, parcelRequire("bFxJH")).getDateFromTimelinePosition)(timelineDuration, timelineWidth, leftPosition);
        return $bc5642321ea52013$export$b6b0beaf88b31f31(startDate);
    };
    const $bc5642321ea52013$export$813ac50a60a492f2 = (rightPosition, timelineDuration, timelineWidth)=>{
        const dueDate = (0, (0, parcelRequire("bFxJH")).getDateFromTimelinePosition)(timelineDuration, timelineWidth, timelineWidth - rightPosition) - (0, (0, parcelRequire("esmwW")).DUE_DATE_OFFSET);
        return $bc5642321ea52013$export$b6b0beaf88b31f31(dueDate);
    };
    const $bc5642321ea52013$export$4a4fadfd0dbb59d8 = (barLeftPosition, barRightPosition, timelineWidth)=>{
        const isBeforeTimeline = barLeftPosition < 0 && barRightPosition >= timelineWidth;
        const isAfterTimeline = barLeftPosition >= timelineWidth && barRightPosition < 0;
        return !isBeforeTimeline && !isAfterTimeline;
    };
});
parcelRegister("fFUUs", function(module, exports) {
    $parcel$export(module.exports, "onNoDateDrag", ()=>$bdfedcd5913d8d4c$export$30770ba27cbf606f);
    var $2KlaV;
    var $7Vii8;
    var $3Fuwz;
    const $bdfedcd5913d8d4c$export$30770ba27cbf606f = ({ from: from, to: to, start: start }, { activeItem: activeItem, dragType: dragType, previewBaselinePosition: previewBaselinePosition }, { timelineDuration: timelineDuration, timelineWidth: timelineWidth, getScrollOffset: getScrollOffset, simpleIntervals: simpleIntervals })=>{
        const gridSize = (0, (0, parcelRequire("7Vii8")).getGridSize)(timelineDuration, timelineWidth);
        const scrollOffset = getScrollOffset(from, to);
        const startPosition = previewBaselinePosition.leftPosition;
        let leftPosition;
        let rightPosition;
        let nextDragType;
        if (dragType === (0, (0, parcelRequire("2KlaV")).LEFT)) {
            const offset = to.x - start.x - scrollOffset;
            rightPosition = timelineWidth - startPosition;
            leftPosition = (0, (0, parcelRequire("7Vii8")).snapToGrid)(startPosition, gridSize, offset);
            nextDragType = leftPosition < startPosition ? (0, (0, parcelRequire("2KlaV")).LEFT) : (0, (0, parcelRequire("2KlaV")).RIGHT);
        } else {
            const offset = to.x - start.x - scrollOffset;
            leftPosition = startPosition;
            rightPosition = timelineWidth - (0, (0, parcelRequire("7Vii8")).snapToGrid)(startPosition, gridSize, offset);
            nextDragType = timelineWidth - rightPosition < startPosition ? (0, (0, parcelRequire("2KlaV")).LEFT) : (0, (0, parcelRequire("2KlaV")).RIGHT);
        }
        if (!(0, (0, parcelRequire("3Fuwz")).isValidDrag)(leftPosition, rightPosition, gridSize, timelineWidth)) return undefined;
        const targetIntervalId = (0, (0, parcelRequire("7Vii8")).getTargetIntervalId)(simpleIntervals, timelineWidth, leftPosition);
        return {
            itemPositions: {
                [`${activeItem.id}`]: {
                    leftPosition: leftPosition,
                    rightPosition: rightPosition
                }
            },
            targetIntervalId: targetIntervalId,
            dragType: nextDragType
        };
    };
});
parcelRegister("3Fuwz", function(module, exports) {
    $parcel$export(module.exports, "isValidDrag", ()=>$24cf25217aee2184$export$94ff4f58995a561);
    var $7Vii8;
    const $24cf25217aee2184$export$94ff4f58995a561 = (leftPosition, rightPosition, gridSize, timelineWidth)=>{
        const distance = Math.abs(timelineWidth - rightPosition - leftPosition);
        return (0, (0, parcelRequire("7Vii8")).to1DP)(distance) >= (0, (0, parcelRequire("7Vii8")).to1DP)(gridSize);
    };
});
parcelRegister("35zaD", function(module, exports) {
    $parcel$export(module.exports, "onLingerEnd", ()=>$a562fef7e4da64db$export$5066f5e6e6738857);
    var $10N8P;
    const $a562fef7e4da64db$export$5066f5e6e6738857 = ()=>({ getState: getState, setState: setState })=>{
            const { dragType: dragType } = getState();
            if (dragType === undefined) setState((0, (0, parcelRequire("10N8P")).DEFAULT_STATE));
        };
});
parcelRegister("6lhlv", function(module, exports) {
    $parcel$export(module.exports, "onLingerStart", ()=>$d37a815130e6b7c6$export$bb211627ff50e51b);
    const $d37a815130e6b7c6$export$bb211627ff50e51b = (id)=>({ getState: getState, setState: setState }, { items: items })=>{
            const { dragType: dragType } = getState();
            const activeItem = items.find((item)=>item.id === id);
            if (activeItem !== undefined && dragType === undefined) setState({
                activeItem: activeItem
            });
        };
});
parcelRegister("l8ERH", function(module, exports) {
    $parcel$export(module.exports, "onLinger", ()=>$6c72e0444690396b$export$c9ef8a8ee2b7f513);
    var $esmwW;
    var $7Vii8;
    const $6c72e0444690396b$export$c9ef8a8ee2b7f513 = ()=>({ getState: getState, setState: setState }, { timelineWidth: timelineWidth, simpleIntervals: simpleIntervals })=>{
            const { activeItem: activeItem, itemPositions: itemPositions } = getState();
            if (activeItem?.startDateType === (0, (0, parcelRequire("esmwW")).INTERVAL) && activeItem?.dueDateType === (0, (0, parcelRequire("esmwW")).INTERVAL) || activeItem?.intervalId !== undefined) {
                let targetIntervalId;
                const { id: id, startDate: startDate, dueDate: dueDate, intervalId: intervalId } = activeItem;
                const leftPosition = itemPositions[id]?.leftPosition;
                if (startDate !== undefined && dueDate !== undefined) {
                    const isIntervalExists = simpleIntervals.find(({ intervalIds: intervalIds })=>intervalId && intervalIds.includes(intervalId));
                    if (isIntervalExists) targetIntervalId = intervalId;
                } else if (leftPosition !== undefined && activeItem.startDateType === (0, (0, parcelRequire("esmwW")).INTERVAL) && activeItem.dueDateType === (0, (0, parcelRequire("esmwW")).INTERVAL)) targetIntervalId = (0, (0, parcelRequire("7Vii8")).getTargetIntervalId)(simpleIntervals, timelineWidth, leftPosition);
                setState({
                    hasLingered: true,
                    targetIntervalId: targetIntervalId
                });
            }
        };
});
parcelRegister("7aEbA", function(module, exports) {
    $parcel$export(module.exports, "onPreview", ()=>$bfa3eb54673fbc8b$export$9d4a8aef590e6b33);
    var $iZN6h;
    var $esmwW;
    var $7Vii8;
    const $bfa3eb54673fbc8b$var$TIMELINE_MODE_OFFSET = {
        [(0, (0, parcelRequire("iZN6h")).WEEKS)]: 7,
        [(0, (0, parcelRequire("iZN6h")).MONTHS)]: 14,
        [(0, (0, parcelRequire("iZN6h")).QUARTERS)]: 30
    };
    const $bfa3eb54673fbc8b$export$9d4a8aef590e6b33 = (previewX)=>({ getState: getState, setState: setState }, { timelineMode: timelineMode, timelineDuration: timelineDuration, timelineWidth: timelineWidth, simpleIntervals: simpleIntervals })=>{
            const { activeItem: activeItem, dragType: dragType } = getState();
            if (!activeItem || activeItem && dragType) return;
            const isInterval = activeItem.startDateType === (0, (0, parcelRequire("esmwW")).INTERVAL) && activeItem.dueDateType === (0, (0, parcelRequire("esmwW")).INTERVAL);
            let leftPosition;
            let rightPosition;
            let targetIntervalId;
            const gridSize = (0, (0, parcelRequire("7Vii8")).getGridSize)(timelineDuration, timelineWidth);
            const leftPositionSnapToGrid = (0, (0, parcelRequire("7Vii8")).snapToGrid)(0, gridSize, previewX);
            if (!isInterval) {
                const rightOffset = $bfa3eb54673fbc8b$var$TIMELINE_MODE_OFFSET[timelineMode] * gridSize;
                leftPosition = leftPositionSnapToGrid;
                rightPosition = timelineWidth - (leftPosition + rightOffset);
            } else targetIntervalId = (0, (0, parcelRequire("7Vii8")).getTargetIntervalId)(simpleIntervals, timelineWidth, previewX);
            setState({
                itemPositions: {
                    [`${activeItem.id}`]: {
                        leftPosition: leftPosition,
                        rightPosition: rightPosition
                    }
                },
                targetIntervalId: targetIntervalId
            });
        };
});
parcelRegister("f5seX", function(module, exports) {
    $parcel$export(module.exports, "onToggleHeaderModal", ()=>$00ee78e6442dbb43$export$8560de0545726746);
    const $00ee78e6442dbb43$export$8560de0545726746 = (isActive)=>({ setState: setState })=>{
            setState({
                isHeaderModalActive: isActive
            });
        };
});
parcelRegister("aTYP2", function(module, exports) {
    $parcel$export(module.exports, "getTargetIntervalId", ()=>$4e401c79111c6cdb$export$fd188f2e31f7a51c);
    $parcel$export(module.exports, "getInteractionDataById", ()=>$4e401c79111c6cdb$export$56ac7aa92dc17fde);
    $parcel$export(module.exports, "getIsHeaderModalActive", ()=>$4e401c79111c6cdb$export$1c272fb440996072);
    $parcel$export(module.exports, "getIntervalDropZoneDataById", ()=>$4e401c79111c6cdb$export$416f05e681eaec5b);
    var $esmwW;
    const $4e401c79111c6cdb$export$fd188f2e31f7a51c = ({ targetIntervalId: targetIntervalId, hasLingered: hasLingered }, intervals)=>{
        if (hasLingered) {
            const targetInterval = intervals.find(({ id: id })=>id === targetIntervalId);
            return targetInterval?.id;
        }
        return undefined;
    };
    const $4e401c79111c6cdb$export$56ac7aa92dc17fde = ({ activeItem: activeItem, dragType: dragType, itemPositions: itemPositions }, id)=>{
        const leftPosition = itemPositions[id]?.leftPosition;
        const rightPosition = itemPositions[id]?.rightPosition;
        const hasAnyPosition = leftPosition !== undefined || rightPosition !== undefined;
        return {
            isActive: activeItem?.id === id,
            leftPosition: leftPosition,
            rightPosition: rightPosition,
            dragType: hasAnyPosition ? dragType : undefined
        };
    };
    const $4e401c79111c6cdb$export$1c272fb440996072 = ({ isHeaderModalActive: isHeaderModalActive })=>({
            isHeaderModalActive: isHeaderModalActive
        });
    const $4e401c79111c6cdb$export$416f05e681eaec5b = ({ activeItem: activeItem, dragType: dragType, hasLingered: hasLingered }, id)=>{
        if (!activeItem || activeItem.id !== id || activeItem.startDateType !== (0, (0, parcelRequire("esmwW")).INTERVAL) && activeItem.dueDateType !== (0, (0, parcelRequire("esmwW")).INTERVAL)) return {
            isVisible: false,
            currentIntervalId: undefined
        };
        if (activeItem.startDate !== undefined && activeItem.dueDate !== undefined) return {
            isVisible: dragType !== undefined,
            currentIntervalId: activeItem.intervalId
        };
        return {
            isVisible: hasLingered,
            currentIntervalId: activeItem.intervalId
        };
    };
});
parcelRegister("g85ud", function(module, exports) {
    $parcel$export(module.exports, "getSimpleIntervals", ()=>$e5507fe0fa149fbb$export$ba37947e5e9cffea);
    var $8QpSo;
    var $igUC7;
    const $e5507fe0fa149fbb$export$ba37947e5e9cffea = (0, (0, parcelRequire("8QpSo")).default)((intervals, timelineDuration, timelineWidth)=>{
        const intervalGroups = (0, (0, parcelRequire("igUC7")).getIntervalGroupPositions)(intervals, timelineDuration, timelineWidth);
        const simpleIntervals = [];
        intervalGroups.forEach((intervalGroup)=>{
            const leftPosition = Math.max(intervalGroup.left, intervalGroup.targetIntervalLeft);
            const rightPosition = Math.max(intervalGroup.right, intervalGroup.targetIntervalRight);
            const targetInterval = intervalGroup.intervals.find((interval)=>interval.state !== (0, $8e299570902dfa36$export$19c4f83398a8dbce));
            const intervalIds = intervals.map((interval)=>interval.id);
            if (targetInterval) simpleIntervals.push({
                targetId: targetInterval.id,
                leftPosition: leftPosition,
                rightPosition: rightPosition,
                intervalIds: intervalIds
            });
        });
        return simpleIntervals;
    });
});
const $8e299570902dfa36$export$19c4f83398a8dbce = 'CLOSED';
const $8e299570902dfa36$export$2b35adb71b3f6143 = 'ACTIVE';
const $8e299570902dfa36$export$47b7b82714c61a7c = 'FUTURE';
parcelRegister("igUC7", function(module, exports) {
    $parcel$export(module.exports, "getIntervalGroupPositions", ()=>$d4cefde65ec9525a$export$209e346bf640604);
    var $esmwW;
    var $apjDv;
    var $20Qxl;
    const $d4cefde65ec9525a$export$cd3d993a5aa1490e = (intervals, timelineDuration)=>{
        const saneIntervals = [];
        intervals.forEach((interval)=>{
            const saneStartDate = Math.min(interval.startDate, interval.endDate);
            const saneEndDate = Math.max(interval.startDate, interval.endDate) + (0, (0, parcelRequire("esmwW")).DUE_DATE_OFFSET);
            const isStartInTimeline = saneStartDate >= timelineDuration.startMilliseconds && saneStartDate <= timelineDuration.endMilliseconds;
            const isEndInTimeline = saneEndDate >= timelineDuration.startMilliseconds && saneEndDate <= timelineDuration.endMilliseconds;
            const isLongerThanTimeline = saneStartDate <= timelineDuration.startMilliseconds && saneEndDate >= timelineDuration.endMilliseconds;
            if (isStartInTimeline || isEndInTimeline || isLongerThanTimeline) saneIntervals.push({
                id: interval.id,
                name: interval.name,
                state: interval.state,
                startDate: saneStartDate,
                endDate: saneEndDate
            });
        });
        return saneIntervals;
    };
    const $d4cefde65ec9525a$export$487a26b15ffb2465 = (intervalGroup, timelineDuration, timelineWidth)=>{
        const { startDate: startDate, endDate: endDate, expandedEndDate: expandedEndDate, intervals: intervals } = intervalGroup;
        const intervalsPositions = {};
        intervals.forEach((interval)=>{
            const left = (0, (0, parcelRequire("apjDv")).getBarLeftPosition)(interval.startDate, timelineDuration, timelineWidth);
            const right = (0, (0, parcelRequire("apjDv")).getBarRightPosition)(interval.endDate - (0, (0, parcelRequire("esmwW")).DUE_DATE_OFFSET), timelineDuration, timelineWidth);
            intervalsPositions[interval.id] = {
                left: Math.max(0, left),
                right: Math.max(0, right)
            };
        });
        const left = (0, (0, parcelRequire("apjDv")).getBarLeftPosition)(startDate, timelineDuration, timelineWidth);
        const right = (0, (0, parcelRequire("apjDv")).getBarRightPosition)(endDate - (0, (0, parcelRequire("esmwW")).DUE_DATE_OFFSET), timelineDuration, timelineWidth);
        const rightExpanded = (0, (0, parcelRequire("apjDv")).getBarRightPosition)(expandedEndDate - (0, (0, parcelRequire("esmwW")).DUE_DATE_OFFSET), timelineDuration, timelineWidth);
        let targetIntervalLeft = left;
        let targetIntervalRight = right;
        const targetInterval = intervals.find((interval)=>interval.state !== (0, $8e299570902dfa36$export$19c4f83398a8dbce));
        if (targetInterval !== undefined && intervalsPositions[targetInterval.id]) {
            targetIntervalLeft = intervalsPositions[targetInterval.id].left;
            targetIntervalRight = intervalsPositions[targetInterval.id].right;
        }
        const clippedLeft = Math.max(0, left);
        const clippedRight = Math.max(0, right);
        const clippedTargetLeft = Math.max(0, targetIntervalLeft);
        const clippedTargetRight = Math.max(0, targetIntervalRight);
        const clippedRightExpanded = Math.max(0, rightExpanded);
        const width = timelineWidth - clippedLeft - clippedRight;
        const widthExpanded = timelineWidth - clippedLeft - clippedRightExpanded;
        return {
            isLeftClipped: left !== clippedLeft,
            isRightClipped: right !== clippedRight,
            isRightExpandedClipped: rightExpanded !== clippedRightExpanded,
            left: clippedLeft,
            right: clippedRight,
            targetIntervalLeft: clippedTargetLeft,
            targetIntervalRight: clippedTargetRight,
            rightExpanded: clippedRightExpanded,
            width: width,
            widthExpanded: widthExpanded,
            intervalsPositions: intervalsPositions,
            intervals: intervals
        };
    };
    const $d4cefde65ec9525a$export$209e346bf640604 = (intervals, timelineDuration, timelineWidth)=>{
        const saneIntervals = $d4cefde65ec9525a$export$cd3d993a5aa1490e(intervals, timelineDuration);
        const intervalGroups = (0, (0, parcelRequire("20Qxl")).groupOverlappingIntervals)(saneIntervals);
        return intervalGroups.map((intervalGroup)=>$d4cefde65ec9525a$export$487a26b15ffb2465(intervalGroup, timelineDuration, timelineWidth));
    };
});
parcelRegister("20Qxl", function(module, exports) {
    $parcel$export(module.exports, "groupOverlappingIntervals", ()=>$4793e10e3de30786$export$1b45218c7b9e570f);
    const $4793e10e3de30786$export$1b45218c7b9e570f = (intervals)=>{
        const intervalsWithIndex = intervals.map((interval, index)=>({
                ...interval,
                index: index
            }));
        const sortedIntervals = [
            ...intervalsWithIndex
        ].sort((interval, otherInterval)=>{
            const endComparison = interval.endDate - otherInterval.endDate;
            if (endComparison !== 0) return endComparison;
            return otherInterval.startDate - interval.startDate;
        });
        let result = [];
        let i = sortedIntervals.length - 1;
        while(i >= 0){
            const currentInterval = sortedIntervals[i];
            let groupedIntervals = [
                currentInterval
            ];
            let j = i - 1;
            while(j >= 0){
                const nextInterval = sortedIntervals[j];
                const isNextIntervalCompletelyOverlapped = currentInterval.startDate <= nextInterval.startDate;
                if (isNextIntervalCompletelyOverlapped) groupedIntervals = [
                    nextInterval
                ].concat(groupedIntervals);
                else break;
                j -= 1;
            }
            const groupedIntervalsInOriginalOrdering = groupedIntervals.sort((interval, otherInterval)=>interval.index - otherInterval.index).map(({ index: index, ...interval })=>interval);
            result = [
                {
                    startDate: currentInterval.startDate,
                    endDate: currentInterval.endDate,
                    expandedEndDate: currentInterval.endDate,
                    intervals: groupedIntervalsInOriginalOrdering
                }
            ].concat(result);
            i = j;
        }
        if (result.length >= 2) for(let k = 0; k < result.length - 1; k += 1){
            const currentIntervalGroup = result[k];
            const nextIntervalGroup = result[k + 1];
            if (currentIntervalGroup.endDate > nextIntervalGroup.startDate) currentIntervalGroup.endDate = nextIntervalGroup.startDate;
        }
        return result;
    };
});
parcelRegister("dEqGC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f8f4bdb7aa6a7a62$export$2e2bcd8739ae039);
    var $7VHMR;
    var $f8f4bdb7aa6a7a62$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        releases: {
            "id": "roadmap.timeline-table-kit.chart-header-item.key-dates.tooltip.releases",
            "defaultMessage": "{noOfReleases} {noOfReleases, plural, one {release} other {releases}}: {releaseNamesAndDates}"
        },
        popupLabel: {
            "id": "roadmap.timeline-table-kit.chart-header-item.key-dates.tooltip.popup-label",
            "defaultMessage": "Release info"
        }
    });
});
parcelRegister("lJjHv", function(module, exports) {
    $parcel$export(module.exports, "getReleaseNamesAndDatesAlly", ()=>$7bf3efa0accda9d1$export$e07503727219f77b);
    var $g11uZ;
    const $7bf3efa0accda9d1$export$e07503727219f77b = (keyDates)=>keyDates.map(({ name: name, date: date })=>`${name} ${(0, (0, parcelRequire("g11uZ")).getDateFromTimestamp)(date)}`).join(', ');
});
parcelRegister("3qgHY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d56f199ee93176b0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $lfTZh;
    var $kxZPA;
    var $eKt4x;
    const $d56f199ee93176b0$var$VersionFlyout = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("dptxP")), {
        ssr: false,
        moduleId: "./src/packages/software/roadmap/standard/src/view/common/table/chart-header-item/releases/flyout/index.tsx"
    });
    var $d56f199ee93176b0$export$2e2bcd8739ae039 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "async-standard-roadmap-version-flyout",
            packageName: (0, (0, parcelRequire("eKt4x")).ROADMAP_PACKAGE_NAME),
            fallback: "flag"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "async-standard-roadmap-version-flyout",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($d56f199ee93176b0$var$VersionFlyout, props)));
});
parcelRegister("dptxP", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gSrM6").then(()=>parcelRequire('aQQiT'));
});
parcelRegister("upR7L", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cfad95171d5247eb$export$2e2bcd8739ae039);
    var $bC2fB;
    var $bZFir;
    var $6efUA;
    const $cfad95171d5247eb$var$mapStateToProps = (state)=>({
            intervals: (0, (0, parcelRequire("bZFir")).getSprintIntervals)(state)
        });
    var $cfad95171d5247eb$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($cfad95171d5247eb$var$mapStateToProps, {})((0, (0, parcelRequire("6efUA")).default));
});
parcelRegister("6efUA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b5440078c3e14ff3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8hFif;
    var $8eMus;
    const $b5440078c3e14ff3$var$RoadmapIntervalsHeader = ({ intervals: intervals })=>{
        const renderPopupContent = (0, $5uXOq.useCallback)((selectedIntervals, setInitialFocusRef)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8eMus")).default), {
                intervals: selectedIntervals,
                setInitialFocusRef: setInitialFocusRef
            }), []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8hFif")).RoadmapIntervals), {
            intervals: intervals,
            renderPopupContent: renderPopupContent
        });
    };
    var $b5440078c3e14ff3$export$2e2bcd8739ae039 = $b5440078c3e14ff3$var$RoadmapIntervalsHeader;
});
parcelRegister("8hFif", function(module, exports) {
    $parcel$export(module.exports, "RoadmapIntervals", ()=>$66a9ffd118d8f66f$export$daf5887cbbb59c3e);
    var $5uXOq = parcelRequire("5uXOq");
    var $biT18;
    var $igUC7;
    var $gEwHu;
    var $ibvNX;
    const $66a9ffd118d8f66f$var$RoadmapIntervals = ({ intervals: intervals, renderPopupContent: renderPopupContent })=>{
        const [{ timelineDuration: timelineDuration, timelineWidth: timelineWidth }] = (0, (0, parcelRequire("biT18")).useTimelineState)();
        const intervalGroups = (0, (0, parcelRequire("igUC7")).getIntervalGroupPositions)(intervals, timelineDuration, timelineWidth);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, intervalGroups.map((intervalGroup, index)=>{
            const hasOpenInterval = intervalGroup.intervals.some(({ state: state })=>state !== (0, $8e299570902dfa36$export$19c4f83398a8dbce));
            const Marker = hasOpenInterval ? (0, (0, parcelRequire("gEwHu")).IntervalMarker) : (0, (0, parcelRequire("ibvNX")).IntervalBaseMarker);
            return (0, ($parcel$interopDefault($5uXOq))).createElement(Marker, {
                key: index,
                intervalGroup: intervalGroup,
                renderPopupContent: renderPopupContent
            });
        }));
    };
    $66a9ffd118d8f66f$var$RoadmapIntervals.whyDidYouRender = true;
    const $66a9ffd118d8f66f$export$daf5887cbbb59c3e = (0, $5uXOq.memo)($66a9ffd118d8f66f$var$RoadmapIntervals);
    $66a9ffd118d8f66f$export$daf5887cbbb59c3e.displayName = 'RoadmapIntervals';
});
parcelRegister("gEwHu", function(module, exports) {
    $parcel$export(module.exports, "IntervalMarker", ()=>$e20cf48f367bb81d$export$2b396c8a14ed518e);
    var $5uXOq = parcelRequire("5uXOq");
    var $gPXTo;
    var $ibvNX;
    const $e20cf48f367bb81d$var$Marker = (props)=>{
        const { intervals: intervals } = props.intervalGroup;
        const [targetIntervalId] = (0, (0, parcelRequire("gPXTo")).useTargetIntervalId)(intervals);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ibvNX")).IntervalBaseMarker), {
            targetIntervalId: targetIntervalId,
            ...props
        });
    };
    $e20cf48f367bb81d$var$Marker.whyDidYouRender = true;
    const $e20cf48f367bb81d$export$2b396c8a14ed518e = (0, $5uXOq.memo)($e20cf48f367bb81d$var$Marker);
    $e20cf48f367bb81d$export$2b396c8a14ed518e.displayName = 'IntervalMarker';
});
parcelRegister("ibvNX", function(module, exports) {
    $parcel$export(module.exports, "IntervalBaseMarker", ()=>$ea0ca1458a693c60$export$11d6002c52c98162);
    var $bwpsq;
    var $lD23V;
    var $5uXOq = parcelRequire("5uXOq");
    var $1I7E8;
    var $dC5iT;
    var $5ILhZ;
    var $cgL5K;
    var $8CUq3;
    var $eTXmK;
    var $4R6GH;
    var $koVbs;
    var $7mPT9;
    var $8zOmE;
    var $2NMNM;
    var $82CeN;
    var $kyahI;
    var $1YcpO;
    var $dCm1o;
    var $hvXFA;
    var $knkJA;
    var $gPXTo;
    var $bmGDh;
    var $h7Ce2;
    var $gTePl;
    var $lFhKE;
    var $4hDMO;
    const $ea0ca1458a693c60$var$EXPANDED_Z_INDEX = 1;
    const $ea0ca1458a693c60$var$BaseMarker = ({ targetIntervalId: targetIntervalId, intervalGroup: intervalGroup, renderPopupContent: renderPopupContent })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { listenToViewportScroll: listenToViewportScroll, stopListeningToViewportScroll: stopListeningToViewportScroll } = (0, (0, parcelRequire("kyahI")).useViewport)();
        const [isMouseEntered, setIsMouseEntered] = (0, $5uXOq.useState)(false);
        const [isPopupActive, setIsPopupActive] = (0, $5uXOq.useState)(false);
        const [{ isHeaderModalActive: isHeaderModalActive }] = (0, (0, parcelRequire("gPXTo")).useIsHeaderModalActive)();
        const { shouldPreventNavigation: shouldPreventNavigation } = (0, (0, parcelRequire("82CeN")).useFocusMarshal)();
        const openPopup = (0, $5uXOq.useCallback)(()=>{
            shouldPreventNavigation(true);
            setIsPopupActive(true);
        }, [
            shouldPreventNavigation
        ]);
        const closePopup = (0, $5uXOq.useCallback)(()=>{
            shouldPreventNavigation(false);
            setIsPopupActive(false);
        }, [
            shouldPreventNavigation
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const onViewPortScrollHandler = ()=>{
                if ((0, (0, parcelRequire("4R6GH")).fg)('timeline_grid_navigation_m2')) closePopup();
                else setIsPopupActive(false);
            };
            listenToViewportScroll(onViewPortScrollHandler);
            return function cleanup() {
                stopListeningToViewportScroll(onViewPortScrollHandler);
            };
        }, [
            closePopup,
            listenToViewportScroll,
            stopListeningToViewportScroll
        ]);
        const { left: left, right: right, rightExpanded: rightExpanded, intervals: intervals } = intervalGroup;
        const isExpandable = right !== rightExpanded;
        const isHighlighted = targetIntervalId !== undefined;
        const isExpanded = isExpandable && (isMouseEntered || isHighlighted);
        const { colors: colors, borders: borders, spacing: spacing, childVisibility: childVisibility } = (0, (0, parcelRequire("lFhKE")).getDynamicMarkerStyles)({
            intervalGroup: intervalGroup,
            isExpanded: isExpanded,
            isExpandable: isExpandable,
            isHighlighted: isHighlighted
        });
        const { isLabelVisible: isLabelVisible, isExpandIndicatorVisible: isExpandIndicatorVisible } = childVisibility;
        const label = (0, (0, parcelRequire("4hDMO")).getLabel)({
            intervals: intervals,
            targetIntervalId: targetIntervalId,
            isLabelVisible: isLabelVisible
        });
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const onMouseEnter = ()=>{
            if (!isPopupActive) setIsMouseEntered(true);
        };
        const onMouseLeave = ()=>{
            if (!isPopupActive) setIsMouseEntered(false);
        };
        const onClickContainer = (0, $5uXOq.useCallback)((event)=>{
            (0, (0, parcelRequire("eTXmK")).default)('timeline-interval-marker-clicked', event.timeStamp);
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'intervalsMarker', {
                numberOfMarker: intervals.length
            });
            if ((0, (0, parcelRequire("4R6GH")).fg)('timeline_grid_navigation_m2')) openPopup();
            else setIsPopupActive(true);
        }, [
            createAnalyticsEvent,
            intervals.length,
            openPopup
        ]);
        const handleKeyDown = (event)=>{
            if ((0, (0, parcelRequire("1YcpO")).isEnterOrSpaceKey)(event)) {
                event.preventDefault();
                if ((0, (0, parcelRequire("4R6GH")).fg)('timeline_grid_navigation_m2')) openPopup();
                else setIsPopupActive(true);
            }
        };
        const renderMarker = ({ ref: triggerRef, ...restTriggerProps }, tooltipProps)=>{
            const { ref: tooltipRef, onFocus: onFocus, onBlur: onBlur, onClick: onClick, ...restTooltipProps } = tooltipProps ?? {};
            const handleOnFocus = (event)=>{
                onMouseEnter();
                onFocus?.(event);
            };
            const handleOnBlur = (event)=>{
                onMouseLeave();
                onBlur?.(event);
            };
            const handleOnClick = (event)=>{
                onClickContainer(event);
                onClick?.(event);
            };
            let borderRightStyles = 'none';
            if (isExpanded) {
                if (borders.border === 'none') borderRightStyles = `${"var(--ds-border-width, 1px)"} solid ${colors.color}`;
                else borderRightStyles = borders.border;
            }
            if ((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_2')) {
                if (!isExpandable) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ILhZ")).default), {
                    ...restTriggerProps,
                    ...restTooltipProps,
                    ref: tooltipRef ? (0, (0, parcelRequire("7mPT9")).mergeRefs)(triggerRef, tooltipRef) : triggerRef,
                    "aria-label": `${formatMessage((0, (0, parcelRequire("h7Ce2")).default).sprintsCountLabel, {
                        sprintsCount: intervals.length
                    })} ${(0, (0, parcelRequire("4hDMO")).getSprintAriaLabel)(intervals, formatMessage)}`,
                    xcss: $ea0ca1458a693c60$var$baseContainerStyles,
                    style: {
                        border: borders.border === 'none' ? `${"var(--ds-border-width, 1px)"} solid ${colors.color}` : borders.border,
                        borderRadius: borders.borderRadius,
                        left: `${left}px`,
                        right: `${right}px`
                    },
                    testId: "roadmap.timeline-table-kit.ui.chart-header-item.intervals.marker.content",
                    onMouseEnter: onMouseEnter,
                    onMouseLeave: onMouseLeave,
                    onFocus: handleOnFocus,
                    onBlur: handleOnBlur,
                    onClick: handleOnClick,
                    onKeyDown: handleKeyDown
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                    maxLines: 1,
                    size: "small"
                }, label));
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ILhZ")).default), {
                    ...restTriggerProps,
                    ...restTooltipProps,
                    ref: tooltipRef ? (0, (0, parcelRequire("7mPT9")).mergeRefs)(triggerRef, tooltipRef) : triggerRef,
                    "aria-label": `${formatMessage((0, (0, parcelRequire("h7Ce2")).default).sprintsCountLabel, {
                        sprintsCount: intervals.length
                    })} ${(0, (0, parcelRequire("4hDMO")).getSprintAriaLabel)(intervals, formatMessage)}`,
                    xcss: [
                        $ea0ca1458a693c60$var$baseContainerStyles,
                        $ea0ca1458a693c60$var$expandableContainerStyles,
                        $ea0ca1458a693c60$var$transitionStyles
                    ],
                    style: {
                        left: `${left}px`,
                        right: `${isExpanded ? rightExpanded : right}px`,
                        zIndex: isExpanded ? $ea0ca1458a693c60$var$EXPANDED_Z_INDEX : 'auto'
                    },
                    onMouseEnter: onMouseEnter,
                    onMouseLeave: onMouseLeave,
                    onFocus: handleOnFocus,
                    onBlur: handleOnBlur,
                    onClick: handleOnClick,
                    onKeyDown: handleKeyDown
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                    testId: "roadmap.timeline-table-kit.ui.chart-header-item.intervals.marker.content",
                    xcss: $ea0ca1458a693c60$var$expandableLabelWrapperStyles,
                    backgroundColor: "elevation.surface",
                    style: {
                        border: borders.border === 'none' ? `${"var(--ds-border-width, 1px)"} solid ${colors.color}` : borders.border,
                        borderRight: borderRightStyles,
                        borderRadius: borders.borderRadius
                    }
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                    as: "span",
                    paddingInline: "space.050",
                    xcss: $ea0ca1458a693c60$var$overflowStyles
                }, label)), isExpandIndicatorVisible && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bmGDh")).ExpandableIndicator), {
                    color: colors.color
                }));
            }
            if (!isExpandable) return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                ...restTriggerProps,
                ...restTooltipProps,
                ref: tooltipRef ? (0, (0, parcelRequire("7mPT9")).mergeRefs)(triggerRef, tooltipRef) : triggerRef,
                role: "button",
                "aria-label": `${formatMessage((0, (0, parcelRequire("h7Ce2")).default).sprintsCountLabel, {
                    sprintsCount: intervals.length
                })} ${(0, (0, parcelRequire("4hDMO")).getSprintAriaLabel)(intervals, formatMessage)}`,
                style: {
                    color: colors.color,
                    backgroundColor: colors.backgroundColor,
                    border: borders.border ?? 'none',
                    borderRadius: borders.borderRadius,
                    padding: spacing.padding,
                    margin: spacing.margin,
                    left: `${left}px`,
                    right: `${right}px`
                },
                tabIndex: 0,
                "data-testid": "roadmap.timeline-table-kit.ui.chart-header-item.intervals.marker.content",
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onFocus: handleOnFocus,
                onBlur: handleOnBlur,
                onClick: handleOnClick,
                onKeyDown: handleKeyDown,
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_kqswstnw _vchhusvi _4t3i7vkz _1ul9v77o _y3gn1h6o _11c81vlj _vwz4utpp _k48pmoej _80omtlke",
                    "_1reo15vq _18m915vq _o5721q9c _1bto1l2s"
                ])
            }, label);
            return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                ...restTriggerProps,
                ...restTooltipProps,
                ref: tooltipRef ? (0, (0, parcelRequire("7mPT9")).mergeRefs)(triggerRef, tooltipRef) : triggerRef,
                role: "button",
                "aria-label": `${formatMessage((0, (0, parcelRequire("h7Ce2")).default).sprintsCountLabel, {
                    sprintsCount: intervals.length
                })} ${(0, (0, parcelRequire("4hDMO")).getSprintAriaLabel)(intervals, formatMessage)}`,
                style: {
                    left: `${left}px`,
                    right: `${isExpanded ? rightExpanded : right}px`,
                    zIndex: isExpanded ? $ea0ca1458a693c60$var$EXPANDED_Z_INDEX : 'auto',
                    margin: spacing.margin
                },
                tabIndex: 0,
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onFocus: handleOnFocus,
                onBlur: handleOnBlur,
                onClick: handleOnClick,
                onKeyDown: handleKeyDown,
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_1e0c1txw",
                    "_kqswstnw _vchhusvi _4t3i7vkz _1ul9v77o _y3gn1h6o _11c81vlj _vwz4utpp _k48pmoej _80omtlke",
                    "_v5644td3"
                ])
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                "data-testid": "roadmap.timeline-table-kit.ui.chart-header-item.intervals.marker.content",
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_1reo15vq _18m915vq _o5721q9c _1bto1l2s",
                    isExpanded && "_16qs1nfl"
                ]),
                style: {
                    color: colors.color,
                    backgroundColor: colors.backgroundColor,
                    border: borders.border ?? 'none',
                    borderRadius: borders.borderRadius,
                    padding: spacing.padding,
                    width: isExpandIndicatorVisible ? `calc(100% - ${0, $1e5d3bf4c9bbb5a9$export$62467065a148cd06}px)` : '100%',
                    "--_pu77ur": (0, (0, parcelRequire("lD23V")).default)((0, (0, parcelRequire("hvXFA")).HEADER_BACKGROUND_COLOR))
                }
            }, label), isExpandIndicatorVisible && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bmGDh")).ExpandableIndicatorOld), {
                backgroundColor: colors.backgroundColor
            }));
        };
        const renderSelectedIntervalPopupContent = (0, $5uXOq.useCallback)(({ setInitialFocusRef: setInitialFocusRef })=>renderPopupContent(intervals, setInitialFocusRef), [
            intervals,
            renderPopupContent
        ]);
        const renderPopupTrigger = (triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gTePl")).IntervalsTooltip), {
                intervals: intervals
            }, (tooltipProps)=>renderMarker(triggerProps, tooltipProps));
        const onClosePopup = ()=>{
            if (!isHeaderModalActive) {
                if (isMouseEntered) setIsMouseEntered(false);
                if ((0, (0, parcelRequire("4R6GH")).fg)('timeline_grid_navigation_m2')) closePopup();
                else setIsPopupActive(false);
            }
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            isOpen: isPopupActive,
            onClose: onClosePopup,
            placement: "bottom-start",
            content: renderSelectedIntervalPopupContent,
            trigger: renderPopupTrigger,
            zIndex: (0, (0, parcelRequire("knkJA")).OVERLAY_FLYOUT_Z_INDEX),
            autoFocus: false,
            role: "dialog",
            label: formatMessage((0, (0, parcelRequire("h7Ce2")).default).popupLabel)
        });
    };
    const $ea0ca1458a693c60$export$11d6002c52c98162 = (0, $5uXOq.memo)($ea0ca1458a693c60$var$BaseMarker);
    const $ea0ca1458a693c60$var$baseContainerStylesOld = null;
    const $ea0ca1458a693c60$var$baseContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        boxSizing: 'border-box',
        position: 'absolute',
        height: '20px',
        minWidth: 'space.025',
        backgroundColor: 'elevation.surface',
        color: 'color.text',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    });
    const $ea0ca1458a693c60$var$expandableLabelWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        height: '20px',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    });
    const $ea0ca1458a693c60$var$overflowStylesOld = null;
    const $ea0ca1458a693c60$var$overflowStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        transition: 'right 0.2s ease-in-out',
        font: 'font.body.small'
    });
    const $ea0ca1458a693c60$var$expandedContainerStylesOld = null;
    const $ea0ca1458a693c60$var$expandableContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginRight: 'space.050',
        backgroundColor: 'color.background.neutral.subtle'
    });
    const $ea0ca1458a693c60$var$transitionStylesOld = null;
    const $ea0ca1458a693c60$var$transitionStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        transition: 'right 0.2s ease-in-out'
    });
    const $ea0ca1458a693c60$var$expandableContentStylesOld = null;
});
const $1e5d3bf4c9bbb5a9$export$62467065a148cd06 = 8;
const $1e5d3bf4c9bbb5a9$export$462ae417bcee39bd = 2;
const $1e5d3bf4c9bbb5a9$export$e2bd4c1faded7921 = 2;
parcelRegister("hvXFA", function(module, exports) {
    $parcel$export(module.exports, "HEADER_BACKGROUND_COLOR", ()=>$bdf1776085f5d2b6$export$cff61b214d368dd4);
    const $bdf1776085f5d2b6$export$cff61b214d368dd4 = `var(--ds-surface, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`;
});
parcelRegister("bmGDh", function(module, exports) {
    $parcel$export(module.exports, "ExpandableIndicatorOld", ()=>$38bd5633a7d65472$export$c41956d29c2a2c7d);
    $parcel$export(module.exports, "ExpandableIndicator", ()=>$38bd5633a7d65472$export$2c9bdfe109ea2701);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $iZN6h;
    const $38bd5633a7d65472$var$POLYGON_COORDINATES = `0,0 ${(0, $1e5d3bf4c9bbb5a9$export$62467065a148cd06) - (0, $1e5d3bf4c9bbb5a9$export$462ae417bcee39bd)},${(0, (0, parcelRequire("iZN6h")).HEADER_CONTENT_HEIGHT) / 2} 0,${(0, (0, parcelRequire("iZN6h")).HEADER_CONTENT_HEIGHT)}`;
    const $38bd5633a7d65472$export$c41956d29c2a2c7d = ({ backgroundColor: backgroundColor })=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: (0, $1e5d3bf4c9bbb5a9$export$62467065a148cd06),
            height: (0, (0, parcelRequire("iZN6h")).HEADER_CONTENT_HEIGHT),
            style: {
                [`${'--icon-primary-color'}`]: backgroundColor,
                color: 'var(--icon-primary-color)'
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            fill: "currentColor"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("polygon", {
            points: $38bd5633a7d65472$var$POLYGON_COORDINATES
        })));
    const $38bd5633a7d65472$export$2c9bdfe109ea2701 = ({ color: color })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $38bd5633a7d65472$var$ExpandableIndicatorWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "7",
            height: "20",
            viewBox: "0 0 7 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M0 1.11111V18.8889V20L1.5 19.4444L3 18.3333L6 10.5556V9.44444L5 6.11111L2.5 1.11111L0 0V1.11111Z",
            fill: "var(--ds-surface, #FFFFFF)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M0 18.8889V20H1.05038C2.23595 20 3.3103 19.2242 3.79181 18.0205L6.45848 11.3538C6.80324 10.4919 6.80324 9.50809 6.45848 8.6462L3.79181 1.97954C3.3103 0.775779 2.23595 0 1.05038 0H0V1.11111H1.05038C1.84076 1.11111 2.55699 1.62829 2.87799 2.4308L5.54466 9.09747C5.77451 9.67206 5.77451 10.3279 5.54466 10.9025L2.87799 17.5692C2.55699 18.3717 1.84076 18.8889 1.05038 18.8889H0Z",
            fill: color
        })));
    const $38bd5633a7d65472$var$ExpandableIndicatorWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'absolute',
        top: '0px',
        right: '0px'
    });
});
parcelRegister("h7Ce2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2e75800a0f57ca54$export$2e2bcd8739ae039);
    var $7VHMR;
    var $2e75800a0f57ca54$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        sprintsCountLabel: {
            "id": "roadmap.timeline-table-kit.chart-header-item.intervals.marker.sprints-count-label",
            "defaultMessage": "{sprintsCount} {sprintsCount, plural, one {sprint} other {sprints}}."
        },
        popupLabel: {
            "id": "roadmap.timeline-table-kit.chart-header-item.intervals.marker.popup-label",
            "defaultMessage": "Sprint info"
        }
    });
});
parcelRegister("gTePl", function(module, exports) {
    $parcel$export(module.exports, "IntervalsTooltip", ()=>$75fd945023c7cc56$export$d653b20e86abaaf3);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $3bDjY;
    var $g11uZ;
    var $6wTnN;
    var $6dG5H;
    const $75fd945023c7cc56$var$tagStyles = null;
    const $75fd945023c7cc56$var$TooltipTag = (0, $5uXOq.forwardRef)((props, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: ref,
            ...props,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i7vkz"
            ])
        }));
    const $75fd945023c7cc56$export$d653b20e86abaaf3 = ({ intervals: intervals, children: children })=>{
        const renderTooltipContent = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, intervals.map(({ name: name, startDate: startDate, endDate: endDate }, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6wTnN")).TooltipInterval), {
                    key: index
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6dG5H")).SprintIcon), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6wTnN")).ContentName), null, name), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6wTnN")).ContentDateLabel), null, `
                        (${(0, (0, parcelRequire("g11uZ")).getDateFromTimestamp)(startDate)} - ${(0, (0, parcelRequire("g11uZ")).getDateFromTimestamp)(endDate)})
                    `))));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            hideTooltipOnClick: true,
            tag: $75fd945023c7cc56$var$TooltipTag,
            content: renderTooltipContent()
        }, typeof children === 'function' ? ({ 'aria-describedby': ariaDescribedby, ...tooltipProps })=>children(tooltipProps) : children);
    };
});
parcelRegister("6dG5H", function(module, exports) {
    $parcel$export(module.exports, "SprintIcon", ()=>$e8fd5f283ee29689$export$8c2ca4d5c7ca94da);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $igBVO;
    var $4R6GH;
    var $koVbs;
    var $sUcA7;
    const $e8fd5f283ee29689$var$getIconSize = (iconSize)=>iconSize === 'small' ? 16 : 24;
    const $e8fd5f283ee29689$var$wrapperStyles = null;
    const $e8fd5f283ee29689$export$8c2ca4d5c7ca94da = ({ size: size })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                height: `${$e8fd5f283ee29689$var$getIconSize(size)}px`,
                width: `${$e8fd5f283ee29689$var$getIconSize(size)}px`
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2hwxv77o"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("igBVO"))))), {
            testId: "roadmap.timeline-table-kit.common.ui.sprint-icon",
            label: (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-post-project-a11y-fix') ? '' : formatMessage((0, (0, parcelRequire("sUcA7")).default).sprintLabel),
            spacing: size === 'medium' ? 'spacious' : 'none',
            color: "currentColor",
            LEGACY_size: size
        }));
    };
    $e8fd5f283ee29689$export$8c2ca4d5c7ca94da.defaultProps = {
        size: 'small'
    };
});
parcelRegister("igBVO", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $d4c724fd848b96af$var$_react = $d4c724fd848b96af$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $d4c724fd848b96af$var$_sprint = $d4c724fd848b96af$var$_interopRequireDefault((parcelRequire("8mG85")));
    var $d4c724fd848b96af$var$_sprint2 = $d4c724fd848b96af$var$_interopRequireDefault((parcelRequire("iyo13")));
    function $d4c724fd848b96af$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $d4c724fd848b96af$var$SprintIcon = (props)=>$d4c724fd848b96af$var$_react.default.createElement($d4c724fd848b96af$var$_sprint.default, Object.assign({
            LEGACY_fallbackIcon: $d4c724fd848b96af$var$_sprint2.default
        }, props));
    $d4c724fd848b96af$var$SprintIcon.Name = 'SprintIconMigration';
    var $d4c724fd848b96af$var$_default = module.exports.default = $d4c724fd848b96af$var$SprintIcon;
});
parcelRegister("8mG85", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $61710ed7f2aa84a3$var$_react = $61710ed7f2aa84a3$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $61710ed7f2aa84a3$var$_UNSAFE_baseNew = $61710ed7f2aa84a3$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $61710ed7f2aa84a3$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $61710ed7f2aa84a3$var$SprintIcon = (props)=>$61710ed7f2aa84a3$var$_react.default.createElement($61710ed7f2aa84a3$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M13.5 6.25a5.5 5.5 0 1 0-5.5 5.5m0 0H0m8 0h6.75m-3-3.5 3.5 3.5-3.5 3.5"/>`
        }, props));
    $61710ed7f2aa84a3$var$SprintIcon.displayName = 'SprintIcon';
    var $61710ed7f2aa84a3$var$_default = module.exports.default = $61710ed7f2aa84a3$var$SprintIcon;
});
parcelRegister("iyo13", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $d81e080f0024ae1d$var$_react = $d81e080f0024ae1d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $d81e080f0024ae1d$var$_sprint = $d81e080f0024ae1d$var$_interopRequireDefault((parcelRequire("8mG85")));
    function $d81e080f0024ae1d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $d81e080f0024ae1d$var$SprintIcon = (props)=>$d81e080f0024ae1d$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="m17.717 17.137-1.436-1.438a1.003 1.003 0 0 1 1.418-1.418l3.007 3.01a1 1 0 0 1 0 1.417l-3.007 3.01a1.003 1.003 0 0 1-1.417-1.42l1.3-1.3-6.072-.003A8 8 0 0 1 4 11.01C4 6.587 7.582 3 12 3s8 3.587 8 8.01a8 8 0 0 1-.789 3.451l-1.438-1.44a6.1 6.1 0 0 0 .345-2.01A6.12 6.12 0 0 0 12 4.884a6.12 6.12 0 0 0-6.118 6.125 6.12 6.12 0 0 0 5.647 6.102zm-12.163-.119c.561.759 1.456 1.49 2.457 1.981L3.937 19C3.42 19 3 18.552 3 18s.42-1 .937-1l1.614.005z"/></svg>`
        }, props, {
            newIcon: $d81e080f0024ae1d$var$_sprint.default
        }));
    $d81e080f0024ae1d$var$SprintIcon.displayName = 'SprintIcon';
    var $d81e080f0024ae1d$var$_default = module.exports.default = $d81e080f0024ae1d$var$SprintIcon;
});
parcelRegister("sUcA7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d1365b6c26a062f3$export$2e2bcd8739ae039);
    var $7VHMR;
    const $d1365b6c26a062f3$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        sprintLabel: {
            "id": "roadmap.timeline-table-kit.common.sprint-icon.sprint-label",
            "defaultMessage": "Sprint"
        }
    });
    var $d1365b6c26a062f3$export$2e2bcd8739ae039 = $d1365b6c26a062f3$var$messages;
});
parcelRegister("lFhKE", function(module, exports) {
    $parcel$export(module.exports, "getDynamicMarkerStyles", ()=>$794bb8856a108847$export$52788c6efbc3355a);
    var $gwIPs;
    var $4R6GH;
    var $dCm1o;
    var $4eUQf;
    const $794bb8856a108847$export$b0916a2042ea04de = ({ width: width, isExpanded: isExpanded, isExpandable: isExpandable })=>{
        const isSpaceToRenderExpandIndicator = width >= 2 * (0, $1e5d3bf4c9bbb5a9$export$62467065a148cd06);
        const isExpandIndicatorVisible = isExpandable && !isExpanded && isSpaceToRenderExpandIndicator;
        const availableLabelWidth = width - (isExpandIndicatorVisible ? (0, $1e5d3bf4c9bbb5a9$export$62467065a148cd06) : 0);
        const isLabelVisible = availableLabelWidth >= (0, (0, parcelRequire("4eUQf")).APPROX_WIDTH_OF_SINGLE_CHARACTER_AND_ELLIPSIS);
        return {
            isLabelVisible: isLabelVisible,
            isExpandIndicatorVisible: isExpandIndicatorVisible
        };
    };
    const $794bb8856a108847$export$706101aacf0f1ff0 = ({ intervals: intervals, isHighlighted: isHighlighted })=>{
        const shouldApplyVisualRefresh = (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_2');
        if (isHighlighted) return 0, (0, parcelRequire("4eUQf")).HIGHLIGHTED_COLORS;
        if (intervals.some(({ state: state })=>state === (0, $8e299570902dfa36$export$2b35adb71b3f6143))) return shouldApplyVisualRefresh ? (0, (0, parcelRequire("4eUQf")).MARKER_COLORS_BY_STATUS)[0, $8e299570902dfa36$export$2b35adb71b3f6143] : (0, (0, parcelRequire("4eUQf")).MARKER_COLORS_BY_STATUS_OLD)[0, $8e299570902dfa36$export$2b35adb71b3f6143];
        if (intervals.some(({ state: state })=>state === (0, $8e299570902dfa36$export$47b7b82714c61a7c))) return shouldApplyVisualRefresh ? (0, (0, parcelRequire("4eUQf")).MARKER_COLORS_BY_STATUS)[0, $8e299570902dfa36$export$47b7b82714c61a7c] : (0, (0, parcelRequire("4eUQf")).MARKER_COLORS_BY_STATUS_OLD)[0, $8e299570902dfa36$export$47b7b82714c61a7c];
        return shouldApplyVisualRefresh ? (0, (0, parcelRequire("4eUQf")).MARKER_COLORS_BY_STATUS)[0, $8e299570902dfa36$export$19c4f83398a8dbce] : (0, (0, parcelRequire("4eUQf")).MARKER_COLORS_BY_STATUS_OLD)[0, $8e299570902dfa36$export$19c4f83398a8dbce];
    };
    const $794bb8856a108847$export$929cde73ea66c204 = ({ isHighlighted: isHighlighted, isLeftClipped: isLeftClipped, isRightClipped: isRightClipped })=>{
        const leftRadius = isLeftClipped ? 0 : (0, (0, parcelRequire("gwIPs")).borderRadius);
        const rightRadius = isRightClipped ? 0 : (0, (0, parcelRequire("gwIPs")).borderRadius);
        return {
            borderRadius: `${leftRadius}px ${rightRadius}px ${rightRadius}px ${leftRadius}px`,
            border: isHighlighted ? (0, (0, parcelRequire("4eUQf")).HIGHLIGHTED_BORDER) : 'none'
        };
    };
    const $794bb8856a108847$export$f63796f8a9382bfb = ({ width: width, isExpanded: isExpanded, isHighlighted: isHighlighted, isRightClipped: isRightClipped, isLabelVisible: isLabelVisible, isExpandIndicatorVisible: isExpandIndicatorVisible })=>{
        const leftMargin = (0, $1e5d3bf4c9bbb5a9$export$462ae417bcee39bd) / 2;
        const rightMargin = isRightClipped ? 0 : leftMargin;
        const margin = `0px ${rightMargin}px 0px ${leftMargin}px`;
        const leftPadding = width > (0, (0, parcelRequire("4eUQf")).MIN_CONTENT_SIZE) ? (0, (0, parcelRequire("4eUQf")).DEFAULT_HORIZONTAL_PADDING) : 0;
        const rightPadding = leftPadding + (isExpanded ? (0, $1e5d3bf4c9bbb5a9$export$462ae417bcee39bd) : 0);
        const topPadding = isHighlighted ? 0 : 2;
        if (!isLabelVisible || !isHighlighted) return {
            padding: `${topPadding}px ${rightPadding}px 0px ${leftPadding}px`,
            margin: margin
        };
        const rightPaddingWithOffset = leftPadding - (isExpandIndicatorVisible ? 0 : (0, $1e5d3bf4c9bbb5a9$export$e2bd4c1faded7921));
        const leftPaddingWithOffset = leftPadding - (0, $1e5d3bf4c9bbb5a9$export$e2bd4c1faded7921);
        return {
            padding: `${topPadding}px ${rightPaddingWithOffset}px 0px ${leftPaddingWithOffset}px`,
            margin: margin
        };
    };
    const $794bb8856a108847$export$52788c6efbc3355a = ({ intervalGroup: intervalGroup, isExpanded: isExpanded, isExpandable: isExpandable, isHighlighted: isHighlighted })=>{
        const { intervals: intervals, isLeftClipped: isLeftClipped } = intervalGroup;
        const width = isExpanded ? intervalGroup.widthExpanded : intervalGroup.width;
        const childVisibility = $794bb8856a108847$export$b0916a2042ea04de({
            width: width,
            isExpanded: isExpanded,
            isExpandable: isExpandable
        });
        const isRightClipped = intervalGroup.isRightClipped || childVisibility.isExpandIndicatorVisible;
        return {
            colors: $794bb8856a108847$export$706101aacf0f1ff0({
                intervals: intervals,
                isHighlighted: isHighlighted
            }),
            borders: $794bb8856a108847$export$929cde73ea66c204({
                isHighlighted: isHighlighted,
                isLeftClipped: isLeftClipped,
                isRightClipped: isRightClipped
            }),
            spacing: $794bb8856a108847$export$f63796f8a9382bfb({
                width: width,
                isExpanded: isExpanded,
                isHighlighted: isHighlighted,
                isRightClipped: isRightClipped,
                ...childVisibility
            }),
            childVisibility: childVisibility
        };
    };
});
parcelRegister("4eUQf", function(module, exports) {
    $parcel$export(module.exports, "APPROX_WIDTH_OF_SINGLE_CHARACTER_AND_ELLIPSIS", ()=>$d421286d98d3f3df$export$35b03b828551403c);
    $parcel$export(module.exports, "DEFAULT_HORIZONTAL_PADDING", ()=>$d421286d98d3f3df$export$382aa5aaf1386a15);
    $parcel$export(module.exports, "MIN_CONTENT_SIZE", ()=>$d421286d98d3f3df$export$26fd56593e380ecc);
    $parcel$export(module.exports, "HIGHLIGHTED_BORDER", ()=>$d421286d98d3f3df$export$99f67a6c4bd713c0);
    $parcel$export(module.exports, "HIGHLIGHTED_COLORS", ()=>$d421286d98d3f3df$export$aa263ebd4566c172);
    $parcel$export(module.exports, "MARKER_COLORS_BY_STATUS", ()=>$d421286d98d3f3df$export$2dadfa510748a1b5);
    $parcel$export(module.exports, "MARKER_COLORS_BY_STATUS_OLD", ()=>$d421286d98d3f3df$export$30f1f2ff28ce9190);
    const $d421286d98d3f3df$export$35b03b828551403c = 30;
    const $d421286d98d3f3df$export$382aa5aaf1386a15 = 4;
    const $d421286d98d3f3df$export$26fd56593e380ecc = 2 * $d421286d98d3f3df$export$382aa5aaf1386a15 + 2 * (0, $1e5d3bf4c9bbb5a9$export$e2bd4c1faded7921);
    const $d421286d98d3f3df$export$99f67a6c4bd713c0 = `${(0, $1e5d3bf4c9bbb5a9$export$e2bd4c1faded7921)}px solid ${`var(--ds-icon-brand, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`}`;
    const $d421286d98d3f3df$export$aa263ebd4566c172 = {
        color: `var(--ds-text-brand, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
        backgroundColor: `var(--ds-background-selected, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`
    };
    const $d421286d98d3f3df$export$2dadfa510748a1b5 = {
        [(0, $8e299570902dfa36$export$2b35adb71b3f6143)]: {
            color: '#669DF1'
        },
        [(0, $8e299570902dfa36$export$47b7b82714c61a7c)]: {
            color: '#B7B9BE'
        },
        [(0, $8e299570902dfa36$export$19c4f83398a8dbce)]: {
            color: '#4BCE97'
        }
    };
    const $d421286d98d3f3df$export$30f1f2ff28ce9190 = {
        [(0, $8e299570902dfa36$export$2b35adb71b3f6143)]: {
            color: `var(--ds-text-accent-blue, ${(0, $829f609a65d26a98$export$a6ee3d71bc067634)})`,
            backgroundColor: `var(--ds-background-accent-blue-subtler, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`
        },
        [(0, $8e299570902dfa36$export$47b7b82714c61a7c)]: {
            color: `var(--ds-text-accent-gray-bolder, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
            backgroundColor: `var(--ds-background-accent-gray-subtler, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`
        },
        [(0, $8e299570902dfa36$export$19c4f83398a8dbce)]: {
            color: `var(--ds-text-accent-gray, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`,
            backgroundColor: `var(--ds-background-accent-gray-subtlest, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`
        }
    };
});
parcelRegister("4hDMO", function(module, exports) {
    $parcel$export(module.exports, "getLabel", ()=>$11f03bb2532318be$export$236350842f3cd9bc);
    $parcel$export(module.exports, "getSprintAriaLabel", ()=>$11f03bb2532318be$export$c5109b68d3576dad);
    var $g11uZ;
    var $dP2CN;
    const $11f03bb2532318be$export$236350842f3cd9bc = ({ intervals: intervals, targetIntervalId: targetIntervalId, isLabelVisible: isLabelVisible })=>{
        if (!isLabelVisible) return null;
        if (targetIntervalId !== undefined) {
            const interval = intervals.find(({ id: id })=>id === targetIntervalId);
            return interval ? interval.name : null;
        }
        return intervals.map(({ name: name })=>name).join(', ');
    };
    const $11f03bb2532318be$export$c5109b68d3576dad = (intervals, formatMessage)=>intervals.map(({ name: name, startDate: startDate, endDate: endDate })=>formatMessage((0, (0, parcelRequire("dP2CN")).default).sprintLabel, {
                name: name,
                startDate: (0, (0, parcelRequire("g11uZ")).getDateFromTimestamp)(startDate),
                endDate: (0, (0, parcelRequire("g11uZ")).getDateFromTimestamp)(endDate)
            })).join(', ');
});
parcelRegister("dP2CN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5d4062773b8d3d71$export$2e2bcd8739ae039);
    var $7VHMR;
    var $5d4062773b8d3d71$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        sprintLabel: {
            "id": "roadmap.timeline-table-kit.chart-header-item.intervals.marker.utils.sprint-label",
            "defaultMessage": "{name} (from {startDate} to {endDate})"
        }
    });
});
parcelRegister("8eMus", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6ec760942211e6f8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $lfTZh;
    var $kxZPA;
    var $eKt4x;
    const $6ec760942211e6f8$var$SprintFlyout = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("5ed7C")), {
        ssr: false,
        moduleId: "./src/packages/software/roadmap/standard/src/view/common/table/chart-header-item/sprints/flyout/index.tsx"
    });
    var $6ec760942211e6f8$export$2e2bcd8739ae039 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "async-standard-roadmap-sprint-flyout",
            packageName: (0, (0, parcelRequire("eKt4x")).ROADMAP_PACKAGE_NAME),
            fallback: "flag"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "async-standard-roadmap-sprint-flyout",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($6ec760942211e6f8$var$SprintFlyout, props)));
});
parcelRegister("5ed7C", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2ExSU").then(()=>parcelRequire('8W3vH'));
});
parcelRegister("hdLIE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e91031be2ec9c6bd$export$2e2bcd8739ae039);
    var $kFsv3;
    var $bC2fB;
    var $gvxNC;
    var $1cn7Z;
    var $e91031be2ec9c6bd$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((state, { id: id })=>{
        const issueChartData = (0, (0, parcelRequire("1cn7Z")).getChartDataHash)(state)[id];
        if (issueChartData === undefined) return {
            startDate: undefined,
            dueDate: undefined,
            level: 0,
            color: (0, (0, parcelRequire("kFsv3")).PURPLE)
        };
        const { color: color, startDate: startDate, dueDate: dueDate, placeholder: placeholder, level: level } = issueChartData;
        return {
            color: color,
            startDate: startDate,
            dueDate: dueDate,
            placeholder: placeholder,
            level: level
        };
    }, null, (stateProps)=>stateProps)((0, (0, parcelRequire("gvxNC")).RoadmapChartItemContentLite));
});
parcelRegister("gvxNC", function(module, exports) {
    $parcel$export(module.exports, "RoadmapChartItemContentLite", ()=>$75b34b09b609a7e6$export$440d1bc6878927ac);
    var $5uXOq = parcelRequire("5uXOq");
    var $biT18;
    var $3yzcQ;
    var $apjDv;
    var $9KS0U;
    const $75b34b09b609a7e6$var$DateItemLite = ({ startDate: startDate, dueDate: dueDate, level: level, placeholder: placeholder, color: color })=>{
        const [{ timelineDuration: timelineDuration, timelineWidth: timelineWidth }] = (0, (0, parcelRequire("biT18")).useTimelineState)();
        const barLeftPosition = (0, (0, parcelRequire("apjDv")).getBarLeftPosition)(startDate, timelineDuration, timelineWidth);
        const barRightPosition = (0, (0, parcelRequire("apjDv")).getBarRightPosition)(dueDate, timelineDuration, timelineWidth);
        const isBarVisible = (0, (0, parcelRequire("apjDv")).getIsBarVisible)(barLeftPosition, barRightPosition, timelineWidth);
        if (!isBarVisible) return null;
        const theme = (0, (0, parcelRequire("9KS0U")).getBarTheme)(color);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                ...(0, (0, parcelRequire("3yzcQ")).getBaseBarStyles)({
                    level: level,
                    theme: theme,
                    placeholder: placeholder
                }),
                left: `${barLeftPosition}px`,
                right: `${barRightPosition}px`
            }
        });
    };
    const $75b34b09b609a7e6$export$440d1bc6878927ac = ({ startDate: startDate, dueDate: dueDate, ...restProps })=>{
        if (startDate !== undefined && dueDate !== undefined) return (0, ($parcel$interopDefault($5uXOq))).createElement($75b34b09b609a7e6$var$DateItemLite, {
            ...restProps,
            startDate: startDate,
            dueDate: dueDate
        });
        return null;
    };
});
parcelRegister("3yzcQ", function(module, exports) {
    $parcel$export(module.exports, "getBaseBarStyles", ()=>$aae92349744e78b7$export$bbdfdd7c08708e05);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $joGLY;
    var $15ADj;
    var $knkJA;
    var $4tYfO;
    const $aae92349744e78b7$var$generateBarBackground = ({ theme: theme, placeholder: placeholder })=>{
        if (placeholder === (0, (0, parcelRequire("15ADj")).START_AND_DUE_DATE_PLACEHOLDER)) return `linear-gradient(90deg, ${theme.gradient} 0%, ${theme.background} 30%, ${theme.background} 70%, ${theme.gradient} 100%)`;
        if (placeholder === (0, (0, parcelRequire("15ADj")).START_DATE_PLACEHOLDER)) return `linear-gradient(90deg, ${theme.gradient} 0%, ${theme.background} 30%)`;
        if (placeholder === (0, (0, parcelRequire("15ADj")).DUE_DATE_PLACEHOLDER)) return `linear-gradient(90deg, ${theme.background} 70%, ${theme.gradient} 100%)`;
        return theme.background;
    };
    const $aae92349744e78b7$export$bbdfdd7c08708e05 = ({ level: level, placeholder: placeholder, theme: theme })=>({
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            minWidth: '3px',
            padding: 0,
            zIndex: `${0, (0, parcelRequire("knkJA")).CHART_BAR_Z_INDEX}`,
            height: `${(0, (0, parcelRequire("joGLY")).isBaseLevel)(level) ? `${0, (0, parcelRequire("15ADj")).BASE_BAR_HEIGHT}px` : `${0, (0, parcelRequire("15ADj")).BAR_HEIGHT}px`}`,
            borderRadius: `${(0, (0, parcelRequire("4tYfO")).generateBarBorderRadius)(placeholder)}`,
            background: `${$aae92349744e78b7$var$generateBarBackground({
                placeholder: placeholder,
                theme: theme
            })}`
        });
    const $aae92349744e78b7$export$8759e0e73077886f = ({ placeholder: placeholder, left: left, right: right, theme: theme, level: level, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                left: `${left}px`,
                right: `${right}px`,
                height: `${(0, (0, parcelRequire("joGLY")).isBaseLevel)(level) ? `${0, (0, parcelRequire("15ADj")).BASE_BAR_HEIGHT}px` : `${0, (0, parcelRequire("15ADj")).BAR_HEIGHT}px`}`,
                borderRadius: `${(0, (0, parcelRequire("4tYfO")).generateBarBorderRadius)(placeholder)}`,
                background: `${$aae92349744e78b7$var$generateBarBackground({
                    placeholder: placeholder,
                    theme: theme
                })}`
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _1e0c1txw _4cvr1h6o _1bahesu3 _1ul91b66 _1yt4otz2 _1pby11wp"
            ])
        }, children);
    const $aae92349744e78b7$var$baseBarStyles = null;
});
parcelRegister("4tYfO", function(module, exports) {
    $parcel$export(module.exports, "generateBarBorderRadius", ()=>$4a72d727054ccffc$export$f984deddd1b0e289);
    var $15ADj;
    const $4a72d727054ccffc$export$f984deddd1b0e289 = (placeholder)=>{
        if (placeholder === (0, (0, parcelRequire("15ADj")).START_AND_DUE_DATE_PLACEHOLDER)) return 0, (0, parcelRequire("15ADj")).LEFT_AND_RIGHT_PLACEHOLDER_BORDER_RADIUS;
        if (placeholder === (0, (0, parcelRequire("15ADj")).START_DATE_PLACEHOLDER)) return 0, (0, parcelRequire("15ADj")).LEFT_PLACEHOLDER_BORDER_RADIUS;
        if (placeholder === (0, (0, parcelRequire("15ADj")).DUE_DATE_PLACEHOLDER)) return 0, (0, parcelRequire("15ADj")).RIGHT_PLACEHOLDER_BORDER_RADIUS;
        return 0, (0, parcelRequire("15ADj")).DEFAULT_BORDER_RADIUS;
    };
});
parcelRegister("9KS0U", function(module, exports) {
    $parcel$export(module.exports, "getBarTheme", ()=>$b5f81983fbd88c96$export$9f7946b895cedb51);
    var $iHPnC;
    const $b5f81983fbd88c96$var$colorToBarTheme = (color)=>({
            background: color.primary,
            gradient: color.primaryGradient,
            handle: color.secondary,
            hasContrastSecondaryGradient: color.hasContrastSecondaryGradient
        });
    const $b5f81983fbd88c96$var$barThemes = (0, (0, parcelRequire("iHPnC")).transformColorToTheme)($b5f81983fbd88c96$var$colorToBarTheme);
    const $b5f81983fbd88c96$export$9f7946b895cedb51 = (color)=>$b5f81983fbd88c96$var$barThemes[color] || $b5f81983fbd88c96$var$barThemes.PURPLE;
});
parcelRegister("2IvBE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6266825a55b96177$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $bC2fB;
    var $joGLY;
    var $1mW3K;
    var $1VLi2;
    var $fvM4Z;
    var $bZFir;
    var $1cn7Z;
    var $lEiof;
    var $cHx7J;
    var $80iMb;
    const $6266825a55b96177$var$mapDispatchToProps = (dispatch)=>({
            onUpdate: (id, { dates: dates, meta: meta, intervalId: intervalId }, event, hasOverdueReleaseDate)=>{
                dispatch((0, (0, parcelRequire("1VLi2")).updateAndPersistIssue)(id, intervalId !== undefined ? {
                    sprintId: intervalId
                } : {
                    ...dates
                }, event, {
                    isDragged: !!meta?.isDragged,
                    hasOverdueReleaseDate: hasOverdueReleaseDate
                }));
            },
            onLeftClick: (id, { level: level, withCmd: withCmd, withShift: withShift }, analyticsEvent)=>{
                if ((0, (0, parcelRequire("4R6GH")).fg)('project_timeline_multi-select_and_checkboxes')) return;
                dispatch((0, (0, parcelRequire("lEiof")).selectItems)({
                    id: id,
                    level: level,
                    withCmd: withCmd,
                    withShift: withShift
                }, analyticsEvent));
            },
            onRightClick: (id, position)=>{
                dispatch((0, (0, parcelRequire("lEiof")).showToolTip)({
                    id: id,
                    type: (0, $12de84cd008e33eb$export$a9487b0be9740846),
                    position: position
                }));
            }
        });
    const $6266825a55b96177$var$mergeProps = (stateProps, dispatchProps, { id: id, isHovered: isHovered })=>({
            ...stateProps,
            ...dispatchProps,
            isHovered: isHovered,
            id: id.toString()
        });
    const $6266825a55b96177$var$DndLongTaskMetric = ({ level: level, isDragging: isDragging })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1mW3K")).DragAndDropLongTaskMetric), {
            isDragging: isDragging,
            metricType: (0, $8038b72ffd5aa8d4$export$2475592765cae5b0),
            extraProps: {
                isBaseLevel: (0, (0, parcelRequire("joGLY")).isBaseLevel)(level)
            }
        });
    var $6266825a55b96177$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((state, { id: id })=>{
        const chartData = (0, (0, parcelRequire("1cn7Z")).getChartDataHash)(state)[id];
        return {
            ...chartData,
            intervals: (0, (0, parcelRequire("bZFir")).getSprintIntervals)(state),
            isReadOnly: !(0, (0, parcelRequire("fvM4Z")).getCanUserEdit)(state),
            renderBarContent: (0, parcelRequire("cHx7J")).renderBarContent,
            DndLongTaskMetric: $6266825a55b96177$var$DndLongTaskMetric
        };
    }, $6266825a55b96177$var$mapDispatchToProps, $6266825a55b96177$var$mergeProps)((0, (0, parcelRequire("80iMb")).default));
});
const $12de84cd008e33eb$export$4b680a32bbb87a28 = 'DEPENDENCIES_FLYOUT';
const $12de84cd008e33eb$export$a9487b0be9740846 = 'CONTEXT_MENU';
parcelRegister("cHx7J", function(module, exports) {
    $parcel$export(module.exports, "renderBarContent", ()=>$5ed637b98fa2bb50$export$2c88996aa786b971);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $8QVIw;
    var $lkDhD;
    var $dVZd1;
    var $20BUF;
    const $5ed637b98fa2bb50$export$2c88996aa786b971 = (barContentProps, barContentState)=>{
        const barContentRenderers = {
            renderBarIcon: ({ id: id, isColorInverted: isColorInverted })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dVZd1")).default), {
                    id: id,
                    ...(0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-post-project-a11y-fix') ? {
                        isColorInverted: isColorInverted
                    } : {}
                }),
            renderDependencyHandler: (props, state)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("20BUF")).default), {
                    ...props,
                    ...state
                }),
            renderDateLabel: (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8QVIw")).RoadmapDateLabels), props)
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lkDhD")).RoadmapBarContent), {
            ...barContentProps,
            ...barContentState,
            ...barContentRenderers
        });
    };
});
parcelRegister("8QVIw", function(module, exports) {
    $parcel$export(module.exports, "RoadmapDateLabels", ()=>$8c8256320fa62b99$export$b6e3ec15be9e500e);
    var $5uXOq = parcelRequire("5uXOq");
    var $esmwW;
    var $2KlaV;
    var $6gIAo;
    var $cNXyp;
    var $15oyE;
    var $iW5q3;
    const $8c8256320fa62b99$export$b6e3ec15be9e500e = ({ prevStartDate: prevStartDate, prevDueDate: prevDueDate, startDate: startDate, dueDate: dueDate, startDateType: startDateType, dueDateType: dueDateType, placeholder: placeholder, dragType: dragType, getBarBoundingClientRect: getBarBoundingClientRect })=>{
        const displayStartDateType = dragType === (0, (0, parcelRequire("2KlaV")).LEFT) || dragType === (0, (0, parcelRequire("2KlaV")).LEFT_AND_RIGHT) ? (0, (0, parcelRequire("esmwW")).EXPLICIT) : startDateType;
        const displayDueDateType = dragType === (0, (0, parcelRequire("2KlaV")).RIGHT) || dragType === (0, (0, parcelRequire("2KlaV")).LEFT_AND_RIGHT) ? (0, (0, parcelRequire("esmwW")).EXPLICIT) : dueDateType;
        const displayPrevStartDate = dragType !== (0, (0, parcelRequire("2KlaV")).RIGHT) ? prevStartDate : undefined;
        const displayPrevDueDate = dragType !== (0, (0, parcelRequire("2KlaV")).LEFT) ? prevDueDate : undefined;
        const displayStartDate = dragType !== (0, (0, parcelRequire("2KlaV")).RIGHT) ? startDate : undefined;
        const displayDueDate = dragType !== (0, (0, parcelRequire("2KlaV")).LEFT) ? dueDate : undefined;
        const isDurationVisible = !placeholder;
        const placement = (0, (0, parcelRequire("iW5q3")).useDatePlacement)({
            dragType: dragType,
            startDateType: displayStartDateType,
            dueDateType: displayDueDateType,
            placeholder: placeholder,
            isDurationVisible: isDurationVisible,
            getBarBoundingClientRect: getBarBoundingClientRect
        });
        const renderDuration = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cNXyp")).Duration), (0, (0, parcelRequire("15oyE")).getDurationProps)(displayPrevStartDate, displayPrevDueDate, displayStartDate, displayDueDate, dragType, startDate, dueDate));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6gIAo")).FormattedDate), {
            placement: placement,
            startDate: displayStartDate,
            dueDate: displayDueDate,
            startDateType: displayStartDateType,
            dueDateType: displayDueDateType,
            placeholder: placeholder,
            isDurationVisible: isDurationVisible,
            renderDuration: renderDuration
        });
    };
    $8c8256320fa62b99$export$b6e3ec15be9e500e.defaultProps = {
        startDateType: (0, (0, parcelRequire("esmwW")).EXPLICIT),
        dueDateType: (0, (0, parcelRequire("esmwW")).EXPLICIT)
    };
});
parcelRegister("6gIAo", function(module, exports) {
    $parcel$export(module.exports, "FormattedDate", ()=>$56f9e8a00236f718$export$40ae3194919d16b);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $g11uZ;
    var $esmwW;
    var $2KlaV;
    var $d8OAB;
    var $cNXyp;
    var $d6q2B;
    var $fRvoq;
    const $56f9e8a00236f718$export$40ae3194919d16b = ({ startDate: startDate, dueDate: dueDate, startDateType: startDateType = (0, (0, parcelRequire("esmwW")).EXPLICIT), dueDateType: dueDateType = (0, (0, parcelRequire("esmwW")).EXPLICIT), placeholder: placeholder, isDurationVisible: isDurationVisible = false, placement: placement, renderDuration: renderDuration })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const startDatePlaceholderMessage = (0, (0, parcelRequire("d8OAB")).isStartDatePlaceholder)(placeholder) ? formatMessage((0, (0, parcelRequire("fRvoq")).default).noStartDate) : undefined;
        const dueDatePlaceholderMessage = (0, (0, parcelRequire("d8OAB")).isDueDatePlaceholder)(placeholder) ? formatMessage((0, (0, parcelRequire("fRvoq")).default).noDueDate) : undefined;
        const renderDurationLabel = (shouldRender = true)=>{
            const isDurationValid = startDate !== undefined || dueDate !== undefined;
            return isDurationVisible && isDurationValid && shouldRender ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, ' ', renderDuration ? renderDuration() : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cNXyp")).Duration), {
                fromDate: startDate ?? 0,
                toDate: dueDate ?? 0
            })) : null;
        };
        const renderDate = (dateType, date, placeholderMessage)=>{
            if (date === undefined) return null;
            const DateContainer = (0, (0, parcelRequire("d6q2B")).DATE_CONTAINER_LOOKUP)[dateType];
            const DateIcon = (0, (0, parcelRequire("d6q2B")).DATE_ICON_LOOKUP)[dateType];
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement(DateIcon, null), placeholderMessage ?? (0, ($parcel$interopDefault($5uXOq))).createElement(DateContainer, null, (0, (0, parcelRequire("g11uZ")).getDateFromTimestamp)(date)));
        };
        if (placement === (0, (0, parcelRequire("2KlaV")).LEFT_AND_RIGHT)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("small", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _19pkidpf _1p1dangw _o572qvpr _1pby37uc _jr2u1qyh",
                "_kqswstnw",
                "_1xi21osq _u5f3u2gc",
                "notranslate"
            ])
        }, renderDate(startDateType, startDate, startDatePlaceholderMessage), renderDurationLabel(startDate !== undefined && dueDate === undefined)), (0, ($parcel$interopDefault($5uXOq))).createElement("small", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _19pkidpf _1p1dangw _o572qvpr _1pby37uc _jr2u1qyh",
                "_kqswstnw",
                "_1ltv1osq _19bvu2gc",
                "notranslate"
            ])
        }, renderDate(dueDateType, dueDate, dueDatePlaceholderMessage), renderDurationLabel(dueDate !== undefined)));
        return (0, ($parcel$interopDefault($5uXOq))).createElement("small", {
            "data-testid": "roadmap.timeline-table-kit.common.ui.formatted-date.formatted-date",
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _19pkidpf _1p1dangw _o572qvpr _1pby37uc _jr2u1qyh",
                placement && "_kqswstnw",
                placement === (0, (0, parcelRequire("2KlaV")).LEFT) && "_1xi21osq _u5f3u2gc",
                placement === (0, (0, parcelRequire("2KlaV")).RIGHT) && "_1ltv1osq _19bvu2gc",
                "notranslate"
            ])
        }, renderDate(startDateType, startDate, startDatePlaceholderMessage), startDate !== undefined && dueDate !== undefined && ' - ', renderDate(dueDateType, dueDate, dueDatePlaceholderMessage), renderDurationLabel());
    };
    const $56f9e8a00236f718$var$placemenetLeftStyles = null;
    const $56f9e8a00236f718$var$placemenetRightStyles = null;
    const $56f9e8a00236f718$var$defaultPlacementStyles = null;
    const $56f9e8a00236f718$var$outerContainerStyles = null;
});
parcelRegister("cNXyp", function(module, exports) {
    $parcel$export(module.exports, "Duration", ()=>$a32f1b2b9e522298$export$3b11bc38611c5941);
    var $5uXOq = parcelRequire("5uXOq");
    var $86dU9;
    var $15oyE;
    const $a32f1b2b9e522298$export$3b11bc38611c5941 = ({ fromDate: fromDate, toDate: toDate, isSigned: isSigned, isToDateExcluded: isToDateExcluded })=>{
        const sign = toDate < fromDate ? '-' : '+';
        const duration = (0, (0, parcelRequire("15oyE")).getDaysInBetween)(fromDate, toDate, isToDateExcluded);
        return duration ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("86dU9")).default), {
            duration: duration,
            sign: isSigned ? sign : undefined
        }) : null;
    };
    $a32f1b2b9e522298$export$3b11bc38611c5941.defaultProps = {
        isSigned: false,
        isToDateExcluded: false
    };
});
parcelRegister("86dU9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a6f452643cc9662d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $16T6Y;
    var $koVbs;
    var $gHgzb;
    const $a6f452643cc9662d$var$DurationBadge = ({ duration: duration, sign: sign })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return duration ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("16T6Y")).default), null, formatMessage((0, (0, parcelRequire("gHgzb")).default).duration, {
            duration: `${sign ?? ''}${duration}`
        })) : null;
    };
    var $a6f452643cc9662d$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($a6f452643cc9662d$var$DurationBadge);
});
parcelRegister("gHgzb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2fbe47442e60766c$export$2e2bcd8739ae039);
    var $7VHMR;
    var $2fbe47442e60766c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        duration: {
            "id": "roadmap.timeline-table-kit.common.date-labels.duration.duration",
            "defaultMessage": "{duration}d"
        }
    });
});
parcelRegister("15oyE", function(module, exports) {
    $parcel$export(module.exports, "getDaysInBetween", ()=>$e6965f13b49c846a$export$ae6ef52daacfecd3);
    $parcel$export(module.exports, "getDurationProps", ()=>$e6965f13b49c846a$export$100189a9c6d8b999);
    const $e6965f13b49c846a$export$ae6ef52daacfecd3 = (fromDate, toDate, isToDateExcluded = false)=>Math.round(Math.abs(fromDate - toDate) / (0, $a797a5154a1373bc$export$1f04624003d2da7d)) + (isToDateExcluded ? 0 : 1);
    const $e6965f13b49c846a$export$100189a9c6d8b999 = (prevStartDate, prevDueDate, startDate, dueDate, dragType, currentStartDate, currentDueDate)=>{
        if (dragType === undefined || dragType === 'LEFT_AND_RIGHT') return {
            fromDate: currentStartDate,
            toDate: currentDueDate,
            isSigned: false,
            isToDateExcluded: false
        };
        const isDurationDiff = prevStartDate !== undefined && prevDueDate !== undefined && startDate !== undefined && dueDate !== undefined;
        const isStartDateFixed = prevDueDate !== undefined && startDate === undefined && dueDate !== undefined;
        const isDueDateFixed = prevStartDate !== undefined && startDate !== undefined && dueDate === undefined;
        const isDurationMeta = prevStartDate === undefined && prevDueDate === undefined && startDate !== undefined && dueDate !== undefined;
        if (isDurationDiff || isStartDateFixed) return {
            fromDate: prevDueDate,
            toDate: dueDate,
            isSigned: true,
            isToDateExcluded: true
        };
        if (isDueDateFixed) return {
            fromDate: startDate,
            toDate: prevStartDate,
            isSigned: true,
            isToDateExcluded: true
        };
        if (isDurationMeta) return {
            fromDate: startDate,
            toDate: dueDate,
            isSigned: false,
            isToDateExcluded: false
        };
        return {
            fromDate: startDate ?? 0,
            toDate: dueDate ?? 0,
            isSigned: false,
            isToDateExcluded: false
        };
    };
});
parcelRegister("d6q2B", function(module, exports) {
    $parcel$export(module.exports, "DATE_ICON_LOOKUP", ()=>$db9ef26425ad815b$export$b6abe4b9e409dfb2);
    $parcel$export(module.exports, "DATE_CONTAINER_LOOKUP", ()=>$db9ef26425ad815b$export$f3b594588fe8a99e);
    var $5uXOq = parcelRequire("5uXOq");
    var $esmwW;
    var $caQD3;
    var $6dG5H;
    const $db9ef26425ad815b$export$b6abe4b9e409dfb2 = {
        [(0, (0, parcelRequire("esmwW")).EXPLICIT)]: (0, $5uXOq.Fragment),
        [(0, (0, parcelRequire("esmwW")).ROLLUP)]: (0, (0, parcelRequire("caQD3")).RollupIcon),
        [(0, (0, parcelRequire("esmwW")).INTERVAL)]: (0, (0, parcelRequire("6dG5H")).SprintIcon)
    };
    const $db9ef26425ad815b$export$f3b594588fe8a99e = {
        [(0, (0, parcelRequire("esmwW")).EXPLICIT)]: (0, $5uXOq.Fragment),
        [(0, (0, parcelRequire("esmwW")).ROLLUP)]: 'i',
        [(0, (0, parcelRequire("esmwW")).INTERVAL)]: 'i'
    };
});
parcelRegister("caQD3", function(module, exports) {
    $parcel$export(module.exports, "RollupIcon", ()=>$2d66613b8d0cd878$export$a33e84c97d0c570c);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $5LWLA;
    var $koVbs;
    var $fZAx6;
    const $2d66613b8d0cd878$var$getRollupIconGlyph = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "currentColor",
            d: "M14.586 11l-2.293-2.293a1 1 0 1 1 1.414-1.414l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L14.586 13H10a1 1 0 0 0-1 1v7a1 1 0 0 1-2 0v-7a3 3 0 0 1 3-3h4.586z"
        }));
    const $2d66613b8d0cd878$export$a33e84c97d0c570c = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($2d66613b8d0cd878$var$Container, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            glyph: $2d66613b8d0cd878$var$getRollupIconGlyph,
            label: formatMessage((0, (0, parcelRequire("fZAx6")).default).rollUpIconLabel),
            size: "small"
        }));
    };
    const $2d66613b8d0cd878$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3igktf _1bsb7vkz _2hwxv77o",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("fZAx6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$330047c05926d5ce$export$2e2bcd8739ae039);
    var $7VHMR;
    const $330047c05926d5ce$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        rollUpIconLabel: {
            "id": "roadmap.timeline-table-kit.common.rollup-icon.roll-up-icon-label",
            "defaultMessage": "Roll-up"
        }
    });
    var $330047c05926d5ce$export$2e2bcd8739ae039 = $330047c05926d5ce$var$messages;
});
parcelRegister("fRvoq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$95dc3801f4e0c608$export$2e2bcd8739ae039);
    var $7VHMR;
    var $95dc3801f4e0c608$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noStartDate: {
            "id": "roadmap.timeline-table-kit.common.formatted-date.no-start-date",
            "defaultMessage": "No start date"
        },
        noDueDate: {
            "id": "roadmap.timeline-table-kit.common.formatted-date.no-due-date",
            "defaultMessage": "No due date"
        }
    });
});
parcelRegister("iW5q3", function(module, exports) {
    $parcel$export(module.exports, "useDatePlacement", ()=>$d185f496f15bad19$export$469d58375b7706b3);
    var $kyahI;
    var $2KlaV;
    var $aU7Qz;
    const $d185f496f15bad19$export$469d58375b7706b3 = ({ dragType: dragType, placeholder: placeholder, startDateType: startDateType, dueDateType: dueDateType, isDurationVisible: isDurationVisible, getBarBoundingClientRect: getBarBoundingClientRect })=>{
        const { requestViewportBoundingClient: requestViewportBoundingClient } = (0, (0, parcelRequire("kyahI")).useViewport)();
        const rect = getBarBoundingClientRect();
        if (!rect) return 0, (0, parcelRequire("2KlaV")).LEFT_AND_RIGHT;
        const { isStartDateVisible: isStartDateVisible, isDueDateVisible: isDueDateVisible } = (0, (0, parcelRequire("aU7Qz")).calculateDateVisibilities)(rect, requestViewportBoundingClient(), placeholder, startDateType, dueDateType, isDurationVisible);
        return (0, (0, parcelRequire("aU7Qz")).getDatePlacement)(dragType, isStartDateVisible, isDueDateVisible);
    };
});
parcelRegister("aU7Qz", function(module, exports) {
    $parcel$export(module.exports, "calculateDateVisibilities", ()=>$e9b4be47a370b3b5$export$883141a0ed8178c0);
    $parcel$export(module.exports, "getDatePlacement", ()=>$e9b4be47a370b3b5$export$af34474977f1fefb);
    var $esmwW;
    var $2KlaV;
    var $d8OAB;
    const $e9b4be47a370b3b5$var$APPROX_DATE_PIXELS = 85;
    const $e9b4be47a370b3b5$var$APPROX_PLACEHOLDER_PIXELS = 98;
    const $e9b4be47a370b3b5$var$APPROX_ICON_PIXELS = 20;
    const $e9b4be47a370b3b5$var$APPOX_DURATION_PIXELS = 33;
    const $e9b4be47a370b3b5$var$add = (accumulator, nextValue)=>accumulator + nextValue;
    const $e9b4be47a370b3b5$export$883141a0ed8178c0 = (barRect, viewportRect, placeholder, startDateType, dueDateType, isDurationVisible)=>{
        const { left: barLeft, right: barRight } = barRect;
        const { left: viewportLeft, right: viewportRight } = viewportRect;
        const availableLeftSpace = barLeft - viewportLeft;
        const availableRightSpace = viewportRight - barRight;
        const hasStartDateIcon = startDateType !== (0, (0, parcelRequire("esmwW")).EXPLICIT);
        const hasDueDateIcon = dueDateType !== (0, (0, parcelRequire("esmwW")).EXPLICIT);
        const spaceRequiredLeft = [
            (0, (0, parcelRequire("d8OAB")).isStartDatePlaceholder)(placeholder) ? $e9b4be47a370b3b5$var$APPROX_PLACEHOLDER_PIXELS : $e9b4be47a370b3b5$var$APPROX_DATE_PIXELS,
            hasStartDateIcon ? $e9b4be47a370b3b5$var$APPROX_ICON_PIXELS : 0
        ];
        const spaceRequiredRight = [
            (0, (0, parcelRequire("d8OAB")).isDueDatePlaceholder)(placeholder) ? $e9b4be47a370b3b5$var$APPROX_PLACEHOLDER_PIXELS : $e9b4be47a370b3b5$var$APPROX_DATE_PIXELS,
            hasDueDateIcon ? $e9b4be47a370b3b5$var$APPROX_ICON_PIXELS : 0,
            isDurationVisible ? $e9b4be47a370b3b5$var$APPOX_DURATION_PIXELS : 0
        ];
        return {
            isStartDateVisible: spaceRequiredLeft.reduce($e9b4be47a370b3b5$var$add, 0) <= availableLeftSpace,
            isDueDateVisible: spaceRequiredRight.reduce($e9b4be47a370b3b5$var$add, 0) <= availableRightSpace
        };
    };
    const $e9b4be47a370b3b5$export$af34474977f1fefb = (dragType, isStartDateVisible, isDueDateVisible)=>{
        if (dragType === (0, (0, parcelRequire("2KlaV")).LEFT_AND_RIGHT) || isStartDateVisible && isDueDateVisible || !isStartDateVisible && !isDueDateVisible) return 0, (0, parcelRequire("2KlaV")).LEFT_AND_RIGHT;
        return isStartDateVisible ? (0, (0, parcelRequire("2KlaV")).LEFT) : (0, (0, parcelRequire("2KlaV")).RIGHT);
    };
});
parcelRegister("lkDhD", function(module, exports) {
    $parcel$export(module.exports, "RoadmapBarContent", ()=>$30e77cb4b5d52032$export$6ad7b40eb111e24e);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $2KlaV;
    const $30e77cb4b5d52032$export$6ad7b40eb111e24e = ({ id: id, dragType: dragType, leftPosition: leftPosition, rightPosition: rightPosition, prevStartDate: prevStartDate, prevDueDate: prevDueDate, startDate: startDate, dueDate: dueDate, startDateType: startDateType, dueDateType: dueDateType, placeholder: placeholder, isActive: isActive, isReadOnly: isReadOnly, isMinimumBar: isMinimumBar, isColorInverted: isColorInverted, renderBarIcon: renderBarIcon, renderDateLabel: renderDateLabel, renderDependencyHandler: renderDependencyHandler, onBarMouseLeave: onBarMouseLeave, getBarBoundingClientRect: getBarBoundingClientRect })=>{
        const isHovered = isActive && !dragType;
        const isDraggingExplicit = isActive && dragType !== undefined;
        const isDragging = dragType !== undefined;
        const getRenderDependencyHandler = ()=>!isDragging && !isReadOnly && renderDependencyHandler({
                id: id,
                leftPosition: leftPosition,
                rightPosition: rightPosition,
                placeholder: placeholder,
                isColorInverted: isColorInverted,
                getBarBoundingClientRect: getBarBoundingClientRect,
                onBarMouseLeave: onBarMouseLeave
            }, {
                isHovered: isHovered
            });
        const getRenderDateLabel = ()=>isDraggingExplicit || isHovered ? renderDateLabel({
                prevStartDate: prevStartDate,
                prevDueDate: prevDueDate,
                startDate: startDate,
                dueDate: dueDate,
                startDateType: startDateType,
                dueDateType: dueDateType,
                placeholder: placeholder,
                getBarBoundingClientRect: getBarBoundingClientRect,
                dragType: dragType
            }) : null;
        const getRenderBarIcon = ()=>!isMinimumBar && !isDraggingExplicit && renderBarIcon({
                id: id,
                leftPosition: leftPosition,
                rightPosition: rightPosition,
                ...(0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-post-project-a11y-fix') ? {
                    isColorInverted: isColorInverted
                } : {}
            });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, getRenderDependencyHandler(), getRenderDateLabel(), getRenderBarIcon());
    };
    $30e77cb4b5d52032$export$6ad7b40eb111e24e.defaultProps = {
        renderBarIcon: (0, (0, parcelRequire("2KlaV")).DEFAULT_RENDERER),
        renderDateLabel: (0, (0, parcelRequire("2KlaV")).DEFAULT_RENDERER),
        renderDependencyHandler: (0, (0, parcelRequire("2KlaV")).DEFAULT_RENDERER)
    };
});
parcelRegister("dVZd1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d68ec4d543277483$export$2e2bcd8739ae039);
    var $4R6GH;
    var $bC2fB;
    var $joGLY;
    var $hFyhA;
    var $5FvOv;
    var $2IdXh;
    var $lEiof;
    var $ihqSu;
    const $d68ec4d543277483$var$EMPTY_ARRAY = [];
    const $d68ec4d543277483$var$mapDispatchToProps = (dispatch, { id: id })=>({
            onClickIcon: (fromIds, toIds, position, triggerRef)=>{
                dispatch((0, (0, parcelRequire("lEiof")).showToolTip)({
                    id: id,
                    type: (0, $12de84cd008e33eb$export$4b680a32bbb87a28),
                    links: {
                        fromIds: fromIds,
                        toIds: toIds
                    },
                    position: position,
                    showImplicitDependency: true,
                    ...(0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-dependency-flyout-refocus') ? {
                        triggerRef: triggerRef
                    } : {}
                }));
            }
        });
    const $d68ec4d543277483$var$mergeProps = (stateProps, dispatchProps, ownProps)=>({
            ...stateProps,
            ...dispatchProps,
            ...(0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-post-project-a11y-fix') ? ownProps : {}
        });
    var $d68ec4d543277483$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((state, { id: id })=>{
        const issueId = id;
        const level = (0, (0, parcelRequire("hFyhA")).getIssueLevel)(state, issueId);
        const implicitDependencyItems = !(0, (0, parcelRequire("joGLY")).isBaseLevel)(level) ? (0, (0, parcelRequire("5FvOv")).getImplicitDependencyItemsForIssue)(state, issueId) || $d68ec4d543277483$var$EMPTY_ARRAY : $d68ec4d543277483$var$EMPTY_ARRAY;
        return {
            dependencies: (0, (0, parcelRequire("2IdXh")).getIssueDependencies)(state, issueId) || $d68ec4d543277483$var$EMPTY_ARRAY,
            dependees: (0, (0, parcelRequire("2IdXh")).getIssueDependees)(state, issueId) || $d68ec4d543277483$var$EMPTY_ARRAY,
            level: level,
            hasImplicitDependency: implicitDependencyItems.length > 0
        };
    }, $d68ec4d543277483$var$mapDispatchToProps, $d68ec4d543277483$var$mergeProps)((0, (0, parcelRequire("ihqSu")).default));
});
parcelRegister("5FvOv", function(module, exports) {
    $parcel$export(module.exports, "getDependenciesTooltipParams", ()=>$acd6b8ddf076c4d1$export$9b579a6f4b6af263);
    $parcel$export(module.exports, "getSelectedDependency", ()=>$acd6b8ddf076c4d1$export$aff715abe5e6e33c);
    $parcel$export(module.exports, "getImplicitDependencyItemsForIssue", ()=>$acd6b8ddf076c4d1$export$ead33b6fc6be1605);
    $parcel$export(module.exports, "getDependenciesItems", ()=>$acd6b8ddf076c4d1$export$675e7796a0dd4b1e);
    $parcel$export(module.exports, "getDependencyItem", ()=>$acd6b8ddf076c4d1$export$71656e1e0a89c318);
    $parcel$export(module.exports, "getDependencyItems", ()=>$acd6b8ddf076c4d1$export$d372e74aefbd38cf);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $4gYYI;
    var $hFyhA;
    var $bM42j;
    var $hhYQB;
    var $2IdXh;
    var $bZFir;
    var $cYRYp;
    var $8uNFS;
    var $1cn7Z;
    var $b8ihP;
    const $acd6b8ddf076c4d1$var$EMPTY_DEPENDENCY = [];
    const $acd6b8ddf076c4d1$var$getIssueAttributeHashes = (0, $dGvGJ.createStructuredSelector)({
        issueSummaryHash: (0, (0, parcelRequire("hFyhA")).getIssueSummaryHash),
        issueTypeIdHash: (0, (0, parcelRequire("hFyhA")).getIssueTypeIdHash),
        issueDueDateHash: (0, (0, parcelRequire("hFyhA")).getIssueDueDateHash),
        issueStartDateHash: (0, (0, parcelRequire("hFyhA")).getIssueStartDateHash),
        issueKeyHash: (0, (0, parcelRequire("hFyhA")).getIssueKeyHash),
        issueParentIdHash: (0, (0, parcelRequire("hFyhA")).getIssueParentIdHash)
    });
    const $acd6b8ddf076c4d1$export$12d5a003c51154a3 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("hFyhA")).getIssueIds), (0, (0, parcelRequire("2IdXh")).getFilteredIssueIdsHash), $acd6b8ddf076c4d1$var$getIssueAttributeHashes, (0, (0, parcelRequire("4gYYI")).getFullIssueTypeHash), (0, (0, parcelRequire("bZFir")).getSanitisedIssueSprintsHash), (0, (0, parcelRequire("4gYYI")).getIsSprintsPlanningEnabled), (0, (0, parcelRequire("4gYYI")).getIsChildIssuePlanningEnabled), (0, (0, parcelRequire("8uNFS")).getParentRolledUpDatesHash), (0, (0, parcelRequire("hhYQB")).isDependenciesVisible), (issueIds, filteredIssueIdHash, { issueSummaryHash: issueSummaryHash, issueTypeIdHash: issueTypeIdHash, issueDueDateHash: issueDueDateHash, issueStartDateHash: issueStartDateHash, issueKeyHash: issueKeyHash, issueParentIdHash: issueParentIdHash }, fullIssueTypes, issueSprintsHash, isSprintsPlanning, isChildIssuePlanningEnabled, parentRolledUpDatesHash, isDependenciesVisibleValue)=>(0, (0, parcelRequire("b8ihP")).getIssueAttributesHashPure)(issueIds, filteredIssueIdHash, issueSummaryHash, issueTypeIdHash, fullIssueTypes, issueDueDateHash, issueStartDateHash, issueKeyHash, issueParentIdHash, issueSprintsHash, isSprintsPlanning, isChildIssuePlanningEnabled, parentRolledUpDatesHash, isDependenciesVisibleValue));
    const $acd6b8ddf076c4d1$export$8d602178215eb1a8 = (state, issueId)=>$acd6b8ddf076c4d1$export$12d5a003c51154a3(state)[issueId];
    const $acd6b8ddf076c4d1$export$9b579a6f4b6af263 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("bM42j")).getTooltipParams), (0, (0, parcelRequire("hFyhA")).getIssueDependenciesHash), (0, (0, parcelRequire("hFyhA")).getIssueDependeesHash), (0, (0, parcelRequire("b8ihP")).getDependenciesTooltipParamsPure));
    const $acd6b8ddf076c4d1$export$aff715abe5e6e33c = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("bM42j")).getTooltipParams), (0, (0, parcelRequire("hFyhA")).getIssueDependeesHash), (0, (0, parcelRequire("b8ihP")).getSelectedDependencyPure));
    const $acd6b8ddf076c4d1$export$7627e0a994fa9128 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("2IdXh")).getFilteredIssueIds), (0, (0, parcelRequire("hFyhA")).getIssueParentIdHash), (0, (0, parcelRequire("bM42j")).getExpandedItems), (0, (0, parcelRequire("2IdXh")).getFilteredIssueDependenciesHash), (0, (0, parcelRequire("2IdXh")).getFilteredIssueDependeesHash), $acd6b8ddf076c4d1$export$12d5a003c51154a3, (0, (0, parcelRequire("4gYYI")).getIsChildIssuePlanningEnabled), (0, (0, parcelRequire("b8ihP")).getImplicitDependencyItemsHashPure));
    const $acd6b8ddf076c4d1$export$ead33b6fc6be1605 = (state, issueId)=>$acd6b8ddf076c4d1$export$7627e0a994fa9128(state)[issueId] || $acd6b8ddf076c4d1$var$EMPTY_DEPENDENCY;
    const $acd6b8ddf076c4d1$export$675e7796a0dd4b1e = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("cYRYp")).getChartItemTopPositionHash), (0, (0, parcelRequire("1cn7Z")).getChartDataHash), (0, (0, parcelRequire("hFyhA")).getIssueDependenciesHash), (0, (0, parcelRequire("4gYYI")).getEpicIssueTypeIds), (0, (0, parcelRequire("hFyhA")).getIssueTypeIdHash), (0, (0, parcelRequire("1cn7Z")).getItemHeight), (0, (0, parcelRequire("b8ihP")).getDependenciesItemsPure));
    const $acd6b8ddf076c4d1$export$71656e1e0a89c318 = (state, issueId)=>$acd6b8ddf076c4d1$export$8d602178215eb1a8(state, issueId);
    const $acd6b8ddf076c4d1$export$d372e74aefbd38cf = (state, issueIds)=>issueIds.flatMap((issueId)=>$acd6b8ddf076c4d1$export$71656e1e0a89c318(state, issueId) || $acd6b8ddf076c4d1$var$EMPTY_DEPENDENCY);
});
parcelRegister("cYRYp", function(module, exports) {
    $parcel$export(module.exports, "getChartItemTopPositionHash", ()=>$47524e12395a8f6c$export$f2a9f880d7b1b487);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $bM42j;
    var $2IdXh;
    var $d5e2N;
    var $1cn7Z;
    const $47524e12395a8f6c$export$f2a9f880d7b1b487 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("1cn7Z")).getTableHeaderItemsHeight), (0, (0, parcelRequire("1cn7Z")).getItemHeight), (0, (0, parcelRequire("2IdXh")).getFilteredNonBaseLevelIssueIds), (0, (0, parcelRequire("2IdXh")).getFilteredChildIssueIdsHash), (0, (0, parcelRequire("bM42j")).getExpandedItems), (0, (0, parcelRequire("bM42j")).getCreateItemAnchor), (0, (0, parcelRequire("d5e2N")).getItemOffsetPositions));
});
parcelRegister("b8ihP", function(module, exports) {
    $parcel$export(module.exports, "getIssueAttributesHashPure", ()=>$f741ae1ec62aa8f3$export$29174164fa2c98c2);
    $parcel$export(module.exports, "getSelectedDependencyPure", ()=>$f741ae1ec62aa8f3$export$67519885927894ef);
    $parcel$export(module.exports, "getDependenciesTooltipParamsPure", ()=>$f741ae1ec62aa8f3$export$a0f4289e45235721);
    $parcel$export(module.exports, "getImplicitDependencyItemsHashPure", ()=>$f741ae1ec62aa8f3$export$db7646447e16ed5d);
    $parcel$export(module.exports, "getDependenciesItemsPure", ()=>$f741ae1ec62aa8f3$export$d1d736cec8b87807);
    var $4R6GH;
    var $15ADj;
    var $iZN6h;
    var $7mhr2;
    var $fnJ0I;
    var $2YnqS;
    const $f741ae1ec62aa8f3$var$getWarningMessage = (isHiddenByView, isHidden)=>{
        const warningMessages = [];
        if (isHiddenByView) {
            warningMessages.push((0, (0, parcelRequire("2YnqS")).default).hiddenByViewsConfigurationWarning);
            return warningMessages;
        }
        if (isHidden) {
            warningMessages.push((0, (0, parcelRequire("2YnqS")).default).hiddenByFilterWarning);
            return warningMessages;
        }
        return warningMessages;
    };
    const $f741ae1ec62aa8f3$var$getDateData = ({ startDate: startDate, dueDate: dueDate, startDateType: startDateType, dueDateType: dueDateType, placeholder: placeholder })=>({
            startDate: placeholder === (0, (0, parcelRequire("15ADj")).START_DATE_PLACEHOLDER) || placeholder === (0, (0, parcelRequire("15ADj")).START_AND_DUE_DATE_PLACEHOLDER) ? undefined : startDate,
            dueDate: placeholder === (0, (0, parcelRequire("15ADj")).DUE_DATE_PLACEHOLDER) || placeholder === (0, (0, parcelRequire("15ADj")).START_AND_DUE_DATE_PLACEHOLDER) ? undefined : dueDate,
            startDateType: startDateType,
            dueDateType: dueDateType
        });
    const $f741ae1ec62aa8f3$export$29174164fa2c98c2 = (issueIds, filteredIssueIdHash, issueSummaries, issueTypes, fullIssueTypes, issueDueDates, issueStartDates, issueKeyHash, parentIdHash, issueSprintsHash, isSprintsPlanning, isChildIssuePlanningEnabled, parentRolledUpDatesHash, isDependenciesVisible)=>{
        const attributesHash = {};
        issueIds.forEach((issueId)=>{
            const isVisible = filteredIssueIdHash[issueId] ?? false;
            const issueType = fullIssueTypes[issueTypes[issueId]];
            const parentId = parentIdHash[issueId];
            const isChildIssue = parentId !== undefined;
            const startDate = issueStartDates[issueId];
            const dueDate = issueDueDates[issueId];
            if (!isChildIssue) {
                const parentDateData = $f741ae1ec62aa8f3$var$getDateData((0, (0, parcelRequire("fnJ0I")).getParentLevelDates)(startDate, dueDate, parentRolledUpDatesHash[issueId], isChildIssuePlanningEnabled));
                attributesHash[`${issueId}`] = {
                    id: issueId,
                    itemKey: issueKeyHash[issueId],
                    title: issueSummaries[issueId],
                    typeName: issueType ? issueType.name : '',
                    iconUrl: issueType ? issueType.iconUrl : '',
                    isHidden: !isVisible,
                    warningMessages: $f741ae1ec62aa8f3$var$getWarningMessage(!isDependenciesVisible, !isVisible),
                    parent: undefined,
                    intervalName: undefined,
                    startDate: parentDateData.startDate,
                    dueDate: parentDateData.dueDate,
                    startDateType: parentDateData.startDateType,
                    dueDateType: parentDateData.dueDateType
                };
            } else {
                const childDateData = $f741ae1ec62aa8f3$var$getDateData((0, (0, parcelRequire("fnJ0I")).getBaseLevelDates)(startDate, dueDate, issueSprintsHash[issueId], isSprintsPlanning, isChildIssuePlanningEnabled));
                const parent = parentId && issueTypes[parentId] ? {
                    iconUrl: fullIssueTypes[issueTypes[parentId]].iconUrl,
                    title: issueSummaries[parentId]
                } : undefined;
                const sprintName = parentId !== undefined && isSprintsPlanning ? (0, (0, parcelRequire("7mhr2")).getSprintNameForBaseLevelIssue)(issueId, issueSprintsHash) : undefined;
                attributesHash[`${issueId}`] = {
                    id: issueId,
                    itemKey: issueKeyHash[issueId],
                    title: issueSummaries[issueId],
                    typeName: issueType ? issueType.name : '',
                    iconUrl: issueType ? issueType.iconUrl : '',
                    isHidden: !isVisible,
                    warningMessages: $f741ae1ec62aa8f3$var$getWarningMessage(!isDependenciesVisible, !isVisible),
                    parent: parent,
                    intervalName: sprintName,
                    startDate: childDateData.startDate,
                    dueDate: childDateData.dueDate,
                    startDateType: childDateData.startDateType,
                    dueDateType: childDateData.dueDateType
                };
            }
        });
        return attributesHash;
    };
    const $f741ae1ec62aa8f3$export$67519885927894ef = (tooltipParams, dependeesHash)=>{
        if (tooltipParams && tooltipParams.type === (0, $12de84cd008e33eb$export$4b680a32bbb87a28)) {
            const { id: id, links: { toIds: toIds } } = tooltipParams;
            const toId = toIds.find((dependee)=>dependeesHash[id] && dependeesHash[id].includes(dependee));
            if (toId !== undefined) return {
                fromId: id,
                toId: toId
            };
        }
        return undefined;
    };
    const $f741ae1ec62aa8f3$export$a0f4289e45235721 = (tooltipParams, dependenciesHash, dependeesHash)=>{
        if (tooltipParams && tooltipParams.type === (0, $12de84cd008e33eb$export$4b680a32bbb87a28)) {
            const { id: id, position: position, links: { fromIds: fromIds, toIds: toIds }, showImplicitDependency: showImplicitDependency } = tooltipParams;
            const filteredDependencies = fromIds.filter((dependency)=>dependenciesHash[id] && dependenciesHash[id].includes(dependency));
            const filteredDependees = toIds.filter((dependee)=>dependeesHash[id] && dependeesHash[id].includes(dependee));
            return {
                position: position,
                issueId: id,
                type: tooltipParams.type,
                dependencies: filteredDependencies,
                dependees: filteredDependees,
                showImplicitDependency: showImplicitDependency,
                ...(0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-dependency-flyout-refocus') ? {
                    triggerRef: tooltipParams.triggerRef
                } : {}
            };
        }
        return undefined;
    };
    const $f741ae1ec62aa8f3$export$db7646447e16ed5d = (issueIds, issueParentIdHash, expandedItems, filteredIssueDependencies, filteredIssueDependees, attributesHash, isChildIssuePlanningEnabled)=>{
        const implicitDependencyItems = {};
        isChildIssuePlanningEnabled && issueIds.forEach((issueId)=>{
            const parentId = issueParentIdHash[issueId];
            const isChildIssue = parentId !== undefined;
            const isParentIssueCollapsed = Boolean(parentId && !expandedItems[parentId]);
            if (isChildIssue && isParentIssueCollapsed) {
                const dependencies = filteredIssueDependencies[issueId]?.map((id)=>attributesHash[id]) ?? [];
                const dependees = filteredIssueDependees[issueId]?.map((id)=>attributesHash[id]) ?? [];
                if (dependencies.length > 0 || dependees.length > 0) {
                    const item = attributesHash[issueId];
                    if (parentId) {
                        if (implicitDependencyItems[parentId] === undefined) implicitDependencyItems[parentId] = [];
                        implicitDependencyItems[parentId].push({
                            item: item,
                            dependencies: dependencies,
                            dependees: dependees
                        });
                    }
                }
            }
        });
        return implicitDependencyItems;
    };
    const $f741ae1ec62aa8f3$export$d1d736cec8b87807 = (positionsHash, itemsHash, dependenciesHash, epicIssueTypeIds, issueTypeIdHash, defaultItemHeight)=>{
        const dependencies = [];
        Object.keys(dependenciesHash).forEach((issueId)=>{
            const blockedIssueId = issueId;
            const issueDependencies = dependenciesHash[blockedIssueId];
            if (itemsHash[blockedIssueId] && positionsHash[blockedIssueId] !== undefined) {
                const blockedItem = itemsHash[blockedIssueId];
                const blockedItemStartDate = blockedItem.startDate;
                if (blockedItemStartDate !== undefined) {
                    const to = {
                        id: blockedIssueId,
                        startDate: blockedItemStartDate,
                        y: positionsHash[blockedIssueId],
                        color: blockedItem.color
                    };
                    issueDependencies.forEach((blockerIssueId)=>{
                        if (itemsHash[blockerIssueId] && positionsHash[blockerIssueId] !== undefined) {
                            const blockerItem = itemsHash[blockerIssueId];
                            const blockerItemDueDate = blockerItem.dueDate;
                            if (blockerItemDueDate !== undefined) {
                                const itemHeight = !epicIssueTypeIds.includes(issueTypeIdHash[blockedIssueId]) || !epicIssueTypeIds.includes(issueTypeIdHash[blockerIssueId]) ? (0, (0, parcelRequire("iZN6h")).BASE_LEVEL_ITEM_HEIGHT)() : defaultItemHeight;
                                dependencies.push({
                                    itemHeight: itemHeight,
                                    from: {
                                        id: blockerIssueId,
                                        dueDate: blockerItemDueDate,
                                        y: positionsHash[blockerIssueId],
                                        color: blockerItem.color
                                    },
                                    to: to
                                });
                            }
                        }
                    });
                }
            }
        });
        return dependencies;
    };
});
parcelRegister("7mhr2", function(module, exports) {
    $parcel$export(module.exports, "getSprintNameForBaseLevelIssue", ()=>$f340de35c468364a$export$bb3e998d749b9888);
    const $f340de35c468364a$export$bb3e998d749b9888 = (issueId, issueSprintsHash)=>{
        const issueSprints = issueSprintsHash[issueId];
        if (issueSprints.length > 0) {
            const recentSprint = issueSprints[0];
            return recentSprint?.name;
        }
        return undefined;
    };
});
parcelRegister("2YnqS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8119aa3244fc8b56$export$2e2bcd8739ae039);
    var $7VHMR;
    var $8119aa3244fc8b56$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        hiddenByFilterWarning: {
            "id": "roadmap.standard-roadmap.state.selectors.dependencies.hidden-by-filter-warning",
            "defaultMessage": "Hidden by filter"
        },
        hiddenByViewsConfigurationWarning: {
            "id": "roadmap.standard-roadmap.state.selectors.dependencies.hidden-by-views-configuration-warning",
            "defaultMessage": "Hidden by \"Views\" dropdown"
        }
    });
});
parcelRegister("ihqSu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c11e267c0a838347$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $8QHH1;
    var $82CeN;
    const $c11e267c0a838347$var$BarIcon = ({ level: level, dependencies: dependencies, dependees: dependees, hasImplicitDependency: hasImplicitDependency, isColorInverted: isColorInverted, onClickIcon: onClickIcon })=>{
        const { shouldPreventNavigation: shouldPreventNavigation } = (0, (0, parcelRequire("82CeN")).useFocusMarshal)();
        const triggerRef = (0, $5uXOq.useRef)(null);
        const onClick = (0, $5uXOq.useCallback)((position)=>{
            if ((0, (0, parcelRequire("4R6GH")).fg)('timeline_grid_navigation_m2')) shouldPreventNavigation(true);
            if ((0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-dependency-flyout-refocus')) onClickIcon(dependencies, dependees, position, triggerRef);
            else onClickIcon(dependencies, dependees, position);
        }, [
            shouldPreventNavigation,
            onClickIcon,
            dependencies,
            dependees
        ]);
        if (dependencies.length === 0 && dependees.length === 0 && !hasImplicitDependency) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8QHH1")).RoadmapBarIcon), {
            level: level,
            onClick: onClick,
            ...(0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-post-project-a11y-fix') ? {
                isColorInverted: isColorInverted
            } : {},
            ...(0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-dependency-flyout-refocus') ? {
                ref: triggerRef
            } : {}
        });
    };
    var $c11e267c0a838347$export$2e2bcd8739ae039 = $c11e267c0a838347$var$BarIcon;
});
parcelRegister("8QHH1", function(module, exports) {
    $parcel$export(module.exports, "RoadmapBarIcon", ()=>$4e12c5ad2d7cfc88$export$31f28142b8ae6fe0);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $bWn3s;
    var $jOyH3;
    var $dC5iT;
    var $8CUq3;
    var $eTXmK;
    var $hxoiH;
    var $3bDjY;
    var $4R6GH;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $1YcpO;
    var $dCm1o;
    var $c5xba;
    const $4e12c5ad2d7cfc88$export$31f28142b8ae6fe0 = (0, $5uXOq.forwardRef)(({ level: level, isColorInverted: isColorInverted, onClick: onClick }, ref)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { colorMode: colorMode } = (0, (0, parcelRequire("hxoiH")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const handleEvent = (0, $5uXOq.useCallback)(({ timeStamp: timeStamp, target: target })=>{
            (0, (0, parcelRequire("eTXmK")).default)('timeline-dependency-clicked', timeStamp);
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'icon'
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'dependencyIcon', {
                level: level
            });
            const { top: top, left: left, width: width } = target.getBoundingClientRect();
            const position = {
                y: top + width,
                x: left
            };
            onClick(position);
        }, [
            onClick,
            level,
            createAnalyticsEvent
        ]);
        const onClickCallback = (0, $5uXOq.useCallback)((event)=>{
            handleEvent({
                timeStamp: event.timeStamp,
                target: event.currentTarget
            });
        }, [
            handleEvent
        ]);
        const onKeyDownCallback = (0, $5uXOq.useCallback)((event)=>{
            if ((0, (0, parcelRequire("1YcpO")).isEnterOrSpaceKey)(event)) {
                event.preventDefault();
                handleEvent({
                    timeStamp: event.timeStamp,
                    target: event.currentTarget
                });
            }
        }, [
            handleEvent
        ]);
        const CustomToolTipTag = (0, $5uXOq.useMemo)(()=>(0, $5uXOq.forwardRef)((props, tooltipRef)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    ...props,
                    ref: (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-dependency-flyout-refocus') ? (0, (0, parcelRequire("bWn3s")).mergeRefs)([
                        ref,
                        tooltipRef
                    ]) : tooltipRef,
                    onClick: onClickCallback,
                    role: "button",
                    onKeyDown: onKeyDownCallback,
                    tabIndex: 0,
                    "aria-label": formatMessage((0, (0, parcelRequire("c5xba")).default).viewDetail),
                    className: (0, (0, parcelRequire("bwpsq")).default)([
                        (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('visual-refresh_drop_1') ? "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsbv47k _4t3iv47k _2hwx1b66 _2rko1l7b _w0lv1dl1 _1pbyegat _80omtlke _p7r11txw _irr31fly" : "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsbv47k _4t3iv47k _2hwx1b66 _2rko1ssb _1pbyegat _80omtlke _p7r11txw _irr31fly",
                        isColorInverted && (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-post-project-a11y-fix') && "_irr315ej"
                    ])
                })), [
            isColorInverted,
            ref,
            onClickCallback,
            onKeyDownCallback,
            formatMessage
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            tag: CustomToolTipTag,
            position: "top",
            content: formatMessage((0, (0, parcelRequire("c5xba")).default).viewDetail)
        }, colorMode && !(0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-post-project-a11y-fix') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $4e12c5ad2d7cfc88$var$opacityStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("jOyH3"))))), {
            label: "",
            color: "var(--ds-text-inverse, #FFFFFF)",
            testId: "roadmap.timeline-table-kit.ui.chart-item-content.date-content.bar.bar-content.bar-icon.link-icon",
            ...(0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-post-project-a11y-fix') ? {
                LEGACY_size: 'small'
            } : {}
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("jOyH3"))))), {
            label: "",
            color: isColorInverted && (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-post-project-a11y-fix') ? "var(--ds-icon, #44546F)" : "var(--ds-text-inverse, #FFFFFF)",
            testId: "roadmap.timeline-table-kit.ui.chart-item-content.date-content.bar.bar-content.bar-icon.link-icon",
            ...(0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-post-project-a11y-fix') ? {
                LEGACY_size: 'small'
            } : {}
        }));
    });
    const $4e12c5ad2d7cfc88$var$iconWrapperStyles = null;
    const $4e12c5ad2d7cfc88$var$iconWrapperStylesOld = null;
    const $4e12c5ad2d7cfc88$var$iconInvertedColorStyles = null;
    const $4e12c5ad2d7cfc88$var$opacityStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        opacity: 0.8
    });
});
parcelRegister("jOyH3", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $e6cd993777d46e1b$var$_react = $e6cd993777d46e1b$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $e6cd993777d46e1b$var$_link = $e6cd993777d46e1b$var$_interopRequireDefault((parcelRequire("1f9bV")));
    var $e6cd993777d46e1b$var$_link2 = $e6cd993777d46e1b$var$_interopRequireDefault((parcelRequire("458iJ")));
    function $e6cd993777d46e1b$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $e6cd993777d46e1b$var$LinkIcon = (props)=>$e6cd993777d46e1b$var$_react.default.createElement($e6cd993777d46e1b$var$_link.default, Object.assign({
            LEGACY_fallbackIcon: $e6cd993777d46e1b$var$_link2.default
        }, props));
    $e6cd993777d46e1b$var$LinkIcon.Name = 'LinkIconMigration';
    var $e6cd993777d46e1b$var$_default = module.exports.default = $e6cd993777d46e1b$var$LinkIcon;
});
parcelRegister("1f9bV", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $0e7e525cdad15340$var$_react = $0e7e525cdad15340$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $0e7e525cdad15340$var$_UNSAFE_baseNew = $0e7e525cdad15340$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $0e7e525cdad15340$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $0e7e525cdad15340$var$LinkIcon = (props)=>$0e7e525cdad15340$var$_react.default.createElement($0e7e525cdad15340$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m5.25 10.75 5.5-5.5M5 6.5 2.75 8.75a3.182 3.182 0 0 0 4.5 4.5L9.5 11m-3-6 2.25-2.25a3.182 3.182 0 0 1 4.5 4.5L11 9.5"/>`
        }, props));
    $0e7e525cdad15340$var$LinkIcon.displayName = 'LinkIcon';
    var $0e7e525cdad15340$var$_default = module.exports.default = $0e7e525cdad15340$var$LinkIcon;
});
parcelRegister("458iJ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $2f8e117d74b4de46$var$_react = $2f8e117d74b4de46$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $2f8e117d74b4de46$var$_link = $2f8e117d74b4de46$var$_interopRequireDefault((parcelRequire("1f9bV")));
    function $2f8e117d74b4de46$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $2f8e117d74b4de46$var$LinkIcon = (props)=>$2f8e117d74b4de46$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m12.856 5.457-.937.92a1 1 0 0 0 0 1.437 1.047 1.047 0 0 0 1.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 0 1 .203 3.81l-2.903 2.852a2.646 2.646 0 0 1-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 0 0-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47"/><path d="m11.144 19.543.937-.92a1 1 0 0 0 0-1.437 1.047 1.047 0 0 0-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 0 1-.203-3.81l2.903-2.852a2.646 2.646 0 0 1 3.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 0 0 .357 6.82c1.893 1.517 4.695 1.226 6.422-.47"/></g></svg>`
        }, props, {
            newIcon: $2f8e117d74b4de46$var$_link.default
        }));
    $2f8e117d74b4de46$var$LinkIcon.displayName = 'LinkIcon';
    var $2f8e117d74b4de46$var$_default = module.exports.default = $2f8e117d74b4de46$var$LinkIcon;
});
parcelRegister("c5xba", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$03513e326c062ac2$export$2e2bcd8739ae039);
    var $7VHMR;
    var $03513e326c062ac2$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        viewDetail: {
            "id": "roadmap.timeline-table-kit.chart-item-content.date-content.bar.bar-content.bar-icon.view-detail",
            "defaultMessage": "View dependency details"
        }
    });
});
parcelRegister("20BUF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$153205ef5963d972$export$2e2bcd8739ae039);
    var $bC2fB;
    var $geIoM;
    var $1VLi2;
    var $1cn7Z;
    const $153205ef5963d972$var$onCreateDependency = (from, to, analyticEvent)=>(0, (0, parcelRequire("1VLi2")).createDependency)({
            dependency: to,
            dependee: from
        }, analyticEvent);
    var $153205ef5963d972$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((state, { id: id })=>{
        const chartData = (0, (0, parcelRequire("1cn7Z")).getChartDataHash)(state)[id];
        return {
            color: chartData.color
        };
    }, {
        onCreateDependency: $153205ef5963d972$var$onCreateDependency
    })((0, (0, parcelRequire("geIoM")).RoadmapDependencyHandlers));
});
parcelRegister("geIoM", function(module, exports) {
    $parcel$export(module.exports, "RoadmapDependencyHandlers", ()=>$e41434601f8ce556$export$14c359ef0e13a4a6);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $2KlaV;
    var $4tYfO;
    var $2XdbK;
    var $c9DTf;
    var $ifO57;
    const $e41434601f8ce556$var$containerStyles = null;
    const $e41434601f8ce556$var$suffixElementStyles = null;
    const $e41434601f8ce556$export$14c359ef0e13a4a6 = ({ id: id, color: color, leftPosition: leftPosition, rightPosition: rightPosition, isHovered: isHovered, placeholder: placeholder, isColorInverted: isColorInverted, onCreateDependency: onCreateDependency, getBarBoundingClientRect: getBarBoundingClientRect, onBarMouseLeave: onBarMouseLeave })=>{
        const [{ isDraggedOver: isDraggedOver }, makeDroppable, cleanupDroppable] = (0, (0, parcelRequire("ifO57")).useDependenciesDrop)(id, onCreateDependency);
        const [currentDragHandle, setCurrentDragHandle] = (0, $5uXOq.useState)(undefined);
        const isDragging = currentDragHandle !== undefined;
        const theme = (0, (0, parcelRequire("2XdbK")).dependencyThemes)?.[color];
        const onDragStart = (0, $5uXOq.useCallback)((type)=>{
            setCurrentDragHandle(type);
            onBarMouseLeave();
        }, [
            onBarMouseLeave
        ]);
        const onDragEnd = (0, $5uXOq.useCallback)(()=>{
            setCurrentDragHandle(undefined);
        }, []);
        (0, $5uXOq.useEffect)(()=>()=>{
                cleanupDroppable();
            }, [
            cleanupDroppable
        ]);
        const renderDragHandle = (type)=>{
            const isHandleInteractive = isHovered || currentDragHandle === type;
            if (!isHandleInteractive) return null;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c9DTf")).default), {
                id: id,
                type: type,
                theme: theme,
                ...(0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-post-project-a11y-fix') ? {
                    isColorInverted: isColorInverted
                } : {},
                leftPosition: leftPosition,
                rightPosition: rightPosition,
                onDrop: onCreateDependency,
                onDragEnd: onDragEnd,
                onDragStart: onDragStart,
                getBarBoundingClientRect: getBarBoundingClientRect
            });
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                borderRadius: (0, (0, parcelRequire("4tYfO")).generateBarBorderRadius)(placeholder)
            },
            "data-testid": `roadmap.timeline-table-kit.ui.chart-item-content.date-content.bar.dependency-drop-target-${id}`,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _154iidpf _1ltvidpf _1xi2idpf _94n5idpf _lcxvglyw _1pbyqfx8",
                (0, $708c0d50a54aba38$export$c330e9be73819573)
            ]),
            ref: makeDroppable
        }, renderDragHandle((0, (0, parcelRequire("2KlaV")).TOP)), renderDragHandle((0, (0, parcelRequire("2KlaV")).BOTTOM)), (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            style: {
                borderRadius: (0, (0, parcelRequire("4tYfO")).generateBarBorderRadius)(placeholder),
                boxShadow: `inset 0 0 0 2px ${theme?.border}`,
                opacity: isDragging || isDraggedOver ? 1 : 0
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1sb2b3bt _kqswstnw _1bsb1osq _4t3i1osq _v5641w7c"
            ])
        }));
    };
});
const $708c0d50a54aba38$export$48a2b55760ce2355 = 'dependency-drag-id';
const $708c0d50a54aba38$export$c330e9be73819573 = 'dependencies-drop-target';
const $708c0d50a54aba38$export$920d6feba87a57ed = 'INCOMING';
const $708c0d50a54aba38$export$2c998d8d93f14e97 = 'OUTGOING';
parcelRegister("2XdbK", function(module, exports) {
    $parcel$export(module.exports, "dependencyThemes", ()=>$de083d5b3ad6e702$export$895cd5f608903fe5);
    var $iHPnC;
    const $de083d5b3ad6e702$export$895cd5f608903fe5 = (0, (0, parcelRequire("iHPnC")).transformColorToTheme)((cs)=>({
            icon: cs.primary,
            line: cs.line,
            border: cs.border,
            handle: {
                shadow: cs.primary,
                background: cs.primary
            }
        }));
});
parcelRegister("c9DTf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a90190be4f2816b8$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $lFKmC = parcelRequire("lFKmC");
    var $34ck9 = parcelRequire("34ck9");
    var $4R6GH;
    var $1XJ20;
    var $a7FTH;
    var $3ruU1;
    var $kyahI;
    var $dCm1o;
    var $2KlaV;
    var $bNS7k;
    var $dUhbI;
    var $cNBuF;
    const $a90190be4f2816b8$var$DependenciesDragHandles = ({ theme: theme, id: id, type: type, leftPosition: leftPosition, rightPosition: rightPosition, isColorInverted: isColorInverted, getBarBoundingClientRect: getBarBoundingClientRect, onDrop: onDrop, onDragStart: onDragStart, onDragEnd: onDragEnd })=>{
        const [handlePosition, setHandlePosition] = (0, $5uXOq.useState)(undefined);
        const { custom: custom } = (0, (0, parcelRequire("3ruU1")).useSideEffectMarshal)();
        const { listenToViewportScroll: listenToViewportScroll, stopListeningToViewportScroll: stopListeningToViewportScroll } = (0, (0, parcelRequire("kyahI")).useViewport)();
        const [{ isDragging: isDragging }, makeDraggable, cleanupDraggable] = (0, (0, parcelRequire("cNBuF")).useDependenciesDrag)({
            id: id,
            type: type,
            leftPosition: leftPosition,
            rightPosition: rightPosition,
            getBarBoundingClientRect: getBarBoundingClientRect,
            onDrop: onDrop
        });
        const wasDragging = (0, (0, parcelRequire("1XJ20")).usePreviousWithInitial)(isDragging);
        const onUpdateBarRectPosition = (0, $5uXOq.useCallback)(()=>{
            const barClientRect = getBarBoundingClientRect();
            if (barClientRect) {
                const fixedHandlePosition = (0, (0, parcelRequire("dUhbI")).getFixedHandlePosition)(type, barClientRect);
                setHandlePosition(fixedHandlePosition);
            }
        }, [
            type,
            getBarBoundingClientRect
        ]);
        const onScrollEnd = (0, $5uXOq.useCallback)((0, ($parcel$interopDefault($lFKmC)))(()=>{
            onUpdateBarRectPosition();
        }, 100), []);
        const onScroll = (0, $5uXOq.useCallback)((0, ($parcel$interopDefault($34ck9)))(()=>{
            setHandlePosition(undefined);
            onScrollEnd();
        }, 100), []);
        (0, $5uXOq.useEffect)(()=>{
            listenToViewportScroll(onScroll);
            return ()=>{
                stopListeningToViewportScroll(onScroll);
                cleanupDraggable();
            };
        }, [
            onScroll,
            cleanupDraggable,
            listenToViewportScroll,
            stopListeningToViewportScroll
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!wasDragging && isDragging) {
                onDragStart(type);
                custom.onDependencyDragStart();
            } else if (wasDragging && !isDragging) {
                onDragEnd();
                custom.onDependencyDragEnd();
            }
        }, [
            type,
            isDragging,
            wasDragging,
            onDragEnd,
            onDragStart,
            custom
        ]);
        (0, $5uXOq.useEffect)(()=>{
            onUpdateBarRectPosition();
        }, [
            onUpdateBarRectPosition
        ]);
        if (!handlePosition) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a7FTH")).default), null, (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('visual-refresh_drop_1') ? (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                visibility: isDragging ? 'hidden' : 'visible',
                left: handlePosition.left,
                top: handlePosition.top
            },
            "data-testid": "roadmap.timeline-table-kit.ui.chart-item-content.date-content.bar.bar-content.dependency-handler.handle",
            ref: makeDraggable,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqsw1n9t _1e0c1txw _2lx21bp4 _1bsb1ejb _4t3i1ejb _1bah1h6o _2rko1ssb _lcxv1rj4 _t9ec1ooe _zdyikb7n _f1zwidpf",
                type === (0, (0, parcelRequire("2KlaV")).TOP) && "_18u0t94y _4cvr1y6m",
                type !== (0, (0, parcelRequire("2KlaV")).TOP) && "_18u01n1a _4cvresu3"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-component-selector": "timeline-data-dot",
            style: {
                backgroundColor: theme.handle.background
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1y44 _4t3i1y44 _2rko1ssb _80omtlke _tip8kb7n _v564m7ou",
                type === (0, (0, parcelRequire("2KlaV")).TOP) && "",
                type === (0, (0, parcelRequire("2KlaV")).TOP) && "_y44v1plm _19pk19bv _2hwxidpf _otyryh40 _18u0idpf",
                type !== (0, (0, parcelRequire("2KlaV")).TOP) && "",
                type !== (0, (0, parcelRequire("2KlaV")).TOP) && "_y44v18br _19pkyh40 _2hwxidpf _otyr19bv _18u0idpf"
            ])
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-component-selector": "timeline-drag-handler",
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _154iv77o _1ltvv77o _80omtlke _tzy4idpf _v564m7ou",
                type === (0, (0, parcelRequire("2KlaV")).TOP) && "_18u014id",
                type !== (0, (0, parcelRequire("2KlaV")).TOP) && "_18u019bv"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bNS7k")).DependencyDragHandler), {
            color: theme.icon,
            ...(0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-post-project-a11y-fix') ? {
                isColorInverted: isColorInverted
            } : {}
        }))) : (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                visibility: isDragging ? 'hidden' : 'visible',
                left: handlePosition.left,
                top: handlePosition.top
            },
            "data-testid": "roadmap.timeline-table-kit.ui.chart-item-content.date-content.bar.bar-content.dependency-handler.handle",
            ref: makeDraggable,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqsw1n9t _1e0c1txw _2lx21bp4 _1bsb1ejb _4t3i1ejb _4cvr1h6o _1bah1h6o _2rko1ssb _lcxv1rj4 _t9ec1ooe _zdyikb7n _f1zwidpf"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-component-selector": "timeline-data-dot",
            style: {
                backgroundColor: theme.handle.background
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsbu2gc _4t3iu2gc _2rko1ssb _80omtlke _tip8kb7n _v564m7ou",
                type === (0, (0, parcelRequire("2KlaV")).TOP) && "",
                type === (0, (0, parcelRequire("2KlaV")).TOP) && "_y44vmujb",
                type !== (0, (0, parcelRequire("2KlaV")).TOP) && "",
                type !== (0, (0, parcelRequire("2KlaV")).TOP) && "_y44v1rg8"
            ])
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-component-selector": "timeline-drag-handler",
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _154iv77o _1ltvv77o _80omtlke _tzy4idpf _v564m7ou"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bNS7k")).DependencyDragHandler), {
            color: theme.icon,
            ...(0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-post-project-a11y-fix') ? {
                isColorInverted: isColorInverted
            } : {}
        }))));
    };
    var $a90190be4f2816b8$export$2e2bcd8739ae039 = $a90190be4f2816b8$var$DependenciesDragHandles;
    const $a90190be4f2816b8$var$slideInTop = null;
    const $a90190be4f2816b8$var$slideInBottom = null;
    const $a90190be4f2816b8$var$SLIDE_OFFSET_OLD = 15;
    const $a90190be4f2816b8$var$slideInTopOld = null;
    const $a90190be4f2816b8$var$slideInBottomOld = null;
    const $a90190be4f2816b8$var$slideInTopStyles = null;
    const $a90190be4f2816b8$var$slideInBottomStyles = null;
    const $a90190be4f2816b8$var$slideInTopStylesOld = null;
    const $a90190be4f2816b8$var$slideInBottomStylesOld = null;
    const $a90190be4f2816b8$var$dragHandleDotStyles = null;
    const $a90190be4f2816b8$var$dragHandleDotStylesOld = null;
    const $a90190be4f2816b8$var$dragHandleWrapperStyles = null;
    const $a90190be4f2816b8$var$dragHandleTopWrapperStyles = null;
    const $a90190be4f2816b8$var$dragHandleBottomWrapperStyles = null;
    const $a90190be4f2816b8$var$dragHandleContainerStyles = null;
    const $a90190be4f2816b8$var$dragHandleTopContainerStyles = null;
    const $a90190be4f2816b8$var$dragHandleBottomContainerStyles = null;
    const $a90190be4f2816b8$var$dragHandleContainerStylesOld = null;
});
parcelRegister("a7FTH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ce15445016e20ca9$export$2e2bcd8739ae039);
    var $7nsd3 = parcelRequire("7nsd3");
    var $c7Iuw;
    const $ce15445016e20ca9$var$Portal = ({ children: children })=>{
        const { portalContainerElement: portalContainerElement } = (0, (0, parcelRequire("c7Iuw")).usePortalScope)();
        if (portalContainerElement) return (0, $7nsd3.createPortal)(children, portalContainerElement);
        return null;
    };
    var $ce15445016e20ca9$export$2e2bcd8739ae039 = $ce15445016e20ca9$var$Portal;
});
parcelRegister("bNS7k", function(module, exports) {
    $parcel$export(module.exports, "DependencyDragHandler", ()=>$e3bd8fe480a533e4$export$df820fc059ab8cf4);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $jOyH3;
    var $4R6GH;
    var $dCm1o;
    const $e3bd8fe480a533e4$var$iconWrapperStyles = null;
    const $e3bd8fe480a533e4$var$iconWrapperExtraPadding = null;
    const $e3bd8fe480a533e4$var$iconWrapperExtraBorderRadius = null;
    const $e3bd8fe480a533e4$export$df820fc059ab8cf4 = ({ color: color, isColorInverted: isColorInverted })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                backgroundColor: color
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bsbgktf _4t3igktf _2rko1ssb _4cvr1h6o _1bah1h6o _16qsanr3",
                (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && !(0, (0, parcelRequire("4R6GH")).fg)('visual-refresh_drop_1') && "_1yt4v77o",
                (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('visual-refresh_drop_1') && "_2rko1l7b"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("jOyH3"))))), {
            LEGACY_size: "small",
            label: "",
            color: isColorInverted && (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-post-project-a11y-fix') ? "var(--ds-icon, #44546F)" : `var(--ds-icon-inverse, ${0, $829f609a65d26a98$export$29a4f05edc054374})`
        }));
});
parcelRegister("dUhbI", function(module, exports) {
    $parcel$export(module.exports, "getFixedHandlePosition", ()=>$522af83740958082$export$cdacaba1feb143c8);
    $parcel$export(module.exports, "getRelativeHandlePosition", ()=>$522af83740958082$export$eb8d2bc119196ff0);
    var $2KlaV;
    const $522af83740958082$var$FIXED_OFFSET_X = 15;
    const $522af83740958082$var$FIXED_OFFSET_Y = 8;
    const $522af83740958082$export$cdacaba1feb143c8 = (type, barClientRect)=>{
        const { top: top, left: left, width: width, height: height } = barClientRect;
        if (type === (0, (0, parcelRequire("2KlaV")).TOP)) return {
            top: top - $522af83740958082$var$FIXED_OFFSET_Y,
            left: left + $522af83740958082$var$FIXED_OFFSET_X
        };
        return {
            top: top + height + $522af83740958082$var$FIXED_OFFSET_Y,
            left: left + width - $522af83740958082$var$FIXED_OFFSET_X
        };
    };
    const $522af83740958082$export$eb8d2bc119196ff0 = (type, timelineWidth, barLeftPosition, barRightPosition)=>type === (0, (0, parcelRequire("2KlaV")).TOP) ? barLeftPosition : timelineWidth - barRightPosition;
});
parcelRegister("cNBuF", function(module, exports) {
    $parcel$export(module.exports, "useDependenciesDrag", ()=>$9cde0a6c943a8eca$export$8d873462c415f4c3);
    var $5uXOq = parcelRequire("5uXOq");
    var $4hDdm = parcelRequire("4hDdm");
    var $7gWdR = parcelRequire("7gWdR");
    var $biT18;
    var $kyahI;
    var $dUhbI;
    const $9cde0a6c943a8eca$export$8d873462c415f4c3 = ({ id: id, type: type, getBarBoundingClientRect: getBarBoundingClientRect, leftPosition: leftPosition, rightPosition: rightPosition })=>{
        const cleanupDragAndDrop = (0, $5uXOq.useRef)(null);
        const [dragState, setDragState] = (0, $5uXOq.useState)({
            isDragging: false
        });
        const [{ timelineWidth: timelineWidth }] = (0, (0, parcelRequire("biT18")).useTimelineState)();
        const { requestViewportBoundingClient: requestViewportBoundingClient, requestViewportScrollBounding: requestViewportScrollBounding, setViewportScroll: setViewportScroll } = (0, (0, parcelRequire("kyahI")).useViewport)();
        const makeDraggable = (0, $5uXOq.useCallback)((dragElement)=>{
            const el = dragElement;
            if (el === null) return;
            cleanupDragAndDrop.current = (0, $4hDdm.combine)((0, $7gWdR.draggable)({
                element: el,
                getInitialData: ()=>({
                        type: (0, $708c0d50a54aba38$export$48a2b55760ce2355),
                        id: id,
                        handleType: type,
                        barRect: getBarBoundingClientRect(),
                        leftPosition: (0, (0, parcelRequire("dUhbI")).getRelativeHandlePosition)(type, timelineWidth, leftPosition, rightPosition),
                        viewportBoundingRect: requestViewportBoundingClient(),
                        initialScrollBoundingRect: requestViewportScrollBounding(),
                        requestViewportScrollBounding: requestViewportScrollBounding,
                        setViewportScroll: setViewportScroll
                    }),
                onGenerateDragPreview: ({ source: source })=>{
                    const { element: draggedElement } = source;
                    draggedElement.style.opacity = '0';
                },
                onDragStart: ({ source: source })=>{
                    const { element: draggedElement } = source;
                    draggedElement.style.opacity = '1';
                    setDragState({
                        isDragging: true
                    });
                },
                onDrop: ()=>{
                    setDragState({
                        isDragging: false
                    });
                }
            }));
        }, [
            id,
            type,
            leftPosition,
            rightPosition,
            timelineWidth,
            setViewportScroll,
            requestViewportScrollBounding,
            requestViewportBoundingClient,
            getBarBoundingClientRect
        ]);
        const cleanupDraggable = (0, $5uXOq.useCallback)(()=>{
            cleanupDragAndDrop.current?.();
        }, []);
        return [
            dragState,
            makeDraggable,
            cleanupDraggable
        ];
    };
});
parcelRegister("ifO57", function(module, exports) {
    $parcel$export(module.exports, "useDependenciesDrop", ()=>$759cf80b74020be8$export$52e673c9910da4de);
    var $5uXOq = parcelRequire("5uXOq");
    var $4hDdm = parcelRequire("4hDdm");
    var $7gWdR = parcelRequire("7gWdR");
    var $8zOmE;
    var $2NMNM;
    var $2KlaV;
    const $759cf80b74020be8$export$52e673c9910da4de = (id, onDrop)=>{
        const cleanupDropTarget = (0, $5uXOq.useRef)(null);
        const [dragState, setDragState] = (0, $5uXOq.useState)({
            isDraggedOver: false
        });
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const makeDroppable = (0, $5uXOq.useCallback)((dropTargetElement)=>{
            const el = dropTargetElement;
            if (el === null) return;
            cleanupDropTarget.current = (0, $4hDdm.combine)((0, $7gWdR.dropTargetForElements)({
                element: el,
                canDrop: ({ source: source })=>{
                    const item = source.data;
                    return item.type === (0, $708c0d50a54aba38$export$48a2b55760ce2355) && item.id !== id;
                },
                onDragEnter: ({ source: source })=>{
                    const item = source.data;
                    if (item.type === (0, $708c0d50a54aba38$export$48a2b55760ce2355) && item.id !== id) setDragState({
                        isDraggedOver: true
                    });
                },
                onDragLeave: ({ source: source })=>{
                    const item = source.data;
                    if (item.type === (0, $708c0d50a54aba38$export$48a2b55760ce2355) && item.id !== id) setDragState({
                        isDraggedOver: false
                    });
                },
                onDrop: ({ source: source })=>{
                    const item = source.data;
                    const analyticsEvent = createAnalyticsEvent({
                        action: 'dropped',
                        actionSubject: 'dropArea'
                    });
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'dependencyDropArea');
                    const from = item.handleType === (0, (0, parcelRequire("2KlaV")).TOP) ? item.id : id;
                    const to = item.handleType === (0, (0, parcelRequire("2KlaV")).TOP) ? id : item.id;
                    onDrop(from, to, analyticsEvent);
                    setDragState({
                        isDraggedOver: false
                    });
                }
            }));
        }, [
            id,
            onDrop,
            createAnalyticsEvent
        ]);
        const cleanupDroppable = (0, $5uXOq.useCallback)(()=>{
            cleanupDropTarget.current?.();
        }, []);
        return [
            dragState,
            makeDroppable,
            cleanupDroppable
        ];
    };
});
parcelRegister("80iMb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$44a17912c2194ebf$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9yxkx;
    var $eKt4x;
    var $cRysC;
    const $44a17912c2194ebf$var$ChartItemContent = (props)=>{
        const { onUpdate: onUpdate, warnings: warnings } = props;
        const hasOverdueReleaseDate = warnings ? warnings.some((warning)=>warning.id === (0, (0, parcelRequire("cRysC")).default)[`${0, (0, parcelRequire("eKt4x")).END_DATE_LATER_RELEASE_DATE_MESSAGE_ID}`].id) : undefined;
        const onUpdateChartItem = (0, $5uXOq.useCallback)((id, { dates: dates, meta: meta, intervalId: intervalId }, event)=>{
            onUpdate(id, {
                dates: dates,
                meta: meta,
                intervalId: intervalId
            }, event, hasOverdueReleaseDate);
        }, [
            onUpdate,
            hasOverdueReleaseDate
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9yxkx")).RoadmapChartItemContent), {
            ...props,
            onUpdate: onUpdateChartItem
        });
    };
    $44a17912c2194ebf$var$ChartItemContent.whyDidYouRender = true;
    var $44a17912c2194ebf$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($44a17912c2194ebf$var$ChartItemContent);
});
parcelRegister("9yxkx", function(module, exports) {
    $parcel$export(module.exports, "RoadmapChartItemContent", ()=>$b80a259a3f2cb3dd$export$3b537bb5a0afaee4);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $esmwW;
    var $2KlaV;
    var $bbHVB;
    var $4lsbG;
    var $8Pp9Z;
    const $b80a259a3f2cb3dd$export$3b537bb5a0afaee4 = ({ id: id, startDate: startDate, dueDate: dueDate, color: color, level: level, startDateType: startDateType, dueDateType: dueDateType, placeholder: placeholder, DndLongTaskMetric: DndLongTaskMetric, warnings: warnings, intervals: intervals, isHovered: isHovered, isReadOnly: isReadOnly, onLeftClick: onLeftClick, onRightClick: onRightClick, onUpdate: onUpdate, renderBarContent: renderBarContent })=>{
        if (startDate !== undefined && dueDate !== undefined) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, !isReadOnly && intervals.length > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4lsbG")).IntervalDropZones), {
            id: id,
            intervals: intervals
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bbHVB")).DateContent), {
            id: id,
            color: color,
            level: level,
            startDate: startDate,
            dueDate: dueDate,
            startDateType: startDateType,
            dueDateType: dueDateType,
            warnings: warnings,
            placeholder: placeholder,
            isHovered: isHovered,
            isReadOnly: isReadOnly,
            onLeftClick: onLeftClick,
            onRightClick: onRightClick,
            onUpdate: onUpdate,
            renderBarContent: renderBarContent,
            DndLongTaskMetric: DndLongTaskMetric
        }));
        return !isReadOnly ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Pp9Z")).NoDateContent), {
            id: id,
            level: level,
            color: color,
            startDateType: startDateType,
            dueDateType: dueDateType,
            isHovered: isHovered,
            onUpdate: onUpdate
        }, intervals.length > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4lsbG")).IntervalDropZones), {
            id: id,
            intervals: intervals,
            onClick: onUpdate
        }))) : null;
    };
    $b80a259a3f2cb3dd$export$3b537bb5a0afaee4.defaultProps = {
        startDateType: (0, (0, parcelRequire("esmwW")).EXPLICIT),
        dueDateType: (0, (0, parcelRequire("esmwW")).EXPLICIT),
        DndLongTaskMetric: ()=>null,
        warnings: [],
        intervals: [],
        isReadOnly: false,
        onLeftClick: (0, ($parcel$interopDefault($8Rkzz))),
        renderBarContent: (0, (0, parcelRequire("2KlaV")).DEFAULT_RENDERER)
    };
});
parcelRegister("bbHVB", function(module, exports) {
    $parcel$export(module.exports, "DateContent", ()=>$5d0b3ad119245818$export$cede4067c9cec7c9);
    var $5uXOq = parcelRequire("5uXOq");
    var $biT18;
    var $esmwW;
    var $6gIAo;
    var $apjDv;
    var $hjVf3;
    var $Aa6uS;
    const $5d0b3ad119245818$export$cede4067c9cec7c9 = ({ id: id, color: color, level: level, startDate: startDate, dueDate: dueDate, startDateType: startDateType, dueDateType: dueDateType, warnings: warnings, placeholder: placeholder, isHovered: isHovered, isReadOnly: isReadOnly, DndLongTaskMetric: DndLongTaskMetric, renderBarContent: renderBarContent, onUpdate: onUpdate, onLeftClick: onLeftClick, onRightClick: onRightClick })=>{
        const [{ timelineDuration: timelineDuration, timelineWidth: timelineWidth }] = (0, (0, parcelRequire("biT18")).useTimelineState)();
        const barLeftPosition = (0, (0, parcelRequire("apjDv")).getBarLeftPosition)(startDate, timelineDuration, timelineWidth);
        const barRightPosition = (0, (0, parcelRequire("apjDv")).getBarRightPosition)(dueDate, timelineDuration, timelineWidth);
        const isBarVisible = (0, (0, parcelRequire("apjDv")).getIsBarVisible)(barLeftPosition, barRightPosition, timelineWidth);
        if (!isBarVisible) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hjVf3")).RoadmapBar), {
            id: id,
            left: barLeftPosition,
            right: barRightPosition,
            color: color,
            level: level,
            startDateType: startDateType,
            dueDateType: dueDateType,
            warnings: warnings,
            placeholder: placeholder,
            isReadOnly: isReadOnly,
            onUpdate: onUpdate,
            onLeftClick: onLeftClick,
            onRightClick: onRightClick,
            renderBarContent: renderBarContent,
            DndLongTaskMetric: DndLongTaskMetric
        }), isHovered && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("Aa6uS")).RoadmapNavigateButton), {
            itemMinLeftPosition: barLeftPosition,
            itemMaxRightPosition: barRightPosition,
            label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6gIAo")).FormattedDate), {
                startDate: startDate,
                startDateType: startDateType,
                dueDate: dueDate,
                dueDateType: dueDateType,
                placeholder: placeholder,
                isDurationVisible: !placeholder
            })
        }));
    };
    $5d0b3ad119245818$export$cede4067c9cec7c9.defaultProps = {
        startDateType: (0, (0, parcelRequire("esmwW")).EXPLICIT),
        dueDateType: (0, (0, parcelRequire("esmwW")).EXPLICIT)
    };
});
parcelRegister("hjVf3", function(module, exports) {
    $parcel$export(module.exports, "RoadmapBar", ()=>$6a9289d21e612fae$export$9335a0f7fb12b232);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $jldZL;
    var $fNuuD;
    var $4R6GH;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $WPwAA;
    var $biT18;
    var $1YcpO;
    var $kCVTH;
    var $g11uZ;
    var $15ADj;
    var $esmwW;
    var $2KlaV;
    var $3yzcQ;
    var $d8OAB;
    var $apjDv;
    var $9KS0U;
    var $gXfPZ;
    var $aZ1r7;
    var $a3omN;
    var $8QqqZ;
    var $inYGI;
    const $6a9289d21e612fae$var$StyledBar = ({ left: left, right: right, placeholder: placeholder, theme: theme, level: level, shouldAnimate: shouldAnimate, isSelectEnabled: isSelectEnabled, innerRef: innerRef, containerRef: containerRef, children: children, startDate: startDate, dueDate: dueDate, color: color, 'data-testid': testId, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onContextMenu: onContextMenu, ...rest })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            ref: containerRef,
            testId: `${testId}-container`,
            style: {
                ...(0, (0, parcelRequire("3yzcQ")).getBaseBarStyles)({
                    level: level,
                    theme: theme,
                    placeholder: placeholder
                }),
                left: `${left}px`,
                right: `${right}px`,
                cursor: isSelectEnabled ? 'pointer' : 'default',
                transition: shouldAnimate ? 'left 0.1s ease, right 0.1s ease' : 'none'
            },
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            ref: innerRef,
            xcss: $6a9289d21e612fae$var$focusedBarStyles,
            "aria-label": formatMessage((0, (0, parcelRequire("a3omN")).default).gridCellAriaLabel, {
                startDate: (0, (0, parcelRequire("g11uZ")).getDateFromTimestamp)(startDate),
                dueDate: (0, (0, parcelRequire("g11uZ")).getDateFromTimestamp)(dueDate),
                color: color
            }),
            onContextMenu: onContextMenu,
            testId: testId,
            ...rest
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $6a9289d21e612fae$var$barContentOverlayStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $6a9289d21e612fae$var$barContentWrapperStyles
        }, children)));
    };
    const $6a9289d21e612fae$var$DraggableBar = (0, (0, parcelRequire("fNuuD")).withDragObserver)($6a9289d21e612fae$var$StyledBar);
    const $6a9289d21e612fae$export$9335a0f7fb12b232 = ({ id: id, color: color, level: level, left: initialLeftPosition, right: initialRightPosition, startDateType: startDateType, dueDateType: dueDateType, warnings: warnings, placeholder: placeholder, isReadOnly: isReadOnly, DndLongTaskMetric: DndLongTaskMetric, onUpdate: onUpdate, onLeftClick: onLeftClick, onRightClick: onRightClick, renderBarContent: renderBarContent })=>{
        const [{ isSelectEnabled: isSelectEnabled }] = (0, (0, parcelRequire("WPwAA")).useEnablements)();
        let handleClick;
        if ((0, (0, parcelRequire("4R6GH")).fg)('project_timeline_multi-select_and_checkboxes')) ({ handleClick: handleClick } = (0, (0, parcelRequire("kCVTH")).useItemSelect)(id));
        const [{ timelineDuration: timelineDuration, timelineWidth: timelineWidth }] = (0, (0, parcelRequire("biT18")).useTimelineState)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const barContainerRef = (0, $5uXOq.useRef)(null);
        const barButtonRef = (0, $5uXOq.useRef)(null);
        const [{ isActive: isActive, dragType: dragType, ...interactionState }, { onDragStart: onDragStart, onDrag: onDrag, onDragEnd: onDragEnd, onLingerStart: onLingerStart, onLingerEnd: onLingerEnd }] = (0, (0, parcelRequire("gXfPZ")).useChartItemInteractions)(id);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const isHovered = isActive && !dragType;
        const isDragging = dragType !== undefined;
        const isDragExplicit = isDragging && isActive;
        const isResizeEnabled = startDateType !== (0, (0, parcelRequire("esmwW")).INTERVAL) && dueDateType !== (0, (0, parcelRequire("esmwW")).INTERVAL);
        const leftPosition = interactionState.leftPosition ?? initialLeftPosition;
        const rightPosition = interactionState.rightPosition ?? initialRightPosition;
        const { minimumLeft: minimumLeft, minimumRight: minimumRight } = (0, (0, parcelRequire("8QqqZ")).getMinimumPositions)(leftPosition, rightPosition, timelineWidth);
        const isMinimumBar = minimumLeft !== undefined && minimumRight !== undefined;
        const newLeft = (isDragExplicit || isHovered) && minimumLeft !== undefined ? minimumLeft : leftPosition;
        const newRight = (isDragExplicit || isHovered) && minimumRight !== undefined ? minimumRight : rightPosition;
        const newPlaceholder = isDragExplicit ? (0, (0, parcelRequire("d8OAB")).getPlaceholderWhileDragging)(dragType, placeholder) : placeholder;
        const prevStartDate = (0, (0, parcelRequire("apjDv")).getStartDate)(initialLeftPosition, timelineDuration, timelineWidth);
        const prevDueDate = (0, (0, parcelRequire("apjDv")).getDueDate)(initialRightPosition, timelineDuration, timelineWidth);
        const startDate = (0, (0, parcelRequire("apjDv")).getStartDate)(leftPosition, timelineDuration, timelineWidth);
        const dueDate = (0, (0, parcelRequire("apjDv")).getDueDate)(rightPosition, timelineDuration, timelineWidth);
        const theme = (0, (0, parcelRequire("9KS0U")).getBarTheme)(color);
        const getBarBoundingClientRect = (0, $5uXOq.useCallback)(()=>barContainerRef.current?.getBoundingClientRect(), []);
        const onResizeStartLeft = ()=>{
            onDragStart((0, (0, parcelRequire("2KlaV")).LEFT));
        };
        const onResizeStartRight = ()=>{
            onDragStart((0, (0, parcelRequire("2KlaV")).RIGHT));
        };
        const onBarDragStart = ()=>{
            onDragStart((0, (0, parcelRequire("2KlaV")).LEFT_AND_RIGHT));
        };
        const onBarDragEnd = ()=>{
            const updatedDates = (0, (0, parcelRequire("8QqqZ")).getUpdatedDates)(startDate, dueDate, dragType);
            const analyticsEvent = createAnalyticsEvent({
                action: 'dragEnded',
                actionSubject: 'bar'
            });
            const attributes = {
                type: (0, (0, parcelRequire("8QqqZ")).getAnalyticsType)(updatedDates),
                level: level,
                isStartDateInferred: startDateType === (0, (0, parcelRequire("esmwW")).ROLLUP) || startDateType === (0, (0, parcelRequire("esmwW")).INTERVAL),
                isDueDateInferred: dueDateType === (0, (0, parcelRequire("esmwW")).ROLLUP) || dueDateType === (0, (0, parcelRequire("esmwW")).INTERVAL)
            };
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'issueBar', attributes);
            onDragEnd();
            onUpdate(id, {
                dates: updatedDates,
                meta: {
                    isDragged: true
                }
            }, analyticsEvent);
        };
        const onBarRightClick = (event)=>{
            if (onRightClick !== undefined) {
                event.preventDefault();
                const { top: top, height: height } = event.currentTarget.getBoundingClientRect();
                const analyticsEvent = createAnalyticsEvent({
                    action: 'rightClicked',
                    actionSubject: 'bar'
                });
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'issueBar');
                onRightClick(id, {
                    x: event.clientX,
                    y: top + height
                });
            }
        };
        const onBarLeftClickOld = (0, $5uXOq.useCallback)(({ target: target, ctrlKey: ctrlKey, metaKey: metaKey, shiftKey: shiftKey })=>{
            if (target === barButtonRef.current) {
                const withCmd = ctrlKey || metaKey;
                const withShift = shiftKey;
                const analyticsEvent = createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'bar'
                });
                const itemClickMeta = {
                    level: level,
                    withCmd: withCmd,
                    withShift: withShift
                };
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'issueBar', itemClickMeta);
                onLeftClick?.(id, itemClickMeta, analyticsEvent);
            }
        }, [
            createAnalyticsEvent,
            id,
            level,
            onLeftClick
        ]);
        const onBarLeftClickNew = (0, $5uXOq.useCallback)((event)=>{
            const { target: target, metaKey: metaKey, ctrlKey: ctrlKey, shiftKey: shiftKey } = event;
            if (target !== barButtonRef.current) return;
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'bar',
                actionSubjectId: 'issueBar',
                attributes: {
                    level: level,
                    withCmd: ctrlKey || metaKey,
                    withShift: shiftKey
                }
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent);
            (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps-timeline-bento-refocusing') ? handleClick?.(event, analyticsEvent, barButtonRef) : handleClick?.(event, analyticsEvent);
            const itemClickMeta = {
                level: level,
                withCmd: ctrlKey || metaKey,
                withShift: shiftKey
            };
            onLeftClick?.(id, itemClickMeta, analyticsEvent);
        }, [
            createAnalyticsEvent,
            level,
            handleClick,
            onLeftClick,
            id
        ]);
        const onBarLeftClick = (0, (0, parcelRequire("4R6GH")).fg)('project_timeline_multi-select_and_checkboxes') ? onBarLeftClickNew : onBarLeftClickOld;
        const renderDragHandle = (type, hasPlaceholder)=>{
            const shouldRenderHandle = isHovered && dragType === undefined || dragType === type && isDragExplicit;
            return shouldRenderHandle && isResizeEnabled && !isReadOnly ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aZ1r7")).RoadmapDragHandle), {
                id: id,
                type: type,
                theme: theme,
                hasPlaceholder: hasPlaceholder,
                onDragStart: type === (0, (0, parcelRequire("2KlaV")).LEFT) ? onResizeStartLeft : onResizeStartRight,
                onDrag: onDrag,
                onDragEnd: onBarDragEnd
            }) : null;
        };
        const renderGhostBar = ()=>{
            if (!isDragging) return null;
            return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                style: {
                    ...(0, (0, parcelRequire("3yzcQ")).getBaseBarStyles)({
                        level: level,
                        theme: theme,
                        placeholder: placeholder
                    }),
                    left: `${initialLeftPosition}px`,
                    right: `${initialRightPosition}px`,
                    backgroundColor: theme.background,
                    opacity: '0.3'
                }
            });
        };
        const barContentProps = {
            id: id,
            dragType: dragType,
            prevStartDate: prevStartDate,
            prevDueDate: prevDueDate,
            startDate: startDate,
            dueDate: dueDate,
            startDateType: startDateType,
            dueDateType: dueDateType,
            leftPosition: newLeft,
            rightPosition: newRight,
            placeholder: newPlaceholder,
            isReadOnly: isReadOnly,
            isMinimumBar: isMinimumBar,
            ...(0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-post-project-a11y-fix') ? {
                isColorInverted: (0, (0, parcelRequire("8QqqZ")).shouldInvertColor)(color)
            } : {},
            getBarBoundingClientRect: getBarBoundingClientRect,
            onBarMouseLeave: onLingerEnd
        };
        const barContentState = {
            isActive: isActive,
            isHovered: isHovered
        };
        const warningsDescription = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jldZL")).default), {
                id: `roadmap.timeline-table-kit.ui.chart-item-content.date-content.bar.warning-desc-${id}`
            }, warnings.length > 0 && `${formatMessage((0, (0, parcelRequire("a3omN")).default).warningsCount, {
                count: warnings.length
            })} `, warnings.map((errorMessage)=>`${formatMessage(errorMessage)} `));
        const onKeyDown = (0, $5uXOq.useCallback)((e)=>{
            if ((0, (0, parcelRequire("1YcpO")).isEnterOrSpaceKey)(e) && isSelectEnabled) {
                e.preventDefault();
                onBarLeftClick(e);
            }
        }, [
            isSelectEnabled,
            onBarLeftClick
        ]);
        const renderDraggableBar = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($6a9289d21e612fae$var$DraggableBar, {
                "data-testid": `roadmap.timeline-table-kit.ui.chart-item-content.date-content.bar.draggable-bar-${id}`,
                innerRef: barButtonRef,
                left: newLeft,
                right: newRight,
                level: level,
                theme: theme,
                placeholder: newPlaceholder,
                shouldAnimate: isHovered && isMinimumBar && !isDragging,
                isSelectEnabled: isSelectEnabled,
                isDisabled: isReadOnly,
                onMouseEnter: onLingerStart,
                onMouseLeave: onLingerEnd,
                onDrag: onDrag,
                onDragStart: onBarDragStart,
                onDragEnd: onBarDragEnd,
                onContextMenu: !isReadOnly ? onBarRightClick : undefined,
                onClick: isSelectEnabled ? onBarLeftClick : undefined,
                containerRef: barContainerRef,
                onKeyDown: onKeyDown,
                tabIndex: 0,
                startDate: startDate,
                dueDate: dueDate,
                color: color,
                role: "button",
                "aria-describedby": `roadmap.timeline-table-kit.ui.chart-item-content.date-content.bar.warning-desc-${id}`
            }, renderBarContent(barContentProps, barContentState), renderDragHandle((0, (0, parcelRequire("2KlaV")).LEFT), placeholder === (0, (0, parcelRequire("15ADj")).START_DATE_PLACEHOLDER) || placeholder === (0, (0, parcelRequire("15ADj")).START_AND_DUE_DATE_PLACEHOLDER)), renderDragHandle((0, (0, parcelRequire("2KlaV")).RIGHT), placeholder === (0, (0, parcelRequire("15ADj")).DUE_DATE_PLACEHOLDER) || placeholder === (0, (0, parcelRequire("15ADj")).START_AND_DUE_DATE_PLACEHOLDER)));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, renderGhostBar(), renderDraggableBar(), warningsDescription(), !isDragExplicit && !isHovered && warnings.length > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("inYGI")).RoadmapBarWarnings), {
            warnings: warnings,
            right: newRight
        }), (0, ($parcel$interopDefault($5uXOq))).createElement(DndLongTaskMetric, {
            isDragging: isDragging,
            level: level
        }));
    };
    const $6a9289d21e612fae$var$focusedBarStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderRadius: 'border.radius',
        boxSizing: 'border-box',
        width: '100%',
        height: '100%',
        ':focus-visible': {
            outline: `2px solid ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`}`,
            outlineOffset: 'space.025'
        }
    });
    const $6a9289d21e612fae$var$barContentOverlayStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: '0',
        paddingLeft: 'space.075',
        paddingRight: 'space.075',
        position: 'absolute',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        pointerEvents: 'none'
    });
    const $6a9289d21e612fae$var$barContentWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        alignItems: 'center',
        pointerEvents: 'auto'
    });
});
parcelRegister("gXfPZ", function(module, exports) {
    $parcel$export(module.exports, "useChartItemInteractions", ()=>$a0949660cbdabb90$export$7de9fc62a8d2ea96);
    var $5uXOq = parcelRequire("5uXOq");
    var $gPXTo;
    const $a0949660cbdabb90$export$7de9fc62a8d2ea96 = (id)=>{
        const timeoutId = (0, $5uXOq.useRef)(undefined);
        const frameId = (0, $5uXOq.useRef)(undefined);
        const [interactionState, interactionActions] = (0, (0, parcelRequire("gPXTo")).useInteractionData)(id);
        (0, $5uXOq.useEffect)(()=>()=>{
                frameId.current && cancelAnimationFrame(frameId.current);
                clearTimeout(timeoutId.current);
            }, []);
        const onDragStart = (0, $5uXOq.useCallback)((dragType)=>{
            interactionActions.onDragStart(id, dragType);
        }, [
            id,
            interactionActions
        ]);
        const onLingerStart = (0, $5uXOq.useCallback)(()=>{
            interactionActions.onLingerStart(id);
            timeoutId.current = setTimeout(()=>interactionActions.onLinger(), 200);
        }, [
            id,
            interactionActions
        ]);
        const onLingerEnd = (0, $5uXOq.useCallback)(()=>{
            clearTimeout(timeoutId.current);
            interactionActions.onLingerEnd();
        }, [
            interactionActions
        ]);
        const onPreview = (0, $5uXOq.useCallback)((previewX)=>{
            if (!frameId.current) frameId.current = requestAnimationFrame(()=>{
                frameId.current = undefined;
                interactionActions.onPreview(previewX);
            });
        }, [
            interactionActions
        ]);
        return [
            interactionState,
            {
                ...interactionActions,
                onDragStart: onDragStart,
                onLingerStart: onLingerStart,
                onLingerEnd: onLingerEnd,
                onPreview: onPreview
            }
        ];
    };
});
parcelRegister("aZ1r7", function(module, exports) {
    $parcel$export(module.exports, "RoadmapDragHandle", ()=>$69ad6bcb1105aeca$export$fd31a6ac7f6022ac);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $fNuuD;
    var $4R6GH;
    var $dCm1o;
    const $69ad6bcb1105aeca$var$Handle = ({ type: type, hasPlaceholder: hasPlaceholder, theme: theme, children: children, testid: testid })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('visual-refresh_drop_1') ? (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                [type]: 0,
                backgroundColor: !theme.hasContrastSecondaryGradient && hasPlaceholder ? theme.background : theme.handle
            },
            "data-testid": testid,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _154iidpf _94n5idpf _1yt41b66 _1bsb1y44 _2rkoftgi _1y1m1ntv _80om11mm"
            ])
        }, children) : (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                [type]: 0,
                backgroundColor: !theme.hasContrastSecondaryGradient && hasPlaceholder ? theme.background : theme.handle
            },
            "data-testid": testid,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _154iidpf _94n5idpf _1yt41b66 _1bsbi2wt _2rkoftgi _1y1m1ntv _80om11mm"
            ])
        }, children));
    };
    const $69ad6bcb1105aeca$var$DraggableHandle = (0, (0, parcelRequire("fNuuD")).withDragObserver)($69ad6bcb1105aeca$var$Handle, 0.1);
    const $69ad6bcb1105aeca$export$fd31a6ac7f6022ac = ({ id: id, type: type, theme: theme, hasPlaceholder: hasPlaceholder, onDragStart: onDragStart, onDrag: onDrag, onDragEnd: onDragEnd })=>{
        const onDragHandleStart = (0, $5uXOq.useCallback)(()=>{
            onDragStart(type);
        }, [
            type,
            onDragStart
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($69ad6bcb1105aeca$var$DraggableHandle, {
            testid: `roadmap.timeline-table.components.bar.draggable.${type.toLowerCase()}-draggable-handle-${id}`,
            theme: theme,
            type: type.toLowerCase(),
            hasPlaceholder: hasPlaceholder,
            onDragStart: onDragHandleStart,
            onDrag: onDrag,
            onDragEnd: onDragEnd
        });
    };
    const $69ad6bcb1105aeca$var$handleStyles = null;
    const $69ad6bcb1105aeca$var$handleStylesOld = null;
});
parcelRegister("a3omN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ec23fd2b82a0df55$export$2e2bcd8739ae039);
    var $7VHMR;
    var $ec23fd2b82a0df55$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        gridCellAriaLabel: {
            "id": "roadmap.timeline-table-kit.chart-item-content.date-content.bar.grid-cell-aria-label",
            "defaultMessage": "Start date {startDate} until due date {dueDate} with color {color}"
        },
        warningsCount: {
            "id": "roadmap.timeline-table-kit.chart-item-content.date-content.bar.warnings-count",
            "defaultMessage": "{count, plural, one {# warning} other {# warnings}}"
        }
    });
});
parcelRegister("8QqqZ", function(module, exports) {
    $parcel$export(module.exports, "getMinimumPositions", ()=>$e7915a82df4b26c5$export$c1b6dd342ed8c79c);
    $parcel$export(module.exports, "getUpdatedDates", ()=>$e7915a82df4b26c5$export$3aa346efaf981bb1);
    $parcel$export(module.exports, "getAnalyticsType", ()=>$e7915a82df4b26c5$export$a3569ac53b82a914);
    $parcel$export(module.exports, "shouldInvertColor", ()=>$e7915a82df4b26c5$export$cf3d4bbc98af47e0);
    var $kFsv3;
    var $15ADj;
    var $2KlaV;
    const $e7915a82df4b26c5$export$c1b6dd342ed8c79c = (leftPosition, rightPosition, timelineWidth)=>{
        const barLength = timelineWidth - rightPosition - leftPosition;
        if (barLength < (0, (0, parcelRequire("15ADj")).MINIMUM_BAR_LENGTH)) {
            const minimumOffset = ((0, (0, parcelRequire("15ADj")).MINIMUM_BAR_LENGTH) - barLength) / 2;
            return {
                minimumLeft: leftPosition - minimumOffset,
                minimumRight: rightPosition - minimumOffset
            };
        }
        return {
            minimumLeft: undefined,
            minimumRight: undefined
        };
    };
    const $e7915a82df4b26c5$export$3aa346efaf981bb1 = (startDate, dueDate, dragType)=>{
        if (dragType === (0, (0, parcelRequire("2KlaV")).LEFT)) return {
            startDate: startDate
        };
        if (dragType === (0, (0, parcelRequire("2KlaV")).RIGHT)) return {
            dueDate: dueDate
        };
        if (dragType === (0, (0, parcelRequire("2KlaV")).LEFT_AND_RIGHT)) return {
            startDate: startDate,
            dueDate: dueDate
        };
        return {};
    };
    const $e7915a82df4b26c5$export$a3569ac53b82a914 = (updatedDates)=>{
        const { startDate: startDate, dueDate: dueDate } = updatedDates;
        if (startDate && !dueDate) return 'resizeLeft';
        if (!startDate && dueDate) return 'resizeRight';
        return 'moveBar';
    };
    const $e7915a82df4b26c5$var$lightColors = [
        (0, (0, parcelRequire("kFsv3")).PURPLE),
        (0, (0, parcelRequire("kFsv3")).BLUE),
        (0, (0, parcelRequire("kFsv3")).GREEN),
        (0, (0, parcelRequire("kFsv3")).TEAL),
        (0, (0, parcelRequire("kFsv3")).YELLOW),
        (0, (0, parcelRequire("kFsv3")).ORANGE),
        (0, (0, parcelRequire("kFsv3")).GREY)
    ];
    const $e7915a82df4b26c5$export$cf3d4bbc98af47e0 = (color)=>{
        return $e7915a82df4b26c5$var$lightColors.includes(color);
    };
});
parcelRegister("inYGI", function(module, exports) {
    $parcel$export(module.exports, "RoadmapBarWarnings", ()=>$06d67bd6df49e4bf$export$a4e6ea3b919ca9a9);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $bU3PY;
    var $3bDjY;
    var $btzsC;
    var $aWse0;
    const $06d67bd6df49e4bf$var$containerStyles = null;
    const $06d67bd6df49e4bf$var$contentWrapperStyles = null;
    const $06d67bd6df49e4bf$var$tooltipTextStyles = null;
    const $06d67bd6df49e4bf$var$iconContainerStyles = null;
    const $06d67bd6df49e4bf$var$TooltipTag = (0, $5uXOq.forwardRef)((props, ref)=>$5uXOq.createElement("span", {
            ref: ref,
            ...props,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz2owi _1e0c1txw"
            ])
        }));
    const $06d67bd6df49e4bf$export$a4e6ea3b919ca9a9 = ({ right: right, warnings: warnings })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        const TooltipComponent = (0, $5uXOq.forwardRef)((tooltipProps, ref)=>$5uXOq.createElement((0, (0, parcelRequire("btzsC")).default), {
                ...tooltipProps,
                ref: ref
            }));
        const tooltipContent = warnings.map((errorMessage)=>$5uXOq.createElement("div", {
                key: `${errorMessage.id}`,
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_1e0c1txw _1bsbp3fh _otyr1b66 _1yt41pyq _2rko1l7b _11q71bhr _16qsac02 _syaz1rn8"
                ])
            }, $5uXOq.createElement((0, ($parcel$interopDefault((0, parcelRequire("bU3PY"))))), {
                color: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$export$c6930421db9fa514)})`,
                LEGACY_size: "medium",
                label: "",
                spacing: "spacious"
            }), $5uXOq.createElement("div", {
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_1yt4swc3 _11c816g6 _18u0u2gc"
                ])
            }, formatMessage(errorMessage))));
        return $5uXOq.createElement("div", {
            style: {
                right: `${right}px`
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _1e0c1ule _t9ecwq5g _80omtlke _1pby11wp"
            ])
        }, $5uXOq.createElement((0, (0, parcelRequire("3bDjY")).default), {
            component: TooltipComponent,
            content: tooltipContent,
            position: "bottom-start",
            delay: 0,
            hideTooltipOnClick: true,
            tag: $06d67bd6df49e4bf$var$TooltipTag
        }, $5uXOq.createElement((0, ($parcel$interopDefault((0, parcelRequire("bU3PY"))))), {
            color: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$export$c6930421db9fa514)})`,
            label: "",
            spacing: "spacious"
        })));
    };
});
parcelRegister("Aa6uS", function(module, exports) {
    $parcel$export(module.exports, "RoadmapNavigateButton", ()=>$5c049fb6f05e980c$export$f4de1542efe44c4);
    var $bwpsq;
    var $lD23V;
    var $5uXOq = parcelRequire("5uXOq");
    var $bu8Mq;
    var $eGdV2;
    var $gwIPs;
    var $4R6GH;
    var $8zOmE;
    var $2NMNM;
    var $3Kr5N;
    var $kyahI;
    var $dCm1o;
    const $5c049fb6f05e980c$var$BUTTON_SIZE = 3 * (0, (0, parcelRequire("gwIPs")).gridSize);
    const $5c049fb6f05e980c$var$DATE_OFFSET = $5c049fb6f05e980c$var$BUTTON_SIZE + (0, (0, parcelRequire("gwIPs")).gridSize);
    const $5c049fb6f05e980c$var$SCROLL_BAR_OFFSET = 10;
    const $5c049fb6f05e980c$var$PAST_BORDER_RADIUS = `0 ${(0, (0, parcelRequire("gwIPs")).borderRadius)}px ${(0, (0, parcelRequire("gwIPs")).borderRadius)}px 0`;
    const $5c049fb6f05e980c$var$FUTURE_BORDER_RADIUS = `${(0, (0, parcelRequire("gwIPs")).borderRadius)}px 0 0 ${(0, (0, parcelRequire("gwIPs")).borderRadius)}px`;
    const $5c049fb6f05e980c$export$f4de1542efe44c4 = ({ itemMinLeftPosition: itemMinLeftPosition, itemMaxRightPosition: itemMaxRightPosition, label: label })=>{
        const { requestViewportScrollBounding: requestViewportScrollBounding, setViewportScroll: setViewportScroll } = (0, (0, parcelRequire("kyahI")).useViewport)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [isScrollingX] = (0, (0, parcelRequire("3Kr5N")).useIsScrollingX)();
        const [isHovered, setIsHovered] = (0, $5uXOq.useState)(false);
        if (isScrollingX) return null;
        const { scrollLeft: scrollLeft, scrollRight: scrollRight, scrollWidth: scrollWidth, isOverflowY: isOverflowY } = requestViewportScrollBounding();
        const isItemInPast = scrollWidth - itemMaxRightPosition < scrollLeft;
        const isItemInFuture = scrollWidth - itemMinLeftPosition < scrollRight;
        if (!isItemInPast && !isItemInFuture) return null;
        const onMouseEnter = ()=>{
            setIsHovered(true);
        };
        const onMouseLeave = ()=>{
            setIsHovered(false);
        };
        const onClick = ()=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            });
            const analyticsAttributes = {
                direction: isItemInPast ? 'past' : 'future'
            };
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'navigateButton', analyticsAttributes);
            setViewportScroll({
                scrollLeft: itemMinLeftPosition - (0, $3f221b37ec60a4b6$export$6053dd7bb292e51e)
            });
        };
        const shouldApplyVisualRefreshChanges = (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1');
        const renderArrowIcon = (Icon)=>(0, ($parcel$interopDefault($5uXOq))).createElement(Icon, {
                label: "",
                color: shouldApplyVisualRefreshChanges ? "var(--ds-icon-inverse, #FFFFFF)" : "var(--ds-icon, #44546F)"
            });
        if (isItemInPast) return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "roadmap.timeline-table-kit.ui.chart-item-content.date-content.navigate-button.navigate",
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onKeyDown: (e)=>(e.key === 'Enter' || e.key === 'Space') && onClick(),
            role: "presentation",
            className: (0, (0, parcelRequire("bwpsq")).default)([
                shouldApplyVisualRefreshChanges ? "_kqswstnw _1e0c1txw _4cvr1h6o _4t3i1tcg _1bsb1tcg _vchhusvi _18u01b66 _2hwx1b66 _2rkoglpi _1yt41b66 _bfhk165m _1pbyouyt _80omtlke _irr31pce" : "_kqswstnw _1e0c1txw _4cvr1h6o _4t3i1tcg _vchhusvi _1yt41b66 _bfhk1i4r _1pbyouyt _80omtlke _irr3arkb",
                !shouldApplyVisualRefreshChanges && "_2rko1gaq"
            ]),
            style: {
                left: `${scrollLeft}px`,
                width: `${$5c049fb6f05e980c$var$BUTTON_SIZE}px`,
                "--_3j09fn": (0, (0, parcelRequire("lD23V")).default)($5c049fb6f05e980c$var$PAST_BORDER_RADIUS)
            }
        }, renderArrowIcon((0, ($parcel$interopDefault((0, parcelRequire("bu8Mq")))))), isHovered && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _1ltvxy5q"
            ])
        }, label));
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "roadmap.timeline-table-kit.ui.chart-item-content.date-content.navigate-button.navigate",
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                shouldApplyVisualRefreshChanges ? "_kqswstnw _1e0c1txw _4cvr1h6o _4t3i1tcg _1bsb1tcg _vchhusvi _18u01b66 _2hwx1b66 _2rkoglpi _1yt41b66 _bfhk165m _1pbyouyt _80omtlke _irr31pce" : "_kqswstnw _1e0c1txw _4cvr1h6o _4t3i1tcg _vchhusvi _1yt41b66 _bfhk1i4r _1pbyouyt _80omtlke _irr3arkb",
                !shouldApplyVisualRefreshChanges && "_2rkoff7z"
            ]),
            style: {
                right: `${scrollRight}px`,
                width: shouldApplyVisualRefreshChanges ? undefined : `${$5c049fb6f05e980c$var$BUTTON_SIZE + (isOverflowY ? $5c049fb6f05e980c$var$SCROLL_BAR_OFFSET : 0)}px`,
                "--_kwbool": (0, (0, parcelRequire("lD23V")).default)($5c049fb6f05e980c$var$FUTURE_BORDER_RADIUS)
            }
        }, renderArrowIcon((0, ($parcel$interopDefault((0, parcelRequire("eGdV2")))))), isHovered && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                right: `${$5c049fb6f05e980c$var$DATE_OFFSET + (isOverflowY ? $5c049fb6f05e980c$var$SCROLL_BAR_OFFSET : 0)}px`
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw"
            ])
        }, label));
    };
    const $5c049fb6f05e980c$var$baseButtonStyles = null;
    const $5c049fb6f05e980c$var$baseButtonStylesOld = null;
    const $5c049fb6f05e980c$var$pastButtonBorderRadiusStyles = null;
    const $5c049fb6f05e980c$var$futureButtonBorderRadiusStyles = null;
    const $5c049fb6f05e980c$var$pastLabelContainerStyles = null;
    const $5c049fb6f05e980c$var$futureLabelContainerStyles = null;
});
parcelRegister("eGdV2", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $aaffc8f190d8dd35$var$_react = $aaffc8f190d8dd35$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $aaffc8f190d8dd35$var$_arrowRight = $aaffc8f190d8dd35$var$_interopRequireDefault((parcelRequire("h1TKi")));
    var $aaffc8f190d8dd35$var$_arrowRight2 = $aaffc8f190d8dd35$var$_interopRequireDefault((parcelRequire("8RBk4")));
    function $aaffc8f190d8dd35$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $aaffc8f190d8dd35$var$ArrowRightIcon = (props)=>$aaffc8f190d8dd35$var$_react.default.createElement($aaffc8f190d8dd35$var$_arrowRight.default, Object.assign({
            LEGACY_fallbackIcon: $aaffc8f190d8dd35$var$_arrowRight2.default
        }, props));
    $aaffc8f190d8dd35$var$ArrowRightIcon.Name = 'ArrowRightIconMigration';
    var $aaffc8f190d8dd35$var$_default = module.exports.default = $aaffc8f190d8dd35$var$ArrowRightIcon;
});
parcelRegister("h1TKi", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c65dc59efb96b35a$var$_react = $c65dc59efb96b35a$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c65dc59efb96b35a$var$_UNSAFE_baseNew = $c65dc59efb96b35a$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $c65dc59efb96b35a$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c65dc59efb96b35a$var$ArrowRightIcon = (props)=>$c65dc59efb96b35a$var$_react.default.createElement($c65dc59efb96b35a$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1 8h12.75m-4.5-5 5 5-5 5"/>`
        }, props));
    $c65dc59efb96b35a$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
    var $c65dc59efb96b35a$var$_default = module.exports.default = $c65dc59efb96b35a$var$ArrowRightIcon;
});
parcelRegister("8RBk4", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $6740397d4ba98b13$var$_react = $6740397d4ba98b13$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $6740397d4ba98b13$var$_arrowRight = $6740397d4ba98b13$var$_interopRequireDefault((parcelRequire("h1TKi")));
    function $6740397d4ba98b13$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $6740397d4ba98b13$var$ArrowRightIcon = (props)=>$6740397d4ba98b13$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.793 5.793a1 1 0 0 0 0 1.414L15.586 11H6a1 1 0 0 0 0 2h9.586l-3.793 3.793a1 1 0 0 0 0 1.414c.39.39 1.024.39 1.415 0l5.499-5.5a1 1 0 0 0 .293-.679v-.057a1 1 0 0 0-.293-.678l-5.499-5.5a1 1 0 0 0-1.415 0"/></svg>`
        }, props, {
            newIcon: $6740397d4ba98b13$var$_arrowRight.default
        }));
    $6740397d4ba98b13$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
    var $6740397d4ba98b13$var$_default = module.exports.default = $6740397d4ba98b13$var$ArrowRightIcon;
});
const $3f221b37ec60a4b6$export$6053dd7bb292e51e = 32;
parcelRegister("4lsbG", function(module, exports) {
    $parcel$export(module.exports, "IntervalDropZones", ()=>$6aa54da9fb003258$export$f18d47ee39e90aec);
    var $5uXOq = parcelRequire("5uXOq");
    var $biT18;
    var $gPXTo;
    var $fjTKQ;
    var $fLTaH;
    const $6aa54da9fb003258$var$VisibleIntervalDropZones = ({ id: id, intervals: intervals, currentIntervalId: currentIntervalId, onClick: onClick })=>{
        const [{ timelineDuration: timelineDuration, timelineWidth: timelineWidth }] = (0, (0, parcelRequire("biT18")).useTimelineState)();
        const activeOrFutureGroups = (0, (0, parcelRequire("fLTaH")).getActiveOrFutureIntervalGroups)({
            intervals: intervals,
            currentIntervalId: currentIntervalId,
            timelineDuration: timelineDuration,
            timelineWidth: timelineWidth
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, activeOrFutureGroups.map((intervalGroup, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fjTKQ")).default), {
                id: id,
                key: index,
                left: Math.max(intervalGroup.left, intervalGroup.targetIntervalLeft),
                right: Math.max(intervalGroup.right, intervalGroup.targetIntervalRight),
                intervals: intervalGroup.intervals,
                onClick: onClick
            })));
    };
    const $6aa54da9fb003258$export$f18d47ee39e90aec = ({ id: id, intervals: intervals, onClick: onClick })=>{
        const [{ isVisible: isVisible, currentIntervalId: currentIntervalId }] = (0, (0, parcelRequire("gPXTo")).useIntervalDropZoneData)(id);
        return isVisible ? (0, ($parcel$interopDefault($5uXOq))).createElement($6aa54da9fb003258$var$VisibleIntervalDropZones, {
            id: id,
            intervals: intervals,
            currentIntervalId: currentIntervalId,
            onClick: onClick
        }) : null;
    };
    var $6aa54da9fb003258$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($6aa54da9fb003258$export$f18d47ee39e90aec);
});
parcelRegister("fjTKQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b024a0b09429ca52$export$2e2bcd8739ae039);
    var $bwpsq;
    var $lD23V;
    var $5uXOq = parcelRequire("5uXOq");
    var $8zOmE;
    var $2NMNM;
    var $gPXTo;
    const $b024a0b09429ca52$var$DROPZONE_BACKGROUND = `var(--ds-background-accent-blue-bolder, ${`${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)}`})`;
    const $b024a0b09429ca52$var$INTERVAL_DROPZONE_WIDTH_EXPANSION = 2;
    const $b024a0b09429ca52$var$dropZoneStyles = null;
    const $b024a0b09429ca52$export$ad226bf0b5a21555 = ({ id: id, left: left, right: right, intervals: intervals, onClick: onClickDropZone })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [targetIntervalId] = (0, (0, parcelRequire("gPXTo")).useTargetIntervalId)(intervals);
        const { resetChartInteractionState: resetChartInteractionState } = (0, (0, parcelRequire("gPXTo")).useResetChartInteractionState)();
        const onClick = ()=>{
            if (onClickDropZone && targetIntervalId !== undefined) {
                const analyticsEvent = createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'dropzone'
                });
                onClickDropZone(id, {
                    intervalId: targetIntervalId
                }, analyticsEvent);
                resetChartInteractionState();
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'intervalDropzone');
            }
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            onClick: onClick,
            onKeyDown: (e)=>(e.key === 'Enter' || e.key === 'Space') && onClick(),
            role: "presentation",
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _4t3igktf _2rko1l7b _1pbycs5v _19it1gv3 _bfhkuyzt _v5641ql7"
            ]),
            style: {
                left: `${targetIntervalId !== undefined ? left - $b024a0b09429ca52$var$INTERVAL_DROPZONE_WIDTH_EXPANSION : left + 1}px`,
                right: `${targetIntervalId !== undefined ? right - $b024a0b09429ca52$var$INTERVAL_DROPZONE_WIDTH_EXPANSION : right + 1}px`,
                opacity: targetIntervalId !== undefined ? 0.38 : 0.13,
                cursor: targetIntervalId !== undefined ? 'pointer' : 'default',
                borderWidth: targetIntervalId !== undefined ? `${$b024a0b09429ca52$var$INTERVAL_DROPZONE_WIDTH_EXPANSION}px` : 0,
                "--_1m5or25": (0, (0, parcelRequire("lD23V")).default)($b024a0b09429ca52$var$DROPZONE_BACKGROUND)
            }
        });
    };
    var $b024a0b09429ca52$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($b024a0b09429ca52$export$ad226bf0b5a21555);
});
parcelRegister("fLTaH", function(module, exports) {
    $parcel$export(module.exports, "getActiveOrFutureIntervalGroups", ()=>$d88fdd46704e2efe$export$8d82d19c3a1af9a2);
    var $igUC7;
    const $d88fdd46704e2efe$export$8d82d19c3a1af9a2 = ({ intervals: intervals, currentIntervalId: currentIntervalId, timelineDuration: timelineDuration, timelineWidth: timelineWidth })=>{
        let unassignedIntervals = intervals;
        if (currentIntervalId !== undefined) unassignedIntervals = intervals.filter((interval)=>interval.id !== currentIntervalId);
        const intervalGroups = (0, (0, parcelRequire("igUC7")).getIntervalGroupPositions)(unassignedIntervals, timelineDuration, timelineWidth);
        return intervalGroups.filter((intervalGroup)=>intervalGroup.intervals.some((interval)=>interval.state !== (0, $8e299570902dfa36$export$19c4f83398a8dbce)));
    };
});
parcelRegister("8Pp9Z", function(module, exports) {
    $parcel$export(module.exports, "NoDateContent", ()=>$2f0a34bfe061100d$export$372da41cc9735180);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $1XJ20;
    var $3Kr5N;
    var $kyahI;
    var $gXfPZ;
    var $ju548;
    const $2f0a34bfe061100d$var$previewContainerStyles = null;
    const $2f0a34bfe061100d$export$372da41cc9735180 = ({ id: id, level: level, color: color, startDateType: startDateType, dueDateType: dueDateType, isHovered: isHovered, onUpdate: onUpdate, children: children })=>{
        const lastScrollLeft = (0, $5uXOq.useRef)(0);
        const [isScrollingX] = (0, (0, parcelRequire("3Kr5N")).useIsScrollingX)();
        const wasScrollingX = (0, (0, parcelRequire("1XJ20")).usePreviousWithInitial)(isScrollingX);
        const { requestViewportScrollBounding: requestViewportScrollBounding } = (0, (0, parcelRequire("kyahI")).useViewport)();
        const [{ isActive: isActive, leftPosition: leftPosition, rightPosition: rightPosition, dragType: dragType }, { onDragStart: onDragStart, onDrag: onDrag, onDragEnd: onDragEnd, onLingerStart: onLingerStart, onLingerEnd: onLingerEnd, onPreview: onPreview }] = (0, (0, parcelRequire("gXfPZ")).useChartItemInteractions)(id);
        (0, $5uXOq.useEffect)(()=>{
            if (isActive && !dragType) {
                const { scrollLeft: scrollLeft } = requestViewportScrollBounding();
                if (!wasScrollingX && isScrollingX) lastScrollLeft.current = scrollLeft;
                else if (wasScrollingX && !isScrollingX && leftPosition !== undefined) {
                    const scrollOffset = scrollLeft - lastScrollLeft.current;
                    lastScrollLeft.current = scrollLeft;
                    onPreview(leftPosition + scrollOffset);
                }
            }
        });
        const onContainerMouseMove = ({ pageX: pageX, currentTarget: currentTarget })=>{
            onPreview(pageX - currentTarget.getBoundingClientRect().left);
        };
        const onPreviewClick = (params, analyticsEvent)=>{
            onUpdate(id, params, analyticsEvent);
            onLingerEnd();
        };
        const onPreviewDragEnd = (params, analyticsEvent)=>{
            onUpdate(id, params, analyticsEvent);
            onDragEnd();
        };
        if (isHovered && !isScrollingX || isActive && dragType) return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": `roadmap.timeline-table-kit.ui.chart-item-content.no-date-content.preview-container-${id}`,
            onMouseMove: onContainerMouseMove,
            onMouseEnter: onLingerStart,
            onMouseLeave: onLingerEnd,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _4t3i1osq _1e0c1txw _4cvr1h6o _1pbyouyt"
            ])
        }, children, leftPosition !== undefined && rightPosition !== undefined && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ju548")).PreviewBar), {
            level: level,
            color: color,
            startDateType: startDateType,
            dueDateType: dueDateType,
            leftPosition: leftPosition,
            rightPosition: rightPosition,
            onDrag: onDrag,
            onDragStart: onDragStart,
            onDragEnd: onPreviewDragEnd,
            onClick: onPreviewClick
        }));
        return null;
    };
});
parcelRegister("ju548", function(module, exports) {
    $parcel$export(module.exports, "PreviewBar", ()=>$aba5b98745058b32$export$cf6bba1afb8df9b7);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $fNuuD;
    var $8zOmE;
    var $2NMNM;
    var $joGLY;
    var $biT18;
    var $esmwW;
    var $2KlaV;
    var $8QVIw;
    var $apjDv;
    var $9KS0U;
    const $aba5b98745058b32$var$Bar = ({ left: left, right: right, level: level, color: color, children: children, 'data-testid': dataTestId })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                left: `${left}px`,
                right: `${right}px`
            },
            "data-testid": dataTestId,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _1ul91b66 _4t3i1tcg _1e0c1txw _4cvr1h6o _2rko1l7b _tzy4idpf _ju25fnf5 _5sagfnf5 _j7hq3v5s _1pgl1ytf _1o51q7pw _80omtlke",
                (0, (0, parcelRequire("joGLY")).isBaseLevel)(level) && "_4t3igktf"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            style: {
                backgroundColor: (0, (0, parcelRequire("9KS0U")).getBarTheme)(color).background
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1sb2b3bt _kqswstnw _154iidpf _1ltvidpf _94n5idpf _1xi2idpf _tzy4105o _2rko1l7b"
            ])
        }), children);
    const $aba5b98745058b32$var$DraggableBar = (0, (0, parcelRequire("fNuuD")).withDragObserver)($aba5b98745058b32$var$Bar);
    const $aba5b98745058b32$export$cf6bba1afb8df9b7 = ({ level: level, color: color, startDateType: startDateType, dueDateType: dueDateType, leftPosition: leftPosition, rightPosition: rightPosition, onDrag: onDrag, onDragStart: onDragStart, onDragEnd: onDragEnd, onClick: onClick })=>{
        const elemRef = (0, $5uXOq.useRef)(null);
        const [{ timelineDuration: timelineDuration, timelineWidth: timelineWidth }] = (0, (0, parcelRequire("biT18")).useTimelineState)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const startDate = (0, (0, parcelRequire("apjDv")).getStartDate)(leftPosition, timelineDuration, timelineWidth);
        const dueDate = (0, (0, parcelRequire("apjDv")).getDueDate)(rightPosition, timelineDuration, timelineWidth);
        const onHandleDragStart = ()=>{
            onDragStart((0, (0, parcelRequire("2KlaV")).RIGHT));
        };
        const onHandleDragEnd = ()=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'dragged',
                actionSubject: 'previewBar'
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'previewBar', {
                level: level
            });
            onDragEnd({
                dates: {
                    startDate: startDate,
                    dueDate: dueDate
                }
            }, analyticsEvent);
        };
        const onHandleClick = ()=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'previewBar'
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'previewBar', {
                level: level
            });
            onClick({
                dates: {
                    startDate: startDate,
                    dueDate: dueDate
                }
            }, analyticsEvent);
        };
        const getBarBoundingClientRect = ()=>elemRef.current?.getBoundingClientRect();
        const isIntervalDateType = startDateType === (0, (0, parcelRequire("esmwW")).INTERVAL) && dueDateType === (0, (0, parcelRequire("esmwW")).INTERVAL);
        return ((0, ($parcel$interopDefault($5uXOq))).createElement($aba5b98745058b32$var$DraggableBar, {
            "data-testid": "roadmap.timeline-table-kit.ui.chart-item-content.no-date-content.preview-bar.preview-bar",
            innerRef: elemRef,
            color: color,
            left: leftPosition,
            right: rightPosition,
            isDisabled: isIntervalDateType,
            onDrag: onDrag,
            onDragStart: onHandleDragStart,
            onDragEnd: onHandleDragEnd,
            onClick: onHandleClick
        }, !isIntervalDateType && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8QVIw")).RoadmapDateLabels), {
            startDate: startDate,
            dueDate: dueDate,
            getBarBoundingClientRect: getBarBoundingClientRect
        })));
    };
    const $aba5b98745058b32$var$fadeInStyles = null;
    const $aba5b98745058b32$var$baseLevelStyles = null;
    const $aba5b98745058b32$var$barStyles = null;
    const $aba5b98745058b32$var$indicatorStyles = null;
});
parcelRegister("9ary6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e6b42cc72d5d0fcc$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bC2fB;
    var $1mW3K;
    var $fvM4Z;
    var $lhyxE;
    const $e6b42cc72d5d0fcc$var$DndLongTaskMetric = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1mW3K")).DragAndDropLongTaskMetric), {
            ...props,
            metricType: (0, $8038b72ffd5aa8d4$export$3ac90e7f239a7193)
        });
    const $e6b42cc72d5d0fcc$var$mapStateToProps = (state)=>({
            isEditEnabled: (0, (0, parcelRequire("fvM4Z")).getCanUserEdit)(state),
            DndLongTaskMetric: $e6b42cc72d5d0fcc$var$DndLongTaskMetric
        });
    var $e6b42cc72d5d0fcc$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($e6b42cc72d5d0fcc$var$mapStateToProps, {})((0, (0, parcelRequire("lhyxE")).default));
});
parcelRegister("lhyxE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0c3f379737ffd831$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $3eHnk;
    var $9XUGm;
    var $g3prf;
    var $2w0lu;
    var $6p2OJ;
    var $cONT5;
    const $0c3f379737ffd831$var$renderOverlayButton = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6p2OJ")).default), null);
    const $0c3f379737ffd831$var$ChartOverlay = ({ isEditEnabled: isEditEnabled, DndLongTaskMetric: DndLongTaskMetric })=>{
        const [{ headerHeight: headerHeight }] = (0, (0, parcelRequire("g3prf")).useHeaderState)();
        const renderPreview = (props)=>{
            const previewProps = (0, (0, parcelRequire("cONT5")).getPreviewProps)(props);
            return previewProps ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2w0lu")).default), previewProps) : null;
        };
        const renderChartDragLayer = ()=>isEditEnabled ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3eHnk")).RoadmapChartDragLayer), {
                type: (0, $708c0d50a54aba38$export$48a2b55760ce2355),
                renderPreview: renderPreview,
                DndLongTaskMetric: DndLongTaskMetric
            }) : null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                top: headerHeight
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _1xi2idpf _94n5idpf _1ltvidpf _1pbyilow"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9XUGm")).RoadmapChartOverlay), {
            renderChartDragLayer: renderChartDragLayer,
            renderOverlayButton: $0c3f379737ffd831$var$renderOverlayButton
        }));
    };
    var $0c3f379737ffd831$export$2e2bcd8739ae039 = $0c3f379737ffd831$var$ChartOverlay;
    const $0c3f379737ffd831$var$dragLayerContainerStyles = null;
});
parcelRegister("3eHnk", function(module, exports) {
    $parcel$export(module.exports, "RoadmapChartDragLayer", ()=>$3c28ef0c3dfa742a$export$f32354274fa76e25);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8QpSo;
    var $4hDdm = parcelRequire("4hDdm");
    var $7gWdR = parcelRequire("7gWdR");
    var $bdtf9;
    const $3c28ef0c3dfa742a$var$getDefaultPreviewProps = (0, (0, parcelRequire("8QpSo")).default)(()=>({
            item: undefined,
            clientOffset: {
                x: 0,
                y: 0
            },
            scrollOffset: {
                scrollLeft: 0,
                scrollTop: 0
            }
        }));
    const $3c28ef0c3dfa742a$export$f32354274fa76e25 = ({ type: type, renderPreview: renderPreview, DndLongTaskMetric: DndLongTaskMetric = ()=>null })=>{
        const defaultPreviewProps = (0, $5uXOq.useMemo)(()=>$3c28ef0c3dfa742a$var$getDefaultPreviewProps(), []);
        const [isDragging, setIsDragging] = (0, $5uXOq.useState)(false);
        const [previewProps, setPreviewProps] = (0, $5uXOq.useState)(defaultPreviewProps);
        (0, $5uXOq.useEffect)(()=>(0, $4hDdm.combine)((0, $7gWdR.monitorForElements)({
                onDrag: ({ source: source, location: location })=>{
                    const item = source.data;
                    const { current: { input: current }, initial: { input: initial } } = location;
                    if (item.type === type) {
                        const { viewportBoundingRect: viewportBoundingRect, initialScrollBoundingRect: initialScrollBoundingRect, requestViewportScrollBounding: requestViewportScrollBounding, setViewportScroll: setViewportScroll } = item;
                        const initialOffset = {
                            x: initial.pageX,
                            y: initial.pageY
                        };
                        const clientOffset = {
                            x: current.pageX,
                            y: current.pageY
                        };
                        if (initialOffset && clientOffset) {
                            const { scrollLeft: scrollLeft, scrollTop: scrollTop } = (0, (0, parcelRequire("bdtf9")).adjustScrollPosition)(initialOffset, clientOffset, setViewportScroll, initialScrollBoundingRect, requestViewportScrollBounding, viewportBoundingRect);
                            const previewItem = source.data;
                            setPreviewProps({
                                item: previewItem,
                                clientOffset: clientOffset,
                                scrollOffset: {
                                    scrollLeft: scrollLeft,
                                    scrollTop: scrollTop
                                }
                            });
                        }
                        setIsDragging(true);
                    }
                },
                onDrop ({ source: source }) {
                    const item = source.data;
                    if (item.type === type) {
                        setPreviewProps(defaultPreviewProps);
                        setIsDragging(false);
                    }
                }
            })), [
            type,
            defaultPreviewProps
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($3c28ef0c3dfa742a$var$Container, null, renderPreview(previewProps), (0, ($parcel$interopDefault($5uXOq))).createElement(DndLongTaskMetric, {
            isDragging: isDragging
        }));
    };
    const $3c28ef0c3dfa742a$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _1ltvidpf _154iidpf _1xi2idpf _94n5idpf _1reo15vq _18m915vq",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("9XUGm", function(module, exports) {
    $parcel$export(module.exports, "RoadmapChartOverlay", ()=>$4ea548ad2a1681c4$export$74441df56fec708f);
    var $5uXOq = parcelRequire("5uXOq");
    const $4ea548ad2a1681c4$export$74441df56fec708f = ({ renderChartDragLayer: renderChartDragLayer = ()=>null, renderOverlayButton: renderOverlayButton = ()=>null })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, renderOverlayButton(), renderChartDragLayer());
});
parcelRegister("2w0lu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$df07377d96a8ac0b$export$2e2bcd8739ae039);
    var $bC2fB;
    var $2IdXh;
    var $afFFB;
    const $df07377d96a8ac0b$var$mergeProps = (stateProps, _, { id: id, ...ownProps })=>({
            ...stateProps,
            ...ownProps
        });
    var $df07377d96a8ac0b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((state, ownProps)=>({
            color: (0, (0, parcelRequire("2IdXh")).getIssueParentColor)(state, ownProps.id)
        }), null, $df07377d96a8ac0b$var$mergeProps)((0, (0, parcelRequire("afFFB")).default));
});
parcelRegister("afFFB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$008a3db9a4fd8d32$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $kFsv3;
    var $2XdbK;
    var $3fzzd;
    const $008a3db9a4fd8d32$var$DependencyLinePreview = ({ x0: x0, y0: y0, x: x, y: y, width: width, height: height, color: color })=>{
        const theme = (0, (0, parcelRequire("2XdbK")).dependencyThemes)[color];
        const top = y - 5;
        const left = x - 5;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3fzzd")).default), {
            color: theme.icon,
            top: top,
            left: left
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: width,
            height: height
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("line", {
            style: {
                stroke: theme.line
            },
            x1: x0,
            y1: y0,
            x2: left,
            y2: top,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1snbcs5v _134c892t _lswuglyw"
            ])
        })));
    };
    $008a3db9a4fd8d32$var$DependencyLinePreview.defaultProps = {
        color: (0, (0, parcelRequire("kFsv3")).PURPLE)
    };
    var $008a3db9a4fd8d32$export$2e2bcd8739ae039 = $008a3db9a4fd8d32$var$DependencyLinePreview;
    const $008a3db9a4fd8d32$var$lineStyles = null;
});
parcelRegister("3fzzd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$678bb9c3f0f1c6b8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $bNS7k;
    const $678bb9c3f0f1c6b8$var$DependencyIcon = ({ top: top, left: left, color: color })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $678bb9c3f0f1c6b8$var$wrapperStyles,
            style: {
                top: top,
                left: left
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bNS7k")).DependencyDragHandler), {
            color: color
        }));
    var $678bb9c3f0f1c6b8$export$2e2bcd8739ae039 = $678bb9c3f0f1c6b8$var$DependencyIcon;
    const $678bb9c3f0f1c6b8$var$wrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'absolute',
        display: 'flex',
        width: "var(--ds-space-250, 20px)",
        height: "var(--ds-space-250, 20px)",
        transform: 'translate(-10px, -10px)'
    });
});
parcelRegister("6p2OJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1b8fbb877b0e6aac$export$2e2bcd8739ae039);
    var $bC2fB;
    var $9fPrG;
    var $dIOb2;
    var $1b8fbb877b0e6aac$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((state)=>({
            isMacroView: (0, (0, parcelRequire("9fPrG")).hasMacroConfig)(state)
        }), {})((0, (0, parcelRequire("dIOb2")).OverlayButton));
});
parcelRegister("dIOb2", function(module, exports) {
    $parcel$export(module.exports, "OverlayButton", ()=>$95e7370872f83cfe$export$8b82a61f37322af9);
    var $5uXOq = parcelRequire("5uXOq");
    var $dPzs1;
    var $4R6GH;
    var $99BAr;
    var $ACELo;
    var $8CVvd;
    var $i0XcG;
    var $dCm1o;
    var $k2DYU;
    var $fwO2i;
    const $95e7370872f83cfe$var$getFullscreenRefs = ()=>Array.from(document.querySelectorAll('[data-fullscreen-id]'));
    const $95e7370872f83cfe$export$8b82a61f37322af9 = ({ isMacroView: isMacroView })=>{
        const toolbarItems = [
            {
                id: 'today-button',
                element: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i0XcG")).RoadmapTodayButton), null),
                showDivider: false
            },
            {
                id: 'timeline-mode-switcher',
                element: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fwO2i")).default), null)
            },
            {
                id: 'legend',
                element: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k2DYU")).default), null)
            }
        ];
        ((0, (0, parcelRequire("8CVvd")).getWillShowNav3)() || !(0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap_drop_2')) && toolbarItems.push({
            id: 'fullscreen-button',
            element: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("99BAr")).default), {
                testId: "roadmap.standard-roadmap.common.table.chart-overlay.overlay-button.fullscreen-button",
                getCustomRefs: $95e7370872f83cfe$var$getFullscreenRefs,
                withContainerStyles: false,
                isSubtle: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)()
            }),
            isVisible: !isMacroView,
            showDivider: false
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ACELo")).JiraBottomRightCornerOutlet), {
            orderFromRight: 2,
            id: "software-roadmap-timeline-overlay"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dPzs1")).default), {
            items: toolbarItems
        }));
    };
});
parcelRegister("dPzs1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$009921c45d78ef32$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fVnbM;
    var $42CjB;
    var $czDCn;
    var $8KJVQ;
    var $lRheX;
    var $3dGN0;
    var $4R6GH;
    var $koVbs;
    var $dCm1o;
    var $aaUcm;
    var $6rGzM;
    const $009921c45d78ef32$var$renderItem = (key, component, showDivider)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, {
            key: key
        }, showDivider && (0, ($parcel$interopDefault($5uXOq))).createElement($009921c45d78ef32$var$Divider, {
            "data-testid": "aais-timeline-toolbar.ui.container.divider"
        }), component);
    const $009921c45d78ef32$var$Toolbar = ({ items: items, isCollapsible: isCollapsible = true })=>{
        const [isExpanded, setIsExpanded] = (0, $5uXOq.useState)(true);
        const toggleIsExpanded = (0, $5uXOq.useCallback)(()=>{
            if (isCollapsible) setIsExpanded(!isExpanded);
        }, [
            isExpanded,
            isCollapsible,
            setIsExpanded
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isExpanded && !isCollapsible) setIsExpanded(true);
        }, [
            isExpanded,
            isCollapsible,
            setIsExpanded
        ]);
        const renderContent = ()=>items.filter(({ isVisible: isVisible = true })=>isVisible).map(({ id: id, element: element, showDivider: showDivider }, index)=>{
                return $009921c45d78ef32$var$renderItem(id, element, (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && showDivider !== undefined ? showDivider : isCollapsible || index !== 0);
            });
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const COLLAPSED_WIDTH = (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? '0px' : '32px';
        return (0, ($parcel$interopDefault($5uXOq))).createElement($009921c45d78ef32$var$TimelineToolbarWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6rGzM")).default), {
            isExpanded: isExpanded,
            collapsedWidth: COLLAPSED_WIDTH
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($009921c45d78ef32$var$TimelineToolbarContainer, null, !(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && isCollapsible && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            testId: "aais-timeline-toolbar.ui.container.expand-button",
            appearance: "subtle",
            onClick: toggleIsExpanded,
            iconBefore: isExpanded ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8KJVQ"))))), {
                label: formatMessage((0, (0, parcelRequire("aaUcm")).default).expandButtonLabel)
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("czDCn"))))), {
                label: formatMessage((0, (0, parcelRequire("aaUcm")).default).collapseButtonLabel)
            }),
            "aria-expanded": isExpanded,
            ...(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics') ? {
                interactionName: 'timeline-toolbar-expand-clicked'
            } : {}
        }), renderContent())), (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
            label: isExpanded ? formatMessage((0, (0, parcelRequire("aaUcm")).default).expandButtonLabel) : formatMessage((0, (0, parcelRequire("aaUcm")).default).collapseButtonLabel),
            "aria-expanded": isExpanded,
            testId: "aais-timeline-toolbar.ui.container.expand-button",
            appearance: "subtle",
            onClick: toggleIsExpanded,
            icon: ()=>isExpanded ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("3dGN0"))))), {
                    label: "",
                    color: "currentColor"
                }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("lRheX"))))), {
                    label: "",
                    color: "currentColor"
                }),
            ...(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics') ? {
                interactionName: 'timeline-toolbar-expand-clicked'
            } : {}
        }));
    };
    var $009921c45d78ef32$export$2e2bcd8739ae039 = $009921c45d78ef32$var$Toolbar;
    const $009921c45d78ef32$var$Divider = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_bfhkb5v6 _4t3i1tcg _1bsbt94y",
                __cmplp.className
            ])
        });
    });
    const $009921c45d78ef32$var$TimelineToolbarWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_bfhkhp5a _1yt41b66 _1e0c1txw _19ith6cr _2rko1l7b _16qscbcv _1reo15vq _18m915vq",
                __cmplp.className
            ])
        });
    });
    const $009921c45d78ef32$var$TimelineToolbarContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _zulp1b66 _1o9zidpf _1puhidpf",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("czDCn", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $92777c37de6ba579$var$_react = $92777c37de6ba579$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $92777c37de6ba579$var$_chevronLeft = $92777c37de6ba579$var$_interopRequireDefault((parcelRequire("lRheX")));
    function $92777c37de6ba579$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $92777c37de6ba579$var$ChevronLeftCircleIcon = (props)=>$92777c37de6ba579$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M13.706 9.698a.99.99 0 0 0 0-1.407 1.01 1.01 0 0 0-1.419 0l-2.965 2.94a1.09 1.09 0 0 0 0 1.548l2.955 2.93a1.01 1.01 0 0 0 1.42 0 .99.99 0 0 0 0-1.407l-2.318-2.297z"/></g></svg>`
        }, props, {
            newIcon: $92777c37de6ba579$var$_chevronLeft.default,
            iconType: "utility"
        }));
    $92777c37de6ba579$var$ChevronLeftCircleIcon.displayName = 'ChevronLeftCircleIcon';
    var $92777c37de6ba579$var$_default = module.exports.default = $92777c37de6ba579$var$ChevronLeftCircleIcon;
});
parcelRegister("lRheX", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $fe9bebc953515e63$var$_react = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $fe9bebc953515e63$var$_UNSAFE_baseNew = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $fe9bebc953515e63$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $fe9bebc953515e63$var$ChevronLeftIcon = (props)=>$fe9bebc953515e63$var$_react.default.createElement($fe9bebc953515e63$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.5 10.5 3 6l4.5-4.5"/>`,
            type: 'utility'
        }, props));
    $fe9bebc953515e63$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
    var $fe9bebc953515e63$var$_default = module.exports.default = $fe9bebc953515e63$var$ChevronLeftIcon;
});
parcelRegister("8KJVQ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $65f63fbd27b0c00e$var$_react = $65f63fbd27b0c00e$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $65f63fbd27b0c00e$var$_chevronRight = $65f63fbd27b0c00e$var$_interopRequireDefault((parcelRequire("3dGN0")));
    function $65f63fbd27b0c00e$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $65f63fbd27b0c00e$var$ChevronRightCircleIcon = (props)=>$65f63fbd27b0c00e$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M10.294 9.698a.99.99 0 0 1 0-1.407 1.01 1.01 0 0 1 1.419 0l2.965 2.94a1.09 1.09 0 0 1 0 1.548l-2.955 2.93a1.01 1.01 0 0 1-1.42 0 .99.99 0 0 1 0-1.407l2.318-2.297z"/></g></svg>`
        }, props, {
            newIcon: $65f63fbd27b0c00e$var$_chevronRight.default,
            iconType: "utility"
        }));
    $65f63fbd27b0c00e$var$ChevronRightCircleIcon.displayName = 'ChevronRightCircleIcon';
    var $65f63fbd27b0c00e$var$_default = module.exports.default = $65f63fbd27b0c00e$var$ChevronRightCircleIcon;
});
parcelRegister("aaUcm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2ec76cd846c1264c$export$2e2bcd8739ae039);
    var $7VHMR;
    var $2ec76cd846c1264c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        expandButtonLabel: {
            "id": "aais-timeline-toolbar.container.expand-button-label",
            "defaultMessage": "Expand timeline time period buttons"
        },
        collapseButtonLabel: {
            "id": "aais-timeline-toolbar.container.collapse-button-label",
            "defaultMessage": "Collapse timeline time period buttons"
        }
    });
});
parcelRegister("6rGzM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3c037e2fcf2c9120$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $8Rkzz = parcelRequire("8Rkzz");
    var $lObw7;
    var $dWt6p;
    var $7XYc4;
    var $dCm1o;
    const $3c037e2fcf2c9120$var$WidthExpander = ({ isExpanded: isExpanded, collapsedWidth: collapsedWidth, children: children })=>{
        const [width, setWidth] = (0, $5uXOq.useState)(isExpanded ? 'auto' : collapsedWidth);
        const prefersReducedMotion = (0, (0, parcelRequire("dWt6p")).useIsReducedMotion)();
        const duration = prefersReducedMotion ? 0 : (0, (0, parcelRequire("lObw7")).mediumDurationMs);
        const isFirstRender = (0, $5uXOq.useRef)(true);
        const state = (0, $5uXOq.useRef)(isExpanded ? 'expanded' : 'collapsed');
        const ref = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (ref.current === null) return 0, ($parcel$interopDefault($8Rkzz));
            if (isFirstRender.current) {
                isFirstRender.current = false;
                return 0, ($parcel$interopDefault($8Rkzz));
            }
            if (prefersReducedMotion) {
                setWidth(isExpanded ? 'auto' : collapsedWidth);
                return 0, ($parcel$interopDefault($8Rkzz));
            }
            const expandedWidth = `${ref.current.offsetWidth}px`;
            if (state.current === 'transitioning') setWidth(isExpanded ? expandedWidth : collapsedWidth);
            else setWidth(expandedWidth);
            const immediate = setTimeout(()=>{
                if (!isExpanded) setWidth(collapsedWidth);
                state.current = 'transitioning';
            }, 1);
            const afterDuration = setTimeout(()=>{
                if (isExpanded) setWidth('auto');
                state.current = isExpanded ? 'expanded' : 'collapsed';
            }, (0, (0, parcelRequire("lObw7")).mediumDurationMs));
            return ()=>{
                clearTimeout(immediate);
                clearTimeout(afterDuration);
            };
        }, [
            isExpanded,
            collapsedWidth,
            duration,
            prefersReducedMotion
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($3c037e2fcf2c9120$var$OuterWrapper, {
            width: width,
            duration: duration,
            "data-testid": "aais-timeline-toolbar.ui.container.width-expander"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($3c037e2fcf2c9120$var$InnerWrapper, {
            ref: ref
        }, children));
    };
    var $3c037e2fcf2c9120$export$2e2bcd8739ae039 = $3c037e2fcf2c9120$var$WidthExpander;
    const $3c037e2fcf2c9120$var$OuterWrapperOld = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { duration: duration, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1gljcou": (0, (0, parcelRequire("lD23V")).default)(__cmplp.width),
                "--_7nn7wk": (0, (0, parcelRequire("lD23V")).default)(`width ${__cmplp.duration}ms ${(0, $eba99f58997c09b3$export$c07234257a03d5e9)}`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _njlp1rql _1bsb1rkg _v5641lsu",
                __cmplp.className
            ])
        });
    });
    const $3c037e2fcf2c9120$var$OuterWrapperNew = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { duration: duration, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1gljcou": (0, (0, parcelRequire("lD23V")).default)(__cmplp.width),
                "--_7nn7wk": (0, (0, parcelRequire("lD23V")).default)(`width ${__cmplp.duration}ms ${(0, $eba99f58997c09b3$export$c07234257a03d5e9)}`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _njlp1rql _1bsb1rkg _v5641lsu _1reo15vq _18m915vq",
                __cmplp.className
            ])
        });
    });
    const $3c037e2fcf2c9120$var$OuterWrapper = (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled), $3c037e2fcf2c9120$var$OuterWrapperNew, $3c037e2fcf2c9120$var$OuterWrapperOld);
    const $3c037e2fcf2c9120$var$InnerWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1o9zidpf",
                __cmplp.className
            ])
        });
    });
});
const $eba99f58997c09b3$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $eba99f58997c09b3$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $eba99f58997c09b3$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
parcelRegister("99BAr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d6d923fac0cd07eb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $gucb2;
    const $d6d923fac0cd07eb$var$FullscreenButton = ({ testId: testId, onToggle: onToggle, getCustomRefs: getCustomRefs, analyticsAttributes: analyticsAttributes, withContainerStyles: withContainerStyles = true, defaultFullscreen: defaultFullscreen = false, isFullscreen: isFullscreenProp, renderAsResponsiveButton: renderAsResponsiveButton = false, shouldRenderContent: shouldRenderContent = true, isSubtle: isSubtle })=>{
        const [isFullscreenState, setIsFullscreenState] = (0, $5uXOq.useState)(isFullscreenProp ?? defaultFullscreen);
        const isFullscreen = isFullscreenProp ?? isFullscreenState;
        const handleToggle = (wasFullscreen, globalStyle)=>{
            onToggle(wasFullscreen, globalStyle);
            setIsFullscreenState(!wasFullscreen);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gucb2")).default), {
            testId: testId,
            onToggle: handleToggle,
            getCustomRefs: getCustomRefs,
            analyticsAttributes: analyticsAttributes,
            withContainerStyles: withContainerStyles,
            defaultFullscreen: defaultFullscreen,
            isFullscreen: isFullscreen,
            renderAsResponsiveButton: renderAsResponsiveButton,
            shouldRenderContent: shouldRenderContent,
            isSubtle: isSubtle
        });
    };
    $d6d923fac0cd07eb$var$FullscreenButton.defaultProps = {
        onToggle: (0, ($parcel$interopDefault($8Rkzz))),
        getCustomRefs: ()=>[],
        analyticsAttributes: {}
    };
    var $d6d923fac0cd07eb$export$2e2bcd8739ae039 = $d6d923fac0cd07eb$var$FullscreenButton;
});
parcelRegister("gucb2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f59079bf3589c5a6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fVnbM;
    var $42CjB;
    var $5JpK2;
    var $j2iKG;
    var $3bDjY;
    var $3Tty1;
    var $koVbs;
    var $g7crU;
    var $3HwlS;
    var $8zOmE;
    var $6lmg7;
    var $dCm1o;
    var $gydfO;
    const $f59079bf3589c5a6$var$removeFullScreenStyle = (customRefs)=>{
        document.getElementById('fullscreen-global-style')?.remove();
        if (customRefs) customRefs.forEach((ref)=>{
            if (ref !== null) ref.classList.remove('fullscreen');
        });
    };
    const $f59079bf3589c5a6$var$FullscreenButton = ({ testId: testId, onToggle: onToggle, getCustomRefs: getCustomRefs, analyticsAttributes: extraAnalyticsAttributes, withContainerStyles: withContainerStyles = true, defaultFullscreen: defaultFullscreen = false, isFullscreen: isFullscreenProp, renderAsResponsiveButton: renderAsResponsiveButton = false, shouldRenderContent: shouldRenderContent = true, isSubtle: isSubtle = false })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const customRefElements = (0, $5uXOq.useRef)(null);
        const [isFullscreenLayout, { setIsFullscreen: setIsFullScreenLayout }] = (0, (0, parcelRequire("g7crU")).useIsFullscreen)();
        const globalStyle = document.createElement('style');
        const isFullscreen = (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? isFullscreenLayout : isFullscreenProp;
        const handleKeysInFullScreen = (0, $5uXOq.useCallback)((e)=>{
            if (e.target instanceof HTMLElement && ([
                'INPUT',
                'TEXTAREA',
                'SELECT'
            ].includes(e.target.tagName.toUpperCase()) || e.target.hasAttribute('contenteditable'))) return;
            const shortcutKeysToPrevent = [
                '/',
                'h'
            ];
            if (shortcutKeysToPrevent.includes(e.key)) e.stopPropagation();
            const navigationShortcuts = [
                '1',
                '2',
                '3',
                '4'
            ];
            if (!(0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && navigationShortcuts.includes(e.key)) {
                onToggle(true, globalStyle);
                const customRefs = customRefElements.current;
                $f59079bf3589c5a6$var$removeFullScreenStyle(customRefs);
            }
        }, [
            globalStyle,
            onToggle
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (isFullscreen) window?.addEventListener('keydown', handleKeysInFullScreen, true);
            else window?.removeEventListener('keydown', handleKeysInFullScreen, true);
            return ()=>window?.removeEventListener('keydown', handleKeysInFullScreen, true);
        }, [
            isFullscreen,
            handleKeysInFullScreen
        ]);
        const createFullScreenStyle = (0, $5uXOq.useCallback)(()=>{
            const customElements = customRefElements.current;
            const hiddenStyles = "#ak-jira-navigation, #ak-side-navigation, #right-sidebar-panel-wrapper, [data-skip-link-wrapper='true'] { display: none }";
            const hiddenStylesNode = document.createTextNode(hiddenStyles);
            globalStyle.id = 'fullscreen-global-style';
            globalStyle.appendChild(hiddenStylesNode);
            if (customElements) customElements.forEach((ref)=>{
                if (ref !== null) ref.classList.add('fullscreen');
            });
            document.head?.appendChild(globalStyle);
        }, [
            globalStyle
        ]);
        const onClick = (event, analyticsEvent)=>{
            if ((0, (0, parcelRequire("3HwlS")).getWillShowNav4)()) {
                const analyticsAttributes = {
                    ...extraAnalyticsAttributes,
                    expandToFullscreen: !isFullscreenLayout
                };
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'fullscreenButton', analyticsAttributes);
                setIsFullScreenLayout(!isFullscreenLayout);
                onToggle(!isFullscreenLayout);
            } else {
                customRefElements.current = getCustomRefs();
                const customElements = customRefElements.current;
                const analyticsAttributes = {
                    ...extraAnalyticsAttributes,
                    expandToFullscreen: !isFullscreen
                };
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'fullscreenButton', analyticsAttributes);
                onToggle(isFullscreen, globalStyle);
                if (isFullscreen) $f59079bf3589c5a6$var$removeFullScreenStyle(customElements);
                else createFullScreenStyle();
            }
        };
        (0, $5uXOq.useEffect)(()=>{
            customRefElements.current = getCustomRefs();
            const customElements = customRefElements.current;
            if (isFullscreen) createFullScreenStyle();
            else $f59079bf3589c5a6$var$removeFullScreenStyle(customElements);
            return ()=>$f59079bf3589c5a6$var$removeFullScreenStyle(customElements);
        }, [
            createFullScreenStyle,
            getCustomRefs,
            isFullscreen
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (defaultFullscreen) createFullScreenStyle();
        }, []);
        (0, $5uXOq.useEffect)(()=>{
            return ()=>{
                if ((0, (0, parcelRequire("3HwlS")).getWillShowNav4)()) setIsFullScreenLayout(false);
            };
        }, []);
        const renderButtonWithTooltip = ()=>{
            if ((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)()) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
                ...withContainerStyles ? {
                    testId: testId
                } : {
                    testId: 'platform.ui.fullscreen-button.fullscreen-button'
                },
                label: isFullscreen ? formatMessage((0, (0, parcelRequire("gydfO")).default).exitFullScreen) : formatMessage((0, (0, parcelRequire("gydfO")).default).enterFullScreen),
                onClick: onClick,
                icon: isFullscreen ? (0, ($parcel$interopDefault((0, parcelRequire("j2iKG"))))) : (0, ($parcel$interopDefault((0, parcelRequire("5JpK2"))))),
                appearance: isSubtle ? 'subtle' : 'default',
                isTooltipDisabled: false
            });
            if (renderAsResponsiveButton && !(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)()) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6lmg7")).ResponsiveButton), {
                label: isFullscreen ? formatMessage((0, (0, parcelRequire("gydfO")).default).exitFullScreen) : formatMessage((0, (0, parcelRequire("gydfO")).default).enterFullScreen),
                icon: isFullscreen ? (0, ($parcel$interopDefault((0, parcelRequire("j2iKG"))))) : (0, ($parcel$interopDefault((0, parcelRequire("5JpK2"))))),
                onClick: onClick,
                testId: testId ?? 'platform.ui.fullscreen-button.fullscreen-button'
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                content: formatMessage(isFullscreen ? (0, (0, parcelRequire("gydfO")).default).exitFullScreen : (0, (0, parcelRequire("gydfO")).default).enterFullScreen),
                position: "top-end"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                ...withContainerStyles ? {
                    testId: testId
                } : {
                    testId: 'platform.ui.fullscreen-button.fullscreen-button'
                },
                appearance: "subtle",
                onClick: onClick,
                iconBefore: isFullscreen ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("j2iKG"))))), {
                    color: "var(--ds-icon, #44546F)",
                    label: formatMessage((0, (0, parcelRequire("gydfO")).default).exitFullScreen),
                    spacing: "spacious"
                }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("5JpK2"))))), {
                    color: "var(--ds-icon, #44546F)",
                    label: formatMessage((0, (0, parcelRequire("gydfO")).default).enterFullScreen),
                    spacing: "spacious"
                })
            }));
        };
        const keyMap = {
            z: {
                callback: ()=>{
                    setIsFullScreenLayout(!isFullscreenLayout);
                }
            }
        };
        if (!shouldRenderContent) return null;
        return withContainerStyles ? (0, ($parcel$interopDefault($5uXOq))).createElement($f59079bf3589c5a6$var$FullscreenButtonContainer, {
            "data-testid": "platform.ui.fullscreen-button.fullscreen-button"
        }, renderButtonWithTooltip(), (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Tty1")).default), {
            keyMap: keyMap
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, renderButtonWithTooltip(), (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Tty1")).default), {
            keyMap: keyMap
        }));
    };
    var $f59079bf3589c5a6$export$2e2bcd8739ae039 = $f59079bf3589c5a6$var$FullscreenButton;
    const $f59079bf3589c5a6$var$FullscreenButtonContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c116y _bfhk1bhr _16qsrs09 _2rko1sit",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("5JpK2", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $42c51f70ef43f1c0$var$_react = $42c51f70ef43f1c0$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $42c51f70ef43f1c0$var$_growDiagonal = $42c51f70ef43f1c0$var$_interopRequireDefault((parcelRequire("l14Zy")));
    var $42c51f70ef43f1c0$var$_actualSize = $42c51f70ef43f1c0$var$_interopRequireDefault((parcelRequire("6LXPU")));
    function $42c51f70ef43f1c0$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $42c51f70ef43f1c0$var$GrowDiagonalIcon = (props)=>$42c51f70ef43f1c0$var$_react.default.createElement($42c51f70ef43f1c0$var$_growDiagonal.default, Object.assign({
            LEGACY_fallbackIcon: $42c51f70ef43f1c0$var$_actualSize.default
        }, props));
    $42c51f70ef43f1c0$var$GrowDiagonalIcon.Name = 'GrowDiagonalIconMigration';
    var $42c51f70ef43f1c0$var$_default = module.exports.default = $42c51f70ef43f1c0$var$GrowDiagonalIcon;
});
parcelRegister("6LXPU", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $4ee58c13163bfe09$var$_react = $4ee58c13163bfe09$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $4ee58c13163bfe09$var$_growDiagonal = $4ee58c13163bfe09$var$_interopRequireDefault((parcelRequire("l14Zy")));
    function $4ee58c13163bfe09$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $4ee58c13163bfe09$var$MediaServicesActualSizeIcon = (props)=>$4ee58c13163bfe09$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16.587 6.003H15A1 1 0 0 1 15 4h3.9l.047.001a.98.98 0 0 1 .736.285l.032.032c.2.2.296.47.284.736l.001.048v3.896a1 1 0 1 1-2 0V7.411l-3.309 3.308a.977.977 0 0 1-1.374-.005l-.032-.032a.976.976 0 0 1-.005-1.374zM7.413 17.997H9A1 1 0 0 1 9 20H5.1l-.047-.001a.98.98 0 0 1-.736-.285l-.032-.032A.98.98 0 0 1 4 18.946v-3.944a1 1 0 1 1 2 0v1.587l3.309-3.308a.977.977 0 0 1 1.374.005l.032.032a.976.976 0 0 1 .005 1.374z"/></svg>`
        }, props, {
            newIcon: $4ee58c13163bfe09$var$_growDiagonal.default
        }));
    $4ee58c13163bfe09$var$MediaServicesActualSizeIcon.displayName = 'MediaServicesActualSizeIcon';
    var $4ee58c13163bfe09$var$_default = module.exports.default = $4ee58c13163bfe09$var$MediaServicesActualSizeIcon;
});
parcelRegister("j2iKG", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ddbcbff50c42c269$var$_react = $ddbcbff50c42c269$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $ddbcbff50c42c269$var$_shrinkDiagonal = $ddbcbff50c42c269$var$_interopRequireDefault((parcelRequire("8KRBa")));
    var $ddbcbff50c42c269$var$_fitToPage = $ddbcbff50c42c269$var$_interopRequireDefault((parcelRequire("2bcm3")));
    function $ddbcbff50c42c269$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $ddbcbff50c42c269$var$ShrinkDiagonalIcon = (props)=>$ddbcbff50c42c269$var$_react.default.createElement($ddbcbff50c42c269$var$_shrinkDiagonal.default, Object.assign({
            LEGACY_fallbackIcon: $ddbcbff50c42c269$var$_fitToPage.default
        }, props));
    $ddbcbff50c42c269$var$ShrinkDiagonalIcon.Name = 'ShrinkDiagonalIconMigration';
    var $ddbcbff50c42c269$var$_default = module.exports.default = $ddbcbff50c42c269$var$ShrinkDiagonalIcon;
});
parcelRegister("2bcm3", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $1966313a87133c34$var$_react = $1966313a87133c34$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $1966313a87133c34$var$_shrinkDiagonal = $1966313a87133c34$var$_interopRequireDefault((parcelRequire("8KRBa")));
    function $1966313a87133c34$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $1966313a87133c34$var$MediaServicesFitToPageIcon = (props)=>$1966313a87133c34$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16.413 8.997H18A1 1 0 0 1 18 11h-3.9l-.047-.001a.98.98 0 0 1-.736-.285l-.032-.032A.98.98 0 0 1 13 9.946V6.002a1 1 0 1 1 2 0v1.587l3.309-3.308a.977.977 0 0 1 1.374.005l.032.032a.976.976 0 0 1 .005 1.374zm-8.826 6.006H6A1 1 0 0 1 6 13h3.9l.047.001a.98.98 0 0 1 .736.285l.032.032c.2.2.296.47.284.736l.001.048v3.896a1 1 0 1 1-2 0v-1.587l-3.309 3.308a.977.977 0 0 1-1.374-.005l-.032-.032a.976.976 0 0 1-.005-1.374z"/></svg>`
        }, props, {
            newIcon: $1966313a87133c34$var$_shrinkDiagonal.default
        }));
    $1966313a87133c34$var$MediaServicesFitToPageIcon.displayName = 'MediaServicesFitToPageIcon';
    var $1966313a87133c34$var$_default = module.exports.default = $1966313a87133c34$var$MediaServicesFitToPageIcon;
});
parcelRegister("gydfO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$50014cef8f43c127$export$2e2bcd8739ae039);
    var $7VHMR;
    var $50014cef8f43c127$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        enterFullScreen: {
            "id": "platform.fullscreen-button.enter-full-screen",
            "defaultMessage": "Enter full screen"
        },
        exitFullScreen: {
            "id": "platform.fullscreen-button.exit-full-screen",
            "defaultMessage": "Exit full screen"
        }
    });
});
parcelRegister("ACELo", function(module, exports) {
    $parcel$export(module.exports, "JiraBottomRightCornerOutlet", ()=>$8d24666022201b4c$export$ee54e6ed235df65e);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $7nsd3 = parcelRequire("7nsd3");
    var $heNNl;
    var $hvrWv;
    const $8d24666022201b4c$var$OutletWithPortal = ({ orderFromRight: orderFromRight, children: children, id: id })=>{
        const portalWrapper = (0, $5uXOq.useRef)(document.createElement('div'));
        const container = (0, (0, parcelRequire("hvrWv")).useBottomRightCornerContainer)();
        if (!container) throw new Error('GlobalBottomRightContainer could not be found. Please ensure that this container was rendered on the page.');
        const { insertBottomRightCornerPortal: insertBottomRightCornerPortal, removeBottomRightCornerPortal: removeBottomRightCornerPortal } = (0, (0, parcelRequire("hvrWv")).useBottomRightCornerActions)();
        (0, $5uXOq.useEffect)(()=>{
            if (container) {
                const indexToRender = insertBottomRightCornerPortal({
                    orderFromRight: orderFromRight,
                    id: id
                });
                container.insertBefore(portalWrapper.current, container.children[indexToRender]);
            }
            const portalCurrent = portalWrapper.current;
            return ()=>{
                container?.removeChild(portalCurrent);
                removeBottomRightCornerPortal(id);
            };
        }, [
            container,
            id,
            orderFromRight,
            insertBottomRightCornerPortal,
            removeBottomRightCornerPortal
        ]);
        return (0, $7nsd3.createPortal)((0, ($parcel$interopDefault($5uXOq))).createElement($8d24666022201b4c$var$StyledOutlet, null, children), portalWrapper.current);
    };
    const $8d24666022201b4c$export$ee54e6ed235df65e = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "bottom-right-corner-outlet",
            packageName: "jira-bottom-right-corner-controller",
            extraEventData: {
                portalId: props.id
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8d24666022201b4c$var$OutletWithPortal, props));
    const $8d24666022201b4c$var$StyledOutlet = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1vgl1wug _1ko9pxbi",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("i0XcG", function(module, exports) {
    $parcel$export(module.exports, "RoadmapTodayButton", ()=>$9cc758fb4b37b04e$export$5fc60be363e9a750);
    var $5uXOq = parcelRequire("5uXOq");
    var $8lrJN;
    var $8zOmE;
    var $biT18;
    var $MXbPK;
    const $9cc758fb4b37b04e$export$5fc60be363e9a750 = ()=>{
        const [{ timelineOriginPosition: timelineOriginPosition }] = (0, (0, parcelRequire("biT18")).useTimelineState)();
        const onClickCallback = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'todayButton');
            (0, (0, parcelRequire("MXbPK")).timelineScroller).scrollTo({
                left: timelineOriginPosition
            });
        }, [
            timelineOriginPosition
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8lrJN")).default), {
            onClick: onClickCallback
        });
    };
});
parcelRegister("8lrJN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$62a37da0263bb7b7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $4R6GH;
    var $koVbs;
    var $h61ge;
    const $62a37da0263bb7b7$var$TodayButton = ({ onClick: onClick, testId: testId })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            testId: testId,
            appearance: "subtle",
            onClick: onClick,
            ...(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics') ? {
                interactionName: 'timeline-today-clicked'
            } : {}
        }, formatMessage((0, (0, parcelRequire("h61ge")).default).today));
    };
    var $62a37da0263bb7b7$export$2e2bcd8739ae039 = $62a37da0263bb7b7$var$TodayButton;
});
parcelRegister("h61ge", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$545f7c2e83fc209b$export$2e2bcd8739ae039);
    var $7VHMR;
    var $545f7c2e83fc209b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        today: {
            "id": "aais-timeline-toolbar.today-button.today",
            "defaultMessage": "Today"
        }
    });
});
parcelRegister("MXbPK", function(module, exports) {
    $parcel$export(module.exports, "timelineScroller", ()=>$f56251be9f02e352$export$e3f9523c9658dc67);
    $parcel$export(module.exports, "useTimelineScroller", ()=>$f56251be9f02e352$export$8b6469154a100351);
    var $iZN6h;
    const $f56251be9f02e352$var$scrollTo = ({ left: left, top: top })=>{
        const timelineElem = document.getElementById((0, (0, parcelRequire("iZN6h")).TIMELINE_ID));
        if (timelineElem !== null) {
            if (left !== undefined) timelineElem.scrollLeft = left;
            if (top !== undefined) timelineElem.scrollTop = top;
        }
    };
    const $f56251be9f02e352$var$getScrollLeft = ()=>{
        const timelineElem = document.getElementById((0, (0, parcelRequire("iZN6h")).TIMELINE_ID));
        if (timelineElem !== null) return timelineElem.scrollLeft;
        return 0;
    };
    const $f56251be9f02e352$var$getVisibleWidth = ()=>{
        const timelineElem = document.getElementById((0, (0, parcelRequire("iZN6h")).TIMELINE_ID));
        if (timelineElem !== null) return timelineElem.clientWidth;
        return 0;
    };
    const $f56251be9f02e352$export$e3f9523c9658dc67 = {
        scrollTo: $f56251be9f02e352$var$scrollTo,
        getScrollLeft: $f56251be9f02e352$var$getScrollLeft,
        getVisibleWidth: $f56251be9f02e352$var$getVisibleWidth
    };
    const $f56251be9f02e352$export$8b6469154a100351 = ()=>$f56251be9f02e352$export$e3f9523c9658dc67;
});
parcelRegister("k2DYU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a4818caa9772ed51$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $igBVO;
    var $3sAtt;
    var $aCxG8;
    var $3kWB1;
    var $kVzk2;
    var $7Vbz7;
    var $bos4g;
    var $d14FQ;
    var $koVbs;
    var $2SRav;
    const $a4818caa9772ed51$var$Legend = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const sprintsMessage = formatMessage((0, (0, parcelRequire("2SRav")).default).sprints);
        const dependencyMessage = formatMessage((0, (0, parcelRequire("2SRav")).default).dependency);
        const rollupMessage = formatMessage((0, (0, parcelRequire("2SRav")).default).rollup);
        const noEndDateMessage = formatMessage((0, (0, parcelRequire("2SRav")).default).noEndDate);
        const noStartDateMessage = formatMessage((0, (0, parcelRequire("2SRav")).default).noStartDate);
        const releasedMessage = formatMessage((0, (0, parcelRequire("2SRav")).default).released);
        const unreleasedMessage = formatMessage((0, (0, parcelRequire("2SRav")).default).unreleased);
        const overdueMessage = formatMessage((0, (0, parcelRequire("2SRav")).default).overdue);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3kWB1")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCxG8")).default), {
            title: formatMessage((0, (0, parcelRequire("2SRav")).default).general)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3sAtt")).default), {
            symbol: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("igBVO"))))), {
                LEGACY_size: "medium",
                label: sprintsMessage,
                color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$e2ef2124cf4024b1)})`,
                spacing: "spacious"
            }),
            label: sprintsMessage
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3sAtt")).default), {
            symbol: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kVzk2")).default), {
                label: dependencyMessage
            }),
            label: dependencyMessage
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3sAtt")).default), {
            symbol: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d14FQ")).default), {
                label: rollupMessage
            }),
            label: rollupMessage
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCxG8")).default), {
            title: formatMessage((0, (0, parcelRequire("2SRav")).default).issueBars)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3sAtt")).default), {
            symbol: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7Vbz7")).default), {
                type: "noEndDate"
            }),
            label: noEndDateMessage
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3sAtt")).default), {
            symbol: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7Vbz7")).default), {
                type: "noStartDate"
            }),
            label: noStartDateMessage
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCxG8")).default), {
            title: formatMessage((0, (0, parcelRequire("2SRav")).default).releases)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3sAtt")).default), {
            symbol: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bos4g")).default), {
                type: "released"
            }),
            label: releasedMessage
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3sAtt")).default), {
            symbol: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bos4g")).default), {
                type: "unreleased"
            }),
            label: unreleasedMessage
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3sAtt")).default), {
            symbol: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bos4g")).default), {
                type: "overdue"
            }),
            label: overdueMessage
        })));
    };
    var $a4818caa9772ed51$export$2e2bcd8739ae039 = $a4818caa9772ed51$var$Legend;
});
parcelRegister("3sAtt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7f375155c0b99249$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $7f375155c0b99249$var$LegendItem = ({ symbol: symbol, label: label })=>(0, ($parcel$interopDefault($5uXOq))).createElement($7f375155c0b99249$var$Container, null, (0, ($parcel$interopDefault($5uXOq))).createElement($7f375155c0b99249$var$Symbol, null, symbol), label);
    var $7f375155c0b99249$export$2e2bcd8739ae039 = $7f375155c0b99249$var$LegendItem;
    const $7f375155c0b99249$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _syaz1n3s _zulpu2gc",
                __cmplp.className
            ])
        });
    });
    const $7f375155c0b99249$var$Symbol = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c116y _1ul91tcg _4t3igktf _4cvr1h6o _1bah1h6o",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("aCxG8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5fcbebf23dc9490a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $5fcbebf23dc9490a$var$LegendSection = ({ title: title, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($5fcbebf23dc9490a$var$Container, null, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1gjq _11c816g6 _vwz4v47k"
            ])
        }, title), children);
    var $5fcbebf23dc9490a$export$2e2bcd8739ae039 = $5fcbebf23dc9490a$var$LegendSection;
    const $5fcbebf23dc9490a$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx21bp4 _zulpu2gc",
                __cmplp.className
            ])
        });
    });
    const $5fcbebf23dc9490a$var$TitleStyles = null;
});
parcelRegister("3kWB1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ff29bd41aa013e69$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eCeGD;
    var $42CjB;
    var $2Yv61;
    var $1I7E8;
    var $dC5iT;
    var $luBm6;
    var $8CUq3;
    var $cSD7y;
    var $4R6GH;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $5ojXj;
    var $lq7p7;
    const $ff29bd41aa013e69$var$LegendNew = ({ children: children, appearance: appearance = 'icon', placement: placement = 'top-end', defaultIsOpen: defaultIsOpen = false })=>{
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(defaultIsOpen);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const onClose = (0, $5uXOq.useCallback)(()=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            });
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, 'legend closed');
            setIsOpen(false);
        }, [
            createAnalyticsEvent,
            setIsOpen
        ]);
        const onToggle = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'legendButton');
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, `legend ${isOpen ? 'closed' : 'opened'}`);
            setIsOpen((value)=>!value);
        }, [
            isOpen
        ]);
        const renderTrigger = (0, $5uXOq.useCallback)((triggerProps)=>{
            switch(appearance){
                case 'full':
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eCeGD")).default), {
                        ...triggerProps,
                        isSelected: isOpen,
                        onClick: onToggle,
                        iconBefore: (0, ($parcel$interopDefault((0, parcelRequire("2Yv61"))))),
                        ...(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics') ? {
                            interactionName: 'timeline-legend-trigger-clicked'
                        } : {}
                    }, formatMessage((0, (0, parcelRequire("5ojXj")).default).legend));
                case 'icon':
                default:
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
                        ...triggerProps,
                        isSelected: isOpen,
                        onClick: onToggle,
                        icon: (0, ($parcel$interopDefault((0, parcelRequire("2Yv61"))))),
                        isTooltipDisabled: false,
                        label: formatMessage((0, (0, parcelRequire("5ojXj")).default).legend),
                        tooltip: {
                            position: 'top'
                        },
                        appearance: "subtle",
                        ...(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics') ? {
                            interactionName: 'timeline-legend-trigger-clicked'
                        } : {}
                    });
            }
        }, [
            appearance,
            formatMessage,
            isOpen,
            onToggle
        ]);
        const renderContent = (0, $5uXOq.useCallback)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lq7p7")).default), {
                placement: placement
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $ff29bd41aa013e69$var$legendContentStyles,
                paddingInline: "space.200",
                paddingBlock: "space.250"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
                space: "space.250"
            }, children))), [
            children,
            placement
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).Popup), {
            id: "timeline-legend",
            role: "dialog",
            isOpen: isOpen,
            placement: placement,
            onClose: onClose,
            trigger: renderTrigger,
            content: renderContent,
            label: formatMessage((0, (0, parcelRequire("5ojXj")).default).legend),
            shouldUseCaptureOnOutsideClick: true
        });
    };
    const $ff29bd41aa013e69$var$LegendOld = ({ children: children, defaultIsOpen: defaultIsOpen = false })=>{
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(defaultIsOpen);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const onClose = (0, $5uXOq.useCallback)(()=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            });
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, 'legend closed');
            setIsOpen(false);
        }, [
            createAnalyticsEvent,
            setIsOpen
        ]);
        const onToggle = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'legendButton');
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, `legend ${isOpen ? 'closed' : 'opened'}`);
            setIsOpen((value)=>!value);
        }, [
            isOpen
        ]);
        const renderContent = (0, $5uXOq.useCallback)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lq7p7")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $ff29bd41aa013e69$var$legendContentStyles,
                paddingInline: "space.200",
                paddingBlock: "space.250"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
                space: "space.250"
            }, children))), [
            children
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).Popup), {
            isOpen: isOpen,
            placement: "top-end",
            onClose: onClose,
            trigger: (triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
                    ...triggerProps,
                    isSelected: isOpen,
                    onClick: onToggle,
                    icon: (0, ($parcel$interopDefault((0, parcelRequire("2Yv61"))))),
                    isTooltipDisabled: false,
                    label: formatMessage((0, (0, parcelRequire("5ojXj")).default).legend),
                    tooltip: {
                        position: 'top'
                    },
                    appearance: "subtle",
                    ...(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics') ? {
                        interactionName: 'timeline-legend-trigger-clicked'
                    } : {}
                }),
            content: renderContent,
            label: formatMessage((0, (0, parcelRequire("5ojXj")).default).legend),
            id: "timeline-legend",
            role: "dialog",
            shouldUseCaptureOnOutsideClick: true
        });
    };
    var $ff29bd41aa013e69$export$2e2bcd8739ae039 = (0, (0, parcelRequire("cSD7y")).componentWithFG)('smart_links_for_plans', $ff29bd41aa013e69$var$LegendNew, $ff29bd41aa013e69$var$LegendOld);
    const $ff29bd41aa013e69$var$legendContentStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        boxSizing: 'content-box',
        minWidth: `calc(${"var(--ds-space-100, 8px)"} * 35)`
    });
});
parcelRegister("5ojXj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4294c1079fc57a08$export$2e2bcd8739ae039);
    var $7VHMR;
    var $4294c1079fc57a08$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        legend: {
            "id": "aais-timeline-legend.legend.legend-button.legend",
            "defaultMessage": "Legend"
        }
    });
});
parcelRegister("lq7p7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5de49db51bebb14b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $cSD7y;
    const $5de49db51bebb14b$var$DEFAULT_OFFSET = 24;
    const $5de49db51bebb14b$var$ShrinkToFitNew = ({ children: children, placement: placement = 'top-end' })=>{
        const [offset, setOffset] = (0, $5uXOq.useState)({
            top: $5de49db51bebb14b$var$DEFAULT_OFFSET,
            bottom: $5de49db51bebb14b$var$DEFAULT_OFFSET
        });
        const rootRef = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useLayoutEffect)(()=>{
            const animationFrame = requestAnimationFrame(()=>{
                if (!rootRef.current) return;
                const rect = rootRef.current.getBoundingClientRect();
                const distanceFromTop = rect.top;
                const distanceFromBottom = window.innerHeight - rect.bottom;
                if (placement.startsWith('top')) setOffset({
                    top: $5de49db51bebb14b$var$DEFAULT_OFFSET,
                    bottom: distanceFromBottom
                });
                else setOffset({
                    top: distanceFromTop,
                    bottom: $5de49db51bebb14b$var$DEFAULT_OFFSET
                });
            });
            return ()=>cancelAnimationFrame(animationFrame);
        }, [
            placement
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            ref: rootRef,
            style: {
                maxHeight: `calc(100vh - ${offset.bottom}px - ${offset.top}px)`
            }
        }, children);
    };
    const $5de49db51bebb14b$var$ShrinkToFitOld = ({ children: children })=>{
        const [bottomOffset, setBottomOffset] = (0, $5uXOq.useState)($5de49db51bebb14b$var$DEFAULT_OFFSET);
        const rootRef = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useLayoutEffect)(()=>{
            const animationFrame = requestAnimationFrame(()=>{
                if (!rootRef.current) return;
                const rect = rootRef.current.getBoundingClientRect();
                const distanceFromBottom = window.innerHeight - rect.bottom;
                setBottomOffset(distanceFromBottom);
            });
            return ()=>cancelAnimationFrame(animationFrame);
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            ref: rootRef,
            style: {
                maxHeight: `calc(100vh - ${bottomOffset}px - ${$5de49db51bebb14b$var$DEFAULT_OFFSET}px)`
            }
        }, children);
    };
    var $5de49db51bebb14b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("cSD7y")).componentWithFG)('smart_links_for_plans', $5de49db51bebb14b$var$ShrinkToFitNew, $5de49db51bebb14b$var$ShrinkToFitOld);
});
parcelRegister("kVzk2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$52379331d4ac5ab1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $7WxSP;
    const $52379331d4ac5ab1$var$DependenciesIcon = ({ label: label, withWarning: withWarning = false })=>withWarning ? (0, ($parcel$interopDefault($5uXOq))).createElement($52379331d4ac5ab1$var$Container, {
            backgroundColor: `var(--ds-background-danger, ${(0, $829f609a65d26a98$export$4b84fd0e2c617bd)})`
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7WxSP"))))), {
            size: "medium",
            key: "dependencies",
            label: label,
            primaryColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7WxSP"))))), {
            size: "medium",
            key: "dependencies",
            label: label
        });
    var $52379331d4ac5ab1$export$2e2bcd8739ae039 = $52379331d4ac5ab1$var$DependenciesIcon;
    const $52379331d4ac5ab1$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { backgroundColor: backgroundColor, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1hphqkz": (0, (0, parcelRequire("lD23V")).default)(__cmplp.backgroundColor)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz15cr _bfhk3qkl _1bsbgktf _4t3igktf _1e0c1txw _4cvr1h6o _1bah1h6o _2rko1osq _vchhusvi _1reo15vq _18m915vq",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("7WxSP", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $5c883bb6fff27f31$var$_react = $5c883bb6fff27f31$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $5c883bb6fff27f31$var$_link = $5c883bb6fff27f31$var$_interopRequireDefault((parcelRequire("1f9bV")));
    function $5c883bb6fff27f31$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $5c883bb6fff27f31$var$EditorLinkIcon = (props)=>$5c883bb6fff27f31$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12.654 8.764a.858.858 0 0 1-1.213-1.213l1.214-1.214a3.717 3.717 0 0 1 5.257 0 3.714 3.714 0 0 1 .001 5.258l-1.214 1.214-.804.804a3.72 3.72 0 0 1-5.263.005.858.858 0 0 1 1.214-1.214c.781.782 2.05.78 2.836-.005l.804-.803 1.214-1.214a2 2 0 0 0-.001-2.831 2 2 0 0 0-2.83 0zm-.808 6.472a.858.858 0 0 1 1.213 1.213l-1.214 1.214a3.717 3.717 0 0 1-5.257 0 3.714 3.714 0 0 1-.001-5.258l1.214-1.214.804-.804a3.72 3.72 0 0 1 5.263-.005.858.858 0 0 1-1.214 1.214 2.005 2.005 0 0 0-2.836.005l-.804.803L7.8 13.618a2 2 0 0 0 .001 2.831 2 2 0 0 0 2.83 0z"/></svg>`
        }, props, {
            newIcon: $5c883bb6fff27f31$var$_link.default
        }));
    $5c883bb6fff27f31$var$EditorLinkIcon.displayName = 'EditorLinkIcon';
    var $5c883bb6fff27f31$var$_default = module.exports.default = $5c883bb6fff27f31$var$EditorLinkIcon;
});
parcelRegister("7Vbz7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$83cb82dc26d6c7bc$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $83cb82dc26d6c7bc$var$getIssueBarContents = (type)=>{
        const color = `var(--ds-background-accent-gray-bolder, ${(0, $829f609a65d26a98$export$e2ef2124cf4024b1)})`;
        switch(type){
            case 'noStartDate':
                return (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
                    width: "53",
                    height: "16",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("defs", null, (0, ($parcel$interopDefault($5uXOq))).createElement("linearGradient", {
                    id: "noStartDate",
                    gradientUnits: "userSpaceOnUse"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
                    stopColor: color,
                    stopOpacity: "0"
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
                    offset: ".75",
                    stopColor: color
                }))), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
                    width: "53",
                    height: "16",
                    rx: "3",
                    fill: "url(#noStartDate)"
                }));
            case 'noEndDate':
                return (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
                    width: "53",
                    height: "16",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("defs", null, (0, ($parcel$interopDefault($5uXOq))).createElement("linearGradient", {
                    id: "noEndDate",
                    gradientUnits: "userSpaceOnUse"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
                    offset: "0.25",
                    stopColor: color
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
                    offset: "1",
                    stopColor: color,
                    stopOpacity: "0"
                }))), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
                    width: "53",
                    height: "16",
                    rx: "3",
                    fill: "url(#noEndDate)"
                }));
            case 'rollupDates':
                return (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
                    width: "53",
                    height: "16",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("defs", null, (0, ($parcel$interopDefault($5uXOq))).createElement("pattern", {
                    id: "rollupDates",
                    patternUnits: "userSpaceOnUse",
                    width: "12",
                    height: "12",
                    x: "6",
                    y: "0",
                    patternTransform: "rotate(27.5)"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("line", {
                    x1: "3",
                    y1: "0",
                    x2: "3",
                    y2: "12",
                    opacity: "0.5",
                    stroke: `var(--ds-background-accent-gray-subtler, ${(0, $829f609a65d26a98$export$c2e91cbeada39b8b)})`,
                    strokeWidth: "6"
                }))), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
                    width: "53",
                    height: "16",
                    rx: "3",
                    fill: color
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
                    width: "53",
                    height: "16",
                    rx: "3",
                    fill: "url(#rollupDates)"
                }));
            default:
                return (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
                    width: "53",
                    height: "16",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
                    width: "53",
                    height: "16",
                    rx: "3",
                    fill: color
                }));
        }
    };
    const $83cb82dc26d6c7bc$var$IssueBarIcon = ({ type: type })=>$83cb82dc26d6c7bc$var$getIssueBarContents(type);
    var $83cb82dc26d6c7bc$export$2e2bcd8739ae039 = $83cb82dc26d6c7bc$var$IssueBarIcon;
});
parcelRegister("bos4g", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b88fff45a0e514a5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $cGbU6;
    var $f22iM;
    var $7XYc4;
    var $4R6GH;
    var $dCm1o;
    const $b88fff45a0e514a5$var$getIconColor = (type)=>{
        switch(type){
            case 'released':
                return `var(--ds-icon-success, ${0, $829f609a65d26a98$export$a49394138f7b8e85})`;
            case 'unreleased':
                return `var(--ds-icon-information, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
            case 'overdue':
            case 'overdue-arj':
            default:
                return `var(--ds-icon-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`;
        }
    };
    const $b88fff45a0e514a5$var$getIconContents = (type)=>{
        switch(type){
            case 'released':
                return (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
                    width: "16",
                    height: "16",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    d: "M11.707 6.707a1 1 0 0 0-1.414-1.414L7 8.586 5.707 7.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4Z",
                    fill: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`
                }));
            case 'overdue':
                return (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
                    width: "16",
                    height: "16",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    d: "M7 4a1 1 0 0 1 2 0v4a1 1 0 0 1-2 0V4Zm1 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
                    fill: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`
                }));
            case 'overdue-arj':
                return (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
                    width: "16",
                    height: "16",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
                    x: "4",
                    y: "7",
                    width: "8",
                    height: "2",
                    rx: "1",
                    fill: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`
                }));
            case 'unreleased':
            default:
                return undefined;
        }
    };
    const $b88fff45a0e514a5$var$ReleaseStatusIconOld = ({ type: type })=>(0, ($parcel$interopDefault($5uXOq))).createElement($b88fff45a0e514a5$var$Container, {
            backgroundColor: $b88fff45a0e514a5$var$getIconColor(type)
        }, $b88fff45a0e514a5$var$getIconContents(type));
    const $b88fff45a0e514a5$var$ReleaseStatusIcon = ({ type: type })=>{
        switch(type){
            case 'released':
                return (0, ($parcel$interopDefault($5uXOq))).createElement($b88fff45a0e514a5$var$Container, {
                    backgroundColor: $b88fff45a0e514a5$var$getIconColor(type)
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("f22iM"))))), {
                    label: "",
                    color: "currentColor"
                }));
            case 'overdue':
                return (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
                    width: "16",
                    height: "16",
                    viewBox: "0 0 16 16",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M0.0175781 8C0.0175478 12.4085 3.59133 15.9823 7.99981 15.9823C12.4083 15.9823 15.9821 12.4085 15.982 8C15.982 3.59155 12.4083 0.0178225 7.99981 0.0178223C3.59136 0.017822 0.0176084 3.59155 0.0175781 8ZM7.24981 9V3.75H8.74981V9H7.24981ZM7.99981 12.25C8.5521 12.25 8.99981 11.8023 8.99981 11.25C8.99981 10.6977 8.5521 10.25 7.99981 10.25C7.44753 10.25 6.99981 10.6977 6.99981 11.25C6.99981 11.8023 7.44753 12.25 7.99981 12.25Z",
                    fill: $b88fff45a0e514a5$var$getIconColor(type)
                }));
            case 'overdue-arj':
                return (0, ($parcel$interopDefault($5uXOq))).createElement($b88fff45a0e514a5$var$Container, {
                    backgroundColor: $b88fff45a0e514a5$var$getIconColor(type)
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("cGbU6"))))), {
                    label: "",
                    color: "currentColor"
                }));
            case 'unreleased':
                return (0, ($parcel$interopDefault($5uXOq))).createElement($b88fff45a0e514a5$var$Container, {
                    backgroundColor: $b88fff45a0e514a5$var$getIconColor(type)
                });
            default:
                return undefined;
        }
    };
    var $b88fff45a0e514a5$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap_drop_2'), $b88fff45a0e514a5$var$ReleaseStatusIcon, $b88fff45a0e514a5$var$ReleaseStatusIconOld);
    const $b88fff45a0e514a5$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { backgroundColor: backgroundColor, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1hphqkz": (0, (0, parcelRequire("lD23V")).default)(__cmplp.backgroundColor)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz15cr _bfhk3qkl _1bsb7vkz _4t3i7vkz _1e0c1txw _4cvr1h6o _1bah1h6o _2rko1osq _vchhusvi _1reo15vq _18m915vq",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("cGbU6", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $93b2a42556cf480d$var$_react = $93b2a42556cf480d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $93b2a42556cf480d$var$_UNSAFE_baseNew = $93b2a42556cf480d$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $93b2a42556cf480d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $93b2a42556cf480d$var$MinusIcon = (props)=>$93b2a42556cf480d$var$_react.default.createElement($93b2a42556cf480d$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M2 8h12"/>`
        }, props));
    $93b2a42556cf480d$var$MinusIcon.displayName = 'MinusIcon';
    var $93b2a42556cf480d$var$_default = module.exports.default = $93b2a42556cf480d$var$MinusIcon;
});
parcelRegister("d14FQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6d07f6596a5e169b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    const $6d07f6596a5e169b$var$getIconContents = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "24",
            height: "24",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "m14.586 9-2.293-2.293a1 1 0 1 1 1.414-1.414l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L14.586 11H10a1 1 0 0 0-1 1v7a1 1 0 1 1-2 0v-7a3 3 0 0 1 3-3h4.586Z",
            fill: "currentColor"
        }));
    const $6d07f6596a5e169b$var$RollupIcon = ({ label: label })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            glyph: $6d07f6596a5e169b$var$getIconContents,
            size: "medium",
            label: label,
            primaryColor: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$e2ef2124cf4024b1)})`
        });
    var $6d07f6596a5e169b$export$2e2bcd8739ae039 = $6d07f6596a5e169b$var$RollupIcon;
});
parcelRegister("2SRav", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$caa339d27fb62fe7$export$2e2bcd8739ae039);
    var $7VHMR;
    var $caa339d27fb62fe7$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        general: {
            "id": "roadmap.standard-roadmap.common.table.chart-overlay.overlay-button.legend.general",
            "defaultMessage": "General"
        },
        issueBars: {
            "id": "roadmap.standard-roadmap.common.table.chart-overlay.overlay-button.legend.issue-bars",
            "defaultMessage": "Issue bars"
        },
        releases: {
            "id": "roadmap.standard-roadmap.common.table.chart-overlay.overlay-button.legend.releases",
            "defaultMessage": "Releases"
        },
        sprints: {
            "id": "roadmap.standard-roadmap.common.table.chart-overlay.overlay-button.legend.sprints",
            "defaultMessage": "Sprints"
        },
        dependency: {
            "id": "roadmap.standard-roadmap.common.table.chart-overlay.overlay-button.legend.dependency",
            "defaultMessage": "Dependency"
        },
        rollup: {
            "id": "roadmap.standard-roadmap.common.table.chart-overlay.overlay-button.legend.rollup",
            "defaultMessage": "Inferred value (roll-up)"
        },
        noEndDate: {
            "id": "roadmap.standard-roadmap.common.table.chart-overlay.overlay-button.legend.no-end-date",
            "defaultMessage": "No end date"
        },
        noStartDate: {
            "id": "roadmap.standard-roadmap.common.table.chart-overlay.overlay-button.legend.no-start-date",
            "defaultMessage": "No start date"
        },
        released: {
            "id": "roadmap.standard-roadmap.common.table.chart-overlay.overlay-button.legend.released",
            "defaultMessage": "Released"
        },
        unreleased: {
            "id": "roadmap.standard-roadmap.common.table.chart-overlay.overlay-button.legend.unreleased",
            "defaultMessage": "Unreleased"
        },
        overdue: {
            "id": "roadmap.standard-roadmap.common.table.chart-overlay.overlay-button.legend.overdue",
            "defaultMessage": "Overdue"
        }
    });
});
parcelRegister("fwO2i", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$556457f2015ed936$export$2e2bcd8739ae039);
    var $bC2fB;
    var $dL11T;
    var $9QFr0;
    const $556457f2015ed936$var$onClick = (timelineMode)=>(0, (0, parcelRequire("9QFr0")).setTimelineMode)(timelineMode);
    var $556457f2015ed936$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)(null, {
        onClick: $556457f2015ed936$var$onClick
    })((0, (0, parcelRequire("dL11T")).RoadmapTimelineMode));
});
parcelRegister("dL11T", function(module, exports) {
    $parcel$export(module.exports, "RoadmapTimelineMode", ()=>$0d19feb93646d416$export$d1eb62afe3c5898c);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $eTXmK;
    var $lfTZh;
    var $iZN6h;
    var $biT18;
    var $kxZPA;
    var $lrbz9;
    var $8FJpd;
    const $0d19feb93646d416$var$LazyTimelineModeSwitcher = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("2lH7Q")), {
        moduleId: "./src/packages/aais/timeline-toolbar/src/ui/timeline-mode-switcher/index.tsx"
    });
    const $0d19feb93646d416$var$MODE_DESCRIPTORS = [
        {
            type: (0, (0, parcelRequire("iZN6h")).WEEKS),
            title: (0, (0, parcelRequire("lrbz9")).default).weeks
        },
        {
            type: (0, (0, parcelRequire("iZN6h")).MONTHS),
            title: (0, (0, parcelRequire("lrbz9")).default).months
        },
        {
            type: (0, (0, parcelRequire("iZN6h")).QUARTERS),
            title: (0, (0, parcelRequire("lrbz9")).default).quarters
        }
    ];
    const $0d19feb93646d416$var$timelineModeContainerStyles = null;
    const $0d19feb93646d416$export$d1eb62afe3c5898c = ({ onClick: onClick, withContainerStyles: withContainerStyles = false })=>{
        const [{ timelineMode: timelineMode }] = (0, (0, parcelRequire("biT18")).useTimelineState)();
        const changeMode = (0, $5uXOq.useCallback)((mode, event)=>{
            (0, (0, parcelRequire("eTXmK")).default)('timeline-mode', event.timeStamp);
            onClick(mode);
        }, [
            onClick
        ]);
        const element = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "timeline-mode-switcher",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8FJpd")).default), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($0d19feb93646d416$var$LazyTimelineModeSwitcher, {
            modes: $0d19feb93646d416$var$MODE_DESCRIPTORS,
            onModeChange: changeMode,
            currentMode: timelineMode
        }));
        return withContainerStyles ? (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c116y _bfhk1bhr _16qsrs09 _2rko1l7b _1ul91lit _1yt41b66"
            ])
        }, element) : element;
    };
});
parcelRegister("lrbz9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$31adc5c8e68efe7b$export$2e2bcd8739ae039);
    var $7VHMR;
    var $31adc5c8e68efe7b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        weeks: {
            "id": "roadmap.timeline-table-kit.chart-overlay.timeline-mode.weeks",
            "defaultMessage": "Weeks"
        },
        months: {
            "id": "roadmap.timeline-table-kit.chart-overlay.timeline-mode.months",
            "defaultMessage": "Months"
        },
        quarters: {
            "id": "roadmap.timeline-table-kit.chart-overlay.timeline-mode.quarters",
            "defaultMessage": "Quarters"
        }
    });
});
parcelRegister("8FJpd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c3642ee154acff7a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $1wbtX;
    const $c3642ee154acff7a$var$TimelineModeSwitcherSkeleton = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($c3642ee154acff7a$var$Container, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1wbtX")).Skeleton), {
            width: "74px",
            height: "32px"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1wbtX")).Skeleton), {
            width: "74px",
            height: "32px"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1wbtX")).Skeleton), {
            width: "74px",
            height: "32px"
        }));
    var $c3642ee154acff7a$export$2e2bcd8739ae039 = $c3642ee154acff7a$var$TimelineModeSwitcherSkeleton;
    const $c3642ee154acff7a$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _zulp1b66",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("2lH7Q", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("19PNG")
    ]).then(()=>parcelRequire('gskNf'));
});
parcelRegister("cONT5", function(module, exports) {
    $parcel$export(module.exports, "getPreviewProps", ()=>$d57c263d999000dd$export$746e70e91ead5d94);
    const $d57c263d999000dd$export$746e70e91ead5d94 = ({ clientOffset: clientOffset, scrollOffset: scrollOffset, item: item })=>{
        if (!item) return undefined;
        const { id: id, barRect: barRect, leftPosition: leftPosition, viewportBoundingRect: viewportBoundingRect, requestViewportScrollBounding: requestViewportScrollBounding } = item;
        const scrollBounding = requestViewportScrollBounding();
        return {
            id: id,
            x0: leftPosition - scrollBounding.scrollLeft,
            y0: barRect.top + barRect.height / 2 - viewportBoundingRect.top + scrollOffset.scrollTop,
            x: clientOffset.x - viewportBoundingRect.left,
            y: clientOffset.y - viewportBoundingRect.top,
            width: viewportBoundingRect.width,
            height: viewportBoundingRect.height
        };
    };
});
parcelRegister("cToNg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f40d52bb252f0695$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bC2fB;
    var $8TimZ;
    var $hhYQB;
    var $bM42j;
    var $7DdOi;
    var $9memv;
    var $iqjfM;
    var $eMI6k;
    const $f40d52bb252f0695$var$renderers = {
        renderDependencyLines: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqjfM")).default), null),
        renderDependencyFlyout: (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9memv")).default), props),
        renderContextMenu: (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7DdOi")).default), props),
        renderHighlightLines: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eMI6k")).default), null)
    };
    var $f40d52bb252f0695$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((state)=>{
        const tooltip = (0, (0, parcelRequire("bM42j")).getTooltipParams)(state);
        return {
            ...$f40d52bb252f0695$var$renderers,
            type: tooltip?.type,
            id: tooltip && 'id' in tooltip ? tooltip.id.toString() : undefined,
            position: tooltip?.position,
            isDependenciesVisible: (0, (0, parcelRequire("hhYQB")).isDependenciesVisible)(state)
        };
    }, {})((0, (0, parcelRequire("8TimZ")).RoadmapChartTimelineOverlay));
});
parcelRegister("8TimZ", function(module, exports) {
    $parcel$export(module.exports, "RoadmapChartTimelineOverlay", ()=>$c36334e492ce3d03$export$8858e3c7842aaf2);
    var $5uXOq = parcelRequire("5uXOq");
    var $2KlaV;
    const $c36334e492ce3d03$export$8858e3c7842aaf2 = ({ id: id, position: position, type: type, isDependenciesVisible: isDependenciesVisible, renderDependencyFlyout: renderDependencyFlyout, renderDependencyLines: renderDependencyLines, renderHighlightLines: renderHighlightLines, renderContextMenu: renderContextMenu })=>{
        const renderFlyout = ()=>{
            if (id !== undefined && type !== undefined && position !== undefined) switch(type){
                case 0, $12de84cd008e33eb$export$4b680a32bbb87a28:
                    return renderDependencyFlyout({
                        id: id,
                        position: position
                    });
                case 0, $12de84cd008e33eb$export$a9487b0be9740846:
                    return renderContextMenu({
                        id: id,
                        position: position
                    });
                default:
                    return null;
            }
            return null;
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, renderFlyout(), isDependenciesVisible && renderDependencyLines(), renderHighlightLines());
    };
    $c36334e492ce3d03$export$8858e3c7842aaf2.defaultProps = {
        renderDependencyFlyout: (0, (0, parcelRequire("2KlaV")).DEFAULT_RENDERER),
        renderDependencyLines: (0, (0, parcelRequire("2KlaV")).DEFAULT_RENDERER),
        renderHighlightLines: (0, (0, parcelRequire("2KlaV")).DEFAULT_RENDERER),
        renderContextMenu: (0, (0, parcelRequire("2KlaV")).DEFAULT_RENDERER)
    };
});
parcelRegister("7DdOi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2267f27e927b7822$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $lfTZh;
    var $kxZPA;
    var $eKt4x;
    const $2267f27e927b7822$var$ContextMenu = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("3WD8i")), {
        ssr: false,
        moduleId: "./src/packages/software/roadmap/standard/src/view/common/table/chart-timeline-overlay/context-menu/index.tsx"
    });
    var $2267f27e927b7822$export$2e2bcd8739ae039 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "async-standard-roadmap-context-menu",
            packageName: (0, (0, parcelRequire("eKt4x")).ROADMAP_PACKAGE_NAME),
            fallback: "flag"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "standard-roadmap-context-menu",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($2267f27e927b7822$var$ContextMenu, props)));
});
parcelRegister("3WD8i", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("dCJZI").then(()=>parcelRequire('apO7q'));
});
parcelRegister("9memv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3a0f921444e5ca02$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $lfTZh;
    var $kxZPA;
    var $eKt4x;
    const $3a0f921444e5ca02$var$DependencyTooltip = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("19iuB")), {
        ssr: false,
        moduleId: "./src/packages/software/roadmap/standard/src/view/common/table/chart-timeline-overlay/dependency-flyout/index.tsx"
    });
    var $3a0f921444e5ca02$export$2e2bcd8739ae039 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "async-standard-roadmap-dependency-tooltip",
            packageName: (0, (0, parcelRequire("eKt4x")).ROADMAP_PACKAGE_NAME),
            fallback: "flag"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "standard-roadmap-dependency-tooltip",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($3a0f921444e5ca02$var$DependencyTooltip, props)));
});
parcelRegister("19iuB", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("klfT1").then(()=>parcelRequire('azq4q'));
});
parcelRegister("iqjfM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a9d361410e774e32$export$2e2bcd8739ae039);
    var $bC2fB;
    var $6mo8w;
    var $5FvOv;
    var $lEiof;
    const $a9d361410e774e32$var$mapStateToProps = (state)=>({
            dependencies: (0, (0, parcelRequire("5FvOv")).getDependenciesItems)(state),
            selectedDependency: (0, (0, parcelRequire("5FvOv")).getSelectedDependency)(state)
        });
    const $a9d361410e774e32$var$onDependencyClick = ({ toId: toId, fromId: fromId }, position)=>(0, (0, parcelRequire("lEiof")).showToolTip)({
            id: fromId,
            type: (0, $12de84cd008e33eb$export$4b680a32bbb87a28),
            links: {
                fromIds: [],
                toIds: [
                    toId
                ]
            },
            position: position,
            showImplicitDependency: false
        });
    const $a9d361410e774e32$var$mapDispatchToProps = {
        onDependencyClick: $a9d361410e774e32$var$onDependencyClick
    };
    var $a9d361410e774e32$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($a9d361410e774e32$var$mapStateToProps, $a9d361410e774e32$var$mapDispatchToProps)((0, (0, parcelRequire("6mo8w")).RoadmapDependencyLines));
});
parcelRegister("6mo8w", function(module, exports) {
    $parcel$export(module.exports, "RoadmapDependencyLines", ()=>$eb164e7806d6b08e$export$ef4d1c7f7fde068f);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $c32Ax;
    var $biT18;
    var $h5d6K;
    const $eb164e7806d6b08e$var$containerStyles = null;
    const $eb164e7806d6b08e$export$ef4d1c7f7fde068f = ({ dependencies: dependencies, selectedDependency: selectedDependency, onDependencyClick: onDependencyClick })=>{
        const [{ timelineDuration: timelineDuration, timelineWidth: timelineWidth }] = (0, (0, parcelRequire("biT18")).useTimelineState)();
        const dependenciesWithPositionsAndIsOverlap = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("h5d6K")).getDependenciesWithPositions)(dependencies, timelineDuration, timelineWidth), [
            dependencies,
            timelineDuration,
            timelineWidth
        ]);
        const onHandleDependencyClick = ({ pageX: pageX, pageY: pageY }, { toId: toId, fromId: fromId })=>{
            onDependencyClick && onDependencyClick({
                toId: toId,
                fromId: fromId
            }, {
                x: pageX,
                y: pageY
            });
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1pbycs5v"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c32Ax")).default), {
            dependencies: dependenciesWithPositionsAndIsOverlap,
            selectedDependency: selectedDependency,
            onDependencyClick: onHandleDependencyClick
        }));
    };
    $eb164e7806d6b08e$export$ef4d1c7f7fde068f.defaultProps = {
        selectedDependency: undefined
    };
});
parcelRegister("c32Ax", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$abcd90738f5b2cb5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $47bDC = parcelRequire("47bDC");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $9cikT;
    const $abcd90738f5b2cb5$var$SvgOverlay = ({ dependencies: dependencies, selectedDependency: selectedDependency, onDependencyClick: onDependencyClick })=>{
        const selectedDependencyLine = selectedDependency && dependencies.find((dependency)=>dependency.from.id === selectedDependency.fromId && dependency.to.id === selectedDependency.toId && dependency.from.indexOnScope === selectedDependency.fromIndex && dependency.to.indexOnScope === selectedDependency.toIndex);
        return ((0, ($parcel$interopDefault($5uXOq))).createElement($abcd90738f5b2cb5$var$SvgContainer, {
            className: (0, $0afb8a62e53619f1$export$1e54f8b472a07d8d)
        }, dependencies.map((dependency)=>{
            if (dependency !== selectedDependencyLine) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9cikT")).default), {
                key: `${dependency.from.id}-${dependency.to.id}-${dependency.from.y}-${dependency.to.y}`,
                ...dependency,
                onClick: onDependencyClick,
                isSelected: false
            });
            return null;
        }), selectedDependencyLine && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9cikT")).default), {
            ...selectedDependencyLine,
            onClick: onDependencyClick,
            isSelected: true
        })));
    };
    $abcd90738f5b2cb5$var$SvgOverlay.defaultProps = {
        selectedDependency: undefined,
        onDependencyClick: (0, ($parcel$interopDefault($8Rkzz))),
        dependencies: []
    };
    var $abcd90738f5b2cb5$export$2e2bcd8739ae039 = $abcd90738f5b2cb5$var$SvgOverlay;
    const $abcd90738f5b2cb5$var$SvgContainer = (0, $47bDC.default).svg.withConfig({
        componentId: "sc-7b34v9-0"
    })({
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        transition: 'opacity 0.2s ease-in-out',
        overflow: 'visible',
        pointerEvents: 'none'
    });
});
const $0afb8a62e53619f1$export$1e54f8b472a07d8d = 'dependencies-overlay';
const $0afb8a62e53619f1$export$cd944e09ecad5145 = 'dependency-line';
parcelRegister("9cikT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7dcd03412ef5592d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $ajpes = parcelRequire("ajpes");
    var $eTXmK;
    var $3bDjY;
    var $koVbs;
    var $iHPnC;
    var $8zOmE;
    var $2NMNM;
    var $eGwbr;
    var $6k94P;
    const $7dcd03412ef5592d$var$DependencyLine = ({ from: from, to: to, itemHeight: itemHeight, isOverlapping: isOverlapping, isSelected: isSelected, onClick: onClick })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [isHovered, setIsHovered] = (0, $5uXOq.useState)(false);
        const onPathClick = (0, $5uXOq.useCallback)((event)=>{
            (0, (0, parcelRequire("eTXmK")).default)('timeline-dependency-clicked', event.timeStamp);
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'line'
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'dependencyLine', {
                isOverlapping: isOverlapping
            });
            onClick(event, {
                fromId: from.id,
                toId: to.id,
                isOverlapping: isOverlapping,
                fromIndexOnScope: from.indexOnScope,
                toIndexOnScope: to.indexOnScope
            });
        }, [
            createAnalyticsEvent,
            isOverlapping,
            from,
            to,
            onClick
        ]);
        const onPathMouseEnter = (0, $5uXOq.useCallback)(()=>{
            setIsHovered(true);
        }, []);
        const onPathMouseLeave = (0, $5uXOq.useCallback)(()=>{
            setIsHovered(false);
        }, []);
        const path = (0, (0, parcelRequire("6k94P")).getPath)(from, to, itemHeight);
        const gradientId = `linear-gradient-${from.id}-${to.id}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (isHovered || isSelected) && (0, ($parcel$interopDefault($5uXOq))).createElement("linearGradient", {
            id: gradientId,
            x1: from.x,
            x2: to.x,
            y1: from.y,
            y2: to.y,
            gradientUnits: "userSpaceOnUse"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0%",
            stopColor: (0, (0, parcelRequire("iHPnC")).getValueFromColor)(from.color)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "100%",
            stopColor: (0, (0, parcelRequire("iHPnC")).getValueFromColor)(to.color)
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: path,
            fill: "transparent",
            strokeWidth: "2",
            stroke: $7dcd03412ef5592d$export$a73db48ef11a2bc3({
                isOverlapping: isOverlapping,
                isSelected: isSelected,
                isHovered: isHovered,
                gradientId: gradientId
            }),
            pointerEvents: "none",
            "data-testid": "aais-dependency-lines-overlay.common.ui.line.dependency-line"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            position: "mouse",
            mousePosition: "top",
            content: formatMessage((0, (0, parcelRequire("eGwbr")).default).viewDetail),
            tag: "g"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($7dcd03412ef5592d$var$InteractivePath, {
            className: (0, $0afb8a62e53619f1$export$cd944e09ecad5145),
            d: path,
            stroke: "transparent",
            strokeWidth: "9",
            fill: "none",
            cursor: "pointer",
            onClick: onPathClick,
            onMouseEnter: onPathMouseEnter,
            onMouseLeave: onPathMouseLeave,
            "data-testid": "aais-dependency-lines-overlay.common.ui.line.interactive-path"
        })));
    };
    $7dcd03412ef5592d$var$DependencyLine.whyDidYouRender = true;
    var $7dcd03412ef5592d$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($7dcd03412ef5592d$var$DependencyLine, (0, ($parcel$interopDefault($ajpes))));
    const $7dcd03412ef5592d$var$InteractivePath = (0, $5uXOq.forwardRef)(({ as: C = "path", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_lcxv1yxs",
                __cmplp.className
            ])
        });
    });
    const $7dcd03412ef5592d$export$a73db48ef11a2bc3 = ({ isOverlapping: isOverlapping, isSelected: isSelected, isHovered: isHovered, gradientId: gradientId })=>{
        const isHighlighted = isSelected || isHovered;
        if (isOverlapping) {
            if (isHighlighted) return `var(--ds-background-danger-bold-hovered, ${(0, $829f609a65d26a98$exports).R500})`;
            return `var(--ds-background-danger-bold, ${(0, $829f609a65d26a98$exports).R300})`;
        }
        if (isHighlighted) return `url(#${gradientId})`;
        return `var(--ds-border-bold, ${(0, $829f609a65d26a98$exports).N50})`;
    };
});
parcelRegister("eGwbr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$188f0fa73c4b9066$export$2e2bcd8739ae039);
    var $7VHMR;
    var $188f0fa73c4b9066$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        viewDetail: {
            "id": "aais-dependency-lines-overlay.common.line.view-detail",
            "defaultMessage": "View dependency detail"
        }
    });
});
parcelRegister("6k94P", function(module, exports) {
    $parcel$export(module.exports, "getPath", ()=>$eb5c0917a150e0bd$export$2aa3fd96c49a84a8);
    var $8QpSo;
    const $eb5c0917a150e0bd$var$calculateMidPoint = (from, to)=>({
            x: (from.x + to.x) / 2,
            y: (from.y + to.y) / 2
        });
    const $eb5c0917a150e0bd$var$getY = (p1, p2, x)=>{
        const m = (p2.y - p1.y) / (p2.x - p1.x);
        return m * (x - p1.x) + p1.y;
    };
    const $eb5c0917a150e0bd$var$generateSegment = (start, end, offset)=>{
        const c1 = {
            x: start.x + offset.x,
            y: start.y
        };
        const c2 = {
            x: start.x + offset.x,
            y: start.y + offset.y
        };
        const s1 = {
            x: start.x,
            y: $eb5c0917a150e0bd$var$getY(c2, end, start.x)
        };
        return `M${start.x} ${start.y} C${c1.x} ${c1.y} ${c2.x} ${c2.y} ${s1.x} ${s1.y} L${s1.x} ${s1.y} ${end.x} ${end.y}`;
    };
    const $eb5c0917a150e0bd$var$getSegmentOffsets = (from, to, halfItemHeight)=>{
        const fromOffset = {
            x: halfItemHeight,
            y: from.y <= to.y ? halfItemHeight : -halfItemHeight
        };
        const toOffset = {
            x: -fromOffset.x,
            y: -fromOffset.y
        };
        return [
            fromOffset,
            toOffset
        ];
    };
    const $eb5c0917a150e0bd$var$generateComplexPath = (from, to, halfItemHeight)=>{
        const middle = $eb5c0917a150e0bd$var$calculateMidPoint(from, to);
        const [fromOffset, toOffset] = $eb5c0917a150e0bd$var$getSegmentOffsets(from, to, halfItemHeight);
        return `${$eb5c0917a150e0bd$var$generateSegment(from, middle, fromOffset)} ${$eb5c0917a150e0bd$var$generateSegment(to, middle, toOffset)}`;
    };
    const $eb5c0917a150e0bd$var$generateSinglePath = (from, to, itemHeight)=>{
        const diffX = Math.abs(from.x - to.x);
        const progression = itemHeight + diffX * 0.1;
        return `M${from.x} ${from.y} C${from.x + progression} ${from.y} ${to.x - progression} ${to.y} ${to.x} ${to.y}`;
    };
    const $eb5c0917a150e0bd$export$2aa3fd96c49a84a8 = (0, (0, parcelRequire("8QpSo")).default)((from, to, itemHeight)=>from.x > to.x ? $eb5c0917a150e0bd$var$generateComplexPath(from, to, itemHeight / 2) : $eb5c0917a150e0bd$var$generateSinglePath(from, to, itemHeight));
});
parcelRegister("h5d6K", function(module, exports) {
    $parcel$export(module.exports, "getDependenciesWithPositions", ()=>$87e96561891a7532$export$2503ae09d0c5f74);
    var $esmwW;
    var $apjDv;
    var $5VKn0;
    const $87e96561891a7532$export$2503ae09d0c5f74 = (dependencies, timelineDuration, timelineWidth)=>dependencies.map(({ itemHeight: itemHeight, from: from, to: to })=>({
                isOverlapping: (0, (0, parcelRequire("5VKn0")).isDependencyDatesOverlapping)(undefined, from.dueDate, to.startDate, undefined),
                itemHeight: itemHeight,
                to: {
                    id: to.id,
                    y: to.y,
                    x: (0, (0, parcelRequire("apjDv")).getBarLeftPosition)(to.startDate, timelineDuration, timelineWidth),
                    color: to.color
                },
                from: {
                    id: from.id,
                    y: from.y,
                    x: (0, (0, parcelRequire("apjDv")).getBarLeftPosition)(from.dueDate + (0, (0, parcelRequire("esmwW")).DUE_DATE_OFFSET), timelineDuration, timelineWidth),
                    color: from.color
                }
            }));
});
parcelRegister("5VKn0", function(module, exports) {
    $parcel$export(module.exports, "isDependencyDatesOverlapping", ()=>$8b5d59bbe66a3f5f$export$9fb40a5a7e47a5dd);
    const $8b5d59bbe66a3f5f$export$9fb40a5a7e47a5dd = (dependencyStartDate = -1, dependencyDueDate = -1, dependeeStartDate = -1, dependeeDueDate = -1)=>{
        if (dependencyDueDate > -1 && dependeeStartDate > -1) return dependencyDueDate > dependeeStartDate;
        if (dependencyStartDate === -1 && dependencyDueDate === -1 || dependeeStartDate === -1 && dependeeDueDate === -1) return false;
        if (dependencyDueDate === -1 && dependeeStartDate === -1) return dependencyStartDate > dependeeDueDate;
        if (dependencyDueDate !== -1) return dependencyDueDate > dependeeDueDate;
        if (dependencyStartDate !== -1) return dependencyStartDate > dependeeStartDate;
        return false;
    };
});
parcelRegister("eMI6k", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$537bbd37c61be434$export$2e2bcd8739ae039);
    var $bC2fB;
    var $3rLbe;
    var $cYfye;
    const $537bbd37c61be434$var$mapStateToProps = (state)=>({
            highlightedKeyDates: (0, (0, parcelRequire("3rLbe")).getHighlightedKeyDates)(state),
            getVersionsForKeyDate: (0, (0, parcelRequire("3rLbe")).createGetVersionsForKeyDates)(state)
        });
    var $537bbd37c61be434$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($537bbd37c61be434$var$mapStateToProps, {})((0, (0, parcelRequire("cYfye")).HighlightLines));
});
parcelRegister("cYfye", function(module, exports) {
    $parcel$export(module.exports, "HighlightLines", ()=>$5164331f83054328$export$895b3d36cc1cb0a9);
    var $5uXOq = parcelRequire("5uXOq");
    var $2GEDy;
    var $biT18;
    const $5164331f83054328$export$895b3d36cc1cb0a9 = ({ highlightedKeyDates: highlightedKeyDates, getVersionsForKeyDate: getVersionsForKeyDate })=>{
        const [{ today: today }] = (0, (0, parcelRequire("biT18")).useTimelineState)();
        const keyDates = getVersionsForKeyDate(today);
        return highlightedKeyDates.length ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2GEDy")).RoadmapHighlightLines), {
            highlightedKeyDates: highlightedKeyDates,
            keyDates: keyDates
        }) : null;
    };
});
parcelRegister("2GEDy", function(module, exports) {
    $parcel$export(module.exports, "RoadmapHighlightLines", ()=>$8287b8a363a33320$export$c255e60bcbb8c4b2);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $biT18;
    var $5SuOw;
    var $44Slk;
    var $bNrCO;
    const $8287b8a363a33320$export$c255e60bcbb8c4b2 = ({ highlightedKeyDates: highlightedKeyDates, keyDates: keyDates })=>{
        const [{ timelineDuration: timelineDuration, timelineWidth: timelineWidth, timelineMode: timelineMode }] = (0, (0, parcelRequire("biT18")).useTimelineState)();
        if (highlightedKeyDates.length === 0) return null;
        const keyDateGroups = (0, (0, parcelRequire("44Slk")).getKeyDatesGroups)({
            keyDates: keyDates,
            timelineMode: timelineMode,
            timelineDuration: timelineDuration,
            timelineWidth: timelineWidth
        });
        const highlightLines = (0, (0, parcelRequire("bNrCO")).getHighlightLines)({
            keyDateGroups: keyDateGroups,
            highlightedKeyDates: highlightedKeyDates
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, highlightLines.map(({ left: left, id: id, status: status })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                key: id,
                style: {
                    left: `${left}px`,
                    backgroundColor: (0, (0, parcelRequire("5SuOw")).MARKER_COLORS)[status]
                },
                "data-testid": `roadmap.timeline-table-kit.ui.chart-timeline-overlay.highlight-lines.highlight-line-${id}`,
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_4t3i1osq _1bsbv77o _kqswstnw _1pby11wp"
                ])
            })));
    };
    const $8287b8a363a33320$var$highlightLineStyles = null;
});
parcelRegister("9iIto", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5baaa0a8b83c36d6$export$2e2bcd8739ae039);
    var $bC2fB;
    var $4gYYI;
    var $hhYQB;
    var $fvM4Z;
    var $9QFr0;
    var $ilGit;
    var $5dslo;
    const $5baaa0a8b83c36d6$var$mapDispatchToProps = {
        onClearFilter: (0, (0, parcelRequire("9QFr0")).clearFilter),
        onClearLevelOneSetting: (0, (0, parcelRequire("ilGit")).clearLevelOneSetting)
    };
    var $5baaa0a8b83c36d6$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((state)=>{
        const { showCompleted: showCompleted, period: period } = (0, (0, parcelRequire("hhYQB")).getLevelOneSetting)(state);
        return {
            levelOneName: (0, (0, parcelRequire("4gYYI")).getLevelOneName)(state),
            isFilterActive: (0, (0, parcelRequire("hhYQB")).isFilterActive)(state),
            isLevelOneSettingActive: !(showCompleted && period === 12),
            canUserCreate: (0, (0, parcelRequire("fvM4Z")).getCanUserCreate)(state)
        };
    }, $5baaa0a8b83c36d6$var$mapDispatchToProps)((0, (0, parcelRequire("5dslo")).StandardRoadmapListEmptyContent));
});
parcelRegister("5dslo", function(module, exports) {
    $parcel$export(module.exports, "StandardRoadmapListEmptyContent", ()=>$52d05e0d3f49345f$export$7b119d4836ac8ade);
    var $5uXOq = parcelRequire("5uXOq");
    var $6s1PB;
    var $koVbs;
    var $1mli4;
    var $8yNlf;
    const $52d05e0d3f49345f$export$7b119d4836ac8ade = ({ levelOneName: levelOneName, isFilterActive: isFilterActive, isLevelOneSettingActive: isLevelOneSettingActive, canUserCreate: canUserCreate, onClearFilter: onClearFilter, onClearLevelOneSetting: onClearLevelOneSetting })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        if (isFilterActive) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1mli4")).RoadmapListEmptyContent), {
            description: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("8yNlf")).default).explanationFilterIssueTermRefresh : (0, (0, parcelRequire("8yNlf")).default).explanationFilter),
            actionLabel: formatMessage((0, (0, parcelRequire("8yNlf")).default).clearFilter),
            onActionClick: onClearFilter
        });
        if (isLevelOneSettingActive) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1mli4")).RoadmapListEmptyContent), {
            description: formatMessage((0, (0, parcelRequire("8yNlf")).default).explanationLevelOneSetting, {
                levelOneName: levelOneName
            }),
            actionLabel: formatMessage((0, (0, parcelRequire("8yNlf")).default).clearLevelOneSetting, {
                levelOneName: levelOneName
            }),
            onActionClick: onClearLevelOneSetting
        });
        if (!canUserCreate) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1mli4")).RoadmapListEmptyContent), {
            title: formatMessage((0, (0, parcelRequire("8yNlf")).default).titleNoAccess),
            description: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("8yNlf")).default).explanationNoAccessIssueTermRefresh : (0, (0, parcelRequire("8yNlf")).default).explanationNoAccess),
            illustration: "generic-empty-state"
        });
        return null;
    };
});
parcelRegister("1mli4", function(module, exports) {
    $parcel$export(module.exports, "RoadmapListEmptyContent", ()=>$a3c05486668f1f01$export$6d386b1e9b37b9ba);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fVnbM;
    var $1dJ6S;
    var $4Bpvs;
    var $hkbwL;
    const $a3c05486668f1f01$var$getIllustration = (illustration)=>{
        switch(illustration){
            case 'generic-empty-state':
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4Bpvs")).default), {
                    alt: "",
                    width: "94",
                    height: "84"
                });
            case 'magnifying-glass':
            default:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hkbwL")).default), {
                    alt: "",
                    width: "110",
                    height: "84"
                });
        }
    };
    const $a3c05486668f1f01$export$6d386b1e9b37b9ba = ({ title: title, description: description, illustration: illustration = 'magnifying-glass', actionLabel: actionLabel, onActionClick: onActionClick })=>{
        const showActionButton = actionLabel !== undefined && onActionClick !== undefined;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($a3c05486668f1f01$var$Container, null, $a3c05486668f1f01$var$getIllustration(illustration), (0, ($parcel$interopDefault($5uXOq))).createElement($a3c05486668f1f01$var$TextContainer, null, title && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            size: "medium",
            as: "span"
        }, title), (0, ($parcel$interopDefault($5uXOq))).createElement($a3c05486668f1f01$var$Explanation, null, description), showActionButton && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "link",
            onClick: onActionClick
        }, actionLabel)));
    };
    const $a3c05486668f1f01$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_ca0q1ejb _1e0c1txw _2lx21bp4 _1bsb1osq _4cvr1h6o _bfhkvuon _zulp1ejb",
                __cmplp.className
            ])
        });
    });
    const $a3c05486668f1f01$var$TextContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bsb1osq _zulpv47k",
                __cmplp.className
            ])
        });
    });
    const $a3c05486668f1f01$var$Explanation = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18s8ie5z _y3gn1h6o _p12f1edt",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("hkbwL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b98252af151943e8$export$2e2bcd8739ae039);
    var $dCLgq;
    var $5u6Z6 = parcelRequire("5u6Z6");
    const $b98252af151943e8$var$Illustration = (0, (0, parcelRequire("dCLgq")).createIllustration)({
        srcLight: ($parcel$interopDefault($5u6Z6)),
        srcDark: ($parcel$interopDefault($5u6Z6))
    });
    var $b98252af151943e8$export$2e2bcd8739ae039 = $b98252af151943e8$var$Illustration;
    const $b98252af151943e8$export$a179c88182cb9d56 = [
        0,
        0,
        110,
        84
    ];
});
parcelRegister("5u6Z6", function(module, exports) {
    module.exports = new URL("magnifying-glass.26424ba7.svg", import.meta.url).toString();
});
parcelRegister("8yNlf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1e6d1f9e51db2555$export$2e2bcd8739ae039);
    var $7VHMR;
    var $1e6d1f9e51db2555$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        explanationFilter: {
            "id": "roadmap.standard-roadmap.common.table.list-empty-content.explanation-filter",
            "defaultMessage": "There are no issues that match your current filter."
        },
        clearFilter: {
            "id": "roadmap.standard-roadmap.common.table.list-empty-content.clear-filter",
            "defaultMessage": "Clear filter"
        },
        explanationLevelOneSetting: {
            "id": "roadmap.standard-roadmap.common.table.list-empty-content.explanation-level-one-setting",
            "defaultMessage": "There isn't a match for your current {levelOneName} display option."
        },
        clearLevelOneSetting: {
            "id": "roadmap.standard-roadmap.common.table.list-empty-content.clear-level-one-setting",
            "defaultMessage": "Clear {levelOneName} display option"
        },
        titleNoAccess: {
            "id": "roadmap.standard-roadmap.common.table.list-empty-content.title-no-access",
            "defaultMessage": "There's nothing here!"
        },
        explanationNoAccess: {
            "id": "roadmap.standard-roadmap.common.table.list-empty-content.explanation-no-access",
            "defaultMessage": "To add issues to the timeline, your Jira administrator needs to give you access to this project."
        },
        explanationFilterIssueTermRefresh: {
            "id": "roadmap.standard-roadmap.common.table.list-empty-content.explanation-filter-issue-term-refresh",
            "defaultMessage": "There are no issues that match your current filter."
        },
        explanationNoAccessIssueTermRefresh: {
            "id": "roadmap.standard-roadmap.common.table.list-empty-content.explanation-no-access-issue-term-refresh",
            "defaultMessage": "To add issues to the timeline, your Jira administrator needs to give you access to this project."
        }
    });
});
parcelRegister("hEVku", function(module, exports) {
    $parcel$export(module.exports, "renderListHeaderItem", ()=>$21f0ca83d3958ca9$export$53818c92b94a5ff7);
    var $5uXOq = parcelRequire("5uXOq");
    var $jldZL;
    var $koVbs;
    var $2KlaV;
    var $iqDub;
    var $iZN6h;
    var $cMNtw;
    const $21f0ca83d3958ca9$var$ListHeaderItem = ({ id: id })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        switch(id){
            case 0, (0, parcelRequire("2KlaV")).RELEASES_HEADER_ID:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqDub")).RoadmapListHeaderRow), {
                    title: formatMessage((0, (0, parcelRequire("cMNtw")).default).releases)
                });
            case 0, (0, parcelRequire("2KlaV")).SPRINTS_HEADER_ID:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqDub")).RoadmapListHeaderRow), {
                    title: formatMessage((0, (0, parcelRequire("cMNtw")).default).sprints)
                });
            case 0, (0, parcelRequire("iZN6h")).DEFAULT_HEADER_ROW_ID:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jldZL")).default), null, formatMessage((0, (0, parcelRequire("cMNtw")).default).empty));
            default:
                return null;
        }
    };
    const $21f0ca83d3958ca9$export$53818c92b94a5ff7 = ({ id: id })=>(0, ($parcel$interopDefault($5uXOq))).createElement($21f0ca83d3958ca9$var$ListHeaderItem, {
            id: id
        });
});
parcelRegister("iqDub", function(module, exports) {
    $parcel$export(module.exports, "RoadmapListHeaderRow", ()=>$96ff7950c8ef2fe8$export$f962ea845bdc3e24);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $1dJ6S;
    var $cgL5K;
    var $4R6GH;
    var $dCm1o;
    const $96ff7950c8ef2fe8$export$f962ea845bdc3e24 = ({ title: title })=>{
        if ((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap_drop_2')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            maxLines: 1,
            color: "color.text.subtlest",
            weight: "bold"
        }, title);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            size: "xsmall",
            as: "div"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("p", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_k48pbfng _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1reo15vq _18m915vq _1bto1l2s _o5721q9c"
            ])
        }, title));
    };
    const $96ff7950c8ef2fe8$var$rowTitleStyles = null;
});
parcelRegister("cMNtw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9ab8b974f0b7896b$export$2e2bcd8739ae039);
    var $7VHMR;
    var $9ab8b974f0b7896b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        releases: {
            "id": "roadmap.standard-roadmap.common.table.list-header-item.releases",
            "defaultMessage": "Releases"
        },
        sprints: {
            "id": "roadmap.standard-roadmap.common.table.list-header-item.sprints",
            "defaultMessage": "Sprints"
        },
        empty: {
            "id": "roadmap.standard-roadmap.common.table.list-header-item.empty",
            "defaultMessage": "Empty"
        }
    });
});
parcelRegister("i4Xj8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$55b0e5d375ea1825$export$2e2bcd8739ae039);
    var $bC2fB;
    var $lS7Bl;
    var $hFyhA;
    var $2IdXh;
    var $55b0e5d375ea1825$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((state, { id: id })=>{
        const issueType = (0, (0, parcelRequire("2IdXh")).getIssueTypeForIssueId)(state, id);
        return {
            iconUrl: issueType?.iconUrl,
            title: (0, (0, parcelRequire("hFyhA")).getIssueSummary)(state, id),
            itemKey: (0, (0, parcelRequire("hFyhA")).getIssueKeyById)(state, id),
            isDone: (0, (0, parcelRequire("hFyhA")).getIsIssueResolved)(state, id)
        };
    }, null, (stateProps)=>({
            ...stateProps
        }))((0, (0, parcelRequire("lS7Bl")).RoadmapListItemContentLite));
});
parcelRegister("lS7Bl", function(module, exports) {
    $parcel$export(module.exports, "RoadmapListItemContentLite", ()=>$bb868b29a8434a13$export$6049b0f2a203677);
    var $5uXOq = parcelRequire("5uXOq");
    var $kVRrg;
    const $bb868b29a8434a13$export$6049b0f2a203677 = ({ title: title, iconUrl: iconUrl, itemKey: itemKey, isDone: isDone })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kVRrg")).SummaryContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kVRrg")).SummaryIcon), {
            src: iconUrl,
            alt: ""
        }), itemKey && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kVRrg")).SummaryKeyLabel), {
            isDone: isDone
        }, itemKey), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kVRrg")).SummaryTitle), {
            type: "div"
        }, title));
    $bb868b29a8434a13$export$6049b0f2a203677.defaultProps = {
        iconUrl: '',
        isDone: false
    };
});
parcelRegister("kVRrg", function(module, exports) {
    $parcel$export(module.exports, "SummaryContainer", ()=>$d63c83f876afad24$export$bd55427d3650a1b0);
    $parcel$export(module.exports, "SummaryIcon", ()=>$d63c83f876afad24$export$ced6452f422b797e);
    $parcel$export(module.exports, "SummaryKeyLink", ()=>$d63c83f876afad24$export$a0a8cbd1a9f0ffc8);
    $parcel$export(module.exports, "SummaryKeyLabel", ()=>$d63c83f876afad24$export$f769aedd3eaca4c3);
    $parcel$export(module.exports, "SummaryTitle", ()=>$d63c83f876afad24$export$ec39b3a5dbed0806);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $kgoHi;
    var $8CUq3;
    var $3bDjY;
    var $6s1PB;
    var $4R6GH;
    var $koVbs;
    var $dCm1o;
    var $2zNw6;
    const $d63c83f876afad24$var$containerStylesCompiledStylesOld = null;
    const $d63c83f876afad24$var$iconStylesCompiledStyles = null;
    const $d63c83f876afad24$var$keyStylesCompiledStyles = null;
    const $d63c83f876afad24$var$keyStylesCompiledStylesOld = null;
    const $d63c83f876afad24$var$doneStylesCompiledStyles = null;
    const $d63c83f876afad24$var$titleStylesCompiledStyles = null;
    const $d63c83f876afad24$var$titleStylesCompiledStylesOld = null;
    const $d63c83f876afad24$export$bd55427d3650a1b0 = ({ children: children })=>(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            alignItems: "center",
            xcss: $d63c83f876afad24$var$containerStylesCompiledStyles
        }, children) : (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx2vrvc _1reo15vq _18m915vq _4cvr1h6o _1bto1l2s _1bsb1osq _1yt4swc3"
            ])
        }, children);
    const $d63c83f876afad24$export$ced6452f422b797e = ({ alt: alt, src: src })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const iconLabelMessage = (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("2zNw6")).default).iconLabelIssueTermRefresh : (0, (0, parcelRequire("2zNw6")).default).iconLabel;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: alt
        }, (tooltipProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement("img", {
                src: src,
                alt: alt,
                "aria-label": alt ? formatMessage(iconLabelMessage, {
                    issueType: alt
                }) : undefined,
                "data-testid": "roadmap.timeline-table-kit.common.ui.summary.icon",
                ...tooltipProps,
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_1bsbpxbi _4t3ipxbi _2rko1l7b _16jlidpf _1o9zidpf _i0dl1wug"
                ])
            }));
    };
    const $d63c83f876afad24$export$a0a8cbd1a9f0ffc8 = ({ children: children, isDone: isDone, testId: testId, ...rest })=>{
        const shouldApplyVisualRefreshChanges = (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1');
        return (0, ($parcel$interopDefault($5uXOq))).createElement("a", {
            "data-testid": testId,
            ...rest,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                shouldApplyVisualRefreshChanges ? "_1wyb1lkt _12ji1r31 _1qu2glyw _12y31o36 _18s84w17 _o5721q9c _syaz131l _k48p1wq8 _4bfu18uv _1nrm18uv _1a3b18uv _9oik18uv _1hmsglyw _c2waglyw _4fprglyw _1bnxglyw _ajmmnqa1 _1iohnqa1 _5goinqa1 _jf4cnqa1 _9h8h131l _f8pj131l _30l3131l" : "_1wybdlk8 _12ji1r31 _1qu2glyw _12y31o36 _18s8171m _o5721q9c _syaz1rc1 _9h8h1rc1 _f8pj1rc1 _30l31rc1 _4bfu18uv _1nrm18uv _1a3b18uv _9oik18uv _1hmsglyw _c2waglyw _4fprglyw _1bnxglyw _ajmmnqa1 _1iohnqa1 _5goinqa1 _jf4cnqa1",
                isDone && "_4bfu18uv _1nrm18uv _1a3b18uv _9oik18uv _1hms1911 _c2wa1911 _4fpr1911 _1bnx1911 _ajmmnqa1 _1iohnqa1 _5goinqa1 _jf4cnqa1"
            ])
        }, children);
    };
    const $d63c83f876afad24$export$f769aedd3eaca4c3 = ({ children: children, isDone: isDone, testId: testId, ...rest })=>{
        const shouldApplyVisualRefreshChanges = (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1');
        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            "data-testid": testId,
            ...rest,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                shouldApplyVisualRefreshChanges ? "_1wyb1lkt _12ji1r31 _1qu2glyw _12y31o36 _18s84w17 _o5721q9c _syaz131l _k48p1wq8 _4bfu18uv _1nrm18uv _1a3b18uv _9oik18uv _1hmsglyw _c2waglyw _4fprglyw _1bnxglyw _ajmmnqa1 _1iohnqa1 _5goinqa1 _jf4cnqa1 _9h8h131l _f8pj131l _30l3131l" : "_1wybdlk8 _12ji1r31 _1qu2glyw _12y31o36 _18s8171m _o5721q9c _syaz1rc1 _9h8h1rc1 _f8pj1rc1 _30l31rc1 _4bfu18uv _1nrm18uv _1a3b18uv _9oik18uv _1hmsglyw _c2waglyw _4fprglyw _1bnxglyw _ajmmnqa1 _1iohnqa1 _5goinqa1 _jf4cnqa1",
                isDone && "_4bfu18uv _1nrm18uv _1a3b18uv _9oik18uv _1hms1911 _c2wa1911 _4fpr1911 _1bnx1911 _ajmmnqa1 _1iohnqa1 _5goinqa1 _jf4cnqa1"
            ])
        }, children);
    };
    const $d63c83f876afad24$export$ec39b3a5dbed0806 = ({ type: type, testId: testId, children: children })=>{
        const shouldApplyVisualRefreshChanges = (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1');
        switch(type){
            case 'div':
                return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    "data-testid": testId,
                    className: (0, (0, parcelRequire("bwpsq")).default)([
                        shouldApplyVisualRefreshChanges ? "_18s84w17 _1reo15vq _18m915vq _1bto1l2s _o5721q9c _16jlkb7n" : "_18s8171m _1reo15vq _18m915vq _1bto1l2s _o5721q9c _16jlkb7n"
                    ])
                }, children);
            case 'p':
            default:
                return (0, ($parcel$interopDefault($5uXOq))).createElement("p", {
                    "data-testid": testId,
                    className: (0, (0, parcelRequire("bwpsq")).default)([
                        shouldApplyVisualRefreshChanges ? "_18s84w17 _1reo15vq _18m915vq _1bto1l2s _o5721q9c _16jlkb7n" : "_18s8171m _1reo15vq _18m915vq _1bto1l2s _o5721q9c _16jlkb7n"
                    ])
                }, children);
        }
    };
    const $d63c83f876afad24$var$containerStylesCompiledStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        width: '100%',
        paddingLeft: 'space.050',
        paddingTop: 'space.050',
        paddingBottom: 'space.050'
    });
});
parcelRegister("2zNw6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f9e58619800ac14e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $f9e58619800ac14e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        iconLabel: {
            "id": "roadmap.timeline-table-kit.common.summary.icon-label",
            "defaultMessage": "issue type {issueType}"
        },
        iconLabelIssueTermRefresh: {
            "id": "roadmap.timeline-table-kit.common.summary.icon-label-issue-term-refresh",
            "defaultMessage": "{issueType}"
        }
    });
});
parcelRegister("5u7kL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$df83b5f200fdc3d9$export$2e2bcd8739ae039);
    var $bC2fB;
    var $joGLY;
    var $hFyhA;
    var $hhYQB;
    var $2IdXh;
    var $4LbSm;
    var $1cn7Z;
    var $lEiof;
    var $faf4f;
    var $gmgMu;
    const $df83b5f200fdc3d9$var$onChildCreateClick = (anchor)=>(0, (0, parcelRequire("lEiof")).setCreateItemAnchor)(anchor);
    var $df83b5f200fdc3d9$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((state, { id: id })=>{
        const issueType = (0, (0, parcelRequire("2IdXh")).getIssueTypeForIssueId)(state, id);
        return {
            iconUrl: issueType?.iconUrl,
            iconAltText: issueType?.name,
            title: (0, (0, parcelRequire("hFyhA")).getIssueSummary)(state, id),
            itemKey: (0, (0, parcelRequire("hFyhA")).getIssueKeyById)(state, id),
            progress: (0, (0, parcelRequire("hhYQB")).isProgressVisible)(state) ? (0, (0, parcelRequire("2IdXh")).getProgress)(state, id) : undefined,
            isDone: (0, (0, parcelRequire("hFyhA")).getIsIssueResolved)(state, id),
            highlightText: (0, (0, parcelRequire("hhYQB")).getFilteredText)(state),
            isNudgeEnabled: (0, (0, parcelRequire("faf4f")).createGetIsNudgeVisible)(id)((0, (0, parcelRequire("1cn7Z")).getIsCreateChildEnabled)(state), (0, (0, parcelRequire("1cn7Z")).getItems)(state)?.[0]),
            progressMetadata: (0, (0, parcelRequire("joGLY")).isBaseLevel)((0, (0, parcelRequire("hFyhA")).getIssueLevel)(state, id)) ? (0, (0, parcelRequire("4LbSm")).getIssueSubtaskProgress)(state, id) : (0, (0, parcelRequire("4LbSm")).DEFAULT_PROGRESS_META_DATA)
        };
    }, {
        onChildCreateClick: $df83b5f200fdc3d9$var$onChildCreateClick
    }, (stateProps, dispatchProps, { isHoveredOrFocused: isHoveredOrFocused, id: id })=>({
            ...stateProps,
            ...dispatchProps,
            isRichContentEnabled: isHoveredOrFocused,
            id: id
        }))((0, (0, parcelRequire("gmgMu")).default));
});
parcelRegister("faf4f", function(module, exports) {
    $parcel$export(module.exports, "createGetIsNudgeVisible", ()=>$bf21c4d54a1d4054$export$3dfb8a83b7cbfb51);
    const $bf21c4d54a1d4054$export$3dfb8a83b7cbfb51 = (id)=>(canCreateChild, firstParentItem)=>canCreateChild && firstParentItem?.id === id;
});
parcelRegister("gmgMu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d96777d0e539e118$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $6s1PB;
    var $koVbs;
    var $8Bc5A;
    var $cE2Qr;
    var $1Kr7A;
    var $6aARE;
    var $iZN6h;
    var $dZK9l;
    const $d96777d0e539e118$var$ListItemContentWithNudge = ({ isNudgeEnabled: isNudgeEnabled, onChildCreateClick: onChildCreateClick, id: id, ...otherProps })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [openTask] = (0, (0, parcelRequire("cE2Qr")).useOpenTask)();
        const [hasNudgeActive] = (0, (0, parcelRequire("cE2Qr")).useHasNudgeActive)();
        const onClick = (0, $5uXOq.useCallback)((event)=>{
            event.stopPropagation();
            onChildCreateClick({
                parentId: id,
                position: (0, (0, parcelRequire("iZN6h")).INSIDE)
            });
        }, [
            id,
            onChildCreateClick
        ]);
        const onKeyDown = (0, $5uXOq.useCallback)((event)=>{
            if (event.key === 'Enter') {
                event.stopPropagation();
                onChildCreateClick({
                    parentId: id,
                    position: (0, (0, parcelRequire("iZN6h")).INSIDE)
                });
            }
        }, [
            id,
            onChildCreateClick
        ]);
        if (hasNudgeActive && openTask === (0, (0, parcelRequire("8Bc5A")).IDENTIFY_SMALL_CHUNKS_OF_WORK_TASK)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6aARE")).RoadmapListItemContent), otherProps), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1Kr7A")).RoadmapCreateEpicChildIssueButtonWrapperNudgeAsync), null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            onClick: onClick,
            role: "button",
            "aria-label": formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("dZK9l")).default).createChildIssueTermRefresh : (0, (0, parcelRequire("dZK9l")).default).createChild),
            tabIndex: 0,
            onKeyDown: onKeyDown,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_154i1grp _1xi212x7 _1bsb1ejb _4t3i1ejb _lcxv1wug _80omtlke _kqswstnw _1ywuglyw _cfu1glyw"
            ])
        })));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6aARE")).RoadmapListItemContent), otherProps);
    };
    const $d96777d0e539e118$var$ListItemContent = (props)=>{
        const { isNudgeEnabled: isNudgeEnabled, onChildCreateClick: onChildCreateClick, id: id, ...otherProps } = props;
        if (!false && isNudgeEnabled) return (0, ($parcel$interopDefault($5uXOq))).createElement($d96777d0e539e118$var$ListItemContentWithNudge, props);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6aARE")).RoadmapListItemContent), otherProps);
    };
    $d96777d0e539e118$var$ListItemContent.whyDidYouRender = true;
    var $d96777d0e539e118$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($d96777d0e539e118$var$ListItemContent);
    const $d96777d0e539e118$var$fakeChildCreateButtonStyles = null;
});
parcelRegister("1Kr7A", function(module, exports) {
    $parcel$export(module.exports, "RoadmapCreateEpicChildIssueButtonWrapperNudgeAsync", ()=>$88043707ce101876$export$ed02c30bbe7241c5);
    var $5uXOq = parcelRequire("5uXOq");
    var $bBbEG;
    var $lfTZh;
    var $kxZPA;
    const $88043707ce101876$var$RoadmapCreateEpicChildIssueButtonLazy = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("lzH30")).then((exportedModule)=>exportedModule.RoadmapCreateEpicChildIssueButtonWrapperNudge), {
        ssr: false,
        moduleId: "./src/packages/software/onboarding-nudges/src/ui/roadmap-create-epic-child-issue/index.tsx"
    });
    const $88043707ce101876$export$ed02c30bbe7241c5 = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bBbEG")).OnboardingNudgeErrorBoundary), {
            id: (0, $6784cbc7d62e5d7c$export$1e39959907a7f359),
            fallback: children,
            attributes: {
                nudgeId: (0, $6784cbc7d62e5d7c$export$1e39959907a7f359)
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "software-quickstart-roadmap-create-child-issue-nudge",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($88043707ce101876$var$RoadmapCreateEpicChildIssueButtonLazy, {
            nudgeId: (0, $6784cbc7d62e5d7c$export$1e39959907a7f359)
        }, children)));
});
parcelRegister("lzH30", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("dO77W")
    ]).then(()=>parcelRequire('2jsZw'));
});
parcelRegister("6aARE", function(module, exports) {
    $parcel$export(module.exports, "RoadmapListItemContent", ()=>$a16539012975aed1$export$d822c765b9c722b8);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $WPwAA;
    var $dCm1o;
    var $gBcuR;
    var $kbCJT;
    const $a16539012975aed1$export$d822c765b9c722b8 = ({ title: title, iconUrl: iconUrl, iconAltText: iconAltText, itemKey: itemKey, progress: progress, highlightText: highlightText, isDone: isDone, isRichContentEnabled: isRichContentEnabled, progressMetadata: progressMetadata })=>{
        let isMultiSelectEnabled;
        if ((0, (0, parcelRequire("4R6GH")).fg)('project_timeline_multi-select_and_checkboxes')) [{ isMultiSelectEnabled: isMultiSelectEnabled }] = (0, (0, parcelRequire("WPwAA")).useEnablements)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kbCJT")).default), {
            title: title,
            itemKey: itemKey,
            iconUrl: iconUrl,
            iconAltText: iconAltText,
            highlightText: highlightText,
            isDone: isDone,
            isActive: isRichContentEnabled,
            progressMetadata: progressMetadata
        }), progress && ((0, (0, parcelRequire("4R6GH")).fg)('project_timeline_multi-select_and_checkboxes') ? (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                left: isMultiSelectEnabled ? "var(--ds-space-1000, 80px)" : "var(--ds-space-600, 48px)",
                marginLeft: !isMultiSelectEnabled && (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? "var(--ds-space-150, 12px)" : "var(--ds-space-0, 0px)"
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _94n51b66 _1bsb1tkr _4t3i1b66"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gBcuR")).RoadmapProgressBar), {
            isRichContentEnabled: isRichContentEnabled,
            progress: progress
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _1ltvoahv _94n51b66 _1bsb1tkr _4t3i1b66"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gBcuR")).RoadmapProgressBar), {
            isRichContentEnabled: isRichContentEnabled,
            progress: progress
        }))));
    };
    $a16539012975aed1$export$d822c765b9c722b8.defaultProps = {
        title: '',
        iconUrl: '',
        iconAltText: '',
        highlightText: '',
        isDone: false
    };
    const $a16539012975aed1$var$legacyContainerStyles = null;
    const $a16539012975aed1$var$containerStyles = null;
});
parcelRegister("gBcuR", function(module, exports) {
    $parcel$export(module.exports, "RoadmapProgressBar", ()=>$3491ebf7c851e852$export$55a41cf6644a7a92);
    var $5uXOq = parcelRequire("5uXOq");
    var $6xUNT;
    var $7IWsp;
    var $koVbs;
    var $4JENb;
    const $3491ebf7c851e852$export$55a41cf6644a7a92 = ({ isRichContentEnabled: isRichContentEnabled, progress: progress })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const total = progress.reduce((totalCount, entry)=>totalCount + entry.count, 0);
        const getTooltipContent = ({ count: count, name: name })=>{
            if (!isRichContentEnabled) return '';
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, (0, parcelRequire("4JENb")).default).tooltip, {
                count: count,
                name: name,
                total: total
            }));
        };
        const fulfilledProgress = progress.slice(0, -1);
        const unfulfilledProgress = progress[progress.length - 1];
        const progressBarAriaLabel = [
            ...fulfilledProgress,
            unfulfilledProgress
        ].map(({ count: count, name: name })=>formatMessage((0, (0, parcelRequire("4JENb")).default).tooltip, {
                count: count,
                name: name,
                total: total
            })).join(', ');
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6xUNT")).default), {
            "aria-label": progressBarAriaLabel,
            sum: total,
            backgroundColor: unfulfilledProgress.color,
            remainingTooltipContent: getTooltipContent(unfulfilledProgress),
            height: 4
        }, fulfilledProgress.map((entry)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7IWsp")).default), {
                key: entry.id,
                value: entry.count,
                color: entry.color,
                tooltipContent: getTooltipContent(entry)
            })));
    };
});
parcelRegister("6xUNT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d12efc7cca969bbb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $47bDC = parcelRequire("47bDC");
    var $7IWsp;
    class $d12efc7cca969bbb$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
        static{
            this.defaultProps = {
                children: null,
                sum: 0,
                remainingTooltipContent: '',
                backgroundColor: (0, $829f609a65d26a98$exports).N30,
                height: 10
            };
        }
        validateElementsAndCalculateElementsWidth() {
            const { children: children } = this.props;
            let sumOfElementsValues = 0;
            const validatedElements = [];
            (0, $5uXOq.Children).map(children, (child)=>{
                const childEl = child;
                if (childEl.props.value && childEl.props.value > 0) {
                    sumOfElementsValues += childEl.props.value;
                    validatedElements.push(childEl);
                }
            });
            return {
                validatedElements: validatedElements,
                elementsSum: sumOfElementsValues
            };
        }
        render() {
            const { children: children, remainingTooltipContent: remainingTooltipContent, sum: sum, backgroundColor: backgroundColor, height: height, borderRadius: borderRadius, tooltipHoverPadding: tooltipHoverPadding } = this.props;
            if (!children) return (0, ($parcel$interopDefault($5uXOq))).createElement($d12efc7cca969bbb$var$ProgressWrapper, {
                "data-testid": "common.components.progress-bar.progress-wrapper",
                backgroundColor: backgroundColor,
                elementsGrow: 0,
                elementsHeight: height,
                borderRadius: borderRadius
            });
            const { validatedElements: validatedElements, elementsSum: elementsSum } = this.validateElementsAndCalculateElementsWidth();
            const remaining = sum - elementsSum;
            return (0, ($parcel$interopDefault($5uXOq))).createElement($d12efc7cca969bbb$var$ProgressWrapper, {
                ...this.props,
                "data-testid": "common.components.progress-bar.progress-wrapper",
                backgroundColor: remaining > 0 ? backgroundColor : 'transparent',
                elementsHeight: height,
                borderRadius: borderRadius,
                tooltipHoverPadding: tooltipHoverPadding,
                role: "status",
                ariaLive: "polite"
            }, validatedElements, remaining > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7IWsp")).default), {
                value: remaining,
                tooltipContent: remainingTooltipContent,
                color: backgroundColor,
                tooltipHoverPadding: tooltipHoverPadding
            }));
        }
    }
    const $d12efc7cca969bbb$var$ProgressWrapper = (0, $47bDC.default).div.withConfig({
        componentId: "sc-1750df9-0"
    })`width:100%;height:${(props)=>props.elementsHeight}px;display:flex;${({ borderRadius: borderRadius, elementsHeight: elementsHeight, tooltipHoverPadding: tooltipHoverPadding })=>!tooltipHoverPadding && `border-radius: ${borderRadius || elementsHeight / 2}px;
        overflow: hidden;
    `} & > div{${({ borderRadius: borderRadius, elementsHeight: elementsHeight })=>{
        const radius = `${borderRadius || elementsHeight / 2}px`;
        return `
                &:first-child {
                    border-top-left-radius: ${radius};
                    border-bottom-left-radius: ${radius};
                }
                &:last-child {
                    border-top-right-radius: ${radius};
                    border-bottom-right-radius: ${radius};
                }
                &:not(:last-child) {
                    margin-right: 2px;
                }
                &:last-child {
                    margin-right: 0;
                }
            `;
    }}}`;
    $d12efc7cca969bbb$var$ProgressWrapper.displayName = 'ProgressWrapper';
});
parcelRegister("7IWsp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$719ee7d438676972$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $47bDC = parcelRequire("47bDC");
    var $3bDjY;
    const $719ee7d438676972$var$SingleElementWithTooltip = (props)=>{
        const { value: value, tooltipContent: tooltipContent, color: color, position: position, tooltipHoverPadding: tooltipHoverPadding } = props;
        const TooltipTag = (0, $5uXOq.useMemo)(()=>(0, $5uXOq.forwardRef)((tagProps, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement($719ee7d438676972$var$SingleElement, {
                    elementGrow: value,
                    color: color,
                    innerRef: ref,
                    tooltipHoverPadding: tooltipHoverPadding,
                    ...tagProps,
                    ...typeof tooltipContent === 'string' ? {
                        role: 'button',
                        'aria-label': tooltipContent,
                        alt: tooltipContent,
                        tabIndex: 0
                    } : {}
                })), [
            color,
            value,
            tooltipContent,
            tooltipHoverPadding
        ]);
        return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: tooltipContent,
            position: position,
            tag: TooltipTag
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", null)));
    };
    class $719ee7d438676972$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
        static{
            this.defaultProps = {
                value: 0,
                tooltipContent: ''
            };
        }
        render() {
            const { value: value, tooltipContent: tooltipContent, color: color } = this.props;
            const hasTooltipContent = Boolean(tooltipContent);
            if (hasTooltipContent) return (0, ($parcel$interopDefault($5uXOq))).createElement($719ee7d438676972$var$SingleElementWithTooltip, {
                ...this.props,
                tooltipContent: tooltipContent
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement($719ee7d438676972$var$SingleElement, {
                elementGrow: value,
                color: color,
                alt: tooltipContent
            });
        }
    }
    const $719ee7d438676972$var$SingleElement = (0, $47bDC.default).div.withConfig({
        componentId: "sc-234u1k-0"
    })`flex-grow:${(props)=>props.elementGrow};height:100%;min-width:5px;background-color:${(props)=>props.color};div{height:100%;width:100%;${({ tooltipHoverPadding: tooltipHoverPadding })=>tooltipHoverPadding && `padding-block: ${tooltipHoverPadding}px;
            margin-top: -${tooltipHoverPadding}px;`}}`;
    $719ee7d438676972$var$SingleElement.displayName = 'SingleElement';
});
parcelRegister("4JENb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$90a8c41c099be1ed$export$2e2bcd8739ae039);
    var $7VHMR;
    var $90a8c41c099be1ed$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        tooltip: {
            "id": "roadmap.timeline-table-kit.common.progress-bar.tooltip",
            "defaultMessage": "{name}: {count} of {total}"
        }
    });
});
parcelRegister("kbCJT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$26d9b32bf7405fc5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $3bDjY;
    var $6s1PB;
    var $4R6GH;
    var $koVbs;
    var $k2wwp;
    var $kVRrg;
    var $4f83r;
    var $1U4Hh;
    const $26d9b32bf7405fc5$export$f994b46402ed991f = (event)=>{
        const withCmd = event.ctrlKey || event.metaKey;
        withCmd ? event.stopPropagation() : event.preventDefault();
    };
    const $26d9b32bf7405fc5$var$onPress = (e, link)=>{
        if (e.key === 'Enter') window.open(link, '_blank');
    };
    const $26d9b32bf7405fc5$var$TooltipTag = (0, $5uXOq.forwardRef)((props, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $26d9b32bf7405fc5$var$tooltipTag,
            ref: ref,
            ...props
        }));
    const $26d9b32bf7405fc5$var$Summary = ({ title: title, iconUrl: iconUrl, isDone: isDone, itemKey: itemKey, iconAltText: iconAltText, highlightText: highlightText, isActive: isActive, progressMetadata: progressMetadata })=>{
        const highlight = (0, $5uXOq.useMemo)(()=>[
                highlightText
            ], [
            highlightText
        ]);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const onClick = (0, $5uXOq.useCallback)((event)=>{
            const withCmd = event.ctrlKey || event.metaKey;
            withCmd ? event.stopPropagation() : event.preventDefault();
        }, []);
        const onKeyDown = (0, $5uXOq.useCallback)((event)=>{
            if (event.key !== 'Enter') return;
            event.stopPropagation();
            const link = `/browse/${itemKey}`;
            const withCmd = event.ctrlKey || event.metaKey;
            if (withCmd) {
                event.preventDefault();
                window.open(link, '_blank');
            }
        }, [
            itemKey
        ]);
        const itemKeyEl = highlightText !== '' && itemKey !== undefined ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k2wwp")).default), {
            "data-testid": "roadmap.timeline-table-kit.ui.list-item-content.summary.item-el",
            text: itemKey,
            highlight: highlight
        }) : itemKey;
        const titleEl = highlightText !== '' ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k2wwp")).default), {
            "data-testid": "roadmap.timeline-table-kit.ui.list-item-content.summary.title-el",
            text: title,
            highlight: highlight
        }) : title;
        const renderSummaryTitle = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kVRrg")).SummaryTitle), {
                type: "p",
                testId: "roadmap.timeline-table-kit.ui.list-item-content.summary.title"
            }, titleEl);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kVRrg")).SummaryContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kVRrg")).SummaryIcon), {
            src: iconUrl,
            alt: iconAltText
        }), itemKey && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kVRrg")).SummaryKeyLink), {
            href: `/browse/${itemKey}`,
            isDone: isDone,
            testId: "roadmap.timeline-table-kit.ui.list-item-content.summary.key",
            "aria-label": formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("4f83r")).default).issueKeyLabelIssueTermRefresh : (0, (0, parcelRequire("4f83r")).default).issueKeyLabel, {
                itemKey: itemKey
            }),
            onClick: (0, (0, parcelRequire("4R6GH")).fg)('timeline_grid_navigation_m2') ? onClick : $26d9b32bf7405fc5$export$f994b46402ed991f,
            onKeyDown: (0, (0, parcelRequire("4R6GH")).fg)('timeline_grid_navigation_m2') ? onKeyDown : (e)=>$26d9b32bf7405fc5$var$onPress(e, `/browse/${itemKey}`)
        }, itemKeyEl), title.length > 16 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            position: "bottom-start",
            content: titleEl,
            ...(0, (0, parcelRequire("4R6GH")).fg)('jsw_fix_timeline_issue_summary_missing_ellipses') && {
                tag: $26d9b32bf7405fc5$var$TooltipTag
            }
        }, renderSummaryTitle()) : renderSummaryTitle()), progressMetadata.total > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1U4Hh")).default), {
            ...progressMetadata,
            isActive: isActive
        }));
    };
    const $26d9b32bf7405fc5$var$tooltipTag = (0, (0, parcelRequire("8CUq3")).xcss)({
        overflow: 'hidden'
    });
    const $26d9b32bf7405fc5$var$DEFAULT_PROGRESS_META = {
        completed: 0,
        total: 0
    };
    $26d9b32bf7405fc5$var$Summary.defaultProps = {
        isDone: false,
        iconAltText: '',
        highlightText: '',
        progressMetadata: $26d9b32bf7405fc5$var$DEFAULT_PROGRESS_META
    };
    var $26d9b32bf7405fc5$export$2e2bcd8739ae039 = $26d9b32bf7405fc5$var$Summary;
});
parcelRegister("k2wwp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5e37bd657627b5db$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1H6kL;
    var $cM7El;
    const $5e37bd657627b5db$var$HighlightTextWithParser = (0, $5uXOq.memo)(({ text: text, highlight: highlight })=>{
        const parts = (0, (0, parcelRequire("1H6kL")).getParts)(highlight, text);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cM7El")).default), {
            parts: parts
        });
    });
    var $5e37bd657627b5db$export$2e2bcd8739ae039 = $5e37bd657627b5db$var$HighlightTextWithParser;
});
parcelRegister("1H6kL", function(module, exports) {
    $parcel$export(module.exports, "removeAccents", ()=>$0b92ef830f5aa8e4$export$f3f2882e8b11d731);
    $parcel$export(module.exports, "getParts", ()=>$0b92ef830f5aa8e4$export$a3aee8a24a54661f);
    var $8QDwl = parcelRequire("8QDwl");
    var $ajpes = parcelRequire("ajpes");
    var $3JOCw = parcelRequire("3JOCw");
    var $8QpSo;
    const $0b92ef830f5aa8e4$export$f3f2882e8b11d731 = (0, (0, parcelRequire("8QpSo")).default)((text)=>text.normalize('NFD').replace(/[\u0300-\u036f]/g, ''));
    const $0b92ef830f5aa8e4$export$1633667427d99697 = (0, (0, parcelRequire("8QpSo")).default)((highlight)=>{
        const escapedFilter = highlight.map((phrase)=>(0, ($parcel$interopDefault($8QDwl)))(phrase)).join('|');
        return new RegExp(escapedFilter, 'gmi');
    }, (newArgs, lastArgs)=>{
        if (newArgs.length !== lastArgs.length) return false;
        const equalityFn = (0, ($parcel$interopDefault($ajpes)));
        return newArgs.every((newArg, index)=>equalityFn(newArg, lastArgs[index]));
    });
    const $0b92ef830f5aa8e4$export$2235873b95f89ea = (content)=>({
            type: 'text',
            content: content
        });
    const $0b92ef830f5aa8e4$export$39ae7d355c29b45f = (content)=>({
            type: 'highlight',
            content: content
        });
    const $0b92ef830f5aa8e4$export$c05c39859172f90c = (str, regExp)=>{
        const ms = [];
        let m = regExp.exec(str);
        while(m){
            ms.push(m);
            m = regExp.exec(str);
        }
        return ms;
    };
    const $0b92ef830f5aa8e4$export$a3aee8a24a54661f = (highlight, text)=>{
        if (highlight == null || highlight.filter((phrase)=>phrase !== '').length === 0) return [
            $0b92ef830f5aa8e4$export$2235873b95f89ea(text)
        ];
        const parts = [];
        const truncatedHighlight = highlight.map((phrase)=>phrase.substring(0, 255));
        const highlightRegExp = $0b92ef830f5aa8e4$export$1633667427d99697(truncatedHighlight.filter((phrase)=>phrase !== ''));
        const textWithoutAccents = $0b92ef830f5aa8e4$export$f3f2882e8b11d731(text);
        const textMatches = $0b92ef830f5aa8e4$export$c05c39859172f90c(text, highlightRegExp);
        const textWithoutAccentsMatches = $0b92ef830f5aa8e4$export$c05c39859172f90c(textWithoutAccents, highlightRegExp);
        const highlightMatches = (0, ($parcel$interopDefault($3JOCw)))([
            ...textWithoutAccentsMatches,
            ...textMatches
        ], 'index');
        let currentPosition = 0;
        highlightMatches.forEach((match)=>{
            const matchText = text.slice(match.index, match.index + match[0].length);
            const leading = text.slice(currentPosition, match.index);
            if (leading !== '') parts.push($0b92ef830f5aa8e4$export$2235873b95f89ea(leading));
            parts.push($0b92ef830f5aa8e4$export$39ae7d355c29b45f(matchText));
            currentPosition = match.index + matchText.length;
        });
        const trailing = text.slice(currentPosition);
        if (trailing !== '') parts.push($0b92ef830f5aa8e4$export$2235873b95f89ea(trailing));
        return parts;
    };
});
parcelRegister("cM7El", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$328475be93221885$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $e9H98;
    const $328475be93221885$var$HighlightText = ({ parts: parts })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, parts.map((part, i)=>{
            if (part.type === 'text') return part.content;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e9H98")).Mark), {
                key: i
            }, part.content);
        }));
    var $328475be93221885$export$2e2bcd8739ae039 = $328475be93221885$var$HighlightText;
});
parcelRegister("e9H98", function(module, exports) {
    $parcel$export(module.exports, "Mark", ()=>$ef706e6c8afab51f$export$c9d15bcfc6d42044);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $ef706e6c8afab51f$export$c9d15bcfc6d42044 = (0, $5uXOq.forwardRef)(({ as: C = "mark", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_bfhkwtfv _syaz1fxt",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("4f83r", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$83b3dcc5123b5d54$export$2e2bcd8739ae039);
    var $7VHMR;
    var $83b3dcc5123b5d54$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        issueKeyLabel: {
            "id": "roadmap.timeline-table-kit.list-item-content.summary.issue-key-label",
            "defaultMessage": "issue key {itemKey}"
        },
        issueKeyLabelIssueTermRefresh: {
            "id": "roadmap.timeline-table-kit.list-item-content.summary.issue-key-label-issue-term-refresh",
            "defaultMessage": "work item key {itemKey}"
        }
    });
});
parcelRegister("1U4Hh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cba1fdffcd3dbe5f$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $ehOs2;
    var $3bDjY;
    var $6s1PB;
    var $koVbs;
    var $8zOmE;
    var $47ciD;
    const $cba1fdffcd3dbe5f$var$Indicator = ({ label: label })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("ehOs2"))))), {
            testId: "roadmap.timeline-table-kit.ui.list-item-content.summary.progress-indicator",
            color: `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$export$e2ef2124cf4024b1)})`,
            LEGACY_size: "small",
            label: label
        });
    const $cba1fdffcd3dbe5f$var$TooltipTag = (0, $5uXOq.forwardRef)((props, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement($cba1fdffcd3dbe5f$var$Container, {
            ref: ref,
            ...props
        }));
    const $cba1fdffcd3dbe5f$var$ProgressIndicator = (props)=>{
        const { total: total, completed: completed, isActive: isActive } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const onTooltipShow = (analyticEvent)=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticEvent, 'childIssuesIcon', {
                childIssuesNum: total
            });
        };
        const message = formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("47ciD")).default).progressMetadataTooltipIssueTermRefresh : (0, (0, parcelRequire("47ciD")).default).progressMetadataTooltip, {
            completed: completed,
            total: total
        });
        if (isActive) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: message,
            tag: $cba1fdffcd3dbe5f$var$TooltipTag,
            onShow: onTooltipShow
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($cba1fdffcd3dbe5f$var$Indicator, {
            label: message
        }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement($cba1fdffcd3dbe5f$var$Container, null, (0, ($parcel$interopDefault($5uXOq))).createElement($cba1fdffcd3dbe5f$var$Indicator, {
            label: message
        }));
    };
    var $cba1fdffcd3dbe5f$export$2e2bcd8739ae039 = $cba1fdffcd3dbe5f$var$ProgressIndicator;
    const $cba1fdffcd3dbe5f$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i7vkz _1bsb7vkz _16jlidpf _1o9zidpf _i0dlexct _1reo15vq _18m915vq _1e0c1txw",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("ehOs2", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $a669c9c7dda1a2bd$var$_react = $a669c9c7dda1a2bd$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $a669c9c7dda1a2bd$var$_childIssues = $a669c9c7dda1a2bd$var$_interopRequireDefault((parcelRequire("a5U1O")));
    var $a669c9c7dda1a2bd$var$_childIssues2 = $a669c9c7dda1a2bd$var$_interopRequireDefault((parcelRequire("hxodJ")));
    function $a669c9c7dda1a2bd$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $a669c9c7dda1a2bd$var$ChildIssuesIcon = (props)=>$a669c9c7dda1a2bd$var$_react.default.createElement($a669c9c7dda1a2bd$var$_childIssues.default, Object.assign({
            LEGACY_fallbackIcon: $a669c9c7dda1a2bd$var$_childIssues2.default
        }, props));
    $a669c9c7dda1a2bd$var$ChildIssuesIcon.Name = 'ChildIssuesIconMigration';
    var $a669c9c7dda1a2bd$var$_default = module.exports.default = $a669c9c7dda1a2bd$var$ChildIssuesIcon;
});
parcelRegister("a5U1O", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $7595d510a7cf11ee$var$_react = $7595d510a7cf11ee$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7595d510a7cf11ee$var$_UNSAFE_baseNew = $7595d510a7cf11ee$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $7595d510a7cf11ee$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $7595d510a7cf11ee$var$ChildIssuesIcon = (props)=>$7595d510a7cf11ee$var$_react.default.createElement($7595d510a7cf11ee$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.75 12.25v1.5a.5.5 0 0 0 .5.5h5.5a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-5.5a.5.5 0 0 0-.5.5zm0 0H3c-.69 0-1.25-.56-1.25-1.25V5.25m0-4.25v4.25m6 0v1.5a.5.5 0 0 0 .5.5h5.5a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-5.5a.5.5 0 0 0-.5.5zm0 0h-6"/>`
        }, props));
    $7595d510a7cf11ee$var$ChildIssuesIcon.displayName = 'ChildIssuesIcon';
    var $7595d510a7cf11ee$var$_default = module.exports.default = $7595d510a7cf11ee$var$ChildIssuesIcon;
});
parcelRegister("hxodJ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $cc484e6d94653edf$var$_react = $cc484e6d94653edf$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $cc484e6d94653edf$var$_childIssues = $cc484e6d94653edf$var$_interopRequireDefault((parcelRequire("a5U1O")));
    function $cc484e6d94653edf$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $cc484e6d94653edf$var$ChildIssuesIcon = (props)=>$cc484e6d94653edf$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11 7h2v5h-2zm5 6h2v3h-2zM6 13h2v3H6z"/><path d="M7 11h10a1 1 0 0 1 1 1v1H6v-1a1 1 0 0 1 1-1"/><path fill-rule="nonzero" d="M5 18v1h4v-1zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2m10 2v1h4v-1zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2M10 5v1h4V5zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2"/></g></svg>`
        }, props, {
            newIcon: $cc484e6d94653edf$var$_childIssues.default
        }));
    $cc484e6d94653edf$var$ChildIssuesIcon.displayName = 'ChildIssuesIcon';
    var $cc484e6d94653edf$var$_default = module.exports.default = $cc484e6d94653edf$var$ChildIssuesIcon;
});
parcelRegister("47ciD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$da982e4e8f5f63af$export$2e2bcd8739ae039);
    var $7VHMR;
    var $da982e4e8f5f63af$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        progressMetadataTooltip: {
            "id": "roadmap.timeline-table-kit.list-item-content.summary.progress-indicator.progress-metadata-tooltip",
            "defaultMessage": "{completed} of {total} child issues complete"
        },
        progressMetadataTooltipIssueTermRefresh: {
            "id": "roadmap.timeline-table-kit.list-item-content.summary.progress-indicator.progress-metadata-tooltip-issue-term-refresh",
            "defaultMessage": "{completed} of {total} child work items complete"
        }
    });
});
parcelRegister("dZK9l", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f123dcdad4f74d4f$export$2e2bcd8739ae039);
    var $7VHMR;
    var $f123dcdad4f74d4f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        createChild: {
            "id": "roadmap.standard-roadmap.common.table.list-item-content.create-child",
            "defaultMessage": "Create child issue"
        },
        createChildIssueTermRefresh: {
            "id": "roadmap.standard-roadmap.common.table.list-item-content.create-child-issue-term-refresh",
            "defaultMessage": "Create child issue"
        }
    });
});
parcelRegister("cvG33", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$38b61f0b6c2136d0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $lfTZh;
    var $kxZPA;
    var $eKt4x;
    var $b6dTd;
    const $38b61f0b6c2136d0$var$ListItemCreate = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("bxV0q")), {
        ssr: false,
        moduleId: "./src/packages/software/roadmap/standard/src/view/common/table/list-item-create/index.tsx"
    });
    var $38b61f0b6c2136d0$export$2e2bcd8739ae039 = (props)=>{
        const { isActive: isActive } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "async-standard-roadmap-list-item-create",
            packageName: (0, (0, parcelRequire("eKt4x")).ROADMAP_PACKAGE_NAME),
            fallback: "flag"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "standard-roadmap-list-item-create",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b6dTd")).default), {
                isActive: isActive
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($38b61f0b6c2136d0$var$ListItemCreate, props)));
    };
});
parcelRegister("b6dTd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$34756653c503b187$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $1wbtX;
    const $34756653c503b187$var$ListItemCreateSkeleton = ({ isActive: isActive })=>isActive ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $34756653c503b187$var$containerStyles,
            style: {
                width: '100%'
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1wbtX")).SkeletonCompiled), {
            width: "16px",
            height: "16px",
            style: {
                marginRight: "var(--ds-space-100, 8px)"
            }
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1wbtX")).SkeletonCompiled), {
            width: "50%",
            height: "14px"
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $34756653c503b187$var$containerStyles,
            style: {
                width: '100%'
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1wbtX")).SkeletonCompiled), {
            width: "35%",
            height: "20px"
        }));
    var $34756653c503b187$export$2e2bcd8739ae039 = $34756653c503b187$var$ListItemCreateSkeleton;
    const $34756653c503b187$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        alignItems: 'center',
        paddingTop: '0',
        paddingBottom: '0',
        paddingLeft: 'space.150',
        paddingRight: 'space.150',
        boxSizing: 'border-box'
    });
});
parcelRegister("bxV0q", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("8JRmb")
    ]).then(()=>parcelRequire('jRrI4'));
});
parcelRegister("ehQek", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$77c9a04182fde288$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $eKt4x;
    var $dfknv;
    var $2kCH3;
    var $kbzVx;
    var $g7ctu;
    var $1Do17;
    var $4ftbb;
    var $dyl9d;
    const $77c9a04182fde288$var$ListItemMenuOption = ({ optionId: optionId, id: id, setOpenModal: setOpenModal, Option: Option, setCloseMenu: setCloseMenu, setInitialFocusRef: setInitialFocusRef })=>{
        switch(optionId){
            case 0, (0, parcelRequire("eKt4x")).CHANGE_PARENT_ISSUE:
                return (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-meatball-reparent-menu') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dyl9d")).default), {
                    id: id,
                    Option: Option,
                    setCloseMenu: setCloseMenu
                }) : null;
            case 0, (0, parcelRequire("eKt4x")).CHANGE_ISSUE_COLOR:
                return (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-meatballs-change-issue-color') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2kCH3")).default), {
                    id: id,
                    Option: Option,
                    setCloseMenu: setCloseMenu
                }) : null;
            case 0, (0, parcelRequire("eKt4x")).EDIT_SPRINT:
                return (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline_sprint_scheduling_a11y') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1Do17")).default), {
                    id: id,
                    Option: Option,
                    setCloseMenu: setCloseMenu
                }) : null;
            case 0, (0, parcelRequire("eKt4x")).EDIT_DATES:
                return (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-meatballs-date-update-modal') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kbzVx")).default), {
                    id: id,
                    setOpenModal: setOpenModal,
                    Option: Option
                }) : null;
            case 0, (0, parcelRequire("eKt4x")).BULK_EDIT_DATES:
                return (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmap_timeline_meatball_selected_item_option') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dfknv")).default), {
                    id: id,
                    setOpenModal: setOpenModal,
                    Option: Option,
                    setInitialFocusRef: setInitialFocusRef
                }) : null;
            case 0, (0, parcelRequire("eKt4x")).REMOVE_DATES:
                return (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-meatballs-date-update-modal') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4ftbb")).default), {
                    id: id,
                    Option: Option,
                    setCloseMenu: setCloseMenu
                }) : null;
            case 0, (0, parcelRequire("eKt4x")).EDIT_DEPENDENCY:
                return (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-meatball-dependency-modal') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("g7ctu")).default), {
                    id: id,
                    setOpenModal: setOpenModal,
                    Option: Option
                }) : null;
            default:
                return null;
        }
    };
    var $77c9a04182fde288$export$2e2bcd8739ae039 = $77c9a04182fde288$var$ListItemMenuOption;
});
parcelRegister("dfknv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ce5898b3c31d4f0c$export$2e2bcd8739ae039);
    var $bC2fB;
    var $4EeLx;
    var $d5NBg;
    const $ce5898b3c31d4f0c$var$mapStateToProps = (state, { id: id })=>{
        const { isDateEditable: isDateEditable } = (0, (0, parcelRequire("4EeLx")).getBulkEditDatesOptionParams)(state, id);
        return {
            isDateEditable: isDateEditable
        };
    };
    var $ce5898b3c31d4f0c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($ce5898b3c31d4f0c$var$mapStateToProps)((0, (0, parcelRequire("d5NBg")).default));
});
parcelRegister("d5NBg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3253a3cd3a518b18$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eTXmK;
    var $4R6GH;
    var $koVbs;
    var $gR6KD;
    const $3253a3cd3a518b18$var$BulkEditDatesOption = ({ isDateEditable: isDateEditable, Option: Option, setOpenModal: setOpenModal, setInitialFocusRef: setInitialFocusRef })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const onClick = (0, $5uXOq.useCallback)((event)=>{
            event.preventDefault();
            if (!(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics')) (0, (0, parcelRequire("eTXmK")).default)('timeline-bulk-edit-dates-option-clicked', event.timeStamp);
            setOpenModal(event);
        }, [
            setOpenModal
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Option, {
            setInitialFocusRef: setInitialFocusRef,
            isDisabled: !isDateEditable,
            label: formatMessage((0, (0, parcelRequire("gR6KD")).default).bulkEditDates),
            onClick: onClick,
            ...(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics') ? {
                interactionName: 'timeline-bulk-edit-dates-option-clicked'
            } : {}
        });
    };
    var $3253a3cd3a518b18$export$2e2bcd8739ae039 = $3253a3cd3a518b18$var$BulkEditDatesOption;
});
parcelRegister("gR6KD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b37c03af4e9d569f$export$2e2bcd8739ae039);
    var $7VHMR;
    const $b37c03af4e9d569f$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        bulkEditDates: {
            "id": "roadmap.standard-roadmap.common.table.list-item-menu-option.bulk-edit-dates-option.bulk-edit-dates",
            "defaultMessage": "Edit dates"
        }
    });
    var $b37c03af4e9d569f$export$2e2bcd8739ae039 = $b37c03af4e9d569f$var$messages;
});
parcelRegister("2kCH3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$998d1fc966528275$export$2e2bcd8739ae039);
    var $bC2fB;
    var $4EeLx;
    var $lz3wL;
    const $998d1fc966528275$var$mapStateToProps = (state, { id: id })=>{
        const changeColorOptionParams = (0, (0, parcelRequire("4EeLx")).getChangeColorOptionParams)(state, id);
        return {
            ...changeColorOptionParams
        };
    };
    var $998d1fc966528275$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($998d1fc966528275$var$mapStateToProps)((0, (0, parcelRequire("lz3wL")).default));
});
parcelRegister("lz3wL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$496cd67a93121497$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6s1PB;
    var $4R6GH;
    var $koVbs;
    var $J6Kdu;
    var $9etyr;
    const $496cd67a93121497$var$ChangeColorOption = ({ id: id, isColorEditable: isColorEditable, color: color, Option: Option, setCloseMenu: setCloseMenu })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("J6Kdu")).ChangeColorMenuLazy).preload();
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Option, {
            isDisabled: !isColorEditable,
            ...(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics') ? {
                interactionName: 'timeline-change-color-primary-option-clicked'
            } : {},
            label: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("9etyr")).default).changeIssueColorIssueTermRefresh : (0, (0, parcelRequire("9etyr")).default).changeIssueColor)
        }, ({ setInitialFocusRef: setInitialFocusRef })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("J6Kdu")).ChangeColorMenuAsync), {
                id: id,
                color: color,
                setInitialFocusRef: setInitialFocusRef,
                setCloseMenu: setCloseMenu
            }));
    };
    var $496cd67a93121497$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($496cd67a93121497$var$ChangeColorOption);
});
parcelRegister("J6Kdu", function(module, exports) {
    $parcel$export(module.exports, "ChangeColorMenuLazy", ()=>$6b655bab128977e9$export$a0975b10625bf4cf);
    $parcel$export(module.exports, "ChangeColorMenuAsync", ()=>$6b655bab128977e9$export$82e69f06470e1e80);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $lfTZh;
    var $kxZPA;
    var $eKt4x;
    const $6b655bab128977e9$export$a0975b10625bf4cf = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("7aKoe")), {
        ssr: false,
        moduleId: "./src/packages/software/roadmap/standard/src/view/common/table/list-item-menu-option/change-color-option/change-color-menu/index.tsx"
    });
    const $6b655bab128977e9$export$82e69f06470e1e80 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "async-standard-roadmap-change-color-menu",
            packageName: (0, (0, parcelRequire("eKt4x")).ROADMAP_PACKAGE_NAME),
            fallback: "flag"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "async-standard-roadmap-change-color-menu",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($6b655bab128977e9$export$a0975b10625bf4cf, props)));
});
parcelRegister("7aKoe", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("dz0DQ").then(()=>parcelRequire('gCPmI'));
});
parcelRegister("9etyr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$64002676bd02f733$export$2e2bcd8739ae039);
    var $7VHMR;
    const $64002676bd02f733$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        changeIssueColor: {
            "id": "roadmap.standard-roadmap.common.table.list-item-menu-option.change-color-option.change-issue-color",
            "defaultMessage": "Change issue color"
        },
        changeIssueColorIssueTermRefresh: {
            "id": "roadmap.standard-roadmap.common.table.list-item-menu-option.change-color-option.change-issue-color-issue-term-refresh",
            "defaultMessage": "Change issue color"
        }
    });
    var $64002676bd02f733$export$2e2bcd8739ae039 = $64002676bd02f733$var$messages;
});
parcelRegister("kbzVx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f1e8fd268c1c5eab$export$2e2bcd8739ae039);
    var $bC2fB;
    var $4EeLx;
    var $bOlE0;
    const $f1e8fd268c1c5eab$var$mapStateToProps = (state, { id: id })=>{
        const { isDateEditable: isDateEditable } = (0, (0, parcelRequire("4EeLx")).getEditDatesOptionParams)(state, id);
        return {
            isDateEditable: isDateEditable
        };
    };
    var $f1e8fd268c1c5eab$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($f1e8fd268c1c5eab$var$mapStateToProps)((0, (0, parcelRequire("bOlE0")).default));
});
parcelRegister("bOlE0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c04d2442557f0886$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eTXmK;
    var $4R6GH;
    var $koVbs;
    var $iJbRn;
    const $c04d2442557f0886$var$EditDatesOption = ({ isDateEditable: isDateEditable, Option: Option, setOpenModal: setOpenModal })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const onClick = (0, $5uXOq.useCallback)((event)=>{
            event.preventDefault();
            if (!(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics')) (0, (0, parcelRequire("eTXmK")).default)('timeline-edit-dates-option-clicked', event.timeStamp);
            setOpenModal(event);
        }, [
            setOpenModal
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Option, {
            isDisabled: !isDateEditable,
            label: formatMessage((0, (0, parcelRequire("iJbRn")).default).editDates),
            onClick: onClick,
            ...(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics') ? {
                interactionName: 'timeline-edit-dates-option-clicked'
            } : {}
        });
    };
    var $c04d2442557f0886$export$2e2bcd8739ae039 = $c04d2442557f0886$var$EditDatesOption;
});
parcelRegister("iJbRn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bb976234edb7a3b9$export$2e2bcd8739ae039);
    var $7VHMR;
    const $bb976234edb7a3b9$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        editDates: {
            "id": "roadmap.standard-roadmap.common.table.list-item-menu-option.edit-dates-option.edit-dates",
            "defaultMessage": "Edit dates"
        }
    });
    var $bb976234edb7a3b9$export$2e2bcd8739ae039 = $bb976234edb7a3b9$var$messages;
});
parcelRegister("g7ctu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9a5287ccff6e3e3c$export$2e2bcd8739ae039);
    var $bC2fB;
    var $4gYYI;
    var $hFyhA;
    var $6ZUmP;
    const $9a5287ccff6e3e3c$var$mapStateToProps = (state, { id: id })=>({
            areDependenciesSupported: (0, (0, parcelRequire("4gYYI")).areDependenciesSupported)(state),
            isChildIssuePlanningEnabled: (0, (0, parcelRequire("4gYYI")).getIsChildIssuePlanningEnabled)(state),
            level: (0, (0, parcelRequire("hFyhA")).getIssueLevel)(state, id)
        });
    var $9a5287ccff6e3e3c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($9a5287ccff6e3e3c$var$mapStateToProps)((0, (0, parcelRequire("6ZUmP")).default));
});
parcelRegister("6ZUmP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$03f5984152ee677e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eTXmK;
    var $4R6GH;
    var $koVbs;
    var $joGLY;
    var $1H9h3;
    const $03f5984152ee677e$var$EditDependencyOption = ({ areDependenciesSupported: areDependenciesSupported, isChildIssuePlanningEnabled: isChildIssuePlanningEnabled, level: level, setOpenModal: setOpenModal, Option: Option })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const isDisabled = !(areDependenciesSupported && (isChildIssuePlanningEnabled || (0, (0, parcelRequire("joGLY")).isParentLevel)(level)));
        const onClick = (0, $5uXOq.useCallback)((event)=>{
            event.preventDefault();
            if (!(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics')) (0, (0, parcelRequire("eTXmK")).default)('timeline-edit-dependency-option-clicked', event.timeStamp);
            setOpenModal(event);
        }, [
            setOpenModal
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Option, {
            isDisabled: isDisabled,
            label: formatMessage((0, (0, parcelRequire("1H9h3")).default).editDependencies),
            onClick: onClick,
            ...(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics') ? {
                interactionName: 'timeline-edit-dependency-option-clicked'
            } : {}
        });
    };
    var $03f5984152ee677e$export$2e2bcd8739ae039 = $03f5984152ee677e$var$EditDependencyOption;
});
parcelRegister("1H9h3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fb73f7f2b9354b9a$export$2e2bcd8739ae039);
    var $7VHMR;
    const $fb73f7f2b9354b9a$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        editDependencies: {
            "id": "roadmap.standard-roadmap.common.table.list-item-menu-option.edit-dependency-option.edit-dependencies",
            "defaultMessage": "Edit dependencies"
        }
    });
    var $fb73f7f2b9354b9a$export$2e2bcd8739ae039 = $fb73f7f2b9354b9a$var$messages;
});
parcelRegister("1Do17", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7a31bdbf942614f5$export$2e2bcd8739ae039);
    var $bC2fB;
    var $4EeLx;
    var $9ECDu;
    const $7a31bdbf942614f5$var$mapStateToProps = (state, { id: id })=>{
        const editSprintOptionParams = (0, (0, parcelRequire("4EeLx")).getEditSprintOptionParams)(state, id);
        return {
            ...editSprintOptionParams
        };
    };
    var $7a31bdbf942614f5$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($7a31bdbf942614f5$var$mapStateToProps)((0, (0, parcelRequire("9ECDu")).default));
});
parcelRegister("9ECDu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$79c2e1467b9de311$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $koVbs;
    var $gaVgM;
    var $8485U;
    const $79c2e1467b9de311$var$EditSprintOption = ({ id: id, isSprintEditable: isSprintEditable, isSprintClearable: isSprintClearable, sprints: sprints, Option: Option, setCloseMenu: setCloseMenu })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("gaVgM")).EditSprintMenuLazy).preload();
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Option, {
            isDisabled: !isSprintEditable,
            label: formatMessage((0, (0, parcelRequire("8485U")).default).editSprint),
            ...(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics') ? {
                interactionName: 'timeline-edit-sprint-primary-option-clicked'
            } : {}
        }, ({ setInitialFocusRef: setInitialFocusRef })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gaVgM")).EditSprintMenuAsync), {
                id: id,
                isSprintClearable: isSprintClearable,
                sprints: sprints,
                setInitialFocusRef: setInitialFocusRef,
                setCloseMenu: setCloseMenu
            }));
    };
    var $79c2e1467b9de311$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($79c2e1467b9de311$var$EditSprintOption);
});
parcelRegister("gaVgM", function(module, exports) {
    $parcel$export(module.exports, "EditSprintMenuLazy", ()=>$93b5a265ea326e6a$export$a506603a6a72df89);
    $parcel$export(module.exports, "EditSprintMenuAsync", ()=>$93b5a265ea326e6a$export$68015483ad69dc68);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $lfTZh;
    var $kxZPA;
    var $eKt4x;
    const $93b5a265ea326e6a$export$a506603a6a72df89 = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("kSPpT")), {
        ssr: false,
        moduleId: "./src/packages/software/roadmap/standard/src/view/common/table/list-item-menu-option/edit-sprint-option/edit-sprint-menu/index.tsx"
    });
    const $93b5a265ea326e6a$export$68015483ad69dc68 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "async-standard-roadmap-edit-sprint-menu",
            packageName: (0, (0, parcelRequire("eKt4x")).ROADMAP_PACKAGE_NAME),
            fallback: "flag"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "async-standard-roadmap-edit-sprint-menu",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($93b5a265ea326e6a$export$a506603a6a72df89, props)));
});
parcelRegister("kSPpT", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lK2p3").then(()=>parcelRequire('gA1Ap'));
});
parcelRegister("8485U", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$766642d160989ba5$export$2e2bcd8739ae039);
    var $7VHMR;
    const $766642d160989ba5$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        editSprint: {
            "id": "roadmap.standard-roadmap.common.table.list-item-menu-option.edit-sprint-option.edit-sprint",
            "defaultMessage": "Edit sprint"
        }
    });
    var $766642d160989ba5$export$2e2bcd8739ae039 = $766642d160989ba5$var$messages;
});
parcelRegister("4ftbb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e2448da46d085d34$export$2e2bcd8739ae039);
    var $bC2fB;
    var $70YnB;
    var $1VLi2;
    var $4EeLx;
    var $5CKDj;
    const $e2448da46d085d34$var$mapStateToProps = (state, { id: id })=>{
        const { isDateEditable: isDateEditable, isStartDateRequired: isStartDateRequired, isDueDateRequired: isDueDateRequired, removeDatesOptionParams: removeDatesOptionParams } = (0, (0, parcelRequire("4EeLx")).getEditDatesOptionParams)(state, id);
        return {
            isDateEditable: isDateEditable,
            isStartDateRequired: isStartDateRequired,
            isDueDateRequired: isDueDateRequired,
            ...removeDatesOptionParams
        };
    };
    const $e2448da46d085d34$var$mapDispatchToProps = (dispatch, { id: id })=>({
            onClear: ({ isClearStart: isClearStart, isClearDue: isClearDue }, analyticsEvent)=>{
                dispatch((0, (0, parcelRequire("1VLi2")).updateAndPersistIssue)(id, {
                    clearFields: [
                        ...isClearStart ? [
                            (0, (0, parcelRequire("70YnB")).START_DATE)
                        ] : [],
                        ...isClearDue ? [
                            (0, (0, parcelRequire("70YnB")).DUE_DATE)
                        ] : []
                    ]
                }, analyticsEvent));
            }
        });
    var $e2448da46d085d34$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($e2448da46d085d34$var$mapStateToProps, $e2448da46d085d34$var$mapDispatchToProps)((0, (0, parcelRequire("5CKDj")).default));
});
parcelRegister("5CKDj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8c6ce5cec1d634c9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eZUJu;
    var $9UCCQ;
    var $eTXmK;
    var $4R6GH;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $eKt4x;
    var $h02tr;
    const $8c6ce5cec1d634c9$var$RemoveDatesOption = ({ isDateEditable: isDateEditable, isStartDateRequired: isStartDateRequired, isDueDateRequired: isDueDateRequired, isStartDateRolledUp: isStartDateRolledUp, isDueDateRolledUp: isDueDateRolledUp, isStartDateClearable: isStartDateClearable, isDueDateClearable: isDueDateClearable, Option: Option, onClear: onClear, setCloseMenu: setCloseMenu })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const handleOnClick = (0, $5uXOq.useCallback)((isStartDateCleared, isDueDateCleared)=>(event)=>{
                event.preventDefault();
                if (isStartDateCleared || isDueDateCleared) {
                    const analyticsEvent = createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'option'
                    });
                    const attributes = {
                        isStartDateCleared: isStartDateCleared,
                        isDueDateCleared: isDueDateCleared
                    };
                    if (!(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics')) {
                        let ufoInteractionName = 'timeline-remove-start-date-option-clicked';
                        if (isStartDateCleared && isDueDateCleared) ufoInteractionName = 'timeline-remove-both-dates-option-clicked';
                        else if (isDueDateCleared) ufoInteractionName = 'timeline-remove-due-date-option-clicked';
                        (0, (0, parcelRequire("eTXmK")).default)(ufoInteractionName, event.timeStamp);
                    }
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'removeDatesOption', attributes);
                    onClear({
                        isClearStart: isStartDateCleared,
                        isClearDue: isDueDateCleared
                    }, analyticsEvent);
                }
                setCloseMenu(event);
            }, [
            createAnalyticsEvent,
            onClear,
            setCloseMenu
        ]);
        const getDisabledTooltip = (0, $5uXOq.useCallback)((isDateRequired, isDateRolledUp)=>{
            if (isDateRequired) return formatMessage((0, (0, parcelRequire("h02tr")).default).requiredDates);
            if (isDateRolledUp) return formatMessage((0, (0, parcelRequire("h02tr")).default).rolledUpDates);
            return undefined;
        }, [
            formatMessage
        ]);
        const options = (0, $5uXOq.useMemo)(()=>[
                {
                    optionId: (0, (0, parcelRequire("eKt4x")).REMOVE_START_DATE),
                    isEnabled: isStartDateClearable,
                    label: formatMessage((0, (0, parcelRequire("h02tr")).default).removeStartDate),
                    disabledTooltip: getDisabledTooltip(isStartDateRequired, isStartDateRolledUp),
                    ...(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics') ? {
                        interactionName: 'timeline-remove-start-date-option-clicked'
                    } : {},
                    onClick: handleOnClick(true, false)
                },
                {
                    optionId: (0, (0, parcelRequire("eKt4x")).REMOVE_DUE_DATE),
                    isEnabled: isDueDateClearable,
                    label: formatMessage((0, (0, parcelRequire("h02tr")).default).removeDueDate),
                    disabledTooltip: getDisabledTooltip(isDueDateRequired, isDueDateRolledUp),
                    ...(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics') ? {
                        interactionName: 'timeline-remove-due-date-option-clicked'
                    } : {},
                    onClick: handleOnClick(false, true)
                },
                {
                    optionId: (0, (0, parcelRequire("eKt4x")).REMOVE_START_DATE_AND_DUE_DATE),
                    isEnabled: isStartDateClearable && isDueDateClearable,
                    label: formatMessage((0, (0, parcelRequire("h02tr")).default).removeBothDates),
                    disabledTooltip: getDisabledTooltip(isStartDateRequired || isDueDateRequired, isStartDateRolledUp || isDueDateRolledUp),
                    ...(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics') ? {
                        interactionName: 'timeline-remove-both-dates-option-clicked'
                    } : {},
                    onClick: handleOnClick(true, true)
                }
            ], [
            isStartDateRequired,
            isDueDateRequired,
            isStartDateRolledUp,
            isDueDateRolledUp,
            isStartDateClearable,
            isDueDateClearable,
            formatMessage,
            getDisabledTooltip,
            handleOnClick
        ]);
        const initialFocusIndex = (0, $5uXOq.useMemo)(()=>options.findIndex(({ isEnabled: isEnabled })=>isEnabled === true), [
            options
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Option, {
            isDisabled: !isDateEditable || !isStartDateClearable && !isDueDateClearable,
            label: formatMessage((0, (0, parcelRequire("h02tr")).default).removeDates),
            ...(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics') ? {
                interactionName: 'timeline-remove-dates-primary-option-clicked'
            } : {}
        }, ({ setInitialFocusRef: setInitialFocusRef })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZUJu")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), null, options.map(({ optionId: optionId, isEnabled: isEnabled, ...optionProps }, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement(Option, {
                    key: optionId,
                    isDisabled: !isEnabled,
                    setInitialFocusRef: index === initialFocusIndex ? setInitialFocusRef : undefined,
                    ...optionProps
                })))));
    };
    var $8c6ce5cec1d634c9$export$2e2bcd8739ae039 = $8c6ce5cec1d634c9$var$RemoveDatesOption;
});
parcelRegister("h02tr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fea7854f729758a4$export$2e2bcd8739ae039);
    var $7VHMR;
    const $fea7854f729758a4$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        removeDates: {
            "id": "roadmap.standard-roadmap.common.table.list-item-menu-option.remove-dates-option.remove-dates",
            "defaultMessage": "Remove dates"
        },
        removeStartDate: {
            "id": "roadmap.standard-roadmap.common.table.list-item-menu-option.remove-dates-option.remove-start-date",
            "defaultMessage": "Remove start date"
        },
        removeDueDate: {
            "id": "roadmap.standard-roadmap.common.table.list-item-menu-option.remove-dates-option.remove-due-date",
            "defaultMessage": "Remove due date"
        },
        removeBothDates: {
            "id": "roadmap.standard-roadmap.common.table.list-item-menu-option.remove-dates-option.remove-both-dates",
            "defaultMessage": "Remove both dates"
        },
        rolledUpDates: {
            "id": "roadmap.standard-roadmap.common.table.list-item-menu-option.remove-dates-option.rolled-up-dates",
            "defaultMessage": "This issue uses dates rolled up from child issues."
        },
        requiredDates: {
            "id": "roadmap.standard-roadmap.common.table.list-item-menu-option.remove-dates-option.required-dates",
            "defaultMessage": "Dates are required for this issue"
        }
    });
    var $fea7854f729758a4$export$2e2bcd8739ae039 = $fea7854f729758a4$var$messages;
});
parcelRegister("dyl9d", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$051e0172aed9f284$export$2e2bcd8739ae039);
    var $bC2fB;
    var $hFyhA;
    var $4MdU8;
    const $051e0172aed9f284$var$mapStateToProps = (state, { id: id })=>({
            issueLevel: (0, (0, parcelRequire("hFyhA")).getIssueLevel)(state, id)
        });
    var $051e0172aed9f284$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($051e0172aed9f284$var$mapStateToProps)((0, (0, parcelRequire("4MdU8")).default));
});
parcelRegister("4MdU8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$336b358e29569e92$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6s1PB;
    var $4R6GH;
    var $koVbs;
    var $joGLY;
    var $fJbPm;
    var $e6DFq;
    const $336b358e29569e92$var$ReparentMenuOption = (0, $5uXOq.memo)(({ id: id, issueLevel: issueLevel, Option: MenuOption, setCloseMenu: setCloseMenu })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("e6DFq")).ReparentMenuWrapperLazy).preload();
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(MenuOption, {
            label: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("fJbPm")).default).changeParentIssueIssueTermRefresh : (0, (0, parcelRequire("fJbPm")).default).changeParentIssue),
            isDisabled: issueLevel === (0, (0, parcelRequire("joGLY")).PARENT_LEVEL),
            ...(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics') ? {
                interactionName: 'timeline-reparent-primary-option-clicked'
            } : {}
        }, ({ setInitialFocusRef: setInitialFocusRef })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e6DFq")).ReparentMenuWrapperAsync), {
                id: id,
                setInitialFocusRef: setInitialFocusRef,
                setCloseMenu: setCloseMenu
            }));
    });
    var $336b358e29569e92$export$2e2bcd8739ae039 = $336b358e29569e92$var$ReparentMenuOption;
});
parcelRegister("fJbPm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2d1991ecf380639b$export$2e2bcd8739ae039);
    var $7VHMR;
    const $2d1991ecf380639b$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        changeParentIssue: {
            "id": "roadmap.standard-roadmap.common.table.list-item-menu-option.reparent-menu-option.change-parent-issue",
            "defaultMessage": "Change parent issue"
        },
        changeParentIssueIssueTermRefresh: {
            "id": "roadmap.standard-roadmap.common.table.list-item-menu-option.reparent-menu-option.change-parent-issue-issue-term-refresh",
            "defaultMessage": "Change parent issue"
        }
    });
    var $2d1991ecf380639b$export$2e2bcd8739ae039 = $2d1991ecf380639b$var$messages;
});
parcelRegister("e6DFq", function(module, exports) {
    $parcel$export(module.exports, "ReparentMenuWrapperLazy", ()=>$c1d7bb5e98c01456$export$5d57d752ff364a69);
    $parcel$export(module.exports, "ReparentMenuWrapperAsync", ()=>$c1d7bb5e98c01456$export$a904dbbf1ea9df1a);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $lfTZh;
    var $kxZPA;
    var $eKt4x;
    const $c1d7bb5e98c01456$export$5d57d752ff364a69 = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("aPhFT")), {
        ssr: false,
        moduleId: "./src/packages/software/roadmap/standard/src/view/common/table/list-item-menu-option/reparent-menu-option/reparent-menu-wrapper/index.tsx"
    });
    const $c1d7bb5e98c01456$export$a904dbbf1ea9df1a = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "async-standard-roadmap-reparent-menu",
            packageName: (0, (0, parcelRequire("eKt4x")).ROADMAP_PACKAGE_NAME),
            fallback: "flag"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "async-standard-roadmap-reparent-menu",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($c1d7bb5e98c01456$export$5d57d752ff364a69, props)));
});
parcelRegister("aPhFT", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("eGVdC").then(()=>parcelRequire('k5Cv8'));
});
parcelRegister("hFbeZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cca79975609e3962$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eKt4x;
    var $hciPA;
    var $7fdLc;
    var $4I7lF;
    const $cca79975609e3962$var$ListItemModal = ({ id: id, optionId: optionId, triggerRef: triggerRef, setCloseModal: setCloseModal })=>{
        switch(optionId){
            case 0, (0, parcelRequire("eKt4x")).EDIT_DATES:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7fdLc")).RoadmapEditDatesModalAsync), {
                    id: id,
                    isOpen: true,
                    setCloseModal: setCloseModal,
                    triggerRef: triggerRef
                });
            case 0, (0, parcelRequire("eKt4x")).BULK_EDIT_DATES:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hciPA")).RoadmapBulkEditDatesModalAsync), {
                    id: id,
                    isOpen: true,
                    setCloseModal: setCloseModal,
                    triggerRef: triggerRef
                });
            case 0, (0, parcelRequire("eKt4x")).EDIT_DEPENDENCY:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4I7lF")).RoadmapEditDependencyModalAsync), {
                    id: id,
                    isOpen: true,
                    setCloseModal: setCloseModal,
                    triggerRef: triggerRef
                });
            default:
                return null;
        }
    };
    var $cca79975609e3962$export$2e2bcd8739ae039 = $cca79975609e3962$var$ListItemModal;
});
parcelRegister("hciPA", function(module, exports) {
    $parcel$export(module.exports, "RoadmapBulkEditDatesModalAsync", ()=>$1bc4247e3a411f70$export$664ae1536c9b5580);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $lfTZh;
    var $kxZPA;
    var $eKt4x;
    const $1bc4247e3a411f70$var$BulkEditDatesModal = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("a9xgY")), {
        ssr: false,
        moduleId: "./src/packages/software/roadmap/standard/src/view/common/table/list-item-modal/bulk-edit-dates-modal/index.tsx"
    });
    const $1bc4247e3a411f70$export$664ae1536c9b5580 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "async-standard-roadmap-bulk-edit-dates-modal",
            packageName: (0, (0, parcelRequire("eKt4x")).ROADMAP_PACKAGE_NAME),
            fallback: "flag"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "async-standard-roadmap-bulk-edit-dates-modal",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($1bc4247e3a411f70$var$BulkEditDatesModal, props)));
});
parcelRegister("a9xgY", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("eF7Ek")
    ]).then(()=>parcelRequire('29tTI'));
});
parcelRegister("7fdLc", function(module, exports) {
    $parcel$export(module.exports, "RoadmapEditDatesModalAsync", ()=>$c2e0ee96486dcfeb$export$d6828597196b3015);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $lfTZh;
    var $kxZPA;
    var $eKt4x;
    const $c2e0ee96486dcfeb$var$EditDatesModal = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("kFHDG")), {
        ssr: false,
        moduleId: "./src/packages/software/roadmap/standard/src/view/common/table/list-item-modal/edit-dates-modal/index.tsx"
    });
    const $c2e0ee96486dcfeb$export$d6828597196b3015 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "async-standard-roadmap-edit-dates-modal",
            packageName: (0, (0, parcelRequire("eKt4x")).ROADMAP_PACKAGE_NAME),
            fallback: "flag"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "async-standard-roadmap-edit-dates-modal",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($c2e0ee96486dcfeb$var$EditDatesModal, props)));
});
parcelRegister("kFHDG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("78Rt8")
    ]).then(()=>parcelRequire('1YM2r'));
});
parcelRegister("4I7lF", function(module, exports) {
    $parcel$export(module.exports, "RoadmapEditDependencyModalAsync", ()=>$aa91ff48d557cdda$export$64cbfe5ad163da1b);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $lfTZh;
    var $kxZPA;
    var $eKt4x;
    const $aa91ff48d557cdda$var$EditDependencyModal = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("dN6cy")), {
        ssr: false,
        moduleId: "./src/packages/software/roadmap/standard/src/view/common/table/list-item-modal/edit-dependency-modal/index.tsx"
    });
    const $aa91ff48d557cdda$export$64cbfe5ad163da1b = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "async-standard-roadmap-edit-dependency-modal",
            packageName: (0, (0, parcelRequire("eKt4x")).ROADMAP_PACKAGE_NAME),
            fallback: "flag"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "async-standard-roadmap-edit-dependency-modal",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($aa91ff48d557cdda$var$EditDependencyModal, props)));
});
parcelRegister("dN6cy", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("bxQnx")
    ]).then(()=>parcelRequire('aWZ0K'));
});
parcelRegister("dHRcC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$25e45b766572f8db$export$2e2bcd8739ae039);
    var $bC2fB;
    var $5XT7o;
    var $1cn7Z;
    var $25e45b766572f8db$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((state, { id: id })=>({
            ...(0, (0, parcelRequire("1cn7Z")).getSecondaryFieldsHash)(state)[id]
        }), null, (stateProps)=>({
            ...stateProps
        }))((0, (0, parcelRequire("5XT7o")).RoadmapListItemSecondaryContent));
});
parcelRegister("5XT7o", function(module, exports) {
    $parcel$export(module.exports, "RoadmapListItemSecondaryContent", ()=>$0ab8b57d71c050d7$export$ea155116919dbf7);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $ujWmd;
    var $lj8SI;
    var $3bDjY;
    var $f9Owr;
    var $dCm1o;
    var $bAGvm;
    const $0ab8b57d71c050d7$var$TooltipTag = (0, $5uXOq.forwardRef)((props, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement($0ab8b57d71c050d7$var$AvatarContainer, {
            ref: ref,
            "data-export-assignee": true,
            ...props
        }));
    const $0ab8b57d71c050d7$export$ea155116919dbf7 = ({ status: status, assignee: assignee, flagged: flagged })=>{
        if ((0, (0, parcelRequire("f9Owr")).ff)('jsw.timeline.return-flagged-attribute-fe')) {
            if (!status && !assignee && !flagged) return null;
        } else if (!status && !assignee) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($0ab8b57d71c050d7$var$Container, null, (0, (0, parcelRequire("f9Owr")).ff)('jsw.timeline.return-flagged-attribute-fe') && flagged && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bAGvm")).FlagIcon), null), status && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
            appearance: status.appearance,
            maxWidth: 85,
            testId: "roadmap.timeline-table-kit.ui.list-item-secondary-content.export-status",
            isBold: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)()
        }, status.name), assignee && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: assignee.name,
            tag: $0ab8b57d71c050d7$var$TooltipTag
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
            testId: "roadmap.timeline-table-kit.ui.list-item-secondary-content.export-assignee",
            appearance: "circle",
            size: "xsmall",
            src: assignee.avatarUrl,
            name: assignee.name,
            borderColor: "transparent"
        })));
    };
    const $0ab8b57d71c050d7$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c116y _4cvr1h6o _18u01b66",
                __cmplp.className
            ])
        });
    });
    const $0ab8b57d71c050d7$var$AvatarContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_otyr1i6y _18u0u2gc",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("bAGvm", function(module, exports) {
    $parcel$export(module.exports, "FlagIcon", ()=>$38bfafd910866269$export$4fd8d63cb0915eb0);
    var $5uXOq = parcelRequire("5uXOq");
    var $7AWcD;
    var $dC5iT;
    var $8CUq3;
    var $koVbs;
    var $V8Q0j;
    const $38bfafd910866269$export$4fd8d63cb0915eb0 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $38bfafd910866269$var$flagSectionStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7AWcD"))))), {
            label: formatMessage((0, (0, parcelRequire("V8Q0j")).default).flagged),
            color: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`,
            LEGACY_size: "small"
        }));
    };
    const $38bfafd910866269$var$flagSectionStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginLeft: 'space.100'
    });
});
parcelRegister("7AWcD", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $58790b12091f30a4$var$_react = $58790b12091f30a4$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $58790b12091f30a4$var$_flagFilled = $58790b12091f30a4$var$_interopRequireDefault((parcelRequire("9ADwJ")));
    var $58790b12091f30a4$var$_flagFilled2 = $58790b12091f30a4$var$_interopRequireDefault((parcelRequire("iyN9w")));
    function $58790b12091f30a4$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $58790b12091f30a4$var$FlagFilledIcon = (props)=>$58790b12091f30a4$var$_react.default.createElement($58790b12091f30a4$var$_flagFilled.default, Object.assign({
            LEGACY_fallbackIcon: $58790b12091f30a4$var$_flagFilled2.default
        }, props));
    $58790b12091f30a4$var$FlagFilledIcon.Name = 'FlagFilledIconMigration';
    var $58790b12091f30a4$var$_default = module.exports.default = $58790b12091f30a4$var$FlagFilledIcon;
});
parcelRegister("9ADwJ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $6fb6230d529aad86$var$_react = $6fb6230d529aad86$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $6fb6230d529aad86$var$_UNSAFE_baseNew = $6fb6230d529aad86$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $6fb6230d529aad86$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $6fb6230d529aad86$var$FlagFilledIcon = (props)=>$6fb6230d529aad86$var$_react.default.createElement($6fb6230d529aad86$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" d="M14 1.75H2.75v8H14l-3-4z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M2.75 15V9.75m0 0v-8H14l-3 4 3 4z"/>`
        }, props));
    $6fb6230d529aad86$var$FlagFilledIcon.displayName = 'FlagFilledIcon';
    var $6fb6230d529aad86$var$_default = module.exports.default = $6fb6230d529aad86$var$FlagFilledIcon;
});
parcelRegister("iyN9w", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $d83187a0eb7b20f4$var$_react = $d83187a0eb7b20f4$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $d83187a0eb7b20f4$var$_flagFilled = $d83187a0eb7b20f4$var$_interopRequireDefault((parcelRequire("9ADwJ")));
    function $d83187a0eb7b20f4$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $d83187a0eb7b20f4$var$FlagFilledIcon = (props)=>$d83187a0eb7b20f4$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6 12.235v6.446c0 .537.45.977 1 .977s1-.44 1-.977v-5.778c1.17-.341 2.389-.045 3.768.29.982.238 2.036.495 3.13.495a5.7 5.7 0 0 0 2.547-.567 1 1 0 0 0 .563-.9V5.466a.998.998 0 0 0-1.437-.9c-1.345.654-2.731.317-4.331-.071-1.729-.42-3.687-.895-5.678.072A1 1 0 0 0 6 5.466z"/></svg>`
        }, props, {
            newIcon: $d83187a0eb7b20f4$var$_flagFilled.default
        }));
    $d83187a0eb7b20f4$var$FlagFilledIcon.displayName = 'FlagFilledIcon';
    var $d83187a0eb7b20f4$var$_default = module.exports.default = $d83187a0eb7b20f4$var$FlagFilledIcon;
});
parcelRegister("V8Q0j", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$34db1fe3f1b74c41$export$2e2bcd8739ae039);
    var $7VHMR;
    const $34db1fe3f1b74c41$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        flagged: {
            "id": "roadmap.timeline-table-kit.list-item-secondary-content.flag-icon.flagged",
            "defaultMessage": "Flagged"
        }
    });
    var $34db1fe3f1b74c41$export$2e2bcd8739ae039 = $34db1fe3f1b74c41$var$messages;
});
parcelRegister("jaLzQ", function(module, exports) {
    $parcel$export(module.exports, "marshalOptions", ()=>$d3b13646c24ccc5f$export$57eb6ddea50ecba1);
    const $d3b13646c24ccc5f$var$onRowDragStart = ({ styleAPI: styleAPI })=>{
        styleAPI.insertStyle((0, $0afb8a62e53619f1$export$1e54f8b472a07d8d), (0, $47a24b60f79a1111$export$b0ef8c040fd0c42f));
        styleAPI.insertStyle((0, $0afb8a62e53619f1$export$cd944e09ecad5145), (0, $47a24b60f79a1111$export$e281b974a204f69b));
    };
    const $d3b13646c24ccc5f$var$onRowDragEnd = ({ styleAPI: styleAPI })=>{
        styleAPI.removeStyle((0, $0afb8a62e53619f1$export$1e54f8b472a07d8d));
        styleAPI.removeStyle((0, $0afb8a62e53619f1$export$cd944e09ecad5145));
    };
    const $d3b13646c24ccc5f$var$onDependencyDragStart = ({ styleAPI: styleAPI })=>{
        styleAPI.insertStyle((0, $708c0d50a54aba38$export$c330e9be73819573), (0, $47a24b60f79a1111$export$db54e6da0a3ca8b5));
    };
    const $d3b13646c24ccc5f$var$onDependencyDragEnd = ({ styleAPI: styleAPI })=>{
        styleAPI.removeStyle((0, $708c0d50a54aba38$export$c330e9be73819573));
    };
    const $d3b13646c24ccc5f$var$onBarInteractionStart = ({ styleAPI: styleAPI })=>{
        styleAPI.insertStyle((0, $0afb8a62e53619f1$export$1e54f8b472a07d8d), (0, $47a24b60f79a1111$export$b0ef8c040fd0c42f));
        styleAPI.insertStyle((0, $0afb8a62e53619f1$export$cd944e09ecad5145), (0, $47a24b60f79a1111$export$e281b974a204f69b));
    };
    const $d3b13646c24ccc5f$var$onBarInteractionEnd = ({ styleAPI: styleAPI })=>{
        styleAPI.removeStyle((0, $0afb8a62e53619f1$export$1e54f8b472a07d8d));
        styleAPI.removeStyle((0, $0afb8a62e53619f1$export$cd944e09ecad5145));
    };
    const $d3b13646c24ccc5f$export$57eb6ddea50ecba1 = {
        customActions: {
            onDependencyDragStart: $d3b13646c24ccc5f$var$onDependencyDragStart,
            onDependencyDragEnd: $d3b13646c24ccc5f$var$onDependencyDragEnd,
            onBarInteractionStart: $d3b13646c24ccc5f$var$onBarInteractionStart,
            onBarInteractionEnd: $d3b13646c24ccc5f$var$onBarInteractionEnd
        },
        overrideActions: {
            onRowDragStart: $d3b13646c24ccc5f$var$onRowDragStart,
            onRowDragEnd: $d3b13646c24ccc5f$var$onRowDragEnd
        }
    };
});
const $47a24b60f79a1111$export$b0ef8c040fd0c42f = `
    opacity: 0;
`;
const $47a24b60f79a1111$export$e281b974a204f69b = `
    pointer-events: none;
`;
const $47a24b60f79a1111$export$db54e6da0a3ca8b5 = `
    pointer-events: all;
`;
parcelRegister("3Z7BC", function(module, exports) {
    $parcel$export(module.exports, "renderProvider", ()=>$4de260b7180275ca$export$de20b5e3308d9465);
    var $5uXOq = parcelRequire("5uXOq");
    var $bC2fB;
    var $gPXTo;
    var $4gYYI;
    var $bZFir;
    var $9gOpc;
    const $4de260b7180275ca$var$Provider = (0, (0, parcelRequire("bC2fB")).connect)((state)=>({
            items: (0, (0, parcelRequire("9gOpc")).getInteractiveChartItems)(state),
            selectedItemIds: (0, (0, parcelRequire("9gOpc")).getSelectedItemIdsMemoized)(state),
            intervals: (0, (0, parcelRequire("bZFir")).getSprintIntervals)(state),
            isDragAlongEnabled: (0, (0, parcelRequire("4gYYI")).getIsChildIssuePlanningEnabled)(state) && !(0, (0, parcelRequire("4gYYI")).getIsSprintsPlanningEnabled)(state)
        }), {})((0, (0, parcelRequire("gPXTo")).RoadmapChartItemInteractionProvider));
    const $4de260b7180275ca$export$de20b5e3308d9465 = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($4de260b7180275ca$var$Provider, null, children);
});
parcelRegister("9gOpc", function(module, exports) {
    $parcel$export(module.exports, "getInteractiveChartItems", ()=>$73a0e44fdba781af$export$8f9e7702b7f24610);
    $parcel$export(module.exports, "getSelectedItemIdsMemoized", ()=>$73a0e44fdba781af$export$191be9baae07fcee);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $joGLY;
    var $4gYYI;
    var $hFyhA;
    var $bZFir;
    var $1cn7Z;
    var $bM42j;
    const $73a0e44fdba781af$var$isItemInteractive = ({ level: level, hasSprint: hasSprint, isSprintsPlanning: isSprintsPlanning, isChildIssuePlanningEnabled: isChildIssuePlanningEnabled, isInCreation: isInCreation })=>{
        const isChildDateBasedPlanning = isChildIssuePlanningEnabled && (isSprintsPlanning && hasSprint || !isSprintsPlanning);
        if (!isInCreation && (level === (0, (0, parcelRequire("joGLY")).PARENT_LEVEL) || isChildDateBasedPlanning)) return true;
        return false;
    };
    const $73a0e44fdba781af$export$8f9e7702b7f24610 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("1cn7Z")).getChartDataHash), (0, (0, parcelRequire("hFyhA")).getIssueParentIdHash), (0, (0, parcelRequire("bM42j")).getExpandedItems), (0, (0, parcelRequire("bZFir")).getSanitisedIssueSprintsHash), (0, (0, parcelRequire("hFyhA")).getIssueCreationTransitionHash), (0, (0, parcelRequire("4gYYI")).getIsSprintsPlanningEnabled), (0, (0, parcelRequire("4gYYI")).getIsChildIssuePlanningEnabled), (0, (0, parcelRequire("4gYYI")).hasActiveOrFutureSprint), (chartDataHash, parentIdHash, expandedItems, issueSprintsHash, issueIsInCreationHash, isSprintsPlanning, isChildIssuePlanningEnabled, hasSprint)=>{
        const items = [];
        Object.keys(chartDataHash).forEach((issueId)=>{
            const { dueDate: dueDate, startDate: startDate, placeholder: placeholder, startDateType: startDateType, dueDateType: dueDateType } = chartDataHash[issueId];
            const parentId = parentIdHash[issueId];
            if (parentId === undefined || parentId && expandedItems[parentId]) {
                const sprints = issueSprintsHash[issueId];
                const level = parentId !== undefined ? (0, (0, parcelRequire("joGLY")).BASE_LEVEL) : (0, (0, parcelRequire("joGLY")).PARENT_LEVEL);
                const intervalId = (0, (0, parcelRequire("joGLY")).isBaseLevel)(level) ? sprints[0]?.id.toString() : undefined;
                const isInCreation = !!issueIsInCreationHash[issueId];
                if ($73a0e44fdba781af$var$isItemInteractive({
                    level: level,
                    hasSprint: hasSprint,
                    isSprintsPlanning: isSprintsPlanning,
                    isChildIssuePlanningEnabled: isChildIssuePlanningEnabled,
                    isInCreation: isInCreation
                })) items.push({
                    id: issueId,
                    dueDate: dueDate,
                    startDate: startDate,
                    placeholder: placeholder,
                    parentId: parentId,
                    level: level,
                    intervalId: intervalId,
                    startDateType: startDateType,
                    dueDateType: dueDateType
                });
            }
        });
        return items;
    });
    const $73a0e44fdba781af$export$191be9baae07fcee = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("bM42j")).getSelectedItemIds), (selectedItemIds)=>selectedItemIds.map(String));
});
parcelRegister("gu4dg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$253b31e9e196b3eb$export$2e2bcd8739ae039);
    var $bwpsq;
    var $lD23V;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $44v1T;
    var $4R6GH;
    var $jQsty;
    var $8CVvd;
    var $3HwlS;
    var $2Z6La;
    var $iXVV6;
    var $5oFIy;
    var $4MFiN;
    var $9hLEH;
    var $auJzk;
    var $caqVv;
    var $jA0eS;
    var $gaIrH;
    var $imS60;
    var $l8ruj;
    var $dCm1o;
    var $9MifT;
    var $a1W7K;
    var $6qMdq;
    var $bGMc6;
    class $253b31e9e196b3eb$var$StandardRoadmap extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                isHeaderHidden: false,
                onExperienceSuccess: (0, ($parcel$interopDefault($8Rkzz)))
            };
        }
        componentDidMount() {
            const { isHealthy: isHealthy, onLoaded: onLoaded, onExperienceSuccess: onExperienceSuccess } = this.props;
            isHealthy && onLoaded();
            onExperienceSuccess();
        }
        shouldComponentUpdate(nextProps) {
            return this.props.isHealthy !== nextProps.isHealthy || this.props.isHeaderHidden !== nextProps.isHeaderHidden || this.props.isServer !== nextProps.isServer || this.props.isMacroView !== nextProps.isMacroView;
        }
        componentDidUpdate(prevProps) {
            const { isHealthy: isHealthy, onLoaded: onLoaded } = this.props;
            if (isHealthy && !prevProps.isHealthy) onLoaded();
        }
        renderHeader() {
            const { Header: Header } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
                name: "roadmap-header"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(Header, null));
        }
        renderRoadmap() {
            const { Table: Table, isServer: isServer, RealtimeProvider: RealtimeProvider, isMacroView: isMacroView, isHeaderHidden: isHeaderHidden, issueIds: issueIds } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, isHeaderHidden ? null : this.renderHeader(), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                "data-fullscreen-id": (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? undefined : 'roadmap-container',
                "data-testid": "roadmap.standard-roadmap.roadmap-container",
                style: {
                    marginLeft: isMacroView ? '-1px' : 0,
                    marginTop: isHeaderHidden ? '-1px' : 0
                },
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && "_16jlkb7n _1o9zkb7n _i0dl1wug _bfhkvuon _kqswh2mm",
                    !(0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && "_16jlkb7n _1o9zkb7n _i0dl1wug _bfhkvuon _kqswh2mm _pvfmstnw _pxxhkb7n _q639idpf _ph9didpf _1do1idpf _1yagidpf _xfk61ejb _1ownutpp"
                ])
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2Z6La")).IccProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("imS60")).default), {
                name: "roadmap-table"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(Table, {
                isServer: isServer
            }))), !isServer && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bGMc6")).default), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4MFiN")).default), {
                issueIds: issueIds
            })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jA0eS")).AsyncScrumOnboardingModal), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("caqVv")).AsyncKanbanOnboardingModal), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("auJzk")).AsyncCustomerTemplatesOnboardingModal), null), !isMacroView && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gaIrH")).AsyncWelcomeModal), {
                source: "timeline"
            }), !(0, (0, parcelRequire("jQsty")).default)('roadmap_realtime') ? (0, ($parcel$interopDefault($5uXOq))).createElement(RealtimeProvider, null) : null);
        }
        render() {
            const { isHealthy: isHealthy, isMacroView: isMacroView, isClassic: isClassic, Healthcheck: Healthcheck, DocumentTitle: DocumentTitle, RouterUpdater: RouterUpdater, boardId: boardId, projectKey: projectKey, MountAnalytic: MountAnalytic, shouldMountKeyboardShortcuts: shouldMountKeyboardShortcuts, objectId: objectId, projectId: projectId, boardType: boardType, childIssuePlanningMode: childIssuePlanningMode } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
                containerType: "project",
                containerId: projectId,
                objectType: "board",
                objectId: objectId,
                attributes: {
                    projectId: projectId,
                    boardId: boardId,
                    boardType: boardType,
                    childIssuePlanningMode: childIssuePlanningMode
                }
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(DocumentTitle, null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9MifT")).InteractionMetricsExtraData), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6qMdq")).default), {
                isMacroView: isMacroView
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a1W7K")).default), null), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_vchhusvi _1e0c1txw _2lx21bp4 _1reo15vq _18m915vq",
                    isMacroView ? "_4t3i1kxc _19bvidpf" : (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap_drop_2') ? "_4t3i1l47 _19bv1ejb" : "_4t3i1l47 _19bv1ylp"
                ]),
                style: {
                    "--_1s93bfy": (0, (0, parcelRequire("lD23V")).default)((0, (0, parcelRequire("44v1T")).PAGE_LAYOUT_OFFSET_TOP))
                }
            }, isHealthy ? this.renderRoadmap() : (0, ($parcel$interopDefault($5uXOq))).createElement(Healthcheck, null)), shouldMountKeyboardShortcuts && (0, (0, parcelRequire("8CVvd")).getWillShowNav3)() && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9hLEH")).default), {
                boardId: boardId,
                projectKey: projectKey,
                isCMPBoard: isClassic
            }), (0, ($parcel$interopDefault($5uXOq))).createElement(RouterUpdater, null), (0, ($parcel$interopDefault($5uXOq))).createElement(MountAnalytic, null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), null));
        }
    }
    var $253b31e9e196b3eb$export$2e2bcd8739ae039 = $253b31e9e196b3eb$var$StandardRoadmap;
    const $253b31e9e196b3eb$var$containerStyles = null;
    const $253b31e9e196b3eb$var$roadmapContainerStylesOld = null;
    const $253b31e9e196b3eb$var$roadmapContainerStylesNewNavigation = null;
    const $253b31e9e196b3eb$var$macroViewStyles = null;
    const $253b31e9e196b3eb$var$nonMacroViewStylesOld = null;
    const $253b31e9e196b3eb$var$nonMacroViewStyles = null;
});
parcelRegister("2Z6La", function(module, exports) {
    $parcel$export(module.exports, "IccContext", ()=>$093fa356b2a966b6$export$2f62d2dfd027123d);
    $parcel$export(module.exports, "useIccContext", ()=>$093fa356b2a966b6$export$f7b8d088c9ea045e);
    $parcel$export(module.exports, "IccProvider", ()=>$093fa356b2a966b6$export$4a7497397d7465fc);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $cSD7y;
    const $093fa356b2a966b6$export$2f62d2dfd027123d = (0, $5uXOq.createContext)({
        initialSummary: '',
        initialCardTypeId: null,
        initialFieldValues: new Map(),
        initialProjectId: null,
        onChangeSummary: (0, ($parcel$interopDefault($8Rkzz))),
        onChangeCardType: (0, ($parcel$interopDefault($8Rkzz))),
        onChangeFieldValue: (0, ($parcel$interopDefault($8Rkzz))),
        onChangeProject: (0, ($parcel$interopDefault($8Rkzz))),
        onCancel: (0, ($parcel$interopDefault($8Rkzz))),
        onCreate: (0, ($parcel$interopDefault($8Rkzz)))
    });
    const $093fa356b2a966b6$export$f7b8d088c9ea045e = ()=>(0, $5uXOq.useContext)($093fa356b2a966b6$export$2f62d2dfd027123d);
    class $093fa356b2a966b6$var$IccProviderOld extends (0, $5uXOq.Component) {
        render() {
            return (0, ($parcel$interopDefault($5uXOq))).createElement($093fa356b2a966b6$export$2f62d2dfd027123d.Provider, {
                value: {
                    initialSummary: this.state.initialSummary,
                    initialCardTypeId: this.state.initialCardTypeId,
                    initialFieldValues: this.state.initialFieldValues,
                    initialProjectId: this.state.initialProjectId,
                    onChangeCardType: this.onChangeCardType,
                    onChangeSummary: this.onChangeSummary,
                    onChangeFieldValue: this.onChangeFieldValue,
                    onChangeProject: this.onChangeProject,
                    onCancel: this.onCancel,
                    onCreate: this.onCreate
                }
            }, this.props.children);
        }
        constructor(...args){
            super(...args);
            this.state = {
                initialSummary: '',
                initialCardTypeId: null,
                initialFieldValues: new Map(),
                initialProjectId: null
            };
            this.onChangeSummary = (summary)=>{
                this.setState({
                    initialSummary: summary
                });
            };
            this.onChangeProject = (projectId)=>{
                this.setState({
                    initialProjectId: projectId
                });
            };
            this.onChangeCardType = (cardTypeId)=>{
                this.setState({
                    initialCardTypeId: cardTypeId
                });
            };
            this.onChangeFieldValue = (fieldKey, fieldValue)=>{
                this.setState(({ initialFieldValues: initialFieldValues })=>({
                        initialFieldValues: initialFieldValues.set(fieldKey, fieldValue)
                    }));
            };
            this.onCancel = ()=>{
                this.setState({
                    initialSummary: '',
                    initialCardTypeId: null
                });
            };
            this.onCreate = ()=>{
                this.setState({
                    initialSummary: ''
                });
            };
        }
    }
    const $093fa356b2a966b6$var$IccProviderNew = (props)=>{
        const [state, setState] = (0, $5uXOq.useState)({
            initialSummary: '',
            initialCardTypeId: null,
            initialFieldValues: new Map(),
            initialProjectId: null
        });
        const onChangeSummary = (0, $5uXOq.useCallback)((summary)=>{
            setState((prevState)=>({
                    ...prevState,
                    initialSummary: summary
                }));
        }, []);
        const onChangeProject = (0, $5uXOq.useCallback)((projectId)=>{
            setState((prevState)=>({
                    ...prevState,
                    initialProjectId: projectId
                }));
        }, []);
        const onChangeCardType = (0, $5uXOq.useCallback)((cardTypeId)=>{
            setState((prevState)=>({
                    ...prevState,
                    initialCardTypeId: cardTypeId
                }));
        }, []);
        const onChangeFieldValue = (0, $5uXOq.useCallback)((fieldKey, fieldValue)=>{
            setState(({ initialFieldValues: initialFieldValues, ...prevState })=>({
                    ...prevState,
                    initialFieldValues: initialFieldValues.set(fieldKey, fieldValue)
                }));
        }, []);
        const onCancel = (0, $5uXOq.useCallback)(()=>{
            setState((prevState)=>({
                    ...prevState,
                    initialSummary: '',
                    initialCardTypeId: null
                }));
        }, []);
        const onCreate = (0, $5uXOq.useCallback)(()=>{
            setState((prevState)=>({
                    ...prevState,
                    initialSummary: ''
                }));
        }, []);
        const values = (0, $5uXOq.useMemo)(()=>({
                initialSummary: state.initialSummary,
                initialCardTypeId: state.initialCardTypeId,
                initialFieldValues: state.initialFieldValues,
                initialProjectId: state.initialProjectId,
                onChangeCardType: onChangeCardType,
                onChangeSummary: onChangeSummary,
                onChangeFieldValue: onChangeFieldValue,
                onChangeProject: onChangeProject,
                onCancel: onCancel,
                onCreate: onCreate
            }), [
            state,
            onChangeCardType,
            onChangeSummary,
            onChangeFieldValue,
            onChangeProject,
            onCancel,
            onCreate
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($093fa356b2a966b6$export$2f62d2dfd027123d.Provider, {
            value: values
        }, props.children);
    };
    const $093fa356b2a966b6$export$4a7497397d7465fc = (0, (0, parcelRequire("cSD7y")).componentWithFG)('board_rendering_optimisations', $093fa356b2a966b6$var$IccProviderNew, $093fa356b2a966b6$var$IccProviderOld);
});
parcelRegister("4MFiN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d8c7654d7458abfb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iINXJ;
    function $d8c7654d7458abfb$var$PrefetchClientOnly(props) {
        if (false) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iINXJ")).Prefetch), props);
    }
    var $d8c7654d7458abfb$export$2e2bcd8739ae039 = $d8c7654d7458abfb$var$PrefetchClientOnly;
});
parcelRegister("iINXJ", function(module, exports) {
    $parcel$export(module.exports, "Prefetch", ()=>$29ba10d1bace2883$export$a92e3edabc61a974);
    var $5uXOq = parcelRequire("5uXOq");
    var $l53am;
    class $29ba10d1bace2883$var$Prefetch extends (0, $5uXOq.Component) {
        constructor(props){
            super(props);
            this.fetchIssues(props.issueIds, props.issueKeys);
        }
        componentDidUpdate({ issueIds: prevIssueIds, issueKeys: prevIssueKeys }) {
            const { issueIds: issueIds, issueKeys: issueKeys } = this.props;
            if (prevIssueIds !== issueIds) {
                const newIds = issueIds.filter((issueId)=>{
                    const isTemporaryId = Number(issueId) < 0;
                    return !prevIssueIds.includes(issueId) && !isTemporaryId;
                });
                this.fetchIssues(newIds);
            }
            if (issueKeys && prevIssueKeys && prevIssueKeys !== issueKeys) this.fetchIssues([], issueKeys);
        }
        fetchIssues(issueIds, issueKeys) {
            if (issueIds.length > 0) this.props.dataProvider.loadIssuesById(issueIds.map((id)=>String(id)));
            if (issueKeys && issueKeys.length > 0) this.props.dataProvider.loadIssues(issueKeys);
        }
        render() {
            return null;
        }
    }
    const $29ba10d1bace2883$export$a92e3edabc61a974 = (0, (0, parcelRequire("l53am")).WithDataProvider)($29ba10d1bace2883$var$Prefetch);
});
parcelRegister("l53am", function(module, exports) {
    $parcel$export(module.exports, "WithDataProvider", ()=>$02b95a9a182f987c$export$b0017632f1661e1);
    var $5uXOq = parcelRequire("5uXOq");
    var $3H1wD;
    const $02b95a9a182f987c$export$b0017632f1661e1 = (WrappedComponent)=>(props)=>{
            const { dataProvider: dataProvider, ...otherProps } = props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3H1wD")).DataProviderContext).Consumer, null, (contextDataProvider)=>(0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                    ...otherProps,
                    dataProvider: dataProvider || contextDataProvider()
                }));
        };
});
parcelRegister("3H1wD", function(module, exports) {
    $parcel$export(module.exports, "DataProviderContext", ()=>$0843efd524aaa43a$export$5bce75db3a3f66c4);
    var $5uXOq = parcelRequire("5uXOq");
    var $7353r;
    const $0843efd524aaa43a$export$5bce75db3a3f66c4 = (0, $5uXOq.createContext)((0, (0, parcelRequire("7353r")).getDataProvider));
});
parcelRegister("7353r", function(module, exports) {
    $parcel$export(module.exports, "getDataProvider", ()=>$cd2cb3c904264bdf$export$add6bf8e4261fead);
    var $kVLXA = parcelRequire("kVLXA");
    parcelRequire("6hSeW");
    var $4Pf62;
    var $g5X3G;
    var $aS73q;
    const $cd2cb3c904264bdf$var$DEFAULT_EXPIRY_THRESHOLD_SECONDS = 3600;
    const $cd2cb3c904264bdf$var$DEFAULT_MAX_SIZE = 100;
    const $cd2cb3c904264bdf$var$getTenantBaseUrl = ()=>{
        try {
            return (0, (0, parcelRequire("g5X3G")).toBaseUrl)((0, (0, parcelRequire("4Pf62")).getTenantContext_DEPRECATED_DO_NOT_USE)().baseUrl);
        } catch (e) {
            return (0, (0, parcelRequire("g5X3G")).toBaseUrl)('');
        }
    };
    const $cd2cb3c904264bdf$var$createConfig = (config = {})=>{
        const defaultConfig = {
            expiryThresholdSeconds: $cd2cb3c904264bdf$var$DEFAULT_EXPIRY_THRESHOLD_SECONDS,
            maxSize: $cd2cb3c904264bdf$var$DEFAULT_MAX_SIZE,
            baseUrl: Object.prototype.hasOwnProperty.call(config, 'baseUrl') ? config.baseUrl : $cd2cb3c904264bdf$var$getTenantBaseUrl(),
            ssrCachedIssue: null
        };
        return Object.assign({}, defaultConfig, config);
    };
    const $cd2cb3c904264bdf$export$33c5e0ba77bb7d8 = (options = {})=>{
        const config = $cd2cb3c904264bdf$var$createConfig(options);
        const baseUrl = (0, (0, parcelRequire("g5X3G")).toBaseUrl)(config.baseUrl);
        const clearCache = ()=>{};
        const insertSerializedIssue = ()=>{};
        const loadIssues = ()=>{};
        const loadIssuesById = ()=>{};
        const getIssue = ()=>{};
        const loadIssue$ = ()=>(0, $kVLXA.Observable).empty();
        const getIssue$ = ()=>(0, $kVLXA.Observable).empty();
        const refreshIssue$ = ()=>loadIssue$();
        const getIssueRemoteData$ = (issueKey, cloudId, isIssueViewWhiteboardsStandaloneEnabled)=>isIssueViewWhiteboardsStandaloneEnabled ? (0, (0, parcelRequire("aS73q")).fetchIssueRemoteDataWithWhiteboards$)((0, (0, parcelRequire("g5X3G")).toIssueKey)(issueKey), (0, (0, parcelRequire("g5X3G")).toCloudId)(cloudId)) : (0, (0, parcelRequire("aS73q")).fetchIssueRemoteData$)(baseUrl, (0, (0, parcelRequire("g5X3G")).toIssueKey)(issueKey));
        const updateIssue = ()=>{};
        const getMetrics = ()=>({
                cacheSize: 0,
                cacheStaleCount: 0,
                cacheAvailableCapacity: 0,
                cacheHit: false,
                staleCacheHit: false
            });
        return {
            clearCache: clearCache,
            loadIssues: loadIssues,
            loadIssuesById: loadIssuesById,
            getIssue: getIssue,
            getIssue$: getIssue$,
            getIssueRemoteData$: getIssueRemoteData$,
            refreshIssue$: refreshIssue$,
            updateIssue: updateIssue,
            getMetrics: getMetrics,
            insertSerializedIssue: insertSerializedIssue
        };
    };
    let $cd2cb3c904264bdf$var$dataProvider;
    const $cd2cb3c904264bdf$export$add6bf8e4261fead = ()=>{
        if ($cd2cb3c904264bdf$var$dataProvider == null) $cd2cb3c904264bdf$var$dataProvider = $cd2cb3c904264bdf$export$33c5e0ba77bb7d8();
        return $cd2cb3c904264bdf$var$dataProvider;
    };
});
parcelRegister("aS73q", function(module, exports) {
    $parcel$export(module.exports, "fetchIssueRemoteData$", ()=>$f482d3f0ea8f2add$export$83220ed1a595568a);
    $parcel$export(module.exports, "fetchIssueRemoteDataWithWhiteboards$", ()=>$f482d3f0ea8f2add$export$3aec720cf88c26cd);
    var $kVLXA = parcelRequire("kVLXA");
    parcelRequire("d0pqD");
    parcelRequire("1oQta");
    parcelRequire("c66Ur");
    parcelRequire("6hSeW");
    var $aq199 = parcelRequire("aq199");
    var $e6C7w = parcelRequire("e6C7w");
    var $4cJXk = parcelRequire("4cJXk");
    var $cVFxd = parcelRequire("cVFxd");
    var $jEfnV = parcelRequire("jEfnV");
    var $1bLFJ;
    var $6r7fT;
    var $g5X3G;
    var $hcsJY;
    var $fb243;
    const $f482d3f0ea8f2add$var$LOG_LOCATION = 'issue.data-provider.source.issue-express';
    const $f482d3f0ea8f2add$var$getIssueKeyFromResponse = (response)=>{
        const fields = response.fields || [];
        const issueKeyField = fields.find((field)=>field.__typename === $a620d3896f16afcc$export$40bed7a29c3b629);
        if (!issueKeyField) throw new Error('Issue key field missing in graphql response');
        return (0, (0, parcelRequire("g5X3G")).toIssueKey)(issueKeyField.stringValue);
    };
    const $f482d3f0ea8f2add$var$transformGraphQlIssueRemoteData = (response, issueKey)=>{
        if (!response) return null;
        const key = issueKey || $f482d3f0ea8f2add$var$getIssueKeyFromResponse(response);
        const now = new Date();
        const { issueId: issueId, remoteLinks: remoteLinks } = response;
        return (0, (0, parcelRequire("hcsJY")).createIssue)({
            key: key
        }).withMeta({
            newIssueViewLockedIn: response.meta ? response.meta.newIssueViewLockedIn : false,
            dataSource: 'issueExpress',
            fetchTime: now
        }).withId(issueId).withRemoteLinks(remoteLinks).build();
    };
    const $f482d3f0ea8f2add$var$transformConfluenceWhiteboardData = (response)=>{
        const issueToWhiteboard = response?.graphStore?.issueToWhiteboard ?? {};
        const whiteboards = issueToWhiteboard.edges?.map(({ node: node })=>({
                whiteboardId: node.whiteboardId,
                author: {
                    ...node.author
                },
                href: `${node.links?.base}${node.links?.webUi}`,
                type: (0, (0, parcelRequire("1bLFJ")).CONFLUENCE_WHITEBOARD),
                id: node.id,
                title: node.title
            }));
        return {
            confluenceWhiteboards: {
                linkedWhiteboards: {
                    whiteboardCount: issueToWhiteboard.totalCount,
                    whiteboards: whiteboards
                }
            }
        };
    };
    const $f482d3f0ea8f2add$export$83220ed1a595568a = (baseUrl, issueKey)=>(0, (0, parcelRequire("fb243")).fetchIssueRemoteData)(baseUrl, issueKey).map((graphQlIssue)=>$f482d3f0ea8f2add$var$transformGraphQlIssueRemoteData(graphQlIssue, issueKey)).filter(Boolean).catch((err)=>{
            (0, (0, parcelRequire("6r7fT")).trackOrLogClientError)($f482d3f0ea8f2add$var$LOG_LOCATION, 'fetchIssueRemoteData: Failed to fetch issue remote data from gira', err);
            return (0, $kVLXA.Observable).empty();
        });
    const $f482d3f0ea8f2add$export$3aec720cf88c26cd = (issueKey, cloudId)=>(0, (0, parcelRequire("fb243")).fetchIssueRemoteData)('', issueKey).pipe((0, $jEfnV.switchMap)((remoteDataResponse)=>(0, (0, parcelRequire("fb243")).fetchIssueConfluenceWhiteboardData)(remoteDataResponse.issueId, cloudId).pipe((0, $cVFxd.map)((confluenceWhiteboardDataResponse)=>{
                const confluenceWhiteboards = $f482d3f0ea8f2add$var$transformConfluenceWhiteboardData(confluenceWhiteboardDataResponse);
                const combinedRemoteData = {
                    ...remoteDataResponse,
                    remoteLinks: {
                        ...remoteDataResponse.remoteLinks,
                        ...confluenceWhiteboards
                    }
                };
                return combinedRemoteData;
            }), (0, $cVFxd.map)((graphQlIssue)=>$f482d3f0ea8f2add$var$transformGraphQlIssueRemoteData(graphQlIssue, issueKey)), (0, $4cJXk.filter)(Boolean), (0, $e6C7w.catchError)((err)=>{
                (0, (0, parcelRequire("6r7fT")).trackOrLogClientError)($f482d3f0ea8f2add$var$LOG_LOCATION, 'fetchIssueConfluenceWhiteboardData: Failed to fetch confluence whiteboards from AGG', err);
                return (0, $aq199.of)($f482d3f0ea8f2add$var$transformGraphQlIssueRemoteData(remoteDataResponse, issueKey));
            }))), (0, $e6C7w.catchError)((err)=>{
            (0, (0, parcelRequire("6r7fT")).trackOrLogClientError)($f482d3f0ea8f2add$var$LOG_LOCATION, 'fetchIssueRemoteData: Failed to fetch issue remote data from gira', err);
            return (0, $kVLXA.Observable).empty();
        }));
});
parcelRegister("1bLFJ", function(module, exports) {
    $parcel$export(module.exports, "CONFLUENCE_BLOGPOST", ()=>$0864033b77341257$export$b0807d3d613e535);
    $parcel$export(module.exports, "CONFLUENCE_WHITEBOARD", ()=>$0864033b77341257$export$489cb2e515fef0c4);
    $parcel$export(module.exports, "toConfluencePageType", ()=>$0864033b77341257$export$a7ae1ae0a3d7d205);
    const $0864033b77341257$export$b0807d3d613e535 = 'blogpost';
    const $0864033b77341257$export$353109fb558251b1 = 'page';
    const $0864033b77341257$export$489cb2e515fef0c4 = 'whiteboard';
    const $0864033b77341257$export$a7ae1ae0a3d7d205 = (type)=>type === $0864033b77341257$export$b0807d3d613e535 ? $0864033b77341257$export$b0807d3d613e535 : $0864033b77341257$export$353109fb558251b1;
});
parcelRegister("6r7fT", function(module, exports) {
    $parcel$export(module.exports, "trackOrLogClientError", ()=>$cdae82c8a9c247d5$export$2fc29872103bf255);
    var $dJl1T;
    var $jcw0u;
    var $fZneA;
    const $cdae82c8a9c247d5$export$c392d6295c0a29c7 = (location, message, error)=>{
        (0, (0, parcelRequire("jcw0u")).default)({
            error: error,
            attributes: {
                message: message
            },
            meta: {
                id: location,
                packageName: 'jiraIssueViewCommonUtils'
            }
        });
    };
    const $cdae82c8a9c247d5$export$2fc29872103bf255 = (location, message, error)=>{
        if (error instanceof TypeError && (0, (0, parcelRequire("fZneA")).isClientFetchError)(error)) $cdae82c8a9c247d5$export$c392d6295c0a29c7(location, message, error);
        else (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData(location, message, error);
    };
});
parcelRegister("hcsJY", function(module, exports) {
    $parcel$export(module.exports, "createIssue", ()=>$b09eba4e8be21e93$export$b61347e00e271b8e);
    class $b09eba4e8be21e93$var$IssueBuilder {
        constructor({ key: key }){
            this.key = key;
            this.fields = new Map();
        }
        withMeta(meta) {
            this.meta = meta;
            return this;
        }
        withId(id) {
            this.id = id;
            return this;
        }
        withFields(fields) {
            fields.forEach(this.withField, this);
            return this;
        }
        withField(field) {
            if (field) this.fields.set(String(field.key), field);
            return this;
        }
        withRemoteLinks(remoteLinks) {
            this.remoteLinks = remoteLinks;
            return this;
        }
        withPreferences(myPreferences) {
            this.myPreferences = myPreferences;
            return this;
        }
        withComments(commentsData) {
            this.commentsData = commentsData;
            return this;
        }
        withWorkflow(workflow) {
            this.workflow = workflow;
            return this;
        }
        withActivitySortOrder(activitySortOrder) {
            this.activitySortOrder = activitySortOrder;
            return this;
        }
        build() {
            const meta = this.meta !== null && this.meta !== undefined ? this.meta : {
                dataSource: 'unknown',
                newIssueViewLockedIn: false,
                fetchTime: new Date()
            };
            const remoteLinks = this.remoteLinks !== null && this.remoteLinks !== undefined ? this.remoteLinks : {
                confluencePages: {
                    linkedPages: {
                        pageCount: 0
                    },
                    mentionedPages: {
                        pageCount: 0
                    }
                },
                confluenceWhiteboards: {
                    linkedWhiteboards: {
                        whiteboardCount: 0
                    }
                },
                webLinks: {
                    linkCount: 0
                },
                remoteLinkedIssues: []
            };
            const myPreferences = this.myPreferences !== null && this.myPreferences !== undefined ? this.myPreferences : {};
            let users = {};
            let comments = {
                totalCount: 0,
                startIndex: 0,
                comments: {}
            };
            if (this.commentsData !== null && this.commentsData !== undefined) {
                comments = {
                    totalCount: this.commentsData.totalCount,
                    startIndex: this.commentsData.startIndex,
                    comments: this.commentsData.comments
                };
                users = this.commentsData.users;
            }
            const workflow = this.workflow !== null && this.workflow !== undefined ? this.workflow : undefined;
            const activitySortOrder = this.activitySortOrder;
            const issue = {
                key: this.key,
                fields: this.fields,
                meta: meta,
                remoteLinks: remoteLinks,
                myPreferences: myPreferences,
                comments: comments,
                users: users,
                workflow: workflow,
                activitySortOrder: activitySortOrder,
                ...this.id !== null && this.id !== undefined ? {
                    id: this.id
                } : undefined
            };
            return issue;
        }
    }
    const $b09eba4e8be21e93$export$b61347e00e271b8e = ({ key: key })=>new $b09eba4e8be21e93$var$IssueBuilder({
            key: key
        });
});
parcelRegister("fb243", function(module, exports) {
    $parcel$export(module.exports, "fetchIssueRemoteData", ()=>$0c2e88a5dd27b6f5$export$619c3be06a997564);
    $parcel$export(module.exports, "fetchIssueConfluenceWhiteboardData", ()=>$0c2e88a5dd27b6f5$export$886e1cd5d478fbe5);
    parcelRequire("fp4O3");
    parcelRequire("3q49N");
    parcelRequire("d0pqD");
    parcelRequire("fPS7b");
    var $487fd;
    var $fqpdr;
    var $dvijh;
    var $fKtck;
    var $POnYB;
    var $gxWw1;
    var $gmIuw;
    const $0c2e88a5dd27b6f5$var$NUM_INITIAL_COMMENTS_TO_LOAD = 5;
    const $0c2e88a5dd27b6f5$var$CREATED_ORDER_DESCENDING = '-created';
    const $0c2e88a5dd27b6f5$var$commentParameter = ()=>{
        const { hasPermalink: hasPermalink, permalinkId: permalinkId } = (0, (0, parcelRequire("fKtck")).getPermalinkStatus)((0, (0, parcelRequire("dvijh")).COMMENTS));
        return hasPermalink ? `, commentId: ${permalinkId}` : '';
    };
    const $0c2e88a5dd27b6f5$var$LOG_LOCATION = 'issue.data-provider.source.issue-express.graphql';
    const $0c2e88a5dd27b6f5$var$VIEW_ISSUE_ALIAS = 'bentoViewIssue';
    const $0c2e88a5dd27b6f5$var$addQueryForRemoteLinks = ()=>`remoteLinks {
       isLinkingEnabled
       confluencePages {
         linkedPages {
            pageCount
         }
         mentionedPages {
            pageCount
         }
       }
     }`;
    const $0c2e88a5dd27b6f5$var$getCommentsQuery = ()=>{
        const commentAmountParameter = `, commentAmount: ${Math.floor($0c2e88a5dd27b6f5$var$NUM_INITIAL_COMMENTS_TO_LOAD / 2)}`;
        const orderByParameter = `, orderBy: "${$0c2e88a5dd27b6f5$var$CREATED_ORDER_DESCENDING}"`;
        const query = `comments (first: 0, maxResults: ${$0c2e88a5dd27b6f5$var$NUM_INITIAL_COMMENTS_TO_LOAD}${orderByParameter}, isPreview: true ${$0c2e88a5dd27b6f5$var$commentParameter()}${commentAmountParameter}) {
            nodes{
              id
              author {
                  accountId
                  displayName
                  avatarUrl
              }
              updateAuthor {
                  accountId
                  displayName
                  avatarUrl
              }
              visibility {
                  type
                  value
              }
              created
              updated
              jsdPublic
              bodyAdf
              jsdAuthorCanSeeRequest
            }
            totalCount
            startIndex
          }
        `;
        return query;
    };
    const $0c2e88a5dd27b6f5$export$895cf5b64d42d88d = ()=>`
        issueId
        fields {
            __typename

            ... on ProjectField {
                fieldKey
                type
                simplified
                name
            }

            ... on TextField {
                fieldKey
                title
                isEditable
                textValue
                adf
                renderer
            }

            ... on IssueTypeField {
              fieldKey
              id
              iconUrl
              name
            }

            ... on StatusField {
              fieldKey
              name
              statusCategoryId
            }

            ... on IssueKeyField {
              fieldKey
              stringValue
            }

            ... on PriorityField {
              fieldKey
              title
              isEditable
              iconUrl
              name
              id
            }

            ... on UserField {
              fieldKey
              title
              isEditable
              userValue {
                displayName
                avatarUrl
                accountId
              }
            }

            ... on VersionsField {
              fieldKey
              title
              isEditable
              versions {
                id
                name
              }
            }

            ... on LabelsField {
              fieldKey
              title
              isEditable
              labels
            }

            ... on ProjectComponentsField {
              fieldKey
              title
              isEditable
              componentValues {
                id
                name
              }
            }

            ... on TimeTrackingField {
              fieldKey
              title
              isEditable
              originalEstimate {
                estimateSeconds
              }
              remainingEstimate {
                estimateSeconds
              }
              timeSpent {
                estimateSeconds
              }
            }

            ... on StoryPointsField {
              fieldKey
              title
              isEditable
              floatValue
            }

            ... on EpicLinkField {
              fieldKey
              title
              isEditable
              epic {
                id
                key
                name
                summary
                colorKey
                done
              }
            }

            ... on EpicNameField {
              fieldKey
              stringValue
              title
              isEditable
            }

            ... on EpicStatusField {
              fieldKey
              title
              isEditable
              selectedValue {
                  optionId
                  value
              }
            }

            ... on SprintCustomField {
              fieldKey
              title
              isEditable
              values {
                id
                name
                goal
                state
                boardId
                startDate
                endDate
                completeDate
              }
            }

            ... on SelectCustomField {
              fieldKey
              title
              isEditable
              selectedValue {
                  optionId
                  value
              }
            }

            ... on CascadingSelectCustomField {
              fieldKey
              title
              isEditable
              selectedValue {
                  optionId
                  value
                  child {
                    optionId
                    value
                  }
              }
            }

            ... on UserPickerCustomField {
              fieldKey
              title
              isEditable
              selectedUser {
                displayName
                avatarUrl
              }
            }

            ... on TextAreaCustomField {
              fieldKey
              title
              isEditable
              wiki
              adf
              renderer
              textValue
            }

            ... on FloatCustomField {
              fieldKey
              title
              isEditable
              floatValue
            }

            ... on DatePickerCustomField {
              fieldKey
              title
              isEditable
              stringValue
            }

            ... on DateTimeCustomField {
              fieldKey
              title
              isEditable
              dateTime
            }

            ... on TextFieldCustomField {
              fieldKey
              title
              isEditable
              wiki
            }

            ... on MultiSelectCustomField {
              fieldKey
              title
              isEditable
              selectedValues {
                  optionId
                  value
              }
            }

            ... on LabelsCustomField {
              fieldKey
              title
              isEditable
              labels
            }

            ... on MultiUserPickerCustomField {
              fieldKey
              title
              isEditable
              selectedUsers {
                accountId
                displayName
                avatarUrl
              }
            }

            ... on UrlCustomField {
              fieldKey
              title
              isEditable
              url
            }

            ... on VersionCustomField {
              fieldKey
              title
              isEditable
              version {
                  id
                  name
              }
            }

            ... on GroupPickerCustomField {
              fieldKey
              title
              isEditable
              group
            }

            ... on MultiVersionCustomField {
              fieldKey
              title
              isEditable
              versions {
                  id
                  name
              }
            }

            ... on MultiGroupPickerCustomField {
              fieldKey
              title
              isEditable
              groups
            }

            ... on DateField {
              fieldKey
              stringValue
              isEditable
              title
            }

            ... on CheckBoxesCustomField {
                fieldKey
                isEditable
                title
                selectedValues {
                    optionId
                    value
                }
            }

            ... on RadioButtonsCustomField {
                fieldKey
                isEditable
                title
                selectedValue {
                    optionId
                    value
                }
            }

            ... on ColorField {
                fieldKey
                isEditable
                title
                stringValue
            }

            ... on EpicColorField {
                fieldKey
                isEditable
                title
                stringValue
            }

            ... on ResolutionField {
                id
                fieldKey
                name
            }

            ... on FlaggedCustomField {
                fieldKey
                title
                isFlagged
                isEditable
                selectedValues {
                    optionId
                    value
                }
            }

            ... on ProjectCustomField {
              fieldKey
              key
              name
              title
              avatarUrl
              isEditable
            }
        }
        ${$0c2e88a5dd27b6f5$var$addQueryForRemoteLinks()}
        ${$0c2e88a5dd27b6f5$var$getCommentsQuery()}
    `;
    const $0c2e88a5dd27b6f5$var$getQueryPrefix = ()=>'_all';
    const $0c2e88a5dd27b6f5$var$getFieldPinningPreference = (projectKey)=>projectKey != null ? `"jira.user.issue.details.pinned-fields.${projectKey}",` : '';
    const $0c2e88a5dd27b6f5$var$getQueryForMyPreferences = (projectKey)=>`
    myPreferences(keys: [
        "jira.user.issue.changeboarding.lastinteracted",
        "jira.user.issue.clickthrough-banner.lastinteracted",
        "jira.user.issue.pinned-fields-banner.lastinteracted",
        ${$0c2e88a5dd27b6f5$var$getFieldPinningPreference(projectKey)}
    ])`;
    const $0c2e88a5dd27b6f5$var$getProjectQueryFragment = (projectKey)=>`
    project(projectKey: "${projectKey}") {
        newIssueViewLockedIn
    }
`;
    const $0c2e88a5dd27b6f5$export$71eec30d9db46a56 = (projectKey)=>`query issueViewQuery($issueKey: String!) {
    ${$0c2e88a5dd27b6f5$var$getQueryForMyPreferences(projectKey)}
    ${projectKey !== undefined ? $0c2e88a5dd27b6f5$var$getProjectQueryFragment(projectKey) : ''}
    ${$0c2e88a5dd27b6f5$var$VIEW_ISSUE_ALIAS}${$0c2e88a5dd27b6f5$var$getQueryPrefix()}: viewIssue(issueKey: $issueKey) {
        ${$0c2e88a5dd27b6f5$export$895cf5b64d42d88d()}
    }
    activitySortOrder
}
`;
    const $0c2e88a5dd27b6f5$var$getFieldDataOptions = (query, variables)=>({
            method: 'POST',
            body: JSON.stringify({
                query: query,
                variables: variables
            }),
            perf: (0, (0, parcelRequire("POnYB")).fetchIssueExpressPerf)
        });
    const $0c2e88a5dd27b6f5$export$619c3be06a997564 = (baseUrl, issueKey)=>(0, (0, parcelRequire("487fd")).default)((0, (0, parcelRequire("fqpdr")).getGiraUrl)(baseUrl, 'issueViewRemoteDataQuery'), $0c2e88a5dd27b6f5$var$getFieldDataOptions((0, (0, parcelRequire("gxWw1")).getIssueRemoteDataQuery)(), {
            issueKey: issueKey
        })).map((response)=>(0, (0, parcelRequire("gmIuw")).getGraphQlData)($0c2e88a5dd27b6f5$var$LOG_LOCATION, response)).map((value)=>value[`${$0c2e88a5dd27b6f5$var$VIEW_ISSUE_ALIAS}${(0, (0, parcelRequire("gxWw1")).getRemoteDataQueryPrefix)()}`]);
    const $0c2e88a5dd27b6f5$export$886e1cd5d478fbe5 = (issueId, cloudId)=>(0, (0, parcelRequire("487fd")).default)('/gateway/api/graphql?operation=issueViewRemoteConfluenceWhiteboardQuery', $0c2e88a5dd27b6f5$var$getFieldDataOptions((0, (0, parcelRequire("gxWw1")).getIssueRemoteConfluenceWhiteboardQuery)(), {
            id: `ari:cloud:jira:${cloudId}:issue/${issueId}`
        })).map((response)=>(0, (0, parcelRequire("gmIuw")).getGraphQlData)($0c2e88a5dd27b6f5$var$LOG_LOCATION, response));
});
parcelRegister("dvijh", function(module, exports) {
    $parcel$export(module.exports, "COMMENTS", ()=>$1403612d0fe1296c$export$4cab9dfa8fc858f4);
    $parcel$export(module.exports, "WORKLOG", ()=>$1403612d0fe1296c$export$df36fc05622c402);
    $parcel$export(module.exports, "PermalinkType", ()=>$1403612d0fe1296c$export$b18d061fc042df1a);
    const $1403612d0fe1296c$export$4cab9dfa8fc858f4 = 'Comments';
    const $1403612d0fe1296c$export$df36fc05622c402 = 'Worklog';
    const $1403612d0fe1296c$export$b18d061fc042df1a = {
        COMMENTS: 'focusedCommentId',
        WORKLOG: 'focusedWorklogId'
    };
});
parcelRegister("fKtck", function(module, exports) {
    $parcel$export(module.exports, "getPermalinkTypeAndId", ()=>$11ab2af1eff70e7f$export$f72cac1fa8a03e80);
    $parcel$export(module.exports, "getPermalinkStatus", ()=>$11ab2af1eff70e7f$export$f79ae8c396759c89);
    $parcel$export(module.exports, "getUrlPermalinkParameter", ()=>$11ab2af1eff70e7f$export$b66f3e03c722c21c);
    var $8QpSo;
    var $ebyGx = parcelRequire("ebyGx");
    var $dvijh;
    const $11ab2af1eff70e7f$export$58d3deae755361f = (0, (0, parcelRequire("8QpSo")).default)((searchString)=>{
        const params = (0, ($parcel$interopDefault($ebyGx))).parseUrl(searchString).query;
        if (params[(0, (0, parcelRequire("dvijh")).PermalinkType).COMMENTS]) return {
            permalinkType: (0, (0, parcelRequire("dvijh")).COMMENTS),
            permalinkId: params[(0, (0, parcelRequire("dvijh")).PermalinkType).COMMENTS]
        };
        if (params[(0, (0, parcelRequire("dvijh")).PermalinkType).WORKLOG]) return {
            permalinkType: (0, (0, parcelRequire("dvijh")).WORKLOG),
            permalinkId: params[(0, (0, parcelRequire("dvijh")).PermalinkType).WORKLOG]
        };
        return null;
    });
    const $11ab2af1eff70e7f$export$f72cac1fa8a03e80 = ()=>$11ab2af1eff70e7f$export$58d3deae755361f(window.location.search);
    const $11ab2af1eff70e7f$export$f79ae8c396759c89 = (targetPermalinkType)=>{
        const { permalinkId: permalinkId, permalinkType: permalinkType } = $11ab2af1eff70e7f$export$f72cac1fa8a03e80() || {};
        const hasPermalink = permalinkType === targetPermalinkType && permalinkId != null;
        return {
            hasPermalink: hasPermalink,
            permalinkId: hasPermalink ? permalinkId : ''
        };
    };
    const $11ab2af1eff70e7f$export$b66f3e03c722c21c = (id, permalinkType)=>{
        const pathName = window.location.pathname;
        let urlQueryParam = `?${permalinkType}=${id}`;
        if (/\/jira\/software\/c\/projects\/[^/]*\/boards\/.*/.test(pathName) || /\/jira\/people\/.*\/boards\/.*/.test(pathName) || pathName === '/secure/RapidBoard.jspa' || pathName.startsWith('/jira/software/projects/') && pathName.split('/')[5] === 'boards' || pathName.startsWith('/jira/servicedesk/projects/') && pathName.split('/')[5] === 'queues') {
            const url = new URL(window.location.href);
            url.searchParams.delete(permalinkType === (0, (0, parcelRequire("dvijh")).PermalinkType).WORKLOG ? (0, (0, parcelRequire("dvijh")).PermalinkType).COMMENTS : (0, (0, parcelRequire("dvijh")).PermalinkType).WORKLOG);
            url.searchParams.set(permalinkType, id);
            urlQueryParam = url.search;
        }
        return urlQueryParam;
    };
});
parcelRegister("POnYB", function(module, exports) {
    $parcel$export(module.exports, "fetchIssueExpressPerf", ()=>$a1e38295f63ccee3$export$9040f8aef1f66451);
    const $a1e38295f63ccee3$var$ISSUE_DETAILS_ANALYTICS_PREFIX = 'ISSUE_DETAILS';
    const $a1e38295f63ccee3$var$FETCH_ISSUE_EXPRESS_REQUEST = 'FETCH_ISSUE_EXPRESS';
    const $a1e38295f63ccee3$export$9040f8aef1f66451 = {
        key: $a1e38295f63ccee3$var$FETCH_ISSUE_EXPRESS_REQUEST,
        prefix: $a1e38295f63ccee3$var$ISSUE_DETAILS_ANALYTICS_PREFIX
    };
});
parcelRegister("gxWw1", function(module, exports) {
    $parcel$export(module.exports, "getRemoteDataQueryPrefix", ()=>$12e83d615b5da262$export$1a164444721ce2fb);
    $parcel$export(module.exports, "getIssueRemoteDataQuery", ()=>$12e83d615b5da262$export$65f9808f978ee25);
    $parcel$export(module.exports, "getIssueRemoteConfluenceWhiteboardQuery", ()=>$12e83d615b5da262$export$8ec691b48e552cf4);
    const $12e83d615b5da262$var$VIEW_ISSUE_ALIAS = 'bentoViewIssue';
    const $12e83d615b5da262$var$getUserQueryFragment = ()=>`
    user {
        key
        accountId
        emailAddress
        avatarUrl
        displayName
        active
    }
`;
    const $12e83d615b5da262$var$getConfluencePagesQueryFragment = ()=>`
    pages {
        ... on ConfluencePage {
            id
            globalId
            href
            title
            type
            lastUpdatedContext {
                ${$12e83d615b5da262$var$getUserQueryFragment()}
            }
        }
        ... on FailedRemoteLink {
            id
            error
            link {
                id
                globalId
                href
            }
            repairLink { href }
        }
    }
`;
    const $12e83d615b5da262$var$getConfluencePageGroupQueryFragment = ()=>`
    pageCount
    ${$12e83d615b5da262$var$getConfluencePagesQueryFragment()}
`;
    const $12e83d615b5da262$var$getRemoteLinkedIssuesPreviewFragment = ()=>`
    id
    issueId
    globalId
    href
    applicationType
    applicationName
    relationship
    title
`;
    const $12e83d615b5da262$var$getAssociatedIssueFragment = ()=>`
    issueId
    issueKey {
        stringValue
    }
    summary {
        textValue
    }
    status {
        statusCategoryId
        name
        statusId
    }
    priority {
        iconUrl
        name
    }
    issueType {
        iconUrl
        name
    }
    assignee {
        userValue
        {
            displayName
            avatarUrl
        }
    }
   isResolved
`;
    const $12e83d615b5da262$var$getRemoteLinkedIssuesDetailsFragment = ()=>`
    ... on AssociatedIssueWrapper {
        associatedIssue {
            ${$12e83d615b5da262$var$getAssociatedIssueFragment()}
        }
    }
    ... on FailedRemoteIssue {
        error
        repairLink { href }
    }
`;
    const $12e83d615b5da262$var$getRemoteLinkedIssuesFragment = ()=>`
    remoteLinkedIssues {
        preview {
            ${$12e83d615b5da262$var$getRemoteLinkedIssuesPreviewFragment()}
        }
        details {
            ${$12e83d615b5da262$var$getRemoteLinkedIssuesDetailsFragment()}
        }
    }
`;
    const $12e83d615b5da262$export$761fd517f0dda983 = ()=>`
    webLinks(allowThirdParties: true, orderBy: "-id") {
        linkCount
        links {
            id
            href
            linkText
            iconUrl
            summary
            resolved
            relationship
            applicationName
            applicationType
        }
    }
`;
    const $12e83d615b5da262$var$getRemoteDataQueryFragment = ()=>`
    issueId
    remoteLinks {
       isLinkingEnabled
       confluencePages {
            linkedPages {
                ${$12e83d615b5da262$var$getConfluencePageGroupQueryFragment()}
            }
            mentionedPages {
                ${$12e83d615b5da262$var$getConfluencePageGroupQueryFragment()}
            }
        }
        ${$12e83d615b5da262$export$761fd517f0dda983()}
        ${$12e83d615b5da262$var$getRemoteLinkedIssuesFragment()}
    }
`;
    const $12e83d615b5da262$export$1a164444721ce2fb = ()=>'_remote_data';
    const $12e83d615b5da262$export$65f9808f978ee25 = ()=>`
    query issueViewRemoteDataQuery($issueKey: String!) {
        ${$12e83d615b5da262$var$VIEW_ISSUE_ALIAS}${$12e83d615b5da262$export$1a164444721ce2fb()}: viewIssue(issueKey: $issueKey) {
            ${$12e83d615b5da262$var$getRemoteDataQueryFragment()}
        }
    }
`;
    const $12e83d615b5da262$export$8ec691b48e552cf4 = ()=>`
    query issueViewRemoteConfluenceWhiteboardQuery($id: ID!) {
        graphStore @optIn(to: "GraphStore") {
            issueToWhiteboard (id: $id first: 900) @optIn(to: "GraphStoreIssueToWhiteboard") {
                edges {
                    node {
                        ... on ConfluenceWhiteboard {
                            id
                            links {
                                base
                                webUi
                            }
                            author {
                                user {
                                accountId
                                accountStatus
                                name
                                picture
                                }
                            }
                            title
                            whiteboardId
                        }
                    }
                }
                totalCount
            }
        }
    }
`;
});
parcelRegister("gmIuw", function(module, exports) {
    $parcel$export(module.exports, "getGraphQlData", ()=>$cfd7686b41fd6499$export$b30cdd26702abb9d);
    $parcel$export(module.exports, "checkEmptyResponse", ()=>$cfd7686b41fd6499$export$a0603b0ff181c30a);
    var $dJl1T;
    var $jJZqs;
    var $g81XS;
    const $cfd7686b41fd6499$export$b30cdd26702abb9d = (logLocation, graphQlResponse)=>{
        if (graphQlResponse.errors) {
            const firstError = graphQlResponse.errors[0];
            const validationError = new (0, (0, parcelRequire("jJZqs")).ValidationError)(firstError.message);
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData(logLocation, 'getGraphQlData: Error present in GraphQL response', validationError);
            throw validationError;
        }
        return graphQlResponse.data;
    };
    const $cfd7686b41fd6499$var$emptyResponseText = 'Response is either not present or has no data.';
    const $cfd7686b41fd6499$export$a0603b0ff181c30a = (response)=>{
        if (!response || !Object.prototype.hasOwnProperty.call(response, 'data')) throw new (0, (0, parcelRequire("g81XS")).NoDataError)($cfd7686b41fd6499$var$emptyResponseText);
        if (response.data === null) throw new (0, (0, parcelRequire("g81XS")).NoDataError)($cfd7686b41fd6499$var$emptyResponseText);
        return response;
    };
});
parcelRegister("g81XS", function(module, exports) {
    $parcel$export(module.exports, "NoDataError", ()=>$7410460e4f0e390b$export$5faf0a0592e30f56);
    class $7410460e4f0e390b$export$5faf0a0592e30f56 extends Error {
    }
});
const $a620d3896f16afcc$export$40bed7a29c3b629 = 'IssueKeyField';
parcelRegister("9hLEH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$25af9d0222a23099$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $heNNl;
    var $lfTZh;
    var $kxZPA;
    const $25af9d0222a23099$var$LazyProjectKeyboardShortcuts = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("fVxX7")), {
        moduleId: "./src/packages/software/keyboard-shortcuts/src/ui/project-shortcuts/main.tsx"
    });
    const $25af9d0222a23099$var$ProjectKeyboardShortcuts = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "jira-software-keyboard-shortcuts-project-shortcuts",
            packageName: "jira-software-keyboard-shortcuts",
            render: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "jira-software-keyboard-shortcuts",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($25af9d0222a23099$var$LazyProjectKeyboardShortcuts, props)));
    var $25af9d0222a23099$export$2e2bcd8739ae039 = $25af9d0222a23099$var$ProjectKeyboardShortcuts;
});
parcelRegister("fVxX7", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("3gkNR")
    ]).then(()=>parcelRequire('9pQJj'));
});
parcelRegister("auJzk", function(module, exports) {
    $parcel$export(module.exports, "AsyncCustomerTemplatesOnboardingModal", ()=>$19494602f5d2447c$export$d0eebcb77e325be9);
    var $5uXOq = parcelRequire("5uXOq");
    var $lkem5;
    var $lfTZh;
    var $kxZPA;
    const $19494602f5d2447c$var$LazyCustomerTemplatesOnboardingModal = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("cyqYk")).then(({ CustomerTemplatesOnboardingModal: CustomerTemplatesOnboardingModal })=>CustomerTemplatesOnboardingModal), {
        moduleId: "./src/packages/software/onboarding-modals/src/ui/customer-templates-onboarding-modal/index.tsx"
    });
    const $19494602f5d2447c$export$d0eebcb77e325be9 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lkem5")).ErrorBoundaryWithChunkErrorLogging), {
            id: "asyncCustomerTemplatesOnboardingModalComponent",
            fallback: "unmount",
            packageName: "jiraSoftwareOnboardingModals",
            teamName: "jlove-makkuro"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "software-onboarding-modals-customer-templates",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($19494602f5d2447c$var$LazyCustomerTemplatesOnboardingModal, null)));
});
parcelRegister("cyqYk", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("ak9gt")
    ]).then(()=>parcelRequire('7TYzY'));
});
parcelRegister("caqVv", function(module, exports) {
    $parcel$export(module.exports, "AsyncKanbanOnboardingModal", ()=>$218e0f2ce6d49d0e$export$64da8380143ef676);
    var $5uXOq = parcelRequire("5uXOq");
    var $lkem5;
    var $lfTZh;
    var $kxZPA;
    const $218e0f2ce6d49d0e$var$LazyKanbanOnboardingModal = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("bRmMI")).then(({ KanbanOnboardingModal: KanbanOnboardingModal })=>KanbanOnboardingModal), {
        moduleId: "./src/packages/software/onboarding-modals/src/ui/kanban-onboarding-modal/index.tsx"
    });
    const $218e0f2ce6d49d0e$export$64da8380143ef676 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lkem5")).ErrorBoundaryWithChunkErrorLogging), {
            id: "asyncKanbanOnboardingModalComponent",
            fallback: "unmount",
            packageName: "jiraSoftwareOnboardingModals",
            teamName: "jlove-makkuro"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "software-onboarding-modals-kanban-onboarding",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($218e0f2ce6d49d0e$var$LazyKanbanOnboardingModal, null)));
});
parcelRegister("bRmMI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("bNcDN")
    ]).then(()=>parcelRequire('cil5Z'));
});
parcelRegister("jA0eS", function(module, exports) {
    $parcel$export(module.exports, "AsyncScrumOnboardingModal", ()=>$68afb034032af6be$export$744c5f72d1694510);
    var $5uXOq = parcelRequire("5uXOq");
    var $lkem5;
    var $lfTZh;
    var $kxZPA;
    const $68afb034032af6be$var$LazyScrumOnboardingModal = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("4zQUu")).then(({ ScrumOnboardingModal: ScrumOnboardingModal })=>ScrumOnboardingModal), {
        moduleId: "./src/packages/software/onboarding-modals/src/ui/scrum-onboarding-modal/index.tsx"
    });
    const $68afb034032af6be$export$744c5f72d1694510 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lkem5")).ErrorBoundaryWithChunkErrorLogging), {
            id: "asyncScrumOnboardingModalComponent",
            fallback: "unmount",
            packageName: "jiraSoftwareOnboardingModals",
            teamName: "jlove-makkuro"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "software-onboarding-modals-scrum-onboarding",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($68afb034032af6be$var$LazyScrumOnboardingModal, null)));
});
parcelRegister("4zQUu", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cIVMr")
    ]).then(()=>parcelRequire('8aL25'));
});
parcelRegister("gaIrH", function(module, exports) {
    $parcel$export(module.exports, "AsyncWelcomeModal", ()=>$469ada65feba09b1$export$d08881a6c29dfdb2);
    var $5uXOq = parcelRequire("5uXOq");
    var $lkem5;
    var $lfTZh;
    var $l8ruj;
    var $kxZPA;
    const $469ada65feba09b1$var$LazyWelcomeModal = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("kVfJo")).then(({ WelcomeModal: WelcomeModal })=>WelcomeModal), {
        moduleId: "./src/packages/software/onboarding-modals/src/ui/welcome-modal/index.tsx"
    });
    const $469ada65feba09b1$export$d08881a6c29dfdb2 = ({ source: source })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "async-onboarding-welcome-modal"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lkem5")).ErrorBoundaryWithChunkErrorLogging), {
            id: "asyncWelcomeModalComponent",
            fallback: "unmount",
            packageName: "jiraSoftwareOnboardingModals",
            teamName: "jlove-makkuro"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "software-onboarding-modals-welcome-modal",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($469ada65feba09b1$var$LazyWelcomeModal, {
            source: source
        }))));
    };
});
parcelRegister("kVfJo", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("fgoJG")
    ]).then(()=>parcelRequire('68yeS'));
});
parcelRegister("a1W7K", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e07650b18cf44575$export$2e2bcd8739ae039);
    var $bC2fB;
    var $gsBJe;
    var $j2Wyr;
    var $i475A;
    var $e07650b18cf44575$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((state)=>({
            payloadGIC: (0, (0, parcelRequire("j2Wyr")).getPayloadGlobalIssueCreate)(state)
        }), {
        onClearGICPayload: (0, (0, parcelRequire("gsBJe")).clearPayloadGlobalIssueCreate)
    })((0, (0, parcelRequire("i475A")).default));
});
parcelRegister("j2Wyr", function(module, exports) {
    $parcel$export(module.exports, "getPayloadGlobalIssueCreate", ()=>$4e7e13de836e15b0$export$6d8c2c3612652d80);
    const $4e7e13de836e15b0$export$6d8c2c3612652d80 = (state)=>state.entities.globalIssueCreate.payloadGIC;
});
parcelRegister("i475A", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ae1a370d3ba31430$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $lfTZh;
    var $kxZPA;
    var $eKt4x;
    const $ae1a370d3ba31430$var$JiraGlobalIssueCreateDialogTrigger = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("htw1R")), {
        moduleId: "./src/packages/software/roadmap/standard/src/view/global-issue-create/dialog-trigger/view.tsx"
    });
    const $ae1a370d3ba31430$var$LazyJiraGlobalIssueCreateDialogTrigger = (props)=>{
        const { payloadGIC: payloadGIC } = props;
        if (payloadGIC !== null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "async-standard-roadmap-global-issue-create",
            packageName: (0, (0, parcelRequire("eKt4x")).ROADMAP_PACKAGE_NAME),
            fallback: "flag"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "standard-roadmap-global-issue-create",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ae1a370d3ba31430$var$JiraGlobalIssueCreateDialogTrigger, props)));
        return null;
    };
    var $ae1a370d3ba31430$export$2e2bcd8739ae039 = $ae1a370d3ba31430$var$LazyJiraGlobalIssueCreateDialogTrigger;
});
parcelRegister("htw1R", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5F70n").then(()=>parcelRequire('M8SJx'));
});
parcelRegister("6qMdq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$176586f944510213$export$2e2bcd8739ae039);
    var $bC2fB;
    var $1VLi2;
    var $9Agiq;
    var $176586f944510213$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)(null, {
        onJiraGlobalIssueCreateClosed: (0, (0, parcelRequire("1VLi2")).globalIssueCreate)
    })((0, (0, parcelRequire("9Agiq")).default));
});
parcelRegister("9Agiq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$331d7b5b862f4ec0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $6BZYo;
    const $331d7b5b862f4ec0$var$JiraGlobalIssueListener = ({ isMacroView: isMacroView, onJiraGlobalIssueCreateClosed: onJiraGlobalIssueCreateClosed })=>{
        const subscriptionHandle = (0, $5uXOq.useRef)((0, ($parcel$interopDefault($8Rkzz))));
        const globalIssueCreateEventHandler = (0, $5uXOq.useCallback)((event, issues)=>{
            const globalIssues = (issues || []).reduce((acc, issue)=>{
                if (issue.createdIssueDetails) acc.push({
                    issueId: issue.createdIssueDetails.id,
                    issueKey: issue.createdIssueDetails.key,
                    projectId: issue.createdIssueDetails.fields.project.id,
                    issueTypeId: issue.createdIssueDetails.fields.issuetype.id
                });
                return acc;
            }, []);
            onJiraGlobalIssueCreateClosed(globalIssues);
        }, [
            onJiraGlobalIssueCreateClosed
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isMacroView) (0, (0, parcelRequire("6BZYo")).loadBridge)({
                name: 'jira/util/events',
                wrmKeys: 'wrc!jira.webresources:jira-events'
            }).then((Events)=>{
                if (Events?.bind) {
                    Events.bind('QuickCreateIssue.sessionComplete', globalIssueCreateEventHandler);
                    subscriptionHandle.current = ()=>{
                        Events.unbind('QuickCreateIssue.sessionComplete', globalIssueCreateEventHandler);
                    };
                }
            });
            return ()=>{
                subscriptionHandle.current();
                subscriptionHandle.current = (0, ($parcel$interopDefault($8Rkzz)));
            };
        }, [
            isMacroView,
            globalIssueCreateEventHandler
        ]);
        return null;
    };
    var $331d7b5b862f4ec0$export$2e2bcd8739ae039 = $331d7b5b862f4ec0$var$JiraGlobalIssueListener;
});
parcelRegister("bGMc6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$63d5927cd95c9f09$export$2e2bcd8739ae039);
    var $bC2fB;
    var $9BcVE;
    var $WCgTe;
    var $63d5927cd95c9f09$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((state)=>({
            panelType: (0, (0, parcelRequire("9BcVE")).getPanelType)(state)
        }), {})((0, (0, parcelRequire("WCgTe")).default));
});
parcelRegister("WCgTe", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$16c176aab8101c91$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $69CGc;
    const $16c176aab8101c91$var$TableOverlay = ({ panelType: panelType })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("69CGc")).default), {
            panelType: panelType
        });
    var $16c176aab8101c91$export$2e2bcd8739ae039 = $16c176aab8101c91$var$TableOverlay;
});
parcelRegister("69CGc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$552e908cc45e3a70$export$2e2bcd8739ae039);
    var $bC2fB;
    var $k6Vft;
    var $5IiTZ;
    var $l7ISM;
    var $552e908cc45e3a70$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((state)=>({
            issuePanelRatio: (0, (0, parcelRequire("5IiTZ")).getIssuePanelRatio)(state)
        }), {
        setIssuePanelRatio: (0, parcelRequire("k6Vft")).setIssuePanelRatio
    })((0, (0, parcelRequire("l7ISM")).RoadmapPanel));
});
parcelRegister("l7ISM", function(module, exports) {
    $parcel$export(module.exports, "RoadmapPanel", ()=>$b4f859eea57e411c$export$99a243582d86ff6);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $2Ud8k;
    const $b4f859eea57e411c$export$99a243582d86ff6 = ({ panelType: panelType, issuePanelRatio: issuePanelRatio, setIssuePanelRatio: setIssuePanelRatio })=>{
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("2Ud8k")).ResizerLazy).preload();
        }, []);
        if (panelType === (0, $7c85843a6edcd27d$export$e90b483346a763db)) return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _1e0c1txw _1bsb1osq _4t3i1osq _1pby1o8a _lcxvglyw"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n _1o9zidpf _i0dlf1ug _4t3i1osq"
            ])
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2Ud8k")).default), {
            issuePanelRatio: issuePanelRatio,
            setIssuePanelRatio: setIssuePanelRatio
        }));
        return null;
    };
    const $b4f859eea57e411c$var$staticContainerStyles = null;
    const $b4f859eea57e411c$var$resizerWrapperStyles = null;
});
parcelRegister("2Ud8k", function(module, exports) {
    $parcel$export(module.exports, "ResizerLazy", ()=>$b631228dc7527350$export$a7e89b4c69122d77);
    $parcel$export(module.exports, "default", ()=>$b631228dc7527350$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $lfTZh;
    var $kxZPA;
    var $eKt4x;
    const $b631228dc7527350$export$a7e89b4c69122d77 = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("iW2WK")), {
        ssr: false,
        moduleId: "./src/packages/software/roadmap/standard/src/view/table-overlay/panel/resizer/index.tsx"
    });
    var $b631228dc7527350$export$2e2bcd8739ae039 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "async-standard-roadmap-feedback",
            packageName: (0, (0, parcelRequire("eKt4x")).ROADMAP_PACKAGE_NAME)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "standard-roadmap-resizer",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($b631228dc7527350$export$a7e89b4c69122d77, props)));
});
parcelRegister("iW2WK", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("dvgx7")
    ]).then(()=>parcelRequire('7IoJu'));
});
parcelRegister("9dbF6", function(module, exports) {
    $parcel$export(module.exports, "SubProductUpdater", ()=>$5979c081afa32bfa$export$eb40d3df56aa5c53);
    var $5uXOq = parcelRequire("5uXOq");
    var $bNvU3;
    var $3iTiR;
    var $ero6m;
    var $54I24;
    var $8OHH4;
    const $5979c081afa32bfa$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
        const subProduct = (0, (0, parcelRequire("8OHH4")).isSubProductProps)(props) ? props.subProduct : (0, (0, parcelRequire("ero6m")).getSubProductFromProjectType)(props.projectType);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bNvU3")).default), {
            op: (0, (0, parcelRequire("54I24")).default),
            args: [
                subProduct,
                allowMonolithDeferral
            ]
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3iTiR")).default), {
            subProduct: subProduct
        }));
    };
});
parcelRegister("3iTiR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1214b0731559b377$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1u3Jv;
    var $hFChZ;
    var $1214b0731559b377$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1u3Jv")).default), {
            op: (0, (0, parcelRequire("hFChZ")).default),
            args: [
                subProduct
            ]
        });
});
parcelRegister("hFChZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0e606430ead76cd8$export$2e2bcd8739ae039);
    var $dJl1T;
    var $eusud;
    var $0e606430ead76cd8$export$2e2bcd8739ae039 = (subProduct)=>{
        (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
        });
    };
});
parcelRegister("ero6m", function(module, exports) {
    $parcel$export(module.exports, "getSubProductFromProjectType", ()=>$0997694844c8a9e7$export$b1fe420ed15dff7b);
    var $16v4H;
    const $0997694844c8a9e7$export$b1fe420ed15dff7b = (projectType)=>{
        if (projectType === 'product_discovery') return 'polaris';
        return (0, (0, parcelRequire("16v4H")).subProductFromProjectType)(projectType);
    };
});
parcelRegister("54I24", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bcbbcd48ca398ed4$export$2e2bcd8739ae039);
    var $7T84i;
    var $9B86Q;
    var $cQZXC;
    var $dJl1T;
    var $fjcgS;
    const $bcbbcd48ca398ed4$var$maybeDelayAndRace = (maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
            maybeWaitPromise.then(getDefaultPromise),
            getRacePromise()
        ]) : getDefaultPromise();
    var $bcbbcd48ca398ed4$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
        (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>{
            client.setSubProduct(subProduct);
            if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
                solutions: [
                    (0, $86344d58e71e925a$export$c8b406ad8ee0dab9)
                ]
            });
            else client.removeUIViewedAttribute('solutions');
        });
        $bcbbcd48ca398ed4$var$maybeDelayAndRace(allowMonolithDeferral ? (0, (0, parcelRequire("cQZXC")).waitForHeritage)() : null, ()=>(0, (0, parcelRequire("7T84i")).loadBridgeStrict)({
                name: 'jira/analytics/sub-product-resolver',
                wrmKeys: [
                    'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
                ]
            }), ()=>(0, (0, parcelRequire("9B86Q")).loadBridgeWeak)({
                name: 'jira/analytics/sub-product-resolver'
            })).then((subProductResolver)=>{
            subProductResolver.setSubProduct(subProduct);
        }).catch((e)=>(0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
    };
});
const $86344d58e71e925a$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';
parcelRegister("8OHH4", function(module, exports) {
    $parcel$export(module.exports, "isSubProductProps", ()=>$701d07b56c3e3574$export$c3063d6d7a8c075f);
    const $701d07b56c3e3574$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
    const $701d07b56c3e3574$export$81da4a7e1ba1dcee = (props)=>'projectType' in props && typeof props.projectType === 'string';
});
parcelRegister("iMyxN", function(module, exports) {
    $parcel$export(module.exports, "roadmapPageLoad", ()=>$4ffd989d80ca5ad1$export$c285c2b2be61e659);
    var $dGrdR;
    const $4ffd989d80ca5ad1$export$c285c2b2be61e659 = (0, (0, parcelRequire("dGrdR")).metrics).pageLoad({
        key: 'roadmap',
        ssr: {
            doneAsFmp: true
        },
        slo: {
            fmp: {
                initial: {
                    threshold: 1000
                },
                transition: {
                    threshold: 1000
                }
            },
            tti: {
                initial: {
                    threshold: 4000
                },
                transition: {
                    threshold: 4000
                }
            }
        }
    });
});
parcelRegister("iK5xG", function(module, exports) {
    $parcel$export(module.exports, "withLicenseCheck", ()=>$fa1c8d37e7d0f3e8$export$9c58509833e46668);
    var $5uXOq = parcelRequire("5uXOq");
    var $ef5Xn;
    var $d31Su;
    var $gmp1S;
    var $9NiTW;
    var $dKwVp;
    const $fa1c8d37e7d0f3e8$export$9c58509833e46668 = (WrappedComponent)=>class WithLicenseCheck extends (0, $5uXOq.Component) {
            static{
                this.displayName = `WithLicenseCheck(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
            }
            render() {
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9NiTW")).AuthenticationCheck), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dKwVp")).LicenseStateCheck), {
                    type: "software"
                }, ({ licenseState: licenseState })=>{
                    if (licenseState === (0, (0, parcelRequire("ef5Xn")).LICENSE_STATE_ACTIVE)) return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, this.props);
                    if (licenseState === (0, (0, parcelRequire("ef5Xn")).LICENSE_STATE_SUSPENDED)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gmp1S")).AsyncSuspendedSoftwareLicense), null);
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d31Su")).AsyncNoSoftwareLicense), null);
                }));
            }
        };
});
parcelRegister("d31Su", function(module, exports) {
    $parcel$export(module.exports, "AsyncNoSoftwareLicense", ()=>$dcd2c1aef082694d$export$52d8964299339cae);
    var $5uXOq = parcelRequire("5uXOq");
    var $kb4zh;
    var $lfTZh;
    var $kxZPA;
    const $dcd2c1aef082694d$var$LazyNoSoftwareLicense = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("1qjZt")), {
        moduleId: "./src/packages/spa-apps/common/src/error-screens/no-software-license/index.tsx"
    });
    const $dcd2c1aef082694d$export$52d8964299339cae = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "no-software-license",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kb4zh")).default), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($dcd2c1aef082694d$var$LazyNoSoftwareLicense, null));
});
parcelRegister("1qjZt", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lzKF1").then(()=>parcelRequire('eX102'));
});
parcelRegister("gmp1S", function(module, exports) {
    $parcel$export(module.exports, "AsyncSuspendedSoftwareLicense", ()=>$507e5a2719a80114$export$a2b6823ff422b6ba);
    var $5uXOq = parcelRequire("5uXOq");
    var $kb4zh;
    var $lfTZh;
    var $kxZPA;
    const $507e5a2719a80114$var$LazySuspendedSoftwareLicense = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("ammVF")), {
        moduleId: "./src/packages/spa-apps/common/src/error-screens/suspended-software-license/index.tsx"
    });
    const $507e5a2719a80114$export$a2b6823ff422b6ba = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "suspended-software-license",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kb4zh")).default), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($507e5a2719a80114$var$LazySuspendedSoftwareLicense, null));
});
parcelRegister("ammVF", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bPGOX").then(()=>parcelRequire('6gs7x'));
});
parcelRegister("dKwVp", function(module, exports) {
    $parcel$export(module.exports, "LicenseStateCheck", ()=>$689f679434973539$export$ce623a03a46f6b64);
    var $5uXOq = parcelRequire("5uXOq");
    var $ef5Xn;
    var $9OXo1;
    const $689f679434973539$var$appLicenseMapper = {
        software: 'software',
        servicedesk: 'serviceDesk'
    };
    const $689f679434973539$export$17fd9ec24bb0187f = (tenantContext, type)=>{
        if (tenantContext.licenseStates) return tenantContext.licenseStates[$689f679434973539$var$appLicenseMapper[type]];
        return 0, (0, parcelRequire("ef5Xn")).LICENSE_STATE_UNLICENSED;
    };
    const $689f679434973539$export$ce623a03a46f6b64 = ({ children: children, type: type })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9OXo1")).TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
            const licenseState = $689f679434973539$export$17fd9ec24bb0187f(tenantContext, type);
            return children({
                licenseState: licenseState
            });
        });
});
